import "./bundle.css";
import { jsx, jsxs, Fragment as Fragment$1 } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Badge, Grid, Box, Stack, rem, Text as Text$1, Layer, Card, Spinner, Flex, Dialog, useTheme, Button as Button$1, Skeleton, Heading, useToast, Avatar, AvatarStack, Inline, Breadcrumbs, useClickOutsideEvent, Code, useLayer, Portal, LayerProvider, MenuDivider, Menu, useElementRect, Autocomplete, useMediaIndex, useGlobalKeyDown, Checkbox as Checkbox$1, Switch as Switch$1, TextInput as TextInput$1, Select, ElementQuery, TabList, rgba, MenuItem as MenuItem$1, useBoundaryElement, BoundaryElementProvider, usePortal, PortalProvider, _responsive, useRootTheme, useArrayProp, TextArea, TextSkeleton, useElementSize, isHTMLElement, Radio, TabPanel, Container as Container$3, studioTheme, Label, AvatarCounter, ThemeColorProvider, DialogProvider, focusLastDescendant, focusFirstDescendant, VirtualList as VirtualList$1, usePrefersDark, ThemeProvider, useTheme_v2, ToastProvider } from "@sanity/ui";
import * as PathUtils from "@sanity/util/paths";
import { toString, FOCUS_TERMINATOR, startsWith, isEqual as isEqual$2, pathFor, fromString, get as get$1, trimChildPath as trimChildPath$1, trimLeft } from "@sanity/util/paths";
import React, { forwardRef, useRef, useState, useId, useCallback, useMemo, useImperativeHandle, useEffect, isValidElement, Fragment, cloneElement, memo, useContext, useSyncExternalStore, Suspense, useReducer, startTransition, Component, use as use$2, useLayoutEffect, useEffectEvent, PureComponent, Children, createContext, useDebugValue, useTransition, useInsertionEffect, lazy, useDeferredValue, version, StrictMode } from "react";
import deepEquals from "react-fast-compare";
import { WorkspacesContext, LocaleContext, MediaLibraryIdsContext, PerspectiveContext, UserColorManagerContext, ResourceCacheContext, EventsContext, WorkspaceContext, DocumentChangeContext, ReviewChangesContext, DiffContext, PresenceContext, FormBuilderContext, PortableTextMemberSchemaTypesContext, SelectedAnnotationsContext, ValidationContext, PortableTextMarkersContext, PortableTextMemberItemsContext, ChangeIndicatorTrackerContextStore, ChangeIndicatorTrackerContextGetSnapshot, FormCallbacksContext, ReferenceInputOptionsContext, DocumentDivergencesContext, ActiveWorkspaceMatcherContext, DocumentIdContext, HoveredFieldContext, FieldActionsContext, FormValueContext, ReferenceItemRefContext, GetFormValueContext, EnhancedObjectDialogContext, DocumentFieldActionsContext, ArrayValidationContext, SortableItemIdContext, SourceContext, VirtualizerScrollInstanceContext, PortableTextMemberItemElementRefsContext, ScrollContext, FullscreenPTEContext, AssetLimitUpsellContext, DialogStackContext, ReleasesUpsellContext, ReleasesMetadataContext, AppIdCacheContext, TableContext, SearchContext, SingleDocReleaseEnabledContext, SingleDocReleaseUpsellContext, SingleDocReleaseContext, PresenceTrackerContextStore, PresenceTrackerContextGetSnapshot, FormFieldPresenceContext, CalendarContext, CommentsAuthoringPathContext, CommentsIntentContext, CommentInputContext, CommentsContext, CommentsEnabledContext, CommentsOnboardingContext, CommentsSelectedPathContext, CommentsUpsellContext, AddonDatasetContext, ScheduledPublishingEnabledContext, SchedulesContext, SchedulePublishUpsellContext, DocumentActionPropsContext, TasksEnabledContext, IsLastPaneContext, MentionUserContext, TasksNavigationContext, TasksContext, TasksUpsellContext, RouterHistoryContext, ColorSchemeSetValueContext, ColorSchemeValueContext, DocumentLimitUpsellContext, NavbarContext, FreeTrialContext, LiveUserApplicationContext, PackageVersionInfoContext, StudioAnnouncementContext, CopyPasteContext, UserApplicationCacheContext, PreviewCardContext, ZIndexContext, zIndexContextDefaults } from "sanity/_singletons";
import { SchedulesContext as SchedulesContext2 } from "sanity/_singletons";
import { useVirtualizer, defaultRangeExtractor, elementScroll } from "@tanstack/react-virtual";
import throttle from "lodash-es/throttle.js";
import { styled, css, keyframes, useTheme as useTheme$1 } from "styled-components";
import { EllipsisHorizontalIcon, ErrorOutlineIcon, CircleIcon, CalendarIcon, UnpublishIcon, PublishIcon, EditIcon, CloseIcon, TrashIcon, AddCircleIcon, TimelineIcon, ChevronRightIcon, DocumentIcon, ImageIcon, ChevronDownIcon, ArrowRightIcon, ArrowDownIcon, RevertIcon, WarningOutlineIcon, InfoOutlineIcon, ArrowLeftIcon, CheckmarkIcon, AddIcon, HelpCircleIcon, AccessDeniedIcon, ToggleArrowRightIcon, SyncIcon, LaunchIcon, BulbOutlineIcon, UnknownIcon, LinkIcon, ChevronUpIcon, DownloadIcon, DocumentsIcon, UploadIcon, DragHandleIcon, InsertAboveIcon, InsertBelowIcon, CopyIcon, AddDocumentIcon, SearchIcon, ChevronLeftIcon, EarthGlobeIcon, EarthAmericasIcon, UlistIcon, OlistIcon, CodeIcon, UnderlineIcon, StrikethroughIcon, ItalicIcon, BoldIcon, BlockElementIcon, InlineElementIcon, CollapseIcon, ExpandIcon, ResetIcon, Icon, ReadOnlyIcon, BinaryDocumentIcon, LockIcon, CropIcon, EyeOpenIcon, ClockIcon, DotIcon, BoltIcon, CheckmarkCircleIcon, PinFilledIcon, PinIcon, RestoreIcon, CloseCircleIcon, UnarchiveIcon, ArchiveIcon, ShareIcon, TargetIcon, TextIcon, ArrowUpIcon, ControlsIcon, SpinnerIcon, SortIcon, FilterIcon as FilterIcon$1, ComposeSparklesIcon, UnlockIcon, ClipboardIcon, StringIcon, NumberIcon, BlockContentIcon, UndoIcon, UnlinkIcon, LinkRemovedIcon, AddCommentIcon, CommentIcon, SelectIcon, TaskIcon, UserIcon, DesktopIcon, MoonIcon, SunIcon, SparkleIcon, EyeClosedIcon, DoubleChevronRightIcon, AddUserIcon, CogIcon, LeaveIcon, UsersIcon, GithubIcon, RefreshIcon, MenuIcon } from "@sanity/icons";
import { createMemoryHistory, createBrowserHistory } from "history";
import { uuid } from "@sanity/uuid";
import { catchError, tap, switchMap, map, scan, distinctUntilChanged, shareReplay, filter, startWith, mergeMapTo, takeUntil, take as take$1, publishReplay, refCount, withLatestFrom, share, mergeMap, concatMap as concatMap$1, groupBy as groupBy$1, throttleTime, last, mergeAll, toArray as toArray$1, distinct, skip, first, debounceTime, auditTime, switchMapTo, delay, reduce as reduce$2, debounce as debounce$1, finalize as finalize$1, expand as expand$1, mapTo, retry as retry$1, timeout } from "rxjs/operators";
import { useObservable, useObservableEvent } from "react-rx";
import { of, concat, defer, EMPTY as EMPTY$5, map as map$1, defaultIfEmpty, catchError as catchError$1, switchMap as switchMap$1, take, concatMap, from, Observable, merge, Subject, fromEvent, throwError, timer, NEVER, pipe, distinctUntilChanged as distinctUntilChanged$1, shareReplay as shareReplay$1, BehaviorSubject, tap as tap$1, finalize, share as share$1, ReplaySubject, combineLatest, asyncScheduler, bufferTime, mergeMap as mergeMap$1, firstValueFrom, filter as filter$1, lastValueFrom, partition as partition$1, asapScheduler, using, repeat, startWith as startWith$1, iif, concatWith, scan as scan$1, count, toArray as toArray$2, reduce as reduce$1, first as first$1, switchScan, delayWhen, zipWith, takeWhile, debounceTime as debounceTime$1, find, zip, isObservable, retry, expand, skip as skip$1, forkJoin, debounce as debounce$2, delay as delay$1, timeout as timeout$1, connect } from "rxjs";
import { getVersionId, getDraftId, getPublishedId, isPublishedId, isDraftId, getVersionFromId, isVersionId, DRAFTS_FOLDER } from "@sanity/client/csm";
import { DRAFTS_FOLDER as DRAFTS_FOLDER2, VERSION_FOLDER, getDraftId as getDraftId2, getPublishedId as getPublishedId2, getVersionFromId as getVersionFromId2, getVersionId as getVersionId2, isDraftId as isDraftId2, isPublishedId as isPublishedId2, isVersionId as isVersionId2 } from "@sanity/client/csm";
import { formatRelative } from "date-fns/formatRelative";
import { isValid } from "date-fns/isValid";
import { parse } from "date-fns/parse";
import { ResizeObserver as ResizeObserver$2 } from "@juggle/resize-observer";
import createPubSub from "nano-pubsub";
import QuickLRU from "quick-lru";
import isEqual$1 from "lodash-es/isEqual.js";
import { COLOR_HUES, hues, white, red, gray, yellow, purple, black, green, blue } from "@sanity/color";
import { darken, lighten, hasBadContrast, readableColor } from "color2k";
import isString$1 from "lodash-es/isString.js";
import { I18nextProvider, useTranslation as useTranslation$1, initReactI18next } from "react-i18next";
import { isIndexSegment, isKeySegment, isIndexTuple, isKeyedObject, isReference as isReference$1, isArrayOfBlocksSchemaType, isSlug, isTypedObject as isTypedObject$1, isGlobalDocumentReference, isObjectSchemaType, isArraySchemaType, isPortableTextSpan, isPortableTextTextBlock, isPrimitiveSchemaType, isArrayOfObjectsSchemaType, isArrayOfPrimitivesSchemaType, isArrayOfStringsSchemaType, isCreateMutation, isCreateOrReplaceMutation, isCreateIfNotExistsMutation, isBooleanSchemaType, isDateTimeSchemaType, isCrossDatasetReferenceSchemaType, isReferenceSchemaType, isNumberSchemaType, isStringSchemaType, isDocumentSchemaType, isCrossDatasetReference, isTitledListValue, isImage, isValidationErrorMarker, isImageSchemaType, isSearchStrategy, searchStrategies as searchStrategies$1, defineType, defineField, defineArrayMember, isValidationWarningMarker, isValidationInfoMarker, isDeprecatedSchemaType, isBlockSchemaType, isSpanSchemaType, isFileSchemaType } from "@sanity/types";
export * from "@sanity/types";
import { useSyncExternalStoreWithSelector } from "use-sync-external-store/with-selector";
import escapeRegExp$1 from "lodash-es/escapeRegExp.js";
import DataLoader from "dataloader";
import { SANITY_VERSION } from "./_chunks-es/version.js";
import { createClient, ClientError } from "@sanity/client";
import memoize$1 from "lodash-es/memoize.js";
import { Button, ErrorBoundary, Tooltip, Popover, MenuItem, MenuButton, TooltipDelayGroupProvider, Dialog as Dialog$1, Tab, generateHelpUrl } from "./_chunks-es/index.js";
import { Hotkeys } from "./_chunks-es/index.js";
import { observableCallback } from "observable-callback";
import { useTelemetry, TelemetryProvider, DeferredTelemetryProvider } from "@sanity/telemetry/react";
import { usePortableTextEditor, PortableTextEditor, usePortableTextEditorSelection, PortableTextEditable, EditorProvider, useEditor, defineSchema, keyGenerator as keyGenerator$1 } from "@portabletext/editor";
import { fromUrl } from "@sanity/bifur-client";
import debug$c from "debug";
import startCase from "lodash-es/startCase.js";
import { isValidElementType } from "react-is";
import uniqueId from "lodash-es/uniqueId.js";
import intersection from "lodash-es/intersection.js";
import isEmpty$1 from "lodash-es/isEmpty.js";
import { isHotkey } from "is-hotkey-esm";
import FocusLock from "react-focus-lock";
import { defineEvent, createSessionId, createBatchedStore } from "@sanity/telemetry";
import { isVersionId as isVersionId$1, getVersionNameFromId } from "@sanity/id-utils";
import { nanoid, customAlphabet } from "nanoid";
import flatten$1 from "lodash-es/flatten.js";
import last$1 from "lodash-es/last.js";
import { differenceInDays } from "date-fns/differenceInDays";
import { differenceInHours } from "date-fns/differenceInHours";
import { differenceInMinutes } from "date-fns/differenceInMinutes";
import { differenceInMonths } from "date-fns/differenceInMonths";
import { differenceInSeconds } from "date-fns/differenceInSeconds";
import { differenceInWeeks } from "date-fns/differenceInWeeks";
import { differenceInYears } from "date-fns/differenceInYears";
import sortBy from "lodash-es/sortBy.js";
import { DEFAULT_MAX_FIELD_DEPTH, builtinTypes, validateSchema, groupProblems, DescriptorConverter, ALL_FIELDS_GROUP_NAME, isActionEnabled, processSchemaSynchronization, getWorkspaceSchemaId } from "@sanity/schema/_internal";
import { cleanupEfficiency, makeDiff, DIFF_INSERT, DIFF_DELETE, DIFF_EQUAL, applyPatches, parsePatch, makePatches } from "@sanity/diff-match-patch";
import orderBy from "lodash-es/orderBy.js";
import * as legacyDateFormat from "@sanity/util/legacyDateFormat";
import { sanitizeLocale, format as format$1, DEFAULT_DATE_FORMAT, parse as parse$2, isValidTimeZoneString, DEFAULT_TIME_FORMAT } from "@sanity/util/legacyDateFormat";
import { getImageDimensions, isDefaultCrop, isDefaultHotspot, isImageSource, isFileSource, isSanityImageUrl, parseImageAssetUrl, isAssetObjectStub, isImageAssetId, isFileAssetId } from "@sanity/asset-utils";
import { createImageUrlBuilder } from "@sanity/image-url";
import { encodeJsonParams, IntentLink, useRouter, RouterContext, useIntentLink, route, useRouterState, useStateLink, Link as Link$1, StateLink, RouteScope, STICKY_PARAMS, RouterProvider } from "sanity/router";
import { addHours } from "date-fns/addHours";
import { startOfHour } from "date-fns/startOfHour";
import { format } from "date-fns/format";
import { tz, TZDate } from "@date-fns/tz";
import { addDays } from "date-fns/addDays";
import { addMonths } from "date-fns/addMonths";
import { setDate } from "date-fns/setDate";
import { setHours } from "date-fns/setHours";
import { setMinutes } from "date-fns/setMinutes";
import { setMonth } from "date-fns/setMonth";
import { setYear } from "date-fns/setYear";
import { isPast } from "date-fns/isPast";
import uniq from "lodash-es/uniq.js";
import xor from "lodash-es/xor.js";
import { createPortableTextMemberSchemaTypes, sanitySchemaToPortableTextSchema } from "@portabletext/sanity-bridge";
import { getMinutes } from "date-fns/getMinutes";
import { parseISO } from "date-fns/parseISO";
import { diffItem } from "@sanity/diff-patch";
import { getTheme_v2, rgba as rgba$1, parseColor, rgbToHex, screen, multiply, createColorTheme, buildTheme } from "@sanity/ui/theme";
import { Mutation, BufferedDocument, extractWithPath, arrayToJSONMatchPath } from "@sanity/mutator";
import omit from "lodash-es/omit.js";
import groupBy from "lodash-es/groupBy.js";
import pick from "lodash-es/pick.js";
import { useDevicePixelRatio, getDevicePixelRatio } from "use-device-pixel-ratio";
import { mergeMapArray } from "rxjs-mergemap-array";
import { useSyncExternalStore as useSyncExternalStore$1 } from "use-sync-external-store/shim/index.js";
import classNames from "classnames";
import debounce from "lodash-es/debounce.js";
import { diffInput, wrap as wrap$1 } from "@sanity/diff";
import { applyPatch as applyPatch$1, incremental } from "mendoza";
import uniqBy from "lodash-es/uniqBy.js";
import { motion, AnimatePresence } from "motion/react";
import get from "lodash-es/get.js";
import { lcs_dp } from "@algorithm.ts/lcs";
import stringify$1 from "json-stable-stringify";
import shallowEquals from "shallow-equals";
import scrollIntoView$1 from "scroll-into-view-if-needed";
import compact from "lodash-es/compact.js";
import keyBy from "lodash-es/keyBy.js";
import partition from "lodash-es/partition.js";
import toLower from "lodash-es/toLower.js";
import union from "lodash-es/union.js";
import words from "lodash-es/words.js";
import flow from "lodash-es/flow.js";
import trim from "lodash-es/trim.js";
import isFinite from "lodash-es/isFinite.js";
import { randomKey as randomKey$1, isDeepEmpty, resolveTypeName as resolveTypeName$1, isShallowEmptyObject } from "@sanity/util/content";
import noop$7 from "lodash-es/noop.js";
import isPlainObject$1 from "lodash-es/isPlainObject.js";
import capitalize from "lodash-es/capitalize.js";
import difference from "lodash-es/difference.js";
import { useSensors, useSensor, PointerSensor, KeyboardSensor, DndContext, closestCenter } from "@dnd-kit/core";
import { restrictToHorizontalAxis, restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { sortableKeyboardCoordinates, useSortable, SortableContext, horizontalListSortingStrategy, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS as CSS$1 } from "@dnd-kit/utilities";
import { InsertMenu as InsertMenu$2 } from "@sanity/insert-menu";
import speakingurl from "speakingurl";
import { PortableText as PortableText$1, toPlainText as toPlainText$1 } from "@portabletext/react";
import { BehaviorPlugin, EventListenerPlugin } from "@portabletext/editor/plugins";
import { OneLinePlugin } from "@portabletext/plugin-one-line";
import { Rule as Rule$1, Schema } from "@sanity/schema";
import { DEFAULT_ANNOTATIONS, DEFAULT_DECORATORS } from "@sanity/schema";
import { defineBehavior, raise, forward } from "@portabletext/editor/behaviors";
import { isPortableTextBlock, toPlainText } from "@portabletext/toolkit";
import castArray from "lodash-es/castArray.js";
import sortedIndex from "lodash-es/sortedIndex.js";
import identity$2 from "lodash-es/identity.js";
import values from "lodash-es/values.js";
import { createNode } from "@sanity/comlink";
import TTLCache from "@isaacs/ttlcache";
import findIndex$1 from "lodash-es/findIndex.js";
import { createClientConcurrencyLimiter } from "@sanity/util/client";
import { ConcurrencyLimiter } from "@sanity/util/concurrency-limiter";
import { createInstance } from "i18next";
import { reduce } from "json-reduce";
import { exhaustMapWithTrailing } from "rxjs-exhaustmap-with-trailing";
import range from "lodash-es/range.js";
import { isSameDay } from "date-fns/isSameDay";
import { isSameMonth } from "date-fns/isSameMonth";
import { endOfDay } from "date-fns/endOfDay";
import { eachWeekOfInterval } from "date-fns/eachWeekOfInterval";
import { getWeek } from "date-fns/getWeek";
import { lastDayOfMonth } from "date-fns/lastDayOfMonth";
import { startOfMonth } from "date-fns/startOfMonth";
import deburr from "lodash-es/deburr.js";
import { getLuminance, parseToRgb, rgb, mix } from "polished";
import exif from "exif-component";
import pickBy from "lodash-es/pickBy.js";
import { ConfirmPopover, MenuGroup } from "./_chunks-es/MenuGroup.js";
import { useHotModuleReload } from "use-hot-module-reload";
import { parse as parse$1, evaluate } from "groq-js";
import sample from "lodash-es/sample.js";
import raf from "raf";
import { renderToString, renderToStaticMarkup } from "react-dom/server";
import { endOfMinute } from "date-fns/endOfMinute";
import { startOfDay } from "date-fns/startOfDay";
import { startOfMinute } from "date-fns/startOfMinute";
import { startOfToday } from "date-fns/startOfToday";
import { sub } from "date-fns/sub";
import { toHTML } from "@portabletext/to-html";
import max from "lodash-es/max.js";
import sum$1 from "lodash-es/sum.js";
import { createRoot } from "react-dom/client";
import { setElementVars } from "@vanilla-extract/dynamic";
import { makeFetchTransport, inboundFiltersIntegration, functionToStringIntegration, browserApiErrorsIntegration, breadcrumbsIntegration, globalHandlersIntegration, linkedErrorsIntegration, dedupeIntegration, httpContextIntegration, isInitialized, getClient, getCurrentScope, BrowserClient, defaultStackParser, Scope, init, withScope, captureException } from "@sentry/react";
import { SanityLogo, SanityMonogram } from "@sanity/logos";
import { addWeeks } from "date-fns/addWeeks";
import { isAfter } from "date-fns/isAfter";
import { isBefore } from "date-fns/isBefore";
import semver, { satisfies } from "semver";
import isObject from "lodash-es/isObject.js";
import { onLCP, onFCP, onCLS, onTTFB, onINP } from "web-vitals/attribution";
import { set as set$3 } from "date-fns/set";
import upperFirst from "lodash-es/upperFirst.js";
import { isThisISOWeek } from "date-fns/isThisISOWeek";
import { isToday } from "date-fns/isToday";
import { formatDistance } from "date-fns/formatDistance";
import { isWeekend } from "date-fns/isWeekend";
import set$2 from "lodash-es/set.js";
import { htmlToPortableText } from "@portabletext/html";
import { MarkdownShortcutsPlugin } from "@portabletext/plugin-markdown-shortcuts";
import { PasteLinkPlugin } from "@portabletext/plugin-paste-link";
import { createDecoratorGuard, TypographyPlugin } from "@portabletext/plugin-typography";
import find$1 from "lodash-es/find.js";
import clone from "lodash-es/clone.js";
import { at, setIfMissing as setIfMissing$1, unset as unset$1, append, set as set$1, SanityEncoder } from "@sanity/mutate";
function BetaBadge(props2) {
  const $ = c(8);
  let rest, t0, t1;
  $[0] !== props2 ? ({
    fontSize: t0,
    children: t1,
    ...rest
  } = props2, $[0] = props2, $[1] = rest, $[2] = t0, $[3] = t1) : (rest = $[1], t0 = $[2], t1 = $[3]);
  const fontSize = t0 === void 0 ? 1 : t0, children = t1 === void 0 ? "Beta" : t1;
  let t2;
  return $[4] !== children || $[5] !== fontSize || $[6] !== rest ? (t2 = /* @__PURE__ */ jsx(Badge, { ...rest, fontSize, radius: 2, tone: "primary", children }), $[4] = children, $[5] = fontSize, $[6] = rest, $[7] = t2) : t2 = $[7], t2;
}
function focusRingBorderStyle$3(border) {
  return `inset 0 0 0 ${border.width}px ${border.color}`;
}
const ColumnarGrid = styled(Grid).withConfig({
  displayName: "ColumnarGrid",
  componentId: "sc-16a5dys-0"
})`align-items:flex-start;`;
function focusRingStyle$2(opts) {
  const {
    base,
    border,
    focusRing
  } = opts, focusRingOutsetWidth = focusRing.offset + focusRing.width, focusRingInsetWidth = 0 - focusRing.offset, bgColor = base ? base.bg : "var(--card-bg-color)";
  return [focusRingInsetWidth > 0 && `inset 0 0 0 ${focusRingInsetWidth}px var(--card-focus-ring-color)`, border && focusRingBorderStyle$3(border), focusRingInsetWidth < 0 && `0 0 0 ${0 - focusRingInsetWidth}px ${bgColor}`, focusRingOutsetWidth > 0 && `0 0 0 ${focusRingOutsetWidth}px var(--card-focus-ring-color)`].filter(Boolean).join(",");
}
const LIST_ITEM_DATA_ATTR_ACTIVE = "data-active", LIST_ITEM_INTERACTIVE_SELECTOR = "a,button", FocusOverlayDiv = /* @__PURE__ */ styled.div.withConfig({
  displayName: "FocusOverlayDiv",
  componentId: "sc-1ds81n6-0"
})(({
  theme,
  offset
}) => css`
    bottom: ${-offset}px;
    border-radius: ${rem(theme.sanity.radius[1])};
    left: ${-offset}px;
    pointer-events: none;
    position: absolute;
    right: ${-offset}px;
    top: ${-offset}px;
    z-index: 2;

    ${VirtualListBox}:focus-visible & {
      box-shadow: ${focusRingStyle$2({
  base: theme.sanity.color.base,
  focusRing: theme.sanity.focusRing
})};
    }
  `), PointerOverlayDiv = styled.div.withConfig({
  displayName: "PointerOverlayDiv",
  componentId: "sc-1ds81n6-1"
})`bottom:0;display:none;left:0;position:absolute;right:0;top:0;z-index:1;@media (hover:hover){&[data-enabled='true']{display:block;}}`, VirtualListBox = styled(Box).withConfig({
  displayName: "VirtualListBox",
  componentId: "sc-1ds81n6-2"
})`height:100%;outline:none;overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain;width:100%;`, VirtualListChildBox = styled(Box).attrs(({
  $height
}) => ({
  style: {
    height: `${$height}px`
  }
})).withConfig({
  displayName: "VirtualListChildBox",
  componentId: "sc-1ds81n6-3"
})`position:relative;width:100%;`, CommandListComponent = forwardRef(function({
  activeItemDataAttr = LIST_ITEM_DATA_ATTR_ACTIVE,
  ariaLabel,
  ariaMultiselectable = !1,
  autoFocus,
  canReceiveFocus,
  fixedHeight,
  focusRingOffset = 0,
  getItemDisabled,
  getItemKey: getItemKey2,
  getItemSelected,
  initialIndex,
  initialScrollAlign = "start",
  inputElement,
  itemHeight,
  items,
  onEndReached,
  onEndReachedIndexOffset = 0,
  onlyShowSelectionWhenActive,
  overscan,
  renderItem: renderItem2,
  testId,
  wrapAround = !0,
  ...responsivePaddingProps
}, ref) {
  const isMountedRef = useRef(!1), [commandListId] = useState(useId()), activeIndexRef = useRef(initialIndex ?? 0), [childContainerElement, setChildContainerElement] = useState(null), [hovered, setHovered] = useState(!1), [pointerOverlayElement, setPointerOverlayElement] = useState(null), [virtualListElement, setVirtualListElement] = useState(null), handleChange = useCallback((v) => {
    if (!onEndReached) return;
    const [lastItem] = [...v.getVirtualItems()].reverse();
    lastItem && lastItem.index >= items.length - onEndReachedIndexOffset - 1 && isMountedRef.current && onEndReached();
  }, [onEndReached, items.length, onEndReachedIndexOffset]), virtualizer = useVirtualizer({
    count: items.length,
    getItemKey: getItemKey2,
    getScrollElement: () => virtualListElement,
    estimateSize: () => itemHeight,
    onChange: handleChange,
    overscan
  }), itemIndices = useMemo(() => getItemIndicies(items, getItemDisabled, getItemSelected), [getItemDisabled, getItemSelected, items]), activeItemCount = useMemo(() => itemIndices.filter((v_0) => !v_0.disabled).length, [itemIndices]), enableChildContainerPointerEvents = useCallback((enabled) => pointerOverlayElement?.setAttribute("data-enabled", (!enabled).toString()), [pointerOverlayElement]), getChildDescendantId = useCallback((index) => `${commandListId}-item-${index}`, [commandListId]), getCommandListChildrenId = useCallback(() => `${commandListId}-children`, [commandListId]), showChildrenActiveState = useCallback(() => {
    const hasFocus = [inputElement, virtualListElement].some((el) => document.activeElement === el);
    onlyShowSelectionWhenActive && !hasFocus && !hovered || Array.from(childContainerElement?.children || [])?.forEach((child) => {
      const virtualIndex = Number(child.dataset?.index), targetIndex = itemIndices[virtualIndex]?.activeIndex;
      child.querySelector(LIST_ITEM_INTERACTIVE_SELECTOR)?.toggleAttribute(activeItemDataAttr, targetIndex === activeIndexRef.current);
    });
  }, [activeItemDataAttr, childContainerElement?.children, hovered, inputElement, itemIndices, onlyShowSelectionWhenActive, virtualListElement]), hideChildrenActiveState = useCallback(() => {
    Array.from(childContainerElement?.children || [])?.forEach((child_0) => {
      child_0.querySelector(LIST_ITEM_INTERACTIVE_SELECTOR)?.toggleAttribute(activeItemDataAttr, !1);
    });
  }, [activeItemDataAttr, childContainerElement?.children]), refreshChildrenActiveStateThrottled = useMemo(() => throttle(showChildrenActiveState, 200), [showChildrenActiveState]), handleUpdateActiveDescendant = useCallback(() => {
    const activeIndex = activeIndexRef?.current;
    items.length > 0 ? (inputElement?.setAttribute("aria-activedescendant", getChildDescendantId(activeIndex)), virtualListElement?.setAttribute("aria-activedescendant", getChildDescendantId(activeIndex))) : (inputElement?.removeAttribute("aria-activedescendant"), virtualListElement?.removeAttribute("aria-activedescendant"));
  }, [getChildDescendantId, inputElement, items.length, virtualListElement]), handleGetTopIndex = useCallback(() => {
    const childContainerParentElement = childContainerElement?.parentElement;
    if (childContainerElement && childContainerParentElement) {
      const offset = childContainerParentElement.getBoundingClientRect().top - childContainerElement.getBoundingClientRect().top;
      return virtualizer.getVirtualItemForOffset(offset)?.index ?? -1;
    }
    return -1;
  }, [childContainerElement, virtualizer]), setActiveIndex = useCallback(({
    index: index_0,
    scrollAlign,
    scrollIntoView: scrollIntoView2 = !0
  }) => {
    if (activeIndexRef.current = index_0, handleUpdateActiveDescendant(), showChildrenActiveState(), scrollIntoView2) {
      const virtualListIndex = itemIndices.findIndex((i) => i.activeIndex === index_0);
      virtualListIndex > -1 && virtualizer.scrollToIndex(virtualListIndex, scrollAlign ? {
        align: scrollAlign
      } : {});
    }
  }, [handleUpdateActiveDescendant, itemIndices, showChildrenActiveState, virtualizer]), selectAdjacentItemIndex = useCallback((direction) => {
    let nextIndex = -1;
    const lastIndex = activeItemCount - 1;
    if (direction === "next") {
      const wrapAroundIndex = wrapAround ? 0 : lastIndex;
      nextIndex = activeIndexRef.current < activeItemCount - 1 ? activeIndexRef.current + 1 : wrapAroundIndex;
    }
    if (direction === "previous") {
      const wrapAroundIndex_0 = wrapAround ? lastIndex : 0;
      nextIndex = activeIndexRef.current > 0 ? activeIndexRef.current - 1 : wrapAroundIndex_0;
    }
    setActiveIndex({
      index: nextIndex,
      scrollIntoView: !0
    }), enableChildContainerPointerEvents(!1);
  }, [activeItemCount, enableChildContainerPointerEvents, setActiveIndex, wrapAround]), focusElement = useCallback((type) => {
    switch (type) {
      case "input":
        inputElement?.focus();
        break;
      case "list":
        virtualListElement?.focus();
        break;
    }
  }, [inputElement, virtualListElement]), focusInputElement = useCallback(() => {
    inputElement?.focus();
  }, [inputElement]), focusListElement = useCallback(() => {
    virtualListElement?.focus();
  }, [virtualListElement]), handleChildMouseEnter = useCallback((index_1) => () => {
    setActiveIndex({
      index: index_1,
      scrollIntoView: !1
    });
  }, [setActiveIndex]), handleFocus = useCallback(() => {
    showChildrenActiveState();
  }, [showChildrenActiveState]), handleKeyDown = useCallback((type_0) => (event) => {
    const childElements_1 = Array.from(childContainerElement?.children || []);
    if (childElements_1.length && (event.key === "ArrowDown" && (event.preventDefault(), focusElement(type_0), selectAdjacentItemIndex("next")), event.key === "ArrowUp" && (event.preventDefault(), focusElement(type_0), selectAdjacentItemIndex("previous")), event.key === "Enter")) {
      event.preventDefault(), focusElement(type_0);
      const currentElement = childElements_1.find((el_0) => Number(el_0.dataset.index) === itemIndices.findIndex((i_0) => i_0.activeIndex === activeIndexRef.current));
      currentElement && currentElement?.querySelector(LIST_ITEM_INTERACTIVE_SELECTOR)?.click();
    }
  }, [childContainerElement?.children, focusElement, itemIndices, selectAdjacentItemIndex]), handleKeyDownInput = useCallback((event_0) => handleKeyDown("input")(event_0), [handleKeyDown]), handleKeyDownList = useCallback((event_1) => handleKeyDown("list")(event_1), [handleKeyDown]), handleVirtualListMouseEnter = useCallback(() => {
    onlyShowSelectionWhenActive && (showChildrenActiveState(), setHovered(!0));
  }, [onlyShowSelectionWhenActive, showChildrenActiveState]), handleVirtualListMouseLeave = useCallback(() => {
    onlyShowSelectionWhenActive && (hideChildrenActiveState(), setHovered(!1));
  }, [hideChildrenActiveState, onlyShowSelectionWhenActive]);
  useImperativeHandle(ref, () => ({
    focusInputElement() {
      focusInputElement();
    },
    focusListElement() {
      focusListElement();
    },
    getTopIndex() {
      return handleGetTopIndex();
    },
    scrollToIndex(index_2) {
      setActiveIndex({
        index: index_2
      }), enableChildContainerPointerEvents(!0);
    }
  }), [enableChildContainerPointerEvents, focusInputElement, focusListElement, handleGetTopIndex, setActiveIndex]), useEffect(() => {
    typeof initialIndex < "u" && !isMountedRef.current && setActiveIndex({
      index: initialIndex,
      scrollAlign: initialScrollAlign,
      scrollIntoView: !0
    }), isMountedRef.current = !0;
  }, [initialIndex, initialScrollAlign, onlyShowSelectionWhenActive, setActiveIndex]), useEffect(() => {
    function handleMouseEvent() {
      enableChildContainerPointerEvents(!0);
    }
    return virtualListElement?.addEventListener("mousemove", handleMouseEvent), virtualListElement?.addEventListener("wheel", handleMouseEvent, {
      passive: !0
    }), () => {
      virtualListElement?.removeEventListener("mousemove", handleMouseEvent), virtualListElement?.removeEventListener("wheel", handleMouseEvent);
    };
  }, [enableChildContainerPointerEvents, virtualListElement]), useEffect(() => (inputElement?.addEventListener("focus", handleFocus), inputElement?.addEventListener("keydown", handleKeyDownInput), virtualListElement?.addEventListener("focus", handleFocus), virtualListElement?.addEventListener("keydown", handleKeyDownList), () => {
    inputElement?.removeEventListener("focus", handleFocus), inputElement?.removeEventListener("keydown", handleKeyDownInput), virtualListElement?.removeEventListener("focus", handleFocus), virtualListElement?.removeEventListener("keydown", handleKeyDownList);
  }), [canReceiveFocus, handleFocus, handleKeyDown, handleKeyDownInput, handleKeyDownList, hideChildrenActiveState, inputElement, showChildrenActiveState, virtualListElement]), useEffect(() => {
    handleUpdateActiveDescendant();
  }, [handleUpdateActiveDescendant, items]), useEffect(() => {
    const mutationObserver = new MutationObserver(refreshChildrenActiveStateThrottled);
    return childContainerElement && mutationObserver.observe(childContainerElement, {
      childList: !0,
      subtree: !0
    }), () => {
      mutationObserver.disconnect();
    };
  }, [childContainerElement, refreshChildrenActiveStateThrottled]), useEffect(() => {
    inputElement?.setAttribute("aria-autocomplete", "list"), inputElement?.setAttribute("aria-expanded", "true"), inputElement?.setAttribute("aria-controls", getCommandListChildrenId()), inputElement?.setAttribute("role", "combobox");
  }, [getCommandListChildrenId, inputElement]), useEffect(() => {
    autoFocus && focusElement(autoFocus);
  }, [autoFocus, canReceiveFocus, focusListElement, focusInputElement, focusElement]);
  const rootTabIndex = canReceiveFocus ? 0 : -1;
  return /* @__PURE__ */ jsxs(VirtualListBox, { id: getCommandListChildrenId(), onMouseEnter: handleVirtualListMouseEnter, onMouseLeave: handleVirtualListMouseLeave, ref: setVirtualListElement, sizing: "border", tabIndex: rootTabIndex, "data-testid": testId, ...responsivePaddingProps, children: [
    canReceiveFocus && /* @__PURE__ */ jsx(FocusOverlayDiv, { offset: focusRingOffset }),
    /* @__PURE__ */ jsx(PointerOverlayDiv, { "aria-hidden": "true", "data-enabled": !0, ref: setPointerOverlayElement }),
    virtualizer && /* @__PURE__ */ jsx(VirtualListChildBox, { forwardedAs: "ul", $height: virtualizer.getTotalSize(), "aria-label": ariaLabel, "aria-multiselectable": ariaMultiselectable, flex: 1, ref: setChildContainerElement, role: "listbox", children: virtualizer.getVirtualItems().map((virtualRow) => {
      const virtualIndex_0 = virtualRow.index, {
        activeIndex: activeIndex_0,
        disabled,
        selected
      } = itemIndices[virtualIndex_0], itemToRender = renderItem2(items[virtualIndex_0], {
        activeIndex: activeIndex_0,
        disabled,
        selected,
        virtualIndex: virtualIndex_0
      }), clonedItem = isValidElement(itemToRender) && itemToRender.type != Fragment ? cloneElement(itemToRender, {
        // @ts-expect-error @TODO shift the responsibility of setting tabIndex to the consumer, so we can remove the need to clone
        tabIndex: -1
      }) : itemToRender;
      return /* @__PURE__ */ jsx(CommandListItem2, { ref: fixedHeight ? void 0 : virtualizer.measureElement, activeIndex: activeIndex_0, activeItemCount, ariaMultiselectable, disabled, fixedHeight: fixedHeight ? `${virtualRow.size}px` : void 0, getChildDescendantId, handleChildMouseEnter, selected, virtualIndex: virtualIndex_0, virtualRowStart: virtualRow.start, children: clonedItem }, virtualRow.key);
    }) })
  ] });
}), CommandList = memo(CommandListComponent);
CommandList.displayName = "Memo(ForwardRef(CommandList))";
const CommandListItemComponent = forwardRef(function(props2, forwardedRef) {
  const $ = c(21), {
    children,
    activeIndex,
    activeItemCount,
    ariaMultiselectable,
    disabled,
    fixedHeight,
    getChildDescendantId,
    handleChildMouseEnter,
    selected,
    virtualIndex,
    virtualRowStart
  } = props2;
  let t0;
  $[0] !== activeIndex || $[1] !== disabled || $[2] !== handleChildMouseEnter ? (t0 = typeof activeIndex == "number" && !disabled ? handleChildMouseEnter(activeIndex) : void 0, $[0] = activeIndex, $[1] = disabled, $[2] = handleChildMouseEnter, $[3] = t0) : t0 = $[3];
  const onMouseEnter = t0;
  let t1;
  $[4] !== activeIndex || $[5] !== activeItemCount || $[6] !== ariaMultiselectable || $[7] !== disabled || $[8] !== getChildDescendantId || $[9] !== selected ? (t1 = typeof activeIndex == "number" && !disabled ? {
    "aria-posinset": activeIndex + 1,
    ...ariaMultiselectable ? {
      "aria-selected": selected.toString()
    } : {},
    "aria-setsize": activeItemCount,
    id: getChildDescendantId(activeIndex),
    role: "option"
  } : {}, $[4] = activeIndex, $[5] = activeItemCount, $[6] = ariaMultiselectable, $[7] = disabled, $[8] = getChildDescendantId, $[9] = selected, $[10] = t1) : t1 = $[10];
  const activeAriaAttributes = t1, t2 = `translateY(${virtualRowStart}px)`;
  let t3;
  $[11] !== fixedHeight || $[12] !== t2 ? (t3 = {
    flex: 1,
    height: fixedHeight,
    left: 0,
    position: "absolute",
    top: 0,
    transform: t2,
    width: "100%"
  }, $[11] = fixedHeight, $[12] = t2, $[13] = t3) : t3 = $[13];
  const style = t3;
  let t4;
  return $[14] !== activeAriaAttributes || $[15] !== children || $[16] !== forwardedRef || $[17] !== onMouseEnter || $[18] !== style || $[19] !== virtualIndex ? (t4 = /* @__PURE__ */ jsx(Stack, { as: "li", "data-index": virtualIndex, ref: forwardedRef, style, tabIndex: -1, ...activeAriaAttributes, onMouseEnter, children }), $[14] = activeAriaAttributes, $[15] = children, $[16] = forwardedRef, $[17] = onMouseEnter, $[18] = style, $[19] = virtualIndex, $[20] = t4) : t4 = $[20], t4;
}), CommandListItem2 = memo(CommandListItemComponent);
CommandListItem2.displayName = "Memo(ForwardRef(CommandListItem))";
function getItemIndicies(items, getItemDisabled, getItemSelected) {
  let i = -1;
  return items.reduce((acc, _, index) => {
    const disabled = getItemDisabled?.(index) ?? !1, selected = getItemSelected?.(index) ?? !1;
    return disabled || (i += 1), acc[index] = {
      activeIndex: disabled ? null : i,
      disabled,
      selected
    }, acc;
  }, []);
}
const ContextMenuButton = forwardRef(function(props2, ref) {
  const $ = c(17);
  let rest, t0, tone, tooltipProps;
  $[0] !== props2 ? ({
    mode: t0,
    tooltipProps,
    tone,
    ...rest
  } = props2, $[0] = props2, $[1] = rest, $[2] = t0, $[3] = tone, $[4] = tooltipProps) : (rest = $[1], t0 = $[2], tone = $[3], tooltipProps = $[4]);
  const mode = t0 === void 0 ? "bleed" : t0, {
    t
  } = useTranslation();
  let t1;
  $[5] !== t || $[6] !== tooltipProps?.content ? (t1 = tooltipProps?.content || t("common.context-menu-button.tooltip"), $[5] = t, $[6] = tooltipProps?.content, $[7] = t1) : t1 = $[7];
  let t2;
  $[8] !== t1 || $[9] !== tooltipProps ? (t2 = {
    ...tooltipProps,
    content: t1
  }, $[8] = t1, $[9] = tooltipProps, $[10] = t2) : t2 = $[10];
  let t3;
  return $[11] !== mode || $[12] !== ref || $[13] !== rest || $[14] !== t2 || $[15] !== tone ? (t3 = /* @__PURE__ */ jsx(Button, { ...rest, icon: EllipsisHorizontalIcon, mode, ref, tone, tooltipProps: t2 }), $[11] = mode, $[12] = ref, $[13] = rest, $[14] = t2, $[15] = tone, $[16] = t3) : t3 = $[16], t3;
});
function getWorkspaceIdentifier({
  name,
  title
}, index) {
  return typeof name == "string" && name.trim().length > 0 ? name : getNamelessWorkspaceIdentifier(title, index);
}
function getNamelessWorkspaceIdentifier(title, index) {
  const withTitle = typeof title == "string" && title.trim().length > 0 ? ` (titled "${title}")` : "";
  return `at index ${index}${withTitle}`;
}
function useWorkspaces() {
  const workspaces = useContext(WorkspacesContext);
  if (!workspaces)
    throw new Error("Could not find `workspaces` context");
  return workspaces;
}
class WorkspaceValidationError extends Error {
  constructor(message, options) {
    super(message), this.name = "WorkspaceValidationError", this.index = options?.index, this.identifier = options?.workspace && getWorkspaceIdentifier(options.workspace, options.index);
  }
}
function validateWorkspaces({
  workspaces
}) {
  if (workspaces.length === 0)
    throw new WorkspaceValidationError("At least one workspace is required.");
  validateNames(workspaces), validateBasePaths(workspaces);
}
function validateNames(workspaces) {
  const isSingleWorkspace = workspaces.length === 1, names = /* @__PURE__ */ new Map();
  workspaces.forEach((workspace, index) => {
    const {
      name: rawName,
      title
    } = workspace, thisIdentifier = getNamelessWorkspaceIdentifier(title, index);
    if (!rawName && !isSingleWorkspace)
      throw new WorkspaceValidationError(`All workspaces must have a \`name\`, unless only a single workspace is defined. Workspace ${thisIdentifier} did not define a \`name\`.`, {
        workspace,
        index
      });
    const name = isSingleWorkspace && typeof rawName > "u" ? "default" : rawName;
    if (typeof name != "string")
      throw new WorkspaceValidationError(`Workspace at index ${index} defined an invalid \`name\` - must be a string.`, {
        workspace,
        index
      });
    const normalized = name.toLowerCase(), existingWorkspace = names.get(normalized);
    if (existingWorkspace) {
      const prevIdentifier = getNamelessWorkspaceIdentifier(existingWorkspace.workspace.title, existingWorkspace.index);
      throw new WorkspaceValidationError(`\`name\`s must be unique. Workspace ${prevIdentifier} and workspace ${thisIdentifier} both have the \`name\` \`${name}\``, {
        workspace,
        index
      });
    }
    if (names.set(normalized, {
      index,
      workspace
    }), !/^[a-z0-9][a-z0-9_-]*$/i.test(name))
      throw new WorkspaceValidationError(`All workspace \`name\`s must consist of only a-z, 0-9, underscore and dashes, and cannot begin with an underscore or dash. Workspace ${thisIdentifier} has the invalid name \`${name}\``, {
        workspace,
        index
      });
  });
}
function validateBasePaths(workspaces) {
  workspaces.length > 1 && workspaces.every(hasBasePath), workspaces.every(validateBasePath);
  const [firstWorkspace, ...restOfWorkspaces] = workspaces, firstWorkspaceSegmentCount = (firstWorkspace.basePath || "/").slice(1).split("/").filter(Boolean).length;
  restOfWorkspaces.forEach((workspace, index) => {
    const workspaceSegmentCount = (workspace.basePath || "/").slice(1).split("/").length;
    if (firstWorkspaceSegmentCount !== workspaceSegmentCount)
      throw new WorkspaceValidationError(`All workspace \`basePath\`s must have the same amount of segments. Workspace \`${getWorkspaceIdentifier(firstWorkspace, index)}\` had ${firstWorkspaceSegmentCount} segment${firstWorkspaceSegmentCount === 1 ? "" : "s"} \`${firstWorkspace.basePath}\` but workspace \`${getWorkspaceIdentifier(workspace, index)}\` had ${workspaceSegmentCount} segment${workspaceSegmentCount === 1 ? "" : "s"} \`${workspace.basePath}\``, {
        workspace,
        index
      });
  });
  const basePaths = /* @__PURE__ */ new Map();
  workspaces.forEach((workspace, index) => {
    const basePath = (workspace.basePath || "").toLowerCase(), existingWorkspace = basePaths.get(basePath);
    if (existingWorkspace)
      throw new WorkspaceValidationError(`\`basePath\`s must be unique. Workspaces \`${existingWorkspace}\` and \`${getWorkspaceIdentifier(workspace, index)}\` both have the \`basePath\` \`${basePath}\``, {
        workspace,
        index
      });
    basePaths.set(basePath, getWorkspaceIdentifier(workspace, index));
  });
}
function hasBasePath(workspace, index) {
  const {
    name,
    basePath
  } = workspace;
  if (basePath && typeof basePath == "string")
    return !0;
  throw typeof basePath > "u" ? new WorkspaceValidationError(`If more than one workspace is defined, every workspace must have a \`basePath\` defined. Workspace \`${name}\` is missing a \`basePath\``, {
    workspace,
    index
  }) : new WorkspaceValidationError(`If more than one workspace is defined, every workspace must have a \`basePath\` defined. Workspace \`${name}\` has an invalid \`basePath\` (must be a non-empty string)`, {
    workspace,
    index
  });
}
function validateBasePath(workspace, index) {
  const {
    name,
    basePath
  } = workspace;
  if (!(!basePath || basePath === "/") && !/^\/[a-z0-9/_-]*[a-z0-9_-]+$/i.test(basePath))
    throw new WorkspaceValidationError(`All workspace \`basePath\`s must start with a leading \`/\`, consist of only URL safe characters, and cannot end with a trailing \`/\`. Workspace \`${name}\`'s basePath is \`${basePath}\``, {
      workspace,
      index
    });
}
const DEBUG_MODE$2 = !1, SPINNER_DELAY = 750, TEXT_DELAY = 2e3, StyledCard$6 = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "StyledCard",
  componentId: "sc-m78l3s-0"
})(({
  $fill
}) => css`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${$fill ? css`
            bottom: 0;
            height: 100%;
            left: 0;
            position: absolute;
            right: 0;
            top: 0;
            width: 100%;
          ` : css`
            min-height: 75px;
            height: stretch;
            height: -webkit-fill-available;
            width: stretch;
            width: -webkit-fill-available;
          `}

    ${DEBUG_MODE$2}

    > * {
      position: absolute;
    }
  `), StyledSpinner = /* @__PURE__ */ styled(Spinner).withConfig({
  displayName: "StyledSpinner",
  componentId: "sc-m78l3s-1"
})(({
  $animatePosition = !0
}) => css`
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    @keyframes slideUp {
      from {
        transform: translateY(0);
      }
      to {
        transform: translateY(-15px);
      }
    }
    animation: ${$animatePosition ? `500ms ease-out ${SPINNER_DELAY}ms 1 normal both running fadeIn, 750ms ease-out ${TEXT_DELAY}ms 1 normal both running slideUp` : `500ms ease-out ${SPINNER_DELAY}ms 1 normal both running fadeIn`};
  `), StyledText$6 = styled(Text$1).withConfig({
  displayName: "StyledText",
  componentId: "sc-m78l3s-2"
})`@keyframes fadeIn{from{opacity:0;}to{opacity:1;}}@keyframes slideDown{from{transform:translateY(0);}to{transform:translateY(15px);}}animation:1500ms ease-out ${TEXT_DELAY}ms 1 normal both running fadeIn,750ms ease-out ${TEXT_DELAY}ms 1 normal both running slideDown;`;
function LoadingBlock(t0) {
  const $ = c(10), {
    fill,
    showText,
    title
  } = t0, t1 = fill ? Layer : "div", t2 = !!showText;
  let t3;
  $[0] !== t2 ? (t3 = /* @__PURE__ */ jsx(StyledSpinner, { $animatePosition: t2, muted: !0 }), $[0] = t2, $[1] = t3) : t3 = $[1];
  let t4;
  $[2] !== showText || $[3] !== title ? (t4 = showText && /* @__PURE__ */ jsx(LoadingText, { title }), $[2] = showText, $[3] = title, $[4] = t4) : t4 = $[4];
  let t5;
  return $[5] !== fill || $[6] !== t1 || $[7] !== t3 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsxs(StyledCard$6, { $fill: fill, as: t1, "data-testid": "loading-block", children: [
    t3,
    t4
  ] }), $[5] = fill, $[6] = t1, $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9], t5;
}
function LoadingText(t0) {
  const $ = c(5), {
    title
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t || $[1] !== title ? (t1 = title || t("common.loading"), $[0] = t, $[1] = title, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(StyledText$6, { muted: !0, size: 1, children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
function defineLocaleResourceBundle(bundle) {
  return bundle;
}
function defineLocale(locale) {
  return locale;
}
function isStaticResourceBundle(bundle) {
  return !("then" in bundle.resources && typeof bundle.resources.then == "function");
}
function defineLocalesResources(namespace, resources) {
  return resources;
}
function removeUndefinedLocaleResources(resources) {
  const result = {};
  for (const key in resources)
    typeof resources[key] < "u" && (result[key] = resources[key]);
  return result;
}
const studioLocaleNamespace = "studio", validationLocaleNamespace = "validation", copyPasteLocalNamespace = "copy-paste", copyPasteLocaleStrings = defineLocalesResources("copy-paste", {
  /** Text on the field action button to copy a document */
  "copy-paste.field-action-copy-button.document.title": "Copy document",
  /** Text on the field action button to copy a field */
  "copy-paste.field-action-copy-button.field.title": "Copy field",
  /** Text on the field action button to paste a document */
  "copy-paste.field-action-paste-button.document.title": "Paste document",
  /** Text on the field action button to paste a field */
  "copy-paste.field-action-paste-button.field.title": "Paste field",
  /** --- On paste --- */
  /** The validation message that is shown when pasting a value into a read-only target */
  "copy-paste.on-paste.validation.read-only-target.description": "The target is read-only",
  /** The validation message that is shown when the source and target schema types are incompatible */
  "copy-paste.on-paste.validation.schema-type-incompatible.description": "Source and target schema types are not compatible",
  /** The validation message that is shown when reference types are incompatible */
  "copy-paste.on-paste.validation.reference-type-incompatible.description": 'References of type "{{sourceReferenceType}}" is not allowed in reference field that accepts types "{{targetReferenceTypes}}"',
  /** The validation message that is shown when reference is incompatible with filter */
  "copy-paste.on-paste.validation.reference-filter-incompatible.description": "Reference is not allowed in reference field according to filter",
  /** The validation message that is shown when reference does not exist */
  "copy-paste.on-paste.validation.reference-validation-failed.description": 'The referenced document "{{ref}}" does not exist',
  /** The validation message that is shown when image files are incompatible */
  "copy-paste.on-paste.validation.image-file-incompatible.description": 'A "{{sourceSchemaType}}" is not allowed in a "{{targetSchemaType}}"',
  /** The validation message that is shown when array types are incompatible */
  "copy-paste.on-paste.validation.array-type-incompatible.description": 'Value of type "{{type}}" is not allowed in this array field',
  /** The validation message that is shown when array values are incompatible */
  "copy-paste.on-paste.validation.array-value-incompatible.description": 'Value of type "{{type}}" is not allowed in this array field',
  /** The validation message that is shown when string values are incompatible */
  "copy-paste.on-paste.validation.string-value-incompatible.description": 'Value "{{value}}" is not allowed in "{{allowedStrings}}"',
  /** The validation message that is shown when primitive types are incompatible */
  "copy-paste.on-paste.validation.primitive-type-incompatible.description": 'Value of type "{{type}}" is not allowed in this field',
  /** The validation message that is shown when the clipboard is empty */
  "copy-paste.on-paste.validation.clipboard-empty.title": "Nothing to paste",
  /** The validation message that is shown when the clipboard item is invalid */
  "copy-paste.on-paste.validation.clipboard-invalid.title": "Invalid clipboard item",
  /** The validation message that is shown when schema types are incompatible */
  "copy-paste.on-paste.validation.schema-type-incompatible.title": "Could not resolve schema type for path: {{path}}",
  /** The warning message that is shown when not all values can be pasted */
  "copy-paste.on-paste.validation.partial-warning.title": "Could not paste all values",
  /** The error message that is shown when the MIME type is not accepted */
  "copy-paste.on-paste.validation.mime-type-incompatible.description": 'MIME type "{{mimeType}}" is not accepted for this field',
  /** The error message that is shown when the MIME type validation fails */
  "copy-paste.on-paste.validation.mime-type-validation-failed.description": "MIME type validation failed",
  /** --- On copy --- */
  /** The error message that is shown when schema types are incompatible */
  "copy-paste.on-copy.validation.schema-type-incompatible.title": "Could not resolve schema type for path: {{path}}",
  /** The error message that is shown when there is no value to copy */
  "copy-paste.on-copy.validation.no-value.title": "Empty value, nothing to copy",
  /** The error message that is shown when the clipboard is not supported */
  "copy-paste.on-copy.validation.clipboard-not-supported.description": "Clipboard access required to copy this content. Allow clipboard permissions in your browser settings, then try copying again.",
  /** The error message that is shown when the clipboard is not supported */
  "copy-paste.on-copy.validation.clipboard-not-supported.title": "Clipboard access blocked"
}), copyPasteLocaleResources = {
  locale: "en-US",
  namespace: copyPasteLocalNamespace,
  resources: copyPasteLocaleStrings
}, studioLocaleStrings = defineLocalesResources("studio", {
  /** "Configuration issue" header */
  "about-dialog.configuration-issue.header": "Configuration issue detected",
  /** Message shown if sanity.cli.ts is missing deployment.appId */
  "about-dialog.configuration-issue.missing-appid": "Auto updates is enabled, but no <code>deployment.appId</code> configured in <code>sanity.cli.ts</code>. This Studio is updating against the <strong>latest</strong>-channel.",
  /** "View documentation" link for auto-updating studios */
  "about-dialog.configuration-issue.missing-appid.view-documentation": "View documentation",
  /** "Disabled" status for auto-updates in About-dialog */
  "about-dialog.version-info.auto-updates.disabled": "Auto Updates not enabled",
  /** "Enabled" status for auto-updates in About-dialog */
  "about-dialog.version-info.auto-updates.enabled": "Auto Updates Enabled",
  /** @deprecated "Auto Updates" status header in About-dialog */
  "about-dialog.version-info.auto-updates.header": "Auto Updates",
  /** "How to enable" next to Disabled state for Auto updates in version info dialog */
  "about-dialog.version-info.auto-updates.how-to-enable": "Enable",
  /** "Manage version" link text */
  "about-dialog.version-info.auto-updates.manage-version": "Manage version",
  /** Text displayed on the "Copy to clipboard"-button after clicked */
  "about-dialog.version-info.copy-to-clipboard-button.copied-text": "Copied to Clipboard. Happy pasting!",
  /** "Copy to Clipboard" button text for copying version details from About-dialog */
  "about-dialog.version-info.copy-to-clipboard-button.text": "Copy to Clipboard",
  /** "Current version" header in version info dialog  */
  "about-dialog.version-info.current-version.header": "Current version",
  /** @deprecated "How to upgrade" link text */
  "about-dialog.version-info.how-to-upgrade": "Update now",
  /** "Latest version" header in version info dialog */
  "about-dialog.version-info.latest-version.header": "Latest version",
  /** Info text when auto updates is enabled and a new version is available */
  "about-dialog.version-info.new-auto-update-version-available": "New version available",
  /** "New version" header in version info dialog - Note that this is not necessary a *higher* version compared to current:
   *  It's a new version configured for auto updates which in some cases could even be a version below current  */
  "about-dialog.version-info.new-version.text": "New version",
  /** "Reload"-button when auto updates is enabled and a new version is available */
  "about-dialog.version-info.reload": "Reload",
  /** "Reload to update"-tooltip when auto updates is enabled and a new version is available */
  "about-dialog.version-info.reload-to-update": "Reload Studio to update",
  /** "Development" tooltip in About-dialog */
  "about-dialog.version-info.tooltip.development": "Development",
  /** "New version available" tooltip in About-dialog */
  "about-dialog.version-info.tooltip.new-version-available": "New version available",
  /** "Prerelease" tooltip in About-dialog */
  "about-dialog.version-info.tooltip.prerelease": "Prerelease",
  /** "Up to date" tooltip in About-dialog */
  "about-dialog.version-info.tooltip.up-to-date": "Up to date",
  /** @deprecated "Up to date" status in About-dialog */
  "about-dialog.version-info.up-to-date": "Up to date",
  /** "Upgrade"-button text */
  "about-dialog.version-info.update-button.text": "Update",
  /** "Upgrade"-button tooltip text */
  "about-dialog.version-info.update-button.tooltip": "Learn how to update Sanity Studio",
  /** "User agent" header in About-dialog */
  "about-dialog.version-info.user-agent.header": "User agent",
  /** "View on GitHub" link from version info dialog */
  "about-dialog.version-info.view-on-github": "View on GitHub",
  /** The text used in the tooltip shown in the dialog close button */
  "announcement.dialog.close": "Close",
  /** Aria label to be used in the dialog close button */
  "announcement.dialog.close-label": "Close dialog",
  /**Text to be used in the tooltip in the button in the studio announcement card */
  "announcement.floating-button.dismiss": "Close",
  /**Aria label to be used in the floating button in the studio announcement card, to dismiss the card */
  "announcement.floating-button.dismiss-label": "Dismiss announcements",
  /**Aria label to be used in the floating button in the studio announcement card */
  "announcement.floating-button.open-label": "Open announcements",
  /** Menu item for deleting the asset */
  "asset-source.asset-list.menu.delete": "Delete",
  /** Menu item for showing where a particular asset is used */
  "asset-source.asset-list.menu.show-usage": "Show usage",
  /** Header in usage dialog for file assets */
  "asset-source.asset-usage-dialog.header_file": "Documents using file",
  /** Header in usage dialog for image assets */
  "asset-source.asset-usage-dialog.header_image": "Documents using image",
  /** Text shown in usage dialog when loading documents using the selected asset */
  "asset-source.asset-usage-dialog.loading": "Loading\u2026",
  /** Browse button text */
  "asset-source.browse-button.text": "Select",
  /** Text for cancel action in delete-asset dialog */
  "asset-source.delete-dialog.action.cancel": "Cancel",
  /** Text for "confirm delete" action in delete-asset dialog */
  "asset-source.delete-dialog.action.delete": "Delete",
  /** Dialog header for delete-asset dialog when deleting a file */
  "asset-source.delete-dialog.header_file": "Delete file",
  /** Dialog header for delete-asset dialog when deleting an image */
  "asset-source.delete-dialog.header_image": "Delete image",
  /** Text shown in delete dialog when loading documents using the selected asset */
  "asset-source.delete-dialog.loading": "Loading\u2026",
  /** Message confirming to delete *named* file */
  "asset-source.delete-dialog.usage-list.confirm-delete-file_named": "You are about to delete the file <strong>{{filename}}</strong> and its metadata. Are you sure?",
  /** Message confirming to delete *unnamed* file */
  "asset-source.delete-dialog.usage-list.confirm-delete-file_unnamed": "You are about to delete the file and its metadata. Are you sure?",
  /** Message confirming to delete *named* image */
  "asset-source.delete-dialog.usage-list.confirm-delete-image_named": "You are about to delete the image <strong>{{filename}}</strong> and its metadata. Are you sure?",
  /** Message confirming to delete *unnamed* image */
  "asset-source.delete-dialog.usage-list.confirm-delete-image_unnamed": "You are about to delete the image and its metadata. Are you sure?",
  /** Alt text showing on image preview in delete asset dialog  */
  "asset-source.delete-dialog.usage-list.image-preview-alt": "Preview of image",
  /** Warning message showing when *named* file can't be deleted because it is in use */
  "asset-source.delete-dialog.usage-list.warning-file-is-in-use_named": "{{filename}} cannot be deleted because it's being used. In order to delete this file, you first need to remove all uses of it.",
  /** Warning message showing when *unnamed* file can't be deleted because it is in use */
  "asset-source.delete-dialog.usage-list.warning-file-is-in-use_unnamed": "This file cannot be deleted because it's being used. In order to delete it, you first need to remove all uses of it.",
  /** Warning message showing when *named* image can't be deleted because it is in use */
  "asset-source.delete-dialog.usage-list.warning-image-is-in-use_named": "{{filename}} cannot be deleted because it's being used. In order to delete this image, you first need to remove all uses of it.",
  /** Warning message showing when *unnamed* image can't be deleted because it is in use */
  "asset-source.delete-dialog.usage-list.warning-image-is-in-use_unnamed": "This image cannot be deleted because it's being used. In order to delete it, you first need to remove all uses of it.",
  /** Text shown when the list of assets only include a specific set of types */
  "asset-source.dialog.accept-message": "Only showing assets of accepted types: <strong>{{acceptTypes}}</strong>",
  /** Select asset dialog cancel-button */
  "asset-source.dialog.button.cancel": "Cancel",
  /** Select asset dialog select-button */
  "asset-source.dialog.button.select": "Select",
  /** Keys shared between both image asset source and file asset source */
  /** Insert asset error */
  "asset-source.dialog.insert-asset-error": "Error inserting asset. See the console for more information.",
  /** Select asset dialog load more items */
  "asset-source.dialog.load-more": "Load more",
  /** Text shown when selecting a file but there's no files to select from
   * @deprecated no longer in use
   */
  "asset-source.dialog.no-assets_file": "No files",
  /** Text shown when selecting an image but there's no images to select from
   * @deprecated no longer in use
   */
  "asset-source.dialog.no-assets_image": "No images",
  "asset-source.file.asset-list.action.delete.disabled-cannot-delete-current-file": "Cannot delete currently selected file",
  "asset-source.file.asset-list.action.delete.text": "Delete",
  "asset-source.file.asset-list.action.delete.title": "Delete file",
  "asset-source.file.asset-list.action.select-file.title": "Select the file {{filename}}",
  "asset-source.file.asset-list.action.show-usage.title": "Show usage",
  "asset-source.file.asset-list.delete-failed": "File could not be deleted",
  "asset-source.file.asset-list.delete-successful": "File was deleted",
  "asset-source.file.asset-list.header.date-added": "Date added",
  /** File asset source */
  "asset-source.file.asset-list.header.filename": "Filename",
  "asset-source.file.asset-list.header.size": "Size",
  "asset-source.file.asset-list.header.type": "Type",
  /** Text displayed on button or menu invoking the file asset source */
  "asset-source.file.title": "Uploaded files",
  "asset-source.image.asset-list.delete-failed": "Image could not be deleted",
  /** Image asset source */
  "asset-source.image.asset-list.delete-successful": "Image was deleted",
  /** Text displayed on button or menu invoking the image asset source */
  "asset-source.image.title": "Uploaded images",
  /** Built in asset source usage texts */
  "asset-source.usage-list.documents-using-file_named_one": "One document is using file <code>{{filename}}</code>",
  "asset-source.usage-list.documents-using-file_named_other": "{{count}} documents are using file <code>{{filename}}</code>",
  /** Text shown in usage dialog for a file asset when there are zero, one or more documents using the *named* file **/
  "asset-source.usage-list.documents-using-file_named_zero": "No documents are using file <code>{{filename}}</code>",
  "asset-source.usage-list.documents-using-file_unnamed_one": "One document is using this file",
  "asset-source.usage-list.documents-using-file_unnamed_other": "{{count}} documents are using this file",
  /** Text shown in usage dialog for a file asset when there are zero, one or more documents using the *unnamed* file **/
  "asset-source.usage-list.documents-using-file_unnamed_zero": "No documents are using this file",
  "asset-source.usage-list.documents-using-image_named_one": "One document is using image <code>{{filename}}</code>",
  "asset-source.usage-list.documents-using-image_named_other": "{{count}} documents are using image <code>{{filename}}</code>",
  /** Text shown in usage dialog for an image asset when there are zero, one or more documents using the *named* image **/
  "asset-source.usage-list.documents-using-image_named_zero": "No documents are using image <code>{{filename}}</code>",
  "asset-source.usage-list.documents-using-image_unnamed_one": "One document is using this image",
  "asset-source.usage-list.documents-using-image_unnamed_other": "{{count}} documents are using this image",
  /** Text shown in usage dialog for an image asset when there are zero, one or more documents using the *unnamed* image **/
  "asset-source.usage-list.documents-using-image_unnamed_zero": "No documents are using this image",
  /** Common (all) Asset Source texts. Note that all translation keys starting with 'asset-source.' is for the built in asset source. */
  "asset-sources.common.uploader.upload-failed.description": "See the console for more information.",
  "asset-sources.common.uploader.upload-failed.title": "Upload failed",
  /** Menu Items for Dataset Asset Source (will be replaced with workspace name by default) */
  "asset-sources.dataset.file.title": "Workspace files",
  "asset-sources.dataset.image.title": "Workspace images",
  /** Error messages for the Media Library Asset Source  */
  "asset-sources.media-library.error.library-could-not-be-resolved": "Something went wrong trying to resolve the Media Library for this project.",
  /** Error message shown when no media library has been provisioned for the current organization */
  "asset-sources.media-library.error.no-media-library-provisioned": "No media library has been provisioned for this organization.",
  /** Menu Items for Media Library Asset Source */
  "asset-sources.media-library.file.title": "Media Library",
  "asset-sources.media-library.image.title": "Media Library",
  /** Done button text */
  "asset-sources.media-library.open-in-source-dialog.button.done": "Done",
  /** Select new asset button text with target title */
  "asset-sources.media-library.open-in-source-dialog.button.select-new-asset": "Select new asset for \u201C{{targetTitle}}\u201D",
  "asset-sources.media-library.open-in-source-dialog.button.select-new-asset-fallback": "Select new asset",
  /** Title for the open in source dialog */
  "asset-sources.media-library.open-in-source-dialog.title": "Edit asset",
  /** Title for the upload dialog (component mode) */
  "asset-sources.media-library.upload-dialog.title": "Upload to Media Library",
  /** Warning message shown when uploading already existing files to the Media Library Asset Source */
  "asset-sources.media-library.warning.file-already-exist.description": "Using the existing file found in the library.",
  "asset-sources.media-library.warning.file-already-exist.title": "File: '{{filename}}' already exists",
  /** Label when a release has been deleted by a different user */
  "banners.deleted-bundle-banner.text": "The '<strong>{{title}}</strong>' release has been deleted.",
  /** Action message for navigating to next month */
  "calendar.action.go-to-next-month": "Go to next month",
  /** Action message for navigating to next year */
  "calendar.action.go-to-next-year": "Go to next year",
  /** Action message for navigating to previous month */
  "calendar.action.go-to-previous-month": "Go to previous month",
  /** Action message for navigating to previous year */
  "calendar.action.go-to-previous-year": "Go to previous year",
  /* Label for navigating the calendar to "today", without _selecting_ today. Short form, eg `Today`, not `Go to today` */
  "calendar.action.go-to-today": "Today",
  /* Accessibility label for navigating the calendar to "today", without _selecting_ today */
  "calendar.action.go-to-today-aria-label": "Go to today",
  /* Label for navigating the calendar to "tomorrow", without _selecting_ tomorrow. Short form, eg `Tomorrow`, not `Go to tomorrow` */
  "calendar.action.go-to-tomorrow": "Tomorrow",
  /* Label for navigating the calendar to "yesterday", without _selecting_ yesterday. Short form, eg `Yesterday`, not `Go to yesterday` */
  "calendar.action.go-to-yesterday": "Yesterday",
  /** Label for switch that controls whether or not to include time in given timestamp */
  "calendar.action.include-time-label": "Include time",
  /** Action message for selecting the time */
  "calendar.action.select-time": "Select time",
  /** Action message for setting to the current time */
  "calendar.action.set-to-current-time": "Set to current time",
  /** Label for selecting an hour preset. Receives a `time` param as a string on hh:mm format and a `date` param as a Date instance denoting the preset date */
  "calendar.action.set-to-time-preset": "{{time}} on {{date, datetime}}",
  /** Aria label for button to open date picker */
  "calendar.button.aria-label": "Open calendar",
  /** Tooltip content for button to open datetime input */
  "calendar.button.tooltip-text": "Select date",
  /** Error message displayed in calendar when entered date is not the correct format */
  "calendar.error.must-be-in-format": "Must be in the format: {{exampleDate}}",
  /** Month name for April */
  "calendar.month-names.april": "April",
  /** Month name for August */
  "calendar.month-names.august": "August",
  /** Month name for December */
  "calendar.month-names.december": "December",
  /** Month name for February */
  "calendar.month-names.february": "February",
  /** Month name for January */
  "calendar.month-names.january": "January",
  /** Month name for July */
  "calendar.month-names.july": "July",
  /** Month name for June */
  "calendar.month-names.june": "June",
  /** Month name for March */
  "calendar.month-names.march": "March",
  /** Month name for May */
  "calendar.month-names.may": "May",
  /** Month name for November */
  "calendar.month-names.november": "November",
  /** Month name for October */
  "calendar.month-names.october": "October",
  /** Month name for September */
  "calendar.month-names.september": "September",
  /** Short weekday name for Friday */
  "calendar.weekday-names.short.friday": "Fri",
  /** Short weekday name for Monday */
  "calendar.weekday-names.short.monday": "Mon",
  /** Short weekday name for Saturdayday */
  "calendar.weekday-names.short.saturday": "Sat",
  /** Short weekday name for Sunday */
  "calendar.weekday-names.short.sunday": "Sun",
  /** Short weekday name for Thursday */
  "calendar.weekday-names.short.thursday": "Thu",
  /** Short weekday name for Tuesday */
  "calendar.weekday-names.short.tuesday": "Tue",
  /** Short weekday name for Wednesday */
  "calendar.weekday-names.short.wednesday": "Wed",
  /** Label for the close button label in Review Changes pane */
  "changes.action.close-label": "Close history",
  /** Cancel label for revert button prompt action */
  "changes.action.revert-all-cancel": "Cancel",
  /** Revert all confirm label for revert button action - used on prompt button + review changes pane */
  "changes.action.revert-all-confirm": "Revert all",
  /** Prompt for reverting all changes in document in Review Changes pane. Includes a count of changes. */
  "changes.action.revert-all-description": "Are you sure you want to revert all {{count}} changes?",
  /** Prompt for confirming revert change (singular) label for field change action */
  "changes.action.revert-changes-confirm-change_one": "Revert change",
  /** Revert for confirming revert (plural) label for field change action */
  "changes.action.revert-changes-confirm-change_other": "Revert changes",
  /** Prompt for reverting changes for a field change */
  "changes.action.revert-changes-description": "Are you sure you want to revert the changes?",
  /** Prompt for reverting changes for a group change, eg multiple changes */
  "changes.action.revert-changes-description_one": "Are you sure you want to revert the change?",
  /** Label for when the action of the change was to set something that was previously empty, eg a field was given a value, an array item was added, an asset was selected or similar */
  "changes.added-label": "Added",
  /** Array diff: An item was added in a given position (`{{position}}`) */
  "changes.array.item-added-in-position": "Added in position {{position}}",
  "changes.array.item-moved_down_one": "Moved {{count}} position down",
  "changes.array.item-moved_down_other": "Moved {{count}} positions down",
  /**
   * Array diff: An item was moved within the array.
   * Receives `{{count}}` representing number of positions it moved.
   * Context is the direction of the move, either `up` or `down`.
   */
  "changes.array.item-moved_up_one": "Moved {{count}} position up",
  "changes.array.item-moved_up_other": "Moved {{count}} positions up",
  /** Array diff: An item was removed from a given position (`{{position}}`) */
  "changes.array.item-removed-from-position": "Removed from position {{position}}",
  /** Accessibility label for the "change bar" shown when there are edits on a field-level */
  "changes.change-bar.aria-label": "Review changes",
  /** Label for when the action of the change was _not_ an add/remove, eg a text field changed value, an image was changed from one asset to another or similar */
  "changes.changed-label": "Changed",
  /** Label and text for tooltip that indicates the authors of the changes */
  "changes.changes-by-author": "Changes by",
  /** Additional text shown in development mode when a diff component crashes during rendering */
  "changes.error-boundary.developer-info": "Check the developer console for more information",
  /** Text shown when a diff component crashes during rendering, triggering the error boundary */
  "changes.error-boundary.title": "Rendering the changes to this field caused an error",
  /* Error description when changes could not be loaded */
  "changes.error-description": "We're unable to load the changes for this document.",
  /** Error title when changes could not be loaded */
  "changes.error-title": "Something went wrong",
  /** Error message shown when the value of a field is not the expected one */
  "changes.error.incorrect-type-message": 'Value error: Value is of type "<code>{{actualType}}</code>", expected "<code>{{expectedType}}</code>"',
  /** File diff: Fallback title for the meta info section when there is no original filename to use  */
  "changes.file.meta-info-fallback-title": "Untitled",
  /** Image diff: Text shown in tooltip when hovering hotspot that has changed in diff view */
  "changes.image.crop-changed": "Crop changed",
  /** Image diff: Text shown if the previous image asset was deleted (shouldn't theoretically happen) */
  "changes.image.deleted": "Image deleted",
  /** Image diff: Text shown if the image failed to be loaded when previewing it */
  "changes.image.error-loading-image": "Error loading image",
  /** Image diff: Text shown in tooltip when hovering hotspot that has changed in diff view */
  "changes.image.hotspot-changed": "Hotspot changed",
  /** Image diff: Fallback title for the meta info section when there is no original filename to use  */
  "changes.image.meta-info-fallback-title": "Untitled",
  /** Image diff: Text shown if no asset has been set for the field (but has metadata changes) */
  "changes.image.no-asset-set": "Image not set",
  /** Image diff: Text shown when the from/to state has/had no image */
  "changes.image.no-image-placeholder": "(no image)",
  /** Label for the "from" value in the change inspector */
  "changes.inspector.from-label": "From",
  /** Label for the "meta" (field path, action etc) information in the change inspector */
  "changes.inspector.meta-label": "Meta",
  /** Label for the "to" value in the change inspector */
  "changes.inspector.to-label": "To",
  /** Loading author of change in the differences tooltip in the review changes pane */
  "changes.loading-author": "Loading\u2026",
  /** Loading changes in Review Changes Pane */
  "changes.loading-changes": "Loading changes\u2026",
  /** Error message shown when the document revision could not be found */
  "changes.missing-since-document-error": "We couldn't find the document revision with id: <code>{{revisionId}}</code> you're trying to compare. <Break/> This is probably due to history retention policy of your plan. <Break/> Please select a different <strong>From</strong> entry.",
  /** No Changes description in the Review Changes pane */
  "changes.no-changes-description": "Edit the document or select an older version in the timeline to see a list of changes appear in this panel.",
  /** No Changes title in the Review Changes pane */
  "changes.no-changes-title": "There are no changes",
  /* Label for the tooltip that shows when an action is not selectable*/
  "changes.not-selectable": "It is not possible to select this event",
  /** Portable Text diff: An annotation was added */
  "changes.portable-text.annotation_added": "Added annotation",
  /** Portable Text diff: An annotation was changed */
  "changes.portable-text.annotation_changed": "Changed annotation",
  /** Portable Text diff: An annotation was removed */
  "changes.portable-text.annotation_removed": "Removed annotation",
  /** Portable Text diff: An annotation was left unchanged */
  "changes.portable-text.annotation_unchanged": "Unchanged annotation",
  /** Portable Text diff: A block changed from one style to another (eg `normal` to `h1` or similar) */
  "changes.portable-text.block-style-changed": 'Changed block style from "{{fromStyle}}" to "{{toStyle}}"',
  /** Portable Text diff: Change formatting of text (setting/unsetting marks, eg bold/italic etc) */
  "changes.portable-text.changed-formatting": "Changed formatting",
  /** Portable Text diff: An empty inline object is part of a change */
  "changes.portable-text.empty-inline-object": "Empty {{inlineObjectType}}",
  /** Portable Text diff: An empty object is the result of adding/removing an annotation */
  "changes.portable-text.empty-object-annotation": "Empty {{annotationType}}",
  /** Portable Text diff: Added a block containing no text (eg empty block) */
  "changes.portable-text.empty-text_added": "Added empty text",
  /** Portable Text diff: Changed a block that contained no text (eg empty block) */
  "changes.portable-text.empty-text_changed": "Changed empty text",
  /** Portable Text diff: Removed a block containing no text (eg empty block) */
  "changes.portable-text.empty-text_removed": "Removed empty text",
  /** Portable Text diff: An inline object was added */
  "changes.portable-text.inline-object_added": "Added inline object",
  /** Portable Text diff: An inline object was changed */
  "changes.portable-text.inline-object_changed": "Changed inline object",
  /** Portable Text diff: An inline object was removed */
  "changes.portable-text.inline-object_removed": "Removed inline object",
  /** Portable Text diff: An inline object was left unchanged */
  "changes.portable-text.inline-object_unchanged": "Unchanged inline object",
  /** Portable Text diff: Added a chunk of text */
  "changes.portable-text.text_added": "Added text",
  /** Portable Text diff: Removed a chunk of text */
  "changes.portable-text.text_removed": "Removed text",
  /** Portable Text diff: Annotation has an unknown schema type */
  "changes.portable-text.unknown-annotation-schema-type": "Unknown schema type",
  /** Portable Text diff: Inline object has an unknown schema type */
  "changes.portable-text.unknown-inline-object-schema-type": "Unknown schema type",
  /** Label for when the action of the change was a removal, eg a field was cleared, an array item was removed, an asset was deselected or similar */
  "changes.removed-label": "Removed",
  /** Same Revision Selected description in the Review Changes pane */
  "changes.same-revision-selected-description": "You have selected the same <strong>from</strong> and <strong>to</strong> revision, please select different revisions to compare the changes between them.",
  /** Same Revision Selected title in the Review Changes pane */
  "changes.same-revision-selected-title": "Same revision selected",
  /** Title for the Review Changes pane */
  "changes.title": "History",
  /**The title that will be shown in the badge inside the events when the item is a draft */
  "changes.versions.draft": "Draft",
  /** --- Common components --- */
  /** Tooltip text for context menu buttons */
  "common.context-menu-button.tooltip": "Show more",
  /** Default text for dialog cancel button */
  "common.dialog.cancel-button.text": "Cancel",
  /** Default text for dialog confirm button */
  "common.dialog.confirm-button.text": "Confirm",
  /** Default text in shared loader text / spinner lockup */
  "common.loading": "Loading",
  /** The title of the reconnecting toast */
  "common.reconnecting.toast.title": "Trying to connect\u2026",
  /** --- Configuration issues --- */
  /** Default label text on configuration issues button */
  "configuration-issues.button.label": "Configuration issues",
  /** Tooltip displayed on configuration issues button */
  "configuration-issues.button.tooltip": "Found configuration issues",
  /** The fallback title for an ordering menu item if no localized titles are provided. */
  "default-menu-item.fallback-title": "Sort by {{title}}",
  /** Title for the default ordering/SortOrder if no orderings are provided and the caption field is found */
  "default-orderings.caption": "Sort by Caption",
  /** Title for the default ordering/SortOrder if no orderings are provided and the description field is found */
  "default-orderings.description": "Sort by Description",
  /** Title for the default ordering/SortOrder if no orderings are provided and the header field is found */
  "default-orderings.header": "Sort by Header",
  /** Title for the default ordering/SortOrder if no orderings are provided and the heading field is found */
  "default-orderings.heading": "Sort by Heading",
  /** Title for the default ordering/SortOrder if no orderings are provided and the label field is found */
  "default-orderings.label": "Sort by Label",
  /** Title for the default ordering/SortOrder if no orderings are provided and the name field is found */
  "default-orderings.name": "Sort by Name",
  /** Title for the default ordering/SortOrder if no orderings are provided and the title field is found */
  "default-orderings.title": "Sort by Title",
  /** Label for action that closes divergence inspector */
  "divergence.action.close.label": "Close",
  /** Label for action that marks divergence as resolved */
  "divergence.action.markResolved.label": "Ignore",
  /** Label for action that moves inspector to the next divergence in the document */
  "divergence.action.next.label": "Next",
  /** Label for action that moves inspector to the previous divergence in the document */
  "divergence.action.previous.label": "Previous",
  /** Label for action that replaces the node's value in the current version with its latest value in the upstream version */
  "divergence.action.takeFromUpstream.label": "Copy from base",
  /** Verb to describe the node's value changed */
  "divergence.effect.changed": "changed",
  /** Summary of the change that occurred */
  "divergence.effect.summary": "{{title}} {{effect}} in {{versionName}} version",
  /** Description of the position of the current divergence being inspected, compared to the total count of divergences */
  "divergence.pagination": "{{position}} of {{count}}",
  /** Label for divergence in a single node */
  "divergence.unresolved-divergence_one": "Unresolved change in {{versionName}} version",
  /** Label for divergences in multiple nodes */
  "divergence.unresolved-divergence_other": "{{count}} unresolved changes in {{versionName}} version",
  /** Label to show in the document footer indicating the creation date of the document */
  "document-status.created": "Created {{date}}",
  /** Label to show in the document status indicating the date of the status */
  "document-status.date": "{{date}}",
  /** Label to show in the document footer indicating the last edited date of the document */
  "document-status.edited": "Edited {{date}}",
  /** Label to show in the document footer status line when a document was last published */
  "document-status.last-published": "Last published",
  /** Label to show in the document footer indicating the document is not published*/
  "document-status.not-published": "Not published",
  /** Label to show in the document footer indicating the published date of the document */
  "document-status.published": "Edited {{date}}",
  /** Label to show in the document footer indicating the revision from date of the document */
  "document-status.revision-from": "Revision from <em>{{date}}</em>",
  /** Label to show in the document footer indicating that the revision was not found */
  "document-status.revision-not-found": "Revision not found",
  /** Toast description shown when saving changes is taking longer than expected */
  "document-store.slow-commit.description": "Your changes are still being saved.",
  /** Toast title shown when saving changes is taking longer than expected */
  "document-store.slow-commit.title": "Saving is taking longer than expected",
  /** Label to indicate that a document type was not found */
  "document.type.not-found": 'Document type "{{type}}" not found',
  /** Error message shown when an action cannot be performed */
  "errors.unable-to-perform-action": "Unable to perform this action",
  /** The value of the <code>_key</code> property must be a unique string. */
  "form.error.duplicate-keys-alert.details.additional-description": "The value of the <code>_key</code> property must be a unique string.",
  /** This usually happens when items are created using an API client, and the <code>_key</code> property of each elements has been generated non-uniquely. */
  "form.error.duplicate-keys-alert.details.description": "This usually happens when items are created using an API client, and the <code>_key</code> property of each elements has been generated non-uniquely.",
  /** Developer info */
  "form.error.duplicate-keys-alert.details.title": "Developer info",
  /** Generate unique keys */
  "form.error.duplicate-keys-alert.generate-button.text": "Generate unique keys",
  /** Several items in this list share the same identifier (key). Every item must have an unique identifier. */
  "form.error.duplicate-keys-alert.summary": "Several items in this list share the same identifier (key). Every item must have an unique identifier.",
  /** Non-unique keys */
  "form.error.duplicate-keys-alert.title": "Non-unique keys",
  /** Error text shown when a field with a given name cannot be found in the schema or is conditionally hidden but explicitly told to render  */
  "form.error.field-not-found": 'Field "{{fieldName}}" not found among members \u2013 verify that it is defined in the schema and that it has not been conditionally hidden.',
  /** Add missing keys */
  "form.error.missing-keys-alert.add-button.text": "Add missing keys",
  /** The value of the <code>_key</code> property must be a unique string. */
  "form.error.missing-keys-alert.details.additional-description": "The value of the <code>_key</code> property must be a unique string.",
  /** This usually happens when items are created using an API client, and the <code>_key</code> property has not been included. */
  "form.error.missing-keys-alert.details.description": "This usually happens when items are created using an API client, and the <code>_key</code> property has not been included.",
  /** Developer info */
  "form.error.missing-keys-alert.details.title": "Developer info",
  /** Some items in the list are missing their keys. This must be fixed in order to edit the list. */
  "form.error.missing-keys-alert.summary": "Some items in the list are missing their keys. This must be fixed in order to edit the list.",
  /** Missing keys */
  "form.error.missing-keys-alert.title": "Missing keys",
  /** This usually happens when items are created using an API client, or when a custom input component has added invalid data to the list. */
  "form.error.mixed-array-alert.details.description": "This usually happens when items are created using an API client, or when a custom input component has added invalid data to the list.",
  /** Developer info */
  "form.error.mixed-array-alert.details.title": "Developer info",
  /**  Remove non-object values */
  "form.error.mixed-array-alert.remove-button.text": "Remove non-object values",
  /** Some items in this list are not objects. This must be fixed in order to edit the list. */
  "form.error.mixed-array-alert.summary": "Some items in this list are not objects. This must be fixed in order to edit the list.",
  /** Invalid list values */
  "form.error.mixed-array-alert.title": "Invalid list values",
  /** Error text shown when form is unable to find an array item at a given indexed path */
  "form.error.no-array-item-at-index": "No array item at index <code>{{index}}</code> found at path <code>{{path}}</code>",
  /** Error text shown when form is unable to find an array item at a given keyed path */
  "form.error.no-array-item-at-key": 'No array item with `_key` <code>"{{key}}"</code> found at path <code>{{path}}</code>',
  /** The title above the error call stack output related to the crash */
  "form.error.unhandled-runtime-error.call-stack.title": "Call Stack:",
  /** The title above the error component stack provided by React's underlying ErrorBoundary component */
  "form.error.unhandled-runtime-error.component-stack.title": "Component Stack:",
  /** The error message for the unhandled error that crashed the Input component during render */
  "form.error.unhandled-runtime-error.error-message": "Error: {{message}}",
  /** The title for the error card rendered inside a field in place of a crashing input */
  "form.error.unhandled-runtime-error.title": "Unhandled Runtime Error",
  /** Form field deprecated label */
  "form.field.deprecated-label": "deprecated",
  /** Fallback title shown above field if it has no defined title */
  "form.field.untitled-field-label": "Untitled",
  /** Accessibility label for the icon that indicates the field has a validation error */
  "form.validation.has-error-aria-label": "Has error",
  /** Accessibility label for the icon that indicates the field has validation information */
  "form.validation.has-info-aria-label": "Has information",
  /** Accessibility label for the icon that indicates the field has a validation warning */
  "form.validation.has-warning-aria-label": "Has warning",
  /** Text shown when summarizing validation information, when the field has one or more errors */
  "form.validation.summary.errors-count_one": "{{count}} error",
  "form.validation.summary.errors-count_other": "{{count}} errors",
  /** Text shown when summarizing validation information, when the field has one or more warnings */
  "form.validation.summary.warnings-count_one": "{{count}} warning",
  "form.validation.summary.warnings-count_other": "{{count}} warnings",
  /** Tooltip for free trial navbar button indicating remaining days */
  "free-trial.tooltip.days-count_one": "{{count}} day left in trial",
  "free-trial.tooltip.days-count_other": "{{count}} days left in trial",
  /** Tooltip for free trial navbar button, once trial has ended */
  "free-trial.tooltip.trial-finished": "Upgrade your project",
  /**
   * Label for "contact sales" call to action
   * These are titles for fallback links in the event the help & resources endpoint isn't able to be fetched
   */
  "help-resources.action.contact-sales": "Contact sales",
  /**
   * Label for "help and support" call to action
   * These are titles for fallback links in the event the help & resources endpoint isn't able to be fetched
   */
  "help-resources.action.help-and-support": "Help and support",
  /**
   * Label for "join our community" call to action
   * These are titles for fallback links in the event the help & resources endpoint isn't able to be fetched
   */
  "help-resources.action.join-our-community": "Join our community",
  /** Information for what the latest sanity version is */
  "help-resources.latest-sanity-version": "Latest version is v{{latestVersion}}",
  /** Text for link to register a studio */
  "help-resources.register-studio": "Register studio",
  /** Name of the sanity studio */
  "help-resources.studio": "Sanity Studio",
  /** Menu item for registered studios (i.e. copies app id) */
  "help-resources.studio-app-id": "App id",
  /** Menu item for reloading Studio to update */
  "help-resources.studio-auto-update-now": "Reload to update to v{{newVersion}}",
  /** Information for what studio version the current studio is running */
  "help-resources.studio-version": "Sanity Studio v{{studioVersion}}",
  /** Title for help and resources menus */
  "help-resources.title": "Help and resources",
  /** Label for studio's which are up to date */
  "help-resources.up-to-date": "Up to date",
  /** Version text */
  "help-resources.version": "v{{version}}",
  /**Incoming references inspector title */
  "incoming-references.title": "Incoming references",
  /** Text for button to cancel an ongoing upload */
  "input.files.common.cancel-upload": "Cancel",
  /** Text for menuitem upload button default asset source */
  "input.files.common.upload-placeholder.file-input-button.default-source.badge": "Default",
  /** Text for file input button in upload placeholder */
  "input.files.common.upload-placeholder.file-input-button.text": "Upload",
  /** Uploading <FileName/> */
  "input.files.common.upload-progress": "Uploading <FileName/>",
  /** The referenced document cannot be opened, because the URL failed to be resolved */
  "input.reference.document-cannot-be-opened.failed-to-resolve-url": "This document cannot be opened (unable to resolve URL to Studio)",
  /** Label for adding item after a specific array item */
  "inputs.array.action.add-after": "Add item after",
  /** Label for adding item before a specific array item */
  "inputs.array.action.add-before": "Add item before",
  /** Label for adding array item action when the schema allows for only one schema type */
  "inputs.array.action.add-item": "Add item",
  /**
   * Label for adding one array item action when the schema allows for multiple schema types,
   * eg. will prompt the user to select a type once triggered
   */
  "inputs.array.action.add-item-select-type": "Add item...",
  /** Label for copying an array item  */
  "inputs.array.action.copy": "Copy",
  /** Array drag handle button tooltip */
  "inputs.array.action.drag.tooltip": "Drag to re-order",
  /** Label for duplicating an array item  */
  "inputs.array.action.duplicate": "Duplicate",
  /** Label for editing the item of a specific type, eg "Edit Person" */
  "inputs.array.action.edit": "Edit {{itemTypeTitle}}",
  /** Tooltip text explaining why adding items is disabled when array max is reached */
  "inputs.array.action.max-reached": "Maximum items reached",
  /** Label for removing an array item action  */
  "inputs.array.action.remove": "Remove",
  /** Label for removing action when an array item has an error  */
  "inputs.array.action.remove-invalid-item": "Remove",
  /** Label for viewing the item of a specific type, eg "View Person" */
  "inputs.array.action.view": "View {{itemTypeTitle}}",
  /** Error description for the array item tooltip that explains that the current item can still be moved or deleted but not edited since the schema definition is not found */
  "inputs.array.error.can-delete-but-no-edit-description": "You can still move or delete this item, but it cannot be edited since the schema definition for its type is nowhere to be found.",
  /** Error label for toast when array could not resolve the initial value */
  "inputs.array.error.cannot-resolve-initial-value-title": "Unable to resolve initial value for type: {{schemaTypeTitle}}: {{errorMessage}}.",
  /** Error label for toast when trying to upload one array item of a type that cannot be converted to array */
  "inputs.array.error.cannot-upload-unable-to-convert_one": "The following item can't be uploaded because there's no known conversion from content type to array item:",
  /** Error label for toast when trying to upload multiple array items of a type that cannot be converted to array */
  "inputs.array.error.cannot-upload-unable-to-convert_other": "The following items can't be uploaded because there's no known conversion from content types to array item:",
  /** Error description for the array item tooltip that explains that the current type item is not valid for the list  */
  "inputs.array.error.current-schema-not-declare-description": "The current schema does not declare items of type <code>{{typeName}}</code> as valid for this list. This could mean that the type has been removed as a valid item type, or that someone else has added it to their own local schema that is not yet deployed.",
  /** Error description to show how the item is being represented in the json format */
  "inputs.array.error.json-representation-description": "JSON representation of this item:",
  /** Error description for the array item tooltip that explains what the error means with more context */
  "inputs.array.error.type-is-incompatible-prompt": "Item of type <code>{{typeName}}</code> not valid for this list",
  /** Error title for when an item type within an array input is incompatible, used in the tooltip */
  "inputs.array.error.type-is-incompatible-title": "Why is this happening?",
  /** Error label for unexpected errors in the Array Input */
  "inputs.array.error.unexpected-error": "Unexpected Error: {{error}}",
  /** Label for the array insert menu all items filter  */
  "inputs.array.insert-menu.filter.all-items": "All",
  /** Label for when the array insert menu search shows no items */
  "inputs.array.insert-menu.search.no-results": "No items found",
  /** Placeholder for the array insert menu search field */
  "inputs.array.insert-menu.search.placeholder": "Search",
  /** Tooltip for the array insert menu grid view toggle */
  "inputs.array.insert-menu.toggle-grid-view.tooltip": "Toggle grid view",
  /** Tooltip for the array insert menu list view toggle */
  "inputs.array.insert-menu.toggle-list-view.tooltip": "Toggle list view",
  /** Label for when the array input doesn't have any items */
  "inputs.array.no-items-label": "No items",
  /** Label for read only array fields */
  "inputs.array.read-only-label": "This field is read-only",
  /** Label for when the array input is resolving the initial value for the item */
  "inputs.array.resolving-initial-value": "Resolving initial value\u2026",
  /** Tooltip content when boolean input is disabled */
  "inputs.boolean.disabled": "Disabled",
  /** Warning label when selected datetime is in the past */
  "inputs.dateTime.past-date-warning": "Select a date in the future.",
  /** Placeholder value for datetime input */
  "inputs.datetime.placeholder": "e.g. {{example}}",
  /** Acessibility label for button to open file options menu */
  "inputs.file.actions-menu.file-options.aria-label": "Open file options menu",
  /** Unknown member kind: `{{kind}}` */
  "inputs.file.error.unknown-member-kind": "Unknown member kind: {{kind}}",
  /** The value of this field is not a valid file. Resetting this field will let you choose a new file. */
  "inputs.file.invalid-file-warning.description": "The value of this field is not a valid file. Resetting this field will let you choose a new file.",
  /** Reset value */
  "inputs.file.invalid-file-warning.reset-button.text": "Reset value",
  /** Invalid file value */
  "inputs.file.invalid-file-warning.title": "Invalid file value",
  /** The upload could not be completed at this time. */
  "inputs.file.upload-failed.description": "The upload could not be completed at this time.",
  /** Upload failed */
  "inputs.file.upload-failed.title": "Upload failed",
  /** Private access policy badge label */
  "inputs.files.common.access-policy.private.label": "Private asset",
  /** Private access policy badge tooltip */
  "inputs.files.common.access-policy.private.tooltip": "CDN access limited to signed URLs",
  /** Clear field */
  "inputs.files.common.actions-menu.clear-field.label": "Clear field",
  /** Copy URL */
  "inputs.files.common.actions-menu.copy-url.label": "Copy URL",
  /** Download */
  "inputs.files.common.actions-menu.download.label": "Download",
  /** The URL is copied to the clipboard */
  "inputs.files.common.actions-menu.notification.url-copied": "The URL is copied to the clipboard",
  /** Open in source */
  "inputs.files.common.actions-menu.open-in-source.label": "Open in {{sourceName}}",
  /** Replace */
  "inputs.files.common.actions-menu.replace.label": "Replace",
  /** Upload */
  "inputs.files.common.actions-menu.upload.label": "Upload",
  /** Drop to upload */
  "inputs.files.common.drop-message.drop-to-upload": "Drop to upload",
  /** Drop to upload `{{count}}` file */
  "inputs.files.common.drop-message.drop-to-upload-multi_one": "Drop to upload {{count}} file",
  /** Drop to upload `{{count}}` files */
  "inputs.files.common.drop-message.drop-to-upload-multi_other": "Drop to upload {{count}} files",
  /** Can't upload this file here */
  "inputs.files.common.drop-message.drop-to-upload.no-accepted-file-message_one": "Can't upload this file here",
  /** Can't upload any of these files here */
  "inputs.files.common.drop-message.drop-to-upload.no-accepted-file-message_other": "Can't upload any of these files here",
  /** `{{count}}` file can't be uploaded here */
  "inputs.files.common.drop-message.drop-to-upload.rejected-file-message_one": "{{count}} file can't be uploaded here",
  /** `{{count}}` files can't be uploaded here */
  "inputs.files.common.drop-message.drop-to-upload.rejected-file-message_other": "{{count}} files can't be uploaded here",
  /** Cannot upload `{{count}}` files */
  "inputs.files.common.placeholder.cannot-upload-some-files_one": "Cannot upload file",
  "inputs.files.common.placeholder.cannot-upload-some-files_other": "Cannot upload {{count}} files",
  /** Drag or paste type here */
  "inputs.files.common.placeholder.drag-or-paste-to-upload_file": "Drag or paste file here",
  /** Drag or paste image here */
  "inputs.files.common.placeholder.drag-or-paste-to-upload_image": "Drag or paste image here",
  /** Drop to upload file */
  "inputs.files.common.placeholder.drop-to-upload_file": "Drop to upload file",
  /** Drop to upload image */
  "inputs.files.common.placeholder.drop-to-upload_image": "Drop to upload image",
  /** Read only */
  "inputs.files.common.placeholder.read-only": "Read only",
  /** Select asset source destination for files to upload */
  "inputs.files.common.placeholder.select-asset-source-upload-destination": "Upload files to:",
  /** Can't upload files here */
  "inputs.files.common.placeholder.upload-not-supported": "Can't upload files here",
  /** Clear upload */
  "inputs.files.common.stale-upload-warning.clear": "Clear upload",
  /** An upload has made no progress for at least `{{staleThresholdMinutes}}` minutes and likely got interrupted. You can safely clear the incomplete upload and try uploading again. */
  "inputs.files.common.stale-upload-warning.description": "An upload has made no progress for at least {{staleThresholdMinutes}} minutes and likely got interrupted. You can safely clear the incomplete upload and try uploading again.",
  /** Incomplete upload */
  "inputs.files.common.stale-upload-warning.title": "Incomplete upload",
  /** Select file */
  "inputs.files.select-dialog.title": 'Select file for "{{targetTitle}}"',
  /** Tooltip text for action to crop image */
  "inputs.image.actions-menu.crop-image-tooltip": "Crop image",
  /** Accessibility label for button to open image edit dialog */
  "inputs.image.actions-menu.edit-details.aria-label": "Open image edit dialog",
  /** Accessibility label for button to open image options menu */
  "inputs.image.actions-menu.options.aria-label": "Open image options menu",
  /** Cannot upload this file here */
  "inputs.image.drag-overlay.cannot-upload-here": "Cannot upload this file here",
  /** Drop image to upload */
  "inputs.image.drag-overlay.drop-to-upload-image": "Drop image to upload",
  /** This field is read only */
  "inputs.image.drag-overlay.this-field-is-read-only": "This field is read only",
  /** Image could not be loaded due to possible access restrictions */
  "inputs.image.error.possible-access-restriction": "Could not load image. This may be due to access restrictions.",
  /** Unknown member kind: `{{kind}}` */
  "inputs.image.error.unknown-member-kind": "Unknown member kind: {{kind}}",
  /** Edit hotspot and crop */
  "inputs.image.hotspot-dialog.title": "Edit hotspot and crop",
  /** The value of this field is not a valid image. Resetting this field will let you choose a new image. */
  "inputs.image.invalid-image-warning.description": "The value of this field is not a valid image. Resetting this field will let you choose a new image.",
  /** Reset value */
  "inputs.image.invalid-image-warning.reset-button.text": "Reset value",
  /** Invalid image value */
  "inputs.image.invalid-image-warning.title": "Invalid image value",
  /** Preview of uploaded image */
  "inputs.image.preview-uploaded-image": "Preview of uploaded image",
  /** Select image */
  "inputs.image.select-dialog.title": 'Select image for "{{targetTitle}}"',
  /** The upload could not be completed at this time. */
  "inputs.image.upload-error.description": "The upload could not be completed at this time.",
  /** Upload failed */
  "inputs.image.upload-error.title": "Upload failed",
  /** Adjust the rectangle to crop image. Adjust the circle to specify the area that should always be visible. */
  "inputs.imagetool.description": "Adjust the rectangle to crop image. Adjust the circle to specify the area that should always be visible.",
  /** Error: `{{errorMessage}}` */
  "inputs.imagetool.load-error": "Error: {{errorMessage}}",
  /** Hotspot & Crop */
  "inputs.imagetool.title": "Hotspot & Crop",
  /** Warnings displayed to developers when using the crop/hotspot tool on vector images, notifying them that crops/hotspot are not respected when serving the image in vector format. For the crop/hotspot to apply, images must be served in a raster format such as JPG or PNG, by appending eg `fm=jpg` to the image url, or calling `format('jpg')` if using `@sanity/image-url` */
  "inputs.imagetool.vector-warning.developer-info": "The Asset Pipeline does not support hotspot and crop for vector formats. To enable hotspot & crop, output this image to any of the supported raster formats. For example: <code>fm=jpg</code> to the <ImageUrlDocumentationLink>image URL</ImageUrlDocumentationLink> or call <code>.format('png')</code> with <ImageUrlPackageDocumentationLink>@sanity/image-url</ImageUrlPackageDocumentationLink>.",
  /** See developer info */
  "inputs.imagetool.vector-warning.expand-developer-info": "See developer info",
  /** Gotcha: Serving vector images with hotspot and crop from the Sanity Image API */
  "inputs.imagetool.vector-warning.title": "Warning: Hotspot and crop might not be applied to this image where it's presented.",
  /** Convert to `{{targetType}}` */
  "inputs.invalid-value.convert-button.text": "Convert to {{targetType}}",
  /** The current value (<code>`{{actualType}}`</code>) */
  "inputs.invalid-value.current-type": "The current value (<code>{{actualType}}</code>)",
  /** The property value is stored as a value type that does not match the expected type. */
  "inputs.invalid-value.description": "The property value is stored as a value type that does not match the expected type.",
  /** The value of this property must be of type <code>`{{validType}}`</code> according to the schema. */
  "inputs.invalid-value.details.description": "The value of this property must be of type <code>{{validType}}</code> according to the schema.",
  /** Only the following types are valid here according to schema: */
  "inputs.invalid-value.details.multi-type-description": "Only the following types are valid here according to schema:",
  /** Mismatching value types typically occur when the schema has recently been changed. */
  "inputs.invalid-value.details.possible-reason": "Mismatching value types typically occur when the schema has recently been changed.",
  /** Developer info */
  "inputs.invalid-value.details.title": "Developer info",
  /** -- Invalid Value Input -- */
  /** Reset value */
  "inputs.invalid-value.reset-button.text": "Reset value",
  /** Invalid property value */
  "inputs.invalid-value.title": "Invalid property value",
  /** Title for the "All fields" field group */
  "inputs.object.field-group-tabs.all-fields-title": "All fields",
  /** Aria label for the "Field groups" select control on smaller screens */
  "inputs.object.field-group-tabs.aria-label": "Field groups",
  /** Text shown in field group select for a group with error validation */
  "inputs.object.field-group-tabs.validation-error": "error",
  /** Text shown in field group select for a group with info validation */
  "inputs.object.field-group-tabs.validation-info": "info",
  /** Text shown in field group select for a group with warning validation */
  "inputs.object.field-group-tabs.validation-warning": "warning",
  /** Read-only field description */
  "inputs.object.unknown-fields.read-only.description": "This field is <strong>read only</strong> according to the document\u2019s schema and cannot be unset. If you want to be able to unset this in Studio, make sure you remove the <code>readOnly</code> field from the enclosing type in the schema.",
  /** Fallback description shown when the unknown reference preview cannot be loaded */
  "inputs.object.unknown-fields.reference.preview.unavailable": 'Unable to load preview for reference "{{documentId}}".',
  /** Remove field */
  "inputs.object.unknown-fields.remove-field-button.text": "Remove field",
  /** Encountered `{{count}}` fields that are not defined in the schema. */
  "inputs.object.unknown-fields.warning.description_one": "Encountered a field that is not defined in the schema.",
  "inputs.object.unknown-fields.warning.description_other": "Encountered {{count}} fields that are not defined in the schema.",
  /** Detailed description of unknown field warning */
  "inputs.object.unknown-fields.warning.details.description_one": "This field is not defined in the schema, which could mean that the field definition has been removed or that someone else has added it to their own local project and have not deployed their changes yet.",
  "inputs.object.unknown-fields.warning.details.description_other": "These fields are not defined in the document\u2019s schema, which could mean that the field definitions have been removed or that someone else has added them to their own local project and have not deployed their changes yet.",
  /** Developer info */
  "inputs.object.unknown-fields.warning.details.title": "Developer info",
  /** Unknown field found */
  "inputs.object.unknown-fields.warning.title_one": "Unknown field found",
  "inputs.object.unknown-fields.warning.title_other": "Unknown fields found",
  /** Collapse the editor to save screen space  */
  "inputs.portable-text.action.collapse-editor": "Collapse editor",
  /** Aria label for action to edit an existing annotation */
  "inputs.portable-text.action.edit-annotation-aria-label": "Edit annotation",
  /** Expand the editor to give more editing space */
  "inputs.portable-text.action.expand-editor": "Expand editor",
  /** Label label for action to insert a block of a given type (`{{typeName}}`) */
  "inputs.portable-text.action.insert-block": "Insert {{typeName}}",
  /** Accessibility label for action to insert a block of a given type (`{{typeName}}`) */
  "inputs.portable-text.action.insert-block-aria-label": "Insert {{typeName}} (block)",
  /** Label for action to insert an inline object of a given type (`{{typeName}}`) */
  "inputs.portable-text.action.insert-inline-object": "Insert {{typeName}}",
  /** Accessibility label for action to insert an inline object of a given type (`{{typeName}}`) */
  "inputs.portable-text.action.insert-inline-object-aria-label": "Insert {{typeName}} (inline)",
  /** Aria label for action to remove an annotation */
  "inputs.portable-text.action.remove-annotation-aria-label": "Remove annotation",
  /** Label for activate on focus with context of click and not focused */
  "inputs.portable-text.activate-on-focus-message_click": "Click to activate",
  /** Label for activate on focus with context of click and focused */
  "inputs.portable-text.activate-on-focus-message_click-focused": "Click or press space to activate",
  /** Label for activate on focus with context of tap and not focused */
  "inputs.portable-text.activate-on-focus-message_tap": "Tap to activate",
  /** Aria label for the annotation object */
  "inputs.portable-text.annotation-aria-label": "Annotation object",
  /** Title for dialog that allows editing an annotation */
  "inputs.portable-text.annotation-editor.title": "Edit {{schemaType}}",
  /** Title of the default "link" annotation */
  "inputs.portable-text.annotation.link": "Link",
  /** Aria label for the block object */
  "inputs.portable-text.block.aria-label": "Block object",
  /** Label for action to edit a block item, in the case where it is editable */
  "inputs.portable-text.block.edit": "Edit",
  /** Accessibility label for the button that opens the actions menu on blocks */
  "inputs.portable-text.block.open-menu-aria-label": "Open menu",
  /** Label for action to open a reference, in the case of block-level reference types */
  "inputs.portable-text.block.open-reference": "Open reference",
  /** Label for action to remove a block item */
  "inputs.portable-text.block.remove": "Remove",
  /** Label for action to view a block item, in the case where it is read-only and thus cannot be edited */
  "inputs.portable-text.block.view": "View",
  /** Title of the "code" decorator */
  "inputs.portable-text.decorator.code": "Code",
  /** Title of the "em" (emphasis) decorator */
  "inputs.portable-text.decorator.emphasis": "Italic",
  /** Title of the "strike-through" decorator */
  "inputs.portable-text.decorator.strike-through": "Strike",
  /** Title of the "strong" decorator */
  "inputs.portable-text.decorator.strong": "Strong",
  /** Title of the "underline" decorator */
  "inputs.portable-text.decorator.underline": "Underline",
  /** Placeholder text for when the editor is empty */
  "inputs.portable-text.empty-placeholder": "Empty",
  /** Aria label for the block object */
  "inputs.portable-text.inline-block.aria-label": "Inline object",
  /** Label for action to edit an inline object item */
  "inputs.portable-text.inline-object.edit": "Edit object",
  /** Aria label for icon for action to edit an inline object item */
  "inputs.portable-text.inline-object.edit-aria-label": "Edit object",
  /** Label for action to remove an inline object item */
  "inputs.portable-text.inline-object.remove": "Remove object",
  /** Aria label for icon for action to remove an inline object item */
  "inputs.portable-text.inline-object.remove-aria-label": "Remove object",
  /** Disclaimer text shown on invalid Portable Text value, when an action is available to unblock the user, but it is not guaranteed to be safe */
  "inputs.portable-text.invalid-value.action-disclaimer": "NOTE: It\u2019s generally safe to perform the action above, but if you are in doubt, get in touch with those responsible for configuring your studio.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` has a child with key `{{childKey}}` of type `{{childType}}` which is not allowed by the schema definition */
  "inputs.portable-text.invalid-value.disallowed-child-type.action": "Remove the object",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` has a child with key `{{childKey}}` of type `{{childType}}` which is not allowed by the schema definition */
  "inputs.portable-text.invalid-value.disallowed-child-type.description": "Child with key {{childKey}} of block with key <code>{{key}}</code> is of type <code>{{childType}}</code>, which is not allowed by the schema.",
  /** Action presented when the Portable Text field value is invalid, when child with key `{{key}}` has a type (`{{typeName}}`) that is not an allowed block type for this field */
  "inputs.portable-text.invalid-value.disallowed-type.action": "Remove the block",
  /** Text explaining that the Portable Text field value is invalid, when child with key `{{key}}` has a type (`{{typeName}}`) that is not an allowed block type for this field */
  "inputs.portable-text.invalid-value.disallowed-type.description": "Block with key <code>{{key}}</code> is of type <code>{{typeName}}</code>, which is not allowed by the schema.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` contains no children */
  "inputs.portable-text.invalid-value.empty-children.action": "Insert empty text span",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` contains no children */
  "inputs.portable-text.invalid-value.empty-children.description": "Text block with key <code>{{key}}</code> has no text spans.",
  /** Label for the button to ignore invalid values in the Portable Text editor */
  "inputs.portable-text.invalid-value.ignore-button.text": "Ignore",
  /** Action presented when the Portable Text field value is invalid, when child with key `{{key}}` has a `_type` property that is set to `block`, but the block type defined in schema has a different name (`{{expectedTypeName}}`) */
  "inputs.portable-text.invalid-value.incorrect-block-type.action": "Use type <code>{{expectedTypeName}}</code>",
  /** Text explaining that the Portable Text field value is invalid, when child with key `{{key}}` has a `_type` property that is set to `block`, but the block type defined in schema has a different name (`{{expectedTypeName}}`) */
  "inputs.portable-text.invalid-value.incorrect-block-type.description": "Block with key <code>{{key}}</code> has an invalid type name. According to the schema, it should be <code>{{expectedTypeName}}</code>.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` has a span with key `{{childKey}}` that has a missing or invalid `text` property */
  "inputs.portable-text.invalid-value.invalid-span-text.action": "Set empty text value",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` has a span with key `{{childKey}}` that has a missing or invalid `text` property */
  "inputs.portable-text.invalid-value.invalid-span-text.description": "Span with key {{childKey}} of block with key <code>{{key}}</code> has a missing or invalid <code>text</code> property.",
  /** Action presented when the Portable Text field value is invalid, when child with key `{{key}}` is missing a `_type` property, but seems to be a block of type `{{expectedTypeName}}` */
  "inputs.portable-text.invalid-value.missing-block-type.action": "Use type <code>{{expectedTypeName}}</code>",
  /** Text explaining that the Portable Text field value is invalid, when child with key `{{key}}` is missing a `_type` property, but seems to be a block of type `{{expectedTypeName}}` */
  "inputs.portable-text.invalid-value.missing-block-type.description": "Block with key <code>{{key}}</code> is missing a type name. According to the schema, it should be <code>{{expectedTypeName}}</code>.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` has a child at `{{index}}` which is missing `_key` property */
  "inputs.portable-text.invalid-value.missing-child-key.action": "Assign random key",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` has a child at `{{index}}` which is missing `_key` property */
  "inputs.portable-text.invalid-value.missing-child-key.description": "Child at index <code>{{index}}</code> of block with key <code>{{key}}</code> is missing <code>_key</code> property.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` has a child with key `{{childKey}}` which is missing a `_type` property */
  "inputs.portable-text.invalid-value.missing-child-type.action": "Remove the object",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` has a child with key `{{childKey}}` which is missing a `_type` property */
  "inputs.portable-text.invalid-value.missing-child-type.description": "Child with key {{childKey}} of block with key <code>{{key}}</code> is missing <code>_type</code> property.",
  /** Action presented when the Portable Text field value is invalid, when child at `{{index}}` is missing the required `_key` property */
  "inputs.portable-text.invalid-value.missing-key.action": "Assign random key",
  /** Text explaining that the Portable Text field value is invalid, when child at `{{index}}` is missing the required `_key` property */
  "inputs.portable-text.invalid-value.missing-key.description": "Block at index <code>{{index}}</code> is missing required <code>_key</code> property.",
  /** Action presented when the Portable Text field value is invalid, when child with key `{{key}}` has a missing or invalid `children` property */
  "inputs.portable-text.invalid-value.missing-or-invalid-children.action": "Remove the block",
  /** Text explaining that the Portable Text field value is invalid, when child with key `{{key}}` has a missing or invalid `children` property */
  "inputs.portable-text.invalid-value.missing-or-invalid-children.description": "Text block with key <code>{{key}}</code> has an invalid or missing `children` property.",
  /** Action presented when the Portable Text field value is invalid, when child with key `{{key}}` has a missing or invalid `markDefs` property */
  "inputs.portable-text.invalid-value.missing-or-invalid-markdefs.action": "Add property",
  /** Text explaining that the Portable Text field value is invalid, when child with key `{{key}}` has a missing or invalid `markDefs` property */
  "inputs.portable-text.invalid-value.missing-or-invalid-markdefs.description": "Text block with key <code>{{key}}</code> has an invalid or missing `markDefs` property.",
  /** Action presented when the Portable Text field value is invalid, when child with key `{{key}}` is missing a `_type` property  */
  "inputs.portable-text.invalid-value.missing-type.action": "Remove the block",
  /** Text explaining that the Portable Text field value is invalid, when child with key `{{key}}` is missing a `_type` property  */
  "inputs.portable-text.invalid-value.missing-type.description": "Block with key <code>{{key}}</code> is missing a type name.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` contains a non-object child at index `{{index}}` */
  "inputs.portable-text.invalid-value.non-object-child.action": "Remove the item",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` contains a non-object child at index `{{index}}` */
  "inputs.portable-text.invalid-value.non-object-child.description": "Child at index <code>{{index}}</code> of block with key <code>{{key}}</code> is not an object.",
  /** Action presented when the Portable Text field value is invalid, when the Portable Text field is not an array, or the array is empty */
  "inputs.portable-text.invalid-value.not-an-array.action": "Unset the value",
  /** Text explaining that the Portable Text field value is invalid, when the Portable Text field is not an array, or the array is empty */
  "inputs.portable-text.invalid-value.not-an-array.description": "Value must be an array of Portable Text blocks, or undefined.",
  /** Action presented when the Portable Text field value is invalid, when child at `{{index}}` is not an object */
  "inputs.portable-text.invalid-value.not-an-object.action": "Remove item",
  /** Text explaining that the Portable Text field value is invalid, when child at `{{index}}` is not an object */
  "inputs.portable-text.invalid-value.not-an-object.description": "Item at <code>{{index}}</code> is not an object,.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` contains marks (`{{orphanedMarks}}`) that are not supported by the current schema */
  "inputs.portable-text.invalid-value.orphaned-marks.action": "Remove disallowed marks",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` contains marks (`{{orphanedMarks}}`) that are not supported by the current schema */
  "inputs.portable-text.invalid-value.orphaned-marks.description": "Text block with key <code>{{key}}</code> contains marks <code>({{orphanedMarks, list}})</code> that are not allowed by the schema.",
  /** Title for the alert indicating that the Portable Text field has an invalid value */
  "inputs.portable-text.invalid-value.title": "Invalid Portable Text value",
  /** Title of "bulleted" list type */
  "inputs.portable-text.list-type.bullet": "Bulleted list",
  /** Title of numbered list type */
  "inputs.portable-text.list-type.number": "Numbered list",
  /** Title of the "h1" block style */
  "inputs.portable-text.style.h1": "Heading 1",
  /** Title of the "h2" block style */
  "inputs.portable-text.style.h2": "Heading 2",
  /** Title of the "h3" block style */
  "inputs.portable-text.style.h3": "Heading 3",
  /** Title of the "h4" block style */
  "inputs.portable-text.style.h4": "Heading 4",
  /** Title of the "h5" block style */
  "inputs.portable-text.style.h5": "Heading 5",
  /** Title of the "h6" block style */
  "inputs.portable-text.style.h6": "Heading 6",
  /** Title shown when multiple blocks of varying styles is selected */
  "inputs.portable-text.style.multiple": "Multiple",
  /** Title of fallback when no style is given for a block */
  "inputs.portable-text.style.none": "No style",
  /** Title of the "normal" block style */
  "inputs.portable-text.style.normal": "Normal",
  /** Title of the "quote" block style */
  "inputs.portable-text.style.quote": "Quote",
  /** Label for action to clear the current value of the reference field */
  "inputs.reference.action.clear": "Clear",
  /** Label for action to copy the current item (used within arrays) */
  "inputs.reference.action.copy": "Copy",
  /** Label for action to create a new document from the reference input */
  "inputs.reference.action.create-new-document": "Create",
  /** Label for action to create a new document from the reference input, when there are multiple templates or document types to choose from */
  "inputs.reference.action.create-new-document-select": "Create\u2026",
  /** Label for action to duplicate the current item to a new item (used within arrays) */
  "inputs.reference.action.duplicate": "Duplicate",
  /** Label for action that opens the referenced document in a new tab */
  "inputs.reference.action.open-in-new-tab": "Open in new tab",
  /** Label for action to remove the reference from an array */
  "inputs.reference.action.remove": "Remove",
  /** Label for action to replace the current value of the field */
  "inputs.reference.action.replace": "Replace",
  /** Label for action to cancel a previously initiated replace action  */
  "inputs.reference.action.replace-cancel": "Cancel replace",
  /** The cross-dataset reference field currently has a reference, but the feature has been disabled since it was created. This explains what can/cannot be done in its current state. */
  "inputs.reference.cross-dataset.feature-disabled-actions": "You can still clear this field's existing reference, but it cannot be changed to a different document as long as the feature is disabled.",
  /** A cross-dataset reference field exists but the feature has been disabled. A <DocumentationLink> component is available. */
  "inputs.reference.cross-dataset.feature-disabled-description": "This feature has been disabled. Read how to enable it in <DocumentationLink>the documentation</DocumentationLink>.",
  /** Title for a warning telling the user that the current project does not have the "cross dataset references" feature */
  "inputs.reference.cross-dataset.feature-unavailable-title": "Unavailable feature: Cross dataset reference",
  /** The cross-dataset reference points to a document with an invalid type  */
  "inputs.reference.cross-dataset.invalid-type": "The referenced document is of invalid type ({{typeName}}) <JsonValue/>",
  /** The referenced document will open in a new tab (due to external studio) */
  "inputs.reference.document-opens-in-new-tab": "This document opens in a new tab",
  /** Error title for when the document is unavailable (for any possible reason) */
  "inputs.reference.error.document-unavailable-title": "Document unavailable",
  /** Error title for when the referenced document failed to be loaded */
  "inputs.reference.error.failed-to-load-document-title": "Failed to load referenced document",
  /** Error title for when the reference search returned a document that is not an allowed type for the field */
  "inputs.reference.error.invalid-search-result-type-title": `Search returned a type that's not valid for this reference: "{{returnedType}}"`,
  /** Error description for when the document referenced is not one of the types declared as allowed target types in schema */
  "inputs.reference.error.invalid-type-description": "Referenced document (<code>{{documentId}}</code>) is of type <code>{{actualType}}</code>. According to the schema, referenced documents can only be of type <AllowedTypes/>.",
  /** Error title for when the document referenced is not one of the types declared as allowed target types in schema */
  "inputs.reference.error.invalid-type-title": "Document of invalid type",
  /** Error description for when the user does not have permissions to read the referenced document */
  "inputs.reference.error.missing-read-permissions-description": "The referenced document could not be accessed due to insufficient permissions",
  /** Error title for when the user does not have permissions to read the referenced document */
  "inputs.reference.error.missing-read-permissions-title": "Insufficient permissions",
  /** Error description for when the current reference value points to a document that does not exist (on weak references) */
  "inputs.reference.error.nonexistent-document-description": "The referenced document does not exist (ID: <code>{{documentId}}</code>). You can either remove the reference or replace it with another document.",
  /** Error title for when the current reference value points to a document that does not exist (on weak references) */
  "inputs.reference.error.nonexistent-document-title": "Not found",
  /** Label for button that clears the reference when it points to a document that does not exist (on weak references) */
  "inputs.reference.error.nonexistent-document.clear-button-label": "Clear",
  /** Error title for when the search for a reference failed. Note that the message sent by the backend may not be localized. */
  "inputs.reference.error.search-failed-title": "Reference search failed",
  /** Label for when the GDR points to an invalid type  */
  "inputs.reference.global.invalid-type": "The referenced document is of invalid type ({{typeName}})",
  /** Alternative text for the image shown in cross-dataset reference input */
  "inputs.reference.image-preview-alt-text": "Image preview of referenced document",
  /** Description for alert shown when a reference in a live-edit document is marked as being weak, the referenced document exists, AND the reference is supposed to be have been strengthened on publish */
  "inputs.reference.incomplete-reference.finalize-action-description": "<strong>{{referencedDocument}}</strong> is published and this reference should now be finalized.",
  /** Title for alert shown when a reference in a live-edit document is marked as being weak, the referenced document exists, AND the reference is supposed to be have been strengthened on publish */
  "inputs.reference.incomplete-reference.finalize-action-title": "Finalize reference",
  /** Description for alert shown when a reference in a live-edit document points to a document that exists and has been published, but the reference is still marked as weak */
  "inputs.reference.incomplete-reference.strengthen-action-description": "<strong>{{referencedDocument}}</strong> is published and this reference should now be converted to a strong reference.",
  /** Title for alert shown when a reference in a live-edit document points to a document that exists and has been published, but the reference is still marked as weak */
  "inputs.reference.incomplete-reference.strengthen-action-title": "Convert to strong reference",
  /** Label for button that triggers the action that strengthen a reference */
  "inputs.reference.incomplete-reference.strengthen-button-label": "Convert to strong reference",
  /** Label for button that triggers a retry attempt for reference metadata  */
  "inputs.reference.metadata-error.retry-button-label": "Retry",
  /** Title for alert shown when reference metadata fails to be loaded */
  "inputs.reference.metadata-error.title": "Unable to load reference metadata",
  /** Message shown when no documents were found that matched the given search string */
  "inputs.reference.no-results-for-query": "No results for <strong>\u201C{{searchTerm}}\u201D</strong>",
  /** Text for tooltip showing when a document was edited, using relative time (eg "how long ago was it edited?") */
  "inputs.reference.preview.edited-at-time": "Edited <RelativeTime/>",
  /** Accessibility label for icon indicating that document does _not_ have any unpublished changes */
  "inputs.reference.preview.has-no-unpublished-changes-aria-label": "No unpublished edits",
  /** Accessibility label for icon indicating that document has unpublished changes */
  "inputs.reference.preview.has-unpublished-changes-aria-label": "Edited",
  /** Accessibility label for icon indicating that document does _not_ have a published version */
  "inputs.reference.preview.is-not-published-aria-label": "Not published",
  /** Accessibility label for icon indicating that document has a published version */
  "inputs.reference.preview.is-published-aria-label": "Published",
  /** Text for tooltip indicating that a document has no unpublished edits */
  "inputs.reference.preview.no-unpublished-edits": "No unpublished edits",
  /** Text for tooltip indicating that a document has not yet been published */
  "inputs.reference.preview.not-published": "Not published",
  /** Text for tooltip showing when a document was published, using relative time (eg "how long ago was it published?") */
  "inputs.reference.preview.published-at-time": "Published <RelativeTime/>",
  /** The referenced document no longer exist and might have been deleted (for weak references) */
  "inputs.reference.referenced-document-does-not-exist": "The referenced document no longer exist and might have been deleted (document ID: <code>{{documentId}}</code>).",
  /** The referenced document could not be displayed to the user because of insufficient permissions */
  "inputs.reference.referenced-document-insufficient-permissions": "The referenced document could not be accessed due to insufficient permissions",
  /** Label for when the reference input is resolving the initial value for an item */
  "inputs.reference.resolving-initial-value": "Resolving initial value\u2026",
  /** Placeholder shown in a reference input with no current value */
  "inputs.reference.search-placeholder": "Type to search",
  /** Explanation of the consequences of leaving the reference as strong instead of weak */
  "inputs.reference.strength-mismatch.is-strong-consquences": "It will not be possible to delete the reference document without first removing this reference or converting it to weak.",
  /** Description for alert shown when a reference is supposed to be weak, but the actual value is strong */
  "inputs.reference.strength-mismatch.is-strong-description": "This reference is <em>strong</em>, but according to the current schema it should be <em>weak</em>.",
  /** Explanation of the consequences of leaving the reference as weak instead of strong */
  "inputs.reference.strength-mismatch.is-weak-consquences": "This makes it possible to delete the referenced document without first deleting this reference, leaving this field referencing a nonexisting document.",
  /** Description for alert shown when a reference is supposed to be strong, but the actual value is weak */
  "inputs.reference.strength-mismatch.is-weak-description": "This reference is <em>weak</em>, but according to the current schema it should be <em>strong</em>.",
  /** Label for button that triggers the action that strengthens a reference on strength mismatch */
  "inputs.reference.strength-mismatch.strengthen-button-label": "Convert to strong reference",
  /** Title for alert shown when a reference is supposed to be weak/strong, but the actual value is the opposite of what it is supposed to be */
  "inputs.reference.strength-mismatch.title": "Reference strength mismatch",
  /** Label for button that triggers the action that weakens a reference on strength mismatch */
  "inputs.reference.strength-mismatch.weaken-button-label": "Convert to weak reference",
  /** Label for action to clear the current value of the select field */
  "inputs.select.action.clear": "Clear",
  /** Action message for generating the slug */
  "inputs.slug.action.generate": "Generate",
  /** Loading message for when the input is actively generating a slug */
  "inputs.slug.action.generating": "Generating\u2026",
  /** Error message for when the source to generate a slug from is missing */
  "inputs.slug.error.missing-source": "Source is missing. Check source on type {{schemaType}} in schema",
  /** Placeholder for an empty tag input */
  "inputs.tags.placeholder": "Enter tag and press ENTER\u2026",
  /** Placeholder for an empty tag input on touch devices */
  "inputs.tags.placeholder_touch": "Enter tag\u2026",
  /** Convert to `{{targetType}}` */
  "inputs.untyped-value.convert-button.text": "Convert to {{targetType}}",
  /** Encountered an object value without a <code>_type</code> property. */
  "inputs.untyped-value.description": "Encountered an object value without a <code>_type</code> property.",
  /** Either remove the <code>name</code> property of the object declaration, or set <code>_type</code> property on items. */
  "inputs.untyped-value.details.description": "Either remove the <code>name</code> property of the object declaration, or set <code>_type</code> property on items.",
  /** Current value (<code>object</code>): */
  "inputs.untyped-value.details.json-dump-prefix": "Current value (<code>object</code>):",
  /** The following types are valid here according to schema: */
  "inputs.untyped-value.details.multi-type-description": "The following types are valid here according to schema:",
  /** Developer info */
  "inputs.untyped-value.details.title": "Developer info",
  /** Property value missing <code>_type</code> */
  "inputs.untyped-value.title": "Property value missing <code>_type</code>",
  /** Unset value */
  "inputs.untyped-value.unset-item-button.text": "Unset value",
  /** Select video */
  "inputs.video.select-dialog.title": 'Select video for "{{targetTitle}}"',
  /** The fallback explanation if no context is provided */
  "insufficient-permissions-message.not-authorized-explanation": "You do not have permission to access this feature.",
  /** The explanation when unable to create any document at all */
  "insufficient-permissions-message.not-authorized-explanation_create-any-document": "You do not have permission to create a document.",
  /** The explanation when unable to create a particular document */
  "insufficient-permissions-message.not-authorized-explanation_create-document": "You do not have permission to create this document.",
  /** The explanation when unable to create a particular type of document */
  "insufficient-permissions-message.not-authorized-explanation_create-document-type": "You do not have permission to create this kind of document.",
  /** The explanation when unable to create a new reference in a document */
  "insufficient-permissions-message.not-authorized-explanation_create-new-reference": "You do not have permission to create a new reference.",
  /** The explanation when unable to delete a particular document */
  "insufficient-permissions-message.not-authorized-explanation_delete-document": "You do not have permission to delete this document.",
  /** The explanation when unable to delete a schedule on scheduled publishing */
  "insufficient-permissions-message.not-authorized-explanation_delete-schedules": "You do not have permission to delete schedules.",
  /** The explanation when unable to discard changes in a particular document */
  "insufficient-permissions-message.not-authorized-explanation_discard-changes": "You do not have permission to discard changes in this document.",
  /** The explanation when unable to duplicate a particular document */
  "insufficient-permissions-message.not-authorized-explanation_duplicate-document": "You do not have permission to duplicate this document.",
  /** The explanation when unable to edit a schedule on scheduled publishing */
  "insufficient-permissions-message.not-authorized-explanation_edit-schedules": "You do not have permission to edit schedules.",
  /** The explanation when unable to execute a schedule on scheduled publishing */
  "insufficient-permissions-message.not-authorized-explanation_execute-schedules": "You do not have permission to execute schedules.",
  /** The explanation when unable to publish a particular document */
  "insufficient-permissions-message.not-authorized-explanation_publish-document": "You do not have permission to publish this document.",
  /** The explanation when unable to unpublish a particular document */
  "insufficient-permissions-message.not-authorized-explanation_unpublish-document": "You do not have permission to unpublish this document.",
  /** Appears after the not-authorized message. Lists the current roles. */
  "insufficient-permissions-message.roles": "Your roles: <Roles/>",
  /** The title for the insufficient permissions message component */
  "insufficient-permissions-message.title": "Insufficient permissions",
  /** Unexpected error: `{{error}}` */
  "member-field-error.unexpected-error": "Unexpected error: {{error}}",
  /** Text shown in warning when browser is using HTTP1 to communicate with the Sanity API */
  "network-check.slow-protocol-warning.description": "Your browser is using an outdated HTTP protocol to communicate with Sanity. This may result in substantially degraded performance.",
  /** Text for link that takes the user to the Sanity documentation to learn more about the HTTP1 issue */
  "network-check.slow-protocol-warning.learn-more-button.text": "Learn more",
  /** Text for link that takes the user to the Sanity documentation to learn more about the HTTP1 issue */
  "network-check.slow-protocol-warning.snooze-button.text": "Don't show again for this session",
  /** Title text for the warning dialog when browser is using HTTP1 to communicate with the Sanity API */
  "network-check.slow-protocol-warning.title": "You've got your breaks on",
  /** Button label for "Create new document" button */
  "new-document.button": "Create",
  /**
   * Tooltip message displayed when hovering/activating the "Create new document" action,
   * when there are templates/types available for creation
   */
  "new-document.create-new-document-label": "New document\u2026",
  /** Placeholder for the "filter" input within the new document menu */
  "new-document.filter-placeholder": "Search document types",
  /** Loading indicator text within the new document menu */
  "new-document.loading": "Loading\u2026",
  /** Accessibility label for the list displaying options in the new document menu */
  "new-document.new-document-aria-label": "New document",
  /** Message for when there are no document type options in the new document menu */
  "new-document.no-document-types-found": "No document types found",
  /**
   * Tooltip message displayed when hovering/activating the "Create new document" action,
   * when there are no templates/types to create from
   */
  "new-document.no-document-types-label": "No document types",
  /** Message for when no results are found for a specific search query in the new document menu */
  "new-document.no-results": "No results for <strong>{{searchQuery}}</strong>",
  /** Aria label for the button that opens the "Create new document" popover/dialog */
  "new-document.open-dialog-aria-label": "Create new document",
  /** Title for "Create new document" dialog */
  "new-document.title": "Create new document",
  /** @deprecated Label for button that will make the browser reload when users' studio version is out-of-date */
  "package-version.new-package-available.reload-button": "Push to reload",
  /** @deprecated Title of the alert for studio users when packages in their studio are out-of-date */
  "package-version.new-package-available.title": "Sanity Studio is ready to update!",
  /** Label for action to invite members to the current studio project */
  "presence.action.manage-members": "Invite members",
  /** Accessibility label for presence menu button */
  "presence.aria-label": "Global presence",
  /** Message description for when no one else is currently present */
  "presence.no-one-else-description": "Invite people to the project to see their online status.",
  /** Message title for when no one else is currently present */
  "presence.no-one-else-title": "No one else is here",
  /** Message for when a user is not in a document (displayed in the global presence menu) */
  "presence.not-in-a-document": "Not in a document",
  /** Tooltip content text for presence menu button */
  "presence.tooltip-content": "Who is here",
  /** Fallback title shown when a preview does not provide a title */
  "preview.default.title-fallback": "Untitled",
  /** Fallback preview value for types that have "no value" (eg null, undefined) */
  "preview.fallback.no-value": "(no value)",
  /** Alternative text for image being shown while image is being uploaded, in previews */
  "preview.image.file-is-being-uploaded.alt-text": "The image currently being uploaded",
  /* Relative time, just now */
  "relative-time.just-now": "just now",
  /** Action message to add document to new release */
  "release.action.add-to-new-release": "Add to release",
  /** Action message to add document to release */
  "release.action.add-to-release": "Add to {{title}}",
  /** Tooltip message for document that is already added to release */
  "release.action.already-exists-in-release": "Document already exists in release",
  /** Action message for when document is already in release  */
  "release.action.already-in-release": "Already in release {{title}}",
  /** Action message for when you click to view all versions you can copy the current document to */
  "release.action.copy-to": "Copy version to",
  /** Action message for creating new releases */
  "release.action.create-new": "New release",
  /** Description for toast when version creation failed */
  "release.action.create-version.failure": "Failed to create version",
  /** Action message for deleting a scheduled publish */
  "release.action.delete-schedule": "Delete schedule",
  /** Action message for when document is already in release  */
  "release.action.discard-version": "Discard version",
  /** Description for toast when version discarding failed */
  "release.action.discard-version.failure": "Failed to discard version",
  /** Action message for editing the schedule of a scheduled publish */
  "release.action.edit-schedule": "Edit schedule",
  /** Action message for when a new release is created off an existing version, draft or published document */
  "release.action.new-release": "New release",
  /** Explanation provided when releases can't be created because the workspace release limit has been reached */
  "release.action.new-release.limit-reached": "This workspace is limited to {{count}} release",
  "release.action.new-release.limit-reached_other": "This workspace is limited to {{count}} releases",
  /** Tooltip message for not having permissions for creating new releases */
  "release.action.permission.error": "You do not have permission to perform this action",
  /** Action message for running a scheduled draft immediately */
  "release.action.publish-now": "Publish now",
  /** Error message description for when a version is reverted from being unpublished */
  "release.action.revert-unpublish-version.failure.description": "Please try again or check your connection. The document is still going to be unpublished upon release.",
  /** Error message title for when a version is reverted from being unpublished */
  "release.action.revert-unpublish-version.failure.title": "Failed to revert from setting to unpublish on release.",
  /** Action message description for when a version is reverted from being unpublished */
  "release.action.revert-unpublish-version.success.description": "You can now edit this version.",
  /** Action message title for when a version is reverted from being unpublished */
  "release.action.revert-unpublish-version.success.title": "Successfully reverted from setting to unpublish on release.",
  /** Action message for scheduling a paused draft */
  "release.action.schedule-publish": "Schedule publish",
  /** Error message for when a version is set to be unpublished */
  "release.action.unpublish-version.failure": "Failed to set version to be unpublished on release",
  /** Action message for when a version is set to be unpublished successfully */
  "release.action.unpublish-version.success": "Successfully set <strong>{{title}}</strong> to be unpublished on release",
  /** Action message for when the view release is pressed */
  "release.action.view-release": "View release",
  /** Action message for when the view scheduled drafts is pressed */
  "release.action.view-scheduled-drafts": "View scheduled drafts",
  /** Label for banner when release is scheduled */
  "release.banner.scheduled-for-publishing-on": "Scheduled to be published on {{date}}",
  "release.chip.button.other-versions_one": "+{{count}} version",
  "release.chip.button.other-versions_other": "+{{count}} versions",
  /** Label for Draft chip in document header */
  "release.chip.draft": "Draft",
  /** Label for Draft chip in global header */
  "release.chip.global.drafts": "Drafts",
  /** Label for Published chip in document header */
  "release.chip.published": "Published",
  /** Label for tooltip in chip when document is in an archived release */
  "release.chip.tooltip.archived": "This release is archived and cannot be edited.",
  /** Label for tooltip in chip with the created date */
  "release.chip.tooltip.created-date": "Created {{date}}",
  /** Label for tooltip in draft chip when it's a live edit document */
  "release.chip.tooltip.draft-disabled.live-edit": "This document is in live edit mode, drafts are disabled",
  /** Label for tooltip in chip with the lasted edited date */
  "release.chip.tooltip.edited-date": "Edited {{date}}",
  /** Label for tooltip in chip when document is intended for a future release that hasn't been scheduled */
  "release.chip.tooltip.intended-for-date": "Intended for {{date}}",
  /** Label for tooltip in chip when there is no recent draft edits */
  "release.chip.tooltip.no-edits": "No edits",
  /** Label for tooltip in chip when document isn't published */
  "release.chip.tooltip.not-published": "Not published",
  "release.chip.tooltip.other-versions_one": "One additional version outside of releases",
  "release.chip.tooltip.other-versions_other": "{{count}} additional versions outside of releases",
  /** Label for tooltip in chip with the published date */
  "release.chip.tooltip.published-date": "Published {{date}}",
  /** Label for tooltip in chip when document is in a release that has been scheduled */
  "release.chip.tooltip.scheduled-for-date": "Scheduled for {{date}}",
  /** Label for tooltip in scheduled chip without a known date */
  "release.chip.tooltip.unknown-date": "Unknown date",
  /** Label for tooltip on deleted release */
  "release.deleted-tooltip": "This release has been deleted",
  /** Title for copying version to a new release dialog */
  "release.dialog.copy-to-release.title": "Copy version to new release",
  /** Title for action create a release */
  "release.dialog.create.confirm": "Create release",
  /** Title for creating releases dialog */
  "release.dialog.create.title": "New release",
  /** Body text when deleting scheduled draft and draft is already up to date */
  "release.dialog.delete-schedule-draft.body-already-current": "Delete this scheduled draft? Your draft is already up to date.",
  /** Body text when deleting scheduled draft and changes will be saved to draft */
  "release.dialog.delete-schedule-draft.body-will-save-to-draft": "Delete this scheduled draft? Your changes will be saved to draft.",
  /** Body text when deleting scheduled draft with checkbox shown for user choice */
  "release.dialog.delete-schedule-draft.body-with-choice": "Delete this scheduled draft?",
  /** Confirm button text for deleting a scheduled draft */
  "release.dialog.delete-schedule-draft.confirm": "Yes, delete schedule",
  /** Checkbox label for copying scheduled draft to draft before deletion */
  "release.dialog.delete-schedule-draft.copy-checkbox": "Keep my scheduled changes by copying them to draft (recommended)",
  /** Explanation text shown when scheduled draft has different changes than current draft */
  "release.dialog.delete-schedule-draft.different-changes-explanation": "Your scheduled draft has different changes than your current draft.",
  /** Header for the dialog confirming deletion of a scheduled draft */
  "release.dialog.delete-schedule-draft.header": "Delete scheduled draft",
  /** Body text for change schedule dialog */
  "release.dialog.edit-schedule.body": "Select a new date and time for the scheduled publish.",
  /** Confirm button text for change schedule dialog */
  "release.dialog.edit-schedule.confirm": "Update schedule",
  /** Header for change schedule dialog */
  "release.dialog.edit-schedule.header": "Change schedule",
  /** Body text for the dialog confirming running a scheduled draft immediately */
  "release.dialog.publish-scheduled-draft.body": "Are you sure you want to publish this scheduled draft immediately?",
  /** Confirm button text for running a scheduled draft immediately */
  "release.dialog.publish-scheduled-draft.confirm": "Yes, run now",
  /** Header for the dialog confirming running a scheduled draft immediately */
  "release.dialog.publish-scheduled-draft.header": "Publish draft now",
  /** Label for description in tooltip to explain release types */
  "release.dialog.tooltip.description": "This is only for planning, previews and hints about whether documents conflict. Setting a time here will not schedule your release. You'll still need to run or schedule the release once all documents are ready.",
  /** Label for noting that a release time is not final */
  "release.dialog.tooltip.note": "You can always change it later.",
  /** Title for tooltip to explain release time */
  "release.dialog.tooltip.title": "Approximate time of release",
  /** The placeholder text when the release doesn't have a description */
  "release.form.placeholder-describe-release": "Describe the release\u2026",
  /** Tooltip for button to hide release visibility */
  "release.layer.hide": "Hide release",
  /** Label for the release menu */
  "release.menu.label": "Release menu",
  /** Menu item label for scheduled drafts */
  "release.menu.scheduled-drafts": "View Scheduled Drafts",
  /** Tooltip for the release menu */
  "release.menu.tooltip": "Actions",
  /** Menu item label for viewing content releases */
  "release.menu.view-releases": "View Content Releases",
  /** Label for draft perspective in navbar */
  "release.navbar.drafts": "Drafts",
  /** Label for published releases in navbar */
  "release.navbar.published": "Published",
  /** Tooltip for releases navigation in navbar */
  "release.navbar.tooltip": "View scheduling",
  /** The placeholder text when the release doesn't have a title */
  "release.placeholder-untitled-release": "Untitled release",
  /** Description for warning that the published schedule time is in the past */
  "release.schedule-dialog.publish-date-in-past-warning": "Schedule for a future time and date.",
  /** Label for date picker when scheduling a release */
  "release.schedule-dialog.select-publish-date-label": "Publish on",
  /** The toast description that will be shown when the user has a release perspective which is now archived
   * @deprecated – no longer needed
   * */
  "release.toast.archived-release.description": "This release has been unpinned",
  /** The toast title that will be shown when the user has a release perspective which is now archived
   * @deprecated – no longer needed
   * */
  "release.toast.archived-release.title": "The '{{title}}' release was archived",
  /** The toast title that will be shown the creating a release fails */
  "release.toast.create-release-error.title": "Failed to create release",
  /** Error toast for deleting a scheduled draft */
  "release.toast.delete-schedule-draft.error": "Failed to delete the scheduled draft document <strong>{{title}}</strong>: {{error}}",
  /** Success toast for deleting a scheduled draft */
  "release.toast.delete-schedule-draft.success": "The scheduled draft document <strong>{{title}}</strong> has been deleted.",
  /** The toast title that will be shown when the user has a release perspective which is now deleted
   * @deprecated – no longer needed
   * */
  "release.toast.not-found-release.title": "The '{{title}}' release could not be found",
  /** Error toast for pausing a scheduled draft */
  "release.toast.pause-scheduled-draft.error": "Failed to pause the scheduled draft document <strong>{{title}}</strong>: {{error}}",
  /** Error toast for running a scheduled publish immediately */
  "release.toast.publish-scheduled-draft.error": "Failed to publish the scheduled draft document <strong>{{title}}</strong>: {{error}}",
  /** Success toast for running a scheduled publish immediately */
  "release.toast.publish-scheduled-draft.success": "The scheduled draft document <strong>{{title}}</strong> has been published.",
  /** The toast description that will be shown when the user has a release perspective which is now published
   * @deprecated – no longer needed
   **/
  "release.toast.published-release.description": "This release has been unpinned",
  /** The toast title that will be shown when the user has a release perspective which is now deleted
   * @deprecated – no longer needed
   **/
  "release.toast.published-release.title": "The '{{title}}' release was published",
  /** Error toast for rescheduling a draft */
  "release.toast.reschedule-scheduled-draft.error": "Failed to reschedule the scheduled draft document <strong>{{title}}</strong>: {{error}}",
  /** Success toast for rescheduling a draft */
  "release.toast.reschedule-scheduled-draft.success": "The scheduled draft document <strong>{{title}}</strong> has been rescheduled.",
  /** Error toast for scheduling a paused draft */
  "release.toast.schedule-publish.error": "Failed to schedule draft: {{error}}",
  /** Success toast for scheduling a paused draft */
  "release.toast.schedule-publish.success": "Scheduled draft successfully",
  /** The toast title that will be shown when the user has a scheduled draft perspective which is now published
   * @deprecated – no longer needed
   * */
  "release.toast.scheduled-draft-published.title": "The scheduled draft was published",
  /** Label for when a version of a document has already been added to the release */
  "release.tooltip.already-added": "A version of this document has already been added",
  /** Label for when a release is scheduled / scheduling and a user can't add a document version to it */
  "release.tooltip.locked": "This release has been scheduled. Unschedule it to add more documents.",
  /** Label for the release type 'as soon as possible' */
  "release.type.asap": "As soon as possible",
  /** Label for the release type 'at time', meaning it's a release with a scheduled date */
  "release.type.scheduled": "At time",
  /** Label for the release type 'undecided' */
  "release.type.undecided": "Undecided",
  /** Tooltip for the dropdown to show all versions of document */
  "release.version-list.tooltip": "See all document versions",
  /** Button text for contacting support in the releases misconfiguration dialog */
  "releases.upsell.misconfiguration.contact-support": "Contact Support",
  /** Header for the releases misconfiguration dialog */
  "releases.upsell.misconfiguration.header": "Content releases configuration issue",
  /** Message shown in the releases misconfiguration dialog */
  "releases.upsell.misconfiguration.message": "Content releases are enabled for your project, but there appears to be a configuration issue with your release limits. Please contact support to have your content releases properly configured.",
  /** Confirm button text for the schedule publish dialog */
  "schedule-publish-dialog.confirm": "Schedule",
  /** Description for the schedule publish dialog */
  "schedule-publish-dialog.description": "Select when this document should be published.",
  /** Header for the schedule publish dialog */
  "schedule-publish-dialog.header": "Schedule draft for publishing",
  /** Title for a scheduled draft release */
  "scheduled-drafts.release.title": "Scheduled publish",
  /** Accessibility label to open search action when the search would go fullscreen (eg on narrower screens) */
  "search.action-open-aria-label": "Open search",
  /** Action label for adding a search filter */
  "search.action.add-filter": "Add filter",
  /** Action label for clearing search filters */
  "search.action.clear-filters": "Clear filters",
  /** Label for action to clear recent searches */
  "search.action.clear-recent-searches": "Clear recent searches",
  /** Accessibility label for action to clear all currently applied document type filters */
  "search.action.clear-type-filters-aria-label": "Clear checked filters",
  /** Label for action to clear all currently applied document type filters */
  "search.action.clear-type-filters-label": "Clear",
  /** Accessibility label for when the search is full screen (on narrow screens) and you want to close the search */
  "search.action.close-search-aria-label": "Close search",
  /** Accessibility label for filtering by document type */
  "search.action.filter-by-document-type-aria-label": "Filter by document type",
  /** Accessibility action label for removing an already applied search filter */
  "search.action.remove-filter-aria-label": "Remove filter",
  /**
   * Text displayed when either no document type(s) have been selected, or we need a fallback,
   * eg "Search for all types".
   */
  "search.action.search-all-types": "Search all documents",
  /**
   * Text displayed when we are able to determine one or more document types that will be used for
   * searching, and can fit within the space assigned by the design.
   */
  "search.action.search-specific-types": "Search for {{types, list}}",
  /**
   * Text displayed when we are able to determine one or more document types that will be used for
   * searching, but cannot list them all within the space assigned by the design, so we need an
   * additional "and X more" suffix. Allows using pluralization suffixes, eg `_one`, `_other` etc.
   */
  "search.action.search-specific-types-truncated": "Search for {{types, list}} +{{count}} more",
  /** Dialog title for action to select an asset of unknown type */
  "search.action.select-asset": "Select asset",
  /** Dialog title for action to select a file asset */
  "search.action.select-asset_file": "Select file",
  /** Dialog title for action to select an image asset */
  "search.action.select-asset_image": "Select image",
  /** Accessibility label for when the search is full screen (on narrow screens) and you want to hide filters */
  "search.action.toggle-filters-aria-label_hide": "Hide filters",
  /** Accessibility label for when the search is full screen (on narrow screens) and you want to show filters */
  "search.action.toggle-filters-aria-label_show": "Show filters",
  /** Label for when the search is full screen (on narrow screens) and you want to hide filters */
  "search.action.toggle-filters-label_hide": "Hide filters",
  /** Label for when the search is full screen (on narrow screens) and you want to show filters */
  "search.action.toggle-filters-label_show": "Show filters",
  /** Tooltip text for the global search button */
  "search.button.tooltip": "Search",
  /**
   * A list of provided types (use `list` formatter preferably).
   */
  "search.document-type-list": "{{types, list}}",
  /**
   * In the context of a list of document types - no filtering selection has been done,
   * thus the default is "all types".
   */
  "search.document-type-list-all-types": "All types",
  /**
   * A list of provided types that has been truncated - more types are included but not displayed,
   * thus we need to indicate that there are more. Allows using pluralization suffixes,
   * eg `_one`, `_other` etc.
   */
  "search.document-type-list-truncated": "{{types, list}} +{{count}} more",
  /** Accessibility label for list displaying the available document types */
  "search.document-types-aria-label": "Document types",
  /** Label for when no document types matching the filter are found */
  "search.document-types-no-matches-found": "No matches for {{filter}}",
  /** Description for error when a filter cannot be displayed, describes that you should check the schema */
  "search.error.display-filter-description": "This may indicate invalid options defined in your schema.",
  /** Title for error when a filter cannot be displayed (mainly a developer-oriented error) */
  "search.error.display-filter-title": "An error occurred whilst displaying this filter.",
  /** Description for error when no valid asset source is found, describes that you should check the the current studio config */
  "search.error.no-valid-asset-source-check-config-description": "Please ensure it's enabled in your studio configuration file.",
  /** Description for error when no valid asset source is found, describes that only the default asset is supported */
  "search.error.no-valid-asset-source-only-default-description": "Currently, only the default asset source is supported.",
  /** Title for error when no valid asset sources found */
  "search.error.no-valid-asset-source-title": "No valid asset sources found.",
  /** Helpful description for when search returned an error that we are not able to describe in detail */
  "search.error.unspecified-error-help-description": "Please try again or check your connection",
  /** Title label for when search returned an error that we are not able to describe in detail */
  "search.error.unspecified-error-title": "Something went wrong while searching",
  /**
   * Label for "All fields", a label that appears above the list of available fields when filtering.
   * If one or more document type has been chosen as filter, this label is replaced with a group of
   * fields per selected document type
   */
  "search.filter-all-fields-header": "All fields",
  /** Label for the action of changing from one file to a different file in asset search filter */
  "search.filter-asset-change_file": "Change file",
  /** Label for the action of changing from one image to a different image in asset search filter */
  "search.filter-asset-change_image": "Change image",
  /** Label for the action of clearing the currently selected asset in an image/file filter */
  "search.filter-asset-clear": "Clear",
  /** Label for the action of selecting a file in asset search filter */
  "search.filter-asset-select_file": "Select file",
  /** Label for the action of selecting an image in asset search filter */
  "search.filter-asset-select_image": "Select image",
  /** Label for boolean filter - false */
  "search.filter-boolean-false": "False",
  /** Label for boolean filter - true */
  "search.filter-boolean-true": "True",
  /** Accessibility label for list that lets you filter fields by title, when adding a new filter in search */
  "search.filter-by-title-aria-label": "Filter by title",
  /** Accessibility label for date filter input */
  "search.filter-date-aria-label": "Date",
  /** Accessibility label for selecting end date on the date range search filter */
  "search.filter-date-range-end-date-aria-label": "End date",
  /** Accessibility label for selecting start date on the date range search filter */
  "search.filter-date-range-start-date-aria-label": "Start date",
  /** Accessibility label for selecting the unit (day/month/year) when adding "X days ago" search filter */
  "search.filter-date-unit-aria-label": "Select unit",
  /**
   * Label for "Days"/"Months"/"Years" when selecting it as unit in "X days ago" search filter.
   * Capitalized, as it would be listed in a dropdown.
   */
  "search.filter-date-unit_days": "Days",
  "search.filter-date-unit_months": "Months",
  "search.filter-date-unit_years": "Years",
  /** Accessibility label for the input value (days/months/years) when adding "X days ago" search filter */
  "search.filter-date-value-aria-label": "Unit value",
  /** Label for "field description" shown in tooltip when navigating list of possible fields to filter */
  "search.filter-field-tooltip-description": "Field description",
  /** Label for "field name" shown in tooltip when navigating list of possible fields to filter */
  "search.filter-field-tooltip-name": "Field name",
  /** Label for "Used in document types", a list of the document types a field appears in. Shown in tooltip when navigating list of possible fields to filter */
  "search.filter-field-tooltip-used-in-document-types": "Used in document types",
  /** Label for when no fields/filters are found for the given term */
  "search.filter-no-matches-found": "No matches for {{filter}}",
  /** Placeholder value for maximum numeric value filter */
  "search.filter-number-max-value-placeholder": "Max value",
  /** Placeholder value for minimum numeric value filter */
  "search.filter-number-min-value-placeholder": "Min value",
  /** Placeholder value for the number filter */
  "search.filter-number-value-placeholder": "Value",
  /** Placeholder for the "Filter" input, when narrowing possible fields/filters */
  "search.filter-placeholder": "Filter",
  /** Label for the action of clearing the currently selected document in a reference filter */
  "search.filter-reference-clear": "Clear",
  /**
   * Label for "shared fields", a label that appears above a list of fields that all filtered types
   * have in common, when adding a new filter. For instance, if "book" and "employee" both have a
   * "title" field, this field would be listed under "shared fields".
   * */
  "search.filter-shared-fields-header": "Shared fields",
  /** Placeholder value for the string filter */
  "search.filter-string-value-placeholder": "Value",
  /** Label/placeholder prompting user to select one of the predefined, allowed values for a string field */
  "search.filter-string-value-select-predefined-value": "Select\u2026",
  /** Accessibility label for the "Filters" list, that is shown when using "Add filter" in search (singular) */
  "search.filters-aria-label_one": "Filter",
  /** Accessibility label for the "Filters" list, that is shown when using "Add filter" in search (plural) */
  "search.filters-aria-label_other": "Filters",
  /** Label for instructions on how to use the search - displayed when no recent searches are available */
  "search.instructions": "Use <ControlsIcon/> to refine your search",
  /** Helpful description for when no search results are found */
  "search.no-results-help-description": "Try another keyword or adjust your filters",
  /** Title label for when no search results are found */
  "search.no-results-title": "No results found",
  /**
   * Individual search operators.
   *
   * The `name` variant is the form we use when the user is building a query, and selecting from a
   * list of available operators for a field. Keep in mind that since the user knows what the field
   * represents, we do not need to contextualize too much, and that the user may not be a developer
   * eg prefer "quantity is" over "array has length". Additionally, (if applicable in language) use
   * lowercased names.
   *
   * The `description` variant is the form shown once the filter has enough information to apply,
   * and is shown in the list of applied filters. It is passed components that _should_ be used to
   * compose the filter string, and to format them correctly:
   *
   * `<Field/>` - eg "Bird species", "Category", "Date of birth"
   * `<Operator>operator text</Operator>` - eg "has ≤", "includes", "is"
   * `<Value>{{value}}</Value>` - eg "Hawk", "Sparrow", "Eagle"
   *
   * Where applicable, a `count` is passed, allowing you to pluralize where needed, by using
   * suffixes such as `_zero`, `_one`, `_other` etc.
   *
   * Prefer (reasonable) brevity since many filters may be applied. For instance:
   * `<Field/> has ≤ <Value/>` may be better than
   * `<Field/> has less than or equal to <Value/>`
   **/
  /* Array should have a count the given filter value */
  "search.operator.array-count-equal.description_one": "<Field/> <Operator>has</Operator> <Value>{{count}} item</Value>",
  "search.operator.array-count-equal.description_other": "<Field/> <Operator>has</Operator> <Value>{{count}} items</Value>",
  "search.operator.array-count-equal.name": "quantity is",
  /* Array should have a count greater than given filter value */
  "search.operator.array-count-gt.description_one": "<Field/> <Operator>has ></Operator> <Value>{{count}} item</Value>",
  "search.operator.array-count-gt.description_other": "<Field/> <Operator>has ></Operator> <Value>{{count}} items</Value>",
  "search.operator.array-count-gt.name": "quantity greater than",
  /* Array should have a count greater than or equal to the given filter value */
  "search.operator.array-count-gte.description_one": "<Field/> <Operator>has \u2265</Operator> <Value>{{count}} item</Value>",
  "search.operator.array-count-gte.description_other": "<Field/> <Operator>has \u2265</Operator> <Value>{{count}} items</Value>",
  "search.operator.array-count-gte.name": "quantity greater than or equal to",
  /* Array should have a count less than given filter value */
  "search.operator.array-count-lt.description_one": "<Field/> <Operator>has <</Operator> <Value>{{count}} item</Value>",
  "search.operator.array-count-lt.description_other": "<Field/> <Operator>has <</Operator> <Value>{{count}} items</Value>",
  "search.operator.array-count-lt.name": "quantity less than",
  /* Array should have a count less than or equal to the given filter value */
  "search.operator.array-count-lte.description_one": "<Field/> <Operator>has \u2264</Operator> <Value>{{count}} item</Value>",
  "search.operator.array-count-lte.description_other": "<Field/> <Operator>has \u2264</Operator> <Value>{{count}} items</Value>",
  "search.operator.array-count-lte.name": "quantity less than or equal to",
  /* Array should have a count that is not equal to the given filter value */
  "search.operator.array-count-not-equal.description_one": "<Field/> <Operator>does not have</Operator> <Value>{{count}} item</Value>",
  "search.operator.array-count-not-equal.description_other": "<Field/> <Operator>does not have</Operator> <Value>{{count}} items</Value>",
  "search.operator.array-count-not-equal.name": "quantity is not",
  /**
   * Array should have a count within the range of given filter values.
   * Gets passed `{{from}}` and `{{to}}` values.
   **/
  "search.operator.array-count-range.description": "<Field/> <Operator>has between</Operator> <Value>{{from}} \u2192 {{to}} items</Value>",
  "search.operator.array-count-range.name": "quantity is between",
  /* Array should include the given value */
  "search.operator.array-list-includes.description": "<Field/> <Operator>includes</Operator> <Value>{{value}}</Value>",
  "search.operator.array-list-includes.name": "includes",
  /* Array should not include the given value */
  "search.operator.array-list-not-includes.description": "<Field/> <Operator>does not include</Operator> <Value>{{value}}</Value>",
  "search.operator.array-list-not-includes.name": "does not include",
  /* Array should include the given reference */
  "search.operator.array-reference-includes.description": "<Field/> <Operator>includes</Operator> <Value>{{value}}</Value>",
  "search.operator.array-reference-includes.name": "includes",
  /* Array should not include the given reference */
  "search.operator.array-reference-not-includes.description": "<Field/> <Operator>does not include</Operator> <Value>{{value}}</Value>",
  "search.operator.array-reference-not-includes.name": "does not include",
  /* Asset (file) should be the selected asset */
  "search.operator.asset-file-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.asset-file-equal.name": "is",
  /* Asset (file) should not be the selected asset */
  "search.operator.asset-file-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.asset-file-not-equal.name": "is not",
  /* Asset (image) should be the selected asset */
  "search.operator.asset-image-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.asset-image-equal.name": "is",
  /* Asset (image) should not be the selected asset */
  "search.operator.asset-image-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.asset-image-not-equal.name": "is not",
  /**
   * Boolean value should be the given filter value (true/false).
   * Context passed is `true` and `false`, allowing for more specific translations:
   * - `search.operator.boolean-equal.description_true`
   * - `search.operator.boolean-equal.description_false`
   */
  "search.operator.boolean-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.boolean-equal.name": "is",
  /* Date should be after (later than) given filter value */
  "search.operator.date-after.description": "<Field/> <Operator>is after</Operator> <Value>{{value}}</Value>",
  "search.operator.date-after.name": "after",
  /* Date should be before (earlier than) given filter value */
  "search.operator.date-before.description": "<Field/> <Operator>is before</Operator> <Value>{{value}}</Value>",
  "search.operator.date-before.name": "before",
  /* Date should be the given filter value */
  "search.operator.date-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.date-equal.name": "is",
  /* Date should be within the given filter value range (eg "within the last X days") */
  "search.operator.date-last.description": "<Field/> <Operator>is in the last</Operator> <Value>{{value}}</Value>",
  "search.operator.date-last.name": "last",
  /* Date should not be the given filter value */
  "search.operator.date-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.date-not-equal.name": "is not",
  /* Date should be within the range of given filter values */
  "search.operator.date-range.description": "<Field/> <Operator>is between</Operator> <Value/>",
  "search.operator.date-range.name": "is between",
  /* Date and time should be after (later than) given filter value */
  "search.operator.date-time-after.description": "<Field/> <Operator>is after</Operator> <Value>{{value}}</Value>",
  "search.operator.date-time-after.name": "after",
  /* Date and time should be before (earlier than) given filter value */
  "search.operator.date-time-before.description": "<Field/> <Operator>is before</Operator> <Value>{{value}}</Value>",
  "search.operator.date-time-before.name": "before",
  /* Date and time should be the given filter value */
  "search.operator.date-time-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.date-time-equal.name": "is",
  /* Date and time should be within the given filter value range (eg "within the last X days") */
  "search.operator.date-time-last.description": "<Field/> <Operator>is in the last</Operator> <Value>{{value}}</Value>",
  "search.operator.date-time-last.name": "last",
  /* Date and time should not be the given filter value */
  "search.operator.date-time-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.date-time-not-equal.name": "is not",
  /* Date and time should be within the range of given filter values */
  "search.operator.date-time-range.description": "<Field/> <Operator>is between</Operator> <Value/>",
  "search.operator.date-time-range.name": "is between",
  /* Value should be defined */
  "search.operator.defined.description": "<Field/> <Operator>is</Operator> <Value>not empty</Value>",
  "search.operator.defined.name": "not empty",
  /* Value should not be defined */
  "search.operator.not-defined.description": "<Field/> <Operator>is</Operator> <Value>empty</Value>",
  "search.operator.not-defined.name": "empty",
  /* Number should be the given filter value */
  "search.operator.number-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.number-equal.name": "is",
  /* Number should be greater than given filter value */
  "search.operator.number-gt.description": "<Field/> <Operator>></Operator> <Value>{{value}}</Value>",
  "search.operator.number-gt.name": "greater than",
  /* Number should be greater than or the given filter value */
  "search.operator.number-gte.description": "<Field/> <Operator>\u2265</Operator> <Value>{{value}}</Value>",
  "search.operator.number-gte.name": "greater than or equal to",
  /* Number should be less than given filter value */
  "search.operator.number-lt.description": "<Field/> <Operator><</Operator> <Value>{{value}}</Value>",
  "search.operator.number-lt.name": "less than",
  /* Number should be less than or the given filter value */
  "search.operator.number-lte.description": "<Field/> <Operator>\u2264</Operator> <Value>{{value}}</Value>",
  "search.operator.number-lte.name": "less than or equal to",
  /* Number should not be the given filter value */
  "search.operator.number-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.number-not-equal.name": "is not",
  /* Number should be within the range of given filter values */
  "search.operator.number-range.description": "<Field/> <Operator>is between</Operator> <Value>{{from}} \u2192 {{to}}</Value>",
  "search.operator.number-range.name": "is between",
  /* Portable Text should contain the given filter value */
  "search.operator.portable-text-contains.description": "<Field/> <Operator>contains</Operator> <Value>{{value}}</Value>",
  "search.operator.portable-text-contains.name": "contains",
  /* Portable Text should be the given filter value */
  "search.operator.portable-text-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.portable-text-equal.name": "is",
  /* Portable Text should not contain the given filter value */
  "search.operator.portable-text-not-contains.description": "<Field/> <Operator>does not contain</Operator> <Value>{{value}}</Value>",
  "search.operator.portable-text-not-contains.name": "does not contain",
  /* Portable Text should not be the given filter value */
  "search.operator.portable-text-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.portable-text-not-equal.name": "is not",
  /* References the given asset (file) */
  "search.operator.reference-asset-file.description": "<Field/> <Operator>\u2192</Operator> <Value>{{value}}</Value>",
  "search.operator.reference-asset-file.name": "file",
  /* References the given asset (image) */
  "search.operator.reference-asset-image.description": "<Field/> <Operator>\u2192</Operator> <Value>{{value}}</Value>",
  "search.operator.reference-asset-image.name": "image",
  /* References the given document */
  "search.operator.reference-document.description": "<Field/> <Operator>\u2192</Operator> <Value>{{value}}</Value>",
  "search.operator.reference-document.name": "document",
  /* Reference should be the given document */
  "search.operator.reference-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.reference-equal.name": "is",
  /* Reference should not be the given document */
  "search.operator.reference-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.reference-not-equal.name": "is not",
  /* Slug contains the given value */
  "search.operator.slug-contains.description": "<Field/> <Operator>contains</Operator> <Value>{{value}}</Value>",
  "search.operator.slug-contains.name": "contains",
  /* Slug equals the given filter value */
  "search.operator.slug-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.slug-equal.name": "is",
  /* Slug does not contain the given value */
  "search.operator.slug-not-contains.description": "<Field/> <Operator>does not contain</Operator> <Value>{{value}}</Value>",
  "search.operator.slug-not-contains.name": "does not contain",
  /* Slug does not equal the given filter value */
  "search.operator.slug-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.slug-not-equal.name": "is not",
  /* String contains the given filter value */
  "search.operator.string-contains.description": "<Field/> <Operator>contains</Operator> <Value>{{value}}</Value>",
  "search.operator.string-contains.name": "contains",
  /* String equals the given filter value */
  "search.operator.string-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.string-equal.name": "is",
  /* String equals one of the predefined allowed values */
  "search.operator.string-list-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.string-list-equal.name": "is",
  /* String does not equal one of the predefined allowed values */
  "search.operator.string-list-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.string-list-not-equal.name": "is not",
  /* String does not contain the given filter value */
  "search.operator.string-not-contains.description": "<Field/> <Operator>does not contain</Operator> <Value>{{value}}</Value>",
  "search.operator.string-not-contains.name": "does not contain",
  /* String does not equal the given filter value */
  "search.operator.string-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.string-not-equal.name": "is not",
  /** Label for the "Best match" search ordering type */
  "search.ordering.best-match-label": "Best match",
  /** Label for the "Created: Oldest first" search ordering type */
  "search.ordering.created-ascending-label": "Created: Oldest first",
  /** Label for the "Created: Newest first" search ordering type */
  "search.ordering.created-descending-label": "Created: Newest first",
  /** Label for the "Updated: Oldest first" search ordering type */
  "search.ordering.updated-ascending-label": "Updated: Oldest first",
  /** Label for the "Updated: Newest first" search ordering type */
  "search.ordering.updated-descending-label": "Updated: Newest first",
  /** Placeholder text for the global search input field */
  "search.placeholder": "Search",
  /** Accessibility label for the recent searches section, shown when no valid search terms has been given */
  "search.recent-searches-aria-label": "Recent searches",
  /** Label/heading shown for the recent searches section */
  "search.recent-searches-label": "Recent searches",
  /** Accessibility label for the search results section, shown when the user has typed valid terms */
  "search.search-results-aria-label": "Search results",
  /** Label for the edit columns button to change field visibility in sheet list */
  "sheet-list.edit-columns": "Edit columns",
  /** Label for the header menu option to hide a field from the sheet list */
  "sheet-list.hide-field": "Remove from table",
  /** Label for reset column visibilities button */
  "sheet-list.reset-columns": "Reset columns",
  /** Title for the edit columns menu */
  "sheet-list.select-fields": "Select up to 5 field types",
  /** Accessibility label for the navbar status button */
  "status-button.aria-label": "Configuration status",
  /* Time zone handling */
  "time-zone.action.search-for-timezone-placeholder": "Search for a city or time zone",
  /* Label for the local time zone button */
  "time-zone.action.select-local-time-zone": "Select local time zone",
  /* Dialog info for the time zone dialog */
  "time-zone.dialog-info.content-releases": "The selected time zone will change how dates are represented in content releases.",
  /* Dialog info for the time zone dialog */
  "time-zone.dialog-info.input": "The selected time zone will change how dates are represented only for this input in this document.",
  /* Dialog info for the time zone dialog */
  "time-zone.dialog-info.scheduled-publishing": "The selected time zone will change how dates are represented in schedules.",
  /* Label for the local time zone button */
  "time-zone.local-time": "local time",
  /* Label for the time zone button */
  "time-zone.time-zone": "Time zone",
  /* Tooltip content for the time zone dialog */
  "time-zone.time-zone-tooltip-content-releases": "Displaying releases in {{alternativeName}} GMT{{offset}}",
  /* Tooltip content for the time zone dialog */
  "time-zone.time-zone-tooltip-input": "Displaying <em>{{title}}</em> in {{alternativeName}} GMT{{offset}}",
  /* Tooltip content for the time zone dialog */
  "time-zone.time-zone-tooltip-scheduled-publishing": "Displaying schedules in {{alternativeName}} GMT{{offset}}",
  /** Title for the changes tooltip in the history inspector*/
  "timeline.changes.title": "Changes by",
  /** Description for error when the timeline for the given document can't be loaded */
  "timeline.error.load-document-changes-description": "Document history transactions have not been affected.",
  /** Title for error when the timeline for the given document can't be loaded */
  "timeline.error.load-document-changes-title": "An error occurred whilst retrieving document changes.",
  /** Description for error when the timeline for the given document can't be loaded */
  "timeline.error.load-document-changes-version-description": "Enable the events API through the Studio config to view document history.",
  /** Title for error when the timeline for the given version document can't be loaded */
  "timeline.error.load-document-changes-version-title": "Version documents history is only available through the Events API.",
  /** Error description for when the document doesn't have history */
  "timeline.error.no-document-history-description": "When changing the content of the document, the document versions will appear in this menu.",
  /** Error title for when the document doesn't have history */
  "timeline.error.no-document-history-title": "No document history",
  /** Error prompt when revision cannot be loaded */
  "timeline.error.unable-to-load-revision": "Unable to load revision",
  /** Label for when the timeline item is the latest in the history */
  "timeline.latest": "Latest",
  /** Label for latest revision for timeline menu dropdown */
  "timeline.latest-revision": "Latest revision",
  /**
   * Label for latest revision for timeline menu dropdown
   * @deprecated as of `v3.47.0` `timeline.latest-revision` should be used instead. Note: _usage_ of this key is deprecated, but Studios on `< v3.47.0` still require this key to be _defined_
   * */
  "timeline.latest-version": "Latest revision",
  /** The aria-label for the list of revisions in the timeline */
  "timeline.list.aria-label": "Document revisions",
  /** Label for loading history */
  "timeline.loading-history": "Loading history\u2026",
  /* Label for when no previous since events are available*/
  "timeline.no-previous-events": "No previous events",
  /** Label shown in review changes timeline when a document has been created */
  "timeline.operation.created": "Created",
  /** Label shown in review changes timeline when a document was initially created */
  "timeline.operation.created-initial": "Created",
  /** Label shown in review changes timeline when a document was initially created, with a timestamp */
  "timeline.operation.created-initial_timestamp": "Created: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document has been created, with a timestamp */
  "timeline.operation.created_timestamp": "Created: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document has been deleted */
  "timeline.operation.deleted": "Deleted",
  /** Label shown in review changes timeline when a document has been deleted, with a timestamp */
  "timeline.operation.deleted_timestamp": "Deleted: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a draft document has been created*/
  "timeline.operation.draft-created": "Draft created",
  /** Label shown in review changes timeline when a draft document has been created, with a timestamp */
  "timeline.operation.draft-created_timestamp": "Draft created: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a draft has been discarded */
  "timeline.operation.draft-discarded": "Discarded draft",
  /** Label shown in review changes timeline when a draft has been discarded, with a timestamp */
  "timeline.operation.draft-discarded_timestamp": "Discarded draft: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a draft has been edited */
  "timeline.operation.edited-draft": "Edited",
  /** Label shown in review changes timeline when a draft has been edited, with a timestamp */
  "timeline.operation.edited-draft_timestamp": "Edited: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document has been edited live */
  "timeline.operation.edited-live": "Live edited",
  /** Label shown in review changes timeline when a document has been edited live, with a timestamp */
  "timeline.operation.edited-live_timestamp": "Live edited: {{timestamp, datetime}}",
  /** Label shown in review changes timeline event when transactions have been deleted by retention policy */
  "timeline.operation.history-cleared": "Deleted by retention policy",
  /** Label shown in review changes timeline when a document was published */
  "timeline.operation.published": "Published",
  /** Label shown in review changes timeline when a document was published, with a timestamp */
  "timeline.operation.published_timestamp": "Published: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document was unpublished */
  "timeline.operation.unpublished": "Unpublished",
  /** Label shown in review changes timeline when a document was unpublished, with a timestamp */
  "timeline.operation.unpublished_timestamp": "Unpublished: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document version has been created */
  "timeline.operation.version-created": "Version created",
  /** Label shown in review changes timeline when a document version has been created, with a timestamp */
  "timeline.operation.version-created_timestamp": "Version created: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document version has been discarded */
  "timeline.operation.version-discarded": "Version discarded",
  /** Label shown in review changes timeline when a document version has been discarded, with a timestamp */
  "timeline.operation.version-discarded_timestamp": "Version discarded: {{timestamp, datetime}}",
  /**
   * Label for determining since which version the changes for timeline menu dropdown are showing.
   * Receives the time label as a parameter (`timestamp`).
   */
  "timeline.since": "{{timestamp, datetime}}",
  /** Label for missing change version for timeline menu dropdown are showing */
  "timeline.since-version-missing": "Since: unknown version",
  /** Aria label for the action buttons in the PTE toolbar */
  "toolbar.portable-text.action-button-aria-label": "{{action}}",
  /** Accessibility label for the breadcrumb menu */
  "tree-editing-dialog.breadcrumbs.menu": "Breadcrumb menu",
  /** Title placeholder for search input in array of objects */
  "tree-editing-dialog.search-placeholder": "Search",
  /** Menu aria label for the search menu */
  "tree-editing-dialog.search.menu-label": "Search menu",
  /** Title label for when no search results are found on the tree of objects */
  "tree-editing-dialog.search.no-results-title": "No results found",
  /** Label to close the sidebar */
  "tree-editing-dialog.sidebar.action.close": "Close sidebar",
  /** Collapse label the menu item in the sidebar  */
  "tree-editing-dialog.sidebar.action.collapse": "Collapse",
  /** Label to close the dialog */
  "tree-editing-dialog.sidebar.action.done": "Done",
  /** Exapnd label the menu item in the sidebar  */
  "tree-editing-dialog.sidebar.action.expand": "Expand",
  /** Label to open the sidebar */
  "tree-editing-dialog.sidebar.action.open": "Open sidebar",
  /** Label for the button showed after trial ended */
  "user-menu.action.free-trial-finished": "Upgrade from free",
  /** Label for button showing the free trial days left */
  "user-menu.action.free-trial_one": "{{count}} day left in trial",
  "user-menu.action.free-trial_other": "{{count}} days left in trial",
  /** Label for action to invite members to the current sanity project */
  "user-menu.action.invite-members": "Invite members",
  /** Accessibility label for action to invite members to the current sanity project */
  "user-menu.action.invite-members-aria-label": "Invite members",
  /** Label for action to manage the current sanity project */
  "user-menu.action.manage-project": "Manage project",
  /** Accessibility label for the action to manage the current project */
  "user-menu.action.manage-project-aria-label": "Manage project",
  /** Tooltip helper text when portable text annotation is disabled for empty block*/
  "user-menu.action.portable-text.annotation-disabled_empty-block": "Cannot apply {{name}} to empty block",
  /** Tooltip helper text when portable text annotation is disabled for multiple blocks */
  "user-menu.action.portable-text.annotation-disabled_multiple-blocks": "Cannot apply {{name}} to multiple blocks",
  /** Label for action to sign out of the current sanity project */
  "user-menu.action.sign-out": "Sign out",
  /** Title for appearance section for the current studio (dark / light / system scheme) */
  "user-menu.appearance-title": "Appearance",
  /** Label for close menu button for user menu */
  "user-menu.close-menu": "Close menu",
  /** Description for using the "dark theme" in the appearance user menu */
  "user-menu.color-scheme.dark-description": "Use dark appearance",
  /** Title for using the "dark theme" in the appearance user menu */
  "user-menu.color-scheme.dark-title": "Dark",
  /** Description for using the "light theme" in the appearance user menu */
  "user-menu.color-scheme.light-description": "Use light appearance",
  /** Title for using the "light theme" in the appearance user menu */
  "user-menu.color-scheme.light-title": "Light",
  /** Description for using "system apparence" in the appearance user menu */
  "user-menu.color-scheme.system-description": "Use system appearance",
  /** Title for using system apparence in the appearance user menu */
  "user-menu.color-scheme.system-title": "System",
  /** Title for locale section for the current studio */
  "user-menu.locale-title": "Language",
  /** Label for tooltip to show which provider the currently logged in user is using */
  "user-menu.login-provider": "Signed in with {{providerTitle}}",
  /** Label for open menu button for user menu */
  "user-menu.open-menu": "Open menu",
  /** Label for other users' agent bundle versions */
  "version.agent-bundle.agent-changes": "Agent changes",
  /** Label for the current user's agent bundle versions */
  "version.agent-bundle.proposed-changes": "Proposed changes",
  /**
   * Label for action to add a workspace (currently a developer-oriented action, as this will
   * lead to the documentation on workspace configuration)
   */
  "workspaces.action.add-workspace": "Add workspace",
  /**
   * Label for action to choose a different workspace, in the case where you are not logged in,
   * have selected a workspace, and are faced with the authentication options for the selected
   * workspace. In other words, label for the action shown when you have reconsidered which
   * workspace to authenticate in.
   */
  "workspaces.action.choose-another-workspace": "Choose another workspace",
  /** Label for title to switch workspace before workspaces are listed */
  "workspaces.action.switch-workspace": "Switch workspace",
  /** Label for heading that indicates that you can choose your workspace */
  "workspaces.choose-your-workspace-label": "Choose your workspace",
  /** Label for the workspace menu */
  "workspaces.select-workspace-aria-label": "Select workspace",
  /** Button label for opening the workspace switcher */
  "workspaces.select-workspace-label": "Select workspace",
  /** Tooltip for the workspace menu */
  "workspaces.select-workspace-tooltip": "Select workspace",
  /** Title for Workplaces dropdown menu */
  "workspaces.title": "Workspaces"
}), studioDefaultLocaleResources = {
  locale: "en-US",
  namespace: studioLocaleNamespace,
  resources: studioLocaleStrings
}, validationLocaleStrings = defineLocalesResources("validation", {
  /** Array must have exactly "$wantedLength" items, but has more/less */
  "array.exact-length": "Must have exactly {{wantedLength}} items",
  /** Portable Text array must have exactly "$wantedLength" blocks, but has more/less */
  "array.exact-length_blocks": "Must have exactly {{wantedLength}} blocks",
  /** Array item is a duplicate, but array wants only unique items */
  "array.item-duplicate": "Can't be a duplicate",
  /** Array has more than the maximum of "$maxLength" items */
  "array.maximum-length": "Must have at most {{maxLength}} items",
  /** Portable Text array has more than the maximum of "$maxLength" items */
  "array.maximum-length_blocks": "Must have at most {{maxLength}} blocks",
  /** Array has less than the minimum of "$minLength" items */
  "array.minimum-length": "Must have at least {{minLength}} items",
  /** Portable Text array has less than the minimum of "$minLength" blocks */
  "array.minimum-length_blocks": "Must have at least {{minLength}} blocks",
  /** Date is not valid or not in the correct format (ISO-8601) */
  "date.invalid-format": "Must be a valid ISO-8601 formatted date string",
  /** Date is later than the given maximum date "$maxDate" */
  "date.maximum": "Must be at or before {{maxDate}}",
  /** Date is earlier than the given minimum date "$minDate" */
  "date.minimum": "Must be at or after {{minDate}}",
  /** A value of incorrect type is found, eg found `number` instead of `string` */
  "generic.incorrect-type": 'Expected type "{{expectedType}}", got "{{actualType}}"',
  /** Value is not one of the values specifically allowed */
  "generic.not-allowed": "Value did not match any allowed values",
  /** Value "$givenValue" is not one of the values specifically allowed */
  "generic.not-allowed_hint": 'Value "{{hint}}" did not match any allowed values',
  /** A value is expected, but none is provided */
  "generic.required": "Required",
  /** Number is less than the given minimum threshold value "$threshold" */
  "number.greater-than": "Must be greater than {{threshold}}",
  /** Number is greater than the given maximum threshold value "$threshold" */
  "number.less-than": "Must be less than {{threshold}}",
  /** Number is higher than the given maximum value "$maxNumber" */
  "number.maximum": "Must be lower than or equal to {{maxNumber}}",
  /** Number has more precision (decimals) than the allowed "$limit" */
  "number.maximum-precision": "Max precision is {{limit}}",
  /** Number is lower than the given minimum value "$minNumber" */
  "number.minimum": "Must be greater than or equal to {{minNumber}}",
  /** Number is not an integer ("whole number") */
  "number.non-integer": "Must be an integer",
  /** Object is missing a reference to an asset document in its `asset` field */
  "object.asset-required": "Asset is required",
  /** Object is missing a reference to a file asset document in its `asset` field */
  "object.asset-required_file": "File is required",
  /** Object is missing a reference to an image asset document in its `asset` field */
  "object.asset-required_image": "Image is required",
  /** Media can't be found in the Media Library */
  "object.media-not-found": "The asset could not be found in the Media Library",
  /** Media object is missing a reference to a document in its `_ref` field */
  "object.not-media-library-asset": "Must be a reference to a Media Library asset",
  /** Object is not a reference to a document (eg `{_ref: 'documentId'}`) */
  "object.not-reference": "Must be a reference to a document",
  /** Object references a document which is not published */
  "object.reference-not-published": "Referenced document must be published",
  /** Accessibility label for closing the validation panel */
  "panel.close-button-aria-label": "Close validation",
  /** Message shown when the validation panel is opened but there are no errors/warnings */
  "panel.no-errors-message": "No validation errors",
  /** Title for the actual "Validation" panel/feature */
  "panel.title": "Validation",
  /** Message shown when the validation panel is opened but the document is going to unpublish */
  "panel.unpublish-message": "Document is going to unpublish, no validation errors are shown",
  /** Slug is an object, but is missing a `current` string property */
  "slug.missing-current": "Slug must have a value",
  /** Slug is not an object (eg `{current: 'some-slug'}`) */
  "slug.not-object": "Slug must be an object",
  /** Slug is already in use somewhere else, but needs to be unique */
  "slug.not-unique": "Slug is already in use",
  /** String is not a valid email address */
  "string.email": "Must be a valid email address",
  /** String has a different character length than the exact number "$wantedLength" */
  "string.exact-length": "Must be exactly {{wantedLength}} characters long",
  /** String contains characters that are not in lowercase  */
  "string.lowercase": "Must be all lowercase characters",
  /** String is longer than the limit of "$maxLength" characters */
  "string.maximum-length": "Must be at most {{maxLength}} characters long",
  /** String is shorter than the limit of "$minLength" characters */
  "string.minimum-length": "Must be at least {{minLength}} characters long",
  /** String does not match the given regular expression, but should */
  "string.regex-does-not-match": 'Does not match "{{name}}"-pattern',
  /** String matches the given regular expression, but should not */
  "string.regex-match": 'Should not match "{{name}}"-pattern',
  /** String contains characters that are not in uppercase */
  "string.uppercase": "Must be all uppercase characters",
  /** String contains a protocol/scheme that is not allowed, eg (`ftp`, `mailto`…) */
  "string.url.disallowed-scheme": "Does not match allowed protocols/schemes",
  /** String contains a URL with a username or password specified before the host */
  "string.url.includes-credentials": "Username/password not allowed",
  /** String is not a valid URL */
  "string.url.invalid": "Not a valid URL",
  /** String is not an absolute URL (eg it is missing a protocol/host) */
  "string.url.not-absolute": "Relative URLs are not allowed",
  /** String is not a relative URL (eg it contains a protocol/host) */
  "string.url.not-relative": "Only relative URLs are allowed"
}), validationLocaleResources = {
  locale: "en-US",
  namespace: validationLocaleNamespace,
  resources: validationLocaleStrings
}, usEnglishLocale = {
  id: "en-US",
  title: "English (US)",
  bundles: [studioDefaultLocaleResources, validationLocaleResources, copyPasteLocaleResources],
  weekInfo: {
    firstDay: 7,
    // Sunday
    weekend: [6, 7]
    // Saturday, Sunday
  }
}, defaultLocale = usEnglishLocale, supportsLocalStorage = (() => {
  if (typeof process < "u" && typeof process.versions < "u")
    return !1;
  const key = "__tmp_supports_local_storage";
  try {
    return typeof localStorage > "u" ? !1 : (localStorage.setItem(key, "---"), localStorage.removeItem(key), !0);
  } catch {
    return !1;
  }
})(), LOCAL_STORAGE_PREFIX = "sanity-locale";
function getPreferredLocale(projectId, sourceId) {
  return supportsLocalStorage ? localStorage.getItem(getItemKey$1(projectId, sourceId)) ?? void 0 : void 0;
}
function storePreferredLocale(projectId, sourceId, locale) {
  supportsLocalStorage && localStorage.setItem(getItemKey$1(projectId, sourceId), locale);
}
function getItemKey$1(projectId, sourceId) {
  return [LOCAL_STORAGE_PREFIX, projectId, sourceId].join(":");
}
function LocaleProvider(props2) {
  const $ = c(6), {
    projectId,
    name: sourceId,
    i18n: t0,
    __internal: t1
  } = useSource(), {
    locales
  } = t0, {
    i18next
  } = t1;
  let t2;
  return $[0] !== i18next || $[1] !== locales || $[2] !== projectId || $[3] !== props2 || $[4] !== sourceId ? (t2 = /* @__PURE__ */ jsx(LocaleProviderBase, { ...props2, projectId, sourceId, locales, i18next }), $[0] = i18next, $[1] = locales, $[2] = projectId, $[3] = props2, $[4] = sourceId, $[5] = t2) : t2 = $[5], t2;
}
function LocaleProviderBase(t0) {
  const $ = c(24), {
    projectId,
    sourceId,
    locales,
    i18next,
    children
  } = t0;
  let t1;
  $[0] !== i18next ? (t1 = (callback) => (i18next.on("languageChanged", callback), () => i18next.off("languageChanged", callback)), $[0] = i18next, $[1] = t1) : t1 = $[1];
  const subscribe2 = t1;
  let t2;
  $[2] !== i18next.language || $[3] !== locales ? (t2 = () => locales.find((candidate) => i18next.language === candidate.id) || defaultLocale, $[2] = i18next.language, $[3] = locales, $[4] = t2) : t2 = $[4];
  const currentLocale = useSyncExternalStore(subscribe2, t2);
  let t3;
  $[5] !== i18next ? (t3 = {
    i18next
  }, $[5] = i18next, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== i18next || $[8] !== projectId || $[9] !== sourceId ? (t4 = async (newLocale) => {
    storePreferredLocale(projectId, sourceId, newLocale), await i18next.changeLanguage(newLocale);
  }, $[7] = i18next, $[8] = projectId, $[9] = sourceId, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== currentLocale || $[12] !== locales || $[13] !== t3 || $[14] !== t4 ? (t5 = {
    locales,
    currentLocale,
    __internal: t3,
    changeLocale: t4
  }, $[11] = currentLocale, $[12] = locales, $[13] = t3, $[14] = t4, $[15] = t5) : t5 = $[15];
  const context = t5;
  let t6;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx(LoadingBlock, {}), $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== children || $[18] !== context || $[19] !== currentLocale.id ? (t7 = /* @__PURE__ */ jsx(LocaleContext.Provider, { value: context, children }, currentLocale.id), $[17] = children, $[18] = context, $[19] = currentLocale.id, $[20] = t7) : t7 = $[20];
  let t8;
  return $[21] !== i18next || $[22] !== t7 ? (t8 = /* @__PURE__ */ jsx(Suspense, { fallback: t6, children: /* @__PURE__ */ jsx(I18nextProvider, { i18n: i18next, children: t7 }) }), $[21] = i18next, $[22] = t7, $[23] = t8) : t8 = $[23], t8;
}
function catchWithCount(selector) {
  return (input$) => {
    let successiveErrorsCount = 0;
    const errorOp = catchError((err, caught) => (successiveErrorsCount++, selector(err, successiveErrorsCount, caught).pipe(errorOp)));
    return input$.pipe(tap(() => {
      successiveErrorsCount = 0;
    }), errorOp);
  };
}
function createHookFromObservableFactory(observableFactory, initialValue) {
  const initialLoadingTuple = [initialValue, !0], initialResult = {
    type: "tuple",
    tuple: initialLoadingTuple
  };
  return function(arg) {
    const observable = useMemo(() => of(arg).pipe(switchMap((_arg) => concat(of({
      type: "loading"
    }), observableFactory(_arg).pipe(map((value) => ({
      type: "value",
      value
    }))))), scan(([prevValue], next) => next.type === "loading" ? [prevValue, !0] : [next.value, !1], initialLoadingTuple), distinctUntilChanged(([prevValue, prevIsLoading], [nextValue, nextIsLoading]) => !(prevValue !== nextValue || prevIsLoading !== nextIsLoading)), map((tuple) => ({
      type: "tuple",
      tuple
    })), catchError((error) => of({
      type: "error",
      error
    }))), [arg]), result = useObservable(observable, initialResult);
    if (result.type === "error") throw result.error;
    return result.tuple;
  };
}
function isNonNullable$2(value) {
  return value != null;
}
const PATH_SEPARATOR = ".", DRAFTS_PREFIX = `${DRAFTS_FOLDER}${PATH_SEPARATOR}`;
function documentIdEquals(documentId, equalsDocumentId) {
  return getPublishedId(documentId) === getPublishedId(equalsDocumentId);
}
function isDraft(document2) {
  return isDraftId(document2._id);
}
function getIdPair(id2, {
  version: version2
} = {}) {
  if (version2 === "drafts" || version2 === "published")
    throw new Error('Version can not be "published" or "drafts"');
  return {
    publishedId: getPublishedId(id2),
    draftId: getDraftId(id2),
    ...version2 ? {
      versionId: getVersionId(id2, version2)
    } : {}
  };
}
const systemBundles = ["drafts", "published"];
function isSystemBundle(maybeSystemBundle) {
  return systemBundles.includes(maybeSystemBundle);
}
const systemBundleNames = ["draft", "published"];
function isSystemBundleName(maybeSystemBundleName) {
  return systemBundleNames.includes(maybeSystemBundleName);
}
function idMatchesPerspective(perspectiveStack, documentId) {
  return isPublishedId(documentId) ? !0 : perspectiveStack.some((perspective) => perspective === "drafts" ? isDraftId(documentId) : getVersionFromId(documentId) === perspective);
}
function createDraftFrom(document2) {
  return {
    ...document2,
    _id: getDraftId(document2._id)
  };
}
function newDraftFrom(document2) {
  return {
    ...document2,
    _id: DRAFTS_PREFIX
  };
}
function createPublishedFrom(document2) {
  return {
    ...document2,
    _id: getPublishedId(document2._id)
  };
}
function collate(documents) {
  const byId = documents.reduce((res, doc) => {
    const publishedId = getPublishedId(doc._id);
    let entry = res.get(publishedId);
    return entry || (entry = {
      id: publishedId,
      type: doc._type,
      published: void 0,
      draft: void 0,
      versions: []
    }, res.set(publishedId, entry)), isPublishedId(doc._id) && (entry.published = doc), isDraftId(doc._id) && (entry.draft = doc), isVersionId(doc._id) && entry.versions.push(doc), res;
  }, /* @__PURE__ */ new Map());
  return Array.from(byId.values());
}
function removeDupes$3(documents) {
  return collate(documents).map((entry) => entry.draft || entry.published || entry.versions[0]).filter(isNonNullable$2);
}
const EMPTY_OBJECT = Object.freeze({}), EMPTY_ARRAY$y = Object.freeze([]), formatRelativeLocale = (...args) => {
  const dateFnsRelative = formatRelative(...args);
  if (isValid(parse(dateFnsRelative, "MM/dd/yyyy", /* @__PURE__ */ new Date()))) {
    const [dateTime] = args;
    return new Date(dateTime).toLocaleDateString();
  }
  return dateFnsRelative;
};
function getDocumentVariantType(documentId) {
  return isDraftId(documentId) ? "draft" : isVersionId(documentId) ? "version" : "published";
}
function getErrorMessage$2(error) {
  return error instanceof Error ? error.message : String(error);
}
const INTERNAL_KEYS = ["_id", "_type", "_createdAt", "_updatedAt", "_rev"];
function getReferencePaths(document2, referenceToId) {
  const referencePaths = [];
  function traverse2(obj, currentPath) {
    if (obj != null) {
      if (typeof obj == "object" && obj._ref === referenceToId) {
        referencePaths.push([...currentPath]);
        return;
      }
      if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          item && typeof item == "object" && item._key ? traverse2(item, [...currentPath, {
            _key: item._key
          }]) : traverse2(item, [...currentPath, index]);
        });
        return;
      }
      typeof obj == "object" && Object.keys(obj).forEach((key) => {
        INTERNAL_KEYS.includes(key) || traverse2(obj[key], [...currentPath, key]);
      });
    }
  }
  return Object.keys(document2).forEach((key) => {
    key.startsWith("_") || traverse2(document2[key], [key]);
  }), referencePaths;
}
function getGlobalScope() {
  if (typeof globalThis < "u") return globalThis;
  if (typeof window < "u") return window;
  if (typeof self < "u") return self;
  if (typeof global < "u") return global;
  throw new Error("@sanity/ui: could not locate global scope");
}
const globalScope = getGlobalScope();
function isArray(value) {
  return Array.isArray(value);
}
function isRecord$4(value) {
  return !!value && typeof value == "object" && !Array.isArray(value);
}
function isString(value) {
  return typeof value == "string";
}
function isTruthy(value) {
  return !!value;
}
const RELEASE_DOCUMENT_TYPE = "system.release", RELEASE_DOCUMENTS_PATH = "_.releases", releaseTypes = ["asap", "scheduled", "undecided"];
function isReleaseType(maybeReleaseType) {
  return typeof maybeReleaseType == "string" && releaseTypes.includes(maybeReleaseType);
}
function isReleaseDocument(doc) {
  return typeof doc == "object" && doc !== null && "_type" in doc && doc._type === RELEASE_DOCUMENT_TYPE;
}
function isCardinalityOneRelease(release) {
  return release.metadata?.cardinality === "one";
}
function isCardinalityOnePerspective(perspective) {
  return isReleaseDocument(perspective) && isCardinalityOneRelease(perspective);
}
function isPausedCardinalityOneRelease(release) {
  return release ? release.state === "active" && release.metadata.releaseType === "scheduled" && isCardinalityOneRelease(release) && !!release.metadata.intendedPublishAt : !1;
}
const ResizeObserver$1 = typeof document == "object" && typeof window == "object" && window.ResizeObserver ? window.ResizeObserver : ResizeObserver$2, createSharedResizeObserver = () => {
  const event = createPubSub(), resizeObserver2 = new ResizeObserver$1((entries) => event.publish(entries));
  return {
    observe: (element, observer, options) => {
      const unsubscribe = event.subscribe((entries) => {
        const entry = entries.find((e) => e.target === element);
        entry && observer(entry);
      });
      return resizeObserver2.observe(element, options), () => {
        unsubscribe(), resizeObserver2.unobserve(element);
      };
    },
    unobserve: (element) => resizeObserver2.unobserve(element)
  };
}, resizeObserver = createSharedResizeObserver(), createSWRCache = createLRUCache;
function createSWR(options) {
  const cache2 = createSWRCache(options);
  return function(key) {
    return (input$) => concat(defer(() => cache2.has(key) ? of({
      fromCache: !0,
      value: cache2.get(key)
    }) : EMPTY$5), input$.pipe(tap((result) => cache2.set(key, result)), map$1((value) => ({
      fromCache: !1,
      value
    }))));
  };
}
function createLRUCache(options) {
  const lru = new QuickLRU(options);
  return {
    get(key) {
      const entry = lru.get(key);
      if (!entry)
        throw new Error(`Key not found in LRU cache: ${key}`);
      return entry.value;
    },
    set(key, value) {
      lru.set(key, {
        value
      });
    },
    delete(key) {
      lru.delete(key);
    },
    has(key) {
      return lru.has(key);
    }
  };
}
const BUNDLED_DOC_TYPES = ["sanity.imageAsset", "sanity.fileAsset"];
function _isSanityDocumentTypeDefinition(def) {
  return def.type === "document" && BUNDLED_DOC_TYPES.includes(def.name);
}
function _isCustomDocumentTypeDefinition(def) {
  return def.type === "document" && !_isSanityDocumentTypeDefinition(def);
}
function _isType(schemaType, typeName) {
  return schemaType.name === typeName ? !0 : schemaType.type ? _isType(schemaType.type, typeName) : !1;
}
const GROQ_KEYWORDS = ["match", "in", "asc", "desc", "true", "false", "null"], VALID_FIELD = /^[a-zA-Z_][a-zA-Z0-9_]*$/, fieldNeedsEscape = (fieldName) => !VALID_FIELD.test(fieldName) || GROQ_KEYWORDS.includes(fieldName), escapeField = (fieldName) => `["${fieldName}"]`, escapeFirst = (fieldName) => `@${escapeField(fieldName)}`, isEmptyArray = (value) => Array.isArray(value) && value.length === 0, joinPath = (pathArray) => {
  let path = "";
  for (let i = 0; i < pathArray.length; i++) {
    const pathSegment = pathArray[i];
    if (isEmptyArray(pathSegment)) {
      path += "[]";
      continue;
    }
    if (typeof pathSegment == "number") {
      path += `[${pathSegment}]`;
      continue;
    }
    const isFirst = i === 0;
    fieldNeedsEscape(pathSegment) ? path = isFirst ? escapeFirst(pathSegment) : `${path}${escapeField(pathSegment)}` : path = isFirst ? pathSegment : `${path}.${pathSegment}`;
  }
  return path;
}, supportsTouch = isTouchDevice$1();
function isTouchDevice$1() {
  return typeof window > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
const FONT_SANS_SERIF = "-apple-system, BlinkMacSystemFont, \\'Segoe UI\\', Roboto, \\'Helvetica Neue\\', Helvetica, Arial, system-ui, sans-serif", FONT_MONOSPACE = "-apple-system-ui-monospace, \\'SF Mono\\', Menlo, Monaco, Consolas, monospace", uncaughtErrorHandler = () => (
  // prettier-ignore
  ["window.onerror = function(m,u,l,c,e) {", "var p=window.location.port;", "var h=window.location.protocol+'//'+window.location.hostname+(p?':'+p:'');", "var r=document.getElementById('sanity');", "while(r.firstChild){r.removeChild(r.firstChild);}", "var s=document.createElement('style');", "s.appendChild(document.createTextNode('", "html,body,#sanityBody,#sanity,#sanityError{height:100%;}", "body{-webkit-font-smoothing:antialiased;margin:0;}", `#sanityError{position:fixed;top:0;left:0;width:100%;height:100%;overflow:auto;background-color:#fff;color:#121923;font-family:${FONT_SANS_SERIF};font-size:16px;line-height:21px;min-height:100%;}`, "#sanityError>div{background-color:#fff;max-width:960px;margin:0 auto;padding:47px 32px 52px;}", "@media(min-width:512px){", "#sanityError>div{", "padding:47px 84px;", "}", "}", "#sanityError button{-webkit-font-smoothing:inherit;font:inherit;font-weight:500;background-color:#2276FC;color:#fff;padding:7px 12px;border-radius:3px;border:0;}", "#sanityError button:hover{background-color:#1E63D0;}", "#sanityError button:active{background-color:#1B50A5;}", "'));", "document.head.appendChild(s);", "var f=document.createElement('div');", "f.id='sanityError';", "f.innerHTML='", "<div>", '<h1 style="font-size:21px;line-height:27px;margin: 0 0 10px;">Unhandled error</h1>', '<p style="color:#66758D;margin:10px 0 14px;">Encountered an unhandled error in this Studio.</p>', '<button class="sanity-error-handler__reload-btn" type="button">Reload page</button>', '<pre style="background-color:#FDEBEA;color:#C3362C;font-size:13px;line-height:17px;padding:8px 12px;border-radius:3px;margin:32px 0 0;overflow:auto;">', `<code style="font-family:${FONT_MONOSPACE};">`, "'+e.stack.replaceAll(h,'')+'", "</code>", "</pre>", "</div>", "';", "var b=f.querySelector('.sanity-error-handler__reload-btn');", "if(b){", "b.onclick=function() {", "window.location.reload();", "}", "};", "r.appendChild(f);", "};"].join("")
), segmenter = typeof Intl == "object" && "Segmenter" in Intl ? new Intl.Segmenter() : void 0;
function sliceString(str, start, end) {
  if (end < start)
    throw new Error("End must be greater than start, use `String.prototype.slice()` for negative values");
  if (!segmenter)
    return str.slice(start, end);
  let i = 0, sliced = "";
  for (const value of segmenter.segment(str)) {
    if (i === end)
      return sliced;
    sliced += value.segment, i++;
  }
  return sliced;
}
function truncateString(str, maxLength) {
  const truncated = sliceString(str, 0, maxLength);
  return truncated === str ? truncated : `${truncated}\u2026`;
}
const LOADING_STATE$1 = {
  isLoading: !0,
  value: void 0,
  error: null
};
function useLoadable(value$, initialValue) {
  const $ = c(4);
  let t0;
  $[0] !== initialValue ? (t0 = typeof initialValue > "u" ? LOADING_STATE$1 : {
    isLoading: !1,
    value: initialValue,
    error: null
  }, $[0] = initialValue, $[1] = t0) : t0 = $[1];
  const initial2 = t0;
  let t1;
  return $[2] !== value$ ? (t1 = value$.pipe(asLoadable()), $[2] = value$, $[3] = t1) : t1 = $[3], useObservable(t1, initial2);
}
function asLoadable() {
  return (value$) => value$.pipe(map((value) => ({
    isLoading: !1,
    value,
    error: null
  })), catchError((error) => of({
    isLoading: !1,
    value: void 0,
    error
  })));
}
function userHasRole(user, roleId) {
  return user !== null && user.roles.some((role) => role.name === roleId);
}
function useThrottledCallback(callback, wait, options) {
  const $ = c(4);
  let t0;
  return $[0] !== callback || $[1] !== options || $[2] !== wait ? (t0 = throttle(callback, wait, options), $[0] = callback, $[1] = options, $[2] = wait, $[3] = t0) : t0 = $[3], t0;
}
function useUnique(value) {
  const [previous, setPrevious] = useState(value);
  return isEqual$1(previous, value) ? previous : (setPrevious(value), value);
}
const DEBUG_MODE$1 = typeof process > "u" ? !1 : process?.env?.SANITY_STUDIO_DEBUG_I18N, DEBUG_I18N = !!DEBUG_MODE$1, debugWrappers = {
  reverse: (str) => `\u202E${str}`,
  triangles: (str) => `\u25E4 ${str} \u25E2`
};
function maybeWrapT(t) {
  const wrapper = DEBUG_MODE$1 === "reverse" || DEBUG_MODE$1 === "triangles" ? debugWrappers[DEBUG_MODE$1] : null;
  return wrapper ? (...args) => wrapper(t(...args)) : t;
}
const translationOptionOverrides = {
  // We're manually forcing a re-render with the locale key in the LocaleProvider,
  // so we don't need to bind to the i18n instance for language change events.
  bindI18n: !1
};
function useTranslation(ns, options) {
  const $ = c(6);
  let t0;
  $[0] !== options ? (t0 = options ? {
    keyPrefix: options.keyPrefix,
    lng: options.lng,
    ...translationOptionOverrides
  } : translationOptionOverrides, $[0] = options, $[1] = t0) : t0 = $[1];
  const {
    t
  } = useTranslation$1(ns, t0);
  let t1;
  $[2] !== t ? (t1 = maybeWrapT(t), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== t1 ? (t2 = {
    t: t1
  }, $[4] = t1, $[5] = t2) : t2 = $[5], t2;
}
function useGetI18nText(input) {
  const $ = c(6);
  let t0;
  if ($[0] !== input) {
    const items = Array.isArray(input) ? input : [input];
    t0 = JSON.stringify(items.flatMap(_temp2$1K).filter(isNonNullable$2).sort()), $[0] = input, $[1] = t0;
  } else
    t0 = $[1];
  const stableNamespaces = t0;
  let t1;
  $[2] !== stableNamespaces ? (t1 = JSON.parse(stableNamespaces), $[2] = stableNamespaces, $[3] = t1) : t1 = $[3];
  const namespaces = t1, {
    t
  } = useTranslation(namespaces);
  let t2;
  return $[4] !== t ? (t2 = function(node) {
    const {
      i18n
    } = node;
    return i18n ? new Proxy(node, {
      get: (target, property) => {
        const defaultValue2 = target[property];
        if (typeof property == "string" && property in i18n) {
          const {
            key,
            ns: ns_0
          } = i18n[property];
          return t(key, {
            ns: ns_0,
            ...typeof defaultValue2 == "string" && {
              defaultValue: defaultValue2
            }
          });
        }
        return defaultValue2;
      }
    }) : node;
  }, $[4] = t, $[5] = t2) : t2 = $[5], t2;
}
function _temp2$1K(item) {
  return item?.i18n ? Object.values(item.i18n).map(_temp$47) : [];
}
function _temp$47(t0) {
  const {
    ns
  } = t0;
  return ns;
}
function useI18nText(node) {
  const $ = c(9);
  let t0;
  bb0: {
    if (!node.i18n) {
      let t13;
      $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = [], $[0] = t13) : t13 = $[0], t0 = t13;
      break bb0;
    }
    let t12;
    $[1] !== node.i18n ? (t12 = Array.from(new Set(Object.values(node.i18n).map(_temp$46))).sort(), $[1] = node.i18n, $[2] = t12) : t12 = $[2], t0 = t12;
  }
  const namespaces = t0, {
    t
  } = useTranslation(namespaces);
  let t1;
  bb1: {
    const {
      i18n
    } = node;
    if (!i18n) {
      t1 = node;
      break bb1;
    }
    let t2;
    $[3] !== i18n || $[4] !== t ? (t2 = (target, property) => {
      const defaultValue2 = target[property];
      if (typeof property == "string" && property in i18n) {
        const {
          key,
          ns: ns_0
        } = i18n[property];
        return t(key, {
          ns: ns_0,
          ...typeof defaultValue2 == "string" && {
            defaultValue: defaultValue2
          }
        });
      }
      return defaultValue2;
    }, $[3] = i18n, $[4] = t, $[5] = t2) : t2 = $[5];
    let t3;
    $[6] !== node || $[7] !== t2 ? (t3 = new Proxy(node, {
      get: t2
    }), $[6] = node, $[7] = t2, $[8] = t3) : t3 = $[8], t1 = t3;
  }
  return t1;
}
function _temp$46(t0) {
  const {
    ns
  } = t0;
  return ns;
}
function useCurrentLocale() {
  return useLocale().currentLocale;
}
function useLocale() {
  const context = useContext(LocaleContext);
  if (!context)
    throw new Error("Sanity LocaleContext value missing. Is this hook being used outside LocaleContext.Provider?");
  return context;
}
const intlCache = (() => {
  const caches = {
    dateTimeFormat: createCache(),
    listFormat: createCache(),
    numberFormat: createCache(),
    relativeTimeFormat: createCache()
  };
  function dateTimeFormat(locale, options) {
    const key = getCacheId(locale, options);
    let instance = caches.dateTimeFormat[key];
    return instance || (instance = new Intl.DateTimeFormat(locale, options), caches.dateTimeFormat[key] = instance, instance);
  }
  function listFormat(locale, options) {
    const key = getCacheId(locale, options);
    let instance = caches.listFormat[key];
    return instance || (instance = new Intl.ListFormat(locale, options), caches.listFormat[key] = instance, instance);
  }
  function numberFormat(locale, options) {
    const key = getCacheId(locale, options);
    let instance = caches.numberFormat[key];
    return instance || (instance = new Intl.NumberFormat(locale, options), caches.numberFormat[key] = instance, instance);
  }
  function relativeTimeFormat(locale, options) {
    const key = getCacheId(locale, options);
    let instance = caches.relativeTimeFormat[key];
    return instance || (instance = new Intl.RelativeTimeFormat(locale, options), caches.relativeTimeFormat[key] = instance, instance);
  }
  return {
    dateTimeFormat,
    listFormat,
    numberFormat,
    relativeTimeFormat
  };
})();
function createCache() {
  return /* @__PURE__ */ Object.create(null);
}
function getCacheId(locale, options) {
  return `${locale}-${JSON.stringify(orderedProps(options))}`;
}
function orderedProps(obj) {
  const segments = [];
  for (const [key, value] of Object.entries(obj))
    segments.push(`${key}=${JSON.stringify(value)}`);
  return segments.sort().join(`
`);
}
function useListFormat(t0) {
  const options = t0 === void 0 ? {} : t0, currentLocale = useContext(LocaleContext)?.currentLocale.id;
  return currentLocale ? intlCache.listFormat(currentLocale, options) : intlCache.listFormat("en-US", {
    ...options,
    style: "narrow"
  });
}
const OPEN_TAG_RE = /^<(?<tag>[^\s\d<][^/?><]+)\/?>/, CLOSE_TAG_RE = /<\/(?<tag>[^>]+)>/, SELF_CLOSING_RE = /<[^>]+\/>/, VALID_COMPONENT_NAME_RE = /^[A-Z][A-Za-z0-9]+$/, VALID_HTML_TAG_NAME_RE = /^[a-z]+$/, TEMPLATE_RE = /{{\s*?([^}]+)\s*?}}/g;
function simpleParser(input) {
  const tokens = [];
  let text = "", openTag = "", remainder = input;
  for (; remainder.length > 0; )
    if (!openTag && remainder[0] === "<") {
      const match = matchOpenTag(remainder);
      if (match) {
        const tagName = match.groups.tag;
        validateTagName(tagName), text && (tokens.push(...textTokenWithInterpolation(text)), text = ""), isSelfClosing(match[0]) ? tokens.push({
          type: "tagOpen",
          selfClosing: !0,
          name: tagName
        }) : (tokens.push({
          type: "tagOpen",
          name: tagName
        }), openTag = tagName), remainder = remainder.slice(match[0].length);
      } else
        text += remainder[0], remainder = remainder.slice(1);
    } else if (openTag && remainder[0] === "<" && remainder[1] !== "<") {
      const match = matchCloseTag(remainder);
      if (match) {
        const tagName = match.groups.tag;
        if (remainder[1] !== "/")
          throw new Error(`Expected closing tag for <${openTag}>, but found new opening tag <${tagName}>. Nested tags is not supported.`);
        if (tagName !== openTag)
          throw new Error(`Expected closing tag for <${openTag}>, but found closing tag </${tagName}> instead. Make sure each opening tag has a matching closing tag.`);
        text && (tokens.push(...textTokenWithInterpolation(text)), text = ""), tokens.push({
          type: "tagClose",
          name: tagName
        }), openTag = "", remainder = remainder.slice(match[0].length);
      } else
        text += remainder[0], remainder = remainder.slice(1);
    } else
      text += remainder[0], remainder = remainder.slice(1);
  if (openTag)
    throw new Error(`No matching closing tag for <${openTag}> found. Either make it self closing (e.g. "<${openTag}/>") or close it (e.g "<${openTag}>...</${openTag}>").`);
  return text && tokens.push(...textTokenWithInterpolation(text)), tokens;
}
function textTokenWithInterpolation(text) {
  const tokens = [], interpolations = text.matchAll(TEMPLATE_RE);
  let lastIndex = 0;
  for (const match of interpolations) {
    if (typeof match.index > "u")
      continue;
    const pre = text.slice(lastIndex, match.index);
    pre.length > 0 && tokens.push({
      type: "text",
      text: pre
    }), tokens.push(parseInterpolation(match[0])), lastIndex += pre.length + match[0].length;
  }
  return lastIndex < text.length && tokens.push({
    type: "text",
    text: text.slice(lastIndex)
  }), tokens;
}
function parseInterpolation(interpolation) {
  const [variable, ...formatters] = interpolation.replace(/^\{\{|\}\}$/g, "").trim().split(/\s*,\s*/);
  if (formatters.length === 1 && formatters[0] === "list")
    return {
      type: "interpolation",
      variable,
      formatters
    };
  if (formatters.length > 0)
    throw new Error(`Interpolations with formatters are not supported when using <Translate>. Found "${interpolation}". Utilize "useTranslation" instead, or format the values passed to <Translate> ahead of time.`);
  return {
    type: "interpolation",
    variable
  };
}
function isSelfClosing(tag) {
  return SELF_CLOSING_RE.test(tag);
}
function matchOpenTag(input) {
  return input.match(OPEN_TAG_RE);
}
function matchCloseTag(input) {
  return input.match(CLOSE_TAG_RE);
}
function validateTagName(tagName) {
  if (!(VALID_COMPONENT_NAME_RE.test(tagName) || VALID_HTML_TAG_NAME_RE.test(tagName)))
    throw new Error(tagName.trim() === tagName ? `Invalid tag "<${tagName}>". Tag names must be lowercase HTML tags or start with an uppercase letter and can only include letters and numbers.` : `Invalid tag "<${tagName}>". No whitespace allowed in tags.`);
}
const COMPONENT_NAME_RE = /^[A-Z]/, RECOGNIZED_HTML_TAGS = /* @__PURE__ */ new Set(["abbr", "address", "cite", "code", "del", "em", "ins", "kbd", "q", "samp", "strong", "sub", "sup"]);
function Translate(props2) {
  const $ = c(16), t0 = props2.values && "count" in props2.values && typeof props2.values.count == "number" ? props2.values.count : void 0;
  let t1;
  $[0] !== props2.context || $[1] !== props2.i18nKey || $[2] !== props2.t || $[3] !== t0 ? (t1 = props2.t(props2.i18nKey, {
    context: props2.context,
    skipInterpolation: !0,
    count: t0
  }), $[0] = props2.context, $[1] = props2.i18nKey, $[2] = props2.t, $[3] = t0, $[4] = t1) : t1 = $[4];
  const translated = t1;
  let t2;
  $[5] !== translated ? (t2 = simpleParser(translated), $[5] = translated, $[6] = t2) : t2 = $[6];
  const tokens = t2, listFormat = useListFormat();
  let t3;
  $[7] !== listFormat ? (t3 = (listValues) => listFormat.format(listValues), $[7] = listFormat, $[8] = t3) : t3 = $[8];
  let t4;
  if ($[9] !== props2.components || $[10] !== props2.values || $[11] !== t3 || $[12] !== tokens) {
    const formatters = {
      list: t3
    };
    t4 = render(tokens, props2.values, props2.components || {}, formatters), $[9] = props2.components, $[10] = props2.values, $[11] = t3, $[12] = tokens, $[13] = t4;
  } else
    t4 = $[13];
  let t5;
  return $[14] !== t4 ? (t5 = /* @__PURE__ */ jsx(Fragment$1, { children: t4 }), $[14] = t4, $[15] = t5) : t5 = $[15], t5;
}
function render(tokens, values2, componentMap, formatters) {
  const [head, ...tail] = tokens;
  if (!head)
    return null;
  if (head.type === "interpolation") {
    const value = values2 ? values2[head.variable] : void 0;
    if (typeof value > "u")
      return `{{${head.variable}}}`;
    const formattedValue = applyFormatters(value, head.formatters || [], formatters);
    return /* @__PURE__ */ jsxs(Fragment$1, { children: [
      formattedValue,
      render(tail, values2, componentMap, formatters)
    ] });
  }
  if (head.type === "text")
    return /* @__PURE__ */ jsxs(Fragment$1, { children: [
      head.text,
      render(tail, values2, componentMap, formatters)
    ] });
  if (head.type === "tagOpen" && head.selfClosing) {
    const Component2 = componentMap[head.name];
    if (!Component2)
      throw new Error(`Component not found: ${head.name}`);
    return /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(Component2, {}),
      render(tail, values2, componentMap, formatters)
    ] });
  }
  if (head.type === "tagOpen" && !head.selfClosing) {
    const nextCloseIdx = tail.findIndex((token) => token.type === "tagClose"), nextClose = tail[nextCloseIdx];
    if (nextClose && head.name !== nextClose.name)
      throw new Error("Nested tags is not allowed");
    const Component2 = componentMap[head.name];
    if (!Component2 && COMPONENT_NAME_RE.test(head.name))
      throw new Error(`Component not defined: ${head.name}`);
    if (!Component2 && !RECOGNIZED_HTML_TAGS.has(head.name))
      throw new Error(`HTML tag "${head.name}" is not allowed`);
    const children = tail.slice(0, nextCloseIdx), remaining = tail.slice(nextCloseIdx + 1), As = Component2 || head.name;
    return /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(As, { children: render(children, values2, componentMap, formatters) }),
      render(remaining, values2, componentMap, formatters)
    ] });
  }
  return null;
}
function applyFormatters(value, formatters, formatterFns) {
  let formattedValue = value;
  for (const formatter of formatters)
    if (formatter === "list")
      if (Array.isArray(value))
        formattedValue = formatterFns.list(value);
      else
        throw new Error("List formatter used on non-array value");
  return `${formattedValue}`;
}
const DEFAULT_API_VERSION = "vX", DEPLOYED_FRONTEND_HOST_STAGING = "https://media.sanity.work", CDN_HOST_STAGING = "https://sanity-cdn.work", API_HOST_STAGING = "https://api.sanity.work", DEPLOYED_FRONTEND_HOST_PRODUCTION = "https://media.sanity.io", CDN_HOST_PRODUCTION = "https://sanity-cdn.com", API_HOST_PRODUCTION = "https://api.sanity.io";
class ProvisionError extends Error {
  // eslint-disable-next-line unicorn/custom-error-definition
  constructor(message, error, code) {
    super(message), this.message = message, this.error = error, this.code = code;
  }
}
function getMediaLibrariesForOrganization(client, organizationId) {
  return client.request({
    uri: `/media-libraries?organizationId=${organizationId}`,
    method: "GET"
  }).pipe(switchMap$1((data) => Array.isArray(data.data) ? from(data.data) : EMPTY$5));
}
function getOrganizationIdFromLibraryId(client, libraryId) {
  return client.request({
    uri: `/media-libraries/${libraryId}`,
    method: "GET"
  }).pipe(concatMap(async (data) => {
    if (data.organizationId)
      return data.organizationId;
    throw new ProvisionError("Library ID not found", "Library ID not found", "ERROR_NO_LIBRARY_FOUND");
  }));
}
function getOrganizationIdFromProjectId(client, projectId) {
  return client.request({
    uri: `/projects/${projectId}`,
    method: "GET"
  }).pipe(concatMap(async (data) => {
    if (data.organizationId)
      return data.organizationId;
    throw new ProvisionError("Organization ID not found", "Organization ID not found", "ERROR_NO_ORGANIZATION_FOUND");
  }));
}
function useEnsureMediaLibrary(props2) {
  const $ = c(11);
  if (props2.from === "library" && !props2.libraryId)
    throw new Error("libraryId is required to fetch organizationId");
  if (props2.from === "project" && !props2.projectId)
    throw new Error("projectId is required to fetch organizationId");
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "v2025-02-19"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0).observable;
  let t1;
  if ($[1] !== client || $[2] !== props2.from || $[3] !== props2.libraryId || $[4] !== props2.projectId) {
    bb0: {
      const handleDefault = defaultIfEmpty({
        status: "inactive"
      }), handleError = catchError$1(_temp$45);
      if (props2.from === "library") {
        let t23;
        $[6] !== props2.libraryId ? (t23 = (organizationId) => ({
          organizationId,
          status: "active",
          id: props2.libraryId
        }), $[6] = props2.libraryId, $[7] = t23) : t23 = $[7], t1 = getOrganizationIdFromLibraryId(client, props2.libraryId).pipe(map$1(t23), handleDefault, handleError);
        break bb0;
      }
      let t22;
      $[8] !== client ? (t22 = (organizationId_0) => getMediaLibrariesForOrganization(client, organizationId_0).pipe(map$1((t3) => {
        const {
          id: id2
        } = t3;
        return {
          organizationId: organizationId_0,
          status: "active",
          id: id2
        };
      })), $[8] = client, $[9] = t22) : t22 = $[9], t1 = getOrganizationIdFromProjectId(client, props2.projectId).pipe(switchMap$1(t22), take(1), handleDefault, handleError);
    }
    $[1] = client, $[2] = props2.from, $[3] = props2.libraryId, $[4] = props2.projectId, $[5] = t1;
  } else
    t1 = $[5];
  const observable = t1;
  let t2;
  return $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    status: "loading"
  }, $[10] = t2) : t2 = $[10], useObservable(observable, t2);
}
function _temp$45(error) {
  if (error instanceof ProvisionError)
    return of({
      status: "error",
      error
    });
  throw error;
}
function EnsureMediaLibrary(props2) {
  const $ = c(20), {
    onSetMediaLibraryIds
  } = props2, {
    t
  } = useTranslation(), {
    id: id2,
    organizationId,
    status,
    error
  } = useEnsureMediaLibrary(props2.mediaLibraryInfo);
  let t0, t1;
  if ($[0] !== id2 || $[1] !== onSetMediaLibraryIds || $[2] !== organizationId || $[3] !== status ? (t0 = () => {
    status === "active" && id2 && organizationId && onSetMediaLibraryIds({
      libraryId: id2,
      organizationId
    });
  }, t1 = [id2, onSetMediaLibraryIds, organizationId, status], $[0] = id2, $[1] = onSetMediaLibraryIds, $[2] = organizationId, $[3] = status, $[4] = t0, $[5] = t1) : (t0 = $[4], t1 = $[5]), useEffect(t0, t1), status === "inactive") {
    let t2;
    $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[6] = t2) : t2 = $[6];
    let t3;
    $[7] !== t ? (t3 = t("asset-sources.media-library.error.no-media-library-provisioned"), $[7] = t, $[8] = t3) : t3 = $[8];
    let t4;
    return $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(Card, { padding: 4, radius: 4, tone: "caution", "data-testid": "media-library-absent-warning", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
      t2,
      /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t3 })
    ] }) }), $[9] = t3, $[10] = t4) : t4 = $[10], t4;
  }
  if (status === "error" && error) {
    const errorCodeTestId = error.code;
    let t2;
    $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[11] = t2) : t2 = $[11];
    let t3;
    $[12] !== error.message || $[13] !== t ? (t3 = error.message || t("asset-sources.media-library.error.library-could-not-be-resolved"), $[12] = error.message, $[13] = t, $[14] = t3) : t3 = $[14];
    let t4;
    $[15] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t3 }), $[15] = t3, $[16] = t4) : t4 = $[16];
    let t5;
    return $[17] !== errorCodeTestId || $[18] !== t4 ? (t5 = /* @__PURE__ */ jsx(Card, { padding: 4, radius: 4, tone: "critical", "data-testid": "media-library-provision-error", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
      t2,
      /* @__PURE__ */ jsx(Stack, { space: 4, "data-testid": errorCodeTestId, children: t4 })
    ] }) }), $[17] = errorCodeTestId, $[18] = t4, $[19] = t5) : t5 = $[19], t5;
  }
  return null;
}
const cachedMediaLibraryIdsMap = /* @__PURE__ */ new Map();
function MediaLibraryProvider(t0) {
  const $ = c(23), {
    projectId,
    libraryId: libraryIdProp,
    children
  } = t0;
  let t1;
  $[0] !== libraryIdProp || $[1] !== projectId ? (t1 = () => projectId && cachedMediaLibraryIdsMap.get(projectId) || libraryIdProp && cachedMediaLibraryIdsMap.get(projectId) || null, $[0] = libraryIdProp, $[1] = projectId, $[2] = t1) : t1 = $[2];
  const [mediaLibraryIds, setMediaLibraryIds] = useState(t1), [unexpectedError, setUnexpectedError] = useState(null), {
    t
  } = useTranslation();
  let t2;
  $[3] !== projectId ? (t2 = (fetchedMediaLibraryIds) => {
    setMediaLibraryIds(fetchedMediaLibraryIds), projectId && cachedMediaLibraryIdsMap.set(projectId, fetchedMediaLibraryIds), cachedMediaLibraryIdsMap.set(fetchedMediaLibraryIds.libraryId, fetchedMediaLibraryIds);
  }, $[3] = projectId, $[4] = t2) : t2 = $[4];
  const handleSetMediaLibraryIds = t2;
  let t3;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (t42) => {
    const {
      error,
      info
    } = t42;
    console.error(error, info), setUnexpectedError(error);
  }, $[5] = t3) : t3 = $[5];
  const handleUnexpectedMediaLibraryError = t3;
  if (unexpectedError) {
    let t42;
    $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[6] = t42) : t42 = $[6];
    let t52;
    $[7] !== t || $[8] !== unexpectedError.message ? (t52 = unexpectedError.message || t("asset-sources.media-library.error.library-could-not-be-resolved"), $[7] = t, $[8] = unexpectedError.message, $[9] = t52) : t52 = $[9];
    let t62;
    return $[10] !== t52 ? (t62 = /* @__PURE__ */ jsx(Card, { padding: 4, radius: 4, tone: "critical", "data-testid": "media-library-provision-error", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
      t42,
      /* @__PURE__ */ jsx(Stack, { space: 4, "data-testid": "MEDIA_LIBRARY_ERROR_UNEXPECTED", children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t52 }) })
    ] }) }), $[10] = t52, $[11] = t62) : t62 = $[11], t62;
  }
  let t4;
  $[12] !== children || $[13] !== handleSetMediaLibraryIds || $[14] !== libraryIdProp || $[15] !== mediaLibraryIds || $[16] !== projectId ? (t4 = mediaLibraryIds ? children : /* @__PURE__ */ jsx(EnsureMediaLibrary, { mediaLibraryInfo: libraryIdProp ? {
    from: "library",
    libraryId: libraryIdProp
  } : {
    from: "project",
    projectId
  }, onSetMediaLibraryIds: handleSetMediaLibraryIds }), $[12] = children, $[13] = handleSetMediaLibraryIds, $[14] = libraryIdProp, $[15] = mediaLibraryIds, $[16] = projectId, $[17] = t4) : t4 = $[17];
  let t5;
  $[18] !== t4 ? (t5 = /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: handleUnexpectedMediaLibraryError, children: t4 }), $[18] = t4, $[19] = t5) : t5 = $[19];
  let t6;
  return $[20] !== mediaLibraryIds || $[21] !== t5 ? (t6 = /* @__PURE__ */ jsx(MediaLibraryIdsContext.Provider, { value: mediaLibraryIds, children: t5 }), $[20] = mediaLibraryIds, $[21] = t5, $[22] = t6) : t6 = $[22], t6;
}
function useToken() {
  const $ = c(3);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: DEFAULT_API_VERSION
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0);
  let t1;
  $[1] !== client ? (t1 = client.config(), $[1] = client, $[2] = t1) : t1 = $[2];
  const {
    token
  } = t1;
  return token;
}
function useAuthType() {
  return useToken() ? "token" : "cookie";
}
function useMediaLibraryIds() {
  return useContext(MediaLibraryIdsContext);
}
function useSanityMediaLibraryConfig() {
  const $ = c(8), workspace = useWorkspace();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: DEFAULT_API_VERSION
  }, $[0] = t0) : t0 = $[0];
  const isStaging2 = useClient(t0).config().apiHost.endsWith("sanity.work"), appHost = workspace.mediaLibrary?.__internal?.frontendHost ?? (isStaging2 ? DEPLOYED_FRONTEND_HOST_STAGING : DEPLOYED_FRONTEND_HOST_PRODUCTION), env = isStaging2 ? "staging" : "production", t1 = isStaging2 ? CDN_HOST_STAGING : CDN_HOST_PRODUCTION, t2 = isStaging2 ? API_HOST_STAGING : API_HOST_PRODUCTION;
  let t3;
  $[1] !== appHost || $[2] !== t1 || $[3] !== t2 ? (t3 = {
    cdn: t1,
    app: appHost,
    api: t2
  }, $[1] = appHost, $[2] = t1, $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== env || $[6] !== t3 ? (t4 = {
    __internal: {
      apiVersion: DEFAULT_API_VERSION,
      appBasePath: "",
      hosts: t3,
      env
    }
  }, $[5] = env, $[6] = t3, $[7] = t4) : t4 = $[7], t4;
}
function usePluginFrameUrl(path, params) {
  const $ = c(2), pluginConfig = useSanityMediaLibraryConfig(), mediaLibraryIds = useMediaLibraryIds(), appHost = pluginConfig.__internal.hosts.app, appBasePath = pluginConfig.__internal.appBasePath;
  let t0;
  $[0] !== params ? (t0 = encodeJsonParams(params), $[0] = params, $[1] = t0) : t0 = $[1];
  const encodedParams = t0;
  return `${appHost}${appBasePath}/${mediaLibraryIds?.organizationId}/${mediaLibraryIds?.libraryId}${path}?createPluginView=${encodedParams}`;
}
const usePluginPostMessage = (origin, handleMessage) => {
  const $ = c(11), token = useToken(), [iframe, setIframe] = useState(null);
  let t0;
  $[0] !== iframe || $[1] !== origin ? (t0 = (message) => {
    iframe?.contentWindow && iframe.contentWindow?.postMessage(message, origin);
  }, $[0] = iframe, $[1] = origin, $[2] = t0) : t0 = $[2];
  const postFn = t0;
  let t1, t2;
  $[3] !== handleMessage || $[4] !== iframe || $[5] !== postFn || $[6] !== token ? (t1 = () => {
    const handler = (event) => {
      iframe && event.source === iframe?.contentWindow && (event.data.type === "tokenRequest" && postFn({
        type: "tokenResponse",
        token: token || null
      }), handleMessage && handleMessage(event.data, postFn));
    };
    return window.addEventListener("message", handler, !1), () => {
      window.removeEventListener("message", handler, !1);
    };
  }, t2 = [handleMessage, iframe, postFn, token], $[3] = handleMessage, $[4] = iframe, $[5] = postFn, $[6] = token, $[7] = t1, $[8] = t2) : (t1 = $[7], t2 = $[8]), useEffect(t1, t2);
  let t3;
  return $[9] !== postFn ? (t3 = {
    postMessage: postFn,
    setIframe
  }, $[9] = postFn, $[10] = t3) : t3 = $[10], t3;
}, AppDialog = styled(Dialog).withConfig({
  displayName: "AppDialog",
  componentId: "sc-1t320i6-0"
})`padding:1.5rem;[data-ui='Card']:first-child{flex:1;}`, defaultStyle = {
  display: "flex",
  width: "100%",
  height: "100%",
  flexDirection: "column",
  overflow: "hidden"
}, hiddenStyle = {
  display: "none"
}, Iframe = forwardRef(function(props2, forwardedRef) {
  const $ = c(7), {
    src,
    hidden
  } = props2, t0 = hidden ? hiddenStyle : defaultStyle;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    overflow: "hidden",
    flexGrow: 1,
    border: "none",
    margin: 0,
    padding: 0,
    height: "100%",
    width: "100%"
  }, $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== forwardedRef || $[2] !== src ? (t2 = /* @__PURE__ */ jsx("iframe", { ref: forwardedRef, src, style: t1 }), $[1] = forwardedRef, $[2] = src, $[3] = t2) : t2 = $[3];
  let t3;
  return $[4] !== t0 || $[5] !== t2 ? (t3 = /* @__PURE__ */ jsx(Card, { style: t0, children: t2 }), $[4] = t0, $[5] = t2, $[6] = t3) : t3 = $[6], t3;
});
function OpenInSourceDialog(props2) {
  const $ = c(35), {
    asset,
    dialogHeaderTitle,
    onClose,
    onSelectNewAsset,
    selectNewAssetButtonLabel
  } = props2, theme = useTheme(), {
    t
  } = useTranslation(), {
    dark
  } = theme.sanity.color, appHost = useSanityMediaLibraryConfig().__internal.hosts.app, authType = useAuthType(), sourceAssetId = asset.source?.id, t0 = dark ? "dark" : "light";
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== authType || $[2] !== t0 ? (t2 = {
    scheme: t0,
    auth: authType,
    disableNavigation: !0,
    selectAssetTypes: t1,
    selectionType: "single"
  }, $[1] = authType, $[2] = t0, $[3] = t2) : t2 = $[3];
  const params = t2, iframeUrl = usePluginFrameUrl(`/assets/${sourceAssetId}`, params);
  let t3;
  $[4] !== onClose ? (t3 = (message) => {
    message.type === "pageUnloaded" && onClose();
  }, $[4] = onClose, $[5] = t3) : t3 = $[5];
  const handlePluginMessage = t3, {
    setIframe
  } = usePluginPostMessage(appHost, handlePluginMessage);
  if (!sourceAssetId)
    return console.warn("Cannot open asset in source: missing asset source id", {
      asset
    }), null;
  let t4;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    position: "relative",
    minHeight: "2dvh"
  }, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== onSelectNewAsset || $[8] !== selectNewAssetButtonLabel ? (t5 = /* @__PURE__ */ jsx(Button, { onClick: onSelectNewAsset, text: selectNewAssetButtonLabel, size: "large", tone: "neutral" }), $[7] = onSelectNewAsset, $[8] = selectNewAssetButtonLabel, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t ? (t6 = t("asset-source.dialog.button.cancel"), $[10] = t, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== onClose || $[13] !== t6 ? (t7 = /* @__PURE__ */ jsx(Button, { mode: "bleed", onClick: onClose, text: t6, size: "large" }), $[12] = onClose, $[13] = t6, $[14] = t7) : t7 = $[14];
  let t8;
  $[15] !== t ? (t8 = t("asset-sources.media-library.open-in-source-dialog.button.done"), $[15] = t, $[16] = t8) : t8 = $[16];
  let t9;
  $[17] !== onClose || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsx(Button, { onClick: onClose, text: t8, size: "large", tone: "primary" }), $[17] = onClose, $[18] = t8, $[19] = t9) : t9 = $[19];
  let t10;
  $[20] !== t7 || $[21] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "center", children: [
    t7,
    t9
  ] }), $[20] = t7, $[21] = t9, $[22] = t10) : t10 = $[22];
  let t11;
  $[23] !== t10 || $[24] !== t5 ? (t11 = /* @__PURE__ */ jsx(Card, { width: "full", height: "fill", padding: 3, shadow: 1, style: t4, children: /* @__PURE__ */ jsxs(Flex, { width: "full", gap: 3, align: "center", justify: "space-between", children: [
    t5,
    t10
  ] }) }), $[23] = t10, $[24] = t5, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = {
    position: "absolute",
    inset: 0,
    borderTop: "1px solid",
    borderColor: "var(--card-border-color)",
    overflow: "hidden",
    display: "flex"
  }, $[26] = t12) : t12 = $[26];
  let t13;
  $[27] !== iframeUrl || $[28] !== setIframe ? (t13 = /* @__PURE__ */ jsx(Box, { style: t12, children: /* @__PURE__ */ jsx(Iframe, { ref: setIframe, src: iframeUrl }) }), $[27] = iframeUrl, $[28] = setIframe, $[29] = t13) : t13 = $[29];
  let t14;
  return $[30] !== dialogHeaderTitle || $[31] !== onClose || $[32] !== t11 || $[33] !== t13 ? (t14 = /* @__PURE__ */ jsx(AppDialog, { header: dialogHeaderTitle, id: "media-library-plugin-dialog-open-in-source", onClose, onClickOutside: onClose, open: !0, "data-testid": "media-library-plugin-dialog-open-in-source", width: 3, footer: t11, children: t13 }), $[30] = dialogHeaderTitle, $[31] = onClose, $[32] = t11, $[33] = t13, $[34] = t14) : t14 = $[34], t14;
}
const AddedVersion = defineEvent({
  name: "Version Document Added to Release ",
  version: 1,
  description: "User added a document to a release"
}), CreatedRelease = defineEvent({
  name: "Release Created",
  version: 1,
  description: "User created a release"
}), DeletedRelease = defineEvent({
  name: "Release Deleted",
  version: 1,
  description: "User deleted a release"
}), PublishedRelease = defineEvent({
  name: "Release Published",
  version: 1,
  description: "User published a release"
}), ScheduledRelease = defineEvent({
  name: "Release Scheduled",
  version: 1,
  description: "User scheduled a release"
}), UnscheduledRelease = defineEvent({
  name: "Release Unscheduled",
  version: 1,
  description: "User unscheduled a release"
}), ArchivedRelease = defineEvent({
  name: "Release Archived",
  version: 1,
  description: "User archived a release"
}), UnarchivedRelease = defineEvent({
  name: "Release Unarchived",
  version: 1,
  description: "User unarchived a release"
}), RevertRelease = defineEvent({
  name: "Release Reverted",
  version: 1,
  description: "User reverted a release"
}), DuplicatedRelease = defineEvent({
  name: "Release Duplicated",
  version: 1,
  description: "User duplicated a release"
}), ReleaseLinkCopied = defineEvent({
  name: "Release Link Copied",
  version: 1,
  description: "User copied release link to clipboard"
}), ReleaseIdCopied = defineEvent({
  name: "Release ID Copied",
  version: 1,
  description: "User copied release ID to clipboard"
}), ReleaseTitleCopied = defineEvent({
  name: "Release Title Copied",
  version: 1,
  description: "User copied release title to clipboard"
}), ChipButtonContainer = styled.span.withConfig({
  displayName: "ChipButtonContainer",
  componentId: "sc-1avgrhw-0"
})`display:inline-flex;--border-color:var(--card-border-color);`, ChipButton = styled(Button$1).withConfig({
  displayName: "ChipButton",
  componentId: "sc-1avgrhw-1"
})`flex:none;transition:none;cursor:pointer;--card-border-color:var(--border-color);`, Chip = forwardRef(function(props2, ref) {
  const $ = c(3);
  let t0;
  return $[0] !== props2 || $[1] !== ref ? (t0 = /* @__PURE__ */ jsx(ChipButtonContainer, { children: /* @__PURE__ */ jsx(ChipButton, { ref, paddingY: 2, paddingLeft: 2, paddingRight: 3, space: 2, radius: "full", ...props2 }) }), $[0] = props2, $[1] = ref, $[2] = t0) : t0 = $[2], t0;
});
function usePerspective() {
  const context = useContext(PerspectiveContext);
  if (!context)
    throw new Error("usePerspective must be used within a PerspectiveProvider");
  return context;
}
const emptyRender = () => /* @__PURE__ */ jsx(Fragment, {});
function _createMiddlewareComponent(DefaultComponent2, middlewareComponents) {
  function MiddlewareComponent(outerProps) {
    const $ = c(4);
    let next = _temp10;
    if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
      for (const Middleware of middlewareComponents) {
        const renderDefault = next;
        next = (props_0) => /* @__PURE__ */ jsx(Middleware, { ...props_0, renderDefault });
      }
      $[0] = next;
    } else
      next = $[0];
    let t0;
    $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Skeleton, { padding: 3, radius: 1, animated: !0 }), $[1] = t0) : t0 = $[1];
    let t1;
    return $[2] !== outerProps ? (t1 = /* @__PURE__ */ jsx(Suspense, { fallback: t0, children: next({
      ...outerProps,
      renderDefault: emptyRender
    }) }), $[2] = outerProps, $[3] = t1) : t1 = $[3], t1;
  }
  function _temp10(props2) {
    return /* @__PURE__ */ jsx(DefaultComponent2, { ...props2 });
  }
  return MiddlewareComponent;
}
function useMiddlewareComponents(props2) {
  const $ = c(4), {
    options
  } = useSource().__internal, {
    defaultComponent,
    pick: pick2
  } = props2;
  let t0;
  if ($[0] !== defaultComponent || $[1] !== options || $[2] !== pick2) {
    const flattened = [...flattenConfig(options, [])];
    flattened.reverse();
    const result = flattened.map((t1) => {
      const {
        config
      } = t1;
      return pick2(config);
    }).filter(Boolean);
    t0 = _createMiddlewareComponent(defaultComponent, result), $[0] = defaultComponent, $[1] = options, $[2] = pick2, $[3] = t0;
  } else
    t0 = $[3];
  return t0;
}
function isBlockType(type) {
  return type.type ? isBlockType(type.type) : type.name === "block";
}
function isArrayOfObjectsFieldMember(member) {
  return member.kind === "field" && member.field.schemaType.jsonType === "array";
}
const rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reKeySegment = /_key\s*==\s*['"](.*)['"]/;
function pathToString$1(path) {
  if (!Array.isArray(path))
    throw new Error("Path is not an array");
  return path.reduce((target, segment, i) => {
    if (isIndexSegment(segment))
      return `${target}[${segment}]`;
    if (isKeySegment(segment) && segment._key)
      return `${target}[_key=="${segment._key}"]`;
    if (isIndexTuple(segment)) {
      const [from2, to] = segment;
      return `${target}[${from2}:${to}]`;
    }
    if (typeof segment == "string")
      return `${target}${i === 0 ? "" : "."}${segment}`;
    throw new Error(`Unsupported path segment \`${JSON.stringify(segment)}\``);
  }, "");
}
function getValueAtPath(rootValue, path) {
  const segment = path[0];
  if (typeof segment > "u")
    return rootValue;
  const tail = path.slice(1);
  if (isIndexSegment(segment))
    return getValueAtPath(Array.isArray(rootValue) ? rootValue[segment] : void 0, tail);
  if (isKeySegment(segment))
    return getValueAtPath(Array.isArray(rootValue) ? rootValue.find((item) => item._key === segment._key) : void 0, tail);
  if (typeof segment == "string")
    return getValueAtPath(isRecord$4(rootValue) ? rootValue[segment] : void 0, tail);
  throw new Error(`Unknown segment type ${JSON.stringify(segment)}`);
}
function findIndex(array, segment) {
  return typeof segment != "number" && !isKeySegment(segment) ? -1 : typeof segment == "number" ? segment : array.findIndex((item) => isKeyedObject(item) && item._key === segment._key);
}
function stringToPath(path) {
  const segments = path.match(rePropName);
  if (!segments)
    throw new Error("Invalid path string");
  return segments.map(normalizePathSegment$1);
}
function normalizePathSegment$1(segment) {
  return isIndexSegment(segment) ? normalizeIndexSegment(segment) : isKeySegment(segment) ? normalizeKeySegment(segment) : isIndexTuple(segment) ? normalizeIndexTupleSegment(segment) : segment;
}
function normalizeIndexSegment(segment) {
  return Number(segment.replace(/[^\d]/g, ""));
}
function normalizeKeySegment(segment) {
  const segments = segment.match(reKeySegment);
  if (!segments)
    throw new Error("Invalid key segment");
  return {
    _key: segments[1]
  };
}
function normalizeIndexTupleSegment(segment) {
  const [from2, to] = segment.split(":").map((seg) => seg === "" ? seg : Number(seg));
  return [from2, to];
}
function pathsAreEqual(pathA, pathB) {
  return pathA.length !== pathB.length ? !1 : pathA.every((segmentA, index) => {
    const segmentB = pathB[index];
    return isKeySegment(segmentA) && isKeySegment(segmentB) ? segmentA._key === segmentB._key : isIndexSegment(segmentA) ? Number(segmentA) === Number(segmentB) : isIndexTuple(segmentA) && isIndexTuple(segmentB) ? segmentA[0] === segmentB[0] && segmentA[1] === segmentB[1] : segmentA === segmentB;
  });
}
function getItemKey(arrayItem) {
  return isKeyedObject(arrayItem) ? arrayItem._key : void 0;
}
function getItemKeySegment(arrayItem) {
  const key = getItemKey(arrayItem);
  return key ? {
    _key: key
  } : void 0;
}
function isEmptyObject$1(item) {
  return typeof item == "object" && item !== null && Object.keys(item).length <= 0;
}
function getAnnotationColor(colorManager, annotation) {
  return colorManager.get(annotation?.author || null);
}
function getAnnotationAtPath(diff, diffPath) {
  const path = Array.isArray(diffPath) ? diffPath : stringToPath(diffPath);
  return getAnnotationAt(diff, path);
}
function getDiffAtPath(diff, diffPath) {
  const path = Array.isArray(diffPath) ? diffPath : stringToPath(diffPath);
  return getDiffAt(diff, path);
}
function getAnnotationAt(diff, path) {
  const diffAt = getDiffAt(diff, path);
  if (diffAt && diffAt.action !== "unchanged")
    return diffAt.annotation || void 0;
}
function getDiffAt(diff, path, parentPath = []) {
  if (path.length === 0)
    return diff;
  const segment = path[0], tail = path.slice(1);
  if (isIndexTuple(segment))
    throw new Error("Index tuples are not supported in diff paths");
  if (isIndexSegment(segment) || isKeySegment(segment)) {
    const location2 = isIndexSegment(segment) ? `at index ${segment}` : `with key ${segment._key}`;
    if (diff.type !== "array") {
      `${location2}${pathToString$1(parentPath)}`;
      return;
    }
    const itemDiff = diff.items.find(isIndexSegment(segment) ? (item) => item.toIndex === segment : (item) => itemMatchesKey(item, segment));
    if (!itemDiff) {
      `${location2}${pathToString$1(parentPath)}`;
      return;
    }
    return getDiffAt(itemDiff.diff, tail, parentPath.concat(segment));
  }
  if (diff.type !== "object") {
    `${segment}${pathToString$1(parentPath)}`;
    return;
  }
  const fieldDiff = diff.fields[segment];
  if (typeof fieldDiff > "u") {
    `${segment}${pathToString$1(parentPath)}`;
    return;
  }
  return getDiffAt(fieldDiff, tail, parentPath.concat(segment));
}
function itemMatchesKey(item, key) {
  const itemDiff = item.diff;
  return itemDiff.type !== "object" || !itemDiff.toValue ? !1 : itemDiff.toValue._key === key;
}
function visitDiff(diff, visitor, path = []) {
  if (visitor(diff, path)) {
    if (diff.type === "array") {
      visitArrayDiff(diff, visitor, path);
      return;
    }
    if (diff.type === "object") {
      visitObjectDiff(diff, visitor, path);
      return;
    }
    diff.type === "string" && visitStringDiff(diff, visitor, path);
  }
}
function visitArrayDiff(diff, visitor, path) {
  diff.action !== "unchanged" && diff.items.forEach((itemDiff) => {
    const _key = itemDiff.diff.type === "object" && itemDiff.diff.toValue?._key, segment = _key ? {
      _key
    } : getItemDiffIndex(itemDiff);
    visitDiff(itemDiff.diff, visitor, path.concat(segment));
  });
}
function visitObjectDiff(diff, visitor, path) {
  diff.action !== "unchanged" && Object.keys(diff.fields).forEach((fieldName) => {
    const fieldDiff = diff.fields[fieldName];
    visitDiff(fieldDiff, visitor, path.concat(fieldName));
  });
}
function visitStringDiff(diff, visitor, path) {
  diff.action !== "unchanged" && diff.segments.forEach((segment) => {
    visitDiff(segment, visitor, path);
  });
}
function getItemDiffIndex(itemDiff) {
  return typeof itemDiff.toIndex > "u" ? itemDiff.fromIndex || 0 : itemDiff.toIndex;
}
function useUserColorManager() {
  const userColorManager = useContext(UserColorManagerContext);
  if (!userColorManager)
    throw new Error("UserColorManager: missing context value");
  return userColorManager;
}
function useUserColor(userId) {
  const $ = c(5), manager = useUserColorManager();
  let t0;
  $[0] !== manager || $[1] !== userId ? (t0 = userId ? manager.listen(userId) : EMPTY$5, $[0] = manager, $[1] = userId, $[2] = t0) : t0 = $[2];
  const observable = t0;
  let t1;
  return $[3] !== manager ? (t1 = manager.get(null), $[3] = manager, $[4] = t1) : t1 = $[4], useObservable(observable, t1);
}
const DEFAULT_CURRENT_USER_HUE = "purple", USER_COLOR_EXCLUDE_HUES = ["green", "red", "gray"], defaultHues = COLOR_HUES.filter((hue) => !USER_COLOR_EXCLUDE_HUES.includes(hue)), getTints = (scheme) => {
  const isDarkScheme = scheme === "dark";
  return {
    background: isDarkScheme ? "900" : "100",
    border: isDarkScheme ? "700" : "300",
    text: isDarkScheme ? "200" : "700"
  };
}, getDefaultColors = (scheme) => {
  const {
    background,
    border,
    text
  } = getTints(scheme);
  return defaultHues.reduce((colors, hue) => (colors[hue] = {
    name: hue,
    background: hues[hue][background].hex,
    border: hues[hue][border].hex,
    text: hues[hue][text].hex,
    tints: hues[hue]
  }, colors), {});
}, getAnonymousColor = (scheme) => {
  const {
    background,
    border,
    text
  } = getTints(scheme);
  return {
    name: "gray",
    background: hues.gray[background].hex,
    border: hues.gray[border].hex,
    text: hues.gray[text].hex,
    tints: hues.gray
  };
};
function createUserColorManager(options) {
  const {
    anonymousColor: anonymousColorProp,
    colors,
    currentUserColor: currentUserColorProp,
    scheme
  } = options, userColors = colors || getDefaultColors(scheme), anonymousColor = anonymousColorProp || getAnonymousColor(scheme), currentUserColor = currentUserColorProp || DEFAULT_CURRENT_USER_HUE;
  if (!userColors.hasOwnProperty(currentUserColor))
    throw new Error(`'colors' must contain 'currentUserColor' (${currentUserColor})`);
  const userColorKeys = Object.keys(userColors), subscriptions = /* @__PURE__ */ new Map(), previouslyAssigned = /* @__PURE__ */ new Map(), assignedCounts = userColorKeys.reduce((counts, color) => (counts[color] = 0, counts), {}), assigned = /* @__PURE__ */ new Map();
  let currentUserId;
  return options?.userStore && options.userStore.me.subscribe((user) => setCurrentUser(user ? user.id : null)), {
    get: get2,
    listen: listen2
  };
  function get2(userId) {
    return userId ? userColors[getUserHue(userId)] : anonymousColor;
  }
  function getUserHue(userId) {
    if (userId === currentUserId)
      return currentUserColor;
    const assignedHue = assigned.get(userId);
    if (assignedHue)
      return assignedHue;
    const prevHue = previouslyAssigned.get(userId);
    if (prevHue && (assignedCounts[prevHue] === 0 || !hasUnusedColor()))
      return assignHue(userId, prevHue);
    const preferredHue = getPreferredHue(userId);
    return assignedCounts[preferredHue] === 0 ? assignHue(userId, preferredHue) : assignHue(userId, getLeastUsedHue(prevHue));
  }
  function listen2(userId) {
    let subscription = subscriptions.get(userId);
    if (subscription)
      return subscription;
    const hue = getUserHue(userId);
    return subscription = getObservableColor(userId, hue), subscriptions.set(userId, subscription), subscription;
  }
  function assignHue(userId, hue) {
    return assigned.set(userId, hue), previouslyAssigned.set(userId, hue), assignedCounts[hue]++, hue;
  }
  function unassignHue(userId, hue) {
    assigned.delete(userId), assignedCounts[hue]--;
  }
  function getUnusedColor() {
    return userColorKeys.find((colorHue) => assignedCounts[colorHue] === 0);
  }
  function hasUnusedColor() {
    return !!getUnusedColor();
  }
  function getLeastUsedHue(tieBreakerPreference) {
    let leastUses = 1 / 0, leastUsed = [];
    return userColorKeys.forEach((colorHue) => {
      const uses = assignedCounts[colorHue];
      uses === leastUses ? leastUsed.push(colorHue) : uses < leastUses && (leastUses = uses, leastUsed = [colorHue]);
    }), tieBreakerPreference && leastUsed.includes(tieBreakerPreference) ? tieBreakerPreference : leastUsed[0];
  }
  function getObservableColor(userId, hue) {
    return new Observable((subscriber) => {
      const userColor = userColors[hue];
      return subscriber.next(userColor), () => {
        subscriptions.delete(userId), unassignHue(userId, hue);
      };
    }).pipe(shareReplay({
      refCount: !0
    }));
  }
  function setCurrentUser(userId) {
    currentUserId = userId, assignedCounts[currentUserColor] += userId ? 1 : -1;
  }
  function getPreferredHue(userId) {
    let hash2 = 0;
    for (let i = 0; i < userId.length; i++)
      hash2 = (hash2 << 5) - hash2 + userId.charCodeAt(i) | 0;
    return userColorKeys[Math.abs(hash2) % userColorKeys.length];
  }
}
function UserColorManagerProvider(t0) {
  const $ = c(6), {
    children,
    manager: managerFromProps
  } = t0, scheme = useColorSchemeValue();
  let t1;
  $[0] !== managerFromProps || $[1] !== scheme ? (t1 = managerFromProps || createUserColorManager({
    scheme
  }), $[0] = managerFromProps, $[1] = scheme, $[2] = t1) : t1 = $[2];
  const manager = t1;
  let t2;
  return $[3] !== children || $[4] !== manager ? (t2 = /* @__PURE__ */ jsx(UserColorManagerContext.Provider, { value: manager, children }), $[3] = children, $[4] = manager, $[5] = t2) : t2 = $[5], t2;
}
function useAnnotationColor(annotation) {
  const $ = c(3), userColorManager = useUserColorManager();
  let t0;
  return $[0] !== annotation || $[1] !== userColorManager ? (t0 = getAnnotationColor(userColorManager, annotation), $[0] = annotation, $[1] = userColorManager, $[2] = t0) : t0 = $[2], t0;
}
function useDiffAnnotationColor(diff, t0) {
  const $ = c(8);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const path = t1, userColorManager = useUserColorManager();
  let t2;
  $[2] !== diff || $[3] !== path ? (t2 = getAnnotationAtPath(diff, path), $[2] = diff, $[3] = path, $[4] = t2) : t2 = $[4];
  const annotation = t2;
  let t3;
  return $[5] !== annotation || $[6] !== userColorManager ? (t3 = getAnnotationColor(userColorManager, annotation), $[5] = annotation, $[6] = userColorManager, $[7] = t3) : t3 = $[7], t3;
}
function createMemoryStorage() {
  const DB = /* @__PURE__ */ Object.create(null);
  return {
    getKey(key) {
      return DB[key] || null;
    },
    setKey(key, value) {
      DB[key] = value;
    }
  };
}
function tryParse(val) {
  try {
    return JSON.parse(val);
  } catch (err) {
    return console.warn(`Failed to parse settings: ${err.message}`), null;
  }
}
function createLocalStoreStorage() {
  if (!supportsLocalStorage)
    return createMemoryStorage();
  function getKey(key) {
    const val = localStorage.getItem(key);
    return val === null ? null : tryParse(val);
  }
  return {
    getKey,
    setKey: function(key, nextValue) {
      typeof nextValue > "u" || nextValue === null ? localStorage.removeItem(key) : localStorage.setItem(key, JSON.stringify(nextValue));
    }
  };
}
const localStoreStorage = createLocalStoreStorage();
function withLocalStorageSWR(wrappedStore) {
  function getKey(key) {
    return merge(of(localStoreStorage.getKey(key)), wrappedStore.getKey(key).pipe(tap((wrappedStoreValue) => {
      localStoreStorage.setKey(key, wrappedStoreValue);
    }))).pipe(distinctUntilChanged(isEqual$1));
  }
  function setKey2(key, nextValue) {
    return localStoreStorage.setKey(key, nextValue), wrappedStore.setKey(key, nextValue);
  }
  return {
    getKey,
    setKey: setKey2
  };
}
const DEFAULT_STUDIO_CLIENT_OPTIONS = {
  apiVersion: "2025-02-19"
}, DEFAULT_STUDIO_CLIENT_HEADERS = {
  "x-sanity-app": `studio@${SANITY_VERSION}`
}, versionedClient = (client, apiVersion) => apiVersion ? client.withConfig({
  apiVersion
}) : client;
function createServerStorage({
  client: _client
}) {
  const client = _client.withConfig(DEFAULT_STUDIO_CLIENT_OPTIONS), keyValueLoader = new DataLoader(async (keys) => {
    const keyValuePairs = (await client.request({
      uri: `/users/me/keyvalue/${keys.join(",")}`
    }).catch((error) => (console.error("Error fetching data:", error), Array(keys.length).fill(null))) || []).reduce((acc, next) => (next?.key && (acc[next.key] = next.value), acc), {});
    return keys.map((key) => keyValuePairs[key] || null);
  });
  return {
    getKey: (key) => keyValueLoader.load(key),
    setKey: (key, nextValue) => client.request({
      method: "PUT",
      uri: "/users/me/keyvalue",
      body: [{
        key,
        value: nextValue
      }]
    }).then((response) => {
      const pair = response[0];
      return keyValueLoader.clear(pair.key), keyValueLoader.prime(pair.key, pair.value), pair.value;
    }, (error) => (console.error("Error setting data:", error), null))
  };
}
function createServerKeyValueStore({
  client
}) {
  const serverStorage = createServerStorage({
    client
  }), events$ = new Subject();
  function getKey(key) {
    return serverStorage.getKey(key);
  }
  function setKey2(key, value) {
    return events$.next({
      type: "optimistic",
      key,
      value
    }), serverStorage.setKey(key, value).then((storedValue) => (events$.next({
      type: "commit",
      key,
      value: storedValue
    }), storedValue));
  }
  return {
    getKey(key) {
      return concat(getKey(key), events$.pipe(filter((event) => event.key === key), map((event) => event.value), distinctUntilChanged(isEqual$1)));
    },
    setKey: setKey2
  };
}
function createKeyValueStore(options) {
  return withLocalStorageSWR(createServerKeyValueStore(options));
}
class CorsOriginError extends Error {
  constructor({
    projectId,
    isStaging: isStaging2
  }) {
    super("CorsOriginError"), this.name = "CorsOriginError", this.projectId = projectId, this.isStaging = isStaging2;
  }
}
const memStore = {};
function setItem(key, value) {
  supportsLocalStorage ? localStorage[key] = value : memStore[key] = value;
}
function getItem(key) {
  return supportsLocalStorage ? localStorage[key] : memStore[key];
}
function removeItem(key) {
  supportsLocalStorage ? localStorage.removeItem(key) : delete memStore[key];
}
function createBroadcastChannel(namespace) {
  const storageEvents$ = typeof window > "u" ? of() : fromEvent(window, "storage"), storageKey = `__studio_local_storage_messaging_${namespace}`, broadcastedMessages$ = new Subject(), messages$ = merge(broadcastedMessages$, storageEvents$.pipe(filter((event) => event.key === storageKey), map((event) => event.newValue), filter(isNonNullable$2), map((newValue) => JSON.parse(newValue)))).pipe(
    // this is important to ensure all new subscribers get a message on subscribe
    shareReplay(1)
  );
  function broadcast(message) {
    try {
      setItem(storageKey, JSON.stringify(message)), removeItem(storageKey), broadcastedMessages$.next(message);
    } catch {
    }
  }
  return {
    messages: messages$,
    broadcast
  };
}
const GithubRootSvg = /* @__PURE__ */ styled.svg.withConfig({
  displayName: "GithubRootSvg",
  componentId: "sc-1uv6cyh-0"
})(({
  theme
}) => {
  const {
    fg
  } = theme.sanity.color.base;
  return css`
    fill: ${fg};
  `;
}), CustomImage = styled.img.withConfig({
  displayName: "CustomImage",
  componentId: "sc-1uv6cyh-1"
})`height:19px;width:19px;object-fit:contain;`, GithubLogo = () => {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(GithubRootSvg, { width: "1em", height: "1em", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 438.55 438.55", children: /* @__PURE__ */ jsx("path", { d: "M409.13 114.57a218.32 218.32 0 0 0-79.8-79.8Q278.94 5.36 219.27 5.36T109.21 34.77a218.29 218.29 0 0 0-79.8 79.8Q0 165 0 224.63q0 71.67 41.83 128.91t108.06 79.23q7.71 1.43 11.42-2a11.17 11.17 0 0 0 3.69-8.57q0-.86-.14-15.42t-.14-25.41l-6.57 1.14a83.77 83.77 0 0 1-15.85 1 120.73 120.73 0 0 1-19.84-2 44.34 44.34 0 0 1-19.11-8.51 36.23 36.23 0 0 1-12.56-17.6l-2.86-6.57a71.34 71.34 0 0 0-9-14.56q-6.14-8-12.42-10.85l-2-1.43a21 21 0 0 1-3.71-3.43 15.66 15.66 0 0 1-2.57-4q-.86-2 1.43-3.29C61.2 310.42 64 310 68 310l5.71.85q5.71 1.14 14.13 6.85a46.08 46.08 0 0 1 13.85 14.84q6.57 11.71 15.85 17.85t18.7 6.14a81.19 81.19 0 0 0 16.27-1.42 56.78 56.78 0 0 0 12.85-4.29q2.57-19.14 14-29.41a195.49 195.49 0 0 1-29.36-5.13 116.52 116.52 0 0 1-26.83-11.14 76.86 76.86 0 0 1-23-19.13q-9.14-11.42-15-30t-5.8-42.81q0-34.55 22.56-58.82-10.57-26 2-58.24 8.28-2.57 24.55 3.85t23.84 11q7.57 4.56 12.13 7.71a206.2 206.2 0 0 1 109.64 0l10.85-6.85a153.65 153.65 0 0 1 26.26-12.56q15.13-5.71 23.13-3.14 12.84 32.26 2.28 58.24 22.55 24.27 22.56 58.82 0 24.27-5.85 43t-15.12 30a79.82 79.82 0 0 1-23.13 19 116.74 116.74 0 0 1-26.84 11.14 195.29 195.29 0 0 1-29.23 5.07q14.8 12.84 14.81 40.58v60.2a11.37 11.37 0 0 0 3.57 8.56q3.57 3.42 11.28 2 66.24-22 108.07-79.23t41.83-128.91q-.03-59.62-29.43-110.05z" }) }), $[0] = t0) : t0 = $[0], t0;
}, GoogleLogo = () => {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", children: [
    /* @__PURE__ */ jsx("path", { d: "M11 24a13 13 0 0 1 .66-4.08l-7.4-5.66a22.18 22.18 0 0 0 0 19.49l7.4-5.67A13 13 0 0 1 11 24z", fill: "#fbbc05" }),
    /* @__PURE__ */ jsx("path", { d: "M24 11a12.72 12.72 0 0 1 8.1 2.9l6.4-6.4a22 22 0 0 0-34.24 6.75l7.4 5.66A13 13 0 0 1 24 11z", fill: "#ea4335" }),
    /* @__PURE__ */ jsx("path", { d: "M24 37a13 13 0 0 1-12.34-8.92l-7.4 5.66A21.93 21.93 0 0 0 24 46a21 21 0 0 0 14.33-5.48l-7-5.44A13.59 13.59 0 0 1 24 37zm-12.35-8.93l-7.4 5.67 7.4-5.66z", fill: "#34a853" }),
    /* @__PURE__ */ jsx("path", { d: "M44.5 20H24v8.5h11.8a9.91 9.91 0 0 1-4.49 6.58l7 5.44C42.37 36.76 45 31.17 45 24a18.25 18.25 0 0 0-.5-4z", fill: "#4285f4" })
  ] }), $[0] = t0) : t0 = $[0], t0;
};
function CustomLogo(props2) {
  const $ = c(3), {
    provider
  } = props2;
  let t0;
  return $[0] !== provider.logo || $[1] !== provider.name ? (t0 = provider.logo ? /* @__PURE__ */ jsx(CustomImage, { src: provider.logo, alt: `Logo for ${provider.name}` }) : void 0, $[0] = provider.logo, $[1] = provider.name, $[2] = t0) : t0 = $[2], t0;
}
const providerLogos = {
  google: GoogleLogo,
  github: GithubLogo
  // sanity: () => <SanityMonogram data-sanity-icon="" />,
}, SANITY_LAST_USED_PROVIDER_KEY = "sanity:last_used_provider";
async function getProviders({
  client,
  mode,
  providers: customProviders = []
}) {
  if (mode === "replace" && Array.isArray(customProviders))
    return customProviders;
  const {
    providers
  } = await client.request({
    uri: "/auth/providers"
  });
  return typeof customProviders == "function" ? customProviders(providers) : customProviders.length === 0 ? providers : mode === "replace" ? customProviders : providers.filter((official) => customProviders.some((provider) => provider.url !== official.url)).concat(customProviders);
}
function createHrefForProvider({
  loginMethod = "dual",
  projectId,
  url,
  redirectPath
}) {
  const params = new URLSearchParams();
  return params.set("origin", `${window.location.origin}${redirectPath}`), params.set("projectId", projectId), loginMethod === "token" ? params.set("withSid", "true") : params.set("type", loginMethod), `${url}?${params}`;
}
function createLoginComponent({
  getClient: getClient2,
  loginMethod,
  redirectOnSingle,
  ...providerOptions
}) {
  const useClient2 = createHookFromObservableFactory(getClient2);
  function LoginComponent(t0) {
    const $ = c(22), {
      projectId,
      ...props2
    } = t0, redirectPath = props2.redirectPath || props2.basePath || "/";
    let t1;
    $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
      providers: [],
      isLoading: !0
    }, $[0] = t1) : t1 = $[0];
    const [providerData, setProviderData] = useState(t1), [error, setError] = useState(null);
    if (error)
      throw error;
    const [client] = useClient2();
    let t2;
    $[1] !== client ? (t2 = async () => {
      let providers = [];
      if (!client)
        return [];
      try {
        providers = await getProviders({
          client,
          ...providerOptions
        });
      } catch (t32) {
        setError(t32);
      }
      return providers;
    }, $[1] = client, $[2] = t2) : t2 = $[2];
    const getProviderData = t2, getLastUsedProvider = _temp10;
    let t3, t4;
    $[3] !== client || $[4] !== getProviderData ? (t3 = () => {
      client && (async () => {
        const providers_0 = await getProviderData(), lastUsedProvider = getLastUsedProvider(providers_0);
        setProviderData({
          providers: providers_0,
          lastUsedProvider,
          isLoading: !1
        });
      })();
    }, t4 = [client, getLastUsedProvider, getProviderData], $[3] = client, $[4] = getProviderData, $[5] = t3, $[6] = t4) : (t3 = $[5], t4 = $[6]), useEffect(t3, t4);
    const {
      providers: providers_1,
      lastUsedProvider: lastUsedProvider_0,
      isLoading
    } = providerData, redirectUrlForRedirectOnSingle = redirectOnSingle && providers_1?.length === 1 && providers_1?.[0] && createHrefForProvider({
      loginMethod,
      projectId,
      url: providers_1[0].url,
      redirectPath
    }), loading = isLoading || redirectUrlForRedirectOnSingle;
    let t5;
    $[7] !== lastUsedProvider_0?.name ? (t5 = (t62) => {
      const {
        name: name_0
      } = t62;
      return name_0 !== lastUsedProvider_0?.name;
    }, $[7] = lastUsedProvider_0?.name, $[8] = t5) : t5 = $[8];
    const providerList_0 = providers_1.filter(t5);
    if (useEffect(() => {
      redirectUrlForRedirectOnSingle && (window.location.href = redirectUrlForRedirectOnSingle);
    }, [redirectUrlForRedirectOnSingle]), loading) {
      let t62;
      return $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t62 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }), $[9] = t62) : t62 = $[9], t62;
    }
    const T0 = Stack, t6 = 4;
    let t7;
    $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsx(Heading, { align: "center", size: 1, children: "Choose login provider" }), $[10] = t7) : t7 = $[10];
    const T1 = Stack, t8 = lastUsedProvider_0 && /* @__PURE__ */ jsx(LastUsedProviderButton, { provider: lastUsedProvider_0, href: createHrefForProvider({
      loginMethod,
      projectId,
      url: lastUsedProvider_0.url,
      redirectPath
    }) }), T2 = Stack, t9 = 2, t10 = providerList_0?.map((provider, index) => /* @__PURE__ */ jsx(ProviderButton, { provider, href: createHrefForProvider({
      loginMethod,
      projectId,
      url: provider.url,
      redirectPath
    }) }, `${provider.url}_${index}`));
    let t11;
    $[11] !== T2 || $[12] !== t10 ? (t11 = /* @__PURE__ */ jsx(T2, { space: t9, children: t10 }), $[11] = T2, $[12] = t10, $[13] = t11) : t11 = $[13];
    let t12;
    $[14] !== T1 || $[15] !== t11 || $[16] !== t8 ? (t12 = /* @__PURE__ */ jsxs(T1, { children: [
      t8,
      t11
    ] }), $[14] = T1, $[15] = t11, $[16] = t8, $[17] = t12) : t12 = $[17];
    let t13;
    return $[18] !== T0 || $[19] !== t12 || $[20] !== t7 ? (t13 = /* @__PURE__ */ jsxs(T0, { space: t6, children: [
      t7,
      t12
    ] }), $[18] = T0, $[19] = t12, $[20] = t7, $[21] = t13) : t13 = $[21], t13;
  }
  function _temp10(providerList) {
    if (!providerList || providerList.length <= 1)
      return;
    const providerName = localStorage.getItem(SANITY_LAST_USED_PROVIDER_KEY);
    return providerList?.find((t0) => {
      const {
        name
      } = t0;
      return name === providerName;
    });
  }
  return LoginComponent;
}
function LastUsedProviderButton(props2) {
  const $ = c(7);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    width: "100%"
  }, $[0] = t0) : t0 = $[0];
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Badge, { radius: 2, tone: "primary", style: {
    alignSelf: "start",
    marginBottom: "8px"
  }, children: "Last used" }), $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== props2 ? (t2 = /* @__PURE__ */ jsx(ProviderButton, { autoFocus: !0, tone: "primary", ...props2 }), $[2] = props2, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 0, align: "center", style: {
    margin: "13px 0 13px 0"
  }, children: "OR" }), $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== t2 ? (t4 = /* @__PURE__ */ jsxs(Flex, { direction: "column", style: t0, children: [
    t1,
    t2,
    t3
  ] }), $[5] = t2, $[6] = t4) : t4 = $[6], t4;
}
function ProviderButton(t0) {
  const $ = c(15), {
    href,
    provider,
    tone: t1,
    autoFocus: t2
  } = t0, tone = t1 === void 0 ? "default" : t1, autoFocus = t2 === void 0 ? !1 : t2;
  let t3;
  $[0] !== autoFocus ? (t3 = (node) => {
    autoFocus && node?.focus();
  }, $[0] = autoFocus, $[1] = t3) : t3 = $[1];
  const focusRef = t3;
  let t4;
  $[2] !== provider.name ? (t4 = () => {
    localStorage.setItem(SANITY_LAST_USED_PROVIDER_KEY, provider.name);
  }, $[2] = provider.name, $[3] = t4) : t4 = $[3];
  const handleProviderSelect = t4, ProviderLogo = providerLogos[provider.name] || CustomLogo;
  let t5;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    width: "100%"
  }, $[4] = t5) : t5 = $[4];
  let t6;
  $[5] !== ProviderLogo || $[6] !== provider ? (t6 = /* @__PURE__ */ jsx(ProviderLogo, { provider }), $[5] = ProviderLogo, $[6] = provider, $[7] = t6) : t6 = $[7];
  let t7;
  return $[8] !== focusRef || $[9] !== handleProviderSelect || $[10] !== href || $[11] !== provider.title || $[12] !== t6 || $[13] !== tone ? (t7 = /* @__PURE__ */ jsx(Button, { ref: focusRef, as: "a", href, mode: "ghost", size: "large", tone, style: t5, text: provider.title, icon: t6, onClick: handleProviderSelect }), $[8] = focusRef, $[9] = handleProviderSelect, $[10] = href, $[11] = provider.title, $[12] = t6, $[13] = tone, $[14] = t7) : t7 = $[14], t7;
}
const sidPattern = /sid=([^&]{20,})&?/;
function consumeSessionId() {
  if (typeof window > "u" || typeof window.location != "object")
    return null;
  const hash2 = window.location.hash, [, sidParam] = hash2.match(sidPattern) || [];
  if (!sidParam)
    return null;
  const newHash = hash2.replace(sidPattern, ""), newUrl = new URL(window.location.href);
  return newUrl.hash = newHash.length > 1 ? newHash : "", history.replaceState(null, "", newUrl), sidParam;
}
let sessionId$1 = consumeSessionId();
const getSessionId$1 = () => {
  const id2 = sessionId$1;
  return id2 && (sessionId$1 = null), id2;
};
function isAuthStore(maybeStore) {
  return isRecord$4(maybeStore) && "state" in maybeStore && isRecord$4(maybeStore.state) && "subscribe" in maybeStore.state && typeof maybeStore.state.subscribe == "function";
}
function isCookielessCompatibleLoginMethod(loginMethod) {
  return ["dual", "token"].includes(loginMethod);
}
const getStorageKey = (projectId) => {
  if (!projectId) throw new Error("Invalid project id");
  return `__studio_auth_token_${projectId}`;
}, getHashToken = () => {
  if (typeof window > "u" || typeof window.location != "object")
    return null;
  const tokenPattern = /token=([^&]{32,})&?/, [, tokenParam] = window.location.hash.match(tokenPattern) || [];
  if (!tokenParam)
    return null;
  const newHash = window.location.hash.replace(tokenPattern, ""), newUrl = new URL(window.location.href);
  return newUrl.hash = newHash.length > 1 ? newHash : "", history.replaceState(null, "", newUrl), tokenParam;
}, getAuthOptions = (loginMethod, token) => loginMethod === "cookie" ? {
  withCredentials: !0
} : loginMethod === "token" ? token ? {
  token
} : null : token ? {
  token
} : {
  withCredentials: !0
}, getStoredToken = (projectId) => {
  try {
    const item = getItem(getStorageKey(projectId));
    if (!item) return null;
    const {
      token
    } = JSON.parse(item);
    return token && typeof token == "string" ? token : null;
  } catch (err) {
    return console.error(err), null;
  }
}, getToken = (projectId) => {
  const storedToken = getStoredToken(projectId), hashToken = getHashToken();
  return hashToken && (!storedToken || hashToken !== storedToken) ? (saveToken({
    token: hashToken,
    projectId
  }), hashToken) : storedToken || null;
}, clearToken = (projectId) => {
  try {
    removeItem(getStorageKey(projectId));
  } catch (err) {
    console.error("Failed to clear auth token from storage:", err);
  }
}, saveToken = ({
  token,
  projectId
}) => {
  try {
    setItem(getStorageKey(projectId), JSON.stringify({
      token,
      time: (/* @__PURE__ */ new Date()).toISOString()
    }));
  } catch (err) {
    console.error("Failed to save auth token to storage:", err);
  }
}, getCurrentUser = async (client, broadcastToken) => {
  try {
    const user = await client.request({
      uri: "/users/me",
      tag: "users.get-current"
    });
    return typeof user?.id == "string" ? user : null;
  } catch (err) {
    if (err.statusCode === 401)
      return clearToken(client.config().projectId || ""), broadcastToken(null), null;
    if (await client.request({
      uri: "/ping",
      withCredentials: !1,
      tag: "cors-check"
    }).then(
      () => !0,
      // Request succeeded, so likely the CORS origin is disallowed
      () => !1
      // Request failed, so likely a network error of some kind
    ))
      throw new CorsOriginError({
        isStaging: client.config().apiHost.endsWith(".work"),
        projectId: client.config()?.projectId
      });
    if (err.isNetworkError && !err.message && err.request && err.request.url) {
      const host = new URL(err.request.url).host;
      throw new Error(`Unknown network error attempting to reach ${host}`, {
        cause: err
      });
    }
    throw err;
  }
};
function _createAuthStore({
  clientFactory: clientFactoryOption,
  projectId,
  dataset,
  apiHost,
  loginMethod = "dual",
  ...providerOptions
}) {
  const {
    broadcast,
    messages
  } = createBroadcastChannel(`dual_mode_auth_${projectId}`), clientFactory = clientFactoryOption ?? createClient, token$ = messages.pipe(startWith(isCookielessCompatibleLoginMethod(loginMethod) ? getToken(projectId) : null)), hostOptions = {};
  apiHost ? hostOptions.apiHost = apiHost : typeof __SANITY_STAGING__ < "u" && __SANITY_STAGING__ === !0 && (hostOptions.apiHost = "https://api.sanity.work");
  const state$ = token$.pipe(
    // // see above
    // debounce(() => firstMessage),
    map((token) => clientFactory({
      projectId,
      dataset,
      apiVersion: "2021-06-07",
      useCdn: !1,
      ...getAuthOptions(loginMethod, token),
      perspective: "raw",
      requestTagPrefix: "sanity.studio",
      ignoreBrowserTokenWarning: !0,
      allowReconfigure: !1,
      headers: DEFAULT_STUDIO_CLIENT_HEADERS,
      ...hostOptions
    })),
    switchMap((client) => defer(async () => {
      const currentUser = await getCurrentUser(client, broadcast);
      return {
        currentUser,
        client,
        authenticated: !!currentUser
      };
    })),
    distinctUntilChanged((prev, next) => (
      // Only notify subscribers if the the currentUser object has changed.
      // Using isEqual is OK since the currentUser object being a small data structure.
      isEqual$1(prev.currentUser, next.currentUser)
    )),
    shareReplay(1)
  );
  async function handleCallbackUrl() {
    const sessionId2 = getSessionId$1();
    if (!sessionId2) {
      broadcast(loginMethod === "cookie" ? null : getToken(projectId));
      return;
    }
    const requestClient = clientFactory({
      projectId,
      dataset,
      useCdn: !0,
      withCredentials: !0,
      apiVersion: "2021-06-07",
      requestTagPrefix: "sanity.studio",
      headers: DEFAULT_STUDIO_CLIENT_HEADERS,
      ...hostOptions
    });
    let currentUser;
    if ((loginMethod === "dual" || loginMethod === "cookie") && (currentUser = await getCurrentUser(requestClient, broadcast)), currentUser || loginMethod === "cookie") {
      broadcast(null);
      return;
    }
    const token = await tradeSessionForToken(requestClient, sessionId2);
    broadcast(token ?? null);
  }
  async function tradeSessionForToken(client, sessionId2) {
    const {
      token
    } = await client.request({
      method: "GET",
      uri: "/auth/fetch",
      query: {
        sid: sessionId2
      },
      tag: "auth.fetch-token"
    });
    return saveToken({
      token,
      projectId
    }), token;
  }
  async function logout() {
    const token = getToken(projectId), requestClient = clientFactory({
      projectId,
      dataset,
      useCdn: !0,
      ...getAuthOptions(loginMethod, token),
      apiVersion: "2021-06-07",
      requestTagPrefix: "sanity.studio",
      headers: DEFAULT_STUDIO_CLIENT_HEADERS,
      ...hostOptions
    });
    clearToken(projectId), await requestClient.request({
      uri: "/auth/logout",
      method: "POST"
    }), broadcast(null);
  }
  const LoginComponent = createLoginComponent({
    ...providerOptions,
    getClient: () => state$.pipe(map((state) => state.client)),
    loginMethod
  });
  return {
    handleCallbackUrl,
    token: token$,
    state: state$,
    LoginComponent,
    logout
  };
}
function hash$1(value) {
  return typeof value != "object" || value === null ? `${value}` : JSON.stringify(Object.fromEntries(Object.entries(value).sort(([a], [b]) => a.localeCompare(b, "en")).map(([k, v]) => [k, hash$1(v)])));
}
const createAuthStore = memoize$1(_createAuthStore, hash$1);
function createMockAuthStore({
  client,
  currentUser = null
}) {
  return {
    state: of({
      authenticated: !0,
      client,
      currentUser
    })
  };
}
function getProviderTitle(provider) {
  if (provider === "google")
    return "Google";
  if (provider === "github")
    return "GitHub";
  if (provider === "sanity")
    return "Sanity";
  if (provider?.startsWith("saml-"))
    return "SAML/SSO";
}
const onOnline$ = typeof window > "u" ? of({}) : fromEvent(window, "online"), onOffline$ = typeof window > "u" ? of({}) : fromEvent(window, "offline"), expBackoff = (retryCount) => Math.pow(2, retryCount) * 100, CONNECTING = {
  type: "connecting"
}, _callback = observableCallback(), onRetry$ = _callback[0], onRetry = _callback[1], createErrorStatus = ({
  error,
  isOffline,
  attemptNo,
  retryAt
}) => ({
  type: "error",
  error,
  attemptNo,
  isOffline,
  retryAt
});
function createConnectionStatusStore({
  bifur
}) {
  return {
    connectionStatus$: merge(bifur.heartbeats, onOffline$.pipe(mergeMapTo(throwError(new Error("The browser went offline"))))).pipe(map((ts) => ({
      type: "connected",
      lastHeartbeat: ts
    })), catchWithCount((error, successiveErrorsCount, caught) => {
      const timeUntilRetry = Math.min(24e4, expBackoff(successiveErrorsCount)), retryAt = new Date((/* @__PURE__ */ new Date()).getTime() + timeUntilRetry), expiry$ = timer(retryAt), isOffline = !navigator.onLine, initialErrorStatus = createErrorStatus({
        error,
        retryAt,
        isOffline,
        attemptNo: successiveErrorsCount
      }), triggerRetry$ = NEVER.pipe(takeUntil(isOffline ? onOnline$ : merge(expiry$, onOnline$, onRetry$)));
      return concat(of(initialErrorStatus), triggerRetry$.pipe(take$1(1)), caught);
    }), startWith(CONNECTING))
  };
}
const SDK_CHANNEL_NAME = "dashboard/channels/sdk", SDK_NODE_NAME = "dashboard/nodes/sdk";
function createComlinkStore({
  capabilities
}) {
  if (!capabilities.comlink)
    return {};
  const node = createNode({
    name: SDK_NODE_NAME,
    connectTo: SDK_CHANNEL_NAME
  });
  return node.start(), {
    node
  };
}
function isCoreUiRenderingContext(maybeCoreUiRenderingContext) {
  return typeof maybeCoreUiRenderingContext == "object" && maybeCoreUiRenderingContext !== null && "name" in maybeCoreUiRenderingContext && maybeCoreUiRenderingContext.name === "coreUi" && "metadata" in maybeCoreUiRenderingContext && typeof maybeCoreUiRenderingContext.metadata == "object" && maybeCoreUiRenderingContext.metadata !== null && "environment" in maybeCoreUiRenderingContext.metadata && typeof maybeCoreUiRenderingContext.metadata.environment == "string";
}
const INITIAL_URL_SEARCH = typeof location == "object" ? location.search : "", CORE_UI_MODE_NAME = "core-ui", CORE_UI_CONTEXT_SEARCH_PARAM = "_context";
function coreUiRenderingContext(urlSearch = INITIAL_URL_SEARCH) {
  return pipe(switchMap$1((renderingContext) => renderingContext ? of(renderingContext) : of(urlSearch).pipe(distinctUntilChanged$1(), map$1((search2) => new URLSearchParams(search2).get(CORE_UI_CONTEXT_SEARCH_PARAM)), map$1((serializedContext) => {
    if (serializedContext === null)
      return;
    const {
      mode,
      env
    } = JSON.parse(serializedContext), coreUirenderingContext = {
      name: mode === CORE_UI_MODE_NAME ? "coreUi" : void 0,
      metadata: {
        environment: env
      }
    };
    if (isCoreUiRenderingContext(coreUirenderingContext))
      return coreUirenderingContext;
  }), catchError$1((error) => (console.warn("Error parsing rendering context:", error), of(void 0))))));
}
const DEFAULT_RENDERING_CONTEXT = {
  name: "default",
  metadata: {}
};
function defaultRenderingContext() {
  return map$1((renderingContext) => renderingContext ?? DEFAULT_RENDERING_CONTEXT);
}
const capabilitiesByRenderingContext = {
  coreUi: {
    globalUserMenu: !0,
    globalWorkspaceControl: !0,
    comlink: !0
  },
  default: {}
};
function listCapabilities() {
  return map$1((renderingContext) => capabilitiesByRenderingContext[renderingContext.name]);
}
function createRenderingContextStore() {
  const renderingContext = of(void 0).pipe(coreUiRenderingContext(), defaultRenderingContext(), shareReplay$1(1)), capabilities = renderingContext.pipe(listCapabilities(), shareReplay$1(1));
  return {
    renderingContext,
    capabilities
  };
}
const useUserViaUserStore = createHookFromObservableFactory(([userStore, userId]) => from(userStore.getUser(userId).catch((err) => (console.error(err), null))));
function useUser(userId) {
  const $ = c(3), userStore = useUserStore();
  let t0;
  return $[0] !== userId || $[1] !== userStore ? (t0 = [userStore, userId], $[0] = userId, $[1] = userStore, $[2] = t0) : t0 = $[2], useUserViaUserStore(t0);
}
function useCurrentUser() {
  const {
    currentUser
  } = useSource();
  return currentUser;
}
const getUpdatedSnapshot = (bufferedDocument) => {
  const LOCAL = bufferedDocument.LOCAL, HEAD = bufferedDocument.document.HEAD;
  return LOCAL && {
    ...LOCAL,
    _type: (HEAD || LOCAL)._type,
    _rev: (HEAD || LOCAL)._rev,
    _updatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, toSnapshotEvent = (document2) => ({
  type: "snapshot",
  document: document2
}), getDocument = (event) => event.document, createObservableBufferedDocument = (listenerEvent$) => {
  const actions$ = new Subject(), consistency$ = new BehaviorSubject(!0), mutations$ = new Subject(), rebase$ = new Subject(), remoteMutations = new Subject(), commitRequests = new Subject(), createInitialBufferedDocument = (initialSnapshot) => {
    const bufferedDocument = new BufferedDocument(initialSnapshot);
    return bufferedDocument.onMutation = ({
      mutation,
      remote
    }) => {
      mutations$.next({
        type: "mutation",
        document: getUpdatedSnapshot(bufferedDocument),
        mutations: mutation.mutations,
        origin: remote ? "remote" : "local"
      });
    }, bufferedDocument.onRemoteMutation = (mutation) => {
      remoteMutations.next({
        type: "remoteMutation",
        head: bufferedDocument.document.HEAD,
        transactionId: mutation.transactionId,
        timestamp: mutation.timestamp,
        author: mutation.identity,
        effects: mutation.effects
      });
    }, bufferedDocument.onRebase = (edge, nextRemoteMutations, localMutations) => {
      rebase$.next({
        type: "rebase",
        document: edge,
        remoteMutations: nextRemoteMutations,
        localMutations
      });
    }, bufferedDocument.onConsistencyChanged = (isConsistent) => {
      consistency$.next(isConsistent);
    }, bufferedDocument.commitHandler = (commitArg) => commitRequests.next(commitArg), bufferedDocument;
  }, currentBufferedDocument$ = listenerEvent$.pipe(scan((bufferedDocument, listenerEvent) => listenerEvent.type === "snapshot" ? (bufferedDocument && bufferedDocument.commit(), consistency$.next(!0), createInitialBufferedDocument(listenerEvent.document || null)) : bufferedDocument === null ? (console.warn('Ignoring event of type "%s" since buffered document has not yet been set up with snapshot', listenerEvent.type), null) : bufferedDocument, null), filter((bufferedDocument) => bufferedDocument !== null), distinctUntilChanged(), publishReplay(1), refCount()), snapshotAfterSync$ = listenerEvent$.pipe(filter((ev) => ev.type === "mutation"), withLatestFrom(currentBufferedDocument$), map(([mutationEvent, bufferedDocument]) => (bufferedDocument.arrive(new Mutation(mutationEvent)), getUpdatedSnapshot(bufferedDocument)))), actionHandler$ = actions$.pipe(
    withLatestFrom(currentBufferedDocument$),
    tap(([action, bufferedDocument]) => {
      action.type === "mutation" && bufferedDocument.add(new Mutation({
        mutations: action.mutations
      })), action.type === "commit" && bufferedDocument.commit();
    }),
    // We subscribe to this only for the side effects
    mergeMapTo(EMPTY$5),
    share()
  ), emitAction = (action) => actions$.next(action), addMutations = (mutations) => emitAction({
    type: "mutation",
    mutations
  }), addMutation = (mutation) => addMutations([mutation]), commit2 = () => {
    currentBufferedDocument$.pipe(take$1(1), tap((bufferedDocument) => bufferedDocument.commit())).subscribe();
  }, snapshot$ = merge(currentBufferedDocument$.pipe(map((bufferedDocument) => bufferedDocument.LOCAL)), mutations$.pipe(map(getDocument)), rebase$.pipe(map(getDocument)), snapshotAfterSync$).pipe(map(toSnapshotEvent), publishReplay(1), refCount()), remoteSnapshot$ = merge(currentBufferedDocument$.pipe(map((bufferedDocument) => bufferedDocument.document.HEAD), map(toSnapshotEvent)), remoteMutations).pipe(publishReplay(1), refCount());
  return {
    updates$: merge(snapshot$, actionHandler$, mutations$, rebase$),
    consistency$: consistency$.pipe(distinctUntilChanged(), publishReplay(1), refCount()),
    remoteSnapshot$,
    commitRequest$: commitRequests,
    addMutation,
    addMutations,
    commit: commit2
  };
}, prepare = (id2) => (document2) => {
  const {
    _id,
    _rev,
    _updatedAt,
    ...rest
  } = document2;
  return {
    _id: id2,
    ...rest
  };
}, createBufferedDocument = (documentId, listenerEvent$) => {
  const bufferedDocument = createObservableBufferedDocument(listenerEvent$), prepareDoc = prepare(documentId), DELETE = {
    delete: {
      id: documentId
    }
  };
  return {
    events: bufferedDocument.updates$,
    consistency$: bufferedDocument.consistency$,
    remoteSnapshot$: bufferedDocument.remoteSnapshot$,
    commitRequest$: bufferedDocument.commitRequest$,
    patch: (patches) => patches.map((patch2) => ({
      patch: {
        ...patch2,
        id: documentId
      }
    })),
    create: (document2) => ({
      create: prepareDoc(document2)
    }),
    createIfNotExists: (document2) => ({
      createIfNotExists: prepareDoc(document2)
    }),
    createOrReplace: (document2) => ({
      createOrReplace: prepareDoc(document2)
    }),
    delete: () => DELETE,
    mutate: (mutations) => bufferedDocument.addMutations(mutations),
    commit: () => bufferedDocument.commit()
  };
};
function shareReplayLatest(configOrPredicate, config) {
  return _shareReplayLatest(typeof configOrPredicate == "function" ? {
    predicate: configOrPredicate,
    ...config
  } : configOrPredicate);
}
function _shareReplayLatest(config) {
  return (source) => {
    let latest, emitted = !1;
    const {
      predicate,
      ...shareConfig
    } = config, wrapped = source.pipe(tap$1((value) => {
      config.predicate(value) && (emitted = !0, latest = value);
    }), finalize(() => {
      emitted = !1, latest = void 0;
    }), share$1(shareConfig)), emitLatest = new Observable((subscriber) => {
      emitted && subscriber.next(
        // this cast is safe because of the emitted check which asserts that we got T from the source
        latest
      ), subscriber.complete();
    });
    return merge(wrapped, emitLatest);
  };
}
const debug$b = debug$c("sanity:document-store"), DEFAULT_TTL = 12e4, DEFAULT_MAX_ENTRIES = 1e3;
function dedupeListenerEvents({
  ttl = DEFAULT_TTL,
  max: max2 = DEFAULT_MAX_ENTRIES
} = {}) {
  return (input$) => input$.pipe(scan(({
    seen
  }, event) => {
    if (event.type !== "mutation")
      return {
        emit: [event],
        seen
      };
    const key = `${event.transactionId}#${event.documentId}`;
    return seen.has(key) ? (debug$b("Ignoring duplicate listener event: ", key), {
      seen,
      emit: []
    }) : (seen.set(key, null), {
      seen,
      emit: [event]
    });
  }, {
    emit: [],
    seen: new TTLCache({
      ttl,
      max: max2
    })
  }), mergeMap((state) => (
    //  note: if state.emit is an empty array, nothing will be emitted
    state.emit
  )));
}
function discardChainTo(chain, revision) {
  const revisionIndex = chain.findIndex((event) => event.resultRev === revision);
  return split(chain, revisionIndex + 1);
}
function split(array, index) {
  return index < 0 ? [[], array] : [array.slice(0, index), array.slice(index)];
}
function toOrderedChains(events2) {
  const parents = {};
  return events2.forEach((event) => {
    parents[event.resultRev] = events2.find((other) => other.resultRev === event.previousRev);
  }), Object.entries(parents).filter(([, parent]) => !parent).map((orphan) => {
    const [headRev] = orphan;
    let current = events2.find((event) => event.resultRev === headRev);
    const sortedList = [];
    for (; current; )
      sortedList.push(current), current = events2.find((event) => event.previousRev === current?.resultRev);
    return sortedList;
  });
}
const DEFAULT_MAX_BUFFER_SIZE = 20, DEFAULT_DEADLINE_MS = 3e4, EMPTY_ARRAY$x = [];
function sequentializeListenerEvents(options) {
  const {
    resolveChainDeadline = DEFAULT_DEADLINE_MS,
    maxBufferSize = DEFAULT_MAX_BUFFER_SIZE
  } = {};
  return (input$) => input$.pipe(scan((state, event) => {
    if (event.type === "mutation" && !state.base)
      throw new Error("Invalid state. Cannot create a sequence without a base");
    if (event.type === "snapshot")
      return {
        base: {
          revision: event.document?._rev
        },
        buffer: EMPTY_ARRAY$x,
        emitEvents: [event]
      };
    if (event.type === "mutation") {
      const orderedChains = toOrderedChains(state.buffer.concat(event)).map((chain) => {
        const [discarded, rest] = discardChainTo(chain, state.base.revision);
        return discarded.length > 0 && debug$b("Discarded %d mutations already applied to document", discarded.length), rest;
      }), [resolvedChains, _nextBuffer] = partition(orderedChains, (chain) => state.base.revision === chain[0]?.previousRev), nextBuffer = _nextBuffer.flat().toSorted((a, b) => a.messageReceivedAt.localeCompare(b.messageReceivedAt));
      if (resolvedChains.length > 1)
        throw new Error("Expected at most one resolved chain");
      if (resolvedChains.length > 0 && resolvedChains[0].length > 0) {
        const lastMutation = resolvedChains[0].at(-1), nextBaseRevision = (
          // special case: if the mutation deletes the document it technically has  no revision, despite
          // resultRev pointing at a transaction id.
          lastMutation.transition === "disappear" ? void 0 : lastMutation?.resultRev
        );
        return state.buffer.length > 0 && (debug$b("Resolved chain: %s => %s", resolvedChains[0][0].previousRev, resolvedChains[0].at(-1)?.resultRev), nextBuffer.length > 0 ? debug$b("There are still %d unchainable mutations", nextBuffer.length) : debug$b("All chains were resolved")), {
          base: {
            revision: nextBaseRevision
          },
          emitEvents: resolvedChains[0],
          buffer: nextBuffer
        };
      }
      if (nextBuffer.length >= maxBufferSize)
        throw new MaxBufferExceededError(`Too many unchainable mutation events: ${state.buffer.length}`, state);
      return {
        ...state,
        buffer: nextBuffer,
        emitEvents: EMPTY_ARRAY$x
      };
    }
    return {
      ...state,
      emitEvents: [event]
    };
  }, {
    emitEvents: EMPTY_ARRAY$x,
    base: void 0,
    buffer: EMPTY_ARRAY$x
  }), switchMap$1((state) => {
    if (state.buffer.length > 0) {
      const brokenChainStartsAt = new Date(state.buffer[0].messageReceivedAt), nextDeadline = resolveChainDeadline - (Date.now() - brokenChainStartsAt.getTime());
      return debug$b("There are %d listener event(s) that can't be applied in sequence. This could be due to events arriving out of order. Will throw an error if chain can't be resolved within %dms", state.buffer.length, nextDeadline), debug$b("Buffered events: %O", state.buffer), concat(of(state), timer(nextDeadline).pipe(mergeMap(() => throwError(() => new DeadlineExceededError(`Did not resolve chain within a deadline of ${resolveChainDeadline}ms`, state)))));
    }
    return of(state);
  }), mergeMap((state) => state.emitEvents));
}
class OutOfSyncError extends Error {
  /**
   * Attach state to the error for debugging/reporting
   */
  constructor(message, state) {
    super(message), this.name = "OutOfSyncError", this.state = state;
  }
}
class DeadlineExceededError extends OutOfSyncError {
  constructor(message, state) {
    super(message, state), this.name = "DeadlineExceededError";
  }
}
class MaxBufferExceededError extends OutOfSyncError {
  constructor(message, state) {
    super(message, state), this.name = "MaxBufferExceededError";
  }
}
const PENDING_START = {
  type: "pending",
  phase: "begin"
}, PENDING_END = {
  type: "pending",
  phase: "end"
};
function isMutationEvent(msg) {
  return msg.type === "mutation";
}
function isMultiTransactionEvent(msg) {
  return msg.transactionTotalEvents > 1;
}
function allPendingTransactionEventsReceived(listenerEvents) {
  const groupedMutations = groupBy(listenerEvents.filter((ev) => ev.type === "mutation"), (e) => e.transactionId);
  return Object.values(groupedMutations).every((mutations) => mutations.length === mutations[0].transactionTotalEvents);
}
function getPairListener(_client, idPair, options = {}) {
  const {
    publishedId,
    draftId,
    versionId
  } = idPair, client = idPair.versionId ? _client.withConfig(RELEASES_STUDIO_CLIENT_OPTIONS) : _client;
  if (idPair.versionId && getVersionFromId(idPair.versionId) === "published" || idPair.versionId && getVersionFromId(idPair.versionId) === "drafts")
    throw new Error('VersionId cannot be "published" or "drafts"');
  const pairEvents$ = defer(() => client.observable.listen("*[_id in $ids]", {
    ids: [publishedId, draftId, versionId].filter((id2) => typeof id2 < "u")
  }, {
    includeResult: !1,
    includeAllVersions: !0,
    enableResume: !0,
    events: ["welcome", "mutation", "reconnect", "reset", "welcomeback"],
    effectFormat: "mendoza",
    tag: options.tag || "document.pair.listen"
  }).pipe(dedupeListenerEvents(), map((event) => event.type === "mutation" ? {
    ...event,
    // client equivalent of `event.messageDispatchedAt`
    // note: consider moving this to client.listen()
    messageReceivedAt: (/* @__PURE__ */ new Date()).toString()
  } : event), shareReplayLatest({
    predicate: (event) => event.type === "welcome" || event.type === "reconnect" || event.type === "reset" || event.type === "welcomeback"
  }))).pipe(
    concatMap$1((event) => event.type === "reset" || // note: resumability may not be enabled – if so, treat welcome the same way as a reset
    event.type === "welcome" ? fetchInitialDocumentSnapshots().pipe(mergeMap(({
      draft,
      published,
      version: version2
    }) => [createSnapshotEvent(draftId, draft), createSnapshotEvent(publishedId, published), ...versionId ? [createSnapshotEvent(versionId, version2)] : []])) : of(event)),
    scan((acc, msg) => {
      if (!isMutationEvent(msg))
        return {
          next: [msg],
          buffer: []
        };
      const isBuffering = acc.buffer.length > 0, isMulti = isMultiTransactionEvent(msg);
      if (!isMulti && !isBuffering)
        return {
          next: [msg],
          buffer: []
        };
      if (!isMulti)
        return {
          next: [],
          buffer: acc.buffer.concat(msg)
        };
      const nextBuffer = acc.buffer.concat(msg);
      return allPendingTransactionEventsReceived(nextBuffer) ? {
        next: nextBuffer.concat(PENDING_END),
        buffer: []
      } : {
        next: nextBuffer.length === 1 ? [PENDING_START] : [],
        buffer: nextBuffer
      };
    }, {
      next: [],
      buffer: []
    }),
    // note: this flattens the array, and in the case of an empty array, no event will be pushed downstream
    mergeMap((v) => v.next),
    share()
  ), draftEvents$ = pairEvents$.pipe(filter((event) => event.type === "mutation" || event.type === "snapshot" ? event.documentId === draftId : !0), sequentializeListenerEvents()), publishedEvents$ = pairEvents$.pipe(filter((event) => event.type === "mutation" || event.type === "snapshot" ? event.documentId === publishedId : !0), sequentializeListenerEvents()), versionEvents$ = pairEvents$.pipe(filter((event) => event.type === "mutation" || event.type === "snapshot" ? event.documentId === versionId : !0), sequentializeListenerEvents());
  return merge(draftEvents$, publishedEvents$, versionEvents$).pipe(catchError((err, caught$) => err instanceof OutOfSyncError ? (debug$b("Recovering from OutOfSyncError: %s", err.name), typeof options?.onSyncErrorRecovery == "function" ? options?.onSyncErrorRecovery(err) : console.error(err), caught$) : throwError(() => err)));
  function fetchInitialDocumentSnapshots() {
    return client.observable.getDocuments([publishedId, draftId, versionId].filter((id2) => typeof id2 == "string"), {
      tag: "document.pair.fetch"
    }).pipe(map(([published, draft, version2]) => ({
      draft,
      published,
      version: version2
    })));
  }
}
function createSnapshotEvent(documentId, document2) {
  return {
    type: "snapshot",
    documentId,
    document: document2
  };
}
const RELEASES_STUDIO_CLIENT_OPTIONS = {
  apiVersion: "v2025-02-19"
}, isReleasePerspective = (perspective) => !!Array.isArray(perspective), ACTIONS_API_MINIMUM_VERSION = "2025-02-19";
function actionsApiClient(client, idPair) {
  return idPair.versionId ? client.withConfig(RELEASES_STUDIO_CLIENT_OPTIONS) : client.withConfig({
    apiVersion: ACTIONS_API_MINIMUM_VERSION
  });
}
function operationsApiClient(client, idPair) {
  return idPair.versionId ? client.withConfig(RELEASES_STUDIO_CLIENT_OPTIONS) : client;
}
const FETCH_SHARD_TIMEOUT = 2e4, SLOW_COMMIT_TIMEOUT_MS = 5e4, isMutationEventForDocId = (id2) => (event) => (event.type === "snapshot" || event.type === "mutation") && event.documentId === id2;
function setVersion(version2) {
  return (ev) => ({
    ...ev,
    version: version2
  });
}
function requireId(value) {
  if (!value._id)
    throw new Error("Expected document to have an _id");
}
function isLiveEditMutation(mutationParams, publishedId) {
  const {
    resultRev,
    ...mutation
  } = mutationParams;
  return mutation.mutations.flatMap((mut) => {
    const mutationPayloads = Object.values(mut);
    if (mutationPayloads.length > 1)
      throw new Error("Did not expect multiple mutations in the same payload");
    return mutationPayloads[0].id || mutationPayloads[0]._id;
  }).every((target) => target === publishedId);
}
function toActions(idPair, mutationParams) {
  const actions = mutationParams.mutations.flatMap((mutations) => {
    if (mutations.createIfNotExists)
      return [];
    if (mutations.create)
      return requireId(mutations.create), {
        actionType: "sanity.action.document.create",
        publishedId: idPair.publishedId,
        attributes: mutations.create,
        ifExists: "fail"
      };
    if (mutations.patch)
      return {
        actionType: "sanity.action.document.edit",
        draftId: idPair.versionId ?? idPair.draftId,
        publishedId: idPair.publishedId,
        patch: omit(mutations.patch, "id")
      };
    throw new Error("Cannot map mutation to action");
  });
  return actions.length === 0 ? [{
    actionType: "sanity.action.document.edit",
    draftId: idPair.draftId,
    publishedId: idPair.publishedId,
    patch: {
      unset: ["_empty_action_guard_pseudo_field_"]
    }
  }] : actions;
}
function commitActions(client, idPair, mutationParams) {
  return isLiveEditMutation(mutationParams, idPair.publishedId) ? commitMutations(client, idPair, mutationParams) : actionsApiClient(client, idPair).observable.action(toActions(idPair, mutationParams), {
    tag: "document.commit",
    transactionId: mutationParams.transactionId
  });
}
function commitMutations(client, idPair, mutationParams) {
  const {
    resultRev,
    ...mutation
  } = mutationParams;
  return operationsApiClient(client, idPair).dataRequest("mutate", mutation, {
    visibility: "async",
    returnDocuments: !1,
    tag: "document.commit",
    // This makes sure the studio doesn't crash when a draft is crated
    // because someone deleted a referenced document in the target dataset
    skipCrossDatasetReferenceValidation: !0
  });
}
function submitCommitRequest(client, idPair, request, serverActionsEnabled) {
  return from(serverActionsEnabled ? commitActions(client, idPair, request.mutation.params) : commitMutations(client, idPair, request.mutation.params)).pipe(tap({
    error: (error) => {
      "statusCode" in error && typeof error.statusCode == "number" && error.statusCode >= 400 && error.statusCode <= 500 ? request.cancel(error) : request.failure(error);
    },
    next: () => request.success()
  }));
}
function checkoutPair(client, idPair, serverActionsEnabled, options = {}) {
  const {
    publishedId,
    draftId,
    versionId
  } = idPair, {
    onReportLatency,
    onSyncErrorRecovery,
    onSlowCommit,
    tag
  } = options, listenerEvents$ = getPairListener(client, idPair, {
    onSyncErrorRecovery,
    tag
  }).pipe(share()), connectionChangeEvents$ = listenerEvents$.pipe(filter((ev) => ev.type === "reconnect" || ev.type === "welcome" || ev.type === "welcomeback")), draft = createBufferedDocument(draftId, listenerEvents$.pipe(filter(isMutationEventForDocId(draftId)))), version2 = typeof versionId > "u" ? void 0 : createBufferedDocument(versionId, listenerEvents$.pipe(filter(isMutationEventForDocId(versionId)))), published = createBufferedDocument(publishedId, listenerEvents$.pipe(filter(isMutationEventForDocId(publishedId)))), transactionsPendingEvents$ = listenerEvents$.pipe(filter((ev) => ev.type === "pending")), commitRequests$ = merge(draft.commitRequest$, published.commitRequest$, version2 ? version2.commitRequest$ : EMPTY$5).pipe(share()), commits$ = commitRequests$.pipe(mergeMap((commitRequest) => serverActionsEnabled.pipe(take$1(1), mergeMap((canUseServerActions) => submitCommitRequest(client, idPair, commitRequest, canUseServerActions)))), share()), pendingEnd$ = transactionsPendingEvents$.pipe(filter((ev) => ev.phase === "end")), commitResolved$ = merge(pendingEnd$, commits$), slowCommitWarning$ = onSlowCommit ? commitRequests$.pipe(switchMap(() => timer(SLOW_COMMIT_TIMEOUT_MS).pipe(takeUntil(commitResolved$))), tap(() => onSlowCommit())) : EMPTY$5, combinedEvents = defer(() => merge(onReportLatency ? reportLatency({
    commits$,
    listenerEvents$,
    client,
    onReportLatency
  }) : merge(commits$, listenerEvents$), slowCommitWarning$)).pipe(mergeMap(() => EMPTY$5), share());
  return {
    transactionsPendingEvents$,
    draft: {
      ...draft,
      events: merge(combinedEvents, connectionChangeEvents$, draft.events).pipe(map(setVersion("draft"))),
      remoteSnapshot$: draft.remoteSnapshot$.pipe(map(setVersion("draft")))
    },
    ...typeof version2 > "u" ? {} : {
      version: {
        ...version2,
        events: merge(combinedEvents, connectionChangeEvents$, version2.events).pipe(map(setVersion("version"))),
        remoteSnapshot$: version2.remoteSnapshot$.pipe(map(setVersion("version")))
      }
    },
    published: {
      ...published,
      events: merge(combinedEvents, connectionChangeEvents$, published.events).pipe(map(setVersion("published"))),
      remoteSnapshot$: published.remoteSnapshot$.pipe(map(setVersion("published")))
    }
  };
}
function reportLatency(options) {
  const {
    client,
    commits$,
    listenerEvents$,
    onReportLatency
  } = options, shardInfo = fetch(client.getUrl(client.getDataUrl("ping")), {
    signal: AbortSignal.timeout(FETCH_SHARD_TIMEOUT)
  }).then((response) => response.headers.get("X-Sanity-Shard") || void 0).catch(() => {
  }), submittedMutations = commits$.pipe(map((ev) => ({
    type: "submit",
    transactionId: ev.transactionId,
    timestamp: /* @__PURE__ */ new Date()
  })), share()), receivedMutations = listenerEvents$.pipe(filter((ev) => ev.type === "mutation"), map((ev) => ({
    type: "receive",
    transactionId: ev.transactionId,
    timestamp: /* @__PURE__ */ new Date()
  })), share());
  return merge(submittedMutations, receivedMutations).pipe(scan((state, event) => {
    const matchingIndex = state.pending.findIndex((e) => e.transactionId === event.transactionId);
    if (matchingIndex > -1) {
      const matching = state.pending[matchingIndex], [submitEvent, receiveEvent] = matching.type == "submit" ? [matching, event] : [event, matching];
      return {
        event: {
          transactionId: event.transactionId,
          submittedAt: submitEvent.timestamp,
          receivedAt: submitEvent.timestamp,
          deltaMs: receiveEvent.timestamp.getTime() - submitEvent.timestamp.getTime()
        },
        pending: state.pending.toSpliced(matchingIndex, 1)
      };
    }
    return {
      event: void 0,
      pending: state.pending.concat(event)
    };
  }, {
    event: void 0,
    pending: []
  }), map((state) => state.event), filter((event) => !!event), withLatestFrom(shardInfo), tap(([event, shard]) => onReportLatency?.({
    latencyMs: event.deltaMs,
    shard,
    transactionId: event.transactionId
  })));
}
function measureFirstEmission(onMeasured) {
  return (source) => {
    let measured = !1, startTime;
    return source.pipe(tap({
      subscribe: () => {
        measured = !1, startTime = performance.now();
      },
      next: (value) => {
        measured || (measured = !0, onMeasured(performance.now() - startTime, value));
      }
    }));
  };
}
function measureFirstMatch(predicate, onMeasured) {
  return (source) => {
    let measured = !1, startTime;
    return source.pipe(tap({
      subscribe: () => {
        measured = !1, startTime = performance.now();
      },
      next: (value) => {
        !measured && predicate(value) && (measured = !0, onMeasured(performance.now() - startTime, value));
      }
    }));
  };
}
function memoize(fn, keyGen) {
  const MEMO = /* @__PURE__ */ Object.create(null);
  return (...args) => {
    const key = keyGen(...args);
    return key in MEMO || (MEMO[key] = fn(...args)), MEMO[key];
  };
}
function memoizeKeyGen(client, idPair, typeName) {
  const config = client.config();
  return `${config.dataset ?? ""}-${config.projectId ?? ""}-${idPair.publishedId}-${idPair.versionId ?? ""}-${typeName}`;
}
const LISTENER_RESET_DELAY$1 = 5e3, memoizedPair = memoize((client, idPair, _typeName, serverActionsEnabled, pairListenerOptions) => new Observable((subscriber) => {
  const pair = checkoutPair(client, idPair, serverActionsEnabled, pairListenerOptions);
  return merge(
    of(pair),
    // merge in draft, published, and version events to makes sure they receive
    // the events they need for as long as the pair is subscribed to
    pair.draft.events.pipe(mergeMap(() => EMPTY$5)),
    pair.published.events.pipe(mergeMap(() => EMPTY$5)),
    pair.version?.events.pipe(mergeMap(() => EMPTY$5)) ?? EMPTY$5
  ).subscribe(subscriber);
}).pipe(share$1({
  connector: () => new ReplaySubject(1),
  resetOnComplete: !0,
  resetOnRefCountZero: () => timer(LISTENER_RESET_DELAY$1)
})), memoizeKeyGen);
function isSnapshotEvent(event) {
  return event.type === "snapshot";
}
function withSnapshots(pair) {
  return {
    snapshots$: pair.events.pipe(filter(isSnapshotEvent), map((event) => event.document), publishReplay(1), refCount()),
    patch: pair.patch,
    create: pair.create,
    createIfNotExists: pair.createIfNotExists,
    createOrReplace: pair.createOrReplace,
    delete: pair.delete,
    mutate: pair.mutate,
    commit: pair.commit
  };
}
const snapshotPair = memoize((client, idPair, typeName, serverActionsEnabled, pairListenerOptions) => memoizedPair(client, idPair, typeName, serverActionsEnabled, pairListenerOptions).pipe(map(({
  published,
  draft,
  version: version2,
  transactionsPendingEvents$
}) => ({
  transactionsPendingEvents$,
  published: withSnapshots(published),
  draft: withSnapshots(draft),
  ...version2 ? {
    version: withSnapshots(version2)
  } : {}
})), publishReplay(1), refCount()), memoizeKeyGen), isLiveEditEnabled$1 = (schema2, typeName) => schema2.get(typeName)?.liveEdit === !0, swr$2 = createSWR({
  maxSize: 50
}), LOCKED = {
  enabled: !0
}, NOT_LOCKED = {
  enabled: !1
}, editState = memoize((ctx, idPair, typeName) => {
  const liveEditSchemaType = isLiveEditEnabled$1(ctx.schema, typeName), liveEdit = typeof idPair.versionId < "u" || liveEditSchemaType;
  return snapshotPair(ctx.client, idPair, typeName, ctx.serverActionsEnabled, ctx.extraOptions).pipe(switchMap((versions) => combineLatest([versions.draft.snapshots$, versions.published.snapshots$, versions.transactionsPendingEvents$.pipe(map((ev) => ev.phase === "begin" ? LOCKED : NOT_LOCKED), startWith(NOT_LOCKED)), typeof versions.version > "u" ? of(null) : versions.version.snapshots$])), swr$2(`${idPair.publishedId}-${idPair.draftId}-${idPair.versionId}`), measureFirstEmission((durationMs, {
    fromCache,
    value: [draftSnapshot, publishedSnapshot, versionSnapshot]
  }) => {
    ctx.extraOptions?.onDocumentPairLoaded?.({
      durationMs,
      fromCache,
      hasPublished: !!publishedSnapshot,
      hasDraft: !!draftSnapshot,
      hasVersion: !!versionSnapshot
    });
  }), map(({
    value: [draftSnapshot, publishedSnapshot, transactionSyncLock, versionSnapshot],
    fromCache
  }) => ({
    id: idPair.publishedId,
    type: typeName,
    draft: draftSnapshot,
    published: publishedSnapshot,
    version: typeof idPair.versionId > "u" ? null : versionSnapshot,
    liveEdit,
    liveEditSchemaType,
    ready: !fromCache,
    transactionSyncLock: fromCache ? null : transactionSyncLock,
    release: idPair.versionId ? getVersionFromId(idPair.versionId) : void 0
  })), startWith({
    id: idPair.publishedId,
    type: typeName,
    draft: null,
    published: null,
    version: null,
    liveEdit,
    liveEditSchemaType,
    ready: !1,
    transactionSyncLock: null,
    release: idPair.versionId ? getVersionFromId(idPair.versionId) : void 0
  }), publishReplay(1), refCount());
}, (ctx, idPair, typeName) => memoizeKeyGen(ctx.client, idPair, typeName)), consistencyStatus = memoize((client, idPair, typeName, serverActionsEnabled, extraOptions) => memoizedPair(client, idPair, typeName, serverActionsEnabled, extraOptions).pipe(switchMap(({
  draft,
  published
}) => combineLatest([draft.consistency$, published.consistency$])), map(([draftIsConsistent, publishedIsConsistent]) => draftIsConsistent && publishedIsConsistent), distinctUntilChanged(), publishReplay(1), refCount()), memoizeKeyGen), operationArgs = memoize((ctx, idPair, typeName) => snapshotPair(ctx.client, idPair, typeName, ctx.serverActionsEnabled, ctx.pairListenerOptions).pipe(switchMap((versions) => combineLatest([versions.draft.snapshots$, versions.published.snapshots$, ctx.serverActionsEnabled, ...typeof versions.version > "u" ? [] : [versions.version.snapshots$]]).pipe(map(([draft, published, canUseServerActions, version2]) => ({
  ...ctx,
  serverActionsEnabled: canUseServerActions,
  idPair,
  typeName,
  snapshots: {
    published,
    draft,
    ...version2 ? {
      version: version2
    } : {}
  },
  ...versions.version ? {
    version: versions.version
  } : {},
  draft: versions.draft,
  published: versions.published
})))), publishReplay(1), refCount()), (ctx, idPair, typeName) => memoizeKeyGen(ctx.client, idPair, typeName)), commit = {
  disabled: () => !1,
  execute: ({
    draft,
    published,
    version: version2
  }) => (version2?.commit(), draft.commit(), published.commit(), EMPTY$5)
}, del$1 = {
  disabled: ({
    snapshots
  }) => snapshots.draft || snapshots.published ? !1 : "NOTHING_TO_DELETE",
  execute: ({
    client,
    schema: schema2,
    idPair,
    typeName
  }) => {
    const tx = operationsApiClient(client, idPair).observable.transaction().delete(idPair.publishedId);
    return isLiveEditEnabled$1(schema2, typeName) ? tx.commit({
      tag: "document.delete"
    }) : tx.delete(idPair.draftId).commit({
      tag: "document.delete",
      // this disables referential integrity for cross-dataset references. we
      // have this set because we warn against deletes in the `ConfirmDeleteDialog`
      // UI. This operation is run when "delete anyway" is clicked
      skipCrossDatasetReferenceValidation: !0
    });
  }
}, discardChanges$1 = {
  disabled: ({
    snapshots
  }) => snapshots.draft ? snapshots.published ? !1 : "NOT_PUBLISHED" : "NO_CHANGES",
  execute: ({
    client,
    idPair
  }) => operationsApiClient(client, idPair).observable.transaction().delete(idPair.draftId).commit({
    tag: "document.discard-changes"
  })
}, omitProps = ["_createdAt", "_updatedAt"], getDocumentToDuplicateId = ({
  versionSnapshot,
  dupeId,
  liveEdit
}) => {
  if (versionSnapshot) {
    const versionId = getVersionFromId(versionSnapshot._id);
    if (versionId) return getVersionId(dupeId, versionId);
  }
  return liveEdit ? dupeId : getDraftId(dupeId);
}, mapDocumentNoop = (document2) => document2, duplicate = {
  disabled: ({
    snapshots
  }) => snapshots.published || snapshots.draft || snapshots.version ? !1 : "NOTHING_TO_DUPLICATE",
  execute: ({
    schema: schema2,
    client,
    snapshots,
    typeName,
    idPair
  }, dupeId, {
    mapDocument = mapDocumentNoop
  } = {}) => {
    const source = snapshots.version || snapshots.draft || snapshots.published;
    if (!source)
      throw new Error("cannot execute on empty document");
    const _id = getDocumentToDuplicateId({
      versionSnapshot: snapshots.version,
      dupeId,
      liveEdit: isLiveEditEnabled$1(schema2, typeName)
    });
    return operationsApiClient(client, idPair).observable.create(omit(
      mapDocument({
        ...source,
        _id,
        _type: source._type
      }),
      omitProps
      // Performing `Omit` on a type that has an index signature causes the known properties to
      // be lost.
    ), {
      tag: "document.duplicate"
    });
  }
}, patch$1 = {
  disabled: () => !1,
  execute: ({
    schema: schema2,
    snapshots,
    idPair,
    draft,
    published,
    version: version2,
    typeName
  }, patches = [], initialDocument) => {
    if (version2) {
      version2.mutate([version2.createIfNotExists({
        _type: typeName,
        ...initialDocument
      }), ...version2.patch(patches)]);
      return;
    }
    isLiveEditEnabled$1(schema2, typeName) ? published.mutate([published.createIfNotExists({
      _type: typeName,
      ...initialDocument
    }), ...published.patch(patches)]) : draft.mutate([draft.createIfNotExists({
      ...initialDocument,
      ...snapshots.published,
      _id: idPair.draftId,
      _type: typeName
    }), ...draft.patch(patches)]);
  }
};
function strengthenOnPublish(obj) {
  return isReference$1(obj) ? obj._strengthenOnPublish ? omit(obj, ["_strengthenOnPublish"].concat(obj._strengthenOnPublish.weak ? [] : ["_weak"])) : obj : typeof obj != "object" || !obj ? obj : Array.isArray(obj) ? obj.map(strengthenOnPublish) : Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, strengthenOnPublish(value)]));
}
const publish$1 = {
  disabled: ({
    schema: schema2,
    typeName,
    snapshots
  }) => isLiveEditEnabled$1(schema2, typeName) ? "LIVE_EDIT_ENABLED" : !snapshots.draft && !snapshots.version ? snapshots.published ? "ALREADY_PUBLISHED" : "NO_CHANGES" : !1,
  execute: ({
    client,
    idPair,
    snapshots
  }) => {
    if (!snapshots.draft && !snapshots.version)
      throw new Error('cannot execute "publish" when draft or version is missing');
    const value = strengthenOnPublish(omit(snapshots.draft || snapshots.version, "_updatedAt")), tx = operationsApiClient(client, idPair).observable.transaction();
    return snapshots.published ? (tx.patch(idPair.publishedId, {
      // Hack until other mutations support revision locking
      unset: ["_revision_lock_pseudo_field_"],
      ifRevisionID: snapshots.published._rev
    }), tx.createOrReplace({
      ...value,
      _id: idPair.publishedId
    })) : tx.create({
      ...value,
      _id: idPair.publishedId
    }), tx.delete(value._id), tx.commit({
      tag: "document.publish",
      visibility: "async"
    });
  }
}, restore$2 = {
  disabled: () => !1,
  execute: ({
    historyStore,
    schema: schema2,
    idPair,
    typeName
  }, fromRevision) => {
    const targetId = idPair.versionId ? idPair.versionId : isLiveEditEnabled$1(schema2, typeName) ? idPair.publishedId : idPair.draftId;
    return historyStore.restore(idPair.publishedId, targetId, fromRevision);
  }
}, unpublish$1 = {
  disabled: ({
    schema: schema2,
    snapshots,
    typeName
  }) => isLiveEditEnabled$1(schema2, typeName) ? "LIVE_EDIT_ENABLED" : snapshots.published ? !1 : "NOT_PUBLISHED",
  execute: ({
    client,
    idPair,
    snapshots
  }) => {
    let tx = operationsApiClient(client, idPair).observable.transaction().delete(idPair.publishedId);
    return snapshots.published && (tx = tx.createIfNotExists({
      ...omit(snapshots.published, "_updatedAt"),
      _id: idPair.draftId,
      _type: snapshots.published._type
    })), tx.commit({
      tag: "document.unpublish",
      visibility: "async",
      // this disables referential integrity for cross-dataset references. we
      // have this set because we warn against unpublishes in the `ConfirmDeleteDialog`
      // UI. This operation is run when "unpublish anyway" is clicked
      skipCrossDatasetReferenceValidation: !0
    });
  }
}, del = {
  disabled: ({
    snapshots
  }) => snapshots.draft || snapshots.published || snapshots.version ? !1 : "NOTHING_TO_DELETE",
  execute: ({
    client,
    idPair,
    snapshots
  }, versions = []) => snapshots.published ? actionsApiClient(client, idPair).observable.action({
    actionType: "sanity.action.document.delete",
    includeDrafts: versions ? (
      // if versions are provided, remove the published id from the list, all versions need to be included in order for the delete to work.
      versions.filter((v) => !isPublishedId(v))
    ) : snapshots.draft ? [idPair.draftId] : [],
    publishedId: idPair.publishedId
  }, {
    tag: "document.delete",
    // this disables referential integrity for cross-dataset references. we
    // have this set because we warn against deletes in the `ConfirmDeleteDialog`
    // UI. This operation is run when "delete anyway" is clicked
    skipCrossDatasetReferenceValidation: !0
  }) : actionsApiClient(client, idPair).observable.action(versions.map((versionId) => ({
    actionType: "sanity.action.document.version.discard",
    versionId
  })), {
    skipCrossDatasetReferenceValidation: !0
  })
}, discardChanges = {
  disabled: ({
    snapshots
  }) => !snapshots.draft && !snapshots.version ? "NO_CHANGES" : !1,
  execute: ({
    client,
    idPair
  }) => actionsApiClient(client, idPair).observable.action({
    actionType: "sanity.action.document.discard",
    draftId: idPair.versionId || idPair.draftId
  }, {
    tag: "document.discard-changes"
  })
}, patch = {
  disabled: () => !1,
  execute: ({
    schema: schema2,
    snapshots,
    idPair,
    draft,
    published,
    version: version2,
    typeName
  }, patches = [], initialDocument) => {
    if (version2) {
      const patchMutation2 = version2.patch(patches), ensureVersion = snapshots.version ? version2.patch([{
        unset: ["_empty_action_guard_pseudo_field_"]
      }]) : [version2.create({
        ...initialDocument,
        _id: idPair.draftId,
        _type: typeName
      })];
      version2.mutate([...ensureVersion, ...patchMutation2]);
      return;
    }
    if (isLiveEditEnabled$1(schema2, typeName)) {
      const patchMutation2 = published.patch(patches), mutations = snapshots.published ? patchMutation2 : [published.createIfNotExists({
        _type: typeName,
        ...initialDocument
      }), ...patchMutation2];
      published.mutate(mutations);
      return;
    }
    const patchMutation = draft.patch(patches);
    if (snapshots.draft) {
      draft.mutate([...draft.patch([{
        unset: ["_empty_action_guard_pseudo_field_"]
      }]), ...patchMutation]);
      return;
    }
    const createMutation = snapshots.published ? (
      // If there's no draft, the user's edits will be based on the published document in the form in front of them
      // so before patching it we need to make sure it's created based on the current published version first.
      draft.createIfNotExists({
        ...initialDocument,
        ...snapshots.published,
        _id: idPair.draftId,
        _type: typeName
      })
    ) : (
      // If the published doesn't exist we need to trigger a `create` action, because we are internally
      // transforming the createIfNotExists action to a patch, which requires the published document to exist.
      // see checkoutPair.ts toActions function for more details.
      draft.create({
        ...initialDocument,
        _id: idPair.draftId,
        _type: typeName
      })
    );
    draft.mutate([createMutation]), draft.commit(), draft.mutate(patchMutation);
  }
}, publish = {
  disabled: ({
    schema: schema2,
    typeName,
    snapshots
  }) => isLiveEditEnabled$1(schema2, typeName) ? "LIVE_EDIT_ENABLED" : !snapshots.draft && !snapshots.version ? snapshots.published ? "ALREADY_PUBLISHED" : "NO_CHANGES" : !1,
  execute: ({
    client,
    idPair,
    snapshots
  }) => {
    if (!snapshots.draft && !snapshots.version)
      throw new Error('cannot execute "publish" when draft or version is missing');
    return actionsApiClient(client, idPair).observable.action({
      actionType: "sanity.action.document.publish",
      draftId: snapshots.draft?._id || snapshots.version?._id,
      publishedId: idPair.publishedId,
      // Optimistic locking using `ifPublishedRevisionId` ensures that concurrent publish action
      // invocations do not override each other.
      //
      // Note: for custom publish actions, `snapshots.draft._rev` may be stale, which means the
      // `ifDraftRevisionId` optimistic lock cannot currently be used.
      ifPublishedRevisionId: snapshots.published?._rev
    }, {
      tag: "document.publish"
    });
  }
}, restore$1 = {
  disabled: () => !1,
  execute: ({
    snapshots,
    historyStore,
    schema: schema2,
    idPair,
    typeName
  }, fromRevision) => {
    const targetId = idPair.versionId ? idPair.versionId : isLiveEditEnabled$1(schema2, typeName) ? idPair.publishedId : idPair.draftId;
    return historyStore.restore(idPair.publishedId, targetId, fromRevision, {
      fromDeleted: !snapshots.draft && !snapshots.published,
      useServerDocumentActions: !0
    });
  }
}, unpublish = {
  disabled: ({
    schema: schema2,
    snapshots,
    typeName
  }) => isLiveEditEnabled$1(schema2, typeName) ? "LIVE_EDIT_ENABLED" : snapshots.published ? !1 : "NOT_PUBLISHED",
  execute: ({
    client,
    idPair
  }) => actionsApiClient(client, idPair).observable.action({
    // This operation is run when "unpublish anyway" is clicked
    actionType: "sanity.action.document.unpublish",
    draftId: idPair.draftId,
    publishedId: idPair.publishedId
  }, {
    tag: "document.unpublish",
    // this disables referential integrity for cross-dataset references. we
    // have this set because we warn against unpublishes in the `ConfirmDeleteDialog`
    // UI.
    skipCrossDatasetReferenceValidation: !0
  })
};
function maybeObservable(v) {
  return typeof v > "u" ? of(null) : v;
}
const operationImpls = {
  del: del$1,
  delete: del$1,
  publish: publish$1,
  patch: patch$1,
  commit,
  discardChanges: discardChanges$1,
  unpublish: unpublish$1,
  duplicate,
  restore: restore$2
}, serverOperationImpls = {
  ...operationImpls,
  del,
  delete: del,
  discardChanges,
  patch,
  publish,
  unpublish,
  restore: restore$1
}, execute = (operationName, operationArguments, extraArgs, serverActionsEnabled) => {
  const operation = serverActionsEnabled ? serverOperationImpls[operationName] : operationImpls[operationName];
  return defer(() => merge(of(null), maybeObservable(operation.execute(operationArguments, ...extraArgs)))).pipe(last());
}, operationCalls$ = new Subject();
function emitOperation(operationName, idPair, typeName, extraArgs) {
  operationCalls$.next({
    operationName,
    idPair,
    typeName,
    extraArgs
  });
}
const REQUIRES_CONSISTENCY = ["publish", "unpublish", "discardChanges", "delete"], operationEvents = memoize((ctx) => {
  const result$ = operationCalls$.pipe(groupBy$1((op) => op.idPair.publishedId), mergeMap((groups$) => groups$.pipe(
    // although it might look like a bug, dropping pending async operations here is actually a feature
    // E.g. if the user types `publish` which is async and then starts patching (sync) then the publish
    // should be cancelled
    switchMap((args) => operationArgs(ctx, args.idPair, args.typeName).pipe(take$1(1), switchMap((operationArguments) => {
      const requiresConsistency = REQUIRES_CONSISTENCY.includes(args.operationName);
      requiresConsistency && (operationArguments.published.commit(), operationArguments.draft.commit());
      const isConsistent$ = consistencyStatus(ctx.client, args.idPair, args.typeName, ctx.serverActionsEnabled, ctx.extraOptions).pipe(filter(Boolean));
      return (requiresConsistency ? isConsistent$.pipe(take$1(1)) : of(!0)).pipe(switchMap(() => execute(args.operationName, operationArguments, args.extraArgs, operationArguments.serverActionsEnabled)));
    }), map(() => ({
      type: "success",
      args
    })), catchError((err) => of({
      type: "error",
      args,
      error: err
    }))))
  )), share()), autoCommit$ = result$.pipe(filter((result) => result.type === "success" && result.args.operationName === "patch"), throttleTime(1e3, asyncScheduler, {
    leading: !0,
    trailing: !0
  }), concatMap$1((result) => window.SLOW ? timer(1e4).pipe(map(() => result)) : of(result)), tap((result) => {
    emitOperation("commit", result.args.idPair, result.args.typeName, []);
  }));
  return merge(result$, autoCommit$.pipe(mergeMapTo(EMPTY$5)));
}, (ctx) => {
  const config = ctx.client.config();
  return `${config.dataset ?? ""}-${config.projectId ?? ""}${ctx.serverActionsEnabled ? "-serverActionsEnabled" : ""}`;
}), remoteSnapshots = memoize((client, idPair, typeName, serverActionsEnabled, pairListenerOptions) => memoizedPair(client, idPair, typeName, serverActionsEnabled, pairListenerOptions).pipe(switchMap(({
  published,
  draft,
  version: version2
}) => merge(published.remoteSnapshot$, draft.remoteSnapshot$, version2?.remoteSnapshot$ ?? EMPTY$5))), memoizeKeyGen);
function pathToString(path = []) {
  return path.reduce((target, segment, i) => {
    const segmentType = typeof segment;
    if (segmentType === "number")
      return `${target}[${segment}]`;
    if (segmentType === "string")
      return `${target}${i === 0 ? "" : "."}${segment}`;
    if (isKeyedObject(segment))
      return `${target}[_key=="${segment._key}"]`;
    throw new Error(`Unsupported path segment "${segment}"`);
  }, "");
}
function isNonNullable$1(t) {
  return t !== null || t !== void 0;
}
function convertToValidationMarker(validatorResult, level, context) {
  if (!context)
    throw new Error("missing context");
  if (validatorResult === !0) return [];
  if (Array.isArray(validatorResult))
    return validatorResult.flatMap((child) => convertToValidationMarker(child, level, context)).filter(isNonNullable$1);
  if (typeof validatorResult == "string")
    return convertToValidationMarker({
      message: validatorResult
    }, level, context);
  if (typeof validatorResult.message != "string")
    throw new Error(`${pathToString(context.path)}: Validator must return 'true' if valid or an error message as a string on errors`);
  const {
    message,
    __internal_metadata
  } = validatorResult, normalizedPaths = [];
  validatorResult.path && normalizedPaths.push(validatorResult.path);
  for (const path of validatorResult.paths || [])
    normalizedPaths.push(path);
  return normalizedPaths.length ? normalizedPaths.map((path) => ({
    path: (context.path || []).concat(path),
    level: level || "error",
    item: {
      message
    },
    message,
    // eslint-disable-next-line camelcase
    __internal_metadata
  })) : [{
    level: level || "error",
    item: {
      message
    },
    message,
    path: context.path || [],
    // eslint-disable-next-line camelcase
    __internal_metadata
  }];
}
function localizeMessage(message, i18n) {
  const {
    currentLocale
  } = i18n, locale = currentLocale.id;
  if (message[locale])
    return message[locale];
  if (locale.includes("-")) {
    const language = locale.split("-", 1)[0];
    if (message[language])
      return message[language];
  }
  return message["en-US"] || message["en-GB"] || message.en || "Unknown validation error (not localized)";
}
function isLocalizedMessages(message) {
  return message !== !0 && typeof message < "u" && typeof message != "string" && isPlainObject$1(message) && !("message" in message);
}
function deepEqualsIgnoreKey(a, b) {
  if (a === b)
    return !0;
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length != b.length) return !1;
    for (let i = 0; i < a.length; i++)
      if (!deepEqualsIgnoreKey(a[i], b[i]))
        return !1;
    return !0;
  }
  if (Array.isArray(a) != Array.isArray(b))
    return !1;
  if (a && b && typeof a == "object" && typeof b == "object") {
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length)
      return !1;
    if (a instanceof Date && b instanceof Date)
      return a.getTime() === b.getTime();
    if (a instanceof Date != b instanceof Date)
      return !1;
    if (a instanceof RegExp && b instanceof RegExp)
      return a.toString() == b.toString();
    if (a instanceof RegExp != b instanceof RegExp)
      return !1;
    for (let i = 0; i < keys.length; i++)
      if (keys[i] !== "_key" && !Object.prototype.hasOwnProperty.call(b, keys[i]))
        return !1;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (key !== "_key" && !deepEqualsIgnoreKey(a[key], b[key]))
        return !1;
    }
    return !0;
  }
  return !1;
}
const _toString = {}.toString, builtIns = [Object, Function, Array, String, Boolean, Number, Date, RegExp, Error];
function isBuiltIn(_constructor) {
  for (let i = 0; i < builtIns.length; i++)
    if (builtIns[i] === _constructor) return !0;
  return !1;
}
function typeString(obj) {
  const stringType = _toString.call(obj).slice(8, -1);
  if (obj == null) return stringType.toLowerCase();
  const constructorType = obj.constructor;
  return constructorType && !isBuiltIn(constructorType) ? constructorType.name : stringType;
}
const SLOW_VALIDATOR_TIMEOUT = 5e3, formatValidationErrors = (options) => options.message ? options.message : options.results.length === 1 ? options.results[0]?.message : options.i18n.t("{{messages, list}}", {
  messages: options.results.map((err) => err.message || err.item?.message),
  formatParams: {
    messages: {
      style: "long",
      type: options.operation
    }
  }
}), genericValidators = {
  type: (expectedType, value, message, {
    i18n
  }) => {
    const actualType = typeString(value);
    return actualType !== expectedType && actualType !== "undefined" ? message || i18n.t("validation:generic.incorrect-type", {
      actualType,
      expectedType
    }) : !0;
  },
  presence: (expected, value, message, {
    i18n
  }) => value === void 0 && expected === "required" ? message || i18n.t("validation:generic.required") : !0,
  all: async (children, value, message, context) => {
    const results = (await Promise.all(children.map((child) => child.validate(value, context)))).flat();
    return results.length === 0 ? !0 : formatValidationErrors({
      message,
      results,
      operation: "conjunction",
      i18n: context.i18n
    });
  },
  either: async (children, value, message, context) => {
    const resolved = await Promise.all(children.map((child) => child.validate(value, context))), results = resolved.flat();
    return resolved.find((result) => !result.length) ? !0 : formatValidationErrors({
      message,
      results,
      operation: "disjunction",
      i18n: context.i18n
    });
  },
  valid: (allowedValues, actual, message, {
    i18n
  }) => {
    const valueType = typeof actual;
    if (valueType === "undefined")
      return !0;
    const value = (valueType === "number" || valueType === "string") && `${actual}`, strValue = value && value.length > 30 ? `${value.slice(0, 30)}\u2026` : value;
    return allowedValues.some((expected) => deepEqualsIgnoreKey(expected, actual)) ? !0 : message || i18n.t("validation:generic.not-allowed", value ? {
      context: "hint",
      replace: {
        hint: strValue
      }
    } : {});
  },
  custom: async (fn, value, message, context) => {
    const slowTimer = setTimeout(() => {
      context.environment === "studio" && console.warn(`Custom validator at ${pathToString(context.path)} has taken more than ${SLOW_VALIDATOR_TIMEOUT}ms to respond`);
    }, SLOW_VALIDATOR_TIMEOUT);
    let result;
    try {
      result = await fn(value, context);
    } finally {
      clearTimeout(slowTimer);
    }
    return isLocalizedMessages(result) ? localizeMessage(result, context.i18n) : typeof result == "string" && message || result;
  }
}, arrayValidators = {
  ...genericValidators,
  min: (minLength, value, message, {
    i18n,
    type
  }) => {
    if (!value || value.length >= minLength)
      return !0;
    const context = isArrayOfBlocksSchemaType(type) ? "blocks" : void 0;
    return message || i18n.t("validation:array.minimum-length", {
      minLength,
      context
    });
  },
  max: (maxLength, value, message, {
    i18n,
    type
  }) => {
    if (!value || value.length <= maxLength)
      return !0;
    const context = isArrayOfBlocksSchemaType(type) ? "blocks" : void 0;
    return message || i18n.t("validation:array.maximum-length", {
      maxLength,
      context
    });
  },
  length: (wantedLength, value, message, {
    i18n,
    type
  }) => {
    if (!value || value.length === wantedLength)
      return !0;
    const context = isArrayOfBlocksSchemaType(type) ? "blocks" : void 0;
    return message || i18n.t("validation:array.exact-length", {
      wantedLength,
      context
    });
  },
  presence: (flag, value, message, {
    i18n
  }) => flag === "required" && !value ? message || i18n.t("validation:generic.required", {
    context: "array"
  }) : !0,
  valid: (allowedValues, values2, message, {
    i18n
  }) => {
    if (typeof values2 > "u")
      return !0;
    const paths = [];
    for (let i = 0; i < values2.length; i++) {
      const value = values2[i];
      if (allowedValues.some((expected) => deepEqualsIgnoreKey(expected, value)))
        continue;
      const pathSegment = value && value._key ? {
        _key: value._key
      } : i;
      paths.push([pathSegment]);
    }
    const sharedMessage = message || i18n.t("validation:generic.not-allowed");
    return paths.map((path) => ({
      message: sharedMessage,
      path
    }));
  },
  unique: (_unused, value, message, {
    i18n
  }) => {
    const dupeIndices = [];
    if (!value)
      return !0;
    for (let x = 0; x < value.length; x++)
      for (let y = x + 1; y < value.length; y++) {
        const itemA = value[x], itemB = value[y];
        deepEqualsIgnoreKey(itemA, itemB) && (dupeIndices.indexOf(x) === -1 && dupeIndices.push(x), dupeIndices.indexOf(y) === -1 && dupeIndices.push(y));
      }
    const paths = dupeIndices.map((idx) => {
      const item = value[idx];
      return [item && item._key ? {
        _key: item._key
      } : idx];
    }), sharedMessage = message || i18n.t("validation:array.item-duplicate");
    return paths.map((path) => ({
      message: sharedMessage,
      path
    }));
  }
}, booleanValidators = {
  ...genericValidators,
  presence: (flag, value, message, {
    i18n
  }) => flag === "required" && typeof value != "boolean" ? message || i18n.t("validation:generic.required", {
    context: "boolean"
  }) : !0
};
function isRecord$3(obj) {
  return typeof obj == "object" && obj !== null && !Array.isArray(obj);
}
const isoDate = /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/, getFormattedDate = (type = "", value, options) => {
  const dateFormat = options?.dateFormat || legacyDateFormat.DEFAULT_DATE_FORMAT, timeFormat = options?.timeFormat || legacyDateFormat.DEFAULT_TIME_FORMAT;
  return legacyDateFormat.format(value, type === "date" ? dateFormat : `${dateFormat} ${timeFormat}`, {
    useUTC: type === "date"
  });
};
function parseDate(date, throwOnError = !1) {
  if (!date) return null;
  if (date === "now") return /* @__PURE__ */ new Date();
  const parsed = new Date(date), isInvalid = isNaN(parsed.getTime());
  if (isInvalid && throwOnError)
    throw new Error(`Unable to parse "${date}" to a date`);
  return isInvalid ? null : parsed;
}
const dateValidators = {
  ...genericValidators,
  type: (_unused, value, message, {
    i18n
  }) => typeof value > "u" || isoDate.test(`${value}`) ? !0 : message || i18n.t("validation:date.invalid-format"),
  min: (minDate, value, message, {
    type,
    i18n
  }) => {
    const dateVal = parseDate(value), minDateVal = parseDate(minDate, !0);
    if (!dateVal || !value || dateVal >= minDateVal)
      return !0;
    if (!type)
      throw new Error("`type` was not provided in validation context.");
    const dateTimeOptions = isRecord$3(type.options) ? type.options : {};
    return message || // Note that the `minDate` passed here is _formatted_, while the raw value provided to the
    // validator is available as `providedMinDate`. This because the formatted date is likely
    // what the developer wants to present to the user
    i18n.t("validation:date.minimum", {
      minDate: getFormattedDate(type.name, minDateVal, dateTimeOptions),
      providedMinDate: minDate
    });
  },
  max: (maxDate, value, message, {
    type,
    i18n
  }) => {
    const dateVal = parseDate(value), maxDateVal = parseDate(maxDate, !0);
    if (!dateVal || !value || dateVal <= maxDateVal)
      return !0;
    if (!type)
      throw new Error("`type` was not provided in validation context.");
    const dateTimeOptions = isRecord$3(type.options) ? type.options : {};
    return message || // Note that the `maxDate` passed here is _formatted_, while the raw value provided to the
    // validator is available as `providedMaxDate`. This because the formatted date is likely
    // what the developer wants to present to the user
    i18n.t("validation:date.maximum", {
      maxDate: getFormattedDate(type.name, maxDateVal, dateTimeOptions),
      providedMaxDate: maxDate
    });
  }
}, precisionRx = /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/, numberValidators = {
  ...genericValidators,
  integer: (_unused, value, message, {
    i18n
  }) => Number.isInteger(value) ? !0 : message || i18n.t("validation:number.non-integer"),
  precision: (limit2, value, message, {
    i18n
  }) => {
    if (value === void 0) return !0;
    const places = value.toString().match(precisionRx);
    return Math.max((places[1] ? places[1].length : 0) - (places[2] ? parseInt(places[2], 10) : 0), 0) > limit2 ? message || i18n.t("validation:number.maximum-precision", {
      limit: limit2
    }) : !0;
  },
  min: (minNumber, value, message, {
    i18n
  }) => value >= minNumber ? !0 : message || i18n.t("validation:number.minimum", {
    minNumber
  }),
  max: (maxNumber, value, message, {
    i18n
  }) => value <= maxNumber ? !0 : message || i18n.t("validation:number.maximum", {
    maxNumber
  }),
  greaterThan: (threshold, value, message, {
    i18n
  }) => value > threshold ? !0 : message || i18n.t("validation:number.greater-than", {
    threshold
  }),
  lessThan: (threshold, value, message, {
    i18n
  }) => value < threshold ? !0 : message || i18n.t("validation:number.less-than", {
    threshold
  })
}, metaKeys = ["_key", "_type", "_weak"], objectValidators = {
  ...genericValidators,
  presence: (expected, value, message, {
    i18n
  }) => {
    if (expected !== "required")
      return !0;
    const keys = value && Object.keys(value).filter((key) => !metaKeys.includes(key));
    return value === void 0 || keys && keys.length === 0 ? message || i18n.t("validation:generic.required", {
      context: "object"
    }) : !0;
  },
  reference: async (_unused, value, message, context) => {
    if (!value)
      return !0;
    const {
      type,
      document: document2,
      getDocumentExists,
      i18n
    } = context;
    if (!isReference$1(value))
      return message || i18n.t("validation:object.not-reference");
    if (!type)
      throw new Error("`type` was not provided in validation context");
    if ("weak" in type && type.weak)
      return !0;
    if (!getDocumentExists)
      throw new Error("`getDocumentExists` was not provided in validation context");
    const documentId = document2?._id;
    return documentId && value._ref == getPublishedId(documentId) || await getDocumentExists({
      id: value._ref
    }) ? !0 : i18n.t("validation:object.reference-not-published", {
      documentId: value._ref
    });
  },
  assetRequired: (flag, value, message, {
    i18n
  }) => !value || !value.asset || !value.asset._ref ? {
    // eslint-disable-next-line camelcase
    __internal_metadata: {
      name: "assetRequired"
    },
    message: message || i18n.t("validation:object.asset-required", {
      context: flag.assetType || ""
    })
  } : !0,
  media: async (fn, value, message, context) => {
    const slowTimer = setTimeout(() => {
      context.environment === "studio" && console.warn(`Media validator at ${pathToString(context.path)} has taken more than ${SLOW_VALIDATOR_TIMEOUT}ms to respond`);
    }, SLOW_VALIDATOR_TIMEOUT);
    if (!value)
      return !0;
    if (!value || !value.media || !value.media._ref)
      return context.i18n.t("validation:object.not-media-library-asset");
    let result = !0;
    try {
      const [type, libraryId, documentId] = value.media._ref.split(":", 3), resourceConfig = {
        resource: {
          type,
          id: libraryId
        }
      }, asset = await context.getClient({
        apiVersion: "2025-02-19"
      }).withConfig(resourceConfig).fetch("*[_id == $id] { ..., 'currentVersion': @.currentVersion-> { ... }  }[0]", {
        id: documentId
      });
      if (!asset)
        return console.warn(`${context.i18n.t("validation:object.media-not-found")}
Asset ID: ${value.media._ref}`), context.i18n.t("validation:object.media-not-found");
      result = await fn({
        media: {
          asset
        },
        value
      }, context);
    } catch (err) {
      throw new Error(`Media validator at ${pathToString(context.path)} failed with an error: ${err instanceof Error ? err.message : String(err)}`, {
        cause: err
      });
    } finally {
      clearTimeout(slowTimer);
    }
    const validationErrorMetadata = {
      // eslint-disable-next-line camelcase
      __internal_metadata: {
        name: "media"
      }
    };
    return result === !0 || Array.isArray(result) ? result : [result].map((res) => typeof res == "string" ? {
      ...validationErrorMetadata,
      message: message || res
    } : isLocalizedMessages(res) ? {
      ...validationErrorMetadata,
      message: message || localizeMessage(res, context.i18n)
    } : {
      ...validationErrorMetadata,
      ...res,
      message: message || res.message
    });
  }
}, DUMMY_ORIGIN = "http://sanity", isRelativeUrl = (url) => /^\.*\//.test(url), emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, stringValidators = {
  ...genericValidators,
  min: (minLength, value, message, {
    i18n
  }) => !value || value.length >= minLength ? !0 : message || i18n.t("validation:string.minimum-length", {
    minLength
  }),
  max: (maxLength, value, message, {
    i18n
  }) => !value || value.length <= maxLength ? !0 : message || i18n.t("validation:string.maximum-length", {
    maxLength
  }),
  length: (wantedLength, value, message, {
    i18n
  }) => (value || "").length === wantedLength ? !0 : message || i18n.t("validation:string.exact-length", {
    wantedLength
  }),
  uri: (constraints, value, message, {
    i18n
  }) => {
    const strValue = value || "";
    if (!strValue)
      return !0;
    const {
      options
    } = constraints, {
      allowCredentials,
      relativeOnly
    } = options, allowRelative = options.allowRelative || relativeOnly;
    let url;
    try {
      url = allowRelative ? new URL(strValue, DUMMY_ORIGIN) : new URL(strValue);
    } catch {
      return message || i18n.t("validation:string.url.invalid");
    }
    if (relativeOnly && url.origin !== DUMMY_ORIGIN)
      return message || i18n.t("validation:string.url.not-relative");
    if (!allowRelative && url.origin === DUMMY_ORIGIN && isRelativeUrl(strValue))
      return message || i18n.t("validation:string.url.not-absolute");
    if (!allowCredentials && (url.username || url.password))
      return message || i18n.t("validation:string.url.includes-credentials");
    const urlScheme = url.protocol.replace(/:$/, "");
    return options.scheme.some((scheme) => scheme.test(urlScheme)) ? !0 : message || i18n.t("validation:string.url.disallowed-scheme", {
      scheme: urlScheme
    });
  },
  stringCasing: (casing, value, message, {
    i18n
  }) => {
    const strValue = value || "";
    return casing === "uppercase" && strValue !== strValue.toLocaleUpperCase() ? message || i18n.t("validation:string.uppercase") : casing === "lowercase" && strValue !== strValue.toLocaleLowerCase() ? message || i18n.t("validation:string.lowercase") : !0;
  },
  presence: (flag, value, message, {
    i18n
  }) => flag === "required" && !value ? message || i18n.t("validation:generic.required", {
    context: "string"
  }) : !0,
  regex: (options, value, message, {
    i18n
  }) => {
    const {
      pattern,
      name,
      invert
    } = options, regName = name || `${pattern.toString()}`, strValue = value || "";
    pattern.lastIndex = 0;
    const matches = pattern.test(strValue);
    return !invert && !matches || invert && matches ? message || (invert ? i18n.t("validation:string.regex-match", {
      name: regName
    }) : i18n.t("validation:string.regex-does-not-match", {
      name: regName
    })) : !0;
  },
  email: (_unused, value, message, {
    i18n
  }) => {
    const strValue = `${value || ""}`.trim();
    return !strValue || emailRegex.test(strValue) ? !0 : message || i18n.t("validation:string.email");
  }
}, typeValidators = {
  Boolean: booleanValidators,
  Number: numberValidators,
  String: stringValidators,
  Array: arrayValidators,
  Object: objectValidators,
  Date: dateValidators
}, isFieldRef = (constraint) => typeof constraint != "object" || !constraint ? !1 : constraint.type === Rule.FIELD_REF, EMPTY_ARRAY$w = [], Rule = class Rule2 extends Rule$1 {
  static array = (def) => new Rule2(def).type("Array");
  static object = (def) => new Rule2(def).type("Object");
  static string = (def) => new Rule2(def).type("String");
  static number = (def) => new Rule2(def).type("Number");
  static boolean = (def) => new Rule2(def).type("Boolean");
  static dateTime = (def) => new Rule2(def).type("Date");
  clone() {
    const rule = new Rule2();
    return rule._type = this._type, rule._message = this._message, rule._required = this._required, rule._rules = [...this._rules], rule._level = this._level, rule._fieldRules = this._fieldRules, rule._typeDef = this._typeDef, rule;
  }
  async validate(value, {
    __internal = {},
    ...context
  }) {
    const {
      customValidationConcurrencyLimiter
    } = __internal, valueIsEmpty = value == null;
    if (valueIsEmpty && this._required === "optional")
      return EMPTY_ARRAY$w;
    const rules = (
      // Run only the _custom_ functions if the rule is not set to required or optional
      this._required === void 0 && valueIsEmpty ? this._rules.filter((curr) => curr.flag === "custom") : this._rules
    ), validators = this._type && typeValidators[this._type] || genericValidators;
    return (await Promise.all(rules.map(async (curr) => {
      if (curr.flag === void 0)
        throw new Error('Invalid rule, did not contain "flag"-property');
      const validator = validators[curr.flag];
      if (!validator) {
        const forType = this._type ? `type "${this._type}"` : "rule without declared type";
        throw new Error(`Validator for flag "${curr.flag}" not found for ${forType}`);
      }
      let specConstraint = "constraint" in curr ? curr.constraint : null;
      if (isFieldRef(specConstraint) && (specConstraint = get(context.parent, specConstraint.path)), curr.flag === "custom" && customValidationConcurrencyLimiter && !specConstraint?.bypassConcurrencyLimit) {
        const customValidator = specConstraint;
        specConstraint = async (...args) => {
          await customValidationConcurrencyLimiter.ready();
          try {
            return await customValidator(...args);
          } finally {
            customValidationConcurrencyLimiter.release();
          }
        };
      }
      const message = isLocalizedMessages(this._message) ? localizeMessage(this._message, context.i18n) : this._message;
      try {
        const result = await validator(specConstraint, value, message, context);
        return convertToValidationMarker(result, this._level, context);
      } catch (err) {
        const errorMessage = `${pathToString(context.path)}: Exception occurred while validating value: ${err.message}`;
        return convertToValidationMarker({
          message: errorMessage
        }, "error", context);
      }
    }))).flat();
  }
}, memoizedWarnOnArraySlug = memoize$1(warnOnArraySlug);
function serializePath(path) {
  return path.reduce((target, part, i) => {
    const isIndex = typeof part == "number", isKey = isKeyedObject(part), add = isIndex || isKey ? "[]" : `${i === 0 ? "" : "."}${part}`;
    return `${target}${add}`;
  }, "");
}
const defaultIsUnique = (slug, context) => {
  const {
    getClient: getClient2,
    document: document2,
    path,
    type
  } = context, schemaOptions = type?.options;
  if (!document2)
    throw new Error("`document` was not provided in validation context.");
  if (!path)
    throw new Error("`path` was not provided in validation context.");
  const disableArrayWarning = schemaOptions?.disableArrayWarning || !1, docType = document2._type, atPath = serializePath(path.concat("current"));
  !disableArrayWarning && atPath.includes("[]") && context.environment === "studio" && memoizedWarnOnArraySlug(serializePath(path));
  const constraints = ["_type == $docType", "!sanity::versionOf($published)", `${atPath} == $slug`].join(" && ");
  return getClient2({
    apiVersion: DEFAULT_STUDIO_CLIENT_OPTIONS.apiVersion
  }).withConfig({
    perspective: "raw"
  }).fetch(`!defined(*[${constraints}][0]._id)`, {
    docType,
    published: getPublishedId(document2._id),
    slug
  }, {
    tag: "validation.slug-is-unique"
  });
};
function warnOnArraySlug(serializedPath) {
  console.warn([`Slug field at path ${serializedPath} is within an array and cannot be automatically checked for uniqueness`, 'If you need to check for uniqueness, provide your own "isUnique" method', "To disable this message, set `disableArrayWarning: true` on the slug `options` field"].join(`
`));
}
const slugValidator = async (value, context) => {
  if (!value)
    return !0;
  const {
    i18n
  } = context;
  if (typeof value != "object" || Array.isArray(value))
    return i18n.t("validation:slug.not-object");
  if (!isSlug(value) || value.current.trim().length === 0)
    return i18n.t("validation:slug.missing-current");
  const isUnique = context?.type?.options?.isUnique || defaultIsUnique, slugContext = {
    ...context,
    parent: context.parent,
    type: context.type,
    defaultIsUnique
  };
  return await isUnique(value.current, slugContext) ? !0 : i18n.t("validation:slug.not-unique", {
    slug: value.current
  });
}, ruleConstraintTypes = {
  array: !0,
  boolean: !0,
  date: !0,
  number: !0,
  object: !0,
  string: !0
}, isRuleConstraint = (typeString2) => typeString2 in ruleConstraintTypes;
function getTypeChain$3(type, visited = /* @__PURE__ */ new Set()) {
  return type ? visited.has(type) ? [] : (visited.add(type), [...type.type ? getTypeChain$3(type.type, visited) : [], type]) : [];
}
function baseRuleReducer(inputRule, type) {
  let baseRule = inputRule;
  isRuleConstraint(type.jsonType) && (baseRule = baseRule.type(type.jsonType));
  const typeOptionsList = (
    // if type.options is truthy
    type?.options && // and type.options is an object (non-null from the previous)
    typeof type.options == "object" && // and if `list` is in options
    "list" in type.options && // then finally access the list
    type.options.list
  );
  return Array.isArray(typeOptionsList) && (baseRule = baseRule.valid(typeOptionsList.map((option) => extractValueFromListOption(option, type)))), type.name === "datetime" || type.name === "date" ? baseRule.type("Date") : type.name === "url" ? baseRule.uri() : type.name === "slug" ? baseRule.custom(slugValidator, {
    bypassConcurrencyLimit: !0
  }) : type.name === "reference" ? baseRule.reference() : type.name === "email" ? baseRule.email() : baseRule;
}
function hasValueField(typeDef) {
  return typeDef ? !("fields" in typeDef) && typeDef.type ? hasValueField(typeDef.type) : !("fields" in typeDef) || !Array.isArray(typeDef.fields) ? !1 : typeDef.fields.some((field) => field.name === "value") : !1;
}
function extractValueFromListOption(option, typeDef) {
  return typeDef.jsonType === "object" && hasValueField(typeDef) || option.value === void 0 ? option : option.value;
}
function normalizeValidationRules(typeDef, context) {
  if (!typeDef)
    return [];
  const validation2 = typeDef.validation;
  if (Array.isArray(validation2))
    return validation2.flatMap((i) => normalizeValidationRules({
      ...typeDef,
      validation: i
    }, context));
  const baseRule = (
    // using an object + Object.values to de-dupe the type chain by type name
    Object.values(getTypeChain$3(typeDef).reduce((acc, type) => (acc[type.name] = type, acc), {})).reduce(baseRuleReducer, new Rule(typeDef))
  );
  return validation2 && typeof validation2 == "object" ? [validation2] : validation2 ? typeof validation2 == "function" ? normalizeValidationRules({
    ...typeDef,
    validation: validation2(baseRule, context)
  }, context) : [baseRule] : [baseRule];
}
function inferFromSchemaType(typeDef) {
  return traverse(typeDef, /* @__PURE__ */ new Set()), typeDef;
}
function traverse(typeDef, visited) {
  if (!visited.has(typeDef)) {
    if (visited.add(typeDef), hasValidationContext(typeDef.validation) || (typeDef.validation = normalizeValidationRules(typeDef)), "fields" in typeDef)
      for (const field of typeDef.fields)
        traverse(field.type, visited);
    if ("of" in typeDef)
      for (const candidate of typeDef.of)
        traverse(candidate, visited);
    if (typeDef.annotations)
      for (const annotation of typeDef.annotations)
        traverse(annotation, visited);
  }
}
function hasValidationContext(validation2) {
  if (!validation2) return !1;
  if (Array.isArray(validation2))
    return validation2.some(hasValidationContext);
  if (typeof validation2 != "function") return !1;
  if (validation2.length >= 2) return !0;
  const signature = Function.prototype.toString.call(validation2);
  return /\(\s*\w+\s*,\s*\.\.\./.test(signature);
}
function inferFromSchema(schema2) {
  return schema2.getLocalTypeNames().forEach((typeName) => {
    const schemaType = schema2.get(typeName);
    schemaType && inferFromSchemaType(schemaType);
  }), schema2;
}
function resolveConditionalProperty(property, context) {
  const {
    currentUser,
    document: document2,
    parent,
    value,
    path
  } = context;
  return typeof property == "boolean" || property === void 0 ? !!property : (
    // oxlint-disable-next-line no-unnecessary-boolean-literal-compare - we can't trust the return value here is actually a boolean at runtime
    property({
      document: document2,
      parent,
      value,
      currentUser,
      path
    }) === !0
  );
}
const shouldEscape = typeof window > "u" || typeof document > "u", fallbackLocales = [defaultLocale], getFallbackLocaleSource = memoize$1(function() {
  const i18n = getFallbackI18nInstance();
  return i18n.init({
    showSupportNotice: !1
  }), {
    currentLocale: defaultLocale,
    locales: fallbackLocales,
    loadNamespaces: i18n.loadNamespaces,
    t: i18n.t
  };
});
function getFallbackI18nInstance() {
  const staticResources = {
    [defaultLocale.id]: {}
  }, staticBundles = usEnglishLocale.bundles?.filter(isStaticResourceBundle) || [], namespaces = /* @__PURE__ */ new Set();
  for (const bundle of staticBundles)
    staticResources[defaultLocale.id][bundle.namespace] = bundle.resources, namespaces.add(bundle.namespace);
  return createInstance({
    ns: Array.from(namespaces),
    defaultNS: studioLocaleNamespace,
    initImmediate: !0,
    showSupportNotice: !1,
    partialBundledLanguages: !0,
    fallbackLng: defaultLocale.id,
    lng: defaultLocale.id,
    supportedLngs: [defaultLocale.id],
    debug: !1,
    load: "currentOnly",
    resources: staticResources,
    interpolation: {
      // If we're in a browser, assume this is running inside of the studio, eg a React app,
      // and that values returned will be escaped by the framework (eg React) automatically.
      escapeValue: shouldEscape
    }
  });
}
const BUFFER_TIME = 250, MAX_BUFFER_SIZE = 100, MAX_REQUEST_CONCURRENCY = 1;
function createBatchedGetDocumentExists(client) {
  const id$ = new Subject(), limiter = new ConcurrencyLimiter(MAX_REQUEST_CONCURRENCY), existence$ = id$.pipe(bufferTime(BUFFER_TIME, null, MAX_BUFFER_SIZE), map$1((ids) => Array.from(new Set(ids))), mergeMap$1((ids) => from(limiter.ready()).pipe(switchMap$1(() => client.observable.request({
    uri: client.getDataUrl("doc", ids.join(",")),
    json: !0,
    query: {
      excludeContent: "true"
    },
    tag: "documents-availability"
  }).pipe(map$1((availability) => ({
    availability,
    ids
  })))), finalize(limiter.release))), mergeMap$1(({
    availability,
    ids
  }) => ids.map((id2) => {
    const omittedIds = availability.omitted.reduce((acc, next) => (acc[next.id] = next.reason, acc), {});
    return omittedIds[id2] ? omittedIds[id2] === "existence" ? {
      id: id2,
      exists: !1
    } : {
      id: id2,
      exists: !0
    } : {
      id: id2,
      exists: !0
    };
  })), share$1());
  return async function(options) {
    const result = firstValueFrom(existence$.pipe(filter$1(({
      id: id2
    }) => id2 === options.id)));
    id$.next(options.id);
    const {
      exists: exists2
    } = await result;
    return exists2;
  };
}
const requestIdleCallbackShim = function(callback, options) {
  const start = Date.now();
  return window.setTimeout(() => {
    callback({
      didTimeout: !1,
      timeRemaining() {
        return Math.max(0, Date.now() - start);
      }
    });
  }, 0);
}, cancelIdleCallbackShim = function(handle) {
  return window.clearTimeout(handle);
}, win = typeof window > "u" ? void 0 : window, requestIdleCallback$1 = win?.requestIdleCallback || requestIdleCallbackShim, cancelIdleCallback = win?.cancelIdleCallback || cancelIdleCallbackShim, unknownFieldsValidator = (type) => (value) => {
  if (typeof value != "object" || !value) return !0;
  const fieldNames = new Set(type.fields?.map((field) => field.name));
  return Object.keys(value).filter((key) => !key.startsWith("_")).filter((key) => !fieldNames.has(key)).map((unknownField) => ({
    message: `Field '${unknownField}' does not exist on type '${type.name}'`,
    path: [unknownField]
  }));
}, DEFAULT_MAX_FETCH_CONCURRENCY = 25, DEFAULT_MAX_CUSTOM_VALIDATION_CONCURRENCY = 5;
let _limitConcurrency;
const getConcurrencyLimiter = (maxConcurrency) => _limitConcurrency || (_limitConcurrency = createClientConcurrencyLimiter(maxConcurrency), _limitConcurrency), isRecord$2 = (maybeRecord) => typeof maybeRecord == "object" && maybeRecord !== null && !Array.isArray(maybeRecord);
function extractFieldRulesFromRule(rule) {
  const results = [];
  rule._fieldRules && results.push(rule._fieldRules);
  for (const ruleSpec of rule._rules)
    if (ruleSpec.flag === "all" || ruleSpec.flag === "either") {
      const childRules = ruleSpec.constraint;
      if (Array.isArray(childRules))
        for (const childRule of childRules)
          results.push(...extractFieldRulesFromRule(childRule));
    }
  return results;
}
function resolveTypeForArrayItem(item, candidates) {
  if (candidates.length === 1) return candidates[0];
  const itemType = isTypedObject$1(item) && item._type, primitive = item == null || !itemType && typeString(item).toLowerCase();
  return primitive && primitive !== "object" ? candidates.find((candidate) => candidate.jsonType === primitive) : candidates.find((candidate) => candidate.type?.name === itemType) || candidates.find((candidate) => candidate.name === itemType) || candidates.find((candidate) => candidate.name === "object" && primitive === "object");
}
function validateDocument({
  document: document2,
  workspace,
  environment = "studio",
  maxFetchConcurrency,
  currentUser,
  ...options
}) {
  const getClient2 = options.getClient || workspace.getClient, limitConcurrency = getConcurrencyLimiter(maxFetchConcurrency ?? DEFAULT_MAX_FETCH_CONCURRENCY);
  return lastValueFrom(validateDocumentObservable({
    document: document2,
    getClient: (clientOptions2) => limitConcurrency(getClient2(clientOptions2)),
    i18n: workspace.i18n,
    schema: workspace.schema,
    getDocumentExists: options.getDocumentExists || createBatchedGetDocumentExists(getClient2({
      apiVersion: "v2021-03-25"
    })),
    environment,
    currentUser
  }));
}
const customValidationConcurrencyLimiters = /* @__PURE__ */ new WeakMap();
function validateDocumentObservable({
  document: document2,
  getClient: getClient2,
  i18n = getFallbackLocaleSource(),
  schema: schema2,
  getDocumentExists,
  environment,
  maxCustomValidationConcurrency,
  currentUser
}) {
  if (typeof document2?._type != "string")
    throw new Error("Tried to validated a value without a '_type'");
  const documentType = schema2.get(document2._type);
  if (!documentType)
    return environment === "studio" ? (console.warn('Schema type for object type "%s" not found, skipping validation', document2._type), of([])) : of([{
      level: "warning",
      message: `Could not find schema type for type '${document2._type}', skipping validation`,
      path: []
    }]);
  let customValidationConcurrencyLimiter = customValidationConcurrencyLimiters.get(schema2);
  customValidationConcurrencyLimiter || (customValidationConcurrencyLimiter = new ConcurrencyLimiter(maxCustomValidationConcurrency ?? DEFAULT_MAX_CUSTOM_VALIDATION_CONCURRENCY), customValidationConcurrencyLimiters.set(schema2, customValidationConcurrencyLimiter));
  const validationOptions = {
    getClient: getClient2,
    schema: schema2,
    parent: void 0,
    value: document2,
    path: [],
    document: document2,
    type: documentType,
    i18n,
    getDocumentExists,
    environment,
    customValidationConcurrencyLimiter,
    currentUser
  };
  return from(i18n.loadNamespaces(["validation"])).pipe(switchMap(() => validateItemObservable(validationOptions)), catchError((err) => {
    console.error(err);
    const message = err?.message || "Unknown error";
    return of([{
      level: "error",
      message,
      item: {
        message
      },
      path: []
    }]);
  }));
}
function validateItem(opts) {
  return lastValueFrom(validateItemObservable(opts));
}
function validateItemObservable({
  value,
  type,
  path = [],
  parent,
  customValidationConcurrencyLimiter,
  environment,
  ...restOfContext
}) {
  const ancestorHidden = restOfContext.hidden === !0, resolveHiddenForType = (schemaType, schemaValue, schemaParent, schemaPath, ancestorHiddenValue) => schemaType ? ancestorHiddenValue || resolveConditionalProperty(schemaType.hidden, {
    ...restOfContext,
    parent: schemaParent,
    value: schemaValue,
    path: schemaPath || [],
    currentUser: restOfContext.currentUser ?? null
  }) : ancestorHiddenValue, hidden = resolveHiddenForType(type, value, parent, path, ancestorHidden), addUnknownFieldsValidator = (rule) => (
    // if the schema type is an object type
    type?.jsonType === "object" && // and if somewhere in it's type chain, it inherits from object or document
    getTypeChain$3(type).find((t) => ["object", "document", "file", "image"].includes(t.name)) && // and the environment is not the studio
    environment !== "studio" ? rule.custom(unknownFieldsValidator(type), {
      bypassConcurrencyLimit: !0
    }).warning() : rule
  ), rules = normalizeValidationRules(type, {
    ...restOfContext,
    hidden,
    environment,
    parent,
    path,
    type
  }), selfChecks = rules.map(addUnknownFieldsValidator).map((rule) => defer(() => rule.validate(value, {
    ...restOfContext,
    environment,
    hidden,
    parent,
    path,
    type,
    __internal: {
      customValidationConcurrencyLimiter
    }
  })));
  let nestedChecks = [];
  const selfIsRequired = rules.some((rule) => rule.isRequired());
  if (
    // run nested validation for objects
    type?.jsonType === "object" && // if the value is truthy
    (value || // or
    // (the value is null or undefined) and the top-level value is required
    value == null && selfIsRequired)
  ) {
    const fieldTypes = type.fields.reduce((acc, field) => (acc[field.name] = field.type, acc), {});
    nestedChecks = nestedChecks.concat(rules.flatMap((rule) => extractFieldRulesFromRule(rule)).flatMap((fieldResults) => Object.entries(fieldResults)).flatMap(([name, validation2]) => {
      const fieldType = fieldTypes[name];
      return normalizeValidationRules({
        ...fieldType,
        validation: validation2
      }).map(addUnknownFieldsValidator).map((subRule) => {
        const nestedValue = isRecord$2(value) ? value[name] : void 0, nestedHidden = resolveHiddenForType(fieldType, nestedValue, value, path.concat(name), hidden);
        return defer(() => subRule.validate(nestedValue, {
          ...restOfContext,
          parent: value,
          path: path.concat(name),
          type: fieldType,
          environment,
          hidden: nestedHidden,
          __internal: {
            customValidationConcurrencyLimiter
          }
        }));
      });
    })), nestedChecks = nestedChecks.concat(type.fields.map((field) => validateItemObservable({
      ...restOfContext,
      hidden,
      parent: value,
      value: isRecord$2(value) ? value[field.name] : void 0,
      path: path.concat(field.name),
      type: field.type,
      environment,
      customValidationConcurrencyLimiter
    })));
  }
  return type?.jsonType === "array" && Array.isArray(value) && (nestedChecks = nestedChecks.concat(value.map((item, index) => validateItemObservable({
    ...restOfContext,
    hidden,
    parent: value,
    value: item,
    path: path.concat(isKeyedObject(item) ? {
      _key: item._key
    } : index),
    type: resolveTypeForArrayItem(item, type.of),
    environment,
    customValidationConcurrencyLimiter
  })))), defer(() => merge([...selfChecks, ...nestedChecks])).pipe(mergeMap((validateNode) => concat(idle(), validateNode), 40), mergeAll(), toArray$1(), map(flatten$1), map((results) => rules.some((rule) => extractFieldRulesFromRule(rule).length > 0) ? uniqBy(results, (rule) => JSON.stringify(rule)) : results));
}
function idle(timeout2) {
  return new Observable((observer) => {
    const handle = requestIdleCallback$1(() => {
      observer.complete();
    }, void 0);
    return () => cancelIdleCallback(handle);
  });
}
const INITIAL_VALIDATION_STATUS = {
  isValidating: !0,
  validation: []
};
function findReferenceIds(obj) {
  return reduce(obj, (acc, node) => (isReference$1(node) && !isGlobalDocumentReference(node) && acc.add(node._ref), acc), /* @__PURE__ */ new Set());
}
const EMPTY_VALIDATION = [], listenDocumentExists = (observeDocumentAvailability, id2, versionId) => observeDocumentAvailability(id2, {
  version: versionId
}).pipe(map(({
  published,
  version: version2
}) => !version2?.available && version2?.reason === "VERSION_DELETED" ? !1 : published.available || version2?.available || !1)), REF_UPDATE_DELAY = 1e3;
function shareLatestWithRefCount$1() {
  return shareReplay({
    bufferSize: 1,
    refCount: !0
  });
}
function validateDocumentWithReferences(ctx, document$, requirePublishedReferences) {
  const referenceIds$ = document$.pipe(map((document2) => findReferenceIds(document2)), mergeMap((ids) => from(ids))), versionId$ = document$.pipe(distinctUntilChanged()), referenceExistence$ = combineLatest([versionId$, referenceIds$]).pipe(groupBy$1(([_, referenceId]) => referenceId, {
    duration: () => timer(1e3 * 60 * 30)
  }), mergeMap((refIds$) => refIds$.pipe(distinct(), mergeMap(([document2, referenceId]) => {
    const versionId = requirePublishedReferences ? void 0 : getVersionFromId(document2?._id || "");
    return listenDocumentExists(ctx.observeDocumentPairAvailability, referenceId, versionId).pipe(map((result) => [referenceId, result]));
  }))), scan((acc, [id2, result]) => acc[id2] === result ? acc : {
    ...acc,
    [id2]: result
  }, {}), distinctUntilChanged(shallowEquals), shareLatestWithRefCount$1()), getDocumentExists = ({
    id: id2
  }) => lastValueFrom(referenceExistence$.pipe(
    // If the id is not present as key in the `referenceExistence` map it means it's existence status
    // isn't yet loaded, so we want to wait until it is
    first((referenceExistence) => id2 in referenceExistence),
    map((referenceExistence) => referenceExistence[id2])
  )), referenceDocumentUpdates$ = referenceExistence$.pipe(
    // we'll skip the first emission since the document already gets an initial validation pass
    // we're only interested in updates in referenced documents after that
    skip(1),
    throttleTime(REF_UPDATE_DELAY, asyncScheduler, {
      leading: !0,
      trailing: !0
    })
  );
  return combineLatest([document$, concat(of(null), referenceDocumentUpdates$)]).pipe(map(([document2]) => document2), exhaustMapWithTrailing((document2) => defer(() => document2?._type ? concat(of({
    isValidating: !0,
    revision: document2._rev
  }), validateDocumentObservable({
    document: document2,
    getClient: ctx.getClient,
    getDocumentExists,
    i18n: ctx.i18n,
    schema: ctx.schema,
    environment: "studio",
    currentUser: ctx.currentUser
  }).pipe(map((validationMarkers) => ({
    validation: validationMarkers,
    isValidating: !1
  })))) : of({
    validation: EMPTY_VALIDATION,
    isValidating: !1
  }))), scan((acc, next) => ({
    ...acc,
    ...next
  }), INITIAL_VALIDATION_STATUS), shareLatestWithRefCount$1());
}
const DOC_UPDATE_DELAY = 200;
function shareLatestWithRefCount() {
  return shareReplay({
    bufferSize: 1,
    refCount: !0
  });
}
const validation = memoize((ctx, {
  draftId,
  publishedId,
  versionId
}, typeName, validationTarget, validatePublishedReferences) => {
  const document$ = editState(ctx, {
    draftId,
    publishedId,
    versionId
  }, typeName).pipe(map((state) => {
    const {
      version: version2,
      draft,
      published
    } = state;
    return validationTarget === "draft" ? draft : validationTarget === "version" ? version2 : published;
  }), throttleTime(DOC_UPDATE_DELAY, asyncScheduler, {
    trailing: !0
  })), documentToValidate$ = document$.pipe(distinctUntilChanged((prev, next) => prev?._rev === next?._rev ? !0 : shallowEquals(omit(prev, "_rev", "_updatedAt"), omit(next, "_rev", "_updatedAt"))), shareLatestWithRefCount()), documentRevision$ = document$.pipe(map((document2) => document2?._rev));
  return combineLatest([documentRevision$, validateDocumentWithReferences(ctx, documentToValidate$, validatePublishedReferences)]).pipe(map(([revision, validationStatus]) => ({
    ...validationStatus,
    revision
  })));
}, (ctx, idPair, typeName, validationTarget, validatePublishedReferences) => {
  const documentId = validationTarget === "draft" ? idPair.draftId : validationTarget === "version" ? idPair.versionId : idPair.publishedId;
  return `${memoizeKeyGen(ctx.client, idPair, typeName)}-${documentId}-${validatePublishedReferences}`;
}), documentEvents = memoize((client, idPair, typeName, serverActionsEnabled, pairListenerOptions) => memoizedPair(client, idPair, typeName, serverActionsEnabled, pairListenerOptions).pipe(switchMap(({
  draft,
  published
}) => merge(draft.events, published.events))), memoizeKeyGen);
function createOperationGuard(opName) {
  return {
    disabled: "NOT_READY",
    execute: () => {
      throw new Error(`Called ${opName} before it was ready.`);
    }
  };
}
const GUARDED = {
  commit: createOperationGuard("commit"),
  delete: createOperationGuard("delete"),
  del: createOperationGuard("del"),
  publish: createOperationGuard("publish"),
  patch: createOperationGuard("patch"),
  discardChanges: createOperationGuard("discardChanges"),
  unpublish: createOperationGuard("unpublish"),
  duplicate: createOperationGuard("duplicate"),
  restore: createOperationGuard("restore")
}, createEmitter = (operationName, idPair, typeName) => (...executeArgs) => emitOperation(operationName, idPair, typeName, executeArgs);
function wrap(opName, op, operationArgs2) {
  return {
    disabled: op.disabled(operationArgs2),
    execute: createEmitter(opName, operationArgs2.idPair, operationArgs2.typeName)
  };
}
function createOperationsAPI(args) {
  const operationsAPI = {
    commit: wrap("commit", commit, args),
    delete: wrap("delete", del$1, args),
    del: wrap("delete", del$1, args),
    publish: wrap("publish", publish$1, args),
    patch: wrap("patch", patch$1, args),
    discardChanges: wrap("discardChanges", discardChanges$1, args),
    unpublish: wrap("unpublish", unpublish$1, args),
    duplicate: wrap("duplicate", duplicate, args),
    restore: wrap("restore", restore$2, args)
  };
  return args.serverActionsEnabled ? {
    ...operationsAPI,
    delete: wrap("delete", del, args),
    del: wrap("delete", del, args),
    discardChanges: wrap("discardChanges", discardChanges, args),
    patch: wrap("patch", patch, args),
    publish: wrap("publish", publish, args),
    unpublish: wrap("unpublish", unpublish, args),
    restore: wrap("restore", restore$1, args)
  } : operationsAPI;
}
const editOperations = memoize((ctx, idPair, typeName) => {
  const operationEvents$ = operationEvents(ctx), operations$ = operationArgs(ctx, idPair, typeName).pipe(map(createOperationsAPI));
  return concat(of(GUARDED), merge(operationEvents$.pipe(mergeMap(() => EMPTY$5)), operations$)).pipe(shareReplay({
    refCount: !0,
    bufferSize: 1
  }));
}, (ctx, idPair, typeName) => memoizeKeyGen(ctx.client, idPair, typeName));
function postTask(callback, options = {}) {
  return "scheduler" in window && typeof window.scheduler?.postTask == "function" ? window.scheduler.postTask(callback, options) : callback();
}
function isRecord$1(value) {
  return isPlainObject$1(value);
}
function deepAssign(target, source) {
  const result = {
    ...target,
    ...source
  };
  return Object.keys(result).forEach((key) => {
    const sourceVal = source[key], targetVal = target[key];
    isRecord$1(sourceVal) && isRecord$1(targetVal) && (result[key] = deepAssign(targetVal, sourceVal));
  }), result;
}
const ALLOWED_REF_PROPS = ["_dataset", "_projectId", "_strengthenOnPublish", "_key", "_ref", "_type", "_weak"], REQUIRED_TEMPLATE_PROPS = ["id", "title", "schemaType", "value"];
function templateId(template, i) {
  return quote(template.id || template.title) || typeof i == "number" && `at index ${i}` || "";
}
function quote(str) {
  return str && str.length > 0 ? `"${str}"` : str;
}
function validateTemplates(schema2, templates) {
  const idMap = /* @__PURE__ */ new Map();
  return templates.forEach((template, i) => {
    const id2 = templateId(template, i);
    if (typeof template.values < "u" && !template.value)
      throw new Error(`Template ${id2} is missing "value" property, but contained "values". Typo?`);
    const missing = REQUIRED_TEMPLATE_PROPS.filter((prop) => !template[prop]);
    if (missing.length > 0)
      throw new Error(`Template ${id2} is missing required properties: ${missing.join(", ")}`);
    if (typeof template.value != "function" && !isRecord$1(template.value))
      throw new Error(`Template ${id2} has an invalid "value" property; should be a function or an object`);
    if (typeof template.parameters < "u")
      if (Array.isArray(template.parameters))
        template.parameters.forEach((param, j) => validateParameter(schema2, param, template, j));
      else
        throw new Error(`Template ${id2} has an invalid "parameters" property; must be an array`);
    if (idMap.has(template.id)) {
      const dupeIndex = idMap.get(template.id), dupe = `${quote(templates[dupeIndex].title)} at index ${dupeIndex}`;
      throw new Error(`Template "${template.title}" at index ${i} has the same ID ("${template.id}") as template ${dupe}`);
    }
    idMap.set(template.id, i);
  }), templates;
}
function validateInitialObjectValue(value, template) {
  const contextError = (msg) => `Template "${template.id}" initial value: ${msg}`;
  if (!isRecord$1(value))
    throw new Error(contextError("resolved to a non-object"));
  if (value._type && template.schemaType !== value._type)
    throw new Error(contextError(`includes "_type"-property (${value._type}) that does not match template (${template.schemaType})`));
  try {
    return validateValue(value);
  } catch (err) {
    throw err.message = contextError(err.message), err;
  }
}
function validateValue(value, path = [], parentIsArray = !1) {
  if (Array.isArray(value))
    return value.map((item, i) => {
      if (Array.isArray(item))
        throw new Error(`multidimensional arrays are not supported (at path "${toString(path)}")`);
      return validateValue(item, path.concat(i), !0);
    });
  if (!isRecord$1(value))
    return value;
  const initial2 = parentIsArray && !value._key ? {
    _key: randomKey$1()
  } : {};
  return path.length > 0 && !value._type && value._ref && (initial2._type = "reference"), value._ref && validateReference(value, path), Object.keys(value).reduce((acc, key) => (acc[key] = validateValue(value[key], path.concat([key])), acc), initial2);
}
function validateParameter(schema2, parameter, template, index) {
  if (!parameter.name)
    throw new Error(`Template ${template.id} has a parameter at index ${index} that is missing its "name"-property`);
  if (parameter.name === "template")
    throw new Error(`Template parameters cannot be named "template", see parameter #${index} for template ${template.id}`);
  if (!schema2.get(parameter.type))
    throw new Error(`Template parameter "${parameter.name}" has an invalid/unknown type: "${parameter.type}"`);
}
function validateReference(value, path = []) {
  if (!value._type && value.type)
    throw new Error(`Reference is missing "_type", but has a "type" property at path "${toString(path)}"`);
  const disallowed = Object.keys(value).filter((key) => !ALLOWED_REF_PROPS.includes(key));
  if (disallowed.length > 0) {
    const plural = disallowed.length > 1 ? "properties" : "property";
    throw new Error(`Disallowed ${plural} found in reference: ${disallowed.map(quote).join(", ")} at path "${toString(path)}"`);
  }
}
function isBuilder(template) {
  return isRecord$1(template) && typeof template.serialize == "function";
}
const cache$5 = /* @__PURE__ */ new WeakMap();
async function resolveValue(initialValueOpt, params, context, options) {
  const useCache = options?.useCache;
  if (typeof initialValueOpt == "function") {
    const cached = cache$5.get(initialValueOpt), key = JSON.stringify([params, context.projectId, context.dataset, context.currentUser?.id]);
    if (useCache && cached?.[key])
      return cached[key];
    const value = initialValueOpt(params, context);
    return useCache && cache$5.set(initialValueOpt, {
      ...cached,
      [key]: value
    }), value;
  }
  return initialValueOpt;
}
async function resolveInitialValue(schema2, template, params = {}, context, options) {
  if (isBuilder(template))
    return resolveInitialValue(schema2, template.serialize(), params, context, options);
  const {
    id: id2,
    schemaType: schemaTypeName,
    value
  } = template;
  if (!value)
    throw new Error(`Template "${id2}" has invalid "value" property`);
  let resolvedValue = await resolveValue(value, params, context, options);
  if (!isRecord$1(resolvedValue))
    throw new Error(`Template "${id2}" has invalid "value" property - must be a plain object or a resolver function returning a plain object`);
  isRecord$1(resolvedValue) && !Object.keys(resolvedValue).length && (resolvedValue = {
    _type: schemaTypeName
  }), resolvedValue = validateInitialObjectValue(resolvedValue, template);
  const schemaType = schema2.get(schemaTypeName);
  if (!schemaType)
    throw new Error(`Could not find schema type with name "${schemaTypeName}".`);
  const newValue = deepAssign(await resolveInitialValueForType(schemaType, params, DEFAULT_MAX_RECURSION_DEPTH, context, options) || {}, resolvedValue);
  return validateInitialObjectValue(newValue, template);
}
function getItemType$1(arrayType, item) {
  const itemTypeName = resolveTypeName$1(item);
  return itemTypeName === "object" && arrayType.of.length === 1 ? arrayType.of[0] : arrayType.of.find((memberType) => memberType.name === itemTypeName);
}
const DEFAULT_MAX_RECURSION_DEPTH = 10, memoizeResolveInitialValueForType = (fn) => {
  const resolveInitialValueForTypeCache = /* @__PURE__ */ new WeakMap(), stableStringify = (obj) => obj !== null && typeof obj == "object" ? Array.isArray(obj) ? `[${obj.map(stableStringify).join(",")}]` : `{${Object.keys(obj).sort().map((key) => `${JSON.stringify(key)}:${stableStringify(obj[key])}`).join(",")}}` : JSON.stringify(obj), hashParameters = (params, context) => stableStringify({
    params,
    context: {
      schemaName: context.schema.name,
      projectId: context.projectId,
      dataset: context.dataset,
      currentUser: context.currentUser?.id
    }
  });
  return async function(type, params, maxDepth, context, options) {
    if (!options?.useCache) return fn(type, params, maxDepth, context, options);
    let typeCache = resolveInitialValueForTypeCache.get(type);
    typeCache || (typeCache = /* @__PURE__ */ new Map(), resolveInitialValueForTypeCache.set(type, typeCache));
    const hash2 = hashParameters(params, context), cachedResult = typeCache.get(hash2);
    if (cachedResult) return cachedResult;
    const result = await fn(type, params, maxDepth, context, options);
    return typeCache.has(hash2) || typeCache.set(hash2, result), result;
  };
}, resolveInitialValueForType = memoizeResolveInitialValueForType((type, params, maxDepth = DEFAULT_MAX_RECURSION_DEPTH, context, options) => maxDepth <= 0 ? Promise.resolve(void 0) : isObjectSchemaType(type) ? postTask(() => resolveInitialObjectValue(type, params, maxDepth, context, options)) : isArraySchemaType(type) ? postTask(() => resolveInitialArrayValue(type, params, maxDepth, context, options)) : resolveValue(type.initialValue, params, context, options));
async function resolveInitialArrayValue(type, params, maxDepth, context, options) {
  const initialArray = await resolveValue(type.initialValue, void 0, context, options);
  if (Array.isArray(initialArray))
    return Promise.all(initialArray.map(async (initialItem) => {
      const itemType = getItemType$1(type, initialItem);
      return isObjectSchemaType(itemType) ? {
        ...initialItem,
        ...await resolveInitialValueForType(itemType, params, maxDepth - 1, context, options),
        _key: randomKey$1()
      } : initialItem;
    }));
}
async function resolveInitialObjectValue(type, params, maxDepth, context, options) {
  const initialObject = {
    ...await resolveValue(type.initialValue, params, context, options) || {}
  }, fieldValues = {};
  await Promise.all(type.fields.map(async (field) => {
    const initialFieldValue = await resolveInitialValueForType(field.type, params, maxDepth - 1, context, options);
    initialFieldValue != null && (fieldValues[field.name] = initialFieldValue);
  }));
  const merged = deepAssign(fieldValues, initialObject);
  if (!isDeepEmpty(merged))
    return type.name !== "object" && (merged._type = type.name), merged;
}
function maybeSerialize(template) {
  return isBuilder(template) ? template.serialize() : template;
}
function isNonNullable(t) {
  return !!t;
}
function prepareTemplates(schema2, initialValueTemplates) {
  const serialized = initialValueTemplates.map(maybeSerialize);
  return validateTemplates(schema2, serialized);
}
function defaultTemplateForType(schemaType) {
  return {
    id: schemaType.name,
    schemaType: schemaType.name,
    title: schemaType.title || schemaType.name,
    icon: schemaType.icon,
    value: schemaType.initialValue || {
      _type: schemaType.name
    }
  };
}
function defaultTemplatesForSchema(schema2) {
  const schemaTypes = schema2.getTypeNames().filter((typeName) => !typeName.startsWith("sanity.")).map((typeName) => schema2.get(typeName)).filter(isNonNullable).filter((schemaType) => schemaType.type?.name === "document");
  return prepareTemplates(schema2, schemaTypes.map((schemaType) => defaultTemplateForType(schemaType)));
}
const LOADING_MSG = {
  type: "loading"
};
function getInitialValueStream(schema2, initialValueTemplates, documentPreviewStore, opts, context) {
  const draft$ = documentPreviewStore.observePaths({
    _type: "reference",
    _ref: getDraftId(opts.documentId)
  }, ["_type"]), published$ = documentPreviewStore.observePaths({
    _type: "reference",
    _ref: getPublishedId(opts.documentId)
  }, ["_type"]);
  return merge(draft$.pipe(map((draft) => ({
    draft
  }))), published$.pipe(map((published) => ({
    published
  })))).pipe(
    scan((prev, res) => ({
      ...prev,
      ...res
    }), {}),
    // Wait until we know the state of both draft and published
    filter((res) => "draft" in res && "published" in res),
    map((res) => res.draft || res.published),
    // Only update if we didn't previously have a document but we now do
    distinctUntilChanged((prev, next) => !!prev != !!next),
    // Prevent rapid re-resolving when transitioning between different templates
    debounceTime(25)
  ).pipe(switchMap((document2) => {
    if (document2)
      return of({
        type: "success",
        value: null
      });
    if (!opts.templateName)
      return of({
        isResolving: !1,
        initialValue: void 0,
        type: "success"
      });
    const template = initialValueTemplates.find((t) => t.id === opts.templateName);
    if (!template)
      return console.warn('Template "%s" not defined, using empty initial value', opts.templateName), of({
        isResolving: !1,
        initialValue: void 0,
        type: "success"
      });
    const initialValueWithParams$ = from(resolveInitialValue(schema2, template, opts.templateParams, context)).pipe(map((initialValue) => ({
      isResolving: !1,
      initialValue
    }))).pipe(catchError((resolveError) => (console.group("Failed to resolve initial value"), console.error(resolveError), console.error("Template ID: %s", opts.templateName), console.error("Parameters: %o", opts.templateParams), console.groupEnd(), of({
      type: "error",
      error: resolveError
    }))));
    return merge(of({
      isResolving: !0
    }), initialValueWithParams$).pipe(switchMap(({
      isResolving,
      initialValue,
      resolveError
    }) => resolveError ? of({
      type: "error",
      message: "Failed to resolve initial value"
    }) : isResolving ? of(LOADING_MSG) : of({
      type: "success",
      value: initialValue
    })));
  }), startWith(LOADING_MSG), distinctUntilChanged());
}
const fetch$1 = (client, query, params, options) => defer(() => client.observable.fetch(query, params, {
  tag: options.tag,
  filterResponse: !0,
  perspective: options.perspective
})), listen = (client, query, params, options) => defer(() => client.listen(query, params, {
  events: ["welcome", "mutation", "reconnect"],
  includeResult: !1,
  visibility: "query",
  includeAllVersions: !0,
  tag: options.tag
}));
function isWelcomeEvent(event) {
  return event.type === "welcome";
}
function listenQuery(client, query, params = {}, options = {}) {
  const fetchQuery = typeof query == "string" ? query : query.fetch, listenerQuery = typeof query == "string" ? query : query.listen, events$ = listen(client, listenerQuery, params, options).pipe(mergeMap((ev, i) => i === 0 && !isWelcomeEvent(ev) ? throwError(() => new Error(ev.type === "reconnect" ? "Could not establish EventSource connection" : `Received unexpected type of first event "${ev.type}"`)) : of(ev)), share()), [welcome$, mutationAndReconnect$] = partition$1(events$, isWelcomeEvent), isRelevantEvent = (event) => !options.transitions || event.type !== "mutation" ? !0 : options.transitions.includes(event.transition), doFetch = () => fetch$1(client, fetchQuery, params, options);
  return merge(welcome$.pipe(take$1(1)), mutationAndReconnect$.pipe(filter(isRelevantEvent), throttleTime(options.throttleTime || 1e3, asyncScheduler, {
    leading: !0,
    trailing: !0
  }))).pipe(exhaustMapWithTrailing((event) => event.type === "mutation" && event.visibility !== "query" ? timer(1200).pipe(mergeMap(doFetch)) : doFetch()));
}
function resolveTypeForDocument(client, id2, specifiedType = "*") {
  return specifiedType && specifiedType !== "*" ? of(specifiedType) : client.observable.fetch("*[sanity::versionOf($publishedId)][0]._type", {
    publishedId: getPublishedId(id2)
  }, {
    tag: "document.resolve-type"
  });
}
function getIdPairFromPublished(publishedId, version2) {
  if (version2 === "published" || version2 === "drafts")
    throw new Error('Version Id cannot be "published" or "drafts"');
  if (isVersionId(publishedId))
    throw new Error("editOpsOf does not expect a version id.");
  if (isDraftId(publishedId))
    throw new Error("editOpsOf does not expect a draft id.");
  return getIdPair(publishedId, {
    version: version2
  });
}
function createDocumentStore({
  getClient: getClient2,
  documentPreviewStore,
  historyStore,
  initialValueTemplates,
  schema: schema2,
  i18n,
  serverActionsEnabled,
  extraOptions = {},
  currentUser
}) {
  const observeDocumentPairAvailability = documentPreviewStore.unstable_observeDocumentPairAvailability, client = getClient2(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    onSyncErrorRecovery,
    onReportLatency,
    onSlowCommit
  } = extraOptions, ctx = {
    client,
    getClient: getClient2,
    observeDocumentPairAvailability,
    historyStore,
    schema: schema2,
    i18n,
    serverActionsEnabled,
    extraOptions,
    currentUser
  };
  return {
    // Public API
    checkoutPair(idPair) {
      return checkoutPair(client, idPair, serverActionsEnabled, {
        onSyncErrorRecovery,
        onReportLatency,
        onSlowCommit
      });
    },
    initialValue(opts, context) {
      return getInitialValueStream(schema2, initialValueTemplates, documentPreviewStore, opts, context);
    },
    listenQuery(query, params, listenQueryOptions) {
      return listenQuery(client, query, params, listenQueryOptions);
    },
    resolveTypeForDocument(id2, specifiedType) {
      return resolveTypeForDocument(client, id2, specifiedType);
    },
    pair: {
      consistencyStatus(publishedId, type, version2) {
        return consistencyStatus(ctx.client, getIdPairFromPublished(publishedId, version2), type, serverActionsEnabled, extraOptions);
      },
      documentEvents(publishedId, type, version2) {
        return documentEvents(ctx.client, getIdPairFromPublished(publishedId, version2), type, serverActionsEnabled, extraOptions);
      },
      editOperations(publishedId, type, version2) {
        return editOperations(ctx, getIdPairFromPublished(publishedId, version2), type);
      },
      editState(publishedId, type, version2) {
        const idPair = getIdPairFromPublished(publishedId, version2);
        return editState(ctx, idPair, type);
      },
      operationEvents(publishedId, type) {
        return operationEvents({
          client,
          historyStore,
          schema: schema2,
          serverActionsEnabled,
          extraOptions
        }).pipe(filter((result) => result.args.idPair.publishedId === publishedId && result.args.typeName === type), map((result) => {
          const {
            operationName,
            idPair: documentIds
          } = result.args;
          return result.type === "success" ? {
            type: "success",
            op: operationName,
            id: documentIds.publishedId
          } : {
            type: "error",
            op: operationName,
            id: documentIds.publishedId,
            error: result.error
          };
        }));
      },
      validation(validationTargetId, type, requirePublishedReferences) {
        const publishedId = getPublishedId(validationTargetId), idPair = getIdPair(publishedId, {
          version: getVersionFromId(validationTargetId)
        }), validationTarget = getDocumentVariantType(validationTargetId);
        return validation(ctx, idPair, type, validationTarget, requirePublishedReferences);
      }
    }
  };
}
const LOADING_STATE = {
  isLoaded: !1,
  documentType: void 0
};
function useDocumentType(documentId, t0) {
  const $ = c(14), specifiedType = t0 === void 0 ? "*" : t0, documentStore = useDocumentStore();
  let t1;
  $[0] !== documentId ? (t1 = getPublishedId(documentId), $[0] = documentId, $[1] = t1) : t1 = $[1];
  const publishedId = t1, isResolved = !!(specifiedType && specifiedType !== "*");
  let t2;
  $[2] !== specifiedType ? (t2 = {
    documentType: specifiedType,
    isLoaded: !0
  }, $[2] = specifiedType, $[3] = t2) : t2 = $[3];
  const SYNC_RESOLVED_STATE = t2, [resolvedState, setDocumentType] = useState(isResolved ? SYNC_RESOLVED_STATE : LOADING_STATE);
  let t3;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setDocumentType(LOADING_STATE), $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== publishedId || $[6] !== specifiedType ? (t4 = [publishedId, specifiedType], $[5] = publishedId, $[6] = specifiedType, $[7] = t4) : t4 = $[7], useEffect(t3, t4);
  let t5, t6;
  return $[8] !== documentStore || $[9] !== isResolved || $[10] !== publishedId || $[11] !== specifiedType ? (t5 = () => {
    if (isResolved)
      return;
    const sub2 = documentStore.resolveTypeForDocument(publishedId, specifiedType).subscribe((documentType) => setDocumentType({
      documentType,
      isLoaded: !0
    }));
    return () => sub2.unsubscribe();
  }, t6 = [documentStore, publishedId, specifiedType, isResolved], $[8] = documentStore, $[9] = isResolved, $[10] = publishedId, $[11] = specifiedType, $[12] = t5, $[13] = t6) : (t5 = $[12], t6 = $[13]), useEffect(t5, t6), isResolved ? SYNC_RESOLVED_STATE : resolvedState;
}
function useDocumentValues(documentId, paths) {
  const $ = c(4), documentPreviewStore = useDocumentPreviewStore();
  let t0;
  return $[0] !== documentId || $[1] !== documentPreviewStore || $[2] !== paths ? (t0 = documentId ? documentPreviewStore.observePaths({
    _type: "reference",
    _ref: documentId
  }, paths) : of(void 0), $[0] = documentId, $[1] = documentPreviewStore, $[2] = paths, $[3] = t0) : t0 = $[3], useLoadable(t0);
}
function isNewDocument(editState2) {
  if (editState2?.ready)
    return [editState2.draft, editState2.published, editState2.version].every((version2) => version2 === null);
}
function selectUpstreamVersion(upstreamEditState) {
  return upstreamEditState.version ?? upstreamEditState.published;
}
function useInitialValue(props2) {
  const $ = c(17), {
    documentId,
    documentType,
    templateName,
    templateParams: templateParamsRaw,
    version: version2
  } = props2, templateParams = useUnique(templateParamsRaw), documentStore = useDocumentStore(), context = useInitialValueResolverContext();
  let t0;
  $[0] !== documentId || $[1] !== version2 ? (t0 = version2 ? getVersionId(documentId, version2) : documentId, $[0] = documentId, $[1] = version2, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] !== documentType || $[4] !== t0 ? (t1 = {
    _id: t0,
    _type: documentType
  }, $[3] = documentType, $[4] = t0, $[5] = t1) : t1 = $[5];
  const defaultValue2 = t1;
  let t2;
  $[6] !== defaultValue2 ? (t2 = {
    loading: !1,
    error: null,
    value: defaultValue2
  }, $[6] = defaultValue2, $[7] = t2) : t2 = $[7];
  const [state, setState] = useState(t2);
  let t3, t4;
  return $[8] !== context || $[9] !== defaultValue2 || $[10] !== documentId || $[11] !== documentStore || $[12] !== documentType || $[13] !== templateName || $[14] !== templateParams ? (t3 = () => {
    const initialValueOptions = {
      documentId,
      documentType,
      templateName,
      templateParams
    }, sub2 = documentStore.initialValue(initialValueOptions, context).subscribe((msg) => {
      msg.type === "loading" && setState({
        loading: !0,
        error: null,
        value: defaultValue2
      }), msg.type === "success" && setState({
        loading: !1,
        error: null,
        value: msg.value ? {
          ...defaultValue2,
          ...msg.value
        } : defaultValue2
      }), msg.type === "error" && setState({
        loading: !1,
        error: msg.error,
        value: defaultValue2
      });
    });
    return setState({
      loading: !0,
      error: null,
      value: defaultValue2
    }), () => sub2.unsubscribe();
  }, t4 = [defaultValue2, documentId, documentStore, documentType, templateName, templateParams, context], $[8] = context, $[9] = defaultValue2, $[10] = documentId, $[11] = documentStore, $[12] = documentType, $[13] = templateName, $[14] = templateParams, $[15] = t3, $[16] = t4) : (t3 = $[15], t4 = $[16]), useEffect(t3, t4), state;
}
function useInitialValueResolverContext() {
  const $ = c(6), source = useSource(), schema2 = useSchema(), currentUser = useCurrentUser(), projectId = useProjectId(), dataset = useDataset(), getClient2 = source.getClient;
  let t0;
  return $[0] !== currentUser || $[1] !== dataset || $[2] !== getClient2 || $[3] !== projectId || $[4] !== schema2 ? (t0 = {
    projectId,
    dataset,
    getClient: getClient2,
    schema: schema2,
    currentUser
  }, $[0] = currentUser, $[1] = dataset, $[2] = getClient2, $[3] = projectId, $[4] = schema2, $[5] = t0) : t0 = $[5], t0;
}
function useResolveInitialValueForType() {
  const $ = c(2), initialValueContext = useInitialValueResolverContext();
  let t0;
  return $[0] !== initialValueContext ? (t0 = (type, params) => resolveInitialValueForType(type, params, DEFAULT_MAX_RECURSION_DEPTH, initialValueContext), $[0] = initialValueContext, $[1] = t0) : t0 = $[1], t0;
}
const DocumentDesynced = defineEvent({
  name: "Document Desynced",
  version: 1,
  description: 'Occurs when a "hole" in events from the document pair listener is detected and recovered from.'
}), DocumentPairLoadingMeasured = defineEvent({
  name: "Document Pair Load Time Measured",
  version: 1,
  description: "Time from document pair subscription to first ready snapshot",
  maxSampleRate: 3e4
}), HighListenerLatencyOccurred = defineEvent({
  name: "High Listener Latency Detected",
  version: 1,
  description: "Emits when a high listener latency is detected"
});
function getSchemaType(schema2, typeName) {
  const type = schema2.get(typeName);
  if (!type)
    throw new Error(`No such schema type: ${typeName}`);
  return type;
}
function getPairPermissions({
  grantsStore,
  permission,
  draft,
  version: version2,
  published,
  liveEdit
}) {
  const effectiveVersion = version2 || draft || published, effectiveVersionType = effectiveVersion === version2 ? version2 : effectiveVersion === draft ? "draft" : "published", {
    checkDocumentPermission
  } = grantsStore;
  switch (permission) {
    case "delete":
      return liveEdit ? [["delete published document (live-edit)", checkDocumentPermission("update", published)]] : [["delete draft document", checkDocumentPermission("update", draft)], ["delete published document", checkDocumentPermission("update", published)]];
    case "discardDraft":
      return liveEdit ? [] : [["delete draft document", checkDocumentPermission("update", draft)]];
    case "discardVersion":
      return liveEdit ? [] : [["delete version", checkDocumentPermission("update", version2 || null)]];
    case "publish":
      return liveEdit ? [] : [
        // precondition
        ["update published document at its current state", checkDocumentPermission("update", published)],
        // post condition
        ["delete draft document", checkDocumentPermission("update", draft)],
        ["create published document from draft", checkDocumentPermission("create", draft && {
          ...draft,
          _id: getPublishedId(draft._id)
        })]
      ];
    case "unpublish":
      return liveEdit ? [] : [
        // precondition
        ["update draft document at its current state", checkDocumentPermission("create", draft)],
        // post condition
        ["delete published document", checkDocumentPermission("update", published)],
        ["create draft document from published version", checkDocumentPermission("create", published && {
          ...published,
          _id: getDraftId(published._id)
        })]
      ];
    case "update":
      return liveEdit ? [["update published document (live-edit)", checkDocumentPermission("update", published)]] : [[`update ${effectiveVersionType} document`, checkDocumentPermission("update", effectiveVersion)]];
    case "duplicate":
      return liveEdit ? [["create new published document from existing document (live-edit)", checkDocumentPermission("create", {
        ...published,
        _id: "dummy-id"
      })]] : [[`create new draft document from existing ${effectiveVersionType} document`, checkDocumentPermission("create", {
        ...effectiveVersion,
        _id: getDraftId("dummy-id")
      })]];
    default:
      throw new Error(`Could not match permission: ${permission}`);
  }
}
function getDocumentPairPermissions({
  client,
  grantsStore,
  schema: schema2,
  id: id2,
  permission,
  type,
  serverActionsEnabled,
  version: v,
  pairListenerOptions
}) {
  if (type === "*")
    return of({
      granted: !1,
      reason: "Type specified was `*`"
    });
  const liveEdit = !!getSchemaType(schema2, type).liveEdit;
  return snapshotPair(client, getIdPair(id2, {
    version: v
  }), type, serverActionsEnabled, pairListenerOptions).pipe(switchMap((pair) => combineLatest([pair.draft.snapshots$, pair.published.snapshots$, pair.version?.snapshots$ || of(null)]).pipe(map(([draft, published, version2]) => ({
    draft,
    published,
    version: version2
  })))), switchMap(({
    draft,
    published,
    version: version2
  }) => {
    const pairPermissions = getPairPermissions({
      grantsStore,
      permission,
      draft,
      version: version2,
      published,
      liveEdit
    }).map(([label, observable]) => observable.pipe(map(({
      granted,
      reason
    }) => ({
      granted,
      reason: granted ? "" : `not allowed to ${label}: ${reason}`,
      label,
      permission
    }))));
    return pairPermissions.length ? combineLatest(pairPermissions).pipe(map((permissionResults) => {
      const granted = permissionResults.every((permissionResult) => permissionResult.granted), reason = granted ? "" : `Unable to ${permission}:
	${permissionResults.filter((permissionResult) => !permissionResult.granted).map((permissionResult) => permissionResult.reason).join(`
	`)}`;
      return {
        granted,
        reason
      };
    })) : of({
      granted: !0,
      reason: ""
    });
  }));
}
const useDocumentPairPermissionsFromHookFactory = createHookFromObservableFactory(getDocumentPairPermissions);
function useDocumentPairPermissions(t0) {
  const $ = c(14), {
    id: id2,
    type,
    version: version2,
    permission,
    client: overrideClient,
    schema: overrideSchema,
    grantsStore: overrideGrantsStore,
    pairListenerOptions
  } = t0, defaultClient = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), defaultSchema = useSchema(), defaultGrantsStore = useGrantsStore(), workspace = useWorkspace(), client = overrideClient || defaultClient, schema2 = overrideSchema || defaultSchema, grantsStore = overrideGrantsStore || defaultGrantsStore;
  let t1;
  $[0] !== workspace.__internal_serverDocumentActions?.enabled ? (t1 = () => {
    const configFlag = workspace.__internal_serverDocumentActions?.enabled;
    return typeof configFlag == "boolean" ? of(configFlag) : of(!0);
  }, $[0] = workspace.__internal_serverDocumentActions?.enabled, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = t1(), $[2] = t1, $[3] = t2) : t2 = $[3];
  const serverActionsEnabled = t2;
  let t3;
  return $[4] !== client || $[5] !== grantsStore || $[6] !== id2 || $[7] !== pairListenerOptions || $[8] !== permission || $[9] !== schema2 || $[10] !== serverActionsEnabled || $[11] !== type || $[12] !== version2 ? (t3 = {
    client,
    schema: schema2,
    grantsStore,
    id: id2,
    permission,
    type,
    serverActionsEnabled,
    pairListenerOptions,
    version: version2
  }, $[4] = client, $[5] = grantsStore, $[6] = id2, $[7] = pairListenerOptions, $[8] = permission, $[9] = schema2, $[10] = serverActionsEnabled, $[11] = type, $[12] = version2, $[13] = t3) : t3 = $[13], useDocumentPairPermissionsFromHookFactory(t3);
}
function getDocumentValuePermissions({
  grantsStore,
  document: document2,
  permission
}) {
  const {
    checkDocumentPermission
  } = grantsStore;
  return checkDocumentPermission(permission, document2);
}
const INITIAL_STATE$c = [void 0, !0];
function stateReducer(prev, action) {
  const [prevResult, prevIsLoading] = prev;
  switch (action.type) {
    // Keep the old value around while loading a new one. Prevents "jittering" UIs, and permissions
    // usually don't change _that_ rapidly (this hook runs on every single document change).
    case "loading":
      return [prevResult, !0];
    case "value":
      return !prevIsLoading && isEqual$1(action.value, prevResult) ? prev : [action.value, !1];
    case "error":
      throw action.error;
    default:
      throw new Error(`Invalid action type: ${action}`);
  }
}
function useDocumentValuePermissions(t0) {
  const $ = c(5), {
    document: document2,
    permission,
    grantsStore: specifiedGrantsStore
  } = t0, defaultGrantsStore = useGrantsStore(), grantsStore = specifiedGrantsStore || defaultGrantsStore, [state, dispatch] = useReducer(stateReducer, INITIAL_STATE$c), subscriptionRef = useRef(null);
  let t1, t2;
  return $[0] !== document2 || $[1] !== grantsStore || $[2] !== permission ? (t1 = () => {
    dispatch({
      type: "loading"
    }), subscriptionRef.current && subscriptionRef.current.unsubscribe();
    const permissions$ = getDocumentValuePermissions({
      grantsStore,
      document: document2,
      permission
    });
    return subscriptionRef.current = permissions$.pipe(distinctUntilChanged$1(_temp$44)).subscribe({
      next: (value) => dispatch({
        type: "value",
        value
      }),
      error: (error) => dispatch({
        type: "error",
        error
      })
    }), () => {
      subscriptionRef.current && (subscriptionRef.current.unsubscribe(), subscriptionRef.current = null);
    };
  }, t2 = [grantsStore, document2, permission], $[0] = document2, $[1] = grantsStore, $[2] = permission, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]), useEffect(t1, t2), state;
}
function _temp$44(prev, next) {
  return isEqual$1(prev, next);
}
function refCountDelay(duration, scheduler = asapScheduler) {
  return (source) => {
    const connectable = source;
    let connectableSubscription = null, connectorSubscription = null;
    const notifier = new Subject(), connector = notifier.pipe(scan((count2, step) => count2 + step, 0), switchMap((count2) => count2 === 0 ? timer(duration, scheduler).pipe(tap(() => {
      connectableSubscription && (connectableSubscription.unsubscribe(), connectableSubscription = null), connectorSubscription && (connectorSubscription.unsubscribe(), connectorSubscription = null);
    })) : !connectableSubscription && count2 > 0 ? timer(0, scheduler).pipe(tap(() => {
      connectableSubscription || (connectableSubscription = connectable.connect());
    })) : NEVER));
    return using(() => (connectorSubscription || (connectorSubscription = connector.subscribe()), notifier.next(1), {
      unsubscribe: () => notifier.next(-1)
    }), () => source);
  };
}
const DEBUG_PREFIX = "_debug_", hashchange$ = typeof window > "u" ? of({}) : fromEvent(window, "hashchange"), debugParams$ = concat(of(0), hashchange$).pipe(map(() => typeof document > "u" ? "#" : document.location.hash), distinctUntilChanged(), map((hash2) => hash2.slice(1).split(";").filter((p) => p.toLowerCase().startsWith(DEBUG_PREFIX)).map((param) => param.slice(DEBUG_PREFIX.length)))), debugRolesParam$ = debugParams$.pipe(map((args) => args.find((arg) => arg.startsWith("roles="))), map((arg) => arg?.split("roles=")[1].split(",").map((r) => r.trim()) || [])), administrator = [{
  filter: '_id in path("**")',
  permissions: ["read", "create", "history", "update"]
}], editor = [{
  filter: '_id in path("**")',
  permissions: ["read", "create", "history", "update"]
}], developer = [{
  filter: '_id in path("**")',
  permissions: ["read", "create", "history", "update"]
}], contributor = [{
  filter: '_id in path("**")',
  permissions: ["read"]
}, {
  filter: '_id in path("drafts.**")',
  permissions: ["create", "history", "update"]
}], viewer = [{
  filter: '_id in path("**")',
  permissions: ["read", "history"]
}], requiresApproval = [{
  filter: "!locked",
  permissions: ["read", "create", "update"]
}], restricted = [{
  filter: '_id in path("drafts.**") && _type in ["stringsTest", "book", "author", "referenceTest"]',
  permissions: ["read", "create", "history", "update"]
}, {
  filter: '_id in path("**")',
  permissions: ["read"]
}], DEBUG_ROLE_GRANTS_MAP = {
  // basic
  administrator,
  editor,
  developer,
  contributor,
  viewer,
  // custom
  restricted,
  requiresApproval,
  // legacy
  read: viewer,
  write: editor
}, debugGrants$ = debugRolesParam$.pipe(map((roles) => roles.length ? roles.filter((value) => !!value && value in DEBUG_ROLE_GRANTS_MAP).flatMap((roleName) => DEBUG_ROLE_GRANTS_MAP[roleName] || []) : null));
async function getDatasetGrants(client, projectId, dataset) {
  return await client.request({
    uri: `/projects/${projectId}/datasets/${dataset}/acl`,
    tag: "acl.get"
  });
}
function getParams(userId) {
  const params = {};
  return userId !== null && (params.identity = userId), params;
}
const PARSED_FILTERS_MEMO = /* @__PURE__ */ new Map();
async function matchesFilter(userId, filter2, document2) {
  PARSED_FILTERS_MEMO.has(filter2) || PARSED_FILTERS_MEMO.set(filter2, parse$1(`*[${filter2}]`));
  const parsed = PARSED_FILTERS_MEMO.get(filter2), evalParams = getParams(userId), {
    identity: identity2
  } = evalParams, params = {
    ...evalParams
  };
  return (await (await evaluate(parsed, {
    dataset: [document2],
    identity: identity2,
    params
  })).get())?.length === 1;
}
function createGrantsStore(opts) {
  const {
    client
  } = opts, versionedClient2 = client.withConfig({
    apiVersion: "2021-06-07"
  }), userId = "userId" in opts ? opts.userId : opts?.currentUser?.id || null, datasetGrants$ = defer(() => of(versionedClient2.config())).pipe(switchMap(({
    projectId,
    dataset
  }) => {
    if (!projectId || !dataset)
      throw new Error("Missing projectId or dataset");
    return getDatasetGrants(versionedClient2, projectId, dataset);
  })), currentUserDatasetGrants = debugGrants$.pipe(switchMap((debugGrants) => debugGrants ? of(debugGrants) : datasetGrants$), publishReplay(1), refCountDelay(1e3));
  return {
    checkDocumentPermission(permission, document2) {
      return currentUserDatasetGrants.pipe(switchMap((grants) => grantsPermissionOn(userId, grants, permission, document2)), distinctUntilChanged(shallowEquals));
    }
  };
}
async function grantsPermissionOn(userId, grants, permission, document2) {
  if (!document2)
    return {
      granted: !0,
      reason: "Null document, nothing to check"
    };
  if (!grants.length)
    return {
      granted: !1,
      reason: "No document grants"
    };
  const matchingGrants = [];
  for (const grant of grants)
    await matchesFilter(userId, grant.filter, document2) && matchingGrants.push(grant);
  const foundMatch = matchingGrants.some((grant) => grant.permissions.some((p) => p === permission));
  return {
    granted: foundMatch,
    reason: foundMatch ? "Matching grant" : "No matching grants found"
  };
}
function serialize$5(item) {
  return typeof item == "object" && item !== null && "serialize" in item ? serialize$5(item.serialize()) : item;
}
function getTemplatePermissions({
  grantsStore,
  templateItems,
  templates,
  schema: schema2,
  context
}) {
  return templateItems?.length ? defer(() => from(templateItems).pipe(
    // Serialize and resolve each item one at a time
    concatMap$1(async (item) => {
      const serializedItem = serialize$5(item), template = templates.find((t) => t.id === serializedItem.templateId);
      if (!template)
        throw new Error(`template not found: "${serializedItem.templateId}"`);
      const resolvedInitialValue = await resolveInitialValue(schema2, template, serializedItem.parameters, context, {
        useCache: !0
      });
      return {
        item: serializedItem,
        template,
        resolvedInitialValue
      };
    }),
    // Convert each resolved item into a permission check observable
    map(({
      item,
      template,
      resolvedInitialValue
    }) => {
      const schemaType = schema2.get(template.schemaType);
      if (!schemaType)
        throw new Error(`schema type not found: "${template.schemaType}"`);
      const liveEdit = schemaType?.liveEdit, {
        initialDocumentId = "dummy-id"
      } = item, documentId = liveEdit ? getPublishedId(initialDocumentId) : getDraftId(initialDocumentId);
      return getDocumentValuePermissions({
        grantsStore,
        permission: "create",
        document: {
          _id: documentId,
          _type: schemaType.name,
          ...resolvedInitialValue
        }
      }).pipe(map(({
        granted,
        reason
      }) => ({
        ...item,
        granted,
        reason,
        resolvedInitialValue,
        template,
        i18n: item.i18n || template.i18n,
        title: item.title || template.title,
        subtitle: schemaType.title === (item.title || template.title) ? void 0 : schemaType.title,
        description: item.description || template.description,
        icon: item.icon || template.icon
      })));
    }),
    // Collect all permission check observables
    toArray$1(),
    // Switch to combined observable of all permission checks
    switchMap((observables) => combineLatest(observables))
  )) : of([]);
}
const useTemplatePermissionsFromHookFactory = createHookFromObservableFactory(getTemplatePermissions);
function useTemplatePermissions(t0) {
  const $ = c(9);
  let rest, templateItems;
  $[0] !== t0 ? ({
    templateItems,
    ...rest
  } = t0, $[0] = t0, $[1] = rest, $[2] = templateItems) : (rest = $[1], templateItems = $[2]);
  const schema2 = useSchema(), templates = useTemplates(), grantsStore = useGrantsStore(), initialValueContext = useInitialValueResolverContext(), t1 = rest.grantsStore || grantsStore, t2 = rest.schema || schema2, t3 = rest.templates || templates;
  let t4;
  return $[3] !== initialValueContext || $[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== templateItems ? (t4 = {
    templateItems,
    grantsStore: t1,
    schema: t2,
    templates: t3,
    context: initialValueContext
  }, $[3] = initialValueContext, $[4] = t1, $[5] = t2, $[6] = t3, $[7] = templateItems, $[8] = t4) : t4 = $[8], useTemplatePermissionsFromHookFactory(t4);
}
const isDev = process.env.NODE_ENV !== "production", isProd = !isDev;
function canMergeEdit(type) {
  return type === "create" || type === "editDraft";
}
const CHUNK_WINDOW = 300 * 1e3;
function isWithinMergeWindow$1(a, b) {
  return Date.parse(b) - Date.parse(a) < CHUNK_WINDOW;
}
function mergeChunk(left, right) {
  if (left.end !== right.start) throw new Error("chunks are not next to each other");
  const draftState = combineState(left.draftState, right.draftState), publishedState = combineState(left.publishedState, right.publishedState);
  if (left.type === "delete" && right.type === "editDraft")
    return [left, {
      ...right,
      type: "create",
      draftState,
      publishedState
    }];
  if (right.type === "delete") {
    if (draftState === "missing" && publishedState === "present")
      return [left, {
        ...right,
        type: "discardDraft",
        draftState,
        publishedState
      }];
    if (draftState === "present" && publishedState === "missing")
      return [left, {
        ...right,
        type: "unpublish",
        draftState,
        publishedState
      }];
  }
  if (canMergeEdit(left.type) && right.type === "editDraft" && isWithinMergeWindow$1(left.endTimestamp, right.startTimestamp)) {
    const authors = /* @__PURE__ */ new Set();
    for (const author of left.authors) authors.add(author);
    for (const author of right.authors) authors.add(author);
    return {
      index: 0,
      id: right.id,
      type: left.type,
      start: left.start,
      end: right.end,
      startTimestamp: left.startTimestamp,
      endTimestamp: right.endTimestamp,
      authors,
      draftState,
      publishedState
    };
  }
  return [left, {
    ...right,
    draftState,
    publishedState
  }];
}
function getChunkState(effect) {
  const modified = !!effect;
  return effect && isDeletePatch$1(effect?.apply) ? "deleted" : modified ? "upsert" : "unedited";
}
function getChunkType(transaction) {
  const draftState = getChunkState(transaction.draftEffect), publishedState = getChunkState(transaction.publishedEffect);
  if (publishedState === "unedited") {
    if (draftState === "deleted")
      return "delete";
    if (draftState === "upsert")
      return "editDraft";
  }
  if (publishedState === "deleted")
    return "delete";
  if (publishedState === "upsert") {
    if (draftState === "unedited")
      return "editLive";
    if (draftState === "deleted")
      return "publish";
    if (draftState === "upsert")
      return "editLive";
  }
  return "editLive";
}
function chunkFromTransaction(transaction) {
  const modifiedDraft = !!transaction.draftEffect, modifiedPublished = !!transaction.publishedEffect, draftDeleted = transaction.draftEffect && isDeletePatch$1(transaction.draftEffect.apply), publishedDeleted = transaction.publishedEffect && isDeletePatch$1(transaction.publishedEffect.apply), type = getChunkType(transaction);
  return {
    index: 0,
    id: transaction.id,
    type,
    start: transaction.index,
    end: transaction.index + 1,
    startTimestamp: transaction.timestamp,
    endTimestamp: transaction.timestamp,
    authors: /* @__PURE__ */ new Set([transaction.author]),
    draftState: modifiedDraft ? draftDeleted ? "missing" : "present" : "unknown",
    publishedState: modifiedPublished ? publishedDeleted ? "missing" : "present" : "unknown"
  };
}
function combineState(left, right) {
  return right === "unknown" ? left : right;
}
function isDeletePatch$1(patch2) {
  return patch2[0] === 0 && patch2[1] === null;
}
function isSameAnnotation(a, b) {
  return a && b ? a.author === b.author && a.timestamp === b.timestamp : !a && !b;
}
function getAttrs$1(doc) {
  return doc.draft || doc.published;
}
class ArrayContentWrapper {
  type = "array";
  elements = [];
  constructor(content, value, annotation, extractor) {
    this.content = content, this.value = value, this.annotation = annotation, this.extractor = extractor, this.length = content.elements.length;
  }
  at(idx) {
    if (idx >= this.length) throw new Error("out of bounds");
    return this.elements[idx] || (this.elements[idx] = wrapValue(this.content.elements[idx], this.value[idx], this.extractor));
  }
  annotationAt(idx) {
    const meta = this.content.metas[idx];
    return this.extractor.fromMeta(meta);
  }
}
class ObjectContentWrapper {
  type = "object";
  fields = {};
  constructor(content, value, annotation, extractor) {
    this.content = content, this.value = value, this.annotation = annotation, this.extractor = extractor, this.keys = Object.keys(content.fields);
  }
  get(key) {
    const input = this.fields[key];
    if (input)
      return input;
    const value = this.content.fields[key];
    if (value)
      return this.fields[key] = wrapValue(value, this.value[key], this.extractor);
  }
}
class StringContentWrapper {
  type = "string";
  constructor(content, value, annotation, extractor) {
    this.content = content, this.value = value, this.annotation = annotation, this.extractor = extractor;
  }
  sliceAnnotation(start, end) {
    const result = [];
    let idx = 0;
    function push(text, annotation) {
      if (result.length > 0) {
        const lst = result[result.length - 1];
        if (isSameAnnotation(lst.annotation, annotation)) {
          lst.text += text;
          return;
        }
      }
      result.push({
        text,
        annotation
      });
    }
    for (const part of this.content.parts) {
      const length = part.value.length, subStart = Math.max(0, start - idx);
      if (subStart < length) {
        const subEnd = Math.min(length, end - idx);
        if (subEnd <= 0) break;
        push(part.value.slice(subStart, subEnd), this.extractor.fromValue(part));
      }
      idx += length;
    }
    return result;
  }
}
function wrapValue(value, raw, extractor) {
  const annotation = extractor.fromValue(value);
  if (value.content)
    switch (value.content.type) {
      case "array":
        return new ArrayContentWrapper(value.content, raw, annotation, extractor);
      case "object":
        return new ObjectContentWrapper(value.content, raw, annotation, extractor);
      case "string":
        return new StringContentWrapper(value.content, raw, annotation, extractor);
    }
  return wrap$1(raw, annotation);
}
function extractAnnotationForFromInput$1(timeline, firstChunk, meta) {
  return meta ? annotationForTransactionIndex$1(timeline, meta.transactionIndex + 1, meta.chunk.index) : firstChunk ? annotationForTransactionIndex$1(timeline, firstChunk.start, firstChunk.index) : null;
}
function extractAnnotationForToInput$1(timeline, meta) {
  return meta ? annotationForTransactionIndex$1(timeline, meta.transactionIndex, meta.chunk.index) : null;
}
function annotationForTransactionIndex$1(timeline, idx, chunkIdx) {
  const tx = timeline.transactionByIndex(idx);
  if (!tx) return null;
  const chunk = timeline.chunkByTransactionIndex(idx, chunkIdx);
  return chunk ? {
    chunk,
    timestamp: tx.timestamp,
    author: tx.author
  } : null;
}
function diffValue$1(timeline, firstChunk, from2, fromRaw, to, toRaw) {
  const fromInput = wrapValue(from2, fromRaw, {
    fromValue(value) {
      return extractAnnotationForFromInput$1(timeline, firstChunk, value.endMeta);
    },
    fromMeta(meta) {
      return extractAnnotationForFromInput$1(timeline, firstChunk, meta);
    }
  }), toInput = wrapValue(to, toRaw, {
    fromValue(value) {
      return extractAnnotationForToInput$1(timeline, value.startMeta);
    },
    fromMeta(meta) {
      return extractAnnotationForToInput$1(timeline, meta);
    }
  });
  return diffInput(fromInput, toInput);
}
class TwoEndedArray {
  _postive = [];
  _negative = [];
  addToEnd(elem) {
    elem.index = this._postive.length, this._postive.push(elem);
  }
  addToBeginning(elem) {
    if (this.length == 0) {
      this.addToEnd(elem);
      return;
    }
    elem.index = -(this._negative.length + 1), this._negative.push(elem);
  }
  mergeAtEnd(value, merger) {
    if (this.length === 0) {
      this.addToEnd(value);
      return;
    }
    const idx = this.lastIdx, result = merger(this.get(idx), value);
    Array.isArray(result) ? (this.set(idx, result[0]), this.addToEnd(result[1])) : this.set(idx, result);
  }
  mergeAtBeginning(value, merger) {
    if (this.length === 0) {
      this.addToEnd(value);
      return;
    }
    const idx = this.firstIdx, result = merger(value, this.get(idx));
    Array.isArray(result) ? (this.set(idx, result[1]), this.addToBeginning(result[0])) : this.set(idx, result);
  }
  removeFromEnd() {
    this._postive.length === 0 ? this._negative.shift() : this._postive.pop();
  }
  has(idx) {
    return idx >= 0 ? idx < this._postive.length : -(idx + 1) < this._negative.length;
  }
  get(idx) {
    return idx >= 0 ? this._postive[idx] : this._negative[-(idx + 1)];
  }
  set(idx, value) {
    idx >= 0 ? (value.index = idx, this._postive[idx] = value) : (value.index = idx, this._negative[-(idx + 1)] = value);
  }
  get lastIdx() {
    return this._postive.length - 1;
  }
  get last() {
    return this.get(this.lastIdx);
  }
  get firstIdx() {
    return -this._negative.length;
  }
  get first() {
    return this.get(this.firstIdx);
  }
  get length() {
    return this._postive.length + this._negative.length;
  }
}
class Timeline {
  reachedEarliestEntry = !1;
  _transactions = new TwoEndedArray();
  _chunks = new TwoEndedArray();
  // These two properties are here to handle the case
  _possiblePendingTransactions = /* @__PURE__ */ new Map();
  constructor(opts) {
    this.publishedId = opts.publishedId, this.draftId = `drafts.${opts.publishedId}`, opts.enableTrace && (this._trace = [], this._trace.push({
      type: "initial",
      publishedId: opts.publishedId
    }), window.__sanityTimelineTrace = this._trace);
  }
  get chunkCount() {
    return this._chunks.length;
  }
  /** Maps over the chunk from newest to oldest. */
  mapChunks(mapper) {
    const result = [], firstIdx = this._chunks.firstIdx, lastIdx = this._chunks.lastIdx;
    for (let idx = lastIdx; idx >= firstIdx; idx--)
      result.push(mapper(this._chunks.get(idx), idx));
    return result;
  }
  reset() {
    this._transactions = new TwoEndedArray(), this._chunks = new TwoEndedArray(), this._possiblePendingTransactions = /* @__PURE__ */ new Map(), this._recreateTransactionsFrom = void 0, this.reachedEarliestEntry = !1;
  }
  /**
   * Adds a remote mutation to the timeline. This methods assumes that the remote mutations
   * come in correct order for their respective version, but has no ordering requirements
   * across draft/published.
   *
   * Example: [D1, D2, P1] (where D1 and P1 were mutations done to the draft and published
   * version in the same transaction) is a valid input. [P1, D2, D1] is _not_ valid since
   * the mutation for the draft is out of order.
   */
  addRemoteMutation(entry) {
    this._trace && this._trace.push({
      type: "addRemoteMutation",
      event: entry
    });
    const pending = this._possiblePendingTransactions.get(entry.transactionId), transaction = pending ? pending.transaction : {
      index: 0,
      id: entry.transactionId,
      timestamp: entry.timestamp.toISOString(),
      author: entry.author
    };
    entry.version === "draft" ? transaction.draftEffect = entry.effects : transaction.publishedEffect = entry.effects, pending ? (this._possiblePendingTransactions.delete(entry.transactionId), this._invalidateTransactionFrom(pending.idx)) : (this._transactions.addToEnd(transaction), this._possiblePendingTransactions.set(entry.transactionId, {
      transaction,
      idx: this._transactions.lastIdx
    }));
  }
  addTranslogEntry(event) {
    this._trace && this._trace.push({
      type: "addTranslogEntry",
      event
    }), this._transactions.addToBeginning({
      index: 0,
      id: event.id,
      author: event.author,
      timestamp: event.timestamp,
      draftEffect: event.effects[this.draftId],
      publishedEffect: event.effects[this.publishedId]
    });
  }
  /** Mark that we've reached the earliest entry. */
  didReachEarliestEntry() {
    this._trace && this._trace.push({
      type: "didReachEarliestEntry"
    }), this.reachedEarliestEntry = !0;
  }
  /**
   * updateChunks synchronizes the chunks to match the current state
   * of the transactions array. After calling this method you need
   * to invalidate all Chunks.
   */
  updateChunks() {
    this._trace && this._trace.push({
      type: "updateChunks"
    }), this._removeInvalidatedChunks(), this._addChunksFromTransactions(), this._createInitialChunk();
  }
  _removeInvalidatedChunks() {
    if (this._recreateTransactionsFrom) {
      for (; this._chunks.length > 0; ) {
        const chunk = this._chunks.last;
        if (this._recreateTransactionsFrom < chunk.end)
          this._chunks.removeFromEnd();
        else
          break;
      }
      this._recreateTransactionsFrom = void 0;
    }
  }
  _addChunksFromTransactions() {
    const firstIdx = this._transactions.firstIdx, lastIdx = this._transactions.lastIdx, nextTransactionToChunk = this._chunks.length > 0 ? this._chunks.last.end : firstIdx;
    for (let idx = nextTransactionToChunk; idx <= lastIdx; idx++) {
      const transaction = this._transactions.get(idx);
      this._chunks.mergeAtEnd(chunkFromTransaction(transaction), mergeChunk);
    }
    if (this._chunks.length == 0) return;
    const firstTransactionChunked = this._chunks.first.start;
    for (let idx = firstTransactionChunked - 1; idx >= firstIdx; idx--) {
      const transaction = this._transactions.get(idx);
      this._chunks.mergeAtBeginning(chunkFromTransaction(transaction), mergeChunk);
    }
  }
  _invalidateTransactionFrom(idx) {
    (this._recreateTransactionsFrom === void 0 || idx < this._recreateTransactionsFrom) && (this._recreateTransactionsFrom = idx);
  }
  _createInitialChunk() {
    if (this.reachedEarliestEntry) {
      if (this._chunks.first?.type === "initial") return;
      const firstTx = this._transactions.first;
      if (!firstTx) return;
      const initialChunk = chunkFromTransaction(firstTx);
      initialChunk.type = "initial", initialChunk.id = "@initial", initialChunk.end = initialChunk.start, this._chunks.addToBeginning(initialChunk);
    }
  }
  /**
   * Resolves a time reference.
   *
   * Note that the chunk returned is only valid if the timeline stays constant.
   * Once the timeline is updated, you must re-parse all references.
   */
  parseTimeId(id2) {
    if (this._chunks.length === 0)
      return this.reachedEarliestEntry ? "invalid" : "loading";
    const idSegments = id2.split("/", 3), timestampStr = idSegments.shift(), chunkId = idSegments.shift(), timestamp = Number(timestampStr);
    for (let idx = this._chunks.lastIdx; idx >= this._chunks.firstIdx; idx--) {
      const chunk = this._chunks.get(idx);
      if (chunk.id === chunkId)
        return chunk;
      if (Date.parse(chunk.endTimestamp) + 3600 * 1e3 < timestamp)
        return "invalid";
    }
    return this.reachedEarliestEntry ? "invalid" : "loading";
  }
  findLastPublishedBefore(chunk) {
    for (let chunkIdx = chunk ? chunk.index - 1 : this._chunks.lastIdx; chunkIdx >= this._chunks.firstIdx; chunkIdx--) {
      const currentChunk = this._chunks.get(chunkIdx);
      if (currentChunk.type === "publish" || currentChunk.type === "initial")
        return currentChunk;
    }
    return this.reachedEarliestEntry ? this._chunks.first : "loading";
  }
  isLatestChunk(chunk) {
    return chunk === this._chunks.last;
  }
  // eslint-disable-next-line class-methods-use-this
  createTimeId(chunk) {
    return `${chunk.endTimestamp.valueOf()}/${chunk.id}`;
  }
  lastChunk() {
    return this._chunks.last;
  }
  transactionByIndex(idx) {
    return this._transactions.has(idx) ? this._transactions.get(idx) : null;
  }
  chunkByTransactionIndex(idx, startChunkIdx = 0) {
    let chunkIdx = startChunkIdx;
    for (; ; ) {
      const chunk = this._chunks.get(chunkIdx);
      if (!chunk) throw new Error("transaction does not belong in any chunk");
      if (idx >= chunk.end)
        chunkIdx++;
      else if (idx < chunk.start)
        chunkIdx--;
      else
        return chunk;
    }
  }
  replayBackwardsBetween(firstIdx, lastIdx, doc) {
    let draft = doc.draft, published = doc.published;
    for (let idx = lastIdx; idx >= firstIdx; idx--) {
      const transaction = this._transactions.get(idx);
      transaction.draftEffect && (draft = applyPatch$1(draft, transaction.draftEffect.revert)), transaction.publishedEffect && (published = applyPatch$1(published, transaction.publishedEffect.revert));
    }
    return {
      draft,
      published
    };
  }
  replayBackwardsUntil(firstIdx, doc) {
    return this.replayBackwardsBetween(firstIdx, this._transactions.lastIdx, doc);
  }
  calculateDiff(initialDoc, finalDoc, firstIdx, lastIdx) {
    let draftValue = incremental.wrap(initialDoc.draft, null), publishedValue = incremental.wrap(initialDoc.published, null);
    const initialValue = getValue(draftValue, publishedValue), initialAttributes = getAttrs$1(initialDoc);
    let firstChunk = null;
    for (let chunkIdx = firstIdx; chunkIdx <= lastIdx; chunkIdx++) {
      const chunk = this._chunks.get(chunkIdx);
      firstChunk || (firstChunk = chunk);
      for (let idx = chunk.start; idx < chunk.end; idx++) {
        const transaction = this._transactions.get(idx), meta = {
          chunk,
          transactionIndex: idx
        }, preDraftValue = draftValue, prePublishedValue = publishedValue;
        transaction.draftEffect && (draftValue = incremental.applyPatch(draftValue, transaction.draftEffect.apply, meta)), transaction.publishedEffect && (publishedValue = incremental.applyPatch(publishedValue, transaction.publishedEffect.apply, meta));
        const didHaveDriaft = incremental.getType(preDraftValue) !== "null", haveDraft = incremental.getType(draftValue) !== "null";
        incremental.getType(publishedValue) !== "null" && !haveDraft && (publishedValue = incremental.rebaseValue(preDraftValue, publishedValue)), haveDraft && !didHaveDriaft && (draftValue = incremental.rebaseValue(prePublishedValue, draftValue));
      }
    }
    const finalValue = incremental.getType(draftValue) === "null" ? publishedValue : draftValue, finalAttributes = getAttrs$1(finalDoc);
    return diffValue$1(this, firstChunk, initialValue, initialAttributes, finalValue, finalAttributes);
  }
}
function getValue(draftValue, publishedValue) {
  return incremental.getType(draftValue) === "null" ? publishedValue : draftValue;
}
function emptyVersionState(id2) {
  return {
    id: id2,
    hasAttrs: !1,
    attrs: null,
    rev: null,
    events: [],
    aligned: !1
  };
}
function align(history2, state) {
  const idx = state.events.findIndex((evt) => history2.id === evt.transactionId);
  return idx >= 0 ? idx + 1 : state.rev ? state.rev === history2.id ? 0 : -1 : 0;
}
function startFromSnapshot(state, doc) {
  if (state.hasAttrs = !0, doc) {
    if (state.attrs = {
      ...doc
    }, typeof state.attrs._rev != "string") throw new Error("snapshot has no _rev");
    state.rev = state.attrs._rev, delete state.attrs._rev;
  } else
    state.attrs = null, state.rev = null;
  state.events = [];
}
class Aligner {
  earliestTransactionId = null;
  constructor(timeline) {
    this.timeline = timeline, this._states = {
      draft: emptyVersionState(timeline.draftId),
      published: emptyVersionState(timeline.publishedId)
    };
  }
  appendRemoteSnapshotEvent(evt) {
    if (evt.version === "version")
      return;
    const state = this._states[evt.version];
    if (evt.type === "snapshot") {
      this._maybeInvalidateHistory(), startFromSnapshot(state, evt.document);
      return;
    }
    evt.type === "remoteMutation" && (state.aligned ? (this._apply(state, evt), this.timeline.addRemoteMutation(evt)) : state.hasAttrs ? state.events.push(evt) : startFromSnapshot(state, evt.head));
  }
  prependHistoryEvent(evt) {
    if (!this.acceptsHistory) throw new Error("cannot prepend history at this point");
    for (const state of Object.values(this._states))
      if (!state.aligned) {
        const idx = align(evt, state);
        idx >= 0 && this._alignAtIndex(state, idx);
      }
    this.timeline.addTranslogEntry(evt), this.earliestTransactionId = evt.id;
  }
  didReachEarliestEntry() {
    for (const state of Object.values(this._states))
      if (!state.aligned) {
        if (state.attrs !== null) throw new Error("unable to find translog entry to align to");
        this._alignAtIndex(state, 0);
      }
    this.timeline.didReachEarliestEntry();
  }
  get isAligned() {
    return Object.values(this._states).every((state) => state.aligned);
  }
  get acceptsHistory() {
    return this._isComplete;
  }
  get currentDocument() {
    return {
      draft: this._states.draft.attrs,
      published: this._states.published.attrs
    };
  }
  _alignAtIndex(state, idx) {
    for (const mutEvt of state.events.slice(0, idx))
      this._apply(state, mutEvt);
    for (const mutEvt of state.events.slice(idx))
      this._apply(state, mutEvt), this.timeline.addRemoteMutation(mutEvt);
    state.events = [], state.aligned = !0;
  }
  get _isComplete() {
    return Object.values(this._states).every((state) => state.hasAttrs);
  }
  // eslint-disable-next-line class-methods-use-this
  _apply(state, evt) {
    state.attrs = applyPatch$1(state.attrs, evt.effects.apply), state.rev = evt.transactionId;
  }
  _maybeInvalidateHistory() {
    if (this._isComplete) {
      for (const state of Object.values(this._states))
        state.aligned = !1;
      this.earliestTransactionId = null, this.timeline.reset();
    }
  }
}
async function getJsonStream(url, token) {
  const options = token ? {
    headers: {
      ...DEFAULT_STUDIO_CLIENT_HEADERS,
      Authorization: `Bearer ${token}`
    }
  } : {
    credentials: "include",
    headers: DEFAULT_STUDIO_CLIENT_HEADERS
  }, response = await fetch(url, options);
  return getStream(response);
}
function getStream(response) {
  const body = response.body;
  if (!body)
    throw new Error("Failed to read body from response");
  let reader, cancelled = !1;
  return new ReadableStream({
    start(controller) {
      reader = body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      reader.read().then(function processResult(result) {
        if (result.done) {
          if (cancelled)
            return;
          if (buffer = buffer.trim(), buffer.length === 0) {
            controller.close();
            return;
          }
          controller.enqueue(JSON.parse(buffer)), controller.close();
          return;
        }
        buffer += decoder.decode(result.value, {
          stream: !0
        });
        const lines = buffer.split(`
`);
        for (let i = 0; i < lines.length - 1; ++i) {
          const line = lines[i].trim();
          if (line.length !== 0)
            try {
              controller.enqueue(JSON.parse(line));
            } catch (err) {
              controller.error(err), cancelled = !0, reader.cancel();
              return;
            }
        }
        return buffer = lines[lines.length - 1], reader.read().then(processResult).catch((err) => controller.error(err));
      }).catch((err) => controller.error(err));
    },
    cancel() {
      cancelled = !0, reader.cancel();
    }
  });
}
class Reconstruction {
  constructor(timeline, doc, start, end) {
    this.timeline = timeline, this.start = start, this.end = end, this.doc = doc;
  }
  same(start, end) {
    return this.start === start && this.end === end;
  }
  /** Returns the attributes as seen at the end of the range. */
  endAttributes() {
    return getAttrs(this.endDocument());
  }
  endDocument() {
    return this._endDocument || (this._endDocument = this.timeline.replayBackwardsUntil(this.end.end, this.doc)), this._endDocument;
  }
  /** Returns the attributes as seen at the end of the range. */
  startAttributes() {
    return getAttrs(this.startDocument());
  }
  startDocument() {
    if (!this.start) throw new Error("start required");
    return this._startDocument || (this._startDocument = this.timeline.replayBackwardsBetween(this.start.end, this.end.end - 1, this.endDocument())), this._startDocument;
  }
  diff() {
    if (!this._diff) {
      if (!this.start) throw new Error("start required");
      this._diff = this.timeline.calculateDiff(this.startDocument(), this.endDocument(), this.start.index + 1, this.end.index);
    }
    return this._diff;
  }
}
function getAttrs(doc) {
  return doc.draft || doc.published;
}
const TRANSLOG_ENTRY_LIMIT$2 = 50;
class TimelineController {
  version = 0;
  /**
   * The selection state represents the  different states of the current selection:
   * - inactive: No selection is active.
   * - rev: A selection is active for a single revision.
   * - range: A selection is active for a range and we have all the data needed to render it.
   * - loading: A selection is active, but we don't have the entries yet.
   * - invalid: The selection picked is invalid.
   */
  selectionState = "inactive";
  constructor(options) {
    this.timeline = options.timeline, this.client = options.client, this.handler = options.handler, this._aligner = new Aligner(this.timeline), this.markChange();
  }
  _fetchMore = !1;
  _fetchAtLeast = 0;
  _isRunning = !1;
  _isSuspended = !1;
  _didErr = !1;
  _since = null;
  _sinceTime = null;
  _rev = null;
  _revTime = null;
  setHandler(handler) {
    this.handler = handler;
  }
  clearRange() {
    this.setRange(null, null);
  }
  setRange(since, rev) {
    rev !== this._rev && this.setRevTime(rev), since !== this._since && this.setSinceTime(since);
    let _fetchAtLeast = 10;
    if (this._sinceTime === "loading" || this._revTime === "loading" || !this._aligner.isAligned)
      this.selectionState = "loading";
    else if (this._sinceTime === "invalid" || this._revTime === "invalid")
      this.selectionState = "invalid";
    else if (this._sinceTime) {
      this.selectionState = "range";
      const targetRev = this._revTime || this.timeline.lastChunk();
      this._sinceTime.index > targetRev.index ? (this._revTime = "invalid", this.selectionState = "invalid") : this.setReconstruction(this._sinceTime, targetRev);
    } else this._revTime ? (this.selectionState = "rev", this.setReconstruction(null, this._revTime)) : (this.selectionState = "inactive", _fetchAtLeast = 0);
    this._fetchAtLeast = _fetchAtLeast, this.start();
  }
  setLoadMore(flag) {
    this._fetchMore = flag, this.start();
  }
  get sinceTime() {
    return this._sinceTime && typeof this._sinceTime == "object" ? this._sinceTime : null;
  }
  get revTime() {
    return this._revTime && typeof this._revTime == "object" ? this._revTime : null;
  }
  get isLoading() {
    return this._isRunning;
  }
  get realRevChunk() {
    return this.revTime || this.timeline.lastChunk();
  }
  /** Returns true when there's an older revision we want to render. */
  onOlderRevision() {
    return !!this._rev && (this.selectionState === "range" || this.selectionState === "rev");
  }
  findRangeForNewRev(rev) {
    const revTimeId = this.timeline.isLatestChunk(rev) ? null : this.timeline.createTimeId(rev);
    if (!this._since)
      return [null, revTimeId];
    const sinceChunk = this.sinceTime;
    return sinceChunk && sinceChunk.index < rev.index ? [this._since, revTimeId] : ["@lastPublished", revTimeId];
  }
  findRangeForNewSince(since) {
    const revChunk = this.revTime;
    return revChunk && since.index < revChunk.index ? [this.timeline.createTimeId(since), this._rev] : [this.timeline.createTimeId(since), null];
  }
  setRevTime(rev) {
    this._rev = rev, this._revTime = rev ? this.timeline.parseTimeId(rev) : null, this._since === "@lastPublished" && (this._since = null, this._sinceTime = null);
  }
  setSinceTime(since) {
    since === "@lastPublished" ? typeof this._revTime == "string" ? this._sinceTime = this._revTime : this._sinceTime = this.timeline.findLastPublishedBefore(this._revTime) : this._sinceTime = since ? this.timeline.parseTimeId(since) : null, this._since = since;
  }
  sinceAttributes() {
    return this._sinceTime && this._reconstruction ? this._reconstruction.startAttributes() : null;
  }
  displayed() {
    return this._revTime && this._reconstruction ? this._reconstruction.endAttributes() : null;
  }
  setReconstruction(since, rev) {
    this._reconstruction && this._reconstruction.same(since, rev) || (this._reconstruction = new Reconstruction(this.timeline, this._aligner.currentDocument, since, rev));
  }
  currentDiff() {
    return this._reconstruction ? this._reconstruction.diff() : null;
  }
  currentObjectDiff() {
    const diff = this.currentDiff();
    if (diff) {
      if (diff.type === "null") return null;
      if (diff.type !== "object") throw new Error(`ObjectDiff expected, got ${diff.type}`);
    }
    return diff;
  }
  handleRemoteMutation(ev) {
    this._aligner.appendRemoteSnapshotEvent(ev), this.markChange(), this._aligner.acceptsHistory && this.start();
  }
  start() {
    this._didErr || this._isRunning || (this._isRunning = !0, this.tick().then(() => {
      this._isRunning = !1;
    }));
  }
  resume() {
    this._isSuspended = !1;
  }
  suspend() {
    this._isSuspended = !0;
  }
  async tick() {
    if (!(this._aligner.acceptsHistory && !this.timeline.reachedEarliestEntry && (this.selectionState === "loading" || this._fetchMore || this.timeline.chunkCount <= this._fetchAtLeast) && !this._isSuspended)) {
      this._isRunning = !1;
      return;
    }
    try {
      await this.fetchMoreTransactions();
    } catch (err) {
      this._didErr = !0, this.handler?.(err, this);
      return;
    }
    await this.tick();
  }
  async fetchMoreTransactions() {
    const publishedId = this.timeline.publishedId, draftId = this.timeline.draftId, clientConfig = this.client.config(), limit2 = TRANSLOG_ENTRY_LIMIT$2;
    let queryParams = `tag=sanity.studio.structure.history&effectFormat=mendoza&excludeContent=true&excludeMutations=true&includeIdentifiedDocumentsOnly=true&reverse=true&limit=${limit2}`, tid = this._aligner.earliestTransactionId;
    tid && (queryParams += `&toTransaction=${tid}`);
    const transactionsUrl = this.client.getUrl(`/data/history/${clientConfig.dataset}/transactions/${publishedId},${draftId}?${queryParams}`), reader = (await getJsonStream(transactionsUrl, clientConfig.token)).getReader();
    let count2 = 0;
    for (; ; ) {
      const result = await reader.read();
      if (result.done) break;
      if ("error" in result.value)
        throw new Error(result.value.error.description || result.value.error.type);
      if (count2++, result.value.id !== tid) {
        if (this._aligner.earliestTransactionId !== tid || !this._aligner.acceptsHistory)
          return;
        this._aligner.prependHistoryEvent(result.value), tid = this._aligner.earliestTransactionId;
      }
    }
    this._aligner.earliestTransactionId !== tid || !this._aligner.acceptsHistory || (count2 < limit2 && this._aligner.didReachEarliestEntry(), this.markChange());
  }
  markChange() {
    this.timeline.updateChunks(), this.setRevTime(this._rev), this.setSinceTime(this._rev), this.version++, this.handler?.(null, this);
  }
}
const documentRevisionCache$1 = /* @__PURE__ */ Object.create(null), getHistory = (client, documentIds, options = {}) => {
  const ids = Array.isArray(documentIds) ? documentIds : [documentIds], {
    time,
    revision
  } = options;
  if (time && revision)
    throw new Error("getHistory can't handle both time and revision parameters");
  let url = `/data/history/${client.config().dataset}/documents/${ids.join(",")}`;
  if (revision)
    url = `${url}?revision=${revision}`;
  else {
    const timestamp = time || (/* @__PURE__ */ new Date()).toISOString();
    url = `${url}?time=${timestamp}`;
  }
  return client.request({
    url
  });
}, getDocumentAtRevision$1 = (client, documentId, revision) => {
  const publishedId = getPublishedId(documentId), draftId = getDraftId(documentId), versionId = isVersionId$1(documentId) ? documentId : void 0, idsToQuery = [publishedId, draftId, versionId].filter(Boolean), isLastRevision = revision === "lastRevision";
  if (!isLastRevision) {
    const cacheKey = `${documentId}@${revision}`, cached = documentRevisionCache$1[cacheKey];
    if (cached)
      return cached;
  }
  const url = `/data/history/${client.config().dataset}/documents/${idsToQuery.join(",")}?${isLastRevision ? "lastRevision=true" : `revision=${revision}`}`, entry = client.request({
    url,
    tag: "history-revision"
  }).then((result) => {
    const documents = result.documents || [], published = documents.find((res) => res._id === publishedId), draft = documents.find((res) => res._id === draftId);
    return (versionId ? documents.find((res) => res._id === versionId) : void 0) || draft || published;
  });
  if (!isLastRevision) {
    const cacheKey = `${documentId}@${revision}`;
    documentRevisionCache$1[cacheKey] = entry;
  }
  return entry;
}, getTimelineController = ({
  client,
  documentId,
  documentType
}) => {
  const timeline = new Timeline({
    enableTrace: isDev,
    publishedId: documentId
  });
  return new TimelineController({
    client,
    documentId,
    documentType,
    timeline
  });
}, getTransactions = async (client, documentIds) => {
  const ids = Array.isArray(documentIds) ? documentIds : [documentIds], dataset = client.config().dataset, query = {
    excludeContent: "true",
    includeIdentifiedDocumentsOnly: "true"
  }, url = `/data/history/${dataset}/transactions/${ids.join(",")}`;
  return (await client.request({
    url,
    query
  })).toString("utf8").split(`
`).filter(Boolean).map((line) => JSON.parse(line));
}, getAllRefIds = (doc) => reduce(doc, (acc, node) => isReference$1(node) && !acc.includes(node._ref) ? [...acc, node._ref] : acc, []);
function jsonMap(value, mapFn) {
  return Array.isArray(value) ? mapFn(value.map((item) => jsonMap(item, mapFn)).filter((item) => typeof item < "u")) : isRecord$4(value) ? mapFn(Object.keys(value).reduce((res, key) => {
    const mappedValue = jsonMap(value[key], mapFn);
    return typeof mappedValue < "u" && (res[key] = mappedValue), res;
  }, {})) : mapFn(value);
}
const mapRefNodes = (doc, mapFn) => jsonMap(doc, (node) => isReference$1(node) ? mapFn(node) : node), removeMissingReferences = (doc, existingIds) => mapRefNodes(doc, (refNode) => existingIds[refNode._ref] ? refNode : void 0);
function restore(client, documentId, targetDocumentId, rev, options) {
  return from(getDocumentAtRevision$1(client, targetDocumentId, rev)).pipe(mergeMap((documentAtRevision) => {
    if (!documentAtRevision)
      throw new Error(`Unable to find document with ID ${documentId} at revision ${rev}`);
    if (rev !== "lastRevision" && documentAtRevision?._rev !== rev)
      throw new Error(`Restored revision ${documentAtRevision?._rev} does not match expected revision ${rev}`);
    const existingIdsQuery = getAllRefIds(documentAtRevision).map((refId) => `"${refId}": defined(*[_id=="${refId}"]._id)`).join(",");
    return client.observable.fetch(`{${existingIdsQuery}}`).pipe(map((existingIds) => removeMissingReferences(documentAtRevision, existingIds)));
  }), map((documentAtRevision) => {
    const {
      _updatedAt,
      ...document2
    } = documentAtRevision;
    return {
      ...document2,
      _id: targetDocumentId
    };
  }), mergeMap((restoredDraft) => {
    if (options?.useServerDocumentActions) {
      const replaceDraftAction = {
        actionType: "sanity.action.document.replaceDraft",
        publishedId: documentId,
        attributes: restoredDraft
      };
      return actionsApiClient(client, getIdPair(documentId, {
        version: getVersionFromId(documentId)
      })).observable.action(options.fromDeleted ? [{
        actionType: "sanity.action.document.create",
        publishedId: documentId,
        attributes: restoredDraft,
        // This will guard against a race where someone else restores a deleted document at the same time
        ifExists: "fail"
      }, replaceDraftAction] : replaceDraftAction);
    }
    return client.observable.createOrReplace(restoredDraft, {
      visibility: "async"
    });
  }), map(() => {
  }));
}
function createHistoryStore({
  client
}) {
  return {
    getDocumentAtRevision: (documentId, revision) => getDocumentAtRevision$1(client, documentId, revision),
    getHistory: (documentIds, options) => getHistory(client, documentIds, options),
    getTransactions: (documentIds) => getTransactions(client, documentIds),
    restore: (id2, targetId, rev, options) => restore(client, id2, targetId, rev, options),
    getTimelineController
  };
}
function useTimelineSelector(timelineStore, selector) {
  if (!timelineStore)
    throw new Error("Passed timelineStore is undefined, if your are using the events timeline, call useEvents() instead. If you need to use this hook, opt in by setting the beta.eventsAPI.enabled feature flag to false");
  return useSyncExternalStoreWithSelector(timelineStore.subscribe, timelineStore.getSnapshot, null, selector);
}
const INITIAL_TIMELINE_STATE = {
  chunks: [],
  diff: null,
  hasMoreChunks: null,
  isLoading: !1,
  isPristine: null,
  lastNonDeletedRevId: null,
  onOlderRevision: !1,
  realRevChunk: null,
  revTime: null,
  selectionState: "inactive",
  sinceAttributes: null,
  sinceTime: null,
  timelineDisplayed: null,
  timelineReady: !1
};
function useTimelineStore(t0) {
  const $ = c(37), {
    documentId,
    documentType,
    onError,
    rev,
    since
  } = t0, historyStore = useHistoryStore(), snapshotsSubscriptionRef = useRef(null), timelineStateRef = useRef(INITIAL_TIMELINE_STATE), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), workspace = useWorkspace();
  let t1;
  $[0] !== client || $[1] !== documentId || $[2] !== documentType || $[3] !== historyStore ? (t1 = historyStore.getTimelineController({
    client,
    documentId,
    documentType
  }), $[0] = client, $[1] = documentId, $[2] = documentType, $[3] = historyStore, $[4] = t1) : t1 = $[4];
  const controller = t1;
  let t2;
  $[5] !== controller ? (t2 = new BehaviorSubject(controller), $[5] = controller, $[6] = t2) : t2 = $[6];
  const timelineController$ = t2;
  let t3, t4;
  $[7] !== controller || $[8] !== rev || $[9] !== since || $[10] !== timelineController$ ? (t3 = () => (controller.setRange(since || null, rev || null), timelineController$.next(controller), controller.setHandler((err, innerController) => {
    err ? timelineController$.error(err) : setTimeout(() => {
      innerController.setRange(since || null, rev || null), timelineController$.next(innerController);
    }, 0);
  }), controller.resume(), () => controller.suspend()), t4 = [rev, since, controller, timelineController$], $[7] = controller, $[8] = rev, $[9] = since, $[10] = timelineController$, $[11] = t3, $[12] = t4) : (t3 = $[11], t4 = $[12]), useEffect(t3, t4);
  let t5;
  $[13] !== workspace.__internal_serverDocumentActions?.enabled ? (t5 = () => {
    const configFlag = workspace.__internal_serverDocumentActions?.enabled;
    return typeof configFlag == "boolean" ? of(configFlag) : of(!0);
  }, $[13] = workspace.__internal_serverDocumentActions?.enabled, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] !== t5 ? (t6 = t5(), $[15] = t5, $[16] = t6) : t6 = $[16];
  const serverActionsEnabled = t6;
  let t7, t8;
  $[17] !== client || $[18] !== controller || $[19] !== documentId || $[20] !== documentType || $[21] !== serverActionsEnabled ? (t7 = () => (snapshotsSubscriptionRef.current || (snapshotsSubscriptionRef.current = remoteSnapshots(client, {
    draftId: `drafts.${documentId}`,
    publishedId: documentId
  }, documentType, serverActionsEnabled).subscribe((ev) => {
    controller.handleRemoteMutation(ev);
  })), () => {
    snapshotsSubscriptionRef.current && (snapshotsSubscriptionRef.current.unsubscribe(), snapshotsSubscriptionRef.current = null);
  }), t8 = [client, controller, documentId, documentType, serverActionsEnabled], $[17] = client, $[18] = controller, $[19] = documentId, $[20] = documentType, $[21] = serverActionsEnabled, $[22] = t7, $[23] = t8) : (t7 = $[22], t8 = $[23]), useEffect(t7, t8);
  let t10, t11, t9;
  $[24] !== controller ? (t9 = (chunk) => controller.findRangeForNewRev(chunk), t10 = (chunk_0) => controller.findRangeForNewSince(chunk_0), t11 = () => {
    controller.setLoadMore(!0);
  }, $[24] = controller, $[25] = t10, $[26] = t11, $[27] = t9) : (t10 = $[25], t11 = $[26], t9 = $[27]);
  let t12;
  $[28] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = () => timelineStateRef.current, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== onError || $[30] !== timelineController$ ? (t13 = (callback) => {
    const subscription = timelineController$.pipe(map$1(_temp3$O), distinctUntilChanged$1(deepEquals), catchError$1((err_0) => (onError?.(err_0), of(INITIAL_TIMELINE_STATE))), tap$1((timelineState) => {
      timelineStateRef.current = timelineState;
    }), tap$1(callback)).subscribe();
    return () => subscription.unsubscribe();
  }, $[29] = onError, $[30] = timelineController$, $[31] = t13) : t13 = $[31];
  let t14;
  return $[32] !== t10 || $[33] !== t11 || $[34] !== t13 || $[35] !== t9 ? (t14 = {
    findRangeForRev: t9,
    findRangeForSince: t10,
    loadMore: t11,
    getSnapshot: t12,
    subscribe: t13
  }, $[32] = t10, $[33] = t11, $[34] = t13, $[35] = t9, $[36] = t14) : t14 = $[36], t14;
}
function _temp3$O(innerController_0) {
  const chunks = innerController_0.timeline.mapChunks(_temp$43), lastNonDeletedChunk = chunks.filter(_temp2$1J), hasMoreChunks = !innerController_0.timeline.reachedEarliestEntry;
  hasMoreChunks && chunks.length > 16 && innerController_0.setLoadMore(!1);
  const timelineReady = !["invalid", "loading"].includes(innerController_0.selectionState);
  return {
    chunks,
    diff: innerController_0.sinceTime ? innerController_0.currentObjectDiff() : null,
    isLoading: innerController_0.isLoading,
    isPristine: timelineReady ? chunks.length === 0 && !hasMoreChunks : null,
    hasMoreChunks: !innerController_0.timeline.reachedEarliestEntry,
    lastNonDeletedRevId: lastNonDeletedChunk?.[0]?.id,
    onOlderRevision: innerController_0.onOlderRevision(),
    realRevChunk: innerController_0.realRevChunk,
    revTime: innerController_0.revTime,
    selectionState: innerController_0.selectionState,
    sinceAttributes: innerController_0.sinceAttributes(),
    sinceTime: innerController_0.sinceTime,
    timelineDisplayed: innerController_0.displayed(),
    timelineReady
  };
}
function _temp2$1J(chunk_1) {
  return !["delete", "initial"].includes(chunk_1.type);
}
function _temp$43(c2) {
  return c2;
}
const handleIncomingMessage = (event) => {
  if (event.type === "rollCall")
    return {
      type: "rollCall",
      userId: event.i,
      sessionId: event.session
    };
  if (event.type === "state") {
    const {
      sessionId: sessionId2,
      locations
    } = event.m;
    return {
      type: "state",
      userId: event.i,
      sessionId: sessionId2,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      locations
    };
  }
  if (event.type === "disconnect")
    return {
      type: "disconnect",
      userId: event.i,
      sessionId: event.m.session,
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    };
  throw new Error(`Got unknown presence event: ${JSON.stringify(event)}`);
}, createBifurTransport = (bifur, sessionId2) => {
  const incomingEvents$ = bifur.listen("presence").pipe(map(handleIncomingMessage)), dispatchMessage = (message) => message.type === "rollCall" ? bifur.request("presence_rollcall", {
    session: sessionId2
  }) : message.type === "state" ? bifur.request("presence_announce", {
    data: {
      locations: message.locations,
      sessionId: sessionId2
    }
  }) : message.type === "disconnect" ? bifur.request("presence_disconnect", {
    session: sessionId2
  }) : EMPTY$5;
  return [incomingEvents$.pipe(share()), dispatchMessage];
}, USERIDS = [
  "pqSMwf6hH",
  "pnLYqNfv5",
  "priDVVmy8",
  "p0NFOU0j8",
  "pTDl2jw8d",
  "pHMeQnTse",
  "pDQYzJbyS",
  "pZyoPHKUs",
  "p4Tyi2Be5",
  "pb9vii060",
  "pE8yhOisw",
  "p7Fd2C6Cj",
  "p3exSgYCx",
  "pbIQRYViC",
  "p8GJaTEhN",
  "p27ewL8aM",
  "pYg97z75S",
  "pdLr4quHv",
  "pkJXiDgg6",
  "pkl4UAKcA",
  // Included to ensure we handle the case when a user profile cannot
  // be fetched due to insufficient privileges or similar
  "pNoExists"
], PATHS = [["nested", "first"], ["nested", "second"], ["nestedArray", {
  _key: "565c867c8dac"
}, "arrayNo1", {
  _key: "a645548a8f01"
}, "arrayNo1", {
  _key: "1685e372c40f"
}, "fieldNo0"], ["nestedArray", {
  _key: "565c867c8dac"
}, "fieldNo0"], ["nestedArray", {
  _key: "565c867c8dac"
}, "arrayNo19", {
  _key: "a02e7a93e2a2"
}, "fieldNo0"], ["nestedArray", {
  _key: "565c867c8dac"
}, "arrayNo19", {
  _key: "a02e7a93e2a2"
}, "fieldNo19"], ["address", "country"], ["address", "street"], ["customInputWithDefaultPresence", "row3", "cell3"]], mock$ = defer(() => timer(0, 1e4)).pipe(mergeMapTo(USERIDS), map((id2, n) => ({
  type: "state",
  userId: id2,
  sessionId: id2 + n,
  timestamp: (/* @__PURE__ */ new Date()).toISOString(),
  locations: [{
    type: "document",
    documentId: "presence-debug",
    lastActiveAt: (/* @__PURE__ */ new Date()).toISOString(),
    path: sample(PATHS)
  }]
})), shareReplay()), KEY$1 = "presence_session_id", generate = () => nanoid(16);
function getSessionId() {
  try {
    return window.sessionStorage.getItem(KEY$1);
  } catch {
  }
  return null;
}
function setSessionId(id2) {
  try {
    window.sessionStorage.setItem(KEY$1, id2);
  } catch {
  }
  return id2;
}
const SESSION_ID = getSessionId() || setSessionId(generate());
function createPresenceStore(context) {
  const {
    bifur,
    connectionStatusStore,
    userStore
  } = context, [presenceEvents$, sendMessage] = createBifurTransport(bifur, SESSION_ID), currentLocation$ = new BehaviorSubject([]), locationChange$ = currentLocation$.pipe(distinctUntilChanged()), setLocation = (nextLocation) => {
    currentLocation$.next(nextLocation);
  }, reportLocations = (locations) => sendMessage({
    type: "state",
    locations
  }), requestRollCall = () => sendMessage({
    type: "rollCall"
  }), rollCallRequests$ = presenceEvents$.pipe(
    filter((event) => event.type === "rollCall"),
    // do not respond to my own rollcall requests
    filter((event) => event.sessionId !== SESSION_ID)
  ), reportLocationInterval$ = timer(0, 3e4), reportLocation$ = defer(() => merge(locationChange$, rollCallRequests$)).pipe(switchMap(() => reportLocationInterval$), withLatestFrom(currentLocation$), map(([, locations]) => locations), auditTime(200), switchMap((locations) => reportLocations(locations)), mergeMapTo(EMPTY$5), share()), myRollCall$ = defer(() => requestRollCall()).pipe(mergeMapTo(EMPTY$5)), connectionChange$ = connectionStatusStore.connectionStatus$.pipe(map((status) => status.type), filter((statusType) => statusType === "connected" || statusType === "error"), distinctUntilChanged()), debugPresenceParam$ = debugParams$.pipe(map((args) => args.find((arg) => arg.startsWith("presence="))), map((arg) => arg?.split("presence=")[1].split(",").map((r) => r.trim()) || [])), useMock$ = debugPresenceParam$.pipe(filter((args) => args.includes("fake_others")), tap(() => {
    console.log('Faking other users present in the studio. They will hang out in the document with _type: "presence" and _id: "presence-debug"');
  }), switchMapTo(mock$)), debugIntrospect$ = debugPresenceParam$.pipe(map((args) => args.includes("show_own"))), syncEvent$ = merge(myRollCall$, presenceEvents$).pipe(filter((event) => event.type === "state" || event.type === "disconnect")), stateEventToSession = (stateEvent) => ({
    lastActiveAt: stateEvent.timestamp,
    locations: stateEvent.locations,
    sessionId: stateEvent.sessionId,
    userId: stateEvent.userId
  }), states$ = merge(syncEvent$, useMock$).pipe(scan((keyed, event) => event.type === "disconnect" ? omit(keyed, event.sessionId) : {
    ...keyed,
    [event.sessionId]: stateEventToSession(event)
  }, {})), allSessions$ = connectionChange$.pipe(switchMap((status) => status === "connected" ? merge(states$, reportLocation$) : NEVER), map((keyedSessions) => Object.values(keyedSessions)), switchMap((sessions) => {
    const userIds = uniq(sessions.map((sess) => sess.userId));
    return from(userStore.getUsers(userIds)).pipe(map((users) => sessions.map((session) => ({
      // eslint-disable-next-line max-nested-callbacks
      user: users.find((res) => res.id === session.userId),
      session
    })).filter(userSessionPairHasUser)));
  }), takeUntil(fromEvent(window, "beforeunload").pipe(switchMap(() => sendMessage({
    type: "disconnect"
  })))), shareReplay({
    refCount: !0,
    bufferSize: 1
  }));
  function userSessionPairHasUser(pair) {
    return !!(pair.user && pair.session);
  }
  const globalPresence$ = allSessions$.pipe(map((sessions) => {
    const grouped = groupBy(sessions.map((s) => s.session), (e) => e.userId);
    return Object.keys(grouped).map((userId) => ({
      user: sessions.find((s) => s.user.id === userId)?.user,
      sessions: grouped[userId]
    }));
  }), withLatestFrom(debugIntrospect$), map(([userAndSessions, debugIntrospect]) => userAndSessions.filter((userAndSession) => debugIntrospect || !userAndSession.sessions.some((sess) => sess.sessionId === SESSION_ID))), map((userAndSessions) => userAndSessions.map((userAndSession) => ({
    user: userAndSession.user,
    status: "online",
    lastActiveAt: userAndSession.sessions.sort((a, b) => b.lastActiveAt.localeCompare(a.lastActiveAt))[0]?.lastActiveAt,
    locations: flatten$1((userAndSession.sessions || []).map((session) => session.locations || [])).map((location2) => ({
      type: location2.type,
      documentId: location2.documentId,
      path: location2.path,
      lastActiveAt: location2.lastActiveAt
    })).reduce((prev, curr) => prev.concat(curr), [])
  })))), allDocumentsPresence$ = combineLatest([allSessions$, debugIntrospect$]).pipe(map(([userAndSessions, debugIntrospect]) => userAndSessions.flatMap((userAndSession) => (userAndSession.session.locations || []).map((location2) => ({
    documentId: location2.documentId,
    presence: {
      user: userAndSession.user,
      lastActiveAt: userAndSession.session.lastActiveAt,
      path: location2.path || [],
      sessionId: userAndSession.session.sessionId,
      selection: location2?.selection
    }
  }))).filter((item) => debugIntrospect || item.presence.sessionId !== SESSION_ID)), shareReplay(1));
  return {
    setLocation,
    reportLocations,
    debugPresenceParam$,
    globalPresence$,
    documentPresence: (documentId, options) => allDocumentsPresence$.pipe(
      map((allPresence) => allPresence.filter((item) => options?.excludeVersions ? item.documentId === documentId : documentIdEquals(item.documentId, documentId)).map((item) => ({
        ...item.presence,
        //documentId: getPublishedId(item.documentId),
        documentId: item.documentId
      }))),
      // Only emit if the presence has changed for this document id
      distinctUntilChanged((prev, curr) => isEqual$1(prev, curr))
    )
  };
}
const REFETCH_INTERVAL = 300 * 1e3, getOrganizationId = memoize((client) => client.observable.request({
  url: `/projects/${client.config().projectId}`,
  tag: "get-org-id",
  query: {
    includeMembers: "false",
    includeFeatures: "false",
    includeOrganization: "true"
  }
}).pipe(map$1((res) => res.organizationId), catchError$1(() => of(null)), repeat({
  delay: REFETCH_INTERVAL
}), share$1({
  connector: () => new ReplaySubject(1),
  resetOnComplete: !0,
  // delay unsubscriptions a little to keep the observable active
  // during React effect setup and teardown due to rapidly changing deps
  resetOnRefCountZero: () => timer(1e3)
})), (client) => `${client.config().projectId}-${client.config().dataset}`);
function createProjectStore(context) {
  const {
    client
  } = context, projectId = client.config().projectId, versionedClient2 = client.withConfig({
    apiVersion: "2021-12-15"
  });
  function get2() {
    return versionedClient2.observable.request({
      url: `/projects/${projectId}`,
      tag: "get-project"
    });
  }
  function getDatasets() {
    return versionedClient2.observable.request({
      url: `/projects/${projectId}/datasets`,
      tag: "get-datasets"
    });
  }
  const grants$ = versionedClient2.observable.request({
    url: `/projects/${projectId}/grants`,
    tag: "get-grants"
  }).pipe(shareReplay$1(1));
  return {
    get: get2,
    getDatasets,
    getGrants: () => grants$,
    getOrganizationId: () => getOrganizationId(versionedClient2)
  };
}
function useProject() {
  const $ = c(5), projectStore = useProjectStore(), [value, setValue] = useState(null);
  let t0, t1;
  $[0] !== projectStore ? (t0 = () => {
    const sub2 = projectStore.get().subscribe(setValue);
    return () => sub2.unsubscribe();
  }, t1 = [projectStore], $[0] = projectStore, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  return $[3] !== value ? (t2 = {
    value
  }, $[3] = value, $[4] = t2) : t2 = $[4], t2;
}
function useProjectDatasets() {
  const $ = c(5), projectStore = useProjectStore(), [value, setValue] = useState(null);
  let t0, t1;
  $[0] !== projectStore ? (t0 = () => {
    const sub2 = projectStore.getDatasets().subscribe(setValue);
    return () => sub2.unsubscribe();
  }, t1 = [projectStore], $[0] = projectStore, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  return $[3] !== value ? (t2 = {
    value
  }, $[3] = value, $[4] = t2) : t2 = $[4], t2;
}
function createMultiKeyWeakMap() {
  const rootMap = /* @__PURE__ */ new WeakMap(), idCache2 = /* @__PURE__ */ new WeakMap();
  function randomId() {
    return Array.from({
      length: 10
    }).map(() => Math.floor(Math.random() * 255).toString(16).padStart(2, "0")).join("");
  }
  function assignId(key) {
    const cachedId = idCache2.get(key);
    if (cachedId) return cachedId;
    const id2 = randomId();
    return idCache2.set(key, id2), id2;
  }
  function arrangeKeys(keys) {
    return Array.from(new Set(keys)).map((key) => [assignId(key), key]).sort(([a], [b]) => a.localeCompare(b, "en")).map(([, key]) => key);
  }
  function getDeep(keys, map2) {
    if (!keys.length) return;
    const [firstKey, ...restOfKeys] = keys, node = map2.get(firstKey);
    if (node)
      return restOfKeys.length ? getDeep(restOfKeys, node.next) : node.value;
  }
  function setDeep(keys, map2, value) {
    if (!keys.length) return;
    const [firstKey, ...restOfKeys] = keys, node = map2.get(firstKey) || {
      type: "multi-key-weak-map-node",
      value: void 0,
      next: /* @__PURE__ */ new WeakMap()
    };
    if (map2.set(firstKey, node), !restOfKeys.length) {
      node.value = value;
      return;
    }
    setDeep(restOfKeys, node.next, value);
  }
  function get2(keys) {
    return getDeep(arrangeKeys(keys), rootMap);
  }
  function set2(keys, value) {
    setDeep(arrangeKeys(keys), rootMap, value);
  }
  return {
    get: get2,
    set: set2
  };
}
function ResourceCacheProvider(t0) {
  const $ = c(3), {
    children
  } = t0, [resourceCache] = useState(_temp$42);
  let t1;
  return $[0] !== children || $[1] !== resourceCache ? (t1 = /* @__PURE__ */ jsx(ResourceCacheContext.Provider, { value: resourceCache, children }), $[0] = children, $[1] = resourceCache, $[2] = t1) : t1 = $[2], t1;
}
function _temp$42() {
  const namespaces = /* @__PURE__ */ new Map(), nullReplacer = {}, emptyDependenciesReplacer = [nullReplacer], removeNullDependencies = (dependencies) => dependencies.length ? dependencies.map((dep) => dep === null ? nullReplacer : dep) : emptyDependenciesReplacer;
  return {
    get: (t0) => {
      const {
        namespace,
        dependencies: dependencies_0
      } = t0, dependenciesWithoutNull = removeNullDependencies(dependencies_0);
      return namespaces.get(namespace)?.get(dependenciesWithoutNull);
    },
    set: (t1) => {
      const {
        namespace: namespace_0,
        dependencies: dependencies_1,
        value
      } = t1, namespaceMap_0 = namespaces.get(namespace_0) || createMultiKeyWeakMap(), dependenciesWithoutNull_0 = removeNullDependencies(dependencies_1);
      namespaces.set(namespace_0, namespaceMap_0), namespaceMap_0.set(dependenciesWithoutNull_0, value);
    }
  };
}
function useResourceCache() {
  const cache2 = useContext(ResourceCacheContext);
  if (!cache2)
    throw new Error("Could not find `cache` context");
  return cache2;
}
const INTERNAL_USER_IDS = [{
  id: "<system>",
  displayName: "Sanity",
  imageUrl: "https://public.sanity.io/logos/favicon-192.png"
}];
function createUserStore({
  client: _client,
  currentUser
}) {
  const client = _client.withConfig({
    apiVersion: "2021-06-07"
  }), userLoader = new DataLoader(async (userIds) => {
    const value = await client.request({
      uri: `/users/${userIds.join(",")}`,
      tag: "users.get"
    }), users = (Array.isArray(value) ? value : [value]).reduce((acc, next) => (next?.id && (acc[next.id] = next), acc), {});
    return userIds.map((id2) => users[id2] || null);
  }, {
    batchScheduleFn: (cb) => raf(cb),
    /**
     * User IDs are generally 9 bytes long, but external user IDs may be longer.
     * In order to keep the HTTP header size below ~8KB, we limit the batch size.
     * ~4kB for user IDs in paths should allow for plenty of headers, if need be.
     */
    maxBatchSize: 400
  }), userFromCurrentUser = currentUser && {
    id: currentUser.id,
    displayName: currentUser.name,
    imageUrl: currentUser.profileImage
  };
  return userLoader.prime("me", userFromCurrentUser), userFromCurrentUser?.id && userLoader.prime(userFromCurrentUser.id, userFromCurrentUser), INTERNAL_USER_IDS.forEach((user) => userLoader.prime(user.id, user)), {
    getUser: async (userId) => {
      if (!userId) return Promise.resolve(null);
      try {
        return await userLoader.load(userId);
      } catch (err) {
        if (err.statusCode === 403)
          return Promise.resolve(null);
        throw err;
      }
    },
    getUsers: async (userIds) => (await userLoader.loadMany(userIds)).filter((result) => isRecord$4(result) && typeof result.id == "string")
  };
}
const IGNORE_LATENCY_BELOW_MS = 1e3, SLOW_COMMIT_TOAST_COOLDOWN_MS = 3e4, slowCommitCooldown = {
  lastToastAt: 0
};
function useUserStore() {
  const $ = c(6), {
    getClient: getClient2,
    currentUser
  } = useSource(), resourceCache = useResourceCache();
  let t0;
  $[0] !== getClient2 ? (t0 = getClient2(DEFAULT_STUDIO_CLIENT_OPTIONS), $[0] = getClient2, $[1] = t0) : t0 = $[1];
  const client = t0;
  let userStore;
  return $[2] !== client || $[3] !== currentUser || $[4] !== resourceCache ? (userStore = resourceCache.get({
    namespace: "userStore",
    dependencies: [client, currentUser]
  }) || createUserStore({
    client,
    currentUser
  }), resourceCache.set({
    namespace: "userStore",
    dependencies: [client, currentUser],
    value: userStore
  }), $[2] = client, $[3] = currentUser, $[4] = resourceCache, $[5] = userStore) : userStore = $[5], userStore;
}
function useGrantsStore() {
  const $ = c(6), {
    getClient: getClient2
  } = useSource();
  let t0;
  $[0] !== getClient2 ? (t0 = getClient2(DEFAULT_STUDIO_CLIENT_OPTIONS), $[0] = getClient2, $[1] = t0) : t0 = $[1];
  const client = t0, currentUser = useCurrentUser(), resourceCache = useResourceCache();
  let grantsStore;
  return $[2] !== client || $[3] !== currentUser || $[4] !== resourceCache ? (grantsStore = resourceCache.get({
    namespace: "grantsStore",
    dependencies: [client, currentUser]
  }) || createGrantsStore({
    client,
    userId: currentUser?.id || null
  }), resourceCache.set({
    namespace: "grantsStore",
    dependencies: [client, currentUser],
    value: grantsStore
  }), $[2] = client, $[3] = currentUser, $[4] = resourceCache, $[5] = grantsStore) : grantsStore = $[5], grantsStore;
}
function useHistoryStore() {
  const $ = c(3), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), resourceCache = useResourceCache();
  let historyStore;
  return $[0] !== client || $[1] !== resourceCache ? (historyStore = resourceCache.get({
    namespace: "historyStore",
    dependencies: [client]
  }) || createHistoryStore({
    client
  }), resourceCache.set({
    namespace: "historyStore",
    dependencies: [client],
    value: historyStore
  }), $[0] = client, $[1] = resourceCache, $[2] = historyStore) : historyStore = $[2], historyStore;
}
function useDocumentPreviewStore() {
  const $ = c(3), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), resourceCache = useResourceCache();
  let documentPreviewStore;
  return $[0] !== client || $[1] !== resourceCache ? (documentPreviewStore = resourceCache.get({
    namespace: "documentPreviewStore",
    dependencies: [client]
  }) || createDocumentPreviewStore({
    client
  }), resourceCache.set({
    namespace: "documentPreviewStore",
    dependencies: [client],
    value: documentPreviewStore
  }), $[0] = client, $[1] = resourceCache, $[2] = documentPreviewStore) : documentPreviewStore = $[2], documentPreviewStore;
}
function useDocumentStore() {
  const $ = c(26), {
    getClient: getClient2,
    i18n,
    currentUser
  } = useSource(), schema2 = useSchema(), templates = useTemplates(), resourceCache = useResourceCache(), historyStore = useHistoryStore(), documentPreviewStore = useDocumentPreviewStore(), workspace = useWorkspace(), configFlag = workspace.__internal_serverDocumentActions?.enabled;
  let t0;
  $[0] !== configFlag ? (t0 = typeof configFlag == "boolean" ? of(configFlag) : of(!0), $[0] = configFlag, $[1] = t0) : t0 = $[1];
  const serverActionsEnabled = t0, telemetry = useTelemetry(), toast = useToast(), {
    t
  } = useTranslation();
  let t1;
  $[2] !== telemetry ? (t1 = (error) => {
    telemetry.log(DocumentDesynced, {
      errorName: error.name
    });
  }, $[2] = telemetry, $[3] = t1) : t1 = $[3];
  const handleSyncErrorRecovery = t1;
  let t2;
  $[4] !== telemetry ? (t2 = (event) => {
    event.latencyMs > IGNORE_LATENCY_BELOW_MS && telemetry.log(HighListenerLatencyOccurred, {
      latency: event.latencyMs,
      shard: event.shard,
      transactionId: event.transactionId
    });
  }, $[4] = telemetry, $[5] = t2) : t2 = $[5];
  const handleReportLatency = t2;
  let t3;
  $[6] !== t || $[7] !== toast ? (t3 = () => {
    const now = Date.now();
    now - slowCommitCooldown.lastToastAt < SLOW_COMMIT_TOAST_COOLDOWN_MS || (slowCommitCooldown.lastToastAt = now, toast.push({
      title: t("document-store.slow-commit.title"),
      description: t("document-store.slow-commit.description"),
      status: "warning"
    }));
  }, $[6] = t, $[7] = toast, $[8] = t3) : t3 = $[8];
  const handleSlowCommit = t3;
  let t4;
  $[9] !== telemetry ? (t4 = (event_0) => {
    telemetry.log(DocumentPairLoadingMeasured, {
      durationMs: event_0.durationMs,
      fromCache: event_0.fromCache,
      hasPublished: event_0.hasPublished,
      hasDraft: event_0.hasDraft,
      hasVersion: event_0.hasVersion
    });
  }, $[9] = telemetry, $[10] = t4) : t4 = $[10];
  const handleDocumentPairLoaded = t4;
  let documentStore;
  return $[11] !== currentUser || $[12] !== documentPreviewStore || $[13] !== getClient2 || $[14] !== handleDocumentPairLoaded || $[15] !== handleReportLatency || $[16] !== handleSlowCommit || $[17] !== handleSyncErrorRecovery || $[18] !== historyStore || $[19] !== i18n || $[20] !== resourceCache || $[21] !== schema2 || $[22] !== serverActionsEnabled || $[23] !== templates || $[24] !== workspace ? (documentStore = resourceCache.get({
    namespace: "documentStore",
    dependencies: [getClient2, documentPreviewStore, historyStore, schema2, i18n, workspace, currentUser]
  }) || createDocumentStore({
    getClient: getClient2,
    documentPreviewStore,
    historyStore,
    initialValueTemplates: templates,
    schema: schema2,
    i18n,
    serverActionsEnabled,
    currentUser,
    extraOptions: {
      onReportLatency: handleReportLatency,
      onSyncErrorRecovery: handleSyncErrorRecovery,
      onSlowCommit: handleSlowCommit,
      onDocumentPairLoaded: handleDocumentPairLoaded
    }
  }), resourceCache.set({
    namespace: "documentStore",
    dependencies: [getClient2, documentPreviewStore, historyStore, schema2, i18n, workspace, currentUser],
    value: documentStore
  }), $[11] = currentUser, $[12] = documentPreviewStore, $[13] = getClient2, $[14] = handleDocumentPairLoaded, $[15] = handleReportLatency, $[16] = handleSlowCommit, $[17] = handleSyncErrorRecovery, $[18] = historyStore, $[19] = i18n, $[20] = resourceCache, $[21] = schema2, $[22] = serverActionsEnabled, $[23] = templates, $[24] = workspace, $[25] = documentStore) : documentStore = $[25], documentStore;
}
function useConnectionStatusStore() {
  const $ = c(3), {
    bifur
  } = useSource().__internal, resourceCache = useResourceCache();
  let connectionStatusStore;
  return $[0] !== bifur || $[1] !== resourceCache ? (connectionStatusStore = resourceCache.get({
    namespace: "connectionStatusStore",
    dependencies: [bifur]
  }) || createConnectionStatusStore({
    bifur
  }), resourceCache.set({
    namespace: "connectionStatusStore",
    dependencies: [bifur],
    value: connectionStatusStore
  }), $[0] = bifur, $[1] = resourceCache, $[2] = connectionStatusStore) : connectionStatusStore = $[2], connectionStatusStore;
}
function usePresenceStore() {
  const $ = c(5), {
    __internal: t0
  } = useSource(), {
    bifur
  } = t0, resourceCache = useResourceCache(), userStore = useUserStore(), connectionStatusStore = useConnectionStatusStore();
  let presenceStore;
  return $[0] !== bifur || $[1] !== connectionStatusStore || $[2] !== resourceCache || $[3] !== userStore ? (presenceStore = resourceCache.get({
    namespace: "presenceStore",
    dependencies: [bifur, connectionStatusStore, userStore]
  }) || createPresenceStore({
    bifur,
    connectionStatusStore,
    userStore
  }), resourceCache.set({
    namespace: "presenceStore",
    dependencies: [bifur, connectionStatusStore, userStore],
    value: presenceStore
  }), $[0] = bifur, $[1] = connectionStatusStore, $[2] = resourceCache, $[3] = userStore, $[4] = presenceStore) : presenceStore = $[4], presenceStore;
}
function useProjectStore() {
  const $ = c(3), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), resourceCache = useResourceCache();
  let projectStore;
  return $[0] !== client || $[1] !== resourceCache ? (projectStore = resourceCache.get({
    namespace: "projectStore",
    dependencies: [client]
  }) || createProjectStore({
    client
  }), resourceCache.set({
    namespace: "projectStore",
    dependencies: [client],
    value: projectStore
  }), $[0] = client, $[1] = resourceCache, $[2] = projectStore) : projectStore = $[2], projectStore;
}
const keyValueStoreCache = /* @__PURE__ */ new Map();
function getKeyValueStoreCacheKey(client) {
  const config = client.config();
  return `${config.projectId}:${config.apiHost || "default"}`;
}
function useKeyValueStore() {
  const $ = c(2), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0;
  if ($[0] !== client) {
    bb0: {
      const cacheKey = getKeyValueStoreCacheKey(client), cached = keyValueStoreCache.get(cacheKey);
      if (cached) {
        t0 = cached;
        break bb0;
      }
      const keyValueStore = createKeyValueStore({
        client
      });
      keyValueStoreCache.set(cacheKey, keyValueStore), t0 = keyValueStore;
    }
    $[0] = client, $[1] = t0;
  } else
    t0 = $[1];
  return t0;
}
function useRenderingContextStore() {
  const $ = c(2), resourceCache = useResourceCache();
  let renderingContextStore;
  return $[0] !== resourceCache ? (renderingContextStore = resourceCache.get({
    dependencies: [],
    namespace: "RenderingContextStore"
  }) || createRenderingContextStore(), resourceCache.set({
    dependencies: [],
    namespace: "RenderingContextStore",
    value: renderingContextStore
  }), $[0] = resourceCache, $[1] = renderingContextStore) : renderingContextStore = $[1], renderingContextStore;
}
function useComlinkStore() {
  const $ = c(4), resourceCache = useResourceCache(), renderingContext = useRenderingContextStore();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {}, $[0] = t0) : t0 = $[0];
  const capabilities = useObservable(renderingContext.capabilities, t0);
  let comlinkStore;
  return $[1] !== capabilities || $[2] !== resourceCache ? (comlinkStore = resourceCache.get({
    dependencies: [capabilities],
    namespace: "ComlinkStore"
  }) || createComlinkStore({
    capabilities
  }), resourceCache.set({
    dependencies: [capabilities],
    namespace: "ComlinkStore",
    value: comlinkStore
  }), $[1] = capabilities, $[2] = resourceCache, $[3] = comlinkStore) : comlinkStore = $[3], comlinkStore;
}
const initial$1 = [], fallback$1 = of(initial$1);
function useDocumentPresence(documentId) {
  const $ = c(6), [mounted, mount] = useReducer(_temp$41, !1);
  let t0, t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => startTransition(mount), t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useEffect(t0, t1);
  const presenceStore = usePresenceStore();
  let t2;
  return $[2] !== documentId || $[3] !== mounted || $[4] !== presenceStore ? (t2 = mounted ? presenceStore.documentPresence(documentId) : fallback$1, $[2] = documentId, $[3] = mounted, $[4] = presenceStore, $[5] = t2) : t2 = $[5], useObservable(t2, initial$1);
}
function _temp$41() {
  return !0;
}
const initial = [], fallback = of(initial);
function useGlobalPresence() {
  const $ = c(2), [mounted, mount] = useReducer(_temp$40, !1);
  let t0, t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => startTransition(mount), t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useEffect(t0, t1);
  const presenceStore = usePresenceStore();
  return useObservable(mounted ? presenceStore.globalPresence$ : fallback, initial);
}
function _temp$40() {
  return !0;
}
const AGENT_BUNDLE_PREFIX = "agent-", INITIAL_STATE$b = {
  bundles: [],
  loading: !0
}, EMPTY_STATE$3 = {
  bundles: [],
  loading: !1
};
function isAgentBundleName(versionName) {
  return typeof versionName == "string" && versionName.startsWith(AGENT_BUNDLE_PREFIX);
}
function createAgentBundlesStore(context) {
  const {
    organizationId$,
    client
  } = context;
  return {
    state$: organizationId$.pipe(distinctUntilChanged$1(), switchMap$1((organizationId) => organizationId ? listenToBundles(client, organizationId) : of(EMPTY_STATE$3)), startWith$1(INITIAL_STATE$b), share$1({
      connector: () => new ReplaySubject(1)
    }))
  };
}
const eventSourcePolyfill$ = defer(() => import("@sanity/eventsource")).pipe(map$1(({
  default: ES
}) => ES), shareReplay$1(1));
function listenToBundles(client, organizationId) {
  const {
    token,
    withCredentials
  } = client.config(), url = client.getUrl(`/agent/${organizationId}/bundles/mine/listen`), esOptions = {};
  return (token || withCredentials) && (esOptions.withCredentials = !0), token && (esOptions.headers = {
    Authorization: `Bearer ${token}`
  }), (esOptions.headers ? eventSourcePolyfill$ : of(EventSource)).pipe(map$1((ES) => new ES(url, esOptions))).pipe(switchMap$1((es) => new Observable((subscriber) => (es.addEventListener("bundles", (event) => {
    try {
      const data = JSON.parse(event.data);
      subscriber.next({
        bundles: data.bundles,
        loading: !1
      });
    } catch {
    }
  }), es.addEventListener("error", () => {
  }), () => {
    es.close();
  }))), catchError$1(() => of(EMPTY_STATE$3)));
}
const CLIENT_OPTIONS$1 = {
  apiVersion: "v2025-02-19"
};
function useAgentBundles() {
  const $ = c(5), resourceCache = useResourceCache(), workspace = useWorkspace(), client = useClient(CLIENT_OPTIONS$1), projectStore = useProjectStore();
  let agentBundlesStore;
  return $[0] !== client || $[1] !== projectStore || $[2] !== resourceCache || $[3] !== workspace ? (agentBundlesStore = resourceCache.get({
    namespace: "AgentBundlesStore",
    dependencies: [workspace]
  }) || createAgentBundlesStore({
    organizationId$: projectStore.getOrganizationId(),
    client
  }), resourceCache.set({
    namespace: "AgentBundlesStore",
    dependencies: [workspace],
    value: agentBundlesStore
  }), $[0] = client, $[1] = projectStore, $[2] = resourceCache, $[3] = workspace, $[4] = agentBundlesStore) : agentBundlesStore = $[4], useObservable(agentBundlesStore.state$, INITIAL_STATE$b);
}
const AGENT_TONE = "suggest";
function useAgentVersionDisplay(versionIds, activeBundleId) {
  const $ = c(32), {
    bundles,
    loading
  } = useAgentBundles(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== bundles ? (t0 = new Set(bundles.map(_temp$3$)), $[0] = bundles, $[1] = t0) : t0 = $[1];
  const myBundleIds = t0;
  let t1;
  if ($[2] !== activeBundleId || $[3] !== loading || $[4] !== myBundleIds || $[5] !== versionIds) {
    let t22;
    $[7] !== activeBundleId || $[8] !== loading || $[9] !== myBundleIds ? (t22 = (id2) => {
      const name = getVersionFromId(id2);
      return !name || !isAgentBundleName(name) ? !1 : loading ? name === activeBundleId : myBundleIds.has(name);
    }, $[7] = activeBundleId, $[8] = loading, $[9] = myBundleIds, $[10] = t22) : t22 = $[10], t1 = versionIds.find(t22), $[2] = activeBundleId, $[3] = loading, $[4] = myBundleIds, $[5] = versionIds, $[6] = t1;
  } else
    t1 = $[6];
  const primaryAgentId = t1;
  let t2;
  if ($[11] !== primaryAgentId || $[12] !== versionIds) {
    let t32;
    $[14] !== primaryAgentId ? (t32 = (id_0) => {
      const name_0 = getVersionFromId(id_0);
      return !name_0 || !isAgentBundleName(name_0) ? !0 : id_0 === primaryAgentId;
    }, $[14] = primaryAgentId, $[15] = t32) : t32 = $[15], t2 = versionIds.filter(t32), $[11] = primaryAgentId, $[12] = versionIds, $[13] = t2;
  } else
    t2 = $[13];
  const filteredVersionIds = t2;
  let t3;
  $[16] !== t ? (t3 = t("version.agent-bundle.proposed-changes"), $[16] = t, $[17] = t3) : t3 = $[17];
  let t4;
  $[18] !== t3 ? (t4 = {
    displayName: t3,
    tone: AGENT_TONE
  }, $[18] = t3, $[19] = t4) : t4 = $[19];
  const ownDisplay = t4;
  let t5;
  $[20] !== t ? (t5 = t("version.agent-bundle.agent-changes"), $[20] = t, $[21] = t5) : t5 = $[21];
  let t6;
  $[22] !== t5 ? (t6 = {
    displayName: t5,
    tone: AGENT_TONE
  }, $[22] = t5, $[23] = t6) : t6 = $[23];
  const otherDisplay = t6;
  let t7;
  $[24] !== loading || $[25] !== myBundleIds || $[26] !== otherDisplay || $[27] !== ownDisplay ? (t7 = (versionDocumentId) => {
    const name_1 = getVersionFromId(versionDocumentId);
    return !name_1 || !isAgentBundleName(name_1) ? null : !loading && myBundleIds.has(name_1) ? ownDisplay : otherDisplay;
  }, $[24] = loading, $[25] = myBundleIds, $[26] = otherDisplay, $[27] = ownDisplay, $[28] = t7) : t7 = $[28];
  const getVersionDisplay = t7;
  let t8;
  return $[29] !== filteredVersionIds || $[30] !== getVersionDisplay ? (t8 = {
    filteredVersionIds,
    getVersionDisplay
  }, $[29] = filteredVersionIds, $[30] = getVersionDisplay, $[31] = t8) : t8 = $[31], t8;
}
function _temp$3$(b) {
  return b.id;
}
function EventsProvider(t0) {
  const $ = c(3), {
    value,
    children
  } = t0;
  let t1;
  return $[0] !== children || $[1] !== value ? (t1 = /* @__PURE__ */ jsx(EventsContext.Provider, { value, children }), $[0] = children, $[1] = value, $[2] = t1) : t1 = $[2], t1;
}
function useEvents() {
  const context = useContext(EventsContext);
  if (context === null)
    throw new Error("useEvents must be used within a EventsProvider");
  return context;
}
const isCreateDocumentVersionEvent = (event) => event.type === "createDocumentVersion", isDeleteDocumentVersionEvent = (event) => event.type === "deleteDocumentVersion", isPublishDocumentVersionEvent = (event) => event.type === "publishDocumentVersion", isUnpublishDocumentEvent = (event) => event.type === "unpublishDocument", isScheduleDocumentVersionEvent = (event) => event.type === "scheduleDocumentVersion", isUnscheduleDocumentVersionEvent = (event) => event.type === "unscheduleDocumentVersion", isDeleteDocumentGroupEvent = (event) => event.type === "deleteDocumentGroup", isCreateLiveDocumentEvent = (event) => event.type === "createLiveDocument", isUpdateLiveDocumentEvent = (event) => event.type === "updateLiveDocument", isEditDocumentVersionEvent = (event) => event.type === "editDocumentVersion", PATH_ID_PREFIX = `${RELEASE_DOCUMENTS_PATH}.`;
function getReleaseIdFromReleaseDocumentId(releaseDocumentId) {
  if (!releaseDocumentId.startsWith(PATH_ID_PREFIX))
    throw new Error(`Release document ID was ${releaseDocumentId} but should start with ${RELEASE_DOCUMENTS_PATH}`);
  return releaseDocumentId.slice(PATH_ID_PREFIX.length);
}
const getFetchQuery = (releaseIds) => {
  const getSafeKey = (id2) => `release_${id2.replaceAll("-", "_")}`;
  return releaseIds.reduce(({
    subquery: accSubquery,
    projection: accProjection
  }, releaseId) => {
    const bundleId = getReleaseIdFromReleaseDocumentId(releaseId), safeId = getSafeKey(bundleId), subquery = `${accSubquery}"${safeId}": *[sanity::partOfRelease("${bundleId}")]{_updatedAt, "docId": string::split(_id, ".")[2] } | order(_updatedAt desc),`, projection = `${accProjection}"${releaseId}": {
              "updatedAt": ${safeId}[0]._updatedAt,
              "documentIds": ${safeId}[].docId,
            },`;
    return {
      subquery,
      projection
    };
  }, {
    subquery: "",
    projection: ""
  });
}, createReleaseMetadataAggregator = (client) => {
  const aggregatorFetch$ = (releaseIds, isInitialLoad = !1) => {
    if (!releaseIds?.length || !client) return of({
      data: null,
      error: null,
      loading: !1
    });
    const {
      subquery: queryAllDocumentsInReleases,
      projection: projectionToBundleMetadata
    } = getFetchQuery(releaseIds), fetchData$ = client.observable.fetch(`{${queryAllDocumentsInReleases}}{${projectionToBundleMetadata}}`, {}, {
      tag: "release-docs.fetch"
    }).pipe(switchMap$1((releaseDocumentIdResponse) => of({
      data: Object.entries(releaseDocumentIdResponse).reduce((existing, el) => {
        const [releaseId, metadata] = el;
        return {
          ...existing,
          [releaseId]: {
            ...metadata,
            documentCount: metadata.documentIds?.length || 0
          }
        };
      }, {}),
      error: null,
      loading: !1
    })), catchError$1((error) => (console.error("Failed to fetch release metadata", error), of({
      data: null,
      error,
      loading: !1
    }))));
    return iif(() => isInitialLoad, fetchData$.pipe(startWith$1({
      loading: !0,
      data: null,
      error: null
    })), fetchData$);
  }, aggregatorListener$ = (releaseIds) => !releaseIds?.length || !client ? EMPTY$5 : client.observable.listen(`*[(${releaseIds.reduce((accQuery, releaseId, index) => `${accQuery}${index === 0 ? "" : " ||"} sanity::partOfRelease("${releaseId}")`, "")})]`, {}, {
    includeResult: !0,
    includeAllVersions: !0,
    visibility: "query",
    events: ["mutation"],
    tag: "release-docs.listen"
  }).pipe(catchError$1((error) => (console.error("Failed to listen for release metadata", error), EMPTY$5)), bufferTime(1e3), filter$1((entriesArray) => entriesArray.length > 0), switchMap$1((entriesArray) => {
    const mutatedReleaseIds = entriesArray.reduce((accReleaseIds, event) => {
      if ("type" in event && event.type === "mutation") {
        const releaseId = event.documentId.split(".")[1];
        return accReleaseIds.includes(releaseId) ? accReleaseIds : [...accReleaseIds, releaseId];
      }
      return accReleaseIds;
    }, []);
    return mutatedReleaseIds.length ? aggregatorFetch$(mutatedReleaseIds) : EMPTY$5;
  }));
  return (releaseIds) => merge(aggregatorFetch$(releaseIds, !0), aggregatorListener$(releaseIds));
};
function createReleasesSet(releases2) {
  return (releases2 ?? []).reduce((acc, bundle) => (acc.set(bundle._id, bundle), acc), /* @__PURE__ */ new Map());
}
function releasesReducer(state, action) {
  switch (action.type) {
    case "LOADING_STATE_CHANGED":
      return {
        ...state,
        state: action.payload.loading ? "loading" : "loaded",
        error: action.payload.error
      };
    case "RELEASES_SET": {
      const releasesById = createReleasesSet(action.payload);
      return {
        ...state,
        releases: releasesById
      };
    }
    default:
      return state;
  }
}
const SORT_FIELD$2 = "_createdAt", SORT_ORDER$2 = "desc", QUERY_FILTER = `_type=="${RELEASE_DOCUMENT_TYPE}" && _id in path("${RELEASE_DOCUMENTS_PATH}.*")`, DEFAULT_RELEASE_TYPE$1 = "undecided", QUERY_PROJECTION$2 = `{
  _id,
  _type,
  _rev,
  _createdAt,
  _updatedAt,
  state,
  finalDocumentStates,
  publishAt,
  publishedAt,
  "metadata": coalesce(metadata, {
    "title": "",
    "releaseType": "${DEFAULT_RELEASE_TYPE$1}",
  }),
  // Content Lake initially encoded non-error states as {error: {message: ""}}. This projection
  // ensures the error field only appears if the document has a non-empty error message.
  ...select(
    length(error.message) > 0 => { error },
    {}
  ),
}`, QUERY_SORT_ORDER$2 = `order(${SORT_FIELD$2} ${SORT_ORDER$2})`, QUERY$1 = `*[${QUERY_FILTER}] ${QUERY_PROJECTION$2} | ${QUERY_SORT_ORDER$2}`, INITIAL_STATE$a = {
  releases: /* @__PURE__ */ new Map(),
  state: "initialising"
};
function createReleaseStore(context) {
  const {
    client
  } = context, dispatch$ = new Subject(), fetchPending$ = new BehaviorSubject(!1);
  function dispatch(action) {
    dispatch$.next(action);
  }
  const listFetch$ = of({
    action: {
      type: "LOADING_STATE_CHANGED",
      payload: {
        loading: !0,
        error: void 0
      }
    }
  }).pipe(
    // Ignore invocations while the list fetch is pending.
    filter$1(() => !fetchPending$.value),
    tap$1(() => fetchPending$.next(!0)),
    concatWith(listenQuery(client, QUERY$1, {}, {
      tag: "releases.listen"
    }).pipe(tap$1(() => fetchPending$.next(!1)), map((releases2) => ({
      response: releases2
    })))),
    catchError$1((error) => of({
      action: {
        type: "LOADING_STATE_CHANGED",
        payload: {
          loading: !1,
          error
        }
      }
    })),
    switchMap$1((entry) => "action" in entry ? of(entry.action) : of({
      type: "RELEASES_SET",
      payload: entry.response
    }, {
      type: "LOADING_STATE_CHANGED",
      payload: {
        loading: !1,
        error: void 0
      }
    }))
  ), state$ = concat(merge(listFetch$, dispatch$)).pipe(filter$1((action) => typeof action < "u"), scan$1((state, action) => releasesReducer(state, action), INITIAL_STATE$a), startWith(INITIAL_STATE$a), shareReplay$1(1)), errorCount$ = state$.pipe(releaseStoreErrorCount(), shareReplay$1(1)), getMetadataStateForSlugs$ = createReleaseMetadataAggregator(client);
  return {
    state$,
    errorCount$,
    getMetadataStateForSlugs$,
    dispatch
  };
}
function releaseStoreErrorCount() {
  return pipe(switchMap$1(({
    releases: releases2
  }) => from(releases2.values()).pipe(filter$1((release) => release.state === "active"), filter$1((release) => typeof release.error < "u"), count())), distinctUntilChanged());
}
function useReleasesStore() {
  const $ = c(5), resourceCache = useResourceCache(), workspace = useWorkspace(), previewStore = useDocumentPreviewStore(), studioClient = useClient(RELEASES_STUDIO_CLIENT_OPTIONS);
  let releaseStore;
  return $[0] !== previewStore || $[1] !== resourceCache || $[2] !== studioClient || $[3] !== workspace ? (releaseStore = resourceCache.get({
    dependencies: [workspace, previewStore],
    namespace: "ReleasesStore"
  }) || createReleaseStore({
    client: studioClient
  }), resourceCache.set({
    dependencies: [workspace, previewStore],
    namespace: "ReleasesStore",
    value: releaseStore
  }), $[0] = previewStore, $[1] = resourceCache, $[2] = studioClient, $[3] = workspace, $[4] = releaseStore) : releaseStore = $[4], releaseStore;
}
function WorkspaceProvider(t0) {
  const $ = c(3), {
    children,
    workspace
  } = t0;
  let t1;
  return $[0] !== children || $[1] !== workspace ? (t1 = /* @__PURE__ */ jsx(WorkspaceContext.Provider, { value: workspace, children }), $[0] = children, $[1] = workspace, $[2] = t1) : t1 = $[2], t1;
}
function useWorkspace() {
  const workspace = useContext(WorkspaceContext);
  if (!workspace)
    throw new Error("Workspace: missing context value");
  return workspace;
}
function getReleaseDocumentIdFromReleaseId(name) {
  return `${RELEASE_DOCUMENTS_PATH}.${name}`;
}
function removeDupes$2(events2, newEvents) {
  const noDupes = [...events2, ...newEvents].reduce((acc, event) => {
    if (acc.has(event.id)) {
      const existingEvent = acc.get(event.id);
      return isEditDocumentVersionEvent(existingEvent) && !isEditDocumentVersionEvent(event) && acc.set(event.id, event), existingEvent.type !== event.type && acc.set(`${event.id}-${event.type}`, event), acc;
    }
    return acc.set(event.id, event);
  }, /* @__PURE__ */ new Map());
  return Array.from(noDupes.values());
}
function addEventId(event, documentVariantType) {
  let id2 = "";
  return isCreateDocumentVersionEvent(event) ? id2 = documentVariantType === "published" ? event.revisionId || `publishCreation--${event.timestamp}` : event.versionRevisionId : isDeleteDocumentVersionEvent(event) ? id2 = documentVariantType === "published" ? `deleteAt-${event.timestamp}` : event.versionRevisionId : isPublishDocumentVersionEvent(event) ? id2 = documentVariantType === "published" ? event.revisionId : event.versionRevisionId || event.revisionId : isUnpublishDocumentEvent(event) ? id2 = documentVariantType === "published" ? `unpublishAt-${event.timestamp}` : "" : isScheduleDocumentVersionEvent(event) || isUnscheduleDocumentVersionEvent(event) ? id2 = documentVariantType === "published" ? "" : event.versionRevisionId : isDeleteDocumentGroupEvent(event) ? id2 = `deleted-${event.timestamp}` : (isCreateLiveDocumentEvent(event) || isUpdateLiveDocumentEvent(event) || isEditDocumentVersionEvent(event)) && (id2 = event.revisionId), {
    ...event,
    id: id2
  };
}
function addParentToEvents(events2) {
  const eventsWithParent = JSON.parse(JSON.stringify(events2));
  return eventsWithParent.forEach((event, index) => {
    if (isPublishDocumentVersionEvent(event) || isDeleteDocumentVersionEvent(event)) {
      event.documentId = event.versionId;
      for (let i = index; i < eventsWithParent.length; i++) {
        const nextEvent = eventsWithParent[i];
        if (isEditDocumentVersionEvent(nextEvent) && (nextEvent.parentId = event.id), isCreateDocumentVersionEvent(nextEvent)) {
          event.creationEvent = nextEvent, nextEvent.parentId = event.id;
          break;
        }
      }
    }
    isEditDocumentVersionEvent(event) && event.parentId === event.id && event.transactions[1]?.revisionId && (event.id = event.transactions[1].revisionId);
  }), eventsWithParent;
}
const MERGE_WINDOW = 300 * 1e3;
function isWithinMergeWindow(a, b) {
  return Math.abs(Date.parse(a) - Date.parse(b)) < MERGE_WINDOW;
}
function squashLiveEditEvents(events2) {
  return events2.reduce((acc, event) => {
    if (isUpdateLiveDocumentEvent(event)) {
      const previousEvent = acc[acc.length - 1];
      if (previousEvent && isUpdateLiveDocumentEvent(previousEvent) && isWithinMergeWindow(previousEvent.timestamp, event.timestamp) && previousEvent.author === event.author)
        return acc;
    }
    return acc.push(event), acc;
  }, []);
}
function remoteMutationToTransaction(event) {
  return {
    author: event.author,
    documentIDs: [],
    id: event.transactionId,
    timestamp: event.timestamp.toISOString(),
    effects: {
      [event.head._id]: {
        apply: event.effects.apply,
        revert: event.effects.revert
      }
    }
  };
}
function updateVersionEvents(events2) {
  return events2.map((event) => isPublishDocumentVersionEvent(event) ? {
    ...event,
    documentId: event.versionId
  } : event);
}
function updatePublishedEvents(events2, releases2) {
  return events2.map((event) => {
    if (isPublishDocumentVersionEvent(event)) {
      const releaseId = getVersionFromId(event.versionId);
      if (releaseId) {
        const releaseDocumentId = getReleaseDocumentIdFromReleaseId(releaseId), release = releases2.releases.get(releaseDocumentId);
        return {
          ...event,
          release: release || {
            _id: releaseDocumentId
          }
        };
      }
      return event;
    }
    return event;
  });
}
function sortEvents({
  remoteEdits,
  events: events2,
  expandedEvents
}) {
  return [...remoteEdits, ...events2, ...expandedEvents].sort(
    // Sort by timestamp, newest first unless is an edit event that has a corresponding publish event
    (a, b) => isPublishDocumentVersionEvent(a) && isEditDocumentVersionEvent(b) && a.versionRevisionId === b.revisionId ? -1 : isPublishDocumentVersionEvent(b) && isEditDocumentVersionEvent(a) && b.versionRevisionId === a.revisionId ? 1 : Date.parse(b.timestamp) - Date.parse(a.timestamp)
  );
}
const addDocumentVariantTypeToEvents = (events2, documentVariantType) => events2.map((event) => ({
  ...event,
  documentVariantType
}));
function createEventsObservable({
  releases$,
  events$,
  remoteEdits$,
  expandedEvents$,
  documentId
}) {
  const documentVariantType = getDocumentVariantType(documentId);
  return combineLatest([releases$, events$, remoteEdits$, expandedEvents$]).pipe(
    map$1(([releases2, {
      events: events2,
      nextCursor,
      loading,
      error
    }, remoteEdits, expandedEvents]) => {
      const eventsWithRemoteEdits = sortEvents({
        remoteEdits,
        events: events2,
        expandedEvents
      });
      return documentVariantType === "published" ? {
        events: updatePublishedEvents(eventsWithRemoteEdits, releases2),
        nextCursor,
        loading,
        error
      } : documentVariantType === "draft" ? {
        events: addParentToEvents(eventsWithRemoteEdits),
        nextCursor,
        loading,
        error
      } : {
        events: updateVersionEvents(eventsWithRemoteEdits),
        nextCursor,
        loading,
        error
      };
    }),
    map$1((value) => ({
      ...value,
      events: addDocumentVariantTypeToEvents(value.events, documentVariantType)
    })),
    // TODO: This is temporal - liveEditEvents will be squashed in the API
    map$1((value) => ({
      ...value,
      events: squashLiveEditEvents(value.events)
    }))
  );
}
function omitRev$2(document2) {
  const {
    _rev,
    ...doc
  } = document2;
  return doc;
}
function annotationForTransactionIndex(transactions, idx, event) {
  const tx = transactions[idx];
  return tx ? {
    timestamp: tx.timestamp,
    author: tx.author,
    event
  } : null;
}
function extractAnnotationForFromInput(transactions, meta) {
  return meta ? annotationForTransactionIndex(transactions, meta.transactionIndex + 1, meta.event) : transactions.length > 0 ? annotationForTransactionIndex(transactions, 0) : null;
}
function extractAnnotationForToInput(transactions, meta) {
  return meta ? annotationForTransactionIndex(transactions, meta.transactionIndex, meta.event) : null;
}
function diffValue({
  transactions,
  fromValue,
  fromRaw,
  toValue,
  toRaw
}) {
  const fromInput = wrapValue(fromValue, fromRaw, {
    fromValue(value) {
      return extractAnnotationForFromInput(transactions, value.endMeta);
    },
    fromMeta(meta) {
      return extractAnnotationForFromInput(transactions, meta);
    }
  }), toInput = wrapValue(toValue, toRaw, {
    fromValue(value) {
      return extractAnnotationForToInput(transactions, value.startMeta);
    },
    fromMeta(meta) {
      return extractAnnotationForToInput(transactions, meta);
    }
  });
  return diffInput(fromInput, toInput);
}
function calculateDiff({
  initialDoc,
  documentId,
  transactions,
  events: events2 = []
}) {
  const initialValue = incremental.wrap(omitRev$2(initialDoc), null);
  let document2 = incremental.wrap(omitRev$2(initialDoc), null), finalDocument = omitRev$2(initialDoc);
  return transactions.forEach((transaction, index) => {
    const meta = {
      transactionIndex: index,
      event: events2.find((event) => !isEditDocumentVersionEvent(event) && "revisionId" in event && event.revisionId === transaction.id)
    }, effect = transaction.effects[documentId];
    effect && (document2 = incremental.applyPatch(document2, effect.apply, meta), finalDocument = applyPatch$1(finalDocument, effect.apply));
  }), diffValue({
    transactions,
    fromValue: initialValue,
    fromRaw: initialDoc,
    toValue: document2,
    toRaw: finalDocument
  });
}
async function getTransactionsLogs(client, documentIds, params) {
  const clientConfig = client.config(), dataset = clientConfig.dataset, queryParams = new URLSearchParams({
    // Default values
    tag: "sanity.studio.transactions-log",
    excludeContent: "true",
    limit: "50",
    includeIdentifiedDocumentsOnly: "true"
  });
  Object.entries(params).forEach(([key, value]) => {
    value !== void 0 && queryParams.set(key, value.toString());
  });
  const transactionsUrl = client.getUrl(`/data/history/${dataset}/transactions/${Array.isArray(documentIds) ? documentIds.join(",") : documentIds}?${queryParams.toString()}`), stream = await getJsonStream(transactionsUrl, clientConfig.token), transactions = [], reader = stream.getReader();
  for (; ; ) {
    const result = await reader.read();
    if (result.done) break;
    if ("error" in result.value)
      throw new Error(result.value.error.description || result.value.error.type);
    transactions.push(result.value);
  }
  return transactions;
}
const TRANSLOG_ENTRY_LIMIT$1 = 50, documentTransactionsCache$1 = /* @__PURE__ */ Object.create(null);
async function getDocumentTransactions({
  documentId,
  client,
  toTransaction,
  fromTransaction
}) {
  const cacheKey = `${documentId}-${toTransaction}-${fromTransaction}`;
  if (documentTransactionsCache$1[cacheKey] && typeof toTransaction < "u")
    return documentTransactionsCache$1[cacheKey];
  const skipFromTransaction = fromTransaction !== toTransaction;
  let transactions = await getTransactionsLogs(client, documentId, {
    tag: "sanity.studio.documents.history",
    effectFormat: "mendoza",
    excludeContent: !0,
    includeIdentifiedDocumentsOnly: !0,
    limit: TRANSLOG_ENTRY_LIMIT$1,
    fromTransaction,
    toTransaction
  });
  if (skipFromTransaction && (transactions = transactions.filter((transaction) => transaction.id !== fromTransaction)), (skipFromTransaction ? (
    // The transaction received with the id fromTransaction is not included in the list but it's returned by the API; remove that from the count
    transactions.length === TRANSLOG_ENTRY_LIMIT$1 - 1
  ) : transactions.length === TRANSLOG_ENTRY_LIMIT$1) && (toTransaction && transactions[transactions.length - 1].id !== toTransaction || !toTransaction)) {
    const nextTransactions = await getDocumentTransactions({
      documentId,
      client,
      toTransaction,
      fromTransaction: transactions[transactions.length - 1].id
    });
    return transactions.concat(nextTransactions);
  }
  return documentTransactionsCache$1[cacheKey] = transactions, transactions;
}
function getEffectState(effect) {
  const modified = !!effect, deleted = effect && isDeletePatch(effect?.apply), created = effect && isDeletePatch(effect?.revert);
  return deleted ? "deleted" : created ? "created" : modified ? "modified" : "noop";
}
function isDeletePatch(patch2) {
  return patch2[0] === 0 && patch2[1] === null;
}
const getEditTransaction = (transaction) => ({
  type: "editTransaction",
  author: transaction.author,
  timestamp: transaction.timestamp,
  revisionId: transaction.id
});
function getEditEvents(transactions, documentId, liveEdit) {
  const editTransactions = transactions.filter((tx) => getEffectState(tx.effects[documentId]) === "modified").sort((a, b) => Date.parse(b.timestamp) - Date.parse(a.timestamp)), result = [];
  for (const transaction of editTransactions) {
    const event = liveEdit ? {
      id: transaction.id,
      timestamp: transaction.timestamp,
      type: "updateLiveDocument",
      documentId,
      revisionId: transaction.id,
      author: transaction.author,
      documentVariantType: getDocumentVariantType(documentId)
    } : {
      type: "editDocumentVersion",
      documentId,
      id: transaction.id,
      timestamp: transaction.timestamp,
      author: transaction.author,
      contributors: [transaction.author],
      releaseId: getVersionFromId(documentId),
      revisionId: transaction.id,
      transactions: [getEditTransaction(transaction)],
      documentVariantType: getDocumentVariantType(documentId)
    };
    if (result.length === 0) {
      result.push(event);
      continue;
    }
    const lastEvent = result[result.length - 1];
    isWithinMergeWindow(lastEvent.timestamp, event.timestamp) ? isEditDocumentVersionEvent(lastEvent) && (lastEvent.transactions.push(getEditTransaction(transaction)), !lastEvent.contributors.includes(event.author) && lastEvent.author !== event.author && lastEvent.contributors.push(event.author)) : result.push(event);
  }
  return result;
}
const HISTORY_CLEARED_EVENT_ID = "history-cleared", INITIAL_VALUE$5 = {
  events: [],
  nextCursor: "",
  loading: !0,
  error: null
};
function getInitialFetchEvents({
  client,
  documentId
}) {
  const documentVariantType = getDocumentVariantType(documentId), refetchEventsTrigger$ = new BehaviorSubject({
    cursor: null,
    origin: "initial"
  }), fetchEvents = ({
    limit: limit2,
    nextCursor: nextCursor2
  }) => {
    const params = new URLSearchParams({
      limit: limit2.toString()
    });
    return nextCursor2 && params.append("nextCursor", nextCursor2), client.observable.request({
      url: `/data/history/${client.config().dataset}/events/documents/${documentId}?${params.toString()}`,
      tag: "get-document-events"
    }).pipe(map((response) => ({
      events: response.events[documentId]?.map((ev) => addEventId(ev, documentVariantType)) || [],
      nextCursor: response.nextCursor,
      loading: !1,
      error: null
    })));
  }, fetchEditEvents = (events2) => {
    const eventWithRevision = documentVariantType === "version" ? events2.find(isCreateDocumentVersionEvent) : events2.find((event) => "versionRevisionId" in event && event.versionRevisionId), revisionId = eventWithRevision && "versionRevisionId" in eventWithRevision && eventWithRevision.versionRevisionId;
    return from(getDocumentTransactions({
      client,
      documentId,
      fromTransaction: revisionId || "",
      toTransaction: void 0
      // We need to get up to the present moment
    })).pipe(map((transactions) => {
      const editEvents = getEditEvents(transactions, documentId, !1);
      if (events2.length === 0 && transactions.length > 0 && editEvents.length > 0) {
        const clearedEventTimestamp = new Date(editEvents[editEvents.length - 1].timestamp).getTime() - 1;
        editEvents.unshift({
          type: "historyCleared",
          documentId,
          id: HISTORY_CLEARED_EVENT_ID,
          timestamp: new Date(clearedEventTimestamp).toISOString(),
          author: "",
          documentVariantType
        });
      }
      return editEvents;
    }));
  };
  let nextCursor = "";
  return {
    events$: refetchEventsTrigger$.pipe(switchMap(({
      cursor,
      origin
    }) => fetchEvents({
      nextCursor: cursor,
      limit: origin === "reload" ? 10 : 100
    }).pipe(switchMap((response) => documentVariantType === "published" || origin === "loadMore" ? of({
      ...response,
      origin
    }) : fetchEditEvents(response.events).pipe(map((editEvents) => ({
      ...response,
      events: [...editEvents, ...response.events],
      origin
    })))), catchError((error) => (console.error("Error fetching events", error), [{
      events: [],
      nextCursor: "",
      loading: !1,
      error,
      origin
    }])), startWith({
      events: [],
      nextCursor: "",
      loading: !0,
      error: null,
      origin
    }))), scan((prev, next) => ({
      events: removeDupes$2(prev.events, next.events),
      // If we are reloading, we should keep the cursor as it was before.
      nextCursor: next.origin === "reload" ? prev.nextCursor : next.nextCursor,
      loading: next.loading,
      error: next.error
    }), INITIAL_VALUE$5), tap((response) => {
      nextCursor = response.nextCursor;
    }), shareReplay(1)),
    /**
     * Loads new events for the document, fetching the latest events from the API.
     */
    reloadEvents: () => refetchEventsTrigger$.next({
      cursor: null,
      origin: "reload"
    }),
    /**
     * Loads more events for the document, fetching the next batch of events from the API.
     */
    loadMore: () => {
      const lastCursorUsed = refetchEventsTrigger$.getValue().cursor;
      nextCursor && lastCursorUsed !== nextCursor && refetchEventsTrigger$.next({
        origin: "loadMore",
        cursor: nextCursor
      });
    }
  };
}
const buildDocumentForDiffInput$1 = (document2) => {
  if (!document2) return {};
  const {
    _id,
    _rev,
    _createdAt,
    _updatedAt,
    _type,
    ...rest
  } = JSON.parse(JSON.stringify(document2));
  return rest;
};
function removeDuplicatedTransactions(transactions) {
  const seen = /* @__PURE__ */ new Set();
  return transactions.filter((tx) => seen.has(tx.id) ? !1 : (seen.add(tx.id), !0));
}
class MissingSinceDocumentError extends Error {
  constructor(revisionId) {
    super(`Missing since document for revision ${revisionId}`), this.name = "MissingSinceDocumentError", this.revisionId = revisionId;
  }
}
function getDocumentChanges({
  eventsObservable$,
  documentId,
  client,
  to$,
  since$,
  remoteTransactions$
}) {
  let lastResolvedSince = null, lastResolvedTo = null, lastTransactions = [];
  return combineLatest(to$, since$, eventsObservable$).pipe(switchMap$1(([toObs, since, {
    events: events2
  }]) => {
    const to = toObs?.document;
    let sinceDoc;
    if (since?.document)
      sinceDoc = since?.document;
    else {
      const selectedToEvent = events2.find((event) => event.id === to?._rev);
      selectedToEvent && isCreateDocumentVersionEvent(selectedToEvent) && to && (sinceDoc = {
        _type: to._type,
        _id: to._id,
        _rev: to._rev
      });
    }
    return sinceDoc ? remoteTransactions$.pipe(switchMap$1((remoteTx) => {
      const viewingLatest = !to?._rev;
      return (sinceDoc._rev === HISTORY_CLEARED_EVENT_ID ? of([]) : viewingLatest && lastResolvedSince === sinceDoc._rev ? of(removeDuplicatedTransactions(lastTransactions.concat(remoteTx))) : lastResolvedSince && lastResolvedSince === sinceDoc._rev && lastResolvedTo && lastResolvedTo === to?._rev ? of(lastTransactions) : from(getDocumentTransactions({
        documentId,
        client,
        toTransaction: to?._rev,
        fromTransaction: sinceDoc._rev
      }))).pipe(tap$1((transactions) => {
        lastResolvedSince = sinceDoc._rev, lastTransactions = transactions, to?._rev && (lastResolvedTo = to._rev);
      }), map$1((transactions) => ({
        loading: !1,
        diff: calculateDiff({
          documentId,
          initialDoc: sinceDoc,
          transactions,
          events: events2
        }),
        error: null
      })));
    }), catchError$1((error) => (console.error(error), of({
      loading: !1,
      diff: null,
      error
    }))), startWith$1({
      loading: !0,
      error: null,
      diff: sinceDoc && to ? diffInput(wrap$1(buildDocumentForDiffInput$1(sinceDoc), null), wrap$1(buildDocumentForDiffInput$1(to), null)) : null
    }), shareReplay$1(1)) : of({
      loading: !1,
      diff: null,
      error: since && !since.loading && since.revisionId ? (
        /**
         * In some cases, depending on history retention, we will get documents in the events api with a revision
         * that may not exist anymore in the /history/documents endpoint.
         *
         * In those cases, we cannot show the comparison, because we don't have a "from" document to select, so we will show an error to the users.
         */
        new MissingSinceDocumentError(since?.revisionId)
      ) : null
    });
  }));
}
function getExpandEvents({
  documentId,
  client
}) {
  const expandedEventsMap$ = new BehaviorSubject(/* @__PURE__ */ new Map()), expandedEvents$ = expandedEventsMap$.pipe(map$1((expandedEventsMap) => Array.from(expandedEventsMap.values()).flatMap((v) => v)));
  return {
    handleExpandEvent: async (event) => {
      if (!expandedEventsMap$.getValue().has(event.id))
        if ((isPublishDocumentVersionEvent(event) || isDeleteDocumentVersionEvent(event)) && event.versionRevisionId && event.creationEvent) {
          const transactions = await getDocumentTransactions({
            client,
            documentId,
            fromTransaction: event.creationEvent.versionRevisionId,
            toTransaction: event.versionRevisionId
          }), editEvents = getEditEvents(transactions, documentId, !1).map((editEvent) => ({
            ...editEvent,
            parentId: event.id
          })), value = expandedEventsMap$.getValue();
          value.set(event.id, editEvents), expandedEventsMap$.next(value);
        } else
          console.error("This event can't be expanded", event);
    },
    expandedEvents$
  };
}
function getRemoteTransactionsSubscription({
  client,
  isLiveEdit,
  documentId,
  documentType,
  serverActionsEnabled,
  onRefetch
}) {
  const remoteTransactions$ = new BehaviorSubject([]), remoteEdits$ = remoteTransactions$.pipe(map$1((transactions) => getEditEvents(transactions, documentId, isLiveEdit))), documentVariantType = getDocumentVariantType(documentId), onMutationReceived = (remoteMutation) => {
    if (!remoteMutation) return;
    const variant = remoteMutation.version;
    if (variant !== documentVariantType)
      return;
    if (variant === "published" && !isLiveEdit) {
      onRefetch();
      return;
    }
    const effectState = getEffectState({
      apply: remoteMutation.effects.apply,
      revert: remoteMutation.effects.revert
    });
    if (effectState === "created" || effectState === "deleted") {
      onRefetch(), remoteTransactions$.next([]);
      return;
    }
    remoteTransactions$.next([...remoteTransactions$.value, remoteMutationToTransaction(remoteMutation)]);
  }, subscription = remoteSnapshots(client, {
    draftId: getDraftId(documentId),
    publishedId: getPublishedId(documentId),
    ...isVersionId(documentId) ? {
      versionId: documentId
    } : {}
  }, documentType, serverActionsEnabled).pipe(filter$1((event) => event.type === "remoteMutation"));
  return {
    remoteTransactions$,
    remoteEdits$,
    subscribe: () => subscription.subscribe(onMutationReceived)
  };
}
function createEventsStore({
  client,
  documentId,
  documentType,
  releases$,
  serverActionsEnabled,
  isLiveEdit
}) {
  const initialEvents = getInitialFetchEvents({
    client,
    documentId
  }), {
    expandedEvents$,
    handleExpandEvent
  } = getExpandEvents({
    client,
    documentId
  }), {
    remoteEdits$,
    remoteTransactions$,
    subscribe: subscribe2
  } = getRemoteTransactionsSubscription({
    client,
    documentId,
    documentType,
    isLiveEdit,
    serverActionsEnabled,
    onRefetch: initialEvents.reloadEvents
  }), eventsObservable$ = createEventsObservable({
    documentId,
    events$: initialEvents.events$,
    remoteEdits$,
    expandedEvents$,
    releases$
  });
  return {
    eventsObservable$,
    getDocumentChanges: (revision$, since$) => getDocumentChanges({
      client,
      eventsObservable$,
      documentId,
      remoteTransactions$,
      to$: revision$,
      since$
    }),
    handleExpandEvent,
    loadMoreEvents: initialEvents.loadMore,
    reloadEvents: initialEvents.reloadEvents,
    remoteTransactionsListener: subscribe2
  };
}
const documentRevisionCache = /* @__PURE__ */ Object.create(null);
function getDocumentAtRevision({
  client,
  documentId,
  revisionId,
  time
}) {
  if (revisionId === HISTORY_CLEARED_EVENT_ID)
    return of({
      document: null,
      loading: !1,
      revisionId
    });
  const cacheKey = `${documentId}@${revisionId ? ["revisionId", revisionId].join(".") : ["time", time].join(".")}`, dataset = client.config().dataset;
  if (!documentRevisionCache[cacheKey]) {
    const searchParams = new URLSearchParams(typeof revisionId == "string" ? {
      revision: revisionId
    } : {
      time
    });
    documentRevisionCache[cacheKey] = client.observable.request({
      url: `/data/history/${dataset}/documents/${documentId}?${searchParams}`,
      tag: "get-document-revision"
    }).pipe(map((response) => {
      const document2 = response.documents[0];
      return {
        document: document2,
        loading: !1,
        revisionId: document2?._rev
      };
    }), catchError((error) => (console.error("Error fetching document at revision", error), [{
      document: null,
      loading: !1,
      revisionId
    }])), startWith({
      document: null,
      loading: !0,
      revisionId
    }), shareReplay(1));
  }
  return documentRevisionCache[cacheKey];
}
const INITIAL_VALUE$4 = {
  events: [],
  nextCursor: "",
  loading: !0,
  error: null
};
function useEventsStore(t0) {
  const $ = c(68), {
    documentId,
    documentType,
    rev,
    since
  } = t0, client = useClient(RELEASES_STUDIO_CLIENT_OPTIONS), {
    state$: releases$
  } = useReleasesStore(), configFlag = useWorkspace().__internal_serverDocumentActions?.enabled;
  let t1;
  $[0] !== configFlag ? (t1 = typeof configFlag == "boolean" ? of(configFlag) : of(!0), $[0] = configFlag, $[1] = t1) : t1 = $[1];
  const serverActionsEnabled = t1, schema2 = useSchema();
  let t2;
  $[2] !== documentType || $[3] !== schema2 ? (t2 = schema2.get(documentType), $[2] = documentType, $[3] = schema2, $[4] = t2) : t2 = $[4];
  const isLiveEdit = !!t2?.liveEdit;
  let t3;
  $[5] !== client || $[6] !== documentId || $[7] !== documentType || $[8] !== isLiveEdit || $[9] !== releases$ || $[10] !== serverActionsEnabled ? (t3 = createEventsStore({
    client,
    documentId,
    documentType,
    releases$,
    serverActionsEnabled,
    isLiveEdit
  }), $[5] = client, $[6] = documentId, $[7] = documentType, $[8] = isLiveEdit, $[9] = releases$, $[10] = serverActionsEnabled, $[11] = t3) : t3 = $[11];
  const eventsStore = t3, {
    events: events2,
    loading,
    error,
    nextCursor
  } = useObservable(eventsStore.eventsObservable$, INITIAL_VALUE$4);
  let t4, t5;
  $[12] !== eventsStore ? (t4 = () => {
    const subscription = eventsStore.remoteTransactionsListener();
    return () => {
      subscription.unsubscribe();
    };
  }, t5 = [eventsStore], $[12] = eventsStore, $[13] = t4, $[14] = t5) : (t4 = $[13], t5 = $[14]), useEffect(t4, t5);
  let t6;
  bb0: {
    if (rev === "@lastPublished") {
      let t72;
      $[15] !== events2 ? (t72 = events2.find(isPublishDocumentVersionEvent), $[15] = events2, $[16] = t72) : t72 = $[16], t6 = t72?.id || null;
      break bb0;
    }
    if (rev === "@lastEdited") {
      let t72;
      $[17] !== events2 ? (t72 = events2.find(isEditDocumentVersionEvent), $[17] = events2, $[18] = t72) : t72 = $[18];
      const editEvent = t72;
      if (editEvent) {
        t6 = editEvent.revisionId;
        break bb0;
      }
    }
    if (rev?.startsWith("@release:")) {
      let t72;
      $[19] !== rev ? (t72 = rev.split(":"), $[19] = rev, $[20] = t72) : t72 = $[20];
      const releaseId = t72[1];
      let t82;
      if ($[21] !== events2 || $[22] !== releaseId) {
        let t92;
        $[24] !== releaseId ? (t92 = (event) => isPublishDocumentVersionEvent(event) && event.releaseId === releaseId, $[24] = releaseId, $[25] = t92) : t92 = $[25], t82 = events2.find(t92), $[21] = events2, $[22] = releaseId, $[23] = t82;
      } else
        t82 = $[23];
      const releaseEvent = t82;
      if (releaseEvent) {
        t6 = releaseEvent.id;
        break bb0;
      }
      events2.length > 0 && !loading && eventsStore.loadMoreEvents();
    }
    if (!rev) {
      const [lastEvent] = events2;
      if (lastEvent && isPublishDocumentVersionEvent(lastEvent)) {
        t6 = lastEvent.id;
        break bb0;
      }
    }
    t6 = rev;
  }
  const revisionId = t6;
  let t7;
  $[26] !== client || $[27] !== documentId || $[28] !== revisionId ? (t7 = revisionId ? getDocumentAtRevision({
    client,
    documentId,
    revisionId
  }) : of(null), $[26] = client, $[27] = documentId, $[28] = revisionId, $[29] = t7) : t7 = $[29];
  const revision$ = t7, revision = useObservable(revision$, null);
  let t8;
  bb1: {
    if (since && since !== "@lastPublished") {
      t8 = since;
      break bb1;
    }
    if (!events2) {
      t8 = null;
      break bb1;
    }
    if (since === "@lastPublished" || !since) {
      let t92;
      $[30] !== revisionId ? (t92 = (e) => e.id === revisionId, $[30] = revisionId, $[31] = t92) : t92 = $[31];
      const revisionIndex = events2.findIndex(t92);
      let t102;
      $[32] !== events2 || $[33] !== revisionIndex ? (t102 = events2.slice(revisionIndex + 1).find(isPublishDocumentVersionEvent)?.id, $[32] = events2, $[33] = revisionIndex, $[34] = t102) : t102 = $[34];
      const lastPublishedId = t102;
      if (lastPublishedId) {
        t8 = lastPublishedId;
        break bb1;
      }
      let t112;
      $[35] !== events2 ? (t112 = events2.find(isCreateDocumentVersionEvent), $[35] = events2, $[36] = t112) : t112 = $[36];
      const creationEvent = t112;
      if (creationEvent) {
        t8 = creationEvent.id;
        break bb1;
      }
    }
    if (!revisionId) {
      t8 = events2[1]?.id;
      break bb1;
    }
    const revisionEventIndex = events2.findIndex((e_0) => e_0.id === revisionId);
    if (revisionEventIndex === -1) {
      t8 = null;
      break bb1;
    }
    t8 = events2[revisionEventIndex + 1]?.id || null;
  }
  const sinceId = t8;
  let t9;
  $[37] !== client || $[38] !== documentId || $[39] !== sinceId ? (t9 = sinceId ? getDocumentAtRevision({
    client,
    documentId,
    revisionId: sinceId
  }) : of(null), $[37] = client, $[38] = documentId, $[39] = sinceId, $[40] = t9) : t9 = $[40];
  const since$ = t9;
  let t10;
  $[41] !== eventsStore || $[42] !== revision$ || $[43] !== since$ ? (t10 = () => eventsStore.getDocumentChanges(revision$, since$), $[41] = eventsStore, $[42] = revision$, $[43] = since$, $[44] = t10) : t10 = $[44];
  const getChangesList = t10, sinceRevision = useObservable(since$, null);
  let t11;
  $[45] !== documentId ? (t11 = getDocumentVariantType(documentId), $[45] = documentId, $[46] = t11) : t11 = $[46];
  const documentVariantType = t11;
  let t12;
  $[47] !== documentVariantType || $[48] !== events2 || $[49] !== revisionId || $[50] !== since ? (t12 = (nextRev) => {
    if (!events2)
      return [null, null];
    const revisionIndex_0 = events2.findIndex((event_0) => event_0.id === nextRev);
    if (revisionIndex_0 === 0)
      return documentVariantType === "version" && isPublishDocumentVersionEvent(events2[0]) ? [since || null, nextRev] : [since || null, null];
    if (!since) {
      const currentRevisionIndex = events2.findIndex((event_1) => event_1.id === revisionId);
      return currentRevisionIndex === -1 || revisionIndex_0 === -1 || revisionIndex_0 > currentRevisionIndex ? [null, nextRev] : [revisionId || null, nextRev];
    }
    const sinceIndex = events2.findIndex((event_2) => event_2.id === since);
    return sinceIndex === -1 || revisionIndex_0 === -1 ? [null, nextRev] : sinceIndex < revisionIndex_0 ? [null, nextRev] : sinceIndex === revisionIndex_0 ? [null, nextRev] : [since, nextRev];
  }, $[47] = documentVariantType, $[48] = events2, $[49] = revisionId, $[50] = since, $[51] = t12) : t12 = $[51];
  const findRangeForRevision = t12;
  let t13;
  $[52] !== events2 || $[53] !== rev || $[54] !== revisionId ? (t13 = (nextSince) => {
    if (!events2)
      return [null, null];
    if (!rev || !revisionId)
      return [nextSince, null];
    const revisionIndex_1 = events2.findIndex((event_3) => event_3.id === revisionId), sinceIndex_0 = events2.findIndex((event_4) => event_4.id === nextSince);
    return sinceIndex_0 === -1 || revisionIndex_1 === -1 ? [nextSince, null] : sinceIndex_0 < revisionIndex_1 ? [nextSince, null] : sinceIndex_0 === revisionIndex_1 ? [nextSince, null] : [nextSince, revisionId];
  }, $[52] = events2, $[53] = rev, $[54] = revisionId, $[55] = t13) : t13 = $[55];
  const findRangeForSince = t13;
  let t14;
  return $[56] !== error || $[57] !== events2 || $[58] !== eventsStore.handleExpandEvent || $[59] !== eventsStore.loadMoreEvents || $[60] !== findRangeForRevision || $[61] !== findRangeForSince || $[62] !== getChangesList || $[63] !== loading || $[64] !== nextCursor || $[65] !== revision || $[66] !== sinceRevision ? (t14 = {
    events: events2,
    nextCursor,
    loading,
    error,
    revision,
    sinceRevision,
    findRangeForRevision,
    findRangeForSince,
    loadMoreEvents: eventsStore.loadMoreEvents,
    expandEvent: eventsStore.handleExpandEvent,
    getChangesList
  }, $[56] = error, $[57] = events2, $[58] = eventsStore.handleExpandEvent, $[59] = eventsStore.loadMoreEvents, $[60] = findRangeForRevision, $[61] = findRangeForSince, $[62] = getChangesList, $[63] = loading, $[64] = nextCursor, $[65] = revision, $[66] = sinceRevision, $[67] = t14) : t14 = $[67], t14;
}
const AvatarSkeleton$1 = /* @__PURE__ */ styled(Skeleton).withConfig({
  displayName: "AvatarSkeleton",
  componentId: "sc-18rwh46-0"
})((props2) => {
  const theme = getTheme_v2(props2.theme), size = props2.$size ?? 1;
  return css`
    border-radius: 50%;
    width: ${theme.avatar.sizes[size].size}px;
    height: ${theme.avatar.sizes[size].size}px;
  `;
}), symbols = /[^\p{Alpha}\p{White_Space}]/gu, whitespace = new RegExp("\\p{White_Space}+", "u"), LEGACY_TO_UI_AVATAR_SIZES = {
  small: 0,
  medium: 1,
  large: 2
};
function nameToInitials$1(fullName) {
  const namesArray = fullName.replace(symbols, "").split(whitespace);
  return namesArray.length === 1 ? `${namesArray[0].charAt(0)}`.toUpperCase() : `${namesArray[0].charAt(0)}${namesArray[namesArray.length - 1].charAt(0)}`;
}
function UserAvatar(props2) {
  const $ = c(13);
  let restProps, user, withTooltip;
  if ($[0] !== props2 ? ({
    user,
    withTooltip,
    ...restProps
  } = props2, $[0] = props2, $[1] = restProps, $[2] = user, $[3] = withTooltip) : (restProps = $[1], user = $[2], withTooltip = $[3]), isRecord$4(user)) {
    if (withTooltip) {
      const t03 = user;
      let t13;
      return $[4] !== restProps || $[5] !== t03 ? (t13 = /* @__PURE__ */ jsx(TooltipUserAvatar, { ...restProps, user: t03 }), $[4] = restProps, $[5] = t03, $[6] = t13) : t13 = $[6], t13;
    }
    const t02 = user;
    let t12;
    return $[7] !== restProps || $[8] !== t02 ? (t12 = /* @__PURE__ */ jsx(StaticUserAvatar, { ...restProps, user: t02 }), $[7] = restProps, $[8] = t02, $[9] = t12) : t12 = $[9], t12;
  }
  const t0 = user;
  let t1;
  return $[10] !== props2 || $[11] !== t0 ? (t1 = /* @__PURE__ */ jsx(UserAvatarLoader, { ...props2, user: t0 }), $[10] = props2, $[11] = t0, $[12] = t1) : t1 = $[12], t1;
}
function TooltipUserAvatar(props2) {
  const $ = c(6), {
    user: t0
  } = props2, {
    displayName
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    display: "inline-block"
  }, $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== props2 ? (t2 = /* @__PURE__ */ jsx("div", { style: t1, children: /* @__PURE__ */ jsx(StaticUserAvatar, { ...props2 }) }), $[1] = props2, $[2] = t2) : t2 = $[2];
  let t3;
  return $[3] !== displayName || $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(Tooltip, { content: displayName, placement: "top", portal: !0, children: t2 }), $[3] = displayName, $[4] = t2, $[5] = t3) : t3 = $[5], t3;
}
const StaticUserAvatar = forwardRef(function(props2, ref) {
  const $ = c(22);
  let animateArrowFrom, position, restProps, size, status, tone, user;
  $[0] !== props2 ? ({
    user,
    animateArrowFrom,
    position,
    size,
    status,
    tone,
    ...restProps
  } = props2, $[0] = props2, $[1] = animateArrowFrom, $[2] = position, $[3] = restProps, $[4] = size, $[5] = status, $[6] = tone, $[7] = user) : (animateArrowFrom = $[1], position = $[2], restProps = $[3], size = $[4], status = $[5], tone = $[6], user = $[7]);
  const [imageLoadError, setImageLoadError] = useState(null), userColor = useUserColor(user.id), imageUrl = imageLoadError ? void 0 : user?.imageUrl;
  let t0;
  $[8] !== user.displayName ? (t0 = user?.displayName && nameToInitials$1(user.displayName), $[8] = user.displayName, $[9] = t0) : t0 = $[9];
  const t1 = typeof size == "string" ? LEGACY_TO_UI_AVATAR_SIZES[size] : size, t2 = user?.displayName;
  let t3;
  return $[10] !== animateArrowFrom || $[11] !== imageUrl || $[12] !== position || $[13] !== ref || $[14] !== restProps || $[15] !== status || $[16] !== t0 || $[17] !== t1 || $[18] !== t2 || $[19] !== tone || $[20] !== userColor.name ? (t3 = /* @__PURE__ */ jsx(Avatar, { __unstable_hideInnerStroke: !0, animateArrowFrom, arrowPosition: position, color: userColor.name, "data-legacy-tone": tone, initials: t0, src: imageUrl, onImageLoadError: setImageLoadError, ref, size: t1, status, title: t2, ...restProps }), $[10] = animateArrowFrom, $[11] = imageUrl, $[12] = position, $[13] = ref, $[14] = restProps, $[15] = status, $[16] = t0, $[17] = t1, $[18] = t2, $[19] = tone, $[20] = userColor.name, $[21] = t3) : t3 = $[21], t3;
});
function UserAvatarLoader(t0) {
  const $ = c(10);
  let loadedProps, user;
  $[0] !== t0 ? ({
    user,
    ...loadedProps
  } = t0, $[0] = t0, $[1] = loadedProps, $[2] = user) : (loadedProps = $[1], user = $[2]);
  const [value, loading] = useUser(user);
  if (loading) {
    let t12;
    return $[3] !== loadedProps.size ? (t12 = /* @__PURE__ */ jsx(AvatarSkeleton$1, { $size: loadedProps.size, animated: !0 }), $[3] = loadedProps.size, $[4] = t12) : t12 = $[4], t12;
  }
  if (!value) {
    let t12;
    return $[5] !== loadedProps.size ? (t12 = /* @__PURE__ */ jsx(AvatarSkeleton$1, { $size: loadedProps.size, animated: !1 }), $[5] = loadedProps.size, $[6] = t12) : t12 = $[6], t12;
  }
  let t1;
  return $[7] !== loadedProps || $[8] !== value ? (t1 = /* @__PURE__ */ jsx(UserAvatar, { ...loadedProps, user: value }), $[7] = loadedProps, $[8] = value, $[9] = t1) : t1 = $[9], t1;
}
function useDateTimeFormat(t0) {
  const $ = c(5);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1, currentLocale = useCurrentLocale().id;
  let t2;
  return $[2] !== currentLocale || $[3] !== options ? (t2 = intlCache.dateTimeFormat(currentLocale, options), $[2] = currentLocale, $[3] = options, $[4] = t2) : t2 = $[4], t2;
}
const FIVE_SECONDS = 1e3 * 5, TWENTY_SECONDS = 1e3 * 20, ONE_MINUTE = 1e3 * 60, ONE_HOUR = ONE_MINUTE * 60, NO_YEAR_DATE_ONLY_FORMAT = {
  month: "short",
  day: "numeric"
}, DATE_ONLY_FORMAT = {
  ...NO_YEAR_DATE_ONLY_FORMAT,
  year: "numeric"
}, FULL_DATE_FORMAT = {
  ...DATE_ONLY_FORMAT,
  hour: "numeric",
  minute: "numeric"
};
function useRelativeTime(time, t0) {
  const $ = c(5);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1, [now, updateNow] = useReducer(_temp$3_, null, _temp2$1I), resolved = useFormatRelativeTime(time, options.relativeTo || now, options);
  let t2, t3;
  return $[2] !== resolved.refreshInterval ? (t2 = () => {
    let timerId;
    function tick(interval) {
      timerId = window.setTimeout(() => {
        updateNow(), timerId = window.setTimeout(() => tick(interval), interval);
      }, interval);
    }
    return resolved.refreshInterval !== null && tick(resolved.refreshInterval), () => {
      timerId !== null && clearTimeout(timerId);
    };
  }, t3 = [resolved.refreshInterval], $[2] = resolved.refreshInterval, $[3] = t2, $[4] = t3) : (t2 = $[3], t3 = $[4]), useEffect(t2, t3), resolved.timestamp;
}
function _temp2$1I() {
  return Date.now();
}
function _temp$3_() {
  return Date.now();
}
function useFormatRelativeTime(date, now, t0) {
  const $ = c(4), opts = t0 === void 0 ? {} : t0, {
    t
  } = useTranslation(), currentLocale = useCurrentLocale().id, {
    timeZone,
    minimal
  } = opts, parsedDate = date instanceof Date ? date : new Date(date), useTemporalPhrase = !!opts.useTemporalPhrase, format2 = (count2, unit) => {
    const isNextOrPrevDay = unit === "day" && Math.abs(count2) === 1, isNextOrPrevWeek = unit === "week" && Math.abs(count2) === 1;
    return useTemporalPhrase || isNextOrPrevDay ? intlCache.relativeTimeFormat(currentLocale, {
      style: minimal && !isNextOrPrevWeek ? "short" : "long",
      numeric: "auto"
    }).format(count2, unit) : intlCache.numberFormat(currentLocale, {
      style: "unit",
      unit,
      unitDisplay: minimal ? "short" : "long"
    }).format(Math.abs(count2));
  };
  if (!parsedDate.getTime())
    return {
      timestamp: "",
      refreshInterval: null
    };
  const diffMonths = differenceInMonths(now, parsedDate), diffYears = differenceInYears(now, parsedDate);
  if (diffMonths || diffYears)
    return minimal && diffYears === 0 ? {
      timestamp: intlCache.dateTimeFormat(currentLocale, {
        ...NO_YEAR_DATE_ONLY_FORMAT,
        timeZone
      }).format(parsedDate),
      refreshInterval: null
    } : minimal ? {
      timestamp: intlCache.dateTimeFormat(currentLocale, {
        ...DATE_ONLY_FORMAT,
        timeZone
      }).format(parsedDate),
      refreshInterval: null
    } : {
      timestamp: intlCache.dateTimeFormat(currentLocale, {
        ...FULL_DATE_FORMAT,
        timeZone
      }).format(parsedDate),
      refreshInterval: null
    };
  const diffWeeks = differenceInWeeks(parsedDate, now);
  if (diffWeeks)
    return {
      timestamp: format2(diffWeeks, "week"),
      refreshInterval: ONE_HOUR
    };
  const diffDays = differenceInDays(parsedDate, now);
  if (diffDays)
    return {
      timestamp: format2(diffDays, "day"),
      refreshInterval: ONE_HOUR
    };
  const diffHours = differenceInHours(parsedDate, now);
  if (diffHours)
    return {
      timestamp: format2(diffHours, "hour"),
      refreshInterval: ONE_MINUTE
    };
  const diffMins = differenceInMinutes(parsedDate, now);
  if (diffMins)
    return {
      timestamp: format2(diffMins, "minute"),
      refreshInterval: TWENTY_SECONDS
    };
  const diffSeconds = differenceInSeconds(parsedDate, now);
  if (Math.abs(diffSeconds) > 10)
    return {
      timestamp: format2(diffSeconds, "second"),
      refreshInterval: FIVE_SECONDS
    };
  let t1;
  $[0] !== t ? (t1 = t("relative-time.just-now"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== t1 ? (t2 = {
    timestamp: t1,
    refreshInterval: FIVE_SECONDS
  }, $[2] = t1, $[3] = t2) : t2 = $[3], t2;
}
const DEFAULT_RELEASE_TITLE_CHARACTER_LIMIT = 50;
function getReleaseTitleDetails(title, fallback2) {
  const fullTitle = title || fallback2, isTruncated = fullTitle.length > DEFAULT_RELEASE_TITLE_CHARACTER_LIMIT;
  return {
    displayTitle: isTruncated ? truncateString(fullTitle, DEFAULT_RELEASE_TITLE_CHARACTER_LIMIT) : fullTitle,
    fullTitle,
    isTruncated
  };
}
const DEFAULT_TOOLTIP_MAX_WIDTH = "300px";
function ReleaseTitle(props2) {
  const $ = c(17), {
    title,
    fallback: fallback2,
    enableTooltip: t0,
    tooltipMaxWidth,
    children,
    textProps
  } = props2, enableTooltip = t0 === void 0 ? !0 : t0;
  let fullTitle, isTruncated, t1;
  if ($[0] !== children || $[1] !== fallback2 || $[2] !== textProps || $[3] !== title) {
    const {
      displayTitle,
      fullTitle: t2,
      isTruncated: t3
    } = getReleaseTitleDetails(title, fallback2);
    fullTitle = t2, isTruncated = t3, t1 = children ? children({
      displayTitle,
      fullTitle,
      isTruncated
    }) : /* @__PURE__ */ jsx(Text$1, { ...textProps, children: displayTitle }), $[0] = children, $[1] = fallback2, $[2] = textProps, $[3] = title, $[4] = fullTitle, $[5] = isTruncated, $[6] = t1;
  } else
    fullTitle = $[4], isTruncated = $[5], t1 = $[6];
  const renderedContent = t1;
  if (isTruncated && enableTooltip) {
    const t2 = tooltipMaxWidth ?? DEFAULT_TOOLTIP_MAX_WIDTH;
    let t3;
    $[7] !== t2 ? (t3 = {
      maxWidth: t2
    }, $[7] = t2, $[8] = t3) : t3 = $[8];
    let t4;
    $[9] !== fullTitle ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: fullTitle }), $[9] = fullTitle, $[10] = t4) : t4 = $[10];
    let t5;
    $[11] !== t3 || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { style: t3, children: t4 }), $[11] = t3, $[12] = t4, $[13] = t5) : t5 = $[13];
    let t6;
    return $[14] !== renderedContent || $[15] !== t5 ? (t6 = /* @__PURE__ */ jsx(Tooltip, { content: t5, children: renderedContent }), $[14] = renderedContent, $[15] = t5, $[16] = t6) : t6 = $[16], t6;
  }
  return renderedContent;
}
const LATEST = "drafts", PUBLISHED$1 = "published", DEFAULT_RELEASE_TYPE = "asap", ARCHIVED_RELEASE_STATES = ["archived", "published"], RELEASE_TYPES_TONES = {
  asap: {
    tone: "caution"
  },
  scheduled: {
    tone: "suggest"
  },
  undecided: {
    tone: "neutral"
  }
}, createBundleId = customAlphabet("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", 8);
function createReleaseId() {
  return `${RELEASE_DOCUMENTS_PATH}.r${createBundleId()}`;
}
function getDocumentIsInPerspective(documentId, perspective) {
  const releaseId = getVersionFromId(documentId);
  return perspective ? typeof perspective > "u" || releaseId === "Published" ? !1 : releaseId === perspective : !isVersionId(documentId);
}
function getPublishDateFromRelease(release) {
  const dateString = release.publishedAt || release.publishAt || release.metadata.intendedPublishAt;
  return dateString ? new Date(dateString) : null;
}
function formatRelativeLocalePublishDate(release) {
  const publishDate = getPublishDateFromRelease(release);
  return publishDate ? formatRelativeLocale(publishDate, /* @__PURE__ */ new Date()) : "";
}
function isPublishedPerspective(perspective) {
  return perspective === "published";
}
function isDraftPerspective(perspective) {
  return perspective === LATEST;
}
function isReleaseScheduledOrScheduling(release) {
  return release.metadata.releaseType === "scheduled" && (release.state === "scheduled" || release.state === "scheduling");
}
const getReleaseDefaults = () => ({
  _id: createReleaseId(),
  metadata: {
    title: "",
    description: "",
    releaseType: DEFAULT_RELEASE_TYPE,
    cardinality: "many"
  }
});
function isNotArchivedRelease(release) {
  return release.state !== "archived";
}
function shouldShowReleaseInView(cardinalityView) {
  return (release) => {
    const isCardinalityOne = isCardinalityOneRelease(release);
    return cardinalityView === "drafts" ? isCardinalityOne : !isCardinalityOne;
  };
}
function filterReleasesForOverview(options) {
  const {
    releases: releases2,
    archivedReleases,
    cardinalityView,
    releaseGroupMode,
    dateFilter
  } = options, dateFiltered = ((items) => {
    if (!dateFilter) return items;
    const [startOfDayForTimeZone, endOfDayForTimeZone] = dateFilter.getTimezoneAdjustedDateTimeRange(dateFilter.filterDate);
    return items.filter((release) => {
      const publishAt = release.publishAt || release.metadata.intendedPublishAt;
      if (!publishAt || release.metadata.releaseType !== "scheduled") return !1;
      const publishDateUTC = new Date(publishAt);
      return publishDateUTC >= startOfDayForTimeZone && publishDateUTC <= endOfDayForTimeZone;
    });
  })(releaseGroupMode === "archived" ? archivedReleases : releases2);
  return cardinalityView !== "drafts" ? dateFiltered : releaseGroupMode === "active" ? dateFiltered.filter((release) => release.state === "scheduled" || release.state === "scheduling") : releaseGroupMode === "paused" ? dateFiltered.filter((release) => isPausedCardinalityOneRelease(release)) : dateFiltered;
}
function getReleaseTone(release) {
  if (isPublishedPerspective(release)) return "positive";
  if (isDraftPerspective(release)) return "default";
  if (isReleaseDocument(release)) {
    if (release.state === "archived")
      return "default";
    if (release?.metadata?.releaseType === "asap")
      return RELEASE_TYPES_TONES.asap.tone;
    if (release?.metadata?.releaseType === "undecided")
      return RELEASE_TYPES_TONES.undecided.tone;
    if (isPausedCardinalityOneRelease(release))
      return "caution";
    if (release?.metadata?.releaseType === "scheduled")
      return RELEASE_TYPES_TONES.scheduled.tone;
  }
  return isAgentBundleName(release) ? "suggest" : "default";
}
const StyledVersionInlineBadge = /* @__PURE__ */ styled.span.withConfig({
  displayName: "StyledVersionInlineBadge",
  componentId: "sc-pk6g57-0"
})((props2) => {
  const {
    $tone
  } = props2;
  return css`
    color: var(--card-badge-${$tone ?? "default"}-fg-color);
    background-color: var(--card-badge-${$tone ?? "default"}-bg-color);
    border-radius: 3px;
    text-decoration: none;
    padding: 0px 2px;
    font-weight: 500;
  `;
}), VersionInlineBadge = (t0) => {
  const $ = c(3), {
    children,
    $tone
  } = t0;
  let t1;
  return $[0] !== $tone || $[1] !== children ? (t1 = /* @__PURE__ */ jsx(StyledVersionInlineBadge, { $tone, children }), $[0] = $tone, $[1] = children, $[2] = t1) : t1 = $[2], t1;
}, getVersionInlineBadge = (release) => {
  const tone = getReleaseTone(release ?? LATEST);
  return (t0) => {
    const $ = c(2), {
      children
    } = t0;
    let t1;
    return $[0] !== children ? (t1 = /* @__PURE__ */ jsx(VersionInlineBadge, { $tone: tone, children }), $[0] = children, $[1] = t1) : t1 = $[1], t1;
  };
}, TIMELINE_ICON_COMPONENTS = {
  historyCleared: TimelineIcon,
  createDocumentVersion: AddCircleIcon,
  createLiveDocument: AddCircleIcon,
  deleteDocumentGroup: TrashIcon,
  deleteDocumentVersion: CloseIcon,
  editDocumentVersion: EditIcon,
  updateLiveDocument: EditIcon,
  publishDocumentVersion: PublishIcon,
  unpublishDocument: UnpublishIcon,
  scheduleDocumentVersion: CalendarIcon,
  unscheduleDocumentVersion: CircleIcon
}, TIMELINE_ITEM_EVENT_TONE = {
  historyCleared: "orange",
  createDocumentVersion: "green",
  createLiveDocument: "blue",
  updateLiveDocument: "green",
  editDocumentVersion: "yellow",
  unpublishDocument: "orange",
  deleteDocumentVersion: "orange",
  deleteDocumentGroup: "orange",
  scheduleDocumentVersion: "cyan",
  unscheduleDocumentVersion: "cyan",
  publishDocumentVersion: "green"
}, TIMELINE_ITEM_I18N_KEY_MAPPING = {
  published: {
    createDocumentVersion: "timeline.operation.created",
    historyCleared: "timeline.operation.history-cleared",
    publishDocumentVersion: "timeline.operation.published",
    updateLiveDocument: "timeline.operation.edited-live",
    editDocumentVersion: "timeline.operation.edited-draft",
    unpublishDocument: "timeline.operation.unpublished",
    deleteDocumentVersion: "timeline.operation.draft-discarded",
    deleteDocumentGroup: "timeline.operation.deleted",
    scheduleDocumentVersion: "timeline.operation.published",
    unscheduleDocumentVersion: "timeline.operation.published",
    createLiveDocument: "timeline.operation.created"
  },
  draft: {
    createDocumentVersion: "timeline.operation.draft-created",
    historyCleared: "timeline.operation.history-cleared",
    publishDocumentVersion: "timeline.operation.published",
    updateLiveDocument: "timeline.operation.edited-live",
    editDocumentVersion: "timeline.operation.edited-draft",
    unpublishDocument: "timeline.operation.unpublished",
    deleteDocumentVersion: "timeline.operation.draft-discarded",
    deleteDocumentGroup: "timeline.operation.deleted",
    scheduleDocumentVersion: "timeline.operation.published",
    unscheduleDocumentVersion: "timeline.operation.published",
    createLiveDocument: "timeline.operation.created"
  },
  version: {
    createDocumentVersion: "timeline.operation.version-created",
    historyCleared: "timeline.operation.history-cleared",
    publishDocumentVersion: "timeline.operation.published",
    updateLiveDocument: "timeline.operation.edited-live",
    editDocumentVersion: "timeline.operation.edited-draft",
    unpublishDocument: "timeline.operation.unpublished",
    deleteDocumentVersion: "timeline.operation.version-discarded",
    deleteDocumentGroup: "timeline.operation.deleted",
    scheduleDocumentVersion: "timeline.operation.published",
    unscheduleDocumentVersion: "timeline.operation.published",
    createLiveDocument: "timeline.operation.created"
  }
};
function UserAvatarStack(t0) {
  const $ = c(9), {
    maxLength,
    userIds,
    size,
    withTooltip: t1
  } = t0, withTooltip = t1 === void 0 ? !0 : t1;
  let t2;
  if ($[0] !== userIds || $[1] !== withTooltip) {
    let t32;
    $[3] !== withTooltip ? (t32 = (userId) => /* @__PURE__ */ jsx(UserAvatar, { user: userId, withTooltip }, userId), $[3] = withTooltip, $[4] = t32) : t32 = $[4], t2 = userIds.map(t32), $[0] = userIds, $[1] = withTooltip, $[2] = t2;
  } else
    t2 = $[2];
  let t3;
  return $[5] !== maxLength || $[6] !== size || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsx(AvatarStack, { maxLength, size, children: t2 }), $[5] = maxLength, $[6] = size, $[7] = t2, $[8] = t3) : t3 = $[8], t3;
}
const IconBox$1 = /* @__PURE__ */ styled(Flex).withConfig({
  displayName: "IconBox",
  componentId: "sc-19zc915-0"
})((props2) => {
  const theme = getTheme_v2(props2.theme), color = props2.$color;
  return css`
    --card-icon-color: ${theme.color.avatar[color].fg};
    background-color: ${theme.color.avatar[color].bg};
    box-shadow: 0 0 0 1px var(--card-bg-color);

    position: absolute;
    width: ${theme.avatar.sizes[0].size}px;
    height: ${theme.avatar.sizes[0].size}px;
    right: -3px;
    bottom: -3px;
    border-radius: 50%;
  `;
}), RELATIVE_TIME_OPTIONS$2 = {
  minimal: !0,
  useTemporalPhrase: !0
}, AvatarSkeleton = /* @__PURE__ */ styled(Skeleton).withConfig({
  displayName: "AvatarSkeleton",
  componentId: "sc-19zc915-1"
})((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    border-radius: 50%;
    width: ${theme.avatar.sizes[1].size}px;
    height: ${theme.avatar.sizes[1].size}px;
  `;
}), NameSkeleton = /* @__PURE__ */ styled(Skeleton).withConfig({
  displayName: "NameSkeleton",
  componentId: "sc-19zc915-2"
})((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    width: 6ch;
    height: ${theme.font.text.sizes[0].lineHeight}px;
  `;
}), UserLine = (t0) => {
  const $ = c(10), {
    userId
  } = t0, [user, loading] = useUser(userId);
  let t1;
  $[0] !== loading || $[1] !== user ? (t1 = /* @__PURE__ */ jsx(Box, { children: loading || !user ? /* @__PURE__ */ jsx(AvatarSkeleton, { animated: !0 }) : /* @__PURE__ */ jsx(UserAvatar, { user }) }), $[0] = loading, $[1] = user, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== loading || $[4] !== user ? (t2 = /* @__PURE__ */ jsx(Box, { children: loading || !user?.displayName ? /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(NameSkeleton, { animated: !0 }) }) : /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: user.displayName }) }), $[3] = loading, $[4] = user, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== t1 || $[7] !== t2 || $[8] !== userId ? (t3 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, padding: 1, children: [
    t1,
    t2
  ] }, userId), $[6] = t1, $[7] = t2, $[8] = userId, $[9] = t3) : t3 = $[9], t3;
}, ChangesBy = (t0) => {
  const $ = c(9), {
    collaborators
  } = t0, {
    t
  } = useTranslation("studio");
  let t1;
  $[0] !== t ? (t1 = t("timeline.changes.title"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { padding: 1, paddingBottom: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t1 }) }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== collaborators ? (t3 = collaborators.map(_temp$3Z), $[4] = collaborators, $[5] = t3) : t3 = $[5];
  let t4;
  return $[6] !== t2 || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { paddingBottom: 1, children: [
    t2,
    t3
  ] }), $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
};
function Event$1(t0) {
  const $ = c(55), {
    event,
    showChangesBy: t1
  } = t0, showChangesBy = t1 === void 0 ? "tooltip" : t1, {
    t
  } = useTranslation("studio"), {
    type,
    timestamp,
    documentVariantType
  } = event, IconComponent = TIMELINE_ICON_COMPONENTS[type];
  let t2;
  $[0] !== event ? (t2 = "contributors" in event ? event.contributors || [] : [], $[0] = event, $[1] = t2) : t2 = $[1];
  const contributors = t2;
  let t3;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    dateStyle: "medium",
    timeStyle: "short"
  }, $[2] = t3) : t3 = $[2];
  const dateFormat = useDateTimeFormat(t3);
  let t4;
  $[3] !== timestamp ? (t4 = new Date(timestamp), $[3] = timestamp, $[4] = t4) : t4 = $[4];
  const updatedTimeAgo = useRelativeTime(t4 || "", RELATIVE_TIME_OPTIONS$2);
  let t5;
  if ($[5] !== dateFormat || $[6] !== timestamp) {
    const parsedDate = new Date(timestamp);
    t5 = dateFormat.format(parsedDate), $[5] = dateFormat, $[6] = timestamp, $[7] = t5;
  } else
    t5 = $[7];
  const formattedTimestamp = t5;
  let t6;
  $[8] !== event ? (t6 = isEditDocumentVersionEvent(event) ? event.contributors : [event.author], $[8] = event, $[9] = t6) : t6 = $[9];
  const userIds = t6;
  let t7;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    position: "relative"
  }, $[10] = t7) : t7 = $[10];
  let t8;
  $[11] !== userIds ? (t8 = userIds.filter(Boolean), $[11] = userIds, $[12] = t8) : t8 = $[12];
  let t9;
  $[13] !== t8 ? (t9 = /* @__PURE__ */ jsx(UserAvatarStack, { maxLength: 3, userIds: t8, size: 2 }), $[13] = t8, $[14] = t9) : t9 = $[14];
  const t10 = TIMELINE_ITEM_EVENT_TONE[type];
  let t11;
  $[15] !== IconComponent ? (t11 = IconComponent && /* @__PURE__ */ jsx(IconComponent, {}), $[15] = IconComponent, $[16] = t11) : t11 = $[16];
  let t12;
  $[17] !== t11 ? (t12 = /* @__PURE__ */ jsx(Text$1, { size: 0, children: t11 }), $[17] = t11, $[18] = t12) : t12 = $[18];
  let t13;
  $[19] !== t10 || $[20] !== t12 ? (t13 = /* @__PURE__ */ jsx(IconBox$1, { align: "center", justify: "center", $color: t10, children: t12 }), $[19] = t10, $[20] = t12, $[21] = t13) : t13 = $[21];
  let t14;
  $[22] !== t13 || $[23] !== t9 ? (t14 = /* @__PURE__ */ jsxs("div", { style: t7, children: [
    t9,
    t13
  ] }), $[22] = t13, $[23] = t9, $[24] = t14) : t14 = $[24];
  const t15 = TIMELINE_ITEM_I18N_KEY_MAPPING[documentVariantType][type];
  let t16;
  $[25] !== t || $[26] !== t15 ? (t16 = t(t15), $[25] = t, $[26] = t15, $[27] = t16) : t16 = $[27];
  let t17;
  $[28] !== documentVariantType || $[29] !== event || $[30] !== t ? (t17 = isPublishDocumentVersionEvent(event) && documentVariantType === "published" && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    " ",
    event.release ? /* @__PURE__ */ jsx(ReleaseTitle, { title: event.release.metadata?.title, fallback: t("release.placeholder-untitled-release"), children: (t182) => {
      const {
        displayTitle
      } = t182;
      return /* @__PURE__ */ jsx(VersionInlineBadge, { $tone: isReleaseDocument(event.release) ? getReleaseTone(event.release) : "default", children: displayTitle });
    } }) : /* @__PURE__ */ jsx(VersionInlineBadge, { $tone: "caution", children: t("changes.versions.draft") })
  ] }), $[28] = documentVariantType, $[29] = event, $[30] = t, $[31] = t17) : t17 = $[31];
  let t18;
  $[32] !== t16 || $[33] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Text$1, { size: 1, weight: "medium", children: [
    t16,
    t17
  ] }), $[32] = t16, $[33] = t17, $[34] = t18) : t18 = $[34];
  let t19;
  $[35] !== formattedTimestamp || $[36] !== timestamp || $[37] !== updatedTimeAgo ? (t19 = /* @__PURE__ */ jsx(Text$1, { as: "time", size: 1, muted: !0, dateTime: timestamp, title: formattedTimestamp, children: updatedTimeAgo }), $[35] = formattedTimestamp, $[36] = timestamp, $[37] = updatedTimeAgo, $[38] = t19) : t19 = $[38];
  let t20;
  $[39] !== t18 || $[40] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t18,
    t19
  ] }), $[39] = t18, $[40] = t19, $[41] = t20) : t20 = $[41];
  let t21;
  $[42] !== contributors || $[43] !== showChangesBy ? (t21 = contributors.length > 0 && showChangesBy == "tooltip" && /* @__PURE__ */ jsx(Flex, { flex: 1, justify: "flex-end", align: "center", children: /* @__PURE__ */ jsx(Tooltip, { placement: "top", content: /* @__PURE__ */ jsx(ChangesBy, { collaborators: contributors }), portal: !0, children: /* @__PURE__ */ jsx(Box, { paddingLeft: 2, paddingY: 2, children: /* @__PURE__ */ jsx(UserAvatarStack, { maxLength: 3, userIds: contributors, size: 0, withTooltip: !1 }) }) }) }), $[42] = contributors, $[43] = showChangesBy, $[44] = t21) : t21 = $[44];
  let t22;
  $[45] !== t14 || $[46] !== t20 || $[47] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t14,
    t20,
    t21
  ] }), $[45] = t14, $[46] = t20, $[47] = t21, $[48] = t22) : t22 = $[48];
  let t23;
  $[49] !== contributors || $[50] !== showChangesBy ? (t23 = contributors.length > 0 && showChangesBy === "inline" && /* @__PURE__ */ jsx(Box, { paddingTop: 2, children: /* @__PURE__ */ jsx(ChangesBy, { collaborators: contributors }) }), $[49] = contributors, $[50] = showChangesBy, $[51] = t23) : t23 = $[51];
  let t24;
  return $[52] !== t22 || $[53] !== t23 ? (t24 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t22,
    t23
  ] }), $[52] = t22, $[53] = t23, $[54] = t24) : t24 = $[54], t24;
}
function _temp$3Z(userId) {
  return /* @__PURE__ */ jsx(UserLine, { userId }, userId);
}
function DiffTooltip(props2) {
  const $ = c(16);
  if (!("diff" in props2)) {
    let t02;
    return $[0] !== props2 ? (t02 = /* @__PURE__ */ jsx(DiffTooltipWithAnnotation, { ...props2 }), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let diff, restProps, t0;
  $[2] !== props2 ? ({
    diff,
    path: t0,
    ...restProps
  } = props2, $[2] = props2, $[3] = diff, $[4] = restProps, $[5] = t0) : (diff = $[3], restProps = $[4], t0 = $[5]);
  let t1;
  $[6] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[6] = t0, $[7] = t1) : t1 = $[7];
  const path = t1;
  let t2;
  $[8] !== diff || $[9] !== path ? (t2 = getAnnotationAtPath(diff, path), $[8] = diff, $[9] = path, $[10] = t2) : t2 = $[10];
  const annotation = t2;
  let t3;
  $[11] !== annotation ? (t3 = annotation ? [annotation] : [], $[11] = annotation, $[12] = t3) : t3 = $[12];
  let t4;
  return $[13] !== restProps || $[14] !== t3 ? (t4 = /* @__PURE__ */ jsx(DiffTooltipWithAnnotation, { ...restProps, annotations: t3 }), $[13] = restProps, $[14] = t3, $[15] = t4) : t4 = $[15], t4;
}
function DiffTooltipWithAnnotation(props2) {
  const $ = c(22);
  let annotations, children, description, restProps;
  $[0] !== props2 ? ({
    annotations,
    children,
    description,
    ...restProps
  } = props2, $[0] = props2, $[1] = annotations, $[2] = children, $[3] = description, $[4] = restProps) : (annotations = $[1], children = $[2], description = $[3], restProps = $[4]);
  const {
    t
  } = useTranslation();
  if (!annotations)
    return children;
  let t0;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    minWidth: "240px"
  }, $[5] = t0) : t0 = $[5];
  let t1;
  $[6] !== description || $[7] !== t ? (t1 = description || t("changes.changed-label"), $[6] = description, $[7] = t, $[8] = t1) : t1 = $[8];
  let t2;
  $[9] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t1 }), $[9] = t1, $[10] = t2) : t2 = $[10];
  let t3;
  $[11] !== annotations ? (t3 = annotations.map(_temp$3Y), $[11] = annotations, $[12] = t3) : t3 = $[12];
  let t4;
  $[13] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { space: 2, children: t3 }), $[13] = t3, $[14] = t4) : t4 = $[14];
  let t5;
  $[15] !== t2 || $[16] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Stack, { space: 2, style: t0, paddingTop: 1, children: [
    t2,
    t4
  ] }), $[15] = t2, $[16] = t4, $[17] = t5) : t5 = $[17];
  const content = t5;
  let t6;
  return $[18] !== children || $[19] !== content || $[20] !== restProps ? (t6 = /* @__PURE__ */ jsx(LegacyLayerProvider, { zOffset: "paneFooter", children: /* @__PURE__ */ jsx(Tooltip, { content, portal: !0, ...restProps, children }) }), $[18] = children, $[19] = content, $[20] = restProps, $[21] = t6) : t6 = $[21], t6;
}
function _temp$3Y(annotation, idx) {
  return /* @__PURE__ */ jsx(AnnotationItem, { annotation }, idx);
}
function AnnotationItem(t0) {
  const $ = c(9), {
    annotation
  } = t0, {
    author,
    timestamp
  } = annotation, [user] = useUser(author), color = useAnnotationColor(annotation);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    minimal: !0
  }, $[0] = t1) : t1 = $[0];
  const timeAgo = useRelativeTime(timestamp, t1), {
    t
  } = useTranslation();
  let t2;
  return $[1] !== annotation.event || $[2] !== author || $[3] !== color || $[4] !== t || $[5] !== timeAgo || $[6] !== timestamp || $[7] !== user ? (t2 = /* @__PURE__ */ jsx(Fragment$1, { children: annotation.event ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(Card, { borderBottom: !0, marginBottom: 2 }),
    /* @__PURE__ */ jsx(Event$1, { event: annotation.event, showChangesBy: "inline" })
  ] }) : /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    /* @__PURE__ */ jsx(Flex, { align: "center", paddingRight: 3, style: {
      backgroundColor: color.background,
      color: color.text,
      borderRadius: "calc(23px / 2)"
    }, children: author && /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(UserAvatar, { user: author }),
      /* @__PURE__ */ jsx(Inline, { paddingLeft: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, style: {
        color: color.text
      }, children: user ? user.displayName : t("changes.loading-author") }) })
    ] }) }),
    /* @__PURE__ */ jsx(Text$1, { as: "time", muted: !0, size: 1, dateTime: timestamp, children: timeAgo })
  ] }) }), $[1] = annotation.event, $[2] = author, $[3] = color, $[4] = t, $[5] = timeAgo, $[6] = timestamp, $[7] = user, $[8] = t2) : t2 = $[8], t2;
}
const StyledCard$5 = styled(Card).withConfig({
  displayName: "StyledCard",
  componentId: "sc-v5xr04-0"
})`--diff-card-radius:${({
  theme
}) => rem(theme.sanity.radius[2])};--diff-card-bg-color:${({
  theme
}) => theme.sanity.color.card.enabled.bg};max-width:100%;position:relative;border-radius:var(--diff-card-radius);background-color:${({
  $annotationColor
}) => $annotationColor.backgroundColor};color:${({
  $annotationColor
}) => $annotationColor.color};z-index:1;&:not(del){text-decoration:none;}&[data-hover]{&::after{content:'';display:block;position:absolute;left:0;right:0;bottom:0;}&:hover{border-bottom-left-radius:0;border-bottom-right-radius:0;&::after{bottom:-3px;border-top:1px solid var(---diff-card-bg-color);border-bottom:2px solid currentColor;border-bottom-left-radius:var(--diff-card-radius);border-bottom-right-radius:var(--diff-card-radius);}}[data-from-to-layout]:hover &{border-bottom-left-radius:0;border-bottom-right-radius:0;&::after{bottom:-3px;border-top:1px solid var(---diff-card-bg-color);border-bottom:2px solid currentColor;border-bottom-left-radius:var(--diff-card-radius);border-bottom-right-radius:var(--diff-card-radius);}}}`, EMPTY_PATH$1 = [], DiffCard = forwardRef(function(props2, ref) {
  const $ = c(35);
  let annotationProp, children, className, diff, disableHoverEffect, restProps, t0, t1, t2, tooltip;
  $[0] !== props2 ? ({
    annotation: annotationProp,
    as: t0,
    children,
    className,
    diff,
    disableHoverEffect,
    path: t1,
    style: t2,
    tooltip,
    ...restProps
  } = props2, $[0] = props2, $[1] = annotationProp, $[2] = children, $[3] = className, $[4] = diff, $[5] = disableHoverEffect, $[6] = restProps, $[7] = t0, $[8] = t1, $[9] = t2, $[10] = tooltip) : (annotationProp = $[1], children = $[2], className = $[3], diff = $[4], disableHoverEffect = $[5], restProps = $[6], t0 = $[7], t1 = $[8], t2 = $[9], tooltip = $[10]);
  const as = t0 === void 0 ? "div" : t0, path = t1 === void 0 ? EMPTY_PATH$1 : t1;
  let t3;
  $[11] !== t2 ? (t3 = t2 === void 0 ? {} : t2, $[11] = t2, $[12] = t3) : t3 = $[12];
  const style = t3;
  let t4;
  $[13] !== annotationProp || $[14] !== diff || $[15] !== path ? (t4 = annotationProp || getAnnotationAtPath(diff, path), $[13] = annotationProp, $[14] = diff, $[15] = path, $[16] = t4) : t4 = $[16];
  const annotation = t4, color = useAnnotationColor(annotation), t5 = disableHoverEffect || !annotation ? void 0 : "";
  let t6;
  $[17] !== color.background || $[18] !== color.text ? (t6 = {
    backgroundColor: color.background,
    color: color.text
  }, $[17] = color.background, $[18] = color.text, $[19] = t6) : t6 = $[19];
  let t7;
  $[20] !== as || $[21] !== children || $[22] !== className || $[23] !== ref || $[24] !== restProps || $[25] !== style || $[26] !== t5 || $[27] !== t6 ? (t7 = /* @__PURE__ */ jsx(StyledCard$5, { ...restProps, as, className, "data-hover": t5, "data-ui": "diff-card", ref, radius: 1, $annotationColor: t6, style, children }), $[20] = as, $[21] = children, $[22] = className, $[23] = ref, $[24] = restProps, $[25] = style, $[26] = t5, $[27] = t6, $[28] = t7) : t7 = $[28];
  const element = t7;
  if (tooltip && annotation) {
    let t8;
    $[29] !== annotation ? (t8 = [annotation], $[29] = annotation, $[30] = t8) : t8 = $[30];
    const t9 = tooltip && typeof tooltip == "object" && tooltip.description;
    let t10;
    return $[31] !== element || $[32] !== t8 || $[33] !== t9 ? (t10 = /* @__PURE__ */ jsx(DiffTooltip, { annotations: t8, description: t9, children: element }), $[31] = element, $[32] = t8, $[33] = t9, $[34] = t10) : t10 = $[34], t10;
  }
  return element;
}), RoundedCard$1 = styled.div.withConfig({
  displayName: "RoundedCard",
  componentId: "sc-42x6l9-0"
})`border-radius:${({
  theme
}) => rem(theme.sanity.radius[2])};padding:${({
  theme
}) => rem(theme.sanity.space[1])};`, AnnotationText = styled(Text$1).withConfig({
  displayName: "AnnotationText",
  componentId: "sc-42x6l9-1"
})`&:not([hidden]){color:inherit;}`;
function ChangeTitleSegment(props2) {
  const $ = c(15), {
    change,
    segment
  } = props2;
  if (typeof segment == "string") {
    let t02;
    return $[0] !== segment ? (t02 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { title: segment, size: 1, weight: "medium", textOverflow: "ellipsis", children: segment }) }), $[0] = segment, $[1] = t02) : t02 = $[1], t02;
  }
  const {
    hasMoved,
    fromIndex,
    toIndex,
    annotation
  } = segment, created = typeof fromIndex > "u", deleted = typeof toIndex > "u";
  if (created) {
    let t02;
    return $[2] !== annotation || $[3] !== change || $[4] !== toIndex ? (t02 = /* @__PURE__ */ jsx(CreatedTitleSegment, { annotation, change, toIndex }), $[2] = annotation, $[3] = change, $[4] = toIndex, $[5] = t02) : t02 = $[5], t02;
  }
  if (deleted) {
    let t02;
    return $[6] !== annotation || $[7] !== fromIndex ? (t02 = /* @__PURE__ */ jsx(DeletedTitleSegment, { annotation, fromIndex }), $[6] = annotation, $[7] = fromIndex, $[8] = t02) : t02 = $[8], t02;
  }
  if (hasMoved && typeof toIndex < "u" && typeof fromIndex < "u") {
    let t02;
    return $[9] !== annotation || $[10] !== fromIndex || $[11] !== toIndex ? (t02 = /* @__PURE__ */ jsx(MovedTitleSegment, { annotation, fromIndex, toIndex }), $[9] = annotation, $[10] = fromIndex, $[11] = toIndex, $[12] = t02) : t02 = $[12], t02;
  }
  const readableIndex = (toIndex || 0) + 1;
  let t0;
  return $[13] !== readableIndex ? (t0 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsxs(Text$1, { size: 1, weight: "medium", children: [
    "#",
    readableIndex
  ] }) }), $[13] = readableIndex, $[14] = t0) : t0 = $[14], t0;
}
function CreatedTitleSegment(props2) {
  const $ = c(18), {
    annotation: annotationProp,
    change,
    toIndex: t0
  } = props2, toIndex = t0 === void 0 ? 0 : t0, {
    t
  } = useTranslation(), readableIndex = toIndex + 1;
  let t1;
  $[0] !== readableIndex || $[1] !== t ? (t1 = t("changes.array.item-added-in-position", {
    position: readableIndex
  }), $[0] = readableIndex, $[1] = t, $[2] = t1) : t1 = $[2];
  const description = t1;
  let t2;
  $[3] !== readableIndex ? (t2 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    "#",
    readableIndex
  ] }), $[3] = readableIndex, $[4] = t2) : t2 = $[4];
  const content = t2;
  let t3;
  $[5] !== change ? (t3 = change?.diff ? getAnnotationAtPath(change.diff, []) : void 0, $[5] = change, $[6] = t3) : t3 = $[6];
  const annotation = t3 || annotationProp;
  if (annotation) {
    let t42;
    $[7] !== description ? (t42 = {
      description
    }, $[7] = description, $[8] = t42) : t42 = $[8];
    let t5;
    $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
      textDecoration: "none"
    }, $[9] = t5) : t5 = $[9];
    let t6;
    $[10] !== content ? (t6 = /* @__PURE__ */ jsx(AnnotationText, { size: 1, weight: "medium", forwardedAs: "ins", style: t5, children: content }), $[10] = content, $[11] = t6) : t6 = $[11];
    let t7;
    return $[12] !== annotation || $[13] !== t42 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsx(DiffCard, { annotation, tooltip: t42, as: RoundedCard$1, children: t6 }), $[12] = annotation, $[13] = t42, $[14] = t6, $[15] = t7) : t7 = $[15], t7;
  }
  let t4;
  return $[16] !== content ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: content }), $[16] = content, $[17] = t4) : t4 = $[17], t4;
}
function DeletedTitleSegment(props2) {
  const $ = c(11), {
    annotation,
    fromIndex: t0
  } = props2, fromIndex = t0 === void 0 ? 0 : t0, {
    t
  } = useTranslation(), readableIndex = fromIndex + 1;
  let t1;
  $[0] !== readableIndex || $[1] !== t ? (t1 = t("changes.array.item-removed-from-position", {
    position: readableIndex
  }), $[0] = readableIndex, $[1] = t, $[2] = t1) : t1 = $[2];
  const description = t1, t2 = annotation || null;
  let t3;
  $[3] !== description ? (t3 = {
    description
  }, $[3] = description, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== readableIndex ? (t4 = /* @__PURE__ */ jsxs(AnnotationText, { size: 1, weight: "medium", forwardedAs: "del", children: [
    "#",
    readableIndex
  ] }), $[5] = readableIndex, $[6] = t4) : t4 = $[6];
  let t5;
  return $[7] !== t2 || $[8] !== t3 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(DiffCard, { annotation: t2, as: RoundedCard$1, tooltip: t3, children: t4 }), $[7] = t2, $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
}
function MovedTitleSegment(props2) {
  const $ = c(19), {
    annotation,
    fromIndex,
    toIndex
  } = props2, {
    t
  } = useTranslation(), indexDiff = toIndex - fromIndex, indexSymbol = indexDiff < 0 ? "\u2191" : "\u2193";
  let t0;
  if ($[0] !== indexDiff || $[1] !== t) {
    const positions = Math.abs(indexDiff), direction = indexDiff < 0 ? "up" : "down";
    t0 = t("changes.array.item-moved", {
      count: positions,
      context: direction
    }), $[0] = indexDiff, $[1] = t, $[2] = t0;
  } else
    t0 = $[2];
  const description = t0, t1 = toIndex + 1;
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsxs(AnnotationText, { size: 1, weight: "medium", children: [
    "#",
    t1
  ] }) }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== description ? (t3 = {
    description
  }, $[5] = description, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== indexDiff ? (t4 = Math.abs(indexDiff), $[7] = indexDiff, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== indexSymbol || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsxs(AnnotationText, { size: 1, weight: "medium", children: [
    indexSymbol,
    t4
  ] }), $[9] = indexSymbol, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== annotation || $[13] !== t3 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(DiffCard, { annotation, as: RoundedCard$1, tooltip: t3, children: t5 }), $[12] = annotation, $[13] = t3, $[14] = t5, $[15] = t6) : t6 = $[15];
  let t7;
  return $[16] !== t2 || $[17] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t2,
    t6
  ] }), $[16] = t2, $[17] = t6, $[18] = t7) : t7 = $[18], t7;
}
function ChangeBreadcrumb(props2) {
  const $ = c(8), {
    change,
    titlePath
  } = props2;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ChevronRightIcon, {}) }), $[0] = t0) : t0 = $[0];
  let t1;
  if ($[1] !== change || $[2] !== titlePath) {
    let t22;
    $[4] !== change ? (t22 = (titleSegment, idx) => typeof titleSegment == "string" || !change || change.showIndex ? /* @__PURE__ */ jsx(ChangeTitleSegment, { change, segment: titleSegment }, idx) : null, $[4] = change, $[5] = t22) : t22 = $[5], t1 = titlePath.map(t22), $[1] = change, $[2] = titlePath, $[3] = t1;
  } else
    t1 = $[3];
  let t2;
  return $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Breadcrumbs, { maxLength: 4, separator: t0, children: t1 }), $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
function isThenable(value) {
  return isRecord$4(value) && typeof value?.then == "function";
}
function useCheckCondition(checkProperty, checkPropertyName, context) {
  const $ = c(8), {
    currentUser,
    document: document2,
    parent,
    value,
    path
  } = context;
  let t0;
  if ($[0] !== checkProperty || $[1] !== checkPropertyName || $[2] !== currentUser || $[3] !== document2 || $[4] !== parent || $[5] !== path || $[6] !== value) {
    bb0: {
      let isTrueIsh;
      if (typeof checkProperty == "boolean" || checkProperty === void 0) {
        t0 = checkProperty || !1;
        break bb0;
      }
      try {
        isTrueIsh = checkProperty({
          document: document2,
          parent,
          value,
          currentUser,
          path
        });
      } catch (t1) {
        console.error(`An error occurred while running the callback from \`${checkPropertyName}\`: ${t1.message}`), t0 = !1;
        break bb0;
      }
      if (isThenable(isTrueIsh)) {
        console.warn(`The \`${checkPropertyName}\` option is either a promise or a promise returning function. Async callbacks for \`${checkPropertyName}\` option is not currently supported.`), t0 = !1;
        break bb0;
      }
      typeof isTrueIsh > "u" && console.warn(`The \`${checkPropertyName}\` option is or returned \`undefined\`. \`${checkPropertyName}\` should return a boolean.`), t0 = isTrueIsh;
    }
    $[0] = checkProperty, $[1] = checkPropertyName, $[2] = currentUser, $[3] = document2, $[4] = parent, $[5] = path, $[6] = value, $[7] = t0;
  } else
    t0 = $[7];
  return t0;
}
const useConditionalProperty = (props2) => {
  const $ = c(6), {
    checkProperty: t0,
    checkPropertyKey,
    document: document2,
    parent,
    value: valueProp,
    path
  } = props2, checkProperty = t0 === void 0 ? !1 : t0, value = useUnique(valueProp), currentUser = useCurrentUser();
  let t1;
  return $[0] !== currentUser || $[1] !== document2 || $[2] !== parent || $[3] !== path || $[4] !== value ? (t1 = {
    currentUser,
    document: document2,
    parent,
    value,
    path
  }, $[0] = currentUser, $[1] = document2, $[2] = parent, $[3] = path, $[4] = value, $[5] = t1) : t1 = $[5], useCheckCondition(checkProperty, checkPropertyKey, t1);
};
function resolveTypeName(value) {
  return isTypedObject$1(value) ? value._type : resolveJSType(value);
}
function getArrayDiffItemType(diff, schemaType) {
  return diff.action === "added" ? {
    toType: resolveArrayMemberType(schemaType, diff.toValue)
  } : diff.action === "changed" ? {
    fromType: resolveArrayMemberType(schemaType, diff.fromValue),
    toType: resolveArrayMemberType(schemaType, diff.toValue)
  } : diff.action === "removed" ? {
    fromType: resolveArrayMemberType(schemaType, diff.fromValue)
  } : {
    toType: resolveArrayMemberType(schemaType, diff.toValue)
  };
}
function resolveArrayMemberType(schemaType, value) {
  const typeName = resolveTypeName(value);
  return schemaType.of.find((candidate) => candidate.name === typeName) || (schemaType.of.length === 1 ? schemaType.of[0] : void 0);
}
function resolveJSType(val) {
  return Array.isArray(val) ? "array" : val === null ? "null" : typeof val;
}
const ANNOTATION_SYMBOLS = [
  // [startTag, endTag]
  ["\uF050", "\uF051"],
  ["\uF052", "\uF053"],
  ["\uF054", "\uF055"],
  ["\uF056", "\uF057"],
  ["\uF058", "\uF059"],
  ["\uF05A", "\uF05B"],
  ["\uF05C", "\uF05D"],
  ["\uF05F", "\uF060"],
  ["\uF061", "\uF062"],
  ["\uF063", "\uF064"],
  ["\uF065", "\uF066"],
  ["\uF067", "\uF068"],
  ["\uF069", "\uF06A"],
  ["\uF06B", "\uF06C"],
  ["\uF06E", "\uF06F"],
  ["\uF070", "\uF071"],
  ["\uF072", "\uF073"],
  ["\uF074", "\uF075"],
  ["\uF076", "\uF077"],
  ["\uF078", "\uF079"],
  ["\uF07A", "\uF07B"],
  ["\uF07C", "\uF07D"],
  ["\uF07E", "\uF07F"],
  ["\uF080", "\uF081"],
  ["\uF082", "\uF083"],
  ["\uF084", "\uF085"],
  ["\uF086", "\uF087"],
  ["\uF088", "\uF089"],
  ["\uF08A", "\uF08B"],
  ["\uF08C", "\uF08D"],
  ["\uF08E", "\uF08F"]
], CHILD_SYMBOL$1 = "\uF0D0", DECORATOR_SYMBOLS = [
  // [startTag, endTag]
  ["\uF000", "\uF001"],
  ["\uF002", "\uF003"],
  ["\uF004", "\uF005"],
  ["\uF006", "\uF007"],
  ["\uF008", "\uF009"],
  ["\uF00A", "\uF00B"],
  ["\uF00C", "\uF00D"],
  ["\uF00F", "\uF010"],
  ["\uF011", "\uF012"],
  ["\uF013", "\uF014"],
  ["\uF015", "\uF016"],
  ["\uF017", "\uF018"],
  ["\uF019", "\uF01A"],
  ["\uF01B", "\uF01C"],
  ["\uF01E", "\uF01F"],
  ["\uF020", "\uF021"]
], EMPTY_BLOCK_SYMBOL = "\u21B2", INLINE_SYMBOLS = ["\uF090", "\uF091", "\uF092", "\uF093", "\uF094", "\uF095", "\uF096", "\uF097", "\uF098", "\uF099", "\uF09A", "\uF09B", "\uF09C", "\uF09D", "\uF09E", "\uF09F", "\uF0A0", "\uF0A1", "\uF0A2", "\uF0A3", "\uF0A4", "\uF0A5", "\uF0A6", "\uF0A7", "\uF0A8", "\uF0A9", "\uF0AA", "\uF0AB", "\uF0AC", "\uF0AD", "\uF0AE", "\uF0AF", "\uF0B0", "\uF0B1", "\uF0B2", "\uF0B3", "\uF0B4", "\uF0B5", "\uF0B6", "\uF0B7", "\uF0B8", "\uF0B9", "\uF0BA", "\uF0BB", "\uF0BC", "\uF0BD", "\uF0BE", "\uF0BF"], TRAILING_SPACE_SYMBOL = "\u205F", SEGMENT_START_SYMBOL = "\u2060";
function hasPTMemberType(schemaType) {
  return schemaType.of.some(isPTSchemaType);
}
const startMarkSymbols = DECORATOR_SYMBOLS.map((set2) => set2[0]).concat(ANNOTATION_SYMBOLS.map((set2) => set2[0])), endMarkSymbols = DECORATOR_SYMBOLS.map((set2) => set2[1]).concat(ANNOTATION_SYMBOLS.map((set2) => set2[1])), allSymbols = startMarkSymbols.concat(endMarkSymbols).concat(INLINE_SYMBOLS).concat(CHILD_SYMBOL$1).concat(SEGMENT_START_SYMBOL), symbolRegex = new RegExp(`${allSymbols.join("|")}`, "g"), segmentRegex = new RegExp(`${allSymbols.join("|")}|
`, "g");
function isPTSchemaType(schemaType) {
  return schemaType.jsonType === "object" && schemaType.name === "block";
}
function isHeader(node) {
  return isPortableTextTextBlock(node) && !!node.style && ["h1", "h2", "h3", "h4", "h5", "h6"].includes(node.style);
}
function findChildDiff(diff, child) {
  return diff.fields.children.items.filter((item) => item.diff.isChanged && (item.diff.toValue === child || item.diff.fromValue === child)).map((item) => item.diff).map((childDiff) => childDiff)[0];
}
function getChildSchemaType(fields, child) {
  const childrenField = fields.find((f) => f.name === "children");
  return childrenField && childrenField.type && childrenField.type.jsonType === "array" && childrenField.type.of.find((type) => type.name === child._type) || void 0;
}
function getDecorators(spanSchemaType) {
  return spanSchemaType.decorators ? orderBy(spanSchemaType.decorators, ["value"], ["asc"]) : [];
}
function isDecorator(name, schemaType) {
  return getDecorators(schemaType).some((dec2) => dec2.value === name);
}
function blockToSymbolizedText(diff, block, decoratorMap, annotationMap, inlineMap) {
  return block ? block.children.map((child) => {
    let returned = isPortableTextSpan(child) ? child.text?.replace(symbolRegex, "") : "";
    if (isPortableTextSpan(child)) {
      const textDiff = findSpanDiffFromChild(diff, child)?.fields.text;
      textDiff && textDiff.toValue === child.text && textDiff.type === "string" && textDiff.action !== "unchanged" && (returned = textDiff.segments.filter((seg) => seg.action !== "removed").map((seg) => seg.text.replace(symbolRegex, "")).join(SEGMENT_START_SYMBOL)), child.marks && child.marks.forEach((mark) => {
        decoratorMap[mark] ? returned = `${decoratorMap[mark][0]}${returned}${decoratorMap[mark][1]}` : annotationMap[mark] && (returned = `${annotationMap[mark][0]}${returned}${annotationMap[mark][1]}`);
      });
    } else
      returned = inlineMap[child._key];
    return `${CHILD_SYMBOL$1}${returned}`;
  }).join("") : "";
}
function createPortableTextDiff(diff, schemaType) {
  const displayValue = diff.action === "removed" ? diff.fromValue : diff.toValue, _diff = {
    ...diff,
    origin: diff
  };
  if (displayValue) {
    const annotationMap = {}, decoratorMap = {}, inlineMap = {}, spanSchemaType = getChildSchemaType(schemaType.fields, {
      _type: "span"
    });
    spanSchemaType && getDecorators(spanSchemaType).forEach((dec2, index) => {
      decoratorMap[dec2.value] = DECORATOR_SYMBOLS[index];
    }), getAllMarkDefs(_diff.origin).forEach((markDef, index) => {
      annotationMap[markDef._key] = ANNOTATION_SYMBOLS[index];
    }), getInlineObjects(_diff.origin).forEach((inline, index) => {
      inlineMap[inline._key] = INLINE_SYMBOLS[index];
    });
    const fromText = blockToSymbolizedText(_diff.origin, _diff.fromValue, decoratorMap, annotationMap, inlineMap), toText = blockToSymbolizedText(_diff.origin, _diff.toValue, decoratorMap, annotationMap, inlineMap), toPseudoValue = {
      ...displayValue,
      children: [{
        _type: "span",
        _key: "pseudoSpanKey",
        text: toText,
        marks: []
      }]
    }, fromPseudoValue = {
      displayValue,
      children: [{
        _type: "span",
        _key: "pseudoSpanKey",
        text: fromText,
        marks: []
      }]
    };
    return {
      origin: diff,
      action: "changed",
      type: "object",
      displayValue: toPseudoValue,
      fromValue: fromPseudoValue,
      toValue: toPseudoValue,
      isChanged: !0,
      fields: {
        children: {
          action: "changed",
          type: "array",
          isChanged: !0,
          items: [{
            diff: {
              action: "changed",
              type: "object",
              isChanged: !0,
              fields: {
                text: {
                  type: "string",
                  action: "changed",
                  isChanged: !0,
                  fromValue: fromText,
                  toValue: toText,
                  segments: buildSegments(fromText, toText).map((seg) => ({
                    ...seg,
                    ..._diff.action !== "unchanged" && _diff.annotation ? {
                      annotation: _diff.annotation
                    } : {}
                  }))
                }
              },
              fromValue: fromPseudoValue.children[0],
              toValue: toPseudoValue.children[0]
            },
            annotation: null,
            fromIndex: 0,
            toIndex: 0,
            hasMoved: !1
          }],
          fromValue: fromPseudoValue.children,
          toValue: toPseudoValue.children
        }
      }
    };
  }
  throw new Error("Can not display this diff");
}
function buildSegments(fromInput, toInput) {
  const segments = [], dmpDiffs = cleanupEfficiency(makeDiff(fromInput, toInput));
  let fromIdx = 0, toIdx = 0;
  for (const [op, text] of dmpDiffs)
    switch (op) {
      case DIFF_EQUAL:
        segments.push({
          type: "stringSegment",
          action: "unchanged",
          text
        }), fromIdx += text.length, toIdx += text.length;
        break;
      case DIFF_DELETE:
        segments.push({
          type: "stringSegment",
          action: "removed",
          text: fromInput.slice(fromIdx, fromIdx + text.length),
          annotation: null
        }), fromIdx += text.length;
        break;
      case DIFF_INSERT:
        segments.push({
          type: "stringSegment",
          action: "added",
          text: toInput.slice(toIdx, toIdx + text.length),
          annotation: null
        }), toIdx += text.length;
        break;
    }
  return flatten$1(segments.map((seg) => {
    const newSegments = [];
    if (seg.text.length > 1) {
      const markMatches = [...seg.text.matchAll(segmentRegex)];
      let lastIndex = -1;
      markMatches.forEach((match) => {
        const index = match.index || 0;
        index > lastIndex && (newSegments.push({
          ...seg,
          text: seg.text.slice(lastIndex + 1, index)
        }), newSegments.push({
          ...seg,
          text: match[0]
        })), match === markMatches[markMatches.length - 1] && newSegments.push({
          ...seg,
          text: seg.text.slice(Math.max(0, index + 1))
        }), lastIndex = index;
      }), markMatches.length === 0 && newSegments.push(seg);
    } else
      newSegments.push(seg);
    return newSegments;
  }));
}
function getInlineObjects(diff) {
  const allChildren = diff.toValue ? diff.toValue.children.filter((cld) => cld._type !== "span") : [];
  return (diff.fromValue ? diff.fromValue.children.filter((cld) => cld._type !== "span") : []).forEach((oCld) => {
    allChildren.some((cld) => oCld._key === cld._key) || allChildren.push(oCld);
  }), orderBy(allChildren, ["_key"], ["asc"]);
}
function findSpanDiffFromChild(diff, child) {
  const candidate = diff.fields.children && diff.fields.children.action !== "unchanged" && diff.fields.children.type === "array" && diff.fields.children.items.find((item) => item.diff && item.diff.type === "object" && (item.diff.action === "removed" ? item.diff.fromValue && item.diff.fromValue._key === child._key : (item.diff.toValue && item.diff.toValue._key) === child._key));
  if (candidate)
    return candidate.diff;
}
function findAnnotationDiff(diff, markDefKey) {
  return diff.fields.markDefs && diff.fields.markDefs.isChanged && diff.fields.markDefs.type === "array" && diff.fields.markDefs.items.find((item) => item.diff && item.diff.type === "object" && (item.diff.toValue && item.diff.toValue._key && item.diff.toValue._key === markDefKey || item.diff.fromValue && item.diff.fromValue._key && item.diff.fromValue._key === markDefKey))?.diff || void 0;
}
function isEmptyObject(object) {
  return object && isEqual$1(Object.keys(object), ["_key", "_type"]) || !1;
}
function escapeRegExp(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
function getAllMarkDefs(diff) {
  const allDefs = [...diff.toValue && diff.toValue.markDefs ? diff.toValue.markDefs : []];
  return (diff.fromValue && diff.fromValue.markDefs ? diff.fromValue.markDefs : []).forEach((oDef) => {
    allDefs.some((def) => oDef._key === def._key) || allDefs.push(oDef);
  }), orderBy(allDefs, ["_key"], ["asc"]);
}
function getPrintableType(value) {
  const nativeType = typeof value;
  if (nativeType === "object") {
    if (value === null) return "null";
    if (Array.isArray(value)) return "array";
    if (value instanceof Object && value.constructor.name !== "Object")
      return value.constructor.name;
  }
  return nativeType;
}
function getValueError(value, schemaType) {
  const {
    jsonType
  } = schemaType, valueType = Array.isArray(value) ? "array" : typeof value;
  if (!(value === null || valueType === "undefined")) {
    if (valueType !== jsonType)
      return {
        messageKey: "changes.error.incorrect-type-message",
        value,
        expectedType: jsonType,
        actualType: getPrintableType(value)
      };
    if (isObjectType$1(schemaType) && isObjectValue(value))
      for (const field of schemaType.fields) {
        const fieldError = getValueError(value[field.name], field.type);
        if (fieldError)
          return fieldError;
      }
  }
}
function isObjectType$1(schemaType) {
  return schemaType.jsonType === "object";
}
function isObjectValue(value) {
  return value !== null && !Array.isArray(value) && typeof value == "object";
}
function noop$6() {
}
function isFieldChange(change) {
  return change.type === "field";
}
function isGroupChange(change) {
  return change.type === "group";
}
function isAddedItemDiff(item) {
  return item.diff.action === "added";
}
function isRemovedItemDiff(item) {
  return item.diff.action === "removed";
}
function isUnchangedDiff(diff) {
  return diff.action === "unchanged";
}
const emptyValuesByType = {
  string: "",
  number: 0,
  boolean: !1,
  array: [],
  object: {}
}, diffResolvers = [];
function Checkbox(t0) {
  const $ = c(11), {
    checked,
    color
  } = t0, t1 = color?.background;
  let t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx("rect", { x: "0", y: "0", width: "17", height: "17", rx: "2.5" }), $[0] = t2) : t2 = $[0];
  let t3;
  $[1] !== checked || $[2] !== color?.text ? (t3 = typeof checked > "u" && /* @__PURE__ */ jsx("path", { d: "M4.07996 8.5H12.92", stroke: color?.text, strokeWidth: "2" }), $[1] = checked, $[2] = color?.text, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== checked || $[5] !== color?.text ? (t4 = checked && /* @__PURE__ */ jsx("path", { d: "M3.5 8L7 11.5L13.5 5", stroke: color?.text, strokeWidth: "2" }), $[4] = checked, $[5] = color?.text, $[6] = t4) : t4 = $[6];
  let t5;
  return $[7] !== t1 || $[8] !== t3 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsxs("svg", { width: "17", height: "17", viewBox: "0 0 17 17", xmlns: "http://www.w3.org/2000/svg", fill: t1, children: [
    t2,
    t3,
    t4
  ] }), $[7] = t1, $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
}
function Switch(t0) {
  const $ = c(13), {
    checked,
    color
  } = t0, t1 = checked ? color?.border : color?.background;
  let t2;
  $[0] !== t1 ? (t2 = /* @__PURE__ */ jsx("rect", { width: "38", height: "22", rx: "11", fill: t1 }), $[0] = t1, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== checked ? (t3 = typeof checked > "u" && /* @__PURE__ */ jsx("rect", { x: "11", y: "3", width: "16", height: "16", rx: "8", fill: "white" }), $[2] = checked, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== checked ? (t4 = checked && /* @__PURE__ */ jsx("rect", { x: "18", y: "3", width: "16", height: "16", rx: "8", fill: "white" }), $[4] = checked, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== checked ? (t5 = typeof checked == "boolean" && !checked && /* @__PURE__ */ jsx("rect", { x: "4", y: "3", width: "16", height: "16", rx: "8", fill: "white" }), $[6] = checked, $[7] = t5) : t5 = $[7];
  let t6;
  return $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsxs("svg", { width: "38", height: "22", viewBox: "0 0 38 22", xmlns: "http://www.w3.org/2000/svg", children: [
    t2,
    t3,
    t4,
    t5
  ] }), $[8] = t2, $[9] = t3, $[10] = t4, $[11] = t5, $[12] = t6) : t6 = $[12], t6;
}
const BooleanFieldDiff = (t0) => {
  const $ = c(24), {
    diff,
    schemaType
  } = t0, {
    fromValue,
    toValue
  } = diff, {
    title,
    options
  } = schemaType, Preview2 = options?.layout === "checkbox" ? Checkbox : Switch;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[0] = t1) : t1 = $[0];
  const userColor = useDiffAnnotationColor(diff, t1), {
    showFromValue
  } = useDocumentChange(), showToValue = toValue != null;
  let t2;
  $[1] !== Preview2 || $[2] !== fromValue || $[3] !== showFromValue || $[4] !== userColor ? (t2 = showFromValue && /* @__PURE__ */ jsx(Preview2, { checked: fromValue, color: userColor }), $[1] = Preview2, $[2] = fromValue, $[3] = showFromValue, $[4] = userColor, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== Preview2 || $[7] !== showFromValue || $[8] !== showToValue || $[9] !== toValue || $[10] !== userColor ? (t3 = showToValue && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    showFromValue && /* @__PURE__ */ jsx(Box, { marginX: 2, children: /* @__PURE__ */ jsx(FromToArrow, {}) }),
    /* @__PURE__ */ jsx(Preview2, { checked: toValue, color: userColor })
  ] }), $[6] = Preview2, $[7] = showFromValue, $[8] = showToValue, $[9] = toValue, $[10] = userColor, $[11] = t3) : t3 = $[11];
  let t4;
  $[12] !== t2 || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t2,
    t3
  ] }), $[12] = t2, $[13] = t3, $[14] = t4) : t4 = $[14];
  let t5;
  $[15] !== diff || $[16] !== t4 ? (t5 = /* @__PURE__ */ jsx(DiffTooltip, { diff, children: t4 }), $[15] = diff, $[16] = t4, $[17] = t5) : t5 = $[17];
  let t6;
  $[18] !== showToValue || $[19] !== title ? (t6 = showToValue && title && /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: title }) }), $[18] = showToValue, $[19] = title, $[20] = t6) : t6 = $[20];
  let t7;
  return $[21] !== t5 || $[22] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t5,
    t6
  ] }), $[21] = t5, $[22] = t6, $[23] = t7) : t7 = $[23], t7;
}, DatetimeWrapper = styled.div.withConfig({
  displayName: "DatetimeWrapper",
  componentId: "sc-1ygkdrz-0"
})`display:inline-block;word-wrap:break-word;`, DatetimePreview = function(t0) {
  const $ = c(5), {
    value,
    schemaType
  } = t0;
  let t1;
  $[0] !== schemaType || $[1] !== value ? (t1 = formatDateTime(value, schemaType), $[0] = schemaType, $[1] = value, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { as: DatetimeWrapper, paddingX: 2, paddingY: 1, children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4], t2;
};
function formatDateTime(value, schemaType) {
  const {
    options,
    name
  } = schemaType, dateFormat = options?.dateFormat || legacyDateFormat.DEFAULT_DATE_FORMAT, timeFormat = options?.timeFormat || legacyDateFormat.DEFAULT_TIME_FORMAT;
  return legacyDateFormat.format(new Date(value), name === "date" ? dateFormat : `${dateFormat} ${timeFormat}`);
}
const DatetimeFieldDiff = (t0) => {
  const $ = c(3), {
    diff,
    schemaType
  } = t0;
  let t1;
  return $[0] !== diff || $[1] !== schemaType ? (t1 = /* @__PURE__ */ jsx(DiffFromTo, { align: "center", diff, layout: "grid", previewComponent: DatetimePreview, schemaType }), $[0] = diff, $[1] = schemaType, $[2] = t1) : t1 = $[2], t1;
};
function useDocumentChange() {
  const documentChange = useContext(DocumentChangeContext);
  if (!documentChange)
    throw new Error("DocumentChange: missing context value");
  return documentChange;
}
function useRefValue(refId) {
  const $ = c(4), [value, setValue] = useState(void 0), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0, t1;
  return $[0] !== client || $[1] !== refId ? (t0 = () => {
    if (!refId)
      return;
    const subscription = client.observable.getDocument(refId).subscribe(setValue);
    return () => {
      subscription.unsubscribe();
    };
  }, t1 = [client, refId], $[0] = client, $[1] = refId, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1), refId ? value : void 0;
}
function getSizeDiff(prev, next) {
  if (!prev || !next)
    return 0;
  const increase = next - prev;
  return Math.round(increase / prev * 100);
}
function getHumanFriendlyBytes(bytes, format2) {
  return bytes < 1e3 ? format2(bytes, "byte") : bytes < 1e3 * 1e3 ? format2(bytes / 1e3, "kilobyte") : bytes < 1e3 * 1e3 * 1e3 ? format2(bytes / (1e3 * 1e3), "megabyte") : bytes < 1e3 * 1e3 * 1e3 * 1e3 ? format2(bytes / (1e3 * 1e3 * 1e3), "gigabyte") : format2(bytes / (1e3 * 1e3 * 1e3 * 1e3), "terabyte");
}
const SizeDiff = styled.div.withConfig({
  displayName: "SizeDiff",
  componentId: "sc-15jc302-0"
})`${({
  theme
}) => `
    --size-diff-positive: ${theme.sanity.color.solid.positive.enabled.bg};
    --size-diff-negative: ${theme.sanity.color.solid.critical.enabled.bg};
  `} &:not([hidden]){display:inline-block;}[data-number='positive']{color:var(--size-diff-positive);}[data-number='negative']{color:var(--size-diff-negative);}`, FileFieldDiff = (t0) => {
  const $ = c(53), {
    diff,
    schemaType
  } = t0, {
    fromValue,
    toValue,
    fields
  } = diff, fromAsset = fromValue?.asset, toAsset = toValue?.asset, {
    t
  } = useTranslation(), prev = useRefValue(fromAsset?._ref), next = useRefValue(toAsset?._ref);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    unitDisplay: "short",
    maximumFractionDigits: 2
  }, $[0] = t1) : t1 = $[0];
  const formatUnit = useUnitFormatter(t1);
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = ["_type", "media"], $[1] = t2) : t2 = $[1];
  const ignoredFields = t2;
  let t3;
  $[2] !== fields ? (t3 = Object.entries(fields).filter((t42) => {
    const [name, field] = t42;
    return field.isChanged && !ignoredFields.includes(name);
  }).map(_temp$3X), $[2] = fields, $[3] = t3) : t3 = $[3];
  const changedFields = t3, didAssetChange = changedFields.includes("asset");
  let t4;
  if ($[4] !== changedFields || $[5] !== schemaType.fields) {
    let t52;
    $[7] !== changedFields ? (t52 = (field_0) => field_0.name !== "asset" && changedFields.includes(field_0.name), $[7] = changedFields, $[8] = t52) : t52 = $[8], t4 = schemaType.fields.filter(t52).map(_temp2$1H), $[4] = changedFields, $[5] = schemaType.fields, $[6] = t4;
  } else
    t4 = $[6];
  const nestedFields = t4, pctDiff = getSizeDiff(prev?.size, next?.size);
  let t5;
  $[9] !== formatUnit || $[10] !== prev ? (t5 = prev?.size && getHumanFriendlyBytes(prev.size, formatUnit), $[9] = formatUnit, $[10] = prev, $[11] = t5) : t5 = $[11];
  const prevSize = t5;
  let t6;
  $[12] !== formatUnit || $[13] !== next ? (t6 = next?.size && getHumanFriendlyBytes(next.size, formatUnit), $[12] = formatUnit, $[13] = next, $[14] = t6) : t6 = $[14];
  const nextSize = t6;
  let t7;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    display: "block",
    flex: 1
  }, $[15] = t7) : t7 = $[15];
  const cardStyles2 = t7;
  let t8;
  $[16] !== diff || $[17] !== prev || $[18] !== prevSize || $[19] !== t ? (t8 = prev && /* @__PURE__ */ jsx(DiffCard, { as: "del", diff, path: "asset._ref", style: cardStyles2, children: /* @__PURE__ */ jsx(MetaInfo, { title: prev.originalFilename || t("changes.file.meta-info-fallback-title"), icon: DocumentIcon, children: /* @__PURE__ */ jsx(Text$1, { size: 0, style: {
    color: "inherit"
  }, children: prevSize }) }) }), $[16] = diff, $[17] = prev, $[18] = prevSize, $[19] = t, $[20] = t8) : t8 = $[20];
  const from2 = t8;
  let t9;
  $[21] !== diff || $[22] !== next || $[23] !== nextSize || $[24] !== pctDiff || $[25] !== t ? (t9 = next && /* @__PURE__ */ jsx(DiffCard, { as: "ins", diff, path: "asset._ref", style: cardStyles2, children: /* @__PURE__ */ jsx(MetaInfo, { title: next.originalFilename || t("changes.file.meta-info-fallback-title"), icon: DocumentIcon, children: /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    /* @__PURE__ */ jsx(Text$1, { size: 0, style: {
      color: "inherit"
    }, children: nextSize }),
    pctDiff !== 0 && /* @__PURE__ */ jsx(Card, { radius: 2, padding: 1, as: SizeDiff, marginLeft: 2, children: /* @__PURE__ */ jsxs(Text$1, { size: 0, "data-number": pctDiff > 0 ? "positive" : "negative", children: [
      pctDiff > 0 ? "+" : "-",
      pctDiff,
      "%"
    ] }) })
  ] }) }) }), $[21] = diff, $[22] = next, $[23] = nextSize, $[24] = pctDiff, $[25] = t, $[26] = t9) : t9 = $[26];
  const to = t9;
  let t10;
  $[27] !== diff || $[28] !== from2 || $[29] !== t || $[30] !== to ? (t10 = from2 && !to && /* @__PURE__ */ jsx(DiffTooltip, { diff, path: "asset._ref", description: t("changes.removed-label"), children: from2 }), $[27] = diff, $[28] = from2, $[29] = t, $[30] = to, $[31] = t10) : t10 = $[31];
  let t11;
  $[32] !== diff || $[33] !== from2 || $[34] !== to ? (t11 = from2 && to && /* @__PURE__ */ jsx(DiffTooltip, { diff, path: "asset._ref", children: /* @__PURE__ */ jsx(FromTo, { from: from2, layout: "grid", to }) }), $[32] = diff, $[33] = from2, $[34] = to, $[35] = t11) : t11 = $[35];
  let t12;
  $[36] !== diff || $[37] !== from2 || $[38] !== t || $[39] !== to ? (t12 = !from2 && to && /* @__PURE__ */ jsx(DiffTooltip, { diff, path: "asset._ref", description: t("changes.added-label"), children: to }), $[36] = diff, $[37] = from2, $[38] = t, $[39] = to, $[40] = t12) : t12 = $[40];
  let t13;
  $[41] !== t10 || $[42] !== t11 || $[43] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t10,
    t11,
    t12
  ] }), $[41] = t10, $[42] = t11, $[43] = t12, $[44] = t13) : t13 = $[44];
  const t14 = didAssetChange && t13;
  let t15;
  $[45] !== didAssetChange || $[46] !== diff || $[47] !== nestedFields || $[48] !== schemaType ? (t15 = nestedFields.length > 0 && /* @__PURE__ */ jsx(Box, { marginTop: didAssetChange ? 4 : 3, children: /* @__PURE__ */ jsx(ChangeList, { diff, schemaType, fields: nestedFields }) }), $[45] = didAssetChange, $[46] = diff, $[47] = nestedFields, $[48] = schemaType, $[49] = t15) : t15 = $[49];
  let t16;
  return $[50] !== t14 || $[51] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t14,
    t15
  ] }), $[50] = t14, $[51] = t15, $[52] = t16) : t16 = $[52], t16;
};
function _temp$3X(t0) {
  const [name_0] = t0;
  return name_0;
}
function _temp2$1H(field_1) {
  return field_1.name;
}
function hexToRgba(hex2, opacity) {
  return `rgba(${(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex2) || []).slice(1).map((num) => parseInt(num, 16)).concat(opacity).join(", ")})`;
}
function simpleHash(str) {
  let hash2 = 0;
  if (str.length == 0)
    return hash2.toString();
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash2 = (hash2 << 5) - hash2 + char, hash2 &= hash2;
  }
  return hash2.toString();
}
function getDeviceDpr() {
  const base = Math.ceil(window.devicePixelRatio || 1);
  return Math.min(3, Math.max(1, base));
}
function HotspotCropSVG(props2) {
  const $ = c(40);
  let crop, diff, hash2, hotspot, restProps, t0, t1;
  $[0] !== props2 ? ({
    crop,
    diff,
    hash: hash2,
    hotspot,
    width: t0,
    height: t1,
    ...restProps
  } = props2, $[0] = props2, $[1] = crop, $[2] = diff, $[3] = hash2, $[4] = hotspot, $[5] = restProps, $[6] = t0, $[7] = t1) : (crop = $[1], diff = $[2], hash2 = $[3], hotspot = $[4], restProps = $[5], t0 = $[6], t1 = $[7]);
  const width = t0 === void 0 ? 100 : t0, height = t1 === void 0 ? 100 : t1, {
    t
  } = useTranslation(), cropColor = useDiffAnnotationColor(diff, "crop"), hotspotColor = useDiffAnnotationColor(diff, "hotspot"), t2 = `0 0 ${width} ${height}`;
  let t3;
  $[8] !== crop || $[9] !== hash2 || $[10] !== height || $[11] !== hotspot || $[12] !== width ? (t3 = crop && hotspot && /* @__PURE__ */ jsxs("mask", { id: `mask-hotspot-${hash2}`, children: [
    /* @__PURE__ */ jsx("rect", { x: 0, y: 0, width, height, fill: "#fff" }),
    /* @__PURE__ */ jsx(HotspotSVG, { hotspot, fill: "#000", offset: 1, width, height, stroke: "#000", strokeWidth: 3 })
  ] }), $[8] = crop, $[9] = hash2, $[10] = height, $[11] = hotspot, $[12] = width, $[13] = t3) : t3 = $[13];
  let t4;
  $[14] !== t3 ? (t4 = /* @__PURE__ */ jsx("defs", { children: t3 }), $[14] = t3, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== crop || $[17] !== cropColor || $[18] !== diff || $[19] !== hash2 || $[20] !== height || $[21] !== hotspot || $[22] !== t || $[23] !== width ? (t5 = crop && /* @__PURE__ */ jsx(DiffTooltip, { diff, path: "crop", description: t("changes.image.crop-changed"), children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(CropSVG, { crop, fill: hexToRgba(cropColor.border, 0.25), mask: hotspot ? `url(#mask-hotspot-${hash2})` : void 0, stroke: cropColor.border, strokeWidth: 1, width, height }) }) }), $[16] = crop, $[17] = cropColor, $[18] = diff, $[19] = hash2, $[20] = height, $[21] = hotspot, $[22] = t, $[23] = width, $[24] = t5) : t5 = $[24];
  let t6;
  $[25] !== diff || $[26] !== height || $[27] !== hotspot || $[28] !== hotspotColor || $[29] !== t || $[30] !== width ? (t6 = hotspot && /* @__PURE__ */ jsx(DiffTooltip, { diff, path: "hotspot", description: t("changes.image.crop-changed"), children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(HotspotSVG, { hotspot, fill: hexToRgba(hotspotColor.border, 0.25), stroke: hotspotColor.border, strokeWidth: 1, width, height }) }) }), $[25] = diff, $[26] = height, $[27] = hotspot, $[28] = hotspotColor, $[29] = t, $[30] = width, $[31] = t6) : t6 = $[31];
  let t7;
  return $[32] !== height || $[33] !== restProps || $[34] !== t2 || $[35] !== t4 || $[36] !== t5 || $[37] !== t6 || $[38] !== width ? (t7 = /* @__PURE__ */ jsxs("svg", { ...restProps, fill: "none", width, height, viewBox: t2, children: [
    t4,
    t5,
    t6
  ] }), $[32] = height, $[33] = restProps, $[34] = t2, $[35] = t4, $[36] = t5, $[37] = t6, $[38] = width, $[39] = t7) : t7 = $[39], t7;
}
function CropSVG(t0) {
  const $ = c(14);
  let crop, height, restProps, width;
  $[0] !== t0 ? ({
    crop,
    width,
    height,
    ...restProps
  } = t0, $[0] = t0, $[1] = crop, $[2] = height, $[3] = restProps, $[4] = width) : (crop = $[1], height = $[2], restProps = $[3], width = $[4]);
  const t1 = crop.left * width, t2 = crop.top * height, t3 = (1 - crop.right - crop.left) * width, t4 = (1 - crop.bottom - crop.top) * height;
  let t5;
  $[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== t4 ? (t5 = {
    x: t1,
    y: t2,
    width: t3,
    height: t4
  }, $[5] = t1, $[6] = t2, $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9];
  const rectProps = t5;
  let t6;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    vectorEffect: "non-scaling-stroke"
  }, $[10] = t6) : t6 = $[10];
  let t7;
  return $[11] !== rectProps || $[12] !== restProps ? (t7 = /* @__PURE__ */ jsx("rect", { ...restProps, ...rectProps, style: t6 }), $[11] = rectProps, $[12] = restProps, $[13] = t7) : t7 = $[13], t7;
}
function HotspotSVG(t0) {
  const $ = c(15);
  let height, hotspot, restProps, t1, width;
  $[0] !== t0 ? ({
    hotspot,
    offset: t1,
    width,
    height,
    ...restProps
  } = t0, $[0] = t0, $[1] = height, $[2] = hotspot, $[3] = restProps, $[4] = t1, $[5] = width) : (height = $[1], hotspot = $[2], restProps = $[3], t1 = $[4], width = $[5]);
  const offset = t1 === void 0 ? 0 : t1, t2 = hotspot.x * width, t3 = hotspot.y * height, t4 = hotspot.width / 2 * width + offset, t5 = hotspot.height / 2 * height + offset;
  let t6;
  $[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 ? (t6 = {
    cx: t2,
    cy: t3,
    rx: t4,
    ry: t5
  }, $[6] = t2, $[7] = t3, $[8] = t4, $[9] = t5, $[10] = t6) : t6 = $[10];
  const ellipseProps = t6;
  let t7;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    vectorEffect: "non-scaling-stroke"
  }, $[11] = t7) : t7 = $[11];
  let t8;
  return $[12] !== ellipseProps || $[13] !== restProps ? (t8 = /* @__PURE__ */ jsx("ellipse", { ...restProps, ...ellipseProps, style: t7 }), $[12] = ellipseProps, $[13] = restProps, $[14] = t8) : t8 = $[14], t8;
}
const ASSET_FIELDS = ["originalFilename"], NoImagePreview = () => {
  const $ = c(4), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("changes.image.no-image-placeholder"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(Card, { flex: 1, tone: "transparent", padding: 4, radius: 2, height: "stretch", children: /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", height: "fill", children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t0 }) }) }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}, ImageWrapper = styled.div.withConfig({
  displayName: "ImageWrapper",
  componentId: "sc-ulc8od-0"
})`height:100%;max-height:190px;position:relative;background-color:${hues.gray[100].hex};background-image:linear-gradient(45deg,${hues.gray[50].hex} 25%,transparent 25%),linear-gradient(-45deg,${hues.gray[50].hex} 25%,transparent 25%),linear-gradient(45deg,transparent 75%,${hues.gray[50].hex} 75%),linear-gradient(-45deg,transparent 75%,${hues.gray[50].hex} 75%);background-size:16px 16px;background-position:0 0,0 8px,8px -8px,-8px 0;&::after{content:'';display:block;position:absolute;top:0;left:0;right:0;bottom:0;box-shadow:inset 0 0 0 1px var(--card-border-color);pointer-events:none;}&[data-changed]{opacity:0.45;}`, Image$8 = styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-ulc8od-1"
})`display:block;flex:1;min-height:0;object-fit:contain;width:100%;height:100%;&[data-action='removed']{opacity:0.45;}`, HotspotDiff = styled.div.withConfig({
  displayName: "HotspotDiff",
  componentId: "sc-ulc8od-2"
})`svg{display:block;position:absolute;top:0;left:0;width:100%;height:100%;}`;
function ImagePreview$2(props2) {
  const $ = c(95), {
    id: id2,
    action,
    diff,
    hotspot,
    crop,
    is: is2
  } = props2, {
    t
  } = useTranslation(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), [imageError, setImageError] = useState(), {
    value: asset
  } = useDocumentValues(id2, ASSET_FIELDS);
  let t0;
  $[0] !== id2 ? (t0 = getImageDimensions(id2), $[0] = id2, $[1] = t0) : t0 = $[1];
  const dimensions = t0;
  let t1;
  $[2] !== client ? (t1 = createImageUrlBuilder(client), $[2] = client, $[3] = t1) : t1 = $[3];
  const imageBuilder = t1, assetIsDeleted = asset === null, title = asset && asset.originalFilename;
  let T0, T1, T2, T3, T4, assetChanged, printAction, t10, t11, t12, t13, t14, t15, t16, t17, t2, t3, t4, t5, t6, t7, t8, t9;
  if ($[4] !== action || $[5] !== assetIsDeleted || $[6] !== crop || $[7] !== diff || $[8] !== dimensions.height || $[9] !== dimensions.width || $[10] !== id2 || $[11] !== imageBuilder || $[12] !== imageError || $[13] !== is2 || $[14] !== t || $[15] !== title) {
    const imageSource = imageBuilder.image(id2).height(190).dpr(getDeviceDpr()).fit("max");
    if (assetChanged = diff.fromValue?.asset?._ref !== diff.toValue?.asset?._ref, action && action !== "changed") {
      const t182 = action === "added" ? "changes.added-label" : "changes.removed-label";
      let t192;
      $[39] !== t || $[40] !== t182 ? (t192 = t(t182), $[39] = t, $[40] = t182, $[41] = t192) : t192 = $[41], printAction = t192;
    }
    const metaAction = action === "changed" ? void 0 : action;
    T4 = Flex, t15 = "column", t16 = "fill", t17 = 1, T3 = Box, t12 = 1, t13 = 2, t14 = 0, T2 = Flex, t6 = ImageWrapper, t7 = "column", t8 = is2 === "from" && assetChanged ? "" : void 0, t9 = imageError ? "" : void 0, t10 = !assetIsDeleted && !imageError && /* @__PURE__ */ jsx(Image$8, { src: imageSource.toString() || "", alt: title, "data-action": metaAction, onError: setImageError, width: dimensions.width, height: dimensions.height }), $[42] !== assetIsDeleted || $[43] !== imageError || $[44] !== t ? (t11 = (assetIsDeleted || imageError) && /* @__PURE__ */ jsx(Box, { paddingY: 5, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, align: "center", children: t(assetIsDeleted ? "changes.image.deleted" : "changes.image.error-loading-image") }) }), $[42] = assetIsDeleted, $[43] = imageError, $[44] = t, $[45] = t11) : t11 = $[45], T1 = HotspotDiff, T0 = HotspotCropSVG, $[46] !== crop ? (t4 = crop && !isDefaultCrop(crop) ? crop : void 0, $[46] = crop, $[47] = t4) : t4 = $[47], t5 = diff, t3 = simpleHash, t2 = imageSource.toString() || "", $[4] = action, $[5] = assetIsDeleted, $[6] = crop, $[7] = diff, $[8] = dimensions.height, $[9] = dimensions.width, $[10] = id2, $[11] = imageBuilder, $[12] = imageError, $[13] = is2, $[14] = t, $[15] = title, $[16] = T0, $[17] = T1, $[18] = T2, $[19] = T3, $[20] = T4, $[21] = assetChanged, $[22] = printAction, $[23] = t10, $[24] = t11, $[25] = t12, $[26] = t13, $[27] = t14, $[28] = t15, $[29] = t16, $[30] = t17, $[31] = t2, $[32] = t3, $[33] = t4, $[34] = t5, $[35] = t6, $[36] = t7, $[37] = t8, $[38] = t9;
  } else
    T0 = $[16], T1 = $[17], T2 = $[18], T3 = $[19], T4 = $[20], assetChanged = $[21], printAction = $[22], t10 = $[23], t11 = $[24], t12 = $[25], t13 = $[26], t14 = $[27], t15 = $[28], t16 = $[29], t17 = $[30], t2 = $[31], t3 = $[32], t4 = $[33], t5 = $[34], t6 = $[35], t7 = $[36], t8 = $[37], t9 = $[38];
  const t18 = `${t2}-${is2}`;
  let t19;
  $[48] !== t18 || $[49] !== t3 ? (t19 = t3(t18), $[48] = t18, $[49] = t3, $[50] = t19) : t19 = $[50];
  const t20 = hotspot && !isDefaultHotspot(hotspot) ? hotspot : void 0;
  let t21;
  $[51] !== T0 || $[52] !== dimensions.height || $[53] !== dimensions.width || $[54] !== t19 || $[55] !== t20 || $[56] !== t4 || $[57] !== t5 ? (t21 = /* @__PURE__ */ jsx(T0, { crop: t4, diff: t5, hash: t19, hotspot: t20, width: dimensions.width, height: dimensions.height }), $[51] = T0, $[52] = dimensions.height, $[53] = dimensions.width, $[54] = t19, $[55] = t20, $[56] = t4, $[57] = t5, $[58] = t21) : t21 = $[58];
  let t22;
  $[59] !== T1 || $[60] !== t21 ? (t22 = /* @__PURE__ */ jsx(T1, { children: t21 }), $[59] = T1, $[60] = t21, $[61] = t22) : t22 = $[61];
  let t23;
  $[62] !== T2 || $[63] !== t10 || $[64] !== t11 || $[65] !== t22 || $[66] !== t6 || $[67] !== t7 || $[68] !== t8 || $[69] !== t9 ? (t23 = /* @__PURE__ */ jsxs(T2, { as: t6, direction: t7, "data-changed": t8, "data-error": t9, children: [
    t10,
    t11,
    t22
  ] }), $[62] = T2, $[63] = t10, $[64] = t11, $[65] = t22, $[66] = t6, $[67] = t7, $[68] = t8, $[69] = t9, $[70] = t23) : t23 = $[70];
  let t24;
  $[71] !== T3 || $[72] !== t12 || $[73] !== t13 || $[74] !== t14 || $[75] !== t23 ? (t24 = /* @__PURE__ */ jsx(T3, { flex: t12, padding: t13, paddingBottom: t14, children: t23 }), $[71] = T3, $[72] = t12, $[73] = t13, $[74] = t14, $[75] = t23, $[76] = t24) : t24 = $[76];
  let t25;
  $[77] !== t || $[78] !== title ? (t25 = title || t("changes.image.meta-info-fallback-title"), $[77] = t, $[78] = title, $[79] = t25) : t25 = $[79];
  const t26 = assetChanged && is2 === "from";
  let t27;
  $[80] !== dimensions.height || $[81] !== dimensions.width || $[82] !== printAction ? (t27 = printAction ? /* @__PURE__ */ jsx("div", { children: printAction }) : /* @__PURE__ */ jsxs("div", { children: [
    dimensions.width,
    " \xD7 ",
    dimensions.height
  ] }), $[80] = dimensions.height, $[81] = dimensions.width, $[82] = printAction, $[83] = t27) : t27 = $[83];
  let t28;
  $[84] !== t25 || $[85] !== t26 || $[86] !== t27 ? (t28 = /* @__PURE__ */ jsx(MetaInfo, { title: t25, icon: ImageIcon, markRemoved: t26, children: t27 }), $[84] = t25, $[85] = t26, $[86] = t27, $[87] = t28) : t28 = $[87];
  let t29;
  return $[88] !== T4 || $[89] !== t15 || $[90] !== t16 || $[91] !== t17 || $[92] !== t24 || $[93] !== t28 ? (t29 = /* @__PURE__ */ jsxs(T4, { direction: t15, height: t16, flex: t17, children: [
    t24,
    t28
  ] }), $[88] = T4, $[89] = t15, $[90] = t16, $[91] = t17, $[92] = t24, $[93] = t28, $[94] = t29) : t29 = $[94], t29;
}
const IMAGE_META_FIELDS = ["crop", "hotspot"], BASE_IMAGE_FIELDS = ["asset", "media", ...IMAGE_META_FIELDS], CARD_STYLES = {
  flex: 1
}, ImageFieldDiff = (t0) => {
  const $ = c(55), {
    diff,
    schemaType
  } = t0, {
    t
  } = useTranslation(), {
    showFromValue
  } = useDocumentChange(), {
    fromValue,
    toValue,
    fields,
    isChanged
  } = diff, fromRef = fromValue?.asset?._ref, toRef = toValue?.asset?._ref;
  let t1;
  $[0] !== diff ? (t1 = getAnnotationAtPath(diff, ["asset", "_ref"]), $[0] = diff, $[1] = t1) : t1 = $[1];
  const assetAnnotation = t1;
  let t2;
  $[2] !== fields ? (t2 = Object.keys(fields), $[2] = fields, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== fields || $[5] !== t2 ? (t3 = t2.filter((name) => fields[name].isChanged && name !== "_type"), $[4] = fields, $[5] = t2, $[6] = t3) : t3 = $[6];
  const changedFields = t3;
  let t4;
  if ($[7] !== changedFields || $[8] !== schemaType.fields) {
    let t52;
    $[10] !== changedFields ? (t52 = (field) => !BASE_IMAGE_FIELDS.includes(field.name) && changedFields.includes(field.name), $[10] = changedFields, $[11] = t52) : t52 = $[11], t4 = schemaType.fields.filter(t52).map(_temp$3W), $[7] = changedFields, $[8] = schemaType.fields, $[9] = t4;
  } else
    t4 = $[9];
  const nestedFields = t4;
  let assetAction = "changed";
  !fromRef && toRef ? assetAction = "added" : !toRef && fromRef && (assetAction = "removed");
  const didAssetChange = changedFields.includes("asset"), didCropChange = changedFields.includes("crop"), didHotspotChange = changedFields.includes("hotspot"), didMetaChange = didCropChange || didHotspotChange, showImageDiff = didAssetChange || didMetaChange, showMetaChange = didMetaChange && !didAssetChange;
  let t5;
  $[12] !== assetAction || $[13] !== assetAnnotation || $[14] !== didCropChange || $[15] !== didHotspotChange || $[16] !== diff || $[17] !== fromRef || $[18] !== fromValue || $[19] !== showMetaChange ? (t5 = fromValue && fromRef ? /* @__PURE__ */ jsx(DiffCard, { annotation: assetAnnotation, style: CARD_STYLES, children: /* @__PURE__ */ jsx(ImagePreview$2, { is: "from", id: fromRef, diff, action: assetAction, hotspot: showMetaChange && didHotspotChange ? fromValue.hotspot : void 0, crop: showMetaChange && didCropChange ? fromValue.crop : void 0 }) }) : /* @__PURE__ */ jsx(NoImagePreview, {}), $[12] = assetAction, $[13] = assetAnnotation, $[14] = didCropChange, $[15] = didHotspotChange, $[16] = diff, $[17] = fromRef, $[18] = fromValue, $[19] = showMetaChange, $[20] = t5) : t5 = $[20];
  const from2 = t5;
  let t6;
  $[21] !== assetAnnotation || $[22] !== didCropChange || $[23] !== didHotspotChange || $[24] !== diff || $[25] !== showMetaChange || $[26] !== toRef || $[27] !== toValue ? (t6 = toValue && toRef ? /* @__PURE__ */ jsx(DiffCard, { annotation: assetAnnotation, style: CARD_STYLES, children: /* @__PURE__ */ jsx(ImagePreview$2, { is: "to", id: toRef, diff, hotspot: showMetaChange && didHotspotChange ? toValue.hotspot : void 0, crop: showMetaChange && didCropChange ? toValue.crop : void 0 }) }) : /* @__PURE__ */ jsx(NoImagePreview, {}), $[21] = assetAnnotation, $[22] = didCropChange, $[23] = didHotspotChange, $[24] = diff, $[25] = showMetaChange, $[26] = toRef, $[27] = toValue, $[28] = t6) : t6 = $[28];
  const to = t6;
  if (!from2 && !to) {
    let t72;
    $[29] !== t ? (t72 = t("changes.image.no-asset-set"), $[29] = t, $[30] = t72) : t72 = $[30];
    let t82;
    return $[31] !== t72 ? (t82 = /* @__PURE__ */ jsx(Card, { padding: 4, radius: 2, tone: "transparent", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, align: "center", children: t72 }) }), $[31] = t72, $[32] = t82) : t82 = $[32], t82;
  }
  if (!isChanged) {
    let t72;
    return $[33] !== assetAnnotation || $[34] !== diff || $[35] !== toRef ? (t72 = toRef ? /* @__PURE__ */ jsx(DiffCard, { annotation: assetAnnotation, style: CARD_STYLES, children: /* @__PURE__ */ jsx(ImagePreview$2, { id: toRef, is: "to", diff }) }) : null, $[33] = assetAnnotation, $[34] = diff, $[35] = toRef, $[36] = t72) : t72 = $[36], t72;
  }
  const t7 = showFromValue ? from2 : void 0;
  let t8;
  $[37] !== t7 || $[38] !== to ? (t8 = /* @__PURE__ */ jsx(FromTo, { align: "center", from: t7, layout: "grid", to }), $[37] = t7, $[38] = to, $[39] = t8) : t8 = $[39];
  const imageDiff = t8;
  let t9;
  $[40] !== assetAction || $[41] !== assetAnnotation || $[42] !== didAssetChange || $[43] !== imageDiff || $[44] !== showImageDiff || $[45] !== t ? (t9 = showImageDiff && (didAssetChange ? /* @__PURE__ */ jsx(DiffTooltip, { annotations: assetAnnotation ? [assetAnnotation] : [], description: getChangeDescription(assetAction, t), children: imageDiff }) : imageDiff), $[40] = assetAction, $[41] = assetAnnotation, $[42] = didAssetChange, $[43] = imageDiff, $[44] = showImageDiff, $[45] = t, $[46] = t9) : t9 = $[46];
  let t10;
  $[47] !== diff || $[48] !== nestedFields || $[49] !== schemaType || $[50] !== showImageDiff ? (t10 = nestedFields.length > 0 && /* @__PURE__ */ jsx(Box, { marginTop: showImageDiff ? 4 : 3, children: /* @__PURE__ */ jsx(ChangeList, { diff, schemaType, fields: nestedFields }) }), $[47] = diff, $[48] = nestedFields, $[49] = schemaType, $[50] = showImageDiff, $[51] = t10) : t10 = $[51];
  let t11;
  return $[52] !== t10 || $[53] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t9,
    t10
  ] }), $[52] = t10, $[53] = t9, $[54] = t11) : t11 = $[54], t11;
};
function getChangeDescription(action, t) {
  switch (action) {
    case "changed":
      return t("changes.changed-label");
    case "added":
      return t("changes.added-label");
    case "removed":
      return t("changes.removed-label");
    default:
      return "Unknown change";
  }
}
function _temp$3W(field_0) {
  return field_0.name;
}
const NumberWrapper = styled.div.withConfig({
  displayName: "NumberWrapper",
  componentId: "sc-175rija-0"
})`display:inline-block;word-break:break-all;`, NumberPreview = (props2) => {
  const $ = c(2), {
    value
  } = props2;
  let t0;
  return $[0] !== value ? (t0 = /* @__PURE__ */ jsx(Box, { as: NumberWrapper, paddingX: 2, paddingY: 1, children: value }), $[0] = value, $[1] = t0) : t0 = $[1], t0;
}, NumberFieldDiff = (t0) => {
  const $ = c(3), {
    diff,
    schemaType
  } = t0;
  let t1;
  return $[0] !== diff || $[1] !== schemaType ? (t1 = /* @__PURE__ */ jsx(DiffFromTo, { diff, schemaType, previewComponent: NumberPreview, layout: "inline" }), $[0] = diff, $[1] = schemaType, $[2] = t1) : t1 = $[2], t1;
}, InlineBox$1 = styled(Box).withConfig({
  displayName: "InlineBox",
  componentId: "sc-1cdtto6-0"
})`&:not([hidden]){display:inline;align-items:center;&[data-changed]{cursor:pointer;}}`, InlineText$1 = styled(Text$1).withConfig({
  displayName: "InlineText",
  componentId: "sc-1cdtto6-1"
})`&:not([hidden]){display:inline;color:inherit;}`, PreviewContainer$1 = styled(Box).withConfig({
  displayName: "PreviewContainer",
  componentId: "sc-1cdtto6-2"
})`&:not([hidden]){display:inline-flex;align-items:center;${InlineBox$1} [data-ui="Text"]{opacity:0.5;}}`, PopoverContainer$1 = styled(Box).withConfig({
  displayName: "PopoverContainer",
  componentId: "sc-1cdtto6-3"
})`min-width:160px;max-height:40vh;overflow-y:auto;`, AnnotationWrapper = styled.div.withConfig({
  displayName: "AnnotationWrapper",
  componentId: "sc-1vzccrq-0"
})`text-decoration:none;display:inline;position:relative;border:0;padding:0;border-bottom:2px dotted currentColor;box-shadow:inset 0 0 0 1px var(--card-border-color);white-space:nowrap;align-items:center;background-color:color(var(--card-fg-color) a(10%));&[data-changed]{cursor:pointer;}&[data-removed]{text-decoration:line-through;}&:hover ${PreviewContainer$1}{opacity:1;}`;
function Annotation$1(t0) {
  const $ = c(21);
  let children, diff, object, path, restProps, schemaType;
  $[0] !== t0 ? ({
    children,
    diff,
    object,
    schemaType,
    path,
    ...restProps
  } = t0, $[0] = t0, $[1] = children, $[2] = diff, $[3] = object, $[4] = path, $[5] = restProps, $[6] = schemaType) : (children = $[1], diff = $[2], object = $[3], path = $[4], restProps = $[5], schemaType = $[6]);
  const {
    t
  } = useTranslation();
  if (!schemaType) {
    let t12;
    $[7] !== t ? (t12 = t("changes.portable-text.unknown-annotation-schema-type"), $[7] = t, $[8] = t12) : t12 = $[8];
    let t2;
    return $[9] !== restProps || $[10] !== t12 ? (t2 = /* @__PURE__ */ jsx(AnnotationWrapper, { ...restProps, children: t12 }), $[9] = restProps, $[10] = t12, $[11] = t2) : t2 = $[11], t2;
  }
  if (diff && diff.action !== "unchanged") {
    let t12;
    return $[12] !== children || $[13] !== diff || $[14] !== object || $[15] !== path || $[16] !== restProps || $[17] !== schemaType ? (t12 = /* @__PURE__ */ jsx(AnnnotationWithDiff, { ...restProps, diff, object, schemaType, path, children }), $[12] = children, $[13] = diff, $[14] = object, $[15] = path, $[16] = restProps, $[17] = schemaType, $[18] = t12) : t12 = $[18], t12;
  }
  let t1;
  return $[19] !== children ? (t1 = /* @__PURE__ */ jsx(AnnotationWrapper, { children }), $[19] = children, $[20] = t1) : t1 = $[20], t1;
}
function AnnnotationWithDiff(t0) {
  const $ = c(92);
  let children, diff, object, path, restProps, schemaType;
  $[0] !== t0 ? ({
    diff,
    children,
    object,
    schemaType,
    path,
    ...restProps
  } = t0, $[0] = t0, $[1] = children, $[2] = diff, $[3] = object, $[4] = path, $[5] = restProps, $[6] = schemaType) : (children = $[1], diff = $[2], object = $[3], path = $[4], restProps = $[5], schemaType = $[6]);
  const {
    onSetFocus
  } = useContext(ReviewChangesContext), {
    path: fullPath
  } = useContext(DiffContext), popoverRef = useRef(null), {
    t
  } = useTranslation();
  let t1;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[7] = t1) : t1 = $[7];
  const color = useDiffAnnotationColor(diff, t1);
  let t2;
  $[8] !== color ? (t2 = color ? {
    background: color.background,
    color: color.text
  } : {}, $[8] = color, $[9] = t2) : t2 = $[9];
  const style = t2, isRemoved = diff.action === "removed", [open, setOpen] = useState(!1);
  let t3;
  $[10] !== object ? (t3 = object && isEmptyObject(object), $[10] = object, $[11] = t3) : t3 = $[11];
  const emptyObject = t3;
  let t4;
  $[12] !== path[0] ? (t4 = [path[0]], $[12] = path[0], $[13] = t4) : t4 = $[13];
  let t5;
  if ($[14] !== object._key || $[15] !== t4) {
    let t62;
    $[17] !== object._key ? (t62 = ["markDefs", {
      _key: object._key
    }], $[17] = object._key, $[18] = t62) : t62 = $[18], t5 = t4.concat(t62), $[14] = object._key, $[15] = t4, $[16] = t5;
  } else
    t5 = $[16];
  const markDefPath = t5;
  let t6;
  if ($[19] !== fullPath || $[20] !== object._key) {
    let t72;
    $[22] !== object._key ? (t72 = (seg) => isKeySegment(seg) && seg._key === object._key, $[22] = object._key, $[23] = t72) : t72 = $[23], t6 = fullPath.slice(0, fullPath.findIndex(t72)), $[19] = fullPath, $[20] = object._key, $[21] = t6;
  } else
    t6 = $[21];
  const prefix = t6;
  let t7;
  $[24] !== path || $[25] !== prefix ? (t7 = prefix.concat(path), $[24] = path, $[25] = prefix, $[26] = t7) : t7 = $[26];
  const annotationPath = t7;
  let t8;
  $[27] !== markDefPath || $[28] !== prefix ? (t8 = prefix.concat(markDefPath), $[27] = markDefPath, $[28] = prefix, $[29] = t8) : t8 = $[29];
  const myPath = t8;
  let t9;
  $[30] !== myPath ? (t9 = toString(myPath), $[30] = myPath, $[31] = t9) : t9 = $[31];
  const myValue = `field-${t9}`, values2 = useChangeIndicatorsReportedValues();
  let t10;
  if ($[32] !== myValue || $[33] !== values2) {
    let t112;
    $[35] !== myValue ? (t112 = (t122) => {
      const [p] = t122;
      return p.startsWith(myValue);
    }, $[35] = myValue, $[36] = t112) : t112 = $[36], t10 = values2.filter(t112), $[32] = myValue, $[33] = values2, $[34] = t10;
  } else
    t10 = $[34];
  const isEditing = t10.length > 0;
  let t11, t12;
  $[37] !== isEditing || $[38] !== myPath || $[39] !== onSetFocus || $[40] !== open ? (t11 = () => {
    !open && isEditing && (setOpen(!0), onSetFocus(myPath));
  }, t12 = [isEditing, myPath, onSetFocus, open], $[37] = isEditing, $[38] = myPath, $[39] = onSetFocus, $[40] = open, $[41] = t11, $[42] = t12) : (t11 = $[41], t12 = $[42]), useEffect(t11, t12);
  let t13;
  $[43] !== annotationPath || $[44] !== isRemoved || $[45] !== myPath || $[46] !== onSetFocus ? (t13 = (event) => {
    event.stopPropagation(), setOpen(!0), isRemoved || (event.preventDefault(), onSetFocus(annotationPath), setTimeout(() => onSetFocus(myPath), 10));
  }, $[43] = annotationPath, $[44] = isRemoved, $[45] = myPath, $[46] = onSetFocus, $[47] = t13) : t13 = $[47];
  const handleOpenPopup = t13;
  let t14;
  $[48] !== isEditing ? (t14 = !isEditing && (() => setOpen(!1)), $[48] = isEditing, $[49] = t14) : t14 = $[49];
  let t15;
  $[50] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = () => [popoverRef.current], $[50] = t15) : t15 = $[50], useClickOutsideEvent(t14, t15);
  const annotation = diff.action !== "unchanged" && diff.annotation || null;
  let t16;
  $[51] !== annotation ? (t16 = annotation ? [annotation] : [], $[51] = annotation, $[52] = t16) : t16 = $[52];
  const annotations = t16;
  let t17;
  $[53] !== myPath ? (t17 = {
    path: myPath
  }, $[53] = myPath, $[54] = t17) : t17 = $[54];
  const value = t17;
  let t18;
  $[55] !== emptyObject || $[56] !== schemaType || $[57] !== t ? (t18 = emptyObject && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("changes.portable-text.empty-object-annotation", {
    annotationType: schemaType.title || schemaType.name
  }) }), $[55] = emptyObject, $[56] = schemaType, $[57] = t, $[58] = t18) : t18 = $[58];
  let t19;
  $[59] !== diff || $[60] !== emptyObject || $[61] !== schemaType ? (t19 = !emptyObject && /* @__PURE__ */ jsx(ChangeList, { diff, schemaType }), $[59] = diff, $[60] = emptyObject, $[61] = schemaType, $[62] = t19) : t19 = $[62];
  let t20;
  $[63] !== t18 || $[64] !== t19 ? (t20 = /* @__PURE__ */ jsx(PopoverContainer$1, { padding: 3, children: /* @__PURE__ */ jsxs("div", { children: [
    t18,
    t19
  ] }) }), $[63] = t18, $[64] = t19, $[65] = t20) : t20 = $[65];
  let t21;
  $[66] !== t20 || $[67] !== value ? (t21 = /* @__PURE__ */ jsx(DiffContext.Provider, { value, children: t20 }), $[66] = t20, $[67] = value, $[68] = t21) : t21 = $[68];
  const popoverContent = t21, t22 = diff.action === "removed" ? "" : void 0;
  let t23;
  $[69] !== diff.action || $[70] !== t ? (t23 = t("changes.portable-text.annotation", {
    context: diff.action
  }), $[69] = diff.action, $[70] = t, $[71] = t23) : t23 = $[71];
  let t24;
  $[72] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t24 = {
    display: "inline-flex"
  }, $[72] = t24) : t24 = $[72];
  let t25;
  $[73] !== children ? (t25 = /* @__PURE__ */ jsx("span", { children }), $[73] = children, $[74] = t25) : t25 = $[74];
  let t26;
  $[75] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t26 = /* @__PURE__ */ jsx(Flex, { align: "center", paddingX: 1, children: /* @__PURE__ */ jsx(InlineText$1, { size: 0, children: /* @__PURE__ */ jsx(ChevronDownIcon, {}) }) }), $[75] = t26) : t26 = $[75];
  let t27;
  $[76] !== t25 ? (t27 = /* @__PURE__ */ jsxs(InlineBox$1, { style: t24, children: [
    t25,
    t26
  ] }), $[76] = t25, $[77] = t27) : t27 = $[77];
  let t28;
  $[78] !== annotations || $[79] !== t23 || $[80] !== t27 ? (t28 = /* @__PURE__ */ jsx(PreviewContainer$1, { paddingLeft: 1, children: /* @__PURE__ */ jsx(DiffTooltip, { annotations, description: t23, children: t27 }) }), $[78] = annotations, $[79] = t23, $[80] = t27, $[81] = t28) : t28 = $[81];
  let t29;
  $[82] !== open || $[83] !== popoverContent || $[84] !== t28 ? (t29 = /* @__PURE__ */ jsx(Popover, { content: popoverContent, open, ref: popoverRef, portal: !0, children: t28 }), $[82] = open, $[83] = popoverContent, $[84] = t28, $[85] = t29) : t29 = $[85];
  let t30;
  return $[86] !== handleOpenPopup || $[87] !== restProps || $[88] !== style || $[89] !== t22 || $[90] !== t29 ? (t30 = /* @__PURE__ */ jsx(AnnotationWrapper, { ...restProps, onClick: handleOpenPopup, style, "data-changed": "", "data-removed": t22, children: t29 }), $[86] = handleOpenPopup, $[87] = restProps, $[88] = style, $[89] = t22, $[90] = t29, $[91] = t30) : t30 = $[91], t30;
}
const Quote = styled.blockquote.withConfig({
  displayName: "Quote",
  componentId: "sc-1qg8mpb-0"
})`margin:0;`;
function Blockquote(t0) {
  const $ = c(2), {
    children
  } = t0;
  let t1;
  return $[0] !== children ? (t1 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Quote, { children }) }), $[0] = children, $[1] = t1) : t1 = $[1], t1;
}
const headingSizes = {
  h1: 2,
  h2: 1,
  h3: 0,
  h4: 0,
  h5: 0,
  h6: 0
}, StyledHeading = styled(Heading).withConfig({
  displayName: "StyledHeading",
  componentId: "sc-wjg6k2-0"
})`&:not([hidden]){display:inline;text-transform:none;margin:0;&::before,&::after{content:unset;}}`;
function Header$1(t0) {
  const $ = c(3), {
    style,
    children
  } = t0, t1 = headingSizes[style];
  let t2;
  return $[0] !== children || $[1] !== t1 ? (t2 = /* @__PURE__ */ jsx(StyledHeading, { size: t1, children }), $[0] = children, $[1] = t1, $[2] = t2) : t2 = $[2], t2;
}
const StyledParagraph = styled.div.withConfig({
  displayName: "StyledParagraph",
  componentId: "sc-le102a-0"
})`text-transform:none;white-space:wrap;overflow-wrap:break-word;margin:0;`;
function Paragraph(t0) {
  const $ = c(2), {
    children
  } = t0;
  let t1;
  return $[0] !== children ? (t1 = /* @__PURE__ */ jsx(StyledParagraph, { children }), $[0] = children, $[1] = t1) : t1 = $[1], t1;
}
const EMPTY_PATH = [];
function Block(props2) {
  const $ = c(41), {
    diff,
    block,
    children
  } = props2, color = useDiffAnnotationColor(diff, EMPTY_PATH), {
    path: fullPath
  } = useContext(DiffContext), {
    onSetFocus
  } = useContext(ReviewChangesContext), {
    t
  } = useTranslation(), isRemoved = diff.action === "removed";
  let returned = children, t0;
  $[0] !== fullPath || $[1] !== isRemoved || $[2] !== onSetFocus ? (t0 = (event) => {
    event.stopPropagation(), isRemoved || onSetFocus(fullPath);
  }, $[0] = fullPath, $[1] = isRemoved, $[2] = onSetFocus, $[3] = t0) : t0 = $[3];
  const handleClick = t0;
  if (block.style === "blockquote") {
    let t12;
    $[4] !== returned ? (t12 = /* @__PURE__ */ jsx(Blockquote, { children: returned }), $[4] = returned, $[5] = t12) : t12 = $[5], returned = t12;
  } else if (block.style && isHeader(block)) {
    let t12;
    $[6] !== block.style || $[7] !== returned ? (t12 = /* @__PURE__ */ jsx(Header$1, { style: block.style, children: returned }), $[6] = block.style, $[7] = returned, $[8] = t12) : t12 = $[8], returned = t12;
  } else {
    let t12;
    $[9] !== returned ? (t12 = /* @__PURE__ */ jsx(Paragraph, { children: returned }), $[9] = returned, $[10] = t12) : t12 = $[10], returned = t12;
  }
  let fromStyle;
  if (diff.origin.action === "changed" && diff.origin.fields.style && diff.origin.fields.style.action === "changed" && diff.origin.fields.style.annotation) {
    fromStyle = diff?.origin?.fromValue?.style;
    let t12;
    $[11] !== color ? (t12 = color ? {
      background: color.background,
      color: color.text
    } : {}, $[11] = color, $[12] = t12) : t12 = $[12];
    const style = t12;
    let t22;
    $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = {
      borderStyle: "dotted"
    }, $[13] = t22) : t22 = $[13];
    const t3 = diff.action, t4 = `changed_from_style_${fromStyle || "undefined"}`, t5 = diff.origin.fields.style?.annotation;
    let t6;
    $[14] !== t5 ? (t6 = [t5], $[14] = t5, $[15] = t6) : t6 = $[15];
    const t7 = diff.origin.fields.style;
    let t8;
    $[16] !== block.style || $[17] !== fromStyle || $[18] !== t ? (t8 = t("changes.portable-text.block-style-changed", {
      fromStyle,
      toStyle: block.style
    }), $[16] = block.style, $[17] = fromStyle, $[18] = t, $[19] = t8) : t8 = $[19];
    let t9;
    $[20] !== t8 ? (t9 = /* @__PURE__ */ jsx(Text$1, { size: 0, children: t8 }), $[20] = t8, $[21] = t9) : t9 = $[21];
    let t10;
    $[22] !== diff.origin.fields.style || $[23] !== t6 || $[24] !== t9 ? (t10 = /* @__PURE__ */ jsx(DiffTooltip, { annotations: t6, diff: t7, children: t9 }), $[22] = diff.origin.fields.style, $[23] = t6, $[24] = t9, $[25] = t10) : t10 = $[25];
    let t11;
    $[26] !== returned || $[27] !== style ? (t11 = /* @__PURE__ */ jsx(Box, { style, children: returned }), $[26] = returned, $[27] = style, $[28] = t11) : t11 = $[28];
    let t122;
    $[29] !== t10 || $[30] !== t11 ? (t122 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
      t10,
      t11
    ] }), $[29] = t10, $[30] = t11, $[31] = t122) : t122 = $[31];
    let t13;
    $[32] !== diff.action || $[33] !== t122 || $[34] !== t4 ? (t13 = /* @__PURE__ */ jsx(Card, { padding: 3, border: !0, radius: 2, style: t22, "diff-block-action": t3, "data-block-note": t4, children: t122 }), $[32] = diff.action, $[33] = t122, $[34] = t4, $[35] = t13) : t13 = $[35], returned = t13;
  }
  const t1 = `changed_from_style_${fromStyle || "undefined"}`;
  let t2;
  return $[36] !== diff.action || $[37] !== handleClick || $[38] !== returned || $[39] !== t1 ? (t2 = /* @__PURE__ */ jsx("div", { onClick: handleClick, "data-diff-block-action": diff.action, "data-block-note": t1, children: returned }), $[36] = diff.action, $[37] = handleClick, $[38] = returned, $[39] = t1, $[40] = t2) : t2 = $[40], t2;
}
const DecoratorWrapper = styled.span.withConfig({
  displayName: "DecoratorWrapper",
  componentId: "sc-1h3s5tg-0"
})`display:inline;${({
  theme,
  decoration
}) => {
  switch (decoration) {
    case "strong":
      return "font-weight: bold;";
    case "em":
      return "font-style: italic;";
    case "underline":
      return "text-decoration: underline;";
    case "overline":
      return "text-decoration: overline;";
    case "strike-through":
      return "text-decoration: line-through;";
    case "code":
      return `
          font-family: ${theme.sanity.fonts.code.family};
          background: ${theme.sanity.color.muted.default.enabled.bg};
        `;
    default:
      return "";
  }
}}`;
function Decorator$1(t0) {
  const $ = c(3), {
    mark,
    children
  } = t0;
  let t1;
  return $[0] !== children || $[1] !== mark ? (t1 = /* @__PURE__ */ jsx(DecoratorWrapper, { decoration: mark, children }), $[0] = children, $[1] = mark, $[2] = t1) : t1 = $[2], t1;
}
const InlineObjectWrapper = styled(Card).withConfig({
  displayName: "InlineObjectWrapper",
  componentId: "sc-kt0ngk-0"
})`&:not([hidden]){display:inline;cursor:pointer;white-space:nowrap;align-items:center;&[data-removed]{text-decoration:line-through;}${InlineBox$1}{display:inline-flex;}}`;
function InlineObject$1(t0) {
  const $ = c(19);
  let diff, object, restProps, schemaType;
  $[0] !== t0 ? ({
    diff,
    object,
    schemaType,
    ...restProps
  } = t0, $[0] = t0, $[1] = diff, $[2] = object, $[3] = restProps, $[4] = schemaType) : (diff = $[1], object = $[2], restProps = $[3], schemaType = $[4]);
  const {
    t
  } = useTranslation();
  if (!schemaType) {
    let t12;
    $[5] !== object._type || $[6] !== t ? (t12 = t("changes.portable-text.unknown-inline-object-schema-type", {
      schemaType: object._type
    }), $[5] = object._type, $[6] = t, $[7] = t12) : t12 = $[7];
    let t2;
    return $[8] !== restProps || $[9] !== t12 ? (t2 = /* @__PURE__ */ jsx(InlineObjectWrapper, { ...restProps, border: !0, radius: 1, children: t12 }), $[8] = restProps, $[9] = t12, $[10] = t2) : t2 = $[10], t2;
  }
  if (diff) {
    let t12;
    return $[11] !== diff || $[12] !== object || $[13] !== restProps || $[14] !== schemaType ? (t12 = /* @__PURE__ */ jsx(InlineObjectWithDiff, { ...restProps, diff, object, schemaType }), $[11] = diff, $[12] = object, $[13] = restProps, $[14] = schemaType, $[15] = t12) : t12 = $[15], t12;
  }
  let t1;
  return $[16] !== object || $[17] !== schemaType ? (t1 = /* @__PURE__ */ jsx(InlineObjectWrapper, { children: /* @__PURE__ */ jsx(Preview$1, { schemaType, value: object, layout: "inline" }) }), $[16] = object, $[17] = schemaType, $[18] = t1) : t1 = $[18], t1;
}
function InlineObjectWithDiff(t0) {
  const $ = c(70);
  let diff, object, path, restProps, schemaType;
  $[0] !== t0 ? ({
    diff,
    object,
    path,
    schemaType,
    ...restProps
  } = t0, $[0] = t0, $[1] = diff, $[2] = object, $[3] = path, $[4] = restProps, $[5] = schemaType) : (diff = $[1], object = $[2], path = $[3], restProps = $[4], schemaType = $[5]);
  const {
    path: fullPath
  } = useContext(DiffContext), {
    onSetFocus
  } = useContext(ReviewChangesContext), {
    t
  } = useTranslation();
  let t1;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[6] = t1) : t1 = $[6];
  const color = useDiffAnnotationColor(diff, t1);
  let t2;
  $[7] !== color ? (t2 = color ? {
    background: color.background,
    color: color.text
  } : {}, $[7] = color, $[8] = t2) : t2 = $[8];
  const style = t2, [open, setOpen] = useState(!1);
  let t3;
  $[9] !== object ? (t3 = object && isEmptyObject(object), $[9] = object, $[10] = t3) : t3 = $[10];
  const emptyObject = t3, isRemoved = diff.action === "removed";
  let myPath, t4;
  if ($[11] !== fullPath || $[12] !== object || $[13] !== path) {
    let t52;
    $[16] !== object ? (t52 = (seg) => isKeySegment(seg) && seg._key === object._key, $[16] = object, $[17] = t52) : t52 = $[17], myPath = fullPath.slice(0, fullPath.findIndex(t52)).concat(path), t4 = toString(myPath), $[11] = fullPath, $[12] = object, $[13] = path, $[14] = myPath, $[15] = t4;
  } else
    myPath = $[14], t4 = $[15];
  const myValue = `field-${t4}`, values2 = useChangeIndicatorsReportedValues();
  let t5;
  if ($[18] !== myValue || $[19] !== values2) {
    let t62;
    $[21] !== myValue ? (t62 = (t72) => {
      const [p] = t72;
      return p.startsWith(myValue);
    }, $[21] = myValue, $[22] = t62) : t62 = $[22], t5 = values2.filter(t62), $[18] = myValue, $[19] = values2, $[20] = t5;
  } else
    t5 = $[20];
  const isEditing = t5.length > 0;
  let t6;
  $[23] !== fullPath || $[24] !== path ? (t6 = fullPath.slice(0, -1).concat(path).concat([FOCUS_TERMINATOR]), $[23] = fullPath, $[24] = path, $[25] = t6) : t6 = $[25];
  const focusPath = t6;
  let t7, t8;
  $[26] !== focusPath || $[27] !== isEditing || $[28] !== onSetFocus ? (t7 = () => {
    isEditing && (setOpen(!0), onSetFocus(focusPath));
  }, t8 = [focusPath, isEditing, onSetFocus], $[26] = focusPath, $[27] = isEditing, $[28] = onSetFocus, $[29] = t7, $[30] = t8) : (t7 = $[29], t8 = $[30]), useEffect(t7, t8);
  let t9;
  $[31] !== focusPath || $[32] !== isRemoved || $[33] !== onSetFocus ? (t9 = (event) => {
    if (event.stopPropagation(), setOpen(!0), !isRemoved) {
      onSetFocus(focusPath);
      return;
    }
    event.preventDefault();
  }, $[31] = focusPath, $[32] = isRemoved, $[33] = onSetFocus, $[34] = t9) : t9 = $[34];
  const handleOpenPopup = t9;
  let t10;
  $[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    setOpen(!1);
  }, $[35] = t10) : t10 = $[35];
  const handleClose = t10;
  let t11;
  $[36] !== myPath ? (t11 = {
    path: myPath
  }, $[36] = myPath, $[37] = t11) : t11 = $[37];
  const value = t11;
  let t12;
  $[38] !== diff || $[39] !== emptyObject || $[40] !== schemaType ? (t12 = /* @__PURE__ */ jsx(PopoverContent$1, { diff, emptyObject, onClose: handleClose, schemaType }), $[38] = diff, $[39] = emptyObject, $[40] = schemaType, $[41] = t12) : t12 = $[41];
  let t13;
  $[42] !== t12 || $[43] !== value ? (t13 = /* @__PURE__ */ jsx(DiffContext.Provider, { value, children: t12 }), $[42] = t12, $[43] = value, $[44] = t13) : t13 = $[44];
  const popoverContent = t13, annotation = diff.action !== "unchanged" && diff.annotation || null;
  let t14;
  $[45] !== annotation ? (t14 = annotation ? [annotation] : [], $[45] = annotation, $[46] = t14) : t14 = $[46];
  const annotations = t14, t15 = diff.action === "removed" ? "" : void 0;
  let t16;
  $[47] !== diff.action || $[48] !== t ? (t16 = t("changes.portable-text.inline-object", {
    context: diff.action
  }), $[47] = diff.action, $[48] = t, $[49] = t16) : t16 = $[49];
  let t17;
  $[50] !== object || $[51] !== schemaType ? (t17 = /* @__PURE__ */ jsx(Preview$1, { schemaType, value: object, layout: "inline" }), $[50] = object, $[51] = schemaType, $[52] = t17) : t17 = $[52];
  let t18;
  $[53] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t18 = /* @__PURE__ */ jsx(Flex, { align: "center", paddingX: 1, children: /* @__PURE__ */ jsx(InlineText$1, { size: 0, children: /* @__PURE__ */ jsx(ChevronDownIcon, {}) }) }), $[53] = t18) : t18 = $[53];
  let t19;
  $[54] !== t17 ? (t19 = /* @__PURE__ */ jsxs(InlineBox$1, { children: [
    t17,
    t18
  ] }), $[54] = t17, $[55] = t19) : t19 = $[55];
  let t20;
  $[56] !== annotations || $[57] !== t16 || $[58] !== t19 ? (t20 = /* @__PURE__ */ jsx(PreviewContainer$1, { children: /* @__PURE__ */ jsx(DiffTooltip, { annotations, description: t16, children: t19 }) }), $[56] = annotations, $[57] = t16, $[58] = t19, $[59] = t20) : t20 = $[59];
  let t21;
  $[60] !== open || $[61] !== popoverContent || $[62] !== t20 ? (t21 = /* @__PURE__ */ jsx(Popover, { content: popoverContent, open, portal: !0, children: t20 }), $[60] = open, $[61] = popoverContent, $[62] = t20, $[63] = t21) : t21 = $[63];
  let t22;
  return $[64] !== handleOpenPopup || $[65] !== restProps || $[66] !== style || $[67] !== t15 || $[68] !== t21 ? (t22 = /* @__PURE__ */ jsx(InlineObjectWrapper, { ...restProps, onClick: handleOpenPopup, style, "data-removed": t15, border: !0, radius: 2, children: t21 }), $[64] = handleOpenPopup, $[65] = restProps, $[66] = style, $[67] = t15, $[68] = t21, $[69] = t22) : t22 = $[69], t22;
}
function PopoverContent$1(t0) {
  const $ = c(12), {
    diff,
    emptyObject,
    onClose,
    schemaType
  } = t0, {
    t
  } = useTranslation(), popoverRef = useRef(null);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => [popoverRef.current], $[0] = t1) : t1 = $[0], useClickOutsideEvent(onClose, t1);
  let t2;
  $[1] !== emptyObject || $[2] !== schemaType || $[3] !== t ? (t2 = emptyObject && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("changes.portable-text.empty-inline-object", {
    inlineObjectType: schemaType.title || schemaType.name
  }) }), $[1] = emptyObject, $[2] = schemaType, $[3] = t, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== diff || $[6] !== emptyObject || $[7] !== schemaType ? (t3 = !emptyObject && /* @__PURE__ */ jsx(ChangeList, { diff, schemaType }), $[5] = diff, $[6] = emptyObject, $[7] = schemaType, $[8] = t3) : t3 = $[8];
  let t4;
  return $[9] !== t2 || $[10] !== t3 ? (t4 = /* @__PURE__ */ jsxs(PopoverContainer$1, { ref: popoverRef, padding: 3, children: [
    t2,
    t3
  ] }), $[9] = t2, $[10] = t3, $[11] = t4) : t4 = $[11], t4;
}
function Text(t0) {
  const $ = c(16);
  let childDiff, children, diff, path, restProps, segment;
  $[0] !== t0 ? ({
    diff,
    childDiff,
    children,
    path,
    segment,
    ...restProps
  } = t0, $[0] = t0, $[1] = childDiff, $[2] = children, $[3] = diff, $[4] = path, $[5] = restProps, $[6] = segment) : (childDiff = $[1], children = $[2], diff = $[3], path = $[4], restProps = $[5], segment = $[6]);
  const diffWithFallback = diff || childDiff;
  if (diffWithFallback && diffWithFallback.action !== "unchanged" && segment.action !== "unchanged") {
    let t12;
    return $[7] !== childDiff || $[8] !== children || $[9] !== diff || $[10] !== path || $[11] !== restProps || $[12] !== segment ? (t12 = /* @__PURE__ */ jsx(TextWithDiff, { ...restProps, childDiff, diff, segment, path, children }), $[7] = childDiff, $[8] = children, $[9] = diff, $[10] = path, $[11] = restProps, $[12] = segment, $[13] = t12) : t12 = $[13], t12;
  }
  let t1;
  return $[14] !== children ? (t1 = /* @__PURE__ */ jsx(InlineBox$1, { children }), $[14] = children, $[15] = t1) : t1 = $[15], t1;
}
function TextWithDiff(t0) {
  const $ = c(33);
  let childDiff, children, diff, path, restProps, segment;
  $[0] !== t0 ? ({
    diff,
    childDiff,
    children,
    path,
    segment,
    ...restProps
  } = t0, $[0] = t0, $[1] = childDiff, $[2] = children, $[3] = diff, $[4] = path, $[5] = restProps, $[6] = segment) : (childDiff = $[1], children = $[2], diff = $[3], path = $[4], restProps = $[5], segment = $[6]);
  const {
    onSetFocus
  } = useContext(ReviewChangesContext), {
    path: fullPath
  } = useContext(DiffContext);
  let t1;
  $[7] !== path ? (t1 = path.slice(-2, 1), $[7] = path, $[8] = t1) : t1 = $[8];
  const spanSegment = t1[0], {
    t
  } = useTranslation(), isRemoved = diff && diff.action === "removed";
  let t2;
  if ($[9] !== fullPath || $[10] !== path || $[11] !== spanSegment) {
    let t32;
    $[13] !== spanSegment ? (t32 = (seg) => isKeySegment(seg) && isKeySegment(spanSegment) && seg._key === spanSegment._key, $[13] = spanSegment, $[14] = t32) : t32 = $[14], t2 = fullPath.slice(0, fullPath.findIndex(t32)).concat(path), $[9] = fullPath, $[10] = path, $[11] = spanSegment, $[12] = t2;
  } else
    t2 = $[12];
  const focusPath = t2;
  let t3;
  $[15] !== focusPath || $[16] !== isRemoved || $[17] !== onSetFocus ? (t3 = (event) => {
    event.stopPropagation(), isRemoved || (event.preventDefault(), onSetFocus(focusPath));
  }, $[15] = focusPath, $[16] = isRemoved, $[17] = onSetFocus, $[18] = t3) : t3 = $[18];
  const handleClick = t3;
  let t4;
  $[19] !== diff || $[20] !== segment ? (t4 = diff && diff.segments.find((rSeg) => rSeg.text === segment.text), $[19] = diff, $[20] = segment, $[21] = t4) : t4 = $[21];
  const realSeg = t4, diffWithFallback = realSeg || diff || childDiff, annotation = diffWithFallback && diffWithFallback.action !== "unchanged" && diffWithFallback.annotation || realSeg && diff && diff.action !== "unchanged" && realSeg.action === "removed" && diff.annotation || null;
  let t5;
  $[22] !== annotation || $[23] !== children || $[24] !== segment || $[25] !== t ? (t5 = annotation && segment.action !== "unchanged" ? /* @__PURE__ */ jsx(DiffCard, { annotation, as: segment.action === "removed" ? "del" : "ins", tooltip: {
    description: t("changes.portable-text.text", {
      context: segment.action
    })
  }, children }) : null, $[22] = annotation, $[23] = children, $[24] = segment, $[25] = t, $[26] = t5) : t5 = $[26];
  const t6 = t5 || children;
  let t7;
  $[27] !== t6 ? (t7 = /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(Fragment$1, { children: t6 }) }), $[27] = t6, $[28] = t7) : t7 = $[28];
  let t8;
  return $[29] !== handleClick || $[30] !== restProps || $[31] !== t7 ? (t8 = /* @__PURE__ */ jsx(InlineBox$1, { ...restProps, onClick: handleClick, "data-changed": "", children: t7 }), $[29] = handleClick, $[30] = restProps, $[31] = t7, $[32] = t8) : t8 = $[32], t8;
}
const decoratorSymbolsStart = DECORATOR_SYMBOLS.map((set2) => set2[0]), decoratorSymbolsEnd = DECORATOR_SYMBOLS.map((set2) => set2[1]), annotationSymbolsStart = ANNOTATION_SYMBOLS.map((set2) => set2[0]), annotationSymbolsEnd = ANNOTATION_SYMBOLS.map((set2) => set2[1]), allSymbolsStart = decoratorSymbolsStart.concat(annotationSymbolsStart), allSymbolsEnd = decoratorSymbolsEnd.concat(annotationSymbolsEnd), allDecoratorSymbols = decoratorSymbolsStart.concat(decoratorSymbolsEnd), markRegex = new RegExp(`${allDecoratorSymbols.concat(allSymbolsEnd).join("|")}`, "g");
function PortableText(props2) {
  const $ = c(20), {
    diff,
    schemaType
  } = props2, block = diff.origin.toValue || diff.origin.fromValue, {
    t
  } = useTranslation();
  let t0;
  $[0] !== diff.origin ? (t0 = diff.origin.toValue ? getInlineObjects(diff.origin) : [], $[0] = diff.origin, $[1] = t0) : t0 = $[1];
  const inlineObjects = t0;
  let t1;
  $[2] !== block || $[3] !== diff || $[4] !== inlineObjects || $[5] !== schemaType || $[6] !== t ? (t1 = defineRenderChild({
    block,
    diff,
    inlineObjects,
    schemaType,
    t
  }), $[2] = block, $[3] = diff, $[4] = inlineObjects, $[5] = schemaType, $[6] = t, $[7] = t1) : t1 = $[7];
  const renderChild2 = t1, t2 = diff.displayValue;
  let t3;
  $[8] !== diff.displayValue.children ? (t3 = diff.displayValue.children || [], $[8] = diff.displayValue.children, $[9] = t3) : t3 = $[9];
  let t4;
  if ($[10] !== renderChild2 || $[11] !== t3) {
    let t52;
    $[13] !== renderChild2 ? (t52 = (child) => renderChild2(child), $[13] = renderChild2, $[14] = t52) : t52 = $[14], t4 = t3.map(t52), $[10] = renderChild2, $[11] = t3, $[12] = t4;
  } else
    t4 = $[12];
  let t5;
  $[15] !== t4 ? (t5 = /* @__PURE__ */ jsx(Fragment$1, { children: t4 }), $[15] = t4, $[16] = t5) : t5 = $[16];
  let t6;
  return $[17] !== diff || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsx(Block, { block: t2, diff, children: t5 }), $[17] = diff, $[18] = t5, $[19] = t6) : t6 = $[19], t6;
}
function renderTextSegment({
  diff,
  child,
  decoratorTypes,
  seg,
  segIndex,
  spanSchemaType,
  t
}) {
  if (seg.text === `
`)
    return /* @__PURE__ */ jsx("br", {});
  let children = /* @__PURE__ */ jsx("span", { children: seg.text.replace(/ /g, TRAILING_SPACE_SYMBOL) }, `text-${segIndex}`);
  const spanDiff = child && findSpanDiffFromChild(diff.origin, child), activeMarks = isPortableTextSpan(child) ? child.marks || [] : [];
  return spanDiff && (children = renderDecorators({
    activeMarks,
    decoratorTypes,
    diff,
    children,
    seg,
    segIndex,
    spanDiff,
    spanSchemaType,
    t
  })), activeMarks && activeMarks.length > 0 && activeMarks.forEach((mark) => {
    isDecorator(mark, spanSchemaType) && (children = /* @__PURE__ */ jsx(Decorator$1, { mark, children }, `decorator-${mark}-${child._key}-${segIndex}`));
  }), children;
}
function renderDecorators({
  activeMarks,
  decoratorTypes,
  diff,
  children,
  seg,
  segIndex,
  spanDiff,
  spanSchemaType,
  t
}) {
  let returned = /* @__PURE__ */ jsx("span", { children }, `text-segment-${segIndex}`);
  const fromPtDiffText = diff.origin.fromValue && diff.fromValue && diff.fromValue.children[0].text || "", indirectMarksAnnotation = spanDiff && spanDiff.action !== "unchanged" && spanDiff.annotation || void 0, marksDiff = spanDiff?.fields?.marks, marksAnnotation = marksDiff && marksDiff.action !== "unchanged" && marksDiff.annotation || indirectMarksAnnotation;
  let marksChanged = [];
  const ptDiffMatchString = fromPtDiffText.split(CHILD_SYMBOL$1).filter((text) => !!text).join(""), controlString = ptDiffMatchString.slice(0, Math.max(0, ptDiffMatchString.indexOf(seg.text) + seg.text.length)), toTest = controlString.slice(0, Math.max(0, controlString.indexOf(seg.text))), marks = [];
  return [...toTest.matchAll(markRegex)].forEach((match) => {
    const sym = match[0], set2 = DECORATOR_SYMBOLS.concat(ANNOTATION_SYMBOLS).find((aSet) => aSet.indexOf(sym) > -1);
    if (set2) {
      const isMarkStart = sym === set2[0], mark = decoratorTypes[isMarkStart ? decoratorSymbolsStart.indexOf(sym) : decoratorSymbolsEnd.indexOf(sym)]?.value || sym;
      toTest.lastIndexOf(sym) > toTest.lastIndexOf(set2[1]) && marks.push(mark);
    }
  }), marksChanged = xor(activeMarks, uniq(marks)), marksAnnotation && marksChanged.length > 0 && marksChanged.some((m) => isDecorator(m, spanSchemaType)) && (returned = /* @__PURE__ */ jsx(DiffCard, { annotation: marksAnnotation, as: "ins", tooltip: {
    description: t("changes.portable-text.changed-formatting")
  }, children: returned }, `diffcard-annotation-${segIndex}-${marksChanged.join("-")}`)), returned;
}
function isEmptyTextChange(block, diff) {
  return block.children.length === 1 && block.children[0]._type === "span" && typeof block.children[0].text == "string" && block.children[0].text === "" && diff.origin.action !== "unchanged";
}
function defineRenderChild({
  block,
  diff,
  inlineObjects,
  schemaType,
  t
}) {
  return (ptDiffChild) => {
    const spanSchemaType = getChildSchemaType(schemaType.fields, ptDiffChild);
    let decoratorTypes = [];
    if (spanSchemaType) {
      decoratorTypes = getDecorators(spanSchemaType);
      const childrenDiff = diff.fields.children, segments = childrenDiff.items[0].diff && childrenDiff.items[0].diff.type === "object" && childrenDiff.items[0].diff.fields.text.type === "string" && childrenDiff.items[0].diff.fields.text.segments || [], returnedChildren = [], annotationSegments = {};
      if (isEmptyTextChange(block, diff) && (diff.origin.action === "added" || diff.origin.action === "removed")) {
        const textDiff = findChildDiff(diff.origin, block.children[0]) || diff.origin;
        if (textDiff && textDiff.action !== "unchanged")
          return /* @__PURE__ */ jsx(DiffCard, { annotation: textDiff.annotation, as: textDiff.action === "removed" ? "del" : "ins", tooltip: {
            description: t("changes.portable-text.empty-text", {
              context: textDiff.action
            })
          }, children: /* @__PURE__ */ jsx("span", { children: EMPTY_BLOCK_SYMBOL }) }, `empty-block-${block._key}`);
      }
      let childToIndex = -1, segIndex = -1;
      const activeAnnotations = [];
      let endedAnnotation;
      const allMarkDefs = getAllMarkDefs(diff.origin);
      return segments.forEach((seg) => {
        segIndex++;
        const isInline = INLINE_SYMBOLS.includes(seg.text), isMarkStart = allSymbolsStart.includes(seg.text), isMarkEnd = allSymbolsEnd.includes(seg.text), isChildStart = seg.text === CHILD_SYMBOL$1, isRemoved = seg.action === "removed";
        if (isChildStart)
          isRemoved || childToIndex++;
        else if (isMarkStart || isMarkEnd) {
          if (isMarkStart && annotationSymbolsStart.includes(seg.text)) {
            const object = allMarkDefs[annotationSymbolsStart.indexOf(seg.text)];
            object && activeAnnotations.push({
              mark: object._key,
              symbols: [seg.text, annotationSymbolsEnd[annotationSymbolsStart.indexOf(seg.text)]],
              object
            });
          }
          isMarkEnd && annotationSymbolsEnd.includes(seg.text) && (endedAnnotation = activeAnnotations.pop());
        } else if (isInline) {
          const indexOfSymbol = INLINE_SYMBOLS.findIndex((sym) => sym === seg.text), key = inlineObjects[indexOfSymbol]?._key, originChild = inlineObjects[indexOfSymbol];
          if (key) {
            const objectSchemaType = getChildSchemaType(schemaType.fields, originChild), objectDiff = findChildDiff(diff.origin, originChild);
            returnedChildren.push(/* @__PURE__ */ jsx(InlineObject$1, { object: originChild, path: [{
              _key: block._key
            }, "children", {
              _key: originChild._key
            }], diff: objectDiff, schemaType: objectSchemaType }, `inline-object-${originChild._key}`));
          }
        } else if (seg.text) {
          const getChildFromFromValue = () => diff.origin.fromValue?.children.find((cld) => cld.text && cld.text.match(escapeRegExp(seg.text))), child = block.children[childToIndex] || getChildFromFromValue(), childDiff = child && findSpanDiffFromChild(diff.origin, child);
          if (!child)
            throw new Error("Could not find child");
          const textDiff = childDiff?.fields?.text ? childDiff?.fields?.text : void 0, text = /* @__PURE__ */ jsx(Text, { diff: textDiff, path: [{
            _key: block._key
          }, "children", {
            _key: child._key
          }], childDiff, segment: seg, children: renderTextSegment({
            diff,
            child,
            decoratorTypes,
            seg,
            segIndex,
            spanSchemaType,
            t
          }) }, `text-${child._key}-${segIndex}`);
          if (activeAnnotations.length > 0 && activeAnnotations.forEach((active) => {
            annotationSegments[active.mark] = annotationSegments[active.mark] || [], annotationSegments[active.mark].push(text);
          }), endedAnnotation) {
            const key = `annotation-${endedAnnotation.object._key}`, lastChild = returnedChildren[returnedChildren.length - 1];
            if (lastChild && lastChild.key !== key) {
              const annotationDiff = findAnnotationDiff(diff.origin, endedAnnotation.mark), objectSchemaType = endedAnnotation && spanSchemaType.annotations && spanSchemaType.annotations.find((type) => endedAnnotation && endedAnnotation.object && type.name === endedAnnotation.object._type);
              returnedChildren.push(/* @__PURE__ */ jsx(Annotation$1, { object: endedAnnotation.object, diff: annotationDiff, path: [{
                _key: block._key
              }, "children", {
                _key: child._key
              }], schemaType: objectSchemaType, children: /* @__PURE__ */ jsx(Fragment$1, { children: annotationSegments[endedAnnotation.mark] }) }, key));
            }
            endedAnnotation = void 0;
          }
          activeAnnotations.length === 0 && returnedChildren.push(text);
        }
      }), /* @__PURE__ */ jsx("div", { children: returnedChildren }, block._key);
    }
    throw new Error("'span' schemaType not found");
  };
}
const PTDiff = (props2) => {
  const $ = c(9), {
    diff,
    schemaType
  } = props2;
  let t0;
  $[0] !== diff || $[1] !== schemaType ? (t0 = createPortableTextDiff(diff, schemaType), $[0] = diff, $[1] = schemaType, $[2] = t0) : t0 = $[2];
  const ptDiff = t0;
  let t1;
  $[3] !== ptDiff || $[4] !== schemaType ? (t1 = /* @__PURE__ */ jsx(PortableText, { diff: ptDiff, schemaType }), $[3] = ptDiff, $[4] = schemaType, $[5] = t1) : t1 = $[5];
  let t2;
  return $[6] !== diff.action || $[7] !== t1 ? (t2 = /* @__PURE__ */ jsx("div", { "data-diff-action": diff.action, children: t1 }), $[6] = diff.action, $[7] = t1, $[8] = t2) : t2 = $[8], t2;
}, ReferenceWrapper = styled.div.withConfig({
  displayName: "ReferenceWrapper",
  componentId: "sc-1kvf1eh-0"
})`word-wrap:break-word;`, ReferencePreview$1 = (t0) => {
  const $ = c(3), {
    value,
    schemaType
  } = t0;
  let t1;
  return $[0] !== schemaType || $[1] !== value ? (t1 = /* @__PURE__ */ jsx(Box, { as: ReferenceWrapper, padding: 2, children: /* @__PURE__ */ jsx(Preview$1, { schemaType, value, layout: "default" }) }), $[0] = schemaType, $[1] = value, $[2] = t1) : t1 = $[2], t1;
}, ReferenceFieldDiff = (t0) => {
  const $ = c(3), {
    diff,
    schemaType
  } = t0;
  let t1;
  return $[0] !== diff || $[1] !== schemaType ? (t1 = /* @__PURE__ */ jsx(DiffFromTo, { align: "center", diff, layout: "grid", path: "_ref", previewComponent: ReferencePreview$1, schemaType }), $[0] = diff, $[1] = schemaType, $[2] = t1) : t1 = $[2], t1;
}, SlugWrapper = styled.div.withConfig({
  displayName: "SlugWrapper",
  componentId: "sc-2vp7rq-0"
})`display:inline-block;word-break:break-all;white-space:pre-wrap;`, SlugPreview = (props2) => {
  const $ = c(2), {
    value
  } = props2;
  let t0;
  return $[0] !== value.current ? (t0 = /* @__PURE__ */ jsx(Box, { as: SlugWrapper, paddingX: 2, paddingY: 1, children: value.current }), $[0] = value.current, $[1] = t0) : t0 = $[1], t0;
}, SlugFieldDiff = (t0) => {
  const $ = c(3), {
    diff,
    schemaType
  } = t0;
  let t1;
  return $[0] !== diff || $[1] !== schemaType ? (t1 = /* @__PURE__ */ jsx(DiffFromTo, { layout: "inline", diff, schemaType, previewComponent: SlugPreview }), $[0] = diff, $[1] = schemaType, $[2] = t1) : t1 = $[2], t1;
}, StringWrapper$1 = styled.div.withConfig({
  displayName: "StringWrapper",
  componentId: "sc-1j5dr71-0"
})`display:inline-block;word-break:break-all;white-space:pre-wrap;`, StringPreview = (props2) => {
  const $ = c(2), {
    value
  } = props2;
  let t0;
  return $[0] !== value ? (t0 = /* @__PURE__ */ jsx(Box, { as: StringWrapper$1, paddingX: 2, paddingY: 1, children: value }), $[0] = value, $[1] = t0) : t0 = $[1], t0;
}, StringWrapper = styled.div.withConfig({
  displayName: "StringWrapper",
  componentId: "sc-1bx58du-0"
})`white-space:pre-wrap;word-wrap:break-word;`, StringFieldDiff = (t0) => {
  const $ = c(5), {
    diff,
    schemaType
  } = t0, {
    options
  } = schemaType;
  if (options?.list) {
    let t12;
    return $[0] !== diff || $[1] !== schemaType ? (t12 = /* @__PURE__ */ jsx(DiffFromTo, { diff, previewComponent: StringPreview, schemaType }), $[0] = diff, $[1] = schemaType, $[2] = t12) : t12 = $[2], t12;
  }
  let t1;
  return $[3] !== diff ? (t1 = /* @__PURE__ */ jsx(StringWrapper, { children: /* @__PURE__ */ jsx(DiffString, { diff }) }), $[3] = diff, $[4] = t1) : t1 = $[4], t1;
}, defaultComponents = {
  block: PTDiff,
  boolean: {
    component: BooleanFieldDiff,
    showHeader: !1
  },
  date: DatetimeFieldDiff,
  datetime: DatetimeFieldDiff,
  file: FileFieldDiff,
  image: ImageFieldDiff,
  number: NumberFieldDiff,
  reference: ReferenceFieldDiff,
  crossDatasetReference: ReferenceFieldDiff,
  slug: SlugFieldDiff,
  string: StringFieldDiff
};
function resolveDiffComponent(type, parentSchemaType) {
  let itType = type;
  for (; itType; ) {
    const resolved = itType?.components?.diff || tryResolve(itType, parentSchemaType) || defaultComponents[itType.name];
    if (resolved)
      return resolved;
    itType = itType.type;
  }
  const defaultComponentKey = ["date", "datetime"].includes(type.name) ? type.name : type.jsonType;
  return defaultComponents[defaultComponentKey];
}
function tryResolve(schemaType, parentSchemaType) {
  const resolvers = diffResolvers;
  let resolved;
  for (const resolver of resolvers) {
    if (typeof resolver != "function") {
      console.error("Diff component resolver is not a function: ", resolver);
      continue;
    }
    if (resolved = resolver({
      schemaType,
      parentSchemaType
    }), resolved)
      return resolved;
  }
}
function buildChangeList(schemaType, diff, path = [], titlePath = [], context = {}) {
  if (!resolveDiffComponent(schemaType, context.parentSchema)) {
    if (schemaType.jsonType === "object" && diff.type === "object")
      return buildObjectChangeList(schemaType, diff, path, titlePath, context);
    if (schemaType.jsonType === "array" && diff.type === "array")
      return buildArrayChangeList(schemaType, diff, path, titlePath);
  }
  return getFieldChange(schemaType, diff, path, titlePath, context);
}
function buildObjectChangeList(schemaType, diff, path = [], titlePath = [], diffContext = {}) {
  const changes = [], childContext = {
    ...diffContext,
    parentSchema: schemaType
  }, fieldSets = schemaType.fieldsets || schemaType.fields.map((field) => ({
    single: !0,
    field
  }));
  for (const fieldSet of fieldSets)
    fieldSet.single ? changes.push(...buildFieldChange(fieldSet.field, diff, path, titlePath, childContext)) : changes.push(...buildFieldsetChangeList(fieldSet, diff, path, titlePath, childContext));
  return changes.length < 2 ? changes : [{
    type: "group",
    key: pathToString$1(path) || "root",
    path,
    titlePath,
    changes: reduceTitlePaths(changes, titlePath.length),
    schemaType
  }];
}
function buildFieldChange(field, diff, path, titlePath, diffContext = {}) {
  const {
    fieldFilter,
    ...context
  } = diffContext, fieldDiff = diff.fields[field.name];
  if (!fieldDiff || !fieldDiff.isChanged || fieldFilter && !fieldFilter.includes(field.name))
    return [];
  const fieldPath = path.concat([field.name]), fieldTitlePath = titlePath.concat([field.type.title || field.name]);
  return buildChangeList(field.type, fieldDiff, fieldPath, fieldTitlePath, context);
}
function buildFieldsetChangeList(fieldSet, diff, path, titlePath, diffContext = {}) {
  const {
    fields,
    name,
    title,
    readOnly,
    hidden
  } = fieldSet, {
    fieldFilter,
    ...context
  } = diffContext, fieldSetHidden = hidden, fieldsetReadOnly = readOnly, fieldSetTitlePath = titlePath.concat([title || name]), changes = [];
  for (const field of fields) {
    const fieldDiff = diff.fields[field.name];
    if (!fieldDiff || !fieldDiff.isChanged || fieldFilter && !fieldFilter.includes(field.name))
      continue;
    const fieldPath = path.concat([field.name]), fieldTitlePath = fieldSetTitlePath.concat([field.type.title || field.name]);
    changes.push(...buildChangeList({
      readOnly: fieldsetReadOnly,
      hidden: fieldSetHidden,
      ...field.type
    }, fieldDiff, fieldPath, fieldTitlePath, context));
  }
  return changes.length < 2 ? changes : [{
    type: "group",
    key: pathToString$1(path) || "root",
    fieldsetName: name,
    path,
    titlePath: fieldSetTitlePath,
    changes: reduceTitlePaths(changes, fieldSetTitlePath.length),
    readOnly: fieldsetReadOnly,
    hidden: fieldSetHidden
  }];
}
function buildArrayChangeList(schemaType, diff, path = [], titlePath = []) {
  const changedOrMoved = diff.items.filter((item) => item.hasMoved && item.fromIndex !== item.toIndex || item.diff.action !== "unchanged");
  if (changedOrMoved.length === 0)
    return [];
  const isPortableText2 = hasPTMemberType(schemaType), list = [], changes = changedOrMoved.reduce((acc, itemDiff) => {
    const memberTypes = getArrayDiffItemType(itemDiff.diff, schemaType), memberType = memberTypes.toType || memberTypes.fromType;
    if (!memberType)
      return console.warn("Could not determine schema type for item at %s", pathToString$1(path)), acc;
    const segment = getItemKeySegment(itemDiff.diff.fromValue) || getItemKeySegment(itemDiff.diff.toValue) || diff.items.indexOf(itemDiff), itemPath = path.concat(segment), itemContext = {
      itemDiff,
      parentDiff: diff,
      parentSchema: schemaType
    }, itemTitlePath = titlePath.concat({
      hasMoved: itemDiff.hasMoved,
      toIndex: itemDiff.toIndex,
      fromIndex: itemDiff.fromIndex,
      annotation: itemDiff.diff.action === "unchanged" ? itemDiff.annotation : itemDiff.diff.annotation
    }), attachItemDiff = (change) => (change.type === "field" && pathsAreEqual(itemPath, change.path) && (change.itemDiff = itemDiff), change), children = buildChangeList(memberType, itemDiff.diff, itemPath, itemTitlePath, itemContext).map(attachItemDiff);
    return isPortableText2 && children.filter(isFieldChange).forEach((field, index, siblings) => {
      field.showHeader = siblings.length === 1, field.showIndex = itemDiff.fromIndex !== itemDiff.toIndex && itemDiff.hasMoved;
    }), children.length === 0 ? acc.push(...getFieldChange(memberType, itemDiff.diff, itemPath, itemTitlePath, itemContext)) : acc.push(...children), acc;
  }, list);
  return changes.length > 1 ? [{
    type: "group",
    key: pathToString$1(path) || "root",
    path,
    titlePath,
    changes: reduceTitlePaths(changes, titlePath.length),
    schemaType
  }] : changes;
}
function getFieldChange(schemaType, diff, path, titlePath, {
  itemDiff,
  parentDiff,
  parentSchema
} = {}) {
  const {
    fromValue,
    toValue,
    type
  } = diff;
  if (type === "array" && isEmpty(fromValue) && isEmpty(toValue))
    return [];
  let error;
  typeof fromValue < "u" && (error = getValueError(fromValue, schemaType)), !error && typeof toValue < "u" && (error = getValueError(toValue, schemaType));
  let showHeader = !0, component;
  const diffComponent = resolveDiffComponent(schemaType, parentSchema);
  return diffComponent && typeof diffComponent == "function" ? component = diffComponent : diffComponent && (component = diffComponent.component, showHeader = typeof diffComponent.showHeader > "u" ? showHeader : diffComponent.showHeader), [{
    type: "field",
    diff,
    path,
    error,
    itemDiff,
    parentDiff,
    titlePath,
    schemaType,
    showHeader,
    showIndex: !0,
    key: pathToString$1(path) || "root",
    diffComponent: error ? void 0 : component,
    parentSchema
  }];
}
function reduceTitlePaths(changes, byLength = 1) {
  return changes.map((change) => (change.titlePath = change.titlePath.slice(byLength), change));
}
function isEmpty(item) {
  return Array.isArray(item) && item.length === 0 || item === null || typeof item > "u";
}
const isAddedAction = (change) => change.type === "field" && change.diff.action === "added", flattenChangeNode = (changeNode) => {
  if (changeNode.type !== "group")
    return [changeNode];
  const newSubChanges = [];
  return changeNode.changes.forEach((cChange) => {
    newSubChanges.push(...flattenChangeNode(cChange));
  }), newSubChanges;
}, isSubpathOf = (subPath, parentPath) => {
  if (parentPath.length >= subPath.length)
    return !1;
  for (let i = 0; i < parentPath.length; i++)
    if (parentPath[i] !== subPath[i])
      return !1;
  return !0;
}, pathSegmentOfCorrectType = (item, child) => {
  const nextItem = item[child], key = getItemKey(nextItem);
  return key ? {
    _key: key
  } : Array.isArray(item) ? parseInt(child, 10) : child;
}, diffOptions = {
  diffMatchPatch: {
    enabled: !1,
    lengthThresholdAbsolute: 30,
    lengthThresholdRelative: 1.2
  }
};
function undoChange(change, rootDiff, documentOperations, stubbed) {
  if (!rootDiff)
    return;
  const patches = [], stubbedPaths = stubbed ?? /* @__PURE__ */ new Set();
  if (change.type === "group") {
    const allChanges = flattenChangeNode(change), unsetChanges = allChanges.filter(isAddedAction);
    allChanges.filter((child) => !isAddedAction(child)).forEach((child) => {
      undoChange(child, rootDiff, documentOperations, stubbedPaths);
    }), patches.push(...buildUnsetPatches(rootDiff, unsetChanges.map((unsetChange) => unsetChange.path).reverse()));
  } else change.diff.action === "added" ? patches.push(...buildUnsetPatches(rootDiff, [change.path])) : change.type === "field" && change.itemDiff && change.parentDiff && change.parentDiff.type === "array" && change.itemDiff.hasMoved ? patches.push(...buildMovePatches(change.itemDiff, change.parentDiff, change.path)) : patches.push(...buildUndoPatches(change.diff, rootDiff, change.path, stubbedPaths));
  documentOperations.patch.execute(patches);
}
function buildUnsetPatch(rootDiff, path, concurrentUnsetPaths) {
  const previousValue = rootDiff.toValue;
  return furthestEmptyAncestor(previousValue, path, concurrentUnsetPaths);
}
function buildUnsetPatches(rootDiff, paths) {
  const patches = [];
  for (let i = 0; i < paths.length; i++)
    patches.some((patch2) => isSubpathOf(paths[i], patch2)) || patches.push(buildUnsetPatch(rootDiff, paths[i], paths));
  return [{
    unset: [...new Set(patches.map(pathToString$1))]
  }];
}
function furthestEmptyAncestor(previousValue, currentPath, ignorePaths = [], initialPath) {
  if (currentPath.length <= 0)
    throw new Error("Root has no ancestor");
  const ancestorPath = currentPath.slice(0, -1), ancestorValue = getValueAtPath(previousValue, ancestorPath), updatedIgnorePaths = [
    ancestorPath,
    /*
     * We can filter out all the subpaths from under this ancestor
     * because since we ignore it higher up in the tree it doesn't
     * matter anymore what the values of subpaths are.
     */
    ...ignorePaths.filter((path) => !isSubpathOf(path, ancestorPath))
  ];
  return isStub(ancestorValue, ancestorPath, ignorePaths) ? furthestEmptyAncestor(previousValue, ancestorPath, updatedIgnorePaths) : currentPath;
}
function buildMovePatches(itemDiff, parentDiff, path) {
  const basePath = path.slice(0, -1), {
    parentValue,
    fromIndex,
    fromValue
  } = getFromItem(parentDiff, itemDiff);
  let insertLocation;
  if (fromIndex === 0)
    insertLocation = {
      before: pathToString$1([...basePath, 0])
    };
  else {
    const prevIndex = fromIndex - 1, prevSegment = getItemKeySegment(parentValue[prevIndex]) || prevIndex;
    insertLocation = {
      after: pathToString$1([...basePath, prevSegment])
    };
  }
  return [{
    unset: [pathToString$1(path)]
  }, {
    insert: {
      ...insertLocation,
      items: [fromValue]
    }
  }];
}
function buildUndoPatches(diff, rootDiff, path, stubbedPaths) {
  const patches = diffItem(diff.toValue, diff.fromValue, diffOptions, path), inserts = patches.filter((patch2) => patch2.op === "insert").map(({
    after,
    items
  }) => ({
    insert: {
      after: pathToString$1(after),
      items
    }
  })), unsets = patches.filter((patch2) => patch2.op === "unset").reduce((acc, patch2) => acc.concat(pathToString$1(patch2.path)), []), stubs = [];
  let hasSets = !1;
  const sets = patches.filter((patch2) => patch2.op === "set").reduce((acc, patch2) => (hasSets = !0, stubs.push(...getParentStubs(patch2.path, rootDiff, stubbedPaths)), acc[pathToString$1(patch2.path)] = patch2.value, acc), {});
  return [...stubs, ...inserts, ...unsets.length > 0 ? [{
    unset: unsets
  }] : [], ...hasSets ? [{
    set: sets
  }] : []];
}
function getParentStubs(path, rootDiff, stubbed) {
  const value = rootDiff.fromValue, nextValue = rootDiff.toValue, stubs = [];
  for (let i = 1; i <= path.length; i++) {
    const subPath = path.slice(0, i), pathStr = pathToString$1(subPath);
    if (stubbed.has(pathStr))
      continue;
    const nextSegment = path[i], nextIsArrayElement = isKeySegment(nextSegment) || isIndexSegment(nextSegment), itemValue = getValueAtPath(value, subPath), stub = getStubValue(itemValue);
    if (nextIsArrayElement && Array.isArray(itemValue) && !getValueAtPath(nextValue, path.slice(0, i + 1))) {
      const indexAtPrev = findIndex(itemValue, nextSegment), nextItem = getValueAtPath(value, subPath.concat(nextSegment)), itemPath = pathToString$1(subPath.concat(nextSegment));
      if (stubbed.has(itemPath)) {
        i++;
        continue;
      }
      stubbed.add(itemPath);
      const prevItem = itemValue[indexAtPrev - 1], prevSeg = isKeyedObject(prevItem) ? {
        _key: prevItem._key
      } : indexAtPrev - 1, after = pathToString$1(subPath.concat(indexAtPrev < 1 ? 0 : prevSeg));
      stubs.push({
        setIfMissing: {
          [pathStr]: []
        }
      }), stubs.push({
        insert: {
          after,
          items: [getStubValue(nextItem)]
        }
      }), i++;
      continue;
    }
    typeof stub > "u" || (stubbed.add(pathStr), stubs.push({
      setIfMissing: {
        [pathStr]: stub
      }
    }));
  }
  return stubs;
}
function onlyContainsStubs(item, path, ignorePaths) {
  if (!isRecord$4(item) || !Array.isArray(item))
    return !1;
  for (const child in item) {
    if (!Object.prototype.hasOwnProperty.call(item, child) || child === "_type" || child === "_key")
      continue;
    const nextPath = [...path, pathSegmentOfCorrectType(item, child)];
    if (!isStub(item[child], nextPath, ignorePaths))
      return !1;
  }
  return !0;
}
function isStub(item, path, ignorePaths) {
  const isIgnoredPath = ignorePaths?.some((ignorePath) => pathToString$1(ignorePath) === pathToString$1(path)), isEmptyArray2 = Array.isArray(item) && item.length <= 0;
  return isIgnoredPath || item === void 0 || item === null || isEmptyArray2 || isEmptyObject$1(item) || onlyContainsStubs(item, path, ignorePaths);
}
function getStubValue(item) {
  if (Array.isArray(item))
    return [];
  if (typeof item != "object" || item === null)
    return;
  const props2 = {};
  return isKeyedObject(item) && (props2._key = item._key), isTypedObject$1(item) && (props2._type = item._type), props2;
}
function getFromItem(parentDiff, itemDiff) {
  if (parentDiff.fromValue && typeof itemDiff.fromIndex == "number") {
    const fromValue = parentDiff.fromValue[itemDiff.fromIndex];
    return {
      parentValue: parentDiff.fromValue,
      fromIndex: itemDiff.fromIndex,
      fromValue
    };
  }
  throw new Error(`Failed to find item at index ${itemDiff.fromIndex}`);
}
const ChangeListWrapper$1 = styled.div.withConfig({
  displayName: "ChangeListWrapper",
  componentId: "sc-kh2d4n-0"
})`display:grid;grid-template-columns:minmax(0,1fr);`;
class DiffErrorBoundary extends Component {
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  state = {};
  // eslint-disable-next-line class-methods-use-this
  componentDidCatch(error) {
    console.error("Error rendering diff component: "), console.error(error);
  }
  render() {
    const {
      t
    } = this.props, {
      error
    } = this.state;
    return error ? /* @__PURE__ */ jsx(Card, { padding: 3, radius: 2, tone: "critical", children: /* @__PURE__ */ jsxs(Flex, { children: [
      /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }),
      /* @__PURE__ */ jsxs(Box, { paddingLeft: 3, children: [
        /* @__PURE__ */ jsx(Text$1, { as: "h3", size: 1, weight: "medium", children: t("changes.error-boundary.title") }),
        isDev && /* @__PURE__ */ jsx(Box, { marginTop: 2, children: /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, children: t("changes.error-boundary.developer-info") }) })
      ] })
    ] }) }) : this.props.children;
  }
}
const arrowComponents = {
  down: ArrowDownIcon,
  right: ArrowRightIcon
};
function FromToArrow(props2) {
  const $ = c(8);
  let restProps, t0;
  $[0] !== props2 ? ({
    direction: t0,
    ...restProps
  } = props2, $[0] = props2, $[1] = restProps, $[2] = t0) : (restProps = $[1], t0 = $[2]);
  const ArrowComponent = arrowComponents[t0 === void 0 ? "right" : t0];
  let t1;
  $[3] !== ArrowComponent ? (t1 = /* @__PURE__ */ jsx(ArrowComponent, {}), $[3] = ArrowComponent, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== restProps || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, ...restProps, children: t1 }), $[5] = restProps, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
const CodeWrapper$1 = styled.pre.withConfig({
  displayName: "CodeWrapper",
  componentId: "sc-10e7hwe-0"
})`overflow-x:auto;position:relative;`, Meta = styled.div.withConfig({
  displayName: "Meta",
  componentId: "sc-10e7hwe-1"
})`position:absolute;top:0;right:0;`;
function DiffInspectWrapper(props2) {
  const $ = c(18);
  let as, change, children, restProps;
  $[0] !== props2 ? ({
    children,
    as,
    change,
    ...restProps
  } = props2, $[0] = props2, $[1] = as, $[2] = change, $[3] = children, $[4] = restProps) : (as = $[1], change = $[2], children = $[3], restProps = $[4]);
  const isHovering = useRef(!1), [isInspecting, setIsInspecting] = useState(!1);
  let t0;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setIsInspecting(_temp$3V), $[5] = t0) : t0 = $[5];
  const toggleInspect = t0;
  let t1;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => isHovering.current = !0, $[6] = t1) : t1 = $[6];
  const handleMouseEnter = t1;
  let t2;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => isHovering.current = !1, $[7] = t2) : t2 = $[7];
  const handleMouseLeave = t2;
  let t3, t4;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    const onKeyDown = function(evt) {
      const {
        metaKey,
        key
      } = evt;
      metaKey && key === "i" && isHovering.current && toggleInspect();
    };
    return window.addEventListener("keydown", onKeyDown, !1), () => window.removeEventListener("keydown", onKeyDown, !1);
  }, t4 = [toggleInspect], $[8] = t3, $[9] = t4) : (t3 = $[8], t4 = $[9]), useEffect(t3, t4);
  let t5;
  $[10] !== change || $[11] !== children || $[12] !== isInspecting ? (t5 = isInspecting ? /* @__PURE__ */ jsx(DiffInspector, { change }) : children, $[10] = change, $[11] = children, $[12] = isInspecting, $[13] = t5) : t5 = $[13];
  let t6;
  return $[14] !== as || $[15] !== restProps || $[16] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { as, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, ...restProps, children: t5 }), $[14] = as, $[15] = restProps, $[16] = t5, $[17] = t6) : t6 = $[17], t6;
}
function _temp$3V(state) {
  return !state;
}
const MetaLabel = (t0) => {
  const $ = c(2), {
    title
  } = t0;
  let t1;
  return $[0] !== title ? (t1 = /* @__PURE__ */ jsx(Box, { padding: 3, display: "inline-block", as: Meta, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: title }) }), $[0] = title, $[1] = t1) : t1 = $[1], t1;
};
function DiffInspector(t0) {
  const $ = c(43), {
    change
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("changes.inspector.meta-label"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(MetaLabel, { title: t1 }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== change.diff.action || $[5] !== change.diff.isChanged || $[6] !== change.itemDiff?.fromIndex || $[7] !== change.itemDiff?.hasMoved || $[8] !== change.itemDiff?.toIndex || $[9] !== change.path ? (t3 = printMeta({
    path: pathToString$1(change.path),
    fromIndex: change.itemDiff?.fromIndex,
    toIndex: change.itemDiff?.toIndex,
    hasMoved: change.itemDiff?.hasMoved,
    action: change.diff.action,
    isChanged: change.diff.isChanged
  }), $[4] = change.diff.action, $[5] = change.diff.isChanged, $[6] = change.itemDiff?.fromIndex, $[7] = change.itemDiff?.hasMoved, $[8] = change.itemDiff?.toIndex, $[9] = change.path, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== t3 ? (t4 = /* @__PURE__ */ jsx(Code, { language: "json", size: 1, children: t3 }), $[11] = t3, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== t2 || $[14] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Card, { padding: 3, tone: "transparent", as: CodeWrapper$1, radius: 1, children: [
    t2,
    t4
  ] }), $[13] = t2, $[14] = t4, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== t ? (t6 = t("changes.inspector.from-label"), $[16] = t, $[17] = t6) : t6 = $[17];
  let t7;
  $[18] !== t6 ? (t7 = /* @__PURE__ */ jsx(MetaLabel, { title: t6 }), $[18] = t6, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== change.diff.fromValue ? (t8 = jsonify(change.diff.fromValue), $[20] = change.diff.fromValue, $[21] = t8) : t8 = $[21];
  let t9;
  $[22] !== t8 ? (t9 = /* @__PURE__ */ jsx(Code, { language: "json", size: 1, children: t8 }), $[22] = t8, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== t7 || $[25] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Card, { as: CodeWrapper$1, tone: "critical", padding: 3, radius: 1, children: [
    t7,
    t9
  ] }), $[24] = t7, $[25] = t9, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx(FromToArrow, { direction: "down", align: "center" }) }), $[27] = t11) : t11 = $[27];
  let t12;
  $[28] !== t ? (t12 = t("changes.inspector.to-label"), $[28] = t, $[29] = t12) : t12 = $[29];
  let t13;
  $[30] !== t12 ? (t13 = /* @__PURE__ */ jsx(MetaLabel, { title: t12 }), $[30] = t12, $[31] = t13) : t13 = $[31];
  let t14;
  $[32] !== change.diff.toValue ? (t14 = jsonify(change.diff.toValue), $[32] = change.diff.toValue, $[33] = t14) : t14 = $[33];
  let t15;
  $[34] !== t14 ? (t15 = /* @__PURE__ */ jsx(Code, { language: "json", size: 1, children: t14 }), $[34] = t14, $[35] = t15) : t15 = $[35];
  let t16;
  $[36] !== t13 || $[37] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Card, { as: CodeWrapper$1, tone: "positive", padding: 3, radius: 1, children: [
    t13,
    t15
  ] }), $[36] = t13, $[37] = t15, $[38] = t16) : t16 = $[38];
  let t17;
  return $[39] !== t10 || $[40] !== t16 || $[41] !== t5 ? (t17 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t5,
    t10,
    t11,
    t16
  ] }), $[39] = t10, $[40] = t16, $[41] = t5, $[42] = t17) : t17 = $[42], t17;
}
function jsonify(value) {
  return typeof value > "u" ? "undefined" : JSON.stringify(value, null, 2);
}
function printMeta(keys) {
  const lines = [];
  return Object.entries(keys).forEach(([key, value]) => {
    typeof value < "u" && value !== null && lines.push(`${key}: ${value}`);
  }), lines.join(`
`);
}
function useChangeVerb(diff) {
  const $ = c(6), {
    t
  } = useTranslation(), hadPrevValue = hasValue(diff.fromValue), hasNextValue = hasValue(diff.toValue);
  if (!hadPrevValue && hasNextValue) {
    let t02;
    return $[0] !== t ? (t02 = t("changes.added-label"), $[0] = t, $[1] = t02) : t02 = $[1], t02;
  }
  if (!hasNextValue && hadPrevValue) {
    let t02;
    return $[2] !== t ? (t02 = t("changes.removed-label"), $[2] = t, $[3] = t02) : t02 = $[3], t02;
  }
  let t0;
  return $[4] !== t ? (t0 = t("changes.changed-label"), $[4] = t, $[5] = t0) : t0 = $[5], t0;
}
function hasValue(value) {
  return value !== null && typeof value < "u" && value !== "";
}
const INLINE_COLUMN_STYLES = {
  flexShrink: 0
}, BLOCK_COLUMN_STYLES = {
  alignItems: "stretch"
}, FLEX_ALIGN = {
  top: "flex-start",
  center: "center",
  bottom: "flex-end",
  default: "flex-start"
}, FromTo = forwardRef(function(props2, ref) {
  const $ = c(28);
  let from2, restProps, style, t0, t1, to;
  $[0] !== props2 ? ({
    align: t0,
    layout: t1,
    from: from2,
    to,
    style,
    ...restProps
  } = props2, $[0] = props2, $[1] = from2, $[2] = restProps, $[3] = style, $[4] = t0, $[5] = t1, $[6] = to) : (from2 = $[1], restProps = $[2], style = $[3], t0 = $[4], t1 = $[5], to = $[6]);
  const align2 = t0 === void 0 ? "top" : t0, layout = t1 === void 0 ? "inline" : t1, theme = useTheme(), Layout2 = layout === "inline" ? Flex : Grid;
  let t2;
  $[7] !== layout || $[8] !== theme ? (t2 = layout === "inline" ? {
    maxWidth: "100%",
    display: "inline-flex"
  } : {
    gridTemplateColumns: `minmax(0, 1fr) ${rem(theme.sanity.space[5])} minmax(0, 1fr)`
  }, $[7] = layout, $[8] = theme, $[9] = t2) : t2 = $[9];
  let t3;
  $[10] !== style || $[11] !== t2 ? (t3 = {
    ...style,
    ...t2
  }, $[10] = style, $[11] = t2, $[12] = t3) : t3 = $[12];
  const layoutStyles = t3, columnStyles = layout === "inline" ? INLINE_COLUMN_STYLES : BLOCK_COLUMN_STYLES;
  let t4;
  $[13] !== align2 || $[14] !== columnStyles || $[15] !== from2 ? (t4 = from2 && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(Flex, { align: FLEX_ALIGN[align2], style: columnStyles, children: from2 }),
    /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", padding: 2, children: /* @__PURE__ */ jsx(FromToArrow, {}) })
  ] }), $[13] = align2, $[14] = columnStyles, $[15] = from2, $[16] = t4) : t4 = $[16];
  const t5 = FLEX_ALIGN[align2];
  let t6;
  $[17] !== columnStyles || $[18] !== t5 || $[19] !== to ? (t6 = /* @__PURE__ */ jsx(Flex, { align: t5, style: columnStyles, children: to }), $[17] = columnStyles, $[18] = t5, $[19] = to, $[20] = t6) : t6 = $[20];
  let t7;
  return $[21] !== Layout2 || $[22] !== layoutStyles || $[23] !== ref || $[24] !== restProps || $[25] !== t4 || $[26] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Layout2, { ...restProps, ref, style: layoutStyles, "data-from-to-layout": !0, children: [
    t4,
    t6
  ] }), $[21] = Layout2, $[22] = layoutStyles, $[23] = ref, $[24] = restProps, $[25] = t4, $[26] = t6, $[27] = t7) : t7 = $[27], t7;
}), cardStyles = {
  flex: 1,
  minWidth: 0,
  display: "block",
  whiteSpace: "break-spaces"
};
function DiffFromTo(props2) {
  const $ = c(39), {
    align: align2,
    cardClassName,
    diff,
    layout,
    path,
    previewComponent: PreviewComponent,
    schemaType
  } = props2, {
    action
  } = diff, changeVerb = useChangeVerb(diff);
  if (action === "unchanged") {
    let t02;
    $[0] !== PreviewComponent || $[1] !== diff.toValue || $[2] !== schemaType ? (t02 = /* @__PURE__ */ jsx(PreviewComponent, { schemaType, value: diff.toValue }), $[0] = PreviewComponent, $[1] = diff.toValue, $[2] = schemaType, $[3] = t02) : t02 = $[3];
    let t12;
    return $[4] !== cardClassName || $[5] !== t02 ? (t12 = /* @__PURE__ */ jsx(DiffCard, { className: cardClassName, style: cardStyles, children: t02 }), $[4] = cardClassName, $[5] = t02, $[6] = t12) : t12 = $[6], t12;
  }
  let t0;
  $[7] !== PreviewComponent || $[8] !== cardClassName || $[9] !== diff || $[10] !== path || $[11] !== schemaType ? (t0 = diff.fromValue !== void 0 && diff.fromValue !== null && /* @__PURE__ */ jsx(DiffCard, { as: "del", className: cardClassName, diff, path, style: cardStyles, children: /* @__PURE__ */ jsx(PreviewComponent, { schemaType, value: diff.fromValue }) }), $[7] = PreviewComponent, $[8] = cardClassName, $[9] = diff, $[10] = path, $[11] = schemaType, $[12] = t0) : t0 = $[12];
  const from2 = t0;
  let t1;
  $[13] !== PreviewComponent || $[14] !== cardClassName || $[15] !== diff || $[16] !== path || $[17] !== schemaType ? (t1 = diff.toValue !== void 0 && diff.toValue !== null && /* @__PURE__ */ jsx(DiffCard, { as: "ins", className: cardClassName, diff, path, style: cardStyles, children: /* @__PURE__ */ jsx(PreviewComponent, { schemaType, value: diff.toValue }) }), $[13] = PreviewComponent, $[14] = cardClassName, $[15] = diff, $[16] = path, $[17] = schemaType, $[18] = t1) : t1 = $[18];
  const to = t1;
  if (from2 && !to) {
    let t22;
    return $[19] !== changeVerb || $[20] !== diff || $[21] !== from2 || $[22] !== path ? (t22 = /* @__PURE__ */ jsx(DiffTooltip, { description: changeVerb, diff, path, children: from2 }), $[19] = changeVerb, $[20] = diff, $[21] = from2, $[22] = path, $[23] = t22) : t22 = $[23], t22;
  }
  if (!from2 && to) {
    let t22;
    return $[24] !== changeVerb || $[25] !== diff || $[26] !== path || $[27] !== to ? (t22 = /* @__PURE__ */ jsx(DiffTooltip, { description: changeVerb, diff, path, children: to }), $[24] = changeVerb, $[25] = diff, $[26] = path, $[27] = to, $[28] = t22) : t22 = $[28], t22;
  }
  let t2;
  $[29] !== align2 || $[30] !== from2 || $[31] !== layout || $[32] !== to ? (t2 = /* @__PURE__ */ jsx(FromTo, { align: align2, from: from2, layout, to }), $[29] = align2, $[30] = from2, $[31] = layout, $[32] = to, $[33] = t2) : t2 = $[33];
  let t3;
  return $[34] !== changeVerb || $[35] !== diff || $[36] !== path || $[37] !== t2 ? (t3 = /* @__PURE__ */ jsx(DiffTooltip, { description: changeVerb, diff, path, children: t2 }), $[34] = changeVerb, $[35] = diff, $[36] = path, $[37] = t2, $[38] = t3) : t3 = $[38], t3;
}
const FallbackPreview = (t0) => {
  const $ = c(3), {
    value,
    schemaType
  } = t0, t1 = value;
  let t2;
  return $[0] !== schemaType || $[1] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Preview$1, { schemaType, value: t1, layout: "default" }) }), $[0] = schemaType, $[1] = t1, $[2] = t2) : t2 = $[2], t2;
}, FallbackDiff = (props2) => {
  const $ = c(3), {
    diff,
    schemaType
  } = props2;
  let t0;
  return $[0] !== diff || $[1] !== schemaType ? (t0 = /* @__PURE__ */ jsx(DiffFromTo, { diff, schemaType, previewComponent: FallbackPreview, layout: "grid" }), $[0] = diff, $[1] = schemaType, $[2] = t0) : t0 = $[2], t0;
}, FieldChangeContainer = styled.div.withConfig({
  displayName: "FieldChangeContainer",
  componentId: "sc-1dn07l7-0"
})`--field-change-error:${({
  theme
}) => theme.sanity.color.solid.critical.enabled.bg};&[data-revert-all-changes-hover] [data-revert-all-hover]::before{border-left:2px solid var(--field-change-error);}`, DiffBorder = styled.div.withConfig({
  displayName: "DiffBorder",
  componentId: "sc-1dn07l7-1"
})`--field-change-error:${({
  theme
}) => theme.sanity.color.solid.critical.enabled.bg};--diff-inspect-padding-xsmall:${({
  theme
}) => rem(theme.sanity.space[1])};--diff-inspect-padding-small:${({
  theme
}) => rem(theme.sanity.space[2])};position:relative;padding:var(--diff-inspect-padding-xsmall) 0 var(--diff-inspect-padding-xsmall) var(--diff-inspect-padding-small);&::before{content:'';display:block;position:absolute;top:0;left:0;bottom:0;border-left:1px solid var(--card-border-color);}&[data-error]:hover::before,&[data-revert-field-hover]:hover::before{border-left:2px solid var(--field-change-error);}`, Root$A = styled(Button).withConfig({
  displayName: "Root",
  componentId: "sc-77vys-0"
})`[data-ui='Text']{font-weight:normal;}div[data-ui='Box']{display:none;}&:not([data-disabled='true']):hover,&:not([data-disabled='true']):focus{--card-fg-color:${({
  theme
}) => theme.sanity.color.solid.critical.enabled.bg};--card-bg-color:transparent;--card-border-color:transparent;div[data-ui='Box']{display:block;}}`, RevertChangesButton = forwardRef(function(props2, ref) {
  const $ = c(12);
  let changeCount, restProps, selected;
  $[0] !== props2 ? ({
    selected,
    changeCount,
    ...restProps
  } = props2, $[0] = props2, $[1] = changeCount, $[2] = restProps, $[3] = selected) : (changeCount = $[1], restProps = $[2], selected = $[3]);
  const {
    t
  } = useTranslation();
  let t0;
  $[4] !== changeCount || $[5] !== t ? (t0 = t("changes.action.revert-changes-confirm-change", {
    count: changeCount
  }), $[4] = changeCount, $[5] = t, $[6] = t0) : t0 = $[6];
  let t1;
  return $[7] !== ref || $[8] !== restProps || $[9] !== selected || $[10] !== t0 ? (t1 = /* @__PURE__ */ jsx(Root$A, { icon: RevertIcon, selected, text: t0, mode: "bleed", ref, tooltipProps: null, ...restProps }), $[7] = ref, $[8] = restProps, $[9] = selected, $[10] = t0, $[11] = t1) : t1 = $[11], t1;
});
function RevertChangesConfirmDialog(t0) {
  const $ = c(17), {
    open,
    onConfirm,
    onCancel,
    changeCount,
    referenceElement
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("changes.action.revert-all-cancel"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== changeCount || $[3] !== t ? (t2 = changeCount > 1 ? t("changes.action.revert-all-confirm") : t("changes.action.revert-changes-confirm-change", {
    count: 1
  }), $[2] = changeCount, $[3] = t, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== changeCount || $[6] !== t ? (t3 = changeCount > 1 ? t("changes.action.revert-all-description", {
    count: changeCount
  }) : t("changes.action.revert-changes-description", {
    count: changeCount
  }), $[5] = changeCount, $[6] = t, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = ["bottom", "bottom-start", "bottom-end"], $[8] = t4) : t4 = $[8];
  let t5;
  return $[9] !== onCancel || $[10] !== onConfirm || $[11] !== open || $[12] !== referenceElement || $[13] !== t1 || $[14] !== t2 || $[15] !== t3 ? (t5 = /* @__PURE__ */ jsx(ConfirmPopover, { cancelButtonText: t1, confirmButtonText: t2, message: t3, onCancel, onConfirm, open, referenceElement, tone: "critical", placement: "bottom", fallbackPlacements: t4 }), $[9] = onCancel, $[10] = onConfirm, $[11] = open, $[12] = referenceElement, $[13] = t1, $[14] = t2, $[15] = t3, $[16] = t5) : t5 = $[16], t5;
}
function ValueError(t0) {
  const $ = c(8), {
    error
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== error.actualType || $[2] !== error.expectedType || $[3] !== error.messageKey || $[4] !== t ? (t2 = t(error.messageKey, {
    expectedType: error.expectedType,
    actualType: error.actualType
  }), $[1] = error.actualType, $[2] = error.expectedType, $[3] = error.messageKey, $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Card, { tone: "critical", padding: 3, children: /* @__PURE__ */ jsxs(Flex, { align: "flex-start", children: [
    t1,
    /* @__PURE__ */ jsx(Box, { flex: 1, paddingLeft: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, as: "p", children: t2 }) })
  ] }) }), $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}
const ParentWrapper = (t0) => {
  const $ = c(8), {
    children,
    path,
    hasRevertHover,
    wrap: wrap2
  } = t0, {
    FieldWrapper: t1
  } = useDocumentChange(), FieldWrapper2 = t1 === void 0 ? Fragment : t1;
  if (wrap2) {
    let lastArrayIndex = 0;
    for (let i = 0; i < path.length; i++)
      typeof path[i] != "string" && (lastArrayIndex = i);
    let t2;
    $[0] !== lastArrayIndex || $[1] !== path ? (t2 = path.slice(0, lastArrayIndex + 1), $[0] = lastArrayIndex, $[1] = path, $[2] = t2) : t2 = $[2];
    let t3;
    return $[3] !== FieldWrapper2 || $[4] !== children || $[5] !== hasRevertHover || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(FieldWrapper2, { path: t2, hasRevertHover, children }), $[3] = FieldWrapper2, $[4] = children, $[5] = hasRevertHover, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
  }
  return children;
};
function FieldChange(props2) {
  const $ = c(68);
  let addParentWrapper, change, hidden, readOnly, restProps;
  $[0] !== props2 ? ({
    change,
    hidden,
    readOnly,
    addParentWrapper,
    ...restProps
  } = props2, $[0] = props2, $[1] = addParentWrapper, $[2] = change, $[3] = hidden, $[4] = readOnly, $[5] = restProps) : (addParentWrapper = $[1], change = $[2], hidden = $[3], readOnly = $[4], restProps = $[5]);
  const DiffComponent = change.diffComponent || FallbackDiff, {
    documentId,
    schemaType,
    rootDiff,
    isComparingCurrent,
    FieldWrapper: t0
  } = useDocumentChange(), FieldWrapper2 = t0 === void 0 ? Fragment : t0, {
    selectedReleaseId
  } = usePerspective(), ops = useDocumentOperation(documentId, schemaType.name, selectedReleaseId), [confirmRevertOpen, setConfirmRevertOpen] = useState(!1), [revertHovered, setRevertHovered] = useState(!1), [buttonElement, _setButtonElement] = useState(null);
  let t1;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (element) => {
    startTransition(() => _setButtonElement(element));
  }, $[6] = t1) : t1 = $[6];
  const setButtonElement = t1, {
    t
  } = useTranslation();
  let t2;
  $[7] !== documentId || $[8] !== schemaType.name ? (t2 = {
    id: documentId,
    type: schemaType.name,
    permission: "update"
  }, $[7] = documentId, $[8] = schemaType.name, $[9] = t2) : t2 = $[9];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t2);
  let t3;
  $[10] !== change || $[11] !== ops || $[12] !== rootDiff ? (t3 = () => {
    undoChange(change, rootDiff, ops), setConfirmRevertOpen(!1);
  }, $[10] = change, $[11] = ops, $[12] = rootDiff, $[13] = t3) : t3 = $[13];
  const handleRevertChanges = t3;
  let t4;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setConfirmRevertOpen(!0);
  }, $[14] = t4) : t4 = $[14];
  const handleRevertChangesConfirm = t4;
  let t5;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    setConfirmRevertOpen(!1);
  }, $[15] = t5) : t5 = $[15];
  const closeRevertChangesConfirmDialog = t5;
  let t6;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    setRevertHovered(!0);
  }, $[16] = t6) : t6 = $[16];
  const handleRevertButtonMouseEnter = t6;
  let t7;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = () => {
    setRevertHovered(!1);
  }, $[17] = t7) : t7 = $[17];
  const handleRevertButtonMouseLeave = t7;
  let t8;
  $[18] !== change.parentSchema ? (t8 = change.parentSchema?.jsonType === "array" && !change.parentSchema.of.some(_temp$3U), $[18] = change.parentSchema, $[19] = t8) : t8 = $[19];
  const isArray2 = t8;
  let t9;
  $[20] !== change.path || $[21] !== isArray2 ? (t9 = isArray2 ? change.path.slice(0, -1) : change.path, $[20] = change.path, $[21] = isArray2, $[22] = t9) : t9 = $[22];
  const fieldPath = t9;
  let t10;
  $[23] !== change.path ? (t10 = {
    path: change.path
  }, $[23] = change.path, $[24] = t10) : t10 = $[24];
  const value = t10;
  if (hidden)
    return null;
  let t11;
  $[25] !== change ? (t11 = change.showHeader && /* @__PURE__ */ jsx(ChangeBreadcrumb, { change, titlePath: change.titlePath }), $[25] = change, $[26] = t11) : t11 = $[26];
  const t12 = !!addParentWrapper, t13 = revertHovered ? "" : void 0, t14 = change.error ? "" : void 0;
  let t15;
  $[27] !== DiffComponent || $[28] !== change.diff || $[29] !== change.error || $[30] !== change.schemaType || $[31] !== t || $[32] !== value ? (t15 = change.error ? /* @__PURE__ */ jsx(ValueError, { error: change.error }) : /* @__PURE__ */ jsx(DiffErrorBoundary, { t, children: /* @__PURE__ */ jsx(DiffContext.Provider, { value, children: /* @__PURE__ */ jsx(DiffComponent, { diff: change.diff, schemaType: change.schemaType }) }) }), $[27] = DiffComponent, $[28] = change.diff, $[29] = change.error, $[30] = change.schemaType, $[31] = t, $[32] = value, $[33] = t15) : t15 = $[33];
  let t16;
  $[34] !== change.key || $[35] !== confirmRevertOpen || $[36] !== isComparingCurrent || $[37] !== isPermissionsLoading || $[38] !== permissions?.granted || $[39] !== readOnly ? (t16 = isComparingCurrent && !isPermissionsLoading && permissions?.granted && /* @__PURE__ */ jsx(RevertChangesButton, { changeCount: 1, onClick: handleRevertChangesConfirm, onMouseEnter: handleRevertButtonMouseEnter, onMouseLeave: handleRevertButtonMouseLeave, selected: confirmRevertOpen, disabled: readOnly, ref: setButtonElement, "data-testid": `single-change-revert-button-${change?.key}` }), $[34] = change.key, $[35] = confirmRevertOpen, $[36] = isComparingCurrent, $[37] = isPermissionsLoading, $[38] = permissions?.granted, $[39] = readOnly, $[40] = t16) : t16 = $[40];
  let t17;
  $[41] !== change || $[42] !== t13 || $[43] !== t14 || $[44] !== t15 || $[45] !== t16 ? (t17 = /* @__PURE__ */ jsxs(DiffInspectWrapper, { change, as: DiffBorder, "data-revert-field-hover": t13, "data-error": t14, "data-revert-all-hover": !0, "data-ui": "field-diff-inspect-wrapper", children: [
    t15,
    t16
  ] }), $[41] = change, $[42] = t13, $[43] = t14, $[44] = t15, $[45] = t16, $[46] = t17) : t17 = $[46];
  let t18;
  $[47] !== FieldWrapper2 || $[48] !== fieldPath || $[49] !== revertHovered || $[50] !== t17 ? (t18 = /* @__PURE__ */ jsx(FieldWrapper2, { path: fieldPath, hasRevertHover: revertHovered, children: t17 }), $[47] = FieldWrapper2, $[48] = fieldPath, $[49] = revertHovered, $[50] = t17, $[51] = t18) : t18 = $[51];
  let t19;
  $[52] !== fieldPath || $[53] !== revertHovered || $[54] !== t12 || $[55] !== t18 ? (t19 = /* @__PURE__ */ jsx(ParentWrapper, { path: fieldPath, hasRevertHover: revertHovered, wrap: t12, children: t18 }), $[52] = fieldPath, $[53] = revertHovered, $[54] = t12, $[55] = t18, $[56] = t19) : t19 = $[56];
  let t20;
  $[57] !== restProps || $[58] !== t11 || $[59] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Stack, { space: 1, as: FieldChangeContainer, ...restProps, children: [
    t11,
    t19
  ] }), $[57] = restProps, $[58] = t11, $[59] = t19, $[60] = t20) : t20 = $[60];
  let t21;
  $[61] !== buttonElement || $[62] !== confirmRevertOpen || $[63] !== handleRevertChanges ? (t21 = /* @__PURE__ */ jsx(RevertChangesConfirmDialog, { open: confirmRevertOpen, onConfirm: handleRevertChanges, onCancel: closeRevertChangesConfirmDialog, changeCount: 1, referenceElement: buttonElement }), $[61] = buttonElement, $[62] = confirmRevertOpen, $[63] = handleRevertChanges, $[64] = t21) : t21 = $[64];
  let t22;
  return $[65] !== t20 || $[66] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t20,
    t21
  ] }), $[65] = t20, $[66] = t21, $[67] = t22) : t22 = $[67], t22;
}
function _temp$3U(ofType) {
  return ofType.type?.name === "block";
}
const ChangeListWrapper = styled.div.withConfig({
  displayName: "ChangeListWrapper",
  componentId: "sc-9bvopx-0"
})`display:grid;grid-template-columns:minmax(0,1fr);`, GroupChangeContainer = styled.div.withConfig({
  displayName: "GroupChangeContainer",
  componentId: "sc-9bvopx-1"
})`--field-change-error:${({
  theme
}) => theme.sanity.color.solid.critical.enabled.bg};--diff-inspect-padding-xsmall:${({
  theme
}) => rem(theme.sanity.space[1])};--diff-inspect-padding-small:${({
  theme
}) => rem(theme.sanity.space[2])};position:relative;padding:var(--diff-inspect-padding-xsmall) var(--diff-inspect-padding-small);&::before{content:'';display:block;position:absolute;top:0;left:0;bottom:0;border-left:1px solid var(--card-border-color);}&[data-error]:hover::before,&[data-revert-group-hover]:hover::before,&[data-revert-all-groups-hover]::before{border-left:2px solid var(--field-change-error);}`;
function GroupChange(props2) {
  const $ = c(46);
  let group2, hidden, readOnly, restProps;
  $[0] !== props2 ? ({
    change: group2,
    readOnly,
    hidden,
    ...restProps
  } = props2, $[0] = props2, $[1] = group2, $[2] = hidden, $[3] = readOnly, $[4] = restProps) : (group2 = $[1], hidden = $[2], readOnly = $[3], restProps = $[4]);
  const {
    titlePath,
    changes,
    path: groupPath
  } = group2, {
    path: diffPath
  } = useContext(DiffContext), {
    documentId,
    schemaType,
    FieldWrapper: t0,
    rootDiff,
    isComparingCurrent
  } = useDocumentChange(), FieldWrapper2 = t0 === void 0 ? Fragment : t0;
  let t1;
  $[5] !== changes ? (t1 = changes.every(_temp$3T), $[5] = changes, $[6] = t1) : t1 = $[6];
  const isPortableText2 = t1;
  let t2;
  $[7] !== diffPath || $[8] !== groupPath ? (t2 = pathsAreEqual(diffPath, groupPath), $[7] = diffPath, $[8] = groupPath, $[9] = t2) : t2 = $[9];
  const isNestedInDiff = t2, [revertButtonElement, _setRevertButtonElement] = useState(null);
  let t3;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (element) => {
    startTransition(() => _setRevertButtonElement(element));
  }, $[10] = t3) : t3 = $[10];
  const setRevertButtonElement = t3, isRevertButtonHovered = useHover(revertButtonElement), {
    selectedReleaseId
  } = usePerspective(), docOperations = useDocumentOperation(documentId, schemaType.name, selectedReleaseId), [confirmRevertOpen, setConfirmRevertOpen] = useState(!1);
  let t4;
  $[11] !== documentId || $[12] !== schemaType.name ? (t4 = {
    id: documentId,
    type: schemaType.name,
    permission: "update"
  }, $[11] = documentId, $[12] = schemaType.name, $[13] = t4) : t4 = $[13];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t4);
  let t5;
  $[14] !== docOperations || $[15] !== group2 || $[16] !== rootDiff ? (t5 = () => {
    undoChange(group2, rootDiff, docOperations), setConfirmRevertOpen(!1);
  }, $[14] = docOperations, $[15] = group2, $[16] = rootDiff, $[17] = t5) : t5 = $[17];
  const handleRevertChanges = t5;
  let t6;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    setConfirmRevertOpen(!0);
  }, $[18] = t6) : t6 = $[18];
  const handleRevertChangesConfirm = t6;
  let t7;
  $[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = () => {
    setConfirmRevertOpen(!1);
  }, $[19] = t7) : t7 = $[19];
  const closeRevertChangesConfirmDialog = t7;
  let t8;
  $[20] !== changes || $[21] !== confirmRevertOpen || $[22] !== group2.key || $[23] !== group2.path.length || $[24] !== handleRevertChanges || $[25] !== hidden || $[26] !== isComparingCurrent || $[27] !== isPermissionsLoading || $[28] !== isPortableText2 || $[29] !== isRevertButtonHovered || $[30] !== permissions?.granted || $[31] !== readOnly || $[32] !== revertButtonElement ? (t8 = hidden ? null : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsxs(Stack, { space: 1, as: GroupChangeContainer, "data-ui": "group-change-content", "data-revert-group-hover": isRevertButtonHovered ? "" : void 0, "data-portable-text": isPortableText2 ? "" : void 0, children: [
      /* @__PURE__ */ jsx(Stack, { as: ChangeListWrapper, space: 5, "data-ui": "group-change-list", children: changes.map((change_0) => /* @__PURE__ */ jsx(ChangeResolver, { change: change_0, readOnly, hidden, addParentWrapper: change_0.path.length - group2.path.length > 1 }, change_0.key)) }),
      isComparingCurrent && !isPermissionsLoading && permissions?.granted && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(RevertChangesButton, { changeCount: changes.length, onClick: handleRevertChangesConfirm, ref: setRevertButtonElement, selected: confirmRevertOpen, disabled: readOnly, "data-testid": `group-change-revert-button-${group2.key}` }) })
    ] }),
    /* @__PURE__ */ jsx(RevertChangesConfirmDialog, { open: confirmRevertOpen, onConfirm: handleRevertChanges, onCancel: closeRevertChangesConfirmDialog, changeCount: changes.length, referenceElement: revertButtonElement })
  ] }), $[20] = changes, $[21] = confirmRevertOpen, $[22] = group2.key, $[23] = group2.path.length, $[24] = handleRevertChanges, $[25] = hidden, $[26] = isComparingCurrent, $[27] = isPermissionsLoading, $[28] = isPortableText2, $[29] = isRevertButtonHovered, $[30] = permissions?.granted, $[31] = readOnly, $[32] = revertButtonElement, $[33] = t8) : t8 = $[33];
  const content = t8;
  let t9;
  $[34] !== group2.schemaType ? (t9 = group2.schemaType?.jsonType === "array" && group2.schemaType.of.some(_temp2$1G), $[34] = group2.schemaType, $[35] = t9) : t9 = $[35];
  const isPortableTextGroupArray = t9;
  let t10;
  return $[36] !== FieldWrapper2 || $[37] !== content || $[38] !== groupPath || $[39] !== hidden || $[40] !== isNestedInDiff || $[41] !== isPortableTextGroupArray || $[42] !== isRevertButtonHovered || $[43] !== restProps || $[44] !== titlePath ? (t10 = hidden ? null : /* @__PURE__ */ jsxs(Stack, { space: 1, ...restProps, children: [
    /* @__PURE__ */ jsx(ChangeBreadcrumb, { titlePath }),
    isNestedInDiff || isPortableTextGroupArray ? content : /* @__PURE__ */ jsx(FieldWrapper2, { hasRevertHover: isRevertButtonHovered, path: groupPath, children: content })
  ] }), $[36] = FieldWrapper2, $[37] = content, $[38] = groupPath, $[39] = hidden, $[40] = isNestedInDiff, $[41] = isPortableTextGroupArray, $[42] = isRevertButtonHovered, $[43] = restProps, $[44] = titlePath, $[45] = t10) : t10 = $[45], t10;
}
function _temp2$1G(ofType) {
  return ofType.name === "block";
}
function _temp$3T(change) {
  return isFieldChange(change) && isPTSchemaType(change.schemaType);
}
function useHover(node) {
  const $ = c(3), [value, setValue] = useState(!1);
  let t0, t1;
  return $[0] !== node ? (t0 = () => {
    if (!node)
      return;
    const handleMouseOver = () => startTransition(() => setValue(!0)), handleMouseOut = () => startTransition(() => setValue(!1));
    return node.addEventListener("mouseover", handleMouseOver), node.addEventListener("mouseout", handleMouseOut), () => {
      node.removeEventListener("mouseover", handleMouseOver), node.removeEventListener("mouseout", handleMouseOut);
    };
  }, t1 = [node], $[0] = node, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1), value;
}
function ChangeResolver(props2) {
  const $ = c(20), {
    change,
    hidden,
    readOnly
  } = props2, {
    value: t0
  } = useDocumentChange(), value = t0 === void 0 ? Fragment : t0, t1 = value, t2 = hidden || change.schemaType?.hidden, t3 = change.type === "field" ? change.diff.toValue : void 0;
  let t4;
  $[0] !== change.path || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 ? (t4 = {
    document: t1,
    checkProperty: t2,
    checkPropertyKey: "hidden",
    value: t3,
    path: change.path
  }, $[0] = change.path, $[1] = t1, $[2] = t2, $[3] = t3, $[4] = t4) : t4 = $[4];
  const isHidden = useConditionalProperty(t4), t5 = value, t6 = readOnly || change.schemaType?.readOnly, t7 = change.type === "field" ? change.diff.toValue : void 0;
  let t8;
  $[5] !== change.path || $[6] !== t5 || $[7] !== t6 || $[8] !== t7 ? (t8 = {
    document: t5,
    checkProperty: t6,
    checkPropertyKey: "readOnly",
    value: t7,
    path: change.path
  }, $[5] = change.path, $[6] = t5, $[7] = t6, $[8] = t7, $[9] = t8) : t8 = $[9];
  const isReadOnly = useConditionalProperty(t8);
  if (isHidden)
    return null;
  if (change.type === "field") {
    let t92;
    return $[10] !== change || $[11] !== isReadOnly || $[12] !== props2.addParentWrapper ? (t92 = /* @__PURE__ */ jsx(FieldChange, { change, readOnly: isReadOnly, addParentWrapper: props2.addParentWrapper }), $[10] = change, $[11] = isReadOnly, $[12] = props2.addParentWrapper, $[13] = t92) : t92 = $[13], t92;
  }
  if (change.type === "group") {
    const t92 = `group-change-${change.fieldsetName}`;
    let t102;
    return $[14] !== change || $[15] !== isReadOnly || $[16] !== t92 ? (t102 = /* @__PURE__ */ jsx(GroupChange, { change, "data-testid": t92, readOnly: isReadOnly }), $[14] = change, $[15] = isReadOnly, $[16] = t92, $[17] = t102) : t102 = $[17], t102;
  }
  const t9 = change.type || "undefined";
  let t10;
  return $[18] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Text$1, { children: [
    "Unknown change type: ",
    /* @__PURE__ */ jsx("code", { children: t9 })
  ] }), $[18] = t9, $[19] = t10) : t10 = $[19], t10;
}
function NoChanges() {
  const $ = c(11), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("changes.no-changes-title"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", as: "h3", children: t0 }), $[2] = t0, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t ? (t2 = t("changes.no-changes-description"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, muted: !0, children: t2 }), $[6] = t2, $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== t1 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { space: 3, paddingTop: 2, children: [
    t1,
    t3
  ] }), $[8] = t1, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
}
function ChangeList(t0) {
  const $ = c(53), {
    diff,
    fields,
    schemaType
  } = t0, {
    documentId,
    isComparingCurrent,
    value
  } = useDocumentChange(), {
    selectedReleaseId
  } = usePerspective(), docOperations = useDocumentOperation(documentId, schemaType.name, selectedReleaseId), {
    path
  } = useContext(DiffContext), isRoot = path.length === 0, [confirmRevertAllOpen, setConfirmRevertAllOpen] = useState(!1), [confirmRevertAllHover, setConfirmRevertAllHover] = useState(!1), [buttonElement, _setButtonElement] = useState(null);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (element) => {
    startTransition(() => _setButtonElement(element));
  }, $[0] = t1) : t1 = $[0];
  const setButtonElement = t1, {
    t
  } = useTranslation(), t2 = value;
  let t3;
  $[1] !== path || $[2] !== schemaType.readOnly || $[3] !== t2 ? (t3 = {
    document: t2,
    value: void 0,
    checkProperty: schemaType.readOnly,
    checkPropertyKey: "readOnly",
    path
  }, $[1] = path, $[2] = schemaType.readOnly, $[3] = t2, $[4] = t3) : t3 = $[4];
  const isReadOnly = useConditionalProperty(t3);
  if (schemaType.jsonType !== "object")
    throw new Error("Only object schema types are allowed in ChangeList");
  let t4;
  $[5] !== documentId || $[6] !== schemaType.name ? (t4 = {
    id: documentId,
    type: schemaType.name,
    permission: "update"
  }, $[5] = documentId, $[6] = schemaType.name, $[7] = t4) : t4 = $[7];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t4);
  let t5;
  $[8] !== diff || $[9] !== fields || $[10] !== path || $[11] !== schemaType ? (t5 = buildObjectChangeList(schemaType, diff, path, [], {
    fieldFilter: fields
  }), $[8] = diff, $[9] = fields, $[10] = path, $[11] = schemaType, $[12] = t5) : t5 = $[12];
  const allChanges = t5;
  let t6;
  $[13] !== allChanges || $[14] !== fields ? (t6 = fields && fields.length === 0 ? [] : maybeFlatten(allChanges), $[13] = allChanges, $[14] = fields, $[15] = t6) : t6 = $[15];
  const changes = t6, rootChange = allChanges[0];
  let t7;
  $[16] !== diff || $[17] !== docOperations || $[18] !== rootChange ? (t7 = () => {
    undoChange(rootChange, diff, docOperations), setConfirmRevertAllOpen(!1);
  }, $[16] = diff, $[17] = docOperations, $[18] = rootChange, $[19] = t7) : t7 = $[19];
  const revertAllChanges = t7;
  let t8;
  $[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = () => {
    setConfirmRevertAllOpen(!0);
  }, $[20] = t8) : t8 = $[20];
  const handleRevertAllChangesClick = t8;
  let t9;
  $[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = () => {
    setConfirmRevertAllHover(!0);
  }, $[21] = t9) : t9 = $[21];
  const handleRevertAllChangesMouseEnter = t9;
  let t10;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    setConfirmRevertAllHover(!1);
  }, $[22] = t10) : t10 = $[22];
  const handleRevertAllChangesMouseLeave = t10;
  let t11;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = () => {
    setConfirmRevertAllOpen(!1);
  }, $[23] = t11) : t11 = $[23];
  const closeRevertAllChangesConfirmDialog = t11;
  if (changes.length === 0) {
    let t122;
    return $[24] !== isRoot ? (t122 = isRoot ? /* @__PURE__ */ jsx(NoChanges, {}) : null, $[24] = isRoot, $[25] = t122) : t122 = $[25], t122;
  }
  const showFooter = isRoot && changes.length > 1;
  let t12;
  if ($[26] !== changes || $[27] !== confirmRevertAllHover || $[28] !== isReadOnly) {
    let t132;
    $[30] !== confirmRevertAllHover || $[31] !== isReadOnly ? (t132 = (change) => /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ChangeResolver, { change, "data-revert-all-changes-hover": confirmRevertAllHover ? "" : void 0, readOnly: isReadOnly || change?.readOnly, hidden: change?.hidden, addParentWrapper: change.path.length > 1 }, change.key) }, change.key), $[30] = confirmRevertAllHover, $[31] = isReadOnly, $[32] = t132) : t132 = $[32], t12 = changes.map(t132), $[26] = changes, $[27] = confirmRevertAllHover, $[28] = isReadOnly, $[29] = t12;
  } else
    t12 = $[29];
  let t13;
  $[33] !== t12 ? (t13 = /* @__PURE__ */ jsx(Stack, { as: ChangeListWrapper$1, space: 5, children: t12 }), $[33] = t12, $[34] = t13) : t13 = $[34];
  let t14;
  $[35] !== isComparingCurrent || $[36] !== isPermissionsLoading || $[37] !== isReadOnly || $[38] !== permissions?.granted || $[39] !== showFooter || $[40] !== t ? (t14 = showFooter && isComparingCurrent && !isPermissionsLoading && permissions?.granted && /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Button, { tone: "critical", mode: "ghost", text: t("changes.action.revert-all-confirm"), icon: RevertIcon, onClick: handleRevertAllChangesClick, onMouseEnter: handleRevertAllChangesMouseEnter, onMouseLeave: handleRevertAllChangesMouseLeave, disabled: isReadOnly, size: "large", ref: setButtonElement }) }), $[35] = isComparingCurrent, $[36] = isPermissionsLoading, $[37] = isReadOnly, $[38] = permissions?.granted, $[39] = showFooter, $[40] = t, $[41] = t14) : t14 = $[41];
  let t15;
  $[42] !== t13 || $[43] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Stack, { space: 5, children: [
    t13,
    t14
  ] }), $[42] = t13, $[43] = t14, $[44] = t15) : t15 = $[44];
  let t16;
  $[45] !== buttonElement || $[46] !== changes.length || $[47] !== confirmRevertAllOpen || $[48] !== revertAllChanges ? (t16 = /* @__PURE__ */ jsx(RevertChangesConfirmDialog, { open: confirmRevertAllOpen, onConfirm: revertAllChanges, onCancel: closeRevertAllChangesConfirmDialog, changeCount: changes.length, referenceElement: buttonElement }), $[45] = buttonElement, $[46] = changes.length, $[47] = confirmRevertAllOpen, $[48] = revertAllChanges, $[49] = t16) : t16 = $[49];
  let t17;
  return $[50] !== t15 || $[51] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Card, { children: [
    t15,
    t16
  ] }), $[50] = t15, $[51] = t16, $[52] = t17) : t17 = $[52], t17;
}
function maybeFlatten(changes) {
  return changes.length === 1 && changes[0].type === "group" && changes[0].path.length === 0 ? changes[0].changes : changes;
}
function ChangesError(t0) {
  const $ = c(16), {
    error
  } = t0, {
    t
  } = useTranslation(), revisionNotFoundError = error instanceof MissingSinceDocumentError;
  let t1;
  $[0] !== t ? (t1 = t("changes.error-title"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", as: "h3", children: t1 }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t ? (t3 = t("changes.error-description"), $[4] = t, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, muted: !0, children: t3 }), $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== error || $[9] !== revisionNotFoundError || $[10] !== t ? (t5 = revisionNotFoundError && /* @__PURE__ */ jsx(Box, { paddingTop: 2, children: /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, muted: !0, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "changes.missing-since-document-error", t, values: {
    revisionId: error.revisionId
  }, components: {
    Break: _temp$3S
  } }) }) }), $[8] = error, $[9] = revisionNotFoundError, $[10] = t, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== t2 || $[13] !== t4 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { tone: "caution", padding: 3, children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t2,
    t4,
    t5
  ] }) }), $[12] = t2, $[13] = t4, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
}
function _temp$3S() {
  return /* @__PURE__ */ jsx("br", {});
}
const RoundedCard = styled.span.withConfig({
  displayName: "RoundedCard",
  componentId: "sc-583d6m-0"
})`border-radius:${({
  theme
}) => rem(theme.sanity.radius[1])};`, ChangeSegment = styled(Text$1).withConfig({
  displayName: "ChangeSegment",
  componentId: "sc-583d6m-1"
})`&:not([hidden]){display:inline;line-height:calc(1.25em + 2px);}&:hover{background-color:none !important;background-image:linear-gradient( to bottom,var(--card-bg-color) 0,var(--card-bg-color) 33.333%,currentColor 33.333%,currentColor 100% );background-size:1px 3px;background-repeat:repeat-x;background-position-y:bottom;padding-bottom:3px;box-shadow:0 0 0 1px var(--card-bg-color);z-index:1;}`;
function DiffStringSegment(props2) {
  const $ = c(24), {
    segment
  } = props2, {
    text
  } = segment, {
    t
  } = useTranslation();
  if (segment.action === "added") {
    const t02 = segment.annotation;
    let t12;
    $[0] !== t ? (t12 = t("changes.added-label"), $[0] = t, $[1] = t12) : t12 = $[1];
    let t2;
    $[2] !== t12 ? (t2 = {
      description: t12
    }, $[2] = t12, $[3] = t2) : t2 = $[3];
    let t3;
    $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
      textDecoration: "none"
    }, $[4] = t3) : t3 = $[4];
    let t4;
    $[5] !== text ? (t4 = /* @__PURE__ */ jsx(ChangeSegment, { as: "ins", style: t3, children: text }), $[5] = text, $[6] = t4) : t4 = $[6];
    let t5;
    return $[7] !== segment.annotation || $[8] !== t2 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(DiffCard, { annotation: t02, disableHoverEffect: !0, tooltip: t2, as: RoundedCard, children: t4 }), $[7] = segment.annotation, $[8] = t2, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
  }
  if (segment.action === "removed") {
    const t02 = segment.annotation;
    let t12;
    $[11] !== t ? (t12 = t("changes.removed-label"), $[11] = t, $[12] = t12) : t12 = $[12];
    let t2;
    $[13] !== t12 ? (t2 = {
      description: t12
    }, $[13] = t12, $[14] = t2) : t2 = $[14];
    let t3;
    $[15] !== text ? (t3 = /* @__PURE__ */ jsx(ChangeSegment, { as: "del", children: text }), $[15] = text, $[16] = t3) : t3 = $[16];
    let t4;
    return $[17] !== segment.annotation || $[18] !== t2 || $[19] !== t3 ? (t4 = /* @__PURE__ */ jsx(DiffCard, { annotation: t02, as: RoundedCard, disableHoverEffect: !0, tooltip: t2, children: t3 }), $[17] = segment.annotation, $[18] = t2, $[19] = t3, $[20] = t4) : t4 = $[20], t4;
  }
  let t0;
  $[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    display: "inline"
  }, $[21] = t0) : t0 = $[21];
  let t1;
  return $[22] !== text ? (t1 = /* @__PURE__ */ jsx(Card, { as: "span", radius: 2, style: t0, children: text }), $[22] = text, $[23] = t1) : t1 = $[23], t1;
}
function DiffString(props2) {
  const $ = c(6), {
    diff
  } = props2;
  let t0;
  $[0] !== diff.segments ? (t0 = diff.segments || [], $[0] = diff.segments, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 ? (t1 = t0.map(_temp$3R), $[2] = t0, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(Fragment$1, { children: t1 }), $[4] = t1, $[5] = t2) : t2 = $[5], t2;
}
function _temp$3R(segment, segmentIndex) {
  return /* @__PURE__ */ jsx(DiffStringSegment, { segment }, segmentIndex);
}
const MetaText = styled(Text$1).withConfig({
  displayName: "MetaText",
  componentId: "sc-7wplty-0"
})`color:inherit;`;
function MetaInfo(props2) {
  const $ = c(17), {
    title,
    action,
    icon: Icon2,
    children,
    markRemoved
  } = props2;
  let t0;
  $[0] !== Icon2 || $[1] !== markRemoved ? (t0 = Icon2 && /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(MetaText, { size: 4, forwardedAs: markRemoved ? "del" : "div", children: /* @__PURE__ */ jsx(Icon2, {}) }) }), $[0] = Icon2, $[1] = markRemoved, $[2] = t0) : t0 = $[2];
  const t1 = markRemoved ? "del" : "h3";
  let t2;
  $[3] !== t1 || $[4] !== title ? (t2 = /* @__PURE__ */ jsx(MetaText, { size: 1, weight: "medium", forwardedAs: t1, textOverflow: "ellipsis", children: title }), $[3] = t1, $[4] = title, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== action ? (t3 = action && /* @__PURE__ */ jsx("div", { children: action }), $[6] = action, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== children ? (t4 = /* @__PURE__ */ jsx(MetaText, { size: 0, textOverflow: "ellipsis", children }), $[8] = children, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== t2 || $[11] !== t3 || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Stack, { space: 2, paddingLeft: 2, children: [
    t2,
    t3,
    t4
  ] }), $[10] = t2, $[11] = t3, $[12] = t4, $[13] = t5) : t5 = $[13];
  let t6;
  return $[14] !== t0 || $[15] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { padding: 2, align: "center", children: [
    t0,
    t5
  ] }), $[14] = t0, $[15] = t5, $[16] = t6) : t6 = $[16], t6;
}
const IGNORE_KEYS = ["_key", "_type", "_weak"];
function isEmptyItem(value) {
  return Object.keys(value).every((key) => IGNORE_KEYS.includes(key));
}
function isPlainObject(obj) {
  return obj !== null && typeof obj == "object" && obj.constructor === Object;
}
function isSchemaType$3(obj) {
  return !(typeof obj != "object" || !obj || !("jsonType" in obj) || typeof obj.jsonType != "string" || !("name" in obj) || typeof obj.name != "string");
}
function identity$1(t) {
  return t;
}
function createImmutableReconcile({
  decorator = identity$1
} = {}) {
  const immutableReconcile2 = decorator(function(prev, curr) {
    if (prev === curr || prev === null || typeof prev != "object" || typeof curr != "object") return curr;
    if (Array.isArray(prev) && Array.isArray(curr)) {
      if (prev.length !== curr.length) return curr;
      const reconciled2 = curr.map((item, index) => immutableReconcile2(prev[index], item));
      return reconciled2.every((item, index) => item === prev[index]) ? prev : reconciled2;
    }
    if (isSchemaType$3(prev) || isSchemaType$3(curr) || !isPlainObject(prev) || !isPlainObject(curr)) return curr;
    const prevObj = prev, currObj = curr, reconciled = {};
    let changed = !1;
    const enumerableKeys = new Set(Object.keys(currObj));
    for (const key of Object.getOwnPropertyNames(currObj))
      if (key in prevObj) {
        const reconciledValue = immutableReconcile2(prevObj[key], currObj[key]);
        enumerableKeys.has(key) ? reconciled[key] = reconciledValue : Object.defineProperty(reconciled, key, {
          value: reconciledValue,
          enumerable: !1
        }), changed = changed || reconciledValue !== prevObj[key];
      } else
        enumerableKeys.has(key) ? reconciled[key] = currObj[key] : Object.defineProperty(reconciled, key, {
          value: currObj[key],
          enumerable: !1
        }), changed = !0;
    for (const key of Object.getOwnPropertyNames(prevObj))
      if (!(key in currObj)) {
        changed = !0;
        break;
      }
    return changed ? reconciled : prev;
  });
  return immutableReconcile2;
}
const immutableReconcile = createImmutableReconcile();
function PresenceProvider(props2) {
  const $ = c(3);
  let t0;
  return $[0] !== props2.children || $[1] !== props2.presence ? (t0 = /* @__PURE__ */ jsx(PresenceContext.Provider, { value: props2.presence, children: props2.children }), $[0] = props2.children, $[1] = props2.presence, $[2] = t0) : t0 = $[2], t0;
}
PresenceProvider.displayName = "PresenceProvider";
function useFormFieldPresence() {
  const ctx = useContext(PresenceContext);
  if (!ctx)
    throw new Error("Form context not provided");
  return ctx;
}
function useChildPresence(path, inclusive) {
  const presence = useFormFieldPresence(), prev = useRef(presence), next = immutableReconcile(
    // eslint-disable-next-line react-hooks/refs -- @todo fix later, requires research to avoid perf degradation, for now "this is fine"
    prev.current,
    presence.filter((item) => startsWith(path, item.path) && inclusive)
  );
  return prev.current = next, next;
}
function useFormBuilder() {
  const formBuilder = useContext(FormBuilderContext);
  if (!formBuilder)
    throw new Error("FormBuilder: missing context value");
  return formBuilder;
}
const getIcon = (level) => level === "error" ? /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) : level === "warning" ? /* @__PURE__ */ jsx(WarningOutlineIcon, {}) : /* @__PURE__ */ jsx(InfoOutlineIcon, {}), IconText = /* @__PURE__ */ styled(Text$1).withConfig({
  displayName: "IconText",
  componentId: "sc-1x7gq0z-0"
})(({
  theme
}) => css`
    &[data-info] {
      color: ${theme.sanity.color.muted.primary.enabled.fg};
    }

    &[data-warning] {
      color: ${theme.sanity.color.muted.caution.enabled.fg};
    }

    &[data-error] {
      color: ${theme.sanity.color.muted.critical.enabled.fg};
    }
  `);
function DefaultMarkers(props2) {
  const $ = c(10), {
    markers,
    validation: validation2,
    renderCustomMarkers
  } = props2, {
    CustomMarkers
  } = useFormBuilder().__internal.components;
  if (markers.length === 0 && validation2.length === 0)
    return null;
  let t0;
  $[0] !== validation2 ? (t0 = validation2.length > 0 && validation2.map((t12, index) => {
    const {
      message,
      level
    } = t12;
    return /* @__PURE__ */ jsxs(Flex, { children: [
      /* @__PURE__ */ jsx(Box, { marginRight: 2, marginBottom: index + 1 === validation2.length ? 0 : 2, children: /* @__PURE__ */ jsx(IconText, { size: 1, "data-error": level === "error" ? "" : void 0, "data-warning": level === "warning" ? "" : void 0, "data-info": level === "info" ? "" : void 0, children: getIcon(level) }) }),
      /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: message || "Error" }) })
    ] }, `validationItem-${index}`);
  }), $[0] = validation2, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== CustomMarkers || $[3] !== markers || $[4] !== renderCustomMarkers || $[5] !== validation2.length ? (t1 = markers.length > 0 && /* @__PURE__ */ jsxs(Box, { marginTop: validation2.length > 0 ? 3 : 0, children: [
    renderCustomMarkers && renderCustomMarkers(markers),
    !renderCustomMarkers && /* @__PURE__ */ jsx(CustomMarkers, { markers })
  ] }), $[2] = CustomMarkers, $[3] = markers, $[4] = renderCustomMarkers, $[5] = validation2.length, $[6] = t1) : t1 = $[6];
  let t2;
  return $[7] !== t0 || $[8] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    t0,
    t1
  ] }), $[7] = t0, $[8] = t1, $[9] = t2) : t2 = $[9], t2;
}
function PortableTextMemberSchemaTypesProvider(t0) {
  const $ = c(5), {
    schemaType,
    children
  } = t0;
  let t1;
  $[0] !== schemaType ? (t1 = createPortableTextMemberSchemaTypes(schemaType), $[0] = schemaType, $[1] = t1) : t1 = $[1];
  const value = t1;
  let t2;
  return $[2] !== children || $[3] !== value ? (t2 = /* @__PURE__ */ jsx(PortableTextMemberSchemaTypesContext.Provider, { value, children }), $[2] = children, $[3] = value, $[4] = t2) : t2 = $[4], t2;
}
function usePortableTextMemberSchemaTypes() {
  const context = use$2(PortableTextMemberSchemaTypesContext);
  if (!context)
    throw new Error("usePortableTextMemberSchemaTypes must be used within PortableTextMemberSchemaTypesProvider");
  return context;
}
function SelectedAnnotationsProvider(t0) {
  const $ = c(10), {
    children
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ new Map(), $[0] = t1) : t1 = $[0];
  const [annotationsMap, setAnnotationsMap] = useState(t1);
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (entry) => {
    setAnnotationsMap((prev) => {
      const next = new Map(prev);
      return next.set(entry.key, entry), next;
    });
  }, $[1] = t2) : t2 = $[1];
  const register = t2;
  let t3;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (key) => {
    setAnnotationsMap((prev_0) => {
      const next_0 = new Map(prev_0);
      return next_0.delete(key), next_0;
    });
  }, $[2] = t3) : t3 = $[2];
  const unregister = t3;
  let t4;
  $[3] !== annotationsMap ? (t4 = Array.from(annotationsMap.values()), $[3] = annotationsMap, $[4] = t4) : t4 = $[4];
  const annotations = t4;
  let t5;
  $[5] !== annotations ? (t5 = {
    register,
    unregister,
    annotations
  }, $[5] = annotations, $[6] = t5) : t5 = $[6];
  const value = t5;
  let t6;
  return $[7] !== children || $[8] !== value ? (t6 = /* @__PURE__ */ jsx(SelectedAnnotationsContext.Provider, { value, children }), $[7] = children, $[8] = value, $[9] = t6) : t6 = $[9], t6;
}
function useSelectedAnnotations() {
  const context = useContext(SelectedAnnotationsContext);
  if (!context)
    throw new Error("useSelectedAnnotations must be used within a SelectedAnnotationsProvider");
  return context;
}
function ValidationProvider(props2) {
  const $ = c(3);
  let t0;
  return $[0] !== props2.children || $[1] !== props2.validation ? (t0 = /* @__PURE__ */ jsx(ValidationContext.Provider, { value: props2.validation, children: props2.children }), $[0] = props2.children, $[1] = props2.validation, $[2] = t0) : t0 = $[2], t0;
}
function useValidationMarkers() {
  const ctx = useContext(ValidationContext);
  if (!ctx)
    throw new Error("Form context not provided");
  return ctx;
}
function useChildValidation(path, t0) {
  const $ = c(7), inclusive = t0 === void 0 ? !1 : t0, validation2 = useValidationMarkers();
  let t1;
  if ($[0] !== inclusive || $[1] !== path || $[2] !== validation2) {
    let t2;
    $[4] !== inclusive || $[5] !== path ? (t2 = (item) => startsWith(path, item.path) && (inclusive || !isEqual$2(path, item.path)), $[4] = inclusive, $[5] = path, $[6] = t2) : t2 = $[6], t1 = validation2.filter(t2).map(_temp$3Q), $[0] = inclusive, $[1] = path, $[2] = validation2, $[3] = t1;
  } else
    t1 = $[3];
  return t1;
}
function _temp$3Q(marker) {
  return {
    message: marker.message,
    level: marker.level,
    path: marker.path
  };
}
const NONEXISTENT_PATH = ["@@_NONEXISTENT_PATH_@@"];
function useMemberValidation(member) {
  const prev = useRef(null), memberValidation = member?.validation && member.validation.length > 0 ? member.validation : EMPTY_ARRAY$y, childValidation = useChildValidation(member?.path || NONEXISTENT_PATH), validation2 = useMemo(() => member?.schemaType && isBlockType(member?.schemaType) ? memberValidation : memberValidation.concat(childValidation), [childValidation, member, memberValidation]), [hasError, hasWarning, hasInfo] = useMemo(() => [validation2.filter((v) => v.level === "error").length > 0, validation2.filter((v_0) => v_0.level === "warning").length > 0, validation2.filter((v_1) => v_1.level === "info").length > 0], [validation2]), reconciled = immutableReconcile(prev.current, validation2);
  return prev.current = reconciled, useMemo(() => ({
    validation: reconciled,
    hasError,
    hasWarning,
    hasInfo
  }), [reconciled, hasError, hasWarning, hasInfo]);
}
function usePortableTextMarkers(path) {
  const $ = c(5), ctx = useContext(PortableTextMarkersContext);
  if (!ctx)
    throw new Error("Form context not provided");
  let t0;
  if ($[0] !== ctx || $[1] !== path) {
    let t1;
    $[3] !== path ? (t1 = (m) => isEqual$2(m.path, path), $[3] = path, $[4] = t1) : t1 = $[4], t0 = ctx.filter(t1), $[0] = ctx, $[1] = path, $[2] = t0;
  } else
    t0 = $[2];
  return t0;
}
function isMemberObject(member) {
  return isObjectSchemaType(member.field.schemaType);
}
function isMemberArrayOfPrimitives(member) {
  return isArraySchemaType(member.field.schemaType) && member.field.schemaType.of.every((ofType) => isPrimitiveSchemaType(ofType));
}
function isMemberArrayOfObjects(member) {
  return isArraySchemaType(member.field.schemaType) && member.field.schemaType.of.every((ofType) => isObjectSchemaType(ofType));
}
function isMemberPrimitive(member) {
  return isPrimitiveSchemaType(member.field.schemaType);
}
const SANITY_PATCH_TYPE = /* @__PURE__ */ Symbol.for("sanity.patch");
function setIfMissing(value, path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "setIfMissing",
    path,
    value
  };
}
function insert$1(items, position, path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "insert",
    path,
    position,
    items
  };
}
function set(value, path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "set",
    path,
    value
  };
}
function unset(path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "unset",
    path
  };
}
function diffMatchPatch(value, path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "diffMatchPatch",
    path,
    value
  };
}
function inc(amount = 1, path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "inc",
    path,
    value: amount
  };
}
function dec(amount = 1, path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "dec",
    path,
    value: amount
  };
}
function prefixPath(patch2, segment) {
  return {
    ...patch2,
    path: [segment, ...patch2.path]
  };
}
function usePortableTextMemberItem(key) {
  const $ = c(5), ctx = useContext(PortableTextMemberItemsContext);
  if (!ctx)
    throw new Error("Form context not provided");
  let t0;
  if ($[0] !== ctx || $[1] !== key) {
    let t1;
    $[3] !== key ? (t1 = (m) => m.key === key, $[3] = key, $[4] = t1) : t1 = $[4], t0 = ctx.find(t1), $[0] = ctx, $[1] = key, $[2] = t0;
  } else
    t0 = $[2];
  return t0;
}
function usePortableTextMemberItems() {
  const ctx = useContext(PortableTextMemberItemsContext);
  if (!ctx)
    throw new Error("Form context not provided");
  return ctx;
}
function usePortableTextMemberItemsFromProps(props2) {
  const {
    members,
    path,
    schemaType,
    renderAnnotation,
    renderField,
    renderBlock: renderBlock2,
    renderInput,
    renderItem: renderItem2,
    renderInlineBlock,
    renderPreview,
    onPathFocus
  } = props2, portableTextMemberItemsRef = useRef([]);
  return useMemo(() => {
    const result = [];
    for (const member of members)
      if (member.kind === "item")
        if (!isBlockType(member.item.schemaType))
          result.push({
            kind: "objectBlock",
            member,
            node: member.item
          });
        else {
          (member.item.validation.length > 0 || member.item.changed || member.item.presence?.length || member.open || member.item.focusPath.length || member.item.focused) && result.push({
            kind: "textBlock",
            member,
            node: member.item
          });
          const childrenField = member.item.members.find((f) => f.kind === "field" && f.name === "children");
          if (childrenField && childrenField.kind === "field" && isMemberArrayOfObjects(childrenField))
            for (const child of childrenField.field.members)
              child.kind === "item" && child.item.schemaType.name !== "span" && result.push({
                kind: "inlineObject",
                member: child,
                node: child.item
              });
          const markDefArrayMember = member.item.members.filter(isArrayOfObjectsFieldMember).find((f_0) => f_0.name === "markDefs");
          if (markDefArrayMember)
            for (const child_0 of markDefArrayMember.field.members)
              child_0.kind === "item" && child_0.item.schemaType.jsonType === "object" && result.push({
                kind: "annotation",
                member: child_0,
                node: child_0.item
              });
        }
    const items = result.map((item) => {
      const key = pathToString$1(item.node.path), existingItem = portableTextMemberItemsRef.current.find((refItem) => refItem.key === key), isObject2 = item.kind !== "textBlock";
      let input = null;
      if (isObject2 && item.member !== existingItem?.member || item.node !== existingItem?.node) {
        const _elementProps = (renderInputProps) => ({
          ...renderInputProps.elementProps,
          onFocus: () => {
          }
        }), _onPathFocus = (focusPath) => {
          const fullPath = item.member.item.path.concat(focusPath);
          focusPath.length !== 0 && onPathFocus(fullPath.slice(path.length, fullPath.length));
        }, _onChangeDisableRemoveSelf = (objectFormRenderInputProps) => (patch2) => {
          if (patch2.type === "unset" && patch2.path.length === 0) {
            objectFormRenderInputProps.onChange(set({
              _type: item.member.item.schemaType.name,
              _key: item.member.key
            }, patch2.path));
            return;
          }
          objectFormRenderInputProps.onChange(patch2);
        }, _renderInput = (renderInputProps_0) => isEqual$2(renderInputProps_0.path, item.member.item.path) ? renderInput({
          ...renderInputProps_0,
          onChange: _onChangeDisableRemoveSelf(renderInputProps_0),
          onPathFocus: _onPathFocus,
          elementProps: _elementProps(renderInputProps_0)
        }) : renderInput(renderInputProps_0), inputProps = {
          absolutePath: pathFor(item.node.path),
          includeField: !1,
          members,
          path: pathFor(path),
          renderAnnotation,
          renderBlock: renderBlock2,
          renderField,
          renderInlineBlock,
          renderInput: _renderInput,
          renderItem: renderItem2,
          renderPreview,
          schemaType
        };
        input = /* @__PURE__ */ jsx(FormInput, { ...inputProps });
      }
      return existingItem ? (existingItem.member = item.member, existingItem.node = item.node, existingItem.input = input || existingItem.input, existingItem) : {
        kind: item.kind,
        key,
        member: item.member,
        node: item.node,
        input
      };
    });
    return portableTextMemberItemsRef.current = items, items;
  }, [members, onPathFocus, path, renderAnnotation, renderBlock2, renderField, renderInlineBlock, renderInput, renderItem2, renderPreview, schemaType]);
}
const Root$z = /* @__PURE__ */ styled.span.withConfig({
  displayName: "Root",
  componentId: "sc-125kpeu-0"
})((props2) => {
  const {
    $toneKey = "default",
    theme
  } = props2;
  return css`
      text-decoration: none;
      display: inline;
      background-color: ${theme.sanity.color.selectable?.[$toneKey].enabled.bg};
      border-bottom: 1px dashed ${theme.sanity.color.selectable?.[$toneKey].enabled.fg};
      color: ${theme.sanity.color.selectable?.[$toneKey].enabled.fg};

      &[data-link] {
        border-bottom: 1px solid ${theme.sanity.color.selectable?.[$toneKey].enabled.fg};
      }

      &[data-custom-markers] {
        background-color: ${theme.sanity.color.dark ? hues.purple[950].hex : hues.purple[50].hex};
      }

      &[data-warning] {
        background-color: ${theme.sanity.color.muted.caution.hovered.bg};
      }

      &[data-error] {
        background-color: ${theme.sanity.color.muted.critical.hovered.bg};
      }
    `;
}), TooltipBox$3 = styled(Box).attrs({
  forwardedAs: "span"
}).withConfig({
  displayName: "TooltipBox",
  componentId: "sc-125kpeu-1"
})`max-width:250px;`;
function Annotation(props2) {
  const $ = c(69), {
    children,
    editorNodeFocused,
    floatingBoundary,
    focused,
    onItemClose,
    onItemOpen,
    onPathFocus,
    path,
    readOnly,
    referenceBoundary,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderCustomMarkers,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    selected,
    setElementRef,
    value
  } = props2, {
    Markers: t0
  } = useFormBuilder().__internal.components, Markers = t0 === void 0 ? DefaultMarkers : t0, editor2 = usePortableTextEditor(), schemaTypes = usePortableTextMemberSchemaTypes();
  let t1;
  $[0] !== path || $[1] !== value._key ? (t1 = path.slice(0, path.length - 2).concat(["markDefs", {
    _key: value._key
  }]), $[0] = path, $[1] = value._key, $[2] = t1) : t1 = $[2];
  const markDefPath = t1, [spanElement, setSpanElement] = useState(null);
  let t2;
  $[3] !== markDefPath ? (t2 = pathToString$1(markDefPath), $[3] = markDefPath, $[4] = t2) : t2 = $[4];
  const memberItem = usePortableTextMemberItem(t2), {
    validation: validation2
  } = useMemberValidation(memberItem?.node), markers = usePortableTextMarkers(path);
  let t3;
  $[5] !== children ? (t3 = /* @__PURE__ */ jsx("span", { "data-annotation": "", children }), $[5] = children, $[6] = t3) : t3 = $[6];
  const text = t3;
  let t4;
  $[7] !== editor2 || $[8] !== memberItem || $[9] !== onItemOpen ? (t4 = () => {
    memberItem && (PortableTextEditor.blur(editor2), onItemOpen(memberItem.node.path));
  }, $[7] = editor2, $[8] = memberItem, $[9] = onItemOpen, $[10] = t4) : t4 = $[10];
  const onOpen = t4;
  let t5;
  $[11] !== editor2 || $[12] !== onItemClose || $[13] !== schemaType || $[14] !== value ? (t5 = () => {
    onItemClose(), isEmptyItem(value) && PortableTextEditor.removeAnnotation(editor2, schemaType), PortableTextEditor.focus(editor2);
  }, $[11] = editor2, $[12] = onItemClose, $[13] = schemaType, $[14] = value, $[15] = t5) : t5 = $[15];
  const onClose = t5;
  let t6;
  $[16] !== editor2 || $[17] !== schemaType ? (t6 = () => {
    PortableTextEditor.removeAnnotation(editor2, schemaType), PortableTextEditor.focus(editor2);
  }, $[16] = editor2, $[17] = schemaType, $[18] = t6) : t6 = $[18];
  const onRemove = t6;
  let t7;
  $[19] !== Markers || $[20] !== markers || $[21] !== renderCustomMarkers || $[22] !== text || $[23] !== validation2 ? (t7 = validation2.length > 0 || markers.length > 0 ? /* @__PURE__ */ jsx(Tooltip, { placement: "bottom", portal: "default", content: /* @__PURE__ */ jsx(TooltipBox$3, { children: /* @__PURE__ */ jsx(Markers, { markers, renderCustomMarkers, validation: validation2 }) }), children: text }) : void 0, $[19] = Markers, $[20] = markers, $[21] = renderCustomMarkers, $[22] = text, $[23] = validation2, $[24] = t7) : t7 = $[24];
  const markersToolTip = t7, presence = useChildPresence(path, !0);
  let t8;
  if ($[25] !== path || $[26] !== presence) {
    let t92;
    $[28] !== path ? (t92 = (p) => isEqual$2(p.path, path), $[28] = path, $[29] = t92) : t92 = $[29], t8 = presence.filter(t92), $[25] = path, $[26] = presence, $[27] = t8;
  } else
    t8 = $[27];
  const rootPresence = t8, isOpen = !!memberItem?.member.open, input = memberItem?.input, nodePath = memberItem?.node.path || EMPTY_ARRAY$y, referenceElement = spanElement, t9 = schemaTypes.block, t10 = !!readOnly, t11 = markersToolTip || text;
  let t12;
  $[30] !== editorNodeFocused || $[31] !== floatingBoundary || $[32] !== focused || $[33] !== input || $[34] !== isOpen || $[35] !== markers || $[36] !== nodePath || $[37] !== onClose || $[38] !== onOpen || $[39] !== onPathFocus || $[40] !== onRemove || $[41] !== referenceBoundary || $[42] !== referenceElement || $[43] !== renderAnnotation || $[44] !== renderBlock2 || $[45] !== renderField || $[46] !== renderInlineBlock || $[47] !== renderInput || $[48] !== renderItem2 || $[49] !== renderPreview || $[50] !== rootPresence || $[51] !== schemaType || $[52] !== schemaTypes.block || $[53] !== selected || $[54] !== t10 || $[55] !== t11 || $[56] !== validation2 || $[57] !== value ? (t12 = {
    __unstable_floatingBoundary: floatingBoundary,
    __unstable_referenceBoundary: referenceBoundary,
    __unstable_referenceElement: referenceElement,
    __unstable_textElementFocus: editorNodeFocused,
    children: input,
    focused,
    markers,
    onClose,
    onOpen,
    onPathFocus,
    onRemove,
    open: isOpen,
    parentSchemaType: t9,
    path: nodePath,
    presence: rootPresence,
    readOnly: t10,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderPreview,
    renderItem: renderItem2,
    renderDefault: DefaultAnnotationComponent,
    schemaType,
    selected,
    textElement: t11,
    validation: validation2,
    value
  }, $[30] = editorNodeFocused, $[31] = floatingBoundary, $[32] = focused, $[33] = input, $[34] = isOpen, $[35] = markers, $[36] = nodePath, $[37] = onClose, $[38] = onOpen, $[39] = onPathFocus, $[40] = onRemove, $[41] = referenceBoundary, $[42] = referenceElement, $[43] = renderAnnotation, $[44] = renderBlock2, $[45] = renderField, $[46] = renderInlineBlock, $[47] = renderInput, $[48] = renderItem2, $[49] = renderPreview, $[50] = rootPresence, $[51] = schemaType, $[52] = schemaTypes.block, $[53] = selected, $[54] = t10, $[55] = t11, $[56] = validation2, $[57] = value, $[58] = t12) : t12 = $[58];
  const componentProps = t12, CustomComponent = schemaType.components?.annotation;
  let t13;
  $[59] !== memberItem || $[60] !== setElementRef ? (t13 = (elm) => {
    memberItem && setElementRef({
      key: memberItem.member.key,
      elementRef: elm
    }), setSpanElement(elm);
  }, $[59] = memberItem, $[60] = setElementRef, $[61] = t13) : t13 = $[61];
  const setRef = t13;
  let t14;
  $[62] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t14 = void 0, $[62] = t14) : t14 = $[62];
  let t15;
  $[63] !== CustomComponent || $[64] !== componentProps ? (t15 = CustomComponent ? /* @__PURE__ */ jsx(CustomComponent, { ...componentProps }) : /* @__PURE__ */ jsx(DefaultAnnotationComponent, { ...componentProps }), $[63] = CustomComponent, $[64] = componentProps, $[65] = t15) : t15 = $[65];
  let t16;
  return $[66] !== setRef || $[67] !== t15 ? (t16 = /* @__PURE__ */ jsx("span", { ref: setRef, style: t14, children: t15 }), $[66] = setRef, $[67] = t15, $[68] = t16) : t16 = $[68], t16;
}
const DefaultAnnotationComponent = (props2) => {
  const $ = c(30), {
    __unstable_referenceElement: referenceElement,
    markers,
    onOpen,
    onRemove,
    open,
    readOnly,
    schemaType,
    selected,
    textElement,
    validation: validation2,
    value
  } = props2, isLink = schemaType.name === "link", hasError = validation2.some(_temp$3P), hasWarning = validation2.some(_temp2$1F), hasMarkers = markers.length > 0, {
    t
  } = useTranslation(), {
    register,
    unregister
  } = useSelectedAnnotations();
  let t0;
  $[0] !== schemaType.i18nTitleKey || $[1] !== schemaType.name || $[2] !== schemaType.title || $[3] !== t ? (t0 = schemaType.i18nTitleKey ? t(schemaType.i18nTitleKey) : schemaType.title || schemaType.name, $[0] = schemaType.i18nTitleKey, $[1] = schemaType.name, $[2] = schemaType.title, $[3] = t, $[4] = t0) : t0 = $[4];
  let t1;
  $[5] !== onOpen || $[6] !== onRemove || $[7] !== referenceElement || $[8] !== schemaType || $[9] !== t0 || $[10] !== value._key ? (t1 = {
    key: value._key,
    title: t0,
    schemaType,
    onOpen,
    onRemove,
    referenceElement
  }, $[5] = onOpen, $[6] = onRemove, $[7] = referenceElement, $[8] = schemaType, $[9] = t0, $[10] = value._key, $[11] = t1) : t1 = $[11];
  const annotationEntry = t1;
  let t2, t3;
  $[12] !== annotationEntry || $[13] !== open || $[14] !== register || $[15] !== selected || $[16] !== unregister ? (t2 = () => selected && !open ? (register(annotationEntry), () => unregister(annotationEntry.key)) : () => unregister(annotationEntry.key), t3 = [selected, open, annotationEntry, register, unregister], $[12] = annotationEntry, $[13] = open, $[14] = register, $[15] = selected, $[16] = unregister, $[17] = t2, $[18] = t3) : (t2 = $[17], t3 = $[18]), useEffect(t2, t3);
  let t4;
  bb0: {
    if (hasError) {
      t4 = "critical";
      break bb0;
    }
    if (hasWarning) {
      t4 = "caution";
      break bb0;
    }
    if (isLink) {
      t4 = "primary";
      break bb0;
    }
    t4 = "default";
  }
  const toneKey = t4;
  let t5;
  $[19] !== t ? (t5 = t("inputs.portable-text.annotation-aria-label"), $[19] = t, $[20] = t5) : t5 = $[20];
  const t6 = isLink ? "" : void 0, t7 = hasError ? "" : void 0, t8 = hasWarning ? "" : void 0, t9 = hasMarkers || void 0, t10 = readOnly ? onOpen : void 0;
  let t11;
  return $[21] !== t10 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9 || $[27] !== textElement || $[28] !== toneKey ? (t11 = /* @__PURE__ */ jsx(Root$z, { $toneKey: toneKey, "aria-label": t5, "data-link": t6, "data-error": t7, "data-warning": t8, "data-markers": t9, onClick: t10, children: textElement }), $[21] = t10, $[22] = t5, $[23] = t6, $[24] = t7, $[25] = t8, $[26] = t9, $[27] = textElement, $[28] = toneKey, $[29] = t11) : t11 = $[29], t11;
};
function _temp$3P(v) {
  return v.level === "error";
}
function _temp2$1F(v_0) {
  return v_0.level === "warning";
}
function createStore(reportedValues, publish2) {
  function add(id2, value) {
    reportedValues.has(id2), reportedValues.set(id2, value), publish2();
  }
  function update(id2, value) {
    reportedValues.has(id2), reportedValues.set(id2, value), publish2();
  }
  function remove2(id2) {
    reportedValues.has(id2), reportedValues.delete(id2), publish2();
  }
  return {
    add,
    remove: remove2,
    update
  };
}
function useTrackerStore() {
  const $ = c(9), [reportedValues] = useState(_temp$3O);
  let t0;
  $[0] !== reportedValues ? (t0 = () => Array.from(reportedValues.entries()), $[0] = reportedValues, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[2] = t1) : t1 = $[2];
  const [snapshot2, updateSnapshot] = useReducer(t0, t1);
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = debounce(updateSnapshot, 10, {
    trailing: !0
  }), $[3] = t2) : t2 = $[3];
  const debouncedUpdateSnapshot = t2;
  let t3;
  $[4] !== reportedValues ? (t3 = createStore(reportedValues, debouncedUpdateSnapshot), $[4] = reportedValues, $[5] = t3) : t3 = $[5];
  const store = t3;
  let t4;
  return $[6] !== snapshot2 || $[7] !== store ? (t4 = {
    store,
    snapshot: snapshot2
  }, $[6] = snapshot2, $[7] = store, $[8] = t4) : t4 = $[8], t4;
}
function _temp$3O() {
  return /* @__PURE__ */ new Map();
}
function useTrackerStoreReporter(store, id2, value, t0) {
  const $ = c(10), isEqual2 = t0 === void 0 ? Object.is : t0, idRef = useRef(null), previousRef = useRef(null);
  let t1, t2;
  $[0] !== id2 || $[1] !== store || $[2] !== value ? (t1 = () => {
    if (id2 === null || store === null)
      return;
    const nextValue = value();
    return store.add(id2, nextValue), idRef.current = id2, previousRef.current = nextValue, () => {
      store.remove(id2), idRef.current = null, previousRef.current = null;
    };
  }, t2 = [id2, store, value], $[0] = id2, $[1] = store, $[2] = value, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]), useLayoutEffect(t1, t2);
  let t3;
  $[5] !== id2 || $[6] !== isEqual2 || $[7] !== store || $[8] !== value ? (t3 = () => {
    if (id2 === null || idRef.current === null || store === null || id2 !== idRef.current)
      return;
    const nextValue_0 = value();
    isEqual2(previousRef.current, nextValue_0) || (store.update(id2, nextValue_0), previousRef.current = nextValue_0);
  }, $[5] = id2, $[6] = isEqual2, $[7] = store, $[8] = value, $[9] = t3) : t3 = $[9], useLayoutEffect(t3);
}
function ChangeIndicatorsTrackerComponent(props2) {
  const $ = c(6), {
    children
  } = props2, {
    store,
    snapshot: snapshot2
  } = useTrackerStore();
  let t0;
  $[0] !== children || $[1] !== snapshot2 ? (t0 = /* @__PURE__ */ jsx(ChangeIndicatorTrackerContextGetSnapshot.Provider, { value: snapshot2, children }), $[0] = children, $[1] = snapshot2, $[2] = t0) : t0 = $[2];
  let t1;
  return $[3] !== store || $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(ChangeIndicatorTrackerContextStore.Provider, { value: store, children: t0 }), $[3] = store, $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}
const ChangeIndicatorsTracker = memo(ChangeIndicatorsTrackerComponent), EMPTY_ARRAY$v = [];
function useChangeIndicatorsReportedValues() {
  const snapshot2 = useContext(ChangeIndicatorTrackerContextGetSnapshot);
  return snapshot2 === null ? (console.warn(new Error('No context provided for reporter. Make sure that the component calling "useChangeIndicatorsReportedValues()", is wrapped inside a <ChangeIndicatorsTracker> element')), EMPTY_ARRAY$v) : snapshot2;
}
const useChangeIndicatorsReporter = (id2, value, isEqual2) => {
  const store = useContext(ChangeIndicatorTrackerContextStore);
  store === null && console.warn(new Error('No context provided for reporter. Make sure that the component calling "useChangeIndicatorsReporter()", is wrapped inside a <ChangeIndicatorsTracker> element')), useTrackerStoreReporter(store, id2, value, isEqual2);
};
function useHoveredChange() {
  const $ = c(2), reportedValues = useChangeIndicatorsReportedValues();
  let t0;
  $[0] !== reportedValues ? (t0 = reportedValues.filter(_temp$3N).sort(_temp2$1E), $[0] = reportedValues, $[1] = t0) : t0 = $[1];
  const hoveredEntry = t0[0];
  if (hoveredEntry) {
    const [, change_0] = hoveredEntry;
    return change_0;
  }
}
function _temp2$1E(a, b) {
  return b[1].path.length - a[1].path.length;
}
function _temp$3N(t0) {
  const [, change] = t0;
  return change.hasHover;
}
const FormCallbacksProvider = memo(function(props2) {
  const $ = c(14), ref = useRef(props2);
  let t0, t1;
  $[0] !== props2 ? (t0 = () => {
    ref.current = props2;
  }, t1 = [props2], $[0] = props2, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (patches) => ref.current?.transformPatches?.(patches) ?? [], $[3] = t2) : t2 = $[3];
  const transformPatches = t2;
  let t3;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (patchEvent) => {
    ref.current.onChange(patchEvent);
  }, $[4] = t3) : t3 = $[4];
  const onChange = t3;
  let t4;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = (path, payload) => {
    ref.current.onPathFocus(path, payload);
  }, $[5] = t4) : t4 = $[5];
  const onPathFocus = t4;
  let t5;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = (path_0) => {
    ref.current.onPathBlur(path_0);
  }, $[6] = t5) : t5 = $[6];
  const onPathBlur = t5;
  let t6;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = (path_1) => {
    ref.current.onPathOpen(path_1);
  }, $[7] = t6) : t6 = $[7];
  const onPathOpen = t6;
  let t7;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = (path_2, collapsed) => {
    ref.current.onSetPathCollapsed(path_2, collapsed);
  }, $[8] = t7) : t7 = $[8];
  const onSetPathCollapsed = t7;
  let t8;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = (path_3, collapsed_0) => {
    ref.current.onSetFieldSetCollapsed(path_3, collapsed_0);
  }, $[9] = t8) : t8 = $[9];
  const onSetFieldSetCollapsed = t8;
  let t9;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = (path_4, fieldGroupName) => {
    ref.current.onFieldGroupSelect(path_4, fieldGroupName);
  }, $[10] = t9) : t9 = $[10];
  const onFieldGroupSelect = t9;
  let t10;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    transformPatches,
    onChange,
    onPathFocus,
    onPathBlur,
    onPathOpen,
    onSetPathCollapsed,
    onSetFieldSetCollapsed,
    onFieldGroupSelect
  }, $[11] = t10) : t10 = $[11];
  const contextValue = t10;
  let t11;
  return $[12] !== props2.children ? (t11 = /* @__PURE__ */ jsx(FormCallbacksContext.Provider, { value: contextValue, children: props2.children }), $[12] = props2.children, $[13] = t11) : t11 = $[13], t11;
});
function useFormCallbacks() {
  const ctx = useContext(FormCallbacksContext);
  if (!ctx)
    throw new Error("Form context not provided");
  return ctx;
}
function useReferenceInputOptions() {
  return useContext(ReferenceInputOptionsContext);
}
function ReferenceInputOptionsProvider(props2) {
  const $ = c(9), {
    children,
    activePath,
    EditReferenceLinkComponent,
    onEditReference,
    initialValueTemplateItems,
    disableNew
  } = props2;
  let t0;
  $[0] !== EditReferenceLinkComponent || $[1] !== activePath || $[2] !== disableNew || $[3] !== initialValueTemplateItems || $[4] !== onEditReference ? (t0 = {
    activePath,
    EditReferenceLinkComponent,
    onEditReference,
    initialValueTemplateItems,
    disableNew
  }, $[0] = EditReferenceLinkComponent, $[1] = activePath, $[2] = disableNew, $[3] = initialValueTemplateItems, $[4] = onEditReference, $[5] = t0) : t0 = $[5];
  const contextValue = t0;
  let t1;
  return $[6] !== children || $[7] !== contextValue ? (t1 = /* @__PURE__ */ jsx(ReferenceInputOptionsContext.Provider, { value: contextValue, children }), $[6] = children, $[7] = contextValue, $[8] = t1) : t1 = $[8], t1;
}
function pathToAnchorIdent(type, path) {
  return [`--${type}`, toString(path).replaceAll(/[^a-z|0-9]+/gi, "_").toLocaleLowerCase()].join("_");
}
const DivergenceIndicator = (t0) => {
  const $ = c(23), {
    divergence,
    divergenceNavigator,
    path,
    upstreamBundle
  } = t0, {
    t
  } = useTranslation();
  let t1, t2, t3;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    opacity: 0
  }, t2 = {
    opacity: 0
  }, t3 = {
    opacity: 1
  }, $[0] = t1, $[1] = t2, $[2] = t3) : (t1 = $[0], t2 = $[1], t3 = $[2]);
  const t4 = typeof upstreamBundle == "string" ? upstreamBundle : upstreamBundle?.metadata.title;
  let t5;
  $[3] !== t || $[4] !== t4 ? (t5 = t("divergence.unresolved-divergence", {
    count: 1,
    versionName: t4
  }), $[3] = t, $[4] = t4, $[5] = t5) : t5 = $[5];
  let t6;
  $[6] !== divergence.path || $[7] !== divergenceNavigator ? (t6 = () => divergenceNavigator.state.focusedDivergence === divergence.path ? divergenceNavigator.blurFocusedDivergence() : divergenceNavigator.focusDivergence(divergence.path), $[6] = divergence.path, $[7] = divergenceNavigator, $[8] = t6) : t6 = $[8];
  const t7 = divergenceNavigator.state.focusedDivergence === divergence.path, t8 = typeof upstreamBundle == "string" ? upstreamBundle : upstreamBundle?.metadata.title;
  let t9;
  $[9] !== t || $[10] !== t8 ? (t9 = t("divergence.unresolved-divergence", {
    count: 1,
    versionName: t8
  }), $[9] = t, $[10] = t8, $[11] = t9) : t9 = $[11];
  let t10;
  $[12] !== t9 ? (t10 = {
    content: t9,
    placement: "left"
  }, $[12] = t9, $[13] = t10) : t10 = $[13];
  const t11 = upstreamBundle === "published" ? "positive" : "suggest";
  let t12;
  $[14] !== t10 || $[15] !== t11 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 ? (t12 = /* @__PURE__ */ jsx(Button, { "aria-label": t5, onClick: t6, selected: t7, mode: "bleed", icon: EditIcon, tooltipProps: t10, radius: "full", tone: t11 }), $[14] = t10, $[15] = t11, $[16] = t5, $[17] = t6, $[18] = t7, $[19] = t12) : t12 = $[19];
  let t13;
  return $[20] !== path || $[21] !== t12 ? (t13 = /* @__PURE__ */ jsx(Container$2, { path, initial: t1, exit: t2, animate: t3, children: t12 }), $[20] = path, $[21] = t12, $[22] = t13) : t13 = $[22], t13;
}, Container$2 = styled(motion.div).withConfig({
  displayName: "Container",
  componentId: "sc-1wecgz0-0"
})`@supports (position-anchor:--anchor){position:absolute;${({
  path
}) => path ? `position-anchor: ${pathToAnchorIdent("input", path)};` : void 0} inset-block-start:anchor(center);transform:translateY(-50%);line-height:0;}`;
function getOption(type, optionName) {
  return get(type.options, optionName);
}
const PSEUDO_OBJECTS = ["array", "file", "image", "reference", "slug"], HIDDEN_FIELDS = ["asset", "crop", "hotspot", "_ref", "_weak", "media"], NO_LEVEL_LAYOUTS = ["tags"], NO_LEVEL_TYPES = ["slug"];
function getTypeChain$2(type, visited) {
  if (!type) return [];
  if (visited.has(type)) return [];
  visited.add(type);
  const next = type.type ? getTypeChain$2(type.type, visited) : [];
  return [type, ...next];
}
function getFieldLevel(schemaType, currentLevel) {
  return isArraySchemaType(schemaType) ? getArrayFieldLevel(schemaType, currentLevel) : getObjectFieldLevel(schemaType, currentLevel);
}
function getObjectFieldLevel(schemaType, currentLevel) {
  const {
    type,
    options
  } = schemaType, typeIfRelevant = asType(type, PSEUDO_OBJECTS), fields = schemaType?.jsonType === "object" ? schemaType.fields : void 0, typeName = typeIfRelevant?.name || "";
  if (NO_LEVEL_TYPES.includes(typeName))
    return 0;
  const isPseudoObject = PSEUDO_OBJECTS.includes(typeName), hasVisibleFields = (fields?.filter((f) => !HIDDEN_FIELDS.includes(f.name)).length ?? 0) > 0, hasListOptions2 = (options?.list?.length ?? 0) > 0;
  return hasVisibleFields || hasListOptions2 || !isPseudoObject ? currentLevel : 0;
}
function getArrayFieldLevel(schemaType, currentLevel) {
  const {
    options
  } = schemaType, hasListOptions2 = (options?.list || [])?.length > 0, isNoLevelLayout = NO_LEVEL_LAYOUTS.includes(options?.layout || "");
  return hasListOptions2 && !isNoLevelLayout ? currentLevel : 0;
}
function asType(schemaType, asOneOfTypes) {
  if (schemaType?.name && asOneOfTypes.includes(schemaType?.name))
    return schemaType;
  if (schemaType)
    return asType(schemaType.type, asOneOfTypes);
}
function* flattenObject(object, {
  compact: compact2 = !1
} = {}, path = [], pathWithTypes = []) {
  path.length !== 0 && !compact2 && (yield [toString(path), object, {
    flatPathArray: path,
    flatPathArrayWithTypes: pathWithTypes
  }]);
  for (const [key, value] of Object.entries(object)) {
    const currentPath = path.concat(key), currentPathWithTypes = pathWithTypes.concat({
      segment: key,
      type: readType(value)
    });
    if (Array.isArray(value)) {
      yield* flattenArray(value, {
        compact: compact2
      }, currentPath, currentPathWithTypes);
      continue;
    }
    if (typeof value == "object" && value !== null) {
      isRecord$4(value) && (yield* flattenObject(value, {
        compact: compact2
      }, currentPath, currentPathWithTypes));
      continue;
    }
    yield [toString(currentPath), value, {
      flatPathArray: currentPath,
      flatPathArrayWithTypes: currentPathWithTypes
    }];
  }
}
function* flattenArray(array, {
  compact: compact2 = !1
} = {}, path = [], pathWithTypes = []) {
  path.length !== 0 && !compact2 && (yield [toString(path), array, {
    flatPathArray: path,
    flatPathArrayWithTypes: pathWithTypes
  }]);
  for (const [index, value] of array.entries()) {
    if (Array.isArray(value))
      continue;
    if (typeof value == "object" && value !== null) {
      isKeyedObject(value) && (yield* flattenObject(value, {
        compact: compact2
      }, path.concat({
        _key: value._key
      }), pathWithTypes.concat({
        segment: value._key,
        type: readType(value)
      })));
      continue;
    }
    const currentPath = path.concat(index), currentPathWithTypes = pathWithTypes.concat({
      segment: index,
      type: readType(value)
    });
    yield [toString(currentPath), value, {
      flatPathArray: currentPath,
      flatPathArrayWithTypes: currentPathWithTypes
    }];
  }
}
function readType(value) {
  return isRecord$4(value) && "_type" in value && typeof value._type == "string" ? value._type : Array.isArray(value) ? "array" : typeof value;
}
function normalizePathSegment(segment) {
  return typeof segment == "object" && "type" in segment ? segment : {
    segment
  };
}
function* introspectSchema(schemaType, path, cache2 = /* @__PURE__ */ new WeakMap(), fullyQualifiedPath = []) {
  const [head, ...tail] = path;
  if (typeof schemaType > "u" || typeof head > "u")
    return;
  const nextFullyQualifiedPath = fullyQualifiedPath.concat(head), cacheKey = JSON.stringify(nextFullyQualifiedPath);
  let cachedSchemaType = cache2.get(schemaType);
  typeof cachedSchemaType > "u" && (cachedSchemaType = {}, cache2.set(schemaType, cachedSchemaType));
  const cachedPath = cachedSchemaType?.[cacheKey], {
    segment: headSegment,
    type: headType
  } = normalizePathSegment(head);
  let headSchemaType;
  if (typeof cachedPath < "u")
    headSchemaType = cachedPath;
  else {
    if (isObjectSchemaType(schemaType) && (headSchemaType = schemaType.fields.find((field) => field.name === headSegment)?.type), isArraySchemaType(schemaType)) {
      if (schemaType.of.length === 0)
        throw new Error(`Array schema at segment \`${JSON.stringify(headSegment)}\` has no constituent types`);
      if (schemaType.of.length === 1)
        headSchemaType = schemaType.of[0];
      else {
        if (typeof headType > "u")
          throw new Error(`No type hint provided for polymorphic array segment: \`${JSON.stringify(headSegment)}\``);
        headSchemaType = schemaType.of.find((type) => getTypeChain$2(type, /* @__PURE__ */ new Set()).some(({
          name
        }) => name === headType));
      }
    }
    if (typeof headSchemaType > "u")
      throw new Error(`Could not resolve schema segment: \`${JSON.stringify(headSegment)}\``);
    cachedSchemaType[cacheKey] = headSchemaType;
  }
  yield headSchemaType, yield* introspectSchema(headSchemaType, tail, cache2, nextFullyQualifiedPath);
}
function isObjectFormNode(formNode) {
  return isObjectSchemaType(formNode.schemaType);
}
function isArrayOfObjectsFormNode(formNode) {
  return isArrayOfObjectsSchemaType(formNode.schemaType);
}
function isArrayOfPrimitivesFormNode(formNode) {
  return isArrayOfPrimitivesSchemaType(formNode.schemaType);
}
function readOrderedFormMembers({
  groups,
  members = []
}) {
  const hasGroups = typeof groups < "u", grouplessMembers = from(members).pipe(filter$1(isFieldMember), filter$1(({
    groups: memberGroups
  }) => typeof groups > "u" ? !0 : !groups.some((group2) => memberGroups.some((memberGroup) => memberGroup === group2.name)))), source = hasGroups ? from(groups).pipe(switchMap$1((group2) => from(members).pipe(filter$1(isFieldMember), filter$1(({
    groups: memberGroups
  }) => memberGroups.includes(group2.name))))) : from(members);
  return merge(grouplessMembers, source).pipe(filter$1(isFieldOrArrayMember), map$1((member) => [selectSubject(member).path, member]), mergeMap$1((memberAtPath) => {
    const [, member] = memberAtPath, subject = selectSubject(member);
    return isObjectFormNode(subject) ? of(memberAtPath).pipe(concatWith(readOrderedFormMembers({
      groups: subject.groups,
      members: subject._allMembers
    }))) : isArrayOfObjectsFormNode(subject) || isArrayOfPrimitivesFormNode(subject) ? of(memberAtPath).pipe(concatWith(readOrderedFormMembers({
      members: subject.members
    }))) : of(memberAtPath);
  }));
}
function selectSubject(member) {
  return member.kind === "field" ? member.field : member.item;
}
function isFieldMemberLike(maybeFieldMemberLike) {
  return typeof maybeFieldMemberLike == "object" && maybeFieldMemberLike !== null && "kind" in maybeFieldMemberLike && typeof maybeFieldMemberLike.kind == "string";
}
function isFieldMember(maybeFieldMember) {
  return isFieldMemberLike(maybeFieldMember) && maybeFieldMember.kind === "field";
}
function isFieldOrArrayMember(maybeFieldOrArrayMember) {
  return isFieldMemberLike(maybeFieldOrArrayMember) && ["field", "item"].includes(maybeFieldOrArrayMember.kind);
}
function transposeSchema(divergences, schemaType, formState) {
  return readOrderedFormMembers({
    groups: formState.groups,
    members: formState._allMembers
  }).pipe(map$1(([path]) => {
    const pathString = toString(path), divergenceAtPath = divergences[pathString];
    return [pathString, divergenceAtPath];
  }), filter$1(([, divergence]) => typeof divergence < "u"), filter$1(([, divergence]) => divergence.status === "unresolved"), switchMap$1(([path, divergence]) => combineLatest({
    path: of(path),
    divergence: of(divergence),
    pathSchemaTypes: from(introspectSchema(schemaType, divergence.snapshots.subjectHead?.pathWithTypes ?? divergence.snapshots.upstreamHead?.pathWithTypes ?? fromString(path))).pipe(
      toArray$2(),
      // Divergences can affect fields that aren't present in the schema. In this scenario,
      // `introspectSchema` throws an error. This behaviour is expected, because divergences are
      // computed by comparing raw document data.
      //
      // When this occurs, the divergence is x and a warning is logged.
      catchError$1((error) => (console.warn(error), of([])))
    )
  })), filter$1(isSupportedNode)).pipe(reduce$1((transposed, {
    path,
    pathSchemaTypes,
    divergence
  }) => {
    const pathSegments = fromString(path), divergenceSchemaType = pathSchemaTypes.at(-1);
    if (typeof divergenceSchemaType > "u")
      return transposed;
    let compositeNodePath, compositeNodeDiffComponent, compositeNodeSchemaType;
    for (let index = 0; index < pathSegments.length; index++) {
      const currentPathSegments = pathSegments.slice(0, index + 1), currentSchemaType = pathSchemaTypes[index], parentSchemaType2 = pathSchemaTypes[index - 1];
      if (typeof currentSchemaType > "u")
        break;
      const diffComponent = isArraySchemaType(currentSchemaType) || isObjectSchemaType(currentSchemaType) ? resolveDiffComponent(currentSchemaType, isObjectSchemaType(parentSchemaType2) || isArraySchemaType(parentSchemaType2) ? parentSchemaType2 : void 0) : void 0;
      if (typeof diffComponent < "u") {
        compositeNodePath = currentPathSegments, compositeNodeDiffComponent = diffComponent, compositeNodeSchemaType = currentSchemaType;
        break;
      }
    }
    if (typeof compositeNodePath < "u" && typeof compositeNodeSchemaType < "u" && typeof compositeNodeDiffComponent < "u")
      return transposed[toString(compositeNodePath)] ??= {
        ...divergence,
        path: toString(compositeNodePath),
        isComposite: !0,
        divergences: [],
        schemaType: compositeNodeSchemaType,
        diffComponent: compositeNodeDiffComponent
      }, transposed[toString(compositeNodePath)].divergences.push([divergence.path, divergence]), transposed;
    const parentSchemaType = pathSchemaTypes.at(-2);
    return transposed[path] ??= {
      ...divergence,
      isComposite: !1,
      divergences: [],
      schemaType: divergenceSchemaType,
      diffComponent: resolveDiffComponent(divergenceSchemaType, isObjectSchemaType(parentSchemaType) || isArraySchemaType(parentSchemaType) ? parentSchemaType : void 0)
    }, transposed[path].divergences.push([divergence.path, divergence]), transposed;
  }, {}), mergeMap$1((transposed) => from(Object.entries(transposed))), toArray$2(), map$1((reachableDivergences) => {
    const divergencesByNode = reachableDivergences.reduce((state, [path]) => {
      const pathSegments = fromString(path);
      for (let index = 0; index < pathSegments.length; index++) {
        const currentPathSegments = pathSegments.slice(0, index + 1), currentPath = toString(currentPathSegments);
        state[currentPath] ??= 0, state[currentPath]++;
      }
      return state;
    }, {});
    return {
      divergences: reachableDivergences,
      divergencesByNode
    };
  }));
}
function isSupportedNode({
  pathSchemaTypes
}) {
  const parentSchemaType = pathSchemaTypes.at(-2), isArrayListOption = isArrayOfPrimitivesSchemaType(parentSchemaType) && Array.isArray(parentSchemaType?.options?.list), isArrayTag = (isArrayOfStringsSchemaType(parentSchemaType) && parentSchemaType?.options && parentSchemaType.options.layout === "tags") ?? !1;
  return !isArrayListOption && !isArrayTag;
}
function useDivergenceNavigator(t0) {
  const $ = c(19), {
    divergences,
    schemaType,
    formState
  } = t0, {
    advancedVersionControl: t1
  } = useWorkspace(), {
    enabled: advancedVersionControlEnabled
  } = t1;
  let t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = new Subject(), $[0] = t2) : t2 = $[0];
  const dispatch = t2;
  let t3;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = new BehaviorSubject(void 0), $[1] = t3) : t3 = $[1];
  const schemaTypeContext = t3;
  let t4, t5;
  $[2] !== schemaType ? (t4 = () => schemaTypeContext.next(schemaType), t5 = [schemaTypeContext, schemaType], $[2] = schemaType, $[3] = t4, $[4] = t5) : (t4 = $[3], t5 = $[4]), useEffect(t4, t5);
  let t6;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = new BehaviorSubject(void 0), $[5] = t6) : t6 = $[5];
  const formStateContext = t6;
  let t7, t8;
  $[6] !== formState ? (t7 = () => formStateContext.next(formState), t8 = [formStateContext, formState], $[6] = formState, $[7] = t7, $[8] = t8) : (t7 = $[7], t8 = $[8]), useEffect(t7, t8);
  let t9;
  bb0: {
    if (!advancedVersionControlEnabled) {
      t9 = EMPTY$5;
      break bb0;
    }
    let t102;
    $[9] !== divergences ? (t102 = combineLatest({
      divergences,
      schemaType: schemaTypeContext.pipe(filter$1(_temp$3M)),
      formState: formStateContext.pipe(filter$1(_temp2$1D), first$1(), map$1(_temp3$N))
    }), $[9] = divergences, $[10] = t102) : t102 = $[10], t9 = t102;
  }
  const context = t9;
  let t10;
  $[11] !== context ? (t10 = createStateReducer({
    dispatch,
    context
  }), $[11] = context, $[12] = t10) : t10 = $[12];
  const readState = t10;
  let t11;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = (path) => {
    dispatch.next({
      type: "FOCUS",
      context: {
        path
      }
    });
  }, $[13] = t11) : t11 = $[13];
  const focusDivergence = t11;
  let t12;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = (path_0) => {
    dispatch.next({
      type: "BLUR",
      context: {
        path: path_0
      }
    });
  }, $[14] = t12) : t12 = $[14];
  const blurDivergence = t12;
  let t13;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = () => {
    dispatch.next({
      type: "BLUR_FOCUSED"
    });
  }, $[15] = t13) : t13 = $[15];
  const blurFocusedDivergence = t13;
  let t14;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t14 = {
    focusedDivergence: void 0,
    previousDivergence: void 0,
    nextDivergence: void 0,
    upstreamId: void 0,
    state: "pending",
    divergences: [],
    allDivergences: [],
    divergencesByNode: {}
  }, $[16] = t14) : t14 = $[16];
  const state_0 = useObservable(readState, t14);
  let t15;
  return $[17] !== state_0 ? (t15 = {
    state: state_0,
    focusDivergence,
    blurDivergence,
    blurFocusedDivergence
  }, $[17] = state_0, $[18] = t15) : t15 = $[18], t15;
}
function _temp3$N(state) {
  return state && pick(state, ["groups", "_allMembers"]);
}
function _temp2$1D(value_0) {
  return typeof value_0 < "u";
}
function _temp$3M(value) {
  return typeof value < "u";
}
function withAddressablePaths(state) {
  const focusedDivergenceIndex = state.divergences.findIndex(([path]) => path === state.focusedDivergence);
  return {
    ...state,
    focusedDivergence: focusedDivergenceIndex === -1 ? void 0 : state.focusedDivergence,
    previousDivergence: typeof state.focusedDivergence > "u" ? void 0 : state.divergences.at((focusedDivergenceIndex - 1 + state.divergences.length) % state.divergences.length)?.[0],
    nextDivergence: typeof state.focusedDivergence > "u" ? void 0 : state.divergences.at((focusedDivergenceIndex + 1) % state.divergences.length)?.[0]
  };
}
function shouldFocusNextDivergence(state, divergences) {
  if (typeof state.focusedDivergence > "u" || typeof state.nextDivergence > "u")
    return !1;
  const focusedDivergence = divergences.find(([path]) => path === state.focusedDivergence)?.[1];
  return typeof focusedDivergence > "u" || focusedDivergence.status === "resolved";
}
function createStateReducer({
  dispatch,
  context
}) {
  return merge(dispatch, context.pipe(map$1((nextContext) => ({
    type: "READ_DIVERGENCES",
    context: nextContext
  })))).pipe(switchScan((state, action) => {
    switch (action.type) {
      case "READ_DIVERGENCES":
        return transposeSchema(action.context.divergences.divergences, action.context.schemaType, action.context.formState).pipe(map$1(({
          divergences,
          divergencesByNode
        }) => withAddressablePaths({
          ...state,
          upstreamId: action.context.divergences.upstreamId,
          state: action.context.divergences.state,
          allDivergences: Object.entries(action.context.divergences.divergences),
          divergences,
          divergencesByNode,
          focusedDivergence: shouldFocusNextDivergence(state, divergences) ? state.nextDivergence : state.focusedDivergence
        })));
      case "FOCUS":
        return of(withAddressablePaths({
          ...state,
          focusedDivergence: action.context.path
        }));
      case "BLUR":
        return typeof state.focusedDivergence > "u" ? of(state) : action.context.path !== state.focusedDivergence ? of(state) : of(withAddressablePaths({
          ...state,
          focusedDivergence: void 0
        }));
      case "BLUR_FOCUSED":
        return of(withAddressablePaths({
          ...state,
          focusedDivergence: void 0
        }));
      default:
        return of(state);
    }
  }, {
    focusedDivergence: void 0,
    previousDivergence: void 0,
    nextDivergence: void 0,
    upstreamId: void 0,
    state: "pending",
    divergences: [],
    allDivergences: [],
    divergencesByNode: {}
  }), shareReplay$1(1));
}
function selectDivergenceCount(state, path) {
  return state?.divergencesByNode?.[toString(path)];
}
function selectDivergence(state, path) {
  if (!(typeof state > "u"))
    return state.divergences.filter(([divergencePath]) => divergencePath === toString(path)).map(([, divergence]) => divergence).at(0);
}
function selectFirstDescendantDivergence(state, path) {
  return state?.divergences.find(([divergencePath]) => startsWith(path, fromString(divergencePath)))?.[1];
}
function useVersionRelease(documentId) {
  const $ = c(11), {
    state$: readReleasesState
  } = useReleasesStore();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    releases: /* @__PURE__ */ new Map(),
    state: "initialising"
  }, $[0] = t0) : t0 = $[0];
  const releasesState = useObservable(readReleasesState, t0);
  if (typeof documentId > "u") {
    let t12;
    return $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = {
      release: void 0,
      state: "initialising"
    }, $[1] = t12) : t12 = $[1], t12;
  }
  let t1, t2, t3;
  if ($[2] !== documentId || $[3] !== releasesState) {
    t3 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    bb0: {
      const versionId = getVersionFromId(documentId);
      if (typeof versionId > "u") {
        let t42;
        $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = {
          release: "published",
          state: "loaded"
        }, $[7] = t42) : t42 = $[7], t3 = t42;
        break bb0;
      }
      t1 = releasesState, t2 = releasesState?.releases.get(getReleaseDocumentIdFromReleaseId(versionId));
    }
    $[2] = documentId, $[3] = releasesState, $[4] = t1, $[5] = t2, $[6] = t3;
  } else
    t1 = $[4], t2 = $[5], t3 = $[6];
  if (t3 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return t3;
  let t4;
  return $[8] !== t1 || $[9] !== t2 ? (t4 = {
    ...t1,
    release: t2
  }, $[8] = t1, $[9] = t2, $[10] = t4) : t4 = $[10], t4;
}
function selectEffect({
  fromValue,
  toValue,
  upstreamParent,
  path
}) {
  return fromString(path).at(-1) === "_type" && typeof fromValue < "u" && typeof toValue < "u" && fromValue !== toValue ? "changeObjectType" : typeof fromValue < "u" && typeof toValue > "u" ? "unset" : Array.isArray(upstreamParent) && typeof fromValue > "u" && typeof toValue < "u" ? "insert" : "set";
}
const UNDEFINED_SHA1 = "da39a3ee5e6b4b0d3255bfef95601890afd80709";
function selectEffectFromHash({
  fromHash,
  toHash,
  upstreamParentIsArray,
  path
}) {
  return fromString(path).at(-1) === "_type" && fromHash !== UNDEFINED_SHA1 && toHash !== UNDEFINED_SHA1 && fromHash !== toHash ? "changeObjectType" : fromHash !== UNDEFINED_SHA1 && toHash === UNDEFINED_SHA1 ? "unset" : upstreamParentIsArray && fromHash === UNDEFINED_SHA1 && toHash !== UNDEFINED_SHA1 ? "insert" : "set";
}
function isDivergenceResolutionMarker(maybeDivergenceResolutionMarker) {
  return Array.isArray(maybeDivergenceResolutionMarker) && maybeDivergenceResolutionMarker.length === 2 && typeof maybeDivergenceResolutionMarker.at(0) == "string" && (typeof maybeDivergenceResolutionMarker.at(1) == "string" || typeof maybeDivergenceResolutionMarker.at(1) == "number");
}
function delayTask() {
  if (typeof window?.scheduler < "u") {
    const {
      scheduler
    } = window;
    return delayWhen(() => from(scheduler.yield()));
  }
  if (typeof requestIdleCallback == "function") {
    const idleCallback = new Promise((resolve) => requestIdleCallback(resolve));
    return delayWhen(() => from(idleCallback));
  }
  return pipe();
}
let cache$4;
function findMovesInArrayOfObjects(a, b) {
  if (typeof a > "u" || typeof b > "u")
    return EMPTY$5;
  cache$4 ??= createMultiKeyWeakMap();
  const cached = cache$4.get([a, b]);
  if (typeof cached < "u")
    return cached;
  const {
    intersectingKeys,
    aIntersectingKeys,
    bIntersectingKeys
  } = findIntersectingKeys(a, b), readMoves = of([aIntersectingKeys, bIntersectingKeys]).pipe(map$1(([aIntersecting, bIntersecting]) => lcs_dp(aIntersecting.length, bIntersecting.length, (x, y) => aIntersecting[x] === bIntersecting[y])), map$1((lcs) => lcs.map(([aIndex]) => aIntersectingKeys[aIndex])), switchMap$1((lcsKeys) => intersectingKeys.size < 3 ? from(lcsKeys) : lcsKeys.length === 1 ? from(intersectingKeys) : from(intersectingKeys).pipe(filter$1((_key) => !lcsKeys.includes(_key)))), map$1((_key) => [_key, bIntersectingKeys.indexOf(_key) - aIntersectingKeys.indexOf(_key)]), filter$1(([, positionDelta]) => positionDelta !== 0), toArray$2(), map$1(Object.fromEntries), shareReplay$1(1));
  return cache$4.set([a, b], readMoves), readMoves;
}
const findIntersectingKeys = (a, b) => "intersection" in Set.prototype ? findIntersectingKeysUsingSet(a, b) : findIntersectingKeysUsingArray(a, b), findIntersectingKeysUsingSet = (a, b) => {
  const aKeys = new Set(a.map(({
    _key
  }) => _key)), bKeys = new Set(b.map(({
    _key
  }) => _key)), intersectingKeys = aKeys.intersection(bKeys), [aIntersectingKeys, bIntersectingKeys] = [a, b].map((subject) => subject.filter(({
    _key
  }) => intersectingKeys.has(_key)).map(({
    _key
  }) => _key));
  return {
    intersectingKeys,
    aIntersectingKeys,
    bIntersectingKeys
  };
}, findIntersectingKeysUsingArray = (a, b) => {
  const aKeys = a.map(({
    _key
  }) => _key), bKeys = b.map(({
    _key
  }) => _key), intersectingKeys = intersection(aKeys, bKeys), [aIntersectingKeys, bIntersectingKeys] = [a, b].map((subject) => subject.filter(({
    _key
  }) => intersectingKeys.includes(_key)).map(({
    _key
  }) => _key));
  return {
    intersectingKeys: new Set(intersectingKeys),
    aIntersectingKeys,
    bIntersectingKeys
  };
};
let textEncoder;
function hashData(data) {
  return textEncoder ??= new TextEncoder(), hash(typeof data == "string" ? textEncoder.encode(data) : typeof data == "number" || typeof data == "boolean" ? textEncoder.encode(String(data)) : textEncoder.encode(stringify$1(data)));
}
async function hash(data) {
  const digest = await globalThis.crypto.subtle.digest("SHA-1", data);
  return hex(new Uint8Array(digest));
}
async function hex(data) {
  return Array.from(data).map((i) => i.toString(16).padStart(2, "0")).join("");
}
const skipFields = /(\.|^)_(id|rev|key|system|createdAt|updatedAt|systemDivergences)(\.|$)/g;
function readDocumentDivergences({
  upstreamAtFork,
  upstreamHead,
  subjectHead,
  resolutions = []
}) {
  if (typeof subjectHead > "u" || typeof upstreamHead > "u" || typeof upstreamAtFork > "u")
    return EMPTY$5;
  const markName = [subjectHead._id, upstreamHead._id, upstreamAtFork._id].join(".");
  return performance.mark(markName), merge(from(flattenObject(subjectHead)).pipe(map$1((entry) => ["subjectHead", entry])), from(flattenObject(upstreamHead)).pipe(map$1((entry) => ["upstreamHead", entry])), from(flattenObject(upstreamAtFork)).pipe(map$1((entry) => ["upstreamAtFork", entry]))).pipe(map$1(([snapshotType, [path, value, context]]) => ({
    snapshotType,
    path,
    value,
    context
  })), filter$1(({
    path
  }) => !path.match(skipFields)), aggregateArrays(), aggregateObjects(), reduce$1((state, {
    snapshotType,
    path,
    value,
    arrays,
    objects,
    context
  }) => {
    state[path] ??= {
      subjectHead: void 0,
      upstreamHead: void 0,
      upstreamAtFork: void 0
    };
    const parentPathArray = toString(context.flatPathArray.slice(0, -1)), parentArray = arrays[parentPathArray], parentObject = objects[parentPathArray];
    return state[path][snapshotType] = {
      value,
      parentArray,
      parentObjectType: get(parentObject, "_type"),
      pathWithTypes: context.flatPathArrayWithTypes
    }, state;
  }, {}), tap$1(() => {
    performance.measure(markName, {
      start: markName,
      detail: {
        devtools: {
          dataType: "track-entry",
          track: "Iterate all versions",
          trackGroup: "Find divergences",
          color: "tertiary-dark"
        }
      }
    });
  }), switchMap$1((state) => from(Object.entries(state))), switchMap$1(([path, snapshots]) => from(resolutions).pipe(first$1(({
    _key
  }) => _key === path, {
    resolutionMarker: void 0
  }), map$1(({
    resolutionMarker
  }) => resolutionMarker), map$1((resolutionMarker) => ({
    path,
    snapshots,
    resolutionMarker
  }))))).pipe(filter$1(({
    snapshots
  }) => {
    const hasObjectSnapshot = [snapshots.upstreamAtFork?.value, snapshots.upstreamHead?.value, snapshots.subjectHead?.value].some(isRecord$4), hasKeyedObjectSnapshot = [snapshots.upstreamAtFork?.value, snapshots.upstreamHead?.value, snapshots.subjectHead?.value].some(isKeyedObject);
    return !hasObjectSnapshot || hasKeyedObjectSnapshot;
  }), delayTask(), mergeMap$1(({
    path,
    snapshots,
    resolutionMarker
  }) => {
    const strategy = typeof resolutionMarker > "u" ? "sinceFork" : "sinceResolution";
    if (isRevisionIdEqual({
      strategy,
      upstreamAtFork,
      upstreamHead,
      resolutionMarker
    }))
      return strategy === "sinceResolution" && typeof resolutionMarker < "u" ? of([path, {
        status: "resolved",
        isAddressable: !1,
        documentId: upstreamHead._id,
        documentType: subjectHead._type,
        subjectId: subjectHead._id,
        path,
        snapshots,
        sinceRevisionId: resolutionMarker?.[0]
      }]) : EMPTY$5;
    if (isPositionedNode({
      strategy,
      snapshots,
      resolutionMarker
    })) {
      const [upstreamBaseIndex, upstreamHeadIndex] = getPositionedNodeIndexes({
        strategy,
        snapshots,
        resolutionMarker
      });
      return of(upstreamHeadIndex - upstreamBaseIndex).pipe(
        // Position has changed in upstream.
        filter$1((moveInUpstream) => moveInUpstream !== 0),
        delayTask(),
        zipWith(isObjectArray(snapshots.subjectHead?.parentArray) && isObjectArray(snapshots.upstreamHead?.parentArray) ? findMovesInArrayOfObjects(snapshots.subjectHead.parentArray, snapshots.upstreamHead?.parentArray) : of({})),
        map$1(([movesInUpstream, movesInSubject]) => {
          const key = get(snapshots, ["upstreamAtFork", "value", "_key"]) ?? get(snapshots, ["upstreamHead", "value", "_key"]);
          return [movesInUpstream, movesInSubject[key]];
        }),
        filter$1((moves) => {
          const [, moveInSubject] = moves;
          return typeof moveInSubject < "u";
        }),
        map$1(([, positionDelta]) => [path, {
          documentId: upstreamHead._id,
          documentType: subjectHead._type,
          subjectId: subjectHead._id,
          status: "unresolved",
          isAddressable: !0,
          effect: "move",
          delta: positionDelta,
          upstreamPosition: upstreamHeadIndex,
          sinceRevisionId: createDocumentRevisionMarker(upstreamAtFork._id, upstreamAtFork?._rev),
          path,
          snapshots
        }])
      );
    }
    if (strategy === "sinceFork") {
      const sinceForkMarkName = ["sinceFork", markName, path].join(".");
      return performance.mark(sinceForkMarkName), combineLatest({
        upstreamAtFork: from(hashData(snapshots.upstreamAtFork?.value)),
        upstreamHead: from(hashData(snapshots.upstreamHead?.value)),
        subjectHead: from(hashData(snapshots.subjectHead?.value))
      }).pipe(
        tap$1(() => {
          performance.measure(path, {
            start: sinceForkMarkName,
            detail: {
              devtools: {
                dataType: "track-entry",
                track: "Hash snapshots",
                trackGroup: "Find divergences",
                color: "tertiary-dark",
                properties: [["Upstream at fork", snapshots.upstreamAtFork?.value], ["Upstream head", snapshots.upstreamHead?.value], ["Subject head", snapshots.subjectHead?.value], ["Strategy", strategy]]
              }
            }
          });
        }),
        delayTask(),
        map$1((hashes) => ({
          hashes,
          effect: selectEffect({
            fromValue: snapshots.upstreamAtFork?.value,
            toValue: snapshots.upstreamHead?.value,
            upstreamParent: snapshots.upstreamHead?.parentArray,
            path
          })
        })),
        // The upstream has changed since the fork occurred.
        takeWhile(({
          hashes,
          effect
        }) => effect === "insert" || effect === "unset" || hashes.upstreamAtFork !== hashes.upstreamHead),
        // The upstream is different to the current value in the subject document.
        takeWhile(({
          hashes,
          effect
        }) => effect === "insert" || effect === "unset" || hashes.upstreamHead !== hashes.subjectHead),
        // If the node is an inserted array item, and it already exists in
        // the subject document, skip it.
        takeWhile(({
          effect
        }) => {
          if (effect === "insert") {
            const parentPathSegment = fromString(path).at(-1);
            if (parentPathSegment && isKeySegment(parentPathSegment))
              return typeof snapshots.subjectHead?.parentArray?.find((item) => isKeyedObject(item) && item._key === get(parentPathSegment, "_key")) > "u";
            if (typeof parentPathSegment == "number")
              return typeof snapshots.subjectHead?.parentArray?.[parentPathSegment] > "u";
          }
          return !0;
        }),
        takeWhile(() => ![snapshots.upstreamAtFork?.value, snapshots.upstreamHead?.value].some(Array.isArray)),
        map$1(({
          effect
        }) => {
          const hasObjectSnapshot = [snapshots.upstreamAtFork?.value, snapshots.upstreamHead?.value].some(isRecord$4), hasKeyedObjectSnapshot = [snapshots.upstreamAtFork?.value, snapshots.upstreamHead?.value].some(isKeyedObject), hasArraySnapshot = [snapshots.upstreamAtFork?.value, snapshots.upstreamHead?.value].some(Array.isArray), hasNullSnapshot = [snapshots.upstreamAtFork?.value, snapshots.upstreamHead?.value].some((value) => value === null), isAddressable = !hasObjectSnapshot && !hasArraySnapshot || hasKeyedObjectSnapshot || hasNullSnapshot && !hasObjectSnapshot && !hasArraySnapshot, divergence = {
            documentId: upstreamHead._id,
            documentType: subjectHead._type,
            subjectId: subjectHead._id,
            status: "unresolved",
            isAddressable,
            effect,
            sinceRevisionId: createDocumentRevisionMarker(upstreamAtFork._id, upstreamAtFork?._rev),
            path,
            snapshots
          };
          return divergence.effect === "insert" ? [path, {
            ...divergence,
            position: findPositionedNodeIndexByKey(snapshots.upstreamHead?.parentArray, get(snapshots, ["upstreamHead", "value", "_key"])) ?? 0
          }] : [path, divergence];
        })
      );
    }
    if (strategy === "sinceResolution") {
      if (typeof resolutionMarker > "u")
        throw new Error("Expected resolution marker");
      const sinceResolutionMarkName = ["sinceResolution", markName, path].join(".");
      return performance.mark(sinceResolutionMarkName), combineLatest({
        upstreamHead: from(hashData(snapshots.upstreamHead?.value)),
        subjectHead: from(hashData(snapshots.subjectHead?.value))
      }).pipe(tap$1(() => {
        performance.measure(path, {
          start: sinceResolutionMarkName,
          detail: {
            devtools: {
              dataType: "track-entry",
              track: "Hash snapshots",
              trackGroup: "Find divergences",
              color: "tertiary-dark",
              properties: [["Upstream at fork", snapshots.upstreamAtFork?.value], ["Upstream head", snapshots.upstreamHead?.value], ["Subject head", snapshots.subjectHead?.value], ["Strategy", strategy]]
            }
          }
        });
      }), delayTask(), map$1((hashes) => [path, {
        documentId: upstreamHead._id,
        documentType: subjectHead._type,
        subjectId: subjectHead._id,
        path,
        snapshots,
        status: (
          // The upstream has not changed since the resolution.
          hashes.upstreamHead === resolutionMarker[1] || // The upstream is not different to the current value in the subject document.
          hashes.upstreamHead === hashes.subjectHead ? "resolved" : "unresolved"
        ),
        // A resolution already exists for the node, so it can be assumed the divergence
        // is addressable.
        isAddressable: !0,
        effect: selectEffectFromHash({
          fromHash: resolutionMarker[1],
          toHash: hashes.upstreamHead,
          upstreamParentIsArray: Array.isArray(snapshots.upstreamHead),
          path
        }),
        sinceRevisionId: resolutionMarker[0]
      }]));
    }
    return EMPTY$5;
  }), coalesceChangedObjectTypes());
}
function isPositionedNode({
  strategy,
  snapshots,
  resolutionMarker
}) {
  if (strategy === "sinceFork")
    return isKeyedObject(snapshots.upstreamAtFork?.value) && isKeyedObject(snapshots.upstreamHead?.value);
  if (strategy === "sinceResolution") {
    if (typeof resolutionMarker > "u")
      throw new Error("Expected resolution marker");
    return isKeyedObject(snapshots.upstreamHead?.value);
  }
  throw new Error(`Unexpected strategy: "${strategy}"`);
}
function getPositionedNodeIndexes({
  strategy,
  snapshots,
  resolutionMarker
}) {
  const key = get(snapshots, ["upstreamAtFork", "value", "_key"]) ?? get(snapshots, ["upstreamHead", "value", "_key"]);
  if (strategy === "sinceFork")
    return [findPositionedNodeIndexByKey(snapshots.upstreamAtFork?.parentArray, key), findPositionedNodeIndexByKey(snapshots.upstreamHead?.parentArray, key)];
  if (strategy === "sinceResolution") {
    if (typeof resolutionMarker > "u")
      throw new Error("Expected resolution marker");
    if (typeof resolutionMarker[1] != "number")
      throw new Error("Expected upstream position at resolution as number, but received string");
    return [resolutionMarker[1], findPositionedNodeIndexByKey(snapshots.upstreamHead?.parentArray, key)];
  }
  throw new Error(`Unexpected strategy: "${strategy}"`);
}
function aggregateArrays() {
  const arrays = {};
  return switchMap$1((entry) => (Array.isArray(entry.value) && (arrays[entry.path] = entry.value), of({
    ...entry,
    arrays
  })));
}
function aggregateObjects() {
  const objects = {};
  return switchMap$1((entry) => (isSanityObjectLike(entry.value) && (objects[entry.path] = entry.value), of({
    ...entry,
    objects
  })));
}
function coalesceChangedObjectTypes() {
  const changedObjectPaths = [];
  return pipe(
    toArray$2(),
    // Ensure the object's `_type` field is iterated first.
    switchMap$1((divergences) => from(divergences.sort(([pathA], [pathB]) => {
      const pathArrayA = fromString(pathA), pathArrayB = fromString(pathB);
      return pathArrayA.at(-1) === "_type" && pathArrayB.at(-1) !== "_type" ? -1 : pathArrayA.at(-1) !== "_type" && pathArrayB.at(-1) === "_type" ? 1 : 0;
    }))),
    mergeMap$1(([path, divergence]) => {
      if (changedObjectPaths.some((changedObjectPath) => startsWith(changedObjectPath, fromString(path))))
        return EMPTY$5;
      const parentObjectPath = fromString(path).slice(0, -1), isSubjectObjectTypeCompatible = ![divergence.snapshots.upstreamHead?.value, divergence.snapshots.subjectHead?.value].some(isKeyedObject) || divergence.snapshots.upstreamHead?.parentObjectType === divergence.snapshots.subjectHead?.parentObjectType, isChangedObjectType = divergence.effect === "changeObjectType", isFirstDescendantOfChangedObject = !changedObjectPaths.some((changedObjectPath) => toString(changedObjectPath) === toString(parentObjectPath));
      return isChangedObjectType || !isSubjectObjectTypeCompatible && isFirstDescendantOfChangedObject ? (changedObjectPaths.push(parentObjectPath), of([toString(parentObjectPath), {
        // Note: `snapshots` currently reflects the `_type` node, or first descendant node
        // encountered, rather than the object itself.
        ...divergence,
        effect: "changeObjectType",
        isAddressable: !0,
        path: toString(parentObjectPath)
      }])) : of([path, divergence]);
    })
  );
}
function findPositionedNodeIndexByKey(array = [], key) {
  return array.findIndex((value) => typeof value != "object" || value === null || !("_key" in value) ? !1 : value._key === key);
}
function isRevisionIdEqual({
  strategy,
  upstreamAtFork,
  upstreamHead,
  resolutionMarker
}) {
  if (strategy === "sinceResolution") {
    if (typeof resolutionMarker > "u")
      throw new Error("Expected resolution marker");
    const [upstreamId, upstreamRevisionId] = resolutionMarker[0].split("@");
    return upstreamId === upstreamHead._id && upstreamRevisionId === upstreamHead._rev;
  }
  if (strategy === "sinceFork")
    return upstreamAtFork?._rev === upstreamHead._rev;
  throw new Error(`Unexpected strategy: "${strategy}"`);
}
function isObjectArray(maybeObjectArray) {
  return Array.isArray(maybeObjectArray) ? maybeObjectArray.some(isKeyedObject) : !1;
}
function isSanityObjectLike(maybeSanityObjectLike) {
  return typeof maybeSanityObjectLike == "object" && maybeSanityObjectLike !== null && "_type" in maybeSanityObjectLike;
}
function createDocumentRevisionMarker(...documentRevision) {
  return documentRevision.join("@");
}
function isDivergenceResolutions(maybeDivergenceResolutions) {
  return Array.isArray(maybeDivergenceResolutions) && maybeDivergenceResolutions.every(isDivergenceResolution);
}
function isDivergenceResolution(maybeDivergenceResolution) {
  return typeof maybeDivergenceResolution == "object" && maybeDivergenceResolution !== null && "_key" in maybeDivergenceResolution && typeof maybeDivergenceResolution._key == "string" && "resolutionMarker" in maybeDivergenceResolution && isDivergenceResolutionMarker(maybeDivergenceResolution.resolutionMarker);
}
const DEBOUNCE_DURATION = 1e3, CACHE_MAX_SIZE$1 = 10;
let cacheWriteChannel, cache$3;
const collateDocumentDivergencesInitialState = {
  state: "pending",
  upstreamId: void 0,
  divergences: {}
};
function collateDocumentDivergences({
  upstreamId,
  subjectId
}) {
  initialiseCache();
  const cacheKey = getCacheKey$1({
    upstreamId,
    subjectId
  }), cachedInstance = cache$3.get(cacheKey);
  if (typeof cachedInstance < "u")
    return cachedInstance;
  const context = new Subject(), markName = ["collateDocumentDivergences", cacheKey].join(".");
  if (typeof upstreamId > "u" || typeof subjectId > "u")
    return {
      observable: EMPTY$5,
      context
    };
  const observable = context.pipe(debounceTime$1(DEBOUNCE_DURATION), tap$1(() => performance.mark(cacheKey)), distinctUntilChanged$1(isContextEqual), switchScan((state, nextContext) => of(nextContext).pipe(delayTask(), tap$1(() => performance.mark(markName)), switchMap$1(readDocumentDivergences), toArray$2(), tap$1(() => performance.measure(cacheKey, {
    start: markName,
    detail: {
      devtools: {
        dataType: "track-entry",
        track: "Find all divergences",
        trackGroup: "Aggregate Divergences",
        color: "tertiary-dark"
      }
    }
  })), map$1(Object.fromEntries), map$1((divergences) => ({
    ...state,
    state: "ready",
    upstreamId,
    divergences
  })), startWith$1({
    ...state,
    upstreamId,
    state: "pending"
  })), collateDocumentDivergencesInitialState), startWith$1(collateDocumentDivergencesInitialState), shareReplay$1(1)), instance = {
    context,
    observable
  };
  return cache$3.set(cacheKey, instance), cacheWriteChannel.next(cacheKey), instance;
}
function isContextEqual(a, b) {
  return a.upstreamHead._rev === b.upstreamHead._rev && a.subjectHead._rev === b.subjectHead._rev && a.upstreamAtFork._rev === b.upstreamAtFork._rev && isEqual$1(a.resolutions, b.resolutions);
}
function initialiseCache() {
  cache$3 ??= new QuickLRU({
    maxSize: CACHE_MAX_SIZE$1
  }), cacheWriteChannel ??= new Subject();
}
function getCacheKey$1({
  subjectId,
  upstreamId
}) {
  return [upstreamId, subjectId].join(".");
}
const PAGE_LENGTH = 50;
let cache$2;
function readMostRecentSharedTransaction({
  a,
  b,
  client,
  getTransactionsLogs: getTransactionsLogs$1 = getTransactionsLogs
}) {
  if (typeof a > "u" || typeof b > "u")
    return EMPTY$5;
  cache$2 ??= new QuickLRU({
    maxSize: 250
  });
  const cacheKey = [a, b].join(";"), cachedReader = cache$2.get(cacheKey);
  if (typeof cachedReader < "u")
    return cachedReader;
  const reader = merge(readTransactionsFollowingLineage({
    documentId: a,
    client,
    getTransactionsLogs: getTransactionsLogs$1
  }).pipe(map$1((transaction) => ["a", transaction])), readTransactionsFollowingLineage({
    documentId: b,
    client,
    getTransactionsLogs: getTransactionsLogs$1
  }).pipe(map$1((transaction) => ["b", transaction]))).pipe(scan$1((visited, [source, transaction]) => (visited[source].add(transaction.id), visited.currentTransaction = [source, transaction], visited), {
    a: /* @__PURE__ */ new Set(),
    b: /* @__PURE__ */ new Set(),
    currentTransaction: void 0
  }), first$1((accumulation) => {
    const {
      a: transactionIdsA,
      b: transactionIdsB,
      currentTransaction
    } = accumulation;
    if (typeof currentTransaction > "u")
      return !1;
    const [source, transaction] = currentTransaction;
    return (source === "a" ? transactionIdsB : transactionIdsA).has(transaction.id);
  }, void 0), map$1((accumulation) => {
    if (typeof accumulation > "u")
      return;
    const [, transaction] = accumulation.currentTransaction;
    return transaction;
  }), catchError$1((error) => {
    throw cache$2?.delete(cacheKey), error;
  }));
  return cache$2.set(cacheKey, reader), reader;
}
let lineageCache;
function readTransactionsFollowingLineage({
  documentId,
  baseRevisionId,
  cursor,
  client,
  getTransactionsLogs: getTransactionsLogs$1 = getTransactionsLogs
}) {
  lineageCache ??= new QuickLRU({
    maxSize: 250
  });
  const cacheKey = [documentId, baseRevisionId, cursor].join(";"), cachedReader = lineageCache.get(cacheKey);
  if (typeof cachedReader < "u")
    return cachedReader;
  const request = getTransactionsLogs$1(client, documentId, {
    limit: PAGE_LENGTH,
    excludeContent: !0,
    effectFormat: "mendoza",
    reverse: !0,
    includeIdentifiedDocumentsOnly: !0,
    toTransaction: cursor ?? baseRevisionId,
    tag: "sanity.studio.divergences.read-version-lineage"
  }), reader = from(request).pipe(switchMap$1((transactions) => from(transactions)), concatMap((transaction, index) => {
    if (transaction.id === cursor)
      return EMPTY$5;
    const maybeReadNextPage = index === PAGE_LENGTH - 1 ? readTransactionsFollowingLineage({
      documentId,
      baseRevisionId,
      cursor: transaction.id,
      client,
      getTransactionsLogs: getTransactionsLogs$1
    }) : EMPTY$5;
    if (isVersionCreateTransaction(transaction, documentId) && typeof transaction.effects[documentId] < "u") {
      const createdDocument = applyPatch$1({}, transaction.effects[documentId]?.apply);
      if (typeof createdDocument._system?.base < "u")
        return concat(of(transaction), readTransactionsFollowingLineage({
          documentId: createdDocument._system.base.id,
          baseRevisionId: createdDocument._system.base.rev,
          client,
          getTransactionsLogs: getTransactionsLogs$1
        }), maybeReadNextPage);
    }
    return concat(of(transaction), maybeReadNextPage);
  }), catchError$1((error) => {
    throw lineageCache?.delete(cacheKey), error;
  }));
  return lineageCache.set(cacheKey, reader), reader;
}
function isVersionCreateTransaction(transaction, documentId) {
  return transaction.mutations.some((mutation) => isCreateMutation(mutation) || isCreateOrReplaceMutation(mutation) || isCreateIfNotExistsMutation(mutation)) && typeof transaction.effects[documentId] < "u" && transaction.effects[documentId].revert.length === 2 && transaction.effects[documentId].revert[0] === 0 && transaction.effects[documentId].revert[1] === null;
}
const DivergencesProvider = (t0) => {
  const $ = c(32), {
    formState,
    upstreamEditState,
    editState: editState2,
    subjectId,
    schemaType,
    displayedId,
    children
  } = t0, {
    advancedVersionControl: t1
  } = useWorkspace(), {
    enabled: advancedVersionControlEnabled
  } = t1, client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let hasUpstreamVersion, subject, t2, upstreamHead;
  if ($[0] !== advancedVersionControlEnabled || $[1] !== displayedId || $[2] !== editState2.draft || $[3] !== editState2.published || $[4] !== editState2.version || $[5] !== subjectId || $[6] !== upstreamEditState) {
    upstreamHead = selectUpstreamVersion(upstreamEditState);
    const upstreamId = upstreamHead?._id;
    hasUpstreamVersion = typeof upstreamId < "u";
    let t32;
    $[11] !== displayedId || $[12] !== editState2.draft || $[13] !== editState2.published || $[14] !== editState2.version ? (t32 = isPublishedId(displayedId) ? editState2.published : editState2.version ?? editState2.draft, $[11] = displayedId, $[12] = editState2.draft, $[13] = editState2.published, $[14] = editState2.version, $[15] = t32) : t32 = $[15], subject = t32, t2 = !advancedVersionControlEnabled || !hasUpstreamVersion || typeof upstreamId > "u" || typeof subjectId > "u" ? {
      context: new Subject(),
      observable: of(collateDocumentDivergencesInitialState)
    } : collateDocumentDivergences({
      subjectId,
      upstreamId
    }), $[0] = advancedVersionControlEnabled, $[1] = displayedId, $[2] = editState2.draft, $[3] = editState2.published, $[4] = editState2.version, $[5] = subjectId, $[6] = upstreamEditState, $[7] = hasUpstreamVersion, $[8] = subject, $[9] = t2, $[10] = upstreamHead;
  } else
    hasUpstreamVersion = $[7], subject = $[8], t2 = $[9], upstreamHead = $[10];
  const collatedDivergences = t2;
  let t3;
  $[16] !== subject ? (t3 = subject && "_systemDivergences" in subject && typeof subject._systemDivergences == "object" && subject._systemDivergences !== null && "resolutions" in subject._systemDivergences && isDivergenceResolutions(subject._systemDivergences.resolutions) ? subject._systemDivergences.resolutions : [], $[16] = subject, $[17] = t3) : t3 = $[17];
  let t4;
  $[18] !== client || $[19] !== collatedDivergences.context || $[20] !== hasUpstreamVersion || $[21] !== subject || $[22] !== t3 || $[23] !== upstreamHead ? (t4 = {
    upstreamHead,
    hasUpstreamVersion,
    subjectHead: subject,
    resolutions: t3,
    client,
    context: collatedDivergences.context
  }, $[18] = client, $[19] = collatedDivergences.context, $[20] = hasUpstreamVersion, $[21] = subject, $[22] = t3, $[23] = upstreamHead, $[24] = t4) : t4 = $[24], useCollateDivergencesContext(t4);
  let t5;
  $[25] !== collatedDivergences.observable || $[26] !== formState || $[27] !== schemaType ? (t5 = {
    divergences: collatedDivergences.observable,
    schemaType,
    formState
  }, $[25] = collatedDivergences.observable, $[26] = formState, $[27] = schemaType, $[28] = t5) : t5 = $[28];
  const divergenceNavigator = useDivergenceNavigator(t5);
  let t6;
  return $[29] !== children || $[30] !== divergenceNavigator ? (t6 = /* @__PURE__ */ jsx(DocumentDivergencesContext.Provider, { value: divergenceNavigator, children }), $[29] = children, $[30] = divergenceNavigator, $[31] = t6) : t6 = $[31], t6;
};
function useDocumentDivergences() {
  const context = useContext(DocumentDivergencesContext);
  if (!context)
    throw new Error("useDocumentDivergences must be used within a DocumentDivergencesContext");
  return context;
}
function useCollateDivergencesContext(t0) {
  const $ = c(34), {
    upstreamHead,
    hasUpstreamVersion,
    subjectHead,
    resolutions,
    client,
    context
  } = t0, shouldFindForkPoint = hasUpstreamVersion && subjectHead && upstreamHead;
  let t1;
  $[0] !== subjectHead || $[1] !== upstreamHead?._id || $[2] !== upstreamHead?._rev ? (t1 = get(subjectHead, ["_system", "base", "id"]) === upstreamHead?._id && get(subjectHead, ["_system", "base", "rev"]) === upstreamHead?._rev, $[0] = subjectHead, $[1] = upstreamHead?._id, $[2] = upstreamHead?._rev, $[3] = t1) : t1 = $[3];
  const baseIsForkPoint = t1;
  let t2;
  $[4] !== baseIsForkPoint || $[5] !== client || $[6] !== shouldFindForkPoint || $[7] !== subjectHead?._id || $[8] !== upstreamHead?._id ? (t2 = shouldFindForkPoint && baseIsForkPoint ? EMPTY$5 : readMostRecentSharedTransaction({
    a: upstreamHead?._id,
    b: subjectHead?._id,
    client
  }), $[4] = baseIsForkPoint, $[5] = client, $[6] = shouldFindForkPoint, $[7] = subjectHead?._id, $[8] = upstreamHead?._id, $[9] = t2) : t2 = $[9];
  const mostRecentSharedTransaction = useObservable(t2);
  let t3;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = new BehaviorSubject(null), $[10] = t3) : t3 = $[10];
  const listenUpstreamHead = t3;
  let t4, t5;
  $[11] !== upstreamHead ? (t4 = () => listenUpstreamHead.next(upstreamHead), t5 = [upstreamHead, listenUpstreamHead], $[11] = upstreamHead, $[12] = t4, $[13] = t5) : (t4 = $[12], t5 = $[13]), useEffect(t4, t5);
  let t6;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = new BehaviorSubject(null), $[14] = t6) : t6 = $[14];
  const listenSubjectHead = t6;
  let t7, t8;
  $[15] !== subjectHead ? (t7 = () => listenSubjectHead.next(subjectHead), t8 = [subjectHead, listenSubjectHead], $[15] = subjectHead, $[16] = t7, $[17] = t8) : (t7 = $[16], t8 = $[17]), useEffect(t7, t8);
  let t9;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = new BehaviorSubject(null), $[18] = t9) : t9 = $[18];
  const listenResolutions = t9;
  let t10, t11;
  $[19] !== resolutions ? (t10 = () => listenResolutions.next(resolutions ?? []), t11 = [resolutions, listenResolutions], $[19] = resolutions, $[20] = t10, $[21] = t11) : (t10 = $[20], t11 = $[21]), useEffect(t10, t11);
  let t12;
  bb0: {
    if (shouldFindForkPoint && baseIsForkPoint) {
      let t133;
      $[22] !== client || $[23] !== subjectHead ? (t133 = getDocumentAtRevision({
        client,
        documentId: get(subjectHead, ["_system", "base", "id"]),
        revisionId: get(subjectHead, ["_system", "base", "rev"])
      }), $[22] = client, $[23] = subjectHead, $[24] = t133) : t133 = $[24], t12 = t133;
      break bb0;
    }
    if (upstreamHead === null || subjectHead === null || !hasUpstreamVersion || typeof mostRecentSharedTransaction > "u") {
      t12 = EMPTY$5;
      break bb0;
    }
    let t132;
    $[25] !== client || $[26] !== mostRecentSharedTransaction.documentIDs[0] || $[27] !== mostRecentSharedTransaction.id ? (t132 = getDocumentAtRevision({
      client,
      documentId: mostRecentSharedTransaction.documentIDs[0],
      revisionId: mostRecentSharedTransaction.id
    }), $[25] = client, $[26] = mostRecentSharedTransaction.documentIDs[0], $[27] = mostRecentSharedTransaction.id, $[28] = t132) : t132 = $[28], t12 = t132;
  }
  const readUpstreamAtFork = t12;
  let t13;
  if ($[29] !== context || $[30] !== readUpstreamAtFork) {
    let t14;
    $[32] !== context ? (t14 = (nextContext) => context.next(nextContext), $[32] = context, $[33] = t14) : t14 = $[33], t13 = combineLatest({
      upstreamHead: listenUpstreamHead.pipe(filter$1(_temp$3L)),
      subjectHead: listenSubjectHead.pipe(filter$1(_temp2$1C)),
      resolutions: listenResolutions.pipe(map$1(_temp3$M)),
      upstreamAtFork: readUpstreamAtFork.pipe(filter$1(_temp4$m), map$1(_temp5$d), filter$1(_temp6$7))
    }).pipe(tap$1(t14)), $[29] = context, $[30] = readUpstreamAtFork, $[31] = t13;
  } else
    t13 = $[31];
  return useObservable(t13);
}
function _temp6$7(document_2) {
  return typeof document_2 < "u" && document_2 !== null;
}
function _temp5$d(t0) {
  const {
    document: document_1
  } = t0;
  return document_1;
}
function _temp4$m(revision) {
  return revision !== null;
}
function _temp3$M(nextResolutions) {
  return nextResolutions ?? [];
}
function _temp2$1C(document_0) {
  return typeof document_0 < "u" && document_0 !== null;
}
function _temp$3L(document2) {
  return typeof document2 < "u" && document2 !== null;
}
const FormDivergenceIndicator = (props2) => {
  const $ = c(10), divergenceNavigator = useDocumentDivergences();
  let t0;
  $[0] !== divergenceNavigator.state || $[1] !== props2.path ? (t0 = selectDivergence(divergenceNavigator.state, props2.path), $[0] = divergenceNavigator.state, $[1] = props2.path, $[2] = t0) : t0 = $[2];
  const divergence = t0, {
    release: upstreamBundle
  } = useVersionRelease(divergenceNavigator.state.upstreamId ?? "");
  let t1;
  $[3] !== divergence || $[4] !== divergenceNavigator || $[5] !== props2 || $[6] !== upstreamBundle ? (t1 = divergence && divergence.divergences[0][1].status === "unresolved" && /* @__PURE__ */ jsx(DivergenceIndicator, { ...props2, divergenceNavigator, divergence, upstreamBundle }), $[3] = divergence, $[4] = divergenceNavigator, $[5] = props2, $[6] = upstreamBundle, $[7] = t1) : t1 = $[7];
  let t2;
  return $[8] !== t1 ? (t2 = /* @__PURE__ */ jsx(AnimatePresence, { children: t1 }), $[8] = t1, $[9] = t2) : t2 = $[9], t2;
};
function useActiveWorkspace() {
  const value = useContext(ActiveWorkspaceMatcherContext);
  if (!value)
    throw new Error("Could not find `ActiveWorkspaceMatcher` context");
  return value;
}
function useRecordDocumentHistoryEvent(t0) {
  const $ = c(9), {
    documentId,
    documentType,
    resourceType,
    resourceId,
    schemaName
  } = t0, {
    node
  } = useComlinkStore();
  if (resourceType !== "studio" && !resourceId)
    throw new Error("resourceId is required for media-library and canvas resources");
  let t1;
  $[0] !== documentId || $[1] !== documentType || $[2] !== node || $[3] !== resourceId || $[4] !== resourceType || $[5] !== schemaName ? (t1 = (eventType) => {
    const run = () => {
      const message = {
        type: "dashboard/v1/events/history",
        data: {
          eventType,
          document: {
            id: documentId,
            type: documentType,
            resource: {
              id: resourceId,
              type: resourceType,
              schemaName
            }
          }
        }
      };
      node?.post?.(message.type, message.data);
    };
    try {
      run();
    } catch (t22) {
      const error = t22;
      throw console.error("Failed to record history event:", error), error;
    }
  }, $[0] = documentId, $[1] = documentType, $[2] = node, $[3] = resourceId, $[4] = resourceType, $[5] = schemaName, $[6] = t1) : t1 = $[6];
  const recordEvent = t1;
  let t2;
  return $[7] !== recordEvent ? (t2 = {
    recordEvent
  }, $[7] = recordEvent, $[8] = t2) : t2 = $[8], t2;
}
function useDocumentOperationWithComlinkHistory(t0) {
  const $ = c(28), {
    api,
    publishedDocId,
    docTypeName,
    version: version2
  } = t0, {
    activeWorkspace
  } = useActiveWorkspace();
  let t1;
  $[0] !== publishedDocId || $[1] !== version2 ? (t1 = version2 ? getVersionId(publishedDocId, version2) : publishedDocId, $[0] = publishedDocId, $[1] = version2, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== activeWorkspace.dataset || $[4] !== activeWorkspace.projectId ? (t2 = [activeWorkspace.projectId, activeWorkspace.dataset], $[3] = activeWorkspace.dataset, $[4] = activeWorkspace.projectId, $[5] = t2) : t2 = $[5];
  const t3 = t2.join(".");
  let t4;
  $[6] !== activeWorkspace.name || $[7] !== docTypeName || $[8] !== t1 || $[9] !== t3 ? (t4 = {
    resourceType: "studio",
    documentId: t1,
    documentType: docTypeName,
    resourceId: t3,
    schemaName: activeWorkspace.name
  }, $[6] = activeWorkspace.name, $[7] = docTypeName, $[8] = t1, $[9] = t3, $[10] = t4) : t4 = $[10];
  const {
    recordEvent
  } = useRecordDocumentHistoryEvent(t4), renderingContextStore = useRenderingContextStore(), capabilities = useObservable(renderingContextStore.capabilities), [hasRecordedEdit, setHasRecordedEdit] = useState(!1);
  let t5;
  $[11] !== hasRecordedEdit ? (t5 = (next) => {
    hasRecordedEdit || (next(), setHasRecordedEdit(!0));
  }, $[11] = hasRecordedEdit, $[12] = t5) : t5 = $[12];
  const preRecordPatch = t5, t6 = capabilities?.comlink;
  let t7;
  $[13] !== recordEvent || $[14] !== t6 ? (t7 = {
    hasComlink: t6,
    recordEvent
  }, $[13] = recordEvent, $[14] = t6, $[15] = t7) : t7 = $[15];
  const comlinkContext = t7;
  let t8;
  $[16] !== comlinkContext ? (t8 = withComlinkEvent({
    ...comlinkContext,
    operationName: "delete",
    comlinkEventType: "deleted"
  }), $[16] = comlinkContext, $[17] = t8) : t8 = $[17];
  const withComlinkDelete = t8;
  let t9;
  $[18] !== comlinkContext ? (t9 = withComlinkEvent({
    ...comlinkContext,
    operationName: "del",
    comlinkEventType: "deleted"
  }), $[18] = comlinkContext, $[19] = t9) : t9 = $[19];
  const withComlinkDel = t9;
  let t10;
  $[20] !== comlinkContext || $[21] !== preRecordPatch ? (t10 = withComlinkEvent({
    ...comlinkContext,
    operationName: "patch",
    comlinkEventType: "edited",
    preRecordEvent: preRecordPatch
  }), $[20] = comlinkContext, $[21] = preRecordPatch, $[22] = t10) : t10 = $[22];
  const withComlinkPatch = t10;
  let t11;
  return $[23] !== api || $[24] !== withComlinkDel || $[25] !== withComlinkDelete || $[26] !== withComlinkPatch ? (t11 = withComlinkDelete(withComlinkDel(withComlinkPatch(api))), $[23] = api, $[24] = withComlinkDel, $[25] = withComlinkDelete, $[26] = withComlinkPatch, $[27] = t11) : t11 = $[27], t11;
}
function withComlinkEvent({
  operationName,
  comlinkEventType,
  hasComlink,
  recordEvent,
  preRecordEvent = (next) => next()
}) {
  return function(api) {
    return hasComlink ? {
      ...api,
      [operationName]: {
        ...api[operationName],
        execute: (...args) => {
          preRecordEvent(() => recordEvent(comlinkEventType)), api[operationName].execute(...args);
        }
      }
    } : api;
  };
}
function useDocumentOperation(publishedDocId, docTypeName, version2) {
  const $ = c(9), documentStore = useDocumentStore();
  let t0;
  $[0] !== docTypeName || $[1] !== documentStore.pair || $[2] !== publishedDocId || $[3] !== version2 ? (t0 = documentStore.pair.editOperations(publishedDocId, docTypeName, version2), $[0] = docTypeName, $[1] = documentStore.pair, $[2] = publishedDocId, $[3] = version2, $[4] = t0) : t0 = $[4];
  const api = useObservable(t0);
  let t1;
  return $[5] !== api || $[6] !== docTypeName || $[7] !== publishedDocId ? (t1 = {
    api,
    docTypeName,
    publishedDocId
  }, $[5] = api, $[6] = docTypeName, $[7] = publishedDocId, $[8] = t1) : t1 = $[8], useDocumentOperationWithComlinkHistory(t1);
}
const InspectedDivergence = defineEvent({
  name: "Inspected Divergence",
  version: 1,
  description: "User inspected divergence in a single node"
}), ActedOnDivergence = defineEvent({
  name: "Acted On Divergence",
  version: 1,
  description: "User acted on divergence in a single node"
}), SYSTEM_PATH = "_systemDivergences", DIVERGENCE_RESOLUTION_PATH = [SYSTEM_PATH, "resolutions"], DEFAULT_VALUES = [{}, []];
function createUpsertResolutionMarkerPatches(...resolutionMarkers) {
  const upsertSystem = DIVERGENCE_RESOLUTION_PATH.map((segment, index, array) => array.slice(0, index).concat(segment)).map((path, index) => at(path, setIfMissing$1(DEFAULT_VALUES[index]))), setResolutionMarkers = resolutionMarkers.flatMap(([path, resolutionMarker]) => [at([...DIVERGENCE_RESOLUTION_PATH, {
    _key: path
  }], unset$1()), at(DIVERGENCE_RESOLUTION_PATH, append([{
    _key: path,
    resolutionMarker
  }]))]);
  return [...upsertSystem, ...setResolutionMarkers];
}
function createTakeFromUpstreamPatches(source, allDivergences, ...paths) {
  return from(allDivergences).pipe(mergeMap$1(([divergencePath, divergence]) => {
    const divergencePathSegments = fromString(divergencePath);
    if (divergence.effect === "set" && divergencePathSegments.at(-1) === "_type" && paths.some((acceptedPath) => acceptedPath.length > divergencePathSegments.length - 1 && startsWith(divergencePathSegments.slice(0, -1), acceptedPath) && !isEqual$2(divergencePathSegments, acceptedPath)))
      return from(flattenObject(source)).pipe(first$1(([nodeFlatPath]) => nodeFlatPath === divergencePath), map$1(([, value]) => value), map$1((value) => at(divergencePath, set$1(value))));
    if (typeof paths.find((path) => isEqual$2(path, divergencePathSegments)) > "u")
      return EMPTY$5;
    if (divergence.effect === "insert")
      throw new Error("Array insertions not supported");
    return divergence.effect === "unset" ? of(at(divergencePath, unset$1())) : divergence.effect === "set" ? from(flattenObject(source)).pipe(first$1(([nodeFlatPath]) => nodeFlatPath === divergencePath), map$1(([, value]) => value), map$1((value) => at(divergencePath, set$1(value)))) : EMPTY$5;
  }));
}
function useDivergenceController(divergence, allDivergences, contextReadOnly) {
  const $ = c(44), {
    subjectId,
    documentId,
    documentType,
    sinceRevisionId,
    path
  } = divergence, client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), documentStore = useDocumentStore(), telemetry = useTelemetry(), [isActionPending, setIsActionPending] = useState(!1);
  let t0;
  $[0] !== telemetry ? (t0 = () => telemetry.log(InspectedDivergence), $[0] = telemetry, $[1] = t0) : t0 = $[1];
  const logInspectedDivergence = useEffectEvent(t0);
  let t1;
  $[2] !== logInspectedDivergence ? (t1 = [logInspectedDivergence], $[2] = logInspectedDivergence, $[3] = t1) : t1 = $[3], useEffect(logInspectedDivergence, t1);
  let t2;
  if ($[4] !== client || $[5] !== path || $[6] !== sinceRevisionId) {
    const [upstreamId, upstreamRevisionId] = sinceRevisionId.split("@");
    let t32;
    $[8] !== path ? (t32 = (state) => state?.loading ? of({
      isLoading: !0
    }) : of(state).pipe(filter$1(_temp$3K), map$1(_temp2$1B), switchMap$1((document_0) => document_0 ? of(get$1(document_0, path)).pipe(map$1((value) => ({
      value,
      document: document_0
    })), startWith$1(void 0)) : EMPTY$5), map$1(_temp3$L)), $[8] = path, $[9] = t32) : t32 = $[9], t2 = getDocumentAtRevision({
      client,
      documentId: upstreamId,
      revisionId: upstreamRevisionId
    }).pipe(switchMap$1(t32)), $[4] = client, $[5] = path, $[6] = sinceRevisionId, $[7] = t2;
  } else
    t2 = $[7];
  const readUpstreamBase = t2;
  let t3;
  if ($[10] !== documentId || $[11] !== documentStore.pair || $[12] !== documentType || $[13] !== path) {
    let t42;
    $[15] !== path ? (t42 = (state_0) => state_0.ready ? of(state_0).pipe(map$1(selectUpstreamVersion), find(_temp4$l), switchMap$1((document_2) => typeof document_2 > "u" ? EMPTY$5 : of(get$1(document_2, path)).pipe(map$1((value_1) => ({
      value: value_1,
      document: document_2
    })), startWith$1(void 0))), map$1(_temp5$c)) : of({
      isLoading: !0
    }), $[15] = path, $[16] = t42) : t42 = $[16], t3 = documentStore.pair.editState(getPublishedId(documentId), documentType, getVersionFromId(documentId)).pipe(switchMap$1(t42)), $[10] = documentId, $[11] = documentStore.pair, $[12] = documentType, $[13] = path, $[14] = t3;
  } else
    t3 = $[14];
  const readUpstreamHead = t3;
  let t4;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    isLoading: !0
  }, $[17] = t4) : t4 = $[17];
  const upstreamBase = useObservable(readUpstreamBase, t4);
  let t5;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    isLoading: !0
  }, $[18] = t5) : t5 = $[18];
  const upstreamHead = useObservable(readUpstreamHead, t5), isLoading = upstreamBase.isLoading || upstreamHead.isLoading, isReadOnly = contextReadOnly || isLoading || isActionPending;
  let t6;
  $[19] !== subjectId ? (t6 = getPublishedId(subjectId), $[19] = subjectId, $[20] = t6) : t6 = $[20];
  let t7;
  $[21] !== subjectId ? (t7 = getVersionFromId(subjectId), $[21] = subjectId, $[22] = t7) : t7 = $[22];
  const {
    patch: patch2
  } = useDocumentOperation(t6, documentType, t7);
  let t8;
  $[23] !== divergence || $[24] !== isReadOnly || $[25] !== patch2 || $[26] !== telemetry || $[27] !== upstreamHead ? (t8 = async () => {
    if (isReadOnly || upstreamHead.isLoading || typeof upstreamHead.value > "u")
      return;
    setIsActionPending(!0), telemetry.log(ActedOnDivergence, {
      action: "mark-resolved"
    });
    const markers = await firstValueFrom(createResolutionMarkers(upstreamHead.value.document, divergence).pipe(toArray$2())), patches = createUpsertResolutionMarkerPatches(...markers);
    patch2.execute(patches.map(SanityEncoder.encodePatch));
  }, $[23] = divergence, $[24] = isReadOnly, $[25] = patch2, $[26] = telemetry, $[27] = upstreamHead, $[28] = t8) : t8 = $[28];
  const markResolved = t8;
  let t9;
  $[29] !== allDivergences || $[30] !== divergence.divergences || $[31] !== isReadOnly || $[32] !== patch2 || $[33] !== telemetry || $[34] !== upstreamHead ? (t9 = async () => {
    if (isReadOnly || upstreamHead.isLoading || typeof upstreamHead.value > "u")
      return;
    setIsActionPending(!0), telemetry.log(ActedOnDivergence, {
      action: "take-upstream-value"
    });
    const patches_0 = await firstValueFrom(createTakeFromUpstreamPatches(upstreamHead.value.document, allDivergences, ...divergence.divergences.map(_temp6$6)).pipe(toArray$2()));
    patch2.execute(patches_0.map(SanityEncoder.encodePatch));
  }, $[29] = allDivergences, $[30] = divergence.divergences, $[31] = isReadOnly, $[32] = patch2, $[33] = telemetry, $[34] = upstreamHead, $[35] = t9) : t9 = $[35];
  const takeUpstreamValue = t9;
  let t10;
  return $[36] !== isActionPending || $[37] !== isLoading || $[38] !== isReadOnly || $[39] !== markResolved || $[40] !== takeUpstreamValue || $[41] !== upstreamBase || $[42] !== upstreamHead ? (t10 = {
    upstreamBase,
    upstreamHead,
    markResolved,
    takeUpstreamValue,
    isLoading,
    isReadOnly,
    isActionPending
  }, $[36] = isActionPending, $[37] = isLoading, $[38] = isReadOnly, $[39] = markResolved, $[40] = takeUpstreamValue, $[41] = upstreamBase, $[42] = upstreamHead, $[43] = t10) : t10 = $[43], t10;
}
function _temp6$6(t0) {
  const [divergencePath] = t0;
  return fromString(divergencePath);
}
function _temp5$c(value_2) {
  return {
    isLoading: !1,
    value: value_2
  };
}
function _temp4$l(document_1) {
  return document_1 !== null;
}
function _temp3$L(value_0) {
  return {
    isLoading: !1,
    value: value_0
  };
}
function _temp2$1B(t0) {
  const {
    document: document2
  } = t0;
  return document2;
}
function _temp$3K(revision) {
  return revision !== null;
}
function createResolutionMarkers(document2, reachableDivergence) {
  return from(reachableDivergence.divergences).pipe(mergeMap$1(([path, divergence]) => zip(of(get$1(document2, path)), of(divergence))), mergeMap$1(([value, divergence]) => {
    if (divergence.effect === "move")
      throw new Error('Resolution of "move" divergences not implemented');
    if (typeof value > "u")
      throw new Error(`Could not resolve upstream value at \`${divergence.path}\``);
    return zip(of(divergence.path), zip(of(createDocumentRevisionMarker(document2._id, document2._rev)), from(hashData(value))));
  }));
}
const DivergenceOverlay = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "DivergenceOverlay",
  componentId: "sc-k99oih-0"
})(({
  $path,
  $layer,
  ...props2
}) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    inline-size: 100%;
    margin-block-start: ${theme.space[3]}px;

    @supports (position-anchor: --anchor) {
      position: fixed;
      position-anchor: ${pathToAnchorIdent("input", $path)};
      position-area: block-end span-all;
      position-try-fallbacks: flip-block;
      inline-size: calc(anchor-size(inline) + ${theme.space[5]}px);
      z-index: ${$layer.zIndex};
    }
  `;
}), sectionPadding = 4, DivergenceDetail = (t0) => {
  const $ = c(114), {
    divergenceNavigator,
    divergence,
    containerElement,
    readOnly: contextReadOnly
  } = t0, {
    upstreamBase,
    upstreamHead,
    markResolved,
    takeUpstreamValue,
    isReadOnly,
    isActionPending,
    isLoading
  } = useDivergenceController(divergence, divergenceNavigator.state.allDivergences, contextReadOnly ?? !1), {
    release: upstreamRelease,
    state: upstreamReleaseState
  } = useVersionRelease(divergence.documentId);
  let t1;
  $[0] !== divergence.schemaType || $[1] !== isLoading || $[2] !== upstreamBase?.value?.value || $[3] !== upstreamHead?.value?.value ? (t1 = isLoading ? void 0 : diffInput(wrap$1(upstreamBase?.value?.value ?? emptyValuesByType[divergence.schemaType.jsonType], {}), wrap$1(upstreamHead?.value?.value ?? emptyValuesByType[divergence.schemaType.jsonType], {}), {}), $[0] = divergence.schemaType, $[1] = isLoading, $[2] = upstreamBase?.value?.value, $[3] = upstreamHead?.value?.value, $[4] = t1) : t1 = $[4];
  const diff = t1;
  let t2;
  $[5] !== divergence.diffComponent ? (t2 = normalizeDiffComponent(divergence.diffComponent), $[5] = divergence.diffComponent, $[6] = t2) : t2 = $[6];
  const DiffComponent = t2;
  let t3;
  $[7] !== divergence.path ? (t3 = (t44) => {
    const [path] = t44;
    return path === divergence.path;
  }, $[7] = divergence.path, $[8] = t3) : t3 = $[8];
  const divergenceIndex = divergenceNavigator.state.divergences.findIndex(t3), {
    t
  } = useTranslation(), layer = useLayer();
  let t4;
  $[9] !== upstreamHead?.value?.document ? (t4 = upstreamHead?.value?.document ?? {}, $[9] = upstreamHead?.value?.document, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== divergence.documentId || $[12] !== divergence.schemaType || $[13] !== t4 ? (t5 = {
    documentId: divergence.documentId,
    schemaType: divergence.schemaType,
    isComparingCurrent: !1,
    FieldWrapper: Fragment,
    rootDiff: null,
    value: t4,
    showFromValue: !0
  }, $[11] = divergence.documentId, $[12] = divergence.schemaType, $[13] = t4, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] !== divergence.path ? (t6 = fromString(divergence.path), $[15] = divergence.path, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== divergence.schemaType || $[18] !== t || $[19] !== upstreamRelease || $[20] !== upstreamReleaseState ? (t7 = upstreamReleaseState === "loaded" && t("divergence.effect.summary", {
    title: divergence.schemaType.title,
    effect: t("divergence.effect.changed"),
    versionName: typeof upstreamRelease == "string" ? upstreamRelease : upstreamRelease?.metadata.title
  }), $[17] = divergence.schemaType, $[18] = t, $[19] = upstreamRelease, $[20] = upstreamReleaseState, $[21] = t7) : t7 = $[21];
  let t8;
  $[22] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { paddingX: sectionPadding, paddingY: sectionPadding, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t7 }) }), $[22] = t7, $[23] = t8) : t8 = $[23];
  let t9;
  $[24] !== t ? (t9 = t("divergence.action.close.label"), $[24] = t, $[25] = t9) : t9 = $[25];
  const t10 = divergenceNavigator.blurFocusedDivergence;
  let t11;
  $[26] !== t ? (t11 = t("divergence.action.close.label"), $[26] = t, $[27] = t11) : t11 = $[27];
  let t12;
  $[28] !== t11 ? (t12 = {
    content: t11,
    portal: !0
  }, $[28] = t11, $[29] = t12) : t12 = $[29];
  let t13;
  $[30] !== divergenceNavigator.blurFocusedDivergence || $[31] !== t12 || $[32] !== t9 ? (t13 = /* @__PURE__ */ jsx(Box, { paddingLeft: sectionPadding, paddingRight: 3, children: /* @__PURE__ */ jsx(Button, { "aria-label": t9, icon: CloseIcon, mode: "bleed", onClick: t10, tooltipProps: t12 }) }), $[30] = divergenceNavigator.blurFocusedDivergence, $[31] = t12, $[32] = t9, $[33] = t13) : t13 = $[33];
  let t14;
  $[34] !== t13 || $[35] !== t8 ? (t14 = /* @__PURE__ */ jsxs(Flex, { justify: "space-between", align: "center", children: [
    t8,
    t13
  ] }), $[34] = t13, $[35] = t8, $[36] = t14) : t14 = $[36];
  let t15;
  $[37] !== DiffComponent || $[38] !== diff || $[39] !== divergence.schemaType || $[40] !== isLoading ? (t15 = /* @__PURE__ */ jsx(Card, { padding: sectionPadding, borderTop: !0, borderBottom: !0, children: isLoading ? /* @__PURE__ */ jsx(Skeleton, { animated: !0, delay: 1e3, radius: 1, style: {
    width: "100%",
    aspectRatio: "1/0.125"
  } }) : /* @__PURE__ */ jsx(Fragment$1, { children: diff && DiffComponent && /* @__PURE__ */ jsx(DiffComponent, { diff, schemaType: divergence.schemaType }) }) }), $[37] = DiffComponent, $[38] = diff, $[39] = divergence.schemaType, $[40] = isLoading, $[41] = t15) : t15 = $[41];
  let t16;
  $[42] !== t ? (t16 = t("divergence.action.markResolved.label"), $[42] = t, $[43] = t16) : t16 = $[43];
  let t17;
  $[44] !== isReadOnly || $[45] !== markResolved || $[46] !== t16 ? (t17 = /* @__PURE__ */ jsx(Button, { mode: "ghost", tone: "neutral", text: t16, type: "button", onClick: markResolved, disabled: isReadOnly }), $[44] = isReadOnly, $[45] = markResolved, $[46] = t16, $[47] = t17) : t17 = $[47];
  let t18;
  $[48] !== t ? (t18 = t("divergence.action.takeFromUpstream.label"), $[48] = t, $[49] = t18) : t18 = $[49];
  let t19;
  $[50] !== isReadOnly || $[51] !== t18 || $[52] !== takeUpstreamValue ? (t19 = /* @__PURE__ */ jsx(Button, { mode: "ghost", tone: "neutral", text: t18, type: "button", onClick: takeUpstreamValue, disabled: isReadOnly }), $[50] = isReadOnly, $[51] = t18, $[52] = takeUpstreamValue, $[53] = t19) : t19 = $[53];
  let t20;
  $[54] !== t17 || $[55] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "center", children: [
    t17,
    t19
  ] }), $[54] = t17, $[55] = t19, $[56] = t20) : t20 = $[56];
  let t21;
  $[57] !== isActionPending ? (t21 = isActionPending && /* @__PURE__ */ jsx(Spinner, {}), $[57] = isActionPending, $[58] = t21) : t21 = $[58];
  let t22;
  $[59] !== t20 || $[60] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Flex, { flex: 1, gap: 3, align: "center", children: [
    t20,
    t21
  ] }), $[59] = t20, $[60] = t21, $[61] = t22) : t22 = $[61];
  let t23;
  $[62] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t23 = {
    justifyContent: "flex-end"
  }, $[62] = t23) : t23 = $[62];
  const t24 = divergenceIndex + 1;
  let t25;
  $[63] !== divergenceNavigator.state.divergences.length || $[64] !== t || $[65] !== t24 ? (t25 = t("divergence.pagination", {
    position: t24,
    count: divergenceNavigator.state.divergences.length
  }), $[63] = divergenceNavigator.state.divergences.length, $[64] = t, $[65] = t24, $[66] = t25) : t25 = $[66];
  let t26;
  $[67] !== t25 ? (t26 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t25 }), $[67] = t25, $[68] = t26) : t26 = $[68];
  let t27;
  $[69] !== t ? (t27 = t("divergence.action.previous.label"), $[69] = t, $[70] = t27) : t27 = $[70];
  let t28;
  $[71] !== t ? (t28 = t("divergence.action.previous.label"), $[71] = t, $[72] = t28) : t28 = $[72];
  let t29;
  $[73] !== t28 ? (t29 = {
    content: t28
  }, $[73] = t28, $[74] = t29) : t29 = $[74];
  const t30 = divergenceNavigator.state.divergences.length < 2;
  let t31;
  $[75] !== divergenceNavigator ? (t31 = () => {
    typeof divergenceNavigator.state.previousDivergence < "u" && divergenceNavigator.focusDivergence(divergenceNavigator.state.previousDivergence);
  }, $[75] = divergenceNavigator, $[76] = t31) : t31 = $[76];
  let t32;
  $[77] !== t27 || $[78] !== t29 || $[79] !== t30 || $[80] !== t31 ? (t32 = /* @__PURE__ */ jsx(Button, { "aria-label": t27, tooltipProps: t29, mode: "ghost", tone: "neutral", icon: ArrowLeftIcon, type: "button", disabled: t30, onClick: t31 }), $[77] = t27, $[78] = t29, $[79] = t30, $[80] = t31, $[81] = t32) : t32 = $[81];
  let t33;
  $[82] !== t ? (t33 = t("divergence.action.next.label"), $[82] = t, $[83] = t33) : t33 = $[83];
  let t34;
  $[84] !== t ? (t34 = t("divergence.action.next.label"), $[84] = t, $[85] = t34) : t34 = $[85];
  let t35;
  $[86] !== t34 ? (t35 = {
    content: t34
  }, $[86] = t34, $[87] = t35) : t35 = $[87];
  const t36 = divergenceNavigator.state.divergences.length < 2;
  let t37;
  $[88] !== divergenceNavigator ? (t37 = () => {
    typeof divergenceNavigator.state.nextDivergence < "u" && divergenceNavigator.focusDivergence(divergenceNavigator.state.nextDivergence);
  }, $[88] = divergenceNavigator, $[89] = t37) : t37 = $[89];
  let t38;
  $[90] !== t33 || $[91] !== t35 || $[92] !== t36 || $[93] !== t37 ? (t38 = /* @__PURE__ */ jsx(Button, { "aria-label": t33, tooltipProps: t35, mode: "ghost", tone: "neutral", icon: ArrowRightIcon, type: "button", disabled: t36, onClick: t37 }), $[90] = t33, $[91] = t35, $[92] = t36, $[93] = t37, $[94] = t38) : t38 = $[94];
  let t39;
  $[95] !== t26 || $[96] !== t32 || $[97] !== t38 ? (t39 = /* @__PURE__ */ jsxs(Flex, { flex: 1, gap: 2, style: t23, align: "center", children: [
    t26,
    t32,
    t38
  ] }), $[95] = t26, $[96] = t32, $[97] = t38, $[98] = t39) : t39 = $[98];
  let t40;
  $[99] !== t22 || $[100] !== t39 ? (t40 = /* @__PURE__ */ jsx(Box, { paddingX: sectionPadding, paddingY: sectionPadding - 1, children: /* @__PURE__ */ jsxs(Flex, { flex: 1, gap: 2, justify: "space-between", children: [
    t22,
    t39
  ] }) }), $[99] = t22, $[100] = t39, $[101] = t40) : t40 = $[101];
  let t41;
  $[102] !== layer || $[103] !== t14 || $[104] !== t15 || $[105] !== t40 || $[106] !== t6 ? (t41 = /* @__PURE__ */ jsxs(DivergenceOverlay, { open: !0, border: !0, radius: 3, shadow: 2, $path: t6, contentEditable: !1, $layer: layer, children: [
    t14,
    t15,
    t40
  ] }), $[102] = layer, $[103] = t14, $[104] = t15, $[105] = t40, $[106] = t6, $[107] = t41) : t41 = $[107];
  let t42;
  $[108] !== containerElement || $[109] !== t41 ? (t42 = /* @__PURE__ */ jsx("div", { ref: containerElement, children: t41 }), $[108] = containerElement, $[109] = t41, $[110] = t42) : t42 = $[110];
  let t43;
  return $[111] !== t42 || $[112] !== t5 ? (t43 = /* @__PURE__ */ jsx(DocumentChangeContext.Provider, { value: t5, children: t42 }), $[111] = t42, $[112] = t5, $[113] = t43) : t43 = $[113], t43;
};
function normalizeDiffComponent(diffComponent) {
  if (!(typeof diffComponent > "u"))
    return "component" in diffComponent ? diffComponent.component : diffComponent;
}
const canUseAnchorPositioning = "CSS" in globalThis && typeof CSS.supports == "function" ? CSS.supports("(position-anchor: --anchor)") : !1, FormNodeDivergenceDetail = (t0) => {
  const $ = c(22), {
    children,
    path,
    readOnly
  } = t0, {
    advancedVersionControl: t1
  } = useWorkspace(), {
    enabled: advancedVersionControlEnabled
  } = t1, containerElement = useRef(null), divergenceDetailContainerElement = useRef(null), divergenceNavigator = useDocumentDivergences();
  let t2;
  $[0] !== divergenceNavigator.state || $[1] !== path ? (t2 = selectDivergence(divergenceNavigator.state, path), $[0] = divergenceNavigator.state, $[1] = path, $[2] = t2) : t2 = $[2];
  const divergence = t2;
  let t3;
  $[3] !== divergence?.path || $[4] !== divergenceNavigator.state.focusedDivergence ? (t3 = () => {
    typeof divergenceNavigator.state.focusedDivergence < "u" && divergenceNavigator.state.focusedDivergence === divergence?.path && containerElement.current?.parentElement?.scrollIntoView({
      block: "center"
    });
  }, $[3] = divergence?.path, $[4] = divergenceNavigator.state.focusedDivergence, $[5] = t3) : t3 = $[5];
  const t4 = divergence?.path;
  let t5;
  $[6] !== divergenceNavigator.state.focusedDivergence || $[7] !== t4 ? (t5 = [divergenceNavigator.state.focusedDivergence, t4], $[6] = divergenceNavigator.state.focusedDivergence, $[7] = t4, $[8] = t5) : t5 = $[8], useEffect(t3, t5);
  let t6;
  $[9] !== divergence || $[10] !== divergenceNavigator ? (t6 = () => {
    typeof divergenceNavigator.state.focusedDivergence < "u" && divergenceNavigator.state.focusedDivergence === divergence?.path && divergenceNavigator?.blurDivergence(divergence.path);
  }, $[9] = divergence, $[10] = divergenceNavigator, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = () => [containerElement.current, divergenceDetailContainerElement.current], $[12] = t7) : t7 = $[12], useClickOutsideEvent(t6, t7);
  const MaybePortal = canUseAnchorPositioning ? Portal : Fragment;
  if (!advancedVersionControlEnabled)
    return children;
  let t8;
  $[13] !== divergence || $[14] !== divergenceNavigator || $[15] !== readOnly ? (t8 = divergence && divergence.status === "unresolved" && divergenceNavigator.state.focusedDivergence === divergence.path && /* @__PURE__ */ jsx(motion.div, { initial: {
    opacity: 0
  }, exit: {
    opacity: 0
  }, animate: {
    opacity: 1
  }, transition: {
    duration: 0.1
  }, children: /* @__PURE__ */ jsx(DivergenceDetail, { containerElement: divergenceDetailContainerElement, divergence, divergenceNavigator, readOnly }) }), $[13] = divergence, $[14] = divergenceNavigator, $[15] = readOnly, $[16] = t8) : t8 = $[16];
  let t9;
  $[17] !== t8 ? (t9 = /* @__PURE__ */ jsx(MaybePortal, { children: /* @__PURE__ */ jsx(LayerProvider, { zOffset: 1, children: /* @__PURE__ */ jsx(AnimatePresence, { children: t8 }) }) }), $[17] = t8, $[18] = t9) : t9 = $[18];
  let t10;
  return $[19] !== children || $[20] !== t9 ? (t10 = /* @__PURE__ */ jsxs("div", { ref: containerElement, children: [
    children,
    t9
  ] }), $[19] = children, $[20] = t9, $[21] = t10) : t10 = $[21], t10;
};
function DocumentIdProvider(props2) {
  const $ = c(5);
  let t0;
  $[0] !== props2.id ? (t0 = {
    id: props2.id
  }, $[0] = props2.id, $[1] = t0) : t0 = $[1];
  const value = t0;
  let t1;
  return $[2] !== props2.children || $[3] !== value ? (t1 = /* @__PURE__ */ jsx(DocumentIdContext.Provider, { value, children: props2.children }), $[2] = props2.children, $[3] = value, $[4] = t1) : t1 = $[4], t1;
}
function useGivenDocumentId() {
  const ctx = useContext(DocumentIdContext);
  if (!ctx)
    throw new Error("useDocumentId must be used within a DocumentIdProvider");
  return ctx.id;
}
function usePublishedId$1() {
  const $ = c(2), t0 = useGivenDocumentId();
  let t1;
  return $[0] !== t0 ? (t1 = getPublishedId(t0), $[0] = t0, $[1] = t1) : t1 = $[1], t1;
}
const POPOVER_PROPS$6 = {
  placement: "right",
  fallbackPlacements: ["top", "bottom"]
};
function FieldActionMenuGroup(props2) {
  const $ = c(14), {
    group: group2
  } = props2, {
    title
  } = useI18nText(group2);
  if (group2.expanded) {
    let t02;
    $[0] !== title ? (t02 = /* @__PURE__ */ jsx(Box, { padding: 2, paddingTop: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: title }) }), $[0] = title, $[1] = t02) : t02 = $[1];
    let t12;
    $[2] !== group2.children ? (t12 = group2.children.map((item, idx) => /* @__PURE__ */ jsx(FieldActionMenuNode, { action: item, isFirst: idx === 0, prevIsGroup: group2.children[idx - 1]?.type === "group" }, idx)), $[2] = group2.children, $[3] = t12) : t12 = $[3];
    let t22;
    return $[4] !== t02 || $[5] !== t12 ? (t22 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
      t02,
      t12
    ] }), $[4] = t02, $[5] = t12, $[6] = t22) : t22 = $[6], t22;
  }
  const t0 = group2.icon, t1 = group2.tone;
  let t2;
  $[7] !== group2.children ? (t2 = group2.children.map((item_0, idx_0) => /* @__PURE__ */ jsx(FieldActionMenuNode, { action: item_0, isFirst: idx_0 === 0, prevIsGroup: group2.children[idx_0 - 1]?.type === "group" }, idx_0)), $[7] = group2.children, $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== group2.icon || $[10] !== group2.tone || $[11] !== t2 || $[12] !== title ? (t3 = /* @__PURE__ */ jsx(MenuGroup, { icon: t0, popover: POPOVER_PROPS$6, text: title, tone: t1, children: t2 }), $[9] = group2.icon, $[10] = group2.tone, $[11] = t2, $[12] = title, $[13] = t3) : t3 = $[13], t3;
}
function FieldActionMenuItem(props2) {
  const $ = c(15), {
    action
  } = props2, {
    title
  } = useI18nText(action);
  let t0;
  $[0] !== action ? (t0 = () => {
    action.onAction();
  }, $[0] = action, $[1] = t0) : t0 = $[1];
  const handleClick = t0;
  let t1;
  $[2] !== action.disabled ? (t1 = typeof action.disabled == "object" && /* @__PURE__ */ jsx(Text$1, { size: 1, children: action.disabled.reason }), $[2] = action.disabled, $[3] = t1) : t1 = $[3];
  const disabledTooltipContent = t1, t2 = !!action.disabled, t3 = action.iconRight || (action.selected ? CheckmarkIcon : void 0);
  let t4;
  $[4] !== action.icon || $[5] !== action.selected || $[6] !== action.tone || $[7] !== handleClick || $[8] !== t2 || $[9] !== t3 || $[10] !== title ? (t4 = /* @__PURE__ */ jsx(MenuItem, { disabled: t2, icon: action.icon, iconRight: t3, onClick: handleClick, pressed: action.selected, text: title, tone: action.tone }), $[4] = action.icon, $[5] = action.selected, $[6] = action.tone, $[7] = handleClick, $[8] = t2, $[9] = t3, $[10] = title, $[11] = t4) : t4 = $[11];
  let t5;
  return $[12] !== disabledTooltipContent || $[13] !== t4 ? (t5 = /* @__PURE__ */ jsx(TooltipOfDisabled, { content: disabledTooltipContent, placement: "left", children: t4 }), $[12] = disabledTooltipContent, $[13] = t4, $[14] = t5) : t5 = $[14], t5;
}
function FieldActionMenuNode(props2) {
  const $ = c(15), {
    action,
    isFirst,
    prevIsGroup
  } = props2;
  if (action.type === "divider") {
    let t02;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(MenuDivider, {}), $[0] = t02) : t02 = $[0], t02;
  }
  if (action.type === "group") {
    let t02;
    $[1] !== isFirst ? (t02 = !isFirst && /* @__PURE__ */ jsx(MenuDivider, {}), $[1] = isFirst, $[2] = t02) : t02 = $[2];
    let t12;
    $[3] !== action ? (t12 = /* @__PURE__ */ jsx(FieldActionMenuGroup, { group: action }), $[3] = action, $[4] = t12) : t12 = $[4];
    let t22;
    return $[5] !== t02 || $[6] !== t12 ? (t22 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
      t02,
      t12
    ] }), $[5] = t02, $[6] = t12, $[7] = t22) : t22 = $[7], t22;
  }
  let t0;
  $[8] !== prevIsGroup ? (t0 = prevIsGroup && /* @__PURE__ */ jsx(MenuDivider, {}), $[8] = prevIsGroup, $[9] = t0) : t0 = $[9];
  let t1;
  $[10] !== action ? (t1 = /* @__PURE__ */ jsx(FieldActionMenuItem, { action }), $[10] = action, $[11] = t1) : t1 = $[11];
  let t2;
  return $[12] !== t0 || $[13] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t0,
    t1
  ] }), $[12] = t0, $[13] = t1, $[14] = t2) : t2 = $[14], t2;
}
const STATUS_BUTTON_TOOLTIP_PROPS = {
  placement: "top"
};
function renderAsButton(node) {
  return "renderAsButton" in node && node.renderAsButton;
}
const FieldActionMenu = memo(function(props2) {
  const $ = c(20), {
    nodes,
    onMenuOpenChange
  } = props2, [open, setOpen] = useState(!1);
  let t0;
  $[0] !== onMenuOpenChange ? (t0 = () => {
    onMenuOpenChange(!0), setOpen(!0);
  }, $[0] = onMenuOpenChange, $[1] = t0) : t0 = $[1];
  const handleOpen = t0;
  let t1;
  $[2] !== onMenuOpenChange ? (t1 = () => {
    onMenuOpenChange(!1), setOpen(!1);
  }, $[2] = onMenuOpenChange, $[3] = t1) : t1 = $[3];
  const handleClose = t1;
  let t2;
  $[4] !== nodes ? (t2 = nodes.filter(renderAsButton), $[4] = nodes, $[5] = t2) : t2 = $[5];
  const buttonNodes = t2;
  let t3;
  $[6] !== nodes ? (t3 = nodes.filter(_temp$3J), $[6] = nodes, $[7] = t3) : t3 = $[7];
  const menuNodesProp = t3;
  let t4;
  bb0: {
    const len = menuNodesProp.length;
    if (len === 0 || len > 1) {
      t4 = menuNodesProp;
      break bb0;
    }
    const node_0 = menuNodesProp[0];
    if (node_0.type === "group") {
      let t52;
      $[8] !== node_0 ? (t52 = [{
        ...node_0,
        expanded: !0
      }], $[8] = node_0, $[9] = t52) : t52 = $[9], t4 = t52;
      break bb0;
    }
    t4 = menuNodesProp;
  }
  const menuNodes = t4;
  let t5;
  $[10] !== menuNodes ? (t5 = menuNodes.length ? [{
    type: "group",
    children: menuNodes,
    icon: EllipsisHorizontalIcon,
    title: "Field actions"
  }] : [], $[10] = menuNodes, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== buttonNodes || $[13] !== t5 ? (t6 = [...t5, ...buttonNodes], $[12] = buttonNodes, $[13] = t5, $[14] = t6) : t6 = $[14];
  const rootNodes = t6;
  let t7;
  return $[15] !== handleClose || $[16] !== handleOpen || $[17] !== open || $[18] !== rootNodes ? (t7 = /* @__PURE__ */ jsx(Fragment$1, { children: rootNodes.map((node_1, idx) => /* @__PURE__ */ jsx(RootFieldActionMenuNode, { node: node_1, onOpen: handleOpen, onClose: handleClose, open }, idx)) }), $[15] = handleClose, $[16] = handleOpen, $[17] = open, $[18] = rootNodes, $[19] = t7) : t7 = $[19], t7;
}), RootFieldActionMenuNode = memo(function(props2) {
  const $ = c(12), {
    node,
    onOpen,
    onClose,
    open
  } = props2;
  if (node.type === "divider") {
    let t02;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(Card, { borderLeft: !0, flex: "none" }), $[0] = t02) : t02 = $[0], t02;
  }
  if (node.type === "action") {
    let t02;
    $[1] !== node.title ? (t02 = {
      ...STATUS_BUTTON_TOOLTIP_PROPS,
      content: node.title
    }, $[1] = node.title, $[2] = t02) : t02 = $[2];
    let t1;
    return $[3] !== node.icon || $[4] !== node.onAction || $[5] !== t02 ? (t1 = /* @__PURE__ */ jsx(Button, { icon: node.icon, mode: "bleed", onClick: node.onAction, tooltipProps: t02 }), $[3] = node.icon, $[4] = node.onAction, $[5] = t02, $[6] = t1) : t1 = $[6], t1;
  }
  let t0;
  return $[7] !== node || $[8] !== onClose || $[9] !== onOpen || $[10] !== open ? (t0 = /* @__PURE__ */ jsx(RootFieldActionMenuGroup, { node, onOpen, onClose, open }), $[7] = node, $[8] = onClose, $[9] = onOpen, $[10] = open, $[11] = t0) : t0 = $[11], t0;
}), ROOT_MENU_BUTTON_POPOVER_PROPS = {
  constrainSize: !0,
  placement: "right",
  portal: !0,
  fallbackPlacements: ["top", "bottom"]
};
function RootFieldActionMenuGroup(props2) {
  const $ = c(16), {
    node,
    onOpen,
    onClose,
    open
  } = props2, {
    title
  } = useI18nText(node), t0 = open ? void 0 : title;
  let t1;
  $[0] !== node.title ? (t1 = {
    ...STATUS_BUTTON_TOOLTIP_PROPS,
    content: node.title
  }, $[0] = node.title, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== node.icon || $[3] !== t0 || $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(Button, { "aria-label": t0, "data-testid": "field-actions-trigger", icon: node.icon, mode: "bleed", tabIndex: 0, tooltipProps: t1 }), $[2] = node.icon, $[3] = t0, $[4] = t1, $[5] = t2) : t2 = $[5];
  const t3 = useId();
  let t4;
  $[6] !== node.children ? (t4 = node.children.map((action, idx) => /* @__PURE__ */ jsx(FieldActionMenuNode, { action, isFirst: idx === 0, prevIsGroup: node.children[idx - 1]?.type === "group" }, idx)), $[6] = node.children, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(Menu, { children: t4 }), $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  return $[10] !== onClose || $[11] !== onOpen || $[12] !== t2 || $[13] !== t3 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(MenuButton, { button: t2, id: t3, menu: t5, onOpen, onClose, popover: ROOT_MENU_BUTTON_POPOVER_PROPS }), $[10] = onClose, $[11] = onOpen, $[12] = t2, $[13] = t3, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
}
function _temp$3J(node) {
  return !renderAsButton(node);
}
function useHoveredField() {
  return useContext(HoveredFieldContext);
}
const FieldActionsProvider = memo(function(props2) {
  const $ = c(20), {
    actions,
    children,
    path,
    focused,
    __internal_comments,
    __internal_slot
  } = props2, {
    onMouseEnter: onFieldMouseEnter,
    onMouseLeave: onFieldMouseLeave,
    store: hoveredStore
  } = useHoveredField();
  let t0;
  $[0] !== hoveredStore || $[1] !== path ? (t0 = () => {
    const [hoveredPath] = hoveredStore.getSnapshot();
    return supportsTouch || (hoveredPath ? pathToString$1(path) === hoveredPath : !1);
  }, $[0] = hoveredStore, $[1] = path, $[2] = t0) : t0 = $[2];
  const hovered = useSyncExternalStore(hoveredStore.subscribe, t0);
  let t1;
  $[3] !== onFieldMouseEnter || $[4] !== path ? (t1 = () => {
    onFieldMouseEnter(path);
  }, $[3] = onFieldMouseEnter, $[4] = path, $[5] = t1) : t1 = $[5];
  const handleMouseEnter = t1;
  let t2;
  $[6] !== onFieldMouseLeave || $[7] !== path ? (t2 = () => {
    onFieldMouseLeave(path);
  }, $[6] = onFieldMouseLeave, $[7] = path, $[8] = t2) : t2 = $[8];
  const handleMouseLeave = t2;
  let t3;
  $[9] !== __internal_comments || $[10] !== __internal_slot || $[11] !== actions || $[12] !== focused || $[13] !== handleMouseEnter || $[14] !== handleMouseLeave || $[15] !== hovered ? (t3 = {
    actions,
    focused,
    hovered,
    __internal_comments,
    __internal_slot,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, $[9] = __internal_comments, $[10] = __internal_slot, $[11] = actions, $[12] = focused, $[13] = handleMouseEnter, $[14] = handleMouseLeave, $[15] = hovered, $[16] = t3) : t3 = $[16];
  const context = t3;
  let t4;
  return $[17] !== children || $[18] !== context ? (t4 = /* @__PURE__ */ jsx(FieldActionsContext.Provider, { value: context, children }), $[17] = children, $[18] = context, $[19] = t4) : t4 = $[19], t4;
});
FieldActionsProvider.displayName = "Memo(FieldActionsProvider)";
function filterActions(actions) {
  return actions.filter(Boolean).filter((node) => "hidden" in node ? node.hidden !== !0 : !0).map((node) => node.type === "group" ? {
    ...node,
    children: filterActions(node.children)
  } : node);
}
const FieldActionsResolver = memo(function(props2) {
  const $ = c(25), {
    actions,
    documentId,
    documentType,
    onActions,
    path,
    schemaType
  } = props2, len = actions.length, lenRef = useRef(len);
  let t0;
  $[0] !== len ? (t0 = () => Array.from(new Array(len)), $[0] = len, $[1] = t0) : t0 = $[1];
  const [fieldActions, setFieldActions] = useState(t0), fieldActionsRef = useRef(fieldActions);
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (index, node) => {
    setFieldActions((prev) => {
      const next = [...prev];
      return next[index] = node, next;
    });
  }, $[2] = t1) : t1 = $[2];
  const setFieldAction = t1;
  let t2, t3;
  $[3] !== fieldActions || $[4] !== onActions ? (t2 = () => {
    fieldActionsRef.current !== fieldActions && (fieldActionsRef.current = fieldActions, onActions(filterActions(fieldActions)));
  }, t3 = [fieldActions, onActions], $[3] = fieldActions, $[4] = onActions, $[5] = t2, $[6] = t3) : (t2 = $[5], t3 = $[6]), useEffect(t2, t3);
  let t4, t5;
  $[7] !== len ? (t4 = () => {
    if (lenRef.current !== len) {
      const newFieldActions = Array.from(new Array(len));
      for (let i = 0; i < len; i++)
        newFieldActions[i] = fieldActionsRef.current[i];
      lenRef.current = len, setFieldActions(newFieldActions), fieldActionsRef.current = newFieldActions;
    }
  }, t5 = [len], $[7] = len, $[8] = t4, $[9] = t5) : (t4 = $[8], t5 = $[9]), useEffect(t4, t5);
  let t6;
  if ($[10] !== actions || $[11] !== documentId || $[12] !== documentType || $[13] !== path || $[14] !== schemaType) {
    let t72;
    $[16] !== documentId || $[17] !== documentType || $[18] !== path || $[19] !== schemaType ? (t72 = (action, index_0) => defineFieldActionComponent({
      action,
      documentId,
      documentType,
      index: index_0,
      path,
      schemaType,
      setFieldAction
    }), $[16] = documentId, $[17] = documentType, $[18] = path, $[19] = schemaType, $[20] = t72) : t72 = $[20], t6 = actions.map(t72), $[10] = actions, $[11] = documentId, $[12] = documentType, $[13] = path, $[14] = schemaType, $[15] = t6;
  } else
    t6 = $[15];
  const FieldActions = t6;
  let t7;
  $[21] !== FieldActions ? (t7 = FieldActions.map(_temp$3I), $[21] = FieldActions, $[22] = t7) : t7 = $[22];
  let t8;
  return $[23] !== t7 ? (t8 = /* @__PURE__ */ jsx(Fragment$1, { children: t7 }), $[23] = t7, $[24] = t8) : t8 = $[24], t8;
});
function defineFieldActionComponent({
  action,
  documentId,
  documentType,
  index,
  path,
  schemaType,
  setFieldAction
}) {
  const {
    useAction
  } = action;
  return memo(function() {
    const $ = c(4);
    let t0;
    $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
      documentId,
      documentType,
      path,
      schemaType
    }, $[0] = t0) : t0 = $[0];
    const _action = useAction(t0), node = useUnique(_action);
    let t1, t2;
    return $[1] !== node ? (t1 = () => {
      setFieldAction(index, node);
    }, t2 = [node], $[1] = node, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2), null;
  });
}
function _temp$3I(FieldAction, key) {
  return /* @__PURE__ */ jsx(FieldAction, {}, key);
}
function useFieldActions() {
  return useContext(FieldActionsContext);
}
const HoveredFieldProvider = memo(function(props2) {
  const $ = c(17), {
    children
  } = props2, [listeners] = useState(_temp$3H);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const hoveredStackRef = useRef(t0);
  let t1;
  $[1] !== listeners ? (t1 = (path) => {
    const pathString = pathToString$1(path);
    if (!hoveredStackRef.current.includes(pathString)) {
      hoveredStackRef.current = [pathString, ...hoveredStackRef.current];
      for (const listener of listeners)
        listener();
    }
  }, $[1] = listeners, $[2] = t1) : t1 = $[2];
  const handleMouseEnter = t1;
  let t2;
  $[3] !== listeners ? (t2 = (path_0) => {
    const pathString_0 = pathToString$1(path_0);
    if (hoveredStackRef.current.includes(pathString_0)) {
      hoveredStackRef.current = hoveredStackRef.current.filter((item) => item !== pathString_0);
      for (const listener_0 of listeners)
        listener_0();
    }
  }, $[3] = listeners, $[4] = t2) : t2 = $[4];
  const handleMouseLeave = t2;
  let t3;
  $[5] !== listeners ? (t3 = (onStoreChange) => (listeners.add(onStoreChange), () => {
    listeners.delete(onStoreChange);
  }), $[5] = listeners, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => hoveredStackRef.current, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t3 ? (t5 = {
    subscribe: t3,
    getSnapshot: t4
  }, $[8] = t3, $[9] = t5) : t5 = $[9];
  const store = t5;
  let t6;
  $[10] !== handleMouseEnter || $[11] !== handleMouseLeave || $[12] !== store ? (t6 = {
    store,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, $[10] = handleMouseEnter, $[11] = handleMouseLeave, $[12] = store, $[13] = t6) : t6 = $[13];
  const context = t6;
  let t7;
  return $[14] !== children || $[15] !== context ? (t7 = /* @__PURE__ */ jsx(HoveredFieldContext.Provider, { value: context, children }), $[14] = children, $[15] = context, $[16] = t7) : t7 = $[16], t7;
});
function _temp$3H() {
  return /* @__PURE__ */ new Set();
}
function useDidUpdate(current, didUpdate, t0) {
  const $ = c(5), compare2 = t0 === void 0 ? shallowEquals : t0, previous = useRef(void 0);
  let t1, t2;
  $[0] !== compare2 || $[1] !== current || $[2] !== didUpdate ? (t1 = () => {
    compare2(previous.current, current) || (didUpdate(previous.current, current), previous.current = current);
  }, t2 = [compare2, current, didUpdate], $[0] = compare2, $[1] = current, $[2] = didUpdate, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]), useEffect(t1, t2);
}
function useScrollIntoViewOnFocusWithin(elementRef, hasFocusWithin) {
  const $ = c(2);
  let t0;
  return $[0] !== elementRef ? (t0 = (hadFocus, hasFocus) => {
    elementRef.current && !hadFocus && hasFocus && scrollIntoView$1(elementRef.current, {
      scrollMode: "always"
    });
  }, $[0] = elementRef, $[1] = t0) : t0 = $[1], useDidUpdate(hasFocusWithin, t0);
}
function ReferenceField(props2) {
  const $ = c(28), elementRef = useRef(null), {
    schemaType,
    path,
    open,
    inputId,
    children,
    inputProps
  } = props2;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const [fieldActionsNodes, setFieldActionNodes] = useState(t0), documentId = usePublishedId$1();
  useScrollIntoViewOnFocusWithin(elementRef, open);
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && elementRef.current && elementRef.current.focus();
  }, $[1] = t1) : t1 = $[1], useDidUpdate(inputProps.focused, t1);
  let t2;
  $[2] !== documentId || $[3] !== path || $[4] !== props2.actions || $[5] !== schemaType ? (t2 = documentId && props2.actions && props2.actions.length > 0 && /* @__PURE__ */ jsx(FieldActionsResolver, { actions: props2.actions, documentId, documentType: schemaType.name, onActions: setFieldActionNodes, path, schemaType }), $[2] = documentId, $[3] = path, $[4] = props2.actions, $[5] = schemaType, $[6] = t2) : t2 = $[6];
  const t3 = !!props2.inputProps.focused;
  let t4;
  $[7] !== children || $[8] !== fieldActionsNodes || $[9] !== inputId || $[10] !== path || $[11] !== props2.__internal_comments || $[12] !== props2.__internal_slot || $[13] !== props2.description || $[14] !== props2.level || $[15] !== props2.presence || $[16] !== props2.schemaType.deprecated || $[17] !== props2.title || $[18] !== props2.validation ? (t4 = /* @__PURE__ */ jsx(FormField, { __internal_comments: props2.__internal_comments, __internal_slot: props2.__internal_slot, __unstable_headerActions: fieldActionsNodes, __unstable_presence: props2.presence, description: props2.description, inputId, level: props2.level, title: props2.title, validation: props2.validation, deprecated: props2.schemaType.deprecated, path, children }), $[7] = children, $[8] = fieldActionsNodes, $[9] = inputId, $[10] = path, $[11] = props2.__internal_comments, $[12] = props2.__internal_slot, $[13] = props2.description, $[14] = props2.level, $[15] = props2.presence, $[16] = props2.schemaType.deprecated, $[17] = props2.title, $[18] = props2.validation, $[19] = t4) : t4 = $[19];
  let t5;
  $[20] !== fieldActionsNodes || $[21] !== path || $[22] !== t3 || $[23] !== t4 ? (t5 = /* @__PURE__ */ jsx(FieldActionsProvider, { actions: fieldActionsNodes, focused: t3, path, children: t4 }), $[20] = fieldActionsNodes, $[21] = path, $[22] = t3, $[23] = t4, $[24] = t5) : t5 = $[24];
  let t6;
  return $[25] !== t2 || $[26] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t2,
    t5
  ] }), $[25] = t2, $[26] = t5, $[27] = t6) : t6 = $[27], t6;
}
const EMPTY_ARRAY$u = [];
function BooleanField(field) {
  const $ = c(27), documentId = usePublishedId$1(), [fieldActionsNodes, setFieldActionNodes] = useState(EMPTY_ARRAY$u), focused = !!field.inputProps.focused, t0 = field.path, t1 = field.inputProps.readOnly;
  let t2;
  $[0] !== field.path ? (t2 = /* @__PURE__ */ jsx(FormDivergenceIndicator, { path: field.path }), $[0] = field.path, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== documentId || $[3] !== field.actions || $[4] !== field.path || $[5] !== field.schemaType ? (t3 = documentId && field.actions && field.actions.length > 0 && /* @__PURE__ */ jsx(FieldActionsResolver, { actions: field.actions, documentId, documentType: field.schemaType.name, onActions: setFieldActionNodes, path: field.path, schemaType: field.schemaType }), $[2] = documentId, $[3] = field.actions, $[4] = field.path, $[5] = field.schemaType, $[6] = t3) : t3 = $[6];
  const t4 = !!field.inputProps.focused;
  let t5;
  $[7] !== field.__internal_comments || $[8] !== field.__internal_slot || $[9] !== field.children || $[10] !== field.path || $[11] !== fieldActionsNodes || $[12] !== focused ? (t5 = /* @__PURE__ */ jsx(FieldActionsProvider, { __internal_slot: field.__internal_slot, __internal_comments: field.__internal_comments, actions: fieldActionsNodes, focused, path: field.path, children: field.children }), $[7] = field.__internal_comments, $[8] = field.__internal_slot, $[9] = field.children, $[10] = field.path, $[11] = fieldActionsNodes, $[12] = focused, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== field.inputProps.changed || $[15] !== field.path || $[16] !== t4 || $[17] !== t5 ? (t6 = /* @__PURE__ */ jsx(ChangeIndicator, { hasFocus: t4, isChanged: field.inputProps.changed, path: field.path, children: t5 }), $[14] = field.inputProps.changed, $[15] = field.path, $[16] = t4, $[17] = t5, $[18] = t6) : t6 = $[18];
  let t7;
  $[19] !== t2 || $[20] !== t3 || $[21] !== t6 ? (t7 = /* @__PURE__ */ jsxs(FormRow, { gutterStartCell: t2, children: [
    t3,
    t6
  ] }), $[19] = t2, $[20] = t3, $[21] = t6, $[22] = t7) : t7 = $[22];
  let t8;
  return $[23] !== field.inputProps.readOnly || $[24] !== field.path || $[25] !== t7 ? (t8 = /* @__PURE__ */ jsx(FormNodeDivergenceDetail, { path: t0, readOnly: t1, children: t7 }), $[23] = field.inputProps.readOnly, $[24] = field.path, $[25] = t7, $[26] = t8) : t8 = $[26], t8;
}
function DateTimeField(field) {
  const $ = c(22), documentId = usePublishedId$1(), [fieldActionsNodes, setFieldActionNodes] = useState(EMPTY_ARRAY$u), focused = !!field.inputProps.focused;
  let t0;
  $[0] !== field.path ? (t0 = /* @__PURE__ */ jsx(FormDivergenceIndicator, { path: field.path }), $[0] = field.path, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== documentId || $[3] !== field.actions || $[4] !== field.path || $[5] !== field.schemaType ? (t1 = documentId && field.actions && field.actions.length > 0 && /* @__PURE__ */ jsx(FieldActionsResolver, { actions: field.actions, documentId, documentType: field.schemaType.name, onActions: setFieldActionNodes, path: field.path, schemaType: field.schemaType }), $[2] = documentId, $[3] = field.actions, $[4] = field.path, $[5] = field.schemaType, $[6] = t1) : t1 = $[6];
  let t2;
  $[7] !== field.__internal_comments || $[8] !== field.__internal_slot || $[9] !== field.children || $[10] !== field.path || $[11] !== fieldActionsNodes || $[12] !== focused ? (t2 = /* @__PURE__ */ jsx(FieldActionsProvider, { __internal_slot: field.__internal_slot, __internal_comments: field.__internal_comments, actions: fieldActionsNodes, focused, path: field.path, children: field.children }), $[7] = field.__internal_comments, $[8] = field.__internal_slot, $[9] = field.children, $[10] = field.path, $[11] = fieldActionsNodes, $[12] = focused, $[13] = t2) : t2 = $[13];
  let t3;
  $[14] !== t0 || $[15] !== t1 || $[16] !== t2 ? (t3 = /* @__PURE__ */ jsxs(FormRow, { gutterStartCell: t0, children: [
    t1,
    t2
  ] }), $[14] = t0, $[15] = t1, $[16] = t2, $[17] = t3) : t3 = $[17];
  let t4;
  return $[18] !== field.inputProps.readOnly || $[19] !== field.path || $[20] !== t3 ? (t4 = /* @__PURE__ */ jsx(FormNodeDivergenceDetail, { path: field.path, readOnly: field.inputProps.readOnly, children: t3 }), $[18] = field.inputProps.readOnly, $[19] = field.path, $[20] = t3, $[21] = t4) : t4 = $[21], t4;
}
function PrimitiveField$1(field) {
  const $ = c(37), [fieldActionsNodes, setFieldActionNodes] = useState(EMPTY_ARRAY$u), documentId = usePublishedId$1(), focused = !!field.inputProps.focused;
  let t0;
  $[0] !== documentId || $[1] !== field.actions || $[2] !== field.path || $[3] !== field.schemaType ? (t0 = documentId && field.actions && field.actions.length > 0 && /* @__PURE__ */ jsx(FieldActionsResolver, { actions: field.actions, documentId, documentType: field.schemaType.name, onActions: setFieldActionNodes, path: field.path, schemaType: field.schemaType }), $[0] = documentId, $[1] = field.actions, $[2] = field.path, $[3] = field.schemaType, $[4] = t0) : t0 = $[4];
  const t1 = `field-${field.inputId}`;
  let t2;
  $[5] !== field.children || $[6] !== field.inputProps.changed || $[7] !== field.path || $[8] !== focused ? (t2 = /* @__PURE__ */ jsx(ChangeIndicator, { hasFocus: focused, isChanged: field.inputProps.changed, path: field.path, children: field.children }), $[5] = field.children, $[6] = field.inputProps.changed, $[7] = field.path, $[8] = focused, $[9] = t2) : t2 = $[9];
  let t3;
  $[10] !== field.__internal_comments || $[11] !== field.__internal_slot || $[12] !== field.description || $[13] !== field.inputId || $[14] !== field.inputProps.readOnly || $[15] !== field.level || $[16] !== field.path || $[17] !== field.presence || $[18] !== field.schemaType.deprecated || $[19] !== field.title || $[20] !== field.validation || $[21] !== fieldActionsNodes || $[22] !== t2 ? (t3 = /* @__PURE__ */ jsx(FormField, { __internal_slot: field.__internal_slot, __internal_comments: field.__internal_comments, __unstable_headerActions: fieldActionsNodes, __unstable_presence: field.presence, description: field.description, inputId: field.inputId, level: field.level, title: field.title, validation: field.validation, deprecated: field.schemaType.deprecated, path: field.path, readOnly: field.inputProps.readOnly, children: t2 }), $[10] = field.__internal_comments, $[11] = field.__internal_slot, $[12] = field.description, $[13] = field.inputId, $[14] = field.inputProps.readOnly, $[15] = field.level, $[16] = field.path, $[17] = field.presence, $[18] = field.schemaType.deprecated, $[19] = field.title, $[20] = field.validation, $[21] = fieldActionsNodes, $[22] = t2, $[23] = t3) : t3 = $[23];
  let t4;
  $[24] !== t1 || $[25] !== t3 ? (t4 = /* @__PURE__ */ jsx("div", { "data-testid": t1, children: t3 }), $[24] = t1, $[25] = t3, $[26] = t4) : t4 = $[26];
  let t5;
  $[27] !== field.__internal_comments || $[28] !== field.__internal_slot || $[29] !== field.path || $[30] !== fieldActionsNodes || $[31] !== focused || $[32] !== t4 ? (t5 = /* @__PURE__ */ jsx(FieldActionsProvider, { __internal_slot: field.__internal_slot, __internal_comments: field.__internal_comments, actions: fieldActionsNodes, focused, path: field.path, children: t4 }), $[27] = field.__internal_comments, $[28] = field.__internal_slot, $[29] = field.path, $[30] = fieldActionsNodes, $[31] = focused, $[32] = t4, $[33] = t5) : t5 = $[33];
  let t6;
  return $[34] !== t0 || $[35] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t0,
    t5
  ] }), $[34] = t0, $[35] = t5, $[36] = t6) : t6 = $[36], t6;
}
function ObjectOrArrayField(field) {
  const $ = c(38), [fieldActionsNodes, setFieldActionNodes] = useState(EMPTY_ARRAY$u), documentId = usePublishedId$1(), focused = !!field.inputProps.focused, disableActions = field.schemaType.options?.disableActions || EMPTY_ARRAY$u;
  let t0;
  $[0] !== disableActions || $[1] !== field.actions ? (t0 = field.actions?.filter((a) => a.name === "pasteField" ? !disableActions.includes("add") : a.name === "copyField" ? !disableActions.includes("copy") : !0), $[0] = disableActions, $[1] = field.actions, $[2] = t0) : t0 = $[2];
  const actions = t0;
  let t1;
  $[3] !== actions || $[4] !== documentId || $[5] !== field.actions || $[6] !== field.path || $[7] !== field.schemaType ? (t1 = documentId && field.actions && field.actions.length > 0 && /* @__PURE__ */ jsx(FieldActionsResolver, { actions: actions || EMPTY_ARRAY$u, documentId, documentType: field.schemaType.name, onActions: setFieldActionNodes, path: field.path, schemaType: field.schemaType }), $[3] = actions, $[4] = documentId, $[5] = field.actions, $[6] = field.path, $[7] = field.schemaType, $[8] = t1) : t1 = $[8];
  const t2 = `field-${field.inputId}`;
  let t3;
  $[9] !== field.__internal_comments || $[10] !== field.__internal_slot || $[11] !== field.children || $[12] !== field.collapsed || $[13] !== field.collapsible || $[14] !== field.description || $[15] !== field.inputId || $[16] !== field.inputProps.readOnly || $[17] !== field.level || $[18] !== field.onCollapse || $[19] !== field.onExpand || $[20] !== field.path || $[21] !== field.presence || $[22] !== field.schemaType || $[23] !== field.title || $[24] !== field.validation || $[25] !== fieldActionsNodes || $[26] !== t2 ? (t3 = /* @__PURE__ */ jsx(FormFieldSet, { __internal_comments: field.__internal_comments, __internal_slot: field.__internal_slot, __unstable_headerActions: fieldActionsNodes, __unstable_presence: field.presence, collapsed: field.collapsed, collapsible: field.collapsible, "data-testid": t2, description: field.description, level: field.level, onCollapse: field.onCollapse, onExpand: field.onExpand, schemaType: field.schemaType, title: field.title, validation: field.validation, inputId: field.inputId, deprecated: field.schemaType.deprecated, path: field.path, readOnly: field.inputProps.readOnly, children: field.children }), $[9] = field.__internal_comments, $[10] = field.__internal_slot, $[11] = field.children, $[12] = field.collapsed, $[13] = field.collapsible, $[14] = field.description, $[15] = field.inputId, $[16] = field.inputProps.readOnly, $[17] = field.level, $[18] = field.onCollapse, $[19] = field.onExpand, $[20] = field.path, $[21] = field.presence, $[22] = field.schemaType, $[23] = field.title, $[24] = field.validation, $[25] = fieldActionsNodes, $[26] = t2, $[27] = t3) : t3 = $[27];
  let t4;
  $[28] !== field.__internal_comments || $[29] !== field.__internal_slot || $[30] !== field.path || $[31] !== fieldActionsNodes || $[32] !== focused || $[33] !== t3 ? (t4 = /* @__PURE__ */ jsx(FieldActionsProvider, { __internal_slot: field.__internal_slot, __internal_comments: field.__internal_comments, actions: fieldActionsNodes, focused, path: field.path, children: t3 }), $[28] = field.__internal_comments, $[29] = field.__internal_slot, $[30] = field.path, $[31] = fieldActionsNodes, $[32] = focused, $[33] = t3, $[34] = t4) : t4 = $[34];
  let t5;
  return $[35] !== t1 || $[36] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t1,
    t4
  ] }), $[35] = t1, $[36] = t4, $[37] = t5) : t5 = $[37], t5;
}
function ImageOrFileField(field) {
  const $ = c(34), [fieldActionsNodes, setFieldActionNodes] = useState(EMPTY_ARRAY$u), documentId = usePublishedId$1(), focused = !!field.inputProps.focused;
  let t0;
  if ($[0] !== field.inputProps.members || $[1] !== field.presence) {
    const hotspotField = field.inputProps.members.find(_temp$3G);
    t0 = hotspotField?.open ? field.presence : field.presence.concat(hotspotField?.field.presence || EMPTY_ARRAY$u), $[0] = field.inputProps.members, $[1] = field.presence, $[2] = t0;
  } else
    t0 = $[2];
  const presence = t0;
  let t1;
  $[3] !== documentId || $[4] !== field.actions || $[5] !== field.path || $[6] !== field.schemaType ? (t1 = documentId && field.actions && field.actions.length > 0 && /* @__PURE__ */ jsx(FieldActionsResolver, { actions: field.actions, documentId, documentType: field.schemaType.name, onActions: setFieldActionNodes, path: field.path, schemaType: field.schemaType }), $[3] = documentId, $[4] = field.actions, $[5] = field.path, $[6] = field.schemaType, $[7] = t1) : t1 = $[7];
  let t2;
  $[8] !== field.__internal_comments || $[9] !== field.__internal_slot || $[10] !== field.children || $[11] !== field.collapsed || $[12] !== field.collapsible || $[13] !== field.description || $[14] !== field.inputId || $[15] !== field.inputProps.readOnly || $[16] !== field.level || $[17] !== field.onCollapse || $[18] !== field.onExpand || $[19] !== field.path || $[20] !== field.schemaType || $[21] !== field.title || $[22] !== field.validation || $[23] !== fieldActionsNodes || $[24] !== presence ? (t2 = /* @__PURE__ */ jsx(FormFieldSet, { __internal_comments: field.__internal_comments, __internal_slot: field.__internal_slot, __unstable_headerActions: fieldActionsNodes, __unstable_presence: presence, collapsed: field.collapsed, collapsible: field.collapsible, description: field.description, level: field.level, onCollapse: field.onCollapse, onExpand: field.onExpand, title: field.title, validation: field.validation, inputId: field.inputId, deprecated: field.schemaType.deprecated, path: field.path, schemaType: field.schemaType, readOnly: field.inputProps.readOnly, children: field.children }), $[8] = field.__internal_comments, $[9] = field.__internal_slot, $[10] = field.children, $[11] = field.collapsed, $[12] = field.collapsible, $[13] = field.description, $[14] = field.inputId, $[15] = field.inputProps.readOnly, $[16] = field.level, $[17] = field.onCollapse, $[18] = field.onExpand, $[19] = field.path, $[20] = field.schemaType, $[21] = field.title, $[22] = field.validation, $[23] = fieldActionsNodes, $[24] = presence, $[25] = t2) : t2 = $[25];
  let t3;
  $[26] !== field.path || $[27] !== fieldActionsNodes || $[28] !== focused || $[29] !== t2 ? (t3 = /* @__PURE__ */ jsx(FieldActionsProvider, { actions: fieldActionsNodes, focused, path: field.path, children: t2 }), $[26] = field.path, $[27] = fieldActionsNodes, $[28] = focused, $[29] = t2, $[30] = t3) : t3 = $[30];
  let t4;
  return $[31] !== t1 || $[32] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t1,
    t3
  ] }), $[31] = t1, $[32] = t3, $[33] = t4) : t4 = $[33], t4;
}
function _temp$3G(member) {
  return member.kind === "field" && member.name === "hotspot";
}
function defaultResolveFieldComponent(schemaType) {
  if (schemaType.components?.field) return schemaType.components.field;
  if (isBooleanSchemaType(schemaType))
    return BooleanField;
  if (isDateTimeSchemaType(schemaType))
    return DateTimeField;
  const typeChain = getTypeChain$2(schemaType, /* @__PURE__ */ new Set());
  return typeChain.some((t) => isDateTimeSchemaType(t)) ? DateTimeField : typeChain.some((t) => t.name === "image" || t.name === "file") ? ImageOrFileField : typeChain.some((t) => isCrossDatasetReferenceSchemaType(t)) || typeChain.some((t) => t.name === "slug") ? PrimitiveField$1 : typeChain.some((t) => isReferenceSchemaType(t)) ? ReferenceField : schemaType.jsonType !== "object" && schemaType.jsonType !== "array" ? PrimitiveField$1 : ObjectOrArrayField;
}
function is$1(typeName, type) {
  return type.name === typeName || !!(type.type && is$1(typeName, type.type));
}
const CACHE$1 = /* @__PURE__ */ new WeakMap(), PREVIEW_FIELD_WEIGHT_MAP$1 = {
  title: 10,
  subtitle: 5,
  description: 1.5
}, BASE_WEIGHTS$1 = {
  _id: {
    weight: 1,
    type: "string"
  },
  _type: {
    weight: 1,
    type: "string"
  }
}, ignoredBuiltInObjectTypes$1 = ["reference", "crossDatasetReference", "slug"], getTypeChain$1 = (type) => type ? [type, ...getTypeChain$1(type.type)] : [], isPtField$1 = (type) => type?.jsonType === "array" && type.of.some((arrType) => getTypeChain$1(arrType).some(({
  name
}) => name === "block")), isStringField$1 = (schemaType) => schemaType ? schemaType?.jsonType === "string" : !1, isSlugField$1 = (schemaType) => getTypeChain$1(schemaType).some(({
  jsonType,
  name
}) => jsonType === "object" && name === "slug"), isSearchConfiguration$1 = (options) => isRecord$4(options) && "search" in options && isRecord$4(options.search);
function isSchemaType$2(input) {
  return typeof input < "u" && "name" in input;
}
function getFullyQualifiedPath$1(schemaType, path) {
  return isSlugField$1(schemaType) ? [path, "current"].join(".") : path;
}
function getLeafWeights$1(schemaType, maxDepth, getWeight) {
  function traverse2(type, path, depth, accumulator = []) {
    if (!type || depth > maxDepth) return accumulator;
    const typeChain = getTypeChain$1(type);
    if (isStringField$1(type) || isPtField$1(type)) {
      const weight = getWeight(type, path);
      return typeof weight == "number" && accumulator.push({
        path,
        weight,
        type: isPtField$1(type) ? "pt" : "string"
      }), accumulator;
    }
    if (isSlugField$1(type)) {
      const weight = getWeight(type, path);
      return typeof weight == "number" && accumulator.push({
        path: getFullyQualifiedPath$1(type, path),
        weight,
        type: isPtField$1(type) ? "pt" : "string"
      }), accumulator;
    }
    let recursiveResult = accumulator;
    for (const t of typeChain)
      if (t.jsonType === "object" && t.fields?.length && !ignoredBuiltInObjectTypes$1.includes(t.name))
        for (const field of t.fields)
          recursiveResult = traverse2(field.type, toString([path, field.name].filter(Boolean)), depth + 1, recursiveResult);
      else if (t.jsonType === "array" && t.of?.length)
        for (const arrayItemType of t.of)
          recursiveResult = traverse2(arrayItemType, `${path}[]`, depth + 1, recursiveResult);
    return recursiveResult;
  }
  return isSchemaType$2(schemaType) ? traverse2(schemaType, "", 0).reduce((acc, {
    path,
    weight,
    type
  }) => (acc[path] = {
    weight,
    type,
    path
  }, acc), {}) : {};
}
const getUserSetWeight$1 = (schemaType) => {
  const searchOptions = getTypeChain$1(schemaType).map((type) => type.options).find(isSearchConfiguration$1);
  return typeof searchOptions?.search?.weight == "number" ? searchOptions.search.weight : null;
}, getHiddenWeight$1 = (schemaType) => getTypeChain$1(schemaType).some((type) => type.hidden) ? 0 : null, getDefaultWeights$1 = (schemaType) => typeof (getUserSetWeight$1(schemaType) ?? getHiddenWeight$1(schemaType)) == "number" ? null : 1, getPreviewWeights$1 = (schemaType, maxDepth, isCrossDataset) => {
  const select2 = schemaType?.preview?.select;
  if (!select2) return null;
  const selectionKeysBySelectionPath = Object.fromEntries(Object.entries(select2).map(([selectionKey, selectionPath]) => [
    // replace indexed paths with `[]`
    // e.g. `arrayOfObjects.0.myField` becomes `arrayOfObjects[].myField`
    selectionPath.replace(/\.\d+/g, "[]"),
    selectionKey
  ])), defaultWeights = getLeafWeights$1(schemaType, maxDepth, getDefaultWeights$1), nestedWeightsBySelectionPath = Object.fromEntries(Object.entries(defaultWeights).map(([path, {
    type
  }]) => ({
    path,
    type
  })).filter(({
    path
  }) => selectionKeysBySelectionPath[path]).map(({
    path,
    type
  }) => [path, {
    type,
    weight: PREVIEW_FIELD_WEIGHT_MAP$1[selectionKeysBySelectionPath[path]]
  }]));
  return isCrossDataset ? Object.fromEntries(Object.entries(selectionKeysBySelectionPath).map(([path, previewFieldName]) => [path, {
    path,
    type: "string",
    weight: PREVIEW_FIELD_WEIGHT_MAP$1[previewFieldName]
  }])) : getLeafWeights$1(schemaType, maxDepth, (type, path) => {
    const nested = nestedWeightsBySelectionPath[getFullyQualifiedPath$1(type, path)];
    return nested ? nested.weight : null;
  });
};
function deriveSearchWeightsFromType({
  schemaType,
  maxDepth,
  isCrossDataset,
  processPaths = (paths) => paths
}) {
  const cached = CACHE$1.get(schemaType);
  if (cached) return cached;
  const userSetWeights = getLeafWeights$1(schemaType, maxDepth, getUserSetWeight$1), hiddenWeights = getLeafWeights$1(schemaType, maxDepth, getHiddenWeight$1), defaultWeights = getLeafWeights$1(schemaType, maxDepth, getDefaultWeights$1), previewWeights = getPreviewWeights$1(schemaType, maxDepth, isCrossDataset), weights = {
    ...BASE_WEIGHTS$1,
    ...defaultWeights,
    ...hiddenWeights,
    ...previewWeights,
    ...userSetWeights
  }, result = {
    typeName: isSchemaType$2(schemaType) ? schemaType.name : schemaType.type,
    paths: processPaths(Object.entries(weights).map(([path, {
      type,
      weight
    }]) => ({
      path,
      weight,
      ...type === "pt" && {
        mapWith: "pt::text"
      }
    })))
  };
  return CACHE$1.set(schemaType, result), result;
}
const CACHE = /* @__PURE__ */ new WeakMap(), PREVIEW_FIELD_WEIGHT_MAP = {
  title: 10,
  subtitle: 5,
  description: 1.5
}, BASE_WEIGHTS = {
  _id: {
    weight: 1
  },
  _type: {
    weight: 1
  }
}, ignoredBuiltInObjectTypes = ["reference", "crossDatasetReference", "slug", "globalDocumentReference"], getTypeChain = (type) => type ? [type, ...getTypeChain(type.type)] : [], isPtField = (type) => type?.jsonType === "array" && type.of.some((arrType) => getTypeChain(arrType).some(({
  name
}) => name === "block")), isStringField = (schemaType) => schemaType ? schemaType?.jsonType === "string" : !1, isSlugField = (schemaType) => getTypeChain(schemaType).some(({
  jsonType,
  name
}) => jsonType === "object" && name === "slug"), isSearchConfiguration = (options) => isRecord$4(options) && "search" in options && isRecord$4(options.search);
function isSchemaType$1(input) {
  return typeof input < "u" && "name" in input;
}
function getFullyQualifiedPath(schemaType, path) {
  return isSlugField(schemaType) ? [path, "current"].join(".") : path;
}
function getLeafWeights(schemaType, maxDepth, getWeight) {
  function traverse2(type, path, depth, accumulator = []) {
    if (!type || depth > maxDepth) return accumulator;
    const typeChain = getTypeChain(type);
    if (isStringField(type) || isPtField(type)) {
      const weight = getWeight(type, path);
      return typeof weight == "number" && accumulator.push({
        path,
        weight
      }), accumulator;
    }
    if (isSlugField(type)) {
      const weight = getWeight(type, path);
      return typeof weight == "number" && accumulator.push({
        path: getFullyQualifiedPath(type, path),
        weight
      }), accumulator;
    }
    let recursiveResult = accumulator;
    for (const t of typeChain)
      if (t.jsonType === "object" && t.fields?.length && !ignoredBuiltInObjectTypes.includes(t.name))
        for (const field of t.fields)
          recursiveResult = traverse2(field.type, toString([path, field.name].filter(Boolean)), depth + 1, recursiveResult);
      else if (t.jsonType === "array" && t.of?.length)
        for (const arrayItemType of t.of)
          recursiveResult = traverse2(arrayItemType, `${path}[]`, depth + 1, recursiveResult);
    return recursiveResult;
  }
  return isSchemaType$1(schemaType) ? traverse2(schemaType, "", 0).reduce((acc, {
    path,
    weight,
    type
  }) => (acc[path] = {
    weight,
    type,
    path
  }, acc), {}) : {};
}
const getUserSetWeight = (schemaType) => {
  const searchOptions = getTypeChain(schemaType).map((type) => type.options).find(isSearchConfiguration);
  return typeof searchOptions?.search?.weight == "number" ? searchOptions.search.weight : null;
}, getHiddenWeight = (schemaType) => getTypeChain(schemaType).some((type) => type.hidden) ? 0 : null, getDefaultWeights = (schemaType) => typeof (getUserSetWeight(schemaType) ?? getHiddenWeight(schemaType)) == "number" ? null : 1, getPreviewWeights = (schemaType, maxDepth, isCrossDataset) => {
  const select2 = schemaType?.preview?.select;
  if (!select2) return null;
  const selectionKeysBySelectionPath = Object.fromEntries(Object.entries(select2).map(([selectionKey, selectionPath]) => [
    // replace indexed paths with `[]`
    // e.g. `arrayOfObjects.0.myField` becomes `arrayOfObjects[].myField`
    selectionPath.replace(/\.\d+/g, "[]"),
    selectionKey
  ])), defaultWeights = getLeafWeights(schemaType, maxDepth, getDefaultWeights), nestedWeightsBySelectionPath = Object.fromEntries(Object.entries(defaultWeights).map(([path, {
    type
  }]) => ({
    path,
    type
  })).filter(({
    path
  }) => selectionKeysBySelectionPath[path]).map(({
    path,
    type
  }) => [path, {
    type,
    weight: PREVIEW_FIELD_WEIGHT_MAP[selectionKeysBySelectionPath[path]] ?? 0
  }]));
  return isCrossDataset ? Object.fromEntries(Object.entries(selectionKeysBySelectionPath).map(([path, previewFieldName]) => [path, {
    path,
    type: "string",
    weight: PREVIEW_FIELD_WEIGHT_MAP[previewFieldName] ?? 0
  }])) : getLeafWeights(schemaType, maxDepth, (type, path) => {
    const nested = nestedWeightsBySelectionPath[getFullyQualifiedPath(type, path)];
    return nested ? nested.weight : null;
  });
};
function deriveSearchWeightsFromType2024({
  schemaType,
  maxDepth,
  isCrossDataset,
  processPaths = (paths) => paths
}) {
  const cached = CACHE.get(schemaType);
  if (cached) return cached;
  const userSetWeights = getLeafWeights(schemaType, maxDepth, getUserSetWeight), hiddenWeights = getLeafWeights(schemaType, maxDepth, getHiddenWeight), defaultWeights = getLeafWeights(schemaType, maxDepth, getDefaultWeights), previewWeights = getPreviewWeights(schemaType, maxDepth, isCrossDataset), weights = {
    ...BASE_WEIGHTS,
    ...defaultWeights,
    ...hiddenWeights,
    ...previewWeights,
    ...userSetWeights
  }, result = {
    typeName: isSchemaType$1(schemaType) ? schemaType.name : schemaType.type,
    paths: processPaths(Object.entries(weights).map(([path, {
      weight
    }]) => ({
      path,
      weight
    })))
  };
  return CACHE.set(schemaType, result), result;
}
const isDocumentType = (type) => !!(type.type && type.type.name === "document"), isObjectType = (type) => type.jsonType === "object", isIgnoredType = (type) => type.name.startsWith("sanity.") && type.name !== "sanity.previewUrlSecret", getSearchableTypes = (schema2, explicitlyAllowedTypes = []) => schema2.getTypeNames().map((typeName) => schema2.get(typeName)).filter(isNonNullable$2).filter((type) => isDocumentType(type) && !isIgnoredType(type) || explicitlyAllowedTypes.includes(type.name)).filter(isObjectType);
function isPerspectiveRaw(perspective) {
  return perspective ? isString(perspective) ? perspective === "raw" : perspective.some((p) => p === "raw") : !1;
}
const TOKEN_REGEX = /(?:[^\s"]+|"[^"]*")+/g;
function isNegationToken(token) {
  return typeof token < "u" && token.trim().at(0) === "-";
}
function isPrefixToken(token) {
  return typeof token < "u" && token.trim().at(-1) === "*";
}
function isExactMatchToken(token) {
  return [token?.at(0), token?.at(-1)].every((character) => character === '"');
}
function prefixLast(query) {
  const tokens = (query.match(TOKEN_REGEX) ?? []).map((token) => token.trim()), finalIncrementalTokenIndex = tokens.findLastIndex((token) => !isNegationToken(token) && !isExactMatchToken(token)), finalIncrementalToken = tokens[finalIncrementalTokenIndex];
  if (tokens.length === 0)
    return "*";
  if (isPrefixToken(finalIncrementalToken) || typeof finalIncrementalToken > "u")
    return tokens.join(" ");
  const prefixedTokens = [...tokens];
  return prefixedTokens.splice(finalIncrementalTokenIndex, 1, `${finalIncrementalToken}*`), prefixedTokens.join(" ");
}
function getNullSortingPrefix(ordering) {
  const {
    direction,
    nulls,
    field
  } = ordering;
  if (!nulls) return;
  const dirLower = (direction || "asc").toLowerCase();
  if (dirLower === "desc" && nulls === "last" || dirLower === "asc" && nulls === "first")
    return nulls === "last" ? `select(defined(${field}) => 0, 1)` : `select(defined(${field}) => 1, 0)`;
}
function wrapFieldWithFn(ordering) {
  return ordering.mapWith ? `${ordering.mapWith}(${ordering.field})` : ordering.field;
}
function toOrderClause(orderBy2) {
  return (orderBy2 || []).flatMap((ordering) => {
    const nullPrefix = getNullSortingPrefix(ordering), fieldClause = [wrapFieldWithFn(ordering), (ordering.direction || "").toLowerCase()].map((str) => str.trim()).filter(Boolean).join(" ");
    return nullPrefix ? [nullPrefix, fieldClause] : [fieldClause];
  }).join(",");
}
const FINDABILITY_MVI$1 = 5, DEFAULT_LIMIT$1 = 1e3;
function isSchemaType(maybeSchemaType) {
  return typeof maybeSchemaType < "u" && "name" in maybeSchemaType;
}
function createSearchQuery$1(searchTerms, searchParams, {
  perspective,
  sort,
  isCrossDataset,
  tag,
  maxDepth,
  cursor,
  limit: limit2,
  params,
  comments: comments2,
  filter: filter2
} = {}) {
  const flattenedSpecs = searchTerms.types.map((schemaType) => deriveSearchWeightsFromType2024({
    schemaType,
    maxDepth: maxDepth || DEFAULT_MAX_FIELD_DEPTH,
    isCrossDataset,
    processPaths: (paths) => paths.filter(({
      weight
    }) => weight !== 1)
  })).filter(({
    paths
  }) => paths.length !== 0).flatMap(({
    typeName,
    paths
  }) => paths.map((path) => ({
    ...path,
    typeName
  }))), groupedSpecs = groupBy(flattenedSpecs, (entry) => [entry.path, entry.weight].join(":")), baseMatch = "([@, _id] match text::query($__query) || references($__rawQuery))", score = Object.entries(groupedSpecs).flatMap(([, entries]) => entries.some(({
    weight
  }) => weight === 0) ? [] : `boost(_type in ${JSON.stringify(entries.map((entry) => entry.typeName))} && ${entries[0].path} match text::query($__query), ${entries[0].weight})`).concat(baseMatch), sortOrder = sort ?? [{
    field: "_score",
    direction: "desc"
  }], isScored = sortOrder.some(({
    field
  }) => field === "_score"), filters = [
    "_type in $__types",
    // If the search request doesn't use scoring, directly filter documents.
    isScored ? [] : baseMatch,
    filter2 ? `(${filter2})` : [],
    searchTerms.filter ? `(${searchTerms.filter})` : [],
    cursor ?? []
  ].flat(), projection = sortOrder.map(({
    field
  }) => field).concat("_type", "_id", "_originalId").join(", "), query = [`*[${filters.join(" && ")}]`, isScored ? ["|", `score(${score.join(", ")})`] : [], ["|", `order(${toOrderClause(sortOrder)})`], isScored ? "[_score > 0]" : [], "[0...$__limit]", `{${projection}}`].flat().join(" "), rawQuery = typeof searchParams == "string" ? searchParams : searchParams.query, finalParams = {
    __types: searchTerms.types.map((type) => isSchemaType(type) ? type.name : type.type),
    // Overfetch by 1 to determine whether there is another page to fetch.
    __limit: (limit2 ?? DEFAULT_LIMIT$1) + 1,
    __query: prefixLast(rawQuery),
    __rawQuery: rawQuery,
    ...params
  };
  return {
    query: [[`findability-mvi:${FINDABILITY_MVI$1}`].concat(comments2 || []).map((s) => `// ${s}`).join(`
`), query].join(`
`),
    options: {
      tag,
      perspective
    },
    params: finalParams,
    sortOrder
  };
}
function getNextCursor({
  lastResult,
  sortOrder
}) {
  if (!lastResult)
    return;
  const hasIdSort = sortOrder.some(({
    field
  }) => field === "_id");
  return sortOrder.concat(hasIdSort ? [] : {
    field: "_id",
    direction: "asc"
  }).reduce((cursor, sortEntry, index) => {
    const nextPredicate = sortOrder.slice(0, index).map((previousSortEntry) => getCursorPredicate(previousSortEntry, lastResult, "==")).concat(getCursorPredicate(sortEntry, lastResult)).filter((predicate) => typeof predicate < "u").join(" && ");
    return [cursor, `(${nextPredicate})`].filter((segment) => typeof segment < "u").join(" || ");
  }, void 0);
}
const sortComparators = {
  asc: ">",
  desc: "<"
};
function getCursorPredicate(sort, lastEntry, comparator = sortComparators[sort.direction]) {
  if (!(sort.field == "_id" && comparator == "=="))
    return [sort.field, comparator, JSON.stringify(lastEntry[sort.field])].join(" ");
}
function getSearchTerms$1(searchParams, types) {
  return typeof searchParams == "string" ? {
    query: searchParams,
    types
  } : searchParams.types.length ? searchParams : {
    ...searchParams,
    types
  };
}
const createGroq2024Search = (typesFromFactory, client, factoryOptions) => function(searchParams, searchOptions = {}) {
  const searchTerms = getSearchTerms$1(searchParams, typesFromFactory), mergedOptions = {
    ...factoryOptions,
    ...searchOptions
  }, {
    query,
    params,
    options,
    sortOrder
  } = createSearchQuery$1(searchTerms, searchParams, mergedOptions);
  return client.observable.fetch(query, params, options).pipe(map$1((hits) => {
    const hasNextPage = typeof searchOptions.limit < "u" && hits.length > searchOptions.limit, lastResult = hasNextPage ? hits.at(-2) : hits.at(-1);
    return {
      type: "groq2024",
      // Search overfetches by 1 to determine whether there is another page to fetch. Therefore,
      // exclude the final result if it's beyond the limit.
      hits: hits.map((hit) => ({
        hit
      })).slice(0, searchOptions.limit),
      nextCursor: hasNextPage ? getNextCursor({
        lastResult,
        sortOrder
      }) : void 0
    };
  }));
}, calculateScore = (searchTerms, value) => {
  const {
    phrases: uniqueSearchPhrases,
    words: uniqueSearchWords
  } = partitionAndSanitizeSearchTerms(searchTerms), [phraseScore, phraseWhy] = calculatePhraseScore(uniqueSearchPhrases, value), [wordScore, wordWhy] = calculateWordScore(uniqueSearchWords, value);
  return [phraseScore + wordScore, [wordWhy, phraseWhy].join(", ")];
}, stringify = (value) => typeof value == "string" ? value : JSON.stringify(value);
function applyWeights(searchSpec, hits, terms = []) {
  const specByType = keyBy(searchSpec, (spec) => spec.typeName);
  return hits.map((hit, index) => {
    const stories = (specByType[hit._type].paths || [])?.map((pathSpec, idx) => {
      const value = stringify(hit[`w${idx}`]);
      if (!value)
        return {
          path: pathSpec.path,
          score: 0,
          why: "No match"
        };
      const [score, why] = calculateScore(terms, value);
      return {
        path: pathSpec.path,
        score: score * pathSpec.weight,
        why: `${why} (*${pathSpec.weight})`
      };
    }), totalScore = stories.reduce((acc, rank) => acc + rank.score, 0);
    return {
      hit,
      resultIndex: hits.length - index,
      score: totalScore,
      stories
    };
  });
}
function calculatePhraseScore(uniqueSearchPhrases, value) {
  const sanitizedValue = value.toLowerCase().trim();
  let fieldScore = 0, matchCount = 0;
  return uniqueSearchPhrases.forEach((term) => {
    sanitizedValue.includes(term) && (fieldScore += term.length / sanitizedValue.length, matchCount += term.length);
  }), fieldScore === 1 ? [1, "[Phrase] Exact match"] : [fieldScore / 2, `[Phrase] Matched ${matchCount} of ${sanitizedValue.length} characters`];
}
function calculateWordScore(uniqueSearchTerms, value) {
  const uniqueValueTerms = uniq(compact(words(toLower(value)))), matches = intersection(uniqueSearchTerms, uniqueValueTerms), all = union(uniqueValueTerms, uniqueSearchTerms), fieldScore = matches.length / all.length;
  return fieldScore === 1 ? [1, "[Word] Exact match"] : [fieldScore / 2, `[Word] Matched ${matches.length} of ${all.length} terms: [${matches.join(", ")}]`];
}
function partitionAndSanitizeSearchTerms(searchTerms) {
  const uniqueSearchTerms = uniq(searchTerms.map(toLower)), [searchPhrases, searchWords] = partition(uniqueSearchTerms, (term) => /^".*"$/.test(term));
  return {
    phrases: uniq(searchPhrases).map(toLower).map(stripWrappingQuotes),
    //
    words: uniq(searchWords.map(toLower))
  };
}
function stripWrappingQuotes(str) {
  return str.replace(/^"(.*)"$/, "$1");
}
const FINDABILITY_MVI = 4, DEFAULT_LIMIT = 1e3, combinePaths = flow([flatten$1, union, compact]), pathWithMapper = ({
  mapWith,
  path
}) => mapWith ? `${mapWith}(${path})` : path;
function createConstraints(terms, specs) {
  const combinedSearchPaths = combinePaths(specs.map((configForType) => (configForType.paths || []).map((opt) => pathWithMapper(opt))));
  return terms.map((_term, i) => combinedSearchPaths.map((joinedPath) => `${joinedPath} match $t${i}`)).filter((constraint) => constraint.length > 0).map((constraint) => `(${constraint.join(" || ")})`);
}
const SPECIAL_CHARS = /([^!@#$%^&*(),\\/?";:{}|[\]+<>\s-])+/g, STRIP_EDGE_CHARS = /(^[.]+)|([.]+$)/;
function tokenize(string) {
  return (string.match(SPECIAL_CHARS) || []).map((token) => token.replace(STRIP_EDGE_CHARS, ""));
}
function extractTermsFromQuery(query) {
  const quotedQueries = [], unquotedQuery = query.replace(/("[^"]*")/g, (match) => words(match).length > 1 ? (quotedQueries.push(match), "") : match), quotedTerms = quotedQueries.map((str) => trim(toLower(str))), remainingTerms = uniq(compact(tokenize(toLower(unquotedQuery))));
  return [...quotedTerms, ...remainingTerms];
}
function createSearchQuery(searchTerms, searchOpts = {}) {
  const {
    filter: filter2,
    params,
    tag,
    maxDepth,
    isCrossDataset,
    __unstable_extendedProjection,
    perspective,
    sort,
    limit: limit2,
    comments: comments2
  } = searchOpts, specs = searchTerms.types.map((schemaType) => deriveSearchWeightsFromType({
    schemaType,
    maxDepth: maxDepth || DEFAULT_MAX_FIELD_DEPTH,
    isCrossDataset
  })).filter(({
    paths
  }) => paths.length), terms = extractTermsFromQuery(searchTerms.query), filters = ["_type in $__types", ...createConstraints(terms, specs), filter2 ? `(${filter2})` : "", searchTerms.filter ? `(${searchTerms.filter})` : ""].filter(Boolean), selections = searchOpts.skipSortByScore ? [] : specs.map((spec) => {
    const constraint = `_type == "${spec.typeName}" => `;
    if (searchOpts.skipSortByScore)
      return;
    const selection2 = `{ ${spec.paths.map((cfg, i) => `"w${i}": ${pathWithMapper(cfg)}`)} }`;
    return `${constraint}${selection2}`;
  }), sortOrder = toOrderClause(sort || [{
    field: "_id",
    direction: "asc"
  }]), projectionFields = ["_type", "_id", "_originalId"], selection = selections.length > 0 ? `...select(${selections.join(`,
`)})` : "", finalProjection = projectionFields.join(", ") + (selection ? `, ${selection}` : "");
  let query = `*[${filters.join(" && ")}]| order(${sortOrder})[0...$__limit]{${finalProjection}}`;
  if (__unstable_extendedProjection) {
    const extendedProjection = __unstable_extendedProjection, firstProjection = projectionFields.concat(extendedProjection).join(", ");
    query = [`*[${filters.join(" && ")}]{${firstProjection}}`, `order(${sortOrder})[0...$__limit]{${finalProjection}}`].join("|");
  }
  const groqComments = [`findability-mvi:${FINDABILITY_MVI}`].concat(comments2 || []).map((s) => `// ${s}`).join(`
`);
  return {
    query: groqComments ? `${groqComments}
${query}` : query,
    params: {
      ...toGroqParams(terms),
      __types: specs.map((spec) => spec.typeName),
      __limit: limit2 ?? DEFAULT_LIMIT,
      ...params
    },
    options: {
      tag,
      perspective
    },
    searchSpec: specs,
    terms
  };
}
const toGroqParams = (terms) => {
  const params = {};
  return terms.reduce((acc, term, i) => (acc[`t${i}`] = `${term}*`, acc), params);
};
function getSearchTerms(searchParams, types) {
  return typeof searchParams == "string" ? {
    query: searchParams,
    types
  } : searchParams.types.length ? searchParams : {
    ...searchParams,
    types
  };
}
const createWeightedSearch = (types, client, factoryOptions) => function(searchParams, searchOptions = {}) {
  const searchTerms = getSearchTerms(searchParams, types), {
    query,
    params,
    options,
    searchSpec,
    terms
  } = createSearchQuery(searchTerms, {
    ...factoryOptions,
    ...searchOptions
  }), apiVersion = isReleasePerspective(options?.perspective) ? RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion : void 0;
  return versionedClient(client, apiVersion).observable.fetch(query, params, options).pipe(
    factoryOptions.unique ? map(removeDupes$3) : tap(),
    // Assign weighting and scores based on current search terms.
    // No scores will be assigned when terms are empty.
    map((hits) => applyWeights(searchSpec, hits, terms)),
    // Optionally skip client-side score sorting.
    // This can be relevant when ordering results by specific fields, especially dates.
    searchOptions?.skipSortByScore ? tap() : map((hits) => sortBy(hits, (hit) => -hit.score)),
    map((hits) => ({
      type: "weighted",
      hits
    }))
  );
}, searchStrategies = {
  groqLegacy: createWeightedSearch,
  groq2024: createGroq2024Search
}, DEFAULT_SEARCH_STRATEGY = "groqLegacy", createSearch = (searchableTypes, client, options) => {
  const factory = searchStrategies[options.strategy ?? DEFAULT_SEARCH_STRATEGY];
  return factory(searchableTypes, isReleasePerspective(options?.perspective) ? versionedClient(client, RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion) : client, options);
}, DEFAULT_API_FIELD_DEPTH = 0, INITIAL_LOADING_STATE$5 = {
  isLoading: !0,
  settings: {
    partialIndexSettings: {
      maxFieldDepth: DEFAULT_API_FIELD_DEPTH
    }
  }
};
function fetchMaxDepth({
  client
}) {
  const {
    projectId,
    dataset
  } = client.config();
  return client.observable.request({
    uri: `/projects/${projectId}/datasets/${dataset}/settings/indexing`,
    tag: "search.getPartialIndexSettings"
  });
}
const cachedSettings = /* @__PURE__ */ new Map();
function useSearchMaxFieldDepth(overrideClient) {
  const $ = c(4), isEnabled = useWorkspace().search?.unstable_partialIndexing?.enabled, workspaceClient = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), client = overrideClient || workspaceClient;
  let t0;
  $[0] !== client ? (t0 = client.config(), $[0] = client, $[1] = t0) : t0 = $[1];
  const dataset = t0.dataset;
  isEnabled || cachedSettings.set(dataset, of(INITIAL_LOADING_STATE$5.settings)), cachedSettings.has(dataset) || cachedSettings.set(dataset, fetchMaxDepth({
    client
  }).pipe(shareReplay()));
  let t1;
  $[2] !== dataset ? (t1 = cachedSettings.get(dataset).pipe(map(_temp$3F), startWith(INITIAL_LOADING_STATE$5), catchError(_temp2$1A)), $[2] = dataset, $[3] = t1) : t1 = $[3];
  const maxFieldDepth = useObservable(t1, INITIAL_LOADING_STATE$5)?.settings?.partialIndexSettings?.maxFieldDepth;
  return isFinite(maxFieldDepth) ? Math.min(maxFieldDepth, DEFAULT_MAX_FIELD_DEPTH) : DEFAULT_MAX_FIELD_DEPTH;
}
function _temp2$1A(err) {
  return console.error(err), of({
    isLoading: !1,
    enabled: !0,
    settings: {
      partialIndexSettings: {
        maxFieldDepth: DEFAULT_API_FIELD_DEPTH
      }
    }
  });
}
function _temp$3F(settings) {
  return {
    isLoading: !1,
    settings
  };
}
function FormValueProvider(props2) {
  const $ = c(5);
  let t0;
  $[0] !== props2.value ? (t0 = {
    value: props2.value
  }, $[0] = props2.value, $[1] = t0) : t0 = $[1];
  const value = t0;
  let t1;
  return $[2] !== props2.children || $[3] !== value ? (t1 = /* @__PURE__ */ jsx(FormValueContext.Provider, { value, children: props2.children }), $[2] = props2.children, $[3] = value, $[4] = t1) : t1 = $[4], t1;
}
function useFormValue(path) {
  const uniquePath = pathFor(path), ctx = useContext(FormValueContext);
  if (!ctx)
    throw new Error("useFormValue must be used within a FormValueProvider");
  return getValueAtPath(ctx?.value, uniquePath);
}
const STATUS_TONES$1 = {
  warning: "caution",
  error: "critical"
}, SuffixBox = styled(Box).withConfig({
  displayName: "SuffixBox",
  componentId: "sc-f6q3pa-0"
})`border-top:1px solid var(--card-border-color);`;
function Alert(props2) {
  const $ = c(31);
  let children, rest, suffix, t0, title;
  $[0] !== props2 ? ({
    children,
    status: t0,
    suffix,
    title,
    ...rest
  } = props2, $[0] = props2, $[1] = children, $[2] = rest, $[3] = suffix, $[4] = t0, $[5] = title) : (children = $[1], rest = $[2], suffix = $[3], t0 = $[4], title = $[5]);
  const status = t0 === void 0 ? "warning" : t0, t1 = STATUS_TONES$1[status], t2 = `alert-${status}`;
  let t3;
  $[6] !== status ? (t3 = status === "warning" && /* @__PURE__ */ jsx(WarningOutlineIcon, {}), $[6] = status, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== status ? (t4 = status === "error" && /* @__PURE__ */ jsx(ErrorOutlineIcon, {}), $[8] = status, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== t3 || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t3,
    t4
  ] }) }), $[10] = t3, $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== title ? (t6 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: title }), $[13] = title, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== children ? (t7 = children && /* @__PURE__ */ jsx(Box, { marginTop: 3, children }), $[15] = children, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t6 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Box, { flex: 1, marginLeft: 3, children: [
    t6,
    t7
  ] }), $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== t5 || $[21] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { padding: 4, children: [
    t5,
    t8
  ] }), $[20] = t5, $[21] = t8, $[22] = t9) : t9 = $[22];
  let t10;
  $[23] !== suffix ? (t10 = suffix && /* @__PURE__ */ jsx(SuffixBox, { children: suffix }), $[23] = suffix, $[24] = t10) : t10 = $[24];
  let t11;
  return $[25] !== rest || $[26] !== t1 || $[27] !== t10 || $[28] !== t2 || $[29] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Card, { radius: 2, tone: t1, ...rest, "data-ui": "Alert", "data-testid": t2, children: [
    t9,
    t10
  ] }), $[25] = rest, $[26] = t1, $[27] = t10, $[28] = t2, $[29] = t9, $[30] = t11) : t11 = $[30], t11;
}
function createPatchChannel() {
  const _subscribers = [];
  return {
    publish(msg) {
      for (const subscriber of _subscribers)
        subscriber(msg);
    },
    subscribe(subscriber) {
      return _subscribers.push(subscriber), () => {
        const idx = _subscribers.indexOf(subscriber);
        idx > -1 && _subscribers.splice(idx, 1);
      };
    }
  };
}
class PatchEvent {
  static from(input) {
    return input instanceof PatchEvent ? input : new PatchEvent(Array.isArray(input) ? flatten$1(input) : [input]);
  }
  constructor(patches) {
    this.patches = patches;
  }
  prepend(...patches) {
    return PatchEvent.from([...flatten$1(patches), ...this.patches]);
  }
  append(...patches) {
    return PatchEvent.from([...this.patches, ...flatten$1(patches)]);
  }
  prefixAll(segment) {
    return PatchEvent.from(this.patches.map((patch2) => prefixPath(patch2, segment)));
  }
}
const NARROW_LAYOUT = css`
  grid-template-columns: minmax(0px, 1fr);
`, WIDE_LAYOUT = css`
  grid-template-columns: 1fr min-content;
`, Root$y = /* @__PURE__ */ styled(Grid).withConfig({
  displayName: "Root",
  componentId: "sc-14vdkq1-0"
})((props2) => props2.$narrow ? NARROW_LAYOUT : WIDE_LAYOUT), AutocompleteContainer = forwardRef(function(props2, forwardedRef) {
  const $ = c(6), [rootElement, setRootElement] = useState(null);
  let t0;
  $[0] !== forwardedRef ? (t0 = (element) => {
    setForwardedRef(forwardedRef, element), setRootElement(element);
  }, $[0] = forwardedRef, $[1] = t0) : t0 = $[1];
  const handleNewRef = t0, t1 = (useElementRect(rootElement)?.width || 480) < 480;
  let t2;
  return $[2] !== handleNewRef || $[3] !== props2.children || $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(Root$y, { ref: handleNewRef, gap: 1, $narrow: t1, children: props2.children }), $[2] = handleNewRef, $[3] = props2.children, $[4] = t1, $[5] = t2) : t2 = $[5], t2;
});
function setForwardedRef(ref, instance) {
  typeof ref == "function" ? ref(instance) : ref && (ref.current = instance);
}
const INLINE_BLOCK_STYLE = {
  display: "inline-flex"
}, FULL_WIDTH = {
  width: "100%"
}, POPOVER_PROPS$5 = {
  portal: !0,
  tone: "default",
  constrainSize: !0,
  fallbackPlacements: ["bottom", "left", "top"],
  placement: "right",
  preventOverflow: !0
};
function CreateButton(props2) {
  const $ = c(25);
  let createOptions, id2, menuRef, onCreate, rest;
  $[0] !== props2 ? ({
    createOptions,
    onCreate,
    id: id2,
    menuRef,
    ...rest
  } = props2, $[0] = props2, $[1] = createOptions, $[2] = id2, $[3] = menuRef, $[4] = onCreate, $[5] = rest) : (createOptions = $[1], id2 = $[2], menuRef = $[3], onCreate = $[4], rest = $[5]);
  const currentUser = useCurrentUser(), {
    t
  } = useTranslation(), getI18nText = useGetI18nText(createOptions);
  if (!createOptions.some(_temp$3E)) {
    let t02;
    $[6] !== currentUser ? (t02 = /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: "create-new-reference" }), $[6] = currentUser, $[7] = t02) : t02 = $[7];
    let t1;
    $[8] !== t ? (t1 = t("inputs.reference.action.create-new-document"), $[8] = t, $[9] = t1) : t1 = $[9];
    let t2;
    $[10] !== t1 ? (t2 = /* @__PURE__ */ jsx("div", { style: INLINE_BLOCK_STYLE, children: /* @__PURE__ */ jsx(Button, { text: t1, mode: "ghost", disabled: !0, icon: AddIcon, style: FULL_WIDTH, size: "large" }) }), $[10] = t1, $[11] = t2) : t2 = $[11];
    let t3;
    return $[12] !== t02 || $[13] !== t2 ? (t3 = /* @__PURE__ */ jsx(Tooltip, { content: t02, children: t2 }), $[12] = t02, $[13] = t2, $[14] = t3) : t3 = $[14], t3;
  }
  let t0;
  return $[15] !== createOptions || $[16] !== currentUser || $[17] !== getI18nText || $[18] !== id2 || $[19] !== menuRef || $[20] !== onCreate || $[21] !== props2.readOnly || $[22] !== rest || $[23] !== t ? (t0 = createOptions.length > 1 ? /* @__PURE__ */ jsx(MenuButton, { button: /* @__PURE__ */ jsx(Button, { ...rest, disabled: props2.readOnly, text: t("inputs.reference.action.create-new-document-select"), mode: "ghost", icon: AddIcon, size: "large" }), id: id2, menu: /* @__PURE__ */ jsx(Menu, { ref: menuRef, children: createOptions.map((createOption) => /* @__PURE__ */ jsx(Tooltip, { disabled: createOption.permission.granted, content: /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: "create-document-type" }), portal: !0, "data-testid": `create-new-document-select-${createOption.title.toLowerCase().replaceAll(" ", "-")}-selectTypeMenuButton`, children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(MenuItem, { disabled: !createOption.permission.granted, icon: createOption.icon, text: getI18nText(createOption).title, onClick: () => onCreate(createOption), "data-testid": `create-new-document-select-${createOption.title.toLowerCase().replaceAll(" ", "-")}-selectTypeMenuItem` }) }) }, createOption.id)) }), popover: POPOVER_PROPS$5 }) : /* @__PURE__ */ jsx(Button, { ...rest, text: t("inputs.reference.action.create-new-document"), mode: "ghost", disabled: !createOptions[0].permission.granted || props2.readOnly, onClick: () => onCreate(createOptions[0]), icon: AddIcon, size: "large", "data-testid": `create-new-document-select-${id2}` }), $[15] = createOptions, $[16] = currentUser, $[17] = getI18nText, $[18] = id2, $[19] = menuRef, $[20] = onCreate, $[21] = props2.readOnly, $[22] = rest, $[23] = t, $[24] = t0) : t0 = $[24], t0;
}
function _temp$3E(option) {
  return option.permission.granted;
}
function sortReleases(releases2 = []) {
  return [...releases2].sort((a, b) => {
    if (a.metadata.releaseType === "undecided" && b.metadata.releaseType !== "undecided")
      return -1;
    if (a.metadata.releaseType !== "undecided" && b.metadata.releaseType === "undecided")
      return 1;
    if (a.metadata.releaseType === "undecided" && b.metadata.releaseType === "undecided")
      return new Date(b._createdAt).getTime() - new Date(a._createdAt).getTime();
    if (a.metadata.releaseType === "scheduled" && b.metadata.releaseType === "scheduled") {
      const aPublishAt = a.publishAt || a.metadata.intendedPublishAt;
      if (!aPublishAt)
        return 1;
      const bPublishAt = b.publishAt || b.metadata.intendedPublishAt;
      return bPublishAt ? new Date(bPublishAt).getTime() - new Date(aPublishAt).getTime() : -1;
    }
    return a.metadata.releaseType === "asap" && b.metadata.releaseType !== "asap" ? 1 : a.metadata.releaseType !== "asap" && b.metadata.releaseType === "asap" ? -1 : a.metadata.releaseType === "asap" && b.metadata.releaseType === "asap" ? new Date(b._createdAt).getTime() - new Date(a._createdAt).getTime() : 0;
  });
}
const DRAFTS = ["drafts"], PUBLISHED = ["published"];
function getReleasesPerspectiveStack({
  selectedPerspectiveName,
  releases: releases2,
  excludedPerspectives,
  isDraftModelEnabled
}) {
  const defaultPerspective = isDraftModelEnabled ? DRAFTS : PUBLISHED;
  if (!selectedPerspectiveName)
    return defaultPerspective;
  if (selectedPerspectiveName === "published")
    return PUBLISHED;
  const sorted = sortReleases(releases2).map((release) => getReleaseIdFromReleaseDocumentId(release._id)), selectedIndex = sorted.indexOf(selectedPerspectiveName);
  return selectedIndex === -1 ? [selectedPerspectiveName, ...defaultPerspective] : sorted.slice(selectedIndex).concat(defaultPerspective).filter((name) => !excludedPerspectives.includes(name));
}
function useActiveReleases() {
  const $ = c(8), {
    state$,
    dispatch
  } = useReleasesStore(), state = useObservable(state$);
  let t0;
  $[0] !== state.releases ? (t0 = sortReleases(Array.from(state.releases.values()).filter(_temp$3D)).reverse(), $[0] = state.releases, $[1] = t0) : t0 = $[1];
  const releasesAsArray = t0, t1 = state.error;
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = ["loading", "initialising"], $[2] = t2) : t2 = $[2];
  const t3 = t2.includes(state.state);
  let t4;
  return $[3] !== dispatch || $[4] !== releasesAsArray || $[5] !== state.error || $[6] !== t3 ? (t4 = {
    data: releasesAsArray,
    dispatch,
    error: t1,
    loading: t3
  }, $[3] = dispatch, $[4] = releasesAsArray, $[5] = state.error, $[6] = t3, $[7] = t4) : t4 = $[7], t4;
}
function _temp$3D(release) {
  return !ARCHIVED_RELEASE_STATES.includes(release.state);
}
const Dot$2 = /* @__PURE__ */ styled.div.withConfig({
  displayName: "Dot",
  componentId: "sc-blcgxy-0"
})((props2) => {
  const {
    $index
  } = props2, tone = {
    asap: RELEASE_TYPES_TONES.asap.tone,
    scheduled: RELEASE_TYPES_TONES.scheduled.tone,
    undecided: RELEASE_TYPES_TONES.undecided.tone
  };
  return css`
    width: 5px;
    height: 5px;
    background-color: var(--card-icon-color);
    border-radius: 999px;
    box-shadow: 0 0 0 1px var(--card-bg-color);
    z-index: ${$index};
    &[data-status='published'] {
      --card-icon-color: var(--card-badge-positive-dot-color);
    }
    &[data-status='draft'] {
      --card-icon-color: var(--card-badge-caution-dot-color);
    }
    &[data-status='asap'] {
      --card-icon-color: var(--card-badge-${tone.asap}-dot-color);
    }
    &[data-status='undecided'] {
      --card-icon-color: var(--card-badge-${tone.undecided}-dot-color);
    }
    &[data-status='scheduled'] {
      --card-icon-color: var(--card-badge-${tone.scheduled}-dot-color);
    }
  `;
});
function DocumentStatusIndicator(t0) {
  const $ = c(21), {
    draft,
    published,
    versions
  } = t0, {
    data: releases2
  } = useActiveReleases(), {
    document: t1
  } = useWorkspace(), {
    drafts: t2
  } = t1, {
    enabled: isDraftModelEnabled
  } = t2;
  let t3;
  $[0] !== releases2 || $[1] !== versions ? (t3 = versions ? Object.entries(versions).map((t42) => {
    const [versionName, snapshot2] = t42;
    return snapshot2 ? releases2?.find((r) => getReleaseIdFromReleaseDocumentId(r._id) === versionName)?.metadata.releaseType : void 0;
  }) : [], $[0] = releases2, $[1] = versions, $[2] = t3) : t3 = $[2];
  const versionsList = t3, t4 = !!published;
  let t5;
  $[3] !== t4 ? (t5 = {
    status: "published",
    show: t4
  }, $[3] = t4, $[4] = t5) : t5 = $[4];
  const t6 = isDraftModelEnabled && !!draft;
  let t7;
  $[5] !== t6 ? (t7 = {
    status: "draft",
    show: t6
  }, $[5] = t6, $[6] = t7) : t7 = $[6];
  const t8 = versionsList.includes("asap");
  let t9;
  $[7] !== t8 ? (t9 = {
    status: "asap",
    show: t8
  }, $[7] = t8, $[8] = t9) : t9 = $[8];
  const t10 = versionsList.includes("scheduled");
  let t11;
  $[9] !== t10 ? (t11 = {
    status: "scheduled",
    show: t10
  }, $[9] = t10, $[10] = t11) : t11 = $[10];
  const t12 = versionsList.includes("undecided");
  let t13;
  $[11] !== t12 ? (t13 = {
    status: "undecided",
    show: t12
  }, $[11] = t12, $[12] = t13) : t13 = $[12];
  let t14;
  $[13] !== t11 || $[14] !== t13 || $[15] !== t5 || $[16] !== t7 || $[17] !== t9 ? (t14 = [t5, t7, t9, t11, t13], $[13] = t11, $[14] = t13, $[15] = t5, $[16] = t7, $[17] = t9, $[18] = t14) : t14 = $[18];
  const indicators = t14;
  let t15;
  return $[19] !== indicators ? (t15 = /* @__PURE__ */ jsx(Flex, { children: indicators.filter(_temp$3C).map(_temp2$1z) }), $[19] = indicators, $[20] = t15) : t15 = $[20], t15;
}
function _temp2$1z(t0, index) {
  const {
    status
  } = t0;
  return /* @__PURE__ */ jsx(Dot$2, { "data-status": status, $index: index + 1 }, status);
}
function _temp$3C(t0) {
  const {
    show
  } = t0;
  return show;
}
function ReferencePreview(props2) {
  const $ = c(29), {
    id: id2,
    layout,
    refType,
    renderPreview,
    showTypeLabel
  } = props2, documentPresence = useDocumentPresence(id2), versionsInfo = useDocumentVersionInfo(id2);
  let t0;
  $[0] !== id2 || $[1] !== refType.name ? (t0 = {
    _id: id2,
    _type: refType.name
  }, $[0] = id2, $[1] = refType.name, $[2] = t0) : t0 = $[2];
  const previewStub = t0;
  let t1;
  $[3] !== refType.title || $[4] !== showTypeLabel ? (t1 = showTypeLabel && /* @__PURE__ */ jsx(Badge, { mode: "outline", children: refType.title }), $[3] = refType.title, $[4] = showTypeLabel, $[5] = t1) : t1 = $[5];
  let t2;
  $[6] !== documentPresence ? (t2 = documentPresence && documentPresence.length > 0 && /* @__PURE__ */ jsx(DocumentPreviewPresence, { presence: documentPresence }), $[6] = documentPresence, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== versionsInfo.draft || $[9] !== versionsInfo.published || $[10] !== versionsInfo.versions ? (t3 = /* @__PURE__ */ jsx(DocumentStatusIndicator, { draft: versionsInfo.draft, published: versionsInfo.published, versions: versionsInfo.versions }), $[8] = versionsInfo.draft, $[9] = versionsInfo.published, $[10] = versionsInfo.versions, $[11] = t3) : t3 = $[11];
  let t4;
  $[12] !== t1 || $[13] !== t2 || $[14] !== t3 ? (t4 = /* @__PURE__ */ jsx(Box, { paddingLeft: 3, children: /* @__PURE__ */ jsxs(Inline, { space: 3, children: [
    t1,
    t2,
    t3
  ] }) }), $[12] = t1, $[13] = t2, $[14] = t3, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== versionsInfo.draft || $[17] !== versionsInfo.published || $[18] !== versionsInfo.versions ? (t5 = /* @__PURE__ */ jsx(DocumentStatus, { draft: versionsInfo.draft, published: versionsInfo.published, versions: versionsInfo.versions }), $[16] = versionsInfo.draft, $[17] = versionsInfo.published, $[18] = versionsInfo.versions, $[19] = t5) : t5 = $[19];
  let t6;
  $[20] !== layout || $[21] !== previewStub || $[22] !== refType || $[23] !== t4 || $[24] !== t5 ? (t6 = {
    children: t4,
    layout,
    schemaType: refType,
    tooltip: t5,
    value: previewStub
  }, $[20] = layout, $[21] = previewStub, $[22] = refType, $[23] = t4, $[24] = t5, $[25] = t6) : t6 = $[25];
  const previewProps = t6;
  let t7;
  return $[26] !== previewProps || $[27] !== renderPreview ? (t7 = renderPreview(previewProps), $[26] = previewProps, $[27] = renderPreview, $[28] = t7) : t7 = $[28], t7;
}
function OptionPreview$2(props2) {
  const $ = c(15), {
    referenceType,
    type,
    id: documentId,
    renderPreview
  } = props2;
  let t0;
  if ($[0] !== referenceType.to || $[1] !== type) {
    let t12;
    $[3] !== type ? (t12 = (toType) => toType.name === type, $[3] = type, $[4] = t12) : t12 = $[4], t0 = referenceType.to.find(t12), $[0] = referenceType.to, $[1] = type, $[2] = t0;
  } else
    t0 = $[2];
  const refType = t0, {
    t
  } = useTranslation();
  if (!refType) {
    let t12;
    $[5] !== t || $[6] !== type ? (t12 = t("inputs.reference.error.invalid-search-result-type-title", {
      returnedType: type
    }), $[5] = t, $[6] = type, $[7] = t12) : t12 = $[7];
    let t22;
    return $[8] !== t12 ? (t22 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: t12 }), $[8] = t12, $[9] = t22) : t22 = $[9], t22;
  }
  const t1 = referenceType.to.length > 1;
  let t2;
  return $[10] !== documentId || $[11] !== refType || $[12] !== renderPreview || $[13] !== t1 ? (t2 = /* @__PURE__ */ jsx(ReferencePreview, { id: documentId, layout: "default", refType, renderPreview, showTypeLabel: t1 }), $[10] = documentId, $[11] = refType, $[12] = renderPreview, $[13] = t1, $[14] = t2) : t2 = $[14], t2;
}
const StyledPopover$6 = styled(Popover).withConfig({
  displayName: "StyledPopover",
  componentId: "sc-15m5qjt-0"
})`& > div{overflow:auto;-webkit-overflow-scrolling:touch;}`, StyledText$5 = styled(Text$1).withConfig({
  displayName: "StyledText",
  componentId: "sc-15m5qjt-1"
})`word-break:break-word;`, FALLBACK_PLACEMENTS$3 = ["top-start", "bottom-start"], ReferenceAutocomplete$3 = forwardRef(function(props2, ref) {
  const $ = c(23), {
    focusPath
  } = useFormBuilder();
  let loading, path, portalRef, referenceElement, restProps, searchString;
  $[0] !== props2 ? ({
    searchString,
    loading,
    portalRef,
    referenceElement,
    path,
    ...restProps
  } = props2, $[0] = props2, $[1] = loading, $[2] = path, $[3] = portalRef, $[4] = referenceElement, $[5] = restProps, $[6] = searchString) : (loading = $[1], path = $[2], portalRef = $[3], referenceElement = $[4], restProps = $[5], searchString = $[6]);
  let t0;
  $[7] !== focusPath || $[8] !== path ? (t0 = () => !!PathUtils.startsWith(path, focusPath), $[7] = focusPath, $[8] = path, $[9] = t0) : t0 = $[9];
  const [autoFocus] = useState(t0), {
    t
  } = useTranslation(), hasResults = props2.options && props2.options.length > 0;
  let t1;
  $[10] !== hasResults || $[11] !== loading || $[12] !== portalRef || $[13] !== referenceElement || $[14] !== searchString || $[15] !== t ? (t1 = (t22, contentRef) => {
    const {
      content,
      hidden,
      inputElement,
      onMouseEnter,
      onMouseLeave
    } = t22;
    return /* @__PURE__ */ jsx(StyledPopover$6, { "data-testid": "autocomplete-popover", placement: "bottom-start", fallbackPlacements: FALLBACK_PLACEMENTS$3, arrow: !1, constrainSize: !0, onMouseEnter, onMouseLeave, content: /* @__PURE__ */ jsx("div", { ref: contentRef, children: hasResults ? content : /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(StyledText$5, { align: "center", muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.no-results-for-query", values: {
      searchTerm: searchString || ""
    } }) }) }) }) }), open: !loading && !hidden, ref: portalRef, portal: !0, referenceElement: referenceElement || inputElement, matchReferenceWidth: !0 });
  }, $[10] = hasResults, $[11] = loading, $[12] = portalRef, $[13] = referenceElement, $[14] = searchString, $[15] = t, $[16] = t1) : t1 = $[16];
  const renderPopover = t1;
  let t2;
  return $[17] !== autoFocus || $[18] !== loading || $[19] !== ref || $[20] !== renderPopover || $[21] !== restProps ? (t2 = /* @__PURE__ */ jsx(Autocomplete, { ...restProps, loading, ref, renderPopover, autoFocus }), $[17] = autoFocus, $[18] = loading, $[19] = ref, $[20] = renderPopover, $[21] = restProps, $[22] = t2) : t2 = $[22], t2;
});
function focusRingBorderStyle$2(border) {
  return `inset 0 0 0 ${border.width}px ${border.color}`;
}
function focusRingStyle$1(opts) {
  const {
    base,
    border,
    focusRing
  } = opts, focusRingOutsetWidth = focusRing.offset + focusRing.width, focusRingInsetWidth = 0 - focusRing.offset, bgColor = base ? base.bg : "var(--card-bg-color)";
  return [focusRingInsetWidth > 0 && `inset 0 0 0 ${focusRingInsetWidth}px var(--card-focus-ring-color)`, border && focusRingBorderStyle$2(border), focusRingInsetWidth < 0 && `0 0 0 ${0 - focusRingInsetWidth}px ${bgColor}`, focusRingOutsetWidth > 0 && `0 0 0 ${focusRingOutsetWidth}px var(--card-focus-ring-color)`].filter(Boolean).join(",");
}
function withFocusRing(component) {
  return styled(component).withConfig({
    componentId: "sc-1tx689r-0"
  })((props2) => {
    const {
      $border,
      $radius
    } = props2, {
      card,
      color,
      radius
    } = getTheme_v2(props2.theme), border = {
      width: $border ? 1 : 0,
      color: "var(--card-border-color)"
    };
    return css`
        --card-focus-box-shadow: ${focusRingBorderStyle$2(border)};

        border-radius: ${rem(radius[$radius ?? 1])};
        outline: none;
        box-shadow: var(--card-focus-box-shadow);

        &:focus {
          --card-focus-box-shadow: ${focusRingStyle$1({
      border,
      base: color,
      focusRing: {
        ...card.focusRing,
        // An offset of 0 is needed to avoid the focus ring overlap the border of the inner items, the theme has an offset of -1
        // Detected in empty array items.
        offset: 0
      }
    })};
        }
      `;
  });
}
function PreviewReferenceValue$2(props2) {
  const $ = c(64), {
    layout: t0,
    referenceInfo,
    renderPreview,
    type,
    value,
    showTypeLabel
  } = props2, layout = t0 === void 0 ? "default" : t0, {
    t
  } = useTranslation();
  if (referenceInfo.isLoading || referenceInfo.error) {
    let t12;
    return $[0] !== layout ? (t12 = /* @__PURE__ */ jsx(SanityDefaultPreview, { isPlaceholder: !0, layout }), $[0] = layout, $[1] = t12) : t12 = $[1], t12;
  }
  if (referenceInfo.result?.availability.reason === "NOT_FOUND" && value._strengthenOnPublish) {
    const t12 = type.to;
    let T0, T1, refType, t22, t3, t4, t5;
    if ($[2] !== layout || $[3] !== renderPreview || $[4] !== type.to || $[5] !== value) {
      t5 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
      bb0: {
        let t62;
        if ($[13] !== value._strengthenOnPublish?.type ? (t62 = (toType) => toType.name === value?._strengthenOnPublish?.type, $[13] = value._strengthenOnPublish?.type, $[14] = t62) : t62 = $[14], refType = t12.find(t62), !refType) {
          const t72 = value._ref, t82 = value._strengthenOnPublish?.type;
          let t92;
          $[15] !== type.to ? (t92 = type.to.map(_temp$3B), $[15] = type.to, $[16] = t92) : t92 = $[16];
          let t10;
          $[17] !== t82 || $[18] !== t92 || $[19] !== value._ref ? (t10 = /* @__PURE__ */ jsx(InvalidType, { documentId: t72, actualType: t82, declaredTypes: t92 }), $[17] = t82, $[18] = t92, $[19] = value._ref, $[20] = t10) : t10 = $[20], t5 = t10;
          break bb0;
        }
        const stub = value._strengthenOnPublish?.type ? {
          _id: value._ref,
          _type: value._strengthenOnPublish?.type
        } : value;
        T1 = Flex, t4 = "center", T0 = Box, t22 = 1, t3 = renderPreview({
          layout,
          schemaType: refType,
          value: stub,
          skipVisibilityCheck: !0
        });
      }
      $[2] = layout, $[3] = renderPreview, $[4] = type.to, $[5] = value, $[6] = T0, $[7] = T1, $[8] = refType, $[9] = t22, $[10] = t3, $[11] = t4, $[12] = t5;
    } else
      T0 = $[6], T1 = $[7], refType = $[8], t22 = $[9], t3 = $[10], t4 = $[11], t5 = $[12];
    if (t5 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
      return t5;
    let t6;
    $[21] !== T0 || $[22] !== t22 || $[23] !== t3 ? (t6 = /* @__PURE__ */ jsx(T0, { flex: t22, children: t3 }), $[21] = T0, $[22] = t22, $[23] = t3, $[24] = t6) : t6 = $[24];
    let t7;
    $[25] !== refType || $[26] !== showTypeLabel ? (t7 = showTypeLabel && /* @__PURE__ */ jsx(Badge, { mode: "outline", children: refType.title }), $[25] = refType, $[26] = showTypeLabel, $[27] = t7) : t7 = $[27];
    let t8;
    $[28] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Inline, { space: 4, children: t7 }) }), $[28] = t7, $[29] = t8) : t8 = $[29];
    let t9;
    return $[30] !== T1 || $[31] !== t4 || $[32] !== t6 || $[33] !== t8 ? (t9 = /* @__PURE__ */ jsxs(T1, { align: t4, children: [
      t6,
      t8
    ] }), $[30] = T1, $[31] = t4, $[32] = t6, $[33] = t8, $[34] = t9) : t9 = $[34], t9;
  }
  const availability = referenceInfo.result.availability, notFound = availability.reason === "NOT_FOUND", insufficientPermissions = availability.reason === "PERMISSION_DENIED";
  if (insufficientPermissions || notFound) {
    let t12;
    $[35] !== t ? (t12 = t("inputs.reference.error.document-unavailable-title"), $[35] = t, $[36] = t12) : t12 = $[36];
    let t22;
    $[37] !== t12 ? (t22 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, children: t12 }) }) }) }), $[37] = t12, $[38] = t22) : t22 = $[38];
    let t3;
    $[39] !== insufficientPermissions || $[40] !== notFound || $[41] !== t || $[42] !== value ? (t3 = insufficientPermissions || notFound ? /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: notFound ? /* @__PURE__ */ jsx(UnavailableMessage, { title: t("inputs.reference.error.nonexistent-document-title"), icon: HelpCircleIcon, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "inputs.reference.error.nonexistent-document-description", t, values: {
      documentId: value._ref
    } }) }) : /* @__PURE__ */ jsx(UnavailableMessage, { title: t("inputs.reference.error.missing-read-permissions-title"), icon: AccessDeniedIcon, children: t("inputs.reference.error.missing-read-permissions-description") }), children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", children: /* @__PURE__ */ jsx(HelpCircleIcon, {}) }) }) }) : null, $[39] = insufficientPermissions, $[40] = notFound, $[41] = t, $[42] = value, $[43] = t3) : t3 = $[43];
    let t4;
    return $[44] !== t22 || $[45] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
      t22,
      t3
    ] }), $[44] = t22, $[45] = t3, $[46] = t4) : t4 = $[46], t4;
  }
  const refTypeName = referenceInfo.result?.type;
  let t1;
  if ($[47] !== refTypeName || $[48] !== type.to) {
    let t22;
    $[50] !== refTypeName ? (t22 = (toType_1) => toType_1.name === refTypeName, $[50] = refTypeName, $[51] = t22) : t22 = $[51], t1 = type.to.find(t22), $[47] = refTypeName, $[48] = type.to, $[49] = t1;
  } else
    t1 = $[49];
  const refType_0 = t1;
  if (!refType_0) {
    const t22 = value._ref, t3 = refTypeName || "<unknown>";
    let t4;
    $[52] !== type.to ? (t4 = type.to.map(_temp2$1y), $[52] = type.to, $[53] = t4) : t4 = $[53];
    let t5;
    return $[54] !== t3 || $[55] !== t4 || $[56] !== value._ref ? (t5 = /* @__PURE__ */ jsx(InvalidType, { documentId: t22, actualType: t3, declaredTypes: t4 }), $[54] = t3, $[55] = t4, $[56] = value._ref, $[57] = t5) : t5 = $[57], t5;
  }
  let t2;
  return $[58] !== layout || $[59] !== refType_0 || $[60] !== renderPreview || $[61] !== showTypeLabel || $[62] !== value._ref ? (t2 = /* @__PURE__ */ jsx(ReferencePreview, { id: value._ref, layout, refType: refType_0, renderPreview, showTypeLabel }), $[58] = layout, $[59] = refType_0, $[60] = renderPreview, $[61] = showTypeLabel, $[62] = value._ref, $[63] = t2) : t2 = $[63], t2;
}
function _temp2$1y(toType_2) {
  return toType_2.name;
}
function _temp$3B(toType_0) {
  return toType_0.name;
}
function UnavailableMessage(props2) {
  const $ = c(12), Icon2 = props2.icon;
  let t0;
  $[0] !== Icon2 ? (t0 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Icon2, {}) }), $[0] = Icon2, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== props2.title ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: props2.title }), $[2] = props2.title, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== props2.children ? (t2 = /* @__PURE__ */ jsx(Box, { marginTop: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: props2.children }) }), $[4] = props2.children, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t1 || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Box, { flex: 1, marginLeft: 3, children: [
    t1,
    t2
  ] }), $[6] = t1, $[7] = t2, $[8] = t3) : t3 = $[8];
  let t4;
  return $[9] !== t0 || $[10] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { children: [
    t0,
    t3
  ] }), $[9] = t0, $[10] = t3, $[11] = t4) : t4 = $[11], t4;
}
function InvalidType(t0) {
  const $ = c(19), {
    declaredTypes,
    documentId,
    actualType
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("inputs.reference.error.invalid-type-title"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, children: t1 }) }) }) }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== actualType || $[5] !== documentId ? (t3 = {
    documentId,
    actualType
  }, $[4] = actualType, $[5] = documentId, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== declaredTypes ? (t4 = {
    AllowedTypes: () => /* @__PURE__ */ jsx(HumanizedList, { values: declaredTypes })
  }, $[7] = declaredTypes, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t || $[10] !== t3 || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(Stack, { space: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.error.invalid-type-description", values: t3, components: t4 }) }) }), $[9] = t, $[10] = t3, $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", children: /* @__PURE__ */ jsx(HelpCircleIcon, {}) }) }), $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== t5 ? (t7 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t5, children: t6 }) }), $[14] = t5, $[15] = t7) : t7 = $[15];
  let t8;
  return $[16] !== t2 || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "flex-start", children: [
    t2,
    t7
  ] }), $[16] = t2, $[17] = t7, $[18] = t8) : t8 = $[18], t8;
}
function HumanizedList(props2) {
  const $ = c(8);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    type: "disjunction"
  }, $[0] = t0) : t0 = $[0];
  const listFormat = useListFormat(t0);
  let T0, t1;
  if ($[1] !== listFormat || $[2] !== props2.values) {
    const parts = listFormat.formatToParts(props2.values);
    T0 = Fragment, t1 = parts.map(_temp3$K), $[1] = listFormat, $[2] = props2.values, $[3] = T0, $[4] = t1;
  } else
    T0 = $[3], t1 = $[4];
  let t2;
  return $[5] !== T0 || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(T0, { children: t1 }), $[5] = T0, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
function _temp3$K(segment) {
  return segment.type === "element" ? /* @__PURE__ */ jsx("code", { children: segment.value }, segment.value) : segment.value;
}
const HeaderButton = styled.button.withConfig({
  displayName: "HeaderButton",
  componentId: "sc-1o6bl5u-0"
})`display:block;-webkit-font-smoothing:inherit;appearance:none;font:inherit;background:none;width:100%;text-align:left;border:0;margin:0;padding:0;outline:none;`, ToggleArrow = styled(ToggleArrowRightIcon).withConfig({
  displayName: "ToggleArrow",
  componentId: "sc-1o6bl5u-1"
})`transform:${(props2) => props2.open ? "rotate(90deg)" : ""};`, Header = styled(Flex).withConfig({
  displayName: "Header",
  componentId: "sc-1o6bl5u-2"
})`cursor:default;line-height:0;`, IconBox = styled(Flex).withConfig({
  displayName: "IconBox",
  componentId: "sc-1o6bl5u-3"
})`& > div > svg{transform:rotate(0);transition:transform 100ms;}&[data-open] > div > svg{transform:rotate(90deg);}`;
function Details(props2) {
  const $ = c(30);
  let children, icon, openProp, restProps, t0;
  $[0] !== props2 ? ({
    children,
    open: openProp,
    icon,
    title: t0,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = icon, $[3] = openProp, $[4] = restProps, $[5] = t0) : (children = $[1], icon = $[2], openProp = $[3], restProps = $[4], t0 = $[5]);
  const title = t0 === void 0 ? "Details" : t0, [open, setOpen] = useState(openProp || !1);
  let t1;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setOpen(_temp$3A), $[6] = t1) : t1 = $[6];
  const handleToggle = t1;
  let t2, t3;
  $[7] !== openProp ? (t2 = () => setOpen(openProp || !1), t3 = [openProp], $[7] = openProp, $[8] = t2, $[9] = t3) : (t2 = $[8], t3 = $[9]), useEffect(t2, t3);
  const t4 = open ? "" : void 0;
  let t5;
  $[10] !== open ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToggleArrow, { open }) }), $[10] = open, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t4 || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(IconBox, { "data-open": t4, children: t5 }), $[12] = t4, $[13] = t5, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== icon ? (t7 = icon && /* @__PURE__ */ jsx(Box, { marginLeft: 1, children: icon }), $[15] = icon, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== title ? (t8 = /* @__PURE__ */ jsx(Box, { flex: 1, marginLeft: 1, children: /* @__PURE__ */ jsx(Text$1, { textOverflow: "ellipsis", size: 1, weight: "medium", children: title }) }), $[17] = title, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== t6 || $[20] !== t7 || $[21] !== t8 ? (t9 = /* @__PURE__ */ jsx(HeaderButton, { type: "button", onClick: handleToggle, children: /* @__PURE__ */ jsx(Header, { children: /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t6,
    t7,
    t8
  ] }) }) }), $[19] = t6, $[20] = t7, $[21] = t8, $[22] = t9) : t9 = $[22];
  const t10 = !open;
  let t11;
  $[23] !== children || $[24] !== t10 ? (t11 = /* @__PURE__ */ jsx(Box, { hidden: t10, marginTop: 3, children }), $[23] = children, $[24] = t10, $[25] = t11) : t11 = $[25];
  let t12;
  return $[26] !== restProps || $[27] !== t11 || $[28] !== t9 ? (t12 = /* @__PURE__ */ jsxs(Box, { ...restProps, children: [
    t9,
    t11
  ] }), $[26] = restProps, $[27] = t11, $[28] = t9, $[29] = t12) : t12 = $[29], t12;
}
function _temp$3A(v) {
  return !v;
}
const STATUS_TONES = {
  warning: "caution",
  error: "critical",
  info: "positive"
}, STATUS_ICONS = {
  warning: /* @__PURE__ */ jsx(WarningOutlineIcon, {}),
  error: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}),
  info: /* @__PURE__ */ jsx(InfoOutlineIcon, {})
};
function AlertStrip(props2) {
  const $ = c(15);
  let children, rest, t0, title;
  $[0] !== props2 ? ({
    children,
    status: t0,
    title,
    ...rest
  } = props2, $[0] = props2, $[1] = children, $[2] = rest, $[3] = t0, $[4] = title) : (children = $[1], rest = $[2], t0 = $[3], title = $[4]);
  const status = t0 === void 0 ? "warning" : t0, t1 = STATUS_TONES[status];
  let t2;
  $[5] !== children || $[6] !== status || $[7] !== title ? (t2 = children && /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Details, { icon: STATUS_ICONS[status], title, children: /* @__PURE__ */ jsx(Box, { marginLeft: 3, marginTop: 3, children }) }) }), $[5] = children, $[6] = status, $[7] = title, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== t2 ? (t3 = /* @__PURE__ */ jsx(Flex, { padding: 1, children: t2 }), $[9] = t2, $[10] = t3) : t3 = $[10];
  let t4;
  return $[11] !== rest || $[12] !== t1 || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsx(Card, { radius: 2, tone: t1, ...rest, "data-ui": "Alert", children: t3 }), $[11] = rest, $[12] = t1, $[13] = t3, $[14] = t4) : t4 = $[14], t4;
}
function ReferenceFinalizeAlertStrip(t0) {
  const $ = c(17), {
    schemaType,
    handleRemoveStrengthenOnPublish
  } = t0, {
    t
  } = useTranslation(), t1 = schemaType.weak ? "inputs.reference.incomplete-reference.finalize-action-title" : "inputs.reference.incomplete-reference.strengthen-action-title";
  let t2;
  $[0] !== t || $[1] !== t1 ? (t2 = t(t1), $[0] = t, $[1] = t1, $[2] = t2) : t2 = $[2];
  const t3 = schemaType.weak ? "inputs.reference.incomplete-reference.finalize-action-description" : "inputs.reference.incomplete-reference.strengthen-action-description";
  let t4;
  $[3] !== t || $[4] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: t3 }) }), $[3] = t, $[4] = t3, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== t ? (t5 = t("inputs.reference.incomplete-reference.strengthen-button-label"), $[6] = t, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== handleRemoveStrengthenOnPublish || $[9] !== t5 ? (t6 = /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: handleRemoveStrengthenOnPublish, size: "large", text: t5, tone: "positive" }), $[8] = handleRemoveStrengthenOnPublish, $[9] = t5, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== t4 || $[12] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t4,
    t6
  ] }), $[11] = t4, $[12] = t6, $[13] = t7) : t7 = $[13];
  let t8;
  return $[14] !== t2 || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(AlertStrip, { padding: 1, title: t2, status: "info", "data-testid": "alert-reference-published", children: t7 }), $[14] = t2, $[15] = t7, $[16] = t8) : t8 = $[16], t8;
}
const StyledCard$4 = styled(Card).withConfig({
  displayName: "StyledCard",
  componentId: "sc-1spfqh0-0"
})`min-height:33px;position:relative;&[data-selected],&[data-pressed],&:active{[data-ui='TextWithTone']{color:inherit;}}`, ReferenceLinkCard = forwardRef(function(props2, ref) {
  const $ = c(13);
  let as, cardProps, documentId, documentType;
  $[0] !== props2 ? ({
    as,
    documentId,
    documentType,
    ...cardProps
  } = props2, $[0] = props2, $[1] = as, $[2] = cardProps, $[3] = documentId, $[4] = documentType) : (as = $[1], cardProps = $[2], documentId = $[3], documentType = $[4]);
  let t0;
  $[5] !== as || $[6] !== documentId || $[7] !== documentType ? (t0 = documentId && documentType && {
    "data-as": "a",
    forwardedAs: as,
    documentId,
    documentType
  }, $[5] = as, $[6] = documentId, $[7] = documentType, $[8] = t0) : t0 = $[8];
  const linkProps = t0, t1 = ref;
  let t2;
  return $[9] !== cardProps || $[10] !== linkProps || $[11] !== t1 ? (t2 = /* @__PURE__ */ jsx(StyledCard$4, { ...cardProps, ...linkProps, "data-ui": "ReferenceLinkCard", ref: t1 }), $[9] = cardProps, $[10] = linkProps, $[11] = t1, $[12] = t2) : t2 = $[12], t2;
});
function ReferenceMetadataLoadErrorAlertStrip(t0) {
  const $ = c(15), {
    errorMessage,
    onHandleRetry
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("inputs.reference.metadata-error.title"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== errorMessage ? (t2 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: errorMessage }), $[2] = errorMessage, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t ? (t3 = t("inputs.reference.metadata-error.retry-button-label"), $[4] = t, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== onHandleRetry || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: onHandleRetry, size: "large", text: t3, tone: "primary" }), $[6] = onHandleRetry, $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t2 || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t2,
    t4
  ] }), $[9] = t2, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== t1 || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(AlertStrip, { padding: 1, title: t1, status: "warning", "data-testid": "alert-reference-info-failed", children: t5 }), $[12] = t1, $[13] = t5, $[14] = t6) : t6 = $[14], t6;
}
function ReferenceStrengthMismatchAlertStrip(t0) {
  const $ = c(23), {
    actualStrength,
    handleFixStrengthMismatch
  } = t0, shouldBe = actualStrength === "weak" ? "strong" : "weak", {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("inputs.reference.strength-mismatch.title"), $[0] = t, $[1] = t1) : t1 = $[1];
  const t2 = actualStrength === "weak" ? "inputs.reference.strength-mismatch.is-weak-description" : "inputs.reference.strength-mismatch.is-strong-description";
  let t3;
  $[2] !== t || $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: t2 }) }), $[2] = t, $[3] = t2, $[4] = t3) : t3 = $[4];
  const t4 = shouldBe === "weak" ? "inputs.reference.strength-mismatch.is-strong-consquences" : "inputs.reference.strength-mismatch.is-weak-consquences";
  let t5;
  $[5] !== t || $[6] !== t4 ? (t5 = t(t4), $[5] = t, $[6] = t4, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== t5 ? (t6 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t5 }), $[8] = t5, $[9] = t6) : t6 = $[9];
  const t7 = shouldBe === "weak" ? "inputs.reference.strength-mismatch.weaken-button-label" : "inputs.reference.strength-mismatch.strengthen-button-label";
  let t8;
  $[10] !== t || $[11] !== t7 ? (t8 = t(t7), $[10] = t, $[11] = t7, $[12] = t8) : t8 = $[12];
  let t9;
  $[13] !== handleFixStrengthMismatch || $[14] !== t8 ? (t9 = /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: handleFixStrengthMismatch, size: "large", text: t8, tone: "caution" }), $[13] = handleFixStrengthMismatch, $[14] = t8, $[15] = t9) : t9 = $[15];
  let t10;
  $[16] !== t3 || $[17] !== t6 || $[18] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t3,
    t6,
    t9
  ] }), $[16] = t3, $[17] = t6, $[18] = t9, $[19] = t10) : t10 = $[19];
  let t11;
  return $[20] !== t1 || $[21] !== t10 ? (t11 = /* @__PURE__ */ jsx(AlertStrip, { padding: 1, title: t1, status: "warning", "data-testid": "alert-reference-strength-mismatch", children: t10 }), $[20] = t1, $[21] = t10, $[22] = t11) : t11 = $[22], t11;
}
const noop$5 = () => {
}, INITIAL_LOADING_STATE$4 = {
  isLoading: !0,
  result: void 0,
  error: void 0,
  retry: noop$5
}, EMPTY_STATE$2 = {
  isLoading: !1,
  result: void 0,
  error: void 0,
  retry: noop$5
};
function useReferenceInfo$2(id2, getReferenceInfo2) {
  const $ = c(10), [t0] = useState(_temp$3z), [onRetry$2, onRetry2] = t0;
  let t1;
  if ($[0] !== getReferenceInfo2 || $[1] !== id2 || $[2] !== onRetry2 || $[3] !== onRetry$2) {
    let t2;
    $[5] !== id2 ? (t2 = () => id2, $[5] = id2, $[6] = t2) : t2 = $[6];
    let t3;
    $[7] !== getReferenceInfo2 || $[8] !== onRetry2 ? (t3 = (refId) => refId ? getReferenceInfo2(refId).pipe(map((result) => ({
      isLoading: !1,
      result,
      error: void 0,
      retry: onRetry2
    })), startWith(INITIAL_LOADING_STATE$4), catchError((err) => (console.error(err), of({
      isLoading: !1,
      result: void 0,
      error: err,
      retry: onRetry2
    })))) : of(EMPTY_STATE$2), $[7] = getReferenceInfo2, $[8] = onRetry2, $[9] = t3) : t3 = $[9], t1 = concat(of(null), onRetry$2).pipe(map(t2), concatMap$1(t3)), $[0] = getReferenceInfo2, $[1] = id2, $[2] = onRetry2, $[3] = onRetry$2, $[4] = t1;
  } else
    t1 = $[4];
  return useObservable(t1, INITIAL_LOADING_STATE$4);
}
function _temp$3z() {
  return observableCallback();
}
const READABLE = {
  available: !0,
  reason: "READABLE"
}, PERMISSION_DENIED = {
  available: !1,
  reason: "PERMISSION_DENIED"
}, NOT_FOUND = {
  available: !1,
  reason: "NOT_FOUND"
};
function getReferenceInfo(documentPreviewStore, id2, referenceType, perspective) {
  const {
    publishedId,
    draftId
  } = getIdPair(id2);
  return documentPreviewStore.unstable_observeDocumentStackAvailability(id2, perspective ?? ["published"]).pipe(switchMap((stackAvailability) => {
    const firstMatch = stackAvailability.find((doc) => doc.availability.available || doc.availability.reason === "PERMISSION_DENIED");
    if (!firstMatch?.availability.available) {
      const availability = firstMatch?.availability?.reason === "PERMISSION_DENIED" ? PERMISSION_DENIED : NOT_FOUND;
      return of({
        id: id2,
        type: void 0,
        availability,
        isPublished: null,
        preview: {
          snapshot: null,
          original: null
        }
      });
    }
    return documentPreviewStore.observeDocumentTypeFromId(draftId, void 0, perspective).pipe(switchMap((typeName) => {
      if (!typeName)
        return of({
          id: id2,
          type: void 0,
          availability: {
            available: !0,
            reason: "READABLE"
          },
          isPublished: null,
          preview: {
            snapshot: null,
            original: null
          }
        });
      const refSchemaType = referenceType.to.find((memberType) => memberType.name === typeName);
      if (!refSchemaType)
        return of({
          id: id2,
          type: typeName,
          availability: {
            available: !0,
            reason: "READABLE"
          },
          isPublished: null,
          preview: {
            snapshot: null,
            original: null
          }
        });
      const publishedDocumentExists$ = documentPreviewStore.observePaths({
        _id: publishedId
      }, ["_rev"]).pipe(map((res) => !!res?._rev)), previewState$ = getPreviewStateObservable$1(documentPreviewStore, refSchemaType, publishedId, perspective);
      return combineLatest([previewState$, publishedDocumentExists$]).pipe(map(([previewState, publishedDocumentExists]) => ({
        type: typeName,
        id: publishedId,
        availability: READABLE,
        isPublished: publishedDocumentExists,
        preview: {
          snapshot: previewState.snapshot,
          original: previewState.original
        }
      })));
    }));
  }));
}
function useReferenceInput(options) {
  const $ = c(38), {
    path,
    schemaType
  } = options, schema2 = useSchema(), perspective = usePerspective(), documentPreviewStore = useDocumentPreviewStore(), t0 = useReferenceInputOptions();
  let EditReferenceLinkComponent, activePath, inheritedOptions, initialValueTemplateItems, onEditReference;
  $[0] !== t0 ? ({
    EditReferenceLinkComponent,
    onEditReference,
    activePath,
    initialValueTemplateItems,
    ...inheritedOptions
  } = t0, $[0] = t0, $[1] = EditReferenceLinkComponent, $[2] = activePath, $[3] = inheritedOptions, $[4] = initialValueTemplateItems, $[5] = onEditReference) : (EditReferenceLinkComponent = $[1], activePath = $[2], inheritedOptions = $[3], initialValueTemplateItems = $[4], onEditReference = $[5]);
  let t1;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[6] = t1) : t1 = $[6];
  const documentTypeName = useFormValue(t1)?._type;
  let t2;
  $[7] !== documentTypeName || $[8] !== schema2 ? (t2 = schema2.get(documentTypeName)?.liveEdit, $[7] = documentTypeName, $[8] = schema2, $[9] = t2) : t2 = $[9];
  const isCurrentDocumentLiveEdit = t2, disableNew = inheritedOptions.disableNew ?? schemaType.options?.disableNew === !0, template = options.value?._strengthenOnPublish?.template;
  let t3;
  $[10] !== EditReferenceLinkComponent || $[11] !== path || $[12] !== template ? (t3 = forwardRef(function(_props, forwardedRef) {
    return EditReferenceLinkComponent ? /* @__PURE__ */ jsx(EditReferenceLinkComponent, { ..._props, ref: forwardedRef, parentRefPath: path, template }) : null;
  }), $[10] = EditReferenceLinkComponent, $[11] = path, $[12] = template, $[13] = t3) : t3 = $[13];
  const EditReferenceLink = t3;
  let t4;
  $[14] !== onEditReference || $[15] !== path ? (t4 = (event) => {
    onEditReference?.({
      parentRefPath: path,
      id: event.id,
      type: event.type,
      template: event.template
    });
  }, $[14] = onEditReference, $[15] = path, $[16] = t4) : t4 = $[16];
  const handleEditReference = t4;
  let t5;
  $[17] !== activePath?.path || $[18] !== activePath?.state || $[19] !== path ? (t5 = PathUtils.startsWith(path, activePath?.path || []) ? activePath?.state : "none", $[17] = activePath?.path, $[18] = activePath?.state, $[19] = path, $[20] = t5) : t5 = $[20];
  const selectedState = t5;
  let t6;
  bb0: {
    if (disableNew) {
      let t73;
      $[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t73 = [], $[21] = t73) : t73 = $[21], t6 = t73;
      break bb0;
    }
    let t72;
    if ($[22] !== initialValueTemplateItems || $[23] !== schemaType.to) {
      let t82;
      $[25] !== schemaType.to ? (t82 = (i) => schemaType.to.some((refType) => refType.name === i.template?.schemaType), $[25] = schemaType.to, $[26] = t82) : t82 = $[26], t72 = (initialValueTemplateItems || []).filter(t82).map(_temp$3y).filter(isNonNullable$2), $[22] = initialValueTemplateItems, $[23] = schemaType.to, $[24] = t72;
    } else
      t72 = $[24];
    t6 = t72;
  }
  const createOptions = t6;
  let t7;
  $[27] !== documentPreviewStore || $[28] !== perspective.perspectiveStack || $[29] !== schemaType ? (t7 = (id2) => getReferenceInfo(documentPreviewStore, id2, schemaType, perspective.perspectiveStack), $[27] = documentPreviewStore, $[28] = perspective.perspectiveStack, $[29] = schemaType, $[30] = t7) : t7 = $[30];
  const getReferenceInfo$1 = t7;
  let t8;
  return $[31] !== EditReferenceLink || $[32] !== createOptions || $[33] !== getReferenceInfo$1 || $[34] !== handleEditReference || $[35] !== isCurrentDocumentLiveEdit || $[36] !== selectedState ? (t8 = {
    selectedState,
    isCurrentDocumentLiveEdit,
    handleEditReference,
    EditReferenceLink,
    createOptions,
    getReferenceInfo: getReferenceInfo$1
  }, $[31] = EditReferenceLink, $[32] = createOptions, $[33] = getReferenceInfo$1, $[34] = handleEditReference, $[35] = isCurrentDocumentLiveEdit, $[36] = selectedState, $[37] = t8) : t8 = $[37], t8;
}
function _temp$3y(item) {
  return item.template?.schemaType ? {
    id: item.id,
    title: item.title || `${item.template.schemaType} from template ${item.template.id}`,
    type: item.template.schemaType,
    icon: item.icon,
    template: {
      id: item.template.id,
      params: item.parameters
    },
    permission: {
      granted: item.granted,
      reason: item.reason
    }
  } : void 0;
}
const WithFocusRingCard = withFocusRing(Card);
function getTone$3({
  readOnly,
  hasErrors,
  hasWarnings
}) {
  return readOnly ? "transparent" : hasErrors ? "critical" : hasWarnings ? "caution" : "default";
}
const MENU_POPOVER_PROPS$9 = {
  portal: !0,
  tone: "default"
};
function ReferenceInputPreview(props2) {
  const $ = c(83), elementRef = useRef(null), {
    schemaType,
    path,
    children,
    focusPath
  } = props2, {
    readOnly,
    focused,
    renderPreview,
    onChange,
    onPathFocus,
    id: inputId
  } = props2;
  let t0;
  $[0] !== onChange ? (t0 = () => onChange(unset()), $[0] = onChange, $[1] = t0) : t0 = $[1];
  const handleClear = t0, value = props2.value;
  let t1;
  $[2] !== path || $[3] !== schemaType || $[4] !== value ? (t1 = {
    path,
    schemaType,
    value
  }, $[2] = path, $[3] = schemaType, $[4] = value, $[5] = t1) : t1 = $[5];
  const {
    EditReferenceLink,
    getReferenceInfo: getReferenceInfo2,
    selectedState,
    isCurrentDocumentLiveEdit
  } = useReferenceInput(t1);
  let t2;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && elementRef.current && elementRef.current.focus();
  }, $[6] = t2) : t2 = $[6], useDidUpdate(focused, t2);
  const hasErrors = props2.validation.some(_temp$3x), hasWarnings = props2.validation.some(_temp2$1x), loadableReferenceInfo = useReferenceInfo$2(value?._ref, getReferenceInfo2), refTypeName = loadableReferenceInfo.result?.type || value?._strengthenOnPublish?.type;
  let t3;
  $[7] !== refTypeName || $[8] !== schemaType.to ? (t3 = refTypeName ? schemaType.to.find((toType) => toType.name === refTypeName) : void 0, $[7] = refTypeName, $[8] = schemaType.to, $[9] = t3) : t3 = $[9];
  const refType = t3, pressed = selectedState === "pressed", selected = selectedState === "selected", hasRef = value?._ref, publishedReferenceExists = hasRef && loadableReferenceInfo.result?.isPublished;
  let t4;
  $[10] !== onChange || $[11] !== schemaType.weak ? (t4 = () => {
    onChange([schemaType.weak === !0 ? set(!0, ["_weak"]) : unset(["_weak"]), unset(["_strengthenOnPublish"])]);
  }, $[10] = onChange, $[11] = schemaType.weak, $[12] = t4) : t4 = $[12];
  const handleRemoveStrengthenOnPublish = t4;
  let t5;
  $[13] !== onChange || $[14] !== schemaType.weak ? (t5 = () => {
    onChange(schemaType.weak === !0 ? set(!0, ["_weak"]) : unset(["_weak"]));
  }, $[13] = onChange, $[14] = schemaType.weak, $[15] = t5) : t5 = $[15];
  const handleFixStrengthMismatch = t5;
  let t6;
  $[16] !== onPathFocus ? (t6 = () => {
    onPathFocus(["_ref"]);
  }, $[16] = onPathFocus, $[17] = t6) : t6 = $[17];
  const handleReplace = t6, actualStrength = value?._weak ? "weak" : "strong", weakShouldBe = schemaType.weak === !0 ? "weak" : "strong", weakWarningOverride = hasRef && !loadableReferenceInfo.isLoading && value?._strengthenOnPublish, showWeakRefMismatch = !loadableReferenceInfo.isLoading && loadableReferenceInfo.result?.availability.available && hasRef && actualStrength !== weakShouldBe && !weakWarningOverride, tone = getTone$3({
    readOnly,
    hasErrors,
    hasWarnings
  }), isEditing = !value?._ref || focusPath[0] === "_ref", {
    t
  } = useTranslation();
  let t7;
  $[18] !== handleRemoveStrengthenOnPublish || $[19] !== isCurrentDocumentLiveEdit || $[20] !== publishedReferenceExists || $[21] !== schemaType || $[22] !== value ? (t7 = isCurrentDocumentLiveEdit && publishedReferenceExists && value._strengthenOnPublish && /* @__PURE__ */ jsx(ReferenceFinalizeAlertStrip, { schemaType, handleRemoveStrengthenOnPublish }), $[18] = handleRemoveStrengthenOnPublish, $[19] = isCurrentDocumentLiveEdit, $[20] = publishedReferenceExists, $[21] = schemaType, $[22] = value, $[23] = t7) : t7 = $[23];
  let t8;
  $[24] !== actualStrength || $[25] !== handleFixStrengthMismatch || $[26] !== showWeakRefMismatch ? (t8 = showWeakRefMismatch && /* @__PURE__ */ jsx(ReferenceStrengthMismatchAlertStrip, { actualStrength, handleFixStrengthMismatch }), $[24] = actualStrength, $[25] = handleFixStrengthMismatch, $[26] = showWeakRefMismatch, $[27] = t8) : t8 = $[27];
  let t9;
  $[28] !== loadableReferenceInfo.error || $[29] !== loadableReferenceInfo.retry ? (t9 = loadableReferenceInfo.error && /* @__PURE__ */ jsx(ReferenceMetadataLoadErrorAlertStrip, { errorMessage: loadableReferenceInfo.error.message, onHandleRetry: loadableReferenceInfo.retry }), $[28] = loadableReferenceInfo.error, $[29] = loadableReferenceInfo.retry, $[30] = t9) : t9 = $[30];
  let t10;
  $[31] !== t7 || $[32] !== t8 || $[33] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t7,
    t8,
    t9
  ] }), $[31] = t7, $[32] = t8, $[33] = t9, $[34] = t10) : t10 = $[34];
  const footer = t10;
  let t11;
  $[35] !== refType?.name || $[36] !== value?._ref ? (t11 = forwardRef(function(restProps, _ref) {
    return /* @__PURE__ */ jsx(IntentLink, { ...restProps, intent: "edit", params: {
      id: value?._ref,
      type: refType?.name
    }, target: "_blank", rel: "noopener noreferrer", ref: _ref });
  }), $[35] = refType?.name, $[36] = value?._ref, $[37] = t11) : t11 = $[37];
  const OpenLink = t11;
  let t12;
  $[38] !== OpenLink || $[39] !== handleClear || $[40] !== handleReplace || $[41] !== inputId || $[42] !== readOnly || $[43] !== t || $[44] !== value?._ref ? (t12 = () => readOnly ? null : /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(MenuButton, { button: /* @__PURE__ */ jsx(ContextMenuButton, {}), id: `${inputId}-menuButton`, menu: /* @__PURE__ */ jsxs(Menu, { children: [
    !readOnly && /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.reference.action.clear"), tone: "critical", icon: TrashIcon, onClick: handleClear }),
      /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.reference.action.replace"), icon: SyncIcon, onClick: handleReplace })
    ] }),
    !readOnly && value?._ref && /* @__PURE__ */ jsx(MenuDivider, {}),
    value?._ref && /* @__PURE__ */ jsx(MenuItem, { as: OpenLink, "data-as": "a", text: t("inputs.reference.action.open-in-new-tab"), icon: LaunchIcon })
  ] }), popover: MENU_POPOVER_PROPS$9 }) }), $[38] = OpenLink, $[39] = handleClear, $[40] = handleReplace, $[41] = inputId, $[42] = readOnly, $[43] = t, $[44] = value?._ref, $[45] = t12) : t12 = $[45];
  let t13;
  $[46] !== t12 ? (t13 = t12(), $[46] = t12, $[47] = t13) : t13 = $[47];
  const menu = t13;
  let t14;
  $[48] !== onPathFocus ? (t14 = (event) => {
    event.target === elementRef.current && onPathFocus(EMPTY_ARRAY$y);
  }, $[48] = onPathFocus, $[49] = t14) : t14 = $[49];
  const handleFocus = t14, [cardRef, setCardRef] = useState(null);
  let t15, t16;
  if ($[50] !== cardRef || $[51] !== focused ? (t15 = () => {
    focused && cardRef && cardRef.focus();
  }, t16 = [focused, cardRef], $[50] = cardRef, $[51] = focused, $[52] = t15, $[53] = t16) : (t15 = $[52], t16 = $[53]), useEffect(t15, t16), isEditing) {
    let t172;
    return $[54] !== children ? (t172 = /* @__PURE__ */ jsx(Box, { children }), $[54] = children, $[55] = t172) : t172 = $[55], t172;
  }
  let t17;
  $[56] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t17 = {
    lineHeight: 0
  }, $[56] = t17) : t17 = $[56];
  const t18 = pressed ? !0 : void 0, t19 = selected ? !0 : void 0, t20 = value?._ref, t21 = refType?.name;
  let t22;
  $[57] !== loadableReferenceInfo || $[58] !== renderPreview || $[59] !== schemaType || $[60] !== value ? (t22 = /* @__PURE__ */ jsx(PreviewReferenceValue$2, { value, referenceInfo: loadableReferenceInfo, renderPreview, type: schemaType }), $[57] = loadableReferenceInfo, $[58] = renderPreview, $[59] = schemaType, $[60] = value, $[61] = t22) : t22 = $[61];
  let t23;
  $[62] !== EditReferenceLink || $[63] !== handleFocus || $[64] !== pressed || $[65] !== selected || $[66] !== t18 || $[67] !== t19 || $[68] !== t20 || $[69] !== t21 || $[70] !== t22 ? (t23 = /* @__PURE__ */ jsx(ReferenceLinkCard, { __unstable_focusRing: !0, as: EditReferenceLink, "data-pressed": t18, "data-selected": t19, documentId: t20, documentType: t21, flex: 1, pressed, radius: 2, ref: elementRef, selected, tone: "inherit", onFocus: handleFocus, children: t22 }), $[62] = EditReferenceLink, $[63] = handleFocus, $[64] = pressed, $[65] = selected, $[66] = t18, $[67] = t19, $[68] = t20, $[69] = t21, $[70] = t22, $[71] = t23) : t23 = $[71];
  let t24;
  $[72] !== menu ? (t24 = /* @__PURE__ */ jsx(Box, { children: menu }), $[72] = menu, $[73] = t24) : t24 = $[73];
  let t25;
  $[74] !== t23 || $[75] !== t24 ? (t25 = /* @__PURE__ */ jsx(Flex, { gap: 1, align: "center", style: t17, children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
    t23,
    t24
  ] }) }), $[74] = t23, $[75] = t24, $[76] = t25) : t25 = $[76];
  let t26;
  $[77] !== footer || $[78] !== t25 ? (t26 = /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    t25,
    footer
  ] }), $[77] = footer, $[78] = t25, $[79] = t26) : t26 = $[79];
  let t27;
  return $[80] !== t26 || $[81] !== tone ? (t27 = /* @__PURE__ */ jsx(WithFocusRingCard, { border: !0, $radius: 2, padding: 1, tone, ref: setCardRef, tabIndex: -1, children: t26 }), $[80] = t26, $[81] = tone, $[82] = t27) : t27 = $[82], t27;
}
function _temp2$1x(v_0) {
  return v_0.level === "warning";
}
function _temp$3x(v) {
  return v.level === "error";
}
function useReferenceItemRef() {
  const $ = c(1), ref = useContext(ReferenceItemRefContext);
  if (!ref) {
    let t0;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
      menuRef: {
        current: null
      },
      menuButtonRef: {
        current: null
      },
      containerRef: {
        current: null
      }
    }, $[0] = t0) : t0 = $[0], t0;
  }
  return ref;
}
const INITIAL_SEARCH_STATE$3 = {
  hits: [],
  isLoading: !1
}, NO_FILTER$3 = () => !0;
function nonNullable$1(v) {
  return v !== null;
}
function ReferenceInput(props2) {
  const $ = c(103), {
    createOptions,
    onChange,
    onEditReference,
    onSearch,
    schemaType,
    readOnly,
    id: id2,
    onPathFocus,
    value,
    renderPreview,
    path,
    elementProps,
    focusPath
  } = props2, {
    selectedReleaseId
  } = usePerspective();
  let t0;
  $[0] !== path || $[1] !== schemaType || $[2] !== value ? (t0 = {
    path,
    schemaType,
    value
  }, $[0] = path, $[1] = schemaType, $[2] = value, $[3] = t0) : t0 = $[3];
  const {
    getReferenceInfo: getReferenceInfo2
  } = useReferenceInput(t0), [searchState, setSearchState] = useState(INITIAL_SEARCH_STATE$3);
  let t1;
  $[4] !== onChange || $[5] !== onEditReference || $[6] !== onPathFocus || $[7] !== path || $[8] !== schemaType.name || $[9] !== schemaType.weak || $[10] !== selectedReleaseId ? (t1 = (option) => {
    const newDocumentId = uuid(), strengthenOnPublishPatches = typeof selectedReleaseId > "u" ? [set(!0, ["_weak"])] : [], createInPlaceMetadataPatches = [set({
      type: option.type,
      weak: schemaType.weak,
      template: option.template
    }, ["_strengthenOnPublish"])], patches = [setIfMissing({}), set(schemaType.name, ["_type"]), set(newDocumentId, ["_ref"])].concat(strengthenOnPublishPatches, createInPlaceMetadataPatches).filter(isNonNullable$2);
    onChange(patches), onEditReference({
      id: newDocumentId,
      type: option.type,
      template: option.template,
      version: selectedReleaseId
    }), onPathFocus(path);
  }, $[4] = onChange, $[5] = onEditReference, $[6] = onPathFocus, $[7] = path, $[8] = schemaType.name, $[9] = schemaType.weak, $[10] = selectedReleaseId, $[11] = t1) : t1 = $[11];
  const handleCreateNew = t1;
  let t2;
  $[12] !== onChange || $[13] !== onPathFocus || $[14] !== path || $[15] !== schemaType.name || $[16] !== schemaType.weak || $[17] !== searchState.hits ? (t2 = (nextId) => {
    if (!nextId) {
      onChange(unset()), onPathFocus([]);
      return;
    }
    const hit = searchState.hits.find((h) => h.id === nextId);
    if (!hit)
      throw new Error("Selected an item that wasnt part of the result set");
    const patches_0 = [setIfMissing({}), set(schemaType.name, ["_type"]), set(getPublishedId(nextId), ["_ref"]), hit.published && !schemaType.weak ? unset(["_weak"]) : set(!0, ["_weak"]), hit.published ? unset(["_strengthenOnPublish"]) : set({
      type: hit?.type,
      weak: schemaType.weak
    }, ["_strengthenOnPublish"])].filter(isNonNullable$2);
    onChange(patches_0), onPathFocus(path);
  }, $[12] = onChange, $[13] = onPathFocus, $[14] = path, $[15] = schemaType.name, $[16] = schemaType.weak, $[17] = searchState.hits, $[18] = t2) : t2 = $[18];
  const handleChange = t2;
  let t3;
  $[19] !== onChange ? (t3 = () => {
    onChange(unset());
  }, $[19] = onChange, $[20] = t3) : t3 = $[20];
  const handleClear = t3;
  let t4;
  $[21] !== onPathFocus || $[22] !== path ? (t4 = (event) => {
    event.key === "Escape" && onPathFocus(path);
  }, $[21] = onPathFocus, $[22] = path, $[23] = t4) : t4 = $[23];
  const handleAutocompleteKeyDown = t4, loadableReferenceInfo = useReferenceInfo$2(value?._ref, getReferenceInfo2), [autocompletePopoverReferenceElement, setAutocompletePopoverReferenceElement] = useState(null), {
    push
  } = useToast(), {
    t
  } = useTranslation();
  let t5;
  $[24] !== id2 || $[25] !== onSearch || $[26] !== push || $[27] !== t ? (t5 = (inputValue$) => inputValue$.pipe(filter(nonNullable$1), switchMap((searchString) => concat(of({
    isLoading: !0
  }), onSearch(searchString).pipe(map((hits) => ({
    hits,
    searchString,
    isLoading: !1
  })), catchError((error) => (push({
    title: t("inputs.reference.error.search-failed-title"),
    description: error.message,
    status: "error",
    id: `reference-search-fail-${id2}`
  }), console.error(error), of({
    hits: [],
    searchString,
    isLoading: !1
  })))))), scan(_temp$3w, INITIAL_SEARCH_STATE$3), tap(setSearchState)), $[24] = id2, $[25] = onSearch, $[26] = push, $[27] = t, $[28] = t5) : t5 = $[28];
  const handleQueryChange = useObservableEvent(t5);
  let t6;
  $[29] !== handleQueryChange ? (t6 = () => {
    handleQueryChange("");
  }, $[29] = handleQueryChange, $[30] = t6) : t6 = $[30];
  const handleAutocompleteOpenButtonClick = t6;
  let t7;
  $[31] !== onPathFocus || $[32] !== path ? (t7 = (e) => {
    e.key === "Escape" && onPathFocus(path);
  }, $[31] = onPathFocus, $[32] = path, $[33] = t7) : t7 = $[33];
  const handleCreateButtonKeyDown = t7;
  let t8;
  $[34] !== renderPreview || $[35] !== schemaType ? (t8 = (option_0) => /* @__PURE__ */ jsx(ReferenceInputPreviewCard, { forwardedAs: "button", type: "button", radius: 2, tone: "inherit", children: /* @__PURE__ */ jsx(OptionPreview$2, { id: option_0.hit.id, type: option_0.hit.type, renderPreview, referenceType: schemaType }) }), $[34] = renderPreview, $[35] = schemaType, $[36] = t8) : t8 = $[36];
  const renderOption = t8;
  let t9;
  $[37] !== loadableReferenceInfo.result?.preview?.original?.title || $[38] !== loadableReferenceInfo.result?.preview?.snapshot?.title ? (t9 = () => loadableReferenceInfo.result?.preview?.snapshot?.title || loadableReferenceInfo.result?.preview?.original?.title || "", $[37] = loadableReferenceInfo.result?.preview?.original?.title, $[38] = loadableReferenceInfo.result?.preview?.snapshot?.title, $[39] = t9) : t9 = $[39];
  const renderValue = t9;
  let t10;
  $[40] !== onPathFocus ? (t10 = () => onPathFocus(["_ref"]), $[40] = onPathFocus, $[41] = t10) : t10 = $[41];
  const handleFocus = t10;
  let t11;
  $[42] !== autocompletePopoverReferenceElement || $[43] !== props2.elementProps ? (t11 = (event_0) => {
    autocompletePopoverReferenceElement?.contains(event_0.relatedTarget) || props2.elementProps.onBlur(event_0);
  }, $[42] = autocompletePopoverReferenceElement, $[43] = props2.elementProps, $[44] = t11) : t11 = $[44];
  const handleBlur = t11, isWeakRefToNonexistent = loadableReferenceInfo?.result?.availability?.reason === "NOT_FOUND" && !value?._strengthenOnPublish && value?._weak;
  let t12;
  $[45] !== elementProps ? (t12 = (hadFocusAtRef, hasFocusAtRef) => {
    !hadFocusAtRef && hasFocusAtRef && elementProps.ref.current?.focus();
  }, $[45] = elementProps, $[46] = t12) : t12 = $[46], useDidUpdate(focusPath?.[0] === "_ref", t12);
  let t13;
  $[47] !== searchState.hits ? (t13 = searchState.hits.map(_temp2$1w), $[47] = searchState.hits, $[48] = t13) : t13 = $[48];
  const hits_0 = t13, isEditing = focusPath.length === 1 && focusPath[0] === "_ref", {
    menuRef,
    menuButtonRef,
    containerRef
  } = useReferenceItemRef(), clickOutsideBoundaryRef = useRef(null), autoCompletePortalRef = useRef(null), createButtonMenuPortalRef = useRef(null);
  let t14;
  $[49] !== handleClear || $[50] !== isEditing || $[51] !== menuButtonRef || $[52] !== value?._ref ? (t14 = !value?._ref && (() => {
    (isEditing || document.activeElement === menuButtonRef.current) && handleClear();
  }), $[49] = handleClear, $[50] = isEditing, $[51] = menuButtonRef, $[52] = value?._ref, $[53] = t14) : t14 = $[53];
  let t15;
  $[54] !== containerRef || $[55] !== menuButtonRef || $[56] !== menuRef ? (t15 = () => [menuRef.current, menuButtonRef.current, containerRef.current, clickOutsideBoundaryRef.current, autoCompletePortalRef.current, createButtonMenuPortalRef.current], $[54] = containerRef, $[55] = menuButtonRef, $[56] = menuRef, $[57] = t15) : t15 = $[57], useClickOutsideEvent(t14, t15);
  const t16 = props2.elementProps.style;
  let t17;
  $[58] !== handleClear || $[59] !== isWeakRefToNonexistent || $[60] !== t || $[61] !== value ? (t17 = isWeakRefToNonexistent ? /* @__PURE__ */ jsx(Alert, { "data-testid": "alert-nonexistent-document", title: t("inputs.reference.error.nonexistent-document-title"), suffix: /* @__PURE__ */ jsx(Stack, { padding: 2, children: /* @__PURE__ */ jsx(Button, { text: t("inputs.reference.error.nonexistent-document.clear-button-label"), onClick: handleClear }) }), children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "inputs.reference.error.nonexistent-document-description", t, values: {
    documentId: value._ref
  } }) }) }) : null, $[58] = handleClear, $[59] = isWeakRefToNonexistent, $[60] = t, $[61] = value, $[62] = t17) : t17 = $[62];
  const t18 = searchState.isLoading;
  let t19;
  $[63] !== t ? (t19 = t("inputs.reference.search-placeholder"), $[63] = t, $[64] = t19) : t19 = $[64];
  const t20 = loadableReferenceInfo.isLoading || readOnly, t21 = renderOption;
  let t22;
  $[65] !== handleAutocompleteOpenButtonClick ? (t22 = {
    onClick: handleAutocompleteOpenButtonClick
  }, $[65] = handleAutocompleteOpenButtonClick, $[66] = t22) : t22 = $[66];
  const t23 = value?._ref;
  let t24;
  $[67] !== autocompletePopoverReferenceElement || $[68] !== elementProps || $[69] !== handleAutocompleteKeyDown || $[70] !== handleBlur || $[71] !== handleChange || $[72] !== handleFocus || $[73] !== handleQueryChange || $[74] !== hits_0 || $[75] !== path || $[76] !== renderValue || $[77] !== searchState.isLoading || $[78] !== searchState.searchString || $[79] !== t19 || $[80] !== t20 || $[81] !== t21 || $[82] !== t22 || $[83] !== t23 ? (t24 = /* @__PURE__ */ jsx(ReferenceAutocomplete$3, { ...elementProps, path, onFocus: handleFocus, onBlur: handleBlur, "data-testid": "autocomplete", loading: t18, referenceElement: autocompletePopoverReferenceElement, options: hits_0, radius: 2, placeholder: t19, onKeyDown: handleAutocompleteKeyDown, readOnly: t20, onQueryChange: handleQueryChange, searchString: searchState.searchString, onChange: handleChange, filterOption: NO_FILTER$3, renderOption: t21, renderValue, openButton: t22, portalRef: autoCompletePortalRef, value: t23 }), $[67] = autocompletePopoverReferenceElement, $[68] = elementProps, $[69] = handleAutocompleteKeyDown, $[70] = handleBlur, $[71] = handleChange, $[72] = handleFocus, $[73] = handleQueryChange, $[74] = hits_0, $[75] = path, $[76] = renderValue, $[77] = searchState.isLoading, $[78] = searchState.searchString, $[79] = t19, $[80] = t20, $[81] = t21, $[82] = t22, $[83] = t23, $[84] = t24) : t24 = $[84];
  let t25;
  $[85] !== createOptions || $[86] !== handleCreateButtonKeyDown || $[87] !== handleCreateNew || $[88] !== id2 || $[89] !== readOnly ? (t25 = createOptions.length > 0 && /* @__PURE__ */ jsx(CreateButton, { id: `${id2}-selectTypeMenuButton`, readOnly, createOptions, onCreate: handleCreateNew, onKeyDown: handleCreateButtonKeyDown, menuRef: createButtonMenuPortalRef }), $[85] = createOptions, $[86] = handleCreateButtonKeyDown, $[87] = handleCreateNew, $[88] = id2, $[89] = readOnly, $[90] = t25) : t25 = $[90];
  let t26;
  $[91] !== t24 || $[92] !== t25 ? (t26 = /* @__PURE__ */ jsxs(AutocompleteContainer, { ref: setAutocompletePopoverReferenceElement, children: [
    t24,
    t25
  ] }), $[91] = t24, $[92] = t25, $[93] = t26) : t26 = $[93];
  let t27;
  $[94] !== t17 || $[95] !== t26 ? (t27 = /* @__PURE__ */ jsx(Stack, { space: 1, "data-testid": "reference-input", ref: clickOutsideBoundaryRef, children: /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t17,
    t26
  ] }) }), $[94] = t17, $[95] = t26, $[96] = t27) : t27 = $[96];
  let t28;
  $[97] !== props2 || $[98] !== t27 ? (t28 = /* @__PURE__ */ jsx(ReferenceInputPreview, { ...props2, children: t27 }), $[97] = props2, $[98] = t27, $[99] = t28) : t28 = $[99];
  let t29;
  return $[100] !== props2.elementProps.style || $[101] !== t28 ? (t29 = /* @__PURE__ */ jsx("div", { style: t16, children: t28 }), $[100] = props2.elementProps.style, $[101] = t28, $[102] = t29) : t29 = $[102], t29;
}
function _temp2$1w(hit_0) {
  return {
    value: hit_0.id,
    hit: hit_0
  };
}
function _temp$3w(prevState, nextState) {
  return {
    ...prevState,
    ...nextState
  };
}
function resolveCreateTypeFilter(options) {
  const {
    schemaType,
    document: document2,
    valuePath
  } = options, availableTypes = schemaType.to.map((refType) => refType.name), toTypes = availableTypes.map((type) => ({
    type
  })), filterFn = schemaType.options?.creationTypeFilter;
  if (!filterFn) return toTypes;
  const parentPath = valuePath.slice(0, -1), context = {
    document: document2,
    parent: get$1(document2, parentPath),
    parentPath
  };
  try {
    const filteredResult = filterFn(context, toTypes);
    if (!Array.isArray(filteredResult))
      return console.error("[sanity] creationTypeFilter must return an array, falling back to all types"), toTypes;
    if (filteredResult.length === 0)
      return [];
    const validTypes = filteredResult.filter((item) => !item || typeof item != "object" || !("type" in item) ? (console.error("[sanity] creationTypeFilter returned invalid object without type property:", item), !1) : availableTypes.includes(item.type));
    return validTypes.length > 0 ? validTypes : toTypes;
  } catch (error) {
    return console.error("[sanity] Error in reference creationTypeFilter function, falling back to all types:", error), toTypes;
  }
}
async function resolveUserDefinedFilter$2(ctx) {
  const {
    options,
    document: document2,
    valuePath,
    perspective,
    getClient: getClient2
  } = ctx;
  if (!options)
    return {};
  if (typeof options.filter == "function") {
    const parentPath = valuePath.slice(0, -1), parent = get$1(document2, parentPath);
    return await options.filter({
      document: document2,
      parentPath,
      parent,
      perspective,
      getClient: getClient2
    });
  }
  return {
    filter: options.filter,
    params: "filterParams" in options ? options.filterParams : void 0
  };
}
function getInvalidUserDefinedPerspectives(valid, perspective) {
  return (perspective ? Array.isArray(perspective) ? perspective : [perspective] : []).filter((p) => p !== "drafts" && p !== "published" && !valid.includes(p));
}
function StudioReferenceInput(props2) {
  const $ = c(52), source = useSource();
  let t0;
  $[0] !== source ? (t0 = source.getClient(DEFAULT_STUDIO_CLIENT_OPTIONS), $[0] = source, $[1] = t0) : t0 = $[1];
  const searchClient = t0, {
    perspectiveStack
  } = usePerspective(), schema2 = useSchema(), maxFieldDepth = useSearchMaxFieldDepth(), documentPreviewStore = useDocumentPreviewStore(), {
    path,
    schemaType
  } = props2, t1 = useReferenceInputOptions();
  let EditReferenceLinkComponent, activePath, inheritedOptions, initialValueTemplateItems, onEditReference;
  $[2] !== t1 ? ({
    EditReferenceLinkComponent,
    onEditReference,
    activePath,
    initialValueTemplateItems,
    ...inheritedOptions
  } = t1, $[2] = t1, $[3] = EditReferenceLinkComponent, $[4] = activePath, $[5] = inheritedOptions, $[6] = initialValueTemplateItems, $[7] = onEditReference) : (EditReferenceLinkComponent = $[3], activePath = $[4], inheritedOptions = $[5], initialValueTemplateItems = $[6], onEditReference = $[7]);
  const {
    strategy: searchStrategy
  } = source.search;
  let t2;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[8] = t2) : t2 = $[8];
  const documentValue = useFormValue(t2), documentTypeName = documentValue?._type;
  let t3;
  $[9] !== documentTypeName || $[10] !== schema2 ? (t3 = schema2.get(documentTypeName), $[9] = documentTypeName, $[10] = schema2, $[11] = t3) : t3 = $[11];
  const isDocumentLiveEdit = t3?.liveEdit, disableNew = inheritedOptions.disableNew ?? schemaType.options?.disableNew === !0, getClient2 = source.getClient;
  let t4;
  $[12] !== documentPreviewStore || $[13] !== documentValue || $[14] !== getClient2 || $[15] !== maxFieldDepth || $[16] !== path || $[17] !== perspectiveStack || $[18] !== schemaType.options || $[19] !== schemaType.to || $[20] !== searchClient || $[21] !== searchStrategy ? (t4 = (searchString) => from(resolveUserDefinedFilter$2({
    options: schemaType.options,
    document: documentValue,
    perspective: perspectiveStack,
    valuePath: path,
    getClient: getClient2
  })).pipe(mergeMap((t52) => {
    const {
      filter: filter2,
      params,
      perspective: userDefinedFilterPerspective
    } = t52;
    if (getInvalidUserDefinedPerspectives(perspectiveStack, userDefinedFilterPerspective).length > 0)
      throw new Error(`Custom reference filter returned an invalid perspective. Filters can only remove perspectives from the passed stack, not add new ones. Expected a subset of [${perspectiveStack.join(", ")}], but received [${userDefinedFilterPerspective}].`);
    const options = {
      ...schemaType.options,
      filter: filter2,
      params,
      tag: "search.reference",
      maxFieldDepth,
      strategy: searchStrategy,
      perspective: userDefinedFilterPerspective || perspectiveStack
    };
    return createSearch(schemaType.to, searchClient, {
      ...options,
      maxDepth: options.maxFieldDepth || DEFAULT_MAX_FIELD_DEPTH
    })(searchString, {
      perspective: options.perspective,
      limit: 101
    }).pipe(map(_temp2$1v), switchMap((docs) => docs.length === 0 ? of([]) : combineLatest(docs.map((doc) => documentPreviewStore.observePaths({
      _id: getPublishedId(doc._id)
    }, ["_rev"]).pipe(map((published) => ({
      id: doc._id,
      type: doc._type,
      published: !!published
    })))))));
  }), catchError((err) => {
    const isQueryError = err.details && err.details.type === "queryParseError";
    return schemaType.options?.filter && isQueryError ? throwError(() => new Error('Invalid reference filter, please check the custom "filter" option', {
      cause: err
    })) : throwError(() => err);
  })), $[12] = documentPreviewStore, $[13] = documentValue, $[14] = getClient2, $[15] = maxFieldDepth, $[16] = path, $[17] = perspectiveStack, $[18] = schemaType.options, $[19] = schemaType.to, $[20] = searchClient, $[21] = searchStrategy, $[22] = t4) : t4 = $[22];
  const handleSearch = useEffectEvent(t4), template = props2.value?._strengthenOnPublish?.template;
  let t5;
  $[23] !== EditReferenceLinkComponent || $[24] !== path || $[25] !== template ? (t5 = forwardRef(function(_props, forwardedRef) {
    return EditReferenceLinkComponent ? /* @__PURE__ */ jsx(EditReferenceLinkComponent, { ..._props, ref: forwardedRef, parentRefPath: path, template }) : null;
  }), $[23] = EditReferenceLinkComponent, $[24] = path, $[25] = template, $[26] = t5) : t5 = $[26];
  const EditReferenceLink = t5;
  let t6;
  $[27] !== onEditReference || $[28] !== path ? (t6 = (event) => {
    onEditReference?.({
      parentRefPath: path,
      id: event.id,
      type: event.type,
      template: event.template,
      version: event.version
    });
  }, $[27] = onEditReference, $[28] = path, $[29] = t6) : t6 = $[29];
  const handleEditReference = t6;
  let t7;
  $[30] !== activePath?.path || $[31] !== activePath?.state || $[32] !== path ? (t7 = PathUtils.startsWith(path, activePath?.path || []) ? activePath?.state : "none", $[30] = activePath?.path, $[31] = activePath?.state, $[32] = path, $[33] = t7) : t7 = $[33];
  const selectedState = t7;
  let t8;
  bb0: {
    if (disableNew) {
      let t93;
      $[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t93 = [], $[34] = t93) : t93 = $[34], t8 = t93;
      break bb0;
    }
    let t92;
    if ($[35] !== documentValue || $[36] !== initialValueTemplateItems || $[37] !== path || $[38] !== schemaType) {
      const allowedTypes = resolveCreateTypeFilter({
        schemaType,
        document: documentValue,
        valuePath: path
      }).map(_temp3$J);
      t92 = (initialValueTemplateItems || []).filter((i) => allowedTypes.includes(i.template?.schemaType ?? "")).map(_temp4$k).filter(isNonNullable$2), $[35] = documentValue, $[36] = initialValueTemplateItems, $[37] = path, $[38] = schemaType, $[39] = t92;
    } else
      t92 = $[39];
    t8 = t92;
  }
  const createOptions = t8;
  let t9;
  $[40] !== documentPreviewStore || $[41] !== perspectiveStack ? (t9 = (id2, _type) => getReferenceInfo(documentPreviewStore, id2, _type, perspectiveStack), $[40] = documentPreviewStore, $[41] = perspectiveStack, $[42] = t9) : t9 = $[42];
  const getReferenceInfo$1 = t9;
  let t10;
  return $[43] !== EditReferenceLink || $[44] !== createOptions || $[45] !== getReferenceInfo$1 || $[46] !== handleEditReference || $[47] !== handleSearch || $[48] !== isDocumentLiveEdit || $[49] !== props2 || $[50] !== selectedState ? (t10 = /* @__PURE__ */ jsx(ReferenceInput, { ...props2, onSearch: handleSearch, liveEdit: isDocumentLiveEdit, getReferenceInfo: getReferenceInfo$1, selectedState, editReferenceLinkComponent: EditReferenceLink, createOptions, onEditReference: handleEditReference }), $[43] = EditReferenceLink, $[44] = createOptions, $[45] = getReferenceInfo$1, $[46] = handleEditReference, $[47] = handleSearch, $[48] = isDocumentLiveEdit, $[49] = props2, $[50] = selectedState, $[51] = t10) : t10 = $[51], t10;
}
function _temp4$k(item) {
  return item.template?.schemaType ? {
    id: item.id,
    title: item.title || `${item.template.schemaType} from template ${item.template?.id}`,
    i18n: item.i18n,
    type: item.template.schemaType,
    icon: item.icon,
    template: {
      id: item.template?.id,
      params: item.parameters
    },
    permission: {
      granted: item.granted,
      reason: item.reason
    }
  } : void 0;
}
function _temp3$J(opt) {
  return opt.type;
}
function _temp2$1v(t0) {
  const {
    hits
  } = t0;
  return hits.map(_temp$3v);
}
function _temp$3v(t0) {
  const {
    hit
  } = t0;
  return hit;
}
function isObjectItemProps(item) {
  return isObjectSchemaType(item.schemaType);
}
function isObjectInputProps$1(inputProps) {
  return isObjectSchemaType(inputProps.schemaType);
}
function isStringInputProps(inputProps) {
  return isStringSchemaType(inputProps.schemaType);
}
function isNumberInputProps(inputProps) {
  return isNumberSchemaType(inputProps.schemaType);
}
function isBooleanInputProps(inputProps) {
  return isBooleanSchemaType(inputProps.schemaType);
}
function isArrayOfObjectsInputProps(inputProps) {
  return isArrayOfObjectsSchemaType(inputProps.schemaType);
}
function isArrayOfBlocksInputProps(inputProps) {
  return isArrayOfBlocksSchemaType(inputProps.schemaType);
}
function isArrayOfPrimitivesInputProps(inputProps) {
  return isArrayOfPrimitivesSchemaType(inputProps.schemaType);
}
const GetFormValueProvider = function(props2) {
  const $ = c(6), valueRef = useRef(props2.value);
  let t0, t1;
  $[0] !== props2.value ? (t0 = () => {
    valueRef.current = props2.value;
  }, t1 = [props2.value], $[0] = props2.value, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (path) => getValueAtPath(valueRef.current, path), $[3] = t2) : t2 = $[3];
  const getValue2 = t2;
  let t3;
  return $[4] !== props2.children ? (t3 = /* @__PURE__ */ jsx(GetFormValueContext.Provider, { value: getValue2, children: props2.children }), $[4] = props2.children, $[5] = t3) : t3 = $[5], t3;
};
GetFormValueProvider.displayName = "GetFormValueProvider";
function useGetFormValue() {
  const ctx = useContext(GetFormValueContext);
  if (!ctx)
    throw new Error("useGetFormValue must be used within a GetFormValueProvider");
  return ctx;
}
const NestedDialogOpened = defineEvent({
  name: "Nested Dialog Opened",
  version: 1,
  description: "User opened a nested dialog"
}), NestedDialogClosed = defineEvent({
  name: "Nested Dialog Closed",
  version: 2,
  description: "User closed a nested dialog"
}), NavigatedToViaArrayList = defineEvent({
  name: "Edited Nested Object in Array List",
  version: 1,
  description: "User edited a object - meaning a navigation to a nested object was made through the array list"
}), NavigatedToNestedObjectViaBreadcrumb = defineEvent({
  name: "Navigated to Nested Object via Breadcrumb",
  version: 1,
  description: "User navigated to a nested object via a breadcrumb"
}), NavigatedToNestedObjectViaCloseButton = defineEvent({
  name: "Navigated to Nested Object via Close Button",
  version: 1,
  description: "User navigated to a nested object via closing the top most dialog via the close button"
}), navigatedToNestedObjectViaKeyboardShortcut = defineEvent({
  name: "Navigated to Nested Object via Keyboard Shortcut",
  version: 1,
  description: "User navigated to a nested object via a keyboard shortcut"
}), CreatedNewObject = defineEvent({
  name: "Created New Object in Array List",
  version: 1,
  description: "User created a new object in an array list"
}), CreatePrependedObject = defineEvent({
  name: "Created Prepended Object in Array List",
  version: 1,
  description: "User created a prepended object in an array list"
}), CreateAppendedObject = defineEvent({
  name: "Created Appended Object in Array List",
  version: 1,
  description: "User created an appended object in an array list"
}), RemovedObject = defineEvent({
  name: "Removed Object in Array List",
  version: 1,
  description: "User removed a object from an array list via actions"
}), OpenedPortableTextEditorFullScreen = defineEvent({
  name: "Opened Portable Text Editor Full Screen in Nested Object Dialog",
  version: 1,
  description: "User opened a portable text editor in full screen mode in a object dialog"
}), ClosedPortableTextEditorFullScreen = defineEvent({
  name: "Closed Portable Text Editor Full Screen in Nested Object Dialog",
  version: 1,
  description: "User closed a portable text editor in full screen mode in a object dialog"
});
function useEnhancedObjectDialog() {
  return useContext(EnhancedObjectDialogContext);
}
function createProtoValue(type) {
  if (isObjectSchemaType(type))
    return type.name === "object" ? {} : {
      _type: type.name
    };
  if (isArraySchemaType(type))
    return [];
  if (type.jsonType === "string")
    return "";
  if (type.jsonType === "number")
    return 0;
  if (type.jsonType === "boolean")
    return !1;
}
function whatwgRNG(length = 16) {
  const rnds8 = new Uint8Array(length);
  return crypto.getRandomValues(rnds8), rnds8;
}
const getByteHexTable = /* @__PURE__ */ (() => {
  let table2;
  return () => {
    if (table2)
      return table2;
    table2 = [];
    for (let i = 0; i < 256; ++i)
      table2[i] = (i + 256).toString(16).slice(1);
    return table2;
  };
})();
function randomKey(length) {
  const table2 = getByteHexTable();
  return whatwgRNG(length).reduce((str, n) => str + table2[n], "").slice(0, length);
}
function hasKey$1(item) {
  return item._key !== void 0;
}
function ensureKey(item) {
  return hasKey$1(item) ? item : {
    ...item,
    _key: randomKey(12)
  };
}
function createDescriptionId(id2, description) {
  if (!(!description || !id2))
    return `desc_${id2}`;
}
const getMemberTypeOfItem$2 = (schemaType, item) => {
  const itemTypeName = resolveTypeName$1(item);
  return schemaType.of.find((memberType) => memberType.name === itemTypeName);
};
function assign(values2, path) {
  return Object.entries(values2).map(([key, value]) => set(value, [...path, key]));
}
function resolveInitialArrayValues(items, schemaType, resolver) {
  return from(items).pipe(mergeMap((item) => {
    const itemPathSegment = {
      _key: item._key
    };
    return of(getMemberTypeOfItem$2(schemaType, item)).pipe(mergeMap((memberType) => memberType ? of(memberType) : EMPTY$5), mergeMap((memberType) => !isEmptyItem(item) || !resolver ? EMPTY$5 : concat(of({
      type: "patch",
      patches: [set(!0, [itemPathSegment, "_resolvingInitialValue"])]
    }), defer(() => resolver(memberType, item)).pipe(filter(isNonNullable$2), map((initial2) => ({
      type: "patch",
      patches: assign(initial2, [itemPathSegment])
    })), catchError((error) => of({
      type: "error",
      error,
      item,
      schemaType: memberType
    }))), of({
      type: "patch",
      patches: [unset([itemPathSegment, "_resolvingInitialValue"])]
    }))));
  }));
}
function ArrayOfObjectsItem(props2) {
  const $ = c(178), focusRef = useRef(void 0), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2, {
    t
  } = useTranslation(), {
    onPathBlur,
    onPathFocus,
    onChange,
    onPathOpen,
    onSetPathCollapsed,
    onSetFieldSetCollapsed,
    onFieldGroupSelect
  } = useFormCallbacks(), resolveInitialValue2 = useResolveInitialValueForType(), getFormValue = useGetFormValue(), {
    onCopy
  } = useCopyPaste(), telemetry = useTelemetry(), {
    enabled: enhancedObjectDialogEnabled
  } = useEnhancedObjectDialog();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && focusRef.current?.focus();
  }, $[0] = t0) : t0 = $[0], useDidUpdate(member.item.focused, t0);
  let t1;
  $[1] !== enhancedObjectDialogEnabled || $[2] !== member.item.path || $[3] !== member.key || $[4] !== onChange || $[5] !== telemetry ? (t1 = () => {
    telemetry.log(RemovedObject, {
      path: pathToString$1(member.item.path),
      origin: enhancedObjectDialogEnabled ? "nested-object" : "default"
    }), onChange(PatchEvent.from([unset([{
      _key: member.key
    }])]));
  }, $[1] = enhancedObjectDialogEnabled, $[2] = member.item.path, $[3] = member.key, $[4] = onChange, $[5] = telemetry, $[6] = t1) : t1 = $[6];
  const onRemove = t1;
  let t2;
  $[7] !== onPathOpen || $[8] !== onSetPathCollapsed ? (t2 = (path) => {
    onPathOpen(path), onSetPathCollapsed(path, !1);
  }, $[7] = onPathOpen, $[8] = onSetPathCollapsed, $[9] = t2) : t2 = $[9];
  const handleOpenItem = t2, toast = useToast();
  let t3;
  $[10] !== enhancedObjectDialogEnabled || $[11] !== member.item.path || $[12] !== telemetry ? (t3 = (event) => {
    event.position === "before" ? telemetry.log(CreatePrependedObject, {
      path: pathToString$1(member.item.path),
      origin: enhancedObjectDialogEnabled ? "nested-object" : "default"
    }) : telemetry.log(CreateAppendedObject, {
      path: pathToString$1(member.item.path),
      origin: enhancedObjectDialogEnabled ? "nested-object" : "default"
    });
  }, $[10] = enhancedObjectDialogEnabled, $[11] = member.item.path, $[12] = telemetry, $[13] = t3) : t3 = $[13];
  const telemetryInsertSiblingsTelemetry = t3;
  let t4;
  $[14] !== handleOpenItem || $[15] !== member.item.path || $[16] !== member.key || $[17] !== member.parentSchemaType || $[18] !== onChange || $[19] !== onPathFocus || $[20] !== resolveInitialValue2 || $[21] !== t || $[22] !== telemetryInsertSiblingsTelemetry || $[23] !== toast ? (t4 = (event_0) => {
    if (event_0.items.length === 0)
      throw new Error("Insert event should include at least one item");
    const itemsWithKeys = event_0.items.map(_temp$3u);
    onChange(PatchEvent.from([insert$1(itemsWithKeys, event_0.position, [{
      _key: member.key
    }])]));
    const focusItemKey = itemsWithKeys[0]._key, itemPath = [...member.item.path.slice(0, -1), {
      _key: focusItemKey
    }];
    onPathFocus(itemPath);
    const shouldOpen = event_0.open !== !1;
    event_0.skipInitialValue ? shouldOpen && (handleOpenItem(itemPath), telemetryInsertSiblingsTelemetry(event_0)) : resolveInitialArrayValues(itemsWithKeys, member.parentSchemaType, resolveInitialValue2).pipe(tap((result) => {
      result.type === "patch" ? onChange(PatchEvent.from(result.patches)) : toast.push({
        title: t("inputs.array.error.cannot-resolve-initial-value-title"),
        description: t("inputs.array.error.cannot-resolve-initial-value-description", {
          schemaTypeTitle: result.schemaType.title,
          errorMessage: result.error.message
        }),
        status: "error"
      });
    })).subscribe({
      complete: () => {
        shouldOpen && (handleOpenItem(itemPath), telemetryInsertSiblingsTelemetry(event_0));
      }
    });
  }, $[14] = handleOpenItem, $[15] = member.item.path, $[16] = member.key, $[17] = member.parentSchemaType, $[18] = onChange, $[19] = onPathFocus, $[20] = resolveInitialValue2, $[21] = t, $[22] = telemetryInsertSiblingsTelemetry, $[23] = toast, $[24] = t4) : t4 = $[24];
  const handleInsert = t4;
  let t5;
  $[25] !== getFormValue || $[26] !== member.item.path || $[27] !== onCopy ? (t5 = (_) => {
    const documentValue = getFormValue([]);
    onCopy(member.item.path, documentValue, {
      context: {
        source: "arrayItem"
      },
      patchType: "append"
    });
  }, $[25] = getFormValue, $[26] = member.item.path, $[27] = onCopy, $[28] = t5) : t5 = $[28];
  const handleCopy = t5;
  let t6;
  $[29] !== member.item.path || $[30] !== onPathBlur ? (t6 = () => {
    onPathBlur(member.item.path);
  }, $[29] = member.item.path, $[30] = onPathBlur, $[31] = t6) : t6 = $[31];
  const handleBlur = t6;
  let t7;
  $[32] !== member.item.path || $[33] !== onPathFocus ? (t7 = () => {
    onPathFocus(member.item.path);
  }, $[32] = member.item.path, $[33] = onPathFocus, $[34] = t7) : t7 = $[34];
  const handleFocus = t7;
  let t8;
  $[35] !== member.item.path || $[36] !== onPathFocus ? (t8 = (path_0) => {
    onPathFocus(member.item.path.concat(path_0));
  }, $[35] = member.item.path, $[36] = onPathFocus, $[37] = t8) : t8 = $[37];
  const handleFocusChildPath = t8;
  let t9;
  $[38] !== member.item.schemaType || $[39] !== member.key || $[40] !== onChange ? (t9 = (event_1) => {
    onChange(PatchEvent.from(event_1).prepend(setIfMissing(createProtoValue(member.item.schemaType))).prefixAll({
      _key: member.key
    }));
  }, $[38] = member.item.schemaType, $[39] = member.key, $[40] = onChange, $[41] = t9) : t9 = $[41];
  const handleChange = t9;
  let t10;
  $[42] !== member.item.path || $[43] !== onSetPathCollapsed ? (t10 = () => {
    onSetPathCollapsed(member.item.path, !0);
  }, $[42] = member.item.path, $[43] = onSetPathCollapsed, $[44] = t10) : t10 = $[44];
  const handleCollapse = t10;
  let t11;
  $[45] !== member.item.path || $[46] !== onSetPathCollapsed ? (t11 = () => {
    onSetPathCollapsed(member.item.path, !1);
  }, $[45] = member.item.path, $[46] = onSetPathCollapsed, $[47] = t11) : t11 = $[47];
  const handleExpand = t11;
  let t12;
  $[48] !== member.item.path || $[49] !== onSetPathCollapsed ? (t12 = (fieldName) => {
    onSetPathCollapsed(member.item.path.concat(fieldName), !0);
  }, $[48] = member.item.path, $[49] = onSetPathCollapsed, $[50] = t12) : t12 = $[50];
  const handleCollapseField = t12;
  let t13;
  $[51] !== member.item.path || $[52] !== onSetPathCollapsed ? (t13 = (fieldName_0) => {
    onSetPathCollapsed(member.item.path.concat(fieldName_0), !1);
  }, $[51] = member.item.path, $[52] = onSetPathCollapsed, $[53] = t13) : t13 = $[53];
  const handleExpandField = t13;
  let t14;
  $[54] !== member.item.path || $[55] !== onPathOpen ? (t14 = () => {
    onPathOpen(member.item.path);
  }, $[54] = member.item.path, $[55] = onPathOpen, $[56] = t14) : t14 = $[56];
  const handleCloseField = t14;
  let t15;
  $[57] !== member.item.path || $[58] !== onPathOpen ? (t15 = (fieldName_1) => {
    onPathOpen(member.item.path.concat(fieldName_1));
  }, $[57] = member.item.path, $[58] = onPathOpen, $[59] = t15) : t15 = $[59];
  const handleOpenField = t15;
  let t16;
  $[60] !== member.item.path || $[61] !== onSetFieldSetCollapsed ? (t16 = (fieldsetName) => {
    onSetFieldSetCollapsed(member.item.path.concat(fieldsetName), !1);
  }, $[60] = member.item.path, $[61] = onSetFieldSetCollapsed, $[62] = t16) : t16 = $[62];
  const handleExpandFieldSet = t16;
  let t17;
  $[63] !== member.item.path || $[64] !== onSetFieldSetCollapsed ? (t17 = (fieldsetName_0) => {
    onSetFieldSetCollapsed(member.item.path.concat(fieldsetName_0), !0);
  }, $[63] = member.item.path, $[64] = onSetFieldSetCollapsed, $[65] = t17) : t17 = $[65];
  const handleCollapseFieldSet = t17;
  let t18;
  $[66] !== enhancedObjectDialogEnabled || $[67] !== member.item.path || $[68] !== onPathOpen || $[69] !== telemetry ? (t18 = () => {
    telemetry.log(NavigatedToViaArrayList, {
      path: pathToString$1(member.item.path),
      origin: enhancedObjectDialogEnabled ? "nested-object" : "default"
    }), onPathOpen(member.item.path);
  }, $[66] = enhancedObjectDialogEnabled, $[67] = member.item.path, $[68] = onPathOpen, $[69] = telemetry, $[70] = t18) : t18 = $[70];
  const handleOpen = t18;
  let t19;
  $[71] !== member.item.value ? (t19 = !member.item.value || isEmptyItem(member.item.value), $[71] = member.item.value, $[72] = t19) : t19 = $[72];
  const isEmptyValue2 = t19;
  let t20;
  $[73] !== isEmptyValue2 || $[74] !== member.item.path || $[75] !== onPathFocus || $[76] !== onPathOpen || $[77] !== onRemove ? (t20 = () => {
    isEmptyValue2 && onRemove();
    const parentPath_0 = member.item.path.slice(0, -1);
    onPathOpen(parentPath_0), onPathFocus(parentPath_0);
  }, $[73] = isEmptyValue2, $[74] = member.item.path, $[75] = onPathFocus, $[76] = onPathOpen, $[77] = onRemove, $[78] = t20) : t20 = $[78];
  const handleClose = t20;
  let t21;
  $[79] !== member.item.path || $[80] !== onFieldGroupSelect ? (t21 = (groupName) => {
    onFieldGroupSelect(member.item.path, groupName);
  }, $[79] = member.item.path, $[80] = onFieldGroupSelect, $[81] = t21) : t21 = $[81];
  const handleSelectFieldGroup = t21, t22 = member.item.id;
  let t23;
  $[82] !== member.item.id || $[83] !== member.item.schemaType.description ? (t23 = createDescriptionId(member.item.id, member.item.schemaType.description), $[82] = member.item.id, $[83] = member.item.schemaType.description, $[84] = t23) : t23 = $[84];
  let t24;
  $[85] !== member.item.path ? (t24 = pathToAnchorIdent("input", member.item.path), $[85] = member.item.path, $[86] = t24) : t24 = $[86];
  let t25;
  $[87] !== t24 ? (t25 = {
    anchorName: t24
  }, $[87] = t24, $[88] = t25) : t25 = $[88];
  let t26;
  $[89] !== handleBlur || $[90] !== handleFocus || $[91] !== member.item.id || $[92] !== t23 || $[93] !== t25 ? (t26 = {
    onBlur: handleBlur,
    onFocus: handleFocus,
    id: t22,
    ref: focusRef,
    "aria-describedby": t23,
    style: t25
  }, $[89] = handleBlur, $[90] = handleFocus, $[91] = member.item.id, $[92] = t23, $[93] = t25, $[94] = t26) : t26 = $[94];
  const elementProps = t26, t27 = member.item.displayInlineChanges ?? !1;
  let t28;
  $[95] !== elementProps || $[96] !== handleChange || $[97] !== handleCloseField || $[98] !== handleCollapseField || $[99] !== handleCollapseFieldSet || $[100] !== handleExpandField || $[101] !== handleExpandFieldSet || $[102] !== handleFocusChildPath || $[103] !== handleOpenField || $[104] !== handleSelectFieldGroup || $[105] !== member.item.__unstable_computeDiff || $[106] !== member.item.changed || $[107] !== member.item.compareValue || $[108] !== member.item.focusPath || $[109] !== member.item.focused || $[110] !== member.item.groups || $[111] !== member.item.hasUpstreamVersion || $[112] !== member.item.id || $[113] !== member.item.level || $[114] !== member.item.members || $[115] !== member.item.path || $[116] !== member.item.presence || $[117] !== member.item.readOnly || $[118] !== member.item.schemaType || $[119] !== member.item.validation || $[120] !== member.item.value || $[121] !== renderAnnotation || $[122] !== renderBlock2 || $[123] !== renderField || $[124] !== renderInlineBlock || $[125] !== renderInput || $[126] !== renderItem2 || $[127] !== renderPreview || $[128] !== t27 ? (t28 = {
    changed: member.item.changed,
    __unstable_computeDiff: member.item.__unstable_computeDiff,
    hasUpstreamVersion: member.item.hasUpstreamVersion,
    focusPath: member.item.focusPath,
    focused: member.item.focused,
    groups: member.item.groups,
    id: member.item.id,
    level: member.item.level,
    members: member.item.members,
    onChange: handleChange,
    onFieldClose: handleCloseField,
    onFieldCollapse: handleCollapseField,
    onFieldSetCollapse: handleCollapseFieldSet,
    onFieldExpand: handleExpandField,
    onFieldSetExpand: handleExpandFieldSet,
    onFieldGroupSelect: handleSelectFieldGroup,
    onPathFocus: handleFocusChildPath,
    onFieldOpen: handleOpenField,
    path: member.item.path,
    presence: member.item.presence,
    readOnly: member.item.readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType: member.item.schemaType,
    validation: member.item.validation,
    value: member.item.value,
    compareValue: member.item.compareValue,
    elementProps,
    displayInlineChanges: t27
  }, $[95] = elementProps, $[96] = handleChange, $[97] = handleCloseField, $[98] = handleCollapseField, $[99] = handleCollapseFieldSet, $[100] = handleExpandField, $[101] = handleExpandFieldSet, $[102] = handleFocusChildPath, $[103] = handleOpenField, $[104] = handleSelectFieldGroup, $[105] = member.item.__unstable_computeDiff, $[106] = member.item.changed, $[107] = member.item.compareValue, $[108] = member.item.focusPath, $[109] = member.item.focused, $[110] = member.item.groups, $[111] = member.item.hasUpstreamVersion, $[112] = member.item.id, $[113] = member.item.level, $[114] = member.item.members, $[115] = member.item.path, $[116] = member.item.presence, $[117] = member.item.readOnly, $[118] = member.item.schemaType, $[119] = member.item.validation, $[120] = member.item.value, $[121] = renderAnnotation, $[122] = renderBlock2, $[123] = renderField, $[124] = renderInlineBlock, $[125] = renderInput, $[126] = renderItem2, $[127] = renderPreview, $[128] = t27, $[129] = t28) : t28 = $[129];
  const inputProps = t28;
  let t29;
  $[130] !== member.item.path || $[131] !== member.item.readOnly || $[132] !== renderInput ? (t29 = (...t302) => {
    const renderProps = t302;
    return /* @__PURE__ */ jsx(FormNodeDivergenceDetail, { path: member.item.path, readOnly: member.item.readOnly, children: renderInput(...renderProps) });
  }, $[130] = member.item.path, $[131] = member.item.readOnly, $[132] = renderInput, $[133] = t29) : t29 = $[133];
  let t30;
  $[134] !== inputProps || $[135] !== t29 ? (t30 = /* @__PURE__ */ jsx(RenderInput$5, { ...inputProps, render: t29 }), $[134] = inputProps, $[135] = t29, $[136] = t30) : t30 = $[136];
  let t31;
  $[137] !== handleBlur || $[138] !== handleClose || $[139] !== handleCollapse || $[140] !== handleCopy || $[141] !== handleExpand || $[142] !== handleFocus || $[143] !== handleInsert || $[144] !== handleOpen || $[145] !== inputProps || $[146] !== member.collapsed || $[147] !== member.collapsible || $[148] !== member.index || $[149] !== member.item.__unstable_computeDiff || $[150] !== member.item.changed || $[151] !== member.item.compareValue || $[152] !== member.item.focused || $[153] !== member.item.hasUpstreamVersion || $[154] !== member.item.id || $[155] !== member.item.level || $[156] !== member.item.path || $[157] !== member.item.presence || $[158] !== member.item.readOnly || $[159] !== member.item.schemaType || $[160] !== member.item.validation || $[161] !== member.item.value || $[162] !== member.key || $[163] !== member.open || $[164] !== member.parentSchemaType || $[165] !== onRemove || $[166] !== renderItem2 || $[167] !== t30 ? (t31 = /* @__PURE__ */ jsx(RenderItem$1, { index: member.index, level: member.item.level, value: member.item.value, compareValue: member.item.compareValue, __unstable_computeDiff: member.item.__unstable_computeDiff, hasUpstreamVersion: member.item.hasUpstreamVersion, title: member.item.schemaType.title, description: member.item.schemaType.description, collapsible: member.collapsible, collapsed: member.collapsed, schemaType: member.item.schemaType, parentSchemaType: member.parentSchemaType, onInsert: handleInsert, onCopy: handleCopy, onRemove, presence: member.item.presence, validation: member.item.validation, open: member.open, onOpen: handleOpen, onClose: handleClose, onExpand: handleExpand, onCollapse: handleCollapse, readOnly: member.item.readOnly, focused: member.item.focused, onFocus: handleFocus, onBlur: handleBlur, inputId: member.item.id, path: member.item.path, changed: member.item.changed, inputProps, render: renderItem2, children: t30 }, member.key), $[137] = handleBlur, $[138] = handleClose, $[139] = handleCollapse, $[140] = handleCopy, $[141] = handleExpand, $[142] = handleFocus, $[143] = handleInsert, $[144] = handleOpen, $[145] = inputProps, $[146] = member.collapsed, $[147] = member.collapsible, $[148] = member.index, $[149] = member.item.__unstable_computeDiff, $[150] = member.item.changed, $[151] = member.item.compareValue, $[152] = member.item.focused, $[153] = member.item.hasUpstreamVersion, $[154] = member.item.id, $[155] = member.item.level, $[156] = member.item.path, $[157] = member.item.presence, $[158] = member.item.readOnly, $[159] = member.item.schemaType, $[160] = member.item.validation, $[161] = member.item.value, $[162] = member.key, $[163] = member.open, $[164] = member.parentSchemaType, $[165] = onRemove, $[166] = renderItem2, $[167] = t30, $[168] = t31) : t31 = $[168];
  let t32;
  return $[169] !== handleChange || $[170] !== onFieldGroupSelect || $[171] !== onPathBlur || $[172] !== onPathFocus || $[173] !== onPathOpen || $[174] !== onSetFieldSetCollapsed || $[175] !== onSetPathCollapsed || $[176] !== t31 ? (t32 = /* @__PURE__ */ jsx(FormCallbacksProvider, { onFieldGroupSelect, onChange: handleChange, onPathOpen, onSetFieldSetCollapsed, onSetPathCollapsed, onPathBlur, onPathFocus, children: t31 }), $[169] = handleChange, $[170] = onFieldGroupSelect, $[171] = onPathBlur, $[172] = onPathFocus, $[173] = onPathOpen, $[174] = onSetFieldSetCollapsed, $[175] = onSetPathCollapsed, $[176] = t31, $[177] = t32) : t32 = $[177], t32;
}
function _temp$3u(item) {
  return ensureKey(item);
}
function RenderInput$5({
  render: render2,
  ...props2
}) {
  return render2(props2);
}
function RenderItem$1({
  render: render2,
  ...props2
}) {
  return render2(props2);
}
const PopoverCard$2 = styled(Card).withConfig({
  displayName: "PopoverCard",
  componentId: "sc-w3hc0b-0"
})`max-width:${({
  theme
}) => theme.sanity.container[1]}px;`;
function IncompatibleItemType$2(props2) {
  const $ = c(60);
  let onFocus, rest, value;
  if ($[0] !== props2) {
    const {
      value: t02,
      onFocus: t110,
      vertical,
      ...t25
    } = props2;
    value = t02, onFocus = t110, rest = t25, $[0] = props2, $[1] = onFocus, $[2] = rest, $[3] = value;
  } else
    onFocus = $[1], rest = $[2], value = $[3];
  const [showDetails, setShowDetails] = useState(!1), popoverRef = useRef(null), {
    t
  } = useTranslation();
  let t0, t1;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setShowDetails(!1), t1 = () => [popoverRef.current], $[4] = t0, $[5] = t1) : (t0 = $[4], t1 = $[5]), useClickOutsideEvent(t0, t1);
  let t2;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (e) => {
    (e.key === "Escape" || e.key === "Tab") && setShowDetails(!1);
  }, $[6] = t2) : t2 = $[6];
  const handleKeyDown = t2;
  let t3;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setShowDetails(_temp$3t);
  }, $[7] = t3) : t3 = $[7];
  const handleShowDetails = t3;
  let t4;
  $[8] !== value ? (t4 = resolveTypeName$1(value), $[8] = value, $[9] = t4) : t4 = $[9];
  const typeName = t4;
  let t5;
  $[10] !== typeName ? (t5 = {
    typeName
  }, $[10] = typeName, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.type-is-incompatible-prompt", values: t5 }) }), $[12] = t, $[13] = t5, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== t ? (t7 = t("inputs.array.error.type-is-incompatible-title"), $[15] = t, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t7 }), $[17] = t7, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== typeName ? (t9 = {
    typeName
  }, $[19] = typeName, $[20] = t9) : t9 = $[20];
  let t10;
  $[21] !== t || $[22] !== t9 ? (t10 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.current-schema-not-declare-description", values: t9 }) }), $[21] = t, $[22] = t9, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = /* @__PURE__ */ jsx(BulbOutlineIcon, {}), $[24] = t11) : t11 = $[24];
  let t12;
  $[25] !== t ? (t12 = t("inputs.array.error.can-delete-but-no-edit-description"), $[25] = t, $[26] = t12) : t12 = $[26];
  let t13;
  $[27] !== t12 ? (t13 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t11,
    " ",
    t12
  ] }) }), $[27] = t12, $[28] = t13) : t13 = $[28];
  let t14;
  $[29] !== t ? (t14 = t("inputs.array.error.json-representation-description"), $[29] = t, $[30] = t14) : t14 = $[30];
  let t15;
  $[31] !== t14 ? (t15 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t14 }), $[31] = t14, $[32] = t15) : t15 = $[32];
  let t16;
  $[33] !== value ? (t16 = JSON.stringify(value, null, 2), $[33] = value, $[34] = t16) : t16 = $[34];
  let t17;
  $[35] !== t16 ? (t17 = /* @__PURE__ */ jsx(Card, { padding: 2, overflow: "auto", border: !0, children: /* @__PURE__ */ jsx(Code, { size: 1, as: "pre", language: "json", children: t16 }) }), $[35] = t16, $[36] = t17) : t17 = $[36];
  let t18;
  $[37] !== t15 || $[38] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t15,
    t17
  ] }), $[37] = t15, $[38] = t17, $[39] = t18) : t18 = $[39];
  let t19;
  $[40] !== t10 || $[41] !== t13 || $[42] !== t18 || $[43] !== t6 || $[44] !== t8 ? (t19 = /* @__PURE__ */ jsx(PopoverCard$2, { margin: 1, padding: 3, onKeyDown: handleKeyDown, tabIndex: 0, overflow: "auto", children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t6,
    t8,
    t10,
    t13,
    t18
  ] }) }), $[40] = t10, $[41] = t13, $[42] = t18, $[43] = t6, $[44] = t8, $[45] = t19) : t19 = $[45];
  let t20;
  $[46] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t20 = /* @__PURE__ */ jsx(Box, { marginRight: 3, children: /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(UnknownIcon, {}) }) }), $[46] = t20) : t20 = $[46];
  let t21;
  $[47] !== typeName ? (t21 = {
    typeName
  }, $[47] = typeName, $[48] = t21) : t21 = $[48];
  let t22;
  $[49] !== t || $[50] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t20,
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.type-is-incompatible-prompt", values: t21 }) }) })
  ] }), $[49] = t, $[50] = t21, $[51] = t22) : t22 = $[51];
  let t23;
  $[52] !== onFocus || $[53] !== rest || $[54] !== t22 ? (t23 = /* @__PURE__ */ jsx(Card, { as: "button", type: "button", radius: 2, tone: "inherit", paddingX: 2, paddingY: 3, flex: 1, onFocus, onClick: handleShowDetails, onKeyDown: handleKeyDown, __unstable_focusRing: !0, ...rest, children: t22 }), $[52] = onFocus, $[53] = rest, $[54] = t22, $[55] = t23) : t23 = $[55];
  let t24;
  return $[56] !== showDetails || $[57] !== t19 || $[58] !== t23 ? (t24 = /* @__PURE__ */ jsx(Popover, { open: showDetails, ref: popoverRef, onKeyDown: handleKeyDown, portal: !0, constrainSize: !0, tone: "default", content: t19, children: t23 }), $[56] = showDetails, $[57] = t19, $[58] = t23, $[59] = t24) : t24 = $[59], t24;
}
function _temp$3t(v) {
  return !v;
}
function MemberItemError(props2) {
  const $ = c(7), {
    member
  } = props2, {
    t
  } = useTranslation();
  if (member.error.type === "INVALID_ITEM_TYPE") {
    let t02;
    return $[0] !== member.error.value ? (t02 = /* @__PURE__ */ jsx(IncompatibleItemType$2, { value: member.error.value }), $[0] = member.error.value, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  $[2] !== member.error.type || $[3] !== t ? (t0 = t("inputs.array.error.unexpected-error", {
    error: member.error.type
  }), $[2] = member.error.type, $[3] = t, $[4] = t0) : t0 = $[4];
  let t1;
  return $[5] !== t0 ? (t1 = /* @__PURE__ */ jsx("div", { children: t0 }), $[5] = t0, $[6] = t1) : t1 = $[6], t1;
}
function ArrayOfObjectsInputMember(props2) {
  const $ = c(11), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2;
  if (member.kind === "item") {
    let t0;
    return $[0] !== member || $[1] !== renderAnnotation || $[2] !== renderBlock2 || $[3] !== renderField || $[4] !== renderInlineBlock || $[5] !== renderInput || $[6] !== renderItem2 || $[7] !== renderPreview ? (t0 = /* @__PURE__ */ jsx(ArrayOfObjectsItem, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }, member.key), $[0] = member, $[1] = renderAnnotation, $[2] = renderBlock2, $[3] = renderField, $[4] = renderInlineBlock, $[5] = renderInput, $[6] = renderItem2, $[7] = renderPreview, $[8] = t0) : t0 = $[8], t0;
  }
  if (member.kind === "error") {
    let t0;
    return $[9] !== member ? (t0 = /* @__PURE__ */ jsx(MemberItemError, { member }, member.key), $[9] = member, $[10] = t0) : t0 = $[10], t0;
  }
  return console.warn(new Error(`Unhandled member kind ${member.kind}`)), null;
}
function ArrayOfObjectsInputMembers(props2) {
  const $ = c(10);
  let members, rest;
  $[0] !== props2 ? ({
    members,
    ...rest
  } = props2, $[0] = props2, $[1] = members, $[2] = rest) : (members = $[1], rest = $[2]);
  let t0;
  if ($[3] !== members || $[4] !== rest) {
    let t12;
    $[6] !== rest ? (t12 = (member) => /* @__PURE__ */ jsx(ArrayOfObjectsInputMember, { member, ...rest }, member.key), $[6] = rest, $[7] = t12) : t12 = $[7], t0 = members.map(t12), $[3] = members, $[4] = rest, $[5] = t0;
  } else
    t0 = $[5];
  let t1;
  return $[8] !== t0 ? (t1 = /* @__PURE__ */ jsx(Fragment$1, { children: t0 }), $[8] = t0, $[9] = t1) : t1 = $[9], t1;
}
function getEmptyValue(type) {
  switch (type.jsonType) {
    case "string":
      return "";
    case "number":
      return -0;
    case "boolean":
      return !1;
    default:
      throw new Error(`Unable to create value from type "${type.jsonType}"`);
  }
}
function resolveNativeNumberInputValue(schemaType, value, localValue) {
  return isNumberSchemaType(schemaType) && typeof localValue == "string" && Number(localValue) === value ? localValue : String(value ?? "");
}
function ArrayOfPrimitivesItem(props2) {
  const $ = c(93), focusRef = useRef(void 0), {
    member,
    renderItem: renderItem2,
    renderInput
  } = props2, [localValue, setLocalValue] = useState(), {
    onPathBlur,
    onPathFocus,
    onChange
  } = useFormCallbacks(), getFormValue = useGetFormValue(), {
    onCopy
  } = useCopyPaste();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && focusRef.current?.focus();
  }, $[0] = t0) : t0 = $[0], useDidUpdate(member.item.focused, t0);
  let t1;
  $[1] !== member.item.path || $[2] !== onPathBlur ? (t1 = (event) => {
    onPathBlur(member.item.path);
  }, $[1] = member.item.path, $[2] = onPathBlur, $[3] = t1) : t1 = $[3];
  const handleBlur = t1;
  let t2;
  $[4] !== member.item.path || $[5] !== onPathFocus ? (t2 = (event_0) => {
    onPathFocus(member.item.path);
  }, $[4] = member.item.path, $[5] = onPathFocus, $[6] = t2) : t2 = $[6];
  const handleFocus = t2;
  let t3;
  $[7] !== member.index || $[8] !== onChange ? (t3 = (event_1) => {
    onChange(PatchEvent.from(event_1).prefixAll(member.index));
  }, $[7] = member.index, $[8] = onChange, $[9] = t3) : t3 = $[9];
  const handleChange = t3;
  let t4;
  $[10] !== handleChange || $[11] !== member.item.schemaType ? (t4 = (event_2) => {
    let inputValue = event_2.currentTarget.value;
    if (isNumberSchemaType(member.item.schemaType)) {
      if (inputValue = event_2.currentTarget.valueAsNumber, inputValue > Number.MAX_SAFE_INTEGER || inputValue < Number.MIN_SAFE_INTEGER)
        return;
    } else
      isBooleanSchemaType(member.item.schemaType) && (inputValue = event_2.currentTarget.checked);
    const hasEmptyValue = inputValue === "" || typeof inputValue == "number" && isNaN(inputValue);
    isNumberSchemaType(member.item.schemaType) && setLocalValue(hasEmptyValue ? void 0 : event_2.currentTarget.value), handleChange(set(hasEmptyValue ? getEmptyValue(member.item.schemaType) : inputValue));
  }, $[10] = handleChange, $[11] = member.item.schemaType, $[12] = t4) : t4 = $[12];
  const handleNativeChange = t4, t5 = member.item.id;
  let t6;
  $[13] !== localValue || $[14] !== member.item.schemaType || $[15] !== member.item.value ? (t6 = resolveNativeInputValue(member.item.schemaType, member.item.value, localValue), $[13] = localValue, $[14] = member.item.schemaType, $[15] = member.item.value, $[16] = t6) : t6 = $[16];
  const t7 = !!member.item.readOnly, t8 = member.item.schemaType.placeholder;
  let t9;
  $[17] !== member.item.id || $[18] !== member.item.schemaType.description ? (t9 = createDescriptionId(member.item.id, member.item.schemaType.description), $[17] = member.item.id, $[18] = member.item.schemaType.description, $[19] = t9) : t9 = $[19];
  let t10;
  $[20] !== member.item.path ? (t10 = pathToAnchorIdent("input", member.item.path), $[20] = member.item.path, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== t10 ? (t11 = {
    anchorName: t10
  }, $[22] = t10, $[23] = t11) : t11 = $[23];
  let t12;
  $[24] !== handleBlur || $[25] !== handleFocus || $[26] !== handleNativeChange || $[27] !== member.item.id || $[28] !== member.item.schemaType.placeholder || $[29] !== t11 || $[30] !== t6 || $[31] !== t7 || $[32] !== t9 ? (t12 = {
    onBlur: handleBlur,
    onFocus: handleFocus,
    id: t5,
    ref: focusRef,
    onChange: handleNativeChange,
    value: t6,
    readOnly: t7,
    placeholder: t8,
    "aria-describedby": t9,
    style: t11
  }, $[24] = handleBlur, $[25] = handleFocus, $[26] = handleNativeChange, $[27] = member.item.id, $[28] = member.item.schemaType.placeholder, $[29] = t11, $[30] = t6, $[31] = t7, $[32] = t9, $[33] = t12) : t12 = $[33];
  const elementProps = t12, t13 = member.item.value, t14 = member.item.schemaType, t15 = member.item.displayInlineChanges ?? !1;
  let t16;
  $[34] !== elementProps || $[35] !== handleChange || $[36] !== member.item.__unstable_computeDiff || $[37] !== member.item.changed || $[38] !== member.item.compareValue || $[39] !== member.item.focused || $[40] !== member.item.hasUpstreamVersion || $[41] !== member.item.id || $[42] !== member.item.level || $[43] !== member.item.path || $[44] !== member.item.presence || $[45] !== member.item.readOnly || $[46] !== member.item.validation || $[47] !== t13 || $[48] !== t14 || $[49] !== t15 ? (t16 = {
    changed: member.item.changed,
    level: member.item.level,
    value: t13,
    compareValue: member.item.compareValue,
    __unstable_computeDiff: member.item.__unstable_computeDiff,
    hasUpstreamVersion: member.item.hasUpstreamVersion,
    readOnly: member.item.readOnly,
    schemaType: t14,
    id: member.item.id,
    path: member.item.path,
    focused: member.item.focused,
    onChange: handleChange,
    validation: member.item.validation,
    presence: member.item.presence,
    elementProps,
    displayInlineChanges: t15
  }, $[34] = elementProps, $[35] = handleChange, $[36] = member.item.__unstable_computeDiff, $[37] = member.item.changed, $[38] = member.item.compareValue, $[39] = member.item.focused, $[40] = member.item.hasUpstreamVersion, $[41] = member.item.id, $[42] = member.item.level, $[43] = member.item.path, $[44] = member.item.presence, $[45] = member.item.readOnly, $[46] = member.item.validation, $[47] = t13, $[48] = t14, $[49] = t15, $[50] = t16) : t16 = $[50];
  const inputProps = t16;
  let t17;
  $[51] !== member.index || $[52] !== onChange ? (t17 = () => {
    onChange(PatchEvent.from([unset([member.index])]));
  }, $[51] = member.index, $[52] = onChange, $[53] = t17) : t17 = $[53];
  const onRemove = t17;
  let t18;
  $[54] !== member.index || $[55] !== onChange ? (t18 = (event_3) => {
    onChange(PatchEvent.from([insert$1(event_3.items, event_3.position, [member.index])]));
  }, $[54] = member.index, $[55] = onChange, $[56] = t18) : t18 = $[56];
  const onInsert = t18;
  let t19;
  $[57] !== getFormValue || $[58] !== member.item.path || $[59] !== onCopy ? (t19 = (_) => {
    const documentValue = getFormValue([]);
    onCopy(member.item.path, documentValue, {
      context: {
        source: "arrayItem"
      },
      patchType: "append"
    });
  }, $[57] = getFormValue, $[58] = member.item.path, $[59] = onCopy, $[60] = t19) : t19 = $[60];
  const handleCopy = t19, t20 = member.item.value, t21 = member.item.schemaType;
  let t22;
  $[61] !== inputProps || $[62] !== renderInput ? (t22 = /* @__PURE__ */ jsx(RenderInput$4, { ...inputProps, render: renderInput }), $[61] = inputProps, $[62] = renderInput, $[63] = t22) : t22 = $[63];
  let t23;
  $[64] !== member.item.path || $[65] !== member.item.readOnly || $[66] !== t22 ? (t23 = /* @__PURE__ */ jsx(FormNodeDivergenceDetail, { path: member.item.path, readOnly: member.item.readOnly, children: t22 }), $[64] = member.item.path, $[65] = member.item.readOnly, $[66] = t22, $[67] = t23) : t23 = $[67];
  let t24;
  return $[68] !== handleBlur || $[69] !== handleCopy || $[70] !== handleFocus || $[71] !== member.index || $[72] !== member.item.__unstable_computeDiff || $[73] !== member.item.changed || $[74] !== member.item.focused || $[75] !== member.item.hasUpstreamVersion || $[76] !== member.item.id || $[77] !== member.item.level || $[78] !== member.item.path || $[79] !== member.item.presence || $[80] !== member.item.readOnly || $[81] !== member.item.schemaType.description || $[82] !== member.item.schemaType.title || $[83] !== member.item.validation || $[84] !== member.key || $[85] !== member.parentSchemaType || $[86] !== onInsert || $[87] !== onRemove || $[88] !== renderItem2 || $[89] !== t20 || $[90] !== t21 || $[91] !== t23 ? (t24 = /* @__PURE__ */ jsx(RenderItem, { index: member.index, level: member.item.level, value: t20, changed: member.item.changed, __unstable_computeDiff: member.item.__unstable_computeDiff, hasUpstreamVersion: member.item.hasUpstreamVersion, title: member.item.schemaType.title, description: member.item.schemaType.description, schemaType: t21, parentSchemaType: member.parentSchemaType, onInsert, onCopy: handleCopy, onRemove, presence: member.item.presence, validation: member.item.validation, readOnly: member.item.readOnly, focused: member.item.focused, onFocus: handleFocus, onBlur: handleBlur, inputId: member.item.id, path: member.item.path, render: renderItem2, children: t23 }, member.key), $[68] = handleBlur, $[69] = handleCopy, $[70] = handleFocus, $[71] = member.index, $[72] = member.item.__unstable_computeDiff, $[73] = member.item.changed, $[74] = member.item.focused, $[75] = member.item.hasUpstreamVersion, $[76] = member.item.id, $[77] = member.item.level, $[78] = member.item.path, $[79] = member.item.presence, $[80] = member.item.readOnly, $[81] = member.item.schemaType.description, $[82] = member.item.schemaType.title, $[83] = member.item.validation, $[84] = member.key, $[85] = member.parentSchemaType, $[86] = onInsert, $[87] = onRemove, $[88] = renderItem2, $[89] = t20, $[90] = t21, $[91] = t23, $[92] = t24) : t24 = $[92], t24;
}
function RenderInput$4({
  render: render2,
  ...props2
}) {
  return render2(props2);
}
function RenderItem({
  render: render2,
  ...props2
}) {
  return render2(props2);
}
function resolveNativeInputValue(schemaType, value, localValue) {
  return Object.is(value, -0) ? "" : resolveNativeNumberInputValue(schemaType, value, localValue);
}
function createProtoArrayValue(type) {
  if (!isObjectSchemaType(type))
    throw new Error(`Invalid item type: "${type.type}". Default array input can only contain objects (for now)`);
  return {
    ...createProtoValue(type),
    _key: randomKey$1(12)
  };
}
function isVideoSchemaType(type) {
  return isRecord$4(type) && (type.name === "sanity.video" || isVideoSchemaType(type.type));
}
function urlToFile(url, filename) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const string = reader.result?.toString(), base64Index = string?.indexOf(";base64");
        if (!string || base64Index === -1) {
          reject(new Error("Could not convert URL to file"));
          return;
        }
        const ext = string.slice(11, base64Index);
        if (!ext && !filename) {
          reject(new Error("Could not find mime type for image"));
          return;
        }
        resolve(dataURLtoFile(reader.result, filename || `${uuid()}.${ext}`));
      }, reader.readAsDataURL(xhr.response);
    }, xhr.onerror = (error) => {
      reject(error);
    }, xhr.open("GET", url), xhr.responseType = "blob", xhr.send();
  });
}
function base64ToFile(base64Data, filename) {
  return new Promise((resolve, reject) => {
    const string = base64Data.toString(), base64Index = string.indexOf(";base64");
    if (!string || base64Index === -1) {
      reject(new Error("Could not convert base64 to file"));
      return;
    }
    const ext = string.slice(11, base64Index);
    if (!ext && !filename) {
      reject(new Error("Could not find mime type for image"));
      return;
    }
    resolve(dataURLtoFile(base64Data, filename || `${uuid()}.${ext}`));
  });
}
function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(","), mime = arr[0].match(/:(.*?);/)?.[1], bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  for (; n--; )
    u8arr[n] = bstr.charCodeAt(n);
  return new File([u8arr], filename, {
    type: mime
  });
}
function handleSelectAssetFromSource({
  assetsFromSource,
  onChange,
  type,
  resolveUploader: resolveUploader2,
  uploadWith
}) {
  if (!assetsFromSource)
    throw new Error("No asset given");
  if (!Array.isArray(assetsFromSource) || assetsFromSource.length === 0)
    throw new Error("Returned value must be an array with at least one item (asset)");
  const firstAsset = assetsFromSource[0], assetProps = firstAsset.assetDocumentProps, mediaLibraryProps = firstAsset.mediaLibraryProps, originalFilename = assetProps?.originalFilename, label = assetProps?.label, title = assetProps?.title, description = assetProps?.description, creditLine = assetProps?.creditLine, source = assetProps?.source, assetOptions = pickBy({
    label,
    title,
    description,
    creditLine,
    source
  }, (value) => value != null && value !== ""), assetPatches = type.name === "image" ? [unset(["hotspot"]), unset(["crop"]), unset(["media"])] : [unset(["media"])];
  if (mediaLibraryProps) {
    const assetContainerRef = {
      _type: "globalDocumentReference",
      _ref: `media-library:${mediaLibraryProps.mediaLibraryId}:${mediaLibraryProps.assetId}`,
      _weak: !0
    };
    if (assetPatches.push(set(assetContainerRef, ["media"])), isVideoSchemaType(type)) {
      const assetInstanceRef = {
        _type: "globalDocumentReference",
        _ref: `media-library:${mediaLibraryProps.mediaLibraryId}:${mediaLibraryProps.assetInstanceId}`,
        _weak: !0
      };
      assetPatches.push(set(assetInstanceRef, ["asset"])), onChange([setIfMissing({
        _type: type.name
      }), ...assetPatches]);
      return;
    }
  }
  switch (firstAsset.kind) {
    case "assetDocumentId":
      onChange([setIfMissing({
        _type: type.name
      }), ...assetPatches, set({
        _type: "reference",
        _ref: firstAsset.value
      }, ["asset"])]);
      break;
    case "file": {
      const uploader = resolveUploader2(type, firstAsset.value);
      uploader && uploadWith && uploadWith(uploader, firstAsset.value, assetOptions);
      break;
    }
    case "base64":
      base64ToFile(firstAsset.value, originalFilename).then((file) => {
        const uploader = resolveUploader2(type, file);
        uploader && uploadWith && uploadWith(uploader, file, assetOptions);
      });
      break;
    case "url":
      urlToFile(firstAsset.value, originalFilename).then((file) => {
        const uploader = resolveUploader2(type, file);
        uploader && uploadWith && uploadWith(uploader, file, assetOptions);
      });
      break;
    default:
      throw new Error("Invalid value returned from asset source plugin");
  }
}
const BEFORE = "before", AFTER = "after";
function arrayInsert(array, position, index, ...args) {
  if (position !== BEFORE && position !== AFTER)
    throw new Error(`Invalid position "${position}", must be either ${BEFORE} or ${AFTER}`);
  const items = flatten(...args);
  if (array.length === 0)
    return items;
  const len = array.length, idx = Math.abs((len + index) % len) % len, normalizedIdx = position === "after" ? idx + 1 : idx, copy = array.slice();
  return copy.splice(normalizedIdx, 0, ...flatten(items)), copy;
}
function flatten(...values2) {
  return values2.reduce((prev, item) => prev.concat(item), []);
}
const hasOwn = (obj, property) => Object.prototype.hasOwnProperty.call(obj, property);
function move$1(arr, from2, to) {
  const nextValue = arr.slice(), val = nextValue[from2];
  return nextValue.splice(from2, 1), nextValue.splice(to, 0, val), nextValue;
}
function findTargetIndex(array, pathSegment) {
  if (typeof pathSegment == "number")
    return pathSegment;
  const index = findIndex$1(array, pathSegment);
  return index === -1 ? !1 : index;
}
function _arrayApply(value, patch2) {
  const nextValue = value.slice();
  if (patch2.path.length === 0) {
    if (patch2.type === "setIfMissing") {
      if (!Array.isArray(patch2.value))
        throw new Error("Cannot set value of an array to a non-array");
      return value === void 0 ? patch2.value : value;
    } else if (patch2.type === "set") {
      if (!Array.isArray(patch2.value))
        throw new Error("Cannot set value of an array to a non-array");
      return patch2.value;
    } else {
      if (patch2.type === "unset")
        return;
      if (patch2.type === "move") {
        if (!patch2.value || !hasOwn(patch2.value, "from") || !hasOwn(patch2.value, "to"))
          throw new Error(`Invalid value of 'move' patch. Expected a value with "from" and "to" indexes, instead got: ${JSON.stringify(patch2.value)}`);
        return move$1(nextValue, patch2.value.from, patch2.value.to);
      }
    }
    throw new Error(`Invalid array operation: ${patch2.type}`);
  }
  const [head, ...tail] = patch2.path, index = findTargetIndex(value, head);
  if (index === !1)
    return nextValue;
  if (tail.length === 0) {
    if (patch2.type === "insert") {
      const {
        position,
        items
      } = patch2;
      return arrayInsert(value, position, index, items);
    } else if (patch2.type === "unset") {
      if (typeof index != "number")
        throw new Error(`Expected array index to be a number, instead got "${index}"`);
      return nextValue.splice(index, 1), nextValue;
    }
  }
  return nextValue[index] = applyPatch(nextValue[index], {
    ...patch2,
    path: tail
  }), nextValue;
}
function _objectApply(value, patch2) {
  const nextValue = clone(value);
  if (patch2.path.length === 0) {
    if (patch2.type === "set") {
      if (!isObject(patch2.value))
        throw new Error("Cannot set value of an object to a non-object");
      return patch2.value;
    } else {
      if (patch2.type === "unset")
        return;
      if (patch2.type === "setIfMissing")
        return value === void 0 ? patch2.value : value;
    }
    throw new Error(`Invalid object operation: ${patch2.type}`);
  }
  const [head, ...tail] = patch2.path;
  if (typeof head != "string")
    throw new Error(`Expected field name to be a string, instad got: ${head}`);
  return tail.length === 0 && patch2.type === "unset" ? omit(nextValue, head) : (nextValue[head] = applyPatch(nextValue[head], {
    ...patch2,
    path: tail
  }), nextValue);
}
const OPERATIONS$1 = {
  replace(currentValue, nextValue) {
    return nextValue;
  },
  set(currentValue, nextValue) {
    return nextValue;
  },
  setIfMissing(currentValue, nextValue) {
    return currentValue === void 0 ? nextValue : currentValue;
  },
  unset(currentValue, nextValue) {
  },
  inc(currentValue, nextValue) {
    return currentValue + nextValue;
  },
  dec(currentValue, nextValue) {
    return currentValue - nextValue;
  }
}, SUPPORTED_PATCH_TYPES$1 = Object.keys(OPERATIONS$1);
function _primitiveApply(value, patch2) {
  if (!SUPPORTED_PATCH_TYPES$1.includes(patch2.type))
    throw new Error(`Received patch of unsupported type "${patch2.type}" for primitives. This is most likely a bug.`);
  if (patch2.path.length > 0)
    throw new Error(`Cannot apply deep operations on primitive values. Received patch with type "${patch2.type}" and path "${patch2.path.map((path) => JSON.stringify(path)).join(".")} that targeted the value "${JSON.stringify(value)}"`);
  return OPERATIONS$1[patch2.type](value, patch2.value);
}
const OPERATIONS = {
  replace(currentValue, nextValue) {
    return nextValue;
  },
  set(currentValue, nextValue) {
    return nextValue;
  },
  setIfMissing(currentValue, nextValue) {
    return currentValue === void 0 ? nextValue : currentValue;
  },
  unset(currentValue, nextValue) {
  },
  diffMatchPatch(currentValue, dmpPatch) {
    const [result] = applyPatches(parsePatch(dmpPatch), currentValue, {
      allowExceedingIndices: !0
    });
    return result;
  }
}, SUPPORTED_PATCH_TYPES = Object.keys(OPERATIONS);
function _stringApply(value, patch2) {
  if (!SUPPORTED_PATCH_TYPES.includes(patch2.type))
    throw new Error(`Received patch of unsupported type: "${JSON.stringify(patch2.type)}" for string. This is most likely a bug.`);
  if (patch2.path.length > 0)
    throw new Error(`Cannot apply deep operations on string values. Received patch with type "${patch2.type}" and path "${patch2.path.join(".")} that targeted the value "${JSON.stringify(value)}"`);
  return OPERATIONS[patch2.type](value, patch2.value);
}
function applyAll(value, patches) {
  return patches.reduce(applyPatch, value);
}
function _applyPatch(value, patch2) {
  return Array.isArray(value) ? _arrayApply(value, patch2) : isString$1(value) ? _stringApply(value, patch2) : isObject(value) ? _objectApply(value, patch2) : _primitiveApply(value, patch2);
}
function applyPatch(value, patch2) {
  return _applyPatch(value, patch2);
}
function DocumentFieldActionsProvider(props2) {
  const $ = c(5), t0 = props2.actions || EMPTY_ARRAY$y;
  let t1;
  $[0] !== t0 ? (t1 = {
    actions: t0
  }, $[0] = t0, $[1] = t1) : t1 = $[1];
  const value = t1;
  let t2;
  return $[2] !== props2.children || $[3] !== value ? (t2 = /* @__PURE__ */ jsx(DocumentFieldActionsContext.Provider, { value, children: props2.children }), $[2] = props2.children, $[3] = value, $[4] = t2) : t2 = $[4], t2;
}
function useDocumentFieldActions() {
  const context = useContext(DocumentFieldActionsContext);
  if (!context)
    throw new Error("useDocumentFieldActions must be used within a DocumentFieldActionsProvider");
  return context.actions;
}
const UPLOAD_STATUS_KEY = "_upload";
function accepts(file, acceptedFiles) {
  if (!file || !acceptedFiles)
    return !0;
  const acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(","), fileName = file.name || "", mimeType = (file.type || "").toLowerCase(), baseMimeType = mimeType.replace(/\/.*$/, "");
  return acceptedFilesArray.some((type) => {
    const validType = type.trim().toLowerCase();
    return validType.charAt(0) === "." ? fileName ? fileName.toLowerCase().endsWith(validType) : !0 : validType.endsWith("/*") ? baseMimeType === validType.replace(/\/.*$/, "") : mimeType === validType;
  });
}
const DEFAULT_CONCURRENCY = 4;
function remove(array, item) {
  const index = array.indexOf(item);
  return index > -1 && array.splice(index, 1), array;
}
function withMaxConcurrency(func, concurrency = DEFAULT_CONCURRENCY) {
  const throttler = createThrottler(concurrency);
  return (...args) => from(throttler(func(...args)));
}
function createThrottler(concurrency = DEFAULT_CONCURRENCY) {
  const currentSubscriptions = [], pendingObservables = [], ready$ = new Subject();
  return request;
  function request(observable) {
    return new Observable((observer) => {
      if (currentSubscriptions.length >= concurrency)
        return scheduleAndWait(observable).pipe(mergeMap(request)).subscribe(observer);
      const subscription = observable.subscribe(observer);
      return currentSubscriptions.push(subscription), () => {
        remove(currentSubscriptions, subscription), remove(pendingObservables, observable), subscription.unsubscribe(), check();
      };
    });
  }
  function scheduleAndWait(observable) {
    return pendingObservables.push(observable), ready$.asObservable().pipe(first((obs) => obs === observable));
  }
  function check() {
    for (; pendingObservables.length > 0 && currentSubscriptions.length < concurrency; )
      ready$.next(pendingObservables.shift());
  }
}
const MAX_CONCURRENT_UPLOADS = 4;
function uploadSanityAsset(client, assetType, file, options = {}) {
  const extract = options.metadata, preserveFilename = options.storeOriginalFilename, {
    label,
    title,
    description,
    creditLine,
    source
  } = options;
  return hashFile(file).pipe(catchError(() => (
    // ignore if hashing fails for some reason
    of(null)
  )), mergeMap((hash2) => (
    // note: the sanity api will still dedupe unique files, but this saves us from uploading the asset file entirely
    hash2 ? fetchExisting(client, `sanity.${assetType}Asset`, hash2) : of(null)
  )), mergeMap((existing) => existing ? of({
    // complete with the existing asset document
    type: "complete",
    id: existing._id,
    asset: existing
  }) : client.observable.assets.upload(assetType, file, {
    tag: "asset.upload",
    extract,
    preserveFilename,
    label,
    title,
    description,
    creditLine,
    source
  }).pipe(map((event) => event.type === "response" ? {
    // rewrite to a 'complete' event
    type: "complete",
    id: event.body.document._id,
    asset: event.body.document
  } : event))));
}
const uploadAsset = withMaxConcurrency(uploadSanityAsset, MAX_CONCURRENT_UPLOADS), uploadImageAsset = (client, file, options) => uploadAsset(client, "image", file, options), uploadFileAsset = (client, file, options) => uploadAsset(client, "file", file, options);
function parseMediaLibraryRef(ref) {
  if (!ref.startsWith("media-library:"))
    return null;
  const parts = ref.split(":");
  return parts.length !== 3 || parts[1] === "" || parts[2] === "" ? null : {
    mediaLibraryId: parts[1],
    assetInstanceId: parts[2]
  };
}
function mediaLibraryRefToMinimalAsset(ref, assetInstanceId) {
  return {
    _id: ref,
    _type: "sanity.videoAsset",
    _rev: "",
    _createdAt: "",
    _updatedAt: "",
    url: "",
    path: "",
    assetId: ref,
    extension: "",
    mimeType: "video/*",
    sha1hash: "",
    size: 0,
    metadata: {
      _type: "sanity.videoMetadata"
    },
    source: {
      id: assetInstanceId,
      name: sourceName$1
    }
  };
}
function mapMediaLibraryDocToAsset(doc, ref, assetInstanceId) {
  const base = mediaLibraryRefToMinimalAsset(ref, assetInstanceId);
  return doc ? {
    ...base,
    _id: doc._id ?? ref,
    _rev: doc._rev ?? base._rev,
    _createdAt: doc._createdAt ?? base._createdAt,
    _updatedAt: doc._updatedAt ?? base._updatedAt,
    url: doc.url ?? base.url,
    path: doc.path ?? base.path,
    assetId: doc._id ?? ref,
    extension: doc.extension ?? base.extension,
    mimeType: doc.mimeType ?? base.mimeType,
    sha1hash: doc.sha1hash ?? base.sha1hash,
    size: doc.size ?? base.size,
    originalFilename: doc.originalFilename,
    title: doc.title,
    ...typeof doc.description == "string" && {
      description: doc.description
    },
    metadata: doc.metadata && typeof doc.metadata == "object" ? {
      _type: "sanity.videoMetadata",
      ...doc.metadata
    } : base.metadata,
    source: doc.source ? {
      id: doc.source.id ?? assetInstanceId,
      name: sourceName$1,
      url: doc.source.url
    } : base.source
  } : base;
}
function observeAssetDoc(documentPreviewStore, id2) {
  return documentPreviewStore.observePaths({
    _type: "reference",
    _ref: id2
  }, ["originalFilename", "url", "metadata", "label", "title", "description", "creditLine", "source", "size"]);
}
function observeImageAsset(documentPreviewStore, id2) {
  return observeAssetDoc(documentPreviewStore, id2);
}
function observeVideoAsset(documentPreviewStore, id2, client) {
  const parsed = parseMediaLibraryRef(id2);
  if (!parsed)
    return observeAssetDoc(documentPreviewStore, id2);
  const {
    mediaLibraryId,
    assetInstanceId
  } = parsed, minimalAsset = mediaLibraryRefToMinimalAsset(id2, assetInstanceId);
  if (!client)
    return of(minimalAsset);
  const resourceConfig = {
    resource: {
      type: "media-library",
      id: mediaLibraryId
    }
  }, mlClient = client.withConfig({
    ...resourceConfig,
    apiVersion: DEFAULT_API_VERSION
  });
  return from(mlClient.fetch("*[_id == $id][0]", {
    id: assetInstanceId
  }, {
    tag: "media-library.observe-video-asset"
  })).pipe(map((doc) => mapMediaLibraryDocToAsset(doc, id2, assetInstanceId)), catchError(() => of(minimalAsset)), startWith(minimalAsset));
}
function observeFileAsset(documentPreviewStore, id2) {
  return observeAssetDoc(documentPreviewStore, id2);
}
function fetchExisting(client, type, hash2) {
  return client.observable.fetch("*[_type == $documentType && sha1hash == $hash][0]", {
    documentType: type,
    hash: hash2
  }, {
    tag: "asset.find-duplicate"
  });
}
function readFile(file) {
  return new Observable((subscriber) => {
    const reader = new FileReader();
    return reader.onload = () => {
      subscriber.next(reader.result), subscriber.complete();
    }, reader.onerror = (err) => {
      subscriber.error(err);
    }, reader.readAsArrayBuffer(file), () => {
      reader.abort();
    };
  });
}
function hashFile(file) {
  return !window.crypto || !window.crypto.subtle || !window.FileReader ? of(null) : readFile(file).pipe(mergeMap((arrayBuffer) => crypto.subtle.digest("SHA-1", arrayBuffer)), map(hexFromBuffer));
}
function hexFromBuffer(buffer) {
  return Array.prototype.map.call(new Uint8Array(buffer), (x) => `00${x.toString(16)}`.slice(-2)).join("");
}
const UNSET_UPLOAD_PATCH = unset([UPLOAD_STATUS_KEY]);
function createUploadEvent(patches = []) {
  return {
    type: "uploadProgress",
    patches
  };
}
const CLEANUP_EVENT = createUploadEvent([UNSET_UPLOAD_PATCH]);
function createInitialUploadEvent(file) {
  return createUploadEvent(createInitialUploadPatches(file));
}
function createInitialUploadPatches(file) {
  const now = (/* @__PURE__ */ new Date()).toISOString(), value = {
    progress: 2,
    createdAt: now,
    updatedAt: now,
    file: {
      name: file.name,
      type: file.type
    }
  };
  return [set(value, [UPLOAD_STATUS_KEY])];
}
function uploadFile(client, file, options) {
  const upload$ = uploadFileAsset(client, file, options).pipe(map((event) => event.type === "complete" ? createUploadEvent([set({
    _type: "reference",
    _ref: event.asset._id
  }, ["asset"]), set(100, [UPLOAD_STATUS_KEY, "progress"]), set((/* @__PURE__ */ new Date()).toISOString(), [UPLOAD_STATUS_KEY, "updated"])]) : createUploadEvent([set(event.percent, [UPLOAD_STATUS_KEY, "progress"]), set((/* @__PURE__ */ new Date()).toISOString(), [UPLOAD_STATUS_KEY, "updated"])])));
  return concat(of(createInitialUploadEvent(file)), upload$, of(CLEANUP_EVENT));
}
function rotated(n) {
  return [5, 6, 7, 8].indexOf(n) > -1;
}
function rotate$1(ctx, options) {
  const x = options.x, y = options.y, radians = (options.degrees || 0) * (Math.PI / 180);
  ctx?.translate(x, y), ctx?.rotate(radians), ctx?.translate(-x, -y);
}
function flip(canvas, x, y) {
  const ctx = canvas.getContext("2d");
  ctx?.translate(x ? canvas.width : 0, y ? canvas.height : 0), ctx?.scale(x ? -1 : 1, y ? -1 : 1);
}
const ORIENTATION_OPS = [{
  op: "none",
  degrees: 0
}, {
  op: "flip-x",
  degrees: 0
}, {
  op: "none",
  degrees: 180
}, {
  op: "flip-y",
  degrees: 0
}, {
  op: "flip-x",
  degrees: 90
}, {
  op: "none",
  degrees: 90
}, {
  op: "flip-x",
  degrees: -90
}, {
  op: "none",
  degrees: -90
}], ORIENTATIONS = ["top-left", "top-right", "bottom-right", "bottom-left", "left-top", "right-top", "right-bottom", "left-bottom"], DEFAULT_ORIENTATION = "top-left", THUMB_SIZE = 120;
function _orient(img, orientationNumber) {
  const orientation = ORIENTATION_OPS[orientationNumber - 1], ratio = img.height / img.width;
  img.width = THUMB_SIZE / ratio, img.height = img.width * ratio;
  const canvas = document.createElement("canvas"), ctx = canvas.getContext("2d");
  if (rotated(orientationNumber) ? (canvas.height = img.width, canvas.width = img.height) : (canvas.width = img.width, canvas.height = img.height), orientation.op === "flip-x" && flip(canvas, !0, !1), orientation.op === "flip-y" && flip(canvas, !1, !0), orientation.degrees && (rotate$1(ctx, {
    degrees: orientation.degrees,
    x: canvas.width / 2,
    y: canvas.height / 2
  }), rotated(orientationNumber))) {
    const d = canvas.width - canvas.height;
    ctx?.translate(d / 2, -d / 2);
  }
  return ctx?.drawImage(img, 0, 0, img.width, img.height), canvas;
}
function orient(image, orientationId) {
  return new Observable((observer) => {
    const orientation = ORIENTATIONS.indexOf(orientationId) + 1, canvas = _orient(image, orientation);
    observer.next(canvas.toDataURL("image/jpeg", 0.1)), observer.complete();
  });
}
function readFileAsArrayBuffer(file, length) {
  return new Observable((observer) => {
    const reader = new window.FileReader();
    return reader.onerror = (err) => observer.error(err), reader.onload = () => {
      observer.next(reader.result), observer.complete();
    }, reader.readAsArrayBuffer(file.slice(0, length)), () => reader.abort();
  });
}
const SKIP_EXIF_ERROR_RE = /(invalid image format)|(No exif data)/i, EXIF_BUFFER_LENGTH = 128e3;
function readExif(file) {
  return from(readFileAsArrayBuffer(file, EXIF_BUFFER_LENGTH)).pipe(map((buf) => exif(buf)), catchError((error) => (SKIP_EXIF_ERROR_RE.test(error.message) || console.warn(`Exif read failed, continuing anyway: ${error.message}`), of({}))));
}
function loadImage$1(url) {
  return new Observable((observer) => {
    const image = new window.Image();
    return image.onerror = () => {
      observer.error(new Error(`Could not load image from url "${url}". Image may be of an unsupported format`));
    }, image.onload = () => {
      observer.next(image), observer.complete();
    }, image.src = url, () => {
    };
  });
}
function rotateImage(file, orientation) {
  return loadImage$1(window.URL.createObjectURL(file)).pipe(mergeMap((image) => orient(image, orientation)));
}
function uploadImage(client, file, options) {
  const upload$ = uploadImageAsset(client, file, options).pipe(filter((event) => event.stage !== "download"), map((event) => ({
    ...event,
    progress: 2 + event.percent / 100 * 98
  })), map((event) => event.type === "complete" ? createUploadEvent([set({
    _type: "reference",
    _ref: event.asset._id
  }, ["asset"]), set(100, [UPLOAD_STATUS_KEY, "progress"]), set((/* @__PURE__ */ new Date()).toISOString(), [UPLOAD_STATUS_KEY, "updatedAt"])]) : createUploadEvent([set(event.percent, [UPLOAD_STATUS_KEY, "progress"]), set((/* @__PURE__ */ new Date()).toISOString(), [UPLOAD_STATUS_KEY, "updatedAt"])]))), setPreviewUrl$ = readExif(file).pipe(mergeMap((exifData) => rotateImage(file, exifData.orientation || DEFAULT_ORIENTATION)), catchError((error) => (console.warn('Image preprocessing failed for "%s" with the error: %s', file.name, error.message), of(null))), filter(Boolean), map((imageUrl) => createUploadEvent([set(imageUrl, [UPLOAD_STATUS_KEY, "previewImage"])])));
  return concat(of(createInitialUploadEvent(file)), merge(upload$, setPreviewUrl$), of(CLEANUP_EVENT));
}
const UPLOAD_IMAGE = {
  type: "image",
  accepts: "image/*",
  upload: (client, file, type, options) => uploadImage(client, file, options)
}, UPLOAD_FILE = {
  type: "file",
  accepts: "",
  upload: (client, file, type, options) => uploadFile(client, file, options)
}, UPLOAD_TEXT = {
  type: "string",
  accepts: "text/*",
  upload: (client, file, type, options) => uploadFile(client, file, options).pipe(map((content) => ({
    type: "uploadProgress",
    patches: [set(content)]
  })))
  // Todo: promote this to a "first-class" form-builder abstraction
  // and make it possible to register custom uploaders
}, uploaders = [UPLOAD_IMAGE, UPLOAD_TEXT, UPLOAD_FILE].map((uploader, i) => ({
  ...uploader,
  priority: i
}));
function resolveUploader(type, file) {
  return uploaders.find((uploader) => is$1(uploader.type, type) && accepts(file, uploader.accepts) && accepts(file, type.options?.accept || "")) || null;
}
function ArrayOfObjectsField(props2) {
  const $ = c(151), {
    onPathBlur,
    onPathFocus,
    onChange,
    onSetPathCollapsed,
    onSetFieldSetCollapsed,
    onPathOpen,
    onFieldGroupSelect
  } = useFormCallbacks(), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2, fieldActions = useDocumentFieldActions(), focusRef = useRef(void 0);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {}, $[0] = t0) : t0 = $[0];
  const assetSourceUploaderRef = useRef(t0);
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[1] = t1) : t1 = $[1];
  const [assetSourceUploadComponents, setAssetSourceUploadComponents] = useState(t1);
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && focusRef.current?.focus();
  }, $[2] = t2) : t2 = $[2], useDidUpdate(member.field.focused, t2);
  let t3;
  $[3] !== member.field.path || $[4] !== onPathFocus ? (t3 = (event) => {
    event.currentTarget === event.target && event.currentTarget === focusRef.current && onPathFocus(member.field.path);
  }, $[3] = member.field.path, $[4] = onPathFocus, $[5] = t3) : t3 = $[5];
  const handleFocus = t3;
  let t4;
  $[6] !== member.field.path || $[7] !== onPathBlur ? (t4 = (event_0) => {
    event_0.currentTarget === event_0.target && event_0.currentTarget === focusRef.current && onPathBlur(member.field.path);
  }, $[6] = member.field.path, $[7] = onPathBlur, $[8] = t4) : t4 = $[8];
  const handleBlur = t4, valueRef = useRef(member.field.value);
  let t5, t6;
  $[9] !== member.field.value ? (t5 = () => {
    valueRef.current = member.field.value;
  }, t6 = [member.field.value], $[9] = member.field.value, $[10] = t5, $[11] = t6) : (t5 = $[10], t6 = $[11]), useEffect(t5, t6);
  let t7;
  $[12] !== member.name || $[13] !== onChange ? (t7 = (event_1) => {
    const patches = PatchEvent.from(event_1).patches;
    if (patches.some(_temp$3s) && (valueRef.current = applyAll(valueRef.current || [], patches), Array.isArray(valueRef.current) && !valueRef.current.length)) {
      onChange(PatchEvent.from(unset([member.name])));
      return;
    }
    onChange(PatchEvent.from(event_1).prepend(setIfMissing([])).prefixAll(member.name));
  }, $[12] = member.name, $[13] = onChange, $[14] = t7) : t7 = $[14];
  const handleChange = t7, resolveInitialValue2 = useResolveInitialValueForType(), toast = useToast(), {
    t
  } = useTranslation();
  let t8;
  $[15] !== member.field.path || $[16] !== onSetPathCollapsed ? (t8 = () => {
    onSetPathCollapsed(member.field.path, !0);
  }, $[15] = member.field.path, $[16] = onSetPathCollapsed, $[17] = t8) : t8 = $[17];
  const handleCollapse = t8;
  let t9;
  $[18] !== member.field.path || $[19] !== onSetPathCollapsed ? (t9 = () => {
    onSetPathCollapsed(member.field.path, !1);
  }, $[18] = member.field.path, $[19] = onSetPathCollapsed, $[20] = t9) : t9 = $[20];
  const handleExpand = t9;
  let t10;
  $[21] !== member.field.path || $[22] !== onSetPathCollapsed ? (t10 = (itemKey) => {
    onSetPathCollapsed(member.field.path.concat({
      _key: itemKey
    }), !0);
  }, $[21] = member.field.path, $[22] = onSetPathCollapsed, $[23] = t10) : t10 = $[23];
  const handleCollapseItem = t10;
  let t11;
  $[24] !== member.field.path || $[25] !== onSetPathCollapsed ? (t11 = (itemKey_0) => {
    onSetPathCollapsed(member.field.path.concat({
      _key: itemKey_0
    }), !1);
  }, $[24] = member.field.path, $[25] = onSetPathCollapsed, $[26] = t11) : t11 = $[26];
  const handleExpandItem = t11;
  let t12;
  $[27] !== onPathOpen || $[28] !== onSetPathCollapsed ? (t12 = (path) => {
    onPathOpen(path), onSetPathCollapsed(path, !1);
  }, $[27] = onPathOpen, $[28] = onSetPathCollapsed, $[29] = t12) : t12 = $[29];
  const handleOpenItem = t12;
  let t13;
  $[30] !== member.field.path || $[31] !== onPathOpen || $[32] !== onSetPathCollapsed ? (t13 = () => {
    onPathOpen(member.field.path), onSetPathCollapsed(member.field.path, !0);
  }, $[30] = member.field.path, $[31] = onPathOpen, $[32] = onSetPathCollapsed, $[33] = t13) : t13 = $[33];
  const handleCloseItem = t13;
  let t14;
  $[34] !== handleChange || $[35] !== handleOpenItem || $[36] !== member.field.path || $[37] !== member.field.schemaType || $[38] !== onPathFocus || $[39] !== resolveInitialValue2 || $[40] !== toast ? (t14 = (event_2) => {
    if (event_2.items.length === 0)
      throw new Error("Insert event should include at least one item");
    const itemsWithKeys = event_2.items.map(_temp2$1u);
    handleChange(PatchEvent.from([insert$1(itemsWithKeys, event_2.position, [event_2.referenceItem])]));
    const focusItemKey = itemsWithKeys[0]._key, itemPath = [...member.field.path, {
      _key: focusItemKey
    }];
    onPathFocus(itemPath);
    const shouldOpen = event_2.open !== !1;
    event_2.skipInitialValue ? shouldOpen && handleOpenItem(itemPath) : resolveInitialArrayValues(itemsWithKeys, member.field.schemaType, resolveInitialValue2).pipe(tap((result) => {
      result.type === "patch" ? handleChange(result.patches) : toast.push({
        title: "Could not resolve initial value",
        description: `Unable to resolve initial value for type: ${result.schemaType.title}: ${result.error.message}.`,
        status: "error"
      });
    })).subscribe({
      complete: () => {
        shouldOpen && handleOpenItem(itemPath);
      }
    });
  }, $[34] = handleChange, $[35] = handleOpenItem, $[36] = member.field.path, $[37] = member.field.schemaType, $[38] = onPathFocus, $[39] = resolveInitialValue2, $[40] = toast, $[41] = t14) : t14 = $[41];
  const handleInsert = t14;
  let t15;
  $[42] !== handleChange || $[43] !== member.field.value ? (t15 = (event_3) => {
    const value = member.field.value, item_0 = value?.[event_3.fromIndex], refItem = value?.[event_3.toIndex];
    if (event_3.fromIndex !== event_3.toIndex) {
      if (!item_0?._key || !refItem?._key) {
        console.error("Neither the item you are moving nor the item you are moving to have a key. Cannot continue.");
        return;
      }
      handleChange([unset([{
        _key: item_0._key
      }]), insert$1([item_0], event_3.fromIndex > event_3.toIndex ? "before" : "after", [{
        _key: refItem._key
      }])]);
    }
  }, $[42] = handleChange, $[43] = member.field.value, $[44] = t15) : t15 = $[44];
  const handleMoveItem = t15;
  let t16;
  $[45] !== handleInsert ? (t16 = (item_1) => {
    handleInsert({
      items: [item_1],
      position: "before",
      referenceItem: 0
    });
  }, $[45] = handleInsert, $[46] = t16) : t16 = $[46];
  const handleItemPrepend = t16;
  let t17;
  $[47] !== handleInsert ? (t17 = (item_2) => {
    handleInsert({
      items: [item_2],
      position: "after",
      referenceItem: -1
    });
  }, $[47] = handleInsert, $[48] = t17) : t17 = $[48];
  const handleItemAppend = t17;
  let t18;
  $[49] !== handleChange ? (t18 = (itemKey_1) => {
    assetSourceUploaderRef.current[itemKey_1] && (assetSourceUploaderRef.current[itemKey_1].unsubscribe(), delete assetSourceUploaderRef.current[itemKey_1]), handleChange([unset([{
      _key: itemKey_1
    }])]);
  }, $[49] = handleChange, $[50] = t18) : t18 = $[50];
  const handleRemoveItem = t18;
  let t19;
  $[51] !== member.field.path || $[52] !== onPathFocus ? (t19 = (path_0, payload) => {
    onPathFocus(member.field.path.concat(path_0), payload);
  }, $[51] = member.field.path, $[52] = onPathFocus, $[53] = t19) : t19 = $[53];
  const handleFocusChildPath = t19, t20 = member.field.id;
  let t21;
  $[54] !== member.field.id || $[55] !== member.field.schemaType.description ? (t21 = createDescriptionId(member.field.id, member.field.schemaType.description), $[54] = member.field.id, $[55] = member.field.schemaType.description, $[56] = t21) : t21 = $[56];
  let t22;
  $[57] !== member.field.path ? (t22 = pathToAnchorIdent("input", member.field.path), $[57] = member.field.path, $[58] = t22) : t22 = $[58];
  let t23;
  $[59] !== t22 ? (t23 = {
    anchorName: t22
  }, $[59] = t22, $[60] = t23) : t23 = $[60];
  let t24;
  $[61] !== handleBlur || $[62] !== handleFocus || $[63] !== member.field.id || $[64] !== t21 || $[65] !== t23 ? (t24 = {
    onBlur: handleBlur,
    onFocus: handleFocus,
    id: t20,
    ref: focusRef,
    "aria-describedby": t21,
    style: t23
  }, $[61] = handleBlur, $[62] = handleFocus, $[63] = member.field.id, $[64] = t21, $[65] = t23, $[66] = t24) : t24 = $[66];
  const elementProps = t24, formBuilder = useFormBuilder(), supportsImageUploads = formBuilder.__internal.image.directUploads, supportsFileUploads = formBuilder.__internal.file.directUploads;
  let t25;
  $[67] !== supportsFileUploads || $[68] !== supportsImageUploads ? (t25 = (type, file) => is$1("image", type) && !supportsImageUploads || is$1("file", type) && !supportsFileUploads ? null : resolveUploader(type, file), $[67] = supportsFileUploads, $[68] = supportsImageUploads, $[69] = t25) : t25 = $[69];
  const resolveUploader$1 = t25;
  let t26;
  $[70] !== handleChange || $[71] !== resolveUploader$1 ? (t26 = (assets, schemaType, key) => {
    handleSelectAssetFromSource({
      assetsFromSource: assets,
      onChange: (patches_0) => handleChange(PatchEvent.from(patches_0).prefixAll({
        _key: key
      })),
      type: schemaType,
      resolveUploader: resolveUploader$1,
      uploadWith: void 0
    });
  }, $[70] = handleChange, $[71] = resolveUploader$1, $[72] = t26) : t26 = $[72];
  const handleSelectAssetsFromSource = t26;
  let t27;
  $[73] !== handleChange || $[74] !== handleInsert || $[75] !== handleRemoveItem || $[76] !== handleSelectAssetsFromSource || $[77] !== t || $[78] !== toast ? (t27 = (t282) => {
    const {
      assetSource,
      schemaType: schemaType_0,
      file: file_0
    } = t282;
    if (assetSource.Uploader) {
      const item_3 = createProtoArrayValue(schemaType_0), key_0 = item_3._key;
      try {
        handleInsert({
          items: [item_3],
          position: "after",
          referenceItem: -1,
          open: !1
        }), handleChange(PatchEvent.from(createInitialUploadPatches(file_0)).prefixAll({
          _key: key_0
        }));
        const uploader = new assetSource.Uploader();
        setAssetSourceUploadComponents((prev) => {
          const AssetSourceComponent = assetSource.component, assetSourceComponent = /* @__PURE__ */ jsx(AssetSourceComponent, { assetSource, action: "upload", onSelect: (assets_0) => handleSelectAssetsFromSource(assets_0, schemaType_0, key_0), accept: "*/*", onClose: noop$7, selectedAssets: [], selectionType: "single", uploader }, key_0);
          return [...prev, assetSourceComponent];
        });
        const unsubscribe = uploader.subscribe((event_4) => {
          bb183: switch (event_4.type) {
            case "progress": {
              handleChange(PatchEvent.from([set(Math.max(2, event_4.progress), [{
                _key: key_0
              }, UPLOAD_STATUS_KEY, "progress"]), set((/* @__PURE__ */ new Date()).toISOString(), [{
                _key: key_0
              }, UPLOAD_STATUS_KEY, "updatedAt"])]));
              break bb183;
            }
            case "error": {
              event_4.files.forEach(_temp3$I), toast.push({
                status: "error",
                description: t("asset-sources.common.uploader.upload-failed.description"),
                title: t("asset-sources.common.uploader.upload-failed.title")
              });
              break bb183;
            }
            case "all-complete": {
              handleChange(PatchEvent.from([unset([{
                _key: key_0
              }, UPLOAD_STATUS_KEY])]));
              break bb183;
            }
            default:
          }
        });
        assetSourceUploaderRef.current = {
          ...assetSourceUploaderRef.current,
          [key_0]: {
            unsubscribe: () => (setAssetSourceUploadComponents((prev_0) => prev_0.filter((el) => el.key !== key_0)), unsubscribe),
            uploader
          }
        }, uploader.upload([file_0], {
          schemaType: schemaType_0,
          onChange: (patches_1) => {
            handleChange(PatchEvent.from(patches_1).prefixAll({
              _key: key_0
            }));
          }
        });
      } catch (t292) {
        console.error(t292), assetSourceUploaderRef.current?.[key_0]?.unsubscribe(), handleChange(PatchEvent.from([unset(["_upload"])]).prefixAll({
          _key: key_0
        })), handleRemoveItem(key_0);
      }
    }
  }, $[73] = handleChange, $[74] = handleInsert, $[75] = handleRemoveItem, $[76] = handleSelectAssetsFromSource, $[77] = t, $[78] = toast, $[79] = t27) : t27 = $[79];
  const handleSelectFile = t27, t28 = member.field.value, t29 = member.field.displayInlineChanges ?? !1;
  let t30;
  $[80] !== elementProps || $[81] !== handleChange || $[82] !== handleCloseItem || $[83] !== handleCollapseItem || $[84] !== handleExpandItem || $[85] !== handleFocusChildPath || $[86] !== handleInsert || $[87] !== handleItemAppend || $[88] !== handleItemPrepend || $[89] !== handleMoveItem || $[90] !== handleOpenItem || $[91] !== handleRemoveItem || $[92] !== handleSelectFile || $[93] !== member.field.__unstable_computeDiff || $[94] !== member.field.changed || $[95] !== member.field.compareValue || $[96] !== member.field.focusPath || $[97] !== member.field.focused || $[98] !== member.field.hasUpstreamVersion || $[99] !== member.field.id || $[100] !== member.field.level || $[101] !== member.field.members || $[102] !== member.field.path || $[103] !== member.field.presence || $[104] !== member.field.readOnly || $[105] !== member.field.schemaType || $[106] !== member.field.validation || $[107] !== renderAnnotation || $[108] !== renderBlock2 || $[109] !== renderField || $[110] !== renderInlineBlock || $[111] !== renderInput || $[112] !== renderItem2 || $[113] !== renderPreview || $[114] !== resolveInitialValue2 || $[115] !== resolveUploader$1 || $[116] !== t28 || $[117] !== t29 ? (t30 = {
    level: member.field.level,
    members: member.field.members,
    value: t28,
    readOnly: member.field.readOnly,
    schemaType: member.field.schemaType,
    changed: member.field.changed,
    __unstable_computeDiff: member.field.__unstable_computeDiff,
    compareValue: member.field.compareValue,
    hasUpstreamVersion: member.field.hasUpstreamVersion,
    id: member.field.id,
    onItemExpand: handleExpandItem,
    onItemCollapse: handleCollapseItem,
    onItemClose: handleCloseItem,
    onItemOpen: handleOpenItem,
    displayInlineChanges: t29,
    focusPath: member.field.focusPath,
    focused: member.field.focused,
    path: member.field.path,
    onChange: handleChange,
    onInsert: handleInsert,
    onItemMove: handleMoveItem,
    onItemRemove: handleRemoveItem,
    onItemAppend: handleItemAppend,
    onItemPrepend: handleItemPrepend,
    onPathFocus: handleFocusChildPath,
    resolveInitialValue: resolveInitialValue2,
    onSelectFile: handleSelectFile,
    resolveUploader: resolveUploader$1,
    validation: member.field.validation,
    presence: member.field.presence,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderInlineBlock,
    renderInput,
    renderField,
    renderItem: renderItem2,
    renderPreview,
    elementProps
  }, $[80] = elementProps, $[81] = handleChange, $[82] = handleCloseItem, $[83] = handleCollapseItem, $[84] = handleExpandItem, $[85] = handleFocusChildPath, $[86] = handleInsert, $[87] = handleItemAppend, $[88] = handleItemPrepend, $[89] = handleMoveItem, $[90] = handleOpenItem, $[91] = handleRemoveItem, $[92] = handleSelectFile, $[93] = member.field.__unstable_computeDiff, $[94] = member.field.changed, $[95] = member.field.compareValue, $[96] = member.field.focusPath, $[97] = member.field.focused, $[98] = member.field.hasUpstreamVersion, $[99] = member.field.id, $[100] = member.field.level, $[101] = member.field.members, $[102] = member.field.path, $[103] = member.field.presence, $[104] = member.field.readOnly, $[105] = member.field.schemaType, $[106] = member.field.validation, $[107] = renderAnnotation, $[108] = renderBlock2, $[109] = renderField, $[110] = renderInlineBlock, $[111] = renderInput, $[112] = renderItem2, $[113] = renderPreview, $[114] = resolveInitialValue2, $[115] = resolveUploader$1, $[116] = t28, $[117] = t29, $[118] = t30) : t30 = $[118];
  const inputProps = t30, t31 = inputProps;
  let t32;
  $[119] !== inputProps || $[120] !== renderInput ? (t32 = /* @__PURE__ */ jsx(RenderInput$3, { ...inputProps, render: renderInput }), $[119] = inputProps, $[120] = renderInput, $[121] = t32) : t32 = $[121];
  let t33;
  $[122] !== fieldActions || $[123] !== handleCollapse || $[124] !== handleExpand || $[125] !== member.collapsed || $[126] !== member.collapsible || $[127] !== member.field.changed || $[128] !== member.field.id || $[129] !== member.field.level || $[130] !== member.field.path || $[131] !== member.field.presence || $[132] !== member.field.schemaType || $[133] !== member.field.validation || $[134] !== member.field.value || $[135] !== member.index || $[136] !== member.name || $[137] !== renderField || $[138] !== t31 || $[139] !== t32 ? (t33 = /* @__PURE__ */ jsx(RenderField$3, { actions: fieldActions, name: member.name, index: member.index, level: member.field.level, value: member.field.value, title: member.field.schemaType.title, description: member.field.schemaType.description, collapsible: member.collapsible, collapsed: member.collapsed, changed: member.field.changed, onCollapse: handleCollapse, onExpand: handleExpand, schemaType: member.field.schemaType, inputId: member.field.id, path: member.field.path, presence: member.field.presence, validation: member.field.validation, inputProps: t31, render: renderField, children: t32 }), $[122] = fieldActions, $[123] = handleCollapse, $[124] = handleExpand, $[125] = member.collapsed, $[126] = member.collapsible, $[127] = member.field.changed, $[128] = member.field.id, $[129] = member.field.level, $[130] = member.field.path, $[131] = member.field.presence, $[132] = member.field.schemaType, $[133] = member.field.validation, $[134] = member.field.value, $[135] = member.index, $[136] = member.name, $[137] = renderField, $[138] = t31, $[139] = t32, $[140] = t33) : t33 = $[140];
  let t34;
  return $[141] !== assetSourceUploadComponents || $[142] !== handleChange || $[143] !== onFieldGroupSelect || $[144] !== onPathBlur || $[145] !== onPathFocus || $[146] !== onPathOpen || $[147] !== onSetFieldSetCollapsed || $[148] !== onSetPathCollapsed || $[149] !== t33 ? (t34 = /* @__PURE__ */ jsxs(FormCallbacksProvider, { onFieldGroupSelect, onChange: handleChange, onSetFieldSetCollapsed, onSetPathCollapsed, onPathOpen, onPathBlur, onPathFocus, children: [
    t33,
    assetSourceUploadComponents
  ] }), $[141] = assetSourceUploadComponents, $[142] = handleChange, $[143] = onFieldGroupSelect, $[144] = onPathBlur, $[145] = onPathFocus, $[146] = onPathOpen, $[147] = onSetFieldSetCollapsed, $[148] = onSetPathCollapsed, $[149] = t33, $[150] = t34) : t34 = $[150], t34;
}
function _temp3$I(_file) {
  console.error(_file.error);
}
function _temp2$1u(item) {
  return ensureKey(item);
}
function _temp$3s(patch2) {
  return patch2.type === "unset" && patch2.path.length === 1;
}
function RenderInput$3({
  render: render2,
  ...props2
}) {
  return render2(props2);
}
function RenderField$3({
  render: render2,
  ...props2
}) {
  return render2(props2);
}
function readAsText(file, encoding) {
  return new Observable((observer) => {
    const reader = new FileReader();
    return reader.onerror = (error) => observer.error(error), reader.onload = () => {
      observer.next(reader.result), observer.complete();
    }, reader.readAsText(file, encoding), () => {
      reader.abort();
    };
  });
}
function move(arr, from2, to) {
  const copy = arr.slice(), val = copy[from2];
  return copy.splice(from2, 1), copy.splice(to, 0, val), copy;
}
function insertAfter(index, arr, items) {
  const copy = arr.slice();
  return copy.splice(index + 1, 0, ...items), copy;
}
function isStringNumeric(input) {
  return /^\d+$/.test(input);
}
function convertToSchemaType(line, candidates) {
  let acceptsBooleans = !1, acceptsNumbers = !1, acceptsStrings = !1;
  return candidates.forEach((candidate) => {
    isBooleanSchemaType(candidate) && (acceptsBooleans = !0), isStringSchemaType(candidate) && (acceptsStrings = !0), isNumberSchemaType(candidate) && (acceptsNumbers = !0);
  }), acceptsBooleans && (line === "true" || line === "false") ? line === "true" : acceptsNumbers && isStringNumeric(line) ? Number(line) : acceptsStrings ? line : void 0;
}
function createPlainTextUploader(itemTypes) {
  return {
    priority: 0,
    accepts: "text/*",
    type: "string",
    upload(client, file) {
      return readAsText(file, "utf-8").pipe(map((textContent) => textContent?.split(/[\n\r]/).map((value) => convertToSchemaType(value, itemTypes)).filter((v) => v !== void 0)), filter((v) => Array.isArray(v)), map((lines) => ({
        type: "uploadProgress",
        patches: [insert$1(lines, "after", [-1])]
      })));
    }
  };
}
function ArrayOfPrimitivesField(props2) {
  const $ = c(124), {
    onPathBlur,
    onPathFocus,
    onChange,
    onPathOpen,
    onSetPathCollapsed,
    onSetFieldSetCollapsed,
    onFieldGroupSelect
  } = useFormCallbacks(), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2, fieldActions = useDocumentFieldActions(), focusRef = useRef(void 0), uploadSubscriptions = useRef(void 0), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && focusRef.current?.focus();
  }, $[0] = t0) : t0 = $[0], useDidUpdate(member.field.focused, t0);
  let t1;
  $[1] !== member.field.path || $[2] !== onPathFocus ? (t1 = (event) => {
    event.currentTarget === event.target && event.currentTarget === focusRef.current && onPathFocus(member.field.path);
  }, $[1] = member.field.path, $[2] = onPathFocus, $[3] = t1) : t1 = $[3];
  const handleFocus = t1;
  let t2;
  $[4] !== member.field.path || $[5] !== onPathBlur ? (t2 = (event_0) => {
    event_0.currentTarget === event_0.target && event_0.currentTarget === focusRef.current && onPathBlur(member.field.path);
  }, $[4] = member.field.path, $[5] = onPathBlur, $[6] = t2) : t2 = $[6];
  const handleBlur = t2;
  let t3;
  $[7] !== member.field.value || $[8] !== member.name || $[9] !== onChange ? (t3 = (event_1) => {
    const patches = PatchEvent.from(event_1).patches;
    if (patches.some(_temp$3r)) {
      const result = applyAll(member.field.value || [], patches);
      if (Array.isArray(result) && !result.length) {
        onChange(PatchEvent.from(unset([member.name])));
        return;
      }
    }
    onChange(PatchEvent.from(event_1).prepend(setIfMissing([])).prefixAll(member.name));
  }, $[7] = member.field.value, $[8] = member.name, $[9] = onChange, $[10] = t3) : t3 = $[10];
  const handleChange = t3;
  let t4;
  $[11] !== member.field.path || $[12] !== onSetPathCollapsed ? (t4 = (collapsed) => {
    onSetPathCollapsed(member.field.path, collapsed);
  }, $[11] = member.field.path, $[12] = onSetPathCollapsed, $[13] = t4) : t4 = $[13];
  const handleSetCollapsed = t4;
  let t5;
  $[14] !== member.field.path || $[15] !== onSetPathCollapsed ? (t5 = () => {
    onSetPathCollapsed(member.field.path, !0);
  }, $[14] = member.field.path, $[15] = onSetPathCollapsed, $[16] = t5) : t5 = $[16];
  const handleCollapse = t5;
  let t6;
  $[17] !== member.field.path || $[18] !== onSetPathCollapsed ? (t6 = () => {
    onSetPathCollapsed(member.field.path, !1);
  }, $[17] = member.field.path, $[18] = onSetPathCollapsed, $[19] = t6) : t6 = $[19];
  const handleExpand = t6;
  let t7;
  $[20] !== handleChange ? (t7 = (nextValue) => {
    handleChange(nextValue.length === 0 ? unset() : set(nextValue));
  }, $[20] = handleChange, $[21] = t7) : t7 = $[21];
  const setValue = t7;
  let t8;
  $[22] !== member.field || $[23] !== setValue ? (t8 = (event_2) => {
    const {
      value: t92
    } = member.field, value = t92 === void 0 ? [] : t92;
    event_2.fromIndex !== event_2.toIndex && setValue(move(value, event_2.fromIndex, event_2.toIndex));
  }, $[22] = member.field, $[23] = setValue, $[24] = t8) : t8 = $[24];
  const handleMoveItem = t8;
  let t9;
  $[25] !== member.field || $[26] !== setValue ? (t9 = (itemValue) => {
    const {
      value: t102
    } = member.field;
    setValue((t102 === void 0 ? [] : t102).concat(itemValue));
  }, $[25] = member.field, $[26] = setValue, $[27] = t9) : t9 = $[27];
  const handleAppend = t9;
  let t10;
  $[28] !== member.field || $[29] !== setValue ? (t10 = (itemValue_0) => {
    const {
      value: t112
    } = member.field, value_1 = t112 === void 0 ? [] : t112;
    setValue([itemValue_0].concat(value_1 || []));
  }, $[28] = member.field, $[29] = setValue, $[30] = t10) : t10 = $[30];
  const handlePrepend = t10;
  let t11;
  $[31] !== member.field || $[32] !== setValue ? (t11 = (event_3) => {
    const {
      value: t122
    } = member.field, value_2 = t122 === void 0 ? [] : t122, insertIndex = event_3.referenceIndex + (event_3.position === "before" ? -1 : 0);
    setValue(insertAfter(insertIndex, value_2, event_3.items));
  }, $[31] = member.field, $[32] = setValue, $[33] = t11) : t11 = $[33];
  const handleInsert = t11;
  let t12;
  $[34] !== handleChange ? (t12 = (index) => {
    handleChange(unset([index]));
  }, $[34] = handleChange, $[35] = t12) : t12 = $[35];
  const handleRemoveItem = t12;
  let t13;
  $[36] !== member.field.path || $[37] !== onPathFocus ? (t13 = (index_0) => {
    onPathFocus(member.field.path.concat([index_0]));
  }, $[36] = member.field.path, $[37] = onPathFocus, $[38] = t13) : t13 = $[38];
  const handleFocusIndex = t13, t14 = member.field.id;
  let t15;
  $[39] !== member.field.id || $[40] !== member.field.schemaType.description ? (t15 = createDescriptionId(member.field.id, member.field.schemaType.description), $[39] = member.field.id, $[40] = member.field.schemaType.description, $[41] = t15) : t15 = $[41];
  let t16;
  $[42] !== member.field.path ? (t16 = pathToAnchorIdent("input", member.field.path), $[42] = member.field.path, $[43] = t16) : t16 = $[43];
  let t17;
  $[44] !== t16 ? (t17 = {
    anchorName: t16
  }, $[44] = t16, $[45] = t17) : t17 = $[45];
  let t18;
  $[46] !== handleBlur || $[47] !== handleFocus || $[48] !== member.field.id || $[49] !== t15 || $[50] !== t17 ? (t18 = {
    onBlur: handleBlur,
    onFocus: handleFocus,
    id: t14,
    ref: focusRef,
    "aria-describedby": t15,
    style: t17
  }, $[46] = handleBlur, $[47] = handleFocus, $[48] = member.field.id, $[49] = t15, $[50] = t17, $[51] = t18) : t18 = $[51];
  const elementProps = t18, t19 = member.field.schemaType.of;
  let t20;
  $[52] !== t19 ? (t20 = createPlainTextUploader(t19), $[52] = t19, $[53] = t20) : t20 = $[53];
  const plainTextUploader = t20;
  let t21;
  $[54] !== plainTextUploader ? (t21 = (schemaType, file) => accepts(file, "text/*") ? plainTextUploader : null, $[54] = plainTextUploader, $[55] = t21) : t21 = $[55];
  const resolveUploader2 = t21;
  let t22;
  $[56] !== client || $[57] !== handleChange ? (t22 = (t232) => {
    const {
      file: file_0,
      schemaType: schemaType_0,
      uploader
    } = t232, events$ = uploader.upload(client, file_0, schemaType_0).pipe(map(_temp2$1t), tap((event_4) => handleChange(event_4.patches)));
    uploadSubscriptions.current && uploadSubscriptions.current.unsubscribe(), uploadSubscriptions.current = events$.subscribe();
  }, $[56] = client, $[57] = handleChange, $[58] = t22) : t22 = $[58];
  const handleUpload = t22, t23 = member.field.value, t24 = member.field.displayInlineChanges ?? !1;
  let t25;
  $[59] !== elementProps || $[60] !== handleAppend || $[61] !== handleChange || $[62] !== handleFocusIndex || $[63] !== handleInsert || $[64] !== handleMoveItem || $[65] !== handlePrepend || $[66] !== handleRemoveItem || $[67] !== handleSetCollapsed || $[68] !== handleUpload || $[69] !== member.field.__unstable_computeDiff || $[70] !== member.field.changed || $[71] !== member.field.compareValue || $[72] !== member.field.focusPath || $[73] !== member.field.focused || $[74] !== member.field.hasUpstreamVersion || $[75] !== member.field.id || $[76] !== member.field.level || $[77] !== member.field.members || $[78] !== member.field.path || $[79] !== member.field.presence || $[80] !== member.field.readOnly || $[81] !== member.field.schemaType || $[82] !== member.field.validation || $[83] !== renderAnnotation || $[84] !== renderBlock2 || $[85] !== renderInlineBlock || $[86] !== renderInput || $[87] !== renderItem2 || $[88] !== renderPreview || $[89] !== resolveUploader2 || $[90] !== t23 || $[91] !== t24 ? (t25 = {
    level: member.field.level,
    members: member.field.members,
    value: t23,
    compareValue: member.field.compareValue,
    readOnly: member.field.readOnly,
    onSetCollapsed: handleSetCollapsed,
    schemaType: member.field.schemaType,
    changed: member.field.changed,
    __unstable_computeDiff: member.field.__unstable_computeDiff,
    hasUpstreamVersion: member.field.hasUpstreamVersion,
    id: member.field.id,
    elementProps,
    path: member.field.path,
    focusPath: member.field.focusPath,
    focused: member.field.focused,
    onChange: handleChange,
    onInsert: handleInsert,
    onMoveItem: handleMoveItem,
    onItemRemove: handleRemoveItem,
    onItemAppend: handleAppend,
    onItemPrepend: handlePrepend,
    validation: member.field.validation,
    presence: member.field.presence,
    resolveUploader: resolveUploader2,
    onUpload: handleUpload,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    onIndexFocus: handleFocusIndex,
    renderPreview,
    displayInlineChanges: t24
  }, $[59] = elementProps, $[60] = handleAppend, $[61] = handleChange, $[62] = handleFocusIndex, $[63] = handleInsert, $[64] = handleMoveItem, $[65] = handlePrepend, $[66] = handleRemoveItem, $[67] = handleSetCollapsed, $[68] = handleUpload, $[69] = member.field.__unstable_computeDiff, $[70] = member.field.changed, $[71] = member.field.compareValue, $[72] = member.field.focusPath, $[73] = member.field.focused, $[74] = member.field.hasUpstreamVersion, $[75] = member.field.id, $[76] = member.field.level, $[77] = member.field.members, $[78] = member.field.path, $[79] = member.field.presence, $[80] = member.field.readOnly, $[81] = member.field.schemaType, $[82] = member.field.validation, $[83] = renderAnnotation, $[84] = renderBlock2, $[85] = renderInlineBlock, $[86] = renderInput, $[87] = renderItem2, $[88] = renderPreview, $[89] = resolveUploader2, $[90] = t23, $[91] = t24, $[92] = t25) : t25 = $[92];
  const inputProps = t25, t26 = inputProps;
  let t27;
  $[93] !== inputProps || $[94] !== renderInput ? (t27 = /* @__PURE__ */ jsx(RenderInput$2, { ...inputProps, render: renderInput }), $[93] = inputProps, $[94] = renderInput, $[95] = t27) : t27 = $[95];
  let t28;
  $[96] !== fieldActions || $[97] !== handleCollapse || $[98] !== handleExpand || $[99] !== member.collapsed || $[100] !== member.collapsible || $[101] !== member.field.changed || $[102] !== member.field.id || $[103] !== member.field.level || $[104] !== member.field.path || $[105] !== member.field.presence || $[106] !== member.field.schemaType || $[107] !== member.field.validation || $[108] !== member.field.value || $[109] !== member.index || $[110] !== member.name || $[111] !== renderField || $[112] !== t26 || $[113] !== t27 ? (t28 = /* @__PURE__ */ jsx(RenderField$2, { actions: fieldActions, name: member.name, index: member.index, level: member.field.level, value: member.field.value, title: member.field.schemaType.title, description: member.field.schemaType.description, collapsible: member.collapsible, collapsed: member.collapsed, onExpand: handleExpand, changed: member.field.changed, onCollapse: handleCollapse, schemaType: member.field.schemaType, inputId: member.field.id, path: member.field.path, presence: member.field.presence, validation: member.field.validation, inputProps: t26, render: renderField, children: t27 }), $[96] = fieldActions, $[97] = handleCollapse, $[98] = handleExpand, $[99] = member.collapsed, $[100] = member.collapsible, $[101] = member.field.changed, $[102] = member.field.id, $[103] = member.field.level, $[104] = member.field.path, $[105] = member.field.presence, $[106] = member.field.schemaType, $[107] = member.field.validation, $[108] = member.field.value, $[109] = member.index, $[110] = member.name, $[111] = renderField, $[112] = t26, $[113] = t27, $[114] = t28) : t28 = $[114];
  let t29;
  return $[115] !== handleChange || $[116] !== onFieldGroupSelect || $[117] !== onPathBlur || $[118] !== onPathFocus || $[119] !== onPathOpen || $[120] !== onSetFieldSetCollapsed || $[121] !== onSetPathCollapsed || $[122] !== t28 ? (t29 = /* @__PURE__ */ jsx(FormCallbacksProvider, { onFieldGroupSelect, onChange: handleChange, onPathOpen, onSetFieldSetCollapsed, onSetPathCollapsed, onPathBlur, onPathFocus, children: t28 }), $[115] = handleChange, $[116] = onFieldGroupSelect, $[117] = onPathBlur, $[118] = onPathFocus, $[119] = onPathOpen, $[120] = onSetFieldSetCollapsed, $[121] = onSetPathCollapsed, $[122] = t28, $[123] = t29) : t29 = $[123], t29;
}
function _temp2$1t(uploadProgressEvent) {
  return PatchEvent.from(uploadProgressEvent.patches || []);
}
function _temp$3r(patch2) {
  return patch2.type === "unset" && patch2.path.length === 1;
}
function RenderInput$2({
  render: render2,
  ...props2
}) {
  return render2(props2);
}
function RenderField$2({
  render: render2,
  ...props2
}) {
  return render2(props2);
}
const ObjectField = function(props2) {
  const $ = c(133), {
    onPathBlur,
    onPathFocus,
    onChange,
    onPathOpen,
    onSetPathCollapsed,
    onSetFieldSetCollapsed,
    onFieldGroupSelect
  } = useFormCallbacks(), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2, fieldActions = useDocumentFieldActions(), focusRef = useRef(void 0), pendingValue = useRef(member.field.value);
  let t0, t1;
  $[0] !== member.field.value ? (t0 = () => {
    pendingValue.current = member.field.value;
  }, t1 = [member.field.value], $[0] = member.field.value, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && focusRef.current?.focus();
  }, $[3] = t2) : t2 = $[3], useDidUpdate(member.field.focused, t2);
  let t3;
  $[4] !== member.field.path || $[5] !== onPathBlur ? (t3 = () => {
    onPathBlur(member.field.path);
  }, $[4] = member.field.path, $[5] = onPathBlur, $[6] = t3) : t3 = $[6];
  const handleBlur = t3;
  let t4;
  $[7] !== member.field.path || $[8] !== onPathFocus ? (t4 = () => {
    onPathFocus(member.field.path);
  }, $[7] = member.field.path, $[8] = onPathFocus, $[9] = t4) : t4 = $[9];
  const handleFocus = t4;
  let t5;
  $[10] !== member.field.path || $[11] !== onPathFocus ? (t5 = (path) => {
    onPathFocus(member.field.path.concat(path));
  }, $[10] = member.field.path, $[11] = onPathFocus, $[12] = t5) : t5 = $[12];
  const handleFocusChildPath = t5;
  let t6;
  $[13] !== member.field.path.length || $[14] !== member.field.schemaType || $[15] !== member.name || $[16] !== onChange ? (t6 = (event) => {
    if (member.field.path.length !== 0) {
      const patches = PatchEvent.from(event).patches;
      if (pendingValue.current = applyAll(pendingValue.current || {}, patches), pendingValue.current && isShallowEmptyObject(pendingValue.current)) {
        onChange(PatchEvent.from(unset([member.name])));
        return;
      }
    }
    onChange(PatchEvent.from(event).prepend(setIfMissing(createProtoValue(member.field.schemaType))).prefixAll(member.name));
  }, $[13] = member.field.path.length, $[14] = member.field.schemaType, $[15] = member.name, $[16] = onChange, $[17] = t6) : t6 = $[17];
  const handleChange = t6;
  let t7;
  $[18] !== member.field.path || $[19] !== onSetPathCollapsed ? (t7 = () => {
    onSetPathCollapsed(member.field.path, !0);
  }, $[18] = member.field.path, $[19] = onSetPathCollapsed, $[20] = t7) : t7 = $[20];
  const handleCollapse = t7;
  let t8;
  $[21] !== member.field.path || $[22] !== onSetPathCollapsed ? (t8 = () => {
    onSetPathCollapsed(member.field.path, !1);
  }, $[21] = member.field.path, $[22] = onSetPathCollapsed, $[23] = t8) : t8 = $[23];
  const handleExpand = t8;
  let t9;
  $[24] !== member.field.path || $[25] !== onSetPathCollapsed ? (t9 = (fieldName) => {
    onSetPathCollapsed(member.field.path.concat(fieldName), !0);
  }, $[24] = member.field.path, $[25] = onSetPathCollapsed, $[26] = t9) : t9 = $[26];
  const handleCollapseField = t9;
  let t10;
  $[27] !== member.field.path || $[28] !== onSetPathCollapsed ? (t10 = (fieldName_0) => {
    onSetPathCollapsed(member.field.path.concat(fieldName_0), !1);
  }, $[27] = member.field.path, $[28] = onSetPathCollapsed, $[29] = t10) : t10 = $[29];
  const handleExpandField = t10;
  let t11;
  $[30] !== member.field.path || $[31] !== onPathOpen ? (t11 = (fieldName_1) => {
    onPathOpen(member.field.path.concat(fieldName_1));
  }, $[30] = member.field.path, $[31] = onPathOpen, $[32] = t11) : t11 = $[32];
  const handleOpenField = t11;
  let t12;
  $[33] !== member.field.path || $[34] !== onPathOpen ? (t12 = () => {
    onPathOpen(member.field.path);
  }, $[33] = member.field.path, $[34] = onPathOpen, $[35] = t12) : t12 = $[35];
  const handleCloseField = t12;
  let t13;
  $[36] !== member.field.path || $[37] !== onSetFieldSetCollapsed ? (t13 = (fieldsetName) => {
    onSetFieldSetCollapsed(member.field.path.concat(fieldsetName), !1);
  }, $[36] = member.field.path, $[37] = onSetFieldSetCollapsed, $[38] = t13) : t13 = $[38];
  const handleExpandFieldSet = t13;
  let t14;
  $[39] !== member.field.path || $[40] !== onSetFieldSetCollapsed ? (t14 = (fieldsetName_0) => {
    onSetFieldSetCollapsed(member.field.path.concat(fieldsetName_0), !0);
  }, $[39] = member.field.path, $[40] = onSetFieldSetCollapsed, $[41] = t14) : t14 = $[41];
  const handleCollapseFieldSet = t14;
  let t15;
  $[42] !== member.field.path || $[43] !== onPathOpen ? (t15 = () => {
    onPathOpen(member.field.path);
  }, $[42] = member.field.path, $[43] = onPathOpen, $[44] = t15) : t15 = $[44];
  const handleOpen = t15;
  let t16;
  $[45] !== member.field.path || $[46] !== onPathOpen ? (t16 = () => {
    onPathOpen(member.field.path.slice(0, -1));
  }, $[45] = member.field.path, $[46] = onPathOpen, $[47] = t16) : t16 = $[47];
  const handleClose = t16;
  let t17;
  $[48] !== member.field.path || $[49] !== onFieldGroupSelect ? (t17 = (groupName) => {
    onFieldGroupSelect(member.field.path, groupName);
  }, $[48] = member.field.path, $[49] = onFieldGroupSelect, $[50] = t17) : t17 = $[50];
  const handleSelectFieldGroup = t17, t18 = member.field.id;
  let t19;
  $[51] !== member.field.id || $[52] !== member.field.schemaType.description ? (t19 = createDescriptionId(member.field.id, member.field.schemaType.description), $[51] = member.field.id, $[52] = member.field.schemaType.description, $[53] = t19) : t19 = $[53];
  let t20;
  $[54] !== member.field.path ? (t20 = pathToAnchorIdent("input", member.field.path), $[54] = member.field.path, $[55] = t20) : t20 = $[55];
  let t21;
  $[56] !== t20 ? (t21 = {
    anchorName: t20
  }, $[56] = t20, $[57] = t21) : t21 = $[57];
  let t22;
  $[58] !== handleBlur || $[59] !== handleFocus || $[60] !== member.field.id || $[61] !== t19 || $[62] !== t21 ? (t22 = {
    onBlur: handleBlur,
    onFocus: handleFocus,
    id: t18,
    ref: focusRef,
    "aria-describedby": t19,
    style: t21
  }, $[58] = handleBlur, $[59] = handleFocus, $[60] = member.field.id, $[61] = t19, $[62] = t21, $[63] = t22) : t22 = $[63];
  const elementProps = t22, t23 = member.field.displayInlineChanges ?? !1;
  let t24;
  $[64] !== elementProps || $[65] !== handleChange || $[66] !== handleCloseField || $[67] !== handleCollapseField || $[68] !== handleCollapseFieldSet || $[69] !== handleExpandField || $[70] !== handleExpandFieldSet || $[71] !== handleFocusChildPath || $[72] !== handleOpenField || $[73] !== handleSelectFieldGroup || $[74] !== member.field.__unstable_computeDiff || $[75] !== member.field.changed || $[76] !== member.field.compareValue || $[77] !== member.field.focusPath || $[78] !== member.field.focused || $[79] !== member.field.groups || $[80] !== member.field.hasUpstreamVersion || $[81] !== member.field.id || $[82] !== member.field.level || $[83] !== member.field.members || $[84] !== member.field.path || $[85] !== member.field.presence || $[86] !== member.field.readOnly || $[87] !== member.field.schemaType || $[88] !== member.field.validation || $[89] !== member.field.value || $[90] !== renderAnnotation || $[91] !== renderBlock2 || $[92] !== renderField || $[93] !== renderInlineBlock || $[94] !== renderInput || $[95] !== renderItem2 || $[96] !== renderPreview || $[97] !== t23 ? (t24 = {
    elementProps,
    level: member.field.level,
    members: member.field.members,
    value: member.field.value,
    compareValue: member.field.compareValue,
    readOnly: member.field.readOnly,
    validation: member.field.validation,
    presence: member.field.presence,
    schemaType: member.field.schemaType,
    changed: member.field.changed,
    __unstable_computeDiff: member.field.__unstable_computeDiff,
    hasUpstreamVersion: member.field.hasUpstreamVersion,
    id: member.field.id,
    onFieldGroupSelect: handleSelectFieldGroup,
    onFieldOpen: handleOpenField,
    onFieldClose: handleCloseField,
    onFieldCollapse: handleCollapseField,
    onFieldExpand: handleExpandField,
    onFieldSetExpand: handleExpandFieldSet,
    onFieldSetCollapse: handleCollapseFieldSet,
    onPathFocus: handleFocusChildPath,
    path: member.field.path,
    focusPath: member.field.focusPath,
    focused: member.field.focused,
    groups: member.field.groups,
    onChange: handleChange,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    displayInlineChanges: t23
  }, $[64] = elementProps, $[65] = handleChange, $[66] = handleCloseField, $[67] = handleCollapseField, $[68] = handleCollapseFieldSet, $[69] = handleExpandField, $[70] = handleExpandFieldSet, $[71] = handleFocusChildPath, $[72] = handleOpenField, $[73] = handleSelectFieldGroup, $[74] = member.field.__unstable_computeDiff, $[75] = member.field.changed, $[76] = member.field.compareValue, $[77] = member.field.focusPath, $[78] = member.field.focused, $[79] = member.field.groups, $[80] = member.field.hasUpstreamVersion, $[81] = member.field.id, $[82] = member.field.level, $[83] = member.field.members, $[84] = member.field.path, $[85] = member.field.presence, $[86] = member.field.readOnly, $[87] = member.field.schemaType, $[88] = member.field.validation, $[89] = member.field.value, $[90] = renderAnnotation, $[91] = renderBlock2, $[92] = renderField, $[93] = renderInlineBlock, $[94] = renderInput, $[95] = renderItem2, $[96] = renderPreview, $[97] = t23, $[98] = t24) : t24 = $[98];
  const inputProps = t24, t25 = inputProps;
  let t26;
  $[99] !== inputProps || $[100] !== renderInput ? (t26 = /* @__PURE__ */ jsx(RenderInput$1, { ...inputProps, render: renderInput }), $[99] = inputProps, $[100] = renderInput, $[101] = t26) : t26 = $[101];
  let t27;
  $[102] !== fieldActions || $[103] !== handleClose || $[104] !== handleCollapse || $[105] !== handleExpand || $[106] !== handleOpen || $[107] !== member.collapsed || $[108] !== member.collapsible || $[109] !== member.field.changed || $[110] !== member.field.id || $[111] !== member.field.level || $[112] !== member.field.path || $[113] !== member.field.presence || $[114] !== member.field.schemaType || $[115] !== member.field.validation || $[116] !== member.field.value || $[117] !== member.index || $[118] !== member.name || $[119] !== member.open || $[120] !== renderField || $[121] !== t25 || $[122] !== t26 ? (t27 = /* @__PURE__ */ jsx(RenderField$1, { actions: fieldActions, name: member.name, index: member.index, level: member.field.level, value: member.field.value, validation: member.field.validation, presence: member.field.presence, title: member.field.schemaType.title, description: member.field.schemaType.description, collapsible: member.collapsible, collapsed: member.collapsed, onCollapse: handleCollapse, onExpand: handleExpand, open: member.open, changed: member.field.changed, onOpen: handleOpen, onClose: handleClose, schemaType: member.field.schemaType, inputId: member.field.id, path: member.field.path, inputProps: t25, render: renderField, children: t26 }), $[102] = fieldActions, $[103] = handleClose, $[104] = handleCollapse, $[105] = handleExpand, $[106] = handleOpen, $[107] = member.collapsed, $[108] = member.collapsible, $[109] = member.field.changed, $[110] = member.field.id, $[111] = member.field.level, $[112] = member.field.path, $[113] = member.field.presence, $[114] = member.field.schemaType, $[115] = member.field.validation, $[116] = member.field.value, $[117] = member.index, $[118] = member.name, $[119] = member.open, $[120] = renderField, $[121] = t25, $[122] = t26, $[123] = t27) : t27 = $[123];
  let t28;
  return $[124] !== handleChange || $[125] !== onFieldGroupSelect || $[126] !== onPathBlur || $[127] !== onPathFocus || $[128] !== onPathOpen || $[129] !== onSetFieldSetCollapsed || $[130] !== onSetPathCollapsed || $[131] !== t27 ? (t28 = /* @__PURE__ */ jsx(FormCallbacksProvider, { onFieldGroupSelect, onChange: handleChange, onSetFieldSetCollapsed, onPathOpen, onSetPathCollapsed, onPathBlur, onPathFocus, children: t27 }), $[124] = handleChange, $[125] = onFieldGroupSelect, $[126] = onPathBlur, $[127] = onPathFocus, $[128] = onPathOpen, $[129] = onSetFieldSetCollapsed, $[130] = onSetPathCollapsed, $[131] = t27, $[132] = t28) : t28 = $[132], t28;
};
function RenderInput$1({
  render: render2,
  ...props2
}) {
  return render2(props2);
}
function RenderField$1({
  render: render2,
  ...props2
}) {
  return render2(props2);
}
function PrimitiveField(props2) {
  const $ = c(77), {
    member,
    renderInput,
    renderField
  } = props2, fieldActions = useDocumentFieldActions(), focusRef = useRef(void 0), [localValue, setLocalValue] = useState(), {
    onPathBlur,
    onPathFocus,
    onChange
  } = useFormCallbacks();
  let t0, t1;
  $[0] !== member.field.focused ? (t0 = () => {
    member.field.focused && focusRef.current?.focus();
  }, t1 = [member.field.focused], $[0] = member.field.focused, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  $[3] !== member.field.path || $[4] !== onPathBlur ? (t2 = () => {
    onPathBlur(member.field.path);
  }, $[3] = member.field.path, $[4] = onPathBlur, $[5] = t2) : t2 = $[5];
  const handleBlur = t2;
  let t3;
  $[6] !== member.field.path || $[7] !== onPathFocus ? (t3 = () => {
    onPathFocus(member.field.path);
  }, $[6] = member.field.path, $[7] = onPathFocus, $[8] = t3) : t3 = $[8];
  const handleFocus = t3;
  let t4;
  $[9] !== member.name || $[10] !== onChange ? (t4 = (event) => {
    onChange(PatchEvent.from(event).prefixAll(member.name));
  }, $[9] = member.name, $[10] = onChange, $[11] = t4) : t4 = $[11];
  const handleChange = t4;
  let t5;
  $[12] !== member.field.schemaType || $[13] !== member.name || $[14] !== onChange ? (t5 = (event_0) => {
    let inputValue = event_0.currentTarget.value;
    if (isNumberSchemaType(member.field.schemaType)) {
      if (inputValue = event_0.currentTarget.valueAsNumber, inputValue > Number.MAX_SAFE_INTEGER || inputValue < Number.MIN_SAFE_INTEGER)
        return;
    } else
      isBooleanSchemaType(member.field.schemaType) && (inputValue = event_0.currentTarget.checked);
    const hasEmptyValue = inputValue === "" || typeof inputValue == "number" && isNaN(inputValue);
    isNumberSchemaType(member.field.schemaType) && setLocalValue(hasEmptyValue ? void 0 : event_0.currentTarget.value), onChange(PatchEvent.from(hasEmptyValue ? unset() : set(inputValue)).prefixAll(member.name));
  }, $[12] = member.field.schemaType, $[13] = member.name, $[14] = onChange, $[15] = t5) : t5 = $[15];
  const handleNativeChange = t5, t6 = member.field.id;
  let t7;
  $[16] !== localValue || $[17] !== member.field.schemaType || $[18] !== member.field.value ? (t7 = resolveNativeNumberInputValue(member.field.schemaType, member.field.value, localValue), $[16] = localValue, $[17] = member.field.schemaType, $[18] = member.field.value, $[19] = t7) : t7 = $[19];
  const t8 = !!member.field.readOnly, t9 = member.field.schemaType.placeholder;
  let t10;
  $[20] !== member.field.id || $[21] !== member.field.schemaType.description ? (t10 = createDescriptionId(member.field.id, member.field.schemaType.description), $[20] = member.field.id, $[21] = member.field.schemaType.description, $[22] = t10) : t10 = $[22];
  let t11;
  $[23] !== member.field.path ? (t11 = pathToAnchorIdent("input", member.field.path), $[23] = member.field.path, $[24] = t11) : t11 = $[24];
  let t12;
  $[25] !== t11 ? (t12 = {
    anchorName: t11
  }, $[25] = t11, $[26] = t12) : t12 = $[26];
  let t13;
  $[27] !== handleBlur || $[28] !== handleFocus || $[29] !== handleNativeChange || $[30] !== member.field.id || $[31] !== member.field.schemaType.placeholder || $[32] !== t10 || $[33] !== t12 || $[34] !== t7 || $[35] !== t8 ? (t13 = {
    onBlur: handleBlur,
    onFocus: handleFocus,
    id: t6,
    ref: focusRef,
    onChange: handleNativeChange,
    value: t7,
    readOnly: t8,
    placeholder: t9,
    "aria-describedby": t10,
    style: t12
  }, $[27] = handleBlur, $[28] = handleFocus, $[29] = handleNativeChange, $[30] = member.field.id, $[31] = member.field.schemaType.placeholder, $[32] = t10, $[33] = t12, $[34] = t7, $[35] = t8, $[36] = t13) : t13 = $[36];
  const elementProps = t13;
  let t14;
  $[37] !== member.field.validation ? (t14 = member.field.validation.filter(_temp$3q).map(_temp2$1s).join(`
`) || void 0, $[37] = member.field.validation, $[38] = t14) : t14 = $[38];
  const validationError = t14, t15 = member.field.value, t16 = member.field.schemaType, t17 = member.field.displayInlineChanges ?? !1;
  let t18;
  $[39] !== elementProps || $[40] !== handleChange || $[41] !== member.field.__unstable_computeDiff || $[42] !== member.field.changed || $[43] !== member.field.compareValue || $[44] !== member.field.focused || $[45] !== member.field.hasUpstreamVersion || $[46] !== member.field.id || $[47] !== member.field.level || $[48] !== member.field.path || $[49] !== member.field.presence || $[50] !== member.field.readOnly || $[51] !== member.field.validation || $[52] !== t15 || $[53] !== t16 || $[54] !== t17 || $[55] !== validationError ? (t18 = {
    value: t15,
    compareValue: member.field.compareValue,
    __unstable_computeDiff: member.field.__unstable_computeDiff,
    readOnly: member.field.readOnly,
    schemaType: t16,
    changed: member.field.changed,
    hasUpstreamVersion: member.field.hasUpstreamVersion,
    id: member.field.id,
    path: member.field.path,
    focused: member.field.focused,
    level: member.field.level,
    onChange: handleChange,
    validation: member.field.validation,
    presence: member.field.presence,
    validationError,
    elementProps,
    displayInlineChanges: t17
  }, $[39] = elementProps, $[40] = handleChange, $[41] = member.field.__unstable_computeDiff, $[42] = member.field.changed, $[43] = member.field.compareValue, $[44] = member.field.focused, $[45] = member.field.hasUpstreamVersion, $[46] = member.field.id, $[47] = member.field.level, $[48] = member.field.path, $[49] = member.field.presence, $[50] = member.field.readOnly, $[51] = member.field.validation, $[52] = t15, $[53] = t16, $[54] = t17, $[55] = validationError, $[56] = t18) : t18 = $[56];
  const inputProps = t18, t19 = inputProps, t20 = member.field.schemaType, t21 = member.field.value;
  let t22;
  $[57] !== inputProps || $[58] !== renderInput ? (t22 = /* @__PURE__ */ jsx(RenderInput, { ...inputProps, render: renderInput }), $[57] = inputProps, $[58] = renderInput, $[59] = t22) : t22 = $[59];
  let t23;
  return $[60] !== fieldActions || $[61] !== member.field.changed || $[62] !== member.field.id || $[63] !== member.field.level || $[64] !== member.field.path || $[65] !== member.field.presence || $[66] !== member.field.schemaType.description || $[67] !== member.field.schemaType.title || $[68] !== member.field.validation || $[69] !== member.index || $[70] !== member.name || $[71] !== renderField || $[72] !== t19 || $[73] !== t20 || $[74] !== t21 || $[75] !== t22 ? (t23 = /* @__PURE__ */ jsx(RenderField, { actions: fieldActions, changed: member.field.changed, description: member.field.schemaType.description, index: member.index, inputId: member.field.id, inputProps: t19, level: member.field.level, name: member.name, path: member.field.path, presence: member.field.presence, schemaType: t20, title: member.field.schemaType.title, validation: member.field.validation, value: t21, render: renderField, children: t22 }), $[60] = fieldActions, $[61] = member.field.changed, $[62] = member.field.id, $[63] = member.field.level, $[64] = member.field.path, $[65] = member.field.presence, $[66] = member.field.schemaType.description, $[67] = member.field.schemaType.title, $[68] = member.field.validation, $[69] = member.index, $[70] = member.name, $[71] = renderField, $[72] = t19, $[73] = t20, $[74] = t21, $[75] = t22, $[76] = t23) : t23 = $[76], t23;
}
function _temp2$1s(item_0) {
  return item_0.message;
}
function _temp$3q(item) {
  return item.level === "error";
}
function RenderInput({
  render: render2,
  ...props2
}) {
  return render2(props2);
}
function RenderField({
  render: render2,
  ...props2
}) {
  return render2(props2);
}
const MemberField = memo(function(props2) {
  const $ = c(31), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2;
  if (isMemberObject(member)) {
    let t0;
    return $[0] !== member || $[1] !== renderAnnotation || $[2] !== renderBlock2 || $[3] !== renderField || $[4] !== renderInlineBlock || $[5] !== renderInput || $[6] !== renderItem2 || $[7] !== renderPreview ? (t0 = /* @__PURE__ */ jsx(ObjectField, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }), $[0] = member, $[1] = renderAnnotation, $[2] = renderBlock2, $[3] = renderField, $[4] = renderInlineBlock, $[5] = renderInput, $[6] = renderItem2, $[7] = renderPreview, $[8] = t0) : t0 = $[8], t0;
  }
  if (isMemberArrayOfPrimitives(member)) {
    const t0 = renderItem2;
    let t1;
    return $[9] !== member || $[10] !== renderAnnotation || $[11] !== renderBlock2 || $[12] !== renderField || $[13] !== renderInlineBlock || $[14] !== renderInput || $[15] !== renderPreview || $[16] !== t0 ? (t1 = /* @__PURE__ */ jsx(ArrayOfPrimitivesField, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInput, renderInlineBlock, renderItem: t0, renderPreview }), $[9] = member, $[10] = renderAnnotation, $[11] = renderBlock2, $[12] = renderField, $[13] = renderInlineBlock, $[14] = renderInput, $[15] = renderPreview, $[16] = t0, $[17] = t1) : t1 = $[17], t1;
  }
  if (isMemberArrayOfObjects(member)) {
    let t0;
    return $[18] !== member || $[19] !== renderAnnotation || $[20] !== renderBlock2 || $[21] !== renderField || $[22] !== renderInlineBlock || $[23] !== renderInput || $[24] !== renderItem2 || $[25] !== renderPreview ? (t0 = /* @__PURE__ */ jsx(ArrayOfObjectsField, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }), $[18] = member, $[19] = renderAnnotation, $[20] = renderBlock2, $[21] = renderField, $[22] = renderInlineBlock, $[23] = renderInput, $[24] = renderItem2, $[25] = renderPreview, $[26] = t0) : t0 = $[26], t0;
  }
  if (isMemberPrimitive(member)) {
    let t0;
    return $[27] !== member || $[28] !== renderField || $[29] !== renderInput ? (t0 = /* @__PURE__ */ jsx(PrimitiveField, { member, renderField, renderInput }), $[27] = member, $[28] = renderField, $[29] = renderInput, $[30] = t0) : t0 = $[30], t0;
  }
  return null;
}), TRUTHY_STRINGS = ["yes", "true", "1"], FALSEY_STRINGS = ["false", "no", "false", "0", "null"], BOOL_STRINGS = TRUTHY_STRINGS.concat(FALSEY_STRINGS), TRUE = () => !0, has = (prop) => (val) => val && val[prop], is = (typeName) => (val) => (val && val._type) === typeName;
function toLocalDate(input) {
  const newDate = new Date(input.getTime() + input.getTimezoneOffset() * 60 * 1e3), offset = input.getTimezoneOffset() / 60, hours = input.getHours();
  return newDate.setHours(hours - offset), newDate;
}
function getTZName() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
  }
  return null;
}
const converters = {
  string: {
    number: {
      test: Number,
      convert: Number
    },
    boolean: {
      test: (value) => BOOL_STRINGS.includes(value.toLowerCase()),
      convert: (value) => TRUTHY_STRINGS.includes(value.toLowerCase()) || !FALSEY_STRINGS.includes(value.toLowerCase())
    },
    richDate: {
      test: (value) => isValid(value),
      convert: (value) => ({
        _type: "richDate",
        local: toLocalDate(new Date(value)).toJSON(),
        utc: new Date(value).toJSON(),
        timezone: getTZName(),
        offset: (/* @__PURE__ */ new Date()).getTimezoneOffset()
      })
    }
  },
  date: {
    richDate: {
      test: is("date"),
      convert: (value) => Object.assign({}, value, {
        _type: "richDate"
      })
    }
  },
  richDate: {
    datetime: {
      test: has("utc"),
      convert: (value) => value.utc
    }
  },
  number: {
    string: {
      test: TRUE,
      convert: String
    },
    boolean: {
      test: TRUE,
      convert: Number
    }
  },
  boolean: {
    string: {
      test: TRUE,
      convert: (value) => value ? "Yes" : "No"
    },
    number: {
      test: TRUE,
      convert: Number
    }
  }
};
function SetMissingTypeButton(t0) {
  const $ = c(13), {
    value,
    targetType,
    onChange
  } = t0;
  let t1;
  $[0] !== targetType || $[1] !== value ? (t1 = {
    ...value,
    _type: targetType
  }, $[0] = targetType, $[1] = value, $[2] = t1) : t1 = $[2];
  const itemValue = t1;
  let t2;
  $[3] !== itemValue || $[4] !== onChange || $[5] !== targetType ? (t2 = () => onChange(PatchEvent.from(setIfMissing(targetType, ["_type"])), itemValue), $[3] = itemValue, $[4] = onChange, $[5] = targetType, $[6] = t2) : t2 = $[6];
  const handleClick = t2, {
    t
  } = useTranslation();
  let t3;
  $[7] !== t || $[8] !== targetType ? (t3 = t("inputs.untyped-value.convert-button.text", {
    targetType
  }), $[7] = t, $[8] = targetType, $[9] = t3) : t3 = $[9];
  let t4;
  return $[10] !== handleClick || $[11] !== t3 ? (t4 = /* @__PURE__ */ jsx(Button, { onClick: handleClick, text: t3 }), $[10] = handleClick, $[11] = t3, $[12] = t4) : t4 = $[12], t4;
}
function UnsetItemButton(t0) {
  const $ = c(11), {
    value,
    onChange,
    validTypes
  } = t0;
  let t1;
  $[0] !== validTypes[0] || $[1] !== value ? (t1 = {
    ...value,
    _type: validTypes[0]
  }, $[0] = validTypes[0], $[1] = value, $[2] = t1) : t1 = $[2];
  const itemValue = t1;
  let t2;
  $[3] !== itemValue || $[4] !== onChange ? (t2 = () => onChange(PatchEvent.from(unset()), itemValue), $[3] = itemValue, $[4] = onChange, $[5] = t2) : t2 = $[5];
  const handleClick = t2, {
    t
  } = useTranslation();
  let t3;
  $[6] !== t ? (t3 = t("inputs.untyped-value.unset-item-button.text"), $[6] = t, $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== handleClick || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(Button, { onClick: handleClick, tone: "critical", text: t3 }), $[8] = handleClick, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
}
function UntypedValueInput(t0) {
  const $ = c(56), {
    validTypes,
    value,
    onChange
  } = t0, schema2 = useSchema(), isSingleValidType = validTypes.length === 1;
  let t1;
  $[0] !== schema2 || $[1] !== validTypes[0] ? (t1 = schema2.has(validTypes[0]), $[0] = schema2, $[1] = validTypes[0], $[2] = t1) : t1 = $[2];
  const isHoistedType = t1, {
    t
  } = useTranslation();
  let t2;
  $[3] !== t ? (t2 = /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.untyped-value.title" }) }), $[3] = t, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("inputs.untyped-value.details.title"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t ? (t4 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.untyped-value.description" }) }), $[7] = t, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== isHoistedType || $[10] !== isSingleValidType || $[11] !== t ? (t5 = isSingleValidType && !isHoistedType && /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.untyped-value.details.description" }) }), $[9] = isHoistedType, $[10] = isSingleValidType, $[11] = t, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== isSingleValidType || $[14] !== t ? (t6 = !isSingleValidType && /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t("inputs.untyped-value.details.multi-type-description") }), $[13] = isSingleValidType, $[14] = t, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== isSingleValidType || $[17] !== validTypes ? (t7 = !isSingleValidType && /* @__PURE__ */ jsx(Stack, { as: "ul", space: 2, children: validTypes.map(_temp$3p) }), $[16] = isSingleValidType, $[17] = validTypes, $[18] = t7) : t7 = $[18];
  let t8;
  $[19] !== t ? (t8 = t("inputs.untyped-value.details.json-dump-prefix"), $[19] = t, $[20] = t8) : t8 = $[20];
  let t9;
  $[21] !== t8 ? (t9 = /* @__PURE__ */ jsx(Text$1, { as: "h4", weight: "medium", size: 1, children: t8 }), $[21] = t8, $[22] = t9) : t9 = $[22];
  let t10;
  $[23] !== value ? (t10 = JSON.stringify(value, null, 2), $[23] = value, $[24] = t10) : t10 = $[24];
  let t11;
  $[25] !== t10 ? (t11 = /* @__PURE__ */ jsx(Card, { border: !0, overflow: "auto", padding: 2, radius: 2, tone: "inherit", children: /* @__PURE__ */ jsx(Code, { language: "json", children: t10 }) }), $[25] = t10, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== t11 || $[28] !== t9 ? (t12 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t9,
    t11
  ] }), $[27] = t11, $[28] = t9, $[29] = t12) : t12 = $[29];
  let t13;
  $[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = [1, 2, 2], $[30] = t13) : t13 = $[30];
  let t14;
  $[31] !== isSingleValidType || $[32] !== onChange || $[33] !== validTypes[0] || $[34] !== value ? (t14 = isSingleValidType && /* @__PURE__ */ jsx(SetMissingTypeButton, { onChange, targetType: validTypes[0], value }), $[31] = isSingleValidType, $[32] = onChange, $[33] = validTypes[0], $[34] = value, $[35] = t14) : t14 = $[35];
  let t15;
  $[36] !== onChange || $[37] !== validTypes || $[38] !== value ? (t15 = /* @__PURE__ */ jsx(UnsetItemButton, { onChange, validTypes, value }), $[36] = onChange, $[37] = validTypes, $[38] = value, $[39] = t15) : t15 = $[39];
  let t16;
  $[40] !== t14 || $[41] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Grid, { columns: t13, gap: 1, children: [
    t14,
    t15
  ] }), $[40] = t14, $[41] = t15, $[42] = t16) : t16 = $[42];
  let t17;
  $[43] !== t12 || $[44] !== t16 || $[45] !== t4 || $[46] !== t5 || $[47] !== t6 || $[48] !== t7 ? (t17 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t4,
    t5,
    t6,
    t7,
    t12,
    t16
  ] }), $[43] = t12, $[44] = t16, $[45] = t4, $[46] = t5, $[47] = t6, $[48] = t7, $[49] = t17) : t17 = $[49];
  let t18;
  $[50] !== t17 || $[51] !== t3 ? (t18 = /* @__PURE__ */ jsx(Details, { open: isDev, title: t3, children: t17 }), $[50] = t17, $[51] = t3, $[52] = t18) : t18 = $[52];
  let t19;
  return $[53] !== t18 || $[54] !== t2 ? (t19 = /* @__PURE__ */ jsx(Alert, { status: "warning", title: t2, children: t18 }), $[53] = t18, $[54] = t2, $[55] = t19) : t19 = $[55], t19;
}
function _temp$3p(validType) {
  return /* @__PURE__ */ jsx(Text$1, { as: "li", muted: !0, size: 1, children: /* @__PURE__ */ jsx("code", { children: validType }) }, validType);
}
function getConverters(value, actualType, validTypes) {
  return actualType in converters ? Object.keys(converters[actualType]).filter((targetType) => validTypes.includes(targetType)).map((targetType) => ({
    from: actualType,
    to: targetType,
    ...converters[actualType][targetType]
  })).filter((converter) => converter.test(value)) : [];
}
const InvalidValueInput = forwardRef((props2, ref) => {
  const $ = c(68), {
    value,
    actualType,
    validTypes,
    onChange
  } = props2;
  useImperativeHandle(ref, _temp2$1r);
  let t0;
  $[0] !== onChange ? (t0 = () => {
    onChange(PatchEvent.from(unset()));
  }, $[0] = onChange, $[1] = t0) : t0 = $[1];
  const handleClearClick = t0;
  let t1;
  $[2] !== onChange ? (t1 = (converted) => {
    onChange(PatchEvent.from(set(converted)));
  }, $[2] = onChange, $[3] = t1) : t1 = $[3];
  const handleConvertTo = t1;
  let t2;
  $[4] !== actualType || $[5] !== validTypes || $[6] !== value ? (t2 = getConverters(value, actualType, validTypes), $[4] = actualType, $[5] = validTypes, $[6] = value, $[7] = t2) : t2 = $[7];
  const converters2 = t2, {
    t
  } = useTranslation();
  if (isPlainObject$1(value) && !("_type" in value)) {
    const t32 = value;
    let t42;
    return $[8] !== onChange || $[9] !== t32 || $[10] !== validTypes ? (t42 = /* @__PURE__ */ jsx(UntypedValueInput, { value: t32, validTypes, onChange }), $[8] = onChange, $[9] = t32, $[10] = validTypes, $[11] = t42) : t42 = $[11], t42;
  }
  let t3;
  $[12] !== t ? (t3 = t("inputs.invalid-value.reset-button.text"), $[12] = t, $[13] = t3) : t3 = $[13];
  let t4;
  $[14] !== handleClearClick || $[15] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { padding: 2, children: /* @__PURE__ */ jsx(Button, { onClick: handleClearClick, tone: "critical", text: t3 }) }), $[14] = handleClearClick, $[15] = t3, $[16] = t4) : t4 = $[16];
  const suffix = t4;
  let t5;
  $[17] !== t ? (t5 = t("inputs.invalid-value.title"), $[17] = t, $[18] = t5) : t5 = $[18];
  let t6;
  $[19] !== t ? (t6 = t("inputs.invalid-value.description"), $[19] = t, $[20] = t6) : t6 = $[20];
  let t7;
  $[21] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t6 }), $[21] = t6, $[22] = t7) : t7 = $[22];
  let t8;
  $[23] !== t ? (t8 = t("inputs.invalid-value.details.title"), $[23] = t, $[24] = t8) : t8 = $[24];
  let t9;
  $[25] !== t || $[26] !== validTypes[0] || $[27] !== validTypes.length ? (t9 = validTypes.length === 1 && /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.invalid-value.details.description", values: {
    validType: validTypes[0]
  } }) }), $[25] = t, $[26] = validTypes[0], $[27] = validTypes.length, $[28] = t9) : t9 = $[28];
  let t10;
  $[29] !== t || $[30] !== validTypes.length ? (t10 = validTypes.length === 1 && /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t("inputs.invalid-value.details.possible-reason") }), $[29] = t, $[30] = validTypes.length, $[31] = t10) : t10 = $[31];
  let t11;
  $[32] !== t || $[33] !== validTypes.length ? (t11 = validTypes.length !== 1 && /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t("inputs.invalid-value.details.multi-type-description") }), $[32] = t, $[33] = validTypes.length, $[34] = t11) : t11 = $[34];
  let t12;
  $[35] !== validTypes ? (t12 = validTypes.length !== 1 && /* @__PURE__ */ jsx(Stack, { as: "ul", space: 2, children: validTypes.map(_temp3$H) }), $[35] = validTypes, $[36] = t12) : t12 = $[36];
  let t13;
  $[37] !== actualType ? (t13 = {
    actualType
  }, $[37] = actualType, $[38] = t13) : t13 = $[38];
  let t14;
  $[39] !== t || $[40] !== t13 ? (t14 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.invalid-value.current-type", values: t13 }) }), $[39] = t, $[40] = t13, $[41] = t14) : t14 = $[41];
  let t15;
  $[42] !== value ? (t15 = JSON.stringify(value, null, 2), $[42] = value, $[43] = t15) : t15 = $[43];
  let t16;
  $[44] !== t15 ? (t16 = /* @__PURE__ */ jsx(Card, { border: !0, padding: 2, radius: 2, tone: "inherit", children: /* @__PURE__ */ jsx(Code, { language: "json", size: 1, children: t15 }) }), $[44] = t15, $[45] = t16) : t16 = $[45];
  let t17;
  $[46] !== t14 || $[47] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Stack, { marginTop: 2, space: 2, children: [
    t14,
    t16
  ] }), $[46] = t14, $[47] = t16, $[48] = t17) : t17 = $[48];
  let t18;
  $[49] !== converters2 || $[50] !== handleConvertTo || $[51] !== value ? (t18 = converters2.length > 0 && /* @__PURE__ */ jsx(Stack, { space: 1, children: converters2.map((converter) => /* @__PURE__ */ jsx(ConvertButton, { converter, onConvert: handleConvertTo, value }, `${converter.from}-${converter.to}`)) }), $[49] = converters2, $[50] = handleConvertTo, $[51] = value, $[52] = t18) : t18 = $[52];
  let t19;
  $[53] !== t10 || $[54] !== t11 || $[55] !== t12 || $[56] !== t17 || $[57] !== t18 || $[58] !== t9 ? (t19 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t9,
    t10,
    t11,
    t12,
    t17,
    t18
  ] }), $[53] = t10, $[54] = t11, $[55] = t12, $[56] = t17, $[57] = t18, $[58] = t9, $[59] = t19) : t19 = $[59];
  let t20;
  $[60] !== t19 || $[61] !== t8 ? (t20 = /* @__PURE__ */ jsx(Details, { marginTop: 4, open: isDev, title: t8, children: t19 }), $[60] = t19, $[61] = t8, $[62] = t20) : t20 = $[62];
  let t21;
  return $[63] !== suffix || $[64] !== t20 || $[65] !== t5 || $[66] !== t7 ? (t21 = /* @__PURE__ */ jsxs(Alert, { status: "error", suffix, title: t5, children: [
    t7,
    t20
  ] }), $[63] = suffix, $[64] = t20, $[65] = t5, $[66] = t7, $[67] = t21) : t21 = $[67], t21;
});
InvalidValueInput.displayName = "ForwardRef(InvalidValueInput)";
function ConvertButton(t0) {
  const $ = c(10), {
    converter,
    onConvert,
    value
  } = t0;
  let t1;
  $[0] !== converter || $[1] !== onConvert || $[2] !== value ? (t1 = () => onConvert(converter.convert(value)), $[0] = converter, $[1] = onConvert, $[2] = value, $[3] = t1) : t1 = $[3];
  const handleClick = t1, {
    t
  } = useTranslation();
  let t2;
  $[4] !== converter.to || $[5] !== t ? (t2 = t("inputs.invalid-value.convert-button.text", {
    targetType: converter.to
  }), $[4] = converter.to, $[5] = t, $[6] = t2) : t2 = $[6];
  let t3;
  return $[7] !== handleClick || $[8] !== t2 ? (t3 = /* @__PURE__ */ jsx(Button, { onClick: handleClick, text: t2 }), $[7] = handleClick, $[8] = t2, $[9] = t3) : t3 = $[9], t3;
}
function _temp$3o() {
}
function _temp2$1r() {
  return {
    focus: _temp$3o
  };
}
function _temp3$H(validType) {
  return /* @__PURE__ */ jsx(Text$1, { as: "li", children: /* @__PURE__ */ jsx("code", { children: validType }) }, validType);
}
const FormCell = styled.div.withConfig({
  displayName: "FormCell",
  componentId: "sc-1x7qlg2-0"
})`grid-area:${({
  $area
}) => $area};`, areas = ["gutterStart", "body", "gutterEnd"], FormRow = (t0) => {
  const $ = c(7), {
    children,
    gutterStartCell
  } = t0;
  let t1;
  $[0] !== gutterStartCell ? (t1 = gutterStartCell && /* @__PURE__ */ jsx(FormCell, { $area: "gutterStart", children: gutterStartCell }), $[0] = gutterStartCell, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== children ? (t2 = /* @__PURE__ */ jsx(FormCell, { $area: "body", children }), $[2] = children, $[3] = t2) : t2 = $[3];
  let t3;
  return $[4] !== t1 || $[5] !== t2 ? (t3 = /* @__PURE__ */ jsxs(FormRowContainer, { children: [
    t1,
    t2
  ] }), $[4] = t1, $[5] = t2, $[6] = t3) : t3 = $[6], t3;
}, FormRowContainer = styled.div.withConfig({
  displayName: "FormRowContainer",
  componentId: "sc-1oa8gi7-0"
})`display:grid;grid-template-areas:'${areas.join(" ")}';grid-template-columns:var(--formGutterSize,0px) 1fr var(--formGutterSize,0px);gap:var(--formGutterGap,0px);& &{grid-template-columns:var(--formGutterSize,0px) 1fr 0;margin-inline-end:calc(var(--formGutterGap,0px) * -1);}`, MAX_AVATARS_DOCK = 3, DEFAULT_MAX_AVATARS_FIELDS = 3, AVATAR_DISTANCE = -4, AVATAR_SIZE = 25, AVATAR_ARROW_HEIGHT = 4, INTERSECTION_THRESHOLDS = [0, 0.25, 0.75, 1], INTERSECTION_ELEMENT_PADDING = 23, SNAP_TO_DOCK_DISTANCE_TOP = 8, SNAP_TO_DOCK_DISTANCE_BOTTOM = 8, SLIDE_RIGHT_THRESHOLD_TOP = 20, SLIDE_RIGHT_THRESHOLD_BOTTOM = 20, DEBUG$1 = !1, splitRight = (array, max2) => {
  const indexFromMax = array.length > max2 ? max2 - 1 : max2, idx = Math.max(0, array.length - indexFromMax);
  return [array.slice(0, idx), array.slice(idx)];
};
function calcAvatarStackWidth(len) {
  return -AVATAR_DISTANCE + (AVATAR_SIZE + AVATAR_DISTANCE) * len;
}
const Root$x = /* @__PURE__ */ styled(Flex).withConfig({
  displayName: "Root",
  componentId: "sc-1wgeujr-0"
})(({
  theme,
  $floatingCardWidth,
  $slotWidth,
  $floatingCardVisible
}) => {
  const {
    space
  } = theme.sanity;
  return css`
    /* Prevent buttons from taking up extra vertical space */
    line-height: 1;
    width: 100%;
    /* For floating actions menu */
    position: relative;

    [data-ui='PresenceBox'] {
      position: absolute;
      bottom: 0;
      right: ${$slotWidth + $floatingCardWidth + space[1]}px;
    }
    @media (hover: hover) {
      // If hover is supported, we hide the floating card by default, so only add space for it when it's visible.
      [data-ui='PresenceBox'] {
        position: absolute;
        bottom: 0;
        right: ${$slotWidth + ($floatingCardVisible ? $floatingCardWidth : 0) + space[1]}px;
      }
    }
  `;
}), ContentBox = /* @__PURE__ */ styled(Box).withConfig({
  displayName: "ContentBox",
  componentId: "sc-1wgeujr-1"
})(({
  theme,
  $presenceMaxWidth
}) => {
  const {
    space
  } = theme.sanity;
  return css`
    max-width: calc(100% - ${$presenceMaxWidth + space[1]}px);
    min-width: 75%;
  `;
}), SlotBox = /* @__PURE__ */ styled(Box).withConfig({
  displayName: "SlotBox",
  componentId: "sc-1wgeujr-2"
})(({
  theme,
  $right,
  $fieldActionsVisible
}) => {
  const {
    space
  } = theme.sanity, right = $fieldActionsVisible ? $right + space[1] : $right;
  return css`
    position: absolute;
    bottom: 0;
    right: ${right}px;
  `;
}), FieldActionsFloatingCard = styled(Card).withConfig({
  displayName: "FieldActionsFloatingCard",
  componentId: "sc-1wgeujr-3"
})`align-items:center;bottom:0;position:absolute;right:0;transition:opacity 150ms ease;line-height:1;@media (hover:hover){opacity:0;pointer-events:none;[data-ui='FieldActionsFlex']{opacity:0;}&[data-actions-visible='false']:not(:focus-within){box-shadow:none;background:transparent;}&[data-has-comments='true']:not([data-has-actions='true']){box-shadow:none;}&:focus-within{opacity:1;pointer-events:auto;width:max-content;[data-ui='FieldActionsFlex']{opacity:1;pointer-events:auto;width:max-content;}}}&[data-visible='true']{opacity:1;pointer-events:auto;width:max-content;}&[data-actions-visible='true']{[data-ui='FieldActionsFlex']{opacity:1;pointer-events:auto;width:max-content;}}`, FieldActionsFlex = styled(Flex).withConfig({
  displayName: "FieldActionsFlex",
  componentId: "sc-1wgeujr-4"
})`gap:inherit;transition:opacity 150ms ease;`, MAX_AVATARS = 4;
function FormFieldBaseHeader(props2) {
  const $ = c(44), {
    __internal_comments: comments2,
    __internal_slot: slot,
    actions,
    content,
    fieldFocused,
    fieldHovered,
    presence,
    inputId
  } = props2, [focused, setFocused] = useState(!1), [menuOpen, setMenuOpen] = useState(!1), [floatingCardElement, setFloatingCardElement] = useState(null), [floatingCardWidth, setFloatingCardWidth] = useState(0), [slotElement, setSlotElement] = useState(null), [slotWidth, setSlotWidth] = useState(0);
  let t0;
  $[0] !== comments2 ? (t0 = comments2 || {}, $[0] = comments2, $[1] = t0) : t0 = $[1];
  const {
    hasComments: t1,
    button: t2,
    isAddingComment: t3
  } = t0, hasComments = t1 === void 0 ? !1 : t1, commentButton = t2 === void 0 ? null : t2, isAddingComment = t3 === void 0 ? !1 : t3, hasActions = actions && actions.length > 0, showFieldActions = fieldFocused || fieldHovered || menuOpen || isAddingComment, hasCommentsButtonOrActions = comments2?.button || hasActions, shouldShowFloatingCard = focused || showFieldActions || hasComments;
  let t4;
  $[2] !== floatingCardElement ? (t4 = () => {
    if (floatingCardElement) {
      const {
        width
      } = floatingCardElement.getBoundingClientRect();
      setFloatingCardWidth(width || 0);
    }
  }, $[2] = floatingCardElement, $[3] = t4) : t4 = $[3];
  const handleSetFloatingCardElementWidth = t4;
  let t5;
  $[4] !== handleSetFloatingCardElementWidth ? (t5 = () => {
    handleSetFloatingCardElementWidth(), setFocused(!0);
  }, $[4] = handleSetFloatingCardElementWidth, $[5] = t5) : t5 = $[5];
  const handleFocusCapture = t5;
  let t6;
  $[6] !== handleSetFloatingCardElementWidth ? (t6 = () => {
    handleSetFloatingCardElementWidth(), setFocused(!1);
  }, $[6] = handleSetFloatingCardElementWidth, $[7] = t6) : t6 = $[7];
  const handleBlurCapture = t6;
  let t7;
  $[8] !== handleSetFloatingCardElementWidth ? (t7 = () => {
    handleSetFloatingCardElementWidth();
  }, $[8] = handleSetFloatingCardElementWidth, $[9] = t7) : t7 = $[9];
  let t8;
  $[10] !== handleSetFloatingCardElementWidth || $[11] !== showFieldActions ? (t8 = [handleSetFloatingCardElementWidth, showFieldActions], $[10] = handleSetFloatingCardElementWidth, $[11] = showFieldActions, $[12] = t8) : t8 = $[12], useEffect(t7, t8);
  let t10, t9;
  $[13] !== slotElement ? (t9 = () => {
    if (slotElement) {
      const {
        width: width_0
      } = slotElement.getBoundingClientRect();
      setSlotWidth(width_0 || 0);
    }
  }, t10 = [slotElement], $[13] = slotElement, $[14] = t10, $[15] = t9) : (t10 = $[14], t9 = $[15]), useEffect(t9, t10);
  let t11;
  bb0: {
    if (!slot) {
      t11 = null;
      break bb0;
    }
    const t122 = !!showFieldActions;
    let t132;
    $[16] !== floatingCardWidth || $[17] !== slot || $[18] !== t122 ? (t132 = /* @__PURE__ */ jsx(SlotBox, { $fieldActionsVisible: t122, $right: floatingCardWidth, ref: setSlotElement, children: slot }), $[16] = floatingCardWidth, $[17] = slot, $[18] = t122, $[19] = t132) : t132 = $[19], t11 = t132;
  }
  const slotEl = t11;
  let t12;
  $[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = calcAvatarStackWidth(MAX_AVATARS), $[20] = t12) : t12 = $[20];
  let t13;
  $[21] !== content ? (t13 = /* @__PURE__ */ jsx(ContentBox, { "data-ui": "fieldHeaderContentBox", flex: 1, paddingY: 2, $presenceMaxWidth: t12, children: content }), $[21] = content, $[22] = t13) : t13 = $[22];
  let t14;
  $[23] !== presence ? (t14 = presence && presence.length > 0 && /* @__PURE__ */ jsx(Box, { "data-ui": "PresenceBox", flex: "none", children: /* @__PURE__ */ jsx(FieldPresence, { maxAvatars: MAX_AVATARS, presence }) }), $[23] = presence, $[24] = t14) : t14 = $[24];
  let t15;
  $[25] !== actions || $[26] !== commentButton || $[27] !== handleBlurCapture || $[28] !== handleFocusCapture || $[29] !== hasActions || $[30] !== hasComments || $[31] !== hasCommentsButtonOrActions || $[32] !== inputId || $[33] !== shouldShowFloatingCard || $[34] !== showFieldActions ? (t15 = (hasCommentsButtonOrActions || hasComments) && /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsxs(FieldActionsFloatingCard, { "data-actions-visible": showFieldActions ? "true" : "false", "data-has-actions": hasActions ? "true" : "false", "data-has-comments": hasComments ? "true" : "false", "data-visible": shouldShowFloatingCard ? "true" : "false", display: "flex", onBlurCapture: handleBlurCapture, onFocusCapture: handleFocusCapture, ref: setFloatingCardElement, sizing: "border", children: [
    hasActions && /* @__PURE__ */ jsx(FieldActionsFlex, { align: "center", "data-ui": "FieldActionsFlex", "data-testid": inputId ? `field-actions-menu-${inputId}` : "field-actions-menu", children: /* @__PURE__ */ jsx(FieldActionMenu, { nodes: actions, onMenuOpenChange: setMenuOpen }) }),
    commentButton
  ] }) }), $[25] = actions, $[26] = commentButton, $[27] = handleBlurCapture, $[28] = handleFocusCapture, $[29] = hasActions, $[30] = hasComments, $[31] = hasCommentsButtonOrActions, $[32] = inputId, $[33] = shouldShowFloatingCard, $[34] = showFieldActions, $[35] = t15) : t15 = $[35];
  let t16;
  return $[36] !== floatingCardWidth || $[37] !== shouldShowFloatingCard || $[38] !== slotEl || $[39] !== slotWidth || $[40] !== t13 || $[41] !== t14 || $[42] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Root$x, { align: "flex-end", justify: "space-between", $floatingCardVisible: shouldShowFloatingCard, $floatingCardWidth: floatingCardWidth, $slotWidth: slotWidth, children: [
    t13,
    t14,
    slotEl,
    t15
  ] }), $[36] = floatingCardWidth, $[37] = shouldShowFloatingCard, $[38] = slotEl, $[39] = slotWidth, $[40] = t13, $[41] = t14, $[42] = t15, $[43] = t16) : t16 = $[43], t16;
}
const StyledErrorOutlineIcon = styled(ErrorOutlineIcon).withConfig({
  displayName: "StyledErrorOutlineIcon",
  componentId: "sc-1a7rwoy-0"
})`--card-icon-color:var(--card-badge-critical-icon-color);`;
function ValidationErrorIcon() {
  const $ = c(4), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("form.validation.has-error-aria-label"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(StyledErrorOutlineIcon, { "data-testid": "input-validation-icon-error", "aria-label": t0, "aria-hidden": !0, role: "presentation" }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}
const StyledWarningOutlineIcon = styled(WarningOutlineIcon).withConfig({
  displayName: "StyledWarningOutlineIcon",
  componentId: "sc-1a7rwoy-1"
})`--card-icon-color:var(--card-badge-caution-icon-color);`;
function ValidationWarningIcon() {
  const $ = c(4), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("form.validation.has-warning-aria-label"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(StyledWarningOutlineIcon, { "data-testid": "input-validation-icon-warning", "aria-label": t0, "aria-hidden": !0, role: "presentation" }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}
const StyledInfoOutlineIcon = styled(InfoOutlineIcon).withConfig({
  displayName: "StyledInfoOutlineIcon",
  componentId: "sc-1a7rwoy-2"
})`--card-icon-color:var(--card-badge-primary-icon-color);`;
function ValidationInfoIcon() {
  const $ = c(4), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("form.validation.has-info-aria-label"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(StyledInfoOutlineIcon, { "data-testid": "input-validation-icon-info", "aria-label": t0, "aria-hidden": !0, role: "presentation" }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}
const VALIDATION_ICONS = {
  error: ValidationErrorIcon,
  warning: ValidationWarningIcon,
  info: ValidationInfoIcon
}, StatusIcon = (t0) => {
  const $ = c(2), {
    status
  } = t0, Icon2 = VALIDATION_ICONS[status];
  if (!Icon2)
    return null;
  let t1;
  return $[0] !== Icon2 ? (t1 = /* @__PURE__ */ jsx(Icon2, {}), $[0] = Icon2, $[1] = t1) : t1 = $[1], t1;
}, StatusIconWrapper = styled.div.withConfig({
  displayName: "StatusIconWrapper",
  componentId: "sc-1hlgdyt-0"
})`left:8px;position:relative;width:25px;`, EMPTY_ARRAY$t = [], StyledStack = styled(Stack).withConfig({
  displayName: "StyledStack",
  componentId: "sc-1hlgdyt-1"
})`max-width:200px;`;
function FormFieldValidationStatus(props2) {
  const $ = c(19), {
    validation: t0,
    __unstable_showSummary: showSummary,
    fontSize,
    placement
  } = props2, validation2 = t0 === void 0 ? EMPTY_ARRAY$t : t0, hasErrors = validation2.some(_temp$3n), hasWarnings = validation2.some(_temp2$1q), status = hasErrors ? "error" : hasWarnings ? "warning" : "info";
  let t1;
  $[0] !== showSummary || $[1] !== validation2 ? (t1 = showSummary && /* @__PURE__ */ jsx(FormFieldValidationSummary, { validation: validation2 }), $[0] = showSummary, $[1] = validation2, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== showSummary || $[4] !== validation2 ? (t2 = !showSummary && /* @__PURE__ */ jsx(Fragment$1, { children: validation2.map(_temp3$G) }), $[3] = showSummary, $[4] = validation2, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t1 || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsxs(StyledStack, { space: 3, children: [
    t1,
    t2
  ] }), $[6] = t1, $[7] = t2, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = ["bottom", "right", "left"], $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== status ? (t5 = /* @__PURE__ */ jsx(StatusIcon, { status }), $[10] = status, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== fontSize || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(StatusIconWrapper, { children: /* @__PURE__ */ jsx(Text$1, { size: fontSize, weight: "medium", children: t5 }) }), $[12] = fontSize, $[13] = t5, $[14] = t6) : t6 = $[14];
  let t7;
  return $[15] !== placement || $[16] !== t3 || $[17] !== t6 ? (t7 = /* @__PURE__ */ jsx(Tooltip, { content: t3, portal: !0, placement, fallbackPlacements: t4, children: t6 }), $[15] = placement, $[16] = t3, $[17] = t6, $[18] = t7) : t7 = $[18], t7;
}
function _temp3$G(item, itemIndex) {
  return /* @__PURE__ */ jsx(FormFieldValidationStatusItem, { validation: item }, itemIndex);
}
function _temp2$1q(v_0) {
  return v_0.level === "warning";
}
function _temp$3n(v) {
  return v.level === "error";
}
function FormFieldValidationStatusItem(props2) {
  const $ = c(7), {
    validation: validation2
  } = props2;
  let t0;
  $[0] !== validation2.level ? (t0 = /* @__PURE__ */ jsx(Box, { marginRight: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: /* @__PURE__ */ jsx(StatusIcon, { status: validation2.level }) }) }), $[0] = validation2.level, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== validation2.message ? (t1 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: validation2.message }) }), $[2] = validation2.message, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== t0 || $[5] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Flex, { children: [
    t0,
    t1
  ] }), $[4] = t0, $[5] = t1, $[6] = t2) : t2 = $[6], t2;
}
function FormFieldValidationSummary(t0) {
  const $ = c(5), {
    validation: validation2
  } = t0, {
    t
  } = useTranslation(), listFormatter = useListFormat();
  let t1, t2;
  if ($[0] !== listFormatter || $[1] !== t || $[2] !== validation2) {
    t2 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    bb0: {
      const errorCount = validation2.reduce(_temp4$j, 0), warningCount = validation2.reduce(_temp5$b, 0), hasErrors = errorCount > 0, hasWarnings = warningCount > 0;
      if (!hasErrors && !hasWarnings) {
        t2 = null;
        break bb0;
      }
      const errorText = hasErrors && t("form.validation.summary.errors-count", {
        count: errorCount
      }), warningText = hasWarnings && t("form.validation.summary.warnings-count", {
        count: warningCount
      });
      t1 = errorText && warningText ? /* @__PURE__ */ jsx(Text$1, { size: 1, children: listFormatter.format([errorText, warningText]) }) : /* @__PURE__ */ jsx(Text$1, { size: 1, children: errorText || warningText });
    }
    $[0] = listFormatter, $[1] = t, $[2] = validation2, $[3] = t1, $[4] = t2;
  } else
    t1 = $[3], t2 = $[4];
  return t2 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel") ? t2 : t1;
}
function _temp5$b(count_0, item_0) {
  return item_0.level === "warning" ? count_0 + 1 : count_0;
}
function _temp4$j(count2, item) {
  return item.level === "error" ? count2 + 1 : count2;
}
const LabelSuffix = styled(Flex).withConfig({
  displayName: "LabelSuffix",
  componentId: "sc-i3ur06-0"
})`height:0;overflow:visible;`, EMPTY_ARRAY$s = [], FormFieldHeaderText = memo(function(props2) {
  const $ = c(28), {
    description,
    inputId,
    title,
    deprecated,
    validation: t0,
    suffix
  } = props2, validation2 = t0 === void 0 ? EMPTY_ARRAY$s : t0, {
    t
  } = useTranslation(), hasValidations = validation2.length > 0;
  let t1;
  $[0] !== t || $[1] !== title ? (t1 = title || /* @__PURE__ */ jsx("span", { style: {
    color: "var(--card-muted-fg-color)"
  }, children: t("form.field.untitled-field-label") }), $[0] = t, $[1] = title, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== inputId || $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(Text$1, { as: "label", htmlFor: inputId, weight: "medium", size: 1, children: t1 }) }), $[3] = inputId, $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== suffix ? (t3 = suffix && /* @__PURE__ */ jsx(Box, { marginLeft: 2, "data-testid": "form-field-suffix", children: suffix }), $[6] = suffix, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== deprecated || $[9] !== hasValidations || $[10] !== t || $[11] !== title || $[12] !== validation2 ? (t4 = (deprecated || hasValidations) && /* @__PURE__ */ jsxs(LabelSuffix, { align: "center", children: [
    deprecated && /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(Badge, { "data-testid": `deprecated-badge-${title}`, tone: "caution", children: t("form.field.deprecated-label") }) }),
    hasValidations && /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(FormFieldValidationStatus, { "data-testid": "input-validation-icon-error", fontSize: 1, placement: "top", validation: validation2 }) })
  ] }), $[8] = deprecated, $[9] = hasValidations, $[10] = t, $[11] = title, $[12] = validation2, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== t2 || $[15] !== t3 || $[16] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "center", paddingY: 1, children: [
    t2,
    t3,
    t4
  ] }), $[14] = t2, $[15] = t3, $[16] = t4, $[17] = t5) : t5 = $[17];
  let t6;
  $[18] !== deprecated || $[19] !== title ? (t6 = deprecated && /* @__PURE__ */ jsx(TextWithTone, { "data-testid": `deprecated-message-${title}`, tone: "caution", size: 1, children: deprecated.reason }), $[18] = deprecated, $[19] = title, $[20] = t6) : t6 = $[20];
  let t7;
  $[21] !== description || $[22] !== inputId ? (t7 = description && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, id: createDescriptionId(inputId, description), children: description }), $[21] = description, $[22] = inputId, $[23] = t7) : t7 = $[23];
  let t8;
  return $[24] !== t5 || $[25] !== t6 || $[26] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t5,
    t6,
    t7
  ] }), $[24] = t5, $[25] = t6, $[26] = t7, $[27] = t8) : t8 = $[27], t8;
}), EMPTY_ARRAY$r = [], FormField = memo(function(props2) {
  const $ = c(45);
  let children, comments2, deprecated, description, inputId, level, path, readOnly, restProps, t0, t1, t2, title, validation2;
  $[0] !== props2 ? ({
    __unstable_headerActions: t0,
    __unstable_presence: t1,
    __internal_slot: t2,
    __internal_comments: comments2,
    children,
    description,
    inputId,
    level,
    path,
    readOnly,
    title,
    validation: validation2,
    deprecated,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = comments2, $[3] = deprecated, $[4] = description, $[5] = inputId, $[6] = level, $[7] = path, $[8] = readOnly, $[9] = restProps, $[10] = t0, $[11] = t1, $[12] = t2, $[13] = title, $[14] = validation2) : (children = $[1], comments2 = $[2], deprecated = $[3], description = $[4], inputId = $[5], level = $[6], path = $[7], readOnly = $[8], restProps = $[9], t0 = $[10], t1 = $[11], t2 = $[12], title = $[13], validation2 = $[14]);
  const actions = t0 === void 0 ? EMPTY_ARRAY$r : t0, presence = t1 === void 0 ? EMPTY_ARRAY$r : t1, slot = t2 === void 0 ? null : t2, {
    focused,
    hovered,
    onMouseEnter,
    onMouseLeave
  } = useFieldActions();
  let t3;
  $[15] !== path ? (t3 = /* @__PURE__ */ jsx(FormDivergenceIndicator, { path }), $[15] = path, $[16] = t3) : t3 = $[16];
  let t4;
  $[17] !== actions || $[18] !== comments2 || $[19] !== deprecated || $[20] !== description || $[21] !== focused || $[22] !== hovered || $[23] !== inputId || $[24] !== presence || $[25] !== slot || $[26] !== title || $[27] !== validation2 ? (t4 = title && /* @__PURE__ */ jsx(FormFieldBaseHeader, { __internal_comments: comments2, __internal_slot: slot, actions, fieldFocused: !!focused, fieldHovered: hovered, presence, inputId, content: /* @__PURE__ */ jsx(FormFieldHeaderText, { description, inputId, title, validation: validation2, deprecated }) }), $[17] = actions, $[18] = comments2, $[19] = deprecated, $[20] = description, $[21] = focused, $[22] = hovered, $[23] = inputId, $[24] = presence, $[25] = slot, $[26] = title, $[27] = validation2, $[28] = t4) : t4 = $[28];
  let t5;
  $[29] !== children ? (t5 = /* @__PURE__ */ jsx("div", { children }), $[29] = children, $[30] = t5) : t5 = $[30];
  let t6;
  $[31] !== level || $[32] !== onMouseEnter || $[33] !== onMouseLeave || $[34] !== restProps || $[35] !== t4 || $[36] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { ...restProps, "data-level": level, onMouseEnter, onMouseLeave, space: 2, children: [
    t4,
    t5
  ] }), $[31] = level, $[32] = onMouseEnter, $[33] = onMouseLeave, $[34] = restProps, $[35] = t4, $[36] = t5, $[37] = t6) : t6 = $[37];
  let t7;
  $[38] !== t3 || $[39] !== t6 ? (t7 = /* @__PURE__ */ jsx(FormRow, { gutterStartCell: t3, children: t6 }), $[38] = t3, $[39] = t6, $[40] = t7) : t7 = $[40];
  let t8;
  return $[41] !== path || $[42] !== readOnly || $[43] !== t7 ? (t8 = /* @__PURE__ */ jsx(FormNodeDivergenceDetail, { path, readOnly, children: t7 }), $[41] = path, $[42] = readOnly, $[43] = t7, $[44] = t8) : t8 = $[44], t8;
}), DivergenceCollectionIndicator = (t0) => {
  const $ = c(24);
  let divergenceCount, props2, upstreamBundle, upstreamId;
  $[0] !== t0 ? ({
    divergenceCount,
    upstreamId,
    upstreamBundle,
    ...props2
  } = t0, $[0] = t0, $[1] = divergenceCount, $[2] = props2, $[3] = upstreamBundle, $[4] = upstreamId) : (divergenceCount = $[1], props2 = $[2], upstreamBundle = $[3], upstreamId = $[4]);
  const {
    t
  } = useTranslation();
  let t1, t2, t3;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    opacity: 0
  }, t2 = {
    opacity: 0
  }, t3 = {
    opacity: 1
  }, $[5] = t1, $[6] = t2, $[7] = t3) : (t1 = $[5], t2 = $[6], t3 = $[7]);
  const t4 = typeof upstreamBundle == "string" ? upstreamBundle : upstreamBundle?.metadata.title;
  let t5;
  $[8] !== divergenceCount || $[9] !== t || $[10] !== t4 ? (t5 = t("divergence.unresolved-divergence", {
    count: divergenceCount,
    versionName: t4
  }), $[8] = divergenceCount, $[9] = t, $[10] = t4, $[11] = t5) : t5 = $[11];
  const t6 = typeof upstreamBundle == "string" ? upstreamBundle : upstreamBundle?.metadata.title;
  let t7;
  $[12] !== divergenceCount || $[13] !== t || $[14] !== t6 ? (t7 = t("divergence.unresolved-divergence", {
    count: divergenceCount,
    versionName: t6
  }), $[12] = divergenceCount, $[13] = t, $[14] = t6, $[15] = t7) : t7 = $[15];
  const t8 = isPublishedId(upstreamId) ? "positive" : "suggest";
  let t9;
  $[16] !== divergenceCount || $[17] !== props2 || $[18] !== t7 || $[19] !== t8 ? (t9 = /* @__PURE__ */ jsx(Button$1, { ...props2, "aria-label": t7, radius: "full", icon: EditIcon, text: divergenceCount, tone: t8, paddingX: 3, paddingY: 2 }), $[16] = divergenceCount, $[17] = props2, $[18] = t7, $[19] = t8, $[20] = t9) : t9 = $[20];
  let t10;
  return $[21] !== t5 || $[22] !== t9 ? (t10 = /* @__PURE__ */ jsx(motion.div, { initial: t1, exit: t2, animate: t3, children: /* @__PURE__ */ jsx(Tooltip, { content: t5, portal: !0, children: t9 }) }), $[21] = t5, $[22] = t9, $[23] = t10) : t10 = $[23], t10;
}, FormNodeDivergenceCollectionIndicator = (t0) => {
  const $ = c(13), {
    path
  } = t0, divergenceNavigator = useDocumentDivergences();
  let t1;
  $[0] !== divergenceNavigator.state || $[1] !== path ? (t1 = selectDivergenceCount(divergenceNavigator.state, path), $[0] = divergenceNavigator.state, $[1] = path, $[2] = t1) : t1 = $[2];
  const divergenceCount = t1;
  let t2;
  $[3] !== divergenceNavigator.state || $[4] !== path ? (t2 = selectFirstDescendantDivergence(divergenceNavigator.state, path), $[3] = divergenceNavigator.state, $[4] = path, $[5] = t2) : t2 = $[5];
  const firstDescendantDivergence = t2, {
    release: upstreamBundle
  } = useVersionRelease(divergenceNavigator.state.upstreamId ?? "");
  let t3;
  $[6] !== divergenceCount || $[7] !== divergenceNavigator || $[8] !== firstDescendantDivergence || $[9] !== upstreamBundle ? (t3 = typeof divergenceCount < "u" && typeof divergenceNavigator.state.upstreamId < "u" && /* @__PURE__ */ jsx(DivergenceCollectionIndicator, { divergenceCount, upstreamId: divergenceNavigator.state.upstreamId, upstreamBundle, onClick: () => {
    typeof firstDescendantDivergence < "u" && divergenceNavigator.focusDivergence(firstDescendantDivergence.path);
  } }), $[6] = divergenceCount, $[7] = divergenceNavigator, $[8] = firstDescendantDivergence, $[9] = upstreamBundle, $[10] = t3) : t3 = $[10];
  let t4;
  return $[11] !== t3 ? (t4 = /* @__PURE__ */ jsx(AnimatePresence, { children: t3 }), $[11] = t3, $[12] = t4) : t4 = $[12], t4;
}, Root$w = styled.legend.withConfig({
  displayName: "Root",
  componentId: "sc-iz82no-0"
})`padding:0;display:table;`, ToggleButton = /* @__PURE__ */ styled(Flex).attrs({
  forwardedAs: "button"
}).withConfig({
  displayName: "ToggleButton",
  componentId: "sc-iz82no-1"
})((props2) => {
  const {
    theme
  } = props2, {
    focusRing,
    radius
  } = theme.sanity, {
    base
  } = theme.sanity.color;
  return css`
    appearance: none;
    border: 0;
    background: none;
    color: inherit;
    -webkit-font-smoothing: inherit;
    font: inherit;
    outline: none;
    border-radius: ${rem(radius[2])};
    position: relative;

    &:not([hidden]) {
      display: flex;
    }

    &:focus {
      box-shadow: ${focusRingStyle$2({
    base,
    focusRing
  })};
    }

    &:focus:not(:focus-visible) {
      box-shadow: none;
    }

    /* Added to increase the hit area of the collapsible fieldset */
    &::after {
      content: '';
      position: absolute;
      top: -10px;
      right: -10px;
      bottom: -10px;
      left: -10px;
    }
  `;
}), ToggleIconBox = styled(Box).withConfig({
  displayName: "ToggleIconBox",
  componentId: "sc-iz82no-2"
})`width:9px;height:9px;margin-right:3px;& svg{transition:transform 100ms;}`, FormFieldSetLegend = memo(function(props2) {
  const $ = c(10), {
    collapsed,
    collapsible,
    onClick: onClick2,
    title
  } = props2;
  let t0;
  $[0] !== title ? (t0 = /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: title }), $[0] = title, $[1] = t0) : t0 = $[1];
  const text = t0;
  if (!collapsible) {
    let t12;
    return $[2] !== text ? (t12 = /* @__PURE__ */ jsx(Root$w, { children: text }), $[2] = text, $[3] = t12) : t12 = $[3], t12;
  }
  const t1 = `rotate(${collapsed ? "0" : "90deg"}) translate3d(0, 0, 0)`;
  let t2;
  $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(ToggleIconBox, { children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ToggleArrowRightIcon, { style: {
    transform: t1
  } }) }) }), $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== onClick2 || $[7] !== t2 || $[8] !== text ? (t3 = /* @__PURE__ */ jsx(Root$w, { children: /* @__PURE__ */ jsxs(ToggleButton, { type: "button", onClick: onClick2, children: [
    t2,
    text
  ] }) }), $[6] = onClick2, $[7] = t2, $[8] = text, $[9] = t3) : t3 = $[9], t3;
});
function getChildren(children) {
  return typeof children == "function" ? children() : children;
}
const Root$v = styled(Stack).attrs({
  forwardedAs: "fieldset"
}).withConfig({
  displayName: "Root",
  componentId: "sc-1kd7me-0"
})`border:none;body:not(:-moz-handler-blocked) &{display:table-cell;}`, Content$1 = /* @__PURE__ */ styled(Box).withConfig({
  displayName: "Content",
  componentId: "sc-1kd7me-1"
})((props2) => {
  const {
    $borderLeft,
    $focused,
    theme
  } = props2, {
    focusRing
  } = theme.sanity, {
    base
  } = theme.sanity.color;
  return css`
    outline: none;
    border-left: ${$borderLeft ? "1px solid var(--card-border-color)" : void 0};
    transition:
      border-color 0.2s ease-in-out,
      box-shadow 0.2s ease-in-out;

    ${$borderLeft && $focused && `border-left: 1px solid var(--card-focus-ring-color);
    box-shadow: inset 1px 0 0 var(--card-focus-ring-color);`}

    ${$borderLeft && !$focused && `
      box-shadow: inset 0 0 0 transparent;
    `}

    &:focus {
      box-shadow: ${focusRingStyle$2({
    base,
    focusRing: {
      ...focusRing,
      offset: 2
    }
  })};
    }

    &:focus:not(:focus-visible) {
      box-shadow: none;
    }
  `;
}), EMPTY_ARRAY$q = [], FormFieldSet = forwardRef(function(props2, forwardedRef) {
  const $ = c(98);
  let children, collapsed, collapsible, columns, comments2, deprecated, description, inputId, onCollapse, onExpand, onFocus, path, readOnly, restProps, schemaType, t0, t1, t2, t3, t4, tabIndex, title;
  $[0] !== props2 ? ({
    __internal_comments: comments2,
    __internal_slot: t0,
    __unstable_headerActions: t1,
    __unstable_presence: t2,
    children,
    collapsed,
    collapsible,
    columns,
    description,
    level: t3,
    onCollapse,
    onExpand,
    onFocus,
    schemaType,
    tabIndex,
    title,
    validation: t4,
    inputId,
    path,
    deprecated,
    readOnly,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = collapsed, $[3] = collapsible, $[4] = columns, $[5] = comments2, $[6] = deprecated, $[7] = description, $[8] = inputId, $[9] = onCollapse, $[10] = onExpand, $[11] = onFocus, $[12] = path, $[13] = readOnly, $[14] = restProps, $[15] = schemaType, $[16] = t0, $[17] = t1, $[18] = t2, $[19] = t3, $[20] = t4, $[21] = tabIndex, $[22] = title) : (children = $[1], collapsed = $[2], collapsible = $[3], columns = $[4], comments2 = $[5], deprecated = $[6], description = $[7], inputId = $[8], onCollapse = $[9], onExpand = $[10], onFocus = $[11], path = $[12], readOnly = $[13], restProps = $[14], schemaType = $[15], t0 = $[16], t1 = $[17], t2 = $[18], t3 = $[19], t4 = $[20], tabIndex = $[21], title = $[22]);
  const slot = t0 === void 0 ? null : t0, actions = t1 === void 0 ? EMPTY_ARRAY$q : t1, presence = t2 === void 0 ? EMPTY_ARRAY$q : t2, level = t3 === void 0 ? 0 : t3, validation2 = t4 === void 0 ? EMPTY_ARRAY$q : t4, {
    focused,
    hovered,
    onMouseEnter,
    onMouseLeave
  } = useFieldActions(), hasValidationMarkers = validation2.length > 0, ref = useRef(null), {
    t
  } = useTranslation();
  let t5;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => ref.current, $[23] = t5) : t5 = $[23], useImperativeHandle(forwardedRef, t5);
  let t6;
  $[24] !== onFocus ? (t6 = (event) => {
    ref.current === event.target && onFocus && onFocus(event);
  }, $[24] = onFocus, $[25] = t6) : t6 = $[25];
  const handleFocus = t6;
  let t7;
  $[26] !== collapsed || $[27] !== onCollapse || $[28] !== onExpand ? (t7 = () => collapsed ? onExpand?.() : onCollapse?.(), $[26] = collapsed, $[27] = onCollapse, $[28] = onExpand, $[29] = t7) : t7 = $[29];
  const handleToggle = t7;
  let t8;
  bb0: {
    if (collapsed) {
      t8 = null;
      break bb0;
    }
    let t92;
    $[30] !== children ? (t92 = getChildren(children), $[30] = children, $[31] = t92) : t92 = $[31];
    let t102;
    $[32] !== columns || $[33] !== t92 ? (t102 = /* @__PURE__ */ jsx(ColumnarGrid, { columns, gapX: 4, gapY: 5, children: t92 }), $[32] = columns, $[33] = t92, $[34] = t102) : t102 = $[34], t8 = t102;
  }
  const content = t8;
  let t9;
  $[35] !== path ? (t9 = /* @__PURE__ */ jsx(FormDivergenceIndicator, { path }), $[35] = path, $[36] = t9) : t9 = $[36];
  const t10 = !!focused;
  let t11;
  $[37] !== collapsed || $[38] !== collapsible || $[39] !== handleToggle || $[40] !== title ? (t11 = title && /* @__PURE__ */ jsx(FormFieldSetLegend, { collapsed: !!collapsed, collapsible, onClick: collapsible ? handleToggle : void 0, title }), $[37] = collapsed, $[38] = collapsible, $[39] = handleToggle, $[40] = title, $[41] = t11) : t11 = $[41];
  let t12;
  $[42] !== deprecated || $[43] !== t || $[44] !== title ? (t12 = deprecated && /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(Badge, { "data-testid": `deprecated-badge-${title}`, tone: "caution", children: t("form.field.deprecated-label") }) }), $[42] = deprecated, $[43] = t, $[44] = title, $[45] = t12) : t12 = $[45];
  let t13;
  $[46] !== path || $[47] !== schemaType ? (t13 = isArraySchemaType(schemaType) && /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(FormNodeDivergenceCollectionIndicator, { path }) }), $[46] = path, $[47] = schemaType, $[48] = t13) : t13 = $[48];
  let t14;
  $[49] !== hasValidationMarkers || $[50] !== validation2 ? (t14 = hasValidationMarkers && /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(FormFieldValidationStatus, { fontSize: 1, placement: "top", validation: validation2 }) }), $[49] = hasValidationMarkers, $[50] = validation2, $[51] = t14) : t14 = $[51];
  let t15;
  $[52] !== t11 || $[53] !== t12 || $[54] !== t13 || $[55] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t11,
    t12,
    t13,
    t14
  ] }), $[52] = t11, $[53] = t12, $[54] = t13, $[55] = t14, $[56] = t15) : t15 = $[56];
  let t16;
  $[57] !== deprecated || $[58] !== title ? (t16 = deprecated && /* @__PURE__ */ jsx(TextWithTone, { "data-testid": `deprecated-message-${title}`, tone: "caution", size: 1, children: deprecated.reason }), $[57] = deprecated, $[58] = title, $[59] = t16) : t16 = $[59];
  let t17;
  $[60] !== description || $[61] !== inputId ? (t17 = description && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, id: createDescriptionId(inputId, description), children: description }), $[60] = description, $[61] = inputId, $[62] = t17) : t17 = $[62];
  let t18;
  $[63] !== t15 || $[64] !== t16 || $[65] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t15,
    t16,
    t17
  ] }), $[63] = t15, $[64] = t16, $[65] = t17, $[66] = t18) : t18 = $[66];
  let t19;
  $[67] !== actions || $[68] !== comments2 || $[69] !== hovered || $[70] !== inputId || $[71] !== presence || $[72] !== slot || $[73] !== t10 || $[74] !== t18 ? (t19 = /* @__PURE__ */ jsx(FormFieldBaseHeader, { __internal_comments: comments2, __internal_slot: slot, actions, fieldFocused: t10, fieldHovered: hovered, presence, inputId, content: t18 }), $[67] = actions, $[68] = comments2, $[69] = hovered, $[70] = inputId, $[71] = presence, $[72] = slot, $[73] = t10, $[74] = t18, $[75] = t19) : t19 = $[75];
  const t20 = level > 0, t21 = !!focused, t22 = level === 0 ? 0 : 3, t23 = typeof tabIndex == "number" && tabIndex > -1 ? handleFocus : void 0, t24 = !collapsed && content;
  let t25;
  $[76] !== collapsed || $[77] !== t20 || $[78] !== t21 || $[79] !== t22 || $[80] !== t23 || $[81] !== t24 || $[82] !== tabIndex ? (t25 = /* @__PURE__ */ jsx(Content$1, { $borderLeft: t20, $focused: t21, hidden: collapsed, paddingLeft: t22, onFocus: t23, ref, tabIndex, children: t24 }), $[76] = collapsed, $[77] = t20, $[78] = t21, $[79] = t22, $[80] = t23, $[81] = t24, $[82] = tabIndex, $[83] = t25) : t25 = $[83];
  let t26;
  $[84] !== level || $[85] !== onMouseEnter || $[86] !== onMouseLeave || $[87] !== restProps || $[88] !== t19 || $[89] !== t25 ? (t26 = /* @__PURE__ */ jsxs(Root$v, { "data-level": level, ...restProps, onMouseEnter, onMouseLeave, space: 2, children: [
    t19,
    t25
  ] }), $[84] = level, $[85] = onMouseEnter, $[86] = onMouseLeave, $[87] = restProps, $[88] = t19, $[89] = t25, $[90] = t26) : t26 = $[90];
  let t27;
  $[91] !== path || $[92] !== readOnly || $[93] !== t26 ? (t27 = /* @__PURE__ */ jsx(FormNodeDivergenceDetail, { path, readOnly, children: t26 }), $[91] = path, $[92] = readOnly, $[93] = t26, $[94] = t27) : t27 = $[94];
  let t28;
  return $[95] !== t27 || $[96] !== t9 ? (t28 = /* @__PURE__ */ jsx(FormRow, { gutterStartCell: t9, children: t27 }), $[95] = t27, $[96] = t9, $[97] = t28) : t28 = $[97], t28;
}), Root$u = styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1ij3f7x-0"
})`display:flex;justify-content:flex-end;box-sizing:border-box;min-height:var(--avatar-height);width:77px;margin-left:var(--small-padding);&[data-max-avatars='1']{max-width:23px;}&[data-position='top']{align-self:flex-start;}&[data-position='bottom']{align-self:flex-end;}`;
function FormFieldStatus(t0) {
  const $ = c(4), {
    children,
    maxAvatars,
    position: t1
  } = t0, position = t1 === void 0 ? "bottom" : t1;
  let t2;
  return $[0] !== children || $[1] !== maxAvatars || $[2] !== position ? (t2 = /* @__PURE__ */ jsx(Root$u, { "data-max-avatars": maxAvatars, "data-position": position, children }), $[0] = children, $[1] = maxAvatars, $[2] = position, $[3] = t2) : t2 = $[3], t2;
}
function DuplicateKeysAlert(props2) {
  const $ = c(36), {
    error,
    onChange,
    path
  } = props2;
  let t0;
  $[0] !== error.duplicates || $[1] !== onChange ? (t0 = () => {
    onChange(PatchEvent.from((error.duplicates || []).map(_temp$3m)));
  }, $[0] = error.duplicates, $[1] = onChange, $[2] = t0) : t0 = $[2];
  const handleFixDuplicateKeys = t0, {
    t
  } = useTranslation(), t1 = error.schemaType.title, t2 = error.schemaType.description;
  let t3;
  $[3] !== t ? (t3 = t("form.error.duplicate-keys-alert.generate-button.text"), $[3] = t, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== handleFixDuplicateKeys || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { padding: 2, children: /* @__PURE__ */ jsx(Button, { onClick: handleFixDuplicateKeys, text: t3, tone: "caution" }) }), $[5] = handleFixDuplicateKeys, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t ? (t5 = t("form.error.duplicate-keys-alert.title"), $[8] = t, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t ? (t6 = t("form.error.duplicate-keys-alert.summary"), $[10] = t, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t6 }), $[12] = t6, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t ? (t8 = t("form.error.duplicate-keys-alert.details.title"), $[14] = t, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] !== t ? (t9 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "form.error.duplicate-keys-alert.details.description" }) }), $[16] = t, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== t ? (t10 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "form.error.duplicate-keys-alert.details.additional-description" }) }), $[18] = t, $[19] = t10) : t10 = $[19];
  let t11;
  $[20] !== t10 || $[21] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t9,
    t10
  ] }), $[20] = t10, $[21] = t9, $[22] = t11) : t11 = $[22];
  let t12;
  $[23] !== t11 || $[24] !== t8 ? (t12 = /* @__PURE__ */ jsx(Details, { marginTop: 4, open: isDev, title: t8, children: t11 }), $[23] = t11, $[24] = t8, $[25] = t12) : t12 = $[25];
  let t13;
  $[26] !== t12 || $[27] !== t4 || $[28] !== t5 || $[29] !== t7 ? (t13 = /* @__PURE__ */ jsxs(Alert, { status: "warning", suffix: t4, title: t5, children: [
    t7,
    t12
  ] }), $[26] = t12, $[27] = t4, $[28] = t5, $[29] = t7, $[30] = t13) : t13 = $[30];
  let t14;
  return $[31] !== error.schemaType.description || $[32] !== error.schemaType.title || $[33] !== path || $[34] !== t13 ? (t14 = /* @__PURE__ */ jsx(FormField, { title: t1, description: t2, path, children: t13 }), $[31] = error.schemaType.description, $[32] = error.schemaType.title, $[33] = path, $[34] = t13, $[35] = t14) : t14 = $[35], t14;
}
function _temp$3m(t0) {
  const [index, key] = t0;
  return set(`${key}_deduped_${index}`, [index, "_key"]);
}
function MissingKeysAlert(props2) {
  const $ = c(36), {
    error,
    onChange,
    path
  } = props2;
  let t0;
  $[0] !== error.value || $[1] !== onChange ? (t0 = () => {
    onChange(PatchEvent.from((error.value || []).map(_temp$3l)));
  }, $[0] = error.value, $[1] = onChange, $[2] = t0) : t0 = $[2];
  const handleFixMissingKeys = t0, {
    t
  } = useTranslation(), t1 = error.schemaType.title, t2 = error.schemaType.description;
  let t3;
  $[3] !== t ? (t3 = t("form.error.missing-keys-alert.add-button.text"), $[3] = t, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== handleFixMissingKeys || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { padding: 2, children: /* @__PURE__ */ jsx(Button, { onClick: handleFixMissingKeys, text: t3, tone: "caution" }) }), $[5] = handleFixMissingKeys, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t ? (t5 = t("form.error.missing-keys-alert.title"), $[8] = t, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t ? (t6 = t("form.error.missing-keys-alert.summary"), $[10] = t, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t6 }), $[12] = t6, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t ? (t8 = t("form.error.missing-keys-alert.details.title"), $[14] = t, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] !== t ? (t9 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "form.error.missing-keys-alert.details.description" }) }), $[16] = t, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== t ? (t10 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "form.error.missing-keys-alert.details.additional-description" }) }), $[18] = t, $[19] = t10) : t10 = $[19];
  let t11;
  $[20] !== t10 || $[21] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t9,
    t10
  ] }), $[20] = t10, $[21] = t9, $[22] = t11) : t11 = $[22];
  let t12;
  $[23] !== t11 || $[24] !== t8 ? (t12 = /* @__PURE__ */ jsx(Details, { marginTop: 4, open: isDev, title: t8, children: t11 }), $[23] = t11, $[24] = t8, $[25] = t12) : t12 = $[25];
  let t13;
  $[26] !== t12 || $[27] !== t4 || $[28] !== t5 || $[29] !== t7 ? (t13 = /* @__PURE__ */ jsxs(Alert, { status: "warning", suffix: t4, title: t5, children: [
    t7,
    t12
  ] }), $[26] = t12, $[27] = t4, $[28] = t5, $[29] = t7, $[30] = t13) : t13 = $[30];
  let t14;
  return $[31] !== error.schemaType.description || $[32] !== error.schemaType.title || $[33] !== path || $[34] !== t13 ? (t14 = /* @__PURE__ */ jsx(FormField, { title: t1, description: t2, path, children: t13 }), $[31] = error.schemaType.description, $[32] = error.schemaType.title, $[33] = path, $[34] = t13, $[35] = t14) : t14 = $[35], t14;
}
function _temp$3l(val, i) {
  return setIfMissing(randomKey$1(), [i, "_key"]);
}
function MixedArrayAlert(props2) {
  const $ = c(33), {
    error,
    onChange,
    path
  } = props2;
  let t0;
  $[0] !== error.value || $[1] !== onChange ? (t0 = () => {
    const patches = (error.value || []).flatMap(_temp$3k).reverse().map(_temp2$1p);
    onChange(PatchEvent.from(patches));
  }, $[0] = error.value, $[1] = onChange, $[2] = t0) : t0 = $[2];
  const handleRemoveNonObjectValues = t0, {
    t
  } = useTranslation(), t1 = error.schemaType.title, t2 = error.schemaType.description;
  let t3;
  $[3] !== t ? (t3 = t("form.error.mixed-array-alert.remove-button.text"), $[3] = t, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== handleRemoveNonObjectValues || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { padding: 2, children: /* @__PURE__ */ jsx(Button, { onClick: handleRemoveNonObjectValues, text: t3, tone: "critical" }) }), $[5] = handleRemoveNonObjectValues, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t ? (t5 = t("form.error.mixed-array-alert.title"), $[8] = t, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t ? (t6 = t("form.error.mixed-array-alert.summary"), $[10] = t, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t6 }), $[12] = t6, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t ? (t8 = t("form.error.mixed-array-alert.details.title"), $[14] = t, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] !== t ? (t9 = t("form.error.mixed-array-alert.details.description"), $[16] = t, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== t9 ? (t10 = /* @__PURE__ */ jsx(Stack, { space: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t9 }) }), $[18] = t9, $[19] = t10) : t10 = $[19];
  let t11;
  $[20] !== t10 || $[21] !== t8 ? (t11 = /* @__PURE__ */ jsx(Details, { marginTop: 4, open: isDev, title: t8, children: t10 }), $[20] = t10, $[21] = t8, $[22] = t11) : t11 = $[22];
  let t12;
  $[23] !== t11 || $[24] !== t4 || $[25] !== t5 || $[26] !== t7 ? (t12 = /* @__PURE__ */ jsxs(Alert, { status: "error", suffix: t4, title: t5, children: [
    t7,
    t11
  ] }), $[23] = t11, $[24] = t4, $[25] = t5, $[26] = t7, $[27] = t12) : t12 = $[27];
  let t13;
  return $[28] !== error.schemaType.description || $[29] !== error.schemaType.title || $[30] !== path || $[31] !== t12 ? (t13 = /* @__PURE__ */ jsx(FormField, { title: t1, description: t2, path, children: t12 }), $[28] = error.schemaType.description, $[29] = error.schemaType.title, $[30] = path, $[31] = t12, $[32] = t13) : t13 = $[32], t13;
}
function _temp2$1p(index_0) {
  return unset([index_0]);
}
function _temp$3k(item, index) {
  return isPlainObject$1(item) ? [] : [index];
}
function MemberFieldError(props2) {
  const $ = c(27), {
    member
  } = props2, {
    onChange
  } = useFormCallbacks();
  let t0;
  $[0] !== member.fieldName || $[1] !== onChange ? (t0 = (event) => {
    onChange(PatchEvent.from(event).prefixAll(member.fieldName));
  }, $[0] = member.fieldName, $[1] = onChange, $[2] = t0) : t0 = $[2];
  const handleChange = t0, {
    t
  } = useTranslation();
  if (member.error.type === "INCOMPATIBLE_TYPE") {
    let t12;
    $[3] !== member.error.expectedSchemaType.name ? (t12 = [member.error.expectedSchemaType.name], $[3] = member.error.expectedSchemaType.name, $[4] = t12) : t12 = $[4];
    let t22;
    return $[5] !== handleChange || $[6] !== member.error.resolvedValueType || $[7] !== member.error.value || $[8] !== t12 ? (t22 = /* @__PURE__ */ jsx(InvalidValueInput, { value: member.error.value, onChange: handleChange, actualType: member.error.resolvedValueType, validTypes: t12 }), $[5] = handleChange, $[6] = member.error.resolvedValueType, $[7] = member.error.value, $[8] = t12, $[9] = t22) : t22 = $[9], t22;
  }
  if (member.error.type === "MISSING_KEYS") {
    let t12;
    return $[10] !== handleChange || $[11] !== member.error || $[12] !== member.path ? (t12 = /* @__PURE__ */ jsx(MissingKeysAlert, { error: member.error, onChange: handleChange, path: member.path }), $[10] = handleChange, $[11] = member.error, $[12] = member.path, $[13] = t12) : t12 = $[13], t12;
  }
  if (member.error.type === "DUPLICATE_KEYS") {
    let t12;
    return $[14] !== handleChange || $[15] !== member.error || $[16] !== member.path ? (t12 = /* @__PURE__ */ jsx(DuplicateKeysAlert, { error: member.error, onChange: handleChange, path: member.path }), $[14] = handleChange, $[15] = member.error, $[16] = member.path, $[17] = t12) : t12 = $[17], t12;
  }
  if (member.error.type === "MIXED_ARRAY") {
    let t12;
    return $[18] !== handleChange || $[19] !== member.error || $[20] !== member.path ? (t12 = /* @__PURE__ */ jsx(MixedArrayAlert, { onChange: handleChange, error: member.error, path: member.path }), $[18] = handleChange, $[19] = member.error, $[20] = member.path, $[21] = t12) : t12 = $[21], t12;
  }
  let t1;
  $[22] !== props2.member.error.type || $[23] !== t ? (t1 = t("member-field-error.unexpected-error", {
    error: props2.member.error.type
  }), $[22] = props2.member.error.type, $[23] = t, $[24] = t1) : t1 = $[24];
  let t2;
  return $[25] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { children: t1 }), $[25] = t1, $[26] = t2) : t2 = $[26], t2;
}
function MemberDecoration(t0) {
  const $ = c(3), {
    member
  } = t0;
  if (isValidElement(member.component))
    return member.component;
  if (isValidElementType(member.component)) {
    const Component2 = member.component;
    let t1;
    return $[0] !== Component2 || $[1] !== member.key ? (t1 = /* @__PURE__ */ jsx(Component2, {}, member.key), $[0] = Component2, $[1] = member.key, $[2] = t1) : t1 = $[2], t1;
  }
  return console.error("Invalid decoration member, expected a valid react component but received:", typeof member.component, member.component), null;
}
const MemberFieldSet = memo(function(props2) {
  const $ = c(44), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType
  } = props2, {
    onSetFieldSetCollapsed
  } = useFormCallbacks();
  let t0;
  $[0] !== member.fieldSet.path || $[1] !== onSetFieldSetCollapsed ? (t0 = () => {
    onSetFieldSetCollapsed(member.fieldSet.path, !0);
  }, $[0] = member.fieldSet.path, $[1] = onSetFieldSetCollapsed, $[2] = t0) : t0 = $[2];
  const handleCollapse = t0;
  let t1;
  $[3] !== member.fieldSet.path || $[4] !== onSetFieldSetCollapsed ? (t1 = () => {
    onSetFieldSetCollapsed(member.fieldSet.path, !1);
  }, $[3] = member.fieldSet.path, $[4] = onSetFieldSetCollapsed, $[5] = t1) : t1 = $[5];
  const handleExpand = t1;
  let t2;
  bb0: {
    if (member.renderMembers) {
      let t32;
      $[6] !== member ? (t32 = member.renderMembers(member.fieldSet.members), $[6] = member, $[7] = t32) : t32 = $[7], t2 = t32;
      break bb0;
    }
    t2 = member.fieldSet.members;
  }
  const fieldsetMembers = t2;
  let t3;
  $[8] !== member.fieldSet.name || $[9] !== member.fieldSet.title ? (t3 = member.fieldSet.title || capitalize(member.fieldSet.name), $[8] = member.fieldSet.name, $[9] = member.fieldSet.title, $[10] = t3) : t3 = $[10];
  const t4 = member.fieldSet.description, t5 = member.fieldSet.level, t6 = member.fieldSet.collapsible, t7 = member.fieldSet.collapsed, t8 = member?.fieldSet?.columns, t9 = `fieldset-${member.fieldSet.name}`, t10 = member.fieldSet.name, t11 = member.path;
  let t12;
  if ($[11] !== fieldsetMembers || $[12] !== member.key || $[13] !== renderAnnotation || $[14] !== renderBlock2 || $[15] !== renderField || $[16] !== renderInlineBlock || $[17] !== renderInput || $[18] !== renderItem2 || $[19] !== renderPreview) {
    let t132;
    $[21] !== member.key || $[22] !== renderAnnotation || $[23] !== renderBlock2 || $[24] !== renderField || $[25] !== renderInlineBlock || $[26] !== renderInput || $[27] !== renderItem2 || $[28] !== renderPreview ? (t132 = (fieldsetMember) => fieldsetMember.kind === "error" ? /* @__PURE__ */ jsx(MemberFieldError, { member: fieldsetMember }, member.key) : fieldsetMember.kind === "decoration" ? /* @__PURE__ */ jsx(MemberDecoration, { member: fieldsetMember }, fieldsetMember.key) : /* @__PURE__ */ jsx(MemberField, { member: fieldsetMember, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }, fieldsetMember.key), $[21] = member.key, $[22] = renderAnnotation, $[23] = renderBlock2, $[24] = renderField, $[25] = renderInlineBlock, $[26] = renderInput, $[27] = renderItem2, $[28] = renderPreview, $[29] = t132) : t132 = $[29], t12 = fieldsetMembers.map(t132), $[11] = fieldsetMembers, $[12] = member.key, $[13] = renderAnnotation, $[14] = renderBlock2, $[15] = renderField, $[16] = renderInlineBlock, $[17] = renderInput, $[18] = renderItem2, $[19] = renderPreview, $[20] = t12;
  } else
    t12 = $[20];
  let t13;
  return $[30] !== handleCollapse || $[31] !== handleExpand || $[32] !== member.fieldSet.collapsed || $[33] !== member.fieldSet.collapsible || $[34] !== member.fieldSet.description || $[35] !== member.fieldSet.level || $[36] !== member.fieldSet.name || $[37] !== member.path || $[38] !== schemaType || $[39] !== t12 || $[40] !== t3 || $[41] !== t8 || $[42] !== t9 ? (t13 = /* @__PURE__ */ jsx(FormFieldSet, { title: t3, description: t4, level: t5, collapsible: t6, collapsed: t7, onCollapse: handleCollapse, onExpand: handleExpand, schemaType, columns: t8, "data-testid": t9, inputId: t10, path: t11, children: t12 }), $[30] = handleCollapse, $[31] = handleExpand, $[32] = member.fieldSet.collapsed, $[33] = member.fieldSet.collapsible, $[34] = member.fieldSet.description, $[35] = member.fieldSet.level, $[36] = member.fieldSet.name, $[37] = member.path, $[38] = schemaType, $[39] = t12, $[40] = t3, $[41] = t8, $[42] = t9, $[43] = t13) : t13 = $[43], t13;
}), ObjectInputMember = memo(function(props2) {
  const $ = c(22), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderInput,
    renderInlineBlock,
    renderField,
    renderItem: renderItem2,
    renderPreview
  } = props2;
  if (member.kind === "decoration") {
    let t0;
    return $[0] !== member ? (t0 = /* @__PURE__ */ jsx(FormRow, { children: /* @__PURE__ */ jsx(MemberDecoration, { member }, member.key) }), $[0] = member, $[1] = t0) : t0 = $[1], t0;
  }
  if (member.kind === "field") {
    let t0;
    return $[2] !== member || $[3] !== renderAnnotation || $[4] !== renderBlock2 || $[5] !== renderField || $[6] !== renderInlineBlock || $[7] !== renderInput || $[8] !== renderItem2 || $[9] !== renderPreview ? (t0 = /* @__PURE__ */ jsx(MemberField, { member, renderAnnotation, renderBlock: renderBlock2, renderInlineBlock, renderInput, renderField, renderItem: renderItem2, renderPreview }, member.key), $[2] = member, $[3] = renderAnnotation, $[4] = renderBlock2, $[5] = renderField, $[6] = renderInlineBlock, $[7] = renderInput, $[8] = renderItem2, $[9] = renderPreview, $[10] = t0) : t0 = $[10], t0;
  }
  if (member.kind === "error") {
    let t0;
    return $[11] !== member ? (t0 = /* @__PURE__ */ jsx(MemberFieldError, { member }, member.key), $[11] = member, $[12] = t0) : t0 = $[12], t0;
  }
  if (member.kind === "fieldSet") {
    let t0;
    return $[13] !== member || $[14] !== renderAnnotation || $[15] !== renderBlock2 || $[16] !== renderField || $[17] !== renderInlineBlock || $[18] !== renderInput || $[19] !== renderItem2 || $[20] !== renderPreview ? (t0 = /* @__PURE__ */ jsx(MemberFieldSet, { member, renderAnnotation, renderBlock: renderBlock2, renderInlineBlock, renderInput, renderField, renderItem: renderItem2, renderPreview }, member.key), $[13] = member, $[14] = renderAnnotation, $[15] = renderBlock2, $[16] = renderField, $[17] = renderInlineBlock, $[18] = renderInput, $[19] = renderItem2, $[20] = renderPreview, $[21] = t0) : t0 = $[21], t0;
  }
  return console.warn(new Error(`Unhandled member kind ${member.kind}`)), null;
});
function ObjectInputMembers(props2) {
  const $ = c(19), {
    members,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderInput,
    renderInlineBlock,
    renderField,
    renderItem: renderItem2,
    renderPreview
  } = props2;
  let t0;
  if ($[0] !== members || $[1] !== renderAnnotation || $[2] !== renderBlock2 || $[3] !== renderField || $[4] !== renderInlineBlock || $[5] !== renderInput || $[6] !== renderItem2 || $[7] !== renderPreview) {
    let t12;
    $[9] !== renderAnnotation || $[10] !== renderBlock2 || $[11] !== renderField || $[12] !== renderInlineBlock || $[13] !== renderInput || $[14] !== renderItem2 || $[15] !== renderPreview ? (t12 = (member) => /* @__PURE__ */ jsx(ObjectInputMember, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }, member.key), $[9] = renderAnnotation, $[10] = renderBlock2, $[11] = renderField, $[12] = renderInlineBlock, $[13] = renderInput, $[14] = renderItem2, $[15] = renderPreview, $[16] = t12) : t12 = $[16], t0 = members.map(t12), $[0] = members, $[1] = renderAnnotation, $[2] = renderBlock2, $[3] = renderField, $[4] = renderInlineBlock, $[5] = renderInput, $[6] = renderItem2, $[7] = renderPreview, $[8] = t0;
  } else
    t0 = $[8];
  const renderMembers = t0;
  let t1;
  return $[17] !== renderMembers ? (t1 = /* @__PURE__ */ jsx(Fragment$1, { children: renderMembers }), $[17] = renderMembers, $[18] = t1) : t1 = $[18], t1;
}
const ObjectMembers = ObjectInputMembers, INITIAL_STATE$9 = {
  referringDocuments: [],
  isLoading: !0
}, DEFAULT_FIELDS = ["_id", "_type"];
function useReferringDocuments(id2, t0) {
  const $ = c(6), fields = t0 === void 0 ? DEFAULT_FIELDS : t0, documentStore = useDocumentStore();
  let t1;
  $[0] !== fields ? (t1 = fields.length === 0 ? "" : fields.join(","), $[0] = fields, $[1] = t1) : t1 = $[1];
  const projection = t1;
  let t2;
  return $[2] !== documentStore || $[3] !== id2 || $[4] !== projection ? (t2 = documentStore.listenQuery({
    fetch: `*[references($docId)][0...101]${projection ? `{${projection}}` : ""}`,
    listen: "*[references($docId)]"
  }, {
    docId: id2
  }, {
    tag: "use-referring-documents"
  }).pipe(map(_temp$3j), startWith(INITIAL_STATE$9)), $[2] = documentStore, $[3] = id2, $[4] = projection, $[5] = t2) : t2 = $[5], useObservable(t2, INITIAL_STATE$9);
}
function _temp$3j(docs) {
  return {
    referringDocuments: docs,
    isLoading: !1
  };
}
const EMPTY_FIELDS = [];
function useLegacyReferringDocuments(id2) {
  return useReferringDocuments(id2, EMPTY_FIELDS);
}
const AssetUsageList = (t0) => {
  const $ = c(16), {
    asset,
    assetType,
    referringDocuments
  } = t0, {
    t
  } = useTranslation(), count2 = referringDocuments.length, t1 = count2 > 0, t2 = `asset-source.usage-list.documents-using-${assetType}`, t3 = asset.originalFilename ? "named" : "unnamed";
  let t4;
  $[0] !== asset.originalFilename || $[1] !== count2 ? (t4 = {
    filename: asset.originalFilename,
    count: count2
  }, $[0] = asset.originalFilename, $[1] = count2, $[2] = t4) : t4 = $[2];
  let t5;
  $[3] !== t || $[4] !== t2 || $[5] !== t3 || $[6] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, as: "h2", weight: "medium", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: t2, context: t3, values: t4 }) }), $[3] = t, $[4] = t2, $[5] = t3, $[6] = t4, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== t1 || $[9] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { borderBottom: t1, marginTop: 2, paddingBottom: 2, marginBottom: 1, children: t5 }), $[8] = t1, $[9] = t5, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== referringDocuments ? (t7 = referringDocuments.map(_temp$3i), $[11] = referringDocuments, $[12] = t7) : t7 = $[12];
  let t8;
  return $[13] !== t6 || $[14] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t6,
    t7
  ] }), $[13] = t6, $[14] = t7, $[15] = t8) : t8 = $[15], t8;
}, DocumentLink = (t0) => {
  const $ = c(15), {
    document: document2
  } = t0, schema2 = useSchema();
  let t1;
  $[0] !== document2._id || $[1] !== document2._type ? (t1 = (linkProps) => /* @__PURE__ */ jsx(IntentLink, { ...linkProps, params: {
    id: document2._id,
    type: document2._type
  }, intent: "edit" }), $[0] = document2._id, $[1] = document2._type, $[2] = t1) : t1 = $[2];
  const LinkComponent = t1, t2 = document2._id;
  let t3;
  $[3] !== document2._id ? (t3 = {
    _type: "reference",
    _ref: document2._id
  }, $[3] = document2._id, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== document2._type || $[6] !== schema2 ? (t4 = schema2.get(document2._type), $[5] = document2._type, $[6] = schema2, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t3 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(Flex, { align: "center", gap: 2, children: /* @__PURE__ */ jsx(Preview$1, { layout: "default", value: t3, schemaType: t4 }) }), $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10];
  let t6;
  return $[11] !== LinkComponent || $[12] !== document2._id || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { as: LinkComponent, radius: 2, "data-as": "a", tabIndex: 0, children: t5 }, t2), $[11] = LinkComponent, $[12] = document2._id, $[13] = t5, $[14] = t6) : t6 = $[14], t6;
};
function _temp$3i(document2) {
  return /* @__PURE__ */ jsx(DocumentLink, { document: document2 }, document2._id);
}
const STYLE_ASSET_IMAGE = {
  maxWidth: "100%",
  height: "120px",
  objectFit: "contain",
  objectPosition: "center"
}, STYLE_CONFIRM_CARD = {
  gridColumn: "span 1",
  overflow: "hidden",
  display: "flex",
  alignSelf: "center",
  justifyContent: "center"
}, STYLE_IMAGE_WRAPPER = {
  height: "100%"
}, ConfirmMessage = (t0) => {
  const $ = c(44), {
    asset,
    assetType,
    hasResults: t1
  } = t0, hasResults = t1 === void 0 ? !1 : t1, isImage2 = assetType === "image", {
    t
  } = useTranslation();
  if (hasResults) {
    let t22;
    $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = [3, 3, 4], $[0] = t22) : t22 = $[0];
    let t32;
    $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t32 = [2, 3, 4], $[1] = t32) : t32 = $[1];
    let t42;
    $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = [3, 4], $[2] = t42) : t42 = $[2];
    const t52 = isImage2 ? "span 2" : "span 3";
    let t62;
    $[3] !== t52 ? (t62 = {
      gridColumn: t52
    }, $[3] = t52, $[4] = t62) : t62 = $[4];
    let t72;
    $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t72 = /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }), $[5] = t72) : t72 = $[5];
    const t82 = `asset-source.delete-dialog.usage-list.warning-${assetType}-is-in-use`, t92 = asset.originalFilename ? "named" : "unnamed";
    let t102;
    $[6] !== asset.originalFilename || $[7] !== t || $[8] !== t82 || $[9] !== t92 ? (t102 = t(t82, {
      context: t92,
      filename: asset.originalFilename
    }), $[6] = asset.originalFilename, $[7] = t, $[8] = t82, $[9] = t92, $[10] = t102) : t102 = $[10];
    let t112;
    $[11] !== t102 ? (t112 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t102 }), $[11] = t102, $[12] = t112) : t112 = $[12];
    let t122;
    $[13] !== t112 || $[14] !== t62 ? (t122 = /* @__PURE__ */ jsxs(Flex, { gap: t42, align: "center", style: t62, children: [
      t72,
      t112
    ] }), $[13] = t112, $[14] = t62, $[15] = t122) : t122 = $[15];
    let t13;
    $[16] !== asset.url || $[17] !== isImage2 || $[18] !== t ? (t13 = isImage2 && /* @__PURE__ */ jsx(Card, { __unstable_checkered: !0, border: !0, radius: 1, style: STYLE_CONFIRM_CARD, children: /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", style: STYLE_IMAGE_WRAPPER, children: /* @__PURE__ */ jsx("img", { src: `${asset.url}?w=200`, style: STYLE_ASSET_IMAGE, alt: t("asset-source.usage-list.image-alt"), referrerPolicy: "strict-origin-when-cross-origin" }) }) }), $[16] = asset.url, $[17] = isImage2, $[18] = t, $[19] = t13) : t13 = $[19];
    let t14;
    return $[20] !== t122 || $[21] !== t13 ? (t14 = /* @__PURE__ */ jsx(Card, { tone: "caution", padding: t22, border: !0, radius: 2, marginBottom: 3, children: /* @__PURE__ */ jsxs(Grid, { columns: 3, gap: t32, children: [
      t122,
      t13
    ] }) }), $[20] = t122, $[21] = t13, $[22] = t14) : t14 = $[22], t14;
  }
  let t2, t3;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = [2, 3, 4], t3 = [3, 3, 3, 4], $[23] = t2, $[24] = t3) : (t2 = $[23], t3 = $[24]);
  const t4 = isImage2 ? "span 2" : "span 3";
  let t5;
  $[25] !== t4 ? (t5 = {
    gridColumn: t4
  }, $[25] = t4, $[26] = t5) : t5 = $[26];
  const t6 = `asset-source.delete-dialog.usage-list.confirm-delete-${assetType}`, t7 = asset.originalFilename ? "named" : "unnamed";
  let t8;
  $[27] !== asset.originalFilename ? (t8 = {
    filename: asset.originalFilename
  }, $[27] = asset.originalFilename, $[28] = t8) : t8 = $[28];
  let t9;
  $[29] !== t || $[30] !== t6 || $[31] !== t7 || $[32] !== t8 ? (t9 = /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: t6, context: t7, values: t8 }) }), $[29] = t, $[30] = t6, $[31] = t7, $[32] = t8, $[33] = t9) : t9 = $[33];
  let t10;
  $[34] !== t5 || $[35] !== t9 ? (t10 = /* @__PURE__ */ jsx(Flex, { style: t5, align: "center", children: t9 }), $[34] = t5, $[35] = t9, $[36] = t10) : t10 = $[36];
  let t11;
  $[37] !== asset.url || $[38] !== isImage2 || $[39] !== t ? (t11 = isImage2 && /* @__PURE__ */ jsx(Card, { __unstable_checkered: !0, border: !0, radius: 1, style: STYLE_CONFIRM_CARD, children: /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", style: STYLE_IMAGE_WRAPPER, children: /* @__PURE__ */ jsx("img", { src: `${asset.url}?w=200`, style: STYLE_ASSET_IMAGE, alt: t("asset-source.asset-list.table.preview-alt"), referrerPolicy: "strict-origin-when-cross-origin" }) }) }), $[37] = asset.url, $[38] = isImage2, $[39] = t, $[40] = t11) : t11 = $[40];
  let t12;
  return $[41] !== t10 || $[42] !== t11 ? (t12 = /* @__PURE__ */ jsx(Card, { paddingX: t2, paddingY: t3, children: /* @__PURE__ */ jsxs(Grid, { columns: 3, gap: 3, children: [
    t10,
    t11
  ] }) }), $[41] = t10, $[42] = t11, $[43] = t12) : t12 = $[43], t12;
};
function AssetDeleteDialog(t0) {
  const $ = c(32), {
    asset,
    assetType,
    isDeleting: t1,
    onClose,
    onDelete
  } = t0, isDeleting = t1 === void 0 ? !1 : t1, {
    isLoading,
    referringDocuments
  } = useLegacyReferringDocuments(asset._id);
  let t2;
  if ($[0] !== referringDocuments) {
    const drafts = referringDocuments.reduce(_temp$3h, []);
    t2 = referringDocuments.filter((doc_0) => !drafts.includes(doc_0._id)), $[0] = referringDocuments, $[1] = t2;
  } else
    t2 = $[1];
  const publishedDocuments = t2, hasResults = publishedDocuments.length > 0, {
    t
  } = useTranslation();
  let t3;
  $[2] !== t ? (t3 = t("asset-source.delete-dialog.action.cancel"), $[2] = t, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== onClose || $[5] !== t3 ? (t4 = {
    onClick: onClose,
    text: t3
  }, $[4] = onClose, $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t ? (t5 = t("asset-source.delete-dialog.action.delete"), $[7] = t, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== hasResults || $[10] !== isDeleting || $[11] !== onDelete || $[12] !== t5 ? (t6 = {
    disabled: hasResults,
    icon: TrashIcon,
    loading: isDeleting,
    onClick: onDelete,
    text: t5
  }, $[9] = hasResults, $[10] = isDeleting, $[11] = onDelete, $[12] = t5, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== t4 || $[15] !== t6 ? (t7 = {
    cancelButton: t4,
    confirmButton: t6
  }, $[14] = t4, $[15] = t6, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== assetType || $[18] !== t ? (t8 = t("asset-source.delete-dialog.header", {
    context: assetType
  }), $[17] = assetType, $[18] = t, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== asset || $[21] !== assetType || $[22] !== hasResults || $[23] !== isLoading || $[24] !== publishedDocuments ? (t9 = isLoading ? /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) }) : /* @__PURE__ */ jsxs(Stack, { paddingX: hasResults ? [2, 3, 4] : 0, paddingY: hasResults ? [3, 3, 3, 4] : 0, space: 1, children: [
    /* @__PURE__ */ jsx(ConfirmMessage, { asset, assetType, hasResults }),
    hasResults && /* @__PURE__ */ jsx(AssetUsageList, { asset, referringDocuments: publishedDocuments, assetType })
  ] }), $[20] = asset, $[21] = assetType, $[22] = hasResults, $[23] = isLoading, $[24] = publishedDocuments, $[25] = t9) : t9 = $[25];
  let t10;
  return $[26] !== isLoading || $[27] !== onClose || $[28] !== t7 || $[29] !== t8 || $[30] !== t9 ? (t10 = /* @__PURE__ */ jsx(Dialog$1, { __unstable_autoFocus: isLoading, footer: t7, header: t8, id: "asset-dialog", onClickOutside: onClose, onClose, width: 1, children: t9 }), $[26] = isLoading, $[27] = onClose, $[28] = t7, $[29] = t8, $[30] = t9, $[31] = t10) : t10 = $[31], t10;
}
function _temp$3h(acc, doc) {
  return doc._id.startsWith("drafts.") ? acc.concat(doc._id.slice(7)) : acc;
}
const MENU_POPOVER_PROPS$8 = {
  portal: !0,
  placement: "right"
};
function AssetMenu(t0) {
  const $ = c(23), {
    isSelected,
    border: t1,
    onAction
  } = t0, border = t1 === void 0 ? !0 : t1, triggerButtonMode = isSelected ? "default" : "bleed", triggerButtonTone = isSelected ? "primary" : "default", {
    t
  } = useTranslation(), t2 = border ? "ghost" : triggerButtonMode, t3 = border ? "default" : triggerButtonTone;
  let t4;
  $[0] !== t2 || $[1] !== t3 ? (t4 = /* @__PURE__ */ jsx(ContextMenuButton, { mode: t2, tone: t3 }), $[0] = t2, $[1] = t3, $[2] = t4) : t4 = $[2];
  let t5;
  $[3] !== t ? (t5 = t("asset-source.asset-list.menu.show-usage"), $[3] = t, $[4] = t5) : t5 = $[4];
  let t6;
  $[5] !== onAction ? (t6 = () => {
    onAction({
      type: "showUsage"
    });
  }, $[5] = onAction, $[6] = t6) : t6 = $[6];
  let t7;
  $[7] !== t5 || $[8] !== t6 ? (t7 = /* @__PURE__ */ jsx(MenuItem, { text: t5, icon: LinkIcon, onClick: t6 }), $[7] = t5, $[8] = t6, $[9] = t7) : t7 = $[9];
  let t8;
  $[10] !== t ? (t8 = t("asset-source.asset-list.menu.delete"), $[10] = t, $[11] = t8) : t8 = $[11];
  let t9;
  $[12] !== onAction ? (t9 = () => {
    onAction({
      type: "delete"
    });
  }, $[12] = onAction, $[13] = t9) : t9 = $[13];
  let t10;
  $[14] !== t8 || $[15] !== t9 ? (t10 = /* @__PURE__ */ jsx(MenuItem, { text: t8, icon: TrashIcon, tone: "critical", onClick: t9 }), $[14] = t8, $[15] = t9, $[16] = t10) : t10 = $[16];
  let t11;
  $[17] !== t10 || $[18] !== t7 ? (t11 = /* @__PURE__ */ jsxs(Menu, { children: [
    t7,
    t10
  ] }), $[17] = t10, $[18] = t7, $[19] = t11) : t11 = $[19];
  let t12;
  return $[20] !== t11 || $[21] !== t4 ? (t12 = /* @__PURE__ */ jsx(MenuButton, { button: t4, id: "asset-menu", menu: t11, popover: MENU_POPOVER_PROPS$8 }), $[20] = t11, $[21] = t4, $[22] = t12) : t12 = $[22], t12;
}
function AssetUsageDialog(t0) {
  const $ = c(14), {
    asset,
    assetType,
    onClose
  } = t0, {
    isLoading,
    referringDocuments
  } = useLegacyReferringDocuments(asset._id);
  let t1;
  if ($[0] !== referringDocuments) {
    const drafts = referringDocuments.reduce(_temp$3g, []);
    t1 = referringDocuments.filter((doc_0) => !drafts.includes(doc_0._id)), $[0] = referringDocuments, $[1] = t1;
  } else
    t1 = $[1];
  const publishedDocuments = t1, {
    t
  } = useTranslation();
  let t2;
  $[2] !== assetType || $[3] !== t ? (t2 = t("asset-source.asset-usage-dialog.header", {
    context: assetType
  }), $[2] = assetType, $[3] = t, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== asset || $[6] !== assetType || $[7] !== isLoading || $[8] !== publishedDocuments ? (t3 = isLoading ? /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) : /* @__PURE__ */ jsx(AssetUsageList, { asset, referringDocuments: publishedDocuments, assetType }), $[5] = asset, $[6] = assetType, $[7] = isLoading, $[8] = publishedDocuments, $[9] = t3) : t3 = $[9];
  let t4;
  return $[10] !== onClose || $[11] !== t2 || $[12] !== t3 ? (t4 = /* @__PURE__ */ jsx(Dialog$1, { __unstable_autoFocus: !0, header: t2, id: "asset-dialog", onClickOutside: onClose, onClose, width: 1, children: t3 }), $[10] = onClose, $[11] = t2, $[12] = t3, $[13] = t4) : t4 = $[13], t4;
}
function _temp$3g(acc, doc) {
  return doc._id.startsWith("drafts.") ? acc.concat(doc._id.slice(7)) : acc;
}
const MIME_TYPES = {
  // Images
  "image/bmp": {
    title: "Bitmap Image"
  },
  "image/jpeg": {
    title: "JPEG Image"
  },
  "image/gif": {
    title: "GIF Image"
  },
  "image/vnd.microsoft.icon": {
    title: "Icon"
  },
  "image/png": {
    title: "PNG Image"
  },
  "image/svg+xml": {
    title: "SVG Image"
  },
  "image/webp": {
    title: "WebP Image"
  },
  "image/tiff": {
    title: "TIFF Image"
  },
  "image/heic": {
    title: "HEIC Image"
  },
  // Audio
  "audio/midi": {
    title: "MIDI Audio"
  },
  "audio/midi-x": {
    title: "MIDI Audio"
  },
  "audio/mpeg": {
    title: "MP3 Audio"
  },
  "audio/ogg": {
    title: "OGG Audio"
  },
  "audio/wav": {
    title: "WAV Audio"
  },
  "audio/webm": {
    title: "WebM Audio"
  },
  "audio/aac": {
    title: "AAC Audio"
  },
  // Video
  "video/x-msvideo": {
    title: "AVI Video"
  },
  "video/mp4": {
    title: "MP4 Video"
  },
  "video/mpeg": {
    title: "MPEG Video"
  },
  "video/ogg": {
    title: "OGG Video"
  },
  "video/webm": {
    title: "WebM Video"
  },
  "video/quicktime": {
    title: "QuickTime Video"
  },
  // Documents
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
    title: "Excel Spreadsheet"
  },
  "application/vnd.ms-excel": {
    title: "Excel Spreadsheet"
  },
  "text/plain": {
    title: "Text"
  },
  "text/javascript": {
    title: "JavaScript"
  },
  "text/markdown": {
    title: "Markdown"
  },
  "text/csv": {
    title: "CSV"
  },
  "text/css": {
    title: "CSS"
  },
  "application/pdf": {
    title: "PDF Document"
  },
  "application/xml": {
    title: "XML Document"
  },
  "text/xml": {
    title: "XML Document"
  },
  "application/zip": {
    title: "ZIP Archive"
  },
  "application/vnd.rar": {
    title: "RAR Archive"
  },
  "application/x-7z-compressed": {
    title: "7-zip Archive"
  },
  "application/octet-stream": {
    title: "Binary"
  }
};
function convertMimeTypeToSomethingNice(mimeType) {
  const part = mimeType.replace("x-", "").split("/")[1];
  return part.charAt(0).toUpperCase() + part.slice(1);
}
function formatMimeType(mimeType) {
  return MIME_TYPES?.[mimeType] ? MIME_TYPES[mimeType].title : convertMimeTypeToSomethingNice(mimeType);
}
const CardIconWrapper = styled.span.withConfig({
  displayName: "CardIconWrapper",
  componentId: "sc-xkzbm8-0"
})`background-color:transparent;flex-shrink:0;`, CustomFlex = styled(Flex).withConfig({
  displayName: "CustomFlex",
  componentId: "sc-xkzbm8-1"
})``, CustomCard$1 = styled(Card).withConfig({
  displayName: "CustomCard",
  componentId: "sc-xkzbm8-2"
})`${(props2) => props2.isSelected && css`
      --card-muted-fg-color: var(--card-bg-color);
      --card-fg-color: var(--card-bg-color);
    `}`, RowButton = styled(Button$1).withConfig({
  displayName: "RowButton",
  componentId: "sc-xkzbm8-3"
})`box-shadow:none;min-width:0;cursor:pointer;position:initial;&:before,&:after{content:'';position:absolute;left:0;top:0;width:100%;height:100%;z-index:2;}&:before{z-index:0;pointer-events:none;border-radius:inherit;}${(props2) => props2.isSelected && css`
      --card-muted-fg-color: var(--card-bg-color);
      --card-fg-color: var(--card-bg-color);

      &:before {
        background-color: var(--card-focus-ring-color);
      }

      ${CardIconWrapper} {
        --card-muted-fg-color: var(--card-bg-color);
      }

      ${CustomFlex} {
        --card-muted-fg-color: var(--card-bg-color);
        --card-fg-color: var(--card-bg-color);
      }
    `} ${(props2) => !props2.isSelected && css`
      &:hover:before {
        background-color: var(--card-bg-color);
      }

      &:focus:before {
        background-color: var(--card-code-bg-color);
      }

      &:focus-within:before {
        background-color: var(--card-bg-color);
      }
    `}`, TypeText = styled(Text$1).withConfig({
  displayName: "TypeText",
  componentId: "sc-xkzbm8-4"
})`overflow-wrap:anywhere;`, STYLES_ROW_CARD = {
  position: "relative"
}, STYLES_ICON_CARD = {
  flexShrink: 0
}, STYLES_BUTTON_TEXT = {
  minWidth: 0
}, STYLES_ASSETMENU_WRAPPER = {
  zIndex: 3,
  marginTop: "-0.5rem",
  marginBottom: "-0.5rem"
}, AssetRow = (props2) => {
  const $ = c(105), versionedClient2 = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), toast = useToast(), deleteRef$ = useRef(void 0), [showUsageDialog, setShowUsageDialog] = useState(!1), [showDeleteDialog, setShowDeleteDialog] = useState(!1), [isDeleting, setIsDeleting] = useState(!1), [isOpen, setIsOpen] = useState(!1), {
    asset,
    onClick: onClick2,
    onKeyPress,
    onDeleteFinished,
    isSelected,
    isMobile
  } = props2, {
    originalFilename,
    _id,
    mimeType,
    size,
    _createdAt
  } = asset;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    useTemporalPhrase: !0
  }, $[0] = t0) : t0 = $[0];
  const formattedTime = useRelativeTime(_createdAt, t0);
  let t1;
  $[1] !== mimeType ? (t1 = formatMimeType(mimeType), $[1] = mimeType, $[2] = t1) : t1 = $[2];
  const formattedMimeType = t1;
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    unitDisplay: "short",
    maximumFractionDigits: 2
  }, $[3] = t2) : t2 = $[3];
  const formatUnit = useUnitFormatter(t2);
  let t3;
  $[4] !== formatUnit || $[5] !== size ? (t3 = getHumanFriendlyBytes(size, formatUnit), $[4] = formatUnit, $[5] = size, $[6] = t3) : t3 = $[6];
  const formattedSize = t3, showTooltip = (originalFilename || "").length > 37, {
    t
  } = useTranslation();
  let t4;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setShowDeleteDialog(!0);
  }, $[7] = t4) : t4 = $[7];
  const handleConfirmDelete = t4;
  let t5;
  $[8] !== t || $[9] !== toast ? (t5 = (error) => {
    toast.push({
      closable: !0,
      status: "error",
      title: t("asset-source.file.asset-list.delete-failed"),
      description: error.message
    });
  }, $[8] = t, $[9] = toast, $[10] = t5) : t5 = $[10];
  const handleDeleteError = t5;
  let t6;
  $[11] !== t || $[12] !== toast ? (t6 = () => {
    toast.push({
      status: "success",
      title: t("asset-source.file.asset-list.delete-successful")
    });
  }, $[11] = t, $[12] = toast, $[13] = t6) : t6 = $[13];
  const handleDeleteSuccess = t6;
  let t7;
  $[14] !== asset._id || $[15] !== handleDeleteError || $[16] !== handleDeleteSuccess || $[17] !== onDeleteFinished || $[18] !== versionedClient2.observable ? (t7 = () => {
    setIsDeleting(!0), deleteRef$.current = versionedClient2.observable.delete(asset._id).subscribe({
      next: () => {
        setIsDeleting(!1), onDeleteFinished?.(asset._id), setShowDeleteDialog(!1), handleDeleteSuccess();
      },
      error: (err) => {
        setIsDeleting(!1), handleDeleteError(err), console.error("Could not delete asset", err);
      }
    });
  }, $[14] = asset._id, $[15] = handleDeleteError, $[16] = handleDeleteSuccess, $[17] = onDeleteFinished, $[18] = versionedClient2.observable, $[19] = t7) : t7 = $[19];
  const handleDeleteAsset = t7;
  let t8;
  $[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = () => {
    setShowUsageDialog(!1), setShowDeleteDialog(!1);
  }, $[20] = t8) : t8 = $[20];
  const handleDialogClose = t8;
  let t9;
  $[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = () => {
    setShowUsageDialog(!0);
  }, $[21] = t9) : t9 = $[21];
  const handleToggleUsageDialog = t9;
  let t10;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    setIsOpen(_temp$3f);
  }, $[22] = t10) : t10 = $[22];
  const handleToggleOpen = t10;
  let t11;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = (action) => {
    action.type === "delete" && handleConfirmDelete(), action.type === "showUsage" && handleToggleUsageDialog();
  }, $[23] = t11) : t11 = $[23];
  const handleMenuAction = t11;
  let t12;
  $[24] !== asset || $[25] !== showUsageDialog ? (t12 = showUsageDialog && /* @__PURE__ */ jsx(AssetUsageDialog, { assetType: "file", asset, onClose: handleDialogClose }), $[24] = asset, $[25] = showUsageDialog, $[26] = t12) : t12 = $[26];
  const usageDialog = t12;
  let t13;
  $[27] !== asset || $[28] !== handleDeleteAsset || $[29] !== isDeleting || $[30] !== showDeleteDialog ? (t13 = showDeleteDialog && /* @__PURE__ */ jsx(AssetDeleteDialog, { assetType: "file", asset, onClose: handleDialogClose, onDelete: handleDeleteAsset, isDeleting }), $[27] = asset, $[28] = handleDeleteAsset, $[29] = isDeleting, $[30] = showDeleteDialog, $[31] = t13) : t13 = $[31];
  const deleteDialog = t13;
  if (isMobile) {
    const t142 = isDeleting ? 0.5 : 1;
    let t152;
    $[32] !== t142 ? (t152 = {
      position: "relative",
      gridTemplateColumns: "1fr 30px",
      opacity: t142
    }, $[32] = t142, $[33] = t152) : t152 = $[33];
    let t162;
    $[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t162 = /* @__PURE__ */ jsx(Card, { as: CardIconWrapper, padding: 2, tone: "transparent", radius: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 2, style: STYLES_ICON_CARD, children: /* @__PURE__ */ jsx(DocumentIcon, {}) }) }), $[34] = t162) : t162 = $[34];
    let t172;
    $[35] !== originalFilename ? (t172 = /* @__PURE__ */ jsxs(Flex, { gap: 2, flex: 2, align: "center", children: [
      t162,
      /* @__PURE__ */ jsx(Text$1, { size: 1, align: "left", textOverflow: "ellipsis", style: STYLES_BUTTON_TEXT, children: originalFilename })
    ] }), $[35] = originalFilename, $[36] = t172) : t172 = $[36];
    let t182;
    $[37] !== _id || $[38] !== asset || $[39] !== onClick2 || $[40] !== t172 ? (t182 = /* @__PURE__ */ jsx(RowButton, { asset, mode: "bleed", padding: 0, "data-id": _id, onClick: onClick2, paddingY: 1, radius: 2, children: t172 }), $[37] = _id, $[38] = asset, $[39] = onClick2, $[40] = t172, $[41] = t182) : t182 = $[41];
    const t192 = isOpen ? ChevronUpIcon : ChevronDownIcon;
    let t202;
    $[42] !== t192 ? (t202 = /* @__PURE__ */ jsx(Flex, { justify: "flex-end", align: "center", paddingRight: 1, style: STYLES_ASSETMENU_WRAPPER, children: /* @__PURE__ */ jsx(Button$1, { mode: "bleed", fontSize: 1, padding: 2, onClick: handleToggleOpen, icon: t192 }) }), $[42] = t192, $[43] = t202) : t202 = $[43];
    let t212;
    $[44] !== t152 || $[45] !== t182 || $[46] !== t202 ? (t212 = /* @__PURE__ */ jsxs(Grid, { columns: 4, gap: 1, style: t152, children: [
      t182,
      t202
    ] }), $[44] = t152, $[45] = t182, $[46] = t202, $[47] = t212) : t212 = $[47];
    let t222;
    $[48] !== formattedMimeType || $[49] !== formattedSize || $[50] !== formattedTime || $[51] !== isOpen || $[52] !== isSelected || $[53] !== t ? (t222 = isOpen && /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsxs(Grid, { marginTop: 3, columns: 3, gap: 1, children: [
        /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
          /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, weight: "medium", children: t("asset-source.file.asset-list.header.size") }),
          /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: formattedSize })
        ] }),
        /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
          /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, weight: "medium", children: t("asset-source.file.asset-list.header.type") }),
          /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: formattedMimeType })
        ] }),
        /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
          /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, weight: "medium", children: t("asset-source.file.asset-list.header.date-added") }),
          /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: formattedTime })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Stack, { space: 2, marginTop: 3, children: [
        /* @__PURE__ */ jsx(Button$1, { fontSize: 1, tone: "default", mode: "ghost", text: t("asset-source.file.asset-list.action.show-usage.title"), onClick: handleToggleUsageDialog, icon: LinkIcon }),
        /* @__PURE__ */ jsx(Button$1, { fontSize: 1, tone: "critical", mode: "ghost", text: t("asset-source.file.asset-list.action.delete.title"), icon: TrashIcon, disabled: isSelected, title: t(isSelected ? "asset-source.file.asset-list.action.delete.disabled-cannot-delete-current-file" : "asset-source.file.asset-list.action.delete.title"), onClick: handleConfirmDelete })
      ] })
    ] }), $[48] = formattedMimeType, $[49] = formattedSize, $[50] = formattedTime, $[51] = isOpen, $[52] = isSelected, $[53] = t, $[54] = t222) : t222 = $[54];
    const t232 = usageDialog || deleteDialog;
    let t242;
    return $[55] !== t212 || $[56] !== t222 || $[57] !== t232 ? (t242 = /* @__PURE__ */ jsxs(Card, { paddingBottom: 2, style: STYLES_ROW_CARD, children: [
      t212,
      t222,
      t232
    ] }), $[55] = t212, $[56] = t222, $[57] = t232, $[58] = t242) : t242 = $[58], t242;
  }
  const t14 = isDeleting ? 0.5 : 1;
  let t15;
  $[59] !== t14 ? (t15 = {
    position: "relative",
    gridTemplateColumns: "3fr 1fr 1fr 2fr 30px",
    opacity: t14
  }, $[59] = t14, $[60] = t15) : t15 = $[60];
  let t16;
  $[61] !== originalFilename || $[62] !== t ? (t16 = t("asset-source.file.asset-list.item.select-file-tooltip", {
    filename: originalFilename
  }), $[61] = originalFilename, $[62] = t, $[63] = t16) : t16 = $[63];
  let t17;
  $[64] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t17 = /* @__PURE__ */ jsx(Card, { as: CardIconWrapper, padding: 2, tone: "transparent", radius: 2, style: STYLES_ICON_CARD, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 2, children: /* @__PURE__ */ jsx(DocumentIcon, {}) }) }), $[64] = t17) : t17 = $[64];
  let t18;
  $[65] !== originalFilename || $[66] !== showTooltip ? (t18 = showTooltip && /* @__PURE__ */ jsx(Tooltip, { content: originalFilename, children: /* @__PURE__ */ jsx(Text$1, { size: 1, align: "left", textOverflow: "ellipsis", style: STYLES_BUTTON_TEXT, children: originalFilename }) }), $[65] = originalFilename, $[66] = showTooltip, $[67] = t18) : t18 = $[67];
  let t19;
  $[68] !== originalFilename || $[69] !== showTooltip ? (t19 = !showTooltip && /* @__PURE__ */ jsx(Text$1, { size: 1, align: "left", textOverflow: "ellipsis", style: STYLES_BUTTON_TEXT, children: originalFilename }), $[68] = originalFilename, $[69] = showTooltip, $[70] = t19) : t19 = $[70];
  let t20;
  $[71] !== _id || $[72] !== onClick2 || $[73] !== onKeyPress || $[74] !== t18 || $[75] !== t19 ? (t20 = /* @__PURE__ */ jsxs(CustomFlex, { gap: 2, flex: 2, paddingRight: 1, align: "center", onClick: onClick2, onKeyPress, "data-id": _id, children: [
    t17,
    t18,
    t19
  ] }), $[71] = _id, $[72] = onClick2, $[73] = onKeyPress, $[74] = t18, $[75] = t19, $[76] = t20) : t20 = $[76];
  let t21;
  $[77] !== _id || $[78] !== asset || $[79] !== isSelected || $[80] !== onClick2 || $[81] !== onKeyPress || $[82] !== t16 || $[83] !== t20 ? (t21 = /* @__PURE__ */ jsx(RowButton, { asset, mode: "bleed", "data-id": _id, onClick: onClick2, padding: 0, onKeyPress, title: t16, isSelected, radius: 2, children: t20 }), $[77] = _id, $[78] = asset, $[79] = isSelected, $[80] = onClick2, $[81] = onKeyPress, $[82] = t16, $[83] = t20, $[84] = t21) : t21 = $[84];
  let t22;
  $[85] !== formattedSize ? (t22 = /* @__PURE__ */ jsx(CustomFlex, { align: "center", children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: formattedSize }) }), $[85] = formattedSize, $[86] = t22) : t22 = $[86];
  let t23;
  $[87] !== formattedMimeType ? (t23 = /* @__PURE__ */ jsx(CustomFlex, { align: "center", children: /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(TypeText, { size: 1, muted: !0, textOverflow: "ellipsis", children: formattedMimeType }) }) }), $[87] = formattedMimeType, $[88] = t23) : t23 = $[88];
  let t24;
  $[89] !== _createdAt || $[90] !== formattedTime ? (t24 = /* @__PURE__ */ jsx(CustomFlex, { align: "center", children: /* @__PURE__ */ jsx(Text$1, { as: "time", size: 1, muted: !0, dateTime: _createdAt, children: formattedTime }) }), $[89] = _createdAt, $[90] = formattedTime, $[91] = t24) : t24 = $[91];
  let t25;
  $[92] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t25 = /* @__PURE__ */ jsx(CustomFlex, { justify: "flex-end", align: "center", paddingX: 1, paddingY: 1, style: STYLES_ASSETMENU_WRAPPER, children: /* @__PURE__ */ jsx(AssetMenu, { border: !1, isSelected: !1, onAction: handleMenuAction }) }), $[92] = t25) : t25 = $[92];
  let t26;
  $[93] !== _id || $[94] !== t15 || $[95] !== t21 || $[96] !== t22 || $[97] !== t23 || $[98] !== t24 ? (t26 = /* @__PURE__ */ jsxs(Grid, { columns: 4, gap: 1, "data-id": _id, paddingY: 1, style: t15, children: [
    t21,
    t22,
    t23,
    t24,
    t25
  ] }), $[93] = _id, $[94] = t15, $[95] = t21, $[96] = t22, $[97] = t23, $[98] = t24, $[99] = t26) : t26 = $[99];
  const t27 = usageDialog || deleteDialog;
  let t28;
  return $[100] !== asset || $[101] !== isSelected || $[102] !== t26 || $[103] !== t27 ? (t28 = /* @__PURE__ */ jsxs(CustomCard$1, { asset, paddingBottom: 1, style: STYLES_ROW_CARD, radius: 0, overflow: "hidden", isSelected, "aria-selected": "true", children: [
    t26,
    t27
  ] }), $[100] = asset, $[101] = isSelected, $[102] = t26, $[103] = t27, $[104] = t28) : t28 = $[104], t28;
};
function _temp$3f(prev) {
  return !prev;
}
const STYLES_FILENAME = {
  paddingLeft: "2.2rem"
}, STYLES_GRID = {
  gridTemplateColumns: "3fr 1fr 1fr 2fr 30px"
};
function FileListView(props2) {
  const $ = c(25), isMobile = useMediaIndex() < 2, {
    assets,
    onClick: onClick2,
    onKeyPress,
    onDeleteFinished,
    selectedAssets,
    isLoading
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== isMobile || $[1] !== t ? (t0 = /* @__PURE__ */ jsx(Card, { borderBottom: !0, paddingBottom: 2, marginBottom: 1, children: isMobile ? /* @__PURE__ */ jsx(Grid, { style: STYLES_GRID, children: /* @__PURE__ */ jsx(Box, { flex: 2, paddingLeft: 5, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("asset-source.file.asset-list.header.filename") }) }) }) : /* @__PURE__ */ jsxs(Grid, { gap: 1, style: STYLES_GRID, children: [
    /* @__PURE__ */ jsx(Box, { flex: 2, style: STYLES_FILENAME, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("asset-source.file.asset-list.header.filename") }) }),
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("asset-source.file.asset-list.header.size") }) }),
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("asset-source.file.asset-list.header.type") }) }),
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("asset-source.file.asset-list.header.date-added") }) })
  ] }) }), $[0] = isMobile, $[1] = t, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] !== assets.length || $[4] !== isLoading ? (t1 = isLoading && assets.length === 0 && /* @__PURE__ */ jsx(Box, { paddingTop: 4, paddingBottom: 2, children: /* @__PURE__ */ jsx(Flex, { justify: "center", children: /* @__PURE__ */ jsx(Spinner, { muted: !0 }) }) }), $[3] = assets.length, $[4] = isLoading, $[5] = t1) : t1 = $[5];
  let t2;
  if ($[6] !== assets || $[7] !== isMobile || $[8] !== onClick2 || $[9] !== onDeleteFinished || $[10] !== onKeyPress || $[11] !== selectedAssets) {
    let t32;
    $[13] !== isMobile || $[14] !== onClick2 || $[15] !== onDeleteFinished || $[16] !== onKeyPress || $[17] !== selectedAssets ? (t32 = (asset) => /* @__PURE__ */ jsx(AssetRow, { asset, isMobile, isSelected: selectedAssets.some((selected) => selected._id === asset._id), onClick: onClick2, onKeyPress, onDeleteFinished }, asset._id), $[13] = isMobile, $[14] = onClick2, $[15] = onDeleteFinished, $[16] = onKeyPress, $[17] = selectedAssets, $[18] = t32) : t32 = $[18], t2 = assets.map(t32), $[6] = assets, $[7] = isMobile, $[8] = onClick2, $[9] = onDeleteFinished, $[10] = onKeyPress, $[11] = selectedAssets, $[12] = t2;
  } else
    t2 = $[12];
  let t3;
  $[19] !== t1 || $[20] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Stack, { children: [
    t1,
    t2
  ] }), $[19] = t1, $[20] = t2, $[21] = t3) : t3 = $[21];
  let t4;
  return $[22] !== t0 || $[23] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Box, { children: [
    t0,
    t3
  ] }), $[22] = t0, $[23] = t3, $[24] = t4) : t4 = $[24], t4;
}
const DPI = typeof window > "u" || !window.devicePixelRatio ? 1 : Math.round(window.devicePixelRatio), Image$7 = styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-a5hopr-0"
})`position:absolute;z-index:1;top:0;left:0;width:100%;height:100%;display:block;object-fit:contain;`, Container$1 = styled(Card).withConfig({
  displayName: "Container",
  componentId: "sc-a5hopr-1"
})`position:relative;z-index:1;padding-bottom:100%;`, Root$t = styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-a5hopr-2"
})`position:relative;display:inherit;`, MenuContainer = styled.div.withConfig({
  displayName: "MenuContainer",
  componentId: "sc-a5hopr-3"
})`box-sizing:border-box;position:absolute;z-index:2;top:3px;right:3px;& button[data-selected]{display:block;}@media (hover:hover){& button{opacity:0;}${Root$t}:hover &{button{opacity:1;}}${Root$t}:focus-within &{button{opacity:1;}}}`, AssetThumb = memo(function(props2) {
  const $ = c(50), versionedClient2 = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), toast = useToast(), deleteRef$ = useRef(void 0), {
    asset,
    onClick: onClick2,
    onKeyPress,
    onDeleteFinished,
    isSelected
  } = props2, [showUsageDialog, setShowUsageDialog] = useState(!1), [showDeleteDialog, setShowDeleteDialog] = useState(!1), [isDeleting, setIsDeleting] = useState(!1), {
    t
  } = useTranslation();
  let t0, t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => () => {
    deleteRef$.current && deleteRef$.current.unsubscribe();
  }, t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useEffect(t0, t1);
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setShowDeleteDialog(!0);
  }, $[2] = t2) : t2 = $[2];
  const handleConfirmDelete = t2;
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setShowUsageDialog(!1), setShowDeleteDialog(!1);
  }, $[3] = t3) : t3 = $[3];
  const handleDialogClose = t3;
  let t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setShowUsageDialog(!0);
  }, $[4] = t4) : t4 = $[4];
  const handleToggleUsageDialog = t4;
  let t5;
  $[5] !== t || $[6] !== toast ? (t5 = (error) => {
    toast.push({
      closable: !0,
      status: "error",
      title: t("asset-source.image.asset-list.delete-failed"),
      description: error.message
    });
  }, $[5] = t, $[6] = toast, $[7] = t5) : t5 = $[7];
  const handleDeleteError = t5;
  let t6;
  $[8] !== t || $[9] !== toast ? (t6 = () => {
    toast.push({
      status: "success",
      title: t("asset-source.image.asset-list.delete-successful")
    });
  }, $[8] = t, $[9] = toast, $[10] = t6) : t6 = $[10];
  const handleDeleteSuccess = t6;
  let t7;
  $[11] !== asset._id || $[12] !== handleDeleteError || $[13] !== handleDeleteSuccess || $[14] !== onDeleteFinished || $[15] !== versionedClient2.observable ? (t7 = () => {
    setIsDeleting(!0), deleteRef$.current = versionedClient2.observable.delete(asset._id).subscribe({
      next: () => {
        setIsDeleting(!1), onDeleteFinished(asset._id), setShowDeleteDialog(!1), handleDeleteSuccess();
      },
      error: (err) => {
        setIsDeleting(!1), handleDeleteError(err), console.error("Could not delete asset", err);
      }
    });
  }, $[11] = asset._id, $[12] = handleDeleteError, $[13] = handleDeleteSuccess, $[14] = onDeleteFinished, $[15] = versionedClient2.observable, $[16] = t7) : t7 = $[16];
  const handleDeleteAsset = t7;
  let t8;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = (action) => {
    action.type === "delete" && handleConfirmDelete(), action.type === "showUsage" && handleToggleUsageDialog();
  }, $[17] = t8) : t8 = $[17];
  const handleMenuAction = t8;
  let t9;
  $[18] !== asset || $[19] !== showUsageDialog ? (t9 = showUsageDialog && /* @__PURE__ */ jsx(AssetUsageDialog, { assetType: "file", asset, onClose: handleDialogClose }), $[18] = asset, $[19] = showUsageDialog, $[20] = t9) : t9 = $[20];
  const usageDialog = t9;
  let t10;
  $[21] !== asset || $[22] !== handleDeleteAsset || $[23] !== isDeleting || $[24] !== showDeleteDialog ? (t10 = showDeleteDialog && /* @__PURE__ */ jsx(AssetDeleteDialog, { assetType: "file", asset, onClose: handleDialogClose, onDelete: handleDeleteAsset, isDeleting }), $[21] = asset, $[22] = handleDeleteAsset, $[23] = isDeleting, $[24] = showDeleteDialog, $[25] = t10) : t10 = $[25];
  const deleteDialog = t10, {
    originalFilename,
    _id,
    url
  } = asset, imgH = 200 * Math.max(1, DPI);
  let t11;
  $[26] !== url ? (t11 = url.includes(".gif") ? `${url}?h=${imgH}&fit=max&fm=jpg` : `${url}?h=${imgH}&fit=max`, $[26] = url, $[27] = t11) : t11 = $[27];
  const imageUrl = t11;
  let t12;
  $[28] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = {
    padding: 2
  }, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== _id || $[30] !== imageUrl || $[31] !== onClick2 || $[32] !== originalFilename ? (t13 = /* @__PURE__ */ jsx(Image$7, { alt: originalFilename, src: imageUrl, onClick: onClick2, "data-id": _id }), $[29] = _id, $[30] = imageUrl, $[31] = onClick2, $[32] = originalFilename, $[33] = t13) : t13 = $[33];
  let t14;
  $[34] !== isDeleting ? (t14 = isDeleting && /* @__PURE__ */ jsx(LoadingBlock, {}), $[34] = isDeleting, $[35] = t14) : t14 = $[35];
  let t15;
  $[36] !== t13 || $[37] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Container$1, { __unstable_checkered: !0, children: [
    t13,
    t14
  ] }), $[36] = t13, $[37] = t14, $[38] = t15) : t15 = $[38];
  let t16;
  $[39] !== _id || $[40] !== isSelected || $[41] !== onKeyPress || $[42] !== t15 ? (t16 = /* @__PURE__ */ jsx(Button$1, { selected: isSelected, tabIndex: 0, "data-id": _id, mode: "ghost", onKeyPress, padding: 0, style: t12, children: t15 }), $[39] = _id, $[40] = isSelected, $[41] = onKeyPress, $[42] = t15, $[43] = t16) : t16 = $[43];
  let t17;
  $[44] !== isSelected ? (t17 = /* @__PURE__ */ jsx(MenuContainer, { children: /* @__PURE__ */ jsx(AssetMenu, { isSelected, onAction: handleMenuAction }) }), $[44] = isSelected, $[45] = t17) : t17 = $[45];
  const t18 = usageDialog || deleteDialog;
  let t19;
  return $[46] !== t16 || $[47] !== t17 || $[48] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Root$t, { children: [
    t16,
    t17,
    t18
  ] }), $[46] = t16, $[47] = t17, $[48] = t18, $[49] = t19) : t19 = $[49], t19;
}), ThumbGrid = styled(Grid).withConfig({
  displayName: "ThumbGrid",
  componentId: "sc-1k9wkkc-0"
})`grid-template-columns:repeat(auto-fill,minmax(120px,1fr));`;
function ImageListView(props2) {
  const $ = c(23), {
    isLoading,
    assets,
    selectedAssets,
    onItemClick,
    onItemKeyPress,
    onDeleteFinished
  } = props2;
  let t0;
  if ($[0] !== assets || $[1] !== onDeleteFinished || $[2] !== onItemClick || $[3] !== onItemKeyPress || $[4] !== selectedAssets) {
    let t12;
    $[6] !== onDeleteFinished || $[7] !== onItemClick || $[8] !== onItemKeyPress || $[9] !== selectedAssets ? (t12 = (asset) => /* @__PURE__ */ jsx(AssetThumb, { asset, isSelected: selectedAssets.some((selected) => selected._id === asset._id), onClick: onItemClick, onKeyPress: onItemKeyPress, onDeleteFinished }, asset._id), $[6] = onDeleteFinished, $[7] = onItemClick, $[8] = onItemKeyPress, $[9] = selectedAssets, $[10] = t12) : t12 = $[10], t0 = assets.map(t12), $[0] = assets, $[1] = onDeleteFinished, $[2] = onItemClick, $[3] = onItemKeyPress, $[4] = selectedAssets, $[5] = t0;
  } else
    t0 = $[5];
  let t1;
  $[11] !== t0 ? (t1 = /* @__PURE__ */ jsx(ThumbGrid, { gap: 2, children: t0 }), $[11] = t0, $[12] = t1) : t1 = $[12];
  let t2;
  $[13] !== assets.length || $[14] !== isLoading ? (t2 = isLoading && assets.length === 0 && /* @__PURE__ */ jsx(Flex, { justify: "center", children: /* @__PURE__ */ jsx(Spinner, { muted: !0 }) }), $[13] = assets.length, $[14] = isLoading, $[15] = t2) : t2 = $[15];
  let t3;
  $[16] !== assets.length || $[17] !== isLoading ? (t3 = !isLoading && assets.length === 0 && /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0 }), $[16] = assets.length, $[17] = isLoading, $[18] = t3) : t3 = $[18];
  let t4;
  return $[19] !== t1 || $[20] !== t2 || $[21] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Box, { padding: 4, children: [
    t1,
    t2,
    t3
  ] }), $[19] = t1, $[20] = t2, $[21] = t3, $[22] = t4) : t4 = $[22], t4;
}
const PER_PAGE = 200, ASSET_TYPE_IMAGE = "sanity.imageAsset", ASSET_TYPE_FILE = "sanity.fileAsset", buildFilterQuery = (acceptParam) => {
  const WILDCARD_ACCEPT = ["image/*", "audio/*", "video/*"], typesForFilter = acceptParam.split(",").map((accept) => accept.trim()).reduce((acceptTypes, acceptValue) => WILDCARD_ACCEPT.includes(acceptValue) ? {
    ...acceptTypes,
    wildcards: `mimeType match '${acceptValue}' || ${acceptTypes.wildcards}`
  } : acceptValue.indexOf(".") === 0 ? {
    ...acceptTypes,
    extensions: `'${acceptValue.replace(".", "")}', ${acceptTypes.extensions}`
  } : {
    ...acceptTypes,
    mimes: `'${acceptValue}', ${acceptTypes.mimes}`
  }, {
    mimes: "",
    extensions: "",
    wildcards: ""
  });
  return `&&
  (
    ${typesForFilter.wildcards}
    extension in [${typesForFilter.extensions}] ||
    mimeType in [${typesForFilter.mimes}]
  )`;
}, buildQuery = (start = 0, end = PER_PAGE, assetType = ASSET_TYPE_IMAGE, acceptParam) => {
  const filterCondition = acceptParam.length > 0 ? buildFilterQuery(acceptParam) : "";
  return `
  *[_type == "${assetType}" ${filterCondition}] | order(_updatedAt desc) [${start}...${end}] {
    _id,
    _updatedAt,
    _createdAt,
    url,
    originalFilename,
    mimeType,
    extension,
    size,
    metadata {dimensions}
  }
`;
}, CardLoadMore = styled(Card).withConfig({
  displayName: "CardLoadMore",
  componentId: "sc-12pv0ix-0"
})`border-top:1px solid var(--card-border-color);position:sticky;bottom:0;z-index:200;`, SelectAssetsComponent = function(props2, ref) {
  const $ = c(68), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0;
  $[0] !== client ? (t0 = client.withConfig({
    apiVersion: "2023-02-14"
  }), $[0] = client, $[1] = t0) : t0 = $[1];
  const versionedClient2 = t0, [_elementId] = useState(_temp$3e), currentPageNumber = useRef(0), {
    t
  } = useTranslation(), fetch$ = useRef(void 0);
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[2] = t1) : t1 = $[2];
  const [assets, setAssets] = useState(t1), [isLastPage, setIsLastPage] = useState(!1), [hasResetAutoFocus, setHasResetFocus] = useState(!1), [isLoading, setIsLoading] = useState(!0), {
    selectedAssets,
    assetType: t2,
    dialogHeaderTitle,
    onClose,
    onSelect,
    accept
  } = props2, assetType = t2 === void 0 ? "image" : t2, isImageOnlyWildCard = accept && accept === "image/*" && assetType === "image";
  let t3;
  $[3] !== accept || $[4] !== assetType || $[5] !== versionedClient2 ? (t3 = (pageNumber) => {
    const start = pageNumber * PER_PAGE, end = start + PER_PAGE, isImageAssetType = assetType === "image", tag = isImageAssetType ? "asset.image-list" : "asset.file-list", assetTypeParam = isImageAssetType ? ASSET_TYPE_IMAGE : ASSET_TYPE_FILE;
    setIsLoading(!0), typeof accept < "u" && (fetch$.current = versionedClient2.observable.fetch(buildQuery(start, end, assetTypeParam, accept), {}, {
      tag
    }).subscribe((result) => {
      setIsLastPage(result.length < PER_PAGE), setAssets((prevState) => prevState.concat(result)), setIsLoading(!1);
    }));
  }, $[3] = accept, $[4] = assetType, $[5] = versionedClient2, $[6] = t3) : t3 = $[6];
  const fetchPage = t3;
  let t4;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = (id2) => {
    setAssets((prevState_0) => prevState_0.filter((asset) => asset._id !== id2));
  }, $[7] = t4) : t4 = $[7];
  const handleDeleteFinished = t4;
  let t5;
  $[8] !== assets || $[9] !== onSelect ? (t5 = (id_0) => {
    assets.find((doc) => doc._id === id_0) && onSelect([{
      kind: "assetDocumentId",
      value: id_0
    }]);
  }, $[8] = assets, $[9] = onSelect, $[10] = t5) : t5 = $[10];
  const select2 = t5;
  let t6;
  $[11] !== select2 ? (t6 = (event) => {
    event.preventDefault();
    const id_1 = event.currentTarget.getAttribute("data-id");
    if (!id_1)
      throw new Error("Missing data-id attribute on item");
    select2(id_1);
  }, $[11] = select2, $[12] = t6) : t6 = $[12];
  const handleItemClick = t6;
  let t7;
  $[13] !== select2 ? (t7 = (event_0) => {
    if (event_0.key === "Enter") {
      event_0.preventDefault();
      const id_2 = event_0.currentTarget.getAttribute("data-id");
      if (!id_2)
        throw new Error("Missing data-id attribute on item");
      select2(id_2);
    }
  }, $[13] = select2, $[14] = t7) : t7 = $[14];
  const handleItemKeyPress = t7;
  let t8;
  $[15] !== onClose ? (t8 = () => {
    onClose && onClose();
  }, $[15] = onClose, $[16] = t8) : t8 = $[16];
  const handleClose = t8;
  let t9;
  $[17] !== fetchPage ? (t9 = (event_1) => {
    event_1.preventDefault(), fetchPage(currentPageNumber.current = currentPageNumber.current + 1);
  }, $[17] = fetchPage, $[18] = t9) : t9 = $[18];
  const handleFetchNextPage = t9;
  let t10, t11;
  $[19] !== fetchPage ? (t10 = () => (fetchPage(currentPageNumber.current), () => {
    fetch$.current && fetch$.current.unsubscribe();
  }), t11 = [fetchPage], $[19] = fetchPage, $[20] = t10, $[21] = t11) : (t10 = $[20], t11 = $[21]), useEffect(t10, t11);
  let t12, t13;
  $[22] !== isLoading ? (t12 = () => {
    !isLoading && (!currentPageNumber.current || currentPageNumber.current === 0) && setHasResetFocus(!0);
  }, t13 = [isLoading], $[22] = isLoading, $[23] = t12, $[24] = t13) : (t12 = $[23], t13 = $[24]), useEffect(t12, t13);
  let t14;
  $[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t14 = {
    style: "narrow"
  }, $[25] = t14) : t14 = $[25];
  const listFormat = useListFormat(t14);
  let t15;
  $[26] !== assetType || $[27] !== dialogHeaderTitle || $[28] !== t ? (t15 = dialogHeaderTitle || t("asset-source.dialog.default-title", {
    context: assetType === "sanity.video" ? "video" : assetType
  }), $[26] = assetType, $[27] = dialogHeaderTitle, $[28] = t, $[29] = t15) : t15 = $[29];
  let t16;
  $[30] !== accept || $[31] !== isImageOnlyWildCard || $[32] !== isLoading || $[33] !== listFormat || $[34] !== t ? (t16 = !isImageOnlyWildCard && !isLoading && accept?.length > 0 && /* @__PURE__ */ jsx(Card, { tone: "primary", padding: 3, border: !0, radius: 2, children: /* @__PURE__ */ jsxs(Flex, { gap: 3, align: "center", children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(InfoOutlineIcon, {}) }),
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "asset-source.dialog.accept-message", values: {
      acceptTypes: listFormat.format(accept.split(",").map(_temp2$1o))
    } }) })
  ] }) }), $[30] = accept, $[31] = isImageOnlyWildCard, $[32] = isLoading, $[33] = listFormat, $[34] = t, $[35] = t16) : t16 = $[35];
  let t17;
  $[36] !== assetType || $[37] !== assets || $[38] !== handleItemClick || $[39] !== handleItemKeyPress || $[40] !== isLoading || $[41] !== selectedAssets ? (t17 = assetType === "file" && /* @__PURE__ */ jsx(FileListView, { assets, onDeleteFinished: handleDeleteFinished, onClick: handleItemClick, onKeyPress: handleItemKeyPress, isLoading, selectedAssets }), $[36] = assetType, $[37] = assets, $[38] = handleItemClick, $[39] = handleItemKeyPress, $[40] = isLoading, $[41] = selectedAssets, $[42] = t17) : t17 = $[42];
  let t18;
  $[43] !== assetType || $[44] !== assets || $[45] !== handleItemClick || $[46] !== handleItemKeyPress || $[47] !== isLoading || $[48] !== selectedAssets ? (t18 = assetType === "image" && /* @__PURE__ */ jsx(ImageListView, { assets, onDeleteFinished: handleDeleteFinished, onItemClick: handleItemClick, onItemKeyPress: handleItemKeyPress, isLoading, selectedAssets }), $[43] = assetType, $[44] = assets, $[45] = handleItemClick, $[46] = handleItemKeyPress, $[47] = isLoading, $[48] = selectedAssets, $[49] = t18) : t18 = $[49];
  let t19;
  $[50] !== assets.length || $[51] !== handleFetchNextPage || $[52] !== isLastPage || $[53] !== isLoading || $[54] !== t ? (t19 = assets.length > 0 && !isLastPage && /* @__PURE__ */ jsx(CardLoadMore, { tone: "default", padding: 4, children: /* @__PURE__ */ jsx(Flex, { direction: "column", children: /* @__PURE__ */ jsx(Button, { type: "button", icon: DownloadIcon, loading: isLoading, onClick: handleFetchNextPage, size: "large", text: t("asset-source.dialog.load-more"), tone: "primary" }) }) }), $[50] = assets.length, $[51] = handleFetchNextPage, $[52] = isLastPage, $[53] = isLoading, $[54] = t, $[55] = t19) : t19 = $[55];
  let t20;
  $[56] !== t16 || $[57] !== t17 || $[58] !== t18 || $[59] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Stack, { space: 5, children: [
    t16,
    t17,
    t18,
    t19
  ] }), $[56] = t16, $[57] = t17, $[58] = t18, $[59] = t19, $[60] = t20) : t20 = $[60];
  let t21;
  return $[61] !== _elementId || $[62] !== handleClose || $[63] !== hasResetAutoFocus || $[64] !== ref || $[65] !== t15 || $[66] !== t20 ? (t21 = /* @__PURE__ */ jsx(Dialog$1, { __unstable_autoFocus: hasResetAutoFocus, header: t15, id: _elementId, onClickOutside: handleClose, onClose: handleClose, ref, width: 2, children: t20 }), $[61] = _elementId, $[62] = handleClose, $[63] = hasResetAutoFocus, $[64] = ref, $[65] = t15, $[66] = t20, $[67] = t21) : t21 = $[67], t21;
}, SelectAssetsDialog$1 = memo(forwardRef(SelectAssetsComponent));
function _temp$3e() {
  return `default-asset-source-${uniqueId()}`;
}
function _temp2$1o(type) {
  return type.trim();
}
const DatasetAssetSourceComponent = function(props2, ref) {
  const $ = c(3), {
    action: t0
  } = props2;
  if ((t0 === void 0 ? "select" : t0) === "select") {
    let t1;
    return $[0] !== props2 || $[1] !== ref ? (t1 = /* @__PURE__ */ jsx(SelectAssetsDialog$1, { ...props2, ref }), $[0] = props2, $[1] = ref, $[2] = t1) : t1 = $[2], t1;
  }
  return null;
}, DatasetAssetSource = memo(forwardRef(DatasetAssetSourceComponent));
class DatasetUploader {
  files = [];
  subscribers = /* @__PURE__ */ new Set();
  subscriptions = /* @__PURE__ */ new Map();
  constructor(props2) {
    this.client = props2.client;
  }
  checkAllComplete() {
    this.files.length > 0 && this.files.every((file) => ["complete", "error", "aborted"].includes(file.status)) && (this.emit({
      type: "all-complete",
      files: this.files
    }), this.reset());
  }
  emit(event) {
    this.subscribers.forEach((fn) => fn(event));
  }
  upload(files, options) {
    const {
      schemaType,
      onChange
    } = options || {};
    for (const file of files) {
      if (!schemaType)
        throw new Error("No schema type provided for file upload");
      if (!onChange)
        throw new Error("No onChange provided for file upload");
      const uploader = resolveUploader(schemaType, file), uploadOptions = {
        metadata: get(schemaType, "options.metadata"),
        storeOriginalFilename: get(schemaType, "options.storeOriginalFilename")
      }, fileId = uuid(), uploadFile2 = {
        id: fileId,
        file,
        progress: 0,
        status: "pending"
      };
      this.files.push(uploadFile2), uploader && this.subscriptions.set(fileId, uploader.upload(this.client, file, schemaType, uploadOptions).subscribe({
        next: (progressEvent) => {
          const {
            patches
          } = progressEvent;
          this.updateFile(uploadFile2.id, {
            status: "uploading"
          }), patches && onChange(patches);
        },
        error: (error) => {
          let _err;
          error instanceof Error ? _err = error : _err = new Error("Unknown error"), this.updateFile(uploadFile2.id, {
            status: "error",
            error: _err
          }), this.emit({
            type: "error",
            files: this.files.filter((erroredFile) => erroredFile.status === "error")
          }), this.subscriptions.get(fileId)?.unsubscribe();
        },
        complete: () => {
          this.updateFile(uploadFile2.id, {
            status: "complete"
          }), this.subscriptions.get(fileId)?.unsubscribe();
        }
      }));
    }
    return this.files;
  }
  abort(file) {
    if (file) {
      const target = this.files.find((f) => f.id === file.id);
      target && ["pending", "uploading"].includes(target.status) && this.updateFile(target.id, {
        status: "aborted"
      });
    } else
      for (const target of this.files)
        ["pending", "uploading"].includes(target.status) && this.updateFile(target.id, {
          status: "aborted"
        });
    this.emit({
      type: "abort",
      files: this.files.filter((abortedFile) => abortedFile.status === "aborted")
    }), this.checkAllComplete();
  }
  updateFile(fileId, data) {
    const target = this.files.find((f) => f.id === fileId);
    target && (data.error && (target.error = data.error), data.progress && data.progress !== target.progress && (target.progress = data.progress, this.emit({
      type: "progress",
      file: target,
      progress: target.progress * 100
    })), data.status && data.status !== target.status && (target.status = data.status, this.emit({
      type: "status",
      file: target,
      status: target.status
    }))), this.checkAllComplete();
  }
  subscribe(subscriber) {
    this.subscribers.add(subscriber);
    for (const file of this.files)
      subscriber({
        type: "status",
        file,
        status: file.status
      }), subscriber({
        type: "progress",
        file,
        progress: file.progress
      });
    return this.checkAllComplete(), () => {
      this.subscribers.delete(subscriber);
    };
  }
  getFiles() {
    return this.files;
  }
  reset() {
    this.files = [];
  }
}
function createDatasetUploader(props2) {
  return class extends DatasetUploader {
    constructor() {
      super(props2);
    }
  };
}
const sourceName$2 = "sanity-default";
function createDatasetImageAssetSource(props2) {
  return {
    name: sourceName$2,
    title: props2.title,
    // i18nKey: 'asset-sources.dataset.image.title',
    component: DatasetAssetSource,
    icon: ImageIcon,
    Uploader: createDatasetUploader(props2)
  };
}
function createDatasetFileAssetSource(props2) {
  return {
    name: sourceName$2,
    title: props2.title,
    // i18nKey: 'asset-sources.dataset.file.title',
    component: DatasetAssetSource,
    icon: DocumentsIcon,
    Uploader: createDatasetUploader(props2)
  };
}
const ASSET_TYPE_CONFIG = {
  image: {
    mimePrefix: "image/",
    defaultAccept: "image/*"
  },
  file: {
    defaultAccept: ""
  },
  video: {
    mimePrefix: "video/",
    defaultAccept: "video/*"
  }
};
function matchesSchemaTypeAccept(file, schemaType, assetType) {
  const config = ASSET_TYPE_CONFIG[assetType];
  if ("mimePrefix" in config && !file.type.startsWith(config.mimePrefix))
    return !1;
  const acceptString = schemaType.options?.accept ?? config.defaultAccept;
  return accepts(file, acceptString);
}
function findMatchingSchemaType(file, types) {
  const imageType = types.find((t) => _isType(t, "image"));
  if (imageType && file.type.startsWith("image/") && matchesSchemaTypeAccept(file, imageType, "image"))
    return {
      schemaType: imageType,
      assetType: "image"
    };
  const fileType = types.find((t) => _isType(t, "file"));
  if (fileType && matchesSchemaTypeAccept(file, fileType, "file"))
    return {
      schemaType: fileType,
      assetType: "file"
    };
  const videoType = types.find((t) => _isType(t, "sanity.video"));
  return videoType && file.type.startsWith("video/") && matchesSchemaTypeAccept(file, videoType, "video") ? {
    schemaType: videoType,
    assetType: "video"
  } : null;
}
function filterAssetSourcesWithFallback(assetSources) {
  const sourcesWithUploader = assetSources.filter((source) => !!source.Uploader);
  return sourcesWithUploader.length > 0 ? sourcesWithUploader : assetSources;
}
function resolveUploadAssetSources(type, formBuilder, file) {
  const supportsDirectImageUploads = formBuilder.__internal.image.directUploads, supportsDirectFileUploads = formBuilder.__internal.file.directUploads;
  return is$1("image", type) ? supportsDirectImageUploads ? file && !accepts(file, type.options?.accept || "image/*") ? [] : filterAssetSourcesWithFallback(formBuilder.__internal.image.assetSources) : [] : is$1("file", type) ? supportsDirectFileUploads ? file && !accepts(file, type.options?.accept || "") ? [] : filterAssetSourcesWithFallback(formBuilder.__internal.file.assetSources) : [] : is$1("sanity.video", type) ? supportsDirectFileUploads ? file && !accepts(file, type.options?.accept || "video/*") ? [] : filterAssetSourcesWithFallback(formBuilder.__internal.file.assetSources) : [] : [];
}
function hasUploadSupport(source) {
  return !!source.Uploader || source.uploadMode === "component";
}
function isComponentModeAssetSource(source) {
  return source.uploadMode === "component";
}
function getAssetSourcesWithUpload(sources) {
  return sources.filter(hasUploadSupport);
}
function getAssetSourceDisplayName(source, t, options) {
  return (source.i18nKey ? t(source.i18nKey) : source.title) || (options?.useStartCaseForName ? startCase(source.name) : source.name);
}
const Sticky = styled(Box).withConfig({
  displayName: "Sticky",
  componentId: "sc-17q41jp-0"
})`position:sticky;top:0;bottom:0;margin:auto;`;
function DropMessage$1(props2) {
  const $ = c(6), {
    hoveringFiles,
    types
  } = props2, formBuilder = useFormBuilder();
  let t0;
  $[0] !== formBuilder || $[1] !== types ? (t0 = (file) => types.some((type) => resolveUploadAssetSources(type, formBuilder, file).length > 0), $[0] = formBuilder, $[1] = types, $[2] = t0) : t0 = $[2];
  const acceptedFiles = hoveringFiles.filter(t0), rejectedFilesCount = hoveringFiles.length - acceptedFiles.length, multiple = types.length > 1, {
    t
  } = useTranslation(), T0 = Sticky, t1 = "upload-target-drop-message", t2 = 3, t3 = 3, t4 = acceptedFiles.length > 0 ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
      /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(UploadIcon, {}) }),
      multiple ? t("inputs.files.common.drop-message.drop-to-upload-multi", {
        count: acceptedFiles.length
      }) : t("inputs.files.common.drop-message.drop-to-upload"),
      /* @__PURE__ */ jsx(Text$1, {})
    ] }),
    rejectedFilesCount > 0 && /* @__PURE__ */ jsx(Box, { marginTop: 4, children: /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
      /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(AccessDeniedIcon, {}) }),
      /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t("inputs.files.common.drop-message.drop-to-upload.rejected-file-message", {
        count: rejectedFilesCount
      }) })
    ] }) })
  ] }) : /* @__PURE__ */ jsxs(Inline, { "data-testid": "upload-target-drop-message-not-allowed", space: 2, children: [
    /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(AccessDeniedIcon, {}) }),
    /* @__PURE__ */ jsx(Text$1, { children: t("inputs.files.common.drop-message.drop-to-upload.no-accepted-file-message", {
      count: hoveringFiles.length
    }) })
  ] });
  let t5;
  return $[3] !== T0 || $[4] !== t4 ? (t5 = /* @__PURE__ */ jsx(T0, { "data-testid": t1, paddingBottom: t2, paddingTop: t3, children: t4 }), $[3] = T0, $[4] = t4, $[5] = t5) : t5 = $[5], t5;
}
function extractPastedFiles(dataTransfer) {
  return dataTransfer.files && dataTransfer.files.length > 0 ? Promise.resolve(Array.from(dataTransfer.files || [])) : normalizeItems(Array.from(dataTransfer.items || [])).then(flatten$1);
}
function extractDroppedFiles(dataTransfer) {
  const files = Array.from(dataTransfer.files || []), items = Array.from(dataTransfer.items || []);
  return files && files.length > 0 ? Promise.resolve(files) : normalizeItems(items).then(flatten$1);
}
function toArray(v) {
  return v === null ? [] : [v];
}
function normalizeItems(items) {
  return Promise.all(items.map((item) => {
    if (item.kind === "file" && item.webkitGetAsEntry) {
      let entry;
      try {
        entry = item.webkitGetAsEntry();
      } catch {
        return toArray(item.getAsFile());
      }
      return entry ? entry.isDirectory ? walk(entry) : toArray(item.getAsFile()) : [];
    }
    if (item.kind === "file") {
      const file = item.getAsFile();
      return Promise.resolve(file ? [file] : []);
    }
    return item.kind === "string" ? (console.warn('DataTransfer with kind="string" is currently not supported'), Promise.resolve([])) : (console.warn("Unknown DataTransferItem.kind: %s", item.kind), Promise.resolve([]));
  }));
}
function walk(entry) {
  if (entry.isFile)
    return new Promise((resolve, reject) => entry.file(resolve, reject)).then((file) => [file]);
  if (entry.isDirectory) {
    const dir = entry.createReader();
    return new Promise((resolve, reject) => dir.readEntries(resolve, reject)).then((entries) => entries.filter((entr) => !entr.name.startsWith("."))).then((entries) => Promise.all(entries.map(walk)).then(flatten$1));
  }
  return Promise.resolve([]);
}
function isPortableTextItem(item) {
  const type = item.type.replace(/^web /, "");
  return type === "application/portable-text" || type === "application/x-portable-text";
}
function imageUrlToBlob(imageUrl, format2 = "image/jpeg", quality = 1) {
  return imageUrl.match(/^webkit-fake-url:\/\//) ? Promise.reject(new Error("Cannot read image contents from webkit fake url")) : new Promise((resolve, reject) => {
    const loader = new Image();
    loader.crossOrigin = "anonymous", loader.referrerPolicy = "strict-origin-when-cross-origin", loader.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = loader.width, canvas.height = loader.height, canvas.getContext("2d")?.drawImage(loader, 0, 0, canvas.width, canvas.height);
      try {
        canvas.toBlob(resolve, format2, quality);
      } catch (error) {
        reject(error);
      }
    }, loader.src = imageUrl;
  });
}
const fileTargetAttributeName = "isFileTarget", fileTargetDataAttribute = {
  "data-is-file-target": "true"
}, isFileTargetElement = (el) => el?.dataset?.[fileTargetAttributeName] === "true", PASTE_INPUT_STYLE = {
  opacity: 0,
  position: "absolute"
};
function fileTarget(Component2) {
  return forwardRef(function(props2, forwardedRef) {
    const $ = c(49);
    let disabled, onFiles, onFilesOut, onFilesOver, pasteTarget, rest;
    $[0] !== props2 ? ({
      onFiles,
      onFilesOver,
      onFilesOut,
      pasteTarget,
      disabled,
      ...rest
    } = props2, $[0] = props2, $[1] = disabled, $[2] = onFiles, $[3] = onFilesOut, $[4] = onFilesOver, $[5] = pasteTarget, $[6] = rest) : (disabled = $[1], onFiles = $[2], onFilesOut = $[3], onFilesOver = $[4], pasteTarget = $[5], rest = $[6]);
    const [showPasteInput, setShowPasteInput] = useState(!1), pasteInput = useRef(null), ref = useRef(null);
    let t0;
    $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => ref.current, $[7] = t0) : t0 = $[7], useImperativeHandle(forwardedRef, t0);
    let t1;
    $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[8] = t1) : t1 = $[8];
    const enteredElements = useRef(t1);
    let t2;
    $[9] !== onFiles ? (t2 = (files) => {
      onFiles?.(files);
    }, $[9] = onFiles, $[10] = t2) : t2 = $[10];
    const emitFiles = t2;
    let t3;
    $[11] !== pasteTarget ? (t3 = (event) => {
      !pasteTarget && event.target === ref.current && (event.ctrlKey || event.metaKey) && event.key === "v" && setShowPasteInput(!0);
    }, $[11] = pasteTarget, $[12] = t3) : t3 = $[12];
    const handleKeyDown = t3;
    let t4;
    $[13] !== emitFiles || $[14] !== pasteTarget ? (t4 = (event_0) => {
      extractPastedFiles(event_0.clipboardData).then((files_0) => pasteTarget ? files_0 : pasteInput.current ? files_0.length > 0 ? files_0 : convertImagesToFilesAndClearContentEditable(pasteInput.current, "image/jpeg") : []).then((files_1) => {
        emitFiles(files_1), pasteTarget || (setShowPasteInput(!1), ref.current?.focus());
      });
    }, $[13] = emitFiles, $[14] = pasteTarget, $[15] = t4) : t4 = $[15];
    const handlePaste = t4;
    let t5, t6;
    $[16] !== handlePaste || $[17] !== pasteTarget ? (t5 = () => {
      if (pasteTarget) {
        const pasteTargetElementListener = (event_1) => {
          if (event_1.clipboardData?.types.some(_temp$3d))
            return;
          const hasHtml = !!event_1.clipboardData?.getData("text/html"), hasText = !!event_1.clipboardData?.getData("text/plain");
          if (hasHtml && hasText) {
            console.warn("Clipboard contains both text and HTML, ignoring additional file data on the clipboard.");
            return;
          }
          handlePaste(event_1);
        };
        return pasteTarget.addEventListener("paste", pasteTargetElementListener), () => {
          pasteTarget.removeEventListener("paste", pasteTargetElementListener);
        };
      }
    }, t6 = [pasteTarget, handlePaste], $[16] = handlePaste, $[17] = pasteTarget, $[18] = t5, $[19] = t6) : (t5 = $[18], t6 = $[19]), useEffect(t5, t6);
    let t7;
    $[20] !== emitFiles || $[21] !== onFiles || $[22] !== onFilesOut ? (t7 = (event_2) => {
      if (enteredElements.current = [], Array.from(event_2.dataTransfer.items).map(_temp2$1n).some(_temp3$F))
        return;
      event_2.preventDefault(), event_2.stopPropagation();
      const dataTransfer = event_2.nativeEvent.dataTransfer;
      onFiles && dataTransfer && extractDroppedFiles(dataTransfer).then((files_2) => {
        files_2 && emitFiles(files_2);
      }), onFilesOut?.();
    }, $[20] = emitFiles, $[21] = onFiles, $[22] = onFilesOut, $[23] = t7) : t7 = $[23];
    const handleDrop = t7;
    let t8;
    $[24] !== onFiles ? (t8 = (event_3) => {
      if (onFiles) {
        if (Array.from(event_3.dataTransfer.items).map(_temp4$i).some(_temp5$a))
          return;
        event_3.preventDefault(), event_3.stopPropagation();
      }
    }, $[24] = onFiles, $[25] = t8) : t8 = $[25];
    const handleDragOver = t8;
    let t9;
    $[26] !== onFilesOver ? (t9 = (event_4) => {
      const fileTypes_1 = Array.from(event_4.dataTransfer.items).map(_temp6$5);
      fileTypes_1.some(_temp7$2) || (event_4.stopPropagation(), onFilesOver && ref.current === event_4.currentTarget && (enteredElements.current = [...new Set(enteredElements.current), event_4.currentTarget], onFilesOver(fileTypes_1)));
    }, $[26] = onFilesOver, $[27] = t9) : t9 = $[27];
    const handleDragEnter = t9;
    let t10;
    $[28] !== onFilesOut ? (t10 = (event_5) => {
      if (Array.from(event_5.dataTransfer.items).map(_temp8$1).some(_temp9))
        return;
      event_5.stopPropagation();
      const idx = enteredElements.current.indexOf(event_5.currentTarget);
      idx > -1 && enteredElements.current.splice(idx, 1), enteredElements.current.length === 0 && onFilesOut?.();
    }, $[28] = onFilesOut, $[29] = t10) : t10 = $[29];
    const handleDragLeave = t10, prevShowPasteInput = useRef(!1);
    let t11;
    $[30] !== showPasteInput ? (t11 = () => {
      !prevShowPasteInput.current && showPasteInput && pasteInput.current ? (pasteInput.current.focus(), select(pasteInput.current)) : prevShowPasteInput.current && !showPasteInput && pasteInput.current?.focus(), prevShowPasteInput.current = showPasteInput;
    }, $[30] = showPasteInput, $[31] = t11) : t11 = $[31];
    let t12;
    $[32] !== pasteTarget || $[33] !== showPasteInput ? (t12 = [pasteTarget, showPasteInput], $[32] = pasteTarget, $[33] = showPasteInput, $[34] = t12) : t12 = $[34], useEffect(t11, t12);
    const t13 = rest, t14 = disabled ? void 0 : handleKeyDown, t15 = disabled ? void 0 : handleDragOver, t16 = disabled ? void 0 : handleDragEnter, t17 = disabled ? void 0 : handleDragLeave, t18 = disabled ? void 0 : handleDrop;
    let t19;
    $[35] !== t13 || $[36] !== t14 || $[37] !== t15 || $[38] !== t16 || $[39] !== t17 || $[40] !== t18 ? (t19 = /* @__PURE__ */ jsx(Component2, { ...t13, ref, onKeyDown: t14, onDragOver: t15, onDragEnter: t16, onDragLeave: t17, onDrop: t18, "data-test-id": "file-target", ...fileTargetDataAttribute }), $[35] = t13, $[36] = t14, $[37] = t15, $[38] = t16, $[39] = t17, $[40] = t18, $[41] = t19) : t19 = $[41];
    let t20;
    $[42] !== disabled || $[43] !== handlePaste || $[44] !== showPasteInput ? (t20 = !disabled && showPasteInput && /* @__PURE__ */ jsx("div", { contentEditable: !0, onPaste: handlePaste, ref: pasteInput, style: PASTE_INPUT_STYLE }), $[42] = disabled, $[43] = handlePaste, $[44] = showPasteInput, $[45] = t20) : t20 = $[45];
    let t21;
    return $[46] !== t19 || $[47] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
      t19,
      t20
    ] }), $[46] = t19, $[47] = t20, $[48] = t21) : t21 = $[48], t21;
  });
}
function convertImagesToFilesAndClearContentEditable(element, targetFormat = "image/jpeg") {
  return element.isContentEditable ? new Promise((resolve) => setTimeout(resolve, 10)).then(() => Array.from(element.querySelectorAll("img"))).then((imageElements) => (element.innerHTML = "", imageElements)).then((images) => Promise.all(images.map((img) => imageUrlToBlob(img.src)))).then((imageBlobs) => imageBlobs.map((blob) => new File([blob], "pasted-image.jpg", {
    type: targetFormat
  }))) : Promise.reject(new Error(`Expected element to be contentEditable="true". Instead found a non contenteditable ${element.tagName}`));
}
function select(el) {
  const range2 = document.createRange();
  range2.selectNodeContents(el);
  const sel = window.getSelection();
  sel?.removeAllRanges(), sel?.addRange(range2);
}
function _temp$3d(t) {
  const normalized = t.replace(/^web /, "");
  return normalized === "application/portable-text" || normalized === "application/x-portable-text";
}
function _temp2$1n(item) {
  return {
    type: item.type,
    kind: item.kind
  };
}
function _temp3$F(item_0) {
  return isPortableTextItem(item_0);
}
function _temp4$i(item_1) {
  return {
    type: item_1.type,
    kind: item_1.kind
  };
}
function _temp5$a(item_2) {
  return isPortableTextItem(item_2);
}
function _temp6$5(item_3) {
  return {
    type: item_3.type,
    kind: item_3.kind
  };
}
function _temp7$2(item_4) {
  return isPortableTextItem(item_4);
}
function _temp8$1(item_5) {
  return {
    type: item_5.type,
    kind: item_5.kind
  };
}
function _temp9(item_6) {
  return isPortableTextItem(item_6);
}
function UploadDestinationPicker(props2) {
  const $ = c(21), {
    assetSources,
    onSelectAssetSource,
    text,
    onClose
  } = props2, {
    t
  } = useTranslation(), assetSourcesWithUpload = getAssetSourcesWithUpload(assetSources);
  let t0;
  $[0] !== assetSources || $[1] !== onSelectAssetSource ? (t0 = (event) => {
    const sourceName2 = event.currentTarget.getAttribute("data-asset-source-name"), assetSource = assetSources.find((source) => source.name === sourceName2);
    assetSource && onSelectAssetSource && onSelectAssetSource(assetSource);
  }, $[0] = assetSources, $[1] = onSelectAssetSource, $[2] = t0) : t0 = $[2];
  const handleClick = t0;
  let t1;
  if ($[3] !== onClose ? (t1 = (event_0) => {
    event_0.key === "Escape" && onClose && onClose();
  }, $[3] = onClose, $[4] = t1) : t1 = $[4], useGlobalKeyDown(t1), assetSourcesWithUpload.length === 0)
    return null;
  const T0 = Dialog$1, t2 = "upload-destination-picker";
  let t3;
  $[5] !== text ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: text }), $[5] = text, $[6] = t3) : t3 = $[6];
  const t4 = 1, t5 = "stretch", T1 = Box, t6 = 2, T2 = Stack, t7 = 2;
  let t8;
  $[7] !== handleClick || $[8] !== t ? (t8 = (assetSource_0) => {
    const Icon2 = assetSource_0.icon;
    return /* @__PURE__ */ jsx(Button, { "data-asset-source-name": assetSource_0.name, "data-testid": `upload-destination-${assetSource_0.name}`, mode: "bleed", onClick: handleClick, size: "large", tone: "default", tooltipProps: null, children: /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
      isValidElementType(Icon2) && /* @__PURE__ */ jsx(Icon2, { style: {
        fontSize: "2rem"
      } }),
      /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { children: getAssetSourceDisplayName(assetSource_0, t) }) })
    ] }) }, assetSource_0.name);
  }, $[7] = handleClick, $[8] = t, $[9] = t8) : t8 = $[9];
  const t9 = assetSourcesWithUpload.map(t8);
  let t10;
  $[10] !== T2 || $[11] !== t9 ? (t10 = /* @__PURE__ */ jsx(T2, { space: t7, children: t9 }), $[10] = T2, $[11] = t9, $[12] = t10) : t10 = $[12];
  let t11;
  $[13] !== T1 || $[14] !== t10 ? (t11 = /* @__PURE__ */ jsx(T1, { padding: t6, children: t10 }), $[13] = T1, $[14] = t10, $[15] = t11) : t11 = $[15];
  let t12;
  return $[16] !== T0 || $[17] !== onClose || $[18] !== t11 || $[19] !== t3 ? (t12 = /* @__PURE__ */ jsx(T0, { onClickOutside: onClose, onClose, id: t2, header: t3, width: t4, bodyHeight: t5, children: t11 }), $[16] = T0, $[17] = onClose, $[18] = t11, $[19] = t3, $[20] = t12) : t12 = $[20], t12;
}
const Overlay$2 = styled(Layer).withConfig({
  displayName: "Overlay",
  componentId: "sc-gjp33r-0"
})`position:absolute;display:flex;flex-direction:column;align-items:center;justify-content:center;top:-2px;left:-2px;right:-2px;bottom:-2px;background-color:var(--card-bg-color);opacity:0.8;`, Root$s = styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-tyjytc-0"
})`position:relative;`;
function uploadTarget$1(Component2) {
  const FileTarget = fileTarget(Component2);
  return forwardRef(function(props2, forwardedRef) {
    const $ = c(91);
    let assetSourcesProp, children, isReadOnly, onOpenSourceForUpload, onSelectFile, onSetHoveringFiles, pasteTarget, rest, toneFromProps, types;
    $[0] !== props2 ? ({
      children,
      isReadOnly,
      onOpenSourceForUpload,
      onSelectFile,
      onSetHoveringFiles,
      assetSources: assetSourcesProp,
      types,
      tone: toneFromProps,
      pasteTarget,
      ...rest
    } = props2, $[0] = props2, $[1] = assetSourcesProp, $[2] = children, $[3] = isReadOnly, $[4] = onOpenSourceForUpload, $[5] = onSelectFile, $[6] = onSetHoveringFiles, $[7] = pasteTarget, $[8] = rest, $[9] = toneFromProps, $[10] = types) : (assetSourcesProp = $[1], children = $[2], isReadOnly = $[3], onOpenSourceForUpload = $[4], onSelectFile = $[5], onSetHoveringFiles = $[6], pasteTarget = $[7], rest = $[8], toneFromProps = $[9], types = $[10]);
    const {
      push: pushToast
    } = useToast(), {
      t
    } = useTranslation(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), source = useSource(), formBuilder = useFormBuilder();
    let t0;
    if ($[11] !== types) {
      const assetTypes = types.filter(_temp$3c);
      t0 = assetTypes.length > 0 && assetTypes.every(_temp2$1m), $[11] = types, $[12] = t0;
    } else
      t0 = $[12];
    const disableUpload = t0, t1 = source.title || source.name;
    let t2;
    $[13] !== client || $[14] !== t1 ? (t2 = createDatasetImageAssetSource({
      client,
      title: t1
    }), $[13] = client, $[14] = t1, $[15] = t2) : t2 = $[15];
    const defaultImageAssetSource = t2, t3 = source.title || source.name;
    let t4;
    $[16] !== client || $[17] !== t3 ? (t4 = createDatasetFileAssetSource({
      client,
      title: t3
    }), $[16] = client, $[17] = t3, $[18] = t4) : t4 = $[18];
    const defaultFileAssetSource = t4;
    let t5;
    $[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = [], $[19] = t5) : t5 = $[19];
    const [filesToUpload, setFilesToUpload] = useState(t5), [showAssetSourceDestinationPicker, setShowAssetSourceDestinationPicker] = useState(!1), [tone, setTone] = useState(toneFromProps || (isReadOnly ? "transparent" : "default")), assetSourceDestinationName = useRef(null);
    let t6;
    $[20] !== pushToast || $[21] !== t ? (t6 = (rejected) => {
      pushToast({
        closable: !0,
        status: "warning",
        title: t("inputs.array.error.cannot-upload-unable-to-convert", {
          count: rejected.length
        }),
        description: rejected.map(_temp3$E)
      });
    }, $[20] = pushToast, $[21] = t, $[22] = t6) : t6 = $[22];
    const alertRejectedFiles = t6;
    let t7;
    $[23] !== alertRejectedFiles || $[24] !== assetSourcesProp || $[25] !== defaultFileAssetSource || $[26] !== defaultImageAssetSource || $[27] !== formBuilder || $[28] !== onOpenSourceForUpload || $[29] !== onSelectFile || $[30] !== types ? (t7 = (files) => {
      const filesAndAssetSources = getFilesAndAssetSources({
        files,
        types,
        assetSourceDestinationName: assetSourceDestinationName.current,
        formBuilder,
        defaultImageAssetSource,
        defaultFileAssetSource,
        assetSources: assetSourcesProp
      }), ready = filesAndAssetSources.filter(_temp4$h), rejected_0 = filesAndAssetSources.filter(_temp5$9);
      rejected_0.length > 0 && alertRejectedFiles(rejected_0);
      const firstReady = ready[0];
      if (firstReady?.assetSource && isComponentModeAssetSource(firstReady.assetSource) && onOpenSourceForUpload) {
        onOpenSourceForUpload(firstReady.assetSource);
        return;
      }
      onSelectFile && ready.forEach((entry_1) => {
        onSelectFile({
          assetSource: entry_1.assetSource,
          schemaType: entry_1.schemaType,
          file: entry_1.file
        });
      });
    }, $[23] = alertRejectedFiles, $[24] = assetSourcesProp, $[25] = defaultFileAssetSource, $[26] = defaultImageAssetSource, $[27] = formBuilder, $[28] = onOpenSourceForUpload, $[29] = onSelectFile, $[30] = types, $[31] = t7) : t7 = $[31];
    const handleUploadFiles = t7;
    let t8;
    $[32] !== alertRejectedFiles || $[33] !== assetSourcesProp || $[34] !== defaultFileAssetSource || $[35] !== defaultImageAssetSource || $[36] !== disableUpload || $[37] !== formBuilder || $[38] !== handleUploadFiles || $[39] !== isReadOnly || $[40] !== types ? (t8 = (files_0) => {
      if (isReadOnly || disableUpload || types.length === 0)
        return;
      const filesAndAssetSources_0 = getFilesAndAssetSources({
        files: files_0,
        types,
        assetSourceDestinationName: assetSourceDestinationName.current,
        formBuilder,
        defaultImageAssetSource,
        defaultFileAssetSource,
        assetSources: assetSourcesProp
      }), ready_0 = filesAndAssetSources_0.filter(_temp6$4);
      if (ready_0.length === 0) {
        filesAndAssetSources_0.length > 0 && alertRejectedFiles(filesAndAssetSources_0);
        return;
      }
      const uploadAssetSources = assetSourcesProp ? getAssetSourcesWithUpload(assetSourcesProp) : types.flatMap((type_1) => resolveUploadAssetSources?.(type_1, formBuilder) ?? []);
      if (uniqBy(uploadAssetSources, "name").length > 1 && assetSourceDestinationName.current === null) {
        setShowAssetSourceDestinationPicker(!0), setFilesToUpload(files_0);
        return;
      }
      setShowAssetSourceDestinationPicker(!1), setFilesToUpload([]), handleUploadFiles(ready_0.map(_temp7$1));
    }, $[32] = alertRejectedFiles, $[33] = assetSourcesProp, $[34] = defaultFileAssetSource, $[35] = defaultImageAssetSource, $[36] = disableUpload, $[37] = formBuilder, $[38] = handleUploadFiles, $[39] = isReadOnly, $[40] = types, $[41] = t8) : t8 = $[41];
    const handleFiles = t8;
    let t9;
    $[42] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = [], $[42] = t9) : t9 = $[42];
    const [hoveringFiles, setHoveringFiles] = useState(t9);
    let t10;
    $[43] !== assetSourcesProp || $[44] !== formBuilder || $[45] !== types ? (t10 = (file) => assetSourcesProp && assetSourcesProp.length > 0 && file.kind === "file" ? findMatchingSchemaType(file, types) !== null : types.some((type_2) => resolveUploadAssetSources(type_2, formBuilder, file).length > 0), $[43] = assetSourcesProp, $[44] = formBuilder, $[45] = types, $[46] = t10) : t10 = $[46];
    const isFileAccepted = t10;
    let t11;
    $[47] !== disableUpload || $[48] !== isFileAccepted || $[49] !== isReadOnly || $[50] !== onSetHoveringFiles ? (t11 = (files_1) => {
      if (isReadOnly || disableUpload)
        return;
      setHoveringFiles(files_1);
      const acceptedFiles = files_1.filter(isFileAccepted);
      files_1.length - acceptedFiles.length > 0 ? setTone("critical") : acceptedFiles.length > 0 ? setTone("primary") : setTone("default"), onSetHoveringFiles && onSetHoveringFiles(files_1);
    }, $[47] = disableUpload, $[48] = isFileAccepted, $[49] = isReadOnly, $[50] = onSetHoveringFiles, $[51] = t11) : t11 = $[51];
    const handleFilesOver = t11;
    let t12;
    $[52] !== disableUpload || $[53] !== isReadOnly || $[54] !== onSetHoveringFiles ? (t12 = () => {
      isReadOnly || disableUpload || (setHoveringFiles([]), setTone("default"), onSetHoveringFiles && onSetHoveringFiles([]), setFilesToUpload([]));
    }, $[52] = disableUpload, $[53] = isReadOnly, $[54] = onSetHoveringFiles, $[55] = t12) : t12 = $[55];
    const handleFilesOut = t12;
    let t13;
    if ($[56] !== assetSourcesProp || $[57] !== formBuilder || $[58] !== types) {
      const allAssetSourcesWithUpload = assetSourcesProp ? getAssetSourcesWithUpload(assetSourcesProp) : types.flatMap((type_3) => resolveUploadAssetSources?.(type_3, formBuilder) ?? []);
      t13 = uniqBy(allAssetSourcesWithUpload, "name"), $[56] = assetSourcesProp, $[57] = formBuilder, $[58] = types, $[59] = t13;
    } else
      t13 = $[59];
    const assetSourcesWithUploadByName = t13;
    let t14;
    $[60] !== filesToUpload || $[61] !== handleUploadFiles || $[62] !== onOpenSourceForUpload ? (t14 = (assetSource) => {
      if (setShowAssetSourceDestinationPicker(!1), !assetSource) {
        setFilesToUpload([]), assetSourceDestinationName.current = null;
        return;
      }
      if (isComponentModeAssetSource(assetSource) && onOpenSourceForUpload) {
        onOpenSourceForUpload(assetSource), setFilesToUpload([]), assetSourceDestinationName.current = null;
        return;
      }
      assetSourceDestinationName.current = assetSource.name, filesToUpload.length > 0 && handleUploadFiles(filesToUpload), setFilesToUpload([]), assetSourceDestinationName.current = null;
    }, $[60] = filesToUpload, $[61] = handleUploadFiles, $[62] = onOpenSourceForUpload, $[63] = t14) : t14 = $[63];
    const handleSetAssetSourceDestination = t14;
    let t15;
    $[64] !== handleFilesOver ? (t15 = () => {
      handleFilesOver([]), setFilesToUpload([]), setShowAssetSourceDestinationPicker(!1), assetSourceDestinationName.current = null;
    }, $[64] = handleFilesOver, $[65] = t15) : t15 = $[65];
    const handleUploadDestinationPickerClose = t15, t16 = types.length > 1 ? "array" : types[0].name;
    let t17;
    $[66] !== t || $[67] !== t16 ? (t17 = t("inputs.files.common.placeholder.select-asset-source-upload-destination", {
      context: t16
    }), $[66] = t, $[67] = t16, $[68] = t17) : t17 = $[68];
    const uploadDestinationPickerText = t17;
    let t18;
    $[69] !== assetSourcesWithUploadByName || $[70] !== handleSetAssetSourceDestination || $[71] !== handleUploadDestinationPickerClose || $[72] !== showAssetSourceDestinationPicker || $[73] !== uploadDestinationPickerText ? (t18 = showAssetSourceDestinationPicker && /* @__PURE__ */ jsx(UploadDestinationPicker, { assetSources: assetSourcesWithUploadByName, onSelectAssetSource: handleSetAssetSourceDestination, onClose: handleUploadDestinationPickerClose, text: uploadDestinationPickerText }), $[69] = assetSourcesWithUploadByName, $[70] = handleSetAssetSourceDestination, $[71] = handleUploadDestinationPickerClose, $[72] = showAssetSourceDestinationPicker, $[73] = uploadDestinationPickerText, $[74] = t18) : t18 = $[74];
    const t19 = toneFromProps || tone;
    let t20;
    $[75] !== hoveringFiles || $[76] !== types ? (t20 = hoveringFiles.length > 0 && /* @__PURE__ */ jsx(Overlay$2, { zOffset: 10, children: /* @__PURE__ */ jsx(DropMessage$1, { hoveringFiles, types }) }), $[75] = hoveringFiles, $[76] = types, $[77] = t20) : t20 = $[77];
    let t21;
    $[78] !== children || $[79] !== forwardedRef || $[80] !== handleFiles || $[81] !== handleFilesOut || $[82] !== handleFilesOver || $[83] !== pasteTarget || $[84] !== rest || $[85] !== t19 || $[86] !== t20 ? (t21 = /* @__PURE__ */ jsxs(FileTarget, { ...rest, tone: t19, ref: forwardedRef, onFiles: handleFiles, onFilesOver: handleFilesOver, onFilesOut: handleFilesOut, pasteTarget, children: [
      t20,
      children
    ] }), $[78] = children, $[79] = forwardedRef, $[80] = handleFiles, $[81] = handleFilesOut, $[82] = handleFilesOver, $[83] = pasteTarget, $[84] = rest, $[85] = t19, $[86] = t20, $[87] = t21) : t21 = $[87];
    let t22;
    return $[88] !== t18 || $[89] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Root$s, { children: [
      t18,
      t21
    ] }), $[88] = t18, $[89] = t21, $[90] = t22) : t22 = $[90], t22;
  });
}
function resolveAssetSourceWithFallback(resolvedSource, defaultSource) {
  return resolvedSource === void 0 ? null : resolvedSource.Uploader || isComponentModeAssetSource(resolvedSource) ? resolvedSource : defaultSource;
}
function findMatchingAssetSource(schemaType, formBuilder, file, assetSourceDestinationName) {
  if (schemaType !== void 0)
    return resolveUploadAssetSources(schemaType, formBuilder, file).find((source) => assetSourceDestinationName === null || source.name === assetSourceDestinationName);
}
function getFilesAndAssetSources(options) {
  const {
    files,
    types,
    assetSourceDestinationName,
    formBuilder,
    defaultImageAssetSource,
    defaultFileAssetSource,
    assetSources
  } = options, imageType = types.find((type) => _isType(type, "image")), fileType = types.find((type) => _isType(type, "file")), videoType = types.find((type) => _isType(type, "sanity.video"));
  return files.map((file) => {
    const resolvedImageSource = (assetSources?.length && imageType && file.type.startsWith("image/") ? assetSources.find((src) => assetSourceDestinationName === null || src.name === assetSourceDestinationName) ?? assetSources[0] : void 0) ?? findMatchingAssetSource(imageType, formBuilder, file, assetSourceDestinationName), imageAssetSource = resolveAssetSourceWithFallback(resolvedImageSource, defaultImageAssetSource);
    if (imageType && file.type.startsWith("image/") && imageAssetSource && matchesSchemaTypeAccept(file, imageType, "image"))
      return {
        file,
        schemaType: imageType,
        assetSource: imageAssetSource
      };
    const resolvedFileSource = (assetSources?.length && fileType ? assetSources.find((src) => assetSourceDestinationName === null || src.name === assetSourceDestinationName) ?? assetSources[0] : void 0) ?? findMatchingAssetSource(fileType, formBuilder, file, assetSourceDestinationName), fileAssetSource = resolveAssetSourceWithFallback(resolvedFileSource, defaultFileAssetSource);
    if (fileType && fileAssetSource)
      return matchesSchemaTypeAccept(file, fileType, "file") ? {
        file,
        schemaType: fileType,
        assetSource: fileAssetSource
      } : {
        file,
        schemaType: fileType,
        assetSource: null
      };
    let videoAssetSource = null;
    if (videoType && file.type.startsWith("video/") && matchesSchemaTypeAccept(file, videoType, "video"))
      if (assetSources && assetSources.length > 0)
        videoAssetSource = assetSources.find((src) => assetSourceDestinationName === null || src.name === assetSourceDestinationName) ?? assetSources[0] ?? null;
      else {
        const resolvedVideoSource = findMatchingAssetSource(videoType, formBuilder, file, assetSourceDestinationName);
        videoAssetSource = resolveAssetSourceWithFallback(resolvedVideoSource, defaultFileAssetSource);
      }
    return videoType && file.type.startsWith("video/") && videoAssetSource ? {
      file,
      schemaType: videoType,
      assetSource: videoAssetSource
    } : {
      file,
      schemaType: null,
      assetSource: null
    };
  });
}
function _temp$3c(type) {
  return _isType(type, "image") || _isType(type, "file") || _isType(type, "sanity.video");
}
function _temp2$1m(type_0) {
  return type_0.options?.disableNew === !0;
}
function _temp3$E(task, i) {
  return /* @__PURE__ */ jsxs(Flex, { gap: 2, padding: 2, children: [
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: task.file.name }) }),
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
      "(",
      task.file.type,
      ")"
    ] }) })
  ] }, i);
}
function _temp4$h(entry) {
  return entry.assetSource !== null;
}
function _temp5$9(entry_0) {
  return entry_0.assetSource === null;
}
function _temp6$4(entry_2) {
  return entry_2.assetSource !== null;
}
function _temp7$1(entry_3) {
  return entry_3.file;
}
const StyledCard$3 = styled(Card).withConfig({
  displayName: "StyledCard",
  componentId: "sc-1vye6ga-0"
})`height:100%;`, UploadTargetCard$1 = withFocusRing(uploadTarget$1(StyledCard$3)), normalizeRules = (validation2, type) => {
  if (typeof validation2 == "function")
    throw new Error(`Schema type "${type?.name || "<not-found>"}"'s \`validation\` was not run though \`inferFromSchema\``);
  return validation2 ? Array.isArray(validation2) ? validation2 : [validation2] : [];
};
function getValidationRule(type, ruleName) {
  for (const rule of normalizeRules(type?.validation, type))
    for (const ruleSpec of rule._rules)
      if (ruleSpec.flag === ruleName)
        return ruleSpec;
  return null;
}
function ArrayValidationProvider(props2) {
  const $ = c(11), {
    children,
    schemaType,
    itemCount
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== schemaType ? (t0 = getValidationRule(schemaType, "max"), $[0] = schemaType, $[1] = t0) : t0 = $[1];
  const maxConstraint = t0?.constraint, maxReached = typeof maxConstraint == "number" && itemCount >= maxConstraint;
  let t1;
  $[2] !== maxReached || $[3] !== t ? (t1 = maxReached ? t("inputs.array.action.max-reached") : void 0, $[2] = maxReached, $[3] = t, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== maxReached || $[6] !== t1 ? (t2 = {
    maxReached,
    maxReachedReason: t1
  }, $[5] = maxReached, $[6] = t1, $[7] = t2) : t2 = $[7];
  const value = t2;
  let t3;
  return $[8] !== children || $[9] !== value ? (t3 = /* @__PURE__ */ jsx(ArrayValidationContext.Provider, { value, children }), $[8] = children, $[9] = value, $[10] = t3) : t3 = $[10], t3;
}
function useArrayValidation() {
  return useContext(ArrayValidationContext);
}
function restrictToBoundingRect(transform, rect, boundingRect, margins) {
  const value = {
    ...transform
  }, marginY = margins.y, marginX = margins.x || 0;
  return rect.top + value.y <= boundingRect.top + marginY ? value.y = boundingRect.top - rect.top + marginY : rect.bottom + value.y >= boundingRect.top + boundingRect.height - marginY && (value.y = boundingRect.top + boundingRect.height - rect.bottom - marginY), rect.left + value.x <= boundingRect.left - marginX ? value.x = boundingRect.left - rect.left + marginX : rect.right + value.x >= boundingRect.left + boundingRect.width + marginX && (value.x = boundingRect.left + boundingRect.width - rect.right + marginX), value;
}
const restrictToParentElementWithMargins = (margins) => ({
  containerNodeRect,
  draggingNodeRect,
  transform
}) => !draggingNodeRect || !containerNodeRect ? transform : restrictToBoundingRect(transform, draggingNodeRect, containerNodeRect, margins), MOVING_ITEM_CLASS_NAME = "moving", ListItem$2 = styled(Box).withConfig({
  displayName: "ListItem",
  componentId: "sc-fbh2lc-0"
})`${(props2) => props2.$moving && css`
      z-index: 10000;
      /* prevents hover-effects etc on the dragged element  */
      pointer-events: none;
    `}`, AUTO_SCROLL_OPTIONS = {
  threshold: {
    x: 0,
    y: 0.02
  }
}, SENSOR_OPTIONS = {
  coordinateGetter: sortableKeyboardCoordinates
}, TRANSITION = {
  duration: 200,
  easing: "ease"
};
function restrictToAxis(axis) {
  return axis === "x" ? restrictToHorizontalAxis : restrictToVerticalAxis;
}
function sortingStrategy(axis) {
  return axis === "x" ? horizontalListSortingStrategy : verticalListSortingStrategy;
}
const SortableList = memo(function(props2) {
  const $ = c(29);
  let axis, children, items, onItemMove, onItemMoveEnd, onItemMoveStart, rest;
  $[0] !== props2 ? ({
    items,
    axis,
    onItemMove,
    onItemMoveStart,
    onItemMoveEnd,
    children,
    ...rest
  } = props2, $[0] = props2, $[1] = axis, $[2] = children, $[3] = items, $[4] = onItemMove, $[5] = onItemMoveEnd, $[6] = onItemMoveStart, $[7] = rest) : (axis = $[1], children = $[2], items = $[3], onItemMove = $[4], onItemMoveEnd = $[5], onItemMoveStart = $[6], rest = $[7]);
  const sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, SENSOR_OPTIONS));
  let t0;
  $[8] !== onItemMove || $[9] !== onItemMoveEnd ? (t0 = (event) => {
    const {
      active,
      over
    } = event;
    active.id !== over?.id && onItemMove?.({
      fromIndex: active.data.current?.sortable?.index,
      toIndex: over?.data.current?.sortable?.index
    }), onItemMoveEnd?.();
  }, $[8] = onItemMove, $[9] = onItemMoveEnd, $[10] = t0) : t0 = $[10];
  const handleDragEnd = t0;
  let t1;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = restrictToParentElementWithMargins({
    y: 4
  }), $[11] = t1) : t1 = $[11];
  let t2;
  $[12] !== axis ? (t2 = [t1, ...axis ? [restrictToAxis(axis)] : []], $[12] = axis, $[13] = t2) : t2 = $[13];
  const modifiers = t2;
  let t3;
  $[14] !== axis ? (t3 = axis ? sortingStrategy(axis) : void 0, $[14] = axis, $[15] = t3) : t3 = $[15];
  let t4;
  $[16] !== children || $[17] !== rest ? (t4 = /* @__PURE__ */ jsx(Grid, { ...rest, children }), $[16] = children, $[17] = rest, $[18] = t4) : t4 = $[18];
  let t5;
  $[19] !== items || $[20] !== t3 || $[21] !== t4 ? (t5 = /* @__PURE__ */ jsx(SortableContext, { items, strategy: t3, children: t4 }), $[19] = items, $[20] = t3, $[21] = t4, $[22] = t5) : t5 = $[22];
  let t6;
  return $[23] !== handleDragEnd || $[24] !== modifiers || $[25] !== onItemMoveStart || $[26] !== sensors || $[27] !== t5 ? (t6 = /* @__PURE__ */ jsx(DndContext, { sensors, autoScroll: AUTO_SCROLL_OPTIONS, modifiers, collisionDetection: closestCenter, onDragEnd: handleDragEnd, onDragStart: onItemMoveStart, children: t5 }), $[23] = handleDragEnd, $[24] = modifiers, $[25] = onItemMoveStart, $[26] = sensors, $[27] = t5, $[28] = t6) : t6 = $[28], t6;
}), SortableListItem = forwardRef(function(props2, ref) {
  const $ = c(19), {
    id: id2,
    children,
    disableTransition
  } = props2, t0 = disableTransition ? null : TRANSITION;
  let t1;
  $[0] !== id2 || $[1] !== t0 ? (t1 = {
    id: id2,
    transition: t0
  }, $[0] = id2, $[1] = t0, $[2] = t1) : t1 = $[2];
  const {
    setNodeRef,
    transform,
    transition,
    active
  } = useSortable(t1), isActive = id2 === active?.id;
  let t2;
  $[3] !== transform ? (t2 = CSS$1.Translate.toString(transform), $[3] = transform, $[4] = t2) : t2 = $[4];
  const t3 = active ? "none" : void 0;
  let t4;
  $[5] !== t2 || $[6] !== t3 || $[7] !== transition ? (t4 = {
    transform: t2,
    transition,
    pointerEvents: t3
  }, $[5] = t2, $[6] = t3, $[7] = transition, $[8] = t4) : t4 = $[8];
  const style = t4;
  let t5;
  $[9] !== ref || $[10] !== setNodeRef ? (t5 = (node) => {
    setNodeRef(node), typeof ref == "function" ? ref(node) : ref && (ref.current = node);
  }, $[9] = ref, $[10] = setNodeRef, $[11] = t5) : t5 = $[11];
  const setRef = t5, t6 = isActive ? MOVING_ITEM_CLASS_NAME : "", t7 = props2["data-index"];
  let t8;
  return $[12] !== children || $[13] !== isActive || $[14] !== setRef || $[15] !== style || $[16] !== t6 || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(ListItem$2, { ref: setRef, style, $moving: isActive, className: t6, "data-index": t7, children }), $[12] = children, $[13] = isActive, $[14] = setRef, $[15] = style, $[16] = t6, $[17] = t7, $[18] = t8) : t8 = $[18], t8;
});
function List(props2) {
  const $ = c(14);
  let onItemMove, onItemMoveEnd, onItemMoveStart, rest, sortable;
  $[0] !== props2 ? ({
    onItemMove,
    onItemMoveEnd,
    onItemMoveStart,
    sortable,
    ...rest
  } = props2, $[0] = props2, $[1] = onItemMove, $[2] = onItemMoveEnd, $[3] = onItemMoveStart, $[4] = rest, $[5] = sortable) : (onItemMove = $[1], onItemMoveEnd = $[2], onItemMoveStart = $[3], rest = $[4], sortable = $[5]);
  let t0;
  $[6] !== onItemMove ? (t0 = (event) => {
    onItemMove?.(event);
  }, $[6] = onItemMove, $[7] = t0) : t0 = $[7];
  const handleSortEnd = t0;
  let t1;
  return $[8] !== handleSortEnd || $[9] !== onItemMoveEnd || $[10] !== onItemMoveStart || $[11] !== rest || $[12] !== sortable ? (t1 = sortable ? /* @__PURE__ */ jsx(SortableList, { onItemMove: handleSortEnd, onItemMoveStart, onItemMoveEnd, ...rest }) : /* @__PURE__ */ jsx(Grid, { ...rest }), $[8] = handleSortEnd, $[9] = onItemMoveEnd, $[10] = onItemMoveStart, $[11] = rest, $[12] = sortable, $[13] = t1) : t1 = $[13], t1;
}
const Item = forwardRef(function(props2, ref) {
  const $ = c(12);
  let disableTransition, rest, sortable;
  $[0] !== props2 ? ({
    sortable,
    disableTransition,
    ...rest
  } = props2, $[0] = props2, $[1] = disableTransition, $[2] = rest, $[3] = sortable) : (disableTransition = $[1], rest = $[2], sortable = $[3]);
  let t0;
  $[4] !== disableTransition || $[5] !== ref || $[6] !== rest || $[7] !== sortable ? (t0 = sortable ? /* @__PURE__ */ jsx(SortableListItem, { ref, disableTransition, ...rest }) : /* @__PURE__ */ jsx(ListItem$2, { ref, ...rest }), $[4] = disableTransition, $[5] = ref, $[6] = rest, $[7] = sortable, $[8] = t0) : t0 = $[8];
  let t1;
  return $[9] !== props2.id || $[10] !== t0 ? (t1 = /* @__PURE__ */ jsx(SortableItemIdContext.Provider, { value: props2.id, children: t0 }), $[9] = props2.id, $[10] = t0, $[11] = t1) : t1 = $[11], t1;
});
function popoverReducer(state, event) {
  return event.type === "toggle" ? {
    open: !state.open
  } : {
    open: !1
  };
}
function useInsertMenuPopover(props2) {
  const $ = c(22);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    open: !1
  }, $[0] = t0) : t0 = $[0];
  const [state, send] = useReducer(popoverReducer, t0), popoverRef = useRef(null), referenceElement = props2.popoverProps.referenceElement ?? null;
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => send({
    type: "close"
  }), $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== referenceElement ? (t2 = () => [popoverRef.current, referenceElement], $[2] = referenceElement, $[3] = t2) : t2 = $[3], useClickOutsideEvent(t1, t2);
  let t3;
  $[4] !== referenceElement || $[5] !== state.open ? (t3 = (event) => {
    event.key === "Escape" && state.open && (send({
      type: "close"
    }), referenceElement?.focus());
  }, $[4] = referenceElement, $[5] = state.open, $[6] = t3) : t3 = $[6], useGlobalKeyDown(t3);
  let insertMenuProps, onSelect;
  $[7] !== props2.insertMenuProps ? ({
    onSelect,
    ...insertMenuProps
  } = props2.insertMenuProps, $[7] = props2.insertMenuProps, $[8] = insertMenuProps, $[9] = onSelect) : (insertMenuProps = $[8], onSelect = $[9]);
  let t4;
  $[10] !== onSelect ? (t4 = (schemaType) => {
    onSelect(schemaType), send({
      type: "close"
    });
  }, $[10] = onSelect, $[11] = t4) : t4 = $[11];
  const handleOnSelect = t4;
  let t5;
  $[12] !== handleOnSelect || $[13] !== insertMenuProps ? (t5 = /* @__PURE__ */ jsx(InsertMenu$1, { ...insertMenuProps, onSelect: handleOnSelect }), $[12] = handleOnSelect, $[13] = insertMenuProps, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] !== props2.popoverProps || $[16] !== state.open || $[17] !== t5 ? (t6 = /* @__PURE__ */ jsx(Popover, { ref: popoverRef, open: state.open, constrainSize: !0, overflow: "hidden", portal: !0, content: t5, ...props2.popoverProps }), $[15] = props2.popoverProps, $[16] = state.open, $[17] = t5, $[18] = t6) : t6 = $[18];
  const popover = t6;
  let t7;
  return $[19] !== popover || $[20] !== state ? (t7 = {
    popover,
    state,
    send
  }, $[19] = popover, $[20] = state, $[21] = t7) : t7 = $[21], t7;
}
function InsertMenu$1(props2) {
  const $ = c(19), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("inputs.array.insert-menu.filter.all-items"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t ? (t1 = t("inputs.array.insert-menu.search.no-results"), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t ? (t2 = t("inputs.array.insert-menu.search.placeholder"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t ? (t3 = t("inputs.array.insert-menu.toggle-grid-view.tooltip"), $[6] = t, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t ? (t4 = t("inputs.array.insert-menu.toggle-list-view.tooltip"), $[8] = t, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== t0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 ? (t5 = {
    "insert-menu.filter.all-items": t0,
    "insert-menu.search.no-results": t1,
    "insert-menu.search.placeholder": t2,
    "insert-menu.toggle-grid-view.tooltip": t3,
    "insert-menu.toggle-list-view.tooltip": t4
  }, $[10] = t0, $[11] = t1, $[12] = t2, $[13] = t3, $[14] = t4, $[15] = t5) : t5 = $[15];
  let t6;
  return $[16] !== props2 || $[17] !== t5 ? (t6 = /* @__PURE__ */ jsx(InsertMenu$2, { ...props2, labels: t5 }), $[16] = props2, $[17] = t5, $[18] = t6) : t6 = $[18], t6;
}
function ArrayOfObjectsFunctions(props2) {
  const $ = c(51), {
    schemaType,
    readOnly,
    children,
    onValueCreate,
    onItemAppend,
    path
  } = props2, {
    t
  } = useTranslation(), maxReached = useArrayValidation()?.maxReached ?? !1, [gridElement, setGridElement] = useState(null), [popoverToggleElement, setPopoverToggleElement] = useState(null), telemetry = useTelemetry(), {
    enabled: enhancedObjectDialogEnabled
  } = useEnhancedObjectDialog();
  let t0;
  $[0] !== onItemAppend || $[1] !== onValueCreate ? (t0 = (itemType) => {
    const item = onValueCreate(itemType);
    onItemAppend(item);
  }, $[0] = onItemAppend, $[1] = onValueCreate, $[2] = t0) : t0 = $[2];
  const insertItem = t0;
  let t1;
  $[3] !== enhancedObjectDialogEnabled || $[4] !== insertItem || $[5] !== path || $[6] !== schemaType.of[0] || $[7] !== telemetry ? (t1 = () => {
    telemetry.log(CreatedNewObject, {
      path: pathToString$1(path),
      origin: enhancedObjectDialogEnabled ? "nested-object" : "default"
    }), insertItem(schemaType.of[0]);
  }, $[3] = enhancedObjectDialogEnabled, $[4] = insertItem, $[5] = path, $[6] = schemaType.of[0], $[7] = telemetry, $[8] = t1) : t1 = $[8];
  const handleAddBtnClick = t1, addItemI18nKey = schemaType.of.length > 1 ? "inputs.array.action.add-item-select-type" : "inputs.array.action.add-item";
  let t2;
  $[9] !== addItemI18nKey || $[10] !== t ? (t2 = t(addItemI18nKey), $[9] = addItemI18nKey, $[10] = t, $[11] = t2) : t2 = $[11];
  let t3;
  $[12] !== t2 ? (t3 = {
    icon: AddIcon,
    mode: "ghost",
    size: "large",
    text: t2
  }, $[12] = t2, $[13] = t3) : t3 = $[13];
  const insertButtonProps = t3, t4 = props2.schemaType.options?.insertMenu;
  let t5;
  $[14] !== insertItem || $[15] !== props2.schemaType.of || $[16] !== t4 ? (t5 = {
    ...t4,
    schemaTypes: props2.schemaType.of,
    onSelect: insertItem
  }, $[14] = insertItem, $[15] = props2.schemaType.of, $[16] = t4, $[17] = t5) : t5 = $[17];
  let t6;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = ["top"], $[18] = t6) : t6 = $[18];
  let t7;
  $[19] !== props2.schemaType.options?.insertMenu?.views ? (t7 = props2.schemaType.options?.insertMenu?.views?.some(_temp$3b), $[19] = props2.schemaType.options?.insertMenu?.views, $[20] = t7) : t7 = $[20];
  let t8;
  $[21] !== gridElement || $[22] !== popoverToggleElement || $[23] !== t7 ? (t8 = {
    placement: "bottom",
    fallbackPlacements: t6,
    matchReferenceWidth: t7,
    referenceBoundary: gridElement,
    referenceElement: popoverToggleElement
  }, $[21] = gridElement, $[22] = popoverToggleElement, $[23] = t7, $[24] = t8) : t8 = $[24];
  let t9;
  $[25] !== t5 || $[26] !== t8 ? (t9 = {
    insertMenuProps: t5,
    popoverProps: t8
  }, $[25] = t5, $[26] = t8, $[27] = t9) : t9 = $[27];
  const insertMenu = useInsertMenuPopover(t9);
  if (schemaType.options?.disableActions?.includes("add"))
    return null;
  if (readOnly) {
    let t102;
    $[28] !== t ? (t102 = t("inputs.array.read-only-label"), $[28] = t, $[29] = t102) : t102 = $[29];
    let t112;
    $[30] !== insertButtonProps ? (t112 = /* @__PURE__ */ jsx(Grid, { children: /* @__PURE__ */ jsx(Button, { ...insertButtonProps, "data-testid": "add-read-object-button", disabled: !0 }) }), $[30] = insertButtonProps, $[31] = t112) : t112 = $[31];
    let t122;
    return $[32] !== t102 || $[33] !== t112 ? (t122 = /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t102, children: t112 }), $[32] = t102, $[33] = t112, $[34] = t122) : t122 = $[34], t122;
  }
  if (maxReached) {
    let t102;
    $[35] !== t ? (t102 = t("inputs.array.action.max-reached"), $[35] = t, $[36] = t102) : t102 = $[36];
    let t112;
    $[37] !== insertButtonProps ? (t112 = /* @__PURE__ */ jsx(Grid, { children: /* @__PURE__ */ jsx(Button, { ...insertButtonProps, "data-testid": "add-max-reached-object-button", disabled: !0 }) }), $[37] = insertButtonProps, $[38] = t112) : t112 = $[38];
    let t122;
    return $[39] !== t102 || $[40] !== t112 ? (t122 = /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t102, children: t112 }), $[39] = t102, $[40] = t112, $[41] = t122) : t122 = $[41], t122;
  }
  let t10;
  $[42] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))"
  }, $[42] = t10) : t10 = $[42];
  let t11;
  $[43] !== handleAddBtnClick || $[44] !== insertButtonProps || $[45] !== insertMenu || $[46] !== schemaType.of.length ? (t11 = schemaType.of.length === 1 ? /* @__PURE__ */ jsx(Button, { ...insertButtonProps, onClick: handleAddBtnClick, "data-testid": "add-single-object-button" }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(Button, { ...insertButtonProps, "data-testid": "add-multiple-object-button", selected: insertMenu.state.open, onClick: () => {
      insertMenu.send({
        type: "toggle"
      });
    }, ref: setPopoverToggleElement }),
    insertMenu.popover
  ] }), $[43] = handleAddBtnClick, $[44] = insertButtonProps, $[45] = insertMenu, $[46] = schemaType.of.length, $[47] = t11) : t11 = $[47];
  let t12;
  return $[48] !== children || $[49] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Grid, { ref: setGridElement, gap: 1, style: t10, children: [
    t11,
    children
  ] }), $[48] = children, $[49] = t11, $[50] = t12) : t12 = $[50], t12;
}
function _temp$3b(view) {
  return view.name === "grid";
}
const DragHandleButton = /* @__PURE__ */ styled(Button).withConfig({
  displayName: "DragHandleButton",
  componentId: "sc-klpxfj-0"
})((props2) => {
  const {
    $grid,
    disabled
  } = props2;
  return disabled ? css`` : css`
    cursor: ${$grid ? "move" : "ns-resize"};
  `;
}), DragHandle = function(props2) {
  const $ = c(20), id2 = useContext(SortableItemIdContext);
  let readOnly, rest, t0;
  $[0] !== props2 ? ({
    mode: t0,
    readOnly,
    ...rest
  } = props2, $[0] = props2, $[1] = readOnly, $[2] = rest, $[3] = t0) : (readOnly = $[1], rest = $[2], t0 = $[3]);
  const mode = t0 === void 0 ? "bleed" : t0;
  let t1;
  $[4] !== id2 || $[5] !== readOnly ? (t1 = {
    id: id2,
    disabled: readOnly
  }, $[4] = id2, $[5] = readOnly, $[6] = t1) : t1 = $[6];
  const {
    listeners,
    attributes
  } = useSortable(t1), {
    t
  } = useTranslation();
  let t2;
  $[7] !== t ? (t2 = t("inputs.array.action.drag.tooltip"), $[7] = t, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    open: 1e3
  }, $[9] = t3) : t3 = $[9];
  const t4 = !!readOnly;
  let t5;
  $[10] !== t2 || $[11] !== t4 ? (t5 = {
    content: t2,
    delay: t3,
    disabled: t4
  }, $[10] = t2, $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  return $[13] !== attributes || $[14] !== listeners || $[15] !== mode || $[16] !== readOnly || $[17] !== rest || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsx(DragHandleButton, { icon: DragHandleIcon, tooltipProps: t5, mode, "data-ui": "DragHandleButton", ...rest, ...attributes, ...listeners, disabled: readOnly }), $[13] = attributes, $[14] = listeners, $[15] = mode, $[16] = readOnly, $[17] = rest, $[18] = t5, $[19] = t6) : t6 = $[19], t6;
}, FooterFlex = styled(Flex).withConfig({
  displayName: "FooterFlex",
  componentId: "sc-13lj9s7-0"
})`min-height:33px;`, PresenceFlex = styled(Flex).withConfig({
  displayName: "PresenceFlex",
  componentId: "sc-13lj9s7-1"
})`position:absolute;top:0;right:0;height:33px;`, DragHandleCard = styled(Card).withConfig({
  displayName: "DragHandleCard",
  componentId: "sc-13lj9s7-2"
})`position:absolute;top:0;left:0;`, Root$r = styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-13lj9s7-3"
})`transition:border-color 250ms;box-sizing:border-box;position:relative;@media (hover:hover){${DragHandleCard}{opacity:0;}&:hover,&:focus-within{${DragHandleCard}{opacity:1;}}}.${MOVING_ITEM_CLASS_NAME} &{box-shadow:0 0 0 0,0 8px 17px 2px var(--card-shadow-umbra-color),0 3px 14px 2px var(--card-shadow-penumbra-color),0 5px 5px -3px var(--card-shadow-ambient-color);}&[aria-selected='true']{box-shadow:0 0 0 2px var(--card-focus-ring-color);}`;
function CellLayout(props2) {
  const $ = c(32);
  let children, dragHandle, footer, menu, presence, readOnly, rest, selected, tone, validation2;
  $[0] !== props2 ? ({
    validation: validation2,
    selected,
    tone,
    presence,
    children,
    dragHandle,
    menu,
    footer,
    readOnly,
    ...rest
  } = props2, $[0] = props2, $[1] = children, $[2] = dragHandle, $[3] = footer, $[4] = menu, $[5] = presence, $[6] = readOnly, $[7] = rest, $[8] = selected, $[9] = tone, $[10] = validation2) : (children = $[1], dragHandle = $[2], footer = $[3], menu = $[4], presence = $[5], readOnly = $[6], rest = $[7], selected = $[8], tone = $[9], validation2 = $[10]);
  let t0;
  $[11] !== dragHandle || $[12] !== readOnly ? (t0 = dragHandle && /* @__PURE__ */ jsx(DragHandleCard, { margin: 1, radius: 2, display: "flex", tone: "inherit", "data-ui": "DragHandleCard", children: /* @__PURE__ */ jsx(DragHandle, { $grid: !0, mode: "ghost", readOnly: !!readOnly }) }), $[11] = dragHandle, $[12] = readOnly, $[13] = t0) : t0 = $[13];
  let t1;
  $[14] !== presence ? (t1 = presence && /* @__PURE__ */ jsx(PresenceFlex, { align: "center", marginX: 1, children: presence }), $[14] = presence, $[15] = t1) : t1 = $[15];
  let t2;
  $[16] !== validation2 ? (t2 = /* @__PURE__ */ jsx(Flex, { children: validation2 }), $[16] = validation2, $[17] = t2) : t2 = $[17];
  let t3;
  $[18] !== footer ? (t3 = /* @__PURE__ */ jsx(Box, { children: footer }), $[18] = footer, $[19] = t3) : t3 = $[19];
  let t4;
  $[20] !== menu || $[21] !== t2 || $[22] !== t3 ? (t4 = /* @__PURE__ */ jsxs(FooterFlex, { align: "center", paddingX: 1, sizing: "border", justify: "space-between", children: [
    t2,
    t3,
    menu
  ] }), $[20] = menu, $[21] = t2, $[22] = t3, $[23] = t4) : t4 = $[23];
  let t5;
  return $[24] !== children || $[25] !== rest || $[26] !== selected || $[27] !== t0 || $[28] !== t1 || $[29] !== t4 || $[30] !== tone ? (t5 = /* @__PURE__ */ jsxs(Root$r, { forwardedAs: Flex, direction: "column", border: !0, selected, "aria-selected": selected, radius: 1, tone, ...rest, children: [
    children,
    t0,
    t1,
    t4
  ] }), $[24] = children, $[25] = rest, $[26] = selected, $[27] = t0, $[28] = t1, $[29] = t4, $[30] = tone, $[31] = t5) : t5 = $[31], t5;
}
const PopoverCard$1 = styled(Card).withConfig({
  displayName: "PopoverCard",
  componentId: "sc-1d9wtn0-0"
})`max-width:${({
  theme
}) => theme.sanity.container[1]}px;`;
function IncompatibleItemType$1(props2) {
  const $ = c(55);
  let onFocus, rest, value;
  if ($[0] !== props2) {
    const {
      value: t02,
      onFocus: t110,
      vertical,
      ...t24
    } = props2;
    value = t02, onFocus = t110, rest = t24, $[0] = props2, $[1] = onFocus, $[2] = rest, $[3] = value;
  } else
    onFocus = $[1], rest = $[2], value = $[3];
  const [showDetails, setShowDetails] = useState(!1), popoverRef = useRef(null), {
    t
  } = useTranslation();
  let t0, t1;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setShowDetails(!1), t1 = () => [popoverRef.current], $[4] = t0, $[5] = t1) : (t0 = $[4], t1 = $[5]), useClickOutsideEvent(t0, t1);
  let t2;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (e) => {
    (e.key === "Escape" || e.key === "Tab") && setShowDetails(!1);
  }, $[6] = t2) : t2 = $[6];
  const handleKeyDown = t2;
  let t3;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setShowDetails(_temp$3a);
  }, $[7] = t3) : t3 = $[7];
  const handleShowDetails = t3;
  let t4;
  $[8] !== value ? (t4 = resolveTypeName$1(value), $[8] = value, $[9] = t4) : t4 = $[9];
  const typeName = t4;
  let t5;
  $[10] !== t ? (t5 = t("inputs.array.error.type-is-incompatible-title"), $[10] = t, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: t5 }) }), $[12] = t5, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== typeName ? (t7 = {
    typeName
  }, $[14] = typeName, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.current-schema-not-declare-description", values: t7 }) }), $[16] = t, $[17] = t7, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = /* @__PURE__ */ jsx(BulbOutlineIcon, {}), $[19] = t9) : t9 = $[19];
  let t10;
  $[20] !== t ? (t10 = t("inputs.array.error.can-delete-but-no-edit-description"), $[20] = t, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== t10 ? (t11 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t9,
    " ",
    t10
  ] }) }), $[22] = t10, $[23] = t11) : t11 = $[23];
  let t12;
  $[24] !== t ? (t12 = t("inputs.array.error.json-representation-description"), $[24] = t, $[25] = t12) : t12 = $[25];
  let t13;
  $[26] !== t12 ? (t13 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t12 }), $[26] = t12, $[27] = t13) : t13 = $[27];
  let t14;
  $[28] !== value ? (t14 = JSON.stringify(value, null, 2), $[28] = value, $[29] = t14) : t14 = $[29];
  let t15;
  $[30] !== t14 ? (t15 = /* @__PURE__ */ jsx(Card, { padding: 2, overflow: "auto", border: !0, children: /* @__PURE__ */ jsx(Code, { size: 1, as: "pre", language: "json", children: t14 }) }), $[30] = t14, $[31] = t15) : t15 = $[31];
  let t16;
  $[32] !== t13 || $[33] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t13,
    t15
  ] }), $[32] = t13, $[33] = t15, $[34] = t16) : t16 = $[34];
  let t17;
  $[35] !== t11 || $[36] !== t16 || $[37] !== t6 || $[38] !== t8 ? (t17 = /* @__PURE__ */ jsx(PopoverCard$1, { margin: 1, padding: 3, onKeyDown: handleKeyDown, tabIndex: 0, overflow: "auto", children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t6,
    t8,
    t11,
    t16
  ] }) }), $[35] = t11, $[36] = t16, $[37] = t6, $[38] = t8, $[39] = t17) : t17 = $[39];
  let t18;
  $[40] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t18 = {
    height: "100%"
  }, $[40] = t18) : t18 = $[40];
  let t19;
  $[41] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t19 = /* @__PURE__ */ jsx(Box, { margin: 1, children: /* @__PURE__ */ jsx(Text$1, { align: "center", size: 4, children: /* @__PURE__ */ jsx(UnknownIcon, {}) }) }), $[41] = t19) : t19 = $[41];
  let t20;
  $[42] !== typeName ? (t20 = {
    typeName
  }, $[42] = typeName, $[43] = t20) : t20 = $[43];
  let t21;
  $[44] !== t || $[45] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Stack, { space: 4, marginTop: 2, children: [
    t19,
    /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.type-is-incompatible-prompt", values: t20 }) })
  ] }), $[44] = t, $[45] = t20, $[46] = t21) : t21 = $[46];
  let t22;
  $[47] !== onFocus || $[48] !== rest || $[49] !== t21 ? (t22 = /* @__PURE__ */ jsx(Card, { as: "button", type: "button", radius: 2, tone: "inherit", paddingX: 2, paddingY: 3, style: t18, onFocus, onClick: handleShowDetails, onKeyDown: handleKeyDown, __unstable_focusRing: !0, ...rest, children: t21 }), $[47] = onFocus, $[48] = rest, $[49] = t21, $[50] = t22) : t22 = $[50];
  let t23;
  return $[51] !== showDetails || $[52] !== t17 || $[53] !== t22 ? (t23 = /* @__PURE__ */ jsx(Popover, { open: showDetails, ref: popoverRef, onKeyDown: handleKeyDown, portal: !0, constrainSize: !0, tone: "default", content: t17, children: t22 }), $[51] = showDetails, $[52] = t17, $[53] = t22, $[54] = t23) : t23 = $[54], t23;
}
function _temp$3a(v) {
  return !v;
}
const MENU_POPOVER_PROPS$7 = {
  portal: !0,
  tone: "default"
};
function ErrorItem$1(props2) {
  const $ = c(22), {
    member,
    sortable,
    readOnly
  } = props2, id2 = useId(), {
    onChange
  } = useFormCallbacks(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== member.key || $[1] !== onChange ? (t0 = () => {
    onChange(PatchEvent.from([unset([{
      _key: member.key
    }])]));
  }, $[0] = member.key, $[1] = onChange, $[2] = t0) : t0 = $[2];
  const handleRemove = t0;
  let t1;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    height: "100%"
  }, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[4] = t2) : t2 = $[4];
  const t3 = `${id2}-menuButton`;
  let t4;
  $[5] !== t ? (t4 = t("inputs.array.action.remove-invalid-item"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== handleRemove || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(Menu, { children: /* @__PURE__ */ jsx(MenuItem, { text: t4, tone: "critical", icon: TrashIcon, onClick: handleRemove }) }), $[7] = handleRemove, $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t3 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(MenuButton, { button: t2, id: t3, menu: t5, popover: MENU_POPOVER_PROPS$7 }), $[10] = t3, $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== member.error.type || $[14] !== member.error.value || $[15] !== t ? (t7 = member.error.type === "INVALID_ITEM_TYPE" ? /* @__PURE__ */ jsx(IncompatibleItemType$1, { value: member.error.value, vertical: !0 }) : /* @__PURE__ */ jsx("div", { children: t("inputs.array.error.unexpected-error", {
    error: member.error.type
  }) }), $[13] = member.error.type, $[14] = member.error.value, $[15] = t, $[16] = t7) : t7 = $[16];
  let t8;
  return $[17] !== readOnly || $[18] !== sortable || $[19] !== t6 || $[20] !== t7 ? (t8 = /* @__PURE__ */ jsx(CellLayout, { dragHandle: sortable, readOnly, tone: "caution", style: t1, menu: t6, children: t7 }), $[17] = readOnly, $[18] = sortable, $[19] = t6, $[20] = t7, $[21] = t8) : t8 = $[21], t8;
}
const isError$2 = (problem) => problem.severity === "error", builtinSchema = Schema.compile({
  name: "studio",
  types: builtinTypes
});
inferFromSchema(builtinSchema);
function createSchema(schemaDef) {
  const validated = validateSchema(schemaDef.types).getTypes(), validation2 = groupProblems(validated), hasErrors = validation2.some((group2) => group2.problems.some(isError$2)), compiled = Schema.compile({
    name: schemaDef.name,
    types: hasErrors ? [] : schemaDef.types.filter(Boolean),
    parent: builtinSchema
  });
  return compiled._validation = validation2, inferFromSchema(compiled);
}
const DESCRIPTOR_CONVERTER = new DescriptorConverter();
function getSchemaTypeTitle(type) {
  return typeof type.title == "string" ? type.title : type.type ? getSchemaTypeTitle(type.type) : type.name || type.jsonType;
}
function SourceProvider(t0) {
  const $ = c(16);
  let children, props2;
  $[0] !== t0 ? ({
    children,
    ...props2
  } = t0, $[0] = t0, $[1] = children, $[2] = props2) : (children = $[1], props2 = $[2]);
  const parentSource = useContext(SourceContext), {
    unstable_sources: sources
  } = useWorkspace();
  if ("source" in props2) {
    const {
      source
    } = props2;
    let t1;
    return $[3] !== children || $[4] !== source ? (t1 = /* @__PURE__ */ jsx(SourceContext.Provider, { value: source, children }), $[3] = children, $[4] = source, $[5] = t1) : t1 = $[5], t1;
  }
  if ("name" in props2) {
    const {
      name
    } = props2;
    let t1;
    if ($[6] !== name || $[7] !== sources) {
      let t22;
      $[9] !== name ? (t22 = (s) => s.name === name, $[9] = name, $[10] = t22) : t22 = $[10], t1 = sources.find(t22), $[6] = name, $[7] = sources, $[8] = t1;
    } else
      t1 = $[8];
    const source_0 = t1;
    if (!source_0)
      throw new Error(`Could not find source with name \`${name}\` in current workspace`);
    if (parentSource === source_0) {
      let t22;
      return $[11] !== children ? (t22 = /* @__PURE__ */ jsx(Fragment$1, { children }), $[11] = children, $[12] = t22) : t22 = $[12], t22;
    }
    let t2;
    return $[13] !== children || $[14] !== source_0 ? (t2 = /* @__PURE__ */ jsx(SourceContext.Provider, { value: source_0, children }), $[13] = children, $[14] = source_0, $[15] = t2) : t2 = $[15], t2;
  }
  throw new Error("Invalid props passed into SourceProvider. A `name` or a `source` object is required.");
}
function useSource() {
  const source = useContext(SourceContext);
  if (!source)
    throw new Error("Could not find `source` context");
  return source;
}
function EnhancedObjectDialogProvider(props2) {
  const $ = c(5), {
    children,
    legacyEditing
  } = props2;
  useSource();
  const t0 = !!legacyEditing;
  let t1;
  $[0] !== t0 ? (t1 = {
    enabled: !0,
    legacyEditing: t0
  }, $[0] = t0, $[1] = t1) : t1 = $[1];
  const value = t1;
  let t2;
  return $[2] !== children || $[3] !== value ? (t2 = /* @__PURE__ */ jsx(EnhancedObjectDialogContext.Provider, { value, children }), $[2] = children, $[3] = value, $[4] = t2) : t2 = $[4], t2;
}
function isGoingToUnpublish(document2) {
  return document2._system?.delete === !0;
}
function unstable_useValuePreview(args) {
  return useValuePreview(args);
}
const INITIAL_STATE$8 = {
  isLoading: !0
}, IDLE_STATE = {
  isLoading: !1,
  value: {
    title: void 0,
    description: void 0
  }
};
function useValuePreview(props2) {
  const $ = c(10);
  let t0;
  $[0] !== props2 ? (t0 = props2 || {}, $[0] = props2, $[1] = t0) : t0 = $[1];
  const {
    enabled: t1,
    ordering,
    schemaType,
    value: previewValue,
    perspectiveStack: chosenPerspectiveStack
  } = t0, enabled = t1 === void 0 ? !0 : t1, {
    observeForPreview
  } = useDocumentPreviewStore(), {
    perspectiveStack
  } = usePerspective();
  let t2;
  bb0: {
    if (!enabled || !previewValue || !schemaType) {
      let t32;
      $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t32 = of(IDLE_STATE), $[2] = t32) : t32 = $[2], t2 = t32;
      break bb0;
    }
    let t3;
    if ($[3] !== chosenPerspectiveStack || $[4] !== observeForPreview || $[5] !== ordering || $[6] !== perspectiveStack || $[7] !== previewValue || $[8] !== schemaType) {
      const updatedStack = isGoingToUnpublish(previewValue) ? [] : chosenPerspectiveStack ?? perspectiveStack, updatedDocId = isGoingToUnpublish(previewValue) ? getPublishedId(previewValue._id) : previewValue._id, restPreviewValue = isGoingToUnpublish(previewValue) ? {} : {
        ...previewValue
      };
      t3 = observeForPreview({
        _id: updatedDocId,
        ...restPreviewValue
      }, schemaType, {
        perspective: updatedStack,
        viewOptions: {
          ordering
        }
      }).pipe(map(_temp$39), catchError(_temp2$1l)), $[3] = chosenPerspectiveStack, $[4] = observeForPreview, $[5] = ordering, $[6] = perspectiveStack, $[7] = previewValue, $[8] = schemaType, $[9] = t3;
    } else
      t3 = $[9];
    t2 = t3;
  }
  return useObservable(t2, INITIAL_STATE$8);
}
function _temp2$1l(error) {
  return of({
    isLoading: !1,
    error
  });
}
function _temp$39(event) {
  return {
    isLoading: !1,
    value: event.snapshot || void 0
  };
}
function useValuePreviewWithFallback(props2) {
  const $ = c(9), preview = useValuePreview(props2), {
    t
  } = useTranslation(), t0 = preview?.value;
  let t1;
  $[0] !== preview?.value?.title || $[1] !== t ? (t1 = preview?.value?.title || t("preview.default.title-fallback"), $[0] = preview?.value?.title, $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t0 || $[4] !== t1 ? (t2 = {
    ...t0,
    title: t1
  }, $[3] = t0, $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== preview || $[7] !== t2 ? (t3 = {
    ...preview,
    value: t2
  }, $[6] = preview, $[7] = t2, $[8] = t3) : t3 = $[8], t3;
}
const KEY_LENGTH = 12;
function regenerateKeys(item) {
  return regenerateValue(item);
}
function buildMarkKeyMap(markDefs) {
  if (!Array.isArray(markDefs) || markDefs.length === 0) return;
  const entries = markDefs.flatMap((entry) => isRecord$4(entry) && typeof entry._key == "string" ? [[entry._key, randomKey(KEY_LENGTH)]] : []);
  return entries.length > 0 ? new Map(entries) : void 0;
}
function remapMarks(child, markKeyMap) {
  return isRecord$4(child) && Array.isArray(child.marks) ? {
    ...child,
    marks: child.marks.map((mark) => typeof mark == "string" ? markKeyMap.get(mark) ?? mark : mark)
  } : child;
}
function regenerateValue(value, markDefKeyMap) {
  if (Array.isArray(value))
    return value.map((entry) => regenerateValue(entry, markDefKeyMap));
  if (!isRecord$4(value)) return value;
  const blockMarkKeyMap = isPortableTextTextBlock(value) ? buildMarkKeyMap(value.markDefs) : void 0;
  return Object.fromEntries(Object.entries(value).map(([field, fieldValue]) => {
    if (field === "_key") {
      const remappedKey = markDefKeyMap?.get(fieldValue);
      return [field, remappedKey ?? randomKey(KEY_LENGTH)];
    }
    if (field === "markDefs" && blockMarkKeyMap)
      return [field, fieldValue.map((entry) => regenerateValue(entry, blockMarkKeyMap))];
    if (field === "children" && blockMarkKeyMap) {
      const regeneratedChildren = fieldValue.map((child) => regenerateValue(child));
      return [field, regeneratedChildren.map((child) => remapMarks(child, blockMarkKeyMap))];
    }
    return [field, regenerateValue(fieldValue)];
  }));
}
function useInsertMenuMenuItems(props2) {
  const $ = c(57), {
    t
  } = useTranslation(), {
    onInsert,
    schemaTypes: types,
    disabled,
    disabledReason
  } = props2;
  let t0;
  $[0] !== props2.schemaTypes ? (t0 = props2.schemaTypes ?? [], $[0] = props2.schemaTypes, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== props2 ? (t1 = (insertType) => {
    props2.onInsert("before", insertType);
  }, $[2] = props2, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== props2.insertMenuOptions || $[5] !== t0 || $[6] !== t1 ? (t2 = {
    ...props2.insertMenuOptions,
    schemaTypes: t0,
    onSelect: t1
  }, $[4] = props2.insertMenuOptions, $[5] = t0, $[6] = t1, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = ["bottom-end"], $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== props2.referenceElement ? (t4 = {
    referenceElement: props2.referenceElement,
    placement: "top-end",
    fallbackPlacements: t3
  }, $[9] = props2.referenceElement, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== t2 || $[12] !== t4 ? (t5 = {
    insertMenuProps: t2,
    popoverProps: t4
  }, $[11] = t2, $[12] = t4, $[13] = t5) : t5 = $[13];
  const insertBefore = useInsertMenuPopover(t5);
  let t6;
  $[14] !== props2.schemaTypes ? (t6 = props2.schemaTypes ?? [], $[14] = props2.schemaTypes, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== props2 ? (t7 = (insertType_0) => {
    props2.onInsert("after", insertType_0);
  }, $[16] = props2, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== props2.insertMenuOptions || $[19] !== t6 || $[20] !== t7 ? (t8 = {
    ...props2.insertMenuOptions,
    schemaTypes: t6,
    onSelect: t7
  }, $[18] = props2.insertMenuOptions, $[19] = t6, $[20] = t7, $[21] = t8) : t8 = $[21];
  let t9;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = ["top-end"], $[22] = t9) : t9 = $[22];
  let t10;
  $[23] !== props2.referenceElement ? (t10 = {
    referenceElement: props2.referenceElement,
    placement: "bottom-end",
    fallbackPlacements: t9
  }, $[23] = props2.referenceElement, $[24] = t10) : t10 = $[24];
  let t11;
  $[25] !== t10 || $[26] !== t8 ? (t11 = {
    insertMenuProps: t8,
    popoverProps: t10
  }, $[25] = t10, $[26] = t8, $[27] = t11) : t11 = $[27];
  const insertAfter2 = useInsertMenuPopover(t11);
  let t12;
  $[28] !== insertBefore || $[29] !== onInsert || $[30] !== types ? (t12 = () => {
    types && (types.length === 1 ? onInsert("before", types[0]) : insertBefore.send({
      type: "toggle"
    }));
  }, $[28] = insertBefore, $[29] = onInsert, $[30] = types, $[31] = t12) : t12 = $[31];
  const handleToggleInsertBefore = t12;
  let t13;
  $[32] !== insertAfter2 || $[33] !== onInsert || $[34] !== types ? (t13 = () => {
    types && (types.length === 1 ? onInsert("after", types[0]) : insertAfter2.send({
      type: "toggle"
    }));
  }, $[32] = insertAfter2, $[33] = onInsert, $[34] = types, $[35] = t13) : t13 = $[35];
  const handleToggleInsertAfter = t13;
  let t14;
  $[36] !== disabled || $[37] !== disabledReason || $[38] !== handleToggleInsertBefore || $[39] !== t || $[40] !== types ? (t14 = types ? /* @__PURE__ */ jsx(MenuItem, { text: types.length === 1 ? t("inputs.array.action.add-before") : `${t("inputs.array.action.add-before")}...`, icon: InsertAboveIcon, onClick: handleToggleInsertBefore, disabled, tooltipProps: disabledReason ? {
    content: disabledReason
  } : void 0 }, "insertBefore") : null, $[36] = disabled, $[37] = disabledReason, $[38] = handleToggleInsertBefore, $[39] = t, $[40] = types, $[41] = t14) : t14 = $[41];
  const insertBeforeMenuItem = t14;
  let t15;
  $[42] !== disabled || $[43] !== disabledReason || $[44] !== handleToggleInsertAfter || $[45] !== t || $[46] !== types ? (t15 = types ? /* @__PURE__ */ jsx(MenuItem, { text: types.length === 1 ? t("inputs.array.action.add-after") : `${t("inputs.array.action.add-after")}...`, icon: InsertBelowIcon, onClick: handleToggleInsertAfter, disabled, tooltipProps: disabledReason ? {
    content: disabledReason
  } : void 0 }, "insertAfter") : null, $[42] = disabled, $[43] = disabledReason, $[44] = handleToggleInsertAfter, $[45] = t, $[46] = types, $[47] = t15) : t15 = $[47];
  const insertAfterMenuItem = t15;
  let t16;
  $[48] !== insertBefore || $[49] !== insertBeforeMenuItem ? (t16 = {
    ...insertBefore,
    menuItem: insertBeforeMenuItem
  }, $[48] = insertBefore, $[49] = insertBeforeMenuItem, $[50] = t16) : t16 = $[50];
  let t17;
  $[51] !== insertAfter2 || $[52] !== insertAfterMenuItem ? (t17 = {
    ...insertAfter2,
    menuItem: insertAfterMenuItem
  }, $[51] = insertAfter2, $[52] = insertAfterMenuItem, $[53] = t17) : t17 = $[53];
  let t18;
  return $[54] !== t16 || $[55] !== t17 ? (t18 = {
    insertBefore: t16,
    insertAfter: t17
  }, $[54] = t16, $[55] = t17, $[56] = t18) : t18 = $[56], t18;
}
const PreviewCard$1 = styled(Card).withConfig({
  displayName: "PreviewCard",
  componentId: "sc-1ig9263-0"
})`border-top-right-radius:inherit;border-top-left-radius:inherit;height:100%;position:relative;@media (hover:hover){&:hover{filter:brightness(95%);}}&:focus:focus-visible{box-shadow:0 0 0 2px var(--card-focus-ring-color);}`;
function getTone$2({
  readOnly,
  hasErrors,
  hasWarnings
}) {
  return readOnly ? "transparent" : hasErrors ? "critical" : hasWarnings ? "caution" : "default";
}
const MENU_POPOVER_PROPS$6 = {
  portal: !0,
  tone: "default"
}, EMPTY_ARRAY$p = [];
function GridItem(props2) {
  const $ = c(98), {
    schemaType,
    parentSchemaType,
    path,
    readOnly,
    onRemove,
    value,
    open,
    onInsert,
    onCopy,
    onFocus,
    onOpen,
    onClose,
    changed,
    focused,
    children,
    inputProps: t0
  } = props2, {
    renderPreview
  } = t0, {
    t
  } = useTranslation(), arrayValidation = useArrayValidation(), maxReached = arrayValidation?.maxReached, maxReachedReason = arrayValidation?.maxReachedReason, {
    enabled: enhancedObjectDialogEnabled
  } = useEnhancedObjectDialog(), uploadState = value[UPLOAD_STATUS_KEY], uploadProgress = typeof uploadState?.progress == "number" ? uploadState?.progress : void 0, openPortal = open && !enhancedObjectDialogEnabled, openEnhancedDialog = open && enhancedObjectDialogEnabled, sortable = parentSchemaType.options?.sortable !== !1, insertableTypes = parentSchemaType.of, [previewCardElement, setPreviewCardElement] = useState(null), previewCardRef = useRef(null);
  let t1, t2;
  $[0] !== previewCardElement ? (t1 = () => previewCardElement, t2 = [previewCardElement], $[0] = previewCardElement, $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]), useImperativeHandle(previewCardRef, t1, t2), useScrollIntoViewOnFocusWithin(previewCardRef, open);
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && previewCardRef.current && previewCardRef.current?.focus();
  }, $[3] = t3) : t3 = $[3], useDidUpdate(focused, t3);
  const resolvingInitialValue = value._resolvingInitialValue;
  let t4;
  $[4] !== onInsert || $[5] !== value ? (t4 = () => {
    onInsert({
      items: [regenerateKeys(value)],
      position: "after"
    });
  }, $[4] = onInsert, $[5] = value, $[6] = t4) : t4 = $[6];
  const handleDuplicate = t4;
  let t5;
  $[7] !== onCopy || $[8] !== value ? (t5 = () => {
    onCopy({
      items: [regenerateKeys(value)]
    });
  }, $[7] = onCopy, $[8] = value, $[9] = t5) : t5 = $[9];
  const handleCopy = t5;
  let t6;
  $[10] !== onInsert ? (t6 = (pos, insertType) => {
    onInsert({
      items: [createProtoArrayValue(insertType)],
      position: pos
    });
  }, $[10] = onInsert, $[11] = t6) : t6 = $[11];
  const handleInsert = t6, childPresence = useChildPresence(path, !0);
  let t7;
  $[12] !== childPresence ? (t7 = childPresence.length === 0 ? null : /* @__PURE__ */ jsx(FieldPresence, { presence: childPresence, maxAvatars: 1 }), $[12] = childPresence, $[13] = t7) : t7 = $[13];
  const presence = t7, childValidation = useChildValidation(path, !0);
  let t8;
  $[14] !== childValidation ? (t8 = childValidation.length === 0 ? null : /* @__PURE__ */ jsx(Box, { paddingX: 1, paddingY: 3, children: /* @__PURE__ */ jsx(FormFieldValidationStatus, { validation: childValidation, __unstable_showSummary: !0 }) }), $[14] = childValidation, $[15] = t8) : t8 = $[15];
  const validation2 = t8, hasErrors = childValidation.some(_temp$38), hasWarnings = childValidation.some(_temp2$1k), [contextMenuButtonElement, setContextMenuButtonElement] = useState(null), t9 = parentSchemaType.options?.insertMenu;
  let t10;
  $[16] !== contextMenuButtonElement || $[17] !== handleInsert || $[18] !== insertableTypes || $[19] !== maxReached || $[20] !== maxReachedReason || $[21] !== t9 ? (t10 = {
    schemaTypes: insertableTypes,
    insertMenuOptions: t9,
    onInsert: handleInsert,
    referenceElement: contextMenuButtonElement,
    disabled: maxReached,
    disabledReason: maxReachedReason
  }, $[16] = contextMenuButtonElement, $[17] = handleInsert, $[18] = insertableTypes, $[19] = maxReached, $[20] = maxReachedReason, $[21] = t9, $[22] = t10) : t10 = $[22];
  const {
    insertBefore,
    insertAfter: insertAfter2
  } = useInsertMenuMenuItems(t10), disableActions = parentSchemaType.options?.disableActions || EMPTY_ARRAY$p;
  let t11;
  $[23] !== disableActions || $[24] !== onRemove || $[25] !== t ? (t11 = !disableActions.includes("remove") && /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.array.action.remove"), tone: "critical", icon: TrashIcon, onClick: onRemove }, "remove"), $[23] = disableActions, $[24] = onRemove, $[25] = t, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== disableActions || $[28] !== handleCopy || $[29] !== t ? (t12 = !disableActions.includes("copy") && /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.array.action.copy"), icon: CopyIcon, onClick: handleCopy }, "copy"), $[27] = disableActions, $[28] = handleCopy, $[29] = t, $[30] = t12) : t12 = $[30];
  let t13;
  $[31] !== disableActions || $[32] !== handleDuplicate || $[33] !== t ? (t13 = !disableActions.includes("duplicate") && /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.array.action.duplicate"), icon: AddDocumentIcon, onClick: handleDuplicate }, "duplicate"), $[31] = disableActions, $[32] = handleDuplicate, $[33] = t, $[34] = t13) : t13 = $[34];
  let t14;
  $[35] !== disableActions || $[36] !== insertBefore.menuItem ? (t14 = !disableActions.includes("add") && !disableActions.includes("addBefore") && insertBefore.menuItem, $[35] = disableActions, $[36] = insertBefore.menuItem, $[37] = t14) : t14 = $[37];
  let t15;
  $[38] !== disableActions || $[39] !== insertAfter2.menuItem ? (t15 = !disableActions.includes("add") && !disableActions.includes("addAfter") && insertAfter2.menuItem, $[38] = disableActions, $[39] = insertAfter2.menuItem, $[40] = t15) : t15 = $[40];
  let t16;
  $[41] !== t11 || $[42] !== t12 || $[43] !== t13 || $[44] !== t14 || $[45] !== t15 ? (t16 = [t11, t12, t13, t14, t15].filter(Boolean), $[41] = t11, $[42] = t12, $[43] = t13, $[44] = t14, $[45] = t15, $[46] = t16) : t16 = $[46];
  const menuItems = t16;
  let t17;
  $[47] !== insertAfter2 || $[48] !== insertBefore || $[49] !== menuItems || $[50] !== props2.inputId || $[51] !== readOnly ? (t17 = readOnly || menuItems.length === 0 ? null : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(MenuButton, { ref: setContextMenuButtonElement, onOpen: () => {
      insertBefore.send({
        type: "close"
      }), insertAfter2.send({
        type: "close"
      });
    }, button: /* @__PURE__ */ jsx(ContextMenuButton, { "data-testid": "array-item-menu-button", selected: insertBefore.state.open || insertAfter2.state.open ? !0 : void 0 }), id: `${props2.inputId}-menuButton`, menu: /* @__PURE__ */ jsx(Menu, { children: menuItems }), popover: MENU_POPOVER_PROPS$6 }),
    insertBefore.popover,
    insertAfter2.popover
  ] }), $[47] = insertAfter2, $[48] = insertBefore, $[49] = menuItems, $[50] = props2.inputId, $[51] = readOnly, $[52] = t17) : t17 = $[52];
  const menu = t17, tone = getTone$2({
    readOnly,
    hasErrors,
    hasWarnings
  }), handleMouseDown = _temp3$D;
  let t18;
  $[53] !== onOpen ? (t18 = (event_0) => {
    event_0.stopPropagation(), onOpen();
  }, $[53] = onOpen, $[54] = t18) : t18 = $[54];
  const handleClick = t18;
  let t19;
  $[55] !== renderPreview || $[56] !== schemaType || $[57] !== uploadProgress || $[58] !== value ? (t19 = renderPreview({
    schemaType,
    value,
    layout: "media",
    withBorder: !1,
    withShadow: !1,
    progress: uploadProgress
  }), $[55] = renderPreview, $[56] = schemaType, $[57] = uploadProgress, $[58] = value, $[59] = t19) : t19 = $[59];
  let t20;
  $[60] !== resolvingInitialValue ? (t20 = resolvingInitialValue && /* @__PURE__ */ jsx(LoadingBlock, { fill: !0 }), $[60] = resolvingInitialValue, $[61] = t20) : t20 = $[61];
  let t21;
  $[62] !== handleClick || $[63] !== onFocus || $[64] !== resolvingInitialValue || $[65] !== t19 || $[66] !== t20 ? (t21 = /* @__PURE__ */ jsxs(PreviewCard$1, { tone: "inherit", overflow: "auto", forwardedAs: "button", "data-ui": "PreviewCard", "data-as": "button", type: "button", flex: 1, tabIndex: 0, disabled: resolvingInitialValue, onMouseDown: handleMouseDown, onClick: handleClick, ref: setPreviewCardElement, onFocus, __unstable_focusRing: !0, children: [
    t19,
    t20
  ] }), $[62] = handleClick, $[63] = onFocus, $[64] = resolvingInitialValue, $[65] = t19, $[66] = t20, $[67] = t21) : t21 = $[67];
  let t22;
  $[68] !== menu || $[69] !== openPortal || $[70] !== presence || $[71] !== readOnly || $[72] !== sortable || $[73] !== t21 || $[74] !== tone || $[75] !== validation2 ? (t22 = /* @__PURE__ */ jsx(CellLayout, { menu, presence, validation: validation2, tone, radius: 2, border: !0, dragHandle: sortable, selected: openPortal, readOnly, children: t21 }), $[68] = menu, $[69] = openPortal, $[70] = presence, $[71] = readOnly, $[72] = sortable, $[73] = t21, $[74] = tone, $[75] = validation2, $[76] = t22) : t22 = $[76];
  const item = t22;
  let t23;
  if ($[77] !== changed || $[78] !== children || $[79] !== focused || $[80] !== item || $[81] !== onClose || $[82] !== openEnhancedDialog || $[83] !== openPortal || $[84] !== parentSchemaType.options?.modal?.type || $[85] !== parentSchemaType.options?.modal?.width || $[86] !== path || $[87] !== previewCardElement || $[88] !== readOnly || $[89] !== schemaType || $[90] !== t || $[91] !== value) {
    const itemTypeTitle = getSchemaTypeTitle(schemaType), t24 = !!focused;
    let t25;
    $[93] !== changed || $[94] !== item || $[95] !== path || $[96] !== t24 ? (t25 = /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: t24, children: item }), $[93] = changed, $[94] = item, $[95] = path, $[96] = t24, $[97] = t25) : t25 = $[97], t23 = /* @__PURE__ */ jsxs(EnhancedObjectDialogProvider, { children: [
      t25,
      openPortal && /* @__PURE__ */ jsx(EditPortal, { header: readOnly ? t("inputs.array.action.view", {
        itemTypeTitle
      }) : t("inputs.array.action.edit", {
        itemTypeTitle
      }), type: parentSchemaType?.options?.modal?.type || "dialog", width: parentSchemaType?.options?.modal?.width ?? 1, id: value._key, onClose, autofocus: focused, legacy_referenceElement: previewCardElement, children }),
      openEnhancedDialog && /* @__PURE__ */ jsx(EnhancedObjectDialog, { header: readOnly ? t("inputs.array.action.view", {
        itemTypeTitle
      }) : t("inputs.array.action.edit", {
        itemTypeTitle
      }), type: parentSchemaType?.options?.modal?.type || "dialog", width: parentSchemaType?.options?.modal?.width ?? 1, id: value._key, onClose, autofocus: focused, legacy_referenceElement: previewCardElement, children })
    ] }), $[77] = changed, $[78] = children, $[79] = focused, $[80] = item, $[81] = onClose, $[82] = openEnhancedDialog, $[83] = openPortal, $[84] = parentSchemaType.options?.modal?.type, $[85] = parentSchemaType.options?.modal?.width, $[86] = path, $[87] = previewCardElement, $[88] = readOnly, $[89] = schemaType, $[90] = t, $[91] = value, $[92] = t23;
  } else
    t23 = $[92];
  return t23;
}
function _temp3$D(event) {
  event.preventDefault();
}
function _temp2$1k(v_0) {
  return v_0.level === "warning";
}
function _temp$38(v) {
  return v.level === "error";
}
const EMPTY$4 = [];
function GridArrayInput(props2) {
  const $ = c(44), {
    arrayFunctions: t0,
    elementProps,
    members,
    onChange,
    onItemPrepend,
    onItemAppend,
    onItemMove,
    onSelectFile,
    onUpload,
    readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderPreview,
    schemaType,
    value: t1
  } = props2, ArrayFunctions = t0 === void 0 ? ArrayOfObjectsFunctions : t0, value = t1 === void 0 ? EMPTY$4 : t1, {
    t
  } = useTranslation(), sortable = schemaType.options?.sortable !== !1, renderItem2 = _temp$37;
  let t2;
  $[0] !== members ? (t2 = members.map(_temp2$1j), $[0] = members, $[1] = t2) : t2 = $[1];
  const memberKeys = t2;
  let t3;
  $[2] !== members.length || $[3] !== schemaType.placeholder || $[4] !== t ? (t3 = members?.length === 0 && /* @__PURE__ */ jsx(Card, { padding: 3, border: !0, radius: 2, children: /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: schemaType.placeholder || /* @__PURE__ */ jsx(Fragment$1, { children: t("inputs.array.no-items-label") }) }) }), $[2] = members.length, $[3] = schemaType.placeholder, $[4] = t, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== memberKeys || $[7] !== members || $[8] !== onItemMove || $[9] !== readOnly || $[10] !== renderAnnotation || $[11] !== renderBlock2 || $[12] !== renderField || $[13] !== renderInlineBlock || $[14] !== renderInput || $[15] !== renderPreview || $[16] !== sortable ? (t4 = members?.length > 0 && /* @__PURE__ */ jsx(Card, { border: !0, radius: 1, children: /* @__PURE__ */ jsx(List, { columns: [2, 3, 4], gap: 3, padding: 1, margin: 1, items: memberKeys, onItemMove, sortable, children: members.map((member_0) => /* @__PURE__ */ jsxs(Item, { sortable, id: member_0.key, flex: 1, children: [
    member_0.kind === "item" && /* @__PURE__ */ jsx(ArrayOfObjectsItem, { member: member_0, renderAnnotation, renderBlock: renderBlock2, renderInlineBlock, renderItem: renderItem2, renderField, renderInput, renderPreview }),
    member_0.kind === "error" && /* @__PURE__ */ jsx(ErrorItem$1, { sortable, member: member_0, readOnly })
  ] }, member_0.key)) }) }), $[6] = memberKeys, $[7] = members, $[8] = onItemMove, $[9] = readOnly, $[10] = renderAnnotation, $[11] = renderBlock2, $[12] = renderField, $[13] = renderInlineBlock, $[14] = renderInput, $[15] = renderPreview, $[16] = sortable, $[17] = t4) : t4 = $[17];
  let t5;
  $[18] !== t3 || $[19] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Stack, { "data-ui": "ArrayInput__content", space: 2, children: [
    t3,
    t4
  ] }), $[18] = t3, $[19] = t4, $[20] = t5) : t5 = $[20];
  let t6;
  $[21] !== elementProps || $[22] !== onSelectFile || $[23] !== onUpload || $[24] !== readOnly || $[25] !== schemaType.of || $[26] !== t5 ? (t6 = /* @__PURE__ */ jsx(UploadTargetCard$1, { ...elementProps, isReadOnly: readOnly, onSelectFile, onUpload, tabIndex: 0, types: schemaType.of, children: t5 }), $[21] = elementProps, $[22] = onSelectFile, $[23] = onUpload, $[24] = readOnly, $[25] = schemaType.of, $[26] = t5, $[27] = t6) : t6 = $[27];
  let t7;
  $[28] !== ArrayFunctions || $[29] !== onChange || $[30] !== onItemAppend || $[31] !== onItemPrepend || $[32] !== props2.path || $[33] !== readOnly || $[34] !== schemaType || $[35] !== value ? (t7 = /* @__PURE__ */ jsx(ArrayFunctions, { onChange, onItemAppend, onItemPrepend, onValueCreate: createProtoArrayValue, path: props2.path, readOnly, schemaType, value }), $[28] = ArrayFunctions, $[29] = onChange, $[30] = onItemAppend, $[31] = onItemPrepend, $[32] = props2.path, $[33] = readOnly, $[34] = schemaType, $[35] = value, $[36] = t7) : t7 = $[36];
  let t8;
  $[37] !== t6 || $[38] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t6,
    t7
  ] }), $[37] = t6, $[38] = t7, $[39] = t8) : t8 = $[39];
  let t9;
  return $[40] !== members.length || $[41] !== schemaType || $[42] !== t8 ? (t9 = /* @__PURE__ */ jsx(ArrayValidationProvider, { schemaType, itemCount: members.length, children: t8 }), $[40] = members.length, $[41] = schemaType, $[42] = t8, $[43] = t9) : t9 = $[43], t9;
}
function _temp2$1j(member) {
  return member.key;
}
function _temp$37(itemProps) {
  return /* @__PURE__ */ jsx(GridItem, { ...itemProps });
}
function useMemoCompare(next, compare2) {
  const [previous, setPrevious] = useState(next);
  return compare2(previous, next) ? previous : (setPrevious(next), next);
}
function useVisibilityDetection(parentRef) {
  const $ = c(6), [isVisible2, setIsVisible] = useState(!0), [mountKey, setMountKey] = useState(0), prevVisible = useRef(!0);
  let t0, t1;
  $[0] !== parentRef ? (t0 = () => {
    const resizeObserver2 = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry)
        return;
      const {
        width,
        height
      } = entry.contentRect, isNowVisible = width > 0 && height > 0, wasVisible = prevVisible.current;
      if (wasVisible === isNowVisible)
        return;
      const becameVisible = !wasVisible && isNowVisible;
      prevVisible.current = isNowVisible, setIsVisible(isNowVisible), becameVisible && setMountKey(_temp$36);
    });
    return parentRef.current && resizeObserver2.observe(parentRef.current), () => resizeObserver2.disconnect();
  }, t1 = [parentRef], $[0] = parentRef, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  return $[3] !== isVisible2 || $[4] !== mountKey ? (t2 = {
    isVisible: isVisible2,
    mountKey
  }, $[3] = isVisible2, $[4] = mountKey, $[5] = t2) : t2 = $[5], t2;
}
function _temp$36(prev) {
  return prev + 1;
}
const Root$q = styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-1944sat-0"
})`position:relative;border:1px solid transparent;transition:border-color 250ms;.${MOVING_ITEM_CLASS_NAME} &{border-color:var(--card-shadow-umbra-color);box-shadow:0 0 0 0,0 8px 17px 2px var(--card-shadow-umbra-color),0 3px 14px 2px var(--card-shadow-penumbra-color),0 5px 5px -3px var(--card-shadow-ambient-color);}&:hover{border-color:var(--card-shadow-umbra-color);}&[aria-selected='true']{border-color:var(--card-focus-ring-color);}`;
function RowLayout(props2) {
  const $ = c(21), {
    validation: validation2,
    selected,
    tone,
    presence,
    focused,
    children,
    dragHandle,
    menu,
    footer,
    readOnly
  } = props2, elementRef = useRef(null);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && elementRef.current?.focus();
  }, $[0] = t0) : t0 = $[0], useDidUpdate(focused, t0);
  let t1;
  $[1] !== dragHandle || $[2] !== readOnly ? (t1 = dragHandle && /* @__PURE__ */ jsx(DragHandle, { paddingY: 3, readOnly }), $[1] = dragHandle, $[2] = readOnly, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== children ? (t2 = /* @__PURE__ */ jsx(Box, { flex: 1, children }), $[4] = children, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== menu || $[7] !== presence || $[8] !== validation2 ? (t3 = (presence || validation2 || menu) && /* @__PURE__ */ jsxs(Flex, { align: "center", flex: "none", gap: 2, style: {
    lineHeight: 0
  }, children: [
    presence && /* @__PURE__ */ jsx(Box, { flex: "none", children: presence }),
    validation2 && /* @__PURE__ */ jsx(Box, { flex: "none", children: validation2 }),
    menu
  ] }), $[6] = menu, $[7] = presence, $[8] = validation2, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t1 || $[11] !== t2 || $[12] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
    t1,
    t2,
    t3
  ] }), $[10] = t1, $[11] = t2, $[12] = t3, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== footer || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    t4,
    footer
  ] }), $[14] = footer, $[15] = t4, $[16] = t5) : t5 = $[16];
  let t6;
  return $[17] !== selected || $[18] !== t5 || $[19] !== tone ? (t6 = /* @__PURE__ */ jsx(Root$q, { ref: elementRef, selected, "aria-selected": selected, radius: 1, padding: 1, tone, children: t5 }), $[17] = selected, $[18] = t5, $[19] = tone, $[20] = t6) : t6 = $[20], t6;
}
const PopoverCard = styled(Card).withConfig({
  displayName: "PopoverCard",
  componentId: "sc-19eub2f-0"
})`max-width:${({
  theme
}) => theme.sanity.container[1]}px;`;
function IncompatibleItemType(props2) {
  const $ = c(54);
  let onFocus, rest, value;
  if ($[0] !== props2) {
    const {
      value: t02,
      onFocus: t110,
      vertical,
      ...t23
    } = props2;
    value = t02, onFocus = t110, rest = t23, $[0] = props2, $[1] = onFocus, $[2] = rest, $[3] = value;
  } else
    onFocus = $[1], rest = $[2], value = $[3];
  const [showDetails, setShowDetails] = useState(!1), popoverRef = useRef(null), {
    t
  } = useTranslation();
  let t0, t1;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setShowDetails(!1), t1 = () => [popoverRef.current], $[4] = t0, $[5] = t1) : (t0 = $[4], t1 = $[5]), useClickOutsideEvent(t0, t1);
  let t2;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (e) => {
    (e.key === "Escape" || e.key === "Tab") && setShowDetails(!1);
  }, $[6] = t2) : t2 = $[6];
  const handleKeyDown = t2;
  let t3;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setShowDetails(_temp$35);
  }, $[7] = t3) : t3 = $[7];
  const handleShowDetails = t3;
  let t4;
  $[8] !== value ? (t4 = resolveTypeName$1(value), $[8] = value, $[9] = t4) : t4 = $[9];
  const typeName = t4;
  let t5;
  $[10] !== t ? (t5 = t("inputs.array.error.type-is-incompatible-title"), $[10] = t, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: t5 }) }), $[12] = t5, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== typeName ? (t7 = {
    typeName
  }, $[14] = typeName, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.current-schema-not-declare-description", values: t7 }) }), $[16] = t, $[17] = t7, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = /* @__PURE__ */ jsx(BulbOutlineIcon, {}), $[19] = t9) : t9 = $[19];
  let t10;
  $[20] !== t ? (t10 = t("inputs.array.error.can-delete-but-no-edit-description"), $[20] = t, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== t10 ? (t11 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t9,
    " ",
    t10
  ] }) }), $[22] = t10, $[23] = t11) : t11 = $[23];
  let t12;
  $[24] !== t ? (t12 = t("inputs.array.error.json-representation-description"), $[24] = t, $[25] = t12) : t12 = $[25];
  let t13;
  $[26] !== t12 ? (t13 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t12 }), $[26] = t12, $[27] = t13) : t13 = $[27];
  let t14;
  $[28] !== value ? (t14 = JSON.stringify(value, null, 2), $[28] = value, $[29] = t14) : t14 = $[29];
  let t15;
  $[30] !== t14 ? (t15 = /* @__PURE__ */ jsx(Card, { padding: 2, overflow: "auto", border: !0, children: /* @__PURE__ */ jsx(Code, { size: 1, as: "pre", language: "json", children: t14 }) }), $[30] = t14, $[31] = t15) : t15 = $[31];
  let t16;
  $[32] !== t13 || $[33] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t13,
    t15
  ] }), $[32] = t13, $[33] = t15, $[34] = t16) : t16 = $[34];
  let t17;
  $[35] !== t11 || $[36] !== t16 || $[37] !== t6 || $[38] !== t8 ? (t17 = /* @__PURE__ */ jsx(PopoverCard, { margin: 1, padding: 3, onKeyDown: handleKeyDown, tabIndex: 0, overflow: "auto", children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t6,
    t8,
    t11,
    t16
  ] }) }), $[35] = t11, $[36] = t16, $[37] = t6, $[38] = t8, $[39] = t17) : t17 = $[39];
  let t18;
  $[40] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t18 = /* @__PURE__ */ jsx(Box, { marginRight: 3, children: /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(UnknownIcon, {}) }) }), $[40] = t18) : t18 = $[40];
  let t19;
  $[41] !== typeName ? (t19 = {
    typeName
  }, $[41] = typeName, $[42] = t19) : t19 = $[42];
  let t20;
  $[43] !== t || $[44] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t18,
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.type-is-incompatible-prompt", values: t19 }) }) })
  ] }), $[43] = t, $[44] = t19, $[45] = t20) : t20 = $[45];
  let t21;
  $[46] !== onFocus || $[47] !== rest || $[48] !== t20 ? (t21 = /* @__PURE__ */ jsx(Card, { as: "button", type: "button", radius: 2, tone: "inherit", paddingX: 2, paddingY: 3, flex: 1, onFocus, onClick: handleShowDetails, onKeyDown: handleKeyDown, __unstable_focusRing: !0, ...rest, children: t20 }), $[46] = onFocus, $[47] = rest, $[48] = t20, $[49] = t21) : t21 = $[49];
  let t22;
  return $[50] !== showDetails || $[51] !== t17 || $[52] !== t21 ? (t22 = /* @__PURE__ */ jsx(Popover, { open: showDetails, ref: popoverRef, onKeyDown: handleKeyDown, portal: !0, constrainSize: !0, tone: "default", content: t17, children: t21 }), $[50] = showDetails, $[51] = t17, $[52] = t21, $[53] = t22) : t22 = $[53], t22;
}
function _temp$35(v) {
  return !v;
}
const MENU_POPOVER_PROPS$5 = {
  portal: !0,
  tone: "default"
};
function ErrorItem(props2) {
  const $ = c(18), {
    member,
    sortable,
    onRemove,
    readOnly
  } = props2, id2 = useId(), {
    t
  } = useTranslation(), t0 = !!readOnly;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[0] = t1) : t1 = $[0];
  const t2 = `${id2}-menuButton`;
  let t3;
  $[1] !== t ? (t3 = t("inputs.array.action.remove-invalid-item"), $[1] = t, $[2] = t3) : t3 = $[2];
  let t4;
  $[3] !== onRemove || $[4] !== t3 ? (t4 = /* @__PURE__ */ jsx(Menu, { children: /* @__PURE__ */ jsx(MenuItem, { text: t3, tone: "critical", icon: TrashIcon, onClick: onRemove }) }), $[3] = onRemove, $[4] = t3, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== t2 || $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(MenuButton, { button: t1, id: t2, menu: t4, popover: MENU_POPOVER_PROPS$5 }), $[6] = t2, $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== member.error.type || $[10] !== member.error.value || $[11] !== t ? (t6 = member.error.type === "INVALID_ITEM_TYPE" ? /* @__PURE__ */ jsx(IncompatibleItemType, { value: member.error.value }) : /* @__PURE__ */ jsx("div", { children: t("inputs.array.error.unexpected-error", {
    error: member.error.type
  }) }), $[9] = member.error.type, $[10] = member.error.value, $[11] = t, $[12] = t6) : t6 = $[12];
  let t7;
  return $[13] !== sortable || $[14] !== t0 || $[15] !== t5 || $[16] !== t6 ? (t7 = /* @__PURE__ */ jsx(Box, { paddingX: 1, children: /* @__PURE__ */ jsx(RowLayout, { dragHandle: sortable, readOnly: t0, tone: "caution", menu: t5, children: t6 }) }), $[13] = sortable, $[14] = t0, $[15] = t5, $[16] = t6, $[17] = t7) : t7 = $[17], t7;
}
function useVirtualizerScrollInstance() {
  const ref = useContext(VirtualizerScrollInstanceContext);
  if (!ref)
    throw new Error("VirtualizerScrollInstance: missing context value");
  return ref;
}
function VirtualizedArrayList(props2) {
  const {
    members,
    memberKeys,
    activeDragItemIndex,
    focusPathKey,
    onItemMove,
    onItemMoveStart,
    onItemMoveEnd,
    sortable,
    readOnly,
    onItemRemove,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    listGridGap,
    paddingY,
    radius
  } = props2, {
    space
  } = useTheme().sanity, {
    scrollElement,
    containerElement
  } = useVirtualizerScrollInstance(), parentRef = useRef(null), [resolvedScrollElement, setResolvedScrollElement] = useState(scrollElement);
  useLayoutEffect(() => {
    const el = parentRef.current;
    if (!scrollElement || !el || scrollElement.contains(el)) {
      setResolvedScrollElement(scrollElement);
      return;
    }
    let ancestor = el.parentElement;
    for (; ancestor && !(ancestor.scrollHeight > ancestor.clientHeight); )
      ancestor = ancestor.parentElement;
    setResolvedScrollElement(ancestor || scrollElement);
  }, [scrollElement, members.length]);
  const rangeExtractor = useCallback((range2) => {
    const newRange = {
      ...range2
    };
    if (activeDragItemIndex !== null && (newRange.startIndex = Math.min(range2.startIndex, activeDragItemIndex), newRange.endIndex = Math.max(range2.endIndex, activeDragItemIndex)), focusPathKey) {
      const index = memberKeys.findIndex((key) => key === focusPathKey);
      index !== -1 && (newRange.startIndex = Math.min(newRange.startIndex, index), newRange.endIndex = Math.max(newRange.endIndex, index));
    }
    return defaultRangeExtractor(newRange);
  }, [activeDragItemIndex, focusPathKey, memberKeys]), observeElementOffset = useCallback((instance, callback) => {
    if (!instance.scrollElement)
      return;
    const scroll = instance.scrollElement;
    if (containerElement.current && !scroll.contains(containerElement.current)) {
      const handleScroll = (evt) => {
        const scrollTop = scroll.getBoundingClientRect().top, parentTop = parentRef.current?.getBoundingClientRect().top ?? 0;
        callback(Math.floor(scrollTop - parentTop), !!evt);
      };
      return handleScroll(), scroll.addEventListener("scroll", handleScroll, {
        capture: !1,
        passive: !0
      }), () => {
        scroll.removeEventListener("scroll", handleScroll);
      };
    }
    const handleScroll_0 = (evt_0) => {
      const containerElementTop = containerElement.current?.getBoundingClientRect().top ?? 0, parentElementTop = parentRef.current?.getBoundingClientRect().top ?? 0, itemOffset = Math.floor(parentElementTop - containerElementTop);
      callback(scroll.scrollTop - itemOffset, !!evt_0);
    };
    return handleScroll_0(), instance.scrollElement.addEventListener("scroll", handleScroll_0, {
      capture: !1,
      passive: !0
    }), () => {
      scroll.removeEventListener("scroll", handleScroll_0);
    };
  }, [containerElement]), estimateSize2 = useCallback(() => 53, []), virtualizer = useVirtualizer({
    count: members.length,
    estimateSize: estimateSize2,
    getScrollElement: useCallback(() => resolvedScrollElement, [resolvedScrollElement]),
    observeElementOffset,
    rangeExtractor,
    getItemKey: useCallback((index_0) => memberKeys[index_0], [memberKeys]),
    scrollToFn: (offset, options, instance_0) => {
      offset !== instance_0.scrollOffset && elementScroll(offset, options, instance_0);
    }
  }), items = virtualizer.getVirtualItems();
  return /* @__PURE__ */ jsx(Card, { ref: parentRef, border: !0, radius, style: {
    // This is not memoized since it changes on scroll so it will change anyways making memo useless
    // Account for grid gap
    boxSizing: "border-box",
    height: `${virtualizer.getTotalSize() + items.length * space[listGridGap] + space[paddingY]}px`,
    width: "100%",
    position: "relative"
  }, children: /* @__PURE__ */ jsx(List, { axis: "y", gap: listGridGap, paddingY, items: memberKeys, onItemMove, onItemMoveStart, onItemMoveEnd, sortable, style: {
    // This is not memoized since it changes on scroll so it will change anyways making memo useless
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    transform: items.length > 0 ? `translateY(${items[0].start}px)` : void 0
  }, children: items.map((virtualRow) => {
    const member = members[virtualRow.index];
    return /* @__PURE__ */ jsxs(Item, { ref: virtualizer.measureElement, sortable, "data-index": virtualRow.index, id: member.key, children: [
      member.kind === "item" && /* @__PURE__ */ jsx(ArrayOfObjectsItem, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }),
      member.kind === "error" && /* @__PURE__ */ jsx(ErrorItem, { readOnly, sortable, member, onRemove: () => onItemRemove(member.key) })
    ] }, virtualRow.key);
  }) }) });
}
const EMPTY$3 = [];
function ListArrayInput(props2) {
  const $ = c(49), {
    arrayFunctions: t0,
    elementProps,
    members,
    onChange,
    onItemMove,
    onSelectFile,
    onUpload,
    focusPath,
    readOnly,
    onItemAppend,
    onItemPrepend,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    value: t1
  } = props2, ArrayFunctions = t0 === void 0 ? ArrayOfObjectsFunctions : t0, value = t1 === void 0 ? EMPTY$3 : t1, {
    t
  } = useTranslation(), [activeDragItemIndex, setActiveDragItemIndex] = useState(null);
  let t2;
  $[0] !== members ? (t2 = members.map(_temp$34), $[0] = members, $[1] = t2) : t2 = $[1];
  const memberKeys = useMemoCompare(t2, shallowEquals), parentRef = useRef(null), {
    isVisible: isVisible2,
    mountKey
  } = useVisibilityDetection(parentRef);
  let t3;
  bb0: {
    const segment = focusPath[0];
    if (isKeySegment(segment)) {
      t3 = segment._key;
      break bb0;
    }
    if (typeof segment == "number") {
      t3 = segment;
      break bb0;
    }
    t3 = void 0;
  }
  const focusPathKey = t3;
  let t4;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = (event) => {
    const {
      active
    } = event;
    setActiveDragItemIndex(active.data.current?.sortable?.index);
  }, $[2] = t4) : t4 = $[2];
  const handleItemMoveStart = t4;
  let t5;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    setActiveDragItemIndex(null);
  }, $[3] = t5) : t5 = $[3];
  const handleItemMoveEnd = t5, sortable = schemaType.options?.sortable !== !1;
  let t6;
  $[4] !== activeDragItemIndex || $[5] !== focusPathKey || $[6] !== isVisible2 || $[7] !== memberKeys || $[8] !== members || $[9] !== mountKey || $[10] !== onItemMove || $[11] !== props2 || $[12] !== readOnly || $[13] !== renderAnnotation || $[14] !== renderBlock2 || $[15] !== renderField || $[16] !== renderInlineBlock || $[17] !== renderInput || $[18] !== renderItem2 || $[19] !== renderPreview || $[20] !== schemaType.placeholder || $[21] !== sortable || $[22] !== t ? (t6 = members.length === 0 ? /* @__PURE__ */ jsx(Card, { padding: 3, border: !0, radius: 2, children: /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: schemaType.placeholder || /* @__PURE__ */ jsx(Fragment$1, { children: t("inputs.array.no-items-label") }) }) }) : isVisible2 ? /* @__PURE__ */ jsx(VirtualizedArrayList, { members, memberKeys, activeDragItemIndex, focusPathKey, onItemMove, onItemMoveStart: handleItemMoveStart, onItemMoveEnd: handleItemMoveEnd, sortable, readOnly, onItemRemove: (key) => props2.onItemRemove(key), renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview, listGridGap: 1, paddingY: 1, radius: 2 }, mountKey) : null, $[4] = activeDragItemIndex, $[5] = focusPathKey, $[6] = isVisible2, $[7] = memberKeys, $[8] = members, $[9] = mountKey, $[10] = onItemMove, $[11] = props2, $[12] = readOnly, $[13] = renderAnnotation, $[14] = renderBlock2, $[15] = renderField, $[16] = renderInlineBlock, $[17] = renderInput, $[18] = renderItem2, $[19] = renderPreview, $[20] = schemaType.placeholder, $[21] = sortable, $[22] = t, $[23] = t6) : t6 = $[23];
  let t7;
  $[24] !== t6 ? (t7 = /* @__PURE__ */ jsx(Stack, { "data-ui": "ArrayInput__content", space: 2, children: t6 }), $[24] = t6, $[25] = t7) : t7 = $[25];
  let t8;
  $[26] !== elementProps || $[27] !== onSelectFile || $[28] !== onUpload || $[29] !== readOnly || $[30] !== schemaType.of || $[31] !== t7 ? (t8 = /* @__PURE__ */ jsx(UploadTargetCard$1, { ...elementProps, $radius: 2, isReadOnly: readOnly, onSelectFile, onUpload, tabIndex: 0, types: schemaType.of, children: t7 }), $[26] = elementProps, $[27] = onSelectFile, $[28] = onUpload, $[29] = readOnly, $[30] = schemaType.of, $[31] = t7, $[32] = t8) : t8 = $[32];
  let t9;
  $[33] !== ArrayFunctions || $[34] !== onChange || $[35] !== onItemAppend || $[36] !== onItemPrepend || $[37] !== props2.path || $[38] !== readOnly || $[39] !== schemaType || $[40] !== value ? (t9 = /* @__PURE__ */ jsx(ArrayFunctions, { onChange, onItemAppend, onItemPrepend, onValueCreate: createProtoArrayValue, path: props2.path, readOnly, schemaType, value }), $[33] = ArrayFunctions, $[34] = onChange, $[35] = onItemAppend, $[36] = onItemPrepend, $[37] = props2.path, $[38] = readOnly, $[39] = schemaType, $[40] = value, $[41] = t9) : t9 = $[41];
  let t10;
  $[42] !== t8 || $[43] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { space: 2, ref: parentRef, children: [
    t8,
    t9
  ] }), $[42] = t8, $[43] = t9, $[44] = t10) : t10 = $[44];
  let t11;
  return $[45] !== members.length || $[46] !== schemaType || $[47] !== t10 ? (t11 = /* @__PURE__ */ jsx(ArrayValidationProvider, { schemaType, itemCount: members.length, children: t10 }), $[45] = members.length, $[46] = schemaType, $[47] = t10, $[48] = t11) : t11 = $[48], t11;
}
function _temp$34(member) {
  return member.key;
}
function ArrayOfObjectsInput(props2) {
  const $ = c(3), isGrid = props2.schemaType.options?.layout === "grid";
  let t0;
  return $[0] !== isGrid || $[1] !== props2 ? (t0 = isGrid ? /* @__PURE__ */ jsx(GridArrayInput, { ...props2 }) : /* @__PURE__ */ jsx(ListArrayInput, { ...props2 }), $[0] = isGrid, $[1] = props2, $[2] = t0) : t0 = $[2], t0;
}
function isEqual(item, otherItem) {
  if (item === otherItem)
    return !0;
  if (typeof item != typeof otherItem)
    return !1;
  if (typeof item != "object" && !Array.isArray(item))
    return item === otherItem;
  if (item._key && item._key === otherItem._key)
    return !0;
  if (Array.isArray(item))
    return !item.length !== otherItem.length ? !1 : item.every((it, i) => isEqual(item[i], otherItem[i]));
  const keys = Object.keys(item), otherKeys = Object.keys(item);
  return keys.length !== otherKeys.length ? !1 : keys.every((keyName) => isEqual(item[keyName], otherItem[keyName]));
}
function inArray(array, candidate) {
  return array ? array.some((item) => isEqual(item, candidate)) : !1;
}
function getMemberTypeOfItem$1(schemaType, item) {
  return schemaType.of.find((memberType) => memberType.name === resolveTypeName$1(item));
}
const EMPTY_ARRAY$o = [];
function ArrayOfObjectOptionsInput(props2) {
  const $ = c(33), {
    renderPreview,
    schemaType,
    onChange,
    onPathFocus,
    value: t0,
    readOnly,
    elementProps,
    path,
    changed
  } = props2;
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const value = t1, t2 = schemaType.options?.list || EMPTY_ARRAY$o;
  let t3;
  $[2] !== t2 ? (t3 = t2.map(_temp$33), $[2] = t2, $[3] = t3) : t3 = $[3];
  const options = t3;
  let t4;
  $[4] !== onChange || $[5] !== options || $[6] !== value ? (t4 = (isChecked, changedOption) => {
    if (!isChecked && isKeyedObject(changedOption)) {
      onChange(unset([{
        _key: changedOption._key
      }]));
      return;
    }
    const nextValue = options.filter((option_0) => isEqual(changedOption, option_0) ? isChecked : inArray(value, option_0));
    onChange(nextValue.length > 0 ? set(nextValue) : unset());
  }, $[4] = onChange, $[5] = options, $[6] = value, $[7] = t4) : t4 = $[7];
  const handleChange = t4;
  let t5;
  $[8] !== onPathFocus ? (t5 = (index_0) => {
    onPathFocus([index_0]);
  }, $[8] = onPathFocus, $[9] = t5) : t5 = $[9];
  const handleItemFocus = t5, t6 = schemaType.options?.layout === "grid" ? Math.min(options.length, 4) : 1;
  let t7;
  if ($[10] !== handleChange || $[11] !== handleItemFocus || $[12] !== options || $[13] !== readOnly || $[14] !== renderPreview || $[15] !== schemaType || $[16] !== value) {
    let t82;
    $[18] !== handleChange || $[19] !== handleItemFocus || $[20] !== readOnly || $[21] !== renderPreview || $[22] !== schemaType || $[23] !== value ? (t82 = (option_1, index_1) => {
      const optionType = getMemberTypeOfItem$1(schemaType, option_1), checked = inArray(value, option_1), disabled = !optionType;
      return /* @__PURE__ */ jsxs(Flex, { align: "center", as: "label", muted: disabled, children: [
        /* @__PURE__ */ jsx(Checkbox$1, { disabled, checked, onChange: (e) => handleChange(e.currentTarget.checked, option_1), onFocus: () => handleItemFocus(index_1), readOnly }),
        /* @__PURE__ */ jsx(Box, { flex: 1, marginLeft: 2, children: optionType ? renderPreview({
          layout: "default",
          schemaType: optionType,
          value: option_1
        }) : /* @__PURE__ */ jsx(Card, { tone: "caution", radius: 2, children: /* @__PURE__ */ jsx(IncompatibleItemType$2, { value: option_1, onFocus: () => handleItemFocus(index_1) }) }) })
      ] }, index_1);
    }, $[18] = handleChange, $[19] = handleItemFocus, $[20] = readOnly, $[21] = renderPreview, $[22] = schemaType, $[23] = value, $[24] = t82) : t82 = $[24], t7 = options.map(t82), $[10] = handleChange, $[11] = handleItemFocus, $[12] = options, $[13] = readOnly, $[14] = renderPreview, $[15] = schemaType, $[16] = value, $[17] = t7;
  } else
    t7 = $[17];
  let t8;
  $[25] !== elementProps || $[26] !== t6 || $[27] !== t7 ? (t8 = /* @__PURE__ */ jsx(Grid, { gap: 2, columns: t6, tabIndex: 0, ...elementProps, children: t7 }), $[25] = elementProps, $[26] = t6, $[27] = t7, $[28] = t8) : t8 = $[28];
  let t9;
  return $[29] !== changed || $[30] !== path || $[31] !== t8 ? (t9 = /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !1, children: t8 }), $[29] = changed, $[30] = path, $[31] = t8, $[32] = t9) : t9 = $[32], t9;
}
function _temp$33(option, index) {
  return isKeyedObject(option) ? option : {
    ...option,
    _key: `auto-generated-${index}`
  };
}
function isPrimitiveOption(option) {
  return !!(option && typeof option == "object" && "title" in option && "value" in option);
}
function normalizeOptions(options) {
  return options.map((option) => isPrimitiveOption(option) ? {
    title: option.title || startCase(String(option.value)),
    value: option.value
  } : {
    title: startCase(String(option)),
    value: option
  });
}
function getMemberTypeOfItem(schemaType, option) {
  return schemaType.of.find((memberType) => memberType.name === resolveTypeName$1(option.value));
}
function ArrayOfPrimitiveOptionsInput(props2) {
  const $ = c(31), {
    schemaType,
    onChange,
    value: t0,
    readOnly,
    path,
    changed,
    onIndexFocus,
    elementProps
  } = props2;
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const value = t1;
  let t2;
  $[2] !== schemaType.options?.list ? (t2 = schemaType.options?.list || [], $[2] = schemaType.options?.list, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t2 ? (t3 = normalizeOptions(t2), $[4] = t2, $[5] = t3) : t3 = $[5];
  const options = t3;
  let t4;
  $[6] !== onChange || $[7] !== options || $[8] !== value ? (t4 = (isChecked, changedValue) => {
    const nextValue = options.map(_temp$32).filter((optionValue) => optionValue === changedValue ? isChecked : value.includes(optionValue));
    onChange(nextValue.length > 0 ? set(nextValue) : unset());
  }, $[6] = onChange, $[7] = options, $[8] = value, $[9] = t4) : t4 = $[9];
  const handleChange = t4, t5 = schemaType.options?.layout === "grid" ? Math.min(options.length, 4) : 1;
  let t6;
  if ($[10] !== handleChange || $[11] !== onIndexFocus || $[12] !== options || $[13] !== readOnly || $[14] !== schemaType || $[15] !== value) {
    let t72;
    $[17] !== handleChange || $[18] !== onIndexFocus || $[19] !== readOnly || $[20] !== schemaType || $[21] !== value ? (t72 = (option_0, index) => {
      const optionType = getMemberTypeOfItem(schemaType, option_0), checked = value.includes(option_0.value), disabled = !optionType;
      return /* @__PURE__ */ jsxs(Flex, { align: "center", as: "label", muted: disabled, children: [
        /* @__PURE__ */ jsx(Checkbox$1, { disabled, checked, onChange: (e) => handleChange(e.currentTarget.checked, option_0.value), onFocus: () => onIndexFocus(index), readOnly }),
        /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { children: option_0.title }) }),
        !optionType && /* @__PURE__ */ jsx(IncompatibleItemType, { value: option_0, onFocus: () => onIndexFocus(index) })
      ] }, index);
    }, $[17] = handleChange, $[18] = onIndexFocus, $[19] = readOnly, $[20] = schemaType, $[21] = value, $[22] = t72) : t72 = $[22], t6 = options.map(t72), $[10] = handleChange, $[11] = onIndexFocus, $[12] = options, $[13] = readOnly, $[14] = schemaType, $[15] = value, $[16] = t6;
  } else
    t6 = $[16];
  let t7;
  $[23] !== elementProps || $[24] !== t5 || $[25] !== t6 ? (t7 = /* @__PURE__ */ jsx(Grid, { gap: 2, columns: t5, ...elementProps, children: t6 }), $[23] = elementProps, $[24] = t5, $[25] = t6, $[26] = t7) : t7 = $[26];
  let t8;
  return $[27] !== changed || $[28] !== path || $[29] !== t7 ? (t8 = /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !1, children: t7 }), $[27] = changed, $[28] = path, $[29] = t7, $[30] = t8) : t8 = $[30], t8;
}
function _temp$32(option) {
  return option.value;
}
function ArrayOfOptionsInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = isArrayOfObjectsInputProps(props2) ? /* @__PURE__ */ jsx(ArrayOfObjectOptionsInput, { ...props2 }) : /* @__PURE__ */ jsx(ArrayOfPrimitiveOptionsInput, { ...props2 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function ArrayOfPrimitivesFunctions(props2) {
  const $ = c(38), {
    schemaType,
    readOnly,
    children,
    onValueCreate,
    onItemAppend
  } = props2, menuButtonId = useId(), {
    t
  } = useTranslation(), maxReached = useArrayValidation()?.maxReached ?? !1;
  let t0;
  $[0] !== onItemAppend || $[1] !== onValueCreate ? (t0 = (itemType) => {
    onItemAppend(onValueCreate(itemType));
  }, $[0] = onItemAppend, $[1] = onValueCreate, $[2] = t0) : t0 = $[2];
  const insertItem = t0;
  let t1;
  $[3] !== insertItem || $[4] !== schemaType.of[0] ? (t1 = () => {
    insertItem(schemaType.of[0]);
  }, $[3] = insertItem, $[4] = schemaType.of[0], $[5] = t1) : t1 = $[5];
  const handleAddBtnClick = t1;
  let t2;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    constrainSize: !0,
    portal: !0
  }, $[6] = t2) : t2 = $[6];
  const popoverProps = t2, addItemI18nKey = schemaType.of.length > 1 ? "inputs.array.action.add-item-select-type" : "inputs.array.action.add-item";
  if (schemaType.options?.disableActions?.includes("add"))
    return null;
  if (readOnly) {
    let t32;
    $[7] !== t ? (t32 = t("inputs.array.read-only-label"), $[7] = t, $[8] = t32) : t32 = $[8];
    let t42;
    $[9] !== addItemI18nKey || $[10] !== t ? (t42 = t(addItemI18nKey), $[9] = addItemI18nKey, $[10] = t, $[11] = t42) : t42 = $[11];
    let t52;
    $[12] !== t42 ? (t52 = /* @__PURE__ */ jsx(Grid, { children: /* @__PURE__ */ jsx(Button, { "data-testid": "add-single-primitive-button", icon: AddIcon, mode: "ghost", disabled: !0, size: "large", text: t42 }) }), $[12] = t42, $[13] = t52) : t52 = $[13];
    let t6;
    return $[14] !== t32 || $[15] !== t52 ? (t6 = /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t32, children: t52 }), $[14] = t32, $[15] = t52, $[16] = t6) : t6 = $[16], t6;
  }
  if (maxReached) {
    let t32;
    $[17] !== t ? (t32 = t("inputs.array.action.max-reached"), $[17] = t, $[18] = t32) : t32 = $[18];
    let t42;
    $[19] !== addItemI18nKey || $[20] !== t ? (t42 = t(addItemI18nKey), $[19] = addItemI18nKey, $[20] = t, $[21] = t42) : t42 = $[21];
    let t52;
    $[22] !== t42 ? (t52 = /* @__PURE__ */ jsx(Grid, { children: /* @__PURE__ */ jsx(Button, { "data-testid": "add-max-reached-primitive-button", icon: AddIcon, mode: "ghost", disabled: !0, size: "large", text: t42 }) }), $[22] = t42, $[23] = t52) : t52 = $[23];
    let t6;
    return $[24] !== t32 || $[25] !== t52 ? (t6 = /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t32, children: t52 }), $[24] = t32, $[25] = t52, $[26] = t6) : t6 = $[26], t6;
  }
  let t3;
  $[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))"
  }, $[27] = t3) : t3 = $[27];
  let t4;
  $[28] !== addItemI18nKey || $[29] !== handleAddBtnClick || $[30] !== insertItem || $[31] !== menuButtonId || $[32] !== schemaType.of || $[33] !== t ? (t4 = schemaType.of.length === 1 ? /* @__PURE__ */ jsx(Button, { "data-testid": "add-multiple--primitive-button", icon: AddIcon, mode: "ghost", onClick: handleAddBtnClick, size: "large", text: t(addItemI18nKey) }) : /* @__PURE__ */ jsx(MenuButton, { button: /* @__PURE__ */ jsx(Button, { icon: AddIcon, mode: "ghost", size: "large", text: t(addItemI18nKey) }), id: menuButtonId || "", menu: /* @__PURE__ */ jsx(Menu, { children: schemaType.of.map((memberDef, i) => {
    const referenceIcon = isReferenceSchemaType(memberDef) && (memberDef.to || []).length === 1 && memberDef.to[0].icon, icon = memberDef.icon || memberDef.type?.icon || referenceIcon;
    return /* @__PURE__ */ jsx(MenuItem, { text: memberDef.title || memberDef.type?.name, onClick: () => insertItem(memberDef), icon }, i);
  }) }), popover: popoverProps }), $[28] = addItemI18nKey, $[29] = handleAddBtnClick, $[30] = insertItem, $[31] = menuButtonId, $[32] = schemaType.of, $[33] = t, $[34] = t4) : t4 = $[34];
  let t5;
  return $[35] !== children || $[36] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Grid, { gap: 1, style: t3, children: [
    t4,
    children
  ] }), $[35] = children, $[36] = t4, $[37] = t5) : t5 = $[37], t5;
}
const Root$p = styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-lw9kc3-0"
})`position:relative;`;
function getUploadCandidates(types, resolveUploader2, file) {
  return types.map((memberType) => ({
    type: memberType,
    uploader: resolveUploader2(memberType, file)
  })).filter((member) => member.uploader);
}
function uploadTarget(Component2) {
  const FileTarget = fileTarget(Component2);
  return forwardRef(function(props2, forwardedRef) {
    const $ = c(26);
    let children, onUpload, resolveUploader2, rest, types;
    $[0] !== props2 ? ({
      children,
      resolveUploader: resolveUploader2,
      onUpload,
      types,
      ...rest
    } = props2, $[0] = props2, $[1] = children, $[2] = onUpload, $[3] = resolveUploader2, $[4] = rest, $[5] = types) : (children = $[1], onUpload = $[2], resolveUploader2 = $[3], rest = $[4], types = $[5]);
    const {
      push: pushToast
    } = useToast(), {
      t
    } = useTranslation();
    let t0;
    $[6] !== onUpload ? (t0 = (file, resolvedUploader) => {
      const {
        type,
        uploader
      } = resolvedUploader;
      onUpload?.({
        file,
        schemaType: type,
        uploader
      });
    }, $[6] = onUpload, $[7] = t0) : t0 = $[7];
    const uploadFile2 = t0;
    let t1;
    $[8] !== pushToast || $[9] !== resolveUploader2 || $[10] !== t || $[11] !== types || $[12] !== uploadFile2 ? (t1 = (files) => {
      if (!resolveUploader2)
        return;
      const tasks2 = files.map((file_0) => ({
        file: file_0,
        uploaderCandidates: getUploadCandidates(types, resolveUploader2, file_0)
      })), ready = tasks2.filter(_temp$31), rejected = tasks2.filter(_temp2$1i);
      rejected.length > 0 && pushToast({
        closable: !0,
        status: "warning",
        title: t("inputs.array.error.cannot-upload-unable-to-convert", {
          count: rejected.length
        }),
        description: rejected.map(_temp3$C)
      }), ready.forEach((task_2) => {
        uploadFile2(task_2.file, sortBy(task_2.uploaderCandidates, _temp4$g)[0]);
      });
    }, $[8] = pushToast, $[9] = resolveUploader2, $[10] = t, $[11] = types, $[12] = uploadFile2, $[13] = t1) : t1 = $[13];
    const handleFiles = t1;
    let t2;
    $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[14] = t2) : t2 = $[14];
    const [hoveringFiles, setHoveringFiles] = useState(t2);
    let t3;
    $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setHoveringFiles([]), $[15] = t3) : t3 = $[15];
    const handleFilesOut = t3;
    let t4;
    $[16] !== hoveringFiles || $[17] !== resolveUploader2 || $[18] !== types ? (t4 = resolveUploader2 && hoveringFiles.length > 0 && /* @__PURE__ */ jsx(Overlay$1, { zOffset: 10, children: /* @__PURE__ */ jsx(DropMessage, { hoveringFiles, types, resolveUploader: resolveUploader2 }) }), $[16] = hoveringFiles, $[17] = resolveUploader2, $[18] = types, $[19] = t4) : t4 = $[19];
    let t5;
    return $[20] !== children || $[21] !== forwardedRef || $[22] !== handleFiles || $[23] !== rest || $[24] !== t4 ? (t5 = /* @__PURE__ */ jsx(Root$p, { children: /* @__PURE__ */ jsxs(FileTarget, { ...rest, ref: forwardedRef, onFiles: handleFiles, onFilesOver: setHoveringFiles, onFilesOut: handleFilesOut, children: [
      t4,
      children
    ] }) }), $[20] = children, $[21] = forwardedRef, $[22] = handleFiles, $[23] = rest, $[24] = t4, $[25] = t5) : t5 = $[25], t5;
  });
}
const StyledCard$2 = styled(Card).withConfig({
  displayName: "StyledCard",
  componentId: "sc-lw9kc3-1"
})`height:100%;`, UploadTargetCard = withFocusRing(uploadTarget(StyledCard$2)), Overlay$1 = styled(Layer).withConfig({
  displayName: "Overlay",
  componentId: "sc-lw9kc3-2"
})`position:absolute;display:flex;flex-direction:column;align-items:center;justify-content:center;top:-2px;left:-2px;right:-2px;bottom:-2px;background-color:var(--card-bg-color);opacity:0.8;`;
function DropMessage(props2) {
  const $ = c(5), {
    hoveringFiles,
    types,
    resolveUploader: resolveUploader2
  } = props2;
  let t0;
  $[0] !== resolveUploader2 || $[1] !== types ? (t0 = (file) => types.some((type) => resolveUploader2(type, file)), $[0] = resolveUploader2, $[1] = types, $[2] = t0) : t0 = $[2];
  const acceptedFiles = hoveringFiles.filter(t0), rejectedFilesCount = hoveringFiles.length - acceptedFiles.length, multiple = types.length > 1, {
    t
  } = useTranslation(), t1 = acceptedFiles.length > 0 ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
      /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(UploadIcon, {}) }),
      multiple ? t("inputs.files.common.drop-message.drop-to-upload-multi", {
        count: acceptedFiles.length
      }) : t("inputs.files.common.drop-message.drop-to-upload"),
      /* @__PURE__ */ jsx(Text$1, {})
    ] }),
    rejectedFilesCount > 0 && /* @__PURE__ */ jsx(Box, { marginTop: 4, children: /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
      /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(AccessDeniedIcon, {}) }),
      /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t("inputs.files.common.drop-message.drop-to-upload.rejected-file-message", {
        count: rejectedFilesCount
      }) })
    ] }) })
  ] }) : /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(AccessDeniedIcon, {}) }),
    /* @__PURE__ */ jsx(Text$1, { children: t("inputs.files.common.drop-message.drop-to-upload.no-accepted-file-message", {
      count: hoveringFiles.length
    }) })
  ] });
  let t2;
  return $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Fragment$1, { children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
function _temp$31(task) {
  return task.uploaderCandidates.length > 0;
}
function _temp2$1i(task_0) {
  return task_0.uploaderCandidates.length === 0;
}
function _temp3$C(task_1, i) {
  return /* @__PURE__ */ jsxs(Flex, { gap: 2, padding: 2, children: [
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: task_1.file.name }) }),
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
      "(",
      task_1.file.type,
      ")"
    ] }) })
  ] }, i);
}
function _temp4$g(candidate) {
  return candidate.uploader.priority;
}
const MENU_POPOVER_PROPS$4 = {
  portal: !0,
  tone: "default",
  placement: "left",
  constrainSize: !0
};
memo(function(props2) {
  const $ = c(15), {
    types,
    onInsert
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("inputs.array.action.add-before"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== onInsert || $[3] !== t0 || $[4] !== types ? (t1 = /* @__PURE__ */ jsx(InsertMenuGroup, { pos: "before", types, onInsert, text: t0, icon: InsertAboveIcon }), $[2] = onInsert, $[3] = t0, $[4] = types, $[5] = t1) : t1 = $[5];
  let t2;
  $[6] !== t ? (t2 = t("inputs.array.action.add-after"), $[6] = t, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== onInsert || $[9] !== t2 || $[10] !== types ? (t3 = /* @__PURE__ */ jsx(InsertMenuGroup, { pos: "after", types, onInsert, text: t2, icon: InsertBelowIcon }), $[8] = onInsert, $[9] = t2, $[10] = types, $[11] = t3) : t3 = $[11];
  let t4;
  return $[12] !== t1 || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t1,
    t3
  ] }), $[12] = t1, $[13] = t3, $[14] = t4) : t4 = $[14], t4;
});
function InsertMenuGroup(props2) {
  const $ = c(24), {
    types,
    onInsert,
    pos,
    text,
    icon,
    disabled,
    disabledReason
  } = props2;
  if (types?.length === 1) {
    let t02;
    $[0] !== onInsert || $[1] !== pos || $[2] !== types[0] ? (t02 = () => onInsert(pos, types[0]), $[0] = onInsert, $[1] = pos, $[2] = types[0], $[3] = t02) : t02 = $[3];
    let t12;
    $[4] !== disabledReason ? (t12 = disabledReason ? {
      content: disabledReason
    } : void 0, $[4] = disabledReason, $[5] = t12) : t12 = $[5];
    let t2;
    return $[6] !== disabled || $[7] !== icon || $[8] !== pos || $[9] !== t02 || $[10] !== t12 || $[11] !== text ? (t2 = /* @__PURE__ */ jsx(MenuItem, { text, icon, onClick: t02, disabled, tooltipProps: t12 }, pos), $[6] = disabled, $[7] = icon, $[8] = pos, $[9] = t02, $[10] = t12, $[11] = text, $[12] = t2) : t2 = $[12], t2;
  }
  let t0;
  $[13] !== disabled || $[14] !== disabledReason || $[15] !== onInsert || $[16] !== pos || $[17] !== types ? (t0 = types?.map((insertableType) => /* @__PURE__ */ jsx(MenuItem, { icon: insertableType.icon, text: insertableType.title, onClick: () => onInsert(pos, insertableType), disabled, tooltipProps: disabledReason ? {
    content: disabledReason
  } : void 0 }, insertableType.name)), $[13] = disabled, $[14] = disabledReason, $[15] = onInsert, $[16] = pos, $[17] = types, $[18] = t0) : t0 = $[18];
  let t1;
  return $[19] !== disabled || $[20] !== pos || $[21] !== t0 || $[22] !== text ? (t1 = /* @__PURE__ */ jsx(MenuGroup, { text, popover: MENU_POPOVER_PROPS$4, disabled, children: t0 }, pos), $[19] = disabled, $[20] = pos, $[21] = t0, $[22] = text, $[23] = t1) : t1 = $[23], t1;
}
const MENU_BUTTON_POPOVER_PROPS$2 = {
  portal: !0,
  tone: "default"
}, EMPTY_ARRAY$n = [], ItemRow = forwardRef(function(props2, ref) {
  const $ = c(76), {
    sortable,
    value,
    insertableTypes,
    onInsert,
    onCopy,
    onRemove,
    readOnly,
    inputId,
    parentSchemaType,
    validation: validation2,
    children,
    presence,
    schemaType
  } = props2, hasError = validation2.filter(_temp$30).length > 0, hasWarning = validation2.filter(_temp2$1h).length > 0;
  let t0;
  $[0] !== onInsert ? (t0 = (pos, insertType) => {
    onInsert({
      position: pos,
      items: [getEmptyValue(insertType)]
    });
  }, $[0] = onInsert, $[1] = t0) : t0 = $[1];
  const handleInsert = t0;
  let t1;
  $[2] !== onInsert || $[3] !== value ? (t1 = () => {
    value && onInsert({
      position: "after",
      items: [value]
    });
  }, $[2] = onInsert, $[3] = value, $[4] = t1) : t1 = $[4];
  const handleDuplicate = t1;
  let t2;
  $[5] !== onCopy || $[6] !== value ? (t2 = () => {
    onCopy({
      items: [value]
    });
  }, $[5] = onCopy, $[6] = value, $[7] = t2) : t2 = $[7];
  const handleCopy = t2;
  let t3;
  bb0: {
    if (hasError) {
      t3 = "critical";
      break bb0;
    }
    if (hasWarning) {
      t3 = "caution";
      break bb0;
    }
    t3 = void 0;
  }
  const tone = t3, {
    t
  } = useTranslation(), arrayValidation = useArrayValidation(), maxReached = arrayValidation?.maxReached, maxReachedReason = arrayValidation?.maxReachedReason, disableActions = parentSchemaType.options?.disableActions || EMPTY_ARRAY$n;
  let t4;
  $[8] !== disableActions || $[9] !== onRemove || $[10] !== t ? (t4 = !disableActions.includes("remove") && /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.array.action.remove"), tone: "critical", icon: TrashIcon, onClick: onRemove }, "remove"), $[8] = disableActions, $[9] = onRemove, $[10] = t, $[11] = t4) : t4 = $[11];
  let t5;
  $[12] !== disableActions || $[13] !== handleCopy || $[14] !== t ? (t5 = !disableActions.includes("copy") && /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.array.action.copy"), icon: CopyIcon, onClick: handleCopy }, "copy"), $[12] = disableActions, $[13] = handleCopy, $[14] = t, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== disableActions || $[17] !== handleDuplicate || $[18] !== t ? (t6 = !disableActions.includes("duplicate") && /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.array.action.duplicate"), icon: AddDocumentIcon, onClick: handleDuplicate }, "duplicate"), $[16] = disableActions, $[17] = handleDuplicate, $[18] = t, $[19] = t6) : t6 = $[19];
  let t7;
  $[20] !== disableActions || $[21] !== handleInsert || $[22] !== insertableTypes || $[23] !== maxReached || $[24] !== maxReachedReason || $[25] !== t ? (t7 = !(disableActions.includes("add") || disableActions.includes("addBefore")) && /* @__PURE__ */ jsx(InsertMenuGroup, { pos: "before", types: insertableTypes, onInsert: handleInsert, text: t("inputs.array.action.add-before"), icon: InsertAboveIcon, disabled: maxReached, disabledReason: maxReachedReason }, "add-before"), $[20] = disableActions, $[21] = handleInsert, $[22] = insertableTypes, $[23] = maxReached, $[24] = maxReachedReason, $[25] = t, $[26] = t7) : t7 = $[26];
  let t8;
  $[27] !== disableActions || $[28] !== handleInsert || $[29] !== insertableTypes || $[30] !== maxReached || $[31] !== maxReachedReason || $[32] !== t ? (t8 = !disableActions.includes("add") && !disableActions.includes("addAfter") && /* @__PURE__ */ jsx(InsertMenuGroup, { pos: "after", types: insertableTypes, onInsert: handleInsert, text: t("inputs.array.action.add-after"), icon: InsertBelowIcon, disabled: maxReached, disabledReason: maxReachedReason }, "add-after"), $[27] = disableActions, $[28] = handleInsert, $[29] = insertableTypes, $[30] = maxReached, $[31] = maxReachedReason, $[32] = t, $[33] = t8) : t8 = $[33];
  let t9;
  $[34] !== t4 || $[35] !== t5 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8 ? (t9 = [t4, t5, t6, t7, t8].filter(Boolean), $[34] = t4, $[35] = t5, $[36] = t6, $[37] = t7, $[38] = t8, $[39] = t9) : t9 = $[39];
  const menuItems = t9;
  let t10;
  $[40] !== inputId || $[41] !== menuItems || $[42] !== readOnly ? (t10 = readOnly || menuItems.length === 0 ? null : /* @__PURE__ */ jsx(MenuButton, { button: /* @__PURE__ */ jsx(ContextMenuButton, {}), id: `${inputId}-menuButton`, popover: MENU_BUTTON_POPOVER_PROPS$2, menu: /* @__PURE__ */ jsx(Menu, { children: menuItems }) }), $[40] = inputId, $[41] = menuItems, $[42] = readOnly, $[43] = t10) : t10 = $[43];
  const menu = t10;
  if (parentSchemaType.options?.layout === "grid") {
    const t112 = !!readOnly;
    let t122;
    $[44] !== presence ? (t122 = presence.length === 0 ? null : /* @__PURE__ */ jsx(FieldPresence, { presence, maxAvatars: 1 }), $[44] = presence, $[45] = t122) : t122 = $[45];
    let t132;
    $[46] !== validation2 ? (t132 = validation2.length > 0 ? /* @__PURE__ */ jsx(Box, { paddingX: 1, paddingY: 3, children: /* @__PURE__ */ jsx(FormFieldValidationStatus, { validation: validation2 }) }) : null, $[46] = validation2, $[47] = t132) : t132 = $[47];
    let t142;
    $[48] !== children ? (t142 = /* @__PURE__ */ jsx(Box, { padding: 2, children }), $[48] = children, $[49] = t142) : t142 = $[49];
    let t152;
    return $[50] !== menu || $[51] !== sortable || $[52] !== t112 || $[53] !== t122 || $[54] !== t132 || $[55] !== t142 || $[56] !== tone ? (t152 = /* @__PURE__ */ jsx(CellLayout, { tone, readOnly: t112, menu, dragHandle: sortable, presence: t122, validation: t132, children: t142 }), $[50] = menu, $[51] = sortable, $[52] = t112, $[53] = t122, $[54] = t132, $[55] = t142, $[56] = tone, $[57] = t152) : t152 = $[57], t152;
  }
  const t11 = !!readOnly;
  let t12;
  $[58] !== presence ? (t12 = presence.length === 0 ? null : /* @__PURE__ */ jsx(FieldPresence, { presence, maxAvatars: 1 }), $[58] = presence, $[59] = t12) : t12 = $[59];
  let t13;
  $[60] !== validation2 ? (t13 = validation2.length > 0 ? /* @__PURE__ */ jsx(Box, { paddingX: 1, paddingY: 3, children: /* @__PURE__ */ jsx(FormFieldValidationStatus, { validation: validation2 }) }) : null, $[60] = validation2, $[61] = t13) : t13 = $[61];
  const t14 = schemaType ? "flex-end" : "center";
  let t15;
  $[62] !== children ? (t15 = /* @__PURE__ */ jsx(Flex, { align: "flex-end", flex: 1, children: /* @__PURE__ */ jsx(Box, { flex: 1, marginRight: 2, children }) }), $[62] = children, $[63] = t15) : t15 = $[63];
  let t16;
  $[64] !== ref || $[65] !== t14 || $[66] !== t15 ? (t16 = /* @__PURE__ */ jsx(Flex, { align: t14, ref, children: t15 }), $[64] = ref, $[65] = t14, $[66] = t15, $[67] = t16) : t16 = $[67];
  let t17;
  return $[68] !== menu || $[69] !== sortable || $[70] !== t11 || $[71] !== t12 || $[72] !== t13 || $[73] !== t16 || $[74] !== tone ? (t17 = /* @__PURE__ */ jsx(RowLayout, { tone, readOnly: t11, menu, dragHandle: sortable, presence: t12, validation: t13, children: t16 }), $[68] = menu, $[69] = sortable, $[70] = t11, $[71] = t12, $[72] = t13, $[73] = t16, $[74] = tone, $[75] = t17) : t17 = $[75], t17;
});
function _temp$30(item) {
  return item.level === "error";
}
function _temp2$1h(item_0) {
  return item_0.level === "warning";
}
function NoItemsPlaceholder(t0) {
  const $ = c(5), {
    schemaType
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== schemaType.placeholder || $[1] !== t ? (t1 = schemaType.placeholder || t("inputs.array.no-items-label"), $[0] = schemaType.placeholder, $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Card, { padding: 3, border: !0, radius: 2, children: /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: t1 }) }), $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
function nearestIndexOf(array, startIdx, searchElement) {
  return nearestIndex(array, startIdx, (element) => element === searchElement);
}
function nearestIndex(array, startIdx, predicate) {
  let lowerIdx = startIdx - 1, upperIdx = startIdx;
  const len = array.length;
  for (; lowerIdx > -1 || upperIdx < len; ) {
    const upper = array[upperIdx];
    if (upperIdx < len && predicate(upper, upperIdx))
      return upperIdx;
    const lower = array[lowerIdx];
    if (lowerIdx > -1 && predicate(lower, lowerIdx))
      return lowerIdx;
    lowerIdx--, upperIdx++;
  }
  return -1;
}
class ArrayOfPrimitivesInput extends PureComponent {
  _element = null;
  constructor(props2) {
    super(props2), this.state = {
      disableTransition: !1
    };
  }
  handleAppend = (itemValue) => {
    const {
      value = [],
      onIndexFocus,
      onItemAppend
    } = this.props;
    onItemAppend(itemValue), onIndexFocus(value.length);
  };
  handlePrepend = (itemValue) => {
    const {
      onIndexFocus,
      value = [],
      onItemPrepend
    } = this.props;
    onItemPrepend(itemValue), onIndexFocus(value.length);
  };
  handleSortEnd = (event) => {
    const {
      onIndexFocus,
      onMoveItem,
      value
    } = this.props;
    value && onMoveItem(event), onIndexFocus(event.toIndex);
  };
  // Enable transition when the user starts dragging an item
  handleItemMoveStart = () => {
    this.setState({
      disableTransition: !1
    });
  };
  // Disable transition when the user stops dragging an item.
  // Note: there's an issue with the transition of items when the sorting is completed, so we disable the
  // transition effect when the user stops dragging.
  handleItemMoveEnd = () => {
    this.setState({
      disableTransition: !0
    });
  };
  focus() {
    this._element && this._element.focus();
  }
  getSnapshotBeforeUpdate(prevProps) {
    const {
      focusPath: prevFocusPath = [],
      value: prevValue = []
    } = prevProps, {
      focusPath = [],
      value = []
    } = this.props;
    if (prevFocusPath[0] === focusPath[0] && prevValue.length !== value.length) {
      const focusIndex = focusPath[0], selection = window.getSelection();
      if (!(selection?.focusNode instanceof HTMLElement))
        return null;
      const input = selection.focusNode?.querySelector("input,textarea");
      return input instanceof HTMLInputElement ? {
        prevFocusedIndex: focusIndex,
        restoreSelection: {
          text: selection.toString(),
          start: input.selectionStart,
          end: input.selectionEnd,
          value: input.value
        }
      } : {};
    }
    return null;
  }
  componentDidUpdate(prevProps, prevState, snapshot2) {
    const {
      onIndexFocus
    } = this.props;
    if (snapshot2?.restoreSelection && prevProps.value) {
      const prevFocusedValue = prevProps.value[snapshot2.prevFocusedIndex], nearestIndex2 = nearestIndexOf(this.props.value || [], snapshot2.prevFocusedIndex, prevFocusedValue);
      if (nearestIndex2 === -1)
        return;
      const newInput = this._element?.querySelector(`[data-item-index='${nearestIndex2}'] input,textarea`);
      if (newInput instanceof HTMLInputElement) {
        newInput.focus();
        try {
          newInput.setSelectionRange(snapshot2.restoreSelection.start, snapshot2.restoreSelection.end);
        } catch {
        }
      }
      onIndexFocus(nearestIndex2);
    }
  }
  renderArrayItem = (props2) => {
    const {
      schemaType
    } = this.props, sortable = schemaType.options?.sortable !== !1;
    return /* @__PURE__ */ jsx(ItemRow, { ...props2, sortable, insertableTypes: schemaType.of });
  };
  render() {
    const {
      schemaType,
      members,
      readOnly,
      renderInput,
      onUpload,
      onItemRemove,
      resolveUploader: resolveUploader2,
      elementProps,
      arrayFunctions: ArrayFunctions = ArrayOfPrimitivesFunctions,
      changed
    } = this.props, isSortable = !readOnly && get(schemaType, "options.sortable") !== !1, isGrid = schemaType.options?.layout === "grid", membersWithSortIds = members.map((member) => ({
      id: `${member.key}-${member.kind === "item" ? member.item.value : "error"}`,
      member
    }));
    return /* @__PURE__ */ jsx(ArrayValidationProvider, { schemaType, itemCount: members.length, children: /* @__PURE__ */ jsxs(Stack, { space: 2, "data-testid": "array-primitives-input", children: [
      /* @__PURE__ */ jsx(UploadTargetCard, { types: schemaType.of, resolveUploader: resolveUploader2, onUpload, ...elementProps, tabIndex: 0, children: /* @__PURE__ */ jsx(Stack, { space: 1, children: membersWithSortIds.length === 0 ? /* @__PURE__ */ jsx(NoItemsPlaceholder, { schemaType }) : /* @__PURE__ */ jsx(Card, { padding: 1, border: !0, children: /* @__PURE__ */ jsx(List, { onItemMove: this.handleSortEnd, onItemMoveStart: this.handleItemMoveStart, onItemMoveEnd: this.handleItemMoveEnd, items: membersWithSortIds.map((m) => m.id), sortable: isSortable, gap: isGrid ? 3 : 1, columns: isGrid ? [2, 3, 4] : 1, padding: isGrid ? 1 : void 0, margin: isGrid ? 1 : void 0, children: membersWithSortIds.map(({
        member,
        id: id2
      }, index) => /* @__PURE__ */ jsxs(Item, { id: id2, sortable: isSortable, disableTransition: this.state.disableTransition, children: [
        member.kind === "item" && /* @__PURE__ */ jsx(ChangeIndicator, { path: member.item.path, isChanged: changed, hasFocus: !1, children: /* @__PURE__ */ jsx(ArrayOfPrimitivesItem, { member, renderItem: this.renderArrayItem, renderInput }) }),
        member.kind === "error" && /* @__PURE__ */ jsx(ErrorItem, { readOnly, sortable: isSortable, member, onRemove: () => onItemRemove(index) })
      ] }, member.key)) }) }) }) }),
      /* @__PURE__ */ jsx(ArrayFunctions, { onChange: this.props.onChange, onItemAppend: this.handleAppend, onItemPrepend: this.handlePrepend, onValueCreate: getEmptyValue, readOnly: this.props.readOnly, schemaType: this.props.schemaType, value: this.props.value, path: this.props.path })
    ] }) });
  }
}
function UniversalArrayInput(props2) {
  const $ = c(4);
  if (Array.isArray(props2.schemaType.options?.list)) {
    let t02;
    return $[0] !== props2 ? (t02 = /* @__PURE__ */ jsx(ArrayOfOptionsInput, { ...props2 }), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== props2 ? (t0 = isArrayOfPrimitivesInputProps(props2) ? /* @__PURE__ */ jsx(ArrayOfPrimitivesInput, { ...props2 }) : /* @__PURE__ */ jsx(ArrayOfObjectsInput, { ...props2 }), $[2] = props2, $[3] = t0) : t0 = $[3], t0;
}
const CenterAlignedBox = styled(Box).withConfig({
  displayName: "CenterAlignedBox",
  componentId: "sc-lddvef-0"
})`align-self:center;`;
function BooleanInput(props2) {
  const $ = c(40), {
    t
  } = useTranslation(), {
    focused,
    __internal_comments: comments2,
    hovered,
    onMouseEnter,
    onMouseLeave,
    actions,
    __internal_slot: slot
  } = useFieldActions(), {
    id: id2,
    value,
    schemaType,
    readOnly,
    elementProps,
    validation: validation2,
    presence
  } = props2, layout = schemaType.options?.layout || "switch", indeterminate = typeof value != "boolean", checked = value || !1, LayoutSpecificInput = layout === "checkbox" ? Checkbox$1 : Switch$1, tone = readOnly ? "transparent" : void 0;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    paddingTop: "0.85rem"
  }, $[0] = t0) : t0 = $[0];
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    margin: -4
  }, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== LayoutSpecificInput || $[3] !== checked || $[4] !== elementProps || $[5] !== indeterminate || $[6] !== readOnly || $[7] !== schemaType.title ? (t2 = /* @__PURE__ */ jsx(Box, { padding: 3, style: t0, children: /* @__PURE__ */ jsx(LayoutSpecificInput, { label: schemaType.title, ...elementProps, checked, readOnly, indeterminate, style: t1 }) }), $[2] = LayoutSpecificInput, $[3] = checked, $[4] = elementProps, $[5] = indeterminate, $[6] = readOnly, $[7] = schemaType.title, $[8] = t2) : t2 = $[8];
  const input = t2, t3 = props2.elementProps.style;
  let t4;
  $[9] !== input || $[10] !== readOnly || $[11] !== t ? (t4 = readOnly ? /* @__PURE__ */ jsx(Tooltip, { content: t("inputs.boolean.disabled"), children: input }) : input, $[9] = input, $[10] = readOnly, $[11] = t, $[12] = t4) : t4 = $[12];
  const t5 = !!focused;
  let t6;
  $[13] !== id2 || $[14] !== schemaType.deprecated || $[15] !== schemaType.description || $[16] !== schemaType.title || $[17] !== validation2 ? (t6 = /* @__PURE__ */ jsx(FormFieldHeaderText, { deprecated: schemaType.deprecated, description: schemaType.description, inputId: id2, validation: validation2, title: schemaType.title }), $[13] = id2, $[14] = schemaType.deprecated, $[15] = schemaType.description, $[16] = schemaType.title, $[17] = validation2, $[18] = t6) : t6 = $[18];
  let t7;
  $[19] !== actions || $[20] !== comments2 || $[21] !== hovered || $[22] !== id2 || $[23] !== presence || $[24] !== slot || $[25] !== t5 || $[26] !== t6 ? (t7 = /* @__PURE__ */ jsx(FormFieldBaseHeader, { __internal_comments: comments2, __internal_slot: slot, actions, fieldFocused: t5, fieldHovered: hovered, presence, inputId: id2, content: t6 }), $[19] = actions, $[20] = comments2, $[21] = hovered, $[22] = id2, $[23] = presence, $[24] = slot, $[25] = t5, $[26] = t6, $[27] = t7) : t7 = $[27];
  let t8;
  $[28] !== onMouseEnter || $[29] !== onMouseLeave || $[30] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { flex: 1, onMouseEnter, onMouseLeave, paddingY: 2, children: t7 }), $[28] = onMouseEnter, $[29] = onMouseLeave, $[30] = t7, $[31] = t8) : t8 = $[31];
  let t9;
  $[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = /* @__PURE__ */ jsx(CenterAlignedBox, { paddingX: 3, paddingY: 1, children: /* @__PURE__ */ jsx(FormFieldStatus, { maxAvatars: 1, position: "top" }) }), $[32] = t9) : t9 = $[32];
  let t10;
  $[33] !== props2.elementProps.style || $[34] !== t4 || $[35] !== t8 ? (t10 = /* @__PURE__ */ jsxs(Flex, { style: t3, children: [
    t4,
    t8,
    t9
  ] }), $[33] = props2.elementProps.style, $[34] = t4, $[35] = t8, $[36] = t10) : t10 = $[36];
  let t11;
  return $[37] !== t10 || $[38] !== tone ? (t11 = /* @__PURE__ */ jsx(Card, { border: !0, "data-testid": "boolean-input", radius: 2, tone, children: t10 }), $[37] = t10, $[38] = tone, $[39] = t11) : t11 = $[39], t11;
}
const DATE_FORMAT = {
  // 1 Oct 22, 10:00 PM
  SMALL: "d MMM yy',' p",
  // 1 October 2022, 10:00 PM
  MEDIUM: "d MMMM yyyy',' p",
  // Saturday, 1 October 2022, 10:00 PM
  LARGE: "iiii',' d MMMM yyyy',' p"
}, ToastDescription$1 = (props2) => {
  const $ = c(10), {
    body,
    title
  } = props2;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(CalendarIcon, {}), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== title ? (t1 = title && /* @__PURE__ */ jsx(Text$1, { size: 2, weight: "semibold", children: title }), $[1] = title, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    t0,
    t1
  ] }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== body ? (t3 = body && /* @__PURE__ */ jsx(Text$1, { size: 1, children: body }), $[5] = body, $[6] = t3) : t3 = $[6];
  let t4;
  return $[7] !== t2 || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { paddingY: 1, space: 3, children: [
    t2,
    t3
  ] }), $[7] = t2, $[8] = t3, $[9] = t4) : t4 = $[9], t4;
}, rootName$1 = "scheduled-publishing:";
function debugWithName$1(name) {
  const namespace = `${rootName$1}${name}`;
  return debug$c && debug$c.enabled(namespace) ? debug$c(namespace) : debug$c(rootName$1);
}
function createTZDateFromComponents(date, timeZone) {
  return new TZDate(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds(), timeZone);
}
const TimeZoneEvents = {
  update: "timeZoneEventUpdate"
}, debug$a = debugWithName$1("useScheduleOperation"), timeZoneLocalStorageNamespace = "studio.timezone.", timeZoneCache = /* @__PURE__ */ new Map(), offsetCache = /* @__PURE__ */ new Map(), offsetToMinutes = (offset) => {
  if (!offset) return 0;
  const multiplier = offset.startsWith("-") ? -1 : 1;
  if (!offset.includes(":")) return multiplier * Number(offset.replace(/[+-]/, "")) * 60;
  const [hours, minutes] = offset.replace(/[+-]/, "").split(":").map(Number);
  return multiplier * (hours * 60 + minutes);
};
function getCachedTimeZoneInfo(locale, canonicalIdentifier, relativeDateForZones) {
  const dateKey = relativeDateForZones?.toISOString().slice(0, 10) || "now", cacheKey = `${locale}_${canonicalIdentifier}_${dateKey}`;
  if (offsetCache.has(cacheKey))
    return offsetCache.get(cacheKey);
  const formatter = new Intl.DateTimeFormat(sanitizeLocale(locale), {
    timeZone: canonicalIdentifier,
    timeZoneName: "long"
  }), shortFormatter = new Intl.DateTimeFormat(sanitizeLocale(locale), {
    timeZone: canonicalIdentifier,
    timeZoneName: "short"
  }), dateToUse = relativeDateForZones ?? /* @__PURE__ */ new Date(), parts = formatter.formatToParts(dateToUse), shortParts = shortFormatter.formatToParts(dateToUse), offset = format(dateToUse, "xxx", {
    in: tz(canonicalIdentifier)
  }).replace(/([+-])0(\d)/, "$1$2").replace(/([+-])0$/, "$1").replace(/:00$/, "").replace(/[+]0$/, ""), info = {
    abbreviation: shortParts.find(({
      type
    }) => type === "timeZoneName")?.value || "",
    alternativeName: parts.find(({
      type
    }) => type === "timeZoneName")?.value || "",
    offset
  };
  return offsetCache.set(cacheKey, info), info;
}
function computeAllTimeZones(locale, relativeDate) {
  return Intl.supportedValuesOf("timeZone").map((tzName) => {
    if (!tzName.includes("/")) return null;
    const {
      alternativeName,
      abbreviation,
      offset
    } = getCachedTimeZoneInfo(locale, tzName, relativeDate), [, city] = tzName.split("/");
    return {
      abbreviation,
      alternativeName,
      city: city.replaceAll("_", " "),
      name: tzName,
      namePretty: tzName.replaceAll("_", " "),
      offset,
      value: `${offset} ${abbreviation} ${tzName} ${alternativeName}`
    };
  }).filter((tz2) => tz2 !== null).sort((a, b) => offsetToMinutes(a.offset) - offsetToMinutes(b.offset));
}
function getGloballyCachedTimeZones(locale, relativeDate) {
  const cacheKey = `${locale}_${relativeDate?.toISOString().slice(0, 10) || "now"}`;
  if (timeZoneCache.has(cacheKey))
    return timeZoneCache.get(cacheKey);
  const computedTimeZones = computeAllTimeZones(locale, relativeDate);
  return timeZoneCache.set(cacheKey, computedTimeZones), computedTimeZones;
}
const TIME_ZONE_SCOPE_TYPE = {
  scheduledPublishing: "scheduled-publishing",
  contentReleases: "content-releases",
  input: "input"
}, useTimeZone = (scope) => {
  const $ = c(62), toast = useToast(), keyValueStore = useKeyValueStore(), currentLocale = navigator.language, {
    defaultTimeZone
  } = scope, type = TIME_ZONE_SCOPE_TYPE[scope.type], keyStoreId = "id" in scope ? `${timeZoneLocalStorageNamespace}${type}.${scope.id}` : `${timeZoneLocalStorageNamespace}${type}`, relativeDate = "relativeDate" in scope ? scope.relativeDate : void 0;
  let t0;
  $[0] !== keyStoreId || $[1] !== keyValueStore || $[2] !== scope.type ? (t0 = () => {
    if (scope.type === "scheduledPublishing") {
      const legacyValue = localStorage.getItem("scheduled-publishing::time-zone");
      if (legacyValue) {
        const scheduledPublishingValue = JSON.parse(legacyValue);
        keyValueStore.setKey(keyStoreId, scheduledPublishingValue.name), localStorage.removeItem("scheduled-publishing::time-zone");
      }
    }
  }, $[0] = keyStoreId, $[1] = keyValueStore, $[2] = scope.type, $[3] = t0) : t0 = $[3];
  let t1;
  $[4] !== keyStoreId || $[5] !== keyValueStore || $[6] !== relativeDate || $[7] !== scope.type ? (t1 = [scope.type, keyValueStore, keyStoreId, currentLocale, relativeDate], $[4] = keyStoreId, $[5] = keyValueStore, $[6] = relativeDate, $[7] = scope.type, $[8] = t1) : t1 = $[8], useEffect(t0, t1);
  let t2;
  $[9] !== relativeDate ? (t2 = getGloballyCachedTimeZones(currentLocale, relativeDate), $[9] = relativeDate, $[10] = t2) : t2 = $[10];
  const allTimeZones = t2;
  let t3;
  $[11] !== allTimeZones || $[12] !== defaultTimeZone ? (t3 = () => defaultTimeZone ? allTimeZones.find((tz2) => tz2.name === defaultTimeZone) : void 0, $[11] = allTimeZones, $[12] = defaultTimeZone, $[13] = t3) : t3 = $[13];
  const getDefaultTimeZone = t3;
  let t4;
  $[14] !== keyStoreId || $[15] !== keyValueStore ? (t4 = keyValueStore.getKey(keyStoreId).pipe(startWith(null)), $[14] = keyStoreId, $[15] = keyValueStore, $[16] = t4) : t4 = $[16];
  const storedTimeZone = useObservable(t4, null);
  let t5;
  $[17] !== allTimeZones || $[18] !== keyStoreId || $[19] !== keyValueStore || $[20] !== storedTimeZone ? (t5 = () => {
    if (!storedTimeZone)
      return;
    const run = () => {
      const wholeTimeZone = allTimeZones.find((tz_0) => tz_0.name === storedTimeZone);
      if (wholeTimeZone && allTimeZones.some((tz_1) => tz_1.name === wholeTimeZone.name))
        return wholeTimeZone;
      const fallbackTimeZone = allTimeZones.find((tz_2) => tz_2.offset === wholeTimeZone?.offset);
      if (fallbackTimeZone)
        return keyValueStore.setKey(keyStoreId, fallbackTimeZone.name), fallbackTimeZone;
    };
    try {
      return run();
    } catch {
      return;
    }
  }, $[17] = allTimeZones, $[18] = keyStoreId, $[19] = keyValueStore, $[20] = storedTimeZone, $[21] = t5) : t5 = $[21];
  const getStoredTimeZone = t5;
  let t6;
  $[22] !== allTimeZones ? (t6 = () => {
    const localTzName = Intl.DateTimeFormat().resolvedOptions().timeZone, foundLocal = allTimeZones.find((tz_3) => tz_3.name === localTzName);
    return foundLocal || allTimeZones.find(_temp$2$) || allTimeZones[0];
  }, $[22] = allTimeZones, $[23] = t6) : t6 = $[23];
  const getLocalTimeZone = t6;
  let t7;
  $[24] !== getDefaultTimeZone || $[25] !== getLocalTimeZone || $[26] !== getStoredTimeZone ? (t7 = () => getStoredTimeZone() || getDefaultTimeZone() || getLocalTimeZone(), $[24] = getDefaultTimeZone, $[25] = getLocalTimeZone, $[26] = getStoredTimeZone, $[27] = t7) : t7 = $[27];
  const getInitialTimeZone = t7;
  let t8;
  $[28] !== getInitialTimeZone ? (t8 = () => getInitialTimeZone(), $[28] = getInitialTimeZone, $[29] = t8) : t8 = $[29];
  const [timeZone_0, setTimeZone] = useState(t8);
  let t10, t9;
  $[30] !== getInitialTimeZone ? (t9 = () => {
    setTimeZone(getInitialTimeZone());
  }, t10 = [getInitialTimeZone], $[30] = getInitialTimeZone, $[31] = t10, $[32] = t9) : (t10 = $[31], t9 = $[32]), useEffect(t9, t10);
  let t11, t12;
  $[33] !== getInitialTimeZone ? (t11 = () => {
    const handler = () => {
      setTimeZone(getInitialTimeZone());
    };
    return window.addEventListener(TimeZoneEvents.update, handler), () => {
      window.removeEventListener(TimeZoneEvents.update, handler);
    };
  }, t12 = [getInitialTimeZone], $[33] = getInitialTimeZone, $[34] = t11, $[35] = t12) : (t11 = $[34], t12 = $[35]), useEffect(t11, t12);
  let t13;
  $[36] !== getLocalTimeZone || $[37] !== timeZone_0?.name ? (t13 = (t142) => {
    const {
      date,
      format: t152,
      includeTimeZone,
      prefix
    } = t142, format$12 = t152 === void 0 ? DATE_FORMAT.LARGE : t152;
    let dateFormat = format$12;
    return prefix && (dateFormat = `'${prefix}'${format$12}`), includeTimeZone && (dateFormat = `${format$12} (zzzz)`), format(date, dateFormat, {
      in: tz(timeZone_0?.name || getLocalTimeZone()?.name || "UTC")
    });
  }, $[36] = getLocalTimeZone, $[37] = timeZone_0?.name, $[38] = t13) : t13 = $[38];
  const formatDateTz = t13;
  let t14;
  $[39] !== timeZone_0 ? (t14 = () => timeZone_0 ? new TZDate(/* @__PURE__ */ new Date(), timeZone_0.name) : /* @__PURE__ */ new Date(), $[39] = timeZone_0, $[40] = t14) : t14 = $[40];
  const getCurrentZoneDate = t14;
  let t15;
  $[41] !== allTimeZones || $[42] !== getInitialTimeZone ? (t15 = (tzValue) => allTimeZones.find((tz_4) => tzValue === tz_4.value) || getInitialTimeZone(), $[41] = allTimeZones, $[42] = getInitialTimeZone, $[43] = t15) : t15 = $[43];
  const getTimeZone = t15;
  let t16;
  $[44] !== keyStoreId || $[45] !== keyValueStore || $[46] !== toast ? (t16 = (tz_5) => {
    debug$a("handleNewValue:", tz_5), setTimeZone((prevTz) => {
      const run_0 = () => {
        prevTz?.name !== tz_5.name && (keyValueStore.setKey(keyStoreId, tz_5.name), window.dispatchEvent(new Event(TimeZoneEvents.update))), toast.push({
          closable: !0,
          description: /* @__PURE__ */ jsx(ToastDescription$1, { body: `${tz_5.alternativeName} (${tz_5.namePretty})`, title: "Time zone updated" }),
          duration: 15e3,
          status: "info"
        });
      };
      try {
        run_0();
      } catch (t172) {
        const err = t172;
        console.error(err), toast.push({
          closable: !0,
          description: /* @__PURE__ */ jsx(ToastDescription$1, { body: getErrorMessage$1(err), title: "Unable to update time zone" }),
          status: "error"
        });
      }
      return tz_5;
    });
  }, $[44] = keyStoreId, $[45] = keyValueStore, $[46] = toast, $[47] = t16) : t16 = $[47];
  const handleNewValue = t16;
  let t17;
  $[48] !== timeZone_0 ? (t17 = (date_0) => timeZone_0 ? new TZDate(date_0, timeZone_0.name) : date_0, $[48] = timeZone_0, $[49] = t17) : t17 = $[49];
  const utcToCurrentZoneDate = t17;
  let t18;
  $[50] !== timeZone_0 ? (t18 = (date_1) => {
    if (!timeZone_0)
      return date_1;
    const tzDate = createTZDateFromComponents(date_1, timeZone_0.name);
    return new Date(tzDate);
  }, $[50] = timeZone_0, $[51] = t18) : t18 = $[51];
  const zoneDateToUtc = t18;
  let t19;
  return $[52] !== allTimeZones || $[53] !== formatDateTz || $[54] !== getCurrentZoneDate || $[55] !== getLocalTimeZone || $[56] !== getTimeZone || $[57] !== handleNewValue || $[58] !== timeZone_0 || $[59] !== utcToCurrentZoneDate || $[60] !== zoneDateToUtc ? (t19 = {
    formatDateTz,
    getCurrentZoneDate,
    setTimeZone: handleNewValue,
    timeZone: timeZone_0,
    allTimeZones,
    getLocalTimeZone,
    getTimeZone,
    utcToCurrentZoneDate,
    zoneDateToUtc
  }, $[52] = allTimeZones, $[53] = formatDateTz, $[54] = getCurrentZoneDate, $[55] = getLocalTimeZone, $[56] = getTimeZone, $[57] = handleNewValue, $[58] = timeZone_0, $[59] = utcToCurrentZoneDate, $[60] = zoneDateToUtc, $[61] = t19) : t19 = $[61], t19;
};
function isClientError$1(e) {
  return typeof e != "object" || !e ? !1 : "statusCode" in e && "response" in e;
}
function getErrorMessage$1(err) {
  let message;
  return isClientError$1(err) ? err.response.statusCode === 403 ? message = "Forbidden. Please check that your project has access to the feature." : message = err.message : (err instanceof Error && (message = err.message), message = String(err)), message;
}
function _temp$2$(timeZone) {
  return timeZone.abbreviation === "GMT";
}
const TimeZoneCitySpan = /* @__PURE__ */ styled.span.withConfig({
  displayName: "TimeZoneCitySpan",
  componentId: "sc-1ktknl0-0"
})(({
  theme
}) => css`
    color: ${theme.sanity.color.base.fg};
    font-weight: 500;
    margin-left: 1em;
  `), TimeZoneOffsetSpan = /* @__PURE__ */ styled.span.withConfig({
  displayName: "TimeZoneOffsetSpan",
  componentId: "sc-1ktknl0-1"
})(({
  theme
}) => css`
    color: ${theme.sanity.color.muted.default.enabled.fg};
    font-weight: 500;
  `), TimeZoneAlternativeNameSpan = /* @__PURE__ */ styled.span.withConfig({
  displayName: "TimeZoneAlternativeNameSpan",
  componentId: "sc-1ktknl0-2"
})(({
  theme
}) => css`
    color: ${theme.sanity.color.input.default.readOnly.fg};
    float: right;
  `), DialogTimeZone = (props2) => {
  const $ = c(66), {
    onClose,
    timeZoneScope
  } = props2, {
    setTimeZone,
    allTimeZones,
    timeZone,
    getLocalTimeZone,
    getTimeZone
  } = useTimeZone(timeZoneScope), [selectedTz, setSelectedTz] = useState(timeZone), [showAllOptions, setShowAllOptions] = useState(!1), {
    t
  } = useTranslation("studio");
  let t0;
  $[0] !== t ? (t0 = t("time-zone.dialog-info.scheduled-publishing"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t ? (t1 = t("time-zone.dialog-info.content-releases"), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t ? (t2 = t("time-zone.dialog-info.input"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t0 || $[7] !== t1 || $[8] !== t2 ? (t3 = {
    scheduledPublishing: t0,
    contentReleases: t1,
    input: t2
  }, $[6] = t0, $[7] = t1, $[8] = t2, $[9] = t3) : t3 = $[9];
  const timeZoneScopeTypeToLabel = t3;
  let t4;
  $[10] !== getTimeZone ? (t4 = (value) => {
    if (!value) {
      setSelectedTz(void 0);
      return;
    }
    setShowAllOptions(!1), setSelectedTz(getTimeZone(value));
  }, $[10] = getTimeZone, $[11] = t4) : t4 = $[11];
  const handleTimeZoneChange = t4;
  let t5;
  $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = (newQuery) => {
    newQuery && setShowAllOptions(!1);
  }, $[12] = t5) : t5 = $[12];
  const handleQueryChange = t5;
  let t6;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    setShowAllOptions(!0);
  }, $[13] = t6) : t6 = $[13];
  const handleAutocompleteOpenButtonClick = t6;
  let t7;
  $[14] !== getLocalTimeZone ? (t7 = () => setSelectedTz(getLocalTimeZone()), $[14] = getLocalTimeZone, $[15] = t7) : t7 = $[15];
  const handleTimeZoneSelectLocal = t7;
  let t8;
  $[16] !== onClose || $[17] !== selectedTz || $[18] !== setTimeZone ? (t8 = () => {
    selectedTz && setTimeZone(selectedTz), onClose?.();
  }, $[16] = onClose, $[17] = selectedTz, $[18] = setTimeZone, $[19] = t8) : t8 = $[19];
  const handleTimeZoneUpdate = t8, isDirty = selectedTz?.name !== timeZone.name;
  let t9;
  $[20] !== getLocalTimeZone ? (t9 = getLocalTimeZone(), $[20] = getLocalTimeZone, $[21] = t9) : t9 = $[21];
  const isLocalTzSelected = selectedTz?.name === t9.name, renderOption = _temp$2_, renderValue = _temp2$1g;
  let t10;
  $[22] !== showAllOptions ? (t10 = (filterQuery, option_1) => showAllOptions || filterQuery === "" ? !0 : `${option_1.city} (GMT${option_1.offset}) ${option_1.alternativeName}`.toLowerCase().includes(filterQuery.toLowerCase()), $[22] = showAllOptions, $[23] = t10) : t10 = $[23];
  const filterOption = t10, t11 = !isDirty || !selectedTz;
  let t12;
  $[24] !== handleTimeZoneUpdate || $[25] !== t11 ? (t12 = {
    confirmButton: {
      text: "Update time zone",
      disabled: t11,
      onClick: handleTimeZoneUpdate,
      tone: "primary"
    }
  }, $[24] = handleTimeZoneUpdate, $[25] = t11, $[26] = t12) : t12 = $[26];
  const t13 = timeZoneScopeTypeToLabel[timeZoneScope.type];
  let t14;
  $[27] !== t13 ? (t14 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t13 }), $[27] = t13, $[28] = t14) : t14 = $[28];
  let t15;
  $[29] !== t ? (t15 = t("time-zone.time-zone"), $[29] = t, $[30] = t15) : t15 = $[30];
  let t16;
  $[31] !== t15 ? (t16 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t15 }), $[31] = t15, $[32] = t16) : t16 = $[32];
  let t17;
  $[33] !== isLocalTzSelected || $[34] !== t ? (t17 = isLocalTzSelected && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t("time-zone.local-time") }), $[33] = isLocalTzSelected, $[34] = t, $[35] = t17) : t17 = $[35];
  let t18;
  $[36] !== t16 || $[37] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    t16,
    t17
  ] }), $[36] = t16, $[37] = t17, $[38] = t18) : t18 = $[38];
  let t19;
  $[39] !== handleTimeZoneSelectLocal || $[40] !== isLocalTzSelected || $[41] !== t ? (t19 = !isLocalTzSelected && /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: /* @__PURE__ */ jsx("a", { onClick: handleTimeZoneSelectLocal, style: {
    cursor: "pointer"
  }, children: t("time-zone.action.select-local-time-zone") }) }), $[39] = handleTimeZoneSelectLocal, $[40] = isLocalTzSelected, $[41] = t, $[42] = t19) : t19 = $[42];
  let t20;
  $[43] !== t18 || $[44] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-between", children: [
    t18,
    t19
  ] }), $[43] = t18, $[44] = t19, $[45] = t20) : t20 = $[45];
  let t21;
  $[46] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t21 = {
    onClick: handleAutocompleteOpenButtonClick
  }, $[46] = t21) : t21 = $[46];
  let t22;
  $[47] !== t ? (t22 = t("time-zone.action.search-for-timezone-placeholder"), $[47] = t, $[48] = t22) : t22 = $[48];
  let t23;
  $[49] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t23 = {
    boundaryElement: document.body,
    constrainSize: !0,
    placement: "bottom-start"
  }, $[49] = t23) : t23 = $[49];
  const t24 = selectedTz?.value;
  let t25;
  $[50] !== allTimeZones || $[51] !== filterOption || $[52] !== handleTimeZoneChange || $[53] !== t22 || $[54] !== t24 ? (t25 = /* @__PURE__ */ jsx(Autocomplete, { fontSize: 2, icon: SearchIcon, id: "timezone", onChange: handleTimeZoneChange, onQueryChange: handleQueryChange, openButton: t21, options: allTimeZones, padding: 4, filterOption, placeholder: t22, popover: t23, renderOption, renderValue, tabIndex: -1, value: t24 }), $[50] = allTimeZones, $[51] = filterOption, $[52] = handleTimeZoneChange, $[53] = t22, $[54] = t24, $[55] = t25) : t25 = $[55];
  let t26;
  $[56] !== t20 || $[57] !== t25 ? (t26 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t20,
    t25
  ] }), $[56] = t20, $[57] = t25, $[58] = t26) : t26 = $[58];
  let t27;
  $[59] !== t14 || $[60] !== t26 ? (t27 = /* @__PURE__ */ jsxs(Stack, { padding: 4, space: 5, children: [
    t14,
    t26
  ] }), $[59] = t14, $[60] = t26, $[61] = t27) : t27 = $[61];
  let t28;
  return $[62] !== onClose || $[63] !== t12 || $[64] !== t27 ? (t28 = /* @__PURE__ */ jsx(Dialog$1, { footer: t12, header: "Select time zone", id: "time-zone", onClose, width: 1, children: t27 }), $[62] = onClose, $[63] = t12, $[64] = t27, $[65] = t28) : t28 = $[65], t28;
};
function _temp$2_(option) {
  return /* @__PURE__ */ jsx(Card, { as: "button", padding: 3, children: /* @__PURE__ */ jsxs(Text$1, { size: 1, textOverflow: "ellipsis", children: [
    /* @__PURE__ */ jsx(TimeZoneCitySpan, { children: option.city }),
    /* @__PURE__ */ jsxs(TimeZoneOffsetSpan, { children: [
      " ",
      "(",
      "GMT",
      option.offset,
      ")"
    ] }),
    /* @__PURE__ */ jsx(TimeZoneAlternativeNameSpan, { children: option.alternativeName })
  ] }) });
}
function _temp2$1g(_value, option_0) {
  return option_0 ? `${option_0.alternativeName} (${option_0.namePretty})` : "";
}
function useDialogTimeZone(timeZoneScope) {
  const $ = c(9), [visible, setVisible] = useState(!1);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setVisible(!1);
  }, $[0] = t0) : t0 = $[0];
  const hide = t0;
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setVisible(!0);
  }, $[1] = t1) : t1 = $[1];
  const show = t1;
  let t2;
  $[2] !== timeZoneScope || $[3] !== visible ? (t2 = {
    onClose: hide,
    visible,
    timeZoneScope
  }, $[2] = timeZoneScope, $[3] = visible, $[4] = t2) : t2 = $[4];
  const dialogProps = t2, t3 = visible ? DialogTimeZone : null;
  let t4;
  return $[5] !== dialogProps || $[6] !== t3 || $[7] !== timeZoneScope ? (t4 = {
    DialogTimeZone: t3,
    dialogProps,
    timeZoneScope,
    dialogTimeZoneShow: show,
    hide
  }, $[5] = dialogProps, $[6] = t3, $[7] = timeZoneScope, $[8] = t4) : t4 = $[8], t4;
}
const TimeInput = styled(TextInput$1).attrs(() => ({
  type: "time"
})).withConfig({
  displayName: "TimeInput",
  componentId: "sc-vo7hzm-0"
})`line-height:1;`;
function CalendarDay$4(props2) {
  const $ = c(30), {
    date,
    focused,
    isCurrentMonth,
    isToday: isToday2,
    onSelect,
    selected,
    isPastDisabled
  } = props2;
  let t0;
  $[0] !== date || $[1] !== onSelect ? (t0 = () => {
    onSelect(date);
  }, $[0] = date, $[1] = onSelect, $[2] = t0) : t0 = $[2];
  const handleClick = t0;
  let t1;
  $[3] !== date ? (t1 = date.toDateString(), $[3] = date, $[4] = t1) : t1 = $[4];
  const t2 = focused ? "true" : "";
  let t3;
  $[5] !== date || $[6] !== isPastDisabled || $[7] !== isToday2 ? (t3 = isPastDisabled && !isToday2 && isPast(date), $[5] = date, $[6] = isPastDisabled, $[7] = isToday2, $[8] = t3) : t3 = $[8];
  const t4 = isToday2 || selected ? "primary" : "default";
  let t5;
  $[9] !== date ? (t5 = date.toDateString().replaceAll(" ", "-"), $[9] = date, $[10] = t5) : t5 = $[10];
  const t6 = `calendar-day-${t5}`, t7 = !selected && !isCurrentMonth;
  let t8;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = {
    textAlign: "center"
  }, $[11] = t8) : t8 = $[11];
  const t9 = isCurrentMonth ? "medium" : "regular";
  let t10;
  $[12] !== date ? (t10 = date.getDate(), $[12] = date, $[13] = t10) : t10 = $[13];
  let t11;
  $[14] !== t10 || $[15] !== t7 || $[16] !== t9 ? (t11 = /* @__PURE__ */ jsx(Text$1, { muted: t7, size: 1, style: t8, weight: t9, children: t10 }), $[14] = t10, $[15] = t7, $[16] = t9, $[17] = t11) : t11 = $[17];
  let t12;
  $[18] !== handleClick || $[19] !== selected || $[20] !== t1 || $[21] !== t11 || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t6 ? (t12 = /* @__PURE__ */ jsx(Card, { "aria-label": t1, "aria-pressed": selected, as: "button", __unstable_focusRing: !0, "data-weekday": !0, "data-focused": t2, role: "button", tabIndex: -1, disabled: t3, onClick: handleClick, padding: 2, radius: 2, selected, tone: t4, "data-testid": t6, children: t11 }), $[18] = handleClick, $[19] = selected, $[20] = t1, $[21] = t11, $[22] = t2, $[23] = t3, $[24] = t4, $[25] = t6, $[26] = t12) : t12 = $[26];
  let t13;
  return $[27] !== selected || $[28] !== t12 ? (t13 = /* @__PURE__ */ jsx("div", { "aria-selected": selected, "data-ui": "CalendarDay", children: t12 }), $[27] = selected, $[28] = t12, $[29] = t13) : t13 = $[29], t13;
}
const DEFAULT_MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], DEFAULT_WEEK_DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], ARROW_KEYS$2 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], TAIL_WEEKDAYS$2 = [1, 2, 3, 4, 5, 6], getWeekStartsOfMonth$2 = (date, weekStartsOn) => {
  const firstDay = startOfMonth(date);
  return eachWeekOfInterval({
    start: firstDay,
    end: lastDayOfMonth(firstDay)
  }, {
    weekStartsOn: weekStartsOn === 7 ? 0 : weekStartsOn
  });
}, getWeekDaysFromWeekStarts$2 = (weekStarts) => weekStarts.map((weekStart) => [weekStart, ...TAIL_WEEKDAYS$2.map((d) => addDays(weekStart, d))]), useWeeksOfMonth$1 = (date) => {
  const $ = c(3), {
    weekInfo
  } = useCurrentLocale();
  let t0;
  return $[0] !== date || $[1] !== weekInfo.firstDay ? (t0 = getWeekDaysFromWeekStarts$2(getWeekStartsOfMonth$2(date, weekInfo.firstDay)).map(_temp$2Z), $[0] = date, $[1] = weekInfo.firstDay, $[2] = t0) : t0 = $[2], t0;
};
function _temp$2Z(days) {
  return {
    number: getWeek(days[0]),
    days
  };
}
function CalendarMonth$3(props2) {
  const $ = c(24), {
    weekInfo: t0
  } = useCurrentLocale(), {
    firstDay: weekStartDay
  } = t0;
  let weekDayNames = props2.weekDayNames;
  if (weekStartDay === 7) {
    let t12;
    $[0] !== props2.weekDayNames ? (t12 = [props2.weekDayNames[6], ...props2.weekDayNames.slice(0, 6)], $[0] = props2.weekDayNames, $[1] = t12) : t12 = $[1], weekDayNames = t12;
  } else if (weekStartDay === 6) {
    let t12;
    $[2] !== props2.weekDayNames ? (t12 = [...props2.weekDayNames.slice(5), ...props2.weekDayNames.slice(0, 5)], $[2] = props2.weekDayNames, $[3] = t12) : t12 = $[3], weekDayNames = t12;
  }
  const t1 = props2.hidden || !1;
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    gridTemplateColumns: "repeat(7, minmax(44px, 46px))"
  }, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== weekDayNames ? (t3 = weekDayNames.map(_temp$2Y), $[5] = weekDayNames, $[6] = t3) : t3 = $[6];
  const t4 = useWeeksOfMonth$1(props2.date);
  let t5;
  if ($[7] !== props2.focused || $[8] !== props2.isPastDisabled || $[9] !== props2.onSelect || $[10] !== props2.selected || $[11] !== t4) {
    let t62;
    $[13] !== props2.focused || $[14] !== props2.isPastDisabled || $[15] !== props2.onSelect || $[16] !== props2.selected ? (t62 = (week, weekIdx) => week.days.map((date, dayIdx) => {
      const focused = props2.focused && isSameDay(date, props2.focused), selected = props2.selected && isSameDay(date, props2.selected), isToday2 = isSameDay(date, /* @__PURE__ */ new Date()), isCurrentMonth = props2.focused && isSameMonth(date, props2.focused);
      return /* @__PURE__ */ jsx(CalendarDay$4, { date, focused, isCurrentMonth, isToday: isToday2, onSelect: props2.onSelect, selected, isPastDisabled: props2.isPastDisabled }, `${weekIdx}-${dayIdx}`);
    }), $[13] = props2.focused, $[14] = props2.isPastDisabled, $[15] = props2.onSelect, $[16] = props2.selected, $[17] = t62) : t62 = $[17], t5 = t4.map(t62), $[7] = props2.focused, $[8] = props2.isPastDisabled, $[9] = props2.onSelect, $[10] = props2.selected, $[11] = t4, $[12] = t5;
  } else
    t5 = $[12];
  let t6;
  $[18] !== t3 || $[19] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Grid, { gap: 1, style: t2, children: [
    t3,
    t5
  ] }), $[18] = t3, $[19] = t5, $[20] = t6) : t6 = $[20];
  let t7;
  return $[21] !== t1 || $[22] !== t6 ? (t7 = /* @__PURE__ */ jsx(Box, { "aria-hidden": t1, "data-ui": "CalendarMonth", children: t6 }), $[21] = t1, $[22] = t6, $[23] = t7) : t7 = $[23], t7;
}
function _temp$2Y(weekday) {
  return /* @__PURE__ */ jsx(Box, { paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", style: {
    textAlign: "center"
  }, children: weekday }) }, weekday);
}
const features$1 = {
  dayPresets: !1,
  timePresets: !1
}, LazyTextInput = forwardRef(function(t0, forwardedRef) {
  const $ = c(22);
  let onBlur, onChange, onKeyPress, rest, value;
  $[0] !== t0 ? ({
    onChange,
    onBlur,
    onKeyPress,
    value,
    ...rest
  } = t0, $[0] = t0, $[1] = onBlur, $[2] = onChange, $[3] = onKeyPress, $[4] = rest, $[5] = value) : (onBlur = $[1], onChange = $[2], onKeyPress = $[3], rest = $[4], value = $[5]);
  const [inputValue, setInputValue] = useState();
  let t1;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (event) => {
    setInputValue(event.currentTarget.value);
  }, $[6] = t1) : t1 = $[6];
  const handleChange = t1;
  let t2;
  $[7] !== onChange || $[8] !== value ? (t2 = (event_0) => {
    event_0.currentTarget.value !== `${value}` && onChange && onChange(event_0), setInputValue(void 0);
  }, $[7] = onChange, $[8] = value, $[9] = t2) : t2 = $[9];
  const checkEvent = t2;
  let t3;
  $[10] !== checkEvent || $[11] !== onBlur ? (t3 = (e) => {
    checkEvent(e), onBlur && onBlur(e);
  }, $[10] = checkEvent, $[11] = onBlur, $[12] = t3) : t3 = $[12];
  const handleBlur = t3;
  let t4;
  $[13] !== checkEvent || $[14] !== onKeyPress ? (t4 = (e_0) => {
    e_0.key === "Enter" && checkEvent(e_0), onKeyPress && onKeyPress(e_0);
  }, $[13] = checkEvent, $[14] = onKeyPress, $[15] = t4) : t4 = $[15];
  const handleKeyPress = t4, t5 = inputValue === void 0 ? value : inputValue;
  let t6;
  return $[16] !== forwardedRef || $[17] !== handleBlur || $[18] !== handleKeyPress || $[19] !== rest || $[20] !== t5 ? (t6 = /* @__PURE__ */ jsx(TextInput$1, { ...rest, ref: forwardedRef, value: t5, onChange: handleChange, onBlur: handleBlur, onKeyPress: handleKeyPress }), $[16] = forwardedRef, $[17] = handleBlur, $[18] = handleKeyPress, $[19] = rest, $[20] = t5, $[21] = t6) : t6 = $[21], t6;
}), YearInput$1 = (props2) => {
  const $ = c(8);
  let onChange, restProps;
  $[0] !== props2 ? ({
    onChange,
    ...restProps
  } = props2, $[0] = props2, $[1] = onChange, $[2] = restProps) : (onChange = $[1], restProps = $[2]);
  let t0;
  $[3] !== onChange ? (t0 = (event) => {
    const numericValue = parseInt(event.currentTarget.value, 10);
    isNaN(numericValue) || onChange(numericValue);
  }, $[3] = onChange, $[4] = t0) : t0 = $[4];
  const handleChange = t0;
  let t1;
  return $[5] !== handleChange || $[6] !== restProps ? (t1 = /* @__PURE__ */ jsx(LazyTextInput, { "data-testid": "date-input", ...restProps, fontSize: 1, onChange: handleChange, inputMode: "numeric", padding: 2, radius: 2 }), $[5] = handleChange, $[6] = restProps, $[7] = t1) : t1 = $[7], t1;
}, MONTH_PICKER_VARIANT = {
  carousel: "carousel"
}, PRESERVE_FOCUS_ELEMENT$3 = /* @__PURE__ */ jsx("span", { "data-preserve-focus": !0, style: {
  overflow: "hidden",
  position: "absolute",
  outline: "none"
}, tabIndex: -1 }), CALENDAR_ICON_BUTTON_PROPS = {
  padding: 2
}, Calendar$2 = forwardRef(function(props2, forwardedRef) {
  const $ = c(147);
  let isPastDisabled, labels2, onSelect, onTimeZoneOpen, restProps, selectTime, t0, t1, t2, t3, timeZoneScope, value;
  $[0] !== props2 ? ({
    selectTime,
    value,
    timeStep: t0,
    onSelect,
    labels: labels2,
    isPastDisabled,
    monthPickerVariant: t1,
    padding: t2,
    showTimeZone: t3,
    timeZoneScope,
    onTimeZoneOpen,
    ...restProps
  } = props2, $[0] = props2, $[1] = isPastDisabled, $[2] = labels2, $[3] = onSelect, $[4] = onTimeZoneOpen, $[5] = restProps, $[6] = selectTime, $[7] = t0, $[8] = t1, $[9] = t2, $[10] = t3, $[11] = timeZoneScope, $[12] = value) : (isPastDisabled = $[1], labels2 = $[2], onSelect = $[3], onTimeZoneOpen = $[4], restProps = $[5], selectTime = $[6], t0 = $[7], t1 = $[8], t2 = $[9], t3 = $[10], timeZoneScope = $[11], value = $[12]);
  const timeStep = t0 === void 0 ? 1 : t0, monthPickerVariant = t1 === void 0 ? "select" : t1, padding = t2 === void 0 ? 2 : t2, showTimeZone = t3 === void 0 ? !1 : t3, {
    timeZone,
    zoneDateToUtc,
    utcToCurrentZoneDate
  } = useTimeZone(timeZoneScope);
  let t4;
  $[13] !== utcToCurrentZoneDate || $[14] !== value ? (t4 = utcToCurrentZoneDate(value), $[13] = utcToCurrentZoneDate, $[14] = value, $[15] = t4) : t4 = $[15];
  const currentTzDate = t4, [focusedDate, setFocusedDate] = useState(value);
  let t5;
  $[16] !== focusedDate || $[17] !== timeZone?.name ? (t5 = () => [Number(format$1(focusedDate, "MM", {
    timeZone: timeZone?.name
  })) - 1, Number(format$1(focusedDate, "YYYY", {
    timeZone: timeZone?.name
  }))], $[16] = focusedDate, $[17] = timeZone?.name, $[18] = t5) : t5 = $[18];
  let t6;
  $[19] !== t5 ? (t6 = t5(), $[19] = t5, $[20] = t6) : t6 = $[20];
  const [displayMonth, displayYear] = t6, {
    DialogTimeZone: DialogTimeZone2,
    dialogProps,
    dialogTimeZoneShow
  } = useDialogTimeZone(timeZoneScope), handleTimeZoneOpen = onTimeZoneOpen ?? dialogTimeZoneShow;
  let t7;
  $[21] !== focusedDate ? (t7 = (month) => setFocusedDate(setDate(setMonth(focusedDate, month), 1)), $[21] = focusedDate, $[22] = t7) : t7 = $[22];
  const setFocusedDateMonth = t7;
  let t8;
  $[23] !== setFocusedDateMonth ? (t8 = (e) => setFocusedDateMonth(Number(e.currentTarget.value)), $[23] = setFocusedDateMonth, $[24] = t8) : t8 = $[24];
  const handleFocusedMonthChange = t8;
  let t9;
  $[25] !== focusedDate ? (t9 = (by) => setFocusedDate(addMonths(focusedDate, by)), $[25] = focusedDate, $[26] = t9) : t9 = $[26];
  const moveFocusedDate = t9;
  let t10;
  $[27] !== focusedDate ? (t10 = (year) => setFocusedDate(setYear(focusedDate, year)), $[27] = focusedDate, $[28] = t10) : t10 = $[28];
  const setFocusedDateYear = t10;
  let t11;
  $[29] !== currentTzDate || $[30] !== onSelect || $[31] !== timeZone || $[32] !== zoneDateToUtc ? (t11 = (date) => {
    const newDate = setMinutes(setHours(date, currentTzDate.getHours()), currentTzDate.getMinutes());
    if (!timeZone) {
      onSelect(newDate);
      return;
    }
    const utcDate = zoneDateToUtc(newDate);
    onSelect(utcDate);
  }, $[29] = currentTzDate, $[30] = onSelect, $[31] = timeZone, $[32] = zoneDateToUtc, $[33] = t11) : t11 = $[33];
  const handleDateChange = t11;
  let t12;
  $[34] !== currentTzDate || $[35] !== onSelect || $[36] !== timeZone || $[37] !== zoneDateToUtc ? (t12 = (hours, mins) => {
    if (!timeZone) {
      onSelect(setHours(setMinutes(currentTzDate, mins), hours));
      return;
    }
    const zonedDate = new TZDate(currentTzDate, timeZone.name), newZonedDate = setHours(setMinutes(zonedDate, mins), hours), utcDate_0 = zoneDateToUtc(newZonedDate);
    onSelect(utcDate_0);
  }, $[34] = currentTzDate, $[35] = onSelect, $[36] = timeZone, $[37] = zoneDateToUtc, $[38] = t12) : t12 = $[38];
  const handleTimeChange = t12, t13 = timeZone?.name;
  let t14;
  $[39] !== currentTzDate || $[40] !== t13 ? (t14 = format$1(currentTzDate, "HH:mm", {
    timeZone: t13
  }), $[39] = currentTzDate, $[40] = t13, $[41] = t14) : t14 = $[41];
  const timeFromDate = t14, [timeValue, setTimeValue] = useState(timeFromDate);
  let t15, t16;
  $[42] !== timeFromDate ? (t15 = () => {
    setTimeValue(timeFromDate);
  }, t16 = [timeFromDate], $[42] = timeFromDate, $[43] = t15, $[44] = t16) : (t15 = $[43], t16 = $[44]), useEffect(t15, t16);
  let t17;
  $[45] !== handleTimeChange ? (t17 = (event) => {
    const nextValue = event.currentTarget.value;
    if (nextValue) {
      setTimeValue(nextValue);
      const date_0 = parse(nextValue, "HH:mm", /* @__PURE__ */ new Date());
      if (!isValid(date_0))
        return;
      handleTimeChange(date_0.getHours(), date_0.getMinutes());
    } else
      setTimeValue(void 0);
  }, $[45] = handleTimeChange, $[46] = t17) : t17 = $[46];
  const handleTimeChangeInputChange = t17, ref = useRef(null);
  let t18;
  $[47] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t18 = () => ref.current, $[47] = t18) : t18 = $[47], useImperativeHandle(forwardedRef, t18);
  let t19;
  $[48] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t19 = () => {
    ref.current?.querySelector('[data-focused="true"]')?.focus();
  }, $[48] = t19) : t19 = $[48];
  const focusCurrentWeekDay = t19;
  let t20;
  $[49] !== focusedDate ? (t20 = (event_0) => {
    if (!ARROW_KEYS$2.includes(event_0.key))
      return;
    const target = event_0.currentTarget;
    if (event_0.preventDefault(), target.hasAttribute("data-calendar-grid")) {
      focusCurrentWeekDay();
      return;
    }
    event_0.key === "ArrowUp" && setFocusedDate(addDays(focusedDate, -7)), event_0.key === "ArrowDown" && setFocusedDate(addDays(focusedDate, 7)), event_0.key === "ArrowLeft" && setFocusedDate(addDays(focusedDate, -1)), event_0.key === "ArrowRight" && setFocusedDate(addDays(focusedDate, 1)), ref.current?.querySelector("[data-preserve-focus]")?.focus();
  }, $[49] = focusedDate, $[50] = t20) : t20 = $[50];
  const handleKeyDown = t20;
  let t21, t22;
  $[51] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t21 = () => {
    focusCurrentWeekDay();
  }, t22 = [focusCurrentWeekDay], $[51] = t21, $[52] = t22) : (t21 = $[51], t22 = $[52]), useEffect(t21, t22);
  let t23;
  $[53] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t23 = () => {
    document.activeElement?.matches("[data-calendar-grid], [data-calendar-grid] [data-preserve-focus]") && focusCurrentWeekDay();
  }, $[53] = t23) : t23 = $[53];
  let t24;
  $[54] !== focusedDate ? (t24 = [ref, focusCurrentWeekDay, focusedDate], $[54] = focusedDate, $[55] = t24) : t24 = $[55], useEffect(t23, t24);
  let t25;
  $[56] !== handleDateChange ? (t25 = () => handleDateChange(addDays(/* @__PURE__ */ new Date(), -1)), $[56] = handleDateChange, $[57] = t25) : t25 = $[57];
  const handleYesterdayClick = t25;
  let t26;
  $[58] !== handleDateChange ? (t26 = () => handleDateChange(/* @__PURE__ */ new Date()), $[58] = handleDateChange, $[59] = t26) : t26 = $[59];
  const handleTodayClick = t26;
  let t27;
  $[60] !== handleDateChange ? (t27 = () => handleDateChange(addDays(/* @__PURE__ */ new Date(), 1)), $[60] = handleDateChange, $[61] = t27) : t27 = $[61];
  const handleTomorrowClick = t27;
  let t28;
  bb0: {
    if (monthPickerVariant === "carousel") {
      let t293;
      $[62] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t293 = {
        borderBottom: "1px solid var(--card-border-color)",
        minHeight: "55px",
        position: "sticky",
        top: 0
      }, $[62] = t293) : t293 = $[62];
      const t303 = labels2.monthNames[(focusedDate || /* @__PURE__ */ new Date())?.getMonth()];
      let t313;
      $[63] !== focusedDate ? (t313 = (focusedDate || /* @__PURE__ */ new Date())?.getFullYear(), $[63] = focusedDate, $[64] = t313) : t313 = $[64];
      let t323;
      $[65] !== t303 || $[66] !== t313 ? (t323 = /* @__PURE__ */ jsx(Flex, { align: "center", flex: 1, children: /* @__PURE__ */ jsxs(Text$1, { weight: "medium", size: 1, children: [
        t303,
        " ",
        t313
      ] }) }), $[65] = t303, $[66] = t313, $[67] = t323) : t323 = $[67];
      let t332;
      $[68] !== moveFocusedDate ? (t332 = () => moveFocusedDate(-1), $[68] = moveFocusedDate, $[69] = t332) : t332 = $[69];
      let t342;
      $[70] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t342 = {
        content: "Previous month"
      }, $[70] = t342) : t342 = $[70];
      let t352;
      $[71] !== t332 ? (t352 = /* @__PURE__ */ jsx(Button, { icon: ChevronLeftIcon, mode: "bleed", onClick: t332, "data-testid": "calendar-prev-month", tooltipProps: t342 }), $[71] = t332, $[72] = t352) : t352 = $[72];
      let t362;
      $[73] !== moveFocusedDate ? (t362 = () => moveFocusedDate(1), $[73] = moveFocusedDate, $[74] = t362) : t362 = $[74];
      let t372;
      $[75] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t372 = {
        content: "Next month"
      }, $[75] = t372) : t372 = $[75];
      let t382;
      $[76] !== t362 ? (t382 = /* @__PURE__ */ jsx(Button, { icon: ChevronRightIcon, mode: "bleed", onClick: t362, "data-testid": "calendar-next-month", tooltipProps: t372 }), $[76] = t362, $[77] = t382) : t382 = $[77];
      let t39;
      $[78] !== t352 || $[79] !== t382 ? (t39 = /* @__PURE__ */ jsx(Flex, { paddingRight: 3, gap: 2, children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
        t352,
        t382
      ] }) }), $[78] = t352, $[79] = t382, $[80] = t39) : t39 = $[80];
      let t40;
      $[81] !== t323 || $[82] !== t39 ? (t40 = /* @__PURE__ */ jsx(Flex, { align: "center", paddingLeft: 4, style: t293, children: /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, justify: "space-between", children: [
        t323,
        t39
      ] }) }), $[81] = t323, $[82] = t39, $[83] = t40) : t40 = $[83], t28 = t40;
      break bb0;
    }
    let t292;
    $[84] !== displayMonth || $[85] !== handleFocusedMonthChange || $[86] !== labels2.monthNames ? (t292 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(CalendarMonthSelect$1, { onChange: handleFocusedMonthChange, monthNames: labels2.monthNames, value: displayMonth }) }), $[84] = displayMonth, $[85] = handleFocusedMonthChange, $[86] = labels2.monthNames, $[87] = t292) : t292 = $[87];
    let t302;
    $[88] !== labels2.goToNextYear || $[89] !== labels2.goToPreviousYear ? (t302 = {
      goToNextYear: labels2.goToNextYear,
      goToPreviousYear: labels2.goToPreviousYear
    }, $[88] = labels2.goToNextYear, $[89] = labels2.goToPreviousYear, $[90] = t302) : t302 = $[90];
    let t312;
    $[91] !== displayYear || $[92] !== moveFocusedDate || $[93] !== setFocusedDateYear || $[94] !== t302 ? (t312 = /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(CalendarYearSelect$1, { moveFocusedDate, labels: t302, onChange: setFocusedDateYear, value: displayYear }) }), $[91] = displayYear, $[92] = moveFocusedDate, $[93] = setFocusedDateYear, $[94] = t302, $[95] = t312) : t312 = $[95];
    let t322;
    $[96] !== t292 || $[97] !== t312 ? (t322 = /* @__PURE__ */ jsxs(Flex, { children: [
      t292,
      t312
    ] }), $[96] = t292, $[97] = t312, $[98] = t322) : t322 = $[98], t28 = t322;
  }
  const monthPicker = t28;
  let t29;
  $[99] !== onSelect ? (t29 = () => onSelect(/* @__PURE__ */ new Date()), $[99] = onSelect, $[100] = t29) : t29 = $[100];
  const handleNowClick = t29;
  let t30;
  $[101] !== handleTodayClick || $[102] !== handleTomorrowClick || $[103] !== handleYesterdayClick || $[104] !== labels2.goToToday || $[105] !== labels2.goToTomorrow || $[106] !== labels2.goToYesterday ? (t30 = features$1.dayPresets, $[101] = handleTodayClick, $[102] = handleTomorrowClick, $[103] = handleYesterdayClick, $[104] = labels2.goToToday, $[105] = labels2.goToTomorrow, $[106] = labels2.goToYesterday, $[107] = t30) : t30 = $[107];
  let t31;
  $[108] !== currentTzDate || $[109] !== focusedDate || $[110] !== handleDateChange || $[111] !== isPastDisabled || $[112] !== labels2.weekDayNamesShort ? (t31 = /* @__PURE__ */ jsx(CalendarMonth$3, { weekDayNames: labels2.weekDayNamesShort, date: focusedDate, focused: focusedDate, onSelect: handleDateChange, selected: currentTzDate, isPastDisabled }), $[108] = currentTzDate, $[109] = focusedDate, $[110] = handleDateChange, $[111] = isPastDisabled, $[112] = labels2.weekDayNamesShort, $[113] = t31) : t31 = $[113];
  let t32;
  $[114] !== handleKeyDown || $[115] !== t31 ? (t32 = /* @__PURE__ */ jsxs(Box, { "data-calendar-grid": !0, onKeyDown: handleKeyDown, marginY: 2, overflow: "hidden", tabIndex: 0, children: [
    t31,
    PRESERVE_FOCUS_ELEMENT$3
  ] }), $[114] = handleKeyDown, $[115] = t31, $[116] = t32) : t32 = $[116];
  let t33;
  $[117] !== monthPicker || $[118] !== padding || $[119] !== t30 || $[120] !== t32 ? (t33 = /* @__PURE__ */ jsxs(Box, { padding, children: [
    t30,
    monthPicker,
    t32
  ] }), $[117] = monthPicker, $[118] = padding, $[119] = t30, $[120] = t32, $[121] = t33) : t33 = $[121];
  let t34;
  $[122] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t34 = {
    borderTop: "1px solid var(--card-border-color)"
  }, $[122] = t34) : t34 = $[122];
  let t35;
  $[123] !== currentTzDate || $[124] !== handleNowClick || $[125] !== handleTimeChange || $[126] !== handleTimeChangeInputChange || $[127] !== handleTimeZoneOpen || $[128] !== labels2 || $[129] !== selectTime || $[130] !== showTimeZone || $[131] !== timeStep || $[132] !== timeValue || $[133] !== timeZone?.abbreviation ? (t35 = selectTime && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
      /* @__PURE__ */ jsx(TimeInput, { "aria-label": labels2.selectTime, value: timeValue, onChange: handleTimeChangeInputChange, step: timeStep * 60 }),
      /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(Button, { text: labels2.setToCurrentTime, mode: "bleed", onClick: handleNowClick }) })
    ] }),
    showTimeZone && /* @__PURE__ */ jsx(Button, { icon: EarthGlobeIcon, mode: "bleed", size: "default", text: `${timeZone?.abbreviation}`, onClick: handleTimeZoneOpen }),
    features$1.timePresets
  ] }), $[123] = currentTzDate, $[124] = handleNowClick, $[125] = handleTimeChange, $[126] = handleTimeChangeInputChange, $[127] = handleTimeZoneOpen, $[128] = labels2, $[129] = selectTime, $[130] = showTimeZone, $[131] = timeStep, $[132] = timeValue, $[133] = timeZone?.abbreviation, $[134] = t35) : t35 = $[134];
  let t36;
  $[135] !== DialogTimeZone2 || $[136] !== dialogProps || $[137] !== onTimeZoneOpen || $[138] !== showTimeZone ? (t36 = showTimeZone && !onTimeZoneOpen && DialogTimeZone2 && /* @__PURE__ */ jsx(DialogTimeZone2, { ...dialogProps }), $[135] = DialogTimeZone2, $[136] = dialogProps, $[137] = onTimeZoneOpen, $[138] = showTimeZone, $[139] = t36) : t36 = $[139];
  let t37;
  $[140] !== t35 || $[141] !== t36 ? (t37 = /* @__PURE__ */ jsx(Box, { padding: 2, style: t34, children: /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-between", children: [
    t35,
    t36
  ] }) }), $[140] = t35, $[141] = t36, $[142] = t37) : t37 = $[142];
  let t38;
  return $[143] !== restProps || $[144] !== t33 || $[145] !== t37 ? (t38 = /* @__PURE__ */ jsxs(Box, { "data-testid": "calendar", "data-ui": "Calendar", ...restProps, ref, children: [
    t33,
    t37
  ] }), $[143] = restProps, $[144] = t33, $[145] = t37, $[146] = t38) : t38 = $[146], t38;
});
function CalendarMonthSelect$1(props2) {
  const $ = c(6), {
    onChange,
    value,
    monthNames
  } = props2;
  let t0;
  $[0] !== monthNames ? (t0 = monthNames.map(_temp$2X), $[0] = monthNames, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== onChange || $[3] !== t0 || $[4] !== value ? (t1 = /* @__PURE__ */ jsx(Flex, { flex: 1, gap: 1, children: /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Select, { fontSize: 1, radius: 2, value, onChange, padding: 2, children: t0 }) }) }), $[2] = onChange, $[3] = t0, $[4] = value, $[5] = t1) : t1 = $[5], t1;
}
function _temp$2X(monthName, i) {
  return /* @__PURE__ */ jsx("option", { value: i, children: monthName }, i);
}
function CalendarYearSelect$1(props2) {
  const $ = c(20), {
    moveFocusedDate,
    onChange,
    value,
    labels: labels2
  } = props2;
  let t0;
  $[0] !== moveFocusedDate ? (t0 = () => moveFocusedDate(-12), $[0] = moveFocusedDate, $[1] = t0) : t0 = $[1];
  const handlePrevYearClick = t0;
  let t1;
  $[2] !== moveFocusedDate ? (t1 = () => moveFocusedDate(12), $[2] = moveFocusedDate, $[3] = t1) : t1 = $[3];
  const handleNextYearClick = t1;
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    content: "Previous year"
  }, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== handlePrevYearClick || $[6] !== labels2.goToPreviousYear ? (t3 = /* @__PURE__ */ jsx(Button, { "aria-label": labels2.goToPreviousYear, onClick: handlePrevYearClick, mode: "bleed", icon: ChevronLeftIcon, tooltipProps: t2, ...CALENDAR_ICON_BUTTON_PROPS }), $[5] = handlePrevYearClick, $[6] = labels2.goToPreviousYear, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    width: 48
  }, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== onChange || $[10] !== value ? (t5 = /* @__PURE__ */ jsx(YearInput$1, { value, onChange, radius: 0, style: t4 }), $[9] = onChange, $[10] = value, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    content: "Next year"
  }, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== handleNextYearClick || $[14] !== labels2.goToNextYear ? (t7 = /* @__PURE__ */ jsx(Button, { "aria-label": labels2.goToNextYear, onClick: handleNextYearClick, mode: "bleed", icon: ChevronRightIcon, tooltipProps: t6, ...CALENDAR_ICON_BUTTON_PROPS }), $[13] = handleNextYearClick, $[14] = labels2.goToNextYear, $[15] = t7) : t7 = $[15];
  let t8;
  return $[16] !== t3 || $[17] !== t5 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t3,
    t5,
    t7
  ] }), $[16] = t3, $[17] = t5, $[18] = t7, $[19] = t8) : t8 = $[19], t8;
}
const DatePicker$2 = forwardRef(function(props2, ref) {
  const $ = c(22);
  let _value, calendarLabels, onChange, onTimeZoneOpen, rest, t0, t1, timeZoneScope;
  $[0] !== props2 ? ({
    value: _value,
    onChange,
    calendarLabels,
    padding: t0,
    showTimeZone: t1,
    timeZoneScope,
    onTimeZoneOpen,
    ...rest
  } = props2, $[0] = props2, $[1] = _value, $[2] = calendarLabels, $[3] = onChange, $[4] = onTimeZoneOpen, $[5] = rest, $[6] = t0, $[7] = t1, $[8] = timeZoneScope) : (_value = $[1], calendarLabels = $[2], onChange = $[3], onTimeZoneOpen = $[4], rest = $[5], t0 = $[6], t1 = $[7], timeZoneScope = $[8]);
  const padding = t0 === void 0 ? 2 : t0, showTimeZone = t1 === void 0 ? !1 : t1;
  let t2;
  bb0: {
    if (_value) {
      t2 = _value;
      break bb0;
    }
    let now;
    $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (now = /* @__PURE__ */ new Date(), now.setSeconds(0, 0), $[9] = now) : now = $[9], t2 = now;
  }
  const value = t2;
  let t3;
  $[10] !== onChange ? (t3 = (nextDate) => {
    onChange(nextDate);
  }, $[10] = onChange, $[11] = t3) : t3 = $[11];
  const handleSelect = t3;
  let t4;
  return $[12] !== calendarLabels || $[13] !== handleSelect || $[14] !== onTimeZoneOpen || $[15] !== padding || $[16] !== ref || $[17] !== rest || $[18] !== showTimeZone || $[19] !== timeZoneScope || $[20] !== value ? (t4 = /* @__PURE__ */ jsx(Calendar$2, { ...rest, labels: calendarLabels, ref, value, onSelect: handleSelect, padding, showTimeZone, timeZoneScope, onTimeZoneOpen }), $[12] = calendarLabels, $[13] = handleSelect, $[14] = onTimeZoneOpen, $[15] = padding, $[16] = ref, $[17] = rest, $[18] = showTimeZone, $[19] = timeZoneScope, $[20] = value, $[21] = t4) : t4 = $[21], t4;
});
function DatePickerPopoverContent(t0) {
  const $ = c(4), {
    popoverRef,
    onClose,
    children
  } = t0, {
    isTopLayer
  } = useLayer();
  let t1;
  $[0] !== popoverRef ? (t1 = () => [popoverRef.current], $[0] = popoverRef, $[1] = t1) : t1 = $[1], useClickOutsideEvent(isTopLayer && onClose, t1);
  let t2;
  return $[2] !== children ? (t2 = /* @__PURE__ */ jsx(Fragment$1, { children }), $[2] = children, $[3] = t2) : t2 = $[3], t2;
}
const DateTimeInput$3 = forwardRef(function(props2, forwardedRef) {
  const $ = c(67);
  let calendarLabels, disableInput, inputValue, isPastDisabled, monthPickerVariant, onChange, onInputChange, padding, readOnly, rest, selectTime, t0, t1, timeStep, timeZoneScope, value;
  $[0] !== props2 ? ({
    value,
    inputValue,
    onInputChange,
    onChange,
    selectTime,
    timeStep,
    calendarLabels,
    readOnly,
    constrainSize: t0,
    monthPickerVariant,
    padding,
    disableInput,
    isPastDisabled,
    showTimeZone: t1,
    timeZoneScope,
    ...rest
  } = props2, $[0] = props2, $[1] = calendarLabels, $[2] = disableInput, $[3] = inputValue, $[4] = isPastDisabled, $[5] = monthPickerVariant, $[6] = onChange, $[7] = onInputChange, $[8] = padding, $[9] = readOnly, $[10] = rest, $[11] = selectTime, $[12] = t0, $[13] = t1, $[14] = timeStep, $[15] = timeZoneScope, $[16] = value) : (calendarLabels = $[1], disableInput = $[2], inputValue = $[3], isPastDisabled = $[4], monthPickerVariant = $[5], onChange = $[6], onInputChange = $[7], padding = $[8], readOnly = $[9], rest = $[10], selectTime = $[11], t0 = $[12], t1 = $[13], timeStep = $[14], timeZoneScope = $[15], value = $[16]);
  const constrainSize = t0 === void 0 ? !0 : t0, showTimeZone = t1 === void 0 ? !1 : t1, {
    t
  } = useTranslation(), popoverRef = useRef(null), ref = useRef(null), buttonRef = useRef(null), {
    zoneDateToUtc
  } = useTimeZone(timeZoneScope), {
    DialogTimeZone: DialogTimeZone2,
    dialogProps,
    dialogTimeZoneShow,
    hide: dialogTimeZoneHide
  } = useDialogTimeZone(timeZoneScope), [referenceElement, setReferenceElement] = useState(null);
  let t2;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => ref.current, $[17] = t2) : t2 = $[17], useImperativeHandle(forwardedRef, t2);
  let t3, t4;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setReferenceElement(ref.current), t4 = [], $[18] = t3, $[19] = t4) : (t3 = $[18], t4 = $[19]), useEffect(t3, t4);
  const [isPickerOpen, setPickerOpen] = useState(!1);
  let t5;
  $[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => setPickerOpen(!1), $[20] = t5) : t5 = $[20];
  const handleClose = t5;
  let t6;
  $[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    ref.current?.focus(), ref.current?.select();
  }, $[21] = t6) : t6 = $[21];
  const handleDeactivation = t6;
  let t7;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = (e) => {
    e.key === "Escape" && setPickerOpen(!1);
  }, $[22] = t7) : t7 = $[22];
  const handleKeyUp = t7;
  let t8;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = () => setPickerOpen(!0), $[23] = t8) : t8 = $[23];
  const handleClick = t8;
  let t9;
  $[24] !== dialogTimeZoneShow ? (t9 = () => {
    setPickerOpen(!1), dialogTimeZoneShow();
  }, $[24] = dialogTimeZoneShow, $[25] = t9) : t9 = $[25];
  const handleTimeZoneOpen = t9;
  let t10;
  $[26] !== dialogTimeZoneHide ? (t10 = () => {
    dialogTimeZoneHide(), setPickerOpen(!0);
  }, $[26] = dialogTimeZoneHide, $[27] = t10) : t10 = $[27];
  const handleTimeZoneClose = t10;
  let t11;
  $[28] !== inputValue || $[29] !== isPastDisabled || $[30] !== zoneDateToUtc ? (t11 = inputValue && isPastDisabled && isPast(zoneDateToUtc(new Date(inputValue))), $[28] = inputValue, $[29] = isPastDisabled, $[30] = zoneDateToUtc, $[31] = t11) : t11 = $[31];
  const isDateInPastWarningShown = t11;
  let t12;
  $[32] !== calendarLabels || $[33] !== readOnly ? (t12 = readOnly ? null : /* @__PURE__ */ jsx(Flex, { style: {
    padding: "5px"
  }, children: /* @__PURE__ */ jsx(Button, { disabled: readOnly, "aria-label": calendarLabels.ariaLabel, ref: buttonRef, icon: CalendarIcon, mode: "bleed", onClick: handleClick, style: {
    display: "block"
  }, "data-testid": "select-date-button", tooltipProps: {
    content: calendarLabels.tooltipText
  } }) }), $[32] = calendarLabels, $[33] = readOnly, $[34] = t12) : t12 = $[34];
  const suffix = t12, t13 = disableInput || readOnly;
  let t14;
  $[35] !== calendarLabels || $[36] !== constrainSize || $[37] !== handleTimeZoneOpen || $[38] !== isDateInPastWarningShown || $[39] !== isPastDisabled || $[40] !== isPickerOpen || $[41] !== monthPickerVariant || $[42] !== onChange || $[43] !== padding || $[44] !== referenceElement || $[45] !== selectTime || $[46] !== showTimeZone || $[47] !== suffix || $[48] !== t || $[49] !== timeStep || $[50] !== timeZoneScope || $[51] !== value ? (t14 = isPickerOpen ? /* @__PURE__ */ jsx(LayerProvider, { zOffset: 1e3, children: /* @__PURE__ */ jsx(Popover, { constrainSize, "data-testid": "date-input-dialog", referenceElement, portal: !0, content: /* @__PURE__ */ jsx(DatePickerPopoverContent, { popoverRef, onClose: handleClose, children: /* @__PURE__ */ jsx(Box, { overflow: "auto", children: /* @__PURE__ */ jsxs(FocusLock, { onDeactivation: handleDeactivation, children: [
    isDateInPastWarningShown && /* @__PURE__ */ jsx(Card, { margin: 1, padding: 2, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("inputs.dateTime.past-date-warning") }) }),
    /* @__PURE__ */ jsx(DatePicker$2, { monthPickerVariant, calendarLabels, selectTime, timeStep, onKeyUp: handleKeyUp, value, isPastDisabled, onChange, padding, showTimeZone, timeZoneScope, onTimeZoneOpen: handleTimeZoneOpen })
  ] }) }) }), open: !0, placement: "bottom", ref: popoverRef, children: /* @__PURE__ */ jsx(Fragment$1, { children: suffix }) }) }) : suffix, $[35] = calendarLabels, $[36] = constrainSize, $[37] = handleTimeZoneOpen, $[38] = isDateInPastWarningShown, $[39] = isPastDisabled, $[40] = isPickerOpen, $[41] = monthPickerVariant, $[42] = onChange, $[43] = padding, $[44] = referenceElement, $[45] = selectTime, $[46] = showTimeZone, $[47] = suffix, $[48] = t, $[49] = timeStep, $[50] = timeZoneScope, $[51] = value, $[52] = t14) : t14 = $[52];
  let t15;
  $[53] !== inputValue || $[54] !== onInputChange || $[55] !== rest || $[56] !== t13 || $[57] !== t14 ? (t15 = /* @__PURE__ */ jsx(LazyTextInput, { ref, "data-testid": "date-input", ...rest, readOnly: t13, value: inputValue, onChange: onInputChange, suffix: t14 }), $[53] = inputValue, $[54] = onInputChange, $[55] = rest, $[56] = t13, $[57] = t14, $[58] = t15) : t15 = $[58];
  let t16;
  $[59] !== DialogTimeZone2 || $[60] !== dialogProps || $[61] !== handleTimeZoneClose || $[62] !== showTimeZone ? (t16 = showTimeZone && DialogTimeZone2 && /* @__PURE__ */ jsx(DialogTimeZone2, { ...dialogProps, onClose: handleTimeZoneClose }), $[59] = DialogTimeZone2, $[60] = dialogProps, $[61] = handleTimeZoneClose, $[62] = showTimeZone, $[63] = t16) : t16 = $[63];
  let t17;
  return $[64] !== t15 || $[65] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t15,
    t16
  ] }), $[64] = t15, $[65] = t16, $[66] = t17) : t17 = $[66], t17;
}), DEFAULT_PLACEHOLDER_TIME = /* @__PURE__ */ new Date(), CommonDateTimeInput$1 = forwardRef(function(props2, forwardedRef) {
  const $ = c(52);
  let deserialize2, formatInputValue, id2, onChange, parseInputValue, placeholder, readOnly, restProps, selectTime, serialize2, timeStep, timeZoneScope, value;
  $[0] !== props2 ? ({
    id: id2,
    deserialize: deserialize2,
    formatInputValue,
    onChange,
    parseInputValue,
    placeholder,
    readOnly,
    selectTime,
    serialize: serialize2,
    timeStep,
    timeZoneScope,
    value,
    ...restProps
  } = props2, $[0] = props2, $[1] = deserialize2, $[2] = formatInputValue, $[3] = id2, $[4] = onChange, $[5] = parseInputValue, $[6] = placeholder, $[7] = readOnly, $[8] = restProps, $[9] = selectTime, $[10] = serialize2, $[11] = timeStep, $[12] = timeZoneScope, $[13] = value) : (deserialize2 = $[1], formatInputValue = $[2], id2 = $[3], onChange = $[4], parseInputValue = $[5], placeholder = $[6], readOnly = $[7], restProps = $[8], selectTime = $[9], serialize2 = $[10], timeStep = $[11], timeZoneScope = $[12], value = $[13]);
  const [localValue, setLocalValue] = useState(null), {
    t
  } = useTranslation();
  let t0;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setLocalValue(null);
  }, $[14] = t0) : t0 = $[14];
  let t1;
  $[15] !== value ? (t1 = [value], $[15] = value, $[16] = t1) : t1 = $[16], useEffect(t0, t1);
  let t2;
  $[17] !== localValue || $[18] !== onChange || $[19] !== parseInputValue || $[20] !== serialize2 || $[21] !== value ? (t2 = (event) => {
    const nextInputValue = event.currentTarget.value, result = nextInputValue === "" ? null : parseInputValue(nextInputValue);
    result === null ? (onChange(null), typeof value > "u" && localValue && setLocalValue(null)) : result.isValid ? onChange(serialize2(result.date)) : setLocalValue(nextInputValue);
  }, $[17] = localValue, $[18] = onChange, $[19] = parseInputValue, $[20] = serialize2, $[21] = value, $[22] = t2) : t2 = $[22];
  const handleDatePickerInputChange = t2;
  let t3;
  $[23] !== onChange || $[24] !== serialize2 ? (t3 = (nextDate) => {
    onChange(nextDate ? serialize2(nextDate) : null);
  }, $[23] = onChange, $[24] = serialize2, $[25] = t3) : t3 = $[25];
  const handleDatePickerChange = t3, ref = useRef(null);
  let t4;
  $[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => ref.current, $[26] = t4) : t4 = $[26], useImperativeHandle(forwardedRef, t4);
  let parseResult, t5;
  $[27] !== deserialize2 || $[28] !== formatInputValue || $[29] !== localValue || $[30] !== parseInputValue || $[31] !== value ? (parseResult = localValue ? parseInputValue(localValue) : value ? deserialize2(value) : null, t5 = localValue || (parseResult?.isValid ? formatInputValue(parseResult.date) : value), $[27] = deserialize2, $[28] = formatInputValue, $[29] = localValue, $[30] = parseInputValue, $[31] = value, $[32] = parseResult, $[33] = t5) : (parseResult = $[32], t5 = $[33]);
  const inputValue = t5, t6 = props2.calendarLabels;
  let t7;
  $[34] !== formatInputValue || $[35] !== placeholder || $[36] !== t ? (t7 = placeholder || t("inputs.datetime.placeholder", {
    example: formatInputValue(DEFAULT_PLACEHOLDER_TIME)
  }), $[34] = formatInputValue, $[35] = placeholder, $[36] = t, $[37] = t7) : t7 = $[37];
  const t8 = parseResult?.date, t9 = inputValue || "", t10 = !!readOnly, t11 = parseResult?.error;
  let t12;
  return $[38] !== handleDatePickerChange || $[39] !== handleDatePickerInputChange || $[40] !== id2 || $[41] !== props2.calendarLabels || $[42] !== restProps || $[43] !== selectTime || $[44] !== t10 || $[45] !== t11 || $[46] !== t7 || $[47] !== t8 || $[48] !== t9 || $[49] !== timeStep || $[50] !== timeZoneScope ? (t12 = /* @__PURE__ */ jsx(DateTimeInput$3, { ...restProps, calendarLabels: t6, id: id2, selectTime, timeStep, timeZoneScope, placeholder: t7, ref, value: t8, inputValue: t9, readOnly: t10, onInputChange: handleDatePickerInputChange, onChange: handleDatePickerChange, customValidity: t11 }), $[38] = handleDatePickerChange, $[39] = handleDatePickerInputChange, $[40] = id2, $[41] = props2.calendarLabels, $[42] = restProps, $[43] = selectTime, $[44] = t10, $[45] = t11, $[46] = t7, $[47] = t8, $[48] = t9, $[49] = timeStep, $[50] = timeZoneScope, $[51] = t12) : t12 = $[51], t12;
});
function isValidDate$1(date) {
  return date instanceof Date && !isNaN(date.valueOf());
}
function getCalendarLabels(t) {
  return {
    ariaLabel: t("calendar.button.aria-label"),
    goToTomorrow: t("calendar.action.go-to-tomorrow"),
    goToToday: t("calendar.action.go-to-today"),
    goToYesterday: t("calendar.action.go-to-yesterday"),
    goToNextMonth: t("calendar.action.go-to-next-month"),
    goToPreviousMonth: t("calendar.action.go-to-previous-month"),
    goToNextYear: t("calendar.action.go-to-next-year"),
    goToPreviousYear: t("calendar.action.go-to-previous-year"),
    setToCurrentTime: t("calendar.action.set-to-current-time"),
    selectTime: t("calendar.action.select-time"),
    tooltipText: t("calendar.button.tooltip-text"),
    monthNames: [t("calendar.month-names.january"), t("calendar.month-names.february"), t("calendar.month-names.march"), t("calendar.month-names.april"), t("calendar.month-names.may"), t("calendar.month-names.june"), t("calendar.month-names.july"), t("calendar.month-names.august"), t("calendar.month-names.september"), t("calendar.month-names.october"), t("calendar.month-names.november"), t("calendar.month-names.december")],
    weekDayNamesShort: [t("calendar.weekday-names.short.monday"), t("calendar.weekday-names.short.tuesday"), t("calendar.weekday-names.short.wednesday"), t("calendar.weekday-names.short.thursday"), t("calendar.weekday-names.short.friday"), t("calendar.weekday-names.short.saturday"), t("calendar.weekday-names.short.sunday")],
    setToTimePreset: (time, date) => t("calendar.action.set-to-time-preset", {
      time,
      date
    })
  };
}
const deserialize$2 = (value) => parse$2(value, DEFAULT_DATE_FORMAT), serialize$4 = (date) => format$1(date, DEFAULT_DATE_FORMAT);
function DateInput(props2) {
  const $ = c(20), {
    readOnly,
    onChange,
    schemaType,
    elementProps,
    value,
    id: id2
  } = props2, dateFormat = schemaType.options?.dateFormat || DEFAULT_DATE_FORMAT, {
    t
  } = useTranslation();
  let t0;
  $[0] !== id2 ? (t0 = {
    type: "input",
    id: id2
  }, $[0] = id2, $[1] = t0) : t0 = $[1];
  const timeZoneScope = t0;
  let t1;
  $[2] !== onChange ? (t1 = (nextDate) => {
    onChange(nextDate === null ? unset() : set(nextDate));
  }, $[2] = onChange, $[3] = t1) : t1 = $[3];
  const handleChange = t1;
  let t2;
  $[4] !== dateFormat ? (t2 = (date) => format$1(date, dateFormat), $[4] = dateFormat, $[5] = t2) : t2 = $[5];
  const formatInputValue = t2;
  let t3;
  $[6] !== dateFormat ? (t3 = (inputValue) => parse$2(inputValue, dateFormat), $[6] = dateFormat, $[7] = t3) : t3 = $[7];
  const parseInputValue = t3;
  let t4;
  $[8] !== t ? (t4 = getCalendarLabels(t), $[8] = t, $[9] = t4) : t4 = $[9];
  const calendarLabels = t4;
  let t5;
  return $[10] !== calendarLabels || $[11] !== elementProps || $[12] !== formatInputValue || $[13] !== handleChange || $[14] !== parseInputValue || $[15] !== readOnly || $[16] !== schemaType.placeholder || $[17] !== timeZoneScope || $[18] !== value ? (t5 = /* @__PURE__ */ jsx(CommonDateTimeInput$1, { ...elementProps, deserialize: deserialize$2, formatInputValue, onChange: handleChange, parseInputValue, placeholder: schemaType.placeholder, calendarLabels, readOnly, selectTime: !1, serialize: serialize$4, value, timeZoneScope }), $[10] = calendarLabels, $[11] = elementProps, $[12] = formatInputValue, $[13] = handleChange, $[14] = parseInputValue, $[15] = readOnly, $[16] = schemaType.placeholder, $[17] = timeZoneScope, $[18] = value, $[19] = t5) : t5 = $[19], t5;
}
const TimeZoneButton = (props2) => {
  const $ = c(18), {
    useElementQueries,
    timeZoneScope,
    allowTimeZoneSwitch: t0,
    tooltipContent
  } = props2, allowTimeZoneSwitch = t0 === void 0 ? !0 : t0, {
    timeZone
  } = useTimeZone(timeZoneScope), {
    DialogTimeZone: DialogTimeZone2,
    dialogProps,
    dialogTimeZoneShow
  } = useDialogTimeZone(timeZoneScope);
  let t1;
  $[0] !== DialogTimeZone2 || $[1] !== dialogProps ? (t1 = DialogTimeZone2 && /* @__PURE__ */ jsx(DialogTimeZone2, { ...dialogProps }), $[0] = DialogTimeZone2, $[1] = dialogProps, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== tooltipContent ? (t2 = /* @__PURE__ */ jsx(Box, { flex: 1, padding: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: tooltipContent }) }), $[3] = tooltipContent, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== allowTimeZoneSwitch || $[6] !== dialogTimeZoneShow || $[7] !== timeZone.alternativeName || $[8] !== timeZone.city || $[9] !== timeZone.namePretty || $[10] !== useElementQueries ? (t3 = /* @__PURE__ */ jsx("div", { children: useElementQueries ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(Box, { className: "button-small", children: allowTimeZoneSwitch ? /* @__PURE__ */ jsx(Button, { "data-testid": "timezone-button", icon: EarthAmericasIcon, mode: "bleed", readOnly: !allowTimeZoneSwitch, onClick: allowTimeZoneSwitch ? dialogTimeZoneShow : noop$7, text: `${timeZone.city}` }) : /* @__PURE__ */ jsxs(Inline, { space: 2, padding: 2, children: [
      /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: /* @__PURE__ */ jsx(EarthAmericasIcon, {}) }),
      /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: `${timeZone.city}` })
    ] }) }),
    /* @__PURE__ */ jsx(Box, { className: "button-large", children: allowTimeZoneSwitch ? /* @__PURE__ */ jsx(Button, { "data-testid": "timezone-button", icon: EarthAmericasIcon, mode: "bleed", readOnly: !allowTimeZoneSwitch, onClick: allowTimeZoneSwitch ? dialogTimeZoneShow : noop$7, text: `${timeZone.alternativeName} (${timeZone.namePretty})` }) : /* @__PURE__ */ jsxs(Inline, { space: 2, padding: 2, children: [
      /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: /* @__PURE__ */ jsx(EarthAmericasIcon, {}) }),
      /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: `${timeZone.alternativeName} (${timeZone.namePretty})` })
    ] }) })
  ] }) : /* @__PURE__ */ jsx(Fragment$1, { children: allowTimeZoneSwitch ? /* @__PURE__ */ jsx(Button, { icon: EarthAmericasIcon, mode: "bleed", readOnly: !allowTimeZoneSwitch, onClick: allowTimeZoneSwitch ? dialogTimeZoneShow : noop$7, text: `${timeZone.alternativeName} (${timeZone.namePretty})` }) : /* @__PURE__ */ jsxs(Inline, { space: 2, padding: 2, children: [
    /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: /* @__PURE__ */ jsx(EarthAmericasIcon, {}) }),
    /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: `${timeZone.alternativeName} (${timeZone.namePretty})` })
  ] }) }) }), $[5] = allowTimeZoneSwitch, $[6] = dialogTimeZoneShow, $[7] = timeZone.alternativeName, $[8] = timeZone.city, $[9] = timeZone.namePretty, $[10] = useElementQueries, $[11] = t3) : t3 = $[11];
  let t4;
  $[12] !== t2 || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsx(Tooltip, { content: t2, portal: !0, children: t3 }), $[12] = t2, $[13] = t3, $[14] = t4) : t4 = $[14];
  let t5;
  return $[15] !== t1 || $[16] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t1,
    t4
  ] }), $[15] = t1, $[16] = t4, $[17] = t5) : t5 = $[17], t5;
}, TimeZoneButtonElementQuery$1 = styled(ElementQuery).withConfig({
  displayName: "TimeZoneButtonElementQuery",
  componentId: "sc-1k8t8gw-0"
})`.button-small{display:block;}.button-large{display:none;}&[data-eq-min~='2']{.button-small{display:none;}.button-large{display:block;}}`;
function sanitizeTimeZoneKeyId(id2) {
  try {
    return fromString(id2).map((segment) => isKeySegment(segment) ? `key-${segment._key}` : typeof segment == "number" ? `idx_${segment}` : segment).join(".");
  } catch {
    return id2.replace(/[[\]="']/g, "-");
  }
}
const Root$o = styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-1t1t98a-0"
})`line-height:1;`, serialize$3 = (date) => date.toISOString();
function parseOptions$1(options = {}) {
  const displayTimeZone = options.displayTimeZone && isValidTimeZoneString(options.displayTimeZone) ? options.displayTimeZone : void 0;
  return options.displayTimeZone && !displayTimeZone && console.warn(`Invalid time zone "${options.displayTimeZone}" supplied to datetime input, defaulting to local time zone or a previously stored preference`), {
    dateFormat: options.dateFormat || DEFAULT_DATE_FORMAT,
    timeFormat: options.timeFormat || DEFAULT_TIME_FORMAT,
    timeStep: "timeStep" in options && Number(options.timeStep) || 1,
    displayTimeZone,
    allowTimeZoneSwitch: options.allowTimeZoneSwitch === void 0 ? !0 : options.allowTimeZoneSwitch
  };
}
const getDeserializer = (timeZoneName) => (isoString) => {
  const {
    date: deserialized
  } = parse$2(isoString, void 0, timeZoneName);
  return deserialized && isValidDate$1(deserialized) ? {
    isValid: !0,
    date: deserialized
  } : {
    isValid: !1,
    error: `Invalid date value: "${isoString}"`
  };
};
function enforceTimeStep$1(dateString, timeStep) {
  if (!timeStep || timeStep === 1)
    return dateString;
  const date = parseISO(dateString), minutes = getMinutes(date), leftOver = minutes % timeStep;
  return serialize$3(leftOver !== 0 ? setMinutes(date, minutes - leftOver) : date);
}
function DateTimeInput$2(props2) {
  const $ = c(78), {
    onChange,
    schemaType,
    value,
    elementProps,
    id: id2,
    validation: validation2,
    changed,
    path,
    presence: t0
  } = props2, presence = t0 === void 0 ? EMPTY_ARRAY$y : t0, {
    focused,
    __internal_comments: comments2,
    hovered,
    onMouseEnter,
    onMouseLeave,
    actions,
    __internal_slot: slot
  } = useFieldActions();
  let t1;
  $[0] !== schemaType.options ? (t1 = parseOptions$1(schemaType.options), $[0] = schemaType.options, $[1] = t1) : t1 = $[1];
  const {
    dateFormat,
    timeFormat,
    timeStep,
    displayTimeZone,
    allowTimeZoneSwitch: t2
  } = t1, allowTimeZoneSwitch = t2 === void 0 ? !0 : t2, {
    title
  } = schemaType, {
    t
  } = useTranslation();
  let t3;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = ["_id"], $[2] = t3) : t3 = $[2];
  const t4 = useFormValue(t3);
  let t5;
  $[3] !== t4 ? (t5 = getPublishedId(t4), $[3] = t4, $[4] = t5) : t5 = $[4];
  const published = t5;
  let t6;
  $[5] !== id2 ? (t6 = sanitizeTimeZoneKeyId(id2), $[5] = id2, $[6] = t6) : t6 = $[6];
  const t7 = `${published}.${t6}${allowTimeZoneSwitch ? "" : ".fixed"}`;
  let t8;
  $[7] !== value ? (t8 = value ? new Date(value) : void 0, $[7] = value, $[8] = t8) : t8 = $[8];
  let t9;
  $[9] !== displayTimeZone || $[10] !== t7 || $[11] !== t8 ? (t9 = {
    type: "input",
    defaultTimeZone: displayTimeZone,
    id: t7,
    relativeDate: t8
  }, $[9] = displayTimeZone, $[10] = t7, $[11] = t8, $[12] = t9) : t9 = $[12];
  const timeZoneScope = t9, {
    timeZone
  } = useTimeZone(timeZoneScope);
  let t10;
  $[13] !== onChange || $[14] !== timeStep ? (t10 = (nextDate) => {
    let date = nextDate;
    date !== null && timeStep > 1 && (date = enforceTimeStep$1(date, timeStep)), onChange(date === null ? unset() : set(date));
  }, $[13] = onChange, $[14] = timeStep, $[15] = t10) : t10 = $[15];
  const handleChange = t10;
  let t11;
  $[16] !== dateFormat || $[17] !== timeFormat || $[18] !== timeZone.name ? (t11 = (date_0) => format$1(date_0, `${dateFormat} ${timeFormat}`, {
    timeZone: timeZone.name
  }), $[16] = dateFormat, $[17] = timeFormat, $[18] = timeZone.name, $[19] = t11) : t11 = $[19];
  const formatInputValue = t11;
  let t12;
  $[20] !== timeZone.name ? (t12 = getDeserializer(timeZone.name), $[20] = timeZone.name, $[21] = t12) : t12 = $[21];
  const deserialize2 = t12;
  let t13;
  $[22] !== dateFormat || $[23] !== timeFormat || $[24] !== timeZone.name ? (t13 = (inputValue) => parse$2(inputValue, `${dateFormat} ${timeFormat}`, timeZone.name), $[22] = dateFormat, $[23] = timeFormat, $[24] = timeZone.name, $[25] = t13) : t13 = $[25];
  const parseInputValue = t13;
  let t14;
  $[26] !== t ? (t14 = getCalendarLabels(t), $[26] = t, $[27] = t14) : t14 = $[27];
  const calendarLabels = t14, t15 = `field-${id2}`, t16 = !!focused;
  let t17;
  $[28] !== allowTimeZoneSwitch || $[29] !== displayTimeZone || $[30] !== schemaType.options?.allowTimeZoneSwitch || $[31] !== t || $[32] !== timeZone.alternativeName || $[33] !== timeZone.offset || $[34] !== timeZoneScope || $[35] !== title ? (t17 = (displayTimeZone || schemaType.options?.allowTimeZoneSwitch === !0) && /* @__PURE__ */ jsx(TimeZoneButtonElementQuery$1, { children: /* @__PURE__ */ jsx(TimeZoneButton, { tooltipContent: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "time-zone.time-zone-tooltip-input", values: {
    title,
    alternativeName: timeZone.alternativeName,
    offset: timeZone.offset
  } }), allowTimeZoneSwitch, useElementQueries: !0, timeZoneScope }) }), $[28] = allowTimeZoneSwitch, $[29] = displayTimeZone, $[30] = schemaType.options?.allowTimeZoneSwitch, $[31] = t, $[32] = timeZone.alternativeName, $[33] = timeZone.offset, $[34] = timeZoneScope, $[35] = title, $[36] = t17) : t17 = $[36];
  let t18;
  $[37] !== id2 || $[38] !== schemaType.deprecated || $[39] !== schemaType.description || $[40] !== schemaType.title || $[41] !== t17 || $[42] !== validation2 ? (t18 = /* @__PURE__ */ jsx(Stack, { space: 2, children: /* @__PURE__ */ jsx(FormFieldHeaderText, { deprecated: schemaType.deprecated, description: schemaType.description, inputId: id2, validation: validation2, title: schemaType.title, suffix: t17 }) }), $[37] = id2, $[38] = schemaType.deprecated, $[39] = schemaType.description, $[40] = schemaType.title, $[41] = t17, $[42] = validation2, $[43] = t18) : t18 = $[43];
  let t19;
  $[44] !== actions || $[45] !== comments2 || $[46] !== hovered || $[47] !== id2 || $[48] !== presence || $[49] !== slot || $[50] !== t16 || $[51] !== t18 ? (t19 = /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, children: /* @__PURE__ */ jsx(FormFieldBaseHeader, { __internal_comments: comments2, __internal_slot: slot, actions, fieldFocused: t16, fieldHovered: hovered, presence, inputId: id2, content: t18 }) }), $[44] = actions, $[45] = comments2, $[46] = hovered, $[47] = id2, $[48] = presence, $[49] = slot, $[50] = t16, $[51] = t18, $[52] = t19) : t19 = $[52];
  let t20;
  $[53] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t20 = /* @__PURE__ */ jsx(FormFieldStatus, { maxAvatars: 1, position: "top" }), $[53] = t20) : t20 = $[53];
  const t21 = !!focused;
  let t22;
  $[54] !== calendarLabels || $[55] !== deserialize2 || $[56] !== elementProps || $[57] !== formatInputValue || $[58] !== handleChange || $[59] !== parseInputValue || $[60] !== schemaType.placeholder || $[61] !== timeStep || $[62] !== timeZoneScope || $[63] !== value ? (t22 = /* @__PURE__ */ jsx("div", { "data-testid": "change-bar-wrapper", children: /* @__PURE__ */ jsx("div", { "data-testid": "change-bar__field-wrapper", children: /* @__PURE__ */ jsx(CommonDateTimeInput$1, { ...elementProps, calendarLabels, deserialize: deserialize2, formatInputValue, onChange: handleChange, parseInputValue, placeholder: schemaType.placeholder, serialize: serialize$3, timeStep, selectTime: !0, value, timeZoneScope }) }) }), $[54] = calendarLabels, $[55] = deserialize2, $[56] = elementProps, $[57] = formatInputValue, $[58] = handleChange, $[59] = parseInputValue, $[60] = schemaType.placeholder, $[61] = timeStep, $[62] = timeZoneScope, $[63] = value, $[64] = t22) : t22 = $[64];
  let t23;
  $[65] !== changed || $[66] !== path || $[67] !== t21 || $[68] !== t22 ? (t23 = /* @__PURE__ */ jsx(ChangeIndicator, { hasFocus: t21, isChanged: changed, path, children: t22 }), $[65] = changed, $[66] = path, $[67] = t21, $[68] = t22, $[69] = t23) : t23 = $[69];
  let t24;
  $[70] !== t19 || $[71] !== t23 ? (t24 = /* @__PURE__ */ jsxs(Flex, { direction: "column", children: [
    t19,
    t20,
    t23
  ] }), $[70] = t19, $[71] = t23, $[72] = t24) : t24 = $[72];
  let t25;
  return $[73] !== onMouseEnter || $[74] !== onMouseLeave || $[75] !== t15 || $[76] !== t24 ? (t25 = /* @__PURE__ */ jsx(Root$o, { onMouseEnter, onMouseLeave, "data-testid": t15, radius: 2, children: t24 }), $[73] = onMouseEnter, $[74] = onMouseLeave, $[75] = t15, $[76] = t24, $[77] = t25) : t25 = $[77], t25;
}
function EmailInput(props2) {
  const $ = c(3), {
    validationError,
    elementProps
  } = props2;
  let t0;
  return $[0] !== elementProps || $[1] !== validationError ? (t0 = /* @__PURE__ */ jsx(TextInput$1, { ...elementProps, type: "email", inputMode: "email", customValidity: validationError }), $[0] = elementProps, $[1] = validationError, $[2] = t0) : t0 = $[2], t0;
}
function getScrollableParent(node) {
  if (!node || !(node instanceof Element)) return null;
  let parent = node.parentElement;
  for (; parent; ) {
    const overflowY = window.getComputedStyle(parent).overflowY;
    if ((overflowY === "auto" || overflowY === "scroll") && parent.scrollHeight > parent.clientHeight)
      return parent;
    parent = parent.parentElement;
  }
  return window;
}
function preventWheel(event) {
  if (event.currentTarget && document.activeElement === event.currentTarget) {
    event.preventDefault();
    const scrollContainer = getScrollableParent(event.currentTarget);
    scrollContainer && scrollContainer.scrollBy({
      top: event.deltaY,
      left: event.deltaX,
      behavior: "instant"
    });
  }
}
function NumberInput(props2) {
  const $ = c(12), {
    schemaType,
    validationError,
    elementProps: _elementProps
  } = props2;
  let elementProps, ref;
  $[0] !== _elementProps ? ({
    ref,
    ...elementProps
  } = _elementProps, $[0] = _elementProps, $[1] = elementProps, $[2] = ref) : (elementProps = $[1], ref = $[2]);
  const minRule = getValidationRule(schemaType, "min"), integerRule = getValidationRule(schemaType, "integer"), precisionRule = getValidationRule(schemaType, "precision"), onlyPositiveNumber = typeof minRule?.constraint == "number" && minRule?.constraint >= 0, onlyIntegers = integerRule || precisionRule?.constraint === 0, inputMode = onlyPositiveNumber ? onlyIntegers ? "numeric" : "decimal" : "text", inputElementRef = useRef(null);
  let t0;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => inputElementRef.current, $[3] = t0) : t0 = $[3], useImperativeHandle(ref, t0);
  let t1, t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    const element = inputElementRef.current;
    if (element)
      return element.addEventListener("wheel", preventWheel), () => {
        element.removeEventListener("wheel", preventWheel);
      };
  }, t2 = [inputElementRef], $[4] = t1, $[5] = t2) : (t1 = $[4], t2 = $[5]), useEffect(t1, t2);
  const t3 = onlyPositiveNumber ? "[d]*" : void 0;
  let t4;
  return $[6] !== elementProps || $[7] !== inputMode || $[8] !== schemaType.placeholder || $[9] !== t3 || $[10] !== validationError ? (t4 = /* @__PURE__ */ jsx(TextInput$1, { ...elementProps, ref: inputElementRef, type: "number", step: "any", inputMode, customValidity: validationError, placeholder: schemaType.placeholder, pattern: t3, max: Number.MAX_SAFE_INTEGER, min: Number.MIN_SAFE_INTEGER, "data-testid": "number-input" }), $[6] = elementProps, $[7] = inputMode, $[8] = schemaType.placeholder, $[9] = t3, $[10] = validationError, $[11] = t4) : t4 = $[11], t4;
}
function useRenderMembers(schemaType, members) {
  const $ = c(3);
  let t0;
  bb0: {
    if (schemaType.renderMembers) {
      let newMembers;
      try {
        let t2;
        $[0] !== members || $[1] !== schemaType ? (t2 = schemaType.renderMembers(members), $[0] = members, $[1] = schemaType, $[2] = t2) : t2 = $[2], newMembers = t2;
      } catch (t1) {
        const error = t1;
        if (isDev)
          throw error;
        console.error("Error rendering members, returning original members", error), newMembers = members;
      }
      t0 = newMembers;
      break bb0;
    }
    t0 = members;
  }
  return t0;
}
function getFieldGroupValidationLevel(group2, groupPath, validation2) {
  let highestLevel;
  if (group2.name === ALL_FIELDS_GROUP_NAME) {
    for (const v of validation2) {
      if (v.level === "error")
        return "error";
      v.level === "warning" ? highestLevel = "warning" : v.level === "info" && highestLevel === void 0 && (highestLevel = "info");
    }
    return highestLevel;
  }
  for (const field of group2.fields) {
    const fieldPath = groupPath.concat(field.name);
    for (const v of validation2)
      if (PathUtils.startsWith(fieldPath, v.path)) {
        if (v.level === "error")
          return "error";
        v.level === "warning" ? highestLevel = "warning" : v.level === "info" && highestLevel === void 0 && (highestLevel = "info");
      }
  }
  return highestLevel;
}
const GroupTab = forwardRef(function(props2, ref) {
  const $ = c(9), {
    onClick: onClick2
  } = props2;
  let t0;
  $[0] !== onClick2 || $[1] !== props2.name ? (t0 = () => {
    onClick2?.(props2.name);
  }, $[0] = onClick2, $[1] = props2.name, $[2] = t0) : t0 = $[2];
  const handleClick = t0, t1 = `group-tab-${props2.name}`, t2 = `${props2.name}-tab`;
  let t3;
  return $[3] !== handleClick || $[4] !== props2 || $[5] !== ref || $[6] !== t1 || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsx(Tab, { "data-testid": t1, id: t2, label: props2.title, ref, ...props2, onClick: handleClick }), $[3] = handleClick, $[4] = props2, $[5] = ref, $[6] = t1, $[7] = t2, $[8] = t3) : t3 = $[8], t3;
}), GroupOption = (props2) => {
  const $ = c(13);
  let name, rest, title;
  $[0] !== props2 ? ({
    name,
    title,
    ...rest
  } = props2, $[0] = props2, $[1] = name, $[2] = rest, $[3] = title) : (name = $[1], rest = $[2], title = $[3]);
  const {
    selected
  } = props2, t0 = `${name}-tab`, t1 = rest["aria-controls"], t2 = `group-select-${name}`, t3 = selected ? "true" : "false", t4 = title || name;
  let t5;
  return $[4] !== name || $[5] !== props2.iconRight || $[6] !== t0 || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== title ? (t5 = /* @__PURE__ */ jsxs("option", { title, value: name, id: t0, "aria-controls": t1, "data-testid": t2, "aria-selected": t3, children: [
    t4,
    " ",
    props2.iconRight
  ] }), $[4] = name, $[5] = props2.iconRight, $[6] = t0, $[7] = t1, $[8] = t2, $[9] = t3, $[10] = t4, $[11] = title, $[12] = t5) : t5 = $[12], t5;
}, Root$n = styled(ElementQuery).withConfig({
  displayName: "Root",
  componentId: "sc-1sy91tf-0"
})`&[data-eq-max~='0'] [data-ui='TabList']{display:none;}[data-ui='Select']{display:none;}&[data-eq-max~='0'] [data-ui='Select']{display:block;}`, GroupTabs = (t0) => {
  const $ = c(19), {
    inputId,
    groups,
    onClick: onClick2,
    shouldAutoFocus: t1,
    disabled,
    path,
    validation: validation2
  } = t0, shouldAutoFocus = t1 === void 0 ? !0 : t1, {
    t
  } = useTranslation();
  let t2;
  if ($[0] !== disabled || $[1] !== groups || $[2] !== inputId || $[3] !== onClick2 || $[4] !== path || $[5] !== shouldAutoFocus || $[6] !== t || $[7] !== validation2) {
    let t32;
    $[9] !== disabled || $[10] !== inputId || $[11] !== onClick2 || $[12] !== path || $[13] !== shouldAutoFocus || $[14] !== t || $[15] !== validation2 ? (t32 = (group2) => {
      const title = group2.i18n?.title ? t(group2.i18n.title.key, {
        ns: group2.i18n.title.ns
      }) : group2.title || group2.name, validationLevel = getFieldGroupValidationLevel(group2, path, validation2);
      return /* @__PURE__ */ jsx(GroupTab, { "aria-controls": `${inputId}-field-group-fields`, autoFocus: shouldAutoFocus && group2.selected, disabled: disabled || group2.disabled, icon: group2?.icon, iconRight: validationLevel ? /* @__PURE__ */ jsx(StatusIcon, { status: validationLevel }) : void 0, name: group2.name, onClick: onClick2, selected: !!group2.selected, title }, `${inputId}-${group2.name}-tab`);
    }, $[9] = disabled, $[10] = inputId, $[11] = onClick2, $[12] = path, $[13] = shouldAutoFocus, $[14] = t, $[15] = validation2, $[16] = t32) : t32 = $[16], t2 = groups.map(t32), $[0] = disabled, $[1] = groups, $[2] = inputId, $[3] = onClick2, $[4] = path, $[5] = shouldAutoFocus, $[6] = t, $[7] = validation2, $[8] = t2;
  } else
    t2 = $[8];
  let t3;
  return $[17] !== t2 ? (t3 = /* @__PURE__ */ jsx(TabList, { space: 2, "data-testid": "field-group-tabs", children: t2 }), $[17] = t2, $[18] = t3) : t3 = $[18], t3;
}, GroupSelect = (t0) => {
  const $ = c(22), {
    disabled,
    groups,
    inputId,
    onSelect,
    shouldAutoFocus: t1,
    path,
    validation: validation2
  } = t0, shouldAutoFocus = t1 === void 0 ? !0 : t1;
  let t2;
  $[0] !== onSelect ? (t2 = (event) => {
    onSelect(event.currentTarget.value);
  }, $[0] = onSelect, $[1] = t2) : t2 = $[1];
  const handleSelect = t2, {
    t
  } = useTranslation();
  let t3;
  $[2] !== t ? (t3 = t("inputs.object.field-group-tabs.aria-label"), $[2] = t, $[3] = t3) : t3 = $[3];
  const t4 = groups.find(_temp$2W)?.name;
  let t5;
  if ($[4] !== groups || $[5] !== inputId || $[6] !== path || $[7] !== t || $[8] !== validation2) {
    let t62;
    $[10] !== inputId || $[11] !== path || $[12] !== t || $[13] !== validation2 ? (t62 = (group2) => {
      const title = group2.i18n?.title ? t(group2.i18n.title.key, {
        ns: group2.i18n.title.ns
      }) : group2.title || group2.name, validationLevel = getFieldGroupValidationLevel(group2, path, validation2), validationText = validationLevel ? ` (${t(`inputs.object.field-group-tabs.validation-${validationLevel}`)})` : void 0;
      return /* @__PURE__ */ jsx(GroupOption, { "aria-controls": `${inputId}-field-group-fields`, disabled: group2.disabled, name: group2.name, iconRight: validationText, selected: !!group2.selected, title }, `${inputId}-${group2.name}-tab`);
    }, $[10] = inputId, $[11] = path, $[12] = t, $[13] = validation2, $[14] = t62) : t62 = $[14], t5 = groups.map(t62), $[4] = groups, $[5] = inputId, $[6] = path, $[7] = t, $[8] = validation2, $[9] = t5;
  } else
    t5 = $[9];
  let t6;
  return $[15] !== disabled || $[16] !== handleSelect || $[17] !== shouldAutoFocus || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 ? (t6 = /* @__PURE__ */ jsx(Select, { "aria-label": t3, autoFocus: shouldAutoFocus, "data-testid": "field-group-select", disabled, fontSize: 2, muted: !0, onChange: handleSelect, value: t4, children: t5 }), $[15] = disabled, $[16] = handleSelect, $[17] = shouldAutoFocus, $[18] = t3, $[19] = t4, $[20] = t5, $[21] = t6) : t6 = $[21], t6;
}, FieldGroupTabs = memo(function(t0) {
  const $ = c(11);
  let onClick2, props2, t1;
  $[0] !== t0 ? ({
    disabled: t1,
    onClick: onClick2,
    ...props2
  } = t0, $[0] = t0, $[1] = onClick2, $[2] = props2, $[3] = t1) : (onClick2 = $[1], props2 = $[2], t1 = $[3]);
  const disabled = t1 === void 0 ? !1 : t1;
  let t2;
  $[4] !== onClick2 ? (t2 = (groupName) => {
    onClick2?.(groupName);
  }, $[4] = onClick2, $[5] = t2) : t2 = $[5];
  const handleClick = t2, validation2 = useChildValidation(props2.path, !0);
  let t3;
  return $[6] !== disabled || $[7] !== handleClick || $[8] !== props2 || $[9] !== validation2 ? (t3 = /* @__PURE__ */ jsxs(Root$n, { "data-testid": "field-group-root", children: [
    /* @__PURE__ */ jsx(GroupTabs, { ...props2, disabled, onClick: handleClick, validation: validation2 }),
    /* @__PURE__ */ jsx(GroupSelect, { ...props2, disabled, onSelect: handleClick, validation: validation2 })
  ] }), $[6] = disabled, $[7] = handleClick, $[8] = props2, $[9] = validation2, $[10] = t3) : t3 = $[10], t3;
});
function _temp$2W(g) {
  return g.selected;
}
const FieldGroupTabsWrapper = styled(Card).withConfig({
  displayName: "FieldGroupTabsWrapper",
  componentId: "sc-1m48g6t-0"
})`margin-bottom:${({
  $level,
  theme
}) => $level === 0 ? 0 : theme.sanity.space[5] * -1}px;padding-bottom:${({
  $level,
  theme
}) => theme.sanity.space[4]}px;`, AlignedBottomGrid = styled(Grid).withConfig({
  displayName: "AlignedBottomGrid",
  componentId: "sc-1m48g6t-1"
})`align-items:flex-end;`;
function UnknownFields(props2) {
  const $ = c(50), {
    fieldNames,
    onChange,
    readOnly,
    renderPreview,
    value
  } = props2, fieldsLen = fieldNames.length, schema2 = useSchema();
  let t0;
  bb0: {
    let schemaReferenceType, t13;
    if ($[0] !== schema2 ? (schemaReferenceType = schema2.get("reference"), t13 = !schemaReferenceType || !isReferenceSchemaType(schemaReferenceType), $[0] = schema2, $[1] = schemaReferenceType, $[2] = t13) : (schemaReferenceType = $[1], t13 = $[2]), t13) {
      t0 = null;
      break bb0;
    }
    let t22;
    $[3] !== schema2 ? (t22 = schema2.getTypeNames().map((typeName) => schema2.get(typeName)).filter(isDocumentSchemaType), $[3] = schema2, $[4] = t22) : t22 = $[4];
    const documentTypes = t22;
    if (documentTypes.length === 0) {
      t0 = null;
      break bb0;
    }
    let t32;
    $[5] !== documentTypes || $[6] !== schemaReferenceType ? (t32 = {
      ...schemaReferenceType,
      to: documentTypes
    }, $[5] = documentTypes, $[6] = schemaReferenceType, $[7] = t32) : t32 = $[7], t0 = t32;
  }
  const referenceSchemaType = t0;
  let t1;
  $[8] !== onChange ? (t1 = (fieldName) => {
    onChange(unset([fieldName]));
  }, $[8] = onChange, $[9] = t1) : t1 = $[9];
  const handleUnsetClick = t1, {
    t
  } = useTranslation();
  let t2;
  $[10] !== fieldsLen || $[11] !== t ? (t2 = t("inputs.object.unknown-fields.warning.title", {
    count: fieldsLen
  }), $[10] = fieldsLen, $[11] = t, $[12] = t2) : t2 = $[12];
  let t3;
  $[13] !== t2 ? (t3 = /* @__PURE__ */ jsx(Fragment$1, { children: t2 }), $[13] = t2, $[14] = t3) : t3 = $[14];
  let t4;
  $[15] !== fieldsLen || $[16] !== t ? (t4 = t("inputs.object.unknown-fields.warning.description", {
    count: fieldsLen
  }), $[15] = fieldsLen, $[16] = t, $[17] = t4) : t4 = $[17];
  let t5;
  $[18] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Fragment$1, { children: t4 }) }), $[18] = t4, $[19] = t5) : t5 = $[19];
  let t6;
  $[20] !== t ? (t6 = t("inputs.object.unknown-fields.warning.details.title"), $[20] = t, $[21] = t6) : t6 = $[21];
  let t7;
  $[22] !== fieldsLen || $[23] !== t ? (t7 = t("inputs.object.unknown-fields.warning.details.description", {
    count: fieldsLen
  }), $[22] = fieldsLen, $[23] = t, $[24] = t7) : t7 = $[24];
  let t8;
  $[25] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { marginBottom: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Fragment$1, { children: t7 }) }) }), $[25] = t7, $[26] = t8) : t8 = $[26];
  let t9;
  if ($[27] !== fieldNames || $[28] !== handleUnsetClick || $[29] !== readOnly || $[30] !== referenceSchemaType || $[31] !== renderPreview || $[32] !== value) {
    let t102;
    $[34] !== handleUnsetClick || $[35] !== readOnly || $[36] !== referenceSchemaType || $[37] !== renderPreview || $[38] !== value ? (t102 = (fieldName_0) => /* @__PURE__ */ jsx(UnknownField, { fieldName: fieldName_0, onUnsetClick: handleUnsetClick, readOnly, referenceSchemaType, renderPreview, value: value?.[fieldName_0] }, fieldName_0), $[34] = handleUnsetClick, $[35] = readOnly, $[36] = referenceSchemaType, $[37] = renderPreview, $[38] = value, $[39] = t102) : t102 = $[39], t9 = fieldNames.map(t102), $[27] = fieldNames, $[28] = handleUnsetClick, $[29] = readOnly, $[30] = referenceSchemaType, $[31] = renderPreview, $[32] = value, $[33] = t9;
  } else
    t9 = $[33];
  let t10;
  $[40] !== t9 ? (t10 = /* @__PURE__ */ jsx(Stack, { as: "ul", space: 3, children: t9 }), $[40] = t9, $[41] = t10) : t10 = $[41];
  let t11;
  $[42] !== t10 || $[43] !== t6 || $[44] !== t8 ? (t11 = /* @__PURE__ */ jsxs(Details, { marginTop: 4, open: isDev, title: t6, children: [
    t8,
    t10
  ] }), $[42] = t10, $[43] = t6, $[44] = t8, $[45] = t11) : t11 = $[45];
  let t12;
  return $[46] !== t11 || $[47] !== t3 || $[48] !== t5 ? (t12 = /* @__PURE__ */ jsxs(Alert, { status: "warning", title: t3, children: [
    t5,
    t11
  ] }), $[46] = t11, $[47] = t3, $[48] = t5, $[49] = t12) : t12 = $[49], t12;
}
function UnknownField(t0) {
  const $ = c(31), {
    fieldName,
    onUnsetClick,
    readOnly,
    referenceSchemaType,
    renderPreview,
    value
  } = t0;
  let t1;
  $[0] !== fieldName || $[1] !== onUnsetClick ? (t1 = () => {
    onUnsetClick(fieldName);
  }, $[0] = fieldName, $[1] = onUnsetClick, $[2] = t1) : t1 = $[2];
  const handleUnsetClick = t1, {
    t
  } = useTranslation();
  let t2;
  $[3] !== value ? (t2 = isReference$1(value), $[3] = value, $[4] = t2) : t2 = $[4];
  const isReferenceValue = t2, referenceId = isReferenceValue ? value._ref : null;
  let t3;
  $[5] !== fieldName ? (t3 = /* @__PURE__ */ jsx(Card, { padding: 3, shadow: 1, tone: "inherit", children: /* @__PURE__ */ jsx(Code, { size: 1, children: fieldName }) }), $[5] = fieldName, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== isReferenceValue || $[8] !== referenceId || $[9] !== referenceSchemaType || $[10] !== renderPreview || $[11] !== t || $[12] !== value ? (t4 = isReferenceValue && /* @__PURE__ */ jsx(Card, { border: !0, padding: 1, radius: 2, tone: "default", margin: 2, children: referenceSchemaType ? renderPreview({
    layout: "default",
    schemaType: referenceSchemaType,
    value
  }) : t("inputs.object.unknown-fields.reference.preview.unavailable", {
    documentId: referenceId
  }) }), $[7] = isReferenceValue, $[8] = referenceId, $[9] = referenceSchemaType, $[10] = renderPreview, $[11] = t, $[12] = value, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== value ? (t5 = JSON.stringify(value, null, 2), $[14] = value, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { overflow: "auto", padding: 3, children: /* @__PURE__ */ jsx(Code, { language: "json", size: 1, children: t5 }) }), $[16] = t5, $[17] = t6) : t6 = $[17];
  let t7;
  $[18] !== readOnly || $[19] !== t ? (t7 = readOnly && /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.object.unknown-fields.read-only.description" }) }) }), $[18] = readOnly, $[19] = t, $[20] = t7) : t7 = $[20];
  let t8;
  $[21] !== handleUnsetClick || $[22] !== readOnly || $[23] !== t ? (t8 = !readOnly && /* @__PURE__ */ jsx(Card, { padding: 3, shadow: 1, tone: "inherit", children: /* @__PURE__ */ jsx(Button, { icon: TrashIcon, mode: "ghost", onClick: handleUnsetClick, size: "large", tone: "critical", text: t("inputs.object.unknown-fields.remove-field-button.text") }) }), $[21] = handleUnsetClick, $[22] = readOnly, $[23] = t, $[24] = t8) : t8 = $[24];
  let t9;
  return $[25] !== t3 || $[26] !== t4 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Card, { as: "li", overflow: "hidden", radius: 2, shadow: 1, tone: "caution", children: [
    t3,
    t4,
    t6,
    t7,
    t8
  ] }), $[25] = t3, $[26] = t4, $[27] = t6, $[28] = t7, $[29] = t8, $[30] = t9) : t9 = $[30], t9;
}
const RootStack$2 = styled(Stack).withConfig({
  displayName: "RootStack",
  componentId: "sc-1iaocof-0"
})`&:focus{outline:none;}`, ObjectInput = memo(function(props2) {
  const $ = c(45), {
    groups,
    id: id2,
    members,
    onChange,
    onFieldGroupSelect,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    path,
    level,
    value,
    onPathFocus
  } = props2, renderedMembers = useRenderMembers(schemaType, members), wrapperRef = useRef(null);
  let t0;
  $[0] !== schemaType.options ? (t0 = schemaType.options || {}, $[0] = schemaType.options, $[1] = t0) : t0 = $[1];
  const {
    columns
  } = t0;
  let t1;
  $[2] !== id2 || $[3] !== path ? (t1 = id2 !== "root" && !(path.length > 0 && isKeySegment(last$1(path))), $[2] = id2, $[3] = path, $[4] = t1) : t1 = $[4];
  const isFocusable = t1;
  let t2;
  bb0: {
    if (!schemaType.fields) {
      t2 = null;
      break bb0;
    }
    let t32;
    if ($[5] !== schemaType.fields || $[6] !== value) {
      const knownFieldNames = schemaType.fields.map(_temp$2V);
      t32 = Object.keys(value || {}).filter((key) => !key.startsWith("_") && !knownFieldNames.includes(key)), $[5] = schemaType.fields, $[6] = value, $[7] = t32;
    } else
      t32 = $[7];
    const unknownFields = t32;
    if (unknownFields.length === 0) {
      t2 = null;
      break bb0;
    }
    let t42;
    $[8] !== onChange || $[9] !== renderPreview || $[10] !== unknownFields || $[11] !== value ? (t42 = /* @__PURE__ */ jsx(FormRow, { children: /* @__PURE__ */ jsx(UnknownFields, { fieldNames: unknownFields, value, onChange, renderPreview }) }), $[8] = onChange, $[9] = renderPreview, $[10] = unknownFields, $[11] = value, $[12] = t42) : t42 = $[12], t2 = t42;
  }
  const renderedUnknownFields = t2;
  let t3;
  $[13] !== groups ? (t3 = groups.find(_temp2$1f), $[13] = groups, $[14] = t3) : t3 = $[14];
  const selectedGroup = t3;
  let t4;
  $[15] !== isFocusable || $[16] !== onPathFocus ? (t4 = (event) => {
    isFocusable && event.target === wrapperRef.current && onPathFocus(EMPTY_ARRAY$y);
  }, $[15] = isFocusable, $[16] = onPathFocus, $[17] = t4) : t4 = $[17];
  const handleFocus = t4;
  let t5;
  $[18] !== renderAnnotation || $[19] !== renderBlock2 || $[20] !== renderField || $[21] !== renderInlineBlock || $[22] !== renderInput || $[23] !== renderItem2 || $[24] !== renderPreview || $[25] !== renderedMembers ? (t5 = () => /* @__PURE__ */ jsx(ObjectInputMembers, { members: renderedMembers, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }), $[18] = renderAnnotation, $[19] = renderBlock2, $[20] = renderField, $[21] = renderInlineBlock, $[22] = renderInput, $[23] = renderItem2, $[24] = renderPreview, $[25] = renderedMembers, $[26] = t5) : t5 = $[26];
  const renderObjectMembers = t5;
  if (members.length === 0)
    return null;
  const t6 = isFocusable ? 0 : void 0;
  let t7;
  $[27] !== groups || $[28] !== id2 || $[29] !== level || $[30] !== onFieldGroupSelect || $[31] !== path ? (t7 = groups.length > 0 ? /* @__PURE__ */ jsx(FieldGroupTabsWrapper, { $level: level, "data-testid": "field-groups", children: /* @__PURE__ */ jsx(FieldGroupTabs, { path, groups, inputId: id2, onClick: onFieldGroupSelect, shouldAutoFocus: !1 }) }) : null, $[27] = groups, $[28] = id2, $[29] = level, $[30] = onFieldGroupSelect, $[31] = path, $[32] = t7) : t7 = $[32];
  const t8 = selectedGroup?.name;
  let t9;
  $[33] !== columns || $[34] !== renderObjectMembers ? (t9 = columns ? /* @__PURE__ */ jsx(AlignedBottomGrid, { columns, gap: 4, marginTop: 1, children: renderObjectMembers() }) : renderObjectMembers(), $[33] = columns, $[34] = renderObjectMembers, $[35] = t9) : t9 = $[35];
  let t10;
  $[36] !== t8 || $[37] !== t9 ? (t10 = /* @__PURE__ */ jsx(Fragment, { children: t9 }, t8), $[36] = t8, $[37] = t9, $[38] = t10) : t10 = $[38];
  let t11;
  return $[39] !== handleFocus || $[40] !== renderedUnknownFields || $[41] !== t10 || $[42] !== t6 || $[43] !== t7 ? (t11 = /* @__PURE__ */ jsxs(RootStack$2, { space: 6, tabIndex: t6, onFocus: handleFocus, ref: wrapperRef, children: [
    t7,
    t10,
    renderedUnknownFields
  ] }), $[39] = handleFocus, $[40] = renderedUnknownFields, $[41] = t10, $[42] = t6, $[43] = t7, $[44] = t11) : t11 = $[44], t11;
});
function _temp$2V(field) {
  return field.name;
}
function _temp2$1f(t0) {
  const {
    selected
  } = t0;
  return selected;
}
const defaultSlugify = (value, type) => {
  const maxLength = type.options?.maxLength;
  return value ? speakingurl(value, {
    truncate: typeof maxLength == "number" ? maxLength : 200,
    symbols: !0
  }) : "";
};
async function slugify(sourceValue, type, context) {
  return sourceValue && (type.options?.slugify || defaultSlugify)(sourceValue, type, context);
}
function useAsync(fn) {
  const $ = c(5), [state, setState] = useState(null), lastId = useRef(0);
  let t0;
  $[0] !== fn ? (t0 = (arg) => {
    const asyncId = lastId.current = lastId.current + 1;
    setState({
      status: "pending"
    }), Promise.resolve().then(() => fn(arg)).then((res) => {
      asyncId === lastId.current && setState({
        status: "complete",
        result: res
      });
    }, (err) => {
      asyncId === lastId.current && setState({
        status: "error",
        error: err
      });
    });
  }, $[0] = fn, $[1] = t0) : t0 = $[1];
  const wrappedCallback = t0;
  let t1;
  return $[2] !== state || $[3] !== wrappedCallback ? (t1 = [state, wrappedCallback], $[2] = state, $[3] = wrappedCallback, $[4] = t1) : t1 = $[4], t1;
}
function useSlugContext() {
  const $ = c(6), {
    getClient: getClient2
  } = useSource(), schema2 = useSchema(), currentUser = useCurrentUser(), projectId = useProjectId(), dataset = useDataset();
  let t0;
  return $[0] !== currentUser || $[1] !== dataset || $[2] !== getClient2 || $[3] !== projectId || $[4] !== schema2 ? (t0 = {
    projectId,
    dataset,
    getClient: getClient2,
    schema: schema2,
    currentUser
  }, $[0] = currentUser, $[1] = dataset, $[2] = getClient2, $[3] = projectId, $[4] = schema2, $[5] = t0) : t0 = $[5], t0;
}
function getSlugSourceContext(valuePath, document2, context) {
  const parentPath = valuePath.slice(0, -1), parent = PathUtils.get(document2, parentPath);
  return {
    parentPath,
    parent,
    ...context
  };
}
async function getNewFromSource(source, document2, context) {
  return typeof source == "function" ? source(document2, context) : PathUtils.get(document2, source);
}
function SlugInput(props2) {
  const $ = c(41), getFormValue = useGetFormValue(), {
    path,
    value,
    schemaType,
    validation: validation2,
    onChange,
    readOnly,
    elementProps,
    focused,
    focusPath
  } = props2, sourceField = schemaType.options?.source;
  let t0;
  $[0] !== validation2 ? (t0 = validation2.filter(_temp$2U), $[0] = validation2, $[1] = t0) : t0 = $[1];
  const errors = t0, inputRef = useRef(null), slugContext = useSlugContext(), {
    t
  } = useTranslation();
  let t1;
  $[2] !== onChange || $[3] !== schemaType.name ? (t1 = (nextSlug) => {
    if (!nextSlug) {
      onChange(PatchEvent.from(unset([])));
      return;
    }
    onChange(PatchEvent.from([setIfMissing({
      _type: schemaType.name
    }), set(nextSlug, ["current"])]));
  }, $[2] = onChange, $[3] = schemaType.name, $[4] = t1) : t1 = $[4];
  const updateSlug = t1;
  let t2;
  $[5] !== getFormValue || $[6] !== path || $[7] !== schemaType || $[8] !== slugContext || $[9] !== sourceField || $[10] !== t || $[11] !== updateSlug ? (t2 = () => {
    if (!sourceField)
      return Promise.reject(new Error(t("inputs.slug.error.missing-source", {
        schemaType: schemaType.name
      })));
    const doc = getFormValue([]) || {
      _type: schemaType.name
    }, sourceContext = getSlugSourceContext(path, doc, slugContext);
    return getNewFromSource(sourceField, doc, sourceContext).then((newFromSource) => slugify(newFromSource || "", schemaType, sourceContext)).then((newSlug) => updateSlug(newSlug));
  }, $[5] = getFormValue, $[6] = path, $[7] = schemaType, $[8] = slugContext, $[9] = sourceField, $[10] = t, $[11] = updateSlug, $[12] = t2) : t2 = $[12];
  const handleAsyncGenerateSlug = t2, [generateState, handleGenerateSlug] = useAsync(handleAsyncGenerateSlug), isUpdating = generateState?.status === "pending";
  let t3;
  $[13] !== updateSlug ? (t3 = (event) => updateSlug(event.currentTarget.value), $[13] = updateSlug, $[14] = t3) : t3 = $[14];
  const handleChange = t3;
  let t4;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    requestAnimationFrame(() => {
      inputRef.current?.focus();
    });
  }, $[15] = t4) : t4 = $[15];
  const handleFocus = t4;
  let t5;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && handleFocus();
  }, $[16] = t5) : t5 = $[16], useDidUpdate(focused, t5);
  let t6;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = (t72, currentFocusPath) => {
    const prevFocusPath = t72 === void 0 ? [] : t72;
    prevFocusPath !== currentFocusPath && Array.isArray(prevFocusPath) && Array.isArray(currentFocusPath) && prevFocusPath.length === 0 && currentFocusPath.length === 1 && currentFocusPath[0] === "current" && handleFocus();
  }, $[17] = t6) : t6 = $[17], useDidUpdate(focusPath, t6);
  let t7;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = () => inputRef.current, $[18] = t7) : t7 = $[18], useImperativeHandle(elementProps.ref, t7);
  const t8 = errors.length > 0 ? errors[0].message : "", t9 = value?.current || "";
  let t10;
  $[19] !== elementProps || $[20] !== handleChange || $[21] !== isUpdating || $[22] !== readOnly || $[23] !== t8 || $[24] !== t9 ? (t10 = /* @__PURE__ */ jsx(TextInput$1, { customValidity: t8, disabled: isUpdating, onChange: handleChange, value: t9, readOnly, ...elementProps, ref: inputRef }), $[19] = elementProps, $[20] = handleChange, $[21] = isUpdating, $[22] = readOnly, $[23] = t8, $[24] = t9, $[25] = t10) : t10 = $[25];
  let t11;
  $[26] !== generateState ? (t11 = generateState?.status === "error" && /* @__PURE__ */ jsx(Card, { padding: 2, tone: "critical", children: generateState.error.message }), $[26] = generateState, $[27] = t11) : t11 = $[27];
  let t12;
  $[28] !== t10 || $[29] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Box, { flex: 1, children: [
    t10,
    t11
  ] }), $[28] = t10, $[29] = t11, $[30] = t12) : t12 = $[30];
  let t13;
  $[31] !== generateState?.status || $[32] !== handleGenerateSlug || $[33] !== isUpdating || $[34] !== readOnly || $[35] !== sourceField || $[36] !== t ? (t13 = sourceField && /* @__PURE__ */ jsx(Button, { mode: "ghost", type: "button", disabled: readOnly || isUpdating, onClick: handleGenerateSlug, size: "large", text: generateState?.status === "pending" ? t("inputs.slug.action.generating") : t("inputs.slug.action.generate") }), $[31] = generateState?.status, $[32] = handleGenerateSlug, $[33] = isUpdating, $[34] = readOnly, $[35] = sourceField, $[36] = t, $[37] = t13) : t13 = $[37];
  let t14;
  return $[38] !== t12 || $[39] !== t13 ? (t14 = /* @__PURE__ */ jsx(Stack, { space: 3, children: /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t12,
    t13
  ] }) }), $[38] = t12, $[39] = t13, $[40] = t14) : t14 = $[40], t14;
}
function _temp$2U(item) {
  return item.level === "error";
}
function StringInputBasic(props2) {
  const $ = c(3), {
    validationError,
    elementProps
  } = props2;
  let t0;
  return $[0] !== elementProps || $[1] !== validationError ? (t0 = /* @__PURE__ */ jsx(TextInput$1, { ...elementProps, customValidity: validationError, "data-testid": "string-input" }), $[0] = elementProps, $[1] = validationError, $[2] = t0) : t0 = $[2], t0;
}
const Segment = styled.span.withConfig({
  displayName: "Segment",
  componentId: "sc-d0cjq3-0"
})`${({
  theme,
  $tone
}) => {
  if (typeof $tone > "u")
    return;
  const {
    color
  } = getTheme_v2(theme);
  return {
    backgroundColor: color.button.bleed[$tone]?.pressed?.bg,
    color: color.button.bleed[$tone]?.pressed?.fg,
    textDecoration: "none"
  };
}}`, DeletedSegment = (t0) => {
  const $ = c(2), {
    segment
  } = t0;
  let t1;
  return $[0] !== segment.text ? (t1 = /* @__PURE__ */ jsx(Segment, { as: "del", "data-text": segment.text, contentEditable: !1, "aria-hidden": !0, inert: !0, $tone: "critical" }), $[0] = segment.text, $[1] = t1) : t1 = $[1], t1;
}, InsertedSegment = (t0) => {
  const $ = c(5), {
    children,
    segment
  } = t0;
  let t1;
  $[0] !== segment ? (t1 = segmentTone(segment), $[0] = segment, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== children || $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Segment, { as: "ins", $tone: t1, children }), $[2] = children, $[3] = t1, $[4] = t2) : t2 = $[4], t2;
};
function segmentTone(segment) {
  if (segment.action !== "unchanged" && typeof segment.annotation.provenance.bundle < "u")
    return segment.annotation.provenance.bundle === "drafts" ? RELEASE_TYPES_TONES.asap.tone : getReleaseTone(segment.annotation.provenance.bundle);
}
function stringDiffContainerStyles() {
  return css`
    del${Segment} {
      opacity: 0.5;
      text-decoration: line-through;

      &::before {
        text-decoration: line-through;
        content: attr(data-text);
      }
    }

    ins${Segment} {
      text-decoration: none;
    }
  `;
}
const PortableTextInputExpanded = defineEvent({
  version: 1,
  name: "Portable Text Editor Expanded",
  description: "The portable text editor was expanded"
}), PortableTextInputCollapsed = defineEvent({
  version: 1,
  name: "Portable Text Editor Collapsed",
  description: "The portable text editor was collapsed"
}), PortableTextInvalidValueIgnore = defineEvent({
  version: 1,
  name: "Portable Text Editor Invalid Value Ignored",
  description: "The portable text got an invalid value from the form and pressed button to ignore it"
}), PortableTextInvalidValueResolve = defineEvent({
  version: 1,
  name: "Portable Text Editor Invalid Value Resolved",
  description: "The portable text got an invalid value from the form and pressed button to resolve it."
}), CreatedDraft = defineEvent({
  name: "New Draft Created",
  version: 1,
  description: "User created a new draft"
}), OverlayContainer = styled.div.withConfig({
  displayName: "OverlayContainer",
  componentId: "sc-qb8e3h-0"
})`position:relative;`, ContentContainer = styled.div.withConfig({
  displayName: "ContentContainer",
  componentId: "sc-qb8e3h-1"
})`z-index:13;opacity:0;transition:opacity 300ms linear;`, CardContainer = styled(Card).withConfig({
  displayName: "CardContainer",
  componentId: "sc-qb8e3h-2"
})`border:1px solid var(--card-border-color);position:absolute;top:0;left:0;width:100%;height:100%;z-index:12;transition:opacity 150ms ease-in-out;opacity:0;box-sizing:border-box;`, FlexContainer = styled(Flex).withConfig({
  displayName: "FlexContainer",
  componentId: "sc-qb8e3h-3"
})`position:absolute;top:0;left:0;width:100%;height:100%;&:hover,&:focus{& ${CardContainer}{opacity:0.9;}& ${ContentContainer}{opacity:1;}}`, isTouchDevice = () => typeof window < "u" && "ontouchstart" in window || typeof navigator < "u" && navigator.maxTouchPoints > 0;
function ActivateOnFocus(props2) {
  const $ = c(25), {
    children,
    message,
    onActivate,
    isOverlayActive
  } = props2, [focused, setFocused] = useState(!1), {
    t
  } = useTranslation();
  let t0;
  $[0] !== onActivate ? (t0 = () => {
    onActivate && onActivate();
  }, $[0] = onActivate, $[1] = t0) : t0 = $[1];
  const handleClick = t0;
  let t1;
  $[2] !== isOverlayActive || $[3] !== onActivate ? (t1 = (event) => {
    isOverlayActive && event.code === "Space" && onActivate && (event.preventDefault(), onActivate());
  }, $[2] = isOverlayActive, $[3] = onActivate, $[4] = t1) : t1 = $[4];
  const handleKeyDown = t1;
  let t2;
  $[5] !== isOverlayActive || $[6] !== onActivate ? (t2 = () => {
    isOverlayActive && onActivate && onActivate();
  }, $[5] = isOverlayActive, $[6] = onActivate, $[7] = t2) : t2 = $[7];
  const handleDragEnter = t2;
  let t3;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setFocused(!0);
  }, $[8] = t3) : t3 = $[8];
  const handleOnFocus = t3;
  let t4;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setFocused(!1);
  }, $[9] = t4) : t4 = $[9];
  const handleBlur = t4, isTouch = isTouchDevice();
  let messageContext;
  isTouch ? messageContext = "tap" : focused ? messageContext = "click-focused" : messageContext = "click";
  let t5;
  $[10] !== message || $[11] !== messageContext || $[12] !== t ? (t5 = message || t("inputs.portable-text.activate-on-focus-message", {
    context: messageContext
  }), $[10] = message, $[11] = messageContext, $[12] = t, $[13] = t5) : t5 = $[13];
  const text = t5;
  let t6;
  $[14] !== text ? (t6 = /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: text }), $[14] = text, $[15] = t6) : t6 = $[15];
  const msg = t6;
  let t7;
  $[16] !== isOverlayActive || $[17] !== msg ? (t7 = isOverlayActive && /* @__PURE__ */ jsxs(FlexContainer, { "data-testid": "activate-overlay", tabIndex: 0, align: "center", justify: "center", children: [
    /* @__PURE__ */ jsx(CardContainer, { radius: 2 }),
    /* @__PURE__ */ jsx(ContentContainer, { children: msg })
  ] }), $[16] = isOverlayActive, $[17] = msg, $[18] = t7) : t7 = $[18];
  let t8;
  return $[19] !== children || $[20] !== handleClick || $[21] !== handleDragEnter || $[22] !== handleKeyDown || $[23] !== t7 ? (t8 = /* @__PURE__ */ jsxs(OverlayContainer, { onBlur: handleBlur, onClick: handleClick, onFocus: handleOnFocus, onKeyDown: handleKeyDown, onDragEnter: handleDragEnter, children: [
    t7,
    children
  ] }), $[19] = children, $[20] = handleClick, $[21] = handleDragEnter, $[22] = handleKeyDown, $[23] = t7, $[24] = t8) : t8 = $[24], t8;
}
const Root$m = /* @__PURE__ */ styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1bnjn7g-0"
})((props2) => {
  const {
    color,
    input,
    radius
  } = getTheme_v2(props2.theme), border = {
    color: color.input.default.enabled.border,
    width: input.border.width
  };
  return css`
    --input-box-shadow: ${focusRingBorderStyle$2(border)};

    position: relative;

    & [data-wrapper] {
      overflow: hidden;
      overflow: clip;
      position: relative;
      z-index: 1;
      padding: ${input.border.width}px;
    }

    & [data-border] {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      box-shadow: var(--input-box-shadow);
      z-index: 2;
      border-radius: ${radius[2]}px;
      pointer-events: none;
    }

    &:not([data-read-only])[data-focused] [data-border] {
      --input-box-shadow: ${focusRingStyle$1({
    base: color,
    border,
    focusRing: input.text.focusRing
  })};
    }
  `;
}), ExpandedLayer = styled(Layer).withConfig({
  displayName: "ExpandedLayer",
  componentId: "sc-1bnjn7g-1"
})`position:absolute;top:0;left:0;right:0;bottom:0;& > div{height:100%;}`, StringDiffContainer = styled.div.withConfig({
  displayName: "StringDiffContainer",
  componentId: "sc-1bnjn7g-2"
})`height:100%;${stringDiffContainerStyles}`;
function usePortableTextMemberItemElementRefs() {
  const $ = c(1), behaviorSubject = useContext(PortableTextMemberItemElementRefsContext);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {}, $[0] = t0) : t0 = $[0], useObservable(behaviorSubject, t0);
}
function useSetPortableTextMemberItemElementRef() {
  const $ = c(2), behaviorSubject = useContext(PortableTextMemberItemElementRefsContext);
  let t0;
  return $[0] !== behaviorSubject ? (t0 = (t1) => {
    const {
      key,
      elementRef
    } = t1;
    behaviorSubject.next({
      ...behaviorSubject.value,
      [key]: elementRef
    });
  }, $[0] = behaviorSubject, $[1] = t0) : t0 = $[1], t0;
}
function useOnScroll(callback) {
  const $ = c(4), parentContext = useContext(ScrollContext);
  let t0, t1;
  $[0] !== callback || $[1] !== parentContext ? (t0 = () => parentContext?.subscribe(callback), t1 = [callback, parentContext], $[0] = callback, $[1] = parentContext, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1);
}
const ScrollContainerComponent = forwardRef(function(props2, forwardedRef) {
  const $ = c(22);
  let onScroll, rest, t0;
  $[0] !== props2 ? ({
    as: t0,
    onScroll,
    ...rest
  } = props2, $[0] = props2, $[1] = onScroll, $[2] = rest, $[3] = t0) : (onScroll = $[1], rest = $[2], t0 = $[3]);
  const As = t0 === void 0 ? "div" : t0, ref = useRef(null);
  let t1;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => ref.current, $[4] = t1) : t1 = $[4], useImperativeHandle(forwardedRef, t1);
  const parentContext = useContext(ScrollContext), [childContext] = useState(_temp$2T);
  let t2, t3;
  $[5] !== childContext || $[6] !== onScroll ? (t2 = () => {
    if (onScroll)
      return childContext.subscribe(onScroll);
  }, t3 = [childContext, onScroll], $[5] = childContext, $[6] = onScroll, $[7] = t2, $[8] = t3) : (t2 = $[7], t3 = $[8]), useEffect(t2, t3);
  let t4, t5;
  $[9] !== childContext || $[10] !== parentContext ? (t4 = () => {
    if (parentContext)
      return childContext.subscribe(parentContext.publish);
  }, t5 = [parentContext, childContext], $[9] = childContext, $[10] = parentContext, $[11] = t4, $[12] = t5) : (t4 = $[11], t5 = $[12]), useEffect(t4, t5);
  let t6, t7;
  $[13] !== childContext ? (t6 = () => {
    const handleScroll = (event) => {
      childContext.publish(event);
    }, el = ref.current;
    if (el)
      return el.addEventListener("scroll", handleScroll, {
        passive: !0,
        capture: !0
      }), () => {
        el.removeEventListener("scroll", handleScroll);
      };
  }, t7 = [childContext, ref], $[13] = childContext, $[14] = t6, $[15] = t7) : (t6 = $[14], t7 = $[15]), useEffect(t6, t7);
  let t8;
  $[16] !== As || $[17] !== rest ? (t8 = /* @__PURE__ */ jsx(As, { "data-testid": "scroll-container", ...rest, ref }), $[16] = As, $[17] = rest, $[18] = t8) : t8 = $[18];
  let t9;
  return $[19] !== childContext || $[20] !== t8 ? (t9 = /* @__PURE__ */ jsx(ScrollContext.Provider, { value: childContext, children: t8 }), $[19] = childContext, $[20] = t8, $[21] = t9) : t9 = $[21], t9;
}), ScrollContainer = memo(ScrollContainerComponent);
ScrollContainer.displayName = "Memo(Forwardref(ScrollContainer))";
function _temp$2T() {
  return createPubSub();
}
const TEXT_LEVELS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], TEXT_BULLET_MARKERS = ["\u25CF", "\u25CB", "\u25A0"], TEXT_NUMBER_FORMATS = ["number", "lower-alpha", "lower-roman"], TEXT_DECORATOR_TAGS = {
  em: "em",
  "strike-through": "s",
  underline: "u",
  strong: "strong",
  code: "code"
}, TEXT_STYLE_PADDING = {
  h1: {
    paddingTop: 5,
    paddingBottom: 4
  },
  h2: {
    paddingTop: 4,
    paddingBottom: 4
  },
  h3: {
    paddingTop: 4,
    paddingBottom: 3
  },
  h4: {
    paddingTop: 4,
    paddingBottom: 3
  },
  h5: {
    paddingTop: 4,
    paddingBottom: 3
  },
  h6: {
    paddingTop: 4,
    paddingBottom: 2
  },
  normal: {
    paddingTop: 2,
    paddingBottom: 3
  },
  blockquote: {
    paddingTop: 2,
    paddingBottom: 3
  }
}, Root$l = /* @__PURE__ */ styled.span.withConfig({
  displayName: "Root",
  componentId: "sc-12qlql7-0"
})(({
  theme
}) => {
  const isDark = theme.sanity.color.dark;
  return css`
    /* Make sure the annotation styling is visible */
    &[data-mark='code'] {
      color: inherit;
      mix-blend-mode: ${isDark ? "screen" : "multiply"};
    }
  `;
});
function Decorator(props2) {
  const $ = c(19), {
    value,
    focused,
    selected,
    children,
    schemaType
  } = props2, schemaTypes = usePortableTextMemberSchemaTypes();
  let t0;
  if ($[0] !== schemaType || $[1] !== schemaTypes.decorators) {
    let t12;
    $[3] !== schemaType ? (t12 = (type) => type.value === schemaType.value, $[3] = schemaType, $[4] = t12) : t12 = $[4], t0 = schemaTypes.decorators.find(t12), $[0] = schemaType, $[1] = schemaTypes.decorators, $[2] = t0;
  } else
    t0 = $[2];
  const sanitySchemaType = t0;
  if (!sanitySchemaType)
    throw new Error(`Could not find Sanity schema type for decorator: ${schemaType.value}`);
  const tag = TEXT_DECORATOR_TAGS[value], CustomComponent = sanitySchemaType.component;
  let t1;
  $[5] !== tag || $[6] !== value ? (t1 = (defaultComponentProps) => /* @__PURE__ */ jsx(Root$l, { as: tag, "data-mark": value, children: defaultComponentProps.children }), $[5] = tag, $[6] = value, $[7] = t1) : t1 = $[7];
  const DefaultComponent2 = t1;
  let t2;
  $[8] !== DefaultComponent2 || $[9] !== focused || $[10] !== sanitySchemaType || $[11] !== selected || $[12] !== value ? (t2 = {
    focused,
    renderDefault: DefaultComponent2,
    schemaType: sanitySchemaType,
    selected,
    title: sanitySchemaType.title,
    value
  }, $[8] = DefaultComponent2, $[9] = focused, $[10] = sanitySchemaType, $[11] = selected, $[12] = value, $[13] = t2) : t2 = $[13];
  const componentProps = t2;
  let t3;
  return $[14] !== CustomComponent || $[15] !== DefaultComponent2 || $[16] !== children || $[17] !== componentProps ? (t3 = CustomComponent ? /* @__PURE__ */ jsx(CustomComponent, { ...componentProps, children }) : /* @__PURE__ */ jsx(DefaultComponent2, { ...componentProps, children }), $[14] = CustomComponent, $[15] = DefaultComponent2, $[16] = children, $[17] = componentProps, $[18] = t3) : t3 = $[18], t3;
}
function createListName(level) {
  return `list-level-${level}`;
}
const ReviewChangesHighlightBlock = /* @__PURE__ */ styled.div.withConfig({
  displayName: "ReviewChangesHighlightBlock",
  componentId: "sc-1414815-0"
})(({
  theme,
  $fullScreen
}) => {
  const {
    radius,
    space,
    color
  } = theme.sanity, bg = rgba(color.spot.yellow, 0.2);
  return css`
    position: absolute;
    border-radius: ${radius[3]}px;
    top: -${space[2]}px;
    bottom: -${space[1] + space[1]}px;
    left: ${$fullScreen ? space[4] + space[1] : space[1]}px;
    right: ${space[1]}px;
    background-color: ${bg};
    pointer-events: none;
  `;
}), CORNER_RADIUS = 4, INTERACTIVE_STROKE_WIDTH = 16, CONNECTOR_MARGIN = 8, ARROW_MARGIN_X = 8, ARROW_MARGIN_Y = 2, ARROW_SIZE = 4, ARROW_THRESHOLD = 12, STROKE_WIDTH$2 = 1, DEBUG = !1, DEBUG_LAYER_BOUNDS = !1, animationSpeed = 250, ChangeBarWrapper$1 = /* @__PURE__ */ styled.div.withConfig({
  displayName: "ChangeBarWrapper",
  componentId: "sc-1legq8u-0"
})(({
  $changed,
  $disabled,
  $hasFocus,
  $isReviewChangeOpen
}) => $disabled ? css`
        ${ChangeBarMarker}:after {
          display: none;
        }
      ` : css`
      --change-bar-offset: 4px;

      display: flex;
      position: relative;

      ${ChangeBarMarker}:after {
        opacity: 0.5;
      }

      @media (hover: hover) {
        &:hover {
          z-index: 10;
          ${ChangeBarMarker}:after {
            opacity: 1;
          }
        }
      }

      /* hide when field is not changed */
      ${$hasFocus && css`
        ${ChangeBarMarker}:after {
          opacity: 1;
        }
      `}

      /* hide when field is not changed */
      ${!$changed && css`
        ${ChangeBarMarker}:after {
          opacity: 0;
          pointer-events: none;
        }
      `}

      /* hide hover effect when review changes is open */
      ${$isReviewChangeOpen && css`
        ${ChangeBarButton} {
          opacity: 0;
        }
      `}
    `), FieldWrapper$1 = styled.div.withConfig({
  displayName: "FieldWrapper",
  componentId: "sc-1legq8u-1"
})`flex-grow:1;min-width:0;`, ChangeBar = styled.div.withConfig({
  displayName: "ChangeBar",
  componentId: "sc-1legq8u-2"
})`position:relative;opacity:1;transition:opacity 100ms;z-index:${({
  $zIndex
}) => $zIndex};`, ChangeBarMarker = /* @__PURE__ */ styled.div.withConfig({
  displayName: "ChangeBarMarker",
  componentId: "sc-1legq8u-3"
})((props2) => {
  const {
    media
  } = getTheme_v2(props2.theme);
  return css`
    position: absolute;
    top: -1px;
    left: var(--change-bar-offset);
    width: 1px;
    bottom: -1px;
    background-color: var(--card-bg-color);

    @media (min-width: ${media[0]}px) {
      display: unset;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 1px;
      left: 0;
      width: 1px;
      bottom: 1px;
      background-color: var(--card-badge-caution-dot-color);
      border-radius: 0.5px;
    }
  `;
}), ChangeBarButton = /* @__PURE__ */ styled.button.withConfig({
  displayName: "ChangeBarButton",
  componentId: "sc-1legq8u-4"
})((props2) => {
  const {
    $withHoverEffect,
    $isInteractive
  } = props2;
  return css`
    appearance: none;
    border: 0;
    outline: 0;
    display: block;
    padding: 0;
    background: transparent;
    opacity: 0;
    position: absolute;
    height: 100%;

    ${$isInteractive && css`
        cursor: pointer;
        pointer-events: all;
      `}

    left: calc(-0.25rem + var(--change-bar-offset));
    width: calc(1rem - 1px);
    transition: opacity ${animationSpeed}ms;

    &:focus {
      border: 0;
      outline: 0;
    }

    &:focus {
      border: 0;
      outline: 0;
    }

    ${$withHoverEffect && css`
        @media (hover: hover) {
          &:hover {
            opacity: 0.2;
          }
        }
      `}
  `;
});
function ElementWithChangeBar(props2) {
  const $ = c(18), {
    children,
    disabled,
    hasFocus,
    isChanged,
    withHoverEffect: t0,
    isInteractive: t1
  } = props2, withHoverEffect = t0 === void 0 ? !0 : t0, isInteractive = t1 === void 0 ? !0 : t1, {
    onOpenReviewChanges,
    isReviewChangesOpen
  } = useContext(ReviewChangesContext), {
    zIndex
  } = useLayer(), {
    t
  } = useTranslation();
  let t2;
  $[0] !== disabled || $[1] !== isChanged || $[2] !== isInteractive || $[3] !== isReviewChangesOpen || $[4] !== onOpenReviewChanges || $[5] !== t || $[6] !== withHoverEffect || $[7] !== zIndex ? (t2 = disabled || !isChanged ? null : /* @__PURE__ */ jsxs(ChangeBar, { "data-testid": "change-bar", $zIndex: zIndex, children: [
    /* @__PURE__ */ jsx(ChangeBarMarker, { "data-testid": "change-bar__marker" }),
    /* @__PURE__ */ jsx(Tooltip, { content: t("changes.change-bar.aria-label"), portal: !0, disabled: !isInteractive, children: /* @__PURE__ */ jsx(ChangeBarButton, { "aria-label": t("changes.change-bar.aria-label"), "data-testid": "change-bar__button", onClick: isReviewChangesOpen ? void 0 : onOpenReviewChanges, tabIndex: -1, type: "button", $withHoverEffect: withHoverEffect, $isInteractive: isInteractive }) })
  ] }), $[0] = disabled, $[1] = isChanged, $[2] = isInteractive, $[3] = isReviewChangesOpen, $[4] = onOpenReviewChanges, $[5] = t, $[6] = withHoverEffect, $[7] = zIndex, $[8] = t2) : t2 = $[8];
  const changeBar = t2;
  let t3;
  $[9] !== children ? (t3 = /* @__PURE__ */ jsx(FieldWrapper$1, { "data-testid": "change-bar__field-wrapper", children }), $[9] = children, $[10] = t3) : t3 = $[10];
  let t4;
  return $[11] !== changeBar || $[12] !== disabled || $[13] !== hasFocus || $[14] !== isChanged || $[15] !== isReviewChangesOpen || $[16] !== t3 ? (t4 = /* @__PURE__ */ jsxs(ChangeBarWrapper$1, { "data-testid": "change-bar-wrapper", $changed: isChanged, $disabled: disabled, $hasFocus: hasFocus, $isReviewChangeOpen: isReviewChangesOpen, children: [
    t3,
    changeBar
  ] }), $[11] = changeBar, $[12] = disabled, $[13] = hasFocus, $[14] = isChanged, $[15] = isReviewChangesOpen, $[16] = t3, $[17] = t4) : t4 = $[17], t4;
}
const ChangeBarWrapper = memo(function(props2) {
  const $ = c(41);
  let children, disabled, hasFocus, isChanged, isInteractive, onMouseEnterProp, onMouseLeaveProp, restProps, t0, withHoverEffect;
  $[0] !== props2 ? ({
    children,
    disabled,
    hasFocus,
    isChanged,
    onMouseEnter: onMouseEnterProp,
    onMouseLeave: onMouseLeaveProp,
    path: t0,
    withHoverEffect,
    isInteractive,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = disabled, $[3] = hasFocus, $[4] = isChanged, $[5] = isInteractive, $[6] = onMouseEnterProp, $[7] = onMouseLeaveProp, $[8] = restProps, $[9] = t0, $[10] = withHoverEffect) : (children = $[1], disabled = $[2], hasFocus = $[3], isChanged = $[4], isInteractive = $[5], onMouseEnterProp = $[6], onMouseLeaveProp = $[7], restProps = $[8], t0 = $[9], withHoverEffect = $[10]);
  const path = t0 === void 0 ? EMPTY_ARRAY$y : t0, layer = useLayer(), [hasHover, setHover] = useState(!1);
  let t1;
  $[11] !== onMouseEnterProp ? (t1 = (event) => {
    onMouseEnterProp?.(event), setHover(!0);
  }, $[11] = onMouseEnterProp, $[12] = t1) : t1 = $[12];
  const onMouseEnter = t1;
  let t2;
  $[13] !== onMouseLeaveProp ? (t2 = (event_0) => {
    onMouseLeaveProp?.(event_0), setHover(!1);
  }, $[13] = onMouseLeaveProp, $[14] = t2) : t2 = $[14];
  const onMouseLeave = t2, [element, setElement] = useState(null);
  let t3;
  $[15] !== disabled || $[16] !== element || $[17] !== path ? (t3 = disabled || !element ? null : `field-${PathUtils.toString(path)}`, $[15] = disabled, $[16] = element, $[17] = path, $[18] = t3) : t3 = $[18];
  const reporterId = t3;
  let t4;
  $[19] !== element || $[20] !== hasFocus || $[21] !== hasHover || $[22] !== isChanged || $[23] !== layer.zIndex || $[24] !== path ? (t4 = () => ({
    element,
    path,
    isChanged: !!isChanged,
    hasFocus,
    hasHover,
    hasRevertHover: !1,
    zIndex: layer.zIndex
  }), $[19] = element, $[20] = hasFocus, $[21] = hasHover, $[22] = isChanged, $[23] = layer.zIndex, $[24] = path, $[25] = t4) : t4 = $[25], useChangeIndicatorsReporter(reporterId, t4, deepEquals);
  let t5;
  $[26] !== path ? (t5 = DEBUG, $[26] = path, $[27] = t5) : t5 = $[27];
  let t6;
  $[28] !== children || $[29] !== disabled || $[30] !== hasFocus || $[31] !== isChanged || $[32] !== isInteractive || $[33] !== t5 || $[34] !== withHoverEffect ? (t6 = /* @__PURE__ */ jsxs(ElementWithChangeBar, { hasFocus, isChanged, disabled, withHoverEffect, isInteractive, children: [
    t5,
    children
  ] }), $[28] = children, $[29] = disabled, $[30] = hasFocus, $[31] = isChanged, $[32] = isInteractive, $[33] = t5, $[34] = withHoverEffect, $[35] = t6) : t6 = $[35];
  let t7;
  return $[36] !== onMouseEnter || $[37] !== onMouseLeave || $[38] !== restProps || $[39] !== t6 ? (t7 = /* @__PURE__ */ jsx("div", { ...restProps, ref: setElement, onMouseEnter, onMouseLeave, children: t6 }), $[36] = onMouseEnter, $[37] = onMouseLeave, $[38] = restProps, $[39] = t6, $[40] = t7) : t7 = $[40], t7;
});
function ChangeIndicator(props2) {
  const $ = c(15);
  let children, hasFocus, isChanged, path, restProps, withHoverEffect;
  $[0] !== props2 ? ({
    children,
    hasFocus,
    isChanged,
    path,
    withHoverEffect,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = hasFocus, $[3] = isChanged, $[4] = path, $[5] = restProps, $[6] = withHoverEffect) : (children = $[1], hasFocus = $[2], isChanged = $[3], path = $[4], restProps = $[5], withHoverEffect = $[6]);
  const {
    isInteractive
  } = useContext(ReviewChangesContext);
  let t0;
  return $[7] !== children || $[8] !== hasFocus || $[9] !== isChanged || $[10] !== isInteractive || $[11] !== path || $[12] !== restProps || $[13] !== withHoverEffect ? (t0 = /* @__PURE__ */ jsx(ChangeBarWrapper, { ...restProps, path, hasFocus, isChanged, withHoverEffect, isInteractive, children }), $[7] = children, $[8] = hasFocus, $[9] = isChanged, $[10] = isInteractive, $[11] = path, $[12] = restProps, $[13] = withHoverEffect, $[14] = t0) : t0 = $[14], t0;
}
const StyledChangeIndicatorWithProvidedFullPath = /* @__PURE__ */ styled(ChangeIndicator).withConfig({
  displayName: "StyledChangeIndicatorWithProvidedFullPath",
  componentId: "sc-1cqx88r-0"
})(() => css`
    width: 1px;
    height: 100%;

    & > div {
      height: 100%;
    }
  `);
function createInsertCallback(options) {
  const {
    block,
    onChange
  } = options;
  return (givenBlock) => {
    const toInsert = Array.isArray(givenBlock) ? givenBlock : [givenBlock], patches = [insert$1(toInsert, "after", [{
      _key: block._key
    }])];
    return onChange(PatchEvent.from(patches));
  };
}
function createSetCallback(options) {
  const {
    block,
    onChange
  } = options;
  return (givenBlock) => {
    const patches = [set(givenBlock, [{
      _key: block._key
    }])];
    return onChange(PatchEvent.from(patches));
  };
}
function createUnsetCallback(options) {
  const {
    block,
    onChange
  } = options;
  return () => {
    const patches = [unset([{
      _key: block._key
    }])];
    return onChange(PatchEvent.from(patches));
  };
}
const Root$k = styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-134ue80-0"
})`display:flex;pointer-events:all;`;
function BlockActions(props2) {
  const $ = c(7), editor2 = usePortableTextEditor(), {
    block,
    onChange,
    renderBlockActions
  } = props2;
  let t0;
  bb0: {
    if (renderBlockActions) {
      let t12;
      if ($[0] !== block || $[1] !== editor2 || $[2] !== onChange || $[3] !== renderBlockActions) {
        const blockActionProps = {
          block,
          value: PortableTextEditor.getValue(editor2),
          set: createSetCallback({
            block,
            onChange
          }),
          unset: createUnsetCallback({
            block,
            onChange
          }),
          insert: createInsertCallback({
            block,
            onChange
          })
        };
        t12 = renderBlockActions(blockActionProps), $[0] = block, $[1] = editor2, $[2] = onChange, $[3] = renderBlockActions, $[4] = t12;
      } else
        t12 = $[4];
      t0 = t12;
      break bb0;
    }
    t0 = void 0;
  }
  const blockActions = t0;
  if (!blockActions)
    return null;
  let t1;
  return $[5] !== blockActions ? (t1 = /* @__PURE__ */ jsx(Root$k, { contentEditable: !1, children: blockActions }), $[5] = blockActions, $[6] = t1) : t1 = $[6], t1;
}
function textBlockStyle(props2) {
  const {
    $level
  } = props2, {
    color,
    font,
    radius,
    space
  } = getTheme_v2(props2.theme), numberMarker = TEXT_NUMBER_FORMATS[($level - 1) % TEXT_NUMBER_FORMATS.length], bulletMarker = TEXT_BULLET_MARKERS[($level - 1) % TEXT_BULLET_MARKERS.length];
  return css`
    --marker-bg-color: transparent;

    mix-blend-mode: ${color._dark ? "screen" : "multiply"};
    position: relative;

    & > [data-ui='TextBlock_inner'] {
      position: relative;
      flex: 1;
    }

    & > div:before {
      content: '';
      position: absolute;
      top: -${space[1]}px;
      bottom: -${space[1]}px;
      left: -${space[1]}px;
      right: -${space[1]}px;
      border-radius: ${radius[2]}px;
      background-color: var(--marker-bg-color);
      // This is to make sure the marker is always behind the text
      z-index: -1;
      pointer-events: none;
    }

    &[data-markers] {
      --marker-bg-color: ${color._dark ? hues.purple[950].hex : hues.purple[50].hex};
    }

    &[data-warning] {
      --card-border-color: ${color.button.ghost.caution.enabled.border};
      --marker-bg-color: ${color.button.ghost.caution.hovered.bg};
    }

    &[data-error] {
      --card-border-color: ${color.button.ghost.critical.enabled.border};
      --marker-bg-color: ${color.button.ghost.critical.hovered.bg};
    }

    & [data-list-prefix] {
      position: absolute;
      margin-left: -4.5rem;
      width: 3.75rem;
      text-align: right;
      box-sizing: border-box;
    }

    &[data-list-item='number'] [data-list-prefix] {
      font-variant-numeric: tabular-nums;

      & > span:before {
        content: counter(${createListName($level)}) '.';
        content: counter(${createListName($level)}, ${numberMarker}) '.';
      }
    }

    &[data-list-item='bullet'] [data-list-prefix] {
      & > span {
        position: relative;
        top: -0.1875em;

        &:before {
          content: '${bulletMarker}';
          font-size: 0.46666em;
        }
      }
    }

    & [data-text] {
      overflow-wrap: anywhere;
      text-transform: none;
      white-space: pre-wrap;
      font-family: ${font.text.family};
      flex: 1;

      *::selection {
        background-color: ${rgba$1(color.focusRing, 0.3)};
      }
    }
  `;
}
const TextRoot = /* @__PURE__ */ styled.div.withConfig({
  displayName: "TextRoot",
  componentId: "sc-dzmicd-0"
})(textBlockStyle), TextBlockFlexWrapper = styled(Box).withConfig({
  displayName: "TextBlockFlexWrapper",
  componentId: "sc-dzmicd-1"
})`position:relative;display:flex;`, ListPrefixWrapper = styled.div.withConfig({
  displayName: "ListPrefixWrapper",
  componentId: "sc-dzmicd-2"
})`user-select:none;white-space:nowrap;`, BlockActionsOuter$1 = styled(Box).withConfig({
  displayName: "BlockActionsOuter",
  componentId: "sc-dzmicd-3"
})`line-height:0;width:25px;position:relative;`, BlockActionsInner$1 = /* @__PURE__ */ styled(Flex).withConfig({
  displayName: "BlockActionsInner",
  componentId: "sc-dzmicd-4"
})(({
  theme
}) => {
  const {
    fonts,
    space
  } = theme.sanity, textSize1 = fonts.text.sizes[1], textSize2 = fonts.text.sizes[2], capHeight1 = textSize1.lineHeight - textSize1.ascenderHeight - textSize1.descenderHeight, capHeight2 = textSize2.lineHeight - textSize2.ascenderHeight - textSize2.descenderHeight, negativeTop = 0 - (capHeight1 + space[2] + space[2] - capHeight2) / 2;
  return css`
    user-select: none;
    position: absolute;
    right: 0;
    top: ${negativeTop}px;
  `;
}), TooltipBox$2 = styled(Box).withConfig({
  displayName: "TooltipBox",
  componentId: "sc-dzmicd-5"
})`max-width:250px;`, TextFlex = styled(Flex).withConfig({
  displayName: "TextFlex",
  componentId: "sc-dzmicd-6"
})`position:relative;padding-left:${({
  $level
}) => $level ? $level * 32 : 0}px;`, ChangeIndicatorWrapper$1 = /* @__PURE__ */ styled.div.withConfig({
  displayName: "ChangeIndicatorWrapper",
  componentId: "sc-dzmicd-7"
})(({
  theme,
  $hasChanges
}) => {
  const {
    space
  } = theme.sanity;
  return css`
      position: absolute;
      width: ${space[2]}px;
      right: 0;
      top: 0;
      bottom: 0;
      padding-left: ${space[1]}px;
      padding-right: ${space[2]}px;
      user-select: none;
      ${DEBUG}

      ${!$hasChanges && css`
          display: none;
        `}
    `;
}), TextContainer = styled.div.withConfig({
  displayName: "TextContainer",
  componentId: "sc-1fthfjz-0"
})`display:block;`, Normal = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { "data-testid": "text-style--normal", ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, Heading1 = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Heading, { as: "h1", "data-testid": "text-style--h1", size: 5, ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, Heading2 = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Heading, { as: "h2", "data-testid": "text-style--h2", size: 4, ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, Heading3 = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Heading, { as: "h3", "data-testid": "text-style--h3", size: 3, ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, Heading4 = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Heading, { as: "h4", "data-testid": "text-style--h4", size: 2, ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, Heading5 = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Heading, { as: "h5", "data-testid": "text-style--h5", size: 1, ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, Heading6 = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Heading, { as: "h6", "data-testid": "text-style--h6", size: 0, ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, BlockQuoteRoot = styled.blockquote.withConfig({
  displayName: "BlockQuoteRoot",
  componentId: "sc-1fthfjz-1"
})`position:relative;display:block;margin:0;padding-left:${({
  theme
}) => theme.sanity.space[3]}px;&::before{content:'';position:absolute;left:0;top:-4px;bottom:-4px;width:3px;background:var(--card-border-color);}`, BlockQuote = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  const t1 = rest;
  let t2;
  $[3] !== children ? (t2 = /* @__PURE__ */ jsx(Text$1, { as: "p", children }), $[3] = children, $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== t1 || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(BlockQuoteRoot, { "data-testid": "text-style--blockquote", ...t1, children: t2 }), $[5] = t1, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}, TEXT_STYLES = {
  normal: Normal,
  h1: Heading1,
  h2: Heading2,
  h3: Heading3,
  h4: Heading4,
  h5: Heading5,
  h6: Heading6,
  blockquote: BlockQuote
};
function TextBlock(props2) {
  const $ = c(126), {
    children,
    floatingBoundary,
    focused,
    isFullscreen,
    onItemClose,
    onItemOpen,
    onPathFocus,
    path,
    readOnly,
    referenceBoundary,
    renderBlock: renderBlock2,
    renderAnnotation,
    renderBlockActions,
    renderCustomMarkers,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    selected,
    setElementRef,
    spellCheck,
    value,
    anchorIdent
  } = props2, {
    Markers
  } = useFormBuilder().__internal.components, markers = usePortableTextMarkers(path), [divElement, setDivElement] = useState(null);
  let t0;
  $[0] !== path ? (t0 = pathToString$1(path), $[0] = path, $[1] = t0) : t0 = $[1];
  const memberItem = usePortableTextMemberItem(t0), editor2 = usePortableTextEditor(), schemaTypes = usePortableTextMemberSchemaTypes(), {
    onChange
  } = useFormCallbacks(), hoveredChange = useHoveredChange(), divergenceNavigator = useDocumentDivergences();
  selectDivergence(divergenceNavigator.state, path);
  const [memberItemRef, setMemberItemRef] = useState(memberItem);
  let t1, t2;
  $[2] !== memberItem ? (t1 = () => {
    memberItem && setMemberItemRef(memberItem);
  }, t2 = [memberItem], $[2] = memberItem, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]), useEffect(t1, t2);
  let t3;
  $[5] !== hoveredChange || $[6] !== path ? (t3 = hoveredChange && pathToString$1(hoveredChange?.path || []) === pathToString$1(path), $[5] = hoveredChange, $[6] = path, $[7] = t3) : t3 = $[7];
  const changeHovered = t3, t4 = divergenceNavigator.state.focusedDivergence;
  let t5;
  $[8] !== path ? (t5 = pathToString$1(path), $[8] = path, $[9] = t5) : t5 = $[9];
  const isFocusedDivergence = t4 === t5, presence = useChildPresence(path, !0);
  let t6;
  if ($[10] !== path || $[11] !== presence) {
    let t72;
    $[13] !== path ? (t72 = (p) => isEqual$2(p.path, path) || p.path.slice(-3)[1] === "children" && p.path.length - path.length === 2, $[13] = path, $[14] = t72) : t72 = $[14], t6 = presence.filter(t72), $[10] = path, $[11] = presence, $[12] = t6;
  } else
    t6 = $[12];
  const textPresence = t6, {
    validation: validation2,
    hasError,
    hasWarning,
    hasInfo
  } = useMemberValidation(memberItem?.node), hasMarkers = !!renderCustomMarkers && markers.length > 0, tooltipEnabled = hasError || hasWarning || hasMarkers || hasInfo;
  let t7;
  $[15] !== memberItem || $[16] !== onItemOpen ? (t7 = () => {
    memberItem && onItemOpen(memberItem.node.path);
  }, $[15] = memberItem, $[16] = onItemOpen, $[17] = t7) : t7 = $[17];
  const onOpen = t7;
  let t8;
  $[18] !== editor2 || $[19] !== path ? (t8 = () => {
    const point = {
      path: path.slice(-1),
      offset: 0
    }, sel = {
      focus: point,
      anchor: point
    };
    PortableTextEditor.delete(editor2, sel, {
      mode: "blocks"
    }), PortableTextEditor.focus(editor2);
  }, $[18] = editor2, $[19] = path, $[20] = t8) : t8 = $[20];
  const onRemove = t8, t9 = value?.level;
  let t10;
  $[21] !== value.listItem ? (t10 = value.listItem && /* @__PURE__ */ jsx(ListPrefixWrapper, { contentEditable: !1, children: /* @__PURE__ */ jsx(Text$1, { "data-list-prefix": "", children: /* @__PURE__ */ jsx(TextContainer, {}) }) }), $[21] = value.listItem, $[22] = t10) : t10 = $[22];
  let t11;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = void 0, $[23] = t11) : t11 = $[23];
  let t12;
  $[24] !== children ? (t12 = /* @__PURE__ */ jsx("div", { "data-text": "", style: t11, children }), $[24] = children, $[25] = t12) : t12 = $[25];
  let t13;
  $[26] !== t10 || $[27] !== t12 || $[28] !== t9 ? (t13 = /* @__PURE__ */ jsxs(TextFlex, { align: "flex-start", $level: t9, children: [
    t10,
    t12
  ] }), $[26] = t10, $[27] = t12, $[28] = t9, $[29] = t13) : t13 = $[29];
  const text = t13;
  let t14;
  bb0: {
    if (isFullscreen && !renderBlockActions) {
      let t153;
      $[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t153 = {
        paddingX: 5
      }, $[30] = t153) : t153 = $[30], t14 = t153;
      break bb0;
    }
    if (isFullscreen && renderBlockActions) {
      let t153;
      $[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t153 = {
        paddingLeft: 5,
        paddingRight: 2
      }, $[31] = t153) : t153 = $[31], t14 = t153;
      break bb0;
    }
    if (renderBlockActions) {
      let t153;
      $[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t153 = {
        paddingLeft: 3,
        paddingRight: 2
      }, $[32] = t153) : t153 = $[32], t14 = t153;
      break bb0;
    }
    let t152;
    $[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t152 = {
      paddingX: 3
    }, $[33] = t152) : t152 = $[33], t14 = t152;
  }
  const innerPaddingProps = t14;
  let t15;
  bb1: {
    if (value.listItem) {
      let t163;
      $[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t163 = {
        paddingY: 2
      }, $[34] = t163) : t163 = $[34], t15 = t163;
      break bb1;
    }
    let t162;
    $[35] !== value.style ? (t162 = TEXT_STYLE_PADDING[value.style || "normal"] || {
      paddingY: 2
    }, $[35] = value.style, $[36] = t162) : t162 = $[36], t15 = t162;
  }
  const outerPaddingProps = t15, isOpen = !!memberItem?.member.open, parentSchemaType = schemaTypes.portableText, referenceElement = divElement, t16 = memberItem?.member.item.changed ?? !1, t17 = memberItem?.node.path || EMPTY_ARRAY$y, t18 = !!readOnly;
  let t19;
  $[37] !== floatingBoundary || $[38] !== focused || $[39] !== isOpen || $[40] !== markers || $[41] !== onItemClose || $[42] !== onOpen || $[43] !== onPathFocus || $[44] !== onRemove || $[45] !== parentSchemaType || $[46] !== referenceBoundary || $[47] !== referenceElement || $[48] !== renderAnnotation || $[49] !== renderBlock2 || $[50] !== renderField || $[51] !== renderInlineBlock || $[52] !== renderInput || $[53] !== renderItem2 || $[54] !== renderPreview || $[55] !== schemaType || $[56] !== selected || $[57] !== t16 || $[58] !== t17 || $[59] !== t18 || $[60] !== text || $[61] !== textPresence || $[62] !== validation2 || $[63] !== value ? (t19 = {
    __unstable_floatingBoundary: floatingBoundary,
    __unstable_referenceBoundary: referenceBoundary,
    __unstable_referenceElement: referenceElement,
    changed: t16,
    children: text,
    focused,
    markers,
    onClose: onItemClose,
    onOpen,
    onPathFocus,
    onRemove,
    open: isOpen,
    parentSchemaType,
    path: t17,
    presence: textPresence,
    readOnly: t18,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderDefault: DefaultComponent$1,
    renderField,
    renderInput,
    renderInlineBlock,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    selected,
    validation: validation2,
    value
  }, $[37] = floatingBoundary, $[38] = focused, $[39] = isOpen, $[40] = markers, $[41] = onItemClose, $[42] = onOpen, $[43] = onPathFocus, $[44] = onRemove, $[45] = parentSchemaType, $[46] = referenceBoundary, $[47] = referenceElement, $[48] = renderAnnotation, $[49] = renderBlock2, $[50] = renderField, $[51] = renderInlineBlock, $[52] = renderInput, $[53] = renderItem2, $[54] = renderPreview, $[55] = schemaType, $[56] = selected, $[57] = t16, $[58] = t17, $[59] = t18, $[60] = text, $[61] = textPresence, $[62] = validation2, $[63] = value, $[64] = t19) : t19 = $[64];
  const componentProps = t19;
  let t20;
  $[65] !== Markers || $[66] !== markers || $[67] !== renderCustomMarkers || $[68] !== tooltipEnabled || $[69] !== validation2 ? (t20 = tooltipEnabled && /* @__PURE__ */ jsx(TooltipBox$2, { children: /* @__PURE__ */ jsx(Markers, { markers, renderCustomMarkers, validation: validation2 }) }) || null, $[65] = Markers, $[66] = markers, $[67] = renderCustomMarkers, $[68] = tooltipEnabled, $[69] = validation2, $[70] = t20) : t20 = $[70];
  const toolTipContent = t20, blockActionsEnabled = renderBlockActions && !readOnly, changeIndicatorVisible = isFullscreen && memberItemRef;
  let t21;
  $[71] !== memberItem || $[72] !== setElementRef ? (t21 = (elm) => {
    memberItem && setElementRef({
      key: memberItem.member.key,
      elementRef: elm
    }), setDivElement(elm);
  }, $[71] = memberItem, $[72] = setElementRef, $[73] = t21) : t21 = $[73];
  const setRef = t21;
  let t22;
  $[74] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = void 0, $[74] = t22) : t22 = $[74];
  let t23;
  $[75] !== anchorIdent ? (t23 = {
    anchorName: anchorIdent
  }, $[75] = anchorIdent, $[76] = t23) : t23 = $[76];
  const t24 = !tooltipEnabled, t25 = value.level || 1, t26 = hasError ? "" : void 0, t27 = hasMarkers ? "" : void 0, t28 = hasWarning ? "" : void 0;
  let t29;
  $[77] !== componentProps || $[78] !== renderBlock2 ? (t29 = renderBlock2 && renderBlock2(componentProps), $[77] = componentProps, $[78] = renderBlock2, $[79] = t29) : t29 = $[79];
  let t30;
  $[80] !== readOnly || $[81] !== spellCheck || $[82] !== t25 || $[83] !== t26 || $[84] !== t27 || $[85] !== t28 || $[86] !== t29 || $[87] !== value.listItem ? (t30 = /* @__PURE__ */ jsx(TextRoot, { $level: t25, "data-error": t26, "data-list-item": value.listItem, "data-markers": t27, "data-read-only": readOnly, "data-testid": "text-block__text", "data-warning": t28, spellCheck, children: t29 }), $[80] = readOnly, $[81] = spellCheck, $[82] = t25, $[83] = t26, $[84] = t27, $[85] = t28, $[86] = t29, $[87] = value.listItem, $[88] = t30) : t30 = $[88];
  let t31;
  $[89] !== t24 || $[90] !== t30 || $[91] !== toolTipContent ? (t31 = /* @__PURE__ */ jsx(Tooltip, { content: toolTipContent, disabled: t24, placement: "top", portal: "editor", children: t30 }), $[89] = t24, $[90] = t30, $[91] = toolTipContent, $[92] = t31) : t31 = $[92];
  let t32;
  $[93] !== t23 || $[94] !== t31 ? (t32 = /* @__PURE__ */ jsx(Box, { flex: 1, style: t23, children: t31 }), $[93] = t23, $[94] = t31, $[95] = t32) : t32 = $[95];
  let t33;
  $[96] !== blockActionsEnabled || $[97] !== focused || $[98] !== onChange || $[99] !== renderBlockActions || $[100] !== value ? (t33 = blockActionsEnabled && /* @__PURE__ */ jsx(BlockActionsOuter$1, { contentEditable: !1, marginRight: 3, children: /* @__PURE__ */ jsx(BlockActionsInner$1, { children: focused && /* @__PURE__ */ jsx(BlockActions, { block: value, onChange, renderBlockActions }) }) }), $[96] = blockActionsEnabled, $[97] = focused, $[98] = onChange, $[99] = renderBlockActions, $[100] = value, $[101] = t33) : t33 = $[101];
  let t34;
  $[102] !== changeIndicatorVisible || $[103] !== focused || $[104] !== memberItem || $[105] !== memberItemRef ? (t34 = changeIndicatorVisible && /* @__PURE__ */ jsx(ChangeIndicatorWrapper$1, { $hasChanges: (memberItem ?? memberItemRef).member.item.changed, contentEditable: !1, children: /* @__PURE__ */ jsx(StyledChangeIndicatorWithProvidedFullPath, { hasFocus: focused, isChanged: (memberItem ?? memberItemRef).member.item.changed, path: (memberItem ?? memberItemRef).member.item.path, withHoverEffect: !1 }) }), $[102] = changeIndicatorVisible, $[103] = focused, $[104] = memberItem, $[105] = memberItemRef, $[106] = t34) : t34 = $[106];
  let t35;
  $[107] !== changeHovered || $[108] !== isFocusedDivergence || $[109] !== isFullscreen ? (t35 = (changeHovered || isFocusedDivergence) && /* @__PURE__ */ jsx(ReviewChangesHighlightBlock, { $fullScreen: !!isFullscreen }), $[107] = changeHovered, $[108] = isFocusedDivergence, $[109] = isFullscreen, $[110] = t35) : t35 = $[110];
  let t36;
  $[111] !== innerPaddingProps || $[112] !== t32 || $[113] !== t33 || $[114] !== t34 || $[115] !== t35 ? (t36 = /* @__PURE__ */ jsxs(Flex, { flex: 1, ...innerPaddingProps, children: [
    t32,
    t33,
    t34,
    t35
  ] }), $[111] = innerPaddingProps, $[112] = t32, $[113] = t33, $[114] = t34, $[115] = t35, $[116] = t36) : t36 = $[116];
  let t37;
  $[117] !== path || $[118] !== readOnly || $[119] !== t36 ? (t37 = /* @__PURE__ */ jsx(TextBlockFlexWrapper, { "data-testid": "text-block__wrapper", children: /* @__PURE__ */ jsx(FormNodeDivergenceDetail, { path, readOnly, children: t36 }) }), $[117] = path, $[118] = readOnly, $[119] = t36, $[120] = t37) : t37 = $[120];
  let t38;
  return $[121] !== isFullscreen || $[122] !== outerPaddingProps || $[123] !== setRef || $[124] !== t37 ? (t38 = /* @__PURE__ */ jsx(Box, { ...outerPaddingProps, "data-testid": "text-block", "data-fullscreen": isFullscreen, ref: setRef, style: t22, children: t37 }), $[121] = isFullscreen, $[122] = outerPaddingProps, $[123] = setRef, $[124] = t37, $[125] = t38) : t38 = $[125], t38;
}
const DefaultComponent$1 = (props2) => {
  const $ = c(2);
  let t0;
  return $[0] !== props2.children ? (t0 = /* @__PURE__ */ jsx(Fragment$1, { children: props2.children }), $[0] = props2.children, $[1] = t0) : t0 = $[1], t0;
}, Root$j = styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-1r30gnh-0"
})`&[data-fullscreen='true']{height:100%;}&[data-fullscreen='false']{min-height:5em;resize:${({
  $isOneLine
}) => $isOneLine ? "none" : "vertical"};overflow:auto;height:${({
  $isOneLine
}) => $isOneLine ? "auto" : "19em"};}&:not([hidden]){display:flex;}flex-direction:column;`, ToolbarCard = styled(Card).withConfig({
  displayName: "ToolbarCard",
  componentId: "sc-1r30gnh-1"
})`z-index:10;line-height:0;`, EditableCard = styled(Card).withConfig({
  displayName: "EditableCard",
  componentId: "sc-1r30gnh-2"
})`position:relative;overflow:hidden;overflow:clip;& > [data-portal]{position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none;& > *{pointer-events:initial;}}&::selection,*::selection{background-color:transparent;}`, Scroller = styled(ScrollContainer).withConfig({
  displayName: "Scroller",
  componentId: "sc-1r30gnh-3"
})`position:relative;overflow:auto;height:100%;display:flex;flex-direction:column;& > *{flex:1;min-height:auto;}`, EditableWrapper = styled(Card).withConfig({
  displayName: "EditableWrapper",
  componentId: "sc-1r30gnh-4"
})`height:100%;width:100%;counter-reset:${TEXT_LEVELS.map((l) => createListName(l)).join(" ")};overflow:hidden;overflow:clip;& > div{height:100%;}& .pt-editable{display:block;width:100%;height:100%;${TEXT_LEVELS.map((l) => css`
        /* Reset the list count each time a list index of 1 is encountered
         * for the current level.
         */
        & [data-level='${l}'][data-list-index='1'] {
          counter-set: ${createListName(l)} 1;
        }
        /* Otherwise, increment the list count for the current level. */
        & [data-level='${l}']:not([data-list-index='1']) {
          counter-increment: ${createListName(l)};
        }
      `)} & > .pt-list-item-bullet + .pt-list-item-number,& > .pt-list-item-number + .pt-list-item-bullet{margin-top:${({
  theme
}) => theme.sanity.space[3]}px;}& > :not(.pt-list-item) + .pt-list-item{margin-top:${({
  theme
}) => theme.sanity.space[2]}px;}& > .pt-list-item + :not(.pt-list-item){margin-top:${({
  theme
}) => theme.sanity.space[3]}px;}& > :first-child{padding-top:${({
  $isFullscreen,
  theme
}) => theme.sanity.space[$isFullscreen ? 5 : 3]}px;}padding-bottom:${({
  $isFullscreen,
  $isOneLine,
  theme
}) => $isOneLine ? "0" : theme.sanity.space[$isFullscreen ? 9 : 5]}px;& > .pt-block{margin:0 auto;max-width:${(props2) => getTheme_v2(props2.theme).container[1]}px;}& .pt-drop-indicator{pointer-events:none;border:1px solid var(--card-focus-ring-color) !important;height:0px !important;border-radius:${(props2) => getTheme_v2(props2.theme).radius[2]}px;margin-top:-3px;left:calc( ${({
  $isFullscreen,
  theme
}) => $isFullscreen ? rem(theme.sanity.space[5]) : rem(theme.sanity.space[3])} - 1px );right:calc( ${({
  $isFullscreen,
  theme
}) => $isFullscreen ? rem(theme.sanity.space[5]) : rem(theme.sanity.space[3])} - 1px );width:calc( 100% - ${({
  $isFullscreen,
  theme
}) => $isFullscreen ? rem(theme.sanity.space[5] * 2) : rem(theme.sanity.space[3] * 2)} + 2px ) !important;}}`;
function useScrollSelectionIntoView(scrollElement) {
  const $ = c(2);
  let t0;
  return $[0] !== scrollElement ? (t0 = (editor2, domRange) => {
    if (PortableTextEditor.getSelection(editor2)) {
      const leafEl = domRange.startContainer.parentElement;
      if (!leafEl)
        return;
      scrollIntoView$1(leafEl, {
        scrollMode: "if-needed",
        boundary: scrollElement,
        block: "nearest",
        inline: "nearest"
      });
    }
  }, $[0] = scrollElement, $[1] = t0) : t0 = $[1], t0;
}
function useSpellCheck() {
  const spellCheckOption = usePortableTextMemberSchemaTypes().block.options?.spellCheck, isChrome96 = typeof navigator > "u" ? !1 : /Chrome\/96/.test(navigator.userAgent);
  return spellCheckOption === void 0 && isChrome96 ? !1 : spellCheckOption;
}
const DefaultComponent = (dProps) => {
  const $ = c(2);
  let t0;
  return $[0] !== dProps.children ? (t0 = /* @__PURE__ */ jsx(Fragment$1, { children: dProps.children }), $[0] = dProps.children, $[1] = t0) : t0 = $[1], t0;
}, ListItem$1 = (props2) => {
  const $ = c(17), {
    block,
    children,
    schemaType,
    selected,
    focused,
    level,
    value
  } = props2, schemaTypes = usePortableTextMemberSchemaTypes();
  let t0;
  if ($[0] !== schemaType || $[1] !== schemaTypes.lists) {
    let t12;
    $[3] !== schemaType ? (t12 = (type) => type.value === schemaType.value, $[3] = schemaType, $[4] = t12) : t12 = $[4], t0 = schemaTypes.lists.find(t12), $[0] = schemaType, $[1] = schemaTypes.lists, $[2] = t0;
  } else
    t0 = $[2];
  const sanitySchemaType = t0;
  if (!sanitySchemaType)
    throw new Error(`Could not find Sanity schema type for list item: ${schemaType.value}`);
  const {
    title,
    component: CustomComponent
  } = sanitySchemaType;
  let t1;
  $[5] !== block || $[6] !== focused || $[7] !== level || $[8] !== sanitySchemaType || $[9] !== selected || $[10] !== title || $[11] !== value ? (t1 = {
    block,
    focused,
    level,
    renderDefault: DefaultComponent,
    schemaType: sanitySchemaType,
    selected,
    title,
    value
  }, $[5] = block, $[6] = focused, $[7] = level, $[8] = sanitySchemaType, $[9] = selected, $[10] = title, $[11] = value, $[12] = t1) : t1 = $[12];
  const componentProps = t1;
  let t2;
  return $[13] !== CustomComponent || $[14] !== children || $[15] !== componentProps ? (t2 = CustomComponent ? /* @__PURE__ */ jsx(CustomComponent, { ...componentProps, children }) : /* @__PURE__ */ jsx(DefaultComponent, { ...componentProps, children }), $[13] = CustomComponent, $[14] = children, $[15] = componentProps, $[16] = t2) : t2 = $[16], t2;
}, Style = (props2) => {
  const $ = c(21), {
    block,
    focused,
    children,
    selected,
    schemaType
  } = props2, schemaTypes = usePortableTextMemberSchemaTypes();
  let t0;
  if ($[0] !== schemaType || $[1] !== schemaTypes.styles) {
    let t12;
    $[3] !== schemaType ? (t12 = (type) => type.value === schemaType.value, $[3] = schemaType, $[4] = t12) : t12 = $[4], t0 = schemaTypes.styles.find(t12), $[0] = schemaType, $[1] = schemaTypes.styles, $[2] = t0;
  } else
    t0 = $[2];
  const sanitySchemaType = t0;
  if (!sanitySchemaType)
    throw new Error(`Could not find Sanity schema type for style: ${schemaType.value}`);
  const DefaultComponentWithFallback = (block.style && TEXT_STYLES[block.style] ? TEXT_STYLES[block.style] : TEXT_STYLES[0]) || Normal;
  let t1;
  $[5] !== DefaultComponentWithFallback || $[6] !== block.style ? (t1 = (defaultComponentProps) => /* @__PURE__ */ jsx(DefaultComponentWithFallback, { children: /* @__PURE__ */ jsx(TextContainer, { "data-testid": `text-style--${block.style}`, children: defaultComponentProps.children }) }), $[5] = DefaultComponentWithFallback, $[6] = block.style, $[7] = t1) : t1 = $[7];
  const DefaultComponent2 = t1, CustomComponent = sanitySchemaType.component, {
    title,
    value
  } = sanitySchemaType;
  let t2;
  $[8] !== DefaultComponent2 || $[9] !== block || $[10] !== focused || $[11] !== sanitySchemaType || $[12] !== selected || $[13] !== title || $[14] !== value ? (t2 = {
    block,
    focused,
    renderDefault: DefaultComponent2,
    schemaType: sanitySchemaType,
    selected,
    title,
    value
  }, $[8] = DefaultComponent2, $[9] = block, $[10] = focused, $[11] = sanitySchemaType, $[12] = selected, $[13] = title, $[14] = value, $[15] = t2) : t2 = $[15];
  const componentProps = t2;
  let t3;
  return $[16] !== CustomComponent || $[17] !== DefaultComponent2 || $[18] !== children || $[19] !== componentProps ? (t3 = CustomComponent ? /* @__PURE__ */ jsx(CustomComponent, { ...componentProps, children }) : /* @__PURE__ */ jsx(DefaultComponent2, { ...componentProps, children }), $[16] = CustomComponent, $[17] = DefaultComponent2, $[18] = children, $[19] = componentProps, $[20] = t3) : t3 = $[20], t3;
}, DividerDiv = styled.div.withConfig({
  displayName: "DividerDiv",
  componentId: "sc-16u5v5h-0"
})`border-right:1px solid var(--card-border-color);height:auto;&[data-hidden]{opacity:0;}`;
function CollapseMenuDivider(props2) {
  const $ = c(6);
  let hidden, rest;
  $[0] !== props2 ? ({
    hidden,
    ...rest
  } = props2, $[0] = props2, $[1] = hidden, $[2] = rest) : (hidden = $[1], rest = $[2]);
  const t0 = hidden ? "" : void 0;
  let t1;
  return $[3] !== rest || $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(DividerDiv, { "data-ui": "CollapseMenuDivider", "data-hidden": t0, ...rest }), $[3] = rest, $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}
const MENU_BUTTON_POPOVER_PROPS$1 = {
  portal: !0,
  constrainSize: !0
}, CollapseOverflowMenu = forwardRef(function(props2, forwardedRef) {
  const $ = c(11), {
    disableRestoreFocusOnClose,
    menuButton,
    menuButtonProps,
    menuOptions,
    onMenuClose
  } = props2;
  let t0;
  $[0] !== menuOptions ? (t0 = menuOptions.map(_temp$2S), $[0] = menuOptions, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(Menu, { children: t0 }), $[2] = t0, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== disableRestoreFocusOnClose || $[5] !== forwardedRef || $[6] !== menuButton || $[7] !== menuButtonProps || $[8] !== onMenuClose || $[9] !== t1 ? (t2 = /* @__PURE__ */ jsx(MenuButton, { __unstable_disableRestoreFocusOnClose: disableRestoreFocusOnClose, id: "menu-button", ref: forwardedRef, onClose: onMenuClose, popover: MENU_BUTTON_POPOVER_PROPS$1, ...menuButtonProps, button: menuButton, menu: t1 }), $[4] = disableRestoreFocusOnClose, $[5] = forwardedRef, $[6] = menuButton, $[7] = menuButtonProps, $[8] = onMenuClose, $[9] = t1, $[10] = t2) : t2 = $[10], t2;
});
function _temp$2S(c2, index) {
  const {
    collapsedProps,
    expandedProps,
    tooltipProps,
    tooltipText,
    dividerBefore,
    fontSize,
    padding,
    text,
    icon,
    selected,
    ...rest
  } = c2.props;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    dividerBefore && index !== 0 && /* @__PURE__ */ jsx(MenuDivider, {}),
    /* @__PURE__ */ jsx(MenuItem, { text, icon, pressed: selected, "aria-pressed": selected, ...rest })
  ] }, c2.key);
}
function ObserveElement(props2) {
  const $ = c(14);
  let children, onIntersectionChange, options, rest;
  $[0] !== props2 ? ({
    onIntersectionChange,
    children,
    options,
    ...rest
  } = props2, $[0] = props2, $[1] = children, $[2] = onIntersectionChange, $[3] = options, $[4] = rest) : (children = $[1], onIntersectionChange = $[2], options = $[3], rest = $[4]);
  const [el, setEl] = useState(null);
  let t0, t1;
  $[5] !== el || $[6] !== onIntersectionChange || $[7] !== options ? (t0 = () => {
    const target = el?.closest('[data-ui="Flex"]');
    if (!target)
      return;
    const io = new IntersectionObserver(onIntersectionChange, options);
    return io.observe(target), () => {
      io.unobserve(target), io.disconnect();
    };
  }, t1 = [el, onIntersectionChange, options], $[5] = el, $[6] = onIntersectionChange, $[7] = options, $[8] = t0, $[9] = t1) : (t0 = $[8], t1 = $[9]), useEffect(t0, t1);
  let t2;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx("span", { hidden: !0, ref: setEl }), $[10] = t2) : t2 = $[10];
  let t3;
  return $[11] !== children || $[12] !== rest ? (t3 = /* @__PURE__ */ jsxs(Flex, { ...rest, children: [
    children,
    t2
  ] }), $[11] = children, $[12] = rest, $[13] = t3) : t3 = $[13], t3;
}
const FOCUS_RING_PADDING = 3, OPTION_STYLE = css`
  list-style: none;
  display: flex;
  white-space: nowrap;

  &[data-hidden='true'] {
    opacity: 0;
    visibility: hidden;
  }
`, OuterFlex = styled(Flex).withConfig({
  displayName: "OuterFlex",
  componentId: "sc-mju1i8-0"
})`padding:${FOCUS_RING_PADDING}px;margin:-${FOCUS_RING_PADDING}px;box-sizing:border-box;`, RootFlex$5 = styled(Flex).withConfig({
  displayName: "RootFlex",
  componentId: "sc-mju1i8-1"
})`border-radius:inherit;position:relative;`, RowFlex = styled(Flex).withConfig({
  displayName: "RowFlex",
  componentId: "sc-mju1i8-2"
})`width:max-content;&[data-hidden='true']{visibility:hidden;position:relative;margin-top:-1px;height:1px;}`, OptionObserveElement$1 = styled(ObserveElement).withConfig({
  displayName: "OptionObserveElement",
  componentId: "sc-mju1i8-3"
})`${OPTION_STYLE}`;
function _isReactElement$1(node) {
  return !!node;
}
const CollapseMenu = forwardRef(function(props2, ref) {
  const $ = c(25);
  let children, collapsed, disableRestoreFocusOnClose, menuButtonProps, onMenuClose, rest;
  $[0] !== props2 ? ({
    children,
    collapsed,
    disableRestoreFocusOnClose,
    onMenuClose,
    menuButtonProps,
    ...rest
  } = props2, $[0] = props2, $[1] = children, $[2] = collapsed, $[3] = disableRestoreFocusOnClose, $[4] = menuButtonProps, $[5] = onMenuClose, $[6] = rest) : (children = $[1], collapsed = $[2], disableRestoreFocusOnClose = $[3], menuButtonProps = $[4], onMenuClose = $[5], rest = $[6]);
  let t0;
  $[7] !== children ? (t0 = Children.toArray(children).filter(_isReactElement$1), $[7] = children, $[8] = t0) : t0 = $[8];
  const menuOptions = t0;
  let t1;
  $[9] !== menuButtonProps?.button ? (t1 = menuButtonProps?.button || /* @__PURE__ */ jsx(ContextMenuButton, {}), $[9] = menuButtonProps?.button, $[10] = t1) : t1 = $[10];
  const menuButton = t1;
  if (collapsed) {
    let t22;
    return $[11] !== disableRestoreFocusOnClose || $[12] !== menuButton || $[13] !== menuButtonProps || $[14] !== menuOptions || $[15] !== onMenuClose || $[16] !== ref ? (t22 = /* @__PURE__ */ jsx(CollapseOverflowMenu, { ref, disableRestoreFocusOnClose, menuButton, menuButtonProps, menuOptions, onMenuClose }), $[11] = disableRestoreFocusOnClose, $[12] = menuButton, $[13] = menuButtonProps, $[14] = menuOptions, $[15] = onMenuClose, $[16] = ref, $[17] = t22) : t22 = $[17], t22;
  }
  let t2;
  return $[18] !== disableRestoreFocusOnClose || $[19] !== menuButtonProps || $[20] !== menuOptions || $[21] !== onMenuClose || $[22] !== ref || $[23] !== rest ? (t2 = /* @__PURE__ */ jsx(AutoCollapseMenu, { ...rest, ref, disableRestoreFocusOnClose, menuButtonProps, menuOptions, onMenuClose }), $[18] = disableRestoreFocusOnClose, $[19] = menuButtonProps, $[20] = menuOptions, $[21] = onMenuClose, $[22] = ref, $[23] = rest, $[24] = t2) : t2 = $[24], t2;
}), AutoCollapseMenu = forwardRef(function(props2, ref) {
  const $ = c(74);
  let disableRestoreFocusOnClose, gap, menuButtonProps, menuOptions, onMenuClose, rest, t0;
  $[0] !== props2 ? ({
    collapseText: t0,
    disableRestoreFocusOnClose,
    gap,
    menuOptions,
    menuButtonProps,
    onMenuClose,
    ...rest
  } = props2, $[0] = props2, $[1] = disableRestoreFocusOnClose, $[2] = gap, $[3] = menuButtonProps, $[4] = menuOptions, $[5] = onMenuClose, $[6] = rest, $[7] = t0) : (disableRestoreFocusOnClose = $[1], gap = $[2], menuButtonProps = $[3], menuOptions = $[4], onMenuClose = $[5], rest = $[6], t0 = $[7]);
  const collapseText = t0 === void 0 ? !0 : t0, [rootEl, setRootEl] = useState(null);
  let t1;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {}, $[8] = t1) : t1 = $[8];
  const [expandedIntersections, setExpandedIntersections] = useState(t1);
  let t2;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {}, $[9] = t2) : t2 = $[9];
  const [collapsedIntersections, setCollapsedIntersections] = useState(t2);
  let t3;
  $[10] !== rootEl ? (t3 = {
    root: rootEl,
    threshold: 0.99,
    rootMargin: "2px"
  }, $[10] = rootEl, $[11] = t3) : t3 = $[11];
  const intersectionOptions = t3;
  let t4;
  $[12] !== menuOptions ? (t4 = menuOptions.map(_temp$2R), $[12] = menuOptions, $[13] = t4) : t4 = $[13];
  const menuOptionKeys = t4;
  let t5;
  $[14] !== collapsedIntersections || $[15] !== expandedIntersections || $[16] !== menuOptionKeys ? (t5 = [...difference(menuOptionKeys, Object.keys(expandedIntersections)), ...difference(menuOptionKeys, Object.keys(collapsedIntersections))], $[14] = collapsedIntersections, $[15] = expandedIntersections, $[16] = menuOptionKeys, $[17] = t5) : t5 = $[17];
  const pendingIntersections = t5;
  let t6;
  if ($[18] !== expandedIntersections || $[19] !== menuOptions) {
    let t72;
    $[21] !== expandedIntersections ? (t72 = (optionElement) => {
      const entry = expandedIntersections[optionElement.key];
      return entry && !entry.intersects;
    }, $[21] = expandedIntersections, $[22] = t72) : t72 = $[22], t6 = menuOptions.filter(t72), $[18] = expandedIntersections, $[19] = menuOptions, $[20] = t6;
  } else
    t6 = $[20];
  const overflowingExpandedElements = t6;
  let t7;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = (e, element) => {
    setExpandedIntersections((current) => {
      const key = element.key;
      if (key === null)
        throw new Error("Expected element to have a non-null key");
      const nextState = {
        intersects: e.isIntersecting,
        element
      }, currentState = current[key];
      return !currentState || currentState.intersects !== nextState.intersects ? {
        ...current,
        [key]: nextState
      } : current;
    });
  }, $[23] = t7) : t7 = $[23];
  const handleExpandedIntersection = t7;
  let t8;
  $[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = (e_0, element_0) => {
    setCollapsedIntersections((current_0) => {
      const key_0 = element_0.key;
      if (key_0 === null)
        throw new Error("Expected child element to have a non-null key");
      const currentElementIntersection = current_0[key_0], nextElementIntersection = {
        intersects: e_0.isIntersecting,
        element: element_0
      };
      return currentElementIntersection?.intersects === nextElementIntersection.intersects ? current_0 : {
        ...current_0,
        [key_0]: nextElementIntersection
      };
    });
  }, $[24] = t8) : t8 = $[24];
  const handleCollapsedIntersection = t8;
  let t9;
  if ($[25] !== collapseText || $[26] !== menuOptions) {
    let t102;
    $[28] !== collapseText ? (t102 = (optionElement_0) => {
      const {
        collapsedProps
      } = optionElement_0.props, modeProps = collapsedProps, text = collapseText ? void 0 : optionElement_0.props.text;
      return cloneElement(optionElement_0, {
        ...modeProps,
        text
      });
    }, $[28] = collapseText, $[29] = t102) : t102 = $[29], t9 = menuOptions.map(t102), $[25] = collapseText, $[26] = menuOptions, $[27] = t9;
  } else
    t9 = $[27];
  const collapsedElements = t9;
  let t10;
  if ($[30] !== collapsedIntersections || $[31] !== menuOptions) {
    let t112;
    $[33] !== collapsedIntersections ? (t112 = (optionElement_1) => !collapsedIntersections[optionElement_1.key]?.intersects, $[33] = collapsedIntersections, $[34] = t112) : t112 = $[34], t10 = menuOptions.filter(t112), $[30] = collapsedIntersections, $[31] = menuOptions, $[32] = t10;
  } else
    t10 = $[32];
  const overflowingCollapsedOptionElements = t10, shouldCollapse = overflowingExpandedElements.length > 0;
  let t11;
  $[35] !== collapsedElements || $[36] !== collapsedIntersections || $[37] !== menuOptions || $[38] !== shouldCollapse ? (t11 = shouldCollapse ? collapsedElements.filter((optionElement_2) => collapsedIntersections[optionElement_2.key]?.intersects) : menuOptions, $[35] = collapsedElements, $[36] = collapsedIntersections, $[37] = menuOptions, $[38] = shouldCollapse, $[39] = t11) : t11 = $[39];
  const visibleMenuOptions = t11;
  let t12;
  $[40] !== menuButtonProps?.button ? (t12 = menuButtonProps?.button || /* @__PURE__ */ jsx(ContextMenuButton, {}), $[40] = menuButtonProps?.button, $[41] = t12) : t12 = $[41];
  const menuButton = t12;
  let t13;
  $[42] !== expandedIntersections || $[43] !== overflowingCollapsedOptionElements || $[44] !== pendingIntersections.length || $[45] !== visibleMenuOptions ? (t13 = pendingIntersections.length === 0 && visibleMenuOptions.map((optionElement_3, index) => {
    const {
      dividerBefore,
      tooltipText: t142,
      tooltipProps: t152
    } = optionElement_3.props, tooltipText = t142 === void 0 ? "" : t142, tooltipProps = t152 === void 0 ? {} : t152, hidden = !optionElement_3.key || !(optionElement_3.key in expandedIntersections) || overflowingCollapsedOptionElements.includes(optionElement_3);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      dividerBefore && index !== 0 && /* @__PURE__ */ jsx(CollapseMenuDivider, { hidden }),
      /* @__PURE__ */ jsx(Tooltip, { portal: !0, disabled: !tooltipText, content: tooltipText, ...tooltipProps, children: /* @__PURE__ */ jsx(Flex, { children: cloneElement(optionElement_3, {
        disabled: optionElement_3.props.disabled || hidden,
        "aria-hidden": hidden
      }) }) })
    ] }, optionElement_3.key);
  }), $[42] = expandedIntersections, $[43] = overflowingCollapsedOptionElements, $[44] = pendingIntersections.length, $[45] = visibleMenuOptions, $[46] = t13) : t13 = $[46];
  let t14;
  $[47] !== gap || $[48] !== t13 ? (t14 = /* @__PURE__ */ jsx(RowFlex, { gap, children: t13 }), $[47] = gap, $[48] = t13, $[49] = t14) : t14 = $[49];
  let t15;
  $[50] !== gap || $[51] !== intersectionOptions || $[52] !== menuOptions ? (t15 = /* @__PURE__ */ jsx(RenderHidden, { gap, elements: menuOptions, intersectionOptions, onIntersectionChange: handleExpandedIntersection }), $[50] = gap, $[51] = intersectionOptions, $[52] = menuOptions, $[53] = t15) : t15 = $[53];
  let t16;
  $[54] !== collapsedElements || $[55] !== gap || $[56] !== intersectionOptions ? (t16 = /* @__PURE__ */ jsx(RenderHidden, { gap, elements: collapsedElements, intersectionOptions, onIntersectionChange: handleCollapsedIntersection }), $[54] = collapsedElements, $[55] = gap, $[56] = intersectionOptions, $[57] = t16) : t16 = $[57];
  let t17;
  $[58] !== t14 || $[59] !== t15 || $[60] !== t16 ? (t17 = /* @__PURE__ */ jsxs(RootFlex$5, { direction: "column", flex: 1, justify: "center", ref: setRootEl, children: [
    t14,
    t15,
    t16
  ] }), $[58] = t14, $[59] = t15, $[60] = t16, $[61] = t17) : t17 = $[61];
  let t18;
  $[62] !== disableRestoreFocusOnClose || $[63] !== gap || $[64] !== menuButton || $[65] !== menuButtonProps || $[66] !== onMenuClose || $[67] !== overflowingCollapsedOptionElements ? (t18 = overflowingCollapsedOptionElements.length > 0 && /* @__PURE__ */ jsx(Flex, { marginLeft: gap, children: /* @__PURE__ */ jsx(CollapseOverflowMenu, { disableRestoreFocusOnClose, menuButton, menuButtonProps, menuOptions: overflowingCollapsedOptionElements, onMenuClose }) }), $[62] = disableRestoreFocusOnClose, $[63] = gap, $[64] = menuButton, $[65] = menuButtonProps, $[66] = onMenuClose, $[67] = overflowingCollapsedOptionElements, $[68] = t18) : t18 = $[68];
  let t19;
  return $[69] !== ref || $[70] !== rest || $[71] !== t17 || $[72] !== t18 ? (t19 = /* @__PURE__ */ jsxs(OuterFlex, { align: "center", "data-ui": "CollapseMenu", overflow: "hidden", sizing: "border", ref, ...rest, children: [
    t17,
    t18
  ] }), $[69] = ref, $[70] = rest, $[71] = t17, $[72] = t18, $[73] = t19) : t19 = $[73], t19;
}), RenderHidden = memo(function(props2) {
  const $ = c(10), {
    elements,
    gap,
    intersectionOptions,
    onIntersectionChange
  } = props2;
  let t0;
  if ($[0] !== elements || $[1] !== intersectionOptions || $[2] !== onIntersectionChange) {
    let t12;
    $[4] !== intersectionOptions || $[5] !== onIntersectionChange ? (t12 = (element, index) => {
      const {
        dividerBefore
      } = element.props;
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        dividerBefore && index !== 0 && /* @__PURE__ */ jsx(CollapseMenuDivider, { hidden: !0 }),
        /* @__PURE__ */ jsx(OptionObserveElement$1, { options: intersectionOptions, onIntersectionChange: (e) => onIntersectionChange(e[0], element), children: /* @__PURE__ */ jsx(Flex, { children: cloneElement(element, {
          disabled: !0,
          "aria-hidden": !0
        }) }) })
      ] }, element.key);
    }, $[4] = intersectionOptions, $[5] = onIntersectionChange, $[6] = t12) : t12 = $[6], t0 = elements.map(t12), $[0] = elements, $[1] = intersectionOptions, $[2] = onIntersectionChange, $[3] = t0;
  } else
    t0 = $[3];
  let t1;
  return $[7] !== gap || $[8] !== t0 ? (t1 = /* @__PURE__ */ jsx(RowFlex, { "data-hidden": !0, "aria-hidden": "true", gap, overflow: "hidden", children: t0 }), $[7] = gap, $[8] = t0, $[9] = t1) : t1 = $[9], t1;
});
function _temp$2R(child) {
  return child.key;
}
const CollapseMenuButton = forwardRef(function(props2, ref) {
  const $ = c(5);
  let rest;
  if ($[0] !== props2) {
    const {
      collapsedProps,
      expandedProps,
      tooltipProps,
      tooltipText,
      dividerBefore,
      ...t02
    } = props2;
    rest = t02, $[0] = props2, $[1] = rest;
  } else
    rest = $[1];
  let t0;
  return $[2] !== ref || $[3] !== rest ? (t0 = /* @__PURE__ */ jsx(Button, { "data-ui": "CollapseMenuButton", ...rest, ref }), $[2] = ref, $[3] = rest, $[4] = t0) : t0 = $[4], t0;
}), CustomIconDiv = styled.div.withConfig({
  displayName: "CustomIconDiv",
  componentId: "sc-1qvcmvu-0"
})`width:1em;height:1em;border-radius:inherit;background-origin:content-box;background-position:center;background-repeat:no-repeat;background-size:cover;transform:scale(0.7);`;
function CustomIcon(props2) {
  const $ = c(5), {
    icon,
    active
  } = props2, t0 = `url(${icon})`, t1 = active ? "invert(100%)" : "invert(0%)";
  let t2;
  $[0] !== t0 || $[1] !== t1 ? (t2 = {
    backgroundImage: t0,
    filter: t1
  }, $[0] = t0, $[1] = t1, $[2] = t2) : t2 = $[2];
  const inlineStyle = t2;
  let t3;
  return $[3] !== inlineStyle ? (t3 = /* @__PURE__ */ jsx(CustomIconDiv, { style: inlineStyle }), $[3] = inlineStyle, $[4] = t3) : t3 = $[4], t3;
}
function getPTEFormatActions(editor2, schemaTypes, disabled, hotkeyOpts, t) {
  return schemaTypes.decorators.map((decorator) => {
    const shortCutKey = Object.keys(hotkeyOpts.marks || {}).find((key) => hotkeyOpts.marks?.[key] === decorator.value);
    let hotkeys = [];
    return shortCutKey && (hotkeys = [shortCutKey]), {
      type: "format",
      disabled,
      icon: decorator?.icon,
      key: decorator.value,
      handle: () => {
        PortableTextEditor.toggleMark(editor2, decorator.value), PortableTextEditor.focus(editor2);
      },
      hotkeys,
      title: decorator.i18nTitleKey && t ? t(decorator.i18nTitleKey) : decorator.title
    };
  });
}
function getPTEListActions(editor2, schemaTypes, disabled, t) {
  return schemaTypes.lists.map((listItem) => ({
    type: "listStyle",
    key: listItem.value,
    disabled,
    icon: listItem?.icon,
    handle: () => {
      PortableTextEditor.toggleList(editor2, listItem.value);
    },
    title: listItem.i18nTitleKey && t ? t(listItem.i18nTitleKey) : listItem.title
  }));
}
function getAnnotationIcon(type) {
  return get(type, "icon") || get(type, "type.icon") || get(type, "type.to.icon") || get(type, "type.to[0].icon");
}
function getPTEAnnotationActions(editor2, schemaTypes, disabled, onInsert, t) {
  const focusChild = PortableTextEditor.focusChild(editor2), hasText = focusChild && focusChild.text;
  return schemaTypes.annotations.map((aType) => ({
    type: "annotation",
    disabled: !hasText || disabled,
    icon: getAnnotationIcon(aType),
    key: aType.name,
    handle: (active) => {
      active ? (PortableTextEditor.removeAnnotation(editor2, aType), PortableTextEditor.focus(editor2)) : onInsert(aType);
    },
    title: aType.i18nTitleKey && t ? t(aType.i18nTitleKey) : aType.title || capitalize(aType.name)
  }));
}
function getPTEToolbarActionGroups(editor2, options) {
  const {
    schemaTypes,
    disabled,
    onInsertAnnotation,
    hotkeyOpts,
    t
  } = options;
  return [{
    name: "format",
    actions: getPTEFormatActions(editor2, schemaTypes, disabled, hotkeyOpts, t)
  }, {
    name: "list",
    actions: getPTEListActions(editor2, schemaTypes, disabled, t)
  }, {
    name: "annotation",
    actions: getPTEAnnotationActions(editor2, schemaTypes, disabled, onInsertAnnotation, t)
  }];
}
function getBlockStyles(types) {
  return types.styles.map((style) => ({
    key: `style-${style.value}`,
    style: style.value,
    styleComponent: style && style.component,
    title: style.title,
    i18nTitleKey: style.i18nTitleKey
  }));
}
function getInsertMenuIcon(type, fallbackIcon) {
  const referenceIcon = get(type, "to[0].icon");
  return type.icon || type.type && type.type.icon || referenceIcon || fallbackIcon;
}
function getInsertMenuItems(types, disabled, onInsertBlock, onInsertInline) {
  const blockItems = types.blockObjects.map((type, index) => ({
    handle: () => onInsertBlock(type),
    icon: getInsertMenuIcon(type, BlockElementIcon),
    inline: !1,
    key: `block-${index}`,
    type
  })), inlineItems = types.inlineObjects.map((type, index) => ({
    handle: () => onInsertInline(type),
    icon: getInsertMenuIcon(type, InlineElementIcon),
    inline: !0,
    key: `inline-${index}`,
    type
  }));
  return blockItems.concat(inlineItems).filter((item) => !item.type?.hidden);
}
const annotationIcons = {
  link: LinkIcon
}, formatIcons = {
  strong: BoldIcon,
  em: ItalicIcon,
  "strike-through": StrikethroughIcon,
  underline: UnderlineIcon,
  code: CodeIcon
}, listStyleIcons = {
  number: OlistIcon,
  bullet: UlistIcon
}, ActionIcon = (t0) => {
  const $ = c(2), {
    action
  } = t0, Icon2 = action.icon;
  if (isValidElementType(Icon2)) {
    let t1;
    return $[0] !== Icon2 ? (t1 = /* @__PURE__ */ jsx(Icon2, {}), $[0] = Icon2, $[1] = t1) : t1 = $[1], t1;
  }
  return isValidElement(Icon2) ? Icon2 : null;
};
function getActionIcon(action, active) {
  return action.icon ? typeof action.icon == "string" ? /* @__PURE__ */ jsx(CustomIcon, { active, icon: action.icon }) : /* @__PURE__ */ jsx("span", { "data-sanity-icon": !0, style: {
    display: "contents"
  }, children: /* @__PURE__ */ jsx(ActionIcon, { action }) }) : action.type === "annotation" ? annotationIcons[action.key] || UnknownIcon : action.type === "listStyle" ? listStyleIcons[action.key] || UnknownIcon : formatIcons[action.key] || UnknownIcon;
}
function useFocusBlock() {
  const $ = c(3), editor2 = usePortableTextEditor(), selection = usePortableTextEditorSelection();
  let t0;
  return $[0] !== editor2 || $[1] !== selection ? (t0 = selection ? PortableTextEditor.focusBlock(editor2) : void 0, $[0] = editor2, $[1] = selection, $[2] = t0) : t0 = $[2], t0;
}
function useActionGroups(t0) {
  const $ = c(11), {
    hotkeys,
    onMemberOpen,
    resolveInitialValue: resolveInitialValue2,
    disabled
  } = t0, editor2 = usePortableTextEditor(), schemaTypes = usePortableTextMemberSchemaTypes(), {
    t
  } = useTranslation();
  let t1;
  $[0] !== editor2 || $[1] !== onMemberOpen || $[2] !== resolveInitialValue2 ? (t1 = async (schemaType) => {
    const initialValue = await resolveInitialValue2(schemaType), paths = PortableTextEditor.addAnnotation(editor2, schemaType, initialValue);
    paths && paths.markDefPath && onMemberOpen(paths.markDefPath);
  }, $[0] = editor2, $[1] = onMemberOpen, $[2] = resolveInitialValue2, $[3] = t1) : t1 = $[3];
  const handleInsertAnnotation = t1;
  let t2;
  return $[4] !== disabled || $[5] !== editor2 || $[6] !== handleInsertAnnotation || $[7] !== hotkeys || $[8] !== schemaTypes || $[9] !== t ? (t2 = editor2 ? getPTEToolbarActionGroups(editor2, {
    schemaTypes,
    disabled,
    onInsertAnnotation: handleInsertAnnotation,
    hotkeyOpts: hotkeys,
    t
  }) : [], $[4] = disabled, $[5] = editor2, $[6] = handleInsertAnnotation, $[7] = hotkeys, $[8] = schemaTypes, $[9] = t, $[10] = t2) : t2 = $[10], t2;
}
function useActiveActionKeys(t0) {
  const $ = c(4), {
    actions
  } = t0, editor2 = usePortableTextEditor(), selection = usePortableTextEditorSelection();
  let t1;
  return $[0] !== actions || $[1] !== editor2 || $[2] !== selection ? (t1 = selection ? actions.filter((a) => a.type === "annotation" ? PortableTextEditor.isAnnotationActive(editor2, a.key) : a.type === "listStyle" ? PortableTextEditor.hasListStyle(editor2, a.key) : PortableTextEditor.isMarkActive(editor2, a.key)).map(_temp$2Q) : [], $[0] = actions, $[1] = editor2, $[2] = selection, $[3] = t1) : t1 = $[3], useUnique(t1);
}
function _temp$2Q(a_0) {
  return a_0.key;
}
function useActiveStyleKeys(t0) {
  const $ = c(5), {
    items
  } = t0, editor2 = usePortableTextEditor(), focusBlock = useFocusBlock(), selection = usePortableTextEditorSelection();
  let t1;
  return $[0] !== editor2 || $[1] !== focusBlock || $[2] !== items || $[3] !== selection ? (t1 = focusBlock && selection ? items.filter((i) => PortableTextEditor.hasBlockStyle(editor2, i.style)).map(_temp2$1e) : [], $[0] = editor2, $[1] = focusBlock, $[2] = items, $[3] = selection, $[4] = t1) : t1 = $[4], useUnique(t1);
}
function _temp2$1e(i_0) {
  return i_0.style;
}
const CollapseMenuMemo$1 = memo(CollapseMenu), MENU_POPOVER_PROPS$3 = {
  constrainSize: !0,
  portal: !0
}, ActionMenu = memo(function(props2) {
  const $ = c(33), {
    disabled: disabledProp,
    groups,
    isFullscreen,
    collapsed
  } = props2, focusBlock = useFocusBlock(), editor2 = usePortableTextEditor(), schemaTypes = usePortableTextMemberSchemaTypes(), selection = usePortableTextEditorSelection(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== selection ? (t0 = selection && isKeySegment(selection.anchor.path[0]) && isKeySegment(selection.focus.path[0]) ? selection.anchor.path[0]._key !== selection?.focus.path[0]._key : selection?.anchor.path[0] !== selection?.focus.path[0], $[0] = selection, $[1] = t0) : t0 = $[1];
  const isSelectingMultipleBlocks = t0, isVoidBlock = focusBlock?._type !== schemaTypes.block.name, isEmptyTextBlock = !isVoidBlock && Array.isArray(focusBlock.children) && focusBlock.children.length === 1 && focusBlock?.children[0].text === "", disabled = disabledProp || isVoidBlock;
  let t1;
  $[2] !== groups ? (t1 = groups.reduce(_temp2$1d, []), $[2] = groups, $[3] = t1) : t1 = $[3];
  const actions = t1;
  let t2;
  $[4] !== actions ? (t2 = {
    actions
  }, $[4] = actions, $[5] = t2) : t2 = $[5];
  const activeKeys = useActiveActionKeys(t2);
  let t3;
  $[6] !== editor2 ? (t3 = () => {
    PortableTextEditor.focus(editor2);
  }, $[6] = editor2, $[7] = t3) : t3 = $[7];
  const handleMenuClose = t3, tooltipPlacement = isFullscreen ? "bottom" : "top";
  let t4;
  if ($[8] !== actions || $[9] !== activeKeys || $[10] !== disabled || $[11] !== isEmptyTextBlock || $[12] !== isSelectingMultipleBlocks || $[13] !== t || $[14] !== tooltipPlacement) {
    let t52;
    $[16] !== activeKeys || $[17] !== disabled || $[18] !== isEmptyTextBlock || $[19] !== isSelectingMultipleBlocks || $[20] !== t || $[21] !== tooltipPlacement ? (t52 = (action_0) => {
      const annotationDisabled = action_0.type === "annotation" && (isEmptyTextBlock || isSelectingMultipleBlocks), annotationDisabledText = isEmptyTextBlock ? t("user-menu.action.portable-text.annotation-disabled_empty-block", {
        name: action_0.title || action_0.key
      }) : t("user-menu.action.portable-text.annotation-disabled_multiple-blocks", {
        name: action_0.title || action_0.key
      }), active = activeKeys.includes(action_0.key);
      return /* @__PURE__ */ jsx(CollapseMenuButton, { "aria-label": t("toolbar.portable-text.action-button-aria-label", {
        action: action_0.title || action_0.key
      }), "data-testid": `action-button-${action_0.key}`, disabled: disabled || annotationDisabled, mode: "bleed", dividerBefore: action_0.firstInGroup, icon: getActionIcon(action_0, active), onClick: () => action_0.handle(active), selected: active, text: action_0.title || action_0.key, tooltipText: annotationDisabled ? annotationDisabledText : action_0.title || action_0.key, tooltipProps: {
        disabled,
        placement: tooltipPlacement,
        portal: "default"
      } }, action_0.key);
    }, $[16] = activeKeys, $[17] = disabled, $[18] = isEmptyTextBlock, $[19] = isSelectingMultipleBlocks, $[20] = t, $[21] = tooltipPlacement, $[22] = t52) : t52 = $[22], t4 = actions.map(t52), $[8] = actions, $[9] = activeKeys, $[10] = disabled, $[11] = isEmptyTextBlock, $[12] = isSelectingMultipleBlocks, $[13] = t, $[14] = tooltipPlacement, $[15] = t4;
  } else
    t4 = $[15];
  const children = t4;
  let t5;
  $[23] !== tooltipPlacement ? (t5 = {
    placement: tooltipPlacement
  }, $[23] = tooltipPlacement, $[24] = t5) : t5 = $[24];
  let t6;
  $[25] !== disabled || $[26] !== t5 ? (t6 = {
    button: /* @__PURE__ */ jsx(ContextMenuButton, { "data-testid": "action-menu-button", disabled, tooltipProps: t5 }),
    popover: MENU_POPOVER_PROPS$3
  }, $[25] = disabled, $[26] = t5, $[27] = t6) : t6 = $[27];
  const menuButtonProps = t6;
  let t7;
  return $[28] !== children || $[29] !== collapsed || $[30] !== handleMenuClose || $[31] !== menuButtonProps ? (t7 = /* @__PURE__ */ jsx(CollapseMenuMemo$1, { "data-testid": "action-menu-auto-collapse-menu", collapsed, disableRestoreFocusOnClose: !0, gap: 1, menuButtonProps, onMenuClose: handleMenuClose, children }), $[28] = children, $[29] = collapsed, $[30] = handleMenuClose, $[31] = menuButtonProps, $[32] = t7) : t7 = $[32], t7;
});
function _temp$2P(action, actionIndex) {
  return actionIndex === 0 ? {
    ...action,
    firstInGroup: !0
  } : action;
}
function _temp2$1d(acc, group2) {
  return acc.concat(group2.actions.map(_temp$2P));
}
const MenuButtonMemo = memo(MenuButton), StyledMenuItem = styled(MenuItem$1).withConfig({
  displayName: "StyledMenuItem",
  componentId: "sc-11vkmsq-0"
})`&[data-selected]{[data-option='blockquote']{--card-border-color:var(--card-muted-fg-color);}}`, TEXT_STYLE_OPTIONS = {
  h1: (title) => /* @__PURE__ */ jsx(Heading1, { children: title }),
  h2: (title) => /* @__PURE__ */ jsx(Heading2, { children: title }),
  h3: (title) => /* @__PURE__ */ jsx(Heading3, { children: title }),
  h4: (title) => /* @__PURE__ */ jsx(Heading4, { children: title }),
  h5: (title) => /* @__PURE__ */ jsx(Heading5, { children: title }),
  h6: (title) => /* @__PURE__ */ jsx(Heading6, { children: title }),
  normal: (title) => /* @__PURE__ */ jsx(Normal, { children: title }),
  blockquote: (title) => /* @__PURE__ */ jsx(BlockQuote, { "data-option": "blockquote", children: title })
}, preventDefault = (event) => event.preventDefault(), emptyStyle = {
  key: "style-none",
  style: "",
  title: "No style",
  i18nTitleKey: "inputs.portable-text.style.none"
}, BlockStyleSelect = memo(function(props2) {
  const $ = c(49), {
    disabled,
    items: itemsProp,
    boundaryElement
  } = props2, editor2 = usePortableTextEditor(), schemaTypes = usePortableTextMemberSchemaTypes(), focusBlock = useFocusBlock(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== boundaryElement ? (t0 = {
    constrainSize: !0,
    placement: "bottom-start",
    portal: "default",
    referenceBoundary: boundaryElement
  }, $[0] = boundaryElement, $[1] = t0) : t0 = $[1];
  const popoverProperties = t0, _disabled = disabled || (focusBlock ? schemaTypes.block.name !== focusBlock._type : !1);
  let t1;
  $[2] !== itemsProp ? (t1 = {
    items: itemsProp
  }, $[2] = itemsProp, $[3] = t1) : t1 = $[3];
  const activeKeys = useActiveStyleKeys(t1);
  let _activeItems, _items;
  if ($[4] !== activeKeys || $[5] !== itemsProp) {
    let t22;
    if ($[8] !== activeKeys ? (t22 = (item) => activeKeys.includes(item.style), $[8] = activeKeys, $[9] = t22) : t22 = $[9], _activeItems = itemsProp.filter(t22), _items = itemsProp, _activeItems.length === 0 && _items.length > 1) {
      let t32;
      $[10] !== _items ? (t32 = _items.concat([emptyStyle]), $[10] = _items, $[11] = t32) : t32 = $[11], _items = t32, _activeItems.push(emptyStyle);
    }
    $[4] = activeKeys, $[5] = itemsProp, $[6] = _activeItems, $[7] = _items;
  } else
    _activeItems = $[6], _items = $[7];
  let t2;
  $[12] !== _activeItems || $[13] !== _items ? (t2 = {
    activeItems: _activeItems,
    items: _items
  }, $[12] = _activeItems, $[13] = _items, $[14] = t2) : t2 = $[14];
  const {
    activeItems,
    items
  } = t2;
  let t3;
  bb0: {
    if (activeItems.length > 1) {
      let t43;
      $[15] !== t ? (t43 = t("inputs.portable-text.style.multiple"), $[15] = t, $[16] = t43) : t43 = $[16], t3 = t43;
      break bb0;
    }
    if (activeItems.length !== 1) {
      let t43;
      $[17] !== t ? (t43 = emptyStyle.i18nTitleKey ? t(emptyStyle.i18nTitleKey) : emptyStyle.title, $[17] = t, $[18] = t43) : t43 = $[18], t3 = t43;
      break bb0;
    }
    let t42;
    $[19] !== activeItems[0].i18nTitleKey || $[20] !== activeItems[0].title || $[21] !== t ? (t42 = activeItems[0].i18nTitleKey ? t(activeItems[0].i18nTitleKey) : activeItems[0].title, $[19] = activeItems[0].i18nTitleKey, $[20] = activeItems[0].title, $[21] = t, $[22] = t42) : t42 = $[22], t3 = t42;
  }
  const menuButtonText = t3;
  let t4;
  $[23] !== editor2 || $[24] !== focusBlock ? (t4 = (item_0) => {
    focusBlock && item_0.style !== focusBlock.style && (PortableTextEditor.toggleBlockStyle(editor2, item_0.style), PortableTextEditor.focus(editor2));
  }, $[23] = editor2, $[24] = focusBlock, $[25] = t4) : t4 = $[25];
  const handleChange = t4;
  let t5;
  $[26] !== t ? (t5 = (item_1) => {
    const {
      style,
      styleComponent
    } = item_1, renderStyle = TEXT_STYLE_OPTIONS[style], title = item_1.i18nTitleKey ? t(item_1.i18nTitleKey) : item_1?.title || item_1.style, CustomComponent = typeof styleComponent == "function" ? styleComponent : void 0;
    return renderStyle && !CustomComponent ? renderStyle(title) : CustomComponent ? /* @__PURE__ */ jsx(CustomComponent, { children: title }) : /* @__PURE__ */ jsx(Text$1, { children: title });
  }, $[26] = t, $[27] = t5) : t5 = $[27];
  const renderOption = t5;
  let t6;
  $[28] !== _disabled || $[29] !== menuButtonText ? (t6 = /* @__PURE__ */ jsx(Button, { disabled: _disabled, iconRight: ChevronDownIcon, justify: "space-between", mode: "bleed", onClick: preventDefault, text: menuButtonText, width: "fill" }), $[28] = _disabled, $[29] = menuButtonText, $[30] = t6) : t6 = $[30];
  const button = t6;
  let t7;
  if ($[31] !== _disabled || $[32] !== activeItems || $[33] !== handleChange || $[34] !== items || $[35] !== renderOption) {
    let t82;
    $[37] !== _disabled || $[38] !== activeItems || $[39] !== handleChange || $[40] !== renderOption ? (t82 = (item_2) => /* @__PURE__ */ jsx(StyledMenuItem, { pressed: activeItems.includes(item_2), onClick: _disabled ? void 0 : () => handleChange(item_2), children: renderOption(item_2) }, item_2.key), $[37] = _disabled, $[38] = activeItems, $[39] = handleChange, $[40] = renderOption, $[41] = t82) : t82 = $[41], t7 = items.map(t82), $[31] = _disabled, $[32] = activeItems, $[33] = handleChange, $[34] = items, $[35] = renderOption, $[36] = t7;
  } else
    t7 = $[36];
  let t8;
  $[42] !== _disabled || $[43] !== t7 ? (t8 = /* @__PURE__ */ jsx(Menu, { disabled: _disabled, children: t7 }), $[42] = _disabled, $[43] = t7, $[44] = t8) : t8 = $[44];
  const menu = t8;
  let t9;
  return $[45] !== button || $[46] !== menu || $[47] !== popoverProperties ? (t9 = /* @__PURE__ */ jsx(MenuButtonMemo, { popover: popoverProperties, id: "block-style-select", button, menu }), $[45] = button, $[46] = menu, $[47] = popoverProperties, $[48] = t9) : t9 = $[48], t9;
}), CollapseMenuMemo = memo(CollapseMenu), MENU_POPOVER_PROPS$2 = {
  constrainSize: !0,
  portal: !0
}, InsertMenu = memo(function(props2) {
  const $ = c(23), {
    disabled,
    items,
    isFullscreen,
    collapsed
  } = props2, {
    t
  } = useTranslation(), focusBlock = useFocusBlock(), editor2 = usePortableTextEditor(), schemaTypes = usePortableTextMemberSchemaTypes(), isVoidFocus = focusBlock && focusBlock._type !== schemaTypes.block.name;
  let t0;
  $[0] !== editor2 ? (t0 = () => {
    PortableTextEditor.focus(editor2);
  }, $[0] = editor2, $[1] = t0) : t0 = $[1];
  const handleMenuClose = t0, tooltipPlacement = isFullscreen ? "bottom" : "top";
  let t1;
  if ($[2] !== disabled || $[3] !== isVoidFocus || $[4] !== items || $[5] !== t || $[6] !== tooltipPlacement) {
    let t22;
    $[8] !== disabled || $[9] !== isVoidFocus || $[10] !== t || $[11] !== tooltipPlacement ? (t22 = (item) => {
      const title = item.type.title || upperFirst(item.type.name);
      return /* @__PURE__ */ jsx(CollapseMenuButton, { "aria-label": t(item.inline ? "inputs.portable-text.action.insert-inline-object-aria-label" : "inputs.portable-text.action.insert-block-aria-label", {
        typeName: title
      }), mode: "bleed", disabled: disabled || isVoidFocus && item.inline || !!item.type.deprecated, "data-testid": `${item.type.name}-insert-menu-button`, icon: item.icon, onClick: item.handle, text: title, tooltipText: t(item.type.deprecated ? item.type.deprecated.reason : item.inline ? "inputs.portable-text.action.insert-inline-object" : "inputs.portable-text.action.insert-block", {
        typeName: title
      }), tooltipProps: {
        disabled,
        placement: tooltipPlacement,
        portal: "default"
      } }, item.key);
    }, $[8] = disabled, $[9] = isVoidFocus, $[10] = t, $[11] = tooltipPlacement, $[12] = t22) : t22 = $[12], t1 = items.map(t22), $[2] = disabled, $[3] = isVoidFocus, $[4] = items, $[5] = t, $[6] = tooltipPlacement, $[7] = t1;
  } else
    t1 = $[7];
  const children = t1;
  let t2;
  $[13] !== tooltipPlacement ? (t2 = {
    placement: tooltipPlacement
  }, $[13] = tooltipPlacement, $[14] = t2) : t2 = $[14];
  let t3;
  $[15] !== disabled || $[16] !== t2 ? (t3 = {
    button: /* @__PURE__ */ jsx(ContextMenuButton, { "data-testid": "insert-menu-button", disabled, tooltipProps: t2 }),
    popover: MENU_POPOVER_PROPS$2
  }, $[15] = disabled, $[16] = t2, $[17] = t3) : t3 = $[17];
  const menuButtonProps = t3;
  let t4;
  return $[18] !== children || $[19] !== collapsed || $[20] !== handleMenuClose || $[21] !== menuButtonProps ? (t4 = /* @__PURE__ */ jsx(CollapseMenuMemo, { "data-testid": "insert-menu-auto-collapse-menu", collapsed, collapseText: !1, disableRestoreFocusOnClose: !0, gap: 1, menuButtonProps, onMenuClose: handleMenuClose, children }), $[18] = children, $[19] = collapsed, $[20] = handleMenuClose, $[21] = menuButtonProps, $[22] = t4) : t4 = $[22], t4;
}), RootFlex$4 = styled(Flex).withConfig({
  displayName: "RootFlex",
  componentId: "sc-1wan29s-0"
})`width:100%;`, StyleSelectBox = styled(Box).withConfig({
  displayName: "StyleSelectBox",
  componentId: "sc-1wan29s-1"
})`width:8em;`, StyleSelectFlex = styled(Flex).withConfig({
  displayName: "StyleSelectFlex",
  componentId: "sc-1wan29s-2"
})`border-right:1px solid var(--card-border-color);`, ActionMenuBox = styled(Box).withConfig({
  displayName: "ActionMenuBox",
  componentId: "sc-1wan29s-3"
})`${({
  $withInsertMenu
}) => $withInsertMenu && css`
      max-width: max-content;
      border-right: 1px solid var(--card-border-color);
    `}`, FullscreenButtonBox = styled(Box).withConfig({
  displayName: "FullscreenButtonBox",
  componentId: "sc-1wan29s-4"
})`border-left:1px solid var(--card-border-color);`, SLOW_INITIAL_VALUE_LIMIT = 300, IS_MAC$1 = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), InnerToolbar = memo(function(t0) {
  const $ = c(47), {
    actionGroups,
    blockStyles,
    collapsible,
    disabled,
    insertMenuItems,
    isFullscreen,
    onToggleFullscreen
  } = t0, {
    t
  } = useTranslation(), showActionMenu = actionGroups.reduce(_temp$2O, 0) > 0, showInsertMenu = insertMenuItems.length > 0, [rootElement, setRootElement] = useState(null), rootElementRect = useElementRect(rootElement), collapsed = collapsible && rootElementRect ? rootElementRect?.width < 400 : !1, showBlockStyleSelect = blockStyles.length > 1;
  let t1;
  $[0] !== rootElement ? (t1 = {
    rootElement
  }, $[0] = rootElement, $[1] = t1) : t1 = $[1], useRovingFocus(t1);
  const preventEditorBlurOnToolbarMouseDown = _temp2$1c;
  let t2;
  $[2] !== blockStyles || $[3] !== collapsed || $[4] !== disabled || $[5] !== isFullscreen || $[6] !== rootElement || $[7] !== showBlockStyleSelect ? (t2 = showBlockStyleSelect && /* @__PURE__ */ jsx(StyleSelectFlex, { flex: collapsed ? 1 : void 0, children: /* @__PURE__ */ jsx(StyleSelectBox, { padding: isFullscreen ? 2 : 1, "data-testid": "block-style-select", children: /* @__PURE__ */ jsx(BlockStyleSelect, { disabled, items: blockStyles, boundaryElement: rootElement }) }) }), $[2] = blockStyles, $[3] = collapsed, $[4] = disabled, $[5] = isFullscreen, $[6] = rootElement, $[7] = showBlockStyleSelect, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== actionGroups || $[10] !== collapsed || $[11] !== disabled || $[12] !== isFullscreen || $[13] !== showActionMenu || $[14] !== showInsertMenu ? (t3 = showActionMenu && /* @__PURE__ */ jsx(ActionMenuBox, { flex: collapsed ? void 0 : 1, padding: isFullscreen ? 2 : 1, $withInsertMenu: showInsertMenu, children: /* @__PURE__ */ jsx(ActionMenu, { disabled, collapsed, groups: actionGroups, isFullscreen }) }), $[9] = actionGroups, $[10] = collapsed, $[11] = disabled, $[12] = isFullscreen, $[13] = showActionMenu, $[14] = showInsertMenu, $[15] = t3) : t3 = $[15];
  let t4;
  $[16] !== collapsed || $[17] !== disabled || $[18] !== insertMenuItems || $[19] !== isFullscreen || $[20] !== showInsertMenu ? (t4 = showInsertMenu && /* @__PURE__ */ jsx(Box, { flex: collapsed ? void 0 : 1, padding: isFullscreen ? 2 : 1, children: /* @__PURE__ */ jsx(InsertMenu, { disabled, collapsed, items: insertMenuItems, isFullscreen }) }), $[16] = collapsed, $[17] = disabled, $[18] = insertMenuItems, $[19] = isFullscreen, $[20] = showInsertMenu, $[21] = t4) : t4 = $[21];
  let t5;
  $[22] !== t3 || $[23] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { flex: 1, children: [
    t3,
    t4
  ] }), $[22] = t3, $[23] = t4, $[24] = t5) : t5 = $[24];
  const t6 = isFullscreen ? 2 : 1;
  let t7;
  $[25] !== t ? (t7 = t("inputs.portable-text.action.expand-editor"), $[25] = t, $[26] = t7) : t7 = $[26];
  const t8 = isFullscreen ? CollapseIcon : ExpandIcon, t9 = isFullscreen ? "fullscreen-button-collapse" : "fullscreen-button-expand", t10 = isFullscreen ? "inputs.portable-text.action.collapse-editor" : "inputs.portable-text.action.expand-editor";
  let t11;
  $[27] !== t || $[28] !== t10 ? (t11 = t(t10), $[27] = t, $[28] = t10, $[29] = t11) : t11 = $[29];
  let t12;
  $[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = [`${IS_MAC$1 ? "Cmd" : "Ctrl"}`, "Enter"], $[30] = t12) : t12 = $[30];
  const t13 = isFullscreen ? "bottom" : "top";
  let t14;
  $[31] !== t11 || $[32] !== t13 ? (t14 = {
    content: t11,
    hotkeys: t12,
    placement: t13,
    portal: "default"
  }, $[31] = t11, $[32] = t13, $[33] = t14) : t14 = $[33];
  let t15;
  $[34] !== onToggleFullscreen || $[35] !== t14 || $[36] !== t7 || $[37] !== t8 || $[38] !== t9 ? (t15 = /* @__PURE__ */ jsx(Button, { "aria-label": t7, icon: t8, "data-testid": t9, mode: "bleed", onClick: onToggleFullscreen, tooltipProps: t14 }), $[34] = onToggleFullscreen, $[35] = t14, $[36] = t7, $[37] = t8, $[38] = t9, $[39] = t15) : t15 = $[39];
  let t16;
  $[40] !== t15 || $[41] !== t6 ? (t16 = /* @__PURE__ */ jsx(FullscreenButtonBox, { padding: t6, children: t15 }), $[40] = t15, $[41] = t6, $[42] = t16) : t16 = $[42];
  let t17;
  return $[43] !== t16 || $[44] !== t2 || $[45] !== t5 ? (t17 = /* @__PURE__ */ jsxs(RootFlex$4, { align: "center", ref: setRootElement, onMouseDown: preventEditorBlurOnToolbarMouseDown, children: [
    t2,
    t5,
    t16
  ] }), $[43] = t16, $[44] = t2, $[45] = t5, $[46] = t17) : t17 = $[46], t17;
});
function Toolbar(props2) {
  const $ = c(30), {
    collapsible,
    hotkeys,
    isFullscreen,
    readOnly,
    onMemberOpen,
    onToggleFullscreen
  } = props2, editor2 = usePortableTextEditor(), schemaTypes = usePortableTextMemberSchemaTypes(), selection = usePortableTextEditorSelection(), resolveInitialValueForType2 = useResolveInitialValueForType(), disabled = readOnly || !selection, {
    push
  } = useToast();
  let t0;
  $[0] !== push || $[1] !== resolveInitialValueForType2 ? (t0 = (type) => {
    let isSlow = !1;
    const slowTimer = setTimeout(() => {
      isSlow = !0, push({
        id: "resolving-initial-value",
        status: "info",
        title: "Resolving initial value\u2026"
      });
    }, SLOW_INITIAL_VALUE_LIMIT);
    return resolveInitialValueForType2(type, {}).then((value) => (isSlow && push({
      id: "resolving-initial-value",
      status: "info",
      duration: 500,
      title: "Initial value resolved"
    }), value)).catch((error) => {
      push({
        title: "Could not resolve initial value",
        id: "resolving-initial-value",
        description: `Unable to resolve initial value for type: ${type.name}: ${error.message}.`,
        status: "error"
      });
    }).finally(() => clearTimeout(slowTimer));
  }, $[0] = push, $[1] = resolveInitialValueForType2, $[2] = t0) : t0 = $[2];
  const resolveInitialValue2 = t0;
  let t1;
  $[3] !== editor2 || $[4] !== onMemberOpen || $[5] !== resolveInitialValue2 ? (t1 = async (type_0) => {
    const initialValue = await resolveInitialValue2(type_0), path = PortableTextEditor.insertBlock(editor2, type_0, initialValue);
    path && onMemberOpen(path);
  }, $[3] = editor2, $[4] = onMemberOpen, $[5] = resolveInitialValue2, $[6] = t1) : t1 = $[6];
  const handleInsertBlock = t1;
  let t2;
  $[7] !== editor2 || $[8] !== onMemberOpen || $[9] !== resolveInitialValue2 ? (t2 = async (type_1) => {
    const initialValue_0 = await resolveInitialValue2(type_1), path_0 = PortableTextEditor.insertChild(editor2, type_1, initialValue_0);
    path_0 && onMemberOpen(path_0);
  }, $[7] = editor2, $[8] = onMemberOpen, $[9] = resolveInitialValue2, $[10] = t2) : t2 = $[10];
  const handleInsertInline = t2;
  let t3;
  $[11] !== hotkeys || $[12] !== onMemberOpen || $[13] !== resolveInitialValue2 ? (t3 = {
    hotkeys,
    onMemberOpen,
    resolveInitialValue: resolveInitialValue2,
    disabled: !0
  }, $[11] = hotkeys, $[12] = onMemberOpen, $[13] = resolveInitialValue2, $[14] = t3) : t3 = $[14];
  const actionGroups = useActionGroups(t3);
  let t4;
  $[15] !== schemaTypes ? (t4 = getBlockStyles(schemaTypes), $[15] = schemaTypes, $[16] = t4) : t4 = $[16];
  const blockStyles = t4;
  let t5;
  $[17] !== disabled || $[18] !== handleInsertBlock || $[19] !== handleInsertInline || $[20] !== schemaTypes ? (t5 = getInsertMenuItems(schemaTypes, disabled, handleInsertBlock, handleInsertInline), $[17] = disabled, $[18] = handleInsertBlock, $[19] = handleInsertInline, $[20] = schemaTypes, $[21] = t5) : t5 = $[21];
  const insertMenuItems = t5;
  let t6;
  return $[22] !== actionGroups || $[23] !== blockStyles || $[24] !== collapsible || $[25] !== disabled || $[26] !== insertMenuItems || $[27] !== isFullscreen || $[28] !== onToggleFullscreen ? (t6 = /* @__PURE__ */ jsx(InnerToolbar, { actionGroups, blockStyles, collapsible, disabled, insertMenuItems, isFullscreen, onToggleFullscreen }), $[22] = actionGroups, $[23] = blockStyles, $[24] = collapsible, $[25] = disabled, $[26] = insertMenuItems, $[27] = isFullscreen, $[28] = onToggleFullscreen, $[29] = t6) : t6 = $[29], t6;
}
function _temp$2O(acc, x) {
  return acc + x.actions.length;
}
function _temp2$1c(e) {
  e.preventDefault();
}
const noOutlineStyle = {
  outline: "none"
}, FORM_BUILDER_DEFAULT_ID = "root", PlaceholderWrapper$1 = /* @__PURE__ */ styled.span.withConfig({
  displayName: "PlaceholderWrapper",
  componentId: "sc-s03q5a-0"
})((props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return css`
    color: ${color.input.default.enabled.placeholder};
  `;
});
function Editor(props2) {
  const $ = c(56), {
    elementRef,
    hideToolbar,
    hotkeys,
    initialSelection,
    isActive,
    isFullscreen,
    isOneLine,
    onCopy,
    onItemOpen,
    onPaste,
    onToggleFullscreen,
    path,
    readOnly,
    rangeDecorations,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderChild: renderChild2,
    scrollElement,
    setPortalElement,
    setScrollElement,
    ariaDescribedBy
  } = props2, {
    id: id2
  } = useFormBuilder(), {
    t
  } = useTranslation(), {
    isTopLayer
  } = useLayer(), {
    element: boundaryElement
  } = useBoundaryElement();
  let t0;
  $[0] !== isFullscreen || $[1] !== isTopLayer || $[2] !== onToggleFullscreen ? (t0 = (event) => {
    !isTopLayer || !isFullscreen || event.key === "Escape" && onToggleFullscreen();
  }, $[0] = isFullscreen, $[1] = isTopLayer, $[2] = onToggleFullscreen, $[3] = t0) : t0 = $[3], useGlobalKeyDown(t0);
  let t1;
  $[4] !== t ? (t1 = () => /* @__PURE__ */ jsx(PlaceholderWrapper$1, { "data-testid": "pt-input-placeholder", children: t("inputs.portable-text.empty-placeholder") }), $[4] = t, $[5] = t1) : t1 = $[5];
  const renderPlaceholder = t1, spellCheck = useSpellCheck(), renderDecorator = _temp$2N, renderStyle = _temp2$1b, renderListItem = _temp3$B, scrollSelectionIntoView = useScrollSelectionIntoView(scrollElement);
  let t2;
  $[6] !== ariaDescribedBy || $[7] !== elementRef || $[8] !== hotkeys || $[9] !== initialSelection || $[10] !== onCopy || $[11] !== onPaste || $[12] !== rangeDecorations || $[13] !== renderAnnotation || $[14] !== renderBlock2 || $[15] !== renderChild2 || $[16] !== renderPlaceholder || $[17] !== scrollSelectionIntoView || $[18] !== spellCheck ? (t2 = {
    "aria-describedby": ariaDescribedBy,
    hotkeys,
    onCopy,
    onPaste,
    rangeDecorations,
    ref: elementRef,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderChild: renderChild2,
    renderDecorator,
    renderListItem,
    renderPlaceholder,
    renderStyle,
    scrollSelectionIntoView,
    selection: initialSelection,
    spellCheck,
    style: noOutlineStyle
  }, $[6] = ariaDescribedBy, $[7] = elementRef, $[8] = hotkeys, $[9] = initialSelection, $[10] = onCopy, $[11] = onPaste, $[12] = rangeDecorations, $[13] = renderAnnotation, $[14] = renderBlock2, $[15] = renderChild2, $[16] = renderPlaceholder, $[17] = scrollSelectionIntoView, $[18] = spellCheck, $[19] = t2) : t2 = $[19];
  const editableProps = t2;
  let t3;
  $[20] !== editableProps ? (t3 = /* @__PURE__ */ jsx(PortableTextEditable, { ...editableProps }), $[20] = editableProps, $[21] = t3) : t3 = $[21];
  const editable = t3;
  let t4;
  $[22] !== onItemOpen || $[23] !== path ? (t4 = (relativePath) => {
    onItemOpen(path.concat(relativePath));
  }, $[22] = onItemOpen, $[23] = path, $[24] = t4) : t4 = $[24];
  const handleToolBarOnMemberOpen = t4, collapsibleToolbar = id2 === FORM_BUILDER_DEFAULT_ID;
  let t5;
  $[25] !== collapsibleToolbar || $[26] !== handleToolBarOnMemberOpen || $[27] !== hideToolbar || $[28] !== hotkeys || $[29] !== isActive || $[30] !== isFullscreen || $[31] !== onToggleFullscreen || $[32] !== readOnly ? (t5 = isActive && !hideToolbar && /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsx(ToolbarCard, { "data-testid": "pt-editor__toolbar-card", shadow: 1, children: /* @__PURE__ */ jsx(Toolbar, { collapsible: collapsibleToolbar, hotkeys, isFullscreen, onMemberOpen: handleToolBarOnMemberOpen, onToggleFullscreen, readOnly }) }) }), $[25] = collapsibleToolbar, $[26] = handleToolBarOnMemberOpen, $[27] = hideToolbar, $[28] = hotkeys, $[29] = isActive, $[30] = isFullscreen, $[31] = onToggleFullscreen, $[32] = readOnly, $[33] = t5) : t5 = $[33];
  const t6 = readOnly ? "transparent" : "default", t7 = readOnly ? "transparent" : "default", t8 = isFullscreen ? scrollElement : boundaryElement;
  let t9;
  $[34] !== editable || $[35] !== t8 ? (t9 = /* @__PURE__ */ jsx(BoundaryElementProvider, { element: t8, children: editable }), $[34] = editable, $[35] = t8, $[36] = t9) : t9 = $[36];
  let t10;
  $[37] !== isFullscreen || $[38] !== isOneLine || $[39] !== t7 || $[40] !== t9 ? (t10 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(EditableWrapper, { $isFullscreen: isFullscreen, $isOneLine: isOneLine, tone: t7, children: t9 }) }), $[37] = isFullscreen, $[38] = isOneLine, $[39] = t7, $[40] = t9, $[41] = t10) : t10 = $[41];
  let t11;
  $[42] !== setScrollElement || $[43] !== t10 ? (t11 = /* @__PURE__ */ jsx(Scroller, { ref: setScrollElement, children: t10 }), $[42] = setScrollElement, $[43] = t10, $[44] = t11) : t11 = $[44];
  let t12;
  $[45] !== setPortalElement ? (t12 = /* @__PURE__ */ jsx("div", { "data-portal": "", ref: setPortalElement }), $[45] = setPortalElement, $[46] = t12) : t12 = $[46];
  let t13;
  $[47] !== t11 || $[48] !== t12 || $[49] !== t6 ? (t13 = /* @__PURE__ */ jsxs(EditableCard, { flex: 1, tone: t6, children: [
    t11,
    t12
  ] }), $[47] = t11, $[48] = t12, $[49] = t6, $[50] = t13) : t13 = $[50];
  let t14;
  return $[51] !== isFullscreen || $[52] !== isOneLine || $[53] !== t13 || $[54] !== t5 ? (t14 = /* @__PURE__ */ jsxs(Root$j, { "data-fullscreen": isFullscreen, "data-testid": "pt-editor", $isOneLine: isOneLine, children: [
    t5,
    t13
  ] }), $[51] = isFullscreen, $[52] = isOneLine, $[53] = t13, $[54] = t5, $[55] = t14) : t14 = $[55], t14;
}
function _temp3$B(listItemProps) {
  return /* @__PURE__ */ jsx(ListItem$1, { ...listItemProps });
}
function _temp2$1b(styleProps) {
  return /* @__PURE__ */ jsx(Style, { ...styleProps });
}
function _temp$2N(decoratorProps) {
  return /* @__PURE__ */ jsx(Decorator, { ...decoratorProps });
}
function useHotkeys(hotkeys) {
  const $ = c(12), schemaTypes = usePortableTextMemberSchemaTypes();
  let t0;
  $[0] !== hotkeys ? (t0 = () => hotkeys, $[0] = hotkeys, $[1] = t0) : t0 = $[1];
  const [initialHotkeys] = useState(t0);
  let defaultHotkeys;
  $[2] !== schemaTypes.decorators ? (defaultHotkeys = {
    marks: {}
  }, schemaTypes.decorators.forEach((dec2) => {
    bb5: switch (dec2.value) {
      case "strong": {
        defaultHotkeys.marks["mod+b"] = dec2.value;
        break bb5;
      }
      case "em": {
        defaultHotkeys.marks["mod+i"] = dec2.value;
        break bb5;
      }
      case "underline": {
        defaultHotkeys.marks["mod+u"] = dec2.value;
        break bb5;
      }
      case "code": {
        defaultHotkeys.marks["mod+'"] = dec2.value;
        break bb5;
      }
    }
  }), $[2] = schemaTypes.decorators, $[3] = defaultHotkeys) : defaultHotkeys = $[3];
  let t1;
  $[4] !== initialHotkeys ? (t1 = initialHotkeys || {}, $[4] = initialHotkeys, $[5] = t1) : t1 = $[5];
  let t2;
  $[6] !== defaultHotkeys.marks || $[7] !== t1.marks ? (t2 = {
    ...defaultHotkeys.marks,
    ...t1.marks
  }, $[6] = defaultHotkeys.marks, $[7] = t1.marks, $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== initialHotkeys.custom || $[10] !== t2 ? (t3 = {
    marks: t2,
    custom: initialHotkeys.custom
  }, $[9] = initialHotkeys.custom, $[10] = t2, $[11] = t3) : t3 = $[11], t3;
}
function useTrackFocusPath(props2) {
  const $ = c(15), {
    focusPath,
    boundaryElement,
    onItemClose
  } = props2, portableTextMemberItems = usePortableTextMemberItems(), elementRefs = usePortableTextMemberItemElementRefs(), editor2 = usePortableTextEditor(), selection = usePortableTextEditorSelection();
  let t0;
  $[0] !== boundaryElement || $[1] !== editor2 || $[2] !== elementRefs || $[3] !== focusPath || $[4] !== portableTextMemberItems || $[5] !== selection ? (t0 = () => {
    if (focusPath.length === 0 || selection?.focus.path && isEqual$2(selection.focus.path, focusPath.slice(0, selection.focus.path.length)))
      return;
    const focusedItem = portableTextMemberItems.find(_temp$2M), openItem = portableTextMemberItems.find(_temp2$1a), relatedEditorItem = focusedItem || openItem, elementRef = relatedEditorItem ? elementRefs[relatedEditorItem.member.key] : void 0;
    if (relatedEditorItem && elementRef) {
      boundaryElement && (scrollIntoView$1(boundaryElement, {
        scrollMode: "if-needed",
        block: "start",
        inline: "start"
      }), scrollIntoView$1(elementRef, {
        scrollMode: "if-needed",
        boundary: boundaryElement,
        block: "nearest",
        inline: "start"
      }));
      const isTextBlock = relatedEditorItem.kind === "textBlock", isBlockFocusPath = focusPath.length === 1;
      if (isTextBlock || isBlockFocusPath) {
        const textBlockChildKey = isTextBlock && isKeyedObject(focusPath[2]) ? focusPath[2]._key : void 0, child = textBlockChildKey && Array.isArray(relatedEditorItem.node.value?.children) ? relatedEditorItem.node.value?.children.find((c2) => c2._key === textBlockChildKey) : void 0, isSpanTextFocusPath = child && child._type === "span" && focusPath.length === 4 && focusPath[1] === "children" && focusPath[3] === "text" || !1, isTextChildFocusPath = isTextBlock && (focusPath.length === 3 && focusPath[1] === "children" || isSpanTextFocusPath);
        let path = [];
        isTextChildFocusPath ? path = focusPath.slice(0, 3) : isTextBlock && isBlockFocusPath && Array.isArray(relatedEditorItem.node.value?.children) ? path = [focusPath[0], "children", {
          _key: relatedEditorItem.node.value?.children[0]._key
        }] : isBlockFocusPath && (path = [{
          _key: relatedEditorItem.key
        }]), path.length && (PortableTextEditor.select(editor2, {
          anchor: {
            path,
            offset: 0
          },
          focus: {
            path,
            offset: 0
          }
        }), isTextBlock && PortableTextEditor.focus(editor2));
      }
    }
  }, $[0] = boundaryElement, $[1] = editor2, $[2] = elementRefs, $[3] = focusPath, $[4] = portableTextMemberItems, $[5] = selection, $[6] = t0) : t0 = $[6];
  const t1 = selection?.focus.path;
  let t2;
  $[7] !== boundaryElement || $[8] !== editor2 || $[9] !== elementRefs || $[10] !== focusPath || $[11] !== onItemClose || $[12] !== portableTextMemberItems || $[13] !== t1 ? (t2 = [boundaryElement, editor2, elementRefs, focusPath, onItemClose, portableTextMemberItems, t1], $[7] = boundaryElement, $[8] = editor2, $[9] = elementRefs, $[10] = focusPath, $[11] = onItemClose, $[12] = portableTextMemberItems, $[13] = t1, $[14] = t2) : t2 = $[14], useLayoutEffect(t0, t2);
}
function _temp2$1a(m_0) {
  return m_0.member.open;
}
function _temp$2M(m) {
  return m.member.item.focused;
}
const POPOVER_FALLBACK_PLACEMENTS$6 = ["top", "bottom"];
function CombinedAnnotationPopover(props2) {
  const $ = c(37), {
    floatingBoundary,
    referenceBoundary
  } = props2, {
    annotations
  } = useSelectedAnnotations(), [cursorRect, setCursorRect] = useState(null), [popoverOpen, setPopoverOpen] = useState(!1), rangeRef = useRef(null), {
    sanity
  } = useTheme(), {
    t
  } = useTranslation(), editor2 = usePortableTextEditor(), popoverScheme = sanity.color.dark ? "light" : "dark";
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ new Map(), $[0] = t0) : t0 = $[0];
  const buttonRefs = useRef(t0);
  let t1;
  bb0: {
    if (!cursorRect) {
      t1 = null;
      break bb0;
    }
    let t22;
    $[1] !== cursorRect ? (t22 = {
      getBoundingClientRect: () => cursorRect
    }, $[1] = cursorRect, $[2] = t22) : t22 = $[2], t1 = t22;
  }
  const cursorElement = t1;
  let t2;
  $[3] !== editor2 ? (t2 = () => {
    PortableTextEditor.focus(editor2), setPopoverOpen(!1);
  }, $[3] = editor2, $[4] = t2) : t2 = $[4];
  const handleClosePopover = t2;
  let t3;
  $[5] !== handleClosePopover || $[6] !== popoverOpen ? (t3 = (event) => {
    popoverOpen && event.key === "Escape" && handleClosePopover();
  }, $[5] = handleClosePopover, $[6] = popoverOpen, $[7] = t3) : t3 = $[7], useGlobalKeyDown(t3);
  let t4;
  $[8] !== annotations ? (t4 = () => {
    if (annotations.length === 0) {
      setPopoverOpen(!1), setCursorRect(null);
      return;
    }
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0)
      return;
    const range2 = sel.getRangeAt(0);
    if (!annotations.some((annotation) => annotation.referenceElement?.contains(range2.commonAncestorContainer))) {
      setPopoverOpen(!1), setCursorRect(null);
      return;
    }
    const rect = range2.getBoundingClientRect();
    rect && (setCursorRect(rect), setPopoverOpen(!0));
  }, $[8] = annotations, $[9] = t4) : t4 = $[9];
  const handleSelectionChange = t4;
  let t5, t6;
  $[10] !== handleSelectionChange ? (t5 = () => (document.addEventListener("selectionchange", handleSelectionChange, {
    passive: !0
  }), () => {
    document.removeEventListener("selectionchange", handleSelectionChange);
  }), t6 = [handleSelectionChange], $[10] = handleSelectionChange, $[11] = t5, $[12] = t6) : (t5 = $[11], t6 = $[12]), useEffect(t5, t6);
  let t7, t8;
  $[13] !== handleSelectionChange ? (t7 = () => {
    handleSelectionChange();
  }, t8 = [handleSelectionChange], $[13] = handleSelectionChange, $[14] = t7, $[15] = t8) : (t7 = $[14], t8 = $[15]), useEffect(t7, t8);
  let t9;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = () => {
    rangeRef.current && setCursorRect(rangeRef.current.getBoundingClientRect());
  }, $[16] = t9) : t9 = $[16];
  const handleScroll = t9;
  let t10;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    const sel_0 = window.getSelection();
    sel_0 && sel_0.rangeCount > 0 && (rangeRef.current = sel_0.getRangeAt(0));
  }, $[17] = t10) : t10 = $[17];
  let t11;
  $[18] !== popoverOpen ? (t11 = [popoverOpen], $[18] = popoverOpen, $[19] = t11) : t11 = $[19], useEffect(t10, t11);
  let t12, t13;
  if ($[20] !== floatingBoundary || $[21] !== popoverOpen || $[22] !== referenceBoundary ? (t12 = () => (popoverOpen && (floatingBoundary?.addEventListener("scroll", handleScroll), referenceBoundary?.addEventListener("scroll", handleScroll)), () => {
    floatingBoundary?.removeEventListener("scroll", handleScroll), referenceBoundary?.removeEventListener("scroll", handleScroll);
  }), t13 = [popoverOpen, referenceBoundary, floatingBoundary, handleScroll], $[20] = floatingBoundary, $[21] = popoverOpen, $[22] = referenceBoundary, $[23] = t12, $[24] = t13) : (t12 = $[23], t13 = $[24]), useEffect(t12, t13), annotations.length === 0 || !cursorElement)
    return null;
  let t14;
  $[25] !== annotations || $[26] !== t ? (t14 = annotations.map((annotation_0, index) => /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", children: [
    /* @__PURE__ */ jsx(Box, { padding: 2, flex: 1, children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: annotation_0.title }) }),
    /* @__PURE__ */ jsx(Button, { "aria-label": t("inputs.portable-text.action.edit-annotation-aria-label"), "data-testid": index === 0 ? "edit-annotation-button" : `edit-annotation-button-${index}`, icon: EditIcon, mode: "bleed", onClick: () => {
      setPopoverOpen(!1), annotation_0.onOpen();
    }, ref: (el) => {
      el && buttonRefs.current.set(`edit-${annotation_0.key}`, el);
    }, tabIndex: 0, tooltipProps: null }),
    /* @__PURE__ */ jsx(Button, { "aria-label": t("inputs.portable-text.action.remove-annotation-aria-label"), "data-testid": index === 0 ? "remove-annotation-button" : `remove-annotation-button-${index}`, icon: TrashIcon, mode: "bleed", onClick: () => {
      setPopoverOpen(!1), annotation_0.onRemove();
    }, ref: (el_0) => {
      el_0 && buttonRefs.current.set(`delete-${annotation_0.key}`, el_0);
    }, tabIndex: 0, tone: "critical", tooltipProps: null })
  ] }, annotation_0.key)), $[25] = annotations, $[26] = t, $[27] = t14) : t14 = $[27];
  let t15;
  $[28] !== t14 ? (t15 = /* @__PURE__ */ jsx(Box, { padding: 1, "data-testid": "annotation-toolbar-popover", children: t14 }), $[28] = t14, $[29] = t15) : t15 = $[29];
  let t16;
  return $[30] !== cursorElement || $[31] !== floatingBoundary || $[32] !== popoverOpen || $[33] !== popoverScheme || $[34] !== referenceBoundary || $[35] !== t15 ? (t16 = /* @__PURE__ */ jsx(Popover, { open: popoverOpen, floatingBoundary, constrainSize: !0, content: t15, fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$6, placement: "top", portal: !0, preventOverflow: !0, referenceBoundary, referenceElement: cursorElement, scheme: popoverScheme }), $[30] = cursorElement, $[31] = floatingBoundary, $[32] = popoverOpen, $[33] = popoverScheme, $[34] = referenceBoundary, $[35] = t15, $[36] = t16) : t16 = $[36], t16;
}
const Root$i = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-1mrg8r-0"
})(rootStyle), PreviewSpan = styled.span.withConfig({
  displayName: "PreviewSpan",
  componentId: "sc-1mrg8r-1"
})`display:block;max-width:calc(5em + 80px);position:relative;`, TooltipBox$1 = styled(Box).withConfig({
  displayName: "TooltipBox",
  componentId: "sc-1mrg8r-2"
})`max-width:250px;`;
function rootStyle({
  theme
}) {
  const {
    color,
    radius
  } = theme.sanity;
  return css`
    line-height: 0;
    border-radius: ${radius[2]}px;
    padding: 2px;
    box-shadow: inset 0 0 0 1px var(--card-border-color);
    height: calc(1em - 1px);
    cursor: default;

    &:not([hidden]) {
      display: inline-flex;
      align-items: center;
      vertical-align: text-bottom;
      margin-inline: 2px;
    }

    &[data-ready-only] {
      cursor: default;
    }

    &[data-focused] {
      box-shadow: inset 0 0 0 1px ${color.selectable?.primary.selected.border};
      color: ${color.selectable?.primary.pressed.fg};
    }

    &[data-selected] {
      background-color: ${color.selectable?.primary.pressed.bg};
    }

    &:not([data-focused]):not([data-selected]) {
      @media (hover: hover) {
        &:hover {
          --card-border-color: ${color.input.default.hovered.border};
        }
      }
    }

    &[data-markers] {
      --card-bg-color: ${color.dark ? hues.purple[950].hex : hues.purple[50].hex};
    }

    &[data-warning] {
      --card-bg-color: ${color.muted.caution.hovered.bg};

      @media (hover: hover) {
        &:hover {
          --card-border-color: ${color.muted.caution.hovered.border};
        }
      }
    }

    &[data-invalid] {
      --card-bg-color: ${color.input.invalid.enabled.bg};
      --card-border-color: ${color.input.invalid.enabled.border};

      @media (hover: hover) {
        &:hover {
          --card-border-color: ${color.input.invalid.hovered.border};
        }
      }
    }
  `;
}
const POPOVER_FALLBACK_PLACEMENTS$5 = ["top", "bottom"];
function InlineObjectToolbarPopover(props2) {
  const $ = c(48), {
    floatingBoundary,
    inlineObjectFocused,
    inlineObjectOpen,
    onOpenInlineObject,
    onRemoveInlineObject,
    referenceBoundary,
    referenceElement,
    title
  } = props2, [popoverOpen, setPopoverOpen] = useState(!1), {
    sanity
  } = useTheme(), {
    t
  } = useTranslation(), editButtonRef = useRef(null), deleteButtonRef = useRef(null), focusTrappedRef = useRef(null), popoverScheme = sanity.color.dark ? "light" : "dark", editor2 = usePortableTextEditor(), contentRef = useRef(null);
  let t0;
  $[0] !== editor2 ? (t0 = () => {
    setPopoverOpen(!1), PortableTextEditor.focus(editor2), focusTrappedRef.current = null;
  }, $[0] = editor2, $[1] = t0) : t0 = $[1];
  const handleClosePopover = t0;
  let t1;
  $[2] !== editor2 || $[3] !== handleClosePopover || $[4] !== inlineObjectFocused || $[5] !== popoverOpen ? (t1 = (event) => {
    if (popoverOpen) {
      if (event.key === "Tab") {
        if (inlineObjectFocused && event.target instanceof HTMLElement && event.target.contentEditable && focusTrappedRef.current === null) {
          event.preventDefault(), editButtonRef.current?.focus(), focusTrappedRef.current = editButtonRef.current;
          return;
        }
        if (event.target === deleteButtonRef.current) {
          event.preventDefault(), event.stopPropagation(), focusTrappedRef.current = null, PortableTextEditor.focus(editor2);
          return;
        }
      }
      event.key === "Escape" && handleClosePopover();
    }
  }, $[2] = editor2, $[3] = handleClosePopover, $[4] = inlineObjectFocused, $[5] = popoverOpen, $[6] = t1) : t1 = $[6], useGlobalKeyDown(t1);
  let t2, t3;
  $[7] !== inlineObjectFocused || $[8] !== inlineObjectOpen ? (t2 = () => {
    if (focusTrappedRef.current = null, inlineObjectOpen) {
      setPopoverOpen(!1);
      return;
    }
    if (inlineObjectFocused) {
      setPopoverOpen(!0);
      return;
    }
    setPopoverOpen(!1);
  }, t3 = [inlineObjectFocused, inlineObjectOpen], $[7] = inlineObjectFocused, $[8] = inlineObjectOpen, $[9] = t2, $[10] = t3) : (t2 = $[9], t3 = $[10]), useEffect(t2, t3);
  let t4;
  $[11] !== onOpenInlineObject ? (t4 = () => {
    setPopoverOpen(!1), onOpenInlineObject();
  }, $[11] = onOpenInlineObject, $[12] = t4) : t4 = $[12];
  const handleEditButtonClicked = t4;
  let t5;
  $[13] !== onRemoveInlineObject ? (t5 = () => {
    setPopoverOpen(!1), onRemoveInlineObject();
  }, $[13] = onRemoveInlineObject, $[14] = t5) : t5 = $[14];
  const handleRemoveButtonClicked = t5, t6 = !inlineObjectOpen && popoverOpen;
  let t7;
  $[15] !== title ? (t7 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: title }) }), $[15] = title, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t ? (t8 = t("inputs.portable-text.inline-object.edit-aria-label"), $[17] = t, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== t ? (t9 = t("inputs.portable-text.inline-object.edit"), $[19] = t, $[20] = t9) : t9 = $[20];
  let t10;
  $[21] !== t9 ? (t10 = {
    content: t9
  }, $[21] = t9, $[22] = t10) : t10 = $[22];
  let t11;
  $[23] !== handleEditButtonClicked || $[24] !== t10 || $[25] !== t8 ? (t11 = /* @__PURE__ */ jsx(Button, { "aria-label": t8, "data-testid": "edit-inline-object-button", icon: EditIcon, mode: "bleed", onClick: handleEditButtonClicked, ref: editButtonRef, tabIndex: 0, tooltipProps: t10 }), $[23] = handleEditButtonClicked, $[24] = t10, $[25] = t8, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== t ? (t12 = t("inputs.portable-text.inline-object.remove-aria-label"), $[27] = t, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== t ? (t13 = t("inputs.portable-text.inline-object.remove"), $[29] = t, $[30] = t13) : t13 = $[30];
  let t14;
  $[31] !== t13 ? (t14 = {
    content: t13
  }, $[31] = t13, $[32] = t14) : t14 = $[32];
  let t15;
  $[33] !== handleRemoveButtonClicked || $[34] !== t12 || $[35] !== t14 ? (t15 = /* @__PURE__ */ jsx(Button, { "aria-label": t12, "data-testid": "remove-inline-object-button", icon: TrashIcon, mode: "bleed", onClick: handleRemoveButtonClicked, ref: deleteButtonRef, tabIndex: 0, tone: "critical", tooltipProps: t14 }), $[33] = handleRemoveButtonClicked, $[34] = t12, $[35] = t14, $[36] = t15) : t15 = $[36];
  let t16;
  $[37] !== t11 || $[38] !== t15 || $[39] !== t7 ? (t16 = /* @__PURE__ */ jsx(Box, { padding: 1, "data-testid": "inline-object-toolbar-popover", ref: contentRef, children: /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t7,
    t11,
    t15
  ] }) }), $[37] = t11, $[38] = t15, $[39] = t7, $[40] = t16) : t16 = $[40];
  let t17;
  return $[41] !== floatingBoundary || $[42] !== popoverScheme || $[43] !== referenceBoundary || $[44] !== referenceElement || $[45] !== t16 || $[46] !== t6 ? (t17 = /* @__PURE__ */ jsx(Popover, { open: t6, floatingBoundary, constrainSize: !0, content: t16, fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$5, placement: "top", portal: !0, preventOverflow: !0, referenceBoundary, referenceElement, scheme: popoverScheme }), $[41] = floatingBoundary, $[42] = popoverScheme, $[43] = referenceBoundary, $[44] = referenceElement, $[45] = t16, $[46] = t6, $[47] = t17) : t17 = $[47], t17;
}
const parseResponsiveWidth = (value) => Array.isArray(value) ? value.flatMap(parseResponsiveWidth) : typeof value == "number" ? [value] : value === "auto" ? ["auto"] : [], parseModalType = (value) => value === "dialog" || value === "popover" ? value : void 0;
function _getModalOption(schemaType) {
  const raw = schemaType.options?.modal;
  return typeof raw == "object" && raw !== null ? {
    type: parseModalType(raw.type),
    width: parseResponsiveWidth(raw.width)
  } : void 0;
}
function VirtualizerScrollInstanceProvider(props2) {
  const $ = c(6), {
    scrollElement,
    containerElement
  } = props2;
  let t0;
  $[0] !== containerElement || $[1] !== scrollElement ? (t0 = {
    scrollElement,
    containerElement
  }, $[0] = containerElement, $[1] = scrollElement, $[2] = t0) : t0 = $[2];
  const value = t0;
  let t1;
  return $[3] !== props2.children || $[4] !== value ? (t1 = /* @__PURE__ */ jsx(VirtualizerScrollInstanceContext.Provider, { value, children: props2.children }), $[3] = props2.children, $[4] = value, $[5] = t1) : t1 = $[5], t1;
}
function DefaultEditDialog(props2) {
  const $ = c(13), {
    onClose,
    children,
    title,
    width: t0,
    autoFocus
  } = props2, width = t0 === void 0 ? 1 : t0, dialogId = useId(), [contentElement, setContentElement] = useState(null), containerElement = useRef(null);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [0, 0, 1, 0], $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== children ? (t2 = /* @__PURE__ */ jsx(Box, { ref: containerElement, children }), $[1] = children, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== contentElement || $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(PresenceOverlay, { margins: t1, children: /* @__PURE__ */ jsx(VirtualizerScrollInstanceProvider, { scrollElement: contentElement, containerElement, children: t2 }) }), $[3] = contentElement, $[4] = t2, $[5] = t3) : t3 = $[5];
  let t4;
  return $[6] !== autoFocus || $[7] !== dialogId || $[8] !== onClose || $[9] !== t3 || $[10] !== title || $[11] !== width ? (t4 = /* @__PURE__ */ jsx(Dialog$1, { header: title, id: dialogId, onClickOutside: onClose, onClose, portal: "default", width, contentRef: setContentElement, "data-testid": "default-edit-object-dialog", __unstable_autoFocus: autoFocus, children: t3 }), $[6] = autoFocus, $[7] = dialogId, $[8] = onClose, $[9] = t3, $[10] = title, $[11] = width, $[12] = t4) : t4 = $[12], t4;
}
const RootPopover = styled(Popover).withConfig({
  displayName: "RootPopover",
  componentId: "sc-3pun1i-0"
})`[data-ui='Popover__wrapper']{overflow:auto;max-height:60vh;}`, ContentScrollerBox = styled(Box).withConfig({
  displayName: "ContentScrollerBox",
  componentId: "sc-3pun1i-1"
})`overflow-x:hidden;`, ContentHeaderBox = styled(Box).withConfig({
  displayName: "ContentHeaderBox",
  componentId: "sc-3pun1i-2"
})`box-shadow:0 1px 0 var(--card-shadow-outline-color);position:relative;z-index:10;min-height:auto;`, NoopContainer = (t0) => {
  const $ = c(6);
  let children, props2;
  $[0] !== t0 ? ({
    children,
    ...props2
  } = t0, $[0] = t0, $[1] = children, $[2] = props2) : (children = $[1], props2 = $[2]);
  let t1;
  return $[3] !== children || $[4] !== props2 ? (t1 = /* @__PURE__ */ jsx("div", { ...props2, tabIndex: -1, children }), $[3] = children, $[4] = props2, $[5] = t1) : t1 = $[5], t1;
}, POPOVER_FALLBACK_PLACEMENTS$4 = ["top", "bottom"];
function PopoverEditDialog(props2) {
  const $ = c(8), {
    floatingBoundary,
    referenceBoundary,
    referenceElement,
    width: t0
  } = props2, width = t0 === void 0 ? 2 : t0;
  let t1;
  $[0] !== props2 ? (t1 = /* @__PURE__ */ jsx(Content, { ...props2 }), $[0] = props2, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== floatingBoundary || $[3] !== referenceBoundary || $[4] !== referenceElement || $[5] !== t1 || $[6] !== width ? (t2 = /* @__PURE__ */ jsx(RootPopover, { content: t1, constrainSize: !0, "data-testid": "popover-edit-dialog", "data-ui": "PopoverEditDialog", fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$4, floatingBoundary, open: !0, overflow: "auto", placement: "bottom", portal: "default", preventOverflow: !0, referenceBoundary, referenceElement, width, autoFocus: !0 }), $[2] = floatingBoundary, $[3] = referenceBoundary, $[4] = referenceElement, $[5] = t1, $[6] = width, $[7] = t2) : t2 = $[7], t2;
}
function Content(props2) {
  const $ = c(27), {
    onClose,
    referenceBoundary,
    referenceElement,
    title
  } = props2, isClosedRef = useRef(!1);
  let t0;
  $[0] !== onClose ? (t0 = () => {
    isClosedRef.current = !0, onClose();
  }, $[0] = onClose, $[1] = t0) : t0 = $[1];
  const handleClose = t0;
  let t1;
  $[2] !== handleClose ? (t1 = (event) => {
    event.key === "Escape" && (event.preventDefault(), event.stopPropagation(), event.stopImmediatePropagation(), handleClose());
  }, $[2] = handleClose, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    capture: !0
  }, $[4] = t2) : t2 = $[4], useGlobalKeyDown(t1, t2);
  let t3;
  $[5] !== referenceElement ? (t3 = () => [referenceElement], $[5] = referenceElement, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== referenceBoundary ? (t4 = () => referenceBoundary, $[7] = referenceBoundary, $[8] = t4) : t4 = $[8], useClickOutsideEvent(handleClose, t3, t4);
  const [contentElement, setContentElement] = useState(null), containerElement = useRef(null);
  let t5;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = (element) => {
    if (isClosedRef.current)
      return !1;
    const target = element, portalElements = document.querySelectorAll("[data-portal]");
    return !Array.from(portalElements).some((portal) => portal.contains(target)) && !isClosedRef.current ? !1 : !!element.contentEditable || !!containerElement.current?.contains(element);
  }, $[9] = t5) : t5 = $[9];
  const handleFocusLockWhiteList = t5;
  let t6;
  $[10] !== title ? (t6 = /* @__PURE__ */ jsx(Box, { flex: 1, padding: 2, children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: title }) }), $[10] = title, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    content: "Close"
  }, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== handleClose ? (t8 = /* @__PURE__ */ jsx(Button, { autoFocus: !0, icon: CloseIcon, mode: "bleed", onClick: handleClose, tooltipProps: t7, "data-testid": "close-popover-edit-dialog-button" }), $[13] = handleClose, $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== t6 || $[16] !== t8 ? (t9 = /* @__PURE__ */ jsx(ContentHeaderBox, { flex: "none", padding: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t6,
    t8
  ] }) }), $[15] = t6, $[16] = t8, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = [0, 0, 1, 0], $[18] = t10) : t10 = $[18];
  let t11;
  $[19] !== props2.children ? (t11 = /* @__PURE__ */ jsx(ContentScrollerBox, { flex: 1, children: /* @__PURE__ */ jsx(PresenceOverlay, { margins: t10, children: /* @__PURE__ */ jsx(Box, { padding: 3, ref: setContentElement, children: props2.children }) }) }), $[19] = props2.children, $[20] = t11) : t11 = $[20];
  let t12;
  $[21] !== t11 || $[22] !== t9 ? (t12 = /* @__PURE__ */ jsx(FocusLock, { autoFocus: !0, whiteList: handleFocusLockWhiteList, children: /* @__PURE__ */ jsxs(Flex, { as: NoopContainer, ref: containerElement, direction: "column", height: "fill", children: [
    t9,
    t11
  ] }) }), $[21] = t11, $[22] = t9, $[23] = t12) : t12 = $[23];
  let t13;
  return $[24] !== contentElement || $[25] !== t12 ? (t13 = /* @__PURE__ */ jsx(VirtualizerScrollInstanceProvider, { scrollElement: contentElement, containerElement, children: t12 }), $[24] = contentElement, $[25] = t12, $[26] = t13) : t13 = $[26], t13;
}
function ObjectEditModal(props2) {
  const $ = c(28), {
    autoFocus,
    defaultType,
    floatingBoundary,
    onClose,
    referenceBoundary,
    referenceElement,
    schemaType
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== schemaType ? (t0 = _getModalOption(schemaType), $[0] = schemaType, $[1] = t0) : t0 = $[1];
  const schemaModalOption = t0, modalType = schemaModalOption?.type || defaultType, {
    enabled: nestedObjectNavigationEnabled
  } = useEnhancedObjectDialog();
  let t1;
  if ($[2] !== schemaType.i18nTitleKey || $[3] !== schemaType.name || $[4] !== schemaType.title || $[5] !== t) {
    const schemaTypeTitle = schemaType.i18nTitleKey ? t(schemaType.i18nTitleKey) : schemaType.title || schemaType.name;
    t1 = t("inputs.portable-text.annotation-editor.title", {
      schemaType: schemaTypeTitle
    }), $[2] = schemaType.i18nTitleKey, $[3] = schemaType.name, $[4] = schemaType.title, $[5] = t, $[6] = t1;
  } else
    t1 = $[6];
  const modalTitle = t1;
  let t2;
  $[7] !== onClose ? (t2 = () => {
    onClose();
  }, $[7] = onClose, $[8] = t2) : t2 = $[8];
  const handleClose = t2, modalWidth = schemaModalOption?.width;
  if (modalType === "popover") {
    let t32;
    $[9] !== modalTitle ? (t32 = /* @__PURE__ */ jsx(Fragment$1, { children: modalTitle }), $[9] = modalTitle, $[10] = t32) : t32 = $[10];
    let t4;
    return $[11] !== autoFocus || $[12] !== floatingBoundary || $[13] !== handleClose || $[14] !== modalWidth || $[15] !== props2.children || $[16] !== referenceBoundary || $[17] !== referenceElement || $[18] !== t32 ? (t4 = /* @__PURE__ */ jsx(PopoverEditDialog, { autoFocus, floatingBoundary, onClose: handleClose, referenceBoundary, referenceElement, title: t32, width: modalWidth, "data-testid": "popover-edit-dialog", children: props2.children }), $[11] = autoFocus, $[12] = floatingBoundary, $[13] = handleClose, $[14] = modalWidth, $[15] = props2.children, $[16] = referenceBoundary, $[17] = referenceElement, $[18] = t32, $[19] = t4) : t4 = $[19], t4;
  }
  let t3;
  return $[20] !== autoFocus || $[21] !== handleClose || $[22] !== modalTitle || $[23] !== modalWidth || $[24] !== nestedObjectNavigationEnabled || $[25] !== onClose || $[26] !== props2.children ? (t3 = nestedObjectNavigationEnabled ? /* @__PURE__ */ jsx(EnhancedObjectDialog, { type: "dialog", onClose, header: modalTitle, width: 1, autofocus: autoFocus, children: props2.children }) : /* @__PURE__ */ jsx(DefaultEditDialog, { onClose: handleClose, title: modalTitle, width: modalWidth, autoFocus, children: props2.children }), $[20] = autoFocus, $[21] = handleClose, $[22] = modalTitle, $[23] = modalWidth, $[24] = nestedObjectNavigationEnabled, $[25] = onClose, $[26] = props2.children, $[27] = t3) : t3 = $[27], t3;
}
const InlineObject = (props2) => {
  const $ = c(69), {
    floatingBoundary,
    focused,
    onItemClose,
    onItemOpen,
    onPathFocus,
    path,
    readOnly,
    referenceBoundary,
    relativePath,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderCustomMarkers,
    renderField,
    renderItem: renderItem2,
    renderInlineBlock,
    renderInput,
    renderPreview,
    schemaType,
    selected,
    setElementRef,
    value
  } = props2, {
    Markers
  } = useFormBuilder().__internal.components, editor2 = usePortableTextEditor(), schemaTypes = usePortableTextMemberSchemaTypes(), markers = usePortableTextMarkers(path), [divElement, setDivElement] = useState(null);
  let t0;
  $[0] !== path ? (t0 = pathToString$1(path), $[0] = path, $[1] = t0) : t0 = $[1];
  const memberItem = usePortableTextMemberItem(t0), {
    validation: validation2,
    hasError,
    hasInfo,
    hasWarning
  } = useMemberValidation(memberItem?.node), parentSchemaType = schemaTypes.block, hasMarkers = markers.length > 0;
  let t1;
  $[2] !== relativePath ? (t1 = {
    anchor: {
      path: relativePath,
      offset: 0
    },
    focus: {
      path: relativePath,
      offset: 0
    }
  }, $[2] = relativePath, $[3] = t1) : t1 = $[3];
  const selfSelection = t1;
  let t2;
  $[4] !== editor2 || $[5] !== selfSelection ? (t2 = () => {
    PortableTextEditor.delete(editor2, selfSelection, {
      mode: "children"
    }), PortableTextEditor.focus(editor2);
  }, $[4] = editor2, $[5] = selfSelection, $[6] = t2) : t2 = $[6];
  const onRemove = t2;
  let t3;
  $[7] !== editor2 || $[8] !== memberItem || $[9] !== onItemOpen ? (t3 = () => {
    memberItem && (PortableTextEditor.blur(editor2), onItemOpen(memberItem.node.path));
  }, $[7] = editor2, $[8] = memberItem, $[9] = onItemOpen, $[10] = t3) : t3 = $[10];
  const onOpen = t3;
  let t4;
  $[11] !== editor2 || $[12] !== onItemClose || $[13] !== selfSelection ? (t4 = () => {
    onItemClose(), PortableTextEditor.select(editor2, selfSelection), PortableTextEditor.focus(editor2);
  }, $[11] = editor2, $[12] = onItemClose, $[13] = selfSelection, $[14] = t4) : t4 = $[14];
  const onClose = t4, isOpen = !!memberItem?.member.open, input = memberItem?.input, nodePath = memberItem?.node.path || EMPTY_ARRAY$y, referenceElement = divElement, presence = useChildPresence(path, !0);
  let t5;
  if ($[15] !== path || $[16] !== presence) {
    let t62;
    $[18] !== path ? (t62 = (p) => isEqual$2(p.path, path), $[18] = path, $[19] = t62) : t62 = $[19], t5 = presence.filter(t62), $[15] = path, $[16] = presence, $[17] = t5;
  } else
    t5 = $[17];
  const rootPresence = t5;
  let t6;
  $[20] !== floatingBoundary || $[21] !== focused || $[22] !== input || $[23] !== isOpen || $[24] !== markers || $[25] !== memberItem?.member || $[26] !== nodePath || $[27] !== onClose || $[28] !== onOpen || $[29] !== onPathFocus || $[30] !== onRemove || $[31] !== parentSchemaType || $[32] !== readOnly || $[33] !== referenceBoundary || $[34] !== referenceElement || $[35] !== renderAnnotation || $[36] !== renderBlock2 || $[37] !== renderField || $[38] !== renderInlineBlock || $[39] !== renderInput || $[40] !== renderItem2 || $[41] !== renderPreview || $[42] !== rootPresence || $[43] !== schemaType || $[44] !== selected || $[45] !== validation2 || $[46] !== value ? (t6 = () => ({
    __unstable_floatingBoundary: floatingBoundary,
    __unstable_referenceBoundary: referenceBoundary,
    __unstable_referenceElement: referenceElement,
    changed: memberItem?.member.item.changed ?? !1,
    children: input,
    focused,
    onClose,
    onOpen,
    onPathFocus,
    onRemove,
    open: isOpen,
    markers,
    member: memberItem?.member,
    parentSchemaType,
    path: nodePath,
    presence: rootPresence,
    readOnly: !!readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderDefault: DefaultInlineObjectComponent,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    selected,
    value,
    validation: validation2
  }), $[20] = floatingBoundary, $[21] = focused, $[22] = input, $[23] = isOpen, $[24] = markers, $[25] = memberItem?.member, $[26] = nodePath, $[27] = onClose, $[28] = onOpen, $[29] = onPathFocus, $[30] = onRemove, $[31] = parentSchemaType, $[32] = readOnly, $[33] = referenceBoundary, $[34] = referenceElement, $[35] = renderAnnotation, $[36] = renderBlock2, $[37] = renderField, $[38] = renderInlineBlock, $[39] = renderInput, $[40] = renderItem2, $[41] = renderPreview, $[42] = rootPresence, $[43] = schemaType, $[44] = selected, $[45] = validation2, $[46] = value, $[47] = t6) : t6 = $[47];
  let t7;
  $[48] !== t6 ? (t7 = t6(), $[48] = t6, $[49] = t7) : t7 = $[49];
  const componentProps = t7, tooltipEnabled = hasError || hasWarning || hasInfo || hasMarkers;
  let t8;
  $[50] !== Markers || $[51] !== markers || $[52] !== renderCustomMarkers || $[53] !== tooltipEnabled || $[54] !== validation2 ? (t8 = tooltipEnabled && /* @__PURE__ */ jsx(TooltipBox$1, { children: /* @__PURE__ */ jsx(Markers, { markers, validation: validation2, renderCustomMarkers }) }) || null, $[50] = Markers, $[51] = markers, $[52] = renderCustomMarkers, $[53] = tooltipEnabled, $[54] = validation2, $[55] = t8) : t8 = $[55];
  const toolTipContent = t8;
  let t9;
  $[56] !== memberItem || $[57] !== setElementRef ? (t9 = (elm) => {
    memberItem && setElementRef({
      key: memberItem.member.key,
      elementRef: elm
    }), setDivElement(elm);
  }, $[56] = memberItem, $[57] = setElementRef, $[58] = t9) : t9 = $[58];
  const setRef = t9, t10 = isOpen ? !0 : !tooltipEnabled;
  let t11;
  $[59] !== componentProps || $[60] !== renderInlineBlock ? (t11 = renderInlineBlock && /* @__PURE__ */ jsx("span", { style: {
    position: "relative"
  }, children: renderInlineBlock(componentProps) }), $[59] = componentProps, $[60] = renderInlineBlock, $[61] = t11) : t11 = $[61];
  let t12;
  $[62] !== t10 || $[63] !== t11 || $[64] !== toolTipContent ? (t12 = /* @__PURE__ */ jsx(Tooltip, { placement: "bottom", portal: "editor", disabled: t10, content: toolTipContent, children: t11 }), $[62] = t10, $[63] = t11, $[64] = toolTipContent, $[65] = t12) : t12 = $[65];
  let t13;
  return $[66] !== setRef || $[67] !== t12 ? (t13 = /* @__PURE__ */ jsx("span", { ref: setRef, contentEditable: !1, children: t12 }), $[66] = setRef, $[67] = t12, $[68] = t13) : t13 = $[68], t13;
}, DefaultInlineObjectComponent = (props2) => {
  const $ = c(45), {
    __unstable_floatingBoundary: floatingBoundary,
    __unstable_referenceBoundary: referenceBoundary,
    __unstable_referenceElement: referenceElement,
    children,
    focused,
    markers,
    onClose,
    onOpen,
    onRemove,
    open,
    readOnly,
    renderPreview,
    schemaType,
    selected,
    validation: validation2,
    value
  } = props2, {
    t
  } = useTranslation(), hasMarkers = markers.length > 0, popoverTitle = schemaType?.title || schemaType.name;
  let t0;
  $[0] !== validation2 ? (t0 = validation2.filter(_temp$2L), $[0] = validation2, $[1] = t0) : t0 = $[1];
  const hasError = t0.length > 0;
  let t1;
  $[2] !== validation2 ? (t1 = validation2.filter(_temp2$19), $[2] = validation2, $[3] = t1) : t1 = $[3];
  const hasWarning = t1.length > 0;
  let t2;
  bb0: {
    if (hasError) {
      t2 = "critical";
      break bb0;
    }
    if (hasWarning) {
      t2 = "caution";
      break bb0;
    }
    if (selected || focused) {
      t2 = "primary";
      break bb0;
    }
    t2 = void 0;
  }
  const tone = t2;
  let t3;
  $[4] !== t ? (t3 = t("inputs.portable-text.inline-block.aria-label"), $[4] = t, $[5] = t3) : t3 = $[5];
  const t4 = focused || void 0, t5 = hasError || void 0, t6 = hasMarkers || void 0, t7 = readOnly || void 0, t8 = selected || void 0, t9 = hasWarning || void 0, t10 = readOnly ? onOpen : void 0;
  let t11;
  $[6] !== renderPreview || $[7] !== schemaType || $[8] !== value ? (t11 = renderPreview({
    layout: "inline",
    schemaType,
    skipVisibilityCheck: !0,
    value,
    fallbackTitle: "Click to edit"
  }), $[6] = renderPreview, $[7] = schemaType, $[8] = value, $[9] = t11) : t11 = $[9];
  let t12;
  $[10] !== t11 ? (t12 = /* @__PURE__ */ jsx(PreviewSpan, { children: t11 }), $[10] = t11, $[11] = t12) : t12 = $[11];
  let t13;
  $[12] !== onOpen || $[13] !== t10 || $[14] !== t12 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9 || $[22] !== tone ? (t13 = /* @__PURE__ */ jsx(Root$i, { "aria-label": t3, "data-focused": t4, "data-invalid": t5, "data-markers": t6, "data-read-only": t7, "data-selected": t8, "data-warning": t9, forwardedAs: "span", onClick: t10, onDoubleClick: onOpen, tone, children: t12 }), $[12] = onOpen, $[13] = t10, $[14] = t12, $[15] = t3, $[16] = t4, $[17] = t5, $[18] = t6, $[19] = t7, $[20] = t8, $[21] = t9, $[22] = tone, $[23] = t13) : t13 = $[23];
  let t14;
  $[24] !== floatingBoundary || $[25] !== focused || $[26] !== onOpen || $[27] !== onRemove || $[28] !== open || $[29] !== popoverTitle || $[30] !== referenceBoundary || $[31] !== referenceElement ? (t14 = referenceElement && /* @__PURE__ */ jsx(InlineObjectToolbarPopover, { floatingBoundary, inlineObjectFocused: focused, inlineObjectOpen: open, onOpenInlineObject: onOpen, onRemoveInlineObject: onRemove, referenceBoundary, referenceElement, title: popoverTitle }), $[24] = floatingBoundary, $[25] = focused, $[26] = onOpen, $[27] = onRemove, $[28] = open, $[29] = popoverTitle, $[30] = referenceBoundary, $[31] = referenceElement, $[32] = t14) : t14 = $[32];
  let t15;
  $[33] !== children || $[34] !== floatingBoundary || $[35] !== onClose || $[36] !== open || $[37] !== referenceBoundary || $[38] !== referenceElement || $[39] !== schemaType ? (t15 = open && /* @__PURE__ */ jsx(ObjectEditModal, { autoFocus: !0, defaultType: "popover", floatingBoundary, onClose, referenceBoundary, referenceElement, schemaType, children }), $[33] = children, $[34] = floatingBoundary, $[35] = onClose, $[36] = open, $[37] = referenceBoundary, $[38] = referenceElement, $[39] = schemaType, $[40] = t15) : t15 = $[40];
  let t16;
  return $[41] !== t13 || $[42] !== t14 || $[43] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t13,
    t14,
    t15
  ] }), $[41] = t13, $[42] = t14, $[43] = t15, $[44] = t16) : t16 = $[44], t16;
};
function _temp$2L(v) {
  return v.level === "error";
}
function _temp2$19(v_0) {
  return v_0.level === "warning";
}
function AnnotationObjectEditModal(props2) {
  const $ = c(14), editor2 = usePortableTextEditor(), boundaryElement = useBoundaryElement().element, portableTextMemberItems = usePortableTextMemberItems(), elementRefs = usePortableTextMemberItemElementRefs();
  let t0;
  $[0] !== portableTextMemberItems ? (t0 = portableTextMemberItems.find(_temp$2K), $[0] = portableTextMemberItems, $[1] = t0) : t0 = $[1];
  const openAnnotation = t0;
  let t1;
  $[2] !== editor2 || $[3] !== openAnnotation || $[4] !== props2 ? (t1 = () => {
    openAnnotation && (props2.onItemClose(), openAnnotation.node.value && isEmptyItem(openAnnotation.node.value) && openAnnotation && PortableTextEditor.removeAnnotation(editor2, openAnnotation.node.schemaType), PortableTextEditor.focus(editor2));
  }, $[2] = editor2, $[3] = openAnnotation, $[4] = props2, $[5] = t1) : t1 = $[5];
  const onClose = t1;
  if (!openAnnotation)
    return null;
  const elementRef = elementRefs[openAnnotation.member.key];
  if (!elementRef)
    return null;
  const t2 = !!props2.focused;
  let t3;
  return $[6] !== boundaryElement || $[7] !== elementRef || $[8] !== onClose || $[9] !== openAnnotation.input || $[10] !== openAnnotation.node.schemaType || $[11] !== props2.referenceBoundary || $[12] !== t2 ? (t3 = /* @__PURE__ */ jsx(ObjectEditModal, { defaultType: "popover", floatingBoundary: boundaryElement, onClose, autoFocus: t2, referenceBoundary: props2.referenceBoundary, referenceElement: elementRef, schemaType: openAnnotation.node.schemaType, children: openAnnotation.input }), $[6] = boundaryElement, $[7] = elementRef, $[8] = onClose, $[9] = openAnnotation.input, $[10] = openAnnotation.node.schemaType, $[11] = props2.referenceBoundary, $[12] = t2, $[13] = t3) : t3 = $[13], t3;
}
function _temp$2K(m) {
  return m.kind === "annotation" && m.member.open;
}
function Compositor(props2) {
  const $ = c(167), {
    changed,
    elementRef,
    focused,
    focusPath: t0,
    elementProps,
    hasFocusWithin,
    hideToolbar,
    hotkeys,
    isActive,
    isFullscreen,
    onActivate,
    onCopy,
    onItemClose,
    onItemOpen,
    onItemRemove,
    onPaste,
    onPathFocus,
    onSelectFile,
    onToggleFullscreen,
    onUpload,
    path,
    rangeDecorations,
    readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderBlockActions,
    renderCustomMarkers,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    value
  } = props2, focusPath = t0 === void 0 ? EMPTY_ARRAY$y : t0, schemaTypes = usePortableTextMemberSchemaTypes(), setElementRef = useSetPortableTextMemberItemElementRef();
  let t1;
  bb0: {
    if (!onPaste) {
      t1 = void 0;
      break bb0;
    }
    let t210;
    $[0] !== onPaste || $[1] !== schemaTypes ? (t210 = (data) => onPaste({
      ...data,
      schemaTypes
    }), $[0] = onPaste, $[1] = schemaTypes, $[2] = t210) : t210 = $[2], t1 = t210;
  }
  const wrappedOnPaste = t1, boundaryElement = useBoundaryElement().element, [wrapperElement, setWrapperElement] = useState(null), [scrollElement, setScrollElement] = useState(null);
  let t2;
  $[3] !== onToggleFullscreen ? (t2 = () => {
    onToggleFullscreen();
  }, $[3] = onToggleFullscreen, $[4] = t2) : t2 = $[4];
  const handleToggleFullscreen = t2, t3 = hotkeys?.custom;
  let t4;
  $[5] !== onToggleFullscreen || $[6] !== t3 ? (t4 = {
    "mod+enter": onToggleFullscreen,
    ...t3
  }, $[5] = onToggleFullscreen, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== hotkeys || $[9] !== t4 ? (t5 = {
    ...hotkeys,
    custom: t4
  }, $[8] = hotkeys, $[9] = t4, $[10] = t5) : t5 = $[10];
  const editorHotkeys = useHotkeys(t5), _renderBlockActions = value && renderBlockActions ? renderBlockActions : void 0, _renderCustomMarkers = value && renderCustomMarkers ? renderCustomMarkers : void 0, [portalElement, setPortalElement] = useState(null);
  let t6;
  $[11] !== _renderBlockActions || $[12] !== _renderCustomMarkers || $[13] !== boundaryElement || $[14] !== isFullscreen || $[15] !== onItemClose || $[16] !== onItemOpen || $[17] !== onItemRemove || $[18] !== onPathFocus || $[19] !== path || $[20] !== readOnly || $[21] !== renderAnnotation || $[22] !== renderBlock2 || $[23] !== renderField || $[24] !== renderInlineBlock || $[25] !== renderInput || $[26] !== renderItem2 || $[27] !== renderPreview || $[28] !== schemaTypes.block || $[29] !== scrollElement || $[30] !== setElementRef ? (t6 = (blockProps) => {
    const {
      children,
      focused: blockFocused,
      path: blockPath,
      selected,
      value: block
    } = blockProps, fullyQualifiedPath = path.concat(blockPath);
    return /* @__PURE__ */ jsx(TextBlock, { floatingBoundary: boundaryElement, focused: blockFocused, isFullscreen, onItemClose, onItemOpen, onItemRemove, onPathFocus, path: path.concat(blockPath), readOnly, referenceBoundary: scrollElement, renderAnnotation, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderBlockActions: _renderBlockActions, renderCustomMarkers: _renderCustomMarkers, renderPreview, renderBlock: renderBlock2, schemaType: schemaTypes.block, selected, setElementRef, value: block, anchorIdent: pathToAnchorIdent("input", fullyQualifiedPath), children });
  }, $[11] = _renderBlockActions, $[12] = _renderCustomMarkers, $[13] = boundaryElement, $[14] = isFullscreen, $[15] = onItemClose, $[16] = onItemOpen, $[17] = onItemRemove, $[18] = onPathFocus, $[19] = path, $[20] = readOnly, $[21] = renderAnnotation, $[22] = renderBlock2, $[23] = renderField, $[24] = renderInlineBlock, $[25] = renderInput, $[26] = renderItem2, $[27] = renderPreview, $[28] = schemaTypes.block, $[29] = scrollElement, $[30] = setElementRef, $[31] = t6) : t6 = $[31];
  const renderTextBlock = t6;
  let t7;
  $[32] !== _renderBlockActions || $[33] !== _renderCustomMarkers || $[34] !== boundaryElement || $[35] !== isFullscreen || $[36] !== onItemClose || $[37] !== onItemOpen || $[38] !== onItemRemove || $[39] !== onPathFocus || $[40] !== path || $[41] !== readOnly || $[42] !== renderAnnotation || $[43] !== renderBlock2 || $[44] !== renderField || $[45] !== renderInlineBlock || $[46] !== renderInput || $[47] !== renderItem2 || $[48] !== renderPreview || $[49] !== schemaTypes.blockObjects || $[50] !== scrollElement || $[51] !== setElementRef ? (t7 = (blockProps_0) => {
    const {
      focused: blockFocused_0,
      path: blockPath_0,
      selected: blockSelected,
      schemaType: blockSchemaType,
      value: blockValue
    } = blockProps_0, sanitySchemaType = schemaTypes.blockObjects.find((type) => type.name === blockSchemaType.name);
    if (!sanitySchemaType)
      throw new Error(`Could not find Sanity schema type for block object: ${blockSchemaType.name}`);
    return /* @__PURE__ */ jsx(BlockObject, { floatingBoundary: boundaryElement, focused: blockFocused_0, isFullscreen, onItemClose, onItemOpen, onItemRemove, onPathFocus, path: path.concat(blockPath_0), readOnly, referenceBoundary: scrollElement, relativePath: blockPath_0, renderAnnotation, renderBlock: renderBlock2, renderBlockActions: _renderBlockActions, renderCustomMarkers: _renderCustomMarkers, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview, schemaType: sanitySchemaType, selected: blockSelected, setElementRef, value: blockValue });
  }, $[32] = _renderBlockActions, $[33] = _renderCustomMarkers, $[34] = boundaryElement, $[35] = isFullscreen, $[36] = onItemClose, $[37] = onItemOpen, $[38] = onItemRemove, $[39] = onPathFocus, $[40] = path, $[41] = readOnly, $[42] = renderAnnotation, $[43] = renderBlock2, $[44] = renderField, $[45] = renderInlineBlock, $[46] = renderInput, $[47] = renderItem2, $[48] = renderPreview, $[49] = schemaTypes.blockObjects, $[50] = scrollElement, $[51] = setElementRef, $[52] = t7) : t7 = $[52];
  const renderObjectBlock = t7;
  let t8;
  $[53] !== renderObjectBlock || $[54] !== renderTextBlock || $[55] !== schemaTypes.block.name ? (t8 = (blockProps_1) => {
    const {
      value: block_0
    } = blockProps_1;
    return block_0._type === schemaTypes.block.name ? renderTextBlock(blockProps_1) : renderObjectBlock(blockProps_1);
  }, $[53] = renderObjectBlock, $[54] = renderTextBlock, $[55] = schemaTypes.block.name, $[56] = t8) : t8 = $[56];
  const editorRenderBlock = t8;
  let t9;
  $[57] !== boundaryElement || $[58] !== onItemClose || $[59] !== onItemOpen || $[60] !== onPathFocus || $[61] !== path || $[62] !== readOnly || $[63] !== renderAnnotation || $[64] !== renderBlock2 || $[65] !== renderCustomMarkers || $[66] !== renderField || $[67] !== renderInlineBlock || $[68] !== renderInput || $[69] !== renderItem2 || $[70] !== renderPreview || $[71] !== schemaTypes.inlineObjects || $[72] !== schemaTypes.span.name || $[73] !== scrollElement || $[74] !== setElementRef ? (t9 = (childProps) => {
    const {
      children: children_0,
      focused: childFocused,
      path: childPath,
      selected: selected_0,
      schemaType: childSchemaType,
      value: child
    } = childProps;
    if (child._type === schemaTypes.span.name)
      return children_0;
    const sanitySchemaType_0 = schemaTypes.inlineObjects.find((type_0) => type_0.name === childSchemaType.name);
    if (!sanitySchemaType_0)
      throw new Error(`Could not find Sanity schema type for inline object: ${childSchemaType.name}`);
    return /* @__PURE__ */ jsx(InlineObject, { floatingBoundary: boundaryElement, focused: childFocused, onItemClose, onItemOpen, onPathFocus, path: path.concat(childPath), readOnly, referenceBoundary: scrollElement, relativePath: childPath, renderAnnotation, renderBlock: renderBlock2, renderCustomMarkers, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview, schemaType: sanitySchemaType_0, selected: selected_0, setElementRef, value: child });
  }, $[57] = boundaryElement, $[58] = onItemClose, $[59] = onItemOpen, $[60] = onPathFocus, $[61] = path, $[62] = readOnly, $[63] = renderAnnotation, $[64] = renderBlock2, $[65] = renderCustomMarkers, $[66] = renderField, $[67] = renderInlineBlock, $[68] = renderInput, $[69] = renderItem2, $[70] = renderPreview, $[71] = schemaTypes.inlineObjects, $[72] = schemaTypes.span.name, $[73] = scrollElement, $[74] = setElementRef, $[75] = t9) : t9 = $[75];
  const editorRenderChild = t9;
  let t10;
  $[76] !== boundaryElement || $[77] !== focused || $[78] !== onItemClose || $[79] !== onItemOpen || $[80] !== onPathFocus || $[81] !== path || $[82] !== readOnly || $[83] !== renderAnnotation || $[84] !== renderBlock2 || $[85] !== renderCustomMarkers || $[86] !== renderField || $[87] !== renderInlineBlock || $[88] !== renderInput || $[89] !== renderItem2 || $[90] !== renderPreview || $[91] !== schemaTypes.annotations || $[92] !== scrollElement || $[93] !== setElementRef ? (t10 = (annotationProps) => {
    const {
      children: children_1,
      focused: editorNodeFocused,
      path: aPath,
      selected: selected_1,
      schemaType: aSchemaType,
      value: aValue
    } = annotationProps, sanitySchemaType_1 = schemaTypes.annotations.find((type_1) => type_1.name === aSchemaType.name);
    if (!sanitySchemaType_1)
      throw new Error(`Could not find Sanity schema type for annotation: ${aSchemaType.name}`);
    return /* @__PURE__ */ jsx(Annotation, { editorNodeFocused, floatingBoundary: boundaryElement, focused: !!focused, onItemClose, onItemOpen, onPathFocus, path: path.concat(aPath), readOnly, referenceBoundary: scrollElement, renderAnnotation, renderBlock: renderBlock2, renderCustomMarkers, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview, schemaType: sanitySchemaType_1, selected: selected_1, setElementRef, value: aValue, children: children_1 });
  }, $[76] = boundaryElement, $[77] = focused, $[78] = onItemClose, $[79] = onItemOpen, $[80] = onPathFocus, $[81] = path, $[82] = readOnly, $[83] = renderAnnotation, $[84] = renderBlock2, $[85] = renderCustomMarkers, $[86] = renderField, $[87] = renderInlineBlock, $[88] = renderInput, $[89] = renderItem2, $[90] = renderPreview, $[91] = schemaTypes.annotations, $[92] = scrollElement, $[93] = setElementRef, $[94] = t10) : t10 = $[94];
  const editorRenderAnnotation = t10, ariaDescribedBy = elementProps["aria-describedby"];
  let t11;
  $[95] !== focusPath || $[96] !== hasFocusWithin ? (t11 = () => {
    if (hasFocusWithin)
      return {
        anchor: {
          path: focusPath,
          offset: 0
        },
        focus: {
          path: focusPath,
          offset: 0
        }
      };
  }, $[95] = focusPath, $[96] = hasFocusWithin, $[97] = t11) : t11 = $[97];
  const [initialSelection] = useState(t11), isOneLineEditor = !!schemaTypes.block.options?.oneLine, t12 = wrapperElement || void 0;
  let t13;
  $[98] !== ariaDescribedBy || $[99] !== editorHotkeys || $[100] !== editorRenderAnnotation || $[101] !== editorRenderBlock || $[102] !== editorRenderChild || $[103] !== elementRef || $[104] !== handleToggleFullscreen || $[105] !== hideToolbar || $[106] !== initialSelection || $[107] !== isActive || $[108] !== isFullscreen || $[109] !== isOneLineEditor || $[110] !== onCopy || $[111] !== onItemOpen || $[112] !== path || $[113] !== rangeDecorations || $[114] !== readOnly || $[115] !== scrollElement || $[116] !== wrappedOnPaste ? (t13 = /* @__PURE__ */ jsx(StringDiffContainer, { children: /* @__PURE__ */ jsx(Editor, { ariaDescribedBy, elementRef, initialSelection, hideToolbar, hotkeys: editorHotkeys, isActive, isFullscreen, isOneLine: isOneLineEditor, onItemOpen, onCopy, onPaste: wrappedOnPaste, onToggleFullscreen: handleToggleFullscreen, path, rangeDecorations, readOnly, renderAnnotation: editorRenderAnnotation, renderBlock: editorRenderBlock, renderChild: editorRenderChild, setPortalElement, scrollElement, setScrollElement }) }), $[98] = ariaDescribedBy, $[99] = editorHotkeys, $[100] = editorRenderAnnotation, $[101] = editorRenderBlock, $[102] = editorRenderChild, $[103] = elementRef, $[104] = handleToggleFullscreen, $[105] = hideToolbar, $[106] = initialSelection, $[107] = isActive, $[108] = isFullscreen, $[109] = isOneLineEditor, $[110] = onCopy, $[111] = onItemOpen, $[112] = path, $[113] = rangeDecorations, $[114] = readOnly, $[115] = scrollElement, $[116] = wrappedOnPaste, $[117] = t13) : t13 = $[117];
  let t14;
  $[118] !== onSelectFile || $[119] !== onUpload || $[120] !== readOnly || $[121] !== schemaTypes.portableText.of || $[122] !== t12 || $[123] !== t13 ? (t14 = /* @__PURE__ */ jsx(UploadTargetCard$1, { isReadOnly: readOnly, onSelectFile, onUpload, pasteTarget: t12, tabIndex: -1, types: schemaTypes.portableText.of, children: t13 }), $[118] = onSelectFile, $[119] = onUpload, $[120] = readOnly, $[121] = schemaTypes.portableText.of, $[122] = t12, $[123] = t13, $[124] = t14) : t14 = $[124];
  const editorNode = t14, portal = usePortal();
  let t15;
  $[125] !== portal.element || $[126] !== portalElement || $[127] !== wrapperElement ? (t15 = {
    collapsed: wrapperElement,
    default: portal.element,
    editor: portalElement,
    expanded: portal.element
  }, $[125] = portal.element, $[126] = portalElement, $[127] = wrapperElement, $[128] = t15) : t15 = $[128];
  const portalElements = t15;
  let t16;
  $[129] !== focusPath || $[130] !== onItemClose || $[131] !== scrollElement ? (t16 = {
    focusPath,
    boundaryElement: scrollElement,
    onItemClose
  }, $[129] = focusPath, $[130] = onItemClose, $[131] = scrollElement, $[132] = t16) : t16 = $[132], useTrackFocusPath(t16);
  const editorFocused = focused || hasFocusWithin, t17 = portal.element, t18 = !isActive, t19 = !!focused, t20 = editorFocused ? "" : void 0, t21 = readOnly ? "" : void 0, t22 = isFullscreen ? "expanded" : "collapsed";
  let t23;
  $[133] !== editorNode || $[134] !== isFullscreen ? (t23 = isFullscreen ? /* @__PURE__ */ jsx(ExpandedLayer, { children: editorNode }) : editorNode, $[133] = editorNode, $[134] = isFullscreen, $[135] = t23) : t23 = $[135];
  let t24;
  $[136] !== focused || $[137] !== onItemClose || $[138] !== scrollElement ? (t24 = /* @__PURE__ */ jsx(AnnotationObjectEditModal, { focused, onItemClose, referenceBoundary: scrollElement }), $[136] = focused, $[137] = onItemClose, $[138] = scrollElement, $[139] = t24) : t24 = $[139];
  let t25;
  $[140] !== boundaryElement || $[141] !== scrollElement ? (t25 = /* @__PURE__ */ jsx(CombinedAnnotationPopover, { floatingBoundary: boundaryElement, referenceBoundary: scrollElement }), $[140] = boundaryElement, $[141] = scrollElement, $[142] = t25) : t25 = $[142];
  let t26;
  $[143] !== t22 || $[144] !== t23 || $[145] !== t24 || $[146] !== t25 ? (t26 = /* @__PURE__ */ jsx(Box, { "data-wrapper": "", ref: setWrapperElement, children: /* @__PURE__ */ jsxs(Portal, { __unstable_name: t22, children: [
    t23,
    t24,
    t25
  ] }) }), $[143] = t22, $[144] = t23, $[145] = t24, $[146] = t25, $[147] = t26) : t26 = $[147];
  let t27;
  $[148] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t27 = /* @__PURE__ */ jsx("div", { "data-border": "" }), $[148] = t27) : t27 = $[148];
  let t28;
  $[149] !== t20 || $[150] !== t21 || $[151] !== t26 ? (t28 = /* @__PURE__ */ jsxs(Root$m, { "data-focused": t20, "data-read-only": t21, children: [
    t26,
    t27
  ] }), $[149] = t20, $[150] = t21, $[151] = t26, $[152] = t28) : t28 = $[152];
  let t29;
  $[153] !== changed || $[154] !== isFullscreen || $[155] !== path || $[156] !== t19 || $[157] !== t28 ? (t29 = /* @__PURE__ */ jsx(ChangeIndicator, { disabled: isFullscreen, hasFocus: t19, isChanged: changed, path, children: t28 }), $[153] = changed, $[154] = isFullscreen, $[155] = path, $[156] = t19, $[157] = t28, $[158] = t29) : t29 = $[158];
  let t30;
  $[159] !== onActivate || $[160] !== t18 || $[161] !== t29 ? (t30 = /* @__PURE__ */ jsx(ActivateOnFocus, { onActivate, isOverlayActive: t18, children: t29 }), $[159] = onActivate, $[160] = t18, $[161] = t29, $[162] = t30) : t30 = $[162];
  let t31;
  return $[163] !== portal.element || $[164] !== portalElements || $[165] !== t30 ? (t31 = /* @__PURE__ */ jsx(SelectedAnnotationsProvider, { children: /* @__PURE__ */ jsx(PortalProvider, { __unstable_elements: portalElements, element: t17, children: t30 }) }), $[163] = portal.element, $[164] = portalElements, $[165] = t30, $[166] = t31) : t31 = $[166], t31;
}
function FullscreenPTEProvider(t0) {
  const $ = c(17), {
    children
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[0] = t1) : t1 = $[0];
  const [fullscreenPaths, setFullscreenPaths] = useState(t1), telemetry = useTelemetry(), {
    enabled: enhancedObjectDialogEnabled
  } = useEnhancedObjectDialog();
  let t2;
  $[1] !== fullscreenPaths ? (t2 = (path) => fullscreenPaths.find((savedPath) => savedPath === pathToString(path)) ?? void 0, $[1] = fullscreenPaths, $[2] = t2) : t2 = $[2];
  const getFullscreenPath = t2;
  let t3;
  $[3] !== enhancedObjectDialogEnabled || $[4] !== fullscreenPaths || $[5] !== telemetry ? (t3 = (path_0, isFullscreen) => {
    isFullscreen ? (telemetry.log(OpenedPortableTextEditorFullScreen, {
      path: pathToString(path_0),
      origin: enhancedObjectDialogEnabled ? "nested-object" : "default"
    }), setFullscreenPaths([...fullscreenPaths, pathToString(path_0)])) : (telemetry.log(ClosedPortableTextEditorFullScreen, {
      path: pathToString(path_0),
      origin: enhancedObjectDialogEnabled ? "nested-object" : "default"
    }), setFullscreenPaths(fullscreenPaths.filter((savedPath_0) => savedPath_0 !== pathToString(path_0))));
  }, $[3] = enhancedObjectDialogEnabled, $[4] = fullscreenPaths, $[5] = telemetry, $[6] = t3) : t3 = $[6];
  const setFullscreenPath = t3;
  let t4;
  $[7] !== fullscreenPaths ? (t4 = () => fullscreenPaths.length > 0, $[7] = fullscreenPaths, $[8] = t4) : t4 = $[8];
  const hasAnyFullscreen = t4;
  let t5;
  $[9] !== fullscreenPaths || $[10] !== getFullscreenPath || $[11] !== hasAnyFullscreen || $[12] !== setFullscreenPath ? (t5 = {
    getFullscreenPath,
    setFullscreenPath,
    hasAnyFullscreen,
    allFullscreenPaths: fullscreenPaths
  }, $[9] = fullscreenPaths, $[10] = getFullscreenPath, $[11] = hasAnyFullscreen, $[12] = setFullscreenPath, $[13] = t5) : t5 = $[13];
  const contextValue = t5;
  let t6;
  return $[14] !== children || $[15] !== contextValue ? (t6 = /* @__PURE__ */ jsx(FullscreenPTEContext.Provider, { value: contextValue, children }), $[14] = children, $[15] = contextValue, $[16] = t6) : t6 = $[16], t6;
}
function useFullscreenPTE() {
  return useContext(FullscreenPTEContext);
}
function PortableTextMarkersProvider(props2) {
  const $ = c(3);
  let t0;
  return $[0] !== props2.children || $[1] !== props2.markers ? (t0 = /* @__PURE__ */ jsx(PortableTextMarkersContext.Provider, { value: props2.markers, children: props2.children }), $[0] = props2.children, $[1] = props2.markers, $[2] = t0) : t0 = $[2], t0;
}
function PortableTextMemberItemsProvider(props2) {
  const $ = c(3);
  let t0;
  return $[0] !== props2.children || $[1] !== props2.memberItems ? (t0 = /* @__PURE__ */ jsx(PortableTextMemberItemsContext.Provider, { value: props2.memberItems, children: props2.children }), $[0] = props2.children, $[1] = props2.memberItems, $[2] = t0) : t0 = $[2], t0;
}
function computeStringDiffRangeDecorations({
  diff,
  mapPayload = (payload) => payload,
  anchorPath = ROOT_PATH,
  focusPath = ROOT_PATH
}) {
  if (diff.type !== "string")
    return [];
  const segments = diff?.segments ?? [], {
    rangeDecorations
  } = segments.reduce((state, segment, index) => {
    const previousSegment = segments.at(index - 1), previousDecoration = state.rangeDecorations.at(-1);
    return segment.action === "added" && previousDecoration?.payload?.action === "removed" && typeof previousSegment < "u" && previousDecoration?.selection?.anchor?.offset === state.position ? (state.rangeDecorations.splice(state.rangeDecorations.length - 1, 1, {
      selection: {
        anchor: {
          path: anchorPath,
          offset: state.position
        },
        focus: {
          path: focusPath,
          offset: state.position + segment.text.length
        }
      },
      component: ({
        children
      }) => /* @__PURE__ */ jsxs("span", { children: [
        /* @__PURE__ */ jsx(previousDecoration.component, {}),
        /* @__PURE__ */ jsx(InsertedSegment, { segment, children })
      ] }),
      payload: mapPayload({
        id: segmentId(previousDecoration?.payload?.action, previousSegment.text, "added", segment.text),
        action: "merged"
      })
    }), state.position += segment.text.length, state) : segment.action === "added" ? (state.rangeDecorations.push({
      selection: {
        anchor: {
          path: anchorPath,
          offset: state.position
        },
        focus: {
          path: focusPath,
          offset: state.position + segment.text.length
        }
      },
      component: (props2) => /* @__PURE__ */ jsx(InsertedSegment, { segment, ...props2 }),
      payload: mapPayload({
        id: segmentId("added", segment.text),
        action: segment.action
      })
    }), state.position += segment.text.length, state) : segment.action === "removed" ? (state.rangeDecorations.push({
      selection: {
        anchor: {
          path: anchorPath,
          offset: state.position
        },
        focus: {
          path: focusPath,
          offset: state.position
        }
      },
      component: () => /* @__PURE__ */ jsx(DeletedSegment, { segment }),
      payload: mapPayload({
        id: segmentId("removed", segment.text),
        action: segment.action
      })
    }), state) : (segment.action === "unchanged" && (state.position += segment.text.length), state);
  }, {
    position: 0,
    rangeDecorations: []
  });
  return rangeDecorations;
}
function segmentId(...path) {
  return path.join(".");
}
function diffPortableTextFragment({
  upstreamValue = [],
  value = [],
  selector,
  perspective
}) {
  const upstreamSelection = selector(upstreamValue), selection = selector(value), isAdded = typeof upstreamSelection > "u" && typeof selection < "u", isRemoved = typeof upstreamSelection < "u" && typeof selection > "u", upstreamTextContent = typeof upstreamSelection < "u" && isPortableTextBlock(upstreamSelection) ? toPlainText(upstreamSelection) : "", textContent = typeof selection < "u" && isPortableTextBlock(selection) ? toPlainText(selection) : "", provenanceAnnotation = {
    provenance: {
      bundle: perspective
    }
  }, stringDiff = diffInput(wrap$1(upstreamTextContent, provenanceAnnotation), wrap$1(textContent, provenanceAnnotation), {});
  return {
    isAdded,
    isRemoved,
    stringDiff
  };
}
function computeRangeDecorationsForPortableText({
  value = [],
  upstreamValue = [],
  perspective
}) {
  return value.reduce((record, block) => {
    const {
      isAdded,
      stringDiff
    } = diffPortableTextFragment({
      upstreamValue,
      value,
      selector: (selectorValue) => selectorValue.find(({
        _key
      }) => _key === block._key),
      perspective
    });
    if (!isPortableTextBlock(block) || block.children.length === 0)
      return record;
    if (isAdded) {
      const textContent = toPlainText(block);
      return record[block._key] ??= [], record[block._key].push({
        selection: {
          anchor: {
            path: [{
              _key: block._key
            }],
            offset: 0
          },
          focus: {
            path: [{
              _key: block._key
            }],
            offset: textContent.length
          }
        },
        component: ({
          children
        }) => /* @__PURE__ */ jsx(InsertedSegment, { segment: {
          action: "added",
          type: "stringSegment",
          text: textContent,
          annotation: {
            provenance: {
              bundle: perspective
            }
          }
        }, children })
      }), record;
    }
    return stringDiff.isChanged && (record[block._key] ??= [], record[block._key].push(...computeStringDiffRangeDecorations({
      diff: stringDiff,
      anchorPath: [{
        _key: block._key
      }],
      focusPath: [{
        _key: block._key
      }]
    }))), record;
  }, {});
}
function diffMatchPatchToPortableText({
  path,
  value
}) {
  const block = path.reduceRight((portableText, segment, index) => {
    if (index === path.length - 1 && segment !== "text")
      throw new Error("Patch path must terminate at Portable Text text field");
    if (segment === "text")
      return {
        _type: "span",
        text: applyPatches(parsePatch(value), "")[0]
      };
    if (segment === "children")
      return {
        _type: "block",
        children: [portableText]
      };
    if (typeof segment == "object" && segment !== null) {
      if (!("_key" in segment))
        throw new Error("Expected `_key` in path segment");
      return portableText._key = segment._key, portableText;
    }
    throw new Error("Unexepected path segment");
  }, {});
  if (block._type === "block")
    return block;
}
function useOptimisticPortableTextDiff(t0) {
  const $ = c(17), {
    upstreamValue,
    definitiveValue,
    perspective,
    displayInlineChanges
  } = t0, [optimisticValue, setOptimisticValue] = useState();
  let t1;
  bb0: {
    if (!displayInlineChanges) {
      let t23;
      $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t23 = [], $[0] = t23) : t23 = $[0], t1 = t23;
      break bb0;
    }
    if (typeof perspective > "u") {
      let t23;
      $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t23 = [], $[1] = t23) : t23 = $[1], t1 = t23;
      break bb0;
    }
    let t22;
    if ($[2] !== definitiveValue || $[3] !== optimisticValue || $[4] !== perspective || $[5] !== upstreamValue) {
      const definitiveRangeDecorations = computeRangeDecorationsForPortableText({
        perspective,
        upstreamValue,
        value: definitiveValue
      }), optimisticRangeDecorations = computeRangeDecorationsForPortableText({
        perspective,
        upstreamValue,
        value: typeof optimisticValue > "u" ? [] : [optimisticValue]
      });
      t22 = Object.values(optimisticRangeDecorations).concat(Object.entries(definitiveRangeDecorations).filter((t32) => {
        const [blockKey] = t32;
        return typeof optimisticRangeDecorations[blockKey] > "u";
      }).map(_temp$2J)).flat(), $[2] = definitiveValue, $[3] = optimisticValue, $[4] = perspective, $[5] = upstreamValue, $[6] = t22;
    } else
      t22 = $[6];
    t1 = t22;
  }
  const rangeDecorations = t1;
  let t2;
  $[7] !== definitiveValue || $[8] !== displayInlineChanges || $[9] !== optimisticValue ? (t2 = (patch2) => {
    if (!displayInlineChanges)
      return;
    const [rootPathSegment] = patch2.path;
    if (typeof rootPathSegment != "object" || !("_key" in rootPathSegment))
      return;
    const rootBlock = [optimisticValue].concat(definitiveValue).find((subject) => typeof subject < "u" && isPortableTextBlock(subject) && subject._key === rootPathSegment._key);
    if (typeof rootBlock > "u") {
      const insertedBlock = diffMatchPatchToPortableText(patch2);
      setOptimisticValue(insertedBlock);
      return;
    }
    const [node] = extractWithPath(arrayToJSONMatchPath(patch2.path), rootBlock);
    if (typeof node > "u")
      return;
    const [nextNodeValue] = applyPatches(parsePatch(patch2.value), typeof node.value == "string" ? node.value : ""), nextOptimisticValue = set$2(typeof rootBlock > "u" ? {} : structuredClone(rootBlock), node?.path, nextNodeValue);
    setOptimisticValue(nextOptimisticValue);
  }, $[7] = definitiveValue, $[8] = displayInlineChanges, $[9] = optimisticValue, $[10] = t2) : t2 = $[10];
  const onOptimisticChange = t2;
  let t3;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setOptimisticValue(void 0);
  }, $[11] = t3) : t3 = $[11];
  let t4;
  $[12] !== definitiveValue ? (t4 = [definitiveValue], $[12] = definitiveValue, $[13] = t4) : t4 = $[13], useEffect(t3, t4);
  let t5;
  return $[14] !== onOptimisticChange || $[15] !== rangeDecorations ? (t5 = {
    rangeDecorations,
    onOptimisticChange
  }, $[14] = onOptimisticChange, $[15] = rangeDecorations, $[16] = t5) : t5 = $[16], t5;
}
function _temp$2J(t0) {
  const [, blockRangeDecorations] = t0;
  return blockRangeDecorations;
}
function InvalidValue(props2) {
  const $ = c(42), {
    onChange,
    onIgnore,
    resolution,
    readOnly
  } = props2, telemetry = useTelemetry(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== onChange || $[1] !== resolution || $[2] !== telemetry ? (t0 = () => {
    resolution && (onChange({
      type: "mutation",
      patches: resolution.patches
    }), telemetry.log(PortableTextInvalidValueResolve, {
      PTEInvalidValueId: resolution.i18n.description,
      PTEInvalidValueDescription: resolution.description
    }));
  }, $[0] = onChange, $[1] = resolution, $[2] = telemetry, $[3] = t0) : t0 = $[3];
  const handleAction = t0;
  let t1;
  $[4] !== onIgnore || $[5] !== telemetry ? (t1 = () => {
    telemetry.log(PortableTextInvalidValueIgnore), onIgnore();
  }, $[4] = onIgnore, $[5] = telemetry, $[6] = t1) : t1 = $[6];
  const handleOnIgnore = t1;
  if (!resolution)
    return null;
  let t2;
  $[7] !== t ? (t2 = t("inputs.portable-text.invalid-value.title"), $[7] = t, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== t2 ? (t3 = /* @__PURE__ */ jsx(Fragment$1, { children: t2 }), $[9] = t2, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== handleAction || $[12] !== handleOnIgnore || $[13] !== readOnly || $[14] !== resolution.action || $[15] !== resolution.i18n.action || $[16] !== resolution.i18n.values || $[17] !== t ? (t4 = resolution.action && /* @__PURE__ */ jsxs(Grid, { columns: [1, 2], gap: 1, children: [
    /* @__PURE__ */ jsx(Button$1, { mode: "ghost", onClick: handleOnIgnore, text: t("inputs.portable-text.invalid-value.ignore-button.text") }),
    !readOnly && /* @__PURE__ */ jsx(Button$1, { onClick: handleAction, text: /* @__PURE__ */ jsx(Translate, { t, i18nKey: resolution.i18n.action, values: resolution.i18n.values }), tone: "caution" })
  ] }), $[11] = handleAction, $[12] = handleOnIgnore, $[13] = readOnly, $[14] = resolution.action, $[15] = resolution.i18n.action, $[16] = resolution.i18n.values, $[17] = t, $[18] = t4) : t4 = $[18];
  let t5;
  $[19] !== resolution.action || $[20] !== t ? (t5 = resolution.action && /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t("inputs.portable-text.invalid-value.action-disclaimer") }), $[19] = resolution.action, $[20] = t, $[21] = t5) : t5 = $[21];
  let t6;
  $[22] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { padding: 3, children: t5 }), $[22] = t5, $[23] = t6) : t6 = $[23];
  let t7;
  $[24] !== t4 || $[25] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { padding: 2, children: [
    t4,
    t6
  ] }), $[24] = t4, $[25] = t6, $[26] = t7) : t7 = $[26];
  let t8;
  $[27] !== resolution.i18n.description || $[28] !== resolution.i18n.values || $[29] !== t ? (t8 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: resolution.i18n.description, values: resolution.i18n.values }) }), $[27] = resolution.i18n.description, $[28] = resolution.i18n.values, $[29] = t, $[30] = t8) : t8 = $[30];
  let t9;
  $[31] !== resolution.item ? (t9 = JSON.stringify(resolution.item, null, 2), $[31] = resolution.item, $[32] = t9) : t9 = $[32];
  let t10;
  $[33] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { border: !0, overflow: "auto", padding: 2, tone: "inherit", children: /* @__PURE__ */ jsx(Code, { language: "json", children: t9 }) }), $[33] = t9, $[34] = t10) : t10 = $[34];
  let t11;
  $[35] !== t10 || $[36] !== t8 ? (t11 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t8,
    t10
  ] }), $[35] = t10, $[36] = t8, $[37] = t11) : t11 = $[37];
  let t12;
  return $[38] !== t11 || $[39] !== t3 || $[40] !== t7 ? (t12 = /* @__PURE__ */ jsx(Alert, { title: t3, suffix: t7, children: t11 }), $[38] = t11, $[39] = t3, $[40] = t7, $[41] = t12) : t12 = $[41], t12;
}
function pickInputComponent(plugin) {
  return plugin.form?.components?.input;
}
function pickFieldComponent(plugin) {
  return plugin.form?.components?.field;
}
function pickPreviewComponent(plugin) {
  return plugin.form?.components?.preview;
}
function pickItemComponent(plugin) {
  return plugin.form?.components?.item;
}
function pickBlockComponent(plugin) {
  return plugin.form?.components?.block;
}
function pickInlineBlockComponent(plugin) {
  return plugin.form?.components?.inlineBlock;
}
function pickAnnotationComponent(plugin) {
  return plugin.form?.components?.annotation;
}
function pickPortableTextEditorPluginsComponent(plugin) {
  return plugin.form?.components?.portableText?.plugins;
}
const markdownConfig = {
  boldDecorator: ({
    schema: schema2
  }) => schema2.decorators.find((decorator) => decorator.name === "strong")?.name,
  codeDecorator: ({
    schema: schema2
  }) => schema2.decorators.find((decorator) => decorator.name === "code")?.name,
  italicDecorator: ({
    schema: schema2
  }) => schema2.decorators.find((decorator) => decorator.name === "em")?.name,
  strikeThroughDecorator: ({
    schema: schema2
  }) => schema2.decorators.find((decorator) => decorator.name === "strike-through")?.name,
  defaultStyle: ({
    schema: schema2
  }) => schema2.styles.find((style) => style.name === "normal")?.name,
  blockquoteStyle: ({
    schema: schema2
  }) => schema2.styles.find((style) => style.name === "blockquote")?.name,
  headingStyle: ({
    schema: schema2,
    level
  }) => schema2.styles.find((style) => style.name === `h${level}`)?.name,
  orderedListStyle: ({
    schema: schema2
  }) => schema2.lists.find((list) => list.name === "number")?.name,
  unorderedListStyle: ({
    schema: schema2
  }) => schema2.lists.find((list) => list.name === "bullet")?.name
}, PortableTextEditorPlugins = (props2) => {
  const $ = c(15), schemaTypes = usePortableTextMemberSchemaTypes(), isOneLineEditor = !!schemaTypes.block.options?.oneLine;
  let t0;
  $[0] !== schemaTypes.block.options?.unstable_whitespaceOnPasteMode ? (t0 = defineBehavior({
    on: "deserialize.data",
    guard: (t12) => {
      const {
        snapshot: snapshot2,
        event
      } = t12;
      if (event.mimeType !== "text/html")
        return !1;
      const blocks = htmlToPortableText(event.data, {
        schema: snapshot2.context.schema,
        keyGenerator: snapshot2.context.keyGenerator,
        whitespaceMode: schemaTypes.block.options?.unstable_whitespaceOnPasteMode
      });
      return blocks.length === 0 ? {
        type: "deserialization.failure",
        mimeType: "text/html",
        reason: "No blocks deserialized"
      } : {
        type: "deserialization.success",
        mimeType: "text/html",
        data: blocks
      };
    },
    actions: [_temp$2I]
  }), $[0] = schemaTypes.block.options?.unstable_whitespaceOnPasteMode, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 ? (t1 = [t0], $[2] = t0, $[3] = t1) : t1 = $[3];
  const htmlPasteBehaviors = t1;
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    plugins: {
      markdown: {
        config: markdownConfig
      },
      pasteLink: {},
      typography: {
        guard: createDecoratorGuard({
          decorators: _temp3$A
        })
      }
    },
    renderDefault: RenderDefault
  }, $[4] = t2) : t2 = $[4];
  const componentProps = t2, CustomComponent = props2.schemaType.components?.portableText?.plugins;
  let t3;
  $[5] !== htmlPasteBehaviors ? (t3 = /* @__PURE__ */ jsx(BehaviorPlugin, { behaviors: htmlPasteBehaviors }), $[5] = htmlPasteBehaviors, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== isOneLineEditor ? (t4 = isOneLineEditor && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(OneLinePlugin, {}),
    /* @__PURE__ */ jsx(BehaviorPlugin, { behaviors: [defineBehavior({
      on: "insert.soft break",
      actions: []
    })] })
  ] }), $[7] = isOneLineEditor, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== CustomComponent ? (t5 = CustomComponent ? /* @__PURE__ */ jsx(CustomComponent, { ...componentProps }) : /* @__PURE__ */ jsx(RenderDefault, { ...componentProps }), $[9] = CustomComponent, $[10] = t5) : t5 = $[10];
  let t6;
  return $[11] !== t3 || $[12] !== t4 || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t3,
    t4,
    t5
  ] }), $[11] = t3, $[12] = t4, $[13] = t5, $[14] = t6) : t6 = $[14], t6;
};
function DefaultPortableTextEditorPlugins(props2) {
  const $ = c(10);
  let t0;
  $[0] !== props2.plugins.markdown ? (t0 = /* @__PURE__ */ jsx(DefaultMarkdownShortcutsPlugin, { ...props2.plugins.markdown }), $[0] = props2.plugins.markdown, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== props2.plugins.pasteLink ? (t1 = /* @__PURE__ */ jsx(DefaultPasteLinkPlugin, { ...props2.plugins.pasteLink }), $[2] = props2.plugins.pasteLink, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== props2.plugins.typography ? (t2 = /* @__PURE__ */ jsx(DefaultTypographyPlugin, { ...props2.plugins.typography }), $[4] = props2.plugins.typography, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== t0 || $[7] !== t1 || $[8] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t0,
    t1,
    t2
  ] }), $[6] = t0, $[7] = t1, $[8] = t2, $[9] = t3) : t3 = $[9], t3;
}
function DefaultMarkdownShortcutsPlugin(incomingProps) {
  const $ = c(17);
  let t0;
  $[0] !== incomingProps ? (t0 = incomingProps ?? {}, $[0] = incomingProps, $[1] = t0) : t0 = $[1];
  const props2 = t0;
  if (!props2.config) {
    let enabled, markdownShortcutsPluginProps;
    if ($[2] !== props2) {
      const {
        enabled: t13,
        config,
        ...t22
      } = props2;
      enabled = t13, markdownShortcutsPluginProps = t22, $[2] = props2, $[3] = enabled, $[4] = markdownShortcutsPluginProps;
    } else
      enabled = $[3], markdownShortcutsPluginProps = $[4];
    if (enabled === !1)
      return null;
    let t12;
    return $[5] !== markdownShortcutsPluginProps ? (t12 = /* @__PURE__ */ jsx(MarkdownShortcutsPlugin, { ...markdownShortcutsPluginProps }), $[5] = markdownShortcutsPluginProps, $[6] = t12) : t12 = $[6], t12;
  }
  let orderedList, orderedListStyle, restMarkdownConfig, unorderedList, unorderedListStyle;
  $[7] !== props2.config ? ({
    orderedList,
    orderedListStyle,
    unorderedList,
    unorderedListStyle,
    ...restMarkdownConfig
  } = props2.config, $[7] = props2.config, $[8] = orderedList, $[9] = orderedListStyle, $[10] = restMarkdownConfig, $[11] = unorderedList, $[12] = unorderedListStyle) : (orderedList = $[8], orderedListStyle = $[9], restMarkdownConfig = $[10], unorderedList = $[11], unorderedListStyle = $[12]);
  const t1 = orderedList ?? orderedListStyle, t2 = unorderedList ?? unorderedListStyle;
  let t3;
  return $[13] !== restMarkdownConfig || $[14] !== t1 || $[15] !== t2 ? (t3 = /* @__PURE__ */ jsx(MarkdownShortcutsPlugin, { orderedList: t1, unorderedList: t2, ...restMarkdownConfig }), $[13] = restMarkdownConfig, $[14] = t1, $[15] = t2, $[16] = t3) : t3 = $[16], t3;
}
function DefaultPasteLinkPlugin(props2) {
  const $ = c(7);
  let t0;
  $[0] !== props2 ? (t0 = props2 ?? {}, $[0] = props2, $[1] = t0) : t0 = $[1];
  let enabled, pasteLinkPluginProps;
  if ($[2] !== t0 ? ({
    enabled,
    ...pasteLinkPluginProps
  } = t0, $[2] = t0, $[3] = enabled, $[4] = pasteLinkPluginProps) : (enabled = $[3], pasteLinkPluginProps = $[4]), enabled === !1)
    return null;
  let t1;
  return $[5] !== pasteLinkPluginProps ? (t1 = /* @__PURE__ */ jsx(PasteLinkPlugin, { ...pasteLinkPluginProps }), $[5] = pasteLinkPluginProps, $[6] = t1) : t1 = $[6], t1;
}
function DefaultTypographyPlugin(props2) {
  const $ = c(7);
  let t0;
  $[0] !== props2 ? (t0 = props2 ?? {}, $[0] = props2, $[1] = t0) : t0 = $[1];
  let enabled, typographyPluginProps;
  if ($[2] !== t0 ? ({
    enabled,
    ...typographyPluginProps
  } = t0, $[2] = t0, $[3] = enabled, $[4] = typographyPluginProps) : (enabled = $[3], typographyPluginProps = $[4]), enabled === !1)
    return null;
  let t1;
  return $[5] !== typographyPluginProps ? (t1 = /* @__PURE__ */ jsx(TypographyPlugin, { ...typographyPluginProps }), $[5] = typographyPluginProps, $[6] = t1) : t1 = $[6], t1;
}
const RenderDefault = (props2) => {
  const $ = c(4);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultPortableTextEditorPlugins,
    pick: pickPortableTextEditorPluginsComponent
  }, $[0] = t0) : t0 = $[0];
  const RenderPlugins = useMiddlewareComponents(t0);
  let t1;
  return $[1] !== RenderPlugins || $[2] !== props2 ? (t1 = /* @__PURE__ */ jsx(RenderPlugins, { ...props2 }), $[1] = RenderPlugins, $[2] = props2, $[3] = t1) : t1 = $[3], t1;
};
function _temp$2I(t0, deserializeEvent) {
  const {
    event: event_0
  } = t0;
  return [raise({
    ...deserializeEvent,
    originEvent: event_0.originEvent
  })];
}
function _temp2$18(decorator) {
  return decorator.name === "code" ? [] : [decorator.name];
}
function _temp3$A(t0) {
  const {
    context
  } = t0;
  return context.schema.decorators.flatMap(_temp2$18);
}
const DOT_SIZE = 6, CONTENT_BOX_VARIANTS = {
  animate: {
    opacity: 1,
    scaleX: 1,
    scaleY: 1
  },
  exit: {
    opacity: 0,
    scaleX: 0,
    scaleY: 0.5
  },
  initial: {
    opacity: 0,
    scaleX: 0,
    scaleY: 0.5
  }
}, CONTENT_BOX_TRANSITION = {
  duration: 0.3,
  ease: "easeInOut",
  type: "spring",
  bounce: 0
}, CONTENT_TEXT_VARIANTS = {
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  },
  initial: {
    opacity: 0
  }
}, CONTENT_TEXT_TRANSITION = {
  duration: 0.2,
  delay: 0.15
}, CursorLine = /* @__PURE__ */ styled.span.withConfig({
  displayName: "CursorLine",
  componentId: "sc-mj5gcd-0"
})(({
  theme,
  $tints
}) => {
  const isDark = getTheme_v2(theme)?.color._dark, bg = $tints[isDark ? 400 : 500].hex, fg = $tints[isDark ? 900 : 50].hex;
  return css`
    --presence-cursor-bg: ${bg};
    --presence-cursor-fg: ${fg};

    border-left: 1px solid transparent;
    border-color: var(--presence-cursor-bg);
    margin-left: -1px;
    position: relative;
    word-break: normal;
    white-space: normal;
    mix-blend-mode: unset;
    pointer-events: none;
  `;
}), CursorDot = styled.div.withConfig({
  displayName: "CursorDot",
  componentId: "sc-mj5gcd-1"
})`background-color:var(--presence-cursor-bg);border-radius:50%;width:${DOT_SIZE}px;height:${DOT_SIZE}px;position:absolute;top:-${DOT_SIZE - 1}px;left:-0.5px;transform:translateX(-50%);mix-blend-mode:unset;z-index:0;pointer-events:all;&:before{content:'';position:absolute;top:-${DOT_SIZE / 2}px;left:50%;transform:translateX(-50%);width:${DOT_SIZE * 2}px;height:${DOT_SIZE * 3}px;opacity:0.5;}`, UserBox = /* @__PURE__ */ styled(motion.create(Box)).withConfig({
  displayName: "UserBox",
  componentId: "sc-mj5gcd-2"
})(({
  theme
}) => {
  const radius = getTheme_v2(theme)?.radius[4];
  return css`
    position: absolute;
    top: -${DOT_SIZE * 1.5}px;
    left: -${DOT_SIZE * 0.75}px;
    transform-origin: left;
    white-space: nowrap;
    padding: 3px 6px;
    box-sizing: border-box;
    border-radius: ${radius}px;
    background-color: var(--presence-cursor-bg);
    z-index: 1;
    mix-blend-mode: unset;
    user-select: none;
  `;
}), UserText = styled(motion.create(Text$1)).withConfig({
  displayName: "UserText",
  componentId: "sc-mj5gcd-3"
})`color:var(--presence-cursor-fg);mix-blend-mode:unset;`;
function UserPresenceCursor(props2) {
  const $ = c(17), {
    children,
    user
  } = props2, {
    tints
  } = useUserColor(user.id), [hovered, setHovered] = useState(!1);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setHovered(!0), $[0] = t0) : t0 = $[0];
  const handleMouseEnter = t0;
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setHovered(!1), $[1] = t1) : t1 = $[1];
  const handleMouseLeave = t1;
  let t2;
  $[2] !== user.displayName ? (t2 = user.displayName?.split(" ").join("-"), $[2] = user.displayName, $[3] = t2) : t2 = $[3];
  const testId = `presence-cursor-${t2}`;
  let t3;
  $[4] !== hovered || $[5] !== user.displayName ? (t3 = hovered && /* @__PURE__ */ jsx(UserBox, { animate: "animate", exit: "exit", flex: 1, initial: "initial", transition: CONTENT_BOX_TRANSITION, variants: CONTENT_BOX_VARIANTS, children: /* @__PURE__ */ jsx(UserText, { animate: "animate", exit: "exit", initial: "initial", size: 0, transition: CONTENT_TEXT_TRANSITION, variants: CONTENT_TEXT_VARIANTS, weight: "medium", children: user.displayName }) }), $[4] = hovered, $[5] = user.displayName, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(AnimatePresence, { children: t3 }), $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(CursorDot, {}), $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t4 || $[11] !== testId || $[12] !== tints ? (t6 = /* @__PURE__ */ jsxs(CursorLine, { $tints: tints, contentEditable: !1, "data-testid": testId, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: [
    t4,
    t5
  ] }), $[10] = t4, $[11] = testId, $[12] = tints, $[13] = t6) : t6 = $[13];
  let t7;
  return $[14] !== children || $[15] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t6,
    children
  ] }), $[14] = children, $[15] = t6, $[16] = t7) : t7 = $[16], t7;
}
function usePresenceCursorDecorations(props2) {
  const $ = c(10), {
    path
  } = props2, fieldPresence = useFormFieldPresence();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const [currentPresence, setCurrentPresence] = useState(t0);
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[1] = t1) : t1 = $[1];
  const [presenceCursorDecorations, setPresenceCursorDecorations] = useState(t1), previousPresence = useRef(currentPresence);
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (details) => {
    const {
      rangeDecoration,
      newSelection
    } = details;
    setPresenceCursorDecorations((prev) => prev.map((p) => p.payload?.sessionId === rangeDecoration.payload?.sessionId ? {
      ...rangeDecoration,
      selection: newSelection
    } : p));
  }, $[2] = t2) : t2 = $[2];
  const handleRangeDecorationMoved = t2;
  let t3, t4;
  $[3] !== fieldPresence || $[4] !== path ? (t3 = () => {
    const nextPresence = fieldPresence.filter((p_0) => startsWith(path, p_0.path) && !isEqual$1(path, p_0.path)), filteredNext = nextPresence.map(_temp$2H), filteredPrevious = previousPresence.current.map(_temp2$17);
    if (!isEqual$1(filteredNext, filteredPrevious)) {
      const value = nextPresence.length > 0 ? nextPresence : EMPTY_ARRAY$y;
      setCurrentPresence(value), previousPresence.current = value;
    }
  }, t4 = [fieldPresence, path], $[3] = fieldPresence, $[4] = path, $[5] = t3, $[6] = t4) : (t3 = $[5], t4 = $[6]), useEffect(t3, t4);
  let t5, t6;
  return $[7] !== currentPresence ? (t5 = () => {
    const decorations = currentPresence.map((presence) => {
      if (!presence.selection)
        return null;
      const cursorPoint = {
        focus: presence.selection.focus,
        anchor: presence.selection.focus
      };
      return {
        component: (t7) => {
          const {
            children
          } = t7;
          return /* @__PURE__ */ jsx(UserPresenceCursor, { user: presence.user, children });
        },
        selection: cursorPoint,
        onMoved: handleRangeDecorationMoved,
        payload: {
          sessionId: presence.sessionId
        }
      };
    });
    setPresenceCursorDecorations(decorations.filter(Boolean));
  }, t6 = [currentPresence, handleRangeDecorationMoved], $[7] = currentPresence, $[8] = t5, $[9] = t6) : (t5 = $[8], t6 = $[9]), useEffect(t5, t6), presenceCursorDecorations;
}
function _temp2$17(d_0) {
  return {
    ...d_0.selection,
    sessionId: d_0.sessionId
  };
}
function _temp$2H(d) {
  return {
    ...d.selection,
    sessionId: d.sessionId
  };
}
function usePatches(props2) {
  const $ = c(5), {
    path
  } = props2, {
    patchChannel
  } = useFormBuilder().__internal;
  let t0;
  $[0] !== patchChannel || $[1] !== path ? (t0 = (subscriber) => patchChannel.subscribe((t12) => {
    const {
      snapshot: snapshot2,
      patches
    } = t12, filteredPatches = patches.filter((patch2) => _startsWith(patch2.path, path)).map((patch_0) => ({
      ...patch_0,
      path: patch_0.path.slice(path.length)
    }));
    filteredPatches.length && subscriber({
      shouldReset: _shouldReset(path, patches),
      snapshot: isRecord$4(snapshot2) ? _getValueAtPath(snapshot2, path) : {},
      patches: filteredPatches
    });
  }), $[0] = patchChannel, $[1] = path, $[2] = t0) : t0 = $[2];
  const subscribe2 = t0;
  let t1;
  return $[3] !== subscribe2 ? (t1 = {
    subscribe: subscribe2
  }, $[3] = subscribe2, $[4] = t1) : t1 = $[4], t1;
}
function _isSegmentEqual(segment1, segment2) {
  const segment1Type = typeof segment1;
  return segment1Type !== typeof segment2 ? !1 : segment1Type === "object" ? shallowEquals(segment1, segment2) : segment1 === segment2;
}
function _startsWith(subjectPath, checkPath2) {
  if (subjectPath === checkPath2)
    return !0;
  if (!Array.isArray(subjectPath) || !Array.isArray(checkPath2) || subjectPath.length < checkPath2.length)
    return !1;
  for (let i = 0, len = checkPath2.length; i < len; i++)
    if (!_isSegmentEqual(checkPath2[i], subjectPath[i]))
      return !1;
  return !0;
}
function _isAncestor(path1, path2) {
  return path1.length === 0 || _startsWith(path2, path1) && !_startsWith(path1, path2);
}
function _shouldReset(path, patches) {
  return patches.some((patch2) => _isAncestor(patch2.path, path) && (patch2.type === "set" || patch2.type === "unset"));
}
function _getValueAtPath(value, path) {
  return path.reduce((result, segment) => typeof segment == "object" ? find$1(result, segment) : get(result, segment), value);
}
function keyGenerator() {
  return randomKey$1(12);
}
const EditorRefPlugin$1 = forwardRef((_, ref) => {
  const $ = c(2), portableTextEditor = usePortableTextEditor(), portableTextEditorRef = useRef(portableTextEditor);
  let t0, t1;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => portableTextEditorRef.current, t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useImperativeHandle(ref, t0, t1), null;
});
EditorRefPlugin$1.displayName = "EditorRefPlugin";
function PortableTextInput(props2) {
  const {
    editorRef: editorRefProp,
    elementProps,
    hotkeys,
    initialActive,
    initialFullscreen,
    markers = EMPTY_ARRAY$y,
    onChange,
    onCopy,
    onEditorChange,
    onFullScreenChange,
    onInsert,
    onItemRemove,
    onPaste,
    onPathFocus,
    path,
    readOnly,
    rangeDecorations: rangeDecorationsProp,
    renderBlockActions,
    renderCustomMarkers,
    schemaType,
    value,
    displayInlineChanges
  } = props2, {
    onBlur,
    ref: elementRef
  } = elementProps, defaultEditorRef = useRef(null), editorRef = editorRefProp || defaultEditorRef, presenceCursorDecorations = usePresenceCursorDecorations(useMemo(() => ({
    path: props2.path
  }), [props2.path])), {
    selectedPerspective
  } = usePerspective(), {
    rangeDecorations: diffRangeDecorations,
    onOptimisticChange
  } = useOptimisticPortableTextDiff({
    upstreamValue: props2.hasUpstreamVersion ? props2.compareValue : [],
    definitiveValue: value,
    perspective: selectedPerspective,
    displayInlineChanges
  }), [ignoreValidationError, setIgnoreValidationError] = useState(!1), [invalidValue, setInvalidValue] = useState(null), [isActive, setIsActive] = useState(initialActive ?? !0), [hasFocusWithin, setHasFocusWithin] = useState(!1), [ready, setReady] = useState(!1), telemetry = useTelemetry(), {
    getFullscreenPath,
    setFullscreenPath
  } = useFullscreenPTE(), [isFullscreen, setIsFullscreen] = useState(!!getFullscreenPath(path) || (initialFullscreen ?? !1)), hasSyncedInitialFullscreenRef = useRef(!1), previousPathRef = useRef(path);
  useEffect(() => {
    !hasSyncedInitialFullscreenRef.current && initialFullscreen && !getFullscreenPath(path) && (hasSyncedInitialFullscreenRef.current = !0, setFullscreenPath(path, !0));
  }, [initialFullscreen, path, getFullscreenPath, setFullscreenPath]), useEffect(() => {
    if (pathToString(previousPathRef.current) !== pathToString(path)) {
      previousPathRef.current = path;
      const currentFullscreenPath = getFullscreenPath(path);
      setIsFullscreen(!!currentFullscreenPath);
    }
  }, [getFullscreenPath, path]);
  const divergenceNavigator = useDocumentDivergences(), controlImplicitExpandedState = useEffectEvent(() => {
    const focusedDivergenceDescendsNode = typeof divergenceNavigator.state.focusedDivergence < "u" && startsWith(path, fromString(divergenceNavigator.state.focusedDivergence));
    if (!(typeof divergenceNavigator.state.focusedDivergence > "u" && isFullscreen)) {
      if (focusedDivergenceDescendsNode && !isFullscreen) {
        setFullscreenPath(path, !0), onFullScreenChange?.(!0), setIsFullscreen(!0);
        return;
      }
      !focusedDivergenceDescendsNode && isFullscreen && (setFullscreenPath(path, !1), onFullScreenChange?.(!1), setIsFullscreen(!1));
    }
  });
  useEffect(() => controlImplicitExpandedState(), [divergenceNavigator.state.focusedDivergence]);
  const toast = useToast(), handleToggleFullscreen = useCallback(() => {
    const next = !isFullscreen;
    next ? telemetry.log(PortableTextInputExpanded) : telemetry.log(PortableTextInputCollapsed), setFullscreenPath(path, next), onFullScreenChange?.(next), setIsFullscreen(next);
  }, [telemetry, path, setFullscreenPath, onFullScreenChange, isFullscreen]);
  useEffect(() => {
    invalidValue && value !== invalidValue.value && setInvalidValue(null);
  }, [invalidValue, value]);
  const portableTextMemberItems = usePortableTextMemberItemsFromProps(props2);
  useEffect(() => {
    hasFocusWithin && setIsActive(!0);
  }, [hasFocusWithin]);
  const setFocusPathFromEditorSelection = useCallback((nextSelection) => {
    const focusPath = nextSelection?.focus.path;
    if (!focusPath) return;
    const nextFocusPath = focusPath.length === 3 && // A span path is always 3 segments long
    focusPath[1] === "children" && // Is a child of a block
    isKeySegment(focusPath[2]) && // Contains the key of the child
    !portableTextMemberItems.some((item) => isKeySegment(focusPath[2]) && item.member.key === focusPath[2]._key) ? focusPath.concat(["text"]) : focusPath;
    startTransition(() => {
      onPathFocus(nextFocusPath, {
        selection: nextSelection
      });
    });
  }, [onPathFocus, portableTextMemberItems]), handleEditorChange = useCallback((change) => {
    switch (change.type) {
      case "mutation":
        onChange(toFormPatches(change.patches));
        break;
      case "selection":
        setFocusPathFromEditorSelection(change.selection);
        break;
      case "focus":
        setIsActive(!0), setHasFocusWithin(!0);
        break;
      case "blur":
        onBlur(change.event), setHasFocusWithin(!1);
        break;
      case "invalidValue":
        setInvalidValue(change);
        break;
      case "error":
        toast.push({
          status: change.level,
          description: change.description
        });
        break;
      case "ready":
        setReady(!0);
        break;
    }
    editorRef.current && onEditorChange && onEditorChange(change, editorRef.current);
  }, [editorRef, onEditorChange, onChange, setFocusPathFromEditorSelection, onBlur, toast]);
  useEffect(() => {
    setIgnoreValidationError(!1);
  }, [value]);
  const handleIgnoreInvalidValue = useCallback(() => {
    setIgnoreValidationError(!0);
  }, []), respondToInvalidContent = useMemo(() => invalidValue && invalidValue.resolution ? /* @__PURE__ */ jsx(Box, { marginBottom: 2, children: /* @__PURE__ */ jsx(InvalidValue, { onChange: handleEditorChange, onIgnore: handleIgnoreInvalidValue, resolution: invalidValue.resolution, readOnly }) }) : null, [handleEditorChange, handleIgnoreInvalidValue, invalidValue, readOnly]), handleActivate = useCallback(() => {
    isActive || (setIsActive(!0), editorRef.current && PortableTextEditor.focus(editorRef.current));
  }, [editorRef, isActive]), previousRangeDecorations = useRef([]), rangeDecorations = useMemo(() => {
    const result = displayInlineChanges ? diffRangeDecorations : [...rangeDecorationsProp || [], ...presenceCursorDecorations], reconciled = immutableReconcile(previousRangeDecorations.current, result);
    return previousRangeDecorations.current = reconciled, reconciled;
  }, [diffRangeDecorations, displayInlineChanges, presenceCursorDecorations, rangeDecorationsProp]);
  return /* @__PURE__ */ jsxs(Box, { children: [
    !ignoreValidationError && respondToInvalidContent,
    (!invalidValue || ignoreValidationError) && /* @__PURE__ */ jsx(PortableTextMemberSchemaTypesProvider, { schemaType, children: /* @__PURE__ */ jsx(PortableTextMarkersProvider, { markers, children: /* @__PURE__ */ jsx(PortableTextMemberItemsProvider, { memberItems: portableTextMemberItems, children: /* @__PURE__ */ jsxs(EditorProvider, { initialConfig: {
      initialValue: value,
      readOnly: readOnly || !ready,
      keyGenerator,
      schemaDefinition: sanitySchemaToPortableTextSchema(schemaType)
    }, children: [
      /* @__PURE__ */ jsx(EditorChangePlugin, { onChange: handleEditorChange, onOptimisticChange }),
      /* @__PURE__ */ jsx(EditorRefPlugin$1, { ref: editorRef }),
      /* @__PURE__ */ jsx(PatchesPlugin, { path }),
      /* @__PURE__ */ jsx(UpdateReadOnlyPlugin$1, { readOnly: readOnly || !ready }),
      /* @__PURE__ */ jsx(UpdateValuePlugin$2, { value }),
      /* @__PURE__ */ jsx(PortableTextEditorPlugins, { schemaType }),
      /* @__PURE__ */ jsx(Compositor, { ...props2, elementRef, hasFocusWithin, hotkeys, isActive, isFullscreen, onActivate: handleActivate, onItemRemove, onCopy, onInsert, onPaste, onToggleFullscreen: handleToggleFullscreen, rangeDecorations, readOnly: readOnly || !ready, renderBlockActions, renderCustomMarkers })
    ] }) }) }) })
  ] });
}
function EditorChangePlugin(props2) {
  const $ = c(4);
  let t0;
  $[0] !== props2 ? (t0 = (event) => {
    bb2: switch (event.type) {
      case "blurred": {
        props2.onChange({
          type: "blur",
          event: event.event
        });
        break bb2;
      }
      case "error": {
        props2.onChange({
          type: "error",
          name: event.name,
          level: "warning",
          description: event.description
        });
        break bb2;
      }
      case "focused": {
        props2.onChange({
          type: "focus",
          event: event.event
        });
        break bb2;
      }
      case "loading": {
        props2.onChange({
          type: "loading",
          isLoading: !0
        });
        break bb2;
      }
      case "done loading": {
        props2.onChange({
          type: "loading",
          isLoading: !1
        });
        break bb2;
      }
      case "invalid value": {
        props2.onChange({
          type: "invalidValue",
          resolution: event.resolution,
          value: event.value
        });
        break bb2;
      }
      case "mutation": {
        props2.onChange({
          type: "mutation",
          snapshot: event.value,
          patches: event.patches
        });
        break bb2;
      }
      case "patch": {
        event.patch.type === "diffMatchPatch" && event.patch.origin === "local" && props2.onOptimisticChange(event.patch), props2.onChange(event);
        break bb2;
      }
      case "ready": {
        props2.onChange(event);
        break bb2;
      }
      case "selection": {
        props2.onChange(event);
        break bb2;
      }
      case "value changed": {
        props2.onChange({
          type: "value",
          value: event.value
        });
        break bb2;
      }
    }
  }, $[0] = props2, $[1] = t0) : t0 = $[1];
  const handleEditorEvent = t0;
  let t1;
  return $[2] !== handleEditorEvent ? (t1 = /* @__PURE__ */ jsx(EventListenerPlugin, { on: handleEditorEvent }), $[2] = handleEditorEvent, $[3] = t1) : t1 = $[3], t1;
}
function PatchesPlugin(props2) {
  const $ = c(6), editor2 = useEditor();
  let t0;
  $[0] !== props2.path ? (t0 = {
    path: props2.path
  }, $[0] = props2.path, $[1] = t0) : t0 = $[1];
  const {
    subscribe: subscribe2
  } = usePatches(t0);
  let t1, t2;
  return $[2] !== editor2 || $[3] !== subscribe2 ? (t1 = () => {
    const unsubscribe = subscribe2((t3) => {
      const {
        patches,
        snapshot: snapshot2
      } = t3;
      editor2.send({
        type: "patches",
        patches,
        snapshot: snapshot2
      });
    });
    return () => unsubscribe();
  }, t2 = [editor2, subscribe2], $[2] = editor2, $[3] = subscribe2, $[4] = t1, $[5] = t2) : (t1 = $[4], t2 = $[5]), useEffect(t1, t2), null;
}
function UpdateValuePlugin$2(props2) {
  const $ = c(4), editor2 = useEditor();
  let t0, t1;
  return $[0] !== editor2 || $[1] !== props2.value ? (t0 = () => {
    editor2.send({
      type: "update value",
      value: props2.value
    });
  }, t1 = [editor2, props2.value], $[0] = editor2, $[1] = props2.value, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1), null;
}
function UpdateReadOnlyPlugin$1(props2) {
  const $ = c(4), editor2 = useEditor();
  let t0, t1;
  return $[0] !== editor2 || $[1] !== props2.readOnly ? (t0 = () => {
    editor2.send({
      type: "update readOnly",
      readOnly: props2.readOnly
    });
  }, t1 = [editor2, props2.readOnly], $[0] = editor2, $[1] = props2.readOnly, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1), null;
}
function toFormPatches(patches) {
  return patches.map((p) => ({
    ...p,
    patchType: SANITY_PATCH_TYPE
  }));
}
function useOptimisticDiff(t0) {
  const $ = c(23), {
    definitiveValue,
    computeDiff
  } = t0, [optimisticValue, setOptimisticValue] = useState(definitiveValue), [currentSignal, setCurrentSignal] = useState("definitive");
  let t1;
  $[0] !== computeDiff || $[1] !== optimisticValue ? (t1 = computeDiff(optimisticValue), $[0] = computeDiff, $[1] = optimisticValue, $[2] = t1) : t1 = $[2];
  const t2 = t1;
  let t3;
  $[3] !== computeDiff || $[4] !== definitiveValue ? (t3 = computeDiff(definitiveValue), $[3] = computeDiff, $[4] = definitiveValue, $[5] = t3) : t3 = $[5];
  const t4 = t3;
  let t5;
  $[6] !== t2 || $[7] !== t4 ? (t5 = {
    optimistic: t2,
    definitive: t4
  }, $[6] = t2, $[7] = t4, $[8] = t5) : t5 = $[8];
  const diff = t5[currentSignal];
  let t6;
  $[9] !== optimisticValue ? (t6 = (value) => {
    const [nextOptimisticValue] = applyPatches(parsePatch(value), optimisticValue ?? "");
    setOptimisticValue(nextOptimisticValue), setCurrentSignal("optimistic");
  }, $[9] = optimisticValue, $[10] = t6) : t6 = $[10];
  const onOptimisticChange = t6;
  let t7, t8;
  $[11] !== definitiveValue ? (t7 = () => {
    setCurrentSignal("definitive"), setOptimisticValue(definitiveValue);
  }, t8 = [definitiveValue], $[11] = definitiveValue, $[12] = t7, $[13] = t8) : (t7 = $[12], t8 = $[13]), useEffect(t7, t8);
  let t9;
  $[14] !== currentSignal ? (t9 = (payload) => ({
    ...payload,
    currentSignal
  }), $[14] = currentSignal, $[15] = t9) : t9 = $[15];
  let t10;
  $[16] !== diff || $[17] !== t9 ? (t10 = computeStringDiffRangeDecorations({
    diff,
    mapPayload: t9
  }), $[16] = diff, $[17] = t9, $[18] = t10) : t10 = $[18];
  const rangeDecorations = t10;
  let t11;
  return $[19] !== diff || $[20] !== onOptimisticChange || $[21] !== rangeDecorations ? (t11 = {
    diff,
    rangeDecorations,
    onOptimisticChange
  }, $[19] = diff, $[20] = onOptimisticChange, $[21] = rangeDecorations, $[22] = t11) : t11 = $[22], t11;
}
function packageValue(value) {
  return [{
    _type: "block",
    _key: "root",
    children: [{
      _type: "span",
      _key: "root",
      text: value ?? ""
    }]
  }];
}
const ROOT_STYLE = css`
  &:not([hidden]) {
    display: flex;
  }

  align-items: center;
`;
function textInputRootStyle() {
  return ROOT_STYLE;
}
function textInputBaseStyle(props2) {
  const {
    $scheme,
    $tone,
    $weight
  } = props2, {
    color,
    font
  } = getTheme_v2(props2.theme);
  return css`
    appearance: none;
    background: none;
    border: 0;
    border-radius: 0;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    font-family: ${font.text.family};
    font-weight: ${$weight && font.text.weights[$weight] || font.text.weights.regular};
    margin: 0;
    position: relative;
    z-index: 1;
    display: block;

    /* NOTE: This is a hack to disable Chrome’s autofill styles */
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: var(--input-fg-color) !important;
      transition: background-color 5000s;
      transition-delay: 86400s /* 24h */;
    }

    /* &:is(textarea) */
    &[data-as='textarea'] {
      resize: none;
    }

    color: var(--input-fg-color);

    &::placeholder {
      color: var(--input-placeholder-color);
    }

    &[data-scheme='${$scheme}'][data-tone='${$tone}'] {
      --input-fg-color: ${color.input.default.enabled.fg};
      --input-placeholder-color: ${color.input.default.enabled.placeholder};

      /* enabled */
      &:not(:invalid):not(:disabled):not([data-read-only='true']) {
        --input-fg-color: ${color.input.default.enabled.fg};
        --input-placeholder-color: ${color.input.default.enabled.placeholder};
      }

      /* disabled */
      &:not(:invalid):disabled {
        --input-fg-color: ${color.input.default.disabled.fg};
        --input-placeholder-color: ${color.input.default.disabled.placeholder};
      }

      /* invalid */
      &:invalid {
        --input-fg-color: ${color.input.invalid.enabled.fg};
        --input-placeholder-color: ${color.input.invalid.enabled.placeholder};
      }

      /* readOnly */
      &[data-read-only='true'] {
        --input-fg-color: ${color.input.default.readOnly.fg};
        --input-placeholder-color: ${color.input.default.readOnly.placeholder};
      }
    }
  `;
}
function textInputRepresentationStyle(props2) {
  const {
    $hasPrefix,
    $hasSuffix,
    $scheme,
    $tone,
    $unstableDisableFocusRing
  } = props2, {
    color,
    input
  } = getTheme_v2(props2.theme);
  return css`
    --input-box-shadow: none;

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    pointer-events: none;
    z-index: 0;

    background-color: var(--card-bg-color);
    box-shadow: var(--input-box-shadow);

    border-top-left-radius: ${$hasPrefix ? 0 : void 0};
    border-bottom-left-radius: ${$hasPrefix ? 0 : void 0};
    border-top-right-radius: ${$hasSuffix ? 0 : void 0};
    border-bottom-right-radius: ${$hasSuffix ? 0 : void 0};

    &[data-scheme='${$scheme}'][data-tone='${$tone}'] {
      --card-bg-color: ${color.input.default.enabled.bg};
      --card-fg-color: ${color.input.default.enabled.fg};

      /* enabled */
      *:not(:disabled) + &[data-border] {
        --input-box-shadow: ${focusRingBorderStyle$3({
    color: color.input.default.enabled.border,
    width: input.border.width
  })};
      }

      /* invalid */
      *:not(:disabled).invalid + & {
        --card-bg-color: ${color.input.invalid.enabled.bg};
        --card-fg-color: ${color.input.invalid.enabled.fg};

        &[data-border] {
          --input-box-shadow: ${focusRingBorderStyle$3({
    color: color.input.invalid.enabled.border,
    width: input.border.width
  })};
        }
      }

      /* focused */
      *:not(:disabled):focus + & {
        &[data-border] {
          --input-box-shadow: ${$unstableDisableFocusRing ? void 0 : focusRingStyle$2({
    border: {
      color: color.input.default.enabled.border,
      width: input.border.width
    },
    focusRing: input.text.focusRing
  })};
        }

        &:not([data-border]) {
          --input-box-shadow: ${$unstableDisableFocusRing ? void 0 : focusRingStyle$2({
    focusRing: input.text.focusRing
  })};
        }
      }

      /* disabled */
      *:not(.invalid):disabled + & {
        --card-bg-color: ${color.input.default.disabled.bg} !important;
        --card-fg-color: ${color.input.default.disabled.fg} !important;
        --card-icon-color: ${color.input.default.disabled.fg} !important;

        &[data-border] {
          --input-box-shadow: ${focusRingBorderStyle$3({
    color: color.input.default.disabled.border,
    width: input.border.width
  })};
        }
      }

      *.invalid:disabled + & {
        --card-bg-color: ${color.input.invalid.disabled.bg} !important;
        --card-fg-color: ${color.input.invalid.disabled.fg} !important;
        --card-icon-color: ${color.input.invalid.disabled.fg} !important;

        &[data-border] {
          --input-box-shadow: ${focusRingBorderStyle$3({
    color: color.input.invalid.disabled.border,
    width: input.border.width
  })};
        }
      }

      /* readOnly */
      *:not(.invalid)[data-read-only='true'] + & {
        --card-bg-color: ${color.input.default.readOnly.bg} !important;
        --card-fg-color: ${color.input.default.readOnly.fg} !important;
      }

      *.invalid[data-read-only='true'] + & {
        --card-bg-color: ${color.input.invalid.readOnly.bg} !important;
        --card-fg-color: ${color.input.invalid.readOnly.fg} !important;
      }

      /* hovered */
      @media (hover: hover) {
        *:not(:disabled):not([data-read-only='true']):not(.invalid):hover + & {
          --card-bg-color: ${color.input.default.hovered.bg};
          --card-fg-color: ${color.input.default.hovered.fg};
        }

        *.invalid:not(:disabled):not([data-read-only='true']):hover + & {
          --card-bg-color: ${color.input.invalid.hovered.bg};
          --card-fg-color: ${color.input.invalid.hovered.fg};
        }

        *:not(:disabled):not([data-read-only='true']):not(.invalid):not(:focus):hover
          + &[data-border] {
          --input-box-shadow: ${focusRingBorderStyle$3({
    color: color.input.default.hovered.border,
    width: input.border.width
  })};
        }

        *.invalid:not(:disabled):not([data-read-only='true']):not(:focus):hover + &[data-border] {
          --input-box-shadow: ${focusRingBorderStyle$3({
    color: color.input.invalid.hovered.border,
    width: input.border.width
  })};
        }
      }
    }
  `;
}
function responsiveInputPaddingStyle(props2) {
  const {
    $fontSize,
    $iconLeft,
    $iconRight,
    $padding,
    $space
  } = props2, {
    font,
    media,
    space
  } = getTheme_v2(props2.theme), len = Math.max($padding.length, $space.length, $fontSize.length), _padding = [], _space = [], _fontSize = [];
  for (let i = 0; i < len; i += 1)
    _fontSize[i] = $fontSize[i] === void 0 ? _fontSize[i - 1] : $fontSize[i], _padding[i] = $padding[i] === void 0 ? _padding[i - 1] : $padding[i], _space[i] = $space[i] === void 0 ? _space[i - 1] : $space[i];
  return _responsive(media, _padding, (_, i) => {
    const size = font.text.sizes[_fontSize[i]] || font.text.sizes[2], emSize = size.lineHeight - size.ascenderHeight - size.descenderHeight, p = space[_padding[i]], s = space[_space[i]], styles = {
      paddingTop: rem(p - size.ascenderHeight),
      paddingRight: rem(p),
      paddingBottom: rem(p - size.descenderHeight),
      paddingLeft: rem(p)
    };
    return $iconRight && (styles.paddingRight = rem(p + emSize + s)), $iconLeft && (styles.paddingLeft = rem(p + emSize + s)), styles;
  });
}
function textInputFontSizeStyle(props2) {
  const {
    font,
    media
  } = getTheme_v2(props2.theme);
  return _responsive(media, props2.$fontSize, (sizeIndex) => {
    const size = font.text.sizes[sizeIndex] || font.text.sizes[2];
    return {
      fontSize: rem(size.fontSize),
      lineHeight: size.lineHeight / size.fontSize
    };
  });
}
function unpackageValue(value = []) {
  return value.filter((block) => isPortableTextBlock(block)).find(({
    _key
  }) => _key === "root")?.children?.find(({
    _key
  }) => _key === "root")?.text ?? "";
}
const ROOT_PATH = [{
  _key: "root"
}, "children", {
  _key: "root"
}], INVALID_CLASS_NAME = "invalid", StyledRoot = styled.div.withConfig({
  displayName: "StyledRoot",
  componentId: "sc-13yzieu-0"
})`flex:1;min-width:0;display:block;position:relative;`, StyledInput = styled(PortableTextEditable).withConfig({
  displayName: "StyledInput",
  componentId: "sc-13yzieu-1"
})`${textInputRootStyle} ${textInputBaseStyle} ${responsiveInputPaddingStyle} ${textInputFontSizeStyle} ${stringDiffContainerStyles}`, StyledEditorRepresentation = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "StyledEditorRepresentation",
  componentId: "sc-13yzieu-2"
})(textInputRepresentationStyle), StyledPlaceholder = styled.span.withConfig({
  displayName: "StyledPlaceholder",
  componentId: "sc-13yzieu-3"
})`${responsiveInputPaddingStyle}`;
function StringInputPortableText(props2) {
  const $ = c(50), {
    elementProps,
    onChange,
    value: definitiveValue,
    __unstable_computeDiff: computeDiff
  } = props2, {
    onFocus,
    onBlur,
    style
  } = elementProps;
  let t0;
  $[0] !== computeDiff || $[1] !== definitiveValue ? (t0 = {
    definitiveValue,
    computeDiff
  }, $[0] = computeDiff, $[1] = definitiveValue, $[2] = t0) : t0 = $[2];
  const {
    diff,
    rangeDecorations,
    onOptimisticChange
  } = useOptimisticDiff(t0);
  let t1;
  $[3] !== definitiveValue || $[4] !== onBlur || $[5] !== onChange || $[6] !== onFocus || $[7] !== onOptimisticChange ? (t1 = (event) => {
    if (event.type === "focused") {
      onFocus(event.event);
      return;
    }
    if (event.type === "blurred") {
      onBlur(event.event);
      return;
    }
    if (event.type === "patch" && event.patch.type === "diffMatchPatch" && event.patch.origin === "local") {
      onOptimisticChange(event.patch.value);
      return;
    }
    if (event.type === "mutation") {
      const value = unpackageValue(event.value), valueRemainsUndefined = typeof definitiveValue > "u" && value === "", valueBecomesUndefined = typeof definitiveValue < "u" && value === "";
      if (!(value !== definitiveValue && !valueRemainsUndefined))
        return;
      if (valueBecomesUndefined) {
        onChange(unset());
        return;
      }
      onChange(set(value));
    }
  }, $[3] = definitiveValue, $[4] = onBlur, $[5] = onChange, $[6] = onFocus, $[7] = onOptimisticChange, $[8] = t1) : t1 = $[8];
  const handleEditorEvent = t1;
  let t2;
  $[9] !== props2.readOnly || $[10] !== props2.value ? (t2 = () => ({
    initialValue: packageValue(props2.value),
    readOnly: props2.readOnly ?? !1,
    schemaDefinition: defineSchema({})
  }), $[9] = props2.readOnly, $[10] = props2.value, $[11] = t2) : t2 = $[11];
  const [initialConfig] = useState(t2), rootTheme = useRootTheme(), fontSize = useArrayProp(2), padding = useArrayProp(3), radius = useArrayProp(2), space = useArrayProp(3), diffSegments = diff.type === "string" ? diff.segments : void 0;
  let t3;
  $[12] !== diff.fromValue || $[13] !== diff.toValue || $[14] !== diffSegments || $[15] !== fontSize || $[16] !== padding || $[17] !== space ? (t3 = () => diff.fromValue && diff.toValue === "" && diffSegments ? /* @__PURE__ */ jsx(StyledPlaceholder, { $fontSize: fontSize, $space: space, $padding: padding, children: /* @__PURE__ */ jsx(DeletedSegment, { segment: diffSegments[0] }) }) : null, $[12] = diff.fromValue, $[13] = diff.toValue, $[14] = diffSegments, $[15] = fontSize, $[16] = padding, $[17] = space, $[18] = t3) : t3 = $[18];
  const renderPlaceholder = t3;
  let t4;
  $[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(OneLinePlugin, {}), $[19] = t4) : t4 = $[19];
  let t5;
  $[20] !== handleEditorEvent ? (t5 = /* @__PURE__ */ jsx(EventListenerPlugin, { on: handleEditorEvent }), $[20] = handleEditorEvent, $[21] = t5) : t5 = $[21];
  let t6;
  $[22] !== props2.value ? (t6 = /* @__PURE__ */ jsx(UpdateValuePlugin$1, { value: props2.value }), $[22] = props2.value, $[23] = t6) : t6 = $[23];
  const t7 = props2.readOnly ?? !1;
  let t8;
  $[24] !== t7 ? (t8 = /* @__PURE__ */ jsx(UpdateReadOnlyPlugin$1, { readOnly: t7 }), $[24] = t7, $[25] = t8) : t8 = $[25];
  let t9;
  $[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = /* @__PURE__ */ jsx(BehaviorPlugin, { behaviors: [plainTextPasteBehaviour, plainTextOneLineBehaviour] }), $[26] = t9) : t9 = $[26];
  const t10 = props2.validationError ? INVALID_CLASS_NAME : void 0, t11 = props2.displayInlineChanges ? renderPlaceholder : void 0, t12 = props2.displayInlineChanges ? rangeDecorations : void 0;
  let t13;
  $[27] !== fontSize || $[28] !== padding || $[29] !== rootTheme.scheme || $[30] !== rootTheme.tone || $[31] !== space || $[32] !== style || $[33] !== t10 || $[34] !== t11 || $[35] !== t12 ? (t13 = /* @__PURE__ */ jsx(StyledInput, { className: t10, style, renderPlaceholder: t11, rangeDecorations: t12, $fontSize: fontSize, $space: space, $padding: padding, $scheme: rootTheme.scheme, $tone: rootTheme.tone, "data-scheme": rootTheme.scheme, "data-tone": rootTheme.tone, "data-testid": "string-input-portable-text" }), $[27] = fontSize, $[28] = padding, $[29] = rootTheme.scheme, $[30] = rootTheme.tone, $[31] = space, $[32] = style, $[33] = t10, $[34] = t11, $[35] = t12, $[36] = t13) : t13 = $[36];
  let t14;
  $[37] !== initialConfig || $[38] !== t13 || $[39] !== t5 || $[40] !== t6 || $[41] !== t8 ? (t14 = /* @__PURE__ */ jsxs(EditorProvider, { initialConfig, children: [
    t4,
    t5,
    t6,
    t8,
    t9,
    t13
  ] }), $[37] = initialConfig, $[38] = t13, $[39] = t5, $[40] = t6, $[41] = t8, $[42] = t14) : t14 = $[42];
  let t15;
  $[43] !== radius || $[44] !== rootTheme.scheme || $[45] !== rootTheme.tone ? (t15 = /* @__PURE__ */ jsx(StyledEditorRepresentation, { radius, $scheme: rootTheme.scheme, $tone: rootTheme.tone, "data-scheme": rootTheme.scheme, "data-tone": rootTheme.tone, "data-border": !0 }), $[43] = radius, $[44] = rootTheme.scheme, $[45] = rootTheme.tone, $[46] = t15) : t15 = $[46];
  let t16;
  return $[47] !== t14 || $[48] !== t15 ? (t16 = /* @__PURE__ */ jsxs(StyledRoot, { children: [
    t14,
    t15
  ] }), $[47] = t14, $[48] = t15, $[49] = t16) : t16 = $[49], t16;
}
function UpdateValuePlugin$1(props2) {
  const $ = c(4), editor2 = useEditor();
  let t0, t1;
  return $[0] !== editor2 || $[1] !== props2.value ? (t0 = () => {
    editor2.send({
      type: "update value",
      value: packageValue(props2.value)
    });
  }, t1 = [editor2, props2.value], $[0] = editor2, $[1] = props2.value, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1), null;
}
const plainTextPasteBehaviour = defineBehavior({
  on: "clipboard.paste",
  actions: [(event) => [raise({
    type: "insert.text",
    text: event.event.originEvent.dataTransfer.getData("text")
  })]]
}), plainTextOneLineBehaviour = defineBehavior({
  on: "insert.text",
  actions: [({
    event
  }) => [forward({
    type: "insert.text",
    text: event.text.replaceAll(/\n+/g, " ")
  })]]
});
function StringInput(props2) {
  const $ = c(4);
  if (props2.displayInlineChanges) {
    let t02;
    return $[0] !== props2 ? (t02 = /* @__PURE__ */ jsx(StringInputPortableText, { ...props2 }), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== props2 ? (t0 = /* @__PURE__ */ jsx(StringInputBasic, { ...props2 }), $[2] = props2, $[3] = t0) : t0 = $[3], t0;
}
const StyledTextArea = styled(TextArea).withConfig({
  displayName: "StyledTextArea",
  componentId: "sc-1l7jyxo-0"
})`&[data-as='textarea']{resize:vertical;}`;
function TextInput(props2) {
  const $ = c(6), {
    schemaType,
    validationError,
    value,
    elementProps
  } = props2, t0 = value || "", t1 = typeof schemaType.rows == "number" ? schemaType.rows : 10;
  let t2;
  return $[0] !== elementProps || $[1] !== schemaType.placeholder || $[2] !== t0 || $[3] !== t1 || $[4] !== validationError ? (t2 = /* @__PURE__ */ jsx(StyledTextArea, { customValidity: validationError, value: t0, placeholder: schemaType.placeholder, rows: t1, ...elementProps }), $[0] = elementProps, $[1] = schemaType.placeholder, $[2] = t0, $[3] = t1, $[4] = validationError, $[5] = t2) : t2 = $[5], t2;
}
function UrlInput(props2) {
  const $ = c(4), {
    schemaType,
    validationError,
    elementProps
  } = props2, inputType = getValidationRule(schemaType, "uri")?.constraint?.options?.allowRelative ? "text" : "url";
  let t0;
  return $[0] !== elementProps || $[1] !== inputType || $[2] !== validationError ? (t0 = /* @__PURE__ */ jsx(TextInput$1, { type: inputType, inputMode: "url", customValidity: validationError, ...elementProps }), $[0] = elementProps, $[1] = inputType, $[2] = validationError, $[3] = t0) : t0 = $[3], t0;
}
const EMPTY_ARRAY$m = [], INITIAL_LOADING_STATE$3 = {
  enabled: !0,
  error: null,
  features: EMPTY_ARRAY$m,
  isLoading: !0
}, FEATURES = {
  contentReleases: "contentReleases",
  studioComments: "studioComments",
  crossDatasetReferences: "crossDatasetReferences",
  scheduledPublishing: "scheduledPublishing",
  sanityTasks: "sanityTasks",
  singleDocRelease: "singleDocRelease"
};
function fetchFeatures({
  versionedClient: versionedClient2
}) {
  return versionedClient2.observable.request({
    uri: "/features",
    tag: "features"
  });
}
const cachedFeatureRequest = /* @__PURE__ */ new Map();
function getFeatures({
  projectId,
  versionedClient: versionedClient2
}) {
  let features2 = cachedFeatureRequest.get(projectId);
  return features2 || (features2 = fetchFeatures({
    versionedClient: versionedClient2
  }).pipe(shareReplay()), cachedFeatureRequest.set(projectId, features2)), features2;
}
function useFeatureEnabled(featureKey) {
  const $ = c(8), versionedClient2 = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    projectId
  } = useSource();
  let t0;
  $[0] !== projectId || $[1] !== versionedClient2 ? (t0 = getFeatures({
    projectId,
    versionedClient: versionedClient2
  }), $[0] = projectId, $[1] = versionedClient2, $[2] = t0) : t0 = $[2];
  const req = t0;
  let t1;
  if ($[3] !== featureKey || $[4] !== req) {
    let t2;
    $[6] !== featureKey ? (t2 = (t3) => {
      const features2 = t3 === void 0 ? [] : t3;
      return {
        isLoading: !1,
        enabled: !!features2?.includes(featureKey),
        features: features2,
        error: null
      };
    }, $[6] = featureKey, $[7] = t2) : t2 = $[7], t1 = req.pipe(map(t2), startWith(INITIAL_LOADING_STATE$3), catchError(_temp$2G)), $[3] = featureKey, $[4] = req, $[5] = t1;
  } else
    t1 = $[5];
  return useObservable(t1, INITIAL_LOADING_STATE$3);
}
function _temp$2G(error) {
  return of({
    isLoading: !1,
    enabled: !1,
    features: EMPTY_ARRAY$m,
    error
  });
}
function DisabledFeatureWarning(t0) {
  const $ = c(29), {
    value,
    onClearValue
  } = t0, hasRef = !!value?._ref, {
    t
  } = useTranslation();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    DocumentationLink: _temp$2F
  }, $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== t ? (t2 = /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.cross-dataset.feature-disabled-description", components: t1 }), $[1] = t, $[2] = t2) : t2 = $[2];
  const description = t2, t3 = hasRef ? 4 : void 0;
  let t4;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[3] = t4) : t4 = $[3];
  let t5;
  $[4] !== t ? (t5 = t("inputs.reference.cross-dataset.feature-unavailable-title"), $[4] = t, $[5] = t5) : t5 = $[5];
  let t6;
  $[6] !== t5 ? (t6 = /* @__PURE__ */ jsx(Text$1, { as: "h2", size: 1, weight: "medium", children: t5 }), $[6] = t5, $[7] = t6) : t6 = $[7];
  let t7;
  $[8] !== description || $[9] !== hasRef || $[10] !== t ? (t7 = hasRef && /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, children: description }),
    /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, children: t("inputs.reference.cross-dataset.feature-disabled-actions") })
  ] }), $[8] = description, $[9] = hasRef, $[10] = t, $[11] = t7) : t7 = $[11];
  let t8;
  $[12] !== description || $[13] !== hasRef ? (t8 = !hasRef && /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, children: description }), $[12] = description, $[13] = hasRef, $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== t6 || $[16] !== t7 || $[17] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t6,
    t7,
    t8
  ] }), $[15] = t6, $[16] = t7, $[17] = t8, $[18] = t9) : t9 = $[18];
  let t10;
  $[19] !== t3 || $[20] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { gap: 4, marginBottom: t3, children: [
    t4,
    t9
  ] }), $[19] = t3, $[20] = t9, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== hasRef || $[23] !== onClearValue || $[24] !== t ? (t11 = onClearValue && hasRef && /* @__PURE__ */ jsx(Button, { icon: ResetIcon, mode: "ghost", onClick: onClearValue, text: t("inputs.reference.action.clear"), width: "fill" }), $[22] = hasRef, $[23] = onClearValue, $[24] = t, $[25] = t11) : t11 = $[25];
  let t12;
  return $[26] !== t10 || $[27] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Card, { tone: "caution", padding: 4, border: !0, radius: 2, "data-testid": "alert-cross-dataset-reference-feature-disabled", children: [
    t10,
    t11
  ] }), $[26] = t10, $[27] = t11, $[28] = t12) : t12 = $[28], t12;
}
function _temp$2F(t0) {
  const {
    children
  } = t0;
  return /* @__PURE__ */ jsx("a", { href: "https://www.sanity.io/docs/cross-dataset-references", target: "_blank", rel: "noreferrer", children });
}
const StyledPreviewFlex$1 = styled(Flex).withConfig({
  displayName: "StyledPreviewFlex",
  componentId: "sc-1vqxa6c-0"
})`min-height:36px;`;
function CrossDatasetReferencePreview(props2) {
  const $ = c(37), {
    refType,
    showStudioUrlIcon,
    hasStudioUrl,
    showTypeLabel,
    availability,
    preview,
    id: id2,
    dataset,
    projectId
  } = props2, notFound = availability?.reason === "NOT_FOUND", insufficientPermissions = availability?.reason === "PERMISSION_DENIED", previewMedia = preview.published?.media, {
    t
  } = useTranslation();
  let t0;
  bb0: {
    if (previewMedia) {
      const isValidImageAsset = typeof previewMedia?.asset < "u" && isImageSource(previewMedia);
      let t13;
      $[0] !== previewMedia ? (t13 = isValidElement(previewMedia), $[0] = previewMedia, $[1] = t13) : t13 = $[1];
      const isValidElement$1 = t13;
      if (!isValidImageAsset && !isValidElement$1) {
        t0 = null;
        break bb0;
      }
      let t22;
      $[2] !== dataset || $[3] !== isValidElement$1 || $[4] !== previewMedia || $[5] !== projectId || $[6] !== t ? (t22 = function(t32) {
        const {
          dimensions
        } = t32;
        return isValidElement$1 ? previewMedia : /* @__PURE__ */ jsx("img", { src: createImageUrlBuilder({
          dataset,
          projectId
        }).image(previewMedia).withOptions(dimensions).url(), alt: t("inputs.reference.image-preview-alt-text"), referrerPolicy: "strict-origin-when-cross-origin" });
      }, $[2] = dataset, $[3] = isValidElement$1, $[4] = previewMedia, $[5] = projectId, $[6] = t, $[7] = t22) : t22 = $[7], t0 = t22;
      break bb0;
    }
    if (!refType?.icon) {
      t0 = null;
      break bb0;
    }
    const Icon2 = refType.icon;
    let t12;
    $[8] !== Icon2 ? (t12 = /* @__PURE__ */ jsx(Icon2, {}), $[8] = Icon2, $[9] = t12) : t12 = $[9], t0 = t12;
  }
  const media = t0;
  let t1;
  $[10] !== availability?.available || $[11] !== media || $[12] !== preview.published?.subtitle || $[13] !== preview.published?.title || $[14] !== t ? (t1 = availability?.available ? /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(DefaultPreview, { title: preview.published?.title, subtitle: preview.published?.subtitle, media: media || !1 }) }) : /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, children: t("inputs.reference.error.document-unavailable-title") }) }) }) }), $[10] = availability?.available, $[11] = media, $[12] = preview.published?.subtitle, $[13] = preview.published?.title, $[14] = t, $[15] = t1) : t1 = $[15];
  let t2;
  $[16] !== refType || $[17] !== showTypeLabel ? (t2 = refType && showTypeLabel && /* @__PURE__ */ jsx(Badge, { mode: "outline", children: refType.title || refType.type }), $[16] = refType, $[17] = showTypeLabel, $[18] = t2) : t2 = $[18];
  let t3;
  $[19] !== id2 || $[20] !== insufficientPermissions || $[21] !== notFound || $[22] !== t ? (t3 = (insufficientPermissions || notFound) && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t(notFound ? "inputs.reference.referenced-document-does-not-exist" : "inputs.reference.referenced-document-insufficient-permissions", {
    documentId: id2
  }), children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", children: insufficientPermissions ? /* @__PURE__ */ jsx(AccessDeniedIcon, {}) : /* @__PURE__ */ jsx(HelpCircleIcon, {}) }) }) }), $[19] = id2, $[20] = insufficientPermissions, $[21] = notFound, $[22] = t, $[23] = t3) : t3 = $[23];
  let t4;
  $[24] !== hasStudioUrl || $[25] !== insufficientPermissions || $[26] !== notFound || $[27] !== showStudioUrlIcon || $[28] !== t ? (t4 = !(notFound || insufficientPermissions) && showStudioUrlIcon && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t(hasStudioUrl ? "inputs.reference.document-opens-in-new-tab" : "input.reference.document-cannot-be-opened.failed-to-resolve-url"), children: /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "default", muted: !hasStudioUrl, children: /* @__PURE__ */ jsx(LaunchIcon, {}) }) }) }), $[24] = hasStudioUrl, $[25] = insufficientPermissions, $[26] = notFound, $[27] = showStudioUrlIcon, $[28] = t, $[29] = t4) : t4 = $[29];
  let t5;
  $[30] !== t2 || $[31] !== t3 || $[32] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { paddingLeft: 3, children: /* @__PURE__ */ jsxs(Inline, { space: 4, paddingRight: 1, children: [
    t2,
    t3,
    t4
  ] }) }), $[30] = t2, $[31] = t3, $[32] = t4, $[33] = t5) : t5 = $[33];
  let t6;
  return $[34] !== t1 || $[35] !== t5 ? (t6 = /* @__PURE__ */ jsxs(StyledPreviewFlex$1, { align: "center", justify: "center", flex: 1, "data-testid": "preview", children: [
    t1,
    t5
  ] }), $[34] = t1, $[35] = t5, $[36] = t6) : t6 = $[36], t6;
}
const noop$4 = () => {
}, INITIAL_LOADING_STATE$2 = {
  isLoading: !0,
  result: void 0,
  error: void 0,
  retry: noop$4
}, EMPTY_STATE$1 = {
  isLoading: !1,
  result: void 0,
  error: void 0,
  retry: noop$4
};
function useReferenceInfo$1(doc, getReferenceInfo2) {
  const $ = c(8), [retryAttempt, setRetryAttempt] = useState(0);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setRetryAttempt(_temp$2E);
  }, $[0] = t0) : t0 = $[0];
  const retry2 = t0;
  let t1;
  $[1] !== doc._id || $[2] !== doc._type ? (t1 = {
    _id: doc._id,
    _type: doc._type
  }, $[1] = doc._id, $[2] = doc._type, $[3] = t1) : t1 = $[3];
  const docInfo = t1;
  let t2;
  return $[4] !== docInfo || $[5] !== getReferenceInfo2 || $[6] !== retryAttempt ? (t2 = docInfo._id ? getReferenceInfo2(docInfo).pipe(map((result) => ({
    isLoading: !1,
    result,
    error: void 0,
    retry: retry2,
    retryAttempt
  })), startWith(INITIAL_LOADING_STATE$2), catchError((err) => (console.error(err), of({
    isLoading: !1,
    result: void 0,
    error: err,
    retry: retry2,
    retryAttempt
  })))) : of(EMPTY_STATE$1), $[4] = docInfo, $[5] = getReferenceInfo2, $[6] = retryAttempt, $[7] = t2) : t2 = $[7], useObservable(t2, INITIAL_LOADING_STATE$2);
}
function _temp$2E(current) {
  return current + 1;
}
function useProjectId$1() {
  const $ = c(2), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0;
  return $[0] !== client ? (t0 = client.config(), $[0] = client, $[1] = t0) : t0 = $[1], t0.projectId;
}
function OptionPreview$1(props2) {
  const $ = c(29), {
    isLoading,
    result: referenceInfo,
    error
  } = useReferenceInfo$1(props2.document, props2.getReferenceInfo), {
    t
  } = useTranslation(), projectId = useProjectId$1();
  if (isLoading) {
    let t02;
    $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(TextSkeleton, { style: {
      maxWidth: 320
    }, radius: 1, animated: !0 }), $[0] = t02) : t02 = $[0];
    let t12;
    return $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsxs(Stack, { space: 2, padding: 1, children: [
      t02,
      /* @__PURE__ */ jsx(TextSkeleton, { style: {
        maxWidth: 200
      }, radius: 1, size: 1, animated: !0 })
    ] }), $[1] = t12) : t12 = $[1], t12;
  }
  if (error) {
    let t02;
    $[2] !== t ? (t02 = t("inputs.reference.error.failed-to-load-document-title"), $[2] = t, $[3] = t02) : t02 = $[3];
    let t12;
    $[4] !== error.message ? (t12 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: error.message }), $[4] = error.message, $[5] = t12) : t12 = $[5];
    let t2;
    return $[6] !== t02 || $[7] !== t12 ? (t2 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: /* @__PURE__ */ jsx(Alert, { title: t02, children: t12 }) }), $[6] = t02, $[7] = t12, $[8] = t2) : t2 = $[8], t2;
  }
  if (!referenceInfo)
    return null;
  if (referenceInfo.availability?.reason === "PERMISSION_DENIED") {
    let t02;
    $[9] !== t ? (t02 = t("inputs.reference.error.missing-read-permissions-description"), $[9] = t, $[10] = t02) : t02 = $[10];
    let t12;
    return $[11] !== t02 ? (t12 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: t02 }), $[11] = t02, $[12] = t12) : t12 = $[12], t12;
  }
  let t0;
  if ($[13] !== props2.referenceType.to || $[14] !== referenceInfo.type) {
    let t12;
    $[16] !== referenceInfo.type ? (t12 = (toEntry) => toEntry.type === referenceInfo.type, $[16] = referenceInfo.type, $[17] = t12) : t12 = $[17], t0 = props2.referenceType.to.find(t12), $[13] = props2.referenceType.to, $[14] = referenceInfo.type, $[15] = t0;
  } else
    t0 = $[15];
  const refType = t0;
  if (!refType) {
    let t12;
    $[18] !== referenceInfo.type || $[19] !== t ? (t12 = t("inputs.reference.error.invalid-search-result-type-title", {
      returnedType: referenceInfo.type
    }), $[18] = referenceInfo.type, $[19] = t, $[20] = t12) : t12 = $[20];
    let t2;
    return $[21] !== t12 ? (t2 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: t12 }), $[21] = t12, $[22] = t2) : t2 = $[22], t2;
  }
  let t1;
  return $[23] !== projectId || $[24] !== props2.referenceType.dataset || $[25] !== props2.referenceType.to.length || $[26] !== refType || $[27] !== referenceInfo ? (t1 = referenceInfo && refType && /* @__PURE__ */ jsx(CrossDatasetReferencePreview, { id: referenceInfo.id, availability: referenceInfo.availability, preview: referenceInfo.preview, refType, dataset: props2.referenceType.dataset, projectId, showTypeLabel: props2.referenceType.to.length > 1 }), $[23] = projectId, $[24] = props2.referenceType.dataset, $[25] = props2.referenceType.to.length, $[26] = refType, $[27] = referenceInfo, $[28] = t1) : t1 = $[28], t1;
}
function PreviewReferenceValue$1(props2) {
  const $ = c(32), {
    value,
    type,
    showStudioUrlIcon,
    hasStudioUrl,
    referenceInfo
  } = props2, {
    t
  } = useTranslation(), projectId = useProjectId$1();
  if (referenceInfo.isLoading || referenceInfo.error) {
    let t02;
    $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = {
      maxWidth: 320
    }, $[0] = t02) : t02 = $[0];
    const t12 = !referenceInfo.error;
    let t2;
    $[1] !== t12 ? (t2 = /* @__PURE__ */ jsx(TextSkeleton, { style: t02, radius: 1, animated: t12 }), $[1] = t12, $[2] = t2) : t2 = $[2];
    let t3;
    $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
      maxWidth: 200
    }, $[3] = t3) : t3 = $[3];
    const t4 = !referenceInfo.error;
    let t5;
    $[4] !== t4 ? (t5 = /* @__PURE__ */ jsx(TextSkeleton, { style: t3, radius: 1, size: 1, animated: t4 }), $[4] = t4, $[5] = t5) : t5 = $[5];
    let t6;
    return $[6] !== t2 || $[7] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { space: 2, padding: 1, children: [
      t2,
      t5
    ] }), $[6] = t2, $[7] = t5, $[8] = t6) : t6 = $[8], t6;
  }
  const showTypeLabel = type.to.length > 1, refTypeName = referenceInfo.result?.type;
  let t0;
  if ($[9] !== refTypeName || $[10] !== type.to) {
    let t12;
    $[12] !== refTypeName ? (t12 = (toType) => toType.type === refTypeName, $[12] = refTypeName, $[13] = t12) : t12 = $[13], t0 = type.to.find(t12), $[9] = refTypeName, $[10] = type.to, $[11] = t0;
  } else
    t0 = $[11];
  const refType = t0;
  if (referenceInfo.result.availability?.available && !refType) {
    const t12 = refTypeName || "unknown";
    let t2;
    $[14] !== t12 ? (t2 = {
      typeName: t12
    }, $[14] = t12, $[15] = t2) : t2 = $[15];
    let t3;
    $[16] !== value ? (t3 = {
      JsonValue: () => /* @__PURE__ */ jsx("pre", { children: JSON.stringify(value, null, 2) })
    }, $[16] = value, $[17] = t3) : t3 = $[17];
    let t4;
    return $[18] !== t || $[19] !== t2 || $[20] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 2, children: /* @__PURE__ */ jsx(Text$1, { as: "p", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.cross-dataset.invalid-type", values: t2, components: t3 }) }) }), $[18] = t, $[19] = t2, $[20] = t3, $[21] = t4) : t4 = $[21], t4;
  }
  let t1;
  return $[22] !== hasStudioUrl || $[23] !== projectId || $[24] !== refType || $[25] !== referenceInfo.result.availability || $[26] !== referenceInfo.result.preview || $[27] !== showStudioUrlIcon || $[28] !== showTypeLabel || $[29] !== type.dataset || $[30] !== value._ref ? (t1 = /* @__PURE__ */ jsx(CrossDatasetReferencePreview, { availability: referenceInfo.result.availability, hasStudioUrl, showStudioUrlIcon, preview: referenceInfo.result.preview, refType, projectId, dataset: type.dataset, id: value._ref, showTypeLabel }), $[22] = hasStudioUrl, $[23] = projectId, $[24] = refType, $[25] = referenceInfo.result.availability, $[26] = referenceInfo.result.preview, $[27] = showStudioUrlIcon, $[28] = showTypeLabel, $[29] = type.dataset, $[30] = value._ref, $[31] = t1) : t1 = $[31], t1;
}
const StyledPopover$5 = styled(Popover).withConfig({
  displayName: "StyledPopover",
  componentId: "sc-1aid2lb-0"
})`& > div{overflow:auto;-webkit-overflow-scrolling:touch;}`, StyledText$4 = styled(Text$1).withConfig({
  displayName: "StyledText",
  componentId: "sc-1aid2lb-1"
})`word-break:break-word;`, FALLBACK_PLACEMENTS$2 = ["top-start", "bottom-start"], ReferenceAutocomplete$2 = forwardRef(function(props2, ref) {
  const $ = c(17);
  let loading, portalRef, referenceElement, restProps, searchString;
  $[0] !== props2 ? ({
    searchString,
    loading,
    portalRef,
    referenceElement,
    ...restProps
  } = props2, $[0] = props2, $[1] = loading, $[2] = portalRef, $[3] = referenceElement, $[4] = restProps, $[5] = searchString) : (loading = $[1], portalRef = $[2], referenceElement = $[3], restProps = $[4], searchString = $[5]);
  const {
    t
  } = useTranslation(), hasResults = props2.options && props2.options.length > 0;
  let t0;
  $[6] !== hasResults || $[7] !== loading || $[8] !== portalRef || $[9] !== referenceElement || $[10] !== searchString || $[11] !== t ? (t0 = (t12, contentRef) => {
    const {
      content,
      hidden,
      inputElement,
      onMouseEnter,
      onMouseLeave
    } = t12;
    return /* @__PURE__ */ jsx(StyledPopover$5, { "data-testid": "autocomplete-popover", placement: "bottom-start", fallbackPlacements: FALLBACK_PLACEMENTS$2, arrow: !1, constrainSize: !0, onMouseEnter, onMouseLeave, content: /* @__PURE__ */ jsx("div", { ref: contentRef, children: hasResults ? content : /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(StyledText$4, { align: "center", muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.no-results-for-query", values: {
      searchTerm: searchString || ""
    } }) }) }) }) }), open: !loading && !hidden, ref: portalRef, portal: !0, referenceElement: referenceElement || inputElement, matchReferenceWidth: !0 });
  }, $[6] = hasResults, $[7] = loading, $[8] = portalRef, $[9] = referenceElement, $[10] = searchString, $[11] = t, $[12] = t0) : t0 = $[12];
  const renderPopover = t0;
  let t1;
  return $[13] !== ref || $[14] !== renderPopover || $[15] !== restProps ? (t1 = /* @__PURE__ */ jsx(Autocomplete, { ...restProps, ref, renderPopover }), $[13] = ref, $[14] = renderPopover, $[15] = restProps, $[16] = t1) : t1 = $[16], t1;
}), INITIAL_SEARCH_STATE$2 = {
  hits: [],
  isLoading: !1
}, NO_FILTER$2 = () => !0, REF_PATH$1 = ["_ref"];
function CrossDatasetReferenceInput(props2) {
  const $ = c(96), {
    changed,
    focused,
    focusPath,
    getReferenceInfo: getReferenceInfo2,
    onChange,
    onPathFocus,
    onSearch,
    path,
    readOnly,
    schemaType,
    validation: validation2,
    value,
    elementProps: t0
  } = props2;
  let elementProps, forwardRef2;
  $[0] !== t0 ? ({
    ref: forwardRef2,
    ...elementProps
  } = t0, $[0] = t0, $[1] = elementProps, $[2] = forwardRef2) : (elementProps = $[1], forwardRef2 = $[2]);
  const {
    t
  } = useTranslation(), projectId = useProjectId$1(), [searchState, setSearchState] = useState(INITIAL_SEARCH_STATE$2);
  let t1;
  $[3] !== onChange || $[4] !== onPathFocus || $[5] !== projectId || $[6] !== schemaType.dataset || $[7] !== schemaType.name || $[8] !== schemaType.weak || $[9] !== searchState.hits || $[10] !== value?._key ? (t1 = (id2) => {
    if (!id2) {
      onChange(unset()), onPathFocus([]);
      return;
    }
    if (!searchState.hits.find((h) => h.id === id2))
      throw new Error("Selected an item that wasnt part of the result set");
    onChange(set({
      _type: schemaType.name,
      _ref: getPublishedId(id2),
      _projectId: projectId,
      _dataset: schemaType.dataset,
      _weak: schemaType.weak,
      _key: value?._key
    })), onPathFocus([]);
  }, $[3] = onChange, $[4] = onPathFocus, $[5] = projectId, $[6] = schemaType.dataset, $[7] = schemaType.name, $[8] = schemaType.weak, $[9] = searchState.hits, $[10] = value?._key, $[11] = t1) : t1 = $[11];
  const handleChange = t1;
  let t2;
  $[12] !== onChange ? (t2 = () => {
    onChange(unset());
  }, $[12] = onChange, $[13] = t2) : t2 = $[13];
  const handleClear = t2;
  let t3;
  $[14] !== onPathFocus ? (t3 = (event) => {
    event.key === "Escape" && onPathFocus?.([]);
  }, $[14] = onPathFocus, $[15] = t3) : t3 = $[15];
  const handleAutocompleteKeyDown = t3;
  let t4;
  $[16] !== getReferenceInfo2 || $[17] !== schemaType ? (t4 = (doc) => getReferenceInfo2(doc, schemaType), $[16] = getReferenceInfo2, $[17] = schemaType, $[18] = t4) : t4 = $[18];
  const getReferenceInfoMemo = t4, t5 = value?._ref;
  let t6;
  $[19] !== t5 ? (t6 = {
    _id: t5
  }, $[19] = t5, $[20] = t6) : t6 = $[20];
  const loadableReferenceInfo = useReferenceInfo$1(t6, getReferenceInfoMemo), featureInfo = useFeatureEnabled(FEATURES.crossDatasetReferences), [autocompletePopoverReferenceElement, setAutocompletePopoverReferenceElement] = useState(null), hasFocusAtRef = focusPath.length === 1 && focusPath[0] === "_ref", focusElementRef = useRef(null);
  let t7;
  $[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = () => focusElementRef.current, $[21] = t7) : t7 = $[21], useImperativeHandle(forwardRef2, t7);
  const t8 = value?._ref;
  let t9;
  $[22] !== hasFocusAtRef || $[23] !== t8 ? (t9 = {
    hasFocusAt: hasFocusAtRef,
    ref: t8
  }, $[22] = hasFocusAtRef, $[23] = t8, $[24] = t9) : t9 = $[24];
  let t10;
  $[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = (prev, current) => {
    const refUpdated = prev?.ref !== current.ref;
    (prev?.hasFocusAt !== current.hasFocusAt || refUpdated) && current.hasFocusAt && focusElementRef.current?.focus();
  }, $[25] = t10) : t10 = $[25], useDidUpdate(t9, t10);
  const actualStrength = value?._weak ? "weak" : "strong", weakShouldBe = schemaType.weak === !0 ? "weak" : "strong", hasRef = !!value?._ref;
  let t11;
  $[26] !== onChange || $[27] !== schemaType.weak ? (t11 = () => {
    onChange(schemaType.weak === !0 ? set(!0, ["_weak"]) : unset(["_weak"]));
  }, $[26] = onChange, $[27] = schemaType.weak, $[28] = t11) : t11 = $[28];
  const handleFixStrengthMismatch = t11, {
    push
  } = useToast();
  let t12;
  $[29] !== validation2 ? (t12 = validation2.filter(_temp$2D), $[29] = validation2, $[30] = t12) : t12 = $[30];
  const errors = t12;
  let t13;
  $[31] !== onPathFocus || $[32] !== path ? (t13 = (event_0) => {
    event_0.currentTarget === focusElementRef.current && onPathFocus?.(path);
  }, $[31] = onPathFocus, $[32] = path, $[33] = t13) : t13 = $[33];
  const handleFocus = t13;
  let t14;
  $[34] !== onPathFocus ? (t14 = (event_1) => {
    event_1.currentTarget === focusElementRef.current && onPathFocus?.(REF_PATH$1);
  }, $[34] = onPathFocus, $[35] = t14) : t14 = $[35];
  const handleAutocompleteFocus = t14;
  let t15;
  $[36] !== onPathFocus ? (t15 = () => {
    onPathFocus?.(REF_PATH$1);
  }, $[36] = onPathFocus, $[37] = t15) : t15 = $[37];
  const handleReplace = t15, inputId = useId();
  let t16;
  $[38] !== inputId || $[39] !== onSearch || $[40] !== push ? (t16 = (inputValue$) => inputValue$.pipe(filter(isNonNullable$2), distinctUntilChanged(), switchMap((searchString) => concat(of({
    isLoading: !0
  }), onSearch(searchString).pipe(map((hits) => ({
    hits,
    searchString,
    isLoading: !1
  })), catchError((error) => (push({
    title: "Reference search failed",
    description: error.message,
    status: "error",
    id: `reference-search-fail-${inputId}`
  }), console.error(error), of({
    hits: []
  })))))), scan(_temp2$16, INITIAL_SEARCH_STATE$2), tap(setSearchState)), $[38] = inputId, $[39] = onSearch, $[40] = push, $[41] = t16) : t16 = $[41];
  const handleQueryChange = useObservableEvent(t16);
  let t17;
  $[42] !== handleQueryChange ? (t17 = () => {
    handleQueryChange("");
  }, $[42] = handleQueryChange, $[43] = t17) : t17 = $[43];
  const handleAutocompleteOpenButtonClick = t17, showWeakRefMismatch = !loadableReferenceInfo.isLoading && hasRef && actualStrength !== weakShouldBe;
  let t18;
  $[44] !== loadableReferenceInfo.result?.type || $[45] !== schemaType || $[46] !== value?._ref ? (t18 = value?._ref && schemaType.studioUrl?.({
    id: value?._ref,
    type: loadableReferenceInfo?.result?.type
  }) || null, $[44] = loadableReferenceInfo.result?.type, $[45] = schemaType, $[46] = value?._ref, $[47] = t18) : t18 = $[47];
  const studioUrl = t18;
  let t19;
  $[48] !== getReferenceInfoMemo || $[49] !== schemaType ? (t19 = (option) => /* @__PURE__ */ jsx(ReferenceInputPreviewCard, { forwardedAs: "button", type: "button", radius: 2, tone: "inherit", children: /* @__PURE__ */ jsx(OptionPreview$1, { referenceType: schemaType, document: option.hit.published, getReferenceInfo: getReferenceInfoMemo }) }), $[48] = getReferenceInfoMemo, $[49] = schemaType, $[50] = t19) : t19 = $[50];
  const renderOption = t19, isEditing = hasFocusAtRef || !value?._ref, clickOutsideBoundaryRef = useRef(null), autocompletePortalRef = useRef(null);
  let t20;
  $[51] !== hasFocusAtRef || $[52] !== onPathFocus ? (t20 = hasFocusAtRef && (() => onPathFocus([])), $[51] = hasFocusAtRef, $[52] = onPathFocus, $[53] = t20) : t20 = $[53];
  let t21;
  $[54] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t21 = () => [clickOutsideBoundaryRef.current, autocompletePortalRef.current], $[54] = t21) : t21 = $[54], useClickOutsideEvent(t20, t21);
  let t22;
  $[55] !== featureInfo.enabled || $[56] !== featureInfo.isLoading || $[57] !== handleClear || $[58] !== value ? (t22 = !featureInfo.isLoading && !featureInfo.enabled && /* @__PURE__ */ jsx(DisabledFeatureWarning, { value, onClearValue: handleClear }), $[55] = featureInfo.enabled, $[56] = featureInfo.isLoading, $[57] = handleClear, $[58] = value, $[59] = t22) : t22 = $[59];
  let t23;
  $[60] !== actualStrength || $[61] !== autocompletePopoverReferenceElement || $[62] !== changed || $[63] !== elementProps || $[64] !== errors || $[65] !== featureInfo.enabled || $[66] !== featureInfo.isLoading || $[67] !== focused || $[68] !== handleAutocompleteFocus || $[69] !== handleAutocompleteKeyDown || $[70] !== handleAutocompleteOpenButtonClick || $[71] !== handleChange || $[72] !== handleClear || $[73] !== handleFixStrengthMismatch || $[74] !== handleFocus || $[75] !== handleQueryChange || $[76] !== handleReplace || $[77] !== inputId || $[78] !== isEditing || $[79] !== loadableReferenceInfo || $[80] !== path || $[81] !== readOnly || $[82] !== renderOption || $[83] !== schemaType || $[84] !== searchState.hits || $[85] !== searchState.isLoading || $[86] !== searchState.searchString || $[87] !== showWeakRefMismatch || $[88] !== studioUrl || $[89] !== t || $[90] !== value ? (t23 = (featureInfo.isLoading || featureInfo.enabled) && /* @__PURE__ */ jsx(Stack, { space: 1, children: isEditing ? /* @__PURE__ */ jsx(Stack, { space: 2, ref: clickOutsideBoundaryRef, children: /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !!focused, children: /* @__PURE__ */ jsx("div", { ref: setAutocompletePopoverReferenceElement, children: /* @__PURE__ */ jsx(ReferenceAutocomplete$2, { ...elementProps, "data-testid": "autocomplete", loading: searchState.isLoading, referenceElement: autocompletePopoverReferenceElement, portalRef: autocompletePortalRef, id: inputId || "", options: searchState.hits.map(_temp3$z), onFocus: handleAutocompleteFocus, radius: 2, placeholder: t("inputs.reference.search-placeholder"), onKeyDown: handleAutocompleteKeyDown, readOnly, disabled: loadableReferenceInfo.isLoading, onQueryChange: handleQueryChange, searchString: searchState.searchString, onChange: handleChange, filterOption: NO_FILTER$2, renderOption, openButton: {
    onClick: handleAutocompleteOpenButtonClick
  }, ref: focusElementRef }) }) }) }) : /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !!focused, children: /* @__PURE__ */ jsxs(Card, { padding: 0, border: !0, flex: 1, radius: 2, tone: readOnly ? "transparent" : loadableReferenceInfo.error || errors.length > 0 ? "critical" : "default", children: [
    /* @__PURE__ */ jsxs(Flex, { align: "center", padding: 1, children: [
      studioUrl ? /* @__PURE__ */ jsx(PreviewCard, { as: "a", target: "_blank", rel: "noopener noreferrer", href: studioUrl, "data-as": "a", flex: 1, paddingRight: 3, radius: 2, tone: "inherit", __unstable_focusRing: !0, tabIndex: 0, onFocus: handleFocus, onBlur: elementProps.onBlur, ref: focusElementRef, children: /* @__PURE__ */ jsx(PreviewReferenceValue$1, { value, referenceInfo: loadableReferenceInfo, showStudioUrlIcon: !0, hasStudioUrl: !!studioUrl, type: schemaType }) }) : /* @__PURE__ */ jsx(PreviewCard, { flex: 1, paddingRight: 3, radius: 2, tone: "inherit", __unstable_focusRing: !0, tabIndex: 0, onFocus: handleFocus, onBlur: elementProps.onBlur, ref: focusElementRef, children: /* @__PURE__ */ jsx(PreviewReferenceValue$1, { value, referenceInfo: loadableReferenceInfo, showStudioUrlIcon: !0, type: schemaType }) }),
      /* @__PURE__ */ jsx(Inline, { paddingX: 1, children: /* @__PURE__ */ jsx(MenuButton, { button: /* @__PURE__ */ jsx(ContextMenuButton, { "data-testid": "menu-button" }), id: `${inputId}-menuButton`, menu: /* @__PURE__ */ jsx(Menu, { children: !readOnly && /* @__PURE__ */ jsxs(Fragment$1, { children: [
        /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.reference.action.clear"), tone: "critical", icon: ResetIcon, "data-testid": "menu-item-clear", onClick: handleClear }),
        /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.reference.action.replace"), icon: SyncIcon, "data-testid": "menu-item-replace", onClick: handleReplace })
      ] }) }), placement: "right", popover: {
        portal: !0,
        tone: "default"
      } }) })
    ] }),
    showWeakRefMismatch && /* @__PURE__ */ jsx(ReferenceStrengthMismatchAlertStrip, { actualStrength, handleFixStrengthMismatch }),
    loadableReferenceInfo.error && /* @__PURE__ */ jsx(ReferenceMetadataLoadErrorAlertStrip, { errorMessage: loadableReferenceInfo.error.message, onHandleRetry: loadableReferenceInfo.retry })
  ] }) }) }), $[60] = actualStrength, $[61] = autocompletePopoverReferenceElement, $[62] = changed, $[63] = elementProps, $[64] = errors, $[65] = featureInfo.enabled, $[66] = featureInfo.isLoading, $[67] = focused, $[68] = handleAutocompleteFocus, $[69] = handleAutocompleteKeyDown, $[70] = handleAutocompleteOpenButtonClick, $[71] = handleChange, $[72] = handleClear, $[73] = handleFixStrengthMismatch, $[74] = handleFocus, $[75] = handleQueryChange, $[76] = handleReplace, $[77] = inputId, $[78] = isEditing, $[79] = loadableReferenceInfo, $[80] = path, $[81] = readOnly, $[82] = renderOption, $[83] = schemaType, $[84] = searchState.hits, $[85] = searchState.isLoading, $[86] = searchState.searchString, $[87] = showWeakRefMismatch, $[88] = studioUrl, $[89] = t, $[90] = value, $[91] = t23) : t23 = $[91];
  let t24;
  return $[92] !== props2.elementProps.style || $[93] !== t22 || $[94] !== t23 ? (t24 = /* @__PURE__ */ jsxs("div", { style: props2.elementProps.style, children: [
    t22,
    t23
  ] }), $[92] = props2.elementProps.style, $[93] = t22, $[94] = t23, $[95] = t24) : t24 = $[95], t24;
}
function _temp3$z(hit_0) {
  return {
    value: hit_0.id,
    hit: hit_0
  };
}
function _temp2$16(prevState, nextState) {
  return {
    ...prevState,
    ...nextState
  };
}
function _temp$2D(item) {
  return item.level === "error";
}
const REQUEST_TAG_BASE$1 = "cross-dataset-refs", AVAILABILITY_READABLE$2 = {
  available: !0,
  reason: "READABLE"
}, AVAILABILITY_PERMISSION_DENIED$2 = {
  available: !1,
  reason: "PERMISSION_DENIED"
}, AVAILABILITY_NOT_FOUND$2 = {
  available: !1,
  reason: "NOT_FOUND"
};
function createGetReferenceInfo$1(context) {
  const {
    client,
    documentPreviewStore
  } = context, {
    dataset,
    projectId
  } = client.config(), apiConfig = dataset && projectId ? {
    dataset,
    projectId
  } : void 0;
  return function(doc, referenceType) {
    return (doc._type ? of(doc) : documentPreviewStore.observeDocumentTypeFromId(doc._id, apiConfig).pipe(map((docType) => ({
      _id: doc._id,
      _type: docType
    })))).pipe(switchMap((resolvedDoc) => {
      if (!resolvedDoc._type)
        return fetchDocumentAvailability$1(client, doc._id).pipe(map((availability) => ({
          id: doc._id,
          type: void 0,
          availability,
          preview: {
            published: void 0
          }
        })));
      const refSchemaType = referenceType.to.find((candidate) => candidate.type === resolvedDoc._type), previewPaths = getPreviewPaths(refSchemaType?.preview) || [], publishedPreview$ = documentPreviewStore.observePaths(doc, previewPaths, apiConfig).pipe(map((result) => result && prepareForPreview(result, refSchemaType)));
      return combineLatest([publishedPreview$]).pipe(map(([publishedPreview]) => ({
        type: resolvedDoc._type,
        id: doc._id,
        availability: AVAILABILITY_READABLE$2,
        preview: {
          published: isRecord$4(publishedPreview) ? publishedPreview : void 0
        }
      })));
    }));
  };
}
function fetchDocumentAvailability$1(client, id2) {
  const requestOptions = {
    uri: client.getDataUrl("doc", id2),
    json: !0,
    query: {
      excludeContent: "true"
    },
    tag: `${REQUEST_TAG_BASE$1}.availability`
  };
  return client.observable.request(requestOptions).pipe(map((response) => {
    const omittedEntry = keyBy(response.omitted || [], (entry) => entry.id)[id2];
    return omittedEntry ? omittedEntry.reason === "existence" ? AVAILABILITY_NOT_FOUND$2 : omittedEntry.reason === "permission" ? AVAILABILITY_PERMISSION_DENIED$2 : null : AVAILABILITY_READABLE$2;
  }));
}
function search$1(client, textTerm, type, options) {
  return createSearch(type.to, client, {
    ...options,
    maxDepth: options.maxFieldDepth
  })(textTerm, {
    isCrossDataset: !0
  }).pipe(map(({
    hits
  }) => hits.map(({
    hit
  }) => hit)), map((docs) => collate(docs)), map((collated) => collated.map((entry) => ({
    id: entry.id,
    type: entry.type,
    published: entry.published
  }))));
}
async function resolveUserDefinedFilter$1(options, document2, valuePath, getClient2) {
  if (!options)
    return {};
  if (typeof options.filter == "function") {
    const parentPath = valuePath.slice(0, -1), parent = get$1(document2, parentPath);
    return await options.filter({
      document: document2,
      parentPath,
      parent,
      // published is default, so this should be good for x-dataset refs
      perspective: [],
      getClient: getClient2
    });
  }
  return {
    filter: options.filter,
    params: "filterParams" in options ? options.filterParams : void 0
  };
}
function StudioCrossDatasetReferenceInput(props2) {
  const $ = c(25), {
    path,
    schemaType,
    readOnly
  } = props2, source = useSource();
  let t0;
  $[0] !== source ? (t0 = source.getClient(DEFAULT_STUDIO_CLIENT_OPTIONS), $[0] = source, $[1] = t0) : t0 = $[1];
  const client = t0, documentPreviewStore = useDocumentPreviewStore(), getClient2 = source.getClient, {
    strategy: searchStrategy
  } = source.search;
  let t1;
  $[2] !== client || $[3] !== schemaType.dataset ? (t1 = client.withConfig({
    dataset: schemaType.dataset,
    apiVersion: DEFAULT_STUDIO_CLIENT_OPTIONS.apiVersion,
    ignoreBrowserTokenWarning: !0
  }).clone(), $[2] = client, $[3] = schemaType.dataset, $[4] = t1) : t1 = $[4];
  const crossDatasetClient = t1, maxFieldDepth = useSearchMaxFieldDepth(crossDatasetClient);
  let t2;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[5] = t2) : t2 = $[5];
  const documentValue = useFormValue(t2);
  let t3;
  $[6] !== crossDatasetClient || $[7] !== documentValue || $[8] !== getClient2 || $[9] !== maxFieldDepth || $[10] !== path || $[11] !== schemaType || $[12] !== searchStrategy ? (t3 = (searchString) => from(resolveUserDefinedFilter$1(schemaType.options, documentValue, path, getClient2)).pipe(mergeMap((t42) => {
    const {
      filter: filter2,
      params
    } = t42;
    return search$1(crossDatasetClient, searchString, schemaType, {
      ...schemaType.options,
      filter: filter2,
      params,
      tag: "search.cross-dataset-reference",
      maxFieldDepth,
      strategy: searchStrategy,
      perspective: "published"
    });
  }), catchError((err) => {
    const isQueryError = err.details && err.details.type === "queryParseError";
    return schemaType.options?.filter && isQueryError && (err.message = 'Invalid reference filter, please check the custom "filter" option'), throwError(err);
  })), $[6] = crossDatasetClient, $[7] = documentValue, $[8] = getClient2, $[9] = maxFieldDepth, $[10] = path, $[11] = schemaType, $[12] = searchStrategy, $[13] = t3) : t3 = $[13];
  const handleSearch = t3;
  let t4;
  $[14] !== crossDatasetClient || $[15] !== documentPreviewStore ? (t4 = createGetReferenceInfo$1({
    client: crossDatasetClient,
    documentPreviewStore
  }), $[14] = crossDatasetClient, $[15] = documentPreviewStore, $[16] = t4) : t4 = $[16];
  const getReferenceInfo2 = t4;
  let t5;
  $[17] !== getReferenceInfo2 || $[18] !== handleSearch || $[19] !== props2 ? (t5 = /* @__PURE__ */ jsx(CrossDatasetReferenceInput, { ...props2, getReferenceInfo: getReferenceInfo2, onSearch: handleSearch }), $[17] = getReferenceInfo2, $[18] = handleSearch, $[19] = props2, $[20] = t5) : t5 = $[20];
  let t6;
  return $[21] !== path || $[22] !== readOnly || $[23] !== t5 ? (t6 = /* @__PURE__ */ jsx(FormNodeDivergenceDetail, { path, readOnly, children: t5 }), $[21] = path, $[22] = readOnly, $[23] = t5, $[24] = t6) : t6 = $[24], t6;
}
const StyledPreviewFlex = styled(Flex).withConfig({
  displayName: "StyledPreviewFlex",
  componentId: "sc-qx2lr5-0"
})`min-height:36px;`;
function resolveProjectDataset(resourceType, resourceId) {
  if (resourceType !== "dataset")
    return null;
  const [projectId, dataset] = resourceId.split(".", 2);
  if (!projectId || !dataset)
    throw new Error(`Invalid resource ID for resource "dataset": ${resourceId}`);
  return {
    projectId,
    dataset
  };
}
function GlobalDocumentReferencePreview(props2) {
  const $ = c(37), {
    refType,
    showStudioUrlIcon,
    hasStudioUrl,
    showTypeLabel,
    availability,
    preview,
    id: id2,
    resourceType,
    resourceId
  } = props2, notFound = availability?.reason === "NOT_FOUND", insufficientPermissions = availability?.reason === "PERMISSION_DENIED", previewMedia = preview.published?.media, {
    t
  } = useTranslation();
  let t0;
  bb0: {
    if (previewMedia) {
      const isValidImageAsset = typeof previewMedia?.asset < "u" && isImageSource(previewMedia);
      let t13;
      $[0] !== previewMedia ? (t13 = isValidElement(previewMedia), $[0] = previewMedia, $[1] = t13) : t13 = $[1];
      const isValidElement$1 = t13;
      if (!isValidImageAsset && !isValidElement$1) {
        t0 = null;
        break bb0;
      }
      let t22;
      $[2] !== isValidElement$1 || $[3] !== previewMedia || $[4] !== resourceId || $[5] !== resourceType || $[6] !== t ? (t22 = function(t32) {
        const {
          dimensions
        } = t32, projectDataset = resolveProjectDataset(resourceType, resourceId);
        return projectDataset ? isValidElement$1 ? previewMedia : /* @__PURE__ */ jsx("img", { src: createImageUrlBuilder(projectDataset).image(previewMedia).withOptions(dimensions).url(), alt: t("inputs.reference.image-preview-alt-text"), referrerPolicy: "strict-origin-when-cross-origin" }) : null;
      }, $[2] = isValidElement$1, $[3] = previewMedia, $[4] = resourceId, $[5] = resourceType, $[6] = t, $[7] = t22) : t22 = $[7], t0 = t22;
      break bb0;
    }
    if (!refType?.icon) {
      t0 = null;
      break bb0;
    }
    const Icon2 = refType.icon;
    let t12;
    $[8] !== Icon2 ? (t12 = /* @__PURE__ */ jsx(Icon2, {}), $[8] = Icon2, $[9] = t12) : t12 = $[9], t0 = t12;
  }
  const media = t0;
  let t1;
  $[10] !== availability?.available || $[11] !== media || $[12] !== preview.published?.subtitle || $[13] !== preview.published?.title || $[14] !== t ? (t1 = availability?.available ? /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(DefaultPreview, { title: preview.published?.title, subtitle: preview.published?.subtitle, media: media || !1 }) }) : /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, children: t("inputs.reference.error.document-unavailable-title") }) }) }) }), $[10] = availability?.available, $[11] = media, $[12] = preview.published?.subtitle, $[13] = preview.published?.title, $[14] = t, $[15] = t1) : t1 = $[15];
  let t2;
  $[16] !== refType || $[17] !== showTypeLabel ? (t2 = refType && showTypeLabel && /* @__PURE__ */ jsx(Badge, { mode: "outline", children: refType.title || refType.type }), $[16] = refType, $[17] = showTypeLabel, $[18] = t2) : t2 = $[18];
  let t3;
  $[19] !== id2 || $[20] !== insufficientPermissions || $[21] !== notFound || $[22] !== t ? (t3 = (insufficientPermissions || notFound) && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t(notFound ? "inputs.reference.referenced-document-does-not-exist" : "inputs.reference.referenced-document-insufficient-permissions", {
    documentId: id2
  }), children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", children: insufficientPermissions ? /* @__PURE__ */ jsx(AccessDeniedIcon, {}) : /* @__PURE__ */ jsx(HelpCircleIcon, {}) }) }) }), $[19] = id2, $[20] = insufficientPermissions, $[21] = notFound, $[22] = t, $[23] = t3) : t3 = $[23];
  let t4;
  $[24] !== hasStudioUrl || $[25] !== insufficientPermissions || $[26] !== notFound || $[27] !== showStudioUrlIcon || $[28] !== t ? (t4 = !(notFound || insufficientPermissions) && showStudioUrlIcon && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t(hasStudioUrl ? "inputs.reference.document-opens-in-new-tab" : "input.reference.document-cannot-be-opened.failed-to-resolve-url"), children: /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "default", muted: !hasStudioUrl, children: /* @__PURE__ */ jsx(LaunchIcon, {}) }) }) }), $[24] = hasStudioUrl, $[25] = insufficientPermissions, $[26] = notFound, $[27] = showStudioUrlIcon, $[28] = t, $[29] = t4) : t4 = $[29];
  let t5;
  $[30] !== t2 || $[31] !== t3 || $[32] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { paddingLeft: 3, children: /* @__PURE__ */ jsxs(Inline, { space: 4, children: [
    t2,
    t3,
    t4
  ] }) }), $[30] = t2, $[31] = t3, $[32] = t4, $[33] = t5) : t5 = $[33];
  let t6;
  return $[34] !== t1 || $[35] !== t5 ? (t6 = /* @__PURE__ */ jsxs(StyledPreviewFlex, { align: "center", justify: "center", flex: 1, "data-testid": "preview", children: [
    t1,
    t5
  ] }), $[34] = t1, $[35] = t5, $[36] = t6) : t6 = $[36], t6;
}
const noop$3 = () => {
}, INITIAL_LOADING_STATE$1 = {
  isLoading: !0,
  result: void 0,
  error: void 0,
  retry: noop$3
}, EMPTY_STATE = {
  isLoading: !1,
  result: void 0,
  error: void 0,
  retry: noop$3
};
function useReferenceInfo(doc, getReferenceInfo2) {
  const $ = c(10), [retryAttempt, setRetryAttempt] = useState(0);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setRetryAttempt(_temp$2C);
  }, $[0] = t0) : t0 = $[0];
  const retry2 = t0;
  let t1;
  bb0: {
    if (!doc) {
      let t22;
      $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = of(EMPTY_STATE), $[1] = t22) : t22 = $[1], t1 = t22;
      break bb0;
    }
    let t2;
    if ($[2] !== doc || $[3] !== getReferenceInfo2 || $[4] !== retryAttempt) {
      let t3;
      $[6] !== retryAttempt ? (t3 = (result) => ({
        isLoading: !1,
        result,
        error: void 0,
        retry: retry2,
        retryAttempt
      }), $[6] = retryAttempt, $[7] = t3) : t3 = $[7];
      let t4;
      $[8] !== retryAttempt ? (t4 = (err) => (console.error(err), of({
        isLoading: !1,
        result: void 0,
        error: err,
        retry: retry2,
        retryAttempt
      })), $[8] = retryAttempt, $[9] = t4) : t4 = $[9], t2 = getReferenceInfo2(doc).pipe(map(t3), startWith(INITIAL_LOADING_STATE$1), catchError(t4)), $[2] = doc, $[3] = getReferenceInfo2, $[4] = retryAttempt, $[5] = t2;
    } else
      t2 = $[5];
    t1 = t2;
  }
  return useObservable(t1, INITIAL_LOADING_STATE$1);
}
function _temp$2C(current) {
  return current + 1;
}
function OptionPreview(props2) {
  const $ = c(29), {
    isLoading,
    result: referenceInfo,
    error
  } = useReferenceInfo(props2.document, props2.getReferenceInfo), {
    t
  } = useTranslation();
  if (isLoading) {
    let t02;
    $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(TextSkeleton, { style: {
      maxWidth: 320
    }, radius: 1, animated: !0 }), $[0] = t02) : t02 = $[0];
    let t12;
    return $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsxs(Stack, { space: 2, padding: 1, children: [
      t02,
      /* @__PURE__ */ jsx(TextSkeleton, { style: {
        maxWidth: 200
      }, radius: 1, size: 1, animated: !0 })
    ] }), $[1] = t12) : t12 = $[1], t12;
  }
  if (error) {
    let t02;
    $[2] !== t ? (t02 = t("inputs.reference.error.failed-to-load-document-title"), $[2] = t, $[3] = t02) : t02 = $[3];
    let t12;
    $[4] !== error.message ? (t12 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: error.message }), $[4] = error.message, $[5] = t12) : t12 = $[5];
    let t2;
    return $[6] !== t02 || $[7] !== t12 ? (t2 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: /* @__PURE__ */ jsx(Alert, { title: t02, children: t12 }) }), $[6] = t02, $[7] = t12, $[8] = t2) : t2 = $[8], t2;
  }
  if (!referenceInfo)
    return null;
  if (referenceInfo.availability?.reason === "PERMISSION_DENIED") {
    let t02;
    $[9] !== t ? (t02 = t("inputs.reference.error.missing-read-permissions-description"), $[9] = t, $[10] = t02) : t02 = $[10];
    let t12;
    return $[11] !== t02 ? (t12 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: t02 }), $[11] = t02, $[12] = t12) : t12 = $[12], t12;
  }
  let t0;
  if ($[13] !== props2.referenceType.to || $[14] !== referenceInfo.type) {
    let t12;
    $[16] !== referenceInfo.type ? (t12 = (toEntry) => toEntry.type === referenceInfo.type, $[16] = referenceInfo.type, $[17] = t12) : t12 = $[17], t0 = props2.referenceType.to.find(t12), $[13] = props2.referenceType.to, $[14] = referenceInfo.type, $[15] = t0;
  } else
    t0 = $[15];
  const refType = t0;
  if (!refType) {
    let t12;
    $[18] !== referenceInfo.type || $[19] !== t ? (t12 = t("inputs.reference.error.invalid-search-result-type-title", {
      returnedType: referenceInfo.type
    }), $[18] = referenceInfo.type, $[19] = t, $[20] = t12) : t12 = $[20];
    let t2;
    return $[21] !== t12 ? (t2 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: t12 }), $[21] = t12, $[22] = t2) : t2 = $[22], t2;
  }
  let t1;
  return $[23] !== props2.referenceType.resourceId || $[24] !== props2.referenceType.resourceType || $[25] !== props2.referenceType.to.length || $[26] !== refType || $[27] !== referenceInfo ? (t1 = referenceInfo && refType && /* @__PURE__ */ jsx(GlobalDocumentReferencePreview, { id: referenceInfo.id, availability: referenceInfo.availability, preview: referenceInfo.preview, refType, resourceType: props2.referenceType.resourceType, resourceId: props2.referenceType.resourceId, showTypeLabel: props2.referenceType.to.length > 1 }), $[23] = props2.referenceType.resourceId, $[24] = props2.referenceType.resourceType, $[25] = props2.referenceType.to.length, $[26] = refType, $[27] = referenceInfo, $[28] = t1) : t1 = $[28], t1;
}
function PreviewReferenceValue(props2) {
  const $ = c(32), {
    value,
    type,
    showStudioUrlIcon,
    hasStudioUrl,
    referenceInfo
  } = props2, {
    t
  } = useTranslation();
  if (referenceInfo.isLoading || referenceInfo.error) {
    let t02;
    $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = {
      maxWidth: 320
    }, $[0] = t02) : t02 = $[0];
    const t12 = !referenceInfo.error;
    let t2;
    $[1] !== t12 ? (t2 = /* @__PURE__ */ jsx(TextSkeleton, { style: t02, radius: 1, animated: t12 }), $[1] = t12, $[2] = t2) : t2 = $[2];
    let t3;
    $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
      maxWidth: 200
    }, $[3] = t3) : t3 = $[3];
    const t4 = !referenceInfo.error;
    let t5;
    $[4] !== t4 ? (t5 = /* @__PURE__ */ jsx(TextSkeleton, { style: t3, radius: 1, size: 1, animated: t4 }), $[4] = t4, $[5] = t5) : t5 = $[5];
    let t6;
    return $[6] !== t2 || $[7] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { space: 2, padding: 1, children: [
      t2,
      t5
    ] }), $[6] = t2, $[7] = t5, $[8] = t6) : t6 = $[8], t6;
  }
  const showTypeLabel = type.to.length > 1, refTypeName = referenceInfo.result?.type;
  let t0;
  if ($[9] !== refTypeName || $[10] !== type.to) {
    let t12;
    $[12] !== refTypeName ? (t12 = (toType) => toType.type === refTypeName, $[12] = refTypeName, $[13] = t12) : t12 = $[13], t0 = type.to.find(t12), $[9] = refTypeName, $[10] = type.to, $[11] = t0;
  } else
    t0 = $[11];
  const refType = t0;
  if (referenceInfo.result.availability?.available && !refType) {
    const t12 = refTypeName || "unknown";
    let t2;
    $[14] !== t12 ? (t2 = {
      typeName: t12
    }, $[14] = t12, $[15] = t2) : t2 = $[15];
    let t3;
    $[16] !== value ? (t3 = {
      JsonValue: () => /* @__PURE__ */ jsx("pre", { children: JSON.stringify(value, null, 2) })
    }, $[16] = value, $[17] = t3) : t3 = $[17];
    let t4;
    return $[18] !== t || $[19] !== t2 || $[20] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 2, children: /* @__PURE__ */ jsx(Text$1, { as: "p", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.global.invalid-type", values: t2, components: t3 }) }) }), $[18] = t, $[19] = t2, $[20] = t3, $[21] = t4) : t4 = $[21], t4;
  }
  let t1;
  return $[22] !== hasStudioUrl || $[23] !== refType || $[24] !== referenceInfo.result.availability || $[25] !== referenceInfo.result.preview || $[26] !== showStudioUrlIcon || $[27] !== showTypeLabel || $[28] !== type.resourceId || $[29] !== type.resourceType || $[30] !== value._ref ? (t1 = /* @__PURE__ */ jsx(GlobalDocumentReferencePreview, { availability: referenceInfo.result.availability, hasStudioUrl, showStudioUrlIcon, preview: referenceInfo.result.preview, refType, resourceType: type.resourceType, resourceId: type.resourceId, id: value._ref, showTypeLabel }), $[22] = hasStudioUrl, $[23] = refType, $[24] = referenceInfo.result.availability, $[25] = referenceInfo.result.preview, $[26] = showStudioUrlIcon, $[27] = showTypeLabel, $[28] = type.resourceId, $[29] = type.resourceType, $[30] = value._ref, $[31] = t1) : t1 = $[31], t1;
}
const StyledPopover$4 = styled(Popover).withConfig({
  displayName: "StyledPopover",
  componentId: "sc-1u5fo8k-0"
})`& > div{overflow:auto;-webkit-overflow-scrolling:touch;}`, StyledText$3 = styled(Text$1).withConfig({
  displayName: "StyledText",
  componentId: "sc-1u5fo8k-1"
})`word-break:break-word;`, FALLBACK_PLACEMENTS$1 = ["top-start", "bottom-start"], ReferenceAutocomplete$1 = forwardRef(function(props2, ref) {
  const $ = c(17);
  let loading, portalRef, referenceElement, restProps, searchString;
  $[0] !== props2 ? ({
    searchString,
    loading,
    portalRef,
    referenceElement,
    ...restProps
  } = props2, $[0] = props2, $[1] = loading, $[2] = portalRef, $[3] = referenceElement, $[4] = restProps, $[5] = searchString) : (loading = $[1], portalRef = $[2], referenceElement = $[3], restProps = $[4], searchString = $[5]);
  const {
    t
  } = useTranslation(), hasResults = props2.options && props2.options.length > 0;
  let t0;
  $[6] !== hasResults || $[7] !== loading || $[8] !== portalRef || $[9] !== referenceElement || $[10] !== searchString || $[11] !== t ? (t0 = (t12, contentRef) => {
    const {
      content,
      hidden,
      inputElement,
      onMouseEnter,
      onMouseLeave
    } = t12;
    return /* @__PURE__ */ jsx(StyledPopover$4, { "data-testid": "autocomplete-popover", placement: "bottom-start", fallbackPlacements: FALLBACK_PLACEMENTS$1, arrow: !1, constrainSize: !0, onMouseEnter, onMouseLeave, content: /* @__PURE__ */ jsx("div", { ref: contentRef, children: hasResults ? content : /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(StyledText$3, { align: "center", muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.no-results-for-query", values: {
      searchTerm: searchString || ""
    } }) }) }) }) }), open: !loading && !hidden, ref: portalRef, portal: !0, referenceElement: referenceElement || inputElement, matchReferenceWidth: !0 });
  }, $[6] = hasResults, $[7] = loading, $[8] = portalRef, $[9] = referenceElement, $[10] = searchString, $[11] = t, $[12] = t0) : t0 = $[12];
  const renderPopover = t0;
  let t1;
  return $[13] !== ref || $[14] !== renderPopover || $[15] !== restProps ? (t1 = /* @__PURE__ */ jsx(Autocomplete, { ...restProps, ref, renderPopover }), $[13] = ref, $[14] = renderPopover, $[15] = restProps, $[16] = t1) : t1 = $[16], t1;
}), INITIAL_SEARCH_STATE$1 = {
  hits: [],
  isLoading: !1
}, NO_FILTER$1 = () => !0, REF_PATH = ["_ref"];
function GlobalDocumentReferenceInput(props2) {
  const $ = c(86), {
    changed,
    focused,
    focusPath,
    getReferenceInfo: getReferenceInfo2,
    onChange,
    onPathFocus,
    onSearch,
    path,
    readOnly,
    schemaType,
    validation: validation2,
    value,
    elementProps: t0
  } = props2;
  let elementProps, forwardRef2;
  $[0] !== t0 ? ({
    ref: forwardRef2,
    ...elementProps
  } = t0, $[0] = t0, $[1] = elementProps, $[2] = forwardRef2) : (elementProps = $[1], forwardRef2 = $[2]);
  const {
    t
  } = useTranslation(), [searchState, setSearchState] = useState(INITIAL_SEARCH_STATE$1);
  let t1;
  $[3] !== onChange || $[4] !== onPathFocus || $[5] !== schemaType.name || $[6] !== schemaType.resourceId || $[7] !== schemaType.resourceType || $[8] !== schemaType.weak || $[9] !== searchState.hits || $[10] !== value?._key ? (t1 = (id2) => {
    if (!id2) {
      onChange(unset()), onPathFocus([]);
      return;
    }
    if (!searchState.hits.find((h) => h.id === id2))
      throw new Error("Selected an item that wasnt part of the result set");
    onChange(set({
      _type: schemaType.name,
      _ref: `${schemaType.resourceType}:${schemaType.resourceId}:${getPublishedId(id2)}`,
      _weak: schemaType.weak,
      _key: value?._key
    })), onPathFocus([]);
  }, $[3] = onChange, $[4] = onPathFocus, $[5] = schemaType.name, $[6] = schemaType.resourceId, $[7] = schemaType.resourceType, $[8] = schemaType.weak, $[9] = searchState.hits, $[10] = value?._key, $[11] = t1) : t1 = $[11];
  const handleChange = t1;
  let t2;
  $[12] !== onChange ? (t2 = () => {
    onChange(unset());
  }, $[12] = onChange, $[13] = t2) : t2 = $[13];
  const handleClear = t2;
  let t3;
  $[14] !== onPathFocus ? (t3 = (event) => {
    event.key === "Escape" && onPathFocus?.([]);
  }, $[14] = onPathFocus, $[15] = t3) : t3 = $[15];
  const handleAutocompleteKeyDown = t3;
  let t4;
  $[16] !== getReferenceInfo2 || $[17] !== schemaType ? (t4 = (doc) => getReferenceInfo2(doc, schemaType), $[16] = getReferenceInfo2, $[17] = schemaType, $[18] = t4) : t4 = $[18];
  const getReferenceInfoMemo = t4;
  let t5;
  bb0: {
    if (!value?._ref) {
      t5 = null;
      break bb0;
    }
    let t62;
    $[19] !== value._ref ? (t62 = value._ref.split(":", 3), $[19] = value._ref, $[20] = t62) : t62 = $[20];
    const [, , _id] = t62;
    let t72;
    $[21] !== _id ? (t72 = {
      _id
    }, $[21] = _id, $[22] = t72) : t72 = $[22], t5 = t72;
  }
  const loadableReferenceInfo = useReferenceInfo(t5, getReferenceInfoMemo), [autocompletePopoverReferenceElement, setAutocompletePopoverReferenceElement] = useState(null), hasFocusAtRef = focusPath.length === 1 && focusPath[0] === "_ref", focusElementRef = useRef(null);
  let t6;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = () => focusElementRef.current, $[23] = t6) : t6 = $[23], useImperativeHandle(forwardRef2, t6);
  const t7 = value?._ref;
  let t8;
  $[24] !== hasFocusAtRef || $[25] !== t7 ? (t8 = {
    hasFocusAt: hasFocusAtRef,
    ref: t7
  }, $[24] = hasFocusAtRef, $[25] = t7, $[26] = t8) : t8 = $[26];
  let t9;
  $[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = (prev, current) => {
    const refUpdated = prev?.ref !== current.ref;
    (prev?.hasFocusAt !== current.hasFocusAt || refUpdated) && current.hasFocusAt && focusElementRef.current?.focus();
  }, $[27] = t9) : t9 = $[27], useDidUpdate(t8, t9);
  const actualStrength = value?._weak ? "weak" : "strong", weakShouldBe = schemaType.weak === !0 ? "weak" : "strong", hasRef = !!value?._ref;
  let t10;
  $[28] !== onChange || $[29] !== schemaType.weak ? (t10 = () => {
    onChange(schemaType.weak === !0 ? set(!0, ["_weak"]) : unset(["_weak"]));
  }, $[28] = onChange, $[29] = schemaType.weak, $[30] = t10) : t10 = $[30];
  const handleFixStrengthMismatch = t10, {
    push
  } = useToast();
  let t11;
  $[31] !== validation2 ? (t11 = validation2.filter(_temp$2B), $[31] = validation2, $[32] = t11) : t11 = $[32];
  const errors = t11;
  let t12;
  $[33] !== onPathFocus ? (t12 = (event_0) => {
    event_0.currentTarget === focusElementRef.current && onPathFocus?.([]);
  }, $[33] = onPathFocus, $[34] = t12) : t12 = $[34];
  const handleFocus = t12;
  let t13;
  $[35] !== onPathFocus ? (t13 = (event_1) => {
    event_1.currentTarget === focusElementRef.current && onPathFocus?.(REF_PATH);
  }, $[35] = onPathFocus, $[36] = t13) : t13 = $[36];
  const handleAutocompleteFocus = t13;
  let t14;
  $[37] !== onPathFocus ? (t14 = () => {
    onPathFocus?.(REF_PATH);
  }, $[37] = onPathFocus, $[38] = t14) : t14 = $[38];
  const handleReplace = t14, inputId = useId();
  let t15;
  $[39] !== inputId || $[40] !== onSearch || $[41] !== push ? (t15 = (inputValue$) => inputValue$.pipe(filter(isNonNullable$2), distinctUntilChanged(), switchMap((searchString) => concat(of({
    isLoading: !0
  }), onSearch(searchString).pipe(map((hits) => ({
    hits,
    searchString,
    isLoading: !1
  })), catchError((error) => (push({
    title: "Reference search failed",
    description: error.message,
    status: "error",
    id: `reference-search-fail-${inputId}`
  }), console.error(error), of({
    hits: []
  })))))), scan(_temp2$15, INITIAL_SEARCH_STATE$1), tap(setSearchState)), $[39] = inputId, $[40] = onSearch, $[41] = push, $[42] = t15) : t15 = $[42];
  const handleQueryChange = useObservableEvent(t15);
  let t16;
  $[43] !== handleQueryChange ? (t16 = () => {
    handleQueryChange("");
  }, $[43] = handleQueryChange, $[44] = t16) : t16 = $[44];
  const handleAutocompleteOpenButtonClick = t16, showWeakRefMismatch = !loadableReferenceInfo.isLoading && hasRef && actualStrength !== weakShouldBe;
  let t17;
  if ($[45] !== loadableReferenceInfo.result || $[46] !== schemaType || $[47] !== value) {
    bb1: {
      if (!value?._ref) {
        t17 = null;
        break bb1;
      }
      if (!isGlobalDocumentReference(value)) {
        t17 = null;
        break bb1;
      }
      const [, , documentId] = value._ref.split(":");
      if (!schemaType.studioUrl || !loadableReferenceInfo?.result?.type) {
        t17 = null;
        break bb1;
      }
      if (typeof schemaType.studioUrl == "string") {
        t17 = `${schemaType.studioUrl}/desk/intent/edit/id=${documentId};type=${loadableReferenceInfo.result.type}/`;
        break bb1;
      }
      t17 = schemaType.studioUrl({
        id: documentId,
        type: loadableReferenceInfo.result.type
      });
    }
    $[45] = loadableReferenceInfo.result, $[46] = schemaType, $[47] = value, $[48] = t17;
  } else
    t17 = $[48];
  const studioUrl = t17;
  let t18;
  $[49] !== getReferenceInfoMemo || $[50] !== schemaType ? (t18 = (option) => /* @__PURE__ */ jsx(PreviewCard, { as: "button", type: "button", radius: 2, children: /* @__PURE__ */ jsx(Box, { paddingX: 3, paddingY: 1, children: /* @__PURE__ */ jsx(OptionPreview, { referenceType: schemaType, document: option.hit.published, getReferenceInfo: getReferenceInfoMemo }) }) }), $[49] = getReferenceInfoMemo, $[50] = schemaType, $[51] = t18) : t18 = $[51];
  const renderOption = t18, isEditing = hasFocusAtRef || !value?._ref, clickOutsideBoundaryRef = useRef(null), autocompletePortalRef = useRef(null);
  let t19;
  $[52] !== hasFocusAtRef || $[53] !== onPathFocus ? (t19 = hasFocusAtRef && (() => onPathFocus([])), $[52] = hasFocusAtRef, $[53] = onPathFocus, $[54] = t19) : t19 = $[54];
  let t20;
  $[55] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t20 = () => [clickOutsideBoundaryRef.current, autocompletePortalRef.current], $[55] = t20) : t20 = $[55], useClickOutsideEvent(t19, t20);
  let t21;
  return $[56] !== actualStrength || $[57] !== autocompletePopoverReferenceElement || $[58] !== changed || $[59] !== elementProps || $[60] !== errors || $[61] !== focused || $[62] !== handleAutocompleteFocus || $[63] !== handleAutocompleteKeyDown || $[64] !== handleAutocompleteOpenButtonClick || $[65] !== handleChange || $[66] !== handleClear || $[67] !== handleFixStrengthMismatch || $[68] !== handleFocus || $[69] !== handleQueryChange || $[70] !== handleReplace || $[71] !== inputId || $[72] !== isEditing || $[73] !== loadableReferenceInfo || $[74] !== path || $[75] !== readOnly || $[76] !== renderOption || $[77] !== schemaType || $[78] !== searchState.hits || $[79] !== searchState.isLoading || $[80] !== searchState.searchString || $[81] !== showWeakRefMismatch || $[82] !== studioUrl || $[83] !== t || $[84] !== value ? (t21 = /* @__PURE__ */ jsx(Stack, { space: 1, children: isEditing ? /* @__PURE__ */ jsx(Stack, { space: 2, ref: clickOutsideBoundaryRef, children: /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !!focused, children: /* @__PURE__ */ jsx("div", { ref: setAutocompletePopoverReferenceElement, children: /* @__PURE__ */ jsx(ReferenceAutocomplete$1, { ...elementProps, "data-testid": "autocomplete", loading: searchState.isLoading, referenceElement: autocompletePopoverReferenceElement, portalRef: autocompletePortalRef, id: inputId || "", options: searchState.hits.map(_temp3$y), onFocus: handleAutocompleteFocus, radius: 2, placeholder: t("inputs.reference.search-placeholder"), onKeyDown: handleAutocompleteKeyDown, readOnly, disabled: loadableReferenceInfo.isLoading, onQueryChange: handleQueryChange, searchString: searchState.searchString, onChange: handleChange, filterOption: NO_FILTER$1, renderOption, openButton: {
    onClick: handleAutocompleteOpenButtonClick
  }, ref: focusElementRef }) }) }) }) : /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !!focused, children: /* @__PURE__ */ jsxs(Card, { padding: 0, border: !0, flex: 1, radius: 1, tone: readOnly ? "transparent" : loadableReferenceInfo.error || errors.length > 0 ? "critical" : "default", children: [
    /* @__PURE__ */ jsxs(Flex, { align: "center", padding: 1, children: [
      studioUrl ? /* @__PURE__ */ jsx(PreviewCard, { as: "a", target: "_blank", rel: "noopener noreferrer", href: studioUrl, "data-as": "a", flex: 1, padding: 1, paddingRight: 3, radius: 2, tone: "inherit", __unstable_focusRing: !0, tabIndex: 0, onFocus: handleFocus, onBlur: elementProps.onBlur, ref: focusElementRef, children: /* @__PURE__ */ jsx(PreviewReferenceValue, { value, referenceInfo: loadableReferenceInfo, showStudioUrlIcon: !0, hasStudioUrl: !0, type: schemaType }) }) : /* @__PURE__ */ jsx(PreviewCard, { flex: 1, padding: 1, paddingRight: 3, radius: 2, tone: "inherit", __unstable_focusRing: !0, tabIndex: 0, onFocus: handleFocus, onBlur: elementProps.onBlur, ref: focusElementRef, children: /* @__PURE__ */ jsx(PreviewReferenceValue, { value, referenceInfo: loadableReferenceInfo, type: schemaType }) }),
      /* @__PURE__ */ jsx(Inline, { paddingX: 1, children: /* @__PURE__ */ jsx(MenuButton, { button: /* @__PURE__ */ jsx(ContextMenuButton, { "data-testid": "menu-button" }), id: `${inputId}-menuButton`, menu: /* @__PURE__ */ jsx(Menu, { children: !readOnly && /* @__PURE__ */ jsxs(Fragment$1, { children: [
        /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.reference.action.clear"), tone: "critical", icon: ResetIcon, "data-testid": "menu-item-clear", onClick: handleClear }),
        /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.reference.action.replace"), icon: SyncIcon, "data-testid": "menu-item-replace", onClick: handleReplace })
      ] }) }), placement: "right", popover: {
        portal: !0,
        tone: "default"
      } }) })
    ] }),
    showWeakRefMismatch && /* @__PURE__ */ jsx(ReferenceStrengthMismatchAlertStrip, { actualStrength, handleFixStrengthMismatch }),
    loadableReferenceInfo.error && /* @__PURE__ */ jsx(ReferenceMetadataLoadErrorAlertStrip, { errorMessage: loadableReferenceInfo.error.message, onHandleRetry: loadableReferenceInfo.retry })
  ] }) }) }), $[56] = actualStrength, $[57] = autocompletePopoverReferenceElement, $[58] = changed, $[59] = elementProps, $[60] = errors, $[61] = focused, $[62] = handleAutocompleteFocus, $[63] = handleAutocompleteKeyDown, $[64] = handleAutocompleteOpenButtonClick, $[65] = handleChange, $[66] = handleClear, $[67] = handleFixStrengthMismatch, $[68] = handleFocus, $[69] = handleQueryChange, $[70] = handleReplace, $[71] = inputId, $[72] = isEditing, $[73] = loadableReferenceInfo, $[74] = path, $[75] = readOnly, $[76] = renderOption, $[77] = schemaType, $[78] = searchState.hits, $[79] = searchState.isLoading, $[80] = searchState.searchString, $[81] = showWeakRefMismatch, $[82] = studioUrl, $[83] = t, $[84] = value, $[85] = t21) : t21 = $[85], t21;
}
function _temp3$y(hit_0) {
  return {
    value: hit_0.id,
    hit: hit_0
  };
}
function _temp2$15(prevState, nextState) {
  return {
    ...prevState,
    ...nextState
  };
}
function _temp$2B(item) {
  return item.level === "error";
}
function getReferenceClient(client, schemaType) {
  if (schemaType.resourceType === "dataset") {
    const [projectId, datasetName] = schemaType.resourceId.split(".", 2);
    return client.withConfig({
      apiVersion: "X",
      resource: {
        type: "dataset",
        id: `${projectId}.${datasetName}`
      }
    });
  }
  if (schemaType.resourceType === "media-library" || schemaType.resourceType === "canvas")
    return client.withConfig({
      apiVersion: "2025-02-19",
      resource: {
        type: schemaType.resourceType,
        id: schemaType.resourceId
      }
    });
  throw new Error(`Invalid resource type "${schemaType.resourceType}"`);
}
function keysOf(value) {
  return Object.keys(value);
}
function setKey(source, key, value) {
  return {
    ...source,
    [key]: value
  };
}
function props(options = {}) {
  return (source) => new Observable((observer) => source.subscribe(observer)).pipe(switchMap((object) => {
    const keyObservables = keysOf(object).map((key) => {
      const value = object[key];
      return isObservable(value) ? from(value).pipe(map((val) => [key, val])) : of([key, value]);
    });
    return options.wait ? combineLatest(keyObservables).pipe(map((pairs) => pairs.reduce((acc, [key, value]) => setKey(acc, key, value), {}))) : from(keyObservables).pipe(mergeAll(), scan((acc, [key, value]) => setKey(acc, key, value), {}));
  }));
}
function createEmpty(fields) {
  return fields.reduce((result, field) => (result[field] = void 0, result), {});
}
function resolveMissingHeads(value, paths) {
  return paths.filter((path) => !(path[0] in value));
}
function getDocumentId(value) {
  return isReference$1(value) ? value._ref : "_id" in value ? value._id : void 0;
}
function observePaths(value, paths, observeFields, apiConfig, perspective) {
  if (!value || typeof value != "object")
    return of(value);
  const id2 = getDocumentId(value), currentValue = id2 ? {
    ...value,
    _id: id2
  } : {
    ...value
  };
  currentValue._type === "reference" && (delete currentValue._type, delete currentValue._ref, delete currentValue._weak, delete currentValue._dataset, delete currentValue._projectId, delete currentValue._strengthenOnPublish);
  const pathsWithMissingHeads = resolveMissingHeads(currentValue, paths);
  if (id2 && pathsWithMissingHeads.length > 0) {
    const nextHeads = uniq(pathsWithMissingHeads.map((path) => path[0])), refApiConfig = isCrossDatasetReference(value) ? {
      projectId: value._projectId,
      dataset: value._dataset
    } : apiConfig;
    return observeFields(id2, nextHeads, refApiConfig, perspective).pipe(switchMap((snapshot2) => snapshot2 === null ? of(null) : observePaths({
      ...createEmpty(nextHeads),
      ...isReference$1(value) ? {
        ...value,
        ...refApiConfig
      } : value,
      ...snapshot2
    }, paths, observeFields, refApiConfig, perspective)));
  }
  const leads = {};
  paths.forEach((path) => {
    const [head, ...tail] = path;
    leads[head] || (leads[head] = []), leads[head].push(tail);
  });
  const next = Object.keys(leads).reduce((res, head) => {
    const tails = leads[head].filter((tail) => tail.length > 0);
    return tails.length === 0 ? res[head] = isRecord$4(value) ? value[head] : void 0 : res[head] = observePaths(value[head], tails, observeFields, apiConfig, perspective), res;
  }, currentValue);
  return of(next).pipe(props({
    wait: !0
  }));
}
function normalizePaths(path) {
  return path.map((segment) => typeof segment == "string" ? segment.split(".") : segment);
}
function createPathObserver(options) {
  const {
    observeFields
  } = options;
  return (value, paths, apiConfig, perspective) => observePaths(value, normalizePaths(paths), observeFields, apiConfig, perspective);
}
const REQUEST_TAG_BASE = "gdr", AVAILABILITY_READABLE$1 = {
  available: !0,
  reason: "READABLE"
}, AVAILABILITY_PERMISSION_DENIED$1 = {
  available: !1,
  reason: "PERMISSION_DENIED"
}, AVAILABILITY_NOT_FOUND$1 = {
  available: !1,
  reason: "NOT_FOUND"
};
function createGetReferenceInfo(context) {
  const {
    client
  } = context;
  return function(doc, referenceType) {
    return (doc._type ? of(doc) : client.observable.getDocument(doc._id).pipe(map((res) => ({
      _id: doc._id,
      _type: res?._type
    })))).pipe(switchMap((resolvedDoc) => {
      if (!resolvedDoc._type)
        return fetchDocumentAvailability(client, doc._id).pipe(map((availability) => ({
          id: doc._id,
          type: void 0,
          availability,
          preview: {
            published: void 0
          }
        })));
      const refSchemaType = referenceType.to.find((candidate) => candidate.type === resolvedDoc._type);
      if (!refSchemaType)
        return of({
          id: doc._id,
          type: resolvedDoc._type,
          availability: AVAILABILITY_READABLE$1,
          preview: {
            published: void 0
          }
        });
      const previewPaths = getPreviewPaths(refSchemaType?.preview) || [], listener = client.observable.listen("*", {}, {
        includeResult: !0,
        tag: `${REQUEST_TAG_BASE}.preview`,
        // by default listen only emits the "mutation" event, however we use the initial "welcome" event to trigger the initial state
        events: ["mutation", "welcome"]
      }), observeFields = createObserveFields$1({
        client,
        listener
      }), publishedPreview$ = createPathObserver({
        observeFields
      })(doc, previewPaths).pipe(map((result) => result ? prepareForPreview(result, refSchemaType) : null));
      return combineLatest([publishedPreview$]).pipe(map(([publishedPreview]) => ({
        type: resolvedDoc._type,
        id: doc._id,
        availability: AVAILABILITY_READABLE$1,
        preview: {
          published: isRecord$4(publishedPreview) ? publishedPreview : void 0
        }
      })));
    }));
  };
}
function createObserveFields$1(context) {
  const {
    client,
    listener
  } = context;
  return function(id2, fields) {
    return listener.pipe(switchMap((event) => {
      if (event.type === "welcome")
        return client.observable.getDocument(id2, {
          tag: `${REQUEST_TAG_BASE}.get-document`
        }).pipe(map((doc) => doc || null));
      if (event.type !== "mutation")
        return EMPTY$5;
      const result = event.result;
      return result ? result.documentId !== id2 ? EMPTY$5 : result.transition === "disappear" ? of(null) : of(result) : EMPTY$5;
    }));
  };
}
function fetchDocumentAvailability(client, id2) {
  const requestOptions = {
    uri: client.getDataUrl("doc", id2),
    json: !0,
    excludeContent: "true",
    tag: `${REQUEST_TAG_BASE}.availability`
  };
  return client.observable.request(requestOptions).pipe(map((response) => {
    const omittedEntry = keyBy(response.omitted || [], (entry) => entry.id)[id2];
    return omittedEntry ? omittedEntry.reason === "existence" ? AVAILABILITY_NOT_FOUND$1 : omittedEntry.reason === "permission" ? AVAILABILITY_PERMISSION_DENIED$1 : null : AVAILABILITY_READABLE$1;
  }));
}
const limit = 10;
function doSearch(client, searchTerm, types, searchOptions) {
  const {
    query,
    params,
    sortOrder
  } = createSearchQuery$1({
    types
  }, searchTerm, searchOptions);
  return client.observable.fetch(query, params).pipe(map((hits) => {
    const hasNextPage = hits.length > limit, lastResult = hasNextPage ? hits.at(-2) : hits.at(-1);
    return {
      type: "groq2024",
      // Search overfetches by 1 to determine whether there is another page to fetch. Therefore,
      // exclude the final result if it's beyond the limit.
      hits: hits.map((hit) => ({
        hit
      })).slice(0, limit),
      nextCursor: hasNextPage ? getNextCursor({
        lastResult,
        sortOrder
      }) : void 0
    };
  }));
}
function search(client, textTerm, type, options) {
  return doSearch(client, textTerm, type.to, options).pipe(map(({
    hits
  }) => hits.map(({
    hit
  }) => hit)), map((docs) => collate(docs)), map((collated) => collated.map((entry) => ({
    id: entry.id,
    type: entry.type,
    published: entry.published
  }))));
}
async function resolveUserDefinedFilter(options, document2, valuePath, getClient2) {
  if (!options)
    return {};
  if (typeof options.filter == "function") {
    const parentPath = valuePath.slice(0, -1), parent = get$1(document2, parentPath);
    return await options.filter({
      document: document2,
      parentPath,
      parent,
      // published is default, so this should be good for x-dataset refs
      perspective: [],
      getClient: getClient2
    });
  }
  return {
    filter: options.filter,
    params: "filterParams" in options ? options.filterParams : void 0
  };
}
function StudioGlobalDocumentReferenceInput(props2) {
  const $ = c(19), {
    path,
    schemaType
  } = props2, source = useSource();
  let t0;
  $[0] !== source ? (t0 = source.getClient({
    apiVersion: "2025-02-19"
  }), $[0] = source, $[1] = t0) : t0 = $[1];
  const client = t0, getClient2 = source.getClient, {
    strategy: searchStrategy
  } = source.search;
  let t1;
  $[2] !== client || $[3] !== schemaType ? (t1 = getReferenceClient(client, schemaType), $[2] = client, $[3] = schemaType, $[4] = t1) : t1 = $[4];
  const referenceClient = t1;
  let t2;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[5] = t2) : t2 = $[5];
  const documentValue = useFormValue(t2);
  let t3;
  $[6] !== documentValue || $[7] !== getClient2 || $[8] !== path || $[9] !== referenceClient || $[10] !== schemaType || $[11] !== searchStrategy ? (t3 = (searchString) => from(resolveUserDefinedFilter(schemaType.options, documentValue, path, getClient2)).pipe(mergeMap((t42) => {
    const {
      filter: filter2,
      params
    } = t42;
    return search(referenceClient, searchString, schemaType, {
      ...schemaType.options,
      filter: filter2,
      params,
      tag: "search.global-document-reference"
    });
  }), catchError((err) => {
    const isQueryError = err.details && err.details.type === "queryParseError";
    return schemaType.options?.filter && isQueryError && (err.message = 'Invalid reference filter, please check the custom "filter" option'), throwError(err);
  })), $[6] = documentValue, $[7] = getClient2, $[8] = path, $[9] = referenceClient, $[10] = schemaType, $[11] = searchStrategy, $[12] = t3) : t3 = $[12];
  const handleSearch = t3;
  let t4;
  $[13] !== referenceClient ? (t4 = createGetReferenceInfo({
    client: referenceClient
  }), $[13] = referenceClient, $[14] = t4) : t4 = $[14];
  const getReferenceInfo2 = t4;
  let t5;
  return $[15] !== getReferenceInfo2 || $[16] !== handleSearch || $[17] !== props2 ? (t5 = /* @__PURE__ */ jsx(GlobalDocumentReferenceInput, { ...props2, getReferenceInfo: getReferenceInfo2, onSearch: handleSearch }), $[15] = getReferenceInfo2, $[16] = handleSearch, $[17] = props2, $[18] = t5) : t5 = $[18], t5;
}
function interpolateTemplate(template, values2) {
  return template.replace(/\{\{(\w+)\}\}/g, (match, key) => {
    const value = values2[key];
    return value === void 0 ? match : String(value);
  });
}
const useUpsellData = (t0) => {
  const $ = c(17), {
    dataUri,
    feature
  } = t0, [upsellData, setUpsellData] = useState(null), [hasError, setHasError] = useState(!1), telemetry = useTelemetry(), projectId = useProjectId(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), baseUrl = `https://www.sanity.${client.config().apiHost.endsWith(".sanity.work") ? "work" : "io"}`;
  let t1;
  $[0] !== feature || $[1] !== telemetry ? (t1 = {
    dialogSecondaryClicked: () => telemetry.log(UpsellDialogLearnMoreCtaClicked, {
      feature,
      type: "modal"
    }),
    dialogPrimaryClicked: () => telemetry.log(UpsellDialogUpgradeCtaClicked, {
      feature,
      type: "modal"
    }),
    dialogViewed: (source) => telemetry.log(UpsellDialogViewed, {
      feature,
      type: "modal",
      source
    }),
    dialogDismissed: () => {
      telemetry.log(UpsellDialogDismissed, {
        feature,
        type: "modal"
      });
    },
    panelViewed: (source_0) => telemetry.log(UpsellDialogViewed, {
      feature,
      type: "inspector",
      source: source_0
    }),
    panelDismissed: () => telemetry.log(UpsellDialogDismissed, {
      feature,
      type: "inspector"
    }),
    panelPrimaryClicked: () => telemetry.log(UpsellDialogUpgradeCtaClicked, {
      feature,
      type: "inspector"
    }),
    panelSecondaryClicked: () => telemetry.log(UpsellDialogLearnMoreCtaClicked, {
      feature,
      type: "inspector"
    })
  }, $[0] = feature, $[1] = telemetry, $[2] = t1) : t1 = $[2];
  const telemetryLogs = t1;
  let t2;
  $[3] !== baseUrl || $[4] !== client.observable || $[5] !== dataUri || $[6] !== projectId ? (t2 = () => {
    const sub2 = client.observable.request({
      uri: dataUri
    }).subscribe({
      next: (data) => {
        if (!data) {
          setHasError(!0), setUpsellData(null);
          return;
        }
        try {
          data.ctaButton.url = interpolateTemplate(data.ctaButton.url, {
            baseUrl,
            projectId
          }), data.secondaryButton.url = interpolateTemplate(data.secondaryButton.url, {
            baseUrl,
            projectId
          }), setUpsellData(data), setHasError(!1);
        } catch {
          setHasError(!0), setUpsellData(null);
        }
      },
      error: (err) => {
        setHasError(!0), setUpsellData(null);
      }
    });
    return () => {
      sub2.unsubscribe();
    };
  }, $[3] = baseUrl, $[4] = client.observable, $[5] = dataUri, $[6] = projectId, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== baseUrl || $[9] !== client || $[10] !== dataUri || $[11] !== projectId ? (t3 = [client, projectId, baseUrl, dataUri], $[8] = baseUrl, $[9] = client, $[10] = dataUri, $[11] = projectId, $[12] = t3) : t3 = $[12], useEffect(t2, t3);
  let t4;
  return $[13] !== hasError || $[14] !== telemetryLogs || $[15] !== upsellData ? (t4 = {
    upsellData,
    telemetryLogs,
    hasError
  }, $[13] = hasError, $[14] = telemetryLogs, $[15] = upsellData, $[16] = t4) : t4 = $[16], t4;
};
function getDialogPropsFromContext(contextValue) {
  return {
    data: contextValue.upsellData,
    open: contextValue.upsellDialogOpen,
    onClose: contextValue.handleClose,
    onPrimaryClick: () => contextValue.telemetryLogs.dialogPrimaryClicked(),
    onSecondaryClick: () => contextValue.telemetryLogs.dialogSecondaryClicked()
  };
}
function useUpsellContext(t0) {
  const $ = c(16), {
    dataUri,
    feature
  } = t0, [upsellDialogOpen, setUpsellDialogOpen] = useState(!1);
  let t1;
  $[0] !== dataUri || $[1] !== feature ? (t1 = {
    dataUri,
    feature
  }, $[0] = dataUri, $[1] = feature, $[2] = t1) : t1 = $[2];
  const {
    upsellData,
    telemetryLogs,
    hasError
  } = useUpsellData(t1), toast = useToast(), {
    t
  } = useTranslation();
  let t2;
  $[3] !== telemetryLogs ? (t2 = () => {
    setUpsellDialogOpen(!1), telemetryLogs.dialogDismissed();
  }, $[3] = telemetryLogs, $[4] = t2) : t2 = $[4];
  const handleClose = t2;
  let t3;
  $[5] !== hasError || $[6] !== t || $[7] !== telemetryLogs || $[8] !== toast ? (t3 = (source) => {
    if (hasError) {
      toast.push({
        status: "error",
        title: t("errors.unable-to-perform-action"),
        closable: !0
      });
      return;
    }
    setUpsellDialogOpen(!0), telemetryLogs.dialogViewed(source);
  }, $[5] = hasError, $[6] = t, $[7] = telemetryLogs, $[8] = toast, $[9] = t3) : t3 = $[9];
  const handleOpenDialog = t3;
  let t4;
  return $[10] !== handleClose || $[11] !== handleOpenDialog || $[12] !== telemetryLogs || $[13] !== upsellData || $[14] !== upsellDialogOpen ? (t4 = {
    upsellDialogOpen,
    handleOpenDialog,
    handleClose,
    upsellData,
    telemetryLogs
  }, $[10] = handleClose, $[11] = handleOpenDialog, $[12] = telemetryLogs, $[13] = upsellData, $[14] = upsellDialogOpen, $[15] = t4) : t4 = $[15], t4;
}
const TRANSFORMATIONS = {
  inlineIcon: (child, idx, block) => {
    if (!isPortableTextTextBlock(block)) return block;
    const hasTextLeft = !!(block.children[idx - 1]?._type === "span" && block.children[idx - 1]?.text), hasTextRight = !!(block.children[idx + 1]?._type === "span" && block.children[idx + 1]?.text);
    return {
      ...child,
      hasTextRight,
      hasTextLeft
    };
  }
}, transformBlocks = (blocks) => blocks.map((block) => {
  if (isPortableTextTextBlock(block) && block._type === "block") {
    const children = block.children.map((child, idx) => TRANSFORMATIONS[child._type] ? TRANSFORMATIONS[child._type](child, idx, block) : child);
    return {
      ...block,
      children
    };
  }
  return block;
}), Divider$2 = styled(Box).withConfig({
  displayName: "Divider",
  componentId: "sc-ryqzo1-0"
})`height:1px;background:var(--card-border-color);width:100%;`, SerializerContainer = styled.div.withConfig({
  displayName: "SerializerContainer",
  componentId: "sc-ryqzo1-1"
})`> div:first-child{margin-top:0;}> [data-ui='Box']:last-child{margin-bottom:0;}`, IconTextContainer = /* @__PURE__ */ styled(Text$1).withConfig({
  displayName: "IconTextContainer",
  componentId: "sc-ryqzo1-2"
})((props2) => props2.accent ? `
    --card-icon-color: var(--card-accent-fg-color);
    ` : ""), AccentSpan = styled.span.withConfig({
  displayName: "AccentSpan",
  componentId: "sc-ryqzo1-3"
})`color:var(--card-accent-fg-color);--card-icon-color:var(--card-accent-fg-color);`, SemiboldSpan = /* @__PURE__ */ styled.span.withConfig({
  displayName: "SemiboldSpan",
  componentId: "sc-ryqzo1-4"
})(({
  theme
}) => {
  const {
    weights
  } = theme.sanity.fonts.text;
  return css`
    font-weight: ${weights.semibold};
  `;
}), InlineIcon = styled(Icon).withConfig({
  displayName: "InlineIcon",
  componentId: "sc-ryqzo1-5"
})`&[data-sanity-icon]{margin-left:${(props2) => props2.$hasTextLeft ? "0" : ""};margin-right:${(props2) => props2.$hasTextRight ? "0" : ""};}`, Link = styled.a.withConfig({
  displayName: "Link",
  componentId: "sc-ryqzo1-6"
})`font-weight:600;color:${(props2) => props2.$useTextColor ? "var(--card-muted-fg-color) !important" : ""};`, DynamicIconContainer = styled.span.withConfig({
  displayName: "DynamicIconContainer",
  componentId: "sc-ryqzo1-7"
})`display:${({
  $inline
}) => $inline ? "inline-block" : "inline"};font-size:calc(21 / 16 * 1rem) !important;min-width:calc(21 / 16 * 1rem - 0.375rem);line-height:0;> svg{height:1em;width:1em;display:inline;font-size:1em !important;margin:-0.375rem !important;*[stroke]{stroke:currentColor;}}`, DynamicIcon = (props2) => {
  const $ = c(8), [__html, setHtml] = useState("");
  let t0, t1;
  $[0] !== props2.icon.url ? (t0 = () => {
    const controller = new AbortController(), signal = controller.signal;
    return fetch(props2.icon.url, {
      signal
    }).then(_temp$2A).then((data) => setHtml(data)).catch(_temp2$14), () => {
      controller.abort();
    };
  }, t1 = [props2.icon.url], $[0] = props2.icon.url, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  const t2 = !!props2.inline;
  let t3;
  $[3] !== __html ? (t3 = {
    __html
  }, $[3] = __html, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== t2 || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(DynamicIconContainer, { $inline: t2, dangerouslySetInnerHTML: t3 }), $[5] = t2, $[6] = t3, $[7] = t4) : t4 = $[7], t4;
};
function NormalBlock$1(props2) {
  const $ = c(2), {
    children
  } = props2;
  let t0;
  return $[0] !== children ? (t0 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginBottom: 4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children }) }), $[0] = children, $[1] = t0) : t0 = $[1], t0;
}
function H2Block(props2) {
  const $ = c(2), {
    children
  } = props2;
  let t0;
  return $[0] !== children ? (t0 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginY: 4, children: /* @__PURE__ */ jsx(Heading, { size: 2, as: "h2", children }) }), $[0] = children, $[1] = t0) : t0 = $[1], t0;
}
function H3Block(props2) {
  const $ = c(2), {
    children
  } = props2;
  let t0;
  return $[0] !== children ? (t0 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginY: 4, children: /* @__PURE__ */ jsx(Heading, { size: 1, as: "h3", children }) }), $[0] = children, $[1] = t0) : t0 = $[1], t0;
}
const Image$6 = /* @__PURE__ */ styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-ryqzo1-8"
})((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    object-fit: cover;
    width: 100%;
    border-radius: ${theme.radius[3]}px;
  `;
});
function ImageBlock(props2) {
  const $ = c(2), t0 = props2.value.image?.url;
  let t1;
  return $[0] !== t0 ? (t1 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginY: 4, children: /* @__PURE__ */ jsx(Image$6, { src: t0 }) }), $[0] = t0, $[1] = t1) : t1 = $[1], t1;
}
const interpolateChildrenText = (interpolation) => (children) => !children || !interpolation ? children : (Array.isArray(children) ? children : [children]).map((child) => typeof child == "string" ? interpolateTemplate(child, interpolation) : child), createComponents = ({
  onLinkClick,
  interpolation
}) => {
  const interpolateChildren = interpolateChildrenText(interpolation);
  return {
    block: {
      normal: ({
        children
      }) => /* @__PURE__ */ jsx(NormalBlock$1, { children: interpolateChildren(children) }),
      h2: ({
        children
      }) => /* @__PURE__ */ jsx(H2Block, { children: interpolateChildren(children) }),
      h3: ({
        children
      }) => /* @__PURE__ */ jsx(H3Block, { children: interpolateChildren(children) })
    },
    list: {
      bullet: ({
        children
      }) => /* @__PURE__ */ jsx("ul", { children: interpolateChildren(children) }),
      number: ({
        children
      }) => /* @__PURE__ */ jsx("ol", { children: interpolateChildren(children) }),
      checkmarks: ({
        children
      }) => /* @__PURE__ */ jsx(Fragment$1, { children: interpolateChildren(children) })
    },
    listItem: {
      bullet: ({
        children
      }) => /* @__PURE__ */ jsx(Text$1, { as: "li", size: 1, muted: !0, style: {
        display: "list-item",
        padding: "0.5rem 0"
      }, children: interpolateChildren(children) }),
      number: ({
        children
      }) => /* @__PURE__ */ jsx(Text$1, { as: "li", size: 1, muted: !0, style: {
        display: "list-item",
        padding: "0.5rem 0"
      }, children: interpolateChildren(children) }),
      checkmarks: ({
        children
      }) => /* @__PURE__ */ jsx(Text$1, { children })
    },
    marks: {
      strong: ({
        children
      }) => /* @__PURE__ */ jsx("strong", { children: interpolateChildren(children) }),
      semibold: ({
        children
      }) => /* @__PURE__ */ jsx(SemiboldSpan, { children: interpolateChildren(children) }),
      link: (props2) => /* @__PURE__ */ jsxs(Link, { href: props2.value.href, rel: "noopener noreferrer", target: "_blank", $useTextColor: props2.value.useTextColor, onClick: onLinkClick ? () => onLinkClick({
        url: props2.value.href,
        linkTitle: props2.text
      }) : void 0, children: [
        props2.children,
        props2.value.showIcon && /* @__PURE__ */ jsx(LinkIcon, { style: {
          marginLeft: "2px"
        } })
      ] }),
      accent: ({
        children
      }) => /* @__PURE__ */ jsx(AccentSpan, { children: interpolateChildren(children) })
    },
    types: {
      inlineIcon: (props2) => {
        const children = props2.value.sanityIcon ? /* @__PURE__ */ jsx(InlineIcon, { symbol: props2.value.sanityIcon, $hasTextLeft: props2.value.hasTextLeft, $hasTextRight: props2.value.hasTextRight }) : /* @__PURE__ */ jsx(Fragment$1, { children: props2.value.icon?.url && /* @__PURE__ */ jsx(DynamicIcon, { icon: props2.value.icon, inline: !0 }) });
        return props2.value.accent ? /* @__PURE__ */ jsx(AccentSpan, { children }) : children;
      },
      divider: () => /* @__PURE__ */ jsx(Box, { marginY: 3, children: /* @__PURE__ */ jsx(Box, { paddingY: 3, children: /* @__PURE__ */ jsx(Divider$2, {}) }) }),
      iconAndText: (props2) => /* @__PURE__ */ jsxs(Flex, { align: "flex-start", paddingX: 2, paddingTop: 1, paddingBottom: 2, marginTop: 2, gap: 2, children: [
        /* @__PURE__ */ jsxs(Flex, { gap: 2, style: {
          flexShrink: 0
        }, children: [
          /* @__PURE__ */ jsx(IconTextContainer, { size: 1, accent: props2.value.accent, children: props2.value.sanityIcon ? /* @__PURE__ */ jsx(Icon, { symbol: props2.value.sanityIcon }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
            props2.value.icon?.url && /* @__PURE__ */ jsx(DynamicIcon, { icon: props2.value.icon }),
            " "
          ] }) }),
          /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", accent: props2.value.accent, children: interpolateChildren(props2.value.title) })
        ] }),
        /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, accent: props2.value.accent, children: interpolateChildren(props2.value.text) })
      ] }),
      imageBlock: (props2) => /* @__PURE__ */ jsx(ImageBlock, { ...props2 })
    }
  };
};
function UpsellDescriptionSerializer(props2) {
  const $ = c(8), {
    blocks,
    onLinkClick,
    interpolation
  } = props2;
  let t0;
  $[0] !== blocks ? (t0 = transformBlocks(blocks), $[0] = blocks, $[1] = t0) : t0 = $[1];
  const value = t0;
  let t1;
  $[2] !== interpolation || $[3] !== onLinkClick ? (t1 = createComponents({
    onLinkClick,
    interpolation
  }), $[2] = interpolation, $[3] = onLinkClick, $[4] = t1) : t1 = $[4];
  const components2 = t1;
  let t2;
  return $[5] !== components2 || $[6] !== value ? (t2 = /* @__PURE__ */ jsx(Card, { tone: "default", children: /* @__PURE__ */ jsx(SerializerContainer, { children: /* @__PURE__ */ jsx(PortableText$1, { value, components: components2, onMissingComponent: !1 }) }) }), $[5] = components2, $[6] = value, $[7] = t2) : t2 = $[7], t2;
}
function _temp$2A(response) {
  if (!response.ok)
    throw new Error(`HTTP error! status: ${response.status}`);
  return response.text();
}
function _temp2$14(error) {
  error.name !== "AbortError" && console.error(error);
}
const StyledButton$3 = /* @__PURE__ */ styled(Button).withConfig({
  displayName: "StyledButton",
  componentId: "sc-12g2r1w-0"
})(({
  theme
}) => {
  const {
    space
  } = getTheme_v2(theme);
  return `
      position: absolute;
      top: ${space[3]}px;
      right: ${space[3]}px;
      z-index: 20;
      background: transparent;
      border-radius: 9999px;
      box-shadow: none;
      color: ${white.hex};
      --card-fg-color: ${white.hex};
      :hover {
        --card-fg-color: ${white.hex};
      }
    `;
}), Image$5 = styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-12g2r1w-1"
})`object-fit:cover;width:100%;height:100%;height:200px;`;
function UpsellDialog(props2) {
  const $ = c(25), {
    data,
    open: t0,
    onClose,
    onPrimaryClick,
    onSecondaryClick,
    interpolation
  } = props2;
  if (!data || !(t0 === void 0 || t0))
    return null;
  let t1;
  $[0] !== data.secondaryButton || $[1] !== onSecondaryClick ? (t1 = data.secondaryButton?.text ? {
    text: data.secondaryButton.text,
    mode: "bleed",
    tone: "default",
    iconRight: LaunchIcon,
    ...data.secondaryButton.url && {
      target: "_blank",
      rel: "noopener noreferrer",
      as: "a",
      href: data.secondaryButton.url
    },
    onClick: onSecondaryClick
  } : void 0, $[0] = data.secondaryButton, $[1] = onSecondaryClick, $[2] = t1) : t1 = $[2];
  const t2 = data.ctaButton?.text;
  let t3;
  $[3] !== data.ctaButton.url ? (t3 = data.ctaButton.url && {
    target: "_blank",
    rel: "noopener noreferrer",
    as: "a",
    href: data.ctaButton.url
  }, $[3] = data.ctaButton.url, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== onPrimaryClick || $[6] !== t2 || $[7] !== t3 ? (t4 = {
    text: t2,
    mode: "default",
    tone: "default",
    ...t3,
    onClick: onPrimaryClick
  }, $[5] = onPrimaryClick, $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t1 || $[10] !== t4 ? (t5 = {
    cancelButton: t1,
    confirmButton: t4
  }, $[9] = t1, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== onClose ? (t6 = /* @__PURE__ */ jsx(StyledButton$3, { icon: CloseIcon, mode: "bleed", tone: "default", onClick: onClose, tabIndex: -1, tooltipProps: null }), $[12] = onClose, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== data.image ? (t7 = data.image && /* @__PURE__ */ jsx(Image$5, { src: data.image.asset.url, alt: data.image.asset.altText ?? "" }), $[14] = data.image, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== data.descriptionText || $[17] !== interpolation ? (t8 = /* @__PURE__ */ jsx(Box, { padding: 3, marginTop: 2, children: /* @__PURE__ */ jsx(Stack, { space: 4, paddingBottom: 2, children: /* @__PURE__ */ jsx(UpsellDescriptionSerializer, { blocks: data.descriptionText, interpolation }) }) }), $[16] = data.descriptionText, $[17] = interpolation, $[18] = t8) : t8 = $[18];
  let t9;
  return $[19] !== onClose || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Dialog$1, { id: "upsell-dialog", onClose, onClickOutside: onClose, __unstable_hideCloseButton: !0, bodyHeight: "fill", padding: !1, zOffset: 800, footer: t5, children: [
    t6,
    t7,
    t8
  ] }), $[19] = onClose, $[20] = t5, $[21] = t6, $[22] = t7, $[23] = t8, $[24] = t9) : t9 = $[24], t9;
}
function AssetLimitUpsellProvider(t0) {
  const $ = c(9), {
    children
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    dataUri: "/journey/asset-limit",
    feature: "asset-limits"
  }, $[0] = t1) : t1 = $[0];
  const contextValue = useUpsellContext(t1);
  let t2;
  $[1] !== contextValue ? (t2 = getDialogPropsFromContext(contextValue), $[1] = contextValue, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(UpsellDialog, { ...t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== children || $[6] !== contextValue || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(AssetLimitUpsellContext.Provider, { value: contextValue, children: [
    children,
    t3
  ] }), $[5] = children, $[6] = contextValue, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
const useAssetLimitsUpsellContext = () => {
  const context = useContext(AssetLimitUpsellContext);
  if (!context)
    throw new Error("useAssetLimitsUpsellContext must be used within a AssetLimitUpsellProvider");
  return context;
};
function WithReferencedAsset(props2) {
  const $ = c(10), {
    reference,
    children,
    observeAsset,
    waitPlaceholder
  } = props2, documentId = reference?._ref;
  let t0;
  $[0] !== documentId || $[1] !== observeAsset ? (t0 = observeAsset(documentId), $[0] = documentId, $[1] = observeAsset, $[2] = t0) : t0 = $[2];
  const asset = useObservable(t0);
  let t1;
  $[3] !== asset || $[4] !== children || $[5] !== documentId || $[6] !== waitPlaceholder ? (t1 = documentId && asset ? children(asset) : waitPlaceholder, $[3] = asset, $[4] = children, $[5] = documentId, $[6] = waitPlaceholder, $[7] = t1) : t1 = $[7];
  let t2;
  return $[8] !== t1 ? (t2 = /* @__PURE__ */ jsx(Fragment$1, { children: t1 }), $[8] = t1, $[9] = t2) : t2 = $[9], t2;
}
const DIALOG_TITLE_KEYS = {
  file: "inputs.files.select-dialog.title",
  image: "inputs.image.select-dialog.title",
  "sanity.video": "inputs.video.select-dialog.title"
}, DEFAULT_ACCEPT = {
  file: "",
  image: "image/*",
  "sanity.video": "video/*"
};
function AssetSourceDialog(props2) {
  const $ = c(35), {
    action,
    assetType,
    observeAsset,
    onClose,
    onChangeAction,
    onSelect,
    openInSourceAsset,
    schemaType,
    selectedAssetSource,
    value,
    uploader
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== assetType || $[1] !== props2.accept || $[2] !== schemaType ? (t0 = props2.accept ?? get(schemaType, "options.accept", DEFAULT_ACCEPT[assetType]), $[0] = assetType, $[1] = props2.accept, $[2] = schemaType, $[3] = t0) : t0 = $[3];
  const accept = t0;
  let t1;
  $[4] !== assetType || $[5] !== schemaType?.title || $[6] !== t ? (t1 = () => t(DIALOG_TITLE_KEYS[assetType], {
    targetTitle: schemaType?.title
  }), $[4] = assetType, $[5] = schemaType?.title, $[6] = t, $[7] = t1) : t1 = $[7];
  let t2;
  $[8] !== t1 ? (t2 = t1(), $[8] = t1, $[9] = t2) : t2 = $[9];
  const dialogHeaderTitle = t2, {
    waitPlaceholder
  } = props2, Component2 = selectedAssetSource.component, t3 = openInSourceAsset || void 0;
  let t4;
  $[10] !== accept || $[11] !== action || $[12] !== assetType || $[13] !== dialogHeaderTitle || $[14] !== onChangeAction || $[15] !== onClose || $[16] !== onSelect || $[17] !== schemaType || $[18] !== selectedAssetSource || $[19] !== t3 || $[20] !== uploader ? (t4 = {
    accept,
    action,
    assetSource: selectedAssetSource,
    assetToOpen: t3,
    assetType,
    dialogHeaderTitle,
    onChangeAction,
    onClose,
    onSelect,
    schemaType,
    selectionType: "single",
    uploader
  }, $[10] = accept, $[11] = action, $[12] = assetType, $[13] = dialogHeaderTitle, $[14] = onChangeAction, $[15] = onClose, $[16] = onSelect, $[17] = schemaType, $[18] = selectedAssetSource, $[19] = t3, $[20] = uploader, $[21] = t4) : t4 = $[21];
  const commonProps = t4;
  let t5;
  $[22] !== Component2 || $[23] !== commonProps ? (t5 = (asset) => /* @__PURE__ */ jsx(Component2, { ...commonProps, selectedAssets: [asset] }), $[22] = Component2, $[23] = commonProps, $[24] = t5) : t5 = $[24];
  const renderWithAsset = t5;
  let t6;
  $[25] !== Component2 || $[26] !== commonProps ? (t6 = () => /* @__PURE__ */ jsx(Component2, { ...commonProps, selectedAssets: [] }), $[25] = Component2, $[26] = commonProps, $[27] = t6) : t6 = $[27];
  const renderWithoutAsset = t6;
  if (value?.asset && observeAsset && action !== "select") {
    let t72;
    return $[28] !== observeAsset || $[29] !== renderWithAsset || $[30] !== value.asset || $[31] !== waitPlaceholder ? (t72 = /* @__PURE__ */ jsx(WithReferencedAsset, { observeAsset, reference: value.asset, waitPlaceholder, children: renderWithAsset }), $[28] = observeAsset, $[29] = renderWithAsset, $[30] = value.asset, $[31] = waitPlaceholder, $[32] = t72) : t72 = $[32], t72;
  }
  let t7;
  return $[33] !== renderWithoutAsset ? (t7 = renderWithoutAsset(), $[33] = renderWithoutAsset, $[34] = t7) : t7 = $[34], t7;
}
function useAssetSourceActionState() {
  const $ = c(13), [action, setAction] = useState(), [selectedAssetSource, setSelectedAssetSource] = useState(null), [openInSourceAsset, setOpenInSourceAsset] = useState(null), [isUploading, setIsUploading] = useState(!1), [isStale, setIsStale] = useState(!1);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = (assetSource) => {
    setAction("select"), setSelectedAssetSource(assetSource);
  }, $[0] = t0) : t0 = $[0];
  const openForBrowse = t0;
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (assetSource_0) => {
    setAction("upload"), setSelectedAssetSource(assetSource_0), setIsUploading(!0);
  }, $[1] = t1) : t1 = $[1];
  const openForUpload = t1;
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (assetSource_1, asset) => {
    setAction("openInSource"), setSelectedAssetSource(assetSource_1), setOpenInSourceAsset(asset);
  }, $[2] = t2) : t2 = $[2];
  const openInSource2 = t2;
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (newAction) => {
    setAction(newAction), setOpenInSourceAsset(null);
  }, $[3] = t3) : t3 = $[3];
  const changeAction = t3;
  let t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setSelectedAssetSource(null), setOpenInSourceAsset(null), setIsUploading(!1), setIsStale(!1), setAction(void 0);
  }, $[4] = t4) : t4 = $[4];
  const resetOnComplete = t4;
  let t5;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    resetOnComplete();
  }, $[5] = t5) : t5 = $[5];
  const close = t5;
  let t6;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = () => setIsStale(!0), $[6] = t6) : t6 = $[6];
  const onStale = t6;
  let t7;
  return $[7] !== action || $[8] !== isStale || $[9] !== isUploading || $[10] !== openInSourceAsset || $[11] !== selectedAssetSource ? (t7 = {
    action,
    selectedAssetSource,
    openInSourceAsset,
    setOpenInSourceAsset,
    setSelectedAssetSource,
    openForBrowse,
    openForUpload,
    openInSource: openInSource2,
    changeAction,
    close,
    resetOnComplete,
    isUploading,
    setIsUploading,
    isStale,
    setIsStale,
    onStale
  }, $[7] = action, $[8] = isStale, $[9] = isUploading, $[10] = openInSourceAsset, $[11] = selectedAssetSource, $[12] = t7) : t7 = $[12], t7;
}
const isAssetLimitError = (error) => error instanceof ClientError ? error.response.body.error === "plan_limit_reached" : !1;
function useAssetSourceUploader(options) {
  const $ = c(17), {
    onChange,
    schemaType,
    handleOpenSourceForUpload,
    handleAssetSourceResetOnComplete,
    setIsUploading,
    onAssetLimitError,
    onAllComplete
  } = options, {
    push
  } = useToast(), {
    t
  } = useTranslation(), [assetSourceUploader, setAssetSourceUploader] = useState(null);
  let t0, t1;
  $[0] !== assetSourceUploader ? (t0 = () => () => {
    assetSourceUploader?.uploader?.abort(), assetSourceUploader?.unsubscribe();
  }, t1 = [assetSourceUploader], $[0] = assetSourceUploader, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  $[3] !== assetSourceUploader || $[4] !== handleAssetSourceResetOnComplete || $[5] !== handleOpenSourceForUpload || $[6] !== onAllComplete || $[7] !== onAssetLimitError || $[8] !== onChange || $[9] !== push || $[10] !== schemaType || $[11] !== setIsUploading || $[12] !== t ? (t2 = (assetSource, files) => {
    if (files.length === 0 || (handleOpenSourceForUpload(assetSource), !assetSource.Uploader))
      return;
    const uploader = new assetSource.Uploader();
    assetSourceUploader?.unsubscribe();
    try {
      setAssetSourceUploader({
        unsubscribe: uploader.subscribe((event) => {
          bb49: switch (event.type) {
            case "progress": {
              onChange(PatchEvent.from([set(Math.max(2, event.progress), [UPLOAD_STATUS_KEY, "progress"]), set((/* @__PURE__ */ new Date()).toISOString(), [UPLOAD_STATUS_KEY, "updatedAt"])]));
              break bb49;
            }
            case "error": {
              event.files.forEach(_temp$2z), push({
                status: "error",
                description: t("asset-sources.common.uploader.upload-failed.description"),
                title: t("asset-sources.common.uploader.upload-failed.title")
              });
              break bb49;
            }
            case "all-complete": {
              onAssetLimitError && event.files && event.files.some(_temp2$13) && onAssetLimitError(), onChange(PatchEvent.from([unset([UPLOAD_STATUS_KEY])])), onAllComplete?.(), handleAssetSourceResetOnComplete();
              break bb49;
            }
            default:
          }
        }),
        uploader
      }), setIsUploading(!0), onChange(PatchEvent.from(createInitialUploadPatches(files[0]))), uploader.upload(files, {
        schemaType,
        onChange
      });
    } catch (t32) {
      const err = t32;
      onChange(PatchEvent.from([unset([UPLOAD_STATUS_KEY])])), handleAssetSourceResetOnComplete(), assetSourceUploader?.unsubscribe(), setAssetSourceUploader(null), push({
        status: "error",
        description: t("asset-sources.common.uploader.upload-failed.description"),
        title: t("asset-sources.common.uploader.upload-failed.title")
      }), console.error(err);
    }
  }, $[3] = assetSourceUploader, $[4] = handleAssetSourceResetOnComplete, $[5] = handleOpenSourceForUpload, $[6] = onAllComplete, $[7] = onAssetLimitError, $[8] = onChange, $[9] = push, $[10] = schemaType, $[11] = setIsUploading, $[12] = t, $[13] = t2) : t2 = $[13];
  const handleSelectFilesToUpload = t2;
  let t3;
  return $[14] !== assetSourceUploader || $[15] !== handleSelectFilesToUpload ? (t3 = {
    assetSourceUploader,
    handleSelectFilesToUpload
  }, $[14] = assetSourceUploader, $[15] = handleSelectFilesToUpload, $[16] = t3) : t3 = $[16], t3;
}
function _temp2$13(file) {
  return file.status === "error" && isAssetLimitError(file.error);
}
function _temp$2z(file_0) {
  return console.error(file_0.error);
}
function useUploadExternalFileToDataset(options) {
  const $ = c(19), {
    client,
    schemaType,
    onChange,
    setIsUploading,
    uploadFailedTitleKey: t0,
    uploadFailedDescriptionKey: t1
  } = options, uploadFailedTitleKey = t0 === void 0 ? "inputs.file.upload-failed.title" : t0, uploadFailedDescriptionKey = t1 === void 0 ? "inputs.file.upload-failed.description" : t1, {
    push
  } = useToast(), {
    t
  } = useTranslation(), uploadSubscriptionRef = useRef(null);
  let t2;
  $[0] !== onChange ? (t2 = () => {
    onChange(PatchEvent.from([unset(["_upload"])]));
  }, $[0] = onChange, $[1] = t2) : t2 = $[1];
  const clearUploadStatus = t2;
  let t3;
  $[2] !== clearUploadStatus ? (t3 = () => {
    uploadSubscriptionRef.current?.unsubscribe(), uploadSubscriptionRef.current = null, clearUploadStatus();
  }, $[2] = clearUploadStatus, $[3] = t3) : t3 = $[3];
  const cancelUpload = t3;
  let t4;
  $[4] !== cancelUpload || $[5] !== clearUploadStatus || $[6] !== client || $[7] !== onChange || $[8] !== push || $[9] !== schemaType || $[10] !== setIsUploading || $[11] !== t || $[12] !== uploadFailedDescriptionKey || $[13] !== uploadFailedTitleKey ? (t4 = (uploader, file, t52) => {
    const assetDocumentProps = t52 === void 0 ? {} : t52, {
      source
    } = assetDocumentProps, uploadOptions = {
      metadata: get(schemaType, "options.metadata"),
      storeOriginalFilename: get(schemaType, "options.storeOriginalFilename"),
      source
    };
    cancelUpload(), setIsUploading(!0), onChange(PatchEvent.from([setIfMissing({
      _type: schemaType.name
    })])), uploadSubscriptionRef.current = uploader.upload(client, file, schemaType, uploadOptions).subscribe({
      next: (uploadEvent) => {
        uploadEvent.patches && onChange(PatchEvent.from(uploadEvent.patches));
      },
      error: (err) => {
        console.error(err), push({
          status: "error",
          description: t(uploadFailedDescriptionKey),
          title: t(uploadFailedTitleKey)
        }), clearUploadStatus();
      },
      complete: () => {
        setIsUploading(!1);
      }
    });
  }, $[4] = cancelUpload, $[5] = clearUploadStatus, $[6] = client, $[7] = onChange, $[8] = push, $[9] = schemaType, $[10] = setIsUploading, $[11] = t, $[12] = uploadFailedDescriptionKey, $[13] = uploadFailedTitleKey, $[14] = t4) : t4 = $[14];
  const uploadWith = t4;
  let t5;
  return $[15] !== cancelUpload || $[16] !== clearUploadStatus || $[17] !== uploadWith ? (t5 = {
    uploadWith,
    cancelUpload,
    clearUploadStatus
  }, $[15] = cancelUpload, $[16] = clearUploadStatus, $[17] = uploadWith, $[18] = t5) : t5 = $[18], t5;
}
function useAssetSource(options) {
  const $ = c(22), {
    client,
    onChange,
    schemaType,
    onAssetLimitError,
    onAllComplete
  } = options, state = useAssetSourceActionState(), {
    close: assetSourceClose,
    openForUpload: handleOpenSourceForUpload,
    resetOnComplete: handleAssetSourceResetOnComplete,
    setIsUploading
  } = state, menuButtonRef = useRef(null);
  let t0;
  $[0] !== assetSourceClose ? (t0 = () => {
    assetSourceClose(), menuButtonRef.current?.focus();
  }, $[0] = assetSourceClose, $[1] = t0) : t0 = $[1];
  const close = t0;
  let t1;
  $[2] !== handleAssetSourceResetOnComplete || $[3] !== handleOpenSourceForUpload || $[4] !== onAllComplete || $[5] !== onAssetLimitError || $[6] !== onChange || $[7] !== schemaType || $[8] !== setIsUploading ? (t1 = {
    onChange,
    schemaType,
    handleOpenSourceForUpload,
    handleAssetSourceResetOnComplete,
    setIsUploading,
    onAssetLimitError,
    onAllComplete
  }, $[2] = handleAssetSourceResetOnComplete, $[3] = handleOpenSourceForUpload, $[4] = onAllComplete, $[5] = onAssetLimitError, $[6] = onChange, $[7] = schemaType, $[8] = setIsUploading, $[9] = t1) : t1 = $[9];
  const {
    assetSourceUploader,
    handleSelectFilesToUpload
  } = useAssetSourceUploader(t1);
  let t2;
  $[10] !== client || $[11] !== onChange || $[12] !== schemaType || $[13] !== setIsUploading ? (t2 = {
    client,
    schemaType,
    onChange,
    setIsUploading
  }, $[10] = client, $[11] = onChange, $[12] = schemaType, $[13] = setIsUploading, $[14] = t2) : t2 = $[14];
  const {
    uploadWith,
    clearUploadStatus
  } = useUploadExternalFileToDataset(t2);
  let t3;
  return $[15] !== assetSourceUploader || $[16] !== clearUploadStatus || $[17] !== close || $[18] !== handleSelectFilesToUpload || $[19] !== state || $[20] !== uploadWith ? (t3 = {
    ...state,
    close,
    menuButtonRef,
    assetSourceUploader,
    handleSelectFilesToUpload,
    uploadWith,
    clearUploadStatus
  }, $[15] = assetSourceUploader, $[16] = clearUploadStatus, $[17] = close, $[18] = handleSelectFilesToUpload, $[19] = state, $[20] = uploadWith, $[21] = t3) : t3 = $[21], t3;
}
const noop$2 = () => {
}, UNDEFINED = (
  /*#__NOINLINE__*/
  noop$2()
), OBJECT = Object, isUndefined = (v) => v === UNDEFINED, isFunction = (v) => typeof v == "function", mergeObjects = (a, b) => ({
  ...a,
  ...b
}), isPromiseLike = (x) => isFunction(x.then), table = /* @__PURE__ */ new WeakMap();
let counter$1 = 0;
const stableHash = (arg) => {
  const type = typeof arg, constructor = arg && arg.constructor, isDate = constructor == Date;
  let result, index;
  if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
    if (result = table.get(arg), result) return result;
    if (result = ++counter$1 + "~", table.set(arg, result), constructor == Array) {
      for (result = "@", index = 0; index < arg.length; index++)
        result += stableHash(arg[index]) + ",";
      table.set(arg, result);
    }
    if (constructor == OBJECT) {
      result = "#";
      const keys = OBJECT.keys(arg).sort();
      for (; !isUndefined(index = keys.pop()); )
        isUndefined(arg[index]) || (result += index + ":" + stableHash(arg[index]) + ",");
      table.set(arg, result);
    }
  } else
    result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
  return result;
}, SWRGlobalState = /* @__PURE__ */ new WeakMap(), EMPTY_CACHE = {}, INITIAL_CACHE = {}, STR_UNDEFINED = "undefined", isWindowDefined = typeof window != STR_UNDEFINED, isDocumentDefined = typeof document != STR_UNDEFINED, hasRequestAnimationFrame = () => isWindowDefined && typeof window.requestAnimationFrame != STR_UNDEFINED, createCacheHelper = (cache2, key) => {
  const state = SWRGlobalState.get(cache2);
  return [
    // Getter
    () => !isUndefined(key) && cache2.get(key) || EMPTY_CACHE,
    // Setter
    (info) => {
      if (!isUndefined(key)) {
        const prev = cache2.get(key);
        key in INITIAL_CACHE || (INITIAL_CACHE[key] = prev), state[5](key, mergeObjects(prev, info), prev || EMPTY_CACHE);
      }
    },
    // Subscriber
    state[6],
    // Get server cache snapshot
    () => !isUndefined(key) && key in INITIAL_CACHE ? INITIAL_CACHE[key] : !isUndefined(key) && cache2.get(key) || EMPTY_CACHE
  ];
};
let online = !0;
const isOnline = () => online, [onWindowEvent, offWindowEvent] = isWindowDefined && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  noop$2,
  noop$2
], isVisible = () => {
  const visibilityState = isDocumentDefined && document.visibilityState;
  return isUndefined(visibilityState) || visibilityState !== "hidden";
}, initFocus = (callback) => (isDocumentDefined && document.addEventListener("visibilitychange", callback), onWindowEvent("focus", callback), () => {
  isDocumentDefined && document.removeEventListener("visibilitychange", callback), offWindowEvent("focus", callback);
}), initReconnect = (callback) => {
  const onOnline = () => {
    online = !0, callback();
  }, onOffline = () => {
    online = !1;
  };
  return onWindowEvent("online", onOnline), onWindowEvent("offline", onOffline), () => {
    offWindowEvent("online", onOnline), offWindowEvent("offline", onOffline);
  };
}, preset = {
  isOnline,
  isVisible
}, defaultConfigOptions = {
  initFocus,
  initReconnect
}, IS_REACT_LEGACY = !React.useId, IS_SERVER = !isWindowDefined || "Deno" in window, rAF = (f) => hasRequestAnimationFrame() ? window.requestAnimationFrame(f) : setTimeout(f, 1), useIsomorphicLayoutEffect = IS_SERVER ? useEffect : useLayoutEffect, navigatorConnection = typeof navigator < "u" && navigator.connection, slowConnection = !IS_SERVER && navigatorConnection && ([
  "slow-2g",
  "2g"
].includes(navigatorConnection.effectiveType) || navigatorConnection.saveData), serialize$2 = (key) => {
  if (isFunction(key))
    try {
      key = key();
    } catch {
      key = "";
    }
  const args = key;
  return key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? stableHash(key) : "", [
    key,
    args
  ];
};
let __timestamp = 0;
const getTimestamp = () => ++__timestamp, FOCUS_EVENT = 0, RECONNECT_EVENT = 1, MUTATE_EVENT = 2, ERROR_REVALIDATE_EVENT = 3;
var events = {
  __proto__: null,
  ERROR_REVALIDATE_EVENT,
  FOCUS_EVENT,
  MUTATE_EVENT,
  RECONNECT_EVENT
};
async function internalMutate(...args) {
  const [cache2, _key, _data, _opts] = args, options = mergeObjects({
    populateCache: !0,
    throwOnError: !0
  }, typeof _opts == "boolean" ? {
    revalidate: _opts
  } : _opts || {});
  let populateCache = options.populateCache;
  const rollbackOnErrorOption = options.rollbackOnError;
  let optimisticData = options.optimisticData;
  const rollbackOnError = (error) => typeof rollbackOnErrorOption == "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== !1, throwOnError = options.throwOnError;
  if (isFunction(_key)) {
    const keyFilter = _key, matchedKeys = [], it = cache2.keys();
    for (const key of it)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(key) && keyFilter(cache2.get(key)._k) && matchedKeys.push(key);
    return Promise.all(matchedKeys.map(mutateByKey));
  }
  return mutateByKey(_key);
  async function mutateByKey(_k) {
    const [key] = serialize$2(_k);
    if (!key) return;
    const [get2, set2] = createCacheHelper(cache2, key), [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = SWRGlobalState.get(cache2), startRevalidate = () => {
      const revalidators = EVENT_REVALIDATORS[key];
      return (isFunction(options.revalidate) ? options.revalidate(get2().data, _k) : options.revalidate !== !1) && (delete FETCH[key], delete PRELOAD[key], revalidators && revalidators[0]) ? revalidators[0](MUTATE_EVENT).then(() => get2().data) : get2().data;
    };
    if (args.length < 3)
      return startRevalidate();
    let data = _data, error;
    const beforeMutationTs = getTimestamp();
    MUTATION[key] = [
      beforeMutationTs,
      0
    ];
    const hasOptimisticData = !isUndefined(optimisticData), state = get2(), displayedData = state.data, currentData = state._c, committedData = isUndefined(currentData) ? displayedData : currentData;
    if (hasOptimisticData && (optimisticData = isFunction(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData, set2({
      data: optimisticData,
      _c: committedData
    })), isFunction(data))
      try {
        data = data(committedData);
      } catch (err) {
        error = err;
      }
    if (data && isPromiseLike(data))
      if (data = await data.catch((err) => {
        error = err;
      }), beforeMutationTs !== MUTATION[key][0]) {
        if (error) throw error;
        return data;
      } else error && hasOptimisticData && rollbackOnError(error) && (populateCache = !0, set2({
        data: committedData,
        _c: UNDEFINED
      }));
    if (populateCache && !error)
      if (isFunction(populateCache)) {
        const populateCachedData = populateCache(data, committedData);
        set2({
          data: populateCachedData,
          error: UNDEFINED,
          _c: UNDEFINED
        });
      } else
        set2({
          data,
          error: UNDEFINED,
          _c: UNDEFINED
        });
    if (MUTATION[key][1] = getTimestamp(), Promise.resolve(startRevalidate()).then(() => {
      set2({
        _c: UNDEFINED
      });
    }), error) {
      if (throwOnError) throw error;
      return;
    }
    return data;
  }
}
const revalidateAllKeys = (revalidators, type) => {
  for (const key in revalidators)
    revalidators[key][0] && revalidators[key][0](type);
}, initCache = (provider, options) => {
  if (!SWRGlobalState.has(provider)) {
    const opts = mergeObjects(defaultConfigOptions, options), EVENT_REVALIDATORS = {}, mutate2 = internalMutate.bind(UNDEFINED, provider);
    let unmount = noop$2;
    const subscriptions = {}, subscribe2 = (key, callback) => {
      const subs = subscriptions[key] || [];
      return subscriptions[key] = subs, subs.push(callback), () => subs.splice(subs.indexOf(callback), 1);
    }, setter = (key, value, prev) => {
      provider.set(key, value);
      const subs = subscriptions[key];
      if (subs)
        for (const fn of subs)
          fn(value, prev);
    }, initProvider = () => {
      if (!SWRGlobalState.has(provider) && (SWRGlobalState.set(provider, [
        EVENT_REVALIDATORS,
        {},
        {},
        {},
        mutate2,
        setter,
        subscribe2
      ]), !IS_SERVER)) {
        const releaseFocus = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT))), releaseReconnect = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
        unmount = () => {
          releaseFocus && releaseFocus(), releaseReconnect && releaseReconnect(), SWRGlobalState.delete(provider);
        };
      }
    };
    return initProvider(), [
      provider,
      mutate2,
      initProvider,
      unmount
    ];
  }
  return [
    provider,
    SWRGlobalState.get(provider)[4]
  ];
}, onErrorRetry = (_, __, config, revalidate, opts) => {
  const maxRetryCount = config.errorRetryCount, currentRetryCount = opts.retryCount, timeout2 = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
  !isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount || setTimeout(revalidate, timeout2, opts);
}, compare = (currentData, newData) => stableHash(currentData) == stableHash(newData), [cache$1, mutate] = initCache(/* @__PURE__ */ new Map()), defaultConfig = mergeObjects(
  {
    // events
    onLoadingSlow: noop$2,
    onSuccess: noop$2,
    onError: noop$2,
    onErrorRetry,
    onDiscarded: noop$2,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: slowConnection ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: slowConnection ? 5e3 : 3e3,
    // providers
    compare,
    isPaused: () => !1,
    cache: cache$1,
    mutate,
    fallback: {}
  },
  // use web preset by default
  preset
), mergeConfigs = (a, b) => {
  const v = mergeObjects(a, b);
  if (b) {
    const { use: u1, fallback: f1 } = a, { use: u2, fallback: f2 } = b;
    u1 && u2 && (v.use = u1.concat(u2)), f1 && f2 && (v.fallback = mergeObjects(f1, f2));
  }
  return v;
}, SWRConfigContext = createContext({}), INFINITE_PREFIX = "$inf$", enableDevtools = isWindowDefined && window.__SWR_DEVTOOLS_USE__, use$1 = enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [], setupDevTools = () => {
  enableDevtools && (window.__SWR_DEVTOOLS_REACT__ = React);
}, normalize = (args) => isFunction(args[1]) ? [
  args[0],
  args[1],
  args[2] || {}
] : [
  args[0],
  null,
  (args[1] === null ? args[2] : args[1]) || {}
], useSWRConfig = () => mergeObjects(defaultConfig, useContext(SWRConfigContext)), middleware = (useSWRNext) => (key_, fetcher_, config) => useSWRNext(key_, fetcher_ && ((...args) => {
  const [key] = serialize$2(key_), [, , , PRELOAD] = SWRGlobalState.get(cache$1);
  if (key.startsWith(INFINITE_PREFIX))
    return fetcher_(...args);
  const req = PRELOAD[key];
  return isUndefined(req) ? fetcher_(...args) : (delete PRELOAD[key], req);
}), config), BUILT_IN_MIDDLEWARE = use$1.concat(middleware), withArgs = (hook) => function(...args) {
  const fallbackConfig = useSWRConfig(), [key, fn, _config] = normalize(args), config = mergeConfigs(fallbackConfig, _config);
  let next = hook;
  const { use: use2 } = config, middleware2 = (use2 || []).concat(BUILT_IN_MIDDLEWARE);
  for (let i = middleware2.length; i--; )
    next = middleware2[i](next);
  return next(key, fn || config.fetcher || null, config);
}, subscribeCallback = (key, callbacks, callback) => {
  const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
  return keyedRevalidators.push(callback), () => {
    const index = keyedRevalidators.indexOf(callback);
    index >= 0 && (keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1], keyedRevalidators.pop());
  };
};
setupDevTools();
const use = React.use || ((promise) => {
  if (promise.status === "pending")
    throw promise;
  if (promise.status === "fulfilled")
    return promise.value;
  throw promise.status === "rejected" ? promise.reason : (promise.status = "pending", promise.then((v) => {
    promise.status = "fulfilled", promise.value = v;
  }, (e) => {
    promise.status = "rejected", promise.reason = e;
  }), promise);
}), WITH_DEDUPE = {
  dedupe: !0
}, useSWRHandler = (_key, fetcher, config) => {
  const { cache: cache2, compare: compare2, suspense, fallbackData, revalidateOnMount, revalidateIfStale, refreshInterval, refreshWhenHidden, refreshWhenOffline, keepPreviousData } = config, [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = SWRGlobalState.get(cache2), [key, fnArg] = serialize$2(_key), initialMountedRef = useRef(!1), unmountedRef = useRef(!1), keyRef = useRef(key), fetcherRef = useRef(fetcher), configRef = useRef(config), getConfig = () => configRef.current, isActive = () => getConfig().isVisible() && getConfig().isOnline(), [getCache, setCache, subscribeCache, getInitialCache] = createCacheHelper(cache2, key), stateDependencies = useRef({}).current, fallback2 = isUndefined(fallbackData) ? config.fallback[key] : fallbackData, isEqual2 = (prev, current) => {
    for (const _ in stateDependencies) {
      const t = _;
      if (t === "data") {
        if (!compare2(prev[t], current[t]) && (!isUndefined(prev[t]) || !compare2(returnedData, current[t])))
          return !1;
      } else if (current[t] !== prev[t])
        return !1;
    }
    return !0;
  }, getSnapshot2 = useMemo(() => {
    const shouldStartRequest = !key || !fetcher ? !1 : isUndefined(revalidateOnMount) ? getConfig().isPaused() || suspense ? !1 : isUndefined(revalidateIfStale) ? !0 : revalidateIfStale : revalidateOnMount, getSelectedCache = (state) => {
      const snapshot2 = mergeObjects(state);
      return delete snapshot2._k, shouldStartRequest ? {
        isValidating: !0,
        isLoading: !0,
        ...snapshot2
      } : snapshot2;
    }, cachedData2 = getCache(), initialData = getInitialCache(), clientSnapshot = getSelectedCache(cachedData2), serverSnapshot = cachedData2 === initialData ? clientSnapshot : getSelectedCache(initialData);
    let memorizedSnapshot = clientSnapshot;
    return [
      () => {
        const newSnapshot = getSelectedCache(getCache());
        return isEqual2(newSnapshot, memorizedSnapshot) ? (memorizedSnapshot.data = newSnapshot.data, memorizedSnapshot.isLoading = newSnapshot.isLoading, memorizedSnapshot.isValidating = newSnapshot.isValidating, memorizedSnapshot.error = newSnapshot.error, memorizedSnapshot) : (memorizedSnapshot = newSnapshot, newSnapshot);
      },
      () => serverSnapshot
    ];
  }, [
    cache2,
    key
  ]), cached = useSyncExternalStore$1(useCallback(
    (callback) => subscribeCache(key, (current, prev) => {
      isEqual2(prev, current) || callback();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      cache2,
      key
    ]
  ), getSnapshot2[0], getSnapshot2[1]), isInitialMount = !initialMountedRef.current, hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0, cachedData = cached.data, data = isUndefined(cachedData) ? fallback2 : cachedData, error = cached.error, laggyDataRef = useRef(data), returnedData = keepPreviousData ? isUndefined(cachedData) ? laggyDataRef.current : cachedData : data, shouldDoInitialRevalidation = hasRevalidator && !isUndefined(error) ? !1 : isInitialMount && !isUndefined(revalidateOnMount) ? revalidateOnMount : getConfig().isPaused() ? !1 : suspense ? isUndefined(data) ? !1 : revalidateIfStale : isUndefined(data) || revalidateIfStale, defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation), isValidating = isUndefined(cached.isValidating) ? defaultValidatingState : cached.isValidating, isLoading = isUndefined(cached.isLoading) ? defaultValidatingState : cached.isLoading, revalidate = useCallback(
    async (revalidateOpts) => {
      const currentFetcher = fetcherRef.current;
      if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused())
        return !1;
      let newData, startAt, loading = !0;
      const opts = revalidateOpts || {}, shouldStartNewRequest = !FETCH[key] || !opts.dedupe, callbackSafeguard = () => IS_REACT_LEGACY ? !unmountedRef.current && key === keyRef.current && initialMountedRef.current : key === keyRef.current, finalState = {
        isValidating: !1,
        isLoading: !1
      }, finishRequestAndUpdateState = () => {
        setCache(finalState);
      }, cleanupState = () => {
        const requestInfo = FETCH[key];
        requestInfo && requestInfo[1] === startAt && delete FETCH[key];
      }, initialState2 = {
        isValidating: !0
      };
      isUndefined(getCache().data) && (initialState2.isLoading = !0);
      try {
        if (shouldStartNewRequest && (setCache(initialState2), config.loadingTimeout && isUndefined(getCache().data) && setTimeout(() => {
          loading && callbackSafeguard() && getConfig().onLoadingSlow(key, config);
        }, config.loadingTimeout), FETCH[key] = [
          currentFetcher(fnArg),
          getTimestamp()
        ]), [newData, startAt] = FETCH[key], newData = await newData, shouldStartNewRequest && setTimeout(cleanupState, config.dedupingInterval), !FETCH[key] || FETCH[key][1] !== startAt)
          return shouldStartNewRequest && callbackSafeguard() && getConfig().onDiscarded(key), !1;
        finalState.error = UNDEFINED;
        const mutationInfo = MUTATION[key];
        if (!isUndefined(mutationInfo) && // case 1
        (startAt <= mutationInfo[0] || // case 2
        startAt <= mutationInfo[1] || // case 3
        mutationInfo[1] === 0))
          return finishRequestAndUpdateState(), shouldStartNewRequest && callbackSafeguard() && getConfig().onDiscarded(key), !1;
        const cacheData = getCache().data;
        finalState.data = compare2(cacheData, newData) ? cacheData : newData, shouldStartNewRequest && callbackSafeguard() && getConfig().onSuccess(newData, key, config);
      } catch (err) {
        cleanupState();
        const currentConfig = getConfig(), { shouldRetryOnError } = currentConfig;
        currentConfig.isPaused() || (finalState.error = err, shouldStartNewRequest && callbackSafeguard() && (currentConfig.onError(err, key, currentConfig), (shouldRetryOnError === !0 || isFunction(shouldRetryOnError) && shouldRetryOnError(err)) && (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) && currentConfig.onErrorRetry(err, key, currentConfig, (_opts) => {
          const revalidators = EVENT_REVALIDATORS[key];
          revalidators && revalidators[0] && revalidators[0](events.ERROR_REVALIDATE_EVENT, _opts);
        }, {
          retryCount: (opts.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return loading = !1, finishRequestAndUpdateState(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      key,
      cache2
    ]
  ), boundMutate = useCallback(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...args) => internalMutate(cache2, keyRef.current, ...args),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (useIsomorphicLayoutEffect(() => {
    fetcherRef.current = fetcher, configRef.current = config, isUndefined(cachedData) || (laggyDataRef.current = cachedData);
  }), useIsomorphicLayoutEffect(() => {
    if (!key) return;
    const softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
    let nextFocusRevalidatedAt = 0;
    const unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, (type, opts = {}) => {
      if (type == events.FOCUS_EVENT) {
        const now = Date.now();
        getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive() && (nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval, softRevalidate());
      } else if (type == events.RECONNECT_EVENT)
        getConfig().revalidateOnReconnect && isActive() && softRevalidate();
      else {
        if (type == events.MUTATE_EVENT)
          return revalidate();
        if (type == events.ERROR_REVALIDATE_EVENT)
          return revalidate(opts);
      }
    });
    return unmountedRef.current = !1, keyRef.current = key, initialMountedRef.current = !0, setCache({
      _k: fnArg
    }), shouldDoInitialRevalidation && (isUndefined(data) || IS_SERVER ? softRevalidate() : rAF(softRevalidate)), () => {
      unmountedRef.current = !0, unsubEvents();
    };
  }, [
    key
  ]), useIsomorphicLayoutEffect(() => {
    let timer2;
    function next() {
      const interval = isFunction(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
      interval && timer2 !== -1 && (timer2 = setTimeout(execute2, interval));
    }
    function execute2() {
      !getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline()) ? revalidate(WITH_DEDUPE).then(next) : next();
    }
    return next(), () => {
      timer2 && (clearTimeout(timer2), timer2 = -1);
    };
  }, [
    refreshInterval,
    refreshWhenHidden,
    refreshWhenOffline,
    key
  ]), useDebugValue(returnedData), suspense && isUndefined(data) && key) {
    if (!IS_REACT_LEGACY && IS_SERVER)
      throw new Error("Fallback data is required when using suspense in SSR.");
    fetcherRef.current = fetcher, configRef.current = config, unmountedRef.current = !1;
    const req = PRELOAD[key];
    if (!isUndefined(req)) {
      const promise = boundMutate(req);
      use(promise);
    }
    if (isUndefined(error)) {
      const promise = revalidate(WITH_DEDUPE);
      isUndefined(returnedData) || (promise.status = "fulfilled", promise.value = !0), use(promise);
    } else
      throw error;
  }
  return {
    mutate: boundMutate,
    get data() {
      return stateDependencies.data = !0, returnedData;
    },
    get error() {
      return stateDependencies.error = !0, error;
    },
    get isValidating() {
      return stateDependencies.isValidating = !0, isValidating;
    },
    get isLoading() {
      return stateDependencies.isLoading = !0, isLoading;
    }
  };
}, useSWR = withArgs(useSWRHandler);
function hasOwnRecord(value, key) {
  return typeof value == "object" && value !== null && Object.prototype.hasOwnProperty.call(value, key);
}
function makeMediaLibraryRef(libraryId, assetId) {
  return `media-library:${libraryId}:${assetId}`;
}
function containsMediaProperty(value) {
  return !hasOwnRecord(value, "media") || !hasOwnRecord(value.media, "_ref") ? !1 : typeof value.media._ref == "string";
}
function isMediaLibraryRef(ref) {
  if (typeof ref != "string") return !1;
  const [resourceType, resourceId, documentId] = ref.split(":", 3);
  return resourceType === "media-library" && !!resourceId && !!documentId;
}
function getMediaLibraryRef(value) {
  const maybeRef = containsMediaProperty(value) ? value?.media?._ref : value;
  return isMediaLibraryRef(maybeRef) ? maybeRef : void 0;
}
const POLICY_CACHE_MAX_SIZE = 2e3, POLICY_CACHE_MAX_AGE = 1e3 * 60 * 5, loaders = /* @__PURE__ */ new Map(), policyCache = new QuickLRU({
  maxAge: POLICY_CACHE_MAX_AGE,
  maxSize: POLICY_CACHE_MAX_SIZE
});
async function fetchAccessPoliciesBatch(params) {
  const {
    assetIds,
    client,
    libraryId
  } = params;
  if (assetIds.length === 0)
    return [];
  try {
    const results = await client.fetch("*[_id in $ids]{_id, cdnAccessPolicy}", {
      ids: assetIds
    }), policyById = Object.fromEntries(results.map((doc) => [doc._id, doc.cdnAccessPolicy]));
    return assetIds.map((assetId) => {
      const policy = policyById[assetId], assetRef = makeMediaLibraryRef(libraryId, assetId);
      return policyCache.set(assetRef, policy), policy;
    });
  } catch (error) {
    return console.error("Error fetching cdnAccessPolicy batch", {
      libraryId,
      assetIds,
      error
    }), assetIds.forEach((assetId) => {
      const assetRef = makeMediaLibraryRef(libraryId, assetId);
      policyCache.set(assetRef, void 0);
    }), assetIds.map(() => {
    });
  }
}
function createMediaLibraryClient(client, libraryId) {
  const {
    apiHost: base,
    projectId: subdomain
  } = client.config();
  if (!subdomain)
    throw new Error("Cannot create Media Library client: missing projectId in client config");
  const baseUrl = new URL(base);
  baseUrl.hostname = `${subdomain}.${baseUrl.hostname}`;
  const apiHost = baseUrl.toString();
  return client.withConfig({
    apiHost,
    resource: {
      id: libraryId,
      type: "media-library"
    }
  });
}
function resolveAssetPolicyLoader(client, libraryId) {
  const existingLoader = loaders.get(libraryId);
  if (existingLoader)
    return existingLoader;
  const mediaLibraryClient = createMediaLibraryClient(client, libraryId), loader = new DataLoader((assetIds) => fetchAccessPoliciesBatch({
    assetIds,
    client: mediaLibraryClient,
    libraryId
  }), {
    cache: !1
  });
  return loaders.set(libraryId, loader), loader;
}
function enqueueAssetAccessPolicyFetch(assetRef, client) {
  const [, libraryId, assetId] = assetRef.split(":", 3);
  if (!libraryId || !assetId || !client)
    return Promise.resolve(void 0);
  if (policyCache.has(assetRef)) {
    const policy = policyCache.get(assetRef) ?? void 0;
    return Promise.resolve(policy);
  }
  return resolveAssetPolicyLoader(client, libraryId).load(assetId);
}
function useAccessPolicy(params) {
  const $ = c(5), {
    client,
    source
  } = params;
  let t0;
  $[0] !== source ? (t0 = getMediaLibraryRef(source), $[0] = source, $[1] = t0) : t0 = $[1];
  const ref = t0, canCheck = !!(ref && client.config().token), requestKey = canCheck ? ref : null;
  let t1;
  $[2] !== client ? (t1 = async (key) => enqueueAssetAccessPolicyFetch(key, client), $[2] = client, $[3] = t1) : t1 = $[3];
  const fetcher = t1;
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    dedupingInterval: 0,
    revalidateOnFocus: !1,
    revalidateOnReconnect: !1,
    shouldRetryOnError: !1
  }, $[4] = t2) : t2 = $[4];
  const options = t2, {
    data: cdnAccessPolicy,
    isLoading
  } = useSWR(requestKey, fetcher, options);
  return ref ? canCheck ? isLoading ? "checking" : cdnAccessPolicy ?? "unknown" : "unknown" : "public";
}
function getDataTestIdPrefix(schemaType) {
  const name = schemaType.name || "file", jsonType = schemaType.jsonType || "object";
  return `${name === "sanity.video" ? "video" : name.replace(/\./g, "-")}-${jsonType}-input`;
}
function AssetSourceBrowser(props2) {
  const $ = c(39), {
    assetSources,
    readOnly,
    schemaType,
    onSelectAssetSource,
    onCloseMenu
  } = props2;
  let t0;
  $[0] !== schemaType ? (t0 = getDataTestIdPrefix(schemaType), $[0] = schemaType, $[1] = t0) : t0 = $[1];
  const dataTestIdPrefix = t0, menuButtonId = useId(), {
    t
  } = useTranslation(), sourcesFromSchema = schemaType.options?.sources;
  let t1;
  $[2] !== onCloseMenu || $[3] !== onSelectAssetSource ? (t1 = (assetSource) => {
    onCloseMenu?.(), onSelectAssetSource(assetSource);
  }, $[2] = onCloseMenu, $[3] = onSelectAssetSource, $[4] = t1) : t1 = $[4];
  const handleSelect = t1;
  if (sourcesFromSchema?.length === 0 || assetSources.length === 0)
    return null;
  if (assetSources.length > 1 && !readOnly) {
    let t22;
    $[5] !== t ? (t22 = t("asset-source.browse-button.text"), $[5] = t, $[6] = t22) : t22 = $[6];
    const t32 = `${dataTestIdPrefix}-multi-browse-button`;
    let t42;
    $[7] !== t22 || $[8] !== t32 ? (t42 = /* @__PURE__ */ jsx(Button, { mode: "bleed", text: t22, "data-testid": t32, icon: SearchIcon, iconRight: ChevronDownIcon }), $[7] = t22, $[8] = t32, $[9] = t42) : t42 = $[9];
    let t52;
    if ($[10] !== menuButtonId) {
      let t62;
      $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t62 = /:/g, $[12] = t62) : t62 = $[12], t52 = menuButtonId.replace(t62, "-"), $[10] = menuButtonId, $[11] = t52;
    } else
      t52 = $[11];
    const t6 = `${dataTestIdPrefix}-select-button-${t52}`;
    let t7;
    if ($[13] !== assetSources || $[14] !== dataTestIdPrefix || $[15] !== handleSelect || $[16] !== t) {
      let t82;
      $[18] !== dataTestIdPrefix || $[19] !== handleSelect || $[20] !== t ? (t82 = (assetSource_0) => /* @__PURE__ */ jsx(MenuItem, { text: getAssetSourceDisplayName(assetSource_0, t, {
        useStartCaseForName: !0
      }), onClick: () => handleSelect(assetSource_0), icon: assetSource_0.icon || ImageIcon, "data-testid": `${dataTestIdPrefix}-browse-button-${assetSource_0.name}` }, assetSource_0.name), $[18] = dataTestIdPrefix, $[19] = handleSelect, $[20] = t, $[21] = t82) : t82 = $[21], t7 = assetSources.map(t82), $[13] = assetSources, $[14] = dataTestIdPrefix, $[15] = handleSelect, $[16] = t, $[17] = t7;
    } else
      t7 = $[17];
    let t8;
    $[22] !== t7 ? (t8 = /* @__PURE__ */ jsx(Menu, { children: t7 }), $[22] = t7, $[23] = t8) : t8 = $[23];
    let t9;
    return $[24] !== menuButtonId || $[25] !== t42 || $[26] !== t6 || $[27] !== t8 ? (t9 = /* @__PURE__ */ jsx(MenuButton, { id: menuButtonId, button: t42, "data-testid": t6, menu: t8 }), $[24] = menuButtonId, $[25] = t42, $[26] = t6, $[27] = t8, $[28] = t9) : t9 = $[28], t9;
  }
  let t2;
  $[29] !== t ? (t2 = t("asset-source.browse-button.text"), $[29] = t, $[30] = t2) : t2 = $[30];
  let t3;
  $[31] !== assetSources[0] || $[32] !== handleSelect ? (t3 = () => handleSelect(assetSources[0]), $[31] = assetSources[0], $[32] = handleSelect, $[33] = t3) : t3 = $[33];
  const t4 = `${dataTestIdPrefix}-browse-button-${assetSources[0].name}`;
  let t5;
  return $[34] !== readOnly || $[35] !== t2 || $[36] !== t3 || $[37] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { text: t2, icon: SearchIcon, mode: "bleed", onClick: t3, "data-testid": t4, disabled: readOnly }), $[34] = readOnly, $[35] = t2, $[36] = t3, $[37] = t4, $[38] = t5) : t5 = $[38], t5;
}
const FileButton = /* @__PURE__ */ styled(Button).attrs({
  forwardedAs: "label"
}).withConfig({
  displayName: "FileButton",
  componentId: "sc-1r6e6de-0"
})(({
  theme
}) => {
  const {
    focusRing
  } = theme.sanity, base = theme.sanity.color.base;
  return css`
      &:not([data-disabled='true']) {
        &:focus-within {
          box-shadow: ${focusRingStyle$1({
    base,
    border: {
      width: 1,
      color: "var(--card-border-color)"
    },
    focusRing
  })};
        }
      }

      // The underlying file input is rendered as children within a Sanity UI <Button> component.
      // The below visibly hides it by targeting the input's parent <span> element, which is
      // added by the <Button> component.
      // TODO: refactor, avoid nth-child selector usage
      & > span:nth-child(2) {
        overflow: hidden;
        overflow: clip;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        min-width: 0;
        display: block;
        appearance: none;
        padding: 0;
        margin: 0;
        border: 0;
        opacity: 0;
      }
    `;
}), FileInputButton = forwardRef(function(props2, forwardedRef) {
  const $ = c(27);
  let accept, capture, disabled, icon, idProp, multiple, onSelect, rest, text;
  $[0] !== props2 ? ({
    icon,
    id: idProp,
    accept,
    capture,
    multiple,
    onSelect,
    text,
    disabled,
    ...rest
  } = props2, $[0] = props2, $[1] = accept, $[2] = capture, $[3] = disabled, $[4] = icon, $[5] = idProp, $[6] = multiple, $[7] = onSelect, $[8] = rest, $[9] = text) : (accept = $[1], capture = $[2], disabled = $[3], icon = $[4], idProp = $[5], multiple = $[6], onSelect = $[7], rest = $[8], text = $[9]);
  const id2 = `${idProp || ""}-${useId()}`;
  let t0;
  $[10] !== onSelect ? (t0 = (event) => {
    onSelect && event.target.files && onSelect(Array.from(event.target.files));
  }, $[10] = onSelect, $[11] = t0) : t0 = $[11];
  const handleChange = t0;
  let t1;
  $[12] !== accept || $[13] !== capture || $[14] !== disabled || $[15] !== forwardedRef || $[16] !== handleChange || $[17] !== id2 || $[18] !== multiple ? (t1 = /* @__PURE__ */ jsx("input", { "data-testid": "file-button-input", accept, capture, id: id2, multiple, onChange: handleChange, ref: forwardedRef, type: "file", value: "", disabled }), $[12] = accept, $[13] = capture, $[14] = disabled, $[15] = forwardedRef, $[16] = handleChange, $[17] = id2, $[18] = multiple, $[19] = t1) : t1 = $[19];
  let t2;
  return $[20] !== disabled || $[21] !== icon || $[22] !== id2 || $[23] !== rest || $[24] !== t1 || $[25] !== text ? (t2 = /* @__PURE__ */ jsx(FileButton, { ...rest, icon, text, htmlFor: id2, disabled, children: t1 }), $[20] = disabled, $[21] = icon, $[22] = id2, $[23] = rest, $[24] = t1, $[25] = text, $[26] = t2) : t2 = $[26], t2;
}), RootFlex$3 = styled(Flex).withConfig({
  displayName: "RootFlex",
  componentId: "sc-q3h17p-0"
})`pointer-events:none;`;
function PlaceholderText(props2) {
  const $ = c(24), {
    hoveringFiles,
    type,
    readOnly,
    acceptedFiles,
    rejectedFilesCount,
    directUploads
  } = props2, isFileType = type === "file", {
    t
  } = useTranslation();
  let t0;
  bb0: {
    if (readOnly) {
      let t13;
      $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = /* @__PURE__ */ jsx(ReadOnlyIcon, {}), $[0] = t13) : t13 = $[0], t0 = t13;
      break bb0;
    }
    if (hoveringFiles && typeof rejectedFilesCount < "u" && rejectedFilesCount > 0 || directUploads === !1) {
      let t13;
      $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = /* @__PURE__ */ jsx(AccessDeniedIcon, {}), $[1] = t13) : t13 = $[1], t0 = t13;
      break bb0;
    }
    let t12;
    $[2] !== isFileType ? (t12 = isFileType ? /* @__PURE__ */ jsx(BinaryDocumentIcon, {}) : /* @__PURE__ */ jsx(ImageIcon, {}), $[2] = isFileType, $[3] = t12) : t12 = $[3], t0 = t12;
  }
  const messageIcon = t0;
  let t1;
  bb1: {
    if (directUploads === !1) {
      let t23;
      $[4] !== t ? (t23 = t("inputs.files.common.placeholder.upload-not-supported"), $[4] = t, $[5] = t23) : t23 = $[5], t1 = t23;
      break bb1;
    }
    if (readOnly) {
      let t23;
      $[6] !== t ? (t23 = t("inputs.files.common.placeholder.read-only"), $[6] = t, $[7] = t23) : t23 = $[7], t1 = t23;
      break bb1;
    }
    if (hoveringFiles && directUploads && !readOnly) {
      if (acceptedFiles && acceptedFiles.length > 0) {
        let t23;
        $[8] !== t || $[9] !== type ? (t23 = t("inputs.files.common.placeholder.drop-to-upload", {
          context: type
        }), $[8] = t, $[9] = type, $[10] = t23) : t23 = $[10], t1 = t23;
        break bb1;
      }
      if (typeof rejectedFilesCount < "u" && rejectedFilesCount > 0) {
        let t23;
        $[11] !== rejectedFilesCount || $[12] !== t ? (t23 = t("inputs.files.common.placeholder.cannot-upload-some-files", {
          count: rejectedFilesCount
        }), $[11] = rejectedFilesCount, $[12] = t, $[13] = t23) : t23 = $[13], t1 = t23;
        break bb1;
      }
    }
    let t22;
    $[14] !== t || $[15] !== type ? (t22 = t("inputs.files.common.placeholder.drag-or-paste-to-upload", {
      context: type
    }), $[14] = t, $[15] = type, $[16] = t22) : t22 = $[16], t1 = t22;
  }
  const messageText = t1;
  let t2;
  $[17] !== messageIcon ? (t2 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: messageIcon }), $[17] = messageIcon, $[18] = t2) : t2 = $[18];
  let t3;
  $[19] !== messageText ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: messageText }), $[19] = messageText, $[20] = t3) : t3 = $[20];
  let t4;
  return $[21] !== t2 || $[22] !== t3 ? (t4 = /* @__PURE__ */ jsxs(RootFlex$3, { align: "center", gap: 3, justify: "center", paddingLeft: 1, children: [
    t2,
    t3
  ] }), $[21] = t2, $[22] = t3, $[23] = t4) : t4 = $[23], t4;
}
function openFilePicker(options) {
  const {
    accept,
    capture,
    multiple,
    onSelect,
    onCancel
  } = options, input = document.createElement("input");
  input.type = "file", input.accept = accept ?? "", input.multiple = multiple ?? !1, capture && (input.capture = capture), input.style.display = "none", input.setAttribute("data-testid", "open-file-picker-input");
  let handled = !1;
  const cleanup = () => {
    input.isConnected && input.remove();
  }, handleChange = () => {
    handled = !0, window.removeEventListener("focus", handleCancel), input.files && input.files.length > 0 && onSelect(Array.from(input.files)), cleanup();
  }, handleCancel = () => {
    handled || (onCancel?.(), cleanup());
  };
  input.addEventListener("change", handleChange, {
    once: !0
  }), window.addEventListener("focus", handleCancel, {
    once: !0
  }), document.body.appendChild(input), input.click();
}
const UPLOAD_DROP_DOWN_MENU_POPOVER = {
  portal: !0
}, MENU_GROUP_POPOVER = {
  placement: "right-start",
  fallbackPlacements: ["left-start", "bottom", "top"]
}, ASSET_SOURCE_DATA_ATTRIBUTE = "data-asset-source-name";
function UploadDropDownMenuComponent(props2, forwardedRef) {
  const $ = c(40), {
    accept,
    assetSources,
    capture,
    directUploads,
    multiple,
    onSelectFiles,
    onOpenSourceForUpload,
    onCloseParentMenu,
    onFilePickerCancel,
    readOnly,
    renderAsMenuGroup: t0,
    "data-testid": dataTestId
  } = props2, renderAsMenuGroup = t0 === void 0 ? !1 : t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = uniqueId(), $[0] = t1) : t1 = $[0];
  const uniqId = t1, uploadsDisabled = readOnly || directUploads === !1;
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (assetSource) => `${uniqId}-${assetSource.name}-upload-button`, $[1] = t2) : t2 = $[1];
  const createAssetSourceInputId = t2;
  let t3;
  $[2] !== accept || $[3] !== capture || $[4] !== multiple || $[5] !== onFilePickerCancel || $[6] !== onSelectFiles ? (t3 = (assetSource_0) => {
    openFilePicker({
      accept,
      capture,
      multiple,
      onSelect: (files) => {
        onSelectFiles?.(assetSource_0, files);
      },
      onCancel: onFilePickerCancel
    });
  }, $[2] = accept, $[3] = capture, $[4] = multiple, $[5] = onFilePickerCancel, $[6] = onSelectFiles, $[7] = t3) : t3 = $[7];
  const openFilePickerForAssetSource = t3;
  let t4;
  $[8] !== assetSources || $[9] !== onCloseParentMenu || $[10] !== onOpenSourceForUpload || $[11] !== openFilePickerForAssetSource ? (t4 = (event) => {
    const assetSourceName = event.currentTarget.getAttribute(ASSET_SOURCE_DATA_ATTRIBUTE), assetSource_1 = assetSources.find((source) => source.name === assetSourceName);
    if (assetSource_1) {
      if (onCloseParentMenu?.(), isComponentModeAssetSource(assetSource_1)) {
        onOpenSourceForUpload && onOpenSourceForUpload(assetSource_1);
        return;
      }
      openFilePickerForAssetSource(assetSource_1);
    }
  }, $[8] = assetSources, $[9] = onCloseParentMenu, $[10] = onOpenSourceForUpload, $[11] = openFilePickerForAssetSource, $[12] = t4) : t4 = $[12];
  const handleMenuItemClick = t4;
  let t5;
  $[13] !== assetSources || $[14] !== handleMenuItemClick || $[15] !== t || $[16] !== uploadsDisabled ? (t5 = (assetSource_2, index) => {
    const inputId = createAssetSourceInputId(assetSource_2), isDefaultSource = assetSource_2.name === assetSources[0].name;
    return /* @__PURE__ */ jsx(MenuItem, { [ASSET_SOURCE_DATA_ATTRIBUTE]: assetSource_2.name, badgeText: isDefaultSource ? t("input.files.common.upload-placeholder.file-input-button.default-source.badge") : void 0, "data-testid": `file-input-upload-button-${index}`, disabled: uploadsDisabled, icon: assetSource_2.icon, onClick: handleMenuItemClick, text: getAssetSourceDisplayName(assetSource_2, t, {
      useStartCaseForName: !0
    }) }, `${inputId}-menu-button`);
  }, $[13] = assetSources, $[14] = handleMenuItemClick, $[15] = t, $[16] = uploadsDisabled, $[17] = t5) : t5 = $[17];
  const renderMenuItemForAssetSource = t5;
  if (assetSources && assetSources.length > 1) {
    let t6;
    if ($[18] !== assetSources || $[19] !== renderMenuItemForAssetSource) {
      let t72;
      $[21] !== renderMenuItemForAssetSource ? (t72 = (assetSource_3, index_0) => renderMenuItemForAssetSource(assetSource_3, index_0), $[21] = renderMenuItemForAssetSource, $[22] = t72) : t72 = $[22], t6 = assetSources.map(t72), $[18] = assetSources, $[19] = renderMenuItemForAssetSource, $[20] = t6;
    } else
      t6 = $[20];
    const menuItems = t6;
    if (renderAsMenuGroup) {
      let t72;
      $[23] !== t ? (t72 = t("input.files.common.upload-placeholder.file-input-button.text"), $[23] = t, $[24] = t72) : t72 = $[24];
      let t82;
      return $[25] !== dataTestId || $[26] !== menuItems || $[27] !== t72 ? (t82 = /* @__PURE__ */ jsx(MenuGroup, { "data-testid": dataTestId, icon: UploadIcon, text: t72, popover: MENU_GROUP_POPOVER, children: menuItems }), $[25] = dataTestId, $[26] = menuItems, $[27] = t72, $[28] = t82) : t82 = $[28], t82;
    }
    let t7;
    $[29] !== t ? (t7 = t("input.files.common.upload-placeholder.file-input-button.text"), $[29] = t, $[30] = t7) : t7 = $[30];
    let t8;
    $[31] !== t7 || $[32] !== uploadsDisabled ? (t8 = /* @__PURE__ */ jsx(Button, { "data-testid": "file-input-upload-button-0", icon: UploadIcon, iconRight: ChevronDownIcon, mode: "bleed", disabled: uploadsDisabled, text: t7 }), $[31] = t7, $[32] = uploadsDisabled, $[33] = t8) : t8 = $[33];
    let t9;
    $[34] !== menuItems ? (t9 = /* @__PURE__ */ jsx(Menu, { children: menuItems }), $[34] = menuItems, $[35] = t9) : t9 = $[35];
    let t10;
    return $[36] !== forwardedRef || $[37] !== t8 || $[38] !== t9 ? (t10 = /* @__PURE__ */ jsx(MenuButton, { id: `${uniqId}_upload-button`, ref: forwardedRef, button: t8, menu: t9, popover: UPLOAD_DROP_DOWN_MENU_POPOVER }), $[36] = forwardedRef, $[37] = t8, $[38] = t9, $[39] = t10) : t10 = $[39], t10;
  }
  return null;
}
const UploadDropDownMenu = memo(forwardRef(UploadDropDownMenuComponent));
function UploadPlaceholderComponent(props2) {
  const $ = c(47), {
    assetSources,
    browse,
    directUploads,
    hoveringFiles,
    onOpenSourceForUpload,
    onUpload,
    readOnly,
    schemaType,
    type
  } = props2, [rootElement, setRootElement] = useState(null), rect = useElementSize(rootElement), collapsed = rect?.border && rect.border.width < 440, {
    t
  } = useTranslation(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), source = useSource();
  let result;
  if ($[0] !== assetSources || $[1] !== client || $[2] !== source || $[3] !== type) {
    if (result = getAssetSourcesWithUpload(assetSources), result.length === 0) {
      const options = {
        client,
        title: source.title || source.name
      }, isFileType = type === "file";
      result.push(isFileType ? createDatasetFileAssetSource(options) : createDatasetImageAssetSource(options));
    }
    $[0] = assetSources, $[1] = client, $[2] = source, $[3] = type, $[4] = result;
  } else
    result = $[4];
  const assetSourcesWithUpload = result;
  let t0;
  $[5] !== onUpload ? (t0 = (assetSource, files) => {
    onUpload && onUpload(assetSource, files);
  }, $[5] = onUpload, $[6] = t0) : t0 = $[6];
  const handleSelectFiles = t0, t1 = schemaType.name === "sanity.video" ? "video/*" : "";
  let t2;
  $[7] !== schemaType || $[8] !== t1 ? (t2 = get(schemaType, "options.accept", t1), $[7] = schemaType, $[8] = t1, $[9] = t2) : t2 = $[9];
  const accept = t2;
  let t3;
  bb0: switch (assetSourcesWithUpload.length) {
    case 0: {
      t3 = null;
      break bb0;
    }
    case 1: {
      const singleSource = assetSourcesWithUpload[0];
      if (isComponentModeAssetSource(singleSource)) {
        const t43 = `file-input-upload-button-${singleSource.name}`, t52 = readOnly || directUploads === !1;
        let t62;
        $[10] !== onOpenSourceForUpload || $[11] !== singleSource ? (t62 = () => {
          onOpenSourceForUpload && onOpenSourceForUpload(singleSource);
        }, $[10] = onOpenSourceForUpload, $[11] = singleSource, $[12] = t62) : t62 = $[12];
        let t72;
        $[13] !== t ? (t72 = t("input.files.common.upload-placeholder.file-input-button.text"), $[13] = t, $[14] = t72) : t72 = $[14];
        let t82;
        $[15] !== t43 || $[16] !== t52 || $[17] !== t62 || $[18] !== t72 ? (t82 = /* @__PURE__ */ jsx(Button, { "data-testid": t43, disabled: t52, icon: UploadIcon, mode: "bleed", onClick: t62, text: t72 }), $[15] = t43, $[16] = t52, $[17] = t62, $[18] = t72, $[19] = t82) : t82 = $[19], t3 = t82;
        break bb0;
      }
      const t42 = `file-input-upload-button-${singleSource.name}`, t5 = readOnly || directUploads === !1;
      let t6;
      $[20] !== onUpload || $[21] !== singleSource ? (t6 = (files_0) => {
        onUpload && onUpload(singleSource, files_0);
      }, $[20] = onUpload, $[21] = singleSource, $[22] = t6) : t6 = $[22];
      let t7;
      $[23] !== t ? (t7 = t("input.files.common.upload-placeholder.file-input-button.text"), $[23] = t, $[24] = t7) : t7 = $[24];
      let t8;
      $[25] !== accept || $[26] !== t42 || $[27] !== t5 || $[28] !== t6 || $[29] !== t7 ? (t8 = /* @__PURE__ */ jsx(FileInputButton, { accept, "data-testid": t42, disabled: t5, icon: UploadIcon, mode: "bleed", onSelect: t6, text: t7 }), $[25] = accept, $[26] = t42, $[27] = t5, $[28] = t6, $[29] = t7, $[30] = t8) : t8 = $[30], t3 = t8;
      break bb0;
    }
    default: {
      let t42;
      $[31] !== accept || $[32] !== assetSourcesWithUpload || $[33] !== directUploads || $[34] !== handleSelectFiles || $[35] !== onOpenSourceForUpload || $[36] !== readOnly ? (t42 = /* @__PURE__ */ jsx(UploadDropDownMenu, { accept, assetSources: assetSourcesWithUpload, directUploads, onSelectFiles: handleSelectFiles, onOpenSourceForUpload, readOnly }), $[31] = accept, $[32] = assetSourcesWithUpload, $[33] = directUploads, $[34] = handleSelectFiles, $[35] = onOpenSourceForUpload, $[36] = readOnly, $[37] = t42) : t42 = $[37], t3 = t42;
    }
  }
  const uploadButton = t3;
  let t4;
  return $[38] !== assetSourcesWithUpload.length || $[39] !== browse || $[40] !== collapsed || $[41] !== directUploads || $[42] !== hoveringFiles || $[43] !== readOnly || $[44] !== type || $[45] !== uploadButton ? (t4 = assetSourcesWithUpload.length === 0 ? null : /* @__PURE__ */ jsxs(Flex, { align: collapsed ? void 0 : "center", direction: collapsed ? "column" : "row", gap: 4, justify: "space-between", paddingY: collapsed ? 1 : void 0, ref: setRootElement, children: [
    /* @__PURE__ */ jsx(Flex, { flex: 1, children: /* @__PURE__ */ jsx(PlaceholderText, { directUploads, hoveringFiles, readOnly, type }) }),
    /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, justify: "center", wrap: "wrap", children: [
      uploadButton,
      browse
    ] })
  ] }), $[38] = assetSourcesWithUpload.length, $[39] = browse, $[40] = collapsed, $[41] = directUploads, $[42] = hoveringFiles, $[43] = readOnly, $[44] = type, $[45] = uploadButton, $[46] = t4) : t4 = $[46], t4;
}
const UploadPlaceholder = memo(UploadPlaceholderComponent), STALE_UPLOAD_MS = 12e4, RatioBox$2 = styled(Card).withConfig({
  displayName: "RatioBox",
  componentId: "sc-x1lc6d-0"
})`position:relative;width:100%;min-height:3.75rem;max-height:min(calc(var(--image-height) * 1px),30vh);aspect-ratio:var(--image-width) / var(--image-height);& img{display:block;width:100%;height:100%;object-fit:scale-down;object-position:center;}`, Overlay = styled(Card).withConfig({
  displayName: "Overlay",
  componentId: "sc-x1lc6d-1"
})`display:flex;justify-content:flex-end;position:absolute;top:0;left:0;right:0;bottom:0;backdrop-filter:blur(10px);background-color:color-mix(in srgb,transparent,var(--card-bg-color) 80%);`, FlexOverlay = styled(Flex).withConfig({
  displayName: "FlexOverlay",
  componentId: "sc-x1lc6d-2"
})`position:absolute;top:0;left:0;bottom:0;right:0;`, ErrorIconWrapper = styled.div.withConfig({
  displayName: "ErrorIconWrapper",
  componentId: "sc-x1lc6d-3"
})`align-items:center;color:var(--card-icon-color);display:flex;font-size:1.5em;justify-content:center;`, CardWrapper = styled(RatioBox$2).withConfig({
  displayName: "CardWrapper",
  componentId: "sc-fnkzfj-0"
})`box-sizing:border-box;`, FlexWrapper$1 = styled(Flex).withConfig({
  displayName: "FlexWrapper",
  componentId: "sc-fnkzfj-1"
})`box-sizing:border-box;text-overflow:ellipsis;overflow:hidden;overflow:clip;`, LeftSection = styled(Stack).withConfig({
  displayName: "LeftSection",
  componentId: "sc-fnkzfj-2"
})`position:relative;width:60%;`, CodeWrapper = styled(Code).withConfig({
  displayName: "CodeWrapper",
  componentId: "sc-fnkzfj-3"
})`position:relative;width:100%;code{overflow:hidden;overflow:clip;text-overflow:ellipsis;position:relative;max-width:200px;}`, elapsedMs = (date) => (/* @__PURE__ */ new Date()).getTime() - new Date(date).getTime();
function UploadProgress(t0) {
  const $ = c(22), {
    uploadState,
    onCancel,
    onStale
  } = t0, filename = uploadState.file.name;
  let t1, t2;
  $[0] !== onStale || $[1] !== uploadState.updatedAt ? (t1 = () => {
    elapsedMs(uploadState.updatedAt) > STALE_UPLOAD_MS && onStale?.();
  }, t2 = [uploadState.updatedAt, onStale], $[0] = onStale, $[1] = uploadState.updatedAt, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  const {
    t
  } = useTranslation();
  let t3, t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = [3, 3, 2, 2], t4 = ["column", "column", "row"], $[4] = t3, $[5] = t4) : (t3 = $[4], t4 = $[5]);
  let t5;
  $[6] !== filename ? (t5 = {
    FileName: () => /* @__PURE__ */ jsx(CodeWrapper, { size: 1, children: filename || "\u2026" })
  }, $[6] = filename, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== t || $[9] !== t5 ? (t6 = /* @__PURE__ */ jsx(Flex, { justify: "center", gap: t3, direction: t4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Inline, { space: 2, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "input.files.common.upload-progress", components: t5 }) }) }) }), $[8] = t, $[9] = t5, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== uploadState.progress ? (t7 = /* @__PURE__ */ jsx(Card, { border: !0, marginTop: 3, radius: 5, children: /* @__PURE__ */ jsx(LinearProgress, { value: uploadState.progress }) }), $[11] = uploadState.progress, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== t6 || $[14] !== t7 ? (t8 = /* @__PURE__ */ jsxs(LeftSection, { children: [
    t6,
    t7
  ] }), $[13] = t6, $[14] = t7, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] !== onCancel || $[17] !== t ? (t9 = onCancel ? /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: onCancel, text: t("input.files.common.cancel-upload"), tone: "critical" }) : null, $[16] = onCancel, $[17] = t, $[18] = t9) : t9 = $[18];
  let t10;
  return $[19] !== t8 || $[20] !== t9 ? (t10 = /* @__PURE__ */ jsx(CardWrapper, { tone: "primary", border: !0, children: /* @__PURE__ */ jsxs(FlexWrapper$1, { padding: 4, align: "center", justify: "space-between", height: "fill", direction: "row", gap: 2, children: [
    t8,
    t9
  ] }) }), $[19] = t8, $[20] = t9, $[21] = t10) : t10 = $[21], t10;
}
function UploadWarning(t0) {
  const $ = c(20), {
    onClearStale
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== t ? (t2 = t("inputs.files.common.stale-upload-warning.title"), $[1] = t, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t ? (t4 = t("inputs.files.common.stale-upload-warning.description", {
    staleThresholdMinutes: Math.ceil(STALE_UPLOAD_MS / 1e3 / 60)
  }), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t4 }), $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t3 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { gap: 4, marginBottom: 4, children: [
    t1,
    /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      t3,
      t5
    ] })
  ] }), $[9] = t3, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t ? (t7 = t("inputs.files.common.stale-upload-warning.clear"), $[12] = t, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== onClearStale || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { icon: ResetIcon, mode: "ghost", onClick: onClearStale, text: t7, width: "fill" }), $[14] = onClearStale, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  return $[17] !== t6 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Card, { tone: "caution", padding: 4, border: !0, radius: 2, children: [
    t6,
    t8
  ] }), $[17] = t6, $[18] = t8, $[19] = t9) : t9 = $[19], t9;
}
function ActionsMenu(props2) {
  const $ = c(38), {
    onReset,
    readOnly,
    browse,
    downloadUrl,
    copyUrl,
    openInSource: openInSource2,
    openInSourceName,
    upload
  } = props2, {
    push: pushToast
  } = useToast(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== copyUrl || $[1] !== pushToast || $[2] !== t ? (t0 = () => {
    navigator.clipboard.writeText(copyUrl || ""), pushToast({
      closable: !0,
      status: "success",
      title: t("inputs.files.common.actions-menu.notification.url-copied")
    });
  }, $[0] = copyUrl, $[1] = pushToast, $[2] = t, $[3] = t0) : t0 = $[3];
  const handleCopyURL = t0;
  let t1;
  $[4] !== browse || $[5] !== upload ? (t1 = upload && browse && /* @__PURE__ */ jsx(MenuDivider, {}), $[4] = browse, $[5] = upload, $[6] = t1) : t1 = $[6];
  let t2;
  $[7] !== copyUrl || $[8] !== downloadUrl || $[9] !== openInSource2 ? (t2 = (downloadUrl || copyUrl || openInSource2) && /* @__PURE__ */ jsx(MenuDivider, {}), $[7] = copyUrl, $[8] = downloadUrl, $[9] = openInSource2, $[10] = t2) : t2 = $[10];
  let t3;
  $[11] !== downloadUrl || $[12] !== t ? (t3 = downloadUrl && /* @__PURE__ */ jsx(MenuItem, { as: "a", icon: DownloadIcon, text: t("inputs.files.common.actions-menu.download.label"), href: downloadUrl }), $[11] = downloadUrl, $[12] = t, $[13] = t3) : t3 = $[13];
  let t4;
  $[14] !== copyUrl || $[15] !== handleCopyURL || $[16] !== t ? (t4 = copyUrl && /* @__PURE__ */ jsx(MenuItem, { icon: CopyIcon, text: t("inputs.files.common.actions-menu.copy-url.label"), onClick: handleCopyURL }), $[14] = copyUrl, $[15] = handleCopyURL, $[16] = t, $[17] = t4) : t4 = $[17];
  let t5;
  $[18] !== openInSource2 || $[19] !== openInSourceName || $[20] !== t ? (t5 = openInSource2 && /* @__PURE__ */ jsx(MenuItem, { icon: LaunchIcon, text: t("inputs.files.common.actions-menu.open-in-source.label", {
    sourceName: openInSourceName || "source"
  }), onClick: openInSource2, "data-testid": "file-input-open-in-source" }), $[18] = openInSource2, $[19] = openInSourceName, $[20] = t, $[21] = t5) : t5 = $[21];
  let t6;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx(MenuDivider, {}), $[22] = t6) : t6 = $[22];
  let t7;
  $[23] !== t ? (t7 = t("inputs.files.common.actions-menu.clear-field.label"), $[23] = t, $[24] = t7) : t7 = $[24];
  let t8;
  $[25] !== onReset || $[26] !== readOnly || $[27] !== t7 ? (t8 = /* @__PURE__ */ jsx(MenuItem, { tone: "critical", icon: ResetIcon, text: t7, onClick: onReset, disabled: readOnly, "data-testid": "file-input-clear" }), $[25] = onReset, $[26] = readOnly, $[27] = t7, $[28] = t8) : t8 = $[28];
  let t9;
  return $[29] !== browse || $[30] !== t1 || $[31] !== t2 || $[32] !== t3 || $[33] !== t4 || $[34] !== t5 || $[35] !== t8 || $[36] !== upload ? (t9 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    upload,
    t1,
    browse,
    t2,
    t3,
    t4,
    t5,
    t6,
    t8
  ] }), $[29] = browse, $[30] = t1, $[31] = t2, $[32] = t3, $[33] = t4, $[34] = t5, $[35] = t8, $[36] = upload, $[37] = t9) : t9 = $[37], t9;
}
function findOpenInSourceResult(asset, assetSources) {
  if (!asset?.source) return null;
  for (const assetSource of assetSources) {
    if (!assetSource.openInSource) continue;
    const result = assetSource.openInSource(asset);
    if (result && typeof result == "object")
      return {
        source: assetSource,
        result
      };
  }
  return null;
}
function getOpenInSourceName(openInSourceResult, t) {
  if (openInSourceResult)
    return getAssetSourceDisplayName(openInSourceResult.source, t);
}
const FileInputMenuItem = forwardRef(function(props2, forwardedRef) {
  const $ = c(24);
  let accept, capture, disabled, icon, multiple, onFilePickerCancel, onSelect, rest, text;
  $[0] !== props2 ? ({
    icon,
    accept,
    capture,
    multiple,
    onSelect,
    onFilePickerCancel,
    text,
    disabled,
    ...rest
  } = props2, $[0] = props2, $[1] = accept, $[2] = capture, $[3] = disabled, $[4] = icon, $[5] = multiple, $[6] = onFilePickerCancel, $[7] = onSelect, $[8] = rest, $[9] = text) : (accept = $[1], capture = $[2], disabled = $[3], icon = $[4], multiple = $[5], onFilePickerCancel = $[6], onSelect = $[7], rest = $[8], text = $[9]);
  let t0;
  $[10] !== accept || $[11] !== capture || $[12] !== disabled || $[13] !== multiple || $[14] !== onFilePickerCancel || $[15] !== onSelect ? (t0 = () => {
    disabled || !onSelect || openFilePicker({
      accept,
      capture,
      multiple,
      onSelect,
      onCancel: onFilePickerCancel
    });
  }, $[10] = accept, $[11] = capture, $[12] = disabled, $[13] = multiple, $[14] = onFilePickerCancel, $[15] = onSelect, $[16] = t0) : t0 = $[16];
  const handleClick = t0;
  let t1;
  return $[17] !== disabled || $[18] !== forwardedRef || $[19] !== handleClick || $[20] !== icon || $[21] !== rest || $[22] !== text ? (t1 = /* @__PURE__ */ jsx(MenuItem, { ...rest, disabled, ref: forwardedRef, icon, text, onClick: handleClick }), $[17] = disabled, $[18] = forwardedRef, $[19] = handleClick, $[20] = icon, $[21] = rest, $[22] = text, $[23] = t1) : t1 = $[23], t1;
});
function useUploadMenuItem(options) {
  const $ = c(31), {
    accept,
    assetSourcesWithUpload,
    directUploads,
    readOnly,
    onSelectFiles,
    onOpenSourceForUpload,
    onOpenSourceForUploadSingle,
    onSelectFilesSingle,
    getSingleButtonTestId,
    dropdownMenuTestId,
    onCloseParentMenu,
    onFilePickerCancel
  } = options, {
    t
  } = useTranslation();
  let t0;
  bb0: switch (assetSourcesWithUpload.length) {
    case 0: {
      t0 = null;
      break bb0;
    }
    case 1: {
      const singleSource = assetSourcesWithUpload[0];
      let t1;
      $[0] !== getSingleButtonTestId || $[1] !== singleSource.name ? (t1 = getSingleButtonTestId?.(singleSource.name), $[0] = getSingleButtonTestId, $[1] = singleSource.name, $[2] = t1) : t1 = $[2];
      const singleButtonTestId = t1, disabled = readOnly || directUploads === !1;
      if (isComponentModeAssetSource(singleSource)) {
        const t22 = singleSource.name;
        let t32;
        $[3] !== t ? (t32 = t("inputs.files.common.actions-menu.upload.label"), $[3] = t, $[4] = t32) : t32 = $[4];
        let t42;
        $[5] !== disabled || $[6] !== onOpenSourceForUploadSingle || $[7] !== singleButtonTestId || $[8] !== singleSource.name || $[9] !== t32 ? (t42 = /* @__PURE__ */ jsx(MenuItem, { icon: UploadIcon, onClick: onOpenSourceForUploadSingle, "data-asset-source-name": t22, text: t32, "data-testid": singleButtonTestId, disabled }), $[5] = disabled, $[6] = onOpenSourceForUploadSingle, $[7] = singleButtonTestId, $[8] = singleSource.name, $[9] = t32, $[10] = t42) : t42 = $[10], t0 = t42;
        break bb0;
      }
      const t2 = singleSource.name;
      let t3;
      $[11] !== t ? (t3 = t("inputs.files.common.actions-menu.upload.label"), $[11] = t, $[12] = t3) : t3 = $[12];
      let t4;
      $[13] !== accept || $[14] !== disabled || $[15] !== onFilePickerCancel || $[16] !== onSelectFilesSingle || $[17] !== singleButtonTestId || $[18] !== singleSource.name || $[19] !== t3 ? (t4 = /* @__PURE__ */ jsx(FileInputMenuItem, { icon: UploadIcon, onSelect: onSelectFilesSingle, onFilePickerCancel, accept, "data-asset-source-name": t2, text: t3, "data-testid": singleButtonTestId, disabled }), $[13] = accept, $[14] = disabled, $[15] = onFilePickerCancel, $[16] = onSelectFilesSingle, $[17] = singleButtonTestId, $[18] = singleSource.name, $[19] = t3, $[20] = t4) : t4 = $[20], t0 = t4;
      break bb0;
    }
    default: {
      let t1;
      $[21] !== accept || $[22] !== assetSourcesWithUpload || $[23] !== directUploads || $[24] !== dropdownMenuTestId || $[25] !== onCloseParentMenu || $[26] !== onFilePickerCancel || $[27] !== onOpenSourceForUpload || $[28] !== onSelectFiles || $[29] !== readOnly ? (t1 = /* @__PURE__ */ jsx(UploadDropDownMenu, { accept, assetSources: assetSourcesWithUpload, directUploads, onSelectFiles, onOpenSourceForUpload, onCloseParentMenu, onFilePickerCancel, readOnly, "data-testid": dropdownMenuTestId, renderAsMenuGroup: !0 }), $[21] = accept, $[22] = assetSourcesWithUpload, $[23] = directUploads, $[24] = dropdownMenuTestId, $[25] = onCloseParentMenu, $[26] = onFilePickerCancel, $[27] = onOpenSourceForUpload, $[28] = onSelectFiles, $[29] = readOnly, $[30] = t1) : t1 = $[30], t0 = t1;
    }
  }
  return t0;
}
function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";
  const k = 1024, dm = decimals < 0 ? 0 : decimals, sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
function AccessPolicyBadge(props2) {
  const $ = c(13), {
    t
  } = useTranslation(), {
    hideBackground: t0
  } = props2, Wrapper2 = t0 !== void 0 && t0 ? Box : Card;
  let t1;
  $[0] !== t ? (t1 = t("inputs.files.common.access-policy.private.tooltip"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(LockIcon, {}) }), $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t ? (t3 = t("inputs.files.common.access-policy.private.label"), $[3] = t, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "center", gap: 2, children: [
    t2,
    /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", muted: !0, children: t3 })
  ] }), $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== Wrapper2 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(Wrapper2, { tone: "neutral", radius: 2, padding: 2, muted: !0, children: t4 }), $[7] = Wrapper2, $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  return $[10] !== t1 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(Tooltip, { content: t1, children: t5 }), $[10] = t1, $[11] = t5, $[12] = t6) : t6 = $[12], t6;
}
function OptionsMenuPopover(props2) {
  const $ = c(34), {
    children,
    isMenuOpen,
    onMenuOpen,
    menuButtonRef,
    ariaLabelKey,
    id: id2,
    openOnClick: t0,
    buttonMode: t1
  } = props2, openOnClick = t0 === void 0 ? "open" : t0, buttonMode = t1 === void 0 ? "bleed" : t1, [menuElement, setMenuElement] = useState(null);
  let t2;
  $[0] !== menuButtonRef ? (t2 = (el) => {
    menuButtonRef && "current" in menuButtonRef && (menuButtonRef.current = el);
  }, $[0] = menuButtonRef, $[1] = t2) : t2 = $[1];
  const setOptionsButtonRef = t2;
  let t3;
  $[2] !== isMenuOpen || $[3] !== menuButtonRef || $[4] !== onMenuOpen ? (t3 = (event) => {
    isMenuOpen && (event.key === "Escape" || event.key === "Tab") && (onMenuOpen(!1), menuButtonRef.current?.focus());
  }, $[2] = isMenuOpen, $[3] = menuButtonRef, $[4] = onMenuOpen, $[5] = t3) : t3 = $[5], useGlobalKeyDown(t3);
  let t4;
  $[6] !== onMenuOpen ? (t4 = () => onMenuOpen(!1), $[6] = onMenuOpen, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== menuButtonRef || $[9] !== menuElement ? (t5 = () => [menuElement, menuButtonRef.current].filter(Boolean), $[8] = menuButtonRef, $[9] = menuElement, $[10] = t5) : t5 = $[10], useClickOutsideEvent(t4, t5);
  let t6, t7;
  $[11] !== isMenuOpen || $[12] !== menuElement ? (t6 = () => {
    isMenuOpen && menuElement?.focus();
  }, t7 = [isMenuOpen, menuElement], $[11] = isMenuOpen, $[12] = menuElement, $[13] = t6, $[14] = t7) : (t6 = $[13], t7 = $[14]), useEffect(t6, t7);
  let t8;
  $[15] !== isMenuOpen || $[16] !== onMenuOpen || $[17] !== openOnClick ? (t8 = () => onMenuOpen(openOnClick === "toggle" ? !isMenuOpen : !0), $[15] = isMenuOpen, $[16] = onMenuOpen, $[17] = openOnClick, $[18] = t8) : t8 = $[18];
  const handleClick = t8, {
    t
  } = useTranslation();
  let t9;
  $[19] !== children ? (t9 = /* @__PURE__ */ jsx(Menu, { ref: setMenuElement, children }), $[19] = children, $[20] = t9) : t9 = $[20];
  let t10;
  $[21] !== ariaLabelKey || $[22] !== t ? (t10 = t(ariaLabelKey), $[21] = ariaLabelKey, $[22] = t, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] !== buttonMode || $[25] !== handleClick || $[26] !== setOptionsButtonRef || $[27] !== t10 ? (t11 = /* @__PURE__ */ jsx(ContextMenuButton, { "aria-label": t10, "data-testid": "options-menu-button", mode: buttonMode, onClick: handleClick, ref: setOptionsButtonRef }), $[24] = buttonMode, $[25] = handleClick, $[26] = setOptionsButtonRef, $[27] = t10, $[28] = t11) : t11 = $[28];
  let t12;
  return $[29] !== id2 || $[30] !== isMenuOpen || $[31] !== t11 || $[32] !== t9 ? (t12 = /* @__PURE__ */ jsx(Popover, { content: t9, id: id2, portal: !0, open: isMenuOpen, constrainSize: !0, animate: !1, children: t11 }), $[29] = id2, $[30] = isMenuOpen, $[31] = t11, $[32] = t9, $[33] = t12) : t12 = $[33], t12;
}
function FileActionsMenu(props2) {
  const $ = c(33), {
    accessPolicy,
    originalFilename,
    size,
    children,
    muted,
    disabled,
    onClick: onClick2,
    isMenuOpen,
    onMenuOpen,
    menuButtonRef
  } = props2, t0 = muted || disabled ? void 0 : "button";
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(BinaryDocumentIcon, {}), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== muted ? (t2 = /* @__PURE__ */ jsx(Card, { padding: 3, tone: "transparent", shadow: 1, radius: 1, children: /* @__PURE__ */ jsx(Text$1, { muted, children: t1 }) }), $[1] = muted, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== muted || $[4] !== originalFilename ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", muted, "data-testid": "file-name", weight: "medium", children: originalFilename }), $[3] = muted, $[4] = originalFilename, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== size ? (t4 = formatBytes(size), $[6] = size, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, "data-testid": "file-size", children: t4 }), $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t3 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, marginLeft: 3, children: [
    t3,
    t5
  ] }), $[10] = t3, $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== t2 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { wrap: "nowrap", align: "center", children: [
    t2,
    t6
  ] }), $[13] = t2, $[14] = t6, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== onClick2 || $[17] !== t0 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsx(Card, { as: t0, radius: 2, padding: 2, tone: "inherit", onClick: onClick2, flex: 1, children: t7 }), $[16] = onClick2, $[17] = t0, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== accessPolicy ? (t9 = accessPolicy === "private" && /* @__PURE__ */ jsx(AccessPolicyBadge, {}), $[20] = accessPolicy, $[21] = t9) : t9 = $[21];
  let t10;
  $[22] !== children || $[23] !== isMenuOpen || $[24] !== menuButtonRef || $[25] !== onMenuOpen ? (t10 = /* @__PURE__ */ jsx(OptionsMenuPopover, { ariaLabelKey: "inputs.file.actions-menu.file-options.aria-label", id: "file-actions-menu", isMenuOpen, menuButtonRef, onMenuOpen, children }), $[22] = children, $[23] = isMenuOpen, $[24] = menuButtonRef, $[25] = onMenuOpen, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== t10 || $[28] !== t9 ? (t11 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsxs(Flex, { justify: "center", gap: 2, children: [
    t9,
    t10
  ] }) }), $[27] = t10, $[28] = t9, $[29] = t11) : t11 = $[29];
  let t12;
  return $[30] !== t11 || $[31] !== t8 ? (t12 = /* @__PURE__ */ jsxs(Flex, { wrap: "nowrap", justify: "space-between", align: "center", children: [
    t8,
    t11
  ] }), $[30] = t11, $[31] = t8, $[32] = t12) : t12 = $[32], t12;
}
function FileSkeleton$1() {
  const $ = c(3);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Skeleton, { padding: 3, radius: 1, animated: !0 }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(TextSkeleton, { style: {
    width: "100%"
  }, radius: 1, animated: !0 }), $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "flex-start", padding: 2, children: [
    t0,
    /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, marginLeft: 3, children: [
      t1,
      /* @__PURE__ */ jsx(TextSkeleton, { style: {
        width: "100%"
      }, radius: 1, animated: !0 })
    ] })
  ] }), $[2] = t2) : t2 = $[2], t2;
}
function FilePreview$1(props2) {
  const $ = c(67), {
    accessPolicy,
    assetSources,
    clearField,
    directUploads,
    menuButtonRef,
    observeAsset,
    onOpenInSource,
    onOpenSourceForUpload,
    onSelectAssetSourceForBrowse,
    onSelectFiles,
    readOnly,
    schemaType,
    value
  } = props2, {
    t
  } = useTranslation(), [isMenuOpen, setIsMenuOpen] = useState(!1), asset = value?.asset, sourcesFromSchema = schemaType.options?.sources;
  let t0;
  $[0] !== schemaType ? (t0 = get(schemaType, "options.accept", ""), $[0] = schemaType, $[1] = t0) : t0 = $[1];
  const accept = t0;
  let t1;
  $[2] !== assetSources ? (t1 = getAssetSourcesWithUpload(assetSources), $[2] = assetSources, $[3] = t1) : t1 = $[3];
  const assetSourcesWithUpload = t1;
  let t2;
  $[4] !== assetSources || $[5] !== onSelectAssetSourceForBrowse ? (t2 = (event) => {
    setIsMenuOpen(!1);
    const assetSourceNameData = event.currentTarget.getAttribute("data-asset-source-name"), assetSource = assetSources.find((source) => source.name === assetSourceNameData);
    assetSource ? onSelectAssetSourceForBrowse?.(assetSource) : console.warn(`No asset source found for the selected asset source name '${assetSourceNameData}'`);
  }, $[4] = assetSources, $[5] = onSelectAssetSourceForBrowse, $[6] = t2) : t2 = $[6];
  const handleSelectFileMenuItemClicked = t2;
  let t3;
  $[7] !== onSelectFiles ? (t3 = (assetSource_0, files) => {
    setIsMenuOpen(!1), onSelectFiles(assetSource_0, files);
  }, $[7] = onSelectFiles, $[8] = t3) : t3 = $[8];
  const handleSelectFilesFromAssetSource = t3;
  let t4;
  $[9] !== assetSourcesWithUpload || $[10] !== handleSelectFilesFromAssetSource ? (t4 = (files_0) => {
    handleSelectFilesFromAssetSource(assetSourcesWithUpload[0], files_0);
  }, $[9] = assetSourcesWithUpload, $[10] = handleSelectFilesFromAssetSource, $[11] = t4) : t4 = $[11];
  const handleSelectFilesFromAssetSourceSingle = t4;
  let t5;
  $[12] !== assetSourcesWithUpload || $[13] !== onOpenSourceForUpload ? (t5 = () => {
    setIsMenuOpen(!1), onOpenSourceForUpload && onOpenSourceForUpload(assetSourcesWithUpload[0]);
  }, $[12] = assetSourcesWithUpload, $[13] = onOpenSourceForUpload, $[14] = t5) : t5 = $[14];
  const handleOpenSourceForUploadSingle = t5;
  let t6;
  $[15] !== onOpenSourceForUpload ? (t6 = (assetSource_1) => {
    setIsMenuOpen(!1), onOpenSourceForUpload?.(assetSource_1);
  }, $[15] = onOpenSourceForUpload, $[16] = t6) : t6 = $[16];
  const handleOpenSourceForUpload = t6;
  let t7;
  bb0: {
    if (sourcesFromSchema?.length === 0) {
      t7 = null;
      break bb0;
    }
    if (assetSources.length === 0) {
      t7 = null;
      break bb0;
    }
    let t82;
    $[17] !== schemaType ? (t82 = getDataTestIdPrefix(schemaType), $[17] = schemaType, $[18] = t82) : t82 = $[18];
    const dataTestIdPrefix = t82;
    if (assetSources.length === 1) {
      let t93;
      $[19] !== t ? (t93 = t("asset-source.browse-button.text"), $[19] = t, $[20] = t93) : t93 = $[20];
      const t102 = `${dataTestIdPrefix}-browse-button-${assetSources[0].name}`;
      let t112;
      $[21] !== assetSources[0].name || $[22] !== handleSelectFileMenuItemClicked || $[23] !== readOnly || $[24] !== t102 || $[25] !== t93 ? (t112 = /* @__PURE__ */ jsx(MenuItem, { icon: SearchIcon, text: t93, onClick: handleSelectFileMenuItemClicked, disabled: readOnly, "data-testid": t102, "data-asset-source-name": assetSources[0].name }), $[21] = assetSources[0].name, $[22] = handleSelectFileMenuItemClicked, $[23] = readOnly, $[24] = t102, $[25] = t93, $[26] = t112) : t112 = $[26], t7 = t112;
      break bb0;
    }
    let t92;
    if ($[27] !== assetSources || $[28] !== dataTestIdPrefix || $[29] !== handleSelectFileMenuItemClicked || $[30] !== readOnly || $[31] !== t) {
      let t102;
      $[33] !== dataTestIdPrefix || $[34] !== handleSelectFileMenuItemClicked || $[35] !== readOnly || $[36] !== t ? (t102 = (assetSource_2) => /* @__PURE__ */ jsx(MenuItem, { text: getAssetSourceDisplayName(assetSource_2, t, {
        useStartCaseForName: !0
      }), onClick: handleSelectFileMenuItemClicked, icon: assetSource_2.icon || ImageIcon, disabled: readOnly, "data-testid": `${dataTestIdPrefix}-browse-button-${assetSource_2.name}`, "data-asset-source-name": assetSource_2.name }, assetSource_2.name), $[33] = dataTestIdPrefix, $[34] = handleSelectFileMenuItemClicked, $[35] = readOnly, $[36] = t, $[37] = t102) : t102 = $[37], t92 = assetSources.map(t102), $[27] = assetSources, $[28] = dataTestIdPrefix, $[29] = handleSelectFileMenuItemClicked, $[30] = readOnly, $[31] = t, $[32] = t92;
    } else
      t92 = $[32];
    t7 = t92;
  }
  const browseMenuItem = t7;
  let t8;
  $[38] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = () => setIsMenuOpen(!1), $[38] = t8) : t8 = $[38];
  let t9;
  $[39] !== menuButtonRef ? (t9 = () => menuButtonRef.current?.focus(), $[39] = menuButtonRef, $[40] = t9) : t9 = $[40];
  let t10;
  $[41] !== accept || $[42] !== assetSourcesWithUpload || $[43] !== directUploads || $[44] !== handleOpenSourceForUpload || $[45] !== handleOpenSourceForUploadSingle || $[46] !== handleSelectFilesFromAssetSource || $[47] !== handleSelectFilesFromAssetSourceSingle || $[48] !== readOnly || $[49] !== t9 ? (t10 = {
    accept,
    assetSourcesWithUpload,
    directUploads,
    readOnly,
    onSelectFiles: handleSelectFilesFromAssetSource,
    onOpenSourceForUpload: handleOpenSourceForUpload,
    onOpenSourceForUploadSingle: handleOpenSourceForUploadSingle,
    onSelectFilesSingle: handleSelectFilesFromAssetSourceSingle,
    getSingleButtonTestId: _temp$2y,
    dropdownMenuTestId: "file-input-upload-drop-down-menu-button",
    onCloseParentMenu: t8,
    onFilePickerCancel: t9
  }, $[41] = accept, $[42] = assetSourcesWithUpload, $[43] = directUploads, $[44] = handleOpenSourceForUpload, $[45] = handleOpenSourceForUploadSingle, $[46] = handleSelectFilesFromAssetSource, $[47] = handleSelectFilesFromAssetSourceSingle, $[48] = readOnly, $[49] = t9, $[50] = t10) : t10 = $[50];
  const uploadMenuItem = useUploadMenuItem(t10);
  if (!asset)
    return null;
  let t11;
  $[51] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = /* @__PURE__ */ jsx(FileSkeleton$1, {}), $[51] = t11) : t11 = $[51];
  let t12;
  $[52] !== accessPolicy || $[53] !== assetSources || $[54] !== browseMenuItem || $[55] !== clearField || $[56] !== isMenuOpen || $[57] !== menuButtonRef || $[58] !== onOpenInSource || $[59] !== readOnly || $[60] !== uploadMenuItem || $[61] !== value ? (t12 = (fileAsset) => /* @__PURE__ */ jsx(FilePreviewContent, { accessPolicy, assetSources, browseMenuItem, clearField, fileAsset, isMenuOpen, onOpenInSource, readOnly, setIsMenuOpen, menuButtonRef, uploadMenuItem, value }), $[52] = accessPolicy, $[53] = assetSources, $[54] = browseMenuItem, $[55] = clearField, $[56] = isMenuOpen, $[57] = menuButtonRef, $[58] = onOpenInSource, $[59] = readOnly, $[60] = uploadMenuItem, $[61] = value, $[62] = t12) : t12 = $[62];
  let t13;
  return $[63] !== asset || $[64] !== observeAsset || $[65] !== t12 ? (t13 = /* @__PURE__ */ jsx(WithReferencedAsset, { reference: asset, observeAsset, waitPlaceholder: t11, children: t12 }), $[63] = asset, $[64] = observeAsset, $[65] = t12, $[66] = t13) : t13 = $[66], t13;
}
function _temp$2y(sourceName2) {
  return `file-input-upload-button-${sourceName2}`;
}
function FilePreviewContent(t0) {
  const $ = c(29), {
    accessPolicy,
    assetSources,
    browseMenuItem,
    clearField,
    fileAsset,
    isMenuOpen,
    menuButtonRef,
    onOpenInSource,
    readOnly,
    setIsMenuOpen,
    uploadMenuItem,
    value
  } = t0, {
    t
  } = useTranslation(), {
    originalFilename,
    extension,
    url,
    size
  } = fileAsset, filename = originalFilename || `download.${extension}`;
  let copyUrl, downloadUrl;
  isFileSource(value) && accessPolicy !== "private" && (downloadUrl = `${url}?dl`, copyUrl = url);
  let t1;
  $[0] !== assetSources || $[1] !== fileAsset ? (t1 = findOpenInSourceResult(fileAsset, assetSources), $[0] = assetSources, $[1] = fileAsset, $[2] = t1) : t1 = $[2];
  const openInSourceResult = t1;
  let t2;
  $[3] !== fileAsset || $[4] !== onOpenInSource || $[5] !== openInSourceResult || $[6] !== setIsMenuOpen ? (t2 = () => {
    if (!openInSourceResult)
      return;
    setIsMenuOpen(!1);
    const {
      source,
      result
    } = openInSourceResult;
    result.type === "url" ? window.open(result.url, result.target || "_blank") : result.type === "component" && onOpenInSource?.(source, fileAsset);
  }, $[3] = fileAsset, $[4] = onOpenInSource, $[5] = openInSourceResult, $[6] = setIsMenuOpen, $[7] = t2) : t2 = $[7];
  const handleOpenInSource = t2, t3 = !readOnly, t4 = downloadUrl, t5 = copyUrl, t6 = openInSourceResult ? handleOpenInSource : void 0;
  let t7;
  $[8] !== openInSourceResult || $[9] !== t ? (t7 = getOpenInSourceName(openInSourceResult, t), $[8] = openInSourceResult, $[9] = t, $[10] = t7) : t7 = $[10];
  let t8;
  $[11] !== browseMenuItem || $[12] !== clearField || $[13] !== copyUrl || $[14] !== downloadUrl || $[15] !== readOnly || $[16] !== t6 || $[17] !== t7 || $[18] !== uploadMenuItem ? (t8 = /* @__PURE__ */ jsx(ActionsMenu, { browse: browseMenuItem, upload: uploadMenuItem, onReset: clearField, downloadUrl: t4, copyUrl: t5, openInSource: t6, openInSourceName: t7, readOnly }), $[11] = browseMenuItem, $[12] = clearField, $[13] = copyUrl, $[14] = downloadUrl, $[15] = readOnly, $[16] = t6, $[17] = t7, $[18] = uploadMenuItem, $[19] = t8) : t8 = $[19];
  let t9;
  return $[20] !== accessPolicy || $[21] !== filename || $[22] !== isMenuOpen || $[23] !== menuButtonRef || $[24] !== setIsMenuOpen || $[25] !== size || $[26] !== t3 || $[27] !== t8 ? (t9 = /* @__PURE__ */ jsx(FileActionsMenu, { accessPolicy, size, originalFilename: filename, muted: t3, onMenuOpen: setIsMenuOpen, isMenuOpen, menuButtonRef, children: t8 }), $[20] = accessPolicy, $[21] = filename, $[22] = isMenuOpen, $[23] = menuButtonRef, $[24] = setIsMenuOpen, $[25] = size, $[26] = t3, $[27] = t8, $[28] = t9) : t9 = $[28], t9;
}
function InvalidFileWarning(t0) {
  const $ = c(20), {
    onClearValue
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== t ? (t2 = t("inputs.file.invalid-file-warning.title"), $[1] = t, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t ? (t4 = t("inputs.file.invalid-file-warning.description"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t4 }), $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t3 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { gap: 4, marginBottom: 4, children: [
    t1,
    /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      t3,
      t5
    ] })
  ] }), $[9] = t3, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t ? (t7 = t("inputs.file.invalid-file-warning.reset-button.text"), $[12] = t, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== onClearValue || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { icon: ResetIcon, mode: "ghost", onClick: onClearValue, text: t7, width: "fill" }), $[14] = onClearValue, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  return $[17] !== t6 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Card, { tone: "caution", padding: 4, border: !0, radius: 2, children: [
    t6,
    t8
  ] }), $[17] = t6, $[18] = t8, $[19] = t9) : t9 = $[19], t9;
}
const ASSET_FIELD_PATH$2 = ["asset"];
function FileAsset(props2) {
  const $ = c(38), {
    assetSources,
    changed,
    clearField,
    directUploads,
    elementProps,
    isStale,
    isUploading,
    onCancelUpload,
    onClearUploadStatus,
    onOpenSourceForUpload,
    onSelectAssets,
    onSelectFiles,
    onStale,
    path,
    readOnly,
    schemaType,
    value
  } = props2, disableNew = schemaType.options?.disableNew === !0;
  let t0;
  $[0] !== path ? (t0 = path.concat(ASSET_FIELD_PATH$2), $[0] = path, $[1] = t0) : t0 = $[1];
  const assetFieldPath = t0;
  let t1;
  $[2] !== elementProps ? (t1 = (event) => {
    event.currentTarget === event.target && event.currentTarget === elementProps.ref?.current && elementProps.onFocus(event);
  }, $[2] = elementProps, $[3] = t1) : t1 = $[3];
  const handleFileTargetFocus = t1;
  let t2;
  $[4] !== directUploads || $[5] !== onSelectFiles || $[6] !== readOnly ? (t2 = (assetSource, files) => {
    directUploads && !readOnly && onSelectFiles(assetSource, files);
  }, $[4] = directUploads, $[5] = onSelectFiles, $[6] = readOnly, $[7] = t2) : t2 = $[7];
  const handleSelectFiles = t2, hasValueOrUpload = !!(value?._upload || value?.asset);
  if (value && typeof value.asset < "u" && !value?._upload && !isFileSource(value)) {
    let t32;
    return $[8] !== clearField ? (t32 = /* @__PURE__ */ jsx(InvalidFileWarning, { onClearValue: clearField }), $[8] = clearField, $[9] = t32) : t32 = $[9], t32;
  }
  let t3;
  $[10] !== isStale || $[11] !== onClearUploadStatus ? (t3 = isStale && /* @__PURE__ */ jsx(Box, { marginBottom: 2, children: /* @__PURE__ */ jsx(UploadWarning, { onClearStale: onClearUploadStatus }) }), $[10] = isStale, $[11] = onClearUploadStatus, $[12] = t3) : t3 = $[12];
  const t4 = !!props2.focused;
  let t5;
  $[13] !== assetSources || $[14] !== disableNew || $[15] !== elementProps || $[16] !== handleFileTargetFocus || $[17] !== handleSelectFiles || $[18] !== hasValueOrUpload || $[19] !== isUploading || $[20] !== onCancelUpload || $[21] !== onOpenSourceForUpload || $[22] !== onSelectAssets || $[23] !== onStale || $[24] !== props2 || $[25] !== readOnly || $[26] !== schemaType || $[27] !== value ? (t5 = value?._upload ? /* @__PURE__ */ jsx(UploadProgress, { uploadState: value._upload, onCancel: isUploading && onCancelUpload ? onCancelUpload : void 0, onStale }) : /* @__PURE__ */ jsx(UploadTargetCard$1, { ...elementProps, $border: hasValueOrUpload, assetSources, isReadOnly: readOnly, onFocus: handleFileTargetFocus, onOpenSourceForUpload, onSelectFile: (t62) => {
    const {
      assetSource: assetSource_0,
      file
    } = t62;
    return handleSelectFiles(assetSource_0, [file]);
  }, radius: 2, sizing: "border", style: {
    padding: 1
  }, tabIndex: 0, types: [schemaType], children: /* @__PURE__ */ jsxs("div", { style: {
    position: "relative"
  }, children: [
    !value?.asset && /* @__PURE__ */ jsx(FileUploadPlaceHolder$1, { ...props2, disableNew, onSelectFiles: handleSelectFiles }),
    !value?._upload && value?.asset && /* @__PURE__ */ jsx(FilePreview$1, { ...props2, onSelectAssets })
  ] }) }), $[13] = assetSources, $[14] = disableNew, $[15] = elementProps, $[16] = handleFileTargetFocus, $[17] = handleSelectFiles, $[18] = hasValueOrUpload, $[19] = isUploading, $[20] = onCancelUpload, $[21] = onOpenSourceForUpload, $[22] = onSelectAssets, $[23] = onStale, $[24] = props2, $[25] = readOnly, $[26] = schemaType, $[27] = value, $[28] = t5) : t5 = $[28];
  let t6;
  $[29] !== assetFieldPath || $[30] !== changed || $[31] !== t4 || $[32] !== t5 ? (t6 = /* @__PURE__ */ jsx(ChangeIndicator, { path: assetFieldPath, hasFocus: t4, isChanged: changed, children: t5 }), $[29] = assetFieldPath, $[30] = changed, $[31] = t4, $[32] = t5, $[33] = t6) : t6 = $[33];
  let t7;
  return $[34] !== elementProps.style || $[35] !== t3 || $[36] !== t6 ? (t7 = /* @__PURE__ */ jsxs("div", { style: elementProps.style, children: [
    t3,
    t6
  ] }), $[34] = elementProps.style, $[35] = t3, $[36] = t6, $[37] = t7) : t7 = $[37], t7;
}
function FileUploadPlaceHolder$1(props2) {
  const $ = c(20), {
    assetSources,
    directUploads,
    disableNew,
    onOpenSourceForUpload,
    onSelectFiles,
    schemaType,
    readOnly,
    setIsBrowseMenuOpen,
    onSelectAssetSourceForBrowse
  } = props2;
  let t0;
  $[0] !== onSelectAssetSourceForBrowse || $[1] !== setIsBrowseMenuOpen ? (t0 = (assetSource) => {
    setIsBrowseMenuOpen(!1), onSelectAssetSourceForBrowse?.(assetSource);
  }, $[0] = onSelectAssetSourceForBrowse, $[1] = setIsBrowseMenuOpen, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] !== assetSources || $[4] !== readOnly || $[5] !== schemaType || $[6] !== t0 ? (t1 = /* @__PURE__ */ jsx(AssetSourceBrowser, { assetSources, readOnly, schemaType, onSelectAssetSource: t0 }), $[3] = assetSources, $[4] = readOnly, $[5] = schemaType, $[6] = t0, $[7] = t1) : t1 = $[7];
  const browseElement = t1, t2 = readOnly ? "transparent" : "inherit";
  let t3;
  $[8] !== assetSources || $[9] !== browseElement || $[10] !== directUploads || $[11] !== disableNew || $[12] !== onOpenSourceForUpload || $[13] !== onSelectFiles || $[14] !== readOnly || $[15] !== schemaType ? (t3 = disableNew ? browseElement : /* @__PURE__ */ jsx(UploadPlaceholder, { assetSources, browse: browseElement, directUploads, onUpload: onSelectFiles, onOpenSourceForUpload, schemaType, readOnly, type: "file" }), $[8] = assetSources, $[9] = browseElement, $[10] = directUploads, $[11] = disableNew, $[12] = onOpenSourceForUpload, $[13] = onSelectFiles, $[14] = readOnly, $[15] = schemaType, $[16] = t3) : t3 = $[16];
  let t4;
  return $[17] !== t2 || $[18] !== t3 ? (t4 = /* @__PURE__ */ jsx(Card, { tone: t2, border: !0, paddingX: 3, paddingY: 2, radius: 2, children: t3 }), $[17] = t2, $[18] = t3, $[19] = t4) : t4 = $[19], t4;
}
function passThrough$2({
  children
}) {
  return children;
}
function BaseFileInput(props2) {
  const $ = c(81), {
    client,
    members,
    onChange,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    value
  } = props2, {
    t
  } = useTranslation(), renderedMembers = useRenderMembers(schemaType, members);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const [hoveringFiles, setHoveringFiles] = useState(t0), [isBrowseMenuOpen, setIsBrowseMenuOpen] = useState(!1), {
    handleOpenDialog: handleAssetLimitUpsellDialog
  } = useAssetLimitsUpsellContext();
  let t1;
  $[1] !== handleAssetLimitUpsellDialog ? (t1 = () => handleAssetLimitUpsellDialog("field_action"), $[1] = handleAssetLimitUpsellDialog, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== client || $[4] !== onChange || $[5] !== schemaType || $[6] !== t1 ? (t2 = {
    client,
    onChange,
    schemaType,
    onAssetLimitError: t1
  }, $[3] = client, $[4] = onChange, $[5] = schemaType, $[6] = t1, $[7] = t2) : t2 = $[7];
  const {
    action: assetSourceAction,
    selectedAssetSource,
    openInSourceAsset,
    setSelectedAssetSource,
    openForBrowse: handleSelectAssetSourceForBrowse,
    openForUpload: handleOpenSourceForUpload,
    openInSource: handleOpenInSource,
    changeAction: handleAssetSourceChangeAction,
    clearUploadStatus,
    close: handleAssetSourceClosed,
    menuButtonRef,
    resetOnComplete: handleAssetSourceResetOnComplete,
    uploadWith: uploadExternalFileToDataset,
    isUploading,
    setIsUploading,
    isStale,
    setIsStale,
    onStale: handleStaleUpload,
    assetSourceUploader,
    handleSelectFilesToUpload
  } = useAssetSource(t2);
  let t3;
  $[8] !== clearUploadStatus || $[9] !== setIsStale || $[10] !== value?._upload ? (t3 = () => {
    value?._upload && (clearUploadStatus(), setIsStale(!1));
  }, $[8] = clearUploadStatus, $[9] = setIsStale, $[10] = value?._upload, $[11] = t3) : t3 = $[11];
  const handleClearUploadStatus = t3;
  let t4;
  $[12] !== onChange ? (t4 = () => {
    onChange([unset(["asset"]), unset(["media"])]);
  }, $[12] = onChange, $[13] = t4) : t4 = $[13];
  const handleClearField = t4;
  let t5;
  $[14] !== handleAssetSourceResetOnComplete || $[15] !== onChange || $[16] !== schemaType || $[17] !== uploadExternalFileToDataset ? (t5 = (assetsFromSource) => {
    assetsFromSource.length !== 0 && (handleSelectAssetFromSource({
      assetsFromSource,
      onChange,
      type: schemaType,
      resolveUploader,
      uploadWith: uploadExternalFileToDataset
    }), handleAssetSourceResetOnComplete());
  }, $[14] = handleAssetSourceResetOnComplete, $[15] = onChange, $[16] = schemaType, $[17] = uploadExternalFileToDataset, $[18] = t5) : t5 = $[18];
  const handleSelectAssets = t5;
  let t6;
  $[19] !== client || $[20] !== value ? (t6 = {
    client,
    source: value
  }, $[19] = client, $[20] = value, $[21] = t6) : t6 = $[21];
  const accessPolicy = useAccessPolicy(t6);
  let t7;
  $[22] !== assetSourceUploader?.uploader ? (t7 = () => {
    assetSourceUploader?.uploader?.abort();
  }, $[22] = assetSourceUploader?.uploader, $[23] = t7) : t7 = $[23];
  const handleCancelUpload = t7;
  let t8;
  $[24] !== accessPolicy || $[25] !== handleCancelUpload || $[26] !== handleClearField || $[27] !== handleClearUploadStatus || $[28] !== handleOpenInSource || $[29] !== handleOpenSourceForUpload || $[30] !== handleSelectAssetSourceForBrowse || $[31] !== handleSelectAssets || $[32] !== handleSelectFilesToUpload || $[33] !== handleStaleUpload || $[34] !== hoveringFiles || $[35] !== isBrowseMenuOpen || $[36] !== isStale || $[37] !== isUploading || $[38] !== menuButtonRef || $[39] !== props2 || $[40] !== selectedAssetSource || $[41] !== setIsUploading || $[42] !== setSelectedAssetSource ? (t8 = () => /* @__PURE__ */ jsx(FileAsset, { ...props2, accessPolicy, menuButtonRef, clearField: handleClearField, hoveringFiles, isBrowseMenuOpen, isStale, isUploading, onCancelUpload: handleCancelUpload, onClearUploadStatus: handleClearUploadStatus, onOpenInSource: handleOpenInSource, onOpenSourceForUpload: handleOpenSourceForUpload, onSelectAssetSourceForBrowse: handleSelectAssetSourceForBrowse, onSelectAssets: handleSelectAssets, onSelectFiles: handleSelectFilesToUpload, onStale: handleStaleUpload, selectedAssetSource, setHoveringFiles, setIsBrowseMenuOpen, setIsUploading, setSelectedAssetSource }), $[24] = accessPolicy, $[25] = handleCancelUpload, $[26] = handleClearField, $[27] = handleClearUploadStatus, $[28] = handleOpenInSource, $[29] = handleOpenSourceForUpload, $[30] = handleSelectAssetSourceForBrowse, $[31] = handleSelectAssets, $[32] = handleSelectFilesToUpload, $[33] = handleStaleUpload, $[34] = hoveringFiles, $[35] = isBrowseMenuOpen, $[36] = isStale, $[37] = isUploading, $[38] = menuButtonRef, $[39] = props2, $[40] = selectedAssetSource, $[41] = setIsUploading, $[42] = setSelectedAssetSource, $[43] = t8) : t8 = $[43];
  const renderAsset = t8;
  let t9;
  if ($[44] !== renderAnnotation || $[45] !== renderAsset || $[46] !== renderBlock2 || $[47] !== renderField || $[48] !== renderInlineBlock || $[49] !== renderInput || $[50] !== renderItem2 || $[51] !== renderPreview || $[52] !== renderedMembers || $[53] !== schemaType || $[54] !== t) {
    let t102;
    $[56] !== renderAnnotation || $[57] !== renderAsset || $[58] !== renderBlock2 || $[59] !== renderField || $[60] !== renderInlineBlock || $[61] !== renderInput || $[62] !== renderItem2 || $[63] !== renderPreview || $[64] !== schemaType || $[65] !== t ? (t102 = (member) => member.kind === "field" ? /* @__PURE__ */ jsx(MemberField, { member, renderAnnotation, renderBlock: renderBlock2, renderField: member.name === "asset" ? passThrough$2 : renderField, renderInlineBlock, renderInput: member.name === "asset" ? renderAsset : renderInput, renderItem: renderItem2, renderPreview }, member.key) : member.kind === "fieldSet" ? /* @__PURE__ */ jsx(MemberFieldSet, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview, schemaType }, member.key) : member.kind === "error" ? /* @__PURE__ */ jsx(MemberFieldError, { member }, member.key) : member.kind === "decoration" ? /* @__PURE__ */ jsx(MemberDecoration, { member }, member.key) : /* @__PURE__ */ jsx(Fragment, { children: t("inputs.file.error.unknown-member-kind", {
      kind: member.kind
    }) }, member.key), $[56] = renderAnnotation, $[57] = renderAsset, $[58] = renderBlock2, $[59] = renderField, $[60] = renderInlineBlock, $[61] = renderInput, $[62] = renderItem2, $[63] = renderPreview, $[64] = schemaType, $[65] = t, $[66] = t102) : t102 = $[66], t9 = renderedMembers.map(t102), $[44] = renderAnnotation, $[45] = renderAsset, $[46] = renderBlock2, $[47] = renderField, $[48] = renderInlineBlock, $[49] = renderInput, $[50] = renderItem2, $[51] = renderPreview, $[52] = renderedMembers, $[53] = schemaType, $[54] = t, $[55] = t9;
  } else
    t9 = $[55];
  let t10;
  $[67] !== assetSourceAction || $[68] !== assetSourceUploader?.uploader || $[69] !== handleAssetSourceChangeAction || $[70] !== handleAssetSourceClosed || $[71] !== handleSelectAssets || $[72] !== openInSourceAsset || $[73] !== props2.observeAsset || $[74] !== props2.schemaType || $[75] !== props2.value || $[76] !== selectedAssetSource ? (t10 = selectedAssetSource && assetSourceAction && /* @__PURE__ */ jsx(AssetSourceDialog, { action: assetSourceAction, assetType: "file", observeAsset: props2.observeAsset, onClose: handleAssetSourceClosed, onChangeAction: handleAssetSourceChangeAction, onSelect: handleSelectAssets, openInSourceAsset, schemaType: props2.schemaType, selectedAssetSource, uploader: assetSourceUploader?.uploader, value: props2.value, waitPlaceholder: /* @__PURE__ */ jsx(FileSkeleton$1, {}) }), $[67] = assetSourceAction, $[68] = assetSourceUploader?.uploader, $[69] = handleAssetSourceChangeAction, $[70] = handleAssetSourceClosed, $[71] = handleSelectAssets, $[72] = openInSourceAsset, $[73] = props2.observeAsset, $[74] = props2.schemaType, $[75] = props2.value, $[76] = selectedAssetSource, $[77] = t10) : t10 = $[77];
  let t11;
  return $[78] !== t10 || $[79] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t9,
    t10
  ] }), $[78] = t10, $[79] = t9, $[80] = t11) : t11 = $[80], t11;
}
function StudioFileInput(props2) {
  const $ = c(11), sourcesFromSchema = props2.schemaType.options?.sources, documentPreviewStore = useDocumentPreviewStore(), {
    file: fileConfig
  } = useFormBuilder().__internal, client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0;
  $[0] !== fileConfig.directUploads ? (t0 = (type, file) => fileConfig.directUploads ? resolveUploader(type, file) : null, $[0] = fileConfig.directUploads, $[1] = t0) : t0 = $[1];
  const resolveUploader$1 = t0, assetSources = sourcesFromSchema || fileConfig.assetSources;
  let t1;
  $[2] !== documentPreviewStore ? (t1 = (id2) => observeFileAsset(documentPreviewStore, id2), $[2] = documentPreviewStore, $[3] = t1) : t1 = $[3];
  const observeAsset = t1;
  let t2;
  return $[4] !== assetSources || $[5] !== client || $[6] !== fileConfig.directUploads || $[7] !== observeAsset || $[8] !== props2 || $[9] !== resolveUploader$1 ? (t2 = /* @__PURE__ */ jsx(BaseFileInput, { ...props2, client, assetSources, directUploads: fileConfig.directUploads, observeAsset, resolveUploader: resolveUploader$1 }), $[4] = assetSources, $[5] = client, $[6] = fileConfig.directUploads, $[7] = observeAsset, $[8] = props2, $[9] = resolveUploader$1, $[10] = t2) : t2 = $[10], t2;
}
const Wrapper = styled(Inline).withConfig({
  displayName: "Wrapper",
  componentId: "sc-x1j8sn-0"
})`position:absolute;top:0;left:0;`;
function ImageAccessPolicy(props2) {
  const $ = c(1), {
    accessPolicy
  } = props2;
  if (accessPolicy === "private") {
    let t0;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Wrapper, { padding: 2, children: /* @__PURE__ */ jsx(AccessPolicyBadge, {}) }), $[0] = t0) : t0 = $[0], t0;
  }
  return null;
}
const ASSET_FIELD_PATH$1 = ["asset"];
function ImageInputAssetComponent(props2) {
  const $ = c(39), {
    assetSources,
    elementProps,
    handleClearUploadState,
    onOpenSourceForUpload,
    onSelectFile,
    inputProps,
    isStale,
    readOnly,
    renderAssetAccessPolicy,
    renderAssetMenu,
    renderPreview,
    renderUploadPlaceholder,
    renderUploadState,
    schemaType,
    value
  } = props2, hasValueOrUpload = !!(value?._upload || value?.asset);
  let t0;
  $[0] !== inputProps.path ? (t0 = inputProps.path.concat(ASSET_FIELD_PATH$1), $[0] = inputProps.path, $[1] = t0) : t0 = $[1];
  const path = t0;
  let t1;
  $[2] !== value ? (t1 = value?.asset ? getImageDimensions(value.asset) : {}, $[2] = value, $[3] = t1) : t1 = $[3];
  const {
    width: t2,
    height: t3
  } = t1, width = t2 === void 0 ? 0 : t2, height = t3 === void 0 ? 0 : t3;
  let t4;
  $[4] !== height || $[5] !== width ? (t4 = {
    "--image-width": width,
    "--image-height": height
  }, $[4] = height, $[5] = width, $[6] = t4) : t4 = $[6];
  const customProperties = t4;
  let t5;
  $[7] !== onSelectFile ? (t5 = (t62) => {
    const {
      assetSource,
      file
    } = t62;
    onSelectFile(assetSource, file);
  }, $[7] = onSelectFile, $[8] = t5) : t5 = $[8];
  const handleSelectFile = t5;
  let t6;
  $[9] !== elementProps.ref?.current || $[10] !== inputProps.elementProps ? (t6 = (event) => {
    event.currentTarget === event.target && event.currentTarget === elementProps.ref?.current && inputProps.elementProps.onFocus(event);
  }, $[9] = elementProps.ref?.current, $[10] = inputProps.elementProps, $[11] = t6) : t6 = $[11];
  const handleFileTargetFocus = t6;
  let t7;
  $[12] !== handleClearUploadState || $[13] !== isStale ? (t7 = isStale && /* @__PURE__ */ jsx(Box, { marginBottom: 2, children: /* @__PURE__ */ jsx(UploadWarning, { onClearStale: handleClearUploadState }) }), $[12] = handleClearUploadState, $[13] = isStale, $[14] = t7) : t7 = $[14];
  const t8 = !!inputProps.focused;
  let t9;
  $[15] !== assetSources || $[16] !== elementProps || $[17] !== handleFileTargetFocus || $[18] !== handleSelectFile || $[19] !== hasValueOrUpload || $[20] !== onOpenSourceForUpload || $[21] !== readOnly || $[22] !== renderAssetAccessPolicy || $[23] !== renderAssetMenu || $[24] !== renderPreview || $[25] !== renderUploadPlaceholder || $[26] !== renderUploadState || $[27] !== schemaType || $[28] !== value ? (t9 = value?._upload ? renderUploadState(value._upload) : /* @__PURE__ */ jsxs(UploadTargetCard$1, { ...elementProps, $border: hasValueOrUpload, assetSources, isReadOnly: readOnly, onFocus: handleFileTargetFocus, onOpenSourceForUpload, onSelectFile: handleSelectFile, radius: 2, sizing: "border", tabIndex: 0, types: [schemaType], children: [
    !value?.asset && renderUploadPlaceholder(),
    !value?._upload && value?.asset && /* @__PURE__ */ jsxs("div", { style: {
      position: "relative"
    }, children: [
      renderPreview(),
      renderAssetAccessPolicy?.(),
      renderAssetMenu()
    ] })
  ] }), $[15] = assetSources, $[16] = elementProps, $[17] = handleFileTargetFocus, $[18] = handleSelectFile, $[19] = hasValueOrUpload, $[20] = onOpenSourceForUpload, $[21] = readOnly, $[22] = renderAssetAccessPolicy, $[23] = renderAssetMenu, $[24] = renderPreview, $[25] = renderUploadPlaceholder, $[26] = renderUploadState, $[27] = schemaType, $[28] = value, $[29] = t9) : t9 = $[29];
  let t10;
  $[30] !== inputProps.changed || $[31] !== path || $[32] !== t8 || $[33] !== t9 ? (t10 = /* @__PURE__ */ jsx(ChangeIndicator, { path, hasFocus: t8, isChanged: inputProps.changed, children: t9 }), $[30] = inputProps.changed, $[31] = path, $[32] = t8, $[33] = t9, $[34] = t10) : t10 = $[34];
  let t11;
  return $[35] !== customProperties || $[36] !== t10 || $[37] !== t7 ? (t11 = /* @__PURE__ */ jsxs("div", { style: customProperties, children: [
    t7,
    t10
  ] }), $[35] = customProperties, $[36] = t10, $[37] = t7, $[38] = t11) : t11 = $[38], t11;
}
const ImageInputAsset = memo(ImageInputAssetComponent), MenuActionsWrapper = styled(Inline).withConfig({
  displayName: "MenuActionsWrapper",
  componentId: "sc-1v0aspi-0"
})`position:absolute;top:0;right:0;`, ImageActionsMenuWaitPlaceholder = () => {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(MenuActionsWrapper, { padding: 2, children: /* @__PURE__ */ jsx(Skeleton, { style: {
    width: "25px",
    height: "25px"
  }, animated: !0 }) }), $[0] = t0) : t0 = $[0], t0;
};
function ImageActionsMenu(props2) {
  const $ = c(13), {
    onEdit,
    children,
    showEdit,
    setHotspotButtonElement,
    menuButtonRef,
    onMenuOpen,
    isMenuOpen
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== onEdit || $[1] !== setHotspotButtonElement || $[2] !== showEdit || $[3] !== t ? (t0 = showEdit && /* @__PURE__ */ jsx(Button, { "aria-label": t("inputs.image.actions-menu.edit-details.aria-label"), "data-testid": "options-menu-edit-details", icon: CropIcon, mode: "ghost", onClick: onEdit, ref: setHotspotButtonElement, tooltipProps: {
    content: t("inputs.image.actions-menu.crop-image-tooltip")
  } }), $[0] = onEdit, $[1] = setHotspotButtonElement, $[2] = showEdit, $[3] = t, $[4] = t0) : t0 = $[4];
  let t1;
  $[5] !== children || $[6] !== isMenuOpen || $[7] !== menuButtonRef || $[8] !== onMenuOpen ? (t1 = /* @__PURE__ */ jsx(OptionsMenuPopover, { ariaLabelKey: "inputs.image.actions-menu.options.aria-label", buttonMode: "ghost", id: "image-actions-menu", isMenuOpen, menuButtonRef, onMenuOpen, openOnClick: "toggle", children }), $[5] = children, $[6] = isMenuOpen, $[7] = menuButtonRef, $[8] = onMenuOpen, $[9] = t1) : t1 = $[9];
  let t2;
  return $[10] !== t0 || $[11] !== t1 ? (t2 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsxs(MenuActionsWrapper, { "data-buttons": !0, space: 1, padding: 2, children: [
    t0,
    t1
  ] }) }), $[10] = t0, $[11] = t1, $[12] = t2) : t2 = $[12], t2;
}
function ImageInputAssetMenuComponent(props2) {
  const $ = c(46), {
    accessPolicy,
    assetSources,
    directUploads,
    handleOpenDialog,
    handleRemoveButtonClick,
    onSelectFile,
    onOpenSourceForUpload,
    handleSelectImageFromAssetSource,
    imageUrlBuilder,
    isImageToolEnabled,
    isMenuOpen,
    observeAsset,
    onOpenInSource,
    readOnly,
    schemaType,
    setHotspotButtonElement,
    menuButtonRef,
    setMenuOpen,
    value
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== schemaType ? (t0 = get(schemaType, "options.accept", "image/*"), $[0] = schemaType, $[1] = t0) : t0 = $[1];
  const accept = t0, asset = value?.asset, showAdvancedEditButton = value && asset && isImageToolEnabled;
  if (!asset)
    return null;
  let t1;
  $[2] !== schemaType ? (t1 = getDataTestIdPrefix(schemaType), $[2] = schemaType, $[3] = t1) : t1 = $[3];
  const dataTestIdPrefix = t1;
  let t2;
  $[4] !== assetSources || $[5] !== dataTestIdPrefix || $[6] !== handleSelectImageFromAssetSource || $[7] !== readOnly || $[8] !== setMenuOpen || $[9] !== t ? (t2 = assetSources && assetSources.length === 0 ? null : /* @__PURE__ */ jsx(MenuItem, { icon: SearchIcon, text: t("asset-source.browse-button.text"), onClick: () => {
    setMenuOpen(!1), handleSelectImageFromAssetSource(assetSources[0]);
  }, disabled: readOnly, "data-testid": `${dataTestIdPrefix}-browse-button` }), $[4] = assetSources, $[5] = dataTestIdPrefix, $[6] = handleSelectImageFromAssetSource, $[7] = readOnly, $[8] = setMenuOpen, $[9] = t, $[10] = t2) : t2 = $[10];
  let browseMenuItem = t2;
  if (assetSources && assetSources.length > 1) {
    let t32;
    if ($[11] !== assetSources || $[12] !== dataTestIdPrefix || $[13] !== handleSelectImageFromAssetSource || $[14] !== readOnly || $[15] !== setMenuOpen || $[16] !== t) {
      let t42;
      $[18] !== dataTestIdPrefix || $[19] !== handleSelectImageFromAssetSource || $[20] !== readOnly || $[21] !== setMenuOpen || $[22] !== t ? (t42 = (assetSource) => /* @__PURE__ */ jsx(MenuItem, { text: getAssetSourceDisplayName(assetSource, t, {
        useStartCaseForName: !0
      }), onClick: () => {
        setMenuOpen(!1), handleSelectImageFromAssetSource(assetSource);
      }, icon: assetSource.icon || ImageIcon, "data-testid": `${dataTestIdPrefix}-browse-button-${assetSource.name}`, disabled: readOnly }, assetSource.name), $[18] = dataTestIdPrefix, $[19] = handleSelectImageFromAssetSource, $[20] = readOnly, $[21] = setMenuOpen, $[22] = t, $[23] = t42) : t42 = $[23], t32 = assetSources.map(t42), $[11] = assetSources, $[12] = dataTestIdPrefix, $[13] = handleSelectImageFromAssetSource, $[14] = readOnly, $[15] = setMenuOpen, $[16] = t, $[17] = t32;
    } else
      t32 = $[17];
    browseMenuItem = t32;
  }
  const t3 = !!showAdvancedEditButton;
  let t4;
  return $[24] !== accept || $[25] !== accessPolicy || $[26] !== asset || $[27] !== assetSources || $[28] !== browseMenuItem || $[29] !== directUploads || $[30] !== handleOpenDialog || $[31] !== handleRemoveButtonClick || $[32] !== imageUrlBuilder || $[33] !== isMenuOpen || $[34] !== menuButtonRef || $[35] !== observeAsset || $[36] !== onOpenInSource || $[37] !== onOpenSourceForUpload || $[38] !== onSelectFile || $[39] !== readOnly || $[40] !== schemaType || $[41] !== setHotspotButtonElement || $[42] !== setMenuOpen || $[43] !== t3 || $[44] !== value ? (t4 = /* @__PURE__ */ jsx(ImageInputAssetMenuWithReferenceAsset, { accept, accessPolicy, assetSources, browseMenuItem, directUploads, handleOpenDialog, handleRemoveButtonClick, onSelectFile, onOpenSourceForUpload, imageUrlBuilder, isMenuOpen, observeAsset, onOpenInSource, readOnly, reference: asset, schemaType, setHotspotButtonElement, menuButtonRef, setMenuOpen, showAdvancedEditButton: t3, value }), $[24] = accept, $[25] = accessPolicy, $[26] = asset, $[27] = assetSources, $[28] = browseMenuItem, $[29] = directUploads, $[30] = handleOpenDialog, $[31] = handleRemoveButtonClick, $[32] = imageUrlBuilder, $[33] = isMenuOpen, $[34] = menuButtonRef, $[35] = observeAsset, $[36] = onOpenInSource, $[37] = onOpenSourceForUpload, $[38] = onSelectFile, $[39] = readOnly, $[40] = schemaType, $[41] = setHotspotButtonElement, $[42] = setMenuOpen, $[43] = t3, $[44] = value, $[45] = t4) : t4 = $[45], t4;
}
const ImageInputAssetMenu = memo(ImageInputAssetMenuComponent);
function ImageInputAssetMenuWithReferenceAssetComponent(props2) {
  const $ = c(69), {
    accept,
    accessPolicy,
    assetSources,
    browseMenuItem,
    directUploads,
    handleOpenDialog,
    handleRemoveButtonClick,
    onSelectFile,
    onOpenSourceForUpload,
    imageUrlBuilder,
    isMenuOpen,
    onOpenInSource,
    observeAsset,
    readOnly,
    reference,
    setHotspotButtonElement,
    menuButtonRef,
    setMenuOpen,
    showAdvancedEditButton,
    value
  } = props2, {
    t
  } = useTranslation(), documentId = reference?._ref;
  let t0;
  $[0] !== documentId || $[1] !== observeAsset ? (t0 = observeAsset(documentId), $[0] = documentId, $[1] = observeAsset, $[2] = t0) : t0 = $[2];
  const asset = useObservable(t0);
  let t1;
  $[3] !== assetSources ? (t1 = getAssetSourcesWithUpload(assetSources), $[3] = assetSources, $[4] = t1) : t1 = $[4];
  const assetSourcesWithUpload = t1;
  let t2;
  $[5] !== asset || $[6] !== assetSources ? (t2 = asset ? findOpenInSourceResult(asset, assetSources) : null, $[5] = asset, $[6] = assetSources, $[7] = t2) : t2 = $[7];
  const openInSourceResult = t2;
  let t3;
  $[8] !== onSelectFile || $[9] !== setMenuOpen ? (t3 = (assetSource, files) => {
    setMenuOpen(!1), onSelectFile(assetSource, files[0]);
  }, $[8] = onSelectFile, $[9] = setMenuOpen, $[10] = t3) : t3 = $[10];
  const handleSelectFilesFromAssetSource = t3;
  let t4;
  $[11] !== assetSourcesWithUpload || $[12] !== handleSelectFilesFromAssetSource ? (t4 = (files_0) => {
    handleSelectFilesFromAssetSource(assetSourcesWithUpload[0], files_0);
  }, $[11] = assetSourcesWithUpload, $[12] = handleSelectFilesFromAssetSource, $[13] = t4) : t4 = $[13];
  const handleSelectFilesFromAssetSourceSingle = t4;
  let t5;
  $[14] !== assetSourcesWithUpload || $[15] !== onOpenSourceForUpload || $[16] !== setMenuOpen ? (t5 = () => {
    setMenuOpen(!1), onOpenSourceForUpload && onOpenSourceForUpload(assetSourcesWithUpload[0]);
  }, $[14] = assetSourcesWithUpload, $[15] = onOpenSourceForUpload, $[16] = setMenuOpen, $[17] = t5) : t5 = $[17];
  const handleOpenSourceForUploadSingle = t5;
  let t6;
  $[18] !== onOpenSourceForUpload || $[19] !== setMenuOpen ? (t6 = (assetSource_0) => {
    setMenuOpen(!1), onOpenSourceForUpload?.(assetSource_0);
  }, $[18] = onOpenSourceForUpload, $[19] = setMenuOpen, $[20] = t6) : t6 = $[20];
  const handleOpenSourceForUpload = t6;
  let t7;
  $[21] !== asset || $[22] !== onOpenInSource || $[23] !== openInSourceResult || $[24] !== setMenuOpen ? (t7 = () => {
    if (!openInSourceResult || !asset)
      return;
    setMenuOpen(!1);
    const {
      source,
      result
    } = openInSourceResult;
    result.type === "url" ? window.open(result.url, result.target || "_blank") : result.type === "component" && onOpenInSource?.(source, asset);
  }, $[21] = asset, $[22] = onOpenInSource, $[23] = openInSourceResult, $[24] = setMenuOpen, $[25] = t7) : t7 = $[25];
  const handleOpenInSource = t7;
  let t8;
  $[26] !== setMenuOpen ? (t8 = () => setMenuOpen(!1), $[26] = setMenuOpen, $[27] = t8) : t8 = $[27];
  let t9;
  $[28] !== menuButtonRef ? (t9 = () => menuButtonRef.current?.focus(), $[28] = menuButtonRef, $[29] = t9) : t9 = $[29];
  let t10;
  $[30] !== accept || $[31] !== assetSourcesWithUpload || $[32] !== directUploads || $[33] !== handleOpenSourceForUpload || $[34] !== handleOpenSourceForUploadSingle || $[35] !== handleSelectFilesFromAssetSource || $[36] !== handleSelectFilesFromAssetSourceSingle || $[37] !== readOnly || $[38] !== t8 || $[39] !== t9 ? (t10 = {
    accept,
    assetSourcesWithUpload,
    directUploads,
    readOnly,
    onSelectFiles: handleSelectFilesFromAssetSource,
    onOpenSourceForUpload: handleOpenSourceForUpload,
    onOpenSourceForUploadSingle: handleOpenSourceForUploadSingle,
    onSelectFilesSingle: handleSelectFilesFromAssetSourceSingle,
    getSingleButtonTestId: _temp$2x,
    onCloseParentMenu: t8,
    onFilePickerCancel: t9
  }, $[30] = accept, $[31] = assetSourcesWithUpload, $[32] = directUploads, $[33] = handleOpenSourceForUpload, $[34] = handleOpenSourceForUploadSingle, $[35] = handleSelectFilesFromAssetSource, $[36] = handleSelectFilesFromAssetSourceSingle, $[37] = readOnly, $[38] = t8, $[39] = t9, $[40] = t10) : t10 = $[40];
  const uploadMenuItem = useUploadMenuItem(t10);
  if (!documentId || !asset) {
    let t112;
    return $[41] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t112 = /* @__PURE__ */ jsx(ImageActionsMenuWaitPlaceholder, {}), $[41] = t112) : t112 = $[41], t112;
  }
  const {
    _id,
    originalFilename,
    extension
  } = asset;
  let copyUrl, downloadUrl;
  if (isImageSource(value) && accessPolicy !== "private") {
    const filename = originalFilename || `download.${extension}`;
    let t112;
    $[42] !== _id || $[43] !== filename || $[44] !== imageUrlBuilder ? (t112 = imageUrlBuilder.image(_id).forceDownload(filename).url(), $[42] = _id, $[43] = filename, $[44] = imageUrlBuilder, $[45] = t112) : t112 = $[45], downloadUrl = t112;
    let t122;
    $[46] !== _id || $[47] !== imageUrlBuilder ? (t122 = imageUrlBuilder.image(_id).url(), $[46] = _id, $[47] = imageUrlBuilder, $[48] = t122) : t122 = $[48], copyUrl = t122;
  }
  const t11 = !!showAdvancedEditButton, t12 = downloadUrl, t13 = openInSourceResult ? handleOpenInSource : void 0;
  let t14;
  $[49] !== openInSourceResult || $[50] !== t ? (t14 = getOpenInSourceName(openInSourceResult, t), $[49] = openInSourceResult, $[50] = t, $[51] = t14) : t14 = $[51];
  let t15;
  $[52] !== browseMenuItem || $[53] !== copyUrl || $[54] !== downloadUrl || $[55] !== handleRemoveButtonClick || $[56] !== readOnly || $[57] !== t13 || $[58] !== t14 || $[59] !== uploadMenuItem ? (t15 = /* @__PURE__ */ jsx(ActionsMenu, { upload: uploadMenuItem, browse: browseMenuItem, onReset: handleRemoveButtonClick, downloadUrl: t12, openInSource: t13, openInSourceName: t14, copyUrl, readOnly }), $[52] = browseMenuItem, $[53] = copyUrl, $[54] = downloadUrl, $[55] = handleRemoveButtonClick, $[56] = readOnly, $[57] = t13, $[58] = t14, $[59] = uploadMenuItem, $[60] = t15) : t15 = $[60];
  let t16;
  return $[61] !== handleOpenDialog || $[62] !== isMenuOpen || $[63] !== menuButtonRef || $[64] !== setHotspotButtonElement || $[65] !== setMenuOpen || $[66] !== t11 || $[67] !== t15 ? (t16 = /* @__PURE__ */ jsx(ImageActionsMenu, { isMenuOpen, onEdit: handleOpenDialog, onMenuOpen: setMenuOpen, setHotspotButtonElement, menuButtonRef, showEdit: t11, children: t15 }), $[61] = handleOpenDialog, $[62] = isMenuOpen, $[63] = menuButtonRef, $[64] = setHotspotButtonElement, $[65] = setMenuOpen, $[66] = t11, $[67] = t15, $[68] = t16) : t16 = $[68], t16;
}
function _temp$2x() {
  return "file-input-upload-button";
}
const ImageInputAssetMenuWithReferenceAsset = memo(ImageInputAssetMenuWithReferenceAssetComponent), RatioBox$1 = styled(Box).withConfig({
  displayName: "RatioBox",
  componentId: "sc-z3271e-0"
})`position:relative;padding-bottom:calc(${({
  ratio = 3 / 2
}) => 1 / ratio} * 100%);& > div{position:absolute;top:${({
  padding = 0
}) => padding}px;left:${({
  padding = 0
}) => padding}px;right:${({
  padding = 0
}) => padding}px;bottom:${({
  padding = 0
}) => padding}px;}`, DEFAULT_HOTSPOT = {
  x: 0.5,
  y: 0.5,
  height: 1,
  width: 1
}, DEFAULT_CROP = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
}, HANDLE_VISUAL_SIZE_HOTSPOT = 16, HANDLE_VISUAL_SIZE_CROP = 8, HANDLE_INTERACTIVE_SIZE = 24, MARGIN_SIZE = HANDLE_INTERACTIVE_SIZE / 2, MIN_CROP_SIZE = 0.05, KEYBOARD_MOVEMENT_STEP = 5e-3, KEYBOARD_RESIZE_STEP = 5e-3, KEYBOARD_SHIFT_MULTIPLIER = 5, KEYBOARD_CHANGE_SAVE_DEBOUNCE_MS = 300;
function calculateStyles(options = {}) {
  const imageAspect = readAspectRatio(options.image) || 1, hotspot = options.hotspot || DEFAULT_HOTSPOT, crop = options.crop || DEFAULT_CROP, containerAspect = readAspectRatio(options.container) || imageAspect * readCropAspect(crop), align2 = options.align || {
    x: "center",
    y: "center"
  }, result = calculateHotSpotCrop(imageAspect, {
    hotspot,
    crop
  }, {
    aspect: containerAspect,
    align: align2
  }), containerHeight = styleFormat(round(100 / containerAspect));
  return {
    debug: {
      result
    },
    container: {
      //outline: '1px solid cyan',
      overflow: "hidden",
      position: "relative",
      width: "100%",
      height: containerHeight
    },
    padding: {
      marginTop: containerHeight
    },
    crop: {
      position: "absolute",
      overflow: "hidden",
      height: toStylePercentage(result.crop.height),
      width: toStylePercentage(result.crop.width),
      top: toStylePercentage(result.crop.top),
      left: toStylePercentage(result.crop.left)
    },
    image: {
      position: "absolute",
      height: toStylePercentage(result.image.height),
      width: toStylePercentage(result.image.width),
      top: toStylePercentage(result.image.top),
      left: toStylePercentage(result.image.left)
    }
  };
}
function readAspectRatio(opts) {
  if (!opts)
    return null;
  if ("aspectRatio" in opts)
    return opts.aspectRatio;
  if ("height" in opts || "width" in opts) {
    if (typeof opts.height != "number" && typeof opts.width != "number")
      throw new Error(`Height and width must be numbers, got ${JSON.stringify(opts)}`);
    return opts.width / opts.height;
  }
  return null;
}
function round(num, decimals = 2) {
  const multiplier = Math.pow(10, decimals);
  return Math.round(num * multiplier) / multiplier;
}
function calculateHotSpotCrop(sourceAspect, descriptor, spec) {
  const crop = descriptor.crop, viewportAspect = spec.aspect, alignment = spec.align, netWidth = 1 - crop.left - crop.right, netHeight = 1 - crop.top - crop.bottom, outImg = {
    top: -crop.top / netHeight,
    left: -crop.left / netWidth,
    width: 1 / netWidth,
    height: 1 / netHeight
  }, cropAspect = netWidth / netHeight * sourceAspect, hotspot = {
    x: (descriptor.hotspot.x - crop.left) / netWidth,
    y: (descriptor.hotspot.y - crop.top) / netHeight,
    height: descriptor.hotspot.height / netHeight,
    width: descriptor.hotspot.width / netWidth
  }, maxHotspotXScale = 1 / hotspot.width, maxHotspotYScale = 1 / hotspot.height * cropAspect / viewportAspect, maxScale = Math.min(maxHotspotXScale, maxHotspotYScale);
  let minFullBleedScale;
  const cropIsTaller = cropAspect <= viewportAspect;
  cropIsTaller ? minFullBleedScale = 1 : minFullBleedScale = cropAspect / viewportAspect;
  let method, outCrop;
  if (minFullBleedScale > maxScale) {
    method = "letterbox";
    let letterboxScale;
    const diff = minFullBleedScale - maxScale;
    cropIsTaller ? letterboxScale = 1 - diff : letterboxScale = maxScale, outCrop = {
      width: letterboxScale,
      height: letterboxScale / cropAspect * viewportAspect,
      // Gets overwritten further down
      left: 0,
      top: 0
    };
    const hotspotLeft = hotspot.x * outCrop.width - hotspot.width * outCrop.width / 2;
    switch (alignment.x) {
      case "left":
        outCrop.left = cropIsTaller ? 0 : -hotspotLeft;
        break;
      case "right":
        outCrop.left = cropIsTaller ? 1 - outCrop.width : hotspotLeft;
        break;
      case "center":
        outCrop.left = cropIsTaller ? (1 - outCrop.width) / 2 : -hotspotLeft;
        break;
      default:
        throw new Error(`Invalid x alignment: '${alignment.x}'. Must be either 'left', 'right' or 'center'`);
    }
    const hotspotTop = hotspot.y * outCrop.height - hotspot.height * outCrop.height / 2;
    switch (alignment.y) {
      case "top":
        outCrop.top = cropIsTaller ? -hotspotTop : 0;
        break;
      case "bottom":
        outCrop.top = hotspotTop;
        break;
      case "center":
        outCrop.top = cropIsTaller ? -hotspotTop : (1 - outCrop.height) / 2;
        break;
      default:
        throw new Error(`Invalid y alignment: '${alignment.y}'. Must be either 'top', 'bottom' or 'center'`);
    }
  } else if (cropIsTaller) {
    method = "full_width";
    let top = -hotspot.y / cropAspect * viewportAspect + 0.5;
    const height = minFullBleedScale / cropAspect * viewportAspect;
    top > 0 ? top = 0 : -top > height - 1 && (top = -(height - 1)), outCrop = {
      width: minFullBleedScale,
      height,
      left: 0,
      // Place the Y center of the hotspot near the center of the viewport
      top
    };
  } else {
    method = "full_height";
    const width = minFullBleedScale;
    let left = 0.5 - hotspot.x * minFullBleedScale;
    left > 0 ? left = 0 : -left > width - 1 && (left = -(width - 1)), outCrop = {
      width,
      height: minFullBleedScale / cropAspect * viewportAspect,
      top: 0,
      // Place the X center of the hotspot at the center of the viewport
      left
    };
  }
  return {
    method,
    crop: outCrop,
    image: outImg
  };
}
function readCropAspect(crop) {
  const height = 1 - crop.top - crop.bottom;
  return (1 - crop.left - crop.right) / height;
}
function styleFormat(num) {
  return num === 0 ? 0 : `${num}%`;
}
function toStylePercentage(num) {
  return styleFormat(round(num * 100));
}
const HotspotImageContainer = styled.div.withConfig({
  displayName: "HotspotImageContainer",
  componentId: "sc-1j0h6c9-0"
})`position:relative;width:100%;`, debug$9 = debug$c("sanity-imagetool");
function getCropAspect(crop, srcAspect) {
  const origHeight = 1 / srcAspect, origWidth = srcAspect * origHeight, cropWidth = origWidth - (crop.left + crop.right) * origWidth, cropHeight = origHeight - (crop.top + crop.bottom) * origHeight;
  return cropWidth / cropHeight;
}
const HotspotImage = memo(function(props2) {
  const $ = c(36), {
    alignX: t0,
    alignY: t1,
    alt,
    aspectRatio: t2,
    className: t3,
    crop: t4,
    hotspot: t5,
    onError,
    onLoad,
    src,
    srcAspectRatio,
    srcSet,
    style
  } = props2, alignX = t0 === void 0 ? "center" : t0, alignY = t1 === void 0 ? "center" : t1, aspectRatio = t2 === void 0 ? "none" : t2, className = t3 === void 0 ? "" : t3, crop = t4 === void 0 ? DEFAULT_CROP : t4, hotspot = t5 === void 0 ? DEFAULT_HOTSPOT : t5, [containerAspect, setContainerAspect] = useState(null), containerElementRef = useRef(null), imageElementRef = useRef(null);
  let t6;
  $[0] !== aspectRatio ? (t6 = () => {
    if (containerElementRef.current)
      if (aspectRatio === "auto") {
        const parentNode = containerElementRef.current.parentNode;
        startTransition(() => setContainerAspect(parentNode.offsetWidth / parentNode.offsetHeight));
      } else
        setContainerAspect(null);
  }, $[0] = aspectRatio, $[1] = t6) : t6 = $[1];
  const updateContainerAspect = t6;
  let t7, t8;
  $[2] !== src || $[3] !== updateContainerAspect ? (t7 = () => {
    const imageElement = imageElementRef.current;
    return imageElement && imageElement.src && imageElement.complete && imageElement.naturalWidth !== void 0 && (debug$9("Image '%s' already loaded, refreshing (from cache) to trigger onLoad / onError", src), imageElement.src = imageElement.src), startTransition(() => updateContainerAspect()), window.addEventListener("resize", updateContainerAspect), () => {
      window.removeEventListener("resize", updateContainerAspect);
    };
  }, t8 = [src, updateContainerAspect], $[2] = src, $[3] = updateContainerAspect, $[4] = t7, $[5] = t8) : (t7 = $[4], t8 = $[5]), useEffect(t7, t8);
  let t9;
  bb0: {
    if (aspectRatio === "none") {
      let t102;
      $[6] !== crop || $[7] !== srcAspectRatio ? (t102 = crop ? getCropAspect(crop, srcAspectRatio) : srcAspectRatio, $[6] = crop, $[7] = srcAspectRatio, $[8] = t102) : t102 = $[8], t9 = t102;
      break bb0;
    }
    if (aspectRatio === "auto") {
      t9 = containerAspect;
      break bb0;
    }
    t9 = aspectRatio || null;
  }
  const t10 = t9 || srcAspectRatio;
  let t11;
  $[9] !== alignX || $[10] !== alignY || $[11] !== crop || $[12] !== hotspot || $[13] !== srcAspectRatio || $[14] !== t10 ? (t11 = calculateStyles({
    container: {
      aspectRatio: t10
    },
    image: {
      aspectRatio: srcAspectRatio
    },
    hotspot,
    crop,
    align: {
      x: alignX,
      y: alignY
    }
  }), $[9] = alignX, $[10] = alignY, $[11] = crop, $[12] = hotspot, $[13] = srcAspectRatio, $[14] = t10, $[15] = t11) : t11 = $[15];
  const targetStyles = t11, t12 = `${className}`;
  let t13;
  $[16] !== targetStyles.padding ? (t13 = /* @__PURE__ */ jsx("div", { style: targetStyles.padding }), $[16] = targetStyles.padding, $[17] = t13) : t13 = $[17];
  let t14;
  $[18] !== alt || $[19] !== onError || $[20] !== onLoad || $[21] !== src || $[22] !== srcSet || $[23] !== targetStyles.image ? (t14 = /* @__PURE__ */ jsx("img", { ref: imageElementRef, src, alt, srcSet, onLoad, onError, style: targetStyles.image }), $[18] = alt, $[19] = onError, $[20] = onLoad, $[21] = src, $[22] = srcSet, $[23] = targetStyles.image, $[24] = t14) : t14 = $[24];
  let t15;
  $[25] !== t14 || $[26] !== targetStyles.crop ? (t15 = /* @__PURE__ */ jsx("div", { style: targetStyles.crop, children: t14 }), $[25] = t14, $[26] = targetStyles.crop, $[27] = t15) : t15 = $[27];
  let t16;
  $[28] !== t13 || $[29] !== t15 || $[30] !== targetStyles.container ? (t16 = /* @__PURE__ */ jsxs("div", { style: targetStyles.container, children: [
    t13,
    t15
  ] }), $[28] = t13, $[29] = t15, $[30] = targetStyles.container, $[31] = t16) : t16 = $[31];
  let t17;
  return $[32] !== style || $[33] !== t12 || $[34] !== t16 ? (t17 = /* @__PURE__ */ jsx(HotspotImageContainer, { className: t12, style, ref: containerElementRef, children: t16 }), $[32] = style, $[33] = t12, $[34] = t16, $[35] = t17) : t17 = $[35], t17;
});
function ImageLoader(props2) {
  const $ = c(8), {
    src,
    children
  } = props2, [isLoading, setIsLoading] = useState(!0), [image, setImage] = useState(null), [error, setError] = useState(null);
  let t0, t1;
  $[0] !== src ? (t0 = () => {
    setImage(null), setError(null), setIsLoading(!0);
    const image_0 = new Image();
    image_0.onload = () => {
      setImage(image_0), setError(null), setIsLoading(!1);
    }, image_0.onerror = () => {
      setError(new Error(`Could not load image from ${JSON.stringify(src)}`)), setIsLoading(!1);
    }, image_0.referrerPolicy = "strict-origin-when-cross-origin", image_0.src = src;
  }, t1 = [src], $[0] = src, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  return $[3] !== children || $[4] !== error || $[5] !== image || $[6] !== isLoading ? (t2 = children({
    image,
    error,
    isLoading
  }), $[3] = children, $[4] = error, $[5] = image, $[6] = isLoading, $[7] = t2) : t2 = $[7], t2;
}
function ResizeSVG(props2) {
  const {
    image,
    maxHeight,
    maxWidth,
    children
  } = props2, ratio = image.width / image.height, landscape = image.width > image.height, targetSize = {
    width: landscape ? maxWidth : maxHeight * ratio,
    height: landscape ? maxWidth / ratio : maxHeight
  };
  return targetSize.width > maxWidth && (targetSize.width = maxWidth, targetSize.height = maxWidth / ratio), targetSize.height > maxHeight && (targetSize.height = maxHeight, targetSize.width = maxHeight * ratio), children(targetSize);
}
const getRectCenterX = (rect) => rect.left + rect.width / 2, getRectCenterY = (rect) => rect.top + rect.height / 2, getRectRight = (rect) => rect.left + rect.width, getRectBottom = (rect) => rect.top + rect.height, getCropDimensions = (crop) => ({
  width: 1 - crop.left - crop.right,
  height: 1 - crop.top - crop.bottom,
  left: crop.left,
  right: 1 - crop.right,
  top: crop.top,
  bottom: 1 - crop.bottom
}), getPointerPosition = (e, svg, size) => {
  const rect = svg.getBoundingClientRect();
  return {
    x: (e.clientX - rect.left) / rect.width * size.width,
    y: (e.clientY - rect.top) / rect.height * size.height
  };
}, calculateDelta = (initialPos, currentPos, rect) => ({
  x: (currentPos.x - initialPos.x) / rect.width,
  y: (currentPos.y - initialPos.y) / rect.height
}), constrainHotspotToCrop = (hotspot, crop) => {
  const cropDimensions = getCropDimensions(crop), adjustedWidth = Math.min(hotspot.width, cropDimensions.width), adjustedHeight = Math.min(hotspot.height, cropDimensions.height), minX = cropDimensions.left + adjustedWidth / 2, maxX = cropDimensions.right - adjustedWidth / 2, minY = cropDimensions.top + adjustedHeight / 2, maxY = cropDimensions.bottom - adjustedHeight / 2;
  return {
    x: Math.min(Math.max(hotspot.x, minX), maxX),
    y: Math.min(Math.max(hotspot.y, minY), maxY),
    width: adjustedWidth,
    height: adjustedHeight
  };
}, applyHotspotMoveBy = (value, delta) => {
  const {
    x,
    y,
    width,
    height
  } = value.hotspot || DEFAULT_HOTSPOT, crop = value.crop || DEFAULT_CROP;
  return constrainHotspotToCrop({
    x: x + delta.x,
    y: y + delta.y,
    width,
    height
  }, crop);
}, handleHotspotMove = (value, initialPosition, pointerPos, innerRect) => {
  const delta = calculateDelta(initialPosition, pointerPos, innerRect);
  return {
    crop: value.crop || DEFAULT_CROP,
    hotspot: applyHotspotMoveBy(value, delta)
  };
}, handleHotspotResize = (params) => {
  const {
    initialHotspot,
    crop,
    initialCursor,
    pointerPos,
    innerRect
  } = params, dimensions = getCropDimensions(crop), netWidth = dimensions.width, netHeight = dimensions.height, cropLeft = dimensions.left, cropRight = dimensions.right, cropTop = dimensions.top, cropBottom = dimensions.bottom, deltaX = pointerPos.x - initialCursor.x, deltaY = pointerPos.y - initialCursor.y, factorX = deltaX, factorY = deltaY, initialWidthPx = initialHotspot.width * innerRect.width, initialHeightPx = initialHotspot.height * innerRect.height, newWidthPx = initialWidthPx + factorX * 2, newHeightPx = initialHeightPx + factorY * 2;
  let newWidth = newWidthPx / innerRect.width, newHeight = newHeightPx / innerRect.height;
  newWidth = Math.max(0, newWidth), newHeight = Math.max(0, newHeight), newWidth = Math.min(newWidth, netWidth), newHeight = Math.min(newHeight, netHeight);
  let newX = initialHotspot.x, newY = initialHotspot.y;
  const minX = cropLeft + newWidth / 2, maxX = cropRight - newWidth / 2;
  newX < minX ? newX = minX : newX > maxX && (newX = maxX);
  const minY = cropTop + newHeight / 2, maxY = cropBottom - newHeight / 2;
  newY < minY ? newY = minY : newY > maxY && (newY = maxY);
  const newHotspot = {
    ...initialHotspot,
    x: newX,
    y: newY,
    width: newWidth,
    height: newHeight
  };
  return {
    crop,
    hotspot: newHotspot
  };
}, handleCropMove = (params) => {
  const {
    initialCrop,
    initialHotspot,
    initialCursor,
    pointerPos,
    innerRect
  } = params, delta = calculateDelta(initialCursor, pointerPos, innerRect), {
    top: initialTop,
    right: initialRight,
    bottom: initialBottom,
    left: initialLeft
  } = initialCrop;
  let newLeft = initialLeft + delta.x, newRight = initialRight - delta.x, newTop = initialTop + delta.y, newBottom = initialBottom - delta.y;
  const dimensions = getCropDimensions(initialCrop), netWidth = dimensions.width, netHeight = dimensions.height;
  newLeft < 0 ? (newLeft = 0, newRight = 1 - netWidth) : newRight < 0 ? (newRight = 0, newLeft = 1 - netWidth) : newLeft + newRight > 1 && (delta.x > 0 ? (newLeft = 1 - netWidth, newRight = 0) : (newLeft = 0, newRight = 1 - netWidth)), newTop < 0 ? (newTop = 0, newBottom = 1 - netHeight) : newBottom < 0 ? (newBottom = 0, newTop = 1 - netHeight) : newTop + newBottom > 1 && (delta.y > 0 ? (newTop = 1 - netHeight, newBottom = 0) : (newTop = 0, newBottom = 1 - netHeight));
  const newCrop = {
    top: newTop,
    right: newRight,
    bottom: newBottom,
    left: newLeft
  }, initialCropCenterX = 0.5 - (initialLeft + initialRight) / 2, initialCropCenterY = 0.5 - (initialTop + initialBottom) / 2, newCropCenterX = 0.5 - (newLeft + newRight) / 2, newCropCenterY = 0.5 - (newTop + newBottom) / 2, cropCenterDeltaX = newCropCenterX - initialCropCenterX, cropCenterDeltaY = newCropCenterY - initialCropCenterY, newHotspot = {
    ...initialHotspot,
    x: initialHotspot.x + cropCenterDeltaX,
    y: initialHotspot.y + cropCenterDeltaY
  }, adjustedHotspot = constrainHotspotToCrop(newHotspot, newCrop);
  return {
    crop: newCrop,
    hotspot: adjustedHotspot
  };
}, handleCropHandleResize = (params) => {
  const {
    initialCrop,
    initialHotspot,
    initialCursor,
    pointerPos,
    innerRect,
    activeHandle
  } = params, handlePosition = activeHandle.startsWith("crop-") ? activeHandle.slice(5) : "", delta = calculateDelta(initialCursor, pointerPos, innerRect);
  let {
    left,
    right,
    top,
    bottom: bottom2
  } = initialCrop;
  const minLeft = 0, minTop = 0;
  switch (handlePosition) {
    case "left":
      left = Math.min(Math.max(initialCrop.left + delta.x, minLeft), 1 - initialCrop.right - MIN_CROP_SIZE);
      break;
    case "right":
      right = Math.min(Math.max(initialCrop.right - delta.x, minLeft), 1 - initialCrop.left - MIN_CROP_SIZE);
      break;
    case "top":
      top = Math.min(Math.max(initialCrop.top + delta.y, minTop), 1 - initialCrop.bottom - MIN_CROP_SIZE);
      break;
    case "bottom":
      bottom2 = Math.min(Math.max(initialCrop.bottom - delta.y, minTop), 1 - initialCrop.top - MIN_CROP_SIZE);
      break;
    case "topLeft":
      left = Math.min(Math.max(initialCrop.left + delta.x, minLeft), 1 - initialCrop.right - MIN_CROP_SIZE), top = Math.min(Math.max(initialCrop.top + delta.y, minTop), 1 - initialCrop.bottom - MIN_CROP_SIZE);
      break;
    case "topRight":
      right = Math.min(Math.max(initialCrop.right - delta.x, minLeft), 1 - initialCrop.left - MIN_CROP_SIZE), top = Math.min(Math.max(initialCrop.top + delta.y, minTop), 1 - initialCrop.bottom - MIN_CROP_SIZE);
      break;
    case "bottomLeft":
      left = Math.min(Math.max(initialCrop.left + delta.x, minLeft), 1 - initialCrop.right - MIN_CROP_SIZE), bottom2 = Math.min(Math.max(initialCrop.bottom - delta.y, minTop), 1 - initialCrop.top - MIN_CROP_SIZE);
      break;
    case "bottomRight":
      right = Math.min(Math.max(initialCrop.right - delta.x, minLeft), 1 - initialCrop.left - MIN_CROP_SIZE), bottom2 = Math.min(Math.max(initialCrop.bottom - delta.y, minTop), 1 - initialCrop.top - MIN_CROP_SIZE);
      break;
  }
  const newCrop = {
    left,
    right,
    top,
    bottom: bottom2
  }, newHotspot = constrainHotspotToCrop(initialHotspot, newCrop);
  return {
    crop: newCrop,
    hotspot: newHotspot
  };
}, HANDLE_CURSOR_MAP = {
  "crop-top": "ns-resize",
  "crop-bottom": "ns-resize",
  "crop-left": "ew-resize",
  "crop-right": "ew-resize",
  "crop-topRight": "nesw-resize",
  "crop-bottomLeft": "nesw-resize",
  "crop-topLeft": "nwse-resize",
  "crop-bottomRight": "nwse-resize"
}, calculateCurrentCursor = (dragTarget, activeHandle, hoverTarget) => dragTarget === "crop" || dragTarget === "hotspot" ? "grabbing" : dragTarget === "hotspotHandle" ? "move" : dragTarget === "cropHandle" && activeHandle ? HANDLE_CURSOR_MAP[activeHandle] || "move" : hoverTarget ? hoverTarget === "crop" || hoverTarget === "hotspot" ? "grab" : hoverTarget === "hotspotHandle" ? "move" : typeof hoverTarget == "string" && hoverTarget in HANDLE_CURSOR_MAP ? HANDLE_CURSOR_MAP[hoverTarget] : "default" : "default", getHotspotHandlePosition = (hotspotRect) => {
  const angle = Math.PI * 0.25, rx = hotspotRect.width / 2, ry = hotspotRect.height / 2;
  return {
    x: getRectCenterX(hotspotRect) + Math.cos(angle) * rx,
    y: getRectCenterY(hotspotRect) + Math.sin(angle) * ry
  };
}, HANDLE_TEMPLATES = {
  CORNER_PATH: (size) => {
    const half = size / 2;
    return `M ${-half} ${size * 1.5} 
            L ${-half} ${-half} 
            L ${size * 1.5} ${-half} 
            L ${size * 1.5} ${half} 
            L ${half} ${half} 
            L ${half} ${size * 1.5} 
            Z`;
  },
  EDGE_DIMENSIONS: {
    top: (size) => ({
      width: size * 2,
      height: size
    }),
    right: (size) => ({
      width: size,
      height: size * 2
    }),
    bottom: (size) => ({
      width: size * 2,
      height: size
    }),
    left: (size) => ({
      width: size,
      height: size * 2
    })
  }
}, HANDLE_PATHS = {
  cornerPath: HANDLE_TEMPLATES.CORNER_PATH(HANDLE_VISUAL_SIZE_CROP),
  edgeDimensions: {
    top: HANDLE_TEMPLATES.EDGE_DIMENSIONS.top(HANDLE_VISUAL_SIZE_CROP),
    right: HANDLE_TEMPLATES.EDGE_DIMENSIONS.right(HANDLE_VISUAL_SIZE_CROP),
    bottom: HANDLE_TEMPLATES.EDGE_DIMENSIONS.bottom(HANDLE_VISUAL_SIZE_CROP),
    left: HANDLE_TEMPLATES.EDGE_DIMENSIONS.left(HANDLE_VISUAL_SIZE_CROP)
  }
}, calculateCropHandles = (cropRect) => {
  const hitAreaSize = HANDLE_INTERACTIVE_SIZE, halfHitAreaSize = hitAreaSize / 2, edgeHitWidth = HANDLE_INTERACTIVE_SIZE, positions = {
    top: {
      x: cropRect.left + cropRect.width / 2,
      y: cropRect.top
    },
    right: {
      x: getRectRight(cropRect),
      y: cropRect.top + cropRect.height / 2
    },
    bottom: {
      x: cropRect.left + cropRect.width / 2,
      y: getRectBottom(cropRect)
    },
    left: {
      x: cropRect.left,
      y: cropRect.top + cropRect.height / 2
    },
    topLeft: {
      x: cropRect.left,
      y: cropRect.top
    },
    topRight: {
      x: getRectRight(cropRect),
      y: cropRect.top
    },
    bottomLeft: {
      x: cropRect.left,
      y: getRectBottom(cropRect)
    },
    bottomRight: {
      x: getRectRight(cropRect),
      y: getRectBottom(cropRect)
    }
  }, rotations = {
    topLeft: 0,
    topRight: 90,
    bottomRight: 180,
    bottomLeft: 270
  }, result = {};
  for (const edge of ["top", "right", "bottom", "left"]) {
    const dims = HANDLE_PATHS.edgeDimensions[edge], pos = positions[edge];
    result[edge] = {
      visual: {
        left: pos.x - dims.width / 2,
        top: pos.y - dims.height / 2,
        width: dims.width,
        height: dims.height
      },
      hit: {
        left: edge === "left" || edge === "right" ? pos.x - edgeHitWidth / 2 : pos.x - HANDLE_INTERACTIVE_SIZE / 2,
        top: edge === "top" || edge === "bottom" ? pos.y - edgeHitWidth / 2 : pos.y - HANDLE_INTERACTIVE_SIZE / 2,
        width: edge === "left" || edge === "right" ? edgeHitWidth : HANDLE_INTERACTIVE_SIZE,
        height: edge === "top" || edge === "bottom" ? edgeHitWidth : HANDLE_INTERACTIVE_SIZE
      }
    };
  }
  for (const corner of ["topLeft", "topRight", "bottomLeft", "bottomRight"]) {
    const pos = positions[corner];
    result[corner] = {
      visual: {
        left: pos.x - HANDLE_INTERACTIVE_SIZE,
        top: pos.y - HANDLE_INTERACTIVE_SIZE,
        width: HANDLE_INTERACTIVE_SIZE * 2,
        height: HANDLE_INTERACTIVE_SIZE * 2
      },
      hit: {
        left: pos.x - halfHitAreaSize,
        top: pos.y - halfHitAreaSize,
        width: hitAreaSize,
        height: hitAreaSize
      },
      path: HANDLE_PATHS.cornerPath,
      position: pos,
      rotation: rotations[corner]
    };
  }
  return result;
};
function useHoverHandlers() {
  const $ = c(8), [hoverTarget, setHoverTarget] = useState(null);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = (target) => {
    setHoverTarget(target);
  }, $[0] = t0) : t0 = $[0];
  const handleMouseEnter = t0;
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setHoverTarget(null);
  }, $[1] = t1) : t1 = $[1];
  const handleMouseLeave = t1;
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => handleMouseEnter("hotspot"), $[2] = t2) : t2 = $[2];
  const handleHotspotMouseEnter = t2;
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => handleMouseEnter("hotspotHandle"), $[3] = t3) : t3 = $[3];
  const handleHotspotHandleMouseEnter = t3;
  let t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => handleMouseEnter("crop"), $[4] = t4) : t4 = $[4];
  const handleCropMouseEnter = t4;
  let t5;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = (key) => () => handleMouseEnter(`crop-${key}`), $[5] = t5) : t5 = $[5];
  const getCropHandleMouseEnter = t5;
  let t6;
  return $[6] !== hoverTarget ? (t6 = {
    hoverTarget,
    handleMouseEnter,
    handleMouseLeave,
    handleHotspotMouseEnter,
    handleHotspotHandleMouseEnter,
    handleCropMouseEnter,
    getCropHandleMouseEnter
  }, $[6] = hoverTarget, $[7] = t6) : t6 = $[7], t6;
}
function useKeyboardControls(t0) {
  const $ = c(20), {
    value,
    onChange,
    onChangeEnd,
    innerRect,
    focusTarget,
    readOnly
  } = t0, initialCropRef = useRef(null), initialHotspotRef = useRef(null), initialCursorRef = useRef(null), changeEndTimeoutRef = useRef(null);
  let t1;
  $[0] !== onChangeEnd || $[1] !== value ? (t1 = () => {
    (initialCropRef.current || initialHotspotRef.current) && (onChangeEnd({
      crop: value.crop || DEFAULT_CROP,
      hotspot: value.hotspot || DEFAULT_HOTSPOT
    }), initialCropRef.current = null, initialHotspotRef.current = null, initialCursorRef.current = null);
  }, $[0] = onChangeEnd, $[1] = value, $[2] = t1) : t1 = $[2];
  const triggerChangeEnd = t1;
  let t2;
  $[3] !== innerRect ? (t2 = (params) => {
    const {
      e,
      crop,
      hotspot,
      isCtrlOrCmdPressed,
      step,
      resizeStep
    } = params;
    let newValue;
    if (isCtrlOrCmdPressed) {
      const pointerPos = {
        x: initialCursorRef.current.x,
        y: initialCursorRef.current.y
      };
      bb19: switch (e.key) {
        case "ArrowUp": {
          pointerPos.y = pointerPos.y - innerRect.height * resizeStep;
          break bb19;
        }
        case "ArrowDown": {
          pointerPos.y = pointerPos.y + innerRect.height * resizeStep;
          break bb19;
        }
        case "ArrowLeft": {
          pointerPos.x = pointerPos.x - innerRect.width * resizeStep;
          break bb19;
        }
        case "ArrowRight": {
          pointerPos.x = pointerPos.x + innerRect.width * resizeStep;
          break bb19;
        }
        default:
          return null;
      }
      newValue = handleHotspotResize({
        initialHotspot: hotspot,
        crop,
        initialCursor: initialCursorRef.current,
        pointerPos,
        innerRect
      });
    } else {
      const delta = {
        x: 0,
        y: 0
      };
      bb31: switch (e.key) {
        case "ArrowUp": {
          delta.y = -step;
          break bb31;
        }
        case "ArrowDown": {
          delta.y = step;
          break bb31;
        }
        case "ArrowLeft": {
          delta.x = -step;
          break bb31;
        }
        case "ArrowRight": {
          delta.x = step;
          break bb31;
        }
        default:
          return null;
      }
      newValue = {
        hotspot: applyHotspotMoveBy({
          hotspot,
          crop
        }, delta),
        crop
      };
    }
    return newValue;
  }, $[3] = innerRect, $[4] = t2) : t2 = $[4];
  const handleHotspotKeyDown = t2;
  let t3;
  $[5] !== innerRect ? (t3 = (params_0) => {
    const {
      e: e_0,
      crop: crop_0,
      hotspot: hotspot_0,
      isCtrlOrCmdPressed: isCtrlOrCmdPressed_0,
      step: step_0,
      resizeStep: resizeStep_0
    } = params_0;
    if (isCtrlOrCmdPressed_0) {
      let activeHandle;
      const pointerPos_0 = {
        x: initialCursorRef.current.x,
        y: initialCursorRef.current.y
      };
      bb46: switch (e_0.key) {
        case "ArrowUp": {
          activeHandle = "crop-bottom", pointerPos_0.y = pointerPos_0.y - innerRect.height * resizeStep_0;
          break bb46;
        }
        case "ArrowDown": {
          activeHandle = "crop-bottom", pointerPos_0.y = pointerPos_0.y + innerRect.height * resizeStep_0;
          break bb46;
        }
        case "ArrowLeft": {
          activeHandle = "crop-right", pointerPos_0.x = pointerPos_0.x - innerRect.width * resizeStep_0;
          break bb46;
        }
        case "ArrowRight": {
          activeHandle = "crop-right", pointerPos_0.x = pointerPos_0.x + innerRect.width * resizeStep_0;
          break bb46;
        }
        default:
          return null;
      }
      if (activeHandle)
        return handleCropHandleResize({
          initialCrop: crop_0,
          initialHotspot: hotspot_0,
          initialCursor: initialCursorRef.current,
          pointerPos: pointerPos_0,
          innerRect,
          activeHandle
        });
    } else {
      const pointerPos_1 = {
        x: initialCursorRef.current.x,
        y: initialCursorRef.current.y
      };
      bb61: switch (e_0.key) {
        case "ArrowUp": {
          pointerPos_1.y = pointerPos_1.y - innerRect.height * step_0;
          break bb61;
        }
        case "ArrowDown": {
          pointerPos_1.y = pointerPos_1.y + innerRect.height * step_0;
          break bb61;
        }
        case "ArrowLeft": {
          pointerPos_1.x = pointerPos_1.x - innerRect.width * step_0;
          break bb61;
        }
        case "ArrowRight": {
          pointerPos_1.x = pointerPos_1.x + innerRect.width * step_0;
          break bb61;
        }
        default:
          return null;
      }
      return handleCropMove({
        initialCrop: crop_0,
        initialHotspot: hotspot_0,
        initialCursor: initialCursorRef.current,
        pointerPos: pointerPos_1,
        innerRect
      });
    }
    return null;
  }, $[5] = innerRect, $[6] = t3) : t3 = $[6];
  const handleCropKeyDown = t3;
  let t4;
  $[7] !== focusTarget || $[8] !== handleCropKeyDown || $[9] !== handleHotspotKeyDown || $[10] !== innerRect || $[11] !== onChange || $[12] !== readOnly || $[13] !== value ? (t4 = (e_1) => {
    if (changeEndTimeoutRef.current !== null && window.clearTimeout(changeEndTimeoutRef.current), readOnly || !focusTarget || !["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e_1.key))
      return;
    const crop_1 = value.crop || DEFAULT_CROP, hotspot_1 = value.hotspot || DEFAULT_HOTSPOT;
    initialCropRef.current = {
      ...crop_1
    }, initialHotspotRef.current = {
      ...hotspot_1
    }, initialCursorRef.current = {
      x: innerRect.width / 2,
      y: innerRect.height / 2
    };
    const isShiftPressed = e_1.shiftKey, isCtrlOrCmdPressed_1 = e_1.ctrlKey || e_1.metaKey, step_1 = isShiftPressed ? KEYBOARD_MOVEMENT_STEP * KEYBOARD_SHIFT_MULTIPLIER : KEYBOARD_MOVEMENT_STEP, resizeStep_1 = isShiftPressed ? KEYBOARD_RESIZE_STEP * KEYBOARD_SHIFT_MULTIPLIER : KEYBOARD_RESIZE_STEP;
    let newValue_0 = null;
    focusTarget === "hotspot" || focusTarget === "hotspotHandle" ? newValue_0 = handleHotspotKeyDown({
      e: e_1,
      crop: crop_1,
      hotspot: hotspot_1,
      isCtrlOrCmdPressed: isCtrlOrCmdPressed_1,
      step: step_1,
      resizeStep: resizeStep_1
    }) : (focusTarget === "crop" || focusTarget === "cropHandle") && (newValue_0 = handleCropKeyDown({
      e: e_1,
      crop: crop_1,
      hotspot: hotspot_1,
      isCtrlOrCmdPressed: isCtrlOrCmdPressed_1,
      step: step_1,
      resizeStep: resizeStep_1
    })), newValue_0 && (onChange(newValue_0), e_1.preventDefault());
  }, $[7] = focusTarget, $[8] = handleCropKeyDown, $[9] = handleHotspotKeyDown, $[10] = innerRect, $[11] = onChange, $[12] = readOnly, $[13] = value, $[14] = t4) : t4 = $[14];
  const handleKeyDown = t4;
  let t5;
  $[15] !== triggerChangeEnd ? (t5 = (e_2) => {
    changeEndTimeoutRef.current !== null && window.clearTimeout(changeEndTimeoutRef.current), changeEndTimeoutRef.current = window.setTimeout(() => {
      triggerChangeEnd(), changeEndTimeoutRef.current = null;
    }, KEYBOARD_CHANGE_SAVE_DEBOUNCE_MS);
  }, $[15] = triggerChangeEnd, $[16] = t5) : t5 = $[16];
  const handleKeyUp = t5;
  let t6;
  return $[17] !== handleKeyDown || $[18] !== handleKeyUp ? (t6 = {
    handleKeyDown,
    handleKeyUp
  }, $[17] = handleKeyDown, $[18] = handleKeyUp, $[19] = t6) : t6 = $[19], t6;
}
function usePointerHandlers(t0) {
  const $ = c(25), {
    value,
    onChange,
    innerRect,
    svgRef,
    size,
    readOnly,
    hotspotRef,
    cropRef
  } = t0, initialCropRef = useRef(null), initialCursorRef = useRef(null), initialHotspotRef = useRef(null), [dragStart, setDragStart] = useState(null), [dragTarget, setDragTarget] = useState(null), [activeHandle, setActiveHandle] = useState(null);
  let t1;
  $[0] !== cropRef || $[1] !== hotspotRef || $[2] !== readOnly || $[3] !== size.height || $[4] !== size.width || $[5] !== svgRef || $[6] !== value.crop || $[7] !== value.hotspot ? (t1 = (e) => {
    if (readOnly)
      return;
    const svg = svgRef.current;
    if (!svg)
      return;
    const rect = svg.getBoundingClientRect(), x = (e.clientX - rect.left) / rect.width * size.width, y = (e.clientY - rect.top) / rect.height * size.height;
    setDragStart({
      x,
      y
    }), initialCursorRef.current = {
      x,
      y
    }, initialCropRef.current = {
      ...value.crop || DEFAULT_CROP
    }, initialHotspotRef.current = {
      ...value.hotspot || DEFAULT_HOTSPOT
    };
    const handle = e.currentTarget.dataset.handle;
    handle === "hotspotHandle" ? (setDragTarget("hotspotHandle"), hotspotRef.current?.focus()) : handle === "hotspot" ? (setDragTarget("hotspot"), hotspotRef.current?.focus()) : handle && handle.startsWith("crop-") ? (setActiveHandle(handle), setDragTarget("cropHandle"), cropRef.current?.focus()) : handle === "crop" && (setDragTarget("crop"), cropRef.current?.focus()), svg.setPointerCapture(e.pointerId), e.preventDefault(), e.stopPropagation();
  }, $[0] = cropRef, $[1] = hotspotRef, $[2] = readOnly, $[3] = size.height, $[4] = size.width, $[5] = svgRef, $[6] = value.crop, $[7] = value.hotspot, $[8] = t1) : t1 = $[8];
  const handlePointerDown = t1;
  let t2;
  $[9] !== activeHandle || $[10] !== dragStart || $[11] !== dragTarget || $[12] !== innerRect || $[13] !== onChange || $[14] !== size || $[15] !== svgRef || $[16] !== value.crop ? (t2 = (e_0) => {
    const svg_0 = svgRef.current;
    if (!svg_0 || !dragTarget || !dragStart || !initialCursorRef.current || !initialCropRef.current || !initialHotspotRef.current)
      return;
    const pointerPos = getPointerPosition(e_0, svg_0, size);
    if (dragTarget === "hotspot") {
      const result = handleHotspotMove({
        crop: value.crop || DEFAULT_CROP,
        hotspot: initialHotspotRef.current
      }, initialCursorRef.current, pointerPos, innerRect);
      onChange(result);
    } else if (dragTarget === "hotspotHandle") {
      const result_0 = handleHotspotResize({
        initialHotspot: initialHotspotRef.current,
        crop: value.crop || DEFAULT_CROP,
        initialCursor: initialCursorRef.current,
        pointerPos,
        innerRect
      });
      onChange(result_0);
    } else if (dragTarget === "crop") {
      const params = {
        initialCrop: initialCropRef.current,
        initialHotspot: initialHotspotRef.current,
        initialCursor: initialCursorRef.current,
        pointerPos,
        innerRect
      }, result_1 = handleCropMove(params);
      onChange(result_1);
    } else if (dragTarget === "cropHandle" && activeHandle) {
      const result_2 = handleCropHandleResize({
        initialCrop: initialCropRef.current,
        initialHotspot: initialHotspotRef.current,
        initialCursor: initialCursorRef.current,
        pointerPos,
        innerRect,
        activeHandle
      });
      onChange(result_2);
    }
  }, $[9] = activeHandle, $[10] = dragStart, $[11] = dragTarget, $[12] = innerRect, $[13] = onChange, $[14] = size, $[15] = svgRef, $[16] = value.crop, $[17] = t2) : t2 = $[17];
  const handlePointerMove = t2;
  let t3;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setDragTarget(null), setActiveHandle(null), setDragStart(null), initialCropRef.current = null, initialCursorRef.current = null, initialHotspotRef.current = null;
  }, $[18] = t3) : t3 = $[18];
  const resetDragState = t3;
  let t4;
  return $[19] !== activeHandle || $[20] !== dragStart || $[21] !== dragTarget || $[22] !== handlePointerDown || $[23] !== handlePointerMove ? (t4 = {
    dragTarget,
    activeHandle,
    dragStart,
    handlePointerDown,
    handlePointerMove,
    resetDragState
  }, $[19] = activeHandle, $[20] = dragStart, $[21] = dragTarget, $[22] = handlePointerDown, $[23] = handlePointerMove, $[24] = t4) : t4 = $[24], t4;
}
function useRectCalculations(t0) {
  const $ = c(29), {
    size,
    value
  } = t0;
  let t1;
  $[0] !== size.height || $[1] !== size.width ? (t1 = {
    left: 0,
    top: 0,
    width: size.width,
    height: size.height
  }, $[0] = size.height, $[1] = size.width, $[2] = t1) : t1 = $[2];
  const imageRect = t1, availableWidth = imageRect.width - MARGIN_SIZE * 2, availableHeight = imageRect.height - MARGIN_SIZE * 2, aspectRatio = imageRect.width / imageRect.height;
  let width, height;
  availableWidth / availableHeight > aspectRatio ? (height = availableHeight, width = height * aspectRatio) : (width = availableWidth, height = width / aspectRatio);
  const left = imageRect.left + (imageRect.width - width) / 2, top = imageRect.top + (imageRect.height - height) / 2;
  let t2;
  $[3] !== height || $[4] !== left || $[5] !== top || $[6] !== width ? (t2 = {
    left,
    top,
    width,
    height
  }, $[3] = height, $[4] = left, $[5] = top, $[6] = width, $[7] = t2) : t2 = $[7];
  const innerRect = t2, crop = value.crop || DEFAULT_CROP;
  let t3;
  $[8] !== crop ? (t3 = getCropDimensions(crop), $[8] = crop, $[9] = t3) : t3 = $[9];
  const dimensions = t3, t4 = innerRect.left + innerRect.width * crop.left, t5 = innerRect.top + innerRect.height * crop.top, t6 = innerRect.width * dimensions.width, t7 = innerRect.height * dimensions.height;
  let t8;
  $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7 ? (t8 = {
    left: t4,
    top: t5,
    width: t6,
    height: t7
  }, $[10] = t4, $[11] = t5, $[12] = t6, $[13] = t7, $[14] = t8) : t8 = $[14];
  const cropRect = t8, hotspot = value.hotspot || DEFAULT_HOTSPOT, crop_0 = value.crop || DEFAULT_CROP;
  let t9;
  $[15] !== crop_0 || $[16] !== hotspot ? (t9 = constrainHotspotToCrop(hotspot, crop_0), $[15] = crop_0, $[16] = hotspot, $[17] = t9) : t9 = $[17];
  const constrainedHotspot = t9, t10 = innerRect.left + innerRect.width * (constrainedHotspot.x - constrainedHotspot.width / 2), t11 = innerRect.top + innerRect.height * (constrainedHotspot.y - constrainedHotspot.height / 2), t12 = innerRect.width * constrainedHotspot.width, t13 = innerRect.height * constrainedHotspot.height;
  let t14;
  $[18] !== t10 || $[19] !== t11 || $[20] !== t12 || $[21] !== t13 ? (t14 = {
    left: t10,
    top: t11,
    width: t12,
    height: t13
  }, $[18] = t10, $[19] = t11, $[20] = t12, $[21] = t13, $[22] = t14) : t14 = $[22];
  const hotspotRect = t14;
  let t15;
  return $[23] !== constrainedHotspot || $[24] !== cropRect || $[25] !== hotspotRect || $[26] !== imageRect || $[27] !== innerRect ? (t15 = {
    imageRect,
    innerRect,
    cropRect,
    constrainedHotspot,
    hotspotRect
  }, $[23] = constrainedHotspot, $[24] = cropRect, $[25] = hotspotRect, $[26] = imageRect, $[27] = innerRect, $[28] = t15) : t15 = $[28], t15;
}
const SVGContainer = styled.div.withConfig({
  displayName: "SVGContainer",
  componentId: "sc-lsgs4f-0"
})`position:relative;display:flex;justify-content:center;align-items:center;width:100%;height:100%;overflow:visible;touch-action:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;user-select:none;-webkit-user-select:none;`, StyledSVG = styled.svg.withConfig({
  displayName: "StyledSVG",
  componentId: "sc-lsgs4f-1"
})`display:block;overflow:visible;shape-rendering:crispEdges;`, DarkenedOverlay = styled.rect.withConfig({
  displayName: "DarkenedOverlay",
  componentId: "sc-lsgs4f-2"
})`fill:rgba(0,0,0,0.5);pointer-events:none;`, getCropStrokeColor = (props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return props2.$focused ? color.focusRing : props2.$hovered ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, .5)";
}, getHotspotStrokeColor = (props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return props2.$focused ? color.focusRing : props2.$hovered ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, .5)";
}, getHandleStrokeColor = (props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return props2.$focused ? color.focusRing : "#000";
}, CropRect = styled.rect.withConfig({
  displayName: "CropRect",
  componentId: "sc-lsgs4f-3"
})`fill:none;stroke:${getCropStrokeColor};stroke-opacity:1;stroke-width:1px;outline:none;${(props2) => props2.$focused && css`
      stroke-width: 2px;
      filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.3));
    `}`, CropCornerHandle = styled.path.withConfig({
  displayName: "CropCornerHandle",
  componentId: "sc-lsgs4f-4"
})`fill:#fff;stroke:${getHandleStrokeColor};stroke-width:1;outline:none;`, CropEdgeHandle = styled.rect.withConfig({
  displayName: "CropEdgeHandle",
  componentId: "sc-lsgs4f-5"
})`fill:#fff;stroke:${getHandleStrokeColor};stroke-width:1;outline:none;`, HotspotEllipse = styled.ellipse.withConfig({
  displayName: "HotspotEllipse",
  componentId: "sc-lsgs4f-6"
})`fill:transparent;stroke:${getHotspotStrokeColor};stroke-opacity:1;stroke-width:1px;outline:none;${(props2) => props2.$focused && css`
      stroke-width: 2px;
    `}`, HotspotHandle = styled.circle.withConfig({
  displayName: "HotspotHandle",
  componentId: "sc-lsgs4f-7"
})`fill:#fff;stroke:${getHandleStrokeColor};stroke-width:1;outline:none;`, CropHandleInteractionArea = styled.rect.withConfig({
  displayName: "CropHandleInteractionArea",
  componentId: "sc-lsgs4f-8"
})`fill:transparent;stroke:transparent;pointer-events:all;`, HotspotHandleInteractionArea = styled.circle.withConfig({
  displayName: "HotspotHandleInteractionArea",
  componentId: "sc-lsgs4f-9"
})`fill:transparent;stroke:transparent;pointer-events:all;`, Guidelines = styled.g.withConfig({
  displayName: "Guidelines",
  componentId: "sc-lsgs4f-10"
})`${(props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return css`
      stroke: ${color.fg};
      stroke-opacity: 0.2;
      stroke-width: 1px;
      stroke-dasharray: 3, 3;
      pointer-events: none;
    `;
}}`, CropDimensionsBadgeGroup = styled.g.withConfig({
  displayName: "CropDimensionsBadgeGroup",
  componentId: "sc-lsgs4f-11"
})`opacity:${(props2) => props2.$visible ? 1 : 0};transition:opacity 0.15s;`, CropDimensionsBadgeRect = styled.rect.withConfig({
  displayName: "CropDimensionsBadgeRect",
  componentId: "sc-lsgs4f-12"
})`${(props2) => {
  const {
    color,
    radius
  } = getTheme_v2(props2.theme);
  return css`
      fill: ${color.focusRing};
      rx: ${radius[1]}px;
    `;
}}`, CropDimensionsBadgeText = styled.text.withConfig({
  displayName: "CropDimensionsBadgeText",
  componentId: "sc-lsgs4f-13"
})`${(props2) => {
  const {
    font
  } = getTheme_v2(props2.theme), textSize = font.text.sizes[0];
  return css`
      fill: #fff;
      font-family: ${font.text.family};
      font-size: ${textSize.fontSize}px;
      letter-spacing: ${textSize.letterSpacing}px;
      font-weight: ${font.text.weights.medium};
      pointer-events: none;
    `;
}}`, BADGE_PADDING_X = 6, BADGE_PADDING_Y = 3, BADGE_OFFSET_Y = 8, BADGE_CHAR_WIDTH_RATIO = 0.6;
function CropDimensionsBadge(props2) {
  const $ = c(20), {
    x,
    y,
    width,
    height,
    visible,
    onMouseEnter,
    onMouseLeave
  } = props2, theme = useTheme();
  let t0;
  $[0] !== theme ? (t0 = getTheme_v2(theme), $[0] = theme, $[1] = t0) : t0 = $[1];
  const {
    font
  } = t0, fontSize = font.text.sizes[1].fontSize, text = `${width} \xD7 ${height}`, badgeWidth = text.length * (fontSize * BADGE_CHAR_WIDTH_RATIO) + BADGE_PADDING_X * 2, badgeHeight = fontSize + BADGE_PADDING_Y * 2, t1 = `Cropped image size: ${width} \xD7 ${height} pixels`;
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx("title", { children: t1 }), $[2] = t1, $[3] = t2) : t2 = $[3];
  const t3 = x - badgeWidth / 2, t4 = y + BADGE_OFFSET_Y;
  let t5;
  $[4] !== badgeHeight || $[5] !== badgeWidth || $[6] !== t3 || $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(CropDimensionsBadgeRect, { x: t3, y: t4, width: badgeWidth, height: badgeHeight }), $[4] = badgeHeight, $[5] = badgeWidth, $[6] = t3, $[7] = t4, $[8] = t5) : t5 = $[8];
  const t6 = y + BADGE_OFFSET_Y + badgeHeight / 2;
  let t7;
  $[9] !== t6 || $[10] !== text || $[11] !== x ? (t7 = /* @__PURE__ */ jsx(CropDimensionsBadgeText, { x, y: t6, textAnchor: "middle", dominantBaseline: "central", children: text }), $[9] = t6, $[10] = text, $[11] = x, $[12] = t7) : t7 = $[12];
  let t8;
  return $[13] !== onMouseEnter || $[14] !== onMouseLeave || $[15] !== t2 || $[16] !== t5 || $[17] !== t7 || $[18] !== visible ? (t8 = /* @__PURE__ */ jsxs(CropDimensionsBadgeGroup, { $visible: visible, onMouseEnter, onMouseLeave, children: [
    t2,
    t5,
    t7
  ] }), $[13] = onMouseEnter, $[14] = onMouseLeave, $[15] = t2, $[16] = t5, $[17] = t7, $[18] = visible, $[19] = t8) : t8 = $[19], t8;
}
function ToolSVGComponent(props2) {
  const $ = c(257), {
    value,
    image,
    onChange,
    onChangeEnd,
    readOnly,
    size
  } = props2, svgRef = useRef(null), cropRef = useRef(null), hotspotRef = useRef(null), [focusTarget, setFocusTarget] = useState(null);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = uuid(), $[0] = t0) : t0 = $[0];
  const hotspotClipId = `hotspotClip-${t0}`;
  let t1, t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    const svgElement = svgRef.current;
    if (!svgElement)
      return;
    const handleTouchMove = _temp$2w;
    return svgElement.addEventListener("touchmove", handleTouchMove, {
      passive: !1
    }), () => {
      svgElement.removeEventListener("touchmove", handleTouchMove);
    };
  }, t2 = [], $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]), useEffect(t1, t2);
  let t3;
  $[3] !== size || $[4] !== value ? (t3 = {
    size,
    value
  }, $[3] = size, $[4] = value, $[5] = t3) : t3 = $[5];
  const {
    innerRect,
    cropRect,
    constrainedHotspot,
    hotspotRect
  } = useRectCalculations(t3), {
    hoverTarget,
    handleMouseEnter,
    handleMouseLeave,
    handleHotspotMouseEnter,
    handleHotspotHandleMouseEnter,
    handleCropMouseEnter,
    getCropHandleMouseEnter
  } = useHoverHandlers();
  let t4;
  $[6] !== innerRect || $[7] !== onChange || $[8] !== readOnly || $[9] !== size || $[10] !== value ? (t4 = {
    value,
    onChange,
    innerRect,
    svgRef,
    size,
    readOnly,
    hotspotRef,
    cropRef
  }, $[6] = innerRect, $[7] = onChange, $[8] = readOnly, $[9] = size, $[10] = value, $[11] = t4) : t4 = $[11];
  const {
    dragTarget,
    activeHandle,
    handlePointerDown,
    handlePointerMove,
    resetDragState
  } = usePointerHandlers(t4);
  let t5;
  $[12] !== focusTarget || $[13] !== innerRect || $[14] !== onChange || $[15] !== onChangeEnd || $[16] !== readOnly || $[17] !== value ? (t5 = {
    value,
    onChange,
    onChangeEnd,
    innerRect,
    focusTarget,
    readOnly
  }, $[12] = focusTarget, $[13] = innerRect, $[14] = onChange, $[15] = onChangeEnd, $[16] = readOnly, $[17] = value, $[18] = t5) : t5 = $[18];
  const {
    handleKeyDown,
    handleKeyUp
  } = useKeyboardControls(t5), crop = value.crop || DEFAULT_CROP;
  let t6;
  $[19] !== crop.left || $[20] !== crop.right || $[21] !== image.naturalWidth ? (t6 = Math.round(image.naturalWidth * (1 - crop.left - crop.right)), $[19] = crop.left, $[20] = crop.right, $[21] = image.naturalWidth, $[22] = t6) : t6 = $[22];
  const croppedWidth = t6;
  let t7;
  $[23] !== crop.bottom || $[24] !== crop.top || $[25] !== image.naturalHeight ? (t7 = Math.round(image.naturalHeight * (1 - crop.top - crop.bottom)), $[23] = crop.bottom, $[24] = crop.top, $[25] = image.naturalHeight, $[26] = t7) : t7 = $[26];
  const croppedHeight = t7;
  let t8;
  $[27] !== croppedHeight || $[28] !== croppedWidth ? (t8 = {
    width: croppedWidth,
    height: croppedHeight
  }, $[27] = croppedHeight, $[28] = croppedWidth, $[29] = t8) : t8 = $[29];
  const croppedDimensions = t8;
  let t9;
  $[30] !== cropRect ? (t9 = calculateCropHandles(cropRect), $[30] = cropRect, $[31] = t9) : t9 = $[31];
  const cropHandles = t9;
  let t10;
  $[32] !== hotspotRect ? (t10 = getHotspotHandlePosition(hotspotRect), $[32] = hotspotRect, $[33] = t10) : t10 = $[33];
  let t11;
  $[34] !== t10 ? (t11 = {
    ...t10,
    radius: HANDLE_VISUAL_SIZE_HOTSPOT / 2,
    hitRadius: HANDLE_INTERACTIVE_SIZE / 2
  }, $[34] = t10, $[35] = t11) : t11 = $[35];
  const hotspotHandlePosition = t11;
  let t12;
  $[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = (target) => {
    setFocusTarget(target);
  }, $[36] = t12) : t12 = $[36];
  const handleFocus = t12;
  let t13;
  $[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = () => {
    setFocusTarget(null);
  }, $[37] = t13) : t13 = $[37];
  const handleBlur = t13;
  let t14;
  $[38] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t14 = () => handleFocus("hotspot"), $[38] = t14) : t14 = $[38];
  const handleHotspotFocus = t14;
  let t15;
  $[39] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = () => handleBlur(), $[39] = t15) : t15 = $[39];
  const handleHotspotBlur = t15;
  let t16;
  $[40] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = () => handleFocus("crop"), $[40] = t16) : t16 = $[40];
  const handleCropFocus = t16;
  let t17;
  $[41] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t17 = () => handleBlur(), $[41] = t17) : t17 = $[41];
  const handleCropBlur = t17;
  let t18;
  $[42] !== constrainedHotspot || $[43] !== dragTarget || $[44] !== onChangeEnd || $[45] !== resetDragState || $[46] !== value.crop || $[47] !== value.hotspot ? (t18 = (e_0) => {
    const svg = svgRef.current;
    svg && (dragTarget && (dragTarget === "hotspot" || dragTarget === "hotspotHandle" ? onChangeEnd({
      hotspot: constrainedHotspot,
      crop: value.crop || DEFAULT_CROP
    }) : (dragTarget === "crop" || dragTarget === "cropHandle") && onChangeEnd({
      crop: value.crop || DEFAULT_CROP,
      hotspot: value.hotspot || DEFAULT_HOTSPOT
    })), svg.releasePointerCapture(e_0.pointerId), resetDragState());
  }, $[42] = constrainedHotspot, $[43] = dragTarget, $[44] = onChangeEnd, $[45] = resetDragState, $[46] = value.crop, $[47] = value.hotspot, $[48] = t18) : t18 = $[48];
  const handlePointerUp = t18;
  let t19;
  $[49] !== activeHandle || $[50] !== dragTarget || $[51] !== hoverTarget ? (t19 = calculateCurrentCursor(dragTarget, activeHandle, hoverTarget), $[49] = activeHandle, $[50] = dragTarget, $[51] = hoverTarget, $[52] = t19) : t19 = $[52];
  const currentCursor = t19;
  let t20;
  $[53] !== handleMouseEnter ? (t20 = () => handleMouseEnter("crop"), $[53] = handleMouseEnter, $[54] = t20) : t20 = $[54];
  const handleCropEnter = t20;
  let t21;
  $[55] !== hoverTarget ? (t21 = (handleId) => hoverTarget ? hoverTarget === "crop" ? !0 : hoverTarget === `crop-${handleId}` : !1, $[55] = hoverTarget, $[56] = t21) : t21 = $[56];
  const isHandleHovered = t21, t22 = `0 0 ${size.width} ${size.height}`, t23 = readOnly ? "default" : currentCursor, t24 = `${size.width}px`, t25 = `${size.height}px`;
  let t26;
  $[57] !== t23 || $[58] !== t24 || $[59] !== t25 ? (t26 = {
    cursor: t23,
    width: t24,
    height: t25
  }, $[57] = t23, $[58] = t24, $[59] = t25, $[60] = t26) : t26 = $[60];
  let t27;
  $[61] !== image.src || $[62] !== innerRect.height || $[63] !== innerRect.left || $[64] !== innerRect.top || $[65] !== innerRect.width ? (t27 = /* @__PURE__ */ jsx("image", { href: image.src, x: innerRect.left, y: innerRect.top, width: innerRect.width, height: innerRect.height, opacity: 0.25, preserveAspectRatio: "xMidYMid meet" }), $[61] = image.src, $[62] = innerRect.height, $[63] = innerRect.left, $[64] = innerRect.top, $[65] = innerRect.width, $[66] = t27) : t27 = $[66];
  const t28 = -cropRect.left + innerRect.left, t29 = -cropRect.top + innerRect.top;
  let t30;
  $[67] !== image.src || $[68] !== innerRect.height || $[69] !== innerRect.width || $[70] !== t28 || $[71] !== t29 ? (t30 = /* @__PURE__ */ jsx("image", { href: image.src, x: t28, y: t29, width: innerRect.width, height: innerRect.height, preserveAspectRatio: "xMidYMid meet" }), $[67] = image.src, $[68] = innerRect.height, $[69] = innerRect.width, $[70] = t28, $[71] = t29, $[72] = t30) : t30 = $[72];
  let t31;
  $[73] !== cropRect.height || $[74] !== cropRect.width ? (t31 = /* @__PURE__ */ jsx(DarkenedOverlay, { x: "0", y: "0", width: cropRect.width, height: cropRect.height }), $[73] = cropRect.height, $[74] = cropRect.width, $[75] = t31) : t31 = $[75];
  let t32;
  $[76] !== cropRect.height || $[77] !== cropRect.width || $[78] !== handleCropMouseEnter || $[79] !== handlePointerDown ? (t32 = /* @__PURE__ */ jsx("rect", { x: "0", y: "0", width: cropRect.width, height: cropRect.height, fill: "transparent", "data-handle": "crop", onPointerDown: handlePointerDown, onMouseEnter: handleCropMouseEnter }), $[76] = cropRect.height, $[77] = cropRect.width, $[78] = handleCropMouseEnter, $[79] = handlePointerDown, $[80] = t32) : t32 = $[80];
  let t33;
  $[81] !== cropRect.height || $[82] !== cropRect.left || $[83] !== cropRect.top || $[84] !== cropRect.width || $[85] !== handleCropMouseEnter || $[86] !== handleMouseLeave || $[87] !== handlePointerDown || $[88] !== t30 || $[89] !== t31 || $[90] !== t32 ? (t33 = /* @__PURE__ */ jsxs("svg", { x: cropRect.left, y: cropRect.top, width: cropRect.width, height: cropRect.height, overflow: "hidden", "data-handle": "crop", onPointerDown: handlePointerDown, onMouseEnter: handleCropMouseEnter, onMouseLeave: handleMouseLeave, children: [
    t30,
    t31,
    t32
  ] }), $[81] = cropRect.height, $[82] = cropRect.left, $[83] = cropRect.top, $[84] = cropRect.width, $[85] = handleCropMouseEnter, $[86] = handleMouseLeave, $[87] = handlePointerDown, $[88] = t30, $[89] = t31, $[90] = t32, $[91] = t33) : t33 = $[91];
  let t34;
  $[92] !== hotspotRect ? (t34 = getRectCenterX(hotspotRect), $[92] = hotspotRect, $[93] = t34) : t34 = $[93];
  let t35;
  $[94] !== hotspotRect ? (t35 = getRectCenterY(hotspotRect), $[94] = hotspotRect, $[95] = t35) : t35 = $[95];
  const t36 = hotspotRect.width / 2, t37 = hotspotRect.height / 2;
  let t38;
  $[96] !== t34 || $[97] !== t35 || $[98] !== t36 || $[99] !== t37 ? (t38 = /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: hotspotClipId, children: /* @__PURE__ */ jsx("ellipse", { cx: t34, cy: t35, rx: t36, ry: t37 }) }) }), $[96] = t34, $[97] = t35, $[98] = t36, $[99] = t37, $[100] = t38) : t38 = $[100];
  let t39;
  $[101] !== image.src || $[102] !== innerRect.height || $[103] !== innerRect.left || $[104] !== innerRect.top || $[105] !== innerRect.width ? (t39 = /* @__PURE__ */ jsx("image", { href: image.src, x: innerRect.left, y: innerRect.top, width: innerRect.width, height: innerRect.height, clipPath: `url(#${hotspotClipId})`, preserveAspectRatio: "xMidYMid meet" }), $[101] = image.src, $[102] = innerRect.height, $[103] = innerRect.left, $[104] = innerRect.top, $[105] = innerRect.width, $[106] = t39) : t39 = $[106];
  let t40;
  $[107] !== hotspotRect ? (t40 = getRectCenterX(hotspotRect), $[107] = hotspotRect, $[108] = t40) : t40 = $[108];
  let t41;
  $[109] !== hotspotRect ? (t41 = getRectCenterY(hotspotRect), $[109] = hotspotRect, $[110] = t41) : t41 = $[110];
  const t42 = Math.max(0.01, hotspotRect.width / 2), t43 = Math.max(0.01, hotspotRect.height / 2), t44 = !readOnly && (hoverTarget === "hotspot" || hoverTarget === "hotspotHandle" || dragTarget === "hotspot" || dragTarget === "hotspotHandle"), t45 = !readOnly && focusTarget === "hotspot", t46 = readOnly ? -1 : 0;
  let t47;
  $[111] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t47 = {
    pointerEvents: "visiblePainted"
  }, $[111] = t47) : t47 = $[111];
  let t48;
  $[112] !== handleHotspotMouseEnter || $[113] !== handleKeyDown || $[114] !== handleKeyUp || $[115] !== handleMouseLeave || $[116] !== handlePointerDown || $[117] !== t40 || $[118] !== t41 || $[119] !== t42 || $[120] !== t43 || $[121] !== t44 || $[122] !== t45 || $[123] !== t46 ? (t48 = /* @__PURE__ */ jsx(HotspotEllipse, { ref: hotspotRef, cx: t40, cy: t41, rx: t42, ry: t43, $hovered: t44, $focused: t45, "data-handle": "hotspot", onPointerDown: handlePointerDown, tabIndex: t46, onMouseEnter: handleHotspotMouseEnter, onMouseLeave: handleMouseLeave, onFocus: handleHotspotFocus, onBlur: handleHotspotBlur, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp, style: t47 }), $[112] = handleHotspotMouseEnter, $[113] = handleKeyDown, $[114] = handleKeyUp, $[115] = handleMouseLeave, $[116] = handlePointerDown, $[117] = t40, $[118] = t41, $[119] = t42, $[120] = t43, $[121] = t44, $[122] = t45, $[123] = t46, $[124] = t48) : t48 = $[124];
  let t49;
  $[125] !== dragTarget || $[126] !== focusTarget || $[127] !== handleHotspotHandleMouseEnter || $[128] !== handleMouseLeave || $[129] !== handlePointerDown || $[130] !== hotspotHandlePosition || $[131] !== hoverTarget || $[132] !== readOnly ? (t49 = !readOnly && /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx(HotspotHandleInteractionArea, { cx: hotspotHandlePosition.x, cy: hotspotHandlePosition.y, r: hotspotHandlePosition.hitRadius, "data-handle": "hotspotHandle", onPointerDown: handlePointerDown, onMouseEnter: handleHotspotHandleMouseEnter, onMouseLeave: handleMouseLeave, style: {
      pointerEvents: "visiblePainted"
    } }),
    /* @__PURE__ */ jsx(HotspotHandle, { cx: hotspotHandlePosition.x, cy: hotspotHandlePosition.y, r: hotspotHandlePosition.radius, $hovered: !readOnly && (hoverTarget === "hotspot" || hoverTarget === "hotspotHandle" || dragTarget === "hotspot" || dragTarget === "hotspotHandle"), $focused: !readOnly && focusTarget === "hotspot", pointerEvents: "none" })
  ] }), $[125] = dragTarget, $[126] = focusTarget, $[127] = handleHotspotHandleMouseEnter, $[128] = handleMouseLeave, $[129] = handlePointerDown, $[130] = hotspotHandlePosition, $[131] = hoverTarget, $[132] = readOnly, $[133] = t49) : t49 = $[133];
  let t50;
  $[134] !== t48 || $[135] !== t49 ? (t50 = /* @__PURE__ */ jsxs("g", { children: [
    t48,
    t49
  ] }), $[134] = t48, $[135] = t49, $[136] = t50) : t50 = $[136];
  let t51;
  $[137] !== hotspotRect ? (t51 = getRectCenterX(hotspotRect), $[137] = hotspotRect, $[138] = t51) : t51 = $[138];
  const t52 = innerRect.top;
  let t53;
  $[139] !== hotspotRect ? (t53 = getRectCenterX(hotspotRect), $[139] = hotspotRect, $[140] = t53) : t53 = $[140];
  let t54;
  $[141] !== innerRect ? (t54 = getRectBottom(innerRect), $[141] = innerRect, $[142] = t54) : t54 = $[142];
  let t55;
  $[143] !== innerRect.top || $[144] !== t51 || $[145] !== t53 || $[146] !== t54 ? (t55 = /* @__PURE__ */ jsx("line", { x1: t51, y1: t52, x2: t53, y2: t54 }), $[143] = innerRect.top, $[144] = t51, $[145] = t53, $[146] = t54, $[147] = t55) : t55 = $[147];
  const t56 = innerRect.left;
  let t57;
  $[148] !== hotspotRect ? (t57 = getRectCenterY(hotspotRect), $[148] = hotspotRect, $[149] = t57) : t57 = $[149];
  let t58;
  $[150] !== innerRect ? (t58 = getRectRight(innerRect), $[150] = innerRect, $[151] = t58) : t58 = $[151];
  let t59;
  $[152] !== hotspotRect ? (t59 = getRectCenterY(hotspotRect), $[152] = hotspotRect, $[153] = t59) : t59 = $[153];
  let t60;
  $[154] !== innerRect.left || $[155] !== t57 || $[156] !== t58 || $[157] !== t59 ? (t60 = /* @__PURE__ */ jsx("line", { x1: t56, y1: t57, x2: t58, y2: t59 }), $[154] = innerRect.left, $[155] = t57, $[156] = t58, $[157] = t59, $[158] = t60) : t60 = $[158];
  const t61 = hotspotRect.left, t62 = innerRect.top, t63 = hotspotRect.left;
  let t64;
  $[159] !== innerRect ? (t64 = getRectBottom(innerRect), $[159] = innerRect, $[160] = t64) : t64 = $[160];
  let t65;
  $[161] !== hotspotRect.left || $[162] !== innerRect.top || $[163] !== t64 ? (t65 = /* @__PURE__ */ jsx("line", { x1: t61, y1: t62, x2: t63, y2: t64 }), $[161] = hotspotRect.left, $[162] = innerRect.top, $[163] = t64, $[164] = t65) : t65 = $[164];
  let t66;
  $[165] !== hotspotRect ? (t66 = getRectRight(hotspotRect), $[165] = hotspotRect, $[166] = t66) : t66 = $[166];
  const t67 = innerRect.top;
  let t68;
  $[167] !== hotspotRect ? (t68 = getRectRight(hotspotRect), $[167] = hotspotRect, $[168] = t68) : t68 = $[168];
  let t69;
  $[169] !== innerRect ? (t69 = getRectBottom(innerRect), $[169] = innerRect, $[170] = t69) : t69 = $[170];
  let t70;
  $[171] !== innerRect.top || $[172] !== t66 || $[173] !== t68 || $[174] !== t69 ? (t70 = /* @__PURE__ */ jsx("line", { x1: t66, y1: t67, x2: t68, y2: t69 }), $[171] = innerRect.top, $[172] = t66, $[173] = t68, $[174] = t69, $[175] = t70) : t70 = $[175];
  const t71 = innerRect.left, t72 = hotspotRect.top;
  let t73;
  $[176] !== innerRect ? (t73 = getRectRight(innerRect), $[176] = innerRect, $[177] = t73) : t73 = $[177];
  let t74;
  $[178] !== hotspotRect.top || $[179] !== innerRect.left || $[180] !== t73 ? (t74 = /* @__PURE__ */ jsx("line", { x1: t71, y1: t72, x2: t73, y2: hotspotRect.top }), $[178] = hotspotRect.top, $[179] = innerRect.left, $[180] = t73, $[181] = t74) : t74 = $[181];
  const t75 = innerRect.left;
  let t76;
  $[182] !== hotspotRect ? (t76 = getRectBottom(hotspotRect), $[182] = hotspotRect, $[183] = t76) : t76 = $[183];
  let t77;
  $[184] !== innerRect ? (t77 = getRectRight(innerRect), $[184] = innerRect, $[185] = t77) : t77 = $[185];
  let t78;
  $[186] !== hotspotRect ? (t78 = getRectBottom(hotspotRect), $[186] = hotspotRect, $[187] = t78) : t78 = $[187];
  let t79;
  $[188] !== innerRect.left || $[189] !== t76 || $[190] !== t77 || $[191] !== t78 ? (t79 = /* @__PURE__ */ jsx("line", { x1: t75, y1: t76, x2: t77, y2: t78 }), $[188] = innerRect.left, $[189] = t76, $[190] = t77, $[191] = t78, $[192] = t79) : t79 = $[192];
  let t80;
  $[193] !== t55 || $[194] !== t60 || $[195] !== t65 || $[196] !== t70 || $[197] !== t74 || $[198] !== t79 ? (t80 = /* @__PURE__ */ jsxs(Guidelines, { children: [
    t55,
    t60,
    t65,
    t70,
    t74,
    t79
  ] }), $[193] = t55, $[194] = t60, $[195] = t65, $[196] = t70, $[197] = t74, $[198] = t79, $[199] = t80) : t80 = $[199];
  let t81;
  $[200] !== dragTarget || $[201] !== hoverTarget || $[202] !== readOnly ? (t81 = !readOnly && (hoverTarget === "crop" || !!hoverTarget?.startsWith("crop-") || dragTarget === "crop" || dragTarget === "cropHandle"), $[200] = dragTarget, $[201] = hoverTarget, $[202] = readOnly, $[203] = t81) : t81 = $[203];
  const t82 = !readOnly && focusTarget === "crop", t83 = readOnly ? -1 : 0;
  let t84;
  $[204] !== cropRect.height || $[205] !== cropRect.left || $[206] !== cropRect.top || $[207] !== cropRect.width || $[208] !== handleCropEnter || $[209] !== handleKeyDown || $[210] !== handleKeyUp || $[211] !== handleMouseLeave || $[212] !== handlePointerDown || $[213] !== t81 || $[214] !== t82 || $[215] !== t83 ? (t84 = /* @__PURE__ */ jsx(CropRect, { ref: cropRef, x: cropRect.left, y: cropRect.top, width: cropRect.width, height: cropRect.height, $hovered: t81, $focused: t82, "data-handle": "crop", onPointerDown: handlePointerDown, tabIndex: t83, onMouseEnter: handleCropEnter, onMouseLeave: handleMouseLeave, onFocus: handleCropFocus, onBlur: handleCropBlur, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp }), $[204] = cropRect.height, $[205] = cropRect.left, $[206] = cropRect.top, $[207] = cropRect.width, $[208] = handleCropEnter, $[209] = handleKeyDown, $[210] = handleKeyUp, $[211] = handleMouseLeave, $[212] = handlePointerDown, $[213] = t81, $[214] = t82, $[215] = t83, $[216] = t84) : t84 = $[216];
  let t85;
  $[217] !== cropHandles || $[218] !== focusTarget || $[219] !== getCropHandleMouseEnter || $[220] !== handleMouseLeave || $[221] !== handlePointerDown || $[222] !== isHandleHovered || $[223] !== readOnly ? (t85 = !readOnly && Object.entries(cropHandles).map((t862) => {
    const [key, handle] = t862;
    return /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx(CropHandleInteractionArea, { x: handle.hit.left, y: handle.hit.top, width: handle.hit.width, height: handle.hit.height, "data-handle": `crop-${key}`, onPointerDown: handlePointerDown, onMouseEnter: getCropHandleMouseEnter(key), onMouseLeave: handleMouseLeave, style: {
        pointerEvents: "all"
      } }),
      ["topLeft", "topRight", "bottomLeft", "bottomRight"].includes(key) ? /* @__PURE__ */ jsx("g", { transform: `translate(${handle.position?.x ?? 0}, ${handle.position?.y ?? 0}) rotate(${handle.rotation ?? 0})`, children: /* @__PURE__ */ jsx(CropCornerHandle, { d: handle.path, $hovered: !readOnly && isHandleHovered(key), $focused: !readOnly && focusTarget === "crop", pointerEvents: "none" }) }) : /* @__PURE__ */ jsx(CropEdgeHandle, { x: handle.visual.left, y: handle.visual.top, width: handle.visual.width, height: handle.visual.height, $hovered: !readOnly && isHandleHovered(key), $focused: !readOnly && focusTarget === "crop", pointerEvents: "none" })
    ] }, key);
  }), $[217] = cropHandles, $[218] = focusTarget, $[219] = getCropHandleMouseEnter, $[220] = handleMouseLeave, $[221] = handlePointerDown, $[222] = isHandleHovered, $[223] = readOnly, $[224] = t85) : t85 = $[224];
  let t86;
  $[225] !== cropRect ? (t86 = getRectCenterX(cropRect), $[225] = cropRect, $[226] = t86) : t86 = $[226];
  let t87;
  $[227] !== cropRect ? (t87 = getRectBottom(cropRect), $[227] = cropRect, $[228] = t87) : t87 = $[228];
  let t88;
  $[229] !== dragTarget || $[230] !== focusTarget || $[231] !== hoverTarget ? (t88 = hoverTarget === "crop" || !!hoverTarget?.startsWith("crop-") || dragTarget === "crop" || dragTarget === "cropHandle" || focusTarget === "crop", $[229] = dragTarget, $[230] = focusTarget, $[231] = hoverTarget, $[232] = t88) : t88 = $[232];
  let t89;
  $[233] !== croppedDimensions.height || $[234] !== croppedDimensions.width || $[235] !== handleCropMouseEnter || $[236] !== handleMouseLeave || $[237] !== t86 || $[238] !== t87 || $[239] !== t88 ? (t89 = /* @__PURE__ */ jsx(CropDimensionsBadge, { x: t86, y: t87, width: croppedDimensions.width, height: croppedDimensions.height, onMouseEnter: handleCropMouseEnter, onMouseLeave: handleMouseLeave, visible: t88 }), $[233] = croppedDimensions.height, $[234] = croppedDimensions.width, $[235] = handleCropMouseEnter, $[236] = handleMouseLeave, $[237] = t86, $[238] = t87, $[239] = t88, $[240] = t89) : t89 = $[240];
  let t90;
  $[241] !== t84 || $[242] !== t85 || $[243] !== t89 ? (t90 = /* @__PURE__ */ jsxs("g", { children: [
    t84,
    t85,
    t89
  ] }), $[241] = t84, $[242] = t85, $[243] = t89, $[244] = t90) : t90 = $[244];
  let t91;
  return $[245] !== handlePointerMove || $[246] !== handlePointerUp || $[247] !== t22 || $[248] !== t26 || $[249] !== t27 || $[250] !== t33 || $[251] !== t38 || $[252] !== t39 || $[253] !== t50 || $[254] !== t80 || $[255] !== t90 ? (t91 = /* @__PURE__ */ jsx(SVGContainer, { children: /* @__PURE__ */ jsxs(StyledSVG, { ref: svgRef, viewBox: t22, preserveAspectRatio: "xMidYMid", onPointerMove: handlePointerMove, onPointerUp: handlePointerUp, style: t26, children: [
    t27,
    t33,
    t38,
    t39,
    t50,
    t80,
    t90
  ] }) }), $[245] = handlePointerMove, $[246] = handlePointerUp, $[247] = t22, $[248] = t26, $[249] = t27, $[250] = t33, $[251] = t38, $[252] = t39, $[253] = t50, $[254] = t80, $[255] = t90, $[256] = t91) : t91 = $[256], t91;
}
function _temp$2w(e) {
  e.preventDefault();
}
const ToolSVG = memo(ToolSVGComponent);
function ImageTool(props2) {
  const $ = c(9), containerRef = useRef(null), [containerWidth, setContainerWidth] = useState(null), [containerHeight, setContainerHeight] = useState(null);
  let t0, t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    if (!containerRef.current)
      return;
    const updateSize = (entry) => {
      setContainerWidth(entry.contentRect.width), setContainerHeight(entry.contentRect.height);
    };
    return containerRef.current && (setContainerWidth(containerRef.current.clientWidth), setContainerHeight(containerRef.current.clientHeight)), resizeObserver.observe(containerRef.current, updateSize);
  }, t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useLayoutEffect(t0, t1);
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    position: "relative",
    width: "100%",
    height: "100%"
  }, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== containerHeight || $[4] !== containerWidth || $[5] !== props2 ? (t3 = containerWidth !== null && containerHeight !== null && /* @__PURE__ */ jsx(ImageLoader, { src: props2.src, children: (t42) => {
    const {
      isLoading,
      image,
      error
    } = t42;
    return isLoading ? /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) : error ? /* @__PURE__ */ jsx("div", { children: error.message }) : image ? /* @__PURE__ */ jsx(ResizeSVG, { image, maxHeight: containerHeight, maxWidth: containerWidth, children: (size) => /* @__PURE__ */ jsx(ToolSVG, { ...props2, image, size }) }) : null;
  } }), $[3] = containerHeight, $[4] = containerWidth, $[5] = props2, $[6] = t3) : t3 = $[6];
  let t4;
  return $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx("div", { ref: containerRef, style: t2, children: t3 }), $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
const PROBABLY_THE_TINIEST_GIF_EVER = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
function isBlob(src) {
  return src.startsWith("blob:");
}
function loadImage(src) {
  return new Observable((subscriber) => {
    const image = document.createElement("img");
    let completed = !1;
    const onload = () => {
      completed = !0, subscriber.next(image), subscriber.complete();
    }, onerror = () => {
      completed = !0, subscriber.error(new Error(`Could not load image from ${isBlob(src) ? "blob" : src}`));
    };
    return image.onload = onload, image.onerror = onerror, image.src = src, () => {
      image.onload = null, image.onerror = null, completed || (image.src = PROBABLY_THE_TINIEST_GIF_EVER);
    };
  });
}
const INITIAL_STATE$7 = {
  isLoading: !0
};
function useLoadImage(url) {
  const $ = c(3), [state, setState] = useState(INITIAL_STATE$7);
  let t0, t1;
  return $[0] !== url ? (t0 = () => {
    setState(INITIAL_STATE$7);
    const subscription = loadImage(url).subscribe({
      error: (err) => {
        setState({
          isLoading: !1,
          error: err
        });
      },
      next: (image) => {
        setState({
          image,
          isLoading: !1
        });
      }
    });
    return () => {
      subscription.unsubscribe();
    };
  }, t1 = [url], $[0] = url, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1), state;
}
const HOTSPOT_PATH = ["hotspot"], DEFAULT_PREVIEWS = [{
  title: "3:4",
  aspectRatio: 3 / 4
}, {
  title: "Square",
  aspectRatio: 1 / 1
}, {
  title: "16:9",
  aspectRatio: 16 / 9
}, {
  title: "Panorama",
  aspectRatio: 4 / 1
}], DEFAULT_VALUE = {
  crop: DEFAULT_CROP,
  hotspot: DEFAULT_HOTSPOT
}, Placeholder$2 = styled.div.withConfig({
  displayName: "Placeholder",
  componentId: "sc-68r3g9-0"
})`min-height:6em;`;
function LoadStatus(props2) {
  const $ = c(3);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    overflowWrap: "break-word"
  }, $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] !== props2.children ? (t1 = /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", padding: 4, style: t0, children: props2.children }), $[1] = props2.children, $[2] = t1) : t1 = $[2], t1;
}
function ImageToolInput(props2) {
  const $ = c(61), {
    imageUrl,
    value,
    changed,
    level,
    path,
    focusPath: t0,
    presence,
    onChange,
    schemaType,
    onPathFocus,
    readOnly,
    elementProps: t1
  } = props2, focusPath = t0 === void 0 ? EMPTY_ARRAY$y : t0, {
    ref: forwardRef2
  } = t1, ref = useRef(null);
  let t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => ref.current, $[0] = t2) : t2 = $[0], useImperativeHandle(forwardRef2, t2);
  const [localValue, setLocalValue] = useState(value || DEFAULT_VALUE), {
    image,
    isLoading: isImageLoading,
    error: imageLoadError
  } = useLoadImage(imageUrl);
  let t3;
  $[1] !== onPathFocus ? (t3 = () => {
    onPathFocus(HOTSPOT_PATH);
  }, $[1] = onPathFocus, $[2] = t3) : t3 = $[2];
  const handleFocus = t3;
  let t4, t5;
  $[3] !== value ? (t4 = () => {
    setLocalValue(value || DEFAULT_VALUE);
  }, t5 = [value], $[3] = value, $[4] = t4, $[5] = t5) : (t4 = $[4], t5 = $[5]), useEffect(t4, t5);
  const hasFocus = focusPath[0] === "hotspot", hotspotPreviews = typeof schemaType.options?.hotspot == "object" && schemaType.options.hotspot.previews || DEFAULT_PREVIEWS;
  let t6;
  $[6] !== hasFocus ? (t6 = (hadFocus) => {
    !hadFocus && hasFocus && ref.current?.focus();
  }, $[6] = hasFocus, $[7] = t6) : t6 = $[7], useDidUpdate(hasFocus, t6);
  let t7;
  $[8] !== onChange || $[9] !== readOnly || $[10] !== schemaType.fields ? (t7 = (finalValue) => {
    if (readOnly)
      return;
    const cropField = schemaType.fields.find(_temp$2v), hotspotField = schemaType.fields.find(_temp2$12), crop = cropField ? {
      _type: cropField.type.name,
      ...finalValue.crop || DEFAULT_CROP
    } : finalValue.crop, hotspot = hotspotField ? {
      _type: hotspotField.type.name,
      ...finalValue.hotspot || DEFAULT_HOTSPOT
    } : finalValue.hotspot;
    onChange([set(crop, ["crop"]), set(hotspot, ["hotspot"])]);
  }, $[8] = onChange, $[9] = readOnly, $[10] = schemaType.fields, $[11] = t7) : t7 = $[11];
  const handleChangeEnd = t7;
  let t8;
  $[12] !== value?.asset?._ref ? (t8 = value?.asset?._ref?.split("-").at(-1), $[12] = value?.asset?._ref, $[13] = t8) : t8 = $[13];
  const isSvg = t8 === "svg", {
    t
  } = useTranslation();
  let t9;
  $[14] !== t ? (t9 = t("inputs.imagetool.title"), $[14] = t, $[15] = t9) : t9 = $[15];
  let t10;
  $[16] !== t ? (t10 = t("inputs.imagetool.description"), $[16] = t, $[17] = t10) : t10 = $[17];
  const t11 = schemaType.deprecated;
  let t12;
  $[18] !== isSvg || $[19] !== t ? (t12 = isSvg ? /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(Card, { padding: 3, marginY: 3, tone: "caution", radius: 2, children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("inputs.imagetool.vector-warning.title") }),
    /* @__PURE__ */ jsx(Details, { title: t("inputs.imagetool.vector-warning.expand-developer-info"), children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.imagetool.vector-warning.developer-info", components: {
      ImageUrlDocumentationLink: _temp3$x,
      ImageUrlPackageDocumentationLink: _temp4$f
    } }) }) })
  ] }) }) }) : null, $[18] = isSvg, $[19] = t, $[20] = t12) : t12 = $[20];
  let t13;
  $[21] !== path ? (t13 = path.concat(HOTSPOT_PATH), $[21] = path, $[22] = t13) : t13 = $[22];
  const t14 = focusPath[0] === "hotspot";
  let t15;
  $[23] !== imageLoadError || $[24] !== isImageLoading || $[25] !== t ? (t15 = (isImageLoading || imageLoadError) && /* @__PURE__ */ jsx(LoadStatus, { children: imageLoadError ? /* @__PURE__ */ jsx(Card, { padding: 4, radius: 2, tone: "critical", border: !0, children: /* @__PURE__ */ jsx(Text$1, { children: t("inputs.imagetool.load-error", {
    errorMessage: imageLoadError.message
  }) }) }) : /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) }), $[23] = imageLoadError, $[24] = isImageLoading, $[25] = t, $[26] = t15) : t15 = $[26];
  let t16;
  $[27] !== handleChangeEnd || $[28] !== image || $[29] !== isImageLoading || $[30] !== localValue || $[31] !== readOnly ? (t16 = !isImageLoading && image && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(ImageTool, { value: localValue, src: image.src, readOnly: !!readOnly, onChangeEnd: handleChangeEnd, onChange: setLocalValue }) }), $[27] = handleChangeEnd, $[28] = image, $[29] = isImageLoading, $[30] = localValue, $[31] = readOnly, $[32] = t16) : t16 = $[32];
  let t17;
  $[33] !== t15 || $[34] !== t16 ? (t17 = /* @__PURE__ */ jsxs(RatioBox$1, { ratio: 1.5, children: [
    t15,
    t16
  ] }), $[33] = t15, $[34] = t16, $[35] = t17) : t17 = $[35];
  let t18;
  $[36] !== changed || $[37] !== t13 || $[38] !== t14 || $[39] !== t17 ? (t18 = /* @__PURE__ */ jsx(ChangeIndicator, { path: t13, hasFocus: t14, isChanged: changed, children: t17 }), $[36] = changed, $[37] = t13, $[38] = t14, $[39] = t17, $[40] = t18) : t18 = $[40];
  let t19;
  $[41] !== handleFocus || $[42] !== t18 ? (t19 = /* @__PURE__ */ jsx(Card, { __unstable_checkered: !0, __unstable_focusRing: !0, tabIndex: 0, ref, onFocus: handleFocus, border: !0, children: t18 }), $[41] = handleFocus, $[42] = t18, $[43] = t19) : t19 = $[43];
  let t20;
  $[44] !== hotspotPreviews || $[45] !== image || $[46] !== isImageLoading || $[47] !== localValue ? (t20 = hotspotPreviews.length > 0 ? /* @__PURE__ */ jsx(Box, { marginTop: 2, children: /* @__PURE__ */ jsx(Grid, { columns: 4, gap: 1, children: hotspotPreviews.map((t212) => {
    const {
      title,
      aspectRatio
    } = t212;
    return /* @__PURE__ */ jsxs(Box, { marginTop: 2, children: [
      /* @__PURE__ */ jsx(Heading, { as: "h4", size: 0, children: title }),
      /* @__PURE__ */ jsx(Box, { marginTop: 2, children: /* @__PURE__ */ jsx(RatioBox$1, { ratio: aspectRatio, children: /* @__PURE__ */ jsx(Card, { __unstable_checkered: !0, border: !0, children: !isImageLoading && image ? /* @__PURE__ */ jsx(HotspotImage, { aspectRatio, src: image.src, srcAspectRatio: image.width / image.height, hotspot: localValue.hotspot || DEFAULT_HOTSPOT, crop: localValue.crop || DEFAULT_CROP }) : /* @__PURE__ */ jsx(Placeholder$2, {}) }) }) })
    ] }, title);
  }) }) }) : null, $[44] = hotspotPreviews, $[45] = image, $[46] = isImageLoading, $[47] = localValue, $[48] = t20) : t20 = $[48];
  let t21;
  $[49] !== t19 || $[50] !== t20 ? (t21 = /* @__PURE__ */ jsxs("div", { children: [
    t19,
    t20
  ] }), $[49] = t19, $[50] = t20, $[51] = t21) : t21 = $[51];
  let t22;
  return $[52] !== level || $[53] !== path || $[54] !== presence || $[55] !== schemaType.deprecated || $[56] !== t10 || $[57] !== t12 || $[58] !== t21 || $[59] !== t9 ? (t22 = /* @__PURE__ */ jsxs(FormField, { title: t9, level, description: t10, deprecated: t11, path, __unstable_presence: presence, children: [
    t12,
    t21
  ] }), $[52] = level, $[53] = path, $[54] = presence, $[55] = schemaType.deprecated, $[56] = t10, $[57] = t12, $[58] = t21, $[59] = t9, $[60] = t22) : t22 = $[60], t22;
}
function _temp4$f(t0) {
  const {
    children: children_0
  } = t0;
  return /* @__PURE__ */ jsx("a", { href: "https://www.sanity.io/docs/image-urls#fm-048ba39d9e88", children: /* @__PURE__ */ jsx("code", { children: children_0 }) });
}
function _temp3$x(t0) {
  const {
    children
  } = t0;
  return /* @__PURE__ */ jsx("a", { href: "https://www.sanity.io/docs/image-urls#fm-048ba39d9e88", children });
}
function _temp2$12(field_0) {
  return field_0.type.name !== "object" && field_0.name === "hotspot";
}
function _temp$2v(field) {
  return field.name === "crop" && field.type.name !== "object";
}
function ImageInputHotspotInput(props2) {
  const $ = c(19), {
    handleCloseDialog,
    inputProps,
    imageInputProps,
    isImageToolEnabled
  } = props2, {
    t
  } = useTranslation(), {
    changed,
    id: id2,
    imageUrlBuilder,
    value
  } = imageInputProps, withImageTool = isImageToolEnabled && value && value.asset;
  let t0;
  $[0] !== imageUrlBuilder || $[1] !== value ? (t0 = value?.asset ? imageUrlBuilder.image(value.asset).url() : "", $[0] = imageUrlBuilder, $[1] = value, $[2] = t0) : t0 = $[2];
  const imageUrl = t0;
  let t1;
  $[3] !== t ? (t1 = t("inputs.image.hotspot-dialog.title"), $[3] = t, $[4] = t1) : t1 = $[4];
  const t2 = `${id2}_dialog`;
  let t3;
  $[5] !== changed || $[6] !== imageInputProps || $[7] !== imageUrl || $[8] !== inputProps || $[9] !== value || $[10] !== withImageTool ? (t3 = withImageTool && value?.asset && /* @__PURE__ */ jsx(ImageToolInput, { ...imageInputProps, imageUrl, value, presence: inputProps.presence, changed }), $[5] = changed, $[6] = imageInputProps, $[7] = imageUrl, $[8] = inputProps, $[9] = value, $[10] = withImageTool, $[11] = t3) : t3 = $[11];
  let t4;
  $[12] !== t3 ? (t4 = /* @__PURE__ */ jsx(PresenceOverlay, { children: /* @__PURE__ */ jsx(Stack, { space: 5, children: t3 }) }), $[12] = t3, $[13] = t4) : t4 = $[13];
  let t5;
  return $[14] !== handleCloseDialog || $[15] !== t1 || $[16] !== t2 || $[17] !== t4 ? (t5 = /* @__PURE__ */ jsx(Dialog$1, { __unstable_autoFocus: !1, header: t1, id: t2, onClickOutside: handleCloseDialog, onClose: handleCloseDialog, width: 1, children: t4 }), $[14] = handleCloseDialog, $[15] = t1, $[16] = t2, $[17] = t4, $[18] = t5) : t5 = $[18], t5;
}
function ImagePreview$1(props2) {
  const $ = c(21);
  let rest, src, t0;
  $[0] !== props2 ? ({
    accessPolicy: t0,
    src,
    ...rest
  } = props2, $[0] = props2, $[1] = rest, $[2] = src, $[3] = t0) : (rest = $[1], src = $[2], t0 = $[3]);
  const accessPolicy = t0 === void 0 ? "public" : t0, [isLoaded, setLoaded] = useState(!1), [hasError, setHasError] = useState(!1);
  let t1;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setLoaded(!1), setHasError(!1);
  }, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== src ? (t2 = [src], $[5] = src, $[6] = t2) : t2 = $[6], useEffect(t1, t2);
  let t3;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setLoaded(!0), setHasError(!1);
  }, $[7] = t3) : t3 = $[7];
  const onLoadChange = t3;
  let t4;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setHasError(!0), setLoaded(!1);
  }, $[8] = t4) : t4 = $[8];
  const onErrorChange = t4, showAccessWarning = hasError && accessPolicy === "unknown", showLoading = !isLoaded && !showAccessWarning;
  let t5;
  $[9] !== showAccessWarning ? (t5 = showAccessWarning && /* @__PURE__ */ jsx(AccessWarningOverlay, {}), $[9] = showAccessWarning, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== showLoading ? (t6 = showLoading && /* @__PURE__ */ jsx(LoadingOverlay, {}), $[11] = showLoading, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== props2.alt || $[14] !== src ? (t7 = src && /* @__PURE__ */ jsx("img", { src, "data-testid": "hotspot-image-input", alt: props2.alt, onLoad: onLoadChange, onError: onErrorChange, referrerPolicy: "strict-origin-when-cross-origin" }), $[13] = props2.alt, $[14] = src, $[15] = t7) : t7 = $[15];
  let t8;
  return $[16] !== rest || $[17] !== t5 || $[18] !== t6 || $[19] !== t7 ? (t8 = /* @__PURE__ */ jsxs(RatioBox$2, { ...rest, tone: "transparent", children: [
    t5,
    t6,
    t7
  ] }), $[16] = rest, $[17] = t5, $[18] = t6, $[19] = t7, $[20] = t8) : t8 = $[20], t8;
}
function LoadingOverlay() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Overlay, { padding: 3, tone: "transparent", children: /* @__PURE__ */ jsx(FlexOverlay, { direction: "column", align: "center", justify: "center", children: /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) }) }), $[0] = t0) : t0 = $[0], t0;
}
function AccessWarningOverlay() {
  const $ = c(5), {
    t
  } = useTranslation();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(ErrorIconWrapper, { children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== t ? (t1 = t("inputs.image.error.possible-access-restriction"), $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Overlay, { padding: 3, tone: "critical", border: !0, children: /* @__PURE__ */ jsxs(FlexOverlay, { direction: "column", align: "center", justify: "center", gap: 2, children: [
    t0,
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t1 })
  ] }) }), $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
const CACHE_DISPOSE_DELAY = 2e3, requestCache = /* @__PURE__ */ new Map(), IDLE_RESULT = {
  error: null,
  isLoading: !1,
  objectUrl: void 0
}, LOADING_RESULT = {
  error: null,
  isLoading: !0,
  objectUrl: void 0
};
function createCacheKey(url, token) {
  if (!(!url || !token))
    return `${token}:${url}`;
}
function notifyListeners(entry) {
  entry.listeners.forEach((listener) => listener());
}
function deriveResultFromEntry(entry) {
  switch (entry.status) {
    case "pending":
      return entry.objectUrl ? {
        objectUrl: entry.objectUrl,
        isLoading: !0,
        error: null
      } : LOADING_RESULT;
    case "success":
      return {
        objectUrl: entry.objectUrl,
        isLoading: !1,
        error: null
      };
    case "error":
      return {
        objectUrl: void 0,
        isLoading: !1,
        error: entry.error
      };
    default:
      return IDLE_RESULT;
  }
}
function createFetchCacheEntry(url, token) {
  const abortController = new AbortController(), entry = {
    abortController,
    blob: null,
    cleanupTimer: void 0,
    error: null,
    listeners: /* @__PURE__ */ new Set(),
    objectUrl: void 0,
    status: "pending"
  };
  return fetch(url, {
    cache: "force-cache",
    headers: {
      Authorization: `Bearer ${token}`
    },
    signal: abortController.signal
  }).then((res) => {
    if (res.ok) return res.blob();
    throw new Error(`Failed to fetch image (HTTP ${res.status})`);
  }).then((blob) => {
    entry.blob = blob, entry.error = null, entry.status = "success", entry.objectUrl = URL.createObjectURL(blob), notifyListeners(entry);
  }).catch((error) => {
    entry.blob = null, entry.error = error, entry.status = "error", notifyListeners(entry);
  }), entry;
}
function useImageObjectUrl(url) {
  const $ = c(10), token = useToken();
  let t0;
  $[0] !== token || $[1] !== url ? (t0 = createCacheKey(url, token), $[0] = token, $[1] = url, $[2] = t0) : t0 = $[2];
  const cacheKey = t0;
  let t1;
  $[3] !== cacheKey ? (t1 = () => {
    if (!cacheKey)
      return IDLE_RESULT;
    const entry = requestCache.get(cacheKey);
    return entry ? deriveResultFromEntry(entry) : LOADING_RESULT;
  }, $[3] = cacheKey, $[4] = t1) : t1 = $[4];
  const [state, setState] = useState(t1);
  let t2, t3;
  return $[5] !== cacheKey || $[6] !== token || $[7] !== url ? (t2 = () => {
    if (!cacheKey) {
      setState(_temp$2u);
      return;
    }
    let entry_0 = requestCache.get(cacheKey);
    entry_0 || (entry_0 = createFetchCacheEntry(url, token), requestCache.set(cacheKey, entry_0)), entry_0.cleanupTimer && (clearTimeout(entry_0.cleanupTimer), entry_0.cleanupTimer = void 0);
    const updateState = () => setState(deriveResultFromEntry(entry_0));
    return updateState(), entry_0.listeners.add(updateState), () => {
      entry_0.listeners.delete(updateState), entry_0.listeners.size === 0 && (entry_0.cleanupTimer = setTimeout(() => {
        entry_0.abortController.abort(), entry_0.objectUrl && URL.revokeObjectURL(entry_0.objectUrl), requestCache.delete(cacheKey);
      }, CACHE_DISPOSE_DELAY));
    };
  }, t3 = [cacheKey, token, url], $[5] = cacheKey, $[6] = token, $[7] = url, $[8] = t2, $[9] = t3) : (t2 = $[8], t3 = $[9]), useEffect(t2, t3), state;
}
function _temp$2u(prev) {
  return prev.objectUrl || prev.isLoading || prev.error ? IDLE_RESULT : prev;
}
function useImageUrl(params) {
  const $ = c(10), {
    accessPolicy: t0,
    imageSource,
    imageUrlBuilder,
    transform
  } = params, accessPolicy = t0 === void 0 ? "public" : t0, isPolicyCheckInProgress = accessPolicy === "checking", isPrivate = accessPolicy === "private";
  let t1;
  bb0: {
    if (!imageSource || isPolicyCheckInProgress) {
      t1 = void 0;
      break bb0;
    }
    if (transform) {
      let t23;
      $[0] !== imageSource || $[1] !== imageUrlBuilder || $[2] !== transform ? (t23 = transform(imageUrlBuilder, imageSource), $[0] = imageSource, $[1] = imageUrlBuilder, $[2] = transform, $[3] = t23) : t23 = $[3], t1 = t23;
      break bb0;
    }
    let t22;
    $[4] !== imageSource || $[5] !== imageUrlBuilder ? (t22 = imageUrlBuilder.image(imageSource).url(), $[4] = imageSource, $[5] = imageUrlBuilder, $[6] = t22) : t22 = $[6], t1 = t22;
  }
  const networkUrl = t1, {
    objectUrl,
    isLoading: objectUrlIsLoading
  } = useImageObjectUrl(isPrivate ? networkUrl : void 0), isLoading = isPolicyCheckInProgress || objectUrlIsLoading, url = isLoading ? void 0 : objectUrl ?? networkUrl;
  let t2;
  return $[7] !== isLoading || $[8] !== url ? (t2 = {
    isLoading,
    url
  }, $[7] = isLoading, $[8] = url, $[9] = t2) : t2 = $[9], t2;
}
const ImageInputPreview = memo(function(props2) {
  const $ = c(6), {
    accessPolicy,
    handleOpenDialog,
    imageUrlBuilder,
    readOnly,
    value
  } = props2;
  let t0;
  return $[0] !== accessPolicy || $[1] !== handleOpenDialog || $[2] !== imageUrlBuilder || $[3] !== readOnly || $[4] !== value ? (t0 = /* @__PURE__ */ jsx(RenderImageInputPreview, { accessPolicy, handleOpenDialog, imageUrlBuilder, readOnly, value }), $[0] = accessPolicy, $[1] = handleOpenDialog, $[2] = imageUrlBuilder, $[3] = readOnly, $[4] = value, $[5] = t0) : t0 = $[5], t0;
});
function RenderImageInputPreview(props2) {
  const $ = c(15), {
    accessPolicy,
    handleOpenDialog,
    imageUrlBuilder,
    readOnly,
    value
  } = props2, {
    t
  } = useTranslation(), dpr = useDevicePixelRatio();
  let t0;
  $[0] !== dpr ? (t0 = (builder, val) => builder.width(2e3).fit("max").image(val).dpr(dpr).auto("format").url(), $[0] = dpr, $[1] = t0) : t0 = $[1];
  const transform = t0;
  let t1;
  $[2] !== accessPolicy || $[3] !== imageUrlBuilder || $[4] !== transform || $[5] !== value ? (t1 = {
    accessPolicy,
    imageSource: value,
    imageUrlBuilder,
    transform
  }, $[2] = accessPolicy, $[3] = imageUrlBuilder, $[4] = transform, $[5] = value, $[6] = t1) : t1 = $[6];
  const {
    url
  } = useImageUrl(t1);
  let t2;
  $[7] !== t ? (t2 = t("inputs.image.preview-uploaded-image"), $[7] = t, $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== accessPolicy || $[10] !== handleOpenDialog || $[11] !== readOnly || $[12] !== t2 || $[13] !== url ? (t3 = /* @__PURE__ */ jsx(ImagePreview$1, { alt: t2, accessPolicy, onDoubleClick: handleOpenDialog, readOnly, src: url }), $[9] = accessPolicy, $[10] = handleOpenDialog, $[11] = readOnly, $[12] = t2, $[13] = url, $[14] = t3) : t3 = $[14], t3;
}
function ImageInputUploadPlaceholderComponent(props2) {
  const $ = c(15), {
    assetSources,
    directUploads,
    disableNew,
    onOpenSourceForUpload,
    onSelectFile,
    readOnly,
    renderBrowser,
    schemaType
  } = props2;
  let t0;
  $[0] !== onSelectFile ? (t0 = (assetSource, files) => {
    onSelectFile(assetSource, files[0]);
  }, $[0] = onSelectFile, $[1] = t0) : t0 = $[1];
  const handleOnUpload = t0;
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    padding: 1
  }, $[2] = t1) : t1 = $[2];
  const t2 = readOnly ? "transparent" : "inherit";
  let t3;
  $[3] !== assetSources || $[4] !== directUploads || $[5] !== disableNew || $[6] !== handleOnUpload || $[7] !== onOpenSourceForUpload || $[8] !== readOnly || $[9] !== renderBrowser || $[10] !== schemaType ? (t3 = disableNew ? renderBrowser() : /* @__PURE__ */ jsx(UploadPlaceholder, { assetSources, browse: renderBrowser(), directUploads, onUpload: handleOnUpload, onOpenSourceForUpload, schemaType, readOnly, type: "image" }), $[3] = assetSources, $[4] = directUploads, $[5] = disableNew, $[6] = handleOnUpload, $[7] = onOpenSourceForUpload, $[8] = readOnly, $[9] = renderBrowser, $[10] = schemaType, $[11] = t3) : t3 = $[11];
  let t4;
  return $[12] !== t2 || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsx("div", { style: t1, children: /* @__PURE__ */ jsx(Card, { tone: t2, border: !0, paddingX: 3, paddingY: 2, radius: 2, children: t3 }) }), $[12] = t2, $[13] = t3, $[14] = t4) : t4 = $[14], t4;
}
const ImageInputUploadPlaceholder = memo(ImageInputUploadPlaceholderComponent);
function InvalidImageWarning(t0) {
  const $ = c(20), {
    onClearValue
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== t ? (t2 = t("inputs.image.invalid-image-warning.title"), $[1] = t, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t ? (t4 = t("inputs.image.invalid-image-warning.description"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t4 }), $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t3 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { gap: 4, marginBottom: 4, children: [
    t1,
    /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      t3,
      t5
    ] })
  ] }), $[9] = t3, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t ? (t7 = t("inputs.image.invalid-image-warning.reset-button.text"), $[12] = t, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== onClearValue || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { icon: ResetIcon, mode: "ghost", onClick: onClearValue, text: t7, width: "fill" }), $[14] = onClearValue, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  return $[17] !== t6 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Card, { "data-testid": "invalid-image-warning", tone: "caution", padding: 4, border: !0, radius: 2, children: [
    t6,
    t8
  ] }), $[17] = t6, $[18] = t8, $[19] = t9) : t9 = $[19], t9;
}
function BaseImageInputComponent(props2) {
  const $ = c(168), {
    assetSources,
    client,
    directUploads,
    elementProps,
    focusPath,
    imageUrlBuilder,
    members,
    observeAsset,
    onChange,
    onPathFocus,
    path,
    readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview: renderPreviewProp,
    resolveUploader: resolveUploader2,
    schemaType,
    value
  } = props2, {
    push
  } = useToast(), {
    t
  } = useTranslation(), renderedMembers = useRenderMembers(schemaType, members), [hotspotButtonElement, setHotspotButtonElement] = useState(null), [isMenuOpen, setMenuOpen] = useState(!1), {
    handleOpenDialog: handleAssetLimitUpsellDialog
  } = useAssetLimitsUpsellContext(), uploadSubscription = useRef(null);
  let t0;
  $[0] !== handleAssetLimitUpsellDialog ? (t0 = () => handleAssetLimitUpsellDialog("field_action"), $[0] = handleAssetLimitUpsellDialog, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setMenuOpen(!1), $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== client || $[4] !== onChange || $[5] !== schemaType || $[6] !== t0 ? (t2 = {
    client,
    onChange,
    schemaType,
    onAssetLimitError: t0,
    onAllComplete: t1
  }, $[3] = client, $[4] = onChange, $[5] = schemaType, $[6] = t0, $[7] = t2) : t2 = $[7];
  const {
    action: assetSourceAction,
    selectedAssetSource,
    openInSourceAsset,
    openForBrowse: handleSelectImageFromAssetSource,
    openForUpload: handleOpenSourceForUpload,
    openInSource: handleOpenInSource,
    changeAction: handleAssetSourceChangeAction,
    close: handleAssetSourceClosed,
    menuButtonRef,
    resetOnComplete: handleAssetSourceResetOnComplete,
    isUploading,
    setIsUploading,
    isStale,
    setIsStale,
    onStale: handleStaleUpload,
    assetSourceUploader,
    handleSelectFilesToUpload
  } = useAssetSource(t2);
  let t3;
  $[8] !== handleSelectFilesToUpload ? (t3 = (assetSource, file) => {
    handleSelectFilesToUpload(assetSource, [file]);
  }, $[8] = handleSelectFilesToUpload, $[9] = t3) : t3 = $[9];
  const handleSelectFileToUpload = t3;
  let t4;
  $[10] !== schemaType ? (t4 = () => {
    const hotspotOptions = get(schemaType, "options.hotspot");
    return typeof hotspotOptions == "object" || hotspotOptions === !0;
  }, $[10] = schemaType, $[11] = t4) : t4 = $[11];
  const isImageToolEnabled = t4;
  let t5;
  $[12] !== path ? (t5 = () => typeof path.slice(-1)[0] != "string", $[12] = path, $[13] = t5) : t5 = $[13];
  const valueIsArrayElement = t5;
  let t6;
  $[14] !== onChange || $[15] !== value?._upload ? (t6 = () => {
    value?._upload && onChange(unset(["_upload"]));
  }, $[14] = onChange, $[15] = value?._upload, $[16] = t6) : t6 = $[16];
  const clearUploadStatus = t6;
  let t7;
  $[17] !== clearUploadStatus ? (t7 = () => {
    uploadSubscription.current && (uploadSubscription.current.unsubscribe(), clearUploadStatus());
  }, $[17] = clearUploadStatus, $[18] = t7) : t7 = $[18];
  const cancelUpload = t7;
  let t8;
  $[19] !== cancelUpload || $[20] !== clearUploadStatus || $[21] !== client || $[22] !== onChange || $[23] !== push || $[24] !== schemaType || $[25] !== setIsUploading || $[26] !== t ? (t8 = (uploader, file_0, t92) => {
    const assetDocumentProps = t92 === void 0 ? {} : t92, {
      label,
      title,
      description,
      creditLine,
      source
    } = assetDocumentProps, options = {
      metadata: get(schemaType, "options.metadata"),
      storeOriginalFilename: get(schemaType, "options.storeOriginalFilename"),
      label,
      title,
      description,
      creditLine,
      source
    };
    cancelUpload(), setIsUploading(!0), onChange(setIfMissing({
      _type: schemaType.name
    })), uploadSubscription.current = uploader.upload(client, file_0, schemaType, options).subscribe({
      next: (uploadEvent) => {
        uploadEvent.patches && onChange(uploadEvent.patches);
      },
      error: (err) => {
        console.error(err), push({
          status: "error",
          description: t("inputs.image.upload-error.description"),
          title: t("inputs.image.upload-error.title")
        }), clearUploadStatus();
      },
      complete: () => {
        onChange([unset(["hotspot"]), unset(["crop"]), unset(["media"])]), setIsUploading(!1);
      }
    });
  }, $[19] = cancelUpload, $[20] = clearUploadStatus, $[21] = client, $[22] = onChange, $[23] = push, $[24] = schemaType, $[25] = setIsUploading, $[26] = t, $[27] = t8) : t8 = $[27];
  const uploadWith = t8;
  let t9;
  $[28] !== onChange ? (t9 = () => {
    onChange([unset(["asset"]), unset(["crop"]), unset(["hotspot"]), unset(["media"])]);
  }, $[28] = onChange, $[29] = t9) : t9 = $[29];
  const handleClearField = t9;
  let t10;
  $[30] !== onChange || $[31] !== value || $[32] !== valueIsArrayElement ? (t10 = () => {
    const allKeys = Object.keys(value || {}), isEmpty2 = allKeys.filter(_temp$2t).length === 0, removeKeys = ["asset", "media"].concat(allKeys.filter(_temp2$11)).map(_temp3$w);
    onChange(isEmpty2 && !valueIsArrayElement() ? unset() : removeKeys);
  }, $[30] = onChange, $[31] = value, $[32] = valueIsArrayElement, $[33] = t10) : t10 = $[33];
  const handleRemoveButtonClick = t10;
  let t11;
  $[34] !== onPathFocus ? (t11 = () => {
    onPathFocus(["hotspot"]);
  }, $[34] = onPathFocus, $[35] = t11) : t11 = $[35];
  const handleOpenDialog = t11;
  let t12;
  $[36] !== hotspotButtonElement || $[37] !== onPathFocus ? (t12 = () => {
    onPathFocus([]), hotspotButtonElement?.focus();
  }, $[36] = hotspotButtonElement, $[37] = onPathFocus, $[38] = t12) : t12 = $[38];
  const handleCloseDialog = t12;
  let t13;
  $[39] !== handleAssetSourceResetOnComplete || $[40] !== onChange || $[41] !== resolveUploader2 || $[42] !== schemaType || $[43] !== uploadWith ? (t13 = (assetsFromSource) => {
    handleSelectAssetFromSource({
      assetsFromSource,
      onChange,
      type: schemaType,
      resolveUploader: resolveUploader2,
      uploadWith
    }), handleAssetSourceResetOnComplete();
  }, $[39] = handleAssetSourceResetOnComplete, $[40] = onChange, $[41] = resolveUploader2, $[42] = schemaType, $[43] = uploadWith, $[44] = t13) : t13 = $[44];
  const handleSelectAssetFromSource$1 = t13;
  let t14;
  $[45] !== assetSourceUploader?.uploader || $[46] !== cancelUpload ? (t14 = () => {
    cancelUpload(), assetSourceUploader?.uploader?.abort();
  }, $[45] = assetSourceUploader?.uploader, $[46] = cancelUpload, $[47] = t14) : t14 = $[47];
  const handleCancelUpload = t14;
  let t15;
  $[48] !== clearUploadStatus || $[49] !== setIsStale ? (t15 = () => {
    setIsStale(!1), clearUploadStatus();
  }, $[48] = clearUploadStatus, $[49] = setIsStale, $[50] = t15) : t15 = $[50];
  const handleClearUploadState = t15;
  let t16;
  $[51] !== client || $[52] !== value ? (t16 = {
    client,
    source: value
  }, $[51] = client, $[52] = value, $[53] = t16) : t16 = $[53];
  const accessPolicy = useAccessPolicy(t16);
  let t17;
  $[54] !== accessPolicy || $[55] !== handleOpenDialog || $[56] !== imageUrlBuilder || $[57] !== readOnly || $[58] !== value ? (t17 = () => value ? /* @__PURE__ */ jsx(ImageInputPreview, { accessPolicy, handleOpenDialog, imageUrlBuilder, readOnly, value }) : /* @__PURE__ */ jsx(Fragment$1, {}), $[54] = accessPolicy, $[55] = handleOpenDialog, $[56] = imageUrlBuilder, $[57] = readOnly, $[58] = value, $[59] = t17) : t17 = $[59];
  const renderPreview = t17;
  let t18;
  $[60] !== accessPolicy ? (t18 = () => /* @__PURE__ */ jsx(ImageAccessPolicy, { accessPolicy }), $[60] = accessPolicy, $[61] = t18) : t18 = $[61];
  const renderAssetAccessPolicy = t18;
  let t19;
  $[62] !== accessPolicy || $[63] !== assetSources || $[64] !== directUploads || $[65] !== handleOpenDialog || $[66] !== handleOpenInSource || $[67] !== handleOpenSourceForUpload || $[68] !== handleRemoveButtonClick || $[69] !== handleSelectFileToUpload || $[70] !== handleSelectImageFromAssetSource || $[71] !== imageUrlBuilder || $[72] !== isImageToolEnabled || $[73] !== isMenuOpen || $[74] !== menuButtonRef || $[75] !== observeAsset || $[76] !== readOnly || $[77] !== schemaType || $[78] !== value ? (t19 = () => /* @__PURE__ */ jsx(ImageInputAssetMenu, { accessPolicy, assetSources, directUploads, handleOpenDialog, handleRemoveButtonClick, onSelectFile: handleSelectFileToUpload, onOpenSourceForUpload: handleOpenSourceForUpload, handleSelectImageFromAssetSource, imageUrlBuilder, isImageToolEnabled: isImageToolEnabled(), isMenuOpen, observeAsset, onOpenInSource: handleOpenInSource, readOnly, schemaType, setHotspotButtonElement, menuButtonRef, setMenuOpen, value }), $[62] = accessPolicy, $[63] = assetSources, $[64] = directUploads, $[65] = handleOpenDialog, $[66] = handleOpenInSource, $[67] = handleOpenSourceForUpload, $[68] = handleRemoveButtonClick, $[69] = handleSelectFileToUpload, $[70] = handleSelectImageFromAssetSource, $[71] = imageUrlBuilder, $[72] = isImageToolEnabled, $[73] = isMenuOpen, $[74] = menuButtonRef, $[75] = observeAsset, $[76] = readOnly, $[77] = schemaType, $[78] = value, $[79] = t19) : t19 = $[79];
  const renderAssetMenu = t19;
  let t20;
  $[80] !== assetSources || $[81] !== handleSelectImageFromAssetSource || $[82] !== readOnly || $[83] !== schemaType ? (t20 = () => /* @__PURE__ */ jsx(AssetSourceBrowser, { assetSources, readOnly, schemaType, onSelectAssetSource: handleSelectImageFromAssetSource }), $[80] = assetSources, $[81] = handleSelectImageFromAssetSource, $[82] = readOnly, $[83] = schemaType, $[84] = t20) : t20 = $[84];
  const renderBrowser = t20, disableNew = schemaType.options?.disableNew === !0;
  let t21;
  $[85] !== assetSources || $[86] !== directUploads || $[87] !== disableNew || $[88] !== handleOpenSourceForUpload || $[89] !== handleSelectFileToUpload || $[90] !== readOnly || $[91] !== renderBrowser || $[92] !== schemaType ? (t21 = () => /* @__PURE__ */ jsx(ImageInputUploadPlaceholder, { assetSources, directUploads, disableNew, onSelectFile: handleSelectFileToUpload, onOpenSourceForUpload: handleOpenSourceForUpload, readOnly, renderBrowser, schemaType }), $[85] = assetSources, $[86] = directUploads, $[87] = disableNew, $[88] = handleOpenSourceForUpload, $[89] = handleSelectFileToUpload, $[90] = readOnly, $[91] = renderBrowser, $[92] = schemaType, $[93] = t21) : t21 = $[93];
  const renderUploadPlaceholder = t21;
  let t22;
  $[94] !== handleCancelUpload || $[95] !== handleStaleUpload || $[96] !== isUploading ? (t22 = (uploadState) => /* @__PURE__ */ jsx(UploadProgress, { uploadState, onCancel: isUploading ? handleCancelUpload : void 0, onStale: handleStaleUpload }), $[94] = handleCancelUpload, $[95] = handleStaleUpload, $[96] = isUploading, $[97] = t22) : t22 = $[97];
  const renderUploadState = t22;
  let t23;
  $[98] !== assetSources || $[99] !== directUploads || $[100] !== elementProps || $[101] !== handleClearField || $[102] !== handleClearUploadState || $[103] !== handleOpenSourceForUpload || $[104] !== handleSelectFileToUpload || $[105] !== isStale || $[106] !== readOnly || $[107] !== renderAssetAccessPolicy || $[108] !== renderAssetMenu || $[109] !== renderPreview || $[110] !== renderUploadPlaceholder || $[111] !== renderUploadState || $[112] !== schemaType || $[113] !== selectedAssetSource || $[114] !== value ? (t23 = (inputProps) => value && typeof value.asset < "u" && !value?._upload && !isImageSource(value) ? /* @__PURE__ */ jsx(InvalidImageWarning, { onClearValue: handleClearField }) : /* @__PURE__ */ jsx(ImageInputAsset, { assetSources, directUploads: directUploads !== !1, elementProps, handleClearUploadState, inputProps, isStale, onOpenSourceForUpload: handleOpenSourceForUpload, onSelectFile: handleSelectFileToUpload, readOnly, renderAssetAccessPolicy, renderAssetMenu, renderPreview, renderUploadPlaceholder, renderUploadState, schemaType, selectedAssetSource, value }), $[98] = assetSources, $[99] = directUploads, $[100] = elementProps, $[101] = handleClearField, $[102] = handleClearUploadState, $[103] = handleOpenSourceForUpload, $[104] = handleSelectFileToUpload, $[105] = isStale, $[106] = readOnly, $[107] = renderAssetAccessPolicy, $[108] = renderAssetMenu, $[109] = renderPreview, $[110] = renderUploadPlaceholder, $[111] = renderUploadState, $[112] = schemaType, $[113] = selectedAssetSource, $[114] = value, $[115] = t23) : t23 = $[115];
  const renderAsset = t23;
  let t24;
  $[116] !== handleCloseDialog || $[117] !== isImageToolEnabled || $[118] !== props2 ? (t24 = (inputProps_0) => /* @__PURE__ */ jsx(ImageInputHotspotInput, { isImageToolEnabled: isImageToolEnabled(), handleCloseDialog, imageInputProps: props2, inputProps: inputProps_0 }), $[116] = handleCloseDialog, $[117] = isImageToolEnabled, $[118] = props2, $[119] = t24) : t24 = $[119];
  const renderHotspotInput = t24;
  let t25;
  $[120] !== assetSourceAction || $[121] !== assetSourceUploader?.uploader || $[122] !== handleAssetSourceChangeAction || $[123] !== handleAssetSourceClosed || $[124] !== handleSelectAssetFromSource$1 || $[125] !== observeAsset || $[126] !== openInSourceAsset || $[127] !== schemaType || $[128] !== selectedAssetSource || $[129] !== value ? (t25 = () => !selectedAssetSource || !assetSourceAction ? null : /* @__PURE__ */ jsx(AssetSourceDialog, { action: assetSourceAction, assetType: "image", observeAsset, onClose: handleAssetSourceClosed, onChangeAction: handleAssetSourceChangeAction, onSelect: handleSelectAssetFromSource$1, openInSourceAsset, schemaType, selectedAssetSource, uploader: assetSourceUploader?.uploader, value }), $[120] = assetSourceAction, $[121] = assetSourceUploader?.uploader, $[122] = handleAssetSourceChangeAction, $[123] = handleAssetSourceClosed, $[124] = handleSelectAssetFromSource$1, $[125] = observeAsset, $[126] = openInSourceAsset, $[127] = schemaType, $[128] = selectedAssetSource, $[129] = value, $[130] = t25) : t25 = $[130];
  const renderAssetSource = t25;
  let t26;
  $[131] !== members ? (t26 = members.find(_temp4$e), $[131] = members, $[132] = t26) : t26 = $[132];
  const hotspotField = t26;
  let t27;
  if ($[133] !== renderAnnotation || $[134] !== renderAsset || $[135] !== renderBlock2 || $[136] !== renderField || $[137] !== renderInlineBlock || $[138] !== renderInput || $[139] !== renderItem2 || $[140] !== renderPreviewProp || $[141] !== renderedMembers || $[142] !== schemaType || $[143] !== t) {
    let t282;
    $[145] !== renderAnnotation || $[146] !== renderAsset || $[147] !== renderBlock2 || $[148] !== renderField || $[149] !== renderInlineBlock || $[150] !== renderInput || $[151] !== renderItem2 || $[152] !== renderPreviewProp || $[153] !== schemaType || $[154] !== t ? (t282 = (member_0) => member_0.kind === "field" && (member_0.name === "crop" || member_0.name === "hotspot") ? null : member_0.kind === "field" ? /* @__PURE__ */ jsx(MemberField, { member: member_0, renderAnnotation, renderBlock: renderBlock2, renderInlineBlock, renderInput: member_0.name === "asset" ? renderAsset : renderInput, renderField: member_0.name === "asset" ? passThrough$1 : renderField, renderItem: renderItem2, renderPreview: renderPreviewProp }, member_0.key) : member_0.kind === "fieldSet" ? /* @__PURE__ */ jsx(MemberFieldSet, { member: member_0, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview: renderPreviewProp, schemaType }, member_0.key) : member_0.kind === "error" ? /* @__PURE__ */ jsx(MemberFieldError, { member: member_0 }, member_0.key) : member_0.kind === "decoration" ? /* @__PURE__ */ jsx(MemberDecoration, { member: member_0 }, member_0.key) : /* @__PURE__ */ jsx(Fragment, { children: t("inputs.image.error.unknown-member-kind", {
      kind: member_0.kind
    }) }, member_0.key), $[145] = renderAnnotation, $[146] = renderAsset, $[147] = renderBlock2, $[148] = renderField, $[149] = renderInlineBlock, $[150] = renderInput, $[151] = renderItem2, $[152] = renderPreviewProp, $[153] = schemaType, $[154] = t, $[155] = t282) : t282 = $[155], t27 = renderedMembers.map(t282), $[133] = renderAnnotation, $[134] = renderAsset, $[135] = renderBlock2, $[136] = renderField, $[137] = renderInlineBlock, $[138] = renderInput, $[139] = renderItem2, $[140] = renderPreviewProp, $[141] = renderedMembers, $[142] = schemaType, $[143] = t, $[144] = t27;
  } else
    t27 = $[144];
  let t28;
  $[156] !== focusPath || $[157] !== hotspotField || $[158] !== props2 || $[159] !== renderHotspotInput ? (t28 = hotspotField && focusPath[0] === "hotspot" && /* @__PURE__ */ jsx(FormInput, { ...props2, absolutePath: hotspotField.field.path, renderInput: renderHotspotInput }), $[156] = focusPath, $[157] = hotspotField, $[158] = props2, $[159] = renderHotspotInput, $[160] = t28) : t28 = $[160];
  let t29;
  $[161] !== renderAssetSource || $[162] !== selectedAssetSource ? (t29 = selectedAssetSource && renderAssetSource(), $[161] = renderAssetSource, $[162] = selectedAssetSource, $[163] = t29) : t29 = $[163];
  let t30;
  return $[164] !== t27 || $[165] !== t28 || $[166] !== t29 ? (t30 = /* @__PURE__ */ jsxs(Stack, { space: 5, "data-testid": "image-input", children: [
    t27,
    t28,
    t29
  ] }), $[164] = t27, $[165] = t28, $[166] = t29, $[167] = t30) : t30 = $[167], t30;
}
function _temp4$e(member) {
  return member.kind === "field" && member.name === "hotspot";
}
function _temp3$w(key_1) {
  return unset([key_1]);
}
function _temp2$11(key_0) {
  return ["crop", "hotspot", "_upload"].includes(key_0);
}
function _temp$2t(key) {
  return !["_type", "_key", "_upload", "asset", "crop", "hotspot", "media"].includes(key);
}
const BaseImageInput = memo(BaseImageInputComponent);
function passThrough$1({
  children
}) {
  return children;
}
function StudioImageInput(props2) {
  const $ = c(12), sourcesFromSchema = props2.schemaType.options?.sources, {
    image: imageConfig
  } = useFormBuilder().__internal, documentPreviewStore = useDocumentPreviewStore(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), supportsImageUploads = imageConfig.directUploads, assetSources = sourcesFromSchema || imageConfig.assetSources;
  let t0;
  $[0] !== client ? (t0 = createImageUrlBuilder(client), $[0] = client, $[1] = t0) : t0 = $[1];
  const builder = t0;
  let t1;
  $[2] !== documentPreviewStore ? (t1 = (id2) => observeImageAsset(documentPreviewStore, id2), $[2] = documentPreviewStore, $[3] = t1) : t1 = $[3];
  const observeAsset = t1, {
    t
  } = useTranslation();
  let t2;
  return $[4] !== assetSources || $[5] !== builder || $[6] !== client || $[7] !== observeAsset || $[8] !== props2 || $[9] !== supportsImageUploads || $[10] !== t ? (t2 = /* @__PURE__ */ jsx(BaseImageInput, { ...props2, t, client, assetSources, directUploads: supportsImageUploads, imageUrlBuilder: builder, observeAsset, resolveUploader }), $[4] = assetSources, $[5] = builder, $[6] = client, $[7] = observeAsset, $[8] = props2, $[9] = supportsImageUploads, $[10] = t, $[11] = t2) : t2 = $[11], t2;
}
const defaultInputs = {
  document: ObjectInput,
  object: ObjectInput,
  array: UniversalArrayInput,
  boolean: BooleanInput,
  number: NumberInput,
  text: TextInput,
  email: EmailInput,
  datetime: DateTimeInput$2,
  date: DateInput,
  url: UrlInput,
  image: StudioImageInput,
  file: StudioFileInput,
  string: StringInput,
  slug: SlugInput,
  crossDatasetReference: StudioCrossDatasetReferenceInput,
  globalDocumentReference: StudioGlobalDocumentReferenceInput
};
function focusRingBorderStyle$1(border) {
  return `inset 0 0 0 ${border.width}px ${border.color}`;
}
function focusRingStyle(opts) {
  const {
    base,
    border,
    focusRing
  } = opts, focusRingOutsetWidth = focusRing.offset + focusRing.width, focusRingInsetWidth = 0 - focusRing.offset, bgColor = base ? base.bg : "var(--card-bg-color)";
  return [focusRingInsetWidth > 0 && `inset 0 0 0 ${focusRingInsetWidth}px var(--card-focus-ring-color)`, border && focusRingBorderStyle$1(border), focusRingInsetWidth < 0 && `0 0 0 ${0 - focusRingInsetWidth}px ${bgColor}`, focusRingOutsetWidth > 0 && `0 0 0 ${focusRingOutsetWidth}px var(--card-focus-ring-color)`].filter(Boolean).join(",");
}
const Root$h = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-1inuom0-0"
})((props2) => {
  const {
    theme
  } = props2, {
    focusRing,
    input,
    radius
  } = theme.sanity, color = theme.sanity.color.input, space = rem(theme.sanity.space[1]);
  return {
    position: "relative",
    borderRadius: `${radius[1]}px`,
    color: color.default.enabled.fg,
    boxShadow: focusRingBorderStyle$1({
      color: color.default.enabled.border,
      width: input.border.width
    }),
    "& > .content": {
      position: "relative",
      lineHeight: "0",
      margin: `-${space} 0 0 -${space}`
    },
    "& > .content > div": {
      display: "inline-block",
      verticalAlign: "top",
      padding: `${space} 0 0 ${space}`
    },
    // enabled
    "&:not([data-read-only])": {
      cursor: "text"
    },
    // hovered
    "@media(hover:hover):not([data-disabled]):not([data-read-only]):hover": {
      borderColor: color.default.hovered.border
    },
    // focused
    "&:not([data-disabled]):not([data-read-only])[data-focused]": {
      boxShadow: focusRingStyle({
        border: {
          color: color.default.enabled.border,
          width: input.border.width
        },
        focusRing
      })
    },
    // disabled
    "*:disabled + &": {
      color: color.default.disabled.fg,
      backgroundColor: color.default.disabled.bg,
      boxShadow: focusRingBorderStyle$1({
        color: color.default.disabled.border,
        width: input.border.width
      })
    }
  };
}), Input = /* @__PURE__ */ styled.input.withConfig({
  displayName: "Input",
  componentId: "sc-1inuom0-1"
})((props2) => {
  const {
    theme
  } = props2, font = theme.sanity.fonts.text, color = theme.sanity.color.input, p = theme.sanity.space[2], size = theme.sanity.fonts.text.sizes[2];
  return {
    appearance: "none",
    background: "none",
    border: 0,
    borderRadius: 0,
    outline: "none",
    fontSize: rem(size.fontSize),
    lineHeight: `${size.lineHeight / size.fontSize}`,
    fontFamily: font.family,
    fontWeight: `${font.weights.regular}`,
    margin: 0,
    display: "block",
    minWidth: "1px",
    maxWidth: "100%",
    boxSizing: "border-box",
    paddingTop: rem(p - size.ascenderHeight),
    paddingRight: rem(p),
    paddingBottom: rem(p - size.descenderHeight),
    paddingLeft: rem(p),
    // enabled
    "&:not(:invalid):not(:disabled)": {
      color: color.default.enabled.fg
    },
    // disabled
    "&:not(:invalid):disabled": {
      color: color.default.disabled.fg
    }
  };
}), Placeholder$1 = /* @__PURE__ */ styled(Box).withConfig({
  displayName: "Placeholder",
  componentId: "sc-1inuom0-2"
})((props2) => {
  const {
    theme
  } = props2, color = theme.sanity.color.input;
  return css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    --card-fg-color: ${color.default.enabled.placeholder};
  `;
}), TagBox = styled(Box).withConfig({
  displayName: "TagBox",
  componentId: "sc-1inuom0-3"
})`max-width:100%;`, TagInput = forwardRef((props2, forwardedRef) => {
  const $ = c(54);
  let disabled, onChange, onFocus, placeholderProp, readOnly, restProps, t0;
  $[0] !== props2 ? ({
    disabled,
    onChange,
    onFocus,
    placeholder: placeholderProp,
    readOnly,
    value: t0,
    ...restProps
  } = props2, $[0] = props2, $[1] = disabled, $[2] = onChange, $[3] = onFocus, $[4] = placeholderProp, $[5] = readOnly, $[6] = restProps, $[7] = t0) : (disabled = $[1], onChange = $[2], onFocus = $[3], placeholderProp = $[4], readOnly = $[5], restProps = $[6], t0 = $[7]);
  let t1;
  $[8] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[8] = t0, $[9] = t1) : t1 = $[9];
  const value = t1, {
    t
  } = useTranslation(studioLocaleNamespace), [inputValue, setInputValue] = useState(""), enabled = !disabled && !readOnly, [focused, setFocused] = useState(!1), ref = useRef(null), rootRef = useRef(null);
  let t2;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => ref.current, $[10] = t2) : t2 = $[10], useImperativeHandle(forwardedRef, t2);
  let t3;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (event) => {
    if (isHTMLElement(event.target) && event.target.closest('[data-ui="Tag"]'))
      return;
    const inputElement = ref.current;
    inputElement && setTimeout(() => inputElement.focus(), 0);
  }, $[11] = t3) : t3 = $[11];
  const handleRootPointerDown = t3;
  let t4;
  $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setFocused(!1);
  }, $[12] = t4) : t4 = $[12];
  const handleInputBlur = t4;
  let t5;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = (event_0) => {
    setInputValue(event_0.currentTarget.value);
  }, $[13] = t5) : t5 = $[13];
  const handleInputChange = t5;
  let t6;
  $[14] !== onFocus ? (t6 = (event_1) => {
    setFocused(!0), onFocus && onFocus(event_1);
  }, $[14] = onFocus, $[15] = t6) : t6 = $[15];
  const handleInputFocus = t6;
  let t7;
  $[16] !== inputValue || $[17] !== onChange || $[18] !== value ? (t7 = (event_2) => {
    if (event_2.key === "Enter" && (event_2.preventDefault(), event_2.stopPropagation(), onChange && inputValue)) {
      const newValue = value.concat([{
        value: inputValue
      }]);
      setInputValue(""), onChange && onChange(newValue);
    }
  }, $[16] = inputValue, $[17] = onChange, $[18] = value, $[19] = t7) : t7 = $[19];
  const handleInputKeyDown = t7;
  let t8;
  $[20] !== onChange || $[21] !== value ? (t8 = (index) => {
    if (!onChange)
      return;
    const newValue_0 = value.slice(0);
    newValue_0.splice(index, 1), onChange(newValue_0);
  }, $[20] = onChange, $[21] = value, $[22] = t8) : t8 = $[22];
  const handleTagRemove = t8;
  let t9;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = () => {
    const inputElement_0 = ref.current;
    inputElement_0 && (inputElement_0.style.width = "0", inputElement_0.style.width = `calc(${inputElement_0.scrollWidth}px + 1rem)`);
  }, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== inputValue ? (t10 = [inputValue], $[24] = inputValue, $[25] = t10) : t10 = $[25], useEffect(t9, t10);
  const t11 = disabled ? "" : void 0, t12 = focused ? "" : void 0, t13 = readOnly ? "" : void 0;
  let t14;
  $[26] !== enabled || $[27] !== inputValue || $[28] !== placeholderProp || $[29] !== t || $[30] !== value.length ? (t14 = enabled && /* @__PURE__ */ jsx(Placeholder$1, { hidden: !!(inputValue || value.length), padding: 3, children: /* @__PURE__ */ jsx(Text$1, { textOverflow: "ellipsis", children: placeholderProp || t("inputs.tags.placeholder", {
    context: typeof window < "u" && "ontouchstart" in window ? "touch" : void 0
  }) }) }), $[26] = enabled, $[27] = inputValue, $[28] = placeholderProp, $[29] = t, $[30] = value.length, $[31] = t14) : t14 = $[31];
  let t15;
  if ($[32] !== enabled || $[33] !== handleTagRemove || $[34] !== value) {
    let t162;
    $[36] !== enabled || $[37] !== handleTagRemove ? (t162 = (tag, tagIndex) => /* @__PURE__ */ jsx(TagBox, { children: /* @__PURE__ */ jsx(Tag, { enabled, index: tagIndex, muted: !enabled, onRemove: handleTagRemove, tag }) }, `tag-${tagIndex}`), $[36] = enabled, $[37] = handleTagRemove, $[38] = t162) : t162 = $[38], t15 = value.map(t162), $[32] = enabled, $[33] = handleTagRemove, $[34] = value, $[35] = t15;
  } else
    t15 = $[35];
  const t16 = !enabled;
  let t17;
  $[39] !== handleInputFocus || $[40] !== handleInputKeyDown || $[41] !== inputValue || $[42] !== restProps || $[43] !== t16 ? (t17 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Input, { ...restProps, disabled: t16, onBlur: handleInputBlur, onChange: handleInputChange, onFocus: handleInputFocus, onKeyDown: handleInputKeyDown, ref, type: "text", value: inputValue }) }, "tag-input"), $[39] = handleInputFocus, $[40] = handleInputKeyDown, $[41] = inputValue, $[42] = restProps, $[43] = t16, $[44] = t17) : t17 = $[44];
  let t18;
  $[45] !== t15 || $[46] !== t17 ? (t18 = /* @__PURE__ */ jsxs("div", { className: "content", children: [
    t15,
    t17
  ] }), $[45] = t15, $[46] = t17, $[47] = t18) : t18 = $[47];
  let t19;
  return $[48] !== t11 || $[49] !== t12 || $[50] !== t13 || $[51] !== t14 || $[52] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Root$h, { "data-disabled": t11, "data-focused": t12, "data-read-only": t13, "data-ui": "TagInput", onPointerDown: handleRootPointerDown, overflow: "auto", padding: 1, ref: rootRef, children: [
    t14,
    t18
  ] }), $[48] = t11, $[49] = t12, $[50] = t13, $[51] = t14, $[52] = t18, $[53] = t19) : t19 = $[53], t19;
});
TagInput.displayName = "ForwardRef(TagInput)";
function Tag(props2) {
  const $ = c(12), {
    enabled,
    index,
    muted,
    onRemove,
    tag
  } = props2;
  let t0;
  $[0] !== index || $[1] !== onRemove ? (t0 = () => {
    onRemove(index);
  }, $[0] = index, $[1] = onRemove, $[2] = t0) : t0 = $[2];
  const handleRemoveClick = t0;
  let t1;
  $[3] !== muted || $[4] !== tag.value ? (t1 = /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, paddingLeft: 2, children: /* @__PURE__ */ jsx(Text$1, { muted, textOverflow: "ellipsis", children: tag.value }) }), $[3] = muted, $[4] = tag.value, $[5] = t1) : t1 = $[5];
  let t2;
  $[6] !== enabled || $[7] !== handleRemoveClick ? (t2 = enabled && /* @__PURE__ */ jsx(Button, { icon: CloseIcon, mode: "bleed", onClick: handleRemoveClick, tooltipProps: {
    content: "Remove"
  } }), $[6] = enabled, $[7] = handleRemoveClick, $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== t1 || $[10] !== t2 ? (t3 = /* @__PURE__ */ jsx(Card, { "data-ui": "Tag", radius: 2, tone: "transparent", children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
    t1,
    t2
  ] }) }), $[9] = t1, $[10] = t2, $[11] = t3) : t3 = $[11], t3;
}
function TagsArrayInput(props2) {
  const $ = c(15), {
    onChange,
    readOnly,
    value: t0,
    elementProps,
    path,
    changed
  } = props2;
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const value = t1;
  let t2;
  $[2] !== value ? (t2 = value?.map(_temp$2s), $[2] = value, $[3] = t2) : t2 = $[3];
  const tagInputValue = t2;
  let t3;
  $[4] !== onChange ? (t3 = (nextValue) => {
    onChange(nextValue.length === 0 ? unset() : set(nextValue.map(_temp2$10)));
  }, $[4] = onChange, $[5] = t3) : t3 = $[5];
  const handleChange = t3;
  let t4;
  $[6] !== elementProps || $[7] !== handleChange || $[8] !== readOnly || $[9] !== tagInputValue ? (t4 = /* @__PURE__ */ jsx(TagInput, { onChange: handleChange, readOnly, value: tagInputValue, ...elementProps }), $[6] = elementProps, $[7] = handleChange, $[8] = readOnly, $[9] = tagInputValue, $[10] = t4) : t4 = $[10];
  let t5;
  return $[11] !== changed || $[12] !== path || $[13] !== t4 ? (t5 = /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !1, children: t4 }), $[11] = changed, $[12] = path, $[13] = t4, $[14] = t5) : t5 = $[14], t5;
}
function _temp2$10(v_0) {
  return v_0.value;
}
function _temp$2s(v) {
  return {
    value: v
  };
}
const PRIMITIVES = ["string", "number", "boolean"];
function isArrayOfPrimitives$1(type) {
  return type.of.every((ofType) => PRIMITIVES.includes(ofType.jsonType));
}
function isStringArray(type) {
  return type.of.length === 1 && is$1("string", type.of[0]);
}
function isTagsArray(type) {
  return type.options?.layout === "tags";
}
function isPortableText(type) {
  return type.of.some((memberType) => is$1("block", memberType));
}
function hasListOptions(type) {
  return !!type.options?.list;
}
function resolveArrayInput(type) {
  return isStringArray(type) && isTagsArray(type) ? TagsArrayInput : hasListOptions(type) ? ArrayOfOptionsInput : isArrayOfPrimitives$1(type) ? ArrayOfPrimitivesInput : isPortableText(type) ? PortableTextInput : ArrayOfObjectsInput;
}
function toSelectItem$1(option) {
  return isTitledListValue(option) ? option : {
    title: capitalize(`${option}`),
    value: option
  };
}
const EMPTY_ITEM = {
  title: "",
  value: void 0
};
function SelectInput(props2) {
  const $ = c(20), {
    value,
    readOnly,
    validationError,
    schemaType,
    onChange,
    path,
    changed,
    focused,
    elementProps
  } = props2;
  let t0;
  $[0] !== schemaType.options?.list ? (t0 = schemaType.options?.list || [], $[0] = schemaType.options?.list, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 ? (t1 = t0.map(toSelectItem$1), $[2] = t0, $[3] = t1) : t1 = $[3];
  const items = t1;
  let t2;
  $[4] !== value ? (t2 = (item) => item.value === value, $[4] = value, $[5] = t2) : t2 = $[5];
  const currentItem = items.find(t2), isRadio = schemaType.options && schemaType.options.layout === "radio";
  let t3;
  $[6] !== items ? (t3 = (optionValue) => {
    const index = Number(optionValue);
    return items[index];
  }, $[6] = items, $[7] = t3) : t3 = $[7];
  const itemFromOptionValue = t3;
  let t4;
  $[8] !== items ? (t4 = (item_0) => String(items.indexOf(item_0)), $[8] = items, $[9] = t4) : t4 = $[9];
  const optionValueFromItem = t4, inputId = useId();
  let t5;
  $[10] !== onChange ? (t5 = (nextItem) => {
    onChange(PatchEvent.from(typeof nextItem?.value > "u" ? unset() : set(nextItem.value)));
  }, $[10] = onChange, $[11] = t5) : t5 = $[11];
  const handleChange = t5;
  let t6;
  $[12] !== handleChange || $[13] !== itemFromOptionValue ? (t6 = (event) => {
    const nextItem_0 = itemFromOptionValue(event.currentTarget.value);
    if (!nextItem_0) {
      handleChange(EMPTY_ITEM);
      return;
    }
    handleChange(nextItem_0);
  }, $[12] = handleChange, $[13] = itemFromOptionValue, $[14] = t6) : t6 = $[14];
  const handleSelectChange = t6, content = isRadio ? /* @__PURE__ */ jsx(RadioSelect, { ...elementProps, value: currentItem, inputId, items, direction: schemaType.options?.direction || "vertical", customValidity: validationError, onChange: handleChange, readOnly }) : /* @__PURE__ */ jsx(Select, { ...elementProps, customValidity: validationError, value: optionValueFromItem(currentItem), readOnly, onChange: handleSelectChange, children: [EMPTY_ITEM, ...items].map(_temp$2r) }), t7 = !!focused;
  let t8;
  return $[15] !== changed || $[16] !== content || $[17] !== path || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: t7, children: content }), $[15] = changed, $[16] = content, $[17] = path, $[18] = t7, $[19] = t8) : t8 = $[19], t8;
}
function _temp$2r(item_1, i) {
  return /* @__PURE__ */ jsx("option", { value: i - 1, children: item_1.title }, `${i - 1}`);
}
const RadioSelect = forwardRef(function(props2, ref) {
  const $ = c(22), {
    items,
    value,
    onChange,
    onFocus,
    readOnly,
    customValidity,
    direction,
    inputId
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== onChange ? (t0 = () => {
    onChange(null);
  }, $[0] = onChange, $[1] = t0) : t0 = $[1];
  const handleClear = t0, isHorizontal = direction === "horizontal", Layout2 = isHorizontal ? Inline : Stack, showClearButton = !readOnly && value, t1 = isHorizontal ? "center" : "flex-end";
  let t2;
  $[2] !== customValidity || $[3] !== inputId || $[4] !== items || $[5] !== onChange || $[6] !== onFocus || $[7] !== readOnly || $[8] !== ref || $[9] !== value ? (t2 = items.map((item, index) => /* @__PURE__ */ jsx(RadioSelectItem, { customValidity, inputId, item, onChange, onFocus, readOnly, ref: index === 0 ? ref : null, value }, index)), $[2] = customValidity, $[3] = inputId, $[4] = items, $[5] = onChange, $[6] = onFocus, $[7] = readOnly, $[8] = ref, $[9] = value, $[10] = t2) : t2 = $[10];
  let t3;
  $[11] !== Layout2 || $[12] !== t2 ? (t3 = /* @__PURE__ */ jsx(Layout2, { space: 3, role: "group", paddingY: 1, children: t2 }), $[11] = Layout2, $[12] = t2, $[13] = t3) : t3 = $[13];
  let t4;
  $[14] !== handleClear || $[15] !== showClearButton || $[16] !== t ? (t4 = showClearButton && /* @__PURE__ */ jsx(Button, { icon: ResetIcon, onClick: handleClear, tooltipProps: {
    content: t("inputs.select.action.clear")
  }, mode: "bleed" }), $[14] = handleClear, $[15] = showClearButton, $[16] = t, $[17] = t4) : t4 = $[17];
  let t5;
  return $[18] !== t1 || $[19] !== t3 || $[20] !== t4 ? (t5 = /* @__PURE__ */ jsx(Card, { border: !0, paddingY: 2, paddingX: 3, radius: 2, children: /* @__PURE__ */ jsxs(Flex, { align: t1, gap: 3, justify: "space-between", children: [
    t3,
    t4
  ] }) }), $[18] = t1, $[19] = t3, $[20] = t4, $[21] = t5) : t5 = $[21], t5;
}), RadioSelectItem = forwardRef(function(props2, ref) {
  const $ = c(17), {
    customValidity,
    inputId,
    item,
    onChange,
    onFocus,
    readOnly,
    value
  } = props2;
  let t0;
  $[0] !== item || $[1] !== onChange ? (t0 = () => {
    onChange(item);
  }, $[0] = item, $[1] = onChange, $[2] = t0) : t0 = $[2];
  const handleChange = t0, checked = value === item;
  let t1;
  $[3] !== checked || $[4] !== customValidity || $[5] !== handleChange || $[6] !== inputId || $[7] !== onFocus || $[8] !== readOnly || $[9] !== ref ? (t1 = /* @__PURE__ */ jsx(Radio, { ref, checked, onChange: handleChange, onFocus, readOnly, customValidity, name: inputId }), $[3] = checked, $[4] = customValidity, $[5] = handleChange, $[6] = inputId, $[7] = onFocus, $[8] = readOnly, $[9] = ref, $[10] = t1) : t1 = $[10];
  const t2 = checked ? "medium" : "regular";
  let t3;
  $[11] !== item.title || $[12] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: t2, children: item.title }) }), $[11] = item.title, $[12] = t2, $[13] = t3) : t3 = $[13];
  let t4;
  return $[14] !== t1 || $[15] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { as: "label", align: "center", children: [
    t1,
    t3
  ] }), $[14] = t1, $[15] = t3, $[16] = t4) : t4 = $[16], t4;
});
function resolveNumberInput(type) {
  return getOption(type, "list") ? SelectInput : NumberInput;
}
function resolveStringInput(type) {
  return getOption(type, "list") ? SelectInput : StringInput;
}
function resolveComponentFromTypeVariants(type) {
  if (is$1("array", type))
    return resolveArrayInput(type);
  if (is$1("reference", type))
    return StudioReferenceInput;
  if (is$1("string", type))
    return resolveStringInput(type);
  if (is$1("number", type))
    return resolveNumberInput(type);
}
function defaultResolveInputComponent(schemaType) {
  if (schemaType.components?.input) return schemaType.components.input;
  const componentFromTypeVariants = resolveComponentFromTypeVariants(schemaType);
  if (componentFromTypeVariants)
    return componentFromTypeVariants;
  const deduped = getTypeChain$2(schemaType, /* @__PURE__ */ new Set()).reduce((acc, type) => (acc[type.name] = type, acc), {}), subType = Object.values(deduped).find((t) => defaultInputs[t.name]);
  if (subType)
    return defaultInputs[subType.name];
  throw new Error(`Could not find input component for schema type \`${schemaType.name}\``);
}
function defaultResolvePreviewComponent(schemaType) {
  return schemaType.components?.preview ? schemaType.components.preview : SanityDefaultPreview;
}
function getTone$1({
  readOnly,
  hasErrors,
  hasWarnings
}) {
  return readOnly ? "transparent" : hasErrors ? "critical" : hasWarnings ? "caution" : "default";
}
const MENU_POPOVER_PROPS$1 = {
  portal: !0,
  tone: "default"
}, BUTTON_CARD_STYLE = {
  position: "relative"
}, EMPTY_ARRAY$l = [];
function PreviewItem(props2) {
  const $ = c(101), {
    schemaType,
    parentSchemaType,
    path,
    readOnly,
    onRemove,
    value,
    open,
    onInsert,
    onCopy,
    onFocus,
    onOpen,
    onClose,
    changed,
    focused,
    children,
    inputProps: t0
  } = props2, {
    renderPreview
  } = t0, {
    t
  } = useTranslation(), arrayValidation = useArrayValidation(), maxReached = arrayValidation?.maxReached, maxReachedReason = arrayValidation?.maxReachedReason, {
    enabled: enhancedObjectDialogEnabled
  } = useEnhancedObjectDialog(), openPortal = open && !enhancedObjectDialogEnabled, openEnhancedDialog = open && enhancedObjectDialogEnabled, sortable = parentSchemaType.options?.sortable !== !1, insertableTypes = parentSchemaType.of, [previewCardElement, setPreviewCardElement] = useState(null), previewCardRef = useRef(null);
  let t1, t2;
  $[0] !== previewCardElement ? (t1 = () => previewCardElement, t2 = [previewCardElement], $[0] = previewCardElement, $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]), useImperativeHandle(previewCardRef, t1, t2), useScrollIntoViewOnFocusWithin(previewCardRef, open && previewCardElement !== null);
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && previewCardRef.current && previewCardRef.current?.focus();
  }, $[3] = t3) : t3 = $[3], useDidUpdate(focused, t3);
  const resolvingInitialValue = value._resolvingInitialValue, uploadState = value[UPLOAD_STATUS_KEY], uploadProgress = typeof uploadState?.progress == "number" ? uploadState?.progress : void 0;
  let t4;
  $[4] !== onInsert || $[5] !== value ? (t4 = () => {
    onInsert({
      items: [regenerateKeys(value)],
      position: "after"
    });
  }, $[4] = onInsert, $[5] = value, $[6] = t4) : t4 = $[6];
  const handleDuplicate = t4;
  let t5;
  $[7] !== onCopy || $[8] !== value ? (t5 = () => {
    onCopy({
      items: [regenerateKeys(value)]
    });
  }, $[7] = onCopy, $[8] = value, $[9] = t5) : t5 = $[9];
  const handleCopy = t5;
  let t6;
  $[10] !== onInsert ? (t6 = (pos, insertType) => {
    onInsert({
      items: [createProtoArrayValue(insertType)],
      position: pos
    });
  }, $[10] = onInsert, $[11] = t6) : t6 = $[11];
  const handleInsert = t6, childPresence = useChildPresence(path, !0);
  let t7;
  $[12] !== childPresence ? (t7 = childPresence.length === 0 ? null : /* @__PURE__ */ jsx(FieldPresence, { presence: childPresence, maxAvatars: 1 }), $[12] = childPresence, $[13] = t7) : t7 = $[13];
  const presence = t7, childValidation = useChildValidation(path, !0);
  let t8;
  $[14] !== childValidation ? (t8 = childValidation.length === 0 ? null : /* @__PURE__ */ jsx(Box, { paddingX: 1, paddingY: 3, children: /* @__PURE__ */ jsx(FormFieldValidationStatus, { validation: childValidation, __unstable_showSummary: !0 }) }), $[14] = childValidation, $[15] = t8) : t8 = $[15];
  const validation2 = t8, hasErrors = childValidation.some(_temp$2q), hasWarnings = childValidation.some(_temp2$$), [contextMenuButtonElement, setContextMenuButtonElement] = useState(null), t9 = parentSchemaType.options?.insertMenu;
  let t10;
  $[16] !== contextMenuButtonElement || $[17] !== handleInsert || $[18] !== insertableTypes || $[19] !== maxReached || $[20] !== maxReachedReason || $[21] !== t9 ? (t10 = {
    schemaTypes: insertableTypes,
    insertMenuOptions: t9,
    onInsert: handleInsert,
    referenceElement: contextMenuButtonElement,
    disabled: maxReached,
    disabledReason: maxReachedReason
  }, $[16] = contextMenuButtonElement, $[17] = handleInsert, $[18] = insertableTypes, $[19] = maxReached, $[20] = maxReachedReason, $[21] = t9, $[22] = t10) : t10 = $[22];
  const {
    insertBefore,
    insertAfter: insertAfter2
  } = useInsertMenuMenuItems(t10), disableActions = parentSchemaType.options?.disableActions || EMPTY_ARRAY$l;
  let t11;
  $[23] !== disableActions || $[24] !== onRemove || $[25] !== t ? (t11 = !disableActions.includes("remove") && /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.array.action.remove"), tone: "critical", icon: TrashIcon, onClick: onRemove }, "remove"), $[23] = disableActions, $[24] = onRemove, $[25] = t, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== disableActions || $[28] !== handleCopy || $[29] !== t ? (t12 = !disableActions.includes("copy") && /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.array.action.copy"), icon: CopyIcon, onClick: handleCopy }, "copy"), $[27] = disableActions, $[28] = handleCopy, $[29] = t, $[30] = t12) : t12 = $[30];
  let t13;
  $[31] !== disableActions || $[32] !== handleDuplicate || $[33] !== t ? (t13 = !disableActions.includes("duplicate") && /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.array.action.duplicate"), icon: AddDocumentIcon, onClick: handleDuplicate }, "duplicate"), $[31] = disableActions, $[32] = handleDuplicate, $[33] = t, $[34] = t13) : t13 = $[34];
  let t14;
  $[35] !== disableActions || $[36] !== insertBefore.menuItem ? (t14 = !disableActions.includes("add") && !disableActions.includes("addBefore") && insertBefore.menuItem, $[35] = disableActions, $[36] = insertBefore.menuItem, $[37] = t14) : t14 = $[37];
  let t15;
  $[38] !== disableActions || $[39] !== insertAfter2.menuItem ? (t15 = !disableActions.includes("add") && !disableActions.includes("addAfter") && insertAfter2.menuItem, $[38] = disableActions, $[39] = insertAfter2.menuItem, $[40] = t15) : t15 = $[40];
  let t16;
  $[41] !== t11 || $[42] !== t12 || $[43] !== t13 || $[44] !== t14 || $[45] !== t15 ? (t16 = [t11, t12, t13, t14, t15].filter(Boolean), $[41] = t11, $[42] = t12, $[43] = t13, $[44] = t14, $[45] = t15, $[46] = t16) : t16 = $[46];
  const menuItems = t16;
  let t17;
  $[47] !== insertAfter2 || $[48] !== insertBefore || $[49] !== menuItems || $[50] !== props2.inputId || $[51] !== readOnly ? (t17 = readOnly || menuItems.length === 0 ? null : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(MenuButton, { ref: setContextMenuButtonElement, onOpen: () => {
      insertBefore.send({
        type: "close"
      }), insertAfter2.send({
        type: "close"
      });
    }, button: /* @__PURE__ */ jsx(ContextMenuButton, { "data-testid": "array-item-menu-button", selected: insertBefore.state.open || insertAfter2.state.open ? !0 : void 0 }), id: `${props2.inputId}-menuButton`, menu: /* @__PURE__ */ jsx(Menu, { children: menuItems }), popover: MENU_POPOVER_PROPS$1 }),
    insertBefore.popover,
    insertAfter2.popover
  ] }), $[47] = insertAfter2, $[48] = insertBefore, $[49] = menuItems, $[50] = props2.inputId, $[51] = readOnly, $[52] = t17) : t17 = $[52];
  const menu = t17, tone = getTone$1({
    readOnly,
    hasErrors,
    hasWarnings
  }), handleMouseDown = _temp3$v;
  let t18;
  $[53] !== onOpen ? (t18 = (event_0) => {
    event_0.stopPropagation(), onOpen();
  }, $[53] = onOpen, $[54] = t18) : t18 = $[54];
  const handleClick = t18, t19 = !!readOnly;
  let t20;
  $[55] !== props2.schemaType || $[56] !== props2.value || $[57] !== renderPreview || $[58] !== uploadProgress ? (t20 = renderPreview({
    schemaType: props2.schemaType,
    value: props2.value,
    layout: "default",
    skipVisibilityCheck: !0,
    progress: uploadProgress
  }), $[55] = props2.schemaType, $[56] = props2.value, $[57] = renderPreview, $[58] = uploadProgress, $[59] = t20) : t20 = $[59];
  let t21;
  $[60] !== resolvingInitialValue ? (t21 = resolvingInitialValue && /* @__PURE__ */ jsx(LoadingBlock, { fill: !0 }), $[60] = resolvingInitialValue, $[61] = t21) : t21 = $[61];
  let t22;
  $[62] !== handleClick || $[63] !== onFocus || $[64] !== resolvingInitialValue || $[65] !== t20 || $[66] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Card, { as: "button", type: "button", tone: "inherit", radius: 1, disabled: resolvingInitialValue, onMouseDown: handleMouseDown, onClick: handleClick, ref: setPreviewCardElement, onFocus, __unstable_focusRing: !0, style: BUTTON_CARD_STYLE, children: [
    t20,
    t21
  ] }), $[62] = handleClick, $[63] = onFocus, $[64] = resolvingInitialValue, $[65] = t20, $[66] = t21, $[67] = t22) : t22 = $[67];
  let t23;
  $[68] !== focused || $[69] !== menu || $[70] !== open || $[71] !== presence || $[72] !== sortable || $[73] !== t19 || $[74] !== t22 || $[75] !== tone || $[76] !== validation2 ? (t23 = /* @__PURE__ */ jsx(RowLayout, { menu, presence, validation: validation2, tone, focused, dragHandle: sortable, selected: open, readOnly: t19, children: t22 }), $[68] = focused, $[69] = menu, $[70] = open, $[71] = presence, $[72] = sortable, $[73] = t19, $[74] = t22, $[75] = tone, $[76] = validation2, $[77] = t23) : t23 = $[77];
  const item = t23;
  let t24;
  if ($[78] !== changed || $[79] !== children || $[80] !== focused || $[81] !== item || $[82] !== onClose || $[83] !== openEnhancedDialog || $[84] !== openPortal || $[85] !== parentSchemaType.options?.modal?.type || $[86] !== parentSchemaType.options?.modal?.width || $[87] !== path || $[88] !== previewCardElement || $[89] !== readOnly || $[90] !== schemaType || $[91] !== t || $[92] !== value) {
    const itemTypeTitle = getSchemaTypeTitle(schemaType), t25 = !!focused;
    let t26;
    $[94] !== item ? (t26 = /* @__PURE__ */ jsx(Box, { paddingX: 1, children: item }), $[94] = item, $[95] = t26) : t26 = $[95];
    let t27;
    $[96] !== changed || $[97] !== path || $[98] !== t25 || $[99] !== t26 ? (t27 = /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: t25, children: t26 }), $[96] = changed, $[97] = path, $[98] = t25, $[99] = t26, $[100] = t27) : t27 = $[100], t24 = /* @__PURE__ */ jsxs(EnhancedObjectDialogProvider, { children: [
      t27,
      openPortal && /* @__PURE__ */ jsx(EditPortal, { header: readOnly ? t("inputs.array.action.view", {
        itemTypeTitle
      }) : t("inputs.array.action.edit", {
        itemTypeTitle
      }), type: parentSchemaType?.options?.modal?.type || "dialog", width: parentSchemaType?.options?.modal?.width ?? 1, id: value._key, onClose, autofocus: focused, legacy_referenceElement: previewCardElement, children }),
      openEnhancedDialog && /* @__PURE__ */ jsx(EnhancedObjectDialog, { header: readOnly ? t("inputs.array.action.view", {
        itemTypeTitle
      }) : t("inputs.array.action.edit", {
        itemTypeTitle
      }), type: parentSchemaType?.options?.modal?.type || "dialog", width: parentSchemaType?.options?.modal?.width ?? 1, id: value._key, onClose, autofocus: focused, legacy_referenceElement: previewCardElement, children })
    ] }), $[78] = changed, $[79] = children, $[80] = focused, $[81] = item, $[82] = onClose, $[83] = openEnhancedDialog, $[84] = openPortal, $[85] = parentSchemaType.options?.modal?.type, $[86] = parentSchemaType.options?.modal?.width, $[87] = path, $[88] = previewCardElement, $[89] = readOnly, $[90] = schemaType, $[91] = t, $[92] = value, $[93] = t24;
  } else
    t24 = $[93];
  return t24;
}
function _temp3$v(event) {
  event.preventDefault();
}
function _temp2$$(v_0) {
  return v_0.level === "warning";
}
function _temp$2q(v) {
  return v.level === "error";
}
function ReferenceItemRefProvider(props2) {
  const $ = c(7), {
    menuRef,
    menuButtonRef,
    containerRef
  } = props2;
  let t0;
  $[0] !== containerRef || $[1] !== menuButtonRef || $[2] !== menuRef ? (t0 = {
    menuRef,
    menuButtonRef,
    containerRef
  }, $[0] = containerRef, $[1] = menuButtonRef, $[2] = menuRef, $[3] = t0) : t0 = $[3];
  const value = t0;
  let t1;
  return $[4] !== props2.children || $[5] !== value ? (t1 = /* @__PURE__ */ jsx(ReferenceItemRefContext.Provider, { value, children: props2.children }), $[4] = props2.children, $[5] = value, $[6] = t1) : t1 = $[6], t1;
}
function getTone({
  readOnly,
  hasErrors,
  hasWarnings
}) {
  return readOnly ? "transparent" : hasErrors ? "critical" : hasWarnings ? "caution" : "default";
}
const MENU_POPOVER_PROPS = {
  portal: !0,
  tone: "default"
};
function ReferenceItem(props2) {
  const $ = c(114), {
    schemaType,
    parentSchemaType,
    path,
    readOnly,
    onRemove,
    value,
    open,
    onInsert,
    onCopy,
    presence,
    validation: validation2,
    inputId,
    changed,
    focused,
    children,
    inputProps: t0
  } = props2, {
    onChange,
    focusPath,
    onPathFocus,
    renderPreview,
    elementProps
  } = t0, sortable = parentSchemaType.options?.sortable !== !1, insertableTypes = parentSchemaType.of, elementRef = useRef(null), menuRef = useRef(null), menuButtonRef = useRef(null), containerRef = useRef(null);
  let t1;
  $[0] !== path || $[1] !== schemaType || $[2] !== value ? (t1 = {
    path,
    schemaType,
    value
  }, $[0] = path, $[1] = schemaType, $[2] = value, $[3] = t1) : t1 = $[3];
  const {
    EditReferenceLink,
    getReferenceInfo: getReferenceInfo2,
    selectedState,
    isCurrentDocumentLiveEdit
  } = useReferenceInput(t1);
  useScrollIntoViewOnFocusWithin(elementRef, open);
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && elementRef.current && elementRef.current?.focus();
  }, $[4] = t2) : t2 = $[4], useDidUpdate(focused, t2);
  const hasErrors = props2.validation.some(_temp$2p), hasWarnings = props2.validation.some(_temp2$_), resolvingInitialValue = value._resolvingInitialValue;
  let t3;
  $[5] !== onInsert || $[6] !== value ? (t3 = () => {
    onInsert({
      items: [regenerateKeys(value)],
      position: "after"
    });
  }, $[5] = onInsert, $[6] = value, $[7] = t3) : t3 = $[7];
  const handleDuplicate = t3;
  let t4;
  $[8] !== onCopy || $[9] !== value ? (t4 = () => {
    onCopy({
      items: [regenerateKeys(value)]
    });
  }, $[8] = onCopy, $[9] = value, $[10] = t4) : t4 = $[10];
  const handleCopy = t4;
  let t5;
  $[11] !== onInsert ? (t5 = (pos, insertType) => {
    onInsert({
      items: [{
        ...createProtoArrayValue(insertType),
        _key: randomKey()
      }],
      position: pos
    });
  }, $[11] = onInsert, $[12] = t5) : t5 = $[12];
  const handleInsert = t5, loadableReferenceInfo = useReferenceInfo$2(value?._ref, getReferenceInfo2), hasRef = value._ref, refTypeName = loadableReferenceInfo.result?.type || value?._strengthenOnPublish?.type, publishedReferenceExists = hasRef && loadableReferenceInfo.result?.isPublished;
  let t6;
  $[13] !== onChange || $[14] !== schemaType.weak ? (t6 = () => {
    onChange([schemaType.weak === !0 ? set(!0, ["_weak"]) : unset(["_weak"]), unset(["_strengthenOnPublish"])]);
  }, $[13] = onChange, $[14] = schemaType.weak, $[15] = t6) : t6 = $[15];
  const handleRemoveStrengthenOnPublish = t6;
  let t7;
  $[16] !== refTypeName || $[17] !== schemaType.to ? (t7 = refTypeName ? schemaType.to.find((toType) => toType.name === refTypeName) : void 0, $[16] = refTypeName, $[17] = schemaType.to, $[18] = t7) : t7 = $[18];
  const refType = t7, pressed = selectedState === "pressed", selected = selectedState === "selected", tone = getTone({
    readOnly,
    hasErrors,
    hasWarnings
  }), isEditing = !hasRef || focusPath[0] === "_ref", {
    t
  } = useTranslation();
  let t8;
  $[19] !== hasRef || $[20] !== isEditing || $[21] !== onPathFocus ? (t8 = () => {
    onPathFocus(hasRef && isEditing ? [] : ["_ref"]);
  }, $[19] = hasRef, $[20] = isEditing, $[21] = onPathFocus, $[22] = t8) : t8 = $[22];
  const handleReplace = t8, [contextMenuButtonElement, setContextMenuButtonElement] = useState(null);
  let t9;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = (element) => {
    setContextMenuButtonElement(element), menuButtonRef.current = element;
  }, $[23] = t9) : t9 = $[23];
  const setMenuButtonRef = t9, maxReached = useArrayValidation()?.maxReached;
  let t10;
  $[24] !== maxReached || $[25] !== t ? (t10 = maxReached ? t("inputs.array.action.max-reached") : void 0, $[24] = maxReached, $[25] = t, $[26] = t10) : t10 = $[26];
  const maxReachedReason = t10, t11 = parentSchemaType.options?.insertMenu;
  let t12;
  $[27] !== contextMenuButtonElement || $[28] !== handleInsert || $[29] !== insertableTypes || $[30] !== maxReached || $[31] !== maxReachedReason || $[32] !== t11 ? (t12 = {
    schemaTypes: insertableTypes,
    insertMenuOptions: t11,
    onInsert: handleInsert,
    referenceElement: contextMenuButtonElement,
    disabled: maxReached,
    disabledReason: maxReachedReason
  }, $[27] = contextMenuButtonElement, $[28] = handleInsert, $[29] = insertableTypes, $[30] = maxReached, $[31] = maxReachedReason, $[32] = t11, $[33] = t12) : t12 = $[33];
  const {
    insertBefore,
    insertAfter: insertAfter2
  } = useInsertMenuMenuItems(t12), disableActions = parentSchemaType.options?.disableActions || EMPTY_ARRAY$y;
  let t13;
  $[34] !== onChange || $[35] !== schemaType.weak ? (t13 = () => {
    onChange(schemaType.weak === !0 ? set(!0, ["_weak"]) : unset(["_weak"]));
  }, $[34] = onChange, $[35] = schemaType.weak, $[36] = t13) : t13 = $[36];
  const handleFixStrengthMismatch = t13, actualStrength = value?._weak ? "weak" : "strong", weakShouldBe = schemaType.weak === !0 ? "weak" : "strong", weakWarningOverride = hasRef && !loadableReferenceInfo.isLoading && value?._strengthenOnPublish, showWeakRefMismatch = !loadableReferenceInfo.isLoading && loadableReferenceInfo.result?.availability.available && hasRef && actualStrength !== weakShouldBe && !weakWarningOverride;
  let t14;
  $[37] !== handleRemoveStrengthenOnPublish || $[38] !== isCurrentDocumentLiveEdit || $[39] !== publishedReferenceExists || $[40] !== schemaType || $[41] !== value._strengthenOnPublish ? (t14 = isCurrentDocumentLiveEdit && publishedReferenceExists && value._strengthenOnPublish && /* @__PURE__ */ jsx(ReferenceFinalizeAlertStrip, { schemaType, handleRemoveStrengthenOnPublish }), $[37] = handleRemoveStrengthenOnPublish, $[38] = isCurrentDocumentLiveEdit, $[39] = publishedReferenceExists, $[40] = schemaType, $[41] = value._strengthenOnPublish, $[42] = t14) : t14 = $[42];
  let t15;
  $[43] !== actualStrength || $[44] !== handleFixStrengthMismatch || $[45] !== showWeakRefMismatch ? (t15 = showWeakRefMismatch && /* @__PURE__ */ jsx(ReferenceStrengthMismatchAlertStrip, { actualStrength, handleFixStrengthMismatch }), $[43] = actualStrength, $[44] = handleFixStrengthMismatch, $[45] = showWeakRefMismatch, $[46] = t15) : t15 = $[46];
  let t16;
  $[47] !== loadableReferenceInfo.error || $[48] !== loadableReferenceInfo.retry ? (t16 = loadableReferenceInfo.error && /* @__PURE__ */ jsx(ReferenceMetadataLoadErrorAlertStrip, { errorMessage: loadableReferenceInfo.error.message, onHandleRetry: loadableReferenceInfo.retry }), $[47] = loadableReferenceInfo.error, $[48] = loadableReferenceInfo.retry, $[49] = t16) : t16 = $[49];
  let t17;
  $[50] !== t14 || $[51] !== t15 || $[52] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t14,
    t15,
    t16
  ] }), $[50] = t14, $[51] = t15, $[52] = t16, $[53] = t17) : t17 = $[53];
  const issues = t17;
  let t18;
  $[54] !== disableActions || $[55] !== handleCopy || $[56] !== handleDuplicate || $[57] !== handleReplace || $[58] !== hasRef || $[59] !== inputId || $[60] !== insertAfter2 || $[61] !== insertBefore || $[62] !== isEditing || $[63] !== onRemove || $[64] !== readOnly || $[65] !== refType?.name || $[66] !== t || $[67] !== value._ref ? (t18 = readOnly ? null : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(MenuButton, { ref: setMenuButtonRef, onOpen: () => {
      insertBefore.send({
        type: "close"
      }), insertAfter2.send({
        type: "close"
      });
    }, button: /* @__PURE__ */ jsx(ContextMenuButton, { selected: insertBefore.state.open || insertAfter2.state.open ? !0 : void 0, tooltipProps: {
      fallbackPlacements: ["top", "bottom"],
      placement: "right"
    } }), id: `${inputId}-menuButton`, menu: /* @__PURE__ */ jsxs(Menu, { ref: menuRef, children: [
      !readOnly && /* @__PURE__ */ jsxs(Fragment$1, { children: [
        !disableActions.includes("remove") && /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.reference.action.remove"), tone: "critical", icon: TrashIcon, onClick: onRemove }),
        /* @__PURE__ */ jsx(MenuItem, { text: t(hasRef && isEditing ? "inputs.reference.action.replace-cancel" : "inputs.reference.action.replace"), icon: hasRef && isEditing ? CloseIcon : SyncIcon, onClick: handleReplace }),
        !disableActions.includes("copy") && /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.reference.action.copy"), icon: CopyIcon, onClick: handleCopy }),
        !disableActions.includes("duplicate") && /* @__PURE__ */ jsx(MenuItem, { text: t("inputs.reference.action.duplicate"), icon: AddDocumentIcon, onClick: handleDuplicate }),
        !(disableActions.includes("add") || disableActions.includes("addBefore")) && insertBefore.menuItem,
        !disableActions.includes("add") && !disableActions.includes("addAfter") && insertAfter2.menuItem
      ] }),
      !readOnly && !isEditing && hasRef && /* @__PURE__ */ jsx(MenuDivider, {}),
      !isEditing && hasRef && /* @__PURE__ */ jsx(MenuItem, { as: IntentLink, icon: LaunchIcon, intent: "edit", params: {
        id: value?._ref,
        type: refType?.name
      }, rel: "noopener noreferrer", target: "_blank", text: t("inputs.reference.action.open-in-new-tab") })
    ] }), popover: MENU_POPOVER_PROPS }),
    insertBefore.popover,
    insertAfter2.popover
  ] }), $[54] = disableActions, $[55] = handleCopy, $[56] = handleDuplicate, $[57] = handleReplace, $[58] = hasRef, $[59] = inputId, $[60] = insertAfter2, $[61] = insertBefore, $[62] = isEditing, $[63] = onRemove, $[64] = readOnly, $[65] = refType?.name, $[66] = t, $[67] = value._ref, $[68] = t18) : t18 = $[68];
  const menu = t18, t19 = !!readOnly;
  let t20;
  $[69] !== isEditing || $[70] !== presence ? (t20 = !isEditing && presence.length > 0 && /* @__PURE__ */ jsx(FieldPresence, { presence, maxAvatars: 1 }), $[69] = isEditing, $[70] = presence, $[71] = t20) : t20 = $[71];
  let t21;
  $[72] !== isEditing || $[73] !== validation2 ? (t21 = !isEditing && validation2.length > 0 && /* @__PURE__ */ jsx(FormFieldValidationStatus, { validation: validation2 }), $[72] = isEditing, $[73] = validation2, $[74] = t21) : t21 = $[74];
  const t22 = isEditing ? void 0 : issues, t23 = isEditing ? void 0 : tone;
  let t24;
  $[75] !== EditReferenceLink || $[76] !== children || $[77] !== elementProps || $[78] !== inputId || $[79] !== isEditing || $[80] !== loadableReferenceInfo || $[81] !== path || $[82] !== presence || $[83] !== pressed || $[84] !== readOnly || $[85] !== refType?.name || $[86] !== renderPreview || $[87] !== resolvingInitialValue || $[88] !== schemaType || $[89] !== selected || $[90] !== validation2 || $[91] !== value ? (t24 = isEditing ? /* @__PURE__ */ jsx(Box, { padding: 1, ref: containerRef, children: /* @__PURE__ */ jsx(FormFieldSet, { title: schemaType.title, description: schemaType.description, __unstable_presence: presence, validation: validation2, inputId, deprecated: schemaType.deprecated, schemaType, path, readOnly, children }) }) : /* @__PURE__ */ jsxs(ReferenceLinkCard, { as: EditReferenceLink, tone: "inherit", radius: 2, documentId: value?._ref, documentType: refType?.name, disabled: resolvingInitialValue, __unstable_focusRing: !0, selected, pressed, "data-selected": selected ? !0 : void 0, "data-pressed": pressed ? !0 : void 0, ...elementProps, children: [
    /* @__PURE__ */ jsx(PreviewReferenceValue$2, { value, referenceInfo: loadableReferenceInfo, renderPreview, type: schemaType }),
    resolvingInitialValue && /* @__PURE__ */ jsx(LoadingBlock, { fill: !0 })
  ] }), $[75] = EditReferenceLink, $[76] = children, $[77] = elementProps, $[78] = inputId, $[79] = isEditing, $[80] = loadableReferenceInfo, $[81] = path, $[82] = presence, $[83] = pressed, $[84] = readOnly, $[85] = refType?.name, $[86] = renderPreview, $[87] = resolvingInitialValue, $[88] = schemaType, $[89] = selected, $[90] = validation2, $[91] = value, $[92] = t24) : t24 = $[92];
  let t25;
  $[93] !== focused || $[94] !== menu || $[95] !== sortable || $[96] !== t19 || $[97] !== t20 || $[98] !== t21 || $[99] !== t22 || $[100] !== t23 || $[101] !== t24 ? (t25 = /* @__PURE__ */ jsx(ReferenceItemRefProvider, { menuRef, menuButtonRef, containerRef, children: /* @__PURE__ */ jsx(RowLayout, { dragHandle: sortable, readOnly: t19, presence: t20, validation: t21, menu, footer: t22, tone: t23, focused, children: t24 }) }), $[93] = focused, $[94] = menu, $[95] = sortable, $[96] = t19, $[97] = t20, $[98] = t21, $[99] = t22, $[100] = t23, $[101] = t24, $[102] = t25) : t25 = $[102];
  const item = t25, t26 = !!focused;
  let t27;
  $[103] !== item ? (t27 = /* @__PURE__ */ jsx(Box, { paddingX: 1, children: item }), $[103] = item, $[104] = t27) : t27 = $[104];
  let t28;
  $[105] !== changed || $[106] !== path || $[107] !== t26 || $[108] !== t27 ? (t28 = /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: t26, children: t27 }), $[105] = changed, $[106] = path, $[107] = t26, $[108] = t27, $[109] = t28) : t28 = $[109];
  let t29;
  return $[110] !== path || $[111] !== readOnly || $[112] !== t28 ? (t29 = /* @__PURE__ */ jsx(FormNodeDivergenceDetail, { path, readOnly, children: t28 }), $[110] = path, $[111] = readOnly, $[112] = t28, $[113] = t29) : t29 = $[113], t29;
}
function _temp2$_(v_0) {
  return v_0.level === "warning";
}
function _temp$2p(v) {
  return v.level === "error";
}
function defaultResolveItemComponent(schemaType) {
  return schemaType.components?.item ? schemaType.components.item : isReferenceSchemaType(schemaType) ? ReferenceItem : PreviewItem;
}
const defaultRenderAnnotation = (props2) => {
  const Annotation2 = defaultResolveAnnotationComponent(props2.schemaType);
  return /* @__PURE__ */ jsx(Annotation2, { ...props2 });
}, defaultRenderBlock = (props2) => {
  const Block2 = defaultResolveBlockComponent(props2.schemaType);
  return /* @__PURE__ */ jsx(Block2, { ...props2 });
}, defaultRenderInlineBlock = (props2) => {
  const InlineBlock = defaultResolveInlineBlockComponent(props2.schemaType);
  return /* @__PURE__ */ jsx(InlineBlock, { ...props2 });
}, defaultRenderField = (props2) => {
  const Field = defaultResolveFieldComponent(props2.schemaType);
  return /* @__PURE__ */ jsx(Field, { ...props2 });
}, defaultRenderInput = (props2) => {
  const Input2 = defaultResolveInputComponent(props2.schemaType);
  return /* @__PURE__ */ jsx(Input2, { ...props2 });
}, defaultRenderItem = (props2) => {
  const Item2 = defaultResolveItemComponent(props2.schemaType);
  return /* @__PURE__ */ jsx(Item2, { ...props2 });
}, defaultRenderPreview = (props2) => /* @__PURE__ */ jsx(Preview$1, { ...props2 }), MAX_FIELD_DEPTH = 20, AUTO_COLLAPSE_DEPTH = 3, ALL_FIELDS_GROUP = {
  name: ALL_FIELDS_GROUP_NAME,
  title: "All fields",
  hidden: !1,
  i18n: {
    title: {
      key: "inputs.object.field-group-tabs.all-fields-title",
      ns: studioLocaleNamespace
    }
  }
};
function identity(t) {
  return t;
}
function createMemoizer({
  getPath,
  hashInput,
  decorator = identity
}) {
  const cache2 = /* @__PURE__ */ new Map();
  function memoizer(fn) {
    function memoizedFn(...args) {
      const path = toString(getPath(...args)), hashed = hashInput(...args), serializedHash = JSON.stringify(hashed), cached = cache2.get(path);
      if (serializedHash === cached?.serializedHash) return cached.result;
      const result = fn(...args);
      return cache2.set(path, {
        serializedHash,
        result
      }), result;
    }
    return decorator(memoizedFn);
  }
  return memoizer;
}
function getCollapsedWithDefaults(options = {}, level) {
  if (options?.collapsible === !1 || options?.collapsable === !1)
    return {
      collapsible: !1,
      collapsed: !1
    };
  const collapsed = typeof options?.collapsed == "boolean" ? options.collapsed : level >= AUTO_COLLAPSE_DEPTH ? !0 : void 0;
  return {
    collapsible: options?.collapsible === !0 || options?.collapsable === !0 || collapsed === !0 ? !0 : void 0,
    collapsed
  };
}
const idCache = /* @__PURE__ */ new WeakMap(), undefinedKey = {
  key: "GetIdUndefined"
}, nullKey = {
  key: "GetIdNull"
};
function getId(value) {
  switch (typeof value) {
    case "undefined":
      return getId(undefinedKey);
    case "function":
    case "object":
    case "symbol": {
      if (value === null) return getId(nullKey);
      const cached = idCache.get(value);
      if (cached) return cached;
      const id2 = nanoid();
      return idCache.set(value, id2), id2;
    }
    default:
      return `${value}`;
  }
}
function getItemType(arrayType, item) {
  const itemTypeName = resolveTypeName$1(item);
  return itemTypeName === "object" && arrayType.of.length === 1 ? arrayType.of[0] : arrayType.of.find((memberType) => memberType.name === itemTypeName);
}
function getPrimitiveItemType(arrayType, item) {
  const itemTypeName = resolveTypeName$1(item);
  return arrayType?.of.find((memberType) => memberType.name === itemTypeName || memberType.jsonType === itemTypeName);
}
const UNSAFE_NAMES = ["parentNode", "childNodes", "firstChild", "lastChild", "nextSibling", "previousSibling", "parentElement", "textContent", "nodeType", "nodeName", "nodeValue", "ownerDocument", "baseURI", "isConnected", "children", "firstElementChild", "lastElementChild", "nextElementSibling", "previousElementSibling", "childElementCount", "innerHTML", "outerHTML", "className", "classList", "tagName", "attributes", "scrollTop", "scrollLeft", "scrollWidth", "scrollHeight", "clientTop", "clientLeft", "clientWidth", "clientHeight", "offsetParent", "offsetTop", "offsetLeft", "offsetWidth", "offsetHeight"];
function getSafeDomId(input) {
  return UNSAFE_NAMES.includes(input) ? `sanitized-${input}` : input;
}
function isFieldEnabledByGroupFilter(groupsConfig, fieldGroup, selectedGroup) {
  return selectedGroup ? selectedGroup.name === ALL_FIELDS_GROUP.name ? !0 : fieldGroup === void 0 ? !1 : groupsConfig.length === 0 && selectedGroup.name === ALL_FIELDS_GROUP.name ? !0 : castArray(fieldGroup).includes(selectedGroup.name) : !1;
}
function isAcceptedObjectValue(value) {
  return typeof value > "u" || isRecord$4(value);
}
function isValidArrayOfObjectsValue(value) {
  return typeof value > "u" || Array.isArray(value);
}
function isValidArrayOfPrimitivesValue(value) {
  return typeof value > "u" || Array.isArray(value);
}
function everyItemIsObject(value) {
  return value.length === 0 || value.every((item) => isRecord$4(item));
}
function findDuplicateKeyEntries(array) {
  const seenKeys = /* @__PURE__ */ new Set();
  return array.reduce((acc, item, index) => (seenKeys.has(item._key) && acc.push([index, item._key]), seenKeys.add(item._key), acc), []);
}
function hasKey(value) {
  return "_key" in value;
}
function everyItemHasKey(array) {
  return array?.every((item) => isRecord$4(item) && hasKey(item));
}
function isChangedValue(value, comparisonValue) {
  return Array.isArray(value) && typeof comparisonValue > "u" || Array.isArray(comparisonValue) && typeof value > "u" ? !1 : value && !comparisonValue ? !0 : !isEqual$1(value, comparisonValue);
}
function createPrepareFormState({
  decorators = {}
} = {}) {
  const memoizePrepareFieldMember = createMemoizer({
    decorator: decorators.prepareFieldMember,
    getPath: ({
      parent,
      field
    }) => [...parent.path, field.name],
    hashInput: ({
      parent,
      field
    }) => {
      const path = [...parent.path, field.name];
      return {
        changesOpen: parent.changesOpen,
        presence: parent.presence.filter((p) => startsWith(path, p.path)),
        validation: parent.validation.filter((v) => startsWith(path, v.path)),
        focusPath: startsWith(path, parent.focusPath) ? parent.focusPath : [],
        openPath: startsWith(path, parent.openPath) ? parent.openPath : [],
        value: getId(parent.value?.[field.name]),
        comparisonValue: getId(parent.comparisonValue?.[field.name]),
        collapsedFieldSets: getId(parent.collapsedFieldSets?.children?.[field.name]),
        collapsedPaths: getId(parent.collapsedPaths?.children?.[field.name]),
        currentUser: getId(parent.currentUser),
        fieldGroupState: getId(parent.fieldGroupState),
        hidden: parent.hidden === !0 || parent.hidden?.value || getId(parent.hidden?.children?.[field.name]),
        readOnly: parent.readOnly === !0 || parent.readOnly?.value || getId(parent.readOnly?.children?.[field.name]),
        schemaType: getId(parent.schemaType),
        hasUpstreamVersion: parent.hasUpstreamVersion,
        displayInlineChanges: parent.displayInlineChanges
      };
    }
  }), memoizePrepareObjectInputState = createMemoizer({
    decorator: decorators.prepareObjectInputState,
    getPath: ({
      path
    }) => path,
    hashInput: (state) => ({
      changesOpen: state.changesOpen,
      presence: state.presence.filter((p) => startsWith(state.path, p.path)),
      validation: state.validation.filter((v) => startsWith(state.path, v.path)),
      focusPath: startsWith(state.path, state.focusPath) ? state.focusPath : [],
      openPath: startsWith(state.path, state.openPath) ? state.openPath : [],
      value: getId(state.value),
      comparisonValue: getId(state.comparisonValue),
      collapsedFieldSets: getId(state.collapsedFieldSets),
      collapsedPaths: state.collapsedPaths,
      currentUser: getId(state.currentUser),
      fieldGroupState: getId(state.fieldGroupState),
      hidden: state.hidden === !0 || state.hidden?.value || getId(state.hidden),
      readOnly: state.readOnly === !0 || state.readOnly?.value || getId(state.readOnly),
      schemaType: getId(state.schemaType),
      perspective: getId(state.perspective),
      hasUpstreamVersion: state.hasUpstreamVersion,
      displayInlineChanges: state.displayInlineChanges
    })
  }), memoizePrepareArrayOfPrimitivesInputState = createMemoizer({
    decorator: decorators.prepareArrayOfPrimitivesInputState,
    getPath: ({
      path
    }) => path,
    hashInput: (state) => ({
      changesOpen: state.changesOpen,
      presence: state.presence.filter((p) => startsWith(state.path, p.path)),
      validation: state.validation.filter((v) => startsWith(state.path, v.path)),
      focusPath: startsWith(state.path, state.focusPath) ? state.focusPath : [],
      openPath: startsWith(state.path, state.openPath) ? state.openPath : [],
      value: getId(state.value),
      comparisonValue: getId(state.comparisonValue),
      collapsedFieldSets: getId(state.collapsedFieldSets),
      collapsedPaths: state.collapsedPaths,
      currentUser: getId(state.currentUser),
      fieldGroupState: getId(state.fieldGroupState),
      hidden: state.hidden === !0 || state.hidden?.value || getId(state.hidden),
      readOnly: state.readOnly === !0 || state.readOnly?.value || getId(state.readOnly),
      schemaType: getId(state.schemaType),
      perspective: getId(state.perspective),
      hasUpstreamVersion: state.hasUpstreamVersion,
      displayInlineChanges: state.displayInlineChanges
    })
  }), memoizePrepareArrayOfObjectsInputState = createMemoizer({
    decorator: decorators.prepareArrayOfObjectsInputState,
    getPath: ({
      path
    }) => path,
    hashInput: (state) => ({
      changesOpen: state.changesOpen,
      presence: state.presence.filter((p) => startsWith(state.path, p.path)),
      validation: state.validation.filter((v) => startsWith(state.path, v.path)),
      focusPath: startsWith(state.path, state.focusPath) ? state.focusPath : [],
      openPath: startsWith(state.path, state.openPath) ? state.openPath : [],
      value: getId(state.value),
      comparisonValue: getId(state.comparisonValue),
      collapsedFieldSets: getId(state.collapsedFieldSets),
      collapsedPaths: state.collapsedPaths,
      currentUser: getId(state.currentUser),
      fieldGroupState: getId(state.fieldGroupState),
      hidden: state.hidden === !0 || state.hidden?.value || getId(state.hidden),
      readOnly: state.readOnly === !0 || state.readOnly?.value || getId(state.readOnly),
      schemaType: getId(state.schemaType),
      perspective: getId(state.perspective),
      hasUpstreamVersion: state.hasUpstreamVersion,
      displayInlineChanges: state.displayInlineChanges
    })
  }), memoizePrepareArrayOfObjectsMember = createMemoizer({
    decorator: decorators.prepareArrayOfObjectsMember,
    getPath: ({
      parent,
      arrayItem
    }) => [...parent.path, {
      _key: arrayItem._key
    }],
    hashInput: ({
      parent,
      arrayItem
    }) => {
      const comparisonValue = Array.isArray(parent.comparisonValue) ? parent.comparisonValue.find((item) => isKeyedObject(item) && item._key === arrayItem._key) : void 0, key = arrayItem._key, path = [...parent.path, {
        _key: key
      }];
      return {
        changesOpen: parent.changesOpen,
        presence: parent.presence.filter((p) => startsWith(path, p.path)),
        validation: parent.validation.filter((v) => startsWith(path, v.path)),
        focusPath: startsWith(path, parent.focusPath) ? parent.focusPath : [],
        openPath: startsWith(path, parent.openPath) ? parent.openPath : [],
        value: getId(arrayItem),
        comparisonValue: getId(comparisonValue),
        collapsedFieldSets: getId(parent.collapsedFieldSets?.children?.[key]),
        collapsedPaths: getId(parent.collapsedPaths?.children?.[key]),
        currentUser: getId(parent.currentUser),
        fieldGroupState: getId(parent.fieldGroupState?.children?.[key]),
        hidden: parent.hidden === !0 || parent.hidden?.value || getId(parent.hidden?.children?.[key]),
        readOnly: parent.readOnly === !0 || parent.readOnly?.value || getId(parent.readOnly?.children?.[key]),
        schemaType: getId(parent.schemaType),
        perspective: getId(parent.perspective),
        hasUpstreamVersion: parent.hasUpstreamVersion,
        displayInlineChanges: parent.displayInlineChanges
      };
    }
  }), memoizePrepareArrayOfPrimitivesMember = createMemoizer({
    decorator: decorators.prepareArrayOfPrimitivesMember,
    getPath: ({
      parent,
      index
    }) => [...parent.path, index],
    hashInput: ({
      parent,
      index,
      arrayItem
    }) => {
      const comparisonValue = Array.isArray(parent.comparisonValue) ? parent.comparisonValue[index] : void 0, path = [...parent.path, index];
      return {
        changesOpen: parent.changesOpen,
        presence: parent.presence.filter((p) => startsWith(path, p.path)),
        validation: parent.validation.filter((v) => startsWith(path, v.path)),
        focusPath: startsWith(path, parent.focusPath) ? parent.focusPath : [],
        openPath: startsWith(path, parent.openPath) ? parent.openPath : [],
        collapsedFieldSets: getId(parent.collapsedFieldSets?.children?.[index]),
        collapsedPaths: getId(parent.collapsedPaths?.children?.[index]),
        currentUser: getId(parent.currentUser),
        fieldGroupState: getId(parent.fieldGroupState?.children?.[index]),
        hidden: parent.hidden === !0 || parent.hidden?.value || getId(parent.hidden?.children?.[index]),
        readOnly: parent.readOnly === !0 || parent.readOnly?.value || getId(parent.readOnly?.children?.[index]),
        schemaType: getId(parent.schemaType),
        value: `${arrayItem}`,
        comparisonValue: `${comparisonValue}`,
        perspective: getId(parent.perspective),
        hasUpstreamVersion: parent.hasUpstreamVersion,
        displayInlineChanges: parent.displayInlineChanges
      };
    }
  }), memoizePreparePrimitiveInputState = createMemoizer({
    decorator: decorators.preparePrimitiveInputState,
    getPath: ({
      path
    }) => path,
    hashInput: (state) => ({
      changesOpen: state.changesOpen,
      presence: state.presence.filter((p) => startsWith(state.path, p.path)),
      validation: state.validation.filter((v) => startsWith(state.path, v.path)),
      focusPath: startsWith(state.path, state.focusPath) ? state.focusPath : [],
      openPath: startsWith(state.path, state.openPath) ? state.openPath : [],
      value: getId(state.value),
      comparisonValue: getId(state.comparisonValue),
      collapsedFieldSets: getId(state.collapsedFieldSets),
      collapsedPaths: state.collapsedPaths,
      currentUser: getId(state.currentUser),
      fieldGroupState: getId(state.fieldGroupState),
      hidden: state.hidden === !0 || state.hidden?.value || getId(state.hidden),
      readOnly: state.readOnly === !0 || state.readOnly?.value || getId(state.readOnly),
      schemaType: getId(state.schemaType),
      perspective: getId(state.perspective),
      hasUpstreamVersion: state.hasUpstreamVersion,
      displayInlineChanges: state.displayInlineChanges
    })
  }), prepareFieldMember = memoizePrepareFieldMember(function(props2) {
    const {
      field,
      index,
      parent
    } = props2, fieldPath = pathFor([...parent.path, field.name]), fieldLevel = getFieldLevel(field.type, parent.level + 1), parentValue = parent.value, parentComparisonValue = parent.comparisonValue;
    if (!isAcceptedObjectValue(parentValue))
      throw new Error("Unexpected non-object value");
    const normalizedFieldGroupNames = field.group ? castArray(field.group) : [], inSelectedGroup = isFieldEnabledByGroupFilter(parent.groups, field.group, parent.selectedGroup);
    if (isObjectSchemaType(field.type)) {
      const fieldValue = parentValue?.[field.name], fieldComparisonValue = isRecord$4(parentComparisonValue) ? parentComparisonValue?.[field.name] : void 0;
      if (!isAcceptedObjectValue(fieldValue))
        return {
          kind: "error",
          key: field.name,
          fieldName: field.name,
          path: fieldPath,
          error: {
            type: "INCOMPATIBLE_TYPE",
            expectedSchemaType: field.type,
            resolvedValueType: resolveTypeName$1(fieldValue),
            value: fieldValue
          }
        };
      if (parent.hidden === !0 || parent?.hidden?.value || parent.hidden?.children?.[field.name]?.value)
        return {
          kind: "hidden",
          key: `field-${field.name}`,
          name: field.name,
          index,
          path: fieldPath
        };
      const fieldGroupState = parent.fieldGroupState?.children?.[field.name], scopedCollapsedPaths = parent.collapsedPaths?.children?.[field.name], scopedCollapsedFieldsets = parent.collapsedFieldSets?.children?.[field.name], scopedHidden = parent.hidden === !0 || parent.hidden?.value || parent.hidden?.children?.[field.name], scopedReadOnly = parent.readOnly === !0 || parent.readOnly?.value || parent.readOnly?.children?.[field.name], inputState = prepareObjectInputState({
        schemaType: field.type,
        currentUser: parent.currentUser,
        value: fieldValue,
        changed: isChangedValue(fieldValue, fieldComparisonValue),
        comparisonValue: fieldComparisonValue,
        perspective: parent.perspective,
        hasUpstreamVersion: parent.hasUpstreamVersion,
        presence: parent.presence,
        validation: parent.validation,
        fieldGroupState,
        path: fieldPath,
        level: fieldLevel,
        focusPath: parent.focusPath,
        openPath: parent.openPath,
        collapsedPaths: scopedCollapsedPaths,
        collapsedFieldSets: scopedCollapsedFieldsets,
        hidden: scopedHidden,
        readOnly: scopedReadOnly,
        changesOpen: parent.changesOpen,
        displayInlineChanges: parent.displayInlineChanges
      });
      if (inputState === null)
        return null;
      const defaultCollapsedState = getCollapsedWithDefaults(field.type.options, fieldLevel), collapsed = scopedCollapsedPaths ? scopedCollapsedPaths.value : defaultCollapsedState.collapsed;
      return {
        kind: "field",
        key: `field-${field.name}`,
        name: field.name,
        index,
        path: fieldPath,
        inSelectedGroup,
        groups: normalizedFieldGroupNames,
        open: startsWith(fieldPath, parent.openPath),
        field: inputState,
        collapsed,
        collapsible: defaultCollapsedState.collapsible
      };
    } else if (isArraySchemaType(field.type)) {
      const fieldValue = parentValue?.[field.name], fieldComparisonValue = isRecord$4(parentComparisonValue) ? parentComparisonValue?.[field.name] : void 0;
      if (isArrayOfObjectsSchemaType(field.type)) {
        const hasValue2 = typeof fieldValue < "u";
        if (hasValue2 && !isValidArrayOfObjectsValue(fieldValue)) {
          const resolvedValueType = resolveTypeName$1(fieldValue);
          return {
            kind: "error",
            key: field.name,
            fieldName: field.name,
            path: fieldPath,
            error: {
              type: "INCOMPATIBLE_TYPE",
              expectedSchemaType: field.type,
              resolvedValueType,
              value: fieldValue
            }
          };
        }
        if (hasValue2 && !everyItemIsObject(fieldValue))
          return {
            kind: "error",
            key: field.name,
            fieldName: field.name,
            path: fieldPath,
            error: {
              type: "MIXED_ARRAY",
              schemaType: field.type,
              value: fieldValue
            }
          };
        if (hasValue2 && !everyItemHasKey(fieldValue))
          return {
            kind: "error",
            key: field.name,
            fieldName: field.name,
            path: fieldPath,
            error: {
              type: "MISSING_KEYS",
              value: fieldValue,
              schemaType: field.type
            }
          };
        const duplicateKeyEntries = hasValue2 ? findDuplicateKeyEntries(fieldValue) : [];
        if (duplicateKeyEntries.length > 0)
          return {
            kind: "error",
            key: field.name,
            fieldName: field.name,
            path: fieldPath,
            error: {
              type: "DUPLICATE_KEYS",
              duplicates: duplicateKeyEntries,
              schemaType: field.type
            }
          };
        const fieldGroupState = parent.fieldGroupState?.children?.[field.name], scopedCollapsedPaths = parent.collapsedPaths?.children?.[field.name], scopedCollapsedFieldSets = parent.collapsedFieldSets?.children?.[field.name], scopedHidden = parent.hidden === !0 || parent.hidden?.value || parent.hidden?.children?.[field.name], scopedReadOnly = parent.readOnly === !0 || parent.readOnly?.value || parent.readOnly?.children?.[field.name], fieldState = prepareArrayOfObjectsInputState({
          schemaType: field.type,
          currentUser: parent.currentUser,
          value: fieldValue,
          changed: isChangedValue(fieldValue, fieldComparisonValue),
          comparisonValue: fieldComparisonValue,
          fieldGroupState,
          focusPath: parent.focusPath,
          openPath: parent.openPath,
          perspective: parent.perspective,
          hasUpstreamVersion: parent.hasUpstreamVersion,
          presence: parent.presence,
          validation: parent.validation,
          collapsedPaths: scopedCollapsedPaths,
          collapsedFieldSets: scopedCollapsedFieldSets,
          level: fieldLevel,
          path: fieldPath,
          readOnly: scopedReadOnly,
          hidden: scopedHidden,
          changesOpen: parent.changesOpen,
          displayInlineChanges: parent.displayInlineChanges
        });
        return fieldState === null ? null : {
          kind: "field",
          key: `field-${field.name}`,
          path: fieldPath,
          name: field.name,
          index,
          open: startsWith(fieldPath, parent.openPath),
          inSelectedGroup,
          groups: normalizedFieldGroupNames,
          collapsible: !1,
          collapsed: !1,
          // note: this is what we actually end up passing down as to the next input component
          field: fieldState
        };
      } else {
        if (!isValidArrayOfPrimitivesValue(fieldValue)) {
          const resolvedValueType = resolveTypeName$1(fieldValue);
          return {
            kind: "error",
            key: field.name,
            path: fieldPath,
            fieldName: field.name,
            error: {
              type: "INCOMPATIBLE_TYPE",
              expectedSchemaType: field.type,
              resolvedValueType,
              value: fieldValue
            }
          };
        }
        const fieldGroupState = parent.fieldGroupState?.children?.[field.name], scopedCollapsedPaths = parent.collapsedPaths?.children?.[field.name], scopedCollapsedFieldSets = parent.collapsedFieldSets?.children?.[field.name], scopedHidden = parent.hidden === !0 || parent.hidden?.value || parent.hidden?.children?.[field.name], scopedReadOnly = parent.readOnly === !0 || parent.readOnly?.value || parent.readOnly?.children?.[field.name], fieldState = prepareArrayOfPrimitivesInputState({
          changed: isChangedValue(fieldValue, fieldComparisonValue),
          comparisonValue: fieldComparisonValue,
          schemaType: field.type,
          currentUser: parent.currentUser,
          value: fieldValue,
          fieldGroupState,
          focusPath: parent.focusPath,
          openPath: parent.openPath,
          perspective: parent.perspective,
          hasUpstreamVersion: parent.hasUpstreamVersion,
          presence: parent.presence,
          validation: parent.validation,
          collapsedPaths: scopedCollapsedPaths,
          collapsedFieldSets: scopedCollapsedFieldSets,
          level: fieldLevel,
          path: fieldPath,
          readOnly: scopedReadOnly,
          hidden: scopedHidden,
          changesOpen: parent.changesOpen,
          displayInlineChanges: parent.displayInlineChanges
        });
        return fieldState === null ? null : {
          kind: "field",
          key: `field-${field.name}`,
          path: fieldPath,
          name: field.name,
          index,
          inSelectedGroup,
          groups: normalizedFieldGroupNames,
          open: startsWith(fieldPath, parent.openPath),
          // todo: consider support for collapsible arrays
          collapsible: !1,
          collapsed: !1,
          // note: this is what we actually end up passing down as to the next input component
          field: fieldState
        };
      }
    } else {
      const fieldValue = parentValue?.[field.name], fieldComparisonValue = isRecord$4(parentComparisonValue) ? parentComparisonValue?.[field.name] : void 0;
      if (parent.hidden === !0 || parent.hidden?.value || parent.hidden?.children?.[field.name]?.value)
        return null;
      const scopedHidden = parent.hidden === !0 || parent.hidden?.value || parent.hidden?.children?.[field.name], scopedReadOnly = parent.readOnly === !0 || parent.readOnly?.value || parent.readOnly?.children?.[field.name], fieldState = preparePrimitiveInputState({
        ...parent,
        comparisonValue: fieldComparisonValue,
        value: fieldValue,
        schemaType: field.type,
        path: fieldPath,
        readOnly: scopedReadOnly,
        hidden: scopedHidden
      });
      return {
        kind: "field",
        key: `field-${field.name}`,
        path: fieldPath,
        name: field.name,
        index,
        open: startsWith(fieldPath, parent.openPath),
        inSelectedGroup,
        groups: normalizedFieldGroupNames,
        // todo: consider support for collapsible primitive fields
        collapsible: !1,
        collapsed: !1,
        field: fieldState
      };
    }
  }), prepareObjectInputState = memoizePrepareObjectInputState(function(props2, enableHiddenCheck = !0) {
    if (props2.level === MAX_FIELD_DEPTH)
      return null;
    const readOnly = props2.readOnly === !0 || props2.readOnly?.value, schemaTypeGroupConfig = props2.schemaType.groups || [], shouldRenderAllFieldsGroup = (
      // All fields can't be hidden when review changes is open or if the all fields group is selected
      props2.changesOpen || props2.fieldGroupState?.value === ALL_FIELDS_GROUP.name
    ), isGroupHidden = (group2) => shouldRenderAllFieldsGroup && group2.name === ALL_FIELDS_GROUP.name ? !1 : props2.hidden === !0 || props2.hidden?.value || props2.hidden?.children?.[`group:${group2.name}`]?.value, groupsConfig = schemaTypeGroupConfig.some((g) => g.name === ALL_FIELDS_GROUP.name) ? schemaTypeGroupConfig : [ALL_FIELDS_GROUP, ...schemaTypeGroupConfig], defaultGroupName = (groupsConfig.find((g) => g.default) || // Use the first non-hidden group as default, if no default group is found.
    groupsConfig.find((g) => !isGroupHidden(g)) || groupsConfig[0]).name, groups = groupsConfig.flatMap((group2) => {
      const groupHidden = isGroupHidden(group2), isSelected = group2.name === (props2.fieldGroupState?.value || defaultGroupName), selected = props2.changesOpen ? group2.name === ALL_FIELDS_GROUP.name : isSelected, disabled = props2.changesOpen ? !selected : !1;
      return groupHidden ? [] : [{
        disabled,
        icon: group2?.icon,
        name: group2.name,
        selected,
        title: group2.title,
        i18n: group2.i18n,
        fields: group2.fields || EMPTY_ARRAY$y
      }];
    }), selectedGroup = groups.find((group2) => group2.selected), members = (props2.schemaType.fieldsets ? props2.schemaType.fieldsets : props2.schemaType.fields.map((field) => ({
      single: !0,
      field
    }))).flatMap((fieldSet, index) => {
      if (fieldSet.single) {
        const field = fieldSet.field, fieldMember = prepareFieldMember({
          field,
          parent: {
            ...props2,
            groups,
            selectedGroup
          },
          index
        });
        return fieldMember ? [fieldMember] : [];
      }
      const fieldsetHidden = props2.hidden === !0 || props2.hidden?.value || props2.hidden?.children?.[`fieldset:${fieldSet.name}`]?.value, fieldsetMembers = fieldSet.fields.flatMap((field) => {
        if (fieldsetHidden)
          return [{
            kind: "hidden",
            key: `field-${field.name}`,
            name: field.name,
            index
          }];
        const fieldMember = prepareFieldMember({
          field,
          parent: {
            ...props2,
            groups,
            selectedGroup
          },
          index
        });
        return fieldMember ? [fieldMember] : [];
      }), defaultCollapsedState = getCollapsedWithDefaults(fieldSet.options, props2.level), collapsed = (props2.collapsedFieldSets?.children || {})[fieldSet.name]?.value ?? defaultCollapsedState.collapsed, fieldSetPath = pathFor(props2.path.concat(fieldSet.name));
      return [{
        kind: "fieldSet",
        key: `fieldset-${fieldSet.name}`,
        path: fieldSetPath,
        _inSelectedGroup: isFieldEnabledByGroupFilter(groups, fieldSet.group, selectedGroup),
        groups: fieldSet.group ? castArray(fieldSet.group) : [],
        renderMembers: fieldSet.renderMembers,
        fieldSet: {
          path: fieldSetPath,
          name: fieldSet.name,
          title: fieldSet.title,
          description: fieldSet.description,
          hidden: !1,
          level: props2.level + 1,
          members: fieldsetMembers.filter((member) => member.kind !== "hidden"),
          collapsible: defaultCollapsedState?.collapsible,
          collapsed,
          columns: fieldSet?.options?.columns
        }
      }];
    }), hasFieldGroups = schemaTypeGroupConfig.length > 0, filteredPresence = props2.presence.filter((item) => isEqual$2(item.path, props2.path)), presence = filteredPresence.length ? filteredPresence : EMPTY_ARRAY$y, validation2 = props2.validation.filter((item) => isEqual$2(item.path, props2.path)).map((v) => ({
      level: v.level,
      message: v.message,
      path: v.path
    })), visibleMembers = members.filter((member) => member.kind !== "hidden" && // Decoration members are added in the ObjectInput component, they won't be added here.
    member.kind !== "decoration");
    if (visibleMembers.length === 0 && enableHiddenCheck)
      return null;
    const visibleGroups = hasFieldGroups ? groups.flatMap((group2) => group2.name === ALL_FIELDS_GROUP.name || visibleMembers.some((member) => member.kind === "error" ? !1 : member.kind === "field" ? member.groups.includes(group2.name) : member.groups.includes(group2.name) || member.fieldSet.members.some((fieldsetMember) => fieldsetMember.kind !== "decoration" && fieldsetMember.kind !== "error" && fieldsetMember.groups.includes(group2.name))) ? group2 : []) : [], filtereredMembers = visibleMembers.flatMap((member) => {
      if (member.kind === "error")
        return [member];
      if (member.kind === "field")
        return member.inSelectedGroup ? [member] : [];
      const filteredFieldsetMembers = member.fieldSet.members.filter((fieldsetMember) => fieldsetMember.kind !== "field" || fieldsetMember.inSelectedGroup);
      return filteredFieldsetMembers.length > 0 ? [{
        ...member,
        fieldSet: {
          ...member.fieldSet,
          members: filteredFieldsetMembers
        }
      }] : [];
    }), diffProps = prepareDiffProps(props2), node = {
      value: props2.value,
      compareValue: props2.comparisonValue ?? void 0,
      schemaType: props2.schemaType,
      readOnly,
      path: props2.path,
      id: getSafeDomId(toString(props2.path)),
      level: props2.level,
      focused: isEqual$2(props2.path, props2.focusPath),
      focusPath: trimChildPath$1(props2.path, props2.focusPath),
      presence,
      validation: validation2,
      // this is currently needed by getExpandOperations which needs to know about hidden members
      // (e.g. members not matching current group filter) in order to determine what to expand
      members: filtereredMembers,
      groups: visibleGroups,
      __unstable_computeDiff: diffProps.__unstable_computeDiff,
      changed: isChangedValue(props2.value, props2.comparisonValue),
      hasUpstreamVersion: diffProps.hasUpstreamVersion,
      displayInlineChanges: props2.displayInlineChanges
    };
    return Object.defineProperty(node, "_allMembers", {
      value: members,
      enumerable: !1
    }), node;
  }), prepareArrayOfPrimitivesInputState = memoizePrepareArrayOfPrimitivesInputState(function(props2) {
    if (props2.level === MAX_FIELD_DEPTH || props2.hidden === !0 || props2.hidden?.value)
      return null;
    const items = Array.isArray(props2.value) ? props2.value : [], filteredPresence = props2.presence.filter((item) => isEqual$2(item.path, props2.path)), presence = filteredPresence.length ? filteredPresence : EMPTY_ARRAY$y, validation2 = props2.validation.filter((item) => isEqual$2(item.path, props2.path)).map((v) => ({
      level: v.level,
      message: v.message,
      path: v.path
    })), members = items.flatMap((item, index) => prepareArrayOfPrimitivesMember({
      arrayItem: item,
      parent: props2,
      index
    })), diffProps = prepareDiffProps(props2);
    return {
      value: props2.value,
      readOnly: props2.readOnly === !0 || props2.readOnly?.value,
      schemaType: props2.schemaType,
      focused: isEqual$2(props2.path, props2.focusPath),
      focusPath: trimChildPath$1(props2.path, props2.focusPath),
      path: props2.path,
      perspective: props2.perspective,
      id: getSafeDomId(toString(props2.path)),
      level: props2.level,
      validation: validation2,
      presence,
      members,
      __unstable_computeDiff: diffProps.__unstable_computeDiff,
      // checks for changes not only on the array itself, but also on any of its items
      changed: props2.changed || members.some((m) => m.kind === "item" && m.item.changed),
      hasUpstreamVersion: diffProps.hasUpstreamVersion,
      displayInlineChanges: props2.displayInlineChanges
    };
  }), prepareArrayOfObjectsInputState = memoizePrepareArrayOfObjectsInputState(function(props2) {
    if (props2.level === MAX_FIELD_DEPTH || props2.hidden === !0 || props2.hidden?.value)
      return null;
    const items = Array.isArray(props2.value) ? props2.value : [], filteredPresence = props2.presence.filter((item) => isEqual$2(item.path, props2.path)), presence = filteredPresence.length ? filteredPresence : EMPTY_ARRAY$y, validation2 = props2.validation.filter((item) => isEqual$2(item.path, props2.path)).map((v) => ({
      level: v.level,
      message: v.message,
      path: v.path
    })), members = items.flatMap((item, index) => prepareArrayOfObjectsMember({
      arrayItem: item,
      parent: props2,
      index
    })), diffProps = prepareDiffProps(props2);
    return {
      value: props2.value,
      perspective: props2.perspective,
      readOnly: props2.readOnly === !0 || props2.readOnly?.value,
      schemaType: props2.schemaType,
      focused: isEqual$2(props2.path, props2.focusPath),
      focusPath: trimChildPath$1(props2.path, props2.focusPath),
      path: props2.path,
      id: getSafeDomId(toString(props2.path)),
      level: props2.level,
      validation: validation2,
      presence,
      members,
      __unstable_computeDiff: diffProps.__unstable_computeDiff,
      // checks for changes not only on the array itself, but also on any of its items
      changed: props2.changed || members.some((m) => m.kind === "item" && m.item.changed),
      compareValue: diffProps.compareValue,
      hasUpstreamVersion: diffProps.hasUpstreamVersion,
      displayInlineChanges: props2.displayInlineChanges
    };
  }), prepareArrayOfObjectsMember = memoizePrepareArrayOfObjectsMember(function(props2) {
    const {
      arrayItem,
      parent,
      index
    } = props2, itemType = getItemType(parent.schemaType, arrayItem), key = arrayItem._key;
    if (!itemType) {
      const itemTypeName = resolveTypeName$1(arrayItem);
      return {
        kind: "error",
        key,
        index,
        error: {
          type: "INVALID_ITEM_TYPE",
          resolvedValueType: itemTypeName,
          value: arrayItem,
          validTypes: parent.schemaType.of
        }
      };
    }
    const itemPath = pathFor([...parent.path, {
      _key: key
    }]), itemLevel = parent.level + 1, fieldGroupState = parent.fieldGroupState?.children?.[key], scopedCollapsedPaths = parent.collapsedPaths?.children?.[key], scopedCollapsedFieldsets = parent.collapsedFieldSets?.children?.[key], scopedHidden = parent.hidden === !0 || parent.hidden?.value || parent.hidden?.children?.[key], scopedReadOnly = parent.readOnly === !0 || parent.readOnly?.value || parent.readOnly?.children?.[key], comparisonValue = Array.isArray(parent.comparisonValue) && parent.comparisonValue.find((i) => i._key === arrayItem._key) || void 0, itemState = prepareObjectInputState({
      schemaType: itemType,
      level: itemLevel,
      value: arrayItem,
      comparisonValue,
      changed: isChangedValue(arrayItem, comparisonValue),
      path: itemPath,
      perspective: parent.perspective,
      hasUpstreamVersion: parent.hasUpstreamVersion,
      focusPath: parent.focusPath,
      openPath: parent.openPath,
      currentUser: parent.currentUser,
      collapsedPaths: scopedCollapsedPaths,
      collapsedFieldSets: scopedCollapsedFieldsets,
      presence: parent.presence,
      validation: parent.validation,
      fieldGroupState,
      readOnly: scopedReadOnly,
      hidden: scopedHidden,
      displayInlineChanges: parent.displayInlineChanges
    }, !1), defaultCollapsedState = getCollapsedWithDefaults(itemType.options, itemLevel), collapsed = scopedCollapsedPaths?.value ?? defaultCollapsedState.collapsed;
    return {
      kind: "item",
      key,
      index,
      open: startsWith(itemPath, parent.openPath),
      collapsed,
      collapsible: !0,
      parentSchemaType: parent.schemaType,
      item: itemState
    };
  }), prepareArrayOfPrimitivesMember = memoizePrepareArrayOfPrimitivesMember(function(props2) {
    const {
      arrayItem,
      parent,
      index
    } = props2, itemType = getPrimitiveItemType(parent.schemaType, arrayItem), itemPath = pathFor([...parent.path, index]), itemValue = parent.value?.[index], itemComparisonValue = parent.comparisonValue?.[index], itemLevel = parent.level + 1, key = `${itemType?.name || "invalid-type"}-${String(index)}`;
    if (!itemType)
      return {
        kind: "error",
        key,
        index,
        error: {
          type: "INVALID_ITEM_TYPE",
          validTypes: parent.schemaType.of,
          resolvedValueType: resolveTypeName$1(itemType),
          value: itemValue
        }
      };
    const scopedReadOnly = parent.readOnly === !0 || parent.readOnly?.value || parent.readOnly?.children?.[index], item = preparePrimitiveInputState({
      ...parent,
      path: itemPath,
      schemaType: itemType,
      level: itemLevel,
      value: itemValue,
      comparisonValue: itemComparisonValue,
      readOnly: scopedReadOnly
    });
    return {
      kind: "item",
      key,
      index,
      parentSchemaType: parent.schemaType,
      open: isEqual$2(itemPath, parent.openPath),
      item
    };
  }), preparePrimitiveInputState = memoizePreparePrimitiveInputState(function(props2) {
    const filteredPresence = props2.presence.filter((item) => isEqual$2(item.path, props2.path)), presence = filteredPresence.length ? filteredPresence : EMPTY_ARRAY$y, validation2 = props2.validation.filter((item) => isEqual$2(item.path, props2.path)).map((v) => ({
      level: v.level,
      message: v.message,
      path: v.path
    })), diffProps = prepareDiffProps(props2);
    return {
      schemaType: props2.schemaType,
      value: props2.value,
      level: props2.level,
      id: getSafeDomId(toString(props2.path)),
      readOnly: props2.readOnly === !0 || props2.readOnly?.value,
      focused: isEqual$2(props2.path, props2.focusPath),
      path: props2.path,
      perspective: props2.perspective,
      presence,
      validation: validation2,
      __unstable_computeDiff: diffProps.__unstable_computeDiff,
      changed: isChangedValue(props2.value, props2.comparisonValue),
      hasUpstreamVersion: diffProps.hasUpstreamVersion,
      displayInlineChanges: props2.displayInlineChanges
    };
  });
  function prepareFormState({
    collapsedFieldSets,
    collapsedPaths,
    comparisonValue,
    currentUser,
    documentValue,
    fieldGroupState,
    focusPath,
    hidden,
    openPath,
    perspective,
    hasUpstreamVersion,
    presence,
    readOnly,
    schemaType,
    validation: validation2,
    changesOpen,
    displayInlineChanges
  }) {
    return prepareObjectInputState({
      collapsedFieldSets,
      collapsedPaths,
      comparisonValue,
      currentUser,
      value: documentValue,
      fieldGroupState,
      focusPath,
      hidden: hidden === !1 ? EMPTY_OBJECT : hidden,
      openPath,
      perspective,
      hasUpstreamVersion,
      presence,
      readOnly: readOnly === !1 ? EMPTY_OBJECT : readOnly,
      schemaType,
      validation: validation2,
      changesOpen,
      level: 0,
      path: [],
      displayInlineChanges
    });
  }
  return prepareFormState._prepareFieldMember = prepareFieldMember, prepareFormState._prepareFieldMember = prepareFieldMember, prepareFormState._prepareObjectInputState = prepareObjectInputState, prepareFormState._prepareArrayOfPrimitivesInputState = prepareArrayOfPrimitivesInputState, prepareFormState._prepareArrayOfObjectsInputState = prepareArrayOfObjectsInputState, prepareFormState._prepareArrayOfObjectsMember = prepareArrayOfObjectsMember, prepareFormState._prepareArrayOfPrimitivesMember = prepareArrayOfPrimitivesMember, prepareFormState._preparePrimitiveInputState = preparePrimitiveInputState, prepareFormState;
}
function prepareDiffProps({
  comparisonValue,
  value: definitiveValue,
  schemaType,
  perspective,
  hasUpstreamVersion
}) {
  const jsonType = typeof schemaType == "object" && schemaType !== null && "jsonType" in schemaType && typeof schemaType.jsonType == "string" && schemaType.jsonType in emptyValuesByType ? schemaType.jsonType : void 0;
  if (typeof jsonType > "u")
    throw new Error("Expected `jsonType`");
  const emptyValue = emptyValuesByType[jsonType], provenanceAnnotation = {
    provenance: {
      bundle: perspective
    }
  };
  return {
    __unstable_computeDiff: (value) => diffInput(wrap$1(hasUpstreamVersion ? comparisonValue ?? emptyValue : emptyValue, provenanceAnnotation), wrap$1(value ?? emptyValue, provenanceAnnotation), {}),
    // TODO: Establish consistent naming.
    compareValue: comparisonValue ?? void 0,
    hasUpstreamVersion
  };
}
function DialogStackProvider(t0) {
  const $ = c(28), {
    children
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[0] = t1) : t1 = $[0];
  const [stack, setStack] = useState(t1), {
    onPathOpen
  } = useFormCallbacks(), {
    hasAnyFullscreen,
    allFullscreenPaths
  } = useFullscreenPTE();
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (id2, path) => {
    setStack((prev) => prev.some((entry) => entry.id === id2) ? prev : [...prev, {
      id: id2,
      path
    }]);
  }, $[1] = t2) : t2 = $[1];
  const push = t2;
  let t3;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (id_0) => {
    setStack((prev_0) => prev_0.filter((entry_0) => entry_0.id !== id_0));
  }, $[2] = t3) : t3 = $[2];
  const remove2 = t3;
  let t4;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = (id_1, path_0) => {
    setStack((prev_1) => prev_1.map((entry_1) => entry_1.id === id_1 ? {
      ...entry_1,
      path: path_0
    } : entry_1));
  }, $[3] = t4) : t4 = $[3];
  const update = t4;
  let t5;
  $[4] !== allFullscreenPaths ? (t5 = (currentPath) => allFullscreenPaths.filter((pathStr) => {
    const fullscreenPath = stringToPath(pathStr);
    if (fullscreenPath.length > currentPath.length || !fullscreenPath.every((segment, index) => {
      const currentSegment = currentPath[index];
      return isKeySegment(segment) && isKeySegment(currentSegment) ? segment._key === currentSegment._key : segment === currentSegment;
    }))
      return !1;
    if (fullscreenPath.some(_temp$2o))
      return !0;
    const nextSegment = currentPath[fullscreenPath.length];
    return !isKeySegment(nextSegment);
  }), $[4] = allFullscreenPaths, $[5] = t5) : t5 = $[5];
  const findAncestorFullscreenPath = t5;
  let t6;
  $[6] !== onPathOpen ? (t6 = () => {
    onPathOpen(EMPTY_ARRAY$y), setStack([]);
  }, $[6] = onPathOpen, $[7] = t6) : t6 = $[7];
  const closeAll = t6;
  let t7;
  $[8] !== closeAll || $[9] !== findAncestorFullscreenPath || $[10] !== onPathOpen ? (t7 = (currentPath_0) => {
    const ancestorPaths = findAncestorFullscreenPath(currentPath_0);
    if (ancestorPaths && ancestorPaths.length > 0) {
      const closestParentPath = ancestorPaths.reduce(_temp2$Z), newPath = stringToPath(closestParentPath);
      onPathOpen(newPath), setStack((prev_2) => prev_2.filter((entry_2) => !entry_2.path || entry_2.path.length >= newPath.length ? !1 : entry_2.path.every((segment_1, index_0) => {
        const newSegment = newPath[index_0];
        return isKeySegment(segment_1) && isKeySegment(newSegment) ? segment_1._key === newSegment._key : segment_1 === newSegment;
      })));
    } else
      closeAll();
  }, $[8] = closeAll, $[9] = findAncestorFullscreenPath, $[10] = onPathOpen, $[11] = t7) : t7 = $[11];
  const closeWithFullscreen = t7;
  let t8;
  $[12] !== allFullscreenPaths || $[13] !== closeAll || $[14] !== closeWithFullscreen || $[15] !== hasAnyFullscreen || $[16] !== onPathOpen || $[17] !== stack ? (t8 = (options) => {
    const currentPath_1 = stack[stack.length - 1]?.path;
    if (options?.toParent && stack.length >= 2) {
      const parentEntry = stack[stack.length - 2];
      if (parentEntry?.path) {
        onPathOpen(parentEntry.path), setStack(_temp3$u);
        return;
      }
    }
    if (currentPath_1 && hasAnyFullscreen() && allFullscreenPaths.length >= 1) {
      closeWithFullscreen(currentPath_1);
      return;
    }
    closeAll();
  }, $[12] = allFullscreenPaths, $[13] = closeAll, $[14] = closeWithFullscreen, $[15] = hasAnyFullscreen, $[16] = onPathOpen, $[17] = stack, $[18] = t8) : t8 = $[18];
  const close = t8;
  let t9;
  $[19] !== onPathOpen ? (t9 = (targetPath) => {
    onPathOpen(targetPath), setStack((prev_4) => prev_4.filter((entry_3) => !entry_3.path || entry_3.path.length >= targetPath.length ? !1 : entry_3.path.every((segment_2, index_1) => {
      const targetSegment = targetPath[index_1];
      return isKeySegment(segment_2) && isKeySegment(targetSegment) ? segment_2._key === targetSegment._key : segment_2 === targetSegment;
    })));
  }, $[19] = onPathOpen, $[20] = t9) : t9 = $[20];
  const navigateTo = t9;
  let t10;
  $[21] !== close || $[22] !== navigateTo || $[23] !== stack ? (t10 = {
    stack,
    push,
    remove: remove2,
    update,
    close,
    navigateTo
  }, $[21] = close, $[22] = navigateTo, $[23] = stack, $[24] = t10) : t10 = $[24];
  const value = t10;
  let t11;
  return $[25] !== children || $[26] !== value ? (t11 = /* @__PURE__ */ jsx(DialogStackContext.Provider, { value, children }), $[25] = children, $[26] = value, $[27] = t11) : t11 = $[27], t11;
}
function _temp3$u(prev_3) {
  return prev_3.slice(0, -1);
}
function _temp2$Z(longest, current) {
  return current.length > longest.length ? current : longest;
}
function _temp$2o(segment_0) {
  return isKeySegment(segment_0);
}
function FormBuilderInputErrorBoundary(props2) {
  const $ = c(7), {
    children
  } = props2;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    error: null,
    info: {}
  }, $[0] = t0) : t0 = $[0];
  const [t1, setError] = useState(t0), {
    error,
    info
  } = t1;
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setError({
    error: null,
    info: {}
  }), $[1] = t2) : t2 = $[1];
  const handleRetry = t2;
  if (!error) {
    let t32;
    return $[2] !== children ? (t32 = /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: setError, children }), $[2] = children, $[3] = t32) : t32 = $[3], t32;
  }
  let t3;
  return $[4] !== error || $[5] !== info ? (t3 = /* @__PURE__ */ jsx(ErrorCard, { error, info, onRetry: handleRetry }), $[4] = error, $[5] = info, $[6] = t3) : t3 = $[6], t3;
}
function ErrorCard(props2) {
  const $ = c(26), {
    error,
    info,
    onRetry: onRetry2
  } = props2;
  if (error instanceof CorsOriginError || error instanceof SchemaError)
    throw error;
  const {
    t
  } = useTranslation(), message = isRecord$4(error) && typeof error.message == "string" && error.message;
  let t0;
  $[0] !== error ? (t0 = isRecord$4(error) && typeof error.stack == "string" && error.stack, $[0] = error, $[1] = t0) : t0 = $[1];
  const callStack = t0, componentStack = typeof info?.componentStack == "string" && info.componentStack;
  useHotModuleReload(onRetry2);
  const T0 = Alert, t1 = "error";
  let t2;
  $[2] !== t ? (t2 = t("form.error.unhandled-runtime-error.title"), $[2] = t, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(Fragment$1, { children: t2 }), $[4] = t2, $[5] = t3) : t3 = $[5];
  const T1 = Stack, t4 = 4, T2 = Text$1, t5 = "p", t6 = !0, t7 = 1, t8 = t("form.error.unhandled-runtime-error.error-message", {
    message
  });
  let t9;
  $[6] !== t8 ? (t9 = /* @__PURE__ */ jsx(Fragment$1, { children: t8 }), $[6] = t8, $[7] = t9) : t9 = $[7];
  let t10;
  $[8] !== T2 || $[9] !== t9 ? (t10 = /* @__PURE__ */ jsx(T2, { as: t5, muted: t6, size: t7, children: t9 }), $[8] = T2, $[9] = t9, $[10] = t10) : t10 = $[10];
  let t11;
  $[11] !== callStack || $[12] !== t ? (t11 = callStack && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, children: /* @__PURE__ */ jsx(Fragment$1, { children: t("form.error.unhandled-runtime-error.call-stack.title") }) }),
    /* @__PURE__ */ jsx(Card, { border: !0, radius: 2, overflow: "auto", padding: 4, tone: "inherit", children: callStack && /* @__PURE__ */ jsx(Code, { size: 1, style: {
      maxHeight: "40vh"
    }, children: callStack }) })
  ] }) }, "call-stack"), $[11] = callStack, $[12] = t, $[13] = t11) : t11 = $[13];
  let t12;
  $[14] !== componentStack || $[15] !== t ? (t12 = isDev && componentStack && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, children: /* @__PURE__ */ jsx(Fragment$1, { children: t("form.error.unhandled-runtime-error.component-stack.title") }) }),
    /* @__PURE__ */ jsx(Card, { border: !0, radius: 2, overflow: "auto", padding: 4, tone: "inherit", children: componentStack && /* @__PURE__ */ jsx(Code, { size: 1, style: {
      maxHeight: "40vh"
    }, children: componentStack }) })
  ] }) }, "component-stack"), $[14] = componentStack, $[15] = t, $[16] = t12) : t12 = $[16];
  let t13;
  $[17] !== T1 || $[18] !== t10 || $[19] !== t11 || $[20] !== t12 ? (t13 = /* @__PURE__ */ jsxs(T1, { space: t4, children: [
    t10,
    t11,
    t12
  ] }), $[17] = T1, $[18] = t10, $[19] = t11, $[20] = t12, $[21] = t13) : t13 = $[21];
  let t14;
  return $[22] !== T0 || $[23] !== t13 || $[24] !== t3 ? (t14 = /* @__PURE__ */ jsx(T0, { status: t1, title: t3, children: t13 }), $[22] = T0, $[23] = t13, $[24] = t3, $[25] = t14) : t14 = $[25], t14;
}
const orientationChange$ = typeof window > "u" ? EMPTY$5 : fromEvent(window, "orientationchange").pipe(shareReplay(1)), resize$ = typeof window > "u" ? EMPTY$5 : fromEvent(window, "resize").pipe(shareReplay(1)), scroll$ = typeof window > "u" ? EMPTY$5 : fromEvent(window, "scroll", {
  passive: !0,
  capture: !0
}).pipe(shareReplay(1)), ROOT_MARGIN_PX = 150;
function isIntersectionObserverSupported() {
  return typeof window < "u" && "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in IntersectionObserverEntry.prototype ? ("isIntersecting" in IntersectionObserverEntry.prototype || Object.defineProperty(IntersectionObserverEntry.prototype, "isIntersecting", {
    get() {
      return this.intersectionRatio > 0;
    }
  }), !0) : !1;
}
const intersectionObservableFor = isIntersectionObserverSupported() ? createIntersectionObserverBased() : createLegacyBased();
function createIntersectionObserverBased() {
  const intersectionObserverEntriesSubject = new Subject(), intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      intersectionObserverEntriesSubject.next(entry);
    });
  }, {
    threshold: 0,
    rootMargin: `${ROOT_MARGIN_PX}px`
  });
  return function(element) {
    return new Observable((observer) => (intersectionObserver.observe(element), observer.next(), () => intersectionObserver.unobserve(element))).pipe(mergeMap(() => intersectionObserverEntriesSubject.asObservable()), filter((entry) => entry.target === element), map((ev) => ({
      isIntersecting: ev.isIntersecting
    })));
  };
}
function createLegacyBased() {
  function getViewport() {
    return {
      left: 0,
      right: window.innerWidth,
      top: 0,
      bottom: window.innerHeight
    };
  }
  function intersects(rect, viewport, margin) {
    return rect.left <= viewport.right + margin && rect.right >= viewport.left - margin && rect.top <= viewport.bottom + margin && rect.bottom >= viewport.top - margin;
  }
  function inViewport(element) {
    return () => intersects(element.getBoundingClientRect(), getViewport(), ROOT_MARGIN_PX);
  }
  return function(element) {
    const isElementInViewport = inViewport(element);
    return merge(of(isElementInViewport()), resize$, scroll$, orientationChange$).pipe(
      // @todo: consider "faking" more of the IntersectionObserverEntry api if possible
      map(isElementInViewport),
      map((isIntersecting) => ({
        isIntersecting
      }))
    );
  };
}
const visibilityChange$ = typeof window > "u" ? EMPTY$5 : fromEvent(document, "visibilitychange").pipe(shareReplay(1));
function useVisibility(props2) {
  const $ = c(5), {
    element,
    hideDelay: t0,
    disabled
  } = props2, hideDelay = t0 === void 0 ? 0 : t0, [visible, setVisible] = useState(!1);
  let t1, t2;
  return $[0] !== disabled || $[1] !== element || $[2] !== hideDelay ? (t1 = () => {
    if (!element || disabled)
      return;
    element && "checkVisibility" in element && setVisible(element.checkVisibility());
    const isDocumentVisible$ = concat(of(!document.hidden), visibilityChange$.pipe(map(_temp$2n))).pipe(distinctUntilChanged()), inViewport$ = intersectionObservableFor(element).pipe(map(_temp2$Y)), sub2 = isDocumentVisible$.pipe(switchMap((isDocumentVisible) => isDocumentVisible ? inViewport$ : of(!1)), switchMap((isVisible2) => isVisible2 ? of(!0) : of(!1).pipe(delay(hideDelay))), distinctUntilChanged()).subscribe(setVisible);
    return () => sub2.unsubscribe();
  }, t2 = [element, hideDelay, disabled], $[0] = disabled, $[1] = element, $[2] = hideDelay, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]), useLayoutEffect(t1, t2), disabled ? !1 : visible;
}
function _temp2$Y(event_0) {
  return event_0.isIntersecting;
}
function _temp$2n(event) {
  return event.target instanceof Document ? !event?.target?.hidden : !1;
}
const _HIDE_DELAY = 2e3;
function _extractUploadState(value) {
  return _resolveUploadValue(value?._upload);
}
function getStringOrUndefined(value) {
  return isString(value) ? value : void 0;
}
function _resolveUploadValue(value) {
  if (!isRecord$4(value)) return;
  const progress = typeof value.progress == "number" ? value.progress : 0, createdAt = getStringOrUndefined(value.initiated || value.createdAt), updatedAt = getStringOrUndefined(value.updated || value.updatedAt), fileName = getStringOrUndefined(value?.file?.name), fileType = getStringOrUndefined(value?.file?.type), previewImage = getStringOrUndefined(value.previewImage);
  if (createdAt && updatedAt && fileName && fileType)
    return {
      progress,
      createdAt,
      updatedAt,
      file: {
        name: fileName,
        type: fileType
      },
      previewImage
    };
}
function PreviewLoader(props2) {
  const $ = c(39);
  let Component2, layout, perspectiveStack, restProps, schemaType, skipVisibilityCheck, styleProp, value;
  $[0] !== props2 ? ({
    layout,
    value,
    component: Component2,
    style: styleProp,
    schemaType,
    skipVisibilityCheck,
    perspectiveStack,
    ...restProps
  } = props2, $[0] = props2, $[1] = Component2, $[2] = layout, $[3] = perspectiveStack, $[4] = restProps, $[5] = schemaType, $[6] = skipVisibilityCheck, $[7] = styleProp, $[8] = value) : (Component2 = $[1], layout = $[2], perspectiveStack = $[3], restProps = $[4], schemaType = $[5], skipVisibilityCheck = $[6], styleProp = $[7], value = $[8]);
  const {
    t
  } = useTranslation(), [element, setElement] = useState(null), isVisible2 = useVisibility({
    disabled: skipVisibilityCheck,
    element,
    hideDelay: _HIDE_DELAY
  }) || skipVisibilityCheck, t0 = skipVisibilityCheck || isVisible2;
  let t1;
  $[9] !== perspectiveStack || $[10] !== schemaType || $[11] !== t0 || $[12] !== value ? (t1 = {
    enabled: t0,
    schemaType,
    value,
    perspectiveStack
  }, $[9] = perspectiveStack, $[10] = schemaType, $[11] = t0, $[12] = value, $[13] = t1) : t1 = $[13];
  const preview = useValuePreview(t1), t2 = styleProp?.minWidth || 1, t3 = styleProp?.minHeight || 1;
  let t4;
  $[14] !== styleProp || $[15] !== t2 || $[16] !== t3 ? (t4 = {
    ...styleProp,
    minWidth: t2,
    minHeight: t3
  }, $[14] = styleProp, $[15] = t2, $[16] = t3, $[17] = t4) : t4 = $[17];
  const style = t4;
  let t5;
  $[18] !== value ? (t5 = _extractUploadState(value), $[18] = value, $[19] = t5) : t5 = $[19];
  const uploadState = t5;
  let t6;
  bb0: {
    if (uploadState?.previewImage) {
      let t72;
      $[20] !== t ? (t72 = t("preview.image.file-is-being-uploaded.alt-text"), $[20] = t, $[21] = t72) : t72 = $[21];
      let t82;
      $[22] !== t72 || $[23] !== uploadState.previewImage ? (t82 = /* @__PURE__ */ jsx("img", { alt: t72, src: uploadState.previewImage }), $[22] = t72, $[23] = uploadState.previewImage, $[24] = t82) : t82 = $[24], t6 = t82;
      break bb0;
    }
    if (preview?.value?.media === null || preview?.value?.media === !1) {
      t6 = void 0;
      break bb0;
    }
    if (!preview?.value?.media) {
      t6 = schemaType.icon;
      break bb0;
    }
    t6 = preview?.value?.media;
  }
  const media = t6;
  let t7;
  $[25] !== preview?.value ? (t7 = preview?.value || {}, $[25] = preview?.value, $[26] = t7) : t7 = $[26];
  const t8 = preview?.error, t9 = preview?.isLoading;
  let t10;
  $[27] !== Component2 || $[28] !== layout || $[29] !== media || $[30] !== restProps || $[31] !== schemaType || $[32] !== t7 || $[33] !== t8 || $[34] !== t9 ? (t10 = /* @__PURE__ */ jsx(Component2, { ...restProps, ...t7, media, error: t8, isPlaceholder: t9, layout, schemaType }), $[27] = Component2, $[28] = layout, $[29] = media, $[30] = restProps, $[31] = schemaType, $[32] = t7, $[33] = t8, $[34] = t9, $[35] = t10) : t10 = $[35];
  let t11;
  return $[36] !== style || $[37] !== t10 ? (t11 = /* @__PURE__ */ jsx("div", { ref: setElement, style, children: t10 }), $[36] = style, $[37] = t10, $[38] = t11) : t11 = $[38], t11;
}
function DefaultCustomMarkers() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    "This is a example custom marker, please implement ",
    /* @__PURE__ */ jsx("code", { children: "renderCustomMarkers" }),
    " function."
  ] }), $[0] = t0) : t0 = $[0], t0;
}
const missingPatchChannel = {
  publish: () => {
  },
  subscribe: () => (console.warn("No patch channel provided to form-builder. If you need input based patch updates, please provide one"), () => {
  })
};
function FormBuilderProvider(props2) {
  const $ = c(62), {
    __internal_fieldActions: t0,
    __internal_patchChannel: t1,
    __internal_inspectOpen: t2,
    autoFocus,
    changesOpen,
    children,
    collapsedFieldSets,
    collapsedPaths,
    file,
    filterField,
    focusPath,
    focused,
    groups,
    id: id2,
    image,
    onChange,
    onFieldGroupSelect,
    onPathBlur,
    onPathFocus,
    onPathOpen,
    onSetFieldSetCollapsed,
    onSetPathCollapsed,
    presence,
    readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    unstable,
    validation: validation2
  } = props2, fieldActions = t0 === void 0 ? EMPTY_ARRAY$y : t0, patchChannel = t1 === void 0 ? missingPatchChannel : t1, inspectOpen = t2 === void 0 ? !1 : t2, t3 = unstable?.CustomMarkers || DefaultCustomMarkers, t4 = unstable?.Markers || DefaultMarkers;
  let t5;
  $[0] !== t3 || $[1] !== t4 ? (t5 = {
    ArrayFunctions: ArrayOfObjectsFunctions,
    CustomMarkers: t3,
    Markers: t4
  }, $[0] = t3, $[1] = t4, $[2] = t5) : t5 = $[2];
  let t6;
  $[3] !== fieldActions ? (t6 = {
    actions: fieldActions
  }, $[3] = fieldActions, $[4] = t6) : t6 = $[4];
  const t7 = file?.directUploads ?? !0;
  let t8;
  $[5] !== file.assetSources || $[6] !== t7 ? (t8 = {
    assetSources: file.assetSources,
    directUploads: t7
  }, $[5] = file.assetSources, $[6] = t7, $[7] = t8) : t8 = $[7];
  const t9 = filterField || _temp$2m, t10 = image?.directUploads ?? !0;
  let t11;
  $[8] !== image.assetSources || $[9] !== t10 ? (t11 = {
    assetSources: image.assetSources,
    directUploads: t10
  }, $[8] = image.assetSources, $[9] = t10, $[10] = t11) : t11 = $[10];
  let t12;
  $[11] !== inspectOpen || $[12] !== onChange || $[13] !== patchChannel || $[14] !== t11 || $[15] !== t5 || $[16] !== t6 || $[17] !== t8 || $[18] !== t9 ? (t12 = {
    patchChannel,
    components: t5,
    field: t6,
    file: t8,
    filterField: t9,
    image: t11,
    inspectOpen,
    onChange
  }, $[11] = inspectOpen, $[12] = onChange, $[13] = patchChannel, $[14] = t11, $[15] = t5, $[16] = t6, $[17] = t8, $[18] = t9, $[19] = t12) : t12 = $[19];
  const __internal = t12;
  let t13;
  $[20] !== __internal || $[21] !== autoFocus || $[22] !== changesOpen || $[23] !== collapsedFieldSets || $[24] !== collapsedPaths || $[25] !== focusPath || $[26] !== focused || $[27] !== groups || $[28] !== id2 || $[29] !== readOnly || $[30] !== renderAnnotation || $[31] !== renderBlock2 || $[32] !== renderField || $[33] !== renderInlineBlock || $[34] !== renderInput || $[35] !== renderItem2 || $[36] !== renderPreview || $[37] !== schemaType ? (t13 = {
    __internal,
    autoFocus,
    changesOpen,
    collapsedFieldSets,
    collapsedPaths,
    focusPath,
    focused,
    groups,
    id: id2,
    readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType
  }, $[20] = __internal, $[21] = autoFocus, $[22] = changesOpen, $[23] = collapsedFieldSets, $[24] = collapsedPaths, $[25] = focusPath, $[26] = focused, $[27] = groups, $[28] = id2, $[29] = readOnly, $[30] = renderAnnotation, $[31] = renderBlock2, $[32] = renderField, $[33] = renderInlineBlock, $[34] = renderInput, $[35] = renderItem2, $[36] = renderPreview, $[37] = schemaType, $[38] = t13) : t13 = $[38];
  const formBuilder = t13;
  let t14;
  $[39] !== children ? (t14 = /* @__PURE__ */ jsx(HoveredFieldProvider, { children }), $[39] = children, $[40] = t14) : t14 = $[40];
  let t15;
  $[41] !== t14 || $[42] !== validation2 ? (t15 = /* @__PURE__ */ jsx(ValidationProvider, { validation: validation2, children: t14 }), $[41] = t14, $[42] = validation2, $[43] = t15) : t15 = $[43];
  let t16;
  $[44] !== presence || $[45] !== t15 ? (t16 = /* @__PURE__ */ jsx(PresenceProvider, { presence, children: t15 }), $[44] = presence, $[45] = t15, $[46] = t16) : t16 = $[46];
  let t17;
  $[47] !== id2 || $[48] !== t16 ? (t17 = /* @__PURE__ */ jsx(DocumentIdProvider, { id: id2, children: t16 }), $[47] = id2, $[48] = t16, $[49] = t17) : t17 = $[49];
  let t18;
  $[50] !== onChange || $[51] !== onFieldGroupSelect || $[52] !== onPathBlur || $[53] !== onPathFocus || $[54] !== onPathOpen || $[55] !== onSetFieldSetCollapsed || $[56] !== onSetPathCollapsed || $[57] !== t17 ? (t18 = /* @__PURE__ */ jsx(FormCallbacksProvider, { onChange, onFieldGroupSelect, onPathBlur, onPathFocus, onPathOpen, onSetPathCollapsed, onSetFieldSetCollapsed, children: t17 }), $[50] = onChange, $[51] = onFieldGroupSelect, $[52] = onPathBlur, $[53] = onPathFocus, $[54] = onPathOpen, $[55] = onSetFieldSetCollapsed, $[56] = onSetPathCollapsed, $[57] = t17, $[58] = t18) : t18 = $[58];
  let t19;
  return $[59] !== formBuilder || $[60] !== t18 ? (t19 = /* @__PURE__ */ jsx(FormBuilderContext.Provider, { value: formBuilder, children: t18 }), $[59] = formBuilder, $[60] = t18, $[61] = t19) : t19 = $[61], t19;
}
function _temp$2m() {
  return !0;
}
function FormProvider(props2) {
  const $ = c(47), {
    __internal_fieldActions: fieldActions,
    __internal_patchChannel: patchChannel,
    __internal_inspectOpen: inspectOpen,
    autoFocus,
    changesOpen,
    children,
    collapsedFieldSets,
    collapsedPaths,
    focusPath,
    focused,
    groups,
    id: id2,
    onChange,
    onPathBlur,
    onPathFocus,
    onPathOpen,
    onFieldGroupSelect,
    onSetPathCollapsed,
    onSetFieldSetCollapsed,
    presence,
    readOnly,
    schemaType,
    validation: validation2
  } = props2, {
    file,
    image
  } = useSource().form, Input2 = useInputComponent(), Field = useFieldComponent(), Preview2 = usePreviewComponent(), Item2 = useItemComponent(), Block2 = useBlockComponent(), InlineBlock = useInlineBlockComponent(), Annotation2 = useAnnotationComponent();
  let t0;
  $[0] !== Input2 ? (t0 = (inputProps) => /* @__PURE__ */ jsx(Input2, { ...inputProps }), $[0] = Input2, $[1] = t0) : t0 = $[1];
  const renderInput = t0;
  let t1;
  $[2] !== Field ? (t1 = (fieldProps) => /* @__PURE__ */ jsx(Field, { ...fieldProps }), $[2] = Field, $[3] = t1) : t1 = $[3];
  const renderField = t1;
  let t2;
  $[4] !== Item2 ? (t2 = (itemProps) => /* @__PURE__ */ jsx(Item2, { ...itemProps }, itemProps.inputId), $[4] = Item2, $[5] = t2) : t2 = $[5];
  const renderItem2 = t2;
  let t3;
  $[6] !== Preview2 ? (t3 = (previewProps) => /* @__PURE__ */ jsx(PreviewLoader, { component: Preview2, ...previewProps }), $[6] = Preview2, $[7] = t3) : t3 = $[7];
  const renderPreview = t3;
  let t4;
  $[8] !== Block2 ? (t4 = (blockProps) => /* @__PURE__ */ jsx(Block2, { ...blockProps }), $[8] = Block2, $[9] = t4) : t4 = $[9];
  const renderBlock2 = t4;
  let t5;
  $[10] !== InlineBlock ? (t5 = (blockProps_0) => /* @__PURE__ */ jsx(InlineBlock, { ...blockProps_0 }), $[10] = InlineBlock, $[11] = t5) : t5 = $[11];
  const renderInlineBlock = t5;
  let t6;
  $[12] !== Annotation2 ? (t6 = (annotationProps) => /* @__PURE__ */ jsx(Annotation2, { ...annotationProps }), $[12] = Annotation2, $[13] = t6) : t6 = $[13];
  const renderAnnotation = t6;
  let t7;
  return $[14] !== autoFocus || $[15] !== changesOpen || $[16] !== children || $[17] !== collapsedFieldSets || $[18] !== collapsedPaths || $[19] !== fieldActions || $[20] !== file || $[21] !== focusPath || $[22] !== focused || $[23] !== groups || $[24] !== id2 || $[25] !== image || $[26] !== inspectOpen || $[27] !== onChange || $[28] !== onFieldGroupSelect || $[29] !== onPathBlur || $[30] !== onPathFocus || $[31] !== onPathOpen || $[32] !== onSetFieldSetCollapsed || $[33] !== onSetPathCollapsed || $[34] !== patchChannel || $[35] !== presence || $[36] !== readOnly || $[37] !== renderAnnotation || $[38] !== renderBlock2 || $[39] !== renderField || $[40] !== renderInlineBlock || $[41] !== renderInput || $[42] !== renderItem2 || $[43] !== renderPreview || $[44] !== schemaType || $[45] !== validation2 ? (t7 = /* @__PURE__ */ jsx(FormBuilderProvider, { __internal_fieldActions: fieldActions, __internal_patchChannel: patchChannel, __internal_inspectOpen: inspectOpen, autoFocus, changesOpen, collapsedFieldSets, collapsedPaths, file, focusPath, focused, groups, id: id2, image, onChange, onPathBlur, onPathFocus, onPathOpen, onFieldGroupSelect, onSetPathCollapsed, onSetFieldSetCollapsed, presence, readOnly, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview, schemaType, validation: validation2, children }), $[14] = autoFocus, $[15] = changesOpen, $[16] = children, $[17] = collapsedFieldSets, $[18] = collapsedPaths, $[19] = fieldActions, $[20] = file, $[21] = focusPath, $[22] = focused, $[23] = groups, $[24] = id2, $[25] = image, $[26] = inspectOpen, $[27] = onChange, $[28] = onFieldGroupSelect, $[29] = onPathBlur, $[30] = onPathFocus, $[31] = onPathOpen, $[32] = onSetFieldSetCollapsed, $[33] = onSetPathCollapsed, $[34] = patchChannel, $[35] = presence, $[36] = readOnly, $[37] = renderAnnotation, $[38] = renderBlock2, $[39] = renderField, $[40] = renderInlineBlock, $[41] = renderInput, $[42] = renderItem2, $[43] = renderPreview, $[44] = schemaType, $[45] = validation2, $[46] = t7) : t7 = $[46], t7;
}
function FormBuilder(props2) {
  const $ = c(119), {
    __internal_fieldActions: fieldActions,
    __internal_patchChannel: patchChannel,
    __internal_inspectOpen: inspectOpen,
    autoFocus,
    changesOpen,
    collapsedFieldSets,
    collapsedPaths,
    focused,
    focusPath,
    groups,
    id: id2,
    members,
    onChange,
    onFieldGroupSelect,
    onPathBlur,
    onPathFocus,
    onPathOpen,
    onSetFieldSetCollapsed,
    onSetPathCollapsed,
    openPath: t0,
    perspective,
    presence,
    readOnly,
    schemaType,
    hasUpstreamVersion,
    validation: validation2,
    value,
    compareValue
  } = props2, openPath = t0 === void 0 ? EMPTY_ARRAY$y : t0;
  let t1;
  $[0] !== onSetPathCollapsed ? (t1 = (fieldName) => onSetPathCollapsed([fieldName], !0), $[0] = onSetPathCollapsed, $[1] = t1) : t1 = $[1];
  const handleCollapseField = t1;
  let t2;
  $[2] !== onSetPathCollapsed ? (t2 = (fieldName_0) => onSetPathCollapsed([fieldName_0], !1), $[2] = onSetPathCollapsed, $[3] = t2) : t2 = $[3];
  const handleExpandField = t2;
  let t3;
  $[4] !== onPathBlur ? (t3 = () => onPathBlur(EMPTY_ARRAY$y), $[4] = onPathBlur, $[5] = t3) : t3 = $[5];
  const handleBlur = t3;
  let t4;
  $[6] !== onPathFocus ? (t4 = () => onPathFocus(EMPTY_ARRAY$y), $[6] = onPathFocus, $[7] = t4) : t4 = $[7];
  const handleFocus = t4;
  let t5;
  $[8] !== onChange ? (t5 = (patch2) => onChange(PatchEvent.from(patch2)), $[8] = onChange, $[9] = t5) : t5 = $[9];
  const handleChange = t5, focusRef = useRef(null);
  let t6;
  $[10] !== onFieldGroupSelect ? (t6 = (groupName) => onFieldGroupSelect(EMPTY_ARRAY$y, groupName), $[10] = onFieldGroupSelect, $[11] = t6) : t6 = $[11];
  const handleSelectFieldGroup = t6;
  let t7;
  $[12] !== onPathOpen ? (t7 = (fieldName_1) => onPathOpen([fieldName_1]), $[12] = onPathOpen, $[13] = t7) : t7 = $[13];
  const handleOpenField = t7;
  let t8;
  $[14] !== onPathOpen ? (t8 = () => onPathOpen([]), $[14] = onPathOpen, $[15] = t8) : t8 = $[15];
  const handleCloseField = t8;
  let t9;
  $[16] !== onSetFieldSetCollapsed ? (t9 = (fieldSetName) => onSetFieldSetCollapsed([fieldSetName], !0), $[16] = onSetFieldSetCollapsed, $[17] = t9) : t9 = $[17];
  const handleCollapseFieldSet = t9;
  let t10;
  $[18] !== onSetFieldSetCollapsed ? (t10 = (fieldSetName_0) => onSetFieldSetCollapsed([fieldSetName_0], !1), $[18] = onSetFieldSetCollapsed, $[19] = t10) : t10 = $[19];
  const handleExpandFieldSet = t10, Input2 = useInputComponent(), Field = useFieldComponent(), Preview2 = usePreviewComponent(), Item2 = useItemComponent(), Block2 = useBlockComponent(), InlineBlock = useInlineBlockComponent(), Annotation2 = useAnnotationComponent();
  let t11;
  $[20] !== Input2 ? (t11 = (inputProps) => /* @__PURE__ */ jsx(FormBuilderInputErrorBoundary, { children: /* @__PURE__ */ jsx(Input2, { ...inputProps }) }), $[20] = Input2, $[21] = t11) : t11 = $[21];
  const renderInput = t11;
  let t12;
  $[22] !== Field ? (t12 = (fieldProps) => /* @__PURE__ */ jsx(Field, { ...fieldProps }), $[22] = Field, $[23] = t12) : t12 = $[23];
  const renderField = t12;
  let t13;
  $[24] !== Item2 ? (t13 = (itemProps) => /* @__PURE__ */ jsx(Item2, { ...itemProps }, itemProps.inputId), $[24] = Item2, $[25] = t13) : t13 = $[25];
  const renderItem2 = t13;
  let t14;
  $[26] !== Preview2 ? (t14 = (previewProps) => /* @__PURE__ */ jsx(PreviewLoader, { component: Preview2, ...previewProps }), $[26] = Preview2, $[27] = t14) : t14 = $[27];
  const renderPreview = t14;
  let t15;
  $[28] !== Block2 ? (t15 = (blockProps) => /* @__PURE__ */ jsx(Block2, { ...blockProps }), $[28] = Block2, $[29] = t15) : t15 = $[29];
  const renderBlock2 = t15;
  let t16;
  $[30] !== InlineBlock ? (t16 = (blockProps_0) => /* @__PURE__ */ jsx(InlineBlock, { ...blockProps_0 }), $[30] = InlineBlock, $[31] = t16) : t16 = $[31];
  const renderInlineBlock = t16;
  let t17;
  $[32] !== Annotation2 ? (t17 = (annotationProps) => /* @__PURE__ */ jsx(Annotation2, { ...annotationProps }), $[32] = Annotation2, $[33] = t17) : t17 = $[33];
  const renderAnnotation = t17;
  let t18;
  $[34] !== compareValue || $[35] !== hasUpstreamVersion || $[36] !== perspective || $[37] !== schemaType || $[38] !== value ? (t18 = prepareDiffProps({
    comparisonValue: compareValue,
    hasUpstreamVersion,
    value,
    schemaType,
    perspective
  }), $[34] = compareValue, $[35] = hasUpstreamVersion, $[36] = perspective, $[37] = schemaType, $[38] = value, $[39] = t18) : t18 = $[39];
  const diffProps = t18;
  let t19;
  $[40] !== id2 ? (t19 = pathToAnchorIdent("input", [id2]), $[40] = id2, $[41] = t19) : t19 = $[41];
  let t20;
  $[42] !== t19 ? (t20 = {
    anchorName: t19
  }, $[42] = t19, $[43] = t20) : t20 = $[43];
  let t21;
  $[44] !== handleBlur || $[45] !== handleFocus || $[46] !== id2 || $[47] !== t20 ? (t21 = {
    ref: focusRef,
    id: id2,
    onBlur: handleBlur,
    onFocus: handleFocus,
    "aria-describedby": void 0,
    style: t20
  }, $[44] = handleBlur, $[45] = handleFocus, $[46] = id2, $[47] = t20, $[48] = t21) : t21 = $[48];
  const t22 = diffProps.__unstable_computeDiff;
  let t23;
  $[49] !== members ? (t23 = members.some(_temp$2l), $[49] = members, $[50] = t23) : t23 = $[50];
  let t24;
  $[51] !== compareValue || $[52] !== diffProps.__unstable_computeDiff || $[53] !== diffProps.hasUpstreamVersion || $[54] !== focusPath || $[55] !== focused || $[56] !== groups || $[57] !== handleChange || $[58] !== handleCloseField || $[59] !== handleCollapseField || $[60] !== handleCollapseFieldSet || $[61] !== handleExpandField || $[62] !== handleExpandFieldSet || $[63] !== handleOpenField || $[64] !== handleSelectFieldGroup || $[65] !== id2 || $[66] !== members || $[67] !== onPathFocus || $[68] !== readOnly || $[69] !== renderAnnotation || $[70] !== renderBlock2 || $[71] !== renderField || $[72] !== renderInlineBlock || $[73] !== renderInput || $[74] !== renderItem2 || $[75] !== renderPreview || $[76] !== schemaType || $[77] !== t21 || $[78] !== t23 || $[79] !== value ? (t24 = {
    focusPath,
    elementProps: t21,
    focused,
    groups,
    id: id2,
    level: 0,
    members,
    onChange: handleChange,
    onFieldClose: handleCloseField,
    onFieldCollapse: handleCollapseField,
    onFieldSetCollapse: handleCollapseFieldSet,
    onFieldExpand: handleExpandField,
    onFieldSetExpand: handleExpandFieldSet,
    onPathFocus,
    onFieldOpen: handleOpenField,
    onFieldGroupSelect: handleSelectFieldGroup,
    path: EMPTY_ARRAY$y,
    presence: EMPTY_ARRAY$y,
    readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    validation: EMPTY_ARRAY$y,
    value,
    compareValue,
    __unstable_computeDiff: t22,
    changed: t23,
    displayInlineChanges: !1,
    hasUpstreamVersion: diffProps.hasUpstreamVersion
  }, $[51] = compareValue, $[52] = diffProps.__unstable_computeDiff, $[53] = diffProps.hasUpstreamVersion, $[54] = focusPath, $[55] = focused, $[56] = groups, $[57] = handleChange, $[58] = handleCloseField, $[59] = handleCollapseField, $[60] = handleCollapseFieldSet, $[61] = handleExpandField, $[62] = handleExpandFieldSet, $[63] = handleOpenField, $[64] = handleSelectFieldGroup, $[65] = id2, $[66] = members, $[67] = onPathFocus, $[68] = readOnly, $[69] = renderAnnotation, $[70] = renderBlock2, $[71] = renderField, $[72] = renderInlineBlock, $[73] = renderInput, $[74] = renderItem2, $[75] = renderPreview, $[76] = schemaType, $[77] = t21, $[78] = t23, $[79] = value, $[80] = t24) : t24 = $[80];
  const rootInputProps = t24;
  let t25;
  $[81] !== onPathOpen || $[82] !== openPath || $[83] !== renderInput || $[84] !== rootInputProps ? (t25 = /* @__PURE__ */ jsx(FullscreenPTEProvider, { children: /* @__PURE__ */ jsx(DialogStackProvider, { children: /* @__PURE__ */ jsx(EnhancedObjectDialogProvider, { children: /* @__PURE__ */ jsx(RootInput, { rootInputProps, onPathOpen, openPath, renderInput }) }) }) }), $[81] = onPathOpen, $[82] = openPath, $[83] = renderInput, $[84] = rootInputProps, $[85] = t25) : t25 = $[85];
  let t26;
  $[86] !== fieldActions || $[87] !== t25 ? (t26 = /* @__PURE__ */ jsx(DocumentFieldActionsProvider, { actions: fieldActions, children: t25 }), $[86] = fieldActions, $[87] = t25, $[88] = t26) : t26 = $[88];
  let t27;
  $[89] !== t26 || $[90] !== value ? (t27 = /* @__PURE__ */ jsx(FormValueProvider, { value, children: t26 }), $[89] = t26, $[90] = value, $[91] = t27) : t27 = $[91];
  let t28;
  $[92] !== t27 || $[93] !== value ? (t28 = /* @__PURE__ */ jsx(GetFormValueProvider, { value, children: t27 }), $[92] = t27, $[93] = value, $[94] = t28) : t28 = $[94];
  let t29;
  return $[95] !== autoFocus || $[96] !== changesOpen || $[97] !== collapsedFieldSets || $[98] !== collapsedPaths || $[99] !== fieldActions || $[100] !== focusPath || $[101] !== focused || $[102] !== groups || $[103] !== id2 || $[104] !== inspectOpen || $[105] !== onChange || $[106] !== onFieldGroupSelect || $[107] !== onPathBlur || $[108] !== onPathFocus || $[109] !== onPathOpen || $[110] !== onSetFieldSetCollapsed || $[111] !== onSetPathCollapsed || $[112] !== patchChannel || $[113] !== presence || $[114] !== readOnly || $[115] !== schemaType || $[116] !== t28 || $[117] !== validation2 ? (t29 = /* @__PURE__ */ jsx(FormProvider, { __internal_fieldActions: fieldActions, __internal_patchChannel: patchChannel, __internal_inspectOpen: inspectOpen, autoFocus, changesOpen, collapsedFieldSets, collapsedPaths, focusPath, focused, groups, id: id2, onChange, onPathBlur, onPathFocus, onPathOpen, onFieldGroupSelect, onSetPathCollapsed, onSetFieldSetCollapsed, presence, validation: validation2, readOnly, schemaType, children: t28 }), $[95] = autoFocus, $[96] = changesOpen, $[97] = collapsedFieldSets, $[98] = collapsedPaths, $[99] = fieldActions, $[100] = focusPath, $[101] = focused, $[102] = groups, $[103] = id2, $[104] = inspectOpen, $[105] = onChange, $[106] = onFieldGroupSelect, $[107] = onPathBlur, $[108] = onPathFocus, $[109] = onPathOpen, $[110] = onSetFieldSetCollapsed, $[111] = onSetPathCollapsed, $[112] = patchChannel, $[113] = presence, $[114] = readOnly, $[115] = schemaType, $[116] = t28, $[117] = validation2, $[118] = t29) : t29 = $[118], t29;
}
function _temp$2l(m) {
  return m.kind === "field" && m.field.changed;
}
function RootInput(props2) {
  const {
    rootInputProps,
    renderInput
  } = props2;
  return renderInput(rootInputProps);
}
const Root$g = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-knly9h-0"
})((props2) => {
  const {
    color,
    radius,
    space
  } = props2.theme.sanity, overlay = css`
    pointer-events: none;
    content: '';
    position: absolute;
    top: -${space[1]}px;
    bottom: -${space[1]}px;
    left: -${space[1]}px;
    right: -${space[1]}px;
    border-radius: ${radius[2]}px;
    mix-blend-mode: ${color.dark ? "screen" : "multiply"};
  `;
  return css`
    box-shadow: 0 0 0 1px var(--card-border-color);
    border-radius: ${radius[1]}px;
    pointer-events: all;
    position: relative;

    &[data-focused] {
      --card-border-color: var(--card-focus-ring-color);
    }

    &:not([data-focused]):not([data-selected]) {
      @media (hover: hover) {
        &:hover {
          --card-border-color: ${color.input.default.hovered.border};
        }
      }
    }

    &[data-markers] {
      &:after {
        ${overlay}
        background-color: ${color.dark ? hues.purple[950].hex : hues.purple[50].hex};
      }
    }

    &[data-warning] {
      &:after {
        ${overlay}
        background-color: ${color.muted.caution.hovered.bg};
      }

      @media (hover: hover) {
        &:hover {
          --card-border-color: ${color.muted.caution.hovered.border};
        }
      }
    }

    &[data-invalid] {
      &:after {
        ${overlay}
        background-color: ${color.input.invalid.enabled.bg};
      }

      @media (hover: hover) {
        &:hover {
          --card-border-color: ${color.input.invalid.hovered.border};
        }
      }
    }
  `;
}), PreviewContainer = styled(Flex).withConfig({
  displayName: "PreviewContainer",
  componentId: "sc-knly9h-1"
})`display:block;position:relative;width:100%;user-select:none;pointer-events:all;`, ChangeIndicatorWrapper = /* @__PURE__ */ styled.div.withConfig({
  displayName: "ChangeIndicatorWrapper",
  componentId: "sc-knly9h-2"
})(({
  theme,
  $hasChanges
}) => {
  const {
    space
  } = theme.sanity;
  return css`
      position: absolute;
      width: ${space[2]}px;
      right: 0;
      top: 0;
      bottom: 0;
      padding-left: ${space[1]}px;
      padding-right: ${space[2]}px;
      user-select: none;
      ${DEBUG}

      ${!$hasChanges && css`
          display: none;
        `}

      [data-dragged] & {
        visibility: hidden;
      }
    `;
});
styled(Flex).withConfig({
  displayName: "InnerFlex",
  componentId: "sc-knly9h-3"
})`position:relative;[data-dragged] > &{opacity:0.5;}`;
const BlockActionsOuter = styled(Box).withConfig({
  displayName: "BlockActionsOuter",
  componentId: "sc-knly9h-4"
})`width:25px;position:relative;flex-shrink:0;user-select:none;[data-dragged] &{visibility:hidden;}`, BlockActionsInner = styled(Flex).withConfig({
  displayName: "BlockActionsInner",
  componentId: "sc-knly9h-5"
})`position:absolute;right:0;[data-dragged] &{visibility:hidden;}`, TooltipBox = styled(Box).withConfig({
  displayName: "TooltipBox",
  componentId: "sc-knly9h-6"
})`max-width:250px;`, POPOVER_PROPS$4 = {
  constrainSize: !0,
  placement: "bottom",
  portal: "default",
  tone: "default"
};
function BlockObjectActionsMenu(props2) {
  const $ = c(42), {
    children,
    focused,
    isOpen,
    onOpen,
    onRemove,
    readOnly,
    value
  } = props2, {
    t
  } = useTranslation(), menuButtonId = useId(), menuButton = useRef(null), isTabbing = useRef(!1);
  let t0;
  $[0] !== value ? (t0 = isReference$1(value) ? forwardRef(function(linkProps, ref) {
    return /* @__PURE__ */ jsx(IntentLink, { ...linkProps, intent: "edit", params: {
      id: value._ref
    }, ref });
  }) : void 0, $[0] = value, $[1] = t0) : t0 = $[1];
  const referenceLink = t0;
  let t1, t2;
  $[2] !== isOpen ? (t1 = () => {
    isOpen && (isTabbing.current = !1);
  }, t2 = [isOpen], $[2] = isOpen, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]), useEffect(t1, t2);
  let t3;
  $[5] !== focused || $[6] !== isOpen ? (t3 = (event) => {
    focused && event.key === "Tab" && menuButton.current && !isTabbing.current && !isOpen && (event.preventDefault(), event.stopPropagation(), menuButton.current.focus(), isTabbing.current = !0);
  }, $[5] = focused, $[6] = isOpen, $[7] = t3) : t3 = $[7], useGlobalKeyDown(t3);
  let t4;
  $[8] !== onRemove ? (t4 = (event_0) => {
    event_0.preventDefault(), event_0.stopPropagation(), onRemove();
  }, $[8] = onRemove, $[9] = t4) : t4 = $[9];
  const handleDelete = t4;
  let t5;
  $[10] !== children ? (t5 = /* @__PURE__ */ jsx(Box, { flex: 1, children }), $[10] = children, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t ? (t6 = t("inputs.portable-text.block.open-menu-aria-label"), $[12] = t, $[13] = t6) : t6 = $[13];
  const t7 = focused ? 0 : 1;
  let t8;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = {
    content: "Open menu"
  }, $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== t6 || $[16] !== t7 ? (t9 = /* @__PURE__ */ jsx(Button, { "aria-label": t6, icon: EllipsisHorizontalIcon, mode: "bleed", paddingY: 3, tabIndex: t7, tooltipProps: t8 }), $[15] = t6, $[16] = t7, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== referenceLink || $[19] !== t || $[20] !== value ? (t10 = "_ref" in value && !!value._ref && /* @__PURE__ */ jsx(MenuItem, { as: referenceLink, "data-as": "a", icon: LinkIcon, text: t("inputs.portable-text.block.open-reference") }), $[18] = referenceLink, $[19] = t, $[20] = value, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== onOpen || $[23] !== readOnly || $[24] !== t ? (t11 = readOnly && /* @__PURE__ */ jsx(MenuItem, { icon: EyeOpenIcon, onClick: onOpen, text: t("inputs.portable-text.block.view") }), $[22] = onOpen, $[23] = readOnly, $[24] = t, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== handleDelete || $[27] !== onOpen || $[28] !== readOnly || $[29] !== t ? (t12 = !readOnly && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(MenuItem, { icon: EditIcon, onClick: onOpen, text: t("inputs.portable-text.block.edit") }),
    /* @__PURE__ */ jsx(MenuItem, { icon: TrashIcon, onClick: handleDelete, text: t("inputs.portable-text.block.remove"), tone: "critical" })
  ] }), $[26] = handleDelete, $[27] = onOpen, $[28] = readOnly, $[29] = t, $[30] = t12) : t12 = $[30];
  let t13;
  $[31] !== t10 || $[32] !== t11 || $[33] !== t12 ? (t13 = /* @__PURE__ */ jsx(Menu, { children: /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t10,
    t11,
    t12
  ] }) }), $[31] = t10, $[32] = t11, $[33] = t12, $[34] = t13) : t13 = $[34];
  let t14;
  $[35] !== menuButtonId || $[36] !== t13 || $[37] !== t9 ? (t14 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(MenuButton, { button: t9, ref: menuButton, id: menuButtonId, menu: t13, popover: POPOVER_PROPS$4 }) }), $[35] = menuButtonId, $[36] = t13, $[37] = t9, $[38] = t14) : t14 = $[38];
  let t15;
  return $[39] !== t14 || $[40] !== t5 ? (t15 = /* @__PURE__ */ jsxs(Flex, { children: [
    t5,
    t14
  ] }), $[39] = t14, $[40] = t5, $[41] = t15) : t15 = $[41], t15;
}
function BlockObject(props2) {
  const $ = c(99), {
    floatingBoundary,
    focused,
    isFullscreen,
    onItemClose,
    onItemOpen,
    onPathFocus,
    path,
    readOnly,
    referenceBoundary,
    relativePath,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderBlockActions,
    renderCustomMarkers,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    selected,
    setElementRef,
    value
  } = props2, {
    onChange
  } = useFormCallbacks(), {
    Markers
  } = useFormBuilder().__internal.components, hoveredChange = useHoveredChange();
  let t0;
  $[0] !== hoveredChange || $[1] !== path ? (t0 = hoveredChange && pathToString$1(hoveredChange.path).startsWith(pathToString$1(path)), $[0] = hoveredChange, $[1] = path, $[2] = t0) : t0 = $[2];
  const changeHovered = t0, markers = usePortableTextMarkers(path), editor2 = usePortableTextEditor(), schemaTypes = usePortableTextMemberSchemaTypes(), [divElement, setDivElement] = useState(null);
  let t1;
  $[3] !== path ? (t1 = pathToString$1(path), $[3] = path, $[4] = t1) : t1 = $[4];
  const memberItem = usePortableTextMemberItem(t1), isDeleting = useRef(!1);
  let t2;
  $[5] !== relativePath ? (t2 = {
    anchor: {
      path: relativePath,
      offset: 0
    },
    focus: {
      path: relativePath,
      offset: 0
    }
  }, $[5] = relativePath, $[6] = t2) : t2 = $[6];
  const selfSelection = t2;
  let t3;
  $[7] !== editor2 || $[8] !== memberItem || $[9] !== onItemOpen ? (t3 = () => {
    memberItem && (PortableTextEditor.blur(editor2), onItemOpen(memberItem.node.path));
  }, $[7] = editor2, $[8] = memberItem, $[9] = onItemOpen, $[10] = t3) : t3 = $[10];
  const onOpen = t3;
  let t4;
  $[11] !== editor2 || $[12] !== onItemClose || $[13] !== selfSelection ? (t4 = () => {
    onItemClose(), PortableTextEditor.select(editor2, selfSelection), PortableTextEditor.focus(editor2);
  }, $[11] = editor2, $[12] = onItemClose, $[13] = selfSelection, $[14] = t4) : t4 = $[14];
  const onClose = t4;
  let t5;
  $[15] !== editor2 || $[16] !== selfSelection ? (t5 = () => {
    if (!isDeleting.current) {
      try {
        PortableTextEditor.delete(editor2, selfSelection, {
          mode: "blocks"
        });
      } catch (t62) {
        console.error(t62);
      }
      isDeleting.current = !0;
    }
  }, $[15] = editor2, $[16] = selfSelection, $[17] = t5) : t5 = $[17];
  const onRemove = t5;
  let t6, t7;
  $[18] !== editor2 ? (t6 = () => () => {
    isDeleting.current && PortableTextEditor.focus(editor2);
  }, t7 = [editor2], $[18] = editor2, $[19] = t6, $[20] = t7) : (t6 = $[19], t7 = $[20]), useEffect(t6, t7);
  let t8;
  bb0: {
    if (isFullscreen && !renderBlockActions) {
      let t93;
      $[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t93 = {
        paddingX: 5
      }, $[21] = t93) : t93 = $[21], t8 = t93;
      break bb0;
    }
    if (isFullscreen && renderBlockActions) {
      let t93;
      $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t93 = {
        paddingLeft: 5,
        paddingRight: 2
      }, $[22] = t93) : t93 = $[22], t8 = t93;
      break bb0;
    }
    if (renderBlockActions) {
      let t93;
      $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t93 = {
        paddingLeft: 3,
        paddingRight: 2
      }, $[23] = t93) : t93 = $[23], t8 = t93;
      break bb0;
    }
    let t92;
    $[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t92 = {
      paddingX: 3
    }, $[24] = t92) : t92 = $[24], t8 = t92;
  }
  const innerPaddingProps = t8, {
    validation: validation2,
    hasError,
    hasWarning,
    hasInfo
  } = useMemberValidation(memberItem?.node), parentSchemaType = schemaTypes.portableText, hasMarkers = markers.length > 0, presence = useChildPresence(path, !0);
  let t9;
  if ($[25] !== path || $[26] !== presence) {
    let t102;
    $[28] !== path ? (t102 = (p) => isEqual$2(p.path, path), $[28] = path, $[29] = t102) : t102 = $[29], t9 = presence.filter(t102), $[25] = path, $[26] = presence, $[27] = t9;
  } else
    t9 = $[27];
  const rootPresence = t9, tooltipEnabled = hasError || hasWarning || hasInfo || hasMarkers;
  let t10;
  $[30] !== Markers || $[31] !== markers || $[32] !== renderCustomMarkers || $[33] !== tooltipEnabled || $[34] !== validation2 ? (t10 = tooltipEnabled && /* @__PURE__ */ jsx(TooltipBox, { children: /* @__PURE__ */ jsx(Markers, { markers, validation: validation2, renderCustomMarkers }) }) || null, $[30] = Markers, $[31] = markers, $[32] = renderCustomMarkers, $[33] = tooltipEnabled, $[34] = validation2, $[35] = t10) : t10 = $[35];
  const toolTipContent = t10, isOpen = !!memberItem?.member.open, input = memberItem?.input, nodePath = memberItem?.node.path || EMPTY_ARRAY$y, referenceElement = divElement, t11 = memberItem?.member.item.changed ?? !1, t12 = !!readOnly;
  let t13;
  $[36] !== floatingBoundary || $[37] !== focused || $[38] !== input || $[39] !== isOpen || $[40] !== markers || $[41] !== nodePath || $[42] !== onClose || $[43] !== onOpen || $[44] !== onPathFocus || $[45] !== onRemove || $[46] !== parentSchemaType || $[47] !== referenceBoundary || $[48] !== referenceElement || $[49] !== renderAnnotation || $[50] !== renderBlock2 || $[51] !== renderField || $[52] !== renderInlineBlock || $[53] !== renderInput || $[54] !== renderItem2 || $[55] !== renderPreview || $[56] !== rootPresence || $[57] !== schemaType || $[58] !== selected || $[59] !== t11 || $[60] !== t12 || $[61] !== validation2 || $[62] !== value ? (t13 = {
    __unstable_floatingBoundary: floatingBoundary,
    __unstable_referenceBoundary: referenceBoundary,
    __unstable_referenceElement: referenceElement,
    changed: t11,
    children: input,
    focused,
    markers,
    onClose,
    onOpen,
    onPathFocus,
    onRemove,
    open: isOpen,
    parentSchemaType,
    path: nodePath,
    presence: rootPresence,
    readOnly: t12,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderDefault: DefaultBlockObjectComponent,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    selected,
    validation: validation2,
    value
  }, $[36] = floatingBoundary, $[37] = focused, $[38] = input, $[39] = isOpen, $[40] = markers, $[41] = nodePath, $[42] = onClose, $[43] = onOpen, $[44] = onPathFocus, $[45] = onRemove, $[46] = parentSchemaType, $[47] = referenceBoundary, $[48] = referenceElement, $[49] = renderAnnotation, $[50] = renderBlock2, $[51] = renderField, $[52] = renderInlineBlock, $[53] = renderInput, $[54] = renderItem2, $[55] = renderPreview, $[56] = rootPresence, $[57] = schemaType, $[58] = selected, $[59] = t11, $[60] = t12, $[61] = validation2, $[62] = value, $[63] = t13) : t13 = $[63];
  const componentProps = t13, blockActionsEnabled = renderBlockActions && value && !readOnly, changeIndicatorVisible = isFullscreen && memberItem;
  let t14;
  $[64] !== memberItem || $[65] !== setElementRef ? (t14 = (elm) => {
    memberItem && setElementRef({
      key: memberItem.member.key,
      elementRef: elm
    }), setDivElement(elm);
  }, $[64] = memberItem, $[65] = setElementRef, $[66] = t14) : t14 = $[66];
  const setRef = t14;
  let t15;
  $[67] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = void 0, $[67] = t15) : t15 = $[67];
  const t16 = isOpen ? !0 : !tooltipEnabled;
  let t17;
  $[68] !== componentProps || $[69] !== renderBlock2 ? (t17 = renderBlock2 && /* @__PURE__ */ jsx(RenderBlock, { ...componentProps, renderBlock: renderBlock2 }), $[68] = componentProps, $[69] = renderBlock2, $[70] = t17) : t17 = $[70];
  let t18;
  $[71] !== t17 ? (t18 = /* @__PURE__ */ jsx("div", { children: t17 }), $[71] = t17, $[72] = t18) : t18 = $[72];
  let t19;
  $[73] !== t16 || $[74] !== t18 || $[75] !== toolTipContent ? (t19 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Tooltip, { placement: "top", portal: "editor", disabled: t16, content: toolTipContent, children: t18 }) }), $[73] = t16, $[74] = t18, $[75] = toolTipContent, $[76] = t19) : t19 = $[76];
  let t20;
  $[77] !== blockActionsEnabled || $[78] !== focused || $[79] !== onChange || $[80] !== renderBlockActions || $[81] !== value ? (t20 = blockActionsEnabled && /* @__PURE__ */ jsx(BlockActionsOuter, { contentEditable: !1, marginRight: 3, children: /* @__PURE__ */ jsx(BlockActionsInner, { children: focused && /* @__PURE__ */ jsx(BlockActions, { block: value, onChange, renderBlockActions }) }) }), $[77] = blockActionsEnabled, $[78] = focused, $[79] = onChange, $[80] = renderBlockActions, $[81] = value, $[82] = t20) : t20 = $[82];
  let t21;
  $[83] !== changeIndicatorVisible || $[84] !== focused || $[85] !== memberItem ? (t21 = changeIndicatorVisible && /* @__PURE__ */ jsx(ChangeIndicatorWrapper, { $hasChanges: memberItem.member.item.changed, contentEditable: !1, children: /* @__PURE__ */ jsx(StyledChangeIndicatorWithProvidedFullPath, { hasFocus: focused, isChanged: memberItem.member.item.changed, path: memberItem.member.item.path, withHoverEffect: !1 }) }), $[83] = changeIndicatorVisible, $[84] = focused, $[85] = memberItem, $[86] = t21) : t21 = $[86];
  let t22;
  $[87] !== changeHovered || $[88] !== isFullscreen ? (t22 = changeHovered && /* @__PURE__ */ jsx(ReviewChangesHighlightBlock, { $fullScreen: !!isFullscreen }), $[87] = changeHovered, $[88] = isFullscreen, $[89] = t22) : t22 = $[89];
  let t23;
  $[90] !== innerPaddingProps || $[91] !== t19 || $[92] !== t20 || $[93] !== t21 || $[94] !== t22 ? (t23 = /* @__PURE__ */ jsx(Flex, { paddingBottom: 1, marginY: 3, style: t15, children: /* @__PURE__ */ jsxs(PreviewContainer, { ...innerPaddingProps, children: [
    t19,
    t20,
    t21,
    t22
  ] }) }), $[90] = innerPaddingProps, $[91] = t19, $[92] = t20, $[93] = t21, $[94] = t22, $[95] = t23) : t23 = $[95];
  let t24;
  return $[96] !== setRef || $[97] !== t23 ? (t24 = /* @__PURE__ */ jsx(Box, { ref: setRef, contentEditable: !1, children: t23 }), $[96] = setRef, $[97] = t23, $[98] = t24) : t24 = $[98], t24;
}
function RenderBlock(props2) {
  const {
    renderBlock: renderBlock2,
    ...componentProps
  } = props2;
  return renderBlock2(componentProps);
}
const DefaultBlockObjectComponent = (props2) => {
  const $ = c(42), {
    __unstable_floatingBoundary,
    __unstable_referenceBoundary,
    __unstable_referenceElement,
    children,
    focused,
    markers,
    onClose,
    onOpen,
    onRemove,
    open,
    readOnly,
    renderPreview,
    schemaType,
    selected,
    value,
    validation: validation2
  } = props2, {
    t
  } = useTranslation(), isImagePreview = isImage(value), hasError = validation2.filter(_temp$2k).length > 0, hasWarning = validation2.filter(_temp2$X).length > 0, hasMarkers = markers.length > 0, tone = selected || focused ? "primary" : "default", uploadState = value[UPLOAD_STATUS_KEY], uploadProgress = typeof uploadState?.progress == "number" ? uploadState?.progress : void 0;
  let t0;
  $[0] !== onOpen ? (t0 = (e) => {
    e.preventDefault(), e.stopPropagation(), onOpen();
  }, $[0] = onOpen, $[1] = t0) : t0 = $[1];
  const handleDoubleClickToOpen = t0;
  let t1;
  $[2] !== t ? (t1 = t("inputs.portable-text.block.aria-label"), $[2] = t, $[3] = t1) : t1 = $[3];
  const t2 = focused ? "" : void 0, t3 = isImagePreview ? "" : void 0, t4 = hasError ? "" : void 0, t5 = hasMarkers ? "" : void 0, t6 = readOnly ? "" : void 0, t7 = selected ? "" : void 0, t8 = hasWarning ? "" : void 0, t9 = isImagePreview ? 0 : 1;
  let t10;
  $[4] !== focused || $[5] !== onOpen || $[6] !== onRemove || $[7] !== open || $[8] !== readOnly || $[9] !== value ? (t10 = /* @__PURE__ */ jsx(BlockObjectActionsMenu, { isOpen: open, focused, onOpen, onRemove, readOnly, value }), $[4] = focused, $[5] = onOpen, $[6] = onRemove, $[7] = open, $[8] = readOnly, $[9] = value, $[10] = t10) : t10 = $[10];
  const t11 = isImagePreview ? "blockImage" : "block";
  let t12;
  $[11] !== renderPreview || $[12] !== schemaType || $[13] !== t10 || $[14] !== t11 || $[15] !== uploadProgress || $[16] !== value ? (t12 = renderPreview({
    actions: t10,
    progress: uploadProgress,
    layout: t11,
    schemaType,
    skipVisibilityCheck: !0,
    value
  }), $[11] = renderPreview, $[12] = schemaType, $[13] = t10, $[14] = t11, $[15] = uploadProgress, $[16] = value, $[17] = t12) : t12 = $[17];
  let t13;
  $[18] !== handleDoubleClickToOpen || $[19] !== t1 || $[20] !== t12 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9 || $[29] !== tone ? (t13 = /* @__PURE__ */ jsx(Root$g, { "aria-label": t1, "data-focused": t2, "data-image-preview": t3, "data-invalid": t4, "data-markers": t5, "data-read-only": t6, "data-selected": t7, "data-testid": "pte-block-object", "data-warning": t8, flex: 1, onDoubleClick: handleDoubleClickToOpen, padding: t9, tone, children: t12 }), $[18] = handleDoubleClickToOpen, $[19] = t1, $[20] = t12, $[21] = t2, $[22] = t3, $[23] = t4, $[24] = t5, $[25] = t6, $[26] = t7, $[27] = t8, $[28] = t9, $[29] = tone, $[30] = t13) : t13 = $[30];
  let t14;
  $[31] !== __unstable_floatingBoundary || $[32] !== __unstable_referenceBoundary || $[33] !== __unstable_referenceElement || $[34] !== children || $[35] !== onClose || $[36] !== open || $[37] !== schemaType ? (t14 = open && /* @__PURE__ */ jsx(ObjectEditModal, { floatingBoundary: __unstable_floatingBoundary, defaultType: "dialog", onClose, autoFocus: !0, schemaType, referenceBoundary: __unstable_referenceBoundary, referenceElement: __unstable_referenceElement, children }), $[31] = __unstable_floatingBoundary, $[32] = __unstable_referenceBoundary, $[33] = __unstable_referenceElement, $[34] = children, $[35] = onClose, $[36] = open, $[37] = schemaType, $[38] = t14) : t14 = $[38];
  let t15;
  return $[39] !== t13 || $[40] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t13,
    t14
  ] }), $[39] = t13, $[40] = t14, $[41] = t15) : t15 = $[41], t15;
};
function _temp$2k(v) {
  return v.level === "error";
}
function _temp2$X(v_0) {
  return v_0.level === "warning";
}
function defaultResolveBlockComponent(schemaType) {
  return schemaType.components?.block ? schemaType.components.block : isBlockType(schemaType) ? DefaultComponent$1 : DefaultBlockObjectComponent;
}
function defaultResolveInlineBlockComponent(schemaType) {
  return schemaType.components?.inlineBlock ? schemaType.components.inlineBlock : DefaultInlineObjectComponent;
}
function defaultResolveAnnotationComponent(schemaType) {
  return schemaType.components?.annotation ? schemaType.components.annotation : DefaultAnnotationComponent;
}
function useResolveDefaultComponent(props2) {
  const $ = c(9), {
    componentResolver,
    componentProps
  } = props2;
  if (!componentProps.schemaType)
    throw new Error("the `schemaType` property must be defined");
  let t0;
  $[0] !== componentProps.schemaType || $[1] !== componentResolver ? (t0 = componentResolver(componentProps.schemaType), $[0] = componentProps.schemaType, $[1] = componentResolver, $[2] = t0) : t0 = $[2];
  const DefaultResolvedComponent = t0;
  let t1;
  $[3] !== componentResolver ? (t1 = (parentTypeProps) => {
    if (!parentTypeProps.schemaType?.type)
      throw new Error("Attempted to render form component of non-existent parent type");
    const {
      components: components2,
      ...restSchemaType
    } = parentTypeProps.schemaType, ParentTypeResolvedComponent = componentResolver(restSchemaType);
    return /* @__PURE__ */ jsx(ParentTypeResolvedComponent, { ...parentTypeProps });
  }, $[3] = componentResolver, $[4] = t1) : t1 = $[4];
  const renderDefault = t1;
  let t2;
  return $[5] !== DefaultResolvedComponent || $[6] !== componentProps || $[7] !== renderDefault ? (t2 = /* @__PURE__ */ jsx(DefaultResolvedComponent, { ...componentProps, renderDefault }), $[5] = DefaultResolvedComponent, $[6] = componentProps, $[7] = renderDefault, $[8] = t2) : t2 = $[8], t2;
}
function DefaultInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolveInputComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function DefaultField(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolveFieldComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function DefaultItem(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolveItemComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function DefaultPreview$1(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolvePreviewComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function DefaultBlock(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolveBlockComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function DefaultInlineBlock(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolveInlineBlockComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function DefaultAnnotation(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolveAnnotationComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function useInputComponent() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultInput,
    pick: pickInputComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useFieldComponent() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultField,
    pick: pickFieldComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function usePreviewComponent() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultPreview$1,
    pick: pickPreviewComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useItemComponent() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultItem,
    pick: pickItemComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useBlockComponent() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultBlock,
    pick: pickBlockComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useInlineBlockComponent() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultInlineBlock,
    pick: pickInlineBlockComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useAnnotationComponent() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultAnnotation,
    pick: pickAnnotationComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function Preview$1(props2) {
  const $ = c(3), PreviewComponent = usePreviewComponent();
  let t0;
  return $[0] !== PreviewComponent || $[1] !== props2 ? (t0 = /* @__PURE__ */ jsx(PreviewLoader, { ...props2, component: PreviewComponent }), $[0] = PreviewComponent, $[1] = props2, $[2] = t0) : t0 = $[2], t0;
}
const _previewComponents = {
  block: BlockPreview,
  blockImage: BlockImagePreview,
  compact: CompactPreview,
  default: DefaultPreview,
  detail: DetailPreview,
  inline: InlinePreview,
  media: MediaPreview
};
function FallbackIcon() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(DocumentIcon, { className: "sanity-studio__preview-fallback-icon" }), $[0] = t0) : t0 = $[0], t0;
}
function SanityDefaultMedia(t0) {
  const $ = c(17), {
    client,
    dimensions,
    imageSource,
    imageUrlBuilder,
    title
  } = t0;
  let t1;
  $[0] !== dimensions ? (t1 = (builder, val) => {
    const width = dimensions.width ?? 100, height = dimensions.height ?? 100, fit = dimensions.fit, dpr = dimensions.dpr ?? 1;
    return builder.image(val).withOptions({
      width,
      height,
      fit,
      dpr
    }).url() || "";
  }, $[0] = dimensions, $[1] = t1) : t1 = $[1];
  const transform = t1;
  let t2;
  $[2] !== client || $[3] !== imageSource ? (t2 = {
    client,
    source: imageSource
  }, $[2] = client, $[3] = imageSource, $[4] = t2) : t2 = $[4];
  const accessPolicy = useAccessPolicy(t2);
  let t3;
  $[5] !== accessPolicy || $[6] !== imageSource || $[7] !== imageUrlBuilder || $[8] !== transform ? (t3 = {
    accessPolicy,
    imageSource,
    imageUrlBuilder,
    transform
  }, $[5] = accessPolicy, $[6] = imageSource, $[7] = imageUrlBuilder, $[8] = transform, $[9] = t3) : t3 = $[9];
  const {
    isLoading,
    url
  } = useImageUrl(t3), [hasImageError, setHasImageError] = useState(!1);
  let t4;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => setHasImageError(!0), $[10] = t4) : t4 = $[10];
  const handleError = t4;
  if (isLoading) {
    let t52;
    return $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t52 = /* @__PURE__ */ jsx(Skeleton, { animated: !0, style: {
      width: "100%",
      height: "100%"
    } }), $[11] = t52) : t52 = $[11], t52;
  }
  if (accessPolicy === "unknown" && hasImageError) {
    let t52;
    $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t52 = {
      width: "100%",
      height: "100%"
    }, $[12] = t52) : t52 = $[12];
    let t62;
    return $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t62 = /* @__PURE__ */ jsx(Card, { tone: "critical", style: t52, children: /* @__PURE__ */ jsx(Flex, { justify: "center", align: "center", style: {
      width: "100%",
      height: "100%"
    }, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[13] = t62) : t62 = $[13], t62;
  }
  const t5 = typeof title == "string" ? title : void 0;
  let t6;
  return $[14] !== t5 || $[15] !== url ? (t6 = /* @__PURE__ */ jsx("img", { alt: t5, onError: handleError, referrerPolicy: "strict-origin-when-cross-origin", src: url }), $[14] = t5, $[15] = url, $[16] = t6) : t6 = $[16], t6;
}
const SanityDefaultPreview = memo(function(props2) {
  const $ = c(34);
  let Icon2, imageUrl, layout, mediaProp, restProps, title, tooltip;
  $[0] !== props2 ? ({
    icon: Icon2,
    layout,
    media: mediaProp,
    imageUrl,
    title,
    tooltip,
    ...restProps
  } = props2, $[0] = props2, $[1] = Icon2, $[2] = imageUrl, $[3] = layout, $[4] = mediaProp, $[5] = restProps, $[6] = title, $[7] = tooltip) : (Icon2 = $[1], imageUrl = $[2], layout = $[3], mediaProp = $[4], restProps = $[5], title = $[6], tooltip = $[7]);
  const client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0;
  $[8] !== client ? (t0 = createImageUrlBuilder(client), $[8] = client, $[9] = t0) : t0 = $[9];
  const imageBuilder = t0;
  let t1;
  $[10] !== client || $[11] !== imageBuilder || $[12] !== mediaProp || $[13] !== title ? (t1 = (options) => {
    let imageSource = mediaProp;
    if (isString(imageSource) && isSanityImageUrl(imageSource)) {
      const {
        assetId
      } = parseImageAssetUrl(imageSource);
      imageSource = assetId;
    }
    return /* @__PURE__ */ jsx(SanityDefaultMedia, { client, dimensions: options.dimensions, imageSource, imageUrlBuilder: imageBuilder, title });
  }, $[10] = client, $[11] = imageBuilder, $[12] = mediaProp, $[13] = title, $[14] = t1) : t1 = $[14];
  const renderMedia2 = t1;
  let t2;
  $[15] !== Icon2 ? (t2 = () => Icon2 ? /* @__PURE__ */ jsx(Icon2, {}) : /* @__PURE__ */ jsx(FallbackIcon, {}), $[15] = Icon2, $[16] = t2) : t2 = $[16];
  const renderIcon = t2;
  let t3;
  bb0: {
    if (Icon2 === !1) {
      t3 = !1;
      break bb0;
    }
    if (isString(mediaProp) && isSanityImageUrl(mediaProp)) {
      t3 = renderMedia2;
      break bb0;
    }
    if (isImageSource(mediaProp)) {
      t3 = renderMedia2;
      break bb0;
    }
    if (isValidElementType(mediaProp)) {
      t3 = mediaProp;
      break bb0;
    }
    if (isValidElement(mediaProp)) {
      t3 = mediaProp;
      break bb0;
    }
    if (isString(imageUrl)) {
      const t42 = isString(title) ? title : void 0;
      let t52;
      $[17] !== imageUrl || $[18] !== t42 ? (t52 = /* @__PURE__ */ jsx("img", { src: imageUrl, alt: t42, referrerPolicy: "strict-origin-when-cross-origin" }), $[17] = imageUrl, $[18] = t42, $[19] = t52) : t52 = $[19], t3 = t52;
      break bb0;
    }
    t3 = renderIcon;
  }
  const t4 = t3;
  let t5;
  $[20] !== restProps || $[21] !== t4 || $[22] !== title ? (t5 = {
    ...restProps,
    media: t4,
    title
  }, $[20] = restProps, $[21] = t4, $[22] = title, $[23] = t5) : t5 = $[23];
  const previewProps = t5, LayoutComponent = _previewComponents[layout || "default"];
  let t6;
  $[24] !== LayoutComponent || $[25] !== previewProps ? (t6 = /* @__PURE__ */ jsx(LayoutComponent, { ...previewProps }), $[24] = LayoutComponent, $[25] = previewProps, $[26] = t6) : t6 = $[26];
  const children = t6;
  if (tooltip) {
    const t7 = !tooltip;
    let t8;
    $[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = ["top-end", "bottom-end"], $[27] = t8) : t8 = $[27];
    let t9;
    $[28] !== children ? (t9 = /* @__PURE__ */ jsx("div", { children }), $[28] = children, $[29] = t9) : t9 = $[29];
    let t10;
    return $[30] !== t7 || $[31] !== t9 || $[32] !== tooltip ? (t10 = /* @__PURE__ */ jsx(Tooltip, { content: tooltip, disabled: t7, fallbackPlacements: t8, placement: "right", children: t9 }), $[30] = t7, $[31] = t9, $[32] = tooltip, $[33] = t10) : t10 = $[33], t10;
  }
  return children;
});
SanityDefaultPreview.displayName = "Memo(SanityDefaultPreview)";
const MAX_DOCUMENT_ID_CHUNK_SIZE = 11164, INCLUDE_FIELDS_QUERY = ["_id", "_rev", "_type"], INCLUDE_FIELDS = [...INCLUDE_FIELDS_QUERY, "_key"], LISTENER_RESET_DELAY = 5e3, AVAILABILITY_READABLE = {
  available: !0,
  reason: "READABLE"
}, AVAILABILITY_PERMISSION_DENIED = {
  available: !1,
  reason: "PERMISSION_DENIED"
}, AVAILABILITY_NOT_FOUND = {
  available: !1,
  reason: "NOT_FOUND"
}, AVAILABILITY_VERSION_DELETED = {
  available: !1,
  reason: "VERSION_DELETED"
}, INVALID_PREVIEW_FALLBACK = {
  title: "Invalid preview config",
  subtitle: "Check the error log in the console",
  media: /* @__PURE__ */ jsx(WarningOutlineIcon, {})
};
function debounceCollect(fn, wait) {
  let timer2, queue = {}, idx = 0;
  return function(...args) {
    return new Observable((obs) => {
      clearTimeout(timer2), timer2 = setTimeout(flush, wait);
      const queueItem = {
        args,
        observer: obs,
        completed: !1
      }, id2 = idx++;
      return queue[id2] = queueItem, () => {
        queueItem.completed = !0;
      };
    });
  };
  function flush() {
    const currentlyFlushingQueue = queue;
    queue = {};
    const queueItemIds = Object.keys(currentlyFlushingQueue).filter((id2) => {
      const queueItem = currentlyFlushingQueue[id2];
      return queueItem && !queueItem.completed;
    });
    if (queueItemIds.length === 0)
      return;
    const collectedArgs = queueItemIds.map((id2) => {
      const queueItem = currentlyFlushingQueue[id2];
      return queueItem && queueItem.args;
    }).filter(isNonNullable$2);
    fn(collectedArgs).subscribe({
      next(results) {
        results.forEach((result, i) => {
          const queueItem = currentlyFlushingQueue[queueItemIds[i]];
          queueItem && !queueItem.completed && queueItem.observer.next(results[i]);
        });
      },
      complete() {
        queueItemIds.forEach((id2) => {
          const entry = currentlyFlushingQueue[id2];
          entry && !entry.completed && entry.observer.complete();
        });
      },
      error(err) {
        queueItemIds.forEach((id2) => {
          const entry = currentlyFlushingQueue[id2];
          entry && !entry.completed && entry.observer.error(err);
        });
      }
    });
  }
}
const swr$1 = createSWR({
  maxSize: 1e3
});
function chunkDocumentIds(documentIds) {
  let chunk = [], chunkSize = 0;
  const chunks = [];
  for (const documentId of documentIds)
    chunkSize + documentId.length + 1 >= MAX_DOCUMENT_ID_CHUNK_SIZE && (chunks.push(chunk), chunk = [], chunkSize = 0), chunkSize += documentId.length + 1, chunk.push(documentId);
  return chunks.includes(chunk) || chunks.push(chunk), chunks;
}
function mutConcat(array, chunks) {
  return array.push(...chunks), array;
}
function createDocumentAvailabilityObserver(versionedClient2, observePaths2) {
  const fetchDocumentReadability = debounceCollect(function(args) {
    const uniqueIds = [...new Set(flatten$1(args))];
    return from(chunkDocumentIds(uniqueIds)).pipe(mergeMap(fetchDocumentReadabilityChunked, 10), reduce$2(mutConcat, []), map((res) => args.map(([id2]) => res[uniqueIds.indexOf(id2)])));
  }, 1);
  function fetchDocumentReadabilityChunked(ids) {
    return defer(() => {
      const requestOptions = {
        uri: versionedClient2.getDataUrl("doc", ids.join(",")),
        json: !0,
        query: {
          excludeContent: "true"
        },
        tag: "preview.documents-availability"
      };
      return versionedClient2.observable.request(requestOptions).pipe(map((response) => {
        const omitted = keyBy(response.omitted || [], (entry) => entry.id);
        return ids.map((id2) => {
          const omittedEntry = omitted[id2];
          if (!omittedEntry)
            return AVAILABILITY_READABLE;
          if (omittedEntry.reason === "existence")
            return AVAILABILITY_NOT_FOUND;
          if (omittedEntry.reason === "permission")
            return AVAILABILITY_PERMISSION_DENIED;
          throw new Error(`Unexpected reason for omission: "${omittedEntry.reason}"`);
        });
      }));
    });
  }
  return function(id2) {
    return observePaths2({
      _id: id2
    }, [["_rev"], ["_system"]]).pipe(map((res) => ({
      hasRev: isRecord$4(res) && !!("_rev" in res && res?._rev),
      isDeleted: isRecord$4(res) && res._system?.delete === !0
    })), distinctUntilChanged(), switchMap(({
      hasRev,
      isDeleted
    }) => isDeleted ? of(AVAILABILITY_VERSION_DELETED) : hasRev ? (
      // short circuit: if we can read the _rev field we know it both exists and is readable
      of(AVAILABILITY_READABLE)
    ) : (
      // we can't read the _rev field for two possible reasons: 1) the document isn't readable or 2) the document doesn't exist
      fetchDocumentReadability(id2)
    )), swr$1(id2), map((ev) => ev.value));
  };
}
function ensurePublished(stack) {
  return stack.includes("published") ? stack : stack.concat(["published"]);
}
function createDocumentStackAvailabilityObserver(versionedClient2, observePaths2) {
  const observeDocumentAvailability = createDocumentAvailabilityObserver(versionedClient2, observePaths2);
  return (id2, stack) => combineLatest(
    // explicitly check availability for published id (we're not using perspective in the following fetch here)
    ensurePublished(stack).map((perspective) => {
      const versionId = perspective === "drafts" ? getDraftId(id2) : perspective === "published" ? getPublishedId(id2) : getVersionId(id2, perspective);
      return observeDocumentAvailability(versionId).pipe(map((availability) => ({
        availability,
        id: versionId
      })));
    })
  );
}
function createPreviewAvailabilityObserver(versionedClient2, observePaths2) {
  const observeDocumentAvailability = createDocumentAvailabilityObserver(versionedClient2, observePaths2);
  return function(id2, {
    version: version2
  } = {}) {
    const draftId = getDraftId(id2), publishedId = getPublishedId(id2), versionId = version2 ? getVersionId(id2, version2) : void 0;
    return combineLatest([observeDocumentAvailability(draftId), observeDocumentAvailability(publishedId), ...versionId ? [observeDocumentAvailability(versionId)] : []]).pipe(distinctUntilChanged(shallowEquals), map(([draftReadability, publishedReadability, versionReadability]) => ({
      draft: draftReadability,
      published: publishedReadability,
      ...versionReadability ? {
        version: versionReadability
      } : {}
    })));
  };
}
function createGlobalListener(client) {
  return client.listen("*", {}, {
    events: ["welcome", "mutation", "reconnect"],
    includeResult: !1,
    includePreviousRevision: !1,
    includeMutations: !1,
    includeAllVersions: !0,
    visibility: "query",
    effectFormat: "mendoza",
    tag: "preview.global"
  }).pipe(shareReplayLatest({
    predicate: (event) => event.type === "welcome" || event.type === "reconnect",
    resetOnRefCountZero: () => timer(LISTENER_RESET_DELAY)
  }));
}
function omitRev$1(document2) {
  if (document2 === void 0)
    return;
  const {
    _rev,
    ...doc
  } = document2;
  return doc;
}
function applyMendozaPatch(document2, patch2, baseRev) {
  if (baseRev !== document2?._rev)
    throw new Error("Invalid document revision. The provided patch is calculated from a different revision than the current document");
  const next = applyPatch$1(omitRev$1(document2), patch2);
  return next === null ? void 0 : next;
}
function applyMutationEventEffects(document2, event) {
  if (!event.effects)
    throw new Error("Mutation event is missing effects. Is the listener set up with effectFormat=mendoza?");
  const next = applyMendozaPatch(document2, event.effects.apply, event.previousRev);
  return next ? {
    ...next,
    _rev: event.resultRev
  } : void 0;
}
function createObserveDocument({
  mutationChannel,
  client
}) {
  const getBatchFetcher = memoize$1(function(apiConfig) {
    const _client = client.withConfig(apiConfig);
    function batchFetchDocuments(ids) {
      return _client.observable.fetch("*[_id in $ids]", {
        ids: uniq(ids.flat())
      }, {
        tag: "preview.observe-document"
      }).pipe(
        // eslint-disable-next-line max-nested-callbacks
        map((result) => ids.map(([id2]) => result.find((r) => r._id === id2)))
      );
    }
    return debounceCollect(batchFetchDocuments, 100);
  }, (apiConfig) => apiConfig.dataset + apiConfig.projectId + apiConfig.apiVersion), MEMO = {};
  function observeDocument(id2, apiConfig) {
    const _apiConfig = {
      dataset: apiConfig?.dataset || client.config().dataset,
      projectId: apiConfig?.projectId || client.config().projectId,
      apiVersion: apiConfig?.apiVersion || client.config().apiVersion
    }, fetchDocument = getBatchFetcher(_apiConfig);
    return mutationChannel.pipe(concatMap$1((event) => event.type === "welcome" ? fetchDocument(id2).pipe(map((document2) => ({
      type: "sync",
      document: document2
    }))) : event.documentId === id2 ? of(event) : EMPTY$5), scan((current, event) => {
      if (event.type === "sync")
        return event.document;
      if (event.type === "mutation")
        return applyMutationEvent(current, event);
      throw new Error(`Unexpected event type: "${event.type}"`);
    }, void 0));
  }
  return function(id2, apiConfig) {
    const key = apiConfig ? `${id2}-${JSON.stringify(apiConfig)}` : id2;
    return key in MEMO || (MEMO[key] = observeDocument(id2, apiConfig).pipe(finalize(() => delete MEMO[key]), shareReplay({
      bufferSize: 1,
      refCount: !0
    }))), MEMO[key];
  };
}
function applyMutationEvent(current, event) {
  if (event.previousRev !== current?._rev)
    return console.warn("Document out of sync, skipping mutation"), current;
  if (!event.effects)
    throw new Error("Mutation event is missing effects. Is the listener set up with effectFormat=mendoza?");
  return applyMutationEventEffects(current, event);
}
const DEFAULT_PREVIEW_PATHS = [["_createdAt"], ["_updatedAt"]];
function getPreviewPaths(preview) {
  const selection = preview?.select;
  return selection ? (Object.values(selection).map((value) => String(value).split(".")) || []).concat(DEFAULT_PREVIEW_PATHS) : void 0;
}
function isPortableTextPreviewValue(value) {
  return Array.isArray(value) && (value.length === 0 || value.some(isPortableTextTextBlock));
}
function extractTextFromBlocks(blocks) {
  const firstBlock = Array.isArray(blocks) && blocks.find(isPortableTextTextBlock);
  return !firstBlock || !firstBlock.children ? "" : firstBlock.children.filter(isPortableTextSpan).map((span) => span.text).join("");
}
const PRESERVE_KEYS = ["_id", "_type", "_upload", "_createdAt", "_updatedAt"], EMPTY$2 = [], errorCollector = /* @__PURE__ */ (() => {
  let errorsByType = {};
  return {
    add: (type, value, error) => {
      const typeName = "name" in type ? type.name : type.type;
      errorsByType[typeName] || (errorsByType[typeName] = []), errorsByType[typeName].push({
        error,
        type,
        value
      });
    },
    getAll() {
      return errorsByType;
    },
    clear() {
      errorsByType = {};
    }
  };
})(), reportErrors = debounce(() => {
  const errorsByType = errorCollector.getAll(), errorCount = flatten$1(Object.keys(errorsByType).map((typeName) => {
    const entries = errorsByType[typeName];
    return uniqBy(entries, (entry) => entry.error.message);
  })).length;
  errorCount !== 0 && (console.groupCollapsed(`%cHeads up! Got ${errorCount === 1 ? "error" : `${errorCount} errors`} while preparing data for preview. Click for details.`, "color: #ff7e7c"), Object.keys(errorsByType).forEach((typeName) => {
    const entries = errorsByType[typeName], first2 = entries[0];
    console.group(`Check the preview config for schema type "${typeName}": %o`, first2.type.preview), uniqBy(entries, (entry) => entry.error.message).forEach((entry) => {
      if (entry.error.type === "returnValueError") {
        const hasPrepare = typeof entry.type.preview?.prepare == "function", {
          value,
          error
        } = entry;
        console.log(`Encountered an invalid ${hasPrepare ? "return value when calling prepare(%o)" : "value targeted by preview.select"}:`, value), console.error(error);
      }
      if (entry.error.type === "prepareError") {
        const {
          value,
          error
        } = entry;
        console.log("Encountered an error when calling prepare(%o):", value), console.error(error);
      }
    }), console.groupEnd();
  }), console.groupEnd(), errorCollector.clear());
}, 1e3), isRenderable = (fieldName) => (value) => {
  const type = typeof value;
  return value === null || type === "undefined" || type === "string" || type === "number" || type === "boolean" ? EMPTY$2 : [assignType("returnValueError", new Error(`The "${fieldName}" field should be a string, number, boolean, undefined or null, instead saw ${inspect(value)}`))];
}, FIELD_NAME_VALIDATORS = {
  media: () => EMPTY$2,
  title: isRenderable("title"),
  subtitle: isRenderable("subtitle"),
  description: isRenderable("description"),
  imageUrl: isRenderable("imageUrl"),
  date: isRenderable("date")
};
function inspect(val, prefixType = !0) {
  if (isRecord$4(val)) {
    const keys = Object.keys(val), ellipse = keys.length > 3 ? "..." : "";
    return `${prefixType ? "object with keys " : ""}{${keys.slice(0, 3).join(", ")}${ellipse}}`;
  }
  if (Array.isArray(val)) {
    const ellipse = val.length > 3 ? "..." : "";
    return `${prefixType ? "array with " : ""}[${val.map((v) => inspect(v, !1))}${ellipse}]`;
  }
  return `the ${typeof val} ${val}`;
}
function validateFieldValue(fieldName, fieldValue) {
  if (typeof fieldValue > "u")
    return EMPTY$2;
  const validator = FIELD_NAME_VALIDATORS[fieldName];
  return validator && validator(fieldValue) || EMPTY$2;
}
function assignType(type, error) {
  return Object.assign(error, {
    type
  });
}
function validatePreparedValue(preparedValue) {
  return !isPlainObject$1(preparedValue) || preparedValue === null ? [assignType("returnValueError", new Error(`Invalid return value. Expected a plain object with at least a 'title' field, instead saw ${inspect(preparedValue)}`))] : Object.entries(preparedValue).reduce((acc, [fieldName, fieldValue]) => [...acc, ...validateFieldValue(fieldName, fieldValue)], EMPTY$2);
}
function validateReturnedPreview(result) {
  return {
    ...result,
    errors: [...result.errors || [], ...validatePreparedValue(result.returnValue)]
  };
}
function defaultPrepare(value) {
  return keysOf(value).reduce((acc, fieldName) => {
    const val = value[fieldName];
    return {
      ...acc,
      [fieldName]: isPortableTextPreviewValue(val) ? extractTextFromBlocks(val) : val
    };
  }, {});
}
function invokePrepare(type, value, viewOptions = {}) {
  const prepare2 = type.preview?.prepare;
  try {
    return {
      returnValue: prepare2 ? prepare2(value, viewOptions) : defaultPrepare(value),
      errors: EMPTY$2
    };
  } catch (error) {
    return {
      returnValue: null,
      errors: [assignType("prepareError", error)]
    };
  }
}
function withErrors(result, type, selectedValue) {
  return result.errors.forEach((error) => errorCollector.add(type, selectedValue, error)), reportErrors(), INVALID_PREVIEW_FALLBACK;
}
function hasEnumListOptions(type) {
  const options = type.options && typeof type.options == "object" ? type.options : !1;
  if (!options || !("list" in options))
    return !1;
  const listOptions = options.list;
  return Array.isArray(listOptions);
}
function getListOptions(type) {
  return hasEnumListOptions(type) ? type.options.list.map((option) => isTitledListValue(option) ? option : {
    title: option,
    value: option
  }) : void 0;
}
function prepareForPreview(rawValue, type, viewOptions = {}) {
  const hasCustomPrepare = typeof type.preview?.prepare == "function", selection = type.preview?.select || {}, selectedValue = Object.keys(selection).reduce((acc, key) => {
    const typeWithFields = "fields" in type ? type : null, targetFieldName = selection[key], valueField = typeWithFields?.fields?.find((f) => f.name === targetFieldName), listOptions = valueField && getListOptions(valueField.type);
    if (!hasCustomPrepare && listOptions) {
      const selectedOption = listOptions && listOptions.find((opt) => opt.value === get(rawValue, selection[key]));
      acc[key] = selectedOption ? selectedOption.value : get(rawValue, selection[key]);
    } else
      acc[key] = get(rawValue, selection[key]);
    return acc;
  }, {}), prepareResult = invokePrepare(type, selectedValue, viewOptions);
  if (prepareResult.errors.length > 0)
    return withErrors(prepareResult, type, selectedValue);
  const returnValueResult = validateReturnedPreview(prepareResult);
  return returnValueResult.errors.length > 0 ? withErrors(returnValueResult, type, selectedValue) : {
    ...pick(rawValue, PRESERVE_KEYS),
    ...prepareResult.returnValue
  };
}
function isRecord(value) {
  return isPlainObject$1(value);
}
function isReference(value) {
  return isPlainObject$1(value);
}
function createPreviewObserver(context) {
  const {
    observeDocumentTypeFromId,
    observePaths: observePaths2
  } = context;
  return function observeForPreview(value, type, options = {}) {
    const {
      viewOptions = {},
      apiConfig,
      perspective
    } = options;
    if (isCrossDatasetReferenceSchemaType(type)) {
      if (!isCrossDatasetReference(value))
        return of({
          snapshot: void 0
        });
      const refApiConfig = {
        projectId: value._projectId,
        dataset: value._dataset
      };
      return observeDocumentTypeFromId(value._ref, refApiConfig, perspective).pipe(switchMap((typeName) => {
        if (typeName) {
          const refType = type.to.find((toType) => toType.type === typeName);
          if (refType)
            return observeForPreview(value, refType, {
              apiConfig: refApiConfig,
              viewOptions,
              perspective
            });
        }
        return of({
          snapshot: void 0
        });
      }));
    }
    if (isReferenceSchemaType(type))
      return isReference(value) ? observeDocumentTypeFromId(value._ref).pipe(switchMap((typeName) => {
        if (typeName) {
          const refType = type.to.find((toType) => toType.name === typeName);
          if (refType)
            return observeForPreview(value, refType, {
              perspective
            });
        }
        return of({
          snapshot: void 0
        });
      })) : of({
        snapshot: void 0
      });
    const paths = getPreviewPaths(type.preview);
    return paths ? observePaths2(value, paths, apiConfig, perspective).pipe(map((snapshot2) => ({
      type,
      snapshot: snapshot2 ? prepareForPreview(snapshot2, type, viewOptions) : null
    }))) : of({
      type,
      snapshot: value && isRecord(value) ? invokePrepare(type, value, viewOptions).returnValue : null
    });
  };
}
function createObservePathsDocumentPair(options) {
  const {
    observeDocumentPairAvailability,
    observePaths: observePaths2
  } = options, ALWAYS_INCLUDED_SNAPSHOT_PATHS = [["_updatedAt"], ["_createdAt"], ["_type"]];
  return function(id2, paths, {
    version: version2
  } = {}) {
    const {
      draftId,
      publishedId,
      versionId
    } = getIdPair(id2, {
      version: version2
    });
    return observeDocumentPairAvailability(draftId, {
      version: version2
    }).pipe(switchMap((availability) => {
      if (!availability.draft.available && !availability.published.available && !availability.version?.available)
        return of({
          id: publishedId,
          type: null,
          draft: {
            availability: availability.draft,
            snapshot: void 0
          },
          published: {
            availability: availability.published,
            snapshot: void 0
          },
          ...availability.version ? {
            version: {
              availability: availability.version,
              snapshot: void 0
            }
          } : {}
        });
      const snapshotPaths = [...paths, ...ALWAYS_INCLUDED_SNAPSHOT_PATHS];
      return combineLatest([observePaths2({
        _type: "reference",
        _ref: draftId
      }, snapshotPaths), observePaths2({
        _type: "reference",
        _ref: publishedId
      }, snapshotPaths), ...version2 ? [observePaths2({
        _type: "reference",
        _ref: versionId
      }, snapshotPaths)] : []]).pipe(map(([draftSnapshot, publishedSnapshot, versionSnapshot]) => {
        const type = isRecord$4(versionSnapshot) && "_type" in versionSnapshot && versionSnapshot._type || isRecord$4(draftSnapshot) && "_type" in draftSnapshot && draftSnapshot._type || isRecord$4(publishedSnapshot) && "_type" in publishedSnapshot && publishedSnapshot._type || null;
        return {
          id: publishedId,
          type: typeof type == "string" ? type : null,
          draft: {
            availability: availability.draft,
            snapshot: draftSnapshot
          },
          published: {
            availability: availability.published,
            snapshot: publishedSnapshot
          },
          ...availability.version ? {
            version: {
              availability: availability.version,
              snapshot: versionSnapshot
            }
          } : {}
        };
      }));
    }));
  };
}
function createDocumentIdSetObserver(client) {
  return function(queryFilter, params, options = {}) {
    const {
      insert: insertOption = "sorted",
      apiVersion
    } = options, query = `*[${queryFilter}]._id`;
    function fetchFilter() {
      return versionedClient(client, apiVersion).observable.fetch(query, params, {
        tag: "preview.observe-document-set.fetch"
      }).pipe(tap((result) => {
        if (!Array.isArray(result))
          throw new Error(`Expected query to return array of documents, but got ${typeof result}`);
      }));
    }
    return versionedClient(client, apiVersion).observable.listen(`*[${queryFilter}]`, params, {
      visibility: "transaction",
      events: ["welcome", "mutation", "reconnect"],
      includeResult: !1,
      includeMutations: !1,
      includeAllVersions: !0,
      tag: "preview.observe-document-set.listen"
    }).pipe(mergeMap((event) => event.type === "welcome" ? fetchFilter().pipe(map((result) => ({
      type: "fetch",
      result
    }))) : of(event)), scan((state, event) => {
      if (event.type === "reconnect")
        return {
          documentIds: state?.documentIds || [],
          ...state,
          status: "reconnecting"
        };
      if (event.type === "fetch")
        return {
          ...state,
          status: "connected",
          documentIds: event.result
        };
      if (event.type === "mutation") {
        if (event.transition === "update")
          return state;
        if (event.transition === "appear")
          return {
            status: "connected",
            documentIds: insert(state?.documentIds || [], event.documentId, insertOption)
          };
        if (event.transition === "disappear")
          return {
            status: "connected",
            documentIds: state?.documentIds ? state.documentIds.filter((id2) => id2 !== event.documentId) : []
          };
      }
      return state;
    }, void 0), distinctUntilChanged(), filter((state) => state !== void 0));
  };
}
function insert(array, element, strategy) {
  let index;
  return strategy === "prepend" ? index = 0 : strategy === "append" ? index = array.length : index = sortedIndex(array, element), array.toSpliced(index, 0, element);
}
function hasEqualFields(fields) {
  return (object, otherObject) => object === otherObject ? !0 : !object || !otherObject || typeof object != "object" || typeof otherObject != "object" ? !1 : fields.every((field) => object[field] === otherObject[field]);
}
const id = (value) => value;
function isUniqueBy(array, itemSelector = id) {
  let prevItem, currItem;
  for (let i = 0; i < array.length; i++) {
    if (i === 0) {
      prevItem = itemSelector(array[i]);
      continue;
    }
    if (currItem = itemSelector(array[i]), prevItem !== currItem)
      return !1;
    prevItem = currItem;
  }
  return !0;
}
function combineSelections(selections) {
  return values(selections.reduce((output, [id2, fields], index) => {
    const key = sortBy(fields.join(","), identity$2).join(".");
    output[key] || (output[key] = {
      fields,
      ids: [],
      map: []
    });
    const idx = output[key].ids.length;
    return output[key].ids[idx] = id2, output[key].map[idx] = index, output;
  }, {}));
}
function stringifyId(id2) {
  return JSON.stringify(id2);
}
const maybeEscape = (fieldName) => fieldNeedsEscape(fieldName) ? `"${fieldName}": @${escapeField(fieldName)}` : fieldName;
function toSubQuery({
  ids,
  fields
}) {
  const allFields = [...INCLUDE_FIELDS_QUERY, ...fields];
  return `*[_id in [${ids.map(stringifyId).join(",")}]][0...${ids.length}]{${allFields.map(maybeEscape).join(",")}}`;
}
function toQuery(combinedSelections) {
  return `[${combinedSelections.map(toSubQuery).join(",")}][0...${combinedSelections.length}]`;
}
function reassemble(queryResult, combinedSelections) {
  return queryResult.reduce((reprojected, subResult, index) => (combinedSelections[index].map.forEach((resultIdx, i) => {
    const id2 = combinedSelections[index].ids[i], found = subResult.find((doc) => doc._id === id2);
    reprojected[resultIdx] = found || null;
  }), reprojected), []);
}
function chunkCombinedSelections(combinedSelections) {
  const chunks = [];
  for (const selection of combinedSelections) {
    let chunk = [], chunkMap = [], chunkSize = 0;
    for (let i = 0; i < selection.ids.length; i++) {
      const id2 = selection.ids[i], idSize = id2.length + 3;
      chunkSize + idSize >= MAX_DOCUMENT_ID_CHUNK_SIZE && chunk.length > 0 && (chunks.push([{
        ids: chunk,
        fields: selection.fields,
        map: chunkMap
      }]), chunk = [], chunkMap = [], chunkSize = 0), chunk.push(id2), chunkMap.push(selection.map[i]), chunkSize += idSize;
    }
    chunk.length > 0 && chunks.push([{
      ids: chunk,
      fields: selection.fields,
      map: chunkMap
    }]);
  }
  return chunks;
}
function createObserveFields(options) {
  const {
    client: currentDatasetClient,
    invalidationChannel
  } = options;
  function fetchAllDocumentPathsWith(client, perspective) {
    return function(selections) {
      const combinedSelections = combineSelections(selections), useReleaseVersion = perspective && perspective.length > 0 || combinedSelections.some((selection) => selection.ids.some(isVersionId)), apiClient = versionedClient(client, useReleaseVersion ? RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion : void 0), selectionChunks = chunkCombinedSelections(combinedSelections), fetchChunk = (chunk) => apiClient.observable.fetch(toQuery(chunk), {}, {
        tag: "preview.document-paths",
        perspective
      }).pipe(retry({
        delay: (_, attempt) => timer(Math.min(3e4, attempt * 1e3))
      }), map((result) => reassemble(result, chunk)));
      if (selectionChunks.length === 0)
        return of([]);
      if (selectionChunks.length === 1)
        return fetchChunk(selectionChunks[0]);
      const totalSelections = selections.length;
      return from(selectionChunks).pipe(mergeMap(fetchChunk, 10), reduce$2((merged, chunkResults) => (chunkResults.forEach((result, idx) => {
        result != null && (merged[idx] = result);
      }), merged), new Array(totalSelections).fill(null)));
    };
  }
  const batchFetchersCache = /* @__PURE__ */ new Map();
  function getBatchFetchersForPerspective(perspective) {
    const key = perspective?.join("-") || "raw";
    if (batchFetchersCache.has(key))
      return batchFetchersCache.get(key);
    const batchFetchers = {
      fast: debounceCollect(fetchAllDocumentPathsWith(currentDatasetClient, perspective), 100),
      slow: debounceCollect(fetchAllDocumentPathsWith(currentDatasetClient, perspective), 1e3)
    };
    return batchFetchersCache.set(key, batchFetchers), batchFetchers;
  }
  function currentDatasetListenFields(documentId, fields, perspective) {
    const {
      fast: fetchDocumentPathsFast,
      slow: fetchDocumentPathsSlow
    } = getBatchFetchersForPerspective(perspective), hasPerspective = perspective && perspective.length > 0, fetchId = hasPerspective ? getPublishedId(documentId) : documentId;
    return invalidationChannel.pipe(filter((event) => event.type === "connected" ? !0 : hasPerspective ? idMatchesPerspective(perspective, documentId) : event.documentId === documentId), switchMap((event) => event.type === "connected" || event.visibility === "query" ? fetchDocumentPathsFast(fetchId, fields).pipe(mergeMap((result) => concat(of(result), result === null ? (
      // just been created and is not yet indexed. We therefore need to wait a bit
      // and then re-fetch.
      fetchDocumentPathsSlow(fetchId, fields)
    ) : []))) : fetchDocumentPathsSlow(fetchId, fields)));
  }
  const CACHE2 = {}, getBatchFetcherForDataset = memoize$1(function(apiConfig) {
    const client = currentDatasetClient.withConfig(apiConfig), fetchAll = fetchAllDocumentPathsWith(client, ["drafts"]);
    return debounceCollect(fetchAll, 10);
  }, (apiConfig) => apiConfig.dataset + apiConfig.projectId), CROSS_DATASET_PREVIEW_POLL_INTERVAL = 1e4, visiblePoll$ = fromEvent(document, "visibilitychange").pipe(startWith(0), map(() => document.visibilityState === "visible"), switchMap((visible) => visible ? timer(0, CROSS_DATASET_PREVIEW_POLL_INTERVAL) : EMPTY$5), share());
  function crossDatasetListenFields(id2, fields, apiConfig) {
    return visiblePoll$.pipe(startWith(0)).pipe(switchMap(() => getBatchFetcherForDataset(apiConfig)(id2, fields)));
  }
  function createCachedFieldObserver(id2, fields, apiConfig, perspective) {
    let latest;
    const changes$ = merge(defer(() => latest === void 0 ? EMPTY$5 : of(latest)), apiConfig ? crossDatasetListenFields(id2, fields, apiConfig) : currentDatasetListenFields(id2, fields, perspective)).pipe(tap((v) => latest = v), shareReplay({
      refCount: !0,
      bufferSize: 1
    }));
    return {
      id: id2,
      fields,
      changes$
    };
  }
  function cachedObserveFields(id2, fields, apiConfig, perspective) {
    const cacheKey = apiConfig ? `${apiConfig.projectId}:${apiConfig.dataset}:${id2}` : `$current$-${id2}-${perspective?.join("-") || "raw"}`;
    cacheKey in CACHE2 || (CACHE2[cacheKey] = []);
    const existingObservers = CACHE2[cacheKey];
    difference(fields, flatten$1(existingObservers.map((cachedFieldObserver) => cachedFieldObserver.fields))).length > 0 && existingObservers.push(createCachedFieldObserver(id2, fields, apiConfig, perspective));
    const cachedFieldObservers = existingObservers.filter((observer) => observer.fields.some((fieldName) => fields.includes(fieldName))).map((cached) => cached.changes$);
    return combineLatest(cachedFieldObservers).pipe(
      // in the event that a document gets deleted, the cached values will be updated to store `undefined`
      // if this happens, we should not pick any fields from it, but rather just return null
      map((snapshots) => snapshots.filter(Boolean)),
      // make sure all snapshots agree on same revision
      filter((snapshots) => isUniqueBy(snapshots, (snapshot2) => snapshot2._rev)),
      // pass on value with the requested fields (or null if value is deleted)
      map((snapshots) => snapshots.length === 0 ? null : pickFrom(snapshots, fields)),
      // emit values only if changed
      distinctUntilChanged(hasEqualFields(fields))
    );
  }
  return cachedObserveFields;
  function pickFrom(objects, fields) {
    return [...INCLUDE_FIELDS, ...fields].reduce((result, fieldName) => {
      const value = getFirstFieldValue(objects, fieldName);
      return value !== void 0 && (result[fieldName] = value), result;
    }, {});
  }
  function getFirstFieldValue(objects, fieldName) {
    let value;
    return objects.some((object) => fieldName in object ? (value = object[fieldName], !0) : !1), value;
  }
}
function createDocumentPreviewStore({
  client
}) {
  const versionedClient2 = client.withConfig({
    apiVersion: "2025-02-19"
  }), globalListener = createGlobalListener(versionedClient2).pipe(filter((event) => (
    // ignore reconnect events for now until we've verified that downstream consumers can handle them
    event.type === "mutation" || event.type === "welcome"
  ))), invalidationChannel = globalListener.pipe(map((event) => event.type === "welcome" ? {
    type: "connected"
  } : event)), observeDocument = createObserveDocument({
    client,
    mutationChannel: globalListener
  }), observeFields = createObserveFields({
    client: versionedClient2,
    invalidationChannel
  }), observePaths2 = createPathObserver({
    observeFields
  });
  function observeDocumentTypeFromId(id2, apiConfig, perspective) {
    return observePaths2({
      _type: "reference",
      _ref: id2
    }, ["_type"], apiConfig, perspective).pipe(map((res) => isRecord$4(res) && typeof res._type == "string" ? res._type : void 0), distinctUntilChanged());
  }
  const observeDocumentIdSet = createDocumentIdSetObserver(versionedClient2), observeForPreview = createPreviewObserver({
    observeDocumentTypeFromId,
    observePaths: observePaths2
  }), observeDocumentStackAvailability = createDocumentStackAvailabilityObserver(versionedClient2, observePaths2), observeDocumentPairAvailability = createPreviewAvailabilityObserver(versionedClient2, observePaths2), observePathsDocumentPair = createObservePathsDocumentPair({
    observeDocumentPairAvailability,
    observePaths: observePaths2
  });
  return {
    observePaths: observePaths2,
    observeForPreview,
    observeDocumentTypeFromId,
    unstable_observeDocumentIdSet: observeDocumentIdSet,
    unstable_observeDocument: observeDocument,
    unstable_observeDocuments: (ids) => combineLatest(ids.map((id2) => observeDocument(id2))),
    unstable_observeDocumentPairAvailability: observeDocumentPairAvailability,
    unstable_observeDocumentStackAvailability: observeDocumentStackAvailability,
    unstable_observePathsDocumentPair: observePathsDocumentPair
  };
}
const INITIAL_STATE$6 = {
  loading: !0,
  document: null
};
function useUnstableObserveDocument(documentId, apiConfig) {
  const $ = c(4), documentPreviewStore = useDocumentPreviewStore();
  let t0;
  return $[0] !== apiConfig || $[1] !== documentId || $[2] !== documentPreviewStore ? (t0 = documentPreviewStore.unstable_observeDocument(documentId, apiConfig).pipe(map(_temp$2j)), $[0] = apiConfig, $[1] = documentId, $[2] = documentPreviewStore, $[3] = t0) : t0 = $[3], useObservable(t0, INITIAL_STATE$6);
}
function _temp$2j(document2) {
  return {
    loading: !1,
    document: document2
  };
}
const unstable_useObserveDocument = (args) => useUnstableObserveDocument(...args);
function getPreviewStateObservable$1(documentPreviewStore, schemaType, documentId, perspective, viewOptions) {
  const perspectiveSnapshot = documentPreviewStore.observeForPreview({
    _id: getPublishedId(documentId)
  }, schemaType, {
    perspective,
    viewOptions
  }), versionOrDraftId = isVersionId(documentId) ? getVersionFromId(documentId) : "drafts", preparedVersionSnapshot = versionOrDraftId ? documentPreviewStore.observeForPreview({
    _id: getPublishedId(documentId)
  }, schemaType, {
    perspective: [versionOrDraftId],
    viewOptions
  }) : of(null);
  return combineLatest([perspectiveSnapshot, preparedVersionSnapshot]).pipe(map(([main, version2]) => ({
    isLoading: !1,
    snapshot: main?.snapshot || null,
    original: version2?.snapshot || null
  })), startWith({
    isLoading: !0,
    snapshot: null,
    original: null
  }));
}
function getMissingDocumentFallback(document2) {
  return {
    title: /* @__PURE__ */ jsx("em", { children: document2.title ? String(document2.title) : "Missing document" }),
    subtitle: /* @__PURE__ */ jsx("em", { children: document2.title ? `Missing document ID: ${document2._id}` : `Document ID: ${document2._id}` }),
    media: () => /* @__PURE__ */ jsx(WarningOutlineIcon, {})
  };
}
const EMPTY$1 = {};
function getPreviewValueWithFallback({
  snapshot: snapshot2,
  original,
  fallback: fallback2
}) {
  return snapshot2 || original || getMissingDocumentFallback(fallback2 || EMPTY$1);
}
function useReleasesIds(releases2) {
  const $ = c(4);
  let t0;
  $[0] !== releases2 ? (t0 = releases2.map(_temp$2i), $[0] = releases2, $[1] = t0) : t0 = $[1];
  const releasesIds = t0;
  let t1;
  return $[2] !== releasesIds ? (t1 = {
    releasesIds
  }, $[2] = releasesIds, $[3] = t1) : t1 = $[3], t1;
}
function _temp$2i(release) {
  return getReleaseIdFromReleaseDocumentId(release._id);
}
function exists(value) {
  return value?._rev;
}
const DOCUMENT_STUB_PATHS = ["_id", "_type", "_rev", "_createdAt", "_updatedAt"], NO_VERSIONS = {};
function useDocumentVersionInfo(documentId) {
  const $ = c(13), documentPreviewStore = useDocumentPreviewStore(), releaseIds = useReleasesIds(useActiveReleases().data).releasesIds;
  let t0;
  $[0] !== documentId ? (t0 = getDraftId(documentId), $[0] = documentId, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== documentId ? (t1 = getPublishedId(documentId), $[2] = documentId, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t0 || $[5] !== t1 ? (t2 = [t0, t1], $[4] = t0, $[5] = t1, $[6] = t2) : t2 = $[6];
  const [draftId, publishedId] = t2;
  let t3;
  if ($[7] !== documentPreviewStore || $[8] !== draftId || $[9] !== publishedId || $[10] !== releaseIds) {
    const releaseVersions = releaseIds.length > 0 ? combineLatest(Object.fromEntries(releaseIds.map((releaseId) => [releaseId, documentPreviewStore.observePaths({
      _id: getVersionId(publishedId, releaseId)
    }, DOCUMENT_STUB_PATHS).pipe(map(_temp$2h))]))) : of(NO_VERSIONS);
    t3 = combineLatest({
      isLoading: of(!1),
      draft: documentPreviewStore.observePaths({
        _id: draftId
      }, DOCUMENT_STUB_PATHS).pipe(map(_temp2$W)),
      published: documentPreviewStore.observePaths({
        _id: publishedId
      }, DOCUMENT_STUB_PATHS).pipe(map(_temp3$t)),
      versions: releaseVersions
    }), $[7] = documentPreviewStore, $[8] = draftId, $[9] = publishedId, $[10] = releaseIds, $[11] = t3;
  } else
    t3 = $[11];
  const observable = t3;
  let t4;
  return $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    isLoading: !0,
    versions: NO_VERSIONS,
    draft: void 0,
    published: void 0
  }, $[12] = t4) : t4 = $[12], useObservable(observable, t4);
}
function _temp3$t(value_1) {
  return exists(value_1) ? value_1 : void 0;
}
function _temp2$W(value_0) {
  return exists(value_0) ? value_0 : void 0;
}
function _temp$2h(value) {
  return exists(value) ? value : void 0;
}
function useCopyToDrafts(options) {
  const $ = c(16), {
    documentId,
    fromRelease,
    onNavigate
  } = options, client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), toast = useToast(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== documentId ? (t0 = getPublishedId(documentId), $[0] = documentId, $[1] = t0) : t0 = $[1];
  const publishedId = t0;
  let t1;
  $[2] !== documentId || $[3] !== fromRelease ? (t1 = fromRelease === "published" ? documentId : getVersionId(documentId, fromRelease), $[2] = documentId, $[3] = fromRelease, $[4] = t1) : t1 = $[4];
  const sourceDocumentId = t1, hasDraftVersion = !!useDocumentVersionInfo(publishedId).draft;
  let t2;
  $[5] !== client || $[6] !== hasDraftVersion || $[7] !== onNavigate || $[8] !== publishedId || $[9] !== sourceDocumentId || $[10] !== t || $[11] !== toast ? (t2 = async () => {
    const run = async () => {
      const sourceDoc = await client.getDocument(sourceDocumentId);
      if (!sourceDoc)
        throw new Error(`Source document ${sourceDocumentId} not found`);
      hasDraftVersion && await client.discardVersion({
        publishedId
      }, !1), await client.createVersion({
        baseId: sourceDocumentId,
        ifBaseRevisionId: sourceDoc._rev,
        publishedId
      }), onNavigate();
    };
    try {
      await run();
    } catch (t32) {
      const err = t32;
      toast.push({
        closable: !0,
        status: "error",
        title: t("release.action.create-version.failure"),
        description: err.message
      });
    }
  }, $[5] = client, $[6] = hasDraftVersion, $[7] = onNavigate, $[8] = publishedId, $[9] = sourceDocumentId, $[10] = t, $[11] = toast, $[12] = t2) : t2 = $[12];
  const handleCopyToDrafts = t2;
  let t3;
  return $[13] !== handleCopyToDrafts || $[14] !== hasDraftVersion ? (t3 = {
    handleCopyToDrafts,
    hasDraftVersion
  }, $[13] = handleCopyToDrafts, $[14] = hasDraftVersion, $[15] = t3) : t3 = $[15], t3;
}
function useDataset() {
  return useSource().dataset;
}
function useProjectId() {
  return useSource().projectId;
}
const INITIAL_VALUE$3 = {
  data: [],
  error: null,
  loading: !0
}, observableCache = /* @__PURE__ */ new Map(), swr = createSWR({
  maxSize: 100
});
function useDocumentVersions(props2) {
  const $ = c(10), {
    documentId
  } = props2;
  let t0;
  $[0] !== documentId ? (t0 = getPublishedId(documentId), $[0] = documentId, $[1] = t0) : t0 = $[1];
  const publishedId = t0, dataset = useDataset(), projectId = useProjectId(), documentPreviewStore = useDocumentPreviewStore(), [results, setResults] = useState(INITIAL_VALUE$3);
  let t1;
  $[2] !== dataset || $[3] !== documentPreviewStore || $[4] !== projectId || $[5] !== publishedId ? (t1 = getOrCreateDocumentVersionsObservable({
    documentPreviewStore,
    publishedId,
    projectId,
    dataset
  }), $[2] = dataset, $[3] = documentPreviewStore, $[4] = projectId, $[5] = publishedId, $[6] = t1) : t1 = $[6];
  const observable = t1;
  let t2, t3;
  return $[7] !== observable ? (t2 = () => {
    const subscription = observable.subscribe((result) => {
      setResults(result);
    });
    return () => subscription.unsubscribe();
  }, t3 = [observable], $[7] = observable, $[8] = t2, $[9] = t3) : (t2 = $[8], t3 = $[9]), useEffect(t2, t3), results;
}
function getOrCreateDocumentVersionsObservable(options) {
  const {
    documentPreviewStore,
    projectId,
    dataset,
    publishedId,
    params = void 0
  } = options, cacheKey = `${projectId}-${dataset}-${publishedId}`, cachedObservable = observableCache.get(cacheKey);
  if (cachedObservable)
    return cachedObservable;
  const newObservable = documentPreviewStore.unstable_observeDocumentIdSet(`sanity::versionOf("${publishedId}")`, params, {
    apiVersion: RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion
  }).pipe(swr(cacheKey), map$1(({
    value
  }) => ({
    data: value.documentIds,
    error: null,
    loading: !1
  })), catchError$1((error) => of({
    error,
    data: [],
    loading: !1
  })), finalize(() => {
    observableCache.delete(cacheKey);
  }), shareReplay$1({
    refCount: !0,
    bufferSize: 1
  }));
  return observableCache.set(cacheKey, newObservable), newObservable;
}
const orderedReleaseTypes$1 = ["asap", "scheduled", "undecided"], useDocumentVersionTypeSortedList = (t0) => {
  const $ = c(9), {
    documentId
  } = t0, {
    data: releases2
  } = useActiveReleases();
  let t1;
  $[0] !== documentId ? (t1 = {
    documentId
  }, $[0] = documentId, $[1] = t1) : t1 = $[1];
  const {
    data: documentVersions
  } = useDocumentVersions(t1);
  let t2;
  if ($[2] !== documentVersions || $[3] !== releases2) {
    let t32;
    $[5] !== documentVersions ? (t32 = (t4) => {
      const {
        _id
      } = t4;
      return documentVersions.some((id2) => getVersionFromId(id2) === getReleaseIdFromReleaseDocumentId(_id));
    }, $[5] = documentVersions, $[6] = t32) : t32 = $[6], t2 = releases2.filter(t32).sort(_temp$2g), $[2] = documentVersions, $[3] = releases2, $[4] = t2;
  } else
    t2 = $[4];
  const sortedDocumentList = t2;
  let t3;
  return $[7] !== sortedDocumentList ? (t3 = {
    sortedDocumentList
  }, $[7] = sortedDocumentList, $[8] = t3) : t3 = $[8], t3;
};
function _temp$2g(releasesList, compareReleasesList) {
  if (releasesList.metadata.releaseType === "scheduled" && compareReleasesList.metadata.releaseType === "scheduled") {
    const aPublishAt = releasesList.publishAt || releasesList.metadata.intendedPublishAt;
    if (!aPublishAt)
      return -1;
    const bPublishAt = compareReleasesList.publishAt || compareReleasesList.metadata.intendedPublishAt;
    return bPublishAt ? new Date(aPublishAt).getTime() - new Date(bPublishAt).getTime() : 1;
  }
  return orderedReleaseTypes$1.indexOf(releasesList.metadata.releaseType) - orderedReleaseTypes$1.indexOf(compareReleasesList.metadata.releaseType);
}
const useIsReleaseActive = () => {
  const $ = c(2), {
    selectedPerspective
  } = usePerspective();
  let t0;
  return $[0] !== selectedPerspective ? (t0 = !isPublishedPerspective(selectedPerspective) && (isDraftPerspective(selectedPerspective) || isReleaseDocument(selectedPerspective) && selectedPerspective.state === "active"), $[0] = selectedPerspective, $[1] = t0) : t0 = $[1], t0;
}, useOnlyHasVersions = (t0) => {
  const $ = c(4), {
    documentId
  } = t0;
  let t1;
  $[0] !== documentId ? (t1 = {
    documentId
  }, $[0] = documentId, $[1] = t1) : t1 = $[1];
  const {
    data: documentVersions
  } = useDocumentVersions(t1);
  let t2;
  return $[2] !== documentVersions ? (t2 = documentVersions && documentVersions.length > 0 && !documentVersions.some(_temp$2f), $[2] = documentVersions, $[3] = t2) : t2 = $[3], t2;
};
function _temp$2f(version2) {
  return !isVersionId(version2);
}
function useGetDefaultPerspective() {
  return useWorkspace().document.drafts.enabled ? LATEST : PUBLISHED$1;
}
function useSetPerspective() {
  const $ = c(3), router = useRouter(), defaultPerspective = useGetDefaultPerspective();
  let t0;
  return $[0] !== defaultPerspective || $[1] !== router ? (t0 = (releaseId) => {
    const newPerspective = !releaseId || releaseId === defaultPerspective ? "" : releaseId;
    router.navigate({
      stickyParams: {
        excludedPerspectives: null,
        perspective: newPerspective
      }
    });
  }, $[0] = defaultPerspective, $[1] = router, $[2] = t0) : t0 = $[2], t0;
}
function useReleasesUpsell() {
  return useContext(ReleasesUpsellContext) || FALLBACK_CONTEXT_VALUE$2;
}
const FALLBACK_CONTEXT_VALUE$2 = {
  upsellDialogOpen: !1,
  mode: "default",
  onReleaseLimitReached: () => null,
  guardWithReleaseLimitUpsell: async () => {
  },
  handleOpenDialog: () => null,
  upsellData: null,
  telemetryLogs: {
    dialogSecondaryClicked: () => null,
    dialogPrimaryClicked: () => null,
    panelViewed: () => null,
    panelDismissed: () => null,
    panelPrimaryClicked: () => null,
    panelSecondaryClicked: () => null
  }
}, isErrorWithDetails = (error) => typeof error == "object" && error !== null && "details" in error && typeof error.details == "object", isReleaseLimitError = (error) => isErrorWithDetails(error) && error.details?.type === "releaseLimitExceededError";
function createReleaseOperationsStore(options) {
  const {
    client,
    onReleaseLimitReached
  } = options, handleReleaseLimitError = (action, opts) => action.catch((error) => {
    throw !opts?.dryRun && isReleaseLimitError(error) && onReleaseLimitReached(error.details.limit || 0), error;
  }), handleCreateRelease = (release, opts) => handleReleaseLimitError(client.releases.create({
    releaseId: getReleaseIdFromReleaseDocumentId(release._id),
    metadata: release.metadata
  }, opts), opts), handleUpdateRelease = async (release, opts) => {
    const releaseId = getReleaseIdFromReleaseDocumentId(release._id), unsetKeys = Object.entries(release).filter(([_, value]) => value === void 0).map(([key]) => `metadata.${key}`);
    return handleReleaseLimitError(client.releases.edit({
      releaseId,
      patch: {
        set: {
          metadata: release.metadata
        },
        unset: unsetKeys
      }
    }, opts), opts);
  }, handlePublishRelease = (releaseId, opts) => handleReleaseLimitError(client.releases.publish({
    releaseId: getReleaseIdFromReleaseDocumentId(releaseId)
  }, opts), opts);
  return {
    archive: (releaseId, opts) => client.releases.archive({
      releaseId: getReleaseIdFromReleaseDocumentId(releaseId)
    }, opts),
    unarchive: (releaseId, opts) => handleReleaseLimitError(client.releases.unarchive({
      releaseId: getReleaseIdFromReleaseDocumentId(releaseId)
    }, opts), opts),
    schedule: (releaseId, publishAt, opts) => handleReleaseLimitError(client.releases.schedule({
      releaseId: getReleaseIdFromReleaseDocumentId(releaseId),
      publishAt: publishAt.toISOString()
    }, opts), opts),
    unschedule: (releaseId, opts) => handleReleaseLimitError(client.releases.unschedule({
      releaseId: getReleaseIdFromReleaseDocumentId(releaseId)
    }, opts), opts),
    createRelease: handleCreateRelease,
    updateRelease: handleUpdateRelease,
    publishRelease: handlePublishRelease,
    deleteRelease: (releaseId, opts) => client.releases.delete({
      releaseId: getReleaseIdFromReleaseDocumentId(releaseId)
    }, opts),
    revertRelease: async (revertReleaseId, releaseDocuments, releaseMetadata, revertType) => {
      await handleCreateRelease({
        _id: revertReleaseId,
        metadata: {
          title: releaseMetadata.title,
          description: releaseMetadata.description,
          releaseType: "asap",
          cardinality: "many"
        }
      });
      const versionId = getReleaseIdFromReleaseDocumentId(revertReleaseId), newVersionDocumentActions = releaseDocuments.map((releaseDocument) => ({
        actionType: "sanity.action.document.version.create",
        document: {
          ...releaseDocument,
          _id: getVersionId(releaseDocument._id, versionId)
        },
        publishedId: getPublishedId(releaseDocument._id)
      }));
      await client.action(newVersionDocumentActions), revertType === "immediate" && await handlePublishRelease(revertReleaseId);
    },
    duplicateRelease: async (releaseDocumentId, releaseMetadata, releaseDocuments) => {
      if (await handleCreateRelease({
        _id: releaseDocumentId,
        metadata: releaseMetadata
      }), releaseDocuments) {
        const versionId = getReleaseIdFromReleaseDocumentId(releaseDocumentId), duplicateVersionDocumentActions = releaseDocuments.map((releaseDocument) => ({
          actionType: "sanity.action.document.version.create",
          document: {
            ...releaseDocument,
            _id: getVersionId(releaseDocument._id, versionId)
          },
          publishedId: getPublishedId(releaseDocument._id)
        }));
        await client.action(duplicateVersionDocumentActions);
      }
    },
    createVersion: async (releaseId, documentId, opts) => {
      const document2 = await client.getDocument(documentId);
      if (!document2)
        throw new Error(`Document with id ${documentId} not found`);
      return client.createVersion({
        baseId: documentId,
        ifBaseRevisionId: document2?._rev,
        publishedId: getPublishedId(documentId),
        releaseId
      }, opts);
    },
    discardVersion: (releaseId, documentId, opts) => client.discardVersion({
      releaseId,
      publishedId: getPublishedId(documentId)
    }, !1, opts),
    unpublishVersion: (documentId, opts) => {
      const releaseId = getVersionFromId(documentId);
      if (!releaseId)
        throw new Error(`Release ID not found for document ${documentId}`);
      return client.unpublishVersion({
        releaseId,
        publishedId: getPublishedId(documentId)
      }, opts);
    },
    revertUnpublishVersion: async (documentId, opts) => await client.action({
      actionType: "sanity.action.document.edit",
      draftId: documentId,
      publishedId: getPublishedId(documentId),
      patch: {
        unset: ["_system.delete"]
      }
    }, opts)
  };
}
function useReleaseOperations() {
  const $ = c(3), studioClient = useClient(RELEASES_STUDIO_CLIENT_OPTIONS), {
    onReleaseLimitReached
  } = useReleasesUpsell();
  let t0;
  return $[0] !== onReleaseLimitReached || $[1] !== studioClient ? (t0 = createReleaseOperationsStore({
    client: studioClient,
    onReleaseLimitReached
  }), $[0] = onReleaseLimitReached, $[1] = studioClient, $[2] = t0) : t0 = $[2], t0;
}
function useVersionOperations() {
  const $ = c(15), telemetry = useTelemetry(), {
    createVersion,
    discardVersion,
    unpublishVersion,
    revertUnpublishVersion
  } = useReleaseOperations(), setPerspective = useSetPerspective();
  let t0;
  $[0] !== createVersion || $[1] !== setPerspective || $[2] !== telemetry ? (t0 = async (releaseId, documentId) => {
    const origin = getDocumentVariantType(documentId);
    await createVersion(releaseId, documentId), setPerspective(releaseId), telemetry.log(AddedVersion, {
      documentOrigin: origin
    });
  }, $[0] = createVersion, $[1] = setPerspective, $[2] = telemetry, $[3] = t0) : t0 = $[3];
  const handleCreateVersion = t0;
  let t1;
  $[4] !== discardVersion ? (t1 = async (releaseId_0, documentId_0) => discardVersion(releaseId_0, documentId_0), $[4] = discardVersion, $[5] = t1) : t1 = $[5];
  const handleDiscardVersion = t1;
  let t2;
  $[6] !== unpublishVersion ? (t2 = async (documentId_1) => unpublishVersion(documentId_1), $[6] = unpublishVersion, $[7] = t2) : t2 = $[7];
  const handleUnpublishVersion = t2;
  let t3;
  $[8] !== revertUnpublishVersion ? (t3 = async (documentId_2) => revertUnpublishVersion(documentId_2), $[8] = revertUnpublishVersion, $[9] = t3) : t3 = $[9];
  const handleRevertUnpublishVersion = t3;
  let t4;
  return $[10] !== handleCreateVersion || $[11] !== handleDiscardVersion || $[12] !== handleRevertUnpublishVersion || $[13] !== handleUnpublishVersion ? (t4 = {
    createVersion: handleCreateVersion,
    discardVersion: handleDiscardVersion,
    unpublishVersion: handleUnpublishVersion,
    revertUnpublishVersion: handleRevertUnpublishVersion
  }, $[10] = handleCreateVersion, $[11] = handleDiscardVersion, $[12] = handleRevertUnpublishVersion, $[13] = handleUnpublishVersion, $[14] = t4) : t4 = $[14], t4;
}
const releasesLocaleNamespace = "releases", releasesUsEnglishLocaleBundle = {
  locale: "en-US",
  namespace: releasesLocaleNamespace,
  resources: () => import("./_chunks-es/resources2.js")
};
function DiscardVersionDialog(props2) {
  const $ = c(57), {
    onClose,
    documentId,
    documentType,
    fromPerspective,
    isGoingToUnpublish: isGoingToUnpublish2
  } = props2, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: coreT
  } = useTranslation();
  let t0;
  $[0] !== documentId ? (t0 = getPublishedId(documentId), $[0] = documentId, $[1] = t0) : t0 = $[1];
  const {
    discardChanges: discardChanges2
  } = useDocumentOperation(t0, documentType), {
    selectedPerspective
  } = usePerspective(), {
    discardVersion
  } = useVersionOperations(), schema2 = useSchema(), toast = useToast(), [isDiscarding, setIsDiscarding] = useState(!1), discardType = isDraftId(documentId) ? "draft" : "release", rawReleaseName = typeof fromPerspective == "string" ? fromPerspective : fromPerspective.metadata.title, t1 = documentId;
  let t2;
  $[2] !== t1 ? (t2 = getVersionNameFromId(t1), $[2] = t1, $[3] = t2) : t2 = $[3];
  const currentRelease = t2;
  let t3;
  $[4] !== coreT || $[5] !== rawReleaseName ? (t3 = rawReleaseName || coreT("release.placeholder-untitled-release"), $[4] = coreT, $[5] = rawReleaseName, $[6] = t3) : t3 = $[6];
  const releaseName = t3;
  let t4;
  $[7] !== documentType || $[8] !== schema2 ? (t4 = schema2.get(documentType), $[7] = documentType, $[8] = schema2, $[9] = t4) : t4 = $[9];
  const schemaType = t4;
  let t5;
  $[10] !== coreT || $[11] !== discardChanges2 || $[12] !== discardVersion || $[13] !== documentId || $[14] !== onClose || $[15] !== selectedPerspective || $[16] !== toast ? (t5 = async () => {
    if (setIsDiscarding(!0), isVersionId(documentId)) {
      const run = async () => {
        await discardVersion(getVersionFromId(documentId) || getReleaseIdFromReleaseDocumentId(selectedPerspective._id), documentId);
      };
      try {
        await run();
      } catch (t62) {
        const err = t62;
        toast.push({
          closable: !0,
          status: "error",
          title: coreT("release.action.discard-version.failure"),
          description: err.message
        });
      }
    } else
      discardChanges2.execute();
    setIsDiscarding(!1), onClose();
  }, $[10] = coreT, $[11] = discardChanges2, $[12] = discardVersion, $[13] = documentId, $[14] = onClose, $[15] = selectedPerspective, $[16] = toast, $[17] = t5) : t5 = $[17];
  const handleDiscardVersion = t5, t6 = `discard-version-dialog.header-${discardType}`;
  let t7;
  $[18] !== releaseName ? (t7 = {
    releaseTitle: releaseName
  }, $[18] = releaseName, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== t || $[21] !== t6 || $[22] !== t7 ? (t8 = /* @__PURE__ */ jsx(Translate, { t, i18nKey: t6, values: t7 }), $[20] = t, $[21] = t6, $[22] = t7, $[23] = t8) : t8 = $[23];
  let t9;
  $[24] !== isDiscarding || $[25] !== onClose ? (t9 = {
    disabled: isDiscarding,
    onClick: onClose
  }, $[24] = isDiscarding, $[25] = onClose, $[26] = t9) : t9 = $[26];
  const t10 = `discard-version-dialog.title-${discardType}`;
  let t11;
  $[27] !== t || $[28] !== t10 ? (t11 = t(t10), $[27] = t, $[28] = t10, $[29] = t11) : t11 = $[29];
  let t12;
  $[30] !== handleDiscardVersion || $[31] !== isDiscarding || $[32] !== t11 ? (t12 = {
    text: t11,
    onClick: handleDiscardVersion,
    disabled: isDiscarding
  }, $[30] = handleDiscardVersion, $[31] = isDiscarding, $[32] = t11, $[33] = t12) : t12 = $[33];
  let t13;
  $[34] !== t12 || $[35] !== t9 ? (t13 = {
    cancelButton: t9,
    confirmButton: t12
  }, $[34] = t12, $[35] = t9, $[36] = t13) : t13 = $[36];
  let t14;
  $[37] !== currentRelease || $[38] !== documentId || $[39] !== isGoingToUnpublish2 || $[40] !== schemaType ? (t14 = schemaType ? /* @__PURE__ */ jsx(Preview$1, { value: {
    _id: isGoingToUnpublish2 ? getPublishedId(documentId) : documentId
  }, schemaType, perspectiveStack: isGoingToUnpublish2 ? [] : [currentRelease] }) : /* @__PURE__ */ jsx(LoadingBlock, {}), $[37] = currentRelease, $[38] = documentId, $[39] = isGoingToUnpublish2, $[40] = schemaType, $[41] = t14) : t14 = $[41];
  let t15;
  $[42] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = {
    maxWidth: "400px"
  }, $[42] = t15) : t15 = $[42];
  const t16 = `discard-version-dialog.description-${discardType}`;
  let t17;
  $[43] !== releaseName ? (t17 = {
    releaseTitle: releaseName
  }, $[43] = releaseName, $[44] = t17) : t17 = $[44];
  let t18;
  $[45] !== t || $[46] !== t16 || $[47] !== t17 ? (t18 = /* @__PURE__ */ jsx(Box, { paddingX: 2, style: t15, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: t16, values: t17 }) }) }), $[45] = t, $[46] = t16, $[47] = t17, $[48] = t18) : t18 = $[48];
  let t19;
  $[49] !== t14 || $[50] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Stack, { space: 3, paddingX: 3, marginBottom: 2, children: [
    t14,
    t18
  ] }), $[49] = t14, $[50] = t18, $[51] = t19) : t19 = $[51];
  let t20;
  return $[52] !== onClose || $[53] !== t13 || $[54] !== t19 || $[55] !== t8 ? (t20 = /* @__PURE__ */ jsx(Dialog$1, { id: "discard-version-dialog", header: t8, onClose, width: 0, padding: !1, footer: t13, children: t19 }), $[52] = onClose, $[53] = t13, $[54] = t19, $[55] = t8, $[56] = t20) : t20 = $[56], t20;
}
const Z_OFFSET$1 = {
  toast: [100, 11e3]
}, SCHEDULED_PUBLISHING_TIME_ZONE_SCOPE$1 = {
  type: "scheduledPublishing"
}, CONTENT_RELEASES_TIME_ZONE_SCOPE = {
  type: "contentReleases"
}, RELEASE_FORM_STORAGE_KEY = "studio.release-form.recovery";
function useReleaseFormStorage() {
  const $ = c(1), getStoredReleaseData = _temp$2e, saveReleaseDataToStorage = _temp2$V, clearReleaseDataFromStorage = _temp3$s;
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    getStoredReleaseData,
    saveReleaseDataToStorage,
    clearReleaseDataFromStorage
  }, $[0] = t0) : t0 = $[0], t0;
}
function _temp3$s() {
  localStorage.removeItem(RELEASE_FORM_STORAGE_KEY);
}
function _temp2$V(data) {
  localStorage.setItem(RELEASE_FORM_STORAGE_KEY, JSON.stringify(data));
}
function _temp$2e() {
  const stored = localStorage.getItem(RELEASE_FORM_STORAGE_KEY);
  return stored ? JSON.parse(stored) : void 0;
}
function renderReleaseTypeIcon(releaseType, iconProps) {
  return releaseType === "asap" ? /* @__PURE__ */ jsx(BoltIcon, { ...iconProps }) : releaseType === "scheduled" ? /* @__PURE__ */ jsx(ClockIcon, { ...iconProps }) : /* @__PURE__ */ jsx(DotIcon, { ...iconProps });
}
const ReleaseAvatarIcon = (t0) => {
  const $ = c(10), {
    tone,
    release,
    releaseType
  } = t0;
  let t1;
  $[0] !== release || $[1] !== releaseType || $[2] !== tone ? (t1 = tone ?? (releaseType ? RELEASE_TYPES_TONES[releaseType]?.tone : release ? isDraftPerspective(release) ? "caution" : getReleaseTone(release) : "default"), $[0] = release, $[1] = releaseType, $[2] = tone, $[3] = t1) : t1 = $[3];
  const resolvedTone = t1, t2 = `release-avatar-${resolvedTone}`, t3 = `var(--card-badge-${resolvedTone}-icon-color)`;
  let t4, t5;
  if ($[4] !== release || $[5] !== releaseType || $[6] !== t2 || $[7] !== t3) {
    t5 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    bb0: {
      const iconProps = {
        "data-testid": t2,
        style: {
          "--card-icon-color": t3
        }
      };
      if (releaseType) {
        t5 = renderReleaseTypeIcon(releaseType, iconProps);
        break bb0;
      }
      if (isReleaseDocument(release)) {
        if (isPausedCardinalityOneRelease(release)) {
          t5 = /* @__PURE__ */ jsx(ClockIcon, { ...iconProps });
          break bb0;
        }
        t5 = renderReleaseTypeIcon(release.metadata.releaseType, iconProps);
        break bb0;
      }
      t4 = /* @__PURE__ */ jsx(DotIcon, { ...iconProps });
    }
    $[4] = release, $[5] = releaseType, $[6] = t2, $[7] = t3, $[8] = t4, $[9] = t5;
  } else
    t4 = $[8], t5 = $[9];
  return t5 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel") ? t5 : t4;
};
function ReleaseAvatar(t0) {
  const $ = c(13);
  let iconProps, t1, t2;
  $[0] !== t0 ? ({
    fontSize: t1,
    padding: t2,
    ...iconProps
  } = t0, $[0] = t0, $[1] = iconProps, $[2] = t1, $[3] = t2) : (iconProps = $[1], t1 = $[2], t2 = $[3]);
  const fontSize = t1 === void 0 ? 1 : t1, padding = t2 === void 0 ? 3 : t2;
  let t3;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    borderRadius: 3
  }, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== iconProps ? (t4 = /* @__PURE__ */ jsx(ReleaseAvatarIcon, { ...iconProps }), $[5] = iconProps, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== fontSize || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: fontSize, children: t4 }), $[7] = fontSize, $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  return $[10] !== padding || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { flex: "none", padding, style: t3, children: t5 }), $[10] = padding, $[11] = t5, $[12] = t6) : t6 = $[12], t6;
}
const inputDateFormat = "PP HH:mm", ScheduleDatePicker = (t0) => {
  const $ = c(47), {
    value,
    onChange,
    timeZoneScope
  } = t0, {
    t
  } = useTranslation(), {
    timeZone,
    utcToCurrentZoneDate,
    zoneDateToUtc
  } = useTimeZone(timeZoneScope), {
    dialogTimeZoneShow,
    DialogTimeZone: DialogTimeZone2,
    dialogProps
  } = useDialogTimeZone(timeZoneScope);
  let T0, T1, t1, t2, t3, t4, t5, t6, t7, t8, t9;
  if ($[0] !== onChange || $[1] !== t || $[2] !== utcToCurrentZoneDate || $[3] !== value || $[4] !== zoneDateToUtc) {
    const timeZoneAdjustedValue = value ? utcToCurrentZoneDate(value) : void 0;
    let t102;
    $[16] !== onChange || $[17] !== zoneDateToUtc ? (t102 = (date) => {
      date && onChange(zoneDateToUtc(date));
    }, $[16] = onChange, $[17] = zoneDateToUtc, $[18] = t102) : t102 = $[18];
    const handlePublishAtCalendarChange = t102;
    let t112;
    $[19] !== onChange || $[20] !== zoneDateToUtc ? (t112 = (event) => {
      const date_0 = event.currentTarget.value, parsedDate = zoneDateToUtc(parse(date_0, inputDateFormat, /* @__PURE__ */ new Date()));
      isValid(parsedDate) && onChange(parsedDate);
    }, $[19] = onChange, $[20] = zoneDateToUtc, $[21] = t112) : t112 = $[21];
    const handlePublishAtInputChange = t112;
    let t122;
    $[22] !== t ? (t122 = getCalendarLabels(t), $[22] = t, $[23] = t122) : t122 = $[23];
    const calendarLabels = t122;
    T1 = Flex, t8 = 1, t9 = "space-between", T0 = DateTimeInput$3, t1 = !0, t2 = MONTH_PICKER_VARIANT.carousel, t3 = handlePublishAtCalendarChange, t4 = handlePublishAtInputChange, t5 = calendarLabels, t6 = timeZoneAdjustedValue, t7 = timeZoneAdjustedValue ? format(timeZoneAdjustedValue, inputDateFormat) : "", $[0] = onChange, $[1] = t, $[2] = utcToCurrentZoneDate, $[3] = value, $[4] = zoneDateToUtc, $[5] = T0, $[6] = T1, $[7] = t1, $[8] = t2, $[9] = t3, $[10] = t4, $[11] = t5, $[12] = t6, $[13] = t7, $[14] = t8, $[15] = t9;
  } else
    T0 = $[5], T1 = $[6], t1 = $[7], t2 = $[8], t3 = $[9], t4 = $[10], t5 = $[11], t6 = $[12], t7 = $[13], t8 = $[14], t9 = $[15];
  let t10;
  $[24] !== T0 || $[25] !== t1 || $[26] !== t2 || $[27] !== t3 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7 || $[32] !== timeZoneScope ? (t10 = /* @__PURE__ */ jsx(T0, { selectTime: t1, monthPickerVariant: t2, onChange: t3, onInputChange: t4, calendarLabels: t5, value: t6, inputValue: t7, constrainSize: !1, padding: 0, isPastDisabled: !0, timeZoneScope }), $[24] = T0, $[25] = t1, $[26] = t2, $[27] = t3, $[28] = t4, $[29] = t5, $[30] = t6, $[31] = t7, $[32] = timeZoneScope, $[33] = t10) : t10 = $[33];
  const t11 = `${timeZone.abbreviation}`;
  let t12;
  $[34] !== dialogTimeZoneShow || $[35] !== t11 ? (t12 = /* @__PURE__ */ jsx(Button, { icon: EarthGlobeIcon, mode: "bleed", size: "default", text: t11, onClick: dialogTimeZoneShow }), $[34] = dialogTimeZoneShow, $[35] = t11, $[36] = t12) : t12 = $[36];
  let t13;
  $[37] !== DialogTimeZone2 || $[38] !== dialogProps ? (t13 = DialogTimeZone2 && /* @__PURE__ */ jsx(DialogTimeZone2, { ...dialogProps }), $[37] = DialogTimeZone2, $[38] = dialogProps, $[39] = t13) : t13 = $[39];
  let t14;
  return $[40] !== T1 || $[41] !== t10 || $[42] !== t12 || $[43] !== t13 || $[44] !== t8 || $[45] !== t9 ? (t14 = /* @__PURE__ */ jsxs(T1, { flex: t8, justify: t9, children: [
    t10,
    t12,
    t13
  ] }), $[40] = T1, $[41] = t10, $[42] = t12, $[43] = t13, $[44] = t8, $[45] = t9, $[46] = t14) : t14 = $[46], t14;
};
function useReleaseFormOptimisticUpdating(t0) {
  const $ = c(20), {
    externalValue,
    id: id2,
    extractData
  } = t0;
  let t1;
  $[0] !== externalValue || $[1] !== extractData ? (t1 = extractData(externalValue), $[0] = externalValue, $[1] = extractData, $[2] = t1) : t1 = $[2];
  const incomingFormData = t1;
  let t2;
  $[3] !== incomingFormData ? (t2 = () => incomingFormData, $[3] = incomingFormData, $[4] = t2) : t2 = $[4];
  const [localData, setLocalData] = useState(t2), [focusedField, setFocusedField] = useState(null), previousIdRef = useRef(id2);
  let t3;
  $[5] !== focusedField || $[6] !== incomingFormData ? (t3 = (currentFormData) => {
    const unfocusedFieldUpdates = Object.keys(incomingFormData).filter((field) => field !== focusedField).reduce((fieldUpdates, field_0) => (fieldUpdates[field_0] = incomingFormData[field_0], fieldUpdates), {});
    return {
      ...currentFormData,
      ...unfocusedFieldUpdates
    };
  }, $[5] = focusedField, $[6] = incomingFormData, $[7] = t3) : t3 = $[7];
  const updateUnfocusedFields = t3;
  let t4, t5;
  $[8] !== externalValue._createdAt || $[9] !== id2 || $[10] !== incomingFormData || $[11] !== updateUnfocusedFields ? (t4 = () => {
    const isEditingExistingRelease = !!externalValue._createdAt;
    previousIdRef.current === id2 ? setLocalData(isEditingExistingRelease ? updateUnfocusedFields : incomingFormData) : (previousIdRef.current = id2, setLocalData(incomingFormData), setFocusedField(null));
  }, t5 = [incomingFormData, id2, externalValue._createdAt, updateUnfocusedFields], $[8] = externalValue._createdAt, $[9] = id2, $[10] = incomingFormData, $[11] = updateUnfocusedFields, $[12] = t4, $[13] = t5) : (t4 = $[12], t5 = $[13]), useEffect(t4, t5);
  let t6;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = (fieldName) => () => setFocusedField(fieldName), $[14] = t6) : t6 = $[14];
  const createFocusHandler = t6;
  let t7;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = () => setFocusedField(null), $[15] = t7) : t7 = $[15];
  const handleBlur = t7;
  let t8;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = (formDataUpdates) => {
    setLocalData((currentFormData_0) => ({
      ...currentFormData_0,
      ...formDataUpdates
    }));
  }, $[16] = t8) : t8 = $[16];
  const updateLocalData = t8;
  let t9;
  return $[17] !== focusedField || $[18] !== localData ? (t9 = {
    localData,
    updateLocalData,
    createFocusHandler,
    handleBlur,
    focusedField
  }, $[17] = focusedField, $[18] = localData, $[19] = t9) : t9 = $[19], t9;
}
const MAX_DESCRIPTION_HEIGHT = 200, TitleTextArea = /* @__PURE__ */ styled.textarea.withConfig({
  displayName: "TitleTextArea",
  componentId: "sc-1q8zdyk-0"
})((props2) => {
  const {
    color,
    font
  } = getTheme_v2(props2.theme);
  return css`
    resize: none;
    overflow: hidden;
    appearance: none;
    background: none;
    border: 0;
    padding: 0;
    border-radius: 0;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    font-family: ${font.text.family};
    font-weight: ${font.text.weights.bold};
    font-size: ${font.text.sizes[4].fontSize}px;
    line-height: ${font.text.sizes[4].lineHeight}px;
    min-height: ${font.text.sizes[4].lineHeight}px;
    margin: 0;
    position: relative;
    z-index: 1;
    display: block;
    /* NOTE: This is a hack to disable Chrome's autofill styles */
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: var(--input-fg-color) !important;
      transition: background-color 5000s;
      transition-delay: 86400s /* 24h */;
    }

    color: ${color.input.default.enabled.fg};

    &::placeholder {
      color: ${color.input.default.enabled.placeholder};
    }
  `;
}), DescriptionTextArea = /* @__PURE__ */ styled.textarea.withConfig({
  displayName: "DescriptionTextArea",
  componentId: "sc-1q8zdyk-1"
})((props2) => {
  const {
    color,
    font
  } = getTheme_v2(props2.theme);
  return css`
    resize: none;
    overflow: hidden;
    appearance: none;
    background: none;
    border: 0;
    padding: 0;
    border-radius: 0;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    font-family: ${font.text.family};
    font-weight: ${font.text.weights.regular};
    font-size: ${font.text.sizes[2].fontSize}px;
    height: auto;
    line-height: ${font.text.sizes[2].lineHeight}px;
    margin: 0;
    max-width: 624px;
    position: relative;
    z-index: 1;
    display: block;
    color: ${color.input.default.enabled.fg};

    &::placeholder {
      color: ${color.input.default.enabled.placeholder};
    }
  `;
}), getIsReleaseOpen = (release) => release.state !== "archived" && release.state !== "published";
function TitleDescriptionForm(t0) {
  const $ = c(44), {
    release,
    onChange,
    disabled
  } = t0;
  let t1;
  $[0] !== release ? (t1 = getIsReleaseOpen(release), $[0] = release, $[1] = t1) : t1 = $[1];
  const isReleaseOpen = t1, titleRef = useRef(null), descriptionRef = useRef(null), [scrollHeight, setScrollHeight] = useState(46), {
    t
  } = useTranslation();
  let t2;
  $[2] !== release ? (t2 = {
    externalValue: release,
    id: release._id,
    extractData: _temp$2d
  }, $[2] = release, $[3] = t2) : t2 = $[3];
  const {
    localData,
    updateLocalData,
    createFocusHandler,
    handleBlur
  } = useReleaseFormOptimisticUpdating(t2);
  let t3, t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    descriptionRef.current && setScrollHeight(descriptionRef.current.scrollHeight), titleRef.current && (titleRef.current.style.height = "auto", titleRef.current.style.height = `${titleRef.current.scrollHeight}px`);
  }, t4 = [], $[4] = t3, $[5] = t4) : (t3 = $[4], t4 = $[5]), useEffect(t3, t4);
  let t5;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    titleRef.current && (titleRef.current.style.height = "auto", titleRef.current.style.height = `${titleRef.current.scrollHeight}px`);
  }, $[6] = t5) : t5 = $[6];
  let t6;
  $[7] !== release.metadata.title ? (t6 = [release.metadata.title], $[7] = release.metadata.title, $[8] = t6) : t6 = $[8], useEffect(t5, t6);
  let t7;
  $[9] !== onChange || $[10] !== release || $[11] !== updateLocalData ? (t7 = (event) => {
    event.preventDefault();
    const title = event.target.value;
    updateLocalData({
      title
    }), onChange({
      ...release,
      metadata: {
        ...release.metadata,
        title
      }
    }), titleRef.current && (titleRef.current.style.height = "auto", titleRef.current.style.height = `${titleRef.current.scrollHeight}px`);
  }, $[9] = onChange, $[10] = release, $[11] = updateLocalData, $[12] = t7) : t7 = $[12];
  const handleTitleChange = t7;
  let t8;
  $[13] !== isReleaseOpen || $[14] !== onChange || $[15] !== release || $[16] !== updateLocalData ? (t8 = (event_0) => {
    if (event_0.preventDefault(), !isReleaseOpen)
      return;
    const description = event_0.target.value;
    updateLocalData({
      description
    }), onChange({
      ...release,
      metadata: {
        ...release.metadata,
        description
      }
    }), descriptionRef.current && (descriptionRef.current.style.overflow = "hidden", descriptionRef.current.style.height = "auto", descriptionRef.current.style.height = `${descriptionRef.current.scrollHeight}px`, parseInt(descriptionRef.current.style.height, 10) > MAX_DESCRIPTION_HEIGHT && (descriptionRef.current.style.overflow = "auto")), setScrollHeight(event_0.currentTarget.scrollHeight);
  }, $[13] = isReleaseOpen, $[14] = onChange, $[15] = release, $[16] = updateLocalData, $[17] = t8) : t8 = $[17];
  const handleDescriptionChange = t8, shouldShowDescription = isReleaseOpen || localData.description;
  let t9;
  $[18] !== createFocusHandler ? (t9 = createFocusHandler("title"), $[18] = createFocusHandler, $[19] = t9) : t9 = $[19];
  const t10 = localData.title;
  let t11;
  $[20] !== t ? (t11 = t("release.placeholder-untitled-release"), $[20] = t, $[21] = t11) : t11 = $[21];
  const t12 = !isReleaseOpen;
  let t13;
  $[22] !== disabled || $[23] !== handleBlur || $[24] !== handleTitleChange || $[25] !== localData.title || $[26] !== t11 || $[27] !== t12 || $[28] !== t9 ? (t13 = /* @__PURE__ */ jsx(TitleTextArea, { ref: titleRef, onChange: handleTitleChange, onFocus: t9, onBlur: handleBlur, value: t10, placeholder: t11, "data-testid": "release-form-title", readOnly: t12, disabled }), $[22] = disabled, $[23] = handleBlur, $[24] = handleTitleChange, $[25] = localData.title, $[26] = t11, $[27] = t12, $[28] = t9, $[29] = t13) : t13 = $[29];
  let t14;
  $[30] !== createFocusHandler || $[31] !== disabled || $[32] !== handleBlur || $[33] !== handleDescriptionChange || $[34] !== isReleaseOpen || $[35] !== localData.description || $[36] !== localData.title || $[37] !== scrollHeight || $[38] !== shouldShowDescription || $[39] !== t ? (t14 = shouldShowDescription && /* @__PURE__ */ jsx(DescriptionTextArea, { ref: descriptionRef, autoFocus: !localData.title, value: localData.description, placeholder: t("release.form.placeholder-describe-release"), onChange: handleDescriptionChange, onFocus: createFocusHandler("description"), onBlur: handleBlur, style: {
    height: `${scrollHeight}px`,
    maxHeight: MAX_DESCRIPTION_HEIGHT
  }, "data-testid": "release-form-description", disabled, readOnly: !isReleaseOpen }), $[30] = createFocusHandler, $[31] = disabled, $[32] = handleBlur, $[33] = handleDescriptionChange, $[34] = isReleaseOpen, $[35] = localData.description, $[36] = localData.title, $[37] = scrollHeight, $[38] = shouldShowDescription, $[39] = t, $[40] = t14) : t14 = $[40];
  let t15;
  return $[41] !== t13 || $[42] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t13,
    t14
  ] }), $[41] = t13, $[42] = t14, $[43] = t15) : t15 = $[43], t15;
}
function _temp$2d(t0) {
  const {
    metadata
  } = t0;
  return {
    title: metadata.title,
    description: metadata.description
  };
}
function ReleaseForm(props2) {
  const $ = c(80), {
    onChange,
    value
  } = props2;
  let t0;
  $[0] !== value.metadata ? (t0 = value.metadata || {}, $[0] = value.metadata, $[1] = t0) : t0 = $[1];
  const {
    releaseType: t1,
    intendedPublishAt
  } = t0, releaseType = t1 === void 0 ? DEFAULT_RELEASE_TYPE : t1, {
    t
  } = useTranslation(), {
    getStoredReleaseData,
    saveReleaseDataToStorage
  } = useReleaseFormStorage(), id2 = value._id;
  let t2, t3;
  $[2] !== getStoredReleaseData || $[3] !== id2 || $[4] !== onChange ? (t2 = () => {
    const storedData = getStoredReleaseData();
    if (storedData) {
      const updatedValue = {
        metadata: {
          title: storedData.title,
          description: storedData.description,
          releaseType: storedData.releaseType ?? DEFAULT_RELEASE_TYPE,
          intendedPublishAt: storedData.intendedPublishAt
        }
      };
      onChange({
        _id: id2,
        ...updatedValue
      });
    }
  }, t3 = [getStoredReleaseData, id2, onChange], $[2] = getStoredReleaseData, $[3] = id2, $[4] = onChange, $[5] = t2, $[6] = t3) : (t2 = $[5], t3 = $[6]), useEffect(t2, t3);
  let t4;
  $[7] !== onChange || $[8] !== saveReleaseDataToStorage ? (t4 = (updatedValue_0) => {
    onChange(updatedValue_0), saveReleaseDataToStorage({
      ...updatedValue_0.metadata
    });
  }, $[7] = onChange, $[8] = saveReleaseDataToStorage, $[9] = t4) : t4 = $[9];
  const handleOnChangeAndStorage = t4;
  let t5;
  $[10] !== handleOnChangeAndStorage || $[11] !== value ? (t5 = (date) => {
    handleOnChangeAndStorage({
      ...value,
      metadata: {
        ...value.metadata,
        intendedPublishAt: date.toISOString()
      }
    });
  }, $[10] = handleOnChangeAndStorage, $[11] = value, $[12] = t5) : t5 = $[12];
  const handleBundlePublishAtCalendarChange = t5;
  let t6;
  $[13] !== handleOnChangeAndStorage || $[14] !== value ? (t6 = (event) => {
    const pickedReleaseType = event.currentTarget.dataset.value;
    if (!isReleaseType(pickedReleaseType))
      return;
    const nextInputValue = startOfHour(addHours(/* @__PURE__ */ new Date(), 1));
    handleOnChangeAndStorage({
      ...value,
      metadata: {
        ...value.metadata,
        releaseType: pickedReleaseType,
        intendedPublishAt: pickedReleaseType === "scheduled" && nextInputValue.toISOString() || void 0
      }
    });
  }, $[13] = handleOnChangeAndStorage, $[14] = value, $[15] = t6) : t6 = $[15];
  const handleReleaseTypeChange = t6;
  let t7;
  $[16] !== handleOnChangeAndStorage || $[17] !== value ? (t7 = (updatedRelease) => {
    handleOnChangeAndStorage({
      ...value,
      metadata: {
        ...value.metadata,
        title: updatedRelease.metadata.title,
        description: updatedRelease.metadata.description
      }
    });
  }, $[16] = handleOnChangeAndStorage, $[17] = value, $[18] = t7) : t7 = $[18];
  const handleTitleDescriptionChange = t7, menuButtonId = useId(), [menuButton, setMenuButton] = useState(null);
  let t8;
  $[19] !== t ? (t8 = t("release.dialog.tooltip.title"), $[19] = t, $[20] = t8) : t8 = $[20];
  let t9;
  $[21] !== menuButtonId || $[22] !== t8 ? (t9 = /* @__PURE__ */ jsx(Text$1, { as: "label", htmlFor: menuButtonId, children: t8 }), $[21] = menuButtonId, $[22] = t8, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    maxWidth: 304
  }, $[24] = t10) : t10 = $[24];
  let t11;
  $[25] !== t ? (t11 = t("release.dialog.tooltip.description"), $[25] = t, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== t11 ? (t12 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t11 }), $[27] = t11, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== t ? (t13 = t("release.dialog.tooltip.note"), $[29] = t, $[30] = t13) : t13 = $[30];
  let t14;
  $[31] !== t13 ? (t14 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t13 }), $[31] = t13, $[32] = t14) : t14 = $[32];
  let t15;
  $[33] !== t12 || $[34] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Stack, { space: 3, style: t10, children: [
    t12,
    t14
  ] }), $[33] = t12, $[34] = t14, $[35] = t15) : t15 = $[35];
  let t16;
  $[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = /* @__PURE__ */ jsx(InfoOutlineIcon, {}), $[36] = t16) : t16 = $[36];
  let t17;
  $[37] !== t15 ? (t17 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Tooltip, { content: t15, delay: 0, placement: "right-start", portal: !0, children: t16 }) }), $[37] = t15, $[38] = t17) : t17 = $[38];
  let t18;
  $[39] !== t17 || $[40] !== t9 ? (t18 = /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "center", children: [
    t9,
    t17
  ] }), $[39] = t17, $[40] = t9, $[41] = t18) : t18 = $[41];
  const t19 = `release.type.${releaseType}`;
  let t20;
  $[42] !== t || $[43] !== t19 ? (t20 = t(t19), $[42] = t, $[43] = t19, $[44] = t20) : t20 = $[44];
  let t21;
  $[45] !== releaseType || $[46] !== t20 ? (t21 = /* @__PURE__ */ jsx(ReleaseTypeOption, { text: t20, releaseType }), $[45] = releaseType, $[46] = t20, $[47] = t21) : t21 = $[47];
  let t22;
  $[48] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ChevronDownIcon, {}) }), $[48] = t22) : t22 = $[48];
  let t23;
  $[49] !== t21 ? (t23 = /* @__PURE__ */ jsx(Button$1, { mode: "ghost", children: /* @__PURE__ */ jsxs(Flex, { justify: "space-between", align: "center", children: [
    t21,
    t22
  ] }) }), $[49] = t21, $[50] = t23) : t23 = $[50];
  let t24;
  $[51] !== menuButton ? (t24 = {
    placement: "bottom",
    matchReferenceWidth: !0,
    boundaryElement: menuButton
  }, $[51] = menuButton, $[52] = t24) : t24 = $[52];
  let t25;
  $[53] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t25 = Object.keys(RELEASE_TYPES_TONES), $[53] = t25) : t25 = $[53];
  let t26;
  $[54] !== handleReleaseTypeChange || $[55] !== t ? (t26 = /* @__PURE__ */ jsx(Menu, { children: t25.map((type) => /* @__PURE__ */ jsx(MenuItem$1, { "data-value": type, onClick: handleReleaseTypeChange, children: /* @__PURE__ */ jsx(ReleaseTypeOption, { text: t(`release.type.${type}`), releaseType: type }) }, type)) }), $[54] = handleReleaseTypeChange, $[55] = t, $[56] = t26) : t26 = $[56];
  let t27;
  $[57] !== menuButtonId || $[58] !== t23 || $[59] !== t24 || $[60] !== t26 ? (t27 = /* @__PURE__ */ jsx(MenuButton, { id: menuButtonId, ref: setMenuButton, button: t23, popover: t24, menu: t26 }), $[57] = menuButtonId, $[58] = t23, $[59] = t24, $[60] = t26, $[61] = t27) : t27 = $[61];
  let t28;
  $[62] !== handleBundlePublishAtCalendarChange || $[63] !== intendedPublishAt || $[64] !== releaseType ? (t28 = releaseType === "scheduled" && /* @__PURE__ */ jsx(TabPanel, { "aria-labelledby": "release-timing-at-time-tab", flex: 1, id: "release-timing-at-time", style: {
    outline: "none"
  }, tabIndex: -1, children: /* @__PURE__ */ jsx(ScheduleDatePicker, { value: intendedPublishAt ? new Date(intendedPublishAt) : void 0, onChange: handleBundlePublishAtCalendarChange, timeZoneScope: CONTENT_RELEASES_TIME_ZONE_SCOPE }) }), $[62] = handleBundlePublishAtCalendarChange, $[63] = intendedPublishAt, $[64] = releaseType, $[65] = t28) : t28 = $[65];
  let t29;
  $[66] !== t28 ? (t29 = /* @__PURE__ */ jsx(Flex, { gap: 1, children: t28 }), $[66] = t28, $[67] = t29) : t29 = $[67];
  let t30;
  $[68] !== t27 || $[69] !== t29 ? (t30 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t27,
    t29
  ] }), $[68] = t27, $[69] = t29, $[70] = t30) : t30 = $[70];
  let t31;
  $[71] !== t18 || $[72] !== t30 ? (t31 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t18,
    t30
  ] }), $[71] = t18, $[72] = t30, $[73] = t31) : t31 = $[73];
  let t32;
  $[74] !== handleTitleDescriptionChange || $[75] !== value ? (t32 = /* @__PURE__ */ jsx(TitleDescriptionForm, { release: value, onChange: handleTitleDescriptionChange }), $[74] = handleTitleDescriptionChange, $[75] = value, $[76] = t32) : t32 = $[76];
  let t33;
  return $[77] !== t31 || $[78] !== t32 ? (t33 = /* @__PURE__ */ jsxs(Stack, { space: 5, children: [
    t31,
    t32
  ] }), $[77] = t31, $[78] = t32, $[79] = t33) : t33 = $[79], t33;
}
const ReleaseTypeOption = (t0) => {
  const $ = c(7), {
    releaseType,
    text
  } = t0;
  let t1;
  $[0] !== releaseType ? (t1 = /* @__PURE__ */ jsx(ReleaseAvatar, { padding: 1, releaseType }), $[0] = releaseType, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== text ? (t2 = /* @__PURE__ */ jsx(Text$1, { children: text }), $[2] = text, $[3] = t2) : t2 = $[3];
  let t3;
  return $[4] !== t1 || $[5] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Flex, { gap: 3, align: "center", children: [
    t1,
    t2
  ] }), $[4] = t1, $[5] = t2, $[6] = t3) : t3 = $[6], t3;
}, INITIAL_VALUE$2 = {
  data: [],
  error: null,
  loading: !0
}, getCompanionDocs = memoize((publishedId, client, previewStore) => {
  const companionDocsIdsListener$ = previewStore.unstable_observeDocumentIdSet("sanity::versionOf($publishedId)", {
    publishedId
  }).pipe(map$1((result) => result.documentIds)).pipe(switchMap$1((versionIds) => previewStore.unstable_observeDocumentIdSet('_type == "sanity.canvas.link" && studioDocumentId in $ids', {
    ids: versionIds
  }))), getCompanionDoc$ = (id2) => client.observable.fetch("*[_id == $id][0]{ _id, canvasDocumentId, studioDocumentId, isStudioDocumentEditable}", {
    id: id2
  }, {
    tag: "canvas.companion-docs"
  }).pipe(map$1((response) => {
    if (!response?._id)
      throw new Error("Companion doc not ready");
    return response;
  }), retry({
    count: 2,
    delay: (error) => {
      if (error instanceof Error && error.message === "Companion doc not ready")
        return timer(1e3);
      throw error;
    }
  }));
  return companionDocsIdsListener$.pipe(map$1((value) => value.documentIds), mergeMapArray(getCompanionDoc$), map$1((value) => ({
    error: null,
    data: value,
    loading: !1
  })), catchError$1((error) => of({
    error,
    data: [],
    loading: !1
  })), startWith$1(INITIAL_VALUE$2), shareReplay$1(1));
}, (publishedId, client) => `${publishedId}-${client.config().dataset}-${client.config().projectId}`);
function createCanvasCompanionDocsStore({
  client,
  previewStore
}) {
  return {
    getCompanionDocs: (documentId) => getCompanionDocs(getPublishedId(documentId), client, previewStore)
  };
}
function useCanvasCompanionDocsStore() {
  const $ = c(5), resourceCache = useResourceCache(), workspace = useWorkspace(), previewStore = useDocumentPreviewStore(), studioClient = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let releaseStore;
  return $[0] !== previewStore || $[1] !== resourceCache || $[2] !== studioClient || $[3] !== workspace ? (releaseStore = resourceCache.get({
    dependencies: [workspace, previewStore],
    namespace: "CompanionDocsStore"
  }) || createCanvasCompanionDocsStore({
    client: studioClient,
    previewStore
  }), resourceCache.set({
    dependencies: [workspace, previewStore],
    namespace: "CompanionDocsStore",
    value: releaseStore
  }), $[0] = previewStore, $[1] = resourceCache, $[2] = studioClient, $[3] = workspace, $[4] = releaseStore) : releaseStore = $[4], releaseStore;
}
function validatePlugin(pluginResult) {
  const messages = ["projectId" in pluginResult && "`projectId` not allowed in plugin configuration", "dataset" in pluginResult && "`dataset` not allowed in plugin configuration"].filter(isString$1);
  if (messages.length) throw new Error(`Invalid plugin configuration:
${messages.map((message) => `	${message}`).join(`
`)}`);
}
function definePlugin(arg) {
  if (typeof arg == "function") {
    const pluginFactory = arg;
    return (options) => {
      const result = pluginFactory(options);
      return validatePlugin(result), result;
    };
  }
  return validatePlugin(arg), () => arg;
}
function createPlugin(arg) {
  return definePlugin(arg);
}
const EMPTY_ARRAY$k = [];
function InsufficientPermissionsMessage(t0) {
  const $ = c(21), {
    currentUser,
    context
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    style: "short",
    type: "unit"
  }, $[0] = t1) : t1 = $[0];
  const list = useListFormat(t1), roles = currentUser?.roles || EMPTY_ARRAY$k;
  let t2;
  $[1] !== list || $[2] !== roles ? (t2 = () => /* @__PURE__ */ jsx(Fragment$1, { children: list.formatToParts(roles.map(_temp$2c)).map(_temp2$U) }), $[1] = list, $[2] = roles, $[3] = t2) : t2 = $[3];
  const Roles = t2;
  let t3;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 0, children: /* @__PURE__ */ jsx(AccessDeniedIcon, {}) }), $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t ? (t4 = t("insufficient-permissions-message.title"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    t3,
    /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t4 })
  ] }), $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== context || $[10] !== t ? (t6 = /* @__PURE__ */ jsx(Inline, { marginTop: 4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "insufficient-permissions-message.not-authorized-explanation", t, context }) }) }), $[9] = context, $[10] = t, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== Roles ? (t7 = {
    Roles
  }, $[12] = Roles, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(Inline, { marginTop: 4, marginBottom: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "insufficient-permissions-message.roles", t, components: t7 }) }) }), $[14] = t, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  return $[17] !== t5 || $[18] !== t6 || $[19] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Box, { children: [
    t5,
    t6,
    t8
  ] }), $[17] = t5, $[18] = t6, $[19] = t8, $[20] = t9) : t9 = $[20], t9;
}
function _temp2$U(i, index) {
  return i.type === "element" ? /* @__PURE__ */ jsx("code", { children: i.value }, `${i.value}-${index}`) : /* @__PURE__ */ jsx(Fragment, { children: i.value }, `${i.value}-${index}`);
}
function _temp$2c(role) {
  return role.title || startCase(role.name);
}
const useDiscardVersionAction = (props2) => {
  const $ = c(24), {
    id: id2,
    type,
    release,
    version: version2
  } = props2, currentUser = useCurrentUser(), {
    t
  } = useTranslation(), {
    selectedPerspective
  } = usePerspective();
  let t0;
  $[0] !== version2 ? (t0 = version2 ? isGoingToUnpublish(version2) : !1, $[0] = version2, $[1] = t0) : t0 = $[1];
  const willUnpublish = t0;
  let t1;
  $[2] !== id2 || $[3] !== release || $[4] !== type ? (t1 = {
    id: id2,
    type,
    version: release,
    permission: "discardVersion"
  }, $[2] = id2, $[3] = release, $[4] = type, $[5] = t1) : t1 = $[5];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t1), [dialogOpen, setDialogOpen] = useState(!1);
  let t2;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setDialogOpen(!0);
  }, $[6] = t2) : t2 = $[6];
  const handleDialogOpen = t2;
  if (!version2)
    return null;
  if (!isPermissionsLoading && !permissions?.granted) {
    let t32;
    return $[7] !== currentUser ? (t32 = {
      disabled: !0,
      icon: TrashIcon,
      label: "no permissions",
      title: /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: "discard-changes" })
    }, $[7] = currentUser, $[8] = t32) : t32 = $[8], t32;
  }
  const t3 = isPermissionsLoading || !permissions?.granted;
  let t4;
  $[9] !== dialogOpen || $[10] !== selectedPerspective || $[11] !== type || $[12] !== version2 || $[13] !== willUnpublish ? (t4 = dialogOpen && {
    type: "custom",
    component: /* @__PURE__ */ jsx(DiscardVersionDialog, { isGoingToUnpublish: willUnpublish, documentId: version2._id, documentType: type, onClose: () => setDialogOpen(!1), fromPerspective: selectedPerspective })
  }, $[9] = dialogOpen, $[10] = selectedPerspective, $[11] = type, $[12] = version2, $[13] = willUnpublish, $[14] = t4) : t4 = $[14];
  let t5;
  $[15] !== t ? (t5 = t("release.action.discard-version"), $[15] = t, $[16] = t5) : t5 = $[16];
  let t6;
  $[17] !== t ? (t6 = t("release.action.discard-version"), $[17] = t, $[18] = t6) : t6 = $[18];
  let t7;
  return $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 ? (t7 = {
    disabled: t3,
    dialog: t4,
    label: t5,
    icon: TrashIcon,
    onHandle: handleDialogOpen,
    title: t6
  }, $[19] = t3, $[20] = t4, $[21] = t5, $[22] = t6, $[23] = t7) : t7 = $[23], t7;
};
useDiscardVersionAction.action = "discardVersion";
useDiscardVersionAction.displayName = "DiscardVersionAction";
function useSchema() {
  return useSource().schema;
}
function useAllReleases() {
  const $ = c(7), {
    state$
  } = useReleasesStore(), {
    releases: releases2,
    error,
    state
  } = useObservable(state$);
  let t0;
  $[0] !== releases2 ? (t0 = sortReleases(Array.from(releases2.values())), $[0] = releases2, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = ["loading", "initialising"], $[2] = t1) : t1 = $[2];
  const t2 = t1.includes(state);
  let t3;
  return $[3] !== error || $[4] !== t0 || $[5] !== t2 ? (t3 = {
    data: t0,
    error,
    loading: t2
  }, $[3] = error, $[4] = t0, $[5] = t2, $[6] = t3) : t3 = $[6], t3;
}
function useArchivedReleases() {
  const $ = c(6), {
    data: releases2,
    error,
    loading
  } = useAllReleases();
  let t0;
  $[0] !== releases2 ? (t0 = Array.from(releases2.values()).filter(_temp$2b), $[0] = releases2, $[1] = t0) : t0 = $[1];
  const archivedReleases = t0;
  let t1;
  return $[2] !== archivedReleases || $[3] !== error || $[4] !== loading ? (t1 = {
    data: archivedReleases,
    error,
    loading
  }, $[2] = archivedReleases, $[3] = error, $[4] = loading, $[5] = t1) : t1 = $[5], t1;
}
function _temp$2b(release) {
  return ARCHIVED_RELEASE_STATES.includes(release.state);
}
function UnpublishVersionDialog(props2) {
  const $ = c(65), {
    onClose,
    documentVersionId,
    documentType
  } = props2, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: coreT
  } = useTranslation(), schema2 = useSchema(), {
    unpublishVersion
  } = useVersionOperations(), [isUnpublishing, setIsUnpublishing] = useState(!1), toast = useToast(), {
    data
  } = useActiveReleases(), {
    data: archivedReleases
  } = useArchivedReleases();
  let release, t0;
  if ($[0] !== archivedReleases || $[1] !== data || $[2] !== documentVersionId) {
    let t110;
    $[5] !== documentVersionId ? (t110 = (candidate) => getReleaseIdFromReleaseDocumentId(candidate._id) === getVersionFromId(documentVersionId), $[5] = documentVersionId, $[6] = t110) : t110 = $[6], release = data.concat(archivedReleases).find(t110), t0 = getReleaseTone(release), $[0] = archivedReleases, $[1] = data, $[2] = documentVersionId, $[3] = release, $[4] = t0;
  } else
    release = $[3], t0 = $[4];
  const tone = t0;
  let t1;
  $[7] !== documentType || $[8] !== schema2 ? (t1 = schema2.get(documentType), $[7] = documentType, $[8] = schema2, $[9] = t1) : t1 = $[9];
  const schemaType = t1;
  let t2;
  $[10] !== documentVersionId ? (t2 = {
    _id: documentVersionId
  }, $[10] = documentVersionId, $[11] = t2) : t2 = $[11];
  let t3;
  $[12] !== schemaType || $[13] !== t2 ? (t3 = {
    schemaType,
    value: t2
  }, $[12] = schemaType, $[13] = t2, $[14] = t3) : t3 = $[14];
  const preview = useValuePreview(t3);
  let t4;
  $[15] !== coreT || $[16] !== documentVersionId || $[17] !== onClose || $[18] !== preview?.value?.title || $[19] !== toast || $[20] !== unpublishVersion ? (t4 = async () => {
    setIsUnpublishing(!0);
    const run = async () => {
      await unpublishVersion(documentVersionId), toast.push({
        closable: !0,
        status: "success",
        description: /* @__PURE__ */ jsx(Translate, { t: coreT, i18nKey: "release.action.unpublish-version.success", values: {
          title: preview?.value?.title || documentVersionId
        } })
      });
    };
    try {
      await run();
    } catch (t52) {
      const err = t52;
      toast.push({
        closable: !0,
        status: "error",
        title: coreT("release.action.unpublish-version.failure"),
        description: err.message
      });
    }
    setIsUnpublishing(!1), onClose();
  }, $[15] = coreT, $[16] = documentVersionId, $[17] = onClose, $[18] = preview?.value?.title, $[19] = toast, $[20] = unpublishVersion, $[21] = t4) : t4 = $[21];
  const handleUnpublish = t4;
  let t5;
  $[22] !== t ? (t5 = t("unpublish-dialog.header"), $[22] = t, $[23] = t5) : t5 = $[23];
  let t6;
  $[24] !== t ? (t6 = t("unpublish-dialog.action.cancel"), $[24] = t, $[25] = t6) : t6 = $[25];
  let t7;
  $[26] !== onClose || $[27] !== t6 ? (t7 = {
    text: t6,
    onClick: onClose
  }, $[26] = onClose, $[27] = t6, $[28] = t7) : t7 = $[28];
  let t8;
  $[29] !== t ? (t8 = t("unpublish-dialog.action.unpublish"), $[29] = t, $[30] = t8) : t8 = $[30];
  let t9;
  $[31] !== handleUnpublish || $[32] !== isUnpublishing || $[33] !== t8 ? (t9 = {
    text: t8,
    onClick: handleUnpublish,
    tone: "critical",
    disabled: isUnpublishing,
    loading: isUnpublishing
  }, $[31] = handleUnpublish, $[32] = isUnpublishing, $[33] = t8, $[34] = t9) : t9 = $[34];
  let t10;
  $[35] !== t7 || $[36] !== t9 ? (t10 = {
    cancelButton: t7,
    confirmButton: t9
  }, $[35] = t7, $[36] = t9, $[37] = t10) : t10 = $[37];
  let t11;
  $[38] !== documentVersionId || $[39] !== schemaType ? (t11 = schemaType ? /* @__PURE__ */ jsx(Preview$1, { value: {
    _id: documentVersionId
  }, schemaType }) : /* @__PURE__ */ jsx(LoadingBlock, {}), $[38] = documentVersionId, $[39] = schemaType, $[40] = t11) : t11 = $[40];
  let t12;
  $[41] !== coreT || $[42] !== release?.metadata.title ? (t12 = release?.metadata.title || coreT("release.placeholder-untitled-release"), $[41] = coreT, $[42] = release?.metadata.title, $[43] = t12) : t12 = $[43];
  let t13;
  $[44] !== t12 ? (t13 = {
    title: t12
  }, $[44] = t12, $[45] = t13) : t13 = $[45];
  let t14;
  $[46] !== tone ? (t14 = {
    Label: (t152) => {
      const {
        children
      } = t152;
      return /* @__PURE__ */ jsx("span", { style: {
        color: `var(--card-badge-${tone ?? "default"}-fg-color)`,
        backgroundColor: `var(--card-badge-${tone ?? "default"}-bg-color)`,
        borderRadius: 3,
        textDecoration: "none",
        padding: "0px 2px",
        fontWeight: 500
      }, children });
    }
  }, $[46] = tone, $[47] = t14) : t14 = $[47];
  let t15;
  $[48] !== t || $[49] !== t13 || $[50] !== t14 ? (t15 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "unpublish-dialog.description.to-draft", values: t13, components: t14 }) }), $[48] = t, $[49] = t13, $[50] = t14, $[51] = t15) : t15 = $[51];
  let t16;
  $[52] !== t ? (t16 = t("unpublish-dialog.description.lost-changes"), $[52] = t, $[53] = t16) : t16 = $[53];
  let t17;
  $[54] !== t16 ? (t17 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t16 }), $[54] = t16, $[55] = t17) : t17 = $[55];
  let t18;
  $[56] !== t11 || $[57] !== t15 || $[58] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Stack, { space: 4, paddingX: 4, paddingBottom: 4, children: [
    t11,
    t15,
    t17
  ] }), $[56] = t11, $[57] = t15, $[58] = t17, $[59] = t18) : t18 = $[59];
  let t19;
  return $[60] !== onClose || $[61] !== t10 || $[62] !== t18 || $[63] !== t5 ? (t19 = /* @__PURE__ */ jsx(Dialog$1, { header: t5, id: "document-unpublish-dialog", onClickOutside: onClose, onClose, width: 0, padding: !1, footer: t10, children: t18 }), $[60] = onClose, $[61] = t10, $[62] = t18, $[63] = t5, $[64] = t19) : t19 = $[64], t19;
}
const useUnpublishVersionAction = (props2) => {
  const $ = c(32), {
    id: id2,
    type,
    release,
    published,
    version: version2
  } = props2, currentUser = useCurrentUser(), isPublished = published !== null, {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t0;
  $[0] !== version2 ? (t0 = version2 ? isGoingToUnpublish(version2) : !1, $[0] = version2, $[1] = t0) : t0 = $[1];
  const isAlreadyUnpublished = t0, {
    revertUnpublishVersion
  } = useVersionOperations(), toast = useToast(), {
    t: coreT
  } = useTranslation();
  let t1;
  $[2] !== id2 || $[3] !== release || $[4] !== type ? (t1 = {
    id: id2,
    type,
    version: release,
    permission: "unpublish"
  }, $[2] = id2, $[3] = release, $[4] = type, $[5] = t1) : t1 = $[5];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t1), [dialogOpen, setDialogOpen] = useState(!1);
  let t2;
  $[6] !== coreT || $[7] !== isAlreadyUnpublished || $[8] !== revertUnpublishVersion || $[9] !== toast || $[10] !== version2 ? (t2 = async () => {
    if (isAlreadyUnpublished && version2)
      try {
        await revertUnpublishVersion(version2._id);
      } catch {
        toast.push({
          closable: !0,
          status: "error",
          title: coreT("release.action.revert-unpublish-version.failure.title"),
          description: coreT("release.action.revert-unpublish-version.failure.description")
        });
      }
    else
      setDialogOpen(!0);
  }, $[6] = coreT, $[7] = isAlreadyUnpublished, $[8] = revertUnpublishVersion, $[9] = toast, $[10] = version2, $[11] = t2) : t2 = $[11];
  const handleOnClick = t2;
  if (!release || !version2)
    return null;
  if (!isPermissionsLoading && !permissions?.granted) {
    let t32;
    return $[12] !== currentUser ? (t32 = {
      disabled: !0,
      icon: TrashIcon,
      label: "no permissions",
      title: /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { context: "unpublish-document", currentUser })
    }, $[12] = currentUser, $[13] = t32) : t32 = $[13], t32;
  }
  let t3;
  $[14] !== dialogOpen || $[15] !== isAlreadyUnpublished || $[16] !== type || $[17] !== version2 ? (t3 = dialogOpen && !isAlreadyUnpublished && {
    type: "custom",
    component: /* @__PURE__ */ jsx(UnpublishVersionDialog, { documentVersionId: version2._id, documentType: type, onClose: () => setDialogOpen(!1) })
  }, $[14] = dialogOpen, $[15] = isAlreadyUnpublished, $[16] = type, $[17] = version2, $[18] = t3) : t3 = $[18];
  let t4;
  $[19] !== isAlreadyUnpublished || $[20] !== t ? (t4 = t(isAlreadyUnpublished ? "action.revert-unpublish-actions" : "action.unpublish-doc-actions"), $[19] = isAlreadyUnpublished, $[20] = t, $[21] = t4) : t4 = $[21];
  const t5 = isAlreadyUnpublished ? RevertIcon : UnpublishIcon, t6 = !isPublished;
  let t7;
  $[22] !== isAlreadyUnpublished || $[23] !== t ? (t7 = t(isAlreadyUnpublished ? "action.revert-unpublish-actions" : "action.unpublish-doc-actions"), $[22] = isAlreadyUnpublished, $[23] = t, $[24] = t7) : t7 = $[24];
  let t8;
  return $[25] !== handleOnClick || $[26] !== t3 || $[27] !== t4 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7 ? (t8 = {
    dialog: t3,
    label: t4,
    icon: t5,
    onHandle: handleOnClick,
    disabled: t6,
    title: t7
  }, $[25] = handleOnClick, $[26] = t3, $[27] = t4, $[28] = t5, $[29] = t6, $[30] = t7, $[31] = t8) : t8 = $[31], t8;
};
useUnpublishVersionAction.action = "unpublishVersion";
useUnpublishVersionAction.displayName = "UnpublishVersionAction";
function resolveDocumentActions$2(existingActions, context) {
  const duplicateAction = existingActions.filter(({
    action
  }) => action === "duplicate");
  return context.versionType === "version" ? duplicateAction.concat(useDiscardVersionAction, useUnpublishVersionAction) : existingActions;
}
const RELEASES_NAME = "sanity/releases", RELEASES_INTENT = "release", releases = definePlugin({
  name: RELEASES_NAME,
  document: {
    actions: (actions, context) => resolveDocumentActions$2(actions, context)
  }
}), DEFAULT_METADATA_STATE = {
  data: null,
  error: null,
  loading: !1
}, ReleasesMetadataProviderInner = (t0) => {
  const $ = c(15), {
    children
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[0] = t1) : t1 = $[0];
  const [listenerReleaseIds, setListenerReleaseIds] = useState(t1), {
    getMetadataStateForSlugs$
  } = useReleasesStore(), [releasesMetadata, setReleasesMetadata] = useState(null);
  let t2;
  $[1] !== getMetadataStateForSlugs$ || $[2] !== listenerReleaseIds ? (t2 = getMetadataStateForSlugs$(listenerReleaseIds.map(_temp$2a)), $[1] = getMetadataStateForSlugs$, $[2] = listenerReleaseIds, $[3] = t2) : t2 = $[3];
  const observedResult = useObservable(t2) || DEFAULT_METADATA_STATE;
  let t3, t4;
  $[4] !== observedResult.data ? (t3 = () => setReleasesMetadata((prevReleaseMetadata) => observedResult.data ? {
    ...prevReleaseMetadata,
    ...observedResult.data
  } : prevReleaseMetadata), t4 = [observedResult.data], $[4] = observedResult.data, $[5] = t3, $[6] = t4) : (t3 = $[5], t4 = $[6]), useEffect(t3, t4);
  let t5;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = (addReleaseIds) => {
    setListenerReleaseIds((prevSlugs) => [...prevSlugs, ...addReleaseIds.filter(_temp2$T)]);
  }, $[7] = t5) : t5 = $[7];
  const addReleaseIdsToListener = t5;
  let t6;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = (releaseIds) => {
    setListenerReleaseIds((prevSlugs_0) => {
      const {
        nextSlugs
      } = prevSlugs_0.reduce((acc, slug_0) => {
        const {
          removedSlugs,
          nextSlugs: accNextSlugs
        } = acc;
        return releaseIds.includes(slug_0) && !removedSlugs.includes(slug_0) ? {
          removedSlugs: [...removedSlugs, slug_0],
          nextSlugs: accNextSlugs
        } : {
          removedSlugs,
          nextSlugs: [...accNextSlugs, slug_0]
        };
      }, {
        removedSlugs: [],
        nextSlugs: []
      });
      return nextSlugs;
    });
  }, $[8] = t6) : t6 = $[8];
  const removeReleaseIdsFromListener = t6;
  let t7;
  $[9] !== observedResult || $[10] !== releasesMetadata ? (t7 = {
    addReleaseIdsToListener,
    removeReleaseIdsFromListener,
    state: {
      ...observedResult,
      data: releasesMetadata
    }
  }, $[9] = observedResult, $[10] = releasesMetadata, $[11] = t7) : t7 = $[11];
  const context = t7;
  let t8;
  return $[12] !== children || $[13] !== context ? (t8 = /* @__PURE__ */ jsx(ReleasesMetadataContext.Provider, { value: context, children }), $[12] = children, $[13] = context, $[14] = t8) : t8 = $[14], t8;
}, ReleasesMetadataProvider = (t0) => {
  const $ = c(2), {
    children
  } = t0;
  if (useContext(ReleasesMetadataContext))
    return children;
  let t1;
  return $[0] !== children ? (t1 = /* @__PURE__ */ jsx(ReleasesMetadataProviderInner, { children }), $[0] = children, $[1] = t1) : t1 = $[1], t1;
}, useReleasesMetadataProvider = () => {
  const $ = c(2), contextValue = useContext(ReleasesMetadataContext);
  let t0;
  return $[0] !== contextValue ? (t0 = contextValue || {
    state: DEFAULT_METADATA_STATE,
    addReleaseIdsToListener: _temp3$r,
    removeReleaseIdsFromListener: _temp4$d
  }, $[0] = contextValue, $[1] = t0) : t0 = $[1], t0;
};
function _temp$2a(slug) {
  return slug;
}
function _temp2$T(releaseId) {
  return typeof releaseId == "string";
}
function _temp3$r() {
  return null;
}
function _temp4$d() {
  return null;
}
function ReleaseLimitsMisconfigurationDialog(props2) {
  const $ = c(18), {
    onClose
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== onClose ? (t0 = () => {
    window.open("https://www.sanity.io/contact/support", "_blank", "noopener,noreferrer"), onClose();
  }, $[0] = onClose, $[1] = t0) : t0 = $[1];
  const handleContactSupport = t0;
  let t1;
  $[2] !== t ? (t1 = t("releases.upsell.misconfiguration.header"), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t ? (t2 = t("releases.upsell.misconfiguration.contact-support"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== handleContactSupport || $[7] !== t2 ? (t3 = {
    confirmButton: {
      text: t2,
      onClick: handleContactSupport,
      tone: "primary"
    }
  }, $[6] = handleContactSupport, $[7] = t2, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== t ? (t4 = t("releases.upsell.misconfiguration.message"), $[9] = t, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(Stack, { space: 4, children: /* @__PURE__ */ jsx(Text$1, { children: t4 }) }), $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  return $[13] !== onClose || $[14] !== t1 || $[15] !== t3 || $[16] !== t5 ? (t6 = /* @__PURE__ */ jsx(Dialog$1, { id: "releases-misconfiguration-dialog", header: t1, width: 1, onClose, footer: t3, children: t5 }), $[13] = onClose, $[14] = t1, $[15] = t3, $[16] = t5, $[17] = t6) : t6 = $[17], t6;
}
function isErrorAtLimits(error) {
  return error.statusCode === 403 && typeof error.response.body != "string" && "data" in error.response.body;
}
function fetchReleaseLimits(client, storeOrigin) {
  const {
    projectId
  } = client.config();
  return client.withConfig({
    apiVersion: "vX"
  }).observable.request({
    uri: `projects/${projectId}/new-content-release-allowed`,
    /**
     * In a particular case when both releaseLimits
     * and orgActiveReleaseCount stores are empty, 2 fetch calls are made
     * to guard the create/archive/revert actions - browsers behave differently.
     *
     * Chromium based browsers will stall the second network request until the first
     * resolves by attaching the store name to the tag, this spoofs 2 unique requests
     * allowing both the fire in parallel.
     */
    tag: `new-content-release-allowed-${storeOrigin}`
  }).pipe(catchError$1((error) => {
    if (console.error(error), isErrorAtLimits(error))
      return of(error.response.body);
    throw error;
  }), map$1(({
    data
  }) => data));
}
const STATE_TTL_MS = 6e4, ORG_ACTIVE_RELEASE_COUNT_RESOURCE_CACHE_NAMESPACE = "orgActiveReleaseCount";
function createOrgActiveReleaseCountStore(client, activeReleasesCount) {
  const latestFetchState = new BehaviorSubject(null), staleFlag$ = new BehaviorSubject(!1), activeReleaseCountAtFetch = new BehaviorSubject(null);
  return {
    orgActiveReleaseCount$: latestFetchState.pipe(switchMap$1((state) => state === null || // oxlint-disable-next-line no-unnecessary-boolean-literal-compare
    staleFlag$.getValue() === !0 || activeReleaseCountAtFetch.getValue() !== activeReleasesCount ? (staleFlag$.next(!1), fetchReleaseLimits(client, "orgActiveReleaseCount").pipe(tap$1(() => activeReleaseCountAtFetch.next(activeReleasesCount)), map$1((data) => data.orgMeteredActiveReleaseCount), catchError$1((error) => {
      if (console.error("Failed to fetch org release count", error), !state) throw error;
      return of(state);
    }), switchMap$1((nextState) => (latestFetchState.next(nextState), timer(STATE_TTL_MS).subscribe(() => {
      staleFlag$.next(!0), activeReleaseCountAtFetch.next(null);
    }), of(nextState))))) : of(state)))
  };
}
const useOrgActiveReleaseCount = () => {
  const $ = c(7), resourceCache = useResourceCache(), {
    data: activeReleases
  } = useActiveReleases();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "v2025-02-19"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0), activeReleasesCount = activeReleases?.length || 0;
  let t1;
  $[1] !== activeReleasesCount ? (t1 = {
    activeReleasesCount
  }, $[1] = activeReleasesCount, $[2] = t1) : t1 = $[2];
  const count2 = t1;
  let releaseLimitsStore;
  return $[3] !== client || $[4] !== count2 || $[5] !== resourceCache ? (releaseLimitsStore = resourceCache.get({
    dependencies: [client, count2],
    namespace: ORG_ACTIVE_RELEASE_COUNT_RESOURCE_CACHE_NAMESPACE
  }) || createOrgActiveReleaseCountStore(client, count2.activeReleasesCount), resourceCache.set({
    namespace: ORG_ACTIVE_RELEASE_COUNT_RESOURCE_CACHE_NAMESPACE,
    value: releaseLimitsStore,
    dependencies: [client, count2]
  }), $[3] = client, $[4] = count2, $[5] = resourceCache, $[6] = releaseLimitsStore) : releaseLimitsStore = $[6], releaseLimitsStore;
}, RELEASE_LIMITS_RESOURCE_CACHE_NAMESPACE = "ReleaseLimits";
function createReleaseLimitsStore(client) {
  return {
    releaseLimits$: fetchReleaseLimits(client, "releaseLimits").pipe(map$1((data) => ({
      datasetReleaseLimit: data.datasetReleaseLimit,
      orgActiveReleaseLimit: data.orgActiveReleaseLimit
    })), shareReplay$1(1), catchError$1((error) => (console.error("Failed to fetch release limits", error), of(null))))
  };
}
const useReleaseLimits = () => {
  const $ = c(4), resourceCache = useResourceCache();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "v2025-02-19"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0);
  let releaseLimitsStore;
  return $[1] !== client || $[2] !== resourceCache ? (releaseLimitsStore = resourceCache.get({
    dependencies: [client],
    namespace: RELEASE_LIMITS_RESOURCE_CACHE_NAMESPACE
  }) || createReleaseLimitsStore(client), resourceCache.set({
    namespace: RELEASE_LIMITS_RESOURCE_CACHE_NAMESPACE,
    value: releaseLimitsStore,
    dependencies: [client]
  }), $[1] = client, $[2] = resourceCache, $[3] = releaseLimitsStore) : releaseLimitsStore = $[3], releaseLimitsStore;
};
class StudioReleaseLimitExceededError extends Error {
  constructor() {
    super("StudioReleaseLimitExceeded"), this.name = "StudioReleaseLimitExceededError", this.details = {
      type: "releaseLimitExceededError"
    };
  }
}
function ReleasesUpsellProvider(props2) {
  const $ = c(47), [upsellDialogOpen, setUpsellDialogOpen] = useState(!1), {
    data: allActiveReleases
  } = useActiveReleases(), {
    enabled: isReleasesFeatureEnabled
  } = useFeatureEnabled(FEATURES.contentReleases);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    dataUri: "/journey/content-releases",
    feature: "content-releases"
  }, $[0] = t0) : t0 = $[0];
  const {
    upsellData,
    telemetryLogs,
    hasError
  } = useUpsellData(t0), toast = useToast(), {
    t
  } = useTranslation();
  let t1;
  $[1] !== allActiveReleases ? (t1 = allActiveReleases.filter(_temp$29), $[1] = allActiveReleases, $[2] = t1) : t1 = $[2];
  const meteredActiveReleases = t1;
  let t2;
  bb0: {
    if (!isReleasesFeatureEnabled) {
      t2 = "upsell";
      break bb0;
    }
    t2 = "default";
  }
  const mode = t2;
  let t3;
  $[3] !== telemetryLogs ? (t3 = () => {
    telemetryLogs.dialogPrimaryClicked();
  }, $[3] = telemetryLogs, $[4] = t3) : t3 = $[4];
  const handlePrimaryButtonClick = t3;
  let t4;
  $[5] !== telemetryLogs ? (t4 = () => {
    telemetryLogs.dialogSecondaryClicked();
  }, $[5] = telemetryLogs, $[6] = t4) : t4 = $[6];
  const handleSecondaryButtonClick = t4;
  let t5;
  $[7] !== telemetryLogs ? (t5 = () => {
    setUpsellDialogOpen(!1), telemetryLogs.dialogDismissed();
  }, $[7] = telemetryLogs, $[8] = t5) : t5 = $[8];
  const handleClose = t5, [releaseLimit, setReleaseLimit] = useState(null), [showMisconfigurationDialog, setShowMisconfigurationDialog] = useState(!1);
  let t6;
  $[9] !== hasError || $[10] !== t || $[11] !== telemetryLogs || $[12] !== toast ? (t6 = (t72) => {
    const source = t72 === void 0 ? "navbar" : t72;
    if (hasError) {
      toast.push({
        status: "error",
        title: t("errors.unable-to-perform-action"),
        closable: !0
      });
      return;
    }
    setUpsellDialogOpen(!0), telemetryLogs.dialogViewed(source);
  }, $[9] = hasError, $[10] = t, $[11] = telemetryLogs, $[12] = toast, $[13] = t6) : t6 = $[13];
  const handleOpenDialog = t6, {
    releaseLimits$
  } = useReleaseLimits(), {
    orgActiveReleaseCount$
  } = useOrgActiveReleaseCount();
  let t7;
  $[14] !== allActiveReleases.length || $[15] !== handleOpenDialog || $[16] !== meteredActiveReleases.length || $[17] !== mode || $[18] !== orgActiveReleaseCount$ || $[19] !== releaseLimits$ ? (t7 = async (cb, t82, whenResolved) => {
    const throwError2 = t82 === void 0 ? !1 : t82, doUpsell = () => {
      if (handleOpenDialog(), throwError2)
        throw new StudioReleaseLimitExceededError();
      return !1;
    };
    if (mode === "upsell")
      return whenResolved?.(!1), doUpsell();
    const result = await (async () => {
      try {
        return await Promise.all([firstValueFrom(orgActiveReleaseCount$), firstValueFrom(releaseLimits$.pipe(tap$1((limit2) => setReleaseLimit(limit2?.orgActiveReleaseLimit || null))))]);
      } catch (t92) {
        return console.error("Error fetching release limits and org count for upsell:", t92), null;
      }
    })();
    if (result === null)
      return whenResolved?.(!0), cb();
    const [orgMeteredActiveReleaseCount, releaseLimits] = result;
    if (releaseLimits === null || orgMeteredActiveReleaseCount === null)
      return whenResolved?.(!0), cb();
    const {
      orgActiveReleaseLimit,
      datasetReleaseLimit
    } = releaseLimits;
    if (orgActiveReleaseLimit === 0) {
      if (whenResolved?.(!1), setShowMisconfigurationDialog(!0), throwError2)
        throw new StudioReleaseLimitExceededError();
      return !1;
    }
    if (orgMeteredActiveReleaseCount === null)
      return whenResolved?.(!0), cb();
    const meteredActiveReleaseCount = meteredActiveReleases?.length || 0, isCurrentDatasetAtAboveDatasetLimit = (allActiveReleases?.length || 0) >= datasetReleaseLimit, isCurrentDatasetAtAboveOrgLimit = orgActiveReleaseLimit !== null && meteredActiveReleaseCount >= orgActiveReleaseLimit, isOrgAtAboveOrgLimit = orgActiveReleaseLimit !== null && orgMeteredActiveReleaseCount >= orgActiveReleaseLimit;
    return isCurrentDatasetAtAboveDatasetLimit || isCurrentDatasetAtAboveOrgLimit || isOrgAtAboveOrgLimit ? (whenResolved?.(!1), doUpsell()) : (whenResolved?.(!0), cb());
  }, $[14] = allActiveReleases.length, $[15] = handleOpenDialog, $[16] = meteredActiveReleases.length, $[17] = mode, $[18] = orgActiveReleaseCount$, $[19] = releaseLimits$, $[20] = t7) : t7 = $[20];
  const guardWithReleaseLimitUpsell = t7;
  let t8;
  $[21] !== handleOpenDialog ? (t8 = (limit_0) => {
    setReleaseLimit(limit_0), handleOpenDialog();
  }, $[21] = handleOpenDialog, $[22] = t8) : t8 = $[22];
  const onReleaseLimitReached = t8;
  let t9;
  $[23] !== guardWithReleaseLimitUpsell || $[24] !== handleOpenDialog || $[25] !== mode || $[26] !== onReleaseLimitReached || $[27] !== telemetryLogs || $[28] !== upsellData || $[29] !== upsellDialogOpen ? (t9 = {
    mode,
    upsellDialogOpen,
    guardWithReleaseLimitUpsell,
    onReleaseLimitReached,
    telemetryLogs,
    upsellData,
    handleOpenDialog
  }, $[23] = guardWithReleaseLimitUpsell, $[24] = handleOpenDialog, $[25] = mode, $[26] = onReleaseLimitReached, $[27] = telemetryLogs, $[28] = upsellData, $[29] = upsellDialogOpen, $[30] = t9) : t9 = $[30];
  const ctxValue = t9;
  let t10;
  $[31] !== releaseLimit ? (t10 = releaseLimit === null ? void 0 : {
    releaseLimit
  }, $[31] = releaseLimit, $[32] = t10) : t10 = $[32];
  const interpolation = t10;
  let t11;
  $[33] !== handleClose || $[34] !== handlePrimaryButtonClick || $[35] !== handleSecondaryButtonClick || $[36] !== interpolation || $[37] !== upsellData || $[38] !== upsellDialogOpen ? (t11 = {
    data: upsellData,
    open: upsellDialogOpen,
    interpolation,
    onClose: handleClose,
    onPrimaryClick: handlePrimaryButtonClick,
    onSecondaryClick: handleSecondaryButtonClick
  }, $[33] = handleClose, $[34] = handlePrimaryButtonClick, $[35] = handleSecondaryButtonClick, $[36] = interpolation, $[37] = upsellData, $[38] = upsellDialogOpen, $[39] = t11) : t11 = $[39];
  const dialogProps = t11;
  let t12;
  $[40] !== dialogProps || $[41] !== showMisconfigurationDialog ? (t12 = showMisconfigurationDialog ? /* @__PURE__ */ jsx(ReleaseLimitsMisconfigurationDialog, { onClose: () => setShowMisconfigurationDialog(!1) }) : /* @__PURE__ */ jsx(UpsellDialog, { ...dialogProps }), $[40] = dialogProps, $[41] = showMisconfigurationDialog, $[42] = t12) : t12 = $[42];
  let t13;
  return $[43] !== ctxValue || $[44] !== props2.children || $[45] !== t12 ? (t13 = /* @__PURE__ */ jsxs(ReleasesUpsellContext.Provider, { value: ctxValue, children: [
    props2.children,
    t12
  ] }), $[43] = ctxValue, $[44] = props2.children, $[45] = t12, $[46] = t13) : t13 = $[46], t13;
}
function _temp$29(release) {
  return !isCardinalityOneRelease(release);
}
function ReleasesStudioLayout(props2) {
  const $ = c(6);
  if (!useReleasesToolAvailable()) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  $[2] !== props2 ? (t0 = props2.renderDefault(props2), $[2] = props2, $[3] = t0) : t0 = $[3];
  let t1;
  return $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(ReleasesUpsellProvider, { children: /* @__PURE__ */ jsx(ReleasesMetadataProvider, { children: t0 }) }), $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}
const GROUP_SEARCH_PARAM_KEY = "group", RELEASE_NOT_FOUND_SEARCH_PARAM_KEY = "releaseNotFound", DATE_SEARCH_PARAM_KEY = "date", VIEW_SEARCH_PARAM_KEY = "view", DATE_SEARCH_PARAM_VALUE_FORMAT = "yyyy-MM-dd";
function getInitialReleaseNotFound(router) {
  return new URLSearchParams(router.state._searchParams).get(RELEASE_NOT_FOUND_SEARCH_PARAM_KEY) === "true";
}
const getInitialFilterDate = (router) => () => {
  const activeFilterDate = new URLSearchParams(router.state._searchParams).get(DATE_SEARCH_PARAM_KEY);
  return activeFilterDate ? new Date(activeFilterDate) : void 0;
}, getInitialReleaseGroupMode = (router) => () => {
  const activeGroupMode = new URLSearchParams(router.state._searchParams).get(GROUP_SEARCH_PARAM_KEY);
  return activeGroupMode === "archived" ? "archived" : activeGroupMode === "paused" ? "paused" : "active";
}, getInitialCardinalityView = ({
  router,
  isScheduledDraftsEnabled,
  isReleasesEnabled
}) => () => isScheduledDraftsEnabled ? isReleasesEnabled ? new URLSearchParams(router.state._searchParams).get(VIEW_SEARCH_PARAM_KEY) === "drafts" ? "drafts" : "releases" : "drafts" : "releases", buildReleasesSearchParams = (releaseFilterDate, releaseGroupMode, cardinalityView) => {
  const params = [];
  return releaseFilterDate ? params.push([DATE_SEARCH_PARAM_KEY, format(releaseFilterDate, DATE_SEARCH_PARAM_VALUE_FORMAT)]) : releaseGroupMode !== "active" && params.push([GROUP_SEARCH_PARAM_KEY, releaseGroupMode]), cardinalityView === "drafts" && params.push([VIEW_SEARCH_PARAM_KEY, "drafts"]), params;
}, INITIAL_VALUE$1 = {
  events: [],
  nextCursor: "",
  loading: !0,
  error: null
};
function removeDupes$1(prev, next) {
  const noDupes = [...prev, ...next].reduce((acc, event) => acc.has(event.id) ? acc : acc.set(event.id, event), /* @__PURE__ */ new Map());
  return Array.from(noDupes.values());
}
function addEventData(event) {
  return {
    ...event,
    id: `${event.timestamp}-${event.type}`,
    origin: "events"
  };
}
function getReleaseActivityEvents({
  client,
  releaseId
}) {
  const refetchEventsTrigger$ = new BehaviorSubject({
    cursor: null,
    origin: "initial"
  }), fetchEvents = ({
    limit: limit2,
    nextCursor: nextCursor2
  }) => {
    const params = new URLSearchParams({
      limit: limit2.toString()
    });
    return nextCursor2 && params.append("nextCursor", nextCursor2), client.observable.request({
      url: `/data/history/${client.config().dataset}/events/releases/${getReleaseIdFromReleaseDocumentId(releaseId)}?${params.toString()}`,
      tag: "get-release-events"
    }).pipe(map((response) => ({
      events: response.events.map(addEventData),
      nextCursor: response.nextCursor,
      loading: !1,
      error: null
    })), catchError((error) => (console.error(error), [{
      events: [],
      nextCursor: "",
      loading: !1,
      error
    }])));
  };
  let nextCursor = "";
  return {
    events$: refetchEventsTrigger$.pipe(switchMap(({
      cursor,
      origin
    }) => fetchEvents({
      nextCursor: cursor,
      limit: origin === "reload" ? 10 : 100
    }).pipe(map((response) => ({
      ...response,
      origin
    })), startWith({
      events: [],
      nextCursor: "",
      loading: !0,
      error: null,
      origin
    }))), scan((prev, next) => ({
      events: removeDupes$1(prev.events, next.events).sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()),
      // If we are reloading, we should keep the cursor as it was before.
      nextCursor: next.origin === "reload" ? prev.nextCursor : next.nextCursor,
      loading: next.loading,
      error: next.error
    }), INITIAL_VALUE$1), tap((response) => {
      nextCursor = response.nextCursor;
    }), shareReplay(1)),
    /**
     * Loads new events for the release, fetching the latest events from the API.
     */
    reloadEvents: () => refetchEventsTrigger$.next({
      cursor: null,
      origin: "reload"
    }),
    /**
     * Loads more events for the release, fetching the next batch of events from the API.
     */
    loadMore: () => {
      const lastCursorUsed = refetchEventsTrigger$.getValue().cursor;
      nextCursor && lastCursorUsed !== nextCursor && refetchEventsTrigger$.next({
        origin: "loadMore",
        cursor: nextCursor
      });
    }
  };
}
function buildReleaseEditEvents(transactions, release) {
  if (release._rev !== transactions[0]?.id)
    return console.error("Some transactions are missing, cannot calculate the edit events"), [];
  const releaseEditEvents = [];
  let currentDocument = release;
  for (const transaction of transactions) {
    const effect = transaction.effects[release._id];
    if (!effect) continue;
    const before = applyMendozaPatch(currentDocument, effect.revert, currentDocument._rev), changed = {};
    before?.state !== currentDocument.state && currentDocument.state === "archived" && releaseEditEvents.push({
      type: "archiveRelease",
      timestamp: transaction.timestamp,
      author: transaction.author,
      releaseName: getReleaseIdFromReleaseDocumentId(release._id),
      id: transaction.id,
      origin: "translog"
    }), before?.state !== currentDocument.state && currentDocument.state === "published" && releaseEditEvents.push({
      type: "publishRelease",
      timestamp: transaction.timestamp,
      author: transaction.author,
      releaseName: getReleaseIdFromReleaseDocumentId(release._id),
      id: transaction.id,
      origin: "translog"
    }), before?.state === "unarchiving" && currentDocument.state === "active" && releaseEditEvents.push({
      type: "unarchiveRelease",
      timestamp: transaction.timestamp,
      author: transaction.author,
      releaseName: getReleaseIdFromReleaseDocumentId(release._id),
      id: transaction.id,
      origin: "translog"
    }), before?.metadata.releaseType !== currentDocument.metadata.releaseType && (changed.releaseType = currentDocument.metadata.releaseType), before?.metadata.intendedPublishAt !== currentDocument.metadata.intendedPublishAt && (changed.intendedPublishDate = currentDocument.metadata.intendedPublishAt), Object.values(changed).length >= 1 && releaseEditEvents.push({
      type: before ? "editRelease" : "createRelease",
      origin: "translog",
      author: transaction.author,
      change: changed,
      id: transaction.id,
      timestamp: transaction.timestamp,
      releaseName: getReleaseIdFromReleaseDocumentId(release._id)
    }), before && (currentDocument = before);
  }
  return releaseEditEvents;
}
const TRANSLOG_ENTRY_LIMIT = 100, documentTransactionsCache = /* @__PURE__ */ Object.create(null);
function removeDupes(newTransactions, oldTransactions) {
  const seen = /* @__PURE__ */ new Set();
  return newTransactions.concat(oldTransactions).filter((transaction) => seen.has(transaction.id) ? !1 : (seen.add(transaction.id), !0));
}
function getReleaseTransactions({
  documentId,
  client,
  toTransaction
}) {
  const cacheKey = `${documentId}`, cachedTransactions = documentTransactionsCache[cacheKey] || [];
  if (cachedTransactions.length > 0 && cachedTransactions[0].id === toTransaction)
    return of(cachedTransactions);
  function fetchLogs(options) {
    return from(getTransactionsLogs(client, documentId, {
      tag: "sanity.studio.release.history",
      effectFormat: "mendoza",
      limit: TRANSLOG_ENTRY_LIMIT,
      reverse: !0,
      fromTransaction: options.fromTransaction,
      toTransaction: options.toTransaction
    }));
  }
  return fetchLogs({
    fromTransaction: cachedTransactions[0]?.id,
    toTransaction
  }).pipe(
    expand((response) => response.length === TRANSLOG_ENTRY_LIMIT ? fetchLogs({
      fromTransaction: void 0,
      toTransaction: response[response.length - 1].id
    }) : of()),
    // Combine all batches of transactions into a single array
    reduce$1((allTransactions, batch) => allTransactions.concat(batch), [])
  ).pipe(map$1((transactions) => removeDupes(transactions, cachedTransactions)), tap$1((transactions) => {
    documentTransactionsCache[cacheKey] = transactions;
  }));
}
const INITIAL_VALUE = {
  editEvents: [],
  loading: !0,
  error: null
};
function getReleaseEditEvents({
  client,
  observeDocument$
}) {
  return observeDocument$.pipe(filter$1(Boolean), distinctUntilChanged$1((prev, next) => prev._rev === next._rev), switchMap$1((release) => getReleaseTransactions({
    client,
    documentId: release._id,
    toTransaction: release._rev
  }).pipe(map$1((transactions) => ({
    editEvents: buildReleaseEditEvents(transactions, release),
    loading: !1,
    error: null
  })), catchError$1((error) => (console.error(error), of({
    editEvents: [],
    loading: !1,
    error
  }))))), startWith$1(INITIAL_VALUE), scan$1((acc, current) => {
    const editEvents = current.loading ? acc.editEvents : current.editEvents;
    return {
      ...current,
      editEvents
    };
  }, INITIAL_VALUE), shareReplay$1(1));
}
const isCreateReleaseEvent = (event) => event.type === "createRelease", isScheduleReleaseEvent = (event) => event.type === "scheduleRelease", isPublishReleaseEvent = (event) => event.type === "publishRelease", isArchiveReleaseEvent = (event) => event.type === "archiveRelease", isUnarchiveReleaseEvent = (event) => event.type === "unarchiveRelease", isAddDocumentToReleaseEvent = (event) => event.type === "addDocumentToRelease", isDiscardDocumentFromReleaseEvent = (event) => event.type === "discardDocumentFromRelease", isEditReleaseEvent = (event) => event.type === "editRelease", isTranslogEvent = (event) => event.origin === "translog", isEventsAPIEvent = (event) => event.origin === "events", EVENTS_INITIAL_VALUE = {
  events: [],
  hasMore: !1,
  error: null,
  loading: !0
}, notEnabledActivityEvents = {
  events$: of({
    events: [],
    nextCursor: "",
    loading: !1,
    error: null
  }),
  reloadEvents: () => {
  },
  loadMore: () => {
  }
};
function getReleaseEvents({
  client,
  releaseId,
  releasesState$,
  documentPreviewStore,
  eventsAPIEnabled
}) {
  const observeDocument$ = documentPreviewStore.unstable_observeDocument(releaseId, {
    apiVersion: RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion
  }), editEvents$ = getReleaseEditEvents({
    client,
    observeDocument$
  }), releaseRev$ = releasesState$.pipe(
    map$1((state) => state.releases.get(releaseId)?._rev),
    filter$1(Boolean),
    distinctUntilChanged$1(),
    // Emit only when rev changes, after first non null value.
    skip$1(1)
  ), activityEvents = eventsAPIEnabled ? getReleaseActivityEvents({
    client,
    releaseId
  }) : notEnabledActivityEvents, documentsCount$ = eventsAPIEnabled ? of(0) : documentPreviewStore.unstable_observeDocumentIdSet("sanity::partOfRelease($releaseId)", {
    releaseId: getReleaseIdFromReleaseDocumentId(releaseId)
  }, {
    apiVersion: RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion
  }).pipe(
    filter$1(({
      status
    }) => status === "connected"),
    map$1(({
      documentIds
    }) => documentIds.length),
    distinctUntilChanged$1(),
    // Emit only when count changes, after first non null value.
    skip$1(1)
  ), sideEffects$ = merge(releaseRev$, documentsCount$).pipe(tap$1(() => {
    activityEvents.reloadEvents();
  }), startWith$1(null));
  return {
    events$: combineLatest([activityEvents.events$, editEvents$, sideEffects$]).pipe(map$1(([activity, edit]) => {
      const events2 = [...activity.events, ...edit.editEvents].sort((a, b) => Date.parse(b.timestamp) - Date.parse(a.timestamp)).reduce((acc, event) => {
        if (isCreateReleaseEvent(event)) {
          const creationEvent = acc.find(isCreateReleaseEvent);
          creationEvent ? isEventsAPIEvent(creationEvent) && isTranslogEvent(event) && (acc[acc.indexOf(creationEvent)] = event) : acc.push(event);
        } else acc.push(event);
        return acc;
      }, []);
      return {
        events: deduplicateEvents(events2),
        hasMore: !!activity.nextCursor,
        error: activity.error || edit.error,
        loading: activity.loading || edit.loading
      };
    })),
    loadMore: activityEvents.loadMore
  };
}
const deduplicateEvents = (events2) => events2.filter((event, index) => {
  const nextEvent = events2[index + 1];
  return nextEvent ? !(event.type === nextEvent.type && areTheSameDate(event.timestamp, nextEvent.timestamp)) : !0;
});
function areTheSameDate(date1, date2) {
  const time1 = new Date(date1).getTime(), time2 = new Date(date2).getTime();
  return Math.abs(time1 - time2) <= 1e3;
}
function useReleaseEvents(releaseId) {
  const $ = c(12), client = useClient(RELEASES_STUDIO_CLIENT_OPTIONS), documentPreviewStore = useDocumentPreviewStore(), {
    state$: releasesState$
  } = useReleasesStore(), eventsAPIEnabled = !!useSource().beta?.eventsAPI?.releases;
  let t0;
  $[0] !== client || $[1] !== documentPreviewStore || $[2] !== eventsAPIEnabled || $[3] !== releaseId || $[4] !== releasesState$ ? (t0 = getReleaseEvents({
    client,
    releaseId: getReleaseDocumentIdFromReleaseId(releaseId),
    releasesState$,
    documentPreviewStore,
    eventsAPIEnabled
  }), $[0] = client, $[1] = documentPreviewStore, $[2] = eventsAPIEnabled, $[3] = releaseId, $[4] = releasesState$, $[5] = t0) : t0 = $[5];
  const releaseEvents = t0, events2 = useObservable(releaseEvents.events$, EVENTS_INITIAL_VALUE);
  let t1;
  return $[6] !== events2.error || $[7] !== events2.events || $[8] !== events2.hasMore || $[9] !== events2.loading || $[10] !== releaseEvents.loadMore ? (t1 = {
    events: events2.events,
    hasMore: events2.hasMore,
    loading: events2.loading,
    error: events2.error,
    loadMore: releaseEvents.loadMore
  }, $[6] = events2.error, $[7] = events2.events, $[8] = events2.hasMore, $[9] = events2.loading, $[10] = releaseEvents.loadMore, $[11] = t1) : t1 = $[11], t1;
}
const Root$f = styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1fzvw9n-0"
})`position:absolute;top:0;bottom:0;width:9px;z-index:201;cursor:ew-resize;${({
  position
}) => position === "right" ? css`
          right: -4px;
        ` : css`
          left: -4px;
        `} & > span:nth-child(1){display:block;border-left:1px solid var(--card-border-color);position:absolute;top:0;${({
  position
}) => position === "right" ? css`
            right: 4px;
          ` : css`
            left: 4px;
          `} bottom:0;transition:opacity 200ms;}& > span:nth-child(2){display:block;position:absolute;top:0;${({
  position
}) => position === "right" ? css`
            right: 0px;
          ` : css`
            left: 0px;
          `} width:9px;bottom:0;background-color:var(--card-border-color);opacity:0;transition:opacity 150ms;}@media (hover:hover){&:hover > span:nth-child(2){opacity:0.2;}}`;
function Resizer(props2) {
  const $ = c(8), {
    onResize,
    onResizeStart,
    position
  } = props2, mouseXRef = useRef(0);
  let t0;
  $[0] !== onResize || $[1] !== onResizeStart ? (t0 = (event) => {
    event.preventDefault(), mouseXRef.current = event.pageX, onResizeStart();
    const handleMouseMove = (e) => {
      e.preventDefault(), onResize(mouseXRef.current - e.pageX);
    }, handleMouseUp = () => {
      window.removeEventListener("mousemove", handleMouseMove), window.removeEventListener("mouseup", handleMouseUp);
    };
    window.addEventListener("mousemove", handleMouseMove), window.addEventListener("mouseup", handleMouseUp);
  }, $[0] = onResize, $[1] = onResizeStart, $[2] = t0) : t0 = $[2];
  const handleMouseDown = t0;
  let t1, t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx("span", {}), t2 = /* @__PURE__ */ jsx("span", {}), $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]);
  let t3;
  return $[5] !== handleMouseDown || $[6] !== position ? (t3 = /* @__PURE__ */ jsxs(Root$f, { onMouseDown: handleMouseDown, position, children: [
    t1,
    t2
  ] }), $[5] = handleMouseDown, $[6] = position, $[7] = t3) : t3 = $[7], t3;
}
const Root$e = styled(Box).withConfig({
  displayName: "Root",
  componentId: "sc-3qhj31-0"
})`position:relative;flex:1;padding-left:1px;`;
function Resizable(props2) {
  const $ = c(33);
  let children, forwardedAs, initialWidth, maxWidth, minWidth, restProps, t0;
  $[0] !== props2 ? ({
    as: forwardedAs,
    children,
    minWidth,
    maxWidth,
    initialWidth,
    resizerPosition: t0,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = forwardedAs, $[3] = initialWidth, $[4] = maxWidth, $[5] = minWidth, $[6] = restProps, $[7] = t0) : (children = $[1], forwardedAs = $[2], initialWidth = $[3], maxWidth = $[4], minWidth = $[5], restProps = $[6], t0 = $[7]);
  const resizerPosition = t0 === void 0 ? "right" : t0, [element, setElement] = useState(null), elementWidthRef = useRef(void 0), [targetWidth, setTargetWidth] = useState(initialWidth);
  let t1;
  $[8] !== element?.offsetWidth ? (t1 = () => {
    elementWidthRef.current = element?.offsetWidth;
  }, $[8] = element?.offsetWidth, $[9] = t1) : t1 = $[9];
  const handleResizeStart = t1;
  let t2;
  $[10] !== maxWidth || $[11] !== minWidth || $[12] !== resizerPosition ? (t2 = (deltaX) => {
    const w = elementWidthRef.current;
    w && setTargetWidth(Math.min(Math.max(resizerPosition === "right" ? w - deltaX : w + deltaX, minWidth), maxWidth));
  }, $[10] = maxWidth, $[11] = minWidth, $[12] = resizerPosition, $[13] = t2) : t2 = $[13];
  const handleResize = t2;
  let t3;
  $[14] !== maxWidth || $[15] !== minWidth || $[16] !== targetWidth ? (t3 = targetWidth ? {
    flex: "none",
    width: targetWidth
  } : {
    minWidth,
    maxWidth
  }, $[14] = maxWidth, $[15] = minWidth, $[16] = targetWidth, $[17] = t3) : t3 = $[17];
  const style = t3;
  let t4;
  $[18] !== handleResize || $[19] !== handleResizeStart || $[20] !== resizerPosition ? (t4 = resizerPosition === "left" && /* @__PURE__ */ jsx(Resizer, { onResize: handleResize, onResizeStart: handleResizeStart, position: "left" }), $[18] = handleResize, $[19] = handleResizeStart, $[20] = resizerPosition, $[21] = t4) : t4 = $[21];
  let t5;
  $[22] !== handleResize || $[23] !== handleResizeStart || $[24] !== resizerPosition ? (t5 = resizerPosition === "right" && /* @__PURE__ */ jsx(Resizer, { onResize: handleResize, onResizeStart: handleResizeStart, position: "right" }), $[22] = handleResize, $[23] = handleResizeStart, $[24] = resizerPosition, $[25] = t5) : t5 = $[25];
  let t6;
  return $[26] !== children || $[27] !== forwardedAs || $[28] !== restProps || $[29] !== style || $[30] !== t4 || $[31] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Root$e, { as: forwardedAs, ...restProps, ref: setElement, style, children: [
    t4,
    children,
    t5
  ] }), $[26] = children, $[27] = forwardedAs, $[28] = restProps, $[29] = style, $[30] = t4, $[31] = t5, $[32] = t6) : t6 = $[32], t6;
}
function RelativeTime(t0) {
  const $ = c(10);
  let options, time;
  $[0] !== t0 ? ({
    time,
    ...options
  } = t0, $[0] = t0, $[1] = options, $[2] = time) : (options = $[1], time = $[2]);
  let t1;
  $[3] !== time ? (t1 = time instanceof Date ? time : new Date(time), $[3] = time, $[4] = t1) : t1 = $[4];
  const timestamp = t1, timeAgo = useRelativeTime(timestamp, options);
  let t2;
  $[5] !== timestamp ? (t2 = timestamp.toISOString(), $[5] = timestamp, $[6] = t2) : t2 = $[6];
  let t3;
  return $[7] !== t2 || $[8] !== timeAgo ? (t3 = /* @__PURE__ */ jsx("time", { dateTime: t2, title: timeAgo, children: timeAgo }), $[7] = t2, $[8] = timeAgo, $[9] = t3) : t3 = $[9], t3;
}
function useDocumentPreviewValues(options) {
  const $ = c(21);
  let t0;
  $[0] !== options ? (t0 = options || {}, $[0] = options, $[1] = t0) : t0 = $[1];
  const {
    documentId,
    documentType,
    perspectiveStack: perspectiveStackFromOptions
  } = t0, t1 = useSchema();
  let t2;
  $[2] !== documentType || $[3] !== t1 ? (t2 = t1.get(documentType), $[2] = documentType, $[3] = t1, $[4] = t2) : t2 = $[4];
  const schemaType = t2, documentPreviewStore = useDocumentPreviewStore(), {
    perspectiveStack
  } = usePerspective();
  let t3;
  bb0: {
    if (!documentId || !schemaType) {
      let t43;
      $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t43 = of(null), $[5] = t43) : t43 = $[5], t3 = t43;
      break bb0;
    }
    const t42 = perspectiveStackFromOptions ?? perspectiveStack;
    let t52;
    $[6] !== documentId || $[7] !== documentPreviewStore || $[8] !== schemaType || $[9] !== t42 ? (t52 = getPreviewStateObservable$1(documentPreviewStore, schemaType, documentId, t42), $[6] = documentId, $[7] = documentPreviewStore, $[8] = schemaType, $[9] = t42, $[10] = t52) : t52 = $[10], t3 = t52;
  }
  const previewState = useObservable(t3), isLoading = previewState?.isLoading ?? !0;
  let t4;
  $[11] !== previewState ? (t4 = previewState || {}, $[11] = previewState, $[12] = t4) : t4 = $[12];
  const {
    snapshot: snapshot2
  } = t4, documentTitle = snapshot2?.title, subtitle = snapshot2?.subtitle, description = snapshot2?.description, media = snapshot2?.media;
  let t5;
  $[13] !== description || $[14] !== documentTitle || $[15] !== media || $[16] !== subtitle ? (t5 = {
    title: documentTitle,
    subtitle,
    media,
    description
  }, $[13] = description, $[14] = documentTitle, $[15] = media, $[16] = subtitle, $[17] = t5) : t5 = $[17];
  let t6;
  return $[18] !== isLoading || $[19] !== t5 ? (t6 = {
    isLoading,
    value: t5
  }, $[18] = isLoading, $[19] = t5, $[20] = t6) : t6 = $[20], t6;
}
const isArchivedRelease = (releaseState) => releaseState === "archived" || releaseState === "archiving" || releaseState === "unarchiving";
function ReleaseDocumentPreview(t0) {
  const $ = c(43), {
    documentId,
    documentTypeName,
    releaseId,
    releaseState,
    isCardinalityOneRelease: isCardinalityOneRelease2,
    documentRevision,
    layout,
    isGoingToBePublished: t1
  } = t0, isGoingToBePublished = t1 === void 0 ? !1 : t1, documentPresence = useDocumentPresence(documentId);
  let t2;
  bb0: {
    if (isCardinalityOneRelease2) {
      let t33;
      $[0] !== releaseId ? (t33 = getReleaseIdFromReleaseDocumentId(releaseId), $[0] = releaseId, $[1] = t33) : t33 = $[1];
      let t42;
      $[2] !== t33 ? (t42 = {
        scheduledDraft: t33
      }, $[2] = t33, $[3] = t42) : t42 = $[3], t2 = t42;
      break bb0;
    }
    if (releaseState === "published") {
      let t33;
      $[4] !== releaseId ? (t33 = getReleaseIdFromReleaseDocumentId(releaseId), $[4] = releaseId, $[5] = t33) : t33 = $[5];
      const t42 = `@release:${t33}`;
      let t52;
      $[6] !== t42 ? (t52 = {
        rev: t42,
        inspect: "sanity/structure/history"
      }, $[6] = t42, $[7] = t52) : t52 = $[7], t2 = t52;
      break bb0;
    }
    if (releaseState === "archived") {
      let t33;
      $[8] !== releaseId ? (t33 = getReleaseIdFromReleaseDocumentId(releaseId), $[8] = releaseId, $[9] = t33) : t33 = $[9];
      let t42;
      $[10] !== documentRevision || $[11] !== t33 ? (t42 = {
        rev: "@lastEdited",
        inspect: "sanity/structure/history",
        historyEvent: documentRevision,
        historyVersion: t33,
        archivedRelease: "true"
      }, $[10] = documentRevision, $[11] = t33, $[12] = t42) : t42 = $[12], t2 = t42;
      break bb0;
    }
    let t32;
    $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t32 = {}, $[13] = t32) : t32 = $[13], t2 = t32;
  }
  const intentParams = t2;
  let t3;
  $[14] !== documentId || $[15] !== documentTypeName || $[16] !== intentParams || $[17] !== isCardinalityOneRelease2 || $[18] !== releaseId || $[19] !== releaseState ? (t3 = forwardRef(function(linkProps, ref) {
    return /* @__PURE__ */ jsx(IntentLink, { ...linkProps, intent: "edit", params: {
      id: getPublishedId(documentId),
      type: documentTypeName,
      ...intentParams
    }, searchParams: isCardinalityOneRelease2 || isArchivedRelease(releaseState) ? void 0 : [["perspective", releaseState === "published" ? "published" : getReleaseIdFromReleaseDocumentId(releaseId)]], ref });
  }), $[14] = documentId, $[15] = documentTypeName, $[16] = intentParams, $[17] = isCardinalityOneRelease2, $[18] = releaseId, $[19] = releaseState, $[20] = t3) : t3 = $[20];
  const LinkComponent = t3;
  let t4;
  $[21] !== documentPresence ? (t4 = documentPresence?.length > 0 && /* @__PURE__ */ jsx(DocumentPreviewPresence, { presence: documentPresence }), $[21] = documentPresence, $[22] = t4) : t4 = $[22];
  const previewPresence = t4;
  let t5;
  $[23] !== documentId || $[24] !== isGoingToBePublished ? (t5 = isGoingToBePublished ? getPublishedId(documentId) : documentId, $[23] = documentId, $[24] = isGoingToBePublished, $[25] = t5) : t5 = $[25];
  let t6;
  $[26] !== isGoingToBePublished || $[27] !== releaseId ? (t6 = isGoingToBePublished ? [] : [getReleaseIdFromReleaseDocumentId(releaseId)], $[26] = isGoingToBePublished, $[27] = releaseId, $[28] = t6) : t6 = $[28];
  let t7;
  $[29] !== documentTypeName || $[30] !== t5 || $[31] !== t6 ? (t7 = {
    documentId: t5,
    documentType: documentTypeName,
    perspectiveStack: t6
  }, $[29] = documentTypeName, $[30] = t5, $[31] = t6, $[32] = t7) : t7 = $[32];
  const {
    isLoading: previewLoading,
    value: resolvedPreview
  } = useDocumentPreviewValues(t7);
  let t8;
  $[33] !== resolvedPreview ? (t8 = resolvedPreview || {}, $[33] = resolvedPreview, $[34] = t8) : t8 = $[34];
  let t9;
  $[35] !== layout || $[36] !== previewLoading || $[37] !== previewPresence || $[38] !== t8 ? (t9 = /* @__PURE__ */ jsx(SanityDefaultPreview, { ...t8, status: previewPresence, isPlaceholder: previewLoading, layout }), $[35] = layout, $[36] = previewLoading, $[37] = previewPresence, $[38] = t8, $[39] = t9) : t9 = $[39];
  let t10;
  return $[40] !== LinkComponent || $[41] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { tone: "inherit", as: LinkComponent, radius: 2, "data-as": "a", children: t9 }), $[40] = LinkComponent, $[41] = t9, $[42] = t10) : t10 = $[42], t10;
}
const StatusText = styled(Text$1).withConfig({
  displayName: "StatusText",
  componentId: "sc-1vmkaay-0"
})`strong{font-weight:500;color:var(--card-fg-color);}time{white-space:nowrap;}`, ACTIVITY_TEXT_118N = {
  addDocumentToRelease: "activity.event.add-document",
  archiveRelease: "activity.event.archive",
  createRelease: "activity.event.create",
  discardDocumentFromRelease: "activity.event.discard-document",
  publishRelease: "activity.event.publish",
  scheduleRelease: "activity.event.schedule",
  unarchiveRelease: "activity.event.unarchive",
  unscheduleRelease: "activity.event.unschedule",
  editRelease: "activity.event.edit"
}, ReleaseEventDocumentPreview = (t0) => {
  const $ = c(4), {
    event,
    releaseId
  } = t0;
  let t1;
  return $[0] !== event.documentId || $[1] !== event.documentType || $[2] !== releaseId ? (t1 = /* @__PURE__ */ jsx(Stack, { space: 2, children: /* @__PURE__ */ jsx(ReleaseDocumentPreview, { releaseId, documentId: event.documentId, documentTypeName: event.documentType, layout: "block" }) }), $[0] = event.documentId, $[1] = event.documentType, $[2] = releaseId, $[3] = t1) : t1 = $[3], t1;
}, ScheduleTarget = (t0) => {
  const $ = c(13), {
    children,
    event
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    dateStyle: "full",
    timeStyle: "medium"
  }, $[0] = t1) : t1 = $[0];
  const dateTimeFormat = useDateTimeFormat(t1), {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t2;
  bb0: {
    if (isEditReleaseEvent(event)) {
      if (event.change.releaseType === "asap") {
        let t33;
        $[1] !== t ? (t33 = t("activity.event.edit-time-asap"), $[1] = t, $[2] = t33) : t33 = $[2], t2 = t33;
        break bb0;
      }
      if (event.change.releaseType === "undecided") {
        let t33;
        $[3] !== t ? (t33 = t("activity.event.edit-time-undecided"), $[3] = t, $[4] = t33) : t33 = $[4], t2 = t33;
        break bb0;
      }
    }
    let dateString;
    if (isScheduleReleaseEvent(event) ? dateString = event.publishAt : isCreateReleaseEvent(event) ? dateString = event.change?.intendedPublishDate : isEditReleaseEvent(event) && (dateString = event.change.intendedPublishDate), !dateString) {
      t2 = null;
      break bb0;
    }
    let t32;
    $[5] !== dateString || $[6] !== dateTimeFormat ? (t32 = dateTimeFormat.format(new Date(dateString)), $[5] = dateString, $[6] = dateTimeFormat, $[7] = t32) : t32 = $[7], t2 = t32;
  }
  const formattedDate = t2;
  if (!formattedDate && isCreateReleaseEvent(event))
    return null;
  const t3 = formattedDate || "---";
  let t4;
  $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx("strong", { children: t3 }), $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== children || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsxs("span", { children: [
    children,
    " ",
    t4
  ] }), $[10] = children, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
}, FadeInCard = motion.create(Card), ReleaseActivityListItem = memo((t0) => {
  const $ = c(28), {
    event,
    releaseId,
    releaseTitle
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t1, t2, t3;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    opacity: 0
  }, t2 = {
    opacity: 1
  }, t3 = {
    type: "spring",
    bounce: 0,
    duration: 0.4
  }, $[0] = t1, $[1] = t2, $[2] = t3) : (t1 = $[0], t2 = $[1], t3 = $[2]);
  let t4;
  $[3] !== event.author ? (t4 = /* @__PURE__ */ jsx(UserAvatar, { user: event.author }), $[3] = event.author, $[4] = t4) : t4 = $[4];
  let t5;
  $[5] !== event ? (t5 = {
    ScheduleTarget: (t62) => {
      const {
        children
      } = t62;
      return /* @__PURE__ */ jsx(ScheduleTarget, { event, children });
    }
  }, $[5] = event, $[6] = t5) : t5 = $[6];
  let t6;
  $[7] !== releaseTitle ? (t6 = {
    releaseTitle
  }, $[7] = releaseTitle, $[8] = t6) : t6 = $[8];
  const t7 = ACTIVITY_TEXT_118N[event.type];
  let t8;
  $[9] !== t || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 ? (t8 = /* @__PURE__ */ jsx(Translate, { t, components: t5, values: t6, i18nKey: t7 }), $[9] = t, $[10] = t5, $[11] = t6, $[12] = t7, $[13] = t8) : t8 = $[13];
  let t9;
  $[14] !== event.timestamp ? (t9 = /* @__PURE__ */ jsx(RelativeTime, { time: event.timestamp, useTemporalPhrase: !0, minimal: !0 }), $[14] = event.timestamp, $[15] = t9) : t9 = $[15];
  let t10;
  $[16] !== t8 || $[17] !== t9 ? (t10 = /* @__PURE__ */ jsx(Flex, { gap: 2, paddingY: 2, children: /* @__PURE__ */ jsxs(StatusText, { muted: !0, size: 1, children: [
    t8,
    " ",
    "\xB7 ",
    t9
  ] }) }), $[16] = t8, $[17] = t9, $[18] = t10) : t10 = $[18];
  let t11;
  $[19] !== event || $[20] !== releaseId ? (t11 = isAddDocumentToReleaseEvent(event) || isDiscardDocumentFromReleaseEvent(event) ? /* @__PURE__ */ jsx(ReleaseEventDocumentPreview, { event, releaseId }) : null, $[19] = event, $[20] = releaseId, $[21] = t11) : t11 = $[21];
  let t12;
  $[22] !== t10 || $[23] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Stack, { flex: 1, children: [
    t10,
    t11
  ] }), $[22] = t10, $[23] = t11, $[24] = t12) : t12 = $[24];
  let t13;
  return $[25] !== t12 || $[26] !== t4 ? (t13 = /* @__PURE__ */ jsx(FadeInCard, { paddingX: 1, paddingTop: 1, paddingBottom: 2, overflow: "hidden", initial: t1, animate: t2, transition: t3, children: /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 2, children: [
    t4,
    t12
  ] }) }), $[25] = t12, $[26] = t4, $[27] = t13) : t13 = $[27], t13;
}, (prevProps, nextProps) => prevProps.event.id === nextProps.event.id && prevProps.releaseId === nextProps.releaseId);
ReleaseActivityListItem.displayName = "ReleaseActivityListItem";
const estimateSize = (event) => event ? isAddDocumentToReleaseEvent(event) || isDiscardDocumentFromReleaseEvent(event) ? 70 : 56 : 40, VirtualContainer = styled(Box).withConfig({
  displayName: "VirtualContainer",
  componentId: "sc-163h2xa-0"
})`height:100%;overflow:scroll;`, ReleaseActivityList = ({
  events: events2,
  releaseTitle,
  releaseId,
  hasMore,
  loadMore,
  isLoading
}) => {
  const virtualizerContainerRef = useRef(null), listEvents = useMemo(() => {
    if (!hasMore && !isLoading) return events2;
    const lastEventFromEventsAPI = [...events2].reverse().find(isEventsAPIEvent);
    if (!lastEventFromEventsAPI && !isLoading) return events2;
    if (!lastEventFromEventsAPI) return [];
    const lastEventDate = new Date(lastEventFromEventsAPI.timestamp);
    return events2.filter((event) => isTranslogEvent(event) ? new Date(event.timestamp) > lastEventDate : !0);
  }, [events2, hasMore, isLoading]), virtualizer = useVirtualizer({
    // If we have more events, or the events are loading, we add a loader row at the end
    count: hasMore || isLoading ? listEvents.length + 1 : listEvents.length,
    getScrollElement: () => virtualizerContainerRef.current,
    estimateSize: (i) => estimateSize(events2[i]),
    overscan: 10,
    paddingEnd: 24
  }), virtualItems = virtualizer.getVirtualItems();
  return useEffect(() => {
    const lastItem = virtualItems.at(-1);
    lastItem && lastItem.index >= listEvents.length - 1 && hasMore && loadMore();
  }, [listEvents.length, hasMore, loadMore, virtualItems]), /* @__PURE__ */ jsx(VirtualContainer, { id: "virtualizer-container", ref: virtualizerContainerRef, paddingX: 3, children: /* @__PURE__ */ jsx("div", { style: {
    height: `${virtualizer.getTotalSize()}px`,
    width: "100%",
    position: "relative"
  }, children: /* @__PURE__ */ jsx(AnimatePresence, { initial: !1, children: virtualizer.getVirtualItems().map((virtualRow) => {
    const event_0 = listEvents[virtualRow.index], isLoaderRow = !event_0;
    return /* @__PURE__ */ jsx("div", { "data-index": virtualRow.index, ref: virtualizer.measureElement, style: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      transform: `translateY(${virtualRow.start}px)`
    }, children: isLoaderRow ? /* @__PURE__ */ jsx(Box, { paddingY: 4, children: /* @__PURE__ */ jsx(LoadingBlock, { fill: !0 }) }) : /* @__PURE__ */ jsx(ReleaseActivityListItem, { event: event_0, releaseId, releaseTitle }) }, virtualRow.key);
  }) }) }) });
}, MotionFlex = motion.create(Flex), FillHeight = styled.div.withConfig({
  displayName: "FillHeight",
  componentId: "sc-cp4fmh-0"
})`--card-border-color:transparent;height:100%;display:flex;flex-direction:column;`;
function ReleaseDashboardActivityPanel(t0) {
  const $ = c(8), {
    events: events2,
    release,
    show
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation();
  let t1;
  $[0] !== events2 || $[1] !== release || $[2] !== show || $[3] !== t || $[4] !== tCore ? (t1 = show && /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(motion.div, { animate: {
    width: "auto",
    opacity: 1
  }, initial: {
    width: 0,
    opacity: 0
  }, exit: {
    width: 0,
    opacity: 0
  }, transition: {
    type: "spring",
    bounce: 0,
    duration: 0.2
  }, children: /* @__PURE__ */ jsx(Resizable, { as: FillHeight, minWidth: 320, maxWidth: 800, initialWidth: 320, resizerPosition: "left", style: {
    display: "flex",
    flexDirection: "column",
    flex: "none",
    maxHeight: "100%"
  }, children: /* @__PURE__ */ jsxs(MotionFlex, { flex: "none", height: "fill", direction: "column", children: [
    /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t("activity.panel.title") }) }),
    events2.error && !events2.events.length && /* @__PURE__ */ jsx(Card, { padding: 3, tone: "caution", children: /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 0, children: t("activity.panel.error") }) }) }),
    events2.loading && !events2.events.length && /* @__PURE__ */ jsx(LoadingBlock, { title: t("activity.panel.loading") }),
    /* @__PURE__ */ jsx(ReleaseActivityList, { releaseTitle: release.metadata.title || tCore("release.placeholder-untitled-release"), releaseId: release._id, events: events2.events, hasMore: events2.hasMore, loadMore: events2.loadMore, isLoading: events2.loading })
  ] }) }) }) }), $[0] = events2, $[1] = release, $[2] = show, $[3] = t, $[4] = tCore, $[5] = t1) : t1 = $[5];
  let t2;
  return $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(AnimatePresence, { children: t1 }), $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
const ToneIcon = (t0) => {
  const $ = c(5), {
    tone,
    icon: Icon2
  } = t0, t1 = `var(--card-badge-${tone}-icon-color)`;
  let t2;
  $[0] !== t1 ? (t2 = {
    "--card-icon-color": t1
  }, $[0] = t1, $[1] = t2) : t2 = $[1];
  const t3 = t2;
  let t4;
  return $[2] !== Icon2 || $[3] !== t3 ? (t4 = /* @__PURE__ */ jsx(Icon2, { style: t3 }), $[2] = Icon2, $[3] = t3, $[4] = t4) : t4 = $[4], t4;
}, TextWithToneStyle = styled(Text$1).withConfig({
  displayName: "TextWithToneStyle",
  componentId: "sc-sctq36-0"
})`&:not([data-muted]){&[data-tone='default']{--card-fg-color:var(--card-badge-default-fg-color);}&[data-tone='primary']{--card-fg-color:var(--card-badge-primary-fg-color);}&[data-tone='positive']{--card-fg-color:var(--card-badge-positive-fg-color);}&[data-tone='caution']{--card-fg-color:var(--card-badge-caution-fg-color);}&[data-tone='critical']{--card-fg-color:var(--card-badge-critical-fg-color);}}&[data-dimmed]{opacity:0.3;}`, TextWithTone = forwardRef(function(props2, ref) {
  const $ = c(12);
  let dimmed, muted, rest, tone;
  $[0] !== props2 ? ({
    tone,
    dimmed,
    muted,
    ...rest
  } = props2, $[0] = props2, $[1] = dimmed, $[2] = muted, $[3] = rest, $[4] = tone) : (dimmed = $[1], muted = $[2], rest = $[3], tone = $[4]);
  const t0 = dimmed ? "" : void 0, t1 = muted ? "" : void 0;
  let t2;
  return $[5] !== muted || $[6] !== ref || $[7] !== rest || $[8] !== t0 || $[9] !== t1 || $[10] !== tone ? (t2 = /* @__PURE__ */ jsx(TextWithToneStyle, { "data-ui": "TextWithTone", "data-dimmed": t0, "data-muted": t1, "data-tone": tone, muted, ref, ...rest }), $[5] = muted, $[6] = ref, $[7] = rest, $[8] = t0, $[9] = t1, $[10] = tone, $[11] = t2) : t2 = $[11], t2;
}), isReleasePermissionError = (error) => isErrorWithDetails(error) && error.details?.type === "insufficientPermissionsError";
function createReleasePermissionsStore(isContentReleasesEnabled) {
  let permissions = {};
  return {
    checkWithPermissionGuard: async (action, ...args) => {
      if (!isContentReleasesEnabled)
        return !0;
      if (permissions[action.name] === void 0)
        try {
          return await action(...args, {
            dryRun: !0,
            skipCrossDatasetReferenceValidation: !0
          }), permissions = {
            ...permissions,
            [action.name]: !0
          }, !0;
        } catch (e) {
          return permissions = {
            ...permissions,
            [action.name]: !1
          }, !isReleasePermissionError(e);
        }
      else
        return permissions[action.name];
    },
    permissions
  };
}
const RELEASE_PERMISSIONS_RESOURCE_CACHE_NAMESPACE = "ReleasePermissions";
function useReleasePermissions() {
  const $ = c(3), resourceCache = useResourceCache(), contentReleasesFeature = useFeatureEnabled(FEATURES.contentReleases);
  let releasePermissionsStore;
  return $[0] !== contentReleasesFeature || $[1] !== resourceCache ? (releasePermissionsStore = resourceCache.get({
    dependencies: [contentReleasesFeature],
    namespace: RELEASE_PERMISSIONS_RESOURCE_CACHE_NAMESPACE
  }) || createReleasePermissionsStore(contentReleasesFeature.enabled), resourceCache.set({
    namespace: RELEASE_PERMISSIONS_RESOURCE_CACHE_NAMESPACE,
    value: releasePermissionsStore,
    dependencies: [contentReleasesFeature]
  }), $[0] = contentReleasesFeature, $[1] = resourceCache, $[2] = releasePermissionsStore) : releasePermissionsStore = $[2], releasePermissionsStore;
}
const INITIAL_LOADING_STATE = {
  error: null,
  projectSubscriptions: null,
  isLoading: !0
};
function fetchProjectSubscriptions({
  versionedClient: versionedClient2
}) {
  return versionedClient2.observable.request({
    uri: `/subscriptions/project/${versionedClient2.config().projectId}`,
    tag: "project-subscriptions"
  });
}
const cachedProjectSubscriptionsRequest = /* @__PURE__ */ new Map();
function useProjectSubscriptions() {
  const $ = c(3), versionedClient2 = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    projectId
  } = useSource();
  if (!cachedProjectSubscriptionsRequest.get(projectId)) {
    const projectSubscriptions = fetchProjectSubscriptions({
      versionedClient: versionedClient2
    }).pipe(shareReplay());
    cachedProjectSubscriptionsRequest.set(projectId, projectSubscriptions);
  }
  let t0;
  if ($[0] !== projectId) {
    bb0: {
      const projectSubscriptions$ = cachedProjectSubscriptionsRequest.get(projectId);
      if (!projectSubscriptions$) {
        let t1;
        $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = of({
          isLoading: !1,
          error: null,
          projectSubscriptions: null
        }), $[2] = t1) : t1 = $[2], t0 = t1;
        break bb0;
      }
      t0 = projectSubscriptions$.pipe(map(_temp$28), startWith(INITIAL_LOADING_STATE), catchError(_temp2$S));
    }
    $[0] = projectId, $[1] = t0;
  } else
    t0 = $[1];
  return useObservable(t0, INITIAL_LOADING_STATE);
}
function _temp2$S(error) {
  return of({
    isLoading: !1,
    projectSubscriptions: null,
    error
  });
}
function _temp$28(cachedSubscriptions) {
  return {
    isLoading: !1,
    projectSubscriptions: cachedSubscriptions,
    error: null
  };
}
function ArchivedReleaseBanner(t0) {
  const $ = c(17), {
    release
  } = t0, {
    state
  } = release, {
    t: tRelease
  } = useTranslation(releasesLocaleNamespace), {
    projectSubscriptions
  } = useProjectSubscriptions(), retentionDays = projectSubscriptions?.featureTypes.retention.features[0].attributes.maxRetentionDays, {
    utcToCurrentZoneDate
  } = useTimeZone(CONTENT_RELEASES_TIME_ZONE_SCOPE);
  let t1;
  bb0: {
    if (!retentionDays || !release?._updatedAt) {
      t1 = "";
      break bb0;
    }
    let t22;
    if ($[0] !== release._updatedAt || $[1] !== retentionDays || $[2] !== utcToCurrentZoneDate) {
      const _removalDate = addDays(new Date(release._updatedAt), retentionDays);
      t22 = format(utcToCurrentZoneDate(_removalDate), "PP"), $[0] = release._updatedAt, $[1] = retentionDays, $[2] = utcToCurrentZoneDate, $[3] = t22;
    } else
      t22 = $[3];
    t1 = t22;
  }
  const removalDate = t1;
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(InfoOutlineIcon, {}) }), $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== state || $[6] !== tRelease ? (t3 = tRelease(state === "archived" ? "archive-info.title" : "publish-info.title"), $[5] = state, $[6] = tRelease, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t3 }), $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== removalDate || $[11] !== retentionDays || $[12] !== tRelease ? (t5 = retentionDays && /* @__PURE__ */ jsx(Text$1, { size: 1, accent: !0, children: /* @__PURE__ */ jsx(Translate, { t: tRelease, i18nKey: "archive-info.description", values: {
    retentionDays,
    removalDate: removalDate || ""
  }, components: {
    Link: _temp$27
  } }) }), $[10] = removalDate, $[11] = retentionDays, $[12] = tRelease, $[13] = t5) : t5 = $[13];
  let t6;
  return $[14] !== t4 || $[15] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { padding: 4, radius: 4, tone: "primary", "data-testid": "retention-policy-card", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
    t2,
    /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
      t4,
      t5
    ] })
  ] }) }), $[14] = t4, $[15] = t5, $[16] = t6) : t6 = $[16], t6;
}
function _temp$27(t0) {
  const {
    children
  } = t0;
  return /* @__PURE__ */ jsx("a", { href: "https://www.sanity.io/docs/user-guides/history-experience", target: "_blank", rel: "noreferrer", children });
}
function ReleaseDetailsEditor(t0) {
  const $ = c(13), {
    release
  } = t0, {
    updateRelease
  } = useReleaseOperations(), [timer2, setTimer] = useState(void 0), {
    checkWithPermissionGuard
  } = useReleasePermissions(), [hasUpdatePermission, setHasUpdatePermission] = useState(null);
  let t1;
  $[0] !== hasUpdatePermission || $[1] !== timer2 || $[2] !== updateRelease ? (t1 = (changedValue) => {
    clearTimeout(timer2);
    const newTimer = setTimeout(() => {
      hasUpdatePermission && updateRelease(changedValue);
    }, 200);
    setTimer(newTimer);
  }, $[0] = hasUpdatePermission, $[1] = timer2, $[2] = updateRelease, $[3] = t1) : t1 = $[3];
  const handleOnChange = t1, isMounted = useRef(!1);
  let t2, t3;
  $[4] !== checkWithPermissionGuard || $[5] !== release || $[6] !== updateRelease ? (t2 = () => (isMounted.current = !0, getIsReleaseOpen(release) && checkWithPermissionGuard(updateRelease, release).then((hasPermission) => {
    isMounted.current && setHasUpdatePermission(hasPermission);
  }), () => {
    isMounted.current = !1;
  }), t3 = [checkWithPermissionGuard, release, release._id, updateRelease], $[4] = checkWithPermissionGuard, $[5] = release, $[6] = updateRelease, $[7] = t2, $[8] = t3) : (t2 = $[7], t3 = $[8]), useEffect(t2, t3);
  const t4 = release._id, t5 = !hasUpdatePermission;
  let t6;
  return $[9] !== handleOnChange || $[10] !== release || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(TitleDescriptionForm, { release, onChange: handleOnChange, disabled: t5 }, t4), $[9] = handleOnChange, $[10] = release, $[11] = t5, $[12] = t6) : t6 = $[12], t6;
}
const useReleaseTime = () => {
  const $ = c(9);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    type: "contentReleases"
  }, $[0] = t0) : t0 = $[0];
  const {
    timeZone,
    utcToCurrentZoneDate,
    getLocalTimeZone
  } = useTimeZone(t0);
  let t1;
  $[1] !== getLocalTimeZone ? (t1 = getLocalTimeZone(), $[1] = getLocalTimeZone, $[2] = t1) : t1 = $[2];
  const {
    abbreviation: localeTimeZoneAbbreviation
  } = t1;
  let t2;
  $[3] !== localeTimeZoneAbbreviation || $[4] !== timeZone.abbreviation ? (t2 = () => timeZone.abbreviation === localeTimeZoneAbbreviation ? "" : `(${timeZone.abbreviation})`, $[3] = localeTimeZoneAbbreviation, $[4] = timeZone.abbreviation, $[5] = t2) : t2 = $[5];
  const getTimezoneAbbreviation = t2;
  let t3;
  return $[6] !== getTimezoneAbbreviation || $[7] !== utcToCurrentZoneDate ? (t3 = (release) => {
    const publishDate = getPublishDateFromRelease(release);
    return publishDate ? `${format(utcToCurrentZoneDate(publishDate), "PPpp")} ${getTimezoneAbbreviation()}` : null;
  }, $[6] = getTimezoneAbbreviation, $[7] = utcToCurrentZoneDate, $[8] = t3) : t3 = $[8], t3;
}, getIsScheduledDateInPast = (value) => !!(value.metadata.releaseType === "scheduled" && value.metadata.intendedPublishAt && isPast(new Date(value.metadata.intendedPublishAt))), ReleaseTime = (t0) => {
  const $ = c(28), {
    release
  } = t0, {
    t
  } = useTranslation(), {
    t: tRelease
  } = useTranslation(releasesLocaleNamespace), getReleaseTime = useReleaseTime(), {
    metadata
  } = release;
  if (metadata.releaseType === "asap") {
    let t12;
    $[0] !== t ? (t12 = t("release.type.asap"), $[0] = t, $[1] = t12) : t12 = $[1];
    let t22;
    return $[2] !== t12 ? (t22 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, weight: "medium", children: t12 }), $[2] = t12, $[3] = t22) : t22 = $[3], t22;
  }
  if (metadata.releaseType === "undecided") {
    let t12;
    $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = {
      opacity: 0.5
    }, $[4] = t12) : t12 = $[4];
    let t22;
    $[5] !== t ? (t22 = t("release.type.undecided"), $[5] = t, $[6] = t22) : t22 = $[6];
    let t32;
    return $[7] !== t22 ? (t32 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, weight: "medium", style: t12, children: t22 }), $[7] = t22, $[8] = t32) : t32 = $[8], t32;
  }
  let t1;
  $[9] !== release ? (t1 = isReleaseScheduledOrScheduling(release), $[9] = release, $[10] = t1) : t1 = $[10];
  const isScheduledOrScheduling = t1;
  let t2;
  $[11] !== release.state ? (t2 = ARCHIVED_RELEASE_STATES.includes(release.state), $[11] = release.state, $[12] = t2) : t2 = $[12];
  const isInArchivedView = t2;
  let t3;
  $[13] !== isScheduledOrScheduling ? (t3 = isScheduledOrScheduling && /* @__PURE__ */ jsx(Box, { paddingY: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: /* @__PURE__ */ jsx(LockIcon, { "data-testid": "release-lock-icon" }) }) }), $[13] = isScheduledOrScheduling, $[14] = t3) : t3 = $[14];
  let t4;
  $[15] !== isInArchivedView || $[16] !== isScheduledOrScheduling || $[17] !== tRelease ? (t4 = !isInArchivedView && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(Box, { paddingY: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: tRelease(isScheduledOrScheduling ? "time.scheduled" : "time.estimated") }) }),
    /* @__PURE__ */ jsx(Box, { paddingY: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: "\xB7" }) })
  ] }), $[15] = isInArchivedView, $[16] = isScheduledOrScheduling, $[17] = tRelease, $[18] = t4) : t4 = $[18];
  let t5;
  $[19] !== getReleaseTime || $[20] !== release ? (t5 = getReleaseTime(release), $[19] = getReleaseTime, $[20] = release, $[21] = t5) : t5 = $[21];
  let t6;
  $[22] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { paddingY: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t5 }) }), $[22] = t5, $[23] = t6) : t6 = $[23];
  let t7;
  return $[24] !== t3 || $[25] !== t4 || $[26] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", wrap: "wrap", children: [
    t3,
    t4,
    t6
  ] }), $[24] = t3, $[25] = t4, $[26] = t6, $[27] = t7) : t7 = $[27], t7;
}, dateInputFormat = "PP HH:mm";
function ReleaseDateInput(props2) {
  const $ = c(12), {
    setIsIntendedScheduleDateInPast,
    intendedPublishAt,
    setIntendedPublishAt
  } = props2, {
    utcToCurrentZoneDate,
    zoneDateToUtc
  } = useTimeZone(CONTENT_RELEASES_TIME_ZONE_SCOPE);
  let t0;
  $[0] !== intendedPublishAt || $[1] !== utcToCurrentZoneDate ? (t0 = intendedPublishAt && utcToCurrentZoneDate(intendedPublishAt), $[0] = intendedPublishAt, $[1] = utcToCurrentZoneDate, $[2] = t0) : t0 = $[2];
  const intendedPublishAtTimezoneAdjusted = t0;
  let t1;
  $[3] !== setIntendedPublishAt || $[4] !== setIsIntendedScheduleDateInPast || $[5] !== zoneDateToUtc ? (t1 = (event) => {
    const parsedDate = zoneDateToUtc(parse(event.currentTarget.value, dateInputFormat, /* @__PURE__ */ new Date()));
    isValid(parsedDate) && (setIsIntendedScheduleDateInPast(isBefore(parsedDate, /* @__PURE__ */ new Date())), setIntendedPublishAt(startOfMinute(parsedDate)));
  }, $[3] = setIntendedPublishAt, $[4] = setIsIntendedScheduleDateInPast, $[5] = zoneDateToUtc, $[6] = t1) : t1 = $[6];
  const handlePublishAtInputChange = t1;
  let t2;
  $[7] !== intendedPublishAtTimezoneAdjusted ? (t2 = intendedPublishAtTimezoneAdjusted ? format(intendedPublishAtTimezoneAdjusted, dateInputFormat) : void 0, $[7] = intendedPublishAtTimezoneAdjusted, $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== handlePublishAtInputChange || $[10] !== t2 ? (t3 = /* @__PURE__ */ jsx(LazyTextInput, { "data-testid": "date-input", value: t2, onChange: handlePublishAtInputChange }), $[9] = handlePublishAtInputChange, $[10] = t2, $[11] = t3) : t3 = $[11], t3;
}
function ReleaseTypePicker(props2) {
  const $ = c(95), {
    release
  } = props2, popoverRef = useRef(null), buttonRef = useRef(null), inputRef = useRef(null), datePickerRef = useRef(null), {
    t: tRelease
  } = useTranslation(releasesLocaleNamespace), {
    t
  } = useTranslation(), {
    updateRelease
  } = useReleaseOperations(), toast = useToast(), getReleaseTime = useReleaseTime(), [open, setOpen] = useState(!1), [releaseType, setReleaseType] = useState(release.metadata.releaseType);
  let t0;
  $[0] !== release ? (t0 = getPublishDateFromRelease(release), $[0] = release, $[1] = t0) : t0 = $[1];
  const publishDate = t0, [isUpdating, setIsUpdating] = useState(!1);
  let t1;
  $[2] !== publishDate ? (t1 = publishDate && isBefore(new Date(publishDate), /* @__PURE__ */ new Date()), $[2] = publishDate, $[3] = t1) : t1 = $[3];
  const [isIntendedScheduleDateInPast, setIsIntendedScheduleDateInPast] = useState(t1);
  let t2;
  $[4] !== publishDate ? (t2 = publishDate ? new Date(publishDate) : void 0, $[4] = publishDate, $[5] = t2) : t2 = $[5];
  const [intendedPublishAt, setIntendedPublishAt] = useState(t2);
  let t3;
  $[6] !== intendedPublishAt ? (t3 = intendedPublishAt?.toISOString(), $[6] = intendedPublishAt, $[7] = t3) : t3 = $[7];
  const updatedDate = t3;
  let t4;
  $[8] !== t ? (t4 = getCalendarLabels(t), $[8] = t, $[9] = t4) : t4 = $[9];
  const calendarLabels = t4;
  let t5;
  $[10] !== open || $[11] !== release || $[12] !== releaseType || $[13] !== t || $[14] !== toast || $[15] !== updateRelease || $[16] !== updatedDate ? (t5 = () => {
    const dialog = document.querySelector("#time-zone");
    if (open && !dialog) {
      const newRelease = {
        ...release,
        metadata: {
          ...release.metadata,
          releaseType,
          ...typeof updatedDate > "u" || releaseType !== "scheduled" ? {} : {
            intendedPublishAt: updatedDate
          }
        }
      };
      isEqual$1(newRelease, release) || (getIsScheduledDateInPast(newRelease) ? (setReleaseType(release.metadata.releaseType), setIntendedPublishAt(release.metadata.intendedPublishAt ? new Date(release.metadata.intendedPublishAt) : void 0), toast.push({
        closable: !0,
        status: "warning",
        title: t("release.schedule-dialog.publish-date-in-past-warning")
      })) : (setIsUpdating(!0), updateRelease(newRelease).finally(() => {
        setIsUpdating(!1);
      }))), setOpen(!1);
    }
  }, $[10] = open, $[11] = release, $[12] = releaseType, $[13] = t, $[14] = toast, $[15] = updateRelease, $[16] = updatedDate, $[17] = t5) : t5 = $[17];
  const close = t5;
  let t6;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = () => [popoverRef.current, buttonRef.current, inputRef.current, datePickerRef.current], $[18] = t6) : t6 = $[18], useClickOutsideEvent(close, t6);
  const isPublishDateInPast = !!publishDate && isBefore(new Date(publishDate), /* @__PURE__ */ new Date());
  let t7;
  $[19] !== release ? (t7 = isReleaseScheduledOrScheduling(release), $[19] = release, $[20] = t7) : t7 = $[20];
  const isReleaseScheduled = t7;
  let t8;
  bb0: {
    if (release.state === "published") {
      if (isPublishDateInPast && publishDate) {
        let t94;
        $[21] !== getReleaseTime || $[22] !== release || $[23] !== tRelease ? (t94 = tRelease("dashboard.details.published-on", {
          date: getReleaseTime(release)
        }), $[21] = getReleaseTime, $[22] = release, $[23] = tRelease, $[24] = t94) : t94 = $[24], t8 = t94;
        break bb0;
      }
      let t93;
      $[25] !== tRelease ? (t93 = tRelease("dashboard.details.published-asap"), $[25] = tRelease, $[26] = t93) : t93 = $[26], t8 = t93;
      break bb0;
    }
    let t92;
    $[27] !== release ? (t92 = /* @__PURE__ */ jsx(ReleaseTime, { release }), $[27] = release, $[28] = t92) : t92 = $[28], t8 = t92;
  }
  const publishDateLabel = t8;
  let t9;
  $[29] !== publishDate ? (t9 = (pickedReleaseType) => {
    setReleaseType(pickedReleaseType);
    const nextPublishAt = pickedReleaseType === "scheduled" ? publishDate ?? startOfMinute(/* @__PURE__ */ new Date()) : publishDate ?? void 0;
    setIntendedPublishAt(nextPublishAt), setIsIntendedScheduleDateInPast(!0);
  }, $[29] = publishDate, $[30] = t9) : t9 = $[30];
  const handleButtonReleaseTypeChange = t9;
  let t10;
  $[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = (date) => {
    if (!date)
      return;
    const cleanDate = startOfMinute(new Date(date));
    setIsIntendedScheduleDateInPast(isBefore(cleanDate, /* @__PURE__ */ new Date())), setIntendedPublishAt(cleanDate);
  }, $[31] = t10) : t10 = $[31];
  const handlePublishAtCalendarChange = t10;
  let t11;
  $[32] !== close || $[33] !== open ? (t11 = () => {
    open ? close() : setOpen(!0);
  }, $[32] = close, $[33] = open, $[34] = t11) : t11 = $[34];
  const handleOnPickerClick = t11;
  let t12;
  $[35] !== release ? (t12 = release.state === "published" ? "positive" : getReleaseTone(release), $[35] = release, $[36] = t12) : t12 = $[36];
  const tone = t12;
  let t13;
  bb1: {
    if (isUpdating) {
      let t143;
      $[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t143 = /* @__PURE__ */ jsx(Spinner, { size: 1, "data-testid": "updating-release-spinner" }), $[37] = t143) : t143 = $[37], t13 = t143;
      break bb1;
    }
    if (release.state === "published") {
      let t143;
      $[38] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t143 = /* @__PURE__ */ jsx(PublishIcon, {}), $[38] = t143) : t143 = $[38], t13 = t143;
      break bb1;
    }
    let t142;
    $[39] !== release ? (t142 = /* @__PURE__ */ jsx(ReleaseAvatar, { release, padding: 0 }), $[39] = release, $[40] = t142) : t142 = $[40], t13 = t142;
  }
  const releaseTypeIcon = t13;
  let t14;
  $[41] !== publishDateLabel ? (t14 = /* @__PURE__ */ jsx("span", { "data-testid": "release-type-label", children: publishDateLabel }), $[41] = publishDateLabel, $[42] = t14) : t14 = $[42];
  let t15;
  $[43] !== releaseTypeIcon || $[44] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Flex, { flex: 1, gap: 2, align: "center", children: [
    releaseTypeIcon,
    t14
  ] }), $[43] = releaseTypeIcon, $[44] = t14, $[45] = t15) : t15 = $[45];
  const labelContent = t15;
  let t16;
  $[46] !== handleButtonReleaseTypeChange ? (t16 = () => handleButtonReleaseTypeChange("asap"), $[46] = handleButtonReleaseTypeChange, $[47] = t16) : t16 = $[47];
  let t17;
  $[48] !== t ? (t17 = t("release.type.asap"), $[48] = t, $[49] = t17) : t17 = $[49];
  const t18 = releaseType === "asap";
  let t19;
  $[50] !== t16 || $[51] !== t17 || $[52] !== t18 ? (t19 = /* @__PURE__ */ jsx(Tab, { "aria-controls": "release-timing-asap", id: "release-timing-asap-tab", onClick: t16, label: t17, selected: t18 }), $[50] = t16, $[51] = t17, $[52] = t18, $[53] = t19) : t19 = $[53];
  let t20;
  $[54] !== handleButtonReleaseTypeChange ? (t20 = () => handleButtonReleaseTypeChange("scheduled"), $[54] = handleButtonReleaseTypeChange, $[55] = t20) : t20 = $[55];
  const t21 = releaseType === "scheduled";
  let t22;
  $[56] !== t ? (t22 = t("release.type.scheduled"), $[56] = t, $[57] = t22) : t22 = $[57];
  let t23;
  $[58] !== t20 || $[59] !== t21 || $[60] !== t22 ? (t23 = /* @__PURE__ */ jsx(Tab, { "aria-controls": "release-timing-at-time", id: "release-timing-at-time-tab", onClick: t20, selected: t21, label: t22 }), $[58] = t20, $[59] = t21, $[60] = t22, $[61] = t23) : t23 = $[61];
  let t24;
  $[62] !== handleButtonReleaseTypeChange ? (t24 = () => handleButtonReleaseTypeChange("undecided"), $[62] = handleButtonReleaseTypeChange, $[63] = t24) : t24 = $[63];
  const t25 = releaseType === "undecided";
  let t26;
  $[64] !== t ? (t26 = t("release.type.undecided"), $[64] = t, $[65] = t26) : t26 = $[65];
  let t27;
  $[66] !== t24 || $[67] !== t25 || $[68] !== t26 ? (t27 = /* @__PURE__ */ jsx(Tab, { "aria-controls": "release-timing-undecided", id: "release-timing-undecided-tab", onClick: t24, selected: t25, label: t26 }), $[66] = t24, $[67] = t25, $[68] = t26, $[69] = t27) : t27 = $[69];
  let t28;
  $[70] !== t19 || $[71] !== t23 || $[72] !== t27 ? (t28 = /* @__PURE__ */ jsxs(TabList, { space: 0.5, children: [
    t19,
    t23,
    t27
  ] }), $[70] = t19, $[71] = t23, $[72] = t27, $[73] = t28) : t28 = $[73];
  let t29;
  $[74] !== calendarLabels || $[75] !== intendedPublishAt || $[76] !== isIntendedScheduleDateInPast || $[77] !== releaseType || $[78] !== t ? (t29 = releaseType === "scheduled" && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    isIntendedScheduleDateInPast && /* @__PURE__ */ jsx(Card, { margin: 1, padding: 2, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("release.schedule-dialog.publish-date-in-past-warning") }) }),
    /* @__PURE__ */ jsx(ReleaseDateInput, { setIsIntendedScheduleDateInPast, setIntendedPublishAt, intendedPublishAt }),
    /* @__PURE__ */ jsx(DatePicker$2, { ref: datePickerRef, monthPickerVariant: MONTH_PICKER_VARIANT.carousel, calendarLabels, selectTime: !0, padding: 0, value: intendedPublishAt, onChange: handlePublishAtCalendarChange, isPastDisabled: !0, showTimeZone: !0, timeZoneScope: CONTENT_RELEASES_TIME_ZONE_SCOPE })
  ] }), $[74] = calendarLabels, $[75] = intendedPublishAt, $[76] = isIntendedScheduleDateInPast, $[77] = releaseType, $[78] = t, $[79] = t29) : t29 = $[79];
  let t30;
  $[80] !== t28 || $[81] !== t29 ? (t30 = /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    t28,
    t29
  ] }), $[80] = t28, $[81] = t29, $[82] = t30) : t30 = $[82];
  let t31;
  $[83] !== handleOnPickerClick || $[84] !== isReleaseScheduled || $[85] !== labelContent || $[86] !== open || $[87] !== release.state || $[88] !== tRelease || $[89] !== tone ? (t31 = release.state === "published" ? /* @__PURE__ */ jsx(Card, { tone: "default", "data-testid": "published-release-type-label", padding: 2, style: {
    borderRadius: "999px"
  }, children: labelContent }) : /* @__PURE__ */ jsx(Button, { disabled: isReleaseScheduled, mode: "bleed", onClick: handleOnPickerClick, ref: buttonRef, tooltipProps: {
    placement: "bottom",
    content: isReleaseScheduled && tRelease("type-picker.tooltip.scheduled")
  }, selected: open, tone, style: {
    borderRadius: "999px"
  }, "data-testid": "release-type-picker", children: labelContent }), $[83] = handleOnPickerClick, $[84] = isReleaseScheduled, $[85] = labelContent, $[86] = open, $[87] = release.state, $[88] = tRelease, $[89] = tone, $[90] = t31) : t31 = $[90];
  let t32;
  return $[91] !== open || $[92] !== t30 || $[93] !== t31 ? (t32 = /* @__PURE__ */ jsx(Popover, { content: t30, open, padding: 1, placement: "bottom-start", ref: popoverRef, children: t31 }), $[91] = open, $[92] = t30, $[93] = t31, $[94] = t32) : t32 = $[94], t32;
}
const degreesToRadians = (degrees) => degrees * Math.PI / 180;
function ProgressIcon(props2) {
  const $ = c(11);
  let progress, rest;
  $[0] !== props2 ? ({
    progress,
    ...rest
  } = props2, $[0] = props2, $[1] = progress, $[2] = rest) : (progress = $[1], rest = $[2]);
  let t0;
  if ($[3] !== progress) {
    const circlePath = partialCircle(12.5, 12.5, 4.5, degreesToRadians(-90), degreesToRadians(progress * 360 - 90));
    t0 = circlePath.length > 0 ? `${circlePath.map(_temp$26).join(" ")} L 12.5 12.5 Z` : void 0, $[3] = progress, $[4] = t0;
  } else
    t0 = $[4];
  const d = t0;
  let t1;
  $[5] !== d ? (t1 = d && /* @__PURE__ */ jsx("path", { d, fill: "currentColor", stroke: "currentColor", strokeWidth: 1.2, strokeLinejoin: "round" }), $[5] = d, $[6] = t1) : t1 = $[6];
  let t2;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx("path", { d: "M12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5C8.08172 4.5 4.5 8.08172 4.5 12.5C4.5 16.9183 8.08172 20.5 12.5 20.5Z", stroke: "currentColor", strokeWidth: 1.2, strokeLinejoin: "round" }), $[7] = t2) : t2 = $[7];
  let t3;
  return $[8] !== rest || $[9] !== t1 ? (t3 = /* @__PURE__ */ jsxs("svg", { "data-sanity-icon": "progress-50", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: [
    t1,
    t2
  ] }), $[8] = rest, $[9] = t1, $[10] = t3) : t3 = $[10], t3;
}
function _temp$26(vs) {
  return vs.join(" ");
}
function partialCircle(cx, cy, r, start, end) {
  const length = end - start;
  if (length === 0) return [];
  const fromX = r * Math.cos(start) + cx, fromY = r * Math.sin(start) + cy, toX = r * Math.cos(end) + cx, toY = r * Math.sin(end) + cy, large = Math.abs(length) <= Math.PI ? "0" : "1", sweep = length < 0 ? "0" : "1";
  return [["M", fromX, fromY], ["A", r, r, 0, large, sweep, toX, toY]];
}
const getDocumentValidationLoading = (documents) => {
  let hasError = !1, isValidating = !1, validatedCount = 0;
  return documents.forEach((doc) => {
    if (isGoingToUnpublish(doc.document))
      validatedCount += 1;
    else {
      const isValidated = !doc.validation.isValidating;
      hasError = hasError || doc.validation.hasError, isValidating = isValidating || doc.validation.isValidating, isValidated && (validatedCount += 1);
    }
  }), {
    hasError,
    isValidating,
    validatedCount
  };
};
function ValidationProgressIndicator(t0) {
  const $ = c(34), {
    documents,
    layout: t1
  } = t0, layout = t1 === void 0 ? "default" : t1, totalCount = documents.length;
  let t2;
  $[0] !== documents ? (t2 = getDocumentValidationLoading(documents), $[0] = documents, $[1] = t2) : t2 = $[1];
  const {
    validatedCount,
    isValidating,
    hasError
  } = t2, [showCheckmark, setShowCheckmark] = useState(!1), [hasFinishedOnce, setHasFinishedOnce] = useState(!1), {
    t
  } = useTranslation(releasesLocaleNamespace), isFinished = validatedCount === totalCount && validatedCount !== 0, isMinimal = layout === "minimal" || hasFinishedOnce;
  let t3;
  $[2] !== isFinished ? (t3 = () => {
    if (isFinished) {
      const timer2 = setTimeout(() => {
        setShowCheckmark(!0), setHasFinishedOnce(!0);
      }, 2500);
      return () => clearTimeout(timer2);
    }
  }, $[2] = isFinished, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== isFinished || $[5] !== showCheckmark ? (t4 = [isFinished, showCheckmark], $[4] = isFinished, $[5] = showCheckmark, $[6] = t4) : t4 = $[6], useEffect(t3, t4);
  let t5, t6;
  if ($[7] !== isValidating ? (t5 = () => {
    isValidating && setShowCheckmark(!1);
  }, t6 = [isValidating], $[7] = isValidating, $[8] = t5, $[9] = t6) : (t5 = $[8], t6 = $[9]), useEffect(t5, t6), !isFinished && !isValidating)
    return null;
  const tone = isValidating ? "neutral" : isFinished && showCheckmark && !hasError ? "transparent" : hasError ? "critical" : "positive", cardBackground = isFinished && showCheckmark && !hasError ? "transparent" : void 0, t7 = isMinimal ? 0 : 2;
  let t8;
  $[10] !== cardBackground ? (t8 = {
    background: cardBackground
  }, $[10] = cardBackground, $[11] = t8) : t8 = $[11];
  let t9;
  $[12] !== hasError || $[13] !== isValidating || $[14] !== t || $[15] !== totalCount || $[16] !== validatedCount ? (t9 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: isValidating ? /* @__PURE__ */ jsx(ProgressIcon, { progress: validatedCount / totalCount }) : /* @__PURE__ */ jsx(Tooltip, { content: t(hasError ? "summary.errors-found" : "summary.all-documents-validated"), children: hasError ? /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) : /* @__PURE__ */ jsx(CheckmarkCircleIcon, {}) }) }), $[12] = hasError, $[13] = isValidating, $[14] = t, $[15] = totalCount, $[16] = validatedCount, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== hasError || $[19] !== isMinimal || $[20] !== isValidating || $[21] !== showCheckmark || $[22] !== t || $[23] !== totalCount || $[24] !== validatedCount ? (t10 = !showCheckmark && !isMinimal && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: isValidating ? t("summary.validating-documents", {
    validatedCount,
    totalCount
  }) : t(hasError ? "summary.all-documents-errors-found" : "summary.all-documents-validated") }), $[18] = hasError, $[19] = isMinimal, $[20] = isValidating, $[21] = showCheckmark, $[22] = t, $[23] = totalCount, $[24] = validatedCount, $[25] = t10) : t10 = $[25];
  let t11;
  $[26] !== t10 || $[27] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Flex, { gap: 2, children: [
    t9,
    t10
  ] }), $[26] = t10, $[27] = t9, $[28] = t11) : t11 = $[28];
  let t12;
  return $[29] !== t11 || $[30] !== t7 || $[31] !== t8 || $[32] !== tone ? (t12 = /* @__PURE__ */ jsx(Card, { padding: t7, radius: "full", tone, style: t8, children: t11 }), $[29] = t11, $[30] = t7, $[31] = t8, $[32] = tone, $[33] = t12) : t12 = $[33], t12;
}
function ReleaseDashboardDetails(t0) {
  const $ = c(62), {
    release,
    documents
  } = t0, {
    state
  } = release;
  let t1;
  $[0] !== release._id ? (t1 = getReleaseIdFromReleaseDocumentId(release._id), $[0] = release._id, $[1] = t1) : t1 = $[1];
  const releaseId = t1, {
    checkWithPermissionGuard
  } = useReleasePermissions(), {
    publishRelease,
    schedule
  } = useReleaseOperations(), {
    t: tRelease
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), {
    selectedReleaseId
  } = usePerspective(), setPerspective = useSetPerspective(), isSelected = releaseId === selectedReleaseId;
  let t2;
  $[2] !== release.metadata.title || $[3] !== tCore ? (t2 = release.metadata.title || tCore("release.placeholder-untitled-release"), $[2] = release.metadata.title, $[3] = tCore, $[4] = t2) : t2 = $[4];
  const releaseFullTitle = t2, isAtTimeRelease = release?.metadata?.releaseType === "scheduled", isReleaseOpen = state !== "archived" && state !== "published", isActive = release.state === "active", shouldDisplayError = isActive && typeof release.error < "u", [shouldDisplayPermissionWarning, setShouldDisplayPermissionWarning] = useState(!1), shouldDisplayWarnings = isActive && shouldDisplayPermissionWarning, isMounted = useRef(!1), {
    document: document2
  } = useWorkspace(), {
    drafts: t3
  } = document2, {
    enabled: isDraftModelEnabled
  } = t3;
  let t4, t5;
  $[5] !== checkWithPermissionGuard || $[6] !== isActive || $[7] !== isAtTimeRelease || $[8] !== publishRelease || $[9] !== release._id || $[10] !== release.metadata.intendedPublishAt || $[11] !== schedule ? (t4 = () => (isMounted.current = !0, isActive && (checkWithPermissionGuard(publishRelease, release._id).then((hasPermission) => (isMounted.current && setShouldDisplayPermissionWarning(!hasPermission), null)), release.metadata.intendedPublishAt && isAtTimeRelease && checkWithPermissionGuard(schedule, release._id, /* @__PURE__ */ new Date()).then((hasPermission_0) => (isMounted.current && setShouldDisplayPermissionWarning(!hasPermission_0), null))), () => {
    isMounted.current = !1;
  }), t5 = [checkWithPermissionGuard, isActive, isAtTimeRelease, publishRelease, release._id, release.metadata.intendedPublishAt, schedule], $[5] = checkWithPermissionGuard, $[6] = isActive, $[7] = isAtTimeRelease, $[8] = publishRelease, $[9] = release._id, $[10] = release.metadata.intendedPublishAt, $[11] = schedule, $[12] = t4, $[13] = t5) : (t4 = $[12], t5 = $[13]), useEffect(t4, t5);
  let t6;
  $[14] !== isDraftModelEnabled || $[15] !== isSelected || $[16] !== releaseId || $[17] !== setPerspective ? (t6 = () => {
    setPerspective(isSelected ? isDraftModelEnabled ? "drafts" : "published" : releaseId);
  }, $[14] = isDraftModelEnabled, $[15] = isSelected, $[16] = releaseId, $[17] = setPerspective, $[18] = t6) : t6 = $[18];
  const handlePinRelease = t6;
  let t7;
  $[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = [3, 3, 4, 5], $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== handlePinRelease || $[21] !== isReleaseOpen || $[22] !== isSelected || $[23] !== releaseFullTitle || $[24] !== tRelease ? (t8 = isReleaseOpen && /* @__PURE__ */ jsx(Button, { icon: isSelected ? PinFilledIcon : PinIcon, tooltipProps: {
    placement: "top",
    content: tRelease(isSelected ? "dashboard.details.unpin-release" : "dashboard.details.pin-release")
  }, mode: "bleed", onClick: handlePinRelease, radius: "full", selected: isSelected, "aria-label": isSelected ? `${tRelease("dashboard.details.unpin-release")}: "${releaseFullTitle}"` : `${tRelease("dashboard.details.pin-release")}: "${releaseFullTitle}"`, "aria-live": "assertive" }), $[20] = handlePinRelease, $[21] = isReleaseOpen, $[22] = isSelected, $[23] = releaseFullTitle, $[24] = tRelease, $[25] = t8) : t8 = $[25];
  let t9;
  $[26] !== release ? (t9 = isNotArchivedRelease(release) && /* @__PURE__ */ jsx(ReleaseTypePicker, { release }), $[26] = release, $[27] = t9) : t9 = $[27];
  let t10;
  $[28] !== documents ? (t10 = /* @__PURE__ */ jsx(ValidationProgressIndicator, { documents }), $[28] = documents, $[29] = t10) : t10 = $[29];
  let t11;
  $[30] !== isAtTimeRelease || $[31] !== shouldDisplayError || $[32] !== tRelease ? (t11 = shouldDisplayError && /* @__PURE__ */ jsxs(Flex, { gap: 2, padding: 2, "data-testid": "release-error-details", children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: "critical" }) }),
    /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "critical", children: tRelease(isAtTimeRelease ? "failed-schedule-title" : "failed-publish-title") })
  ] }), $[30] = isAtTimeRelease, $[31] = shouldDisplayError, $[32] = tRelease, $[33] = t11) : t11 = $[33];
  let t12;
  $[34] !== shouldDisplayWarnings || $[35] !== tRelease ? (t12 = shouldDisplayWarnings && /* @__PURE__ */ jsxs(Flex, { gap: 2, padding: 2, "data-testid": "release-permission-error-details", children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToneIcon, { icon: WarningOutlineIcon, tone: "caution" }) }),
    /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "caution", children: tRelease("permission-missing-title") })
  ] }), $[34] = shouldDisplayWarnings, $[35] = tRelease, $[36] = t12) : t12 = $[36];
  let t13;
  $[37] !== t10 || $[38] !== t11 || $[39] !== t12 || $[40] !== t8 || $[41] !== t9 ? (t13 = /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", children: [
    t8,
    t9,
    t10,
    t11,
    t12
  ] }), $[37] = t10, $[38] = t11, $[39] = t12, $[40] = t8, $[41] = t9, $[42] = t13) : t13 = $[42];
  let t14;
  $[43] !== release ? (t14 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(ReleaseDetailsEditor, { release }) }), $[43] = release, $[44] = t14) : t14 = $[44];
  let t15;
  $[45] !== isAtTimeRelease || $[46] !== release.error?.message || $[47] !== shouldDisplayError || $[48] !== tRelease ? (t15 = shouldDisplayError && /* @__PURE__ */ jsx(Card, { padding: 4, radius: 4, tone: "critical", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }),
    /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
      /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: tRelease(isAtTimeRelease ? "failed-schedule-title" : "failed-publish-title") }),
      /* @__PURE__ */ jsx(Details, { title: tRelease("error-details-title"), children: /* @__PURE__ */ jsx(Text$1, { size: 1, accent: !0, children: /* @__PURE__ */ jsx("code", { children: release.error?.message }) }) })
    ] })
  ] }) }), $[45] = isAtTimeRelease, $[46] = release.error?.message, $[47] = shouldDisplayError, $[48] = tRelease, $[49] = t15) : t15 = $[49];
  let t16;
  $[50] !== shouldDisplayWarnings || $[51] !== tRelease ? (t16 = shouldDisplayWarnings && /* @__PURE__ */ jsx(Card, { padding: 4, radius: 4, tone: "caution", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }),
    /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      /* @__PURE__ */ jsx(Text$1, { size: 1, children: tRelease("permission-missing-title") }),
      /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: tRelease("permission-missing-description") })
    ] })
  ] }) }), $[50] = shouldDisplayWarnings, $[51] = tRelease, $[52] = t16) : t16 = $[52];
  let t17;
  $[53] !== isReleaseOpen || $[54] !== release ? (t17 = !isReleaseOpen && /* @__PURE__ */ jsx(ArchivedReleaseBanner, { release }), $[53] = isReleaseOpen, $[54] = release, $[55] = t17) : t17 = $[55];
  let t18;
  return $[56] !== t13 || $[57] !== t14 || $[58] !== t15 || $[59] !== t16 || $[60] !== t17 ? (t18 = /* @__PURE__ */ jsx(Container$3, { width: 3, children: /* @__PURE__ */ jsxs(Stack, { padding: 3, paddingY: t7, children: [
    t13,
    t14,
    t15,
    t16,
    t17
  ] }) }), $[56] = t13, $[57] = t14, $[58] = t15, $[59] = t16, $[60] = t17, $[61] = t18) : t18 = $[61], t18;
}
const ReleasePublishAllButton = (t0) => {
  const $ = c(85), {
    release,
    documents,
    disabled,
    isMenuItem: t1,
    onConfirmDialogOpen,
    onConfirmDialogClose
  } = t0, isMenuItem = t1 === void 0 ? !1 : t1, toast = useToast(), {
    publishRelease
  } = useReleaseOperations(), {
    checkWithPermissionGuard
  } = useReleasePermissions(), {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), perspective = usePerspective(), setPerspective = useSetPerspective(), telemetry = useTelemetry(), {
    document: document2
  } = useWorkspace(), {
    drafts: t2
  } = document2, {
    enabled: isDraftModelEnabled
  } = t2, [publishBundleStatus, setPublishBundleStatus] = useState("idle"), [publishPermission, setPublishPermission] = useState(!1);
  let t3;
  $[0] !== documents ? (t3 = documents.some(_temp$25), $[0] = documents, $[1] = t3) : t3 = $[1];
  const isValidatingDocuments = t3;
  let t4;
  $[2] !== documents ? (t4 = documents.some(_temp2$R), $[2] = documents, $[3] = t4) : t4 = $[3];
  const hasDocumentValidationErrors = t4, isPublishButtonDisabled = disabled || isValidatingDocuments || hasDocumentValidationErrors || !publishPermission, isMounted = useRef(!1);
  let t5;
  $[4] !== checkWithPermissionGuard || $[5] !== publishRelease || $[6] !== release._id ? (t5 = () => (isMounted.current = !0, checkWithPermissionGuard(publishRelease, release._id).then((hasPermission) => {
    isMounted.current && setPublishPermission(hasPermission);
  }), () => {
    isMounted.current = !1;
  }), $[4] = checkWithPermissionGuard, $[5] = publishRelease, $[6] = release._id, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== checkWithPermissionGuard || $[9] !== publishRelease || $[10] !== release._id || $[11] !== release.metadata.intendedPublishAt ? (t6 = [checkWithPermissionGuard, publishRelease, release._id, release.metadata.intendedPublishAt], $[8] = checkWithPermissionGuard, $[9] = publishRelease, $[10] = release._id, $[11] = release.metadata.intendedPublishAt, $[12] = t6) : t6 = $[12], useEffect(t5, t6);
  let t7;
  $[13] !== isDraftModelEnabled || $[14] !== onConfirmDialogClose || $[15] !== perspective.selectedPerspective || $[16] !== publishRelease || $[17] !== release || $[18] !== setPerspective || $[19] !== t || $[20] !== tCore || $[21] !== telemetry || $[22] !== toast ? (t7 = async () => {
    if (!release)
      return;
    const run = async () => {
      setPublishBundleStatus("publishing"), await publishRelease(release._id), telemetry.log(PublishedRelease), isReleaseDocument(perspective.selectedPerspective) && perspective.selectedPerspective?._id === release._id && setPerspective(isDraftModelEnabled ? "drafts" : "published");
    };
    try {
      await run();
    } catch (t82) {
      const publishingError = t82;
      toast.push({
        status: "error",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "toast.publish.error", values: {
          title: release.metadata.title || tCore("release.placeholder-untitled-release"),
          error: publishingError.message
        } }) })
      }), console.error(publishingError);
    }
    onConfirmDialogClose?.(), setPublishBundleStatus("idle");
  }, $[13] = isDraftModelEnabled, $[14] = onConfirmDialogClose, $[15] = perspective.selectedPerspective, $[16] = publishRelease, $[17] = release, $[18] = setPerspective, $[19] = t, $[20] = tCore, $[21] = telemetry, $[22] = toast, $[23] = t7) : t7 = $[23];
  const handleConfirmPublishAll = t7;
  let t8;
  bb0: {
    if (publishBundleStatus === "idle") {
      t8 = null;
      break bb0;
    }
    let t92;
    $[24] !== t ? (t92 = t("publish-dialog.confirm-publish.title"), $[24] = t, $[25] = t92) : t92 = $[25];
    let t102;
    $[26] !== onConfirmDialogClose ? (t102 = () => {
      onConfirmDialogClose?.(), setPublishBundleStatus("idle");
    }, $[26] = onConfirmDialogClose, $[27] = t102) : t102 = $[27];
    let t112;
    $[28] !== t ? (t112 = t("action.publish-all-documents"), $[28] = t, $[29] = t112) : t112 = $[29];
    const t122 = publishBundleStatus === "publishing", t132 = publishBundleStatus === "publishing";
    let t142;
    $[30] !== handleConfirmPublishAll || $[31] !== t112 || $[32] !== t122 || $[33] !== t132 ? (t142 = {
      confirmButton: {
        text: t112,
        tone: "positive",
        onClick: handleConfirmPublishAll,
        loading: t122,
        disabled: t132
      }
    }, $[30] = handleConfirmPublishAll, $[31] = t112, $[32] = t122, $[33] = t132, $[34] = t142) : t142 = $[34];
    let t152;
    $[35] !== release.metadata.title || $[36] !== tCore ? (t152 = release.metadata.title || tCore("release.placeholder-untitled-release"), $[35] = release.metadata.title, $[36] = tCore, $[37] = t152) : t152 = $[37];
    let t162;
    $[38] !== documents.length || $[39] !== t152 ? (t162 = {
      title: t152,
      releaseDocumentsLength: documents.length,
      count: documents.length
    }, $[38] = documents.length, $[39] = t152, $[40] = t162) : t162 = $[40];
    let t172;
    $[41] !== t || $[42] !== t162 ? (t172 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "publish-dialog.confirm-publish-description", values: t162 }) }), $[41] = t, $[42] = t162, $[43] = t172) : t172 = $[43];
    let t182;
    $[44] !== t102 || $[45] !== t142 || $[46] !== t172 || $[47] !== t92 ? (t182 = /* @__PURE__ */ jsx(Dialog$1, { id: "confirm-publish-dialog", "data-testid": "confirm-publish-dialog", header: t92, onClose: t102, footer: t142, children: t172 }), $[44] = t102, $[45] = t142, $[46] = t172, $[47] = t92, $[48] = t182) : t182 = $[48], t8 = t182;
  }
  const confirmPublishDialog = t8;
  let t9;
  bb1: {
    if (!hasDocumentValidationErrors && !isValidatingDocuments && publishPermission) {
      t9 = null;
      break bb1;
    }
    let t102;
    $[49] !== documents.length || $[50] !== hasDocumentValidationErrors || $[51] !== isValidatingDocuments || $[52] !== publishPermission || $[53] !== t ? (t102 = () => documents.length === 0 ? t("publish-action.validation.no-documents") : publishPermission ? isValidatingDocuments ? t("publish-dialog.validation.loading") : hasDocumentValidationErrors ? t("publish-dialog.validation.error") : null : t("publish-dialog.validation.no-permission"), $[49] = documents.length, $[50] = hasDocumentValidationErrors, $[51] = isValidatingDocuments, $[52] = publishPermission, $[53] = t, $[54] = t102) : t102 = $[54];
    const tooltipText = t102, t112 = isValidatingDocuments ? "default" : "critical";
    let t122;
    $[55] !== t112 ? (t122 = /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: t112 }), $[55] = t112, $[56] = t122) : t122 = $[56];
    let t132;
    $[57] !== tooltipText ? (t132 = tooltipText(), $[57] = tooltipText, $[58] = t132) : t132 = $[58];
    let t142;
    $[59] !== t122 || $[60] !== t132 ? (t142 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, padding: 1, children: [
      t122,
      t132
    ] }) }), $[59] = t122, $[60] = t132, $[61] = t142) : t142 = $[61], t9 = t142;
  }
  const publishTooltipContent = t9;
  let t10;
  $[62] !== onConfirmDialogOpen ? (t10 = () => {
    setPublishBundleStatus("confirm"), onConfirmDialogOpen?.();
  }, $[62] = onConfirmDialogOpen, $[63] = t10) : t10 = $[63];
  const handleInitialPublish = t10, t11 = isPublishButtonDisabled || publishBundleStatus === "publishing" || documents.length === 0;
  let t12;
  $[64] !== t ? (t12 = t("action.publish-all-documents"), $[64] = t, $[65] = t12) : t12 = $[65];
  const t13 = !isPublishButtonDisabled;
  let t14;
  $[66] !== publishTooltipContent || $[67] !== t13 ? (t14 = {
    disabled: t13,
    content: publishTooltipContent,
    placement: "bottom"
  }, $[66] = publishTooltipContent, $[67] = t13, $[68] = t14) : t14 = $[68];
  const t15 = t14;
  let t16;
  $[69] !== handleInitialPublish || $[70] !== t11 || $[71] !== t12 || $[72] !== t15 ? (t16 = {
    icon: PublishIcon,
    disabled: t11,
    text: t12,
    handleOnClick: handleInitialPublish,
    tooltipProps: t15
  }, $[69] = handleInitialPublish, $[70] = t11, $[71] = t12, $[72] = t15, $[73] = t16) : t16 = $[73];
  const sharedProps = t16;
  let t17;
  $[74] !== isMenuItem || $[75] !== publishBundleStatus || $[76] !== sharedProps.disabled || $[77] !== sharedProps.handleOnClick || $[78] !== sharedProps.icon || $[79] !== sharedProps.text || $[80] !== sharedProps.tooltipProps ? (t17 = isMenuItem ? /* @__PURE__ */ jsx(MenuItem, { tooltipProps: sharedProps.tooltipProps, icon: sharedProps.icon, disabled: sharedProps.disabled, text: sharedProps.text, onClick: sharedProps.handleOnClick, "data-testid": "publish-all-button-menu-item" }) : /* @__PURE__ */ jsx(Button, { tooltipProps: sharedProps.tooltipProps, icon: sharedProps.icon, disabled: sharedProps.disabled, text: sharedProps.text, onClick: sharedProps.handleOnClick, loading: publishBundleStatus === "publishing", "data-testid": "publish-all-button", tone: "positive" }), $[74] = isMenuItem, $[75] = publishBundleStatus, $[76] = sharedProps.disabled, $[77] = sharedProps.handleOnClick, $[78] = sharedProps.icon, $[79] = sharedProps.text, $[80] = sharedProps.tooltipProps, $[81] = t17) : t17 = $[81];
  let t18;
  return $[82] !== confirmPublishDialog || $[83] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t17,
    confirmPublishDialog
  ] }), $[82] = confirmPublishDialog, $[83] = t17, $[84] = t18) : t18 = $[84], t18;
};
function _temp$25(t0) {
  const {
    validation: validation2
  } = t0;
  return validation2.isValidating;
}
function _temp2$R(t0) {
  const {
    validation: validation_0
  } = t0;
  return validation_0.hasError;
}
function promiseWithResolvers() {
  let resolve, reject;
  return {
    promise: new Promise((res, rej) => {
      resolve = res, reject = rej;
    }),
    resolve,
    reject
  };
}
const useDocumentRevertStates = (releaseDocuments) => {
  const $ = c(15), client = useClient(RELEASES_STUDIO_CLIENT_OPTIONS), observableClient = client.observable, transactionId = releaseDocuments[0]?.document._rev;
  let t0;
  $[0] !== client ? (t0 = client.config(), $[0] = client, $[1] = t0) : t0 = $[1];
  const {
    dataset
  } = t0, resultPromiseRef = useRef(null), resolvedDocumentRevertStatesPromiseRef = useRef(null), resolvedDocumentRevertStatesResultRef = useRef(null);
  let t1, t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    if (!resultPromiseRef.current) {
      const {
        promise,
        resolve
      } = promiseWithResolvers();
      resultPromiseRef.current = promise, resolvedDocumentRevertStatesPromiseRef.current = resolve;
    }
  }, t2 = [], $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  let t3;
  bb0: {
    if (!releaseDocuments.length) {
      let t43;
      $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t43 = of(void 0), $[4] = t43) : t43 = $[4], t3 = t43;
      break bb0;
    }
    let t42;
    if ($[5] !== client || $[6] !== dataset || $[7] !== observableClient || $[8] !== releaseDocuments || $[9] !== transactionId) {
      const publishedDocuments = releaseDocuments.map(_temp$24);
      t42 = from(getTransactionsLogs(client, publishedDocuments.map(_temp2$Q), {
        toTransaction: transactionId,
        reverse: !0
      })).pipe(map$1((transactions) => {
        const getDocumentTransaction = (docId) => transactions.find((t52) => {
          const {
            documentIDs
          } = t52;
          return documentIDs.includes(docId);
        })?.id;
        return publishedDocuments.map((document_1) => ({
          docId: document_1._id,
          revisionId: getDocumentTransaction(document_1._id)
        }));
      }), switchMap$1((docRevisionPairs) => docRevisionPairs ? forkJoin(docRevisionPairs.map((t62) => {
        const {
          docId: docId_0,
          revisionId
        } = t62;
        if (!revisionId) {
          const {
            publishedDocumentExists,
            ...unpublishDocument
          } = publishedDocuments.find((document_2) => document_2._id === docId_0) || {};
          return of({
            ...unpublishDocument,
            _system: {
              delete: !0
            }
          });
        }
        return observableClient.request({
          url: `/data/history/${dataset}/documents/${docId_0}?revision=${revisionId}`
        }).pipe(map$1(_temp3$q), catchError$1((err) => (console.error(`Error fetching document ${docId_0}:`, err), of(void 0))));
      })) : of(void 0)), map$1(_temp5$8), catchError$1(_temp6$3)), $[5] = client, $[6] = dataset, $[7] = observableClient, $[8] = releaseDocuments, $[9] = transactionId, $[10] = t42;
    } else
      t42 = $[10];
    t3 = t42;
  }
  const documentRevertStatesResult = useObservable(t3, null);
  let t4, t5;
  $[11] !== documentRevertStatesResult ? (t4 = () => {
    documentRevertStatesResult !== null && (resolvedDocumentRevertStatesResultRef.current = documentRevertStatesResult, resolvedDocumentRevertStatesPromiseRef.current && (resolvedDocumentRevertStatesPromiseRef.current(documentRevertStatesResult), resolvedDocumentRevertStatesPromiseRef.current = null, resultPromiseRef.current = null));
  }, t5 = [documentRevertStatesResult], $[11] = documentRevertStatesResult, $[12] = t4, $[13] = t5) : (t4 = $[12], t5 = $[13]), useEffect(t4, t5);
  let t6;
  return $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = () => resolvedDocumentRevertStatesResultRef.current ? Promise.resolve(resolvedDocumentRevertStatesResultRef.current) : resultPromiseRef.current, $[14] = t6) : t6 = $[14], t6;
};
function _temp$24(t0) {
  const {
    document: document2
  } = t0;
  return {
    ...document2,
    _id: getPublishedId(document2._id)
  };
}
function _temp2$Q(document_0) {
  return document_0._id;
}
function _temp3$q(t0) {
  const {
    documents: t1
  } = t0, [revertDocument] = t1;
  return revertDocument;
}
function _temp4$c(result) {
  return result !== void 0;
}
function _temp5$8(results) {
  return results?.filter(_temp4$c);
}
function _temp6$3(err_0) {
  return console.error("Error in document revert states pipeline:", err_0), of(void 0);
}
const usePostPublishTransactions = (documents) => {
  const $ = c(5), client = useClient(RELEASES_STUDIO_CLIENT_OPTIONS), transactionId = documents[0]?.document._rev;
  let t0;
  bb0: {
    if (!documents.length) {
      let t12;
      $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = of(!1), $[0] = t12) : t12 = $[0], t0 = t12;
      break bb0;
    }
    let t1;
    $[1] !== client || $[2] !== documents || $[3] !== transactionId ? (t1 = from(getTransactionsLogs(client, documents.map(_temp$23), {
      fromTransaction: transactionId,
      limit: 2
    })).pipe(map$1(_temp2$P), catchError$1(_temp3$p)), $[1] = client, $[2] = documents, $[3] = transactionId, $[4] = t1) : t1 = $[4], t0 = t1;
  }
  return useObservable(t0, null);
};
function _temp$23(t0) {
  const {
    document: document2
  } = t0;
  return getPublishedId(document2._id);
}
function _temp2$P(transactions) {
  return transactions.length > 1;
}
function _temp3$p() {
  return of(null);
}
const ConfirmReleaseDialog = (t0) => {
  const $ = c(56), {
    revertReleaseStatus,
    documents,
    setRevertReleaseStatus,
    release
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation();
  let t1;
  $[0] !== release.metadata.title || $[1] !== tCore ? (t1 = release.metadata.title || tCore("release.placeholder-untitled-release"), $[0] = release.metadata.title, $[1] = tCore, $[2] = t1) : t1 = $[2];
  const releaseDisplayTitle = t1, hasPostPublishTransactions = usePostPublishTransactions(documents), getDocumentRevertStates = useDocumentRevertStates(documents), [stageNewRevertRelease, setStageNewRevertRelease] = useState(!0), toast = useToast(), telemetry = useTelemetry(), {
    revertRelease
  } = useReleaseOperations(), router = useRouter();
  let t2;
  $[3] !== router ? (t2 = (revertReleaseId) => () => router.navigate({
    releaseId: getReleaseIdFromReleaseDocumentId(revertReleaseId)
  }), $[3] = router, $[4] = t2) : t2 = $[4];
  const navigateToRevertRelease = t2;
  let t3;
  $[5] !== getDocumentRevertStates || $[6] !== navigateToRevertRelease || $[7] !== releaseDisplayTitle || $[8] !== revertRelease || $[9] !== setRevertReleaseStatus || $[10] !== stageNewRevertRelease || $[11] !== t || $[12] !== telemetry || $[13] !== toast ? (t3 = async () => {
    setRevertReleaseStatus("reverting");
    const documentRevertStates = await getDocumentRevertStates(), revertReleaseId_0 = createReleaseId();
    await (async () => {
      if (!documentRevertStates)
        throw new Error("Unable to find documents to revert");
      await revertRelease(revertReleaseId_0, documentRevertStates, {
        title: t("revert-release.title", {
          title: releaseDisplayTitle
        }),
        description: t("revert-release.description", {
          title: releaseDisplayTitle
        }),
        releaseType: "asap"
      }, stageNewRevertRelease ? "staged" : "immediate"), stageNewRevertRelease ? (telemetry.log(RevertRelease, {
        revertType: "staged"
      }), toast.push({
        closable: !0,
        status: "success",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { components: {
          Link: () => /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", "data-as": "a", onClick: navigateToRevertRelease(revertReleaseId_0), style: {
            cursor: "pointer",
            marginBottom: "0.5rem",
            display: "flex"
          }, "data-testid": "revert-stage-success-link", children: t("toast.revert-stage.success-link") })
        }, t, i18nKey: "toast.revert-stage.success", values: {
          title: releaseDisplayTitle
        } }) })
      })) : (telemetry.log(RevertRelease, {
        revertType: "immediate"
      }), toast.push({
        closable: !0,
        status: "success",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "toast.immediate-revert.success", values: {
          title: releaseDisplayTitle
        } }) })
      }));
    })().catch((revertError) => {
      isReleaseLimitError(revertError) || (toast.push({
        status: "error",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "toast.revert.error", values: {
          error: revertError.message
        } }) })
      }), console.error(revertError));
    }).finally(() => {
      setRevertReleaseStatus("idle");
    });
  }, $[5] = getDocumentRevertStates, $[6] = navigateToRevertRelease, $[7] = releaseDisplayTitle, $[8] = revertRelease, $[9] = setRevertReleaseStatus, $[10] = stageNewRevertRelease, $[11] = t, $[12] = telemetry, $[13] = toast, $[14] = t3) : t3 = $[14];
  const handleRevertRelease = t3, description = documents.length > 1 ? "revert-dialog.confirm-revert-description_other" : "revert-dialog.confirm-revert-description_one";
  let t4;
  $[15] !== releaseDisplayTitle || $[16] !== t ? (t4 = t("revert-dialog.confirm-revert.title", {
    title: releaseDisplayTitle
  }), $[15] = releaseDisplayTitle, $[16] = t, $[17] = t4) : t4 = $[17];
  let t5;
  $[18] !== setRevertReleaseStatus ? (t5 = () => setRevertReleaseStatus("idle"), $[18] = setRevertReleaseStatus, $[19] = t5) : t5 = $[19];
  const t6 = stageNewRevertRelease ? "action.create-revert-release" : "action.immediate-revert-release";
  let t7;
  $[20] !== t || $[21] !== t6 ? (t7 = t(t6), $[20] = t, $[21] = t6, $[22] = t7) : t7 = $[22];
  const t8 = revertReleaseStatus === "reverting", t9 = revertReleaseStatus === "reverting";
  let t10;
  $[23] !== handleRevertRelease || $[24] !== t7 || $[25] !== t8 || $[26] !== t9 ? (t10 = {
    confirmButton: {
      text: t7,
      tone: "positive",
      onClick: handleRevertRelease,
      loading: t8,
      disabled: t9
    }
  }, $[23] = handleRevertRelease, $[24] = t7, $[25] = t8, $[26] = t9, $[27] = t10) : t10 = $[27];
  let t11;
  $[28] !== documents.length ? (t11 = {
    releaseDocumentsLength: documents.length
  }, $[28] = documents.length, $[29] = t11) : t11 = $[29];
  let t12;
  $[30] !== description || $[31] !== t || $[32] !== t11 ? (t12 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: description, values: t11 }) }), $[30] = description, $[31] = t, $[32] = t11, $[33] = t12) : t12 = $[33];
  let t13;
  $[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = () => setStageNewRevertRelease(_temp$22), $[34] = t13) : t13 = $[34];
  let t14;
  $[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t14 = {
    display: "block"
  }, $[35] = t14) : t14 = $[35];
  const t15 = !stageNewRevertRelease;
  let t16;
  $[36] !== t15 ? (t16 = /* @__PURE__ */ jsx(Checkbox$1, { onChange: t13, id: "immediate-revert-release", style: t14, checked: t15 }), $[36] = t15, $[37] = t16) : t16 = $[37];
  let t17;
  $[38] !== t ? (t17 = t("revert-dialog.confirm-revert.stage-revert-checkbox-label"), $[38] = t, $[39] = t17) : t17 = $[39];
  let t18;
  $[40] !== t17 ? (t18 = /* @__PURE__ */ jsx(Box, { flex: 1, paddingLeft: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx("label", { htmlFor: "immediate-revert-release", children: t17 }) }) }), $[40] = t17, $[41] = t18) : t18 = $[41];
  let t19;
  $[42] !== t16 || $[43] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Flex, { align: "center", paddingTop: 4, children: [
    t16,
    t18
  ] }), $[42] = t16, $[43] = t18, $[44] = t19) : t19 = $[44];
  let t20;
  $[45] !== hasPostPublishTransactions || $[46] !== stageNewRevertRelease || $[47] !== t ? (t20 = hasPostPublishTransactions && !stageNewRevertRelease && /* @__PURE__ */ jsx(Card, { marginTop: 4, padding: 3, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t("revert-dialog.confirm-revert.warning-card") }) }), $[45] = hasPostPublishTransactions, $[46] = stageNewRevertRelease, $[47] = t, $[48] = t20) : t20 = $[48];
  let t21;
  return $[49] !== t10 || $[50] !== t12 || $[51] !== t19 || $[52] !== t20 || $[53] !== t4 || $[54] !== t5 ? (t21 = /* @__PURE__ */ jsxs(Dialog$1, { id: "confirm-revert-dialog", header: t4, onClose: t5, footer: t10, children: [
    t12,
    t19,
    t20
  ] }), $[49] = t10, $[50] = t12, $[51] = t19, $[52] = t20, $[53] = t4, $[54] = t5, $[55] = t21) : t21 = $[55], t21;
}, ReleaseRevertButton = (t0) => {
  const $ = c(25), {
    release,
    documents,
    disabled
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), {
    guardWithReleaseLimitUpsell
  } = useReleasesUpsell(), [revertReleaseStatus, setRevertReleaseStatus] = useState("idle"), [isPendingGuardResponse, setIsPendingGuardResponse] = useState(!1), {
    createRelease
  } = useReleaseOperations(), {
    checkWithPermissionGuard
  } = useReleasePermissions(), [hasCreatePermission, setHasCreatePermission] = useState(null);
  let t1;
  $[0] !== guardWithReleaseLimitUpsell ? (t1 = async () => {
    setIsPendingGuardResponse(!0), await guardWithReleaseLimitUpsell(() => setRevertReleaseStatus("confirm")), setIsPendingGuardResponse(!1);
  }, $[0] = guardWithReleaseLimitUpsell, $[1] = t1) : t1 = $[1];
  const handleMoveToConfirmStatus = t1, isMounted = useRef(!1);
  let t2, t3;
  $[2] !== checkWithPermissionGuard || $[3] !== createRelease ? (t2 = () => (isMounted.current = !0, checkWithPermissionGuard(createRelease, getReleaseDefaults()).then((hasPermissions) => {
    isMounted.current && setHasCreatePermission(hasPermissions);
  }), () => {
    isMounted.current = !1;
  }), t3 = [checkWithPermissionGuard, createRelease], $[2] = checkWithPermissionGuard, $[3] = createRelease, $[4] = t2, $[5] = t3) : (t2 = $[4], t3 = $[5]), useEffect(t2, t3);
  let t4;
  $[6] !== t ? (t4 = t("action.revert"), $[6] = t, $[7] = t4) : t4 = $[7];
  const t5 = hasCreatePermission === !0;
  let t6;
  $[8] !== tCore ? (t6 = tCore("release.action.permission.error"), $[8] = tCore, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== t5 || $[11] !== t6 ? (t7 = {
    disabled: t5,
    content: t6
  }, $[10] = t5, $[11] = t6, $[12] = t7) : t7 = $[12];
  const t8 = isPendingGuardResponse || !hasCreatePermission || disabled;
  let t9;
  $[13] !== handleMoveToConfirmStatus || $[14] !== t4 || $[15] !== t7 || $[16] !== t8 ? (t9 = /* @__PURE__ */ jsx(Button, { icon: RestoreIcon, onClick: handleMoveToConfirmStatus, text: t4, tone: "critical", tooltipProps: t7, disabled: t8, "data-testid": "revert-button" }), $[13] = handleMoveToConfirmStatus, $[14] = t4, $[15] = t7, $[16] = t8, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== documents || $[19] !== release || $[20] !== revertReleaseStatus ? (t10 = revertReleaseStatus !== "idle" && /* @__PURE__ */ jsx(ConfirmReleaseDialog, { release, documents, revertReleaseStatus, setRevertReleaseStatus }), $[18] = documents, $[19] = release, $[20] = revertReleaseStatus, $[21] = t10) : t10 = $[21];
  let t11;
  return $[22] !== t10 || $[23] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t9,
    t10
  ] }), $[22] = t10, $[23] = t9, $[24] = t11) : t11 = $[24], t11;
};
function _temp$22(current) {
  return !current;
}
const ReleaseScheduleButton = (t0) => {
  const $ = c(143), {
    release,
    disabled,
    documents,
    isMenuItem: t1,
    onConfirmDialogOpen,
    onConfirmDialogClose
  } = t0, isMenuItem = t1 === void 0 ? !1 : t1, toast = useToast(), {
    schedule,
    updateRelease
  } = useReleaseOperations(), {
    checkWithPermissionGuard
  } = useReleasePermissions(), [schedulePermission, setSchedulePermission] = useState(!1), {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), telemetry = useTelemetry(), {
    utcToCurrentZoneDate,
    zoneDateToUtc,
    timeZone
  } = useTimeZone(CONTENT_RELEASES_TIME_ZONE_SCOPE), [status, setStatus] = useState("idle"), [publishAt, setPublishAt] = useState(), [rerenderDialog, setRerenderDialog] = useState(0);
  let t2;
  $[0] !== publishAt || $[1] !== utcToCurrentZoneDate ? (t2 = publishAt ? utcToCurrentZoneDate(publishAt) : void 0, $[0] = publishAt, $[1] = utcToCurrentZoneDate, $[2] = t2) : t2 = $[2];
  const timeZoneAdjustedPublishAt = t2;
  let t3;
  $[3] !== documents ? (t3 = documents.some(_temp$21), $[3] = documents, $[4] = t3) : t3 = $[4];
  const isValidatingDocuments = t3;
  let t4;
  $[5] !== documents ? (t4 = documents.some(_temp2$O), $[5] = documents, $[6] = t4) : t4 = $[6];
  const hasDocumentValidationErrors = t4, isScheduleButtonDisabled = disabled || isValidatingDocuments || !schedulePermission || hasDocumentValidationErrors, isMounted = useRef(!1);
  let t5;
  $[7] !== checkWithPermissionGuard || $[8] !== release._id || $[9] !== schedule ? (t5 = () => (isMounted.current = !0, checkWithPermissionGuard(schedule, release._id, /* @__PURE__ */ new Date()).then((hasPermission) => {
    isMounted.current && setSchedulePermission(hasPermission);
  }), () => {
    isMounted.current = !1;
  }), $[7] = checkWithPermissionGuard, $[8] = release._id, $[9] = schedule, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== checkWithPermissionGuard || $[12] !== release._id || $[13] !== release.metadata.intendedPublishAt || $[14] !== schedule ? (t6 = [checkWithPermissionGuard, release._id, release.metadata.intendedPublishAt, schedule], $[11] = checkWithPermissionGuard, $[12] = release._id, $[13] = release.metadata.intendedPublishAt, $[14] = schedule, $[15] = t6) : t6 = $[15], useEffect(t5, t6);
  let t7;
  $[16] !== publishAt || $[17] !== zoneDateToUtc ? (t7 = () => isBefore(zoneDateToUtc(publishAt || /* @__PURE__ */ new Date()), /* @__PURE__ */ new Date()), $[16] = publishAt, $[17] = zoneDateToUtc, $[18] = t7) : t7 = $[18];
  const isScheduledDateInPast = t7;
  let t8;
  $[19] !== isMenuItem || $[20] !== isScheduledDateInPast || $[21] !== onConfirmDialogClose || $[22] !== publishAt || $[23] !== release || $[24] !== schedule || $[25] !== t || $[26] !== tCore || $[27] !== telemetry || $[28] !== toast || $[29] !== updateRelease ? (t8 = async () => {
    if (!publishAt)
      return;
    if (isMenuItem) {
      const newRelease = {
        ...release,
        metadata: {
          ...release.metadata,
          releaseType: "scheduled",
          intendedPublishAt: publishAt.toISOString()
        }
      };
      isEqual$1(newRelease, release) || updateRelease(newRelease);
    }
    if (isScheduledDateInPast()) {
      setRerenderDialog(_temp3$o);
      return;
    }
    const run = async () => {
      setStatus("scheduling"), await schedule(release._id, publishAt), telemetry.log(ScheduledRelease), toast.push({
        closable: !0,
        status: "info",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "toast.schedule.success", values: {
          title: release.metadata.title || tCore("release.placeholder-untitled-release")
        } }) })
      });
    };
    try {
      await run();
    } catch (t92) {
      const schedulingError = t92;
      toast.push({
        status: "error",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "toast.schedule.error", values: {
          title: release.metadata.title || tCore("release.placeholder-untitled-release"),
          error: schedulingError.message
        } }) })
      }), console.error(schedulingError);
    }
    onConfirmDialogClose?.(), setStatus("idle");
  }, $[19] = isMenuItem, $[20] = isScheduledDateInPast, $[21] = onConfirmDialogClose, $[22] = publishAt, $[23] = release, $[24] = schedule, $[25] = t, $[26] = tCore, $[27] = telemetry, $[28] = toast, $[29] = updateRelease, $[30] = t8) : t8 = $[30];
  const handleConfirmSchedule = t8;
  let t9;
  $[31] !== tCore ? (t9 = getCalendarLabels(tCore), $[31] = tCore, $[32] = t9) : t9 = $[32];
  const calendarLabels = t9;
  let t10;
  $[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = (date) => {
    date && setPublishAt(startOfMinute(date));
  }, $[33] = t10) : t10 = $[33];
  const handleBundlePublishAtCalendarChange = t10;
  let t11;
  $[34] !== zoneDateToUtc ? (t11 = (event) => {
    const date_0 = event.currentTarget.value, parsedDate = zoneDateToUtc(parse(date_0, "PP HH:mm", /* @__PURE__ */ new Date()));
    isValid(parsedDate) && setPublishAt(parsedDate);
  }, $[34] = zoneDateToUtc, $[35] = t11) : t11 = $[35];
  const handleBundleInputChange = t11;
  let t12;
  $[36] !== onConfirmDialogClose || $[37] !== status ? (t12 = () => {
    onConfirmDialogClose?.(), status !== "scheduling" && setStatus("idle");
  }, $[36] = onConfirmDialogClose, $[37] = status, $[38] = t12) : t12 = $[38];
  const handleOnDialogClose = t12;
  let t13;
  bb0: {
    if (status === "idle") {
      t13 = null;
      break bb0;
    }
    let t142;
    $[39] !== isScheduledDateInPast ? (t142 = isScheduledDateInPast(), $[39] = isScheduledDateInPast, $[40] = t142) : t142 = $[40];
    const _isScheduledDateInPast = t142;
    let t152;
    $[41] !== documents.length || $[42] !== t ? (t152 = t("schedule-dialog.confirm-title", {
      documentsLength: documents.length,
      count: documents.length
    }), $[41] = documents.length, $[42] = t, $[43] = t152) : t152 = $[43];
    let t162;
    $[44] !== t ? (t162 = t("schedule-dialog.confirm-button"), $[44] = t, $[45] = t162) : t162 = $[45];
    const t172 = status === "scheduling", t182 = _isScheduledDateInPast || status === "scheduling";
    let t192;
    $[46] !== handleConfirmSchedule || $[47] !== t162 || $[48] !== t172 || $[49] !== t182 ? (t192 = {
      text: t162,
      tone: "default",
      onClick: handleConfirmSchedule,
      loading: t172,
      disabled: t182
    }, $[46] = handleConfirmSchedule, $[47] = t162, $[48] = t172, $[49] = t182, $[50] = t192) : t192 = $[50];
    const t202 = status === "scheduling";
    let t212;
    $[51] !== t202 ? (t212 = {
      disabled: t202
    }, $[51] = t202, $[52] = t212) : t212 = $[52];
    let t222;
    $[53] !== t192 || $[54] !== t212 ? (t222 = {
      confirmButton: t192,
      cancelButton: t212
    }, $[53] = t192, $[54] = t212, $[55] = t222) : t222 = $[55];
    let t232;
    $[56] !== _isScheduledDateInPast || $[57] !== tCore ? (t232 = _isScheduledDateInPast && /* @__PURE__ */ jsx(Card, { marginBottom: 1, padding: 2, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: tCore("release.schedule-dialog.publish-date-in-past-warning") }) }), $[56] = _isScheduledDateInPast, $[57] = tCore, $[58] = t232) : t232 = $[58];
    let t242;
    $[59] !== tCore ? (t242 = tCore("release.schedule-dialog.select-publish-date-label"), $[59] = tCore, $[60] = t242) : t242 = $[60];
    let t252;
    $[61] !== t242 ? (t252 = /* @__PURE__ */ jsx("label", { children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t242 }) }), $[61] = t242, $[62] = t252) : t252 = $[62];
    let t262;
    $[63] !== tCore ? (t262 = tCore("release.schedule-dialog.select-publish-date-label"), $[63] = tCore, $[64] = t262) : t262 = $[64];
    let t27;
    $[65] !== t262 || $[66] !== timeZone.alternativeName || $[67] !== timeZone.offset ? (t27 = {
      title: t262,
      alternativeName: timeZone.alternativeName,
      offset: timeZone.offset
    }, $[65] = t262, $[66] = timeZone.alternativeName, $[67] = timeZone.offset, $[68] = t27) : t27 = $[68];
    let t28;
    $[69] !== t27 || $[70] !== tCore ? (t28 = /* @__PURE__ */ jsx(TimeZoneButtonElementQuery$1, { children: /* @__PURE__ */ jsx(TimeZoneButton, { tooltipContent: /* @__PURE__ */ jsx(Translate, { t: tCore, i18nKey: "time-zone.time-zone-tooltip-input", values: t27 }), allowTimeZoneSwitch: !0, useElementQueries: !0, timeZoneScope: CONTENT_RELEASES_TIME_ZONE_SCOPE }) }), $[69] = t27, $[70] = tCore, $[71] = t28) : t28 = $[71];
    let t29;
    $[72] !== t252 || $[73] !== t28 ? (t29 = /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-between", gap: 2, children: [
      t252,
      t28
    ] }), $[72] = t252, $[73] = t28, $[74] = t29) : t29 = $[74];
    let t30;
    $[75] !== timeZoneAdjustedPublishAt ? (t30 = timeZoneAdjustedPublishAt ? format(timeZoneAdjustedPublishAt, "PP HH:mm") : "", $[75] = timeZoneAdjustedPublishAt, $[76] = t30) : t30 = $[76];
    let t31;
    $[77] !== calendarLabels || $[78] !== handleBundleInputChange || $[79] !== publishAt || $[80] !== t30 ? (t31 = /* @__PURE__ */ jsx(DateTimeInput$3, { selectTime: !0, monthPickerVariant: MONTH_PICKER_VARIANT.carousel, onChange: handleBundlePublishAtCalendarChange, onInputChange: handleBundleInputChange, value: publishAt, calendarLabels, inputValue: t30, constrainSize: !1, isPastDisabled: !0, timeZoneScope: CONTENT_RELEASES_TIME_ZONE_SCOPE }), $[77] = calendarLabels, $[78] = handleBundleInputChange, $[79] = publishAt, $[80] = t30, $[81] = t31) : t31 = $[81];
    let t32;
    $[82] !== t29 || $[83] !== t31 ? (t32 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      t29,
      t31
    ] }), $[82] = t29, $[83] = t31, $[84] = t32) : t32 = $[84];
    let t33;
    $[85] !== release.metadata.title || $[86] !== tCore ? (t33 = release.metadata.title || tCore("release.placeholder-untitled-release"), $[85] = release.metadata.title, $[86] = tCore, $[87] = t33) : t33 = $[87];
    let t34;
    $[88] !== documents.length || $[89] !== t33 ? (t34 = {
      title: t33,
      count: documents.length
    }, $[88] = documents.length, $[89] = t33, $[90] = t34) : t34 = $[90];
    let t35;
    $[91] !== t || $[92] !== t34 ? (t35 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "schedule-dialog.confirm-description", values: t34 }) }), $[91] = t, $[92] = t34, $[93] = t35) : t35 = $[93];
    let t36;
    $[94] !== t232 || $[95] !== t32 || $[96] !== t35 ? (t36 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      t232,
      t32,
      t35
    ] }), $[94] = t232, $[95] = t32, $[96] = t35, $[97] = t36) : t36 = $[97];
    let t37;
    $[98] !== handleOnDialogClose || $[99] !== rerenderDialog || $[100] !== t152 || $[101] !== t222 || $[102] !== t36 ? (t37 = /* @__PURE__ */ jsx(Dialog$1, { id: "confirm-schedule-dialog", "data-testid": "confirm-schedule-dialog", header: t152, onClose: handleOnDialogClose, footer: t222, children: t36 }, rerenderDialog), $[98] = handleOnDialogClose, $[99] = rerenderDialog, $[100] = t152, $[101] = t222, $[102] = t36, $[103] = t37) : t37 = $[103], t13 = t37;
  }
  const confirmScheduleDialog = t13;
  let t14;
  $[104] !== onConfirmDialogOpen || $[105] !== release.metadata.intendedPublishAt ? (t14 = () => {
    setPublishAt(release.metadata.intendedPublishAt ? new Date(release.metadata.intendedPublishAt) : /* @__PURE__ */ new Date()), setStatus("confirm"), onConfirmDialogOpen?.();
  }, $[104] = onConfirmDialogOpen, $[105] = release.metadata.intendedPublishAt, $[106] = t14) : t14 = $[106];
  const handleOnInitialSchedule = t14;
  let t15;
  bb1: {
    if (documents.length === 0) {
      let t162;
      $[107] !== t ? (t162 = t("schedule-action.validation.no-documents"), $[107] = t, $[108] = t162) : t162 = $[108], t15 = t162;
      break bb1;
    }
    if (!schedulePermission) {
      let t162;
      $[109] !== t ? (t162 = t("schedule-button-tooltip.validation.no-permission"), $[109] = t, $[110] = t162) : t162 = $[110], t15 = t162;
      break bb1;
    }
    if (isValidatingDocuments) {
      let t162;
      $[111] !== t ? (t162 = t("schedule-button-tooltip.validation.loading"), $[111] = t, $[112] = t162) : t162 = $[112], t15 = t162;
      break bb1;
    }
    if (hasDocumentValidationErrors) {
      let t162;
      $[113] !== t ? (t162 = t("schedule-button-tooltip.validation.error"), $[113] = t, $[114] = t162) : t162 = $[114], t15 = t162;
      break bb1;
    }
    if (isReleaseScheduledOrScheduling(release)) {
      let t162;
      $[115] !== t ? (t162 = t("schedule-button-tooltip.already-scheduled"), $[115] = t, $[116] = t162) : t162 = $[116], t15 = t162;
      break bb1;
    }
    t15 = null;
  }
  const tooltipText = t15, t16 = isValidatingDocuments ? "default" : "critical";
  let t17;
  $[117] !== t16 ? (t17 = /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: t16 }), $[117] = t16, $[118] = t17) : t17 = $[118];
  let t18;
  $[119] !== t17 || $[120] !== tooltipText ? (t18 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, padding: 1, children: [
    t17,
    tooltipText
  ] }) }), $[119] = t17, $[120] = tooltipText, $[121] = t18) : t18 = $[121];
  const scheduleTooltipContent = t18, t19 = isScheduleButtonDisabled || status === "scheduling" || documents.length === 0;
  let t20;
  $[122] !== t ? (t20 = t("action.schedule"), $[122] = t, $[123] = t20) : t20 = $[123];
  const t21 = !tooltipText;
  let t22;
  $[124] !== scheduleTooltipContent || $[125] !== t21 ? (t22 = {
    disabled: t21,
    content: scheduleTooltipContent,
    placement: "bottom"
  }, $[124] = scheduleTooltipContent, $[125] = t21, $[126] = t22) : t22 = $[126];
  const t23 = t22;
  let t24;
  $[127] !== handleOnInitialSchedule || $[128] !== t19 || $[129] !== t20 || $[130] !== t23 ? (t24 = {
    icon: ClockIcon,
    disabled: t19,
    text: t20,
    handleOnClick: handleOnInitialSchedule,
    tooltipProps: t23
  }, $[127] = handleOnInitialSchedule, $[128] = t19, $[129] = t20, $[130] = t23, $[131] = t24) : t24 = $[131];
  const sharedProps = t24;
  let t25;
  $[132] !== isMenuItem || $[133] !== sharedProps.disabled || $[134] !== sharedProps.handleOnClick || $[135] !== sharedProps.icon || $[136] !== sharedProps.text || $[137] !== sharedProps.tooltipProps || $[138] !== status ? (t25 = isMenuItem ? /* @__PURE__ */ jsx(MenuItem, { tooltipProps: sharedProps.tooltipProps, icon: sharedProps.icon, disabled: sharedProps.disabled, text: sharedProps.text, onClick: sharedProps.handleOnClick, "data-testid": "schedule-button-menu-item" }) : /* @__PURE__ */ jsx(Button, { tooltipProps: sharedProps.tooltipProps, tone: "primary", icon: sharedProps.icon, disabled: sharedProps.disabled, text: sharedProps.text, onClick: sharedProps.handleOnClick, loading: status === "scheduling", "data-testid": "schedule-button" }), $[132] = isMenuItem, $[133] = sharedProps.disabled, $[134] = sharedProps.handleOnClick, $[135] = sharedProps.icon, $[136] = sharedProps.text, $[137] = sharedProps.tooltipProps, $[138] = status, $[139] = t25) : t25 = $[139];
  let t26;
  return $[140] !== confirmScheduleDialog || $[141] !== t25 ? (t26 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t25,
    confirmScheduleDialog
  ] }), $[140] = confirmScheduleDialog, $[141] = t25, $[142] = t26) : t26 = $[142], t26;
};
function _temp$21(t0) {
  const {
    validation: validation2
  } = t0;
  return validation2.isValidating;
}
function _temp2$O(t0) {
  const {
    validation: validation_0
  } = t0;
  return validation_0.hasError;
}
function _temp3$o(cur) {
  return cur + 1;
}
const ReleaseUnscheduleButton = (t0) => {
  const $ = c(48), {
    release,
    disabled,
    documents
  } = t0, toast = useToast(), {
    unschedule
  } = useReleaseOperations(), {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), telemetry = useTelemetry(), [status, setStatus] = useState("idle");
  let t1;
  $[0] !== release._id || $[1] !== release.metadata.title || $[2] !== t || $[3] !== tCore || $[4] !== telemetry || $[5] !== toast || $[6] !== unschedule ? (t1 = async () => {
    await (async () => {
      setStatus("unscheduling"), await unschedule(release._id), telemetry.log(UnscheduledRelease);
    })().catch((schedulingError) => {
      toast.push({
        status: "error",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "toast.unschedule.error", values: {
          title: release.metadata.title || tCore("release.placeholder-untitled-release"),
          error: schedulingError.message
        } }) })
      }), console.error(schedulingError);
    }).finally(() => {
      setStatus("idle");
    });
  }, $[0] = release._id, $[1] = release.metadata.title, $[2] = t, $[3] = tCore, $[4] = telemetry, $[5] = toast, $[6] = unschedule, $[7] = t1) : t1 = $[7];
  const handleConfirmSchedule = t1;
  let t2;
  bb0: {
    if (status === "idle") {
      t2 = null;
      break bb0;
    }
    let t32;
    $[8] !== t ? (t32 = t("unschedule-dialog.confirm-title"), $[8] = t, $[9] = t32) : t32 = $[9];
    let t42;
    $[10] !== status ? (t42 = () => status !== "unscheduling" && setStatus("idle"), $[10] = status, $[11] = t42) : t42 = $[11];
    let t52;
    $[12] !== t ? (t52 = t("action.unschedule"), $[12] = t, $[13] = t52) : t52 = $[13];
    const t62 = status === "unscheduling", t72 = status === "unscheduling";
    let t82;
    $[14] !== handleConfirmSchedule || $[15] !== t52 || $[16] !== t62 || $[17] !== t72 ? (t82 = {
      text: t52,
      tone: "default",
      onClick: handleConfirmSchedule,
      loading: t62,
      disabled: t72
    }, $[14] = handleConfirmSchedule, $[15] = t52, $[16] = t62, $[17] = t72, $[18] = t82) : t82 = $[18];
    const t9 = status === "unscheduling";
    let t10;
    $[19] !== t9 ? (t10 = {
      disabled: t9
    }, $[19] = t9, $[20] = t10) : t10 = $[20];
    let t11;
    $[21] !== t10 || $[22] !== t82 ? (t11 = {
      confirmButton: t82,
      cancelButton: t10
    }, $[21] = t10, $[22] = t82, $[23] = t11) : t11 = $[23];
    let t12;
    $[24] !== release.metadata.title || $[25] !== tCore ? (t12 = release.metadata.title || tCore("release.placeholder-untitled-release"), $[24] = release.metadata.title, $[25] = tCore, $[26] = t12) : t12 = $[26];
    let t13;
    $[27] !== documents.length || $[28] !== t12 ? (t13 = {
      title: t12,
      documentsLength: documents.length,
      count: documents.length
    }, $[27] = documents.length, $[28] = t12, $[29] = t13) : t13 = $[29];
    let t14;
    $[30] !== t || $[31] !== t13 ? (t14 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "unschedule-dialog.confirm-description", values: t13 }) }), $[30] = t, $[31] = t13, $[32] = t14) : t14 = $[32];
    let t15;
    $[33] !== t11 || $[34] !== t14 || $[35] !== t32 || $[36] !== t42 ? (t15 = /* @__PURE__ */ jsx(Dialog$1, { id: "confirm-unschedule-dialog", header: t32, onClose: t42, footer: t11, children: t14 }), $[33] = t11, $[34] = t14, $[35] = t32, $[36] = t42, $[37] = t15) : t15 = $[37], t2 = t15;
  }
  const confirmScheduleDialog = t2, t3 = disabled || status === "unscheduling";
  let t4;
  $[38] !== t ? (t4 = t("action.unschedule"), $[38] = t, $[39] = t4) : t4 = $[39];
  let t5;
  $[40] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => setStatus("confirm"), $[40] = t5) : t5 = $[40];
  const t6 = status === "unscheduling";
  let t7;
  $[41] !== t3 || $[42] !== t4 || $[43] !== t6 ? (t7 = /* @__PURE__ */ jsx(Button, { icon: CloseCircleIcon, disabled: t3, text: t4, onClick: t5, loading: t6, "data-testid": "schedule-button" }), $[41] = t3, $[42] = t4, $[43] = t6, $[44] = t7) : t7 = $[44];
  let t8;
  return $[45] !== confirmScheduleDialog || $[46] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t7,
    confirmScheduleDialog
  ] }), $[45] = confirmScheduleDialog, $[46] = t7, $[47] = t8) : t8 = $[47], t8;
}, actionIds = /* @__PURE__ */ new WeakMap();
let counter = 0;
function getHookId(actionHook) {
  const cachedId = actionIds.get(actionHook);
  if (cachedId) return cachedId;
  const id2 = `${actionHook.displayName || actionHook.name || "<anonymous>"}-${counter++}`;
  return actionIds.set(actionHook, id2), id2;
}
function defineHookStateComponent({
  hook: useHook,
  id: id2
}) {
  const HookStateComponent = (t0) => {
    const $ = c(4), {
      args,
      handleNext
    } = t0, hookState = useHook(args);
    let t1, t2;
    return $[0] !== handleNext || $[1] !== hookState ? (t1 = () => {
      hookState ? handleNext(id2, {
        ...hookState,
        action: useHook.action
      }) : handleNext(id2, hookState);
    }, t2 = [handleNext, hookState], $[0] = handleNext, $[1] = hookState, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2), null;
  }, {
    displayName = id2.replace(/-[0-9]+$/, "")
  } = useHook;
  return HookStateComponent.displayName = displayName, HookStateComponent;
}
const HookCollectionStateComponent = (t0) => {
  const $ = c(7), {
    hooks,
    args,
    handleNext
  } = t0;
  let t1;
  if ($[0] !== args || $[1] !== handleNext || $[2] !== hooks) {
    let t2;
    $[4] !== args || $[5] !== handleNext ? (t2 = (hook) => {
      const id2 = getHookId(hook);
      return /* @__PURE__ */ jsx(RenderHook, { args, id: id2, hook, handleNext }, id2);
    }, $[4] = args, $[5] = handleNext, $[6] = t2) : t2 = $[6], t1 = hooks.map(t2), $[0] = args, $[1] = handleNext, $[2] = hooks, $[3] = t1;
  } else
    t1 = $[3];
  return t1;
};
HookCollectionStateComponent.displayName = "HookCollectionState";
const HookCollectionState = memo(
  HookCollectionStateComponent,
  // react-fast-compare handles react specifis and allows us to bail on `args` values that are still the same as before, like `<>A</>`
  deepEquals
);
function RenderHook(t0) {
  const $ = c(7), {
    args,
    hook,
    id: id2,
    handleNext
  } = t0;
  let t1;
  $[0] !== hook || $[1] !== id2 ? (t1 = defineHookStateComponent({
    hook,
    id: id2
  }), $[0] = hook, $[1] = id2, $[2] = t1) : t1 = $[2];
  const HookState = t1;
  let t2;
  return $[3] !== HookState || $[4] !== args || $[5] !== handleNext ? (t2 = /* @__PURE__ */ jsx(HookState, { args, handleNext }), $[3] = HookState, $[4] = args, $[5] = handleNext, $[6] = t2) : t2 = $[6], t2;
}
const throttleOptions = {
  trailing: !0
};
function mapHooksToStates(states, {
  hooks
}) {
  return hooks.map((hook) => {
    const id2 = getHookId(hook);
    return states.get(id2);
  }).filter(isNonNullable$2);
}
function useHookCollectionStates(t0) {
  const $ = c(12), {
    hooks
  } = t0, [states] = useState(_temp$20);
  let t1;
  $[0] !== hooks || $[1] !== states ? (t1 = () => mapHooksToStates(states, {
    hooks
  }), $[0] = hooks, $[1] = states, $[2] = t1) : t1 = $[2];
  const [snapshot2, setSnapshot2] = useState(t1), abortControllerRef = useRef(null);
  let t2;
  $[3] !== hooks || $[4] !== states ? (t2 = () => {
    abortControllerRef.current?.abort(), abortControllerRef.current = new AbortController(), postTask(() => {
      setSnapshot2(mapHooksToStates(states, {
        hooks
      }));
    }, {
      signal: abortControllerRef.current.signal
    })?.catch(_temp2$N);
  }, $[3] = hooks, $[4] = states, $[5] = t2) : t2 = $[5];
  const requestUpdateSnapshot = useThrottledCallback(t2, 60, throttleOptions);
  let t3;
  $[6] !== requestUpdateSnapshot || $[7] !== states ? (t3 = (id2, hookState) => {
    let shouldUpdateSnapshot = !0;
    if (hookState === null)
      states.delete(id2);
    else {
      if (states.has(id2)) {
        const prev = states.get(id2);
        shouldUpdateSnapshot = !deepEquals(prev, hookState);
      }
      states.set(id2, hookState);
    }
    shouldUpdateSnapshot && requestUpdateSnapshot();
  }, $[6] = requestUpdateSnapshot, $[7] = states, $[8] = t3) : t3 = $[8];
  const handleNext = t3;
  let t4;
  return $[9] !== handleNext || $[10] !== snapshot2 ? (t4 = {
    states: snapshot2,
    handleNext
  }, $[9] = handleNext, $[10] = snapshot2, $[11] = t4) : t4 = $[11], t4;
}
function _temp2$N(error) {
  if (error.name !== "AbortError")
    throw error;
}
function _temp$20() {
  return /* @__PURE__ */ new Map();
}
function GetHookCollectionState(props2) {
  const $ = c(15), {
    hooks,
    args,
    children,
    resetRef
  } = props2;
  let t0;
  $[0] !== hooks ? (t0 = {
    hooks
  }, $[0] = hooks, $[1] = t0) : t0 = $[1];
  const {
    states,
    handleNext
  } = useHookCollectionStates(t0);
  let t1;
  $[2] !== children || $[3] !== states ? (t1 = children({
    states
  }), $[2] = children, $[3] = states, $[4] = t1) : t1 = $[4];
  const result = t1, [forceReset, setForceReset] = useState(0);
  let t2, t3;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => () => setForceReset(_temp$1$), t3 = [], $[5] = t2, $[6] = t3) : (t2 = $[5], t3 = $[6]), useImperativeHandle(resetRef, t2, t3);
  const t4 = `render-${forceReset}`;
  let t5;
  $[7] !== args || $[8] !== handleNext || $[9] !== hooks || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsx(HookCollectionState, { hooks, args, handleNext }, t4), $[7] = args, $[8] = handleNext, $[9] = hooks, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== result || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t5,
    result
  ] }), $[12] = result, $[13] = t5, $[14] = t6) : t6 = $[14], t6;
}
function _temp$1$(n) {
  return n + 1;
}
const ReleaseActionsStateHandler = memo(function(t0) {
  const $ = c(7), {
    states,
    onActions,
    renderChildren
  } = t0;
  let t1, t2;
  $[0] !== onActions || $[1] !== states ? (t1 = () => {
    onActions(states);
  }, t2 = [states, onActions], $[0] = onActions, $[1] = states, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  let t3;
  return $[4] !== renderChildren || $[5] !== states ? (t3 = renderChildren ? renderChildren({
    states
  }) : null, $[4] = renderChildren, $[5] = states, $[6] = t3) : t3 = $[6], t3;
}), ReleaseActionsResolver = memo(function(props2) {
  const $ = c(10), {
    actions,
    release,
    documents,
    onActions,
    children
  } = props2;
  let t0;
  $[0] !== documents || $[1] !== release ? (t0 = {
    release,
    documents
  }, $[0] = documents, $[1] = release, $[2] = t0) : t0 = $[2];
  const actionProps = t0;
  let t1;
  $[3] !== children || $[4] !== onActions ? (t1 = (t22) => {
    const {
      states
    } = t22;
    return /* @__PURE__ */ jsx(ReleaseActionsStateHandler, { states, onActions, renderChildren: children });
  }, $[3] = children, $[4] = onActions, $[5] = t1) : t1 = $[5];
  let t2;
  return $[6] !== actionProps || $[7] !== actions || $[8] !== t1 ? (t2 = /* @__PURE__ */ jsx(GetHookCollectionState, { hooks: actions, args: actionProps, children: t1 }), $[6] = actionProps, $[7] = actions, $[8] = t1, $[9] = t2) : t2 = $[9], t2;
});
function useCustomReleaseActions(release, t0) {
  const $ = c(7);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const documents = t1, source = useSource();
  let t2;
  bb0: {
    if (!source.releases?.actions) {
      let t32;
      $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t32 = [], $[2] = t32) : t32 = $[2], t2 = t32;
      break bb0;
    }
    let t3;
    $[3] !== documents || $[4] !== release || $[5] !== source.releases ? (t3 = source.releases.actions({
      release,
      documents
    }), $[3] = documents, $[4] = release, $[5] = source.releases, $[6] = t3) : t3 = $[6], t2 = t3;
  }
  return t2;
}
const DuplicateReleaseToastLink = (t0) => {
  const $ = c(9), {
    actionResult
  } = t0, router = useRouter(), {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t1;
  $[0] !== actionResult || $[1] !== router ? (t1 = () => {
    !actionResult || !("releaseId" in actionResult) || router.navigate({
      releaseId: getReleaseIdFromReleaseDocumentId(actionResult.releaseId)
    });
  }, $[0] = actionResult, $[1] = router, $[2] = t1) : t1 = $[2];
  const navigateToDuplicateRelease = t1;
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    cursor: "pointer",
    marginBottom: "0.5rem",
    display: "flex"
  }, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t ? (t3 = t("toast.duplicate.success-link"), $[4] = t, $[5] = t3) : t3 = $[5];
  let t4;
  return $[6] !== navigateToDuplicateRelease || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", "data-as": "a", onClick: navigateToDuplicateRelease, style: t2, "data-testid": "duplicate-release-success-link", children: t3 }), $[6] = navigateToDuplicateRelease, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}, RELEASE_ACTION_MAP = {
  delete: {
    confirmDialog: {
      dialogId: "confirm-delete-dialog",
      dialogHeaderI18nKey: "delete-dialog.confirm-delete.header",
      dialogDescriptionI18nKey: "delete-dialog.confirm-delete-description",
      dialogConfirmButtonI18nKey: "delete-dialog.confirm-delete-button",
      confirmButtonTone: "critical"
    },
    toastSuccessI18nKey: "toast.delete.success",
    toastFailureI18nKey: "toast.delete.error",
    telemetry: DeletedRelease
  },
  archive: {
    confirmDialog: {
      dialogId: "confirm-archive-dialog",
      dialogHeaderI18nKey: "archive-dialog.confirm-archive-header",
      dialogDescriptionI18nKey: "archive-dialog.confirm-archive-description",
      dialogConfirmButtonI18nKey: "archive-dialog.confirm-archive-button",
      confirmButtonTone: "critical"
    },
    toastFailureI18nKey: "toast.archive.error",
    telemetry: ArchivedRelease
  },
  unarchive: {
    confirmDialog: !1,
    toastFailureI18nKey: "toast.unarchive.error",
    telemetry: UnarchivedRelease
  },
  unschedule: {
    confirmDialog: !1,
    toastFailureI18nKey: "toast.unschedule.error",
    telemetry: UnscheduledRelease
  },
  duplicate: {
    confirmDialog: {
      dialogId: "confirm-duplicate-dialog",
      dialogHeaderI18nKey: "duplicate-dialog.confirm-duplicate-header",
      dialogDescriptionI18nKey: "duplicate-dialog.confirm-duplicate-description",
      dialogConfirmButtonI18nKey: "duplicate-dialog.confirm-duplicate-button",
      confirmButtonTone: "primary"
    },
    toastSuccessI18nKey: "toast.duplicate.success",
    toastFailureI18nKey: "toast.duplicate.error",
    telemetry: DuplicatedRelease
  }
}, ReleaseMenu = (t0) => {
  const $ = c(118), {
    ignoreCTA,
    disabled,
    release,
    setSelectedAction,
    documents
  } = t0, releaseMenuDisabled = !release || disabled, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    archive,
    unarchive,
    deleteRelease,
    publishRelease,
    schedule,
    createRelease
  } = useReleaseOperations(), {
    checkWithPermissionGuard
  } = useReleasePermissions(), [hasArchivePermission, setHasArchivePermission] = useState(null), [hasUnarchivePermission, setHasUnarchivePermission] = useState(null), [hasDeletePermission, setHasDeletePermission] = useState(null), [hasPublishPermission, setHasPublishPermission] = useState(null), [hasSchedulePermission, setHasSchedulePermission] = useState(null), [hasDuplicatePermission, setHasDuplicatePermission] = useState(null), isMounted = useRef(!1);
  let t1;
  $[0] !== archive || $[1] !== checkWithPermissionGuard || $[2] !== createRelease || $[3] !== deleteRelease || $[4] !== publishRelease || $[5] !== release._id || $[6] !== release.state || $[7] !== releaseMenuDisabled || $[8] !== schedule || $[9] !== unarchive ? (t1 = () => (isMounted.current = !0, releaseMenuDisabled || (release.state !== "published" && (release.state === "archived" ? checkWithPermissionGuard(unarchive, release._id).then((hasPermission) => {
    isMounted.current && setHasUnarchivePermission(hasPermission);
  }) : (checkWithPermissionGuard(archive, release._id).then((hasPermission_0) => {
    isMounted.current && setHasArchivePermission(hasPermission_0);
  }), checkWithPermissionGuard(publishRelease, release._id).then((hasPermission_1) => {
    isMounted.current && setHasPublishPermission(hasPermission_1);
  }), checkWithPermissionGuard(schedule, release._id, /* @__PURE__ */ new Date()).then((hasPermission_2) => {
    isMounted.current && setHasSchedulePermission(hasPermission_2);
  })), checkWithPermissionGuard(createRelease, getReleaseDefaults()).then((hasPermission_3) => {
    isMounted.current && setHasDuplicatePermission(hasPermission_3);
  })), (release.state === "archived" || release.state == "published") && checkWithPermissionGuard(deleteRelease, release._id).then((hasPermission_4) => {
    isMounted.current && setHasDeletePermission(hasPermission_4);
  })), () => {
    isMounted.current = !1;
  }), $[0] = archive, $[1] = checkWithPermissionGuard, $[2] = createRelease, $[3] = deleteRelease, $[4] = publishRelease, $[5] = release._id, $[6] = release.state, $[7] = releaseMenuDisabled, $[8] = schedule, $[9] = unarchive, $[10] = t1) : t1 = $[10];
  let t2;
  $[11] !== archive || $[12] !== checkWithPermissionGuard || $[13] !== createRelease || $[14] !== deleteRelease || $[15] !== publishRelease || $[16] !== release._id || $[17] !== release.metadata.releaseType || $[18] !== release.state || $[19] !== releaseMenuDisabled || $[20] !== schedule || $[21] !== unarchive ? (t2 = [release._id, releaseMenuDisabled, release.state, checkWithPermissionGuard, unarchive, archive, deleteRelease, release.metadata.releaseType, publishRelease, schedule, createRelease], $[11] = archive, $[12] = checkWithPermissionGuard, $[13] = createRelease, $[14] = deleteRelease, $[15] = publishRelease, $[16] = release._id, $[17] = release.metadata.releaseType, $[18] = release.state, $[19] = releaseMenuDisabled, $[20] = schedule, $[21] = unarchive, $[22] = t2) : t2 = $[22], useEffect(t1, t2);
  let t3;
  $[23] !== setSelectedAction ? (t3 = (event) => {
    const action = event.currentTarget.getAttribute("data-value");
    setSelectedAction(action);
  }, $[23] = setSelectedAction, $[24] = t3) : t3 = $[24];
  const handleOnInitiateAction = t3;
  let t4;
  bb0: {
    if (release.state === "published") {
      t4 = null;
      break bb0;
    }
    if (release.state === "archived") {
      const t53 = releaseMenuDisabled || !hasUnarchivePermission;
      let t63;
      $[25] !== t ? (t63 = t("action.unarchive"), $[25] = t, $[26] = t63) : t63 = $[26];
      let t73;
      $[27] !== hasUnarchivePermission || $[28] !== t ? (t73 = !hasUnarchivePermission && t("permissions.error.unarchive"), $[27] = hasUnarchivePermission, $[28] = t, $[29] = t73) : t73 = $[29];
      let t83;
      $[30] !== t73 ? (t83 = {
        content: t73
      }, $[30] = t73, $[31] = t83) : t83 = $[31];
      let t93;
      $[32] !== handleOnInitiateAction || $[33] !== t53 || $[34] !== t63 || $[35] !== t83 ? (t93 = /* @__PURE__ */ jsx(MenuItem, { "data-value": "unarchive", disabled: t53, onClick: handleOnInitiateAction, icon: UnarchiveIcon, text: t63, "data-testid": "unarchive-release-menu-item", tooltipProps: t83 }, "unarchive"), $[32] = handleOnInitiateAction, $[33] = t53, $[34] = t63, $[35] = t83, $[36] = t93) : t93 = $[36], t4 = t93;
      break bb0;
    }
    let t52;
    $[37] !== disabled || $[38] !== hasArchivePermission || $[39] !== release.state ? (t52 = hasArchivePermission ? !["scheduled", "scheduling"].includes(release.state) || disabled : !1, $[37] = disabled, $[38] = hasArchivePermission, $[39] = release.state, $[40] = t52) : t52 = $[40];
    let t62;
    $[41] !== hasArchivePermission || $[42] !== t ? (t62 = t(hasArchivePermission ? "action.archive.tooltip" : "permissions.error.archive"), $[41] = hasArchivePermission, $[42] = t, $[43] = t62) : t62 = $[43];
    let t72;
    $[44] !== t52 || $[45] !== t62 ? (t72 = {
      disabled: t52,
      content: t62
    }, $[44] = t52, $[45] = t62, $[46] = t72) : t72 = $[46];
    let t82;
    $[47] !== t ? (t82 = t("action.archive"), $[47] = t, $[48] = t82) : t82 = $[48];
    let t92;
    $[49] !== hasArchivePermission || $[50] !== release.state || $[51] !== releaseMenuDisabled ? (t92 = releaseMenuDisabled || ["scheduled", "scheduling"].includes(release.state) || !hasArchivePermission, $[49] = hasArchivePermission, $[50] = release.state, $[51] = releaseMenuDisabled, $[52] = t92) : t92 = $[52];
    let t102;
    $[53] !== handleOnInitiateAction || $[54] !== t72 || $[55] !== t82 || $[56] !== t92 ? (t102 = /* @__PURE__ */ jsx(MenuItem, { tooltipProps: t72, "data-value": "archive", onClick: handleOnInitiateAction, icon: ArchiveIcon, text: t82, "data-testid": "archive-release-menu-item", disabled: t92 }, "archive"), $[53] = handleOnInitiateAction, $[54] = t72, $[55] = t82, $[56] = t92, $[57] = t102) : t102 = $[57], t4 = t102;
  }
  const archiveUnarchiveMenuItem = t4;
  let t5;
  bb1: {
    if (release.state !== "archived" && release.state !== "published") {
      t5 = null;
      break bb1;
    }
    const t62 = releaseMenuDisabled || !hasDeletePermission;
    let t72;
    $[58] !== t ? (t72 = t("action.delete-release"), $[58] = t, $[59] = t72) : t72 = $[59];
    let t82;
    $[60] !== hasDeletePermission || $[61] !== t ? (t82 = !hasDeletePermission && t("permissions.error.delete"), $[60] = hasDeletePermission, $[61] = t, $[62] = t82) : t82 = $[62];
    let t92;
    $[63] !== t82 ? (t92 = {
      content: t82
    }, $[63] = t82, $[64] = t92) : t92 = $[64];
    let t102;
    $[65] !== handleOnInitiateAction || $[66] !== t62 || $[67] !== t72 || $[68] !== t92 ? (t102 = /* @__PURE__ */ jsx(MenuItem, { "data-value": "delete", onClick: handleOnInitiateAction, disabled: t62, icon: TrashIcon, text: t72, "data-testid": "delete-release-menu-item", tooltipProps: t92 }, "delete"), $[65] = handleOnInitiateAction, $[66] = t62, $[67] = t72, $[68] = t92, $[69] = t102) : t102 = $[69], t5 = t102;
  }
  const deleteMenuItem = t5;
  let t6;
  bb2: {
    if (ignoreCTA || release.state !== "scheduled" && release.state !== "scheduling") {
      t6 = null;
      break bb2;
    }
    let t72;
    $[70] !== t ? (t72 = t("action.unschedule"), $[70] = t, $[71] = t72) : t72 = $[71];
    let t82;
    $[72] !== handleOnInitiateAction || $[73] !== releaseMenuDisabled || $[74] !== t72 ? (t82 = /* @__PURE__ */ jsx(MenuItem, { "data-value": "unschedule", onClick: handleOnInitiateAction, disabled: releaseMenuDisabled, icon: CloseCircleIcon, text: t72, "data-testid": "unschedule-release-menu-item" }, "unschedule"), $[72] = handleOnInitiateAction, $[73] = releaseMenuDisabled, $[74] = t72, $[75] = t82) : t82 = $[75], t6 = t82;
  }
  const unscheduleMenuItem = t6;
  let t7;
  bb3: {
    if (release.state !== "active" || ignoreCTA && release.metadata.releaseType === "scheduled") {
      t7 = null;
      break bb3;
    }
    const t82 = releaseMenuDisabled || !hasSchedulePermission;
    let t102, t92;
    $[76] !== setSelectedAction ? (t92 = () => setSelectedAction(void 0), t102 = () => setSelectedAction("schedule"), $[76] = setSelectedAction, $[77] = t102, $[78] = t92) : (t102 = $[77], t92 = $[78]);
    let t112;
    $[79] !== documents || $[80] !== release || $[81] !== t102 || $[82] !== t82 || $[83] !== t92 ? (t112 = /* @__PURE__ */ jsx(ReleaseScheduleButton, { disabled: t82, release, documents, isMenuItem: !0, onConfirmDialogClose: t92, onConfirmDialogOpen: t102 }, "schedule"), $[79] = documents, $[80] = release, $[81] = t102, $[82] = t82, $[83] = t92, $[84] = t112) : t112 = $[84], t7 = t112;
  }
  const scheduleMenuItem = t7;
  let t8;
  bb4: {
    if (release.state !== "active" || ignoreCTA && release.metadata.releaseType !== "scheduled") {
      t8 = null;
      break bb4;
    }
    const t92 = releaseMenuDisabled || !hasPublishPermission;
    let t102, t112;
    $[85] !== setSelectedAction ? (t102 = () => setSelectedAction(void 0), t112 = () => setSelectedAction("publish"), $[85] = setSelectedAction, $[86] = t102, $[87] = t112) : (t102 = $[86], t112 = $[87]);
    let t12;
    $[88] !== documents || $[89] !== release || $[90] !== t102 || $[91] !== t112 || $[92] !== t92 ? (t12 = /* @__PURE__ */ jsx(ReleasePublishAllButton, { release, documents, disabled: t92, isMenuItem: !0, onConfirmDialogClose: t102, onConfirmDialogOpen: t112 }, "publish"), $[88] = documents, $[89] = release, $[90] = t102, $[91] = t112, $[92] = t92, $[93] = t12) : t12 = $[93], t8 = t12;
  }
  const publishMenuItem = t8;
  let t9;
  bb5: {
    if (release.state === "published" || release.state === "archived") {
      t9 = null;
      break bb5;
    }
    const t102 = releaseMenuDisabled || !hasDuplicatePermission;
    let t112;
    $[94] !== t ? (t112 = t("action.duplicate-release"), $[94] = t, $[95] = t112) : t112 = $[95];
    let t12;
    $[96] !== hasDuplicatePermission || $[97] !== t ? (t12 = !hasDuplicatePermission && t("permissions.error.duplicate"), $[96] = hasDuplicatePermission, $[97] = t, $[98] = t12) : t12 = $[98];
    let t13;
    $[99] !== t12 ? (t13 = {
      content: t12
    }, $[99] = t12, $[100] = t13) : t13 = $[100];
    let t14;
    $[101] !== handleOnInitiateAction || $[102] !== t102 || $[103] !== t112 || $[104] !== t13 ? (t14 = /* @__PURE__ */ jsx(MenuItem, { "data-value": "duplicate", onClick: handleOnInitiateAction, disabled: t102, icon: CopyIcon, text: t112, "data-testid": "duplicate-release-menu-item", tooltipProps: t13 }, "duplicate"), $[101] = handleOnInitiateAction, $[102] = t102, $[103] = t112, $[104] = t13, $[105] = t14) : t14 = $[105], t9 = t14;
  }
  const duplicateMenuItem = t9;
  let t10;
  bb6: {
    if (release.metadata.releaseType === "scheduled") {
      let t113;
      $[106] !== publishMenuItem || $[107] !== scheduleMenuItem ? (t113 = [scheduleMenuItem, publishMenuItem], $[106] = publishMenuItem, $[107] = scheduleMenuItem, $[108] = t113) : t113 = $[108], t10 = t113;
      break bb6;
    }
    let t112;
    $[109] !== publishMenuItem || $[110] !== scheduleMenuItem ? (t112 = [publishMenuItem, scheduleMenuItem], $[109] = publishMenuItem, $[110] = scheduleMenuItem, $[111] = t112) : t112 = $[111], t10 = t112;
  }
  const ActionsOrder = t10;
  let t11;
  return $[112] !== ActionsOrder || $[113] !== archiveUnarchiveMenuItem || $[114] !== deleteMenuItem || $[115] !== duplicateMenuItem || $[116] !== unscheduleMenuItem ? (t11 = [unscheduleMenuItem, ...ActionsOrder, duplicateMenuItem, archiveUnarchiveMenuItem, deleteMenuItem], $[112] = ActionsOrder, $[113] = archiveUnarchiveMenuItem, $[114] = deleteMenuItem, $[115] = duplicateMenuItem, $[116] = unscheduleMenuItem, $[117] = t11) : t11 = $[117], t11;
};
function ReleasePreviewCard(t0) {
  const $ = c(16), {
    release
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== release ? (t1 = /* @__PURE__ */ jsx(ReleaseAvatar, { release, padding: 0 }), $[0] = release, $[1] = t1) : t1 = $[1];
  const t2 = release.metadata.title;
  let t3;
  $[2] !== t ? (t3 = t("release.placeholder-untitled-release"), $[2] = t, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    weight: "medium",
    size: 1
  }, $[4] = t4) : t4 = $[4];
  let t5;
  $[5] !== release.metadata.title || $[6] !== t3 ? (t5 = /* @__PURE__ */ jsx(ReleaseTitle, { title: t2, fallback: t3, textProps: t4 }), $[5] = release.metadata.title, $[6] = t3, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== release ? (t6 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ReleaseTime, { release }) }), $[8] = release, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== t5 || $[11] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t5,
    t6
  ] }), $[10] = t5, $[11] = t6, $[12] = t7) : t7 = $[12];
  let t8;
  return $[13] !== t1 || $[14] !== t7 ? (t8 = /* @__PURE__ */ jsx(Card, { border: !0, padding: 1, radius: 2, children: /* @__PURE__ */ jsxs(Flex, { gap: 3, padding: 3, children: [
    t1,
    t7
  ] }) }), $[13] = t1, $[14] = t7, $[15] = t8) : t8 = $[15], t8;
}
const toastActionComponents = {
  duplicate: (actionResult) => ({
    Link: () => /* @__PURE__ */ jsx(DuplicateReleaseToastLink, { actionResult })
  })
}, ReleaseMenuButton = (t0) => {
  const $ = c(134), {
    ignoreCTA,
    release,
    documentsCount,
    documents
  } = t0, toast = useToast(), router = useRouter(), {
    archive,
    unarchive,
    deleteRelease,
    unschedule,
    duplicateRelease
  } = useReleaseOperations(), [isPerformingOperation, setIsPerformingOperation] = useState(!1), [selectedAction, setSelectedAction] = useState(), {
    selectedReleaseId
  } = usePerspective(), setPerspective = useSetPerspective(), popoverRef = useRef(null), releaseMenuRef = useRef(null), [openPopover, setOpenPopover] = useState(!1);
  let t1;
  $[0] !== documents ? (t1 = documents ?? [], $[0] = documents, $[1] = t1) : t1 = $[1];
  const customActions = useCustomReleaseActions(release, t1);
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[2] = t2) : t2 = $[2];
  const [customActionDescriptions, setCustomActionDescriptions] = useState(t2);
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (actions) => {
    setCustomActionDescriptions(actions.filter(Boolean));
  }, $[3] = t3) : t3 = $[3];
  const handleCustomActionsUpdate = t3, releaseMenuDisabled = !release, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), telemetry = useTelemetry(), {
    guardWithReleaseLimitUpsell
  } = useReleasesUpsell();
  let t4;
  $[4] !== release.metadata.title || $[5] !== tCore ? (t4 = release.metadata.title || tCore("release.placeholder-untitled-release"), $[4] = release.metadata.title, $[5] = tCore, $[6] = t4) : t4 = $[6];
  const releaseTitle = t4, isActionPublishOrSchedule = selectedAction === "publish" || selectedAction === "schedule", {
    document: document2
  } = useWorkspace(), {
    drafts: t5
  } = document2, {
    enabled: isDraftModelEnabled
  } = t5;
  let t6;
  $[7] !== deleteRelease || $[8] !== release._id || $[9] !== router ? (t6 = async () => {
    await deleteRelease(release._id), router.navigate({});
  }, $[7] = deleteRelease, $[8] = release._id, $[9] = router, $[10] = t6) : t6 = $[10];
  const handleDelete = t6;
  let t7;
  $[11] !== guardWithReleaseLimitUpsell || $[12] !== release._id || $[13] !== unarchive ? (t7 = async () => guardWithReleaseLimitUpsell(() => unarchive(release._id), !0), $[11] = guardWithReleaseLimitUpsell, $[12] = release._id, $[13] = unarchive, $[14] = t7) : t7 = $[14];
  const handleUnarchive = t7;
  let t8;
  $[15] !== documents || $[16] !== duplicateRelease || $[17] !== guardWithReleaseLimitUpsell || $[18] !== release.metadata || $[19] !== t ? (t8 = async () => {
    const duplicateReleaseId = createReleaseId();
    return await guardWithReleaseLimitUpsell(async () => {
      const releaseDocuments = documents?.map(_temp$1_), duplicatedMetadata = {
        ...release.metadata,
        title: `${release.metadata.title} (${t("copy-suffix")})`
      };
      return duplicateRelease(duplicateReleaseId, duplicatedMetadata, releaseDocuments);
    }, !0), {
      releaseId: duplicateReleaseId
    };
  }, $[15] = documents, $[16] = duplicateRelease, $[17] = guardWithReleaseLimitUpsell, $[18] = release.metadata, $[19] = t, $[20] = t8) : t8 = $[20];
  const handleDuplicate = t8;
  let t9;
  $[21] !== archive || $[22] !== handleDelete || $[23] !== handleDuplicate || $[24] !== handleUnarchive || $[25] !== isDraftModelEnabled || $[26] !== release._id || $[27] !== releaseMenuDisabled || $[28] !== releaseTitle || $[29] !== router || $[30] !== selectedReleaseId || $[31] !== setPerspective || $[32] !== t || $[33] !== telemetry || $[34] !== toast || $[35] !== unschedule ? (t9 = async (action) => {
    if (action === "publish" || action === "schedule" || releaseMenuDisabled)
      return;
    const actionLookup = {
      delete: handleDelete,
      archive,
      unarchive: handleUnarchive,
      unschedule,
      duplicate: handleDuplicate
    }, actionValues = RELEASE_ACTION_MAP[action];
    await (async () => {
      (action === "archive" || action === "delete") && selectedReleaseId === getReleaseIdFromReleaseDocumentId(release._id) && setPerspective(isDraftModelEnabled ? "drafts" : "published"), setIsPerformingOperation(!0);
      const actionResult = await actionLookup[action](release._id);
      if (telemetry.log(actionValues.telemetry), typeof actionValues.toastSuccessI18nKey < "u") {
        const toastComponents = toastActionComponents[action]?.(actionResult);
        toast.push({
          closable: !0,
          status: "success",
          title: /* @__PURE__ */ jsx(RouterContext.Provider, { value: router, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, components: toastComponents, i18nKey: actionValues.toastSuccessI18nKey, values: {
            title: releaseTitle
          } }) }) })
        });
      }
    })().catch((actionError) => {
      isReleaseLimitError(actionError) || (typeof actionValues.toastFailureI18nKey < "u" && toast.push({
        status: "error",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: actionValues.toastFailureI18nKey, values: {
          title: releaseTitle,
          error: actionError.toString()
        } }) })
      }), console.error(actionError));
    }).finally(() => {
      setIsPerformingOperation(!1), setSelectedAction(void 0);
    });
  }, $[21] = archive, $[22] = handleDelete, $[23] = handleDuplicate, $[24] = handleUnarchive, $[25] = isDraftModelEnabled, $[26] = release._id, $[27] = releaseMenuDisabled, $[28] = releaseTitle, $[29] = router, $[30] = selectedReleaseId, $[31] = setPerspective, $[32] = t, $[33] = telemetry, $[34] = toast, $[35] = unschedule, $[36] = t9) : t9 = $[36];
  const handleAction = t9;
  let t10;
  $[37] !== handleAction || $[38] !== isActionPublishOrSchedule || $[39] !== selectedAction ? (t10 = () => {
    !selectedAction || isActionPublishOrSchedule || RELEASE_ACTION_MAP[selectedAction].confirmDialog || handleAction(selectedAction);
  }, $[37] = handleAction, $[38] = isActionPublishOrSchedule, $[39] = selectedAction, $[40] = t10) : t10 = $[40];
  let t11;
  $[41] !== documentsCount || $[42] !== handleAction || $[43] !== isActionPublishOrSchedule || $[44] !== selectedAction ? (t11 = [documentsCount, handleAction, isActionPublishOrSchedule, selectedAction], $[41] = documentsCount, $[42] = handleAction, $[43] = isActionPublishOrSchedule, $[44] = selectedAction, $[45] = t11) : t11 = $[45], useEffect(t10, t11);
  let t12;
  bb0: {
    if (!selectedAction || isActionPublishOrSchedule) {
      t12 = null;
      break bb0;
    }
    const {
      confirmDialog
    } = RELEASE_ACTION_MAP[selectedAction];
    if (!confirmDialog) {
      t12 = null;
      break bb0;
    }
    const t132 = confirmDialog.dialogId, t142 = confirmDialog.dialogId;
    let t152;
    $[46] !== confirmDialog.dialogHeaderI18nKey || $[47] !== t ? (t152 = t(confirmDialog.dialogHeaderI18nKey), $[46] = confirmDialog.dialogHeaderI18nKey, $[47] = t, $[48] = t152) : t152 = $[48];
    let t162;
    $[49] !== isPerformingOperation ? (t162 = () => !isPerformingOperation && setSelectedAction(void 0), $[49] = isPerformingOperation, $[50] = t162) : t162 = $[50];
    let t172;
    $[51] !== confirmDialog.dialogConfirmButtonI18nKey || $[52] !== t ? (t172 = t(confirmDialog.dialogConfirmButtonI18nKey), $[51] = confirmDialog.dialogConfirmButtonI18nKey, $[52] = t, $[53] = t172) : t172 = $[53];
    let t182;
    $[54] !== handleAction || $[55] !== selectedAction ? (t182 = () => handleAction(selectedAction), $[54] = handleAction, $[55] = selectedAction, $[56] = t182) : t182 = $[56];
    let t192;
    $[57] !== confirmDialog.confirmButtonTone || $[58] !== isPerformingOperation || $[59] !== t172 || $[60] !== t182 ? (t192 = {
      text: t172,
      tone: confirmDialog.confirmButtonTone,
      onClick: t182,
      loading: isPerformingOperation,
      disabled: isPerformingOperation
    }, $[57] = confirmDialog.confirmButtonTone, $[58] = isPerformingOperation, $[59] = t172, $[60] = t182, $[61] = t192) : t192 = $[61];
    let t202;
    $[62] !== isPerformingOperation ? (t202 = {
      disabled: isPerformingOperation
    }, $[62] = isPerformingOperation, $[63] = t202) : t202 = $[63];
    let t212;
    $[64] !== t192 || $[65] !== t202 ? (t212 = {
      confirmButton: t192,
      cancelButton: t202
    }, $[64] = t192, $[65] = t202, $[66] = t212) : t212 = $[66];
    let t222;
    $[67] !== release ? (t222 = /* @__PURE__ */ jsx(ReleasePreviewCard, { release }), $[67] = release, $[68] = t222) : t222 = $[68];
    let t232;
    $[69] !== confirmDialog.dialogDescriptionI18nKey || $[70] !== documentsCount || $[71] !== t ? (t232 = !!documentsCount && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: confirmDialog.dialogDescriptionI18nKey, values: {
      count: documentsCount
    } }) }), $[69] = confirmDialog.dialogDescriptionI18nKey, $[70] = documentsCount, $[71] = t, $[72] = t232) : t232 = $[72];
    let t242;
    $[73] !== t222 || $[74] !== t232 ? (t242 = /* @__PURE__ */ jsxs(Stack, { space: 4, paddingX: 4, paddingBottom: 4, children: [
      t222,
      t232
    ] }), $[73] = t222, $[74] = t232, $[75] = t242) : t242 = $[75];
    let t252;
    $[76] !== confirmDialog.dialogId || $[77] !== t152 || $[78] !== t162 || $[79] !== t212 || $[80] !== t242 ? (t252 = /* @__PURE__ */ jsx(Dialog$1, { id: t132, "data-testid": t142, header: t152, onClose: t162, padding: !1, footer: t212, children: t242 }), $[76] = confirmDialog.dialogId, $[77] = t152, $[78] = t162, $[79] = t212, $[80] = t242, $[81] = t252) : t252 = $[81], t12 = t252;
  }
  const confirmActionDialog = t12;
  let t13;
  $[82] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = () => {
    setOpenPopover(!1);
  }, $[82] = t13) : t13 = $[82];
  const closePopover = t13;
  let t14;
  $[83] !== openPopover ? (t14 = () => {
    openPopover ? closePopover() : setOpenPopover(!0);
  }, $[83] = openPopover, $[84] = t14) : t14 = $[84];
  const handleOnButtonClick = t14;
  let t15;
  $[85] !== isActionPublishOrSchedule ? (t15 = () => {
    isActionPublishOrSchedule || closePopover();
  }, $[85] = isActionPublishOrSchedule, $[86] = t15) : t15 = $[86];
  let t16;
  $[87] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = () => [popoverRef.current, releaseMenuRef.current], $[87] = t16) : t16 = $[87], useClickOutsideEvent(t15, t16);
  let t17;
  $[88] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t17 = (action_0) => {
    action_0 || closePopover(), setSelectedAction(action_0);
  }, $[88] = t17) : t17 = $[88];
  const handleSetSelectedAction = t17;
  let t18;
  $[89] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t18 = (action_1) => () => {
    action_1.onHandle && (action_1.onHandle(), closePopover());
  }, $[89] = t18) : t18 = $[89];
  const handleOnActionClick = t18;
  let t19;
  if ($[90] !== customActionDescriptions || $[91] !== isPerformingOperation) {
    let t202;
    $[93] !== isPerformingOperation ? (t202 = (action_2, index) => /* @__PURE__ */ jsx(MenuItem, { icon: action_2.icon, text: action_2.label, disabled: action_2.disabled || isPerformingOperation, onClick: handleOnActionClick(action_2), tooltipProps: action_2.title ? {
      content: action_2.title
    } : void 0 }, `custom-action-${index}`), $[93] = isPerformingOperation, $[94] = t202) : t202 = $[94], t19 = customActionDescriptions.map(t202), $[90] = customActionDescriptions, $[91] = isPerformingOperation, $[92] = t19;
  } else
    t19 = $[92];
  const customActionMenuItems = t19, hasCustomActions = customActions.length > 0;
  let t20;
  $[95] !== customActions || $[96] !== documents || $[97] !== hasCustomActions || $[98] !== release ? (t20 = hasCustomActions && /* @__PURE__ */ jsx(ReleaseActionsResolver, { actions: customActions, release, documents: documents ?? [], onActions: handleCustomActionsUpdate }), $[95] = customActions, $[96] = documents, $[97] = hasCustomActions, $[98] = release, $[99] = t20) : t20 = $[99];
  let t21;
  $[100] !== documents ? (t21 = documents ?? [], $[100] = documents, $[101] = t21) : t21 = $[101];
  let t22;
  $[102] !== ignoreCTA || $[103] !== isPerformingOperation || $[104] !== release || $[105] !== t21 ? (t22 = /* @__PURE__ */ jsx(ReleaseMenu, { ignoreCTA, release, setSelectedAction: handleSetSelectedAction, disabled: isPerformingOperation, documents: t21 }), $[102] = ignoreCTA, $[103] = isPerformingOperation, $[104] = release, $[105] = t21, $[106] = t22) : t22 = $[106];
  let t23;
  $[107] !== customActionMenuItems || $[108] !== hasCustomActions ? (t23 = hasCustomActions && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(MenuDivider, {}),
    customActionMenuItems
  ] }), $[107] = customActionMenuItems, $[108] = hasCustomActions, $[109] = t23) : t23 = $[109];
  let t24;
  $[110] !== t22 || $[111] !== t23 ? (t24 = /* @__PURE__ */ jsxs(Menu, { ref: releaseMenuRef, children: [
    t22,
    t23
  ] }), $[110] = t22, $[111] = t23, $[112] = t24) : t24 = $[112];
  let t25;
  $[113] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t25 = ["top-end"], $[113] = t25) : t25 = $[113];
  const t26 = releaseMenuDisabled || isPerformingOperation, t27 = isPerformingOperation ? Spinner : EllipsisHorizontalIcon;
  let t28;
  $[114] !== t ? (t28 = t("menu.tooltip"), $[114] = t, $[115] = t28) : t28 = $[115];
  let t29;
  $[116] !== t28 ? (t29 = {
    content: t28
  }, $[116] = t28, $[117] = t29) : t29 = $[117];
  let t30;
  $[118] !== t ? (t30 = t("menu.label"), $[118] = t, $[119] = t30) : t30 = $[119];
  let t31;
  $[120] !== handleOnButtonClick || $[121] !== t26 || $[122] !== t27 || $[123] !== t29 || $[124] !== t30 ? (t31 = /* @__PURE__ */ jsx(Button, { disabled: t26, icon: t27, mode: "bleed", tooltipProps: t29, "aria-label": t30, "data-testid": "release-menu-button", onClick: handleOnButtonClick }), $[120] = handleOnButtonClick, $[121] = t26, $[122] = t27, $[123] = t29, $[124] = t30, $[125] = t31) : t31 = $[125];
  let t32;
  $[126] !== openPopover || $[127] !== t24 || $[128] !== t31 ? (t32 = /* @__PURE__ */ jsx(Popover, { content: t24, open: openPopover, ref: popoverRef, constrainSize: !1, fallbackPlacements: t25, portal: !0, tone: "default", placement: "bottom", children: t31 }), $[126] = openPopover, $[127] = t24, $[128] = t31, $[129] = t32) : t32 = $[129];
  let t33;
  return $[130] !== confirmActionDialog || $[131] !== t20 || $[132] !== t32 ? (t33 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t20,
    t32,
    confirmActionDialog
  ] }), $[130] = confirmActionDialog, $[131] = t20, $[132] = t32, $[133] = t33) : t33 = $[133], t33;
};
function _temp$1_(doc) {
  return doc.document;
}
function StatusItem(props2) {
  const $ = c(13), {
    avatar,
    text,
    testId
  } = props2;
  let t0;
  $[0] !== avatar ? (t0 = avatar && /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx("div", { style: {
    margin: -1
  }, children: avatar }) }), $[0] = avatar, $[1] = t0) : t0 = $[1];
  const t1 = avatar ? 1 : void 0;
  let t2;
  $[2] !== text ? (t2 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: text }), $[2] = text, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t1 || $[5] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { padding: 2, paddingLeft: t1, children: t2 }), $[4] = t1, $[5] = t2, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t0 || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { children: [
    t0,
    t3
  ] }), $[7] = t0, $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== t4 || $[11] !== testId ? (t5 = /* @__PURE__ */ jsx(Card, { "data-testid": testId, children: t4 }), $[10] = t4, $[11] = testId, $[12] = t5) : t5 = $[12], t5;
}
const STATUS_TITLE_I18N = {
  createRelease: "footer.status.created",
  publishRelease: "footer.status.published",
  archiveRelease: "footer.status.archived",
  unarchiveRelease: "footer.status.unarchived"
};
function ReleaseStatusItems(t0) {
  const $ = c(13), {
    events: events2,
    release
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t1;
  if ($[0] !== events2) {
    const createEvent = events2.find(isCreateReleaseEvent), extraEvent = events2.find(_temp$1Z);
    t1 = [createEvent, extraEvent].filter(isNonNullable$2), $[0] = events2, $[1] = t1;
  } else
    t1 = $[1];
  const footerEvents = t1;
  if (!footerEvents.length) {
    let t22;
    $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(AvatarSkeleton$1, { $size: 0 }), $[2] = t22) : t22 = $[2];
    let t3;
    $[3] !== t ? (t3 = t(STATUS_TITLE_I18N.createRelease), $[3] = t, $[4] = t3) : t3 = $[4];
    let t4;
    $[5] !== release._createdAt ? (t4 = /* @__PURE__ */ jsx(RelativeTime, { time: release._createdAt, useTemporalPhrase: !0, minimal: !0 }), $[5] = release._createdAt, $[6] = t4) : t4 = $[6];
    let t5;
    return $[7] !== t3 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(Flex, { flex: 1, gap: 1, children: /* @__PURE__ */ jsx(StatusItem, { avatar: t22, text: /* @__PURE__ */ jsxs(Fragment$1, { children: [
      t3,
      " ",
      t4
    ] }) }) }), $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9], t5;
  }
  let t2;
  return $[10] !== footerEvents || $[11] !== t ? (t2 = /* @__PURE__ */ jsx(Flex, { flex: 1, gap: 1, children: footerEvents.map((event_0) => /* @__PURE__ */ jsx(StatusItem, { testId: `status-${event_0.type}`, avatar: event_0.author && /* @__PURE__ */ jsx(UserAvatar, { size: 0, user: event_0.author }), text: /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t(STATUS_TITLE_I18N[event_0.type]),
    " ",
    /* @__PURE__ */ jsx(RelativeTime, { time: event_0.timestamp, useTemporalPhrase: !0, minimal: !0 })
  ] }) }, event_0.id)) }), $[10] = footerEvents, $[11] = t, $[12] = t2) : t2 = $[12], t2;
}
function _temp$1Z(event) {
  return isPublishReleaseEvent(event) || isArchiveReleaseEvent(event) || isUnarchiveReleaseEvent(event);
}
function ReleaseDashboardFooter(props2) {
  const $ = c(30), {
    documents,
    release,
    events: events2
  } = props2;
  let t0;
  bb0: {
    if (release.state === "archived") {
      t0 = null;
      break bb0;
    }
    if (isReleaseScheduledOrScheduling(release)) {
      const t12 = !documents.length;
      let t22;
      $[0] !== documents || $[1] !== release || $[2] !== t12 ? (t22 = /* @__PURE__ */ jsx(ReleaseUnscheduleButton, { release, documents, disabled: t12 }), $[0] = documents, $[1] = release, $[2] = t12, $[3] = t22) : t22 = $[3], t0 = t22;
      break bb0;
    }
    if (release.state === "active") {
      if (release.metadata.releaseType === "scheduled") {
        const t12 = !documents.length;
        let t22;
        $[4] !== documents || $[5] !== release || $[6] !== t12 ? (t22 = /* @__PURE__ */ jsx(ReleaseScheduleButton, { release, documents, disabled: t12 }), $[4] = documents, $[5] = release, $[6] = t12, $[7] = t22) : t22 = $[7], t0 = t22;
        break bb0;
      }
      if (release.metadata.releaseType === "asap") {
        const t12 = !documents.length;
        let t22;
        $[8] !== documents || $[9] !== release || $[10] !== t12 ? (t22 = /* @__PURE__ */ jsx(ReleasePublishAllButton, { release, documents, disabled: t12 }), $[8] = documents, $[9] = release, $[10] = t12, $[11] = t22) : t22 = $[11], t0 = t22;
        break bb0;
      }
    }
    if (release.state === "published") {
      const t12 = !documents.length;
      let t22;
      $[12] !== documents || $[13] !== release || $[14] !== t12 ? (t22 = /* @__PURE__ */ jsx(ReleaseRevertButton, { release, documents, disabled: t12 }), $[12] = documents, $[13] = release, $[14] = t12, $[15] = t22) : t22 = $[15], t0 = t22;
      break bb0;
    }
    t0 = null;
  }
  const releaseActionButton = t0;
  let t1;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Card, { borderTop: !0, marginX: 2, style: {
    opacity: 0.6
  } }), $[16] = t1) : t1 = $[16];
  let t2;
  $[17] !== events2 || $[18] !== release ? (t2 = /* @__PURE__ */ jsx(Flex, { flex: 1, gap: 1, children: /* @__PURE__ */ jsx(ReleaseStatusItems, { events: events2, release }) }), $[17] = events2, $[18] = release, $[19] = t2) : t2 = $[19];
  const t3 = release.metadata.releaseType !== "undecided";
  let t4;
  $[20] !== documents || $[21] !== release || $[22] !== t3 ? (t4 = /* @__PURE__ */ jsx(ReleaseMenuButton, { release, documentsCount: documents.length, documents, ignoreCTA: t3 }), $[20] = documents, $[21] = release, $[22] = t3, $[23] = t4) : t4 = $[23];
  let t5;
  $[24] !== releaseActionButton || $[25] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { flex: "none", gap: 1, "data-testid": "release-dashboard-footer-actions", children: [
    releaseActionButton,
    t4
  ] }), $[24] = releaseActionButton, $[25] = t4, $[26] = t5) : t5 = $[26];
  let t6;
  return $[27] !== t2 || $[28] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Card, { flex: "none", children: [
    t1,
    /* @__PURE__ */ jsxs(Flex, { padding: 3, children: [
      t2,
      t5
    ] })
  ] }), $[27] = t2, $[28] = t5, $[29] = t6) : t6 = $[29], t6;
}
const INITIAL_STATE$5 = {
  value: null,
  loading: !0
};
function useProjectOrganizationId() {
  const $ = c(2), projectStore = useProjectStore();
  let t0;
  return $[0] !== projectStore ? (t0 = projectStore.getOrganizationId().pipe(map$1(_temp$1Y), startWith$1({
    value: null,
    loading: !0
  })), $[0] = projectStore, $[1] = t0) : t0 = $[1], useObservable(t0, INITIAL_STATE$5);
}
function _temp$1Y(res) {
  return {
    value: res,
    loading: !1
  };
}
function useRenderingContext() {
  const renderingContextStore = useRenderingContextStore();
  return useObservable(renderingContextStore.renderingContext);
}
function createAppIdCache() {
  const appIdCache = {};
  return {
    get: async (args) => {
      const {
        projectId,
        appIdFetcher
      } = args;
      let cacheElement = appIdCache[projectId];
      return cacheElement || (cacheElement = (async () => {
        try {
          return await appIdFetcher(projectId);
        } catch (error) {
          console.error(error), appIdCache[projectId] = void 0;
          return;
        }
      })(), appIdCache[projectId] = cacheElement, cacheElement);
    }
  };
}
function AppIdCacheProvider(props2) {
  const $ = c(5), {
    children
  } = props2, parentCache = useContext(AppIdCacheContext);
  let t0;
  $[0] !== parentCache ? (t0 = parentCache || createAppIdCache(), $[0] = parentCache, $[1] = t0) : t0 = $[1];
  const cache2 = t0;
  let t1;
  return $[2] !== cache2 || $[3] !== children ? (t1 = /* @__PURE__ */ jsx(AppIdCacheContext.Provider, { value: cache2, children }), $[2] = cache2, $[3] = children, $[4] = t1) : t1 = $[4], t1;
}
function useAppIdCache() {
  const cache2 = useContext(AppIdCacheContext);
  if (!cache2)
    throw new Error("AppIdCache: missing context value. Ensure the component is wrapped in a AppIdCacheProvider.");
  return cache2;
}
async function checkStudioManifestExists(studioHostUrl) {
  const url = `${studioHostUrl}/static/create-manifest.json`;
  try {
    const response = await fetch(url, {
      method: "HEAD"
    });
    return response.status == 404 ? !1 : response.status > 299 ? (console.error(`Failed to get manifest from ${url}`, response), !1) : !0;
  } catch (e) {
    return console.error(`Failed to fetch from ${url}`, e), !1;
  }
}
const isStaging$1 = typeof __SANITY_STAGING__ < "u" && __SANITY_STAGING__ === !0, internalUrlSuffix = isStaging$1 ? "studio.sanity.work" : "sanity.studio";
async function fetchStudiosWithUrl(client, projectId, internalSuffix) {
  return (await client.request({
    method: "GET",
    url: `/projects/${projectId}/user-applications`
  })).map((app) => ({
    ...app,
    studioUrl: getStudioUrl(app, internalSuffix)
  }));
}
async function fetchCreateCompatibleAppId(args) {
  const {
    projectId,
    client,
    fallbackOrigin,
    internalSuffix = internalUrlSuffix,
    checkStudioManifest = checkStudioManifestExists,
    origin = window.location?.origin
  } = args, appsWithStudioUrl = await fetchStudiosWithUrl(client, projectId, internalSuffix), appMatchingOrigin = appsWithStudioUrl.find((app) => app && origin && app.studioUrl?.startsWith(origin));
  return appMatchingOrigin?.appHost && await checkStudioManifest(getStudioUrl(appMatchingOrigin, internalSuffix)) ? {
    appId: appMatchingOrigin.id,
    studioApps: appsWithStudioUrl
  } : {
    appId: appsWithStudioUrl.find((app) => app && fallbackOrigin && app.studioUrl?.startsWith(`https://${fallbackOrigin}`))?.id,
    studioApps: appsWithStudioUrl
  };
}
function getStudioUrl(app, internalSuffix) {
  return app.urlType === "internal" ? `https://${app.appHost}.${internalSuffix}` : app.appHost;
}
function useStudioAppIdStore(config) {
  const $ = c(9);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "2024-09-01"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0), cache2 = useAppIdCache(), {
    projectId
  } = useSource();
  let t1;
  $[1] !== client || $[2] !== config.fallbackStudioOrigin ? (t1 = (pId) => fetchCreateCompatibleAppId({
    projectId: pId,
    client,
    fallbackOrigin: config.fallbackStudioOrigin
  }), $[1] = client, $[2] = config.fallbackStudioOrigin, $[3] = t1) : t1 = $[3];
  const appIdFetcher = t1;
  let t2;
  return $[4] !== appIdFetcher || $[5] !== cache2 || $[6] !== config.enabled || $[7] !== projectId ? (t2 = {
    projectId,
    cache: cache2,
    appIdFetcher,
    enabled: config.enabled
  }, $[4] = appIdFetcher, $[5] = cache2, $[6] = config.enabled, $[7] = projectId, $[8] = t2) : t2 = $[8], useStudioAppIdStoreInner(t2);
}
function useStudioAppIdStoreInner(props2) {
  const $ = c(9), {
    cache: cache2,
    enabled,
    appIdFetcher,
    projectId
  } = props2, [loading, setLoading] = useState(!1), [studioApp, setStudioApp] = useState();
  let t0, t1;
  $[0] !== appIdFetcher || $[1] !== cache2 || $[2] !== enabled || $[3] !== projectId ? (t0 = () => {
    let mounted = !0;
    return enabled && (async function() {
      if (projectId) {
        setLoading(!0);
        try {
          const entry = await cache2.get({
            projectId,
            appIdFetcher
          });
          mounted && setStudioApp(entry);
        } catch {
          mounted && setStudioApp(void 0);
        }
        mounted && setLoading(!1);
      }
    })().catch(console.error), () => {
      mounted = !1, setLoading(!1);
    };
  }, t1 = [setLoading, appIdFetcher, cache2, enabled, projectId], $[0] = appIdFetcher, $[1] = cache2, $[2] = enabled, $[3] = projectId, $[4] = t0, $[5] = t1) : (t0 = $[4], t1 = $[5]), useEffect(t0, t1);
  let t2;
  return $[6] !== loading || $[7] !== studioApp ? (t2 = {
    loading,
    studioApp
  }, $[6] = loading, $[7] = studioApp, $[8] = t2) : t2 = $[8], t2;
}
function useEnvAwareSanityWebsiteUrl() {
  const {
    getClient: getClient2
  } = useWorkspace();
  return getClient2({
    apiVersion: "2025-08-15"
  }).config().apiHost.endsWith(".work") ? "https://www.sanity.work" : "https://www.sanity.io";
}
const getDashboardPath = ({
  organizationId,
  dashboardDomain,
  appId,
  workspaceName
}) => `${dashboardDomain}/@${organizationId}/studio/${appId}/${workspaceName}`, useStudioUrl = (defaultUrl) => {
  const $ = c(17), renderingContext = useRenderingContext();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    enabled: !0
  }, $[0] = t0) : t0 = $[0];
  const {
    studioApp,
    loading: appIdLoading
  } = useStudioAppIdStore(t0), {
    activeWorkspace
  } = useActiveWorkspace(), {
    value: organizationId,
    loading: organizationIdLoading
  } = useProjectOrganizationId(), isLoading = appIdLoading || organizationIdLoading, isCoreUi = renderingContext?.name === "coreUi", sanityWebsiteUrl = useEnvAwareSanityWebsiteUrl(), appId = studioApp?.appId || "";
  let t1;
  bb0: {
    if (!isCoreUi || isLoading || !appId || !organizationId) {
      t1 = defaultUrl || window.location.origin;
      break bb0;
    }
    let t22;
    $[1] !== activeWorkspace.name || $[2] !== appId || $[3] !== organizationId || $[4] !== sanityWebsiteUrl ? (t22 = getDashboardPath({
      dashboardDomain: sanityWebsiteUrl,
      organizationId,
      appId,
      workspaceName: activeWorkspace.name
    }), $[1] = activeWorkspace.name, $[2] = appId, $[3] = organizationId, $[4] = sanityWebsiteUrl, $[5] = t22) : t22 = $[5], t1 = t22;
  }
  const studioUrl = t1, basePath = activeWorkspace.basePath;
  let t2;
  $[6] !== isCoreUi || $[7] !== studioUrl ? (t2 = (t32) => {
    const {
      coreUi,
      studio
    } = t32;
    return (isCoreUi ? coreUi : studio)?.(studioUrl) || studioUrl;
  }, $[6] = isCoreUi, $[7] = studioUrl, $[8] = t2) : t2 = $[8];
  const buildStudioUrl = t2;
  let t3;
  $[9] !== basePath || $[10] !== isCoreUi || $[11] !== studioUrl ? (t3 = (intentLink) => isCoreUi && basePath !== "/" ? `${studioUrl}${intentLink.slice(basePath.length)}` : `${studioUrl}${intentLink}`, $[9] = basePath, $[10] = isCoreUi, $[11] = studioUrl, $[12] = t3) : t3 = $[12];
  const buildIntentUrl = t3;
  let t4;
  return $[13] !== buildIntentUrl || $[14] !== buildStudioUrl || $[15] !== studioUrl ? (t4 = {
    buildIntentUrl,
    buildStudioUrl,
    studioUrl
  }, $[13] = buildIntentUrl, $[14] = buildStudioUrl, $[15] = studioUrl, $[16] = t4) : t4 = $[16], t4;
};
function CopyReleaseActions(props2) {
  const $ = c(47), {
    release
  } = props2, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), telemetry = useTelemetry(), toast = useToast(), {
    resolvePathFromState
  } = useRouter(), {
    buildIntentUrl
  } = useStudioUrl();
  let t0;
  $[0] !== release._id ? (t0 = getReleaseIdFromReleaseDocumentId(release._id), $[0] = release._id, $[1] = t0) : t0 = $[1];
  const releaseId = t0;
  let t1;
  $[2] !== release.metadata.title || $[3] !== tCore ? (t1 = release.metadata.title || tCore("release.placeholder-untitled-release"), $[2] = release.metadata.title, $[3] = tCore, $[4] = t1) : t1 = $[4];
  const title = t1;
  let t2;
  $[5] !== t || $[6] !== telemetry || $[7] !== toast ? (t2 = async (text, event, toastKey) => {
    await navigator.clipboard.writeText(text), telemetry.log(event), toast.push({
      id: toastKey,
      status: "info",
      title: t(`toast.${toastKey}.success`)
    });
  }, $[5] = t, $[6] = telemetry, $[7] = toast, $[8] = t2) : t2 = $[8];
  const copyToClipboard = t2;
  let t3;
  $[9] !== buildIntentUrl || $[10] !== copyToClipboard || $[11] !== releaseId || $[12] !== resolvePathFromState ? (t3 = async () => {
    const releasePath = resolvePathFromState({
      releaseId
    }), url = buildIntentUrl(releasePath);
    await copyToClipboard(url, ReleaseLinkCopied, "copy-release-link");
  }, $[9] = buildIntentUrl, $[10] = copyToClipboard, $[11] = releaseId, $[12] = resolvePathFromState, $[13] = t3) : t3 = $[13];
  const handleCopyReleaseLink = t3;
  let t4;
  $[14] !== copyToClipboard || $[15] !== releaseId ? (t4 = async () => {
    await copyToClipboard(releaseId, ReleaseIdCopied, "copy-release-id");
  }, $[14] = copyToClipboard, $[15] = releaseId, $[16] = t4) : t4 = $[16];
  const handleCopyReleaseId = t4;
  let t5;
  $[17] !== copyToClipboard || $[18] !== title ? (t5 = async () => {
    await copyToClipboard(title, ReleaseTitleCopied, "copy-release-title");
  }, $[17] = copyToClipboard, $[18] = title, $[19] = t5) : t5 = $[19];
  const handleCopyReleaseTitle = t5;
  let t6;
  $[20] !== t ? (t6 = t("action.copy-release.label"), $[20] = t, $[21] = t6) : t6 = $[21];
  let t7;
  $[22] !== t6 ? (t7 = /* @__PURE__ */ jsx(Button, { "data-testid": "copy-release-actions-button", icon: ShareIcon, mode: "bleed", tooltipProps: {
    content: t6
  } }), $[22] = t6, $[23] = t7) : t7 = $[23];
  let t8;
  $[24] !== t ? (t8 = t("action.copy-release-link.label"), $[24] = t, $[25] = t8) : t8 = $[25];
  let t9;
  $[26] !== handleCopyReleaseLink || $[27] !== t8 ? (t9 = /* @__PURE__ */ jsx(MenuItem, { icon: LinkIcon, onClick: handleCopyReleaseLink, text: t8 }), $[26] = handleCopyReleaseLink, $[27] = t8, $[28] = t9) : t9 = $[28];
  let t10;
  $[29] !== t ? (t10 = t("action.copy-release-id.label"), $[29] = t, $[30] = t10) : t10 = $[30];
  let t11;
  $[31] !== handleCopyReleaseId || $[32] !== t10 ? (t11 = /* @__PURE__ */ jsx(MenuItem, { icon: TargetIcon, onClick: handleCopyReleaseId, text: t10 }), $[31] = handleCopyReleaseId, $[32] = t10, $[33] = t11) : t11 = $[33];
  let t12;
  $[34] !== t ? (t12 = t("action.copy-release-title.label"), $[34] = t, $[35] = t12) : t12 = $[35];
  let t13;
  $[36] !== handleCopyReleaseTitle || $[37] !== t12 ? (t13 = /* @__PURE__ */ jsx(MenuItem, { icon: TextIcon, onClick: handleCopyReleaseTitle, text: t12 }), $[36] = handleCopyReleaseTitle, $[37] = t12, $[38] = t13) : t13 = $[38];
  let t14;
  $[39] !== t11 || $[40] !== t13 || $[41] !== t9 ? (t14 = /* @__PURE__ */ jsxs(Menu, { children: [
    t9,
    t11,
    t13
  ] }), $[39] = t11, $[40] = t13, $[41] = t9, $[42] = t14) : t14 = $[42];
  let t15;
  $[43] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = {
    placement: "bottom-end"
  }, $[43] = t15) : t15 = $[43];
  let t16;
  return $[44] !== t14 || $[45] !== t7 ? (t16 = /* @__PURE__ */ jsx(MenuButton, { id: "copy-release-actions", button: t7, menu: t14, popover: t15 }), $[44] = t14, $[45] = t7, $[46] = t16) : t16 = $[46], t16;
}
function ReleaseDashboardHeader(props2) {
  const $ = c(38), {
    inspector,
    release,
    setInspector
  } = props2, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation();
  let t0;
  $[0] !== release.metadata.title || $[1] !== tCore ? (t0 = release.metadata.title || tCore("release.placeholder-untitled-release"), $[0] = release.metadata.title, $[1] = tCore, $[2] = t0) : t0 = $[2];
  const title = t0, router = useRouter();
  let t1;
  $[3] !== release.state || $[4] !== router ? (t1 = () => {
    const isReleaseOpen = release.state !== "archived" && release.state !== "published";
    router.navigate({
      _searchParams: isReleaseOpen ? void 0 : [[GROUP_SEARCH_PARAM_KEY, "archived"]]
    });
  }, $[3] = release.state, $[4] = router, $[5] = t1) : t1 = $[5];
  const handleNavigateToReleasesList = t1;
  let t2;
  $[6] !== setInspector ? (t2 = () => {
    setInspector(_temp$1X);
  }, $[6] = setInspector, $[7] = t2) : t2 = $[7];
  const handleActivityClick = t2;
  let t3;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    minWidth: 0
  }, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== t ? (t4 = t("overview.title"), $[9] = t, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== handleNavigateToReleasesList || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsx(Flex, { flex: "none", children: /* @__PURE__ */ jsx(Button$1, { mode: "bleed", onClick: handleNavigateToReleasesList, text: t4, textWeight: "regular", padding: 2, "data-testid": "back-to-releases-button" }) }), $[11] = handleNavigateToReleasesList, $[12] = t4, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx(Box, { paddingY: 2, flex: "none", children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ChevronRightIcon, {}) }) }), $[14] = t6) : t6 = $[14];
  let t7;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    minWidth: 0,
    maxWidth: "300px"
  }, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== release.metadata.title ? (t8 = release.metadata.title ? void 0 : {
    opacity: 0.5
  }, $[16] = release.metadata.title, $[17] = t8) : t8 = $[17];
  let t9;
  $[18] !== t8 || $[19] !== title ? (t9 = /* @__PURE__ */ jsx(Box, { padding: 2, style: t7, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", textOverflow: "ellipsis", style: t8, children: title }) }), $[18] = t8, $[19] = title, $[20] = t9) : t9 = $[20];
  let t10;
  $[21] !== t5 || $[22] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { flex: 1, align: "center", style: t3, children: [
    t5,
    t6,
    t9
  ] }), $[21] = t5, $[22] = t9, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] !== release ? (t11 = /* @__PURE__ */ jsx(CopyReleaseActions, { release }), $[24] = release, $[25] = t11) : t11 = $[25];
  const t12 = inspector === "activity";
  let t13;
  $[26] !== t ? (t13 = t("dashboard.details.activity"), $[26] = t, $[27] = t13) : t13 = $[27];
  let t14;
  $[28] !== handleActivityClick || $[29] !== t12 || $[30] !== t13 ? (t14 = /* @__PURE__ */ jsx(Button$1, { icon: RestoreIcon, mode: "bleed", onClick: handleActivityClick, padding: 2, selected: t12, space: 2, text: t13 }), $[28] = handleActivityClick, $[29] = t12, $[30] = t13, $[31] = t14) : t14 = $[31];
  let t15;
  $[32] !== t11 || $[33] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Flex, { flex: "none", gap: 2, children: [
    t11,
    t14
  ] }), $[32] = t11, $[33] = t14, $[34] = t15) : t15 = $[34];
  let t16;
  return $[35] !== t10 || $[36] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", children: [
    t10,
    t15
  ] }), $[35] = t10, $[36] = t15, $[37] = t16) : t16 = $[37], t16;
}
function _temp$1X(prev) {
  return prev === "activity" ? void 0 : "activity";
}
const emptyCellStyle = {
  textAlign: "center",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, emptyRowStyle = {
  justifyContent: "center",
  alignItems: "center",
  height: "100%"
}, TableEmptyState = (t0) => {
  const $ = c(10), {
    emptyState,
    colSpan
  } = t0;
  if (typeof emptyState == "string") {
    let t12;
    $[0] !== emptyState ? (t12 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: emptyState }), $[0] = emptyState, $[1] = t12) : t12 = $[1];
    let t22;
    return $[2] !== colSpan || $[3] !== t12 ? (t22 = /* @__PURE__ */ jsx(Card, { borderBottom: !0, display: "flex", padding: 4, as: "tr", style: emptyRowStyle, children: /* @__PURE__ */ jsx("td", { colSpan, style: emptyCellStyle, children: t12 }) }), $[2] = colSpan, $[3] = t12, $[4] = t22) : t22 = $[4], t22;
  }
  const EmptyStateComponent = emptyState;
  let t1;
  $[5] !== EmptyStateComponent ? (t1 = /* @__PURE__ */ jsx(EmptyStateComponent, {}), $[5] = EmptyStateComponent, $[6] = t1) : t1 = $[6];
  let t2;
  return $[7] !== colSpan || $[8] !== t1 ? (t2 = /* @__PURE__ */ jsx(Card, { borderBottom: !0, display: "flex", padding: 4, as: "tr", style: emptyRowStyle, children: /* @__PURE__ */ jsx("td", { colSpan, style: emptyCellStyle, children: t1 }) }), $[7] = colSpan, $[8] = t1, $[9] = t2) : t2 = $[9], t2;
}, TableProvider = (t0) => {
  const $ = c(7), {
    children,
    defaultSort
  } = t0, [searchTerm, setSearchTerm] = useState(null), [sort, setSort] = useState(defaultSort || null);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (newColumn) => {
    setSort((s) => s?.column === newColumn ? {
      ...s,
      direction: s.direction === "asc" ? "desc" : "asc"
    } : {
      column: String(newColumn),
      direction: "desc"
    });
  }, $[0] = t1) : t1 = $[0];
  const setSortColumn = t1;
  let t2;
  $[1] !== searchTerm || $[2] !== sort ? (t2 = {
    searchTerm,
    setSearchTerm,
    sort,
    setSortColumn
  }, $[1] = searchTerm, $[2] = sort, $[3] = t2) : t2 = $[3];
  const contextValue = t2;
  let t3;
  return $[4] !== children || $[5] !== contextValue ? (t3 = /* @__PURE__ */ jsx(TableContext.Provider, { value: contextValue, children }), $[4] = children, $[5] = contextValue, $[6] = t3) : t3 = $[6], t3;
}, useTableContext = () => {
  const context = useContext(TableContext);
  if (!context)
    throw new Error("useTableContext must be used within a TableProvider");
  return context;
}, MotionIcon = motion.create(ArrowUpIcon), BasicHeader = (t0) => {
  const $ = c(2), {
    text
  } = t0;
  let t1;
  return $[0] !== text ? (t1 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: text }) }), $[0] = text, $[1] = t1) : t1 = $[1], t1;
}, SortHeaderButton = (t0) => {
  const $ = c(12), {
    header,
    text
  } = t0, {
    sort,
    setSortColumn
  } = useTableContext(), t1 = sort?.direction === "asc" ? 0 : 180;
  let t2;
  $[0] !== t1 ? (t2 = {
    rotate: t1
  }, $[0] = t1, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    duration: 0.25,
    ease: "easeInOut"
  }, $[2] = t3) : t3 = $[2];
  let t4;
  $[3] !== t2 ? (t4 = /* @__PURE__ */ jsx(MotionIcon, { initial: !1, animate: t2, transition: t3 }), $[3] = t2, $[4] = t4) : t4 = $[4];
  const sortIcon = t4, t5 = header.sorting && sort?.column === header.id ? sortIcon : void 0;
  let t6;
  $[5] !== header.id || $[6] !== setSortColumn ? (t6 = () => setSortColumn(String(header.id)), $[5] = header.id, $[6] = setSortColumn, $[7] = t6) : t6 = $[7];
  let t7;
  return $[8] !== t5 || $[9] !== t6 || $[10] !== text ? (t7 = /* @__PURE__ */ jsx(Button, { iconRight: t5, onClick: t6, mode: "bleed", size: "default", text }), $[8] = t5, $[9] = t6, $[10] = text, $[11] = t7) : t7 = $[11], t7;
}, TableHeaderSearch = (t0) => {
  const $ = c(16), {
    headerProps,
    searchDisabled,
    placeholder
  } = t0, {
    t
  } = useTranslation(), {
    setSearchTerm,
    searchTerm
  } = useTableContext();
  let t1;
  $[0] !== placeholder || $[1] !== t ? (t1 = placeholder || t("search.placeholder"), $[0] = placeholder, $[1] = t, $[2] = t1) : t1 = $[2];
  const t2 = searchTerm || "";
  let t3, t4;
  $[3] !== setSearchTerm ? (t3 = (event) => setSearchTerm(event.currentTarget.value), t4 = () => setSearchTerm(""), $[3] = setSearchTerm, $[4] = t3, $[5] = t4) : (t3 = $[4], t4 = $[5]);
  const t5 = !!searchTerm;
  let t6;
  $[6] !== searchDisabled || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(TextInput$1, { border: !1, fontSize: 1, icon: SearchIcon, placeholder: t1, radius: 3, value: t2, disabled: searchDisabled, onChange: t3, onClear: t4, clearButton: t5 }), $[6] = searchDisabled, $[7] = t1, $[8] = t2, $[9] = t3, $[10] = t4, $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  return $[13] !== headerProps || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsx(Stack, { ...headerProps, flex: 1, paddingY: 2, paddingRight: 3, sizing: "border", children: t6 }), $[13] = headerProps, $[14] = t6, $[15] = t7) : t7 = $[15], t7;
}, STICKY_HEADER_STYLE = {
  position: "sticky",
  top: 0,
  zIndex: 1
}, TableHeader = (t0) => {
  const $ = c(8), {
    headers,
    searchDisabled
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    paddingInline: `max(
          calc((100% - var(--maxInlineSize)) / 2),
          var(--paddingInline)
        )`
  }, $[0] = t1) : t1 = $[0];
  let t2;
  if ($[1] !== headers || $[2] !== searchDisabled) {
    let t32;
    $[4] !== searchDisabled ? (t32 = (t4) => {
      const {
        header: Header2,
        style,
        width,
        id: id2,
        sorting
      } = t4;
      return !!Header2 && /* @__PURE__ */ jsx(Header2, { headerProps: {
        as: "th",
        id: String(id2),
        style: {
          ...style,
          width: width || void 0
        }
      }, header: {
        id: id2,
        sorting
      }, searchDisabled }, String(id2));
    }, $[4] = searchDisabled, $[5] = t32) : t32 = $[5], t2 = headers.map(t32), $[1] = headers, $[2] = searchDisabled, $[3] = t2;
  } else
    t2 = $[3];
  let t3;
  return $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Card, { as: "thead", borderBottom: !0, style: STICKY_HEADER_STYLE, children: /* @__PURE__ */ jsx(Flex, { as: "tr", style: t1, children: t2 }) }), $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}, Headers = {
  SortHeaderButton,
  TableHeaderSearch,
  BasicHeader
}, TableLayout = (t0) => {
  const $ = c(16), {
    isEmptyState,
    header,
    content,
    contentHeight
  } = t0;
  if (isEmptyState) {
    let t12, t22;
    $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = {
      height: "100%"
    }, t22 = {
      width: "100%",
      height: "100%",
      display: "grid",
      gridTemplateRows: "auto 1fr"
    }, $[0] = t12, $[1] = t22) : (t12 = $[0], t22 = $[1]);
    let t32;
    $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t32 = {
      height: "100%",
      position: "relative",
      overflow: "hidden"
    }, $[2] = t32) : t32 = $[2];
    let t4;
    $[3] !== content ? (t4 = /* @__PURE__ */ jsx("tbody", { style: t32, children: content }), $[3] = content, $[4] = t4) : t4 = $[4];
    let t5;
    return $[5] !== header || $[6] !== t4 ? (t5 = /* @__PURE__ */ jsx("div", { style: t12, children: /* @__PURE__ */ jsxs("table", { style: t22, children: [
      header,
      t4
    ] }) }), $[5] = header, $[6] = t4, $[7] = t5) : t5 = $[7], t5;
  }
  let t1;
  $[8] !== contentHeight ? (t1 = {
    height: contentHeight,
    position: "relative"
  }, $[8] = contentHeight, $[9] = t1) : t1 = $[9];
  let t2;
  $[10] !== content || $[11] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { style: t1, as: "tbody", children: content }), $[10] = content, $[11] = t1, $[12] = t2) : t2 = $[12];
  let t3;
  return $[13] !== header || $[14] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Stack, { as: "table", children: [
    header,
    t2
  ] }), $[13] = header, $[14] = t2, $[15] = t3) : t3 = $[15], t3;
}, ITEM_HEIGHT$1 = 59, LOADING_ROW_COUNT = 3, TableInner = ({
  columnDefs,
  data,
  emptyState,
  searchFilter,
  rowId,
  rowActions,
  loading = !1,
  rowProps = () => ({}),
  scrollContainerRef,
  hideTableInlinePadding = !1
}) => {
  const {
    searchTerm,
    sort
  } = useTableContext(), filteredData = useMemo(() => {
    const filteredResult = searchFilter ? searchFilter(data, searchTerm || "") : data;
    if (!sort) return filteredResult;
    const sortColumn = columnDefs.find((column) => column.id === sort.column);
    return [...filteredResult].sort((a, b) => {
      let order;
      const [aValue, bValue] = [a, b].map((sortValue) => sortColumn?.sortTransform?.(sortValue, sort.direction) ?? get(sortValue, sort.column));
      if (typeof aValue == "string" && typeof bValue == "string" && !isValid(aValue) && !isValid(bValue))
        order = aValue.toLowerCase().localeCompare(bValue.toLowerCase());
      else {
        const parseDate2 = (datum) => sortColumn?.sortTransform && typeof datum == "number" ? datum : typeof datum == "string" ? Date.parse(datum) : 0, [aDate, bDate] = [aValue, bValue].map(parseDate2);
        order = aDate - bDate;
      }
      return sort.direction === "asc" ? order : -order;
    });
  }, [columnDefs, data, searchFilter, searchTerm, sort]), rowVirtualizer = useVirtualizer({
    count: filteredData.length,
    getScrollElement: () => scrollContainerRef,
    estimateSize: () => ITEM_HEIGHT$1,
    overscan: 5
  }), rowActionColumnDef = useMemo(() => ({
    id: "actions",
    sorting: !1,
    width: 50,
    header: ({
      headerProps: {
        id: id2
      }
    }) => /* @__PURE__ */ jsx(Flex, { as: "th", id: id2, paddingY: 3, paddingX: 3, sizing: "border", style: {
      width: "50px"
    }, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: "\xA0" }) }),
    cell: ({
      datum: datum_0,
      cellProps: {
        id: id_0
      }
    }) => /* @__PURE__ */ jsx(Flex, { as: "td", id: id_0, align: "center", flex: "none", padding: 3, style: {
      width: "25px"
    }, children: !datum_0.isLoading && rowActions?.({
      datum: datum_0
    }) || /* @__PURE__ */ jsx(Box, { style: {
      width: "25px"
    } }) })
  }), [rowActions]), amalgamatedColumnDefs = useMemo(() => (rowActions ? [...columnDefs, rowActionColumnDef] : columnDefs).filter((column_0) => !column_0.hidden), [columnDefs, rowActionColumnDef, rowActions]), tableMinWidth = useMemo(() => amalgamatedColumnDefs.reduce((sum2, col) => sum2 + (col.width || 200), 0), [amalgamatedColumnDefs]), renderRow = useMemo(() => function(datum_1) {
    const cardRowProps = rowProps(datum_1), cardKey = loading ? `skeleton-${datum_1.index}` : String(get(datum_1, rowId));
    return /* @__PURE__ */ jsx(Card, { "data-testid": loading ? "table-row-skeleton" : "table-row", borderBottom: !0, display: "flex", "data-index": datum_1.index, as: "tr", style: {
      height: `${datum_1.virtualRow.size}px`,
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      transform: `translateY(${datum_1.virtualRow.start}px)`,
      paddingInline: `max(
                calc((100% - var(--maxInlineSize)) / 2),
                var(--paddingInline)
              )`
    }, ...cardRowProps, children: amalgamatedColumnDefs.map(({
      cell: Cell,
      style,
      width,
      id: id_1,
      sorting = !1
    }) => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Cell, { datum: {
      ...datum_1,
      isLoading: loading
    }, cellProps: {
      as: "td",
      id: String(id_1),
      style: {
        ...style,
        width: width || void 0
      }
    }, sorting }) }, String(id_1))) }, cardKey);
  }, [amalgamatedColumnDefs, loading, rowId, rowProps]), emptyContent = useMemo(() => /* @__PURE__ */ jsx(TableEmptyState, { emptyState, colSpan: amalgamatedColumnDefs.length }), [amalgamatedColumnDefs.length, emptyState]), headers = useMemo(() => amalgamatedColumnDefs.map(({
    cell,
    sortTransform,
    ...header
  }) => ({
    ...header,
    id: String(header.id)
  })), [amalgamatedColumnDefs]), theme = useTheme(), maxInlineSize = !hideTableInlinePadding && theme.sanity.v2?.container[3] || 0, renderLoadingRows = (rowRenderer) => Array.from({
    length: LOADING_ROW_COUNT
  }).map((_el, index) => {
    const cardKey_0 = `skeleton-${index}`, virtualRow = {
      index,
      start: index * ITEM_HEIGHT$1,
      size: ITEM_HEIGHT$1,
      lane: 0,
      key: cardKey_0,
      end: index * ITEM_HEIGHT$1 + ITEM_HEIGHT$1
    };
    return rowRenderer({
      _id: cardKey_0,
      isLoading: !0,
      virtualRow,
      index,
      isFirst: index === 0,
      isLast: index === LOADING_ROW_COUNT - 1
    });
  }), tableContent = () => loading ? renderLoadingRows(renderRow) : filteredData.length === 0 ? emptyContent : rowVirtualizer.getVirtualItems().map((virtualRow_0, index_0) => {
    const datum_2 = filteredData[virtualRow_0.index];
    return renderRow({
      ...datum_2,
      virtualRow: virtualRow_0,
      index: index_0,
      isFirst: virtualRow_0.index === 0,
      isLast: virtualRow_0.index === filteredData.length - 1
    });
  });
  return /* @__PURE__ */ jsx("div", { style: {
    height: "100%"
  }, children: /* @__PURE__ */ jsx("div", { style: {
    width: "100%",
    minWidth: `${tableMinWidth}px`,
    height: "100%",
    position: "relative",
    "--maxInlineSize": rem(maxInlineSize),
    "--paddingInline": rem(theme.sanity.v2?.space[3] ?? 0)
  }, children: /* @__PURE__ */ jsx(TableLayout, { isEmptyState: filteredData.length === 0 && !loading, header: /* @__PURE__ */ jsx(TableHeader, { headers, searchDisabled: loading || !searchTerm && !data.length }), content: tableContent(), contentHeight: `${rowVirtualizer.getTotalSize()}px` }) }) });
}, Table = (t0) => {
  const $ = c(8);
  let defaultSort, props2;
  $[0] !== t0 ? ({
    defaultSort,
    ...props2
  } = t0, $[0] = t0, $[1] = defaultSort, $[2] = props2) : (defaultSort = $[1], props2 = $[2]);
  let t1;
  $[3] !== props2 ? (t1 = /* @__PURE__ */ jsx(TableInner, { ...props2 }), $[3] = props2, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== defaultSort || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsx(TableProvider, { defaultSort, children: t1 }) }), $[5] = defaultSort, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, IS_MAC = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), DEBUG_FRAGMENT = "_debug_search_score", DEBUG_MODE = !1, SEARCH_LIMIT = 1e3, GLOBAL_SEARCH_KEY = "k", GLOBAL_SEARCH_KEY_MODIFIER = IS_MAC ? "Cmd" : "Ctrl", POPOVER_INPUT_PADDING = studioTheme.space[4], POPOVER_MAX_HEIGHT = 735, POPOVER_MAX_WIDTH = 800, POPOVER_VERTICAL_MARGIN = 5, POPOVER_RADIUS = 3;
function useSearchState() {
  const context = useContext(SearchContext);
  if (context === void 0)
    throw new Error("useSearchState must be used within an SearchProvider");
  return context;
}
function hasSearchableTerms({
  allowEmptyQueries,
  terms
}) {
  const hasQuery = allowEmptyQueries ? !0 : terms.query.length > 0, hasFilter = !!terms.filter, hasSelectedTypes = terms.types.length > 0;
  return hasQuery || hasFilter || hasSelectedTypes;
}
const isSearchHotKey = isHotkey(`mod+${GLOBAL_SEARCH_KEY}`), isEscape$1 = isHotkey("escape");
function useSearchHotkeys(t0) {
  const $ = c(7), {
    open,
    onClose,
    onOpen
  } = t0, {
    isTopLayer
  } = useLayer();
  let t1;
  $[0] !== onClose ? (t1 = () => {
    onClose?.();
  }, $[0] = onClose, $[1] = t1) : t1 = $[1];
  const handleClose = t1;
  let t2;
  $[2] !== handleClose || $[3] !== isTopLayer || $[4] !== onOpen || $[5] !== open ? (t2 = (event) => {
    isSearchHotKey(event) && (event.preventDefault(), open ? handleClose() : onOpen?.()), isEscape$1(event) && open && isTopLayer && handleClose();
  }, $[2] = handleClose, $[3] = isTopLayer, $[4] = onOpen, $[5] = open, $[6] = t2) : t2 = $[6], useGlobalKeyDown(t2);
}
function SearchWrapper(t0) {
  const $ = c(24), {
    children,
    hasValidTerms,
    onClose,
    onOpen,
    open
  } = t0, isMountedRef = useRef(!1), {
    dispatch,
    searchCommandList,
    setOnClose,
    state: t1
  } = useSearchState(), {
    result
  } = t1;
  let t2;
  $[0] !== dispatch || $[1] !== onClose || $[2] !== searchCommandList ? (t2 = () => {
    dispatch({
      index: searchCommandList?.getTopIndex() ?? -1,
      type: "LAST_ACTIVE_INDEX_SET"
    }), onClose();
  }, $[0] = dispatch, $[1] = onClose, $[2] = searchCommandList, $[3] = t2) : t2 = $[3];
  const handleClose = t2;
  let t3;
  $[4] !== handleClose || $[5] !== onOpen || $[6] !== open ? (t3 = {
    onClose: handleClose,
    onOpen,
    open
  }, $[4] = handleClose, $[5] = onOpen, $[6] = open, $[7] = t3) : t3 = $[7], useSearchHotkeys(t3);
  let t4, t5;
  $[8] !== handleClose || $[9] !== setOnClose ? (t4 = () => {
    setOnClose(() => handleClose);
  }, t5 = [handleClose, setOnClose], $[8] = handleClose, $[9] = setOnClose, $[10] = t4, $[11] = t5) : (t4 = $[10], t5 = $[11]), useEffect(t4, t5);
  let t6, t7;
  $[12] !== dispatch || $[13] !== hasValidTerms || $[14] !== result.loaded ? (t6 = () => {
    (!hasValidTerms || result.loaded) && isMountedRef.current && dispatch({
      index: 0,
      type: "LAST_ACTIVE_INDEX_SET"
    });
  }, t7 = [dispatch, hasValidTerms, result.loaded], $[12] = dispatch, $[13] = hasValidTerms, $[14] = result.loaded, $[15] = t6, $[16] = t7) : (t6 = $[15], t7 = $[16]), useEffect(t6, t7);
  let t8, t9;
  $[17] !== dispatch || $[18] !== hasValidTerms || $[19] !== open ? (t8 = () => {
    !hasValidTerms && isMountedRef.current && !open && dispatch({
      type: "ORDERING_RESET"
    });
  }, t9 = [dispatch, hasValidTerms, open], $[17] = dispatch, $[18] = hasValidTerms, $[19] = open, $[20] = t8, $[21] = t9) : (t8 = $[20], t9 = $[21]), useEffect(t8, t9);
  let t10, t11;
  return $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    isMountedRef?.current || (isMountedRef.current = !0);
  }, t11 = [], $[22] = t10, $[23] = t11) : (t10 = $[22], t11 = $[23]), useEffect(t10, t11), children;
}
function createFilterDefinitionDictionary(filterDefinitions2) {
  return filterDefinitions2.reduce((acc, val) => (acc[val.name] = val, acc), {});
}
function defineSearchFilter(filterDef) {
  return filterDef;
}
function defineSearchFilterOperators(operators) {
  return operators;
}
function getFilterDefinition(definitions, filterName) {
  return definitions[filterName];
}
function getSupportedFieldTypes(filterDefs) {
  return filterDefs.reduce((acc, val) => (val.type === "field" && acc.push(val.fieldType), acc), []);
}
function createOperatorDefinitionDictionary(operatorDefinitions2) {
  return operatorDefinitions2.reduce((acc, val) => (acc[val.type] = val, acc), {});
}
function getOperatorDefinition(operators, operatorType) {
  return operatorType ? operators[operatorType] : void 0;
}
function getOperatorInitialValue(operators, operatorType) {
  return getOperatorDefinition(operators, operatorType)?.initialValue;
}
function buildSearchFilter(filterDefinition, fieldId) {
  return {
    fieldId,
    filterName: filterDefinition.name,
    operatorType: filterDefinition?.operators.find((operator) => operator.type === "item")?.name || ""
  };
}
function generateFilterQuery({
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  filters,
  operatorDefinitions: operatorDefinitions2
}) {
  return filters.filter((filter2) => validateFilter({
    filter: filter2,
    filterDefinitions: filterDefinitions2,
    fieldDefinitions,
    operatorDefinitions: operatorDefinitions2
  })).map((filter2) => getOperatorDefinition(operatorDefinitions2, filter2.operatorType)?.groqFilter({
    fieldPath: resolveFieldPath({
      filter: filter2,
      fieldDefinitions,
      filterDefinitions: filterDefinitions2
    }),
    value: filter2?.value
  })).filter((filter2) => !isEmpty$1(filter2)).filter(isNonNullable$2).join(" && ");
}
function getFieldFromFilter(fields, filter2) {
  return filter2?.fieldId ? fields[filter2.fieldId] : void 0;
}
function getFilterKey(filter2) {
  return [filter2.filterName, ...filter2.fieldId ? [filter2.fieldId] : []].join("-");
}
function narrowDocumentTypes({
  fieldDefinitions,
  filters,
  types
}) {
  const selectedDocumentTypes = types.map((type) => type.name), filteredDocumentTypes = Object.values(fieldDefinitions).filter((field) => filters.map((filter2) => filter2?.fieldId).includes(field.id)).filter((field) => field.documentTypes.length > 0).map((field) => field.documentTypes), intersectingDocumentTypes = intersection(...filteredDocumentTypes), documentTypes = [];
  return selectedDocumentTypes.length > 0 && documentTypes.push(selectedDocumentTypes), intersectingDocumentTypes.length > 0 && documentTypes.push(intersectingDocumentTypes), intersection(...documentTypes).sort();
}
function resolveFieldPath({
  filter: filter2,
  fieldDefinitions,
  filterDefinitions: filterDefinitions2
}) {
  const fieldDefinition = getFieldFromFilter(fieldDefinitions, filter2), filterDefinition = getFilterDefinition(filterDefinitions2, filter2.filterName);
  if (filterDefinition)
    switch (filterDefinition.type) {
      case "field":
        return fieldDefinition?.fieldPath;
      case "pinned":
        return filterDefinition?.fieldPath;
      default:
        return;
    }
}
function validateFilter({
  filter: filter2,
  filterDefinitions: filterDefinitions2,
  fieldDefinitions,
  operatorDefinitions: operatorDefinitions2
}) {
  const filterDef = getFilterDefinition(filterDefinitions2, filter2.filterName), operatorDef = getOperatorDefinition(operatorDefinitions2, filter2.operatorType), fieldDef = getFieldFromFilter(fieldDefinitions, filter2);
  return !(!filterDef || !operatorDef || filter2.fieldId && !fieldDef || filterDef.type === "field" && (!fieldDef?.fieldPath || !filter2.fieldId || !operatorDef.groqFilter({
    fieldPath: fieldDef.fieldPath,
    value: filter2.value
  })) || filterDef.type === "pinned" && !operatorDef.groqFilter({
    fieldPath: filterDef.fieldPath,
    value: filter2.value
  }));
}
const isEscape = isHotkey("escape"), MAX_HEIGHT = 500, HiddenOverlay = styled.div.withConfig({
  displayName: "HiddenOverlay",
  componentId: "sc-ijpdjy-0"
})`background:transparent;height:100%;left:0;position:fixed;top:0;width:100%;z-index:-1;`;
function FilterPopoverWrapper(t0) {
  const $ = c(15), {
    anchorElement,
    children,
    onClose
  } = t0, {
    isTopLayer
  } = useLayer();
  let t1;
  $[0] !== isTopLayer || $[1] !== onClose ? (t1 = (event) => {
    isEscape(event) && isTopLayer && onClose();
  }, $[0] = isTopLayer, $[1] = onClose, $[2] = t1) : t1 = $[2], useGlobalKeyDown(t1);
  const popoverOffset = usePopoverOffset(anchorElement || null);
  let t2;
  $[3] !== onClose ? (t2 = /* @__PURE__ */ jsx(HiddenOverlay, { onClick: onClose }), $[3] = onClose, $[4] = t2) : t2 = $[4];
  const t3 = `min(calc(100vh - ${popoverOffset}px - ${POPOVER_VERTICAL_MARGIN}px - ${POPOVER_INPUT_PADDING}px), ${MAX_HEIGHT}px`;
  let t4;
  $[5] !== t3 ? (t4 = {
    maxHeight: t3,
    zIndex: 1
  }, $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== children ? (t5 = /* @__PURE__ */ jsx(Flex, { children }), $[7] = children, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t4 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsx(FocusLock, { autoFocus: !1, returnFocus: !0, children: /* @__PURE__ */ jsx(Card, { display: "flex", overflow: "hidden", radius: POPOVER_RADIUS, style: t4, children: t5 }) }), $[9] = t4, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  return $[12] !== t2 || $[13] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t2,
    t6
  ] }), $[12] = t2, $[13] = t6, $[14] = t7) : t7 = $[14], t7;
}
function calcPopoverOffset(element) {
  const rect = element.getBoundingClientRect();
  return rect.y + rect.height + POPOVER_VERTICAL_MARGIN;
}
function usePopoverOffset(element) {
  const $ = c(10);
  let t0;
  $[0] !== element ? (t0 = element && calcPopoverOffset(element), $[0] = element, $[1] = t0) : t0 = $[1];
  const [offset, setOffset] = useState(t0);
  let t1;
  $[2] !== element ? (t1 = () => {
    element && setOffset(calcPopoverOffset(element));
  }, $[2] = element, $[3] = t1) : t1 = $[3];
  const handleWindowResize = t1;
  let t2, t3;
  $[4] !== element ? (t2 = () => {
    element && setOffset(calcPopoverOffset(element));
  }, t3 = [element], $[4] = element, $[5] = t2, $[6] = t3) : (t2 = $[5], t3 = $[6]), useEffect(t2, t3);
  let t4, t5;
  return $[7] !== handleWindowResize ? (t4 = () => (window.addEventListener("resize", handleWindowResize), () => window.removeEventListener("resize", handleWindowResize)), t5 = [handleWindowResize], $[7] = handleWindowResize, $[8] = t4, $[9] = t5) : (t4 = $[8], t5 = $[9]), useEffect(t4, t5), offset;
}
const CustomTextInputBox = /* @__PURE__ */ styled(Box).withConfig({
  displayName: "CustomTextInputBox",
  componentId: "sc-gvtuis-0"
})(({
  $background,
  $smallClearButton
}) => css`
    width: 100%;

    input + span {
      background: ${({
  theme
}) => $background ? theme.sanity.color.card.disabled.bg2 : "transparent"};
    }

    [data-qa='clear-button'] {
      background: none;
      box-shadow: none;
      display: flex; /* TODO: hack, currently used to vertically center <TextInput>'s clearButton */
      transform: ${$smallClearButton ? "scale(0.8)" : "scale(1)"};
      &:hover {
        opacity: 0.5;
      }
    }
  `), CustomTextInput = forwardRef(function(props2, ref) {
  const $ = c(11);
  let $background, $smallClearButton, rest;
  $[0] !== props2 ? ({
    $background,
    $smallClearButton,
    ...rest
  } = props2, $[0] = props2, $[1] = $background, $[2] = $smallClearButton, $[3] = rest) : ($background = $[1], $smallClearButton = $[2], rest = $[3]);
  let t0;
  $[4] !== ref || $[5] !== rest ? (t0 = /* @__PURE__ */ jsx(TextInput$1, { ...rest, ref }), $[4] = ref, $[5] = rest, $[6] = t0) : t0 = $[6];
  let t1;
  return $[7] !== $background || $[8] !== $smallClearButton || $[9] !== t0 ? (t1 = /* @__PURE__ */ jsx(CustomTextInputBox, { $background, $smallClearButton, children: t0 }), $[7] = $background, $[8] = $smallClearButton, $[9] = t0, $[10] = t1) : t1 = $[10], t1;
}), SearchHeaderBox = styled(Box).withConfig({
  displayName: "SearchHeaderBox",
  componentId: "sc-50u6gq-0"
})`border-bottom:1px solid ${({
  theme
}) => theme.sanity.color.base.border};flex-shrink:0;`, SearchHeaderContentFlex = styled(Flex).withConfig({
  displayName: "SearchHeaderContentFlex",
  componentId: "sc-50u6gq-1"
})`box-sizing:border-box;`, FilterPopoverContentHeader = forwardRef(function(t0, ref) {
  const $ = c(11), {
    ariaInputLabel,
    onChange,
    onClear,
    typeFilter
  } = t0, {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation(), t2 = !!typeFilter, t3 = fullscreen ? 2 : 1;
  let t4;
  $[0] !== t ? (t4 = t("search.filter-placeholder"), $[0] = t, $[1] = t4) : t4 = $[1];
  let t5;
  return $[2] !== ariaInputLabel || $[3] !== onChange || $[4] !== onClear || $[5] !== ref || $[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== typeFilter ? (t5 = /* @__PURE__ */ jsx(SearchHeaderBox, { children: /* @__PURE__ */ jsx(SearchHeaderContentFlex, { align: "center", flex: 1, padding: 1, children: /* @__PURE__ */ jsx(CustomTextInput, { __unstable_disableFocusRing: !0, $smallClearButton: !0, "aria-label": ariaInputLabel, autoComplete: "off", border: !1, clearButton: t2, fontSize: t3, icon: SearchIcon, muted: !0, onChange, onClear, placeholder: t4, ref, spellCheck: !1, radius: 2, value: typeFilter }) }) }), $[2] = ariaInputLabel, $[3] = onChange, $[4] = onClear, $[5] = ref, $[6] = t2, $[7] = t3, $[8] = t4, $[9] = typeFilter, $[10] = t5) : t5 = $[10], t5;
});
function createFilterMenuItems({
  documentTypesNarrowed,
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  schema: schema2,
  titleFilter,
  types,
  t
}) {
  const fieldFilters = Object.values(fieldDefinitions).filter((fieldDef) => includesTitleInFieldDefinition(fieldDef, titleFilter)).map((fieldDef) => {
    const filterDef = getFilterDefinition(filterDefinitions2, fieldDef.filterName);
    return filterDef ? buildSearchFilter(filterDef, fieldDef.id) : null;
  }).filter(isNonNullable$2), pinnedItems = buildPinnedMenuItems({
    fieldDefinitions,
    filterDefinitions: filterDefinitions2,
    titleFilter
  });
  return documentTypesNarrowed.length === 0 ? [
    ...pinnedItems,
    // All fields
    ...filterGroup({
      fieldDefinitions,
      filterDefinitions: filterDefinitions2,
      filters: fieldFilters,
      headerTitle: t("search.filter-all-fields-header"),
      id: "field"
    })
  ] : [
    ...pinnedItems,
    // All shared / narrowed items
    ...buildFieldMenuItemsNarrowed({
      documentTypesNarrowed,
      fieldDefinitions,
      filterDefinitions: filterDefinitions2,
      filters: fieldFilters,
      schema: schema2,
      types,
      t
    })
  ];
}
function filterGroup({
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  filters,
  id: id2,
  headerTitle,
  tone
}) {
  const header = {
    title: headerTitle || "",
    tone: tone || "default",
    type: "header"
  }, filterItems = filters.map((filter2) => ({
    fieldDefinition: getFieldFromFilter(fieldDefinitions, filter2),
    filterDefinition: getFilterDefinition(filterDefinitions2, filter2.filterName),
    filter: filter2,
    group: id2,
    tone: tone || "default",
    type: "filter"
  }));
  return filterItems.length > 0 ? [
    ...headerTitle ? [header] : [],
    //
    ...filterItems
  ] : [];
}
function buildFieldMenuItemsNarrowed({
  documentTypesNarrowed,
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  filters,
  schema: schema2,
  types,
  t
}) {
  const sharedFilters = filters.filter((filter2) => {
    const fieldDefinition = getFieldFromFilter(fieldDefinitions, filter2);
    return sharesDocumentTypes(documentTypesNarrowed, fieldDefinition);
  }), sharedItems = documentTypesNarrowed.length > 1 && types.length > 1 ? filterGroup({
    fieldDefinitions,
    filterDefinitions: filterDefinitions2,
    filters: sharedFilters,
    headerTitle: t("search.filter-shared-fields-header"),
    id: "shared",
    tone: "primary"
  }) : [], groupedItems = documentTypesNarrowed.map((documentType) => {
    const docType = schema2.get(documentType);
    return {
      // Note: it shouldn't be possible to select document types that do not exist in schema,
      // and there is no way to inject it into state (eg not persisted in URL), thus we leave
      // this fallback (`Unknown type`) only as a edge-case safety net and will not translate it.
      title: docType?.title || startCase(docType?.name) || "(Unknown type)",
      documentType
    };
  }).sort((a, b) => a.title.localeCompare(b.title)).flatMap(({
    documentType,
    title
  }) => {
    const groupFilters = filters.filter((filter2) => {
      const fieldDefinition = getFieldFromFilter(fieldDefinitions, filter2);
      return includesDocumentTypes([documentType], fieldDefinition);
    });
    return filterGroup({
      fieldDefinitions,
      filterDefinitions: filterDefinitions2,
      filters: groupFilters,
      id: title,
      headerTitle: title
    });
  });
  return [...sharedItems, ...groupedItems];
}
function buildPinnedMenuItems({
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  titleFilter
}) {
  const ungroupedPinnedFilters = Object.values(filterDefinitions2).filter(isPinnedFilterDefWithoutGroup).filter((filterDef) => includesTitleInPinnedFilterDefinition(filterDef, titleFilter)).map((filterDef) => buildSearchFilter(filterDef)), groupedPinnedFilters = Object.values(filterDefinitions2).filter(isPinnedFilterDefWithGroup).filter((filterDef) => includesTitleInPinnedFilterDefinition(filterDef, titleFilter)).reduce((acc, val) => (acc[val.group] = acc[val.group] || [], acc[val.group].push(buildSearchFilter(val)), acc), {});
  return [
    // Ungrouped
    ...filterGroup({
      fieldDefinitions,
      filterDefinitions: filterDefinitions2,
      filters: ungroupedPinnedFilters,
      id: "pinned-ungrouped",
      tone: "primary"
    }),
    // Grouped
    ...Object.entries(groupedPinnedFilters).flatMap(([groupTitle, filters]) => filterGroup({
      fieldDefinitions,
      filterDefinitions: filterDefinitions2,
      filters,
      headerTitle: groupTitle,
      id: groupTitle,
      tone: "primary"
    }))
  ];
}
function includesDocumentTypes(documentTypes, fieldDefinition) {
  return fieldDefinition?.documentTypes.some((type) => documentTypes.includes(type));
}
function includesTitleInFieldDefinition(field, currentTitle) {
  return field.titlePath.join("/").toLowerCase().includes(currentTitle.toLowerCase());
}
function includesTitleInPinnedFilterDefinition(filter2, currentTitle) {
  return filter2.title.toLowerCase().includes(currentTitle.toLowerCase());
}
function isPinnedFilterDefWithGroup(filterDef) {
  return filterDef.type === "pinned" && typeof filterDef?.group < "u";
}
function isPinnedFilterDefWithoutGroup(filterDef) {
  return filterDef.type === "pinned" && typeof filterDef?.group > "u";
}
function sharesDocumentTypes(documentTypes, fieldDefinition) {
  return difference(documentTypes, fieldDefinition?.documentTypes || []).length === 0;
}
function FilterTitle(t0) {
  const $ = c(9), {
    filter: filter2,
    maxLength
  } = t0, {
    state: t1
  } = useSearchState(), {
    definitions
  } = t1;
  let t2;
  bb0: {
    let t32;
    $[0] !== definitions.filters || $[1] !== filter2.filterName ? (t32 = getFilterDefinition(definitions.filters, filter2.filterName), $[0] = definitions.filters, $[1] = filter2.filterName, $[2] = t32) : t32 = $[2];
    const filterDef = t32;
    switch (filterDef?.type) {
      case "field": {
        let t4;
        $[3] !== definitions.fields || $[4] !== filter2 ? (t4 = getFieldFromFilter(definitions.fields, filter2), $[3] = definitions.fields, $[4] = filter2, $[5] = t4) : t4 = $[5];
        const fieldDefinition = t4;
        if (fieldDefinition?.titlePath) {
          t2 = fieldDefinition.titlePath[fieldDefinition.titlePath.length - 1];
          break bb0;
        }
        t2 = null;
        break bb0;
      }
      case "pinned": {
        t2 = filterDef.title;
        break bb0;
      }
      default:
        t2 = null;
    }
  }
  const title = t2;
  if (!title)
    return null;
  let t3;
  return $[6] !== maxLength || $[7] !== title ? (t3 = maxLength && title.length > maxLength ? /* @__PURE__ */ jsxs("span", { children: [
    title.slice(0, maxLength),
    "\u2026"
  ] }) : /* @__PURE__ */ jsx("span", { children: title }), $[6] = maxLength, $[7] = title, $[8] = t3) : t3 = $[8], t3;
}
function FilterIcon(t0) {
  const $ = c(6), {
    filter: filter2
  } = t0, {
    state: t1
  } = useSearchState(), {
    definitions
  } = t1;
  let t2;
  $[0] !== definitions.filters || $[1] !== filter2.filterName ? (t2 = getFilterDefinition(definitions.filters, filter2.filterName)?.icon, $[0] = definitions.filters, $[1] = filter2.filterName, $[2] = t2) : t2 = $[2];
  const Icon2 = t2;
  if (Icon2) {
    let t32;
    return $[3] !== Icon2 ? (t32 = /* @__PURE__ */ jsx(Icon2, {}), $[3] = Icon2, $[4] = t32) : t32 = $[4], t32;
  }
  let t3;
  return $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(UnknownIcon, {}), $[5] = t3) : t3 = $[5], t3;
}
function FilterDetails(t0) {
  const $ = c(18), {
    filter: filter2
  } = t0, {
    state: t1
  } = useSearchState(), {
    definitions
  } = t1;
  let T0, t2, t3;
  if ($[0] !== definitions.fields || $[1] !== filter2) {
    const fieldDefinition = getFieldFromFilter(definitions.fields, filter2);
    T0 = Stack, t2 = 2, t3 = fieldDefinition?.titlePath && fieldDefinition.titlePath?.length > 1 && /* @__PURE__ */ jsx(Box, { marginLeft: 4, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 0, children: fieldDefinition.titlePath.slice(0, -1).map((pathTitle, index) => /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("span", { children: pathTitle }),
      index !== fieldDefinition.titlePath.length - 2 && /* @__PURE__ */ jsx("span", { style: {
        opacity: 0.75,
        paddingLeft: "0.25em",
        paddingRight: "0.25em"
      }, children: /* @__PURE__ */ jsx(ChevronRightIcon, {}) })
    ] }, index)) }) }), $[0] = definitions.fields, $[1] = filter2, $[2] = T0, $[3] = t2, $[4] = t3;
  } else
    T0 = $[2], t2 = $[3], t3 = $[4];
  let t4;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    flexShrink: 0
  }, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== filter2 ? (t5 = /* @__PURE__ */ jsx(Box, { style: t4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(FilterIcon, { filter: filter2 }) }) }), $[6] = filter2, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== filter2 ? (t6 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: /* @__PURE__ */ jsx(FilterTitle, { filter: filter2 }) }), $[8] = filter2, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== t5 || $[11] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, children: [
    t5,
    t6
  ] }), $[10] = t5, $[11] = t6, $[12] = t7) : t7 = $[12];
  let t8;
  return $[13] !== T0 || $[14] !== t2 || $[15] !== t3 || $[16] !== t7 ? (t8 = /* @__PURE__ */ jsxs(T0, { space: t2, children: [
    t3,
    t7
  ] }), $[13] = T0, $[14] = t2, $[15] = t3, $[16] = t7, $[17] = t8) : t8 = $[17], t8;
}
function getSchemaField$2(schemaType, fieldPath) {
  const paths = fieldPath.split("."), firstPath = paths[0];
  if (firstPath && isObjectSchemaType(schemaType)) {
    const field = schemaType.fields.find((f) => f.name === firstPath);
    if (field) {
      const nextPath = paths.slice(1).join(".");
      return nextPath ? getSchemaField$2(field.type, nextPath) : field;
    }
  }
}
function sanitizeFieldValue(name) {
  if (isValidElement(name))
    try {
      return stripHtmlTags(renderToString(name));
    } catch (err) {
      return console.warn("A field title or description contains a React component that could not be rendered. This is likely caused by a component that requires runtime context. Use a string or JSX containing HTML elements only.", err), "";
    }
  return typeof name == "string" ? name : "";
}
function stripHtmlTags(str) {
  return new DOMParser().parseFromString(str, "text/html")?.body.textContent || "";
}
const MAX_VISIBLE_TYPES = 10;
function FilterTooltip(t0) {
  const $ = c(60), {
    children,
    fieldDefinition,
    filterDefinition,
    visible
  } = t0, {
    state: t1
  } = useSearchState(), {
    documentTypesNarrowed
  } = t1, {
    t
  } = useTranslation(), schema2 = useSchema();
  let T0, T1, T2, t2, t3, t4, t5, t6, t7, t8, t9;
  if ($[0] !== documentTypesNarrowed.length || $[1] !== fieldDefinition || $[2] !== filterDefinition || $[3] !== schema2 || $[4] !== t) {
    const fieldDefinitionDocumentTypeTitles = fieldDefinition?.documentTypes ? fieldDefinition.documentTypes.map((d) => {
      const defType = schema2.get(d);
      return defType?.title || startCase(defType?.name);
    }).filter(isNonNullable$2).sort() : EMPTY_ARRAY$y;
    if ($[16] !== fieldDefinition || $[17] !== schema2 || $[18] !== t) {
      let fieldDefinitionDescription;
      if (fieldDefinition?.documentTypes) {
        let t102;
        if ($[28] !== fieldDefinition.documentTypes || $[29] !== fieldDefinition.fieldPath || $[30] !== schema2) {
          let t112;
          $[32] !== fieldDefinition.fieldPath || $[33] !== schema2 ? (t112 = (d_0) => {
            const defType_0 = schema2.get(d_0);
            if (defType_0) {
              const field = getSchemaField$2(defType_0, fieldDefinition.fieldPath);
              return field?.type.description && sanitizeFieldValue(field?.type.description);
            }
            return null;
          }, $[32] = fieldDefinition.fieldPath, $[33] = schema2, $[34] = t112) : t112 = $[34];
          const descriptions = fieldDefinition.documentTypes.map(t112).filter(isNonNullable$2).sort();
          t102 = uniq(descriptions), $[28] = fieldDefinition.documentTypes, $[29] = fieldDefinition.fieldPath, $[30] = schema2, $[31] = t102;
        } else
          t102 = $[31];
        const uniqueDescriptions = t102;
        uniqueDescriptions.length === 1 && (fieldDefinitionDescription = uniqueDescriptions[0]);
      }
      T2 = Tooltip, T1 = Card, t7 = "default", t8 = 2, $[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = {
        maxWidth: "250px"
      }, $[35] = t9) : t9 = $[35], T0 = Stack, t2 = 4, $[36] !== fieldDefinition || $[37] !== t ? (t3 = fieldDefinition && /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
        /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("search.filter-field-tooltip-name") }),
        /* @__PURE__ */ jsx(TextWithTone, { size: 1, style: {
          fontFamily: "monospace"
        }, tone: "primary", textOverflow: "ellipsis", children: fieldDefinition?.name })
      ] }), $[36] = fieldDefinition, $[37] = t, $[38] = t3) : t3 = $[38], t4 = fieldDefinitionDescription && /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
        /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("search.filter-field-tooltip-description") }),
        /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: truncateString(fieldDefinitionDescription, 256) })
      ] }), $[16] = fieldDefinition, $[17] = schema2, $[18] = t, $[19] = T0, $[20] = T1, $[21] = T2, $[22] = t2, $[23] = t3, $[24] = t4, $[25] = t7, $[26] = t8, $[27] = t9;
    } else
      T0 = $[19], T1 = $[20], T2 = $[21], t2 = $[22], t3 = $[23], t4 = $[24], t7 = $[25], t8 = $[26], t9 = $[27];
    $[39] !== filterDefinition ? (t5 = filterDefinition?.description && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: truncateString(filterDefinition.description, 256) }), $[39] = filterDefinition, $[40] = t5) : t5 = $[40], t6 = !documentTypesNarrowed.length && fieldDefinitionDocumentTypeTitles.length > 0 && /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
      /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
        /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("search.filter-field-tooltip-used-in-document-types") }),
        /* @__PURE__ */ jsx(Card, { padding: 1, radius: 2, tone: "transparent", children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: fieldDefinitionDocumentTypeTitles.length }) })
      ] }),
      /* @__PURE__ */ jsxs(Text$1, { size: 1, weight: "regular", muted: !0, children: [
        fieldDefinitionDocumentTypeTitles.slice(0, MAX_VISIBLE_TYPES).join(", "),
        fieldDefinitionDocumentTypeTitles?.length > MAX_VISIBLE_TYPES ? ` +${fieldDefinitionDocumentTypeTitles.length - MAX_VISIBLE_TYPES} more` : ""
      ] })
    ] }), $[0] = documentTypesNarrowed.length, $[1] = fieldDefinition, $[2] = filterDefinition, $[3] = schema2, $[4] = t, $[5] = T0, $[6] = T1, $[7] = T2, $[8] = t2, $[9] = t3, $[10] = t4, $[11] = t5, $[12] = t6, $[13] = t7, $[14] = t8, $[15] = t9;
  } else
    T0 = $[5], T1 = $[6], T2 = $[7], t2 = $[8], t3 = $[9], t4 = $[10], t5 = $[11], t6 = $[12], t7 = $[13], t8 = $[14], t9 = $[15];
  let t10;
  $[41] !== T0 || $[42] !== t2 || $[43] !== t3 || $[44] !== t4 || $[45] !== t5 || $[46] !== t6 ? (t10 = /* @__PURE__ */ jsxs(T0, { space: t2, children: [
    t3,
    t4,
    t5,
    t6
  ] }), $[41] = T0, $[42] = t2, $[43] = t3, $[44] = t4, $[45] = t5, $[46] = t6, $[47] = t10) : t10 = $[47];
  let t11;
  $[48] !== T1 || $[49] !== t10 || $[50] !== t7 || $[51] !== t8 || $[52] !== t9 ? (t11 = /* @__PURE__ */ jsx(T1, { tone: t7, radius: t8, style: t9, children: t10 }), $[48] = T1, $[49] = t10, $[50] = t7, $[51] = t8, $[52] = t9, $[53] = t11) : t11 = $[53];
  const t12 = !visible;
  let t13;
  $[54] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = ["left"], $[54] = t13) : t13 = $[54];
  let t14;
  return $[55] !== T2 || $[56] !== children || $[57] !== t11 || $[58] !== t12 ? (t14 = /* @__PURE__ */ jsx(T2, { content: t11, disabled: t12, fallbackPlacements: t13, placement: "right", portal: !0, children }), $[55] = T2, $[56] = children, $[57] = t11, $[58] = t12, $[59] = t14) : t14 = $[59], t14;
}
const MenuItemFilter = memo(function(t0) {
  const $ = c(29);
  let item, onClose, rest;
  $[0] !== t0 ? ({
    item,
    onClose,
    ...rest
  } = t0, $[0] = t0, $[1] = item, $[2] = onClose, $[3] = rest) : (item = $[1], onClose = $[2], rest = $[3]);
  const {
    dispatch,
    state: t1
  } = useSearchState(), {
    filters
  } = t1;
  let t2;
  $[4] !== dispatch || $[5] !== item.filter || $[6] !== onClose ? (t2 = () => {
    dispatch({
      filter: item.filter,
      type: "TERMS_FILTERS_ADD"
    }), onClose?.();
  }, $[4] = dispatch, $[5] = item.filter, $[6] = onClose, $[7] = t2) : t2 = $[7];
  const handleClick = t2;
  let t3;
  if ($[8] !== filters || $[9] !== item.filter) {
    let t42;
    $[11] !== item.filter ? (t42 = (f) => getFilterKey(f) === getFilterKey(item.filter), $[11] = item.filter, $[12] = t42) : t42 = $[12], t3 = filters.find(t42), $[8] = filters, $[9] = item.filter, $[10] = t3;
  } else
    t3 = $[10];
  const isAlreadyActive = !!t3, tooltipEnabled = !!(item.fieldDefinition || item.filterDefinition.description), t4 = isAlreadyActive ? void 0 : handleClick;
  let t5;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    position: "relative",
    whiteSpace: "normal",
    width: "100%"
  }, $[13] = t5) : t5 = $[13];
  const t6 = item?.tone;
  let t7;
  $[14] !== item.filter ? (t7 = /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(FilterDetails, { filter: item.filter }) }), $[14] = item.filter, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== item.fieldDefinition || $[17] !== item.filterDefinition || $[18] !== t7 || $[19] !== tooltipEnabled ? (t8 = /* @__PURE__ */ jsx(FilterTooltip, { fieldDefinition: item.fieldDefinition, filterDefinition: item.filterDefinition, visible: tooltipEnabled, children: t7 }), $[16] = item.fieldDefinition, $[17] = item.filterDefinition, $[18] = t7, $[19] = tooltipEnabled, $[20] = t8) : t8 = $[20];
  let t9;
  $[21] !== isAlreadyActive || $[22] !== t4 || $[23] !== t6 || $[24] !== t8 ? (t9 = /* @__PURE__ */ jsx(Button$1, { disabled: isAlreadyActive, fontSize: 1, justify: "flex-start", mode: "bleed", onClick: t4, padding: 0, style: t5, tabIndex: -1, tone: t6, children: t8 }), $[21] = isAlreadyActive, $[22] = t4, $[23] = t6, $[24] = t8, $[25] = t9) : t9 = $[25];
  let t10;
  return $[26] !== rest || $[27] !== t9 ? (t10 = /* @__PURE__ */ jsx(Box, { ...rest, children: t9 }), $[26] = rest, $[27] = t9, $[28] = t10) : t10 = $[28], t10;
}), MenuItemHeader = memo(function(t0) {
  const $ = c(5), {
    item
  } = t0, t1 = item?.tone;
  let t2;
  $[0] !== item.title ? (t2 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", weight: "medium", children: item.title }), $[0] = item.title, $[1] = t2) : t2 = $[1];
  let t3;
  return $[2] !== t1 || $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { paddingTop: 1, children: /* @__PURE__ */ jsx(Card, { borderBottom: !0, paddingX: 2, paddingY: 3, tone: t1, children: t2 }) }), $[2] = t1, $[3] = t2, $[4] = t3) : t3 = $[4], t3;
}), POPOVER_STYLES$1 = {
  width: "300px"
};
function AddFilterPopoverContent(t0) {
  const $ = c(39), {
    onClose
  } = t0, [inputElement, setInputElement] = useState(null), [titleFilter, setTitleFilter] = useState(""), {
    t
  } = useTranslation();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (e) => setTitleFilter(e.currentTarget.value), $[0] = t1) : t1 = $[0];
  const handleFilterChange = t1;
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setTitleFilter(""), $[1] = t2) : t2 = $[1];
  const handleFilterClear = t2, schema2 = useSchema(), {
    state: t3
  } = useSearchState(), {
    documentTypesNarrowed,
    definitions,
    filters,
    terms: t4
  } = t3, {
    types
  } = t4;
  let t5;
  $[2] !== definitions.fields || $[3] !== definitions.filters || $[4] !== documentTypesNarrowed || $[5] !== schema2 || $[6] !== t || $[7] !== titleFilter || $[8] !== types ? (t5 = createFilterMenuItems({
    documentTypesNarrowed,
    fieldDefinitions: definitions.fields,
    filterDefinitions: definitions.filters,
    schema: schema2,
    titleFilter,
    types,
    t
  }), $[2] = definitions.fields, $[3] = definitions.filters, $[4] = documentTypesNarrowed, $[5] = schema2, $[6] = t, $[7] = titleFilter, $[8] = types, $[9] = t5) : t5 = $[9];
  const filteredMenuItems = t5;
  let t6;
  $[10] !== onClose ? (t6 = (item) => item.type === "filter" ? /* @__PURE__ */ jsx(MenuItemFilter, { item, onClose, paddingBottom: 1 }) : item.type === "header" ? /* @__PURE__ */ jsx(MenuItemHeader, { item }) : null, $[10] = onClose, $[11] = t6) : t6 = $[11];
  const renderItem2 = t6;
  let t7;
  $[12] !== filteredMenuItems || $[13] !== filters ? (t7 = (index) => {
    const filterItem = filteredMenuItems[index];
    return filterItem.type !== "filter" || !!filters.find((f) => getFilterKey(f) === getFilterKey(filterItem.filter));
  }, $[12] = filteredMenuItems, $[13] = filters, $[14] = t7) : t7 = $[14];
  const getItemDisabled = t7;
  let t8;
  $[15] !== filteredMenuItems ? (t8 = (index_0) => {
    const menuItem = filteredMenuItems[index_0];
    switch (menuItem.type) {
      case "filter":
        return [...menuItem.group ? [menuItem.group] : [], getFilterKey(menuItem.filter)].join("-");
      case "header":
        return `${menuItem.type}-${menuItem.title}`;
      default:
        return index_0;
    }
  }, $[15] = filteredMenuItems, $[16] = t8) : t8 = $[16];
  const getItemKey2 = t8;
  let t9;
  $[17] !== t ? (t9 = t("search.filter-by-title-aria-label"), $[17] = t, $[18] = t9) : t9 = $[18];
  let t10;
  $[19] !== t9 || $[20] !== titleFilter ? (t10 = /* @__PURE__ */ jsx(FilterPopoverContentHeader, { ariaInputLabel: t9, onChange: handleFilterChange, onClear: handleFilterClear, ref: setInputElement, typeFilter: titleFilter }), $[19] = t9, $[20] = titleFilter, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== filteredMenuItems || $[23] !== getItemDisabled || $[24] !== getItemKey2 || $[25] !== inputElement || $[26] !== renderItem2 || $[27] !== t ? (t11 = filteredMenuItems.length > 0 && /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("search.filters-aria-label", {
    count: filteredMenuItems.length
  }), autoFocus: "input", getItemDisabled, getItemKey: getItemKey2, inputElement, itemHeight: 45, items: filteredMenuItems, overscan: 20, padding: 1, paddingBottom: 0, renderItem: renderItem2 }), $[22] = filteredMenuItems, $[23] = getItemDisabled, $[24] = getItemKey2, $[25] = inputElement, $[26] = renderItem2, $[27] = t, $[28] = t11) : t11 = $[28];
  let t12;
  $[29] !== filteredMenuItems.length || $[30] !== t || $[31] !== titleFilter ? (t12 = filteredMenuItems.length == 0 && /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: t("search.filter-no-matches-found", {
    filter: titleFilter
  }) }) }), $[29] = filteredMenuItems.length, $[30] = t, $[31] = titleFilter, $[32] = t12) : t12 = $[32];
  let t13;
  $[33] !== t11 || $[34] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Flex, { children: [
    t11,
    t12
  ] }), $[33] = t11, $[34] = t12, $[35] = t13) : t13 = $[35];
  let t14;
  return $[36] !== t10 || $[37] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Flex, { direction: "column", style: POPOVER_STYLES$1, children: [
    t10,
    t13
  ] }), $[36] = t10, $[37] = t13, $[38] = t14) : t14 = $[38], t14;
}
function AddFilterButton() {
  const $ = c(18), [open, setOpen] = useState(!1), [buttonElement, setButtonElement] = useState(null), popoverRef = useRef(null), {
    t
  } = useTranslation(), {
    state: t0
  } = useSearchState(), {
    fullscreen
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setOpen(!1), $[0] = t1) : t1 = $[0];
  const handleClose = t1;
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setOpen(!0), $[1] = t2) : t2 = $[1];
  const handleOpen = t2;
  let t3;
  $[2] !== buttonElement ? (t3 = () => [buttonElement, popoverRef.current], $[2] = buttonElement, $[3] = t3) : t3 = $[3], useClickOutsideEvent(handleClose, t3);
  let t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = [POPOVER_VERTICAL_MARGIN, 0, 0, 0], $[4] = t4) : t4 = $[4];
  let t5;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(AddFilterPopoverContent, { onClose: handleClose }), $[5] = t5) : t5 = $[5];
  let t6;
  $[6] !== buttonElement ? (t6 = /* @__PURE__ */ jsx(FilterPopoverWrapper, { anchorElement: buttonElement, onClose: handleClose, children: t5 }), $[6] = buttonElement, $[7] = t6) : t6 = $[7];
  const t7 = fullscreen ? "large" : "default";
  let t8;
  $[8] !== t ? (t8 = t("search.action.add-filter"), $[8] = t, $[9] = t8) : t8 = $[9];
  let t9;
  $[10] !== open || $[11] !== t7 || $[12] !== t8 ? (t9 = /* @__PURE__ */ jsx(Button, { icon: AddIcon, mode: "bleed", onClick: handleOpen, size: t7, ref: setButtonElement, selected: open, text: t8 }), $[10] = open, $[11] = t7, $[12] = t8, $[13] = t9) : t9 = $[13];
  let t10;
  return $[14] !== open || $[15] !== t6 || $[16] !== t9 ? (t10 = /* @__PURE__ */ jsx(Popover, { __unstable_margins: t4, content: t6, open, placement: "bottom-start", radius: POPOVER_RADIUS, ref: popoverRef, portal: !0, children: t9 }), $[14] = open, $[15] = t6, $[16] = t9, $[17] = t10) : t10 = $[17], t10;
}
function getDocumentTypesTruncated({
  availableCharacters = 40,
  types
}) {
  if (types.length === 0)
    return {
      remainingCount: 0,
      types: []
    };
  const visibleTypes = types.reduce(/* @__PURE__ */ (function() {
    let remaining = availableCharacters;
    return function(acc, val, index) {
      const title = typeTitle(val);
      return remaining -= title.length, (index === 0 || availableCharacters > title.length && remaining > title.length) && acc.push(val), acc;
    };
  })(), []);
  return {
    remainingCount: types.length - visibleTypes.length,
    types: visibleTypes.map(typeTitle)
  };
}
function documentTypesTruncated({
  t,
  availableCharacters,
  types
}) {
  if (types.length === 0)
    return t("search.document-type-list-all-types");
  const {
    remainingCount,
    types: visibleTypes
  } = getDocumentTypesTruncated({
    availableCharacters,
    types
  }), key = remainingCount > 0 ? "search.document-type-list-truncated" : "search.document-type-list";
  return t(key, {
    count: remainingCount,
    types: visibleTypes,
    formatParams: {
      types: {
        style: "short",
        type: "unit"
      }
    }
  });
}
function typeTitle(schemaType) {
  return schemaType.title ?? schemaType.name;
}
function getSelectableOmnisearchTypes(schema2, typeFilter) {
  return getSearchableOmnisearchTypes(schema2).filter((type) => inTypeFilter(type, typeFilter)).sort(sortTypes);
}
function getSearchableOmnisearchTypes(schema2) {
  return getSearchableTypes(schema2).filter((type) => type.__experimental_omnisearch_visibility !== !1);
}
function sortTypes(a, b) {
  return (a.title ?? a.name).localeCompare(b.title ?? b.name);
}
function inTypeFilter(type, typeFilter) {
  return !typeFilter || (type.title ?? type.name).toLowerCase().includes(typeFilter?.toLowerCase());
}
const DocumentTypeFilterItem = memo(function(t0) {
  const $ = c(23);
  let rest, selected, type;
  $[0] !== t0 ? ({
    selected,
    type,
    ...rest
  } = t0, $[0] = t0, $[1] = rest, $[2] = selected, $[3] = type) : (rest = $[1], selected = $[2], type = $[3]);
  const {
    dispatch
  } = useSearchState();
  let t1;
  $[4] !== dispatch || $[5] !== type ? (t1 = () => {
    dispatch({
      type: "TERMS_TYPE_ADD",
      schemaType: type
    });
  }, $[4] = dispatch, $[5] = type, $[6] = t1) : t1 = $[6];
  const handleTypeAdd = t1;
  let t2;
  $[7] !== dispatch || $[8] !== type ? (t2 = () => {
    dispatch({
      type: "TERMS_TYPE_REMOVE",
      schemaType: type
    });
  }, $[7] = dispatch, $[8] = type, $[9] = t2) : t2 = $[9];
  const handleTypeRemove = t2;
  let t3;
  $[10] !== handleTypeAdd || $[11] !== handleTypeRemove || $[12] !== selected ? (t3 = () => {
    selected ? handleTypeRemove() : handleTypeAdd();
  }, $[10] = handleTypeAdd, $[11] = handleTypeRemove, $[12] = selected, $[13] = t3) : t3 = $[13];
  const handleClick = t3, t4 = type.title ?? type.name, t5 = selected && CheckmarkIcon, t6 = type.title ?? type.name, t7 = selected ? "primary" : "default";
  let t8;
  $[14] !== handleClick || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { iconRight: t5, justify: "flex-start", mode: "bleed", onClick: handleClick, width: "fill", size: "large", tabIndex: -1, text: t6, tone: t7 }, t4), $[14] = handleClick, $[15] = t4, $[16] = t5, $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  return $[20] !== rest || $[21] !== t8 ? (t9 = /* @__PURE__ */ jsx(Box, { ...rest, children: t8 }), $[20] = rest, $[21] = t8, $[22] = t9) : t9 = $[22], t9;
}), ClearButtonBox = styled(Box).withConfig({
  displayName: "ClearButtonBox",
  componentId: "sc-xxyhdm-0"
})`border-top:1px solid ${({
  theme
}) => theme.sanity.color.base.border};flex-shrink:0;`, POPOVER_STYLES = {
  width: "250px"
};
function DocumentTypesPopoverContent() {
  const $ = c(37), [inputElement, setInputElement] = useState(null), [typeFilter, setTypeFilter] = useState(""), commandListRef = useRef(null), {
    t
  } = useTranslation(), schema2 = useSchema(), {
    dispatch,
    state: t0
  } = useSearchState(), {
    terms: t1
  } = t0, {
    types: selectedTypes
  } = t1, [selectedTypesSnapshot, setSelectedTypesSnapshot] = useState(selectedTypes), documentTypeItems = useGetDocumentTypeItems(schema2, selectedTypes, selectedTypesSnapshot, typeFilter);
  let t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (e) => setTypeFilter(e.currentTarget.value), $[0] = t2) : t2 = $[0];
  const handleFilterChange = t2;
  let t3;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setTypeFilter(""), $[1] = t3) : t3 = $[1];
  const handleFilterClear = t3;
  let t4;
  $[2] !== dispatch ? (t4 = () => {
    setSelectedTypesSnapshot([]), dispatch({
      type: "TERMS_TYPES_CLEAR"
    }), commandListRef?.current?.focusInputElement(), commandListRef?.current?.scrollToIndex(0);
  }, $[2] = dispatch, $[3] = t4) : t4 = $[3];
  const handleTypesClear = t4;
  let t5;
  $[4] !== documentTypeItems ? (t5 = (index) => {
    const virtualItem = documentTypeItems[index];
    switch (virtualItem.type) {
      case "divider":
        return `${virtualItem.type}-${index}`;
      case "header":
        return `${virtualItem.type}-${virtualItem.title}`;
      case "item":
        return `${virtualItem.type}-${virtualItem.item.name}`;
      default:
        return index;
    }
  }, $[4] = documentTypeItems, $[5] = t5) : t5 = $[5];
  const getItemKey2 = t5, renderItem2 = _temp$1W;
  let t6;
  $[6] !== documentTypeItems ? (t6 = (index_0) => documentTypeItems[index_0].type !== "item", $[6] = documentTypeItems, $[7] = t6) : t6 = $[7];
  const getItemDisabled = t6;
  let t7;
  $[8] !== documentTypeItems ? (t7 = (index_1) => {
    const item_1 = documentTypeItems[index_1];
    return item_1.type === "item" && item_1.selected;
  }, $[8] = documentTypeItems, $[9] = t7) : t7 = $[9];
  const getItemSelected = t7;
  let t8;
  $[10] !== t ? (t8 = t("search.action.filter-by-document-type-aria-label"), $[10] = t, $[11] = t8) : t8 = $[11];
  let t9;
  $[12] !== t8 || $[13] !== typeFilter ? (t9 = /* @__PURE__ */ jsx(FilterPopoverContentHeader, { ariaInputLabel: t8, onChange: handleFilterChange, onClear: handleFilterClear, ref: setInputElement, typeFilter }), $[12] = t8, $[13] = typeFilter, $[14] = t9) : t9 = $[14];
  let t10;
  $[15] !== documentTypeItems || $[16] !== getItemDisabled || $[17] !== getItemKey2 || $[18] !== getItemSelected || $[19] !== inputElement || $[20] !== t ? (t10 = documentTypeItems.length > 0 && /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("search.document-types-aria-label"), ariaMultiselectable: !0, autoFocus: "input", getItemDisabled, getItemSelected, getItemKey: getItemKey2, inputElement, itemHeight: 37, items: documentTypeItems, overscan: 20, padding: 1, paddingBottom: 0, ref: commandListRef, renderItem: renderItem2 }), $[15] = documentTypeItems, $[16] = getItemDisabled, $[17] = getItemKey2, $[18] = getItemSelected, $[19] = inputElement, $[20] = t, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== documentTypeItems.length || $[23] !== t || $[24] !== typeFilter ? (t11 = !documentTypeItems.length && /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: t("search.document-types-no-matches-found", {
    filter: typeFilter
  }) }) }), $[22] = documentTypeItems.length, $[23] = t, $[24] = typeFilter, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== t10 || $[27] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Flex, { children: [
    t10,
    t11
  ] }), $[26] = t10, $[27] = t11, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== handleTypesClear || $[30] !== selectedTypes || $[31] !== typeFilter ? (t13 = !typeFilter && selectedTypes.length > 0 && /* @__PURE__ */ jsx(ClearButton, { onClick: handleTypesClear, selectedTypes }), $[29] = handleTypesClear, $[30] = selectedTypes, $[31] = typeFilter, $[32] = t13) : t13 = $[32];
  let t14;
  return $[33] !== t12 || $[34] !== t13 || $[35] !== t9 ? (t14 = /* @__PURE__ */ jsxs(Flex, { direction: "column", style: POPOVER_STYLES, children: [
    t9,
    t12,
    t13
  ] }), $[33] = t12, $[34] = t13, $[35] = t9, $[36] = t14) : t14 = $[36], t14;
}
function _temp$1W(item) {
  return item.type === "divider" ? /* @__PURE__ */ jsx(Box, { paddingY: 1, children: /* @__PURE__ */ jsx(MenuDivider, {}) }) : item.type === "header" ? /* @__PURE__ */ jsx(Box, { margin: 2, padding: 1, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: item.title }) }) : item.type === "item" ? /* @__PURE__ */ jsx(DocumentTypeFilterItem, { paddingBottom: 1, selected: item.selected, type: item.item }) : null;
}
function ClearButton(t0) {
  const $ = c(9), {
    onClick: onClick2,
    selectedTypes
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("search.action.clear-type-filters-aria-label"), $[0] = t, $[1] = t1) : t1 = $[1];
  const t2 = selectedTypes.length === 0;
  let t3;
  $[2] !== t ? (t3 = t("search.action.clear-type-filters-label"), $[2] = t, $[3] = t3) : t3 = $[3];
  let t4;
  return $[4] !== onClick2 || $[5] !== t1 || $[6] !== t2 || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(ClearButtonBox, { padding: 1, children: /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Button, { "aria-label": t1, "data-name": "type-filter-button", disabled: t2, mode: "bleed", onClick: onClick2, text: t3, tone: "primary" }) }) }), $[4] = onClick2, $[5] = t1, $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
function useGetDocumentTypeItems(schema2, selectedTypes, selectedTypesSnapshot, typeFilter) {
  const $ = c(5);
  let items;
  if ($[0] !== schema2 || $[1] !== selectedTypes || $[2] !== selectedTypesSnapshot || $[3] !== typeFilter) {
    const [itemsSelected, itemsUnselected] = partition(getSelectableOmnisearchTypes(schema2, typeFilter), (type) => selectedTypesSnapshot.includes(type)), hasSelectedItems = itemsSelected.length > 0, hasUnselectedItems = itemsSelected.length > 0;
    items = [], hasSelectedItems && items.push({
      title: "Selected",
      type: "header"
    }), itemsSelected.forEach((item) => items.push({
      item,
      selected: selectedTypes.includes(item),
      type: "item"
    })), hasSelectedItems && hasUnselectedItems && items.push({
      type: "divider"
    }), itemsUnselected.forEach((item_0) => items.push({
      item: item_0,
      selected: selectedTypes.includes(item_0),
      type: "item"
    })), $[0] = schema2, $[1] = selectedTypes, $[2] = selectedTypesSnapshot, $[3] = typeFilter, $[4] = items;
  } else
    items = $[4];
  return items;
}
const FALLBACK_PLACEMENTS = ["top-start", "bottom-start"];
function DocumentTypesButton() {
  const $ = c(19), [open, setOpen] = useState(!1), [buttonElement, setButtonElement] = useState(null), popoverRef = useRef(null), {
    state: t0
  } = useSearchState(), {
    fullscreen,
    terms: t1
  } = t0, {
    types
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setOpen(!1), $[0] = t2) : t2 = $[0];
  const handleClose = t2;
  let t3;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setOpen(!0), $[1] = t3) : t3 = $[1];
  const handleOpen = t3;
  let t4;
  $[2] !== buttonElement ? (t4 = () => [buttonElement, popoverRef.current], $[2] = buttonElement, $[3] = t4) : t4 = $[3], useClickOutsideEvent(handleClose, t4);
  let t5;
  $[4] !== t || $[5] !== types ? (t5 = documentTypesTruncated({
    types,
    t
  }), $[4] = t, $[5] = types, $[6] = t5) : t5 = $[6];
  const title = t5;
  let t6;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = [POPOVER_VERTICAL_MARGIN, 0, 0, 0], $[7] = t6) : t6 = $[7];
  let t7;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsx(DocumentTypesPopoverContent, {}), $[8] = t7) : t7 = $[8];
  let t8;
  $[9] !== buttonElement ? (t8 = /* @__PURE__ */ jsx(FilterPopoverWrapper, { anchorElement: buttonElement, onClose: handleClose, children: t7 }), $[9] = buttonElement, $[10] = t8) : t8 = $[10];
  const t9 = fullscreen ? "large" : "default";
  let t10;
  $[11] !== open || $[12] !== t9 || $[13] !== title ? (t10 = /* @__PURE__ */ jsx(Button, { iconRight: ChevronDownIcon, mode: "ghost", onClick: handleOpen, size: t9, ref: setButtonElement, selected: open, text: title, tone: "default" }), $[11] = open, $[12] = t9, $[13] = title, $[14] = t10) : t10 = $[14];
  let t11;
  return $[15] !== open || $[16] !== t10 || $[17] !== t8 ? (t11 = /* @__PURE__ */ jsx(Popover, { __unstable_margins: t6, content: t8, open, placement: "bottom-start", fallbackPlacements: FALLBACK_PLACEMENTS, portal: !0, radius: POPOVER_RADIUS, ref: popoverRef, children: t10 }), $[15] = open, $[16] = t10, $[17] = t8, $[18] = t11) : t11 = $[18], t11;
}
const CustomBox = styled(Box).withConfig({
  displayName: "CustomBox",
  componentId: "sc-i77z7g-0"
})`flex-shrink:${({
  $flexShrink = 0
}) => $flexShrink};`;
function FilterLabel(t0) {
  const $ = c(29), {
    filter: filter2,
    fontSize: t1,
    showContent: t2
  } = t0, fontSize = t1 === void 0 ? 1 : t1, showContent = t2 === void 0 ? !0 : t2, {
    t
  } = useTranslation(), {
    state: t3
  } = useSearchState(), {
    definitions,
    fullscreen
  } = t3;
  let t4;
  $[0] !== definitions.operators || $[1] !== filter2.operatorType ? (t4 = getOperatorDefinition(definitions.operators, filter2.operatorType), $[0] = definitions.operators, $[1] = filter2.operatorType, $[2] = t4) : t4 = $[2];
  const operator = t4, ButtonValue = operator?.buttonValueComponent, filterValue = filter2.value;
  let t5;
  $[3] !== filter2 || $[4] !== fontSize || $[5] !== fullscreen ? (t5 = () => /* @__PURE__ */ jsx(CustomBox, { $flexShrink: fullscreen ? 1 : 0, children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", size: fontSize, textOverflow: "ellipsis", weight: "medium", children: /* @__PURE__ */ jsx(FilterTitle, { filter: filter2, maxLength: fullscreen ? 25 : 40 }) }) }), $[3] = filter2, $[4] = fontSize, $[5] = fullscreen, $[6] = t5) : t5 = $[6];
  let t6;
  $[7] !== fontSize || $[8] !== showContent ? (t6 = (t72) => {
    const {
      children
    } = t72;
    return showContent ? /* @__PURE__ */ jsx(CustomBox, { $flexShrink: 0, children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", size: fontSize, textOverflow: "ellipsis", weight: "regular", children }) }) : null;
  }, $[7] = fontSize, $[8] = showContent, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== ButtonValue || $[11] !== filterValue || $[12] !== fontSize || $[13] !== showContent ? (t7 = (t82) => {
    const {
      children: children_0
    } = t82;
    return showContent ? /* @__PURE__ */ jsx(CustomBox, { $flexShrink: 1, children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", size: fontSize, textOverflow: "ellipsis", weight: "medium", children: ButtonValue ? /* @__PURE__ */ jsx(ButtonValue, { value: filterValue }) : children_0 }) }) : null;
  }, $[10] = ButtonValue, $[11] = filterValue, $[12] = fontSize, $[13] = showContent, $[14] = t7) : t7 = $[14];
  let t8;
  $[15] !== t5 || $[16] !== t6 || $[17] !== t7 ? (t8 = {
    Field: t5,
    Operator: t6,
    Value: t7
  }, $[15] = t5, $[16] = t6, $[17] = t7, $[18] = t8) : t8 = $[18];
  const components2 = t8;
  if (operator?.descriptionKey || console.warn("Missing `descriptionKey` for operator `%s`", filter2.operatorType), !showContent || !operator?.descriptionKey) {
    const Field = components2.Field;
    let t92;
    return $[19] !== Field ? (t92 = /* @__PURE__ */ jsx(Flex, { align: "center", gap: 1, children: /* @__PURE__ */ jsx(Field, {}) }), $[19] = Field, $[20] = t92) : t92 = $[20], t92;
  }
  const t9 = operator?.descriptionKey;
  let t10;
  $[21] !== filter2 || $[22] !== t ? (t10 = getFilterValues(filter2, t), $[21] = filter2, $[22] = t, $[23] = t10) : t10 = $[23];
  let t11;
  return $[24] !== components2 || $[25] !== t || $[26] !== t10 || $[27] !== t9 ? (t11 = /* @__PURE__ */ jsx(Flex, { align: "center", gap: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: t9, components: components2, values: t10 }) }), $[24] = components2, $[25] = t, $[26] = t10, $[27] = t9, $[28] = t11) : t11 = $[28], t11;
}
function getFilterValues(filter2, t) {
  const values2 = {};
  return typeof filter2.value == "number" && (values2.count = filter2.value), isStringOrNumber(filter2.value) && (values2.value = filter2.value), typeof filter2.value == "boolean" && (values2.value = filter2.value ? t("search.filter-boolean-true") : t("search.filter-boolean-false")), isRecord$4(filter2.value) && "from" in filter2.value && isStringOrNumber(filter2.value.from) && (values2.from = filter2.value.from), isRecord$4(filter2.value) && "to" in filter2.value && isStringOrNumber(filter2.value.to) && (values2.to = filter2.value.to), values2;
}
function isStringOrNumber(value) {
  return typeof value == "string" || typeof value == "number";
}
function FilterError(props2) {
  const $ = c(15), {
    t
  } = useTranslation();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(TextWithTone, { tone: "critical", children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== t ? (t1 = t("search.error.display-filter-title"), $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "critical", weight: "medium", children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("search.error.display-filter-description"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "critical", children: t3 }), $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t2 || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, children: [
    t0,
    /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
      t2,
      t4
    ] })
  ] }), $[9] = t2, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== props2 || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { ...props2, children: t5 }), $[12] = props2, $[13] = t5, $[14] = t6) : t6 = $[14], t6;
}
function CustomMenuItem$2(t0) {
  const $ = c(11), {
    onClick: onClick2,
    operator,
    selected
  } = t0;
  let t1;
  $[0] !== onClick2 || $[1] !== operator.type ? (t1 = () => onClick2(operator.type), $[0] = onClick2, $[1] = operator.type, $[2] = t1) : t1 = $[2];
  const handleClick = t1, {
    t
  } = useTranslation();
  let t2;
  $[3] !== operator.nameKey || $[4] !== t ? (t2 = t(operator.nameKey), $[3] = operator.nameKey, $[4] = t, $[5] = t2) : t2 = $[5];
  const t3 = operator?.icon;
  let t4;
  return $[6] !== handleClick || $[7] !== selected || $[8] !== t2 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(MenuItem, { onClick: handleClick, pressed: selected, tone: "default", text: t2, iconRight: t3 }), $[6] = handleClick, $[7] = selected, $[8] = t2, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
}
function OperatorsMenuButton(t0) {
  const $ = c(38), {
    filter: filter2,
    operator
  } = t0, menuButtonId = useId(), {
    t
  } = useTranslation(), {
    dispatch,
    state
  } = useSearchState();
  let T0, T1, T2, t1, t2, t3, t4;
  if ($[0] !== dispatch || $[1] !== filter2 || $[2] !== menuButtonId || $[3] !== operator || $[4] !== state.definitions.filters || $[5] !== state.definitions.operators || $[6] !== t) {
    t4 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    bb0: {
      const operatorItems = getFilterDefinition(state.definitions.filters, filter2.filterName)?.operators;
      let t52;
      $[14] !== dispatch || $[15] !== filter2 ? (t52 = (operatorType) => {
        dispatch({
          filterKey: getFilterKey(filter2),
          operatorType,
          type: "TERMS_FILTERS_SET_OPERATOR"
        });
      }, $[14] = dispatch, $[15] = filter2, $[16] = t52) : t52 = $[16];
      const handleClick = t52;
      if (!operator || !operatorItems || operatorItems.length <= 1) {
        t4 = null;
        break bb0;
      }
      T2 = Inline, T1 = MenuButton;
      let t62;
      $[17] !== operator.nameKey || $[18] !== t ? (t62 = t(operator.nameKey), $[17] = operator.nameKey, $[18] = t, $[19] = t62) : t62 = $[19], $[20] !== t62 ? (t2 = /* @__PURE__ */ jsx(Button, { mode: "ghost", iconRight: ChevronDownIcon, text: t62 }), $[20] = t62, $[21] = t2) : t2 = $[21], t3 = menuButtonId || "", T0 = Menu;
      let t72;
      $[22] !== handleClick || $[23] !== operator.type || $[24] !== state.definitions.operators ? (t72 = (item, index) => {
        if (item.type === "item") {
          const menuOperator = getOperatorDefinition(state.definitions.operators, item.name);
          return menuOperator ? /* @__PURE__ */ jsx(CustomMenuItem$2, { onClick: handleClick, operator: menuOperator, selected: operator.type === item.name }, index) : null;
        }
        return item.type === "divider" ? /* @__PURE__ */ jsx(MenuDivider, {}, index) : null;
      }, $[22] = handleClick, $[23] = operator.type, $[24] = state.definitions.operators, $[25] = t72) : t72 = $[25], t1 = operatorItems.map(t72);
    }
    $[0] = dispatch, $[1] = filter2, $[2] = menuButtonId, $[3] = operator, $[4] = state.definitions.filters, $[5] = state.definitions.operators, $[6] = t, $[7] = T0, $[8] = T1, $[9] = T2, $[10] = t1, $[11] = t2, $[12] = t3, $[13] = t4;
  } else
    T0 = $[7], T1 = $[8], T2 = $[9], t1 = $[10], t2 = $[11], t3 = $[12], t4 = $[13];
  if (t4 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return t4;
  let t5;
  $[26] !== T0 || $[27] !== t1 ? (t5 = /* @__PURE__ */ jsx(T0, { children: t1 }), $[26] = T0, $[27] = t1, $[28] = t5) : t5 = $[28];
  let t6;
  $[29] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    constrainSize: !0,
    portal: !1,
    radius: 2
  }, $[29] = t6) : t6 = $[29];
  let t7;
  $[30] !== T1 || $[31] !== t2 || $[32] !== t3 || $[33] !== t5 ? (t7 = /* @__PURE__ */ jsx(T1, { button: t2, id: t3, menu: t5, placement: "bottom-start", popover: t6 }), $[30] = T1, $[31] = t2, $[32] = t3, $[33] = t5, $[34] = t7) : t7 = $[34];
  let t8;
  return $[35] !== T2 || $[36] !== t7 ? (t8 = /* @__PURE__ */ jsx(T2, { children: t7 }), $[35] = T2, $[36] = t7, $[37] = t8) : t8 = $[37], t8;
}
function FilterForm(t0) {
  const $ = c(45), {
    filter: filter2
  } = t0, [errorParams, setErrorParams] = useState(null), {
    dispatch,
    state: t1
  } = useSearchState(), {
    definitions,
    fullscreen
  } = t1;
  let t2;
  $[0] !== definitions.filters || $[1] !== filter2.filterName ? (t2 = getFilterDefinition(definitions.filters, filter2.filterName), $[0] = definitions.filters, $[1] = filter2.filterName, $[2] = t2) : t2 = $[2];
  const filterDefinition = t2;
  let t3;
  $[3] !== definitions.operators || $[4] !== filter2.operatorType ? (t3 = getOperatorDefinition(definitions.operators, filter2.operatorType), $[3] = definitions.operators, $[4] = filter2.operatorType, $[5] = t3) : t3 = $[5];
  const operator = t3;
  let t4;
  $[6] !== definitions.fields || $[7] !== filter2 ? (t4 = getFieldFromFilter(definitions.fields, filter2), $[6] = definitions.fields, $[7] = filter2, $[8] = t4) : t4 = $[8];
  const fieldDefinition = t4;
  let t5;
  $[9] !== filter2 ? (t5 = getFilterKey(filter2), $[9] = filter2, $[10] = t5) : t5 = $[10];
  const filterKey = t5;
  let t6;
  $[11] !== dispatch || $[12] !== filter2 ? (t6 = () => {
    dispatch({
      filterKey: getFilterKey(filter2),
      type: "TERMS_FILTERS_REMOVE"
    });
  }, $[11] = dispatch, $[12] = filter2, $[13] = t6) : t6 = $[13];
  const handleClose = t6;
  let t7;
  $[14] !== dispatch || $[15] !== filterKey ? (t7 = (value) => {
    dispatch({
      filterKey,
      type: "TERMS_FILTERS_SET_VALUE",
      value
    });
  }, $[14] = dispatch, $[15] = filterKey, $[16] = t7) : t7 = $[16];
  const handleValueChange = t7;
  let t8;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = (params) => {
    setErrorParams(params);
  }, $[17] = t8) : t8 = $[17];
  const handleCatchError = t8, Component2 = operator?.inputComponent;
  if (errorParams) {
    let t92;
    return $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t92 = /* @__PURE__ */ jsx(FilterError, { padding: 4 }), $[18] = t92) : t92 = $[18], t92;
  }
  let t9;
  $[19] !== Component2 || $[20] !== fieldDefinition || $[21] !== filter2.operatorType || $[22] !== filter2.value || $[23] !== handleValueChange ? (t9 = Component2 && /* @__PURE__ */ jsx(Card, { borderTop: !0, padding: 3, children: /* @__PURE__ */ jsx(Component2, { fieldDefinition, onChange: handleValueChange, value: filter2.value }, filter2.operatorType) }), $[19] = Component2, $[20] = fieldDefinition, $[21] = filter2.operatorType, $[22] = filter2.value, $[23] = handleValueChange, $[24] = t9) : t9 = $[24];
  let t10;
  $[25] !== filter2 ? (t10 = /* @__PURE__ */ jsx(Box, { paddingLeft: 1, paddingRight: 2, paddingY: 1, children: /* @__PURE__ */ jsx(FilterDetails, { filter: filter2 }) }), $[25] = filter2, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== fullscreen || $[28] !== handleClose ? (t11 = fullscreen && /* @__PURE__ */ jsx(Button, { icon: TrashIcon, mode: "bleed", onClick: handleClose, tone: "critical", tooltipProps: {
    content: "Remove filter"
  } }), $[27] = fullscreen, $[28] = handleClose, $[29] = t11) : t11 = $[29];
  let t12;
  $[30] !== t10 || $[31] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, justify: "space-between", children: [
    t10,
    t11
  ] }), $[30] = t10, $[31] = t11, $[32] = t12) : t12 = $[32];
  let t13;
  $[33] !== filterDefinition ? (t13 = filterDefinition?.description && /* @__PURE__ */ jsx(Card, { border: !0, padding: 3, radius: 2, tone: "transparent", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: filterDefinition.description }) }), $[33] = filterDefinition, $[34] = t13) : t13 = $[34];
  let t14;
  $[35] !== filter2 || $[36] !== operator ? (t14 = /* @__PURE__ */ jsx(OperatorsMenuButton, { filter: filter2, operator }), $[35] = filter2, $[36] = operator, $[37] = t14) : t14 = $[37];
  let t15;
  $[38] !== t12 || $[39] !== t13 || $[40] !== t14 ? (t15 = /* @__PURE__ */ jsx(Card, { padding: 3, children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t12,
    t13,
    t14
  ] }) }), $[38] = t12, $[39] = t13, $[40] = t14, $[41] = t15) : t15 = $[41];
  let t16;
  return $[42] !== t15 || $[43] !== t9 ? (t16 = /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: handleCatchError, children: /* @__PURE__ */ jsx(FocusLock, { autoFocus: !supportsTouch, returnFocus: !0, children: /* @__PURE__ */ jsxs(Flex, { direction: "column-reverse", children: [
    t9,
    t15
  ] }) }) }), $[42] = t15, $[43] = t9, $[44] = t16) : t16 = $[44], t16;
}
const ContainerFlex = styled(Flex).withConfig({
  displayName: "ContainerFlex",
  componentId: "sc-1a56kua-0"
})`max-width:480px;min-width:150px;overflow:hidden;overflow:clip;width:100%;`;
function FilterPopoverContent(t0) {
  const $ = c(6), {
    filter: filter2
  } = t0;
  let t1, t2;
  $[0] !== filter2 ? (t1 = /* @__PURE__ */ jsx(FilterForm, { filter: filter2 }), t2 = DEBUG_MODE, $[0] = filter2, $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]);
  let t3;
  return $[3] !== t1 || $[4] !== t2 ? (t3 = /* @__PURE__ */ jsxs(ContainerFlex, { direction: "column", children: [
    t1,
    t2
  ] }), $[3] = t1, $[4] = t2, $[5] = t3) : t3 = $[5], t3;
}
const CloseButton = styled(Button$1).withConfig({
  displayName: "CloseButton",
  componentId: "sc-1v4keo-0"
})`border-radius:${({
  theme
}) => `0 ${rem(theme.sanity.radius[2])} ${rem(theme.sanity.radius[2])} 0`};`, CloseCard = styled(Card).withConfig({
  displayName: "CloseCard",
  componentId: "sc-1v4keo-1"
})`position:absolute;right:0;`, ContainerDiv = styled.div.withConfig({
  displayName: "ContainerDiv",
  componentId: "sc-1v4keo-2"
})`align-items:center;display:inline-flex;max-width:100%;position:relative;`, LabelButton = styled(Button$1).withConfig({
  displayName: "LabelButton",
  componentId: "sc-1v4keo-3"
})`border:none;width:100%;`;
function FilterButton(t0) {
  const $ = c(45), {
    filter: filter2,
    initialOpen
  } = t0, [open, setOpen] = useState(initialOpen), [buttonElement, setButtonElement] = useState(null), popoverRef = useRef(null), {
    dispatch,
    state: t1
  } = useSearchState(), {
    definitions,
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setOpen(!1), $[0] = t2) : t2 = $[0];
  const handleClose = t2;
  let t3;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setOpen(!0), $[1] = t3) : t3 = $[1];
  const handleOpen = t3;
  let t4;
  $[2] !== dispatch || $[3] !== filter2 ? (t4 = () => dispatch({
    filterKey: getFilterKey(filter2),
    type: "TERMS_FILTERS_REMOVE"
  }), $[2] = dispatch, $[3] = filter2, $[4] = t4) : t4 = $[4];
  const handleRemove = t4;
  let t5;
  $[5] !== handleRemove ? (t5 = (event) => {
    ["Backspace", "Delete"].includes(event.key) && handleRemove();
  }, $[5] = handleRemove, $[6] = t5) : t5 = $[6];
  const handleKeyDown = t5;
  let t6;
  $[7] !== buttonElement ? (t6 = () => [buttonElement, popoverRef.current], $[7] = buttonElement, $[8] = t6) : t6 = $[8], useClickOutsideEvent(handleClose, t6);
  let t7;
  $[9] !== definitions.fields || $[10] !== definitions.filters || $[11] !== definitions.operators || $[12] !== filter2 ? (t7 = validateFilter({
    fieldDefinitions: definitions.fields,
    filter: filter2,
    filterDefinitions: definitions.filters,
    operatorDefinitions: definitions.operators
  }), $[9] = definitions.fields, $[10] = definitions.filters, $[11] = definitions.operators, $[12] = filter2, $[13] = t7) : t7 = $[13];
  const isValid2 = t7;
  let t8;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = [POPOVER_VERTICAL_MARGIN, 0, 0, 0], $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== filter2 ? (t9 = /* @__PURE__ */ jsx(FilterPopoverContent, { filter: filter2 }), $[15] = filter2, $[16] = t9) : t9 = $[16];
  let t10;
  $[17] !== buttonElement || $[18] !== t9 ? (t10 = /* @__PURE__ */ jsx(FilterPopoverWrapper, { anchorElement: buttonElement, onClose: handleClose, children: t9 }), $[17] = buttonElement, $[18] = t9, $[19] = t10) : t10 = $[19];
  const t11 = isValid2 ? "primary" : "transparent", t12 = fullscreen ? 3 : 2, t13 = fullscreen ? 3 : 5, t14 = fullscreen ? 3 : 2;
  let t15;
  $[20] !== filter2 || $[21] !== isValid2 ? (t15 = /* @__PURE__ */ jsx(FilterLabel, { filter: filter2, showContent: isValid2 }), $[20] = filter2, $[21] = isValid2, $[22] = t15) : t15 = $[22];
  let t16;
  $[23] !== handleKeyDown || $[24] !== t12 || $[25] !== t13 || $[26] !== t14 || $[27] !== t15 ? (t16 = /* @__PURE__ */ jsx(LabelButton, { mode: "bleed", onClick: handleOpen, onKeyDown: handleKeyDown, paddingLeft: t12, paddingRight: t13, paddingY: t14, ref: setButtonElement, children: t15 }), $[23] = handleKeyDown, $[24] = t12, $[25] = t13, $[26] = t14, $[27] = t15, $[28] = t16) : t16 = $[28];
  let t17;
  $[29] !== t11 || $[30] !== t16 ? (t17 = /* @__PURE__ */ jsx(Card, { __unstable_focusRing: !0, display: "flex", radius: 2, tone: t11, children: t16 }), $[29] = t11, $[30] = t16, $[31] = t17) : t17 = $[31];
  let t18;
  $[32] !== fullscreen || $[33] !== handleKeyDown || $[34] !== handleRemove || $[35] !== isValid2 || $[36] !== t ? (t18 = !fullscreen && /* @__PURE__ */ jsx(CloseCard, { __unstable_focusRing: !0, display: "flex", radius: 2, tone: isValid2 ? "primary" : "transparent", children: /* @__PURE__ */ jsx(CloseButton, { "aria-label": t("search.action.remove-filter-aria-label"), fontSize: 1, icon: CloseIcon, mode: "bleed", onClick: handleRemove, onKeyDown: handleKeyDown, padding: 2, radius: 2 }) }), $[32] = fullscreen, $[33] = handleKeyDown, $[34] = handleRemove, $[35] = isValid2, $[36] = t, $[37] = t18) : t18 = $[37];
  let t19;
  $[38] !== t17 || $[39] !== t18 ? (t19 = /* @__PURE__ */ jsxs(ContainerDiv, { children: [
    t17,
    t18
  ] }), $[38] = t17, $[39] = t18, $[40] = t19) : t19 = $[40];
  let t20;
  return $[41] !== open || $[42] !== t10 || $[43] !== t19 ? (t20 = /* @__PURE__ */ jsx(Popover, { __unstable_margins: t8, content: t10, constrainSize: !0, open, overflow: "auto", placement: "bottom-start", portal: !0, radius: POPOVER_RADIUS, ref: popoverRef, children: t19 }), $[41] = open, $[42] = t10, $[43] = t19, $[44] = t20) : t20 = $[44], t20;
}
function Filters(t0) {
  const $ = c(36), {
    showTypeFilter: t1
  } = t0, showTypeFilter = t1 === void 0 ? !0 : t1, {
    dispatch,
    state: t2
  } = useSearchState(), {
    filters,
    fullscreen,
    lastAddedFilter,
    terms: t3
  } = t2, {
    types
  } = t3, {
    t
  } = useTranslation(), [isMounted, setIsMounted] = useState(!1);
  let t4;
  $[0] !== dispatch || $[1] !== showTypeFilter ? (t4 = () => {
    showTypeFilter && dispatch({
      type: "TERMS_TYPES_CLEAR"
    }), dispatch({
      type: "TERMS_FILTERS_CLEAR"
    });
  }, $[0] = dispatch, $[1] = showTypeFilter, $[2] = t4) : t4 = $[2];
  const handleClear = t4, clearFiltersButtonVisible = filters.length > 0 || showTypeFilter && types.length > 0;
  let t5, t6;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    setIsMounted(!0);
  }, t6 = [], $[3] = t5, $[4] = t6) : (t5 = $[3], t6 = $[4]), useEffect(t5, t6);
  let t7;
  $[5] !== lastAddedFilter ? (t7 = lastAddedFilter && getFilterKey(lastAddedFilter), $[5] = lastAddedFilter, $[6] = t7) : t7 = $[6];
  const lastAddedFilterKey = t7, t8 = fullscreen ? "large" : "default";
  let t9;
  $[7] !== t ? (t9 = t("search.action.clear-filters"), $[7] = t, $[8] = t9) : t9 = $[8];
  let t10;
  $[9] !== handleClear || $[10] !== t8 || $[11] !== t9 ? (t10 = /* @__PURE__ */ jsx(Button, { mode: "bleed", onClick: handleClear, size: t8, text: t9, tone: "critical" }), $[9] = handleClear, $[10] = t8, $[11] = t9, $[12] = t10) : t10 = $[12];
  const clearFiltersButton = t10;
  let t11;
  $[13] !== showTypeFilter ? (t11 = showTypeFilter && /* @__PURE__ */ jsx(DocumentTypesButton, {}), $[13] = showTypeFilter, $[14] = t11) : t11 = $[14];
  let t12;
  $[15] !== filters || $[16] !== isMounted || $[17] !== lastAddedFilterKey ? (t12 = filters?.map((filter2) => {
    const key = getFilterKey(filter2);
    return /* @__PURE__ */ jsx(FilterButton, { filter: filter2, initialOpen: isMounted && lastAddedFilterKey === key }, key);
  }), $[15] = filters, $[16] = isMounted, $[17] = lastAddedFilterKey, $[18] = t12) : t12 = $[18];
  let t13;
  $[19] !== fullscreen ? (t13 = !fullscreen && /* @__PURE__ */ jsx(AddFilterButton, {}), $[19] = fullscreen, $[20] = t13) : t13 = $[20];
  let t14;
  $[21] !== t11 || $[22] !== t12 || $[23] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Flex, { flex: 1, gap: 2, wrap: "wrap", children: [
    t11,
    t12,
    t13
  ] }), $[21] = t11, $[22] = t12, $[23] = t13, $[24] = t14) : t14 = $[24];
  const t15 = clearFiltersButtonVisible && !fullscreen && clearFiltersButton;
  let t16;
  $[25] !== t14 || $[26] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, justify: "space-between", padding: 2, children: [
    t14,
    t15
  ] }), $[25] = t14, $[26] = t15, $[27] = t16) : t16 = $[27];
  let t17;
  $[28] !== clearFiltersButton || $[29] !== clearFiltersButtonVisible || $[30] !== fullscreen ? (t17 = fullscreen && /* @__PURE__ */ jsxs(Flex, { justify: "space-between", paddingBottom: 2, paddingX: 2, children: [
    /* @__PURE__ */ jsx(AddFilterButton, {}),
    clearFiltersButtonVisible && clearFiltersButton
  ] }), $[28] = clearFiltersButton, $[29] = clearFiltersButtonVisible, $[30] = fullscreen, $[31] = t17) : t17 = $[31];
  let t18;
  $[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t18 = DEBUG_MODE, $[32] = t18) : t18 = $[32];
  let t19;
  return $[33] !== t16 || $[34] !== t17 ? (t19 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t16,
    t17,
    t18
  ] }), $[33] = t16, $[34] = t17, $[35] = t19) : t19 = $[35], t19;
}
const MAX_OBJECT_TRAVERSAL_DEPTH = 3;
function createFieldDefinitions(schema2, filterDefinitions2) {
  const searchableDocumentTypeNames = getSearchableOmnisearchTypes(schema2).map((s) => s.name), {
    documentTypes,
    objectTypes
  } = (schema2._original?.types || []).filter((t) => (isDocumentObjectDefinition(t) ? searchableDocumentTypeNames.includes(t.name) : !0) && // Ignore the 'slug' object to prevent surfacing 'current' and (deprecated) 'source field' fields.
  t.name !== "slug" && // Ignore sanity documents and assets
  !t.name.startsWith("sanity.")).reduce((acc, schemaType) => (isDocumentObjectDefinition(schemaType) && (acc.documentTypes[schemaType.name] = schemaType), isObjectDefinition(schemaType) && (acc.objectTypes[schemaType.name] = schemaType), acc), {
    documentTypes: {},
    objectTypes: {}
  }) || {
    documentTypes: {},
    objectTypes: {}
  }, supportedFieldTypes = getSupportedFieldTypes(filterDefinitions2);
  return getDocumentFieldDefinitions(supportedFieldTypes, documentTypes, objectTypes);
}
function createFieldDefinitionDictionary(fieldDefinitions) {
  return fieldDefinitions.reduce((acc, val) => (acc[val.id] = val, acc), {});
}
function generateFieldId(field) {
  return [field.type, field.fieldPath, field.title].join("-");
}
function getDocumentFieldDefinitions(supportedFieldTypes, documentTypes, objectTypes) {
  const supportedFieldTypeSet = new Set(supportedFieldTypes);
  function addFieldDefinitionRecursive({
    acc,
    defType,
    depth = 0,
    documentType,
    prevFieldPath,
    prevTitlePath
  }) {
    if (depth > MAX_OBJECT_TRAVERSAL_DEPTH)
      return;
    const isInternalField = defType.name.startsWith("_"), title = defType?.title ? sanitizeFieldValue(defType.title) : startCase(defType.name), fieldPath = prevFieldPath ? `${prevFieldPath}.${defType.name}` : defType.name, titlePath = prevTitlePath ? [...prevTitlePath, title] : [title], existingObject = objectTypes[defType.type], existingDocument = documentTypes[defType.type], inlineObject = isObjectDefinition(defType) ? defType : null, targetObject = existingDocument || existingObject || inlineObject;
    if (targetObject) {
      for (const field of targetObject.fields ?? [])
        addFieldDefinitionRecursive({
          acc,
          defType: field,
          depth: depth + 1,
          documentType,
          prevFieldPath: fieldPath,
          prevTitlePath: titlePath
        });
      return;
    }
    supportedFieldTypeSet.has(defType.type) && acc.push({
      documentTypes: documentType && !isInternalField ? [documentType] : [],
      fieldPath,
      filterName: resolveFilterName(defType),
      id: "",
      name: defType.name,
      titlePath,
      title,
      type: defType.type
    });
  }
  const fieldDefinitions = [];
  for (const documentType of Object.values(documentTypes)) {
    const documentFields = [];
    for (const documentField of documentType.fields ?? [])
      addFieldDefinitionRecursive({
        acc: documentFields,
        defType: documentField,
        documentType: documentType.name
      });
    fieldDefinitions.push(...documentFields.map(addFieldDefinitionId));
  }
  const consolidatedFieldDefinitionMap = /* @__PURE__ */ new Map();
  for (const fieldDefinitionWithId of fieldDefinitions) {
    const consolidated = consolidatedFieldDefinitionMap.get(fieldDefinitionWithId.id);
    if (consolidated) {
      consolidated.documentTypes.push(...fieldDefinitionWithId.documentTypes);
      continue;
    }
    consolidatedFieldDefinitionMap.set(fieldDefinitionWithId.id, fieldDefinitionWithId);
  }
  const consolidatedFieldDefinitions = Array.from(consolidatedFieldDefinitionMap.values());
  return consolidatedFieldDefinitions.sort(sortFieldDefinitions), consolidatedFieldDefinitions;
}
function addFieldDefinitionId(field) {
  return {
    ...field,
    id: generateFieldId(field)
  };
}
function isArrayOfPrimitives(schemaType) {
  return isArrayDefinition(schemaType) ? schemaType.of.every((item) => ["boolean", "number", "string"].includes(item.type)) && (schemaType.options?.list ? schemaType.options.list.length > 0 : !1) : !1;
}
function isArrayDefinition(schemaType) {
  return schemaType.type === "array";
}
function isDocumentObjectDefinition(schemaType) {
  return schemaType.type === "document";
}
function isObjectDefinition(schemaType) {
  return schemaType.type === "object";
}
function isStringDefinition(schemaType) {
  return schemaType.type === "string";
}
function isStringListDefinition(schemaType) {
  return isStringDefinition(schemaType) && schemaType.options?.list ? schemaType.options.list.length > 0 : !1;
}
function resolveFilterName(schemaType) {
  if (isStringListDefinition(schemaType))
    return "stringList";
  if (isArrayDefinition(schemaType)) {
    if (schemaType.of.some((item) => item.type === "reference"))
      return "arrayReferences";
    if (schemaType.of.find((item) => item.type === "block"))
      return "portableText";
    if (isArrayOfPrimitives(schemaType))
      return "arrayList";
  }
  return schemaType.type;
}
function sortFieldDefinitions(a, b) {
  return a.title.localeCompare(b.title) || a.titlePath.slice(0, -1).join("/").localeCompare(b.titlePath.slice(0, -1).join("/")) || a.fieldPath.localeCompare(b.fieldPath);
}
const RECENT_SEARCH_VERSION$1 = 3, STORED_SEARCHES_NAMESPACE = "studio.search.recent", defaultValue = {
  version: RECENT_SEARCH_VERSION$1,
  recentSearches: []
};
function useStoredSearch() {
  const $ = c(16), keyValueStore = useKeyValueStore(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0;
  $[0] !== client ? (t0 = client.config(), $[0] = client, $[1] = t0) : t0 = $[1];
  const {
    dataset
  } = t0, keyValueStoreKey = `${STORED_SEARCHES_NAMESPACE}.${dataset}`, [value, setValue] = useState(defaultValue);
  let t1;
  $[2] !== keyValueStore || $[3] !== keyValueStoreKey ? (t1 = keyValueStore.getKey(keyValueStoreKey), $[2] = keyValueStore, $[3] = keyValueStoreKey, $[4] = t1) : t1 = $[4];
  const settings = t1;
  let t2, t3;
  $[5] !== keyValueStore || $[6] !== keyValueStoreKey || $[7] !== settings ? (t2 = () => {
    const sub2 = settings.pipe(startWith(defaultValue), map((data) => data ? data?.version !== RECENT_SEARCH_VERSION$1 ? (keyValueStore.setKey(keyValueStoreKey, defaultValue), defaultValue) : data : defaultValue)).subscribe({
      next: setValue
    });
    return () => sub2?.unsubscribe();
  }, t3 = [settings, keyValueStore, keyValueStoreKey], $[5] = keyValueStore, $[6] = keyValueStoreKey, $[7] = settings, $[8] = t2, $[9] = t3) : (t2 = $[8], t3 = $[9]), useEffect(t2, t3);
  let t4;
  $[10] !== keyValueStore || $[11] !== keyValueStoreKey ? (t4 = (newValue) => {
    setValue(newValue), keyValueStore.setKey(keyValueStoreKey, newValue);
  }, $[10] = keyValueStore, $[11] = keyValueStoreKey, $[12] = t4) : t4 = $[12];
  const set2 = t4;
  let t5;
  return $[13] !== set2 || $[14] !== value ? (t5 = [value, set2], $[13] = set2, $[14] = value, $[15] = t5) : t5 = $[15], t5;
}
const MAX_RECENT_SEARCHES = 5, RECENT_SEARCH_VERSION = 3;
function useRecentSearchesStore() {
  const $ = c(18), [storedSearch, setStoredSearch] = useStoredSearch(), schema2 = useSchema(), {
    search: t0
  } = useSource(), {
    operators,
    filters
  } = t0;
  let t1;
  $[0] !== filters || $[1] !== schema2 ? (t1 = createFieldDefinitionDictionary(createFieldDefinitions(schema2, filters)), $[0] = filters, $[1] = schema2, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== filters ? (t2 = createFilterDefinitionDictionary(filters), $[3] = filters, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== operators ? (t3 = createOperatorDefinitionDictionary(operators), $[5] = operators, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t1 || $[8] !== t2 || $[9] !== t3 ? (t4 = {
    fieldDefinitions: t1,
    filterDefinitions: t2,
    operatorDefinitions: t3
  }, $[7] = t1, $[8] = t2, $[9] = t3, $[10] = t4) : t4 = $[10];
  const {
    fieldDefinitions,
    filterDefinitions: filterDefinitions2,
    operatorDefinitions: operatorDefinitions2
  } = t4;
  let t5;
  return $[11] !== fieldDefinitions || $[12] !== filterDefinitions2 || $[13] !== operatorDefinitions2 || $[14] !== schema2 || $[15] !== setStoredSearch || $[16] !== storedSearch ? (t5 = {
    addSearch: (searchTerm, searchFilters) => {
      const validStoredFilters = (searchFilters || []).map(_temp$1V).filter((filter_0) => validateFilter({
        fieldDefinitions,
        filter: filter_0,
        filterDefinitions: filterDefinitions2,
        operatorDefinitions: operatorDefinitions2
      })), newSearchItem = {
        created: (/* @__PURE__ */ new Date()).toISOString(),
        filters: validStoredFilters,
        terms: {
          query: searchTerm.query.trim(),
          typeNames: searchTerm.types.map(_temp2$M)
        }
      }, newRecent = {
        version: RECENT_SEARCH_VERSION,
        recentSearches: [newSearchItem, ...storedSearch.recentSearches.filter((r) => !isEqual$1(omit(r, "created"), omit(newSearchItem, "created")))].slice(0, MAX_RECENT_SEARCHES)
      };
      return setStoredSearch(newRecent), getRecentSearchTerms({
        fieldDefinitions,
        filterDefinitions: filterDefinitions2,
        operatorDefinitions: operatorDefinitions2,
        schema: schema2,
        storedSearch: newRecent,
        setStoredSearch
      });
    },
    getRecentSearches: () => getRecentSearchTerms({
      fieldDefinitions,
      filterDefinitions: filterDefinitions2,
      operatorDefinitions: operatorDefinitions2,
      schema: schema2,
      storedSearch,
      setStoredSearch
    }),
    removeSearch: () => {
      const newRecent_0 = {
        ...storedSearch,
        recentSearches: []
      };
      return setStoredSearch(newRecent_0), getRecentSearchTerms({
        fieldDefinitions,
        filterDefinitions: filterDefinitions2,
        operatorDefinitions: operatorDefinitions2,
        schema: schema2,
        storedSearch: newRecent_0,
        setStoredSearch
      });
    },
    removeSearchAtIndex: (index) => {
      if (index < 0 || index > storedSearch.recentSearches.length)
        return getRecentSearchTerms({
          fieldDefinitions,
          filterDefinitions: filterDefinitions2,
          operatorDefinitions: operatorDefinitions2,
          schema: schema2,
          storedSearch,
          setStoredSearch
        });
      const newRecent_1 = {
        ...storedSearch,
        recentSearches: [...storedSearch.recentSearches.slice(0, index), ...storedSearch.recentSearches.slice(index + 1)]
      };
      return setStoredSearch(newRecent_1), getRecentSearchTerms({
        fieldDefinitions,
        filterDefinitions: filterDefinitions2,
        operatorDefinitions: operatorDefinitions2,
        schema: schema2,
        storedSearch: newRecent_1,
        setStoredSearch
      });
    }
  }, $[11] = fieldDefinitions, $[12] = filterDefinitions2, $[13] = operatorDefinitions2, $[14] = schema2, $[15] = setStoredSearch, $[16] = storedSearch, $[17] = t5) : t5 = $[17], t5;
}
function _temp2$M(s) {
  return s.name;
}
function _temp$1V(filter2) {
  return {
    fieldId: filter2.fieldId,
    filterName: filter2.filterName,
    operatorType: filter2.operatorType,
    value: filter2.value
  };
}
function getRecentSearchTerms({
  schema: schema2,
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  operatorDefinitions: operatorDefinitions2,
  storedSearch,
  setStoredSearch
}) {
  return sanitizeStoredSearch({
    studioSchema: schema2,
    filterDefinitions: filterDefinitions2,
    fieldDefinitions,
    operatorDefinitions: operatorDefinitions2,
    storedSearch,
    setStoredSearch
  }).recentSearches.filter((r) => !!r.terms).map((r, index) => ({
    __recent: {
      index,
      timestamp: new Date(r.created).getTime()
    },
    filters: r.filters,
    query: r.terms.query,
    types: r.terms.typeNames.map((typeName) => schema2.get(typeName)).filter((s) => !!(s && s.jsonType === "object"))
  }));
}
function sanitizeStoredSearch({
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  operatorDefinitions: operatorDefinitions2,
  studioSchema,
  storedSearch,
  setStoredSearch
}) {
  const searchableTypeNames = getSearchableOmnisearchTypes(studioSchema).map((schema2) => schema2.name), filteredSearch = storedSearch.recentSearches.filter((recentSearch) => (
    // Has valid searchable types (not hidden by omnisearch)
    recentSearch.terms.typeNames.every((typeName) => searchableTypeNames.includes(typeName)) && recentSearch.filters.every((filter2) => validateFilter({
      fieldDefinitions,
      filter: filter2,
      filterDefinitions: filterDefinitions2,
      operatorDefinitions: operatorDefinitions2
    }))
  )), newStoredSearch = {
    version: RECENT_SEARCH_VERSION,
    recentSearches: filteredSearch
  };
  return newStoredSearch.recentSearches.length < storedSearch.recentSearches.length && setStoredSearch(newStoredSearch), newStoredSearch;
}
function Instructions() {
  const $ = c(3), {
    t
  } = useTranslation();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    ControlsIcon: _temp$1U
  }, $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] !== t ? (t1 = /* @__PURE__ */ jsx(Flex, { align: "center", direction: "column", gap: 4, paddingX: 4, paddingY: 5, children: /* @__PURE__ */ jsx(Inline, { space: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "search.instructions", components: t0 }) }) }) }), $[1] = t, $[2] = t1) : t1 = $[2], t1;
}
function _temp$1U() {
  return /* @__PURE__ */ jsx(ControlsIcon, { style: {
    padding: "0 0.25rem"
  } }, 0);
}
const RecentSearchClicked = defineEvent({
  name: "Recent Search Viewed",
  version: 1,
  description: "User clicked on a recent search item to reapply it"
});
function DocumentTypesPill(t0) {
  const $ = c(6), {
    availableCharacters,
    types
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== availableCharacters || $[1] !== t || $[2] !== types ? (t1 = documentTypesTruncated({
    availableCharacters,
    types,
    t
  }), $[0] = availableCharacters, $[1] = t, $[2] = types, $[3] = t1) : t1 = $[3];
  const title = t1;
  let t2;
  return $[4] !== title ? (t2 = /* @__PURE__ */ jsx(Card, { border: !0, padding: 2, radius: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: title }) }), $[4] = title, $[5] = t2) : t2 = $[5], t2;
}
const FilterPillCard = styled(Card).withConfig({
  displayName: "FilterPillCard",
  componentId: "sc-1a5zdw8-0"
})`cursor:default;`;
function FilterPill(t0) {
  const $ = c(2), {
    filter: filter2
  } = t0;
  let t1;
  return $[0] !== filter2 ? (t1 = /* @__PURE__ */ jsx(FilterPillCard, { border: !0, padding: 2, radius: 2, tone: "primary", children: /* @__PURE__ */ jsx(FilterLabel, { filter: filter2 }) }), $[0] = filter2, $[1] = t1) : t1 = $[1], t1;
}
const DEFAULT_COMBINED_TYPE_COUNT = 40, RecentSearchItemButton = styled(Button$1).withConfig({
  displayName: "RecentSearchItemButton",
  componentId: "sc-167yegb-0"
})`border-radius:${({
  theme
}) => rem(theme.sanity.radius[2])};cursor:default;width:100%;`, SearchItemPillsBox = styled(Box).withConfig({
  displayName: "SearchItemPillsBox",
  componentId: "sc-167yegb-1"
})`flex-shrink:3;`, SearchItemQueryFlex = styled(Flex).withConfig({
  displayName: "SearchItemQueryFlex",
  componentId: "sc-167yegb-2"
})`flex-shrink:2;`, CloseButtonDiv = styled.div.withConfig({
  displayName: "CloseButtonDiv",
  componentId: "sc-167yegb-3"
})`opacity:0.8;visibility:hidden;@media (hover:hover){${RecentSearchItemButton}:hover &{visibility:visible;}&:hover{opacity:0.4;}}`;
function RecentSearchItem(t0) {
  const $ = c(37);
  let index, rest, t1, value;
  $[0] !== t0 ? ({
    index,
    maxVisibleTypePillChars: t1,
    value,
    ...rest
  } = t0, $[0] = t0, $[1] = index, $[2] = rest, $[3] = t1, $[4] = value) : (index = $[1], rest = $[2], t1 = $[3], value = $[4]);
  const maxVisibleTypePillChars = t1 === void 0 ? DEFAULT_COMBINED_TYPE_COUNT : t1, {
    dispatch
  } = useSearchState(), recentSearchesStore = useRecentSearchesStore(), telemetry = useTelemetry(), availableCharacters = maxVisibleTypePillChars - value.query.length;
  let t2;
  $[5] !== dispatch || $[6] !== recentSearchesStore || $[7] !== telemetry || $[8] !== value ? (t2 = () => {
    dispatch({
      type: "TERMS_SET",
      filters: value?.filters,
      terms: value
    }), recentSearchesStore && recentSearchesStore?.addSearch(value, value?.filters), telemetry.log(RecentSearchClicked);
  }, $[5] = dispatch, $[6] = recentSearchesStore, $[7] = telemetry, $[8] = value, $[9] = t2) : t2 = $[9];
  const handleClick = t2;
  let t3;
  $[10] !== index || $[11] !== recentSearchesStore ? (t3 = (event) => {
    event.stopPropagation(), recentSearchesStore && recentSearchesStore?.removeSearchAtIndex(index);
  }, $[10] = index, $[11] = recentSearchesStore, $[12] = t3) : t3 = $[12];
  const handleDelete = t3;
  let t4;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsxs(Inline, { paddingY: 2, children: [
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ClockIcon, {}) }),
    /* @__PURE__ */ jsx(Text$1, { children: "\u200B" })
  ] }), $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== value.query ? (t5 = value.query && /* @__PURE__ */ jsx(SearchItemQueryFlex, { align: "center", paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", weight: "medium", children: value.query }) }), $[14] = value.query, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== availableCharacters || $[17] !== value.types ? (t6 = value.types.length > 0 && /* @__PURE__ */ jsx(SearchItemPillsBox, { children: /* @__PURE__ */ jsx(DocumentTypesPill, { availableCharacters, types: value.types }) }), $[16] = availableCharacters, $[17] = value.types, $[18] = t6) : t6 = $[18];
  let t7;
  $[19] !== value.filters ? (t7 = value?.filters?.map(_temp$1T), $[19] = value.filters, $[20] = t7) : t7 = $[20];
  let t8;
  $[21] !== t5 || $[22] !== t6 || $[23] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "stretch", flex: 1, gap: 2, justify: "flex-start", marginLeft: 3, wrap: "wrap", children: [
    t5,
    t6,
    t7
  ] }), $[21] = t5, $[22] = t6, $[23] = t7, $[24] = t8) : t8 = $[24];
  let t9;
  $[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = /* @__PURE__ */ jsx(Flex, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(CloseIcon, {}) }) }), $[25] = t9) : t9 = $[25];
  let t10;
  $[26] !== handleDelete ? (t10 = /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(CloseButtonDiv, { onClick: handleDelete, children: t9 }) }), $[26] = handleDelete, $[27] = t10) : t10 = $[27];
  let t11;
  $[28] !== t10 || $[29] !== t8 ? (t11 = /* @__PURE__ */ jsxs(Flex, { align: "stretch", children: [
    t4,
    t8,
    t10
  ] }), $[28] = t10, $[29] = t8, $[30] = t11) : t11 = $[30];
  let t12;
  $[31] !== handleClick || $[32] !== t11 ? (t12 = /* @__PURE__ */ jsx(RecentSearchItemButton, { mode: "bleed", onClick: handleClick, paddingLeft: 3, paddingRight: 1, paddingY: 1, tabIndex: -1, children: t11 }), $[31] = handleClick, $[32] = t11, $[33] = t12) : t12 = $[33];
  let t13;
  return $[34] !== rest || $[35] !== t12 ? (t13 = /* @__PURE__ */ jsx(Box, { ...rest, children: t12 }), $[34] = rest, $[35] = t12, $[36] = t13) : t13 = $[36], t13;
}
function _temp$1T(filter2, i) {
  return /* @__PURE__ */ jsx(FilterPill, { filter: filter2 }, i);
}
const VIRTUAL_LIST_RECENT_SEARCH_ITEM_HEIGHT = 36, MAX_COMBINED_TYPE_COUNT_SMALL = 20, MAX_COMBINED_TYPE_COUNT_LARGE = 40, RecentSearchesBox = styled(Card).withConfig({
  displayName: "RecentSearchesBox",
  componentId: "sc-on6v84-0"
})`overflow-x:hidden;overflow-y:auto;position:relative;`;
function RecentSearches(t0) {
  const $ = c(17), {
    inputElement
  } = t0, {
    state: t1
  } = useSearchState(), {
    filtersVisible,
    fullscreen
  } = t1, recentSearchesStore = useRecentSearchesStore();
  let t2;
  $[0] !== recentSearchesStore ? (t2 = recentSearchesStore?.getRecentSearches(), $[0] = recentSearchesStore, $[1] = t2) : t2 = $[1];
  const recentSearches = t2, commandListRef = useRef(null), {
    t
  } = useTranslation();
  let t3;
  $[2] !== recentSearchesStore ? (t3 = () => {
    recentSearchesStore && recentSearchesStore.removeSearch(), commandListRef?.current?.focusInputElement();
  }, $[2] = recentSearchesStore, $[3] = t3) : t3 = $[3];
  const handleClearRecentSearchesClick = t3, maxVisibleTypePillChars = useMediaIndex() < 2 ? MAX_COMBINED_TYPE_COUNT_SMALL : MAX_COMBINED_TYPE_COUNT_LARGE;
  let t4;
  $[4] !== maxVisibleTypePillChars ? (t4 = (item, t52) => {
    const {
      virtualIndex
    } = t52;
    return /* @__PURE__ */ jsx(RecentSearchItem, { index: virtualIndex, maxVisibleTypePillChars, paddingBottom: 1, value: item });
  }, $[4] = maxVisibleTypePillChars, $[5] = t4) : t4 = $[5];
  const renderItem2 = t4, hasRecentSearches = !!recentSearches.length, t5 = hasRecentSearches || !hasRecentSearches && !filtersVisible && fullscreen;
  let t6;
  $[6] !== filtersVisible || $[7] !== fullscreen || $[8] !== handleClearRecentSearchesClick || $[9] !== inputElement || $[10] !== recentSearches || $[11] !== renderItem2 || $[12] !== t ? (t6 = recentSearches.length > 0 ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(Box, { paddingBottom: 2, paddingTop: 4, paddingX: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("search.recent-searches-label") }) }),
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("search.recent-searches-aria-label"), inputElement, initialIndex: 0, itemHeight: VIRTUAL_LIST_RECENT_SEARCH_ITEM_HEIGHT, items: recentSearches, paddingX: 2, paddingY: 1, renderItem: renderItem2 }) }),
    /* @__PURE__ */ jsx(Box, { paddingBottom: 2, paddingTop: 1, paddingX: 2, children: /* @__PURE__ */ jsx(Button, { mode: "bleed", onClick: handleClearRecentSearchesClick, tone: "default", text: t("search.action.clear-recent-searches"), muted: !0 }) })
  ] }) : !filtersVisible && fullscreen && /* @__PURE__ */ jsx(Instructions, {}), $[6] = filtersVisible, $[7] = fullscreen, $[8] = handleClearRecentSearchesClick, $[9] = inputElement, $[10] = recentSearches, $[11] = renderItem2, $[12] = t, $[13] = t6) : t6 = $[13];
  let t7;
  return $[14] !== t5 || $[15] !== t6 ? (t7 = /* @__PURE__ */ jsx(RecentSearchesBox, { borderTop: t5, flex: 1, children: t6 }), $[14] = t5, $[15] = t6, $[16] = t7) : t7 = $[16], t7;
}
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, AnimatedSpinnerIcon = styled(SpinnerIcon).withConfig({
  displayName: "AnimatedSpinnerIcon",
  componentId: "sc-1bz7gqq-0"
})`animation:${rotate} 500ms linear infinite;`, FilterDiv = styled.div.withConfig({
  displayName: "FilterDiv",
  componentId: "sc-1bz7gqq-1"
})`line-height:0;position:relative;`, SearchHeader = forwardRef(function(t0, ref) {
  const $ = c(48), {
    ariaInputLabel,
    onClose
  } = t0, isMountedRef = useRef(!1), {
    t
  } = useTranslation(), {
    dispatch,
    state: t1
  } = useSearchState(), {
    filters,
    filtersVisible,
    fullscreen,
    result: t2,
    terms
  } = t1, {
    loading
  } = t2, {
    types,
    query
  } = terms;
  let t3;
  $[0] !== terms ? (t3 = hasSearchableTerms({
    terms
  }), $[0] = terms, $[1] = t3) : t3 = $[1];
  const hasValidTerms = t3;
  let t4;
  $[2] !== ariaInputLabel || $[3] !== hasValidTerms || $[4] !== t ? (t4 = t(ariaInputLabel || hasValidTerms ? "search.search-results-aria-label" : "search.recent-searches-aria-label"), $[2] = ariaInputLabel, $[3] = hasValidTerms, $[4] = t, $[5] = t4) : t4 = $[5];
  const ariaLabel = t4;
  let t5;
  $[6] !== dispatch || $[7] !== filtersVisible ? (t5 = () => dispatch({
    type: "FILTERS_VISIBLE_SET",
    visible: !filtersVisible
  }), $[6] = dispatch, $[7] = filtersVisible, $[8] = t5) : t5 = $[8];
  const handleFiltersToggle = t5;
  let t6;
  $[9] !== dispatch ? (t6 = (e) => dispatch({
    type: "TERMS_QUERY_SET",
    query: e.currentTarget.value
  }), $[9] = dispatch, $[10] = t6) : t6 = $[10];
  const handleQueryChange = t6;
  let t7;
  $[11] !== dispatch ? (t7 = () => {
    dispatch({
      type: "TERMS_QUERY_SET",
      query: ""
    });
  }, $[11] = dispatch, $[12] = t7) : t7 = $[12];
  const handleQueryClear = t7;
  let t8, t9;
  $[13] !== dispatch || $[14] !== fullscreen ? (t8 = () => {
    fullscreen || dispatch({
      type: "FILTERS_VISIBLE_SET",
      visible: !0
    });
  }, t9 = [dispatch, fullscreen], $[13] = dispatch, $[14] = fullscreen, $[15] = t8, $[16] = t9) : (t8 = $[15], t9 = $[16]), useEffect(t8, t9);
  let t10, t11;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    isMountedRef.current = !0;
  }, t11 = [], $[17] = t10, $[18] = t11) : (t10 = $[17], t11 = $[18]), useEffect(t10, t11);
  const notificationBadgeVisible = filters.length > 0 || types.length > 0, t12 = fullscreen ? 2 : 1, t13 = fullscreen ? 2 : 1;
  let t14;
  $[19] !== fullscreen || $[20] !== onClose || $[21] !== t ? (t14 = fullscreen && /* @__PURE__ */ jsx(Button, { "aria-label": t("search.action.close-search-aria-label"), icon: ArrowLeftIcon, mode: "bleed", onClick: onClose, size: "large", tooltipProps: {
    content: t("search.action.close-search-aria-label")
  } }), $[19] = fullscreen, $[20] = onClose, $[21] = t, $[22] = t14) : t14 = $[22];
  const t15 = !!query;
  let t16;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = [2, 2, 1], $[23] = t16) : t16 = $[23];
  const t17 = loading ? AnimatedSpinnerIcon : SearchIcon;
  let t18;
  $[24] !== t ? (t18 = t("search.placeholder"), $[24] = t, $[25] = t18) : t18 = $[25];
  let t19;
  $[26] !== ariaLabel || $[27] !== fullscreen || $[28] !== handleQueryChange || $[29] !== handleQueryClear || $[30] !== query || $[31] !== ref || $[32] !== t15 || $[33] !== t17 || $[34] !== t18 ? (t19 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(CustomTextInput, { __unstable_disableFocusRing: !0, $background: fullscreen, $smallClearButton: fullscreen, "aria-label": ariaLabel, autoComplete: "off", border: !1, clearButton: t15, fontSize: t16, icon: t17, onChange: handleQueryChange, onClear: handleQueryClear, placeholder: t18, radius: 2, ref, spellCheck: !1, value: query }) }), $[26] = ariaLabel, $[27] = fullscreen, $[28] = handleQueryChange, $[29] = handleQueryClear, $[30] = query, $[31] = ref, $[32] = t15, $[33] = t17, $[34] = t18, $[35] = t19) : t19 = $[35];
  let t20;
  $[36] !== filtersVisible || $[37] !== fullscreen || $[38] !== handleFiltersToggle || $[39] !== notificationBadgeVisible || $[40] !== t ? (t20 = fullscreen && /* @__PURE__ */ jsx(FilterDiv, { children: /* @__PURE__ */ jsx(StatusButton, { "aria-expanded": filtersVisible, "aria-label": t("search.action.toggle-filters-aria-label", {
    context: filtersVisible ? "hide" : "show"
  }), icon: ControlsIcon, mode: "bleed", onClick: handleFiltersToggle, selected: filtersVisible, size: "large", tone: notificationBadgeVisible ? "primary" : void 0, tooltipProps: {
    content: t("search.action.toggle-filters-label", {
      context: filtersVisible ? "hide" : "show"
    })
  } }) }), $[36] = filtersVisible, $[37] = fullscreen, $[38] = handleFiltersToggle, $[39] = notificationBadgeVisible, $[40] = t, $[41] = t20) : t20 = $[41];
  let t21;
  return $[42] !== t12 || $[43] !== t13 || $[44] !== t14 || $[45] !== t19 || $[46] !== t20 ? (t21 = /* @__PURE__ */ jsx(Card, { flex: "none", children: /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: t12, padding: t13, children: [
    t14,
    t19,
    t20
  ] }) }), $[42] = t12, $[43] = t13, $[44] = t14, $[45] = t19, $[46] = t20, $[47] = t21) : t21 = $[47], t21;
});
function NoResults() {
  const $ = c(11), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("search.no-results-title"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, weight: "medium", children: t0 }), $[2] = t0, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t ? (t2 = t("search.no-results-help-description"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: t2 }), $[6] = t2, $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== t1 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(Container$3, { width: 0, children: /* @__PURE__ */ jsxs(Stack, { "aria-live": "assertive", space: 4, paddingX: 4, paddingY: 5, children: [
    t1,
    t3
  ] }) }), $[8] = t1, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
}
function SearchError() {
  const $ = c(12), {
    t
  } = useTranslation();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Box, { marginBottom: 1, children: /* @__PURE__ */ jsx(TextWithTone, { tone: "critical", children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== t ? (t1 = t("search.error.unspecified-error-title"), $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(TextWithTone, { size: 2, tone: "critical", weight: "medium", children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("search.error.unspecified-error-help-description"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "critical", children: t3 }), $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  return $[9] !== t2 || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "center", "aria-live": "assertive", direction: "column", flex: 1, gap: 3, marginY: 2, padding: 4, children: [
    t0,
    t2,
    t4
  ] }), $[9] = t2, $[10] = t4, $[11] = t5) : t5 = $[11], t5;
}
const getOrderings = ({
  searchStrategy
}) => ({
  createdAsc: {
    ignoreScore: !0,
    sort: {
      direction: "asc",
      field: "_createdAt"
    },
    titleKey: "search.ordering.created-ascending-label"
  },
  createdDesc: {
    ignoreScore: !0,
    sort: {
      direction: "desc",
      field: "_createdAt"
    },
    titleKey: "search.ordering.created-descending-label"
  },
  relevance: {
    customMeasurementLabel: "relevance",
    ...searchStrategy === "groqLegacy" ? {
      sort: {
        direction: "desc",
        field: "_updatedAt"
      }
    } : {},
    titleKey: "search.ordering.best-match-label"
  },
  updatedAsc: {
    ignoreScore: !0,
    sort: {
      direction: "asc",
      field: "_updatedAt"
    },
    titleKey: "search.ordering.updated-ascending-label"
  },
  updatedDesc: {
    ignoreScore: !0,
    sort: {
      direction: "desc",
      field: "_updatedAt"
    },
    titleKey: "search.ordering.updated-descending-label"
  }
}), SortMenuContentFlex = styled(Flex).withConfig({
  displayName: "SortMenuContentFlex",
  componentId: "sc-11mc67b-0"
})`box-sizing:border-box;`;
function isSearchDivider(item) {
  return item.type === "divider";
}
function CustomMenuItem$1(t0) {
  const $ = c(13), {
    ordering
  } = t0, {
    t
  } = useTranslation(), {
    dispatch,
    state: t1
  } = useSearchState(), {
    ordering: currentOrdering
  } = t1;
  let t2;
  $[0] !== dispatch || $[1] !== ordering ? (t2 = () => {
    dispatch({
      ordering,
      type: "ORDERING_SET"
    });
  }, $[0] = dispatch, $[1] = ordering, $[2] = t2) : t2 = $[2];
  const handleClick = t2;
  let t3;
  $[3] !== currentOrdering || $[4] !== ordering ? (t3 = isEqual$1(currentOrdering, ordering), $[3] = currentOrdering, $[4] = ordering, $[5] = t3) : t3 = $[5];
  const isSelected = t3;
  let t4;
  $[6] !== ordering.titleKey || $[7] !== t ? (t4 = t(ordering.titleKey), $[6] = ordering.titleKey, $[7] = t, $[8] = t4) : t4 = $[8];
  let t5;
  return $[9] !== handleClick || $[10] !== isSelected || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(MenuItem, { onClick: handleClick, pressed: isSelected, tone: "default", text: t4 }), $[9] = handleClick, $[10] = isSelected, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
}
function SortMenu() {
  const $ = c(48), {
    t
  } = useTranslation(), {
    strategy: searchStrategy
  } = useWorkspace().search, {
    state: t0
  } = useSearchState(), {
    ordering
  } = t0, menuButtonId = useId();
  let t1;
  $[0] !== searchStrategy ? (t1 = getOrderings({
    searchStrategy
  }), $[0] = searchStrategy, $[1] = t1) : t1 = $[1];
  const orderings = t1;
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    type: "divider"
  }, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    type: "divider"
  }, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== orderings.createdAsc || $[5] !== orderings.createdDesc || $[6] !== orderings.relevance || $[7] !== orderings.updatedAsc || $[8] !== orderings.updatedDesc ? (t4 = [orderings.relevance, t2, orderings.createdAsc, orderings.createdDesc, t3, orderings.updatedAsc, orderings.updatedDesc], $[4] = orderings.createdAsc, $[5] = orderings.createdDesc, $[6] = orderings.relevance, $[7] = orderings.updatedAsc, $[8] = orderings.updatedDesc, $[9] = t4) : t4 = $[9];
  const menuOrderings = t4;
  let T0, T1, T2, T3, t10, t11, t12, t5, t6, t7, t8, t9;
  if ($[10] !== menuOrderings || $[11] !== ordering || $[12] !== t) {
    t12 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    bb0: {
      const currentMenuItem = menuOrderings.find((item) => isEqual$1(ordering, item) && !isSearchDivider(item));
      if (!currentMenuItem) {
        t12 = null;
        break bb0;
      }
      T3 = Card, t11 = !0, T2 = SortMenuContentFlex, t8 = "center", t9 = 1, t10 = 2, T1 = MenuButton, T0 = Button, t5 = "bleed", t6 = SortIcon, t7 = t(currentMenuItem.titleKey);
    }
    $[10] = menuOrderings, $[11] = ordering, $[12] = t, $[13] = T0, $[14] = T1, $[15] = T2, $[16] = T3, $[17] = t10, $[18] = t11, $[19] = t12, $[20] = t5, $[21] = t6, $[22] = t7, $[23] = t8, $[24] = t9;
  } else
    T0 = $[13], T1 = $[14], T2 = $[15], T3 = $[16], t10 = $[17], t11 = $[18], t12 = $[19], t5 = $[20], t6 = $[21], t7 = $[22], t8 = $[23], t9 = $[24];
  if (t12 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return t12;
  let t13;
  $[25] !== T0 || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 ? (t13 = /* @__PURE__ */ jsx(T0, { mode: t5, icon: t6, text: t7 }), $[25] = T0, $[26] = t5, $[27] = t6, $[28] = t7, $[29] = t13) : t13 = $[29];
  const t14 = menuButtonId || "";
  let t15;
  $[30] !== menuOrderings ? (t15 = /* @__PURE__ */ jsx(Menu, { children: menuOrderings.map(_temp$1S) }), $[30] = menuOrderings, $[31] = t15) : t15 = $[31];
  let t16;
  $[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = {
    portal: !0,
    radius: 2
  }, $[32] = t16) : t16 = $[32];
  let t17;
  $[33] !== T1 || $[34] !== t13 || $[35] !== t14 || $[36] !== t15 ? (t17 = /* @__PURE__ */ jsx(T1, { button: t13, id: t14, menu: t15, placement: "bottom-start", popover: t16 }), $[33] = T1, $[34] = t13, $[35] = t14, $[36] = t15, $[37] = t17) : t17 = $[37];
  let t18;
  $[38] !== T2 || $[39] !== t10 || $[40] !== t17 || $[41] !== t8 || $[42] !== t9 ? (t18 = /* @__PURE__ */ jsx(T2, { align: t8, flex: t9, padding: t10, children: t17 }), $[38] = T2, $[39] = t10, $[40] = t17, $[41] = t8, $[42] = t9, $[43] = t18) : t18 = $[43];
  let t19;
  return $[44] !== T3 || $[45] !== t11 || $[46] !== t18 ? (t19 = /* @__PURE__ */ jsx(T3, { borderBottom: t11, children: t18 }), $[44] = T3, $[45] = t11, $[46] = t18, $[47] = t19) : t19 = $[47], t19;
}
function _temp$1S(item_0, index) {
  return isSearchDivider(item_0) ? /* @__PURE__ */ jsx(MenuDivider, {}, index) : /* @__PURE__ */ jsx(CustomMenuItem$1, { ordering: item_0 }, index);
}
const DebugScoreCard = styled(Card).withConfig({
  displayName: "DebugScoreCard",
  componentId: "sc-1u006xj-0"
})`cursor:help;left:0;position:absolute;top:0;`;
function DebugOverlay(t0) {
  const $ = c(18), {
    data
  } = t0, {
    score
  } = data;
  let tone = "default";
  score <= 0.1 ? tone = "critical" : score >= 0.5 && (tone = "primary");
  let T0, T1, t1, t2;
  if ($[0] !== data.stories) {
    const matchingStories = data.stories.filter(_temp$1R);
    T1 = Tooltip, T0 = Stack, t1 = 2, t2 = matchingStories.length ? /* @__PURE__ */ jsx(Fragment$1, { children: matchingStories.map(_temp2$L) }) : /* @__PURE__ */ jsx(Code, { size: 0, children: "No matches" }), $[0] = data.stories, $[1] = T0, $[2] = T1, $[3] = t1, $[4] = t2;
  } else
    T0 = $[1], T1 = $[2], t1 = $[3], t2 = $[4];
  let t3;
  $[5] !== T0 || $[6] !== t1 || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsx(T0, { space: t1, children: t2 }), $[5] = T0, $[6] = t1, $[7] = t2, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== score ? (t4 = /* @__PURE__ */ jsxs(Code, { size: 0, children: [
    "score: ",
    score
  ] }), $[9] = score, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== t4 || $[12] !== tone ? (t5 = /* @__PURE__ */ jsx(DebugScoreCard, { padding: 1, shadow: 1, tone, children: t4 }), $[11] = t4, $[12] = tone, $[13] = t5) : t5 = $[13];
  let t6;
  return $[14] !== T1 || $[15] !== t3 || $[16] !== t5 ? (t6 = /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(T1, { content: t3, placement: "bottom-start", portal: !0, children: t5 }) }), $[14] = T1, $[15] = t3, $[16] = t5, $[17] = t6) : t6 = $[17], t6;
}
function _temp2$L(story_0) {
  return /* @__PURE__ */ jsxs(Inline, { space: 3, children: [
    /* @__PURE__ */ jsx(Code, { size: 0, weight: "medium", children: story_0.path }),
    /* @__PURE__ */ jsx(Code, { size: 0, children: story_0.why })
  ] }, story_0.path);
}
function _temp$1R(story) {
  return story.score > 0;
}
const SearchResultItemPreviewBox = styled(Box).withConfig({
  displayName: "SearchResultItemPreviewBox",
  componentId: "sc-1yg22aa-0"
})`@supports (-webkit-overflow-scrolling:touch){* [data-ui='Box']{background-attachment:scroll;}}`;
function SearchResultItemPreview(t0) {
  const $ = c(37), {
    documentId,
    documentType,
    layout,
    presence,
    schemaType,
    showBadge: t1,
    perspective
  } = t0, showBadge = t1 === void 0 ? !0 : t1, documentPreviewStore = useDocumentPreviewStore();
  let t2;
  $[0] !== documentId || $[1] !== documentPreviewStore || $[2] !== perspective || $[3] !== schemaType ? (t2 = getPreviewStateObservable$1(documentPreviewStore, schemaType, documentId, perspective), $[0] = documentId, $[1] = documentPreviewStore, $[2] = perspective, $[3] = schemaType, $[4] = t2) : t2 = $[4];
  const observable = t2;
  let t3;
  $[5] !== documentId || $[6] !== documentType ? (t3 = {
    _id: documentId,
    _type: documentType
  }, $[5] = documentId, $[6] = documentType, $[7] = t3) : t3 = $[7];
  const documentStub = t3;
  let t4;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    snapshot: null,
    isLoading: !0,
    original: null
  }, $[8] = t4) : t4 = $[8];
  const {
    isLoading,
    snapshot: snapshot2,
    original
  } = useObservable(observable, t4), versionsInfo = useDocumentVersionInfo(documentId);
  let t5;
  bb0: {
    if (isLoading) {
      t5 = null;
      break bb0;
    }
    let t62;
    $[9] !== presence ? (t62 = presence && presence.length > 0 && /* @__PURE__ */ jsx(DocumentPreviewPresence, { presence }), $[9] = presence, $[10] = t62) : t62 = $[10];
    let t72;
    $[11] !== schemaType.title || $[12] !== showBadge ? (t72 = showBadge && /* @__PURE__ */ jsx(Badge, { children: schemaType.title }), $[11] = schemaType.title, $[12] = showBadge, $[13] = t72) : t72 = $[13];
    let t82;
    $[14] !== versionsInfo.draft || $[15] !== versionsInfo.published || $[16] !== versionsInfo.versions ? (t82 = /* @__PURE__ */ jsx(DocumentStatusIndicator, { draft: versionsInfo.draft, published: versionsInfo.published, versions: versionsInfo.versions }), $[14] = versionsInfo.draft, $[15] = versionsInfo.published, $[16] = versionsInfo.versions, $[17] = t82) : t82 = $[17];
    let t92;
    $[18] !== t62 || $[19] !== t72 || $[20] !== t82 ? (t92 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
      t62,
      t72,
      t82
    ] }), $[18] = t62, $[19] = t72, $[20] = t82, $[21] = t92) : t92 = $[21], t5 = t92;
  }
  const status = t5;
  let t6;
  $[22] !== versionsInfo.draft || $[23] !== versionsInfo.published || $[24] !== versionsInfo.versions ? (t6 = /* @__PURE__ */ jsx(DocumentStatus, { draft: versionsInfo.draft, published: versionsInfo.published, versions: versionsInfo.versions }), $[22] = versionsInfo.draft, $[23] = versionsInfo.published, $[24] = versionsInfo.versions, $[25] = t6) : t6 = $[25];
  const tooltip = t6;
  let t7;
  $[26] !== documentStub || $[27] !== original || $[28] !== snapshot2 ? (t7 = getPreviewValueWithFallback({
    snapshot: snapshot2,
    original,
    fallback: documentStub
  }), $[26] = documentStub, $[27] = original, $[28] = snapshot2, $[29] = t7) : t7 = $[29];
  const t8 = isLoading ?? !0, t9 = layout || "default";
  let t10;
  return $[30] !== schemaType.icon || $[31] !== status || $[32] !== t7 || $[33] !== t8 || $[34] !== t9 || $[35] !== tooltip ? (t10 = /* @__PURE__ */ jsx(SearchResultItemPreviewBox, { children: /* @__PURE__ */ jsx(SanityDefaultPreview, { ...t7, isPlaceholder: t8, layout: t9, icon: schemaType.icon, status, tooltip }) }), $[30] = schemaType.icon, $[31] = status, $[32] = t7, $[33] = t8, $[34] = t9, $[35] = tooltip, $[36] = t10) : t10 = $[36], t10;
}
function SearchResultItem(t0) {
  const $ = c(68);
  let disableIntentLink, documentId, documentType, layout, onClick2, onItemSelect, previewPerspective, rest;
  $[0] !== t0 ? ({
    disableIntentLink,
    documentId,
    documentType,
    layout,
    onClick: onClick2,
    onItemSelect,
    previewPerspective,
    ...rest
  } = t0, $[0] = t0, $[1] = disableIntentLink, $[2] = documentId, $[3] = documentType, $[4] = layout, $[5] = onClick2, $[6] = onItemSelect, $[7] = previewPerspective, $[8] = rest) : (disableIntentLink = $[1], documentId = $[2], documentType = $[3], layout = $[4], onClick2 = $[5], onItemSelect = $[6], previewPerspective = $[7], rest = $[8]);
  const schema2 = useSchema();
  let t1;
  $[9] !== documentType || $[10] !== schema2 ? (t1 = schema2.get(documentType), $[9] = documentType, $[10] = schema2, $[11] = t1) : t1 = $[11];
  const type = t1, documentPresence = useDocumentPresence(documentId);
  let t2;
  $[12] !== documentId ? (t2 = getPublishedId(documentId), $[12] = documentId, $[13] = t2) : t2 = $[13];
  const t3 = type?.name;
  let t4;
  $[14] !== t2 || $[15] !== t3 ? (t4 = {
    id: t2,
    type: t3
  }, $[14] = t2, $[15] = t3, $[16] = t4) : t4 = $[16];
  const params = t4;
  let t5;
  $[17] !== params ? (t5 = {
    intent: "edit",
    params
  }, $[17] = params, $[18] = t5) : t5 = $[18];
  const {
    onClick: onIntentClick,
    href
  } = useIntentLink(t5), {
    state
  } = useSearchState(), {
    t
  } = useTranslation(), grantsStore = useGrantsStore(), [createPermission, setCreatePermission] = useState(null), hasCreatePermission = createPermission?.granted;
  let t6, t7;
  $[19] !== documentId || $[20] !== documentType || $[21] !== grantsStore || $[22] !== state.canDisableAction ? (t6 = () => {
    state.canDisableAction && grantsStore.checkDocumentPermission("create", {
      _id: documentId,
      _type: documentType
    }).subscribe(setCreatePermission);
  }, t7 = [documentId, documentType, grantsStore, state.canDisableAction], $[19] = documentId, $[20] = documentType, $[21] = grantsStore, $[22] = state.canDisableAction, $[23] = t6, $[24] = t7) : (t6 = $[23], t7 = $[24]), useEffect(t6, t7);
  let t8;
  $[25] !== documentId || $[26] !== state.disabledDocumentIds ? (t8 = state.disabledDocumentIds?.some((id2) => id2.includes(getPublishedId(documentId))), $[25] = documentId, $[26] = state.disabledDocumentIds, $[27] = t8) : t8 = $[27];
  const existsInRelease = t8, disabledAction = !hasCreatePermission && state.canDisableAction || existsInRelease;
  let t9;
  $[28] !== documentId || $[29] !== documentType ? (t9 = {
    _id: documentId,
    _type: documentType
  }, $[28] = documentId, $[29] = documentType, $[30] = t9) : t9 = $[30];
  const documentStub = t9;
  let t10;
  $[31] !== documentStub || $[32] !== type ? (t10 = {
    enabled: !0,
    schemaType: type,
    value: documentStub
  }, $[31] = documentStub, $[32] = type, $[33] = t10) : t10 = $[33];
  const preview = useValuePreview(t10);
  let t11;
  $[34] !== disableIntentLink || $[35] !== documentId || $[36] !== documentType || $[37] !== onClick2 || $[38] !== onIntentClick || $[39] !== onItemSelect || $[40] !== preview ? (t11 = (e) => {
    onItemSelect?.({
      _id: documentId,
      _type: documentType,
      title: preview.value?.title
    }), disableIntentLink || onIntentClick(e), onClick2?.(e);
  }, $[34] = disableIntentLink, $[35] = documentId, $[36] = documentType, $[37] = onClick2, $[38] = onIntentClick, $[39] = onItemSelect, $[40] = preview, $[41] = t11) : t11 = $[41];
  const handleClick = t11;
  if (!type)
    return null;
  const t12 = disabledAction ? void 0 : "a", t13 = disabledAction || disableIntentLink ? void 0 : href, t14 = disabledAction ? "none" : void 0, t15 = disabledAction ? 0.5 : 1;
  let t16;
  $[42] !== t14 || $[43] !== t15 ? (t16 = {
    pointerEvents: t14,
    opacity: t15
  }, $[42] = t14, $[43] = t15, $[44] = t16) : t16 = $[44];
  let t17;
  $[45] !== documentId || $[46] !== documentPresence || $[47] !== documentType || $[48] !== layout || $[49] !== previewPerspective || $[50] !== type ? (t17 = /* @__PURE__ */ jsx(SearchResultItemPreview, { documentId, documentType, layout, perspective: previewPerspective, presence: documentPresence, schemaType: type }), $[45] = documentId, $[46] = documentPresence, $[47] = documentType, $[48] = layout, $[49] = previewPerspective, $[50] = type, $[51] = t17) : t17 = $[51];
  let t18;
  $[52] !== handleClick || $[53] !== t12 || $[54] !== t13 || $[55] !== t16 || $[56] !== t17 ? (t18 = /* @__PURE__ */ jsx(PreviewCard, { as: t12, "data-as": "a", flex: 1, href: t13, onClick: handleClick, radius: 2, tabIndex: -1, style: t16, children: t17 }), $[52] = handleClick, $[53] = t12, $[54] = t13, $[55] = t16, $[56] = t17, $[57] = t18) : t18 = $[57];
  let t19;
  $[58] !== rest || $[59] !== t18 ? (t19 = /* @__PURE__ */ jsx(Box, { ...rest, children: t18 }), $[58] = rest, $[59] = t18, $[60] = t19) : t19 = $[60];
  const content = t19;
  let t20;
  $[61] !== existsInRelease || $[62] !== t ? (t20 = t(existsInRelease ? "release.action.already-exists-in-release" : "release.action.permission.error"), $[61] = existsInRelease, $[62] = t, $[63] = t20) : t20 = $[63];
  const tooltipContent = t20;
  let t21;
  return $[64] !== content || $[65] !== disabledAction || $[66] !== tooltipContent ? (t21 = disabledAction ? /* @__PURE__ */ jsx(Tooltip, { content: tooltipContent, placement: "top", children: content }) : content, $[64] = content, $[65] = disabledAction, $[66] = tooltipContent, $[67] = t21) : t21 = $[67], t21;
}
const VIRTUAL_LIST_SEARCH_RESULT_ITEM_HEIGHT = 57, VIRTUAL_LIST_OVERSCAN = 4, SearchResultsInnerFlex = styled(Flex).withConfig({
  displayName: "SearchResultsInnerFlex",
  componentId: "sc-i32997-0"
})`opacity:${({
  $loadingFirstPage
}) => $loadingFirstPage ? 0.5 : 1};overflow-x:hidden;overflow-y:auto;position:relative;transition:300ms opacity;width:100%;`;
function SearchResults(t0) {
  const $ = c(36), {
    disableIntentLink,
    inputElement,
    onItemSelect,
    previewPerspective
  } = t0, {
    dispatch,
    onClose,
    setSearchCommandList,
    state: t1
  } = useSearchState(), {
    debug: debug2,
    filters,
    fullscreen,
    lastActiveIndex,
    result,
    terms,
    cursor
  } = t1, {
    t
  } = useTranslation(), recentSearchesStore = useRecentSearchesStore(), hasSearchResults = !!result.hits.length, hasNoSearchResults = !result.hits.length && result.loaded, hasError = result.error;
  let t2;
  $[0] !== filters || $[1] !== onClose || $[2] !== recentSearchesStore || $[3] !== terms ? (t2 = (e) => {
    recentSearchesStore && recentSearchesStore.addSearch(terms, filters), !e.metaKey && !e.ctrlKey && onClose?.();
  }, $[0] = filters, $[1] = onClose, $[2] = recentSearchesStore, $[3] = terms, $[4] = t2) : t2 = $[4];
  const handleSearchResultClick = t2;
  let t3;
  $[5] !== dispatch ? (t3 = () => {
    dispatch({
      type: "PAGE_INCREMENT"
    });
  }, $[5] = dispatch, $[6] = t3) : t3 = $[6];
  const handleEndReached = t3;
  let t4;
  $[7] !== debug2 || $[8] !== disableIntentLink || $[9] !== handleSearchResultClick || $[10] !== onItemSelect || $[11] !== previewPerspective ? (t4 = (item) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(SearchResultItem, { disableIntentLink, documentId: item.hit._id || "", documentType: item.hit._type, onClick: handleSearchResultClick, onItemSelect, previewPerspective, paddingY: 1 }),
    debug2 && /* @__PURE__ */ jsx(DebugOverlay, { data: item })
  ] }), $[7] = debug2, $[8] = disableIntentLink, $[9] = handleSearchResultClick, $[10] = onItemSelect, $[11] = previewPerspective, $[12] = t4) : t4 = $[12];
  const renderItem2 = t4, t5 = fullscreen || !!(hasError || hasSearchResults || hasNoSearchResults);
  let t6;
  $[13] !== hasSearchResults ? (t6 = hasSearchResults && /* @__PURE__ */ jsx(SortMenu, {}), $[13] = hasSearchResults, $[14] = t6) : t6 = $[14];
  const t7 = result.loading && cursor === null;
  let t8;
  $[15] !== handleEndReached || $[16] !== hasError || $[17] !== hasNoSearchResults || $[18] !== hasSearchResults || $[19] !== inputElement || $[20] !== lastActiveIndex || $[21] !== renderItem2 || $[22] !== result.hits || $[23] !== setSearchCommandList || $[24] !== t ? (t8 = hasError ? /* @__PURE__ */ jsx(SearchError, {}) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    hasSearchResults && /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("search.search-results-label"), "data-testid": "search-results", fixedHeight: !0, initialIndex: lastActiveIndex, inputElement, itemHeight: VIRTUAL_LIST_SEARCH_RESULT_ITEM_HEIGHT, items: result.hits, overscan: VIRTUAL_LIST_OVERSCAN, onEndReached: handleEndReached, paddingX: 2, paddingY: 1, ref: setSearchCommandList, renderItem: renderItem2 }),
    hasNoSearchResults && /* @__PURE__ */ jsx(NoResults, {})
  ] }), $[15] = handleEndReached, $[16] = hasError, $[17] = hasNoSearchResults, $[18] = hasSearchResults, $[19] = inputElement, $[20] = lastActiveIndex, $[21] = renderItem2, $[22] = result.hits, $[23] = setSearchCommandList, $[24] = t, $[25] = t8) : t8 = $[25];
  let t9;
  $[26] !== result.loading || $[27] !== t7 || $[28] !== t8 ? (t9 = /* @__PURE__ */ jsx(SearchResultsInnerFlex, { $loadingFirstPage: t7, "aria-busy": result.loading, flex: 1, children: t8 }), $[26] = result.loading, $[27] = t7, $[28] = t8, $[29] = t9) : t9 = $[29];
  let t10;
  $[30] !== t6 || $[31] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { direction: "column", height: "fill", children: [
    t6,
    t9
  ] }), $[30] = t6, $[31] = t9, $[32] = t10) : t10 = $[32];
  let t11;
  return $[33] !== t10 || $[34] !== t5 ? (t11 = /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(Card, { borderTop: t5, flex: 1, children: t10 }) }), $[33] = t10, $[34] = t5, $[35] = t11) : t11 = $[35], t11;
}
const ANIMATION_TRANSITION$1 = {
  duration: 0.4,
  type: "spring"
}, CARD_VARIANTS = {
  open: {
    opacity: 1,
    scale: 1,
    x: "-50%"
  },
  closed: {
    opacity: 0,
    scale: 0.99,
    x: "-50%"
  }
}, OVERLAY_VARIANTS = {
  open: {
    opacity: 1
  },
  closed: {
    opacity: 0
  }
}, Y_POSITION = 12, MotionOverlay = styled(motion.create(Card)).withConfig({
  displayName: "MotionOverlay",
  componentId: "sc-4oou0a-0"
})`background-color:var(--card-backdrop-color);bottom:0;left:0;position:absolute;right:0;top:0;`, SearchMotionCard = styled(motion.create(Card)).withConfig({
  displayName: "SearchMotionCard",
  componentId: "sc-4oou0a-1"
})`display:flex !important;flex-direction:column;left:50%;max-height:min( calc(100vh - ${Y_POSITION}vh - ${POPOVER_INPUT_PADDING}px),${POPOVER_MAX_HEIGHT}px );position:absolute;top:${Y_POSITION}vh;width:min(calc(100vw - ${POPOVER_INPUT_PADDING * 2}px),${POPOVER_MAX_WIDTH}px);`;
function SearchPopover(t0) {
  const $ = c(22), {
    disableFocusLock,
    disableIntentLink,
    onClose,
    onItemSelect,
    onOpen,
    previewPerspective,
    open
  } = t0, [inputElement, setInputElement] = useState(null), popoverElement = useRef(null), {
    isTopLayer,
    zIndex
  } = useLayer(), {
    onClose: onSearchClose,
    state: t1
  } = useSearchState(), {
    filtersVisible,
    terms
  } = t1;
  let t2;
  $[0] !== terms ? (t2 = hasSearchableTerms({
    terms
  }), $[0] = terms, $[1] = t2) : t2 = $[1];
  const hasValidTerms = t2;
  let t3;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => [popoverElement.current], $[2] = t3) : t3 = $[2], useClickOutsideEvent(isTopLayer && open && !!onSearchClose && onSearchClose, t3);
  let t4;
  $[3] !== disableFocusLock || $[4] !== disableIntentLink || $[5] !== filtersVisible || $[6] !== hasValidTerms || $[7] !== inputElement || $[8] !== onClose || $[9] !== onItemSelect || $[10] !== open || $[11] !== previewPerspective || $[12] !== zIndex ? (t4 = open && /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsxs(FocusLock, { autoFocus: !supportsTouch, disabled: disableFocusLock, returnFocus: !0, children: [
    /* @__PURE__ */ jsx(MotionOverlay, { animate: "open", exit: "closed", initial: "closed", style: {
      zIndex
    }, transition: ANIMATION_TRANSITION$1, variants: OVERLAY_VARIANTS }),
    /* @__PURE__ */ jsxs(SearchMotionCard, { animate: "open", exit: "closed", initial: "closed", overflow: "hidden", radius: POPOVER_RADIUS, ref: popoverElement, shadow: 2, style: {
      zIndex
    }, transition: ANIMATION_TRANSITION$1, variants: CARD_VARIANTS, children: [
      /* @__PURE__ */ jsx(SearchHeader, { onClose, ref: setInputElement }),
      filtersVisible && /* @__PURE__ */ jsx(Card, { borderTop: !0, flex: "none", children: /* @__PURE__ */ jsx(Filters, {}) }),
      hasValidTerms ? /* @__PURE__ */ jsx(SearchResults, { inputElement, onItemSelect, disableIntentLink, previewPerspective }) : /* @__PURE__ */ jsx(RecentSearches, { inputElement })
    ] })
  ] }) }), $[3] = disableFocusLock, $[4] = disableIntentLink, $[5] = filtersVisible, $[6] = hasValidTerms, $[7] = inputElement, $[8] = onClose, $[9] = onItemSelect, $[10] = open, $[11] = previewPerspective, $[12] = zIndex, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== t4 ? (t5 = /* @__PURE__ */ jsx(AnimatePresence, { children: t4 }), $[14] = t4, $[15] = t5) : t5 = $[15];
  let t6;
  return $[16] !== hasValidTerms || $[17] !== onClose || $[18] !== onOpen || $[19] !== open || $[20] !== t5 ? (t6 = /* @__PURE__ */ jsx(SearchWrapper, { hasValidTerms, onClose, onOpen, open, children: t5 }), $[16] = hasValidTerms, $[17] = onClose, $[18] = onOpen, $[19] = open, $[20] = t5, $[21] = t6) : t6 = $[21], t6;
}
const DEFAULT_DEBOUNCE_TIME = 300, INITIAL_SEARCH_STATE = {
  error: null,
  hits: [],
  loading: !1,
  terms: {
    query: "",
    types: []
  }
};
function nonNullable(v) {
  return v !== null;
}
function sanitizeRequest(request) {
  return {
    ...request,
    terms: {
      ...request.terms,
      filter: request.terms.filter?.trim(),
      query: request.terms.query.trim()
    }
  };
}
function useSearch(t0) {
  const $ = c(16), {
    allowEmptyQueries,
    initialState: initialState2,
    onComplete,
    onError,
    onStart,
    schema: schema2
  } = t0, [searchState, setSearchState] = useState(initialState2), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), maxFieldDepth = useSearchMaxFieldDepth(), {
    strategy
  } = useWorkspace().search;
  let t1;
  $[0] !== client || $[1] !== maxFieldDepth || $[2] !== schema2 || $[3] !== strategy ? (t1 = createSearch(getSearchableOmnisearchTypes(schema2), client, {
    tag: "search.global",
    unique: !0,
    strategy,
    maxDepth: maxFieldDepth
  }), $[0] = client, $[1] = maxFieldDepth, $[2] = schema2, $[3] = strategy, $[4] = t1) : t1 = $[4];
  const search2 = t1;
  let t2;
  $[5] !== allowEmptyQueries || $[6] !== onComplete || $[7] !== onError || $[8] !== onStart || $[9] !== search2 ? (t2 = (inputValue$) => inputValue$.pipe(filter(nonNullable), map(sanitizeRequest), distinctUntilChanged(isEqual$1), debounce$1(_temp$1Q), tap(onStart), switchMap((request_0) => concat(of({
    ...INITIAL_SEARCH_STATE,
    loading: !0,
    options: request_0.options,
    terms: request_0.terms
  }), iif(() => hasSearchableTerms({
    allowEmptyQueries,
    terms: request_0.terms
  }), search2(request_0.terms, request_0.options).pipe(tap((t32) => {
    const {
      hits,
      nextCursor
    } = t32;
    return onComplete?.({
      hits,
      nextCursor
    });
  }), catchError((error) => (onError?.(error), of({
    ...INITIAL_SEARCH_STATE,
    error,
    loading: !1,
    options: request_0.options,
    terms: request_0.terms
  })))), of(EMPTY$5).pipe(tap(() => onComplete?.({
    hits: [],
    nextCursor: void 0
  })))), of({
    loading: !1
  }))), scan(_temp2$K, INITIAL_SEARCH_STATE), tap(setSearchState)), $[5] = allowEmptyQueries, $[6] = onComplete, $[7] = onError, $[8] = onStart, $[9] = search2, $[10] = t2) : t2 = $[10];
  const handleQueryChange = useObservableEvent(t2);
  let t3;
  $[11] !== handleQueryChange ? (t3 = (searchRequest) => handleQueryChange(searchRequest), $[11] = handleQueryChange, $[12] = t3) : t3 = $[12];
  const handleSearch = t3;
  let t4;
  return $[13] !== handleSearch || $[14] !== searchState ? (t4 = {
    handleSearch,
    searchState
  }, $[13] = handleSearch, $[14] = searchState, $[15] = t4) : t4 = $[15], t4;
}
function _temp2$K(prevState, nextState) {
  return {
    ...prevState,
    ...nextState
  };
}
function _temp$1Q(request) {
  return timer(request?.debounceTime || DEFAULT_DEBOUNCE_TIME);
}
function isRecentSearchTerms(terms) {
  return typeof terms.__recent < "u";
}
const rootName = "core:studio:navbar:search:";
function debugWithName(name) {
  const namespace = `${rootName}${name}`;
  return debug$c && debug$c.enabled(namespace) ? debug$c(namespace) : debug$c(rootName);
}
function isDebugMode() {
  return typeof window > "u" ? !1 : window.location.hash.slice(1).split(";").includes(DEBUG_FRAGMENT);
}
function initialSearchState({
  currentUser,
  fullscreen,
  definitions,
  pagination,
  strategy
}) {
  return {
    currentUser,
    debug: isDebugMode(),
    documentTypesNarrowed: [],
    filters: [],
    filtersVisible: !0,
    fullscreen,
    lastActiveIndex: -1,
    ordering: getOrderings({
      searchStrategy: strategy
    }).relevance,
    ...pagination,
    result: {
      error: null,
      hasLocal: !1,
      hits: [],
      loaded: !1,
      loading: !1
    },
    terms: {
      query: "",
      types: []
    },
    definitions,
    strategy
  };
}
const debug$8 = debugWithName("reducer");
function searchReducer(state, action) {
  let prefix = "\u{1F50D}";
  switch (action.type.startsWith("SEARCH_REQUEST") && (prefix = "\u{1F6A8}"), action.type.startsWith("RECENT_SEARCHES") && (prefix = "\u{1F4BE}"), debug$8(prefix, action), action.type) {
    case "FILTERS_VISIBLE_SET":
      return {
        ...state,
        filtersVisible: action.visible
      };
    case "LAST_ACTIVE_INDEX_SET":
      return {
        ...state,
        lastActiveIndex: action.index
      };
    case "ORDERING_RESET":
      return {
        ...state,
        ordering: getOrderings({
          searchStrategy: state.strategy
        }).relevance,
        terms: stripRecent(state.terms),
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    case "ORDERING_SET":
      return {
        ...state,
        ordering: action.ordering,
        terms: stripRecent(state.terms),
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    case "PAGE_INCREMENT":
      return {
        ...state,
        cursor: state.nextCursor ?? state.cursor,
        nextCursor: null,
        terms: stripRecent(state.terms)
      };
    case "SEARCH_CLEAR":
      return {
        ...state,
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          hasLocal: !1,
          hits: []
        }
      };
    case "SEARCH_REQUEST_COMPLETE":
      return {
        ...state,
        nextCursor: action.nextCursor ?? null,
        result: {
          ...state.result,
          error: null,
          hasLocal: !0,
          hits: removeDupes$3([...state.result.hasLocal ? state.result.hits : [], ...action.hits].map(({
            hit
          }) => hit)).map((hit) => ({
            hit
          })),
          loaded: !0,
          loading: !1
        }
      };
    case "SEARCH_REQUEST_ERROR":
      return {
        ...state,
        result: {
          ...state.result,
          error: action.error,
          loaded: !1,
          loading: !1
        }
      };
    case "SEARCH_REQUEST_START":
      return {
        ...state,
        result: {
          ...state.result,
          loaded: !1,
          loading: !0
        }
      };
    case "TERMS_FILTERS_ADD": {
      const newFilter = {
        ...action.filter,
        value: getOperatorInitialValue(state.definitions.operators, action.filter.operatorType)
      }, filters = [...state.filters, newFilter];
      return {
        ...state,
        documentTypesNarrowed: narrowDocumentTypes({
          fieldDefinitions: state.definitions.fields,
          filters,
          types: state.terms.types
        }),
        filters,
        lastAddedFilter: newFilter,
        cursor: null,
        nextCursor: null,
        terms: {
          ...state.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            filters,
            operatorDefinitions: state.definitions.operators
          })
        },
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    }
    case "TERMS_FILTERS_CLEAR": {
      const filters = [];
      return {
        ...state,
        documentTypesNarrowed: narrowDocumentTypes({
          fieldDefinitions: state.definitions.fields,
          filters,
          types: state.terms.types
        }),
        filters,
        cursor: null,
        nextCursor: null,
        terms: {
          ...state.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            filters,
            operatorDefinitions: state.definitions.operators
          })
        },
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    }
    case "TERMS_FILTERS_REMOVE": {
      const index = state.filters.findIndex((filter2) => getFilterKey(filter2) === action.filterKey), filters = [
        ...state.filters.slice(0, index),
        //
        ...state.filters.slice(index + 1)
      ];
      return {
        ...state,
        documentTypesNarrowed: narrowDocumentTypes({
          fieldDefinitions: state.definitions.fields,
          filters,
          types: state.terms.types
        }),
        filters,
        cursor: null,
        nextCursor: null,
        terms: {
          ...state.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            filters,
            operatorDefinitions: state.definitions.operators
          })
        },
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    }
    case "TERMS_FILTERS_SET_OPERATOR": {
      const matchedFilter = state.filters.find((filter2) => getFilterKey(filter2) === action.filterKey), currentOperator = getOperatorDefinition(state.definitions.operators, matchedFilter?.operatorType), nextOperator = getOperatorDefinition(state.definitions.operators, action.operatorType), nextInitialValue = nextOperator?.initialValue, inputComponentChanged = currentOperator?.inputComponent != nextOperator?.inputComponent, filters = state.filters.map((filter2) => getFilterKey(filter2) === action.filterKey ? {
        ...filter2,
        operatorType: action.operatorType,
        ...inputComponentChanged ? {
          value: nextInitialValue
        } : {}
      } : filter2);
      return {
        ...state,
        filters,
        cursor: null,
        nextCursor: null,
        terms: {
          ...state.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            filters,
            operatorDefinitions: state.definitions.operators
          })
        },
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    }
    case "TERMS_FILTERS_SET_VALUE": {
      const filters = state.filters.map((filter2) => getFilterKey(filter2) === action.filterKey ? {
        ...filter2,
        value: action.value
      } : filter2);
      return {
        ...state,
        filters,
        cursor: null,
        nextCursor: null,
        terms: {
          ...state.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            filters,
            operatorDefinitions: state.definitions.operators
          })
        },
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    }
    case "TERMS_QUERY_SET":
      return {
        ...state,
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          loaded: !1,
          hasLocal: !1
        },
        terms: stripRecent({
          ...state.terms,
          query: action.query
        })
      };
    case "TERMS_SET": {
      const filters = action.filters || [], types = [
        ...state.terms.types || [],
        //
        ...action.terms.types
      ].sort(sortTypes);
      return {
        ...state,
        documentTypesNarrowed: narrowDocumentTypes({
          fieldDefinitions: state.definitions.fields,
          filters,
          types
        }),
        filters,
        lastAddedFilter: null,
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          loaded: !1,
          hasLocal: !1
        },
        terms: {
          ...action.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            filters,
            operatorDefinitions: state.definitions.operators
          })
        }
      };
    }
    case "TERMS_TYPE_ADD": {
      const types = [
        ...state.terms.types || [],
        //
        action.schemaType
      ].sort(sortTypes), documentTypesNarrowed = narrowDocumentTypes({
        fieldDefinitions: state.definitions.fields,
        filters: [],
        types
      }), filters = state.filters.filter((f) => {
        const fieldDefinition = getFieldFromFilter(state.definitions.fields, f);
        return fieldDefinition ? fieldDefinition.documentTypes.length === 0 ? !0 : documentTypesNarrowed.every((type) => fieldDefinition.documentTypes.findIndex((t) => t === type) > -1) : !0;
      });
      return {
        ...state,
        documentTypesNarrowed,
        filters,
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          loaded: !1,
          hasLocal: !1
        },
        terms: stripRecent({
          ...state.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            operatorDefinitions: state.definitions.operators,
            filters
          }),
          types
        })
      };
    }
    case "TERMS_TYPE_REMOVE": {
      const types = (state.terms.types || []).filter((s) => s !== action.schemaType);
      return {
        ...state,
        documentTypesNarrowed: narrowDocumentTypes({
          fieldDefinitions: state.definitions.fields,
          filters: state.filters,
          types
        }),
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          loaded: !1,
          hasLocal: !1
        },
        terms: stripRecent({
          ...state.terms,
          types
        })
      };
    }
    case "TERMS_TYPES_CLEAR": {
      const types = [];
      return {
        ...state,
        documentTypesNarrowed: narrowDocumentTypes({
          fieldDefinitions: state.definitions.fields,
          filters: state.filters,
          types
        }),
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          loaded: !1,
          hasLocal: !1
        },
        terms: stripRecent({
          ...state.terms,
          types: []
        })
      };
    }
    default:
      return state;
  }
}
function stripRecent(terms) {
  if (isRecentSearchTerms(terms)) {
    const {
      __recent,
      ...rest
    } = terms;
    return rest;
  }
  return terms;
}
function SearchProvider(t0) {
  const $ = c(83), {
    children,
    fullscreen,
    disabledDocumentIds,
    canDisableAction
  } = t0, [onClose, setOnClose] = useState(null), [searchCommandList, setSearchCommandList] = useState(null), {
    data: releases2
  } = useActiveReleases(), schema2 = useSchema(), currentUser = useCurrentUser(), {
    search: t1
  } = useSource(), {
    operators,
    filters,
    strategy
  } = t1;
  let t2;
  $[0] !== filters || $[1] !== schema2 ? (t2 = createFieldDefinitionDictionary(createFieldDefinitions(schema2, filters)), $[0] = filters, $[1] = schema2, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== filters ? (t3 = createFilterDefinitionDictionary(filters), $[3] = filters, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== operators ? (t4 = createOperatorDefinitionDictionary(operators), $[5] = operators, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t2 || $[8] !== t3 || $[9] !== t4 ? (t5 = {
    fieldDefinitions: t2,
    filterDefinitions: t3,
    operatorDefinitions: t4
  }, $[7] = t2, $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10];
  const {
    fieldDefinitions,
    filterDefinitions: filterDefinitions2,
    operatorDefinitions: operatorDefinitions2
  } = t5;
  let t6;
  $[11] !== currentUser || $[12] !== fieldDefinitions || $[13] !== filterDefinitions2 || $[14] !== fullscreen || $[15] !== operatorDefinitions2 || $[16] !== strategy ? (t6 = initialSearchState({
    currentUser,
    fullscreen,
    definitions: {
      fields: fieldDefinitions,
      operators: operatorDefinitions2,
      filters: filterDefinitions2
    },
    pagination: {
      cursor: null,
      nextCursor: null
    },
    strategy
  }), $[11] = currentUser, $[12] = fieldDefinitions, $[13] = filterDefinitions2, $[14] = fullscreen, $[15] = operatorDefinitions2, $[16] = strategy, $[17] = t6) : t6 = $[17];
  const initialState2 = t6, [state, dispatch] = useReducer(searchReducer, initialState2), {
    documentTypesNarrowed,
    filters: currentFilters,
    ordering,
    cursor,
    result,
    terms
  } = state, isMountedRef = useRef(!1), previousOrderingRef = useRef(initialState2.ordering), previousCursorRef = useRef(initialState2.cursor), previousTermsRef = useRef(initialState2.terms);
  let t7;
  $[18] !== result || $[19] !== terms ? (t7 = {
    ...result,
    terms
  }, $[18] = result, $[19] = terms, $[20] = t7) : t7 = $[20];
  let t10, t8, t9;
  $[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = (searchResult) => dispatch({
    ...searchResult,
    type: "SEARCH_REQUEST_COMPLETE"
  }), t9 = (error) => dispatch({
    error,
    type: "SEARCH_REQUEST_ERROR"
  }), t10 = () => dispatch({
    type: "SEARCH_REQUEST_START"
  }), $[21] = t10, $[22] = t8, $[23] = t9) : (t10 = $[21], t8 = $[22], t9 = $[23]);
  let t11;
  $[24] !== schema2 || $[25] !== t7 ? (t11 = {
    initialState: t7,
    onComplete: t8,
    onError: t9,
    onStart: t10,
    schema: schema2
  }, $[24] = schema2, $[25] = t7, $[26] = t11) : t11 = $[26];
  const {
    handleSearch,
    searchState
  } = useSearch(t11);
  let t12;
  $[27] !== terms ? (t12 = hasSearchableTerms({
    terms
  }), $[27] = terms, $[28] = t12) : t12 = $[28];
  const hasValidTerms = t12;
  let t13;
  if ($[29] !== documentTypesNarrowed || $[30] !== schema2) {
    let t142;
    $[32] !== schema2 ? (t142 = (documentType) => schema2.get(documentType), $[32] = schema2, $[33] = t142) : t142 = $[33], t13 = documentTypesNarrowed.map(t142), $[29] = documentTypesNarrowed, $[30] = schema2, $[31] = t13;
  } else
    t13 = $[31];
  const documentTypes = t13;
  let t14;
  if ($[34] !== currentFilters || $[35] !== fieldDefinitions || $[36] !== filterDefinitions2 || $[37] !== operatorDefinitions2) {
    let t152;
    $[39] !== fieldDefinitions || $[40] !== filterDefinitions2 || $[41] !== operatorDefinitions2 ? (t152 = (filter2) => validateFilter({
      fieldDefinitions,
      filter: filter2,
      filterDefinitions: filterDefinitions2,
      operatorDefinitions: operatorDefinitions2
    }), $[39] = fieldDefinitions, $[40] = filterDefinitions2, $[41] = operatorDefinitions2, $[42] = t152) : t152 = $[42], t14 = currentFilters.filter(t152), $[34] = currentFilters, $[35] = fieldDefinitions, $[36] = filterDefinitions2, $[37] = operatorDefinitions2, $[38] = t14;
  } else
    t14 = $[38];
  const completeFilters = t14;
  let t15;
  $[43] !== completeFilters.length || $[44] !== cursor || $[45] !== documentTypes || $[46] !== handleSearch || $[47] !== ordering || $[48] !== strategy || $[49] !== terms ? (t15 = () => {
    const orderingChanged = !isEqual$1(ordering, previousOrderingRef.current), cursorChanged = cursor !== previousCursorRef.current, termsChanged = !isEqual$1(terms, previousTermsRef.current);
    if (orderingChanged || cursorChanged || termsChanged) {
      let sortLabel = "findability-sort:";
      (ordering?.customMeasurementLabel || ordering.sort) && (sortLabel = "findability-sort:" + (ordering?.customMeasurementLabel || `${ordering.sort?.field} ${ordering.sort?.direction}`)), handleSearch({
        options: {
          comments: [...isRecentSearchTerms(terms) ? [`findability-recent-search:${terms.__recent.index}`] : [], `findability-selected-types:${terms.types.length}`, sortLabel, "findability-source: global", `findability-filter-count:${completeFilters.length}`],
          limit: strategy === "groq2024" ? 25 : SEARCH_LIMIT,
          skipSortByScore: ordering.ignoreScore,
          ...ordering.sort ? {
            sort: [ordering.sort]
          } : {},
          cursor: cursor || void 0,
          perspective: "raw"
        },
        terms: {
          ...terms,
          ...documentTypes ? {
            types: documentTypes
          } : {}
        }
      }), cursorChanged && (previousCursorRef.current = cursor);
    }
    previousOrderingRef.current = ordering, previousTermsRef.current = terms;
  }, $[43] = completeFilters.length, $[44] = cursor, $[45] = documentTypes, $[46] = handleSearch, $[47] = ordering, $[48] = strategy, $[49] = terms, $[50] = t15) : t15 = $[50];
  let t16;
  $[51] !== completeFilters.length || $[52] !== currentFilters || $[53] !== cursor || $[54] !== documentTypes || $[55] !== handleSearch || $[56] !== hasValidTerms || $[57] !== ordering || $[58] !== releases2 || $[59] !== searchState.terms || $[60] !== strategy || $[61] !== terms ? (t16 = [completeFilters.length, currentFilters, documentTypes, handleSearch, hasValidTerms, ordering, searchState.terms, terms, cursor, strategy, releases2], $[51] = completeFilters.length, $[52] = currentFilters, $[53] = cursor, $[54] = documentTypes, $[55] = handleSearch, $[56] = hasValidTerms, $[57] = ordering, $[58] = releases2, $[59] = searchState.terms, $[60] = strategy, $[61] = terms, $[62] = t16) : t16 = $[62], useEffect(t15, t16);
  let t17;
  $[63] !== hasValidTerms || $[64] !== result.hits ? (t17 = () => {
    !hasValidTerms && isMountedRef?.current && result.hits.length > 0 && dispatch({
      type: "SEARCH_CLEAR"
    }), isMountedRef.current = !0;
  }, $[63] = hasValidTerms, $[64] = result.hits, $[65] = t17) : t17 = $[65];
  let t18;
  $[66] !== hasValidTerms || $[67] !== result.hits || $[68] !== terms.query || $[69] !== terms.types ? (t18 = [dispatch, hasValidTerms, result.hits, terms.query, terms.types], $[66] = hasValidTerms, $[67] = result.hits, $[68] = terms.query, $[69] = terms.types, $[70] = t18) : t18 = $[70], useEffect(t17, t18);
  let t19;
  $[71] !== canDisableAction || $[72] !== disabledDocumentIds || $[73] !== fullscreen || $[74] !== state ? (t19 = {
    ...state,
    fullscreen,
    disabledDocumentIds,
    canDisableAction
  }, $[71] = canDisableAction, $[72] = disabledDocumentIds, $[73] = fullscreen, $[74] = state, $[75] = t19) : t19 = $[75];
  let t20;
  $[76] !== onClose || $[77] !== searchCommandList || $[78] !== t19 ? (t20 = {
    dispatch,
    onClose,
    searchCommandList,
    setSearchCommandList,
    setOnClose,
    state: t19
  }, $[76] = onClose, $[77] = searchCommandList, $[78] = t19, $[79] = t20) : t20 = $[79];
  const value = t20;
  let t21;
  return $[80] !== children || $[81] !== value ? (t21 = /* @__PURE__ */ jsx(SearchContext.Provider, { value, children }), $[80] = children, $[81] = value, $[82] = t21) : t21 = $[82], t21;
}
function AddDocumentSearch(t0) {
  const $ = c(9), {
    open,
    onClose,
    releaseId,
    idsInRelease
  } = t0;
  let t1;
  $[0] !== releaseId ? (t1 = [releaseId], $[0] = releaseId, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== onClose || $[3] !== open || $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(PortalProvider, { children: /* @__PURE__ */ jsx(SearchPopover, { onClose, onItemSelect: onClose, open, previewPerspective: t1, disableIntentLink: !0 }) }), $[2] = onClose, $[3] = open, $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== idsInRelease || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsx(LayerProvider, { zOffset: 1, children: /* @__PURE__ */ jsx(SearchProvider, { disabledDocumentIds: idsInRelease, canDisableAction: !0, children: t2 }) }), $[6] = idsInRelease, $[7] = t2, $[8] = t3) : t3 = $[8], t3;
}
const DOCUMENT_ACTION_CONFIGS = [{
  key: "added",
  tone: "positive",
  labelKey: "table-body.action.add"
}, {
  key: "changed",
  tone: "caution",
  labelKey: "table-body.action.change"
}, {
  key: "unpublished",
  tone: "critical",
  labelKey: "table-body.action.unpublish"
}], FILTER_TAB_CONFIGS = [{
  key: "all",
  labelKey: "filter-tab.all",
  tone: "default"
}, ...DOCUMENT_ACTION_CONFIGS, {
  key: "errors",
  labelKey: "filter-tab.errors",
  tone: "critical"
}];
function countDocumentsByAction(documents) {
  return documents.reduce((acc, doc) => {
    const actionType = getDocumentActionType(doc);
    return actionType && acc[actionType]++, doc.validation.hasError && !doc.isPending && acc.errors++, acc;
  }, {
    added: 0,
    changed: 0,
    unpublished: 0,
    errors: 0
  });
}
function documentMatchesFilter(doc, filter2) {
  return filter2 === "all" ? !0 : filter2 === "errors" ? doc.validation.hasError && !doc.isPending : getDocumentActionType(doc) === filter2;
}
function getDocumentActionType(document2) {
  return !document2.document || document2.isPending ? null : isGoingToUnpublish(document2.document) ? "unpublished" : document2.document.publishedDocumentExists ? "changed" : "added";
}
function getReleaseDocumentActionConfig(actionType) {
  return DOCUMENT_ACTION_CONFIGS.find(({
    key
  }) => key === actionType);
}
function ReleaseDocumentFilterTabs(t0) {
  const $ = c(6), {
    documents,
    releaseState,
    isLoading: t1,
    activeFilter,
    onFilterChange
  } = t0, isLoading = t1 === void 0 ? !1 : t1, {
    t
  } = useTranslation(releasesLocaleNamespace);
  if (releaseState === "archived" || releaseState === "published")
    return null;
  if (isLoading) {
    let t22;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(Container$3, { width: 3, children: /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(Flex, { align: "center", gap: 2, children: FILTER_TAB_CONFIGS.filter(_temp$1P).map(_temp2$J) }) }) }), $[0] = t22) : t22 = $[0], t22;
  }
  if (documents.length === 0)
    return null;
  let t2;
  return $[1] !== activeFilter || $[2] !== documents || $[3] !== onFilterChange || $[4] !== t ? (t2 = /* @__PURE__ */ jsx(ReleaseDocumentFilterTabsInner, { documents, activeFilter, onFilterChange, t }), $[1] = activeFilter, $[2] = documents, $[3] = onFilterChange, $[4] = t, $[5] = t2) : t2 = $[5], t2;
}
function _temp2$J(config_0) {
  return /* @__PURE__ */ jsx(Skeleton, { animated: !0, style: {
    width: "70px",
    height: "32px"
  }, radius: 2 }, `loading-skeleton-${config_0.key}`);
}
function _temp$1P(config) {
  return config.key !== "errors";
}
function ReleaseDocumentFilterTabsInner(t0) {
  const $ = c(15), {
    documents,
    activeFilter,
    onFilterChange,
    t
  } = t0;
  let t1;
  $[0] !== documents ? (t1 = countDocumentsByAction(documents), $[0] = documents, $[1] = t1) : t1 = $[1];
  const counts = t1;
  let t2;
  $[2] !== counts || $[3] !== t ? (t2 = (config) => {
    const label = t(config.labelKey);
    if (config.key === "all")
      return label;
    const count2 = counts[config.key];
    return `${label} (${count2})`;
  }, $[2] = counts, $[3] = t, $[4] = t2) : t2 = $[4];
  const getTabLabel = t2;
  let t3;
  $[5] !== activeFilter ? (t3 = (config_0) => config_0.key === "errors" ? "critical" : activeFilter === config_0.key ? config_0.tone : "default", $[5] = activeFilter, $[6] = t3) : t3 = $[6];
  const getTabTone = t3;
  let t4;
  $[7] !== activeFilter || $[8] !== counts || $[9] !== getTabLabel || $[10] !== getTabTone || $[11] !== onFilterChange ? (t4 = FILTER_TAB_CONFIGS.map((config_1) => {
    const isSelected = activeFilter === config_1.key;
    return config_1.key !== "all" && counts[config_1.key] === 0 ? null : /* @__PURE__ */ jsx(Tab, { id: `filter-tab-${config_1.key}`, "aria-controls": "document-table-card", label: getTabLabel(config_1), onClick: () => onFilterChange(config_1.key), selected: isSelected, tone: getTabTone(config_1) }, config_1.key);
  }), $[7] = activeFilter, $[8] = counts, $[9] = getTabLabel, $[10] = getTabTone, $[11] = onFilterChange, $[12] = t4) : t4 = $[12];
  let t5;
  return $[13] !== t4 ? (t5 = /* @__PURE__ */ jsx(Container$3, { width: 3, children: /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(TabList, { space: 1, children: t4 }) }) }), $[13] = t4, $[14] = t5) : t5 = $[14], t5;
}
const DocumentActionsInner = memo(function(t0) {
  const $ = c(65), {
    document: document2,
    releaseTitle
  } = t0, [showDiscardDialog, setShowDiscardDialog] = useState(!1), [showUnpublishDialog, setShowUnpublishDialog] = useState(!1), {
    t: coreT
  } = useTranslation(), {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t1;
  $[0] !== document2.document ? (t1 = isGoingToUnpublish(document2.document), $[0] = document2.document, $[1] = t1) : t1 = $[1];
  const isAlreadyUnpublished = t1;
  let t2;
  $[2] !== document2.document._id ? (t2 = getPublishedId(document2.document._id), $[2] = document2.document._id, $[3] = t2) : t2 = $[3];
  const publishedId = t2, type = document2.document._type;
  let t3;
  $[4] !== document2.document._id ? (t3 = getVersionFromId(document2.document._id), $[4] = document2.document._id, $[5] = t3) : t3 = $[5];
  const version2 = t3;
  let t4;
  $[6] !== publishedId || $[7] !== type || $[8] !== version2 ? (t4 = {
    id: publishedId,
    type,
    version: version2,
    permission: "discardVersion"
  }, $[6] = publishedId, $[7] = type, $[8] = version2, $[9] = t4) : t4 = $[9];
  const [discardVersionPermission, isDiscardVersionPermissionsLoading] = useDocumentPairPermissions(t4);
  let t5;
  $[10] !== publishedId || $[11] !== type || $[12] !== version2 ? (t5 = {
    id: publishedId,
    type,
    version: version2,
    permission: "unpublish"
  }, $[10] = publishedId, $[11] = type, $[12] = version2, $[13] = t5) : t5 = $[13];
  const [unpublishPermission, isUnpublishPermissionsLoading] = useDocumentPairPermissions(t5), isDiscardVersionActionDisabled = !discardVersionPermission?.granted || isDiscardVersionPermissionsLoading, noPermissionToUnpublish = !unpublishPermission?.granted || isUnpublishPermissionsLoading;
  let t6;
  bb0: {
    if (noPermissionToUnpublish) {
      let t72;
      $[14] !== t ? (t72 = t("permissions.error.unpublish"), $[14] = t, $[15] = t72) : t72 = $[15], t6 = t72;
      break bb0;
    }
    if (!document2.document.publishedDocumentExists) {
      let t72;
      $[16] !== t ? (t72 = t("unpublish.no-published-version"), $[16] = t, $[17] = t72) : t72 = $[17], t6 = t72;
      break bb0;
    }
    if (isAlreadyUnpublished) {
      let t72;
      $[18] !== t ? (t72 = t("unpublish.already-unpublished"), $[18] = t, $[19] = t72) : t72 = $[19], t6 = t72;
      break bb0;
    }
    t6 = null;
  }
  const unPublishTooltipContent = t6, isUnpublishActionDisabled = noPermissionToUnpublish || !document2.document.publishedDocumentExists || isAlreadyUnpublished;
  let t7;
  $[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[20] = t7) : t7 = $[20];
  let t8;
  $[21] !== coreT ? (t8 = coreT("release.action.discard-version"), $[21] = coreT, $[22] = t8) : t8 = $[22];
  let t9;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = () => setShowDiscardDialog(!0), $[23] = t9) : t9 = $[23];
  const t10 = !isDiscardVersionActionDisabled;
  let t11;
  $[24] !== t ? (t11 = t("permissions.error.discard-version"), $[24] = t, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== t10 || $[27] !== t11 ? (t12 = {
    disabled: t10,
    content: t11
  }, $[26] = t10, $[27] = t11, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== isDiscardVersionActionDisabled || $[30] !== t12 || $[31] !== t8 ? (t13 = /* @__PURE__ */ jsx(MenuItem, { text: t8, icon: CloseIcon, onClick: t9, disabled: isDiscardVersionActionDisabled, tooltipProps: t12 }), $[29] = isDiscardVersionActionDisabled, $[30] = t12, $[31] = t8, $[32] = t13) : t13 = $[32];
  let t14;
  $[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t14 = /* @__PURE__ */ jsx(MenuDivider, {}), $[33] = t14) : t14 = $[33];
  let t15;
  $[34] !== t ? (t15 = t("menu.group.when-releasing"), $[34] = t, $[35] = t15) : t15 = $[35];
  let t16;
  $[36] !== t15 ? (t16 = /* @__PURE__ */ jsx(Box, { padding: 3, paddingBottom: 2, children: /* @__PURE__ */ jsx(Label, { size: 1, children: t15 }) }), $[36] = t15, $[37] = t16) : t16 = $[37];
  let t17;
  $[38] !== t ? (t17 = t("action.unpublish"), $[38] = t, $[39] = t17) : t17 = $[39];
  const t18 = !isUnpublishActionDisabled;
  let t19;
  $[40] !== t18 || $[41] !== unPublishTooltipContent ? (t19 = {
    disabled: t18,
    content: unPublishTooltipContent
  }, $[40] = t18, $[41] = unPublishTooltipContent, $[42] = t19) : t19 = $[42];
  let t20;
  $[43] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t20 = () => setShowUnpublishDialog(!0), $[43] = t20) : t20 = $[43];
  let t21;
  $[44] !== isUnpublishActionDisabled || $[45] !== t17 || $[46] !== t19 ? (t21 = /* @__PURE__ */ jsx(MenuItem, { text: t17, icon: UnpublishIcon, disabled: isUnpublishActionDisabled, tooltipProps: t19, onClick: t20 }), $[44] = isUnpublishActionDisabled, $[45] = t17, $[46] = t19, $[47] = t21) : t21 = $[47];
  let t22;
  $[48] !== t13 || $[49] !== t16 || $[50] !== t21 ? (t22 = /* @__PURE__ */ jsx(Card, { tone: "default", display: "flex", children: /* @__PURE__ */ jsx(MenuButton, { id: "document-actions", button: t7, menu: /* @__PURE__ */ jsxs(Menu, { children: [
    t13,
    t14,
    t16,
    t21
  ] }) }) }), $[48] = t13, $[49] = t16, $[50] = t21, $[51] = t22) : t22 = $[51];
  let t23;
  $[52] !== document2.document || $[53] !== releaseTitle || $[54] !== showDiscardDialog || $[55] !== t ? (t23 = showDiscardDialog && /* @__PURE__ */ jsx(DiscardVersionDialog, { isGoingToUnpublish: isGoingToUnpublish(document2.document), onClose: () => setShowDiscardDialog(!1), documentId: document2.document._id, documentType: document2.document._type, fromPerspective: releaseTitle || t("release-placeholder.title") }), $[52] = document2.document, $[53] = releaseTitle, $[54] = showDiscardDialog, $[55] = t, $[56] = t23) : t23 = $[56];
  let t24;
  $[57] !== document2.document._id || $[58] !== document2.document._type || $[59] !== showUnpublishDialog ? (t24 = showUnpublishDialog && /* @__PURE__ */ jsx(UnpublishVersionDialog, { onClose: () => setShowUnpublishDialog(!1), documentVersionId: document2.document._id, documentType: document2.document._type }), $[57] = document2.document._id, $[58] = document2.document._type, $[59] = showUnpublishDialog, $[60] = t24) : t24 = $[60];
  let t25;
  return $[61] !== t22 || $[62] !== t23 || $[63] !== t24 ? (t25 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t22,
    t23,
    t24
  ] }), $[61] = t22, $[62] = t23, $[63] = t24, $[64] = t25) : t25 = $[64], t25;
}, (prev, next) => prev.document.memoKey === next.document.memoKey), DocumentActions = memo(function(props2) {
  const $ = c(7), type = useSchema().get(props2.document.document._type), {
    t
  } = useTranslation();
  if (!type) {
    let t02;
    $[0] !== props2.document.document._type || $[1] !== t ? (t02 = t("document.type.not-found", {
      type: props2.document.document._type
    }), $[0] = props2.document.document._type, $[1] = t, $[2] = t02) : t02 = $[2];
    let t1;
    return $[3] !== t02 ? (t1 = /* @__PURE__ */ jsx(ContextMenuButton, { disabled: !0, tooltipProps: {
      content: t02
    } }), $[3] = t02, $[4] = t1) : t1 = $[4], t1;
  }
  let t0;
  return $[5] !== props2 ? (t0 = /* @__PURE__ */ jsx(DocumentActionsInner, { ...props2 }), $[5] = props2, $[6] = t0) : t0 = $[6], t0;
}), historyCache = /* @__PURE__ */ Object.create(null);
let activeHistoryStreams = 0;
const pendingHistoryResolvers = [];
async function acquireHistorySlot(maxConcurrent = 10) {
  activeHistoryStreams >= maxConcurrent && await new Promise((resolve) => pendingHistoryResolvers.push(resolve)), activeHistoryStreams += 1;
}
function releaseHistorySlot() {
  activeHistoryStreams = Math.max(0, activeHistoryStreams - 1);
  const next = pendingHistoryResolvers.shift();
  next && next();
}
function useReleaseHistory(releaseDocumentId, releaseId, documentRevision) {
  const $ = c(16), client = useClient(RELEASES_STUDIO_CLIENT_OPTIONS), [history2, setHistory] = useState(null);
  let t0;
  bb0: {
    if (!releaseDocumentId || !releaseId) {
      t0 = "";
      break bb0;
    }
    let t12;
    $[0] !== releaseDocumentId || $[1] !== releaseId ? (t12 = getVersionId(releaseDocumentId, releaseId), $[0] = releaseDocumentId, $[1] = releaseId, $[2] = t12) : t12 = $[2], t0 = t12;
  }
  const versionId = t0, cancelledRef = useRef(!1);
  let t1;
  $[3] !== client || $[4] !== documentRevision || $[5] !== releaseDocumentId || $[6] !== versionId ? (t1 = async () => {
    if (!versionId) {
      setHistory(null);
      return;
    }
    const cacheKey = `${releaseDocumentId}-${documentRevision}`, cached = historyCache[cacheKey];
    if (cached) {
      setHistory(cached.transactions);
      return;
    }
    await acquireHistorySlot(), await (async () => {
      const transactions = await getTransactionsLogs(client, versionId, {
        tag: "sanity.studio.releases.documents.history",
        effectFormat: "mendoza",
        excludeContent: !0,
        includeIdentifiedDocumentsOnly: !0,
        limit: 1,
        reverse: !0
      });
      cancelledRef.current || (setHistory(transactions), historyCache[cacheKey] = {
        transactions
      });
    })().catch((error) => {
      console.error("Failed to fetch or parse document history:", error), cancelledRef.current || setHistory([]);
    }).finally(_temp$1O);
  }, $[3] = client, $[4] = documentRevision, $[5] = releaseDocumentId, $[6] = versionId, $[7] = t1) : t1 = $[7];
  const fetchAndParse = t1;
  let t2, t3;
  $[8] !== fetchAndParse ? (t2 = () => (cancelledRef.current = !1, fetchAndParse(), () => {
    cancelledRef.current = !0;
  }), t3 = [fetchAndParse], $[8] = fetchAndParse, $[9] = t2, $[10] = t3) : (t2 = $[9], t3 = $[10]), useEffect(t2, t3);
  let t4;
  if ($[11] !== history2) {
    bb1: {
      const collaborators = [];
      if (!history2 || history2.length === 0) {
        t4 = {
          documentHistory: void 0,
          collaborators,
          loading: !0
        };
        break bb1;
      }
      const aggregated = {
        history: [],
        createdBy: "",
        lastEditedBy: "",
        editors: []
      };
      history2.forEach((item) => {
        const author = item.author;
        collaborators.includes(author) || collaborators.push(author), aggregated.history.length === 0 && (aggregated.createdBy = author), item.mutations?.some(_temp2$I) && (aggregated.createdBy = author), aggregated.editors.includes(author) || aggregated.editors.push(author), aggregated.lastEditedBy = author, aggregated.history.push(item);
      });
      let t5;
      $[13] !== aggregated || $[14] !== collaborators ? (t5 = {
        documentHistory: aggregated,
        collaborators,
        loading: !1
      }, $[13] = aggregated, $[14] = collaborators, $[15] = t5) : t5 = $[15], t4 = t5;
    }
    $[11] = history2, $[12] = t4;
  } else
    t4 = $[12];
  return t4;
}
function _temp2$I(mutation) {
  return "create" in mutation;
}
function _temp$1O() {
  releaseHistorySlot();
}
const MemoReleaseDocumentPreview = memo(function(t0) {
  const $ = c(9), {
    item,
    releaseId,
    releaseState,
    documentRevision
  } = t0;
  let t1;
  $[0] !== item.document ? (t1 = isGoingToUnpublish(item.document), $[0] = item.document, $[1] = t1) : t1 = $[1];
  const isGoingToBePublished = t1;
  let t2;
  return $[2] !== documentRevision || $[3] !== isGoingToBePublished || $[4] !== item.document._id || $[5] !== item.document._type || $[6] !== releaseId || $[7] !== releaseState ? (t2 = /* @__PURE__ */ jsx(ReleaseDocumentPreview, { documentId: item.document._id, documentTypeName: item.document._type, releaseId, releaseState, documentRevision, isGoingToBePublished }), $[2] = documentRevision, $[3] = isGoingToBePublished, $[4] = item.document._id, $[5] = item.document._type, $[6] = releaseId, $[7] = releaseState, $[8] = t2) : t2 = $[8], t2;
}, (prev, next) => prev.item.memoKey === next.item.memoKey && prev.releaseId === next.releaseId), MemoDocumentType = memo(function(t0) {
  const $ = c(5), {
    type
  } = t0, schema2 = useSchema();
  let t1;
  $[0] !== schema2 || $[1] !== type ? (t1 = schema2.get(type), $[0] = schema2, $[1] = type, $[2] = t1) : t1 = $[2];
  const t2 = t1?.title || "Not found";
  let t3;
  return $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t2 }), $[3] = t2, $[4] = t3) : t3 = $[4], t3;
}, (prev, next) => prev.type === next.type), documentActionColumn = (t) => ({
  id: "action",
  width: null,
  style: {
    minWidth: 100
  },
  header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.BasicHeader, { text: t("table-header.action") }) }),
  cell: ({
    cellProps,
    datum
  }) => /* @__PURE__ */ jsx(Flex, { align: "center", ...cellProps, children: /* @__PURE__ */ jsx(Box, { paddingX: 2, children: (() => {
    const actionType = getDocumentActionType(datum);
    if (!actionType) return null;
    const documentActionConfig = getReleaseDocumentActionConfig(actionType);
    return documentActionConfig ? /* @__PURE__ */ jsx(Badge, { radius: 2, tone: documentActionConfig.tone, "data-testid": `${actionType}-badge-${datum.document._id}`, children: t(documentActionConfig.labelKey) }) : null;
  })() }) })
}), getDocumentTableColumnDefs = (releaseId, releaseState, t) => [
  /**
   * Hiding action for archived and published releases of v1.0
   * This will be added once Events API has reverse order lookup supported
   */
  ...releaseState === "archived" || releaseState === "published" ? [] : [documentActionColumn(t)],
  {
    id: "document._type",
    width: null,
    style: {
      minWidth: 100
    },
    sorting: !0,
    header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { text: t("table-header.type"), ...props2 }) }),
    cell: ({
      cellProps,
      datum
    }) => /* @__PURE__ */ jsx(Flex, { align: "center", ...cellProps, children: /* @__PURE__ */ jsx(Box, { paddingX: 2, children: !datum.isLoading && /* @__PURE__ */ jsx(MemoDocumentType, { type: datum.document._type }) }) })
  },
  {
    id: "search",
    width: null,
    style: {
      minWidth: "min(50%, calc(100vw - 80px))",
      maxWidth: "min(50%, calc(100vw - 80px))"
    },
    sortTransform(value) {
      return String(value.document?.title || value.document?.name || value.document?._id).toLowerCase() || 0;
    },
    header: (props2) => /* @__PURE__ */ jsx(Headers.TableHeaderSearch, { ...props2, placeholder: t("search-documents-placeholder") }),
    cell: ({
      cellProps,
      datum
    }) => /* @__PURE__ */ jsx(Box, { ...cellProps, flex: 1, padding: 1, paddingRight: 2, sizing: "border", children: datum.isPending || datum.isLoading ? /* @__PURE__ */ jsx(SanityDefaultPreview, { isPlaceholder: !0 }) : /* @__PURE__ */ jsx(MemoReleaseDocumentPreview, { item: datum, releaseId, releaseState, documentRevision: datum.document._rev }) })
  },
  {
    id: "document._updatedAt",
    sorting: !0,
    width: 130,
    header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { text: t("table-header.edited"), ...props2 }) }),
    cell: (props2) => /* @__PURE__ */ jsx(UpdatedAtCell, { ...props2, releaseDocumentId: releaseId })
  },
  {
    id: "validation",
    sorting: !1,
    width: 50,
    header: ({
      headerProps
    }) => /* @__PURE__ */ jsx(Flex, { ...headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.BasicHeader, { text: "" }) }),
    cell: ({
      cellProps,
      datum
    }) => {
      if (datum.isLoading) return null;
      const validationErrorCount = datum.validation.validation.filter((validation2) => validation2.level === "error").length;
      return /* @__PURE__ */ jsx(Flex, { ...cellProps, flex: 1, padding: 1, justify: "center", align: "center", sizing: "border", children: datum.validation.hasError && /* @__PURE__ */ jsx(Tooltip, { portal: !0, placement: "bottom-end", content: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, padding: 1, children: [
        /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: "critical" }),
        t(validationErrorCount === 1 ? "document-validation.error_one" : "document-validation.error_other", {
          count: validationErrorCount
        })
      ] }) }), children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: "critical" }) }) }) });
    }
  }
];
function UpdatedAtCell(t0) {
  const $ = c(16), {
    cellProps,
    datum,
    releaseDocumentId
  } = t0, {
    document: document2,
    isLoading
  } = datum;
  let t1;
  $[0] !== releaseDocumentId ? (t1 = getReleaseIdFromReleaseDocumentId(releaseDocumentId), $[0] = releaseDocumentId, $[1] = t1) : t1 = $[1];
  const bundleId = t1, historyDocumentId = datum.isPending || document2?._id?.endsWith("-pending") ? void 0 : document2?._id, {
    documentHistory
  } = useReleaseHistory(historyDocumentId, bundleId, document2?._rev);
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    minWidth: 130
  }, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== documentHistory?.lastEditedBy || $[4] !== isLoading ? (t3 = (isLoading || !documentHistory?.lastEditedBy) && /* @__PURE__ */ jsx(AvatarSkeleton$1, { $size: 0, animated: !0 }), $[3] = documentHistory?.lastEditedBy, $[4] = isLoading, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== document2 || $[7] !== documentHistory || $[8] !== isLoading ? (t4 = !isLoading && document2._updatedAt && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    documentHistory?.lastEditedBy && /* @__PURE__ */ jsx(UserAvatar, { size: 0, user: documentHistory.lastEditedBy }),
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(RelativeTime, { time: document2._updatedAt, useTemporalPhrase: !0, minimal: !0 }) })
  ] }), $[6] = document2, $[7] = documentHistory, $[8] = isLoading, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== t3 || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t3,
    t4
  ] }), $[10] = t3, $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  return $[13] !== cellProps || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, style: t2, sizing: "border", children: t5 }), $[13] = cellProps, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
}
function extractSearchableText(value, depth = 0, visited = []) {
  if (typeof value > "u" || value === null || depth > 3) return "";
  if (typeof value == "string") return value;
  if (typeof value == "number") return value.toString();
  if (Array.isArray(value))
    return value.map((item) => typeof item == "object" && item.children && item._type === "block" ? item.children.map((child) => child.text).join(" ").trim() : Array.isArray(item) ? extractSearchableText(item, depth + 1, visited) : item.toString().trim()).filter(Boolean).join(" ");
  if (typeof value == "object" && value !== null) {
    if (visited.includes(value)) return "";
    visited.push(value);
    const entries = Object.entries(value);
    if (entries.length > 0 && entries.every(([key, val]) => typeof val != "boolean" && !key.startsWith("_")))
      return entries.map(([, val]) => extractSearchableText(val, depth + 1, visited)).filter(Boolean).join(" ");
    const title = "title" in value && typeof value.title == "string" ? value.title.toString().trim() : void 0, name = "name" in value && typeof value.name == "string" ? value.name.toString().trim() : void 0, text = "text" in value && typeof value.text == "string" ? value.text.toString().trim() : void 0;
    return title || name || text ? [title, name, text].filter(Boolean).join(" ") : entries.filter(([key]) => !key.startsWith("_")).map(([, val]) => extractSearchableText(val, depth + 1, visited)).filter(Boolean).join(" ");
  }
  return "";
}
function searchDocumentRelease(document2, searchTerm) {
  if (!searchTerm || searchTerm.trim().length === 0 || !document2.title && !document2.name)
    return !1;
  const title = extractSearchableText(document2.title), name = extractSearchableText(document2.name), normalizedSearchTerm = searchTerm.toLowerCase().trim(), normalizedTitle = title.toLowerCase(), normalizedName = name.toLowerCase(), hasTitle = normalizedTitle.trim().length > 0, hasName = normalizedName.trim().length > 0, combinedText = `${normalizedTitle} ${normalizedName}`, allWordsMatch = normalizedSearchTerm.split(/\s+/).filter((word) => word.length > 0).every((word) => hasTitle && normalizedTitle.includes(word) || hasName && normalizedName.includes(word) || combinedText.includes(word)), documentInSearchTerm = hasName && normalizedSearchTerm.includes(normalizedName) || hasTitle && normalizedSearchTerm.includes(normalizedTitle);
  return allWordsMatch || documentInSearchTerm;
}
const FULL_HEIGHT_STYLE = {
  height: "100%"
}, SCROLL_CONTAINER_STYLE = {
  overflow: "auto",
  scrollbarWidth: "none",
  msOverflowStyle: "none"
}, FIT_CONTENT_STYLE = {
  minWidth: "fit-content",
  height: "100%"
}, isBundleDocumentRow = (maybeBundleDocumentRow) => !!maybeBundleDocumentRow && typeof maybeBundleDocumentRow == "object" && "memoKey" in maybeBundleDocumentRow && "document" in maybeBundleDocumentRow && "validation" in maybeBundleDocumentRow;
function ReleaseSummary(props2) {
  const $ = c(62), {
    documents,
    isLoading: t0,
    release
  } = props2, isLoading = t0 === void 0 ? !1 : t0, [scrollContainerRef, setScrollContainerRef] = useState(null), toast = useToast(), {
    createVersion
  } = useReleaseOperations(), telemetry = useTelemetry(), [openAddDocumentDialog, setAddDocumentDialog] = useState(!1);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[0] = t1) : t1 = $[0];
  const [pendingAddedDocument, setPendingAddedDocument] = useState(t1), [activeFilter, setActiveFilter] = useState("all"), {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t2;
  $[1] !== release._id ? (t2 = getReleaseIdFromReleaseDocumentId(release._id), $[1] = release._id, $[2] = t2) : t2 = $[2];
  const releaseId = t2;
  let t3;
  $[3] !== release.metadata.title || $[4] !== release.state ? (t3 = (rowProps) => release.state !== "active" || !isBundleDocumentRow(rowProps.datum) || rowProps.datum.isPending ? null : /* @__PURE__ */ jsx(DocumentActions, { document: rowProps.datum, releaseTitle: release.metadata.title }), $[3] = release.metadata.title, $[4] = release.state, $[5] = t3) : t3 = $[5];
  const renderRowActions = t3;
  let t4;
  $[6] !== release._id || $[7] !== release.state || $[8] !== t ? (t4 = getDocumentTableColumnDefs(release._id, release.state, t), $[6] = release._id, $[7] = release.state, $[8] = t, $[9] = t4) : t4 = $[9];
  const documentTableColumnDefs = t4;
  let t5;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => setAddDocumentDialog(!0), $[10] = t5) : t5 = $[10];
  const handleAddDocumentClick = t5;
  let t6;
  $[11] !== activeFilter ? (t6 = (data, searchTerm) => data.filter((doc) => (searchTerm ? searchDocumentRelease(doc.document, searchTerm) : !0) && documentMatchesFilter(doc, activeFilter)), $[11] = activeFilter, $[12] = t6) : t6 = $[12];
  const filterRows = t6;
  let t7;
  $[13] !== createVersion || $[14] !== releaseId || $[15] !== t || $[16] !== telemetry || $[17] !== toast ? (t7 = async (documentToAdd) => {
    if (setAddDocumentDialog(!1), !documentToAdd)
      return;
    const versionDocumentId = getVersionId(documentToAdd._id, releaseId), pendingAddedDocumentId = `${versionDocumentId}-pending`, pendingDocumentRow = {
      memoKey: versionDocumentId,
      validation: {
        isValidating: !1,
        validation: [],
        hasError: !1
      },
      document: {
        ...documentToAdd,
        _id: pendingAddedDocumentId,
        publishedDocumentExists: !1
      },
      isPending: !0
    };
    setPendingAddedDocument((prev) => [...prev, pendingDocumentRow]);
    try {
      await createVersion(releaseId, documentToAdd._id);
      const origin = getDocumentVariantType(documentToAdd._id);
      telemetry.log(AddedVersion, {
        documentOrigin: origin
      });
    } catch (t82) {
      const error = t82;
      setPendingAddedDocument((prev_0) => prev_0.filter((t92) => {
        const {
          document: document2
        } = t92;
        return document2._id !== pendingAddedDocumentId;
      })), toast.push({
        id: `add-version-to-release-${versionDocumentId}`,
        closable: !0,
        status: "error",
        title: t("toast.create-version.error", {
          error: error.message
        })
      });
    }
  }, $[13] = createVersion, $[14] = releaseId, $[15] = t, $[16] = telemetry, $[17] = toast, $[18] = t7) : t7 = $[18];
  const closeAddDialog = t7;
  let t8;
  $[19] !== documents || $[20] !== pendingAddedDocument ? (t8 = () => {
    const documentsNoLongerPending = [];
    pendingAddedDocument?.forEach((pendingDocument) => {
      documents.find((t92) => {
        const {
          document: document_0
        } = t92;
        return `${document_0._id}-pending` === pendingDocument.document._id;
      }) && documentsNoLongerPending.push(pendingDocument.document._id);
    }), documentsNoLongerPending.length && setPendingAddedDocument((prev_1) => prev_1.filter((t102) => {
      const {
        document: document_1
      } = t102;
      return !documentsNoLongerPending.includes(document_1._id);
    }));
  }, $[19] = documents, $[20] = pendingAddedDocument, $[21] = t8) : t8 = $[21];
  let t9;
  $[22] !== documents || $[23] !== pendingAddedDocument || $[24] !== t || $[25] !== toast ? (t9 = [documents, pendingAddedDocument, t, toast], $[22] = documents, $[23] = pendingAddedDocument, $[24] = t, $[25] = toast, $[26] = t9) : t9 = $[26], useEffect(t8, t9);
  let t10;
  $[27] !== documents || $[28] !== pendingAddedDocument ? (t10 = pendingAddedDocument.length ? [...documents, ...pendingAddedDocument] : documents, $[27] = documents, $[28] = pendingAddedDocument, $[29] = t10) : t10 = $[29];
  const tableData = t10;
  let t11;
  $[30] !== activeFilter || $[31] !== isLoading || $[32] !== release.state || $[33] !== tableData ? (t11 = /* @__PURE__ */ jsx(ReleaseDocumentFilterTabs, { documents: tableData, releaseState: release.state, isLoading, activeFilter, onFilterChange: setActiveFilter }), $[30] = activeFilter, $[31] = isLoading, $[32] = release.state, $[33] = tableData, $[34] = t11) : t11 = $[34];
  let t12;
  $[35] !== t ? (t12 = t("summary.no-documents"), $[35] = t, $[36] = t12) : t12 = $[36];
  let t13;
  $[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = {
    column: "search",
    direction: "asc"
  }, $[37] = t13) : t13 = $[37];
  let t14;
  $[38] !== documentTableColumnDefs || $[39] !== filterRows || $[40] !== isLoading || $[41] !== renderRowActions || $[42] !== scrollContainerRef || $[43] !== t12 || $[44] !== tableData ? (t14 = /* @__PURE__ */ jsx(Card, { ref: setScrollContainerRef, "data-testid": "document-table-card", flex: 1, borderTop: !0, style: SCROLL_CONTAINER_STYLE, children: /* @__PURE__ */ jsx("div", { style: FIT_CONTENT_STYLE, children: /* @__PURE__ */ jsx(Table, { loading: isLoading, data: tableData, emptyState: t12, rowId: "document._id", columnDefs: documentTableColumnDefs, rowActions: renderRowActions, searchFilter: filterRows, scrollContainerRef, defaultSort: t13 }) }) }), $[38] = documentTableColumnDefs, $[39] = filterRows, $[40] = isLoading, $[41] = renderRowActions, $[42] = scrollContainerRef, $[43] = t12, $[44] = tableData, $[45] = t14) : t14 = $[45];
  let t15;
  $[46] !== isLoading || $[47] !== release.state || $[48] !== t ? (t15 = release.state === "active" && /* @__PURE__ */ jsx(Container$3, { width: 3, children: /* @__PURE__ */ jsx(Card, { padding: 3, children: /* @__PURE__ */ jsx(Button, { icon: AddIcon, disabled: isLoading, mode: "bleed", onClick: handleAddDocumentClick, text: t("action.add-document") }) }) }), $[46] = isLoading, $[47] = release.state, $[48] = t, $[49] = t15) : t15 = $[49];
  let t16;
  $[50] !== documents ? (t16 = documents.map(_temp$1N), $[50] = documents, $[51] = t16) : t16 = $[51];
  let t17;
  $[52] !== closeAddDialog || $[53] !== openAddDocumentDialog || $[54] !== releaseId || $[55] !== t16 ? (t17 = /* @__PURE__ */ jsx(AddDocumentSearch, { open: openAddDocumentDialog, onClose: closeAddDialog, releaseId, idsInRelease: t16 }), $[52] = closeAddDialog, $[53] = openAddDocumentDialog, $[54] = releaseId, $[55] = t16, $[56] = t17) : t17 = $[56];
  let t18;
  return $[57] !== t11 || $[58] !== t14 || $[59] !== t15 || $[60] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Flex, { direction: "column", style: FULL_HEIGHT_STYLE, children: [
    t11,
    t14,
    t15,
    t17
  ] }), $[57] = t11, $[58] = t14, $[59] = t15, $[60] = t17, $[61] = t18) : t18 = $[61], t18;
}
function _temp$1N(t0) {
  const {
    document: document_2
  } = t0;
  return document_2._id;
}
function schedulerYield(promise) {
  return "scheduler" in window && typeof window.scheduler?.yield == "function" ? window.scheduler.yield() : promise();
}
const bundleDocumentsCache = /* @__PURE__ */ Object.create(null), getActiveReleaseDocumentsObservable = ({
  schema: schema2,
  documentPreviewStore,
  i18n,
  getClient: getClient2,
  releaseId,
  currentUser
}) => {
  const groqFilter = "sanity::partOfRelease($releaseId)", createValidationObservable = (ctx, document2) => isGoingToUnpublish(document2) ? of({
    isValidating: !1,
    validation: [],
    revision: document2._rev,
    hasError: !1
  }) : from(schedulerYield(() => Promise.resolve())).pipe(switchMap(() => validateDocumentWithReferences(ctx, of(document2), !1).pipe(map((validationStatus) => ({
    ...validationStatus,
    hasError: validationStatus.validation.some((marker) => isValidationErrorMarker(marker))
  }))))), processDocument = (id2) => {
    const ctx = {
      observeDocumentPairAvailability: documentPreviewStore.unstable_observeDocumentPairAvailability,
      i18n,
      getClient: getClient2,
      schema: schema2,
      currentUser
    }, document$ = documentPreviewStore.unstable_observeDocument(id2, {
      apiVersion: RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion
    }).pipe(filter(Boolean), switchMap((doc) => documentPreviewStore.unstable_observeDocumentPairAvailability(id2).pipe(map((availability) => ({
      ...doc,
      publishedDocumentExists: availability.published.available
    }))))), validation$ = document$.pipe(switchMap((document2) => createValidationObservable(ctx, document2)));
    return combineLatest([document$, validation$]).pipe(map(([document2, validation2]) => ({
      document: document2,
      validation: validation2,
      memoKey: uuid()
    })));
  }, processDocumentIdsGroup = (documentIdsGroup, groupIndex) => {
    const batchDelay = groupIndex === 0 ? 0 : 100;
    return of(documentIdsGroup).pipe(delay(batchDelay), mergeMapArray((id2) => processDocument(id2)));
  };
  return documentPreviewStore.unstable_observeDocumentIdSet(groqFilter, {
    releaseId
  }, {
    apiVersion: RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion
  }).pipe(map((state) => state.documentIds || []), switchMap((documentIds) => {
    if (documentIds.length === 0)
      return of([]);
    const batchSize = 5, documentIdsGroups = [];
    for (let i = 0; i < documentIds.length; i += batchSize)
      documentIdsGroups.push(documentIds.slice(i, i + batchSize));
    return combineLatest(documentIdsGroups.map((batch, batchIndex) => (
      // The delay is used to control the rate of the requests
      // It increases as it goes on as to allow for some space (in the miliseconds scale)
      // This means that technically one might expect it to take longer to get all the results, but
      // It makes the user experience better as it is not overwhelming the main thread
      // And it allows for the browser to more easily handle the requests
      processDocumentIdsGroup(batch, batchIndex).pipe(delay(batchIndex * 100))
    ))).pipe(
      // Flatten all batch results into a single array
      // This is done to avoid having to nest the results and keep the strutcture as it was before
      map((groupResults) => groupResults.flat())
    );
  }), map((results) => ({
    loading: !1,
    results,
    error: null
  })), catchError((error) => of({
    loading: !1,
    results: [],
    error
  })));
}, getPublishedArchivedReleaseDocumentsObservable = ({
  getClient: getClient2,
  release
}) => {
  const client = getClient2(RELEASES_STUDIO_CLIENT_OPTIONS), observableClient = client.observable, dataset = client.config().dataset;
  if (!release.finalDocumentStates?.length) return of({
    loading: !1,
    results: [],
    error: null
  });
  function batchRequestDocumentFromHistory(startIndex) {
    const finalIndex = startIndex + 10;
    return observableClient.request({
      url: `/data/history/${dataset}/documents/${release.finalDocumentStates?.slice(startIndex, finalIndex).map((d) => d.id).join(",")}?lastRevision=true`
    }).pipe(map(({
      documents
    }) => ({
      documents,
      finalIndex
    })));
  }
  return batchRequestDocumentFromHistory(0).pipe(expand$1((response) => release.finalDocumentStates && response.finalIndex < release.finalDocumentStates.length ? batchRequestDocumentFromHistory(response.finalIndex) : of()), reduce$2((documents, batch) => documents.concat(batch.documents), [])).pipe(map((documents) => ({
    loading: !1,
    results: documents.map((document2) => ({
      document: document2,
      memoKey: uuid(),
      validation: {
        validation: [],
        hasError: !1,
        isValidating: !1
      }
    })),
    error: null
  })), catchError((error) => of({
    loading: !1,
    results: [],
    error
  })));
}, getReleaseDocumentsObservable = ({
  schema: schema2,
  documentPreviewStore,
  getClient: getClient2,
  releaseId,
  i18n,
  releasesState$,
  currentUser
}) => (bundleDocumentsCache[releaseId] || (bundleDocumentsCache[releaseId] = releasesState$.pipe(
  map((releasesState) => releasesState.releases.get(getReleaseDocumentIdFromReleaseId(releaseId))),
  filter(Boolean),
  // Removes falsey values
  distinctUntilChanged((prev, next) => prev.state === next.state && prev.finalDocumentStates === next.finalDocumentStates),
  switchMap((release) => {
    const cacheKey = [releaseId, release.state, release.finalDocumentStates?.flatMap((doc) => doc.id), release._rev].join("-");
    if (!bundleDocumentsCache[cacheKey]) {
      let observable;
      release.state === "published" || release.state === "archived" ? observable = getPublishedArchivedReleaseDocumentsObservable({
        getClient: getClient2,
        release
      }) : observable = getActiveReleaseDocumentsObservable({
        schema: schema2,
        documentPreviewStore,
        i18n,
        getClient: getClient2,
        releaseId,
        currentUser
      }), bundleDocumentsCache[cacheKey] = observable.pipe(finalize$1(() => {
        delete bundleDocumentsCache[cacheKey];
      }), shareReplay(1));
    }
    return bundleDocumentsCache[cacheKey];
  }),
  startWith({
    loading: !0,
    results: [],
    error: null
  }),
  shareReplay(1)
)), bundleDocumentsCache[releaseId]);
function useBundleDocuments(releaseId) {
  const $ = c(9), documentPreviewStore = useDocumentPreviewStore(), {
    getClient: getClient2,
    i18n,
    currentUser
  } = useSource(), schema2 = useSchema(), {
    state$: releasesState$
  } = useReleasesStore();
  let t0;
  $[0] !== currentUser || $[1] !== documentPreviewStore || $[2] !== getClient2 || $[3] !== i18n || $[4] !== releaseId || $[5] !== releasesState$ || $[6] !== schema2 ? (t0 = getReleaseDocumentsObservable({
    schema: schema2,
    documentPreviewStore,
    getClient: getClient2,
    releaseId,
    i18n,
    releasesState$,
    currentUser
  }), $[0] = currentUser, $[1] = documentPreviewStore, $[2] = getClient2, $[3] = i18n, $[4] = releaseId, $[5] = releasesState$, $[6] = schema2, $[7] = t0) : t0 = $[7];
  const releaseDocumentsObservable = t0;
  let t1;
  return $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    loading: !0,
    results: [],
    error: null
  }, $[8] = t1) : t1 = $[8], useObservable(releaseDocumentsObservable, t1);
}
const MotionCard$1 = motion.create(Card);
function ReleaseDetail() {
  const $ = c(58), router = useRouter(), [inspector, setInspector] = useState(void 0), {
    t
  } = useTranslation(releasesLocaleNamespace), {
    releaseId: releaseIdRaw
  } = router.state, releaseId = decodeURIComponent(releaseIdRaw || ""), {
    data,
    loading
  } = useActiveReleases(), {
    data: archivedReleases
  } = useArchivedReleases(), {
    loading: documentsLoading,
    results,
    error: bundleDocumentsError
  } = useBundleDocuments(releaseId), releaseEvents = useReleaseEvents(releaseId);
  let t0;
  if ($[0] !== archivedReleases || $[1] !== data || $[2] !== releaseId) {
    let t12;
    $[4] !== releaseId ? (t12 = (candidate) => getReleaseIdFromReleaseDocumentId(candidate._id) === releaseId, $[4] = releaseId, $[5] = t12) : t12 = $[5], t0 = data.concat(archivedReleases).find(t12), $[0] = archivedReleases, $[1] = data, $[2] = releaseId, $[3] = t0;
  } else
    t0 = $[3];
  const releaseInDetail = t0, isNotFound = !loading && !releaseInDetail;
  let t1, t2;
  $[6] !== isNotFound || $[7] !== router ? (t1 = () => {
    isNotFound && router.navigate({
      _searchParams: [[RELEASE_NOT_FOUND_SEARCH_PARAM_KEY, "true"]]
    });
  }, t2 = [isNotFound, router], $[6] = isNotFound, $[7] = router, $[8] = t1, $[9] = t2) : (t1 = $[8], t2 = $[9]), useEffect(t1, t2);
  let t3;
  bb0: {
    if (bundleDocumentsError) {
      let t42, t5;
      $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = {
        opacity: 0
      }, t5 = {
        opacity: 1
      }, $[10] = t42, $[11] = t5) : (t42 = $[10], t5 = $[11]);
      let t6;
      $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[12] = t6) : t6 = $[12];
      let t7;
      $[13] !== t ? (t7 = t("loading-release-documents.error.title"), $[13] = t, $[14] = t7) : t7 = $[14];
      let t8;
      $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t7 }), $[15] = t7, $[16] = t8) : t8 = $[16];
      let t9;
      $[17] !== t ? (t9 = t("loading-release-documents.error.description"), $[17] = t, $[18] = t9) : t9 = $[18];
      let t10;
      $[19] !== t9 ? (t10 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t9 }), $[19] = t9, $[20] = t10) : t10 = $[20];
      let t11;
      $[21] !== t10 || $[22] !== t8 ? (t11 = /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(MotionCard$1, { initial: t42, animate: t5, tone: "critical", padding: 4, radius: 4, children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
        t6,
        /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
          t8,
          t10
        ] })
      ] }) }) }), $[21] = t10, $[22] = t8, $[23] = t11) : t11 = $[23], t3 = t11;
      break bb0;
    }
    if (!releaseInDetail) {
      t3 = null;
      break bb0;
    }
    let t4;
    $[24] !== documentsLoading || $[25] !== releaseInDetail || $[26] !== results ? (t4 = /* @__PURE__ */ jsx(ReleaseSummary, { isLoading: documentsLoading, documents: results, release: releaseInDetail }), $[24] = documentsLoading, $[25] = releaseInDetail, $[26] = results, $[27] = t4) : t4 = $[27], t3 = t4;
  }
  const detailContent = t3;
  if (loading) {
    let t4;
    $[28] !== t ? (t4 = t("loading-release"), $[28] = t, $[29] = t4) : t4 = $[29];
    let t5;
    return $[30] !== t4 ? (t5 = /* @__PURE__ */ jsx(LoadingBlock, { title: t4, fill: !0, "data-testid": "release-documents-table-loader" }), $[30] = t4, $[31] = t5) : t5 = $[31], t5;
  }
  if (releaseInDetail) {
    let t4;
    $[32] !== inspector || $[33] !== releaseInDetail ? (t4 = /* @__PURE__ */ jsx(Card, { flex: "none", padding: 3, children: /* @__PURE__ */ jsx(ReleaseDashboardHeader, { release: releaseInDetail, inspector, setInspector }) }), $[32] = inspector, $[33] = releaseInDetail, $[34] = t4) : t4 = $[34];
    let t5;
    $[35] !== releaseInDetail || $[36] !== results ? (t5 = /* @__PURE__ */ jsx(ReleaseDashboardDetails, { release: releaseInDetail, documents: results }), $[35] = releaseInDetail, $[36] = results, $[37] = t5) : t5 = $[37];
    let t6;
    $[38] !== detailContent || $[39] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Card, { flex: 1, overflow: "auto", children: [
      t5,
      detailContent
    ] }), $[38] = detailContent, $[39] = t5, $[40] = t6) : t6 = $[40];
    let t7;
    $[41] !== releaseEvents.events || $[42] !== releaseInDetail || $[43] !== results ? (t7 = /* @__PURE__ */ jsx(ReleaseDashboardFooter, { documents: results, release: releaseInDetail, events: releaseEvents.events }), $[41] = releaseEvents.events, $[42] = releaseInDetail, $[43] = results, $[44] = t7) : t7 = $[44];
    let t8;
    $[45] !== t6 || $[46] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, height: "fill", children: [
      t6,
      t7
    ] }), $[45] = t6, $[46] = t7, $[47] = t8) : t8 = $[47];
    const t9 = inspector === "activity";
    let t10;
    $[48] !== releaseEvents || $[49] !== releaseInDetail || $[50] !== t9 ? (t10 = /* @__PURE__ */ jsx(ReleaseDashboardActivityPanel, { events: releaseEvents, release: releaseInDetail, show: t9 }), $[48] = releaseEvents, $[49] = releaseInDetail, $[50] = t9, $[51] = t10) : t10 = $[51];
    let t11;
    $[52] !== t10 || $[53] !== t8 ? (t11 = /* @__PURE__ */ jsxs(Flex, { flex: 1, children: [
      t8,
      t10
    ] }), $[52] = t10, $[53] = t8, $[54] = t11) : t11 = $[54];
    let t12;
    return $[55] !== t11 || $[56] !== t4 ? (t12 = /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, height: "fill", overflow: "hidden", children: [
      t4,
      t11
    ] }), $[55] = t11, $[56] = t4, $[57] = t12) : t12 = $[57], t12;
  }
  return null;
}
function CalendarDay$3(props2) {
  const $ = c(33), {
    date,
    focused,
    isCurrentMonth,
    isToday: isToday2,
    onSelect,
    selected,
    disabled,
    dateStyles: t0
  } = props2;
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const dateStyles = t1;
  let t2;
  $[2] !== date || $[3] !== onSelect || $[4] !== selected ? (t2 = () => {
    onSelect(selected ? void 0 : date);
  }, $[2] = date, $[3] = onSelect, $[4] = selected, $[5] = t2) : t2 = $[5];
  const handleClick = t2;
  let tone;
  isToday2 || selected ? tone = "primary" : (isWeekend(date), tone = "default");
  let t3;
  $[6] !== date ? (t3 = date.toDateString(), $[6] = date, $[7] = t3) : t3 = $[7];
  const t4 = focused ? "true" : "";
  let t5;
  $[8] !== date || $[9] !== isToday2 ? (t5 = isToday2 ? "day-tile-today" : `day-tile-${date.getDate()}-${date.getMonth()}`, $[8] = date, $[9] = isToday2, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    position: "relative"
  }, $[11] = t6) : t6 = $[11];
  const t7 = !selected && !isCurrentMonth ? 0.35 : 1;
  let t8;
  $[12] !== dateStyles || $[13] !== t7 ? (t8 = {
    opacity: t7,
    textAlign: "center",
    ...dateStyles
  }, $[12] = dateStyles, $[13] = t7, $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== date || $[16] !== selected ? (t9 = selected ? /* @__PURE__ */ jsx(CloseIcon, {}) : date.getDate(), $[15] = date, $[16] = selected, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== t8 || $[19] !== t9 ? (t10 = /* @__PURE__ */ jsx(Text$1, { size: 1, style: t8, children: t9 }), $[18] = t8, $[19] = t9, $[20] = t10) : t10 = $[20];
  let t11;
  $[21] !== disabled || $[22] !== handleClick || $[23] !== selected || $[24] !== t10 || $[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== tone ? (t11 = /* @__PURE__ */ jsx(Card, { "aria-label": t3, "aria-pressed": selected, as: "button", __unstable_focusRing: !0, "data-weekday": !0, "data-focused": t4, "data-testid": t5, role: "button", tabIndex: -1, onClick: handleClick, paddingX: 3, paddingY: 4, radius: 2, selected, style: t6, tone, disabled, children: t10 }), $[21] = disabled, $[22] = handleClick, $[23] = selected, $[24] = t10, $[25] = t3, $[26] = t4, $[27] = t5, $[28] = tone, $[29] = t11) : t11 = $[29];
  let t12;
  return $[30] !== selected || $[31] !== t11 ? (t12 = /* @__PURE__ */ jsx("div", { "aria-selected": selected, "data-ui": "CalendarDay", children: t11 }), $[30] = selected, $[31] = t11, $[32] = t12) : t12 = $[32], t12;
}
function CalendarMonth$2(props2) {
  const $ = c(24), {
    date,
    renderCalendarDay,
    hidden,
    disabled,
    timeZoneScope
  } = props2, {
    getCurrentZoneDate
  } = useTimeZone(timeZoneScope), CalendarDay2 = renderCalendarDay || CalendarDay$3, weeksOfMonth = useWeeksOfMonth$1(date), t0 = hidden || !1;
  let t1, t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    gridGap: "1px",
    gridTemplateColumns: "repeat(7, 1fr)"
  }, t2 = DEFAULT_WEEK_DAY_NAMES.map(_temp$1M), $[0] = t1, $[1] = t2) : (t1 = $[0], t2 = $[1]);
  let t3;
  if ($[2] !== CalendarDay2 || $[3] !== date || $[4] !== disabled || $[5] !== getCurrentZoneDate || $[6] !== props2.focused || $[7] !== props2.onSelect || $[8] !== props2.selected || $[9] !== weeksOfMonth) {
    let t42;
    $[11] !== CalendarDay2 || $[12] !== date || $[13] !== disabled || $[14] !== getCurrentZoneDate || $[15] !== props2.focused || $[16] !== props2.onSelect || $[17] !== props2.selected ? (t42 = (week, weekIdx) => week.days.map((dayDate, dayIdx) => {
      const focused = props2.focused && isSameDay(dayDate, props2.focused), selected = props2.selected && isSameDay(dayDate, props2.selected), isToday2 = isSameDay(dayDate, getCurrentZoneDate()), isCurrentMonth = isSameMonth(dayDate, props2.focused || date);
      return /* @__PURE__ */ jsx(CalendarDay2, { date: dayDate, focused, isCurrentMonth, isToday: isToday2, onSelect: props2.onSelect, selected, disabled }, `${weekIdx}-${dayIdx}`);
    }), $[11] = CalendarDay2, $[12] = date, $[13] = disabled, $[14] = getCurrentZoneDate, $[15] = props2.focused, $[16] = props2.onSelect, $[17] = props2.selected, $[18] = t42) : t42 = $[18], t3 = weeksOfMonth.map(t42), $[2] = CalendarDay2, $[3] = date, $[4] = disabled, $[5] = getCurrentZoneDate, $[6] = props2.focused, $[7] = props2.onSelect, $[8] = props2.selected, $[9] = weeksOfMonth, $[10] = t3;
  } else
    t3 = $[10];
  let t4;
  $[19] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Grid, { style: t1, children: [
    t2,
    t3
  ] }), $[19] = t3, $[20] = t4) : t4 = $[20];
  let t5;
  return $[21] !== t0 || $[22] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { "aria-hidden": t0, "data-ui": "CalendarMonth", children: t4 }), $[21] = t0, $[22] = t4, $[23] = t5) : t5 = $[23], t5;
}
function _temp$1M(weekday) {
  return /* @__PURE__ */ jsx(Card, { paddingY: 3, children: /* @__PURE__ */ jsx(Label, { size: 1, style: {
    textAlign: "center"
  }, children: weekday.slice(0, 1) }) }, weekday);
}
const PRESERVE_FOCUS_ELEMENT$2 = /* @__PURE__ */ jsx("span", { "data-preserve-focus": !0, style: {
  overflow: "hidden",
  position: "absolute",
  outline: "none"
}, tabIndex: -1 }), CalendarFilter = forwardRef(function(props2, forwardedRef) {
  const $ = c(86);
  let handleOnFocusedDateChange, onSelect, providedFocusedDate, renderCalendarDay, restProps, selectedDate, timeZoneScope;
  $[0] !== props2 ? ({
    focusedDate: providedFocusedDate,
    onFocusedDateChange: handleOnFocusedDateChange,
    onSelect,
    selectedDate,
    renderCalendarDay,
    timeZoneScope,
    ...restProps
  } = props2, $[0] = props2, $[1] = handleOnFocusedDateChange, $[2] = onSelect, $[3] = providedFocusedDate, $[4] = renderCalendarDay, $[5] = restProps, $[6] = selectedDate, $[7] = timeZoneScope) : (handleOnFocusedDateChange = $[1], onSelect = $[2], providedFocusedDate = $[3], renderCalendarDay = $[4], restProps = $[5], selectedDate = $[6], timeZoneScope = $[7]);
  let t0;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ new Date(), $[8] = t0) : t0 = $[8];
  const [_focusedDate, _setFocusedDate] = useState(t0), {
    t: tCore
  } = useTranslation(), {
    zoneDateToUtc
  } = useTimeZone(timeZoneScope), focusedDate = providedFocusedDate || _focusedDate;
  let t1;
  $[9] !== handleOnFocusedDateChange || $[10] !== providedFocusedDate ? (t1 = (date) => {
    handleOnFocusedDateChange && providedFocusedDate ? handleOnFocusedDateChange(date) : _setFocusedDate(date);
  }, $[9] = handleOnFocusedDateChange, $[10] = providedFocusedDate, $[11] = t1) : t1 = $[11];
  const onFocusedDateChange = t1;
  let t2;
  $[12] !== onFocusedDateChange || $[13] !== zoneDateToUtc ? (t2 = (date_0) => {
    onFocusedDateChange(zoneDateToUtc(date_0));
  }, $[12] = onFocusedDateChange, $[13] = zoneDateToUtc, $[14] = t2) : t2 = $[14];
  const setFocusedDate = t2;
  let t3;
  $[15] !== focusedDate || $[16] !== setFocusedDate ? (t3 = (by) => setFocusedDate(addMonths(focusedDate, by)), $[15] = focusedDate, $[16] = setFocusedDate, $[17] = t3) : t3 = $[17];
  const moveFocusedDate = t3;
  let t4;
  $[18] !== onFocusedDateChange || $[19] !== onSelect || $[20] !== zoneDateToUtc ? (t4 = (date_1) => {
    if (date_1) {
      const targetDate = zoneDateToUtc(setMinutes(setHours(date_1, date_1.getHours()), date_1.getMinutes()));
      onSelect(targetDate), onFocusedDateChange(targetDate);
    } else
      onSelect(void 0);
  }, $[18] = onFocusedDateChange, $[19] = onSelect, $[20] = zoneDateToUtc, $[21] = t4) : t4 = $[21];
  const handleDateChange = t4, ref = useRef(null);
  let t5;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => ref.current, $[22] = t5) : t5 = $[22], useImperativeHandle(forwardedRef, t5);
  let t6;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    ref.current?.querySelector('[data-focused="true"]')?.focus();
  }, $[23] = t6) : t6 = $[23];
  const focusCurrentWeekDay = t6;
  let t7;
  $[24] !== focusedDate || $[25] !== onFocusedDateChange || $[26] !== zoneDateToUtc ? (t7 = (event) => {
    if (ARROW_KEYS$2.includes(event.key)) {
      if (event.preventDefault(), event.currentTarget.hasAttribute("data-calendar-grid")) {
        focusCurrentWeekDay();
        return;
      }
      event.key === "ArrowUp" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, -7))), event.key === "ArrowDown" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, 7))), event.key === "ArrowLeft" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, -1))), event.key === "ArrowRight" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, 1))), ref.current?.querySelector("[data-preserve-focus]")?.focus();
    }
  }, $[24] = focusedDate, $[25] = onFocusedDateChange, $[26] = zoneDateToUtc, $[27] = t7) : t7 = $[27];
  const handleKeyDown = t7;
  let t8, t9;
  $[28] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = () => {
    focusCurrentWeekDay();
  }, t9 = [focusCurrentWeekDay], $[28] = t8, $[29] = t9) : (t8 = $[28], t9 = $[29]), useEffect(t8, t9);
  let t10;
  $[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    document.activeElement?.matches("[data-calendar-grid], [data-calendar-grid] [data-preserve-focus]") && focusCurrentWeekDay();
  }, $[30] = t10) : t10 = $[30];
  let t11;
  $[31] !== focusedDate ? (t11 = [ref, focusCurrentWeekDay, focusedDate], $[31] = focusedDate, $[32] = t11) : t11 = $[32], useEffect(t10, t11);
  let t12;
  $[33] !== onFocusedDateChange || $[34] !== onSelect ? (t12 = () => {
    const now = /* @__PURE__ */ new Date();
    onSelect(now), onFocusedDateChange(now);
  }, $[33] = onFocusedDateChange, $[34] = onSelect, $[35] = t12) : t12 = $[35];
  const handleNowClick = t12;
  let t13;
  $[36] !== moveFocusedDate ? (t13 = () => moveFocusedDate(-1), $[36] = moveFocusedDate, $[37] = t13) : t13 = $[37];
  const handlePrevMonthClick = t13;
  let t14;
  $[38] !== moveFocusedDate ? (t14 = () => moveFocusedDate(1), $[38] = moveFocusedDate, $[39] = t14) : t14 = $[39];
  const handleNextMonthClick = t14;
  let t15;
  $[40] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = {
    borderBottom: "1px solid var(--card-border-color)",
    minHeight: "55px",
    position: "sticky",
    top: 0
  }, $[40] = t15) : t15 = $[40];
  const t16 = DEFAULT_MONTH_NAMES[focusedDate?.getMonth()];
  let t17;
  $[41] !== focusedDate ? (t17 = focusedDate?.getFullYear(), $[41] = focusedDate, $[42] = t17) : t17 = $[42];
  let t18;
  $[43] !== t16 || $[44] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Text$1, { weight: "medium", size: 1, children: [
    t16,
    " ",
    t17
  ] }), $[43] = t16, $[44] = t17, $[45] = t18) : t18 = $[45];
  let t19;
  $[46] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t19 = {
    content: "Previous month"
  }, $[46] = t19) : t19 = $[46];
  let t20;
  $[47] !== handlePrevMonthClick || $[48] !== restProps.disabled ? (t20 = /* @__PURE__ */ jsx(Button, { icon: ChevronLeftIcon, mode: "bleed", onClick: handlePrevMonthClick, tooltipProps: t19, disabled: restProps.disabled }), $[47] = handlePrevMonthClick, $[48] = restProps.disabled, $[49] = t20) : t20 = $[49];
  let t21;
  $[50] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t21 = {
    content: "Next month"
  }, $[50] = t21) : t21 = $[50];
  let t22;
  $[51] !== handleNextMonthClick || $[52] !== restProps.disabled ? (t22 = /* @__PURE__ */ jsx(Button, { icon: ChevronRightIcon, mode: "bleed", onClick: handleNextMonthClick, tooltipProps: t21, disabled: restProps.disabled }), $[51] = handleNextMonthClick, $[52] = restProps.disabled, $[53] = t22) : t22 = $[53];
  let t23;
  $[54] !== t20 || $[55] !== t22 ? (t23 = /* @__PURE__ */ jsx(Flex, { paddingRight: 3, gap: 2, children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
    t20,
    t22
  ] }) }), $[54] = t20, $[55] = t22, $[56] = t23) : t23 = $[56];
  let t24;
  $[57] !== t18 || $[58] !== t23 ? (t24 = /* @__PURE__ */ jsx(Flex, { align: "center", paddingLeft: 4, style: t15, children: /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, justify: "space-between", children: [
    t18,
    t23
  ] }) }), $[57] = t18, $[58] = t23, $[59] = t24) : t24 = $[59];
  let t25;
  $[60] !== focusedDate || $[61] !== handleDateChange || $[62] !== providedFocusedDate || $[63] !== renderCalendarDay || $[64] !== restProps.disabled || $[65] !== selectedDate || $[66] !== timeZoneScope ? (t25 = /* @__PURE__ */ jsx(CalendarMonth$2, { date: focusedDate, focused: providedFocusedDate, onSelect: handleDateChange, selected: selectedDate, renderCalendarDay, disabled: restProps.disabled, timeZoneScope }), $[60] = focusedDate, $[61] = handleDateChange, $[62] = providedFocusedDate, $[63] = renderCalendarDay, $[64] = restProps.disabled, $[65] = selectedDate, $[66] = timeZoneScope, $[67] = t25) : t25 = $[67];
  let t26;
  $[68] !== handleKeyDown || $[69] !== t25 ? (t26 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Box, { "data-calendar-grid": !0, onKeyDown: handleKeyDown, overflow: "hidden", paddingBottom: 1, paddingX: 1, tabIndex: 0, children: [
    t25,
    PRESERVE_FOCUS_ELEMENT$2
  ] }) }), $[68] = handleKeyDown, $[69] = t25, $[70] = t26) : t26 = $[70];
  let t27;
  $[71] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t27 = {
    borderBottom: "1px solid var(--card-border-color)"
  }, $[71] = t27) : t27 = $[71];
  const t28 = restProps.disabled;
  let t29;
  $[72] !== tCore ? (t29 = tCore("calendar.action.go-to-today-aria-label"), $[72] = tCore, $[73] = t29) : t29 = $[73];
  let t30;
  $[74] !== tCore ? (t30 = tCore("calendar.action.go-to-today"), $[74] = tCore, $[75] = t30) : t30 = $[75];
  let t31;
  $[76] !== handleNowClick || $[77] !== restProps.disabled || $[78] !== t29 || $[79] !== t30 ? (t31 = /* @__PURE__ */ jsx(Box, { flex: 1, style: t27, children: /* @__PURE__ */ jsx(Button, { disabled: t28, mode: "bleed", onClick: handleNowClick, width: "fill", "aria-label": t29, text: t30 }) }), $[76] = handleNowClick, $[77] = restProps.disabled, $[78] = t29, $[79] = t30, $[80] = t31) : t31 = $[80];
  let t32;
  return $[81] !== restProps || $[82] !== t24 || $[83] !== t26 || $[84] !== t31 ? (t32 = /* @__PURE__ */ jsxs(Box, { "data-ui": "Calendar", ...restProps, ref, children: [
    t24,
    t26,
    t31
  ] }), $[81] = restProps, $[82] = t24, $[83] = t26, $[84] = t31, $[85] = t32) : t32 = $[85], t32;
});
function useScheduledDraftsEnabled() {
  return !!useSource().scheduledDrafts?.enabled;
}
function SingleDocReleaseEnabledProvider(t0) {
  const $ = c(6), {
    children
  } = t0, {
    enabled: featureEnabled,
    isLoading,
    error
  } = useFeatureEnabled(FEATURES.singleDocRelease), isWorkspaceEnabled = useScheduledDraftsEnabled();
  let t1;
  bb0: {
    if (!isWorkspaceEnabled || isLoading || error) {
      let t23;
      $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t23 = {
        enabled: !1,
        mode: null
      }, $[0] = t23) : t23 = $[0], t1 = t23;
      break bb0;
    }
    const t22 = featureEnabled ? "default" : "upsell";
    let t3;
    $[1] !== t22 ? (t3 = {
      enabled: !0,
      mode: t22
    }, $[1] = t22, $[2] = t3) : t3 = $[2], t1 = t3;
  }
  const value = t1;
  let t2;
  return $[3] !== children || $[4] !== value ? (t2 = /* @__PURE__ */ jsx(SingleDocReleaseEnabledContext.Provider, { value, children }), $[3] = children, $[4] = value, $[5] = t2) : t2 = $[5], t2;
}
function useSingleDocReleaseEnabled() {
  return useContext(SingleDocReleaseEnabledContext);
}
const useCreateReleaseMetadata = () => {
  const $ = c(2), {
    zoneDateToUtc
  } = useTimeZone(CONTENT_RELEASES_TIME_ZONE_SCOPE);
  let t0;
  return $[0] !== zoneDateToUtc ? (t0 = (release) => {
    const {
      metadata
    } = release, intendedPublishAt = metadata.intendedPublishAt ? zoneDateToUtc(new Date(metadata.intendedPublishAt)).toISOString() : void 0;
    return {
      ...release,
      metadata: {
        ...metadata,
        intendedPublishAt,
        title: metadata?.title?.trim()
      }
    };
  }, $[0] = zoneDateToUtc, $[1] = t0) : t0 = $[1], t0;
};
function useGuardWithReleaseLimitUpsell() {
  const $ = c(7), [isPendingGuardResponse, setIsPendingGuardResponse] = useState(!0), [releasePromise, setReleasePromise] = useState(null), {
    guardWithReleaseLimitUpsell
  } = useReleasesUpsell();
  let t0;
  $[0] !== guardWithReleaseLimitUpsell ? (t0 = () => {
    setIsPendingGuardResponse(!0);
    const promise = new Promise((resolve) => {
      guardWithReleaseLimitUpsell(noop$7, !1, (hasPassed) => {
        resolve(hasPassed);
      });
    });
    setReleasePromise(promise);
  }, $[0] = guardWithReleaseLimitUpsell, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== guardWithReleaseLimitUpsell || $[3] !== isPendingGuardResponse ? (t1 = [guardWithReleaseLimitUpsell, isPendingGuardResponse], $[2] = guardWithReleaseLimitUpsell, $[3] = isPendingGuardResponse, $[4] = t1) : t1 = $[4], useEffect(t0, t1);
  let t2;
  return $[5] !== releasePromise ? (t2 = {
    releasePromise
  }, $[5] = releasePromise, $[6] = t2) : t2 = $[6], t2;
}
function getIsReleaseInvalid(release) {
  return release.metadata?.releaseType === "scheduled" && !release.metadata?.intendedPublishAt;
}
function CreateReleaseDialog(props2) {
  const $ = c(38), {
    onCancel,
    onSubmit,
    origin
  } = props2, toast = useToast(), {
    createRelease
  } = useReleaseOperations(), setPerspective = useSetPerspective(), {
    t
  } = useTranslation(), telemetry = useTelemetry(), createReleaseMetadata = useCreateReleaseMetadata(), {
    clearReleaseDataFromStorage
  } = useReleaseFormStorage(), [release, setRelease] = useState(getReleaseDefaults), [isSubmitting, setIsSubmitting] = useState(!1);
  let t0;
  $[0] !== release ? (t0 = getIsReleaseInvalid(release), $[0] = release, $[1] = t0) : t0 = $[1];
  const invalid = t0, {
    releasePromise
  } = useGuardWithReleaseLimitUpsell();
  let t1;
  $[2] !== clearReleaseDataFromStorage || $[3] !== createRelease || $[4] !== createReleaseMetadata || $[5] !== onCancel || $[6] !== onSubmit || $[7] !== origin || $[8] !== release || $[9] !== releasePromise || $[10] !== setPerspective || $[11] !== t || $[12] !== telemetry || $[13] !== toast ? (t1 = async (event) => {
    if (event.preventDefault(), setIsSubmitting(!0), !await releasePromise) {
      setIsSubmitting(!1);
      return;
    }
    try {
      const releaseValue = createReleaseMetadata(release);
      await createRelease(releaseValue), onCancel(), telemetry.log(CreatedRelease, {
        origin
      }), await new Promise(_temp$1L), setPerspective(getReleaseIdFromReleaseDocumentId(release._id)), onSubmit(getReleaseIdFromReleaseDocumentId(release._id));
    } catch (t22) {
      const err = t22;
      isReleaseLimitError(err) ? (onCancel(), clearReleaseDataFromStorage()) : (console.error(err), toast.push({
        closable: !0,
        status: "error",
        title: t("release.toast.create-release-error.title")
      }));
    }
    setIsSubmitting(!1), clearReleaseDataFromStorage();
  }, $[2] = clearReleaseDataFromStorage, $[3] = createRelease, $[4] = createReleaseMetadata, $[5] = onCancel, $[6] = onSubmit, $[7] = origin, $[8] = release, $[9] = releasePromise, $[10] = setPerspective, $[11] = t, $[12] = telemetry, $[13] = toast, $[14] = t1) : t1 = $[14];
  const handleOnSubmit = t1;
  let t2;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (releaseMetadata) => {
    setRelease(releaseMetadata);
  }, $[15] = t2) : t2 = $[15];
  const handleOnChange = t2;
  let t3;
  $[16] !== t ? (t3 = t("release.dialog.create.title"), $[16] = t, $[17] = t3) : t3 = $[17];
  const dialogTitle = t3;
  let t4;
  $[18] !== t ? (t4 = t("release.dialog.create.confirm"), $[18] = t, $[19] = t4) : t4 = $[19];
  const dialogConfirm = t4;
  let t5;
  $[20] !== clearReleaseDataFromStorage || $[21] !== onCancel ? (t5 = () => {
    clearReleaseDataFromStorage(), onCancel();
  }, $[20] = clearReleaseDataFromStorage, $[21] = onCancel, $[22] = t5) : t5 = $[22];
  const handleOnClose = t5;
  let t6;
  $[23] !== release ? (t6 = /* @__PURE__ */ jsx(Box, { paddingBottom: 4, children: /* @__PURE__ */ jsx(ReleaseForm, { onChange: handleOnChange, value: release }) }), $[23] = release, $[24] = t6) : t6 = $[24];
  const t7 = isSubmitting || invalid;
  let t8;
  $[25] !== dialogConfirm || $[26] !== isSubmitting || $[27] !== t7 ? (t8 = /* @__PURE__ */ jsx(Flex, { justify: "flex-end", paddingTop: 5, children: /* @__PURE__ */ jsx(Button, { size: "large", disabled: t7, type: "submit", text: dialogConfirm, loading: isSubmitting, "data-testid": "submit-release-button" }) }), $[25] = dialogConfirm, $[26] = isSubmitting, $[27] = t7, $[28] = t8) : t8 = $[28];
  let t9;
  $[29] !== handleOnSubmit || $[30] !== t6 || $[31] !== t8 ? (t9 = /* @__PURE__ */ jsx(Card, { padding: 4, borderTop: !0, children: /* @__PURE__ */ jsxs("form", { onSubmit: handleOnSubmit, children: [
    t6,
    t8
  ] }) }), $[29] = handleOnSubmit, $[30] = t6, $[31] = t8, $[32] = t9) : t9 = $[32];
  let t10;
  return $[33] !== dialogTitle || $[34] !== handleOnClose || $[35] !== onCancel || $[36] !== t9 ? (t10 = /* @__PURE__ */ jsx(Dialog$1, { onClickOutside: onCancel, header: dialogTitle, id: "create-release-dialog", onClose: handleOnClose, width: 1, padding: !1, children: t9 }), $[33] = dialogTitle, $[34] = handleOnClose, $[35] = onCancel, $[36] = t9, $[37] = t10) : t10 = $[37], t10;
}
function _temp$1L(resolve) {
  return setTimeout(resolve, 1e3);
}
const useReleasesMetadata = (releaseIds) => {
  const $ = c(14), {
    addReleaseIdsToListener: addBundleIdsToListener,
    removeReleaseIdsFromListener: removeBundleIdsFromListener,
    state
  } = useReleasesMetadataProvider();
  let t0, t1;
  $[0] !== addBundleIdsToListener || $[1] !== releaseIds || $[2] !== removeBundleIdsFromListener ? (t0 = () => (releaseIds.length && addBundleIdsToListener([...new Set(releaseIds)]), () => removeBundleIdsFromListener([...new Set(releaseIds)])), t1 = [addBundleIdsToListener, releaseIds, removeBundleIdsFromListener], $[0] = addBundleIdsToListener, $[1] = releaseIds, $[2] = removeBundleIdsFromListener, $[3] = t0, $[4] = t1) : (t0 = $[3], t1 = $[4]), useEffect(t0, t1);
  const {
    data,
    loading
  } = state;
  let responseData = null;
  if (data) {
    let t3;
    if ($[5] !== data || $[6] !== releaseIds) {
      let t4;
      $[8] !== data ? (t4 = (releaseId) => [releaseId, data[releaseId]], $[8] = data, $[9] = t4) : t4 = $[9], t3 = Object.fromEntries(releaseIds.map(t4)), $[5] = data, $[6] = releaseIds, $[7] = t3;
    } else
      t3 = $[7];
    responseData = t3;
  }
  let t2;
  return $[10] !== loading || $[11] !== responseData || $[12] !== state.error ? (t2 = {
    error: state.error,
    loading,
    data: responseData
  }, $[10] = loading, $[11] = responseData, $[12] = state.error, $[13] = t2) : t2 = $[13], t2;
};
function CalendarPopover(t0) {
  const $ = c(22), {
    content,
    asDialog
  } = t0, buttonRef = useRef(null), popoverRef = useRef(null), [isCalendarOpen, setIsCalendarOpen] = useState(!1), {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t1;
  $[0] !== asDialog ? (t1 = () => {
    asDialog || setIsCalendarOpen(!1);
  }, $[0] = asDialog, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => [buttonRef.current, popoverRef.current], $[2] = t2) : t2 = $[2], useClickOutsideEvent(t1, t2);
  let t3;
  $[3] !== t ? (t3 = t("overview.calendar.tooltip"), $[3] = t, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => setIsCalendarOpen(_temp$1K), $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== isCalendarOpen ? (t5 = /* @__PURE__ */ jsx(Button$1, { name: "calendar", "data-as": "a", icon: FilterIcon$1, mode: "bleed", padding: 2, radius: "full", selected: isCalendarOpen, onClick: t4, ref: buttonRef, space: 2 }), $[6] = isCalendarOpen, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== t3 || $[9] !== t5 ? (t6 = /* @__PURE__ */ jsx(Tooltip, { content: t3, children: t5 }), $[8] = t3, $[9] = t5, $[10] = t6) : t6 = $[10];
  const triggerButton = t6;
  if (asDialog) {
    let t72;
    $[11] !== content || $[12] !== isCalendarOpen || $[13] !== t ? (t72 = isCalendarOpen && /* @__PURE__ */ jsx(Dialog$1, { id: "calendar-filter-dialog", header: t("overview.calendar.tooltip"), onClose: () => setIsCalendarOpen(!1), onClickOutside: () => setIsCalendarOpen(!1), width: 1, padding: !1, children: content }), $[11] = content, $[12] = isCalendarOpen, $[13] = t, $[14] = t72) : t72 = $[14];
    let t8;
    return $[15] !== t72 || $[16] !== triggerButton ? (t8 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
      triggerButton,
      t72
    ] }), $[15] = t72, $[16] = triggerButton, $[17] = t8) : t8 = $[17], t8;
  }
  let t7;
  return $[18] !== content || $[19] !== isCalendarOpen || $[20] !== triggerButton ? (t7 = /* @__PURE__ */ jsx(Popover, { content, placement: "bottom", open: isCalendarOpen, ref: popoverRef, children: triggerButton }), $[18] = content, $[19] = isCalendarOpen, $[20] = triggerButton, $[21] = t7) : t7 = $[21], t7;
}
function _temp$1K(prev) {
  return !prev;
}
const NavigatedToReleasesOverview = defineEvent({
  name: "Navigated to Content Releases",
  version: 1,
  description: "User navigated to the content releases list view"
}), NavigatedToScheduledDrafts = defineEvent({
  name: "Navigated to Scheduled Drafts",
  version: 1,
  description: "User navigated to the scheduled drafts list view"
}), getPickerView = ({
  hasSingleDocRelease,
  isScheduledDraftsEnabled,
  isReleasesEnabled,
  cardinalityView,
  isDraftModelEnabled
}) => isReleasesEnabled ? hasSingleDocRelease || isScheduledDraftsEnabled && isDraftModelEnabled || cardinalityView === "drafts" ? "both" : "contentReleases" : cardinalityView === "releases" ? "both" : "singleDocReleases", CardinalityViewPicker = (t0) => {
  const $ = c(46), {
    cardinalityView,
    loading,
    isScheduledDraftsEnabled,
    isReleasesEnabled,
    isDraftModelEnabled,
    allReleases,
    onCardinalityViewChange
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace), telemetry = useTelemetry();
  let t1;
  $[0] !== allReleases ? (t1 = allReleases.some(isCardinalityOneRelease), $[0] = allReleases, $[1] = t1) : t1 = $[1];
  const hasSingleDocRelease = t1;
  let t2;
  $[2] !== cardinalityView || $[3] !== hasSingleDocRelease || $[4] !== isDraftModelEnabled || $[5] !== isReleasesEnabled || $[6] !== isScheduledDraftsEnabled ? (t2 = getPickerView({
    hasSingleDocRelease,
    isScheduledDraftsEnabled,
    isReleasesEnabled,
    cardinalityView,
    isDraftModelEnabled
  }), $[2] = cardinalityView, $[3] = hasSingleDocRelease, $[4] = isDraftModelEnabled, $[5] = isReleasesEnabled, $[6] = isScheduledDraftsEnabled, $[7] = t2) : t2 = $[7];
  const pickerView = t2;
  let t3;
  $[8] !== onCardinalityViewChange || $[9] !== telemetry ? (t3 = (view) => () => {
    const telemetryEvent = view === "releases" ? NavigatedToReleasesOverview : NavigatedToScheduledDrafts;
    telemetry.log(telemetryEvent, {
      source: "view-picker"
    }), onCardinalityViewChange(view)();
  }, $[8] = onCardinalityViewChange, $[9] = telemetry, $[10] = t3) : t3 = $[10];
  const handleViewChange = t3;
  if (pickerView === "contentReleases" || pickerView === "singleDocReleases") {
    let t42;
    $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = /* @__PURE__ */ jsx(CalendarIcon, {}), $[11] = t42) : t42 = $[11];
    let t52;
    $[12] !== pickerView || $[13] !== t ? (t52 = t(pickerView === "contentReleases" ? "action.releases" : "action.drafts"), $[12] = pickerView, $[13] = t, $[14] = t52) : t52 = $[14];
    let t62;
    return $[15] !== t52 ? (t62 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
      t42,
      /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t52 })
    ] }), $[15] = t52, $[16] = t62) : t62 = $[16], t62;
  }
  let t4;
  $[17] !== cardinalityView || $[18] !== t ? (t4 = t(cardinalityView === "releases" ? "action.releases" : "action.drafts"), $[17] = cardinalityView, $[18] = t, $[19] = t4) : t4 = $[19];
  let t5;
  $[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    fontWeight: 600
  }, $[20] = t5) : t5 = $[20];
  let t6;
  $[21] !== loading || $[22] !== t4 ? (t6 = /* @__PURE__ */ jsx(Button, { mode: "bleed", paddingY: 2, text: t4, icon: CalendarIcon, iconRight: ChevronDownIcon, disabled: loading, style: t5 }), $[21] = loading, $[22] = t4, $[23] = t6) : t6 = $[23];
  let t7;
  $[24] !== t ? (t7 = t("action.releases"), $[24] = t, $[25] = t7) : t7 = $[25];
  const t8 = cardinalityView === "releases";
  let t9;
  $[26] !== handleViewChange ? (t9 = handleViewChange("releases"), $[26] = handleViewChange, $[27] = t9) : t9 = $[27];
  let t10;
  $[28] !== t7 || $[29] !== t8 || $[30] !== t9 ? (t10 = /* @__PURE__ */ jsx(MenuItem, { text: t7, selected: t8, onClick: t9 }), $[28] = t7, $[29] = t8, $[30] = t9, $[31] = t10) : t10 = $[31];
  let t11;
  $[32] !== t ? (t11 = t("action.drafts"), $[32] = t, $[33] = t11) : t11 = $[33];
  const t12 = cardinalityView === "drafts";
  let t13;
  $[34] !== handleViewChange ? (t13 = handleViewChange("drafts"), $[34] = handleViewChange, $[35] = t13) : t13 = $[35];
  let t14;
  $[36] !== t11 || $[37] !== t12 || $[38] !== t13 ? (t14 = /* @__PURE__ */ jsx(MenuItem, { text: t11, selected: t12, onClick: t13 }), $[36] = t11, $[37] = t12, $[38] = t13, $[39] = t14) : t14 = $[39];
  let t15;
  $[40] !== t10 || $[41] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Menu, { children: [
    t10,
    t14
  ] }), $[40] = t10, $[41] = t14, $[42] = t15) : t15 = $[42];
  let t16;
  return $[43] !== t15 || $[44] !== t6 ? (t16 = /* @__PURE__ */ jsx(MenuButton, { id: "cardinality-view-menu", button: t6, menu: t15 }), $[43] = t15, $[44] = t6, $[45] = t16) : t16 = $[45], t16;
};
function useScheduleActiveDrafts() {
  const $ = c(4), client = useClient(RELEASES_STUDIO_CLIENT_OPTIONS);
  let t0;
  $[0] !== client ? (t0 = async (releases2) => {
    const scheduleActions = releases2.flatMap(_temp$1J);
    await client.action(scheduleActions);
  }, $[0] = client, $[1] = t0) : t0 = $[1];
  const scheduleActiveDrafts = t0;
  let t1;
  return $[2] !== scheduleActiveDrafts ? (t1 = {
    scheduleActiveDrafts
  }, $[2] = scheduleActiveDrafts, $[3] = t1) : t1 = $[3], t1;
}
function _temp$1J(release) {
  return release.metadata.intendedPublishAt ? [{
    actionType: "sanity.action.release.schedule",
    releaseId: getReleaseIdFromReleaseDocumentId(release._id),
    publishAt: new Date(release.metadata.intendedPublishAt).toISOString()
  }] : [];
}
function ConfirmScheduledDraftsDialog(t0) {
  const $ = c(31), {
    activeScheduledDrafts,
    onClose
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace), toast = useToast(), {
    scheduleActiveDrafts
  } = useScheduleActiveDrafts(), [isScheduling, setIsScheduling] = useState(!1);
  let t1;
  $[0] !== activeScheduledDrafts ? (t1 = activeScheduledDrafts.some(_temp2$H), $[0] = activeScheduledDrafts, $[1] = t1) : t1 = $[1];
  const hasPastDates = t1;
  let t2;
  $[2] !== activeScheduledDrafts || $[3] !== onClose || $[4] !== scheduleActiveDrafts || $[5] !== t || $[6] !== toast ? (t2 = async () => {
    setIsScheduling(!0);
    try {
      await scheduleActiveDrafts(activeScheduledDrafts), onClose();
    } catch (t32) {
      const error = t32;
      toast.push({
        status: "error",
        title: t("toast.confirm-active-scheduled-drafts.error", {
          error: error.message
        })
      });
    }
    setIsScheduling(!1);
  }, $[2] = activeScheduledDrafts, $[3] = onClose, $[4] = scheduleActiveDrafts, $[5] = t, $[6] = toast, $[7] = t2) : t2 = $[7];
  const handleConfirmSchedules = t2;
  let t3;
  $[8] !== t ? (t3 = t("confirm-active-scheduled-drafts-dialog.title"), $[8] = t, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t ? (t4 = t("confirm-active-scheduled-drafts-dialog.confirm-button"), $[10] = t, $[11] = t4) : t4 = $[11];
  let t5;
  $[12] !== handleConfirmSchedules || $[13] !== isScheduling || $[14] !== t4 ? (t5 = {
    confirmButton: {
      text: t4,
      tone: "primary",
      onClick: handleConfirmSchedules,
      loading: isScheduling,
      disabled: isScheduling
    }
  }, $[12] = handleConfirmSchedules, $[13] = isScheduling, $[14] = t4, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== t ? (t6 = t("confirm-active-scheduled-drafts-dialog.description"), $[16] = t, $[17] = t6) : t6 = $[17];
  let t7;
  $[18] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t6 }), $[18] = t6, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== hasPastDates || $[21] !== t ? (t8 = hasPastDates && /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t("confirm-active-scheduled-drafts-dialog.past-dates-warning") }), $[20] = hasPastDates, $[21] = t, $[22] = t8) : t8 = $[22];
  let t9;
  $[23] !== t7 || $[24] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t7,
    t8
  ] }), $[23] = t7, $[24] = t8, $[25] = t9) : t9 = $[25];
  let t10;
  return $[26] !== onClose || $[27] !== t3 || $[28] !== t5 || $[29] !== t9 ? (t10 = /* @__PURE__ */ jsx(Dialog$1, { id: "confirm-active-scheduled-drafts-dialog", header: t3, onClose, width: 0, footer: t5, children: t9 }), $[26] = onClose, $[27] = t3, $[28] = t5, $[29] = t9, $[30] = t10) : t10 = $[30], t10;
}
function _temp2$H(release) {
  return release.metadata.intendedPublishAt && isPast(new Date(release.metadata.intendedPublishAt));
}
function ConfirmActiveScheduledDraftsBanner(t0) {
  const $ = c(27), {
    releases: releases2,
    releaseGroupMode,
    hasDateFilter,
    onNavigateToPaused
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace), [isDialogOpen, setIsDialogOpen] = useState(!1);
  let t1;
  $[0] !== releases2 ? (t1 = releases2.filter(_temp$1I), $[0] = releases2, $[1] = t1) : t1 = $[1];
  const activeScheduledDrafts = t1, shouldOpenDialog = releaseGroupMode === "paused" && !hasDateFilter;
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setIsDialogOpen(!1);
  }, $[2] = t2) : t2 = $[2];
  const handleCloseDialog = t2;
  let t3;
  $[3] !== onNavigateToPaused || $[4] !== shouldOpenDialog ? (t3 = () => shouldOpenDialog ? setIsDialogOpen(!0) : onNavigateToPaused(), $[3] = onNavigateToPaused, $[4] = shouldOpenDialog, $[5] = t3) : t3 = $[5];
  const handleClick = t3;
  if (activeScheduledDrafts.length === 0)
    return null;
  let t4;
  $[6] !== shouldOpenDialog || $[7] !== t ? (t4 = t(shouldOpenDialog ? "banner.confirm-active-scheduled-drafts.button-paused" : "banner.confirm-active-scheduled-drafts.button"), $[6] = shouldOpenDialog, $[7] = t, $[8] = t4) : t4 = $[8];
  const buttonText = t4;
  let t5;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 0, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }), $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== activeScheduledDrafts.length ? (t6 = {
    count: activeScheduledDrafts.length
  }, $[10] = activeScheduledDrafts.length, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t || $[13] !== t6 ? (t7 = /* @__PURE__ */ jsx(Flex, { align: "center", flex: 1, gap: 2, paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "banner.confirm-active-scheduled-drafts", values: t6 }) }) }), $[12] = t, $[13] = t6, $[14] = t7) : t7 = $[14];
  let t8;
  $[15] !== buttonText || $[16] !== handleClick ? (t8 = /* @__PURE__ */ jsx(Flex, { flex: "none", children: /* @__PURE__ */ jsx(Button, { text: buttonText, mode: "bleed", tone: "caution", onClick: handleClick }) }), $[15] = buttonText, $[16] = handleClick, $[17] = t8) : t8 = $[17];
  let t9;
  $[18] !== t7 || $[19] !== t8 ? (t9 = /* @__PURE__ */ jsx(Box, { flex: "none", padding: 1, marginBottom: 4, children: /* @__PURE__ */ jsx(Card, { radius: 3, paddingX: 2, paddingY: 2, tone: "caution", children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, paddingX: 2, children: [
    t5,
    t7,
    t8
  ] }) }) }), $[18] = t7, $[19] = t8, $[20] = t9) : t9 = $[20];
  let t10;
  $[21] !== activeScheduledDrafts || $[22] !== isDialogOpen ? (t10 = isDialogOpen && /* @__PURE__ */ jsx(ConfirmScheduledDraftsDialog, { activeScheduledDrafts, onClose: handleCloseDialog }), $[21] = activeScheduledDrafts, $[22] = isDialogOpen, $[23] = t10) : t10 = $[23];
  let t11;
  return $[24] !== t10 || $[25] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t9,
    t10
  ] }), $[24] = t10, $[25] = t9, $[26] = t11) : t11 = $[26], t11;
}
function _temp$1I(release) {
  return release.state === "active" && isCardinalityOneRelease(release);
}
const DraftsDisabledBanner = (t0) => {
  const $ = c(8), {
    isDraftModelEnabled,
    isScheduledDraftsEnabled,
    allReleases
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace), hasSingleDocRelease = allReleases.some(isCardinalityOneRelease);
  if (!((!isDraftModelEnabled || !isScheduledDraftsEnabled) && hasSingleDocRelease))
    return null;
  let t1;
  $[0] !== isScheduledDraftsEnabled || $[1] !== t ? (t1 = () => t(isScheduledDraftsEnabled ? "banner.drafts-mode-disabled" : "banner.scheduled-drafts-disabled"), $[0] = isScheduledDraftsEnabled, $[1] = t, $[2] = t1) : t1 = $[2];
  const getBannerMessage = t1;
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 0, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }), $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== getBannerMessage ? (t3 = getBannerMessage(), $[4] = getBannerMessage, $[5] = t3) : t3 = $[5];
  let t4;
  return $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(Box, { padding: 1, marginBottom: 4, children: /* @__PURE__ */ jsx(Card, { radius: 3, paddingX: 2, paddingY: 2, tone: "caution", children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, paddingX: 2, children: [
    t2,
    /* @__PURE__ */ jsx(Flex, { align: "center", flex: 1, gap: 2, paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t3 }) })
  ] }) }) }), $[6] = t3, $[7] = t4) : t4 = $[7], t4;
}, useTimezoneAdjustedDateTimeRange = () => {
  const $ = c(2), {
    zoneDateToUtc
  } = useTimeZone(CONTENT_RELEASES_TIME_ZONE_SCOPE);
  let t0;
  return $[0] !== zoneDateToUtc ? (t0 = (date) => [startOfDay(date), endOfDay(date)].map(zoneDateToUtc), $[0] = zoneDateToUtc, $[1] = t0) : t0 = $[1], t0;
}, ReleaseCalendarFilterDayWithCardinality = (props2) => {
  const $ = c(18), {
    data: allReleases
  } = useActiveReleases(), getTimezoneAdjustedDateTimeRange = useTimezoneAdjustedDateTimeRange();
  let calendarDayProps, cardinalityView, date;
  $[0] !== props2 ? ({
    date,
    cardinalityView,
    ...calendarDayProps
  } = props2, $[0] = props2, $[1] = calendarDayProps, $[2] = cardinalityView, $[3] = date) : (calendarDayProps = $[1], cardinalityView = $[2], date = $[3]);
  let t0;
  $[4] !== date || $[5] !== getTimezoneAdjustedDateTimeRange ? (t0 = getTimezoneAdjustedDateTimeRange(date), $[4] = date, $[5] = getTimezoneAdjustedDateTimeRange, $[6] = t0) : t0 = $[6];
  const [startOfDayForTimeZone, endOfDayForTimeZone] = t0;
  let t1;
  $[7] !== allReleases || $[8] !== cardinalityView || $[9] !== endOfDayForTimeZone || $[10] !== startOfDayForTimeZone ? (t1 = allReleases?.filter(shouldShowReleaseInView(cardinalityView))?.some((release) => {
    const releasePublishAt = release.publishAt || release.metadata.intendedPublishAt;
    if (!releasePublishAt)
      return !1;
    const publishDateUTC = new Date(releasePublishAt);
    return release.metadata.releaseType === "scheduled" && publishDateUTC >= startOfDayForTimeZone && publishDateUTC <= endOfDayForTimeZone;
  }), $[7] = allReleases, $[8] = cardinalityView, $[9] = endOfDayForTimeZone, $[10] = startOfDayForTimeZone, $[11] = t1) : t1 = $[11];
  const dayHasReleases = t1;
  let t2;
  $[12] !== dayHasReleases ? (t2 = dayHasReleases ? {
    fontWeight: 700
  } : {}, $[12] = dayHasReleases, $[13] = t2) : t2 = $[13];
  let t3;
  return $[14] !== calendarDayProps || $[15] !== date || $[16] !== t2 ? (t3 = /* @__PURE__ */ jsx(CalendarDay$3, { ...calendarDayProps, date, dateStyles: t2 }), $[14] = calendarDayProps, $[15] = date, $[16] = t2, $[17] = t3) : t3 = $[17], t3;
}, createReleaseCalendarFilterDay = (cardinalityView) => {
  const ReleaseCalendarFilterDayComponent = (props2) => {
    const $ = c(2);
    let t0;
    return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(ReleaseCalendarFilterDayWithCardinality, { ...props2, cardinalityView }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
  };
  return ReleaseCalendarFilterDayComponent.displayName = "ReleaseCalendarFilterDayComponent", ReleaseCalendarFilterDayComponent;
}, MotionButton$1 = motion.create(Button), DateFilterButton = (t0) => {
  const $ = c(8), {
    filterDate,
    onClear
  } = t0, [isExiting, setIsExiting] = useState(!1);
  let t1;
  $[0] !== onClear ? (t1 = () => {
    setIsExiting(!1), onClear();
  }, $[0] = onClear, $[1] = t1) : t1 = $[1];
  const handleOnExitComplete = t1;
  if (!filterDate)
    return null;
  let t2;
  $[2] !== filterDate || $[3] !== isExiting ? (t2 = !isExiting && /* @__PURE__ */ jsx(MotionButton$1, { "data-testid": "selected-date-filter", initial: {
    width: 0,
    opacity: 0
  }, animate: {
    width: "auto",
    opacity: 1
  }, exit: {
    width: 0,
    opacity: 0
  }, transition: {
    duration: 0.35,
    ease: "easeInOut"
  }, iconRight: CloseIcon, mode: "bleed", onClick: () => setIsExiting(!0), selected: !0, text: format(filterDate, "PPP") }), $[2] = filterDate, $[3] = isExiting, $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== handleOnExitComplete || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(AnimatePresence, { onExitComplete: handleOnExitComplete, children: t2 }), $[5] = handleOnExitComplete, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}, ReleaseMenuButtonWrapper = (t0) => {
  const $ = c(6), {
    release,
    documentsCount
  } = t0;
  let t1;
  $[0] !== release._id ? (t1 = getReleaseIdFromReleaseDocumentId(release._id), $[0] = release._id, $[1] = t1) : t1 = $[1];
  const {
    results: documents
  } = useBundleDocuments(t1);
  let t2;
  return $[2] !== documents || $[3] !== documentsCount || $[4] !== release ? (t2 = /* @__PURE__ */ jsx(ReleaseMenuButton, { release, documentsCount, documents }), $[2] = documents, $[3] = documentsCount, $[4] = release, $[5] = t2) : t2 = $[5], t2;
};
function ReleaseNotFoundBanner(t0) {
  const $ = c(15), {
    onDismiss
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 0, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== t ? (t2 = t("banner.release-not-found"), $[1] = t, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t2 }) }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t ? (t4 = t("banner.release-not-found.dismiss"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 ? (t5 = {
    content: t4
  }, $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== onDismiss || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsx(Button, { icon: CloseIcon, mode: "bleed", onClick: onDismiss, tooltipProps: t5 }), $[9] = onDismiss, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  return $[12] !== t3 || $[13] !== t6 ? (t7 = /* @__PURE__ */ jsx(Box, { flex: "none", padding: 1, marginBottom: 4, children: /* @__PURE__ */ jsx(Card, { radius: 3, paddingX: 2, paddingY: 2, tone: "caution", children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, paddingX: 2, children: [
    t1,
    t3,
    t6
  ] }) }) }), $[12] = t3, $[13] = t6, $[14] = t7) : t7 = $[14], t7;
}
const ReleaseIllustration = () => {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsxs("svg", { "data-testid": "release-illustration", width: "248", height: "201", viewBox: "0 0 248 201", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M175.4 29.8262V98.1738C175.4 103.823 181.346 107.498 186.399 104.971L222.399 86.9714C224.974 85.684 226.6 83.0524 226.6 80.1738V11.8262C226.6 6.17654 220.654 2.50197 215.601 5.02859L179.601 23.0286C177.026 24.316 175.4 26.9476 175.4 29.8262Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M183.4 33.8262V102.174C183.4 107.823 189.346 111.498 194.399 108.971L230.399 90.9714C232.974 89.684 234.6 87.0524 234.6 84.1738V15.8262C234.6 10.1765 228.654 6.50197 223.601 9.02859L187.601 27.0286C185.026 28.316 183.4 30.9476 183.4 33.8262Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M195.4 39.8262V108.174C195.4 113.823 201.346 117.498 206.399 114.971L242.399 96.9714C244.974 95.684 246.6 93.0524 246.6 90.1738V21.8262C246.6 16.1765 240.654 12.502 235.601 15.0286L199.601 33.0286C197.026 34.316 195.4 36.9476 195.4 39.8262Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.6", d: "M109.4 50.8262V119.174C109.4 124.823 115.346 128.498 120.399 125.971L156.399 107.971C158.974 106.684 160.6 104.052 160.6 101.174V32.8262C160.6 27.1765 154.654 23.502 149.601 26.0286L113.601 44.0286C111.026 45.316 109.4 47.9476 109.4 50.8262Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.9", d: "M118 123.174V54.8262C118 52.1748 119.498 49.751 121.87 48.5653L157.87 30.5652C162.524 28.2381 168 31.6226 168 36.8262V105.174C168 107.825 166.502 110.249 164.131 111.435L128.13 129.435C123.476 131.762 118 128.377 118 123.174Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M121.4 56.8262V125.174C121.4 130.823 127.346 134.498 132.399 131.971L168.399 113.971C170.974 112.684 172.6 110.052 172.6 107.174V38.8262C172.6 33.1765 166.654 29.502 161.601 32.0286L125.601 50.0286C123.026 51.316 121.4 53.9476 121.4 56.8262Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M125.4 58.8262V127.174C125.4 132.823 131.346 136.498 136.399 133.971L172.399 115.971C174.974 114.684 176.6 112.052 176.6 109.174V40.8262C176.6 35.1765 170.654 31.502 165.601 34.0286L129.601 52.0286C127.026 53.316 125.4 55.9476 125.4 58.8262Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M137.4 64.8262V133.174C137.4 138.823 143.346 142.498 148.399 139.971L184.399 121.971C186.974 120.684 188.6 118.052 188.6 115.174V46.8262C188.6 41.1765 182.654 37.502 177.601 40.0286L141.601 58.0286C139.026 59.316 137.4 61.9476 137.4 64.8262Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M145.4 68.8262V137.174C145.4 142.823 151.346 146.498 156.399 143.971L192.399 125.971C194.974 124.684 196.6 122.052 196.6 119.174V50.8262C196.6 45.1765 190.654 41.502 185.601 44.0286L149.601 62.0286C147.026 63.316 145.4 65.9476 145.4 68.8262Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.6", d: "M1.4 104.826V173.174C1.4 178.823 7.34557 182.498 12.3988 179.971L48.3988 161.971C50.9736 160.684 52.6 158.052 52.6 155.174V86.8262C52.6 81.1765 46.6544 77.502 41.6012 80.0286L5.60117 98.0286C3.02641 99.316 1.4 101.948 1.4 104.826Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.6", d: "M56.6 146.174V77.8262C56.6 75.4021 57.9696 73.186 60.1378 72.1019L96.1378 54.1019C100.393 51.9742 105.4 55.0686 105.4 59.8262V128.174C105.4 130.598 104.03 132.814 101.862 133.898L65.8622 151.898C61.6068 154.026 56.6 150.931 56.6 146.174Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.8", d: "M60.6 148.174V79.8262C60.6 77.4021 61.9696 75.186 64.1378 74.1019L100.138 56.1019C104.393 53.9742 109.4 57.0686 109.4 61.8262V130.174C109.4 132.598 108.03 134.814 105.862 135.898L69.8622 153.898C65.6068 156.026 60.6 152.931 60.6 148.174Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.9", d: "M64 150.174V81.8262C64 79.1748 65.498 76.751 67.8695 75.5653L103.87 57.5652C108.524 55.2381 114 58.6226 114 63.8262V132.174C114 134.825 112.502 137.249 110.131 138.435L74.1305 156.435C69.4762 158.762 64 155.377 64 150.174Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M72.6 154.174V85.8262C72.6 83.4021 73.9696 81.186 76.1378 80.1019L112.138 62.1019C116.393 59.9742 121.4 63.0686 121.4 67.8262V136.174C121.4 138.598 120.03 140.814 117.862 141.898L81.8622 159.898C77.6068 162.026 72.6 158.931 72.6 154.174Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M76.6 156.174V87.8262C76.6 85.4021 77.9696 83.186 80.1378 82.1019L116.138 64.1019C120.393 61.9742 125.4 65.0686 125.4 69.8262V138.174C125.4 140.598 124.03 142.814 121.862 143.898L85.8622 161.898C81.6068 164.026 76.6 160.931 76.6 156.174Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M84.6 160.174V91.8262C84.6 89.4021 85.9696 87.186 88.1378 86.1019L124.138 68.1019C128.393 65.9742 133.4 69.0686 133.4 73.8262V142.174C133.4 144.598 132.03 146.814 129.862 147.898L93.8622 165.898C89.6068 168.026 84.6 164.931 84.6 160.174Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M88.6 162.174V93.8262C88.6 91.4021 89.9696 89.186 92.1378 88.1019L128.138 70.1019C132.393 67.9742 137.4 71.0686 137.4 75.8262V144.174C137.4 146.598 136.03 148.814 133.862 149.898L97.8622 167.898C93.6068 170.026 88.6 166.931 88.6 162.174Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M92.6 164.174V95.8262C92.6 93.4021 93.9696 91.186 96.1378 90.1019L132.138 72.1019C136.393 69.9742 141.4 73.0686 141.4 77.8262V146.174C141.4 148.598 140.03 150.814 137.862 151.898L101.862 169.898C97.6068 172.026 92.6 168.931 92.6 164.174Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M96.6 166.174V97.8262C96.6 95.4021 97.9696 93.186 100.138 92.1019L136.138 74.1019C140.393 71.9742 145.4 75.0686 145.4 79.8262V148.174C145.4 150.598 144.03 152.814 141.862 153.898L105.862 171.898C101.607 174.026 96.6 170.931 96.6 166.174Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M104.6 170.174V101.826C104.6 99.4021 105.97 97.186 108.138 96.1019L144.138 78.1019C148.393 75.9742 153.4 79.0686 153.4 83.8262V152.174C153.4 154.598 152.03 156.814 149.862 157.898L113.862 175.898C109.607 178.026 104.6 174.931 104.6 170.174Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.8", d: "M5.4 106.826V175.174C5.4 180.823 11.3456 184.498 16.3988 181.971L52.3988 163.971C54.9736 162.684 56.6 160.052 56.6 157.174V88.8262C56.6 83.1765 50.6544 79.502 45.6012 82.0286L9.60117 100.029C7.02641 101.316 5.4 103.948 5.4 106.826Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.9", d: "M10 177.174V108.826C10 106.175 11.498 103.751 13.8695 102.565L49.8695 84.5652C54.5238 82.2381 60 85.6226 60 90.8262V159.174C60 161.825 58.502 164.249 56.1305 165.435L20.1305 183.435C15.4762 185.762 10 182.377 10 177.174Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M13.4 110.826V179.174C13.4 184.823 19.3456 188.498 24.3988 185.971L60.3988 167.971C62.9736 166.684 64.6 164.052 64.6 161.174V92.8262C64.6 87.1765 58.6544 83.502 53.6012 86.0286L17.6012 104.029C15.0264 105.316 13.4 107.948 13.4 110.826Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M29.4 118.826V187.174C29.4 192.823 35.3456 196.498 40.3988 193.971L76.3988 175.971C78.9736 174.684 80.6 172.052 80.6 169.174V100.826C80.6 95.1765 74.6544 91.502 69.6012 94.0286L33.6012 112.029C31.0264 113.316 29.4 115.948 29.4 118.826Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M33.4 120.826V189.174C33.4 194.823 39.3456 198.498 44.3988 195.971L80.3988 177.971C82.9736 176.684 84.6 174.052 84.6 171.174V102.826C84.6 97.1765 78.6544 93.502 73.6012 96.0286L37.6012 114.029C35.0264 115.316 33.4 117.948 33.4 120.826Z", fill: "var(--card-muted-bg-color)", stroke: "var(--card-muted-fg-color)", strokeWidth: "1.2" })
  ] }), $[0] = t0) : t0 = $[0], t0;
}, ReleasesEmptyState = (t0) => {
  const $ = c(22), {
    createReleaseButton
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    mode
  } = useReleasesUpsell();
  if (mode === "upsell")
    return null;
  let t1, t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    maxWidth: "300px"
  }, t2 = /* @__PURE__ */ jsx(ReleaseIllustration, {}), $[0] = t1, $[1] = t2) : (t1 = $[0], t2 = $[1]);
  let t3;
  $[2] !== t ? (t3 = t("overview.title"), $[2] = t, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { as: "h1", size: 1, weight: "semibold", "data-testid": "no-releases-info-text", children: t3 }), $[4] = t3, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    textAlign: "center"
  }, $[6] = t5) : t5 = $[6];
  let t6;
  $[7] !== t ? (t6 = t("overview.description"), $[7] = t, $[8] = t6) : t6 = $[8];
  let t7;
  $[9] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, style: t5, children: t6 }), $[9] = t6, $[10] = t7) : t7 = $[10];
  let t8;
  $[11] !== t ? (t8 = t("overview.action.documentation"), $[11] = t, $[12] = t8) : t8 = $[12];
  let t9;
  $[13] !== t8 ? (t9 = /* @__PURE__ */ jsx(Button, { as: "a", href: "https://www.sanity.io/docs/content-releases", target: "_blank", mode: "ghost", text: t8 }), $[13] = t8, $[14] = t9) : t9 = $[14];
  let t10;
  $[15] !== createReleaseButton || $[16] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    createReleaseButton,
    t9
  ] }), $[15] = createReleaseButton, $[16] = t9, $[17] = t10) : t10 = $[17];
  let t11;
  return $[18] !== t10 || $[19] !== t4 || $[20] !== t7 ? (t11 = /* @__PURE__ */ jsx(Flex, { direction: "column", flex: 1, justify: "center", align: "center", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, direction: "column", align: "center", style: t1, children: [
    t2,
    t4,
    t7,
    t10
  ] }) }), $[18] = t10, $[19] = t4, $[20] = t7, $[21] = t11) : t11 = $[21], t11;
};
function ReleaseColumnValidationLoading(t0) {
  const $ = c(5), {
    releaseId
  } = t0;
  let t1;
  $[0] !== releaseId ? (t1 = getReleaseIdFromReleaseDocumentId(releaseId), $[0] = releaseId, $[1] = t1) : t1 = $[1];
  const rId = t1, {
    results: documents,
    loading
  } = useBundleDocuments(rId);
  let t2;
  return $[2] !== documents || $[3] !== loading ? (t2 = loading ? /* @__PURE__ */ jsx(Spinner, { size: 1, muted: !0 }) : /* @__PURE__ */ jsx(ValidationProgressIndicator, { layout: "minimal", documents }), $[2] = documents, $[3] = loading, $[4] = t2) : t2 = $[4], t2;
}
const ReleaseDocumentsCounter = (t0) => {
  const $ = c(2), {
    documentCount
  } = t0, t1 = documentCount || "-";
  let t2;
  return $[0] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t1 }), $[0] = t1, $[1] = t2) : t2 = $[1], t2;
}, PREVIEW_SIZES = {
  block: {
    icon: 25,
    media: {
      width: 33,
      height: 33
    }
  },
  blockImage: {
    icon: 25,
    media: {
      width: 600,
      height: 400
    }
  },
  compact: {
    icon: 21,
    media: {
      width: 25,
      height: 25
    }
  },
  default: {
    icon: 21,
    media: {
      width: 33,
      height: 33
    }
  },
  detail: {
    icon: 25,
    media: {
      width: 73,
      height: 73
    }
  },
  inline: {
    icon: 15,
    media: {
      width: 15,
      height: 15
    }
  },
  media: {
    icon: 25,
    media: {
      width: 160,
      height: 160
    }
  }
}, RootFlex$2 = styled(Flex).attrs({
  align: "center"
}).withConfig({
  displayName: "RootFlex",
  componentId: "sc-1mf80xe-0"
})`height:${rem(PREVIEW_SIZES.detail.media.height)};`, StatusBox = styled(Box).withConfig({
  displayName: "StatusBox",
  componentId: "sc-1mf80xe-1"
})`white-space:nowrap;`, MediaSkeleton$1 = styled(Skeleton).attrs({
  animated: !0,
  radius: 2
}).withConfig({
  displayName: "MediaSkeleton",
  componentId: "sc-1mf80xe-2"
})`width:${rem(PREVIEW_SIZES.detail.media.width)};height:${rem(PREVIEW_SIZES.detail.media.height)};`, TitleSkeleton$3 = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
}).withConfig({
  displayName: "TitleSkeleton",
  componentId: "sc-1mf80xe-3"
})`max-width:${rem(160)};width:80%;`, SubtitleSkeleton$2 = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
}).withConfig({
  displayName: "SubtitleSkeleton",
  componentId: "sc-1mf80xe-4"
})`max-width:${rem(120)};width:60%;`, DescriptionSkeleton = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
}).withConfig({
  displayName: "DescriptionSkeleton",
  componentId: "sc-1mf80xe-5"
})`max-width:${rem(180)};width:90%;`, DescriptionText = /* @__PURE__ */ styled(Text$1).withConfig({
  displayName: "DescriptionText",
  componentId: "sc-1mf80xe-6"
})(({
  theme
}) => {
  const {
    fonts
  } = theme.sanity, textSize1 = fonts.text.sizes[1], maxLines = 2, maxHeight = textSize1.lineHeight * maxLines;
  return css`
    & > span {
      max-height: ${rem(maxHeight)};

      /* Multi-line text overflow */
      display: -webkit-box;
      overflow: hidden;
      overflow: clip;
      text-overflow: ellipsis;
      -webkit-line-clamp: ${maxLines};
      -webkit-box-orient: vertical;
    }
  `;
}), ReleaseNameCell = (t0) => {
  const $ = c(65), {
    cellProps,
    datum: release
  } = t0, router = useRouter(), {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), {
    selectedReleaseId
  } = usePerspective(), setPerspective = useSetPerspective(), {
    state
  } = release;
  let t1;
  $[0] !== release._id || $[1] !== release.isLoading ? (t1 = release.isLoading ? "loading" : getReleaseIdFromReleaseDocumentId(release._id), $[0] = release._id, $[1] = release.isLoading, $[2] = t1) : t1 = $[2];
  const releaseId = t1, isArchived = state === "archived", isReleasePinned = releaseId === selectedReleaseId, {
    document: document2
  } = useWorkspace(), {
    drafts: t2
  } = document2, {
    enabled: isDraftModelEnabled
  } = t2;
  let t3;
  $[3] !== isDraftModelEnabled || $[4] !== isReleasePinned || $[5] !== releaseId || $[6] !== setPerspective ? (t3 = () => {
    setPerspective(isReleasePinned ? isDraftModelEnabled ? "drafts" : "published" : releaseId);
  }, $[3] = isDraftModelEnabled, $[4] = isReleasePinned, $[5] = releaseId, $[6] = setPerspective, $[7] = t3) : t3 = $[7];
  const handlePinRelease = t3;
  if (release.isLoading) {
    let t42;
    $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(Skeleton, { animated: !0, radius: 1, style: PREVIEW_SIZES.default.media }),
      /* @__PURE__ */ jsx(TitleSkeleton$3, {})
    ] }), $[8] = t42) : t42 = $[8];
    let t52;
    return $[9] !== cellProps ? (t52 = /* @__PURE__ */ jsx(Box, { ...cellProps, paddingLeft: 3, flex: 1, paddingY: 1, paddingRight: 2, sizing: "border", children: t42 }), $[9] = cellProps, $[10] = t52) : t52 = $[10], t52;
  }
  let t4;
  $[11] !== release.isDeleted || $[12] !== releaseId || $[13] !== router ? (t4 = release.isDeleted ? {
    tone: "transparent"
  } : {
    as: "a",
    onClick: () => router.navigate({
      releaseId
    }),
    tone: "inherit"
  }, $[11] = release.isDeleted, $[12] = releaseId, $[13] = router, $[14] = t4) : t4 = $[14];
  const cardProps = t4, pinButtonIcon = isReleasePinned ? PinFilledIcon : PinIcon;
  let t5;
  $[15] !== release.metadata.title || $[16] !== tCore ? (t5 = release.metadata.title || tCore("release.placeholder-untitled-release"), $[15] = release.metadata.title, $[16] = tCore, $[17] = t5) : t5 = $[17];
  const releaseTitle = t5, t6 = !release.isDeleted;
  let t7;
  $[18] !== releaseTitle ? (t7 = {
    title: releaseTitle
  }, $[18] = releaseTitle, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== t || $[21] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "deleted-release", values: t7 }) }), $[20] = t, $[21] = t7, $[22] = t8) : t8 = $[22];
  const t9 = isArchived || release.state === "published";
  let t10;
  $[23] !== isReleasePinned || $[24] !== t ? (t10 = t(isReleasePinned ? "dashboard.details.unpin-release" : "dashboard.details.pin-release"), $[23] = isReleasePinned, $[24] = t, $[25] = t10) : t10 = $[25];
  let t11;
  $[26] !== t10 || $[27] !== t9 ? (t11 = {
    disabled: t9,
    content: t10
  }, $[26] = t10, $[27] = t9, $[28] = t11) : t11 = $[28];
  const t12 = isArchived || release.state === "published";
  let t13;
  $[29] !== isReleasePinned || $[30] !== releaseTitle || $[31] !== t ? (t13 = isReleasePinned ? `${t("dashboard.details.unpin-release")}: "${releaseTitle}"` : `${t("dashboard.details.pin-release")}: "${releaseTitle}"`, $[29] = isReleasePinned, $[30] = releaseTitle, $[31] = t, $[32] = t13) : t13 = $[32];
  let t14;
  $[33] !== handlePinRelease || $[34] !== isReleasePinned || $[35] !== pinButtonIcon || $[36] !== t11 || $[37] !== t12 || $[38] !== t13 ? (t14 = /* @__PURE__ */ jsx(Button, { tooltipProps: t11, disabled: t12, icon: pinButtonIcon, mode: "bleed", "data-testid": "pin-release-button", onClick: handlePinRelease, radius: "full", selected: isReleasePinned, "aria-label": t13, "aria-live": "assertive" }), $[33] = handlePinRelease, $[34] = isReleasePinned, $[35] = pinButtonIcon, $[36] = t11, $[37] = t12, $[38] = t13, $[39] = t14) : t14 = $[39];
  let t15;
  $[40] !== release ? (t15 = /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(ReleaseAvatar, { release }) }), $[40] = release, $[41] = t15) : t15 = $[41];
  let t16;
  $[42] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = {
    minWidth: 0
  }, $[42] = t16) : t16 = $[42];
  const t17 = release.metadata.title;
  let t18;
  $[43] !== tCore ? (t18 = tCore("release.placeholder-untitled-release"), $[43] = tCore, $[44] = t18) : t18 = $[44];
  let t19;
  $[45] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t19 = {
    size: 1,
    weight: "medium",
    style: {
      minWidth: 0
    }
  }, $[45] = t19) : t19 = $[45];
  let t20;
  $[46] !== release.metadata.title || $[47] !== t18 ? (t20 = /* @__PURE__ */ jsx(Stack, { flex: 1, space: 2, children: /* @__PURE__ */ jsx(Flex, { align: "center", gap: 2, style: t16, children: /* @__PURE__ */ jsx(ReleaseTitle, { title: t17, fallback: t18, textProps: t19 }) }) }), $[46] = release.metadata.title, $[47] = t18, $[48] = t20) : t20 = $[48];
  let t21;
  $[49] !== t15 || $[50] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t15,
    t20
  ] }), $[49] = t15, $[50] = t20, $[51] = t21) : t21 = $[51];
  let t22;
  $[52] !== cardProps || $[53] !== t21 ? (t22 = /* @__PURE__ */ jsx(Card, { ...cardProps, padding: 2, radius: 2, flex: 1, children: t21 }), $[52] = cardProps, $[53] = t21, $[54] = t22) : t22 = $[54];
  let t23;
  $[55] !== t14 || $[56] !== t22 ? (t23 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t14,
    t22
  ] }), $[55] = t14, $[56] = t22, $[57] = t23) : t23 = $[57];
  let t24;
  $[58] !== t23 || $[59] !== t6 || $[60] !== t8 ? (t24 = /* @__PURE__ */ jsx(Tooltip, { disabled: t6, content: t8, children: t23 }), $[58] = t23, $[59] = t6, $[60] = t8, $[61] = t24) : t24 = $[61];
  let t25;
  return $[62] !== cellProps || $[63] !== t24 ? (t25 = /* @__PURE__ */ jsx(Box, { ...cellProps, paddingLeft: 3, flex: 1, paddingY: 1, paddingRight: 2, sizing: "border", children: t24 }), $[62] = cellProps, $[63] = t24, $[64] = t25) : t25 = $[64], t25;
}, enableColumnFormMode = (currentMode) => (column, expectedMode) => {
  if (!currentMode) throw new Error("currentMode is required");
  if (expectedMode === "all" || expectedMode === currentMode)
    return column;
}, releasesOverviewColumnDefs = (t, releaseGroupMode) => {
  const checkColumnMode = enableColumnFormMode(releaseGroupMode);
  return [
    checkColumnMode({
      id: "metadata.title",
      sorting: !0,
      width: null,
      style: {
        minWidth: "min(50%, calc(100vw - 80px))",
        maxWidth: "min(50%, calc(100vw - 80px))"
      },
      header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, flex: 1, paddingLeft: 6, width: 3, paddingRight: 2, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { ...props2, text: t("table-header.title") }) }),
      cell: ReleaseNameCell
    }, "all"),
    checkColumnMode({
      id: "publishAt",
      sorting: !0,
      sortTransform: (release) => {
        if (release.metadata.releaseType === "undecided") return 1 / 0;
        const publishDate = getPublishDateFromRelease(release);
        return release.metadata.releaseType === "asap" || !publishDate ? 0 : new Date(publishDate).getTime();
      },
      width: 280,
      header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { text: t("table-header.when"), ...props2 }) }),
      cell: ({
        cellProps,
        datum: release
      }) => release.isLoading ? null : /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, gap: 2, sizing: "border", children: /* @__PURE__ */ jsx(ReleaseTime, { release }) })
    }, "active"),
    // This is a hidden column only used for sorting when
    // no other sort column is selected (the default state)
    checkColumnMode({
      id: "lastActivity",
      hidden: !0,
      sorting: !0,
      width: 100,
      sortTransform: ({
        publishedAt,
        _updatedAt
      }) => {
        const lastActivity = publishedAt ?? _updatedAt;
        return lastActivity ? new Date(lastActivity).getTime() : -1 / 0;
      }
    }, "archived"),
    checkColumnMode({
      id: "publishedAt",
      sorting: !0,
      sortTransform: (release, direction) => release.state !== "published" ? direction === "asc" ? 1 / 0 : -1 / 0 : release.publishedAt ? new Date(release.publishedAt).getTime() : release._updatedAt,
      width: 250,
      header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { text: t("table-header.published-at"), ...props2 }) }),
      cell: ({
        cellProps,
        datum: release
      }) => /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, gap: 2, sizing: "border", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: release.publishedAt ? (
        // Assuming releases are not updated after archiving.
        // If we realize this is miss leading for customers and they have edited the release after archiving
        // we can use the history endpoint to get the archived change.
        /* @__PURE__ */ jsx(RelativeTime, { time: release.publishedAt, useTemporalPhrase: !0, minimal: !0 })
      ) : "-" }) })
    }, "archived"),
    checkColumnMode({
      id: "_updatedAt",
      sorting: !0,
      sortTransform: (release, direction) => release.state !== "archived" ? direction === "asc" ? 1 / 0 : -1 / 0 : new Date(release._updatedAt).getTime(),
      width: 250,
      header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { text: t("table-header.archivedAt"), ...props2 }) }),
      cell: ({
        cellProps,
        datum: release
      }) => /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, gap: 2, sizing: "border", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: release.state === "archived" ? (
        // Assuming releases are not updated after archiving.
        // If we later realize this is miss leading for customers and they have edited the release after archiving
        // we can use the history endpoint to get the archived change.
        /* @__PURE__ */ jsx(RelativeTime, { time: release._updatedAt, useTemporalPhrase: !0, minimal: !0 })
      ) : "-" }) })
    }, "archived"),
    checkColumnMode({
      id: "documentsMetadata.updatedAt",
      sorting: !0,
      width: 150,
      header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { text: t("table-header.edited"), ...props2 }) }),
      cell: ({
        datum: {
          documentsMetadata,
          _updatedAt
        },
        cellProps
      }) => {
        const updatedAtDate = documentsMetadata?.updatedAt ?? _updatedAt;
        return /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", gap: 2, paddingX: 2, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: updatedAtDate ? /* @__PURE__ */ jsx(RelativeTime, { time: updatedAtDate, useTemporalPhrase: !0, minimal: !0 }) : "-" }) });
      }
    }, "active"),
    checkColumnMode({
      id: "error",
      sorting: !1,
      width: 40,
      header: ({
        headerProps
      }) => /* @__PURE__ */ jsx(Flex, { ...headerProps, paddingY: 3, sizing: "border" }),
      cell: ({
        datum,
        cellProps
      }) => {
        const {
          error,
          state
        } = datum, hasError = typeof error < "u" && state === "active", hasWarning = state === "active" && getIsScheduledDateInPast(datum);
        return /* @__PURE__ */ jsxs(Flex, { ...cellProps, align: "center", gap: 2, paddingX: 2, paddingY: 3, sizing: "border", "data-testid": "error-indicator", children: [
          hasError && /* @__PURE__ */ jsx(Tooltip, { content: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("failed-publish-title") }), portal: !0, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: "critical" }) }) }),
          hasWarning && /* @__PURE__ */ jsx(Tooltip, { content: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("passed-intended-publish-date") }), portal: !0, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToneIcon, { icon: WarningOutlineIcon, tone: "caution" }) }) })
        ] });
      }
    }, "all"),
    checkColumnMode({
      id: "documentCount",
      sorting: !1,
      width: 120,
      header: ({
        headerProps
      }) => /* @__PURE__ */ jsx(Flex, { ...headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.BasicHeader, { text: t("table-header.documents") }) }),
      cell: ({
        datum: {
          isDeleted,
          state,
          finalDocumentStates,
          documentsMetadata,
          _id
        },
        cellProps
      }) => /* @__PURE__ */ jsxs(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, sizing: "border", gap: 2, children: [
        state === "active" && /* @__PURE__ */ jsx(ReleaseColumnValidationLoading, { releaseId: _id }),
        state === "scheduled" && /* @__PURE__ */ jsx(Card, { padding: 0, radius: "full", tone: "neutral", style: {
          background: "transparent"
        }, children: /* @__PURE__ */ jsx(Flex, { gap: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Tooltip, { content: t("summary.all-documents-validated"), children: /* @__PURE__ */ jsx(CheckmarkCircleIcon, {}) }) }) }) }),
        !isDeleted && /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(ReleaseDocumentsCounter, { documentCount: state === "archived" || state === "published" ? finalDocumentStates?.length : documentsMetadata?.documentCount }) })
      ] })
    }, "all")
  ].filter(filterNull);
};
function filterNull(value) {
  return !!value;
}
function useScheduledDraftDocument(releaseDocumentId, t0) {
  const $ = c(19);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1, {
    includePreview: t2
  } = options, includePreview = t2 === void 0 ? !1 : t2;
  let t3;
  $[2] !== releaseDocumentId ? (t3 = releaseDocumentId ? getReleaseIdFromReleaseDocumentId(releaseDocumentId) : "", $[2] = releaseDocumentId, $[3] = t3) : t3 = $[3];
  const releaseId = t3, {
    results: documents,
    loading,
    error
  } = useBundleDocuments(releaseId), schema2 = useSchema(), firstDocument = documents?.[0]?.document, firstDocumentValidation = documents?.[0]?.validation.validation, documentsCount = documents?.length || 0;
  let t4;
  $[4] !== firstDocument || $[5] !== schema2 ? (t4 = firstDocument ? schema2.get(firstDocument._type) : null, $[4] = firstDocument, $[5] = schema2, $[6] = t4) : t4 = $[6];
  const schemaType = t4, t5 = includePreview && !!firstDocument && !!schemaType, t6 = schemaType || void 0;
  let t7;
  $[7] !== firstDocument || $[8] !== t5 || $[9] !== t6 ? (t7 = {
    enabled: t5,
    schemaType: t6,
    value: firstDocument
  }, $[7] = firstDocument, $[8] = t5, $[9] = t6, $[10] = t7) : t7 = $[10];
  const {
    value: previewValue,
    isLoading: previewLoading
  } = unstable_useValuePreview(t7), t8 = includePreview ? previewValue : void 0, t9 = includePreview ? previewLoading : !1;
  let t10;
  return $[11] !== documentsCount || $[12] !== error || $[13] !== firstDocument || $[14] !== firstDocumentValidation || $[15] !== loading || $[16] !== t8 || $[17] !== t9 ? (t10 = {
    firstDocument,
    firstDocumentPreview: t8,
    firstDocumentValidation,
    documentsCount,
    loading,
    error,
    previewLoading: t9
  }, $[11] = documentsCount, $[12] = error, $[13] = firstDocument, $[14] = firstDocumentValidation, $[15] = loading, $[16] = t8, $[17] = t9, $[18] = t10) : t10 = $[18], t10;
}
function useScheduleDraftOperations() {
  const $ = c(22), {
    t
  } = useTranslation(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), releaseOperations = useReleaseOperations(), {
    data: allReleases
  } = useAllReleases();
  let t0;
  $[0] !== releaseOperations ? (t0 = async (title, scheduleAt, opts) => {
    const releaseDocumentId = createReleaseId();
    return await releaseOperations.createRelease({
      _id: releaseDocumentId,
      metadata: {
        title,
        description: "",
        releaseType: "scheduled",
        cardinality: "one",
        intendedPublishAt: scheduleAt.toISOString()
      }
    }, opts), releaseDocumentId;
  }, $[0] = releaseOperations, $[1] = t0) : t0 = $[1];
  const createScheduledDraftRelease = t0;
  let t1;
  $[2] !== createScheduledDraftRelease || $[3] !== releaseOperations || $[4] !== t ? (t1 = async (documentId, publishAt, opts_0) => {
    const releaseTitle = t("scheduled-drafts.release.title"), releaseDocumentId_0 = await createScheduledDraftRelease(releaseTitle, publishAt, opts_0), draftId = getDraftId(documentId), releaseId = getReleaseIdFromReleaseDocumentId(releaseDocumentId_0);
    return await releaseOperations.createVersion(releaseId, draftId, opts_0), await releaseOperations.schedule(releaseDocumentId_0, publishAt, opts_0), releaseDocumentId_0;
  }, $[2] = createScheduledDraftRelease, $[3] = releaseOperations, $[4] = t, $[5] = t1) : t1 = $[5];
  const handleCreateScheduledDraft = t1;
  let t2;
  $[6] !== releaseOperations ? (t2 = async (release, opts_1) => {
    isReleaseScheduledOrScheduling(release) && await releaseOperations.unschedule(release._id, opts_1), await releaseOperations.publishRelease(release._id, opts_1);
  }, $[6] = releaseOperations, $[7] = t2) : t2 = $[7];
  const handlePublishScheduledDraft = t2;
  let t3;
  $[8] !== allReleases || $[9] !== client || $[10] !== releaseOperations ? (t3 = async (releaseDocumentId_1, shouldCopyToDraft, publishedId, opts_2) => {
    const release_0 = allReleases.find((r) => r._id === releaseDocumentId_1);
    if (!release_0)
      throw new Error(`Release with ID ${releaseDocumentId_1} not found`);
    if (shouldCopyToDraft && publishedId) {
      const releaseId_0 = getReleaseIdFromReleaseDocumentId(releaseDocumentId_1), scheduledDraftId = getVersionId(publishedId, releaseId_0), scheduledDraftDoc = await client.getDocument(scheduledDraftId);
      if (scheduledDraftDoc) {
        const draftId_0 = getDraftId(publishedId), {
          _rev,
          ...contentWithoutRev
        } = scheduledDraftDoc;
        await client.createOrReplace({
          ...contentWithoutRev,
          _id: draftId_0
        });
      }
    }
    (release_0.state === "scheduled" || release_0.state === "scheduling") && await releaseOperations.unschedule(releaseDocumentId_1, opts_2), release_0.state !== "archived" && release_0.state !== "published" && await releaseOperations.archive(releaseDocumentId_1, opts_2), await releaseOperations.deleteRelease(releaseDocumentId_1, opts_2);
  }, $[8] = allReleases, $[9] = client, $[10] = releaseOperations, $[11] = t3) : t3 = $[11];
  const handleDeleteScheduledDraft = t3;
  let t4;
  $[12] !== releaseOperations ? (t4 = async (release_1, newPublishAt, opts_3) => {
    await releaseOperations.updateRelease({
      _id: release_1._id,
      metadata: {
        ...release_1.metadata,
        intendedPublishAt: newPublishAt.toISOString()
      }
    }, opts_3), await releaseOperations.schedule(release_1._id, newPublishAt, opts_3);
  }, $[12] = releaseOperations, $[13] = t4) : t4 = $[13];
  const handleRescheduleScheduledDraft = t4;
  let t5;
  $[14] !== releaseOperations ? (t5 = async (release_2, opts_4) => {
    await releaseOperations.unschedule(release_2._id, opts_4);
  }, $[14] = releaseOperations, $[15] = t5) : t5 = $[15];
  const handlePauseScheduledDraft = t5;
  let t6;
  return $[16] !== handleCreateScheduledDraft || $[17] !== handleDeleteScheduledDraft || $[18] !== handlePauseScheduledDraft || $[19] !== handlePublishScheduledDraft || $[20] !== handleRescheduleScheduledDraft ? (t6 = {
    createScheduledDraft: handleCreateScheduledDraft,
    publishScheduledDraft: handlePublishScheduledDraft,
    deleteScheduledDraft: handleDeleteScheduledDraft,
    rescheduleScheduledDraft: handleRescheduleScheduledDraft,
    pauseScheduledDraft: handlePauseScheduledDraft
  }, $[16] = handleCreateScheduledDraft, $[17] = handleDeleteScheduledDraft, $[18] = handlePauseScheduledDraft, $[19] = handlePublishScheduledDraft, $[20] = handleRescheduleScheduledDraft, $[21] = t6) : t6 = $[21], t6;
}
function getDialogDescription(draftVersionInfo, scheduledDraftBaseRev) {
  return draftVersionInfo ? scheduledDraftBaseRev === draftVersionInfo._rev ? {
    bodyKey: "release.dialog.delete-schedule-draft.body-already-current",
    copy: {
      visible: !1,
      default: !1
    }
  } : {
    bodyKey: "release.dialog.delete-schedule-draft.body-with-choice",
    copy: {
      visible: !0,
      default: !0
    }
  } : {
    bodyKey: "release.dialog.delete-schedule-draft.body-will-save-to-draft",
    copy: {
      visible: !1,
      default: !0
    }
  };
}
function useDeleteScheduledDraft(firstDocumentPreview, onClose, deleteOperation) {
  const $ = c(9), {
    t
  } = useTranslation(), toast = useToast(), [isDeleting, setIsDeleting] = useState(!1);
  let t0;
  $[0] !== deleteOperation || $[1] !== firstDocumentPreview?.title || $[2] !== onClose || $[3] !== t || $[4] !== toast ? (t0 = async () => {
    setIsDeleting(!0), await (async () => {
      await deleteOperation(), toast.push({
        closable: !0,
        status: "success",
        description: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "release.toast.delete-schedule-draft.success", values: {
          title: firstDocumentPreview?.title || t("preview.default.title-fallback")
        } })
      });
    })().catch((error) => {
      console.error("Failed to delete scheduled draft:", error), toast.push({
        closable: !0,
        status: "error",
        description: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "release.toast.delete-schedule-draft.error", values: {
          title: firstDocumentPreview?.title || t("preview.default.title-fallback"),
          error: getErrorMessage$2(error)
        } })
      });
    }).finally(() => {
      setIsDeleting(!1), onClose();
    });
  }, $[0] = deleteOperation, $[1] = firstDocumentPreview?.title, $[2] = onClose, $[3] = t, $[4] = toast, $[5] = t0) : t0 = $[5];
  const handleDeleteSchedule = t0;
  let t1;
  return $[6] !== handleDeleteSchedule || $[7] !== isDeleting ? (t1 = {
    isDeleting,
    handleDeleteSchedule
  }, $[6] = handleDeleteSchedule, $[7] = isDeleting, $[8] = t1) : t1 = $[8], t1;
}
function DeleteScheduledDraftDialogContent(t0) {
  const $ = c(21), {
    onClose,
    handleDeleteSchedule,
    isDeleting,
    children
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("release.dialog.delete-schedule-draft.header"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== isDeleting || $[3] !== onClose ? (t2 = {
    disabled: isDeleting,
    onClick: onClose
  }, $[2] = isDeleting, $[3] = onClose, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("release.dialog.delete-schedule-draft.confirm"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== handleDeleteSchedule || $[8] !== isDeleting || $[9] !== t3 ? (t4 = {
    text: t3,
    tone: "critical",
    onClick: handleDeleteSchedule,
    disabled: isDeleting,
    loading: isDeleting
  }, $[7] = handleDeleteSchedule, $[8] = isDeleting, $[9] = t3, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== t2 || $[12] !== t4 ? (t5 = {
    cancelButton: t2,
    confirmButton: t4
  }, $[11] = t2, $[12] = t4, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== children ? (t6 = /* @__PURE__ */ jsx(Stack, { space: 3, paddingX: 3, marginBottom: 2, children }), $[14] = children, $[15] = t6) : t6 = $[15];
  let t7;
  return $[16] !== onClose || $[17] !== t1 || $[18] !== t5 || $[19] !== t6 ? (t7 = /* @__PURE__ */ jsx(Dialog$1, { id: "delete-schedule-dialog", header: t1, onClose, width: 0, padding: !1, footer: t5, children: t6 }), $[16] = onClose, $[17] = t1, $[18] = t5, $[19] = t6, $[20] = t7) : t7 = $[20], t7;
}
function DeleteScheduledDraftDialogWithCopyToDraft(t0) {
  const $ = c(35), {
    documentId,
    documentType,
    onClose,
    release
  } = t0, {
    t
  } = useTranslation(), schema2 = useSchema(), operations = useScheduleDraftOperations();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    includePreview: !0
  }, $[0] = t1) : t1 = $[0];
  const {
    firstDocument,
    firstDocumentPreview
  } = useScheduledDraftDocument(release._id, t1);
  let t2;
  $[1] !== documentId ? (t2 = getPublishedId(documentId), $[1] = documentId, $[2] = t2) : t2 = $[2];
  const publishedId = t2, {
    draft: draftVersionInfo
  } = useDocumentVersionInfo(publishedId), scheduledDraftBaseRev = firstDocument?._system?.base?.rev;
  let t3;
  $[3] !== draftVersionInfo || $[4] !== scheduledDraftBaseRev ? (t3 = getDialogDescription(draftVersionInfo, scheduledDraftBaseRev), $[3] = draftVersionInfo, $[4] = scheduledDraftBaseRev, $[5] = t3) : t3 = $[5];
  const dialogDescription = t3, [shouldCopyToDraft, setShouldCopyToDraft] = useState(dialogDescription.copy.default);
  let t4;
  $[6] !== dialogDescription.copy.default || $[7] !== dialogDescription.copy.visible || $[8] !== operations || $[9] !== publishedId || $[10] !== release._id || $[11] !== shouldCopyToDraft ? (t4 = async () => {
    const shouldCopy = dialogDescription.copy.visible ? shouldCopyToDraft : dialogDescription.copy.default;
    await operations.deleteScheduledDraft(release._id, shouldCopy, publishedId);
  }, $[6] = dialogDescription.copy.default, $[7] = dialogDescription.copy.visible, $[8] = operations, $[9] = publishedId, $[10] = release._id, $[11] = shouldCopyToDraft, $[12] = t4) : t4 = $[12];
  const deleteOperation = t4, {
    isDeleting,
    handleDeleteSchedule
  } = useDeleteScheduledDraft(firstDocumentPreview, onClose, deleteOperation);
  let t5;
  $[13] !== documentType || $[14] !== schema2 ? (t5 = schema2.get(documentType), $[13] = documentType, $[14] = schema2, $[15] = t5) : t5 = $[15];
  const schemaType = t5;
  let t6;
  $[16] !== firstDocument || $[17] !== schemaType ? (t6 = schemaType && firstDocument ? /* @__PURE__ */ jsx(Preview$1, { value: firstDocument, schemaType }) : /* @__PURE__ */ jsx(LoadingBlock, {}), $[16] = firstDocument, $[17] = schemaType, $[18] = t6) : t6 = $[18];
  let t7;
  $[19] !== dialogDescription.bodyKey || $[20] !== t ? (t7 = t(dialogDescription.bodyKey), $[19] = dialogDescription.bodyKey, $[20] = t, $[21] = t7) : t7 = $[21];
  let t8;
  $[22] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { paddingX: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t7 }) }), $[22] = t7, $[23] = t8) : t8 = $[23];
  let t9;
  $[24] !== dialogDescription.copy.visible || $[25] !== shouldCopyToDraft || $[26] !== t ? (t9 = dialogDescription.copy.visible && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(Box, { paddingX: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t("release.dialog.delete-schedule-draft.different-changes-explanation") }) }),
    /* @__PURE__ */ jsx(Box, { paddingX: 2, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, as: "label", children: [
      /* @__PURE__ */ jsx(Checkbox$1, { checked: shouldCopyToDraft, onChange: (event) => setShouldCopyToDraft(event.currentTarget.checked) }),
      /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t("release.dialog.delete-schedule-draft.copy-checkbox") })
    ] }) })
  ] }), $[24] = dialogDescription.copy.visible, $[25] = shouldCopyToDraft, $[26] = t, $[27] = t9) : t9 = $[27];
  let t10;
  return $[28] !== handleDeleteSchedule || $[29] !== isDeleting || $[30] !== onClose || $[31] !== t6 || $[32] !== t8 || $[33] !== t9 ? (t10 = /* @__PURE__ */ jsxs(DeleteScheduledDraftDialogContent, { onClose, handleDeleteSchedule, isDeleting, children: [
    t6,
    t8,
    t9
  ] }), $[28] = handleDeleteSchedule, $[29] = isDeleting, $[30] = onClose, $[31] = t6, $[32] = t8, $[33] = t9, $[34] = t10) : t10 = $[34], t10;
}
function DeleteScheduledDraftDialogWithEmptyRelease(t0) {
  const $ = c(13), {
    onClose,
    release
  } = t0, {
    t
  } = useTranslation(), operations = useScheduleDraftOperations();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    includePreview: !0
  }, $[0] = t1) : t1 = $[0];
  const {
    firstDocumentPreview
  } = useScheduledDraftDocument(release._id, t1);
  let t2;
  $[1] !== operations || $[2] !== release._id ? (t2 = async () => {
    await operations.deleteScheduledDraft(release._id, !1, void 0);
  }, $[1] = operations, $[2] = release._id, $[3] = t2) : t2 = $[3];
  const deleteOperation = t2, {
    isDeleting,
    handleDeleteSchedule
  } = useDeleteScheduledDraft(firstDocumentPreview, onClose, deleteOperation);
  let t3;
  $[4] !== t ? (t3 = t("release.dialog.delete-schedule-draft.body-already-current"), $[4] = t, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(Box, { paddingX: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t3 }) }), $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  return $[8] !== handleDeleteSchedule || $[9] !== isDeleting || $[10] !== onClose || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(DeleteScheduledDraftDialogContent, { onClose, handleDeleteSchedule, isDeleting, children: t4 }), $[8] = handleDeleteSchedule, $[9] = isDeleting, $[10] = onClose, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
}
function DeleteScheduledDraftDialog(t0) {
  const $ = c(8), {
    documentId,
    documentType,
    onClose,
    release
  } = t0;
  if (!documentId || !documentType) {
    let t12;
    return $[0] !== onClose || $[1] !== release ? (t12 = /* @__PURE__ */ jsx(DeleteScheduledDraftDialogWithEmptyRelease, { onClose, release }), $[0] = onClose, $[1] = release, $[2] = t12) : t12 = $[2], t12;
  }
  let t1;
  return $[3] !== documentId || $[4] !== documentType || $[5] !== onClose || $[6] !== release ? (t1 = /* @__PURE__ */ jsx(DeleteScheduledDraftDialogWithCopyToDraft, { documentId, documentType, onClose, release }), $[3] = documentId, $[4] = documentType, $[5] = onClose, $[6] = release, $[7] = t1) : t1 = $[7], t1;
}
function PublishScheduledDraftDialog(props2) {
  const $ = c(40), {
    onClose,
    release,
    documentType
  } = props2, {
    t
  } = useTranslation(), toast = useToast(), schema2 = useSchema(), operations = useScheduleDraftOperations(), [isPublishing, setIsPublishing] = useState(!1);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    includePreview: !0
  }, $[0] = t0) : t0 = $[0];
  const {
    firstDocument,
    firstDocumentPreview
  } = useScheduledDraftDocument(release._id, t0);
  let t1;
  $[1] !== documentType || $[2] !== schema2 ? (t1 = documentType ? schema2.get(documentType) : null, $[1] = documentType, $[2] = schema2, $[3] = t1) : t1 = $[3];
  const schemaType = t1;
  let t2;
  $[4] !== firstDocumentPreview?.title || $[5] !== onClose || $[6] !== operations || $[7] !== release || $[8] !== t || $[9] !== toast ? (t2 = async () => {
    setIsPublishing(!0);
    const run = async () => {
      await operations.publishScheduledDraft(release), toast.push({
        closable: !0,
        status: "success",
        description: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "release.toast.publish-scheduled-draft.success", values: {
          title: firstDocumentPreview?.title || t("preview.default.title-fallback")
        } })
      });
    };
    try {
      await run();
    } catch (t32) {
      const error = t32;
      console.error("Failed to run scheduled draft:", error), toast.push({
        closable: !0,
        status: "error",
        description: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "release.toast.publish-scheduled-draft.error", values: {
          title: firstDocumentPreview?.title || t("preview.default.title-fallback"),
          error: getErrorMessage$2(error)
        } })
      });
    }
    setIsPublishing(!1), onClose();
  }, $[4] = firstDocumentPreview?.title, $[5] = onClose, $[6] = operations, $[7] = release, $[8] = t, $[9] = toast, $[10] = t2) : t2 = $[10];
  const handlePublishScheduledDraft = t2;
  let t3;
  $[11] !== t ? (t3 = t("release.dialog.publish-scheduled-draft.header"), $[11] = t, $[12] = t3) : t3 = $[12];
  let t4;
  $[13] !== isPublishing || $[14] !== onClose ? (t4 = {
    disabled: isPublishing,
    onClick: onClose
  }, $[13] = isPublishing, $[14] = onClose, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== t ? (t5 = t("release.dialog.publish-scheduled-draft.confirm"), $[16] = t, $[17] = t5) : t5 = $[17];
  let t6;
  $[18] !== handlePublishScheduledDraft || $[19] !== isPublishing || $[20] !== t5 ? (t6 = {
    text: t5,
    tone: "primary",
    onClick: handlePublishScheduledDraft,
    disabled: isPublishing,
    loading: isPublishing
  }, $[18] = handlePublishScheduledDraft, $[19] = isPublishing, $[20] = t5, $[21] = t6) : t6 = $[21];
  let t7;
  $[22] !== t4 || $[23] !== t6 ? (t7 = {
    cancelButton: t4,
    confirmButton: t6
  }, $[22] = t4, $[23] = t6, $[24] = t7) : t7 = $[24];
  let t8;
  $[25] !== firstDocument || $[26] !== schemaType ? (t8 = schemaType && firstDocument ? /* @__PURE__ */ jsx(Preview$1, { value: firstDocument, schemaType }) : /* @__PURE__ */ jsx(LoadingBlock, {}), $[25] = firstDocument, $[26] = schemaType, $[27] = t8) : t8 = $[27];
  let t9;
  $[28] !== t ? (t9 = t("release.dialog.publish-scheduled-draft.body"), $[28] = t, $[29] = t9) : t9 = $[29];
  let t10;
  $[30] !== t9 ? (t10 = /* @__PURE__ */ jsx(Box, { paddingX: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t9 }) }), $[30] = t9, $[31] = t10) : t10 = $[31];
  let t11;
  $[32] !== t10 || $[33] !== t8 ? (t11 = /* @__PURE__ */ jsxs(Stack, { space: 3, paddingX: 3, marginBottom: 2, children: [
    t8,
    t10
  ] }), $[32] = t10, $[33] = t8, $[34] = t11) : t11 = $[34];
  let t12;
  return $[35] !== onClose || $[36] !== t11 || $[37] !== t3 || $[38] !== t7 ? (t12 = /* @__PURE__ */ jsx(Dialog$1, { id: "publish-scheduled-draft-dialog", "data-testid": "publish-scheduled-draft-dialog", header: t3, onClose, width: 0, padding: !1, footer: t7, children: t11 }), $[35] = onClose, $[36] = t11, $[37] = t3, $[38] = t7, $[39] = t12) : t12 = $[39], t12;
}
const SCHEDULE_DRAFT_DIALOG_CONFIG = {
  schedule: {
    headerI18nKey: "schedule-publish-dialog.header",
    descriptionI18nKey: "schedule-publish-dialog.description",
    confirmButtonTextI18nKey: "schedule-publish-dialog.confirm"
  },
  "edit-schedule": {
    headerI18nKey: "release.dialog.edit-schedule.header",
    descriptionI18nKey: "release.dialog.edit-schedule.body",
    confirmButtonTextI18nKey: "release.dialog.edit-schedule.confirm"
  }
};
function ScheduleDraftDialog(props2) {
  const $ = c(110), {
    onClose,
    onSchedule,
    variant,
    loading: t0,
    initialDate
  } = props2, loading = t0 === void 0 ? !1 : t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== initialDate ? (t1 = () => new Date(initialDate || /* @__PURE__ */ new Date()), $[0] = initialDate, $[1] = t1) : t1 = $[1];
  const [publishAt, setPublishAt] = useState(t1), {
    utcToCurrentZoneDate,
    zoneDateToUtc
  } = useTimeZone(CONTENT_RELEASES_TIME_ZONE_SCOPE);
  let T0, T1, T2, T3, _isScheduledDateInPast, t10, t11, t12, t13, t14, t15, t16, t17, t18, t19, t2, t20, t21, t3, t4, t5, t6, t7, t8, t9;
  if ($[2] !== loading || $[3] !== onClose || $[4] !== onSchedule || $[5] !== publishAt || $[6] !== t || $[7] !== utcToCurrentZoneDate || $[8] !== variant || $[9] !== zoneDateToUtc) {
    const timeZoneAdjustedPublishAt = publishAt ? utcToCurrentZoneDate(publishAt) : void 0;
    let t222;
    $[35] !== t ? (t222 = getCalendarLabels(t), $[35] = t, $[36] = t222) : t222 = $[36];
    const calendarLabels = t222, dialogConfig = SCHEDULE_DRAFT_DIALOG_CONFIG[variant];
    let t232;
    $[37] !== publishAt || $[38] !== zoneDateToUtc ? (t232 = () => publishAt ? isBefore(zoneDateToUtc(publishAt), /* @__PURE__ */ new Date()) : !0, $[37] = publishAt, $[38] = zoneDateToUtc, $[39] = t232) : t232 = $[39];
    const isScheduledDateInPast = t232;
    let t242;
    $[40] !== zoneDateToUtc ? (t242 = (date) => {
      date && setPublishAt(zoneDateToUtc(startOfMinute(date)));
    }, $[40] = zoneDateToUtc, $[41] = t242) : t242 = $[41];
    const handleDateTimeChange = t242;
    let t252;
    $[42] !== zoneDateToUtc ? (t252 = (event) => {
      const date_0 = event.currentTarget.value, parsedDate = zoneDateToUtc(parse(date_0, "PP HH:mm", /* @__PURE__ */ new Date()));
      isValid(parsedDate) && setPublishAt(parsedDate);
    }, $[42] = zoneDateToUtc, $[43] = t252) : t252 = $[43];
    const handleInputChange = t252;
    let t262;
    $[44] !== isScheduledDateInPast || $[45] !== onSchedule || $[46] !== publishAt ? (t262 = async () => {
      !publishAt || isScheduledDateInPast() || onSchedule(publishAt);
    }, $[44] = isScheduledDateInPast, $[45] = onSchedule, $[46] = publishAt, $[47] = t262) : t262 = $[47];
    const handleConfirmSchedule = t262;
    let t27;
    $[48] !== isScheduledDateInPast ? (t27 = isScheduledDateInPast(), $[48] = isScheduledDateInPast, $[49] = t27) : t27 = $[49], _isScheduledDateInPast = t27, T3 = Dialog$1, t16 = "schedule-draft-dialog", $[50] !== dialogConfig.headerI18nKey || $[51] !== t ? (t17 = t(dialogConfig.headerI18nKey), $[50] = dialogConfig.headerI18nKey, $[51] = t, $[52] = t17) : t17 = $[52], t18 = loading ? void 0 : onClose, t19 = 0, t20 = !1;
    let t28;
    $[53] !== dialogConfig.confirmButtonTextI18nKey || $[54] !== t ? (t28 = t(dialogConfig.confirmButtonTextI18nKey), $[53] = dialogConfig.confirmButtonTextI18nKey, $[54] = t, $[55] = t28) : t28 = $[55];
    const t29 = _isScheduledDateInPast || loading || !publishAt;
    let t30;
    $[56] !== handleConfirmSchedule || $[57] !== loading || $[58] !== t28 || $[59] !== t29 ? (t30 = {
      text: t28,
      tone: "primary",
      onClick: handleConfirmSchedule,
      loading,
      disabled: t29
    }, $[56] = handleConfirmSchedule, $[57] = loading, $[58] = t28, $[59] = t29, $[60] = t30) : t30 = $[60];
    let t31;
    $[61] !== loading ? (t31 = {
      disabled: loading
    }, $[61] = loading, $[62] = t31) : t31 = $[62], $[63] !== t30 || $[64] !== t31 ? (t21 = {
      confirmButton: t30,
      cancelButton: t31
    }, $[63] = t30, $[64] = t31, $[65] = t21) : t21 = $[65], T2 = Stack, t11 = 4, t12 = 4, t13 = 4, t14 = 1;
    let t32;
    $[66] !== dialogConfig.descriptionI18nKey || $[67] !== t ? (t32 = t(dialogConfig.descriptionI18nKey), $[66] = dialogConfig.descriptionI18nKey, $[67] = t, $[68] = t32) : t32 = $[68], $[69] !== t32 ? (t15 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t32 }), $[69] = t32, $[70] = t15) : t15 = $[70], T1 = Stack, t9 = 3;
    let t33;
    $[71] !== t ? (t33 = t("release.schedule-dialog.select-publish-date-label"), $[71] = t, $[72] = t33) : t33 = $[72], $[73] !== t33 ? (t10 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t33 }), $[73] = t33, $[74] = t10) : t10 = $[74], T0 = DateTimeInput$3, t2 = !0, t3 = MONTH_PICKER_VARIANT.carousel, t4 = handleDateTimeChange, t5 = handleInputChange, t6 = timeZoneAdjustedPublishAt, t7 = calendarLabels, t8 = timeZoneAdjustedPublishAt ? format(timeZoneAdjustedPublishAt, "PP HH:mm") : "", $[2] = loading, $[3] = onClose, $[4] = onSchedule, $[5] = publishAt, $[6] = t, $[7] = utcToCurrentZoneDate, $[8] = variant, $[9] = zoneDateToUtc, $[10] = T0, $[11] = T1, $[12] = T2, $[13] = T3, $[14] = _isScheduledDateInPast, $[15] = t10, $[16] = t11, $[17] = t12, $[18] = t13, $[19] = t14, $[20] = t15, $[21] = t16, $[22] = t17, $[23] = t18, $[24] = t19, $[25] = t2, $[26] = t20, $[27] = t21, $[28] = t3, $[29] = t4, $[30] = t5, $[31] = t6, $[32] = t7, $[33] = t8, $[34] = t9;
  } else
    T0 = $[10], T1 = $[11], T2 = $[12], T3 = $[13], _isScheduledDateInPast = $[14], t10 = $[15], t11 = $[16], t12 = $[17], t13 = $[18], t14 = $[19], t15 = $[20], t16 = $[21], t17 = $[22], t18 = $[23], t19 = $[24], t2 = $[25], t20 = $[26], t21 = $[27], t3 = $[28], t4 = $[29], t5 = $[30], t6 = $[31], t7 = $[32], t8 = $[33], t9 = $[34];
  let t22;
  $[75] !== T0 || $[76] !== t2 || $[77] !== t3 || $[78] !== t4 || $[79] !== t5 || $[80] !== t6 || $[81] !== t7 || $[82] !== t8 ? (t22 = /* @__PURE__ */ jsx(T0, { selectTime: t2, monthPickerVariant: t3, onChange: t4, onInputChange: t5, value: t6, calendarLabels: t7, inputValue: t8, constrainSize: !1, isPastDisabled: !0, showTimeZone: !0, timeZoneScope: CONTENT_RELEASES_TIME_ZONE_SCOPE }), $[75] = T0, $[76] = t2, $[77] = t3, $[78] = t4, $[79] = t5, $[80] = t6, $[81] = t7, $[82] = t8, $[83] = t22) : t22 = $[83];
  let t23;
  $[84] !== T1 || $[85] !== t10 || $[86] !== t22 || $[87] !== t9 ? (t23 = /* @__PURE__ */ jsx("label", { children: /* @__PURE__ */ jsxs(T1, { space: t9, children: [
    t10,
    t22
  ] }) }), $[84] = T1, $[85] = t10, $[86] = t22, $[87] = t9, $[88] = t23) : t23 = $[88];
  let t24;
  $[89] !== _isScheduledDateInPast || $[90] !== t ? (t24 = _isScheduledDateInPast && /* @__PURE__ */ jsx(Card, { marginBottom: 1, padding: 2, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("release.schedule-dialog.publish-date-in-past-warning") }) }), $[89] = _isScheduledDateInPast, $[90] = t, $[91] = t24) : t24 = $[91];
  let t25;
  $[92] !== T2 || $[93] !== t11 || $[94] !== t12 || $[95] !== t13 || $[96] !== t14 || $[97] !== t15 || $[98] !== t23 || $[99] !== t24 ? (t25 = /* @__PURE__ */ jsxs(T2, { space: t11, paddingX: t12, paddingBottom: t13, paddingTop: t14, children: [
    t15,
    t23,
    t24
  ] }), $[92] = T2, $[93] = t11, $[94] = t12, $[95] = t13, $[96] = t14, $[97] = t15, $[98] = t23, $[99] = t24, $[100] = t25) : t25 = $[100];
  let t26;
  return $[101] !== T3 || $[102] !== t16 || $[103] !== t17 || $[104] !== t18 || $[105] !== t19 || $[106] !== t20 || $[107] !== t21 || $[108] !== t25 ? (t26 = /* @__PURE__ */ jsx(T3, { id: t16, header: t17, onClose: t18, width: t19, padding: t20, footer: t21, children: t25 }), $[101] = T3, $[102] = t16, $[103] = t17, $[104] = t18, $[105] = t19, $[106] = t20, $[107] = t21, $[108] = t25, $[109] = t26) : t26 = $[109], t26;
}
function useScheduledDraftMenuActions(options) {
  const $ = c(66), {
    release,
    documentType,
    documentId,
    disabled: t0,
    onActionComplete
  } = options, disabled = t0 === void 0 ? !1 : t0, {
    t
  } = useTranslation(), toast = useToast(), operations = useScheduleDraftOperations(), [selectedAction, setSelectedAction] = useState(null), [isPerformingOperation, setIsPerformingOperation] = useState(!1), [isScheduling, setIsScheduling] = useState(!1);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    includePreview: !0
  }, $[0] = t1) : t1 = $[0];
  const {
    firstDocumentPreview,
    loading: documentLoading
  } = useScheduledDraftDocument(release?._id, t1);
  let t2;
  $[1] !== firstDocumentPreview?.title || $[2] !== onActionComplete || $[3] !== operations || $[4] !== release || $[5] !== t || $[6] !== toast ? (t2 = async () => {
    if (!release)
      return;
    setIsPerformingOperation(!0);
    const run = async () => {
      await operations.pauseScheduledDraft(release), onActionComplete?.();
    };
    try {
      await run();
    } catch (t32) {
      const error = t32;
      console.error("Failed to pause scheduled draft:", error), toast.push({
        closable: !0,
        status: "error",
        description: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "release.toast.pause-scheduled-draft.error", values: {
          title: firstDocumentPreview?.title || t("preview.default.title-fallback"),
          error: getErrorMessage$2(error)
        } })
      });
    }
    setIsPerformingOperation(!1), setSelectedAction(null);
  }, $[1] = firstDocumentPreview?.title, $[2] = onActionComplete, $[3] = operations, $[4] = release, $[5] = t, $[6] = toast, $[7] = t2) : t2 = $[7];
  const handleEditSchedule = t2;
  let t3;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (action) => {
    setSelectedAction(action);
  }, $[8] = t3) : t3 = $[8];
  const handleMenuItemClick = t3;
  let t4;
  $[9] !== isPerformingOperation ? (t4 = () => {
    isPerformingOperation || setSelectedAction(null);
  }, $[9] = isPerformingOperation, $[10] = t4) : t4 = $[10];
  const handleDialogClose = t4;
  let t5;
  $[11] !== handleDialogClose || $[12] !== operations || $[13] !== release || $[14] !== t || $[15] !== toast ? (t5 = async (publishAt) => {
    if (!release)
      return;
    setIsScheduling(!0);
    const run_0 = async () => {
      await operations.rescheduleScheduledDraft(release, publishAt), toast.push({
        closable: !0,
        status: "success",
        title: t("release.toast.schedule-publish.success")
      });
    };
    try {
      await run_0();
    } catch (t62) {
      const error_0 = t62;
      console.error("Failed to schedule draft:", error_0), toast.push({
        closable: !0,
        status: "error",
        title: t("release.toast.schedule-publish.error", {
          error: getErrorMessage$2(error_0)
        })
      });
    }
    setIsScheduling(!1), handleDialogClose();
  }, $[11] = handleDialogClose, $[12] = operations, $[13] = release, $[14] = t, $[15] = toast, $[16] = t5) : t5 = $[16];
  const handleSchedulePublish = t5, baseDisabled = disabled || isPerformingOperation || documentLoading;
  let t6;
  $[17] !== t ? (t6 = t("release.action.publish-now"), $[17] = t, $[18] = t6) : t6 = $[18];
  let t7;
  $[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = () => handleMenuItemClick("publish-now"), $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== baseDisabled || $[21] !== t6 ? (t8 = {
    icon: PublishIcon,
    text: t6,
    tone: "default",
    onClick: t7,
    disabled: baseDisabled,
    "data-testid": "publish-now-menu-item"
  }, $[20] = baseDisabled, $[21] = t6, $[22] = t8) : t8 = $[22];
  let t9;
  $[23] !== t ? (t9 = t("release.action.edit-schedule"), $[23] = t, $[24] = t9) : t9 = $[24];
  let t10;
  $[25] !== baseDisabled || $[26] !== handleEditSchedule || $[27] !== t9 ? (t10 = {
    icon: EditIcon,
    text: t9,
    tone: "default",
    onClick: handleEditSchedule,
    disabled: baseDisabled,
    "data-testid": "edit-schedule-menu-item"
  }, $[25] = baseDisabled, $[26] = handleEditSchedule, $[27] = t9, $[28] = t10) : t10 = $[28];
  let t11;
  $[29] !== t ? (t11 = t("release.action.schedule-publish"), $[29] = t, $[30] = t11) : t11 = $[30];
  let t12;
  $[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = () => handleMenuItemClick("schedule-publish"), $[31] = t12) : t12 = $[31];
  let t13;
  $[32] !== baseDisabled || $[33] !== t11 ? (t13 = {
    icon: CalendarIcon,
    text: t11,
    tone: "default",
    onClick: t12,
    disabled: baseDisabled,
    "data-testid": "schedule-publish-menu-item"
  }, $[32] = baseDisabled, $[33] = t11, $[34] = t13) : t13 = $[34];
  let t14;
  $[35] !== t ? (t14 = t("release.action.delete-schedule"), $[35] = t, $[36] = t14) : t14 = $[36];
  let t15;
  $[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = () => handleMenuItemClick("delete-schedule"), $[37] = t15) : t15 = $[37];
  let t16;
  $[38] !== baseDisabled || $[39] !== t14 ? (t16 = {
    icon: TrashIcon,
    text: t14,
    tone: "critical",
    onClick: t15,
    disabled: baseDisabled,
    "data-testid": "delete-schedule-menu-item"
  }, $[38] = baseDisabled, $[39] = t14, $[40] = t16) : t16 = $[40];
  let t17;
  $[41] !== t10 || $[42] !== t13 || $[43] !== t16 || $[44] !== t8 ? (t17 = {
    publishNow: t8,
    editSchedule: t10,
    schedulePublish: t13,
    deleteSchedule: t16
  }, $[41] = t10, $[42] = t13, $[43] = t16, $[44] = t8, $[45] = t17) : t17 = $[45];
  const actions = t17;
  let t18;
  bb0: {
    if (!selectedAction || !release) {
      t18 = null;
      break bb0;
    }
    switch (selectedAction) {
      case "publish-now": {
        let t192;
        $[46] !== documentType || $[47] !== handleDialogClose || $[48] !== release ? (t192 = /* @__PURE__ */ jsx(PublishScheduledDraftDialog, { release, documentType, onClose: handleDialogClose }), $[46] = documentType, $[47] = handleDialogClose, $[48] = release, $[49] = t192) : t192 = $[49], t18 = t192;
        break bb0;
      }
      case "delete-schedule": {
        let t192;
        $[50] !== documentId || $[51] !== documentType || $[52] !== handleDialogClose || $[53] !== release ? (t192 = /* @__PURE__ */ jsx(DeleteScheduledDraftDialog, { release, documentType, documentId, onClose: handleDialogClose }), $[50] = documentId, $[51] = documentType, $[52] = handleDialogClose, $[53] = release, $[54] = t192) : t192 = $[54], t18 = t192;
        break bb0;
      }
      case "schedule-publish": {
        const t192 = release?.metadata?.intendedPublishAt;
        let t20;
        $[55] !== handleDialogClose || $[56] !== handleSchedulePublish || $[57] !== isScheduling || $[58] !== t192 ? (t20 = /* @__PURE__ */ jsx(ScheduleDraftDialog, { onClose: handleDialogClose, onSchedule: handleSchedulePublish, variant: "schedule", loading: isScheduling, initialDate: t192 }), $[55] = handleDialogClose, $[56] = handleSchedulePublish, $[57] = isScheduling, $[58] = t192, $[59] = t20) : t20 = $[59], t18 = t20;
        break bb0;
      }
      default:
        t18 = null;
    }
  }
  const dialogs = t18;
  let t19;
  return $[60] !== actions || $[61] !== dialogs || $[62] !== handleDialogClose || $[63] !== isPerformingOperation || $[64] !== selectedAction ? (t19 = {
    actions,
    dialogs,
    isPerformingOperation,
    selectedAction,
    handleDialogClose
  }, $[60] = actions, $[61] = dialogs, $[62] = handleDialogClose, $[63] = isPerformingOperation, $[64] = selectedAction, $[65] = t19) : t19 = $[65], t19;
}
const ScheduledDraftMenuButtonWrapper = (t0) => {
  const $ = c(56), {
    release
  } = t0, {
    t
  } = useTranslation(), router = useRouter(), popoverRef = useRef(null), scheduledDraftMenuRef = useRef(null), [openPopover, setOpenPopover] = useState(!1), {
    firstDocument: scheduledDraftDocument
  } = useScheduledDraftDocument(release._id);
  let t1;
  $[0] !== release._id || $[1] !== router || $[2] !== scheduledDraftDocument ? (t1 = () => {
    scheduledDraftDocument && router.navigateIntent("edit", {
      id: getPublishedId(scheduledDraftDocument._id),
      type: scheduledDraftDocument._type,
      scheduledDraft: getReleaseIdFromReleaseDocumentId(release._id)
    });
  }, $[0] = release._id, $[1] = router, $[2] = scheduledDraftDocument, $[3] = t1) : t1 = $[3];
  const handleActionComplete = t1, t2 = scheduledDraftDocument?._type, t3 = scheduledDraftDocument?._id, t4 = !scheduledDraftDocument;
  let t5;
  $[4] !== handleActionComplete || $[5] !== release || $[6] !== t2 || $[7] !== t3 || $[8] !== t4 ? (t5 = {
    release,
    documentType: t2,
    documentId: t3,
    disabled: t4,
    onActionComplete: handleActionComplete
  }, $[4] = handleActionComplete, $[5] = release, $[6] = t2, $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9];
  const {
    actions,
    dialogs,
    isPerformingOperation
  } = useScheduledDraftMenuActions(t5);
  let t6;
  bb0: {
    if (release.state === "archived" || release.state === "published") {
      let t73;
      $[10] !== actions.deleteSchedule ? (t73 = [/* @__PURE__ */ jsx(MenuItem, { ...actions.deleteSchedule }, "delete-schedule")], $[10] = actions.deleteSchedule, $[11] = t73) : t73 = $[11], t6 = t73;
      break bb0;
    }
    if (isPausedCardinalityOneRelease(release)) {
      let t73;
      $[12] !== actions.publishNow ? (t73 = /* @__PURE__ */ jsx(MenuItem, { ...actions.publishNow }, "publish-now"), $[12] = actions.publishNow, $[13] = t73) : t73 = $[13];
      let t83;
      $[14] !== actions.schedulePublish ? (t83 = /* @__PURE__ */ jsx(MenuItem, { ...actions.schedulePublish }, "schedule-publish"), $[14] = actions.schedulePublish, $[15] = t83) : t83 = $[15];
      let t93;
      $[16] !== actions.deleteSchedule ? (t93 = /* @__PURE__ */ jsx(MenuItem, { ...actions.deleteSchedule }, "delete-schedule"), $[16] = actions.deleteSchedule, $[17] = t93) : t93 = $[17];
      let t103;
      $[18] !== t73 || $[19] !== t83 || $[20] !== t93 ? (t103 = [t73, t83, t93], $[18] = t73, $[19] = t83, $[20] = t93, $[21] = t103) : t103 = $[21], t6 = t103;
      break bb0;
    }
    let t72;
    $[22] !== actions.publishNow ? (t72 = /* @__PURE__ */ jsx(MenuItem, { ...actions.publishNow }, "publish-now"), $[22] = actions.publishNow, $[23] = t72) : t72 = $[23];
    let t82;
    $[24] !== actions.editSchedule ? (t82 = /* @__PURE__ */ jsx(MenuItem, { ...actions.editSchedule }, "edit-schedule"), $[24] = actions.editSchedule, $[25] = t82) : t82 = $[25];
    let t92;
    $[26] !== actions.deleteSchedule ? (t92 = /* @__PURE__ */ jsx(MenuItem, { ...actions.deleteSchedule }, "delete-schedule"), $[26] = actions.deleteSchedule, $[27] = t92) : t92 = $[27];
    let t102;
    $[28] !== t72 || $[29] !== t82 || $[30] !== t92 ? (t102 = [t72, t82, t92], $[28] = t72, $[29] = t82, $[30] = t92, $[31] = t102) : t102 = $[31], t6 = t102;
  }
  const displayedMenuItems = t6, canPerformActions = !!scheduledDraftDocument;
  let t7;
  $[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = () => {
    setOpenPopover(_temp$1H);
  }, $[32] = t7) : t7 = $[32];
  const handleOnButtonClick = t7;
  let t8, t9;
  if ($[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = () => setOpenPopover(!1), t9 = () => [popoverRef.current, scheduledDraftMenuRef.current], $[33] = t8, $[34] = t9) : (t8 = $[33], t9 = $[34]), useClickOutsideEvent(t8, t9), !canPerformActions)
    return null;
  let t10;
  $[35] !== displayedMenuItems ? (t10 = /* @__PURE__ */ jsx(Menu, { ref: scheduledDraftMenuRef, children: displayedMenuItems }), $[35] = displayedMenuItems, $[36] = t10) : t10 = $[36];
  let t11;
  $[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = ["top-end"], $[37] = t11) : t11 = $[37];
  const t12 = !canPerformActions || isPerformingOperation, t13 = isPerformingOperation ? Spinner : EllipsisHorizontalIcon;
  let t14;
  $[38] !== t ? (t14 = t("release.menu.tooltip"), $[38] = t, $[39] = t14) : t14 = $[39];
  let t15;
  $[40] !== t14 ? (t15 = {
    content: t14
  }, $[40] = t14, $[41] = t15) : t15 = $[41];
  let t16;
  $[42] !== t ? (t16 = t("release.menu.label"), $[42] = t, $[43] = t16) : t16 = $[43];
  let t17;
  $[44] !== t12 || $[45] !== t13 || $[46] !== t15 || $[47] !== t16 ? (t17 = /* @__PURE__ */ jsx(Button, { disabled: t12, icon: t13, mode: "bleed", tooltipProps: t15, "aria-label": t16, "data-testid": "scheduled-draft-menu-button", onClick: handleOnButtonClick }), $[44] = t12, $[45] = t13, $[46] = t15, $[47] = t16, $[48] = t17) : t17 = $[48];
  let t18;
  $[49] !== openPopover || $[50] !== t10 || $[51] !== t17 ? (t18 = /* @__PURE__ */ jsx(Popover, { content: t10, open: openPopover, ref: popoverRef, constrainSize: !1, fallbackPlacements: t11, portal: !0, tone: "default", placement: "bottom", children: t17 }), $[49] = openPopover, $[50] = t10, $[51] = t17, $[52] = t18) : t18 = $[52];
  let t19;
  return $[53] !== dialogs || $[54] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t18,
    dialogs
  ] }), $[53] = dialogs, $[54] = t18, $[55] = t19) : t19 = $[55], t19;
};
function _temp$1H(prev) {
  return !prev;
}
const singleDocReleaseNamespace = "singleDocRelease", singleDocReleaseUsEnglishLocaleBundle = {
  locale: "en-US",
  namespace: singleDocReleaseNamespace,
  resources: () => import("./_chunks-es/resources6.js")
}, ScheduledDraftsEmptyState = () => {
  const $ = c(19), {
    t
  } = useTranslation(singleDocReleaseNamespace), {
    mode
  } = useSingleDocReleaseEnabled();
  if (mode === "upsell")
    return null;
  let t0, t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    maxWidth: "300px"
  }, t1 = /* @__PURE__ */ jsx(ReleaseIllustration, {}), $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]);
  let t2;
  $[2] !== t ? (t2 = t("empty-state.title"), $[2] = t, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { as: "h1", size: 1, weight: "semibold", "data-testid": "no-releases-info-text", children: t2 }), $[4] = t2, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    textAlign: "center"
  }, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t ? (t5 = t("empty-state.description"), $[7] = t, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t5 ? (t6 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, style: t4, children: t5 }), $[9] = t5, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== t ? (t7 = t("empty-state.action.documentation"), $[11] = t, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { as: "a", href: "https://www.sanity.io/docs/studio/scheduled-drafts-user-guide", target: "_blank", mode: "ghost", text: t7 }), $[13] = t7, $[14] = t8) : t8 = $[14];
  let t9;
  return $[15] !== t3 || $[16] !== t6 || $[17] !== t8 ? (t9 = /* @__PURE__ */ jsx(Flex, { direction: "column", flex: 1, justify: "center", align: "center", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, direction: "column", align: "center", style: t0, children: [
    t1,
    t3,
    t6,
    t8
  ] }) }), $[15] = t3, $[16] = t6, $[17] = t8, $[18] = t9) : t9 = $[18], t9;
}, ScheduledDraftDocumentPreview = (t0) => {
  const $ = c(52), {
    datum: release,
    cellProps
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    firstDocument,
    firstDocumentValidation,
    loading: documentsLoading
  } = useScheduledDraftDocument(release._id && !release.isLoading ? release._id : void 0);
  if (release.isLoading || documentsLoading || !firstDocument) {
    let t16;
    $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = /* @__PURE__ */ jsx(Skeleton, { animated: !0, radius: 2, style: {
      height: "32px",
      width: "100%"
    } }), $[0] = t16) : t16 = $[0];
    let t22;
    return $[1] !== cellProps ? (t22 = /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, sizing: "border", children: t16 }), $[1] = cellProps, $[2] = t22) : t22 = $[2], t22;
  }
  let T0, T1, T2, t1, t10, t11, t12, t2, t3, t4, t5, t6, t7, t8, t9;
  if ($[3] !== cellProps || $[4] !== firstDocument._id || $[5] !== firstDocument._rev || $[6] !== firstDocument._type || $[7] !== firstDocumentValidation || $[8] !== release._id || $[9] !== release.state || $[10] !== t) {
    const validationErrorCount = firstDocumentValidation?.filter(_temp$1G).length || 0;
    T2 = Box, t7 = cellProps, t8 = 1, t9 = 1, t10 = 2, t11 = 2, t12 = "border", T1 = Card, t5 = validationErrorCount ? "critical" : "inherit", t6 = 2, T0 = Flex, t1 = "center", t2 = 2, $[26] !== firstDocument._id || $[27] !== firstDocument._rev || $[28] !== firstDocument._type || $[29] !== release._id || $[30] !== release.state ? (t3 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(ReleaseDocumentPreview, { documentId: firstDocument._id, documentTypeName: firstDocument._type, releaseId: release._id, releaseState: release.state, isCardinalityOneRelease: !0, documentRevision: firstDocument._rev, layout: "default" }) }), $[26] = firstDocument._id, $[27] = firstDocument._rev, $[28] = firstDocument._type, $[29] = release._id, $[30] = release.state, $[31] = t3) : t3 = $[31], t4 = validationErrorCount > 0 && /* @__PURE__ */ jsx(Box, { paddingRight: 3, children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, placement: "bottom-end", content: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, padding: 1, children: [
      /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: "critical" }),
      t("document-validation.error", {
        count: validationErrorCount
      })
    ] }) }), children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: "critical" }) }) }) }), $[3] = cellProps, $[4] = firstDocument._id, $[5] = firstDocument._rev, $[6] = firstDocument._type, $[7] = firstDocumentValidation, $[8] = release._id, $[9] = release.state, $[10] = t, $[11] = T0, $[12] = T1, $[13] = T2, $[14] = t1, $[15] = t10, $[16] = t11, $[17] = t12, $[18] = t2, $[19] = t3, $[20] = t4, $[21] = t5, $[22] = t6, $[23] = t7, $[24] = t8, $[25] = t9;
  } else
    T0 = $[11], T1 = $[12], T2 = $[13], t1 = $[14], t10 = $[15], t11 = $[16], t12 = $[17], t2 = $[18], t3 = $[19], t4 = $[20], t5 = $[21], t6 = $[22], t7 = $[23], t8 = $[24], t9 = $[25];
  let t13;
  $[32] !== T0 || $[33] !== t1 || $[34] !== t2 || $[35] !== t3 || $[36] !== t4 ? (t13 = /* @__PURE__ */ jsxs(T0, { align: t1, gap: t2, children: [
    t3,
    t4
  ] }), $[32] = T0, $[33] = t1, $[34] = t2, $[35] = t3, $[36] = t4, $[37] = t13) : t13 = $[37];
  let t14;
  $[38] !== T1 || $[39] !== t13 || $[40] !== t5 || $[41] !== t6 ? (t14 = /* @__PURE__ */ jsx(T1, { tone: t5, radius: t6, children: t13 }), $[38] = T1, $[39] = t13, $[40] = t5, $[41] = t6, $[42] = t14) : t14 = $[42];
  let t15;
  return $[43] !== T2 || $[44] !== t10 || $[45] !== t11 || $[46] !== t12 || $[47] !== t14 || $[48] !== t7 || $[49] !== t8 || $[50] !== t9 ? (t15 = /* @__PURE__ */ jsx(T2, { ...t7, flex: t8, padding: t9, paddingLeft: t10, paddingRight: t11, sizing: t12, children: t14 }), $[43] = T2, $[44] = t10, $[45] = t11, $[46] = t12, $[47] = t14, $[48] = t7, $[49] = t8, $[50] = t9, $[51] = t15) : t15 = $[51], t15;
};
function _temp$1G(validation2) {
  return validation2.level === "error";
}
function useReleaseCreator(releaseDocumentId, t0) {
  const $ = c(7), isLoading = t0 === void 0 ? !1 : t0;
  let t1;
  $[0] !== isLoading || $[1] !== releaseDocumentId ? (t1 = releaseDocumentId && !isLoading ? getReleaseIdFromReleaseDocumentId(releaseDocumentId) : "", $[0] = isLoading, $[1] = releaseDocumentId, $[2] = t1) : t1 = $[2];
  const releaseId = t1, {
    firstDocument,
    loading: documentsLoading
  } = useScheduledDraftDocument(releaseDocumentId), {
    documentHistory,
    loading: historyLoading
  } = useReleaseHistory(firstDocument?._id, releaseId);
  if (!releaseDocumentId || isLoading) {
    let t22;
    return $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = {
      createdBy: void 0,
      loading: !1
    }, $[3] = t22) : t22 = $[3], t22;
  }
  if (documentsLoading || historyLoading) {
    let t22;
    return $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = {
      createdBy: void 0,
      loading: !0
    }, $[4] = t22) : t22 = $[4], t22;
  }
  const t2 = documentHistory?.createdBy;
  let t3;
  return $[5] !== t2 ? (t3 = {
    createdBy: t2,
    loading: !1
  }, $[5] = t2, $[6] = t3) : t3 = $[6], t3;
}
const ScheduledDraftMetadataCell = (t0) => {
  const $ = c(17), {
    datum,
    cellProps
  } = t0, {
    createdBy,
    loading: creatorLoading
  } = useReleaseCreator(datum.isLoading ? void 0 : datum._id, datum.isLoading);
  if (datum.isLoading || !datum.metadata) {
    let t12;
    $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(Skeleton, { animated: !0, radius: 2, style: {
      height: "40px",
      width: "150px"
    } }), $[0] = t12) : t12 = $[0];
    let t22;
    return $[1] !== cellProps ? (t22 = /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, sizing: "border", children: t12 }), $[1] = cellProps, $[2] = t22) : t22 = $[2], t22;
  }
  let t1;
  $[3] !== creatorLoading ? (t1 = creatorLoading && /* @__PURE__ */ jsx(AvatarSkeleton$1, { $size: 1, animated: !0 }), $[3] = creatorLoading, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== createdBy || $[6] !== creatorLoading ? (t2 = !creatorLoading && createdBy && /* @__PURE__ */ jsx(UserAvatar, { user: createdBy, size: 1 }), $[5] = createdBy, $[6] = creatorLoading, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== datum ? (t3 = /* @__PURE__ */ jsx(Stack, { space: 1, children: /* @__PURE__ */ jsx(ReleaseTime, { release: datum }) }), $[8] = datum, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t1 || $[11] !== t2 || $[12] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t1,
    t2,
    t3
  ] }), $[10] = t1, $[11] = t2, $[12] = t3, $[13] = t4) : t4 = $[13];
  let t5;
  return $[14] !== cellProps || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, sizing: "border", children: t4 }), $[14] = cellProps, $[15] = t4, $[16] = t5) : t5 = $[16], t5;
}, ScheduledDraftWarningCell = (t0) => {
  const $ = c(8), {
    datum,
    cellProps
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t1;
  $[0] !== datum ? (t1 = datum.state === "active" && getIsScheduledDateInPast(datum), $[0] = datum, $[1] = t1) : t1 = $[1];
  const hasWarning = t1;
  let t2;
  $[2] !== hasWarning || $[3] !== t ? (t2 = hasWarning && /* @__PURE__ */ jsx(Tooltip, { content: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("passed-intended-publish-date-draft") }), portal: !0, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToneIcon, { icon: WarningOutlineIcon, tone: "caution" }) }) }), $[2] = hasWarning, $[3] = t, $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== cellProps || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", gap: 2, paddingX: 2, paddingY: 3, sizing: "border", "data-testid": "warning-indicator", children: t2 }), $[5] = cellProps, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}, scheduledDraftsOverviewColumnDefs = (t, releaseGroupMode) => [{
  id: "documentPreview",
  sorting: !1,
  width: null,
  style: {
    flex: 1
  },
  header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingLeft: 2, paddingRight: 2, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.BasicHeader, { text: t("table-header.document") }) }),
  cell: ScheduledDraftDocumentPreview
}, {
  id: "publishAt",
  sorting: !0,
  width: 300,
  header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, paddingX: 2, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { ...props2, text: t(releaseGroupMode === "archived" ? "table-header.scheduled-draft.published-at" : releaseGroupMode === "paused" ? "table-header.intended-for" : "table-header.scheduled-for") }) }),
  cell: ScheduledDraftMetadataCell
}, {
  id: "warning",
  sorting: !1,
  width: 40,
  header: ({
    headerProps
  }) => /* @__PURE__ */ jsx(Flex, { ...headerProps, paddingY: 3, sizing: "border" }),
  cell: ScheduledDraftWarningCell
}];
function SingleDocReleaseUpsellProvider(props2) {
  const $ = c(9);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    dataUri: "/journey/scheduled-drafts",
    feature: "single_doc_release"
  }, $[0] = t0) : t0 = $[0];
  const contextValue = useUpsellContext(t0), t1 = props2.children;
  let t2;
  $[1] !== contextValue ? (t2 = getDialogPropsFromContext(contextValue), $[1] = contextValue, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(UpsellDialog, { ...t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== contextValue || $[6] !== props2.children || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(SingleDocReleaseUpsellContext.Provider, { value: contextValue, children: [
    t1,
    t3
  ] }), $[5] = contextValue, $[6] = props2.children, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
function useSingleDocReleaseUpsell() {
  return useContext(SingleDocReleaseUpsellContext);
}
const Image$4 = /* @__PURE__ */ styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-17dkvy4-0"
})((props2) => {
  const {
    media
  } = getTheme_v2(props2.theme), responsiveStyles = _responsive(media, props2.$direction, (val) => ({
    width: val === "row" ? "50%" : "100%",
    height: val === "row" ? "auto" : "180px"
  }));
  return css`
    object-fit: cover;
    ${responsiveStyles}
  `;
}), DescriptionRoot = styled(Box).withConfig({
  displayName: "DescriptionRoot",
  componentId: "sc-17dkvy4-1"
})`margin:auto 0;`, HORIZONTAL_PADDING_Y = [3, 3, 5];
function UpsellPanel(props2) {
  const $ = c(35), {
    data,
    onPrimaryClick,
    onSecondaryClick,
    layout: t0,
    border: t1,
    align: t2
  } = props2, layout = t0 === void 0 ? "vertical" : t0, border = t1 === void 0 ? !0 : t1, align2 = t2 === void 0 ? "flex-start" : t2, t3 = layout === "horizontal" ? "row" : "column";
  let t4;
  $[0] !== t3 ? (t4 = ["column", "column", t3], $[0] = t3, $[1] = t4) : t4 = $[1];
  const direction = t4;
  let t5;
  $[2] !== data.image || $[3] !== direction ? (t5 = data.image && /* @__PURE__ */ jsx(Image$4, { src: data.image.asset.url, alt: data.image.asset.altText ?? "", $direction: direction }), $[2] = data.image, $[3] = direction, $[4] = t5) : t5 = $[4];
  const t6 = layout === "horizontal" ? HORIZONTAL_PADDING_Y : 3;
  let t7;
  $[5] !== data.descriptionText ? (t7 = /* @__PURE__ */ jsx(UpsellDescriptionSerializer, { blocks: data.descriptionText }), $[5] = data.descriptionText, $[6] = t7) : t7 = $[6];
  let t8;
  $[7] !== align2 || $[8] !== t7 ? (t8 = /* @__PURE__ */ jsx(Flex, { gap: 4, direction: "column", align: align2, children: t7 }), $[7] = align2, $[8] = t7, $[9] = t8) : t8 = $[9];
  const t9 = align2 === "center" ? "center" : "flex-end";
  let t10;
  $[10] !== data.secondaryButton.text || $[11] !== data.secondaryButton.url || $[12] !== onSecondaryClick ? (t10 = data.secondaryButton.text && /* @__PURE__ */ jsx(Button, { mode: "bleed", text: data.secondaryButton.text, tone: "default", iconRight: LaunchIcon, ...data.secondaryButton.url && {
    target: "_blank",
    rel: "noopener noreferrer",
    as: "a",
    href: data.secondaryButton.url
  }, onClick: onSecondaryClick }), $[10] = data.secondaryButton.text, $[11] = data.secondaryButton.url, $[12] = onSecondaryClick, $[13] = t10) : t10 = $[13];
  let t11;
  $[14] !== data.ctaButton.url ? (t11 = data.ctaButton.url && {
    target: "_blank",
    rel: "noopener noreferrer",
    as: "a",
    href: data.ctaButton.url
  }, $[14] = data.ctaButton.url, $[15] = t11) : t11 = $[15];
  let t12;
  $[16] !== data.ctaButton.text || $[17] !== onPrimaryClick || $[18] !== t11 ? (t12 = /* @__PURE__ */ jsx(Button, { text: data.ctaButton.text, tone: "default", ...t11, onClick: onPrimaryClick }), $[16] = data.ctaButton.text, $[17] = onPrimaryClick, $[18] = t11, $[19] = t12) : t12 = $[19];
  let t13;
  $[20] !== t10 || $[21] !== t12 || $[22] !== t9 ? (t13 = /* @__PURE__ */ jsxs(Flex, { gap: 2, justify: t9, marginTop: 5, children: [
    t10,
    t12
  ] }), $[20] = t10, $[21] = t12, $[22] = t9, $[23] = t13) : t13 = $[23];
  let t14;
  $[24] !== t13 || $[25] !== t6 || $[26] !== t8 ? (t14 = /* @__PURE__ */ jsxs(DescriptionRoot, { paddingX: 3, paddingY: t6, children: [
    t8,
    t13
  ] }), $[24] = t13, $[25] = t6, $[26] = t8, $[27] = t14) : t14 = $[27];
  let t15;
  $[28] !== direction || $[29] !== t14 || $[30] !== t5 ? (t15 = /* @__PURE__ */ jsxs(Flex, { direction, gap: 2, children: [
    t5,
    t14
  ] }), $[28] = direction, $[29] = t14, $[30] = t5, $[31] = t15) : t15 = $[31];
  let t16;
  return $[32] !== border || $[33] !== t15 ? (t16 = /* @__PURE__ */ jsx(Card, { radius: 3, overflow: "hidden", border, children: t15 }), $[32] = border, $[33] = t15, $[34] = t16) : t16 = $[34], t16;
}
const Panel$1 = styled(Container$3).withConfig({
  displayName: "Panel",
  componentId: "sc-16xjvaf-0"
})`width:auto;flex-shrink:0;`, SingleDocReleasesUpsell = () => {
  const $ = c(14), {
    mode
  } = useSingleDocReleaseEnabled(), {
    upsellData,
    telemetryLogs
  } = useSingleDocReleaseUpsell();
  let t0;
  $[0] !== telemetryLogs ? (t0 = () => {
    telemetryLogs.panelPrimaryClicked();
  }, $[0] = telemetryLogs, $[1] = t0) : t0 = $[1];
  const handlePrimaryClick = t0;
  let t1;
  $[2] !== telemetryLogs ? (t1 = () => {
    telemetryLogs.panelSecondaryClicked();
  }, $[2] = telemetryLogs, $[3] = t1) : t1 = $[3];
  const handleSecondaryClick = t1;
  if (mode !== "upsell" || !upsellData)
    return null;
  let t2, t3, t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    opacity: 0
  }, t3 = {
    opacity: 1
  }, t4 = {
    duration: 0.3,
    ease: "easeInOut"
  }, $[4] = t2, $[5] = t3, $[6] = t4) : (t2 = $[4], t3 = $[5], t4 = $[6]);
  let t5;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(ReleaseIllustration, {}), $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== upsellData ? (t6 = {
    ...upsellData,
    image: null
  }, $[8] = upsellData, $[9] = t6) : t6 = $[9];
  let t7;
  return $[10] !== handlePrimaryClick || $[11] !== handleSecondaryClick || $[12] !== t6 ? (t7 = /* @__PURE__ */ jsx(Flex, { direction: "column", flex: 1, justify: "center", align: "center", children: /* @__PURE__ */ jsx(motion.div, { initial: t2, animate: t3, transition: t4, children: /* @__PURE__ */ jsx(Panel$1, { width: 0, padding: 4, paddingY: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", direction: "column", children: [
    t5,
    /* @__PURE__ */ jsx(Box, { paddingTop: 2, children: /* @__PURE__ */ jsx(UpsellPanel, { align: "center", layout: "vertical", data: t6, border: !1, onPrimaryClick: handlePrimaryClick, onSecondaryClick: handleSecondaryClick }) })
  ] }) }) }) }), $[10] = handlePrimaryClick, $[11] = handleSecondaryClick, $[12] = t6, $[13] = t7) : t7 = $[13], t7;
}, ReleasesUpsell = () => {
  const $ = c(14), {
    upsellData,
    telemetryLogs,
    mode
  } = useReleasesUpsell();
  let t0;
  $[0] !== telemetryLogs ? (t0 = () => {
    telemetryLogs.panelPrimaryClicked();
  }, $[0] = telemetryLogs, $[1] = t0) : t0 = $[1];
  const handlePrimaryClick = t0;
  let t1;
  $[2] !== telemetryLogs ? (t1 = () => {
    telemetryLogs.panelSecondaryClicked();
  }, $[2] = telemetryLogs, $[3] = t1) : t1 = $[3];
  const handleSecondaryClick = t1;
  if (!upsellData || mode === "default")
    return null;
  let t2, t3, t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    opacity: 0
  }, t3 = {
    opacity: 1
  }, t4 = {
    duration: 0.3,
    ease: "easeInOut"
  }, $[4] = t2, $[5] = t3, $[6] = t4) : (t2 = $[4], t3 = $[5], t4 = $[6]);
  let t5;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(ReleaseIllustration, {}), $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== upsellData ? (t6 = {
    ...upsellData,
    image: null
  }, $[8] = upsellData, $[9] = t6) : t6 = $[9];
  let t7;
  return $[10] !== handlePrimaryClick || $[11] !== handleSecondaryClick || $[12] !== t6 ? (t7 = /* @__PURE__ */ jsx(Flex, { direction: "column", flex: 1, justify: "center", align: "center", children: /* @__PURE__ */ jsx(motion.div, { initial: t2, animate: t3, transition: t4, children: /* @__PURE__ */ jsx(Panel$1, { width: 0, padding: 4, paddingY: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", direction: "column", children: [
    t5,
    /* @__PURE__ */ jsx(Box, { paddingTop: 2, children: /* @__PURE__ */ jsx(UpsellPanel, { align: "center", layout: "vertical", data: t6, border: !1, onPrimaryClick: handlePrimaryClick, onSecondaryClick: handleSecondaryClick }) })
  ] }) }) }) }), $[10] = handlePrimaryClick, $[11] = handleSecondaryClick, $[12] = t6, $[13] = t7) : t7 = $[13], t7;
};
function SchedulesUpsell(t0) {
  const $ = c(2), {
    cardinalityView
  } = t0;
  if (cardinalityView === "drafts") {
    let t1;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(SingleDocReleasesUpsell, {}), $[0] = t1) : t1 = $[0], t1;
  }
  if (cardinalityView === "releases") {
    let t1;
    return $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(ReleasesUpsell, {}), $[1] = t1) : t1 = $[1], t1;
  }
  return null;
}
const MotionButton = motion.create(Button), DEFAULT_RELEASES_OVERVIEW_SORT = {
  column: "publishAt",
  direction: "asc"
}, DEFAULT_ARCHIVED_RELEASES_OVERVIEW_SORT = {
  column: "lastActivity",
  direction: "desc"
};
function toLocalDateComponents(utcDate, utcToZoneDate) {
  const tz2 = utcToZoneDate(utcDate);
  return new Date(tz2.getFullYear(), tz2.getMonth(), tz2.getDate());
}
function ReleasesOverview() {
  const $ = c(226), {
    data: allReleases,
    loading: loadingReleases
  } = useActiveReleases(), {
    data: allArchivedReleases
  } = useArchivedReleases(), {
    mode: releasesUpsellMode,
    handleOpenDialog: handleOpenReleasesUpsellDialog
  } = useReleasesUpsell(), {
    mode: scheduledDraftsMode
  } = useSingleDocReleaseEnabled(), isScheduledDraftsEnabled = useScheduledDraftsEnabled(), {
    document: document2,
    releases: releasesConfig
  } = useWorkspace(), isReleasesEnabled = !!releasesConfig?.enabled, isDraftModelEnabled = document2?.drafts?.enabled, router = useRouter(), navigateRef = useRef(router.navigate);
  let t0;
  $[0] !== router ? (t0 = getInitialReleaseGroupMode(router), $[0] = router, $[1] = t0) : t0 = $[1];
  const [releaseGroupMode, setReleaseGroupMode] = useState(t0);
  let t1;
  $[2] !== isReleasesEnabled || $[3] !== isScheduledDraftsEnabled || $[4] !== router ? (t1 = getInitialCardinalityView({
    router,
    isScheduledDraftsEnabled,
    isReleasesEnabled
  }), $[2] = isReleasesEnabled, $[3] = isScheduledDraftsEnabled, $[4] = router, $[5] = t1) : t1 = $[5];
  const [cardinalityView, setCardinalityView] = useState(t1), viewFromUrl = new URLSearchParams(router.state._searchParams).get("view") === "drafts" ? "drafts" : "releases";
  viewFromUrl !== cardinalityView && setCardinalityView(viewFromUrl);
  let t2;
  $[6] !== router ? (t2 = getInitialFilterDate(router), $[6] = router, $[7] = t2) : t2 = $[7];
  const [releaseFilterDate, setReleaseFilterDate] = useState(t2);
  let t3;
  $[8] !== router ? (t3 = () => getInitialReleaseNotFound(router), $[8] = router, $[9] = t3) : t3 = $[9];
  const [showReleaseNotFound, setShowReleaseNotFound] = useState(t3), [isCreateReleaseDialogOpen, setIsCreateReleaseDialogOpen] = useState(!1);
  let t4;
  $[10] !== allReleases || $[11] !== cardinalityView ? (t4 = allReleases.filter(shouldShowReleaseInView(cardinalityView)), $[10] = allReleases, $[11] = cardinalityView, $[12] = t4) : t4 = $[12];
  const releases2 = t4;
  let t5;
  $[13] !== allArchivedReleases || $[14] !== cardinalityView ? (t5 = allArchivedReleases.filter(shouldShowReleaseInView(cardinalityView)), $[13] = allArchivedReleases, $[14] = cardinalityView, $[15] = t5) : t5 = $[15];
  const archivedReleases = t5;
  let t6;
  $[16] !== cardinalityView || $[17] !== releases2 ? (t6 = cardinalityView === "drafts" ? releases2.filter(_temp$1F) : [], $[16] = cardinalityView, $[17] = releases2, $[18] = t6) : t6 = $[18];
  const pausedReleases = t6;
  let t7;
  $[19] !== releases2 ? (t7 = releases2.map(_temp2$G), $[19] = releases2, $[20] = t7) : t7 = $[20];
  const releaseIds = t7, {
    data: releasesMetadata,
    loading: loadingReleasesMetadata
  } = useReleasesMetadata(releaseIds), loading = loadingReleases || loadingReleasesMetadata && !releasesMetadata, loadingTableData = loading || !releasesMetadata && !!releaseIds.length, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), {
    timeZone,
    utcToCurrentZoneDate
  } = useTimeZone(CONTENT_RELEASES_TIME_ZONE_SCOPE), {
    selectedPerspective
  } = usePerspective(), {
    DialogTimeZone: DialogTimeZone2,
    dialogProps,
    dialogTimeZoneShow
  } = useDialogTimeZone(CONTENT_RELEASES_TIME_ZONE_SCOPE), getTimezoneAdjustedDateTimeRange = useTimezoneAdjustedDateTimeRange(), {
    createRelease
  } = useReleaseOperations(), {
    checkWithPermissionGuard
  } = useReleasePermissions(), [hasCreatePermission, setHasCreatePermission] = useState(null), mediaIndex = useMediaIndex(), isNarrowViewport = mediaIndex < 2;
  let t8;
  $[21] !== isNarrowViewport ? (t8 = isNarrowViewport ? {
    minWidth: "100%",
    order: 3
  } : void 0, $[21] = isNarrowViewport, $[22] = t8) : t8 = $[22];
  const narrowFilterStyle = t8;
  let t9;
  $[23] !== isNarrowViewport ? (t9 = isNarrowViewport ? {
    marginLeft: "auto"
  } : void 0, $[23] = isNarrowViewport, $[24] = t9) : t9 = $[24];
  const narrowTimezoneStyle = t9, timeZoneLabel = `${timeZone.abbreviation} (${timeZone.namePretty})`;
  let t10;
  $[25] !== isNarrowViewport || $[26] !== timeZoneLabel ? (t10 = isNarrowViewport ? {
    tooltipProps: {
      content: timeZoneLabel
    }
  } : {
    iconRight: ChevronDownIcon,
    text: timeZoneLabel
  }, $[25] = isNarrowViewport, $[26] = timeZoneLabel, $[27] = t10) : t10 = $[27];
  const timeZoneButtonProps = t10;
  let t11;
  $[28] !== selectedPerspective ? (t11 = (datum) => datum.isDeleted ? {
    tone: "transparent"
  } : isReleaseDocument(selectedPerspective) && selectedPerspective._id === datum._id ? {
    tone: getReleaseTone(datum)
  } : datum.state === "active" && getIsScheduledDateInPast(datum) ? {
    tone: "caution"
  } : {
    tone: "default"
  }, $[28] = selectedPerspective, $[29] = t11) : t11 = $[29];
  const getRowProps = t11, [scrollContainerRef, setScrollContainerRef] = useState(null), hasReleases = releases2.length > 0 || archivedReleases.length > 0, showDraftsDisabledBanner = cardinalityView === "drafts" && (!isDraftModelEnabled || !isScheduledDraftsEnabled), loadingOrHasReleases = loading || hasReleases, hasNoReleases = !loading && !hasReleases;
  let t12;
  bb0: {
    if (!hasReleases || !releasesMetadata) {
      let t133;
      $[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t133 = [], $[30] = t133) : t133 = $[30], t12 = t133;
      break bb0;
    }
    let t132;
    if ($[31] !== releases2 || $[32] !== releasesMetadata) {
      let t142;
      $[34] !== releasesMetadata ? (t142 = (release_1) => ({
        ...release_1,
        publishAt: release_1.publishAt || release_1.metadata.intendedPublishAt,
        documentsMetadata: releasesMetadata[release_1._id] || {}
      }), $[34] = releasesMetadata, $[35] = t142) : t142 = $[35], t132 = releases2.map(t142), $[31] = releases2, $[32] = releasesMetadata, $[33] = t132;
    } else
      t132 = $[33];
    t12 = t132;
  }
  const tableReleases = t12, isMounted = useRef(!1);
  let t13, t14;
  $[36] !== checkWithPermissionGuard || $[37] !== createRelease ? (t13 = () => (isMounted.current = !0, checkWithPermissionGuard(createRelease, getReleaseDefaults()).then((hasPermissions) => {
    isMounted.current && setHasCreatePermission(hasPermissions);
  }), () => {
    isMounted.current = !1;
  }), t14 = [checkWithPermissionGuard, createRelease], $[36] = checkWithPermissionGuard, $[37] = createRelease, $[38] = t13, $[39] = t14) : (t13 = $[38], t14 = $[39]), useEffect(t13, t14), releaseGroupMode === "archived" && !loadingReleases && !archivedReleases.length && setReleaseGroupMode("active"), releaseGroupMode === "paused" && !loadingReleases && !pausedReleases.length && setReleaseGroupMode("active");
  let t15;
  $[40] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = () => {
    setShowReleaseNotFound(!1);
  }, $[40] = t15) : t15 = $[40];
  const handleDismissReleaseNotFound = t15;
  let t16;
  $[41] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = (t172) => {
    const {
      currentTarget: t182
    } = t172, {
      value: groupMode
    } = t182;
    setReleaseGroupMode(groupMode);
  }, $[41] = t16) : t16 = $[41];
  const handleReleaseGroupModeChange = t16;
  let t17;
  $[42] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t17 = (view) => () => setCardinalityView(view), $[42] = t17) : t17 = $[42];
  const handleCardinalityViewChange = t17;
  let t18;
  $[43] !== utcToCurrentZoneDate ? (t18 = (date) => setReleaseFilterDate((prevFilterDate) => {
    if (!date)
      return;
    const normalized = toLocalDateComponents(date, utcToCurrentZoneDate);
    return prevFilterDate && isSameDay(prevFilterDate, normalized) ? void 0 : normalized;
  }), $[43] = utcToCurrentZoneDate, $[44] = t18) : t18 = $[44];
  const handleSelectFilterDate = t18;
  let t19;
  $[45] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t19 = () => {
    setReleaseFilterDate(void 0), setReleaseGroupMode("active");
  }, $[45] = t19) : t19 = $[45];
  const clearFilterDate = t19;
  let t20;
  $[46] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t20 = () => {
    setReleaseFilterDate(void 0), setReleaseGroupMode("paused");
  }, $[46] = t20) : t20 = $[46];
  const handleNavigateToPaused = t20;
  let t21;
  $[47] !== router.navigate ? (t21 = () => {
    navigateRef.current = router.navigate;
  }, $[47] = router.navigate, $[48] = t21) : t21 = $[48], useEffect(t21);
  let t22, t23;
  $[49] !== cardinalityView || $[50] !== isScheduledDraftsEnabled || $[51] !== releaseFilterDate || $[52] !== releaseGroupMode ? (t22 = () => {
    navigateRef.current({
      _searchParams: buildReleasesSearchParams(releaseFilterDate, releaseGroupMode, isScheduledDraftsEnabled ? cardinalityView : "releases")
    });
  }, t23 = [releaseFilterDate, releaseGroupMode, cardinalityView, isScheduledDraftsEnabled], $[49] = cardinalityView, $[50] = isScheduledDraftsEnabled, $[51] = releaseFilterDate, $[52] = releaseGroupMode, $[53] = t22, $[54] = t23) : (t22 = $[53], t23 = $[54]), useEffect(t22, t23);
  const [hasMounted, setHasMounted] = useState(!1);
  let t24, t25;
  $[55] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t24 = () => {
    setHasMounted(!0);
  }, t25 = [], $[55] = t24, $[56] = t25) : (t24 = $[55], t25 = $[56]), useEffect(t24, t25);
  const showCalendar = mediaIndex > 2, t26 = loading || !hasReleases;
  let t27;
  $[57] !== hasMounted ? (t27 = hasMounted ? {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    transition: {
      duration: 0.4,
      ease: "easeInOut"
    }
  } : {}, $[57] = hasMounted, $[58] = t27) : t27 = $[58];
  let t28;
  $[59] !== t26 || $[60] !== t27 ? (t28 = {
    disabled: t26,
    mode: "bleed",
    padding: 2,
    ...t27
  }, $[59] = t26, $[60] = t27, $[61] = t28) : t28 = $[61];
  const groupModeButtonBaseProps = t28, t29 = releaseGroupMode === "active";
  let t30;
  $[62] !== t ? (t30 = t("action.open"), $[62] = t, $[63] = t30) : t30 = $[63];
  let t31;
  $[64] !== groupModeButtonBaseProps || $[65] !== t29 || $[66] !== t30 ? (t31 = /* @__PURE__ */ jsx(MotionButton, { ...groupModeButtonBaseProps, onClick: handleReleaseGroupModeChange, selected: t29, text: t30, value: "active" }, "open-group"), $[64] = groupModeButtonBaseProps, $[65] = t29, $[66] = t30, $[67] = t31) : t31 = $[67];
  let t32;
  $[68] !== cardinalityView || $[69] !== groupModeButtonBaseProps || $[70] !== pausedReleases.length || $[71] !== releaseGroupMode || $[72] !== t ? (t32 = cardinalityView === "drafts" && /* @__PURE__ */ jsx(Tooltip, { disabled: pausedReleases.length !== 0, content: t("no-paused-release"), placement: "bottom", children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(MotionButton, { ...groupModeButtonBaseProps, disabled: groupModeButtonBaseProps.disabled || !pausedReleases.length, onClick: handleReleaseGroupModeChange, selected: releaseGroupMode === "paused", text: t("action.paused"), value: "paused" }, "paused-group") }) }), $[68] = cardinalityView, $[69] = groupModeButtonBaseProps, $[70] = pausedReleases.length, $[71] = releaseGroupMode, $[72] = t, $[73] = t32) : t32 = $[73];
  const t33 = archivedReleases.length !== 0;
  let t34;
  $[74] !== t ? (t34 = t("no-archived-release"), $[74] = t, $[75] = t34) : t34 = $[75];
  const t35 = groupModeButtonBaseProps.disabled || !archivedReleases.length, t36 = releaseGroupMode === "archived";
  let t37;
  $[76] !== t ? (t37 = t("action.archived"), $[76] = t, $[77] = t37) : t37 = $[77];
  let t38;
  $[78] !== groupModeButtonBaseProps || $[79] !== t35 || $[80] !== t36 || $[81] !== t37 ? (t38 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(MotionButton, { ...groupModeButtonBaseProps, disabled: t35, onClick: handleReleaseGroupModeChange, selected: t36, text: t37, value: "archived" }, "archived-group") }), $[78] = groupModeButtonBaseProps, $[79] = t35, $[80] = t36, $[81] = t37, $[82] = t38) : t38 = $[82];
  let t39;
  $[83] !== t33 || $[84] !== t34 || $[85] !== t38 ? (t39 = /* @__PURE__ */ jsx(Tooltip, { disabled: t33, content: t34, placement: "bottom", children: t38 }), $[83] = t33, $[84] = t34, $[85] = t38, $[86] = t39) : t39 = $[86];
  let t40;
  $[87] !== t31 || $[88] !== t32 || $[89] !== t39 ? (t40 = /* @__PURE__ */ jsxs(AnimatePresence, { children: [
    t31,
    t32,
    t39
  ] }), $[87] = t31, $[88] = t32, $[89] = t39, $[90] = t40) : t40 = $[90];
  const currentArchivedPicker = t40;
  let t41;
  $[91] !== handleOpenReleasesUpsellDialog || $[92] !== releasesUpsellMode ? (t41 = () => {
    if (releasesUpsellMode === "upsell") {
      handleOpenReleasesUpsellDialog();
      return;
    }
    setIsCreateReleaseDialogOpen(!0);
  }, $[91] = handleOpenReleasesUpsellDialog, $[92] = releasesUpsellMode, $[93] = t41) : t41 = $[93];
  const handleOnClickCreateRelease = t41;
  let t42;
  bb1: {
    if (isScheduledDraftsEnabled && cardinalityView === "drafts") {
      t42 = null;
      break bb1;
    }
    const t432 = !hasCreatePermission || isCreateReleaseDialogOpen;
    let t442;
    $[94] !== tCore ? (t442 = tCore("release.action.create-new"), $[94] = tCore, $[95] = t442) : t442 = $[95];
    const t452 = hasCreatePermission === !0;
    let t462;
    $[96] !== tCore ? (t462 = tCore("release.action.permission.error"), $[96] = tCore, $[97] = t462) : t462 = $[97];
    let t472;
    $[98] !== t452 || $[99] !== t462 ? (t472 = {
      disabled: t452,
      content: t462
    }, $[98] = t452, $[99] = t462, $[100] = t472) : t472 = $[100];
    let t482;
    $[101] !== handleOnClickCreateRelease || $[102] !== t432 || $[103] !== t442 || $[104] !== t472 ? (t482 = /* @__PURE__ */ jsx(Button, { icon: AddIcon, disabled: t432, onClick: handleOnClickCreateRelease, text: t442, tooltipProps: t472 }), $[101] = handleOnClickCreateRelease, $[102] = t432, $[103] = t442, $[104] = t472, $[105] = t482) : t482 = $[105], t42 = t482;
  }
  const createReleaseButton = t42;
  let t43;
  $[106] !== router ? (t43 = (createdReleaseId) => {
    setIsCreateReleaseDialogOpen(!1), router.navigate({
      releaseId: createdReleaseId
    }, {
      stickyParams: {
        excludedPerspectives: null,
        perspective: createdReleaseId
      }
    });
  }, $[106] = router, $[107] = t43) : t43 = $[107];
  const handleOnCreateRelease = t43;
  let t44;
  $[108] !== cardinalityView || $[109] !== releaseGroupMode ? (t44 = (t452) => {
    const {
      datum: datum_0
    } = t452, release_2 = datum_0;
    if (release_2.isDeleted || release_2.isLoading)
      return null;
    if (cardinalityView === "drafts")
      return /* @__PURE__ */ jsx(ScheduledDraftMenuButtonWrapper, { release: release_2 });
    const documentsCount = (releaseGroupMode === "active" ? release_2.documentsMetadata?.documentCount : release_2.finalDocumentStates?.length) ?? 0;
    return /* @__PURE__ */ jsx(ReleaseMenuButtonWrapper, { release: release_2, documentsCount });
  }, $[108] = cardinalityView, $[109] = releaseGroupMode, $[110] = t44) : t44 = $[110];
  const renderRowActions = t44;
  let t45;
  $[111] !== archivedReleases || $[112] !== cardinalityView || $[113] !== getTimezoneAdjustedDateTimeRange || $[114] !== releaseFilterDate || $[115] !== releaseGroupMode || $[116] !== tableReleases ? (t45 = filterReleasesForOverview({
    releases: tableReleases,
    archivedReleases,
    cardinalityView,
    releaseGroupMode,
    dateFilter: releaseFilterDate ? {
      filterDate: releaseFilterDate,
      getTimezoneAdjustedDateTimeRange
    } : void 0
  }), $[111] = archivedReleases, $[112] = cardinalityView, $[113] = getTimezoneAdjustedDateTimeRange, $[114] = releaseFilterDate, $[115] = releaseGroupMode, $[116] = tableReleases, $[117] = t45) : t45 = $[117];
  const filteredReleases = t45;
  let t46;
  $[118] !== cardinalityView || $[119] !== releases2 ? (t46 = cardinalityView === "drafts" && releases2.some(_temp3$n), $[118] = cardinalityView, $[119] = releases2, $[120] = t46) : t46 = $[120];
  const showConfirmActiveScheduledDraftsBanner = t46, t47 = loading || releases2.length === 0;
  let t48;
  $[121] !== cardinalityView ? (t48 = createReleaseCalendarFilterDay(cardinalityView), $[121] = cardinalityView, $[122] = t48) : t48 = $[122];
  let t49;
  $[123] !== handleSelectFilterDate || $[124] !== releaseFilterDate || $[125] !== t47 || $[126] !== t48 ? (t49 = /* @__PURE__ */ jsx(CalendarFilter, { disabled: t47, renderCalendarDay: t48, selectedDate: releaseFilterDate, onSelect: handleSelectFilterDate, timeZoneScope: CONTENT_RELEASES_TIME_ZONE_SCOPE }), $[123] = handleSelectFilterDate, $[124] = releaseFilterDate, $[125] = t47, $[126] = t48, $[127] = t49) : t49 = $[127];
  const calendarFilterContent = t49;
  let t50;
  $[128] !== calendarFilterContent ? (t50 = /* @__PURE__ */ jsx(Flex, { flex: "none", children: /* @__PURE__ */ jsx(Card, { borderRight: !0, flex: "none", disabled: !0, children: calendarFilterContent }) }), $[128] = calendarFilterContent, $[129] = t50) : t50 = $[129];
  const renderCalendarFilter = t50;
  let t51;
  bb2: {
    if (cardinalityView === "drafts") {
      let t523;
      $[130] !== releaseGroupMode || $[131] !== t ? (t523 = scheduledDraftsOverviewColumnDefs(t, releaseGroupMode), $[130] = releaseGroupMode, $[131] = t, $[132] = t523) : t523 = $[132], t51 = t523;
      break bb2;
    }
    let t522;
    $[133] !== releaseGroupMode || $[134] !== t ? (t522 = releasesOverviewColumnDefs(t, releaseGroupMode), $[133] = releaseGroupMode, $[134] = t, $[135] = t522) : t522 = $[135], t51 = t522;
  }
  const tableColumns = t51, hasBannerAboveTable = showReleaseNotFound || showDraftsDisabledBanner || showConfirmActiveScheduledDraftsBanner, defaultTableSort = releaseGroupMode === "archived" && cardinalityView === "releases" ? DEFAULT_ARCHIVED_RELEASES_OVERVIEW_SORT : DEFAULT_RELEASES_OVERVIEW_SORT;
  let t52;
  $[136] !== createReleaseButton ? (t52 = () => /* @__PURE__ */ jsx(ReleasesEmptyState, { createReleaseButton }), $[136] = createReleaseButton, $[137] = t52) : t52 = $[137];
  const releasesEmptyStateComponent = t52;
  let t53;
  bb3: {
    if (cardinalityView === "releases" && releaseGroupMode === "active") {
      t53 = releasesEmptyStateComponent;
      break bb3;
    }
    if (cardinalityView === "drafts") {
      let t543;
      $[138] !== t ? (t543 = t("no-scheduled-drafts"), $[138] = t, $[139] = t543) : t543 = $[139], t53 = t543;
      break bb3;
    }
    let t542;
    $[140] !== t ? (t542 = t("no-releases"), $[140] = t, $[141] = t542) : t542 = $[141], t53 = t542;
  }
  const tableEmptyState = t53;
  let t54;
  $[142] !== cardinalityView || $[143] !== createReleaseButton || $[144] !== releasesUpsellMode || $[145] !== scheduledDraftsMode ? (t54 = function() {
    return cardinalityView === "releases" && releasesUpsellMode === "upsell" || cardinalityView === "drafts" && scheduledDraftsMode === "upsell" ? /* @__PURE__ */ jsx(SchedulesUpsell, { cardinalityView }) : cardinalityView === "drafts" ? /* @__PURE__ */ jsx(ScheduledDraftsEmptyState, {}) : /* @__PURE__ */ jsx(ReleasesEmptyState, { createReleaseButton });
  }, $[142] = cardinalityView, $[143] = createReleaseButton, $[144] = releasesUpsellMode, $[145] = scheduledDraftsMode, $[146] = t54) : t54 = $[146];
  const renderNoReleasesEmptyState = t54;
  let t55;
  $[147] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t55 = {
    height: "100%"
  }, $[147] = t55) : t55 = $[147];
  const t56 = showCalendar && renderCalendarFilter;
  let t57;
  $[148] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t57 = {
    position: "relative"
  }, $[148] = t57) : t57 = $[148];
  let t58;
  $[149] !== calendarFilterContent || $[150] !== isNarrowViewport || $[151] !== showCalendar ? (t58 = !showCalendar && /* @__PURE__ */ jsx(CalendarPopover, { content: calendarFilterContent, asDialog: isNarrowViewport }), $[149] = calendarFilterContent, $[150] = isNarrowViewport, $[151] = showCalendar, $[152] = t58) : t58 = $[152];
  let t59;
  $[153] !== allReleases || $[154] !== cardinalityView || $[155] !== isDraftModelEnabled || $[156] !== isReleasesEnabled || $[157] !== isScheduledDraftsEnabled || $[158] !== loading ? (t59 = /* @__PURE__ */ jsx(CardinalityViewPicker, { cardinalityView, loading, onCardinalityViewChange: handleCardinalityViewChange, isScheduledDraftsEnabled, allReleases, isReleasesEnabled, isDraftModelEnabled }), $[153] = allReleases, $[154] = cardinalityView, $[155] = isDraftModelEnabled, $[156] = isReleasesEnabled, $[157] = isScheduledDraftsEnabled, $[158] = loading, $[159] = t59) : t59 = $[159];
  let t60;
  $[160] !== t58 || $[161] !== t59 ? (t60 = /* @__PURE__ */ jsxs(Inline, { children: [
    t58,
    t59
  ] }), $[160] = t58, $[161] = t59, $[162] = t60) : t60 = $[162];
  let t61;
  $[163] !== currentArchivedPicker || $[164] !== loadingOrHasReleases || $[165] !== releaseFilterDate ? (t61 = loadingOrHasReleases && (releaseFilterDate ? /* @__PURE__ */ jsx(DateFilterButton, { filterDate: releaseFilterDate, onClear: clearFilterDate }) : currentArchivedPicker), $[163] = currentArchivedPicker, $[164] = loadingOrHasReleases, $[165] = releaseFilterDate, $[166] = t61) : t61 = $[166];
  let t62;
  $[167] !== narrowFilterStyle || $[168] !== t61 ? (t62 = /* @__PURE__ */ jsx(Flex, { flex: 1, gap: 1, style: narrowFilterStyle, children: t61 }), $[167] = narrowFilterStyle, $[168] = t61, $[169] = t62) : t62 = $[169];
  let t63;
  $[170] !== dialogTimeZoneShow || $[171] !== timeZoneButtonProps ? (t63 = /* @__PURE__ */ jsx(Button, { icon: EarthGlobeIcon, mode: "bleed", onClick: dialogTimeZoneShow, ...timeZoneButtonProps }), $[170] = dialogTimeZoneShow, $[171] = timeZoneButtonProps, $[172] = t63) : t63 = $[172];
  let t64;
  $[173] !== DialogTimeZone2 || $[174] !== dialogProps ? (t64 = DialogTimeZone2 && /* @__PURE__ */ jsx(DialogTimeZone2, { ...dialogProps }), $[173] = DialogTimeZone2, $[174] = dialogProps, $[175] = t64) : t64 = $[175];
  const t65 = loadingOrHasReleases && createReleaseButton;
  let t66;
  $[176] !== narrowTimezoneStyle || $[177] !== t63 || $[178] !== t64 || $[179] !== t65 ? (t66 = /* @__PURE__ */ jsxs(Flex, { flex: "none", gap: 2, style: narrowTimezoneStyle, children: [
    t63,
    t64,
    t65
  ] }), $[176] = narrowTimezoneStyle, $[177] = t63, $[178] = t64, $[179] = t65, $[180] = t66) : t66 = $[180];
  let t67;
  $[181] !== t60 || $[182] !== t62 || $[183] !== t66 ? (t67 = /* @__PURE__ */ jsx(Card, { flex: "none", padding: 3, children: /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 3, wrap: "wrap", children: [
    t60,
    t62,
    t66
  ] }) }), $[181] = t60, $[182] = t62, $[183] = t66, $[184] = t67) : t67 = $[184];
  let t68;
  $[185] !== showReleaseNotFound ? (t68 = showReleaseNotFound && /* @__PURE__ */ jsx(ReleaseNotFoundBanner, { onDismiss: handleDismissReleaseNotFound }), $[185] = showReleaseNotFound, $[186] = t68) : t68 = $[186];
  let t69;
  $[187] !== allReleases || $[188] !== isDraftModelEnabled || $[189] !== isScheduledDraftsEnabled || $[190] !== showDraftsDisabledBanner ? (t69 = showDraftsDisabledBanner && /* @__PURE__ */ jsx(DraftsDisabledBanner, { isDraftModelEnabled, isScheduledDraftsEnabled, allReleases }), $[187] = allReleases, $[188] = isDraftModelEnabled, $[189] = isScheduledDraftsEnabled, $[190] = showDraftsDisabledBanner, $[191] = t69) : t69 = $[191];
  let t70;
  $[192] !== releaseFilterDate || $[193] !== releaseGroupMode || $[194] !== releases2 || $[195] !== showConfirmActiveScheduledDraftsBanner ? (t70 = showConfirmActiveScheduledDraftsBanner && /* @__PURE__ */ jsx(ConfirmActiveScheduledDraftsBanner, { releases: releases2, releaseGroupMode, hasDateFilter: !!releaseFilterDate, onNavigateToPaused: handleNavigateToPaused }), $[192] = releaseFilterDate, $[193] = releaseGroupMode, $[194] = releases2, $[195] = showConfirmActiveScheduledDraftsBanner, $[196] = t70) : t70 = $[196];
  let t71;
  $[197] !== defaultTableSort || $[198] !== filteredReleases || $[199] !== getRowProps || $[200] !== hasBannerAboveTable || $[201] !== hasNoReleases || $[202] !== loadingTableData || $[203] !== releaseFilterDate || $[204] !== releaseGroupMode || $[205] !== renderNoReleasesEmptyState || $[206] !== renderRowActions || $[207] !== scrollContainerRef || $[208] !== tableColumns || $[209] !== tableEmptyState ? (t71 = hasNoReleases ? renderNoReleasesEmptyState() : /* @__PURE__ */ jsx(Box, { ref: setScrollContainerRef, marginTop: hasBannerAboveTable ? 0 : 3, overflow: "auto", children: /* @__PURE__ */ jsx(Table, { defaultSort: defaultTableSort, loading: loadingTableData, data: filteredReleases, columnDefs: tableColumns, emptyState: tableEmptyState, rowId: "_id", rowActions: renderRowActions, rowProps: getRowProps, scrollContainerRef, hideTableInlinePadding: !0 }, releaseFilterDate ? "by_date" : releaseGroupMode) }), $[197] = defaultTableSort, $[198] = filteredReleases, $[199] = getRowProps, $[200] = hasBannerAboveTable, $[201] = hasNoReleases, $[202] = loadingTableData, $[203] = releaseFilterDate, $[204] = releaseGroupMode, $[205] = renderNoReleasesEmptyState, $[206] = renderRowActions, $[207] = scrollContainerRef, $[208] = tableColumns, $[209] = tableEmptyState, $[210] = t71) : t71 = $[210];
  let t72;
  $[211] !== t67 || $[212] !== t68 || $[213] !== t69 || $[214] !== t70 || $[215] !== t71 ? (t72 = /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, style: t57, children: [
    t67,
    t68,
    t69,
    t70,
    t71
  ] }), $[211] = t67, $[212] = t68, $[213] = t69, $[214] = t70, $[215] = t71, $[216] = t72) : t72 = $[216];
  let t73;
  $[217] !== t56 || $[218] !== t72 ? (t73 = /* @__PURE__ */ jsxs(Flex, { flex: 1, children: [
    t56,
    t72
  ] }), $[217] = t56, $[218] = t72, $[219] = t73) : t73 = $[219];
  let t74;
  $[220] !== handleOnCreateRelease || $[221] !== isCreateReleaseDialogOpen ? (t74 = isCreateReleaseDialogOpen && /* @__PURE__ */ jsx(CreateReleaseDialog, { onCancel: () => setIsCreateReleaseDialogOpen(!1), onSubmit: handleOnCreateRelease, origin: "release-plugin" }), $[220] = handleOnCreateRelease, $[221] = isCreateReleaseDialogOpen, $[222] = t74) : t74 = $[222];
  let t75;
  return $[223] !== t73 || $[224] !== t74 ? (t75 = /* @__PURE__ */ jsxs(Flex, { direction: "row", flex: 1, style: t55, children: [
    t73,
    t74
  ] }), $[223] = t73, $[224] = t74, $[225] = t75) : t75 = $[225], t75;
}
function _temp3$n(release_3) {
  return release_3.state === "active" && isCardinalityOneRelease(release_3);
}
function _temp2$G(release_0) {
  return release_0._id;
}
function _temp$1F(release) {
  return isPausedCardinalityOneRelease(release);
}
function ReleasesTool() {
  const $ = c(3), router = useRouter(), {
    releaseId
  } = router.state;
  if (releaseId) {
    let t02;
    return $[0] !== releaseId ? (t02 = /* @__PURE__ */ jsx(ReleaseDetail, {}, releaseId), $[0] = releaseId, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(ReleasesOverview, {}), $[2] = t0) : t0 = $[2], t0;
}
const createScheduledDraftAction = (actionKey, visibilityCheck) => (props2) => {
  const $ = c(11), {
    type,
    release,
    id: id2
  } = props2, {
    data: t0,
    loading
  } = useAllReleases(), releases2 = t0 === void 0 ? [] : t0;
  let t1;
  $[0] !== release ? (t1 = (r) => getReleaseIdFromReleaseDocumentId(r._id) === release, $[0] = release, $[1] = t1) : t1 = $[1];
  const releaseDocument = releases2.find(t1), {
    actions,
    dialogs
  } = useScheduledDraftMenuActions({
    release: releaseDocument,
    documentType: type,
    documentId: id2
  });
  if (visibilityCheck && !visibilityCheck(releaseDocument) || !releaseDocument || !actions || !actions[actionKey])
    return null;
  const actionProps = actions[actionKey], t2 = actionProps.disabled || loading;
  let t3;
  $[2] !== dialogs ? (t3 = dialogs ? {
    type: "custom",
    component: dialogs
  } : !1, $[2] = dialogs, $[3] = t3) : t3 = $[3];
  let t4;
  return $[4] !== actionProps.icon || $[5] !== actionProps.onClick || $[6] !== actionProps.text || $[7] !== actionProps.tone || $[8] !== t2 || $[9] !== t3 ? (t4 = {
    disabled: t2,
    icon: actionProps.icon,
    label: actionProps.text,
    title: actionProps.text,
    tone: actionProps.tone,
    dialog: t3,
    onHandle: actionProps.onClick
  }, $[4] = actionProps.icon, $[5] = actionProps.onClick, $[6] = actionProps.text, $[7] = actionProps.tone, $[8] = t2, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
}, PublishScheduledDraftAction = createScheduledDraftAction("publishNow"), EditScheduledDraftAction = createScheduledDraftAction(
  "editSchedule",
  (release) => !isPausedCardinalityOneRelease(release)
  // Hide when paused
), DeleteScheduledDraftAction = createScheduledDraftAction("deleteSchedule");
PublishScheduledDraftAction.displayName = "PublishScheduledDraftAction";
PublishScheduledDraftAction.action = "publish";
EditScheduledDraftAction.displayName = "EditScheduledDraftAction";
EditScheduledDraftAction.action = "schedule";
DeleteScheduledDraftAction.displayName = "DeleteScheduledDraftAction";
DeleteScheduledDraftAction.action = "discardVersion";
function SingleDocReleaseProvider(t0) {
  const $ = c(5), {
    children,
    onSetScheduledDraftPerspective
  } = t0;
  let t1;
  $[0] !== onSetScheduledDraftPerspective ? (t1 = {
    onSetScheduledDraftPerspective
  }, $[0] = onSetScheduledDraftPerspective, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== children || $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(SingleDocReleaseContext.Provider, { value: t1, children }), $[2] = children, $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
function useSingleDocRelease() {
  const context = useContext(SingleDocReleaseContext);
  if (!context)
    throw new Error("SingleDocReleaseContext not found");
  return context;
}
function useHasCardinalityOneReleaseVersions(documentId) {
  const $ = c(5), {
    data: allReleases
  } = useActiveReleases();
  let t0;
  $[0] !== documentId ? (t0 = {
    documentId
  }, $[0] = documentId, $[1] = t0) : t0 = $[1];
  const {
    data: documentVersions
  } = useDocumentVersions(t0);
  let t1;
  bb0: {
    if (!allReleases || !documentVersions) {
      t1 = !1;
      break bb0;
    }
    let t2;
    if ($[2] !== allReleases || $[3] !== documentVersions) {
      const documentReleaseIds = documentVersions.map(getVersionFromId).filter(Boolean);
      t2 = allReleases.some((release) => {
        const releaseId = getReleaseIdFromReleaseDocumentId(release._id);
        return documentReleaseIds.includes(releaseId) && isCardinalityOneRelease(release);
      }), $[2] = allReleases, $[3] = documentVersions, $[4] = t2;
    } else
      t2 = $[4];
    t1 = t2;
  }
  return t1;
}
const useSchedulePublishAction = (props2) => {
  const $ = c(51), {
    id: id2,
    type,
    draft
  } = props2, {
    t
  } = useTranslation(singleDocReleaseNamespace), {
    createScheduledDraft,
    rescheduleScheduledDraft
  } = useScheduleDraftOperations(), toast = useToast(), {
    enabled: singleDocReleaseEnabled,
    mode
  } = useSingleDocReleaseEnabled(), {
    handleOpenDialog: handleOpenUpsellDialog
  } = useSingleDocReleaseUpsell();
  let t0;
  $[0] !== id2 ? (t0 = getDraftId(id2), $[0] = id2, $[1] = t0) : t0 = $[1];
  const validationStatus = useValidationStatus(t0, type, !0);
  let t1;
  $[2] !== validationStatus.validation ? (t1 = validationStatus.validation.some(isValidationErrorMarker), $[2] = validationStatus.validation, $[3] = t1) : t1 = $[3];
  const hasValidationErrors = t1, hasCardinalityOneReleaseVersions = useHasCardinalityOneReleaseVersions(id2), [dialogOpen, setDialogOpen] = useState(!1), [isScheduling, setIsScheduling] = useState(!1), {
    onSetScheduledDraftPerspective
  } = useSingleDocRelease(), {
    data: t2
  } = useActiveReleases();
  let t3;
  $[4] !== t2 ? (t3 = t2 === void 0 ? [] : t2, $[4] = t2, $[5] = t3) : t3 = $[5];
  const releases2 = t3, perspective = usePerspective();
  let t4;
  if ($[6] !== perspective.selectedReleaseId || $[7] !== releases2) {
    let t52;
    $[9] !== perspective.selectedReleaseId ? (t52 = (r) => getReleaseIdFromReleaseDocumentId(r._id) === perspective.selectedReleaseId, $[9] = perspective.selectedReleaseId, $[10] = t52) : t52 = $[10], t4 = releases2.find(t52), $[6] = perspective.selectedReleaseId, $[7] = releases2, $[8] = t4;
  } else
    t4 = $[8];
  const currentRelease = t4;
  let t5;
  $[11] !== currentRelease ? (t5 = isPausedCardinalityOneRelease(currentRelease), $[11] = currentRelease, $[12] = t5) : t5 = $[12];
  const isPaused = t5;
  let t6;
  $[13] !== currentRelease || $[14] !== isPaused ? (t6 = isPaused && currentRelease?.metadata.intendedPublishAt ? new Date(currentRelease.metadata.intendedPublishAt) : void 0, $[13] = currentRelease, $[14] = isPaused, $[15] = t6) : t6 = $[15];
  const initialDate = t6;
  let t7;
  $[16] !== handleOpenUpsellDialog || $[17] !== mode ? (t7 = () => {
    mode === "upsell" ? handleOpenUpsellDialog("document_action") : setDialogOpen(!0);
  }, $[16] = handleOpenUpsellDialog, $[17] = mode, $[18] = t7) : t7 = $[18];
  const handleOpenDialog = t7;
  let t8;
  $[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = () => {
    setDialogOpen(!1);
  }, $[19] = t8) : t8 = $[19];
  const handleCloseDialog = t8;
  let t9;
  $[20] !== createScheduledDraft || $[21] !== currentRelease || $[22] !== id2 || $[23] !== isPaused || $[24] !== onSetScheduledDraftPerspective || $[25] !== rescheduleScheduledDraft || $[26] !== t || $[27] !== toast ? (t9 = async (publishAt) => {
    setIsScheduling(!0);
    const run = async () => {
      if (isPaused && currentRelease)
        await rescheduleScheduledDraft(currentRelease, publishAt);
      else {
        const releaseDocumentId = await createScheduledDraft(id2, publishAt);
        onSetScheduledDraftPerspective(getReleaseIdFromReleaseDocumentId(releaseDocumentId));
      }
      setDialogOpen(!1);
    };
    try {
      await run();
    } catch (t102) {
      const error = t102;
      console.error("Failed to schedule document publish:", error), toast.push({
        closable: !0,
        status: "error",
        title: t("action.schedule-publish-error"),
        description: error instanceof Error ? error.message : "An unknown error occurred"
      });
    }
    setIsScheduling(!1);
  }, $[20] = createScheduledDraft, $[21] = currentRelease, $[22] = id2, $[23] = isPaused, $[24] = onSetScheduledDraftPerspective, $[25] = rescheduleScheduledDraft, $[26] = t, $[27] = toast, $[28] = t9) : t9 = $[28];
  const handleSchedule = t9, disabled = isPaused ? hasValidationErrors : hasCardinalityOneReleaseVersions || hasValidationErrors;
  let t10;
  bb0: {
    if (isPaused && hasValidationErrors) {
      let t113;
      $[29] !== t ? (t113 = t("action.schedule-publish.disabled.validation-issues"), $[29] = t, $[30] = t113) : t113 = $[30], t10 = t113;
      break bb0;
    }
    if (hasCardinalityOneReleaseVersions) {
      let t113;
      $[31] !== t ? (t113 = t("action.schedule-publish.disabled.cardinality-one"), $[31] = t, $[32] = t113) : t113 = $[32], t10 = t113;
      break bb0;
    }
    if (hasValidationErrors) {
      let t113;
      $[33] !== t ? (t113 = t("action.schedule-publish.disabled.validation-issues"), $[33] = t, $[34] = t113) : t113 = $[34], t10 = t113;
      break bb0;
    }
    let t112;
    $[35] !== t ? (t112 = t("action.schedule-publish"), $[35] = t, $[36] = t112) : t112 = $[36], t10 = t112;
  }
  const title = t10;
  if (!singleDocReleaseEnabled || !draft && !isPaused)
    return null;
  let t11;
  $[37] !== t ? (t11 = t("action.schedule-publish"), $[37] = t, $[38] = t11) : t11 = $[38];
  const t12 = isPaused ? "primary" : void 0;
  let t13;
  $[39] !== dialogOpen || $[40] !== handleSchedule || $[41] !== initialDate || $[42] !== isScheduling ? (t13 = dialogOpen && {
    type: "custom",
    component: /* @__PURE__ */ jsx(ScheduleDraftDialog, { onClose: handleCloseDialog, onSchedule: handleSchedule, variant: "schedule", loading: isScheduling, initialDate })
  }, $[39] = dialogOpen, $[40] = handleSchedule, $[41] = initialDate, $[42] = isScheduling, $[43] = t13) : t13 = $[43];
  let t14;
  return $[44] !== disabled || $[45] !== handleOpenDialog || $[46] !== t11 || $[47] !== t12 || $[48] !== t13 || $[49] !== title ? (t14 = {
    icon: CalendarIcon,
    disabled,
    label: t11,
    title,
    tone: t12,
    onHandle: handleOpenDialog,
    dialog: t13
  }, $[44] = disabled, $[45] = handleOpenDialog, $[46] = t11, $[47] = t12, $[48] = t13, $[49] = title, $[50] = t14) : t14 = $[50], t14;
};
useSchedulePublishAction.action = "schedule";
useSchedulePublishAction.displayName = "SchedulePublishAction";
function resolveDocumentActions$1(existingActions, context) {
  if (context.versionType === "scheduled-draft")
    return [
      useSchedulePublishAction,
      // Shows only when paused
      PublishScheduledDraftAction,
      // Always shows
      EditScheduledDraftAction,
      // Shows only when NOT paused
      DeleteScheduledDraftAction
      // Always shows
    ];
  if (context.versionType === "draft") {
    const actionsExcludingOriginalSchedule = existingActions.filter(({
      action
    }) => action !== "schedule"), publishActionIndex = actionsExcludingOriginalSchedule.findIndex(({
      action
    }) => action === "publish"), nextAfterPublishIndex = publishActionIndex + 1, hasPublishAction = publishActionIndex >= 0, actionsBeforePublish = hasPublishAction ? actionsExcludingOriginalSchedule.slice(0, nextAfterPublishIndex) : [], actionsAfterPublish = hasPublishAction ? actionsExcludingOriginalSchedule.slice(nextAfterPublishIndex) : actionsExcludingOriginalSchedule;
    return [...actionsBeforePublish, useSchedulePublishAction, ...actionsAfterPublish];
  }
  return existingActions;
}
function SingleDocReleaseLayout(props2) {
  const $ = c(4);
  let t0;
  $[0] !== props2 ? (t0 = props2.renderDefault(props2), $[0] = props2, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(SingleDocReleaseEnabledProvider, { children: /* @__PURE__ */ jsx(SingleDocReleaseUpsellProvider, { children: t0 }) }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}
const SINGLE_DOC_RELEASE_NAME = "sanity/singleDocRelease", RELEASES_SCHEDULED_DRAFTS_INTENT = "releases-scheduled-drafts", singleDocRelease = definePlugin({
  name: SINGLE_DOC_RELEASE_NAME,
  studio: {
    components: {
      layout: SingleDocReleaseLayout
    }
  },
  i18n: {
    bundles: [singleDocReleaseUsEnglishLocaleBundle]
  },
  document: {
    actions: resolveDocumentActions$1
  }
}), SCHEDULES_NAME = "sanity/schedules", SCHEDULES_TOOL_NAME = "releases", schedules = definePlugin((options) => ({
  name: SCHEDULES_NAME,
  studio: {
    components: {
      layout: ReleasesStudioLayout
    }
  },
  tools: [{
    name: SCHEDULES_TOOL_NAME,
    title: options.releases.enabled ? "Releases" : "Scheduled Drafts",
    component: ReleasesTool,
    router: route.create("/", [route.create("/:releaseId")]),
    __internalApplicationType: "sanity/schedules",
    canHandleIntent: (intent) => intent === RELEASES_INTENT || intent === RELEASES_SCHEDULED_DRAFTS_INTENT,
    getIntentState(intent, params) {
      if (intent === RELEASES_INTENT)
        return {
          releaseId: params.id
        };
      if (intent === RELEASES_SCHEDULED_DRAFTS_INTENT) {
        const searchParams = [];
        return params.view && searchParams.push(["view", params.view]), {
          _searchParams: searchParams
        };
      }
      return null;
    }
  }],
  i18n: {
    bundles: [releasesUsEnglishLocaleBundle]
  }
}));
function useReleasesToolAvailable() {
  const $ = c(2), workspace = useWorkspace();
  let t0;
  return $[0] !== workspace.tools ? (t0 = workspace.tools.some(_temp$1E), $[0] = workspace.tools, $[1] = t0) : t0 = $[1], t0;
}
function _temp$1E(t0) {
  const {
    name
  } = t0;
  return name === SCHEDULES_TOOL_NAME;
}
const useHasCopyToDraftOption = (documentType, fromRelease) => {
  const $ = c(3), {
    document: document2
  } = useWorkspace(), schema2 = useSchema();
  let t0;
  $[0] !== documentType || $[1] !== schema2 ? (t0 = schema2.get(documentType), $[0] = documentType, $[1] = schema2, $[2] = t0) : t0 = $[2];
  const isLiveEdit = t0?.liveEdit;
  return document2?.drafts?.enabled && fromRelease !== "draft" && fromRelease !== "published" && !isLiveEdit;
}, CopyToDraftsMenuItem = memo(function(props2) {
  const $ = c(13), {
    documentId,
    documentType,
    fromRelease,
    onClick: onClick2,
    onNavigate
  } = props2, {
    t
  } = useTranslation(), shouldShowDraftsOption = useHasCopyToDraftOption(documentType, fromRelease);
  let t0;
  $[0] !== documentId || $[1] !== fromRelease || $[2] !== onNavigate ? (t0 = {
    documentId,
    fromRelease,
    onNavigate
  }, $[0] = documentId, $[1] = fromRelease, $[2] = onNavigate, $[3] = t0) : t0 = $[3];
  const {
    handleCopyToDrafts,
    hasDraftVersion
  } = useCopyToDrafts(t0);
  let t1;
  $[4] !== handleCopyToDrafts || $[5] !== hasDraftVersion || $[6] !== onClick2 ? (t1 = () => {
    hasDraftVersion ? onClick2() : handleCopyToDrafts();
  }, $[4] = handleCopyToDrafts, $[5] = hasDraftVersion, $[6] = onClick2, $[7] = t1) : t1 = $[7];
  const handleDraftsClick = t1;
  if (!shouldShowDraftsOption)
    return null;
  let t2;
  $[8] !== t ? (t2 = () => /* @__PURE__ */ jsxs(Flex, { gap: 3, align: "center", children: [
    /* @__PURE__ */ jsx(Box, { flex: "none", paddingX: 2, children: /* @__PURE__ */ jsx(ReleaseAvatar, { padding: 0, release: LATEST }) }),
    /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t("release.chip.draft") })
  ] }), $[8] = t, $[9] = t2) : t2 = $[9];
  let t3;
  return $[10] !== handleDraftsClick || $[11] !== t2 ? (t3 = /* @__PURE__ */ jsx(MenuItem, { as: "a", onClick: handleDraftsClick, "data-testid": "copy-to-drafts-menu-item", renderMenuItem: t2 }), $[10] = handleDraftsClick, $[11] = t2, $[12] = t3) : t3 = $[12], t3;
}), CreateReleaseMenuItem = (t0) => {
  const $ = c(29), {
    onCreateRelease
  } = t0, {
    t
  } = useTranslation(), {
    createRelease
  } = useReleaseOperations(), {
    checkWithPermissionGuard
  } = useReleasePermissions(), createReleaseMetadata = useCreateReleaseMetadata();
  let t1;
  $[0] !== checkWithPermissionGuard || $[1] !== createRelease || $[2] !== createReleaseMetadata ? (t1 = from(checkWithPermissionGuard(createRelease, createReleaseMetadata(getReleaseDefaults()))), $[0] = checkWithPermissionGuard, $[1] = createRelease, $[2] = createReleaseMetadata, $[3] = t1) : t1 = $[3];
  const hasCreatePermission = useObservable(t1), activeReleaseCount = useActiveReleases().data.length, {
    releases: releases2
  } = useWorkspace(), workspaceReleaseLimit = releases2?.limit ?? 1 / 0, isWorkspaceReleaseLimitReached = activeReleaseCount >= workspaceReleaseLimit;
  let t2;
  $[4] !== t ? (t2 = t("release.action.create-new"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== onCreateRelease || $[7] !== t2 ? (t3 = {
    icon: AddIcon,
    onClick: onCreateRelease,
    "data-testid": "create-new-release-button",
    text: t2
  }, $[6] = onCreateRelease, $[7] = t2, $[8] = t3) : t3 = $[8];
  const menuItemProps = t3;
  if (isWorkspaceReleaseLimitReached) {
    let t42;
    $[9] !== t ? (t42 = t("release.action.create-new"), $[9] = t, $[10] = t42) : t42 = $[10];
    let t5;
    $[11] !== t || $[12] !== workspaceReleaseLimit ? (t5 = t("release.action.new-release.limit-reached", {
      count: workspaceReleaseLimit
    }), $[11] = t, $[12] = workspaceReleaseLimit, $[13] = t5) : t5 = $[13];
    let t6;
    $[14] !== t5 ? (t6 = {
      content: t5
    }, $[14] = t5, $[15] = t6) : t6 = $[15];
    let t7;
    return $[16] !== menuItemProps || $[17] !== t42 || $[18] !== t6 ? (t7 = /* @__PURE__ */ jsx(MenuItem, { ...menuItemProps, text: t42, tooltipProps: t6, disabled: !0 }), $[16] = menuItemProps, $[17] = t42, $[18] = t6, $[19] = t7) : t7 = $[19], t7;
  }
  if (!hasCreatePermission) {
    let t42;
    $[20] !== t ? (t42 = t("release.action.permission.error"), $[20] = t, $[21] = t42) : t42 = $[21];
    let t5;
    $[22] !== t42 ? (t5 = {
      content: t42
    }, $[22] = t42, $[23] = t5) : t5 = $[23];
    let t6;
    return $[24] !== menuItemProps || $[25] !== t5 ? (t6 = /* @__PURE__ */ jsx(MenuItem, { ...menuItemProps, tooltipProps: t5, disabled: !0 }), $[24] = menuItemProps, $[25] = t5, $[26] = t6) : t6 = $[26], t6;
  }
  let t4;
  return $[27] !== menuItemProps ? (t4 = /* @__PURE__ */ jsx(MenuItem, { ...menuItemProps }), $[27] = menuItemProps, $[28] = t4) : t4 = $[28], t4;
}, VersionContextMenuItem = memo(function(props2) {
  const $ = c(32), {
    release
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== release ? (t0 = isReleaseScheduledOrScheduling(release), $[0] = release, $[1] = t0) : t0 = $[1];
  const isScheduled = t0;
  let t1;
  $[2] !== release ? (t1 = /* @__PURE__ */ jsx(ReleaseAvatar, { padding: 2, release }), $[2] = release, $[3] = t1) : t1 = $[3];
  const t2 = release.metadata?.title;
  let t3;
  $[4] !== t ? (t3 = t("release.placeholder-untitled-release"), $[4] = t, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    size: 1,
    weight: "medium"
  }, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t2 || $[8] !== t3 ? (t5 = /* @__PURE__ */ jsx(ReleaseTitle, { title: t2, fallback: t3, textProps: t4 }), $[7] = t2, $[8] = t3, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== release.metadata.releaseType || $[11] !== t ? (t6 = release.metadata.releaseType === "asap" && /* @__PURE__ */ jsx(Fragment$1, { children: t("release.type.asap") }), $[10] = release.metadata.releaseType, $[11] = t, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== release || $[14] !== t ? (t7 = release.metadata.releaseType === "scheduled" && (release.metadata.intendedPublishAt ? /* @__PURE__ */ jsx(Fragment$1, { children: formatRelativeLocalePublishDate(release) }) : /* @__PURE__ */ jsx(Fragment$1, { children: t("release.chip.tooltip.unknown-date") })), $[13] = release, $[14] = t, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== release.metadata.releaseType || $[17] !== t ? (t8 = release.metadata.releaseType === "undecided" && /* @__PURE__ */ jsx(Fragment$1, { children: t("release.type.undecided") }), $[16] = release.metadata.releaseType, $[17] = t, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== t6 || $[20] !== t7 || $[21] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
    t6,
    t7,
    t8
  ] }), $[19] = t6, $[20] = t7, $[21] = t8, $[22] = t9) : t9 = $[22];
  let t10;
  $[23] !== t5 || $[24] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
    t5,
    t9
  ] }), $[23] = t5, $[24] = t9, $[25] = t10) : t10 = $[25];
  let t11;
  $[26] !== isScheduled ? (t11 = isScheduled && /* @__PURE__ */ jsx(LockIcon, {}), $[26] = isScheduled, $[27] = t11) : t11 = $[27];
  let t12;
  return $[28] !== t1 || $[29] !== t10 || $[30] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Flex, { gap: 3, justify: "center", align: "center", children: [
    t1,
    t10,
    t11
  ] }), $[28] = t1, $[29] = t10, $[30] = t11, $[31] = t12) : t12 = $[31], t12;
}), ReleasesList$1 = styled(Stack).withConfig({
  displayName: "ReleasesList",
  componentId: "sc-1kwebcg-0"
})`max-width:300px;max-height:200px;overflow-y:auto;`, CopyToReleaseMenuGroup = memo(function(props2) {
  const $ = c(31), {
    releases: releases2,
    bundleId,
    onCreateRelease,
    onCopyToDrafts,
    onCopyToDraftsNavigate,
    onCreateVersion,
    disabled,
    isReleasesEnabled,
    hasCreatePermission,
    hasCopyToDraftOption,
    documentId,
    documentType
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    placement: "right-start"
  }, $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== t ? (t1 = t("release.action.copy-to"), $[1] = t, $[2] = t1) : t1 = $[2];
  const t2 = hasCreatePermission === !0;
  let t3;
  $[3] !== t ? (t3 = t("release.action.permission.error"), $[3] = t, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t2 || $[6] !== t3 ? (t4 = {
    disabled: t2,
    content: t3
  }, $[5] = t2, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== bundleId || $[9] !== documentId || $[10] !== documentType || $[11] !== hasCopyToDraftOption || $[12] !== onCopyToDrafts || $[13] !== onCopyToDraftsNavigate || $[14] !== onCreateVersion || $[15] !== releases2 ? (t5 = (hasCopyToDraftOption || releases2.length > 0) && /* @__PURE__ */ jsxs(ReleasesList$1, { space: 1, children: [
    hasCopyToDraftOption && /* @__PURE__ */ jsx(CopyToDraftsMenuItem, { documentType, documentId, fromRelease: bundleId, onClick: onCopyToDrafts, onNavigate: onCopyToDraftsNavigate }),
    releases2.map((targetRelease) => /* @__PURE__ */ jsx(MenuItem, { as: "a", onClick: () => onCreateVersion(targetRelease._id), renderMenuItem: () => /* @__PURE__ */ jsx(VersionContextMenuItem, { release: targetRelease }) }, targetRelease._id))
  ] }, bundleId), $[8] = bundleId, $[9] = documentId, $[10] = documentType, $[11] = hasCopyToDraftOption, $[12] = onCopyToDrafts, $[13] = onCopyToDraftsNavigate, $[14] = onCreateVersion, $[15] = releases2, $[16] = t5) : t5 = $[16];
  let t6;
  $[17] !== hasCopyToDraftOption || $[18] !== isReleasesEnabled || $[19] !== releases2 ? (t6 = isReleasesEnabled && (hasCopyToDraftOption || releases2.length > 0) && /* @__PURE__ */ jsx(MenuDivider, {}), $[17] = hasCopyToDraftOption, $[18] = isReleasesEnabled, $[19] = releases2, $[20] = t6) : t6 = $[20];
  let t7;
  $[21] !== isReleasesEnabled || $[22] !== onCreateRelease ? (t7 = isReleasesEnabled && /* @__PURE__ */ jsx(CreateReleaseMenuItem, { onCreateRelease }), $[21] = isReleasesEnabled, $[22] = onCreateRelease, $[23] = t7) : t7 = $[23];
  let t8;
  return $[24] !== disabled || $[25] !== t1 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== t7 ? (t8 = /* @__PURE__ */ jsxs(MenuGroup, { icon: CopyIcon, popover: t0, text: t1, disabled, tooltipProps: t4, "data-testid": "copy-version-to-release-button-group", children: [
    t5,
    t6,
    t7
  ] }), $[24] = disabled, $[25] = t1, $[26] = t4, $[27] = t5, $[28] = t6, $[29] = t7, $[30] = t8) : t8 = $[30], t8;
}), CanonicalReleaseContextMenu = memo(function(props2) {
  const $ = c(40), {
    releases: releases2,
    releasesLoading,
    bundleId,
    onDiscard,
    onCreateRelease,
    onCopyToDrafts,
    onCopyToDraftsNavigate,
    onCreateVersion,
    disabled,
    locked,
    release,
    isGoingToUnpublish: t0,
    hasCreatePermission,
    hasDiscardPermission,
    isPublished,
    documentId,
    documentType
  } = props2, isGoingToUnpublish2 = t0 === void 0 ? !1 : t0, {
    t
  } = useTranslation(), hasCopyToDraftOption = useHasCopyToDraftOption(documentType, bundleId), isCopyToReleaseDisabled = disabled || !hasCreatePermission || isGoingToUnpublish2;
  let t1;
  $[0] !== releases2 ? (t1 = releases2.filter(_temp$1D), $[0] = releases2, $[1] = t1) : t1 = $[1];
  const copyToReleaseOptions = t1, isReleasesEnabled = !!useWorkspace().releases?.enabled, showCopyToReleaseMenuItem = isReleasesEnabled || hasCopyToDraftOption;
  let t2;
  $[2] !== bundleId || $[3] !== disabled || $[4] !== release || $[5] !== t ? (t2 = release && /* @__PURE__ */ jsx(IntentLink, { intent: RELEASES_INTENT, params: {
    id: bundleId
  }, rel: "noopener noreferrer", style: {
    textDecoration: "none"
  }, disabled, children: /* @__PURE__ */ jsx(MenuItem, { icon: CalendarIcon, text: t("release.action.view-release") }) }), $[2] = bundleId, $[3] = disabled, $[4] = release, $[5] = t, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] !== releasesLoading ? (t3 = releasesLoading && /* @__PURE__ */ jsx(Spinner, {}), $[7] = releasesLoading, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== bundleId || $[10] !== copyToReleaseOptions || $[11] !== documentId || $[12] !== documentType || $[13] !== hasCopyToDraftOption || $[14] !== hasCreatePermission || $[15] !== isCopyToReleaseDisabled || $[16] !== isReleasesEnabled || $[17] !== onCopyToDrafts || $[18] !== onCopyToDraftsNavigate || $[19] !== onCreateRelease || $[20] !== onCreateVersion || $[21] !== showCopyToReleaseMenuItem ? (t4 = showCopyToReleaseMenuItem && /* @__PURE__ */ jsx(CopyToReleaseMenuGroup, { releases: copyToReleaseOptions, hasCopyToDraftOption, isReleasesEnabled, bundleId, onCreateRelease, onCopyToDrafts, onCopyToDraftsNavigate, onCreateVersion, disabled: isCopyToReleaseDisabled, hasCreatePermission, documentId, documentType }), $[9] = bundleId, $[10] = copyToReleaseOptions, $[11] = documentId, $[12] = documentType, $[13] = hasCopyToDraftOption, $[14] = hasCreatePermission, $[15] = isCopyToReleaseDisabled, $[16] = isReleasesEnabled, $[17] = onCopyToDrafts, $[18] = onCopyToDraftsNavigate, $[19] = onCreateRelease, $[20] = onCreateVersion, $[21] = showCopyToReleaseMenuItem, $[22] = t4) : t4 = $[22];
  let t5;
  $[23] !== isPublished || $[24] !== release || $[25] !== showCopyToReleaseMenuItem ? (t5 = !isPublished && (showCopyToReleaseMenuItem || release) && /* @__PURE__ */ jsx(MenuDivider, {}), $[23] = isPublished, $[24] = release, $[25] = showCopyToReleaseMenuItem, $[26] = t5) : t5 = $[26];
  let t6;
  $[27] !== disabled || $[28] !== hasDiscardPermission || $[29] !== isPublished || $[30] !== locked || $[31] !== onDiscard || $[32] !== t ? (t6 = !isPublished && /* @__PURE__ */ jsx(MenuItem, { icon: TrashIcon, onClick: onDiscard, text: t("release.action.discard-version"), tone: "critical", disabled: disabled || locked || !hasDiscardPermission, tooltipProps: {
    disabled: hasDiscardPermission,
    content: t("release.action.permission.error")
  } }), $[27] = disabled, $[28] = hasDiscardPermission, $[29] = isPublished, $[30] = locked, $[31] = onDiscard, $[32] = t, $[33] = t6) : t6 = $[33];
  let t7;
  return $[34] !== t2 || $[35] !== t3 || $[36] !== t4 || $[37] !== t5 || $[38] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Menu, { children: [
    t2,
    t3,
    t4,
    t5,
    t6
  ] }), $[34] = t2, $[35] = t3, $[36] = t4, $[37] = t5, $[38] = t6, $[39] = t7) : t7 = $[39], t7;
});
function _temp$1D(r) {
  return !isReleaseScheduledOrScheduling(r);
}
const ScheduledDraftContextMenu = memo(function(props2) {
  const $ = c(36), {
    releases: releases2,
    bundleId,
    onCreateRelease,
    onCopyToDrafts,
    onCopyToDraftsNavigate,
    onCreateVersion,
    disabled,
    isGoingToUnpublish: t0,
    hasCreatePermission,
    scheduledDraftMenuActions,
    documentId,
    documentType,
    release
  } = props2, isGoingToUnpublish2 = t0 === void 0 ? !1 : t0, {
    t
  } = useTranslation(), hasCopyToDraftOption = useHasCopyToDraftOption(documentType, bundleId), isCopyToReleaseDisabled = disabled || !hasCreatePermission || isGoingToUnpublish2;
  let t1;
  $[0] !== releases2 ? (t1 = releases2.filter(_temp$1C), $[0] = releases2, $[1] = t1) : t1 = $[1];
  const copyToReleaseOptions = t1, isReleasesEnabled = !!useWorkspace().releases?.enabled, showCopyToReleaseMenuItem = isReleasesEnabled && copyToReleaseOptions.length > 0, {
    actions
  } = scheduledDraftMenuActions;
  let t2;
  $[2] !== actions.publishNow ? (t2 = /* @__PURE__ */ jsx(MenuItem, { ...actions.publishNow }), $[2] = actions.publishNow, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== actions.editSchedule || $[5] !== release ? (t3 = !isPausedCardinalityOneRelease(release) && /* @__PURE__ */ jsx(MenuItem, { ...actions.editSchedule }), $[4] = actions.editSchedule, $[5] = release, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    view: "drafts"
  }, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    textDecoration: "none"
  }, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t ? (t6 = t("release.action.view-scheduled-drafts"), $[9] = t, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== t6 ? (t7 = /* @__PURE__ */ jsx(IntentLink, { intent: RELEASES_SCHEDULED_DRAFTS_INTENT, params: t4, rel: "noopener noreferrer", style: t5, children: /* @__PURE__ */ jsx(MenuItem, { icon: CalendarIcon, text: t6 }) }), $[11] = t6, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = /* @__PURE__ */ jsx(MenuDivider, {}), $[13] = t8) : t8 = $[13];
  let t9;
  $[14] !== bundleId || $[15] !== copyToReleaseOptions || $[16] !== documentId || $[17] !== documentType || $[18] !== hasCopyToDraftOption || $[19] !== hasCreatePermission || $[20] !== isCopyToReleaseDisabled || $[21] !== isReleasesEnabled || $[22] !== onCopyToDrafts || $[23] !== onCopyToDraftsNavigate || $[24] !== onCreateRelease || $[25] !== onCreateVersion || $[26] !== showCopyToReleaseMenuItem ? (t9 = (showCopyToReleaseMenuItem || hasCopyToDraftOption) && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(CopyToReleaseMenuGroup, { releases: copyToReleaseOptions, bundleId, hasCopyToDraftOption, isReleasesEnabled, onCreateRelease, onCopyToDrafts, onCopyToDraftsNavigate, onCreateVersion, disabled: isCopyToReleaseDisabled, hasCreatePermission, documentId, documentType }),
    /* @__PURE__ */ jsx(MenuDivider, {})
  ] }), $[14] = bundleId, $[15] = copyToReleaseOptions, $[16] = documentId, $[17] = documentType, $[18] = hasCopyToDraftOption, $[19] = hasCreatePermission, $[20] = isCopyToReleaseDisabled, $[21] = isReleasesEnabled, $[22] = onCopyToDrafts, $[23] = onCopyToDraftsNavigate, $[24] = onCreateRelease, $[25] = onCreateVersion, $[26] = showCopyToReleaseMenuItem, $[27] = t9) : t9 = $[27];
  let t10;
  $[28] !== actions.deleteSchedule ? (t10 = /* @__PURE__ */ jsx(MenuItem, { ...actions.deleteSchedule }), $[28] = actions.deleteSchedule, $[29] = t10) : t10 = $[29];
  let t11;
  return $[30] !== t10 || $[31] !== t2 || $[32] !== t3 || $[33] !== t7 || $[34] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Menu, { children: [
    t2,
    t3,
    t7,
    t8,
    t9,
    t10
  ] }), $[30] = t10, $[31] = t2, $[32] = t3, $[33] = t7, $[34] = t9, $[35] = t11) : t11 = $[35], t11;
});
function _temp$1C(r) {
  return !isReleaseScheduledOrScheduling(r);
}
const VersionContextMenu = memo(function(props2) {
  const $ = c(47), {
    documentId,
    releases: releases2,
    releasesLoading,
    fromRelease,
    isVersion,
    onDiscard,
    onCreateRelease,
    onCopyToDrafts,
    onCopyToDraftsNavigate,
    onCreateVersion,
    disabled,
    locked,
    type,
    isGoingToUnpublish: t0,
    release,
    isScheduledDraft,
    scheduledDraftMenuActions
  } = props2, isGoingToUnpublish2 = t0 === void 0 ? !1 : t0;
  let t1;
  $[0] !== documentId || $[1] !== isVersion ? (t1 = isPublishedId(documentId) && !isVersion, $[0] = documentId, $[1] = isVersion, $[2] = t1) : t1 = $[2];
  const isPublished = t1, {
    checkWithPermissionGuard
  } = useReleasePermissions(), {
    createRelease
  } = useReleaseOperations(), [hasCreatePermission, setHasCreatePermission] = useState(null);
  let t2;
  $[3] !== documentId ? (t2 = getPublishedId(documentId), $[3] = documentId, $[4] = t2) : t2 = $[4];
  const t3 = isVersion ? fromRelease : void 0, t4 = fromRelease === "draft" ? "discardDraft" : "discardVersion";
  let t5;
  $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== type ? (t5 = {
    id: t2,
    type,
    version: t3,
    permission: t4
  }, $[5] = t2, $[6] = t3, $[7] = t4, $[8] = type, $[9] = t5) : t5 = $[9];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t5), hasDiscardPermission = !isPermissionsLoading && permissions?.granted, isMounted = useRef(!1);
  let t6, t7;
  if ($[10] !== checkWithPermissionGuard || $[11] !== createRelease ? (t6 = () => (isMounted.current = !0, checkWithPermissionGuard(createRelease, getReleaseDefaults()).then((hasPermission) => {
    isMounted.current && setHasCreatePermission(hasPermission);
  }), () => {
    isMounted.current = !1;
  }), t7 = [checkWithPermissionGuard, createRelease], $[10] = checkWithPermissionGuard, $[11] = createRelease, $[12] = t6, $[13] = t7) : (t6 = $[12], t7 = $[13]), useEffect(t6, t7), isScheduledDraft && isVersion && release && scheduledDraftMenuActions) {
    let t82;
    return $[14] !== disabled || $[15] !== documentId || $[16] !== fromRelease || $[17] !== hasCreatePermission || $[18] !== isGoingToUnpublish2 || $[19] !== onCopyToDrafts || $[20] !== onCopyToDraftsNavigate || $[21] !== onCreateRelease || $[22] !== onCreateVersion || $[23] !== release || $[24] !== releases2 || $[25] !== scheduledDraftMenuActions || $[26] !== type ? (t82 = /* @__PURE__ */ jsx(ScheduledDraftContextMenu, { releases: releases2, bundleId: fromRelease, release, onCreateRelease, onCopyToDrafts, onCopyToDraftsNavigate, onCreateVersion, disabled, isGoingToUnpublish: isGoingToUnpublish2, hasCreatePermission, scheduledDraftMenuActions, documentId, documentType: type }), $[14] = disabled, $[15] = documentId, $[16] = fromRelease, $[17] = hasCreatePermission, $[18] = isGoingToUnpublish2, $[19] = onCopyToDrafts, $[20] = onCopyToDraftsNavigate, $[21] = onCreateRelease, $[22] = onCreateVersion, $[23] = release, $[24] = releases2, $[25] = scheduledDraftMenuActions, $[26] = type, $[27] = t82) : t82 = $[27], t82;
  }
  const t8 = hasDiscardPermission || !1;
  let t9;
  return $[28] !== disabled || $[29] !== documentId || $[30] !== fromRelease || $[31] !== hasCreatePermission || $[32] !== isGoingToUnpublish2 || $[33] !== isPublished || $[34] !== isVersion || $[35] !== locked || $[36] !== onCopyToDrafts || $[37] !== onCopyToDraftsNavigate || $[38] !== onCreateRelease || $[39] !== onCreateVersion || $[40] !== onDiscard || $[41] !== release || $[42] !== releases2 || $[43] !== releasesLoading || $[44] !== t8 || $[45] !== type ? (t9 = /* @__PURE__ */ jsx(CanonicalReleaseContextMenu, { releases: releases2, releasesLoading, bundleId: fromRelease, release, isVersion, onDiscard, onCreateRelease, onCopyToDrafts, onCopyToDraftsNavigate, onCreateVersion, disabled, locked, isGoingToUnpublish: isGoingToUnpublish2, hasCreatePermission, hasDiscardPermission: t8, isPublished, documentId, documentType: type }), $[28] = disabled, $[29] = documentId, $[30] = fromRelease, $[31] = hasCreatePermission, $[32] = isGoingToUnpublish2, $[33] = isPublished, $[34] = isVersion, $[35] = locked, $[36] = onCopyToDrafts, $[37] = onCopyToDraftsNavigate, $[38] = onCreateRelease, $[39] = onCreateVersion, $[40] = onDiscard, $[41] = release, $[42] = releases2, $[43] = releasesLoading, $[44] = t8, $[45] = type, $[46] = t9) : t9 = $[46], t9;
}), CopyToDraftsDialog = memo(function(props2) {
  const $ = c(30), {
    documentId,
    fromRelease,
    onClose,
    onNavigate
  } = props2, {
    t: tReleases
  } = useTranslation(releasesLocaleNamespace), [isProcessing, startTransition2] = useTransition();
  let t0;
  $[0] !== documentId || $[1] !== fromRelease || $[2] !== onNavigate ? (t0 = {
    documentId,
    fromRelease,
    onNavigate
  }, $[0] = documentId, $[1] = fromRelease, $[2] = onNavigate, $[3] = t0) : t0 = $[3];
  const {
    handleCopyToDrafts
  } = useCopyToDrafts(t0);
  let t1;
  $[4] !== handleCopyToDrafts || $[5] !== onClose ? (t1 = () => startTransition2(async () => {
    await handleCopyToDrafts(), onClose();
  }), $[4] = handleCopyToDrafts, $[5] = onClose, $[6] = t1) : t1 = $[6];
  const handleConfirm = t1;
  let t2;
  $[7] !== tReleases ? (t2 = tReleases("copy-to-draft-dialog.title"), $[7] = tReleases, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== tReleases ? (t3 = tReleases("copy-to-draft-dialog.confirm-button"), $[9] = tReleases, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== handleConfirm || $[12] !== isProcessing || $[13] !== t3 ? (t4 = {
    text: t3,
    onClick: handleConfirm,
    loading: isProcessing,
    disabled: isProcessing
  }, $[11] = handleConfirm, $[12] = isProcessing, $[13] = t3, $[14] = t4) : t4 = $[14];
  let t5;
  $[15] !== isProcessing || $[16] !== onClose ? (t5 = {
    onClick: onClose,
    disabled: isProcessing
  }, $[15] = isProcessing, $[16] = onClose, $[17] = t5) : t5 = $[17];
  let t6;
  $[18] !== t4 || $[19] !== t5 ? (t6 = {
    confirmButton: t4,
    cancelButton: t5
  }, $[18] = t4, $[19] = t5, $[20] = t6) : t6 = $[20];
  let t7;
  $[21] !== tReleases ? (t7 = tReleases("copy-to-draft-dialog.description"), $[21] = tReleases, $[22] = t7) : t7 = $[22];
  let t8;
  $[23] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t7 }), $[23] = t7, $[24] = t8) : t8 = $[24];
  let t9;
  return $[25] !== onClose || $[26] !== t2 || $[27] !== t6 || $[28] !== t8 ? (t9 = /* @__PURE__ */ jsx(Dialog$1, { id: "copy-to-drafts-dialog", header: t2, onClose, footer: t6, children: t8 }), $[25] = onClose, $[26] = t2, $[27] = t6, $[28] = t8, $[29] = t9) : t9 = $[29], t9;
});
function CopyToNewReleaseDialog(props2) {
  const $ = c(79), {
    onClose,
    documentId,
    documentType,
    release: sourceRelease,
    title,
    onCreateVersion
  } = props2, {
    t
  } = useTranslation(), toast = useToast(), createReleaseMetadata = useCreateReleaseMetadata(), {
    releasePromise
  } = useGuardWithReleaseLimitUpsell(), schema2 = useSchema();
  let t0;
  $[0] !== documentType || $[1] !== schema2 ? (t0 = schema2.get(documentType), $[0] = documentType, $[1] = schema2, $[2] = t0) : t0 = $[2];
  const schemaType = t0, [newReleaseId] = useState(createReleaseId);
  let t1;
  $[3] !== newReleaseId ? (t1 = () => ({
    _id: newReleaseId,
    metadata: {
      title: "",
      description: "",
      releaseType: DEFAULT_RELEASE_TYPE
    }
  }), $[3] = newReleaseId, $[4] = t1) : t1 = $[4];
  const [release, setRelease] = useState(t1), [isSubmitting, setIsSubmitting] = useState(!1), [, setRerenderDialog] = useState(0), telemetry = useTelemetry(), {
    createRelease
  } = useReleaseOperations(), {
    clearReleaseDataFromStorage
  } = useReleaseFormStorage();
  let t2;
  $[5] !== t || $[6] !== title ? (t2 = title || t("release.placeholder-untitled-release"), $[5] = t, $[6] = title, $[7] = t2) : t2 = $[7];
  const displayTitle = t2;
  let t3;
  $[8] !== release ? (t3 = getIsScheduledDateInPast(release), $[8] = release, $[9] = t3) : t3 = $[9];
  const isScheduledDateInPast = t3;
  let t4;
  $[10] !== release ? (t4 = getIsReleaseInvalid(release), $[10] = release, $[11] = t4) : t4 = $[11];
  const invalid = t4;
  let t5;
  $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = (releaseMetadata) => {
    setRelease(releaseMetadata);
  }, $[12] = t5) : t5 = $[12];
  const handleOnChange = t5;
  let t6;
  $[13] !== newReleaseId || $[14] !== onCreateVersion ? (t6 = () => {
    onCreateVersion(newReleaseId);
  }, $[13] = newReleaseId, $[14] = onCreateVersion, $[15] = t6) : t6 = $[15];
  const handleAddVersion = t6;
  let t7;
  $[16] !== clearReleaseDataFromStorage || $[17] !== createRelease || $[18] !== createReleaseMetadata || $[19] !== handleAddVersion || $[20] !== onClose || $[21] !== release || $[22] !== releasePromise || $[23] !== setRerenderDialog || $[24] !== t || $[25] !== telemetry || $[26] !== toast ? (t7 = async () => {
    if (getIsScheduledDateInPast(release)) {
      setRerenderDialog(_temp$1B);
      return;
    }
    if (setIsSubmitting(!0), !await releasePromise) {
      setIsSubmitting(!1);
      return;
    }
    try {
      const releaseValue = createReleaseMetadata(release);
      await createRelease(releaseValue), handleAddVersion(), telemetry.log(CreatedRelease, {
        origin: "document-panel"
      });
    } catch (t82) {
      const err = t82;
      isReleaseLimitError(err) ? onClose() : (console.error(err), toast.push({
        closable: !0,
        status: "error",
        title: t("release.toast.create-release-error.title"),
        description: err.message
      }));
    }
    setIsSubmitting(!1), clearReleaseDataFromStorage();
  }, $[16] = clearReleaseDataFromStorage, $[17] = createRelease, $[18] = createReleaseMetadata, $[19] = handleAddVersion, $[20] = onClose, $[21] = release, $[22] = releasePromise, $[23] = setRerenderDialog, $[24] = t, $[25] = telemetry, $[26] = toast, $[27] = t7) : t7 = $[27];
  const handleCreateRelease = t7;
  let t8;
  $[28] !== clearReleaseDataFromStorage || $[29] !== onClose ? (t8 = () => {
    clearReleaseDataFromStorage(), onClose();
  }, $[28] = clearReleaseDataFromStorage, $[29] = onClose, $[30] = t8) : t8 = $[30];
  const handleOnClose = t8;
  let t9;
  $[31] !== t ? (t9 = t("release.dialog.copy-to-release.title"), $[31] = t, $[32] = t9) : t9 = $[32];
  let t10;
  $[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    borderBottom: "1px solid var(--card-border-color)"
  }, $[33] = t10) : t10 = $[33];
  let t11;
  $[34] !== documentId || $[35] !== schemaType ? (t11 = schemaType ? /* @__PURE__ */ jsx(Preview$1, { value: {
    _id: documentId
  }, schemaType }) : /* @__PURE__ */ jsx(LoadingBlock, {}), $[34] = documentId, $[35] = schemaType, $[36] = t11) : t11 = $[36];
  let t12;
  $[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = {
    borderRadius: 999,
    border: "1px solid var(--card-border-color)",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }, $[37] = t12) : t12 = $[37];
  let t13;
  $[38] !== sourceRelease ? (t13 = /* @__PURE__ */ jsx(ReleaseAvatar, { padding: 1, release: sourceRelease }), $[38] = sourceRelease, $[39] = t13) : t13 = $[39];
  let t14;
  $[40] !== displayTitle ? (t14 = /* @__PURE__ */ jsx(Text$1, { size: 1, title: displayTitle, children: displayTitle }), $[40] = displayTitle, $[41] = t14) : t14 = $[41];
  let t15;
  $[42] !== t13 || $[43] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, padding: 1, paddingRight: 2, style: t12, children: [
    t13,
    t14
  ] }), $[42] = t13, $[43] = t14, $[44] = t15) : t15 = $[44];
  let t16;
  $[45] !== t11 || $[46] !== t15 ? (t16 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginBottom: 2, style: t10, children: /* @__PURE__ */ jsxs(Flex, { align: "center", padding: 4, paddingTop: 1, justify: "space-between", children: [
    t11,
    t15
  ] }) }), $[45] = t11, $[46] = t15, $[47] = t16) : t16 = $[47];
  let t17;
  $[48] !== isScheduledDateInPast || $[49] !== t ? (t17 = isScheduledDateInPast && /* @__PURE__ */ jsx(Card, { padding: 3, marginBottom: 3, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("release.schedule-dialog.publish-date-in-past-warning") }) }), $[48] = isScheduledDateInPast, $[49] = t, $[50] = t17) : t17 = $[50];
  let t18;
  $[51] !== release ? (t18 = /* @__PURE__ */ jsx(ReleaseForm, { onChange: handleOnChange, value: release }), $[51] = release, $[52] = t18) : t18 = $[52];
  let t19;
  $[53] !== t ? (t19 = t("common.dialog.cancel-button.text"), $[53] = t, $[54] = t19) : t19 = $[54];
  let t20;
  $[55] !== isSubmitting || $[56] !== onClose || $[57] !== t19 ? (t20 = /* @__PURE__ */ jsx(Button, { disabled: isSubmitting, text: t19, "data-testid": "cancel-button", onClick: onClose, mode: "bleed" }), $[55] = isSubmitting, $[56] = onClose, $[57] = t19, $[58] = t20) : t20 = $[58];
  const t21 = isSubmitting || isScheduledDateInPast || invalid;
  let t22;
  $[59] !== t ? (t22 = t("release.action.add-to-new-release"), $[59] = t, $[60] = t22) : t22 = $[60];
  let t23;
  $[61] !== handleCreateRelease || $[62] !== isSubmitting || $[63] !== t21 || $[64] !== t22 ? (t23 = /* @__PURE__ */ jsx(Button, { disabled: t21, type: "submit", onClick: handleCreateRelease, text: t22, loading: isSubmitting, tone: "primary", "data-testid": "confirm-button" }), $[61] = handleCreateRelease, $[62] = isSubmitting, $[63] = t21, $[64] = t22, $[65] = t23) : t23 = $[65];
  let t24;
  $[66] !== t20 || $[67] !== t23 ? (t24 = /* @__PURE__ */ jsxs(Flex, { width: "full", gap: 3, justify: "flex-end", paddingTop: 3, align: "center", children: [
    t20,
    t23
  ] }), $[66] = t20, $[67] = t23, $[68] = t24) : t24 = $[68];
  let t25;
  $[69] !== t17 || $[70] !== t18 || $[71] !== t24 ? (t25 = /* @__PURE__ */ jsxs(Box, { paddingX: 5, paddingY: 3, children: [
    t17,
    t18,
    t24
  ] }), $[69] = t17, $[70] = t18, $[71] = t24, $[72] = t25) : t25 = $[72];
  let t26;
  return $[73] !== handleOnClose || $[74] !== onClose || $[75] !== t16 || $[76] !== t25 || $[77] !== t9 ? (t26 = /* @__PURE__ */ jsxs(Dialog$1, { id: "create-release-dialog", header: t9, onClickOutside: onClose, onClose: handleOnClose, padding: !1, width: 1, children: [
    t16,
    t25
  ] }), $[73] = handleOnClose, $[74] = onClose, $[75] = t16, $[76] = t25, $[77] = t9, $[78] = t26) : t26 = $[78], t26;
}
function _temp$1B(cur) {
  return cur + 1;
}
const useVersionIsLinked = (documentId, fromRelease) => {
  const $ = c(13);
  let t0;
  bb0: {
    if (fromRelease === "published") {
      let t13;
      $[0] !== documentId ? (t13 = getPublishedId(documentId), $[0] = documentId, $[1] = t13) : t13 = $[1], t0 = t13;
      break bb0;
    }
    if (fromRelease === "draft") {
      let t13;
      $[2] !== documentId ? (t13 = getDraftId(documentId), $[2] = documentId, $[3] = t13) : t13 = $[3], t0 = t13;
      break bb0;
    }
    let t12;
    $[4] !== documentId || $[5] !== fromRelease ? (t12 = getVersionId(documentId, fromRelease), $[4] = documentId, $[5] = fromRelease, $[6] = t12) : t12 = $[6], t0 = t12;
  }
  const versionId = t0, companionDocsStore = useCanvasCompanionDocsStore();
  let t1;
  $[7] !== companionDocsStore || $[8] !== documentId ? (t1 = companionDocsStore.getCompanionDocs(documentId), $[7] = companionDocsStore, $[8] = documentId, $[9] = t1) : t1 = $[9];
  const companionDocs = useObservable(t1);
  let t2;
  return $[10] !== companionDocs?.data || $[11] !== versionId ? (t2 = companionDocs?.data.some((companion) => companion?.studioDocumentId === versionId), $[10] = companionDocs?.data, $[11] = versionId, $[12] = t2) : t2 = $[12], t2;
}, CONTEXT_MENU_CLOSED = {
  open: !1
}, VersionChip$1 = memo(function(props2) {
  const $ = c(108), {
    disabled,
    selected,
    tooltipContent,
    onClick: onClick2,
    text,
    contextMenuPortal: t0,
    tone,
    locked: t1,
    onCopyToDraftsNavigate,
    contextValues: t2
  } = props2, contextMenuPortal = t0 === void 0 ? !0 : t0, locked = t1 === void 0 ? !1 : t1, {
    documentId,
    releases: releases2,
    releasesLoading,
    documentType,
    bundleId,
    isVersion,
    disabled: t3,
    isGoingToUnpublish: t4,
    release
  } = t2, contextMenuDisabled = t3 === void 0 ? !1 : t3, isGoingToUnpublish2 = t4 === void 0 ? !1 : t4, releasesToolAvailable = useReleasesToolAvailable(), isLinked = useVersionIsLinked(documentId, bundleId);
  let t5;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    open: !1
  }, $[0] = t5) : t5 = $[0];
  const [contextMenu, setContextMenu] = useState(t5), popoverRef = useRef(null), [dialogState, setDialogState] = useState("idle"), chipRef = useRef(null);
  let t6, t7;
  $[1] !== selected ? (t6 = () => {
    selected && chipRef.current?.scrollIntoView({
      inline: "center"
    });
  }, t7 = [selected], $[1] = selected, $[2] = t6, $[3] = t7) : (t6 = $[2], t7 = $[3]), useEffect(t6, t7);
  let t8;
  $[4] !== bundleId || $[5] !== documentId || $[6] !== isVersion ? (t8 = isVersion ? getVersionId(documentId, bundleId) : documentId, $[4] = bundleId, $[5] = documentId, $[6] = isVersion, $[7] = t8) : t8 = $[7];
  const docId = t8, {
    createVersion
  } = useVersionOperations(), toast = useToast(), {
    t
  } = useTranslation(), {
    onSetScheduledDraftPerspective
  } = useSingleDocRelease();
  let t9;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = () => setContextMenu(CONTEXT_MENU_CLOSED), $[8] = t9) : t9 = $[8];
  const close = t9, [referenceElement, setReferenceElement] = useState(null);
  let t10;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = (event) => {
    event.preventDefault();
    const elementRect = event.currentTarget?.getBoundingClientRect();
    setContextMenu({
      open: !0,
      translate: {
        x: event.clientX - elementRect.left,
        y: elementRect.top - event.clientY
      }
    });
  }, $[9] = t10) : t10 = $[9];
  const handleContextMenu = t10;
  let t11;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = () => [popoverRef.current], $[10] = t11) : t11 = $[10], useClickOutsideEvent(close, t11);
  let t12;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = (event_0) => {
    event_0.key === "Escape" && close();
  }, $[11] = t12) : t12 = $[11], useGlobalKeyDown(t12);
  let t13;
  $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = () => {
    setDialogState("discard-version");
  }, $[12] = t13) : t13 = $[12];
  const openDiscardDialog = t13;
  let t14;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t14 = () => {
    setDialogState("create-release");
  }, $[13] = t14) : t14 = $[13];
  const openCreateReleaseDialog = t14;
  let t15;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = () => {
    setDialogState("copy-to-drafts");
  }, $[14] = t15) : t15 = $[14];
  const openCopyToDraftsDialog = t15;
  let t16;
  $[15] !== createVersion || $[16] !== docId || $[17] !== t || $[18] !== toast ? (t16 = async (targetRelease) => {
    try {
      await createVersion(getReleaseIdFromReleaseDocumentId(targetRelease), docId);
    } catch (t172) {
      const err = t172;
      toast.push({
        closable: !0,
        status: "error",
        title: t("release.action.create-version.failure"),
        description: err.message
      });
    }
    close();
  }, $[15] = createVersion, $[16] = docId, $[17] = t, $[18] = toast, $[19] = t16) : t16 = $[19];
  const handleAddVersion = t16, contextMenuHandler = disabled || !releasesToolAvailable ? void 0 : handleContextMenu;
  let t17;
  $[20] !== isVersion || $[21] !== release ? (t17 = release && isVersion && isCardinalityOneRelease(release), $[20] = isVersion, $[21] = release, $[22] = t17) : t17 = $[22];
  const isScheduledDraft = t17;
  let t18;
  $[23] !== onSetScheduledDraftPerspective || $[24] !== release ? (t18 = () => {
    release && onSetScheduledDraftPerspective(getReleaseIdFromReleaseDocumentId(release._id));
  }, $[23] = onSetScheduledDraftPerspective, $[24] = release, $[25] = t18) : t18 = $[25];
  const handleEditScheduleComplete = t18;
  let t19;
  $[26] !== contextMenuDisabled || $[27] !== documentId || $[28] !== documentType || $[29] !== handleEditScheduleComplete || $[30] !== release ? (t19 = {
    release,
    documentType,
    documentId,
    disabled: contextMenuDisabled,
    onActionComplete: handleEditScheduleComplete
  }, $[26] = contextMenuDisabled, $[27] = documentId, $[28] = documentType, $[29] = handleEditScheduleComplete, $[30] = release, $[31] = t19) : t19 = $[31];
  const scheduledDraftMenuActions = useScheduledDraftMenuActions(t19), isPaused = isPausedCardinalityOneRelease(release), sourceReleasePerspective = release ?? (bundleId === "published" ? PUBLISHED$1 : bundleId === "draft" ? LATEST : bundleId);
  let t20;
  bb0: {
    if (isLinked) {
      let t212;
      $[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t212 = /* @__PURE__ */ jsx(ComposeSparklesIcon, {}), $[32] = t212) : t212 = $[32], t20 = t212;
      break bb0;
    }
    if (isPaused) {
      let t212;
      $[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t212 = /* @__PURE__ */ jsx(UnlockIcon, {}), $[33] = t212) : t212 = $[33], t20 = t212;
      break bb0;
    }
    if (locked) {
      let t212;
      $[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t212 = /* @__PURE__ */ jsx(LockIcon, {}), $[34] = t212) : t212 = $[34], t20 = t212;
      break bb0;
    }
    t20 = void 0;
  }
  const rightIcon = t20;
  let t21;
  $[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t21 = [], $[35] = t21) : t21 = $[35];
  let t22;
  $[36] !== text ? (t22 = text.replaceAll(" ", "-"), $[36] = text, $[37] = t22) : t22 = $[37];
  const t23 = `document-header-${t22}-chip`, t24 = disabled ? "ghost" : "bleed";
  let t25;
  $[38] !== sourceReleasePerspective ? (t25 = /* @__PURE__ */ jsx(ReleaseAvatarIcon, { release: sourceReleasePerspective }), $[38] = sourceReleasePerspective, $[39] = t25) : t25 = $[39];
  let t26;
  $[40] !== contextMenuHandler || $[41] !== disabled || $[42] !== onClick2 || $[43] !== rightIcon || $[44] !== selected || $[45] !== t23 || $[46] !== t24 || $[47] !== t25 || $[48] !== text || $[49] !== tone ? (t26 = /* @__PURE__ */ jsx("span", { ref: chipRef, children: /* @__PURE__ */ jsx(Chip, { "data-testid": t23, ref: setReferenceElement, disabled, mode: t24, onClick: onClick2, selected, tone, onContextMenu: contextMenuHandler, icon: t25, iconRight: rightIcon, text }) }), $[40] = contextMenuHandler, $[41] = disabled, $[42] = onClick2, $[43] = rightIcon, $[44] = selected, $[45] = t23, $[46] = t24, $[47] = t25, $[48] = text, $[49] = tone, $[50] = t26) : t26 = $[50];
  let t27;
  $[51] !== t26 || $[52] !== tooltipContent ? (t27 = /* @__PURE__ */ jsx(Tooltip, { content: tooltipContent, fallbackPlacements: t21, portal: !0, placement: "bottom", children: t26 }), $[51] = t26, $[52] = tooltipContent, $[53] = t27) : t27 = $[53];
  let t28;
  $[54] !== bundleId || $[55] !== contextMenuDisabled || $[56] !== documentId || $[57] !== documentType || $[58] !== handleAddVersion || $[59] !== isGoingToUnpublish2 || $[60] !== isScheduledDraft || $[61] !== isVersion || $[62] !== locked || $[63] !== onCopyToDraftsNavigate || $[64] !== release || $[65] !== releases2 || $[66] !== releasesLoading || $[67] !== scheduledDraftMenuActions ? (t28 = /* @__PURE__ */ jsx(VersionContextMenu, { documentId, releases: releases2, releasesLoading, fromRelease: bundleId, isVersion, onDiscard: openDiscardDialog, onCreateRelease: openCreateReleaseDialog, onCopyToDrafts: openCopyToDraftsDialog, onCopyToDraftsNavigate, disabled: contextMenuDisabled, onCreateVersion: handleAddVersion, locked, type: documentType, isGoingToUnpublish: isGoingToUnpublish2, release, isScheduledDraft, scheduledDraftMenuActions }), $[54] = bundleId, $[55] = contextMenuDisabled, $[56] = documentId, $[57] = documentType, $[58] = handleAddVersion, $[59] = isGoingToUnpublish2, $[60] = isScheduledDraft, $[61] = isVersion, $[62] = locked, $[63] = onCopyToDraftsNavigate, $[64] = release, $[65] = releases2, $[66] = releasesLoading, $[67] = scheduledDraftMenuActions, $[68] = t28) : t28 = $[68];
  let t29;
  $[69] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t29 = [], $[69] = t29) : t29 = $[69];
  let t30;
  $[70] !== contextMenu.open || $[71] !== contextMenu.translate ? (t30 = contextMenu.open ? {
    transform: `translate(${contextMenu.translate.x}px, ${contextMenu.translate.y}px)`
  } : void 0, $[70] = contextMenu.open, $[71] = contextMenu.translate, $[72] = t30) : t30 = $[72];
  let t31;
  $[73] !== contextMenu.open || $[74] !== contextMenuPortal || $[75] !== referenceElement || $[76] !== t28 || $[77] !== t30 ? (t31 = /* @__PURE__ */ jsx(Popover, { animate: !1, content: t28, fallbackPlacements: t29, open: contextMenu.open, portal: contextMenuPortal, placement: "bottom-start", ref: popoverRef, referenceElement, zOffset: 10, style: t30 }), $[73] = contextMenu.open, $[74] = contextMenuPortal, $[75] = referenceElement, $[76] = t28, $[77] = t30, $[78] = t31) : t31 = $[78];
  let t32;
  $[79] !== bundleId || $[80] !== dialogState || $[81] !== documentId || $[82] !== documentType || $[83] !== isGoingToUnpublish2 || $[84] !== isVersion || $[85] !== text ? (t32 = dialogState === "discard-version" && /* @__PURE__ */ jsx(DiscardVersionDialog, { onClose: () => setDialogState("idle"), documentId: isVersion ? getVersionId(documentId, bundleId) : documentId, fromPerspective: text, documentType, isGoingToUnpublish: isGoingToUnpublish2 }), $[79] = bundleId, $[80] = dialogState, $[81] = documentId, $[82] = documentType, $[83] = isGoingToUnpublish2, $[84] = isVersion, $[85] = text, $[86] = t32) : t32 = $[86];
  let t33;
  $[87] !== bundleId || $[88] !== dialogState || $[89] !== documentId || $[90] !== documentType || $[91] !== handleAddVersion || $[92] !== isVersion || $[93] !== sourceReleasePerspective || $[94] !== text ? (t33 = dialogState === "create-release" && /* @__PURE__ */ jsx(CopyToNewReleaseDialog, { onClose: () => setDialogState("idle"), onCreateVersion: handleAddVersion, documentId: isVersion ? getVersionId(documentId, bundleId) : documentId, documentType, release: sourceReleasePerspective, title: text }), $[87] = bundleId, $[88] = dialogState, $[89] = documentId, $[90] = documentType, $[91] = handleAddVersion, $[92] = isVersion, $[93] = sourceReleasePerspective, $[94] = text, $[95] = t33) : t33 = $[95];
  let t34;
  $[96] !== bundleId || $[97] !== dialogState || $[98] !== documentId || $[99] !== onCopyToDraftsNavigate ? (t34 = dialogState === "copy-to-drafts" && /* @__PURE__ */ jsx(CopyToDraftsDialog, { onClose: () => setDialogState("idle"), documentId, fromRelease: bundleId, onNavigate: onCopyToDraftsNavigate }), $[96] = bundleId, $[97] = dialogState, $[98] = documentId, $[99] = onCopyToDraftsNavigate, $[100] = t34) : t34 = $[100];
  const t35 = isScheduledDraft && scheduledDraftMenuActions.dialogs;
  let t36;
  return $[101] !== t27 || $[102] !== t31 || $[103] !== t32 || $[104] !== t33 || $[105] !== t34 || $[106] !== t35 ? (t36 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t27,
    t31,
    t32,
    t33,
    t34,
    t35
  ] }), $[101] = t27, $[102] = t31, $[103] = t32, $[104] = t33, $[105] = t34, $[106] = t35, $[107] = t36) : t36 = $[107], t36;
}), PRESENCE_MENU_POPOVER_PROPS = {
  portal: !0
}, AvatarStackBox = /* @__PURE__ */ styled.div.withConfig({
  displayName: "AvatarStackBox",
  componentId: "sc-q68gz0-0"
})((props2) => {
  const {
    space
  } = getTheme_v2(props2.theme);
  return css`
    margin: ${0 - space[1]}px;
  `;
});
function DocumentPreviewPresence(props2) {
  const $ = c(21), {
    presence
  } = props2, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    data: releases2
  } = useActiveReleases();
  let t0;
  $[0] !== presence ? (t0 = Array.from(new Set(presence.map(_temp$1A))), $[0] = presence, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== presence || $[3] !== t0 ? (t1 = t0.map((id2) => presence.find((a_0) => a_0.user.id === id2)).filter(isNonNullable$2), $[2] = presence, $[3] = t0, $[4] = t1) : t1 = $[4];
  const uniquePresence = t1;
  let t2;
  bb0: {
    if (uniquePresence.length === 1) {
      const firstPresence = uniquePresence[0], documentId = firstPresence?.documentId;
      let t32;
      if ($[5] !== documentId || $[6] !== firstPresence.user.displayName || $[7] !== releases2 || $[8] !== t) {
        const releaseTitle = (documentId ? releases2.find((r) => getReleaseIdFromReleaseDocumentId(r._id) === getVersionFromId(documentId)) : void 0)?.metadata?.title;
        t32 = t("presence.tooltip.one", {
          displayName: firstPresence.user.displayName,
          releaseTitle: releaseTitle || t("release-placeholder.title")
        }), $[5] = documentId, $[6] = firstPresence.user.displayName, $[7] = releases2, $[8] = t, $[9] = t32;
      } else
        t32 = $[9];
      t2 = t32;
      break bb0;
    }
    if (uniquePresence.length > 1) {
      let t32;
      $[10] !== t || $[11] !== uniquePresence.length ? (t32 = t("presence.tooltip.other", {
        count: uniquePresence.length
      }), $[10] = t, $[11] = uniquePresence.length, $[12] = t32) : t32 = $[12], t2 = t32;
      break bb0;
    }
    t2 = void 0;
  }
  const tooltipContent = t2;
  let t3;
  $[13] !== uniquePresence ? (t3 = uniquePresence.map(_temp2$F), $[13] = uniquePresence, $[14] = t3) : t3 = $[14];
  let t4;
  $[15] !== t3 || $[16] !== tooltipContent ? (t4 = /* @__PURE__ */ jsx(AvatarStackBox, { children: /* @__PURE__ */ jsx(AvatarStack, { maxLength: 2, "aria-label": tooltipContent, size: 0, children: t3 }) }), $[15] = t3, $[16] = tooltipContent, $[17] = t4) : t4 = $[17];
  let t5;
  return $[18] !== t4 || $[19] !== tooltipContent ? (t5 = /* @__PURE__ */ jsx(Tooltip, { content: tooltipContent, ...PRESENCE_MENU_POPOVER_PROPS, children: t4 }), $[18] = t4, $[19] = tooltipContent, $[20] = t5) : t5 = $[20], t5;
}
function _temp2$F(item) {
  return /* @__PURE__ */ jsx(UserAvatar, { size: 0, user: item.user }, item.user.id);
}
function _temp$1A(a) {
  return a.user.id;
}
const FlexWrapper = styled(Flex).withConfig({
  displayName: "FlexWrapper",
  componentId: "sc-u08lu2-0"
})`& > div:first-child{flex:1;min-width:0;}`, InnerBox = styled(Flex).withConfig({
  displayName: "InnerBox",
  componentId: "sc-u08lu2-1"
})`height:${AVATAR_SIZE}px;min-width:23px;vertical-align:top;`;
function PresenceTrackerComponent(props2) {
  const $ = c(6), {
    children
  } = props2, {
    store,
    snapshot: snapshot2
  } = useTrackerStore();
  let t0;
  $[0] !== children || $[1] !== snapshot2 ? (t0 = /* @__PURE__ */ jsx(PresenceTrackerContextGetSnapshot.Provider, { value: snapshot2, children }), $[0] = children, $[1] = snapshot2, $[2] = t0) : t0 = $[2];
  let t1;
  return $[3] !== store || $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(PresenceTrackerContextStore.Provider, { value: store, children: t0 }), $[3] = store, $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}
const PresenceTracker = memo(PresenceTrackerComponent), EMPTY_ARRAY$j = [];
function usePresenceReportedValues() {
  const snapshot2 = useContext(PresenceTrackerContextGetSnapshot);
  return snapshot2 === null ? (console.warn(new Error('No context provided for reporter. Make sure that the component calling "usePresenceReportedValues()", is wrapped inside a <PresenceTracker> element')), EMPTY_ARRAY$j) : snapshot2;
}
const usePresenceReporter = (id2, value, isEqual2) => {
  const store = useContext(PresenceTrackerContextStore);
  store === null && console.warn(new Error('No context provided for reporter. Make sure that the component calling "usePresenceReporter()", is wrapped inside a <PresenceTracker> element')), useTrackerStoreReporter(store, id2, value, isEqual2);
};
function PresenceTooltip(props2) {
  const $ = c(7), {
    children,
    items
  } = props2;
  let t0;
  $[0] !== items ? (t0 = items.map(_temp$1z), $[0] = items, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(Stack, { sizing: "border", children: t0 }), $[2] = t0, $[3] = t1) : t1 = $[3];
  const content = t1;
  let t2;
  return $[4] !== children || $[5] !== content ? (t2 = /* @__PURE__ */ jsx(Tooltip, { content, placement: "top", portal: "documentScrollElement", children }), $[4] = children, $[5] = content, $[6] = t2) : t2 = $[6], t2;
}
function _temp$1z(item) {
  return /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(UserAvatar, { user: item.user, status: "online" }) }),
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: item.user.displayName })
  ] }, item.user.id);
}
const FieldPresenceInner = memo(function(t0) {
  const $ = c(12), {
    presence,
    position: t1,
    animateArrowFrom: t2,
    maxAvatars: t3,
    stack: t4
  } = t0, position = t1 === void 0 ? "inside" : t1, animateArrowFrom = t2 === void 0 ? "inside" : t2, maxAvatars = t3 === void 0 ? DEFAULT_MAX_AVATARS_FIELDS : t3, stack = t4 === void 0 ? !0 : t4;
  let t5;
  if ($[0] !== animateArrowFrom || $[1] !== maxAvatars || $[2] !== position || $[3] !== presence || $[4] !== stack) {
    const uniquePresence = uniqBy(presence || [], _temp$1y), sorted = sortBy(uniquePresence, _temp2$E), [hidden, visible] = stack ? splitRight(sorted, maxAvatars) : [[], sorted];
    let t62;
    $[6] !== animateArrowFrom || $[7] !== position ? (t62 = (_visible) => ({
      key: _visible.user.id,
      element: /* @__PURE__ */ jsx(UserAvatar, { animateArrowFrom, position, status: "online", user: _visible.user })
    }), $[6] = animateArrowFrom, $[7] = position, $[8] = t62) : t62 = $[8], t5 = [...visible.reverse().map(t62), hidden.length >= 2 ? {
      key: "counter",
      element: /* @__PURE__ */ jsx(AvatarCounter, { count: hidden.length })
    } : null].filter(Boolean), $[0] = animateArrowFrom, $[1] = maxAvatars, $[2] = position, $[3] = presence, $[4] = stack, $[5] = t5;
  } else
    t5 = $[5];
  const avatars = t5;
  let t6;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx("div", {}), $[9] = t6) : t6 = $[9];
  let t7;
  return $[10] !== avatars ? (t7 = /* @__PURE__ */ jsxs(FlexWrapper, { children: [
    t6,
    /* @__PURE__ */ jsx(InnerBox, { direction: "row-reverse", children: avatars.map(_temp3$m) })
  ] }), $[10] = avatars, $[11] = t7) : t7 = $[11], t7;
});
function FieldPresence(props2) {
  const $ = c(11), contextPresence = useContext(FormFieldPresenceContext), {
    presence: t0,
    maxAvatars: t1
  } = props2, presence = t0 === void 0 ? contextPresence : t0, maxAvatars = t1 === void 0 ? DEFAULT_MAX_AVATARS_FIELDS : t1, [element, setElement] = useState(null), reporterId = useId();
  let t2;
  $[0] !== element || $[1] !== maxAvatars || $[2] !== presence ? (t2 = () => ({
    presence,
    element,
    maxAvatars
  }), $[0] = element, $[1] = maxAvatars, $[2] = presence, $[3] = t2) : t2 = $[3], usePresenceReporter(element ? reporterId : null, t2);
  let t3;
  $[4] !== presence ? (t3 = presence || [], $[4] = presence, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t3 ? (t4 = uniqBy(t3, _temp4$b), $[6] = t3, $[7] = t4) : t4 = $[7];
  const uniquePresence = t4;
  let t5;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(FlexWrapper, { ref: setElement, style: {
    minHeight: AVATAR_SIZE,
    minWidth: AVATAR_SIZE
  } }), $[8] = t5) : t5 = $[8];
  let t6;
  return $[9] !== uniquePresence ? (t6 = /* @__PURE__ */ jsx(PresenceTooltip, { items: uniquePresence, children: t5 }), $[9] = uniquePresence, $[10] = t6) : t6 = $[10], t6;
}
function _temp4$b(item) {
  return item.user.id;
}
const FieldPresenceWithOverlay = FieldPresence;
function _temp$1y(item) {
  return item.user.id;
}
function _temp2$E(_presence) {
  return _presence.lastActiveAt;
}
function _temp3$m(av, i) {
  return av && /* @__PURE__ */ jsx("div", { style: {
    position: "absolute",
    transform: `translate3d(${-i * (AVATAR_SIZE + AVATAR_DISTANCE)}px, 0px, 0px)`,
    transitionProperty: "transform",
    transitionDuration: "200ms",
    transitionTimingFunction: "cubic-bezier(0.85, 0, 0.15, 1)",
    zIndex: 100 - i
  }, children: av.element }, av.key);
}
const createIntersectionObserver = (options) => {
  const entries$ = new Subject(), intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      entries$.next(entry);
    });
  }, options);
  return {
    observe: (element) => new Observable((subscriber) => {
      const subscription = entries$.pipe(filter((entry) => entry.target === element)).subscribe(subscriber);
      return intersectionObserver.observe(element), () => {
        subscription.unsubscribe(), intersectionObserver.unobserve(element);
      };
    })
  };
}, WithIntersection = (props2) => {
  const $ = c(12);
  let id2, io, onIntersection, rest;
  $[0] !== props2 ? ({
    onIntersection,
    io,
    id: id2,
    ...rest
  } = props2, $[0] = props2, $[1] = id2, $[2] = io, $[3] = onIntersection, $[4] = rest) : (id2 = $[1], io = $[2], onIntersection = $[3], rest = $[4]);
  const element = useRef(null);
  let t0, t1;
  $[5] !== id2 || $[6] !== io || $[7] !== onIntersection ? (t0 = () => {
    const el = element.current;
    if (!el)
      return;
    const subscription = io.observe(el).pipe(tap((entry) => onIntersection(id2, entry))).subscribe();
    return () => subscription.unsubscribe();
  }, t1 = [io, id2, onIntersection], $[5] = id2, $[6] = io, $[7] = onIntersection, $[8] = t0, $[9] = t1) : (t0 = $[8], t1 = $[9]), useEffect(t0, t1);
  let t2;
  return $[10] !== rest ? (t2 = /* @__PURE__ */ jsx("div", { ...rest, ref: element }), $[10] = rest, $[11] = t2) : t2 = $[11], t2;
}, RootWrapper = styled.div.withConfig({
  displayName: "RootWrapper",
  componentId: "sc-1elv6r8-0"
})`position:relative;`, OverlayWrapper = styled.div.withConfig({
  displayName: "OverlayWrapper",
  componentId: "sc-1elv6r8-1"
})`position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none;z-index:13;`, RegionWrapper = css`
  overflow: hidden;
  overflow: clip;
  pointer-events: none;
  position: absolute;
`, TopRegionWrapper = /* @__PURE__ */ styled(WithIntersection).withConfig({
  displayName: "TopRegionWrapper",
  componentId: "sc-1elv6r8-2"
})(({
  $debug,
  margins
}) => css`
    ${RegionWrapper}

    z-index: 100;
    position: sticky;
    height: 1px;
    top: ${margins ? `${margins[0] - 1}px` : void 0};
    background-color: ${$debug ? "red" : "none"};
  `), MiddleRegionWrapper = /* @__PURE__ */ styled(WithIntersection).withConfig({
  displayName: "MiddleRegionWrapper",
  componentId: "sc-1elv6r8-3"
})(({
  $debug
}) => css`
    ${RegionWrapper}

    visibility: none;

    ${$debug && css`
        background: rgba(255, 0, 0, 0.25);
        outline: 1px solid #00b;
        visibility: visible;
      `}
  `), BottomRegionWrapper = /* @__PURE__ */ styled(WithIntersection).withConfig({
  displayName: "BottomRegionWrapper",
  componentId: "sc-1elv6r8-4"
})(({
  $debug
}) => css`
    ${RegionWrapper}

    position: sticky;
    bottom: -1px;
    height: 1px;
    background-color: ${$debug ? "blue" : "transparent"};
  `), toPx = (num) => `${num}px`, negate = (num) => 0 - num, RegionsWithIntersections = forwardRef(function(props2, ref) {
  const $ = c(43), {
    regions,
    render: render2,
    children,
    margins: t0
  } = props2, [mt, mr, mb, ml] = t0, overlayRef = useRef(null);
  let t1;
  $[0] !== mb || $[1] !== ml || $[2] !== mr || $[3] !== mt ? (t1 = [mt, mr, mb, ml], $[0] = mb, $[1] = ml, $[2] = mr, $[3] = mt, $[4] = t1) : t1 = $[4];
  const margins = t1;
  let t2;
  $[5] !== margins ? (t2 = margins.map(negate).map(toPx), $[5] = margins, $[6] = t2) : t2 = $[6];
  const t3 = t2.join(" ");
  let t4;
  $[7] !== t3 ? (t4 = createIntersectionObserver({
    rootMargin: t3,
    threshold: INTERSECTION_THRESHOLDS
  }), $[7] = t3, $[8] = t4) : t4 = $[8];
  const io = t4;
  let t5;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {}, $[9] = t5) : t5 = $[9];
  const [intersections, setIntersections] = useState(t5);
  let t6;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = (id2, entry) => {
    setIntersections((current) => ({
      ...current,
      [id2]: entry
    }));
  }, $[10] = t6) : t6 = $[10];
  const onIntersection = t6, [overlayWidth, setOverlayWidth] = useState(0);
  let t7, t8;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = () => {
    if (overlayRef.current)
      return setOverlayWidth(overlayRef.current.offsetWidth), resizeObserver.observe(overlayRef.current, (event) => {
        setOverlayWidth(event.contentRect.width);
      });
  }, t8 = [], $[11] = t7, $[12] = t8) : (t7 = $[11], t8 = $[12]), useLayoutEffect(t7, t8);
  const top = intersections["::top"], bottom2 = intersections["::bottom"];
  let t9;
  $[13] !== bottom2 || $[14] !== intersections || $[15] !== regions || $[16] !== top ? (t9 = top && bottom2 ? regions.filter(_temp$1x).map((region_0) => {
    const intersection2 = intersections[region_0.id];
    if (!intersection2)
      return null;
    const {
      bottom: boundsBottom,
      top: boundsTop
    } = intersection2.boundingClientRect, aboveTop = intersection2.boundingClientRect.top < top.boundingClientRect.bottom, belowBottom = intersection2.boundingClientRect.top < bottom2.boundingClientRect.top, distanceTop = intersection2.isIntersecting ? boundsTop - (intersection2.intersectionRect.top - INTERSECTION_ELEMENT_PADDING) : aboveTop ? -top.boundingClientRect.bottom : bottom2.boundingClientRect.top, distanceBottom = intersection2.isIntersecting ? -(boundsBottom - (intersection2.intersectionRect.bottom + INTERSECTION_ELEMENT_PADDING)) : belowBottom ? bottom2.boundingClientRect.top : -top.boundingClientRect.bottom, position = distanceTop <= SNAP_TO_DOCK_DISTANCE_TOP ? "top" : distanceBottom <= SNAP_TO_DOCK_DISTANCE_BOTTOM ? "bottom" : "inside";
    return {
      distanceTop,
      distanceBottom,
      region: region_0,
      position
    };
  }).filter(Boolean) : [], $[13] = bottom2, $[14] = intersections, $[15] = regions, $[16] = top, $[17] = t9) : t9 = $[17];
  const regionsWithIntersectionDetails = t9;
  let t10;
  $[18] !== io || $[19] !== margins ? (t10 = /* @__PURE__ */ jsx(TopRegionWrapper, { $debug: DEBUG$1, io, id: "::top", onIntersection, margins }), $[18] = io, $[19] = margins, $[20] = t10) : t10 = $[20];
  let t11;
  $[21] !== children ? (t11 = /* @__PURE__ */ jsx("div", { children }), $[21] = children, $[22] = t11) : t11 = $[22];
  let t12;
  $[23] !== overlayWidth || $[24] !== regionsWithIntersectionDetails || $[25] !== render2 ? (t12 = overlayWidth && render2(regionsWithIntersectionDetails, overlayWidth), $[23] = overlayWidth, $[24] = regionsWithIntersectionDetails, $[25] = render2, $[26] = t12) : t12 = $[26];
  let t13;
  $[27] !== t12 ? (t13 = /* @__PURE__ */ jsx(OverlayWrapper, { ref: overlayRef, children: t12 }), $[27] = t12, $[28] = t13) : t13 = $[28];
  let t14;
  if ($[29] !== io || $[30] !== regions) {
    let t152;
    $[32] !== io ? (t152 = (region_1) => {
      const forceWidth = region_1.rect.width === 0;
      return /* @__PURE__ */ jsx(MiddleRegionWrapper, { $debug: DEBUG$1, io, onIntersection, id: region_1.id, style: {
        width: forceWidth ? 1 : region_1.rect.width,
        left: region_1.rect.left - (forceWidth ? 1 : 0),
        top: region_1.rect.top - INTERSECTION_ELEMENT_PADDING,
        height: region_1.rect.height + INTERSECTION_ELEMENT_PADDING * 2
      } }, region_1.id);
    }, $[32] = io, $[33] = t152) : t152 = $[33], t14 = regions.map(t152), $[29] = io, $[30] = regions, $[31] = t14;
  } else
    t14 = $[31];
  let t15;
  $[34] !== io ? (t15 = /* @__PURE__ */ jsx(BottomRegionWrapper, { $debug: DEBUG$1, id: "::bottom", io, onIntersection }), $[34] = io, $[35] = t15) : t15 = $[35];
  let t16;
  return $[36] !== ref || $[37] !== t10 || $[38] !== t11 || $[39] !== t13 || $[40] !== t14 || $[41] !== t15 ? (t16 = /* @__PURE__ */ jsxs(RootWrapper, { ref, children: [
    t10,
    t11,
    t13,
    t14,
    t15
  ] }), $[36] = ref, $[37] = t10, $[38] = t11, $[39] = t13, $[40] = t14, $[41] = t15, $[42] = t16) : t16 = $[42], t16;
});
function _temp$1x(region) {
  return region.presence?.length > 0;
}
const ITEM_TRANSITION = {
  transitionProperty: "transform",
  transitionDuration: "200ms",
  transitionTimingFunction: "cubic-bezier(0.85, 0, 0.15, 1)"
}, bottom = (rect) => rect.top + rect.height;
function withSpacerHeight(regionsWithIntersectionDetails) {
  return regionsWithIntersectionDetails.map((withIntersection, idx, _regionsWithIntersectionDetails) => {
    const prevRect = _regionsWithIntersectionDetails[idx - 1]?.region.rect, prevBottom = prevRect ? bottom(prevRect) : 0;
    return {
      ...withIntersection,
      spacerHeight: withIntersection.region.rect.top - prevBottom
    };
  });
}
const orderByTop = (regionsWithIntersectionDetails) => orderBy(regionsWithIntersectionDetails, (withIntersection) => withIntersection.region.rect.top), plus = (a, b) => a + b, sum = (array) => array.reduce(plus, 0);
function group(regionsWithIntersectionDetails) {
  const regionsWithSpacerHeight = withSpacerHeight(orderByTop(regionsWithIntersectionDetails)), grouped = {
    top: [],
    inside: [],
    bottom: [],
    ...groupBy(regionsWithSpacerHeight, (_withSpacerHeight) => _withSpacerHeight.position)
  };
  return {
    top: orderByTop(grouped.top).map((withIntersection, i, grp) => ({
      ...withIntersection,
      indent: grp.slice(i + 1).reduce((w, _withIntersection) => w + _withIntersection.region.rect.width, 0)
    })),
    inside: orderByTop(grouped.inside).map((withIntersection) => ({
      ...withIntersection,
      indent: 0
    })),
    bottom: orderByTop(grouped.bottom).map((withIntersection, i, grp) => ({
      ...withIntersection,
      indent: grp.slice(0, i).reduce((w, _withIntersection) => w + _withIntersection.region.rect.width, 0)
    }))
  };
}
const Spacer = (t0) => {
  const $ = c(6);
  let height, rest;
  $[0] !== t0 ? ({
    height,
    ...rest
  } = t0, $[0] = t0, $[1] = height, $[2] = rest) : (height = $[1], rest = $[2]);
  const t1 = Math.max(0, height), t2 = rest?.style;
  let t3;
  return $[3] !== t1 || $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx("div", { style: {
    height: t1,
    ...t2
  } }), $[3] = t1, $[4] = t2, $[5] = t3) : t3 = $[5], t3;
}, DEFAULT_MARGINS$1 = [0, 0, 0, 0], getOffsetsTo$1 = (source, target) => {
  let el = source, top = -el.scrollTop, left = 0;
  for (; el && el !== target; )
    top += el.offsetTop - el.scrollTop, left += el.offsetLeft, el = el.offsetParent instanceof HTMLElement ? el.offsetParent : null;
  return {
    top,
    left
  };
};
function getRelativeRect(element, parent) {
  return {
    ...getOffsetsTo$1(element, parent),
    width: element.offsetWidth,
    height: element.offsetHeight
  };
}
function regionsWithComputedRects(regions, parent) {
  return regions.map(([id2, region]) => region.element ? {
    ...region,
    id: id2,
    rect: getRelativeRect(region.element, parent)
  } : null).filter(Boolean);
}
function StickyOverlay(props2) {
  const $ = c(10), {
    children,
    margins: t0
  } = props2, margins = t0 === void 0 ? DEFAULT_MARGINS$1 : t0, reportedValues = usePresenceReportedValues(), [element, setElement] = useState(null);
  let t1;
  $[0] !== element || $[1] !== reportedValues ? (t1 = element ? regionsWithComputedRects(reportedValues, element) : EMPTY_ARRAY$i, $[0] = element, $[1] = reportedValues, $[2] = t1) : t1 = $[2];
  const regions = t1;
  let t2;
  $[3] !== margins ? (t2 = (regionsWithIntersectionDetails, containerWidth) => {
    const grouped = group(regionsWithIntersectionDetails.filter(_temp$1w)), topSpacing = sum(grouped.top.map(_temp2$D)), bottomSpacing = sum([...grouped.inside, ...grouped.bottom].map(_temp3$l)), counts = grouped.inside.reduce(_temp4$a, {
      nearTop: 0,
      nearBottom: 0
    });
    return /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(PresenceDock, { closeCount: counts.nearTop, margins, position: "top", regionsWithIntersectionDetails: grouped.top }),
      /* @__PURE__ */ jsx(Spacer, { height: topSpacing }),
      /* @__PURE__ */ jsx(PresenceInside, { containerWidth, regionsWithIntersectionDetails: grouped.inside }),
      /* @__PURE__ */ jsx(Spacer, { height: bottomSpacing }),
      /* @__PURE__ */ jsx(PresenceDock, { closeCount: counts.nearBottom, margins, position: "bottom", regionsWithIntersectionDetails: grouped.bottom })
    ] });
  }, $[3] = margins, $[4] = t2) : t2 = $[4];
  const renderCallback = t2;
  let t3;
  return $[5] !== children || $[6] !== margins || $[7] !== regions || $[8] !== renderCallback ? (t3 = /* @__PURE__ */ jsx(RegionsWithIntersections, { ref: setElement, margins, regions, render: renderCallback, children }), $[5] = children, $[6] = margins, $[7] = regions, $[8] = renderCallback, $[9] = t3) : t3 = $[9], t3;
}
function _temp4$a(_counts, withIntersection) {
  const {
    distanceTop,
    distanceBottom
  } = withIntersection, nearTop = distanceTop <= SLIDE_RIGHT_THRESHOLD_TOP, nearBottom = distanceBottom <= SLIDE_RIGHT_THRESHOLD_BOTTOM;
  return {
    nearTop: _counts.nearTop + (nearTop ? withIntersection.region.presence.length : 0),
    nearBottom: _counts.nearBottom + (nearBottom ? withIntersection.region.presence.length : 0)
  };
}
function _temp3$l(n_0) {
  return n_0.region.rect.height + n_0.spacerHeight;
}
function _temp2$D(n) {
  return n.region.rect.height + n.spacerHeight;
}
function _temp$1w(item) {
  return item.region.presence.length > 0;
}
const EMPTY_ARRAY$i = [], PresenceDock = memo(function(props2) {
  const $ = c(17), {
    closeCount,
    margins,
    position,
    regionsWithIntersectionDetails
  } = props2, dir = position === "top" ? 1 : -1;
  let t0;
  bb0: {
    if (!regionsWithIntersectionDetails.length) {
      t0 = EMPTY_ARRAY$i;
      break bb0;
    }
    let t12;
    if ($[0] !== dir || $[1] !== regionsWithIntersectionDetails) {
      let t22;
      $[3] !== dir ? (t22 = (r) => r.region.rect.top * dir, $[3] = dir, $[4] = t22) : t22 = $[4], t12 = flatten$1(sortBy(regionsWithIntersectionDetails, t22).map(_temp5$7)), $[0] = dir, $[1] = regionsWithIntersectionDetails, $[2] = t12;
    } else
      t12 = $[2];
    t0 = t12;
  }
  const allPresenceItems = t0, [topMargin, rightMargin, bottomMargin, leftMargin] = margins, leftOffset = (leftMargin || 0) + (allPresenceItems.length > 0 ? -closeCount * (AVATAR_SIZE + AVATAR_DISTANCE) : 0) - rightMargin, margin = position === "top" ? topMargin : bottomMargin, t1 = `translate3d(${leftOffset}px, 0px, 0px)`, t2 = AVATAR_ARROW_HEIGHT + 1 + margin, t3 = AVATAR_ARROW_HEIGHT + 1 + margin;
  let t4;
  $[5] !== t1 || $[6] !== t2 || $[7] !== t3 ? (t4 = {
    zIndex: 2,
    position: "sticky",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    ...ITEM_TRANSITION,
    transform: t1,
    top: t2,
    bottom: t3
  }, $[5] = t1, $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8];
  const style = t4, t5 = `sticky-${position}`;
  let t6;
  $[9] !== allPresenceItems || $[10] !== position ? (t6 = /* @__PURE__ */ jsx(FieldPresenceInner, { position, maxAvatars: MAX_AVATARS_DOCK, presence: allPresenceItems }), $[9] = allPresenceItems, $[10] = position, $[11] = t6) : t6 = $[11];
  let t7;
  return $[12] !== position || $[13] !== style || $[14] !== t5 || $[15] !== t6 ? (t7 = /* @__PURE__ */ jsx("div", { "data-dock": position, style, children: t6 }, t5), $[12] = position, $[13] = style, $[14] = t5, $[15] = t6, $[16] = t7) : t7 = $[16], t7;
});
function PresenceInside(props2) {
  const $ = c(7), {
    regionsWithIntersectionDetails,
    containerWidth
  } = props2;
  let t0;
  if ($[0] !== containerWidth || $[1] !== regionsWithIntersectionDetails) {
    let t12;
    $[3] !== containerWidth ? (t12 = (withIntersection) => {
      const originalLeft = withIntersection.region.rect.left, {
        distanceTop,
        distanceBottom
      } = withIntersection, nearTop = distanceTop <= SLIDE_RIGHT_THRESHOLD_TOP, nearBottom = distanceBottom <= SLIDE_RIGHT_THRESHOLD_BOTTOM, diffRight = containerWidth - originalLeft - withIntersection.region.rect.width, {
        presence,
        maxAvatars
      } = withIntersection.region;
      return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("div", { style: {
        zIndex: 2,
        position: "absolute",
        ...ITEM_TRANSITION,
        left: originalLeft,
        transform: `translate3d(${nearTop || nearBottom ? diffRight : 0}px, 0px, 0px)`,
        height: withIntersection.region.rect.height,
        top: withIntersection.region.rect.top
      }, children: /* @__PURE__ */ jsx(DebugValue, { value: () => `\u2912${distanceTop} | ${distanceBottom}\u2913`, children: /* @__PURE__ */ jsx(FieldPresenceInner, { stack: !nearTop && !nearBottom, position: nearTop ? "top" : nearBottom ? "bottom" : "inside", maxAvatars, presence }) }) }) }, withIntersection.region.id);
    }, $[3] = containerWidth, $[4] = t12) : t12 = $[4], t0 = regionsWithIntersectionDetails.map(t12), $[0] = containerWidth, $[1] = regionsWithIntersectionDetails, $[2] = t0;
  } else
    t0 = $[2];
  let t1;
  return $[5] !== t0 ? (t1 = /* @__PURE__ */ jsx(Fragment$1, { children: t0 }), $[5] = t0, $[6] = t1) : t1 = $[6], t1;
}
const PassThrough = (props2) => props2.children, DebugValue = PassThrough;
function _temp5$7(withIntersection) {
  return withIntersection.region.presence || EMPTY_ARRAY$i;
}
const DEFAULT_MARGINS = [0, 0, 0, 0];
function PresenceOverlay(t0) {
  const $ = c(3), {
    children,
    margins
  } = t0, t1 = margins || DEFAULT_MARGINS;
  let t2;
  return $[0] !== children || $[1] !== t1 ? (t2 = /* @__PURE__ */ jsx(PresenceTracker, { children: /* @__PURE__ */ jsx(StickyOverlay, { margins: t1, children }) }), $[0] = children, $[1] = t1, $[2] = t2) : t2 = $[2], t2;
}
const EMPTY_ARRAY$h = [];
function trimChildPath(path, childPath) {
  return PathUtils.startsWith(path, childPath) ? PathUtils.trimLeft(path, childPath) : EMPTY_ARRAY$h;
}
function PresenceScope(props2) {
  const $ = c(7), {
    readOnly,
    path,
    children
  } = props2, contextPresence = useContext(FormFieldPresenceContext);
  let t0;
  $[0] !== contextPresence || $[1] !== path || $[2] !== readOnly ? (t0 = readOnly ? EMPTY_ARRAY$h : (contextPresence || EMPTY_ARRAY$h).filter((presence) => PathUtils.startsWith(path, presence.path)).map((presence_0) => ({
    ...presence_0,
    path: trimChildPath(path, presence_0.path)
  })), $[0] = contextPresence, $[1] = path, $[2] = readOnly, $[3] = t0) : t0 = $[3];
  const childPresence = t0;
  let t1;
  return $[4] !== childPresence || $[5] !== children ? (t1 = /* @__PURE__ */ jsx(FormFieldPresenceContext.Provider, { value: childPresence, children }), $[4] = childPresence, $[5] = children, $[6] = t1) : t1 = $[6], t1;
}
const PRESENCE_MARGINS$1 = [0, 0, 1, 0];
function onDragEnter$1(event) {
  return event.stopPropagation();
}
function onDrop$1(event) {
  return event.stopPropagation();
}
function EditPortal(props2) {
  const $ = c(21), {
    children,
    header,
    onClose,
    type,
    width
  } = props2, [documentScrollElement, setDocumentScrollElement] = useState(null), containerElement = useRef(null);
  let t0;
  $[0] !== children ? (t0 = /* @__PURE__ */ jsx(PresenceOverlay, { margins: PRESENCE_MARGINS$1, children: /* @__PURE__ */ jsx(Box, { ref: containerElement, children }) }), $[0] = children, $[1] = t0) : t0 = $[1];
  const contents = t0;
  if (type === "dialog") {
    const t12 = props2.id || "";
    let t22;
    $[2] !== contents || $[3] !== header || $[4] !== onClose || $[5] !== props2.autofocus || $[6] !== t12 || $[7] !== width ? (t22 = /* @__PURE__ */ jsx(Dialog$1, { __unstable_autoFocus: props2.autofocus, contentRef: setDocumentScrollElement, "data-testid": "edit-portal-dialog", header, id: t12, onClickOutside: onClose, onClose, onDragEnter: onDragEnter$1, onDrop: onDrop$1, width, children: contents }), $[2] = contents, $[3] = header, $[4] = onClose, $[5] = props2.autofocus, $[6] = t12, $[7] = width, $[8] = t22) : t22 = $[8];
    let t3;
    return $[9] !== documentScrollElement || $[10] !== t22 ? (t3 = /* @__PURE__ */ jsx(VirtualizerScrollInstanceProvider, { scrollElement: documentScrollElement, containerElement, children: t22 }), $[9] = documentScrollElement, $[10] = t22, $[11] = t3) : t3 = $[11], t3;
  }
  let t1;
  $[12] !== contents || $[13] !== documentScrollElement ? (t1 = /* @__PURE__ */ jsx(VirtualizerScrollInstanceProvider, { scrollElement: documentScrollElement, containerElement, children: contents }), $[12] = contents, $[13] = documentScrollElement, $[14] = t1) : t1 = $[14];
  let t2;
  return $[15] !== header || $[16] !== onClose || $[17] !== props2.legacy_referenceElement || $[18] !== t1 || $[19] !== width ? (t2 = /* @__PURE__ */ jsx(PopoverDialog, { header, onClose, referenceElement: props2.legacy_referenceElement, width, containerRef: setDocumentScrollElement, children: t1 }), $[15] = header, $[16] = onClose, $[17] = props2.legacy_referenceElement, $[18] = t1, $[19] = width, $[20] = t2) : t2 = $[20], t2;
}
const noop$1 = () => {
};
function useDialogStack(t0) {
  const $ = c(22);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const {
    path
  } = t1, context = useContext(DialogStackContext), id2 = useId(), hasRegistered = useRef(!1), push = context?.push, remove2 = context?.remove, update = context?.update;
  let t2, t3;
  $[2] !== id2 || $[3] !== path || $[4] !== push || $[5] !== remove2 ? (t2 = () => {
    if (!(!push || !remove2))
      return hasRegistered.current = !0, push(id2, path), () => {
        hasRegistered.current = !1, remove2(id2);
      };
  }, t3 = [push, remove2, id2, path], $[2] = id2, $[3] = path, $[4] = push, $[5] = remove2, $[6] = t2, $[7] = t3) : (t2 = $[6], t3 = $[7]), useEffect(t2, t3);
  let t4, t5;
  $[8] !== id2 || $[9] !== path || $[10] !== update ? (t4 = () => {
    update && hasRegistered.current && update(id2, path);
  }, t5 = [update, id2, path], $[8] = id2, $[9] = path, $[10] = update, $[11] = t4, $[12] = t5) : (t4 = $[11], t5 = $[12]), useEffect(t4, t5);
  let t6;
  $[13] !== context?.stack ? (t6 = context?.stack ?? [], $[13] = context?.stack, $[14] = t6) : t6 = $[14];
  const stack = t6, topEntry = stack.length > 0 ? stack[stack.length - 1] : null, isTop = context ? topEntry?.id === id2 : !0, close = context?.close ?? noop$1, navigateTo = context?.navigateTo ?? noop$1;
  let t7;
  return $[15] !== close || $[16] !== id2 || $[17] !== isTop || $[18] !== navigateTo || $[19] !== stack || $[20] !== topEntry ? (t7 = {
    dialogId: id2,
    topEntry,
    stack,
    isTop,
    close,
    navigateTo
  }, $[15] = close, $[16] = id2, $[17] = isTop, $[18] = navigateTo, $[19] = stack, $[20] = topEntry, $[21] = t7) : t7 = $[21], t7;
}
function getSchemaField$1(schemaType, fieldPath) {
  if (!fieldPath) return;
  const paths = fromString(fieldPath), firstPath = paths[0];
  if (firstPath && isObjectSchemaType(schemaType)) {
    const field = schemaType?.fields?.find((f) => f.name === firstPath);
    if (field) {
      const nextPath = toString(paths.slice(1));
      return nextPath ? getSchemaField$1(field.type, nextPath) : field;
    }
  }
}
function resolveSchemaTypeForPath(baseType, path, documentValue) {
  if (!baseType) return;
  let currentField = baseType;
  return path.forEach((segment, index) => {
    const nextPath = path.slice(0, index + 1);
    if (isKeySegment(segment) || isIndexSegment(segment)) {
      const arraySchemaType = currentField, itemValue = getValueAtPath(documentValue, nextPath), item = getItemType(arraySchemaType, itemValue);
      if (item) {
        currentField = item;
        return;
      }
    }
    const nextField = getSchemaField$1(currentField, toString(nextPath.length > 1 ? nextPath.slice(-1) : nextPath));
    nextField?.type && (currentField = nextField.type);
  }), currentField;
}
function getAnnotatedText(blockValue, markDefKey) {
  if (!isPortableTextTextBlock(blockValue)) return;
  const texts = blockValue.children.filter((child) => isPortableTextSpan(child) && child.marks?.includes(markDefKey)).map((child) => isPortableTextSpan(child) ? child.text : "");
  return texts.length > 0 ? texts.join("") : void 0;
}
function getMarkDefContext(itemPath, currentPath) {
  if (!currentPath || itemPath[itemPath.length - 1] !== "markDefs") return;
  const nextSegment = currentPath[itemPath.length];
  if (isKeySegment(nextSegment))
    return {
      blockPath: itemPath.slice(0, -1),
      markDefKey: nextSegment._key
    };
}
function useBreadcrumbPreview(itemPath, documentSchemaType, documentValue, currentPath) {
  const $ = c(16);
  let t0;
  $[0] !== currentPath || $[1] !== itemPath ? (t0 = getMarkDefContext(itemPath, currentPath), $[0] = currentPath, $[1] = itemPath, $[2] = t0) : t0 = $[2];
  const markDefContext = t0, value = useFormValue(markDefContext?.blockPath ?? itemPath);
  let t1;
  $[3] !== documentSchemaType || $[4] !== documentValue || $[5] !== itemPath ? (t1 = resolveSchemaTypeForPath(documentSchemaType, itemPath, documentValue), $[3] = documentSchemaType, $[4] = documentValue, $[5] = itemPath, $[6] = t1) : t1 = $[6];
  const schemaType = t1;
  let t2;
  $[7] !== schemaType || $[8] !== value ? (t2 = {
    schemaType,
    value
  }, $[7] = schemaType, $[8] = value, $[9] = t2) : t2 = $[9];
  const {
    value: preview
  } = useValuePreviewWithFallback(t2);
  if (markDefContext) {
    let t32;
    $[10] !== markDefContext.markDefKey || $[11] !== value ? (t32 = getAnnotatedText(value, markDefContext.markDefKey), $[10] = markDefContext.markDefKey, $[11] = value, $[12] = t32) : t32 = $[12];
    const annotatedText = t32;
    if (annotatedText)
      return annotatedText;
  }
  let t3;
  return $[13] !== preview || $[14] !== schemaType ? (t3 = isArraySchemaType(schemaType) ? schemaType.title : preview.title, $[13] = preview, $[14] = schemaType, $[15] = t3) : t3 = $[15], t3;
}
function isArrayItemSelected(itemPath, path) {
  return JSON.stringify(itemPath) === JSON.stringify(path);
}
function isArrayItemPath(path) {
  return path.length === 0 ? !1 : path[path.length - 1].hasOwnProperty("_key");
}
function hasSpanChildren(block) {
  return !block || typeof block != "object" || !("children" in block) ? !1 : Array.isArray(block.children) && block.children.some((child) => child && child._type === "span");
}
function shouldBeInBreadcrumb(itemPath, path, documentValue) {
  if (!documentValue)
    return itemPath.every((segment, index) => isArrayItemSelected(path[index], segment)) && isArrayItemPath(itemPath);
  let currentValue = documentValue;
  for (const segment of itemPath)
    if (typeof segment == "string" ? currentValue = currentValue?.[segment] : typeof segment == "object" && isKeySegment(segment) && Array.isArray(currentValue) && (currentValue = currentValue.find((child) => child?._key === segment._key)), !currentValue) break;
  return currentValue && typeof currentValue == "object" && "_type" in currentValue && hasSpanChildren(currentValue) ? !1 : itemPath.every((segment, index) => isArrayItemSelected(path[index], segment));
}
function shouldSkipSiblingCount(args) {
  const {
    arraySchemaType,
    fieldPath
  } = args, lastFieldSegment = fieldPath[fieldPath.length - 1];
  return isArrayOfBlocksSchemaType(arraySchemaType) && lastFieldSegment === "children";
}
function useBreadcrumbSiblingInfo(itemPath, documentSchemaType, documentValue) {
  const $ = c(9), hasKeySegment = isKeySegment(itemPath[itemPath.length - 1]), lastKeySegmentIndex = itemPath.findLastIndex(isKeySegment);
  let t0;
  bb0: {
    if (lastKeySegmentIndex < 0) {
      let t13;
      $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = [], $[0] = t13) : t13 = $[0], t0 = t13;
      break bb0;
    }
    let t12;
    $[1] !== itemPath || $[2] !== lastKeySegmentIndex ? (t12 = itemPath.slice(0, lastKeySegmentIndex), $[1] = itemPath, $[2] = lastKeySegmentIndex, $[3] = t12) : t12 = $[3], t0 = t12;
  }
  const parentArrayPath = t0, parentArrayValue = useFormValue(parentArrayPath), parentArraySchemaType = resolveSchemaTypeForPath(documentSchemaType, parentArrayPath, documentValue);
  let t1;
  bb1: {
    if (parentArrayPath.length < 3) {
      t1 = !1;
      break bb1;
    }
    const pteArrayPath = parentArrayPath.slice(0, -2), pteSchemaType = resolveSchemaTypeForPath(documentSchemaType, pteArrayPath, documentValue);
    t1 = shouldSkipSiblingCount({
      arraySchemaType: pteSchemaType,
      fieldPath: parentArrayPath
    });
  }
  const isInsidePTEChildren = t1, itemSchemaType = resolveSchemaTypeForPath(documentSchemaType, itemPath, documentValue);
  let t2;
  bb2: {
    if (!hasKeySegment) {
      t2 = null;
      break bb2;
    }
    if (lastKeySegmentIndex < 0) {
      t2 = null;
      break bb2;
    }
    const isObjectType2 = isObjectSchemaType(itemSchemaType), isParentPTE = parentArraySchemaType && isArrayOfBlocksSchemaType(parentArraySchemaType);
    if (isObjectType2 && isParentPTE) {
      t2 = null;
      break bb2;
    }
    if (isObjectType2 && isInsidePTEChildren) {
      t2 = null;
      break bb2;
    }
    const keySegment = itemPath[lastKeySegmentIndex];
    if (!isKeySegment(keySegment)) {
      t2 = null;
      break bb2;
    }
    const arrayValue = parentArrayValue;
    if (!Array.isArray(arrayValue)) {
      t2 = null;
      break bb2;
    }
    let t3;
    $[4] !== keySegment ? (t3 = (item) => item._key === keySegment._key, $[4] = keySegment, $[5] = t3) : t3 = $[5];
    const index = arrayValue.findIndex(t3);
    if (index < 0) {
      t2 = null;
      break bb2;
    }
    const t4 = index + 1;
    let t5;
    $[6] !== arrayValue.length || $[7] !== t4 ? (t5 = {
      index: t4,
      count: arrayValue.length
    }, $[6] = arrayValue.length, $[7] = t4, $[8] = t5) : t5 = $[8], t2 = t5;
  }
  return t2;
}
const MAX_LENGTH = 5, SEPARATOR = "/", rootInlineStyle = {
  flexWrap: "nowrap",
  overflow: "hidden",
  minWidth: 0,
  width: "100%"
}, overflowButtonStyle = {
  maxHeight: "1rem",
  overflow: "hidden",
  minWidth: "2ch"
}, overflowTextStyle = {
  overflow: "hidden",
  padding: "8px 0"
}, SeparatorItem = forwardRef(function(props2, ref) {
  const $ = c(5), {
    children
  } = props2;
  let t0;
  $[0] !== children ? (t0 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children }), $[0] = children, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== ref || $[3] !== t0 ? (t1 = /* @__PURE__ */ jsx(Box, { ref, children: t0 }), $[2] = ref, $[3] = t0, $[4] = t1) : t1 = $[4], t1;
});
function BreadcrumbButton(t0) {
  const $ = c(25), {
    itemPath,
    documentSchemaType,
    documentValue,
    currentPath,
    isSelected: t1,
    onPathSelect
  } = t0, isSelected = t1 === void 0 ? !1 : t1, title = useBreadcrumbPreview(itemPath, documentSchemaType, documentValue, currentPath), siblingInfo = useBreadcrumbSiblingInfo(itemPath, documentSchemaType, documentValue), telemetry = useTelemetry();
  let t2;
  $[0] !== itemPath || $[1] !== onPathSelect || $[2] !== telemetry ? (t2 = () => {
    onPathSelect(itemPath), telemetry.log(NavigatedToNestedObjectViaBreadcrumb, {
      path: pathToString$1(itemPath)
    });
  }, $[0] = itemPath, $[1] = onPathSelect, $[2] = telemetry, $[3] = t2) : t2 = $[3];
  const handleClick = t2;
  let t3;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    minWidth: 0,
    maxWidth: "250px"
  }, $[4] = t3) : t3 = $[4];
  const t4 = isSelected ? "location" : !1;
  let t5;
  $[5] !== title ? (t5 = title?.toLowerCase().replace(/ /g, "-"), $[5] = title, $[6] = t5) : t5 = $[6];
  const t6 = `breadcrumb-item-${t5}`;
  let t7;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    minWidth: 0
  }, $[7] = t7) : t7 = $[7];
  let t8;
  $[8] !== siblingInfo ? (t8 = siblingInfo && /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsxs(Badge, { children: [
    "#",
    siblingInfo.index
  ] }) }), $[8] = siblingInfo, $[9] = t8) : t8 = $[9];
  let t9;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = {
    minWidth: 0,
    overflow: "hidden"
  }, $[10] = t9) : t9 = $[10];
  const t10 = !isSelected, t11 = isSelected ? "bold" : "medium";
  let t12;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = {
    whiteSpace: "nowrap",
    textTransform: "capitalize"
  }, $[11] = t12) : t12 = $[11];
  let t13;
  $[12] !== t10 || $[13] !== t11 || $[14] !== title ? (t13 = /* @__PURE__ */ jsx(Box, { padding: 1, style: t9, children: /* @__PURE__ */ jsx(Text$1, { muted: t10, size: 1, weight: t11, textOverflow: "ellipsis", style: t12, children: title }) }), $[12] = t10, $[13] = t11, $[14] = title, $[15] = t13) : t13 = $[15];
  let t14;
  $[16] !== t13 || $[17] !== t8 ? (t14 = /* @__PURE__ */ jsxs(Flex, { align: "center", style: t7, children: [
    t8,
    t13
  ] }), $[16] = t13, $[17] = t8, $[18] = t14) : t14 = $[18];
  let t15;
  return $[19] !== handleClick || $[20] !== t14 || $[21] !== t4 || $[22] !== t6 || $[23] !== title ? (t15 = /* @__PURE__ */ jsx(Button$1, { mode: "bleed", padding: 1, radius: 2, onClick: handleClick, style: t3, title, "aria-label": title, "aria-current": t4, "data-testid": t6, children: t14 }), $[19] = handleClick, $[20] = t14, $[21] = t4, $[22] = t6, $[23] = title, $[24] = t15) : t15 = $[24], t15;
}
function BreadcrumbMenuItem(t0) {
  const $ = c(19), {
    itemPath,
    documentSchemaType,
    documentValue,
    currentPath,
    onPathSelect
  } = t0, title = useBreadcrumbPreview(itemPath, documentSchemaType, documentValue, currentPath), siblingInfo = useBreadcrumbSiblingInfo(itemPath, documentSchemaType, documentValue);
  let t1;
  $[0] !== itemPath || $[1] !== onPathSelect ? (t1 = () => {
    onPathSelect(itemPath);
  }, $[0] = itemPath, $[1] = onPathSelect, $[2] = t1) : t1 = $[2];
  const handleClick = t1;
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    minWidth: 0,
    maxWidth: "250px"
  }, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== siblingInfo ? (t3 = siblingInfo && /* @__PURE__ */ jsxs(Badge, { size: 1, children: [
    "#",
    siblingInfo.index
  ] }), $[4] = siblingInfo, $[5] = t3) : t3 = $[5];
  const t4 = siblingInfo?.index ? 1 : 0;
  let t5;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    minWidth: 0,
    overflow: "hidden"
  }, $[6] = t5) : t5 = $[6];
  let t6;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    whiteSpace: "nowrap",
    textTransform: "capitalize"
  }, $[7] = t6) : t6 = $[7];
  let t7;
  $[8] !== title ? (t7 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", style: t6, title, children: title }), $[8] = title, $[9] = t7) : t7 = $[9];
  let t8;
  $[10] !== t4 || $[11] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { paddingLeft: t4, paddingY: 1, style: t5, children: t7 }), $[10] = t4, $[11] = t7, $[12] = t8) : t8 = $[12];
  let t9;
  $[13] !== t3 || $[14] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { align: "center", style: t2, children: [
    t3,
    t8
  ] }), $[13] = t3, $[14] = t8, $[15] = t9) : t9 = $[15];
  let t10;
  return $[16] !== handleClick || $[17] !== t9 ? (t10 = /* @__PURE__ */ jsx(MenuItem$1, { padding: 1, onClick: handleClick, children: t9 }), $[16] = handleClick, $[17] = t9, $[18] = t10) : t10 = $[18], t10;
}
function DialogBreadcrumbs(t0) {
  const $ = c(31), {
    currentPath,
    onNavigate,
    onClose
  } = t0, {
    onPathOpen
  } = useFormCallbacks(), {
    schemaType: documentSchemaType
  } = useFormBuilder();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[0] = t1) : t1 = $[0];
  const documentValue = useFormValue(t1), [rootElement, setRootElement] = useState(null), size = useElementSize(rootElement), navigate = onNavigate ?? onPathOpen;
  let t2;
  $[1] !== currentPath || $[2] !== documentSchemaType || $[3] !== documentValue || $[4] !== navigate || $[5] !== onClose ? (t2 = (path) => {
    if (isKeySegment(path[path.length - 1])) {
      if (currentPath && currentPath.length > path.length && path.every((segment, index) => {
        const currentSegment = currentPath[index];
        return isKeySegment(segment) && isKeySegment(currentSegment) ? segment._key === currentSegment._key : segment === currentSegment;
      })) {
        const nextSegment = currentPath[path.length];
        if (!isKeySegment(nextSegment)) {
          const itemSchemaType = resolveSchemaTypeForPath(documentSchemaType, path, documentValue);
          if (isObjectSchemaType(itemSchemaType) && itemSchemaType.fields.some((field) => field.name === nextSegment)) {
            navigate([...path, nextSegment]);
            return;
          }
        }
      }
      navigate(path);
    } else
      path.length === 1 ? onClose?.(!0) : navigate(path);
  }, $[1] = currentPath, $[2] = documentSchemaType, $[3] = documentValue, $[4] = navigate, $[5] = onClose, $[6] = t2) : t2 = $[6];
  const handlePathSelect = t2;
  let t3;
  bb0: {
    const w = size?.border.width;
    if (!w) {
      t3 = MAX_LENGTH;
      break bb0;
    }
    if (w < 500) {
      t3 = 5;
      break bb0;
    }
    if (w < 700) {
      t3 = 6;
      break bb0;
    }
    t3 = MAX_LENGTH;
  }
  const maxLength = t3;
  let t4;
  bb1: {
    if (!currentPath || currentPath.length === 0) {
      let t52;
      $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t52 = [], $[7] = t52) : t52 = $[7], t4 = t52;
      break bb1;
    }
    let result;
    $[8] !== currentPath || $[9] !== documentValue ? (result = [], currentPath.forEach((segment_0, index_0) => {
      const itemPath = currentPath.slice(0, index_0 + 1);
      shouldBeInBreadcrumb(itemPath, currentPath, documentValue) && result.push({
        path: itemPath
      });
    }), $[8] = currentPath, $[9] = documentValue, $[10] = result) : result = $[10], t4 = result;
  }
  const rawItems = t4;
  let t5;
  bb2: {
    const len = rawItems.length + 1, availableSlots = maxLength - 1, beforeLength = Math.ceil(availableSlots / 2), afterLength = Math.floor(availableSlots / 2);
    if (maxLength && len > maxLength) {
      let t62;
      $[11] !== beforeLength || $[12] !== rawItems ? (t62 = rawItems.slice(0, beforeLength - 1), $[11] = beforeLength, $[12] = rawItems, $[13] = t62) : t62 = $[13];
      let t7;
      $[14] !== afterLength || $[15] !== beforeLength || $[16] !== rawItems ? (t7 = rawItems.slice(beforeLength - 1, rawItems.length - afterLength), $[14] = afterLength, $[15] = beforeLength, $[16] = rawItems, $[17] = t7) : t7 = $[17];
      let t8;
      $[18] !== afterLength || $[19] !== rawItems ? (t8 = rawItems.slice(rawItems.length - afterLength), $[18] = afterLength, $[19] = rawItems, $[20] = t8) : t8 = $[20];
      let t9;
      $[21] !== t62 || $[22] !== t7 || $[23] !== t8 ? (t9 = [...t62, t7, ...t8], $[21] = t62, $[22] = t7, $[23] = t8, $[24] = t9) : t9 = $[24], t5 = t9;
      break bb2;
    }
    t5 = rawItems;
  }
  const items = t5;
  if (!currentPath || currentPath.length === 0)
    return null;
  let t6;
  if ($[25] !== currentPath || $[26] !== documentSchemaType || $[27] !== documentValue || $[28] !== handlePathSelect || $[29] !== items) {
    const nodes = items.map((item, index_1) => {
      const key = `breadcrumb-${index_1}`, showSeparator = index_1 < items.length - 1;
      if (Array.isArray(item))
        return /* @__PURE__ */ jsxs(Inline, { children: [
          /* @__PURE__ */ jsx(MenuButton, { id: "breadcrumb-overflow-menu-button", button: /* @__PURE__ */ jsx(Button$1, { mode: "bleed", padding: 1, style: overflowButtonStyle, children: /* @__PURE__ */ jsx(Flex, { overflow: "hidden", children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", textOverflow: "ellipsis", style: overflowTextStyle, "aria-label": "More breadcrumb items", children: "..." }) }) }), popover: {
            placement: "bottom-start",
            portal: !0
          }, menu: /* @__PURE__ */ jsx(Menu, { children: item.map((overflowItem) => /* @__PURE__ */ jsx(BreadcrumbMenuItem, { itemPath: overflowItem.path, documentSchemaType, documentValue, currentPath, onPathSelect: handlePathSelect }, overflowItem.path.toString())) }) }),
          showSeparator && /* @__PURE__ */ jsx(SeparatorItem, { children: SEPARATOR })
        ] }, key);
      const isSelected = currentPath.length === item.path.length && item.path.every((seg, i) => {
        const currentSeg = currentPath[i];
        return isKeySegment(seg) && isKeySegment(currentSeg) ? seg._key === currentSeg._key : seg === currentSeg;
      }), isLast = index_1 === items.length - 1;
      return /* @__PURE__ */ jsxs(Inline, { flex: isLast ? 1 : void 0, style: {
        minWidth: 0
      }, children: [
        /* @__PURE__ */ jsx(BreadcrumbButton, { itemPath: item.path, documentSchemaType, documentValue, currentPath, isSelected, onPathSelect: handlePathSelect }),
        showSeparator && /* @__PURE__ */ jsx(SeparatorItem, { children: SEPARATOR })
      ] }, key);
    });
    t6 = /* @__PURE__ */ jsx(Inline, { ref: setRootElement, style: rootInlineStyle, children: nodes }), $[25] = currentPath, $[26] = documentSchemaType, $[27] = documentValue, $[28] = handlePathSelect, $[29] = items, $[30] = t6;
  } else
    t6 = $[30];
  return t6;
}
const StyledDialog$2 = styled(Dialog$1).withConfig({
  displayName: "StyledDialog",
  componentId: "sc-1thco4c-0"
})`${(props2) => props2.$isHidden && `
    /* Hide the backdrop (the semi-transparent overlay) */
    background: transparent !important;

    /* Hide the dialog card */
    [data-ui='DialogCard'] {
      opacity: 0 !important;
      pointer-events: none !important;
      transform: scale(0.95) !important;
    }
  `}`, PRESENCE_MARGINS = [0, 0, 1, 0];
function onDragEnter(event) {
  return event.stopPropagation();
}
function onDrop(event) {
  return event.stopPropagation();
}
function EnhancedObjectDialog(props2) {
  const $ = c(55), {
    children,
    header,
    type,
    width
  } = props2, [documentScrollElement, setDocumentScrollElement] = useState(null), containerElement = useRef(null), telemetry = useTelemetry(), {
    __internal
  } = useFormBuilder(), isInspectOpen = !!__internal.inspectOpen, {
    absolutePath,
    path
  } = children?.props, currentPath = absolutePath || path;
  let t0;
  $[0] !== currentPath ? (t0 = {
    path: currentPath
  }, $[0] = currentPath, $[1] = t0) : t0 = $[1];
  const {
    dialogId,
    isTop,
    stack,
    close,
    navigateTo
  } = useDialogStack(t0);
  let t1;
  $[2] !== stack.length || $[3] !== telemetry ? (t1 = () => {
    stack.length === 0 && telemetry.log(NestedDialogOpened, {
      path: pathToString$1([])
    });
  }, $[2] = stack.length, $[3] = telemetry, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== stack || $[6] !== telemetry ? (t2 = [stack, telemetry], $[5] = stack, $[6] = telemetry, $[7] = t2) : t2 = $[7], useEffect(t1, t2);
  let t3;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    minHeight: "min(calc(100vh - 200px), 500px)"
  }, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== children ? (t4 = /* @__PURE__ */ jsx(PresenceOverlay, { margins: PRESENCE_MARGINS, children: /* @__PURE__ */ jsx(Box, { ref: containerElement, style: t3, children }) }), $[9] = children, $[10] = t4) : t4 = $[10];
  const contents = t4, [hasEverBeenNested, setHasEverBeenNested] = useState(!1);
  let t5, t6;
  $[11] !== hasEverBeenNested || $[12] !== stack.length ? (t5 = () => {
    stack.length > 1 && !hasEverBeenNested && setHasEverBeenNested(!0);
  }, t6 = [stack.length, hasEverBeenNested], $[11] = hasEverBeenNested, $[12] = stack.length, $[13] = t5, $[14] = t6) : (t5 = $[13], t6 = $[14]), useEffect(t5, t6);
  const shouldDisableAnimation = stack.length > 1 || hasEverBeenNested;
  let t7;
  $[15] !== close || $[16] !== isTop || $[17] !== navigateTo || $[18] !== stack || $[19] !== telemetry ? (t7 = (event) => {
    if (isTop && (event.metaKey || event.ctrlKey) && event.key === "ArrowUp") {
      event.preventDefault();
      const lastStackPath = stack[stack.length - 1]?.path;
      if (lastStackPath && lastStackPath.length > 1) {
        const newLastStackPath = lastStackPath.slice(0, -1);
        newLastStackPath.length > 1 ? (telemetry.log(navigatedToNestedObjectViaKeyboardShortcut), navigateTo(newLastStackPath)) : (telemetry.log(NestedDialogClosed), close());
      }
    }
  }, $[15] = close, $[16] = isTop, $[17] = navigateTo, $[18] = stack, $[19] = telemetry, $[20] = t7) : t7 = $[20];
  const handleGlobalKeyDown = t7;
  let t8;
  $[21] !== close || $[22] !== stack.length || $[23] !== telemetry ? (t8 = (closeAll) => {
    !closeAll && stack.length >= 2 ? (telemetry.log(NavigatedToNestedObjectViaCloseButton), close({
      toParent: !0
    })) : (telemetry.log(NestedDialogClosed), close());
  }, $[21] = close, $[22] = stack.length, $[23] = telemetry, $[24] = t8) : t8 = $[24];
  const handleStackedDialogClose = t8;
  let t9;
  $[25] !== close || $[26] !== isInspectOpen || $[27] !== telemetry ? (t9 = () => {
    isInspectOpen || (telemetry.log(NestedDialogClosed), close());
  }, $[25] = close, $[26] = isInspectOpen, $[27] = telemetry, $[28] = t9) : t9 = $[28];
  const handleCompleteDialogClose = t9;
  if (useGlobalKeyDown(handleGlobalKeyDown), type === "dialog") {
    const t102 = !isTop, t112 = isTop ? props2.autofocus : !1;
    let t12;
    $[29] !== currentPath || $[30] !== handleStackedDialogClose || $[31] !== navigateTo ? (t12 = /* @__PURE__ */ jsx(DialogBreadcrumbs, { currentPath, onNavigate: navigateTo, onClose: handleStackedDialogClose }), $[29] = currentPath, $[30] = handleStackedDialogClose, $[31] = navigateTo, $[32] = t12) : t12 = $[32];
    const t13 = !shouldDisableAnimation;
    let t14;
    $[33] !== contents || $[34] !== dialogId || $[35] !== handleCompleteDialogClose || $[36] !== handleStackedDialogClose || $[37] !== t102 || $[38] !== t112 || $[39] !== t12 || $[40] !== t13 || $[41] !== width ? (t14 = /* @__PURE__ */ jsx(StyledDialog$2, { $isHidden: t102, __unstable_autoFocus: t112, contentRef: setDocumentScrollElement, "data-testid": "nested-object-dialog", header: t12, id: dialogId, onClose: handleStackedDialogClose, onDragEnter, onDrop, width, animate: t13, onClickOutside: handleCompleteDialogClose, children: contents }), $[33] = contents, $[34] = dialogId, $[35] = handleCompleteDialogClose, $[36] = handleStackedDialogClose, $[37] = t102, $[38] = t112, $[39] = t12, $[40] = t13, $[41] = width, $[42] = t14) : t14 = $[42];
    let t15;
    return $[43] !== documentScrollElement || $[44] !== t14 ? (t15 = /* @__PURE__ */ jsx(VirtualizerScrollInstanceProvider, { scrollElement: documentScrollElement, containerElement, children: t14 }), $[43] = documentScrollElement, $[44] = t14, $[45] = t15) : t15 = $[45], t15;
  }
  let t10;
  $[46] !== contents || $[47] !== handleStackedDialogClose || $[48] !== header || $[49] !== props2.legacy_referenceElement || $[50] !== width ? (t10 = /* @__PURE__ */ jsx(PopoverDialog, { header, onClose: handleStackedDialogClose, width, containerRef: setDocumentScrollElement, referenceElement: props2.legacy_referenceElement, children: contents }), $[46] = contents, $[47] = handleStackedDialogClose, $[48] = header, $[49] = props2.legacy_referenceElement, $[50] = width, $[51] = t10) : t10 = $[51];
  let t11;
  return $[52] !== documentScrollElement || $[53] !== t10 ? (t11 = /* @__PURE__ */ jsx(VirtualizerScrollInstanceProvider, { scrollElement: documentScrollElement, containerElement, children: t10 }), $[52] = documentScrollElement, $[53] = t10, $[54] = t11) : t11 = $[54], t11;
}
function isObjectInputProps(inputProps) {
  return isObjectSchemaType(inputProps.schemaType);
}
function isArrayInputProps(inputProps) {
  return isArraySchemaType(inputProps.schemaType);
}
const pass = ({
  children
}) => children;
function hasAbsolutePath(a) {
  return "absolutePath" in a;
}
const FormInput = memo(function(props2) {
  const $ = c(8);
  let t0;
  $[0] !== props2 ? (t0 = hasAbsolutePath(props2) ? props2.absolutePath : props2.path.concat(props2.relativePath), $[0] = props2, $[1] = t0) : t0 = $[1];
  const absolutePath = t0, t1 = props2.renderAnnotation || NullRender, t2 = props2.renderBlock || NullRender, t3 = props2.renderInlineBlock || NullRender;
  let t4;
  return $[2] !== absolutePath || $[3] !== props2 || $[4] !== t1 || $[5] !== t2 || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(FormInputInner, { ...props2, absolutePath, destinationRenderAnnotation: t1, destinationRenderBlock: t2, destinationRenderField: props2.renderField, destinationRenderInlineBlock: t3, destinationRenderInput: props2.renderInput, destinationRenderItem: props2.renderItem, destinationRenderPreview: props2.renderPreview }), $[2] = absolutePath, $[3] = props2, $[4] = t1, $[5] = t2, $[6] = t3, $[7] = t4) : t4 = $[7], t4;
});
function FormInputInner(props2) {
  const $ = c(73), {
    absolutePath,
    destinationRenderAnnotation,
    destinationRenderBlock,
    destinationRenderField,
    destinationRenderInlineBlock,
    destinationRenderInput,
    destinationRenderItem,
    destinationRenderPreview
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== absolutePath || $[1] !== destinationRenderField || $[2] !== props2.includeField ? (t0 = (fieldProps) => (isEqual$2(absolutePath, fieldProps.path) ? props2.includeField : startsWith(absolutePath, fieldProps.path)) ? destinationRenderField(fieldProps) : pass(fieldProps), $[0] = absolutePath, $[1] = destinationRenderField, $[2] = props2.includeField, $[3] = t0) : t0 = $[3];
  const renderField = t0;
  let t1;
  $[4] !== absolutePath || $[5] !== destinationRenderItem || $[6] !== props2.includeItem ? (t1 = (itemProps) => (isEqual$2(absolutePath, itemProps.path) ? props2.includeItem : startsWith(absolutePath, itemProps.path)) ? destinationRenderItem(itemProps) : pass(itemProps), $[4] = absolutePath, $[5] = destinationRenderItem, $[6] = props2.includeItem, $[7] = t1) : t1 = $[7];
  const renderItem2 = t1;
  let t2;
  $[8] !== absolutePath || $[9] !== destinationRenderAnnotation || $[10] !== destinationRenderBlock || $[11] !== destinationRenderField || $[12] !== destinationRenderInlineBlock || $[13] !== destinationRenderInput || $[14] !== destinationRenderItem || $[15] !== destinationRenderPreview || $[16] !== props2.includeField || $[17] !== props2.includeItem ? (t2 = (inputProps) => {
    if (isEqual$2(inputProps.path, absolutePath) || startsWith(absolutePath, inputProps.path))
      return destinationRenderInput(inputProps);
    if (!isObjectInputProps(inputProps) && !isArrayInputProps(inputProps))
      throw new Error(`Expected either object input props or array input props for: ${JSON.stringify(inputProps.path)}`);
    return /* @__PURE__ */ jsx(FormInputInner, { ...inputProps, includeField: props2.includeField, includeItem: props2.includeItem, absolutePath, destinationRenderAnnotation, destinationRenderBlock, destinationRenderInput, destinationRenderItem, destinationRenderField, destinationRenderInlineBlock, destinationRenderPreview });
  }, $[8] = absolutePath, $[9] = destinationRenderAnnotation, $[10] = destinationRenderBlock, $[11] = destinationRenderField, $[12] = destinationRenderInlineBlock, $[13] = destinationRenderInput, $[14] = destinationRenderItem, $[15] = destinationRenderPreview, $[16] = props2.includeField, $[17] = props2.includeItem, $[18] = t2) : t2 = $[18];
  const renderInput = t2;
  let t3;
  $[19] !== absolutePath || $[20] !== destinationRenderBlock || $[21] !== props2.includeItem ? (t3 = (blockProps) => startsWith(absolutePath, blockProps.path) && (props2.includeItem || !isEqual$2(absolutePath, blockProps.path)) ? destinationRenderBlock(blockProps) : pass(blockProps), $[19] = absolutePath, $[20] = destinationRenderBlock, $[21] = props2.includeItem, $[22] = t3) : t3 = $[22];
  const renderBlock2 = t3;
  let t4;
  $[23] !== absolutePath || $[24] !== destinationRenderInlineBlock || $[25] !== props2.includeItem ? (t4 = (blockProps_0) => startsWith(absolutePath, blockProps_0.path) && (props2.includeItem || !isEqual$2(absolutePath, blockProps_0.path)) ? destinationRenderInlineBlock(blockProps_0) : pass(blockProps_0), $[23] = absolutePath, $[24] = destinationRenderInlineBlock, $[25] = props2.includeItem, $[26] = t4) : t4 = $[26];
  const renderInlineBlock = t4;
  let t5;
  $[27] !== absolutePath || $[28] !== destinationRenderAnnotation || $[29] !== props2.includeItem ? (t5 = (annotationProps) => startsWith(absolutePath, annotationProps.path) && (props2.includeItem || !isEqual$2(absolutePath, annotationProps.path)) ? destinationRenderAnnotation(annotationProps) : pass(annotationProps), $[27] = absolutePath, $[28] = destinationRenderAnnotation, $[29] = props2.includeItem, $[30] = t5) : t5 = $[30];
  const renderAnnotation = t5;
  if (isArrayInputProps(props2)) {
    let t6;
    if ($[31] !== absolutePath || $[32] !== props2.members || $[33] !== props2.path) {
      const childPath = trimLeft(props2.path, absolutePath);
      t6 = props2.members.find((member) => member.kind == "item" && isKeySegment(childPath[0]) && member.key === childPath[0]._key), $[31] = absolutePath, $[32] = props2.members, $[33] = props2.path, $[34] = t6;
    } else
      t6 = $[34];
    const itemMember = t6;
    if (!itemMember) {
      let path, t72, t8;
      if ($[35] !== absolutePath || $[36] !== props2.path || $[37] !== t) {
        t8 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
        bb0: {
          path = pathToString$1(props2.path);
          const relativePath = trimLeft(props2.path, absolutePath);
          if (isKeySegment(relativePath[0])) {
            const key = relativePath[0]._key;
            t8 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "form.error.no-array-item-at-key", values: {
              key,
              path
            } }) });
            break bb0;
          }
          t72 = isIndexSegment(relativePath[0]) ? relativePath[0] : relativePath[0][0];
        }
        $[35] = absolutePath, $[36] = props2.path, $[37] = t, $[38] = path, $[39] = t72, $[40] = t8;
      } else
        path = $[38], t72 = $[39], t8 = $[40];
      if (t8 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
        return t8;
      const index = t72;
      let t9;
      $[41] !== index || $[42] !== path ? (t9 = {
        index,
        path
      }, $[41] = index, $[42] = path, $[43] = t9) : t9 = $[43];
      let t10;
      return $[44] !== t || $[45] !== t9 ? (t10 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "form.error.no-array-item-at-index", values: t9 }) }), $[44] = t, $[45] = t9, $[46] = t10) : t10 = $[46], t10;
    }
    if (itemMember.kind === "error") {
      let t72;
      return $[47] !== itemMember ? (t72 = /* @__PURE__ */ jsx(MemberItemError, { member: itemMember }), $[47] = itemMember, $[48] = t72) : t72 = $[48], t72;
    }
    let t7;
    return $[49] !== destinationRenderPreview || $[50] !== itemMember || $[51] !== renderAnnotation || $[52] !== renderBlock2 || $[53] !== renderField || $[54] !== renderInlineBlock || $[55] !== renderInput || $[56] !== renderItem2 ? (t7 = /* @__PURE__ */ jsx(ArrayOfObjectsItem, { member: itemMember, renderAnnotation, renderBlock: renderBlock2, renderInput, renderField, renderInlineBlock, renderItem: renderItem2, renderPreview: destinationRenderPreview }), $[49] = destinationRenderPreview, $[50] = itemMember, $[51] = renderAnnotation, $[52] = renderBlock2, $[53] = renderField, $[54] = renderInlineBlock, $[55] = renderInput, $[56] = renderItem2, $[57] = t7) : t7 = $[57], t7;
  }
  if (isObjectInputProps(props2)) {
    let member_3, t6;
    if ($[58] !== absolutePath || $[59] !== props2.members || $[60] !== props2.path || $[61] !== t) {
      t6 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
      bb1: {
        const childPath_0 = trimLeft(props2.path, absolutePath), fieldMember = props2.members.find((member_0) => member_0.kind == "field" && childPath_0[0] === member_0.name), fieldSetMember = props2.members.filter(_temp$1v).flatMap(_temp2$C).find((m) => m.kind === "field" && m.name === childPath_0[0]);
        if (member_3 = fieldMember || fieldSetMember, !member_3) {
          const fieldName = typeof childPath_0[0] == "string" ? childPath_0[0] : JSON.stringify(childPath_0[0]);
          t6 = /* @__PURE__ */ jsx("div", { children: t("form.error.field-not-found", {
            fieldName
          }) });
          break bb1;
        }
      }
      $[58] = absolutePath, $[59] = props2.members, $[60] = props2.path, $[61] = t, $[62] = member_3, $[63] = t6;
    } else
      member_3 = $[62], t6 = $[63];
    if (t6 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
      return t6;
    let t7;
    return $[64] !== destinationRenderPreview || $[65] !== member_3 || $[66] !== renderAnnotation || $[67] !== renderBlock2 || $[68] !== renderField || $[69] !== renderInlineBlock || $[70] !== renderInput || $[71] !== renderItem2 ? (t7 = /* @__PURE__ */ jsx(MemberField, { member: member_3, renderAnnotation, renderBlock: renderBlock2, renderInput, renderInlineBlock, renderField, renderItem: renderItem2, renderPreview: destinationRenderPreview }), $[64] = destinationRenderPreview, $[65] = member_3, $[66] = renderAnnotation, $[67] = renderBlock2, $[68] = renderField, $[69] = renderInlineBlock, $[70] = renderInput, $[71] = renderItem2, $[72] = t7) : t7 = $[72], t7;
  }
  throw new Error("FormInput can only be used with arrays or objects");
}
function _temp2$C(member_2) {
  return member_2.kind === "fieldSet" && member_2.fieldSet?.members || [];
}
function _temp$1v(member_1) {
  return member_1.kind === "fieldSet";
}
function NullRender() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Fragment$1, { children: "Missing destination render function" }), $[0] = t0) : t0 = $[0], t0;
}
const FormContainer = /* @__PURE__ */ styled.div.withConfig({
  displayName: "FormContainer",
  componentId: "sc-yal29m-0"
})((props2) => {
  const {
    space,
    container
  } = getTheme_v2(props2.theme);
  return css`
    box-sizing: border-box;
    margin-inline: auto;
    padding-inline: ${space[4]}px;
    padding-block-start: ${space[5]}px;
    padding-block-end: ${space[9]}px;
    max-width: calc(${container[1]}px + (var(--formGutterSize, 0px) * 2) + (var(--formGutterGap, 0px) * 2));
  `;
});
function TelephoneInput(props2) {
  const $ = c(5), {
    schemaType,
    validationError,
    value,
    elementProps
  } = props2, t0 = value || "";
  let t1;
  return $[0] !== elementProps || $[1] !== schemaType.placeholder || $[2] !== t0 || $[3] !== validationError ? (t1 = /* @__PURE__ */ jsx(TextInput$1, { type: "tel", inputMode: "tel", customValidity: validationError, value: t0, placeholder: schemaType.placeholder, ...elementProps }), $[0] = elementProps, $[1] = schemaType.placeholder, $[2] = t0, $[3] = validationError, $[4] = t1) : t1 = $[4], t1;
}
function setAtPath(currentTree, path, value) {
  if (path.length === 0)
    return {
      ...currentTree,
      value
    };
  const [head, ...tail] = path, key = isKeySegment(head) ? head._key : String(head), children = currentTree?.children ?? {};
  return {
    value: currentTree?.value,
    children: {
      ...children,
      [key]: setAtPath(children[key] || {}, tail, value)
    }
  };
}
function resolveCallbackState({
  value,
  parent,
  document: document2,
  currentUser,
  schemaType,
  level,
  property,
  path
}) {
  const context = {
    value,
    parent,
    document: document2,
    currentUser,
    path
  }, selfValue = resolveConditionalProperty(schemaType[property], context);
  if (selfValue || level === MAX_FIELD_DEPTH)
    return {
      value: selfValue
    };
  const children = {};
  if (schemaType.jsonType === "object") {
    const normalizedSchemaMembers = schemaType.fieldsets ? schemaType.fieldsets : schemaType.fields.map((field) => ({
      single: !0,
      field
    }));
    for (const fieldset of normalizedSchemaMembers) {
      if (fieldset.single) {
        const childResult = resolveCallbackState({
          currentUser,
          document: document2,
          parent: value,
          value: value?.[fieldset.field.name],
          schemaType: fieldset.field.type,
          level: level + 1,
          property,
          path: [...path, fieldset.field.name]
        });
        if (!childResult) continue;
        children[fieldset.field.name] = childResult;
        continue;
      }
      const fieldsetValue = resolveConditionalProperty(fieldset.hidden, context);
      fieldsetValue && (children[`fieldset:${fieldset.name}`] = {
        value: fieldsetValue
      });
      for (const field of fieldset.fields) {
        const childResult = resolveCallbackState({
          currentUser,
          document: document2,
          parent: value,
          value: value?.[field.name],
          schemaType: field.type,
          level: level + 1,
          property,
          path: [...path, field.name]
        });
        childResult && (children[field.name] = childResult);
      }
    }
    for (const group2 of schemaType.groups ?? EMPTY_ARRAY$y)
      if (property in group2) {
        const groupResult = resolveConditionalProperty(group2[property], context);
        if (!groupResult) continue;
        children[`group:${group2.name}`] = {
          value: groupResult
        };
      }
  }
  if (schemaType.jsonType === "array" && Array.isArray(value) && value.every(isKeyedObject))
    for (const item of value) {
      const itemType = getItemType(schemaType, item);
      if (!itemType) continue;
      const childResult = resolveCallbackState({
        currentUser,
        document: document2,
        level: level + 1,
        value: item,
        parent: value,
        schemaType: itemType,
        property,
        path: [...path, {
          _key: item._key
        }]
      });
      childResult && (children[item._key] = childResult);
    }
  if (Object.keys(children).length) return {
    children
  };
}
function createCallbackResolver({
  property
}) {
  const stableTrue = {
    value: !0
  };
  let last2 = null;
  function callbackResult({
    currentUser,
    documentValue,
    schemaType,
    ...options
  }) {
    const hash2 = {
      currentUser: getId(currentUser),
      schemaType: getId(schemaType),
      document: getId(documentValue)
    }, serializedHash = JSON.stringify(hash2);
    if (property in options && options[property] === !0)
      return stableTrue;
    if (last2?.serializedHash === serializedHash) return last2.result;
    const result = immutableReconcile(last2?.result ?? null, resolveCallbackState({
      currentUser,
      document: documentValue,
      level: 0,
      parent: null,
      schemaType,
      value: documentValue,
      property,
      path: []
    }));
    return last2 = {
      result,
      serializedHash
    }, result;
  }
  return callbackResult;
}
function useFormState(t0) {
  const $ = c(42), {
    comparisonValue,
    documentValue,
    fieldGroupState,
    collapsedFieldSets,
    collapsedPaths,
    focusPath,
    openPath,
    presence,
    validation: validation2,
    readOnly: inputReadOnly,
    changesOpen,
    schemaType,
    perspective,
    hasUpstreamVersion,
    displayInlineChanges
  } = t0, currentUser = useCurrentUser(), [prepareHiddenState] = useState(_temp$1u), [prepareReadOnlyState] = useState(_temp2$B), [prepareFormState] = useState(_temp3$k), [reconcileFieldGroupState] = useState(_temp4$9);
  let t1;
  $[0] !== fieldGroupState || $[1] !== reconcileFieldGroupState ? (t1 = reconcileFieldGroupState(fieldGroupState), $[0] = fieldGroupState, $[1] = reconcileFieldGroupState, $[2] = t1) : t1 = $[2];
  const reconciledFieldGroupState = t1, [reconcileCollapsedPaths] = useState(_temp5$6);
  let t2;
  $[3] !== collapsedPaths || $[4] !== reconcileCollapsedPaths ? (t2 = reconcileCollapsedPaths(collapsedPaths), $[3] = collapsedPaths, $[4] = reconcileCollapsedPaths, $[5] = t2) : t2 = $[5];
  const reconciledCollapsedPaths = t2, [reconcileCollapsedFieldsets] = useState(_temp6$2);
  let t3;
  $[6] !== collapsedFieldSets || $[7] !== reconcileCollapsedFieldsets ? (t3 = reconcileCollapsedFieldsets(collapsedFieldSets), $[6] = collapsedFieldSets, $[7] = reconcileCollapsedFieldsets, $[8] = t3) : t3 = $[8];
  const reconciledCollapsedFieldsets = t3;
  let t4;
  $[9] !== currentUser || $[10] !== documentValue || $[11] !== prepareHiddenState || $[12] !== schemaType ? (t4 = prepareHiddenState({
    currentUser,
    documentValue,
    schemaType
  }), $[9] = currentUser, $[10] = documentValue, $[11] = prepareHiddenState, $[12] = schemaType, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== currentUser || $[15] !== documentValue || $[16] !== inputReadOnly || $[17] !== prepareReadOnlyState || $[18] !== schemaType ? (t5 = prepareReadOnlyState({
    currentUser,
    documentValue,
    schemaType,
    readOnly: inputReadOnly
  }), $[14] = currentUser, $[15] = documentValue, $[16] = inputReadOnly, $[17] = prepareReadOnlyState, $[18] = schemaType, $[19] = t5) : t5 = $[19];
  let t6;
  $[20] !== t4 || $[21] !== t5 ? (t6 = {
    hidden: t4,
    readOnly: t5
  }, $[20] = t4, $[21] = t5, $[22] = t6) : t6 = $[22];
  const {
    hidden,
    readOnly
  } = t6, t7 = documentValue && isGoingToUnpublish(documentValue) ? EMPTY_ARRAY$y : validation2;
  let t8;
  return $[23] !== changesOpen || $[24] !== comparisonValue || $[25] !== currentUser || $[26] !== displayInlineChanges || $[27] !== documentValue || $[28] !== focusPath || $[29] !== hasUpstreamVersion || $[30] !== hidden || $[31] !== openPath || $[32] !== perspective || $[33] !== prepareFormState || $[34] !== presence || $[35] !== readOnly || $[36] !== reconciledCollapsedFieldsets || $[37] !== reconciledCollapsedPaths || $[38] !== reconciledFieldGroupState || $[39] !== schemaType || $[40] !== t7 ? (t8 = prepareFormState({
    schemaType,
    fieldGroupState: reconciledFieldGroupState,
    collapsedFieldSets: reconciledCollapsedFieldsets,
    collapsedPaths: reconciledCollapsedPaths,
    documentValue,
    comparisonValue,
    focusPath,
    openPath,
    readOnly,
    hidden,
    currentUser,
    presence,
    validation: t7,
    changesOpen,
    perspective,
    hasUpstreamVersion,
    displayInlineChanges
  }), $[23] = changesOpen, $[24] = comparisonValue, $[25] = currentUser, $[26] = displayInlineChanges, $[27] = documentValue, $[28] = focusPath, $[29] = hasUpstreamVersion, $[30] = hidden, $[31] = openPath, $[32] = perspective, $[33] = prepareFormState, $[34] = presence, $[35] = readOnly, $[36] = reconciledCollapsedFieldsets, $[37] = reconciledCollapsedPaths, $[38] = reconciledFieldGroupState, $[39] = schemaType, $[40] = t7, $[41] = t8) : t8 = $[41], t8;
}
function _temp6$2() {
  let last_1;
  return (state_1) => {
    const result_1 = immutableReconcile(last_1 ?? null, state_1);
    return last_1 = result_1, result_1;
  };
}
function _temp5$6() {
  let last_0;
  return (state_0) => {
    const result_0 = immutableReconcile(last_0 ?? null, state_0);
    return last_0 = result_0, result_0;
  };
}
function _temp4$9() {
  let last2;
  return (state) => {
    const result = immutableReconcile(last2 ?? null, state);
    return last2 = result, result;
  };
}
function _temp3$k() {
  return createPrepareFormState();
}
function _temp2$B() {
  return createCallbackResolver({
    property: "readOnly"
  });
}
function _temp$1u() {
  return createCallbackResolver({
    property: "hidden"
  });
}
function hasAllMembers(value) {
  return "_allMembers" in value && Array.isArray(value._allMembers);
}
function getExpandOperations(node, path) {
  return [
    // make sure to expand all intermediate paths
    ...path.map((p, i) => ({
      type: "expandPath",
      path: path.slice(0, i + 1)
    })),
    // make sure to expand all fieldsets and selects the groups that includes the intermediate nodes
    ...getFieldsetAndFieldGroupOperations(node, path)
  ];
}
function getFieldsetAndFieldGroupOperations(node, path) {
  return path.length === 0 ? [] : isObjectFormNode(node) && hasAllMembers(node) ? getObjectFieldsetAndFieldGroupOperations(node, path) : isArrayOfObjectsFormNode(node) ? getArrayFieldsetAndFieldGroupOperations(node, path) : [];
}
function getObjectFieldsetAndFieldGroupOperations(node, path) {
  if (path.length === 0)
    return [];
  const [fieldName, ...tail] = path, fieldsetMember = node._allMembers.find((member) => member.kind === "fieldSet" && member.fieldSet.members.some((field) => field.kind === "field" && field.name === fieldName)), fieldMember = (fieldsetMember ? fieldsetMember.fieldSet.members : (
    // Note: we need to use the internal `_allMembers` array here instead of members since hidden/collapsed members are omitted from members
    node._allMembers
  )).find((member) => member !== null && member.kind === "field" && member.name === fieldName), schemaField = node.schemaType.fields.find((field) => field.name === fieldName), selectedGroupName = node.groups.find((group2) => group2.selected)?.name, schemaFieldGroup = schemaField && castArray(schemaField.group) || [], inSelectedGroup = selectedGroupName && (selectedGroupName === ALL_FIELDS_GROUP.name || schemaFieldGroup.includes(selectedGroupName)), ops = [];
  if (!inSelectedGroup) {
    const groupName = node.groups.find((group2) => schemaFieldGroup.includes(group2.name))?.name || ALL_FIELDS_GROUP.name;
    ops.push({
      type: "setSelectedGroup",
      path: node.path,
      groupName
    });
  }
  return fieldsetMember && ops.push({
    type: "expandFieldSet",
    path: fieldsetMember.fieldSet.path
  }), fieldMember && isMemberArrayOfObjects(fieldMember) && ops.push(...getArrayFieldsetAndFieldGroupOperations(fieldMember.field, tail)), fieldMember && isMemberObject(fieldMember) && hasAllMembers(fieldMember.field) && ops.push(...getObjectFieldsetAndFieldGroupOperations(fieldMember.field, tail)), ops;
}
function getArrayFieldsetAndFieldGroupOperations(state, path) {
  if (path.length === 0)
    return [];
  const [segment, ...rest] = path;
  if (!isKeySegment(segment))
    throw new Error("Expected path segment to be an object with a _key property");
  const foundMember = state.members.find((member) => member.key === segment._key);
  return foundMember ? getFieldsetAndFieldGroupOperations(foundMember.item, rest) : [];
}
const useCanvasCompanionDoc = (documentId) => {
  const $ = c(13), companionDocsStore = useCanvasCompanionDocsStore();
  let t0;
  $[0] !== documentId ? (t0 = getPublishedId(documentId), $[0] = documentId, $[1] = t0) : t0 = $[1];
  const publishedId = t0;
  let t1;
  $[2] !== companionDocsStore || $[3] !== publishedId ? (t1 = companionDocsStore.getCompanionDocs(publishedId), $[2] = companionDocsStore, $[3] = publishedId, $[4] = t1) : t1 = $[4];
  const companionDocs = useObservable(t1);
  let t2;
  $[5] !== companionDocs?.data || $[6] !== documentId ? (t2 = companionDocs?.data.find((companion) => companion?.studioDocumentId === documentId), $[5] = companionDocs?.data, $[6] = documentId, $[7] = t2) : t2 = $[7];
  const companionDoc = t2, t3 = !!companionDoc, t4 = companionDoc ? !companionDoc.isStudioDocumentEditable : !1, t5 = companionDocs?.loading;
  let t6;
  return $[8] !== companionDoc || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 ? (t6 = {
    isLinked: t3,
    isLockedByCanvas: t4,
    companionDoc,
    loading: t5
  }, $[8] = companionDoc, $[9] = t3, $[10] = t4, $[11] = t5, $[12] = t6) : t6 = $[12], t6;
}, INITIAL$1 = "connecting";
function useConnectionState(publishedDocId, docTypeName, version2) {
  const $ = c(5), documentStore = useDocumentStore();
  let t0;
  return $[0] !== docTypeName || $[1] !== documentStore.pair || $[2] !== publishedDocId || $[3] !== version2 ? (t0 = documentStore.pair.documentEvents(publishedDocId, docTypeName, version2).pipe(map(_temp$1t), map(_temp2$A), switchMap(_temp3$j), startWith(INITIAL$1), distinctUntilChanged()), $[0] = docTypeName, $[1] = documentStore.pair, $[2] = publishedDocId, $[3] = version2, $[4] = t0) : t0 = $[4], useObservable(t0, INITIAL$1);
}
function _temp3$j(isConnected) {
  return isConnected ? of("connected") : timer(200).pipe(mapTo("reconnecting"));
}
function _temp2$A(eventType) {
  return eventType !== "reconnect";
}
function _temp$1t(ev) {
  return ev.type;
}
function useFilteredReleases(t0) {
  const $ = c(22), {
    displayed,
    documentId,
    strict,
    historyVersion
  } = t0, {
    selectedReleaseId
  } = usePerspective(), {
    data: releases2
  } = useActiveReleases(), {
    data: archivedReleases
  } = useArchivedReleases();
  let t1;
  $[0] !== documentId ? (t1 = {
    documentId
  }, $[0] = documentId, $[1] = t1) : t1 = $[1];
  const {
    data: documentVersions
  } = useDocumentVersions(t1), isCreatingDocument = displayed && !displayed._createdAt, t2 = !documentVersions;
  let activeReleases, t3;
  if ($[2] !== archivedReleases || $[3] !== displayed || $[4] !== documentVersions || $[5] !== historyVersion || $[6] !== isCreatingDocument || $[7] !== releases2 || $[8] !== selectedReleaseId || $[9] !== strict || $[10] !== t2) {
    t3 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    bb0: {
      if (t2) {
        t3 = {
          notCurrentReleases: [],
          currentReleases: [],
          inCreation: null
        };
        break bb0;
      }
      if ($[13] !== archivedReleases || $[14] !== displayed || $[15] !== documentVersions || $[16] !== historyVersion || $[17] !== isCreatingDocument || $[18] !== releases2 || $[19] !== selectedReleaseId || $[20] !== strict) {
        const releasesIds = documentVersions.map(_temp$1s);
        if (activeReleases = releases2.reduce((acc, release) => {
          const versionDocExists = releasesIds.includes(getReleaseIdFromReleaseDocumentId(release._id)), releaseId = getReleaseIdFromReleaseDocumentId(release._id);
          return isCreatingDocument && releaseId === getVersionFromId(displayed._id || "") && releaseId === selectedReleaseId ? acc.inCreation = release : versionDocExists ? strict ? (getDocumentIsInPerspective(displayed?._id ?? "", getReleaseIdFromReleaseDocumentId(release._id)) || release.metadata.releaseType === "scheduled") && acc.currentReleases.push(release) : acc.currentReleases.push(release) : acc.notCurrentReleases.push(release), acc;
        }, {
          notCurrentReleases: [],
          currentReleases: [],
          inCreation: null
        }), !historyVersion) {
          t3 = activeReleases;
          break bb0;
        }
        const archivedRelease = archivedReleases.find((r) => getReleaseIdFromReleaseDocumentId(r._id) === historyVersion);
        archivedRelease?.state === "archived" && activeReleases.currentReleases.push(archivedRelease), $[13] = archivedReleases, $[14] = displayed, $[15] = documentVersions, $[16] = historyVersion, $[17] = isCreatingDocument, $[18] = releases2, $[19] = selectedReleaseId, $[20] = strict, $[21] = activeReleases;
      } else
        activeReleases = $[21];
    }
    $[2] = archivedReleases, $[3] = displayed, $[4] = documentVersions, $[5] = historyVersion, $[6] = isCreatingDocument, $[7] = releases2, $[8] = selectedReleaseId, $[9] = strict, $[10] = t2, $[11] = activeReleases, $[12] = t3;
  } else
    activeReleases = $[11], t3 = $[12];
  return t3 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel") ? t3 : activeReleases;
}
function _temp$1s(id2) {
  return getVersionFromId(id2);
}
function useDocumentIdStack(t0) {
  const $ = c(24), {
    displayed,
    documentId,
    editState: editState2,
    strict
  } = t0, {
    document: t1
  } = useWorkspace(), {
    drafts: t2
  } = t1, {
    enabled: isDraftModelEnabled
  } = t2;
  let t3;
  $[0] !== displayed || $[1] !== documentId || $[2] !== strict ? (t3 = {
    displayed,
    documentId,
    strict
  }, $[0] = displayed, $[1] = documentId, $[2] = strict, $[3] = t3) : t3 = $[3];
  const filteredReleases = useFilteredReleases(t3);
  let t4;
  $[4] !== displayed?._id || $[5] !== isDraftModelEnabled || $[6] !== strict ? (t4 = isDraftModelEnabled && (strict ? isDraftId(displayed?._id ?? "") : !0), $[4] = displayed?._id, $[5] = isDraftModelEnabled, $[6] = strict, $[7] = t4) : t4 = $[7];
  const shouldIncludeDraft = t4, t5 = editState2?.published?._id;
  let t6;
  if ($[8] !== displayed?._id || $[9] !== editState2 || $[10] !== filteredReleases.currentReleases || $[11] !== shouldIncludeDraft || $[12] !== strict || $[13] !== t5) {
    const systemStack = [t5, shouldIncludeDraft ? editState2?.draft?._id : []].flat();
    let t72;
    $[15] !== editState2 ? (t72 = (release) => editState2?.id && getVersionId(editState2.id, getReleaseIdFromReleaseDocumentId(release._id)), $[15] = editState2, $[16] = t72) : t72 = $[16];
    const releaseStack = filteredReleases.currentReleases.map(t72), isAnonymousVersion = editState2?.version !== null && !releaseStack.includes(displayed?._id), anonymousVersionsStack = isAnonymousVersion ? [displayed?._id] : [];
    t6 = systemStack.concat(!isAnonymousVersion || !strict ? releaseStack : []).concat(anonymousVersionsStack).filter(_temp$1r), $[8] = displayed?._id, $[9] = editState2, $[10] = filteredReleases.currentReleases, $[11] = shouldIncludeDraft, $[12] = strict, $[13] = t5, $[14] = t6;
  } else
    t6 = $[14];
  const stack = t6;
  let t7;
  $[17] !== displayed?._id ? (t7 = (id_0) => id_0 === displayed?._id, $[17] = displayed?._id, $[18] = t7) : t7 = $[18];
  const position = stack.findIndex(t7), previousId = stack[position - 1] ?? void 0, nextId = stack[position + 1] ?? void 0;
  let t8;
  return $[19] !== nextId || $[20] !== position || $[21] !== previousId || $[22] !== stack ? (t8 = {
    position,
    previousId,
    nextId,
    stack
  }, $[19] = nextId, $[20] = position, $[21] = previousId, $[22] = stack, $[23] = t8) : t8 = $[23], t8;
}
function _temp$1r(id2) {
  return typeof id2 == "string";
}
function useEditState(publishedDocId, docTypeName, t0, version2) {
  const $ = c(10), priority = t0 === void 0 ? "default" : t0;
  if (version2 === "published" || version2 === "draft")
    throw new Error("Version cannot be published or draft");
  const documentStore = useDocumentStore();
  let t1;
  bb0: {
    if (priority === "low") {
      let t22;
      if ($[0] !== docTypeName || $[1] !== documentStore.pair || $[2] !== publishedDocId || $[3] !== version2) {
        const base = documentStore.pair.editState(publishedDocId, docTypeName, version2).pipe(share$1());
        t22 = merge(base.pipe(take(1)), base.pipe(skip$1(1), debounce$2(_temp$1q))), $[0] = docTypeName, $[1] = documentStore.pair, $[2] = publishedDocId, $[3] = version2, $[4] = t22;
      } else
        t22 = $[4];
      t1 = t22;
      break bb0;
    }
    let t2;
    $[5] !== docTypeName || $[6] !== documentStore.pair || $[7] !== publishedDocId || $[8] !== version2 ? (t2 = documentStore.pair.editState(publishedDocId, docTypeName, version2), $[5] = docTypeName, $[6] = documentStore.pair, $[7] = publishedDocId, $[8] = version2, $[9] = t2) : t2 = $[9], t1 = t2;
  }
  return useObservable(t1);
}
function _temp$1q() {
  return timer(1e3);
}
const INITIAL = {
  validation: [],
  isValidating: !1
};
function useValidationStatus(validationTargetId, docTypeName, requirePublishedReferences) {
  const $ = c(5), documentStore = useDocumentStore();
  let t0;
  return $[0] !== docTypeName || $[1] !== documentStore.pair || $[2] !== requirePublishedReferences || $[3] !== validationTargetId ? (t0 = documentStore.pair.validation(validationTargetId, docTypeName, requirePublishedReferences), $[0] = docTypeName, $[1] = documentStore.pair, $[2] = requirePublishedReferences, $[3] = validationTargetId, $[4] = t0) : t0 = $[4], useObservable(t0, INITIAL);
}
function getSelectedPerspective(selectedPerspectiveName, releases2) {
  return selectedPerspectiveName ? selectedPerspectiveName === "published" ? "published" : releases2.find((release) => getReleaseIdFromReleaseDocumentId(release._id) === selectedPerspectiveName) || selectedPerspectiveName : "drafts";
}
function useComlinkViewHistory(t0) {
  const $ = c(18), {
    editState: editState2
  } = t0, renderingContextStore = useRenderingContextStore(), capabilities = useObservable(renderingContextStore.capabilities), {
    activeWorkspace
  } = useActiveWorkspace(), displayed = editState2.version ?? editState2.draft ?? editState2.published, t1 = displayed?._id ?? editState2.id, t2 = editState2.type;
  let t3;
  $[0] !== activeWorkspace.dataset || $[1] !== activeWorkspace.projectId ? (t3 = [activeWorkspace.projectId, activeWorkspace.dataset], $[0] = activeWorkspace.dataset, $[1] = activeWorkspace.projectId, $[2] = t3) : t3 = $[2];
  const t4 = t3.join(".");
  let t5;
  $[3] !== activeWorkspace.name || $[4] !== editState2.type || $[5] !== t1 || $[6] !== t4 ? (t5 = {
    resourceType: "studio",
    documentId: t1,
    documentType: t2,
    resourceId: t4,
    schemaName: activeWorkspace.name
  }, $[3] = activeWorkspace.name, $[4] = editState2.type, $[5] = t1, $[6] = t4, $[7] = t5) : t5 = $[7];
  const {
    recordEvent
  } = useRecordDocumentHistoryEvent(t5), hasRecordedView = useRef(!1);
  let t6;
  $[8] !== capabilities?.comlink || $[9] !== displayed || $[10] !== editState2.ready || $[11] !== recordEvent ? (t6 = () => {
    const documentExists = editState2.ready && displayed !== null;
    capabilities?.comlink && documentExists && !hasRecordedView.current && (hasRecordedView.current = !0, recordEvent("viewed"));
  }, $[8] = capabilities?.comlink, $[9] = displayed, $[10] = editState2.ready, $[11] = recordEvent, $[12] = t6) : t6 = $[12];
  const t7 = capabilities?.comlink;
  let t8;
  $[13] !== displayed || $[14] !== editState2.ready || $[15] !== recordEvent || $[16] !== t7 ? (t8 = [t7, displayed, editState2.ready, recordEvent], $[13] = displayed, $[14] = editState2.ready, $[15] = recordEvent, $[16] = t7, $[17] = t8) : t8 = $[17], useEffect(t6, t8);
}
function useDocumentForm(options) {
  const $ = c(159), {
    documentType,
    getFormDocumentValue,
    documentId,
    initialValue,
    changesOpen: t0,
    comparisonValue: comparisonValueRaw,
    releaseId,
    initialFocusPath,
    selectedPerspectiveName,
    readOnly: readOnlyProp,
    onFocusPath,
    displayInlineChanges
  } = options, changesOpen = t0 === void 0 ? !1 : t0, schema2 = useSchema(), presenceStore = usePresenceStore(), {
    data: releases2
  } = useActiveReleases();
  let t1;
  $[0] !== documentId ? (t1 = {
    documentId
  }, $[0] = documentId, $[1] = t1) : t1 = $[1];
  const {
    data: documentVersions
  } = useDocumentVersions(t1);
  useWorkspace();
  let t2;
  $[2] !== documentType || $[3] !== schema2 ? (t2 = schema2.get(documentType), $[2] = documentType, $[3] = schema2, $[4] = t2) : t2 = $[4];
  const schemaType = t2;
  if (!schemaType)
    throw new Error(`Schema type for '${documentType}' not found`);
  const liveEdit = !!schemaType.liveEdit, publishedId = getPublishedId(documentId), telemetry = useTelemetry();
  let t3;
  $[5] !== documentId ? (t3 = {
    documentId
  }, $[5] = documentId, $[6] = t3) : t3 = $[6];
  const {
    sortedDocumentList
  } = useDocumentVersionTypeSortedList(t3);
  let t4;
  $[7] !== documentId ? (t4 = {
    documentId
  }, $[7] = documentId, $[8] = t4) : t4 = $[8];
  const onlyHasVersions = useOnlyHasVersions(t4);
  let t5;
  $[9] !== documentVersions || $[10] !== sortedDocumentList[0] || $[11] !== sortedDocumentList.length ? (t5 = sortedDocumentList.length > 0 ? documentVersions.find((id2) => getVersionFromId(id2) === getReleaseIdFromReleaseDocumentId(sortedDocumentList[0]._id)) : void 0, $[9] = documentVersions, $[10] = sortedDocumentList[0], $[11] = sortedDocumentList.length, $[12] = t5) : t5 = $[12];
  const firstVersion = t5;
  let t6;
  bb0: {
    if (isSystemBundle(selectedPerspectiveName)) {
      t6 = void 0;
      break bb0;
    }
    if (documentVersions.some((id_0) => getVersionFromId(id_0) === selectedPerspectiveName)) {
      t6 = selectedPerspectiveName;
      break bb0;
    }
    if (selectedPerspectiveName && (!documentVersions.length || !onlyHasVersions)) {
      t6 = selectedPerspectiveName;
      break bb0;
    }
    const t72 = firstVersion ?? "";
    let t82;
    $[13] !== t72 ? (t82 = getVersionFromId(t72), $[13] = t72, $[14] = t82) : t82 = $[14], t6 = t82;
  }
  const activeDocumentReleaseId = t6, editState2 = useEditState(documentId, documentType, "default", activeDocumentReleaseId), connectionState = useConnectionState(documentId, documentType, activeDocumentReleaseId);
  useReconnectingToast(connectionState === "reconnecting");
  const [focusPath, setFocusPath] = useState(initialFocusPath || EMPTY_ARRAY$y);
  let t7;
  bb1: {
    let t82;
    $[15] !== documentId || $[16] !== documentType || $[17] !== initialValue?.value ? (t82 = initialValue?.value || {
      _id: documentId,
      _type: documentType
    }, $[15] = documentId, $[16] = documentType, $[17] = initialValue?.value, $[18] = t82) : t82 = $[18];
    const baseValue = t82;
    if (releaseId && !isSystemBundle(releaseId)) {
      if (editState2.version && isGoingToUnpublish(editState2.version)) {
        t7 = editState2.published || baseValue;
        break bb1;
      }
      t7 = editState2.version || editState2.draft || editState2.published || baseValue;
      break bb1;
    }
    if (selectedPerspectiveName && isPublishedPerspective(selectedPerspectiveName)) {
      let t92;
      $[19] !== baseValue || $[20] !== documentId || $[21] !== documentType || $[22] !== editState2.published || $[23] !== liveEdit ? (t92 = editState2.published || (liveEdit ? baseValue : {
        _id: documentId,
        _type: documentType
      }), $[19] = baseValue, $[20] = documentId, $[21] = documentType, $[22] = editState2.published, $[23] = liveEdit, $[24] = t92) : t92 = $[24], t7 = t92;
      break bb1;
    }
    if (selectedPerspectiveName || onlyHasVersions) {
      t7 = editState2.version || editState2.draft || editState2.published || baseValue;
      break bb1;
    }
    t7 = editState2?.draft || editState2?.published || baseValue;
  }
  const value = t7, {
    validation: validationRaw
  } = useValidationStatus(value._id, documentType, !releaseId), validation2 = useUnique(validationRaw);
  let t8;
  $[25] !== documentId || $[26] !== editState2 || $[27] !== value ? (t8 = {
    strict: !0,
    displayed: value,
    documentId,
    editState: editState2
  }, $[25] = documentId, $[26] = editState2, $[27] = value, $[28] = t8) : t8 = $[28];
  const {
    previousId: upstreamId
  } = useDocumentIdStack(t8), t9 = upstreamId ?? "";
  let t10;
  $[29] !== t9 ? (t10 = getVersionFromId(t9), $[29] = t9, $[30] = t10) : t10 = $[30];
  const upstreamEditState = useEditState(documentId, documentType, "default", t10);
  let t11;
  bb2: {
    if (typeof comparisonValueRaw == "function") {
      let t122;
      $[31] !== comparisonValueRaw || $[32] !== upstreamEditState ? (t122 = comparisonValueRaw(upstreamEditState), $[31] = comparisonValueRaw, $[32] = upstreamEditState, $[33] = t122) : t122 = $[33], t11 = t122;
      break bb2;
    }
    t11 = comparisonValueRaw;
  }
  const comparisonValue = t11;
  let t12;
  $[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = [], $[34] = t12) : t12 = $[34];
  const [presence, setPresence] = useState(t12);
  let t13, t14;
  $[35] !== presenceStore || $[36] !== value._id ? (t13 = () => {
    const subscription = presenceStore.documentPresence(value._id, {
      excludeVersions: !0
    }).subscribe((nextPresence) => {
      setPresence((prev) => prev.length === nextPresence.length && prev.every((p, i) => p.sessionId === nextPresence[i].sessionId && p.lastActiveAt === nextPresence[i].lastActiveAt && p.path === nextPresence[i].path) ? prev : nextPresence);
    });
    return () => {
      subscription.unsubscribe();
    };
  }, t14 = [presenceStore, value._id], $[35] = presenceStore, $[36] = value._id, $[37] = t13, $[38] = t14) : (t13 = $[37], t14 = $[38]), useEffect(t13, t14);
  const [openPath, onSetOpenPath] = useState(EMPTY_ARRAY$y), [fieldGroupState, onSetFieldGroupState] = useState(), [collapsedPaths, onSetCollapsedPath] = useState(), [collapsedFieldSets, onSetCollapsedFieldSets] = useState();
  let t15;
  $[39] !== onSetCollapsedPath ? (t15 = (path, collapsed) => {
    onSetCollapsedPath((prevState) => setAtPath(prevState, path, collapsed));
  }, $[39] = onSetCollapsedPath, $[40] = t15) : t15 = $[40];
  const handleOnSetCollapsedPath = t15;
  let t16;
  $[41] !== onSetCollapsedFieldSets ? (t16 = (path_0, collapsed_0) => {
    onSetCollapsedFieldSets((prevState_0) => setAtPath(prevState_0, path_0, collapsed_0));
  }, $[41] = onSetCollapsedFieldSets, $[42] = t16) : t16 = $[42];
  const handleOnSetCollapsedFieldSet = t16;
  let t17;
  $[43] !== onSetFieldGroupState ? (t17 = (path_1, groupName) => onSetFieldGroupState((prevState_1) => setAtPath(prevState_1, path_1, groupName)), $[43] = onSetFieldGroupState, $[44] = t17) : t17 = $[44];
  const handleSetActiveFieldGroup = t17, requiredPermission = value._createdAt ? "update" : "create", targetDocumentId = activeDocumentReleaseId ? getVersionId(publishedId, activeDocumentReleaseId) : liveEdit ? editState2?.draft?._id || publishedId : getDraftId(documentId);
  let t18;
  $[45] !== targetDocumentId || $[46] !== value ? (t18 = {
    ...value,
    _id: targetDocumentId
  }, $[45] = targetDocumentId, $[46] = value, $[47] = t18) : t18 = $[47];
  const docPermissionsInput = t18;
  let t19;
  $[48] !== docPermissionsInput || $[49] !== requiredPermission ? (t19 = {
    document: docPermissionsInput,
    permission: requiredPermission
  }, $[48] = docPermissionsInput, $[49] = requiredPermission, $[50] = t19) : t19 = $[50];
  const [permissions, isPermissionsLoading] = useDocumentValuePermissions(t19), isNonExistent = !value?._id, ready = connectionState === "connected" && editState2.ready && !initialValue?.loading;
  let t20;
  $[51] !== releases2 || $[52] !== selectedPerspectiveName ? (t20 = getSelectedPerspective(selectedPerspectiveName, releases2), $[51] = releases2, $[52] = selectedPerspectiveName, $[53] = t20) : t20 = $[53];
  const selectedPerspective = t20;
  let t21;
  $[54] !== selectedPerspective ? (t21 = isReleaseDocument(selectedPerspective) ? isReleaseScheduledOrScheduling(selectedPerspective) : !1, $[54] = selectedPerspective, $[55] = t21) : t21 = $[55];
  const isReleaseLocked = t21, {
    isLockedByCanvas
  } = useCanvasCompanionDoc(value._id);
  let t22;
  $[56] !== connectionState || $[57] !== editState2 || $[58] !== isLockedByCanvas || $[59] !== isNonExistent || $[60] !== isPermissionsLoading || $[61] !== isReleaseLocked || $[62] !== liveEdit || $[63] !== onlyHasVersions || $[64] !== permissions?.granted || $[65] !== readOnlyProp || $[66] !== ready || $[67] !== releaseId || $[68] !== schemaType || $[69] !== selectedPerspectiveName || $[70] !== value ? (t22 = () => {
    const hasNoPermission = !isPermissionsLoading && !permissions?.granted, updateActionDisabled = !isActionEnabled(schemaType, "update"), createActionDisabled = isNonExistent && !isActionEnabled(schemaType, "create"), reconnecting = connectionState === "reconnecting", isLocked = editState2.transactionSyncLock?.enabled, willBeUnpublished = value ? isGoingToUnpublish(value) : !1;
    return editState2.version && !editState2.draft && !editState2.published && onlyHasVersions && selectedPerspectiveName !== getVersionFromId(editState2.version._id) && isNewDocument(editState2) === !1 || liveEdit && editState2.draft?._id || !liveEdit && selectedPerspectiveName === "published" || releaseId && getVersionFromId(value._id) !== releaseId && isNewDocument(editState2) === !1 || !ready || isLockedByCanvas || hasNoPermission || updateActionDisabled || createActionDisabled || reconnecting || isLocked || willBeUnpublished || isReleaseLocked ? !0 : typeof readOnlyProp == "function" ? readOnlyProp(editState2) : !!readOnlyProp;
  }, $[56] = connectionState, $[57] = editState2, $[58] = isLockedByCanvas, $[59] = isNonExistent, $[60] = isPermissionsLoading, $[61] = isReleaseLocked, $[62] = liveEdit, $[63] = onlyHasVersions, $[64] = permissions?.granted, $[65] = readOnlyProp, $[66] = ready, $[67] = releaseId, $[68] = schemaType, $[69] = selectedPerspectiveName, $[70] = value, $[71] = t22) : t22 = $[71];
  let t23;
  $[72] !== t22 ? (t23 = t22(), $[72] = t22, $[73] = t23) : t23 = $[73];
  const readOnly = t23, {
    patch: patch2
  } = useDocumentOperation(documentId, documentType, activeDocumentReleaseId), patchRef = useRef(_temp$1p);
  let t24;
  $[74] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t24 = (event) => patchRef.current(event), $[74] = t24) : t24 = $[74];
  const handleChange = t24;
  let t25;
  $[75] !== editState2.draft || $[76] !== editState2.published || $[77] !== initialValue?.value || $[78] !== patch2 || $[79] !== readOnly || $[80] !== telemetry ? (t25 = () => {
    readOnly ? patchRef.current = _temp2$z : patchRef.current = (event_0) => {
      !editState2.draft && !editState2.published && telemetry.log(CreatedDraft), patch2.execute(toMutationPatches(event_0.patches), initialValue?.value);
    };
  }, $[75] = editState2.draft, $[76] = editState2.published, $[77] = initialValue?.value, $[78] = patch2, $[79] = readOnly, $[80] = telemetry, $[81] = t25) : t25 = $[81];
  let t26;
  $[82] !== editState2.draft || $[83] !== editState2.published || $[84] !== initialValue || $[85] !== patch2 || $[86] !== readOnly || $[87] !== telemetry ? (t26 = [editState2.draft, editState2.published, initialValue, patch2, telemetry, readOnly], $[82] = editState2.draft, $[83] = editState2.published, $[84] = initialValue, $[85] = patch2, $[86] = readOnly, $[87] = telemetry, $[88] = t26) : t26 = $[88], useInsertionEffect(t25, t26);
  let t27;
  bb3: {
    if (getFormDocumentValue) {
      let t282;
      $[89] !== getFormDocumentValue || $[90] !== value ? (t282 = getFormDocumentValue(value), $[89] = getFormDocumentValue, $[90] = value, $[91] = t282) : t282 = $[91], t27 = t282;
      break bb3;
    }
    t27 = value;
  }
  const formDocumentValue = t27;
  let t28;
  $[92] !== upstreamEditState ? (t28 = selectUpstreamVersion(upstreamEditState), $[92] = upstreamEditState, $[93] = t28) : t28 = $[93];
  const hasUpstreamVersion = t28 !== null, t29 = comparisonValue || value;
  let t30;
  $[94] !== changesOpen || $[95] !== collapsedFieldSets || $[96] !== collapsedPaths || $[97] !== displayInlineChanges || $[98] !== fieldGroupState || $[99] !== focusPath || $[100] !== formDocumentValue || $[101] !== hasUpstreamVersion || $[102] !== openPath || $[103] !== presence || $[104] !== readOnly || $[105] !== schemaType || $[106] !== selectedPerspective || $[107] !== t29 || $[108] !== validation2 ? (t30 = {
    schemaType,
    documentValue: formDocumentValue,
    readOnly,
    comparisonValue: t29,
    focusPath,
    openPath,
    perspective: selectedPerspective,
    collapsedPaths,
    presence,
    validation: validation2,
    collapsedFieldSets,
    fieldGroupState,
    changesOpen,
    hasUpstreamVersion,
    displayInlineChanges
  }, $[94] = changesOpen, $[95] = collapsedFieldSets, $[96] = collapsedPaths, $[97] = displayInlineChanges, $[98] = fieldGroupState, $[99] = focusPath, $[100] = formDocumentValue, $[101] = hasUpstreamVersion, $[102] = openPath, $[103] = presence, $[104] = readOnly, $[105] = schemaType, $[106] = selectedPerspective, $[107] = t29, $[108] = validation2, $[109] = t30) : t30 = $[109];
  const formState = useFormState(t30), formStateRef = useRef(formState);
  let t31, t32;
  $[110] !== formState ? (t31 = () => {
    formStateRef.current = formState;
  }, t32 = [formState], $[110] = formState, $[111] = t31, $[112] = t32) : (t31 = $[111], t32 = $[112]), useEffect(t31, t32);
  let t33;
  $[113] !== editState2 ? (t33 = {
    editState: editState2
  }, $[113] = editState2, $[114] = t33) : t33 = $[114], useComlinkViewHistory(t33);
  let t34;
  $[115] !== onSetCollapsedFieldSets || $[116] !== onSetCollapsedPath || $[117] !== onSetFieldGroupState || $[118] !== onSetOpenPath ? (t34 = (path_2) => {
    getExpandOperations(formStateRef.current, path_2).forEach((op) => {
      op.type === "expandPath" && onSetCollapsedPath((prevState_2) => setAtPath(prevState_2, op.path, !1)), op.type === "expandFieldSet" && onSetCollapsedFieldSets((prevState_3) => setAtPath(prevState_3, op.path, !1)), op.type === "setSelectedGroup" && onSetFieldGroupState((prevState_4) => setAtPath(prevState_4, op.path, op.groupName));
    }), onSetOpenPath(path_2);
  }, $[115] = onSetCollapsedFieldSets, $[116] = onSetCollapsedPath, $[117] = onSetFieldGroupState, $[118] = onSetOpenPath, $[119] = t34) : t34 = $[119];
  const handleSetOpenPath = t34;
  let t35;
  $[120] !== presenceStore || $[121] !== value._id ? (t35 = throttle((nextFocusPath, payload) => {
    presenceStore.setLocation([{
      type: "document",
      documentId: value._id,
      path: nextFocusPath,
      lastActiveAt: (/* @__PURE__ */ new Date()).toISOString(),
      selection: payload?.selection
    }]);
  }, 1e3, {
    leading: !0,
    trailing: !0
  }), $[120] = presenceStore, $[121] = value._id, $[122] = t35) : t35 = $[122];
  const updatePresenceThrottled = t35;
  let t36;
  $[123] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t36 = [], $[123] = t36) : t36 = $[123];
  const focusPathRef = useRef(t36);
  let t37;
  $[124] !== handleSetOpenPath || $[125] !== onFocusPath || $[126] !== setFocusPath || $[127] !== updatePresenceThrottled ? (t37 = (_nextFocusPath, payload_0) => {
    const nextFocusPath_0 = pathFor(_nextFocusPath);
    nextFocusPath_0 !== focusPathRef.current && (setFocusPath(pathFor(nextFocusPath_0)), handleSetOpenPath(pathFor(nextFocusPath_0.slice(0, -1))), focusPathRef.current = nextFocusPath_0, onFocusPath?.(nextFocusPath_0)), updatePresenceThrottled(nextFocusPath_0, payload_0);
  }, $[124] = handleSetOpenPath, $[125] = onFocusPath, $[126] = setFocusPath, $[127] = updatePresenceThrottled, $[128] = t37) : t37 = $[128];
  const handleFocus = t37;
  let t38;
  $[129] !== onFocusPath || $[130] !== setFocusPath ? (t38 = (_blurredPath) => {
    setFocusPath(EMPTY_ARRAY$y), focusPathRef.current !== EMPTY_ARRAY$y && (focusPathRef.current = EMPTY_ARRAY$y, onFocusPath?.(EMPTY_ARRAY$y));
  }, $[129] = onFocusPath, $[130] = setFocusPath, $[131] = t38) : t38 = $[131];
  const handleBlur = t38;
  let t39;
  $[132] !== handleSetOpenPath || $[133] !== onFocusPath || $[134] !== setFocusPath ? (t39 = (nextPath) => {
    deepEquals(focusPathRef.current, nextPath) || (setFocusPath(nextPath), handleSetOpenPath(nextPath), onFocusPath?.(nextPath), focusPathRef.current = nextPath);
  }, $[132] = handleSetOpenPath, $[133] = onFocusPath, $[134] = setFocusPath, $[135] = t39) : t39 = $[135];
  const handleProgrammaticFocus = t39;
  let t40;
  return $[136] !== collapsedFieldSets || $[137] !== collapsedPaths || $[138] !== connectionState || $[139] !== editState2 || $[140] !== focusPath || $[141] !== formState || $[142] !== handleBlur || $[143] !== handleFocus || $[144] !== handleOnSetCollapsedFieldSet || $[145] !== handleOnSetCollapsedPath || $[146] !== handleProgrammaticFocus || $[147] !== handleSetActiveFieldGroup || $[148] !== handleSetOpenPath || $[149] !== hasUpstreamVersion || $[150] !== isPermissionsLoading || $[151] !== openPath || $[152] !== permissions || $[153] !== ready || $[154] !== schemaType || $[155] !== upstreamEditState || $[156] !== validation2 || $[157] !== value ? (t40 = {
    editState: editState2,
    upstreamEditState,
    connectionState,
    focusPath,
    validation: validation2,
    ready,
    value,
    formState,
    permissions,
    isPermissionsLoading,
    formStateRef,
    hasUpstreamVersion,
    collapsedFieldSets,
    collapsedPaths,
    openPath,
    schemaType,
    onChange: handleChange,
    onPathOpen: handleSetOpenPath,
    onProgrammaticFocus: handleProgrammaticFocus,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onSetActiveFieldGroup: handleSetActiveFieldGroup,
    onSetCollapsedPath: handleOnSetCollapsedPath,
    onSetCollapsedFieldSet: handleOnSetCollapsedFieldSet
  }, $[136] = collapsedFieldSets, $[137] = collapsedPaths, $[138] = connectionState, $[139] = editState2, $[140] = focusPath, $[141] = formState, $[142] = handleBlur, $[143] = handleFocus, $[144] = handleOnSetCollapsedFieldSet, $[145] = handleOnSetCollapsedPath, $[146] = handleProgrammaticFocus, $[147] = handleSetActiveFieldGroup, $[148] = handleSetOpenPath, $[149] = hasUpstreamVersion, $[150] = isPermissionsLoading, $[151] = openPath, $[152] = permissions, $[153] = ready, $[154] = schemaType, $[155] = upstreamEditState, $[156] = validation2, $[157] = value, $[158] = t40) : t40 = $[158], t40;
}
function _temp2$z() {
  throw new Error("Attempted to patch a read-only document");
}
function _temp$1p() {
  throw new Error("Attempted to patch the Sanity document during initial render or in an `useInsertionEffect`. Input components should only call `onChange()` in a useEffect or an event handler.");
}
const IS_NUMERIC = /^\d+$/;
function unquote(str) {
  return str.replace(/^['"]/, "").replace(/['"]$/, "");
}
function splitAttr(segment) {
  const [attr, key] = segment.split("==");
  return {
    [attr]: unquote(key)
  };
}
function coerce(segment) {
  return IS_NUMERIC.test(segment) ? Number(segment) : segment;
}
function parseGradientPath(focusPathStr) {
  return focusPathStr.split(/[[.\]]/g).filter(Boolean).map((seg) => seg.includes("==") ? splitAttr(seg) : coerce(seg));
}
function encodePath(formBuilderPath) {
  return arrayToJSONMatchPath(formBuilderPath);
}
function decodePath(gradientPath) {
  return parseGradientPath(gradientPath);
}
function toMutationPatches(patches) {
  return patches.map(toMutationPatch);
}
function fromMutationPatches(origin, patches) {
  return flatten$1(patches.map((patch2) => toFormBuilderPatches(origin, patch2)));
}
const notIn = (values2) => (value) => !values2.includes(value);
function toFormBuilderPatches(origin, patch2) {
  return flatten$1(Object.keys(patch2).filter(notIn(["id", "ifRevisionID", "query"])).map((type) => {
    if (type === "unset")
      return patch2.unset.map((path) => ({
        type: "unset",
        path: decodePath(path),
        origin
      }));
    if (type === "insert") {
      const position = "before" in patch2.insert ? "before" : "after";
      return {
        type: "insert",
        position,
        path: decodePath(patch2.insert[position]),
        items: patch2.insert.items,
        origin
      };
    }
    return Object.keys(patch2[type]).map((gradientPath) => type === "set" ? {
      type: "set",
      path: decodePath(gradientPath),
      value: patch2[type][gradientPath],
      origin
    } : type === "inc" || type === "dec" ? {
      type,
      path: decodePath(gradientPath),
      value: patch2[type][gradientPath],
      origin
    } : type === "setIfMissing" ? {
      type: "setIfMissing",
      path: decodePath(gradientPath),
      value: patch2[type][gradientPath],
      origin
    } : type === "diffMatchPatch" ? {
      type,
      path: decodePath(gradientPath),
      value: patch2[type][gradientPath],
      origin
    } : (console.warn(new Error(`Unsupported patch type: ${type}`)), null)).filter(Boolean);
  }));
}
function toMutationPatch(patch2) {
  if (patch2.patchType !== SANITY_PATCH_TYPE && patch2.type)
    throw new Error(`Patch is missing "patchType" - import and use "${patch2.type}()" from "sanity/form"`);
  if (patch2.patchType !== SANITY_PATCH_TYPE)
    throw new Error('Patch is missing "patchType" - import and use the patch method helpers from "sanity/form"');
  const matchPath = arrayToJSONMatchPath(patch2.path || []);
  if (patch2.type === "insert") {
    const {
      position,
      items
    } = patch2;
    return {
      insert: {
        [position]: matchPath,
        items
      }
    };
  }
  if (patch2.type === "unset")
    return {
      unset: [matchPath]
    };
  if (!patch2.type)
    throw new Error(`Missing patch type in patch ${JSON.stringify(patch2)}`);
  return matchPath ? {
    [patch2.type]: {
      [matchPath]: patch2.value
    }
  } : {
    [patch2.type]: patch2.value
  };
}
const TransformPatches = memo(function(props2) {
  const $ = c(9), {
    transform
  } = props2, callbacks = useFormCallbacks();
  let t0;
  $[0] !== callbacks || $[1] !== transform ? (t0 = (patchEvent) => {
    const patches = patchEvent.patches, transformedPatches = transform(patches);
    callbacks.onChange(PatchEvent.from(transformedPatches));
  }, $[0] = callbacks, $[1] = transform, $[2] = t0) : t0 = $[2];
  const handleChange = t0;
  let t1;
  $[3] !== callbacks || $[4] !== handleChange ? (t1 = {
    ...callbacks,
    onChange: handleChange
  }, $[3] = callbacks, $[4] = handleChange, $[5] = t1) : t1 = $[5];
  const contextValue = t1;
  let t2;
  return $[6] !== contextValue || $[7] !== props2.children ? (t2 = /* @__PURE__ */ jsx(FormCallbacksContext.Provider, { value: contextValue, children: props2.children }), $[6] = contextValue, $[7] = props2.children, $[8] = t2) : t2 = $[8], t2;
});
function useLinkAssets(t0) {
  const $ = c(7), {
    schemaType
  } = t0, mediaLibraryIds = useMediaLibraryIds();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    apiVersion: DEFAULT_API_VERSION
  }, $[0] = t1) : t1 = $[0];
  const client = useClient(t1);
  let t2;
  $[1] !== client || $[2] !== mediaLibraryIds || $[3] !== schemaType ? (t2 = (assetSelection) => {
    if (!mediaLibraryIds?.libraryId)
      throw new Error("No libraryId found");
    const metadataPropsFromSchema = schemaType && isImageSchemaType(schemaType) ? schemaType.options?.metadata : void 0;
    if (isVideoSchemaType(schemaType))
      return firstValueFrom(from(assetSelection).pipe(map$1((asset) => ({
        kind: "assetDocumentId",
        value: asset.asset._id,
        mediaLibraryProps: {
          mediaLibraryId: mediaLibraryIds.libraryId,
          assetId: asset.asset._id,
          assetInstanceId: asset.assetInstanceId
        }
      })), toArray$2()), {
        defaultValue: []
      });
    const assetsFromSource = from(assetSelection).pipe(linkAsset({
      client,
      mediaLibraryId: mediaLibraryIds.libraryId,
      metadataPropsFromSchema
    }), toArray$2());
    return firstValueFrom(assetsFromSource, {
      defaultValue: []
    });
  }, $[1] = client, $[2] = mediaLibraryIds, $[3] = schemaType, $[4] = t2) : t2 = $[4];
  const handleLinkAssets = t2;
  let t3;
  return $[5] !== handleLinkAssets ? (t3 = {
    onLinkAssets: handleLinkAssets
  }, $[5] = handleLinkAssets, $[6] = t3) : t3 = $[6], t3;
}
function linkAsset({
  client,
  mediaLibraryId,
  metadataPropsFromSchema
}) {
  return mergeMap$1((asset) => client.observable.request({
    method: "POST",
    url: `/assets/media-library-link/${client.config().dataset}?${metadataPropsFromSchema?.map((prop) => `meta[]=${prop}`).join("&") || ""}`,
    withCredentials: !0,
    body: {
      mediaLibraryId,
      assetInstanceId: asset.assetInstanceId,
      assetId: asset.asset._id
    },
    tag: "media-library.link-asset"
  }).pipe(retry({
    count: 10,
    delay(error) {
      if (isAssetUnreadyError(error))
        return timer(2e3);
      throw error;
    }
  }), map$1(({
    document: document2
  }) => ({
    kind: "assetDocumentId",
    value: document2._id,
    mediaLibraryProps: {
      mediaLibraryId,
      assetId: asset.asset._id,
      assetInstanceId: asset.assetInstanceId
    }
  })), delay$1(1e3)), 5);
}
function isAssetUnreadyError(maybeError) {
  const isUnprocessable = get(maybeError, ["statusCode"]) === 422, isUnready = get(maybeError, ["response", "body", "message"]) === "Media library asset is not ready";
  return isUnprocessable && isUnready;
}
function filterMediaValidationMarkers(validationMarkers) {
  return validationMarkers.filter((marker) => "__internal_metadata" in marker && typeof marker.__internal_metadata == "object" && marker.__internal_metadata !== null && "name" in marker.__internal_metadata && marker.__internal_metadata?.name === "media");
}
function SelectAssetsDialog(props2) {
  const $ = c(71), theme = useTheme(), {
    t
  } = useTranslation(), {
    dark
  } = theme.sanity.color, mediaLibraryIds = useMediaLibraryIds(), mediaLibraryConfig = useSanityMediaLibraryConfig(), appHost = mediaLibraryConfig.__internal.hosts.app, authType = useAuthType(), {
    dialogHeaderTitle,
    onClose,
    open,
    onSelect,
    selectionType: t0,
    ref,
    selectAssetType,
    schemaType
  } = props2, selectionType = t0 === void 0 ? "single" : t0, toast = useToast(), [assetSelection, setAssetSelection] = useState(props2.selection), [didSelect, setDidSelect] = useState(!1);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[0] = t1) : t1 = $[0];
  const [validation2, setValidation] = useState(t1);
  let t2;
  $[1] !== mediaLibraryConfig.__internal.apiVersion ? (t2 = {
    apiVersion: mediaLibraryConfig.__internal.apiVersion
  }, $[1] = mediaLibraryConfig.__internal.apiVersion, $[2] = t2) : t2 = $[2];
  const client = useClient(t2), workspace = useWorkspace(), schema2 = useSchema();
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = [], $[3] = t3) : t3 = $[3];
  const document2 = useFormValue(t3);
  let t4;
  $[4] !== client || $[5] !== document2 || $[6] !== mediaLibraryIds?.libraryId || $[7] !== schema2 || $[8] !== schemaType || $[9] !== workspace.i18n ? (t4 = async (assetSelectionItem) => {
    const value = {
      _type: "mainImage",
      media: {
        _ref: `media-library:${mediaLibraryIds?.libraryId}:${assetSelectionItem.asset._id}`,
        _type: "globalDocumentReference",
        _weak: !0
      }
    }, result = await validateItem({
      value,
      getClient: () => client,
      path: [],
      schema: schema2,
      type: schemaType,
      parent: document2,
      i18n: workspace.i18n,
      environment: "studio",
      document: document2,
      getDocumentExists: _temp$1o
    });
    return filterMediaValidationMarkers(result);
  }, $[4] = client, $[5] = document2, $[6] = mediaLibraryIds?.libraryId, $[7] = schema2, $[8] = schemaType, $[9] = workspace.i18n, $[10] = t4) : t4 = $[10];
  const validateSelection = t4;
  let t5;
  $[11] !== schemaType?.options?.mediaLibrary?.filters ? (t5 = schemaType?.options?.mediaLibrary?.filters || [], $[11] = schemaType?.options?.mediaLibrary?.filters, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== t5 ? (t6 = t5.map(_temp2$y), $[13] = t5, $[14] = t6) : t6 = $[14];
  const pluginFilters = t6;
  let t7;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    privateAssets: !0
  }, $[15] = t7) : t7 = $[15];
  const t8 = dark ? "dark" : "light";
  let t9;
  $[16] !== selectAssetType ? (t9 = selectAssetType ? [selectAssetType] : [], $[16] = selectAssetType, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== authType || $[19] !== pluginFilters || $[20] !== selectionType || $[21] !== t8 || $[22] !== t9 ? (t10 = {
    auth: authType,
    capabilities: t7,
    pluginFilters,
    scheme: t8,
    selectAssetTypes: t9,
    selectionType
  }, $[18] = authType, $[19] = pluginFilters, $[20] = selectionType, $[21] = t8, $[22] = t9, $[23] = t10) : t10 = $[23];
  const iframeUrl = usePluginFrameUrl("/assets", t10);
  let t11;
  $[24] !== schemaType ? (t11 = {
    schemaType
  }, $[24] = schemaType, $[25] = t11) : t11 = $[25];
  const {
    onLinkAssets
  } = useLinkAssets(t11);
  let t12;
  $[26] !== assetSelection || $[27] !== onClose || $[28] !== onLinkAssets || $[29] !== onSelect || $[30] !== t || $[31] !== toast ? (t12 = async () => {
    try {
      setDidSelect(!0);
      const assets = await onLinkAssets([assetSelection[0]]);
      onSelect(assets), onClose();
    } catch (t132) {
      const error = t132;
      toast.push({
        closable: !0,
        status: "error",
        id: "insert-asset-error",
        title: t("asset-source.dialog.insert-asset-error")
      }), console.error(error), setDidSelect(!1);
    }
  }, $[26] = assetSelection, $[27] = onClose, $[28] = onLinkAssets, $[29] = onSelect, $[30] = t, $[31] = toast, $[32] = t12) : t12 = $[32];
  const handleSelect = t12;
  let t13;
  $[33] !== onClose ? (t13 = () => {
    onClose();
  }, $[33] = onClose, $[34] = t13) : t13 = $[34];
  const handleClose = t13;
  let t14;
  $[35] !== validateSelection ? (t14 = async (assetSelectionItems) => {
    if (assetSelectionItems.length === 0) {
      setValidation([]);
      return;
    }
    const validationResult = await validateSelection(assetSelectionItems[0]);
    validationResult.some(_temp3$i) && setValidation(validationResult);
  }, $[35] = validateSelection, $[36] = t14) : t14 = $[36];
  const handleAssetSelection = t14;
  let t15;
  $[37] !== handleAssetSelection ? (t15 = (message) => {
    message.type === "assetSelection" && (setAssetSelection(message.selection), handleAssetSelection(message.selection));
  }, $[37] = handleAssetSelection, $[38] = t15) : t15 = $[38];
  const handlePluginMessage = t15, {
    setIframe
  } = usePluginPostMessage(appHost, handlePluginMessage);
  if (!open)
    return null;
  let t16;
  $[39] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = {
    position: "relative",
    minHeight: "2dvh"
  }, $[39] = t16) : t16 = $[39];
  let t17;
  $[40] !== validation2 ? (t17 = validation2.length > 0 && /* @__PURE__ */ jsx(FormFieldValidationStatus, { fontSize: 2, placement: "top", validation: validation2 }), $[40] = validation2, $[41] = t17) : t17 = $[41];
  let t18;
  $[42] !== t ? (t18 = t("asset-source.dialog.button.cancel"), $[42] = t, $[43] = t18) : t18 = $[43];
  let t19;
  $[44] !== handleClose || $[45] !== t18 ? (t19 = /* @__PURE__ */ jsx(Button, { mode: "bleed", onClick: handleClose, text: t18, size: "large" }), $[44] = handleClose, $[45] = t18, $[46] = t19) : t19 = $[46];
  let t20;
  $[47] !== assetSelection.length || $[48] !== validation2 ? (t20 = assetSelection.length === 0 || validation2.some(_temp4$8), $[47] = assetSelection.length, $[48] = validation2, $[49] = t20) : t20 = $[49];
  let t21;
  $[50] !== t ? (t21 = t("asset-source.dialog.button.select"), $[50] = t, $[51] = t21) : t21 = $[51];
  let t22;
  $[52] !== didSelect || $[53] !== handleSelect || $[54] !== t20 || $[55] !== t21 ? (t22 = /* @__PURE__ */ jsx(Button, { onClick: handleSelect, loading: didSelect, disabled: t20, text: t21, size: "large", tone: "primary" }), $[52] = didSelect, $[53] = handleSelect, $[54] = t20, $[55] = t21, $[56] = t22) : t22 = $[56];
  let t23;
  $[57] !== t17 || $[58] !== t19 || $[59] !== t22 ? (t23 = /* @__PURE__ */ jsx(Card, { width: "full", height: "fill", padding: 3, shadow: 1, style: t16, children: /* @__PURE__ */ jsx(Flex, { width: "full", gap: 3, justify: "flex-end", children: /* @__PURE__ */ jsxs(Flex, { width: "full", gap: 2, justify: "flex-end", align: "center", children: [
    t17,
    t19,
    t22
  ] }) }) }), $[57] = t17, $[58] = t19, $[59] = t22, $[60] = t23) : t23 = $[60];
  let t24;
  $[61] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t24 = {
    position: "absolute",
    inset: 0,
    borderTop: "1px solid",
    borderColor: "var(--card-border-color)",
    overflow: "hidden",
    display: "flex"
  }, $[61] = t24) : t24 = $[61];
  let t25;
  $[62] !== iframeUrl || $[63] !== setIframe ? (t25 = /* @__PURE__ */ jsx(Box, { style: t24, children: /* @__PURE__ */ jsx(Iframe, { ref: setIframe, src: iframeUrl }) }), $[62] = iframeUrl, $[63] = setIframe, $[64] = t25) : t25 = $[64];
  let t26;
  return $[65] !== dialogHeaderTitle || $[66] !== handleClose || $[67] !== ref || $[68] !== t23 || $[69] !== t25 ? (t26 = /* @__PURE__ */ jsx(AppDialog, { header: dialogHeaderTitle, id: "media-library-plugin-dialog-select-assets", onClose: handleClose, onClickOutside: handleClose, open: !0, ref, "data-testid": "media-library-plugin-dialog-select-assets", width: 3, footer: t23, children: t25 }), $[65] = dialogHeaderTitle, $[66] = handleClose, $[67] = ref, $[68] = t23, $[69] = t25, $[70] = t26) : t26 = $[70], t26;
}
function _temp4$8(marker_0) {
  return marker_0.level === "error";
}
function _temp3$i(marker) {
  return marker.level === "error";
}
function _temp2$y(filter2) {
  return {
    type: "groq",
    name: filter2.name,
    query: filter2.query
  };
}
async function _temp$1o() {
  return !0;
}
function UploadAssetsDialog(props2) {
  const $ = c(25), mediaLibraryIds = useMediaLibraryIds(), {
    schemaType
  } = props2;
  let t0;
  $[0] !== schemaType ? (t0 = {
    schemaType
  }, $[0] = schemaType, $[1] = t0) : t0 = $[1];
  const {
    onLinkAssets
  } = useLinkAssets(t0), {
    open,
    onSelect,
    onClose,
    uploader
  } = props2, pluginConfig = useSanityMediaLibraryConfig(), authType = useAuthType(), toast = useToast(), {
    t
  } = useTranslation(), appHost = pluginConfig.__internal.hosts.app, appBasePath = pluginConfig.__internal.appBasePath, iframeUrl = `${appHost}${appBasePath}/plugin/v1/library/${mediaLibraryIds?.libraryId}/upload?auth=${authType}`, uploaderRef = useRef(null), [pageReadyForUploads, setPageReadyForUploads] = useState(!1);
  let t1;
  $[2] !== onClose || $[3] !== onLinkAssets || $[4] !== onSelect || $[5] !== t || $[6] !== toast ? (t1 = async (uploadedAssets) => {
    try {
      const assets = await onLinkAssets(uploadedAssets);
      onSelect(assets), onClose();
    } catch (t22) {
      const error = t22;
      toast.push({
        closable: !0,
        status: "error",
        id: "insert-asset-error",
        title: t("asset-source.dialog.insert-asset-error")
      }), console.error(error);
    }
  }, $[2] = onClose, $[3] = onLinkAssets, $[4] = onSelect, $[5] = t, $[6] = toast, $[7] = t1) : t1 = $[7];
  const handleUploaded = t1;
  let t2;
  $[8] !== handleUploaded || $[9] !== open || $[10] !== t || $[11] !== toast || $[12] !== uploader ? (t2 = (message) => {
    open && (message.type === "pageLoaded" && message.page === "upload" && setPageReadyForUploads(!0), message.type === "pageUnloaded" && message.page === "upload" && setPageReadyForUploads(!1), message.type === "uploadProgress" && uploader && message.files.forEach((t32) => {
      const {
        id: id2,
        status,
        progress,
        error: error_0
      } = t32;
      if (status === "alreadyExists") {
        const file = uploader.getFiles().find((f) => f.id === id2);
        file && toast.push({
          status: "warning",
          title: t("asset-sources.media-library.warning.file-already-exist.title", {
            filename: file.file.name
          }),
          description: t("asset-sources.media-library.warning.file-already-exist.description"),
          closable: !0,
          duration: 1e4
        });
      }
      uploader.updateFile(id2, {
        status,
        progress,
        error: error_0
      });
    }), message.type === "uploadResponse" && uploader && handleUploaded(message.assets).then(() => {
      "signalCompletion" in uploader && typeof uploader.signalCompletion == "function" && uploader.signalCompletion();
    }));
  }, $[8] = handleUploaded, $[9] = open, $[10] = t, $[11] = toast, $[12] = uploader, $[13] = t2) : t2 = $[13];
  const handlePluginMessage = t2, {
    postMessage,
    setIframe
  } = usePluginPostMessage(appHost, handlePluginMessage);
  let t3, t4;
  if ($[14] !== open || $[15] !== pageReadyForUploads || $[16] !== postMessage || $[17] !== t || $[18] !== toast || $[19] !== uploader ? (t3 = () => {
    if (open && uploader) {
      pageReadyForUploads && uploader.getFiles().length > 0 && uploader.getFiles().every(_temp$1n) && (postMessage({
        type: "uploadRequest",
        files: uploader.getFiles()
      }), setPageReadyForUploads(!1));
      const subscribe2 = () => uploader.subscribe((event) => {
        event.type === "all-complete" && event.files.filter(_temp2$x).forEach((file_2) => {
          toast.push({
            status: "warning",
            title: t("asset-sources.media-library.warning.file-already-exist.title", {
              filename: file_2.file.name
            }),
            description: t("asset-sources.media-library.warning.file-already-exist.description"),
            closable: !0,
            duration: 1e4
          });
        }), event.type === "status" && event.status === "aborted" && postMessage({
          type: "abortUploadRequest",
          files: [{
            id: event.file.id
          }]
        });
      });
      return uploaderRef.current = {
        uploader,
        unsubscribe: subscribe2()
      }, uploaderRef.current.unsubscribe;
    }
    return uploaderRef.current?.unsubscribe();
  }, t4 = [open, pageReadyForUploads, postMessage, t, toast, uploader, uploaderRef], $[14] = open, $[15] = pageReadyForUploads, $[16] = postMessage, $[17] = t, $[18] = toast, $[19] = uploader, $[20] = t3, $[21] = t4) : (t3 = $[20], t4 = $[21]), useEffect(t3, t4), !open)
    return null;
  let t5;
  return $[22] !== iframeUrl || $[23] !== setIframe ? (t5 = /* @__PURE__ */ jsx(Iframe, { ref: setIframe, src: iframeUrl, hidden: !0 }), $[22] = iframeUrl, $[23] = setIframe, $[24] = t5) : t5 = $[24], t5;
}
function _temp2$x(file_1) {
  return file_1.status === "alreadyExists";
}
function _temp$1n(file_0) {
  return file_0.status === "pending";
}
const MediaLibraryAssetSourceComponent = function(props2, ref) {
  const $ = c(41), {
    action: t0,
    assetToOpen,
    assetType: t1,
    dialogHeaderTitle,
    libraryId: libraryIdProp,
    onChangeAction,
    onClose,
    onSelect,
    schemaType,
    uploader
  } = props2, action = t0 === void 0 ? "select" : t0, assetType = t1 === void 0 ? "image" : t1, {
    t
  } = useTranslation();
  let t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    apiVersion: DEFAULT_API_VERSION
  }, $[0] = t2) : t2 = $[0];
  const client = useClient(t2);
  let t3;
  $[1] !== client ? (t3 = client.config(), $[1] = client, $[2] = t3) : t3 = $[2];
  const projectId = t3.projectId, portalElement = useRootPortalElement();
  let t4;
  $[3] !== onChangeAction ? (t4 = () => {
    onChangeAction && onChangeAction("select");
  }, $[3] = onChangeAction, $[4] = t4) : t4 = $[4];
  const handleSelectNewAsset = t4;
  if (!projectId)
    throw new Error("No projectId found");
  const selectAssetType = assetType === "sanity.video" ? "video" : assetType, t5 = action === "upload";
  let t6;
  $[5] !== onClose || $[6] !== onSelect || $[7] !== schemaType || $[8] !== t5 || $[9] !== uploader ? (t6 = /* @__PURE__ */ jsx(UploadAssetsDialog, { open: t5, onClose, onSelect, schemaType, uploader }), $[5] = onClose, $[6] = onSelect, $[7] = schemaType, $[8] = t5, $[9] = uploader, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== dialogHeaderTitle || $[12] !== schemaType?.title || $[13] !== selectAssetType || $[14] !== t ? (t7 = dialogHeaderTitle || t("asset-sources.media-library.select-dialog.title", {
    context: selectAssetType,
    targetTitle: schemaType?.title
  }), $[11] = dialogHeaderTitle, $[12] = schemaType?.title, $[13] = selectAssetType, $[14] = t, $[15] = t7) : t7 = $[15];
  const t8 = action === "select";
  let t9;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = [], $[16] = t9) : t9 = $[16];
  let t10;
  $[17] !== onClose || $[18] !== onSelect || $[19] !== ref || $[20] !== schemaType || $[21] !== selectAssetType || $[22] !== t7 || $[23] !== t8 ? (t10 = /* @__PURE__ */ jsx(SelectAssetsDialog, { dialogHeaderTitle: t7, open: t8, ref, onClose, onSelect, selection: t9, schemaType, selectAssetType }), $[17] = onClose, $[18] = onSelect, $[19] = ref, $[20] = schemaType, $[21] = selectAssetType, $[22] = t7, $[23] = t8, $[24] = t10) : t10 = $[24];
  let t11;
  $[25] !== action || $[26] !== assetToOpen || $[27] !== handleSelectNewAsset || $[28] !== onClose || $[29] !== schemaType || $[30] !== t ? (t11 = action === "openInSource" && assetToOpen && /* @__PURE__ */ jsx(OpenInSourceDialog, { asset: assetToOpen, dialogHeaderTitle: t("asset-sources.media-library.open-in-source-dialog.title"), selectNewAssetButtonLabel: schemaType?.title ? t("asset-sources.media-library.open-in-source-dialog.button.select-new-asset", {
    targetTitle: schemaType.title
  }) : t("asset-sources.media-library.open-in-source-dialog.button.select-new-asset-fallback"), onClose, onSelectNewAsset: handleSelectNewAsset }), $[25] = action, $[26] = assetToOpen, $[27] = handleSelectNewAsset, $[28] = onClose, $[29] = schemaType, $[30] = t, $[31] = t11) : t11 = $[31];
  let t12;
  $[32] !== portalElement || $[33] !== t10 || $[34] !== t11 ? (t12 = /* @__PURE__ */ jsxs(PortalProvider, { element: portalElement, children: [
    t10,
    t11
  ] }), $[32] = portalElement, $[33] = t10, $[34] = t11, $[35] = t12) : t12 = $[35];
  let t13;
  return $[36] !== libraryIdProp || $[37] !== projectId || $[38] !== t12 || $[39] !== t6 ? (t13 = /* @__PURE__ */ jsxs(MediaLibraryProvider, { projectId, libraryId: libraryIdProp, children: [
    t6,
    t12
  ] }), $[36] = libraryIdProp, $[37] = projectId, $[38] = t12, $[39] = t6, $[40] = t13) : t13 = $[40], t13;
}, MediaLibraryAssetSource = memo(forwardRef(MediaLibraryAssetSourceComponent)), useRootPortalElement = () => {
  const $ = c(3), [container] = useState(_temp$1m);
  let t0, t1;
  return $[0] !== container ? (t0 = () => (container.classList.add("media-library-portal"), document.body.appendChild(container), () => {
    document.body.removeChild(container);
  }), t1 = [container], $[0] = container, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1), container;
};
function _temp$1m() {
  return document.createElement("div");
}
const DEFERRED_TERMINAL_STATUSES = ["complete", "alreadyExists"];
class MediaLibraryUploader {
  files = [];
  subscribers = /* @__PURE__ */ new Set();
  deferredUpdates = /* @__PURE__ */ new Map();
  checkAllComplete() {
    this.files.length > 0 && this.files.every((file) => ["complete", "error", "aborted", "alreadyExists"].includes(file.status)) && (this.files.some((file) => file.status === "error") && this.emit({
      type: "error",
      files: this.files.filter((file) => file.status === "error")
    }), this.emit({
      type: "all-complete",
      files: this.files
    }), this.reset());
  }
  emit(event) {
    this.subscribers.forEach((fn) => fn(event));
  }
  /**
   * Emit all-complete after applying any deferred terminal status updates.
   * Call this when uploadResponse is received so all-complete fires after the
   * asset source has the data it needs, avoiding unmount before postMessage arrives.
   */
  signalCompletion() {
    this.deferredUpdates.forEach(({
      status,
      progress,
      error
    }, fileId) => {
      const target = this.files.find((f) => f.id === fileId);
      target && (error && (target.error = error), progress !== void 0 && (target.progress = progress), target.status = status);
    }), this.deferredUpdates.clear(), this.checkAllComplete();
  }
  upload(files) {
    for (const file of files) {
      const uploadFile2 = {
        id: uuid(),
        file,
        progress: 0,
        status: "pending"
      };
      this.files.push(uploadFile2);
    }
    return this.files;
  }
  abort(file) {
    if (file) {
      const target = this.files.find((f) => f.id === file.id);
      target && ["pending", "uploading"].includes(target.status) && this.updateFile(target.id, {
        status: "aborted"
      });
    } else
      for (const target of this.files)
        ["pending", "uploading"].includes(target.status) && this.updateFile(target.id, {
          status: "aborted"
        });
    this.emit({
      type: "abort",
      files: this.files.filter((abortedFile) => abortedFile.status === "aborted")
    }), this.checkAllComplete();
  }
  updateFile(fileId, data) {
    const target = this.files.find((f) => f.id === fileId);
    if (target) {
      if (data.error && (target.error = data.error), data.progress !== void 0 && data.progress !== target.progress && (target.progress = data.progress, this.emit({
        type: "progress",
        file: target,
        progress: target.progress * 100
      })), data.status && data.status !== target.status) {
        if (DEFERRED_TERMINAL_STATUSES.includes(data.status)) {
          this.deferredUpdates.set(fileId, {
            status: data.status,
            progress: data.progress,
            error: data.error
          });
          return;
        }
        target.status = data.status, this.emit({
          type: "status",
          file: target,
          status: target.status
        });
      }
      this.checkAllComplete();
    }
  }
  subscribe(subscriber) {
    this.subscribers.add(subscriber);
    for (const file of this.files)
      subscriber({
        type: "status",
        file,
        status: file.status
      }), subscriber({
        type: "progress",
        file,
        progress: file.progress
      });
    return this.checkAllComplete(), () => {
      this.subscribers.delete(subscriber);
    };
  }
  getFiles() {
    return this.files;
  }
  reset() {
    this.files = [], this.deferredUpdates.clear();
  }
}
const sourceName$1 = "sanity-media-library";
function openInSource(asset) {
  return asset.source?.name === sourceName$1 ? {
    type: "component"
  } : !1;
}
function createSanityMediaLibraryImageSource(props2) {
  return {
    name: props2.name || sourceName$1,
    i18nKey: props2.i18nKey || "asset-sources.media-library.image.title",
    component: (sourceProps) => /* @__PURE__ */ jsx(MediaLibraryAssetSource, { ...sourceProps, libraryId: props2.libraryId }),
    icon: props2.icon || ImageIcon,
    Uploader: MediaLibraryUploader,
    openInSource
  };
}
function createSanityMediaLibraryFileSource(props2) {
  return {
    name: props2.name || sourceName$1,
    i18nKey: props2.i18nKey || "asset-sources.media-library.file.title",
    component: (sourceProps) => /* @__PURE__ */ jsx(MediaLibraryAssetSource, { ...sourceProps, libraryId: props2.libraryId }),
    icon: props2.icon || DocumentIcon,
    Uploader: MediaLibraryUploader,
    openInSource
  };
}
class ConfigPropertyError extends Error {
  constructor({
    propertyName,
    path,
    cause
  }) {
    const message = isRecord$4(cause) && typeof cause?.message == "string" ? `: ${cause.message}` : "";
    super(`An error occurred while resolving \`${propertyName}\` from ${path.join(" > ")}${message}`), this.name = "ConfigPropertyError", this.propertyName = propertyName, this.cause = cause, this.path = path;
  }
}
class ConfigResolutionError extends Error {
  constructor({
    causes,
    name,
    type
  }) {
    const messages = causes.filter(Boolean).map((cause) => isRecord$4(cause) && typeof cause?.message == "string" ? cause.message : String(cause));
    super(`Could not resolve ${type}${name ? ` \`${name}\`` : ""}:
${messages.map((message) => `	- ${message}`).join(`
`)}

`), this.name = name, this.causes = causes, this.type = type;
  }
}
function pseudoRandomNumber(seed) {
  const hashCode = seed.split("").reduce((prevHash, currVal) => (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0, 0);
  return Math.abs(hashCode * 16807 % 2147483647) / 2147483647;
}
const possibleTints = ["300", "400", "500", "600", "700"];
function DefaultIcon(t0) {
  const $ = c(22), {
    title,
    subtitle
  } = t0, theme = useTheme$1(), fontFamily = theme.sanity.fonts.text.family, fontWeight = theme.sanity.fonts.text.weights.medium, fontSize = `${theme.sanity.fonts.text.sizes[1].fontSize}px`;
  let t1;
  $[0] !== subtitle || $[1] !== title ? (t1 = () => pseudoRandomNumber(`${title} ${subtitle}`), $[0] = subtitle, $[1] = title, $[2] = t1) : t1 = $[2];
  const [rng1] = useState(t1), huesWithoutGray = COLOR_HUES.filter(_temp$1l), colorHue = huesWithoutGray[Math.floor(rng1 * huesWithoutGray.length)];
  let t2;
  $[3] !== rng1 ? (t2 = () => pseudoRandomNumber(rng1.toString()), $[3] = rng1, $[4] = t2) : t2 = $[4];
  const [rng2] = useState(t2), tint = possibleTints[Math.floor(rng2 * possibleTints.length)], color = hues[colorHue][tint].hex;
  let t3;
  $[5] !== title ? (t3 = title.split(/\s/g).map(_temp2$w).filter(Boolean).slice(0, 2).map(_temp3$h), $[5] = title, $[6] = t3) : t3 = $[6];
  const letters = t3;
  let t4;
  if ($[7] !== color) {
    const darkened = darken(color, 0.4), lightened = lighten(color, 0.4);
    t4 = hasBadContrast(color, "readable", darkened) ? hasBadContrast(color, "readable", lightened) ? readableColor(color) : lightened : darkened, $[7] = color, $[8] = t4;
  } else
    t4 = $[8];
  const textColor = t4;
  let t5;
  $[9] !== color ? (t5 = /* @__PURE__ */ jsx("rect", { width: 32, height: 32, rx: 2, fill: color }), $[9] = color, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== fontFamily || $[12] !== fontSize || $[13] !== fontWeight ? (t6 = {
    fontFamily,
    fontWeight,
    fontSize,
    transform: "translateY(1px)"
  }, $[11] = fontFamily, $[12] = fontSize, $[13] = fontWeight, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== letters || $[16] !== t6 || $[17] !== textColor ? (t7 = /* @__PURE__ */ jsx("text", { x: "50%", y: "50%", textAnchor: "middle", alignmentBaseline: "middle", dominantBaseline: "middle", fill: textColor, style: t6, children: letters }), $[15] = letters, $[16] = t6, $[17] = textColor, $[18] = t7) : t7 = $[18];
  let t8;
  return $[19] !== t5 || $[20] !== t7 ? (t8 = /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", children: [
    t5,
    t7
  ] }), $[19] = t5, $[20] = t7, $[21] = t8) : t8 = $[21], t8;
}
function _temp3$h(i) {
  return [...i][0]?.toUpperCase() ?? "";
}
function _temp2$w(word) {
  return word.replace(/[^\p{L}\p{N}]/gu, "");
}
function _temp$1l(hue) {
  return hue !== "gray";
}
function createDefaultIcon(title, subtitle) {
  return /* @__PURE__ */ jsx(DefaultIcon, { title, subtitle });
}
function defineConfig(config) {
  return config;
}
function createConfig(config) {
  return config;
}
const SANITY_DEFINED_ACTIONS = {
  delete: "delete",
  discardChanges: "discardChanges",
  discardVersion: "discardVersion",
  duplicate: "duplicate",
  restore: "restore",
  publish: "publish",
  unpublish: "unpublish",
  unpublishVersion: "unpublishVersion",
  linkToCanvas: "linkToCanvas",
  editInCanvas: "editInCanvas",
  unlinkFromCanvas: "unlinkFromCanvas",
  schedule: "schedule"
}, isSanityDefinedAction = (action) => action.action ? SANITY_DEFINED_ACTIONS[action.action] !== void 0 : !1;
function defineDocumentFieldAction(fieldAction) {
  return fieldAction;
}
const copyAction = {
  name: "copyField",
  useAction({
    path
  }) {
    const getFormValue = useGetFormValue(), {
      onCopy
    } = useCopyPaste(), {
      t
    } = useTranslation("copy-paste"), isDocument = path.length === 0, documentTitle = t("copy-paste.field-action-copy-button.document.title"), fieldTitle = t("copy-paste.field-action-copy-button.field.title"), title = isDocument ? documentTitle : fieldTitle, onAction = useCallback(() => {
      const value = getFormValue([]);
      onCopy(path, value, {
        context: {
          source: isDocument ? "documentFieldAction" : "fieldAction"
        }
      });
    }, [path, isDocument, onCopy, getFormValue]);
    return {
      type: "action",
      icon: CopyIcon,
      onAction,
      title
    };
  }
}, pasteAction = {
  name: "pasteField",
  useAction({
    path
  }) {
    const {
      t
    } = useTranslation("copy-paste"), getFormValue = useGetFormValue(), isDocument = path.length === 0, documentTitle = t("copy-paste.field-action-paste-button.document.title"), fieldTitle = t("copy-paste.field-action-paste-button.field.title"), title = isDocument ? documentTitle : fieldTitle, {
      onPaste
    } = useCopyPaste(), onAction = useCallback(() => {
      const value = getFormValue([]);
      onPaste(path, value, {
        context: {
          source: isDocument ? "documentFieldAction" : "fieldAction"
        }
      });
    }, [getFormValue, onPaste, path, isDocument]);
    return {
      type: "action",
      icon: ClipboardIcon,
      onAction,
      title
    };
  }
}, documentFieldActionsReducer = (prev, {
  document: document2
}, context) => {
  const documentFieldActions = document2?.unstable_fieldActions;
  if (!documentFieldActions) return prev;
  if (typeof documentFieldActions == "function") return documentFieldActions(prev, context);
  if (Array.isArray(documentFieldActions)) return [...prev, ...documentFieldActions];
  throw new Error(`Expected \`document.unstable_fieldActions\` to be an array or a function, but received ${typeof documentFieldActions}`);
}, initialDocumentFieldActions = [copyAction, pasteAction];
function defineDocumentInspector(inspector) {
  return inspector;
}
function SchedulePublishingStudioLayout$1(props2) {
  const $ = c(5), toast = useToast();
  let t0, t1;
  $[0] !== toast ? (t0 = () => {
    console.error(`Scheduled publishing plugin is added by default, please remove this plugin from your config. 
        
If you have a custom date config, you can use the scheduledPublishing API to customize the date input.
        
See: https://www.sanity.io/docs/scheduled-publishing.
        `), toast.push({
      id: "scheduled-publishing-deprecated",
      closable: !0,
      duration: 6e4,
      status: "error",
      title: "Scheduled publishing plugin is deprecated",
      description: "The scheduled publishing plugin is now deprecated, you should remove the plugin from your configuration. If you have a custom date config, you can use the scheduledPublishing API to customize the date input. See: https://www.sanity.io/docs/scheduled-publishing."
    });
  }, t1 = [toast], $[0] = toast, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  return $[3] !== props2 ? (t2 = props2.renderDefault(props2), $[3] = props2, $[4] = t2) : t2 = $[4], t2;
}
const deprecatedScheduledPublishingPlugin = definePlugin({
  name: "sanity/deprecated/scheduled-publishing",
  studio: {
    components: {
      layout: SchedulePublishingStudioLayout$1
    }
  }
}), DEPRECATED_PLUGINS = [
  // Scheduled publishing is added by default, we are filtering to avoid duplicates
  "scheduled-publishing"
], flattenConfig = ({
  plugins = [],
  ...currentConfig
}, path) => {
  const rootConfig = {
    config: currentConfig,
    path: [...path, currentConfig.name]
  }, allPlugins = plugins.flatMap((plugin) => flattenConfig(plugin, [...path, currentConfig.name])), deprecatedScheduledPublishing = allPlugins.find((p) => p.config.name === "scheduled-publishing");
  return deprecatedScheduledPublishing && allPlugins.push({
    path: deprecatedScheduledPublishing.path,
    config: deprecatedScheduledPublishingPlugin()
  }), [...allPlugins.filter((plugin) => !DEPRECATED_PLUGINS.includes(plugin.config.name)), rootConfig];
}, DECISION_PARAMETERS_SCHEMA = /* @__PURE__ */ Symbol("__decisionParametersSchema"), initialDocumentBadges = [], initialDocumentActions = [], initialLanguageFilter = [], schemaTypesReducer = (prev, {
  schema: schema2
}, context) => {
  const schemaTypes = schema2?.types;
  if (!schemaTypes) return prev;
  if (typeof schemaTypes == "function") return schemaTypes(prev, context);
  if (Array.isArray(schemaTypes)) return [...prev, ...schemaTypes];
  throw new Error(`Expected \`schema.types\` to be an array or a function, but received ${getPrintableType(schemaTypes)}`);
}, resolveProductionUrlReducer = async (prev, {
  document: document2
}, context) => {
  const resolveProductionUrl = document2?.productionUrl;
  return resolveProductionUrl ? await resolveProductionUrl(prev, context) : prev;
}, toolsReducer = (prev, {
  tools
}, context) => {
  if (!tools) return prev;
  if (typeof tools == "function") return tools(prev, context);
  if (Array.isArray(tools)) return [...prev, ...tools];
  throw new Error(`Expected \`tools\` to be an array or a function, but received ${getPrintableType(tools)}`);
}, schemaTemplatesReducer = (prev, {
  schema: schema2
}, context) => {
  const schemaTemplates = schema2?.templates;
  if (!schemaTemplates) return prev;
  if (typeof schemaTemplates == "function") return schemaTemplates(prev, context);
  if (Array.isArray(schemaTemplates)) return [...prev, ...schemaTemplates];
  throw new Error(`Expected \`schema.templates\` to be an array or a function, but received ${getPrintableType(schemaTemplates)}`);
}, localeDefReducer = (prev, {
  i18n
}, context) => {
  const locales = i18n?.locales;
  if (!locales) return prev;
  if (typeof locales == "function") return locales(prev, context);
  if (Array.isArray(locales)) return [...prev, ...locales];
  throw new Error(`Expected \`i18n.locales\` to be an array or a function, but received ${getPrintableType(locales)}`);
}, localeBundlesReducer = (prev, {
  i18n
}, context) => {
  const bundles = i18n?.bundles;
  if (!bundles) return prev;
  if (Array.isArray(bundles)) return [...prev, ...bundles];
  if (typeof bundles == "function") return bundles(prev, context);
  throw new Error(`Expected \`i18n.bundles\` to be an array or a function, but received ${typeof bundles}`);
}, documentBadgesReducer = (prev, {
  document: document2
}, context) => {
  const documentBadges = document2?.badges;
  if (!documentBadges) return prev;
  if (typeof documentBadges == "function") return documentBadges(prev, context);
  if (Array.isArray(documentBadges)) return [...prev, ...documentBadges];
  throw new Error(`Expected \`document.badges\` to be an array or a function, but received ${getPrintableType(documentBadges)}`);
}, documentActionsReducer = (prev, {
  document: document2
}, context) => {
  const documentActions = document2?.actions;
  if (!documentActions) return prev;
  if (typeof documentActions == "function") return documentActions(prev, context);
  if (Array.isArray(documentActions)) return [...prev, ...documentActions];
  throw new Error(`Expected \`document.actions\` to be an array or a function, but received ${getPrintableType(documentActions)}`);
}, releaseActionsReducer = (prev, {
  releases: releases2
}, context) => {
  const releaseActions = releases2?.actions;
  if (!releaseActions) return prev;
  if (typeof releaseActions == "function") return releaseActions(prev, context);
  if (Array.isArray(releaseActions)) return [...prev, ...releaseActions];
  throw new Error(`Expected \`releases.actions\` to be an array or a function, but received ${getPrintableType(releaseActions)}`);
}, newDocumentOptionsResolver = (prev, {
  document: document2
}, context) => {
  const resolveNewDocumentOptions = document2?.newDocumentOptions;
  if (!resolveNewDocumentOptions) return prev;
  if (typeof resolveNewDocumentOptions != "function")
    throw new Error(`Expected \`document.resolveNewDocumentOptions\` to be a function, but received ${getPrintableType(resolveNewDocumentOptions)}`);
  return resolveNewDocumentOptions(prev, context);
}, fileAssetSourceResolver = (prev, {
  form
}, context) => {
  const assetSources = form?.file?.assetSources;
  if (!assetSources) return prev;
  if (typeof assetSources == "function") return assetSources(prev, context);
  if (Array.isArray(assetSources)) return [...prev, ...assetSources];
  throw new Error(`Expected \`form.file.assetSources\` to be an array or a function, but received ${getPrintableType(assetSources)}`);
}, directUploadsReducer = (opts) => {
  const {
    config,
    schemaTypeName
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.form?.[schemaTypeName]?.directUploads;
    if (!resolver && typeof resolver != "boolean") return acc;
    if (typeof resolver == "boolean") return resolver;
    throw new Error(`Expected \`form.${schemaTypeName}.directUploads\` to be a boolean, but received ${getPrintableType(resolver)}`);
  }, !0);
}, imageAssetSourceResolver = (prev, {
  form
}, context) => {
  const assetSources = form?.image?.assetSources;
  if (!assetSources) return prev;
  if (typeof assetSources == "function") return assetSources(prev, context);
  if (Array.isArray(assetSources)) return [...prev, ...assetSources];
  throw new Error(`Expected \`form.image.assetSources\` to be an array or a function, but received ${getPrintableType(assetSources)}`);
}, documentLanguageFilterReducer = (prev, {
  document: document2
}, context) => {
  const resolveDocumentLanguageFilter = document2?.unstable_languageFilter;
  if (!resolveDocumentLanguageFilter) return prev;
  if (typeof resolveDocumentLanguageFilter == "function") return resolveDocumentLanguageFilter(prev, context);
  if (Array.isArray(resolveDocumentLanguageFilter)) return [...prev, ...resolveDocumentLanguageFilter];
  throw new Error(`Expected \`document.unstable_languageFilter\` to be an array or a function, but received ${getPrintableType(resolveDocumentLanguageFilter)}`);
}, documentInspectorsReducer = (prev, {
  document: document2
}, context) => {
  const resolveInspectorsFilter = document2?.inspectors;
  if (!resolveInspectorsFilter) return prev;
  if (typeof resolveInspectorsFilter == "function") return resolveInspectorsFilter(prev, context);
  if (Array.isArray(resolveInspectorsFilter)) return [...prev, ...resolveInspectorsFilter];
  throw new Error(`Expected \`document.inspectors\` to be an array or a function, but received ${getPrintableType(resolveInspectorsFilter)}`);
}, documentCommentsEnabledReducer = (opts) => {
  const {
    config,
    context,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.document?.comments?.enabled ?? innerConfig.document?.unstable_comments?.enabled;
    if (!resolver && typeof resolver != "boolean") return acc;
    if (typeof resolver == "function") return resolver(context);
    if (typeof resolver == "boolean") return resolver;
    throw new Error(`Expected \`document.comments.enabled\` to be a boolean or a function, but received ${getPrintableType(resolver)}`);
  }, initialValue);
}, onUncaughtErrorResolver = (opts) => {
  const {
    config,
    context
  } = opts;
  flattenConfig(config, []).forEach(({
    config: pluginConfig
  }) => {
    const resolver = pluginConfig.onUncaughtError;
    if (typeof resolver == "function") return resolver(context.error, context.errorInfo);
    if (resolver)
      throw new Error(`Expected \`document.onUncaughtError\` to be a a function, but received ${getPrintableType(resolver)}`);
  });
}, internalTasksReducer = (opts) => {
  const {
    config
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.__internal_tasks;
    if (!resolver) return acc;
    if (typeof resolver == "object" && resolver.footerAction) return resolver;
    throw new Error(`Expected \`__internal__tasks\` to be an object with footerAction, but received ${getPrintableType(resolver)}`);
  }, void 0);
}, eventsAPIReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    if (innerConfig.beta?.eventsAPI?.enabled)
      throw new Error(`The \`beta.eventsAPI.enabled\` option has been removed. Use \`beta.eventsAPI.${opts.key}\` instead.`);
    const enabled = innerConfig.beta?.eventsAPI?.[opts.key];
    if (typeof enabled > "u") return acc;
    if (typeof enabled == "boolean") return enabled;
    throw new Error(`Expected \`beta.eventsAPI.${opts.key}\` to be a boolean, but received ${getPrintableType(enabled)}`);
  }, initialValue);
}, mediaLibraryEnabledReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.mediaLibrary?.enabled;
    if (!resolver && typeof resolver != "boolean") return acc;
    if (typeof resolver == "boolean") return resolver;
    throw new Error(`Expected \`mediaLibrary.enabled\` to be a boolean, but received ${getPrintableType(resolver)}`);
  }, initialValue);
}, mediaLibraryLibraryIdReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.mediaLibrary?.libraryId;
    if (!resolver && typeof resolver != "string") return acc;
    if (typeof resolver == "string") return resolver;
    throw new Error(`Expected \`mediaLibrary.libraryId\` to be a string, but received ${getPrintableType(resolver)}`);
  }, initialValue);
}, mediaLibraryFrontendHostReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.mediaLibrary?.__internal?.frontendHost;
    if (!resolver && typeof resolver != "string") return acc;
    if (typeof resolver == "string") return resolver;
    throw new Error(`Expected \`mediaLibrary.__internal.frontendHost\` to be a string, but received ${getPrintableType(resolver)}`);
  }, initialValue);
}, serverDocumentActionsReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const enabled = innerConfig.__internal_serverDocumentActions?.enabled;
    if (typeof enabled > "u") return acc;
    if (typeof enabled == "boolean") return enabled;
    throw new Error(`Expected \`__internal_serverDocumentActions\` to be a boolean, but received ${getPrintableType(enabled)}`);
  }, initialValue);
}, scheduledDraftsEnabledReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const enabled = innerConfig.scheduledDrafts?.enabled;
    if (typeof enabled > "u") return acc;
    if (typeof enabled == "boolean") return enabled;
    throw new Error(`Expected a boolean, but received ${getPrintableType(enabled)}`);
  }, initialValue);
}, decisionParametersSchemaReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const schema2 = innerConfig[DECISION_PARAMETERS_SCHEMA];
    if (typeof schema2 > "u") return acc;
    if (typeof schema2 == "object" && schema2 !== null) return schema2;
    throw new Error(`Expected an object, but received ${getPrintableType(schema2)}`);
  }, initialValue);
}, partialIndexingEnabledReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.search?.unstable_partialIndexing?.enabled;
    if (!resolver && typeof resolver != "boolean") return acc;
    if (typeof resolver == "boolean") return resolver;
    throw new Error(`Expected \`search.unstable_partialIndexing.enabled\` to be a boolean, but received ${getPrintableType(resolver)}`);
  }, initialValue);
}, legacySearchEnabledReducer = (prev, {
  search: search2
}) => typeof search2?.enableLegacySearch < "u" ? search2.enableLegacySearch : prev, draftsEnabledReducer = (prev, {
  document: document2
}) => {
  if (typeof document2?.drafts?.enabled == "boolean")
    return document2?.drafts?.enabled;
  if (typeof document2?.drafts?.enabled < "u")
    throw new Error(`Expected boolean, but received ${getPrintableType(document2?.drafts?.enabled)}`);
  return prev;
}, searchStrategyReducer = ({
  config,
  initialValue
}) => {
  const flattenedConfig = flattenConfig(config, []), [implicit, explicit] = flattenedConfig.reduce(([currentImplicit, currentExplicit], entry) => {
    const {
      enableLegacySearch,
      strategy
    } = entry.config.search ?? {};
    if (typeof strategy < "u") {
      if (!isSearchStrategy(strategy)) {
        const options = new Intl.ListFormat("en-US", {
          type: "disjunction"
        }).format(searchStrategies$1.map((value) => `"${value}"`)), received = typeof strategy == "string" ? `"${strategy}"` : getPrintableType(strategy);
        throw new Error(`Expected \`search.strategy\` to be ${options}, but received ${received}`);
      }
      return [currentImplicit, strategy];
    }
    return typeof enableLegacySearch == "boolean" ? [enableLegacySearch ? "groqLegacy" : "groq2024", currentExplicit] : [currentImplicit, currentExplicit];
  }, [void 0, void 0]);
  return explicit ?? implicit ?? initialValue;
}, announcementsEnabledReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.announcements?.enabled;
    if (!resolver && typeof resolver != "boolean") return acc;
    if (typeof resolver == "boolean") return resolver;
    throw new Error(`Expected \`announcements.enabled\` to be a boolean, but received ${getPrintableType(resolver)}`);
  }, initialValue);
}, advancedVersionControlEnabledReducer = (prev, {
  advancedVersionControl
}, context) => {
  const resolver = advancedVersionControl?.enabled;
  if (typeof resolver == "boolean")
    return resolver;
  if (typeof resolver == "function")
    return resolver(prev, context);
  if (typeof resolver < "u")
    throw new Error(`Expected boolean, but received ${getPrintableType(resolver)}`);
  return prev;
};
function resolveConfigProperty({
  config: inputConfig,
  context,
  initialValue,
  propertyName,
  ...reducers
}) {
  const configs = flattenConfig(inputConfig, []);
  if ("reducer" in reducers)
    return configs.reduce((acc, {
      config,
      path
    }) => {
      try {
        return reducers.reducer(acc, config, context);
      } catch (e) {
        throw new ConfigPropertyError({
          propertyName,
          path,
          cause: e
        });
      }
    }, initialValue);
  const reducer2 = reducers.asyncReducer;
  return (async () => {
    let current = initialValue;
    for (const {
      config,
      path
    } of configs)
      try {
        current = await reducer2(current, config, context);
      } catch (e) {
        throw new ConfigPropertyError({
          propertyName,
          path,
          cause: e
        });
      }
    return current;
  })();
}
function createSanityI18nBackend(options) {
  const {
    bundles
  } = options;
  function init2() {
  }
  function read(locale, namespace, callback) {
    const loadable = bundles.filter((bundle) => bundle.locale === locale && bundle.namespace === namespace);
    if (loadable.length === 0) {
      callback(
        `No translations found for namespace "${namespace}", language "${locale}"`,
        void 0
        // Returning undefined here will i18next _not_ retry
      );
      return;
    }
    loadBundles(loadable).then((resources) => callback(null, resources)).catch((err) => callback(err, !0));
  }
  return {
    type: "backend",
    init: init2,
    read
  };
}
async function loadBundles(bundles) {
  const resolved = await Promise.all(bundles.map(async (bundle) => ({
    ...bundle,
    resources: await loadBundleResources(bundle)
  }))), base = {};
  for (const item of resolved) {
    const deep = item.deep ?? !0, overwrite = item.overwrite ?? !0;
    deep ? deepExtend(base, item.resources, overwrite) : overwrite ? Object.assign(base, item.resources) : Object.assign({}, item.resources, base);
  }
  return base;
}
async function loadBundleResources(bundle) {
  if (typeof bundle.resources != "function")
    return bundle.resources;
  const resources = await bundle.resources();
  return maybeUnwrapModule(resources);
}
function deepExtend(target, source, overwrite = !1) {
  for (const prop in source) {
    if (prop === "__proto__" || prop === "constructor")
      continue;
    if (!(prop in target)) {
      target[prop] = source[prop];
      continue;
    }
    const targetLeaf = target[prop], sourceLeaf = source[prop], targetIsString = isStringLeaf(targetLeaf), sourceIsString = isStringLeaf(sourceLeaf);
    if ((targetIsString || sourceIsString) && overwrite) {
      target[prop] = source[prop];
      continue;
    }
    if (targetIsString || sourceIsString)
      continue;
    const sourceIsArray = Array.isArray(sourceLeaf), targetIsArray = Array.isArray(targetLeaf);
    if (sourceIsArray || targetIsArray) {
      overwrite && (target[prop] = sourceLeaf);
      continue;
    }
    deepExtend(targetLeaf, sourceLeaf, overwrite);
  }
  return target;
}
function isStringLeaf(target) {
  return typeof target == "string" || target instanceof String;
}
function maybeUnwrapModule(maybeModule) {
  return isWrappedModule(maybeModule) ? maybeModule.default : maybeModule;
}
function isWrappedModule(mod) {
  return "default" in mod && typeof mod.default == "object" && isPlainObject$1(mod.default);
}
function prepareI18n(source) {
  const {
    projectId,
    dataset,
    name: sourceName2
  } = source, context = {
    projectId,
    dataset
  }, locales = resolveConfigProperty({
    config: source,
    context,
    propertyName: "i18n.locales",
    reducer: localeDefReducer,
    initialValue: [defaultLocale]
  }), bundles = resolveConfigProperty({
    config: source,
    context,
    propertyName: "i18n.bundles",
    reducer: localeBundlesReducer,
    initialValue: normalizeResourceBundles(locales)
  });
  return createI18nApi({
    locales,
    bundles,
    projectId,
    sourceName: sourceName2
  });
}
function createI18nApi({
  locales,
  bundles,
  projectId,
  sourceName: sourceName2
}) {
  const namespaceNames = new Set(bundles.map((bundle) => bundle.namespace)), options = getI18NextOptions(projectId, sourceName2, locales, namespaceNames), i18nInstance = createInstance().use(createSanityI18nBackend({
    bundles
  })).use(initReactI18next);
  i18nInstance.init(options).catch((err) => {
    console.error("Failed to initialize i18n backend: %s", err);
  });
  const reducedLocales = locales.map(reduceLocaleDefinition);
  return {
    /** @public */
    source: {
      get currentLocale() {
        return reducedLocales.find((locale) => locale.id === i18nInstance.language) ?? defaultLocale;
      },
      loadNamespaces(namespaces) {
        const missing = namespaces.filter((ns) => !i18nInstance.hasLoadedNamespace(ns));
        return missing.length === 0 ? Promise.resolve() : i18nInstance.loadNamespaces(missing);
      },
      locales: reducedLocales,
      t: maybeWrapT(i18nInstance.t)
    },
    /** @internal */
    i18next: i18nInstance
  };
}
function normalizeResourceBundles(locales) {
  const normalized = [];
  for (const lang of locales) {
    if (lang.bundles && !Array.isArray(lang.bundles))
      throw new Error(`Resource bundle for locale ${lang.id} is not an array`);
    if (lang.bundles)
      for (const bundle of lang.bundles) {
        if ("locale" in bundle && bundle.locale !== lang.id)
          throw new Error(`Resource bundle inside locale ${lang.id} has mismatching locale id`);
        if (!bundle.namespace)
          throw new Error(`Resource bundle for locale ${lang.id} is missing namespace`);
        normalized.push("locale" in bundle ? bundle : {
          ...bundle,
          locale: lang.id
        });
      }
  }
  return normalized;
}
const defaultOptions = {
  /**
   * Even though we're only defining the studio namespace, i18next will still load requested
   * namespaces through the backend. The reason why we're defining the namespace at all is to
   * prevent i18next from (trying) to load the i18next default `translation` namespace.
   */
  ns: [studioLocaleNamespace],
  defaultNS: studioLocaleNamespace,
  partialBundledLanguages: !0,
  // Fall back to English (US) locale
  fallbackLng: defaultLocale.id,
  // This will be overriden with the users detected/preferred locale before initing,
  // but to satisfy the init options and prevent mistakes, we include a default here.
  lng: defaultLocale.id,
  // In rare cases we'll want to be able to debug i18next - there is a `debug` option
  // in the studio i18n configuration for that, which will override this value.
  debug: DEBUG_I18N,
  // When specifying language 'en-US', do not load 'en-US', 'en', 'dev' - only `en-US`.
  load: "currentOnly",
  // We always use our "backend" for loading translations, allowing us to handle i18n resources
  // in a single place with a single approach. This means we shouldn't need to wait for the init,
  // as any missing translations will be loaded async (through react suspense).
  initAsync: !0,
  // Suppress ads in console
  // for context see https://github.com/i18next/i18next/issues/2390
  // Open source funding is tricky, but this is NOT the way
  showSupportNotice: !1,
  // Because we use i18next-react, we do not need to escale values
  interpolation: {
    escapeValue: !1
  },
  // Theoretically, if the framework somehow gets new translations added, re-render.
  // Note that this shouldn't actually happen, as we only use the Sanity backend
  react: {
    bindI18nStore: "added"
  }
};
function getI18NextOptions(projectId, sourceName2, locales, namespaces) {
  const preferredLocaleId = getPreferredLocale(projectId, sourceName2), preferredLocale = locales.find((l) => l.id === preferredLocaleId), lastLocale = locales[locales.length - 1], locale = preferredLocale?.id ?? lastLocale.id ?? defaultOptions.lng;
  return {
    ...defaultOptions,
    ns: Array.from(namespaces),
    // For now, let us load all namespaces. We can optimize later.
    lng: locale,
    supportedLngs: locales.map((def) => def.id)
  };
}
function reduceLocaleDefinition(definition) {
  const {
    bundles,
    ...locale
  } = definition;
  return locale;
}
const filterDefinitions = [
  // 'Pinned' filters
  {
    fieldPath: "_updatedAt",
    icon: CalendarIcon,
    operators: [{
      name: "dateTimeLast",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateTimeRange",
      type: "item"
    }, {
      name: "dateTimeAfter",
      type: "item"
    }, {
      name: "dateTimeBefore",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateTimeEqual",
      type: "item"
    }, {
      name: "dateTimeNotEqual",
      type: "item"
    }],
    title: "Edited at",
    name: "updatedAt",
    type: "pinned"
  },
  {
    fieldPath: "_createdAt",
    icon: CalendarIcon,
    operators: [{
      name: "dateTimeLast",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateTimeRange",
      type: "item"
    }, {
      name: "dateTimeAfter",
      type: "item"
    }, {
      name: "dateTimeBefore",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateTimeEqual",
      type: "item"
    }, {
      name: "dateTimeNotEqual",
      type: "item"
    }],
    title: "Created at",
    name: "createdAt",
    type: "pinned"
  },
  {
    icon: LinkIcon,
    operators: [{
      name: "referencesDocument",
      type: "item"
    }, {
      name: "referencesAssetImage",
      type: "item"
    }, {
      name: "referencesAssetFile",
      type: "item"
    }],
    title: "Contains document, image or file",
    name: "references",
    type: "pinned"
  },
  // 'Field' filters
  {
    fieldType: "array",
    icon: UlistIcon,
    name: "array",
    operators: [{
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountEqual",
      type: "item"
    }, {
      name: "arrayCountNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountGt",
      type: "item"
    }, {
      name: "arrayCountGte",
      type: "item"
    }, {
      name: "arrayCountLt",
      type: "item"
    }, {
      name: "arrayCountLte",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountRange",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "array",
    icon: UlistIcon,
    name: "arrayList",
    operators: [{
      name: "arrayListIncludes",
      type: "item"
    }, {
      name: "arrayListNotIncludes",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountEqual",
      type: "item"
    }, {
      name: "arrayCountNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountGt",
      type: "item"
    }, {
      name: "arrayCountGte",
      type: "item"
    }, {
      name: "arrayCountLt",
      type: "item"
    }, {
      name: "arrayCountLte",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountRange",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "array",
    icon: UlistIcon,
    name: "arrayReferences",
    operators: [{
      name: "arrayReferenceIncludes",
      type: "item"
    }, {
      name: "arrayReferenceNotIncludes",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountEqual",
      type: "item"
    }, {
      name: "arrayCountNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountGt",
      type: "item"
    }, {
      name: "arrayCountGte",
      type: "item"
    }, {
      name: "arrayCountLt",
      type: "item"
    }, {
      name: "arrayCountLte",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountRange",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "boolean",
    icon: CheckmarkCircleIcon,
    name: "boolean",
    operators: [{
      name: "booleanEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "date",
    icon: CalendarIcon,
    name: "date",
    operators: [{
      name: "dateLast",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateRange",
      type: "item"
    }, {
      name: "dateAfter",
      type: "item"
    }, {
      name: "dateBefore",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateEqual",
      type: "item"
    }, {
      name: "dateNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "datetime",
    icon: CalendarIcon,
    name: "datetime",
    operators: [{
      name: "dateTimeLast",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateTimeRange",
      type: "item"
    }, {
      name: "dateTimeAfter",
      type: "item"
    }, {
      name: "dateTimeBefore",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateTimeEqual",
      type: "item"
    }, {
      name: "dateTimeNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "email",
    icon: StringIcon,
    name: "email",
    operators: [{
      name: "stringMatches",
      type: "item"
    }, {
      name: "stringNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "stringEqual",
      type: "item"
    }, {
      name: "stringNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "file",
    icon: DocumentIcon,
    name: "file",
    operators: [{
      name: "assetFileEqual",
      type: "item"
    }, {
      name: "assetFileNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "image",
    icon: ImageIcon,
    name: "image",
    operators: [{
      name: "assetImageEqual",
      type: "item"
    }, {
      name: "assetImageNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "number",
    icon: NumberIcon,
    name: "number",
    operators: [{
      name: "numberEqual",
      type: "item"
    }, {
      name: "numberNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "numberGt",
      type: "item"
    }, {
      name: "numberGte",
      type: "item"
    }, {
      name: "numberLt",
      type: "item"
    }, {
      name: "numberLte",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "numberRange",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "array",
    icon: BlockContentIcon,
    name: "portableText",
    operators: [{
      name: "portableTextMatches",
      type: "item"
    }, {
      name: "portableTextNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "portableTextEqual",
      type: "item"
    }, {
      name: "portableTextNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "reference",
    icon: LinkIcon,
    name: "reference",
    operators: [{
      name: "referenceEqual",
      type: "item"
    }, {
      name: "referenceNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "slug",
    icon: StringIcon,
    name: "slug",
    operators: [{
      name: "slugMatches",
      type: "item"
    }, {
      name: "slugNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "slugEqual",
      type: "item"
    }, {
      name: "slugNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "string",
    icon: StringIcon,
    name: "string",
    operators: [{
      name: "stringMatches",
      type: "item"
    }, {
      name: "stringNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "stringEqual",
      type: "item"
    }, {
      name: "stringNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "string",
    icon: ChevronDownIcon,
    name: "stringList",
    operators: [{
      name: "stringListEqual",
      type: "item"
    }, {
      name: "stringListNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "stringMatches",
      type: "item"
    }, {
      name: "stringNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "text",
    icon: StringIcon,
    name: "text",
    operators: [{
      name: "stringMatches",
      type: "item"
    }, {
      name: "stringNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "stringEqual",
      type: "item"
    }, {
      name: "stringNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "url",
    icon: StringIcon,
    name: "url",
    operators: [{
      name: "stringMatches",
      type: "item"
    }, {
      name: "stringNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "stringEqual",
      type: "item"
    }, {
      name: "stringNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  }
];
function useUnitFormatter(t0) {
  const $ = c(7);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1, currentLocale = useCurrentLocale().id;
  let t2;
  $[2] !== options ? (t2 = {
    unitDisplay: "long",
    ...options,
    style: "unit"
  }, $[2] = options, $[3] = t2) : t2 = $[3];
  const defaultOptions2 = t2;
  let t3;
  return $[4] !== currentLocale || $[5] !== defaultOptions2 ? (t3 = function(value, unit) {
    return intlCache.numberFormat(currentLocale, {
      ...defaultOptions2,
      unit
    }).format(value);
  }, $[4] = currentLocale, $[5] = defaultOptions2, $[6] = t3) : t3 = $[6], t3;
}
function ReferencePreviewTitle(t0) {
  const $ = c(12), {
    documentId,
    schemaType
  } = t0, documentPreviewStore = useDocumentPreviewStore();
  let t1;
  $[0] !== documentId || $[1] !== documentPreviewStore || $[2] !== schemaType ? (t1 = getPreviewStateObservable$1(documentPreviewStore, schemaType, documentId), $[0] = documentId, $[1] = documentPreviewStore, $[2] = schemaType, $[3] = t1) : t1 = $[3];
  const observable = t1;
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    isLoading: !0,
    snapshot: null,
    original: null
  }, $[4] = t2) : t2 = $[4];
  const {
    snapshot: snapshot2,
    original,
    isLoading
  } = useObservable(observable, t2);
  if (isLoading) {
    let t32;
    return $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t32 = /* @__PURE__ */ jsx(Skeleton, { animated: !0, marginLeft: 1, radius: 2, style: {
      width: "10ch",
      height: "1em"
    } }), $[5] = t32) : t32 = $[5], t32;
  }
  let t3;
  $[6] !== documentId || $[7] !== original?.title || $[8] !== snapshot2?.title ? (t3 = snapshot2?.title || original?.title || documentId.slice(0, 8), $[6] = documentId, $[7] = original?.title, $[8] = snapshot2?.title, $[9] = t3) : t3 = $[9];
  let t4;
  return $[10] !== t3 ? (t4 = /* @__PURE__ */ jsx(Fragment$1, { children: t3 }), $[10] = t3, $[11] = t4) : t4 = $[11], t4;
}
function SearchButtonValueDate(t0) {
  const $ = c(8), {
    value
  } = t0, t1 = value.includeTime ? "short" : void 0;
  let t2;
  $[0] !== t1 ? (t2 = {
    dateStyle: "medium",
    timeStyle: t1
  }, $[0] = t1, $[1] = t2) : t2 = $[1];
  const dateFormat = useDateTimeFormat(t2);
  let t3, t4;
  if ($[2] !== dateFormat || $[3] !== value.date) {
    t4 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    bb0: {
      const date = value?.date ? new Date(value.date) : null;
      if (!date || !isValid(date)) {
        t4 = null;
        break bb0;
      }
      t3 = dateFormat.format(date);
    }
    $[2] = dateFormat, $[3] = value.date, $[4] = t3, $[5] = t4;
  } else
    t3 = $[4], t4 = $[5];
  if (t4 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return t4;
  let t5;
  return $[6] !== t3 ? (t5 = /* @__PURE__ */ jsx(Fragment$1, { children: t3 }), $[6] = t3, $[7] = t5) : t5 = $[7], t5;
}
function SearchButtonValueDateLast(t0) {
  const $ = c(6), {
    value
  } = t0, formatUnit = useUnitFormatter(), t1 = Math.floor(value?.unitValue ?? 0);
  let t2;
  $[0] !== formatUnit || $[1] !== t1 || $[2] !== value.unit ? (t2 = formatUnit(t1, value.unit), $[0] = formatUnit, $[1] = t1, $[2] = value.unit, $[3] = t2) : t2 = $[3];
  let t3;
  return $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(Fragment$1, { children: t2 }), $[4] = t2, $[5] = t3) : t3 = $[5], t3;
}
function SearchButtonValueDateRange(t0) {
  const $ = c(10), {
    value
  } = t0, t1 = value.includeTime ? "short" : void 0;
  let t2;
  $[0] !== t1 ? (t2 = {
    dateStyle: "medium",
    timeStyle: t1
  }, $[0] = t1, $[1] = t2) : t2 = $[1];
  const dateFormat = useDateTimeFormat(t2);
  let from2, t3, t4;
  if ($[2] !== dateFormat || $[3] !== value.from || $[4] !== value.to) {
    t4 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    bb0: {
      const startDate = value?.from ? new Date(value.from) : null, endDate = value?.to ? new Date(value.to) : null;
      if (!endDate || !startDate || !isValid(endDate) || !isValid(startDate)) {
        t4 = null;
        break bb0;
      }
      from2 = dateFormat.format(startDate), t3 = dateFormat.format(endDate);
    }
    $[2] = dateFormat, $[3] = value.from, $[4] = value.to, $[5] = from2, $[6] = t3, $[7] = t4;
  } else
    from2 = $[5], t3 = $[6], t4 = $[7];
  if (t4 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return t4;
  const t5 = `${from2} \u2192 ${t3}`;
  let t6;
  return $[8] !== t5 ? (t6 = /* @__PURE__ */ jsx(Fragment$1, { children: t5 }), $[8] = t5, $[9] = t6) : t6 = $[9], t6;
}
function SearchButtonValueReference(t0) {
  const $ = c(6), {
    value
  } = t0, schema2 = useSchema(), documentId = value._ref;
  let t1;
  $[0] !== schema2 || $[1] !== value._type ? (t1 = schema2.get(value._type), $[0] = schema2, $[1] = value._type, $[2] = t1) : t1 = $[2];
  const schemaType = t1;
  if (!schemaType)
    return null;
  let t2;
  return $[3] !== documentId || $[4] !== schemaType ? (t2 = /* @__PURE__ */ jsx(ReferencePreviewTitle, { documentId, schemaType }), $[3] = documentId, $[4] = schemaType, $[5] = t2) : t2 = $[5], t2;
}
function SearchFilterNumberInput(t0) {
  const $ = c(9), {
    value,
    onChange
  } = t0, [uncontrolledValue, setUncontrolledValue] = useState(value ?? ""), {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] !== onChange ? (t2 = (event) => {
    setUncontrolledValue(event.currentTarget.value);
    const numValue = parseFloat(event.currentTarget.value);
    onChange(Number.isFinite(numValue) ? numValue : null);
  }, $[0] = onChange, $[1] = t2) : t2 = $[1];
  const handleChange = t2, t3 = fullscreen ? 2 : 1;
  let t4;
  $[2] !== t ? (t4 = t("search.filter-number-value-placeholder"), $[2] = t, $[3] = t4) : t4 = $[3];
  let t5;
  return $[4] !== handleChange || $[5] !== t3 || $[6] !== t4 || $[7] !== uncontrolledValue ? (t5 = /* @__PURE__ */ jsx(TextInput$1, { fontSize: t3, onChange: handleChange, placeholder: t4, radius: 2, step: "any", type: "number", value: uncontrolledValue }), $[4] = handleChange, $[5] = t3, $[6] = t4, $[7] = uncontrolledValue, $[8] = t5) : t5 = $[8], t5;
}
function SearchFilterNumberRangeInput(t0) {
  const $ = c(23), {
    onChange,
    value
  } = t0, [to, setTo] = useState(value?.to ?? ""), [from2, setFrom] = useState(value?.from ?? ""), {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] !== onChange || $[1] !== value?.from ? (t2 = (event) => {
    setTo(event.currentTarget.value);
    const numValue = parseFloat(event.currentTarget.value);
    onChange({
      to: Number.isFinite(numValue) ? numValue : null,
      from: value?.from ?? null
    });
  }, $[0] = onChange, $[1] = value?.from, $[2] = t2) : t2 = $[2];
  const handleToChange = t2;
  let t3;
  $[3] !== onChange || $[4] !== value?.to ? (t3 = (event_0) => {
    setFrom(event_0.currentTarget.value);
    const numValue_0 = parseFloat(event_0.currentTarget.value);
    onChange({
      to: value?.to ?? null,
      from: Number.isFinite(numValue_0) ? numValue_0 : null
    });
  }, $[3] = onChange, $[4] = value?.to, $[5] = t3) : t3 = $[5];
  const handleFromChange = t3, t4 = fullscreen ? 2 : 1;
  let t5;
  $[6] !== t ? (t5 = t("search.filter-number-min-value-placeholder"), $[6] = t, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== from2 || $[9] !== handleFromChange || $[10] !== t4 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(TextInput$1, { fontSize: t4, onChange: handleFromChange, placeholder: t5, radius: 2, step: "any", type: "number", value: from2 }) }), $[8] = from2, $[9] = handleFromChange, $[10] = t4, $[11] = t5, $[12] = t6) : t6 = $[12];
  const t7 = fullscreen ? 2 : 1;
  let t8;
  $[13] !== t ? (t8 = t("search.filter-number-max-value-placeholder"), $[13] = t, $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== handleToChange || $[16] !== t7 || $[17] !== t8 || $[18] !== to ? (t9 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(TextInput$1, { fontSize: t7, onChange: handleToChange, placeholder: t8, radius: 2, step: "any", type: "number", value: to }) }), $[15] = handleToChange, $[16] = t7, $[17] = t8, $[18] = to, $[19] = t9) : t9 = $[19];
  let t10;
  return $[20] !== t6 || $[21] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { gap: 2, children: [
    t6,
    t9
  ] }), $[20] = t6, $[21] = t9, $[22] = t10) : t10 = $[22], t10;
}
const NO_FILTER = () => !0, StyledText$2 = styled(Text$1).withConfig({
  displayName: "StyledText",
  componentId: "sc-vmbu0s-0"
})`word-break:break-word;`, ReferenceAutocomplete = forwardRef(function(t0, ref) {
  const $ = c(43), {
    onSelect,
    types: t1,
    value
  } = t0;
  let t2;
  $[0] !== t1 ? (t2 = t1 === void 0 ? [] : t1, $[0] = t1, $[1] = t2) : t2 = $[1];
  const types = t2, autocompletePopoverReferenceElementRef = useRef(null), schema2 = useSchema(), {
    state: t3
  } = useSearchState(), {
    fullscreen
  } = t3, {
    t
  } = useTranslation(), autocompleteId = useId();
  let t4;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = [], $[2] = t4) : t4 = $[2];
  const [hits, setHits] = useState(t4);
  let t5;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = [], $[3] = t5) : t5 = $[3];
  let t6;
  $[4] !== types ? (t6 = {
    hits: t5,
    loading: !1,
    error: null,
    terms: {
      query: "",
      types
    }
  }, $[4] = types, $[5] = t6) : t6 = $[5];
  let t7;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = (result) => {
    setHits(result.hits.map(_temp$1k));
  }, $[6] = t7) : t7 = $[6];
  let t8;
  $[7] !== schema2 || $[8] !== t6 ? (t8 = {
    allowEmptyQueries: !0,
    initialState: t6,
    onComplete: t7,
    schema: schema2
  }, $[7] = schema2, $[8] = t6, $[9] = t8) : t8 = $[9];
  const {
    handleSearch,
    searchState
  } = useSearch(t8);
  let t9;
  $[10] !== handleSearch || $[11] !== types ? (t9 = () => {
    handleSearch({
      debounceTime: 0,
      options: {
        limit: 100
      },
      terms: {
        query: "",
        types
      }
    });
  }, $[10] = handleSearch, $[11] = types, $[12] = t9) : t9 = $[12];
  const handleAutocompleteOpenButtonClick = t9;
  let t10;
  $[13] !== handleSearch || $[14] !== types ? (t10 = (query) => {
    handleSearch(query ? {
      options: {
        limit: 100
      },
      terms: {
        query: query || "",
        types
      }
    } : {
      debounceTime: 0,
      options: {
        limit: 0
      },
      terms: {
        query: "",
        types
      }
    });
  }, $[13] = handleSearch, $[14] = types, $[15] = t10) : t10 = $[15];
  const handleQueryChange = t10;
  let t11;
  $[16] !== hits || $[17] !== onSelect ? (t11 = (val) => {
    const hit_0 = hits.find((h) => h.value === val)?.hit;
    hit_0 && onSelect?.({
      _ref: getPublishedId(hit_0._id),
      _type: hit_0._type
    });
  }, $[16] = hits, $[17] = onSelect, $[18] = t11) : t11 = $[18];
  const handleSelect = t11;
  let t12;
  bb0: {
    if (types.length === 0) {
      let t133;
      $[19] !== t ? (t133 = t("search.action.search-all-types"), $[19] = t, $[20] = t133) : t133 = $[20], t12 = t133;
      break bb0;
    }
    let t132;
    if ($[21] !== t || $[22] !== types) {
      const {
        remainingCount,
        types: visibleTypes
      } = getDocumentTypesTruncated({
        types
      }), key = remainingCount > 0 ? "search.action.search-specific-types-truncated" : "search.action.search-specific-types";
      t132 = t(key, {
        count: remainingCount,
        types: visibleTypes,
        formatParams: {
          types: {
            style: "short",
            type: "unit"
          }
        }
      }), $[21] = t, $[22] = types, $[23] = t132;
    } else
      t132 = $[23];
    t12 = t132;
  }
  const placeholderText = t12, renderOption = _temp2$v;
  let t13;
  $[24] !== hits || $[25] !== searchState.loading || $[26] !== searchState.terms.query || $[27] !== t ? (t13 = (props2, contentRef) => {
    const {
      content,
      hidden,
      onMouseEnter,
      onMouseLeave
    } = props2, hasResults = hits && hits.length > 0;
    return /* @__PURE__ */ jsx(Popover, { constrainSize: !0, content: /* @__PURE__ */ jsx("div", { ref: contentRef, children: hasResults ? content : searchState.terms.query && /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(StyledText$2, { align: "center", muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "new-document.no-results", values: {
      searchQuery: searchState.terms.query
    } }) }) }) }) }), fallbackPlacements: ["bottom", "bottom-end"], matchReferenceWidth: !0, onMouseEnter, onMouseLeave, open: !searchState.loading && !hidden, overflow: "auto", placement: "bottom-start", radius: POPOVER_RADIUS, referenceElement: autocompletePopoverReferenceElementRef.current });
  }, $[24] = hits, $[25] = searchState.loading, $[26] = searchState.terms.query, $[27] = t, $[28] = t13) : t13 = $[28];
  const renderPopover = t13, t14 = fullscreen ? 2 : 1;
  let t15;
  $[29] !== handleAutocompleteOpenButtonClick ? (t15 = {
    onClick: handleAutocompleteOpenButtonClick
  }, $[29] = handleAutocompleteOpenButtonClick, $[30] = t15) : t15 = $[30];
  const t16 = value?._ref;
  let t17;
  return $[31] !== autocompleteId || $[32] !== handleQueryChange || $[33] !== handleSelect || $[34] !== hits || $[35] !== placeholderText || $[36] !== ref || $[37] !== renderPopover || $[38] !== searchState.loading || $[39] !== t14 || $[40] !== t15 || $[41] !== t16 ? (t17 = /* @__PURE__ */ jsx("div", { ref: autocompletePopoverReferenceElementRef, children: /* @__PURE__ */ jsx(Autocomplete, { "aria-label": placeholderText, filterOption: NO_FILTER, fontSize: t14, id: autocompleteId, loading: searchState.loading, openButton: t15, options: hits, onQueryChange: handleQueryChange, onSelect: handleSelect, placeholder: placeholderText, radius: 2, ref, renderOption, renderPopover, value: t16 }) }), $[31] = autocompleteId, $[32] = handleQueryChange, $[33] = handleSelect, $[34] = hits, $[35] = placeholderText, $[36] = ref, $[37] = renderPopover, $[38] = searchState.loading, $[39] = t14, $[40] = t15, $[41] = t16, $[42] = t17) : t17 = $[42], t17;
});
function _temp$1k(t0) {
  const {
    hit
  } = t0;
  return {
    value: hit._id,
    hit
  };
}
function _temp2$v(option) {
  return /* @__PURE__ */ jsx(SearchResultItem, { disableIntentLink: !0, documentId: option.value, documentType: option.hit._type, layout: "compact" });
}
function SearchFilterReferenceInput(t0) {
  const $ = c(25), {
    fieldDefinition,
    onChange,
    value
  } = t0, {
    onClose,
    state: t1
  } = useSearchState(), {
    documentTypesNarrowed
  } = t1, schema2 = useSchema(), {
    t
  } = useTranslation();
  let t2;
  $[0] !== onChange ? (t2 = (referenceValue) => onChange(referenceValue), $[0] = onChange, $[1] = t2) : t2 = $[1];
  const handleChange = t2;
  let t3;
  bb0: {
    if (!fieldDefinition) {
      let t43;
      $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t43 = [], $[2] = t43) : t43 = $[2], t3 = t43;
      break bb0;
    }
    let t42;
    if ($[3] !== documentTypesNarrowed || $[4] !== fieldDefinition.documentTypes || $[5] !== fieldDefinition.fieldPath || $[6] !== schema2) {
      let t52;
      $[8] !== documentTypesNarrowed ? (t52 = (d) => documentTypesNarrowed.includes(d), $[8] = documentTypesNarrowed, $[9] = t52) : t52 = $[9];
      let t62;
      $[10] !== fieldDefinition.fieldPath || $[11] !== schema2 ? (t62 = (type) => {
        const schemaType = schema2.get(type);
        if (schemaType) {
          const field = getSchemaField$2(schemaType, fieldDefinition.fieldPath);
          if (isArraySchemaType(field?.type))
            return field?.type.of.filter(isReferenceSchemaType).flatMap(_temp$1j);
          if (isReferenceSchemaType(field?.type))
            return field?.type.to;
        }
        return [];
      }, $[10] = fieldDefinition.fieldPath, $[11] = schema2, $[12] = t62) : t62 = $[12], t42 = fieldDefinition.documentTypes.filter(t52).flatMap(t62).reduce(_temp2$u, []), $[3] = documentTypesNarrowed, $[4] = fieldDefinition.documentTypes, $[5] = fieldDefinition.fieldPath, $[6] = schema2, $[7] = t42;
    } else
      t42 = $[7];
    t3 = t42;
  }
  const searchableTypes = t3;
  let t4;
  $[13] !== handleChange ? (t4 = () => handleChange(null), $[13] = handleChange, $[14] = t4) : t4 = $[14];
  const handleClear = t4;
  let t5;
  $[15] !== onClose ? (t5 = () => {
    onClose?.();
  }, $[15] = onClose, $[16] = t5) : t5 = $[16];
  const handleClick = t5;
  let t6;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    width: "min(calc(100vw - 40px), 420px)"
  }, $[17] = t6) : t6 = $[17];
  let t7;
  return $[18] !== handleChange || $[19] !== handleClear || $[20] !== handleClick || $[21] !== searchableTypes || $[22] !== t || $[23] !== value ? (t7 = /* @__PURE__ */ jsx(Box, { style: t6, children: value?._ref && value?._type ? /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    /* @__PURE__ */ jsx(Card, { padding: 1, radius: 1, shadow: 1, children: /* @__PURE__ */ jsx(SearchResultItem, { documentId: value._ref, documentType: value._type, layout: "compact", onClick: handleClick }) }),
    /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: handleClear, text: t("search.filter-reference-clear"), tone: "critical" })
  ] }) : /* @__PURE__ */ jsx(ReferenceAutocomplete, { onSelect: handleChange, types: searchableTypes, value }) }), $[18] = handleChange, $[19] = handleClear, $[20] = handleClick, $[21] = searchableTypes, $[22] = t, $[23] = value, $[24] = t7) : t7 = $[24], t7;
}
function _temp2$u(acc, val) {
  return acc.findIndex((v) => v.name === val?.name) < 0 && acc.push(val), acc;
}
function _temp$1j(i) {
  return i.to;
}
function CustomMenuItem(t0) {
  const $ = c(7), {
    onClick: onClick2,
    selected,
    title,
    value
  } = t0;
  let t1;
  $[0] !== onClick2 || $[1] !== value ? (t1 = () => onClick2(value), $[0] = onClick2, $[1] = value, $[2] = t1) : t1 = $[2];
  const handleClick = t1;
  let menuItemText = `${title}`;
  typeof value < "u" && title !== value && (menuItemText = menuItemText + ` (${value})`);
  let t2;
  return $[3] !== handleClick || $[4] !== menuItemText || $[5] !== selected ? (t2 = /* @__PURE__ */ jsx(MenuItem, { onClick: handleClick, pressed: selected, tone: "default", text: menuItemText }), $[3] = handleClick, $[4] = menuItemText, $[5] = selected, $[6] = t2) : t2 = $[6], t2;
}
function SearchFilterStringListInput(t0) {
  const $ = c(32), {
    fieldDefinition,
    onChange,
    value
  } = t0, menuButtonId = useId(), {
    state: t1
  } = useSearchState(), {
    documentTypesNarrowed
  } = t1, {
    t
  } = useTranslation(), schema2 = useSchema();
  let t2;
  bb0: {
    if (!fieldDefinition) {
      let t33;
      $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t33 = [], $[0] = t33) : t33 = $[0], t2 = t33;
      break bb0;
    }
    let t32;
    if ($[1] !== documentTypesNarrowed || $[2] !== fieldDefinition.documentTypes || $[3] !== fieldDefinition.fieldPath || $[4] !== schema2) {
      let t42;
      $[6] !== documentTypesNarrowed ? (t42 = (d) => documentTypesNarrowed.includes(d), $[6] = documentTypesNarrowed, $[7] = t42) : t42 = $[7];
      let t52;
      $[8] !== fieldDefinition.fieldPath || $[9] !== schema2 ? (t52 = (type) => {
        const schemaType = schema2.get(type);
        return schemaType ? getSchemaField$2(schemaType, fieldDefinition.fieldPath)?.type.options : null;
      }, $[8] = fieldDefinition.fieldPath, $[9] = schema2, $[10] = t52) : t52 = $[10], t32 = fieldDefinition.documentTypes.filter(t42).map(t52).filter(isNonNullable$2).map(_temp$1i).flatMap(_temp3$g).filter(isNonNullable$2).reduce(_temp5$5, []), $[1] = documentTypesNarrowed, $[2] = fieldDefinition.documentTypes, $[3] = fieldDefinition.fieldPath, $[4] = schema2, $[5] = t32;
    } else
      t32 = $[5];
    t2 = t32;
  }
  const items = t2;
  let t3;
  $[11] !== onChange ? (t3 = (v_0) => {
    onChange(v_0);
  }, $[11] = onChange, $[12] = t3) : t3 = $[12];
  const handleClick = t3;
  let t4;
  $[13] !== t || $[14] !== value ? (t4 = value ? String(value) : t("search.filter-string-value-select-predefined-value"), $[13] = t, $[14] = value, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { mode: "ghost", iconRight: ChevronDownIcon, text: t4 }), $[16] = t4, $[17] = t5) : t5 = $[17];
  const t6 = menuButtonId || "";
  let t7;
  if ($[18] !== handleClick || $[19] !== items || $[20] !== value) {
    let t82;
    $[22] !== handleClick || $[23] !== value ? (t82 = (item, index) => /* @__PURE__ */ jsx(CustomMenuItem, { onClick: handleClick, selected: item.value === value, title: item.title.join(", "), value: item.value || "" }, index), $[22] = handleClick, $[23] = value, $[24] = t82) : t82 = $[24], t7 = items.map(t82), $[18] = handleClick, $[19] = items, $[20] = value, $[21] = t7;
  } else
    t7 = $[21];
  let t8;
  $[25] !== t7 ? (t8 = /* @__PURE__ */ jsx(Menu, { children: t7 }), $[25] = t7, $[26] = t8) : t8 = $[26];
  let t9;
  $[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = {
    constrainSize: !0,
    placement: "bottom-start",
    portal: !1,
    radius: 2
  }, $[27] = t9) : t9 = $[27];
  let t10;
  return $[28] !== t5 || $[29] !== t6 || $[30] !== t8 ? (t10 = /* @__PURE__ */ jsx(MenuButton, { button: t5, id: t6, menu: t8, popover: t9 }), $[28] = t5, $[29] = t6, $[30] = t8, $[31] = t10) : t10 = $[31], t10;
}
function _temp5$5(acc, val) {
  const prevIndex = acc.findIndex((v) => v.value === val?.value);
  if (prevIndex > -1) {
    const prevValue = acc[prevIndex];
    acc[prevIndex] = {
      ...acc[prevIndex],
      title: uniq([...prevValue.title, val.title]).sort(_temp4$7)
    };
  } else
    acc.push({
      ...val,
      title: [val.title]
    });
  return acc;
}
function _temp4$7(a, b) {
  return typeof a == "string" && typeof b == "string" ? a.localeCompare(b) : Number(a) - Number(b);
}
function _temp3$g(list) {
  return list?.map(_temp2$t);
}
function _temp2$t(l) {
  return toSelectItem(l);
}
function _temp$1i(o) {
  return o.list;
}
function toSelectItem(option) {
  return isTitledListValue(option) ? option : {
    title: capitalize(`${option}`),
    value: option
  };
}
const GteIcon = () => {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("path", { d: "M7.04 19V17.512H17.36V19H7.04ZM7.04 15.328V13.624L12.08 11.872L15.32 10.816V10.72L12.08 9.664L7.04 7.912V6.208L17.36 9.88V11.656L7.04 15.328Z", fill: "currentColor" }) }), $[0] = t0) : t0 = $[0], t0;
}, GtIcon = () => {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("path", { d: "M7.568 18.848V16.952L14.792 12.08V11.984L7.568 7.112V5.216L16.52 11.288V12.776L7.568 18.848Z", fill: "currentColor" }) }), $[0] = t0) : t0 = $[0], t0;
}, LteIcon = () => {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("path", { d: "M7.04 19V17.512H17.36V19H7.04ZM17.36 15.328L7.04 11.656V9.88L17.36 6.208V7.912L12.32 9.664L9.08 10.72V10.816L12.32 11.872L17.36 13.624V15.328Z", fill: "currentColor" }) }), $[0] = t0) : t0 = $[0], t0;
}, LtIcon = () => {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("path", { d: "M16.952 19.632L8 13.56V12.072L16.952 6V7.896L9.728 12.768V12.864L16.952 17.736V19.632Z", fill: "currentColor" }) }), $[0] = t0) : t0 = $[0], t0;
};
function defineSearchOperator(definition) {
  return definition;
}
function toJSON(val) {
  return JSON.stringify(val);
}
const arrayOperators = {
  arrayCountEqual: {
    nameKey: "search.operator.array-count-equal.name",
    descriptionKey: "search.operator.array-count-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `count(${fieldPath}) == ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "arrayCountEqual"
  },
  arrayCountGt: {
    nameKey: "search.operator.array-count-gt.name",
    descriptionKey: "search.operator.array-count-gt.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `count(${fieldPath}) > ${toJSON(value)}` : null,
    icon: GtIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "arrayCountGt"
  },
  arrayCountGte: {
    nameKey: "search.operator.array-count-gte.name",
    descriptionKey: "search.operator.array-count-gte.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `count(${fieldPath}) >= ${toJSON(value)}` : null,
    icon: GteIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "arrayCountGte"
  },
  arrayCountLt: {
    nameKey: "search.operator.array-count-lt.name",
    descriptionKey: "search.operator.array-count-lt.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `count(${fieldPath}) < ${toJSON(value)}` : null,
    icon: LtIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "arrayCountLt"
  },
  arrayCountLte: {
    nameKey: "search.operator.array-count-lte.name",
    descriptionKey: "search.operator.array-count-lte.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `count(${fieldPath}) <= ${toJSON(value)}` : null,
    icon: LteIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "arrayCountLte"
  },
  arrayCountNotEqual: {
    nameKey: "search.operator.array-count-not-equal.name",
    descriptionKey: "search.operator.array-count-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `count(${fieldPath}) != ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "arrayCountNotEqual"
  },
  arrayCountRange: {
    nameKey: "search.operator.array-count-range.name",
    descriptionKey: "search.operator.array-count-range.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value?.to) && Number.isFinite(value?.from) && fieldPath ? `count(${fieldPath}) > ${toJSON(value?.from)} && count(${fieldPath}) < ${toJSON(value?.to)}` : "",
    initialValue: null,
    inputComponent: SearchFilterNumberRangeInput,
    type: "arrayCountRange"
  },
  arrayListIncludes: {
    nameKey: "search.operator.array-list-includes.name",
    descriptionKey: "search.operator.array-list-includes.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${toJSON(value)} in ${fieldPath}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringListInput,
    type: "arrayListIncludes"
  },
  arrayListNotIncludes: {
    nameKey: "search.operator.array-list-not-includes.name",
    descriptionKey: "search.operator.array-list-not-includes.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `!(${toJSON(value)} in ${fieldPath})` : null,
    initialValue: null,
    inputComponent: SearchFilterStringListInput,
    type: "arrayListNotIncludes"
  },
  arrayReferenceIncludes: {
    nameKey: "search.operator.array-reference-includes.name",
    descriptionKey: "search.operator.array-reference-includes.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${toJSON(value._ref)} in ${fieldPath}[]._ref` : null,
    initialValue: null,
    inputComponent: SearchFilterReferenceInput,
    type: "arrayReferenceIncludes"
  },
  arrayReferenceNotIncludes: {
    nameKey: "search.operator.array-reference-not-includes.name",
    descriptionKey: "search.operator.array-reference-not-includes.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `!(${toJSON(value._ref)} in ${fieldPath}[]._ref)` : null,
    initialValue: null,
    inputComponent: SearchFilterReferenceInput,
    type: "arrayReferenceNotIncludes"
  }
};
function AssetSourceError(props2) {
  const $ = c(20), {
    t
  } = useTranslation();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(TextWithTone, { tone: "caution", children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== t ? (t1 = t("search.error.no-valid-asset-source-title"), $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "caution", weight: "medium", children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("search.error.no-valid-asset-source-only-default-description"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "caution", children: t3 }), $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t ? (t5 = t("search.error.no-valid-asset-source-check-config-description"), $[9] = t, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "caution", children: t5 }), $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== t2 || $[14] !== t4 || $[15] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, children: [
    t0,
    /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
      t2,
      t4,
      t6
    ] })
  ] }), $[13] = t2, $[14] = t4, $[15] = t6, $[16] = t7) : t7 = $[16];
  let t8;
  return $[17] !== props2 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { ...props2, children: t7 }), $[17] = props2, $[18] = t7, $[19] = t8) : t8 = $[19], t8;
}
function FileReferencePreview(t0) {
  const $ = c(6), {
    reference
  } = t0, documentPreviewStore = useDocumentPreviewStore();
  let t1;
  $[0] !== documentPreviewStore ? (t1 = (id2) => observeFileAsset(documentPreviewStore, id2), $[0] = documentPreviewStore, $[1] = t1) : t1 = $[1];
  const observeAsset = t1;
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(FileSkeleton, {}), $[2] = t2) : t2 = $[2];
  let t3;
  return $[3] !== observeAsset || $[4] !== reference ? (t3 = /* @__PURE__ */ jsx(WithReferencedAsset, { observeAsset, reference, waitPlaceholder: t2, children: _temp$1h }), $[3] = observeAsset, $[4] = reference, $[5] = t3) : t3 = $[5], t3;
}
function _temp$1h(asset) {
  return /* @__PURE__ */ jsx(FilePreview, { asset });
}
function FilePreview(t0) {
  const $ = c(10), {
    asset
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Card, { padding: 3, radius: 1, shadow: 1, tone: "transparent", children: /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(BinaryDocumentIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  const t2 = asset?.originalFilename || asset._id;
  let t3;
  $[1] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", weight: "medium", children: t2 }), $[1] = t2, $[2] = t3) : t3 = $[2];
  let t4;
  $[3] !== asset.size ? (t4 = formatBytes(asset.size), $[3] = asset.size, $[4] = t4) : t4 = $[4];
  let t5;
  $[5] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t4 }), $[5] = t4, $[6] = t5) : t5 = $[6];
  let t6;
  return $[7] !== t3 || $[8] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { padding: 2, shadow: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-between", wrap: "nowrap", children: [
    t1,
    /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, marginLeft: 3, children: [
      t3,
      t5
    ] })
  ] }) }), $[7] = t3, $[8] = t5, $[9] = t6) : t6 = $[9], t6;
}
function FileSkeleton() {
  const $ = c(3);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Card, { padding: 3, radius: 1, shadow: 1, tone: "transparent", children: /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(BinaryDocumentIcon, {}) }) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(TextSkeleton, { animated: !0, style: {
    width: "100%"
  }, radius: 1 }), $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Card, { padding: 2, shadow: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "flex-start", children: [
    t0,
    /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, marginLeft: 3, children: [
      t1,
      /* @__PURE__ */ jsx(TextSkeleton, { animated: !0, style: {
        width: "100%"
      }, radius: 1 })
    ] })
  ] }) }), $[2] = t2) : t2 = $[2], t2;
}
const Container = styled(Card).withConfig({
  displayName: "Container",
  componentId: "sc-1t3dhca-0"
})`position:relative;padding-bottom:100%;`, Image$3 = styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-1t3dhca-1"
})`position:absolute;top:0;left:0;width:100%;height:100%;display:block;object-fit:contain;`;
function ImageReferencePreview(t0) {
  const $ = c(5), {
    reference
  } = t0, documentPreviewStore = useDocumentPreviewStore();
  let t1;
  $[0] !== documentPreviewStore ? (t1 = (id2) => observeImageAsset(documentPreviewStore, id2), $[0] = documentPreviewStore, $[1] = t1) : t1 = $[1];
  const observeAsset = t1;
  let t2;
  return $[2] !== observeAsset || $[3] !== reference ? (t2 = /* @__PURE__ */ jsx(WithReferencedAsset, { observeAsset, reference, children: _temp$1g }), $[2] = observeAsset, $[3] = reference, $[4] = t2) : t2 = $[4], t2;
}
function _temp$1g(asset) {
  return /* @__PURE__ */ jsx(ImagePreview, { asset });
}
function ImagePreview(t0) {
  const $ = c(8), {
    asset
  } = t0, [loaded, setLoaded] = useState(!1), imageUrl = `${asset.url}?h=800&fit=max`;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setLoaded(!0), $[0] = t1) : t1 = $[0];
  const handleLoad = t1;
  let t2;
  $[1] !== loaded ? (t2 = !loaded && /* @__PURE__ */ jsx(LoadingBlock, { fill: !0, showText: !0 }), $[1] = loaded, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== imageUrl ? (t3 = /* @__PURE__ */ jsx(Image$3, { onLoad: handleLoad, src: imageUrl }), $[3] = imageUrl, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== t2 || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Container, { __unstable_checkered: !0, border: !0, children: [
    t2,
    t3
  ] }), $[5] = t2, $[6] = t3, $[7] = t4) : t4 = $[7], t4;
}
function AssetPreview(t0) {
  const $ = c(4), {
    reference
  } = t0;
  if (!reference)
    return null;
  if (reference._type.startsWith("sanity.fileAsset")) {
    let t1;
    return $[0] !== reference ? (t1 = /* @__PURE__ */ jsx(FileReferencePreview, { reference }), $[0] = reference, $[1] = t1) : t1 = $[1], t1;
  }
  if (reference._type.startsWith("sanity.imageAsset")) {
    let t1;
    return $[2] !== reference ? (t1 = /* @__PURE__ */ jsx(ImageReferencePreview, { reference }), $[2] = reference, $[3] = t1) : t1 = $[3], t1;
  }
  return null;
}
const ASSET_TYPE = {
  file: "sanity.fileAsset",
  image: "sanity.imageAsset"
}, ContainerBox = styled(Box).withConfig({
  displayName: "ContainerBox",
  componentId: "sc-1l821ib-0"
})`width:min(calc(100vw - 40px),320px);`;
function SearchFilterAssetInput(type) {
  return function({
    onChange,
    value
  }) {
    const [selectedAssetSource, setSelectedAssetSource] = useState(null), [selectedAssetFromSource, setSelectedAssetFromSource] = useState(null);
    useSearchState();
    const {
      file,
      image
    } = useSource().form, {
      t
    } = useTranslation(), assetSources = useMemo(() => {
      switch (type) {
        case "file":
          return file.assetSources.filter((a) => a.name === sourceName$2);
        case "image":
          return image.assetSources.filter((a) => a.name === sourceName$2);
        default:
          throw Error("Unknown asset source found");
      }
    }, [file.assetSources, image.assetSources]), menuButtonId = useId(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), handleClear = useCallback(() => {
      setSelectedAssetFromSource(null), onChange(null);
    }, [onChange]), handleCloseAssetSource = useCallback(() => {
      setSelectedAssetSource(null);
    }, []), handleSelectAssetFromSource2 = useCallback((assetFromSource) => {
      const firstAsset = assetFromSource[0];
      setSelectedAssetFromSource(firstAsset), handleCloseAssetSource();
    }, [handleCloseAssetSource]), handleSelectAssetSource = useCallback((source) => setSelectedAssetSource(source), []);
    useEffect(() => {
      selectedAssetFromSource?.kind === "assetDocumentId" && typeof selectedAssetFromSource?.value == "string" && type && onChange({
        _ref: selectedAssetFromSource.value,
        _type: ASSET_TYPE[type]
      });
    }, [client, onChange, selectedAssetFromSource]);
    const AssetSourceComponent = selectedAssetSource?.component, buttonText = t(value ? "search.filter-asset-change" : "search.filter-asset-select", {
      context: type
    }), accept = get(type, "options.accept", type === "image" ? "image/*" : "");
    return /* @__PURE__ */ jsx(ContainerBox, { children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      selectedAssetSource && AssetSourceComponent && /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(AssetSourceComponent, { assetType: type, assetSource: selectedAssetSource, dialogHeaderTitle: t("search.action.select-asset", {
        context: type
      }), onClose: handleCloseAssetSource, onSelect: handleSelectAssetFromSource2, selectedAssets: [], selectionType: "single", accept }) }),
      value && /* @__PURE__ */ jsx(AssetPreview, { reference: value }),
      /* @__PURE__ */ jsxs(Flex, { gap: 2, children: [
        assetSources.length === 0 && /* @__PURE__ */ jsx(AssetSourceError, { padding: 2 }),
        assetSources.length > 0 && /* @__PURE__ */ jsx(Fragment$1, { children: assetSources.length > 1 ? /* @__PURE__ */ jsx(MenuButton, { button: /* @__PURE__ */ jsx(Button, { icon: value ? UndoIcon : SearchIcon, iconRight: ChevronDownIcon, mode: "ghost", width: value ? "fill" : void 0, text: buttonText }), id: menuButtonId, menu: /* @__PURE__ */ jsx(Menu, { children: assetSources.map((source) => /* @__PURE__ */ jsx(MenuItem, { icon: source.icon || ImageIcon, onClick: () => handleSelectAssetSource(source), text: getAssetSourceDisplayName(source, t, {
          useStartCaseForName: !0
        }) }, source.name)) }), popover: {
          constrainSize: !0,
          portal: !1,
          radius: 2
        } }) : /* @__PURE__ */ jsx(Button, { icon: value ? UndoIcon : SearchIcon, mode: "ghost", onClick: () => handleSelectAssetSource(assetSources[0]), width: value ? "fill" : void 0, text: buttonText }) }),
        value && /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: handleClear, width: "fill", text: t("search.filter-asset-clear"), tone: "critical" })
      ] })
    ] }) });
  };
}
const assetOperators = {
  assetFileEqual: {
    nameKey: "search.operator.asset-file-equal.name",
    descriptionKey: "search.operator.asset-file-equal.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${fieldPath}.asset._ref == ${toJSON(value._ref)}` : null,
    initialValue: null,
    inputComponent: SearchFilterAssetInput("file"),
    type: "assetFileEqual"
  },
  assetFileNotEqual: {
    nameKey: "search.operator.asset-file-not-equal.name",
    descriptionKey: "search.operator.asset-file-not-equal.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${fieldPath}.asset._ref != ${toJSON(value._ref)}` : null,
    initialValue: null,
    inputComponent: SearchFilterAssetInput("file"),
    type: "assetFileNotEqual"
  },
  assetImageEqual: {
    nameKey: "search.operator.asset-image-equal.name",
    descriptionKey: "search.operator.asset-image-equal.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${fieldPath}.asset._ref == ${toJSON(value._ref)}` : null,
    initialValue: null,
    inputComponent: SearchFilterAssetInput("image"),
    type: "assetImageEqual"
  },
  assetImageNotEqual: {
    nameKey: "search.operator.asset-image-not-equal.name",
    descriptionKey: "search.operator.asset-image-not-equal.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${fieldPath}.asset._ref != ${toJSON(value._ref)}` : null,
    initialValue: null,
    inputComponent: SearchFilterAssetInput("image"),
    type: "assetImageNotEqual"
  }
};
function SearchFilterBooleanInput(t0) {
  const $ = c(16), {
    onChange,
    value
  } = t0, {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] !== onChange ? (t2 = (event) => {
    onChange(event.currentTarget.value === "true");
  }, $[0] = onChange, $[1] = t2) : t2 = $[1];
  const handleChange = t2, t3 = fullscreen ? 2 : 1, t4 = String(value ?? !0);
  let t5;
  $[2] !== t ? (t5 = t("search.filter-boolean-true"), $[2] = t, $[3] = t5) : t5 = $[3];
  let t6;
  $[4] !== t5 ? (t6 = /* @__PURE__ */ jsx("option", { value: "true", children: t5 }), $[4] = t5, $[5] = t6) : t6 = $[5];
  let t7;
  $[6] !== t ? (t7 = t("search.filter-boolean-false"), $[6] = t, $[7] = t7) : t7 = $[7];
  let t8;
  $[8] !== t7 ? (t8 = /* @__PURE__ */ jsx("option", { value: "false", children: t7 }), $[8] = t7, $[9] = t8) : t8 = $[9];
  let t9;
  return $[10] !== handleChange || $[11] !== t3 || $[12] !== t4 || $[13] !== t6 || $[14] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Select, { fontSize: t3, onChange: handleChange, radius: 2, value: t4, children: [
    t6,
    t8
  ] }), $[10] = handleChange, $[11] = t3, $[12] = t4, $[13] = t6, $[14] = t8, $[15] = t9) : t9 = $[15], t9;
}
const booleanOperators = {
  booleanEqual: {
    nameKey: "search.operator.boolean-equal.name",
    descriptionKey: "search.operator.boolean-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => typeof value < "u" && fieldPath ? `${fieldPath} == ${toJSON(value)}` : null,
    initialValue: !0,
    inputComponent: SearchFilterBooleanInput,
    type: "booleanEqual"
  }
}, TimeLabelText = styled(Text$1).withConfig({
  displayName: "TimeLabelText",
  componentId: "sc-gdbody-0"
})`cursor:default;`;
function DateIncludeTimeFooter(t0) {
  const $ = c(14), {
    onChange,
    value
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("calendar.action.include-time-label"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== onChange || $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(TimeLabelText, { muted: !0, onClick: onChange, size: 1, weight: "medium", children: t1 }) }), $[2] = onChange, $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("calendar.action.include-time-label"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== onChange || $[8] !== t3 || $[9] !== value ? (t4 = /* @__PURE__ */ jsx(Switch$1, { checked: value, label: t3, onChange }), $[7] = onChange, $[8] = t3, $[9] = value, $[10] = t4) : t4 = $[10];
  let t5;
  return $[11] !== t2 || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, justify: "flex-end", marginTop: 1, children: [
    t2,
    t4
  ] }), $[11] = t2, $[12] = t4, $[13] = t5) : t5 = $[13], t5;
}
function useCalendar() {
  const context = useContext(CalendarContext);
  if (context === void 0)
    throw new Error("useCalendar must be used within an CalendarContext.Provider");
  return context;
}
function CalendarHeader(props2) {
  const $ = c(39), {
    t
  } = useTranslation();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    month: "long",
    year: "numeric"
  }, $[0] = t0) : t0 = $[0];
  const monthFormatter = useDateTimeFormat(t0), {
    focusedDate
  } = useCalendar(), {
    moveFocusedDate,
    onNowClick
  } = props2;
  let t1;
  $[1] !== moveFocusedDate ? (t1 = () => moveFocusedDate(-1), $[1] = moveFocusedDate, $[2] = t1) : t1 = $[2];
  const handlePrevMonthClick = t1;
  let t2;
  $[3] !== moveFocusedDate ? (t2 = () => moveFocusedDate(1), $[3] = moveFocusedDate, $[4] = t2) : t2 = $[4];
  const handleNextMonthClick = t2;
  let t3;
  $[5] !== focusedDate || $[6] !== monthFormatter ? (t3 = upperFirst(monthFormatter.format(focusedDate)), $[5] = focusedDate, $[6] = monthFormatter, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(Inline, { paddingLeft: 2, space: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t3 }) }), $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== t ? (t5 = t("calendar.action.go-to-today-aria-label"), $[10] = t, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t ? (t6 = t("calendar.action.go-to-today"), $[12] = t, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== onNowClick || $[15] !== t5 || $[16] !== t6 ? (t7 = /* @__PURE__ */ jsx(Button, { "aria-label": t5, mode: "bleed", onClick: onNowClick, text: t6 }), $[14] = onNowClick, $[15] = t5, $[16] = t6, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== t ? (t8 = t("calendar.action.go-to-previous-month"), $[18] = t, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== t8 ? (t9 = {
    content: t8
  }, $[20] = t8, $[21] = t9) : t9 = $[21];
  let t10;
  $[22] !== handlePrevMonthClick || $[23] !== t9 ? (t10 = /* @__PURE__ */ jsx(Button, { icon: ChevronLeftIcon, mode: "bleed", onClick: handlePrevMonthClick, tooltipProps: t9 }), $[22] = handlePrevMonthClick, $[23] = t9, $[24] = t10) : t10 = $[24];
  let t11;
  $[25] !== t ? (t11 = t("calendar.action.go-to-next-month"), $[25] = t, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== t11 ? (t12 = {
    content: t11
  }, $[27] = t11, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== handleNextMonthClick || $[30] !== t12 ? (t13 = /* @__PURE__ */ jsx(Button, { icon: ChevronRightIcon, mode: "bleed", onClick: handleNextMonthClick, tooltipProps: t12 }), $[29] = handleNextMonthClick, $[30] = t12, $[31] = t13) : t13 = $[31];
  let t14;
  $[32] !== t10 || $[33] !== t13 || $[34] !== t7 ? (t14 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t7,
    t10,
    t13
  ] }), $[32] = t10, $[33] = t13, $[34] = t7, $[35] = t14) : t14 = $[35];
  let t15;
  return $[36] !== t14 || $[37] !== t4 ? (t15 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, justify: "space-between", children: [
    t4,
    t14
  ] }), $[36] = t14, $[37] = t4, $[38] = t15) : t15 = $[38], t15;
}
const CircleSvg = /* @__PURE__ */ styled.svg.withConfig({
  displayName: "CircleSvg",
  componentId: "sc-558x4k-0"
})(({
  theme
}) => css`
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;

    circle {
      stroke: ${theme.sanity.color.card.enabled.border};
      stroke-width: 3;
      fill: none;
    }
  `), CustomCard = styled(Card).withConfig({
  displayName: "CustomCard",
  componentId: "sc-558x4k-1"
})`position:relative;&[data-focused='true']{z-index:1;}&[data-start-date='true']{border-top-right-radius:0;border-bottom-right-radius:0;}&[data-end-date='true']{border-top-left-radius:0;border-bottom-left-radius:0;}&[data-within-range='true']{border-radius:0;}`;
function CalendarDay$2(t0) {
  const $ = c(41), {
    date,
    onSelect
  } = t0;
  let t1;
  $[0] !== date || $[1] !== onSelect ? (t1 = () => {
    onSelect(date);
  }, $[0] = date, $[1] = onSelect, $[2] = t1) : t1 = $[2];
  const handleClick = t1, {
    date: selectedDate,
    endDate: selectedEndDate,
    focusedDate,
    selectRange
  } = useCalendar();
  let t2;
  $[3] !== date || $[4] !== selectedDate ? (t2 = selectedDate && isSameDay(date, selectedDate), $[3] = date, $[4] = selectedDate, $[5] = t2) : t2 = $[5];
  const isSelected = t2;
  let t3;
  $[6] !== date || $[7] !== selectRange || $[8] !== selectedDate ? (t3 = selectRange && selectedDate && isSameDay(date, selectedDate), $[6] = date, $[7] = selectRange, $[8] = selectedDate, $[9] = t3) : t3 = $[9];
  const isStartDate = t3;
  let t4;
  $[10] !== date || $[11] !== selectRange || $[12] !== selectedEndDate ? (t4 = selectRange && selectedEndDate && isSameDay(date, selectedEndDate), $[10] = date, $[11] = selectRange, $[12] = selectedEndDate, $[13] = t4) : t4 = $[13];
  const isEndDate = t4;
  let t5;
  $[14] !== date || $[15] !== focusedDate ? (t5 = isSameMonth(date, focusedDate), $[14] = date, $[15] = focusedDate, $[16] = t5) : t5 = $[16];
  const isCurrentMonth = t5, isFocused = focusedDate && isSameDay(date, focusedDate);
  let t6;
  $[17] !== date ? (t6 = isSameDay(date, /* @__PURE__ */ new Date()), $[17] = date, $[18] = t6) : t6 = $[18];
  const isToday2 = t6, isWithinRange = selectedDate && selectedEndDate && !isStartDate && !isEndDate && isAfter(date, selectedDate) && isBefore(date, selectedEndDate);
  let t7;
  $[19] !== date ? (t7 = date.toDateString(), $[19] = date, $[20] = t7) : t7 = $[20];
  const t8 = isEndDate ? !0 : void 0, t9 = isFocused ? "true" : "", t10 = isStartDate ? !0 : void 0, t11 = isWithinRange ? !0 : void 0, t12 = isSelected || isStartDate || isEndDate, t13 = isWithinRange ? "primary" : "default";
  let t14;
  $[21] !== isToday2 ? (t14 = isToday2 && /* @__PURE__ */ jsx(CircleSvg, { height: "100%", preserveAspectRatio: "xMidYMid meet", vectorEffect: "non-scaling-stroke", viewBox: "0 0 100 100", width: "100%", children: /* @__PURE__ */ jsx("circle", { cx: "50", cy: "50", r: "40%" }) }), $[21] = isToday2, $[22] = t14) : t14 = $[22];
  const t15 = !isSelected && !isCurrentMonth, t16 = isCurrentMonth ? "medium" : "regular";
  let t17;
  $[23] !== date ? (t17 = date.getDate(), $[23] = date, $[24] = t17) : t17 = $[24];
  let t18;
  $[25] !== t15 || $[26] !== t16 || $[27] !== t17 ? (t18 = /* @__PURE__ */ jsx(Text$1, { align: "center", muted: t15, size: 1, weight: t16, children: t17 }), $[25] = t15, $[26] = t16, $[27] = t17, $[28] = t18) : t18 = $[28];
  let t19;
  return $[29] !== handleClick || $[30] !== isSelected || $[31] !== t10 || $[32] !== t11 || $[33] !== t12 || $[34] !== t13 || $[35] !== t14 || $[36] !== t18 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9 ? (t19 = /* @__PURE__ */ jsxs(CustomCard, { __unstable_focusRing: !0, "aria-label": t7, "aria-pressed": isSelected, "data-end-date": t8, "data-focused": t9, "data-ui": "CalendarDay", "aria-selected": isSelected, "data-start-date": t10, "data-within-range": t11, forwardedAs: "button", onClick: handleClick, paddingX: 3, paddingY: 2, radius: 2, role: "button", selected: t12, tabIndex: -1, tone: t13, children: [
    t14,
    t18
  ] }), $[29] = handleClick, $[30] = isSelected, $[31] = t10, $[32] = t11, $[33] = t12, $[34] = t13, $[35] = t14, $[36] = t18, $[37] = t7, $[38] = t8, $[39] = t9, $[40] = t19) : t19 = $[40], t19;
}
const SHORT_WEEK_DAY_KEYS = ["calendar.weekday-names.short.monday", "calendar.weekday-names.short.tuesday", "calendar.weekday-names.short.wednesday", "calendar.weekday-names.short.thursday", "calendar.weekday-names.short.friday", "calendar.weekday-names.short.saturday", "calendar.weekday-names.short.sunday"], ARROW_KEYS$1 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], TAIL_WEEKDAYS$1 = [1, 2, 3, 4, 5, 6], getWeekStartsOfMonth$1 = (date, weekStartsOn) => {
  const firstDay = startOfMonth(date);
  return eachWeekOfInterval({
    start: firstDay,
    end: lastDayOfMonth(firstDay)
  }, {
    weekStartsOn: weekStartsOn === 7 ? 0 : weekStartsOn
  });
}, getWeekDaysFromWeekStarts$1 = (weekStarts) => weekStarts.map((weekStart) => [weekStart, ...TAIL_WEEKDAYS$1.map((d) => addDays(weekStart, d))]), useWeeksOfMonth = (date) => {
  const $ = c(3), {
    weekInfo
  } = useCurrentLocale();
  let t0;
  return $[0] !== date || $[1] !== weekInfo.firstDay ? (t0 = getWeekDaysFromWeekStarts$1(getWeekStartsOfMonth$1(date, weekInfo.firstDay)).map(_temp$1f), $[0] = date, $[1] = weekInfo.firstDay, $[2] = t0) : t0 = $[2], t0;
};
function _temp$1f(days) {
  return {
    number: getWeek(days[0]),
    days
  };
}
const WEEK_DAY_NAME_KEYS = {
  // Monday is start of the week
  1: SHORT_WEEK_DAY_KEYS,
  // Saturday is start of week
  6: [...SHORT_WEEK_DAY_KEYS.slice(5), ...SHORT_WEEK_DAY_KEYS.slice(0, 5)],
  // Sunday is start of the week
  7: [SHORT_WEEK_DAY_KEYS[6], ...SHORT_WEEK_DAY_KEYS.slice(0, 6)]
}, CustomGrid = styled(Grid).withConfig({
  displayName: "CustomGrid",
  componentId: "sc-72z3fa-0"
})`grid-template-columns:repeat(7,minmax(44px,auto));`;
function CalendarMonth$1(t0) {
  const $ = c(16), {
    hidden,
    onSelect
  } = t0, {
    focusedDate,
    firstWeekDay
  } = useCalendar(), {
    t
  } = useTranslation(), t1 = hidden || !1, t2 = WEEK_DAY_NAME_KEYS[firstWeekDay];
  let t3;
  if ($[0] !== t || $[1] !== t2) {
    let t42;
    $[3] !== t ? (t42 = (weekdayDay) => /* @__PURE__ */ jsx(Box, { paddingBottom: 3, paddingTop: 2, children: /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, weight: "medium", children: t(weekdayDay) }) }, weekdayDay), $[3] = t, $[4] = t42) : t42 = $[4], t3 = t2.map(t42), $[0] = t, $[1] = t2, $[2] = t3;
  } else
    t3 = $[2];
  const t4 = useWeeksOfMonth(focusedDate);
  let t5;
  if ($[5] !== onSelect || $[6] !== t4) {
    let t62;
    $[8] !== onSelect ? (t62 = (week, weekIdx) => week.days.map((weekDayDate, dayIdx) => /* @__PURE__ */ jsx(CalendarDay$2, { date: weekDayDate, onSelect }, `${weekIdx}-${dayIdx}`)), $[8] = onSelect, $[9] = t62) : t62 = $[9], t5 = t4.map(t62), $[5] = onSelect, $[6] = t4, $[7] = t5;
  } else
    t5 = $[7];
  let t6;
  $[10] !== t3 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsxs(CustomGrid, { gapY: 1, children: [
    t3,
    t5
  ] }), $[10] = t3, $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  return $[13] !== t1 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsx(Box, { "aria-hidden": t1, "data-ui": "CalendarMonth", children: t6 }), $[13] = t1, $[14] = t6, $[15] = t7) : t7 = $[15], t7;
}
const PRESERVE_FOCUS_ELEMENT$1 = /* @__PURE__ */ jsx("span", { "data-preserve-focus": !0, style: {
  overflow: "hidden",
  position: "absolute",
  outline: "none"
}, tabIndex: -1 });
function Calendar$1(props2) {
  const $ = c(53), {
    date,
    endDate,
    onSelect,
    selectRange,
    selectTime
  } = props2, [calendarElement, setCalendarElement] = useState(null), [selectEndValue, setSelectEndValue] = useState(!1);
  let t0;
  $[0] !== date ? (t0 = date || /* @__PURE__ */ new Date(), $[0] = date, $[1] = t0) : t0 = $[1];
  const [focusedDate, setFocusedDate] = useState(t0), previousDate = useRef(date || null), previousEndDate = useRef(endDate || null), {
    weekInfo: t1
  } = useCurrentLocale(), {
    firstDay: firstWeekDay
  } = t1;
  let t2;
  $[2] !== calendarElement ? (t2 = () => {
    calendarElement?.querySelector('[data-focused="true"]')?.focus();
  }, $[2] = calendarElement, $[3] = t2) : t2 = $[3];
  const focusCurrentWeekDay = t2;
  let t3;
  $[4] !== date || $[5] !== endDate || $[6] !== onSelect || $[7] !== selectEndValue || $[8] !== selectRange ? (t3 = (d) => {
    const selectedDate = set$3(d, {
      hours: d.getHours(),
      minutes: d.getMinutes(),
      seconds: 0,
      milliseconds: 0
    }), dateIsBeforeStartDate = date && isBefore(selectedDate, date), dateIsAfterEndDate = endDate && isAfter(selectedDate, endDate);
    if (selectRange) {
      if (dateIsBeforeStartDate || dateIsAfterEndDate) {
        onSelect({
          date: selectedDate,
          endDate: null
        });
        return;
      }
      onSelect(selectEndValue ? {
        date: date || null,
        endDate: selectedDate
      } : {
        date: selectedDate,
        endDate: date ? null : endDate || null
      });
    } else
      onSelect({
        date: selectedDate
      });
  }, $[4] = date, $[5] = endDate, $[6] = onSelect, $[7] = selectEndValue, $[8] = selectRange, $[9] = t3) : t3 = $[9];
  const handleDateChange = t3;
  let t4;
  $[10] !== onSelect || $[11] !== selectRange ? (t4 = () => {
    const now = /* @__PURE__ */ new Date();
    selectRange ? setFocusedDate(now) : onSelect({
      date: now
    });
  }, $[10] = onSelect, $[11] = selectRange, $[12] = t4) : t4 = $[12];
  const handleNowClick = t4;
  let t5;
  $[13] !== calendarElement || $[14] !== focusCurrentWeekDay || $[15] !== focusedDate ? (t5 = (event) => {
    if (ARROW_KEYS$1.includes(event.key)) {
      if (event.preventDefault(), event.target.hasAttribute("data-calendar-grid")) {
        focusCurrentWeekDay();
        return;
      }
      event.key === "ArrowUp" && setFocusedDate(addDays(focusedDate, -7)), event.key === "ArrowDown" && setFocusedDate(addDays(focusedDate, 7)), event.key === "ArrowLeft" && setFocusedDate(addDays(focusedDate, -1)), event.key === "ArrowRight" && setFocusedDate(addDays(focusedDate, 1)), calendarElement?.querySelector("[data-preserve-focus]")?.focus();
    }
  }, $[13] = calendarElement, $[14] = focusCurrentWeekDay, $[15] = focusedDate, $[16] = t5) : t5 = $[16];
  const handleKeyDown = t5;
  let t6;
  $[17] !== focusedDate ? (t6 = (by) => setFocusedDate(addMonths(focusedDate, by)), $[17] = focusedDate, $[18] = t6) : t6 = $[18];
  const moveFocusedDate = t6;
  let t7, t8;
  $[19] !== focusCurrentWeekDay ? (t7 = () => {
    focusCurrentWeekDay();
  }, t8 = [focusCurrentWeekDay], $[19] = focusCurrentWeekDay, $[20] = t7, $[21] = t8) : (t7 = $[20], t8 = $[21]), useEffect(t7, t8);
  let t9;
  $[22] !== focusCurrentWeekDay ? (t9 = () => {
    document.activeElement?.matches("[data-calendar-grid], [data-calendar-grid] [data-preserve-focus]") && focusCurrentWeekDay();
  }, $[22] = focusCurrentWeekDay, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== focusCurrentWeekDay || $[25] !== focusedDate ? (t10 = [focusCurrentWeekDay, focusedDate], $[24] = focusCurrentWeekDay, $[25] = focusedDate, $[26] = t10) : t10 = $[26], useEffect(t9, t10);
  let t11, t12;
  $[27] !== date || $[28] !== endDate || $[29] !== onSelect ? (t11 = () => {
    const dateChanged = date?.getTime() !== previousDate.current?.getTime(), endDateChanged = endDate?.getTime() !== previousEndDate.current?.getTime(), onlyDateChanged = dateChanged && !endDateChanged, onlyEndDateChanged = !dateChanged && endDateChanged, dateIsAfterEndDate_0 = date && endDate && isAfter(date, endDate);
    onlyDateChanged && (dateIsAfterEndDate_0 && (setSelectEndValue(!0), onSelect({
      date,
      endDate: null
    })), setSelectEndValue(!!date), date && setFocusedDate(date)), onlyEndDateChanged && (dateIsAfterEndDate_0 && (setSelectEndValue(!0), onSelect({
      date: endDate,
      endDate: null
    })), setSelectEndValue(!!date && !endDate), endDate && setFocusedDate(endDate)), dateChanged && endDateChanged && (setSelectEndValue(!0), date && setFocusedDate(date)), previousDate.current = date || null, previousEndDate.current = endDate || null;
  }, t12 = [date, endDate, onSelect], $[27] = date, $[28] = endDate, $[29] = onSelect, $[30] = t11, $[31] = t12) : (t11 = $[30], t12 = $[31]), useEffect(t11, t12);
  let t13;
  $[32] !== date || $[33] !== endDate || $[34] !== firstWeekDay || $[35] !== focusedDate || $[36] !== selectRange || $[37] !== selectTime ? (t13 = {
    date,
    endDate,
    focusedDate,
    selectRange,
    selectTime,
    firstWeekDay
  }, $[32] = date, $[33] = endDate, $[34] = firstWeekDay, $[35] = focusedDate, $[36] = selectRange, $[37] = selectTime, $[38] = t13) : t13 = $[38];
  const value = t13;
  let t14;
  $[39] !== handleNowClick || $[40] !== moveFocusedDate ? (t14 = /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(CalendarHeader, { moveFocusedDate, onNowClick: handleNowClick }) }) }), $[39] = handleNowClick, $[40] = moveFocusedDate, $[41] = t14) : t14 = $[41];
  let t15;
  $[42] !== handleDateChange ? (t15 = /* @__PURE__ */ jsx(CalendarMonth$1, { onSelect: handleDateChange }), $[42] = handleDateChange, $[43] = t15) : t15 = $[43];
  let t16;
  $[44] !== handleKeyDown || $[45] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Box, { "data-calendar-grid": !0, onKeyDown: handleKeyDown, marginTop: 2, overflow: "hidden", tabIndex: 0, children: [
    t15,
    PRESERVE_FOCUS_ELEMENT$1
  ] }), $[44] = handleKeyDown, $[45] = t15, $[46] = t16) : t16 = $[46];
  let t17;
  $[47] !== t14 || $[48] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Box, { "data-ui": "Calendar", ref: setCalendarElement, children: [
    t14,
    t16
  ] }), $[47] = t14, $[48] = t16, $[49] = t17) : t17 = $[49];
  let t18;
  return $[50] !== t17 || $[51] !== value ? (t18 = /* @__PURE__ */ jsx(CalendarContext.Provider, { value, children: t17 }), $[50] = t17, $[51] = value, $[52] = t18) : t18 = $[52], t18;
}
function DatePicker$1(t0) {
  const $ = c(8), {
    date,
    endDate,
    onChange,
    selectRange,
    selectTime
  } = t0;
  let t1;
  $[0] !== onChange ? (t1 = (dates) => {
    onChange(dates);
  }, $[0] = onChange, $[1] = t1) : t1 = $[1];
  const handleSelect = t1;
  let t2;
  return $[2] !== date || $[3] !== endDate || $[4] !== handleSelect || $[5] !== selectRange || $[6] !== selectTime ? (t2 = /* @__PURE__ */ jsx(Calendar$1, { date, endDate, onSelect: handleSelect, selectRange, selectTime }), $[2] = date, $[3] = endDate, $[4] = handleSelect, $[5] = selectRange, $[6] = selectTime, $[7] = t2) : t2 = $[7], t2;
}
function getDateISOString({
  date,
  dateOnly,
  roundDay
}) {
  let adjustedDate;
  switch (roundDay) {
    case "end":
      adjustedDate = endOfDay(date);
      break;
    case "start":
      adjustedDate = startOfDay(date);
      break;
    default:
      adjustedDate = date;
      break;
  }
  return dateOnly ? adjustedDate.toISOString().split("T")[0] : adjustedDate.toISOString();
}
const FORMAT = {
  date: {
    exampleDate: "Jan 1, 2000",
    pattern: "MMM d, yyyy"
  },
  datetime: {
    exampleDate: "Jan 1, 2000 12:00 AM",
    pattern: "MMM d, yyyy p"
  }
};
function ParsedDateTextInput(t0) {
  const $ = c(53);
  let isDateTime, isDateTimeFormat, onChange, placeholderDate, rest, value;
  $[0] !== t0 ? ({
    isDateTime,
    onChange,
    placeholderDate,
    isDateTimeFormat,
    value,
    ...rest
  } = t0, $[0] = t0, $[1] = isDateTime, $[2] = isDateTimeFormat, $[3] = onChange, $[4] = placeholderDate, $[5] = rest, $[6] = value) : (isDateTime = $[1], isDateTimeFormat = $[2], onChange = $[3], placeholderDate = $[4], rest = $[5], value = $[6]);
  const {
    t
  } = useTranslation(), dateFormat = isDateTimeFormat ? FORMAT.datetime.pattern : FORMAT.date.pattern, [customValidity, setCustomValidity] = useState(void 0);
  let t1;
  $[7] !== dateFormat || $[8] !== value ? (t1 = () => {
    if (!value)
      return "";
    const inputValueDate = new Date(value);
    return format(inputValueDate, dateFormat);
  }, $[7] = dateFormat, $[8] = value, $[9] = t1) : t1 = $[9];
  const [inputValue, setInputValue] = useState(t1);
  let t2;
  $[10] !== placeholderDate ? (t2 = placeholderDate || /* @__PURE__ */ new Date(), $[10] = placeholderDate, $[11] = t2) : t2 = $[11];
  const date = t2;
  let t3;
  $[12] !== date || $[13] !== dateFormat ? (t3 = format(date, dateFormat), $[12] = date, $[13] = dateFormat, $[14] = t3) : t3 = $[14];
  const formattedPlaceholder = t3;
  let t4;
  $[15] !== dateFormat || $[16] !== isDateTime || $[17] !== onChange ? (t4 = (t52) => {
    const {
      dateString,
      triggerOnChange
    } = t52;
    if (!dateString)
      return;
    const dateParsed = parse(dateString, dateFormat, /* @__PURE__ */ new Date()), validDate = isValid(dateParsed);
    validDate && (triggerOnChange && onChange(getDateISOString({
      date: dateParsed,
      dateOnly: !isDateTime
    })), setInputValue(format(dateParsed, dateFormat))), setCustomValidity(validDate ? void 0 : `Invalid ${isDateTime ? "datetime" : "date"}`);
  }, $[15] = dateFormat, $[16] = isDateTime, $[17] = onChange, $[18] = t4) : t4 = $[18];
  const processInputString = t4;
  let t5;
  $[19] !== inputValue || $[20] !== processInputString ? (t5 = () => {
    processInputString({
      dateString: inputValue,
      triggerOnChange: !0
    });
  }, $[19] = inputValue, $[20] = processInputString, $[21] = t5) : t5 = $[21];
  const handleTextInputBlur = t5;
  let t6;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = (event) => {
    setInputValue(event.currentTarget.value);
  }, $[22] = t6) : t6 = $[22];
  const handleTextInputChange = t6;
  let t7;
  $[23] !== onChange ? (t7 = () => {
    onChange(null), setCustomValidity(void 0), setInputValue("");
  }, $[23] = onChange, $[24] = t7) : t7 = $[24];
  const handleTextInputClear = t7;
  let t8;
  $[25] !== inputValue || $[26] !== processInputString ? (t8 = (event_0) => {
    event_0.key === "Enter" && processInputString({
      dateString: inputValue,
      triggerOnChange: !0
    });
  }, $[25] = inputValue, $[26] = processInputString, $[27] = t8) : t8 = $[27];
  const handleTextInputKeyDown = t8;
  let t9;
  $[28] !== dateFormat || $[29] !== processInputString || $[30] !== value ? (t9 = () => {
    const updatedDate = value && new Date(value);
    updatedDate && processInputString({
      dateString: format(updatedDate, dateFormat),
      triggerOnChange: !1
    });
  }, $[28] = dateFormat, $[29] = processInputString, $[30] = value, $[31] = t9) : t9 = $[31];
  let t10;
  $[32] !== dateFormat || $[33] !== isDateTimeFormat || $[34] !== processInputString || $[35] !== value ? (t10 = [dateFormat, processInputString, isDateTimeFormat, value], $[32] = dateFormat, $[33] = isDateTimeFormat, $[34] = processInputString, $[35] = value, $[36] = t10) : t10 = $[36], useEffect(t9, t10);
  const t11 = isDateTimeFormat ? FORMAT.datetime.exampleDate : FORMAT.date.exampleDate;
  let t12;
  $[37] !== t || $[38] !== t11 ? (t12 = t("calendar.error.must-be-in-format", {
    exampleDate: t11
  }), $[37] = t, $[38] = t11, $[39] = t12) : t12 = $[39];
  const t13 = !customValidity, t14 = !!inputValue;
  let t15;
  $[40] !== customValidity || $[41] !== formattedPlaceholder || $[42] !== handleTextInputBlur || $[43] !== handleTextInputClear || $[44] !== handleTextInputKeyDown || $[45] !== inputValue || $[46] !== rest || $[47] !== t14 ? (t15 = /* @__PURE__ */ jsx(CustomTextInput, { ...rest, clearButton: t14, customValidity, onBlur: handleTextInputBlur, onChange: handleTextInputChange, onClear: handleTextInputClear, onKeyDown: handleTextInputKeyDown, placeholder: formattedPlaceholder, value: inputValue }), $[40] = customValidity, $[41] = formattedPlaceholder, $[42] = handleTextInputBlur, $[43] = handleTextInputClear, $[44] = handleTextInputKeyDown, $[45] = inputValue, $[46] = rest, $[47] = t14, $[48] = t15) : t15 = $[48];
  let t16;
  return $[49] !== t12 || $[50] !== t13 || $[51] !== t15 ? (t16 = /* @__PURE__ */ jsx(Tooltip, { content: t12, disabled: t13, placement: "top", portal: !0, children: t15 }), $[49] = t12, $[50] = t13, $[51] = t15, $[52] = t16) : t16 = $[52], t16;
}
function CommonDateDirectionInput(t0) {
  const $ = c(36), {
    direction,
    isDateTime,
    onChange,
    value
  } = t0, {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  bb0: switch (direction) {
    case "after": {
      t2 = "end";
      break bb0;
    }
    case "before": {
      t2 = "start";
      break bb0;
    }
    default:
      t2 = void 0;
  }
  const roundDay = t2;
  let t3;
  $[0] !== isDateTime || $[1] !== onChange || $[2] !== roundDay || $[3] !== value?.includeTime ? (t3 = (t42) => {
    const {
      date
    } = t42;
    let dateISOString = null;
    date && (dateISOString = getDateISOString({
      date,
      dateOnly: !isDateTime,
      roundDay: value?.includeTime ? void 0 : roundDay
    })), onChange({
      includeTime: value?.includeTime,
      date: dateISOString
    });
  }, $[0] = isDateTime, $[1] = onChange, $[2] = roundDay, $[3] = value?.includeTime, $[4] = t3) : t3 = $[4];
  const handleDatePickerChange = t3;
  let t4;
  $[5] !== isDateTime || $[6] !== onChange || $[7] !== roundDay || $[8] !== value ? (t4 = () => {
    const includeTime = !value?.includeTime, date_0 = value?.date ? new Date(value.date) : null;
    let dateISOString_0 = null;
    date_0 && (dateISOString_0 = getDateISOString({
      date: date_0,
      dateOnly: !isDateTime,
      roundDay: includeTime ? "start" : roundDay
    })), onChange({
      includeTime,
      date: dateISOString_0
    });
  }, $[5] = isDateTime, $[6] = onChange, $[7] = roundDay, $[8] = value, $[9] = t4) : t4 = $[9];
  const handleIncludeTimeChange = t4;
  let t5;
  $[10] !== onChange || $[11] !== value?.includeTime ? (t5 = (date_1) => {
    onChange({
      includeTime: value?.includeTime,
      date: date_1 || null
    });
  }, $[10] = onChange, $[11] = value?.includeTime, $[12] = t5) : t5 = $[12];
  const handleTextDateChange = t5;
  let t6;
  $[13] !== t ? (t6 = t("search.filter-date-aria-label"), $[13] = t, $[14] = t6) : t6 = $[14];
  const t7 = fullscreen ? 2 : 1, t8 = isDateTime && value?.includeTime, t9 = value?.date;
  let t10;
  $[15] !== handleTextDateChange || $[16] !== isDateTime || $[17] !== t6 || $[18] !== t7 || $[19] !== t8 || $[20] !== t9 ? (t10 = /* @__PURE__ */ jsx(ParsedDateTextInput, { "aria-label": t6, fontSize: t7, isDateTime, isDateTimeFormat: t8, onChange: handleTextDateChange, radius: 2, value: t9 }), $[15] = handleTextDateChange, $[16] = isDateTime, $[17] = t6, $[18] = t7, $[19] = t8, $[20] = t9, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== value ? (t11 = value?.date ? new Date(value.date) : void 0, $[22] = value, $[23] = t11) : t11 = $[23];
  let t12;
  $[24] !== handleDatePickerChange || $[25] !== isDateTime || $[26] !== t11 ? (t12 = /* @__PURE__ */ jsx(DatePicker$1, { date: t11, onChange: handleDatePickerChange, selectTime: isDateTime }), $[24] = handleDatePickerChange, $[25] = isDateTime, $[26] = t11, $[27] = t12) : t12 = $[27];
  let t13;
  $[28] !== handleIncludeTimeChange || $[29] !== isDateTime || $[30] !== value?.includeTime ? (t13 = isDateTime && /* @__PURE__ */ jsx(DateIncludeTimeFooter, { onChange: handleIncludeTimeChange, value: !!value?.includeTime }), $[28] = handleIncludeTimeChange, $[29] = isDateTime, $[30] = value?.includeTime, $[31] = t13) : t13 = $[31];
  let t14;
  return $[32] !== t10 || $[33] !== t12 || $[34] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t10,
    t12,
    t13
  ] }), $[32] = t10, $[33] = t12, $[34] = t13, $[35] = t14) : t14 = $[35], t14;
}
function SearchFilterDateAfterInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateDirectionInput, { ...props2, direction: "after", isDateTime: !1 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function SearchFilterDateBeforeInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateDirectionInput, { ...props2, direction: "before", isDateTime: !1 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function CommonDateEqualInput(t0) {
  const $ = c(34), {
    isDateTime,
    onChange,
    value
  } = t0, {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] !== isDateTime || $[1] !== onChange || $[2] !== value?.includeTime ? (t2 = (t32) => {
    const {
      date
    } = t32;
    if (date) {
      const dateISOString = getDateISOString({
        date,
        dateOnly: !isDateTime
      });
      onChange({
        includeTime: value?.includeTime,
        date: dateISOString
      });
    } else
      onChange(null);
  }, $[0] = isDateTime, $[1] = onChange, $[2] = value?.includeTime, $[3] = t2) : t2 = $[3];
  const handleDatePickerChange = t2;
  let t3;
  $[4] !== isDateTime || $[5] !== onChange || $[6] !== value ? (t3 = () => {
    const includeTime = !value?.includeTime, date_0 = value?.date ? new Date(value.date) : null;
    let dateISOString_0 = null;
    date_0 && (dateISOString_0 = getDateISOString({
      date: date_0,
      dateOnly: !isDateTime
    })), onChange({
      includeTime,
      date: dateISOString_0
    });
  }, $[4] = isDateTime, $[5] = onChange, $[6] = value, $[7] = t3) : t3 = $[7];
  const handleIncludeTimeChange = t3;
  let t4;
  $[8] !== onChange || $[9] !== value?.includeTime ? (t4 = (date_1) => {
    onChange({
      includeTime: value?.includeTime,
      date: date_1 || null
    });
  }, $[8] = onChange, $[9] = value?.includeTime, $[10] = t4) : t4 = $[10];
  const handleTextDateChange = t4;
  let t5;
  $[11] !== t ? (t5 = t("search.filter-date-aria-label"), $[11] = t, $[12] = t5) : t5 = $[12];
  const t6 = fullscreen ? 2 : 1, t7 = isDateTime && value?.includeTime, t8 = value?.date;
  let t9;
  $[13] !== handleTextDateChange || $[14] !== isDateTime || $[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsx(ParsedDateTextInput, { "aria-label": t5, fontSize: t6, isDateTime, isDateTimeFormat: t7, onChange: handleTextDateChange, radius: 2, value: t8 }), $[13] = handleTextDateChange, $[14] = isDateTime, $[15] = t5, $[16] = t6, $[17] = t7, $[18] = t8, $[19] = t9) : t9 = $[19];
  let t10;
  $[20] !== value ? (t10 = value?.date ? new Date(value.date) : void 0, $[20] = value, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== handleDatePickerChange || $[23] !== isDateTime || $[24] !== t10 ? (t11 = /* @__PURE__ */ jsx(DatePicker$1, { date: t10, onChange: handleDatePickerChange, selectTime: isDateTime }), $[22] = handleDatePickerChange, $[23] = isDateTime, $[24] = t10, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== handleIncludeTimeChange || $[27] !== isDateTime || $[28] !== value?.includeTime ? (t12 = isDateTime && /* @__PURE__ */ jsx(DateIncludeTimeFooter, { onChange: handleIncludeTimeChange, value: !!value?.includeTime }), $[26] = handleIncludeTimeChange, $[27] = isDateTime, $[28] = value?.includeTime, $[29] = t12) : t12 = $[29];
  let t13;
  return $[30] !== t11 || $[31] !== t12 || $[32] !== t9 ? (t13 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t9,
    t11,
    t12
  ] }), $[30] = t11, $[31] = t12, $[32] = t9, $[33] = t13) : t13 = $[33], t13;
}
function SearchFilterDateEqualInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateEqualInput, { ...props2, isDateTime: !1 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
const UNIT_CHOICES = [{
  unit: "day",
  key: "search.filter-date-unit_days"
}, {
  unit: "month",
  key: "search.filter-date-unit_months"
}, {
  unit: "year",
  key: "search.filter-date-unit_years"
}];
function SearchFilterDateLastInput(t0) {
  const $ = c(26), {
    onChange,
    value
  } = t0, [uncontrolledValue, setUncontrolledValue] = useState(value?.unitValue || ""), dateUnit = useRef("day"), dateValue = useRef(value?.unitValue || null), {
    t
  } = useTranslation(), {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1;
  let t2;
  $[0] !== onChange ? (t2 = () => {
    onChange({
      unit: dateUnit?.current,
      unitValue: dateValue?.current
    });
  }, $[0] = onChange, $[1] = t2) : t2 = $[1];
  const handleChange = t2;
  let t3;
  $[2] !== handleChange ? (t3 = (event) => {
    dateUnit.current = event.currentTarget.value, handleChange();
  }, $[2] = handleChange, $[3] = t3) : t3 = $[3];
  const handleUnitChange = t3;
  let t4;
  $[4] !== handleChange ? (t4 = (event_0) => {
    setUncontrolledValue(event_0.currentTarget.value);
    const numValue = parseFloat(event_0.currentTarget.value);
    dateValue.current = Number.isFinite(numValue) ? numValue : null, handleChange();
  }, $[4] = handleChange, $[5] = t4) : t4 = $[5];
  const handleValueChange = t4;
  let t5;
  $[6] !== t ? (t5 = t("search.filter-date-value-aria-label"), $[6] = t, $[7] = t5) : t5 = $[7];
  const t6 = fullscreen ? 2 : 1;
  let t7;
  $[8] !== handleValueChange || $[9] !== t5 || $[10] !== t6 || $[11] !== uncontrolledValue ? (t7 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(TextInput$1, { "aria-label": t5, fontSize: t6, onChange: handleValueChange, pattern: "\\d*", radius: 2, step: "1", type: "number", value: uncontrolledValue }) }), $[8] = handleValueChange, $[9] = t5, $[10] = t6, $[11] = uncontrolledValue, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== t ? (t8 = t("search.filter-date-unit-aria-label"), $[13] = t, $[14] = t8) : t8 = $[14];
  const t9 = fullscreen ? 2 : 1, t10 = value?.unit;
  let t11;
  $[15] !== t ? (t11 = UNIT_CHOICES.map((choice) => /* @__PURE__ */ jsx("option", { value: choice.unit, children: t(choice.key) }, choice.key)), $[15] = t, $[16] = t11) : t11 = $[16];
  let t12;
  $[17] !== handleUnitChange || $[18] !== t10 || $[19] !== t11 || $[20] !== t8 || $[21] !== t9 ? (t12 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Select, { "aria-label": t8, fontSize: t9, onChange: handleUnitChange, radius: 2, value: t10, children: t11 }) }), $[17] = handleUnitChange, $[18] = t10, $[19] = t11, $[20] = t8, $[21] = t9, $[22] = t12) : t12 = $[22];
  let t13;
  return $[23] !== t12 || $[24] !== t7 ? (t13 = /* @__PURE__ */ jsxs(Flex, { gap: 2, children: [
    t7,
    t12
  ] }), $[23] = t12, $[24] = t7, $[25] = t13) : t13 = $[25], t13;
}
const PLACEHOLDER_START_DATE_OFFSET = -7;
function CommonDateRangeInput(t0) {
  const $ = c(56), {
    isDateTime,
    onChange,
    value
  } = t0, {
    t
  } = useTranslation(), {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, [placeholderStartDate] = useState(_temp$1e), [placeholderEndDate] = useState(_temp2$s);
  let t2;
  $[0] !== isDateTime || $[1] !== onChange || $[2] !== value?.includeTime ? (t2 = (t32) => {
    const {
      date,
      endDate
    } = t32;
    onChange(getStartAndEndDate({
      date,
      endDate,
      includeTime: value?.includeTime,
      isDateTime
    }));
  }, $[0] = isDateTime, $[1] = onChange, $[2] = value?.includeTime, $[3] = t2) : t2 = $[3];
  const handleDatePickerChange = t2;
  let t3;
  $[4] !== isDateTime || $[5] !== onChange || $[6] !== value ? (t3 = () => {
    const includeTime = !value?.includeTime;
    onChange(getStartAndEndDate({
      date: value?.from ? new Date(value.from) : null,
      endDate: value?.to ? new Date(value.to) : null,
      includeTime,
      isDateTime
    }));
  }, $[4] = isDateTime, $[5] = onChange, $[6] = value, $[7] = t3) : t3 = $[7];
  const handleIncludeTimeChange = t3;
  let t4;
  $[8] !== onChange || $[9] !== value?.from || $[10] !== value?.includeTime ? (t4 = (date_0) => {
    onChange({
      includeTime: value?.includeTime,
      to: date_0 || null,
      from: value?.from || null
    });
  }, $[8] = onChange, $[9] = value?.from, $[10] = value?.includeTime, $[11] = t4) : t4 = $[11];
  const handleTextEndDateChange = t4;
  let t5;
  $[12] !== onChange || $[13] !== value?.includeTime || $[14] !== value?.to ? (t5 = (date_1) => {
    onChange({
      includeTime: value?.includeTime,
      to: value?.to || null,
      from: date_1 || null
    });
  }, $[12] = onChange, $[13] = value?.includeTime, $[14] = value?.to, $[15] = t5) : t5 = $[15];
  const handleTextStartDateChange = t5;
  let t6;
  $[16] !== t ? (t6 = t("search.filter-date-range-start-date-aria-label"), $[16] = t, $[17] = t6) : t6 = $[17];
  const t7 = fullscreen ? 2 : 1, t8 = isDateTime && value?.includeTime, t9 = value?.from;
  let t10;
  $[18] !== handleTextStartDateChange || $[19] !== isDateTime || $[20] !== placeholderStartDate || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9 ? (t10 = /* @__PURE__ */ jsx(ParsedDateTextInput, { "aria-label": t6, fontSize: t7, isDateTime, isDateTimeFormat: t8, onChange: handleTextStartDateChange, placeholderDate: placeholderStartDate, radius: 2, value: t9 }), $[18] = handleTextStartDateChange, $[19] = isDateTime, $[20] = placeholderStartDate, $[21] = t6, $[22] = t7, $[23] = t8, $[24] = t9, $[25] = t10) : t10 = $[25];
  let t11;
  $[26] !== t ? (t11 = t("search.filter-date-range-end-date-aria-label"), $[26] = t, $[27] = t11) : t11 = $[27];
  const t12 = fullscreen ? 2 : 1, t13 = isDateTime && value?.includeTime, t14 = value?.to;
  let t15;
  $[28] !== handleTextEndDateChange || $[29] !== isDateTime || $[30] !== placeholderEndDate || $[31] !== t11 || $[32] !== t12 || $[33] !== t13 || $[34] !== t14 ? (t15 = /* @__PURE__ */ jsx(ParsedDateTextInput, { "aria-label": t11, fontSize: t12, isDateTime, isDateTimeFormat: t13, onChange: handleTextEndDateChange, placeholderDate: placeholderEndDate, radius: 2, value: t14 }), $[28] = handleTextEndDateChange, $[29] = isDateTime, $[30] = placeholderEndDate, $[31] = t11, $[32] = t12, $[33] = t13, $[34] = t14, $[35] = t15) : t15 = $[35];
  let t16;
  $[36] !== t10 || $[37] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Flex, { direction: "column", gap: 3, children: [
    t10,
    t15
  ] }), $[36] = t10, $[37] = t15, $[38] = t16) : t16 = $[38];
  let t17;
  $[39] !== value ? (t17 = value?.from ? new Date(value.from) : void 0, $[39] = value, $[40] = t17) : t17 = $[40];
  let t18;
  $[41] !== value ? (t18 = value?.to ? new Date(value.to) : void 0, $[41] = value, $[42] = t18) : t18 = $[42];
  let t19;
  $[43] !== handleDatePickerChange || $[44] !== isDateTime || $[45] !== t17 || $[46] !== t18 ? (t19 = /* @__PURE__ */ jsx(DatePicker$1, { date: t17, endDate: t18, onChange: handleDatePickerChange, selectRange: !0, selectTime: isDateTime }), $[43] = handleDatePickerChange, $[44] = isDateTime, $[45] = t17, $[46] = t18, $[47] = t19) : t19 = $[47];
  let t20;
  $[48] !== handleIncludeTimeChange || $[49] !== isDateTime || $[50] !== value?.includeTime ? (t20 = isDateTime && /* @__PURE__ */ jsx(DateIncludeTimeFooter, { onChange: handleIncludeTimeChange, value: !!value?.includeTime }), $[48] = handleIncludeTimeChange, $[49] = isDateTime, $[50] = value?.includeTime, $[51] = t20) : t20 = $[51];
  let t21;
  return $[52] !== t16 || $[53] !== t19 || $[54] !== t20 ? (t21 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t16,
    t19,
    t20
  ] }) }), $[52] = t16, $[53] = t19, $[54] = t20, $[55] = t21) : t21 = $[55], t21;
}
function _temp2$s() {
  return /* @__PURE__ */ new Date();
}
function _temp$1e() {
  return addDays(/* @__PURE__ */ new Date(), PLACEHOLDER_START_DATE_OFFSET);
}
function getStartAndEndDate({
  date,
  endDate,
  includeTime,
  isDateTime
}) {
  return includeTime ? {
    includeTime,
    to: endDate ? getDateISOString({
      date: endDate,
      dateOnly: !isDateTime,
      roundDay: "start"
    }) : null,
    from: date ? getDateISOString({
      date,
      dateOnly: !isDateTime,
      roundDay: "start"
    }) : null
  } : {
    includeTime,
    to: endDate ? getDateISOString({
      date: endDate,
      dateOnly: !isDateTime,
      roundDay: "end"
    }) : null,
    from: date ? getDateISOString({
      date,
      dateOnly: !isDateTime,
      roundDay: "start"
    }) : null
  };
}
function SearchFilterDateRangeInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateRangeInput, { ...props2, isDateTime: !1 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function SearchFilterDateTimeAfterInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateDirectionInput, { ...props2, direction: "after", isDateTime: !0 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function SearchFilterDateTimeBeforeInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateDirectionInput, { ...props2, direction: "before", isDateTime: !0 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function SearchFilterDateTimeEqualInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateEqualInput, { ...props2, isDateTime: !0 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function SearchFilterDateTimeRangeInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateRangeInput, { ...props2, isDateTime: !0 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
const COMMON = {
  dateAfter: {
    buttonValueComponent: SearchButtonValueDate,
    initialValue: null
  },
  dateBefore: {
    buttonValueComponent: SearchButtonValueDate,
    initialValue: null
  },
  dateEqual: {
    buttonValueComponent: SearchButtonValueDate,
    initialValue: {
      date: null,
      includeTime: !1
    }
  },
  dateLast: {
    buttonValueComponent: SearchButtonValueDateLast
  },
  dateNotEqual: {
    buttonValueComponent: SearchButtonValueDate,
    initialValue: {
      date: null,
      includeTime: !1
    }
  },
  dateRange: {
    initialValue: null
  }
}, dateOperators = {
  dateAfter: {
    ...COMMON.dateAfter,
    nameKey: "search.operator.date-after.name",
    descriptionKey: "search.operator.date-after.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value?.date && fieldPath ? `${fieldPath} > ${toJSON(value?.date)}` : null,
    inputComponent: SearchFilterDateAfterInput,
    type: "dateAfter"
  },
  dateBefore: {
    ...COMMON.dateBefore,
    nameKey: "search.operator.date-before.name",
    descriptionKey: "search.operator.date-before.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value?.date && fieldPath ? `${fieldPath} < ${toJSON(value?.date)}` : null,
    inputComponent: SearchFilterDateBeforeInput,
    type: "dateBefore"
  },
  dateEqual: {
    ...COMMON.dateEqual,
    nameKey: "search.operator.date-equal.name",
    descriptionKey: "search.operator.date-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value?.date && fieldPath ? `${fieldPath} == ${toJSON(value.date)}` : null,
    inputComponent: SearchFilterDateEqualInput,
    type: "dateEqual"
  },
  dateLast: {
    ...COMMON.dateLast,
    nameKey: "search.operator.date-last.name",
    descriptionKey: "search.operator.date-last.description",
    groqFilter: ({
      fieldPath,
      value
    }) => {
      const flooredValue = typeof value?.unitValue == "number" ? Math.floor(value.unitValue) : void 0, timestampAgo = Number.isFinite(flooredValue) ? sub(/* @__PURE__ */ new Date(), {
        days: value?.unit === "day" ? flooredValue : 0,
        months: value?.unit === "month" ? flooredValue : 0,
        years: value?.unit === "year" ? flooredValue : 0
      }).toISOString().split("T")[0] : null;
      return timestampAgo && fieldPath ? `${fieldPath} > ${toJSON(timestampAgo)}` : null;
    },
    inputComponent: SearchFilterDateLastInput,
    initialValue: {
      unit: "day",
      unitValue: 7
    },
    type: "dateLast"
  },
  dateNotEqual: {
    ...COMMON.dateNotEqual,
    nameKey: "search.operator.date-not-equal.name",
    descriptionKey: "search.operator.date-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value?.date && fieldPath ? `${fieldPath} != ${toJSON(value.date)}` : null,
    inputComponent: SearchFilterDateEqualInput,
    type: "dateNotEqual"
  },
  dateRange: {
    ...COMMON.dateRange,
    nameKey: "search.operator.date-range.name",
    descriptionKey: "search.operator.date-range.description",
    buttonValueComponent: SearchButtonValueDateRange,
    groqFilter: ({
      fieldPath,
      value
    }) => value?.to && value?.from && fieldPath ? `${fieldPath} >= ${toJSON(value.from)} && ${fieldPath} <= ${toJSON(value.to)}` : null,
    initialValue: {
      includeTime: !1,
      to: startOfToday().toISOString(),
      from: null
    },
    inputComponent: SearchFilterDateRangeInput,
    type: "dateRange"
  },
  dateTimeAfter: {
    ...COMMON.dateAfter,
    nameKey: "search.operator.date-time-after.name",
    descriptionKey: "search.operator.date-time-after.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value?.date && fieldPath ? `dateTime(${fieldPath}) > dateTime(${toJSON(value.date)})` : null,
    inputComponent: SearchFilterDateTimeAfterInput,
    type: "dateTimeAfter"
  },
  dateTimeBefore: {
    ...COMMON.dateBefore,
    nameKey: "search.operator.date-time-before.name",
    descriptionKey: "search.operator.date-time-before.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value?.date && fieldPath ? `dateTime(${fieldPath}) < dateTime(${toJSON(value.date)})` : null,
    inputComponent: SearchFilterDateTimeBeforeInput,
    type: "dateTimeBefore"
  },
  dateTimeEqual: {
    ...COMMON.dateEqual,
    nameKey: "search.operator.date-time-equal.name",
    descriptionKey: "search.operator.date-time-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => {
      const date = value?.date && new Date(value.date);
      if (!date || !isValid(date) || !fieldPath)
        return null;
      const dateStart = (value?.includeTime ? startOfMinute(date) : startOfDay(date)).toISOString(), dateEnd = (value?.includeTime ? endOfMinute(date) : endOfDay(date)).toISOString();
      return `dateTime(${fieldPath}) > dateTime(${toJSON(dateStart)}) && dateTime(${fieldPath}) < dateTime(${toJSON(dateEnd)})`;
    },
    inputComponent: SearchFilterDateTimeEqualInput,
    type: "dateTimeEqual"
  },
  dateTimeLast: {
    ...COMMON.dateLast,
    nameKey: "search.operator.date-time-last.name",
    descriptionKey: "search.operator.date-time-last.description",
    groqFilter: ({
      fieldPath,
      value
    }) => {
      const flooredValue = typeof value?.unitValue == "number" ? Math.floor(value.unitValue) : void 0, timestampAgo = Number.isFinite(flooredValue) ? sub(/* @__PURE__ */ new Date(), {
        days: value?.unit === "day" ? flooredValue : 0,
        months: value?.unit === "month" ? flooredValue : 0,
        years: value?.unit === "year" ? flooredValue : 0
      }).toISOString() : null;
      return timestampAgo && fieldPath ? `dateTime(${fieldPath}) > dateTime(${toJSON(timestampAgo)})` : null;
    },
    initialValue: {
      unit: "day",
      unitValue: 7
    },
    inputComponent: SearchFilterDateLastInput,
    type: "dateTimeLast"
  },
  dateTimeNotEqual: {
    ...COMMON.dateNotEqual,
    nameKey: "search.operator.date-time-not-equal.name",
    descriptionKey: "search.operator.date-time-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => {
      const date = value?.date && new Date(value.date);
      if (!date || !isValid(date) || !fieldPath)
        return null;
      const dateStart = (value?.includeTime ? startOfMinute(date) : startOfDay(date)).toISOString(), dateEnd = (value?.includeTime ? endOfMinute(date) : endOfDay(date)).toISOString();
      return `dateTime(${fieldPath}) < dateTime(${toJSON(dateStart)}) || dateTime(${fieldPath}) > dateTime(${toJSON(dateEnd)})`;
    },
    inputComponent: SearchFilterDateTimeEqualInput,
    type: "dateTimeNotEqual"
  },
  dateTimeRange: {
    ...COMMON.dateRange,
    nameKey: "search.operator.date-time-range.name",
    descriptionKey: "search.operator.date-time-range.description",
    buttonValueComponent: SearchButtonValueDateRange,
    groqFilter: ({
      fieldPath,
      value
    }) => value?.to && value?.from && fieldPath ? `dateTime(${fieldPath}) >= dateTime(${toJSON(value.from)}) && dateTime(${fieldPath}) <= dateTime(${toJSON(value.to)})` : null,
    initialValue: {
      includeTime: !1,
      to: startOfToday().toISOString(),
      from: null
    },
    inputComponent: SearchFilterDateTimeRangeInput,
    type: "dateTimeRange"
  }
}, definedOperators = {
  defined: {
    nameKey: "search.operator.defined.name",
    descriptionKey: "search.operator.defined.description",
    groqFilter: ({
      fieldPath
    }) => fieldPath ? `defined(${fieldPath})` : null,
    type: "defined"
  },
  notDefined: {
    nameKey: "search.operator.not-defined.name",
    descriptionKey: "search.operator.not-defined.description",
    groqFilter: ({
      fieldPath
    }) => fieldPath ? `!defined(${fieldPath})` : null,
    type: "notDefined"
  }
}, numberOperators = {
  numberEqual: {
    nameKey: "search.operator.number-equal.name",
    descriptionKey: "search.operator.number-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `${fieldPath} == ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "numberEqual"
  },
  numberGt: {
    nameKey: "search.operator.number-gt.name",
    descriptionKey: "search.operator.number-gt.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `${fieldPath} > ${toJSON(value)}` : null,
    icon: GtIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "numberGt"
  },
  numberGte: {
    nameKey: "search.operator.number-gte.name",
    descriptionKey: "search.operator.number-gte.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `${fieldPath} >= ${toJSON(value)}` : null,
    icon: GteIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "numberGte"
  },
  numberLt: {
    nameKey: "search.operator.number-lt.name",
    descriptionKey: "search.operator.number-lt.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `${fieldPath} < ${toJSON(value)}` : null,
    icon: LtIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "numberLt"
  },
  numberLte: {
    nameKey: "search.operator.number-lte.name",
    descriptionKey: "search.operator.number-lte.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `${fieldPath} <= ${toJSON(value)}` : null,
    icon: LteIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "numberLte"
  },
  numberNotEqual: {
    nameKey: "search.operator.number-not-equal.name",
    descriptionKey: "search.operator.number-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `${fieldPath} != ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "numberNotEqual"
  },
  numberRange: {
    nameKey: "search.operator.number-range.name",
    descriptionKey: "search.operator.number-range.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value?.to) && Number.isFinite(value?.from) && fieldPath ? `${fieldPath} > ${toJSON(value?.from)} && ${fieldPath} < ${toJSON(value?.to)}` : "",
    initialValue: null,
    inputComponent: SearchFilterNumberRangeInput,
    type: "numberRange"
  }
};
function SearchFilterStringInput(t0) {
  const $ = c(9), {
    onChange,
    value
  } = t0, {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] !== onChange ? (t2 = (event) => onChange(event.currentTarget.value || null), $[0] = onChange, $[1] = t2) : t2 = $[1];
  const handleChange = t2, t3 = fullscreen ? 2 : 1;
  let t4;
  $[2] !== t ? (t4 = t("search.filter-string-value-placeholder"), $[2] = t, $[3] = t4) : t4 = $[3];
  const t5 = value || "";
  let t6;
  return $[4] !== handleChange || $[5] !== t3 || $[6] !== t4 || $[7] !== t5 ? (t6 = /* @__PURE__ */ jsx(TextInput$1, { fontSize: t3, onChange: handleChange, placeholder: t4, radius: 2, value: t5 }), $[4] = handleChange, $[5] = t3, $[6] = t4, $[7] = t5, $[8] = t6) : t6 = $[8], t6;
}
const portableTextOperators = {
  portableTextEqual: {
    nameKey: "search.operator.portable-text-equal.name",
    descriptionKey: "search.operator.portable-text-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `pt::text(${fieldPath}) == ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "portableTextEqual"
  },
  portableTextMatches: {
    nameKey: "search.operator.portable-text-contains.name",
    descriptionKey: "search.operator.portable-text-contains.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `pt::text(${fieldPath}) match ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "portableTextMatches"
  },
  portableTextNotEqual: {
    nameKey: "search.operator.portable-text-not-equal.name",
    descriptionKey: "search.operator.portable-text-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `pt::text(${fieldPath}) != ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "portableTextNotEqual"
  },
  portableTextNotMatches: {
    nameKey: "search.operator.portable-text-not-contains.name",
    descriptionKey: "search.operator.portable-text-not-contains.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `!(pt::text(${fieldPath}) match ${toJSON(value)})` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "portableTextNotMatches"
  }
}, referenceOperators = {
  referenceEqual: {
    nameKey: "search.operator.reference-equal.name",
    descriptionKey: "search.operator.reference-equal.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${fieldPath}._ref == ${toJSON(value._ref)}` : null,
    initialValue: null,
    inputComponent: SearchFilterReferenceInput,
    type: "referenceEqual"
  },
  referenceNotEqual: {
    nameKey: "search.operator.reference-not-equal.name",
    descriptionKey: "search.operator.reference-not-equal.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${fieldPath}._ref != ${toJSON(value._ref)}` : null,
    initialValue: null,
    inputComponent: SearchFilterReferenceInput,
    type: "referenceNotEqual"
  },
  referencesAssetFile: {
    nameKey: "search.operator.reference-asset-file.name",
    descriptionKey: "search.operator.reference-asset-file.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      value
    }) => value?._ref ? `references(${toJSON(value._ref)})` : null,
    initialValue: null,
    inputComponent: SearchFilterAssetInput("file"),
    type: "referencesAssetFile"
  },
  referencesAssetImage: {
    nameKey: "search.operator.reference-asset-image.name",
    descriptionKey: "search.operator.reference-asset-image.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      value
    }) => value?._ref ? `references(${toJSON(value._ref)})` : null,
    initialValue: null,
    inputComponent: SearchFilterAssetInput("image"),
    type: "referencesAssetImage"
  },
  referencesDocument: {
    nameKey: "search.operator.reference-document.name",
    descriptionKey: "search.operator.reference-document.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      value
    }) => value?._ref ? `references(${toJSON(value._ref)})` : null,
    initialValue: null,
    inputComponent: SearchFilterReferenceInput,
    type: "referencesDocument"
  }
}, slugOperators = {
  slugEqual: {
    nameKey: "search.operator.slug-equal.name",
    descriptionKey: "search.operator.slug-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath}.current == ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "slugEqual"
  },
  slugMatches: {
    nameKey: "search.operator.slug-contains.name",
    descriptionKey: "search.operator.slug-contains.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath}.current match ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "slugMatches"
  },
  slugNotEqual: {
    nameKey: "search.operator.slug-not-equal.name",
    descriptionKey: "search.operator.slug-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath}.current != ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "slugNotEqual"
  },
  slugNotMatches: {
    nameKey: "search.operator.slug-not-contains.name",
    descriptionKey: "search.operator.slug-not-contains.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `!(${fieldPath}.current match ${toJSON(value)})` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "slugNotMatches"
  }
}, stringOperators = {
  stringEqual: {
    nameKey: "search.operator.string-equal.name",
    descriptionKey: "search.operator.string-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath} == ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "stringEqual"
  },
  stringListEqual: {
    nameKey: "search.operator.string-list-equal.name",
    descriptionKey: "search.operator.string-list-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath} == ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringListInput,
    type: "stringListEqual"
  },
  stringListNotEqual: {
    nameKey: "search.operator.string-list-not-equal.name",
    descriptionKey: "search.operator.string-list-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath} != ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringListInput,
    type: "stringListNotEqual"
  },
  stringMatches: {
    nameKey: "search.operator.string-contains.name",
    descriptionKey: "search.operator.string-contains.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath} match "*${value}*"` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "stringMatches"
  },
  stringNotEqual: {
    nameKey: "search.operator.string-not-equal.name",
    descriptionKey: "search.operator.string-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath} != ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "stringNotEqual"
  },
  stringNotMatches: {
    nameKey: "search.operator.string-not-contains.name",
    descriptionKey: "search.operator.string-not-contains.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `!(${fieldPath} match "*${value}*")` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "stringNotMatches"
  }
}, searchOperators = {
  ...arrayOperators,
  ...assetOperators,
  ...booleanOperators,
  ...dateOperators,
  ...definedOperators,
  ...numberOperators,
  ...portableTextOperators,
  ...referenceOperators,
  ...slugOperators,
  ...stringOperators
}, operatorDefinitions = Object.values(searchOperators), debug$7 = debug$c("sanity:manifest"), MAX_SYNC_ITERATIONS = 5, claimPromiseCache = /* @__PURE__ */ new Map();
async function uploadSchema(schema2, client) {
  const pauseDurations = [], before = performance.now(), sync = await DESCRIPTOR_CONVERTER.get(schema2, {
    pauseDurations
  }), after = performance.now(), totalPause = sum$1(pauseDurations) || 0, maxPause = max(pauseDurations) || 0, avgPause = pauseDurations.length === 0 ? 0 : totalPause / pauseDurations.length, duration = after - before;
  duration > 1e3 && console.warn(`Building schema for synchronization took more than 1 second (${duration}ms)`), maxPause > 100 && console.warn(`Building schema for synchronization blocked UI for more than 100ms (${maxPause}ms)`);
  const descriptorId = sync.set.id, {
    projectId = "?",
    dataset = "?"
  } = client.config();
  let contextKey = `dataset:${projectId}:${dataset}`;
  isDev && (contextKey += "#dev");
  const cacheKey = `${descriptorId}:${contextKey}`, cached = claimPromiseCache.get(cacheKey);
  if (cached)
    return debug$7("Reusing cached claim promise for %s", cacheKey), cached;
  const claimAndSync = (async () => {
    const claimRequest = {
      descriptorId,
      contextKey
    }, clientTimings = {
      convertSchema: duration,
      convertSchemaPauseTotal: totalPause,
      convertSchemaPauseMax: maxPause,
      convertSchemaPauseAvg: avgPause
    };
    let syncResult = (await client.request({
      uri: "/descriptors/claim",
      method: "POST",
      body: claimRequest,
      headers: {
        // We mirror the format of Server-Timing: https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Headers/Server-Timing
        "Client-Timing": Object.entries(clientTimings).map(([name, dur]) => `${name};dur=${dur}`).join(",")
      }
    })).synchronization;
    for (let i = 0; i < MAX_SYNC_ITERATIONS; i++) {
      const syncRequest = processSchemaSynchronization(sync, syncResult);
      if (syncRequest === null) return descriptorId;
      syncResult = await client.request({
        uri: "/descriptors/synchronize",
        method: "POST",
        body: syncRequest
      });
    }
    throw new Error(`Schema synchronization didn't succeed in ${MAX_SYNC_ITERATIONS} iterations`);
  })();
  return claimPromiseCache.set(cacheKey, claimAndSync), claimAndSync.catch(() => {
    claimPromiseCache.delete(cacheKey);
  }), claimAndSync;
}
const mediaLibraryLocaleNamespace = "media-library", mediaLibraryUsEnglishLocaleBundle = {
  locale: "en-US",
  namespace: mediaLibraryLocaleNamespace,
  resources: () => import("./_chunks-es/resources5.js")
}, sourceName = "sanity-media-library";
function InvalidVideoWarning(t0) {
  const $ = c(20), {
    onClearValue
  } = t0, {
    t
  } = useTranslation(mediaLibraryLocaleNamespace);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== t ? (t2 = t("invalid-video-warning.title"), $[1] = t, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t ? (t4 = t("invalid-video-warning.description"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t4 }), $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t3 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { gap: 4, marginBottom: 4, children: [
    t1,
    /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      t3,
      t5
    ] })
  ] }), $[9] = t3, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t ? (t7 = t("invalid-video-warning.reset-button.text"), $[12] = t, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== onClearValue || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { icon: ResetIcon, mode: "ghost", onClick: onClearValue, text: t7, width: "fill" }), $[14] = onClearValue, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  return $[17] !== t6 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Card, { "data-testid": "invalid-video-warning", tone: "caution", padding: 4, border: !0, radius: 2, children: [
    t6,
    t8
  ] }), $[17] = t6, $[18] = t8, $[19] = t9) : t9 = $[19], t9;
}
const CUSTOM_DOMAIN_STAGING = "m.sanity-cdn.work", CUSTOM_DOMAIN_PRODUCTION = "m.sanity-cdn.com";
function isSignedPlayback(item) {
  return "token" in item;
}
function isSignedPlaybackInfo(playbackInfo) {
  return isSignedPlayback(playbackInfo.stream);
}
function getPlaybackTokens(playbackInfo) {
  if (isSignedPlaybackInfo(playbackInfo))
    return {
      animated: playbackInfo.animated.token,
      playback: playbackInfo.stream.token,
      thumbnail: playbackInfo.thumbnail.token,
      storyboard: playbackInfo.storyboard.token
    };
}
const POLLING_DELAY = 2e3, POLLING_MAX_DURATION = 12e4;
class AssetProcessingError extends Error {
  constructor(message) {
    super(message), this.name = "AssetProcessingError";
  }
}
function isPlaybackNotFoundError(error) {
  return error?.statusCode === 404;
}
function pollForReadyState(client, mediaLibraryId, assetInstanceId) {
  return client.observable.request({
    method: "GET",
    url: `/media-libraries/${mediaLibraryId}/doc/${assetInstanceId}`
  }).pipe(mergeMap((response) => {
    const doc = response.documents?.[0];
    if (!doc)
      throw new Error(`Asset document ${assetInstanceId} not found, retrying...`);
    if (doc.state === "ready")
      return of(doc);
    throw doc.state === "processing" ? new AssetProcessingError("Asset is processing") : new Error(`Asset state is not "ready": ${doc.state || "unknown"}`);
  }), retry$1({
    delay: (pollError) => {
      if (pollError instanceof AssetProcessingError)
        return timer(POLLING_DELAY);
      throw pollError;
    }
  }), timeout(POLLING_MAX_DURATION), catchError((err) => {
    throw err.name === "TimeoutError" ? new Error(`Asset ${assetInstanceId} was not ready processing after 2 minutes.`) : err;
  }));
}
function parseAssetInstanceId(assetRef) {
  if (assetRef.startsWith("video-"))
    return assetRef;
  const parts = assetRef.split(":");
  if (parts.length !== 3)
    throw new Error(`Invalid asset reference format: expected 3 parts, got ${parts.length}`);
  const [resourceType, mediaLibraryId, instanceId] = parts;
  if (resourceType !== "media-library")
    throw new Error(`Invalid resource type: expected "media-library", got "${resourceType}"`);
  if (!instanceId)
    throw new Error("Missing asset instance ID in reference");
  return instanceId;
}
function useVideoPlaybackInfo(params) {
  const $ = c(11);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: DEFAULT_API_VERSION
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0), [retrySubject] = useState(_temp$1d);
  let t1;
  $[1] !== retrySubject ? (t1 = () => {
    retrySubject.next();
  }, $[1] = retrySubject, $[2] = t1) : t1 = $[2];
  const retry2 = t1;
  let t2;
  if ($[3] !== client || $[4] !== params || $[5] !== retry2 || $[6] !== retrySubject) {
    bb0: {
      const loadingState = {
        isLoading: !0,
        result: void 0,
        error: void 0,
        retry: retry2
      }, emptyState = {
        isLoading: !1,
        result: void 0,
        error: void 0,
        retry: retry2
      };
      if (!params) {
        t2 = [emptyState, of(emptyState)];
        break bb0;
      }
      const {
        mediaLibraryId,
        assetRef
      } = params, obs$ = retrySubject.pipe(startWith(void 0)).pipe(switchMap(() => defer(() => {
        const assetInstanceId = parseAssetInstanceId(assetRef._ref);
        return from(client.request({
          uri: `/media-libraries/${mediaLibraryId}/video/${assetInstanceId}/playback-info`,
          tag: "media-library.video-playback-info"
        }));
      }).pipe(map((result) => ({
        isLoading: !1,
        result,
        error: void 0,
        retry: retry2
      })), retry$1({
        delay: (error) => {
          if (!isPlaybackNotFoundError(error))
            throw error;
          const assetInstanceId_0 = parseAssetInstanceId(assetRef._ref);
          return pollForReadyState(client, mediaLibraryId, assetInstanceId_0);
        }
      }), catchError((err) => (console.error("Failed to fetch video playback info:", err), of({
        isLoading: !1,
        result: void 0,
        error: err,
        retry: retry2
      }))), startWith(loadingState))));
      let t3;
      $[8] !== loadingState || $[9] !== obs$ ? (t3 = [loadingState, obs$], $[8] = loadingState, $[9] = obs$, $[10] = t3) : t3 = $[10], t2 = t3;
    }
    $[3] = client, $[4] = params, $[5] = retry2, $[6] = retrySubject, $[7] = t2;
  } else
    t2 = $[7];
  const [initialState2, playbackInfoObservable] = t2;
  return useObservable(playbackInfoObservable, initialState2);
}
function _temp$1d() {
  return new Subject();
}
const RatioBox = styled(Card).withConfig({
  displayName: "RatioBox",
  componentId: "sc-1ga7ysd-0"
})`position:relative;display:flex;justify-content:center;align-items:center;width:100%;min-height:3.75rem;aspect-ratio:var(--aspect-ratio);${(props2) => props2.$isPortrait ? "max-height: 30dvh;" : ""}`;
function VideoSkeleton(t0) {
  const $ = c(11), {
    error,
    retry: retry2,
    aspectRatio
  } = t0, {
    t
  } = useTranslation(mediaLibraryLocaleNamespace), ratio = aspectRatio ?? 1.7777777777777777, t1 = error ? "critical" : "transparent", t2 = ratio < 0.75;
  let t3;
  $[0] !== ratio ? (t3 = {
    "--aspect-ratio": ratio
  }, $[0] = ratio, $[1] = t3) : t3 = $[1];
  const t4 = t3;
  let t5;
  $[2] !== error || $[3] !== retry2 || $[4] !== t ? (t5 = error ? /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "center", direction: "column", gap: 3, style: {
    position: "absolute",
    inset: 0
  }, padding: 4, children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: error.message || t("video-error.description") }),
    retry2 && /* @__PURE__ */ jsx(Button, { icon: ResetIcon, mode: "ghost", text: t("video-error.retry-button.text"), onClick: retry2 })
  ] }) : /* @__PURE__ */ jsx(Skeleton, { style: {
    position: "absolute",
    inset: 0
  }, radius: 1, animated: !0 }), $[2] = error, $[3] = retry2, $[4] = t, $[5] = t5) : t5 = $[5];
  let t6;
  return $[6] !== t1 || $[7] !== t2 || $[8] !== t4 || $[9] !== t5 ? (t6 = /* @__PURE__ */ jsx(RatioBox, { tone: t1, $isPortrait: t2, style: t4, children: t5 }), $[6] = t1, $[7] = t2, $[8] = t4, $[9] = t5, $[10] = t6) : t6 = $[10], t6;
}
const VideoPlayer = lazy(() => import("./_chunks-es/VideoPlayer.js").then((module) => ({
  default: module.VideoPlayer
})));
function VideoActionsMenu(props2) {
  const $ = c(23), {
    customDomain,
    playbackId,
    tokens,
    children,
    aspectRatio,
    muted,
    disabled,
    onClick: onClick2,
    isMenuOpen,
    onMenuOpen,
    menuButtonRef
  } = props2, t0 = muted || disabled ? void 0 : "button", t1 = aspectRatio !== void 0 && aspectRatio < 0.75;
  let t2;
  $[0] !== aspectRatio ? (t2 = {
    "--aspect-ratio": aspectRatio
  }, $[0] = aspectRatio, $[1] = t2) : t2 = $[1];
  const t3 = t2;
  let t4;
  $[2] !== aspectRatio || $[3] !== customDomain || $[4] !== playbackId || $[5] !== tokens ? (t4 = playbackId && /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(VideoSkeleton, { aspectRatio }), children: /* @__PURE__ */ jsx(VideoPlayer, { customDomain, playbackId, tokens, aspectRatio }) }), $[2] = aspectRatio, $[3] = customDomain, $[4] = playbackId, $[5] = tokens, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t1 || $[8] !== t3 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(RatioBox, { tone: "transparent", $isPortrait: t1, style: t3, children: t4 }), $[7] = t1, $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== onClick2 || $[12] !== t0 || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { as: t0, tone: "inherit", onClick: onClick2, flex: 1, children: t5 }), $[11] = onClick2, $[12] = t0, $[13] = t5, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== children || $[16] !== isMenuOpen || $[17] !== menuButtonRef || $[18] !== onMenuOpen ? (t7 = /* @__PURE__ */ jsx(MenuActionsWrapper, { padding: 2, children: /* @__PURE__ */ jsx(OptionsMenuPopover, { ariaLabelKey: "inputs.file.actions-menu.video-options.aria-label", id: "video-actions-menu", isMenuOpen, menuButtonRef, onMenuOpen, children }) }), $[15] = children, $[16] = isMenuOpen, $[17] = menuButtonRef, $[18] = onMenuOpen, $[19] = t7) : t7 = $[19];
  let t8;
  return $[20] !== t6 || $[21] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Box, { children: [
    t6,
    t7
  ] }), $[20] = t6, $[21] = t7, $[22] = t8) : t8 = $[22], t8;
}
function getMediaLibraryId(assetRef) {
  const parts = assetRef.split(":");
  if (parts.length !== 3 || parts[0] !== "media-library" || !parts[1])
    throw new Error("Invalid asset reference");
  return parts[1];
}
function getAssetContainerIdFromRef(ref) {
  if (!ref?.startsWith("media-library:")) return null;
  const parts = ref.split(":");
  return parts.length !== 3 || !parts[2] ? null : parts[2];
}
function createMinimalAssetForOpenInSource(mediaRef) {
  const assetContainerId = getAssetContainerIdFromRef(mediaRef);
  return assetContainerId ? {
    _id: mediaRef,
    _type: "sanity.videoAsset",
    source: {
      id: assetContainerId,
      name: sourceName$1
    }
  } : null;
}
function VideoPreview(props2) {
  const $ = c(96), {
    assetSources,
    clearField,
    directUploads,
    menuButtonRef,
    observeAsset,
    onOpenInSource,
    onOpenSourceForUpload,
    onSelectAssetSourceForBrowse,
    onSelectFiles,
    readOnly,
    schemaType,
    setSelectedAssetSource,
    value
  } = props2, {
    t
  } = useTranslation(), [isMenuOpen, setIsMenuOpen] = useState(!1), asset = value?.asset, mediaRef = value?.media?._ref, sourcesFromSchema = schemaType.options?.sources, t0 = schemaType.name === "sanity.video" ? "video/*" : "";
  let t1;
  $[0] !== schemaType || $[1] !== t0 ? (t1 = get(schemaType, "options.accept", t0), $[0] = schemaType, $[1] = t0, $[2] = t1) : t1 = $[2];
  const accept = t1;
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    apiVersion: DEFAULT_API_VERSION
  }, $[3] = t2) : t2 = $[3];
  const isStaging2 = useClient(t2).config().apiHost.endsWith(".sanity.work");
  let t3;
  bb0: {
    if (!asset?._ref) {
      let t42;
      $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = [null, null], $[4] = t42) : t42 = $[4], t3 = t42;
      break bb0;
    }
    try {
      let t52;
      $[5] !== asset._ref ? (t52 = getMediaLibraryId(asset._ref), $[5] = asset._ref, $[6] = t52) : t52 = $[6];
      const mediaLibraryId = t52;
      let t62;
      $[7] !== asset || $[8] !== mediaLibraryId ? (t62 = [{
        mediaLibraryId,
        assetRef: asset
      }, null], $[7] = asset, $[8] = mediaLibraryId, $[9] = t62) : t62 = $[9], t3 = t62;
    } catch (t42) {
      const error = t42;
      console.error("Failed to parse asset reference:", error);
      let t52;
      $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t52 = [null, error instanceof Error ? error : new Error(String(error))], $[10] = t52) : t52 = $[10], t3 = t52;
    }
  }
  const [videoPlaybackParams, parseError] = t3, playbackInfoState = useVideoPlaybackInfo(videoPlaybackParams), customDomain = isStaging2 ? CUSTOM_DOMAIN_STAGING : CUSTOM_DOMAIN_PRODUCTION;
  let t4;
  $[11] !== playbackInfoState.result ? (t4 = playbackInfoState?.result ? getPlaybackTokens(playbackInfoState.result) : void 0, $[11] = playbackInfoState.result, $[12] = t4) : t4 = $[12];
  const tokens = t4, t5 = playbackInfoState.result?.aspectRatio, t6 = playbackInfoState.result?.id;
  let t7;
  $[13] !== customDomain || $[14] !== isMenuOpen || $[15] !== menuButtonRef || $[16] !== t5 || $[17] !== t6 ? (t7 = {
    aspectRatio: t5,
    customDomain,
    playbackId: t6,
    onMenuOpen: setIsMenuOpen,
    isMenuOpen,
    menuButtonRef
  }, $[13] = customDomain, $[14] = isMenuOpen, $[15] = menuButtonRef, $[16] = t5, $[17] = t6, $[18] = t7) : t7 = $[18];
  const baseProps = t7;
  let t8;
  $[19] !== baseProps || $[20] !== tokens ? (t8 = tokens ? {
    ...baseProps,
    tokens
  } : baseProps, $[19] = baseProps, $[20] = tokens, $[21] = t8) : t8 = $[21];
  const videoActionsMenuProps = t8;
  let t9;
  $[22] !== assetSources ? (t9 = getAssetSourcesWithUpload(assetSources), $[22] = assetSources, $[23] = t9) : t9 = $[23];
  const assetSourcesWithUpload = t9, documentId = asset?._ref;
  let t10;
  $[24] !== documentId || $[25] !== observeAsset ? (t10 = documentId && observeAsset ? observeAsset(documentId) : EMPTY$5, $[24] = documentId, $[25] = observeAsset, $[26] = t10) : t10 = $[26];
  const resolvedAsset = useObservable(t10);
  let t11;
  if ($[27] !== assetSources || $[28] !== mediaRef || $[29] !== resolvedAsset) {
    bb1: {
      if (resolvedAsset) {
        let t122;
        $[31] !== assetSources || $[32] !== resolvedAsset ? (t122 = findOpenInSourceResult(resolvedAsset, assetSources), $[31] = assetSources, $[32] = resolvedAsset, $[33] = t122) : t122 = $[33], t11 = t122;
        break bb1;
      }
      if (mediaRef) {
        const minimalAsset = createMinimalAssetForOpenInSource(mediaRef);
        if (minimalAsset) {
          t11 = findOpenInSourceResult(minimalAsset, assetSources);
          break bb1;
        }
      }
      t11 = null;
    }
    $[27] = assetSources, $[28] = mediaRef, $[29] = resolvedAsset, $[30] = t11;
  } else
    t11 = $[30];
  const openInSourceResult = t11;
  let t12;
  $[34] !== onSelectAssetSourceForBrowse || $[35] !== setSelectedAssetSource ? (t12 = (assetSource) => {
    setIsMenuOpen(!1), (onSelectAssetSourceForBrowse ?? setSelectedAssetSource)(assetSource);
  }, $[34] = onSelectAssetSourceForBrowse, $[35] = setSelectedAssetSource, $[36] = t12) : t12 = $[36];
  const handleSelectAssetSourceForBrowse = t12;
  let t13;
  $[37] !== mediaRef || $[38] !== onOpenInSource || $[39] !== openInSourceResult || $[40] !== resolvedAsset ? (t13 = () => {
    if (!openInSourceResult)
      return;
    setIsMenuOpen(!1);
    const {
      source,
      result
    } = openInSourceResult;
    if (result.type === "url")
      window.open(result.url, result.target || "_blank");
    else if (result.type === "component") {
      const assetContainerId = mediaRef ? getAssetContainerIdFromRef(mediaRef) : null, baseAsset = resolvedAsset ?? (mediaRef ? createMinimalAssetForOpenInSource(mediaRef) : null), assetToOpen = baseAsset ? assetContainerId && baseAsset.source ? {
        ...baseAsset,
        source: {
          ...baseAsset.source,
          id: assetContainerId
        }
      } : baseAsset : null;
      assetToOpen && onOpenInSource?.(source, assetToOpen);
    }
  }, $[37] = mediaRef, $[38] = onOpenInSource, $[39] = openInSourceResult, $[40] = resolvedAsset, $[41] = t13) : t13 = $[41];
  const handleOpenInSource = t13;
  let t14;
  $[42] !== onSelectFiles ? (t14 = (assetSource_0, videos) => {
    setIsMenuOpen(!1), onSelectFiles(assetSource_0, videos);
  }, $[42] = onSelectFiles, $[43] = t14) : t14 = $[43];
  const handleSelectVideosFromAssetSource = t14;
  let t15;
  $[44] !== assetSourcesWithUpload || $[45] !== handleSelectVideosFromAssetSource ? (t15 = (videos_0) => {
    handleSelectVideosFromAssetSource(assetSourcesWithUpload[0], videos_0);
  }, $[44] = assetSourcesWithUpload, $[45] = handleSelectVideosFromAssetSource, $[46] = t15) : t15 = $[46];
  const handleSelectVideosFromAssetSourceSingle = t15;
  let t16;
  $[47] !== assetSourcesWithUpload || $[48] !== onOpenSourceForUpload ? (t16 = () => {
    setIsMenuOpen(!1), onOpenSourceForUpload?.(assetSourcesWithUpload[0]);
  }, $[47] = assetSourcesWithUpload, $[48] = onOpenSourceForUpload, $[49] = t16) : t16 = $[49];
  const handleOpenSourceForUploadSingle = t16;
  let t17;
  $[50] !== onOpenSourceForUpload ? (t17 = (assetSource_1) => {
    setIsMenuOpen(!1), onOpenSourceForUpload?.(assetSource_1);
  }, $[50] = onOpenSourceForUpload, $[51] = t17) : t17 = $[51];
  const handleOpenSourceForUpload = t17;
  let t18;
  $[52] !== schemaType ? (t18 = getDataTestIdPrefix(schemaType), $[52] = schemaType, $[53] = t18) : t18 = $[53];
  const dataTestIdPrefix = t18;
  let t19;
  $[54] !== assetSources || $[55] !== dataTestIdPrefix || $[56] !== handleSelectAssetSourceForBrowse || $[57] !== readOnly || $[58] !== sourcesFromSchema?.length || $[59] !== t ? (t19 = () => sourcesFromSchema?.length === 0 || assetSources.length === 0 ? null : assetSources.length === 1 ? /* @__PURE__ */ jsx(MenuItem, { icon: SearchIcon, text: t("asset-source.browse-button.text"), onClick: () => handleSelectAssetSourceForBrowse(assetSources[0]), disabled: readOnly, "data-testid": `${dataTestIdPrefix}-browse-button-${assetSources[0].name}` }) : assetSources.map((assetSource_2) => /* @__PURE__ */ jsx(MenuItem, { text: getAssetSourceDisplayName(assetSource_2, t, {
    useStartCaseForName: !0
  }), onClick: () => handleSelectAssetSourceForBrowse(assetSource_2), icon: assetSource_2.icon || ImageIcon, disabled: readOnly, "data-testid": `${dataTestIdPrefix}-browse-button-${assetSource_2.name}` }, assetSource_2.name)), $[54] = assetSources, $[55] = dataTestIdPrefix, $[56] = handleSelectAssetSourceForBrowse, $[57] = readOnly, $[58] = sourcesFromSchema?.length, $[59] = t, $[60] = t19) : t19 = $[60];
  let t20;
  $[61] !== t19 ? (t20 = t19(), $[61] = t19, $[62] = t20) : t20 = $[62];
  const browseMenuItem = t20;
  let t21;
  $[63] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t21 = () => setIsMenuOpen(!1), $[63] = t21) : t21 = $[63];
  let t22;
  $[64] !== menuButtonRef ? (t22 = () => menuButtonRef.current?.focus(), $[64] = menuButtonRef, $[65] = t22) : t22 = $[65];
  let t23;
  $[66] !== accept || $[67] !== assetSourcesWithUpload || $[68] !== directUploads || $[69] !== handleOpenSourceForUpload || $[70] !== handleOpenSourceForUploadSingle || $[71] !== handleSelectVideosFromAssetSource || $[72] !== handleSelectVideosFromAssetSourceSingle || $[73] !== readOnly || $[74] !== t22 ? (t23 = {
    accept,
    assetSourcesWithUpload,
    directUploads,
    readOnly,
    onSelectFiles: handleSelectVideosFromAssetSource,
    onOpenSourceForUpload: handleOpenSourceForUpload,
    onOpenSourceForUploadSingle: handleOpenSourceForUploadSingle,
    onSelectFilesSingle: handleSelectVideosFromAssetSourceSingle,
    getSingleButtonTestId: _temp$1c,
    dropdownMenuTestId: "video-input-upload-drop-down-menu-button",
    onCloseParentMenu: t21,
    onFilePickerCancel: t22
  }, $[66] = accept, $[67] = assetSourcesWithUpload, $[68] = directUploads, $[69] = handleOpenSourceForUpload, $[70] = handleOpenSourceForUploadSingle, $[71] = handleSelectVideosFromAssetSource, $[72] = handleSelectVideosFromAssetSourceSingle, $[73] = readOnly, $[74] = t22, $[75] = t23) : t23 = $[75];
  const uploadMenuItem = useUploadMenuItem(t23);
  if (!asset)
    return null;
  if (parseError) {
    let t242;
    return $[76] !== parseError ? (t242 = /* @__PURE__ */ jsx(VideoSkeleton, { error: parseError }), $[76] = parseError, $[77] = t242) : t242 = $[77], t242;
  }
  if (playbackInfoState.isLoading) {
    let t242;
    return $[78] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t242 = /* @__PURE__ */ jsx(VideoSkeleton, {}), $[78] = t242) : t242 = $[78], t242;
  }
  if (playbackInfoState.error) {
    let t242;
    return $[79] !== playbackInfoState.error || $[80] !== playbackInfoState.retry ? (t242 = /* @__PURE__ */ jsx(VideoSkeleton, { error: playbackInfoState.error, retry: playbackInfoState.retry }), $[79] = playbackInfoState.error, $[80] = playbackInfoState.retry, $[81] = t242) : t242 = $[81], t242;
  }
  if (!playbackInfoState.result) {
    let t242;
    return $[82] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t242 = /* @__PURE__ */ jsx(VideoSkeleton, {}), $[82] = t242) : t242 = $[82], t242;
  }
  const t24 = openInSourceResult ? handleOpenInSource : void 0;
  let t25;
  $[83] !== openInSourceResult || $[84] !== t ? (t25 = getOpenInSourceName(openInSourceResult, t), $[83] = openInSourceResult, $[84] = t, $[85] = t25) : t25 = $[85];
  let t26;
  $[86] !== browseMenuItem || $[87] !== clearField || $[88] !== readOnly || $[89] !== t24 || $[90] !== t25 || $[91] !== uploadMenuItem ? (t26 = /* @__PURE__ */ jsx(ActionsMenu, { browse: browseMenuItem, upload: uploadMenuItem, onReset: clearField, openInSource: t24, openInSourceName: t25, readOnly }), $[86] = browseMenuItem, $[87] = clearField, $[88] = readOnly, $[89] = t24, $[90] = t25, $[91] = uploadMenuItem, $[92] = t26) : t26 = $[92];
  let t27;
  return $[93] !== t26 || $[94] !== videoActionsMenuProps ? (t27 = /* @__PURE__ */ jsx(VideoActionsMenu, { ...videoActionsMenuProps, children: t26 }), $[93] = t26, $[94] = videoActionsMenuProps, $[95] = t27) : t27 = $[95], t27;
}
function _temp$1c(sourceName2) {
  return `video-input-upload-button-${sourceName2}`;
}
const ASSET_FIELD_PATH = ["asset"];
function isVideoSource(source) {
  if (typeof source != "object" || source === null || !("asset" in source))
    return !1;
  const asset = source.asset;
  if (typeof asset != "object" || asset === null || !("_ref" in asset))
    return !1;
  const ref = asset._ref;
  return typeof ref == "string" && ref.startsWith("media-library:");
}
function VideoAsset(props2) {
  const $ = c(40), {
    assetSources,
    changed,
    clearField,
    directUploads,
    elementProps,
    isStale,
    isUploading,
    onCancelUpload,
    onClearUploadStatus,
    onOpenSourceForUpload,
    onSelectAssets,
    onSelectFiles,
    onStale,
    path,
    readOnly,
    schemaType,
    setHoveringFiles,
    value
  } = props2;
  let t0;
  $[0] !== path ? (t0 = path.concat(ASSET_FIELD_PATH), $[0] = path, $[1] = t0) : t0 = $[1];
  const assetFieldPath = t0;
  let t1;
  $[2] !== elementProps ? (t1 = (event) => {
    event.currentTarget === event.target && event.currentTarget === elementProps.ref?.current && elementProps.onFocus(event);
  }, $[2] = elementProps, $[3] = t1) : t1 = $[3];
  const handleFileTargetFocus = t1;
  let t2;
  $[4] !== directUploads || $[5] !== onSelectFiles || $[6] !== readOnly ? (t2 = (assetSource, files) => {
    directUploads && !readOnly && onSelectFiles(assetSource, files);
  }, $[4] = directUploads, $[5] = onSelectFiles, $[6] = readOnly, $[7] = t2) : t2 = $[7];
  const handleSelectFiles = t2;
  let t3;
  $[8] !== handleSelectFiles ? (t3 = (t42) => {
    const {
      assetSource: assetSource_0,
      file
    } = t42;
    handleSelectFiles(assetSource_0, [file]);
  }, $[8] = handleSelectFiles, $[9] = t3) : t3 = $[9];
  const handleSelectFile = t3, hasValueOrUpload = !!(value?._upload || value?.asset);
  if (value && typeof value.asset < "u" && !value?._upload && !isVideoSource(value)) {
    let t42;
    return $[10] !== clearField ? (t42 = /* @__PURE__ */ jsx(InvalidVideoWarning, { onClearValue: clearField }), $[10] = clearField, $[11] = t42) : t42 = $[11], t42;
  }
  let t4;
  $[12] !== isStale || $[13] !== onClearUploadStatus ? (t4 = isStale && /* @__PURE__ */ jsx(Box, { marginBottom: 2, children: /* @__PURE__ */ jsx(UploadWarning, { onClearStale: onClearUploadStatus }) }), $[12] = isStale, $[13] = onClearUploadStatus, $[14] = t4) : t4 = $[14];
  const t5 = !!props2.focused;
  let t6;
  $[15] !== assetSources || $[16] !== elementProps || $[17] !== handleFileTargetFocus || $[18] !== handleSelectFile || $[19] !== handleSelectFiles || $[20] !== hasValueOrUpload || $[21] !== isUploading || $[22] !== onCancelUpload || $[23] !== onOpenSourceForUpload || $[24] !== onSelectAssets || $[25] !== onStale || $[26] !== props2 || $[27] !== readOnly || $[28] !== schemaType || $[29] !== setHoveringFiles || $[30] !== value ? (t6 = value?._upload ? /* @__PURE__ */ jsx(UploadProgress, { uploadState: value._upload, onCancel: isUploading && onCancelUpload ? onCancelUpload : void 0, onStale }) : /* @__PURE__ */ jsx(UploadTargetCard$1, { ...elementProps, $border: hasValueOrUpload, isReadOnly: readOnly, onFocus: handleFileTargetFocus, onOpenSourceForUpload, onSelectFile: handleSelectFile, onSetHoveringFiles: setHoveringFiles, radius: 2, assetSources, sizing: "border", style: {
    padding: 1
  }, tabIndex: 0, types: [schemaType], children: /* @__PURE__ */ jsxs("div", { style: {
    position: "relative"
  }, children: [
    !value?.asset && /* @__PURE__ */ jsx(FileUploadPlaceHolder, { ...props2, onSelectFiles: handleSelectFiles }),
    !value?._upload && value?.asset && /* @__PURE__ */ jsx(VideoPreview, { ...props2, onSelectAssets })
  ] }) }), $[15] = assetSources, $[16] = elementProps, $[17] = handleFileTargetFocus, $[18] = handleSelectFile, $[19] = handleSelectFiles, $[20] = hasValueOrUpload, $[21] = isUploading, $[22] = onCancelUpload, $[23] = onOpenSourceForUpload, $[24] = onSelectAssets, $[25] = onStale, $[26] = props2, $[27] = readOnly, $[28] = schemaType, $[29] = setHoveringFiles, $[30] = value, $[31] = t6) : t6 = $[31];
  let t7;
  $[32] !== assetFieldPath || $[33] !== changed || $[34] !== t5 || $[35] !== t6 ? (t7 = /* @__PURE__ */ jsx(ChangeIndicator, { path: assetFieldPath, hasFocus: t5, isChanged: changed, children: t6 }), $[32] = assetFieldPath, $[33] = changed, $[34] = t5, $[35] = t6, $[36] = t7) : t7 = $[36];
  let t8;
  return $[37] !== t4 || $[38] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t4,
    t7
  ] }), $[37] = t4, $[38] = t7, $[39] = t8) : t8 = $[39], t8;
}
function FileUploadPlaceHolder(props2) {
  const $ = c(24), {
    assetSources,
    directUploads,
    hoveringFiles,
    onOpenSourceForUpload,
    onSelectFiles,
    onSelectAssetSourceForBrowse,
    readOnly,
    schemaType,
    setIsBrowseMenuOpen,
    setSelectedAssetSource
  } = props2;
  let t0;
  $[0] !== onSelectAssetSourceForBrowse || $[1] !== setIsBrowseMenuOpen || $[2] !== setSelectedAssetSource ? (t0 = (assetSource) => {
    setIsBrowseMenuOpen(!1), (onSelectAssetSourceForBrowse ?? setSelectedAssetSource)(assetSource);
  }, $[0] = onSelectAssetSourceForBrowse, $[1] = setIsBrowseMenuOpen, $[2] = setSelectedAssetSource, $[3] = t0) : t0 = $[3];
  let t1;
  $[4] !== assetSources || $[5] !== readOnly || $[6] !== schemaType || $[7] !== t0 ? (t1 = /* @__PURE__ */ jsx(AssetSourceBrowser, { assetSources, readOnly, schemaType, onSelectAssetSource: t0 }), $[4] = assetSources, $[5] = readOnly, $[6] = schemaType, $[7] = t0, $[8] = t1) : t1 = $[8];
  const browseElement = t1, t2 = readOnly ? "transparent" : "inherit";
  let t3;
  $[9] !== hoveringFiles.length ? (t3 = hoveringFiles.length === 0 ? {
    borderStyle: "dashed"
  } : {
    borderStyle: "dashed",
    borderColor: "transparent"
  }, $[9] = hoveringFiles.length, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== assetSources || $[12] !== browseElement || $[13] !== directUploads || $[14] !== hoveringFiles || $[15] !== onOpenSourceForUpload || $[16] !== onSelectFiles || $[17] !== readOnly || $[18] !== schemaType ? (t4 = /* @__PURE__ */ jsx(UploadPlaceholder, { assetSources, browse: browseElement, directUploads, hoveringFiles, onOpenSourceForUpload, onUpload: onSelectFiles, readOnly, schemaType, type: "file" }), $[11] = assetSources, $[12] = browseElement, $[13] = directUploads, $[14] = hoveringFiles, $[15] = onOpenSourceForUpload, $[16] = onSelectFiles, $[17] = readOnly, $[18] = schemaType, $[19] = t4) : t4 = $[19];
  let t5;
  return $[20] !== t2 || $[21] !== t3 || $[22] !== t4 ? (t5 = /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(Card, { tone: t2, border: !0, paddingX: 3, paddingY: 2, radius: 2, style: t3, children: t4 }) }), $[20] = t2, $[21] = t3, $[22] = t4, $[23] = t5) : t5 = $[23], t5;
}
function passThrough({
  children
}) {
  return children;
}
function BaseVideoInput(props2) {
  const $ = c(74), {
    client,
    members,
    observeAsset,
    onChange,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    value
  } = props2, {
    t
  } = useTranslation(), renderedMembers = useRenderMembers(schemaType, members);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const [hoveringFiles, setHoveringFiles] = useState(t0), [isBrowseMenuOpen, setIsBrowseMenuOpen] = useState(!1);
  let t1;
  $[1] !== client || $[2] !== onChange || $[3] !== schemaType ? (t1 = {
    client,
    onChange,
    schemaType
  }, $[1] = client, $[2] = onChange, $[3] = schemaType, $[4] = t1) : t1 = $[4];
  const {
    action: assetSourceAction,
    selectedAssetSource,
    openInSourceAsset,
    openForBrowse: handleSelectAssetSourceForBrowse,
    openForUpload: handleOpenSourceForUpload,
    openInSource: handleOpenInSource,
    changeAction: handleAssetSourceChangeAction,
    clearUploadStatus,
    close: handleAssetSourceClosed,
    menuButtonRef,
    resetOnComplete: handleAssetSourceResetOnComplete,
    setSelectedAssetSource,
    uploadWith: uploadExternalFileToDataset,
    isUploading,
    setIsUploading,
    isStale,
    setIsStale,
    onStale: handleStaleUpload,
    assetSourceUploader,
    handleSelectFilesToUpload
  } = useAssetSource(t1);
  let t2;
  $[5] !== clearUploadStatus || $[6] !== setIsStale || $[7] !== value?._upload ? (t2 = () => {
    value?._upload && (clearUploadStatus(), setIsStale(!1));
  }, $[5] = clearUploadStatus, $[6] = setIsStale, $[7] = value?._upload, $[8] = t2) : t2 = $[8];
  const handleClearUploadStatus = t2;
  let t3;
  $[9] !== onChange ? (t3 = () => {
    onChange([unset(["asset"]), unset(["media"])]);
  }, $[9] = onChange, $[10] = t3) : t3 = $[10];
  const handleClearField = t3;
  let t4;
  $[11] !== handleAssetSourceResetOnComplete || $[12] !== onChange || $[13] !== schemaType || $[14] !== uploadExternalFileToDataset ? (t4 = (assetsFromSource) => {
    handleSelectAssetFromSource({
      assetsFromSource,
      onChange,
      type: schemaType,
      resolveUploader,
      uploadWith: uploadExternalFileToDataset
    }), handleAssetSourceResetOnComplete();
  }, $[11] = handleAssetSourceResetOnComplete, $[12] = onChange, $[13] = schemaType, $[14] = uploadExternalFileToDataset, $[15] = t4) : t4 = $[15];
  const handleSelectAssets = t4;
  let t5;
  $[16] !== assetSourceUploader?.uploader ? (t5 = () => {
    assetSourceUploader?.uploader?.abort();
  }, $[16] = assetSourceUploader?.uploader, $[17] = t5) : t5 = $[17];
  const handleCancelUpload = t5;
  let t6;
  $[18] !== handleCancelUpload || $[19] !== handleClearField || $[20] !== handleClearUploadStatus || $[21] !== handleOpenInSource || $[22] !== handleOpenSourceForUpload || $[23] !== handleSelectAssetSourceForBrowse || $[24] !== handleSelectAssets || $[25] !== handleSelectFilesToUpload || $[26] !== handleStaleUpload || $[27] !== hoveringFiles || $[28] !== isBrowseMenuOpen || $[29] !== isStale || $[30] !== isUploading || $[31] !== menuButtonRef || $[32] !== props2 || $[33] !== selectedAssetSource || $[34] !== setIsUploading || $[35] !== setSelectedAssetSource ? (t6 = () => /* @__PURE__ */ jsx(VideoAsset, { ...props2, menuButtonRef, clearField: handleClearField, hoveringFiles, isBrowseMenuOpen, isStale, isUploading, onCancelUpload: handleCancelUpload, onClearUploadStatus: handleClearUploadStatus, onOpenInSource: handleOpenInSource, onOpenSourceForUpload: handleOpenSourceForUpload, onSelectAssetSourceForBrowse: handleSelectAssetSourceForBrowse, onSelectAssets: handleSelectAssets, onSelectFiles: handleSelectFilesToUpload, onStale: handleStaleUpload, selectedAssetSource, setHoveringFiles, setIsBrowseMenuOpen, setIsUploading, setSelectedAssetSource }), $[18] = handleCancelUpload, $[19] = handleClearField, $[20] = handleClearUploadStatus, $[21] = handleOpenInSource, $[22] = handleOpenSourceForUpload, $[23] = handleSelectAssetSourceForBrowse, $[24] = handleSelectAssets, $[25] = handleSelectFilesToUpload, $[26] = handleStaleUpload, $[27] = hoveringFiles, $[28] = isBrowseMenuOpen, $[29] = isStale, $[30] = isUploading, $[31] = menuButtonRef, $[32] = props2, $[33] = selectedAssetSource, $[34] = setIsUploading, $[35] = setSelectedAssetSource, $[36] = t6) : t6 = $[36];
  const renderAsset = t6;
  let t7;
  if ($[37] !== renderAnnotation || $[38] !== renderAsset || $[39] !== renderBlock2 || $[40] !== renderField || $[41] !== renderInlineBlock || $[42] !== renderInput || $[43] !== renderItem2 || $[44] !== renderPreview || $[45] !== renderedMembers || $[46] !== schemaType || $[47] !== t) {
    let t82;
    $[49] !== renderAnnotation || $[50] !== renderAsset || $[51] !== renderBlock2 || $[52] !== renderField || $[53] !== renderInlineBlock || $[54] !== renderInput || $[55] !== renderItem2 || $[56] !== renderPreview || $[57] !== schemaType || $[58] !== t ? (t82 = (member) => member.kind === "field" ? /* @__PURE__ */ jsx(MemberField, { member, renderAnnotation, renderBlock: renderBlock2, renderField: member.name === "asset" ? passThrough : renderField, renderInlineBlock, renderInput: member.name === "asset" ? renderAsset : renderInput, renderItem: renderItem2, renderPreview }, member.key) : member.kind === "fieldSet" ? /* @__PURE__ */ jsx(MemberFieldSet, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview, schemaType }, member.key) : member.kind === "decoration" ? /* @__PURE__ */ jsx(MemberDecoration, { member }, member.key) : member.kind === "error" ? /* @__PURE__ */ jsx(MemberFieldError, { member }, member.key) : /* @__PURE__ */ jsx(Fragment, { children: t("inputs.file.error.unknown-member-kind", {
      kind: member.kind
    }) }, member.key), $[49] = renderAnnotation, $[50] = renderAsset, $[51] = renderBlock2, $[52] = renderField, $[53] = renderInlineBlock, $[54] = renderInput, $[55] = renderItem2, $[56] = renderPreview, $[57] = schemaType, $[58] = t, $[59] = t82) : t82 = $[59], t7 = renderedMembers.map(t82), $[37] = renderAnnotation, $[38] = renderAsset, $[39] = renderBlock2, $[40] = renderField, $[41] = renderInlineBlock, $[42] = renderInput, $[43] = renderItem2, $[44] = renderPreview, $[45] = renderedMembers, $[46] = schemaType, $[47] = t, $[48] = t7;
  } else
    t7 = $[48];
  let t8;
  $[60] !== assetSourceAction || $[61] !== assetSourceUploader?.uploader || $[62] !== handleAssetSourceChangeAction || $[63] !== handleAssetSourceClosed || $[64] !== handleSelectAssets || $[65] !== observeAsset || $[66] !== openInSourceAsset || $[67] !== props2.schemaType || $[68] !== props2.value || $[69] !== selectedAssetSource ? (t8 = selectedAssetSource && assetSourceAction && /* @__PURE__ */ jsx(AssetSourceDialog, { action: assetSourceAction, assetType: "sanity.video", observeAsset, onClose: handleAssetSourceClosed, onChangeAction: handleAssetSourceChangeAction, onSelect: handleSelectAssets, openInSourceAsset, schemaType: props2.schemaType, selectedAssetSource, uploader: assetSourceUploader?.uploader, value: props2.value, waitPlaceholder: /* @__PURE__ */ jsx(VideoSkeleton, {}) }), $[60] = assetSourceAction, $[61] = assetSourceUploader?.uploader, $[62] = handleAssetSourceChangeAction, $[63] = handleAssetSourceClosed, $[64] = handleSelectAssets, $[65] = observeAsset, $[66] = openInSourceAsset, $[67] = props2.schemaType, $[68] = props2.value, $[69] = selectedAssetSource, $[70] = t8) : t8 = $[70];
  let t9;
  return $[71] !== t7 || $[72] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t7,
    t8
  ] }), $[71] = t7, $[72] = t8, $[73] = t9) : t9 = $[73], t9;
}
function StudioVideoInput(props2) {
  const $ = c(14), sourcesFromSchema = props2.schemaType.options?.sources, documentPreviewStore = useDocumentPreviewStore(), {
    file: fileConfig
  } = useFormBuilder().__internal, client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0;
  $[0] !== fileConfig.directUploads ? (t0 = (type, file) => fileConfig.directUploads ? resolveUploader(type, file) : null, $[0] = fileConfig.directUploads, $[1] = t0) : t0 = $[1];
  const resolveUploader$1 = t0, assetSources = sourcesFromSchema || fileConfig.assetSources;
  let t1;
  $[2] !== assetSources ? (t1 = assetSources.filter(_temp$1b), $[2] = assetSources, $[3] = t1) : t1 = $[3];
  const filteredAssetSources = t1;
  let t2;
  $[4] !== client || $[5] !== documentPreviewStore ? (t2 = (id2) => observeVideoAsset(documentPreviewStore, id2, client), $[4] = client, $[5] = documentPreviewStore, $[6] = t2) : t2 = $[6];
  const observeAsset = t2;
  let t3;
  return $[7] !== client || $[8] !== fileConfig.directUploads || $[9] !== filteredAssetSources || $[10] !== observeAsset || $[11] !== props2 || $[12] !== resolveUploader$1 ? (t3 = /* @__PURE__ */ jsx(BaseVideoInput, { ...props2, client, assetSources: filteredAssetSources, directUploads: fileConfig.directUploads, observeAsset, resolveUploader: resolveUploader$1 }), $[7] = client, $[8] = fileConfig.directUploads, $[9] = filteredAssetSources, $[10] = observeAsset, $[11] = props2, $[12] = resolveUploader$1, $[13] = t3) : t3 = $[13], t3;
}
function _temp$1b(source) {
  return source.name === sourceName;
}
const VideoField = (props2) => props2.renderDefault({
  ...props2,
  level: props2.level - 1
}), video = defineType({
  name: "sanity.video",
  title: "Video",
  type: "object",
  components: {
    input: StudioVideoInput,
    field: VideoField
  },
  fields: [{
    name: "asset",
    type: "globalDocumentReference",
    to: [{
      type: "sanity.videoAsset",
      // Note: the preview configuration is not used in Studio, but it must be present in order
      // to satisfy global document reference schema validation.
      //
      // If an empty object is supplied, the preview configuration will be omitted when the
      // schema is extracted. Studio will be completely functional, but an error will occur
      // when another service (e.g. Agent Actions) attempts to parse the serialized schema and
      // finds the required preview configuration is absent.
      preview: {
        select: {
          title: "_id"
        }
      }
    }],
    resourceType: "media-library",
    resourceId: "_"
  }, {
    name: "media",
    type: "globalDocumentReference",
    hidden: !0,
    to: [{
      type: "sanity.asset",
      // Note: the preview configuration is not used in Studio, but it must be present in order
      // to satisfy global document reference schema validation.
      //
      // If an empty object is supplied, the preview configuration will be omitted when the
      // schema is extracted. Studio will be completely functional, but an error will occur
      // when another service (e.g. Agent Actions) attempts to parse the serialized schema and
      // finds the required preview configuration is absent.
      preview: {
        select: {
          title: "_id"
        }
      }
    }],
    resourceType: "media-library",
    resourceId: "_"
  }]
}), videoAsset = defineType({
  name: "sanity.videoAsset",
  title: "Video",
  type: "document",
  fieldsets: [{
    name: "system",
    title: "System fields",
    description: "These fields are managed by the system and not editable"
  }],
  fields: [{
    name: "originalFilename",
    type: "string",
    title: "Original file name",
    readOnly: !0
  }, {
    name: "label",
    type: "string",
    title: "Label"
  }, {
    name: "title",
    type: "string",
    title: "Title"
  }, {
    name: "description",
    type: "string",
    title: "Description"
  }, {
    name: "altText",
    type: "string",
    title: "Alternative text"
  }, {
    name: "creditLine",
    type: "string",
    title: "Credit line"
  }, {
    name: "metadata",
    type: "sanity.videoMetadata",
    title: "Video metadata",
    readOnly: !0,
    fieldset: "system"
  }, {
    name: "sha1hash",
    type: "string",
    title: "SHA1 hash",
    readOnly: !0,
    fieldset: "system"
  }, {
    name: "extension",
    type: "string",
    title: "File extension",
    readOnly: !0,
    fieldset: "system"
  }, {
    name: "mimeType",
    type: "string",
    title: "Mime type",
    readOnly: !0,
    fieldset: "system"
  }, {
    name: "size",
    type: "number",
    title: "File size in bytes",
    readOnly: !0,
    fieldset: "system"
  }, {
    name: "assetId",
    type: "string",
    title: "Asset ID",
    readOnly: !0,
    fieldset: "system"
  }, {
    name: "uploadId",
    type: "string",
    readOnly: !0,
    hidden: !0,
    fieldset: "system"
  }, {
    name: "path",
    type: "string",
    title: "Path",
    readOnly: !0,
    fieldset: "system"
  }, {
    name: "url",
    type: "string",
    title: "Url",
    readOnly: !0,
    fieldset: "system"
  }],
  preview: {
    select: {
      title: "originalFilename",
      path: "path",
      mimeType: "mimeType",
      size: "size",
      duration: "metadata.duration"
    },
    prepare(doc) {
      const duration = doc.duration ? `${Math.floor(doc.duration / 60)}:${String(Math.floor(doc.duration % 60)).padStart(2, "0")}` : "";
      return {
        title: doc.title || doc.path.split("/").slice(-1)[0],
        subtitle: `${doc.mimeType} (${(doc.size / 1024 / 1024).toFixed(2)} MB)${duration ? ` - ${duration}` : ""}`
      };
    }
  },
  orderings: [{
    title: "File size",
    name: "fileSizeDesc",
    by: [{
      field: "size",
      direction: "desc"
    }]
  }, {
    title: "Duration",
    name: "durationDesc",
    by: [{
      field: "metadata.duration",
      direction: "desc"
    }]
  }]
}), videoAssetMetadataPlayback = defineType({
  name: "sanity.videoMetadata.playback",
  title: "Playback",
  type: "object",
  fields: [{
    name: "policy",
    type: "string"
  }]
}), videoAssetMetadata = defineType({
  name: "sanity.videoMetadata",
  title: "Video metadata",
  type: "object",
  fieldsets: [{
    name: "extra",
    title: "Extra metadata\u2026",
    options: {
      collapsible: !0
    }
  }],
  fields: [{
    name: "duration",
    title: "Duration (seconds)",
    type: "number",
    readOnly: !0
  }, {
    name: "framerate",
    title: "Frame Rate",
    type: "number",
    readOnly: !0
  }, {
    name: "aspectRatio",
    title: "Aspect Ratio",
    type: "number",
    readOnly: !0
  }, {
    name: "hasAudio",
    title: "Has audio",
    type: "boolean",
    readOnly: !0
  }, {
    name: "codec",
    title: "Codec",
    type: "string",
    readOnly: !0,
    fieldset: "extra"
  }, {
    name: "bitrate",
    title: "Bitrate",
    type: "number",
    readOnly: !0,
    fieldset: "extra"
  }]
}), mediaLibrarySchemas = [video, videoAsset, videoAssetMetadata, videoAssetMetadataPlayback], MEDIA_LIBRARY_NAME = "sanity/media-library", mediaLibrary = definePlugin({
  name: MEDIA_LIBRARY_NAME,
  schema: {
    types: mediaLibrarySchemas
  },
  i18n: {
    bundles: [mediaLibraryUsEnglishLocaleBundle]
  }
}), canvasLocaleNamespace = "canvas", canvasUsEnglishLocaleBundle = {
  locale: "en-US",
  namespace: canvasLocaleNamespace,
  resources: () => import("./_chunks-es/resources4.js")
}, CanvasLinkCtaClicked = defineEvent({
  name: "Canvas Link CTA Clicked",
  version: 1,
  description: 'The "Link to Canvas" button is clicked.'
}), CanvasLinkRedirected = defineEvent({
  name: "Canvas Link Redirected",
  version: 1,
  description: "The user is redirected to the canvas studio-import page"
}), CanvasLinkDialogDiffsShown = defineEvent({
  name: "Canvas Link Dialog Diffs Shown",
  version: 1,
  description: "The diffs dialog is shown"
}), CanvasLinkDialogRejected = defineEvent({
  name: "Canvas Link Dialog Rejected",
  version: 1,
  description: 'User clicked "Cancel" in the "Link to Canvas" dialog after seeing the diffs'
}), CanvasUnlinkCtaClicked = defineEvent({
  name: "Canvas Unlink CTA Clicked",
  version: 1,
  description: 'User clicked "Unlink" action'
}), CanvasUnlinkApproved = defineEvent({
  name: "Canvas Unlink Approved",
  version: 1,
  description: "User confirmed that they want the Studio document unlinked"
}), CanvasOpened = defineEvent({
  name: "Canvas Opened from studio",
  version: 1,
  description: 'User clicked "Edit in Canvas"'
}), getDiffTypesCount = (diffs) => diffs.reduce((acc, diff) => (acc[diff.type] = (acc[diff.type] || 0) + 1, acc), {});
function useCanvasTelemetry() {
  const $ = c(2), telemetry = useTelemetry();
  let t0;
  return $[0] !== telemetry ? (t0 = {
    linkCtaClicked: () => telemetry.log(CanvasLinkCtaClicked),
    linkRedirected: (origin, diffs) => telemetry.log(CanvasLinkRedirected, {
      origin,
      diffs: diffs ? getDiffTypesCount(diffs) : void 0
    }),
    linkDialogDiffsShown: () => telemetry.log(CanvasLinkDialogDiffsShown),
    linkDialogRejected: (diffs_0) => telemetry.log(CanvasLinkDialogRejected, {
      diffs: getDiffTypesCount(diffs_0)
    }),
    unlinkCtaClicked: () => telemetry.log(CanvasUnlinkCtaClicked),
    unlinkApproved: () => telemetry.log(CanvasUnlinkApproved),
    canvasOpened: (origin_0) => telemetry.log(CanvasOpened, {
      origin: origin_0
    })
  }, $[0] = telemetry, $[1] = t0) : t0 = $[1], t0;
}
const useNavigateToCanvasDoc = (canvasDocId, origin) => {
  const $ = c(10), {
    value: organizationId
  } = useProjectOrganizationId(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    node
  } = useComlinkStore(), isInDashboard = useRenderingContext()?.name === "coreUi", {
    canvasOpened
  } = useCanvasTelemetry(), toast = useToast(), {
    t
  } = useTranslation(canvasLocaleNamespace);
  let t0;
  return $[0] !== canvasDocId || $[1] !== canvasOpened || $[2] !== client || $[3] !== isInDashboard || $[4] !== node || $[5] !== organizationId || $[6] !== origin || $[7] !== t || $[8] !== toast ? (t0 = () => {
    if (canvasDocId)
      if (canvasOpened(origin), isInDashboard && node) {
        const message = {
          type: "dashboard/v1/bridge/navigate-to-resource",
          data: {
            resourceId: "",
            resourceType: "canvas",
            path: `doc/${canvasDocId}`
          }
        };
        node.post(message.type, message.data);
      } else {
        if (!organizationId) {
          toast.push({
            status: "error",
            title: t("navigate-to-canvas-doc.error.missing-permissions")
          });
          return;
        }
        const isStaging2 = client.config().apiHost === "https://api.sanity.work";
        window.open(`https://www.sanity.${isStaging2 ? "work" : "io"}/@${organizationId}/canvas/doc/${canvasDocId}`, "_blank");
      }
  }, $[0] = canvasDocId, $[1] = canvasOpened, $[2] = client, $[3] = isInDashboard, $[4] = node, $[5] = organizationId, $[6] = origin, $[7] = t, $[8] = toast, $[9] = t0) : t0 = $[9], t0;
};
function getDocumentIdForCanvasLink(actionProps) {
  return actionProps.version ? actionProps.version._id : actionProps.liveEditSchemaType ? getPublishedId(actionProps.id) : actionProps.draft ? actionProps.draft._id : getDraftId(actionProps.id);
}
const useEditInCanvasAction = (props2) => {
  const $ = c(7), {
    t
  } = useTranslation(canvasLocaleNamespace);
  let t0;
  $[0] !== props2 ? (t0 = getDocumentIdForCanvasLink(props2), $[0] = props2, $[1] = t0) : t0 = $[1];
  const {
    isLinked,
    companionDoc,
    loading
  } = useCanvasCompanionDoc(t0), navigateToCanvas = useNavigateToCanvasDoc(companionDoc?.canvasDocumentId, "action");
  if (!isLinked || loading)
    return null;
  let t1;
  $[2] !== t ? (t1 = t("action.edit-document"), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== navigateToCanvas || $[5] !== t1 ? (t2 = {
    icon: ComposeSparklesIcon,
    label: t1,
    onHandle: navigateToCanvas
  }, $[4] = navigateToCanvas, $[5] = t1, $[6] = t2) : t2 = $[6], t2;
};
useEditInCanvasAction.action = "editInCanvas";
useEditInCanvasAction.displayName = "EditInCanvasAction";
const buildDocumentForDiffInput = (document2) => {
  const {
    _id,
    _rev,
    _createdAt,
    _updatedAt,
    ...rest
  } = JSON.parse(JSON.stringify(document2));
  return rest;
};
function DocumentDiff(t0) {
  const $ = c(20), {
    baseDocument,
    document: document2
  } = t0, schema2 = useSchema();
  let t1;
  $[0] !== document2._type || $[1] !== schema2 ? (t1 = schema2.get(document2._type), $[0] = document2._type, $[1] = schema2, $[2] = t1) : t1 = $[2];
  const schemaType = t1, {
    currentUser
  } = useSource();
  let t2;
  $[3] !== baseDocument || $[4] !== currentUser?.id || $[5] !== document2 ? (t2 = diffInput(wrap$1(buildDocumentForDiffInput(baseDocument ?? {}), {
    author: currentUser?.id
  }), wrap$1(buildDocumentForDiffInput(document2), {
    author: currentUser?.id
  })), $[3] = baseDocument, $[4] = currentUser?.id, $[5] = document2, $[6] = t2) : t2 = $[6];
  const rootDiff = t2;
  let t3;
  $[7] !== document2._id ? (t3 = getPublishedId(document2._id), $[7] = document2._id, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== document2 || $[10] !== rootDiff || $[11] !== schemaType || $[12] !== t3 ? (t4 = {
    documentId: t3,
    schemaType,
    rootDiff,
    isComparingCurrent: !1,
    FieldWrapper: _temp$1a,
    value: document2,
    showFromValue: !0
  }, $[9] = document2, $[10] = rootDiff, $[11] = schemaType, $[12] = t3, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== rootDiff || $[15] !== schemaType ? (t5 = /* @__PURE__ */ jsx(ChangeList, { diff: rootDiff, schemaType }), $[14] = rootDiff, $[15] = schemaType, $[16] = t5) : t5 = $[16];
  let t6;
  return $[17] !== t4 || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsx(DocumentChangeContext.Provider, { value: t4, children: t5 }), $[17] = t4, $[18] = t5, $[19] = t6) : t6 = $[19], t6;
}
function _temp$1a(props2) {
  return props2.children;
}
const ChipCard = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "ChipCard",
  componentId: "sc-yz82fb-0"
})((props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return css`
    --card-fg-color: ${color.button.ghost[props2.tone].enabled.fg};
  `;
}), VersionChip = (t0) => {
  const $ = c(13), {
    id: id2,
    showSparkles
  } = t0, documentVariantType = getDocumentVariantType(id2), badgeTitle = documentVariantType === "published" ? "Published" : "Draft", badgeTone = documentVariantType === "published" ? "positive" : "caution", t1 = documentVariantType === "published" ? "positive" : "caution";
  let t2;
  $[0] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ReleaseAvatarIcon, { tone: t1 }) }), $[0] = t1, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== badgeTitle ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: badgeTitle }), $[2] = badgeTitle, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== showSparkles ? (t4 = showSparkles && /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ComposeSparklesIcon, {}) }), $[4] = showSparkles, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== t2 || $[7] !== t3 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "center", children: [
    t2,
    t3,
    t4
  ] }), $[6] = t2, $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  return $[10] !== badgeTone || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(ChipCard, { tone: badgeTone, padding: 2, paddingRight: 3, radius: "full", children: t5 }), $[10] = badgeTone, $[11] = t5, $[12] = t6) : t6 = $[12], t6;
};
function LinkToCanvasDiff(t0) {
  const $ = c(34), {
    originalDocument,
    mappedDocument
  } = t0, {
    t
  } = useTranslation(canvasLocaleNamespace);
  let t1, t2, t3, t4;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    opacity: 0
  }, t2 = {
    opacity: 1
  }, t3 = {
    opacity: 0
  }, t4 = {
    duration: 0.3
  }, $[0] = t1, $[1] = t2, $[2] = t3, $[3] = t4) : (t1 = $[0], t2 = $[1], t3 = $[2], t4 = $[3]);
  let t5;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 2, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[4] = t5) : t5 = $[4];
  let t6;
  $[5] !== t ? (t6 = t("dialog.confirm-document-changes.title"), $[5] = t, $[6] = t6) : t6 = $[6];
  let t7;
  $[7] !== t6 ? (t7 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t6 }) }), $[7] = t6, $[8] = t7) : t7 = $[8];
  let t8;
  $[9] !== t ? (t8 = t("dialog.confirm-document-changes.description"), $[9] = t, $[10] = t8) : t8 = $[10];
  let t9;
  $[11] !== t8 ? (t9 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t8 }) }), $[11] = t8, $[12] = t9) : t9 = $[12];
  let t10;
  $[13] !== t7 || $[14] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { tone: "critical", padding: 2, radius: 3, children: /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "flex-start", children: [
    t5,
    /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
      t7,
      t9
    ] })
  ] }) }), $[13] = t7, $[14] = t9, $[15] = t10) : t10 = $[15];
  const t11 = originalDocument?._id || "";
  let t12;
  $[16] !== t11 ? (t12 = /* @__PURE__ */ jsx(VersionChip, { id: t11 }), $[16] = t11, $[17] = t12) : t12 = $[17];
  let t13;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = /* @__PURE__ */ jsx(Text$1, { size: 2, children: /* @__PURE__ */ jsx(ArrowRightIcon, {}) }), $[18] = t13) : t13 = $[18];
  const t14 = mappedDocument?._id || "";
  let t15;
  $[19] !== t14 ? (t15 = /* @__PURE__ */ jsx(VersionChip, { id: t14, showSparkles: !0 }), $[19] = t14, $[20] = t15) : t15 = $[20];
  let t16;
  $[21] !== t12 || $[22] !== t15 ? (t16 = /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "center", children: [
    t12,
    t13,
    t15
  ] }) }), $[21] = t12, $[22] = t15, $[23] = t16) : t16 = $[23];
  let t17;
  $[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t17 = /* @__PURE__ */ jsx(Card, { borderBottom: !0 }), $[24] = t17) : t17 = $[24];
  let t18;
  $[25] !== mappedDocument || $[26] !== originalDocument ? (t18 = originalDocument && mappedDocument && /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(DocumentDiff, { baseDocument: originalDocument, document: mappedDocument }) }), $[25] = mappedDocument, $[26] = originalDocument, $[27] = t18) : t18 = $[27];
  let t19;
  $[28] !== t16 || $[29] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Card, { radius: 3, border: !0, marginTop: 3, children: [
    t16,
    t17,
    t18
  ] }), $[28] = t16, $[29] = t18, $[30] = t19) : t19 = $[30];
  let t20;
  return $[31] !== t10 || $[32] !== t19 ? (t20 = /* @__PURE__ */ jsxs(motion.div, { initial: t1, animate: t2, exit: t3, transition: t4, children: [
    t10,
    t19
  ] }), $[31] = t10, $[32] = t19, $[33] = t20) : t20 = $[33], t20;
}
const useWorkspaceSchemaId = () => {
  const $ = c(2), t0 = useWorkspace().name || "default";
  let t1;
  return $[0] !== t0 ? (t1 = getWorkspaceSchemaId({
    workspaceName: t0
  }), $[0] = t0, $[1] = t1) : t1 = $[1], t1.safeBaseId;
}, localeSettings = Intl.DateTimeFormat().resolvedOptions(), initialState$1 = {
  status: "validating"
}, CANVAS_CLIENT_CONFIG = {
  apiVersion: "v2025-04-29"
}, canvasPreflight = ({
  client,
  document: document2,
  schemaId
}) => {
  const dataset = client.config().dataset;
  return client.observable.request({
    url: `/assist/studio-to-canvas/${dataset}`,
    tag: "sanity.canvas",
    method: "POST",
    body: {
      document: document2,
      schemaId,
      localeSettings: {
        locale: localeSettings.locale,
        timeZone: localeSettings.timeZone
      }
    }
  });
};
function useLinkToCanvas(t0) {
  const $ = c(25), {
    document: document2
  } = t0, workspace = useWorkspace(), projectStore = useProjectStore(), renderContext = useRenderingContext(), {
    node
  } = useComlinkStore(), isInDashboard = renderContext?.name === "coreUi", {
    linkRedirected,
    linkDialogDiffsShown
  } = useCanvasTelemetry(), t1 = workspace.apps?.canvas?.fallbackStudioOrigin;
  let t2;
  $[0] !== t1 ? (t2 = {
    enabled: !0,
    fallbackStudioOrigin: t1
  }, $[0] = t1, $[1] = t2) : t2 = $[1];
  const {
    studioApp,
    loading: appIdLoading
  } = useStudioAppIdStore(t2), schemaId = useWorkspaceSchemaId(), client = useClient(CANVAS_CLIENT_CONFIG);
  let t3;
  bb0: {
    if (appIdLoading) {
      let t42;
      $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = of({
        status: "validating"
      }), $[2] = t42) : t42 = $[2], t3 = t42;
      break bb0;
    }
    if (!studioApp?.appId) {
      let t42;
      $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = of({
        status: "error",
        error: "Studio app not found, try deploying it or set the fallbackStudioOrigin"
      }), $[3] = t42) : t42 = $[3], t3 = t42;
      break bb0;
    }
    if (!document2?._id) {
      let t42;
      $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = of({
        status: "missing-document-id",
        error: "Missing document ID"
      }), $[4] = t42) : t42 = $[4], t3 = t42;
      break bb0;
    }
    let t4;
    $[5] !== client || $[6] !== document2._id || $[7] !== document2._type || $[8] !== isInDashboard || $[9] !== node || $[10] !== projectStore || $[11] !== studioApp?.appId || $[12] !== workspace.name ? (t4 = () => {
      const dataset = client.config().dataset || "", projectId = client.config().projectId || "", path = `studio-import?${new URLSearchParams({
        projectId,
        dataset,
        documentType: document2._type,
        documentId: document2._id,
        workspaceName: workspace.name,
        applicationId: studioApp?.appId || ""
      }).toString()}`;
      if (isInDashboard && node) {
        const message = {
          type: "dashboard/v1/bridge/navigate-to-resource",
          data: {
            resourceId: "",
            resourceType: "canvas",
            path
          }
        };
        return of(() => node.post(message.type, message.data));
      }
      return projectStore.getOrganizationId().pipe(map$1((organizationId) => {
        if (!organizationId)
          return _temp$19;
        const canvasLinkUrl = `https://www.sanity.${client.config().apiHost === "https://api.sanity.work" ? "work" : "io"}/@${organizationId}/canvas/${path}`;
        return () => window.open(canvasLinkUrl, "_blank");
      }));
    }, $[5] = client, $[6] = document2._id, $[7] = document2._type, $[8] = isInDashboard, $[9] = node, $[10] = projectStore, $[11] = studioApp?.appId, $[12] = workspace.name, $[13] = t4) : t4 = $[13];
    const getNavigateToCanvas = t4;
    let t5;
    if ($[14] !== client || $[15] !== document2 || $[16] !== getNavigateToCanvas || $[17] !== linkDialogDiffsShown || $[18] !== linkRedirected || $[19] !== schemaId) {
      let t6;
      $[21] !== linkRedirected ? (t6 = (t72) => {
        const [preflight, navigateToCanvas] = t72;
        if (!preflight.error) {
          const status = preflight.diff?.length ? "diff" : "redirecting";
          return {
            status,
            error: null,
            response: preflight,
            navigateToCanvas: () => {
              linkRedirected(status === "diff" ? "diff-dialog" : "redirect", preflight.diff), navigateToCanvas();
            }
          };
        }
        return {
          status: "error",
          error: preflight.error,
          response: preflight,
          redirectUrl: void 0
        };
      }, $[21] = linkRedirected, $[22] = t6) : t6 = $[22];
      let t7;
      $[23] !== linkDialogDiffsShown ? (t7 = (t8) => {
        const {
          status: status_0,
          navigateToCanvas: navigateToCanvas_0
        } = t8;
        status_0 === "redirecting" && setTimeout(() => {
          navigateToCanvas_0();
        }, 1e3), status_0 === "diff" && linkDialogDiffsShown();
      }, $[23] = linkDialogDiffsShown, $[24] = t7) : t7 = $[24], t5 = combineLatest([canvasPreflight({
        client,
        document: document2,
        schemaId
      }), getNavigateToCanvas()]).pipe(map$1(t6), tap$1(t7), catchError$1(_temp2$r)), $[14] = client, $[15] = document2, $[16] = getNavigateToCanvas, $[17] = linkDialogDiffsShown, $[18] = linkRedirected, $[19] = schemaId, $[20] = t5;
    } else
      t5 = $[20];
    t3 = t5;
  }
  return useObservable(t3, initialState$1);
}
function _temp2$r(error) {
  return of({
    status: "error",
    error: error.message
  });
}
function _temp$19() {
}
const LinkToCanvasDialog = (t0) => {
  const $ = c(35), {
    document: document2,
    onClose
  } = t0, {
    t
  } = useTranslation(canvasLocaleNamespace), id2 = useId();
  let t1;
  $[0] !== document2 ? (t1 = {
    document: document2
  }, $[0] = document2, $[1] = t1) : t1 = $[1];
  const {
    status,
    error,
    navigateToCanvas,
    response
  } = useLinkToCanvas(t1), {
    linkDialogRejected
  } = useCanvasTelemetry();
  let t2;
  $[2] !== linkDialogRejected || $[3] !== onClose || $[4] !== response?.diff || $[5] !== status ? (t2 = () => {
    onClose(), status === "diff" && linkDialogRejected(response?.diff || []);
  }, $[2] = linkDialogRejected, $[3] = onClose, $[4] = response?.diff, $[5] = status, $[6] = t2) : t2 = $[6];
  const handleClose = t2, t3 = `dialog-link-to-canvas-${id2}`;
  let t4;
  $[7] !== t ? (t4 = t("dialog.link-to-canvas.title"), $[7] = t, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== navigateToCanvas || $[10] !== onClose || $[11] !== status || $[12] !== t ? (t5 = status === "diff" ? {
    description: t("dialog.confirm-document-changes.footer-description"),
    confirmButton: {
      text: t("dialog.confirm-document-changes.confirm"),
      icon: ComposeSparklesIcon,
      tone: "default",
      onClick: navigateToCanvas,
      space: 2
    },
    cancelButton: {
      text: t("dialog.confirm-document-changes.cancel"),
      onClick: onClose
    }
  } : void 0, $[9] = navigateToCanvas, $[10] = onClose, $[11] = status, $[12] = t, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== status || $[15] !== t ? (t6 = (status === "validating" || status === "redirecting") && /* @__PURE__ */ jsx(Box, { paddingY: 5, children: /* @__PURE__ */ jsx(LoadingBlock, { title: t(status === "validating" ? "dialog.link-to-canvas.validating" : "dialog.link-to-canvas.redirecting"), showText: !0 }) }), $[14] = status, $[15] = t, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== error || $[18] !== status || $[19] !== t ? (t7 = (status === "error" || status === "missing-document-id") && /* @__PURE__ */ jsx(motion.div, { initial: {
    opacity: 0
  }, animate: {
    opacity: 1
  }, exit: {
    opacity: 0
  }, transition: {
    duration: 0.3
  }, children: /* @__PURE__ */ jsx(Card, { border: !0, tone: "critical", padding: 4, radius: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: error || t("dialog.link-to-canvas.error") }) }) }), $[17] = error, $[18] = status, $[19] = t, $[20] = t7) : t7 = $[20];
  let t8;
  $[21] !== document2 || $[22] !== response || $[23] !== status ? (t8 = status === "diff" && response && /* @__PURE__ */ jsx(LinkToCanvasDiff, { originalDocument: document2, mappedDocument: response.mappedDocument }), $[21] = document2, $[22] = response, $[23] = status, $[24] = t8) : t8 = $[24];
  let t9;
  $[25] !== t6 || $[26] !== t7 || $[27] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Box, { padding: 3, children: [
    t6,
    t7,
    t8
  ] }), $[25] = t6, $[26] = t7, $[27] = t8, $[28] = t9) : t9 = $[28];
  let t10;
  return $[29] !== handleClose || $[30] !== t3 || $[31] !== t4 || $[32] !== t5 || $[33] !== t9 ? (t10 = /* @__PURE__ */ jsx(Dialog$1, { id: t3, header: t4, onClose: handleClose, width: 1, bodyHeight: "stretch", padding: !1, footer: t5, children: t9 }), $[29] = handleClose, $[30] = t3, $[31] = t4, $[32] = t5, $[33] = t9, $[34] = t10) : t10 = $[34], t10;
}, useIsExcludedType = (type) => {
  const $ = c(3), schema2 = useSchema();
  let t0;
  return $[0] !== schema2 || $[1] !== type ? (t0 = schema2.get(type)?.options?.sanityCreate?.exclude, $[0] = schema2, $[1] = type, $[2] = t0) : t0 = $[2], t0;
}, useLinkToCanvasAction = (props2) => {
  const $ = c(38), {
    t
  } = useTranslation(canvasLocaleNamespace), [isDialogOpen, setIsDialogOpen] = useState(!1), {
    selectedPerspective
  } = usePerspective();
  let t0;
  $[0] !== props2 ? (t0 = getDocumentIdForCanvasLink(props2), $[0] = props2, $[1] = t0) : t0 = $[1];
  const {
    isLinked,
    loading
  } = useCanvasCompanionDoc(t0), {
    value: organizationId
  } = useProjectOrganizationId(), {
    linkCtaClicked
  } = useCanvasTelemetry(), isExcludedType = useIsExcludedType(props2.type);
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setIsDialogOpen(!1), $[2] = t1) : t1 = $[2];
  const handleCloseDialog = t1, isInDashboard = useRenderingContext()?.name === "coreUi", isVersionDocument = !!props2.release, getFormValue = useGetFormValue(), [formValue, setFormValue] = useState();
  let t2;
  $[3] !== getFormValue || $[4] !== linkCtaClicked || $[5] !== props2.liveEditSchemaType ? (t2 = () => {
    linkCtaClicked();
    const value = getFormValue([]);
    setFormValue({
      ...value,
      _id: props2.liveEditSchemaType ? getPublishedId(value._id) : getDraftId(value._id)
    }), setIsDialogOpen(!0);
  }, $[3] = getFormValue, $[4] = linkCtaClicked, $[5] = props2.liveEditSchemaType, $[6] = t2) : t2 = $[6];
  const handleOpenDialog = t2;
  let t3;
  bb0: {
    if (!organizationId) {
      let t43;
      $[7] !== t ? (t43 = t("action.link-document-disabled.missing-permissions"), $[7] = t, $[8] = t43) : t43 = $[8];
      let t52;
      $[9] !== t43 ? (t52 = {
        disabled: !0,
        reason: t43
      }, $[9] = t43, $[10] = t52) : t52 = $[10], t3 = t52;
      break bb0;
    }
    if (!isInDashboard) {
      let t43;
      $[11] !== t ? (t43 = t("action.link-document-disabled.not-in-dashboard"), $[11] = t, $[12] = t43) : t43 = $[12];
      let t52;
      $[13] !== t43 ? (t52 = {
        disabled: !0,
        reason: t43
      }, $[13] = t43, $[14] = t52) : t52 = $[14], t3 = t52;
      break bb0;
    }
    if (isVersionDocument) {
      let t43;
      $[15] !== t ? (t43 = t("action.link-document-disabled.version-document"), $[15] = t, $[16] = t43) : t43 = $[16];
      let t52;
      $[17] !== t43 ? (t52 = {
        disabled: !0,
        reason: t43
      }, $[17] = t43, $[18] = t52) : t52 = $[18], t3 = t52;
      break bb0;
    }
    if (!props2.initialValueResolved) {
      let t43;
      $[19] !== t ? (t43 = t("action.link-document-disabled.initial-value-not-resolved"), $[19] = t, $[20] = t43) : t43 = $[20];
      let t52;
      $[21] !== t43 ? (t52 = {
        disabled: !0,
        reason: t43
      }, $[21] = t43, $[22] = t52) : t52 = $[22], t3 = t52;
      break bb0;
    }
    let t42;
    $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = {
      disabled: !1,
      reason: void 0
    }, $[23] = t42) : t42 = $[23], t3 = t42;
  }
  const disabled = t3;
  let t4, t5;
  if ($[24] !== isLinked ? (t4 = () => {
    isLinked && handleCloseDialog();
  }, t5 = [isLinked, handleCloseDialog], $[24] = isLinked, $[25] = t4, $[26] = t5) : (t4 = $[25], t5 = $[26]), useEffect(t4, t5), isLinked || loading || isExcludedType || selectedPerspective === "published" && !props2.liveEditSchemaType || isReleaseDocument(selectedPerspective) || !isInDashboard)
    return null;
  const t6 = disabled.disabled;
  let t7;
  $[27] !== formValue || $[28] !== isDialogOpen ? (t7 = isDialogOpen && formValue ? {
    type: "custom",
    component: /* @__PURE__ */ jsx(LinkToCanvasDialog, { onClose: handleCloseDialog, document: formValue })
  } : void 0, $[27] = formValue, $[28] = isDialogOpen, $[29] = t7) : t7 = $[29];
  let t8;
  $[30] !== t ? (t8 = t("action.link-document"), $[30] = t, $[31] = t8) : t8 = $[31];
  let t9;
  return $[32] !== disabled.disabled || $[33] !== disabled.reason || $[34] !== handleOpenDialog || $[35] !== t7 || $[36] !== t8 ? (t9 = {
    disabled: t6,
    icon: ComposeSparklesIcon,
    dialog: t7,
    label: t8,
    title: disabled.reason,
    onHandle: handleOpenDialog
  }, $[32] = disabled.disabled, $[33] = disabled.reason, $[34] = handleOpenDialog, $[35] = t7, $[36] = t8, $[37] = t9) : t9 = $[37], t9;
};
useLinkToCanvasAction.action = "linkToCanvas";
useLinkToCanvasAction.displayName = "LinkToCanvasAction";
const useDocumentTitle = (t0) => {
  const $ = c(11), {
    document: document2
  } = t0, schema2 = useSchema();
  let t1;
  $[0] !== document2._type || $[1] !== schema2 ? (t1 = schema2.get(document2._type), $[0] = document2._type, $[1] = schema2, $[2] = t1) : t1 = $[2];
  const schemaType = t1, t2 = !!document2;
  let t3;
  $[3] !== document2 || $[4] !== schemaType || $[5] !== t2 ? (t3 = {
    enabled: t2,
    schemaType,
    value: document2
  }, $[3] = document2, $[4] = schemaType, $[5] = t2, $[6] = t3) : t3 = $[6];
  const {
    error,
    value
  } = useValuePreview(t3);
  if (!schemaType) {
    let t42;
    return $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = {
      error: "Schema type not found"
    }, $[7] = t42) : t42 = $[7], t42;
  }
  const t4 = value?.title;
  let t5;
  return $[8] !== error || $[9] !== t4 ? (t5 = {
    error,
    title: t4
  }, $[8] = error, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
}, UnlinkFromCanvasDialog = (t0) => {
  const $ = c(50), {
    document: document2,
    onClose,
    status,
    error,
    handleUnlink
  } = t0, {
    t
  } = useTranslation(canvasLocaleNamespace), {
    t: coreT
  } = useTranslation();
  let t1;
  $[0] !== document2 ? (t1 = {
    document: document2
  }, $[0] = document2, $[1] = t1) : t1 = $[1];
  const {
    title
  } = useDocumentTitle(t1), t2 = `dialog-unlink-from-canvas-${useId()}`;
  let t3;
  $[2] !== t ? (t3 = t("dialog.unlink-from-canvas.title"), $[2] = t, $[3] = t3) : t3 = $[3];
  const t4 = status === "loading" ? void 0 : onClose;
  let t5;
  $[4] !== t ? (t5 = t("dialog.unlink-from-canvas.cancel"), $[4] = t, $[5] = t5) : t5 = $[5];
  const t6 = status != "idle";
  let t7;
  $[6] !== onClose || $[7] !== t5 || $[8] !== t6 ? (t7 = {
    text: t5,
    onClick: onClose,
    disabled: t6
  }, $[6] = onClose, $[7] = t5, $[8] = t6, $[9] = t7) : t7 = $[9];
  let t8;
  $[10] !== t ? (t8 = t("dialog.unlink-from-canvas.unlink-action"), $[10] = t, $[11] = t8) : t8 = $[11];
  const t9 = status === "loading", t10 = status != "idle";
  let t11;
  $[12] !== handleUnlink || $[13] !== t10 || $[14] !== t8 || $[15] !== t9 ? (t11 = {
    text: t8,
    onClick: handleUnlink,
    tone: "default",
    loading: t9,
    disabled: t10
  }, $[12] = handleUnlink, $[13] = t10, $[14] = t8, $[15] = t9, $[16] = t11) : t11 = $[16];
  let t12;
  $[17] !== t11 || $[18] !== t7 ? (t12 = {
    cancelButton: t7,
    confirmButton: t11
  }, $[17] = t11, $[18] = t7, $[19] = t12) : t12 = $[19];
  let t13;
  $[20] !== coreT || $[21] !== title ? (t13 = title || coreT("preview.default.title-fallback"), $[20] = coreT, $[21] = title, $[22] = t13) : t13 = $[22];
  let t14;
  $[23] !== t13 ? (t14 = {
    documentTitle: t13
  }, $[23] = t13, $[24] = t14) : t14 = $[24];
  let t15;
  $[25] !== t || $[26] !== t14 ? (t15 = /* @__PURE__ */ jsx(Box, { paddingBottom: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "dialog.unlink-from-canvas.unlinking", values: t14 }) }) }), $[25] = t, $[26] = t14, $[27] = t15) : t15 = $[27];
  let t16;
  $[28] !== t ? (t16 = t("dialog.unlink-from-canvas.description"), $[28] = t, $[29] = t16) : t16 = $[29];
  let t17;
  $[30] !== t16 ? (t17 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t16 }) }), $[30] = t16, $[31] = t17) : t17 = $[31];
  let t18;
  $[32] !== t15 || $[33] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t15,
    t17
  ] }), $[32] = t15, $[33] = t17, $[34] = t18) : t18 = $[34];
  let t19;
  $[35] !== error || $[36] !== status || $[37] !== t ? (t19 = status === "error" && /* @__PURE__ */ jsx(motion.div, { initial: {
    opacity: 0,
    scale: 0.9
  }, animate: {
    opacity: 1,
    scale: 1
  }, children: /* @__PURE__ */ jsx(Card, { tone: "critical", padding: 2, radius: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: error || t("dialog.unlink-from-canvas.error") }) }) }, "error"), $[35] = error, $[36] = status, $[37] = t, $[38] = t19) : t19 = $[38];
  let t20;
  $[39] !== t19 ? (t20 = /* @__PURE__ */ jsx(AnimatePresence, { children: t19 }), $[39] = t19, $[40] = t20) : t20 = $[40];
  let t21;
  $[41] !== t18 || $[42] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t18,
    t20
  ] }), $[41] = t18, $[42] = t20, $[43] = t21) : t21 = $[43];
  let t22;
  return $[44] !== t12 || $[45] !== t2 || $[46] !== t21 || $[47] !== t3 || $[48] !== t4 ? (t22 = /* @__PURE__ */ jsx(Dialog$1, { id: t2, header: t3, onClose: t4, bodyHeight: "stretch", footer: t12, children: t21 }), $[44] = t12, $[45] = t2, $[46] = t21, $[47] = t3, $[48] = t4, $[49] = t22) : t22 = $[49], t22;
}, useUnlinkFromCanvasAction = (props2) => {
  const $ = c(23), {
    t
  } = useTranslation(canvasLocaleNamespace);
  let t0;
  $[0] !== props2 ? (t0 = getDocumentIdForCanvasLink(props2), $[0] = props2, $[1] = t0) : t0 = $[1];
  const {
    isLinked,
    companionDoc,
    loading
  } = useCanvasCompanionDoc(t0), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    unlinkCtaClicked,
    unlinkApproved
  } = useCanvasTelemetry(), toast = useToast(), [isDialogOpen, setIsDialogOpen] = useState(!1), [status, setStatus] = useState("idle"), [error, setError] = useState(null);
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setIsDialogOpen(!1), $[2] = t1) : t1 = $[2];
  const handleCloseDialog = t1;
  let t2;
  $[3] !== unlinkCtaClicked ? (t2 = () => {
    unlinkCtaClicked(), setIsDialogOpen(!0);
  }, $[3] = unlinkCtaClicked, $[4] = t2) : t2 = $[4];
  const handleOpenDialog = t2;
  let t3;
  $[5] !== client || $[6] !== companionDoc?._id || $[7] !== t || $[8] !== toast || $[9] !== unlinkApproved ? (t3 = async () => {
    const run = async () => {
      if (!companionDoc?._id)
        throw new Error("Companion doc not found");
      setStatus("loading"), unlinkApproved(), await client.delete(companionDoc?._id), setStatus("idle"), handleCloseDialog(), toast.push({
        status: "success",
        title: t("dialog.unlink-from-canvas.success")
      });
    };
    try {
      await run();
    } catch (t42) {
      const e = t42;
      console.error(e), setError(e.message), setStatus("error");
    }
  }, $[5] = client, $[6] = companionDoc?._id, $[7] = t, $[8] = toast, $[9] = unlinkApproved, $[10] = t3) : t3 = $[10];
  const handleUnlink = t3, document2 = props2.version || props2.draft || props2.published;
  if (!document2 || !isLinked || loading)
    return null;
  let t4;
  $[11] !== document2 || $[12] !== error || $[13] !== handleUnlink || $[14] !== isDialogOpen || $[15] !== status ? (t4 = isDialogOpen ? {
    type: "custom",
    component: /* @__PURE__ */ jsx(UnlinkFromCanvasDialog, { onClose: handleCloseDialog, document: document2, status, error, handleUnlink })
  } : void 0, $[11] = document2, $[12] = error, $[13] = handleUnlink, $[14] = isDialogOpen, $[15] = status, $[16] = t4) : t4 = $[16];
  let t5;
  $[17] !== t ? (t5 = t("action.unlink-document"), $[17] = t, $[18] = t5) : t5 = $[18];
  let t6;
  return $[19] !== handleOpenDialog || $[20] !== t4 || $[21] !== t5 ? (t6 = {
    icon: UnlinkIcon,
    dialog: t4,
    label: t5,
    onHandle: handleOpenDialog
  }, $[19] = handleOpenDialog, $[20] = t4, $[21] = t5, $[22] = t6) : t6 = $[22], t6;
};
useUnlinkFromCanvasAction.action = "unlinkFromCanvas";
useUnlinkFromCanvasAction.displayName = "UnlinkFromCanvasAction";
const CANVAS_INTEGRATION_NAME = "sanity/canvas-integration", canvasIntegration = definePlugin(() => ({
  name: CANVAS_INTEGRATION_NAME,
  i18n: {
    bundles: [canvasUsEnglishLocaleBundle]
  },
  document: {
    actions: (prev, context) => {
      if (context.versionType === "draft" || context.versionType === "version") {
        const deleteAndDiscardActionNames = ["delete", "discardVersion"], deleteAndDiscardActions = prev.filter((action) => deleteAndDiscardActionNames.includes(action.action));
        return [...prev.filter((action) => !deleteAndDiscardActionNames.includes(action.action)), useLinkToCanvasAction, useUnlinkFromCanvasAction, useEditInCanvasAction, ...deleteAndDiscardActions];
      }
      return prev;
    }
  }
})), commentsLocaleNamespace = "comments", commentsUsEnglishLocaleBundle = {
  locale: "en-US",
  namespace: commentsLocaleNamespace,
  resources: () => import("./_chunks-es/resources.js")
};
function CommentsAuthoringPathProvider(props2) {
  const $ = c(6), {
    children
  } = props2, [authoringPath, setAuthoringPath] = useState(null);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = (nextAuthoringPath) => {
    setAuthoringPath(nextAuthoringPath);
  }, $[0] = t0) : t0 = $[0];
  const handleSetAuthoringPath = t0;
  let t1;
  $[1] !== authoringPath ? (t1 = {
    authoringPath,
    setAuthoringPath: handleSetAuthoringPath
  }, $[1] = authoringPath, $[2] = t1) : t1 = $[2];
  const value = t1;
  let t2;
  return $[3] !== children || $[4] !== value ? (t2 = /* @__PURE__ */ jsx(CommentsAuthoringPathContext.Provider, { value, children }), $[3] = children, $[4] = value, $[5] = t2) : t2 = $[5], t2;
}
function useCommentsIntent() {
  return useContext(CommentsIntentContext);
}
function useNotificationTarget(opts) {
  const $ = c(20);
  let t0;
  $[0] !== opts ? (t0 = opts || {}, $[0] = opts, $[1] = t0) : t0 = $[1];
  const {
    documentId,
    documentType,
    getCommentLink,
    documentVersionId
  } = t0, t1 = useSchema();
  let t2;
  $[2] !== documentType || $[3] !== t1 ? (t2 = t1.get(documentType), $[2] = documentType, $[3] = t1, $[4] = t2) : t2 = $[4];
  const schemaType = t2, {
    title: workspaceTitle,
    name: workspaceName
  } = useWorkspace(), documentPreviewStore = useDocumentPreviewStore();
  let t3;
  bb0: {
    if (!documentId || !schemaType) {
      let t43;
      $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t43 = of(null), $[5] = t43) : t43 = $[5], t3 = t43;
      break bb0;
    }
    let t42;
    $[6] !== documentId || $[7] !== documentPreviewStore || $[8] !== documentVersionId || $[9] !== schemaType ? (t42 = getPreviewStateObservable$1(documentPreviewStore, schemaType, documentId, documentVersionId ? [documentVersionId, "drafts"] : ["drafts"]), $[6] = documentId, $[7] = documentPreviewStore, $[8] = documentVersionId, $[9] = schemaType, $[10] = t42) : t42 = $[10], t3 = t42;
  }
  const previewState = useObservable(t3);
  let t4;
  $[11] !== previewState ? (t4 = previewState || {}, $[11] = previewState, $[12] = t4) : t4 = $[12];
  const {
    snapshot: snapshot2,
    original
  } = t4, documentTitle = snapshot2?.title || original?.title || "Sanity document";
  let t5;
  $[13] !== documentTitle || $[14] !== getCommentLink || $[15] !== workspaceName || $[16] !== workspaceTitle ? (t5 = (t62) => {
    const {
      commentId
    } = t62;
    return {
      documentTitle,
      url: getCommentLink?.(commentId),
      workspaceTitle,
      workspaceName
    };
  }, $[13] = documentTitle, $[14] = getCommentLink, $[15] = workspaceName, $[16] = workspaceTitle, $[17] = t5) : t5 = $[17];
  const handleGetNotificationValue = t5;
  let t6;
  return $[18] !== handleGetNotificationValue ? (t6 = {
    getNotificationValue: handleGetNotificationValue
  }, $[18] = handleGetNotificationValue, $[19] = t6) : t6 = $[19], t6;
}
function getSchemaField(schemaType, fieldPath) {
  const paths = PathUtils.fromString(fieldPath), firstPath = paths[0];
  if (firstPath && isObjectSchemaType(schemaType)) {
    const field = schemaType?.fields?.find((f) => f.name === firstPath);
    if (field) {
      const nextPath = PathUtils.toString(paths.slice(1));
      return nextPath ? getSchemaField(field.type, nextPath) : field;
    }
  }
}
function findArrayItemIndex(array, pathSegment) {
  if (typeof pathSegment == "number")
    return pathSegment;
  const index = findIndex$1(array, pathSegment);
  return index === -1 ? !1 : index;
}
function buildCommentBreadcrumbs(props2) {
  const {
    currentUser,
    schemaType,
    fieldPath,
    documentValue
  } = props2, paths = PathUtils.fromString(fieldPath), fieldPaths = [];
  let currentSchemaType = schemaType;
  return paths.forEach((seg, index) => {
    const currentPath = paths.slice(0, index + 1), previousPath = paths.slice(0, index), field = getSchemaField(currentSchemaType, PathUtils.toString([seg])), isKeySegment2 = seg.hasOwnProperty("_key"), parentValue = getValueAtPath(documentValue, previousPath), currentValue = getValueAtPath(documentValue, currentPath), conditionalContext = {
      document: documentValue,
      currentUser,
      parent: parentValue,
      value: currentValue,
      path: currentPath
    };
    if (isKeySegment2 && Array.isArray(parentValue)) {
      const arrayItemIndex = findArrayItemIndex(parentValue, seg), isNumber = typeof arrayItemIndex == "number";
      fieldPaths.push({
        invalid: arrayItemIndex === !1,
        isArrayItem: !0,
        title: isNumber ? `#${Number(arrayItemIndex) + 1}` : "Unknown array item"
      });
      return;
    }
    if (field?.type) {
      const hidden = resolveConditionalProperty(field.type.hidden, conditionalContext);
      fieldPaths.push({
        invalid: hidden,
        isArrayItem: !1,
        title: getSchemaTypeTitle(field.type)
      }), currentSchemaType = field.type;
      return;
    }
    if (isArraySchemaType(currentSchemaType)) {
      const objectType = getValueAtPath(documentValue, previousPath)?._type, objectField = currentSchemaType?.of?.find((type) => type.name === objectType), currentField = objectField?.fields?.find((f) => f.name === seg);
      if (!objectType && currentValue) {
        const anonymousField = currentSchemaType?.of?.map((o) => o?.fields).filter(Boolean).flat()?.find((f) => f?.name === seg), hidden = resolveConditionalProperty(anonymousField?.type?.hidden, conditionalContext);
        anonymousField && (fieldPaths.push({
          invalid: hidden,
          isArrayItem: !1,
          title: getSchemaTypeTitle(anonymousField?.type)
        }), currentSchemaType = anonymousField?.type);
        return;
      }
      if (!currentField) {
        fieldPaths.push({
          invalid: !0,
          isArrayItem: !1,
          title: "Unknown field"
        });
        return;
      }
      const currentTitle = getSchemaTypeTitle(currentField?.type), objectFieldHidden = resolveConditionalProperty(objectField?.type?.hidden, conditionalContext), currentFieldHidden = resolveConditionalProperty(currentField?.type.hidden, conditionalContext), isHidden = objectFieldHidden || currentFieldHidden;
      fieldPaths.push({
        invalid: isHidden,
        isArrayItem: !1,
        title: currentTitle
      }), currentSchemaType = currentField?.type;
      return;
    }
    fieldPaths.push({
      invalid: !0,
      isArrayItem: !1,
      title: "Unknown field"
    });
  }), fieldPaths;
}
function useCommentHasChanged(message) {
  const $ = c(3), [prevMessage] = useState(message);
  let t0;
  return $[0] !== message || $[1] !== prevMessage ? (t0 = isEqual$1(prevMessage, message), $[0] = message, $[1] = prevMessage, $[2] = t0) : t0 = $[2], !t0;
}
function hasCommentMessageValue(value) {
  return value ? value?.some((block) => isPortableTextTextBlock(block) && (block?.children || [])?.some((c2) => isPortableTextSpan(c2) ? c2.text : c2.userId)) : !1;
}
function commentIntentIfDiffers(parent, comment) {
  const parentIntent = parent?.context?.intent, intent = comment?.context?.intent;
  if (intent && (!parentIntent || "preview" in intent.params && "preview" in parentIntent.params && intent.params.preview !== parentIntent.params.preview))
    return intent;
}
function isTextSelectionComment(comment) {
  return comment ? !!(comment?.target?.path?.selection?.type === "text" && comment?.target?.path?.selection?.value) : !1;
}
const EMPTY_ARRAY$g = [];
function buildCommentThreadItems(props2) {
  const {
    comments: comments2,
    currentUser,
    documentValue,
    schemaType,
    type
  } = props2, parentComments = comments2?.filter((c2) => !c2.parentCommentId);
  return type === "task" ? parentComments.map((parentComment) => {
    const replies = comments2?.filter((r) => r.parentCommentId === parentComment._id);
    return {
      commentsCount: [parentComment, ...replies].length,
      parentComment,
      replies,
      threadId: parentComment.threadId,
      hasReferencedValue: !1,
      breadcrumbs: EMPTY_ARRAY$g,
      fieldPath: ""
    };
  }) : type === "field" ? parentComments.map((parentComment) => {
    const crumbs = buildCommentBreadcrumbs({
      currentUser,
      documentValue,
      fieldPath: parentComment.target.path?.field || "",
      schemaType
    });
    let hasTextSelection = !1;
    if (isTextSelectionComment(parentComment) && (hasTextSelection = !!(parentComment.target.path?.selection && parentComment.target.path.selection.value.some((v) => v.text))), crumbs.some((bc) => bc.invalid)) return;
    const replies = comments2?.filter((r) => r.parentCommentId === parentComment._id), commentsCount = [parentComment, ...replies].length, hasReferencedValue = hasTextSelection;
    return {
      breadcrumbs: crumbs,
      commentsCount,
      fieldPath: parentComment.target.path?.field || "",
      parentComment,
      replies,
      threadId: parentComment.threadId,
      hasReferencedValue
    };
  }).filter(Boolean) : EMPTY_ARRAY$g;
}
const separator = /* @__PURE__ */ jsx(Text$1, { muted: !0, children: /* @__PURE__ */ jsx(ChevronRightIcon, {}) }), renderItem = (item, index) => /* @__PURE__ */ jsx(Box, { as: "li", children: /* @__PURE__ */ jsx(Text$1, { textOverflow: "ellipsis", size: 1, weight: "medium", children: item }) }, `${item}-${index}`);
function CommentBreadcrumbs(props2) {
  const $ = c(11), {
    titlePath,
    maxLength
  } = props2;
  let t0;
  bb0: {
    const len = titlePath.length, beforeLength = Math.ceil(maxLength / 2), afterLength = Math.floor(maxLength / 2);
    if (maxLength && len > maxLength) {
      let t12;
      $[0] !== afterLength || $[1] !== beforeLength || $[2] !== len || $[3] !== titlePath ? (t12 = [...titlePath.slice(0, beforeLength - 1), titlePath.slice(beforeLength - 1, len - afterLength), ...titlePath.slice(len - afterLength)], $[0] = afterLength, $[1] = beforeLength, $[2] = len, $[3] = titlePath, $[4] = t12) : t12 = $[4], t0 = t12;
      break bb0;
    }
    t0 = titlePath;
  }
  const items = t0;
  let t1;
  if ($[5] !== items) {
    let t22;
    $[7] !== items.length ? (t22 = (item, index) => {
      const key = `${item}-${index}`, showSeparator = index < items.length - 1;
      return Array.isArray(item) ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Tooltip, { content: /* @__PURE__ */ jsx(Stack, { space: 2, padding: 2, children: item.map(renderItem) }), children: /* @__PURE__ */ jsx(Box, { children: renderItem("...", index) }) }),
        showSeparator && separator
      ] }, key) : /* @__PURE__ */ jsxs(Fragment, { children: [
        renderItem(item, index),
        showSeparator && separator
      ] }, key);
    }, $[7] = items.length, $[8] = t22) : t22 = $[8], t1 = items.map(t22), $[5] = items, $[6] = t1;
  } else
    t1 = $[6];
  const nodes = t1;
  let t2;
  return $[9] !== nodes ? (t2 = /* @__PURE__ */ jsx(Flex, { align: "center", as: "ol", gap: 2, children: nodes }), $[9] = nodes, $[10] = t2) : t2 = $[10], t2;
}
function getDialogCopy(t) {
  return {
    thread: {
      title: t("delete-thread.title"),
      body: t("delete-thread.body"),
      confirmButtonText: t("delete-thread.confirm")
    },
    comment: {
      title: t("delete-comment.title"),
      body: t("delete-comment.body"),
      confirmButtonText: t("delete-comment.confirm")
    }
  };
}
function CommentDeleteDialog(props2) {
  const $ = c(27), {
    isParent,
    onClose,
    commentId,
    onConfirm,
    loading,
    error
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] !== t ? (t0 = getDialogCopy(t), $[0] = t, $[1] = t0) : t0 = $[1];
  const dialogCopy = t0, {
    title,
    body,
    confirmButtonText
  } = dialogCopy[isParent ? "thread" : "comment"];
  let t1;
  $[2] !== commentId || $[3] !== onConfirm ? (t1 = () => {
    onConfirm(commentId);
  }, $[2] = commentId, $[3] = onConfirm, $[4] = t1) : t1 = $[4];
  const handleDelete = t1;
  let t2;
  $[5] !== onClose ? (t2 = {
    onClick: onClose
  }, $[5] = onClose, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] !== confirmButtonText || $[8] !== handleDelete || $[9] !== loading ? (t3 = {
    loading,
    onClick: handleDelete,
    text: confirmButtonText,
    tone: "critical"
  }, $[7] = confirmButtonText, $[8] = handleDelete, $[9] = loading, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== t2 || $[12] !== t3 ? (t4 = {
    cancelButton: t2,
    confirmButton: t3
  }, $[11] = t2, $[12] = t3, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== body ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: body }), $[14] = body, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== error || $[17] !== t ? (t6 = error && /* @__PURE__ */ jsx(TextWithTone, { tone: "critical", children: t("delete-dialog.error") }), $[16] = error, $[17] = t, $[18] = t6) : t6 = $[18];
  let t7;
  $[19] !== t5 || $[20] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t5,
    t6
  ] }), $[19] = t5, $[20] = t6, $[21] = t7) : t7 = $[21];
  let t8;
  return $[22] !== onClose || $[23] !== t4 || $[24] !== t7 || $[25] !== title ? (t8 = /* @__PURE__ */ jsx(Dialog$1, { footer: t4, header: title, id: "delete-comment-dialog", onClose, width: 0, children: t7 }), $[22] = onClose, $[23] = t4, $[24] = t7, $[25] = title, $[26] = t8) : t8 = $[26], t8;
}
const CommentDisabledIcon = forwardRef(function(props2, ref) {
  const $ = c(5);
  let t0, t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M5.92627 14.5381H7.92627V18.5381L11.9263 14.5381H15.9263C17.0308 14.5381 17.9263 13.6427 17.9263 12.5381V6.53809C17.9263 5.43352 17.0308 4.53809 15.9263 4.53809H5.92627C4.8217 4.53809 3.92627 5.43352 3.92627 6.53809V12.5381C3.92627 13.6427 4.8217 14.5381 5.92627 14.5381Z", stroke: "currentColor", strokeWidth: "1.2", strokeLinejoin: "round" }), t1 = /* @__PURE__ */ jsx("path", { d: "M2.77256 2.66835C2.54413 2.51319 2.23317 2.57259 2.07802 2.80103L1.40378 3.7937C1.32927 3.9034 1.30139 4.0382 1.32627 4.16845C1.35115 4.29871 1.42676 4.41374 1.53646 4.48825L19.5861 16.7479C19.8146 16.903 20.1255 16.8436 20.2807 16.6152L20.9549 15.6225C21.0294 15.5128 21.0573 15.378 21.0324 15.2478C21.0076 15.1175 20.9319 15.0025 20.8222 14.928L2.77256 2.66835Z", fill: "currentColor", strokeLinejoin: "round" }), $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]);
  let t2;
  return $[2] !== props2 || $[3] !== ref ? (t2 = /* @__PURE__ */ jsxs("svg", { "data-sanity-icon": "comment-disabled", width: "1em", height: "1em", ref, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2, children: [
    t0,
    t1
  ] }), $[2] = props2, $[3] = ref, $[4] = t2) : t2 = $[4], t2;
}), MentionIcon = forwardRef(function(props2, ref) {
  const $ = c(5);
  let t0, t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M16.6633 18.9383C15.539 19.6562 14.2034 20.0723 12.7705 20.0723C8.77022 20.0723 5.52734 16.8294 5.52734 12.8291C5.52734 8.82881 8.77022 5.58594 12.7705 5.58594C16.7708 5.58594 20.0137 8.82881 20.0137 12.8291C20.0137 13.6623 19.8249 14.7093 19.6141 15.2077C19.5578 15.3408 19.479 15.4845 19.3936 15.6238C19.0955 16.1106 18.5507 16.3721 17.9807 16.4018V16.4018C16.8271 16.462 15.8588 15.5428 15.8588 14.3877V9.27302", stroke: "currentColor", strokeWidth: 1.2, strokeLinejoin: "round" }), t1 = /* @__PURE__ */ jsx("circle", { cx: "12.5732", cy: "12.8291", r: "3.08691", stroke: "currentColor", strokeWidth: 1.2 }), $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]);
  let t2;
  return $[2] !== props2 || $[3] !== ref ? (t2 = /* @__PURE__ */ jsxs("svg", { "data-sanity-icon": "mention", fill: "none", height: "1em", ref, viewBox: "0 0 25 25", width: "1em", xmlns: "http://www.w3.org/2000/svg", ...props2, children: [
    t0,
    t1
  ] }), $[2] = props2, $[3] = ref, $[4] = t2) : t2 = $[4], t2;
}), ReactionIcon = forwardRef(function(props2, ref) {
  const $ = c(8);
  let t0, t1, t2, t3, t4;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M10.1044 10.4011L10.1044 10.9972", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "square" }), t1 = /* @__PURE__ */ jsx("path", { d: "M14.2393 10.4011L14.2393 10.9972", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "square" }), t2 = /* @__PURE__ */ jsx("path", { d: "M7.12128 14.1151C7.70803 15.0226 9.66113 16.8377 11.7735 16.8377C13.8859 16.8377 15.6713 15.0226 16.4257 14.1151", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "square" }), t3 = /* @__PURE__ */ jsx("path", { d: "M16.703 6.43905C15.3486 5.36511 13.6357 4.72374 11.773 4.72374C7.38731 4.72374 3.83203 8.27902 3.83203 12.6647C3.83203 17.0503 7.38731 20.6056 11.773 20.6056C16.0995 20.6056 19.618 17.1455 19.712 12.8415", stroke: "currentColor", strokeWidth: 1.2 }), t4 = /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.1135 9.03425L19.1135 11.4903L20.3135 11.4903L20.3135 9.03425L22.7693 9.03425L22.7693 7.83425L20.3135 7.83425L20.3135 5.37941L19.1135 5.37941L19.1135 7.83425L16.6584 7.83425L16.6584 9.03425L19.1135 9.03425Z", fill: "currentColor" }), $[0] = t0, $[1] = t1, $[2] = t2, $[3] = t3, $[4] = t4) : (t0 = $[0], t1 = $[1], t2 = $[2], t3 = $[3], t4 = $[4]);
  let t5;
  return $[5] !== props2 || $[6] !== ref ? (t5 = /* @__PURE__ */ jsxs("svg", { "data-sanity-icon": "add-reaction", fill: "none", height: "1em", ref, viewBox: "0 0 25 25", width: "1em", xmlns: "http://www.w3.org/2000/svg", ...props2, children: [
    t0,
    t1,
    t2,
    t3,
    t4
  ] }), $[5] = props2, $[6] = ref, $[7] = t5) : t5 = $[7], t5;
}), SendIcon = forwardRef(function(props2, ref) {
  const $ = c(4);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { clipRule: "evenodd", d: "M21.1602 12.5L7.16016 19.5V14.8765L13.6656 12.4989L7.16016 9.97149L7.16016 5.5L21.1602 12.5Z", stroke: "currentColor", strokeWidth: 1.2, strokeLinejoin: "round" }), $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] !== props2 || $[2] !== ref ? (t1 = /* @__PURE__ */ jsx("svg", { "data-sanity-icon": "send", fill: "none", height: "1em", ref, viewBox: "0 0 25 25", width: "1em", xmlns: "http://www.w3.org/2000/svg", ...props2, children: t0 }), $[1] = props2, $[2] = ref, $[3] = t1) : t1 = $[3], t1;
}), StyledAvatar = styled(Avatar).withConfig({
  displayName: "StyledAvatar",
  componentId: "sc-40otsc-0"
})`svg > ellipse{stroke:transparent;}`, SYMBOLS = /[^\p{Alpha}\p{White_Space}]/gu, WHITESPACE = new RegExp("\\p{White_Space}+", "u");
function nameToInitials(fullName) {
  const namesArray = fullName.replace(SYMBOLS, "").split(WHITESPACE);
  return namesArray.length === 1 ? `${namesArray[0].charAt(0)}`.toUpperCase() : `${namesArray[0].charAt(0)}${namesArray[namesArray.length - 1].charAt(0)}`;
}
function CommentsAvatar(props2) {
  const $ = c(12);
  let restProps, userProp;
  $[0] !== props2 ? ({
    user: userProp,
    ...restProps
  } = props2, $[0] = props2, $[1] = restProps, $[2] = userProp) : (restProps = $[1], userProp = $[2]);
  const user = userProp, t0 = user?.displayName || "";
  let t1;
  $[3] !== t0 ? (t1 = nameToInitials(t0), $[3] = t0, $[4] = t1) : t1 = $[4];
  const initials = t1;
  if (!user) {
    let t22;
    return $[5] !== restProps ? (t22 = /* @__PURE__ */ jsx(StyledAvatar, { ...restProps }), $[5] = restProps, $[6] = t22) : t22 = $[6], t22;
  }
  const t2 = user?.imageUrl, t3 = user?.displayName;
  let t4;
  return $[7] !== initials || $[8] !== restProps || $[9] !== t2 || $[10] !== t3 ? (t4 = /* @__PURE__ */ jsx(StyledAvatar, { initials, src: t2, title: t3, ...restProps }), $[7] = initials, $[8] = restProps, $[9] = t2, $[10] = t3, $[11] = t4) : t4 = $[11], t4;
}
const SpacerAvatar = /* @__PURE__ */ styled.div.withConfig({
  displayName: "SpacerAvatar",
  componentId: "sc-115wr3a-0"
})((props2) => {
  const theme = getTheme_v2(props2.theme), {
    $size = 1
  } = props2;
  return css`
    min-width: ${theme.avatar.sizes[$size]?.size}px;
  `;
}), mentionObject = defineField({
  name: "mention",
  type: "object",
  fields: [{
    name: "userId",
    type: "string"
  }]
}), blockType = defineField({
  type: "block",
  name: "block",
  of: [mentionObject],
  marks: {
    annotations: []
  },
  styles: [{
    title: "Normal",
    value: "normal"
  }],
  lists: []
}), portableTextType = defineArrayMember({
  type: "array",
  name: "body",
  of: [blockType]
}), schema = Schema.compile({
  name: "comments",
  types: [portableTextType]
}), editorSchemaType = schema.get("body"), Span = /* @__PURE__ */ styled.span.withConfig({
  displayName: "Span",
  componentId: "sc-ue14if-0"
})(({
  theme
}) => {
  const {
    regular
  } = theme.sanity.fonts?.text.weights || {}, {
    hovered
  } = theme.sanity.color?.card || {}, {
    bg
  } = theme.sanity.color.selectable?.caution.pressed || {};
  return css`
    font-weight: ${regular};
    color: var(--card-link-fg-color);
    border-radius: 2px;
    background-color: ${hovered.bg};
    padding: 1px;
    box-sizing: border-box;

    &[data-active='true'] {
      background-color: ${bg};
    }
  `;
});
function MentionInlineBlock(props2) {
  const $ = c(15), {
    selected,
    userId
  } = props2, [user, loading] = useUser(userId), currentUser = useCurrentUser();
  if (!user || loading) {
    let t02;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(TextSkeleton, { "data-testid": "comment-mentions-loading-skeleton", style: {
      width: "10ch"
    }, size: 0, muted: !0, radius: 1, animated: !0 }), $[0] = t02) : t02 = $[0], t02;
  }
  let t0;
  $[1] !== user ? (t0 = /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(CommentsAvatar, { user }) }), $[1] = user, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] !== user.displayName ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: user.displayName }), $[3] = user.displayName, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== t0 || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t0,
    t1
  ] }), $[5] = t0, $[6] = t1, $[7] = t2) : t2 = $[7];
  const t3 = currentUser?.id === userId;
  let t4;
  $[8] !== selected || $[9] !== t3 || $[10] !== user.displayName ? (t4 = /* @__PURE__ */ jsxs(Span, { "data-selected": selected, "data-active": t3, children: [
    "@",
    user.displayName
  ] }), $[8] = selected, $[9] = t3, $[10] = user.displayName, $[11] = t4) : t4 = $[11];
  let t5;
  return $[12] !== t2 || $[13] !== t4 ? (t5 = /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t2, children: t4 }), $[12] = t2, $[13] = t4, $[14] = t5) : t5 = $[14], t5;
}
const NormalText$1 = styled(Text$1).withConfig({
  displayName: "NormalText",
  componentId: "sc-1p13grc-0"
})`word-break:break-word;`;
function NormalBlock(props2) {
  const $ = c(2), {
    children
  } = props2;
  let t0;
  return $[0] !== children ? (t0 = /* @__PURE__ */ jsx(NormalText$1, { size: 1, children }), $[0] = children, $[1] = t0) : t0 = $[1], t0;
}
const renderBlock$1 = (blockProps) => {
  const {
    children
  } = blockProps;
  return /* @__PURE__ */ jsx(NormalBlock, { children });
}, renderChild = (childProps) => {
  const {
    children,
    value,
    selected
  } = childProps;
  return value._type === "mention" && value.userId ? /* @__PURE__ */ jsx(MentionInlineBlock, { selected, userId: value?.userId }) : children;
}, Z_OFFSET = 9999999;
function CommentInputDiscardDialog(props2) {
  const $ = c(25), {
    t
  } = useTranslation(commentsLocaleNamespace), {
    onClose,
    onConfirm
  } = props2;
  let t0;
  $[0] !== onClose ? (t0 = (e) => {
    e.stopPropagation(), onClose();
  }, $[0] = onClose, $[1] = t0) : t0 = $[1];
  const handleCancelClick = t0;
  let t1;
  $[2] !== onConfirm ? (t1 = (e_0) => {
    e_0.stopPropagation(), onConfirm();
  }, $[2] = onConfirm, $[3] = t1) : t1 = $[3];
  const handleConfirmClick = t1;
  let t2;
  $[4] !== t ? (t2 = t("discard.header"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== handleCancelClick ? (t3 = {
    onClick: handleCancelClick
  }, $[6] = handleCancelClick, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t ? (t4 = t("discard.button-confirm"), $[8] = t, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== handleConfirmClick || $[11] !== t4 ? (t5 = {
    onClick: handleConfirmClick,
    text: t4,
    tone: "critical"
  }, $[10] = handleConfirmClick, $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== t3 || $[14] !== t5 ? (t6 = {
    cancelButton: t3,
    confirmButton: t5
  }, $[13] = t3, $[14] = t5, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== t ? (t7 = t("discard.text"), $[16] = t, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t7 }), $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  return $[20] !== onClose || $[21] !== t2 || $[22] !== t6 || $[23] !== t8 ? (t9 = /* @__PURE__ */ jsx(ThemeColorProvider, { tone: "default", children: /* @__PURE__ */ jsx(DialogProvider, { zOffset: Z_OFFSET, children: /* @__PURE__ */ jsx(Dialog$1, { header: t2, id: "discard-comment-dialog", onClose, width: 0, onClickOutside: onClose, footer: t6, children: t8 }) }) }), $[20] = onClose, $[21] = t2, $[22] = t6, $[23] = t8, $[24] = t9) : t9 = $[24], t9;
}
const InnerFlex = styled(Flex).withConfig({
  displayName: "InnerFlex",
  componentId: "sc-13vb0ms-0"
})``, SKELETON_INLINE_STYLE$1 = {
  width: "50%"
};
function MentionsMenuItem(props2) {
  const $ = c(23), {
    user,
    onSelect
  } = props2, [loadedUser] = useUser(user.id), {
    t
  } = useTranslation(commentsLocaleNamespace), t0 = user.granted ? void 0 : "inactive";
  let t1;
  $[0] !== loadedUser || $[1] !== t0 ? (t1 = /* @__PURE__ */ jsx(CommentsAvatar, { user: loadedUser, status: t0 }), $[0] = loadedUser, $[1] = t0, $[2] = t1) : t1 = $[2];
  const avatar = t1;
  let t2;
  $[3] !== loadedUser ? (t2 = loadedUser ? /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", title: loadedUser.displayName, children: loadedUser.displayName }) : /* @__PURE__ */ jsx(TextSkeleton, { size: 1, style: SKELETON_INLINE_STYLE$1 }), $[3] = loadedUser, $[4] = t2) : t2 = $[4];
  const text = t2;
  let t3;
  $[5] !== onSelect || $[6] !== user.id ? (t3 = () => {
    onSelect(user.id);
  }, $[5] = onSelect, $[6] = user.id, $[7] = t3) : t3 = $[7];
  const handleSelect = t3, t4 = !user.granted;
  let t5;
  $[8] !== text ? (t5 = /* @__PURE__ */ jsx(Box, { children: text }), $[8] = text, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== avatar || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsxs(InnerFlex, { align: "center", gap: 2, flex: 1, children: [
    avatar,
    t5
  ] }), $[10] = avatar, $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== t || $[14] !== user.granted ? (t7 = !user.granted && /* @__PURE__ */ jsx(Badge, { fontSize: 1, mode: "outline", children: t("mentions.unauthorized-user") }), $[13] = t, $[14] = user.granted, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t6 || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t6,
    t7
  ] }), $[16] = t6, $[17] = t7, $[18] = t8) : t8 = $[18];
  let t9;
  return $[19] !== handleSelect || $[20] !== t4 || $[21] !== t8 ? (t9 = /* @__PURE__ */ jsx(Card, { as: "button", disabled: t4, onClick: handleSelect, padding: 2, radius: 2, children: t8 }), $[19] = handleSelect, $[20] = t4, $[21] = t8, $[22] = t9) : t9 = $[22], t9;
}
const EMPTY_ARRAY$f = [], Root$d = /* @__PURE__ */ styled(Stack).withConfig({
  displayName: "Root",
  componentId: "sc-2kezws-0"
})({
  maxWidth: "220px"
  // todo: improve
}), ITEM_HEIGHT = 41, LIST_PADDING = 4, MAX_ITEMS = 7, FlexWrap = /* @__PURE__ */ styled(Flex).withConfig({
  displayName: "FlexWrap",
  componentId: "sc-2kezws-1"
})({
  maxHeight: ITEM_HEIGHT * MAX_ITEMS + LIST_PADDING * 2 + ITEM_HEIGHT / 2
}), MentionsMenu$1 = forwardRef(function(props2, ref) {
  const $ = c(24), {
    t
  } = useTranslation(commentsLocaleNamespace), {
    loading,
    onSelect,
    options: t0,
    inputElement
  } = props2;
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1, [searchTerm, setSearchTerm] = useState(""), commandListRef = useRef(null);
  let t2, t3;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => ({
    setSearchTerm(term) {
      setSearchTerm(term);
    }
  }), t3 = [], $[2] = t2, $[3] = t3) : (t2 = $[2], t3 = $[3]), useImperativeHandle(ref, t2, t3);
  let t4;
  $[4] !== onSelect ? (t4 = (itemProps) => /* @__PURE__ */ jsx(MentionsMenuItem, { user: itemProps, onSelect }), $[4] = onSelect, $[5] = t4) : t4 = $[5];
  const renderItem2 = t4;
  let t5;
  $[6] !== options ? (t5 = (index) => !options?.[index]?.granted, $[6] = options, $[7] = t5) : t5 = $[7];
  const getItemDisabled = t5;
  let t6;
  bb0: {
    if (!searchTerm) {
      t6 = options || EMPTY_ARRAY$f;
      break bb0;
    }
    let t72;
    if ($[8] !== options || $[9] !== searchTerm) {
      const deburredSearchTerm = deburr(searchTerm).toLocaleLowerCase();
      t72 = options?.map(_temp$18)?.filter((option_0) => option_0?.displayName?.includes(deburredSearchTerm))?.sort((a, b) => {
        const matchA = a.displayName?.startsWith(deburredSearchTerm), matchB = b.displayName?.startsWith(deburredSearchTerm);
        return matchA && !matchB ? -1 : !matchA && matchB ? 1 : 0;
      }), $[8] = options, $[9] = searchTerm, $[10] = t72;
    } else
      t72 = $[10];
    t6 = t72 || EMPTY_ARRAY$f;
  }
  const filteredOptions = t6;
  if (loading) {
    let t72;
    return $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t72 = /* @__PURE__ */ jsx(Root$d, { children: /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) }), $[11] = t72) : t72 = $[11], t72;
  }
  const _inputElement = inputElement || void 0;
  let t7;
  $[12] !== filteredOptions.length || $[13] !== t ? (t7 = filteredOptions.length === 0 && /* @__PURE__ */ jsx(Box, { padding: 5, children: /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, muted: !0, children: t("mentions.no-users-found") }) }), $[12] = filteredOptions.length, $[13] = t, $[14] = t7) : t7 = $[14];
  let t8;
  $[15] !== _inputElement || $[16] !== filteredOptions || $[17] !== getItemDisabled || $[18] !== renderItem2 || $[19] !== t ? (t8 = filteredOptions.length > 0 && /* @__PURE__ */ jsx(FlexWrap, { direction: "column", flex: 1, overflow: "hidden", children: /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("mentions.user-list-aria-label"), fixedHeight: !0, getItemDisabled, inputElement: _inputElement, itemHeight: 41, items: filteredOptions, padding: 1, ref: commandListRef, renderItem: renderItem2 }) }), $[15] = _inputElement, $[16] = filteredOptions, $[17] = getItemDisabled, $[18] = renderItem2, $[19] = t, $[20] = t8) : t8 = $[20];
  let t9;
  return $[21] !== t7 || $[22] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { direction: "column", height: "fill", "data-testid": "comments-mentions-menu", children: [
    t7,
    t8
  ] }), $[21] = t7, $[22] = t8, $[23] = t9) : t9 = $[23], t9;
});
function _temp$18(option) {
  return {
    ...option,
    displayName: deburr(option.displayName || "").toLocaleLowerCase()
  };
}
function useCommentInput() {
  const ctx = useContext(CommentInputContext);
  if (!ctx)
    throw new Error("useCommentInputContext must be used within a CommentInputProvider");
  return ctx;
}
const EVENT_LISTENER_OPTIONS = {
  passive: !0
};
function useCursorElement(opts) {
  const $ = c(8), {
    disabled,
    rootElement
  } = opts, [cursorRect, setCursorRect] = useState(null);
  let t0;
  bb0: {
    if (!cursorRect) {
      t0 = null;
      break bb0;
    }
    let t12;
    $[0] !== cursorRect ? (t12 = {
      getBoundingClientRect: () => cursorRect
    }, $[0] = cursorRect, $[1] = t12) : t12 = $[1], t0 = t12;
  }
  const cursorElement = t0;
  let t1;
  $[2] !== disabled || $[3] !== rootElement ? (t1 = () => {
    if (disabled) {
      setCursorRect(null);
      return;
    }
    const sel = window.getSelection();
    if (!sel || !sel.isCollapsed || sel.rangeCount === 0)
      return;
    const range2 = sel.getRangeAt(0);
    if (!rootElement?.contains(range2.commonAncestorContainer)) {
      setCursorRect(null);
      return;
    }
    const rect = range2?.getBoundingClientRect();
    rect && setCursorRect(rect);
  }, $[2] = disabled, $[3] = rootElement, $[4] = t1) : t1 = $[4];
  const handleSelectionChange = t1;
  let t2, t3;
  return $[5] !== handleSelectionChange ? (t2 = () => (document.addEventListener("selectionchange", handleSelectionChange, EVENT_LISTENER_OPTIONS), () => {
    document.removeEventListener("selectionchange", handleSelectionChange);
  }), t3 = [handleSelectionChange], $[5] = handleSelectionChange, $[6] = t2, $[7] = t3) : (t2 = $[6], t3 = $[7]), useEffect(t2, t3), cursorElement;
}
const POPOVER_FALLBACK_PLACEMENTS$3 = ["bottom", "top"], INLINE_STYLE = {
  outline: "none"
}, EMPTY_ARRAY$e = [], PlaceholderWrapper = /* @__PURE__ */ styled.span.withConfig({
  displayName: "PlaceholderWrapper",
  componentId: "sc-tck1wn-0"
})((props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return css`
    color: ${color.input.default.enabled.placeholder};
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    display: block;
  `;
}), StyledPopover$3 = /* @__PURE__ */ styled(Popover).withConfig({
  displayName: "StyledPopover",
  componentId: "sc-tck1wn-1"
})(({
  theme
}) => {
  const {
    space,
    radius
  } = theme.sanity;
  return css`
    &[data-placement='bottom'] {
      transform: translateY(${space[1]}px);
    }

    &[data-placement='top'] {
      transform: translateY(-${space[1]}px);
    }

    [data-ui='Popover__wrapper'] {
      border-radius: ${radius[3]}px;
      display: flex;
      flex-direction: column;
      overflow: clip;
      overflow: hidden;
      position: relative;
      width: 300px; // todo: improve
    }
  `;
});
function Editable(props2) {
  const $ = c(50), {
    t
  } = useTranslation(commentsLocaleNamespace), {
    focusLock,
    onFocus,
    onBlur,
    onKeyDown,
    onSubmit,
    placeholder: t0,
    renderBlock: renderBlock2
  } = props2;
  let t1;
  $[0] !== t || $[1] !== t0 ? (t1 = t0 === void 0 ? t("compose.create-comment-placeholder") : t0, $[0] = t, $[1] = t0, $[2] = t1) : t1 = $[2];
  const placeholder = t1, popoverRef = useRef(null), [rootElement, setRootElement] = useState(null), [inputElement, setInputElement] = useState(null), mentionsMenuRef = useRef(null), selection = usePortableTextEditorSelection(), {
    canSubmit,
    closeMentions,
    insertMention,
    mentionOptions,
    mentionsMenuOpen,
    mentionsSearchTerm,
    onBeforeInput,
    value
  } = useCommentInput(), t2 = !mentionsMenuOpen;
  let t3;
  $[3] !== rootElement || $[4] !== t2 ? (t3 = {
    disabled: t2,
    rootElement
  }, $[3] = rootElement, $[4] = t2, $[5] = t3) : t3 = $[5];
  const cursorElement = useCursorElement(t3);
  let t4;
  $[6] !== placeholder ? (t4 = () => /* @__PURE__ */ jsx(PlaceholderWrapper, { children: placeholder }), $[6] = placeholder, $[7] = t4) : t4 = $[7];
  const renderPlaceholder = t4;
  let t5;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => [popoverRef.current], $[8] = t5) : t5 = $[8], useClickOutsideEvent(mentionsMenuOpen && closeMentions, t5);
  let t6;
  $[9] !== canSubmit || $[10] !== closeMentions || $[11] !== mentionsMenuOpen || $[12] !== onKeyDown || $[13] !== onSubmit ? (t6 = (event) => {
    bb14: switch (event.key) {
      case "Enter": {
        if (event.shiftKey)
          break bb14;
        if (mentionsMenuOpen) {
          event.preventDefault(), event.stopPropagation(), closeMentions();
          break bb14;
        }
        onSubmit && canSubmit && (event.preventDefault(), event.stopPropagation(), onSubmit());
        break bb14;
      }
      case "Escape":
      case "ArrowLeft":
      case "ArrowRight": {
        mentionsMenuOpen && (event.preventDefault(), event.stopPropagation(), closeMentions());
        break bb14;
      }
    }
    onKeyDown && onKeyDown(event);
  }, $[9] = canSubmit, $[10] = closeMentions, $[11] = mentionsMenuOpen, $[12] = onKeyDown, $[13] = onSubmit, $[14] = t6) : t6 = $[14];
  const handleKeyDown = t6;
  let t7;
  if ($[15] !== selection || $[16] !== value) {
    bb0: {
      if (selection) {
        t7 = void 0;
        break bb0;
      }
      const lastBlock = (value || EMPTY_ARRAY$e).slice(-1)[0], lastChild = isPortableTextTextBlock(lastBlock) ? lastBlock.children.slice(-1)[0] : void 0;
      if (!lastChild) {
        t7 = void 0;
        break bb0;
      }
      const point = {
        path: [{
          _key: lastBlock._key
        }, "children", {
          _key: lastChild._key
        }],
        offset: isPortableTextSpan(lastChild) ? lastChild.text.length : 0
      };
      let t82;
      $[18] !== point ? (t82 = {
        focus: point,
        anchor: point
      }, $[18] = point, $[19] = t82) : t82 = $[19], t7 = t82;
    }
    $[15] = selection, $[16] = value, $[17] = t7;
  } else
    t7 = $[17];
  const initialSelectionAtEndOfContent = t7;
  let t8, t9;
  $[20] !== mentionsSearchTerm ? (t8 = () => {
    mentionsMenuRef.current?.setSearchTerm(mentionsSearchTerm);
  }, t9 = [mentionsSearchTerm], $[20] = mentionsSearchTerm, $[21] = t8, $[22] = t9) : (t8 = $[21], t9 = $[22]), useEffect(t8, t9);
  let t10, t11;
  $[23] !== closeMentions || $[24] !== mentionsMenuOpen || $[25] !== selection ? (t10 = () => {
    mentionsMenuOpen && selection && !isEqual$1(selection.anchor, selection.focus) && closeMentions();
  }, t11 = [mentionsMenuOpen, closeMentions, selection], $[23] = closeMentions, $[24] = mentionsMenuOpen, $[25] = selection, $[26] = t10, $[27] = t11) : (t10 = $[26], t11 = $[27]), useEffect(t10, t11);
  const t12 = mentionOptions.data || EMPTY_ARRAY$e;
  let t13;
  $[28] !== inputElement || $[29] !== insertMention || $[30] !== mentionOptions.loading || $[31] !== t12 ? (t13 = /* @__PURE__ */ jsx(MentionsMenu$1, { inputElement, loading: mentionOptions.loading, onSelect: insertMention, options: t12, ref: mentionsMenuRef }), $[28] = inputElement, $[29] = insertMention, $[30] = mentionOptions.loading, $[31] = t12, $[32] = t13) : t13 = $[32];
  const popoverContent = t13, t14 = !mentionsMenuOpen;
  let t15;
  $[33] !== cursorElement || $[34] !== mentionsMenuOpen || $[35] !== popoverContent || $[36] !== t14 ? (t15 = /* @__PURE__ */ jsx(StyledPopover$3, { arrow: !1, constrainSize: !0, content: popoverContent, disabled: t14, fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$3, open: mentionsMenuOpen, placement: "bottom", ref: popoverRef, referenceElement: cursorElement }), $[33] = cursorElement, $[34] = mentionsMenuOpen, $[35] = popoverContent, $[36] = t14, $[37] = t15) : t15 = $[37];
  const t16 = focusLock ? 0 : void 0;
  let t17;
  $[38] !== handleKeyDown || $[39] !== initialSelectionAtEndOfContent || $[40] !== onBeforeInput || $[41] !== onBlur || $[42] !== onFocus || $[43] !== renderBlock2 || $[44] !== renderPlaceholder || $[45] !== t16 ? (t17 = /* @__PURE__ */ jsx(PortableTextEditable, { "data-testid": "comment-input-editable", "data-ui": "EditableElement", onBeforeInput, onBlur, onFocus, onKeyDown: handleKeyDown, ref: setInputElement, renderBlock: renderBlock2, renderChild, renderPlaceholder, selection: initialSelectionAtEndOfContent, style: INLINE_STYLE, tabIndex: t16 }), $[38] = handleKeyDown, $[39] = initialSelectionAtEndOfContent, $[40] = onBeforeInput, $[41] = onBlur, $[42] = onFocus, $[43] = renderBlock2, $[44] = renderPlaceholder, $[45] = t16, $[46] = t17) : t17 = $[46];
  let t18;
  return $[47] !== t15 || $[48] !== t17 ? (t18 = /* @__PURE__ */ jsxs("div", { ref: setRootElement, children: [
    t15,
    t17
  ] }), $[47] = t15, $[48] = t17, $[49] = t18) : t18 = $[49], t18;
}
Editable.displayName = "Editable";
const EditableWrap = styled(Box).withConfig({
  displayName: "EditableWrap",
  componentId: "sc-w7gjfe-0"
})`max-height:20vh;overflow-y:auto;`, ButtonDivider = /* @__PURE__ */ styled(MenuDivider).withConfig({
  displayName: "ButtonDivider",
  componentId: "sc-w7gjfe-1"
})({
  height: 20,
  width: 1
});
function focusRingBorderStyle(border) {
  return `inset 0 0 0 ${border.width}px ${border.color}`;
}
const RootCard$2 = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "RootCard",
  componentId: "sc-w7gjfe-2"
})(({
  theme
}) => {
  const {
    color,
    input,
    radius
  } = getTheme_v2(theme), radii = radius[2];
  return css`
    border-radius: ${radii}px;
    box-shadow: var(--input-box-shadow);

    --input-box-shadow: ${focusRingBorderStyle({
    color: color.input.default.enabled.border,
    width: input.border.width
  })};

    &:not([data-expand-on-focus='false'], :focus-within) {
      background: transparent;
      box-shadow: unset;
    }

    &[data-focused='true']:focus-within {
      ${EditableWrap} {
        min-height: 1em;
      }

      /* box-shadow: inset 0 0 0 1px var(--card-focus-ring-color); */
      --input-box-shadow: ${focusRingBorderStyle({
    color: "var(--card-focus-ring-color)",
    width: input.border.width
  })};
    }

    &:focus-within {
      ${EditableWrap} {
        min-height: 1em;
      }
    }

    &[data-expand-on-focus='false'] {
      ${EditableWrap} {
        min-height: 1em;
      }
    }

    &[data-expand-on-focus='true'] {
      [data-ui='CommentInputActions']:not([hidden]) {
        display: none;
      }

      &:focus-within {
        [data-ui='CommentInputActions'] {
          display: flex;
        }
      }
    }
    &:hover {
      --input-box-shadow: ${focusRingBorderStyle({
    color: color.input.default.hovered.border,
    width: input.border.width
  })};
    }
  `;
}), AvatarContainer = /* @__PURE__ */ styled.div.withConfig({
  displayName: "AvatarContainer",
  componentId: "sc-w7gjfe-3"
})((props2) => `
    min-height: ${getTheme_v2(props2.theme).avatar.sizes[1]?.size}px;
    display: flex;
    align-items: center;
  `);
function CommentInputInner(props2) {
  const $ = c(41), {
    avatarSize: t0,
    currentUser,
    focusLock,
    onBlur,
    onFocus,
    onKeyDown,
    onSubmit,
    placeholder,
    renderBlock: renderBlock2,
    withAvatar
  } = props2, avatarSize = t0 === void 0 ? 1 : t0, [user] = useUser(currentUser.id), {
    canSubmit,
    expandOnFocus,
    focused,
    hasChanges,
    insertAtChar,
    openMentions,
    readOnly,
    mentionOptions
  } = useCommentInput(), {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t1;
  $[0] !== avatarSize || $[1] !== user || $[2] !== withAvatar ? (t1 = withAvatar ? /* @__PURE__ */ jsx(AvatarContainer, { children: /* @__PURE__ */ jsx(CommentsAvatar, { user, size: avatarSize }) }) : null, $[0] = avatarSize, $[1] = user, $[2] = withAvatar, $[3] = t1) : t1 = $[3];
  const avatar = t1;
  let t2;
  $[4] !== insertAtChar || $[5] !== openMentions ? (t2 = (e) => {
    e.stopPropagation(), insertAtChar(), openMentions();
  }, $[4] = insertAtChar, $[5] = openMentions, $[6] = t2) : t2 = $[6];
  const handleMentionButtonClicked = t2, t3 = expandOnFocus && !canSubmit ? "true" : "false", t4 = focused ? "true" : "false", t5 = readOnly ? "transparent" : "default";
  let t6;
  $[7] !== focusLock || $[8] !== onBlur || $[9] !== onFocus || $[10] !== onKeyDown || $[11] !== onSubmit || $[12] !== placeholder || $[13] !== renderBlock2 ? (t6 = /* @__PURE__ */ jsx(EditableWrap, { "data-ui": "CommentInputEditableWrap", paddingX: 1, paddingY: 2, sizing: "border", children: /* @__PURE__ */ jsx(Editable, { focusLock, onBlur, onFocus, onKeyDown, onSubmit, placeholder, renderBlock: renderBlock2 }) }), $[7] = focusLock, $[8] = onBlur, $[9] = onFocus, $[10] = onKeyDown, $[11] = onSubmit, $[12] = placeholder, $[13] = renderBlock2, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== handleMentionButtonClicked || $[16] !== mentionOptions.disabled || $[17] !== readOnly || $[18] !== t ? (t7 = !mentionOptions.disabled && /* @__PURE__ */ jsx(Button, { "aria-label": t("compose.mention-user-aria-label"), "data-testid": "comment-input-mention-button", disabled: readOnly, icon: MentionIcon, mode: "bleed", type: "button", onClick: handleMentionButtonClicked, tooltipProps: {
    content: t("compose.mention-user-tooltip")
  } }), $[15] = handleMentionButtonClicked, $[16] = mentionOptions.disabled, $[17] = readOnly, $[18] = t, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== canSubmit || $[21] !== hasChanges || $[22] !== mentionOptions.disabled || $[23] !== onSubmit || $[24] !== readOnly || $[25] !== t ? (t8 = onSubmit && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    !mentionOptions.disabled && /* @__PURE__ */ jsx(ButtonDivider, {}),
    /* @__PURE__ */ jsx(Button, { "aria-label": t("compose.send-comment-aria-label"), "data-testid": "comment-input-send-button", disabled: !canSubmit || !hasChanges || readOnly, icon: SendIcon, mode: hasChanges && canSubmit ? "default" : "bleed", onClick: onSubmit, tone: hasChanges && canSubmit ? "primary" : "default", tooltipProps: {
      content: t("compose.send-comment-tooltip")
    } })
  ] }), $[20] = canSubmit, $[21] = hasChanges, $[22] = mentionOptions.disabled, $[23] = onSubmit, $[24] = readOnly, $[25] = t, $[26] = t8) : t8 = $[26];
  let t9;
  $[27] !== t7 || $[28] !== t8 ? (t9 = /* @__PURE__ */ jsx(Flex, { align: "center", "data-ui": "CommentInputActions", gap: 1, justify: "flex-end", padding: 1, children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
    t7,
    t8
  ] }) }), $[27] = t7, $[28] = t8, $[29] = t9) : t9 = $[29];
  let t10;
  $[30] !== t6 || $[31] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { children: [
    t6,
    t9
  ] }), $[30] = t6, $[31] = t9, $[32] = t10) : t10 = $[32];
  let t11;
  $[33] !== t10 || $[34] !== t3 || $[35] !== t4 || $[36] !== t5 ? (t11 = /* @__PURE__ */ jsx(RootCard$2, { id: "comment-input-root", "data-expand-on-focus": t3, "data-focused": t4, flex: 1, sizing: "border", tone: t5, children: t10 }), $[33] = t10, $[34] = t3, $[35] = t4, $[36] = t5, $[37] = t11) : t11 = $[37];
  let t12;
  return $[38] !== avatar || $[39] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 2, children: [
    avatar,
    t11
  ] }), $[38] = avatar, $[39] = t11, $[40] = t12) : t12 = $[40], t12;
}
function CommentInputProvider(props2) {
  const $ = c(42), {
    children,
    expandOnFocus: t0,
    focused,
    focusOnMount: t1,
    mentionOptions,
    onMentionMenuOpenChange,
    value,
    readOnly
  } = props2, expandOnFocus = t0 === void 0 ? !1 : t0, focusOnMount = t1 === void 0 ? !1 : t1, editor2 = usePortableTextEditor(), [mentionsMenuOpen, setMentionsMenuOpen] = useState(!1), [mentionsSearchTerm, setMentionsSearchTerm] = useState(""), [selectionAtMentionInsert, setSelectionAtMentionInsert] = useState(null);
  let t2;
  $[0] !== value ? (t2 = hasCommentMessageValue(value), $[0] = value, $[1] = t2) : t2 = $[1];
  const canSubmit = t2, hasChanges = useCommentHasChanged(value);
  let t3;
  $[2] !== editor2 || $[3] !== readOnly ? (t3 = () => {
    readOnly || PortableTextEditor.focus(editor2);
  }, $[2] = editor2, $[3] = readOnly, $[4] = t3) : t3 = $[4];
  const focusEditor = t3;
  let t4;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setMentionsMenuOpen(!1), setMentionsSearchTerm(""), setSelectionAtMentionInsert(null);
  }, $[5] = t4) : t4 = $[5];
  const closeMentions = t4;
  let t5;
  $[6] !== editor2 || $[7] !== mentionOptions?.disabled ? (t5 = () => {
    mentionOptions?.disabled || (setMentionsMenuOpen(!0), setMentionsSearchTerm(""), setMentionsMenuOpen(!0), setSelectionAtMentionInsert(PortableTextEditor.getSelection(editor2)));
  }, $[6] = editor2, $[7] = mentionOptions?.disabled, $[8] = t5) : t5 = $[8];
  const openMentions = t5;
  let t6;
  $[9] !== editor2 || $[10] !== mentionOptions?.disabled || $[11] !== mentionsSearchTerm || $[12] !== openMentions ? (t6 = (event) => {
    if (mentionOptions?.disabled)
      return;
    const selection = PortableTextEditor.getSelection(editor2), cursorOffset = selection ? selection.focus.offset : 0, focusChild = PortableTextEditor.focusChild(editor2), focusSpan = isPortableTextSpan(focusChild) && focusChild || void 0, isInsertText = event.inputType === "insertText", isDeleteText = event.inputType === "deleteContentBackward", isInsertingAtChar = isInsertText && event.data === "@", lastIndexOfAt = focusSpan?.text.slice(0, Math.max(0, cursorOffset)).lastIndexOf("@") || 0, isWhitespaceCharBeforeCursorPosition = focusSpan?.text.slice(cursorOffset - 1, cursorOffset) === " ", filterStartsWithSpaceChar = isInsertText && event.data === " " && !mentionsSearchTerm;
    if (isInsertingAtChar && (cursorOffset < 1 || isWhitespaceCharBeforeCursorPosition)) {
      openMentions();
      return;
    }
    if (filterStartsWithSpaceChar || isDeleteText && (focusSpan?.text.length === 1 || lastIndexOfAt === (focusSpan?.text.length || 0) - 1)) {
      closeMentions();
      return;
    }
    if (isPortableTextSpan(focusChild)) {
      let term = focusChild.text.slice(lastIndexOfAt + 1, cursorOffset);
      isInsertText && (term = term + event.data), isDeleteText && (term = term.slice(0, Math.max(0, term.length - 1))), setMentionsSearchTerm(term);
    }
  }, $[9] = editor2, $[10] = mentionOptions?.disabled, $[11] = mentionsSearchTerm, $[12] = openMentions, $[13] = t6) : t6 = $[13];
  const onBeforeInput = t6;
  let t7;
  $[14] !== editor2 ? (t7 = () => {
    setMentionsMenuOpen(!0), PortableTextEditor.focus(editor2), PortableTextEditor.insertChild(editor2, editor2.schemaTypes.span, {
      text: "@"
    }), setSelectionAtMentionInsert(PortableTextEditor.getSelection(editor2));
  }, $[14] = editor2, $[15] = t7) : t7 = $[15];
  const insertAtChar = t7;
  let t8;
  $[16] !== mentionsMenuOpen || $[17] !== onMentionMenuOpenChange ? (t8 = () => onMentionMenuOpenChange?.(mentionsMenuOpen), $[16] = mentionsMenuOpen, $[17] = onMentionMenuOpenChange, $[18] = t8) : t8 = $[18], useDidUpdate(mentionsMenuOpen, t8);
  let t9;
  $[19] !== editor2 || $[20] !== selectionAtMentionInsert ? (t9 = (userId) => {
    const mentionSchemaType = editor2.schemaTypes.inlineObjects.find(_temp$17), [span, spanPath] = selectionAtMentionInsert && PortableTextEditor.findByPath(editor2, selectionAtMentionInsert.focus.path) || [];
    if (span && isPortableTextSpan(span) && spanPath && mentionSchemaType) {
      PortableTextEditor.focus(editor2);
      const offset = PortableTextEditor.getSelection(editor2)?.focus.offset;
      typeof offset < "u" && (PortableTextEditor.delete(editor2, {
        anchor: {
          path: spanPath,
          offset: span.text.lastIndexOf("@")
        },
        focus: {
          path: spanPath,
          offset
        }
      }, {
        mode: "selected"
      }), PortableTextEditor.insertChild(editor2, mentionSchemaType, {
        userId
      }), PortableTextEditor.insertChild(editor2, editor2.schemaTypes.span, {
        text: " "
      }));
    }
  }, $[19] = editor2, $[20] = selectionAtMentionInsert, $[21] = t9) : t9 = $[21];
  const insertMention = t9, t10 = !!readOnly;
  let t11;
  $[22] !== canSubmit || $[23] !== editor2 || $[24] !== expandOnFocus || $[25] !== focusEditor || $[26] !== focusOnMount || $[27] !== focused || $[28] !== hasChanges || $[29] !== insertAtChar || $[30] !== insertMention || $[31] !== mentionOptions || $[32] !== mentionsMenuOpen || $[33] !== mentionsSearchTerm || $[34] !== onBeforeInput || $[35] !== openMentions || $[36] !== t10 || $[37] !== value ? (t11 = {
    canSubmit,
    closeMentions,
    editor: editor2,
    expandOnFocus,
    focused,
    focusEditor,
    focusOnMount,
    hasChanges,
    insertAtChar,
    insertMention,
    mentionOptions,
    mentionsMenuOpen,
    mentionsSearchTerm,
    onBeforeInput,
    openMentions,
    readOnly: t10,
    value
  }, $[22] = canSubmit, $[23] = editor2, $[24] = expandOnFocus, $[25] = focusEditor, $[26] = focusOnMount, $[27] = focused, $[28] = hasChanges, $[29] = insertAtChar, $[30] = insertMention, $[31] = mentionOptions, $[32] = mentionsMenuOpen, $[33] = mentionsSearchTerm, $[34] = onBeforeInput, $[35] = openMentions, $[36] = t10, $[37] = value, $[38] = t11) : t11 = $[38];
  const ctxValue = t11;
  let t12;
  return $[39] !== children || $[40] !== ctxValue ? (t12 = /* @__PURE__ */ jsx(CommentInputContext.Provider, { value: ctxValue, children }), $[39] = children, $[40] = ctxValue, $[41] = t12) : t12 = $[41], t12;
}
function _temp$17(t) {
  return t.name === "mention";
}
const EditorRefPlugin = forwardRef(function(_, ref) {
  const $ = c(2), portableTextEditor = usePortableTextEditor(), portableTextEditorRef = useRef(portableTextEditor);
  let t0, t1;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => portableTextEditorRef.current, t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useImperativeHandle(ref, t0, t1), null;
});
EditorRefPlugin.displayName = "EditorRefPlugin";
const EMPTY_ARRAY$d = [], SCROLL_INTO_VIEW_OPTIONS = {
  behavior: "smooth",
  block: "center",
  inline: "center"
}, CommentInput = forwardRef(function(props2, ref) {
  const $ = c(71), {
    avatarSize,
    currentUser,
    expandOnFocus,
    focusLock: t0,
    focusOnMount,
    mentionOptions,
    onBlur,
    onChange,
    onDiscardCancel,
    onDiscardConfirm,
    onFocus,
    onKeyDown,
    onMentionMenuOpenChange,
    onSubmit,
    placeholder,
    readOnly,
    renderBlock: t1,
    value: t2,
    withAvatar: t3
  } = props2, focusLock = t0 === void 0 ? !1 : t0, renderBlock2 = t1 === void 0 ? renderBlock$1 : t1, value = t2 === void 0 ? EMPTY_ARRAY$d : t2, withAvatar = t3 === void 0 ? !0 : t3, [focused, setFocused] = useState(!1), editorRef = useRef(null), editorContainerRef = useRef(null), [showDiscardDialog, setShowDiscardDialog] = useState(!1), preDivRef = useRef(null), postDivRef = useRef(null), innerRef = useRef(null);
  let t4;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = keyGenerator$1(), $[0] = t4) : t4 = $[0];
  const [editorInstanceKey, setEditorInstanceKey] = useState(t4);
  let t5;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    requestAnimationFrame(() => {
      editorRef.current && PortableTextEditor.focus(editorRef.current);
    });
  }, $[1] = t5) : t5 = $[1];
  const requestFocus = t5;
  let t6;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    setEditorInstanceKey(keyGenerator$1());
  }, $[2] = t6) : t6 = $[2];
  const resetEditorInstance = t6;
  let t7;
  $[3] !== focusOnMount || $[4] !== onChange ? (t7 = (event) => {
    event.type === "ready" && focusOnMount && requestFocus(), event.type === "focused" && setFocused(!0), event.type === "blurred" && setFocused(!1), event.type === "mutation" && onChange(event.value || EMPTY_ARRAY$d);
  }, $[3] = focusOnMount, $[4] = onChange, $[5] = t7) : t7 = $[5];
  const handleEvent = t7;
  let t8;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = () => {
    editorContainerRef.current?.scrollIntoView(SCROLL_INTO_VIEW_OPTIONS);
  }, $[6] = t8) : t8 = $[6];
  const scrollToEditor = t8;
  let t9;
  $[7] !== onSubmit ? (t9 = () => {
    onSubmit?.(), resetEditorInstance(), requestFocus(), scrollToEditor();
  }, $[7] = onSubmit, $[8] = t9) : t9 = $[8];
  const handleSubmit = t9;
  let t10;
  $[9] !== onDiscardConfirm ? (t10 = () => {
    onDiscardConfirm(), resetEditorInstance();
  }, $[9] = onDiscardConfirm, $[10] = t10) : t10 = $[10];
  const handleDiscardConfirm = t10;
  let t11;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = {
    open: () => {
      setShowDiscardDialog(!0);
    },
    close: () => {
      setShowDiscardDialog(!1), requestFocus();
    }
  }, $[11] = t11) : t11 = $[11];
  const discardDialogController = t11;
  let t12, t13;
  $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = () => ({
    focus: requestFocus,
    blur() {
      editorRef.current && PortableTextEditor.blur(editorRef.current);
    },
    scrollTo: scrollToEditor,
    reset: resetEditorInstance,
    discardDialogController
  }), t13 = [discardDialogController, requestFocus, resetEditorInstance, scrollToEditor], $[12] = t12, $[13] = t13) : (t12 = $[12], t13 = $[13]), useImperativeHandle(ref, t12, t13);
  let t14;
  $[14] !== focusLock ? (t14 = (event_0) => {
    if (!focusLock)
      return;
    const target = event_0.target, innerEl = innerRef.current;
    if (innerEl && target === preDivRef.current) {
      focusLastDescendant(innerEl);
      return;
    }
    innerEl && target === postDivRef.current && focusFirstDescendant(innerEl);
  }, $[14] = focusLock, $[15] = t14) : t14 = $[15];
  const handleFocus = t14;
  let t15;
  $[16] !== handleDiscardConfirm || $[17] !== onDiscardCancel || $[18] !== showDiscardDialog ? (t15 = showDiscardDialog && onDiscardCancel && /* @__PURE__ */ jsx(CommentInputDiscardDialog, { onClose: onDiscardCancel, onConfirm: handleDiscardConfirm }), $[16] = handleDiscardConfirm, $[17] = onDiscardCancel, $[18] = showDiscardDialog, $[19] = t15) : t15 = $[19];
  let t16;
  $[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = sanitySchemaToPortableTextSchema(editorSchemaType), $[20] = t16) : t16 = $[20];
  const t17 = value || EMPTY_ARRAY$d;
  let t18;
  $[21] !== readOnly || $[22] !== t17 ? (t18 = {
    schemaDefinition: t16,
    initialValue: t17,
    readOnly
  }, $[21] = readOnly, $[22] = t17, $[23] = t18) : t18 = $[23];
  let t19;
  $[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t19 = /* @__PURE__ */ jsx(EditorRefPlugin, { ref: editorRef }), $[24] = t19) : t19 = $[24];
  let t20;
  $[25] !== handleEvent ? (t20 = /* @__PURE__ */ jsx(EventListenerPlugin, { on: handleEvent }), $[25] = handleEvent, $[26] = t20) : t20 = $[26];
  let t21;
  $[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t21 = /* @__PURE__ */ jsx(OneLinePlugin, {}), $[27] = t21) : t21 = $[27];
  const t22 = readOnly ?? !1;
  let t23;
  $[28] !== t22 ? (t23 = /* @__PURE__ */ jsx(UpdateReadOnlyPlugin, { readOnly: t22 }), $[28] = t22, $[29] = t23) : t23 = $[29];
  const t24 = value ?? void 0;
  let t25;
  $[30] !== t24 ? (t25 = /* @__PURE__ */ jsx(UpdateValuePlugin, { value: t24 }), $[30] = t24, $[31] = t25) : t25 = $[31];
  let t26;
  $[32] !== focusLock ? (t26 = focusLock && /* @__PURE__ */ jsx("div", { ref: preDivRef, tabIndex: 0 }), $[32] = focusLock, $[33] = t26) : t26 = $[33];
  const t27 = onSubmit && handleSubmit;
  let t28;
  $[34] !== avatarSize || $[35] !== currentUser || $[36] !== focusLock || $[37] !== onBlur || $[38] !== onFocus || $[39] !== onKeyDown || $[40] !== placeholder || $[41] !== renderBlock2 || $[42] !== t27 || $[43] !== withAvatar ? (t28 = /* @__PURE__ */ jsx(Stack, { ref: innerRef, children: /* @__PURE__ */ jsx(CommentInputInner, { avatarSize, currentUser, focusLock, onBlur, onFocus, onKeyDown, onSubmit: t27, placeholder, renderBlock: renderBlock2, withAvatar }) }), $[34] = avatarSize, $[35] = currentUser, $[36] = focusLock, $[37] = onBlur, $[38] = onFocus, $[39] = onKeyDown, $[40] = placeholder, $[41] = renderBlock2, $[42] = t27, $[43] = withAvatar, $[44] = t28) : t28 = $[44];
  let t29;
  $[45] !== focusLock ? (t29 = focusLock && /* @__PURE__ */ jsx("div", { ref: postDivRef, tabIndex: 0 }), $[45] = focusLock, $[46] = t29) : t29 = $[46];
  let t30;
  $[47] !== expandOnFocus || $[48] !== focusOnMount || $[49] !== focused || $[50] !== mentionOptions || $[51] !== onMentionMenuOpenChange || $[52] !== readOnly || $[53] !== t26 || $[54] !== t28 || $[55] !== t29 || $[56] !== value ? (t30 = /* @__PURE__ */ jsxs(CommentInputProvider, { expandOnFocus, focused, focusOnMount, mentionOptions, onMentionMenuOpenChange, readOnly, value, children: [
    t26,
    t28,
    t29
  ] }), $[47] = expandOnFocus, $[48] = focusOnMount, $[49] = focused, $[50] = mentionOptions, $[51] = onMentionMenuOpenChange, $[52] = readOnly, $[53] = t26, $[54] = t28, $[55] = t29, $[56] = value, $[57] = t30) : t30 = $[57];
  let t31;
  $[58] !== editorInstanceKey || $[59] !== t18 || $[60] !== t20 || $[61] !== t23 || $[62] !== t25 || $[63] !== t30 ? (t31 = /* @__PURE__ */ jsxs(EditorProvider, { initialConfig: t18, children: [
    t19,
    t20,
    t21,
    t23,
    t25,
    t30
  ] }, editorInstanceKey), $[58] = editorInstanceKey, $[59] = t18, $[60] = t20, $[61] = t23, $[62] = t25, $[63] = t30, $[64] = t31) : t31 = $[64];
  let t32;
  $[65] !== handleFocus || $[66] !== t31 ? (t32 = /* @__PURE__ */ jsx(Stack, { ref: editorContainerRef, "data-testid": "comment-input", onFocus: handleFocus, children: t31 }), $[65] = handleFocus, $[66] = t31, $[67] = t32) : t32 = $[67];
  let t33;
  return $[68] !== t15 || $[69] !== t32 ? (t33 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t15,
    t32
  ] }), $[68] = t15, $[69] = t32, $[70] = t33) : t33 = $[70], t33;
});
function UpdateReadOnlyPlugin(props2) {
  const $ = c(4), editor2 = useEditor();
  let t0, t1;
  return $[0] !== editor2 || $[1] !== props2.readOnly ? (t0 = () => {
    editor2.send({
      type: "update readOnly",
      readOnly: props2.readOnly
    });
  }, t1 = [editor2, props2.readOnly], $[0] = editor2, $[1] = props2.readOnly, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1), null;
}
function UpdateValuePlugin(props2) {
  const $ = c(4), editor2 = useEditor();
  let t0, t1;
  return $[0] !== editor2 || $[1] !== props2.value ? (t0 = () => {
    editor2.send({
      type: "update value",
      value: props2.value
    });
  }, t1 = [editor2, props2.value], $[0] = editor2, $[1] = props2.value, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1), null;
}
const COMMENTS_INSPECTOR_NAME = "sanity/comments", COMMENTS_HIGHLIGHT_HUE_KEY = "yellow", COMMENT_REACTION_OPTIONS = [{
  shortName: ":+1:",
  title: "Thumbs up"
}, {
  shortName: ":-1:",
  title: "Thumbs down"
}, {
  shortName: ":heart:",
  title: "Heart"
}, {
  shortName: ":rocket:",
  title: "Rocket"
}, {
  shortName: ":heavy_plus_sign:",
  title: "Heavy plus sign"
}, {
  shortName: ":eyes:",
  title: "Eyes"
}], COMMENT_REACTION_EMOJIS = {
  ":-1:": "\u{1F44E}",
  ":+1:": "\u{1F44D}",
  ":eyes:": "\u{1F440}",
  ":heart:": "\u2764\uFE0F",
  ":heavy_plus_sign:": "\u2795",
  ":rocket:": "\u{1F680}"
}, HighlightSpan = /* @__PURE__ */ styled.span.withConfig({
  displayName: "HighlightSpan",
  componentId: "sc-cgy0jg-0"
})(({
  theme
}) => {
  const isDark = theme.sanity.v2?.color._dark, addedBg = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 800 : 100].hex, addedBorder = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 700 : 300].hex, addedHoverBg = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 700 : 200].hex, addedHoverBorder = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 600 : 400].hex, addedNestedBg = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 700 : 200].hex, addedNesterBorder = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 600 : 400].hex;
  return css`
    box-sizing: border-box;
    transition:
      background-color 100ms ease,
      border-color 100ms ease;

    // Make sure that child elements appropriately blend with the
    // background of the highlight span
    * {
      mix-blend-mode: ${isDark ? "screen" : "multiply"};
    }

    &[data-inline-comment-state='added'][data-inline-comment-nested='false'] {
      background-color: ${addedBg};
      border-bottom: 2px solid ${addedBorder};
    }

    &[data-inline-comment-state='added'][data-inline-comment-nested='true'] {
      background-color: ${addedNestedBg};
      border-bottom: 2px solid ${addedNesterBorder};
    }

    &[data-inline-comment-state='added'][data-inline-comment-nested='false'][data-hovered='true'] {
      background-color: ${addedHoverBg};
      border-bottom: 2px solid ${addedHoverBorder};
    }

    &[data-inline-comment-state='authoring'] {
      background-color: ${addedBg};
      border-bottom: 2px solid ${addedBorder};
    }
  `;
}), CommentInlineHighlightSpan = forwardRef(function(props2, ref) {
  const $ = c(14);
  let children, isAdded, isAuthoring, isHovered, isNested, rest;
  $[0] !== props2 ? ({
    children,
    isAdded,
    isAuthoring,
    isHovered,
    isNested,
    ...rest
  } = props2, $[0] = props2, $[1] = children, $[2] = isAdded, $[3] = isAuthoring, $[4] = isHovered, $[5] = isNested, $[6] = rest) : (children = $[1], isAdded = $[2], isAuthoring = $[3], isHovered = $[4], isNested = $[5], rest = $[6]);
  const state = isAdded ? "added" : isAuthoring ? "authoring" : void 0, t0 = isHovered ? "true" : "false", t1 = isNested ? "true" : "false";
  let t2;
  return $[7] !== children || $[8] !== ref || $[9] !== rest || $[10] !== state || $[11] !== t0 || $[12] !== t1 ? (t2 = /* @__PURE__ */ jsx(HighlightSpan, { ...rest, "data-hovered": t0, "data-inline-comment-nested": t1, "data-inline-comment-state": state, ref, children }), $[7] = children, $[8] = ref, $[9] = rest, $[10] = state, $[11] = t0, $[12] = t1, $[13] = t2) : t2 = $[13], t2;
}), PortableTextWrap = /* @__PURE__ */ styled(Stack).withConfig({
  displayName: "PortableTextWrap",
  componentId: "sc-5m7slo-0"
})(() => css`
    & > [data-ui='Text']:not(:first-child) {
      margin-top: 1em; // todo: improve
    }

    & > [data-ui='Text']:has(> span:empty) {
      display: none;
    }
  `), EMPTY_ARRAY$c = [];
function NormalBlockTransformed(props2) {
  const $ = c(4);
  let t0;
  $[0] !== props2.children ? (t0 = transformChildren(props2.children), $[0] = props2.children, $[1] = t0) : t0 = $[1];
  const children = t0;
  let t1;
  return $[2] !== children ? (t1 = /* @__PURE__ */ jsx(NormalBlock, { children }), $[2] = children, $[3] = t1) : t1 = $[3], t1;
}
const components = {
  // Since we do not offer any formatting options, we can just use the normal block for all of these.
  block: {
    normal: NormalBlockTransformed,
    h1: NormalBlockTransformed,
    h2: NormalBlockTransformed,
    h3: NormalBlockTransformed,
    h4: NormalBlockTransformed,
    h5: NormalBlockTransformed,
    h6: NormalBlockTransformed,
    blockquote: NormalBlockTransformed,
    code: NormalBlockTransformed
  },
  list: {
    bullet: Fragment,
    number: Fragment,
    checkmarks: Fragment
  },
  listItem: {
    bullet: NormalBlockTransformed,
    number: NormalBlockTransformed,
    checkmarks: NormalBlockTransformed
  },
  // Since we do not offer any formatting options, we can just use the normal block for all of these.
  marks: {
    strong: Fragment,
    em: Fragment,
    code: Fragment,
    underline: Fragment,
    strikeThrough: Fragment,
    link: Fragment
  },
  types: {
    mention: (props2) => /* @__PURE__ */ jsx(MentionInlineBlock, { userId: props2?.value?.userId, selected: !1 })
  }
};
function CommentMessageSerializer(props2) {
  const $ = c(2), {
    blocks
  } = props2, t0 = blocks || EMPTY_ARRAY$c;
  let t1;
  return $[0] !== t0 ? (t1 = /* @__PURE__ */ jsx(PortableTextWrap, { children: /* @__PURE__ */ jsx(PortableText$1, { value: t0, components }) }), $[0] = t0, $[1] = t1) : t1 = $[1], t1;
}
const FLEX_GAP = 3, EmojiText = styled(Text$1).withConfig({
  displayName: "EmojiText",
  componentId: "sc-13labuh-0"
})`font-family:'Twemoji Mozilla','Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji','EmojiOne Color','Android Emoji',sans-serif;`, GRID_COLUMNS = 6;
function CommentReactionsMenu(props2) {
  const $ = c(20), {
    options,
    onSelect
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace), [rootElement, setRootElement] = useState(null), [focusedIndex, setFocusedIndex] = useState(0);
  let t0;
  $[0] !== rootElement ? (t0 = (event) => {
    const focusableLen = rootElement?.querySelectorAll("button").length ?? 0;
    event.key === "ArrowRight" && setFocusedIndex((prev) => (prev + 1) % focusableLen), event.key === "ArrowLeft" && setFocusedIndex((prev_0) => (prev_0 - 1 + focusableLen) % focusableLen);
  }, $[0] = rootElement, $[1] = t0) : t0 = $[1];
  const handleRootKeyDown = t0;
  let t1;
  $[2] !== onSelect || $[3] !== options || $[4] !== rootElement ? (t1 = (event_0) => {
    const index = rootElement ? Array.from(rootElement.querySelectorAll("button")).indexOf(event_0.currentTarget) : -1;
    setFocusedIndex(index), onSelect(options[index]);
  }, $[2] = onSelect, $[3] = options, $[4] = rootElement, $[5] = t1) : t1 = $[5];
  const handleOptionClick = t1;
  let t2, t3;
  $[6] !== focusedIndex || $[7] !== rootElement ? (t2 = () => {
    if (!rootElement)
      return;
    const focusableElements = Array.from(rootElement.querySelectorAll("button"));
    focusableElements.length > 0 && focusableElements[focusedIndex].focus();
  }, t3 = [focusedIndex, rootElement], $[6] = focusedIndex, $[7] = rootElement, $[8] = t2, $[9] = t3) : (t2 = $[8], t3 = $[9]), useEffect(t2, t3);
  let t4;
  if ($[10] !== handleOptionClick || $[11] !== options || $[12] !== t) {
    let t52;
    $[14] !== handleOptionClick || $[15] !== t ? (t52 = (o) => {
      const emoji = COMMENT_REACTION_EMOJIS[o.shortName];
      return /* @__PURE__ */ jsx(Button$1, { "aria-label": t("reactions.react-with-aria-label", {
        reactionName: o.title || o.shortName
      }), mode: "bleed", onClick: handleOptionClick, padding: 2, role: "menuitem", tabIndex: -1, children: /* @__PURE__ */ jsx(EmojiText, { align: "center", size: 2, children: emoji }) }, o.shortName);
    }, $[14] = handleOptionClick, $[15] = t, $[16] = t52) : t52 = $[16], t4 = options.map(t52), $[10] = handleOptionClick, $[11] = options, $[12] = t, $[13] = t4;
  } else
    t4 = $[13];
  let t5;
  return $[17] !== handleRootKeyDown || $[18] !== t4 ? (t5 = /* @__PURE__ */ jsx(Grid, { columns: GRID_COLUMNS, gap: 1, onKeyDown: handleRootKeyDown, ref: setRootElement, role: "menu", children: t4 }), $[17] = handleRootKeyDown, $[18] = t4, $[19] = t5) : t5 = $[19], t5;
}
const POPOVER_FALLBACK_PLACEMENTS$2 = ["top", "bottom"];
function CommentReactionsMenuButton(props2) {
  const $ = c(35), {
    onMenuClose,
    onMenuOpen,
    onSelect,
    options,
    readOnly,
    renderMenuButton: renderMenuButton2,
    mode
  } = props2, [buttonElement, setButtonElement] = useState(null), popoverRef = useRef(null), [open, setOpen] = useState(!1), {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] !== onMenuClose || $[1] !== onMenuOpen || $[2] !== open ? (t0 = () => {
    const next = !open;
    setOpen(next), next ? onMenuOpen?.() : onMenuClose?.();
  }, $[0] = onMenuClose, $[1] = onMenuOpen, $[2] = open, $[3] = t0) : t0 = $[3];
  const handleClick = t0;
  let t1;
  $[4] !== onMenuClose || $[5] !== open ? (t1 = () => {
    open && (setOpen(!1), onMenuClose?.());
  }, $[4] = onMenuClose, $[5] = open, $[6] = t1) : t1 = $[6];
  const handleClose = t1;
  let t2;
  $[7] !== buttonElement || $[8] !== handleClose || $[9] !== open ? (t2 = () => {
    open && (handleClose(), buttonElement?.focus());
  }, $[7] = buttonElement, $[8] = handleClose, $[9] = open, $[10] = t2) : t2 = $[10];
  const handleCloseAndFocus = t2;
  let t3;
  $[11] !== handleCloseAndFocus ? (t3 = (event) => {
    const {
      key,
      shiftKey
    } = event;
    (shiftKey && key === "Tab" || key === "Escape" || key === "Tab") && handleCloseAndFocus();
  }, $[11] = handleCloseAndFocus, $[12] = t3) : t3 = $[12];
  const handleKeyDown = t3;
  let t4;
  $[13] !== buttonElement ? (t4 = () => [popoverRef.current, buttonElement], $[13] = buttonElement, $[14] = t4) : t4 = $[14], useClickOutsideEvent(handleClose, t4);
  let t5;
  $[15] !== handleClose || $[16] !== onSelect ? (t5 = (option) => {
    onSelect(option), handleClose();
  }, $[15] = handleClose, $[16] = onSelect, $[17] = t5) : t5 = $[17];
  const handleSelect = t5;
  let t6;
  if ($[18] !== handleClick || $[19] !== mode || $[20] !== open || $[21] !== readOnly || $[22] !== renderMenuButton2 || $[23] !== t) {
    const btn = renderMenuButton2({
      open,
      tooltipContent: t(mode === "upsell" ? "list-item.context-menu-add-reaction-upsell" : "list-item.context-menu-add-reaction"),
      t
    });
    t6 = cloneElement(btn, {
      "aria-expanded": open,
      "aria-haspopup": "true",
      disabled: readOnly || mode === "upsell",
      id: "reactions-menu-button",
      onClick: handleClick,
      ref: setButtonElement
    }), $[18] = handleClick, $[19] = mode, $[20] = open, $[21] = readOnly, $[22] = renderMenuButton2, $[23] = t, $[24] = t6;
  } else
    t6 = $[24];
  const button = t6;
  let t7;
  $[25] !== handleSelect || $[26] !== options ? (t7 = /* @__PURE__ */ jsx(CommentReactionsMenu, { onSelect: handleSelect, options }), $[25] = handleSelect, $[26] = options, $[27] = t7) : t7 = $[27];
  let t8;
  $[28] !== handleKeyDown || $[29] !== t7 ? (t8 = /* @__PURE__ */ jsx(Card, { "aria-labelledby": "reactions-menu-button", onKeyDown: handleKeyDown, padding: 1, radius: 3, tone: "default", children: t7 }), $[28] = handleKeyDown, $[29] = t7, $[30] = t8) : t8 = $[30];
  const popoverContent = t8;
  let t9;
  return $[31] !== button || $[32] !== open || $[33] !== popoverContent ? (t9 = /* @__PURE__ */ jsx(Popover, { constrainSize: !0, content: popoverContent, fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$2, open, placement: "bottom", portal: !0, ref: popoverRef, tone: "default", children: button }), $[31] = button, $[32] = open, $[33] = popoverContent, $[34] = t9) : t9 = $[34], t9;
}
const TEXT_SIZE = 1, ContentStack$1 = styled(Stack).withConfig({
  displayName: "ContentStack",
  componentId: "sc-e2nrgi-0"
})`max-width:180px;`, TextGroup = styled.div.withConfig({
  displayName: "TextGroup",
  componentId: "sc-e2nrgi-1"
})`display:inline-block;`, InlineText = styled(Text$1).attrs({
  size: TEXT_SIZE
}).withConfig({
  displayName: "InlineText",
  componentId: "sc-e2nrgi-2"
})`display:inline-block !important;& > span{white-space:break-spaces;}`, TextBox = styled(Box).withConfig({
  displayName: "TextBox",
  componentId: "sc-e2nrgi-3"
})`line-height:1;text-align:center;`, LEADING_NON_WHITESPACE_RE = /^\S+/;
function UserDisplayName(props2) {
  const $ = c(7), {
    currentUserId,
    isFirst,
    userId
  } = props2, [user] = useUser(userId), {
    t
  } = useTranslation(commentsLocaleNamespace);
  if (currentUserId === userId) {
    const context = isFirst ? "leading" : void 0, t02 = user?.displayName;
    let t1;
    return $[0] !== context || $[1] !== t || $[2] !== t02 ? (t1 = t("reactions.user-list.you", {
      context,
      replace: {
        name: t02
      }
    }), $[0] = context, $[1] = t, $[2] = t02, $[3] = t1) : t1 = $[3], t1;
  }
  let t0;
  return $[4] !== t || $[5] !== user?.displayName ? (t0 = user?.displayName || t("reactions.user-list.unknown-user-fallback-name"), $[4] = t, $[5] = user?.displayName, $[6] = t0) : t0 = $[6], t0;
}
function CommentReactionsUsersTooltip(props2) {
  const $ = c(10);
  let children, restProps;
  $[0] !== props2 ? ({
    children,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = restProps) : (children = $[1], restProps = $[2]);
  let t0;
  $[3] !== restProps ? (t0 = /* @__PURE__ */ jsx(CommentReactionsUsersTooltipContent, { ...restProps }), $[3] = restProps, $[4] = t0) : t0 = $[4];
  let t1;
  $[5] !== children ? (t1 = /* @__PURE__ */ jsx("div", { children }), $[5] = children, $[6] = t1) : t1 = $[6];
  let t2;
  return $[7] !== t0 || $[8] !== t1 ? (t2 = /* @__PURE__ */ jsx(Tooltip, { content: t0, placement: "bottom", portal: !0, children: t1 }), $[7] = t0, $[8] = t1, $[9] = t2) : t2 = $[9], t2;
}
function FormattedUserList(t0) {
  const $ = c(5), {
    currentUserId,
    userIds
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    style: "long",
    type: "conjunction"
  }, $[0] = t1) : t1 = $[0];
  const listFormat = useListFormat(t1);
  if (userIds.length === 0)
    return null;
  let elements;
  if ($[1] !== currentUserId || $[2] !== listFormat || $[3] !== userIds) {
    const parts = listFormat.formatToParts(userIds);
    elements = [];
    for (let i = 0; i < parts.length; i++) {
      const item = parts[i];
      if (item.type === "literal") {
        elements.push(/* @__PURE__ */ jsx(InlineText, { children: item.value }, `literal-${i}`));
        continue;
      }
      const nextItem = parts[i + 1];
      if (nextItem && nextItem.type === "literal" && LEADING_NON_WHITESPACE_RE.test(nextItem.value)) {
        const [t2] = nextItem.value.match(LEADING_NON_WHITESPACE_RE) || [], nonWhitespace = t2 === void 0 ? "" : t2;
        elements.push(/* @__PURE__ */ jsxs(TextGroup, { children: [
          /* @__PURE__ */ jsx(InlineText, { weight: "medium", children: /* @__PURE__ */ jsx(UserDisplayName, { currentUserId, isFirst: i === 0, userId: item.value }) }),
          /* @__PURE__ */ jsx(InlineText, { children: nonWhitespace })
        ] }, item.value)), nextItem.value = nextItem.value.slice(nonWhitespace.length);
        continue;
      }
      elements.push(/* @__PURE__ */ jsx(InlineText, { weight: "medium", children: /* @__PURE__ */ jsx(UserDisplayName, { currentUserId, isFirst: i === 0, userId: item.value }) }, item.value));
    }
    $[1] = currentUserId, $[2] = listFormat, $[3] = userIds, $[4] = elements;
  } else
    elements = $[4];
  return elements;
}
function CommentReactionsUsersTooltipContent(props2) {
  const $ = c(19), {
    currentUser,
    reactionName,
    userIds
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] !== currentUser || $[1] !== userIds ? (t0 = () => currentUser ? /* @__PURE__ */ jsx(FormattedUserList, { currentUserId: currentUser.id, userIds }) : null, $[0] = currentUser, $[1] = userIds, $[2] = t0) : t0 = $[2];
  const UserList = t0, t1 = COMMENT_REACTION_EMOJIS[reactionName];
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Flex, { justify: "center", paddingBottom: 2, paddingTop: 1, children: /* @__PURE__ */ jsx(EmojiText, { size: 4, children: t1 }) }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== reactionName ? (t3 = {
    reactionName
  }, $[5] = reactionName, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== reactionName ? (t4 = () => /* @__PURE__ */ jsx(InlineText, { muted: !0, children: reactionName }), $[7] = reactionName, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== UserList || $[10] !== t4 ? (t5 = {
    UserList,
    ReactionName: t4,
    Text: _temp$16
  }, $[9] = UserList, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t || $[13] !== t3 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(TextBox, { children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "reactions.users-reacted-with-reaction", values: t3, components: t5 }) }), $[12] = t, $[13] = t3, $[14] = t5, $[15] = t6) : t6 = $[15];
  let t7;
  return $[16] !== t2 || $[17] !== t6 ? (t7 = /* @__PURE__ */ jsxs(ContentStack$1, { padding: 1, children: [
    t2,
    t6
  ] }), $[16] = t2, $[17] = t6, $[18] = t7) : t7 = $[18], t7;
}
function _temp$16(t0) {
  const {
    children
  } = t0;
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(InlineText, { muted: !0, children }),
    " ",
    /* @__PURE__ */ jsx("wbr", {}),
    " "
  ] });
}
const TransparentCard = styled(Card).withConfig({
  displayName: "TransparentCard",
  componentId: "sc-h5x3la-0"
})`background:none;`;
function groupReactionsByName(reactions) {
  const grouped = reactions.reduce((acc, reaction) => {
    const {
      shortName
    } = reaction;
    return acc[shortName] || (acc[shortName] = []), acc[shortName].push(reaction), acc;
  }, {});
  return Object.entries(grouped).sort(([nameA], [nameB]) => {
    const indexA = reactions.findIndex((r) => r.shortName === nameA), indexB = reactions.findIndex((r) => r.shortName === nameB);
    return indexA - indexB;
  });
}
const renderMenuButton$1 = ({
  open,
  tooltipContent
}) => /* @__PURE__ */ jsx(Button$1, { fontSize: 1, mode: "ghost", padding: 0, radius: "full", selected: open, children: /* @__PURE__ */ jsx(Flex, { paddingX: 3, paddingY: 2, children: /* @__PURE__ */ jsx(Tooltip, { animate: !0, content: tooltipContent, disabled: open, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ReactionIcon, {}) }) }) }) }), CommentReactionsBar = memo(function(props2) {
  const $ = c(41), {
    currentUser,
    onSelect,
    reactions,
    readOnly,
    mode
  } = props2;
  let t0;
  $[0] !== onSelect ? (t0 = (name) => {
    const option = COMMENT_REACTION_OPTIONS.find((o) => o.shortName === name);
    option && onSelect(option);
  }, $[0] = onSelect, $[1] = t0) : t0 = $[1];
  const handleSelect = t0;
  let t1;
  if ($[2] !== currentUser?.id || $[3] !== reactions) {
    let t22;
    $[5] !== currentUser?.id ? (t22 = (r) => r.userId === currentUser?.id, $[5] = currentUser?.id, $[6] = t22) : t22 = $[6], t1 = reactions.filter(t22).map(_temp$15), $[2] = currentUser?.id, $[3] = reactions, $[4] = t1;
  } else
    t1 = $[4];
  const currentUserReactionNames = t1;
  let t2;
  $[7] !== reactions ? (t2 = groupReactionsByName(reactions).filter(_temp2$q), $[7] = reactions, $[8] = t2) : t2 = $[8];
  const groupedReactions = t2;
  let t3;
  $[9] !== groupedReactions ? (t3 = () => ({
    sortOrder: Object.keys(Object.fromEntries(groupedReactions)),
    groupedReactions: [],
    sortedReactions: []
  }), $[9] = groupedReactions, $[10] = t3) : t3 = $[10];
  const [sortedGroupedReactions, setSortedGroupedReactions] = useState(t3);
  let {
    sortedReactions
  } = sortedGroupedReactions;
  if (sortedGroupedReactions.groupedReactions !== groupedReactions) {
    const {
      sortOrder
    } = sortedGroupedReactions;
    let t42, t52, t62;
    if ($[11] !== groupedReactions || $[12] !== sortOrder) {
      let t72;
      $[17] !== sortOrder ? (t72 = (t8, t9) => {
        const [nameA] = t8, [nameB] = t9, indexA = sortOrder.indexOf(nameA), indexB = sortOrder.indexOf(nameB);
        return indexA === -1 ? 1 : indexB === -1 ? -1 : indexA - indexB;
      }, $[17] = sortOrder, $[18] = t72) : t72 = $[18], sortedReactions = groupedReactions.sort(t72), t62 = setSortedGroupedReactions, t42 = groupedReactions, t52 = sortedReactions.map(_temp3$f), $[11] = groupedReactions, $[12] = sortOrder, $[13] = t42, $[14] = t52, $[15] = t62, $[16] = sortedReactions;
    } else
      t42 = $[13], t52 = $[14], t62 = $[15], sortedReactions = $[16];
    t62({
      groupedReactions: t42,
      sortOrder: t52,
      sortedReactions
    });
  }
  let t4;
  if ($[19] !== currentUser || $[20] !== currentUserReactionNames || $[21] !== handleSelect || $[22] !== mode || $[23] !== readOnly || $[24] !== sortedReactions) {
    let t52;
    $[26] !== currentUser || $[27] !== currentUserReactionNames || $[28] !== handleSelect || $[29] !== mode || $[30] !== readOnly ? (t52 = (t62) => {
      const [name_2, reactionsList] = t62, hasReacted = currentUserReactionNames.includes(name_2), userIds = reactionsList.map(_temp4$6), emoji = COMMENT_REACTION_EMOJIS[name_2];
      return /* @__PURE__ */ jsx(CommentReactionsUsersTooltip, { currentUser, reactionName: name_2, userIds, children: /* @__PURE__ */ jsx(TransparentCard, { tone: "default", children: /* @__PURE__ */ jsx(Button$1, { disabled: readOnly || mode === "upsell", mode: "ghost", onClick: () => handleSelect(name_2), padding: 2, radius: "full", selected: hasReacted, tone: hasReacted ? "primary" : "default", children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
        /* @__PURE__ */ jsx(EmojiText, { size: 1, children: emoji }),
        /* @__PURE__ */ jsx(Text$1, { size: 0, weight: hasReacted ? "semibold" : "medium", children: reactionsList?.length })
      ] }) }) }) }, name_2);
    }, $[26] = currentUser, $[27] = currentUserReactionNames, $[28] = handleSelect, $[29] = mode, $[30] = readOnly, $[31] = t52) : t52 = $[31], t4 = sortedReactions.map(t52), $[19] = currentUser, $[20] = currentUserReactionNames, $[21] = handleSelect, $[22] = mode, $[23] = readOnly, $[24] = sortedReactions, $[25] = t4;
  } else
    t4 = $[25];
  let t5;
  $[32] !== handleSelect ? (t5 = (o_0) => handleSelect(o_0.shortName), $[32] = handleSelect, $[33] = t5) : t5 = $[33];
  let t6;
  $[34] !== mode || $[35] !== readOnly || $[36] !== t5 ? (t6 = /* @__PURE__ */ jsx(TransparentCard, { tone: "default", children: /* @__PURE__ */ jsx(CommentReactionsMenuButton, { mode, onSelect: t5, options: COMMENT_REACTION_OPTIONS, readOnly, renderMenuButton: renderMenuButton$1 }) }), $[34] = mode, $[35] = readOnly, $[36] = t5, $[37] = t6) : t6 = $[37];
  let t7;
  return $[38] !== t4 || $[39] !== t6 ? (t7 = /* @__PURE__ */ jsx(Flex, { align: "center", gap: 1, wrap: "wrap", children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
    t4,
    t6
  ] }) }), $[38] = t4, $[39] = t6, $[40] = t7) : t7 = $[40], t7;
});
CommentReactionsBar.displayName = "Memo(CommentReactionsBar)";
function _temp$15(r_0) {
  return r_0.shortName;
}
function _temp2$q(t0) {
  const [name_0] = t0;
  return COMMENT_REACTION_EMOJIS[name_0];
}
function _temp3$f(t0) {
  const [name_1] = t0;
  return name_1;
}
function _temp4$6(r_1) {
  return r_1.userId;
}
const renderMenuButton = ({
  open,
  tooltipContent,
  t
}) => /* @__PURE__ */ jsx(Button, { "aria-label": t("list-item.context-menu-add-reaction-aria-label"), icon: ReactionIcon, mode: "bleed", selected: open, tooltipProps: {
  content: tooltipContent
} }), POPOVER_PROPS$3 = {
  placement: "bottom-end"
}, FloatingCard = styled(Card).withConfig({
  displayName: "FloatingCard",
  componentId: "sc-lacwdd-0"
})`&:empty{display:none;}`;
function CommentsListItemContextMenu(props2) {
  const $ = c(29), {
    canDelete,
    canEdit,
    isParent,
    mode,
    onCopyLink,
    onDeleteStart,
    onEditStart,
    onMenuClose,
    onMenuOpen,
    onReactionSelect,
    onStatusChange,
    readOnly,
    status
  } = props2, showMenuButton = !!(onCopyLink || onDeleteStart || onEditStart), {
    t
  } = useTranslation(commentsLocaleNamespace), hasContextMenuOptions = !!(canDelete || canEdit || onCopyLink);
  let t0;
  $[0] !== mode || $[1] !== onMenuClose || $[2] !== onMenuOpen || $[3] !== onReactionSelect || $[4] !== readOnly ? (t0 = onReactionSelect && /* @__PURE__ */ jsx(CommentReactionsMenuButton, { mode, onMenuClose, onMenuOpen, onSelect: onReactionSelect, options: COMMENT_REACTION_OPTIONS, readOnly, renderMenuButton }), $[0] = mode, $[1] = onMenuClose, $[2] = onMenuOpen, $[3] = onReactionSelect, $[4] = readOnly, $[5] = t0) : t0 = $[5];
  let t1;
  $[6] !== isParent || $[7] !== onStatusChange || $[8] !== readOnly || $[9] !== status || $[10] !== t ? (t1 = isParent && onStatusChange && /* @__PURE__ */ jsx(Button, { "aria-label": t(status === "open" ? "list-item.resolved-tooltip-aria-label" : "list-item.re-open-resolved-aria-label"), "data-testid": "comments-list-item-status-button", disabled: readOnly, icon: status === "open" ? CheckmarkCircleIcon : UndoIcon, mode: "bleed", onClick: onStatusChange, tooltipProps: {
    content: t(status === "open" ? "list-item.resolved-tooltip-content" : "list-item.re-open-resolved")
  } }), $[6] = isParent, $[7] = onStatusChange, $[8] = readOnly, $[9] = status, $[10] = t, $[11] = t1) : t1 = $[11];
  let t2;
  $[12] !== canDelete || $[13] !== canEdit || $[14] !== hasContextMenuOptions || $[15] !== mode || $[16] !== onCopyLink || $[17] !== onDeleteStart || $[18] !== onEditStart || $[19] !== onMenuClose || $[20] !== onMenuOpen || $[21] !== readOnly || $[22] !== showMenuButton || $[23] !== t ? (t2 = hasContextMenuOptions && /* @__PURE__ */ jsx(MenuButton, { id: "comment-actions-menu", button: /* @__PURE__ */ jsx(ContextMenuButton, { "aria-label": t("list-item.open-menu-aria-label"), disabled: readOnly, hidden: !showMenuButton }), onOpen: onMenuOpen, onClose: onMenuClose, menu: /* @__PURE__ */ jsxs(Menu, { children: [
    /* @__PURE__ */ jsx(MenuItem, { hidden: !canEdit, icon: EditIcon, onClick: onEditStart, text: t("list-item.edit-comment"), tooltipProps: mode === "upsell" ? {
      content: t("list-item.edit-comment-upsell")
    } : void 0, disabled: mode === "upsell" }),
    /* @__PURE__ */ jsx(MenuItem, { hidden: !canDelete, icon: TrashIcon, onClick: onDeleteStart, text: t("list-item.delete-comment"), tone: "critical" }),
    onCopyLink && /* @__PURE__ */ jsx(MenuDivider, { hidden: !canDelete && !canEdit }),
    /* @__PURE__ */ jsx(MenuItem, { hidden: !onCopyLink, icon: LinkIcon, onClick: onCopyLink, text: t("list-item.copy-link") })
  ] }), popover: POPOVER_PROPS$3 }), $[12] = canDelete, $[13] = canEdit, $[14] = hasContextMenuOptions, $[15] = mode, $[16] = onCopyLink, $[17] = onDeleteStart, $[18] = onEditStart, $[19] = onMenuClose, $[20] = onMenuOpen, $[21] = readOnly, $[22] = showMenuButton, $[23] = t, $[24] = t2) : t2 = $[24];
  let t3;
  return $[25] !== t0 || $[26] !== t1 || $[27] !== t2 ? (t3 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsxs(FloatingCard, { display: "flex", shadow: 2, padding: 1, radius: 2, sizing: "border", children: [
    t0,
    t1,
    t2
  ] }) }) }), $[25] = t0, $[26] = t1, $[27] = t2, $[28] = t3) : t3 = $[28], t3;
}
function truncate(str, length = 250) {
  return str.length <= length ? str : `${str.slice(0, length)}...`;
}
const InlineBox = styled(Box).attrs({
  marginLeft: 1,
  marginRight: 2
}).withConfig({
  displayName: "InlineBox",
  componentId: "sc-1ae0rk-0"
})`&:not([data-hidden]){display:inline;}`, BlockQuoteStack = /* @__PURE__ */ styled(Stack).withConfig({
  displayName: "BlockQuoteStack",
  componentId: "sc-1ae0rk-1"
})(({
  theme,
  $hasReferencedValue
}) => {
  const isDark = theme.sanity.v2?.color._dark, hue = $hasReferencedValue ? COMMENTS_HIGHLIGHT_HUE_KEY : "gray", borderColor = isDark ? hues[hue][700].hex : hues[hue][300].hex;
  return css`
    border-left: 2px solid ${borderColor};
    word-break: break-word;
  `;
});
function CommentsListItemReferencedValue(props2) {
  const $ = c(13), {
    hasReferencedValue,
    value
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] !== t ? (t0 = t("list-item.missing-referenced-value-tooltip-content"), $[0] = t, $[1] = t0) : t0 = $[1];
  const tooltipText = t0;
  let t1;
  bb0: {
    if (Array.isArray(value) && value?.filter(isPortableTextTextBlock).length > 0) {
      let t22;
      if ($[2] !== value) {
        const text = value?.map(toPlainText$1).join(" ");
        t22 = truncate(text), $[2] = value, $[3] = t22;
      } else
        t22 = $[3];
      t1 = t22;
      break bb0;
    }
    t1 = null;
  }
  const resolvedValue = t1;
  if (!resolvedValue)
    return null;
  const t2 = !!hasReferencedValue;
  let t3;
  $[4] !== hasReferencedValue || $[5] !== tooltipText ? (t3 = !hasReferencedValue && /* @__PURE__ */ jsx(Tooltip, { content: tooltipText, children: /* @__PURE__ */ jsx(InlineBox, { children: /* @__PURE__ */ jsx(LinkRemovedIcon, {}) }) }), $[4] = hasReferencedValue, $[5] = tooltipText, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== resolvedValue || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(Flex, { align: "flex-start", children: /* @__PURE__ */ jsxs(Text$1, { size: 1, muted: !0, children: [
    t3,
    resolvedValue
  ] }) }), $[7] = resolvedValue, $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== t2 || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(BlockQuoteStack, { $hasReferencedValue: t2, "data-testid": "comments-list-item-referenced-value", flex: 1, forwardedAs: "blockquote", padding: 1, paddingLeft: 2, sizing: "border", children: t4 }), $[10] = t2, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
}
const stopPropagation = (e) => e.stopPropagation(), ContextMenuBox = styled(Box).withConfig({
  displayName: "ContextMenuBox",
  componentId: "sc-1e1bh61-0"
})``, SKELETON_INLINE_STYLE = {
  width: "50%"
}, EMPTY_ARRAY$b = [], TimeText = /* @__PURE__ */ styled(Text$1).withConfig({
  displayName: "TimeText",
  componentId: "sc-1e1bh61-1"
})(({
  theme
}) => {
  const isDark = theme.sanity.color.dark, fg = hues.gray[isDark ? 200 : 800].hex;
  return css`
    min-width: max-content;
    --card-fg-color: ${fg};
    color: var(--card-fg-color);
  `;
}), HeaderFlex$4 = /* @__PURE__ */ styled(Flex).withConfig({
  displayName: "HeaderFlex",
  componentId: "sc-1e1bh61-2"
})((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    min-height: ${theme.avatar.sizes[props2.$size]?.size}px;
  `;
}), IntentText = /* @__PURE__ */ styled(Text$1).withConfig({
  displayName: "IntentText",
  componentId: "sc-1e1bh61-3"
})(({
  theme
}) => {
  const isDark = theme.sanity.color.dark, fg = hues.gray[isDark ? 200 : 800].hex;
  return css`
    --card-fg-color: ${fg};
    color: var(--card-fg-color);
  `;
}), InnerStack = styled(Stack).withConfig({
  displayName: "InnerStack",
  componentId: "sc-1e1bh61-4"
})`transition:opacity 200ms ease;&[data-muted='true']{transition:unset;opacity:0.5;}`, ErrorFlex = /* @__PURE__ */ styled(Flex).withConfig({
  displayName: "ErrorFlex",
  componentId: "sc-1e1bh61-5"
})((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    min-height: ${theme.avatar.sizes[props2.$size]?.size}px;
  `;
}), RetryCardButton = styled(Card).withConfig({
  displayName: "RetryCardButton",
  componentId: "sc-1e1bh61-6"
})`&:not(:hover){background-color:transparent;}`, RootStack$1 = /* @__PURE__ */ styled(Stack).withConfig({
  displayName: "RootStack",
  componentId: "sc-1e1bh61-7"
})(({
  theme
}) => {
  const {
    space
  } = theme.sanity;
  return css`
    position: relative;

    /* Only show the floating layer on hover when hover is supported.
    Else, the layer is always visible. */
    @media (hover: hover) {
      ${ContextMenuBox} {
        opacity: 0;
        position: absolute;
        right: 0;
        top: 0;
        transform: translate(${space[1]}px, -${space[1]}px);
      }

      ${ContextMenuBox} {
        &:focus-within {
          opacity: 1;
        }
      }

      &:hover {
        ${ContextMenuBox} {
          opacity: 1;
        }
      }
    }

    &[data-menu-open='true'] {
      ${ContextMenuBox} {
        opacity: 1;
      }
    }
  `;
}), RELATIVE_TIME_OPTIONS$1 = {
  useTemporalPhrase: !0
};
function CommentsListItemLayout(props2) {
  const $ = c(152), {
    avatarSize: t0,
    canDelete,
    canEdit,
    comment,
    currentUser,
    hasError,
    hasReferencedValue,
    intent,
    isParent,
    isRetrying,
    mentionOptions,
    mode,
    onCopyLink,
    onCreateRetry,
    onDelete,
    onEdit,
    onInputKeyDown,
    onReactionSelect,
    onStatusChange,
    readOnly,
    withAvatar: t1
  } = props2, avatarSize = t0 === void 0 ? 1 : t0, withAvatar = t1 === void 0 ? !0 : t1, {
    _createdAt,
    authorId,
    message,
    _id,
    lastEditedAt
  } = comment, [user] = useUser(authorId), {
    t
  } = useTranslation(commentsLocaleNamespace), [value, setValue] = useState(message), [isEditing, setIsEditing] = useState(!1), rootElementRef = useRef(null), startMessage = useRef(message), [menuOpen, setMenuOpen] = useState(!1), commentInputRef = useRef(null), hasChanges = useCommentHasChanged(value);
  let t2;
  $[0] !== value ? (t2 = hasCommentMessageValue(value), $[0] = value, $[1] = t2) : t2 = $[1];
  const hasValue2 = t2;
  let t3;
  $[2] !== comment.reactions ? (t3 = (comment?.reactions?.filter(_temp$14) || EMPTY_ARRAY$b).filter(_temp2$p), $[2] = comment.reactions, $[3] = t3) : t3 = $[3];
  const reactions = t3, hasReactions = !!reactions?.length;
  let t4;
  $[4] !== _createdAt ? (t4 = _createdAt ? new Date(_createdAt) : /* @__PURE__ */ new Date(), $[4] = _createdAt, $[5] = t4) : t4 = $[5];
  const createdDate = t4, editedDate = lastEditedAt ? new Date(lastEditedAt) : null, createdTimeAgo = useRelativeTime(createdDate, RELATIVE_TIME_OPTIONS$1);
  let t5;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    dateStyle: "full",
    timeStyle: "medium"
  }, $[6] = t5) : t5 = $[6];
  const dateTimeFormat = useDateTimeFormat(t5);
  let t6;
  $[7] !== createdDate || $[8] !== dateTimeFormat ? (t6 = dateTimeFormat.format(createdDate), $[7] = createdDate, $[8] = dateTimeFormat, $[9] = t6) : t6 = $[9];
  const formattedCreatedAt = t6, formattedLastEditAt = editedDate ? dateTimeFormat.format(editedDate) : null, displayError = hasError || isRetrying;
  let t7, t8;
  $[10] !== isEditing || $[11] !== message ? (t7 = () => {
    isEditing || (startMessage.current = message, setValue(message));
  }, t8 = [isEditing, message], $[10] = isEditing, $[11] = message, $[12] = t7, $[13] = t8) : (t7 = $[12], t8 = $[13]), useEffect(t7, t8);
  let t9;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = () => setMenuOpen(!0), $[14] = t9) : t9 = $[14];
  const handleMenuOpen = t9;
  let t10;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = () => setMenuOpen(!1), $[15] = t10) : t10 = $[15];
  const handleMenuClose = t10;
  let t11;
  $[16] !== _id || $[17] !== onCopyLink ? (t11 = () => onCopyLink?.(_id), $[16] = _id, $[17] = onCopyLink, $[18] = t11) : t11 = $[18];
  const handleCopyLink = t11;
  let t12;
  $[19] !== _id || $[20] !== onCreateRetry ? (t12 = (e) => {
    e.stopPropagation(), onCreateRetry?.(_id);
  }, $[19] = _id, $[20] = onCreateRetry, $[21] = t12) : t12 = $[21];
  const handleCreateRetry = t12;
  let t13;
  $[22] !== _id || $[23] !== onDelete ? (t13 = () => onDelete(_id), $[22] = _id, $[23] = onDelete, $[24] = t13) : t13 = $[24];
  const handleDelete = t13;
  let t14;
  $[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t14 = () => {
    setIsEditing(!1), setValue(startMessage.current);
  }, $[25] = t14) : t14 = $[25];
  const cancelEdit = t14;
  let t15;
  $[26] !== hasChanges || $[27] !== hasValue2 ? (t15 = () => {
    if (!hasValue2 || !hasChanges) {
      cancelEdit();
      return;
    }
    commentInputRef.current?.discardDialogController.open();
  }, $[26] = hasChanges, $[27] = hasValue2, $[28] = t15) : t15 = $[28];
  const startDiscard = t15;
  let t16;
  $[29] !== onInputKeyDown || $[30] !== startDiscard ? (t16 = (event) => {
    event.isDefaultPrevented() || (event.key === "Escape" && (event.preventDefault(), event.stopPropagation(), startDiscard()), onInputKeyDown && onInputKeyDown(event));
  }, $[29] = onInputKeyDown, $[30] = startDiscard, $[31] = t16) : t16 = $[31];
  const handleInputKeyDown = t16;
  let t17;
  $[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t17 = () => {
    commentInputRef.current?.discardDialogController.close();
  }, $[32] = t17) : t17 = $[32];
  const cancelDiscard = t17;
  let t18;
  $[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t18 = () => {
    commentInputRef.current?.discardDialogController.close(), cancelEdit();
  }, $[33] = t18) : t18 = $[33];
  const confirmDiscard = t18;
  let t19;
  $[34] !== _id || $[35] !== onReactionSelect ? (t19 = (reaction) => {
    onReactionSelect?.(_id, reaction);
  }, $[34] = _id, $[35] = onReactionSelect, $[36] = t19) : t19 = $[36];
  const handleReactionSelect = t19;
  let t20;
  $[37] !== _id || $[38] !== onEdit || $[39] !== value ? (t20 = () => {
    onEdit(_id, {
      message: value
    }), setIsEditing(!1);
  }, $[37] = _id, $[38] = onEdit, $[39] = value, $[40] = t20) : t20 = $[40];
  const handleEditSubmit = t20;
  let t21;
  $[41] !== _id || $[42] !== comment.status || $[43] !== onStatusChange ? (t21 = () => {
    onStatusChange?.(_id, comment.status === "open" ? "resolved" : "open");
  }, $[41] = _id, $[42] = comment.status, $[43] = onStatusChange, $[44] = t21) : t21 = $[44];
  const handleOpenStatusChange = t21;
  let t22;
  $[45] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = () => {
    setIsEditing(_temp3$e);
  }, $[45] = t22) : t22 = $[45];
  const toggleEdit = t22;
  let t23;
  $[46] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t23 = () => setMenuOpen(!1), $[46] = t23) : t23 = $[46];
  const handleCloseMenu = t23;
  let t24;
  $[47] !== hasChanges ? (t24 = (event_0) => {
    event_0.key === "Escape" && !hasChanges && cancelEdit();
  }, $[47] = hasChanges, $[48] = t24) : t24 = $[48];
  const handleRootKeyDown = t24;
  useDidUpdate(isEditing, handleCloseMenu);
  let t25;
  $[49] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t25 = () => [rootElementRef.current], $[49] = t25) : t25 = $[49], useClickOutsideEvent(!hasChanges && cancelEdit, t25);
  let t26;
  $[50] !== user ? (t26 = user?.displayName ? /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", textOverflow: "ellipsis", title: user.displayName, children: user.displayName }) : /* @__PURE__ */ jsx(TextSkeleton, { size: 1, style: SKELETON_INLINE_STYLE }), $[50] = user, $[51] = t26) : t26 = $[51];
  const name = t26, T0 = RootStack$1, t27 = menuOpen ? "true" : "false", t28 = "comments-list-item-layout", t29 = 4, T1 = InnerStack, t30 = 1, T2 = HeaderFlex$4, t31 = "center", t32 = FLEX_GAP, t33 = 1;
  let t34;
  $[52] !== avatarSize || $[53] !== user || $[54] !== withAvatar ? (t34 = withAvatar && /* @__PURE__ */ jsx(CommentsAvatar, { user, size: avatarSize }), $[52] = avatarSize, $[53] = user, $[54] = withAvatar, $[55] = t34) : t34 = $[55];
  const T3 = Flex, t35 = "column", t36 = 2, t37 = intent ? 2 : 0, T4 = Flex, t38 = "center", t39 = comment.context?.intent ? 0 : 1, t40 = "border", t41 = 1, T5 = Flex, t42 = "flex-end", t43 = 2;
  let t44;
  $[56] !== name ? (t44 = /* @__PURE__ */ jsx(Box, { flex: 1, children: name }), $[56] = name, $[57] = t44) : t44 = $[57];
  const t45 = !displayError && /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
    /* @__PURE__ */ jsx(TimeText, { muted: !0, size: 0, children: /* @__PURE__ */ jsx("time", { dateTime: createdDate.toISOString(), title: formattedCreatedAt, children: createdTimeAgo }) }),
    formattedLastEditAt && editedDate && /* @__PURE__ */ jsx(TimeText, { muted: !0, size: 0, title: formattedLastEditAt, children: /* @__PURE__ */ jsxs("time", { dateTime: editedDate.toISOString(), title: formattedLastEditAt, children: [
      "(",
      t("list-item.layout-edited"),
      ")"
    ] }) })
  ] });
  let t46;
  $[58] !== T5 || $[59] !== t44 || $[60] !== t45 ? (t46 = /* @__PURE__ */ jsxs(T5, { align: t42, gap: t43, children: [
    t44,
    t45
  ] }), $[58] = T5, $[59] = t44, $[60] = t45, $[61] = t46) : t46 = $[61];
  let t47;
  $[62] !== T4 || $[63] !== t39 || $[64] !== t46 ? (t47 = /* @__PURE__ */ jsx(T4, { align: t38, paddingBottom: t39, sizing: t40, flex: t41, children: t46 }), $[62] = T4, $[63] = t39, $[64] = t46, $[65] = t47) : t47 = $[65];
  let t48;
  $[66] !== intent || $[67] !== t ? (t48 = intent && /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(IntentText, { muted: !0, size: 0, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "list-item.layout-context", values: {
    title: intent.title,
    intent: "edit"
  }, components: {
    IntentLink: (t492) => {
      const {
        children
      } = t492;
      return intent ? /* @__PURE__ */ jsx(IntentLink, { params: intent.params, intent: intent.name, children }) : void 0;
    }
  } }) }) }), $[66] = intent, $[67] = t, $[68] = t48) : t48 = $[68];
  let t49;
  $[69] !== T3 || $[70] !== t37 || $[71] !== t47 || $[72] !== t48 ? (t49 = /* @__PURE__ */ jsxs(T3, { direction: t35, gap: t36, paddingY: t37, children: [
    t47,
    t48
  ] }), $[69] = T3, $[70] = t37, $[71] = t47, $[72] = t48, $[73] = t49) : t49 = $[73];
  let t50;
  $[74] !== canDelete || $[75] !== canEdit || $[76] !== comment.status || $[77] !== displayError || $[78] !== handleCopyLink || $[79] !== handleDelete || $[80] !== handleMenuClose || $[81] !== handleMenuOpen || $[82] !== handleOpenStatusChange || $[83] !== handleReactionSelect || $[84] !== isEditing || $[85] !== isParent || $[86] !== mode || $[87] !== onCopyLink || $[88] !== onStatusChange || $[89] !== readOnly || $[90] !== toggleEdit ? (t50 = !isEditing && !displayError && /* @__PURE__ */ jsx(ContextMenuBox, { "data-root-menu": isParent ? "true" : "false", onClick: stopPropagation, children: /* @__PURE__ */ jsx(CommentsListItemContextMenu, { canDelete, canEdit, isParent, mode, onCopyLink: onCopyLink ? handleCopyLink : void 0, onDeleteStart: handleDelete, onEditStart: toggleEdit, onMenuClose: handleMenuClose, onMenuOpen: handleMenuOpen, onReactionSelect: handleReactionSelect, onStatusChange: onStatusChange ? handleOpenStatusChange : void 0, readOnly, status: comment.status }) }), $[74] = canDelete, $[75] = canEdit, $[76] = comment.status, $[77] = displayError, $[78] = handleCopyLink, $[79] = handleDelete, $[80] = handleMenuClose, $[81] = handleMenuOpen, $[82] = handleOpenStatusChange, $[83] = handleReactionSelect, $[84] = isEditing, $[85] = isParent, $[86] = mode, $[87] = onCopyLink, $[88] = onStatusChange, $[89] = readOnly, $[90] = toggleEdit, $[91] = t50) : t50 = $[91];
  let t51;
  $[92] !== T2 || $[93] !== avatarSize || $[94] !== t32 || $[95] !== t34 || $[96] !== t49 || $[97] !== t50 ? (t51 = /* @__PURE__ */ jsxs(T2, { align: t31, gap: t32, flex: t33, $size: avatarSize, children: [
    t34,
    t49,
    t50
  ] }), $[92] = T2, $[93] = avatarSize, $[94] = t32, $[95] = t34, $[96] = t49, $[97] = t50, $[98] = t51) : t51 = $[98];
  let t52;
  $[99] !== avatarSize || $[100] !== comment || $[101] !== hasReferencedValue || $[102] !== withAvatar ? (t52 = isTextSelectionComment(comment) && !!comment?.contentSnapshot && /* @__PURE__ */ jsxs(Flex, { gap: FLEX_GAP, marginBottom: 3, children: [
    withAvatar && /* @__PURE__ */ jsx(SpacerAvatar, { $size: avatarSize }),
    /* @__PURE__ */ jsx(CommentsListItemReferencedValue, { hasReferencedValue, value: comment?.contentSnapshot })
  ] }), $[99] = avatarSize, $[100] = comment, $[101] = hasReferencedValue, $[102] = withAvatar, $[103] = t52) : t52 = $[103];
  let t53;
  $[104] !== avatarSize || $[105] !== cancelDiscard || $[106] !== confirmDiscard || $[107] !== currentUser || $[108] !== handleEditSubmit || $[109] !== handleInputKeyDown || $[110] !== isEditing || $[111] !== mentionOptions || $[112] !== readOnly || $[113] !== value || $[114] !== withAvatar ? (t53 = isEditing && /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 2, children: [
    withAvatar && /* @__PURE__ */ jsx(SpacerAvatar, { $size: avatarSize }),
    /* @__PURE__ */ jsx(Stack, { flex: 1, children: /* @__PURE__ */ jsx(CommentInput, { currentUser, focusOnMount: !0, mentionOptions, onChange: setValue, onDiscardCancel: cancelDiscard, onDiscardConfirm: confirmDiscard, onKeyDown: handleInputKeyDown, onSubmit: handleEditSubmit, readOnly, ref: commentInputRef, value, withAvatar: !1 }) })
  ] }), $[104] = avatarSize, $[105] = cancelDiscard, $[106] = confirmDiscard, $[107] = currentUser, $[108] = handleEditSubmit, $[109] = handleInputKeyDown, $[110] = isEditing, $[111] = mentionOptions, $[112] = readOnly, $[113] = value, $[114] = withAvatar, $[115] = t53) : t53 = $[115];
  let t54;
  $[116] !== avatarSize || $[117] !== isEditing || $[118] !== message || $[119] !== withAvatar ? (t54 = !isEditing && /* @__PURE__ */ jsxs(Flex, { gap: FLEX_GAP, children: [
    withAvatar && /* @__PURE__ */ jsx(SpacerAvatar, { $size: avatarSize }),
    /* @__PURE__ */ jsx(CommentMessageSerializer, { blocks: message })
  ] }), $[116] = avatarSize, $[117] = isEditing, $[118] = message, $[119] = withAvatar, $[120] = t54) : t54 = $[120];
  let t55;
  $[121] !== avatarSize || $[122] !== currentUser || $[123] !== handleReactionSelect || $[124] !== hasReactions || $[125] !== mode || $[126] !== reactions || $[127] !== readOnly || $[128] !== withAvatar ? (t55 = hasReactions && /* @__PURE__ */ jsxs(Flex, { gap: FLEX_GAP, marginTop: 2, children: [
    withAvatar && /* @__PURE__ */ jsx(SpacerAvatar, { $size: avatarSize }),
    /* @__PURE__ */ jsx(Box, { onClick: stopPropagation, children: /* @__PURE__ */ jsx(CommentReactionsBar, { currentUser, mode, onSelect: handleReactionSelect, reactions, readOnly }) })
  ] }), $[121] = avatarSize, $[122] = currentUser, $[123] = handleReactionSelect, $[124] = hasReactions, $[125] = mode, $[126] = reactions, $[127] = readOnly, $[128] = withAvatar, $[129] = t55) : t55 = $[129];
  let t56;
  $[130] !== T1 || $[131] !== displayError || $[132] !== t51 || $[133] !== t52 || $[134] !== t53 || $[135] !== t54 || $[136] !== t55 ? (t56 = /* @__PURE__ */ jsxs(T1, { space: t30, "data-muted": displayError, children: [
    t51,
    t52,
    t53,
    t54,
    t55
  ] }), $[130] = T1, $[131] = displayError, $[132] = t51, $[133] = t52, $[134] = t53, $[135] = t54, $[136] = t55, $[137] = t56) : t56 = $[137];
  let t57;
  $[138] !== avatarSize || $[139] !== displayError || $[140] !== handleCreateRetry || $[141] !== hasError || $[142] !== isRetrying || $[143] !== t || $[144] !== withAvatar ? (t57 = displayError && /* @__PURE__ */ jsxs(ErrorFlex, { gap: FLEX_GAP, $size: avatarSize, children: [
    withAvatar && /* @__PURE__ */ jsx(SpacerAvatar, { $size: avatarSize }),
    /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, flex: 1, children: [
      /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
        hasError && t("list-item.layout-failed-sent"),
        isRetrying && t("list-item.layout-posting")
      ] }),
      /* @__PURE__ */ jsx(Flex, { hidden: isRetrying, children: /* @__PURE__ */ jsx(RetryCardButton, { __unstable_focusRing: !0, display: "flex", forwardedAs: "button", onClick: handleCreateRetry, padding: 1, radius: 2, tone: "primary", children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t("list-item.layout-retry") }) }) })
    ] })
  ] }), $[138] = avatarSize, $[139] = displayError, $[140] = handleCreateRetry, $[141] = hasError, $[142] = isRetrying, $[143] = t, $[144] = withAvatar, $[145] = t57) : t57 = $[145];
  let t58;
  return $[146] !== T0 || $[147] !== handleRootKeyDown || $[148] !== t27 || $[149] !== t56 || $[150] !== t57 ? (t58 = /* @__PURE__ */ jsxs(T0, { "data-menu-open": t27, "data-testid": t28, onKeyDown: handleRootKeyDown, ref: rootElementRef, space: t29, children: [
    t56,
    t57
  ] }), $[146] = T0, $[147] = handleRootKeyDown, $[148] = t27, $[149] = t56, $[150] = t57, $[151] = t58) : t58 = $[151], t58;
}
function _temp3$e(v) {
  return !v;
}
function _temp2$p(r_0) {
  return "userId" in r_0 && "shortName" in r_0;
}
function _temp$14(r) {
  return r?._optimisticState !== "removed";
}
const ThreadCard = /* @__PURE__ */ styled(Card).attrs({
  padding: 3,
  radius: 3,
  sizing: "border"
}).withConfig({
  displayName: "ThreadCard",
  componentId: "sc-11xkvyy-0"
})((props2) => {
  const {
    theme
  } = props2, isDark = theme.sanity.color.dark, activeBg = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 900 : 50].hex, defaultBg = hues.gray[isDark ? 900 : 50].hex;
  return css`
      background-color: ${defaultBg};

      &[data-active='true'] {
        background-color: ${activeBg};
      }
    `;
}), EMPTY_ARRAY$a = [], MAX_COLLAPSED_REPLIES = 5, DEFAULT_AVATAR_CONFIG = {
  avatarSize: 1,
  parentCommentAvatar: !0,
  replyAvatar: !0,
  threadCommentsAvatar: !0
}, StyledThreadCard = /* @__PURE__ */ styled(ThreadCard).withConfig({
  displayName: "StyledThreadCard",
  componentId: "sc-niunrr-0"
})(() => css`
    position: relative;

    &:has(> [data-ui='GhostButton']:focus:focus-visible) {
      box-shadow:
        inset 0 0 0 1px var(--card-border-color),
        0 0 0 1px var(--card-bg-color),
        0 0 0 2px var(--card-focus-ring-color);
    }

    // The hover styles is managed with the [data-hovered] attribute instead of the :hover pseudo class
    // since we want to show the hover styles when hovering over the menu items in the context menu as well.
    // The context menu is rendered using a portal, so the :hover pseudo class won't work when hovering over
    // the menu items.
    &:not([data-active='true']) {
      @media (hover: hover) {
        &[data-hovered='true'] {
          [data-root-menu='true'] {
            opacity: 1;
          }
        }
      }
    }
  `), ExpandButton = /* @__PURE__ */ styled(Button).withConfig({
  displayName: "ExpandButton",
  componentId: "sc-niunrr-1"
})(({
  theme
}) => {
  const {
    medium
  } = theme.sanity.fonts.text.weights;
  return css`
    font-weight: ${medium};
  `;
}), GhostButton = styled.button.withConfig({
  displayName: "GhostButton",
  componentId: "sc-niunrr-2"
})`opacity:0;position:absolute;right:0;top:0;bottom:0;left:0;`, CommentsListItem = memo(function(props2) {
  const $ = c(113), {
    avatarConfig: t0,
    canReply,
    currentUser,
    hasReferencedValue,
    innerPadding,
    isSelected,
    mentionOptions,
    mode,
    onCopyLink,
    onCreateRetry,
    onDelete,
    onEdit,
    onKeyDown,
    onPathSelect,
    onReactionSelect,
    onReply,
    onStatusChange,
    parentComment,
    readOnly,
    replies: t1
  } = props2, avatarConfig = t0 === void 0 ? DEFAULT_AVATAR_CONFIG : t0, replies = t1 === void 0 ? EMPTY_ARRAY$a : t1, {
    t
  } = useTranslation(commentsLocaleNamespace), [value, setValue] = useState(EMPTY_ARRAY$a), [collapsed, setCollapsed] = useState(!0), replyInputRef = useRef(null), {
    isTopLayer
  } = useLayer();
  let t2;
  $[0] !== value ? (t2 = hasCommentMessageValue(value), $[0] = value, $[1] = t2) : t2 = $[1];
  const hasValue2 = t2, [mouseOver, setMouseOver] = useState(!1);
  let t3;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setMouseOver(!0), $[2] = t3) : t3 = $[2];
  const handleMouseEnter = t3;
  let t4;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => setMouseOver(!1), $[3] = t4) : t4 = $[3];
  const handleMouseLeave = t4;
  let t5;
  $[4] !== onReply || $[5] !== parentComment._id || $[6] !== parentComment.status || $[7] !== parentComment.target.path?.field || $[8] !== parentComment.threadId || $[9] !== value ? (t5 = () => {
    const nextComment = {
      message: value,
      parentCommentId: parentComment._id,
      status: parentComment?.status || "open",
      threadId: parentComment.threadId,
      reactions: EMPTY_ARRAY$a,
      payload: {
        fieldPath: parentComment.target.path?.field || ""
      }
    };
    onReply?.(nextComment), setValue(EMPTY_ARRAY$a);
  }, $[4] = onReply, $[5] = parentComment._id, $[6] = parentComment.status, $[7] = parentComment.target.path?.field, $[8] = parentComment.threadId, $[9] = value, $[10] = t5) : t5 = $[10];
  const handleReplySubmit = t5;
  let t6;
  $[11] !== hasValue2 ? (t6 = () => {
    if (!hasValue2) {
      setValue(EMPTY_ARRAY$a);
      return;
    }
    replyInputRef.current?.discardDialogController.open();
  }, $[11] = hasValue2, $[12] = t6) : t6 = $[12];
  const startDiscard = t6;
  let t7;
  $[13] !== startDiscard ? (t7 = (event) => {
    event.isDefaultPrevented() || event.key === "Escape" && (event.preventDefault(), event.stopPropagation(), startDiscard());
  }, $[13] = startDiscard, $[14] = t7) : t7 = $[14];
  const handleInputKeyDown = t7;
  let t8;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = () => {
    replyInputRef.current?.discardDialogController.close();
  }, $[15] = t8) : t8 = $[15];
  const cancelDiscard = t8;
  let t9;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = () => {
    setValue(EMPTY_ARRAY$a), replyInputRef.current?.discardDialogController.close(), replyInputRef.current?.focus();
  }, $[16] = t9) : t9 = $[16];
  const confirmDiscard = t9;
  let t10;
  $[17] !== isTopLayer || $[18] !== onPathSelect || $[19] !== parentComment.target.path?.field || $[20] !== parentComment.threadId ? (t10 = (e) => {
    e.stopPropagation(), isTopLayer && onPathSelect?.({
      fieldPath: parentComment.target.path?.field || "",
      origin: "inspector",
      threadId: parentComment.threadId
    });
  }, $[17] = isTopLayer, $[18] = onPathSelect, $[19] = parentComment.target.path?.field, $[20] = parentComment.threadId, $[21] = t10) : t10 = $[21];
  const handleThreadRootClick = t10;
  let t11;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = (e_0) => {
    e_0.stopPropagation(), setCollapsed(!1);
  }, $[22] = t11) : t11 = $[22];
  const handleExpand = t11;
  let t12;
  bb0: {
    if (collapsed) {
      let t132;
      $[23] !== replies ? (t132 = replies?.slice(-MAX_COLLAPSED_REPLIES), $[23] = replies, $[24] = t132) : t132 = $[24], t12 = t132;
      break bb0;
    }
    t12 = replies;
  }
  const splicedReplies = t12;
  let t13;
  bb1: {
    if (!replies) {
      t13 = !1;
      break bb1;
    }
    t13 = replies.length > MAX_COLLAPSED_REPLIES;
  }
  const showCollapseButton = t13, expandButtonText = `${replies?.length - MAX_COLLAPSED_REPLIES} more ${replies?.length - MAX_COLLAPSED_REPLIES === 1 ? "comment" : "comments"}`, t14 = isSelected ? "true" : "false", t15 = mouseOver ? "true" : "false";
  let t16;
  $[25] !== t ? (t16 = t("list-item.go-to-field-button.aria-label"), $[25] = t, $[26] = t16) : t16 = $[26];
  let t17;
  $[27] !== t16 ? (t17 = /* @__PURE__ */ jsx(GhostButton, { "data-ui": "GhostButton", "aria-label": t16 }), $[27] = t16, $[28] = t17) : t17 = $[28];
  const t18 = canReply ? void 0 : 1;
  let t19;
  $[29] !== parentComment._id ? (t19 = applyCommentIdAttr(parentComment._id), $[29] = parentComment._id, $[30] = t19) : t19 = $[30];
  const t20 = parentComment.authorId === currentUser.id, t21 = parentComment.authorId === currentUser.id, t22 = parentComment._state?.type === "createError", t23 = parentComment.context?.intent, t24 = parentComment._state?.type === "createRetrying";
  let t25;
  $[31] !== avatarConfig.avatarSize || $[32] !== avatarConfig.parentCommentAvatar || $[33] !== currentUser || $[34] !== hasReferencedValue || $[35] !== mentionOptions || $[36] !== mode || $[37] !== onCopyLink || $[38] !== onCreateRetry || $[39] !== onDelete || $[40] !== onEdit || $[41] !== onKeyDown || $[42] !== onReactionSelect || $[43] !== onStatusChange || $[44] !== parentComment || $[45] !== readOnly || $[46] !== t20 || $[47] !== t21 || $[48] !== t22 || $[49] !== t23 || $[50] !== t24 ? (t25 = /* @__PURE__ */ jsx(CommentsListItemLayout, { avatarSize: avatarConfig.avatarSize, canDelete: t20, canEdit: t21, comment: parentComment, currentUser, hasError: t22, hasReferencedValue, intent: t23, isParent: !0, isRetrying: t24, mentionOptions, mode, onCopyLink, onCreateRetry, onDelete, onEdit, onInputKeyDown: onKeyDown, onReactionSelect, onStatusChange, readOnly, withAvatar: avatarConfig.parentCommentAvatar }), $[31] = avatarConfig.avatarSize, $[32] = avatarConfig.parentCommentAvatar, $[33] = currentUser, $[34] = hasReferencedValue, $[35] = mentionOptions, $[36] = mode, $[37] = onCopyLink, $[38] = onCreateRetry, $[39] = onDelete, $[40] = onEdit, $[41] = onKeyDown, $[42] = onReactionSelect, $[43] = onStatusChange, $[44] = parentComment, $[45] = readOnly, $[46] = t20, $[47] = t21, $[48] = t22, $[49] = t23, $[50] = t24, $[51] = t25) : t25 = $[51];
  let t26;
  $[52] !== t19 || $[53] !== t25 ? (t26 = /* @__PURE__ */ jsx(Stack, { as: "li", ...t19, children: t25 }), $[52] = t19, $[53] = t25, $[54] = t26) : t26 = $[54];
  let t27;
  $[55] !== collapsed || $[56] !== expandButtonText || $[57] !== showCollapseButton ? (t27 = showCollapseButton && collapsed && /* @__PURE__ */ jsxs(Flex, { gap: 1, paddingY: 1, sizing: "border", children: [
    /* @__PURE__ */ jsx(SpacerAvatar, {}),
    /* @__PURE__ */ jsx(ExpandButton, { iconRight: ChevronDownIcon, mode: "bleed", onClick: handleExpand, text: expandButtonText })
  ] }), $[55] = collapsed, $[56] = expandButtonText, $[57] = showCollapseButton, $[58] = t27) : t27 = $[58];
  let t28;
  if ($[59] !== avatarConfig.avatarSize || $[60] !== avatarConfig.threadCommentsAvatar || $[61] !== currentUser || $[62] !== handleInputKeyDown || $[63] !== mentionOptions || $[64] !== mode || $[65] !== onCopyLink || $[66] !== onCreateRetry || $[67] !== onDelete || $[68] !== onEdit || $[69] !== onReactionSelect || $[70] !== parentComment || $[71] !== readOnly || $[72] !== splicedReplies) {
    let t292;
    $[74] !== avatarConfig.avatarSize || $[75] !== avatarConfig.threadCommentsAvatar || $[76] !== currentUser || $[77] !== handleInputKeyDown || $[78] !== mentionOptions || $[79] !== mode || $[80] !== onCopyLink || $[81] !== onCreateRetry || $[82] !== onDelete || $[83] !== onEdit || $[84] !== onReactionSelect || $[85] !== parentComment || $[86] !== readOnly ? (t292 = (reply) => /* @__PURE__ */ jsx(Stack, { as: "li", ...applyCommentIdAttr(reply._id), children: /* @__PURE__ */ jsx(CommentsListItemLayout, { avatarSize: avatarConfig.avatarSize, canDelete: reply.authorId === currentUser.id, canEdit: reply.authorId === currentUser.id, comment: reply, currentUser, hasError: reply._state?.type === "createError", isRetrying: reply._state?.type === "createRetrying", intent: commentIntentIfDiffers(parentComment, reply), mentionOptions, mode, onCopyLink, onCreateRetry, onDelete, onEdit, onInputKeyDown: handleInputKeyDown, onReactionSelect, readOnly, withAvatar: avatarConfig.threadCommentsAvatar }) }, reply._id), $[74] = avatarConfig.avatarSize, $[75] = avatarConfig.threadCommentsAvatar, $[76] = currentUser, $[77] = handleInputKeyDown, $[78] = mentionOptions, $[79] = mode, $[80] = onCopyLink, $[81] = onCreateRetry, $[82] = onDelete, $[83] = onEdit, $[84] = onReactionSelect, $[85] = parentComment, $[86] = readOnly, $[87] = t292) : t292 = $[87], t28 = splicedReplies.map(t292), $[59] = avatarConfig.avatarSize, $[60] = avatarConfig.threadCommentsAvatar, $[61] = currentUser, $[62] = handleInputKeyDown, $[63] = mentionOptions, $[64] = mode, $[65] = onCopyLink, $[66] = onCreateRetry, $[67] = onDelete, $[68] = onEdit, $[69] = onReactionSelect, $[70] = parentComment, $[71] = readOnly, $[72] = splicedReplies, $[73] = t28;
  } else
    t28 = $[73];
  let t29;
  $[88] !== avatarConfig.avatarSize || $[89] !== avatarConfig.replyAvatar || $[90] !== canReply || $[91] !== currentUser || $[92] !== handleInputKeyDown || $[93] !== handleReplySubmit || $[94] !== mentionOptions || $[95] !== mode || $[96] !== readOnly || $[97] !== t || $[98] !== value ? (t29 = canReply && /* @__PURE__ */ jsx(CommentInput, { avatarSize: avatarConfig.avatarSize, currentUser, expandOnFocus: !0, mentionOptions, onChange: setValue, onDiscardCancel: cancelDiscard, onDiscardConfirm: confirmDiscard, onKeyDown: handleInputKeyDown, onSubmit: handleReplySubmit, placeholder: t(mode === "upsell" ? "compose.reply-placeholder-upsell" : "compose.reply-placeholder"), readOnly: readOnly || mode === "upsell", ref: replyInputRef, value, withAvatar: avatarConfig.replyAvatar }), $[88] = avatarConfig.avatarSize, $[89] = avatarConfig.replyAvatar, $[90] = canReply, $[91] = currentUser, $[92] = handleInputKeyDown, $[93] = handleReplySubmit, $[94] = mentionOptions, $[95] = mode, $[96] = readOnly, $[97] = t, $[98] = value, $[99] = t29) : t29 = $[99];
  let t30;
  $[100] !== innerPadding || $[101] !== t18 || $[102] !== t26 || $[103] !== t27 || $[104] !== t28 || $[105] !== t29 ? (t30 = /* @__PURE__ */ jsxs(Stack, { as: "ul", padding: innerPadding, paddingBottom: t18, space: 4, children: [
    t26,
    t27,
    t28,
    t29
  ] }), $[100] = innerPadding, $[101] = t18, $[102] = t26, $[103] = t27, $[104] = t28, $[105] = t29, $[106] = t30) : t30 = $[106];
  let t31;
  return $[107] !== handleThreadRootClick || $[108] !== t14 || $[109] !== t15 || $[110] !== t17 || $[111] !== t30 ? (t31 = /* @__PURE__ */ jsxs(StyledThreadCard, { "data-active": t14, "data-hovered": t15, "data-testid": "comments-list-item", "data-ui": "CommentsListItem", onClick: handleThreadRootClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: [
    t17,
    t30
  ] }), $[107] = handleThreadRootClick, $[108] = t14, $[109] = t15, $[110] = t17, $[111] = t30, $[112] = t31) : t31 = $[112], t31;
});
CommentsListItem.displayName = "Memo(CommentsListItem)";
function getEmptyStateMessages(t) {
  return {
    open: {
      title: t("list-status.empty-state-open-title"),
      message: t("list-status.empty-state-open-text")
    },
    resolved: {
      title: t("list-status.empty-state-resolved-title"),
      message: t("list-status.empty-state-resolved-text")
    }
  };
}
function CommentsListStatus(props2) {
  const $ = c(17), {
    status,
    error,
    loading,
    hasNoComments
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] !== t ? (t0 = getEmptyStateMessages(t), $[0] = t, $[1] = t0) : t0 = $[1];
  const emptyStateMessages = t0;
  if (error) {
    let t1;
    $[2] !== t ? (t1 = t("list-status.error"), $[2] = t, $[3] = t1) : t1 = $[3];
    let t2;
    return $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", flex: 1, padding: 4, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t1 }) }) }), $[4] = t1, $[5] = t2) : t2 = $[5], t2;
  }
  if (loading) {
    let t1;
    $[6] !== t ? (t1 = t("list-status.loading"), $[6] = t, $[7] = t1) : t1 = $[7];
    let t2;
    return $[8] !== t1 ? (t2 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0, title: t1 }), $[8] = t1, $[9] = t2) : t2 = $[9], t2;
  }
  if (hasNoComments) {
    const t1 = emptyStateMessages[status];
    let t2;
    $[10] !== t1.title ? (t2 = /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, muted: !0, weight: "medium", children: t1.title }), $[10] = t1.title, $[11] = t2) : t2 = $[11];
    const t3 = emptyStateMessages[status];
    let t4;
    $[12] !== t3.message ? (t4 = /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, muted: !0, children: t3.message }), $[12] = t3.message, $[13] = t4) : t4 = $[13];
    let t5;
    return $[14] !== t2 || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", flex: 1, sizing: "border", children: /* @__PURE__ */ jsx(Container$3, { width: 0, padding: 4, children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      t2,
      t4
    ] }) }) }), $[14] = t2, $[15] = t4, $[16] = t5) : t5 = $[16], t5;
  }
  return null;
}
const EMPTY_PT_ARRAY = [];
function CreateNewThreadInput(props2) {
  const $ = c(26), {
    currentUser,
    fieldTitle,
    mentionOptions,
    mode,
    onBlur,
    onFocus,
    onKeyDown,
    onNewThreadCreate,
    readOnly
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace), [value, setValue] = useState(EMPTY_PT_ARRAY), commentInputHandle = useRef(null);
  let t0;
  $[0] !== onNewThreadCreate || $[1] !== value ? (t0 = () => {
    onNewThreadCreate?.(value), setValue(EMPTY_PT_ARRAY);
  }, $[0] = onNewThreadCreate, $[1] = value, $[2] = t0) : t0 = $[2];
  const handleSubmit = t0;
  let t1;
  $[3] !== value ? (t1 = hasCommentMessageValue(value), $[3] = value, $[4] = t1) : t1 = $[4];
  const hasValue2 = t1;
  let t2;
  $[5] !== hasValue2 ? (t2 = () => {
    hasValue2 && commentInputHandle.current?.discardDialogController.open();
  }, $[5] = hasValue2, $[6] = t2) : t2 = $[6];
  const startDiscard = t2;
  let t3;
  $[7] !== onKeyDown || $[8] !== startDiscard ? (t3 = (event) => {
    event.isDefaultPrevented() || (event.key === "Escape" && (event.preventDefault(), event.stopPropagation(), startDiscard()), onKeyDown && onKeyDown(event));
  }, $[7] = onKeyDown, $[8] = startDiscard, $[9] = t3) : t3 = $[9];
  const handleInputKeyDown = t3;
  let t4;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setValue(EMPTY_PT_ARRAY), commentInputHandle.current?.discardDialogController.close(), commentInputHandle.current?.focus();
  }, $[10] = t4) : t4 = $[10];
  const confirmDiscard = t4;
  let t5;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    commentInputHandle.current?.discardDialogController.close();
  }, $[11] = t5) : t5 = $[11];
  const cancelDiscard = t5;
  let t6;
  $[12] !== fieldTitle || $[13] !== mode || $[14] !== t ? (t6 = mode === "upsell" ? t("compose.add-comment-input-placeholder-upsell") : /* @__PURE__ */ jsx(Translate, { t, i18nKey: "compose.add-comment-input-placeholder", values: {
    field: fieldTitle
  } }), $[12] = fieldTitle, $[13] = mode, $[14] = t, $[15] = t6) : t6 = $[15];
  const placeholder = t6, t7 = readOnly || mode === "upsell";
  let t8;
  return $[16] !== currentUser || $[17] !== handleInputKeyDown || $[18] !== handleSubmit || $[19] !== mentionOptions || $[20] !== onBlur || $[21] !== onFocus || $[22] !== placeholder || $[23] !== t7 || $[24] !== value ? (t8 = /* @__PURE__ */ jsx(CommentInput, { currentUser, expandOnFocus: !0, mentionOptions, onBlur, onChange: setValue, onDiscardCancel: cancelDiscard, onDiscardConfirm: confirmDiscard, onKeyDown: handleInputKeyDown, onFocus, onSubmit: handleSubmit, placeholder, readOnly: t7, ref: commentInputHandle, value }), $[16] = currentUser, $[17] = handleInputKeyDown, $[18] = handleSubmit, $[19] = mentionOptions, $[20] = onBlur, $[21] = onFocus, $[22] = placeholder, $[23] = t7, $[24] = value, $[25] = t8) : t8 = $[25], t8;
}
const HeaderFlex$3 = styled(Flex).withConfig({
  displayName: "HeaderFlex",
  componentId: "sc-17u7b8x-0"
})`min-height:25px;`, BreadcrumbsButton = /* @__PURE__ */ styled(Button$1).withConfig({
  displayName: "BreadcrumbsButton",
  componentId: "sc-17u7b8x-1"
})(({
  theme
}) => {
  const fg = theme.sanity.color.base.fg;
  return css`
    --card-fg-color: ${fg};

    // The width is needed to make the text ellipsis work
    // in the breadcrumbs component
    max-width: 100%;
  `;
});
function CommentThreadLayout(props2) {
  const $ = c(36), {
    breadcrumbs,
    canCreateNewThread,
    children,
    currentUser,
    fieldPath,
    isSelected,
    mentionOptions,
    mode,
    onNewThreadCreate,
    onPathSelect,
    readOnly
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] !== fieldPath || $[1] !== onNewThreadCreate ? (t0 = (payload) => {
    const nextComment = {
      message: payload,
      parentCommentId: void 0,
      status: "open",
      threadId: uuid(),
      reactions: [],
      payload: {
        fieldPath
      }
    };
    onNewThreadCreate?.(nextComment);
  }, $[0] = fieldPath, $[1] = onNewThreadCreate, $[2] = t0) : t0 = $[2];
  const handleNewThreadCreate = t0;
  let t1;
  $[3] !== fieldPath || $[4] !== onPathSelect ? (t1 = (e) => {
    e.stopPropagation(), onPathSelect?.({
      fieldPath,
      origin: "inspector",
      threadId: null
    });
  }, $[3] = fieldPath, $[4] = onPathSelect, $[5] = t1) : t1 = $[5];
  const handleBreadcrumbsClick = t1;
  let t2;
  $[6] !== fieldPath || $[7] !== onPathSelect ? (t2 = (e_0) => {
    e_0.stopPropagation(), e_0.detail !== 0 && onPathSelect?.({
      fieldPath,
      origin: "inspector",
      threadId: null
    });
  }, $[6] = fieldPath, $[7] = onPathSelect, $[8] = t2) : t2 = $[8];
  const handleNewThreadClick = t2;
  let t3;
  $[9] !== breadcrumbs ? (t3 = breadcrumbs?.map(_temp$13) || [], $[9] = breadcrumbs, $[10] = t3) : t3 = $[10];
  const crumbsTitlePath = t3, lastCrumb = crumbsTitlePath[crumbsTitlePath.length - 1];
  let t4;
  $[11] !== lastCrumb || $[12] !== t ? (t4 = t("list-item.breadcrumb-button-go-to-field-aria-label", {
    field: lastCrumb
  }), $[11] = lastCrumb, $[12] = t, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== crumbsTitlePath ? (t5 = /* @__PURE__ */ jsx(CommentBreadcrumbs, { maxLength: 3, titlePath: crumbsTitlePath }), $[14] = crumbsTitlePath, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== handleBreadcrumbsClick || $[17] !== t4 || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsx(HeaderFlex$3, { align: "center", gap: 2, paddingRight: 1, sizing: "border", children: /* @__PURE__ */ jsx(Stack, { flex: 1, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(BreadcrumbsButton, { "aria-label": t4, mode: "bleed", onClick: handleBreadcrumbsClick, padding: 2, space: 2, children: t5 }) }) }) }), $[16] = handleBreadcrumbsClick, $[17] = t4, $[18] = t5, $[19] = t6) : t6 = $[19];
  let t7;
  $[20] !== canCreateNewThread || $[21] !== currentUser || $[22] !== handleNewThreadClick || $[23] !== handleNewThreadCreate || $[24] !== isSelected || $[25] !== lastCrumb || $[26] !== mentionOptions || $[27] !== mode || $[28] !== readOnly ? (t7 = canCreateNewThread && /* @__PURE__ */ jsx(ThreadCard, { onClick: handleNewThreadClick, "data-active": isSelected, children: /* @__PURE__ */ jsx(CreateNewThreadInput, { currentUser, fieldTitle: lastCrumb, mentionOptions, mode, onNewThreadCreate: handleNewThreadCreate, readOnly }) }), $[20] = canCreateNewThread, $[21] = currentUser, $[22] = handleNewThreadClick, $[23] = handleNewThreadCreate, $[24] = isSelected, $[25] = lastCrumb, $[26] = mentionOptions, $[27] = mode, $[28] = readOnly, $[29] = t7) : t7 = $[29];
  let t8;
  $[30] !== children ? (t8 = /* @__PURE__ */ jsx(Stack, { space: 2, children }), $[30] = children, $[31] = t8) : t8 = $[31];
  let t9;
  return $[32] !== t6 || $[33] !== t7 || $[34] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t6,
    t7,
    t8
  ] }), $[32] = t6, $[33] = t7, $[34] = t8, $[35] = t9) : t9 = $[35], t9;
}
function _temp$13(p) {
  return p.title;
}
function groupThreads(comments2) {
  return comments2.reduce((acc, comment) => {
    const field = comment.fieldPath;
    return acc[field] || (acc[field] = []), acc[field].push(comment), acc;
  }, {});
}
const CommentsListInner = forwardRef(function(props2, ref) {
  const $ = c(32), {
    beforeListNode,
    comments: comments2,
    currentUser,
    error,
    loading,
    mentionOptions,
    mode,
    onCopyLink,
    onCreateRetry,
    onDelete,
    onEdit,
    onNewThreadCreate,
    onPathSelect,
    onReactionSelect,
    onReply,
    onStatusChange,
    readOnly,
    selectedPath,
    status
  } = props2, [boundaryElement, setBoundaryElement] = useState(null);
  let t0;
  $[0] !== comments2 ? (t0 = Object.entries(groupThreads(comments2)), $[0] = comments2, $[1] = t0) : t0 = $[1];
  const groupedThreads = t0, showComments = !loading && !error && groupedThreads.length > 0;
  let t1;
  $[2] !== error || $[3] !== groupedThreads || $[4] !== loading || $[5] !== mode || $[6] !== status ? (t1 = mode !== "upsell" && /* @__PURE__ */ jsx(CommentsListStatus, { error, hasNoComments: groupedThreads.length === 0, loading, status }), $[2] = error, $[3] = groupedThreads, $[4] = loading, $[5] = mode, $[6] = status, $[7] = t1) : t1 = $[7];
  let t2;
  $[8] !== beforeListNode || $[9] !== boundaryElement || $[10] !== currentUser || $[11] !== groupedThreads || $[12] !== mentionOptions || $[13] !== mode || $[14] !== onCopyLink || $[15] !== onCreateRetry || $[16] !== onDelete || $[17] !== onEdit || $[18] !== onNewThreadCreate || $[19] !== onPathSelect || $[20] !== onReactionSelect || $[21] !== onReply || $[22] !== onStatusChange || $[23] !== readOnly || $[24] !== ref || $[25] !== selectedPath || $[26] !== showComments || $[27] !== status ? (t2 = (showComments || beforeListNode) && /* @__PURE__ */ jsxs(Stack, { as: "ul", flex: 1, overflow: "auto", padding: 3, paddingTop: 1, paddingBottom: 6, sizing: "border", space: 1, ref, children: [
    beforeListNode,
    /* @__PURE__ */ jsx(BoundaryElementProvider, { element: boundaryElement, children: groupedThreads?.map((t32) => {
      const [fieldPath, group2] = t32, breadcrumbs = group2[0].breadcrumbs, firstThreadId = group2[0].threadId, newThreadSelected = selectedPath?.fieldPath === fieldPath && !selectedPath.threadId;
      return /* @__PURE__ */ jsx(Stack, { as: "li", paddingTop: 3, ...applyCommentsGroupAttr(firstThreadId), children: /* @__PURE__ */ jsx(CommentThreadLayout, { breadcrumbs, canCreateNewThread: status === "open", currentUser, fieldPath, isSelected: newThreadSelected, mentionOptions, mode, onNewThreadCreate, onPathSelect, readOnly, children: group2.map((item) => {
        const replies = item.replies.slice().reverse(), canReply = status === "open" && item.parentComment._state?.type !== "createError" && item.parentComment._state?.type !== "createRetrying", threadIsSelected = selectedPath?.threadId === item.parentComment.threadId && selectedPath?.fieldPath === item.parentComment.target.path?.field;
        return /* @__PURE__ */ jsx(CommentsListItem, { canReply, currentUser, hasReferencedValue: item.hasReferencedValue, isSelected: threadIsSelected, mentionOptions, mode, onCopyLink, onCreateRetry, onDelete, onEdit, onPathSelect, onReactionSelect, onReply, onStatusChange, parentComment: item.parentComment, readOnly, replies }, item.parentComment._id);
      }) }, fieldPath) }, fieldPath);
    }) })
  ] }), $[8] = beforeListNode, $[9] = boundaryElement, $[10] = currentUser, $[11] = groupedThreads, $[12] = mentionOptions, $[13] = mode, $[14] = onCopyLink, $[15] = onCreateRetry, $[16] = onDelete, $[17] = onEdit, $[18] = onNewThreadCreate, $[19] = onPathSelect, $[20] = onReactionSelect, $[21] = onReply, $[22] = onStatusChange, $[23] = readOnly, $[24] = ref, $[25] = selectedPath, $[26] = showComments, $[27] = status, $[28] = t2) : t2 = $[28];
  let t3;
  return $[29] !== t1 || $[30] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Flex, { "data-testid": "comments-list", direction: "column", flex: 1, height: "fill", overflow: "hidden", ref: setBoundaryElement, sizing: "border", children: [
    t1,
    t2
  ] }), $[29] = t1, $[30] = t2, $[31] = t3) : t3 = $[31], t3;
}), CommentsList = memo(CommentsListInner), Root$c = styled(Box).withConfig({
  displayName: "Root",
  componentId: "sc-1frwq5h-0"
})`max-width:280px;`, fadeInKeyFrame = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`, StyledPopover$2 = styled(Popover).withConfig({
  displayName: "StyledPopover",
  componentId: "sc-1frwq5h-1"
})`opacity:0;animation:${fadeInKeyFrame} 200ms 500ms forwards;`;
function CommentsOnboardingPopover(props2) {
  const $ = c(23);
  let onDismiss, rest;
  $[0] !== props2 ? ({
    onDismiss,
    ...rest
  } = props2, $[0] = props2, $[1] = onDismiss, $[2] = rest) : (onDismiss = $[1], rest = $[2]);
  const {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[3] !== t ? (t0 = t("onboarding.header"), $[3] = t, $[4] = t0) : t0 = $[4];
  let t1;
  $[5] !== t0 ? (t1 = /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: t0 }), $[5] = t0, $[6] = t1) : t1 = $[6];
  let t2;
  $[7] !== t ? (t2 = t("onboarding.body"), $[7] = t, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t2 }), $[9] = t2, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== t ? (t4 = t("onboarding.dismiss"), $[11] = t, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== onDismiss || $[14] !== t4 ? (t5 = /* @__PURE__ */ jsx(Flex, { justify: "flex-end", marginTop: 2, children: /* @__PURE__ */ jsx(Button, { text: t4, tone: "primary", onClick: onDismiss }) }), $[13] = onDismiss, $[14] = t4, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== t1 || $[17] !== t3 || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsx(Root$c, { padding: 4, children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t1,
    t3,
    t5
  ] }) }), $[16] = t1, $[17] = t3, $[18] = t5, $[19] = t6) : t6 = $[19];
  let t7;
  return $[20] !== rest || $[21] !== t6 ? (t7 = /* @__PURE__ */ jsx(StyledPopover$2, { content: t6, open: !0, portal: !0, ...rest }), $[20] = rest, $[21] = t6, $[22] = t7) : t7 = $[22], t7;
}
function CommentsUpsellPanel(props2) {
  const $ = c(4), {
    data,
    onPrimaryClick,
    onSecondaryClick
  } = props2;
  let t0;
  return $[0] !== data || $[1] !== onPrimaryClick || $[2] !== onSecondaryClick ? (t0 = /* @__PURE__ */ jsx(Container$3, { width: 1, children: /* @__PURE__ */ jsx(Box, { marginBottom: 6, children: /* @__PURE__ */ jsx(UpsellPanel, { data, onPrimaryClick, onSecondaryClick }) }) }), $[0] = data, $[1] = onPrimaryClick, $[2] = onSecondaryClick, $[3] = t0) : t0 = $[3], t0;
}
const DMP_MARGIN = 15;
function diffText(current, next) {
  const diff = makeDiff(current, next), diffs = cleanupEfficiency(diff), levenshtein = diffsLevenshtein(diffs);
  return {
    patches: makePatches(current, diffs, {
      margin: DMP_MARGIN
    }),
    levenshtein
  };
}
function diffApply(current, patches) {
  return applyPatches(patches, current, {
    allowExceedingIndices: !0,
    margin: DMP_MARGIN
  })[0];
}
const CHILD_SYMBOL = "\uF0D0";
function toPlainTextWithChildSeparators(inputBlock) {
  return inputBlock.children.map((child) => isPortableTextSpan(child) ? child.text.replaceAll(CHILD_SYMBOL, " ") : "").join(CHILD_SYMBOL);
}
const COMMENT_INDICATORS = ["\uF000", "\uF001"], COMMENT_INDICATORS_REGEX = new RegExp(`[${COMMENT_INDICATORS.join("")}]`, "g"), EMPTY_ARRAY$9 = [];
function buildRangeDecorationSelectionsFromComments(props2) {
  const {
    value,
    comments: comments2
  } = props2;
  if (!value || value.length === 0) return EMPTY_ARRAY$9;
  const textSelections = comments2.filter(isTextSelectionComment), decorators = [];
  return textSelections.forEach((comment) => {
    comment.target.path?.selection?.value.forEach((selectionMember) => {
      const matchedBlock = value.find((block) => block._key === selectionMember._key);
      if (!matchedBlock || !isPortableTextTextBlock(matchedBlock))
        return;
      const selectionText = selectionMember.text.replaceAll(COMMENT_INDICATORS_REGEX, ""), textWithChildSeparators = toPlainTextWithChildSeparators(matchedBlock), {
        patches
      } = diffText(selectionText, selectionMember.text), diffedText = diffApply(textWithChildSeparators, patches), startIndex = diffedText.indexOf(COMMENT_INDICATORS[0]), endIndex = diffedText.replaceAll(COMMENT_INDICATORS[0], "").indexOf(COMMENT_INDICATORS[1]), textWithoutCommentTags = diffedText.replaceAll(COMMENT_INDICATORS_REGEX, ""), oldCommentedText = selectionMember.text.slice(selectionMember.text.indexOf(COMMENT_INDICATORS[0]) + 1, selectionMember.text.indexOf(COMMENT_INDICATORS[1])), newCommentedText = textWithoutCommentTags.slice(startIndex, endIndex), {
        levenshtein
      } = diffText(newCommentedText, oldCommentedText), threshold = Math.round(newCommentedText.length + oldCommentedText.length / 2);
      let nullSelection = !1;
      if (newCommentedText.length === 0 && (nullSelection = !0), levenshtein > threshold && (nullSelection = !0), startIndex + 1 === endIndex && (nullSelection = !0), startIndex !== -1 && endIndex !== -1) {
        let childIndexAnchor = 0, anchorOffset = 0, childIndexFocus = 0, focusOffset = 0;
        for (let i = 0; i < textWithoutCommentTags.length && (textWithoutCommentTags[i] === CHILD_SYMBOL && (i <= startIndex && (anchorOffset = -1, childIndexAnchor++), focusOffset = -1, childIndexFocus++), i < startIndex && anchorOffset++, i < startIndex + newCommentedText.length && focusOffset++, i !== startIndex + newCommentedText.length); i++)
          ;
        decorators.push({
          selection: {
            anchor: {
              path: [{
                _key: matchedBlock._key
              }, "children", {
                _key: matchedBlock.children[childIndexAnchor]._key
              }],
              offset: anchorOffset
            },
            focus: {
              path: [{
                _key: matchedBlock._key
              }, "children", {
                _key: matchedBlock.children[childIndexFocus]._key
              }],
              offset: focusOffset
            }
          },
          comment,
          range: {
            _key: matchedBlock._key,
            text: nullSelection ? "" : diffedText
          }
        });
      }
    });
  }), decorators.length === 0 ? EMPTY_ARRAY$9 : decorators;
}
function diffsLevenshtein(diffs) {
  let levenshtein = 0, insertions = 0, deletions = 0;
  for (let x = 0; x < diffs.length; x++) {
    const op = diffs[x][0], data = diffs[x][1];
    switch (op) {
      case DIFF_INSERT:
        insertions += data.length;
        break;
      case DIFF_DELETE:
        deletions += data.length;
        break;
      case DIFF_EQUAL:
        levenshtein += Math.max(insertions, deletions), insertions = 0, deletions = 0;
        break;
    }
  }
  return levenshtein += Math.max(insertions, deletions), levenshtein;
}
const CommentRangeDecoration = memo(function(props2) {
  const $ = c(20), {
    children,
    commentId,
    currentHoveredCommentId,
    onClick: onClick2,
    onHoverEnd,
    onHoverStart,
    selectedThreadId,
    threadId
  } = props2, decoratorRef = useRef(null), [isNested, setIsNested] = useState(!1), [parentCommentId, setParentCommentId] = useState(null);
  let t0, t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    const prevEl = decoratorRef.current?.previousSibling, nextEl = decoratorRef.current?.nextSibling;
    if (!prevEl || !nextEl) {
      setIsNested(!1);
      return;
    }
    const [key] = Object.keys(applyInlineCommentIdAttr("")), prevId = prevEl.getAttribute(key), nextId = nextEl.getAttribute(key), isNestedDecorator = !!(prevId && nextId && prevId === nextId);
    setParentCommentId(isNestedDecorator ? prevId : null), setIsNested(isNestedDecorator);
  }, t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useEffect(t0, t1);
  let t2;
  $[2] !== commentId || $[3] !== onHoverStart ? (t2 = () => onHoverStart(commentId), $[2] = commentId, $[3] = onHoverStart, $[4] = t2) : t2 = $[4];
  const handleMouseEnter = t2;
  let t3;
  $[5] !== onHoverEnd ? (t3 = () => onHoverEnd(null), $[5] = onHoverEnd, $[6] = t3) : t3 = $[6];
  const handleMouseLeave = t3;
  let t4;
  $[7] !== commentId || $[8] !== onClick2 ? (t4 = () => onClick2(commentId), $[7] = commentId, $[8] = onClick2, $[9] = t4) : t4 = $[9];
  const handleClick = t4, t5 = currentHoveredCommentId === commentId || currentHoveredCommentId === parentCommentId && isNested || selectedThreadId === threadId;
  let t6;
  $[10] !== threadId ? (t6 = applyInlineCommentIdAttr(threadId), $[10] = threadId, $[11] = t6) : t6 = $[11];
  let t7;
  return $[12] !== children || $[13] !== handleClick || $[14] !== handleMouseEnter || $[15] !== handleMouseLeave || $[16] !== isNested || $[17] !== t5 || $[18] !== t6 ? (t7 = /* @__PURE__ */ jsx(CommentInlineHighlightSpan, { isAdded: !0, isHovered: t5, isNested, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, ref: decoratorRef, ...t6, children }), $[12] = children, $[13] = handleClick, $[14] = handleMouseEnter, $[15] = handleMouseLeave, $[16] = isNested, $[17] = t5, $[18] = t6, $[19] = t7) : t7 = $[19], t7;
});
CommentRangeDecoration.displayName = "Memo(CommentRangeDecoration)";
function buildCommentRangeDecorations(props2) {
  const {
    comments: comments2,
    currentHoveredCommentId,
    onDecorationClick,
    onDecorationHoverEnd,
    onDecorationHoverStart,
    onDecorationMoved,
    selectedThreadId,
    value
  } = props2;
  return buildRangeDecorationSelectionsFromComments({
    comments: comments2,
    value
  }).map(({
    selection,
    comment,
    range: range2
  }) => ({
    component: ({
      children
    }) => /* @__PURE__ */ jsx(CommentRangeDecoration, { commentId: comment._id, currentHoveredCommentId, onClick: onDecorationClick, onHoverEnd: onDecorationHoverEnd, onHoverStart: onDecorationHoverStart, selectedThreadId, threadId: comment.threadId, children }),
    onMoved: onDecorationMoved,
    selection,
    payload: {
      commentId: comment._id,
      range: range2
    }
  }));
}
function buildTextSelectionFromFragment(props2) {
  const {
    fragment,
    value,
    selection
  } = props2;
  if (!selection)
    throw new Error("Selection is required");
  const normalizedSelection = selection.backward ? {
    anchor: selection.focus,
    focus: selection.anchor
  } : selection;
  return {
    type: "text",
    value: fragment.map((fragmentBlock) => {
      const originalBlock = value.find((b) => b._key === fragmentBlock._key);
      if (!isPortableTextTextBlock(originalBlock))
        return {
          _key: fragmentBlock._key,
          text: ""
        };
      const anchorBlockKey = isKeySegment(normalizedSelection.anchor.path[0]) && normalizedSelection.anchor.path[0]._key, focusBlockKey = isKeySegment(normalizedSelection.focus.path[0]) && normalizedSelection.focus.path[0]._key, fragmentBlockText = toPlainText$1([fragmentBlock]), fragmentStartSpan = isPortableTextTextBlock(fragmentBlock) ? fragmentBlock.children[0] : void 0, fragmentEndSpan = isPortableTextTextBlock(fragmentBlock) ? fragmentBlock.children[fragmentBlock.children.length - 1] : void 0;
      let originalTextBeforeSelection = "", startChildIndex = -1;
      if (anchorBlockKey === originalBlock._key)
        for (const child of originalBlock.children) {
          if (startChildIndex++, child._key === fragmentStartSpan?._key) {
            originalTextBeforeSelection += isPortableTextSpan(child) && child.text.slice(0, Math.max(0, normalizedSelection.anchor.offset)) || "";
            break;
          }
          originalTextBeforeSelection += child.text;
        }
      let originalTextAfterSelection = "";
      if (focusBlockKey === originalBlock._key)
        for (const child of originalBlock.children.slice(startChildIndex).reverse()) {
          if (child._key === fragmentEndSpan?._key) {
            originalTextAfterSelection = (isPortableTextSpan(child) && child.text.slice(normalizedSelection.focus.offset, child.text.length) || "") + originalTextAfterSelection;
            break;
          }
          originalTextAfterSelection = child.text + originalTextAfterSelection;
        }
      return {
        _key: originalBlock._key,
        text: `${originalTextBeforeSelection}${COMMENT_INDICATORS[0]}${fragmentBlockText}${COMMENT_INDICATORS[1]}${originalTextAfterSelection}`
      };
    })
  };
}
function mergeCommentReactions(reactionsA, reactionsB) {
  const mergedReactions = {};
  for (const reaction of reactionsA)
    mergedReactions[reaction._key] = {
      ...reaction
    };
  for (const reaction of reactionsB)
    mergedReactions[reaction._key] = {
      ...mergedReactions[reaction._key],
      ...reaction
    };
  return Object.values(mergedReactions);
}
const URL_REGEX = /\b(https?:\/\/[^\s,()]+(?:\.[^\s,()]+)*|www\.[^\s,()]+\.[^\s,()]{2,})\b/g;
function onClick(event) {
  event.stopPropagation();
}
function createLinkElement(url) {
  const href = url.startsWith("http") ? url : `https://${url}`;
  return /* @__PURE__ */ jsx("a", { href, target: "_blank", rel: "noopener noreferrer", onClick, children: url }, url);
}
const linkMiddleware = (node) => typeof node == "string" ? node.split(URL_REGEX).flatMap((part) => part.match(URL_REGEX) ? createLinkElement(part) : part) : node, middlewares = [linkMiddleware];
function transformChildren(node) {
  return Array.isArray(node) ? node.flatMap((item) => {
    let transformedItem = [item];
    for (const middleware2 of middlewares)
      transformedItem = transformedItem.flatMap(middleware2);
    return transformedItem;
  }) : node;
}
function weakenReferences(node) {
  if (node && typeof node == "object" && node.hasOwnProperty("_ref"))
    return {
      ...node,
      _weak: !0
    };
  if (Array.isArray(node))
    return node.map((item) => weakenReferences(item));
  if (node && typeof node == "object") {
    const result = {};
    return Object.keys(node).forEach((key) => {
      const value = node[key];
      typeof value == "object" && value !== null ? result[key] = weakenReferences(value) : result[key] = value;
    }), result;
  }
  return node;
}
function weakenReferencesInContentSnapshot(snapshot2) {
  return weakenReferences(snapshot2);
}
async function createOperation(props2) {
  const {
    activeTool,
    client,
    comment,
    currentUser,
    dataset,
    documentId,
    documentRevisionId,
    documentType,
    documentVersionId,
    getIntent,
    getNotificationValue,
    getThreadLength,
    onCreate,
    onCreateError,
    projectId,
    createAddonDataset,
    workspace
  } = props2, commentId = comment?.id || uuid(), authorId = currentUser.id, currentThreadLength = (getThreadLength?.(comment.threadId) || 0) + 1;
  let nextComment;
  if (comment.type === "task" && (nextComment = {
    _id: commentId,
    _type: "comment",
    authorId,
    message: comment.message,
    lastEditedAt: void 0,
    parentCommentId: comment.parentCommentId,
    status: comment.status,
    threadId: comment.threadId,
    reactions: comment.reactions,
    context: {
      payload: {
        workspace
      },
      notification: comment.context.notification,
      tool: activeTool?.name || ""
    },
    target: {
      document: {
        _ref: documentId,
        _type: "reference",
        _weak: !0
      },
      documentVersionId,
      documentType
    }
  }), comment.type === "field") {
    const {
      documentTitle = "",
      url = "",
      workspaceTitle = "",
      workspaceName = ""
    } = getNotificationValue({
      commentId
    }) || {}, notification = {
      currentThreadLength,
      documentTitle,
      url,
      workspaceTitle,
      workspaceName
    }, intent = getIntent?.({
      id: documentId,
      type: documentType,
      path: comment.fieldPath
    }), contentSnapshot = weakenReferencesInContentSnapshot(comment.contentSnapshot);
    nextComment = {
      _id: commentId,
      _type: "comment",
      authorId,
      message: comment.message,
      lastEditedAt: void 0,
      parentCommentId: comment.parentCommentId,
      status: comment.status,
      threadId: comment.threadId,
      reactions: comment.reactions,
      context: {
        payload: {
          workspace
        },
        intent,
        notification,
        tool: activeTool?.name || ""
      },
      contentSnapshot,
      target: {
        documentRevisionId: documentRevisionId || "",
        path: {
          field: comment.fieldPath,
          selection: comment.selection
        },
        document: {
          _dataset: dataset,
          _projectId: projectId,
          _ref: documentId,
          _type: "crossDatasetReference",
          _weak: !0
        },
        documentType,
        documentVersionId
      }
    };
  }
  if (nextComment) {
    if (onCreate?.(nextComment), !client) {
      try {
        const newAddonClient = await createAddonDataset();
        if (!newAddonClient)
          throw new Error("Failed to create addon dataset client");
        await newAddonClient.create(nextComment);
      } catch (err) {
        throw onCreateError?.(nextComment._id, err), err;
      }
      return;
    }
    try {
      await client.create(nextComment);
    } catch (err) {
      throw onCreateError?.(nextComment._id, err), err;
    }
  }
}
function createReactionKey(userId, shortName) {
  return `${userId}-${shortName}`;
}
async function reactOperation(props2) {
  const {
    client,
    currentUser,
    id: id2,
    reaction,
    getComment,
    onUpdate
  } = props2, reactions = getComment?.(id2)?.reactions || [], currentUserReactions = reactions.filter((r) => r.userId === currentUser.id), _key = createReactionKey(currentUser.id, reaction.shortName), currentReaction = currentUserReactions.find((r) => r._key === _key && r._optimisticState !== "removed");
  if (currentReaction) {
    const next = reactions.map((r) => r._key === currentReaction._key ? {
      ...r,
      _optimisticState: "removed"
    } : r);
    onUpdate?.(id2, {
      reactions: next
    }), await client.patch(id2).unset([`reactions[_key=="${_key}"]`]).commit();
    return;
  }
  if (!currentReaction) {
    const reactionItem = {
      _key,
      addedAt: (/* @__PURE__ */ new Date()).toISOString(),
      shortName: reaction.shortName,
      userId: currentUser.id
    }, optimisticReactionItem = {
      ...reactionItem,
      _optimisticState: "added"
    }, next = reactions.concat(optimisticReactionItem).filter((r) => !(r._key === reactionItem._key && r._optimisticState === "removed"));
    onUpdate?.(id2, {
      reactions: next
    }), await client.patch(id2).setIfMissing({
      reactions: []
    }).append("reactions", [reactionItem]).commit();
  }
}
async function removeOperation(props2) {
  const {
    client,
    id: id2,
    onRemove
  } = props2;
  onRemove?.(id2), await Promise.all([client.delete({
    query: `*[_type == "comment" && parentCommentId == "${id2}"]`
  }), client.delete(id2)]);
}
const THROTTLE_TIME_MS = 1e3, THROTTLE_SETTINGS = {
  trailing: !0,
  leading: !1
}, throttleFunctionsMap = /* @__PURE__ */ new Map();
function getThrottledFunction(id2) {
  if (!throttleFunctionsMap.has(id2)) {
    const throttledFunction = throttle(postCommentUpdate, THROTTLE_TIME_MS, THROTTLE_SETTINGS);
    return throttleFunctionsMap.set(id2, throttledFunction), throttledFunction;
  }
  return throttleFunctionsMap.get(id2);
}
async function postCommentUpdate(props2) {
  const {
    client,
    id: id2,
    comment,
    transactionId: transactionIdProp,
    onUpdate
  } = props2, transactionId = transactionIdProp || uuid(), patch2 = client?.patch(id2).set(comment), transaction = client.transaction().transactionId(transactionId).patch(patch2);
  onUpdate?.(id2, comment), comment.status ? (await transaction.commit(), await client.patch({
    query: `*[_type == "comment" && parentCommentId == "${id2}"]`
  }).set({
    status: comment.status
  }).commit()) : await transaction.commit(), throttleFunctionsMap.delete(id2);
}
async function updateOperation(props2) {
  const {
    id: id2,
    comment,
    throttled: throttledProp
  } = props2, hasEditedMessage = "message" in comment, editedComment = {
    ...comment,
    lastEditedAt: (/* @__PURE__ */ new Date()).toISOString()
  }, nextComment = hasEditedMessage ? editedComment : comment;
  if (!throttledProp) {
    await postCommentUpdate({
      ...props2,
      comment: nextComment
    });
    return;
  }
  await getThrottledFunction(id2)({
    ...props2,
    comment: nextComment
  });
}
function useCommentOperations(opts) {
  const $ = c(46), {
    client,
    currentUser,
    dataset,
    documentId,
    documentRevisionId,
    documentType,
    documentVersionId,
    getComment,
    getThreadLength,
    onCreate,
    onCreateError,
    onRemove,
    onTransactionStart,
    onUpdate,
    projectId,
    createAddonDataset,
    workspace,
    getCommentLink
  } = opts, getIntent = useCommentsIntent(), activeToolName = useRouterState(_temp$12), tools = useTools();
  let t0;
  if ($[0] !== activeToolName || $[1] !== tools) {
    let t12;
    $[3] !== activeToolName ? (t12 = (tool) => tool.name === activeToolName, $[3] = activeToolName, $[4] = t12) : t12 = $[4], t0 = tools.find(t12), $[0] = activeToolName, $[1] = tools, $[2] = t0;
  } else
    t0 = $[2];
  const activeTool = t0;
  let t1;
  $[5] !== documentId || $[6] !== documentType || $[7] !== documentVersionId || $[8] !== getCommentLink ? (t1 = {
    documentId,
    documentType,
    getCommentLink,
    documentVersionId
  }, $[5] = documentId, $[6] = documentType, $[7] = documentVersionId, $[8] = getCommentLink, $[9] = t1) : t1 = $[9];
  const {
    getNotificationValue
  } = useNotificationTarget(t1);
  let t2;
  $[10] !== activeTool || $[11] !== client || $[12] !== createAddonDataset || $[13] !== currentUser || $[14] !== dataset || $[15] !== documentId || $[16] !== documentRevisionId || $[17] !== documentType || $[18] !== documentVersionId || $[19] !== getIntent || $[20] !== getNotificationValue || $[21] !== getThreadLength || $[22] !== onCreate || $[23] !== onCreateError || $[24] !== projectId || $[25] !== workspace ? (t2 = async (comment) => {
    currentUser?.id && await createOperation({
      activeTool,
      client,
      comment,
      currentUser,
      dataset,
      documentId,
      documentRevisionId,
      documentType,
      documentVersionId,
      getIntent,
      getNotificationValue,
      getThreadLength,
      onCreate,
      onCreateError,
      projectId,
      createAddonDataset,
      workspace
    });
  }, $[10] = activeTool, $[11] = client, $[12] = createAddonDataset, $[13] = currentUser, $[14] = dataset, $[15] = documentId, $[16] = documentRevisionId, $[17] = documentType, $[18] = documentVersionId, $[19] = getIntent, $[20] = getNotificationValue, $[21] = getThreadLength, $[22] = onCreate, $[23] = onCreateError, $[24] = projectId, $[25] = workspace, $[26] = t2) : t2 = $[26];
  const handleCreate = t2;
  let t3;
  $[27] !== client || $[28] !== onRemove ? (t3 = async (id2) => {
    client && await removeOperation({
      client,
      id: id2,
      onRemove
    });
  }, $[27] = client, $[28] = onRemove, $[29] = t3) : t3 = $[29];
  const handleRemove = t3;
  let t4;
  $[30] !== client || $[31] !== onTransactionStart || $[32] !== onUpdate ? (t4 = async (id_0, comment_0, updateOpts) => {
    if (!client)
      return;
    const {
      throttled
    } = updateOpts || {}, nextTransactionId = uuid();
    onTransactionStart(id_0, nextTransactionId), await updateOperation({
      client,
      comment: comment_0,
      throttled,
      id: id_0,
      onUpdate,
      transactionId: nextTransactionId
    });
  }, $[30] = client, $[31] = onTransactionStart, $[32] = onUpdate, $[33] = t4) : t4 = $[33];
  const handleUpdate = t4;
  let t5;
  $[34] !== client || $[35] !== currentUser || $[36] !== getComment || $[37] !== onUpdate ? (t5 = async (id_1, reaction) => {
    !client || !currentUser?.id || await reactOperation({
      client,
      currentUser,
      id: id_1,
      reaction,
      getComment,
      onUpdate
    });
  }, $[34] = client, $[35] = currentUser, $[36] = getComment, $[37] = onUpdate, $[38] = t5) : t5 = $[38];
  const handleReact = t5;
  let t6;
  $[39] !== handleCreate || $[40] !== handleReact || $[41] !== handleRemove || $[42] !== handleUpdate ? (t6 = {
    create: handleCreate,
    react: handleReact,
    remove: handleRemove,
    update: handleUpdate
  }, $[39] = handleCreate, $[40] = handleReact, $[41] = handleRemove, $[42] = handleUpdate, $[43] = t6) : t6 = $[43];
  const t7 = t6;
  let t8;
  return $[44] !== t7 ? (t8 = {
    operation: t7
  }, $[44] = t7, $[45] = t8) : t8 = $[45], t8;
}
function _temp$12(routerState) {
  return typeof routerState.tool == "string" ? routerState.tool : void 0;
}
function useComments() {
  const value = useContext(CommentsContext);
  if (!value)
    throw new Error("useComments must be used within a CommentsProvider");
  return value;
}
function useCommentsAuthoringPath() {
  const value = useContext(CommentsAuthoringPathContext);
  if (!value)
    throw new Error("useCommentsAuthoringPath: missing context value");
  return value;
}
function useCommentsEnabled() {
  return useContext(CommentsEnabledContext);
}
function useCommentsOnboarding() {
  const ctx = useContext(CommentsOnboardingContext);
  if (!ctx)
    throw new Error("useCommentsOnboarding: missing context value");
  return ctx;
}
const BASE_SCROLL_OPTIONS = {
  behavior: "smooth",
  inline: "center",
  scrollMode: "if-needed"
}, GROUP_SCROLL_OPTIONS = {
  ...BASE_SCROLL_OPTIONS,
  block: "start"
}, INLINE_COMMENT_SCROLL_OPTIONS = {
  ...BASE_SCROLL_OPTIONS,
  block: "center"
}, SCROLL_TO_FIELD_OPTIONS = {
  ...BASE_SCROLL_OPTIONS,
  block: "center"
}, SCROLL_TO_COMMENT_OPTIONS = {
  ...BASE_SCROLL_OPTIONS,
  block: "center"
}, SCROLL_OPTIONS_BY_TYPE = {
  comment: SCROLL_TO_COMMENT_OPTIONS,
  field: SCROLL_TO_FIELD_OPTIONS,
  group: GROUP_SCROLL_OPTIONS,
  "inline-comment": INLINE_COMMENT_SCROLL_OPTIONS
};
function generateValidAttrValue(id2) {
  const symbolsToRemove = /[[\]_"_=.]/g;
  return id2.replace(symbolsToRemove, "");
}
function applyCommentIdAttr(id2) {
  return {
    "data-comments-comment-id": generateValidAttrValue(id2)
  };
}
function applyCommentsFieldAttr(id2) {
  return {
    "data-comments-field-id": generateValidAttrValue(id2)
  };
}
function applyCommentsGroupAttr(id2) {
  return {
    "data-comments-group-id": generateValidAttrValue(id2)
  };
}
function applyInlineCommentIdAttr(id2) {
  return {
    "data-comments-inline-comment-id": generateValidAttrValue(id2)
  };
}
function useCommentsScroll(opts) {
  const $ = c(14);
  let t0;
  $[0] !== opts ? (t0 = opts || {}, $[0] = opts, $[1] = t0) : t0 = $[1];
  const {
    boundaryElement
  } = t0, [scrollTarget, setScrollTarget] = useState(null), options = SCROLL_OPTIONS_BY_TYPE[scrollTarget?.type || "comment"], t1 = scrollTarget?.type === "comment" ? boundaryElement : void 0;
  let t2;
  $[2] !== options || $[3] !== t1 ? (t2 = {
    ...options,
    boundary: t1
  }, $[2] = options, $[3] = t1, $[4] = t2) : t2 = $[4];
  const scrollOpts = t2;
  let t3;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (commentId) => {
    setScrollTarget({
      type: "comment",
      id: commentId
    });
  }, $[5] = t3) : t3 = $[5];
  const handleScrollToComment = t3;
  let t4;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = (threadId) => {
    setScrollTarget({
      type: "group",
      id: threadId
    });
  }, $[6] = t4) : t4 = $[6];
  const handleScrollToGroup = t4;
  let t5;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = (fieldPath) => {
    setScrollTarget({
      type: "field",
      id: fieldPath
    });
  }, $[7] = t5) : t5 = $[7];
  const handleScrollToField = t5;
  let t6;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = (commentId_0) => {
    setScrollTarget({
      type: "inline-comment",
      id: commentId_0
    });
  }, $[8] = t6) : t6 = $[8];
  const handleScrollToInlineComment = t6;
  let t7, t8;
  $[9] !== scrollOpts || $[10] !== scrollTarget ? (t7 = () => {
    const raf2 = requestAnimationFrame(() => {
      if (!scrollTarget)
        return;
      const {
        type,
        id: id2
      } = scrollTarget, element = document?.querySelector(`[data-comments-${type}-id="${generateValidAttrValue(id2)}"]`);
      element && scrollIntoView$1(element, scrollOpts);
    });
    return () => {
      cancelAnimationFrame(raf2);
    };
  }, t8 = [scrollOpts, scrollTarget], $[9] = scrollOpts, $[10] = scrollTarget, $[11] = t7, $[12] = t8) : (t7 = $[11], t8 = $[12]), useEffect(t7, t8);
  let t9;
  return $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = {
    scrollToComment: handleScrollToComment,
    scrollToField: handleScrollToField,
    scrollToGroup: handleScrollToGroup,
    scrollToInlineComment: handleScrollToInlineComment
  }, $[13] = t9) : t9 = $[13], t9;
}
function useCommentsSelectedPath() {
  const ctx = useContext(CommentsSelectedPathContext);
  if (!ctx)
    throw new Error("useCommentsSelectedPath: missing context value");
  return ctx;
}
const CommentLinkCopied = defineEvent({
  name: "Comment Link Copied",
  version: 1,
  description: "The link to a comment is copied"
}), CommentViewedFromLink = defineEvent({
  name: "Comment Viewed From Link",
  version: 1,
  description: "A comment is viewed from a link"
}), CommentListViewChanged = defineEvent({
  name: "Comment List View Changed",
  version: 1,
  description: "The view of the comment list is changed"
});
function useCommentsTelemetry() {
  const $ = c(10), telemetry = useTelemetry();
  let t0;
  $[0] !== telemetry ? (t0 = () => {
    telemetry.log(CommentLinkCopied);
  }, $[0] = telemetry, $[1] = t0) : t0 = $[1];
  const commentLinkCopied = t0;
  let t1;
  $[2] !== telemetry ? (t1 = () => {
    telemetry.log(CommentViewedFromLink);
  }, $[2] = telemetry, $[3] = t1) : t1 = $[3];
  const commentViewedFromLink = t1;
  let t2;
  $[4] !== telemetry ? (t2 = (view) => {
    telemetry.log(CommentListViewChanged, {
      view
    });
  }, $[4] = telemetry, $[5] = t2) : t2 = $[5];
  const commentListViewChanged = t2;
  let t3;
  return $[6] !== commentLinkCopied || $[7] !== commentListViewChanged || $[8] !== commentViewedFromLink ? (t3 = {
    commentLinkCopied,
    commentListViewChanged,
    commentViewedFromLink
  }, $[6] = commentLinkCopied, $[7] = commentListViewChanged, $[8] = commentViewedFromLink, $[9] = t3) : t3 = $[9], t3;
}
function useCommentsUpsell() {
  const $ = c(1), value = useContext(CommentsUpsellContext);
  if (!value) {
    let t0;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
      upsellData: null,
      handleOpenDialog: _temp$11,
      handleClose: _temp2$o,
      upsellDialogOpen: !1,
      telemetryLogs: {
        dialogSecondaryClicked: _temp3$d,
        dialogPrimaryClicked: _temp4$5,
        panelViewed: _temp5$4,
        panelDismissed: _temp6$1,
        panelPrimaryClicked: _temp7,
        panelSecondaryClicked: _temp8
      }
    }, $[0] = t0) : t0 = $[0], t0;
  }
  return value;
}
function _temp8() {
  return null;
}
function _temp7() {
  return null;
}
function _temp6$1() {
  return null;
}
function _temp5$4() {
  return null;
}
function _temp4$5() {
  return null;
}
function _temp3$d() {
  return null;
}
function _temp2$o() {
  return null;
}
function _temp$11() {
  return null;
}
function useResolveCommentsEnabled(documentId, documentType) {
  const $ = c(3), {
    enabled: featureEnabled,
    isLoading,
    error
  } = useFeatureEnabled(FEATURES.studioComments), {
    enabled
  } = useSource().document.comments, enabledFromConfig = enabled({
    documentType,
    documentId: getPublishedId(documentId)
  });
  let t0;
  bb0: {
    if (isLoading || !enabledFromConfig || error) {
      let t12;
      $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = {
        enabled: !1,
        mode: null
      }, $[0] = t12) : t12 = $[0], t0 = t12;
      break bb0;
    }
    const t1 = featureEnabled ? "default" : "upsell";
    let t2;
    $[1] !== t1 ? (t2 = {
      enabled: !0,
      mode: t1
    }, $[1] = t1, $[2] = t2) : t2 = $[2], t0 = t2;
  }
  return t0;
}
function createCommentsSet(comments2) {
  return comments2.reduce((acc, comment) => ({
    ...acc,
    [comment._id]: comment
  }), {});
}
function commentsReducer(state, action) {
  switch (action.type) {
    case "COMMENTS_SET": {
      const commentsById = createCommentsSet(action.comments);
      return {
        ...state,
        comments: commentsById
      };
    }
    case "COMMENT_ADDED": {
      const nextCommentResult = action.payload, nextCommentValue = nextCommentResult, nextComment = {
        [nextCommentResult._id]: {
          ...state.comments[nextCommentResult._id],
          ...nextCommentValue,
          _state: nextCommentResult._state || void 0,
          // If the comment is created optimistically, it won't have a createdAt date as this is set on the server.
          // However, we need to set a createdAt date to be able to sort the comments correctly.
          // Therefore, we set the createdAt date to the current date here if it's missing while creating the comment.
          // Once the comment is created and received from the server, the createdAt date will be updated to the correct value.
          _createdAt: nextCommentResult._createdAt || (/* @__PURE__ */ new Date()).toISOString()
        }
      };
      return {
        ...state,
        comments: {
          ...state.comments,
          ...nextComment
        }
      };
    }
    case "COMMENT_RECEIVED": {
      const nextCommentResult = action.payload;
      return {
        ...state,
        comments: {
          ...state.comments,
          [nextCommentResult._id]: nextCommentResult
        }
      };
    }
    case "COMMENT_DELETED": {
      const {
        [action.id]: _,
        ...restComments
      } = state.comments;
      return Object.keys(restComments).forEach((commentId) => {
        restComments[commentId].parentCommentId === action.id && delete restComments[commentId];
      }), {
        ...state,
        comments: restComments
      };
    }
    case "COMMENT_UPDATED": {
      const updatedComment = action.payload, id2 = updatedComment._id, comment = state.comments[id2], optimisticReactions = comment?.reactions?.filter((v) => v?._optimisticState) || [], incomingReactions = updatedComment.reactions || [], nextReactions = mergeCommentReactions(optimisticReactions, incomingReactions), nextComment = {
        // Add existing comment data
        ...comment,
        // Add incoming comment data
        ...updatedComment,
        // Add reactions merged with optimistic reactions
        reactions: nextReactions
      };
      return {
        ...state,
        comments: {
          ...state.comments,
          [id2]: nextComment
        }
      };
    }
    default:
      return state;
  }
}
const INITIAL_STATE$4 = {
  comments: {}
}, LISTEN_OPTIONS$1 = {
  events: ["welcome", "mutation", "reconnect"],
  includeResult: !0,
  includeAllVersions: !0,
  visibility: "query",
  tag: "comments-store"
}, SORT_FIELD$1 = "_createdAt", SORT_ORDER$1 = "desc", QUERY_FILTERS$1 = ['_type == "comment"', "target.document._ref == $documentId"], VERSION_FILTER = "target.documentVersionId==$documentVersionId", NO_VERSION_FILTER = "!defined(target.documentVersionId)", QUERY_PROJECTION$1 = `{
  _createdAt,
  _id,
  authorId,
  contentSnapshot,
  context,
  lastEditedAt,
  message,
  parentCommentId,
  reactions,
  status,
  target,
  threadId
}`, QUERY_SORT_ORDER$1 = `order(${SORT_FIELD$1} ${SORT_ORDER$1})`;
function useCommentsStore(opts) {
  const $ = c(33), {
    client,
    documentId,
    onLatestTransactionIdReceived,
    transactionsIdMap,
    releaseId
  } = opts, t0 = releaseId ? VERSION_FILTER : NO_VERSION_FILTER;
  let t1;
  $[0] !== t0 ? (t1 = [...QUERY_FILTERS$1, t0], $[0] = t0, $[1] = t1) : t1 = $[1];
  const filters = t1.join(" && "), query = `*[${filters}] ${QUERY_PROJECTION$1} | ${QUERY_SORT_ORDER$1}`, [state, dispatch] = useReducer(commentsReducer, INITIAL_STATE$4), [loading, setLoading] = useState(client !== null), [error, setError] = useState(null), didInitialFetch = useRef(!1);
  let t2;
  $[2] !== documentId ? (t2 = getPublishedId(documentId), $[2] = documentId, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== releaseId ? (t3 = releaseId ? {
    documentVersionId: releaseId
  } : {}, $[4] = releaseId, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t2 || $[7] !== t3 ? (t4 = {
    documentId: t2,
    ...t3
  }, $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8];
  const params = t4;
  let t5;
  $[9] !== client || $[10] !== params || $[11] !== query ? (t5 = async () => {
    if (!client) {
      setLoading(!1);
      return;
    }
    try {
      const res = await client.fetch(query, params);
      dispatch({
        type: "COMMENTS_SET",
        comments: res
      }), setLoading(!1);
    } catch (t62) {
      setError(t62);
    }
  }, $[9] = client, $[10] = params, $[11] = query, $[12] = t5) : t5 = $[12];
  const initialFetch = t5;
  let t6;
  $[13] !== initialFetch || $[14] !== onLatestTransactionIdReceived || $[15] !== transactionsIdMap ? (t6 = async (event) => {
    if (event.type === "welcome" && !didInitialFetch.current && (setLoading(!0), await initialFetch(), setLoading(!1), didInitialFetch.current = !0), event.type === "reconnect" && (setLoading(!0), didInitialFetch.current = !1), event.type === "mutation") {
      if (event.transition === "appear") {
        const nextComment = event.result;
        nextComment && dispatch({
          type: "COMMENT_RECEIVED",
          payload: nextComment
        });
      }
      if (event.transition === "disappear" && dispatch({
        type: "COMMENT_DELETED",
        id: event.documentId
      }), event.transition === "update") {
        const updatedComment = event.result, id2 = event.result?._id || "", transactionId = event.transactionId, latestTransactionId = transactionsIdMap.get(id2), isLatestTransaction = transactionId === latestTransactionId;
        if (!isLatestTransaction && latestTransactionId)
          return;
        updatedComment && (dispatch({
          type: "COMMENT_UPDATED",
          payload: updatedComment
        }), isLatestTransaction && onLatestTransactionIdReceived(id2));
      }
    }
  }, $[13] = initialFetch, $[14] = onLatestTransactionIdReceived, $[15] = transactionsIdMap, $[16] = t6) : t6 = $[16];
  const handleListenerEvent = t6;
  let t7;
  bb0: {
    if (!client) {
      let t83;
      $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t83 = of(), $[17] = t83) : t83 = $[17], t7 = t83;
      break bb0;
    }
    let t82;
    if ($[18] !== client.observable || $[19] !== filters || $[20] !== params) {
      let t92;
      $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t92 = (err_0) => (setError(err_0), of(err_0)), $[22] = t92) : t92 = $[22], t82 = client.observable.listen(`*[${filters}]`, params, LISTEN_OPTIONS$1).pipe(catchError$1(t92)), $[18] = client.observable, $[19] = filters, $[20] = params, $[21] = t82;
    } else
      t82 = $[21];
    t7 = t82;
  }
  const listener$ = t7;
  let t8, t9;
  $[23] !== handleListenerEvent || $[24] !== listener$ ? (t8 = () => {
    const sub2 = listener$.subscribe(handleListenerEvent);
    return () => {
      sub2?.unsubscribe();
    };
  }, t9 = [handleListenerEvent, listener$], $[23] = handleListenerEvent, $[24] = listener$, $[25] = t8, $[26] = t9) : (t8 = $[25], t9 = $[26]), useEffect(t8, t9);
  let t10;
  $[27] !== state.comments ? (t10 = Object.values(state.comments), $[27] = state.comments, $[28] = t10) : t10 = $[28];
  const commentsAsArray = t10;
  let t11;
  return $[29] !== commentsAsArray || $[30] !== error || $[31] !== loading ? (t11 = {
    data: commentsAsArray,
    dispatch,
    error,
    loading
  }, $[29] = commentsAsArray, $[30] = error, $[31] = loading, $[32] = t11) : t11 = $[32], t11;
}
const EMPTY_ARRAY$8 = [], EMPTY_COMMENTS_DATA = {
  open: EMPTY_ARRAY$8,
  resolved: EMPTY_ARRAY$8
}, CommentsProvider = memo(function(props2) {
  const $ = c(88), {
    children,
    documentId,
    documentType,
    isCommentsOpen,
    onCommentsOpen,
    sortOrder,
    type,
    getCommentLink,
    onClearSelectedComment,
    selectedCommentId,
    isConnecting,
    onPathOpen,
    releaseId,
    mentionsDisabled
  } = props2, commentsEnabled = useCommentsEnabled(), [status, setStatus] = useState("open"), {
    client,
    createAddonDataset,
    isCreatingDataset
  } = useAddonDataset();
  let t0;
  $[0] !== documentId ? (t0 = getPublishedId(documentId), $[0] = documentId, $[1] = t0) : t0 = $[1];
  const publishedId = t0, editState2 = useEditState(publishedId, documentType, "low", releaseId), t1 = useSchema();
  let t2;
  $[2] !== documentType || $[3] !== t1 ? (t2 = t1.get(documentType), $[2] = documentType, $[3] = t1, $[4] = t2) : t2 = $[4];
  const schemaType = t2, currentUser = useCurrentUser(), {
    name: workspaceName,
    dataset,
    projectId
  } = useWorkspace();
  let t3;
  bb0: {
    if (releaseId) {
      t3 = editState2.version;
      break bb0;
    }
    t3 = editState2.draft || editState2.published;
  }
  const documentValue = t3, documentRevisionId = documentValue?._rev, [transactionsIdMap] = useState(_temp$10);
  let t4;
  $[5] !== transactionsIdMap ? (t4 = (commentDocumentId) => {
    transactionsIdMap.delete(commentDocumentId);
  }, $[5] = transactionsIdMap, $[6] = t4) : t4 = $[6];
  const handleOnLatestTransactionIdReceived = t4;
  let t5;
  $[7] !== client || $[8] !== documentId || $[9] !== handleOnLatestTransactionIdReceived || $[10] !== releaseId || $[11] !== transactionsIdMap ? (t5 = {
    documentId,
    releaseId,
    client,
    transactionsIdMap,
    onLatestTransactionIdReceived: handleOnLatestTransactionIdReceived
  }, $[7] = client, $[8] = documentId, $[9] = handleOnLatestTransactionIdReceived, $[10] = releaseId, $[11] = transactionsIdMap, $[12] = t5) : t5 = $[12];
  const {
    dispatch,
    data: t6,
    error,
    loading
  } = useCommentsStore(t5), data = t6 === void 0 ? EMPTY_ARRAY$8 : t6;
  let t7;
  $[13] !== transactionsIdMap ? (t7 = (commentDocumentId_0, transactionId) => {
    transactionsIdMap.set(commentDocumentId_0, transactionId);
  }, $[13] = transactionsIdMap, $[14] = t7) : t7 = $[14];
  const handleOnTransactionStart = t7;
  let t8;
  $[15] !== commentsEnabled ? (t8 = (newStatus) => commentsEnabled.mode === "upsell" && newStatus === "resolved" ? null : setStatus(newStatus), $[15] = commentsEnabled, $[16] = t8) : t8 = $[16];
  const handleSetStatus = t8;
  let t9;
  $[17] !== documentValue ? (t9 = {
    documentValue,
    permission: "read"
  }, $[17] = documentValue, $[18] = t9) : t9 = $[18];
  const mentionOptions = useUserListWithPermissions(t9);
  let t10;
  if ($[19] !== currentUser || $[20] !== data || $[21] !== documentValue || $[22] !== schemaType || $[23] !== sortOrder || $[24] !== type) {
    bb1: {
      if (!currentUser) {
        t10 = EMPTY_COMMENTS_DATA;
        break bb1;
      }
      const sorted = orderBy(data, ["_createdAt"], [sortOrder]);
      let items;
      if (type === "task")
        items = buildCommentThreadItems({
          comments: sorted,
          currentUser,
          documentValue,
          type
        });
      else {
        if (!schemaType) {
          t10 = EMPTY_COMMENTS_DATA;
          break bb1;
        }
        items = buildCommentThreadItems({
          comments: sorted,
          currentUser,
          documentValue,
          schemaType,
          type
        });
      }
      t10 = {
        open: items.filter(_temp2$n),
        resolved: items.filter(_temp3$c)
      };
    }
    $[19] = currentUser, $[20] = data, $[21] = documentValue, $[22] = schemaType, $[23] = sortOrder, $[24] = type, $[25] = t10;
  } else
    t10 = $[25];
  const threadItemsByStatus = t10;
  let t11;
  $[26] !== threadItemsByStatus.open ? (t11 = (threadId) => threadItemsByStatus.open.filter((item_1) => item_1.threadId === threadId).length, $[26] = threadItemsByStatus.open, $[27] = t11) : t11 = $[27];
  const getThreadLength = t11;
  let t12;
  $[28] !== data ? (t12 = (id2) => data?.find((c2) => c2._id === id2), $[28] = data, $[29] = t12) : t12 = $[29];
  const getComment = t12;
  let t13;
  $[30] !== data || $[31] !== dispatch ? (t13 = (payload) => {
    const hasError = data?.find((c_0) => c_0._id === payload._id)?._state?.type === "createError";
    dispatch({
      type: "COMMENT_ADDED",
      payload: {
        ...payload,
        _state: hasError ? {
          type: "createRetrying"
        } : void 0
      }
    });
  }, $[30] = data, $[31] = dispatch, $[32] = t13) : t13 = $[32];
  const handleOnCreate = t13;
  let t14;
  $[33] !== dispatch ? (t14 = (id_0, payload_0) => {
    dispatch({
      type: "COMMENT_UPDATED",
      payload: {
        _id: id_0,
        ...payload_0
      }
    });
  }, $[33] = dispatch, $[34] = t14) : t14 = $[34];
  const handleOnUpdate = t14;
  let t15;
  $[35] !== dispatch ? (t15 = (id_1, err) => {
    dispatch({
      type: "COMMENT_UPDATED",
      payload: {
        _id: id_1,
        _state: {
          error: err,
          type: "createError"
        }
      }
    });
  }, $[35] = dispatch, $[36] = t15) : t15 = $[36];
  const handleOnCreateError = t15;
  let t16;
  $[37] !== client || $[38] !== createAddonDataset || $[39] !== currentUser || $[40] !== dataset || $[41] !== documentRevisionId || $[42] !== documentType || $[43] !== getComment || $[44] !== getCommentLink || $[45] !== getThreadLength || $[46] !== handleOnCreate || $[47] !== handleOnCreateError || $[48] !== handleOnTransactionStart || $[49] !== handleOnUpdate || $[50] !== projectId || $[51] !== publishedId || $[52] !== releaseId || $[53] !== schemaType || $[54] !== workspaceName ? (t16 = {
    client,
    currentUser,
    dataset,
    documentId: publishedId,
    documentVersionId: releaseId,
    documentRevisionId,
    documentType,
    getComment,
    getThreadLength,
    projectId,
    schemaType,
    workspace: workspaceName,
    createAddonDataset,
    onCreate: handleOnCreate,
    onCreateError: handleOnCreateError,
    onUpdate: handleOnUpdate,
    onTransactionStart: handleOnTransactionStart,
    getCommentLink
  }, $[37] = client, $[38] = createAddonDataset, $[39] = currentUser, $[40] = dataset, $[41] = documentRevisionId, $[42] = documentType, $[43] = getComment, $[44] = getCommentLink, $[45] = getThreadLength, $[46] = handleOnCreate, $[47] = handleOnCreateError, $[48] = handleOnTransactionStart, $[49] = handleOnUpdate, $[50] = projectId, $[51] = publishedId, $[52] = releaseId, $[53] = schemaType, $[54] = workspaceName, $[55] = t16) : t16 = $[55];
  const {
    operation
  } = useCommentOperations(t16), t17 = loading || isCreatingDataset || isConnecting || !1;
  let t18;
  $[56] !== error || $[57] !== t17 || $[58] !== threadItemsByStatus ? (t18 = {
    data: threadItemsByStatus,
    error,
    loading: t17
  }, $[56] = error, $[57] = t17, $[58] = threadItemsByStatus, $[59] = t18) : t18 = $[59];
  let t19;
  $[60] !== operation.create || $[61] !== operation.react || $[62] !== operation.remove || $[63] !== operation.update ? (t19 = {
    create: operation.create,
    react: operation.react,
    remove: operation.remove,
    update: operation.update
  }, $[60] = operation.create, $[61] = operation.react, $[62] = operation.remove, $[63] = operation.update, $[64] = t19) : t19 = $[64];
  let t20;
  $[65] !== mentionOptions || $[66] !== mentionsDisabled ? (t20 = {
    ...mentionOptions,
    disabled: mentionsDisabled
  }, $[65] = mentionOptions, $[66] = mentionsDisabled, $[67] = t20) : t20 = $[67];
  let t21;
  $[68] !== documentId || $[69] !== documentType || $[70] !== getComment || $[71] !== getCommentLink || $[72] !== handleSetStatus || $[73] !== isCommentsOpen || $[74] !== isConnecting || $[75] !== isCreatingDataset || $[76] !== onClearSelectedComment || $[77] !== onCommentsOpen || $[78] !== onPathOpen || $[79] !== selectedCommentId || $[80] !== status || $[81] !== t18 || $[82] !== t19 || $[83] !== t20 ? (t21 = {
    documentId,
    documentType,
    isCreatingDataset,
    status,
    setStatus: handleSetStatus,
    getComment,
    getCommentLink,
    onClearSelectedComment,
    selectedCommentId,
    isCommentsOpen,
    onCommentsOpen,
    isConnecting,
    onPathOpen,
    comments: t18,
    operation: t19,
    mentionOptions: t20
  }, $[68] = documentId, $[69] = documentType, $[70] = getComment, $[71] = getCommentLink, $[72] = handleSetStatus, $[73] = isCommentsOpen, $[74] = isConnecting, $[75] = isCreatingDataset, $[76] = onClearSelectedComment, $[77] = onCommentsOpen, $[78] = onPathOpen, $[79] = selectedCommentId, $[80] = status, $[81] = t18, $[82] = t19, $[83] = t20, $[84] = t21) : t21 = $[84];
  const ctxValue = t21;
  let t22;
  return $[85] !== children || $[86] !== ctxValue ? (t22 = /* @__PURE__ */ jsx(CommentsContext.Provider, { value: ctxValue, children }), $[85] = children, $[86] = ctxValue, $[87] = t22) : t22 = $[87], t22;
});
function _temp$10() {
  return /* @__PURE__ */ new Map();
}
function _temp2$n(item) {
  return item.parentComment.status === "open";
}
function _temp3$c(item_0) {
  return item_0.parentComment.status === "resolved";
}
const CommentsEnabledProvider = memo(function(props2) {
  const $ = c(3), {
    children,
    documentId,
    documentType
  } = props2, value = useResolveCommentsEnabled(documentId, documentType);
  let t0;
  return $[0] !== children || $[1] !== value ? (t0 = /* @__PURE__ */ jsx(CommentsEnabledContext.Provider, { value, children }), $[0] = children, $[1] = value, $[2] = t0) : t0 = $[2], t0;
}), CommentsIntentProvider = memo(function(props2) {
  const $ = c(3), {
    children,
    getIntent
  } = props2;
  let t0;
  return $[0] !== children || $[1] !== getIntent ? (t0 = /* @__PURE__ */ jsx(CommentsIntentContext.Provider, { value: getIntent, children }), $[0] = children, $[1] = getIntent, $[2] = t0) : t0 = $[2], t0;
}), VERSION = 1, LOCAL_STORAGE_KEY$2 = `sanityStudio:comments:inspector:onboarding:dismissed:v${VERSION}`, setLocalStorage = (value) => {
  try {
    window.localStorage.setItem(LOCAL_STORAGE_KEY$2, JSON.stringify(value));
  } catch {
  }
}, getLocalStorage = () => {
  try {
    const value = window.localStorage.getItem(LOCAL_STORAGE_KEY$2);
    return value ? JSON.parse(value) : !1;
  } catch {
    return !1;
  }
};
function CommentsOnboardingProvider(props2) {
  const $ = c(7), {
    children
  } = props2;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = getLocalStorage(), $[0] = t0) : t0 = $[0];
  const [dismissed, setDismissed] = useState(t0);
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setDismissed(!0), setLocalStorage(!0);
  }, $[1] = t1) : t1 = $[1];
  const handleDismiss = t1;
  let t2;
  $[2] !== dismissed ? (t2 = {
    setDismissed: handleDismiss,
    isDismissed: dismissed
  }, $[2] = dismissed, $[3] = t2) : t2 = $[3];
  const ctxValue = t2;
  let t3;
  return $[4] !== children || $[5] !== ctxValue ? (t3 = /* @__PURE__ */ jsx(CommentsOnboardingContext.Provider, { value: ctxValue, children }), $[4] = children, $[5] = ctxValue, $[6] = t3) : t3 = $[6], t3;
}
const CommentsSelectedPathProvider = memo(function(props2) {
  const $ = c(8), {
    children
  } = props2, [selectedPath, setSelectedPath] = useState(null);
  let t0;
  $[0] !== selectedPath ? (t0 = (nextPath) => {
    isEqual$1(selectedPath, nextPath) || setSelectedPath(nextPath);
  }, $[0] = selectedPath, $[1] = t0) : t0 = $[1];
  const handleSelectPath = t0;
  let t1;
  $[2] !== handleSelectPath || $[3] !== selectedPath ? (t1 = {
    selectedPath,
    setSelectedPath: handleSelectPath
  }, $[2] = handleSelectPath, $[3] = selectedPath, $[4] = t1) : t1 = $[4];
  const ctxValue = t1;
  let t2;
  return $[5] !== children || $[6] !== ctxValue ? (t2 = /* @__PURE__ */ jsx(CommentsSelectedPathContext.Provider, { value: ctxValue, children }), $[5] = children, $[6] = ctxValue, $[7] = t2) : t2 = $[7], t2;
});
function CommentsUpsellProvider(props2) {
  const $ = c(9);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    dataUri: "/journey/comments",
    feature: "comments"
  }, $[0] = t0) : t0 = $[0];
  const contextValue = useUpsellContext(t0), t1 = props2.children;
  let t2;
  $[1] !== contextValue ? (t2 = getDialogPropsFromContext(contextValue), $[1] = contextValue, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(UpsellDialog, { ...t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== contextValue || $[6] !== props2.children || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(CommentsUpsellContext.Provider, { value: contextValue, children: [
    t1,
    t3
  ] }), $[5] = contextValue, $[6] = props2.children, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
function CommentsDocumentLayout(props2) {
  const $ = c(8), {
    documentId,
    documentType
  } = props2;
  if (useCommentsEnabled().mode !== null) {
    let t02;
    return $[0] !== props2 ? (t02 = /* @__PURE__ */ jsx(CommentsDocumentLayoutInner, { ...props2 }), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  $[2] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommentsDocumentLayoutInner, { ...props2 }), $[2] = props2, $[3] = t0) : t0 = $[3];
  let t1;
  return $[4] !== documentId || $[5] !== documentType || $[6] !== t0 ? (t1 = /* @__PURE__ */ jsx(CommentsEnabledProvider, { documentId, documentType, children: t0 }), $[4] = documentId, $[5] = documentType, $[6] = t0, $[7] = t1) : t1 = $[7], t1;
}
function CommentsDocumentLayoutInner(props2) {
  const $ = c(6);
  if (!useCommentsEnabled().enabled) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  $[2] !== props2 ? (t0 = props2.renderDefault(props2), $[2] = props2, $[3] = t0) : t0 = $[3];
  let t1;
  return $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(CommentsSelectedPathProvider, { children: /* @__PURE__ */ jsx(CommentsAuthoringPathProvider, { children: t0 }) }), $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}
function useAddonDataset() {
  const ctx = useContext(AddonDatasetContext);
  if (!ctx)
    throw new Error("useAddonDataset: missing context value");
  return ctx;
}
const ContentStack = styled(Stack).withConfig({
  displayName: "ContentStack",
  componentId: "sc-1pykjeg-0"
})`width:320px;`;
function CommentsFieldButton(props2) {
  const $ = c(69), {
    count: count2,
    currentUser,
    fieldTitle,
    isCreatingDataset,
    mentionOptions,
    onChange,
    onClick: onClick2,
    onClose,
    onCommentAdd,
    onDiscard,
    onInputKeyDown,
    open,
    value
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace), {
    error: addonDatasetError
  } = useAddonDataset(), popoverRef = useRef(null), [addCommentButtonElement, setAddCommentButtonElement] = useState(null), commentInputHandle = useRef(null), hasComments = count2 > 0;
  let t0;
  $[0] !== addCommentButtonElement || $[1] !== onClose || $[2] !== open ? (t0 = () => {
    open && (onClose(), addCommentButtonElement?.focus());
  }, $[0] = addCommentButtonElement, $[1] = onClose, $[2] = open, $[3] = t0) : t0 = $[3];
  const closePopover = t0;
  let t1;
  $[4] !== closePopover || $[5] !== onCommentAdd ? (t1 = () => {
    onCommentAdd(), closePopover();
  }, $[4] = closePopover, $[5] = onCommentAdd, $[6] = t1) : t1 = $[6];
  const handleSubmit = t1;
  let t2;
  $[7] !== value ? (t2 = hasCommentMessageValue(value), $[7] = value, $[8] = t2) : t2 = $[8];
  const hasValue2 = t2;
  let t3;
  $[9] !== closePopover || $[10] !== hasValue2 ? (t3 = () => {
    if (!hasValue2) {
      closePopover();
      return;
    }
    commentInputHandle.current?.discardDialogController.open();
  }, $[9] = closePopover, $[10] = hasValue2, $[11] = t3) : t3 = $[11];
  const startDiscard = t3;
  let t4;
  $[12] !== onInputKeyDown ? (t4 = (event) => {
    event.isDefaultPrevented() || onInputKeyDown && onInputKeyDown(event);
  }, $[12] = onInputKeyDown, $[13] = t4) : t4 = $[13];
  const handleInputKeyDown = t4;
  let t5;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    commentInputHandle.current?.discardDialogController.close();
  }, $[14] = t5) : t5 = $[14];
  const handleDiscardCancel = t5;
  let t6;
  $[15] !== closePopover || $[16] !== onDiscard ? (t6 = () => {
    commentInputHandle.current?.discardDialogController.close(), closePopover(), onDiscard();
  }, $[15] = closePopover, $[16] = onDiscard, $[17] = t6) : t6 = $[17];
  const handleDiscardConfirm = t6;
  let t7;
  $[18] !== startDiscard ? (t7 = (event_0) => {
    event_0.key === "Escape" && (event_0.preventDefault(), event_0.stopPropagation(), startDiscard());
  }, $[18] = startDiscard, $[19] = t7) : t7 = $[19];
  const handlePopoverKeyDown = t7;
  let t8;
  if ($[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = () => [popoverRef.current], $[20] = t8) : t8 = $[20], useClickOutsideEvent(!open && startDiscard, t8), !hasComments) {
    let t92;
    $[21] !== fieldTitle ? (t92 = {
      field: fieldTitle
    }, $[21] = fieldTitle, $[22] = t92) : t92 = $[22];
    let t102;
    $[23] !== t || $[24] !== t92 ? (t102 = /* @__PURE__ */ jsx(Translate, { t, i18nKey: "compose.add-comment-input-placeholder", values: t92 }), $[23] = t, $[24] = t92, $[25] = t102) : t102 = $[25];
    const placeholder = t102;
    let t112;
    $[26] !== currentUser || $[27] !== handleDiscardConfirm || $[28] !== handleInputKeyDown || $[29] !== handleSubmit || $[30] !== isCreatingDataset || $[31] !== mentionOptions || $[32] !== onChange || $[33] !== placeholder || $[34] !== value ? (t112 = /* @__PURE__ */ jsx(ContentStack, { padding: 2, space: 4, children: /* @__PURE__ */ jsx(CommentInput, { currentUser, focusLock: !0, focusOnMount: !0, mentionOptions, onChange, onDiscardCancel: handleDiscardCancel, onDiscardConfirm: handleDiscardConfirm, onKeyDown: handleInputKeyDown, onSubmit: handleSubmit, placeholder, readOnly: isCreatingDataset, ref: commentInputHandle, value }) }), $[26] = currentUser, $[27] = handleDiscardConfirm, $[28] = handleInputKeyDown, $[29] = handleSubmit, $[30] = isCreatingDataset, $[31] = mentionOptions, $[32] = onChange, $[33] = placeholder, $[34] = value, $[35] = t112) : t112 = $[35];
    const content = t112;
    let t122;
    $[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t122 = ["bottom-end"], $[36] = t122) : t122 = $[36];
    let t132;
    $[37] !== t ? (t132 = t("field-button.aria-label-add"), $[37] = t, $[38] = t132) : t132 = $[38];
    const t142 = isCreatingDataset || !!addonDatasetError;
    let t152;
    $[39] !== t ? (t152 = t("field-button.title"), $[39] = t, $[40] = t152) : t152 = $[40];
    let t16;
    $[41] !== t152 ? (t16 = {
      content: t152,
      placement: "top"
    }, $[41] = t152, $[42] = t16) : t16 = $[42];
    let t17;
    $[43] !== onClick2 || $[44] !== open || $[45] !== t132 || $[46] !== t142 || $[47] !== t16 ? (t17 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Button, { "aria-label": t132, disabled: t142, icon: AddCommentIcon, mode: "bleed", onClick: onClick2, ref: setAddCommentButtonElement, selected: open, tooltipProps: t16 }) }), $[43] = onClick2, $[44] = open, $[45] = t132, $[46] = t142, $[47] = t16, $[48] = t17) : t17 = $[48];
    let t18;
    return $[49] !== content || $[50] !== handlePopoverKeyDown || $[51] !== open || $[52] !== t17 ? (t18 = /* @__PURE__ */ jsx(Popover, { constrainSize: !0, content, fallbackPlacements: t122, open, placement: "right-start", portal: !0, ref: popoverRef, onKeyDown: handlePopoverKeyDown, children: t17 }), $[49] = content, $[50] = handlePopoverKeyDown, $[51] = open, $[52] = t17, $[53] = t18) : t18 = $[53], t18;
  }
  let t9;
  $[54] !== count2 || $[55] !== t ? (t9 = t("field-button.content", {
    count: count2
  }), $[54] = count2, $[55] = t, $[56] = t9) : t9 = $[56];
  let t10;
  $[57] !== t ? (t10 = t("field-button.aria-label-open"), $[57] = t, $[58] = t10) : t10 = $[58];
  let t11;
  $[59] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(CommentIcon, {}) }), $[59] = t11) : t11 = $[59];
  const t12 = count2 > 9 ? "9+" : count2;
  let t13;
  $[60] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t11,
    /* @__PURE__ */ jsx(Text$1, { size: 0, children: t12 })
  ] }), $[60] = t12, $[61] = t13) : t13 = $[61];
  let t14;
  $[62] !== onClick2 || $[63] !== t10 || $[64] !== t13 ? (t14 = /* @__PURE__ */ jsx(Button$1, { "aria-label": t10, mode: "bleed", onClick: onClick2, padding: 2, space: 2, children: t13 }), $[62] = onClick2, $[63] = t10, $[64] = t13, $[65] = t14) : t14 = $[65];
  let t15;
  return $[66] !== t14 || $[67] !== t9 ? (t15 = /* @__PURE__ */ jsx(Tooltip, { portal: !0, placement: "top", content: t9, children: t14 }), $[66] = t14, $[67] = t9, $[68] = t15) : t15 = $[68], t15;
}
const messageCache = /* @__PURE__ */ new Map(), EMPTY_ARRAY$7 = [], HIGHLIGHT_BLOCK_VARIANTS = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};
function CommentsField(props2) {
  const $ = c(5), {
    enabled,
    mode
  } = useCommentsEnabled();
  if (!enabled) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== mode || $[3] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommentFieldInner, { ...props2, mode }), $[2] = mode, $[3] = props2, $[4] = t0) : t0 = $[4], t0;
}
const HighlightDiv = /* @__PURE__ */ styled(motion.div).withConfig({
  displayName: "HighlightDiv",
  componentId: "sc-xeguza-0"
})(({
  theme
}) => {
  const {
    radius,
    space,
    color
  } = theme.sanity, bg = hues[COMMENTS_HIGHLIGHT_HUE_KEY][color.dark ? 900 : 50].hex;
  return css`
    mix-blend-mode: ${color.dark ? "screen" : "multiply"};
    border-radius: ${radius[3]}px;
    top: -${space[2]}px;
    left: -${space[2]}px;
    bottom: -${space[2]}px;
    right: -${space[2]}px;
    pointer-events: none;
    position: absolute;
    z-index: 1;
    width: calc(100% + ${space[2] * 2}px);
    height: calc(100% + ${space[2] * 2}px);
    background-color: ${bg};
  `;
}), FieldStack = styled(Stack).withConfig({
  displayName: "FieldStack",
  componentId: "sc-xeguza-1"
})`position:relative;`;
function CommentFieldInner(props2) {
  const $ = c(85), {
    mode
  } = props2, currentUser = useCurrentUser(), {
    element: boundaryElement
  } = useBoundaryElement(), rootRef = useRef(null), {
    comments: comments2,
    isCommentsOpen,
    isCreatingDataset,
    mentionOptions,
    onCommentsOpen,
    operation,
    setStatus,
    status
  } = useComments(), {
    upsellData,
    handleOpenDialog
  } = useCommentsUpsell(), {
    selectedPath,
    setSelectedPath
  } = useCommentsSelectedPath(), {
    authoringPath,
    setAuthoringPath
  } = useCommentsAuthoringPath();
  let t0;
  $[0] !== boundaryElement ? (t0 = {
    boundaryElement
  }, $[0] = boundaryElement, $[1] = t0) : t0 = $[1];
  const {
    scrollToGroup
  } = useCommentsScroll(t0);
  let t1;
  $[2] !== props2.schemaType ? (t1 = getSchemaTypeTitle(props2.schemaType), $[2] = props2.schemaType, $[3] = t1) : t1 = $[3];
  const fieldTitle = t1;
  let t2;
  $[4] !== props2.path ? (t2 = PathUtils.toString(props2.path), $[4] = props2.path, $[5] = t2) : t2 = $[5];
  const stringPath = t2;
  let t3;
  $[6] !== stringPath ? (t3 = messageCache.get(stringPath) || null, $[6] = stringPath, $[7] = t3) : t3 = $[7];
  const cachedValue = t3, [value, setValue] = useState(cachedValue), isOpen = authoringPath === stringPath;
  let t4;
  $[8] !== isCommentsOpen || $[9] !== selectedPath?.fieldPath || $[10] !== selectedPath?.origin || $[11] !== stringPath ? (t4 = () => !isCommentsOpen || selectedPath?.origin === "form" || selectedPath?.origin === "url" ? !1 : selectedPath?.fieldPath === stringPath, $[8] = isCommentsOpen, $[9] = selectedPath?.fieldPath, $[10] = selectedPath?.origin, $[11] = stringPath, $[12] = t4) : t4 = $[12];
  const isSelected = t4();
  let t5;
  if ($[13] !== comments2.data.open || $[14] !== selectedPath?.threadId) {
    let t62;
    $[16] !== selectedPath?.threadId ? (t62 = (c2) => c2.threadId === selectedPath?.threadId, $[16] = selectedPath?.threadId, $[17] = t62) : t62 = $[17], t5 = comments2.data.open.filter(t62).some(_temp$$), $[13] = comments2.data.open, $[14] = selectedPath?.threadId, $[15] = t5;
  } else
    t5 = $[15];
  const isInlineCommentThread = t5;
  let t6;
  if ($[18] !== comments2.data.open || $[19] !== stringPath) {
    let t72;
    $[21] !== stringPath ? (t72 = (c_0) => c_0.fieldPath === stringPath ? c_0.commentsCount : 0, $[21] = stringPath, $[22] = t72) : t72 = $[22], t6 = comments2.data.open.map(t72).reduce(_temp2$m, 0), $[18] = comments2.data.open, $[19] = stringPath, $[20] = t6;
  } else
    t6 = $[20];
  const count2 = t6 || 0, hasComments = count2 > 0;
  let t7;
  $[23] !== stringPath ? (t7 = () => {
    setValue(null), messageCache.delete(stringPath);
  }, $[23] = stringPath, $[24] = t7) : t7 = $[24];
  const resetMessageValue = t7;
  let t8;
  $[25] !== comments2.data.open || $[26] !== handleOpenDialog || $[27] !== hasComments || $[28] !== isOpen || $[29] !== mode || $[30] !== onCommentsOpen || $[31] !== props2.path || $[32] !== scrollToGroup || $[33] !== setAuthoringPath || $[34] !== setSelectedPath || $[35] !== setStatus || $[36] !== status || $[37] !== stringPath || $[38] !== upsellData ? (t8 = () => {
    if (hasComments) {
      status === "resolved" && setStatus("open"), setAuthoringPath(null), onCommentsOpen?.();
      const scrollToThreadId = comments2.data.open.find((c_1) => c_1.fieldPath === PathUtils.toString(props2.path))?.threadId;
      scrollToThreadId && (setSelectedPath({
        threadId: scrollToThreadId,
        origin: "form",
        fieldPath: PathUtils.toString(props2.path)
      }), scrollToGroup(scrollToThreadId));
      return;
    }
    if (mode === "upsell") {
      upsellData ? handleOpenDialog("field_action") : onCommentsOpen?.();
      return;
    }
    setAuthoringPath(isOpen ? null : stringPath);
  }, $[25] = comments2.data.open, $[26] = handleOpenDialog, $[27] = hasComments, $[28] = isOpen, $[29] = mode, $[30] = onCommentsOpen, $[31] = props2.path, $[32] = scrollToGroup, $[33] = setAuthoringPath, $[34] = setSelectedPath, $[35] = setStatus, $[36] = status, $[37] = stringPath, $[38] = upsellData, $[39] = t8) : t8 = $[39];
  const handleClick = t8;
  let t9;
  $[40] !== onCommentsOpen || $[41] !== operation || $[42] !== props2.path || $[43] !== resetMessageValue || $[44] !== scrollToGroup || $[45] !== setSelectedPath || $[46] !== setStatus || $[47] !== status || $[48] !== value ? (t9 = () => {
    if (value) {
      const newThreadId = uuid(), nextComment = {
        type: "field",
        fieldPath: PathUtils.toString(props2.path),
        message: value,
        parentCommentId: void 0,
        status: "open",
        threadId: newThreadId,
        reactions: EMPTY_ARRAY$7
      };
      operation.create(nextComment), onCommentsOpen?.(), status === "resolved" && setStatus("open"), resetMessageValue(), setSelectedPath({
        threadId: newThreadId,
        origin: "form",
        fieldPath: PathUtils.toString(props2.path)
      }), scrollToGroup(newThreadId);
    }
  }, $[40] = onCommentsOpen, $[41] = operation, $[42] = props2.path, $[43] = resetMessageValue, $[44] = scrollToGroup, $[45] = setSelectedPath, $[46] = setStatus, $[47] = status, $[48] = value, $[49] = t9) : t9 = $[49];
  const handleCommentAdd = t9;
  let t10;
  $[50] !== setAuthoringPath ? (t10 = () => setAuthoringPath(null), $[50] = setAuthoringPath, $[51] = t10) : t10 = $[51];
  const handleClose = t10;
  let t11;
  $[52] !== stringPath ? (t11 = (nextValue) => {
    setValue(nextValue), messageCache.set(stringPath, nextValue);
  }, $[52] = stringPath, $[53] = t11) : t11 = $[53];
  const handleOnChange = t11;
  let t12;
  $[54] !== count2 || $[55] !== currentUser || $[56] !== fieldTitle || $[57] !== handleClick || $[58] !== handleClose || $[59] !== handleCommentAdd || $[60] !== handleOnChange || $[61] !== isCreatingDataset || $[62] !== isOpen || $[63] !== mentionOptions || $[64] !== resetMessageValue || $[65] !== value ? (t12 = currentUser && /* @__PURE__ */ jsx(CommentsFieldButton, { count: Number(count2), currentUser, fieldTitle, isCreatingDataset, mentionOptions, onChange: handleOnChange, onClick: handleClick, onClose: handleClose, onCommentAdd: handleCommentAdd, onDiscard: resetMessageValue, open: isOpen, value }), $[54] = count2, $[55] = currentUser, $[56] = fieldTitle, $[57] = handleClick, $[58] = handleClose, $[59] = handleCommentAdd, $[60] = handleOnChange, $[61] = isCreatingDataset, $[62] = isOpen, $[63] = mentionOptions, $[64] = resetMessageValue, $[65] = value, $[66] = t12) : t12 = $[66];
  let t13;
  $[67] !== hasComments || $[68] !== isOpen || $[69] !== t12 ? (t13 = {
    button: t12,
    hasComments,
    isAddingComment: isOpen
  }, $[67] = hasComments, $[68] = isOpen, $[69] = t12, $[70] = t13) : t13 = $[70];
  const internalComments = t13;
  let t14;
  $[71] !== props2.path ? (t14 = applyCommentsFieldAttr(PathUtils.toString(props2.path)), $[71] = props2.path, $[72] = t14) : t14 = $[72];
  let t15;
  $[73] !== internalComments || $[74] !== props2 ? (t15 = props2.renderDefault({
    ...props2,
    __internal_comments: internalComments
  }), $[73] = internalComments, $[74] = props2, $[75] = t15) : t15 = $[75];
  let t16;
  $[76] !== isInlineCommentThread || $[77] !== isSelected ? (t16 = isSelected && !isInlineCommentThread && /* @__PURE__ */ jsx(HighlightDiv, { animate: "animate", exit: "exit", initial: "initial", variants: HIGHLIGHT_BLOCK_VARIANTS }), $[76] = isInlineCommentThread, $[77] = isSelected, $[78] = t16) : t16 = $[78];
  let t17;
  $[79] !== t16 ? (t17 = /* @__PURE__ */ jsx(AnimatePresence, { children: t16 }), $[79] = t16, $[80] = t17) : t17 = $[80];
  let t18;
  return $[81] !== t14 || $[82] !== t15 || $[83] !== t17 ? (t18 = /* @__PURE__ */ jsxs(FieldStack, { ...t14, ref: rootRef, children: [
    t15,
    t17
  ] }), $[81] = t14, $[82] = t15, $[83] = t17, $[84] = t18) : t18 = $[84], t18;
}
function _temp2$m(acc, val) {
  return acc + val;
}
function _temp$$(x) {
  return isTextSelectionComment(x.parentComment);
}
function createDomRectFromElements(elements) {
  if (!elements || !elements.length) return null;
  const rects = elements.map((el) => el.getBoundingClientRect()), minX = Math.min(...rects.map((r) => r.x)) || 0, minY = Math.min(...rects.map((r) => r.y)) || 0, maxRight = Math.max(...rects.map((r) => r.right)) || 0, maxBottom = Math.max(...rects.map((r) => r.bottom)) || 0;
  return {
    x: minX,
    y: minY,
    width: maxRight - minX,
    height: maxBottom - minY,
    top: minY,
    right: maxRight,
    bottom: maxBottom,
    left: minX
  };
}
function useRectFromElements(props2) {
  const $ = c(5), {
    scrollElement,
    disabled,
    selector
  } = props2, [rect, setRect] = useState(null);
  let t0, t1;
  return $[0] !== disabled || $[1] !== scrollElement || $[2] !== selector ? (t0 = () => {
    if (disabled)
      return;
    const handleSetRect = () => {
      const elements = document?.querySelectorAll(selector);
      if (!elements)
        return;
      const nextRect = createDomRectFromElements(Array.from(elements));
      setRect(nextRect);
    };
    if (handleSetRect(), !!scrollElement)
      return scrollElement.addEventListener("wheel", handleSetRect), () => {
        scrollElement.removeEventListener("wheel", handleSetRect);
      };
  }, t1 = [scrollElement, disabled, selector], $[0] = disabled, $[1] = scrollElement, $[2] = selector, $[3] = t0, $[4] = t1) : (t0 = $[3], t1 = $[4]), useEffect(t0, t1), rect;
}
function useAuthoringReferenceElement(props2) {
  const $ = c(6), {
    scrollElement,
    disabled,
    selector
  } = props2;
  let t0;
  $[0] !== disabled || $[1] !== scrollElement || $[2] !== selector ? (t0 = {
    scrollElement,
    disabled,
    selector
  }, $[0] = disabled, $[1] = scrollElement, $[2] = selector, $[3] = t0) : t0 = $[3];
  const rect = useRectFromElements(t0);
  let t1;
  bb0: {
    if (!rect) {
      t1 = null;
      break bb0;
    }
    let t2;
    $[4] !== rect ? (t2 = {
      getBoundingClientRect: () => rect
    }, $[4] = rect, $[5] = t2) : t2 = $[5], t1 = t2;
  }
  return t1;
}
function getSelectionBoundingRect() {
  const selection = window.getSelection();
  let range2 = null;
  return selection && selection.rangeCount > 0 && (range2 = selection.getRangeAt(0)), range2?.getBoundingClientRect() || null;
}
const MotionPopover$1 = styled(motion.create(Popover)).withConfig({
  displayName: "MotionPopover",
  componentId: "sc-wmroq-0"
})`user-select:none;`, POPOVER_FALLBACK_PLACEMENTS$1 = ["bottom", "top"], VARIANTS$3 = {
  hidden: {
    opacity: 0,
    y: -4
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
function FloatingButtonPopover(props2) {
  const $ = c(13), {
    disabled,
    onClick: onClick2,
    onClickOutside,
    referenceElement
  } = props2, buttonRef = useRef(null), {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => [buttonRef.current], $[0] = t0) : t0 = $[0], useClickOutsideEvent(onClickOutside, t0);
  let t1;
  $[1] !== t ? (t1 = t("inline-add-comment-button.disabled-overlap-title"), $[1] = t, $[2] = t1) : t1 = $[2];
  const disabledText = t1;
  let t2;
  $[3] !== t ? (t2 = t("inline-add-comment-button.title"), $[3] = t, $[4] = t2) : t2 = $[4];
  const text = disabled ? disabledText : t2, t3 = disabled ? CommentDisabledIcon : AddCommentIcon;
  let t4;
  $[5] !== disabled || $[6] !== onClick2 || $[7] !== t3 || $[8] !== text ? (t4 = /* @__PURE__ */ jsx(Button, { "data-testid": "inline-comment-button", disabled, icon: t3, mode: "bleed", onClick: onClick2, ref: buttonRef, text }), $[5] = disabled, $[6] = onClick2, $[7] = t3, $[8] = text, $[9] = t4) : t4 = $[9];
  const content = t4;
  let t5;
  return $[10] !== content || $[11] !== referenceElement ? (t5 = /* @__PURE__ */ jsx(MotionPopover$1, { animate: "visible", content, contentEditable: !1, fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$1, initial: "hidden", open: !0, padding: 1, placement: "bottom", portal: !0, referenceElement, variants: VARIANTS$3 }), $[10] = content, $[11] = referenceElement, $[12] = t5) : t5 = $[12], t5;
}
const POPOVER_FALLBACK_PLACEMENTS = ["bottom", "top"], MotionPopover = motion.create(Popover), RootStack = styled(Stack).withConfig({
  displayName: "RootStack",
  componentId: "sc-w2wgl6-0"
})`width:250px;`, VARIANTS$2 = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1
  }
};
function InlineCommentInputPopover(props2) {
  const $ = c(17), {
    currentUser,
    mentionOptions,
    onChange,
    onClickOutside,
    onDiscardConfirm,
    onSubmit,
    referenceElement,
    value
  } = props2, commentInputRef = useRef(null), contentElementRef = useRef(null);
  let t0;
  $[0] !== onDiscardConfirm ? (t0 = () => {
    commentInputRef.current?.discardDialogController.close(), onDiscardConfirm();
  }, $[0] = onDiscardConfirm, $[1] = t0) : t0 = $[1];
  const handleDiscardConfirm = t0;
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    commentInputRef.current?.discardDialogController.close();
  }, $[2] = t1) : t1 = $[2];
  const handleDiscardCancel = t1;
  let t2;
  $[3] !== onClickOutside || $[4] !== value ? (t2 = () => {
    if (hasCommentMessageValue(value)) {
      commentInputRef.current?.discardDialogController.open();
      return;
    }
    onClickOutside();
  }, $[3] = onClickOutside, $[4] = value, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => [contentElementRef.current], $[6] = t3) : t3 = $[6], useClickOutsideEvent(t2, t3);
  let t4;
  $[7] !== currentUser || $[8] !== handleDiscardConfirm || $[9] !== mentionOptions || $[10] !== onChange || $[11] !== onSubmit || $[12] !== value ? (t4 = /* @__PURE__ */ jsx(RootStack, { padding: 2, ref: contentElementRef, children: /* @__PURE__ */ jsx(CommentInput, { currentUser, focusLock: !0, focusOnMount: !0, mentionOptions, onChange, onDiscardCancel: handleDiscardCancel, onDiscardConfirm: handleDiscardConfirm, onSubmit, ref: commentInputRef, value }) }), $[7] = currentUser, $[8] = handleDiscardConfirm, $[9] = mentionOptions, $[10] = onChange, $[11] = onSubmit, $[12] = value, $[13] = t4) : t4 = $[13];
  const content = t4;
  let t5;
  return $[14] !== content || $[15] !== referenceElement ? (t5 = /* @__PURE__ */ jsx(MotionPopover, { animate: "visible", content, "data-ui": "InlineCommentInputPopover", fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS, initial: "hidden", open: !0, placement: "bottom", portal: !0, referenceElement, variants: VARIANTS$2 }), $[14] = content, $[15] = referenceElement, $[16] = t5) : t5 = $[16], t5;
}
const EMPTY_ARRAY$6 = [], AI_ASSIST_TYPE = "sanity.assist.instruction.prompt";
function CommentsPortableTextInput(props2) {
  const $ = c(5), {
    enabled,
    mode
  } = useCommentsEnabled(), fieldActions = useFieldActions(), isAiAssist = props2.schemaType.name === AI_ASSIST_TYPE, isCommentsEnabledInField = !!fieldActions.__internal_comments;
  if (!enabled || isAiAssist || !isCommentsEnabledInField) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== mode || $[3] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommentsPortableTextInputInner, { ...props2, mode }), $[2] = mode, $[3] = props2, $[4] = t0) : t0 = $[4], t0;
}
const CommentsPortableTextInputInner = memo(function(props2) {
  const $ = c(98), {
    mode
  } = props2, currentUser = useCurrentUser(), portal = usePortal(), {
    comments: comments2,
    getComment,
    mentionOptions,
    onCommentsOpen,
    operation,
    setStatus,
    status
  } = useComments(), {
    error: addonDatasetError
  } = useAddonDataset(), {
    setSelectedPath,
    selectedPath
  } = useCommentsSelectedPath(), {
    scrollToComment,
    scrollToGroup
  } = useCommentsScroll(), {
    handleOpenDialog
  } = useCommentsUpsell(), [mousePressed, setMousePressed] = useState(!1), editorRef = useRef(null), [authoringDecorationElement, setAuthoringDecorationElement] = useState(null), [nextCommentValue, setNextCommentValue] = useState(null), [nextCommentSelection, setNextCommentSelection] = useState(null), [currentSelection, setCurrentSelection] = useState(null), [currentSelectionRect, setCurrenSelectionRect] = useState(null), [currentHoveredCommentId, setCurrentHoveredCommentId] = useState(null), [canSubmit, setCanSubmit] = useState(!1), [rootElement, setRootElement] = useState(null), [isFullScreen, setIsFullScreen] = useState(!1), [addedCommentsDecorations, setAddedCommentsDecorations] = useState(EMPTY_ARRAY$6);
  let t0;
  $[0] !== props2.path ? (t0 = PathUtils.toString(props2.path), $[0] = props2.path, $[1] = t0) : t0 = $[1];
  const stringFieldPath = t0, [fragment, setFragment] = useState(null);
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => editorRef.current ? PortableTextEditor.getFragment(editorRef.current) : EMPTY_ARRAY$6, $[2] = t1) : t1 = $[2];
  const getFragment = t1;
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    const rect = getSelectionBoundingRect();
    setCurrenSelectionRect(rect);
  }, $[3] = t2) : t2 = $[3];
  const handleSetCurrentSelectionRect = t2;
  let t3;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setCurrentSelection(null), setCurrenSelectionRect(null), setNextCommentSelection(null), setNextCommentValue(null), setCanSubmit(!1), setAuthoringDecorationElement(null), setFragment(null);
  }, $[4] = t3) : t3 = $[4];
  const resetStates = t3;
  let t4;
  $[5] !== currentSelection || $[6] !== handleOpenDialog || $[7] !== mode ? (t4 = () => {
    if (mode === "upsell") {
      handleOpenDialog("pte");
      return;
    }
    const currentFragment = getFragment() || null;
    setFragment(currentFragment), setNextCommentSelection(currentSelection);
  }, $[5] = currentSelection, $[6] = handleOpenDialog, $[7] = mode, $[8] = t4) : t4 = $[8];
  const handleSelectCurrentSelection = t4;
  let t5;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    resetStates();
  }, $[9] = t5) : t5 = $[9];
  const handleCommentDiscardConfirm = t5;
  let t6;
  if ($[10] !== comments2.data.open || $[11] !== stringFieldPath) {
    let t72;
    $[13] !== stringFieldPath ? (t72 = (comment) => comment.fieldPath === stringFieldPath, $[13] = stringFieldPath, $[14] = t72) : t72 = $[14], t6 = comments2.data.open.filter(t72).filter(_temp$_).map(_temp2$l), $[10] = comments2.data.open, $[11] = stringFieldPath, $[12] = t6;
  } else
    t6 = $[12];
  const textComments = t6;
  let t7;
  $[15] !== fragment || $[16] !== nextCommentSelection || $[17] !== nextCommentValue || $[18] !== onCommentsOpen || $[19] !== operation || $[20] !== scrollToGroup || $[21] !== setSelectedPath || $[22] !== setStatus || $[23] !== status || $[24] !== stringFieldPath ? (t7 = () => {
    if (!nextCommentSelection || !editorRef.current)
      return;
    const editorValue = PortableTextEditor.getValue(editorRef.current);
    if (!editorValue)
      return;
    const textSelection = buildTextSelectionFromFragment({
      fragment: fragment || EMPTY_ARRAY$6,
      selection: nextCommentSelection,
      value: editorValue
    }), threadId = uuid();
    operation.create({
      type: "field",
      contentSnapshot: fragment,
      fieldPath: stringFieldPath,
      message: nextCommentValue,
      parentCommentId: void 0,
      reactions: EMPTY_ARRAY$6,
      selection: textSelection,
      status: "open",
      threadId
    }), onCommentsOpen?.(), status === "resolved" && setStatus("open"), setSelectedPath({
      fieldPath: stringFieldPath,
      threadId,
      origin: "form"
    }), scrollToGroup(threadId), resetStates();
  }, $[15] = fragment, $[16] = nextCommentSelection, $[17] = nextCommentValue, $[18] = onCommentsOpen, $[19] = operation, $[20] = scrollToGroup, $[21] = setSelectedPath, $[22] = setStatus, $[23] = status, $[24] = stringFieldPath, $[25] = t7) : t7 = $[25];
  const handleSubmit = t7;
  let t8;
  $[26] !== getComment || $[27] !== onCommentsOpen || $[28] !== scrollToComment || $[29] !== setSelectedPath ? (t8 = (commentId) => {
    const comment_0 = getComment(commentId);
    comment_0 && (setSelectedPath({
      fieldPath: comment_0.target.path?.field || "",
      threadId: comment_0.threadId,
      origin: "form"
    }), onCommentsOpen?.(), scrollToComment(comment_0._id));
  }, $[26] = getComment, $[27] = onCommentsOpen, $[28] = scrollToComment, $[29] = setSelectedPath, $[30] = t8) : t8 = $[30];
  const handleDecoratorClick = t8, blurred = useRef(!1);
  let t9;
  $[31] !== mousePressed ? (t9 = (selection) => {
    const isRangeSelected = selection?.anchor.offset !== selection?.focus.offset;
    if (!getFragment()?.every(isPortableTextTextBlock) || !isRangeSelected) {
      setCanSubmit(!1);
      return;
    }
    if (blurred.current) {
      blurred.current = !1;
      return;
    }
    mousePressed || handleSetCurrentSelectionRect(), setCurrentSelection(selection), setCanSubmit(!0);
  }, $[31] = mousePressed, $[32] = t9) : t9 = $[32];
  const debounceSelectionChange = useDebounceSelectionChange(t9);
  let t10;
  $[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    startTransition(() => setMousePressed(!0));
  }, $[33] = t10) : t10 = $[33];
  const handleMouseDown = t10;
  let t11;
  $[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = () => {
    startTransition(() => setMousePressed(!1)), handleSetCurrentSelectionRect();
  }, $[34] = t11) : t11 = $[34];
  const handleMouseUp = t11;
  let t12;
  $[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = (details) => {
    const {
      rangeDecoration,
      newSelection
    } = details, commentId_0 = rangeDecoration.payload?.commentId;
    setAddedCommentsDecorations((prev) => prev.map((p) => p.payload?.commentId === commentId_0 ? {
      ...rangeDecoration,
      selection: newSelection,
      payload: {
        ...rangeDecoration.payload,
        dirty: !0
      }
    } : p));
  }, $[35] = t12) : t12 = $[35];
  const handleRangeDecorationMoved = t12;
  let t13;
  $[36] !== addedCommentsDecorations || $[37] !== getComment || $[38] !== operation ? (t13 = () => {
    const decoratorsToUpdate = addedCommentsDecorations.filter(_temp3$b);
    decoratorsToUpdate.length !== 0 && (decoratorsToUpdate.forEach((decorator_0) => {
      const commentId_1 = decorator_0.payload?.commentId, comment_1 = getComment(commentId_1 || "");
      if (!comment_1 || !editorRef.current)
        return;
      const editorValue_0 = PortableTextEditor.getValue(editorRef.current) || EMPTY_ARRAY$6, [updatedDecoration] = buildRangeDecorationSelectionsFromComments({
        comments: [comment_1],
        value: editorValue_0
      }), nextRange = updatedDecoration?.range ? [updatedDecoration.range] : EMPTY_ARRAY$6, nextValue = updatedDecoration ? [...comment_1.target.path?.selection?.value.filter((r) => r._key !== nextRange[0]?._key).concat(nextRange).flat().sort(_temp4$4) || EMPTY_ARRAY$6] : EMPTY_ARRAY$6, nextComment = {
        target: {
          ...comment_1.target,
          path: {
            ...comment_1.target?.path,
            field: comment_1.target.path?.field || "",
            selection: {
              type: "text",
              value: nextValue
            }
          }
        }
      };
      !isEqual$1(comment_1.target, nextComment.target) && operation.update(comment_1._id, nextComment);
    }), setAddedCommentsDecorations((prev_0) => prev_0.map((p_0) => decoratorsToUpdate.find((d) => d.payload?.commentId === p_0.payload?.commentId)?.payload?.dirty ? {
      ...p_0,
      payload: {
        ...p_0.payload,
        dirty: !1
      }
    } : p_0).filter(_temp5$3)));
  }, $[36] = addedCommentsDecorations, $[37] = getComment, $[38] = operation, $[39] = t13) : t13 = $[39];
  const updateCommentRange = t13;
  let t14;
  $[40] !== currentHoveredCommentId || $[41] !== handleDecoratorClick || $[42] !== selectedPath?.threadId ? (t14 = (commentsToDecorate) => {
    if (!editorRef.current)
      return EMPTY_ARRAY$6;
    const editorValue_1 = PortableTextEditor.getValue(editorRef.current) || EMPTY_ARRAY$6;
    return buildCommentRangeDecorations({
      comments: commentsToDecorate,
      currentHoveredCommentId,
      onDecorationClick: handleDecoratorClick,
      onDecorationHoverEnd: setCurrentHoveredCommentId,
      onDecorationHoverStart: setCurrentHoveredCommentId,
      onDecorationMoved: handleRangeDecorationMoved,
      selectedThreadId: selectedPath?.threadId || null,
      value: editorValue_1
    });
  }, $[40] = currentHoveredCommentId, $[41] = handleDecoratorClick, $[42] = selectedPath?.threadId, $[43] = t14) : t14 = $[43];
  const handleBuildRangeDecorations = t14;
  let t15;
  $[44] !== debounceSelectionChange || $[45] !== updateCommentRange ? (t15 = (change) => {
    change.type === "mutation" && updateCommentRange(), change.type === "blur" && (blurred.current = !0), change.type === "selection" && debounceSelectionChange(change.selection);
  }, $[44] = debounceSelectionChange, $[45] = updateCommentRange, $[46] = t15) : t15 = $[46];
  const onEditorChange = t15;
  let t16;
  bb0: {
    if (!nextCommentSelection) {
      t16 = null;
      break bb0;
    }
    let t172;
    $[47] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t172 = (t183) => {
      const {
        children
      } = t183;
      return /* @__PURE__ */ jsx(CommentInlineHighlightSpan, { isAuthoring: !0, ref: setAuthoringDecorationElement, children });
    }, $[47] = t172) : t172 = $[47];
    let t182;
    $[48] !== nextCommentSelection ? (t182 = {
      component: t172,
      selection: nextCommentSelection
    }, $[48] = nextCommentSelection, $[49] = t182) : t182 = $[49], t16 = t182;
  }
  const authoringDecoration = t16, t17 = props2?.rangeDecorations || EMPTY_ARRAY$6;
  let t18;
  $[50] !== addedCommentsDecorations || $[51] !== authoringDecoration || $[52] !== t17 ? (t18 = [...t17, ...authoringDecoration ? [authoringDecoration] : EMPTY_ARRAY$6, ...addedCommentsDecorations], $[50] = addedCommentsDecorations, $[51] = authoringDecoration, $[52] = t17, $[53] = t18) : t18 = $[53];
  const rangeDecorations = t18, [currentSelectionIsOverlapping, setCurrentSelectionIsOverlapping] = useState(!1);
  let t19, t20;
  $[54] !== addedCommentsDecorations || $[55] !== currentSelection ? (t19 = () => {
    startTransition(() => setCurrentSelectionIsOverlapping(() => !currentSelection || addedCommentsDecorations.length === 0 ? !1 : addedCommentsDecorations.some((d_0) => {
      if (!editorRef.current)
        return !1;
      const testA = PortableTextEditor.isSelectionsOverlapping(editorRef.current, currentSelection, d_0.selection), testB = PortableTextEditor.isSelectionsOverlapping(editorRef.current, d_0.selection, currentSelection);
      return testA || testB;
    })));
  }, t20 = [addedCommentsDecorations, currentSelection], $[54] = addedCommentsDecorations, $[55] = currentSelection, $[56] = t19, $[57] = t20) : (t19 = $[56], t20 = $[57]), useEffect(t19, t20);
  const scrollElement = isFullScreen ? document.body : portal.elements?.documentScrollElement || document.body, boundaryElement = isFullScreen ? portal.elements?.documentScrollElement || document.body : rootElement, t21 = !nextCommentSelection || !authoringDecorationElement;
  let t22;
  $[58] !== scrollElement || $[59] !== t21 ? (t22 = {
    scrollElement,
    disabled: t21,
    selector: '[data-inline-comment-state="authoring"]'
  }, $[58] = scrollElement, $[59] = t21, $[60] = t22) : t22 = $[60];
  const popoverAuthoringReferenceElement = useAuthoringReferenceElement(t22);
  let t23;
  bb1: {
    if (!currentSelectionRect) {
      t23 = null;
      break bb1;
    }
    let t242;
    $[61] !== currentSelectionRect ? (t242 = {
      getBoundingClientRect: () => currentSelectionRect
    }, $[61] = currentSelectionRect, $[62] = t242) : t242 = $[62], t23 = t242;
  }
  const selectionReferenceElement = t23;
  let t24, t25;
  $[63] !== currentSelection || $[64] !== scrollElement ? (t24 = () => {
    if (currentSelection)
      return scrollElement?.addEventListener("wheel", handleSetCurrentSelectionRect), () => {
        scrollElement?.removeEventListener("wheel", handleSetCurrentSelectionRect);
      };
  }, t25 = [currentSelection, scrollElement, handleSetCurrentSelectionRect], $[63] = currentSelection, $[64] = scrollElement, $[65] = t24, $[66] = t25) : (t24 = $[65], t25 = $[66]), useEffect(t24, t25);
  let t26, t27;
  $[67] !== handleBuildRangeDecorations || $[68] !== textComments ? (t26 = () => {
    const nextDecorations = handleBuildRangeDecorations(textComments);
    startTransition(() => setAddedCommentsDecorations((current) => nextDecorations.map((nextDecoration_1) => {
      const prevDecoration = current.find((p_2) => p_2.payload?.commentId === nextDecoration_1.payload?.commentId);
      return prevDecoration?.payload?.dirty ? {
        ...nextDecoration_1,
        payload: {
          ...nextDecoration_1.payload,
          dirty: prevDecoration.payload.dirty
        }
      } : nextDecoration_1;
    })));
  }, t27 = [handleBuildRangeDecorations, textComments], $[67] = handleBuildRangeDecorations, $[68] = textComments, $[69] = t26, $[70] = t27) : (t26 = $[69], t27 = $[70]), useEffect(t26, t27);
  const showFloatingButton = !!(currentSelection && canSubmit && selectionReferenceElement && !mousePressed), showFloatingInput = !!(nextCommentSelection && popoverAuthoringReferenceElement);
  let t28;
  $[71] !== currentUser || $[72] !== handleSubmit || $[73] !== mentionOptions || $[74] !== nextCommentValue || $[75] !== popoverAuthoringReferenceElement || $[76] !== showFloatingInput ? (t28 = showFloatingInput && currentUser && /* @__PURE__ */ jsx(InlineCommentInputPopover, { currentUser, mentionOptions, onChange: setNextCommentValue, onClickOutside: resetStates, onDiscardConfirm: handleCommentDiscardConfirm, onSubmit: handleSubmit, referenceElement: popoverAuthoringReferenceElement, value: nextCommentValue }), $[71] = currentUser, $[72] = handleSubmit, $[73] = mentionOptions, $[74] = nextCommentValue, $[75] = popoverAuthoringReferenceElement, $[76] = showFloatingInput, $[77] = t28) : t28 = $[77];
  let t29;
  $[78] !== addonDatasetError || $[79] !== currentSelectionIsOverlapping || $[80] !== handleSelectCurrentSelection || $[81] !== selectionReferenceElement || $[82] !== showFloatingButton || $[83] !== showFloatingInput ? (t29 = showFloatingButton && !showFloatingInput && /* @__PURE__ */ jsx(FloatingButtonPopover, { disabled: currentSelectionIsOverlapping || !!addonDatasetError, onClick: handleSelectCurrentSelection, onClickOutside: resetStates, referenceElement: selectionReferenceElement }), $[78] = addonDatasetError, $[79] = currentSelectionIsOverlapping, $[80] = handleSelectCurrentSelection, $[81] = selectionReferenceElement, $[82] = showFloatingButton, $[83] = showFloatingInput, $[84] = t29) : t29 = $[84];
  let t30;
  $[85] !== t28 || $[86] !== t29 ? (t30 = /* @__PURE__ */ jsxs(AnimatePresence, { children: [
    t28,
    t29
  ] }), $[85] = t28, $[86] = t29, $[87] = t30) : t30 = $[87];
  let t31;
  $[88] !== boundaryElement || $[89] !== t30 ? (t31 = /* @__PURE__ */ jsx(BoundaryElementProvider, { element: boundaryElement, children: t30 }), $[88] = boundaryElement, $[89] = t30, $[90] = t31) : t31 = $[90];
  let t32;
  $[91] !== onEditorChange || $[92] !== props2 || $[93] !== rangeDecorations ? (t32 = /* @__PURE__ */ jsx(Stack, { ref: setRootElement, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, children: /* @__PURE__ */ jsx(RenderDefaultCommentsPortableTextInputInner, { ...props2, onEditorChange, editorRef, rangeDecorations, onFullScreenChange: setIsFullScreen }) }), $[91] = onEditorChange, $[92] = props2, $[93] = rangeDecorations, $[94] = t32) : t32 = $[94];
  let t33;
  return $[95] !== t31 || $[96] !== t32 ? (t33 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t31,
    t32
  ] }), $[95] = t31, $[96] = t32, $[97] = t33) : t33 = $[97], t33;
});
function useDebounceSelectionChange(handleSelectionChange) {
  const $ = c(2);
  let t0;
  return $[0] !== handleSelectionChange ? (t0 = debounce(handleSelectionChange, 200), $[0] = handleSelectionChange, $[1] = t0) : t0 = $[1], t0;
}
function RenderDefaultCommentsPortableTextInputInner(props2) {
  return props2.renderDefault(props2);
}
function _temp$_(c2) {
  return isTextSelectionComment(c2.parentComment);
}
function _temp2$l(c_0) {
  return c_0.parentComment;
}
function _temp3$b(decorator) {
  return decorator.payload?.dirty;
}
function _temp4$4(a, b) {
  return a._key.localeCompare(b._key);
}
function _temp5$3(p_1) {
  return p_1.selection !== null;
}
function isPortableTextInputProps(inputProps) {
  return isArrayOfBlocksSchemaType(inputProps.schemaType);
}
function CommentsInput(props2) {
  const $ = c(4);
  if (isPortableTextInputProps(props2)) {
    let t02;
    return $[0] !== props2 ? (t02 = /* @__PURE__ */ jsx(CommentsPortableTextInput, { ...props2 }), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== props2 ? (t0 = props2.renderDefault(props2), $[2] = props2, $[3] = t0) : t0 = $[3], t0;
}
function AddonDatasetProviderInner(props2) {
  const $ = c(25), {
    children
  } = props2, {
    dataset,
    projectId
  } = useWorkspace(), originalClient = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), [addonDatasetClient, setAddonDatasetClient] = useState(null), [isCreatingDataset, setIsCreatingDataset] = useState(!1), [ready, setReady] = useState(!1), [error, setError] = useState(null);
  let t0;
  $[0] !== dataset || $[1] !== originalClient || $[2] !== projectId ? (t0 = async () => (await originalClient.request({
    uri: `/projects/${projectId}/datasets?datasetProfile=comments&addonFor=${dataset}`,
    tag: "sanity.studio"
  }))?.[0]?.name, $[0] = dataset, $[1] = originalClient, $[2] = projectId, $[3] = t0) : t0 = $[3];
  const getAddonDatasetName = t0;
  let t1;
  $[4] !== originalClient || $[5] !== projectId ? (t1 = (addonDatasetName) => originalClient.withConfig({
    dataset: addonDatasetName,
    projectId,
    requestTagPrefix: "sanity.studio",
    useCdn: !1
  }), $[4] = originalClient, $[5] = projectId, $[6] = t1) : t1 = $[6];
  const handleCreateClient = t1;
  let t2;
  $[7] !== dataset || $[8] !== getAddonDatasetName || $[9] !== handleCreateClient || $[10] !== originalClient ? (t2 = async () => {
    setIsCreatingDataset(!0);
    try {
      const addonDatasetName_0 = await getAddonDatasetName();
      if (addonDatasetName_0) {
        const client_0 = handleCreateClient(addonDatasetName_0);
        return setAddonDatasetClient(client_0), setIsCreatingDataset(!1), client_0;
      }
    } catch {
    }
    return (async () => {
      const datasetName = (await originalClient.request({
        uri: `/comments/${dataset}/setup`,
        method: "POST"
      }))?.datasetName;
      if (!datasetName)
        return setIsCreatingDataset(!1), null;
      const client_1 = handleCreateClient(datasetName);
      return setAddonDatasetClient(client_1), client_1;
    })().finally(() => {
      setIsCreatingDataset(!1);
    });
  }, $[7] = dataset, $[8] = getAddonDatasetName, $[9] = handleCreateClient, $[10] = originalClient, $[11] = t2) : t2 = $[11];
  const handleCreateAddonDataset = t2;
  let t3, t4;
  $[12] !== getAddonDatasetName || $[13] !== handleCreateClient ? (t3 = () => {
    getAddonDatasetName().then((addonDatasetName_1) => {
      if (!addonDatasetName_1)
        return;
      const client_2 = handleCreateClient(addonDatasetName_1);
      setAddonDatasetClient(client_2);
    }).catch((err) => {
      setError(err);
    }).finally(() => {
      setReady(!0);
    });
  }, t4 = [getAddonDatasetName, handleCreateClient], $[12] = getAddonDatasetName, $[13] = handleCreateClient, $[14] = t3, $[15] = t4) : (t3 = $[14], t4 = $[15]), useEffect(t3, t4);
  let t5;
  $[16] !== addonDatasetClient || $[17] !== error || $[18] !== handleCreateAddonDataset || $[19] !== isCreatingDataset || $[20] !== ready ? (t5 = {
    client: addonDatasetClient,
    createAddonDataset: handleCreateAddonDataset,
    isCreatingDataset,
    ready,
    error
  }, $[16] = addonDatasetClient, $[17] = error, $[18] = handleCreateAddonDataset, $[19] = isCreatingDataset, $[20] = ready, $[21] = t5) : t5 = $[21];
  const ctxValue = t5;
  let t6;
  return $[22] !== children || $[23] !== ctxValue ? (t6 = /* @__PURE__ */ jsx(AddonDatasetContext.Provider, { value: ctxValue, children }), $[22] = children, $[23] = ctxValue, $[24] = t6) : t6 = $[24], t6;
}
function AddonDatasetProvider(props2) {
  const $ = c(2);
  if (useContext(AddonDatasetContext))
    return props2.children;
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(AddonDatasetProviderInner, { ...props2 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function CommentsInspectorError(t0) {
  const $ = c(9), {
    error
  } = t0, {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t1;
  $[0] !== t ? (t1 = t("inspector-error.title"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t1 }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== error.message ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: error.message }), $[4] = error.message, $[5] = t3) : t3 = $[5];
  let t4;
  return $[6] !== t2 || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Card, { paddingX: 2, paddingY: 3, tone: "critical", border: !0, radius: 3, children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t2,
    t3
  ] }) }) }), $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
const Root$b = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-1vekini-0"
})({
  position: "relative",
  zIndex: "1",
  lineHeight: "0"
}), CommentsInspectorHeader = forwardRef(function(props2, ref) {
  const $ = c(57), {
    t
  } = useTranslation(commentsLocaleNamespace), {
    onClose,
    onViewChange,
    view,
    mode
  } = props2;
  let t0;
  $[0] !== onViewChange ? (t0 = () => onViewChange("open"), $[0] = onViewChange, $[1] = t0) : t0 = $[1];
  const handleSetOpenView = t0;
  let t1;
  $[2] !== onViewChange ? (t1 = () => onViewChange("resolved"), $[2] = onViewChange, $[3] = t1) : t1 = $[3];
  const handleSetResolvedView = t1;
  let t2;
  $[4] !== t ? (t2 = t("feature-name"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Flex, { align: "center", flex: 1, gap: 2, paddingY: 2, padding: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "h1", size: 1, weight: "medium", children: t2 }) }), $[6] = t2, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t || $[9] !== view ? (t4 = t(view === "open" ? "status-filter.status-open" : "status-filter.status-resolved"), $[8] = t, $[9] = view, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { text: t4, mode: "bleed", iconRight: ChevronDownIcon }), $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    width: "180px"
  }, $[13] = t6) : t6 = $[13];
  const t7 = view === "open" ? CheckmarkIcon : void 0;
  let t8;
  $[14] !== t ? (t8 = t("status-filter.status-open-full"), $[14] = t, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] !== handleSetOpenView || $[17] !== t7 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsx(MenuItem, { iconRight: t7, onClick: handleSetOpenView, text: t8 }), $[16] = handleSetOpenView, $[17] = t7, $[18] = t8, $[19] = t9) : t9 = $[19];
  const t10 = view === "resolved" ? CheckmarkIcon : void 0;
  let t11;
  $[20] !== t ? (t11 = t("status-filter.status-resolved-full"), $[20] = t, $[21] = t11) : t11 = $[21];
  let t12;
  $[22] !== mode || $[23] !== t ? (t12 = mode === "upsell" ? {
    content: t("status-filter.status-resolved-full-upsell")
  } : void 0, $[22] = mode, $[23] = t, $[24] = t12) : t12 = $[24];
  const t13 = mode === "upsell";
  let t14;
  $[25] !== handleSetResolvedView || $[26] !== t10 || $[27] !== t11 || $[28] !== t12 || $[29] !== t13 ? (t14 = /* @__PURE__ */ jsx(MenuItem, { iconRight: t10, onClick: handleSetResolvedView, text: t11, tooltipProps: t12, disabled: t13 }), $[25] = handleSetResolvedView, $[26] = t10, $[27] = t11, $[28] = t12, $[29] = t13, $[30] = t14) : t14 = $[30];
  let t15;
  $[31] !== t14 || $[32] !== t9 ? (t15 = /* @__PURE__ */ jsxs(Menu, { style: t6, children: [
    t9,
    t14
  ] }), $[31] = t14, $[32] = t9, $[33] = t15) : t15 = $[33];
  let t16;
  $[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = {
    placement: "bottom-end"
  }, $[34] = t16) : t16 = $[34];
  let t17;
  $[35] !== t15 || $[36] !== t5 ? (t17 = /* @__PURE__ */ jsx(MenuButton, { id: "comment-status-menu-button", button: t5, menu: t15, popover: t16 }), $[35] = t15, $[36] = t5, $[37] = t17) : t17 = $[37];
  let t18;
  $[38] !== t ? (t18 = t("close-pane-button-text-aria-label"), $[38] = t, $[39] = t18) : t18 = $[39];
  let t19;
  $[40] !== t ? (t19 = t("close-pane-button-text"), $[40] = t, $[41] = t19) : t19 = $[41];
  let t20;
  $[42] !== t19 ? (t20 = {
    content: t19
  }, $[42] = t19, $[43] = t20) : t20 = $[43];
  let t21;
  $[44] !== onClose || $[45] !== t18 || $[46] !== t20 ? (t21 = /* @__PURE__ */ jsx(Button, { "aria-label": t18, icon: CloseIcon, mode: "bleed", onClick: onClose, tooltipProps: t20 }), $[44] = onClose, $[45] = t18, $[46] = t20, $[47] = t21) : t21 = $[47];
  let t22;
  $[48] !== t17 || $[49] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Flex, { flex: "none", padding: 1, gap: 2, children: [
    t17,
    t21
  ] }), $[48] = t17, $[49] = t21, $[50] = t22) : t22 = $[50];
  let t23;
  $[51] !== t22 || $[52] !== t3 ? (t23 = /* @__PURE__ */ jsxs(Flex, { padding: 2, children: [
    t3,
    t22
  ] }), $[51] = t22, $[52] = t3, $[53] = t23) : t23 = $[53];
  let t24;
  return $[54] !== ref || $[55] !== t23 ? (t24 = /* @__PURE__ */ jsx(Root$b, { ref, children: t23 }), $[54] = ref, $[55] = t23, $[56] = t24) : t24 = $[56], t24;
}), RootLayer$1 = styled(Layer).withConfig({
  displayName: "RootLayer",
  componentId: "sc-clw1pq-0"
})`display:flex;flex-direction:column;height:100%;overflow:hidden;`;
function CommentsInspector(props2) {
  const $ = c(3), {
    enabled,
    mode
  } = useCommentsEnabled();
  if (!enabled)
    return null;
  let t0;
  return $[0] !== mode || $[1] !== props2 ? (t0 = /* @__PURE__ */ jsx(RootLayer$1, { children: /* @__PURE__ */ jsx(CommentsInspectorInner, { ...props2, mode }) }), $[0] = mode, $[1] = props2, $[2] = t0) : t0 = $[2], t0;
}
function CommentsInspectorInner(props2) {
  const $ = c(122), {
    t
  } = useTranslation(commentsLocaleNamespace), {
    onClose,
    mode
  } = props2, [showDeleteDialog, setShowDeleteDialog] = useState(!1), [commentToDelete, setCommentToDelete] = useState(null), [deleteLoading, setDeleteLoading] = useState(!1), [deleteError, setDeleteError] = useState(null), rootRef = useRef(null), [rootElement, setRootElement] = useState(null), currentUser = useCurrentUser(), {
    comments: comments2,
    getComment,
    isCreatingDataset,
    mentionOptions,
    setStatus,
    status,
    operation,
    selectedCommentId,
    getCommentLink,
    onClearSelectedComment,
    onPathOpen
  } = useComments(), commentIdParamRef = useRef(selectedCommentId), {
    error: addonDatasetError
  } = useAddonDataset(), didScrollToCommentFromParam = useRef(!1), pushToast = useToast().push, {
    isTopLayer
  } = useLayer();
  let t0;
  $[0] !== rootElement ? (t0 = {
    boundaryElement: rootElement
  }, $[0] = rootElement, $[1] = t0) : t0 = $[1];
  const {
    scrollToComment,
    scrollToField,
    scrollToInlineComment
  } = useCommentsScroll(t0), {
    selectedPath,
    setSelectedPath
  } = useCommentsSelectedPath(), {
    isDismissed,
    setDismissed
  } = useCommentsOnboarding(), telemetry = useCommentsTelemetry(), {
    upsellData,
    telemetryLogs: upsellTelemetryLogs
  } = useCommentsUpsell(), currentComments = comments2.data[status], {
    loading
  } = comments2;
  let t1;
  $[2] !== setSelectedPath || $[3] !== setStatus || $[4] !== telemetry ? (t1 = (nextView) => {
    setStatus(nextView), setSelectedPath(null), telemetry.commentListViewChanged(nextView);
  }, $[2] = setSelectedPath, $[3] = setStatus, $[4] = telemetry, $[5] = t1) : t1 = $[5];
  const handleChangeView = t1;
  let t2;
  $[6] !== onClose || $[7] !== setSelectedPath ? (t2 = () => {
    onClose(), setSelectedPath(null);
  }, $[6] = onClose, $[7] = setSelectedPath, $[8] = t2) : t2 = $[8];
  const handleCloseInspector = t2;
  let t3;
  bb0: {
    if (!getCommentLink) {
      t3 = void 0;
      break bb0;
    }
    let t42;
    $[9] !== getCommentLink || $[10] !== pushToast || $[11] !== t || $[12] !== telemetry ? (t42 = (id2) => {
      navigator.clipboard.writeText(getCommentLink(id2)).catch(() => {
        pushToast({
          closable: !0,
          status: "error",
          title: t("copy-link-error-message")
        });
      }), telemetry.commentLinkCopied();
    }, $[9] = getCommentLink, $[10] = pushToast, $[11] = t, $[12] = telemetry, $[13] = t42) : t42 = $[13], t3 = t42;
  }
  const handleCopyLink = t3;
  let t4;
  $[14] !== getComment || $[15] !== operation ? (t4 = (id_0) => {
    const comment = getComment(id_0);
    comment && operation.create({
      type: "field",
      fieldPath: comment.target.path?.field || "",
      id: comment._id,
      message: comment.message,
      parentCommentId: comment.parentCommentId,
      reactions: comment.reactions || [],
      status: comment.status,
      threadId: comment.threadId
    });
  }, $[14] = getComment, $[15] = operation, $[16] = t4) : t4 = $[16];
  const handleCreateRetry = t4;
  let t5;
  $[17] !== deleteLoading ? (t5 = () => {
    deleteLoading || (setShowDeleteDialog(!1), setCommentToDelete(null));
  }, $[17] = deleteLoading, $[18] = t5) : t5 = $[18];
  const closeDeleteDialog = t5;
  let t6;
  $[19] !== comments2.data.open || $[20] !== onPathOpen || $[21] !== scrollToField || $[22] !== scrollToInlineComment || $[23] !== setSelectedPath ? (t6 = (nextPath) => {
    if (setSelectedPath(nextPath), nextPath?.fieldPath) {
      const path = PathUtils.fromString(nextPath.fieldPath);
      onPathOpen?.(path), scrollToField(nextPath.fieldPath), comments2.data.open.filter((c2) => c2.threadId === nextPath?.threadId).some(_temp$Z) && nextPath.threadId && scrollToInlineComment(nextPath.threadId);
    }
  }, $[19] = comments2.data.open, $[20] = onPathOpen, $[21] = scrollToField, $[22] = scrollToInlineComment, $[23] = setSelectedPath, $[24] = t6) : t6 = $[24];
  const handlePathSelect = t6;
  let t7;
  $[25] !== operation || $[26] !== setSelectedPath ? (t7 = (nextComment) => {
    const fieldPath = nextComment?.payload?.fieldPath || "";
    operation.create({
      type: "field",
      fieldPath,
      message: nextComment.message,
      parentCommentId: nextComment.parentCommentId,
      reactions: nextComment.reactions,
      status: nextComment.status,
      threadId: nextComment.threadId
    }), setSelectedPath({
      fieldPath,
      origin: "inspector",
      threadId: nextComment.threadId
    });
  }, $[25] = operation, $[26] = setSelectedPath, $[27] = t7) : t7 = $[27];
  const handleNewThreadCreate = t7;
  let t8;
  $[28] !== operation ? (t8 = (nextComment_0) => {
    operation.create({
      ...nextComment_0,
      type: "field",
      fieldPath: nextComment_0?.payload?.fieldPath || ""
    });
  }, $[28] = operation, $[29] = t8) : t8 = $[29];
  const handleReply = t8;
  let t9;
  $[30] !== operation ? (t9 = (id_1, nextComment_1) => {
    operation.update(id_1, nextComment_1);
  }, $[30] = operation, $[31] = t9) : t9 = $[31];
  const handleEdit = t9;
  let t10;
  $[32] !== currentComments ? (t10 = (id_2) => {
    const parent = currentComments.find((c_0) => c_0.parentComment?._id === id_2), isParent = !!(parent && parent?.replies?.length > 0);
    setShowDeleteDialog(!0), setCommentToDelete({
      commentId: id_2,
      isParent
    });
  }, $[32] = currentComments, $[33] = t10) : t10 = $[33];
  const onDeleteStart = t10;
  let t11;
  $[34] !== closeDeleteDialog || $[35] !== operation ? (t11 = async (id_3) => {
    try {
      setDeleteLoading(!0), await operation.remove(id_3), closeDeleteDialog();
    } catch (t122) {
      setDeleteError(t122);
    }
    setDeleteLoading(!1);
  }, $[34] = closeDeleteDialog, $[35] = operation, $[36] = t11) : t11 = $[36];
  const handleDeleteConfirm = t11;
  let t12;
  $[37] !== getComment || $[38] !== operation || $[39] !== scrollToComment || $[40] !== setSelectedPath || $[41] !== setStatus ? (t12 = (id_4, nextStatus) => {
    if (operation.update(id_4, {
      status: nextStatus
    }), nextStatus === "open") {
      setStatus("open");
      const comment_0 = getComment(id_4);
      if (!comment_0)
        return;
      setSelectedPath({
        fieldPath: comment_0.target.path?.field || null,
        origin: "inspector",
        threadId: comment_0.threadId || null
      }), scrollToComment(id_4);
    }
  }, $[37] = getComment, $[38] = operation, $[39] = scrollToComment, $[40] = setSelectedPath, $[41] = setStatus, $[42] = t12) : t12 = $[42];
  const handleStatusChange = t12;
  let t13;
  $[43] !== operation ? (t13 = (id_5, reaction) => {
    operation.react(id_5, reaction);
  }, $[43] = operation, $[44] = t13) : t13 = $[44];
  const handleReactionSelect = t13;
  let t14;
  $[45] !== isTopLayer || $[46] !== selectedPath || $[47] !== setSelectedPath ? (t14 = () => {
    selectedPath && isTopLayer && setSelectedPath(null);
  }, $[45] = isTopLayer, $[46] = selectedPath, $[47] = setSelectedPath, $[48] = t14) : t14 = $[48];
  const handleDeselectPath = t14;
  let t15;
  $[49] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = (element) => {
    rootRef.current = element, setRootElement(element);
  }, $[49] = t15) : t15 = $[49];
  const setRootRef = t15;
  let t16;
  $[50] !== handleDeselectPath ? (t16 = (event) => {
    event.target instanceof HTMLElement && event.target?.hasAttribute("data-slate-string") || handleDeselectPath();
  }, $[50] = handleDeselectPath, $[51] = t16) : t16 = $[51];
  let t17;
  $[52] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t17 = () => [rootRef.current], $[52] = t17) : t17 = $[52], useClickOutsideEvent(t16, t17);
  const [loggedTelemetry, setLoggedTelemetry] = useState(!1);
  let t18;
  $[53] !== loggedTelemetry || $[54] !== mode || $[55] !== selectedPath?.origin || $[56] !== upsellTelemetryLogs ? (t18 = () => {
    if (!(loggedTelemetry || mode !== "upsell"))
      return setLoggedTelemetry(!0), selectedPath?.origin === "form" ? upsellTelemetryLogs.panelViewed("field_action") : commentIdParamRef.current ? upsellTelemetryLogs.panelViewed("link") : upsellTelemetryLogs.panelViewed("document_action"), () => {
        upsellTelemetryLogs.panelDismissed();
      };
  }, $[53] = loggedTelemetry, $[54] = mode, $[55] = selectedPath?.origin, $[56] = upsellTelemetryLogs, $[57] = t18) : t18 = $[57];
  const t19 = selectedPath?.origin;
  let t20;
  $[58] !== loggedTelemetry || $[59] !== mode || $[60] !== t19 || $[61] !== upsellTelemetryLogs ? (t20 = [loggedTelemetry, mode, t19, upsellTelemetryLogs], $[58] = loggedTelemetry, $[59] = mode, $[60] = t19, $[61] = upsellTelemetryLogs, $[62] = t20) : t20 = $[62], useEffect(t18, t20);
  let t21, t22;
  $[63] !== getComment || $[64] !== handlePathSelect || $[65] !== loading || $[66] !== onClearSelectedComment || $[67] !== scrollToComment || $[68] !== setStatus || $[69] !== telemetry ? (t21 = () => {
    const commentToScrollTo = getComment(commentIdParamRef.current || "");
    !loading && commentToScrollTo && !didScrollToCommentFromParam.current && (setStatus(commentToScrollTo.status || "open"), handlePathSelect({
      fieldPath: commentToScrollTo.target.path?.field || null,
      origin: "url",
      threadId: commentToScrollTo.threadId || null
    }), requestAnimationFrame(() => {
      scrollToComment(commentToScrollTo._id);
    }), didScrollToCommentFromParam.current = !0, commentIdParamRef.current = void 0, onClearSelectedComment?.(), telemetry.commentViewedFromLink());
  }, t22 = [getComment, handlePathSelect, loading, onClearSelectedComment, scrollToComment, setStatus, telemetry], $[63] = getComment, $[64] = handlePathSelect, $[65] = loading, $[66] = onClearSelectedComment, $[67] = scrollToComment, $[68] = setStatus, $[69] = telemetry, $[70] = t21, $[71] = t22) : (t21 = $[70], t22 = $[71]), useEffect(t21, t22);
  let t23;
  bb1: {
    if (mode === "upsell" && upsellData) {
      let t242;
      $[72] !== upsellData || $[73] !== upsellTelemetryLogs.panelPrimaryClicked || $[74] !== upsellTelemetryLogs.panelSecondaryClicked ? (t242 = /* @__PURE__ */ jsx(CommentsUpsellPanel, { data: upsellData, onPrimaryClick: upsellTelemetryLogs.panelPrimaryClicked, onSecondaryClick: upsellTelemetryLogs.panelSecondaryClicked }), $[72] = upsellData, $[73] = upsellTelemetryLogs.panelPrimaryClicked, $[74] = upsellTelemetryLogs.panelSecondaryClicked, $[75] = t242) : t242 = $[75], t23 = t242;
      break bb1;
    }
    t23 = null;
  }
  const beforeListNode = t23;
  let t24;
  $[76] !== closeDeleteDialog || $[77] !== commentToDelete || $[78] !== deleteError || $[79] !== deleteLoading || $[80] !== handleDeleteConfirm || $[81] !== showDeleteDialog ? (t24 = commentToDelete && showDeleteDialog && /* @__PURE__ */ jsx(CommentDeleteDialog, { ...commentToDelete, error: deleteError, loading: deleteLoading, onClose: closeDeleteDialog, onConfirm: handleDeleteConfirm }), $[76] = closeDeleteDialog, $[77] = commentToDelete, $[78] = deleteError, $[79] = deleteLoading, $[80] = handleDeleteConfirm, $[81] = showDeleteDialog, $[82] = t24) : t24 = $[82];
  const t25 = !isDismissed;
  let t26;
  $[83] !== handleChangeView || $[84] !== handleCloseInspector || $[85] !== mode || $[86] !== status ? (t26 = /* @__PURE__ */ jsx(CommentsInspectorHeader, { onClose: handleCloseInspector, onViewChange: handleChangeView, view: status, mode }), $[83] = handleChangeView, $[84] = handleCloseInspector, $[85] = mode, $[86] = status, $[87] = t26) : t26 = $[87];
  let t27;
  $[88] !== setDismissed || $[89] !== t25 || $[90] !== t26 ? (t27 = /* @__PURE__ */ jsx(CommentsOnboardingPopover, { onDismiss: setDismissed, open: t25, placement: "left-start", children: t26 }), $[88] = setDismissed, $[89] = t25, $[90] = t26, $[91] = t27) : t27 = $[91];
  let t28;
  $[92] !== addonDatasetError ? (t28 = addonDatasetError && /* @__PURE__ */ jsx(CommentsInspectorError, { error: addonDatasetError }), $[92] = addonDatasetError, $[93] = t28) : t28 = $[93];
  let t29;
  $[94] !== beforeListNode || $[95] !== comments2.error || $[96] !== currentComments || $[97] !== currentUser || $[98] !== handleCopyLink || $[99] !== handleCreateRetry || $[100] !== handleEdit || $[101] !== handleNewThreadCreate || $[102] !== handlePathSelect || $[103] !== handleReactionSelect || $[104] !== handleReply || $[105] !== handleStatusChange || $[106] !== isCreatingDataset || $[107] !== loading || $[108] !== mentionOptions || $[109] !== mode || $[110] !== onDeleteStart || $[111] !== selectedPath || $[112] !== status ? (t29 = currentUser && /* @__PURE__ */ jsx(CommentsList, { beforeListNode, comments: currentComments, currentUser, error: comments2.error, loading, mentionOptions, mode, onCopyLink: handleCopyLink, onCreateRetry: handleCreateRetry, onDelete: onDeleteStart, onEdit: handleEdit, onNewThreadCreate: handleNewThreadCreate, onPathSelect: handlePathSelect, onReactionSelect: handleReactionSelect, onReply: handleReply, onStatusChange: handleStatusChange, readOnly: isCreatingDataset, selectedPath, status }), $[94] = beforeListNode, $[95] = comments2.error, $[96] = currentComments, $[97] = currentUser, $[98] = handleCopyLink, $[99] = handleCreateRetry, $[100] = handleEdit, $[101] = handleNewThreadCreate, $[102] = handlePathSelect, $[103] = handleReactionSelect, $[104] = handleReply, $[105] = handleStatusChange, $[106] = isCreatingDataset, $[107] = loading, $[108] = mentionOptions, $[109] = mode, $[110] = onDeleteStart, $[111] = selectedPath, $[112] = status, $[113] = t29) : t29 = $[113];
  let t30;
  $[114] !== handleDeselectPath || $[115] !== t27 || $[116] !== t28 || $[117] !== t29 ? (t30 = /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, height: "fill", onClick: handleDeselectPath, overflow: "hidden", ref: setRootRef, children: [
    t27,
    t28,
    t29
  ] }), $[114] = handleDeselectPath, $[115] = t27, $[116] = t28, $[117] = t29, $[118] = t30) : t30 = $[118];
  let t31;
  return $[119] !== t24 || $[120] !== t30 ? (t31 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t24,
    t30
  ] }), $[119] = t24, $[120] = t30, $[121] = t31) : t31 = $[121], t31;
}
function _temp$Z(x) {
  return isTextSelectionComment(x.parentComment);
}
function useMenuItem() {
  const $ = c(5), {
    t
  } = useTranslation(commentsLocaleNamespace), {
    enabled
  } = useCommentsEnabled(), t0 = !enabled;
  let t1;
  $[0] !== t ? (t1 = t("feature-name"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== t0 || $[3] !== t1 ? (t2 = {
    hidden: t0,
    icon: CommentIcon,
    showAsAction: !0,
    title: t1
  }, $[2] = t0, $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
const commentsInspector = {
  name: COMMENTS_INSPECTOR_NAME,
  component: CommentsInspector,
  useMenuItem
};
function CommentsStudioLayout(props2) {
  const $ = c(8), {
    enabled,
    isLoading
  } = useFeatureEnabled(FEATURES.studioComments);
  let t0;
  $[0] !== props2 ? (t0 = props2.renderDefault(props2), $[0] = props2, $[1] = t0) : t0 = $[1];
  const children = t0;
  let t1;
  $[2] !== children || $[3] !== enabled || $[4] !== isLoading ? (t1 = !enabled && !isLoading ? /* @__PURE__ */ jsx(CommentsUpsellProvider, { children }) : children, $[2] = children, $[3] = enabled, $[4] = isLoading, $[5] = t1) : t1 = $[5];
  let t2;
  return $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(AddonDatasetProvider, { children: /* @__PURE__ */ jsx(CommentsOnboardingProvider, { children: t1 }) }), $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
const comments = definePlugin({
  name: "sanity/comments",
  document: {
    inspectors: [commentsInspector],
    components: {
      unstable_layout: CommentsDocumentLayout
    }
  },
  form: {
    components: {
      field: CommentsField,
      input: CommentsInput
    }
  },
  studio: {
    components: {
      layout: CommentsStudioLayout
    }
  },
  i18n: {
    bundles: [commentsUsEnglishLocaleBundle]
  }
}), SCHEDULE_ACTION_DICTIONARY = {
  publish: {
    actionName: "Publishing",
    badgeColor: "primary",
    badgeTone: "positive"
  },
  unpublish: {
    actionName: "Unpublishing",
    badgeColor: "danger",
    badgeTone: "critical"
  }
}, SCHEDULE_STATE_DICTIONARY = {
  scheduled: {
    title: "Upcoming"
  },
  succeeded: {
    title: "Completed"
  },
  cancelled: {
    title: "Failed"
  }
}, SCHEDULE_FILTERS = Object.keys(SCHEDULE_STATE_DICTIONARY).filter((f) => !!f), TOOL_HEADER_HEIGHT = 55, DOCUMENT_HAS_WARNINGS_TEXT = "This document has validation warnings.", DOCUMENT_HAS_ERRORS_TEXT = "This document has validation errors that should be resolved before its publish date.", SCHEDULE_FAILED_TEXT = "This schedule failed to run.", TOOL_TITLE = "Schedules", RELEASES_DOCS_URL = "https://www.sanity.io/blog/introducing-content-releases", FORBIDDEN_RESPONSE_TEXT = "Forbidden. Please check that your project has access to Scheduled Publishing.", SCHEDULED_PUBLISHING_TOOL_NAME$1 = "schedules", SCHEDULED_PUBLISHING_TIME_ZONE_SCOPE = {
  type: "scheduledPublishing"
}, HAS_USED_SCHEDULED_PUBLISHING = {
  used: !1,
  loading: !0
}, cachedUsedScheduledPublishing = /* @__PURE__ */ new Map();
function fetchUsedScheduledPublishing(client) {
  const {
    dataset,
    projectId
  } = client.config();
  return client.observable.request({
    uri: `/schedules/${projectId}/${dataset}?limit=1`,
    tag: "scheduled-publishing-used"
  }).pipe(map$1((res) => ({
    used: res.schedules?.length > 0,
    loading: !1
  })), catchError$1(() => of({
    used: !1,
    loading: !1
  })));
}
function useHasUsedScheduledPublishing(t0) {
  const $ = c(4), {
    explicitEnabled,
    isWorkspaceEnabled
  } = t0, client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    projectId,
    dataset
  } = useWorkspace(), key = `${projectId}-${dataset}`;
  if (!cachedUsedScheduledPublishing.get(key)) {
    const hasUsed = fetchUsedScheduledPublishing(client).pipe(shareReplay$1());
    cachedUsedScheduledPublishing.set(key, hasUsed);
  }
  let t1;
  bb0: {
    if (explicitEnabled) {
      let t22;
      $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = of({
        used: !0,
        loading: !1
      }), $[0] = t22) : t22 = $[0], t1 = t22;
      break bb0;
    }
    if (!isWorkspaceEnabled) {
      let t22;
      $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = of({
        used: !1,
        loading: !1
      }), $[1] = t22) : t22 = $[1], t1 = t22;
      break bb0;
    }
    let t2;
    $[2] !== key ? (t2 = cachedUsedScheduledPublishing.get(key) || of(HAS_USED_SCHEDULED_PUBLISHING), $[2] = key, $[3] = t2) : t2 = $[3], t1 = t2;
  }
  return useObservable(t1, HAS_USED_SCHEDULED_PUBLISHING);
}
function ScheduledPublishingEnabledProvider(t0) {
  const $ = c(16), {
    children
  } = t0, {
    enabled,
    isLoading,
    error
  } = useFeatureEnabled(FEATURES.scheduledPublishing), {
    scheduledPublishing: scheduledPublishing2
  } = useWorkspace(), isWorkspaceEnabled = scheduledPublishing2.enabled, explicitEnabled = scheduledPublishing2.__internal__workspaceEnabled;
  let t1;
  $[0] !== explicitEnabled || $[1] !== isWorkspaceEnabled ? (t1 = {
    explicitEnabled,
    isWorkspaceEnabled
  }, $[0] = explicitEnabled, $[1] = isWorkspaceEnabled, $[2] = t1) : t1 = $[2];
  const hasUsedScheduledPublishing = useHasUsedScheduledPublishing(t1);
  let t2;
  bb0: {
    if (!isWorkspaceEnabled || isLoading || error) {
      let t33;
      $[3] !== hasUsedScheduledPublishing ? (t33 = {
        enabled: !1,
        mode: null,
        hasUsedScheduledPublishing
      }, $[3] = hasUsedScheduledPublishing, $[4] = t33) : t33 = $[4], t2 = t33;
      break bb0;
    }
    if (explicitEnabled) {
      const t33 = enabled ? "default" : "upsell";
      let t42;
      $[5] !== hasUsedScheduledPublishing || $[6] !== t33 ? (t42 = {
        enabled: !0,
        mode: t33,
        hasUsedScheduledPublishing
      }, $[5] = hasUsedScheduledPublishing, $[6] = t33, $[7] = t42) : t42 = $[7], t2 = t42;
      break bb0;
    }
    if (!hasUsedScheduledPublishing.used) {
      let t33;
      $[8] !== hasUsedScheduledPublishing ? (t33 = {
        enabled: !1,
        mode: null,
        hasUsedScheduledPublishing
      }, $[8] = hasUsedScheduledPublishing, $[9] = t33) : t33 = $[9], t2 = t33;
      break bb0;
    }
    const t32 = enabled ? "default" : "upsell";
    let t4;
    $[10] !== hasUsedScheduledPublishing || $[11] !== t32 ? (t4 = {
      enabled: !0,
      mode: t32,
      hasUsedScheduledPublishing
    }, $[10] = hasUsedScheduledPublishing, $[11] = t32, $[12] = t4) : t4 = $[12], t2 = t4;
  }
  const value = t2;
  let t3;
  return $[13] !== children || $[14] !== value ? (t3 = /* @__PURE__ */ jsx(ScheduledPublishingEnabledContext.Provider, { value, children }), $[13] = children, $[14] = value, $[15] = t3) : t3 = $[15], t3;
}
function useScheduledPublishingEnabled() {
  return useContext(ScheduledPublishingEnabledContext);
}
const TimeZoneButtonElementQuery = styled(ElementQuery).withConfig({
  displayName: "TimeZoneButtonElementQuery",
  componentId: "sc-1578vde-0"
})`.button-small{display:block;}.button-large{display:none;}&[data-eq-min~='2']{.button-small{display:none;}.button-large{display:block;}}`, ErrorCallout = (props2) => {
  const $ = c(8), {
    description,
    title
  } = props2;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Text$1, { size: 2, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== title ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: title }), $[1] = title, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== description ? (t2 = description && /* @__PURE__ */ jsx(Text$1, { size: 1, children: description }), $[3] = description, $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== t1 || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Card, { overflow: "hidden", padding: 4, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 4, children: [
    t0,
    /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
      t1,
      t2
    ] })
  ] }) }), $[5] = t1, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}, InfoCallout = () => {
  const $ = c(5);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Text$1, { size: 2, children: /* @__PURE__ */ jsx(InfoOutlineIcon, {}) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: "Schedule Publishing is not enabled" }), $[1] = t1) : t1 = $[1];
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    "We recommend using",
    " ",
    /* @__PURE__ */ jsx("a", { target: "_blank", href: RELEASES_DOCS_URL, rel: "noreferrer", children: "Releases" }),
    "."
  ] }), $[2] = t2) : t2 = $[2];
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    "Scheduled Publishing is not enabled by default. It can be enabled in the config by setting ",
    /* @__PURE__ */ jsx("code", { children: "scheduledPublishing.enabled = true" })
  ] }), $[3] = t3) : t3 = $[3];
  let t4;
  return $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(Card, { overflow: "hidden", padding: 4, radius: 2, shadow: 1, tone: "suggest", children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 4, children: [
    t0,
    /* @__PURE__ */ jsxs(Inline, { space: 3, children: [
      t1,
      /* @__PURE__ */ jsxs(Stack, { space: 3, marginTop: 2, children: [
        t2,
        t3,
        /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx("a", { target: "_blank", href: "https://www.sanity.io/docs/scheduled-publishing", rel: "noreferrer", children: "Read the docs" }) })
      ] })
    ] })
  ] }) }), $[4] = t4) : t4 = $[4], t4;
};
function getLastExecuteDate(schedule) {
  return schedule?.executedAt || schedule?.executeAt;
}
function sortByExecuteDate({
  reverseOrder
} = {
  reverseOrder: !1
}) {
  return function(a, b) {
    const aExecuteDate = getLastExecuteDate(a), bExecuteDate = getLastExecuteDate(b);
    return aExecuteDate === bExecuteDate ? 0 : aExecuteDate === null ? 1 : bExecuteDate === null ? -1 : (aExecuteDate > bExecuteDate ? 1 : -1) * (reverseOrder ? -1 : 1);
  };
}
const ToastDescription = (props2) => {
  const $ = c(10), {
    body,
    title
  } = props2;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(CalendarIcon, {}), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== title ? (t1 = title && /* @__PURE__ */ jsx(Text$1, { size: 2, weight: "semibold", children: title }), $[1] = title, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    t0,
    t1
  ] }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== body ? (t3 = body && /* @__PURE__ */ jsx(Text$1, { size: 1, children: body }), $[5] = body, $[6] = t3) : t3 = $[6];
  let t4;
  return $[7] !== t2 || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { paddingY: 1, space: 3, children: [
    t2,
    t3
  ] }), $[7] = t2, $[8] = t3, $[9] = t4) : t4 = $[9], t4;
};
function isClientError(e) {
  return typeof e != "object" || !e ? !1 : "statusCode" in e && "response" in e;
}
function getErrorMessage(err) {
  let message;
  return isClientError(err) ? err.response.statusCode === 403 ? message = FORBIDDEN_RESPONSE_TEXT : message = err.message : (err instanceof Error && (message = err.message), message = String(err)), message;
}
const debug$6 = debugWithName$1("useScheduleOperation");
function useScheduleApi() {
  const $ = c(3);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "2022-09-01"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0);
  let t1;
  return $[1] !== client ? (t1 = createScheduleApi(client), $[1] = client, $[2] = t1) : t1 = $[2], t1;
}
function createScheduleApi(client) {
  const {
    dataset,
    projectId
  } = client.config();
  function _create({
    date,
    documentId
  }) {
    debug$6("_create:", documentId);
    const roundedDate = new Date(date);
    return roundedDate.setSeconds(0), roundedDate.setMilliseconds(0), client.request({
      body: {
        documents: [{
          documentId
        }],
        executeAt: roundedDate,
        name: roundedDate
      },
      method: "POST",
      uri: `/schedules/${projectId}/${dataset}`
    });
  }
  function _delete({
    scheduleId
  }) {
    return debug$6("_delete:", scheduleId), client.request({
      method: "DELETE",
      uri: `/schedules/${projectId}/${dataset}/${scheduleId}`
    });
  }
  function _deleteMultiple({
    scheduleIds
  }) {
    debug$6("_deleteMultiple:", scheduleIds);
    const requests = scheduleIds.map((scheduleId) => _delete({
      scheduleId
    }));
    return Promise.allSettled(requests);
  }
  function _publish({
    scheduleId
  }) {
    return debug$6("_publish:", scheduleId), client.request({
      method: "POST",
      uri: `/schedules/${projectId}/${dataset}/${scheduleId}/publish`
    });
  }
  function _update({
    documentSchedule,
    scheduleId
  }) {
    return debug$6("_update:", scheduleId, documentSchedule), client.request({
      body: documentSchedule,
      method: "PATCH",
      uri: `/schedules/${projectId}/${dataset}/${scheduleId}`
    });
  }
  return {
    create: _create,
    delete: _delete,
    deleteMultiple: _deleteMultiple,
    publish: _publish,
    update: _update
  };
}
const ScheduleEvents = {
  create: "scheduleCreate",
  delete: "scheduleDelete",
  deleteMultiple: "scheduleDeleteMultiple",
  publish: "schedulePublish",
  update: "scheduleUpdate"
};
function pluralize(word, count2) {
  return `${count2} ${word}${count2 === 1 ? "" : "s"}`;
}
const scheduleCustomEvent = (name, payload) => new CustomEvent(name, payload);
function useScheduleOperation() {
  const $ = c(24), toast = useToast();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    type: "scheduledPublishing"
  }, $[0] = t0) : t0 = $[0];
  const {
    formatDateTz
  } = useTimeZone(t0), api = useScheduleApi();
  let t1;
  $[1] !== api || $[2] !== formatDateTz || $[3] !== toast ? (t1 = async function(t22) {
    const {
      date,
      displayToast: t32,
      documentId
    } = t22, displayToast = t32 === void 0 ? !0 : t32;
    await (async () => {
      const data = await api.create({
        date,
        documentId
      });
      window.dispatchEvent(scheduleCustomEvent(ScheduleEvents.create, {
        detail: {
          date,
          documentId
        }
      })), displayToast && data?.executeAt && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: formatDateTz({
          date: new Date(data.executeAt),
          includeTimeZone: !0,
          prefix: "Publishing on "
        }), title: "Schedule created" }),
        duration: 15e3,
        status: "success"
      });
    })().catch((err) => {
      displayToast && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: getErrorMessage(err), title: "Unable to create schedule" }),
        duration: 15e3,
        status: "error"
      });
    });
  }, $[1] = api, $[2] = formatDateTz, $[3] = toast, $[4] = t1) : t1 = $[4];
  const createSchedule = t1;
  let t2;
  $[5] !== api || $[6] !== toast ? (t2 = async function(t32) {
    const {
      displayToast: t42,
      schedule
    } = t32, displayToast_0 = t42 === void 0 ? !0 : t42;
    await (async () => {
      await api.delete({
        scheduleId: schedule?.id
      }), window.dispatchEvent(scheduleCustomEvent(ScheduleEvents.delete, {
        detail: {
          scheduleId: schedule?.id
        }
      })), displayToast_0 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { title: "Schedule deleted" }),
        status: "success"
      });
    })().catch((err_0) => {
      displayToast_0 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: getErrorMessage(err_0), title: "Unable to delete schedule" }),
        duration: 15e3,
        status: "error"
      });
    });
  }, $[5] = api, $[6] = toast, $[7] = t2) : t2 = $[7];
  const deleteSchedule = t2;
  let t3;
  $[8] !== api || $[9] !== toast ? (t3 = async function(t42) {
    const {
      displayToast: t52,
      schedules: schedules2
    } = t42, displayToast_1 = t52 === void 0 ? !0 : t52;
    await (async () => {
      const scheduleIds = schedules2.map(_temp$Y), response = await api.deleteMultiple({
        scheduleIds
      }), {
        fulfilledIds,
        rejectedReasons
      } = response.reduce((acc, v, index) => (v.status === "fulfilled" && acc.fulfilledIds.push(schedules2[index].id), v.status === "rejected" && acc.rejectedReasons.push(`[${schedules2[index].id}]: ${v.reason}`), acc), {
        fulfilledIds: [],
        rejectedReasons: []
      }), numFulfilledIds = fulfilledIds.length, numRejectedReasons = rejectedReasons.length;
      fulfilledIds?.length > 0 && window.dispatchEvent(scheduleCustomEvent(ScheduleEvents.deleteMultiple, {
        detail: {
          scheduleIds: fulfilledIds
        }
      })), displayToast_1 && (fulfilledIds?.length > 0 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { title: `${pluralize("schedule", numFulfilledIds)} deleted` }),
        status: "success"
      }), rejectedReasons?.length > 0 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: rejectedReasons?.toString(), title: `Unable to delete ${pluralize("schedule", numRejectedReasons)}` }),
        duration: 15e3,
        status: "error"
      }));
    })().catch((err_1) => {
      displayToast_1 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: getErrorMessage(err_1), title: "Unable to delete schedules" }),
        duration: 15e3,
        status: "error"
      });
    });
  }, $[8] = api, $[9] = toast, $[10] = t3) : t3 = $[10];
  const deleteSchedules = t3;
  let t4;
  $[11] !== api || $[12] !== toast ? (t4 = async function(t52) {
    const {
      displayToast: t62,
      schedule: schedule_1
    } = t52, displayToast_2 = t62 === void 0 ? !0 : t62;
    try {
      const scheduleId = schedule_1.id;
      await api.publish({
        scheduleId
      }), window.dispatchEvent(scheduleCustomEvent(ScheduleEvents.publish, {
        detail: {
          scheduleId
        }
      })), displayToast_2 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { title: "Document published" }),
        status: "success"
      });
    } catch (t7) {
      const err_2 = t7;
      displayToast_2 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: getErrorMessage(err_2), title: "Unable to publish schedule" }),
        duration: 15e3,
        status: "error"
      });
    }
  }, $[11] = api, $[12] = toast, $[13] = t4) : t4 = $[13];
  const publishSchedule = t4;
  let t5;
  $[14] !== api || $[15] !== formatDateTz || $[16] !== toast ? (t5 = async function(t62) {
    const {
      date: date_0,
      displayToast: t7,
      scheduleId: scheduleId_0
    } = t62, displayToast_3 = t7 === void 0 ? !0 : t7;
    try {
      await api.update({
        documentSchedule: {
          executeAt: date_0
        },
        scheduleId: scheduleId_0
      }), window.dispatchEvent(scheduleCustomEvent(ScheduleEvents.update, {
        detail: {
          date: date_0,
          scheduleId: scheduleId_0
        }
      })), displayToast_3 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: formatDateTz({
          date: new Date(date_0),
          includeTimeZone: !0,
          prefix: "Publishing on "
        }), title: "Schedule updated" }),
        duration: 15e3,
        status: "success"
      });
    } catch (t8) {
      const err_3 = t8;
      displayToast_3 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: getErrorMessage(err_3), title: "Unable to update schedule" }),
        duration: 15e3,
        status: "error"
      });
    }
  }, $[14] = api, $[15] = formatDateTz, $[16] = toast, $[17] = t5) : t5 = $[17];
  const updateSchedule = t5;
  let t6;
  return $[18] !== createSchedule || $[19] !== deleteSchedule || $[20] !== deleteSchedules || $[21] !== publishSchedule || $[22] !== updateSchedule ? (t6 = {
    createSchedule,
    deleteSchedule,
    deleteSchedules,
    publishSchedule,
    updateSchedule
  }, $[18] = createSchedule, $[19] = deleteSchedule, $[20] = deleteSchedules, $[21] = publishSchedule, $[22] = updateSchedule, $[23] = t6) : t6 = $[23], t6;
}
function _temp$Y(schedule_0) {
  return schedule_0.id;
}
function useScheduleBaseUrl() {
  const $ = c(3);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "2022-09-01"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0);
  let t1;
  $[1] !== client ? (t1 = client.config(), $[1] = client, $[2] = t1) : t1 = $[2];
  const {
    dataset,
    projectId
  } = t1;
  return `/schedules/${projectId}/${dataset}`;
}
function useFetcher(queryKey) {
  const $ = c(5);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "2022-09-01"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0);
  let t1;
  return $[1] !== client || $[2] !== queryKey.params || $[3] !== queryKey.url ? (t1 = () => client.request({
    query: queryKey.params,
    method: "GET",
    uri: queryKey.url
  }), $[1] = client, $[2] = queryKey.params, $[3] = queryKey.url, $[4] = t1) : t1 = $[4], t1;
}
const NO_SCHEDULES = [];
function usePollSchedules(t0) {
  const $ = c(32);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const {
    documentId,
    state
  } = t1, {
    mode,
    enabled
  } = useScheduledPublishingEnabled(), t2 = mode === "default" ? 1e4 : void 0, t3 = mode === "default", t4 = mode === "default";
  let t5;
  $[2] !== t2 || $[3] !== t3 || $[4] !== t4 ? (t5 = {
    refreshWhenHidden: !1,
    refreshWhenOffline: !1,
    revalidateOnFocus: !1,
    shouldRetryOnError: !1,
    refreshInterval: t2,
    revalidateIfStale: t3,
    revalidateOnReconnect: t4
  }, $[2] = t2, $[3] = t3, $[4] = t4, $[5] = t5) : t5 = $[5];
  const swrOptions = t5, url = useScheduleBaseUrl();
  let t6;
  $[6] !== documentId || $[7] !== state ? (t6 = {
    documentIds: documentId,
    state
  }, $[6] = documentId, $[7] = state, $[8] = t6) : t6 = $[8];
  let t7;
  $[9] !== t6 || $[10] !== url ? (t7 = {
    params: t6,
    url
  }, $[9] = t6, $[10] = url, $[11] = t7) : t7 = $[11];
  const queryKey = t7, fetcher = useFetcher(queryKey), {
    data,
    error,
    mutate: mutate2
  } = useSWR(enabled ? queryKey : null, fetcher, swrOptions);
  let t8;
  $[12] !== mutate2 ? (t8 = (event) => {
    mutate2((currentData) => ({
      schedules: currentData?.schedules?.filter((schedule) => schedule.id !== event.detail.scheduleId)
    }), !0);
  }, $[12] = mutate2, $[13] = t8) : t8 = $[13];
  const handleDelete = t8;
  let t9;
  $[14] !== mutate2 ? (t9 = (event_0) => {
    mutate2((currentData_0) => ({
      schedules: currentData_0?.schedules?.filter((schedule_0) => !event_0.detail.scheduleIds.includes(schedule_0.id))
    }), !0);
  }, $[14] = mutate2, $[15] = t9) : t9 = $[15];
  const handleDeleteMultiple = t9;
  let t10;
  $[16] !== mutate2 ? (t10 = (event_1) => {
    mutate2((currentData_1) => {
      const currentSchedules = currentData_1?.schedules || [], index = currentSchedules.findIndex((schedule_1) => schedule_1.id === event_1.detail.scheduleId);
      return {
        schedules: [...currentSchedules.slice(0, index), {
          ...currentSchedules[index],
          executeAt: (/* @__PURE__ */ new Date()).toISOString(),
          state: "succeeded"
        }, ...currentSchedules.slice(index + 1)]
      };
    }, !0);
  }, $[16] = mutate2, $[17] = t10) : t10 = $[17];
  const handlePublish = t10;
  let t11;
  $[18] !== mutate2 ? (t11 = (event_2) => {
    mutate2((currentData_2) => {
      const currentSchedules_0 = currentData_2?.schedules || [], index_0 = currentSchedules_0.findIndex((schedule_2) => schedule_2.id === event_2.detail.scheduleId);
      return {
        schedules: [...currentSchedules_0.slice(0, index_0), {
          ...currentSchedules_0[index_0],
          executeAt: event_2.detail.date
        }, ...currentSchedules_0.slice(index_0 + 1)]
      };
    }, !0);
  }, $[18] = mutate2, $[19] = t11) : t11 = $[19];
  const handleUpdate = t11;
  let t12, t13;
  $[20] !== handleDelete || $[21] !== handleDeleteMultiple || $[22] !== handlePublish || $[23] !== handleUpdate ? (t12 = () => (window.addEventListener(ScheduleEvents.delete, handleDelete), window.addEventListener(ScheduleEvents.deleteMultiple, handleDeleteMultiple), window.addEventListener(ScheduleEvents.publish, handlePublish), window.addEventListener(ScheduleEvents.update, handleUpdate), () => {
    window.removeEventListener(ScheduleEvents.delete, handleDelete), window.removeEventListener(ScheduleEvents.deleteMultiple, handleDeleteMultiple), window.removeEventListener(ScheduleEvents.publish, handlePublish), window.removeEventListener(ScheduleEvents.update, handleUpdate);
  }), t13 = [handleDelete, handleDeleteMultiple, handlePublish, handleUpdate], $[20] = handleDelete, $[21] = handleDeleteMultiple, $[22] = handlePublish, $[23] = handleUpdate, $[24] = t12, $[25] = t13) : (t12 = $[24], t13 = $[25]), useEffect(t12, t13);
  let t14;
  $[26] !== data?.schedules ? (t14 = data?.schedules?.sort(sortByExecuteDate()), $[26] = data?.schedules, $[27] = t14) : t14 = $[27];
  const sortedSchedules = t14, t15 = !error && !data, t16 = sortedSchedules || NO_SCHEDULES;
  let t17;
  return $[28] !== error || $[29] !== t15 || $[30] !== t16 ? (t17 = {
    error,
    isInitialLoading: t15,
    schedules: t16
  }, $[28] = error, $[29] = t15, $[30] = t16, $[31] = t17) : t17 = $[31], t17;
}
const EMPTY_SCHEDULE = [];
function SchedulesProvider(t0) {
  const $ = c(22), {
    children,
    value
  } = t0, [sortBy2, setSortBy] = useState(value.sortBy || "executeAt");
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    type: "scheduledPublishing"
  }, $[0] = t1) : t1 = $[0];
  const {
    utcToCurrentZoneDate
  } = useTimeZone(t1);
  let t2;
  $[1] !== utcToCurrentZoneDate ? (t2 = (wallDate) => function(schedule) {
    const executeDate = getLastExecuteDate(schedule);
    if (!executeDate)
      return !1;
    const scheduleDate = new Date(executeDate), zonedScheduleDate = utcToCurrentZoneDate(scheduleDate);
    return isSameDay(zonedScheduleDate, wallDate);
  }, $[1] = utcToCurrentZoneDate, $[2] = t2) : t2 = $[2];
  const filterByDate = t2, filterByState = _temp$X;
  let t3;
  $[3] !== filterByDate || $[4] !== sortBy2 || $[5] !== value.scheduleState || $[6] !== value.schedules || $[7] !== value.selectedDate ? (t3 = value.schedules.filter((scheduleState_0) => value.selectedDate ? filterByDate(value.selectedDate)(scheduleState_0) : filterByState(value.scheduleState)(scheduleState_0)).sort((a, b) => {
    if (sortBy2 === "createdAt")
      return a[sortBy2] < b[sortBy2] ? 1 : -1;
    if (sortBy2 === "executeAt") {
      const reverseOrder = !(value.scheduleState === "scheduled" || value.selectedDate);
      return sortByExecuteDate({
        reverseOrder
      })(a, b);
    }
    return 1;
  }) || [], $[3] = filterByDate, $[4] = sortBy2, $[5] = value.scheduleState, $[6] = value.schedules, $[7] = value.selectedDate, $[8] = t3) : t3 = $[8];
  const activeSchedules = t3;
  let t4;
  $[9] !== filterByDate || $[10] !== value.schedules ? (t4 = (wallDate_0) => value.schedules.filter(filterByDate(wallDate_0)).sort(sortByExecuteDate()), $[9] = filterByDate, $[10] = value.schedules, $[11] = t4) : t4 = $[11];
  const schedulesByDate = t4, t5 = value.schedules || EMPTY_SCHEDULE;
  let t6;
  $[12] !== activeSchedules || $[13] !== schedulesByDate || $[14] !== sortBy2 || $[15] !== t5 || $[16] !== value.scheduleState || $[17] !== value.selectedDate ? (t6 = {
    activeSchedules,
    schedules: t5,
    schedulesByDate,
    scheduleState: value.scheduleState,
    selectedDate: value.selectedDate,
    setSortBy,
    sortBy: sortBy2
  }, $[12] = activeSchedules, $[13] = schedulesByDate, $[14] = sortBy2, $[15] = t5, $[16] = value.scheduleState, $[17] = value.selectedDate, $[18] = t6) : t6 = $[18];
  const context = t6;
  let t7;
  return $[19] !== children || $[20] !== context ? (t7 = /* @__PURE__ */ jsx(SchedulesContext.Provider, { value: context, children }), $[19] = children, $[20] = context, $[21] = t7) : t7 = $[21], t7;
}
function _temp$X(scheduleState) {
  return function(schedule_0) {
    return schedule_0.state === scheduleState;
  };
}
function useSchedules() {
  const context = useContext(SchedulesContext);
  if (context === void 0)
    throw new Error("useSchedules must be used within a SchedulesProvider");
  return context;
}
function useFilteredSchedules(schedules2, filter2) {
  const $ = c(5);
  let t0;
  if ($[0] !== filter2 || $[1] !== schedules2) {
    let t1;
    $[3] !== filter2 ? (t1 = (schedule) => schedule.state === filter2, $[3] = filter2, $[4] = t1) : t1 = $[4], t0 = schedules2.filter(t1), $[0] = filter2, $[1] = schedules2, $[2] = t0;
  } else
    t0 = $[2];
  return t0;
}
const ScheduleFilter = (props2) => {
  const $ = c(16), {
    selected,
    schedules: schedules2,
    state
  } = props2, count2 = useFilteredSchedules(schedules2, state).length, hasItems = count2 > 0, critical = state === "cancelled";
  let t0;
  $[0] !== state ? (t0 = {
    state: {
      state
    }
  }, $[0] = state, $[1] = t0) : t0 = $[1];
  const {
    href,
    onClick: onClick2
  } = useStateLink(t0), t1 = critical ? "critical" : "default", t2 = SCHEDULE_STATE_DICTIONARY[state];
  let t3;
  $[2] !== t2.title ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t2.title }), $[2] = t2.title, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== count2 || $[5] !== hasItems ? (t4 = hasItems && /* @__PURE__ */ jsx(Text$1, { size: 0, children: count2 }), $[4] = count2, $[5] = hasItems, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t3 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "center", children: [
    t3,
    t4
  ] }), $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  return $[10] !== href || $[11] !== onClick2 || $[12] !== selected || $[13] !== t1 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(Button$1, { as: "a", href, mode: "bleed", onClick: onClick2, selected, tone: t1, padding: 2, children: t5 }), $[10] = href, $[11] = onClick2, $[12] = selected, $[13] = t1, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
}, ScheduleFilters = (props2) => {
  const $ = c(26), {
    onClearDate,
    selectedDate
  } = props2, {
    navigate
  } = useRouter(), {
    schedules: schedules2,
    scheduleState
  } = useSchedules();
  let t0;
  $[0] !== navigate ? (t0 = (state) => {
    navigate(state);
  }, $[0] = navigate, $[1] = t0) : t0 = $[1];
  const handleMenuClick = t0, currentSchedules = useFilteredSchedules(schedules2, scheduleState);
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = ["block", "block", "none"], $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== onClearDate || $[4] !== selectedDate ? (t2 = selectedDate && /* @__PURE__ */ jsx(Button, { iconRight: CloseIcon, onClick: onClearDate, text: format(selectedDate, "d MMMM yyyy"), tone: "primary" }), $[3] = onClearDate, $[4] = selectedDate, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== currentSchedules?.length || $[7] !== handleMenuClick || $[8] !== scheduleState ? (t3 = scheduleState && /* @__PURE__ */ jsx(MenuButton, { button: /* @__PURE__ */ jsx(Button, { iconRight: SelectIcon, mode: "ghost", text: `${SCHEDULE_STATE_DICTIONARY[scheduleState].title} (${currentSchedules?.length || 0})`, tone: "default" }), id: "state", menu: /* @__PURE__ */ jsx(Menu, { style: {
    minWidth: "175px"
  }, children: SCHEDULE_FILTERS.map((filter2) => /* @__PURE__ */ jsx(MenuItem, { iconRight: filter2 === scheduleState ? CheckmarkIcon : void 0, onClick: handleMenuClick.bind(void 0, {
    state: filter2
  }), text: SCHEDULE_STATE_DICTIONARY[filter2].title }, filter2)) }), placement: "bottom" }), $[6] = currentSchedules?.length, $[7] = handleMenuClick, $[8] = scheduleState, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t2 || $[11] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Box, { display: t1, children: [
    t2,
    t3
  ] }), $[10] = t2, $[11] = t3, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = ["none", "none", "block"], $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== onClearDate || $[15] !== selectedDate ? (t6 = selectedDate && /* @__PURE__ */ jsx(Button, { iconRight: CloseIcon, onClick: onClearDate, text: format(selectedDate, "d MMMM yyyy"), tone: "primary" }), $[14] = onClearDate, $[15] = selectedDate, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== scheduleState || $[18] !== schedules2 ? (t7 = scheduleState && /* @__PURE__ */ jsx(Flex, { gap: 2, children: SCHEDULE_FILTERS.map((filter_0) => /* @__PURE__ */ jsx(ScheduleFilter, { schedules: schedules2, selected: scheduleState === filter_0, state: filter_0 }, filter_0)) }), $[17] = scheduleState, $[18] = schedules2, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== t6 || $[21] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Box, { display: t5, children: [
    t6,
    t7
  ] }), $[20] = t6, $[21] = t7, $[22] = t8) : t8 = $[22];
  let t9;
  return $[23] !== t4 || $[24] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t4,
    t8
  ] }), $[23] = t4, $[24] = t8, $[25] = t9) : t9 = $[25], t9;
};
function SchedulePublishingUpsellProvider(props2) {
  const $ = c(9);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    dataUri: "/journey/scheduled-publishing",
    feature: "scheduled_publishing"
  }, $[0] = t0) : t0 = $[0];
  const contextValue = useUpsellContext(t0), t1 = props2.children;
  let t2;
  $[1] !== contextValue ? (t2 = getDialogPropsFromContext(contextValue), $[1] = contextValue, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(UpsellDialog, { ...t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== contextValue || $[6] !== props2.children || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(SchedulePublishUpsellContext.Provider, { value: contextValue, children: [
    t1,
    t3
  ] }), $[5] = contextValue, $[6] = props2.children, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
function useSchedulePublishingUpsell() {
  return useContext(SchedulePublishUpsellContext);
}
const BigIconComingSoon = (props2) => {
  const $ = c(15);
  let t0, t1, t10, t11, t12, t2, t3, t4, t5, t6, t7, t8, t9;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M54 26C54 28.7614 49.0751 31 43 31C36.9249 31 32 28.7614 32 26C32 23.2386 36.9249 7 43 7C49.0751 7 54 23.2386 54 26Z", stroke: "#7B8CA8", strokeWidth: "1.2" }), t1 = /* @__PURE__ */ jsx("path", { d: "M65 71.5V57M65 71.5L60.5789 69.0132M65 71.5L60.5789 73.9868M65 57L57 52.5L54 54.1875M65 57V42.5M65 57L57 47M65 57L58.1586 60.8483M65 57L60.5789 67.5M65 42.5L57 38L54 39.6875M65 42.5L57 47M65 42.5V27.5M57 47L65 27.5M57 47L54 39.6875M57 47L54 45.3125M57 47L54 50.75M57 23L65 27.5M57 23L54 24.6875V39.6875M57 23V60M65 27.5L57 32L54 30.3125", stroke: "#7B8CA8", strokeWidth: "1.2" }), t2 = /* @__PURE__ */ jsx("path", { d: "M54 76C54 78.7614 49.0751 81 43 81C36.9249 81 32 78.7614 32 76M54 76H60.5V63L54 57M54 76V57M32 76H25V63L32 57M32 76V57M32 26V57M54 26V57M54 45C54 47.7614 49.0751 50 43 50V35C49.0751 35 54 32.7614 54 30", stroke: "#7B8CA8", strokeWidth: "1.2" }), t3 = /* @__PURE__ */ jsx("path", { d: "M43 45.5701H44.8976L45.8465 43.1981L46.9679 42.7335L49.3162 43.7399L50.658 42.3981L49.6516 40.0499L50.1161 38.9284L52.4882 37.9795V36.0819L50.1161 35.1331L49.6516 34.0116M47.1334 34.9653C47.5197 35.5597 47.7441 36.269 47.7441 37.0307C47.7441 39.1268 46.0449 40.826 43.9488 40.826C43.6212 40.826 43.3033 40.7845 43 40.7064", stroke: "#7B8CA8", strokeWidth: "1.2", strokeLinejoin: "round" }), t4 = /* @__PURE__ */ jsx("path", { d: "M63.5464 78.6739L64.9606 78.0321L67.4355 78.5135L68.6174 78.2913L69.6174 77.1566H71.6174L72.6174 78.2913L73.7994 78.5135L76.2743 78.0321L77.6885 78.6739M63.5464 78.6739L64.607 79.7972L64.1174 80.3336L63.5464 80.4373M63.5464 78.6739V80.4373M77.6885 78.6739L76.6278 79.7972L77.1174 80.3336L77.6885 80.4373M77.6885 78.6739V80.4373M63.5464 80.4373L61.6174 80.7875V81.6952L64.1174 82.1491L64.607 82.6855L63.5464 83.8088L64.9606 84.4506L67.4355 83.9693L68.6174 84.1915L69.6174 85.3261H71.6174L72.6174 84.1915L73.7994 83.9693L76.2743 84.4506L77.6885 83.8088L76.6278 82.6855L77.1174 82.1491L79.6174 81.6952V80.7875L77.6885 80.4373", stroke: "#7B8CA8", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t5 = /* @__PURE__ */ jsx("path", { d: "M79.6174 81.4647V84.7162L77.6885 85.0664M76.2743 87.4716L77.6885 86.8298V85.0664M76.2743 87.4716L73.7994 86.9902L72.6174 87.2124L71.6174 88.3471M76.2743 87.4716V84.7162M61.6174 81.4647V84.7162L63.5464 85.0664M71.6174 88.3471H69.6174M71.6174 88.3471V85.3261M69.6174 88.3471L68.6174 87.2124L67.4355 86.9902L64.9606 87.4716M69.6174 88.3471V85.3261M64.9606 87.4716L64.2535 87.1507L63.5464 86.8298V85.0664M64.9606 87.4716V84.6825M63.5464 84.039V85.0664M77.6885 84.039V85.0664", stroke: "#7B8CA8", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t6 = /* @__PURE__ */ jsx("path", { d: "M73.6174 81.2412C73.6174 81.9932 72.2743 82.6028 70.6174 82.6028C68.9606 82.6028 67.6174 81.9932 67.6174 81.2412C67.6174 80.4892 68.9606 79.8796 70.6174 79.8796C72.2743 79.8796 73.6174 80.4892 73.6174 81.2412Z", stroke: "#7B8CA8", strokeWidth: "1.2" }), t7 = /* @__PURE__ */ jsx("path", { d: "M90 85.3616C90 86.1136 88.6569 86.7232 87 86.7232C85.3431 86.7232 84 86.1136 84 85.3616M90 85.3616C90 84.6096 88.6569 84 87 84C85.3431 84 84 84.6096 84 85.3616M90 85.3616V87.3616C90 88.1136 88.6569 88.7232 87 88.7232C85.3431 88.7232 84 88.1136 84 87.3616V85.3616", stroke: "#7B8CA8", strokeWidth: "1.2" }), t8 = /* @__PURE__ */ jsx("path", { d: "M82 89.8648C82 90.3425 81.3284 90.7297 80.5 90.7297C79.6716 90.7297 79 90.3425 79 89.8648M82 89.8648C82 89.3872 81.3284 89 80.5 89C79.6716 89 79 89.3872 79 89.8648M82 89.8648V91.1352C82 91.6128 81.3284 92 80.5 92C79.6716 92 79 91.6128 79 91.1352V89.8648", stroke: "#7B8CA8", strokeWidth: "1.2" }), t9 = /* @__PURE__ */ jsx("path", { d: "M52.7555 46.7289L52.5381 45.0136L51.2951 44.6903L50.2695 46.0824L49.4558 46.1956L48.0892 45.1364L46.9817 45.7867L47.2408 47.4962L46.7455 48.1517L45.0302 48.3691L44.7069 49.612M51.1084 47.9593C49.8968 47.6442 48.6622 48.2485 48.1434 49.3385", stroke: "#7B8CA8", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t10 = /* @__PURE__ */ jsx("path", { d: "M39 80.5L38 83.5C38 84.8807 40.2386 86 43 86C45.7614 86 48 84.8807 48 83.5L47 80.5", stroke: "#7B8CA8", strokeWidth: "1.2" }), t11 = /* @__PURE__ */ jsx("path", { d: "M32 77L31 80C31 81.3807 33.2386 82.5 36 82.5C36.9107 82.5 37.7646 82.3783 38.5 82.1655", stroke: "#7B8CA8", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t12 = /* @__PURE__ */ jsx("path", { d: "M54 77L55 80C55 81.3807 52.7614 82.5 50 82.5C49.0893 82.5 48.2354 82.3783 47.5 82.1655", stroke: "#7B8CA8", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), $[0] = t0, $[1] = t1, $[2] = t10, $[3] = t11, $[4] = t12, $[5] = t2, $[6] = t3, $[7] = t4, $[8] = t5, $[9] = t6, $[10] = t7, $[11] = t8, $[12] = t9) : (t0 = $[0], t1 = $[1], t10 = $[2], t11 = $[3], t12 = $[4], t2 = $[5], t3 = $[6], t4 = $[7], t5 = $[8], t6 = $[9], t7 = $[10], t8 = $[11], t9 = $[12]);
  let t13;
  return $[13] !== props2 ? (t13 = /* @__PURE__ */ jsxs("svg", { width: "100", height: "100", viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2, children: [
    t0,
    t1,
    t2,
    t3,
    t4,
    t5,
    t6,
    t7,
    t8,
    t9,
    t10,
    t11,
    t12
  ] }), $[13] = props2, $[14] = t13) : t13 = $[14], t13;
}, BigIconScreen = (props2) => {
  const $ = c(9);
  let t0, t1, t2, t3, t4, t5, t6;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M35 84.5L41.7308 67H50V69.5M65 84.5L58.2692 67M32 65H42.5H50H57.5H81V23H19V65H24", stroke: "#7B8CA8", strokeWidth: "1.2" }), t1 = /* @__PURE__ */ jsx("path", { d: "M84 16V23H16V16M84 16H16M84 16L82 14H18L16 16", stroke: "#7B8CA8", strokeWidth: "1.2" }), t2 = /* @__PURE__ */ jsx("path", { d: "M24 65H18L17 67H83L82 65H32", stroke: "#7B8CA8", strokeWidth: "1.2" }), t3 = /* @__PURE__ */ jsx("circle", { cx: "50", cy: "72", r: "2", stroke: "#7B8CA8", strokeWidth: "1.2" }), t4 = /* @__PURE__ */ jsx("path", { d: "M24 63C24 61.8954 24.8954 61 26 61H30C31.1046 61 32 61.8954 32 63V67H24V63Z", stroke: "#7B8CA8", strokeWidth: "1.2" }), t5 = /* @__PURE__ */ jsx("path", { d: "M24 65C24 63.8954 24.8954 63 26 63H30C31.1046 63 32 63.8954 32 65V67H24V65Z", stroke: "#7B8CA8", strokeWidth: "1.2" }), t6 = /* @__PURE__ */ jsx("path", { d: "M28 44.9975C31.0617 44.62 33.5601 42.4793 35.2478 39.995C36.199 38.5947 36.9116 37.0761 36.9653 35.3597C36.9973 34.3355 36.8332 33.1459 35.8944 32.5454C35.3035 32.1675 34.4935 32.0285 33.8044 32.0022C32.7788 31.9631 32.1643 32.4357 31.8489 33.4197C30.3123 38.2145 33.0184 42.7025 36.3911 45.8977C38.1152 47.531 40.0746 48.9275 42.1179 50.1294C43.9867 51.2287 46.003 52.2595 48.1189 52.7885C48.9466 52.9954 50.4951 53.3913 51.3211 52.954C52.3579 52.4051 51.8285 49.7323 51.7091 48.9809C51.3862 46.9486 50.7293 45.0311 49.8726 43.1662C49.3791 42.0918 48.7948 40.8004 47.9999 39.8967C47.4959 39.3237 47.1331 39.4889 47.1101 40.2278C47.0699 41.5204 47.5768 42.7535 48.3103 43.7973C50.633 47.1024 54.4924 49.4656 58.2792 50.6985C59.9643 51.2471 61.8953 51.7306 63.6853 51.6193C65.3845 51.5137 65.6225 50.1321 65.7287 48.655C65.9958 44.9405 64.9629 40.7695 62.6403 37.7963C61.615 36.4839 60.3547 35.6334 58.6879 35.4476C57.7554 35.3437 56.665 35.3303 55.7391 35.5097C54.8073 35.6903 54.0162 36.297 54.3371 37.3462C54.6464 38.3572 55.8044 39.0666 56.6444 39.5759C57.983 40.3876 59.4813 40.9898 61.0262 41.2624C63.2658 41.6576 65.1745 41.1715 67.141 40.1346C67.9966 39.6835 68.8825 39.1795 69.4379 38.3861", stroke: "#7B8CA8", strokeWidth: "1.2" }), $[0] = t0, $[1] = t1, $[2] = t2, $[3] = t3, $[4] = t4, $[5] = t5, $[6] = t6) : (t0 = $[0], t1 = $[1], t2 = $[2], t3 = $[3], t4 = $[4], t5 = $[5], t6 = $[6]);
  let t7;
  return $[7] !== props2 ? (t7 = /* @__PURE__ */ jsxs("svg", { width: "100", height: "100", viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2, children: [
    t0,
    t1,
    t2,
    t3,
    t4,
    t5,
    t6
  ] }), $[7] = props2, $[8] = t7) : t7 = $[8], t7;
}, BigIconSuccess = (props2) => {
  const $ = c(16);
  let t0, t1, t10, t11, t12, t13, t2, t3, t4, t5, t6, t7, t8, t9;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M35.5034 34.5961C35.6531 34.1763 35.8628 33.792 36.1352 33.4478C37.6813 31.4827 40.9503 31.2145 44.9898 32.3554M35.5034 34.5961L24.12 78.5806C23.4656 81.1092 26.1309 83.2083 28.4357 81.9796L68.4485 60.6484M35.5034 34.5961C34.2315 38.1622 37.2902 44.2842 43.0792 50.0342M68.4485 60.6484C68.8174 60.4078 69.1391 60.118 69.4084 59.7777C70.9736 57.7883 70.4521 54.4677 68.3472 50.7308M68.4485 60.6484C65.1795 62.7806 58.1999 61.0522 51.0413 56.4338M49.3164 55.2667C48.6043 54.7622 47.8933 54.2299 47.1867 53.6707C46.3331 52.9953 45.5161 52.3044 44.7387 51.6037M49.3164 55.2667C49.8913 55.674 50.4669 56.0632 51.0413 56.4338M49.3164 55.2667C52.3445 53.1871 58.7283 49.8329 66.4965 47.8874M51.0413 56.4338C55.9305 53.432 62.4593 51.6876 68.3472 50.7308M43.0792 50.0342C43.6098 50.5612 44.1634 51.0852 44.7387 51.6037M43.0792 50.0342C44.4006 45.7138 45.8116 38.387 44.9898 32.3554M44.7387 51.6037C47.6743 44.2968 48.7135 38.3712 48.6643 33.6916M63.9622 36.487C63.2905 34.23 62.35 29.5386 63.9622 28.8293C65.9774 27.9426 68.5569 33.5045 70.8139 32.2148C73.0709 30.9251 69.4435 27.7814 70.8139 25.2019C72.1842 22.6224 79.6002 28.4262 81.2123 23.4285C82.502 19.4304 79.7614 16.6574 78.2298 15.7708M66.4965 47.8874C70.7697 46.8171 75.462 46.1731 80.2449 46.4019L80.2449 49.7068C77.5329 49.6936 73.1535 49.9498 68.3472 50.7308M66.4965 47.8874C64.45 45.1054 61.6564 42.2264 58.3003 39.5859C55.0633 37.039 51.7429 35.0416 48.6643 33.6916M48.6643 33.6916C48.5822 25.8794 45.4671 21.5396 43.0792 20.043L39.941 23.4285C42.9851 25.0774 44.4569 28.4441 44.9898 32.3554", stroke: "#7B8CA8", strokeWidth: "1.2" }), t1 = /* @__PURE__ */ jsx("path", { d: "M32.2094 47.3001C31.0515 50.5465 34.6857 56.6214 40.9597 61.5862C47.2404 66.5562 53.9958 68.696 56.8839 66.8122", stroke: "#7B8CA8", strokeWidth: "1.2" }), t2 = /* @__PURE__ */ jsx("path", { d: "M28.8867 60.1903C28.1245 62.3275 30.5169 66.3267 34.6472 69.595C38.7818 72.8669 43.229 74.2755 45.1303 73.0354", stroke: "#7B8CA8", strokeWidth: "1.2" }), t3 = /* @__PURE__ */ jsx("path", { d: "M26.2718 70.2225C25.8147 71.5039 27.2491 73.9016 29.7254 75.8611C32.2044 77.8228 34.8707 78.6673 36.0106 77.9238", stroke: "#7B8CA8", strokeWidth: "1.2" }), t4 = /* @__PURE__ */ jsx("path", { d: "M28.0529 44.1724C29.5354 43.1981 32.3735 40.6904 31.8652 38.4538C31.2298 35.6581 22.8425 38.9622 22.7155 36.5477C22.5884 34.1331 27.0361 30.575 26.909 28.6688C26.7819 26.7626 18.6489 30.8291 18.6489 26.8896C18.6489 23.738 21.36 22.1029 22.7155 21.6793", stroke: "#7B8CA8", strokeWidth: "1.2" }), t5 = /* @__PURE__ */ jsx("rect", { x: "21.8833", y: "50.1122", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 21.8833 50.1122)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t6 = /* @__PURE__ */ jsx("rect", { x: "16.0527", y: "36.722", width: "3.03077", height: "3.03077", transform: "rotate(4.36851 16.0527 36.722)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t7 = /* @__PURE__ */ jsx("rect", { x: "27.9448", y: "22.8353", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 27.9448 22.8353)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t8 = /* @__PURE__ */ jsx("rect", { x: "53.7065", y: "33.443", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 53.7065 33.443)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t9 = /* @__PURE__ */ jsx("rect", { x: "67.3447", y: "13.743", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 67.3447 13.743)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t10 = /* @__PURE__ */ jsx("rect", { x: "74.9219", y: "54.6584", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 74.9219 54.6584)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t11 = /* @__PURE__ */ jsx("rect", { x: "70.3755", y: "66.7814", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 70.3755 66.7814)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t12 = /* @__PURE__ */ jsx("rect", { x: "77.9526", y: "78.9045", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 77.9526 78.9045)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t13 = /* @__PURE__ */ jsx("rect", { x: "82.4985", y: "62.2353", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 82.4985 62.2353)", stroke: "#7B8CA8", strokeWidth: "1.2" }), $[0] = t0, $[1] = t1, $[2] = t10, $[3] = t11, $[4] = t12, $[5] = t13, $[6] = t2, $[7] = t3, $[8] = t4, $[9] = t5, $[10] = t6, $[11] = t7, $[12] = t8, $[13] = t9) : (t0 = $[0], t1 = $[1], t10 = $[2], t11 = $[3], t12 = $[4], t13 = $[5], t2 = $[6], t3 = $[7], t4 = $[8], t5 = $[9], t6 = $[10], t7 = $[11], t8 = $[12], t9 = $[13]);
  let t14;
  return $[14] !== props2 ? (t14 = /* @__PURE__ */ jsxs("svg", { width: "100", height: "100", viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2, children: [
    t0,
    t1,
    t2,
    t3,
    t4,
    t5,
    t6,
    t7,
    t8,
    t9,
    t10,
    t11,
    t12,
    t13
  ] }), $[14] = props2, $[15] = t14) : t14 = $[15], t14;
}, EmptySchedules = (props2) => {
  const $ = c(16), {
    scheduleState,
    selectedDate
  } = props2;
  let BigIcon, description, heading;
  bb0: switch (scheduleState) {
    case "succeeded": {
      description = "When a scheduled document is successfully published it moves to this list view.", heading = "No completed scheduled publications ... yet", BigIcon = BigIconComingSoon;
      break bb0;
    }
    case "cancelled": {
      description = "Schedules can fail for several reasons, for example when their documents are deleted. When they do, they show up here.", heading = "No failed scheduled publications", BigIcon = BigIconSuccess;
      break bb0;
    }
    case "scheduled": {
      description = "When editing a document, create a new scheduled publication from the menu next to the Publish button.", heading = "No upcoming scheduled publications", BigIcon = BigIconScreen;
      break bb0;
    }
  }
  if (selectedDate) {
    description = "No schedules for this date.";
    let t02;
    $[0] !== selectedDate ? (t02 = format(selectedDate, "d MMMM yyyy"), $[0] = selectedDate, $[1] = t02) : t02 = $[1], heading = t02, BigIcon = BigIconScreen;
  }
  let t0;
  $[2] !== BigIcon ? (t0 = BigIcon && /* @__PURE__ */ jsx(BigIcon, {}), $[2] = BigIcon, $[3] = t0) : t0 = $[3];
  let t1;
  $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(Flex, { justify: "center", children: t0 }), $[4] = t0, $[5] = t1) : t1 = $[5];
  let t2;
  $[6] !== heading ? (t2 = heading && /* @__PURE__ */ jsx(Heading, { align: "center", size: 1, children: heading }), $[6] = heading, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== description ? (t3 = description && /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, children: description }), $[8] = description, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t2 || $[11] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t2,
    t3
  ] }), $[10] = t2, $[11] = t3, $[12] = t4) : t4 = $[12];
  let t5;
  return $[13] !== t1 || $[14] !== t4 ? (t5 = /* @__PURE__ */ jsx(Card, { paddingX: 6, paddingBottom: 8, paddingTop: 7, radius: 2, shadow: 1, children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t1,
    t4
  ] }) }), $[13] = t1, $[14] = t4, $[15] = t5) : t5 = $[15], t5;
}, isLiveEditEnabled = (schemaType) => schemaType.liveEdit === !0;
function getPreviewStateObservable(documentPreviewStore, schemaType, documentId, title) {
  const draft$ = isLiveEditEnabled(schemaType) ? of({
    snapshot: null
  }) : documentPreviewStore.observeForPreview({
    _type: "reference",
    _ref: getDraftId(documentId)
  }, schemaType), published$ = documentPreviewStore.observeForPreview({
    _type: "reference",
    _ref: getPublishedId(documentId)
  }, schemaType);
  return combineLatest([draft$, published$]).pipe(map(([draft, published]) => ({
    draft: draft.snapshot ? {
      title,
      ...draft.snapshot
    } : null,
    isLoading: !1,
    published: published.snapshot ? {
      title,
      ...published.snapshot
    } : null
  })), startWith({
    draft: null,
    isLoading: !0,
    published: null
  }));
}
function getScheduledDocument(schedule) {
  return schedule.documents?.[0];
}
function getScheduledDocumentId(schedule) {
  return getScheduledDocument(schedule)?.documentId.replaceAll("drafts.", "");
}
function usePreviewState(documentId, schemaType) {
  const $ = c(6), documentPreviewStore = useDocumentPreviewStore();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {}, $[0] = t0) : t0 = $[0];
  const [paneItemPreview, setPaneItemPreview] = useState(t0);
  let t1, t2;
  return $[1] !== documentId || $[2] !== documentPreviewStore || $[3] !== schemaType ? (t1 = () => {
    if (!schemaType)
      return;
    const subscription = getPreviewStateObservable(documentPreviewStore, schemaType, documentId, "").subscribe((state) => {
      setPaneItemPreview(state);
    });
    return () => {
      subscription?.unsubscribe();
    };
  }, t2 = [documentPreviewStore, schemaType, documentId], $[1] = documentId, $[2] = documentPreviewStore, $[3] = schemaType, $[4] = t1, $[5] = t2) : (t1 = $[4], t2 = $[5]), useEffect(t1, t2), paneItemPreview;
}
function useScheduleSchemaType(schedule) {
  const $ = c(5);
  let t0;
  $[0] !== schedule ? (t0 = getScheduledDocument(schedule), $[0] = schedule, $[1] = t0) : t0 = $[1];
  const firstDocument = t0, schema2 = useSchema(), schemaName = firstDocument.documentType;
  let t1;
  bb0: {
    if (!schemaName) {
      t1 = void 0;
      break bb0;
    }
    let t2;
    $[2] !== schema2 || $[3] !== schemaName ? (t2 = schema2.get(schemaName), $[2] = schema2, $[3] = schemaName, $[4] = t2) : t2 = $[4], t1 = t2;
  }
  return t1;
}
function useSchemaType(schemaName) {
  const $ = c(3), schema2 = useSchema();
  let t0;
  return $[0] !== schema2 || $[1] !== schemaName ? (t0 = schema2.get(schemaName), $[0] = schema2, $[1] = schemaName, $[2] = t0) : t0 = $[2], t0;
}
const DateWithTooltipElementQuery = styled(ElementQuery).withConfig({
  displayName: "DateWithTooltipElementQuery",
  componentId: "sc-hcyssw-0"
})`.date-small{display:inline;}.date-medium{display:none;}.date-large{display:none;}&[data-eq-min~='1']{.date-small{display:none;}.date-medium{display:inline;}.date-large{display:none;}}&[data-eq-min~='2']{.date-small{display:none;}.date-medium{display:none;}.date-large{display:inline;}}`;
function DocumentActionPropsProvider(t0) {
  const $ = c(3), {
    children,
    value
  } = t0;
  let t1;
  return $[0] !== children || $[1] !== value ? (t1 = /* @__PURE__ */ jsx(DocumentActionPropsContext.Provider, { value, children }), $[0] = children, $[1] = value, $[2] = t1) : t1 = $[2], t1;
}
function useDocumentActionProps() {
  const context = useContext(DocumentActionPropsContext);
  if (context === void 0)
    throw new Error("useDocumentActionProps must be used within a DocumentActionPropsProvider");
  return context;
}
function useScheduleForm(schedule) {
  const $ = c(8), [isDirty, setIsDirty] = useState(!1);
  let t0;
  $[0] !== schedule ? (t0 = schedule && schedule?.executeAt ? {
    date: schedule.executeAt
  } : null, $[0] = schedule, $[1] = t0) : t0 = $[1];
  const [formData, setFormData] = useState(t0);
  let t1;
  $[2] !== schedule ? (t1 = (form) => {
    const equalDates = schedule?.executeAt && new Date(schedule.executeAt).getTime() === new Date(form?.date).getTime();
    setFormData(form), setIsDirty(!equalDates);
  }, $[2] = schedule, $[3] = t1) : t1 = $[3];
  const handleFormChange = t1;
  let t2;
  return $[4] !== formData || $[5] !== handleFormChange || $[6] !== isDirty ? (t2 = {
    formData,
    isDirty,
    onFormChange: handleFormChange
  }, $[4] = formData, $[5] = handleFormChange, $[6] = isDirty, $[7] = t2) : t2 = $[7], t2;
}
function CalendarDay$1(props2) {
  const $ = c(27), {
    date,
    focused,
    isCurrentMonth,
    isToday: isToday2,
    customValidation,
    onSelect,
    selected
  } = props2;
  let t0;
  bb0: {
    if (!customValidation) {
      t0 = !0;
      break bb0;
    }
    let t13;
    $[0] !== customValidation || $[1] !== date ? (t13 = customValidation(endOfDay(date)), $[0] = customValidation, $[1] = date, $[2] = t13) : t13 = $[2], t0 = t13;
  }
  const isValid2 = t0;
  let t1;
  $[3] !== date || $[4] !== isValid2 || $[5] !== onSelect ? (t1 = () => {
    isValid2 && onSelect(date);
  }, $[3] = date, $[4] = isValid2, $[5] = onSelect, $[6] = t1) : t1 = $[6];
  const handleClick = t1;
  let t2;
  $[7] !== date ? (t2 = date.toDateString(), $[7] = date, $[8] = t2) : t2 = $[8];
  const t3 = focused ? "true" : "", t4 = !isValid2, t5 = isToday2 || selected ? "primary" : "default", t6 = !selected && !isCurrentMonth;
  let t7;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    textAlign: "center"
  }, $[9] = t7) : t7 = $[9];
  const t8 = isCurrentMonth ? "medium" : "regular";
  let t9;
  $[10] !== date ? (t9 = date.getDate(), $[10] = date, $[11] = t9) : t9 = $[11];
  let t10;
  $[12] !== t6 || $[13] !== t8 || $[14] !== t9 ? (t10 = /* @__PURE__ */ jsx(Text$1, { muted: t6, style: t7, weight: t8, children: t9 }), $[12] = t6, $[13] = t8, $[14] = t9, $[15] = t10) : t10 = $[15];
  let t11;
  $[16] !== handleClick || $[17] !== selected || $[18] !== t10 || $[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 ? (t11 = /* @__PURE__ */ jsx(Card, { "aria-label": t2, "aria-pressed": selected, as: "button", __unstable_focusRing: !0, "data-weekday": !0, "data-focused": t3, disabled: t4, role: "button", tabIndex: -1, onClick: handleClick, padding: 3, radius: 2, selected, tone: t5, children: t10 }), $[16] = handleClick, $[17] = selected, $[18] = t10, $[19] = t2, $[20] = t3, $[21] = t4, $[22] = t5, $[23] = t11) : t11 = $[23];
  let t12;
  return $[24] !== selected || $[25] !== t11 ? (t12 = /* @__PURE__ */ jsx("div", { "aria-selected": selected, "data-ui": "CalendarDay", children: t11 }), $[24] = selected, $[25] = t11, $[26] = t12) : t12 = $[26], t12;
}
const MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], WEEK_DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], HOURS_24 = range(0, 24), ARROW_KEYS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], TAIL_WEEKDAYS = [1, 2, 3, 4, 5, 6], getWeekStartsOfMonth = (date) => {
  const firstDay = startOfMonth(date);
  return eachWeekOfInterval({
    start: firstDay,
    end: lastDayOfMonth(firstDay)
  });
}, getWeekDaysFromWeekStarts = (weekStarts) => weekStarts.map((weekStart) => [weekStart, ...TAIL_WEEKDAYS.map((d) => addDays(weekStart, d))]), getWeeksOfMonth = (date) => getWeekDaysFromWeekStarts(getWeekStartsOfMonth(date)).map((days) => ({
  number: getWeek(days[0]),
  days
}));
function CalendarMonth(props2) {
  const $ = c(20), {
    customValidation,
    timeZoneScope
  } = props2, {
    getCurrentZoneDate
  } = useTimeZone(timeZoneScope), t0 = props2.hidden || !1;
  let t1, t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    gridTemplateColumns: "repeat(7, minmax(44px, 46px))"
  }, t2 = WEEK_DAY_NAMES.map(_temp$W), $[0] = t1, $[1] = t2) : (t1 = $[0], t2 = $[1]);
  let t3;
  if ($[2] !== customValidation || $[3] !== getCurrentZoneDate || $[4] !== props2.date || $[5] !== props2.focused || $[6] !== props2.onSelect || $[7] !== props2.selected) {
    let t42;
    $[9] !== customValidation || $[10] !== getCurrentZoneDate || $[11] !== props2.focused || $[12] !== props2.onSelect || $[13] !== props2.selected ? (t42 = (week, weekIdx) => week.days.map((date, dayIdx) => {
      const focused = props2.focused && isSameDay(date, props2.focused), selected = props2.selected && isSameDay(date, props2.selected), isToday2 = isSameDay(date, getCurrentZoneDate()), isCurrentMonth = props2.focused && isSameMonth(date, props2.focused);
      return /* @__PURE__ */ jsx(CalendarDay$1, { date, focused, isCurrentMonth, isToday: isToday2, customValidation, onSelect: props2.onSelect, selected }, `${weekIdx}-${dayIdx}`);
    }), $[9] = customValidation, $[10] = getCurrentZoneDate, $[11] = props2.focused, $[12] = props2.onSelect, $[13] = props2.selected, $[14] = t42) : t42 = $[14], t3 = getWeeksOfMonth(props2.date).map(t42), $[2] = customValidation, $[3] = getCurrentZoneDate, $[4] = props2.date, $[5] = props2.focused, $[6] = props2.onSelect, $[7] = props2.selected, $[8] = t3;
  } else
    t3 = $[8];
  let t4;
  $[15] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Grid, { gap: 1, style: t1, children: [
    t2,
    t3
  ] }), $[15] = t3, $[16] = t4) : t4 = $[16];
  let t5;
  return $[17] !== t0 || $[18] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { "aria-hidden": t0, "data-ui": "CalendarMonth", children: t4 }), $[17] = t0, $[18] = t4, $[19] = t5) : t5 = $[19], t5;
}
function _temp$W(weekday) {
  return /* @__PURE__ */ jsx(Box, { paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", style: {
    textAlign: "center"
  }, children: weekday }) }, weekday);
}
const features = {
  timePresets: !1
}, YearInput = (t0) => {
  const $ = c(8);
  let onChange, props2;
  $[0] !== t0 ? ({
    onChange,
    ...props2
  } = t0, $[0] = t0, $[1] = onChange, $[2] = props2) : (onChange = $[1], props2 = $[2]);
  let t1;
  $[3] !== onChange ? (t1 = (event) => {
    const numericValue = parseInt(event.currentTarget.value, 10);
    isNaN(numericValue) || onChange(numericValue);
  }, $[3] = onChange, $[4] = t1) : t1 = $[4];
  const handleChange = t1;
  let t2;
  return $[5] !== handleChange || $[6] !== props2 ? (t2 = /* @__PURE__ */ jsx(LazyTextInput, { "data-testid": "date-input", ...props2, onChange: handleChange, inputMode: "numeric" }), $[5] = handleChange, $[6] = props2, $[7] = t2) : t2 = $[7], t2;
}, PRESERVE_FOCUS_ELEMENT = /* @__PURE__ */ jsx("span", { "data-preserve-focus": !0, style: {
  overflow: "hidden",
  position: "absolute",
  outline: "none"
}, tabIndex: -1 }), Calendar = forwardRef(function(props2, forwardedRef) {
  const $ = c(95), {
    getCurrentZoneDate,
    zoneDateToUtc
  } = useTimeZone(props2.timeZoneScope);
  let customValidation, onFocusedDateChange, onSelect, restProps, selectTime, t0, t1, t2, timeZoneScope;
  $[0] !== props2 ? ({
    selectTime,
    onFocusedDateChange,
    selectedDate: t0,
    focusedDate: t1,
    timeStep: t2,
    onSelect,
    customValidation,
    timeZoneScope,
    ...restProps
  } = props2, $[0] = props2, $[1] = customValidation, $[2] = onFocusedDateChange, $[3] = onSelect, $[4] = restProps, $[5] = selectTime, $[6] = t0, $[7] = t1, $[8] = t2, $[9] = timeZoneScope) : (customValidation = $[1], onFocusedDateChange = $[2], onSelect = $[3], restProps = $[4], selectTime = $[5], t0 = $[6], t1 = $[7], t2 = $[8], timeZoneScope = $[9]);
  let t3;
  $[10] !== getCurrentZoneDate || $[11] !== t0 ? (t3 = t0 === void 0 ? getCurrentZoneDate() : t0, $[10] = getCurrentZoneDate, $[11] = t0, $[12] = t3) : t3 = $[12];
  const selectedDate = t3, focusedDate = t1 === void 0 ? selectedDate : t1, timeStep = t2 === void 0 ? 1 : t2;
  let t4;
  $[13] !== onFocusedDateChange || $[14] !== zoneDateToUtc ? (t4 = (date) => onFocusedDateChange(zoneDateToUtc(date)), $[13] = onFocusedDateChange, $[14] = zoneDateToUtc, $[15] = t4) : t4 = $[15];
  const setFocusedDate = t4;
  let t5;
  $[16] !== focusedDate || $[17] !== setFocusedDate ? (t5 = (month) => setFocusedDate(setDate(setMonth(focusedDate, month), 1)), $[16] = focusedDate, $[17] = setFocusedDate, $[18] = t5) : t5 = $[18];
  const setFocusedDateMonth = t5;
  let t6;
  $[19] !== setFocusedDateMonth ? (t6 = (e) => setFocusedDateMonth(Number(e.currentTarget.value)), $[19] = setFocusedDateMonth, $[20] = t6) : t6 = $[20];
  const handleFocusedMonthChange = t6;
  let t7;
  $[21] !== focusedDate || $[22] !== setFocusedDate ? (t7 = (by) => setFocusedDate(addMonths(focusedDate, by)), $[21] = focusedDate, $[22] = setFocusedDate, $[23] = t7) : t7 = $[23];
  const moveFocusedDate = t7;
  let t8;
  $[24] !== focusedDate || $[25] !== setFocusedDate ? (t8 = (year) => setFocusedDate(setYear(focusedDate, year)), $[24] = focusedDate, $[25] = setFocusedDate, $[26] = t8) : t8 = $[26];
  const setFocusedDateYear = t8;
  let t9;
  $[27] !== onSelect || $[28] !== selectedDate || $[29] !== zoneDateToUtc ? (t9 = (date_0) => {
    onSelect(zoneDateToUtc(setMinutes(setHours(date_0, selectedDate.getHours()), selectedDate.getMinutes())));
  }, $[27] = onSelect, $[28] = selectedDate, $[29] = zoneDateToUtc, $[30] = t9) : t9 = $[30];
  const handleDateChange = t9;
  let t10;
  $[31] !== onSelect || $[32] !== selectedDate || $[33] !== zoneDateToUtc ? (t10 = (event) => {
    const m = Number(event.currentTarget.value);
    onSelect(zoneDateToUtc(setMinutes(selectedDate, m)));
  }, $[31] = onSelect, $[32] = selectedDate, $[33] = zoneDateToUtc, $[34] = t10) : t10 = $[34];
  const handleMinutesChange = t10;
  let t11;
  $[35] !== onSelect || $[36] !== selectedDate || $[37] !== zoneDateToUtc ? (t11 = (event_0) => {
    const m_0 = Number(event_0.currentTarget.value);
    onSelect(zoneDateToUtc(setHours(selectedDate, m_0)));
  }, $[35] = onSelect, $[36] = selectedDate, $[37] = zoneDateToUtc, $[38] = t11) : t11 = $[38];
  const handleHoursChange = t11;
  let t12;
  $[39] !== onSelect || $[40] !== selectedDate || $[41] !== zoneDateToUtc ? (t12 = (hours, mins) => {
    onSelect(zoneDateToUtc(setHours(setMinutes(selectedDate, mins), hours)));
  }, $[39] = onSelect, $[40] = selectedDate, $[41] = zoneDateToUtc, $[42] = t12) : t12 = $[42];
  const handleTimeChange = t12, ref = useRef(null);
  let t13;
  $[43] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = () => ref.current, $[43] = t13) : t13 = $[43], useImperativeHandle(forwardedRef, t13);
  let t14;
  $[44] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t14 = () => {
    ref.current?.querySelector('[data-focused="true"]')?.focus();
  }, $[44] = t14) : t14 = $[44];
  const focusCurrentWeekDay = t14;
  let t15;
  $[45] !== focusedDate || $[46] !== onFocusedDateChange || $[47] !== zoneDateToUtc ? (t15 = (event_1) => {
    if (ARROW_KEYS.includes(event_1.key)) {
      if (event_1.preventDefault(), event_1.currentTarget.hasAttribute("data-calendar-grid")) {
        focusCurrentWeekDay();
        return;
      }
      event_1.key === "ArrowUp" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, -7))), event_1.key === "ArrowDown" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, 7))), event_1.key === "ArrowLeft" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, -1))), event_1.key === "ArrowRight" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, 1))), ref.current?.querySelector("[data-preserve-focus]")?.focus();
    }
  }, $[45] = focusedDate, $[46] = onFocusedDateChange, $[47] = zoneDateToUtc, $[48] = t15) : t15 = $[48];
  const handleKeyDown = t15;
  let t16, t17;
  $[49] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = () => {
    focusCurrentWeekDay();
  }, t17 = [focusCurrentWeekDay], $[49] = t16, $[50] = t17) : (t16 = $[49], t17 = $[50]), useEffect(t16, t17);
  let t18;
  $[51] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t18 = () => {
    document.activeElement?.matches("[data-calendar-grid], [data-calendar-grid] [data-preserve-focus]") && focusCurrentWeekDay();
  }, $[51] = t18) : t18 = $[51];
  let t19;
  $[52] !== focusedDate ? (t19 = [ref, focusCurrentWeekDay, focusedDate], $[52] = focusedDate, $[53] = t19) : t19 = $[53], useEffect(t18, t19);
  let t20;
  $[54] !== onSelect ? (t20 = () => onSelect(/* @__PURE__ */ new Date()), $[54] = onSelect, $[55] = t20) : t20 = $[55];
  const handleNowClick = t20;
  let t21;
  $[56] !== focusedDate ? (t21 = focusedDate?.getMonth(), $[56] = focusedDate, $[57] = t21) : t21 = $[57];
  let t22;
  $[58] !== handleFocusedMonthChange || $[59] !== moveFocusedDate || $[60] !== t21 ? (t22 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(CalendarMonthSelect, { moveFocusedDate, onChange: handleFocusedMonthChange, value: t21 }) }), $[58] = handleFocusedMonthChange, $[59] = moveFocusedDate, $[60] = t21, $[61] = t22) : t22 = $[61];
  let t23;
  $[62] !== focusedDate ? (t23 = focusedDate.getFullYear(), $[62] = focusedDate, $[63] = t23) : t23 = $[63];
  let t24;
  $[64] !== moveFocusedDate || $[65] !== setFocusedDateYear || $[66] !== t23 ? (t24 = /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(CalendarYearSelect, { moveFocusedDate, onChange: setFocusedDateYear, value: t23 }) }), $[64] = moveFocusedDate, $[65] = setFocusedDateYear, $[66] = t23, $[67] = t24) : t24 = $[67];
  let t25;
  $[68] !== t22 || $[69] !== t24 ? (t25 = /* @__PURE__ */ jsxs(Flex, { children: [
    t22,
    t24
  ] }), $[68] = t22, $[69] = t24, $[70] = t25) : t25 = $[70];
  let t26;
  $[71] !== customValidation || $[72] !== focusedDate || $[73] !== handleDateChange || $[74] !== selectedDate || $[75] !== timeZoneScope ? (t26 = /* @__PURE__ */ jsx(CalendarMonth, { date: focusedDate, focused: focusedDate, customValidation, onSelect: handleDateChange, selected: selectedDate, timeZoneScope }), $[71] = customValidation, $[72] = focusedDate, $[73] = handleDateChange, $[74] = selectedDate, $[75] = timeZoneScope, $[76] = t26) : t26 = $[76];
  let t27;
  $[77] !== handleKeyDown || $[78] !== t26 ? (t27 = /* @__PURE__ */ jsxs(Box, { "data-calendar-grid": !0, onKeyDown: handleKeyDown, marginTop: 2, overflow: "hidden", tabIndex: 0, children: [
    t26,
    PRESERVE_FOCUS_ELEMENT
  ] }), $[77] = handleKeyDown, $[78] = t26, $[79] = t27) : t27 = $[79];
  let t28;
  $[80] !== t25 || $[81] !== t27 ? (t28 = /* @__PURE__ */ jsxs(Box, { padding: 2, children: [
    t25,
    t27
  ] }), $[80] = t25, $[81] = t27, $[82] = t28) : t28 = $[82];
  let t29;
  $[83] !== handleHoursChange || $[84] !== handleMinutesChange || $[85] !== handleNowClick || $[86] !== handleTimeChange || $[87] !== selectTime || $[88] !== selectedDate || $[89] !== timeStep ? (t29 = selectTime && /* @__PURE__ */ jsxs(Box, { padding: 2, style: {
    borderTop: "1px solid var(--card-border-color)"
  }, children: [
    /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
      /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, children: [
        /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Select, { "aria-label": "Select hour", value: selectedDate?.getHours(), onChange: handleHoursChange, children: HOURS_24.map(_temp$V) }) }),
        /* @__PURE__ */ jsx(Box, { paddingX: 1, children: /* @__PURE__ */ jsx(Text$1, { children: ":" }) }),
        /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Select, { "aria-label": "Select minutes", value: selectedDate?.getMinutes(), onChange: handleMinutesChange, children: range(0, 60, timeStep).map(_temp2$k) }) })
      ] }),
      /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(Button$1, { text: "Set to current time", mode: "bleed", onClick: handleNowClick }) })
    ] }),
    features.timePresets
  ] }), $[83] = handleHoursChange, $[84] = handleMinutesChange, $[85] = handleNowClick, $[86] = handleTimeChange, $[87] = selectTime, $[88] = selectedDate, $[89] = timeStep, $[90] = t29) : t29 = $[90];
  let t30;
  return $[91] !== restProps || $[92] !== t28 || $[93] !== t29 ? (t30 = /* @__PURE__ */ jsxs(Box, { "data-ui": "Calendar", ...restProps, ref, children: [
    t28,
    t29
  ] }), $[91] = restProps, $[92] = t28, $[93] = t29, $[94] = t30) : t30 = $[94], t30;
});
function CalendarMonthSelect(props2) {
  const $ = c(16), {
    moveFocusedDate,
    onChange,
    value
  } = props2;
  let t0;
  $[0] !== moveFocusedDate ? (t0 = () => moveFocusedDate(-1), $[0] = moveFocusedDate, $[1] = t0) : t0 = $[1];
  const handlePrevMonthClick = t0;
  let t1;
  $[2] !== moveFocusedDate ? (t1 = () => moveFocusedDate(1), $[2] = moveFocusedDate, $[3] = t1) : t1 = $[3];
  const handleNextMonthClick = t1;
  let t2;
  $[4] !== handlePrevMonthClick ? (t2 = /* @__PURE__ */ jsx(Button$1, { "aria-label": "Go to previous month", onClick: handlePrevMonthClick, mode: "bleed", icon: ChevronLeftIcon, paddingX: 2, radius: 0 }), $[4] = handlePrevMonthClick, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = MONTH_NAMES.map(_temp3$a), $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== onChange || $[8] !== value ? (t4 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Select, { radius: 0, value, onChange, children: t3 }) }), $[7] = onChange, $[8] = value, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== handleNextMonthClick ? (t5 = /* @__PURE__ */ jsx(Button$1, { "aria-label": "Go to next month", mode: "bleed", icon: ChevronRightIcon, onClick: handleNextMonthClick, paddingX: 2, radius: 0 }), $[10] = handleNextMonthClick, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== t2 || $[13] !== t4 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { flex: 1, children: [
    t2,
    t4,
    t5
  ] }), $[12] = t2, $[13] = t4, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
}
function _temp3$a(m, i) {
  return /* @__PURE__ */ jsx("option", { value: i, children: m }, i);
}
function CalendarYearSelect(props2) {
  const $ = c(16), {
    moveFocusedDate,
    onChange,
    value
  } = props2;
  let t0;
  $[0] !== moveFocusedDate ? (t0 = () => moveFocusedDate(-12), $[0] = moveFocusedDate, $[1] = t0) : t0 = $[1];
  const handlePrevYearClick = t0;
  let t1;
  $[2] !== moveFocusedDate ? (t1 = () => moveFocusedDate(12), $[2] = moveFocusedDate, $[3] = t1) : t1 = $[3];
  const handleNextYearClick = t1;
  let t2;
  $[4] !== handlePrevYearClick ? (t2 = /* @__PURE__ */ jsx(Button$1, { "aria-label": "Previous year", onClick: handlePrevYearClick, mode: "bleed", icon: ChevronLeftIcon, paddingX: 2, radius: 0 }), $[4] = handlePrevYearClick, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    width: 65
  }, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== onChange || $[8] !== value ? (t4 = /* @__PURE__ */ jsx(YearInput, { value, onChange, radius: 0, style: t3 }), $[7] = onChange, $[8] = value, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== handleNextYearClick ? (t5 = /* @__PURE__ */ jsx(Button$1, { "aria-label": "Next year", onClick: handleNextYearClick, mode: "bleed", icon: ChevronRightIcon, paddingX: 2, radius: 0 }), $[10] = handleNextYearClick, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== t2 || $[13] !== t4 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { children: [
    t2,
    t4,
    t5
  ] }), $[12] = t2, $[13] = t4, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
}
function _temp$V(h) {
  return /* @__PURE__ */ jsx("option", { value: h, children: `${h}`.padStart(2, "0") }, h);
}
function _temp2$k(m_1) {
  return /* @__PURE__ */ jsx("option", { value: m_1, children: `${m_1}`.padStart(2, "0") }, m_1);
}
const DatePicker = forwardRef(function(props2, ref) {
  const $ = c(24);
  let _value, customValidation, onChange, rest, timeZoneScope;
  $[0] !== props2 ? ({
    value: _value,
    onChange,
    customValidation,
    timeZoneScope,
    ...rest
  } = props2, $[0] = props2, $[1] = _value, $[2] = customValidation, $[3] = onChange, $[4] = rest, $[5] = timeZoneScope) : (_value = $[1], customValidation = $[2], onChange = $[3], rest = $[4], timeZoneScope = $[5]);
  let t0;
  $[6] !== _value ? (t0 = _value ?? /* @__PURE__ */ new Date(), $[6] = _value, $[7] = t0) : t0 = $[7];
  const value = t0, {
    utcToCurrentZoneDate
  } = useTimeZone(timeZoneScope), [focusedDate, setFocusedDay] = useState();
  let t1;
  $[8] !== onChange ? (t1 = (nextDate) => {
    onChange(nextDate), setFocusedDay(void 0);
  }, $[8] = onChange, $[9] = t1) : t1 = $[9];
  const handleSelect = t1;
  let t2;
  $[10] !== utcToCurrentZoneDate || $[11] !== value ? (t2 = utcToCurrentZoneDate(value), $[10] = utcToCurrentZoneDate, $[11] = value, $[12] = t2) : t2 = $[12];
  const t3 = focusedDate || value;
  let t4;
  $[13] !== t3 || $[14] !== utcToCurrentZoneDate ? (t4 = utcToCurrentZoneDate(t3), $[13] = t3, $[14] = utcToCurrentZoneDate, $[15] = t4) : t4 = $[15];
  let t5;
  return $[16] !== customValidation || $[17] !== handleSelect || $[18] !== ref || $[19] !== rest || $[20] !== t2 || $[21] !== t4 || $[22] !== timeZoneScope ? (t5 = /* @__PURE__ */ jsx(Calendar, { ...rest, ref, selectedDate: t2, onSelect: handleSelect, focusedDate: t4, onFocusedDateChange: setFocusedDay, customValidation, timeZoneScope }), $[16] = customValidation, $[17] = handleSelect, $[18] = ref, $[19] = rest, $[20] = t2, $[21] = t4, $[22] = timeZoneScope, $[23] = t5) : t5 = $[23], t5;
}), DateTimeInput$1 = forwardRef(function(props2, forwardedRef) {
  const $ = c(32);
  let customValidation, inputValue, onChange, onInputChange, rest, selectTime, timeStep, timeZoneScope, value;
  $[0] !== props2 ? ({
    value,
    inputValue,
    customValidation,
    onInputChange,
    onChange,
    selectTime,
    timeStep,
    timeZoneScope,
    ...rest
  } = props2, $[0] = props2, $[1] = customValidation, $[2] = inputValue, $[3] = onChange, $[4] = onInputChange, $[5] = rest, $[6] = selectTime, $[7] = timeStep, $[8] = timeZoneScope, $[9] = value) : (customValidation = $[1], inputValue = $[2], onChange = $[3], onInputChange = $[4], rest = $[5], selectTime = $[6], timeStep = $[7], timeZoneScope = $[8], value = $[9]);
  const popoverRef = useRef(null), inputRef = useRef(null), buttonRef = useRef(null);
  let t0;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => inputRef.current, $[10] = t0) : t0 = $[10], useImperativeHandle(forwardedRef, t0);
  const [isPickerOpen, setPickerOpen] = useState(!1), portal = usePortal();
  let t1, t2;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setPickerOpen(!1), t2 = () => [popoverRef.current], $[11] = t1, $[12] = t2) : (t1 = $[11], t2 = $[12]), useClickOutsideEvent(t1, t2);
  let t3;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    inputRef.current?.focus(), inputRef.current?.select();
  }, $[13] = t3) : t3 = $[13];
  const handleDeactivation = t3;
  let t4;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = (e) => {
    e.key === "Escape" && setPickerOpen(!1);
  }, $[14] = t4) : t4 = $[14];
  const handleKeyUp = t4;
  let t5;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => setPickerOpen(!0), $[15] = t5) : t5 = $[15];
  const handleClick = t5;
  let t6;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    padding: "5px"
  }, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsx(Box, { style: t6, children: /* @__PURE__ */ jsx(Button$1, { ref: buttonRef, icon: CalendarIcon, mode: "bleed", padding: 2, onClick: handleClick, style: {
    display: "block"
  }, "data-testid": "select-date-button" }) }), $[17] = t7) : t7 = $[17];
  const suffix = t7;
  let t8;
  $[18] !== customValidation || $[19] !== isPickerOpen || $[20] !== onChange || $[21] !== portal || $[22] !== selectTime || $[23] !== timeStep || $[24] !== timeZoneScope || $[25] !== value ? (t8 = isPickerOpen ? /* @__PURE__ */ jsx(LayerProvider, { zOffset: 1e3, children: /* @__PURE__ */ jsx(Popover, { constrainSize: !0, content: /* @__PURE__ */ jsx(Box, { overflow: "auto", children: /* @__PURE__ */ jsx(FocusLock, { onDeactivation: handleDeactivation, children: /* @__PURE__ */ jsx(DatePicker, { selectTime, timeStep, onKeyUp: handleKeyUp, value, onChange, customValidation, timeZoneScope }) }) }), "data-testid": "date-input-dialog", fallbackPlacements: ["bottom", "bottom-start", "top-end", "top", "top-start"], floatingBoundary: portal.element, open: !0, placement: "bottom-end", portal: !0, radius: 2, ref: popoverRef, children: suffix }) }) : suffix, $[18] = customValidation, $[19] = isPickerOpen, $[20] = onChange, $[21] = portal, $[22] = selectTime, $[23] = timeStep, $[24] = timeZoneScope, $[25] = value, $[26] = t8) : t8 = $[26];
  let t9;
  return $[27] !== inputValue || $[28] !== onInputChange || $[29] !== rest || $[30] !== t8 ? (t9 = /* @__PURE__ */ jsx(LazyTextInput, { "data-testid": "date-input", ref: inputRef, ...rest, value: inputValue, onChange: onInputChange, suffix: t8 }), $[27] = inputValue, $[28] = onInputChange, $[29] = rest, $[30] = t8, $[31] = t9) : t9 = $[31], t9;
}), CommonDateTimeInput = forwardRef(function(props2, forwardedRef) {
  const $ = c(67);
  let customValidation, description, deserialize2, formatInputValue, level, markers, onChange, parseInputValue, placeholder, readOnly, rest, selectTime, serialize2, timeStep, timeZoneScope, title, value;
  $[0] !== props2 ? ({
    value,
    markers,
    title,
    description,
    placeholder,
    parseInputValue,
    formatInputValue,
    deserialize: deserialize2,
    serialize: serialize2,
    selectTime,
    timeStep,
    readOnly,
    level,
    onChange,
    customValidation,
    timeZoneScope,
    ...rest
  } = props2, $[0] = props2, $[1] = customValidation, $[2] = description, $[3] = deserialize2, $[4] = formatInputValue, $[5] = level, $[6] = markers, $[7] = onChange, $[8] = parseInputValue, $[9] = placeholder, $[10] = readOnly, $[11] = rest, $[12] = selectTime, $[13] = serialize2, $[14] = timeStep, $[15] = timeZoneScope, $[16] = title, $[17] = value) : (customValidation = $[1], description = $[2], deserialize2 = $[3], formatInputValue = $[4], level = $[5], markers = $[6], onChange = $[7], parseInputValue = $[8], placeholder = $[9], readOnly = $[10], rest = $[11], selectTime = $[12], serialize2 = $[13], timeStep = $[14], timeZoneScope = $[15], title = $[16], value = $[17]);
  const [localValue, setLocalValue] = useState(null);
  let t0;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setLocalValue(null);
  }, $[18] = t0) : t0 = $[18];
  let t1;
  $[19] !== value ? (t1 = [value], $[19] = value, $[20] = t1) : t1 = $[20], useEffect(t0, t1);
  const {
    zoneDateToUtc
  } = useTimeZone(timeZoneScope), undefinedValue = typeof value > "u";
  let t2;
  $[21] !== localValue || $[22] !== onChange || $[23] !== parseInputValue || $[24] !== serialize2 || $[25] !== undefinedValue || $[26] !== zoneDateToUtc ? (t2 = (event) => {
    const nextInputValue = event.currentTarget.value, result = nextInputValue === "" ? null : parseInputValue(nextInputValue);
    result === null ? (onChange(null), undefinedValue && localValue && setLocalValue(null)) : result.isValid ? onChange(serialize2(zoneDateToUtc(result.date))) : setLocalValue(nextInputValue);
  }, $[21] = localValue, $[22] = onChange, $[23] = parseInputValue, $[24] = serialize2, $[25] = undefinedValue, $[26] = zoneDateToUtc, $[27] = t2) : t2 = $[27];
  const handleDatePickerInputChange = t2;
  let t3;
  $[28] !== onChange || $[29] !== serialize2 ? (t3 = (nextDate) => {
    onChange(nextDate ? serialize2(nextDate) : null);
  }, $[28] = onChange, $[29] = serialize2, $[30] = t3) : t3 = $[30];
  const handleDatePickerChange = t3, inputRef = useRef(null);
  let t4;
  $[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => inputRef.current, $[31] = t4) : t4 = $[31], useImperativeHandle(forwardedRef, t4);
  const id2 = useId();
  let parseResult, t5;
  $[32] !== deserialize2 || $[33] !== formatInputValue || $[34] !== localValue || $[35] !== parseInputValue || $[36] !== value ? (parseResult = localValue ? parseInputValue(localValue) : value ? deserialize2(value) : null, t5 = localValue || (parseResult?.isValid ? formatInputValue(parseResult.date) : value), $[32] = deserialize2, $[33] = formatInputValue, $[34] = localValue, $[35] = parseInputValue, $[36] = value, $[37] = parseResult, $[38] = t5) : (parseResult = $[37], t5 = $[38]);
  const inputValue = t5;
  let t6;
  $[39] !== markers ? (t6 = markers.map(_temp$U), $[39] = markers, $[40] = t6) : t6 = $[40];
  const nodeValidations = t6;
  let t7;
  $[41] !== nodeValidations || $[42] !== parseResult ? (t7 = parseResult?.error ? [...nodeValidations, {
    level: "error",
    message: parseResult.error,
    path: []
  }] : nodeValidations, $[41] = nodeValidations, $[42] = parseResult, $[43] = t7) : t7 = $[43];
  let t8;
  $[44] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = [], $[44] = t8) : t8 = $[44];
  let t9;
  $[45] !== customValidation || $[46] !== formatInputValue || $[47] !== handleDatePickerChange || $[48] !== handleDatePickerInputChange || $[49] !== id2 || $[50] !== inputValue || $[51] !== parseResult?.date || $[52] !== parseResult?.error || $[53] !== placeholder || $[54] !== readOnly || $[55] !== rest || $[56] !== selectTime || $[57] !== timeStep || $[58] !== timeZoneScope ? (t9 = readOnly ? /* @__PURE__ */ jsx(TextInput$1, { value: inputValue, readOnly: !0 }) : /* @__PURE__ */ jsx(DateTimeInput$1, { ...rest, id: id2, selectTime, timeStep, placeholder: placeholder || `e.g. ${formatInputValue(/* @__PURE__ */ new Date())}`, ref: inputRef, value: parseResult?.date, inputValue: inputValue || "", readOnly: !!readOnly, onInputChange: handleDatePickerInputChange, onChange: handleDatePickerChange, customValidity: parseResult?.error, customValidation, timeZoneScope }), $[45] = customValidation, $[46] = formatInputValue, $[47] = handleDatePickerChange, $[48] = handleDatePickerInputChange, $[49] = id2, $[50] = inputValue, $[51] = parseResult?.date, $[52] = parseResult?.error, $[53] = placeholder, $[54] = readOnly, $[55] = rest, $[56] = selectTime, $[57] = timeStep, $[58] = timeZoneScope, $[59] = t9) : t9 = $[59];
  let t10;
  return $[60] !== description || $[61] !== id2 || $[62] !== level || $[63] !== t7 || $[64] !== t9 || $[65] !== title ? (t10 = /* @__PURE__ */ jsx(FormField, { validation: t7, title, level, description, inputId: id2, path: t8, children: t9 }), $[60] = description, $[61] = id2, $[62] = level, $[63] = t7, $[64] = t9, $[65] = title, $[66] = t10) : t10 = $[66], t10;
});
function _temp$U(m) {
  return {
    level: m.level,
    path: m.path,
    message: m.message ?? m.item?.message
  };
}
function isValidDate(date) {
  return date instanceof Date && !isNaN(date.valueOf());
}
function parseOptions(options = {}) {
  return {
    customValidation: options.customValidation || function() {
      return !0;
    },
    customValidationMessage: options.customValidationMessage || "Invalid date.",
    calendarTodayLabel: options.calendarTodayLabel || "Today",
    timeStep: "timeStep" in options && Number(options.timeStep) || 1
  };
}
function serialize$1(date) {
  return date.toISOString();
}
function deserialize$1(isoString) {
  const deserialized = new Date(isoString);
  return isValidDate(deserialized) ? {
    isValid: !0,
    date: deserialized
  } : {
    isValid: !1,
    error: `Invalid date value: "${isoString}"`
  };
}
function enforceTimeStep(dateString, timeStep) {
  if (!timeStep || timeStep === 1)
    return dateString;
  const date = parseISO(dateString), minutes = getMinutes(date), leftOver = minutes % timeStep;
  return serialize$1(leftOver !== 0 ? setMinutes(date, minutes - leftOver) : date);
}
const DateTimeInput = forwardRef(function(props2, forwardedRef) {
  const $ = c(30);
  let onChange, rest, timeZoneScope, type;
  $[0] !== props2 ? ({
    type,
    onChange,
    timeZoneScope,
    ...rest
  } = props2, $[0] = props2, $[1] = onChange, $[2] = rest, $[3] = timeZoneScope, $[4] = type) : (onChange = $[1], rest = $[2], timeZoneScope = $[3], type = $[4]);
  const {
    title,
    description,
    placeholder
  } = type, {
    scheduledPublishing: scheduledPublishing2
  } = useWorkspace(), inputDateTimeFormat = scheduledPublishing2.inputDateTimeFormat, {
    getCurrentZoneDate,
    timeZone
  } = useTimeZone(timeZoneScope);
  let t0;
  $[5] !== type.options ? (t0 = parseOptions(type.options), $[5] = type.options, $[6] = t0) : t0 = $[6];
  const {
    customValidation,
    customValidationMessage,
    timeStep
  } = t0;
  let t1;
  $[7] !== onChange || $[8] !== timeStep ? (t1 = (nextDate) => {
    let date = nextDate;
    date !== null && timeStep > 1 && (date = enforceTimeStep(date, timeStep)), onChange(date);
  }, $[7] = onChange, $[8] = timeStep, $[9] = t1) : t1 = $[9];
  const handleChange = t1;
  let t2;
  $[10] !== inputDateTimeFormat || $[11] !== timeZone.name ? (t2 = (date_0) => format(date_0, `${inputDateTimeFormat}`, {
    in: tz(timeZone.name)
  }), $[10] = inputDateTimeFormat, $[11] = timeZone.name, $[12] = t2) : t2 = $[12];
  const formatInputValue = t2;
  let t3;
  $[13] !== customValidation || $[14] !== customValidationMessage || $[15] !== getCurrentZoneDate || $[16] !== inputDateTimeFormat ? (t3 = (inputValue) => {
    const parsed = parse(inputValue, `${inputDateTimeFormat}`, getCurrentZoneDate());
    return isValid(parsed) ? customValidation(parsed) ? {
      isValid: !0,
      date: parsed
    } : {
      isValid: !1,
      error: customValidationMessage
    } : {
      isValid: !1,
      error: `Invalid date. Must be in the format "${inputDateTimeFormat}"`
    };
  }, $[13] = customValidation, $[14] = customValidationMessage, $[15] = getCurrentZoneDate, $[16] = inputDateTimeFormat, $[17] = t3) : t3 = $[17];
  const parseInputValue = t3;
  let t4;
  return $[18] !== customValidation || $[19] !== description || $[20] !== formatInputValue || $[21] !== forwardedRef || $[22] !== handleChange || $[23] !== parseInputValue || $[24] !== placeholder || $[25] !== rest || $[26] !== timeStep || $[27] !== timeZoneScope || $[28] !== title ? (t4 = /* @__PURE__ */ jsx(CommonDateTimeInput, { ...rest, onChange: handleChange, ref: forwardedRef, selectTime: !0, timeStep, title, description, placeholder, serialize: serialize$1, deserialize: deserialize$1, formatInputValue, customValidation, parseInputValue, timeZoneScope }), $[18] = customValidation, $[19] = description, $[20] = formatInputValue, $[21] = forwardedRef, $[22] = handleChange, $[23] = parseInputValue, $[24] = placeholder, $[25] = rest, $[26] = timeStep, $[27] = timeZoneScope, $[28] = title, $[29] = t4) : t4 = $[29], t4;
}), ScheduleForm = (props2) => {
  const $ = c(11), {
    onChange,
    value
  } = props2, {
    getCurrentZoneDate
  } = useTimeZone(SCHEDULED_PUBLISHING_TIME_ZONE_SCOPE), [inputValue, setInputValue] = useState();
  let t0;
  $[0] !== onChange ? (t0 = (date) => {
    date && onChange && (onChange({
      date
    }), setInputValue(date));
  }, $[0] = onChange, $[1] = t0) : t0 = $[1];
  const handleChange = t0;
  let t1;
  $[2] !== getCurrentZoneDate ? (t1 = (selectedDate) => selectedDate > getCurrentZoneDate(), $[2] = getCurrentZoneDate, $[3] = t1) : t1 = $[3];
  const handleCustomValidation = t1;
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== handleCustomValidation ? (t3 = {
    name: "date",
    options: {
      customValidation: handleCustomValidation,
      customValidationMessage: "Date cannot be in the past."
    },
    title: "Date and time"
  }, $[5] = handleCustomValidation, $[6] = t3) : t3 = $[6];
  const t4 = inputValue === void 0 ? value?.date : inputValue;
  let t5;
  return $[7] !== handleChange || $[8] !== t3 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(Stack, { space: 4, children: /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx(DateTimeInput, { level: 0, markers: t2, onChange: handleChange, type: t3, value: t4, timeZoneScope: SCHEDULED_PUBLISHING_TIME_ZONE_SCOPE }) }) }), $[7] = handleChange, $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
};
function EditScheduleForm(props2) {
  const $ = c(6), {
    onChange,
    value
  } = props2;
  let t0;
  $[0] !== onChange || $[1] !== value ? (t0 = /* @__PURE__ */ jsx(ScheduleForm, { onChange, value }), $[0] = onChange, $[1] = value, $[2] = t0) : t0 = $[2];
  let t1;
  return $[3] !== props2.children || $[4] !== t0 ? (t1 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    props2.children,
    t0
  ] }), $[3] = props2.children, $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}
const DialogHeader$1 = (props2) => {
  const $ = c(12), {
    title,
    timeZoneScope
  } = props2, {
    timeZone
  } = useTimeZone(timeZoneScope), {
    t
  } = useTranslation();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("input", { style: {
    opacity: 0,
    position: "absolute",
    width: 0
  }, tabIndex: -1, type: "button" }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    marginTop: "-1em",
    marginBottom: "-1em"
  }, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t || $[3] !== timeZone.alternativeName || $[4] !== timeZone.offset ? (t2 = t("time-zone.time-zone-tooltip-scheduled-publishing", {
    alternativeName: timeZone.alternativeName,
    offset: timeZone.offset
  }), $[2] = t, $[3] = timeZone.alternativeName, $[4] = timeZone.offset, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t2 || $[7] !== timeZoneScope ? (t3 = /* @__PURE__ */ jsx(Box, { marginLeft: 2, style: t1, children: /* @__PURE__ */ jsx(TimeZoneButton, { tooltipContent: t2, timeZoneScope, useElementQueries: !0 }) }), $[6] = t2, $[7] = timeZoneScope, $[8] = t3) : t3 = $[8];
  let t4;
  return $[9] !== t3 || $[10] !== title ? (t4 = /* @__PURE__ */ jsx(TimeZoneButtonElementQuery, { children: /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    title,
    t0,
    t3
  ] }) }), $[9] = t3, $[10] = title, $[11] = t4) : t4 = $[11], t4;
}, DialogScheduleEdit = (props2) => {
  const $ = c(16), {
    onClose,
    schedule
  } = props2, {
    updateSchedule
  } = useScheduleOperation(), {
    formData,
    isDirty,
    onFormChange
  } = useScheduleForm(schedule);
  let t0;
  $[0] !== formData || $[1] !== onClose || $[2] !== schedule || $[3] !== updateSchedule ? (t0 = async () => {
    formData?.date && (await updateSchedule({
      date: formData.date,
      scheduleId: schedule.id
    }), onClose());
  }, $[0] = formData, $[1] = onClose, $[2] = schedule, $[3] = updateSchedule, $[4] = t0) : t0 = $[4];
  const handleScheduleUpdate = t0, t1 = !isDirty;
  let t2;
  $[5] !== handleScheduleUpdate || $[6] !== t1 ? (t2 = {
    confirmButton: {
      text: "Update",
      disabled: t1,
      onClick: handleScheduleUpdate
    }
  }, $[5] = handleScheduleUpdate, $[6] = t1, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(DialogHeader$1, { timeZoneScope: SCHEDULED_PUBLISHING_TIME_ZONE_SCOPE, title: "Edit schedule" }), $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== formData || $[10] !== onFormChange ? (t4 = /* @__PURE__ */ jsx(EditScheduleForm, { onChange: onFormChange, value: formData }), $[9] = formData, $[10] = onFormChange, $[11] = t4) : t4 = $[11];
  let t5;
  return $[12] !== onClose || $[13] !== t2 || $[14] !== t4 ? (t5 = /* @__PURE__ */ jsx(Dialog$1, { footer: t2, header: t3, id: "time-zone", onClose, width: 1, children: t4 }), $[12] = onClose, $[13] = t2, $[14] = t4, $[15] = t5) : t5 = $[15], t5;
};
function useDialogVisible(timeZoneScope) {
  const $ = c(5), [dialogVisible, setDialogVisible] = useState(!1);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setDialogVisible(!1);
  }, $[0] = t0) : t0 = $[0];
  const hide = t0;
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setDialogVisible(!0);
  }, $[1] = t1) : t1 = $[1];
  const show = t1;
  let t2;
  return $[2] !== dialogVisible || $[3] !== timeZoneScope ? (t2 = {
    visible: dialogVisible,
    show,
    timeZoneScope,
    hide
  }, $[2] = dialogVisible, $[3] = timeZoneScope, $[4] = t2) : t2 = $[4], t2;
}
function useDialogScheduleEdit(schedule, tzScope) {
  const $ = c(10), {
    visible,
    show,
    hide,
    timeZoneScope
  } = useDialogVisible(tzScope);
  let t0;
  $[0] !== hide || $[1] !== schedule || $[2] !== visible ? (t0 = {
    onClose: hide,
    schedule,
    visible
  }, $[0] = hide, $[1] = schedule, $[2] = visible, $[3] = t0) : t0 = $[3];
  const dialogProps = t0, t1 = visible ? DialogScheduleEdit : null;
  let t2;
  return $[4] !== dialogProps || $[5] !== hide || $[6] !== show || $[7] !== t1 || $[8] !== timeZoneScope ? (t2 = {
    DialogScheduleEdit: t1,
    dialogProps,
    timeZoneScope,
    dialogScheduleEditShow: show,
    hide
  }, $[4] = dialogProps, $[5] = hide, $[6] = show, $[7] = t1, $[8] = timeZoneScope, $[9] = t2) : t2 = $[9], t2;
}
const MenuItemWithPermissionsTooltip = (props2) => {
  const $ = c(13), {
    currentUser,
    hasPermission,
    icon,
    onClick: onClick2,
    permissionsOperationLabel,
    title,
    tone,
    disabled
  } = props2;
  let t0;
  $[0] !== currentUser || $[1] !== permissionsOperationLabel ? (t0 = /* @__PURE__ */ jsx(Box, { paddingX: 2, paddingY: 1, children: /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: permissionsOperationLabel }) }), $[0] = currentUser, $[1] = permissionsOperationLabel, $[2] = t0) : t0 = $[2];
  const t1 = !hasPermission || disabled;
  let t2;
  $[3] !== icon || $[4] !== onClick2 || $[5] !== t1 || $[6] !== title || $[7] !== tone ? (t2 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(MenuItem, { disabled: t1, icon, onClick: onClick2, text: title, tone }) }), $[3] = icon, $[4] = onClick2, $[5] = t1, $[6] = title, $[7] = tone, $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== hasPermission || $[10] !== t0 || $[11] !== t2 ? (t3 = /* @__PURE__ */ jsx(Tooltip, { content: t0, disabled: hasPermission, placement: "left", portal: !0, children: t2 }), $[9] = hasPermission, $[10] = t0, $[11] = t2, $[12] = t3) : t3 = $[12], t3;
}, ContextMenuItems = (props2) => {
  const $ = c(43), {
    actions,
    onDelete,
    onEdit,
    schedule,
    schemaType
  } = props2, {
    mode
  } = useScheduledPublishingEnabled();
  let t0;
  $[0] !== schedule ? (t0 = getScheduledDocument(schedule), $[0] = schedule, $[1] = t0) : t0 = $[1];
  const firstDocument = t0, currentUser = useCurrentUser(), t1 = schemaType?.name;
  let t2;
  $[2] !== firstDocument.documentId || $[3] !== t1 ? (t2 = {
    id: firstDocument.documentId,
    type: t1,
    permission: "publish"
  }, $[2] = firstDocument.documentId, $[3] = t1, $[4] = t2) : t2 = $[4];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t2), {
    deleteSchedule,
    publishSchedule
  } = useScheduleOperation(), insufficientPermissions = !isPermissionsLoading && !permissions?.granted;
  let t3;
  $[5] !== onEdit ? (t3 = () => {
    onEdit?.();
  }, $[5] = onEdit, $[6] = t3) : t3 = $[6];
  const handleEdit = t3;
  let t4;
  $[7] !== deleteSchedule || $[8] !== onDelete || $[9] !== schedule ? (t4 = () => {
    deleteSchedule({
      schedule
    }).then(() => onDelete?.());
  }, $[7] = deleteSchedule, $[8] = onDelete, $[9] = schedule, $[10] = t4) : t4 = $[10];
  const handleDelete = t4;
  let t5;
  $[11] !== publishSchedule || $[12] !== schedule ? (t5 = () => {
    publishSchedule({
      schedule
    });
  }, $[11] = publishSchedule, $[12] = schedule, $[13] = t5) : t5 = $[13];
  const handleExecute = t5;
  if (!currentUser)
    return null;
  let t6;
  $[14] !== actions?.edit || $[15] !== currentUser || $[16] !== handleEdit || $[17] !== insufficientPermissions || $[18] !== mode ? (t6 = actions?.edit && /* @__PURE__ */ jsx(MenuItemWithPermissionsTooltip, { currentUser, hasPermission: !insufficientPermissions, icon: CalendarIcon, onClick: handleEdit, permissionsOperationLabel: "edit-schedules", title: "Edit schedule", disabled: mode === "upsell" }), $[14] = actions?.edit, $[15] = currentUser, $[16] = handleEdit, $[17] = insufficientPermissions, $[18] = mode, $[19] = t6) : t6 = $[19];
  let t7;
  $[20] !== actions?.execute || $[21] !== currentUser || $[22] !== handleExecute || $[23] !== insufficientPermissions || $[24] !== mode ? (t7 = actions?.execute && /* @__PURE__ */ jsx(MenuItemWithPermissionsTooltip, { currentUser, hasPermission: !insufficientPermissions, icon: PublishIcon, onClick: handleExecute, permissionsOperationLabel: "execute-schedules", title: "Publish now", disabled: mode === "upsell" }), $[20] = actions?.execute, $[21] = currentUser, $[22] = handleExecute, $[23] = insufficientPermissions, $[24] = mode, $[25] = t7) : t7 = $[25];
  let t8;
  $[26] !== actions?.delete || $[27] !== currentUser || $[28] !== handleDelete || $[29] !== insufficientPermissions || $[30] !== mode ? (t8 = actions?.delete && /* @__PURE__ */ jsx(MenuItemWithPermissionsTooltip, { currentUser, hasPermission: !insufficientPermissions, icon: TrashIcon, onClick: handleDelete, permissionsOperationLabel: "delete-schedules", title: "Delete schedule", tone: "critical", disabled: mode === "upsell" }), $[26] = actions?.delete, $[27] = currentUser, $[28] = handleDelete, $[29] = insufficientPermissions, $[30] = mode, $[31] = t8) : t8 = $[31];
  let t9;
  $[32] !== actions?.clear || $[33] !== currentUser || $[34] !== handleDelete || $[35] !== insufficientPermissions || $[36] !== mode ? (t9 = actions?.clear && /* @__PURE__ */ jsx(MenuItemWithPermissionsTooltip, { currentUser, hasPermission: !insufficientPermissions, icon: CheckmarkCircleIcon, onClick: handleDelete, permissionsOperationLabel: "delete-schedules", title: "Clear completed schedule", disabled: mode === "upsell" }), $[32] = actions?.clear, $[33] = currentUser, $[34] = handleDelete, $[35] = insufficientPermissions, $[36] = mode, $[37] = t9) : t9 = $[37];
  let t10;
  return $[38] !== t6 || $[39] !== t7 || $[40] !== t8 || $[41] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t6,
    t7,
    t8,
    t9
  ] }), $[38] = t6, $[39] = t7, $[40] = t8, $[41] = t9, $[42] = t10) : t10 = $[42], t10;
}, ScheduleContextMenu = (props2) => {
  const $ = c(10), {
    actions,
    onDelete,
    onEdit,
    schedule,
    schemaType
  } = props2;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== actions || $[2] !== onDelete || $[3] !== onEdit || $[4] !== schedule || $[5] !== schemaType ? (t1 = /* @__PURE__ */ jsx(Menu, { children: /* @__PURE__ */ jsx(ContextMenuItems, { actions, onDelete, onEdit, schedule, schemaType }) }), $[1] = actions, $[2] = onDelete, $[3] = onEdit, $[4] = schedule, $[5] = schemaType, $[6] = t1) : t1 = $[6];
  let t2;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    portal: !0,
    tone: "default"
  }, $[7] = t2) : t2 = $[7];
  let t3;
  return $[8] !== t1 ? (t3 = /* @__PURE__ */ jsx(MenuButton, { button: t0, id: "contextMenu", menu: t1, placement: "left", popover: t2 }), $[8] = t1, $[9] = t3) : t3 = $[9], t3;
}, EMPTY_VALIDATION_STATUS = {
  validation: [],
  isValidating: !1
};
function getValidationState(validationMarkers = EMPTY_VALIDATION_STATUS.validation) {
  const hasError = validationMarkers.filter(isValidationErrorMarker).length > 0, hasWarning = validationMarkers.filter(isValidationWarningMarker).length > 0;
  let validationTone = "default";
  return hasWarning && (validationTone = "default"), hasError && (validationTone = "critical"), {
    markers: validationMarkers,
    validationTone,
    hasError,
    hasWarning
  };
}
function useValidationState(markers) {
  const $ = c(2);
  let t0;
  return $[0] !== markers ? (t0 = getValidationState(markers), $[0] = markers, $[1] = t0) : t0 = $[1], t0;
}
const VALIDATION_DELAY_MS = 1500;
function ValidateScheduleDoc(t0) {
  const $ = c(6), {
    schedule,
    updateValidation
  } = t0, schemaType = useScheduleSchemaType(schedule);
  let t1;
  $[0] !== schedule ? (t1 = getScheduledDocumentId(schedule), $[0] = schedule, $[1] = t1) : t1 = $[1];
  const id2 = t1;
  if (!id2 || !schemaType?.name)
    return null;
  let t2;
  return $[2] !== id2 || $[3] !== schemaType.name || $[4] !== updateValidation ? (t2 = /* @__PURE__ */ jsx(DelayedValidationRunner, { id: id2, schemaName: schemaType.name, updateValidation }), $[2] = id2, $[3] = schemaType.name, $[4] = updateValidation, $[5] = t2) : t2 = $[5], t2;
}
function DelayedValidationRunner(t0) {
  const $ = c(6), {
    id: id2,
    schemaName,
    updateValidation
  } = t0, [ready, setReady] = useState(!1);
  let t1, t2;
  if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    const timeout2 = setTimeout(() => {
      setReady(!0);
    }, VALIDATION_DELAY_MS);
    return () => {
      clearTimeout(timeout2);
    };
  }, t2 = [], $[0] = t1, $[1] = t2) : (t1 = $[0], t2 = $[1]), useEffect(t1, t2), !ready)
    return null;
  let t3;
  return $[2] !== id2 || $[3] !== schemaName || $[4] !== updateValidation ? (t3 = /* @__PURE__ */ jsx(ValidationRunner, { id: id2, schemaName, updateValidation }), $[2] = id2, $[3] = schemaName, $[4] = updateValidation, $[5] = t3) : t3 = $[5], t3;
}
function ValidationRunner(t0) {
  const $ = c(6), {
    id: id2,
    schemaName,
    updateValidation
  } = t0;
  let t1;
  $[0] !== id2 ? (t1 = getDraftId(id2), $[0] = id2, $[1] = t1) : t1 = $[1];
  const validationStatus = useValidationStatus(t1, schemaName, !0);
  let t2, t3;
  return $[2] !== updateValidation || $[3] !== validationStatus ? (t2 = () => {
    validationStatus.isValidating || updateValidation(validationStatus);
  }, t3 = [updateValidation, validationStatus], $[2] = updateValidation, $[3] = validationStatus, $[4] = t2, $[5] = t3) : (t2 = $[4], t3 = $[5]), useEffect(t2, t3), null;
}
function usePublishedId(id2) {
  const $ = c(2);
  let t0;
  return $[0] !== id2 ? (t0 = id2 ? id2.replaceAll("drafts.", "") : void 0, $[0] = id2, $[1] = t0) : t0 = $[1], t0;
}
const StyledText$1 = styled(Text$1).withConfig({
  displayName: "StyledText",
  componentId: "sc-q947a2-0"
})`white-space:initial;`, MENU_ITEM_TONES = {
  error: "critical",
  warning: "caution",
  info: "primary"
};
function ValidationListItem(props2) {
  const $ = c(30), {
    marker,
    onClick: onClick2,
    path,
    truncate: truncate2
  } = props2;
  let t0;
  $[0] !== marker.path || $[1] !== onClick2 ? (t0 = () => {
    onClick2 && onClick2(marker.path);
  }, $[0] = marker.path, $[1] = onClick2, $[2] = t0) : t0 = $[2];
  const handleClick = t0, menuItemTone = MENU_ITEM_TONES[marker?.level] || void 0, message = marker.message ?? marker.item?.message;
  let t1;
  $[3] !== marker.level ? (t1 = marker.level === "error" && /* @__PURE__ */ jsx(ErrorOutlineIcon, {}), $[3] = marker.level, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== marker.level ? (t2 = marker.level === "warning" && /* @__PURE__ */ jsx(WarningOutlineIcon, {}), $[5] = marker.level, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] !== marker.level ? (t3 = marker.level === "info" && /* @__PURE__ */ jsx(InfoOutlineIcon, {}), $[7] = marker.level, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== t1 || $[10] !== t2 || $[11] !== t3 ? (t4 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t1,
    t2,
    t3
  ] }) }), $[9] = t1, $[10] = t2, $[11] = t3, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== path ? (t5 = path && /* @__PURE__ */ jsx(StyledText$1, { size: 1, weight: "semibold", children: path }), $[13] = path, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] !== message || $[16] !== truncate2 ? (t6 = message && /* @__PURE__ */ jsx(StyledText$1, { muted: !0, size: 1, textOverflow: truncate2 ? "ellipsis" : void 0, children: message }), $[15] = message, $[16] = truncate2, $[17] = t6) : t6 = $[17];
  let t7;
  $[18] !== t5 || $[19] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 2, flex: 1, paddingLeft: 3, children: [
    t5,
    t6
  ] }), $[18] = t5, $[19] = t6, $[20] = t7) : t7 = $[20];
  let t8;
  $[21] !== t4 || $[22] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { children: [
    t4,
    t7
  ] }), $[21] = t4, $[22] = t7, $[23] = t8) : t8 = $[23];
  const children = t8;
  let t9;
  $[24] !== children ? (t9 = /* @__PURE__ */ jsx(Box, { padding: 2, children }), $[24] = children, $[25] = t9) : t9 = $[25];
  let t10;
  return $[26] !== handleClick || $[27] !== menuItemTone || $[28] !== t9 ? (t10 = /* @__PURE__ */ jsx(MenuItem$1, { padding: 1, onClick: handleClick, radius: 2, tone: menuItemTone, children: t9 }), $[26] = handleClick, $[27] = menuItemTone, $[28] = t9, $[29] = t10) : t10 = $[29], t10;
}
function ValidationList(props2) {
  const $ = c(27), {
    documentType,
    kind,
    validation: validation2,
    onFocus,
    onClose,
    truncate: truncate2
  } = props2;
  let T0, t0, t1, t2, t3, t4, t5, t6;
  if ($[0] !== documentType || $[1] !== kind || $[2] !== onClose || $[3] !== onFocus || $[4] !== truncate2 || $[5] !== validation2) {
    t6 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    bb0: {
      const errors = validation2.filter(isValidationErrorMarker), warnings = validation2.filter(isValidationWarningMarker), info = validation2.filter(isValidationInfoMarker);
      let t72;
      $[14] !== onClose || $[15] !== onFocus ? (t72 = (t82) => {
        onFocus && onFocus(t82 === void 0 ? [] : t82), onClose && onClose();
      }, $[14] = onClose, $[15] = onFocus, $[16] = t72) : t72 = $[16];
      const handleClick = t72;
      let t8;
      $[17] !== documentType ? (t8 = (path_0) => {
        const fields = documentType && documentType.fields, field = fields && fields.find((curr) => curr.name === path_0[0]);
        return field && field.type.title || "";
      }, $[17] = documentType, $[18] = t8) : t8 = $[18];
      const resolvePathTitle = t8, hasErrors = errors.length > 0, hasWarnings = warnings.length > 0, hasInfo = info.length > 0;
      if (!hasErrors && !hasWarnings && !hasInfo) {
        t6 = null;
        break bb0;
      }
      T0 = Container$3, t0 = 0, t1 = kind, t2 = "validation-list", t3 = hasErrors && errors.map((_error, i) => /* @__PURE__ */ jsx(ValidationListItem, { truncate: truncate2, path: resolvePathTitle(_error.path), marker: _error, onClick: handleClick }, i)), t4 = hasWarnings && warnings.map((_warning, i_0) => /* @__PURE__ */ jsx(ValidationListItem, { truncate: truncate2, path: resolvePathTitle(_warning.path), marker: _warning, onClick: handleClick }, i_0)), t5 = hasInfo && info.map((_info, i_1) => /* @__PURE__ */ jsx(ValidationListItem, { truncate: truncate2, path: resolvePathTitle(_info.path), marker: _info, onClick: handleClick }, i_1));
    }
    $[0] = documentType, $[1] = kind, $[2] = onClose, $[3] = onFocus, $[4] = truncate2, $[5] = validation2, $[6] = T0, $[7] = t0, $[8] = t1, $[9] = t2, $[10] = t3, $[11] = t4, $[12] = t5, $[13] = t6;
  } else
    T0 = $[6], t0 = $[7], t1 = $[8], t2 = $[9], t3 = $[10], t4 = $[11], t5 = $[12], t6 = $[13];
  if (t6 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return t6;
  let t7;
  return $[19] !== T0 || $[20] !== t0 || $[21] !== t1 || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 ? (t7 = /* @__PURE__ */ jsxs(T0, { width: t0, "data-kind": t1, "data-testid": t2, children: [
    t3,
    t4,
    t5
  ] }), $[19] = T0, $[20] = t0, $[21] = t1, $[22] = t2, $[23] = t3, $[24] = t4, $[25] = t5, $[26] = t7) : t7 = $[26], t7;
}
const POPOVER_PROPS$2 = {
  portal: !0,
  constrainSize: !0,
  preventOverflow: !0,
  tone: "default",
  width: 0,
  placement: "bottom-end"
};
function ValidationInfo(props2) {
  const $ = c(21), {
    type,
    markers,
    menuHeader,
    documentId
  } = props2, router = useRouter(), {
    hasError,
    hasWarning
  } = useValidationState(markers), visibility = hasError || hasWarning ? "visible" : "hidden", id2 = useId() || "", publishId = usePublishedId(documentId);
  let t0;
  $[0] !== publishId || $[1] !== router ? (t0 = (path) => {
    publishId && router.navigateIntent("edit", {
      id: publishId,
      path: encodeURIComponent(PathUtils.toString(path))
    });
  }, $[0] = publishId, $[1] = router, $[2] = t0) : t0 = $[2];
  const onFocus = t0, t1 = id2 || "";
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    content: "Show validation issues"
  }, $[3] = t2) : t2 = $[3];
  const t3 = hasError ? ErrorOutlineIcon : WarningOutlineIcon;
  let t4;
  $[4] !== visibility ? (t4 = {
    visibility
  }, $[4] = visibility, $[5] = t4) : t4 = $[5];
  const t5 = hasError ? "critical" : "default";
  let t6;
  $[6] !== t3 || $[7] !== t4 || $[8] !== t5 ? (t6 = /* @__PURE__ */ jsx(Button, { tooltipProps: t2, mode: "bleed", "data-testid": "schedule-validation-list-button", icon: t3, style: t4, tone: t5 }), $[6] = t3, $[7] = t4, $[8] = t5, $[9] = t6) : t6 = $[9];
  const t7 = menuHeader ?? null, t8 = type;
  let t9;
  $[10] !== markers || $[11] !== onFocus || $[12] !== t8 ? (t9 = /* @__PURE__ */ jsx(ValidationList, { documentType: t8, validation: markers, onFocus }), $[10] = markers, $[11] = onFocus, $[12] = t8, $[13] = t9) : t9 = $[13];
  let t10;
  $[14] !== t7 || $[15] !== t9 ? (t10 = /* @__PURE__ */ jsx(Menu, { padding: 1, children: /* @__PURE__ */ jsx(Container$3, { width: 0, children: /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    t7,
    t9
  ] }) }) }), $[14] = t7, $[15] = t9, $[16] = t10) : t10 = $[16];
  let t11;
  return $[17] !== t1 || $[18] !== t10 || $[19] !== t6 ? (t11 = /* @__PURE__ */ jsx(MenuButton, { id: t1, button: t6, menu: t10, popover: POPOVER_PROPS$2 }), $[17] = t1, $[18] = t10, $[19] = t6, $[20] = t11) : t11 = $[20], t11;
}
const DateWithTooltip = (props2) => {
  const $ = c(22), {
    date,
    useElementQueries
  } = props2;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    type: "scheduledPublishing"
  }, $[0] = t0) : t0 = $[0];
  const {
    formatDateTz
  } = useTimeZone(t0);
  let t1;
  $[1] !== date ? (t1 = formatDistance(date, /* @__PURE__ */ new Date(), {
    addSuffix: !0
  }), $[1] = date, $[2] = t1) : t1 = $[2];
  const distance = t1;
  let t2;
  $[3] !== date || $[4] !== formatDateTz ? (t2 = formatDateTz({
    date,
    format: DATE_FORMAT.LARGE
  }), $[3] = date, $[4] = formatDateTz, $[5] = t2) : t2 = $[5];
  const dateTimeLarge = t2;
  let t3;
  $[6] !== date || $[7] !== formatDateTz ? (t3 = formatDateTz({
    date,
    format: DATE_FORMAT.MEDIUM
  }), $[6] = date, $[7] = formatDateTz, $[8] = t3) : t3 = $[8];
  const dateTimeMedium = t3;
  let t4;
  $[9] !== date || $[10] !== formatDateTz ? (t4 = formatDateTz({
    date,
    format: DATE_FORMAT.SMALL
  }), $[9] = date, $[10] = formatDateTz, $[11] = t4) : t4 = $[11];
  const dateTimeSmall = t4;
  let t5;
  $[12] !== dateTimeLarge || $[13] !== dateTimeMedium || $[14] !== dateTimeSmall || $[15] !== useElementQueries ? (t5 = useElementQueries ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx("span", { className: "date-small", children: dateTimeSmall }),
    /* @__PURE__ */ jsx("span", { className: "date-medium", children: dateTimeMedium }),
    /* @__PURE__ */ jsx("span", { className: "date-large", children: dateTimeLarge })
  ] }) : dateTimeLarge, $[12] = dateTimeLarge, $[13] = dateTimeMedium, $[14] = dateTimeSmall, $[15] = useElementQueries, $[16] = t5) : t5 = $[16];
  let t6;
  $[17] !== t5 ? (t6 = /* @__PURE__ */ jsx("span", { children: t5 }), $[17] = t5, $[18] = t6) : t6 = $[18];
  let t7;
  return $[19] !== distance || $[20] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(Tooltip, { content: distance, portal: !0, children: t6 }) }), $[19] = distance, $[20] = t6, $[21] = t7) : t7 = $[21], t7;
}, POPOVER_PROPS$1 = {
  portal: !0,
  constrainSize: !0,
  preventOverflow: !0,
  tone: "default",
  width: 0
}, StateReasonFailedInfo = (props2) => {
  const $ = c(6), {
    stateReason
  } = props2;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Button, { tooltipProps: {
    content: "Schedule failed"
  }, mode: "bleed", "data-testid": "schedule-validation-list-button", icon: ErrorOutlineIcon, tone: "critical" }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: SCHEDULE_FAILED_TEXT }), $[1] = t1) : t1 = $[1];
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, style: {
    color: red[700].hex
  }, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[2] = t2) : t2 = $[2];
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    color: red[700].hex
  }, $[3] = t3) : t3 = $[3];
  let t4;
  return $[4] !== stateReason ? (t4 = /* @__PURE__ */ jsx(MenuButton, { id: "stateReason", button: t0, menu: /* @__PURE__ */ jsx(Menu, { padding: 1, children: /* @__PURE__ */ jsxs(Container$3, { padding: 2, width: 0, children: [
    t1,
    /* @__PURE__ */ jsxs(Flex, { gap: 3, marginTop: 4, padding: 1, children: [
      t2,
      /* @__PURE__ */ jsx(Text$1, { size: 1, style: t3, weight: "medium", children: stateReason })
    ] })
  ] }) }), popover: POPOVER_PROPS$1 }), $[4] = stateReason, $[5] = t4) : t4 = $[5], t4;
}, User = (props2) => {
  const $ = c(2), {
    id: id2
  } = props2;
  let t0;
  return $[0] !== id2 ? (t0 = /* @__PURE__ */ jsx(UserAvatar, { user: id2, withTooltip: !0 }), $[0] = id2, $[1] = t0) : t0 = $[1], t0;
}, StatusDotPlaceholder = styled(Box).withConfig({
  displayName: "StatusDotPlaceholder",
  componentId: "sc-cgui20-0"
})`width:9px;`, PreviewWrapper = (props2) => {
  const $ = c(163), {
    children,
    contextMenu,
    linkComponent,
    onClick: onClick2,
    previewState,
    publishedDocumentId,
    schedule,
    schemaType,
    useElementQueries
  } = props2, {
    mode
  } = useScheduledPublishingEnabled(), [validationStatus, setValidationStatus] = useState(EMPTY_VALIDATION_STATUS), {
    validation: validation2
  } = validationStatus, {
    hasError,
    validationTone
  } = useValidationState(validation2);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    type: "scheduledPublishing"
  }, $[0] = t0) : t0 = $[0];
  const {
    formatDateTz
  } = useTimeZone(t0);
  let T0, T1, T2, T3, T4, T5, T6, scheduleDate, t1, t10, t11, t12, t13, t14, t15, t16, t17, t18, t19, t2, t20, t21, t22, t23, t24, t25, t26, t27, t28, t29, t3, t30, t31, t4, t5, t6, t7, t8, t9;
  if ($[1] !== children || $[2] !== formatDateTz || $[3] !== linkComponent || $[4] !== mode || $[5] !== onClick2 || $[6] !== previewState?.draft || $[7] !== previewState?.published || $[8] !== schedule || $[9] !== validationTone) {
    const executeDate = getLastExecuteDate(schedule);
    scheduleDate = executeDate ? new Date(executeDate) : null, T6 = Card, t27 = 1, t28 = 2, t29 = 1, t30 = validationTone, $[49] !== mode || $[50] !== schedule.state ? (t31 = mode === "upsell" && schedule.state === "scheduled" ? {
      opacity: 0.7
    } : void 0, $[49] = mode, $[50] = schedule.state, $[51] = t31) : t31 = $[51], T5 = Flex, t24 = "center", t25 = 1, t26 = "space-between", T4 = Tooltip, $[52] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t20 = {
      open: 400
    }, $[52] = t20) : t20 = $[52], t21 = "bottom-end";
    const t322 = previewState?.draft, t332 = previewState?.published;
    $[53] !== t322 || $[54] !== t332 ? (t22 = /* @__PURE__ */ jsx(DocumentStatus, { draft: t322, published: t332 }), $[53] = t322, $[54] = t332, $[55] = t22) : t22 = $[55], t23 = !previewState?.draft && !previewState?.published, T3 = Card, t11 = !0, t12 = linkComponent || void 0, t13 = onClick2 || linkComponent ? "a" : void 0, t14 = 1, t15 = onClick2, t16 = 1, t17 = 2, t18 = 0, t19 = validationTone, T2 = Flex, t5 = "center", t6 = 3, t7 = "flex-start", $[56] !== children ? (t8 = children ? 0 : [1, 2], $[56] = children, $[57] = t8) : t8 = $[57], $[58] !== children ? (t9 = children && /* @__PURE__ */ jsx(Box, { style: {
      flexBasis: "auto",
      flexGrow: 1
    }, children }), $[58] = children, $[59] = t9) : t9 = $[59], $[60] !== schedule.action ? (t10 = schedule.action === "unpublish" && /* @__PURE__ */ jsx(Flex, { style: {
      flexShrink: 0
    }, children: /* @__PURE__ */ jsx(Badge, { fontSize: 0, mode: "outline", tone: SCHEDULE_ACTION_DICTIONARY[schedule.action].badgeTone, children: schedule.action }) }), $[60] = schedule.action, $[61] = t10) : t10 = $[61], T1 = Box, $[62] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = ["block", "none"], t4 = {
      flexShrink: 0,
      width: "90px"
    }, $[62] = t3, $[63] = t4) : (t3 = $[62], t4 = $[63]), T0 = Stack, t1 = 2, t2 = scheduleDate ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(Text$1, { size: 1, children: formatDateTz({
        date: scheduleDate,
        format: "dd/MM/yyyy"
      }) }),
      /* @__PURE__ */ jsx(Text$1, { size: 1, children: formatDateTz({
        date: scheduleDate,
        format: "p"
      }) })
    ] }) : /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx("em", { children: "No date specified" }) }), $[1] = children, $[2] = formatDateTz, $[3] = linkComponent, $[4] = mode, $[5] = onClick2, $[6] = previewState?.draft, $[7] = previewState?.published, $[8] = schedule, $[9] = validationTone, $[10] = T0, $[11] = T1, $[12] = T2, $[13] = T3, $[14] = T4, $[15] = T5, $[16] = T6, $[17] = scheduleDate, $[18] = t1, $[19] = t10, $[20] = t11, $[21] = t12, $[22] = t13, $[23] = t14, $[24] = t15, $[25] = t16, $[26] = t17, $[27] = t18, $[28] = t19, $[29] = t2, $[30] = t20, $[31] = t21, $[32] = t22, $[33] = t23, $[34] = t24, $[35] = t25, $[36] = t26, $[37] = t27, $[38] = t28, $[39] = t29, $[40] = t3, $[41] = t30, $[42] = t31, $[43] = t4, $[44] = t5, $[45] = t6, $[46] = t7, $[47] = t8, $[48] = t9;
  } else
    T0 = $[10], T1 = $[11], T2 = $[12], T3 = $[13], T4 = $[14], T5 = $[15], T6 = $[16], scheduleDate = $[17], t1 = $[18], t10 = $[19], t11 = $[20], t12 = $[21], t13 = $[22], t14 = $[23], t15 = $[24], t16 = $[25], t17 = $[26], t18 = $[27], t19 = $[28], t2 = $[29], t20 = $[30], t21 = $[31], t22 = $[32], t23 = $[33], t24 = $[34], t25 = $[35], t26 = $[36], t27 = $[37], t28 = $[38], t29 = $[39], t3 = $[40], t30 = $[41], t31 = $[42], t4 = $[43], t5 = $[44], t6 = $[45], t7 = $[46], t8 = $[47], t9 = $[48];
  let t32;
  $[64] !== T0 || $[65] !== t1 || $[66] !== t2 ? (t32 = /* @__PURE__ */ jsx(T0, { space: t1, children: t2 }), $[64] = T0, $[65] = t1, $[66] = t2, $[67] = t32) : t32 = $[67];
  let t33;
  $[68] !== T1 || $[69] !== t3 || $[70] !== t32 || $[71] !== t4 ? (t33 = /* @__PURE__ */ jsx(T1, { display: t3, style: t4, children: t32 }), $[68] = T1, $[69] = t3, $[70] = t32, $[71] = t4, $[72] = t33) : t33 = $[72];
  let t34;
  $[73] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t34 = ["none", "block"], $[73] = t34) : t34 = $[73];
  const t35 = children ? "35%" : "auto";
  let t36;
  $[74] !== t35 ? (t36 = {
    flexShrink: 0,
    maxWidth: "250px",
    width: t35
  }, $[74] = t35, $[75] = t36) : t36 = $[75];
  let t37;
  $[76] !== scheduleDate || $[77] !== useElementQueries ? (t37 = scheduleDate ? /* @__PURE__ */ jsx(DateWithTooltip, { date: scheduleDate, useElementQueries }) : /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx("em", { children: "No date specified" }) }), $[76] = scheduleDate, $[77] = useElementQueries, $[78] = t37) : t37 = $[78];
  let t38;
  $[79] !== t36 || $[80] !== t37 ? (t38 = /* @__PURE__ */ jsx(Box, { display: t34, style: t36, children: t37 }), $[79] = t36, $[80] = t37, $[81] = t38) : t38 = $[81];
  let t39;
  $[82] !== children ? (t39 = !children && /* @__PURE__ */ jsx(Box, { style: {
    visibility: "hidden"
  }, children: /* @__PURE__ */ jsx(SanityDefaultPreview, { isPlaceholder: !0 }) }), $[82] = children, $[83] = t39) : t39 = $[83];
  let t40;
  $[84] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t40 = {
    flexShrink: 0,
    marginLeft: "auto"
  }, $[84] = t40) : t40 = $[84];
  let t41;
  $[85] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t41 = ["none", "none", "block"], $[85] = t41) : t41 = $[85];
  let t42;
  $[86] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = {
    flexShrink: 0
  }, $[86] = t42) : t42 = $[86];
  const t43 = schedule?.author;
  let t44;
  $[87] !== t43 ? (t44 = /* @__PURE__ */ jsx(Box, { display: t41, marginX: 3, style: t42, children: /* @__PURE__ */ jsx(User, { id: t43 }) }), $[87] = t43, $[88] = t44) : t44 = $[88];
  let t45, t46, t47;
  $[89] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t45 = ["none", "block"], t46 = [2, 2, 3], t47 = {
    flexShrink: 0
  }, $[89] = t45, $[90] = t46, $[91] = t47) : (t45 = $[89], t46 = $[90], t47 = $[91]);
  let t48;
  $[92] !== publishedDocumentId ? (t48 = /* @__PURE__ */ jsx(Box, { display: t45, marginX: t46, style: t47, children: publishedDocumentId ? /* @__PURE__ */ jsx(DocumentVersionsStatus, { publishedDocumentId }) : /* @__PURE__ */ jsx(StatusDotPlaceholder, {}) }), $[92] = publishedDocumentId, $[93] = t48) : t48 = $[93];
  let t49;
  $[94] !== t44 || $[95] !== t48 ? (t49 = /* @__PURE__ */ jsxs(Flex, { align: "center", style: t40, children: [
    t44,
    t48
  ] }), $[94] = t44, $[95] = t48, $[96] = t49) : t49 = $[96];
  let t50;
  $[97] !== T2 || $[98] !== t10 || $[99] !== t33 || $[100] !== t38 || $[101] !== t39 || $[102] !== t49 || $[103] !== t5 || $[104] !== t6 || $[105] !== t7 || $[106] !== t8 || $[107] !== t9 ? (t50 = /* @__PURE__ */ jsxs(T2, { align: t5, gap: t6, justify: t7, paddingLeft: t8, children: [
    t9,
    t10,
    t33,
    t38,
    t39,
    t49
  ] }), $[97] = T2, $[98] = t10, $[99] = t33, $[100] = t38, $[101] = t39, $[102] = t49, $[103] = t5, $[104] = t6, $[105] = t7, $[106] = t8, $[107] = t9, $[108] = t50) : t50 = $[108];
  let t51;
  $[109] !== T3 || $[110] !== t11 || $[111] !== t12 || $[112] !== t13 || $[113] !== t14 || $[114] !== t15 || $[115] !== t16 || $[116] !== t17 || $[117] !== t18 || $[118] !== t19 || $[119] !== t50 ? (t51 = /* @__PURE__ */ jsx(T3, { __unstable_focusRing: t11, as: t12, "data-as": t13, flex: t14, onClick: t15, padding: t16, radius: t17, tabIndex: t18, tone: t19, children: t50 }), $[109] = T3, $[110] = t11, $[111] = t12, $[112] = t13, $[113] = t14, $[114] = t15, $[115] = t16, $[116] = t17, $[117] = t18, $[118] = t19, $[119] = t50, $[120] = t51) : t51 = $[120];
  let t52;
  $[121] !== T4 || $[122] !== t20 || $[123] !== t21 || $[124] !== t22 || $[125] !== t23 || $[126] !== t51 ? (t52 = /* @__PURE__ */ jsx(T4, { delay: t20, placement: t21, content: t22, disabled: t23, children: t51 }), $[121] = T4, $[122] = t20, $[123] = t21, $[124] = t22, $[125] = t23, $[126] = t51, $[127] = t52) : t52 = $[127];
  let t53;
  $[128] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t53 = {
    width: "38px"
  }, $[128] = t53) : t53 = $[128];
  let t54;
  $[129] !== hasError || $[130] !== publishedDocumentId || $[131] !== schedule || $[132] !== schemaType || $[133] !== validation2 ? (t54 = schedule.state === "scheduled" && /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsx(ValidateScheduleDoc, { schedule, updateValidation: setValidationStatus }),
    /* @__PURE__ */ jsx(ValidationInfo, { markers: validation2, type: schemaType, documentId: publishedDocumentId, menuHeader: /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: hasError ? DOCUMENT_HAS_ERRORS_TEXT : DOCUMENT_HAS_WARNINGS_TEXT }) }) })
  ] }), $[129] = hasError, $[130] = publishedDocumentId, $[131] = schedule, $[132] = schemaType, $[133] = validation2, $[134] = t54) : t54 = $[134];
  let t55;
  $[135] !== schedule.state || $[136] !== schedule.stateReason ? (t55 = schedule.state === "cancelled" && /* @__PURE__ */ jsx(StateReasonFailedInfo, { stateReason: schedule.stateReason }), $[135] = schedule.state, $[136] = schedule.stateReason, $[137] = t55) : t55 = $[137];
  let t56;
  $[138] !== t54 || $[139] !== t55 ? (t56 = /* @__PURE__ */ jsxs(Flex, { justify: "center", style: t53, children: [
    t54,
    t55
  ] }), $[138] = t54, $[139] = t55, $[140] = t56) : t56 = $[140];
  let t57;
  $[141] !== schedule.state || $[142] !== schedule.stateReason ? (t57 = schedule.state === "cancelled" && /* @__PURE__ */ jsx(StateReasonFailedInfo, { stateReason: schedule.stateReason }), $[141] = schedule.state, $[142] = schedule.stateReason, $[143] = t57) : t57 = $[143];
  let t58;
  $[144] !== contextMenu ? (t58 = contextMenu && /* @__PURE__ */ jsx(Box, { style: {
    flexShrink: 0
  }, paddingRight: 2, children: contextMenu }), $[144] = contextMenu, $[145] = t58) : t58 = $[145];
  let t59;
  $[146] !== T5 || $[147] !== t24 || $[148] !== t25 || $[149] !== t26 || $[150] !== t52 || $[151] !== t56 || $[152] !== t57 || $[153] !== t58 ? (t59 = /* @__PURE__ */ jsxs(T5, { align: t24, gap: t25, justify: t26, children: [
    t52,
    t56,
    t57,
    t58
  ] }), $[146] = T5, $[147] = t24, $[148] = t25, $[149] = t26, $[150] = t52, $[151] = t56, $[152] = t57, $[153] = t58, $[154] = t59) : t59 = $[154];
  let t60;
  return $[155] !== T6 || $[156] !== t27 || $[157] !== t28 || $[158] !== t29 || $[159] !== t30 || $[160] !== t31 || $[161] !== t59 ? (t60 = /* @__PURE__ */ jsx(T6, { padding: t27, radius: t28, shadow: t29, tone: t30, style: t31, children: t59 }), $[155] = T6, $[156] = t27, $[157] = t28, $[158] = t29, $[159] = t30, $[160] = t31, $[161] = t59, $[162] = t60) : t60 = $[162], t60;
};
function DocumentVersionsStatus(t0) {
  const $ = c(3), {
    publishedDocumentId
  } = t0, versionsInfo = useDocumentVersionInfo(publishedDocumentId);
  let t1;
  return $[0] !== versionsInfo.draft || $[1] !== versionsInfo.published ? (t1 = /* @__PURE__ */ jsx(DocumentStatusIndicator, { draft: versionsInfo.draft, published: versionsInfo.published }), $[0] = versionsInfo.draft, $[1] = versionsInfo.published, $[2] = t1) : t1 = $[2], t1;
}
const DocumentPreview$1 = (props2) => {
  const $ = c(20), {
    schedule,
    schemaType
  } = props2, {
    DialogScheduleEdit: DialogScheduleEdit2,
    dialogProps,
    dialogScheduleEditShow
  } = useDialogScheduleEdit(schedule, SCHEDULED_PUBLISHING_TIME_ZONE_SCOPE), {
    onComplete
  } = useDocumentActionProps();
  let t0;
  $[0] !== schedule ? (t0 = getScheduledDocumentId(schedule), $[0] = schedule, $[1] = t0) : t0 = $[1];
  const publishedId = t0;
  let t1;
  $[2] !== DialogScheduleEdit2 || $[3] !== dialogProps ? (t1 = DialogScheduleEdit2 && /* @__PURE__ */ jsx(DialogScheduleEdit2, { ...dialogProps }), $[2] = DialogScheduleEdit2, $[3] = dialogProps, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    delete: !0,
    edit: !0
  }, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== dialogScheduleEditShow || $[7] !== onComplete || $[8] !== schedule || $[9] !== schemaType ? (t3 = /* @__PURE__ */ jsx(ScheduleContextMenu, { actions: t2, onDelete: onComplete, onEdit: dialogScheduleEditShow, schedule, schemaType }), $[6] = dialogScheduleEditShow, $[7] = onComplete, $[8] = schedule, $[9] = schemaType, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== dialogScheduleEditShow || $[12] !== publishedId || $[13] !== schedule || $[14] !== schemaType || $[15] !== t3 ? (t4 = /* @__PURE__ */ jsx(PreviewWrapper, { contextMenu: t3, onClick: dialogScheduleEditShow, publishedDocumentId: publishedId, schedule, schemaType }), $[11] = dialogScheduleEditShow, $[12] = publishedId, $[13] = schedule, $[14] = schemaType, $[15] = t3, $[16] = t4) : t4 = $[16];
  let t5;
  return $[17] !== t1 || $[18] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t1,
    t4
  ] }), $[17] = t1, $[18] = t4, $[19] = t5) : t5 = $[19], t5;
}, FallbackContextMenu = (props2) => {
  const $ = c(10), {
    onDelete,
    schedule
  } = props2, {
    deleteSchedule
  } = useScheduleOperation();
  let t0;
  $[0] !== deleteSchedule || $[1] !== onDelete || $[2] !== schedule ? (t0 = () => {
    deleteSchedule({
      schedule
    }).then(() => onDelete?.());
  }, $[0] = deleteSchedule, $[1] = onDelete, $[2] = schedule, $[3] = t0) : t0 = $[3];
  const handleDelete = t0;
  let t1;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== handleDelete ? (t2 = /* @__PURE__ */ jsx(Menu, { children: /* @__PURE__ */ jsx(MenuItem, { icon: TrashIcon, onClick: handleDelete, text: "Delete schedule", tone: "critical" }) }), $[5] = handleDelete, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    portal: !0,
    tone: "default"
  }, $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== t2 ? (t4 = /* @__PURE__ */ jsx(MenuButton, { button: t1, id: "contextMenu", menu: t2, placement: "left", popover: t3 }), $[8] = t2, $[9] = t4) : t4 = $[9], t4;
}, NoSchemaItem = (t0) => {
  const $ = c(6), {
    schedule
  } = t0;
  let t1;
  $[0] !== schedule ? (t1 = /* @__PURE__ */ jsx(FallbackContextMenu, { schedule }), $[0] = schedule, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(SanityDefaultPreview, { icon: UnknownIcon, layout: "default", subtitle: /* @__PURE__ */ jsx("em", { children: "It may have been deleted" }), title: /* @__PURE__ */ jsx("em", { style: {
    color: red[600].hex
  }, children: "Document not found" }) }), $[2] = t2) : t2 = $[2];
  let t3;
  return $[3] !== schedule || $[4] !== t1 ? (t3 = /* @__PURE__ */ jsx(PreviewWrapper, { contextMenu: t1, schedule, useElementQueries: !0, children: t2 }), $[3] = schedule, $[4] = t1, $[5] = t3) : t3 = $[5], t3;
}, ToolPreview = (props2) => {
  const $ = c(30), {
    previewState,
    schedule,
    schemaType
  } = props2, visibleDocument = previewState.draft || previewState.published, isCompleted = schedule.state === "succeeded", isScheduled = schedule.state === "scheduled", {
    DialogScheduleEdit: DialogScheduleEdit2,
    dialogProps,
    dialogScheduleEditShow
  } = useDialogScheduleEdit(schedule, SCHEDULED_PUBLISHING_TIME_ZONE_SCOPE), publishedId = usePublishedId(visibleDocument?._id);
  let Component2;
  $[0] !== schemaType || $[1] !== visibleDocument ? (Component2 = forwardRef((linkProps, ref) => /* @__PURE__ */ jsx(IntentLink, { ...linkProps, intent: "edit", params: {
    type: schemaType.name,
    id: visibleDocument && getPublishedId(visibleDocument?._id)
  }, ref })), Component2.displayName = "ForwardRef(LinkComponent)", $[0] = schemaType, $[1] = visibleDocument, $[2] = Component2) : Component2 = $[2];
  const LinkComponent = Component2;
  let t0;
  $[3] !== DialogScheduleEdit2 || $[4] !== dialogProps ? (t0 = DialogScheduleEdit2 && /* @__PURE__ */ jsx(DialogScheduleEdit2, { ...dialogProps }), $[3] = DialogScheduleEdit2, $[4] = dialogProps, $[5] = t0) : t0 = $[5];
  const t1 = !isCompleted;
  let t2;
  $[6] !== isCompleted || $[7] !== isScheduled || $[8] !== t1 ? (t2 = {
    clear: isCompleted,
    delete: t1,
    edit: isScheduled,
    execute: isScheduled
  }, $[6] = isCompleted, $[7] = isScheduled, $[8] = t1, $[9] = t2) : t2 = $[9];
  let t3;
  $[10] !== dialogScheduleEditShow || $[11] !== schedule || $[12] !== schemaType || $[13] !== t2 ? (t3 = /* @__PURE__ */ jsx(ScheduleContextMenu, { actions: t2, onEdit: dialogScheduleEditShow, schedule, schemaType }), $[10] = dialogScheduleEditShow, $[11] = schedule, $[12] = schemaType, $[13] = t2, $[14] = t3) : t3 = $[14];
  let t4;
  $[15] !== previewState.isLoading || $[16] !== schemaType || $[17] !== visibleDocument ? (t4 = previewState.isLoading ? /* @__PURE__ */ jsx(SanityDefaultPreview, { icon: schemaType?.icon, isPlaceholder: previewState.isLoading, layout: "default" }) : /* @__PURE__ */ jsx(Preview$1, { layout: "default", schemaType, value: visibleDocument }), $[15] = previewState.isLoading, $[16] = schemaType, $[17] = visibleDocument, $[18] = t4) : t4 = $[18];
  let t5;
  $[19] !== LinkComponent || $[20] !== previewState || $[21] !== publishedId || $[22] !== schedule || $[23] !== schemaType || $[24] !== t3 || $[25] !== t4 ? (t5 = /* @__PURE__ */ jsx(PreviewWrapper, { contextMenu: t3, linkComponent: LinkComponent, previewState, publishedDocumentId: publishedId, schedule, schemaType, useElementQueries: !0, children: t4 }), $[19] = LinkComponent, $[20] = previewState, $[21] = publishedId, $[22] = schedule, $[23] = schemaType, $[24] = t3, $[25] = t4, $[26] = t5) : t5 = $[26];
  let t6;
  return $[27] !== t0 || $[28] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t0,
    t5
  ] }), $[27] = t0, $[28] = t5, $[29] = t6) : t6 = $[29], t6;
}, ScheduleItem = (props2) => {
  const $ = c(13), {
    schedule,
    type
  } = props2;
  let t0;
  $[0] !== schedule ? (t0 = getScheduledDocument(schedule), $[0] = schedule, $[1] = t0) : t0 = $[1];
  const firstDocument = t0, schemaType = useScheduleSchemaType(schedule), previewState = usePreviewState(firstDocument?.documentId, schemaType), invalidDocument = !(previewState.draft || previewState.published) && !previewState.isLoading;
  let t1;
  bb0: {
    if (!schemaType || invalidDocument) {
      let t22;
      $[2] !== schedule ? (t22 = /* @__PURE__ */ jsx(NoSchemaItem, { schedule }), $[2] = schedule, $[3] = t22) : t22 = $[3], t1 = t22;
      break bb0;
    }
    if (type === "document") {
      let t22;
      $[4] !== schedule || $[5] !== schemaType ? (t22 = /* @__PURE__ */ jsx(DocumentPreview$1, { schedule, schemaType }), $[4] = schedule, $[5] = schemaType, $[6] = t22) : t22 = $[6], t1 = t22;
      break bb0;
    }
    if (type === "tool") {
      let t22;
      $[7] !== previewState || $[8] !== schedule || $[9] !== schemaType ? (t22 = /* @__PURE__ */ jsx(ToolPreview, { previewState, schedule, schemaType }), $[7] = previewState, $[8] = schedule, $[9] = schemaType, $[10] = t22) : t22 = $[10], t1 = t22;
      break bb0;
    }
    t1 = null;
  }
  const preview = t1;
  let t2;
  return $[11] !== preview ? (t2 = /* @__PURE__ */ jsx(DateWithTooltipElementQuery, { children: preview }), $[11] = preview, $[12] = t2) : t2 = $[12], t2;
}, SCHEDULE_RENDER_DELAY_MS = 200;
function VirtualListItem(props2) {
  const $ = c(10), {
    item: t0,
    measureElement
  } = props2, {
    content,
    virtualRow
  } = t0, t1 = `translateY(${virtualRow.start}px)`;
  let t2;
  $[0] !== t1 ? (t2 = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    transform: t1
  }, $[0] = t1, $[1] = t2) : t2 = $[1];
  const style = t2;
  let t3;
  $[2] !== content ? (t3 = typeof content == "string" ? /* @__PURE__ */ jsx(MonthHeading, { content }) : /* @__PURE__ */ jsx(DelayedScheduleItem, { schedule: content }), $[2] = content, $[3] = t3) : t3 = $[3];
  let t4;
  return $[4] !== measureElement || $[5] !== style || $[6] !== t3 || $[7] !== virtualRow.index || $[8] !== virtualRow.key ? (t4 = /* @__PURE__ */ jsx(Box, { "data-index": virtualRow.index, paddingBottom: 2, ref: measureElement, style, children: t3 }, virtualRow.key), $[4] = measureElement, $[5] = style, $[6] = t3, $[7] = virtualRow.index, $[8] = virtualRow.key, $[9] = t4) : t4 = $[9], t4;
}
function DelayedScheduleItem(t0) {
  const $ = c(4), {
    schedule
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(PlaceholderScheduleItem, {}), $[0] = t1) : t1 = $[0];
  const [delayedScheduleItem, setDelayedScheduleItem] = useState(t1);
  let t2, t3;
  return $[1] !== schedule ? (t2 = () => {
    let canUpdate = !0;
    const timeout2 = setTimeout(() => {
      canUpdate && setDelayedScheduleItem(/* @__PURE__ */ jsx(ScheduleItem, { schedule, type: "tool" }));
    }, SCHEDULE_RENDER_DELAY_MS);
    return () => {
      canUpdate = !1, clearTimeout(timeout2);
    };
  }, t3 = [schedule], $[1] = schedule, $[2] = t2, $[3] = t3) : (t2 = $[2], t3 = $[3]), useEffect(t2, t3), delayedScheduleItem;
}
function MonthHeading(t0) {
  const $ = c(2), {
    content
  } = t0;
  let t1;
  return $[0] !== content ? (t1 = /* @__PURE__ */ jsx(Flex, { align: "flex-end", paddingBottom: 2, paddingTop: 4, children: /* @__PURE__ */ jsx(Label, { muted: !0, size: 1, children: content }) }), $[0] = content, $[1] = t1) : t1 = $[1], t1;
}
function PlaceholderScheduleItem() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Card, { padding: 1, radius: 2, shadow: 1, children: /* @__PURE__ */ jsx(Card, { padding: 1, children: /* @__PURE__ */ jsx(SanityDefaultPreview, { isPlaceholder: !0 }) }) }), $[0] = t0) : t0 = $[0], t0;
}
function getLocalizedDate(date) {
  return new Date(date).toLocaleString("default", {
    month: "long",
    year: "numeric"
  });
}
const VirtualList = () => {
  const $ = c(26), {
    activeSchedules,
    scheduleState,
    sortBy: sortBy2
  } = useSchedules(), {
    measureElement,
    virtualList,
    totalSize,
    containerRef
  } = useVirtualizedSchedules(activeSchedules, sortBy2), {
    deleteSchedules
  } = useScheduleOperation();
  let t0;
  $[0] !== activeSchedules || $[1] !== deleteSchedules ? (t0 = () => {
    deleteSchedules({
      schedules: activeSchedules || []
    });
  }, $[0] = activeSchedules, $[1] = deleteSchedules, $[2] = t0) : t0 = $[2];
  const handleClearSchedules = t0;
  let t1;
  $[3] !== containerRef ? (t1 = () => {
    containerRef?.current?.scrollTo(0, 0);
  }, $[3] = containerRef, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== containerRef || $[6] !== scheduleState || $[7] !== sortBy2 ? (t2 = [scheduleState, sortBy2, containerRef], $[5] = containerRef, $[6] = scheduleState, $[7] = sortBy2, $[8] = t2) : t2 = $[8], useEffect(t1, t2);
  const t3 = `${totalSize}px`;
  let t4;
  $[9] !== t3 ? (t4 = {
    height: t3,
    width: "100%",
    position: "relative"
  }, $[9] = t3, $[10] = t4) : t4 = $[10];
  let t5;
  if ($[11] !== measureElement || $[12] !== virtualList) {
    let t62;
    $[14] !== measureElement ? (t62 = (item) => /* @__PURE__ */ jsx(VirtualListItem, { item, measureElement }, item.key), $[14] = measureElement, $[15] = t62) : t62 = $[15], t5 = virtualList.map(t62), $[11] = measureElement, $[12] = virtualList, $[13] = t5;
  } else
    t5 = $[13];
  let t6;
  $[16] !== t4 || $[17] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { style: t4, children: t5 }), $[16] = t4, $[17] = t5, $[18] = t6) : t6 = $[18];
  let t7;
  $[19] !== handleClearSchedules || $[20] !== scheduleState ? (t7 = scheduleState === "succeeded" && /* @__PURE__ */ jsx(Flex, { justify: "center", marginTop: 6, children: /* @__PURE__ */ jsx(Button, { icon: CheckmarkCircleIcon, mode: "ghost", onClick: handleClearSchedules, text: "Clear all completed schedules" }) }), $[19] = handleClearSchedules, $[20] = scheduleState, $[21] = t7) : t7 = $[21];
  let t8;
  return $[22] !== containerRef || $[23] !== t6 || $[24] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Box, { paddingBottom: 6, paddingTop: 1, paddingX: 4, ref: containerRef, overflow: "hidden", children: [
    t6,
    t7
  ] }), $[22] = containerRef, $[23] = t6, $[24] = t7, $[25] = t8) : t8 = $[25], t8;
};
function useVirtualizedSchedules(activeSchedules, sortBy2) {
  const containerRef = useRef(null), listSourceItems = useMemo(() => {
    const items = [];
    return activeSchedules.forEach((schedule, index) => {
      if (sortBy2 == "executeAt") {
        const previousSchedule = activeSchedules[index - 1], previousExecuteDate = getLastExecuteDate(previousSchedule), datePrevious = index > 0 && previousExecuteDate ? getLocalizedDate(previousExecuteDate) : null, currentExecuteDate = getLastExecuteDate(schedule), dateCurrent = currentExecuteDate ? getLocalizedDate(currentExecuteDate) : null;
        dateCurrent !== datePrevious && items.push(dateCurrent || "No date specified");
      }
      items.push(schedule);
    }), items;
  }, [activeSchedules, sortBy2]), virtualizer = useVirtualizer({
    count: listSourceItems.length,
    getScrollElement: () => containerRef.current,
    estimateSize: () => 50,
    overscan: 5
  }), virtualList = virtualizer.getVirtualItems().map((virtualRow) => {
    const item = listSourceItems[virtualRow.index];
    return {
      content: item,
      key: typeof item == "string" ? item : item.id,
      virtualRow
    };
  });
  return {
    containerRef,
    measureElement: virtualizer.measureElement,
    totalSize: virtualizer.getTotalSize(),
    virtualList
  };
}
const Panel = styled(Container$3).withConfig({
  displayName: "Panel",
  componentId: "sc-1ny9eog-0"
})`width:auto;`, Schedules$1 = () => {
  const $ = c(13), {
    activeSchedules,
    selectedDate,
    scheduleState
  } = useSchedules(), {
    upsellData,
    telemetryLogs
  } = useSchedulePublishingUpsell(), {
    mode
  } = useScheduledPublishingEnabled(), showWarning = mode === "upsell" && scheduleState === "scheduled";
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    height: "100%"
  }, $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== mode || $[2] !== telemetryLogs || $[3] !== upsellData ? (t1 = mode === "upsell" && upsellData && /* @__PURE__ */ jsx(Panel, { width: 1, padding: 4, paddingBottom: 1, children: /* @__PURE__ */ jsx(UpsellPanel, { layout: "horizontal", data: upsellData, onPrimaryClick: telemetryLogs.panelPrimaryClicked, onSecondaryClick: telemetryLogs.panelSecondaryClicked }) }), $[1] = mode, $[2] = telemetryLogs, $[3] = upsellData, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== activeSchedules.length || $[6] !== scheduleState || $[7] !== selectedDate || $[8] !== showWarning ? (t2 = activeSchedules.length === 0 ? /* @__PURE__ */ jsx(Panel, { width: 1, padding: 4, paddingTop: 4, children: /* @__PURE__ */ jsx(EmptySchedules, { scheduleState, selectedDate }) }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    showWarning && /* @__PURE__ */ jsx(Card, { margin: 4, marginBottom: 2, padding: 3, tone: "caution", radius: 3, shadow: 1, children: /* @__PURE__ */ jsxs(Flex, { gap: 3, align: "center", children: [
      /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }),
      /* @__PURE__ */ jsx(Text$1, { size: 1, children: "Your scheduled documents won't be published automatically unless you upgrade your plan. You can still publish them manually." })
    ] }) }),
    /* @__PURE__ */ jsx(Box, { paddingTop: showWarning ? 0 : 4, children: /* @__PURE__ */ jsx(VirtualList, {}) })
  ] }), $[5] = activeSchedules.length, $[6] = scheduleState, $[7] = selectedDate, $[8] = showWarning, $[9] = t2) : t2 = $[9];
  let t3;
  return $[10] !== t1 || $[11] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Box, { style: t0, children: [
    t1,
    t2
  ] }), $[10] = t1, $[11] = t2, $[12] = t3) : t3 = $[12], t3;
}, SchedulesContextMenu = () => {
  const $ = c(15), {
    setSortBy,
    sortBy: sortBy2
  } = useSchedules();
  let t0;
  $[0] !== setSortBy ? (t0 = () => setSortBy("createdAt"), $[0] = setSortBy, $[1] = t0) : t0 = $[1];
  const handleSortByCreateAt = t0;
  let t1;
  $[2] !== setSortBy ? (t1 = () => setSortBy("executeAt"), $[2] = setSortBy, $[3] = t1) : t1 = $[3];
  const handleSortByExecuteAt = t1;
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[4] = t2) : t2 = $[4];
  let t3;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    minWidth: "250px"
  }, $[5] = t3) : t3 = $[5];
  const t4 = sortBy2 === "createdAt" ? CheckmarkIcon : void 0;
  let t5;
  $[6] !== handleSortByCreateAt || $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(MenuItem, { icon: SortIcon, iconRight: t4, onClick: handleSortByCreateAt, text: "Sort by time added" }), $[6] = handleSortByCreateAt, $[7] = t4, $[8] = t5) : t5 = $[8];
  const t6 = sortBy2 === "executeAt" ? CheckmarkIcon : void 0;
  let t7;
  $[9] !== handleSortByExecuteAt || $[10] !== t6 ? (t7 = /* @__PURE__ */ jsx(MenuItem, { icon: SortIcon, iconRight: t6, onClick: handleSortByExecuteAt, text: "Sort by time scheduled" }), $[9] = handleSortByExecuteAt, $[10] = t6, $[11] = t7) : t7 = $[11];
  let t8;
  return $[12] !== t5 || $[13] !== t7 ? (t8 = /* @__PURE__ */ jsx(MenuButton, { button: t2, id: "sort", menu: /* @__PURE__ */ jsxs(Menu, { style: t3, children: [
    t5,
    t7
  ] }) }), $[12] = t5, $[13] = t7, $[14] = t8) : t8 = $[14], t8;
}, Pip = (props2) => {
  const $ = c(8), {
    mode: t0,
    selected
  } = props2, mode = t0 === void 0 ? "default" : t0;
  let t1;
  $[0] !== mode || $[1] !== selected ? (t1 = mode === "default" ? {
    background: gray[selected ? 100 : 300].hex
  } : {}, $[0] = mode, $[1] = selected, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== mode ? (t2 = mode === "failed" ? {
    background: red[500].hex
  } : {}, $[3] = mode, $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== t1 || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { style: {
    ...t1,
    ...t2,
    borderRadius: "2px",
    height: "2px",
    width: "100%"
  } }), $[5] = t1, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
};
function CalendarDay(props2) {
  const $ = c(60), {
    date,
    focused,
    isCurrentMonth,
    isToday: isToday2,
    onSelect,
    selected
  } = props2, {
    schedulesByDate
  } = useSchedules();
  let t0;
  $[0] !== date || $[1] !== schedulesByDate ? (t0 = schedulesByDate(date), $[0] = date, $[1] = schedulesByDate, $[2] = t0) : t0 = $[2];
  const schedules2 = t0;
  let t1;
  $[3] !== date || $[4] !== onSelect || $[5] !== selected ? (t1 = () => {
    onSelect(selected ? void 0 : date);
  }, $[3] = date, $[4] = onSelect, $[5] = selected, $[6] = t1) : t1 = $[6];
  const handleClick = t1;
  let tone;
  isToday2 || selected ? tone = "primary" : (isWeekend(date), tone = "default");
  const hasSchedules = schedules2.length > 0;
  let t2;
  $[7] !== schedules2 ? (t2 = schedules2.filter(_temp$T), $[7] = schedules2, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== schedules2 ? (t3 = schedules2.filter(_temp2$j), $[9] = schedules2, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== schedules2 ? (t4 = schedules2.filter(_temp3$9), $[11] = schedules2, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== t2 || $[14] !== t3 || $[15] !== t4 ? (t5 = {
    completed: t2,
    failed: t3,
    upcoming: t4
  }, $[13] = t2, $[14] = t3, $[15] = t4, $[16] = t5) : t5 = $[16];
  const {
    completed,
    failed,
    upcoming
  } = t5;
  let t6;
  $[17] !== date || $[18] !== schedules2 ? (t6 = /* @__PURE__ */ jsx(TooltipContent, { date, schedules: schedules2 }), $[17] = date, $[18] = schedules2, $[19] = t6) : t6 = $[19];
  const t7 = !hasSchedules;
  let t8;
  $[20] !== date ? (t8 = date.toDateString(), $[20] = date, $[21] = t8) : t8 = $[21];
  const t9 = focused ? "true" : "";
  let t10;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    position: "relative"
  }, $[22] = t10) : t10 = $[22];
  const t11 = !selected && !isCurrentMonth ? 0.35 : 1;
  let t12;
  $[23] !== t11 ? (t12 = {
    opacity: t11,
    textAlign: "center"
  }, $[23] = t11, $[24] = t12) : t12 = $[24];
  let t13;
  $[25] !== date || $[26] !== selected ? (t13 = selected ? /* @__PURE__ */ jsx(CloseIcon, {}) : date.getDate(), $[25] = date, $[26] = selected, $[27] = t13) : t13 = $[27];
  let t14;
  $[28] !== t12 || $[29] !== t13 ? (t14 = /* @__PURE__ */ jsx(Text$1, { size: 1, style: t12, children: t13 }), $[28] = t12, $[29] = t13, $[30] = t14) : t14 = $[30];
  let t15;
  $[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = {
    bottom: 2,
    left: 2,
    position: "absolute",
    right: 2
  }, $[31] = t15) : t15 = $[31];
  let t16;
  $[32] !== completed.length || $[33] !== selected ? (t16 = completed.length > 0 && /* @__PURE__ */ jsx(Pip, { selected }), $[32] = completed.length, $[33] = selected, $[34] = t16) : t16 = $[34];
  let t17;
  $[35] !== selected || $[36] !== upcoming.length ? (t17 = upcoming.length > 0 && /* @__PURE__ */ jsx(Pip, { selected }), $[35] = selected, $[36] = upcoming.length, $[37] = t17) : t17 = $[37];
  let t18;
  $[38] !== failed.length || $[39] !== selected ? (t18 = failed.length > 0 && /* @__PURE__ */ jsx(Pip, { mode: "failed", selected }), $[38] = failed.length, $[39] = selected, $[40] = t18) : t18 = $[40];
  let t19;
  $[41] !== t16 || $[42] !== t17 || $[43] !== t18 ? (t19 = /* @__PURE__ */ jsx(Box, { style: t15, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, justify: "center", children: [
    t16,
    t17,
    t18
  ] }) }), $[41] = t16, $[42] = t17, $[43] = t18, $[44] = t19) : t19 = $[44];
  let t20;
  $[45] !== handleClick || $[46] !== selected || $[47] !== t14 || $[48] !== t19 || $[49] !== t8 || $[50] !== t9 || $[51] !== tone ? (t20 = /* @__PURE__ */ jsxs(Card, { "aria-label": t8, "aria-pressed": selected, as: "button", __unstable_focusRing: !0, "data-weekday": !0, "data-focused": t9, role: "button", tabIndex: -1, onClick: handleClick, paddingX: 3, paddingY: 4, radius: 2, selected, style: t10, tone, children: [
    t14,
    t19
  ] }), $[45] = handleClick, $[46] = selected, $[47] = t14, $[48] = t19, $[49] = t8, $[50] = t9, $[51] = tone, $[52] = t20) : t20 = $[52];
  let t21;
  $[53] !== t20 || $[54] !== t6 || $[55] !== t7 ? (t21 = /* @__PURE__ */ jsx(Tooltip, { content: t6, disabled: t7, portal: !0, children: t20 }), $[53] = t20, $[54] = t6, $[55] = t7, $[56] = t21) : t21 = $[56];
  let t22;
  return $[57] !== selected || $[58] !== t21 ? (t22 = /* @__PURE__ */ jsx("div", { "aria-selected": selected, "data-ui": "CalendarDay", children: t21 }), $[57] = selected, $[58] = t21, $[59] = t22) : t22 = $[59], t22;
}
function _temp3$9(s_1) {
  return s_1.state === "scheduled";
}
function _temp2$j(s_0) {
  return s_0.state === "cancelled";
}
function _temp$T(s) {
  return s.state === "succeeded";
}
function TooltipContent(props2) {
  const $ = c(12), {
    date,
    schedules: t0
  } = props2, schedules2 = t0 === void 0 ? [] : t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    type: "scheduledPublishing"
  }, $[0] = t1) : t1 = $[0];
  const {
    formatDateTz
  } = useTimeZone(t1), schedulesByState = schedules2.reduce(_temp4$3, {
    cancelled: [],
    succeeded: [],
    scheduled: []
  }), T0 = Box, t2 = 3;
  let t3;
  $[1] !== date ? (t3 = format(date, "d MMMM yyyy"), $[1] = date, $[2] = t3) : t3 = $[2];
  let t4;
  $[3] !== t3 ? (t4 = /* @__PURE__ */ jsx(Box, { marginBottom: 4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t3 }) }), $[3] = t3, $[4] = t4) : t4 = $[4];
  const T1 = Stack, t5 = 3, t6 = Object.keys(schedulesByState).map((key) => {
    const stateSchedules = schedulesByState[key];
    return stateSchedules.length === 0 ? null : /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
      /* @__PURE__ */ jsx(Label, { muted: !0, size: 0, children: SCHEDULE_STATE_DICTIONARY[key].title }),
      /* @__PURE__ */ jsx(Stack, { space: 1, children: stateSchedules.filter(_temp5$2).map((schedule_0) => {
        const executeDate = getLastExecuteDate(schedule_0);
        return executeDate ? /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
          /* @__PURE__ */ jsx(Box, { style: {
            width: "60px"
          }, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "regular", children: formatDateTz({
            date: new Date(executeDate),
            format: "p"
          }) }) }),
          /* @__PURE__ */ jsx(Flex, { align: "center", style: {
            flexShrink: 0,
            opacity: schedule_0.action === "unpublish" ? 1 : 0
          }, children: /* @__PURE__ */ jsx(Badge, { fontSize: 0, mode: "outline", tone: SCHEDULE_ACTION_DICTIONARY[schedule_0.action].badgeTone, children: schedule_0.action }) })
        ] }, schedule_0.id) : null;
      }) })
    ] }, key);
  });
  let t7;
  $[5] !== T1 || $[6] !== t6 ? (t7 = /* @__PURE__ */ jsx(T1, { space: t5, children: t6 }), $[5] = T1, $[6] = t6, $[7] = t7) : t7 = $[7];
  let t8;
  return $[8] !== T0 || $[9] !== t4 || $[10] !== t7 ? (t8 = /* @__PURE__ */ jsxs(T0, { padding: t2, children: [
    t4,
    t7
  ] }), $[8] = T0, $[9] = t4, $[10] = t7, $[11] = t8) : t8 = $[11], t8;
}
function _temp5$2(schedule) {
  return schedule.executeAt;
}
function _temp4$3(acc, val) {
  return acc[val.state].push(val), acc;
}
const ToolCalendar = (props2) => {
  const $ = c(11), {
    onSelect,
    selectedDate,
    timeZoneScope
  } = props2, {
    getCurrentZoneDate,
    utcToCurrentZoneDate
  } = useTimeZone(timeZoneScope);
  let t0;
  $[0] !== getCurrentZoneDate || $[1] !== selectedDate ? (t0 = selectedDate || getCurrentZoneDate(), $[0] = getCurrentZoneDate, $[1] = selectedDate, $[2] = t0) : t0 = $[2];
  const [focusedDate, setFocusedDate] = useState(t0);
  let t1;
  $[3] !== utcToCurrentZoneDate ? (t1 = (date) => {
    setFocusedDate(utcToCurrentZoneDate(date));
  }, $[3] = utcToCurrentZoneDate, $[4] = t1) : t1 = $[4];
  const handleFocusDateChange = t1;
  let t2;
  return $[5] !== focusedDate || $[6] !== handleFocusDateChange || $[7] !== onSelect || $[8] !== selectedDate || $[9] !== timeZoneScope ? (t2 = /* @__PURE__ */ jsx(CalendarFilter, { focusedDate, onFocusedDateChange: handleFocusDateChange, onSelect, selectedDate, renderCalendarDay: CalendarDay, timeZoneScope }), $[5] = focusedDate, $[6] = handleFocusDateChange, $[7] = onSelect, $[8] = selectedDate, $[9] = timeZoneScope, $[10] = t2) : t2 = $[10], t2;
}, Column = styled(Box).withConfig({
  displayName: "Column",
  componentId: "sc-1q185kz-0"
})`flex-direction:column;&:not(:last-child){border-right:1px solid var(--card-border-color);}`, NO_SCHEDULE = [], DATE_SLUG_FORMAT = "yyyy-MM-dd";
function ScheduledDraftsBanner() {
  const $ = c(4), router = useRouter(), isScheduledDraftsEnabled = useScheduledDraftsEnabled();
  let t0;
  $[0] !== router ? (t0 = router.resolveIntentLink(RELEASES_SCHEDULED_DRAFTS_INTENT, {
    view: "drafts"
  }), $[0] = router, $[1] = t0) : t0 = $[1];
  const releasesUrl = t0;
  if (isScheduledDraftsEnabled) {
    let t1;
    return $[2] !== releasesUrl ? (t1 = /* @__PURE__ */ jsx(Card, { padding: 4, tone: "caution", width: "fill", children: /* @__PURE__ */ jsx(Flex, { gap: 3, align: "center", justify: "center", children: /* @__PURE__ */ jsxs(Text$1, { size: 1, weight: "medium", children: [
      "Scheduled Drafts is enabled for this Studio. All new Scheduled Drafts will be",
      " ",
      /* @__PURE__ */ jsx(Link$1, { href: releasesUrl, children: "available here" })
    ] }) }) }), $[2] = releasesUrl, $[3] = t1) : t1 = $[3], t1;
  }
}
function Tool() {
  const $ = c(60), router = useRouter(), {
    scheduledPublishing: scheduledPublishing2
  } = useWorkspace(), {
    sanity: theme
  } = useTheme(), {
    error,
    isInitialLoading,
    schedules: t0
  } = usePollSchedules(), schedules2 = t0 === void 0 ? NO_SCHEDULE : t0, {
    t
  } = useTranslation(), {
    enabled,
    hasUsedScheduledPublishing
  } = useScheduledPublishingEnabled(), lastScheduleState = useRef(void 0), scheduleState = router.state.state;
  let t1;
  $[0] !== router.state.date ? (t1 = router.state.date ? parse(router.state.date, DATE_SLUG_FORMAT, /* @__PURE__ */ new Date()) : void 0, $[0] = router.state.date, $[1] = t1) : t1 = $[1];
  const selectedDate = t1;
  let t2, t3;
  $[2] !== router.state.state ? (t2 = () => {
    router.state.state && (lastScheduleState.current = router.state.state);
  }, t3 = [router.state.state], $[2] = router.state.state, $[3] = t2, $[4] = t3) : (t2 = $[3], t3 = $[4]), useEffect(t2, t3), useFallbackNavigation(router, scheduleState, selectedDate);
  const {
    formatDateTz,
    timeZone
  } = useTimeZone(SCHEDULED_PUBLISHING_TIME_ZONE_SCOPE);
  let t4;
  $[5] !== scheduleState || $[6] !== schedules2 || $[7] !== selectedDate ? (t4 = {
    schedules: schedules2,
    scheduleState,
    selectedDate
  }, $[5] = scheduleState, $[6] = schedules2, $[7] = selectedDate, $[8] = t4) : t4 = $[8];
  const schedulesContext = t4;
  let t5;
  $[9] !== router ? (t5 = () => {
    router.navigate({
      state: lastScheduleState?.current || SCHEDULE_FILTERS[0]
    });
  }, $[9] = router, $[10] = t5) : t5 = $[10];
  const handleClearDate = t5;
  let t6;
  $[11] !== formatDateTz || $[12] !== router ? (t6 = (date) => {
    date ? router.navigate({
      date: formatDateTz({
        date,
        format: DATE_SLUG_FORMAT
      })
    }) : router.navigate({
      state: lastScheduleState?.current || SCHEDULE_FILTERS[0]
    });
  }, $[11] = formatDateTz, $[12] = router, $[13] = t6) : t6 = $[13];
  const handleSelectDate = t6;
  if (!enabled) {
    if (scheduledPublishing2.__internal__workspaceEnabled) {
      let t73;
      return $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t73 = /* @__PURE__ */ jsx(Container$3, { width: 1, paddingTop: 4, children: /* @__PURE__ */ jsx(Box, { paddingTop: 4, paddingX: 4, children: /* @__PURE__ */ jsx(ErrorCallout, { description: "Something went wrong loading permissions, please try again.", title: "Permissions check failed" }) }) }), $[14] = t73) : t73 = $[14], t73;
    }
    let t72;
    return $[15] !== hasUsedScheduledPublishing.loading ? (t72 = /* @__PURE__ */ jsx(Container$3, { width: 1, paddingTop: 4, children: /* @__PURE__ */ jsx(Box, { paddingTop: 4, paddingX: 4, children: hasUsedScheduledPublishing.loading ? /* @__PURE__ */ jsx(LoadingBlock, {}) : /* @__PURE__ */ jsx(InfoCallout, {}) }) }), $[15] = hasUsedScheduledPublishing.loading, $[16] = t72) : t72 = $[16], t72;
  }
  let t7;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = ["none", null, null, "flex"], $[17] = t7) : t7 = $[17];
  let t8;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = {
    position: "sticky",
    top: 0,
    width: "350px"
  }, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== handleSelectDate || $[20] !== selectedDate ? (t9 = /* @__PURE__ */ jsx(Column, { display: t7, style: t8, children: /* @__PURE__ */ jsx(ToolCalendar, { onSelect: handleSelectDate, timeZoneScope: SCHEDULED_PUBLISHING_TIME_ZONE_SCOPE, selectedDate }) }), $[19] = handleSelectDate, $[20] = selectedDate, $[21] = t9) : t9 = $[21];
  let t10;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = /* @__PURE__ */ jsx(ScheduledDraftsBanner, {}), $[22] = t10) : t10 = $[22];
  let t11;
  $[23] !== theme.color.card.enabled.bg ? (t11 = {
    background: theme.color.card.enabled.bg,
    position: "sticky",
    top: 0,
    zIndex: 1
  }, $[23] = theme.color.card.enabled.bg, $[24] = t11) : t11 = $[24];
  let t12;
  $[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = {
    borderBottom: "1px solid var(--card-border-color)",
    minHeight: `${TOOL_HEADER_HEIGHT}px`
  }, $[25] = t12) : t12 = $[25];
  let t13;
  $[26] !== handleClearDate || $[27] !== selectedDate ? (t13 = /* @__PURE__ */ jsx(ScheduleFilters, { onClearDate: handleClearDate, selectedDate }), $[26] = handleClearDate, $[27] = selectedDate, $[28] = t13) : t13 = $[28];
  let t14;
  $[29] !== t || $[30] !== timeZone.alternativeName || $[31] !== timeZone.offset ? (t14 = t("time-zone.time-zone-tooltip-content-releases", {
    alternativeName: timeZone.alternativeName,
    offset: timeZone.offset
  }), $[29] = t, $[30] = timeZone.alternativeName, $[31] = timeZone.offset, $[32] = t14) : t14 = $[32];
  let t15;
  $[33] !== t14 ? (t15 = /* @__PURE__ */ jsx(TimeZoneButton, { tooltipContent: t14, timeZoneScope: SCHEDULED_PUBLISHING_TIME_ZONE_SCOPE, useElementQueries: !0 }), $[33] = t14, $[34] = t15) : t15 = $[34];
  let t16;
  $[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = /* @__PURE__ */ jsx(SchedulesContextMenu, {}), $[35] = t16) : t16 = $[35];
  let t17;
  $[36] !== t15 ? (t17 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
    t15,
    t16
  ] }), $[36] = t15, $[37] = t17) : t17 = $[37];
  let t18;
  $[38] !== t13 || $[39] !== t17 ? (t18 = /* @__PURE__ */ jsx(Flex, { align: "center", paddingLeft: 4, paddingRight: 3, style: t12, children: /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, justify: "space-between", children: [
    t13,
    t17
  ] }) }), $[38] = t13, $[39] = t17, $[40] = t18) : t18 = $[40];
  let t19;
  $[41] !== t11 || $[42] !== t18 ? (t19 = /* @__PURE__ */ jsx(TimeZoneButtonElementQuery, { style: t11, children: t18 }), $[41] = t11, $[42] = t18, $[43] = t19) : t19 = $[43];
  let t20;
  $[44] !== error ? (t20 = error && /* @__PURE__ */ jsx(Box, { paddingTop: 4, paddingX: 4, children: /* @__PURE__ */ jsx(ErrorCallout, { description: "More information in the developer console.", title: "Something went wrong, unable to retrieve schedules." }) }), $[44] = error, $[45] = t20) : t20 = $[45];
  let t21;
  $[46] !== isInitialLoading ? (t21 = /* @__PURE__ */ jsx(Box, { flex: 1, overflow: "auto", children: isInitialLoading ? /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, children: "Loading..." }) }) : /* @__PURE__ */ jsx(Schedules$1, {}) }), $[46] = isInitialLoading, $[47] = t21) : t21 = $[47];
  let t22;
  $[48] !== t20 || $[49] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, children: [
    t20,
    t21
  ] }), $[48] = t20, $[49] = t21, $[50] = t22) : t22 = $[50];
  let t23;
  $[51] !== t19 || $[52] !== t22 ? (t23 = /* @__PURE__ */ jsxs(Column, { display: "flex", flex: 1, overflow: "hidden", children: [
    t10,
    t19,
    t22
  ] }), $[51] = t19, $[52] = t22, $[53] = t23) : t23 = $[53];
  let t24;
  $[54] !== t23 || $[55] !== t9 ? (t24 = /* @__PURE__ */ jsx(Flex, { direction: "column", height: "fill", flex: 1, overflow: "hidden", children: /* @__PURE__ */ jsxs(Flex, { flex: 1, height: "fill", children: [
    t9,
    t23
  ] }) }), $[54] = t23, $[55] = t9, $[56] = t24) : t24 = $[56];
  let t25;
  return $[57] !== schedulesContext || $[58] !== t24 ? (t25 = /* @__PURE__ */ jsx(SchedulesProvider, { value: schedulesContext, children: t24 }), $[57] = schedulesContext, $[58] = t24, $[59] = t25) : t25 = $[59], t25;
}
function useFallbackNavigation(router, filter2, selectedDate) {
  const $ = c(5);
  let t0, t1;
  $[0] !== filter2 || $[1] !== router || $[2] !== selectedDate ? (t0 = () => {
    !filter2 && !selectedDate && router.navigate({
      state: SCHEDULE_FILTERS[0]
    }, {
      replace: !0
    });
  }, t1 = [selectedDate, router, filter2], $[0] = filter2, $[1] = router, $[2] = selectedDate, $[3] = t0, $[4] = t1) : (t0 = $[3], t1 = $[4]), useEffect(t0, t1);
}
const DialogFooter = (props2) => {
  const $ = c(11), {
    buttonText: t0,
    disabled,
    icon,
    onAction,
    onComplete,
    tone: t1
  } = props2, buttonText = t0 === void 0 ? "Action" : t0, tone = t1 === void 0 ? "positive" : t1;
  let t2;
  $[0] !== onComplete ? (t2 = /* @__PURE__ */ jsx(Button, { mode: "bleed", onClick: onComplete, text: "Cancel" }), $[0] = onComplete, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== buttonText || $[3] !== disabled || $[4] !== icon || $[5] !== onAction || $[6] !== tone ? (t3 = onAction && /* @__PURE__ */ jsx(Button, { disabled, icon, onClick: onAction, text: buttonText, tone }), $[2] = buttonText, $[3] = disabled, $[4] = icon, $[5] = onAction, $[6] = tone, $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== t2 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { width: "full", gap: 3, justify: "flex-end", children: [
    t2,
    t3
  ] }), $[8] = t2, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
};
function NewScheduleInfo(t0) {
  const $ = c(5), {
    id: id2,
    schemaType
  } = t0;
  let t1, t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    "Schedule this document to be published at any time in the future.",
    /* @__PURE__ */ jsx("br", {}),
    "Any edits in the meantime will be added to the scheduled document."
  ] }), t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: "Visit the Schedules page to get an overview of all schedules." }), $[0] = t1, $[1] = t2) : (t1 = $[0], t2 = $[1]);
  let t3;
  return $[2] !== id2 || $[3] !== schemaType ? (t3 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t1,
    t2,
    /* @__PURE__ */ jsx(ValidationWarning, { id: id2, type: schemaType })
  ] }), $[2] = id2, $[3] = schemaType, $[4] = t3) : t3 = $[4], t3;
}
function ValidationWarning(t0) {
  const $ = c(11), {
    id: id2,
    type
  } = t0, schema2 = useSchemaType(type);
  let t1;
  $[0] !== id2 ? (t1 = getDraftId(id2), $[0] = id2, $[1] = t1) : t1 = $[1];
  const draftId = t1;
  let t2;
  $[2] !== id2 ? (t2 = getPublishedId(id2), $[2] = id2, $[3] = t2) : t2 = $[3];
  const publishedId = t2, validationStatus = useValidationStatus(draftId, type, !0), {
    hasError
  } = useValidationState(validationStatus.validation);
  if (!hasError)
    return null;
  let t3;
  $[4] !== publishedId || $[5] !== schema2 || $[6] !== validationStatus.validation ? (t3 = /* @__PURE__ */ jsx(ValidationInfo, { markers: validationStatus.validation, type: schema2, documentId: publishedId }), $[4] = publishedId, $[5] = schema2, $[6] = validationStatus.validation, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: DOCUMENT_HAS_ERRORS_TEXT }), $[8] = t4) : t4 = $[8];
  let t5;
  return $[9] !== t3 ? (t5 = /* @__PURE__ */ jsx(Card, { padding: 2, radius: 1, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", children: [
    t3,
    t4
  ] }) }), $[9] = t3, $[10] = t5) : t5 = $[10], t5;
}
const Schedules = (props2) => {
  const $ = c(2), {
    schedules: schedules2
  } = props2;
  let t0;
  return $[0] !== schedules2 ? (t0 = /* @__PURE__ */ jsx(Stack, { space: 4, children: schedules2.length === 0 ? /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: "No schedules" }) }) : /* @__PURE__ */ jsx(Stack, { space: 2, children: schedules2.map(_temp$S) }) }), $[0] = schedules2, $[1] = t0) : t0 = $[1], t0;
};
function _temp$S(schedule) {
  return /* @__PURE__ */ jsx(ScheduleItem, { schedule, type: "document" }, schedule.id);
}
const debug$5 = debugWithName$1("ScheduleAction"), useScheduleAction = (props2) => {
  const $ = c(47), {
    draft,
    id: id2,
    liveEdit,
    onComplete,
    published,
    type
  } = props2, currentUser = useCurrentUser();
  let t0;
  $[0] !== id2 || $[1] !== type ? (t0 = {
    id: id2,
    type,
    permission: "publish"
  }, $[0] = id2, $[1] = type, $[2] = t0) : t0 = $[2];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t0), {
    createSchedule
  } = useScheduleOperation(), {
    enabled,
    mode
  } = useScheduledPublishingEnabled(), {
    handleOpenDialog
  } = useSchedulePublishingUpsell(), [dialogOpen, setDialogOpen] = useState(!1), {
    formData,
    onFormChange
  } = useScheduleForm();
  let t1;
  $[3] !== id2 ? (t1 = {
    documentId: id2,
    state: "scheduled"
  }, $[3] = id2, $[4] = t1) : t1 = $[4];
  const {
    error: fetchError,
    isInitialLoading,
    schedules: schedules2
  } = usePollSchedules(t1);
  debug$5("schedules", schedules2);
  const hasExistingSchedules = schedules2 && schedules2.length > 0, documentExists = draft !== null || published !== null, insufficientPermissions = !isPermissionsLoading && !permissions?.granted;
  let t2;
  $[5] !== handleOpenDialog || $[6] !== mode ? (t2 = () => {
    mode === "upsell" ? handleOpenDialog("document_action") : setDialogOpen(!0);
  }, $[5] = handleOpenDialog, $[6] = mode, $[7] = t2) : t2 = $[7];
  const handleDialogOpen = t2;
  let t3;
  $[8] !== createSchedule || $[9] !== formData || $[10] !== id2 || $[11] !== onComplete ? (t3 = () => {
    formData?.date && createSchedule({
      date: formData.date,
      documentId: id2
    }).then(onComplete);
  }, $[8] = createSchedule, $[9] = formData, $[10] = id2, $[11] = onComplete, $[12] = t3) : t3 = $[12];
  const handleScheduleCreate = t3, title = hasExistingSchedules ? "Edit Schedule" : "Schedule";
  if (insufficientPermissions) {
    let t42;
    $[13] !== currentUser ? (t42 = /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: "edit-schedules" }), $[13] = currentUser, $[14] = t42) : t42 = $[14];
    let t52;
    return $[15] !== t42 || $[16] !== title ? (t52 = {
      disabled: !0,
      icon: CalendarIcon,
      label: title,
      title: t42
    }, $[15] = t42, $[16] = title, $[17] = t52) : t52 = $[17], t52;
  }
  let tooltip = "This document doesn't exist yet";
  documentExists && (tooltip = null), isInitialLoading && (tooltip = "Loading schedules"), liveEdit && (tooltip = "Live Edit is enabled for this content type and publishing happens automatically as you make changes");
  let t4;
  $[18] !== fetchError || $[19] !== formData || $[20] !== hasExistingSchedules || $[21] !== id2 || $[22] !== onFormChange || $[23] !== props2 || $[24] !== schedules2 || $[25] !== type ? (t4 = fetchError ? /* @__PURE__ */ jsx(ErrorCallout, { description: "More information in the developer console.", title: "Something went wrong, unable to retrieve schedules." }) : /* @__PURE__ */ jsx(DocumentActionPropsProvider, { value: props2, children: hasExistingSchedules ? /* @__PURE__ */ jsx(Schedules, { schedules: schedules2 }) : /* @__PURE__ */ jsx(EditScheduleForm, { onChange: onFormChange, value: formData, children: /* @__PURE__ */ jsx(NewScheduleInfo, { id: id2, schemaType: type }) }) }), $[18] = fetchError, $[19] = formData, $[20] = hasExistingSchedules, $[21] = id2, $[22] = onFormChange, $[23] = props2, $[24] = schedules2, $[25] = type, $[26] = t4) : t4 = $[26];
  let t5;
  $[27] !== formData?.date || $[28] !== handleScheduleCreate || $[29] !== hasExistingSchedules || $[30] !== onComplete ? (t5 = !hasExistingSchedules && /* @__PURE__ */ jsx(DialogFooter, { buttonText: "Schedule", disabled: !formData?.date, icon: ClockIcon, onAction: handleScheduleCreate, onComplete, tone: "primary" }), $[27] = formData?.date, $[28] = handleScheduleCreate, $[29] = hasExistingSchedules, $[30] = onComplete, $[31] = t5) : t5 = $[31];
  let t6;
  $[32] !== title ? (t6 = /* @__PURE__ */ jsx(DialogHeader$1, { timeZoneScope: SCHEDULED_PUBLISHING_TIME_ZONE_SCOPE, title }), $[32] = title, $[33] = t6) : t6 = $[33];
  let t7;
  $[34] !== onComplete || $[35] !== t4 || $[36] !== t5 || $[37] !== t6 ? (t7 = {
    content: t4,
    footer: t5,
    header: t6,
    onClose: onComplete,
    type: "dialog"
  }, $[34] = onComplete, $[35] = t4, $[36] = t5, $[37] = t6, $[38] = t7) : t7 = $[38];
  const dialog = t7;
  if (!enabled)
    return null;
  const t8 = dialogOpen && dialog, t9 = isInitialLoading || !documentExists || liveEdit;
  let t10;
  $[39] !== tooltip ? (t10 = tooltip && /* @__PURE__ */ jsx(Box, { style: {
    maxWidth: "315px"
  }, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: tooltip }) }), $[39] = tooltip, $[40] = t10) : t10 = $[40];
  let t11;
  return $[41] !== handleDialogOpen || $[42] !== t10 || $[43] !== t8 || $[44] !== t9 || $[45] !== title ? (t11 = {
    dialog: t8,
    disabled: t9,
    label: title,
    icon: CalendarIcon,
    onHandle: handleDialogOpen,
    title: t10
  }, $[41] = handleDialogOpen, $[42] = t10, $[43] = t8, $[44] = t9, $[45] = title, $[46] = t11) : t11 = $[46], t11;
};
useScheduleAction.action = "schedule";
useScheduleAction.displayName = "ScheduleAction";
function resolveDocumentActions(existingActions, context) {
  return context.versionType === "published" ? existingActions : existingActions.findIndex((a) => a.action === "publish") < 0 ? [useScheduleAction, ...existingActions] : existingActions.flatMap((action) => action.action === "publish" ? [action, useScheduleAction] : action);
}
const debug$4 = debugWithName$1("ScheduledBadge"), useScheduledBadge = (props2) => {
  const $ = c(7);
  let t0;
  $[0] !== props2.id ? (t0 = {
    documentId: props2.id,
    state: "scheduled"
  }, $[0] = props2.id, $[1] = t0) : t0 = $[1];
  const {
    schedules: schedules2
  } = usePollSchedules(t0);
  debug$4("schedules", schedules2);
  const upcomingSchedule = schedules2?.[0];
  if (!upcomingSchedule || !upcomingSchedule.executeAt || !upcomingSchedule.action)
    return null;
  let t1;
  $[2] !== upcomingSchedule.executeAt ? (t1 = format(new Date(upcomingSchedule.executeAt), DATE_FORMAT.LARGE), $[2] = upcomingSchedule.executeAt, $[3] = t1) : t1 = $[3];
  const formattedDateTime = t1, t2 = SCHEDULE_ACTION_DICTIONARY[upcomingSchedule.action], t3 = `${SCHEDULE_ACTION_DICTIONARY[upcomingSchedule.action].actionName} on ${formattedDateTime} (local time)`;
  let t4;
  return $[4] !== t2.badgeColor || $[5] !== t3 ? (t4 = {
    color: t2.badgeColor,
    label: "Scheduled",
    title: t3
  }, $[4] = t2.badgeColor, $[5] = t3, $[6] = t4) : t4 = $[6], t4;
};
useScheduledBadge.displayName = "ScheduledBadge";
const ScheduledBadge = useScheduledBadge;
function resolveDocumentBadges(existingBadges) {
  return [...existingBadges, ScheduledBadge];
}
function ScheduleBanner(props2) {
  const $ = c(24), {
    id: id2,
    markers
  } = props2, publishedId = usePublishedId(id2), {
    hasError
  } = useValidationState(markers);
  let t0;
  $[0] !== publishedId ? (t0 = {
    documentId: publishedId,
    state: "scheduled"
  }, $[0] = publishedId, $[1] = t0) : t0 = $[1];
  const {
    schedules: schedules2
  } = usePollSchedules(t0), {
    mode
  } = useScheduledPublishingEnabled();
  if (!(schedules2.length > 0))
    return null;
  let t1;
  $[2] !== mode ? (t1 = mode === "upsell" && /* @__PURE__ */ jsx(Card, { tone: "caution", padding: 3, radius: 3, shadow: 1, marginBottom: 3, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, padding: 1, children: [
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }),
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: "Scheduled publishing is not available on your current plan" })
  ] }) }), $[2] = mode, $[3] = t1) : t1 = $[3];
  const t2 = hasError ? "critical" : "primary";
  let t3;
  $[4] !== mode ? (t3 = mode === "upsell" ? {
    opacity: 0.7
  } : void 0, $[4] = mode, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(CalendarIcon, {}) }), $[6] = t4) : t4 = $[6];
  let t5;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, marginBottom: 1, padding: 1, children: [
    t4,
    /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
      /* @__PURE__ */ jsx("span", { style: {
        fontWeight: 600
      }, children: "Upcoming schedule" }),
      " (local time)"
    ] })
  ] }), $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== schedules2 ? (t6 = schedules2.map(_temp$R), $[8] = schedules2, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== t6 ? (t7 = /* @__PURE__ */ jsx(Stack, { space: 2, children: t6 }), $[10] = t6, $[11] = t7) : t7 = $[11];
  let t8;
  $[12] !== hasError ? (t8 = hasError && /* @__PURE__ */ jsx(Box, { marginTop: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "regular", children: DOCUMENT_HAS_ERRORS_TEXT }) }), $[12] = hasError, $[13] = t8) : t8 = $[13];
  let t9;
  $[14] !== t7 || $[15] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t5,
    t7,
    t8
  ] }), $[14] = t7, $[15] = t8, $[16] = t9) : t9 = $[16];
  let t10;
  $[17] !== t2 || $[18] !== t3 || $[19] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { padding: 3, radius: 1, shadow: 1, tone: t2, style: t3, children: t9 }), $[17] = t2, $[18] = t3, $[19] = t9, $[20] = t10) : t10 = $[20];
  let t11;
  return $[21] !== t1 || $[22] !== t10 ? (t11 = /* @__PURE__ */ jsxs(Box, { marginBottom: 4, children: [
    t1,
    t10
  ] }), $[21] = t1, $[22] = t10, $[23] = t11) : t11 = $[23], t11;
}
function _temp$R(schedule) {
  if (!schedule.executeAt)
    return null;
  const formattedDateTime = format(new Date(schedule.executeAt), DATE_FORMAT.LARGE);
  return /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: formattedDateTime }),
    /* @__PURE__ */ jsx(Flex, { style: {
      opacity: schedule.action === "unpublish" ? 1 : 0
    }, children: /* @__PURE__ */ jsx(Badge, { fontSize: 0, mode: "outline", children: schedule.action }) })
  ] }, schedule.id);
}
function ScheduledDocumentInput(props2) {
  const $ = c(8), {
    value,
    validation: validation2,
    children
  } = props2, doc = value;
  let t0;
  $[0] !== validation2 ? (t0 = validation2.map(_temp$Q), $[0] = validation2, $[1] = t0) : t0 = $[1];
  const markers = t0;
  let t1;
  $[2] !== doc || $[3] !== markers ? (t1 = doc?._id ? /* @__PURE__ */ jsx(ScheduleBanner, { id: doc._id, markers }) : null, $[2] = doc, $[3] = markers, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== children || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t1,
    children
  ] }), $[5] = children, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
function _temp$Q(v) {
  return {
    level: v.level,
    path: v.path,
    item: {
      message: v.message
    },
    message: v.message
  };
}
const DocumentBannerInput = (props2) => {
  const $ = c(7), {
    schemaType
  } = props2;
  if (getRootType(schemaType).name === "document") {
    let t02;
    $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1];
    let t1;
    return $[2] !== props2 || $[3] !== t02 ? (t1 = /* @__PURE__ */ jsx(ScheduledDocumentInput, { ...props2, children: t02 }), $[2] = props2, $[3] = t02, $[4] = t1) : t1 = $[4], t1;
  }
  let t0;
  return $[5] !== props2 ? (t0 = props2.renderDefault(props2), $[5] = props2, $[6] = t0) : t0 = $[6], t0;
};
function getRootType(type) {
  return type.type ? getRootType(type.type) : type;
}
function SchedulePublishingStudioLayoutInner(props2) {
  const $ = c(6), {
    enabled,
    mode
  } = useScheduledPublishingEnabled();
  if (!enabled) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  $[2] !== props2 ? (t0 = props2.renderDefault(props2), $[2] = props2, $[3] = t0) : t0 = $[3];
  const children = t0;
  if (mode === "upsell") {
    let t1;
    return $[4] !== children ? (t1 = /* @__PURE__ */ jsx(SchedulePublishingUpsellProvider, { children }), $[4] = children, $[5] = t1) : t1 = $[5], t1;
  }
  return children;
}
function SchedulePublishingStudioLayout(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(ScheduledPublishingEnabledProvider, { children: /* @__PURE__ */ jsx(SchedulePublishingStudioLayoutInner, { ...props2 }) }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
const SCHEDULED_PUBLISHING_NAME = "sanity/scheduled-publishing", scheduledPublishing = definePlugin({
  // Renamed from 'scheduled-publishing' to 'sanity/scheduled-publishing' to avoid duplicates, see packages/sanity/src/core/config/flattenConfig.ts - DEPRECATED_PLUGINS.
  name: SCHEDULED_PUBLISHING_NAME,
  document: {
    actions: (prev, context) => resolveDocumentActions(prev, context),
    badges: (prev) => resolveDocumentBadges(prev)
  },
  form: {
    components: {
      input: DocumentBannerInput
    }
  },
  studio: {
    components: {
      layout: SchedulePublishingStudioLayout
    }
  },
  tools: (prev) => [...prev, {
    name: SCHEDULED_PUBLISHING_TOOL_NAME$1,
    title: TOOL_TITLE,
    icon: CalendarIcon,
    component: Tool,
    router: route.create("/", [route.create("/state/:state"), route.create("/date/:date")]),
    __internalApplicationType: "sanity/scheduled-publishing"
  }]
}), tasksLocaleNamespace = "tasks", tasksUsEnglishLocaleBundle = {
  locale: "en-US",
  namespace: tasksLocaleNamespace,
  resources: () => import("./_chunks-es/resources3.js")
};
function TasksEnabledProvider(t0) {
  const $ = c(6), {
    children
  } = t0, {
    enabled,
    isLoading,
    error
  } = useFeatureEnabled(FEATURES.sanityTasks), isWorkspaceEnabled = useWorkspace().tasks?.enabled;
  let t1;
  bb0: {
    if (!isWorkspaceEnabled || isLoading || error) {
      let t23;
      $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t23 = {
        enabled: !1,
        mode: null
      }, $[0] = t23) : t23 = $[0], t1 = t23;
      break bb0;
    }
    const t22 = enabled ? "default" : "upsell";
    let t3;
    $[1] !== t22 ? (t3 = {
      enabled: !0,
      mode: t22
    }, $[1] = t22, $[2] = t3) : t3 = $[2], t1 = t3;
  }
  const value = t1;
  let t2;
  return $[3] !== children || $[4] !== value ? (t2 = /* @__PURE__ */ jsx(TasksEnabledContext.Provider, { value, children }), $[3] = children, $[4] = value, $[5] = t2) : t2 = $[5], t2;
}
function useTasksEnabled() {
  return useContext(TasksEnabledContext);
}
function IsLastPaneProvider(t0) {
  const $ = c(3), {
    children,
    isLastPane
  } = t0;
  let t1;
  return $[0] !== children || $[1] !== isLastPane ? (t1 = /* @__PURE__ */ jsx(IsLastPaneContext.Provider, { value: isLastPane, children }), $[0] = children, $[1] = isLastPane, $[2] = t1) : t1 = $[2], t1;
}
function useIsLastPane() {
  return useContext(IsLastPaneContext);
}
function MentionUserProvider(props2) {
  const $ = c(8), [selectedDocument, setSelectedDocument] = useState(null);
  let t0;
  $[0] !== selectedDocument ? (t0 = {
    documentValue: selectedDocument,
    permission: "read"
  }, $[0] = selectedDocument, $[1] = t0) : t0 = $[1];
  const mentionOptions = useUserListWithPermissions(t0);
  let t1;
  $[2] !== mentionOptions || $[3] !== selectedDocument ? (t1 = {
    mentionOptions,
    selectedDocument,
    setSelectedDocument
  }, $[2] = mentionOptions, $[3] = selectedDocument, $[4] = t1) : t1 = $[4];
  const value = t1;
  let t2;
  return $[5] !== props2.children || $[6] !== value ? (t2 = /* @__PURE__ */ jsx(MentionUserContext.Provider, { value, children: props2.children }), $[5] = props2.children, $[6] = value, $[7] = t2) : t2 = $[7], t2;
}
function useMentionUser() {
  const context = useContext(MentionUserContext);
  if (!context)
    throw new Error("useMentionUser must be used within a MentionUserProvider");
  return context;
}
const TaskCreated = defineEvent({
  name: "Task Created",
  version: 1,
  description: "A task is created"
}), TaskStatusChanged = defineEvent({
  name: "Task Status Changed",
  version: 1,
  description: "Task status changed"
}), TaskDuplicated = defineEvent({
  name: "Task Duplicated",
  version: 1,
  description: "A task is duplicated"
}), TaskRemoved = defineEvent({
  name: "Task Removed",
  version: 1,
  description: "A task is removed"
}), TaskLinkCopied = defineEvent({
  name: "Task Link Copied",
  version: 1,
  description: "The link to a task is copied"
}), TaskLinkOpened = defineEvent({
  name: "Task Link Opened",
  version: 1,
  description: "User visited the studio through a link with a task"
}), TASKS_SIDEBAR_SEARCH_PARAM = "sidebar", TASKS_SELECTED_TASK_SEARCH_PARAM = "selectedTask", TASKS_VIEW_MODE_SEARCH_PARAM = "viewMode", initialState = {
  viewMode: "list",
  selectedTask: null,
  activeTabId: "assigned",
  duplicateTaskValues: null,
  isOpen: !1
};
function reducer$1(state, action) {
  switch (action.type) {
    case "TOGGLE_TASKS_VIEW":
      return action.payload ? {
        ...state,
        isOpen: action.payload
      } : {
        ...initialState,
        isOpen: action.payload
      };
    case "CREATE_TASK":
      return {
        ...state,
        viewMode: "create",
        selectedTask: uuid()
      };
    case "EDIT_TASK":
      return {
        ...state,
        viewMode: "edit",
        selectedTask: action.payload.id
      };
    case "EDIT_DRAFT":
      return {
        ...state,
        viewMode: "draft",
        selectedTask: action.payload.id
      };
    case "DUPLICATE_TASK":
      return {
        ...state,
        viewMode: "duplicate",
        selectedTask: uuid(),
        duplicateTaskValues: action.payload.duplicateTaskValues
      };
    case "SET_ACTIVE_TAB":
      return {
        ...state,
        viewMode: "list",
        activeTabId: action.payload
      };
    case "NAVIGATE_TO_LIST":
      return {
        ...state,
        viewMode: "list"
      };
    default:
      return state;
  }
}
const TasksNavigationProvider = (t0) => {
  const $ = c(23), {
    children
  } = t0, [state, dispatch] = useReducer(reducer$1, initialState), router = useRouter(), toast = useToast(), telemetry = useTelemetry();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (viewMode) => {
    bb2: switch (viewMode.type) {
      case "list": {
        dispatch({
          type: "NAVIGATE_TO_LIST"
        });
        break bb2;
      }
      case "create": {
        dispatch({
          type: "CREATE_TASK"
        });
        break bb2;
      }
      case "edit": {
        dispatch({
          type: "EDIT_TASK",
          payload: {
            id: viewMode.id
          }
        });
        break bb2;
      }
      case "duplicate": {
        dispatch({
          type: "DUPLICATE_TASK",
          payload: {
            duplicateTaskValues: viewMode.duplicateTaskValues
          }
        });
        break bb2;
      }
      case "draft": {
        dispatch({
          type: "EDIT_DRAFT",
          payload: {
            id: viewMode.id
          }
        });
        break bb2;
      }
    }
  }, $[0] = t1) : t1 = $[0];
  const setViewMode = t1;
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (tabId) => {
    dispatch({
      type: "SET_ACTIVE_TAB",
      payload: tabId
    });
  }, $[1] = t2) : t2 = $[1];
  const setActiveTab = t2;
  let t3;
  $[2] !== router ? (t3 = () => {
    dispatch({
      type: "TOGGLE_TASKS_VIEW",
      payload: !1
    }), router.navigate({
      stickyParams: {
        ...router.stickyParams,
        [TASKS_SIDEBAR_SEARCH_PARAM]: null,
        [TASKS_VIEW_MODE_SEARCH_PARAM]: null,
        [TASKS_SELECTED_TASK_SEARCH_PARAM]: null
      }
    });
  }, $[2] = router, $[3] = t3) : t3 = $[3];
  const handleCloseTasks = t3;
  let t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    dispatch({
      type: "TOGGLE_TASKS_VIEW",
      payload: !0
    });
  }, $[4] = t4) : t4 = $[4];
  const handleOpenTasks = t4;
  let t5;
  $[5] !== state.selectedTask || $[6] !== state.viewMode || $[7] !== telemetry || $[8] !== toast ? (t5 = () => {
    const url = new URL(window.location.href);
    url.searchParams.set(TASKS_SIDEBAR_SEARCH_PARAM, "tasks"), url.searchParams.set(TASKS_VIEW_MODE_SEARCH_PARAM, state.viewMode), state.selectedTask && url.searchParams.set(TASKS_SELECTED_TASK_SEARCH_PARAM, state.selectedTask), navigator.clipboard.writeText(url.toString()).then(() => {
      telemetry.log(TaskLinkCopied);
    }).catch(() => {
      toast.push({
        closable: !0,
        status: "error",
        title: "Failed to copy link to clipboard"
      });
    });
  }, $[5] = state.selectedTask, $[6] = state.viewMode, $[7] = telemetry, $[8] = toast, $[9] = t5) : t5 = $[9];
  const handleCopyLinkToTask = t5, sidebar = router.stickyParams[TASKS_SIDEBAR_SEARCH_PARAM], viewMode_0 = router.stickyParams[TASKS_VIEW_MODE_SEARCH_PARAM], selectedTask = router.stickyParams[TASKS_SELECTED_TASK_SEARCH_PARAM];
  let t6, t7;
  $[10] !== selectedTask || $[11] !== sidebar || $[12] !== telemetry || $[13] !== viewMode_0 ? (t6 = () => {
    sidebar === "tasks" && (dispatch({
      type: "TOGGLE_TASKS_VIEW",
      payload: !0
    }), viewMode_0 === "edit" && selectedTask && (dispatch({
      type: "EDIT_TASK",
      payload: {
        id: selectedTask
      }
    }), telemetry.log(TaskLinkOpened)));
  }, t7 = [selectedTask, sidebar, telemetry, viewMode_0], $[10] = selectedTask, $[11] = sidebar, $[12] = telemetry, $[13] = viewMode_0, $[14] = t6, $[15] = t7) : (t6 = $[14], t7 = $[15]), useEffect(t6, t7);
  let t8;
  $[16] !== handleCloseTasks || $[17] !== handleCopyLinkToTask || $[18] !== state ? (t8 = {
    state,
    setViewMode,
    setActiveTab,
    handleCloseTasks,
    handleOpenTasks,
    handleCopyLinkToTask
  }, $[16] = handleCloseTasks, $[17] = handleCopyLinkToTask, $[18] = state, $[19] = t8) : t8 = $[19];
  const value = t8;
  let t9;
  return $[20] !== children || $[21] !== value ? (t9 = /* @__PURE__ */ jsx(TasksNavigationContext.Provider, { value, children }), $[20] = children, $[21] = value, $[22] = t9) : t9 = $[22], t9;
};
function useTasksNavigation() {
  return useContext(TasksNavigationContext) || FALLBACK_CONTEXT_VALUE$1;
}
const FALLBACK_CONTEXT_VALUE$1 = {
  state: {
    activeTabId: "assigned",
    viewMode: "list",
    selectedTask: null,
    isOpen: !1,
    duplicateTaskValues: null
  },
  setActiveTab: () => null,
  setViewMode: () => null,
  handleCloseTasks: () => null,
  handleCopyLinkToTask: () => null,
  handleOpenTasks: () => null
};
function createTasksSet(tasks2) {
  return tasks2.reduce((acc, task) => ({
    ...acc,
    [task._id]: task
  }), {});
}
function tasksReducer(state, action) {
  switch (action.type) {
    case "TASKS_SET": {
      const tasksById = createTasksSet(action.tasks);
      return {
        ...state,
        tasks: tasksById
      };
    }
    case "TASK_ADDED": {
      const nextTaskResult = action.payload, nextTaskValue = nextTaskResult, nextTask = {
        [nextTaskResult._id]: {
          ...state.tasks[nextTaskResult._id],
          ...nextTaskValue,
          _state: nextTaskResult._state || void 0,
          // If the task is created optimistically, it won't have a createdAt date as this is set on the server.
          // However, we need to set a createdAt date to be able to sort the tasks correctly.
          // Therefore, we set the createdAt date to the current date here if it's missing while creating the task.
          // Once the task is created and received from the server, the createdAt date will be updated to the correct value.
          _createdAt: nextTaskResult._createdAt || (/* @__PURE__ */ new Date()).toISOString()
        }
      };
      return {
        ...state,
        tasks: {
          ...state.tasks,
          ...nextTask
        }
      };
    }
    case "TASK_RECEIVED": {
      const nextTaskResult = action.payload;
      return {
        ...state,
        tasks: {
          ...state.tasks,
          [nextTaskResult._id]: nextTaskResult
        }
      };
    }
    case "TASK_DELETED": {
      const {
        [action.id]: _,
        ...restTasks
      } = state.tasks;
      return {
        ...state,
        tasks: restTasks
      };
    }
    case "TASK_UPDATED": {
      const updatedTask = action.payload, id2 = updatedTask._id, nextTask = {
        // Add existing task data
        ...state.tasks[id2],
        // Add incoming task data
        ...updatedTask
      };
      return {
        ...state,
        tasks: {
          ...state.tasks,
          [id2]: nextTask
        }
      };
    }
    default:
      return state;
  }
}
const INITIAL_STATE$3 = {
  tasks: {}
}, LISTEN_OPTIONS = {
  events: ["welcome", "mutation", "reconnect"],
  includeResult: !0,
  visibility: "query",
  includeAllVersions: !0,
  tag: "tasks-store"
}, SORT_FIELD = "_createdAt", SORT_ORDER = "desc", QUERY_FILTERS = ['_type == "tasks.task"'], QUERY_PROJECTION = `{
  ...,
}`, QUERY_SORT_ORDER = `order(${SORT_FIELD} ${SORT_ORDER})`, QUERY = `*[${QUERY_FILTERS.join(" && ")}] ${QUERY_PROJECTION} | ${QUERY_SORT_ORDER}`;
function useTasksStore(opts) {
  const $ = c(24), {
    client
  } = useAddonDataset(), {
    documentId
  } = opts, [state, dispatch] = useReducer(tasksReducer, INITIAL_STATE$3), [isLoading, setIsLoading] = useState(client !== null), [error, setError] = useState(null);
  let t0;
  $[0] !== documentId ? (t0 = documentId ? getPublishedId(documentId) : null, $[0] = documentId, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 ? (t1 = {
    documentId: t0
  }, $[2] = t0, $[3] = t1) : t1 = $[3];
  const params = t1;
  let t2;
  $[4] !== client || $[5] !== params ? (t2 = async () => {
    if (!client) {
      setIsLoading(!1);
      return;
    }
    try {
      const res = await client.fetch(QUERY, params);
      dispatch({
        type: "TASKS_SET",
        tasks: res
      }), setIsLoading(!1);
    } catch (t32) {
      setError(t32);
    }
  }, $[4] = client, $[5] = params, $[6] = t2) : t2 = $[6];
  const initialFetch = t2;
  let t3;
  $[7] !== initialFetch ? (t3 = async (event) => {
    if (event.type === "welcome" && (setIsLoading(!0), await initialFetch(), setIsLoading(!1)), event.type === "reconnect" && setIsLoading(!0), event.type === "mutation") {
      if (event.transition === "appear") {
        const nextTask = event.result;
        nextTask && dispatch({
          type: "TASK_RECEIVED",
          payload: nextTask
        });
      }
      if (event.transition === "disappear" && dispatch({
        type: "TASK_DELETED",
        id: event.documentId
      }), event.transition === "update") {
        const updatedTask = event.result;
        updatedTask && dispatch({
          type: "TASK_UPDATED",
          payload: updatedTask
        });
      }
    }
  }, $[7] = initialFetch, $[8] = t3) : t3 = $[8];
  const handleListenerEvent = t3;
  let t4;
  bb0: {
    if (!client) {
      let t53;
      $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t53 = of(), $[9] = t53) : t53 = $[9], t4 = t53;
      break bb0;
    }
    let t52;
    if ($[10] !== client.observable || $[11] !== params) {
      let t62;
      $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t62 = (err_0) => (setError(err_0), of(err_0)), $[13] = t62) : t62 = $[13], t52 = client.observable.listen(QUERY, params, LISTEN_OPTIONS).pipe(catchError$1(t62)), $[10] = client.observable, $[11] = params, $[12] = t52;
    } else
      t52 = $[12];
    t4 = t52;
  }
  const listener$ = t4;
  let t5, t6;
  $[14] !== handleListenerEvent || $[15] !== listener$ ? (t5 = () => {
    const sub2 = listener$.subscribe(handleListenerEvent);
    return () => {
      sub2?.unsubscribe();
    };
  }, t6 = [handleListenerEvent, listener$], $[14] = handleListenerEvent, $[15] = listener$, $[16] = t5, $[17] = t6) : (t5 = $[16], t6 = $[17]), useEffect(t5, t6);
  let t7;
  $[18] !== state.tasks ? (t7 = Object.values(state.tasks), $[18] = state.tasks, $[19] = t7) : t7 = $[19];
  const tasksAsArray = t7;
  let t8;
  return $[20] !== error || $[21] !== isLoading || $[22] !== tasksAsArray ? (t8 = {
    data: tasksAsArray,
    dispatch,
    error,
    isLoading
  }, $[20] = error, $[21] = isLoading, $[22] = tasksAsArray, $[23] = t8) : t8 = $[23], t8;
}
const EMPTY_ARRAY$5 = [];
function TasksProvider(props2) {
  const $ = c(11), {
    children
  } = props2, [activeDocument, setActiveDocument] = useState(null);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {}, $[0] = t0) : t0 = $[0];
  const {
    data: t1,
    isLoading
  } = useTasksStore(t0), data = t1 === void 0 ? EMPTY_ARRAY$5 : t1;
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = debounce(setActiveDocument, 1e3), $[1] = t2) : t2 = $[1];
  const debouncedSetActiveDocument = t2;
  let t3;
  $[2] !== data ? (t3 = data ?? [], $[2] = data, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== activeDocument || $[5] !== isLoading || $[6] !== t3 ? (t4 = {
    activeDocument,
    setActiveDocument: debouncedSetActiveDocument,
    isLoading,
    data: t3
  }, $[4] = activeDocument, $[5] = isLoading, $[6] = t3, $[7] = t4) : t4 = $[7];
  const value = t4;
  let t5;
  return $[8] !== children || $[9] !== value ? (t5 = /* @__PURE__ */ jsx(TasksContext.Provider, { value, children }), $[8] = children, $[9] = value, $[10] = t5) : t5 = $[10], t5;
}
function useTasks() {
  const $ = c(1), context = useContext(TasksContext);
  if (!context) {
    let t0;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
      activeDocument: null,
      setActiveDocument: _temp$P,
      data: [],
      isLoading: !1
    }, $[0] = t0) : t0 = $[0], t0;
  }
  return context;
}
function _temp$P() {
  return null;
}
function TasksUpsellProvider(props2) {
  const $ = c(9);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    dataUri: "/journey/tasks",
    feature: "tasks"
  }, $[0] = t0) : t0 = $[0];
  const contextValue = useUpsellContext(t0), t1 = props2.children;
  let t2;
  $[1] !== contextValue ? (t2 = getDialogPropsFromContext(contextValue), $[1] = contextValue, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(UpsellDialog, { ...t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== contextValue || $[6] !== props2.children || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(TasksUpsellContext.Provider, { value: contextValue, children: [
    t1,
    t3
  ] }), $[5] = contextValue, $[6] = props2.children, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
function useTasksUpsell() {
  return useContext(TasksUpsellContext) || FALLBACK_CONTEXT_VALUE;
}
const FALLBACK_CONTEXT_VALUE = {
  upsellData: null,
  handleOpenDialog: () => null,
  handleClose: () => null,
  upsellDialogOpen: !1,
  telemetryLogs: {
    dialogSecondaryClicked: () => null,
    dialogPrimaryClicked: () => null,
    panelViewed: () => null,
    panelDismissed: () => null,
    panelPrimaryClicked: () => null,
    panelSecondaryClicked: () => null
  }
};
function TaskCreateAction() {
  const $ = c(14), {
    handleOpenTasks,
    setViewMode
  } = useTasksNavigation(), {
    enabled,
    mode
  } = useTasksEnabled(), {
    handleOpenDialog
  } = useTasksUpsell();
  let t0;
  $[0] !== handleOpenDialog || $[1] !== handleOpenTasks || $[2] !== mode || $[3] !== setViewMode ? (t0 = () => {
    mode === "upsell" ? handleOpenDialog("document_action") : (handleOpenTasks(), setViewMode({
      type: "create"
    }));
  }, $[0] = handleOpenDialog, $[1] = handleOpenTasks, $[2] = mode, $[3] = setViewMode, $[4] = t0) : t0 = $[4];
  const handleCreateTaskFromDocument = t0, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t1;
  bb0: {
    if (!enabled) {
      t1 = null;
      break bb0;
    }
    let t2;
    $[5] !== t ? (t2 = t("actions.create.text"), $[5] = t, $[6] = t2) : t2 = $[6];
    let t3;
    $[7] !== t ? (t3 = t("actions.create.text"), $[7] = t, $[8] = t3) : t3 = $[8];
    let t4;
    $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = ["paneActions"], $[9] = t4) : t4 = $[9];
    let t5;
    $[10] !== handleCreateTaskFromDocument || $[11] !== t2 || $[12] !== t3 ? (t5 = {
      icon: TaskIcon,
      label: t2,
      title: t3,
      group: t4,
      onHandle: handleCreateTaskFromDocument
    }, $[10] = handleCreateTaskFromDocument, $[11] = t2, $[12] = t3, $[13] = t5) : t5 = $[13], t1 = t5;
  }
  return t1;
}
TaskCreateAction.displayName = "TaskCreateAction";
function SetActiveDocumentInner(document2) {
  const $ = c(6), {
    documentId,
    documentType
  } = document2, isLast = useIsLastPane(), {
    setActiveDocument
  } = useTasks();
  let t0, t1;
  return $[0] !== documentId || $[1] !== documentType || $[2] !== isLast || $[3] !== setActiveDocument ? (t0 = () => (documentId && isLast && documentType && setActiveDocument?.({
    documentId: isVersionId(documentId) ? documentId : getPublishedId(documentId),
    documentType
  }), () => {
    isLast && setActiveDocument?.(null);
  }), t1 = [documentId, documentType, isLast, setActiveDocument], $[0] = documentId, $[1] = documentType, $[2] = isLast, $[3] = setActiveDocument, $[4] = t0, $[5] = t1) : (t0 = $[4], t1 = $[5]), useEffect(t0, t1), null;
}
function SetActiveDocument(document2) {
  const $ = c(2), {
    enabled
  } = useTasksEnabled();
  if (!enabled)
    return null;
  let t0;
  return $[0] !== document2 ? (t0 = /* @__PURE__ */ jsx(SetActiveDocumentInner, { ...document2 }), $[0] = document2, $[1] = t0) : t0 = $[1], t0;
}
function TasksDocumentInputLayout(props2) {
  const $ = c(8), documentId = props2.value?._id, documentType = props2.value?._type;
  let t0;
  $[0] !== documentId || $[1] !== documentType ? (t0 = /* @__PURE__ */ jsx(SetActiveDocument, { documentId, documentType }), $[0] = documentId, $[1] = documentType, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] !== props2 ? (t1 = props2.renderDefault(props2), $[3] = props2, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== t0 || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t0,
    t1
  ] }), $[5] = t0, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
const ButtonContainer = styled.div.withConfig({
  displayName: "ButtonContainer",
  componentId: "sc-s9haa-0"
})`position:relative;[data-ui='Badge']{position:absolute;top:-2px;right:-2px;}`;
function TasksFooterOpenTasks() {
  const $ = c(31), {
    data,
    activeDocument
  } = useTasks(), {
    handleOpenTasks,
    setActiveTab
  } = useTasksNavigation(), mediaIndex = useMediaIndex();
  let t0;
  $[0] !== activeDocument || $[1] !== data ? (t0 = activeDocument?.documentId ? data.filter((item) => item.target?.document._ref === activeDocument.documentId && item.status === "open" && item.createdByUser) : [], $[0] = activeDocument, $[1] = data, $[2] = t0) : t0 = $[2];
  const pendingTasks = t0;
  let t1;
  $[3] !== handleOpenTasks || $[4] !== setActiveTab ? (t1 = () => {
    handleOpenTasks(), setActiveTab("document");
  }, $[3] = handleOpenTasks, $[4] = setActiveTab, $[5] = t1) : t1 = $[5];
  const handleOnClick = t1, {
    t
  } = useTranslation(tasksLocaleNamespace);
  if (pendingTasks.length === 0)
    return null;
  if (mediaIndex < 3) {
    let t22;
    $[6] !== pendingTasks.length || $[7] !== t ? (t22 = t("document.footer.open-tasks.placeholder", {
      count: pendingTasks.length
    }), $[6] = pendingTasks.length, $[7] = t, $[8] = t22) : t22 = $[8];
    let t32;
    $[9] !== t22 ? (t32 = {
      content: t22
    }, $[9] = t22, $[10] = t32) : t32 = $[10];
    let t42;
    $[11] !== handleOnClick || $[12] !== t32 ? (t42 = /* @__PURE__ */ jsx(Button, { mode: "bleed", icon: TaskIcon, size: "large", onClick: handleOnClick, tooltipProps: t32 }), $[11] = handleOnClick, $[12] = t32, $[13] = t42) : t42 = $[13];
    let t52;
    $[14] !== pendingTasks.length ? (t52 = /* @__PURE__ */ jsx(Badge, { "data-testid": "tasks-badge", tone: "primary", fontSize: 0, children: pendingTasks.length }), $[14] = pendingTasks.length, $[15] = t52) : t52 = $[15];
    let t6;
    return $[16] !== t42 || $[17] !== t52 ? (t6 = /* @__PURE__ */ jsxs(ButtonContainer, { children: [
      t42,
      t52
    ] }), $[16] = t42, $[17] = t52, $[18] = t6) : t6 = $[18], t6;
  }
  let t2;
  $[19] !== pendingTasks.length || $[20] !== t ? (t2 = t("document.footer.open-tasks.placeholder", {
    count: pendingTasks.length
  }), $[19] = pendingTasks.length, $[20] = t, $[21] = t2) : t2 = $[21];
  let t3;
  $[22] !== t2 ? (t3 = {
    content: t2
  }, $[22] = t2, $[23] = t3) : t3 = $[23];
  let t4;
  $[24] !== pendingTasks.length || $[25] !== t ? (t4 = t("document.footer.open-tasks.text", {
    count: pendingTasks.length
  }), $[24] = pendingTasks.length, $[25] = t, $[26] = t4) : t4 = $[26];
  let t5;
  return $[27] !== handleOnClick || $[28] !== t3 || $[29] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { mode: "bleed", tooltipProps: t3, text: t4, onClick: handleOnClick }), $[27] = handleOnClick, $[28] = t3, $[29] = t4, $[30] = t5) : t5 = $[30], t5;
}
function getTargetValue({
  documentId,
  documentType,
  dataset,
  projectId
}) {
  return {
    documentType,
    document: {
      _ref: getPublishedId(documentId),
      _type: "crossDatasetReference",
      _dataset: dataset,
      _projectId: projectId,
      _weak: !0
    }
  };
}
function getMentionedUsers(description) {
  if (!description) return [];
  const subscribers2 = [];
  return description?.forEach((block) => {
    isPortableTextTextBlock(block) && block.children.forEach((child) => {
      child._type === "mention" && typeof child.userId == "string" && !subscribers2.includes(child.userId) && subscribers2.push(child.userId);
    });
  }), subscribers2;
}
const API_VERSION = "2024-03-05", TASK_STATUS = [{
  value: "open",
  title: "To Do",
  icon: /* @__PURE__ */ jsx(CircleIcon, {})
}, {
  value: "closed",
  title: "Done",
  icon: /* @__PURE__ */ jsx(CheckmarkCircleIcon, {})
}], FIELDS_TO_GROUP = ["title", "status", "assignedTo", "dueBy", "target", "description"];
function groupChanges(changes) {
  const groupedChanges = [];
  for (const change of changes) {
    const lastChangeProcessed = groupedChanges[groupedChanges.length - 1];
    if (!lastChangeProcessed) {
      groupedChanges.push(change);
      continue;
    }
    if (!FIELDS_TO_GROUP.includes(change.field)) {
      groupedChanges.push(change);
      continue;
    }
    if (lastChangeProcessed.author === change.author && lastChangeProcessed.field === change.field) {
      const lastChangeDate = new Date(lastChangeProcessed.timestamp), changeDate = new Date(change.timestamp);
      if (Math.abs(lastChangeDate.getTime() - changeDate.getTime()) <= 12e4) {
        lastChangeProcessed.to = change.to, lastChangeProcessed.timestamp = change.timestamp;
        continue;
      }
    }
    groupedChanges.push(change);
  }
  return groupedChanges;
}
function omitRev(document2) {
  const {
    _rev,
    ...doc
  } = document2;
  return doc;
}
function trackFieldChanges(newestDocument, transactions, fieldsToTrack) {
  let currentDocument = omitRev(newestDocument);
  const changes = [];
  let previousDocument = currentDocument;
  for (const transaction of transactions) {
    const {
      timestamp,
      effects
    } = transaction, documentId = transaction.documentIDs[0], effect = effects[documentId];
    !effect || !effect.revert || (previousDocument = applyPatch$1(currentDocument, effect.revert), fieldsToTrack.forEach((field) => {
      previousDocument?.[field] !== currentDocument?.[field] && changes.push({
        field,
        from: previousDocument?.[field],
        to: currentDocument?.[field],
        timestamp,
        author: transaction.author
      });
    }), currentDocument = previousDocument);
  }
  const changesSortedByTimestamp = changes.sort((a, b) => a.timestamp.localeCompare(b.timestamp)), createdByUserIndex = changesSortedByTimestamp.findIndex((change) => change.field === "createdByUser");
  return groupChanges(changesSortedByTimestamp.slice(createdByUserIndex + 1));
}
function useActivityLog(task) {
  const $ = c(17);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const [changes, setChanges] = useState(t0);
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    apiVersion: API_VERSION
  }, $[1] = t1) : t1 = $[1];
  const client = useClient(t1), t2 = task?._id ?? "";
  let t3;
  $[2] !== t2 ? (t3 = getPublishedId(t2), $[2] = t2, $[3] = t3) : t3 = $[3];
  const publishedId = t3;
  let t4;
  $[4] !== client || $[5] !== publishedId ? (t4 = async (newestTaskDocument) => {
    try {
      if (!publishedId)
        return;
      const transactions = await getTransactionsLogs(client, publishedId, {
        tag: "sanity.studio.tasks.history",
        effectFormat: "mendoza",
        reverse: !0
      }), fieldsToTrack = ["createdByUser", "title", "description", "dueBy", "assignedTo", "status", "target"], parsedChanges = trackFieldChanges(newestTaskDocument, [...transactions], fieldsToTrack);
      setChanges(parsedChanges);
    } catch (t52) {
      console.error("Failed to fetch and parse activity log", t52);
    }
  }, $[4] = client, $[5] = publishedId, $[6] = t4) : t4 = $[6];
  const fetchAndParse = t4;
  let t5;
  $[7] !== fetchAndParse || $[8] !== task ? (t5 = (_rev) => fetchAndParse(task), $[7] = fetchAndParse, $[8] = task, $[9] = t5) : t5 = $[9];
  const handleFetchAndParse = useEffectEvent(t5);
  let t6;
  $[10] !== handleFetchAndParse || $[11] !== task._rev ? (t6 = () => {
    handleFetchAndParse(task._rev);
  }, $[10] = handleFetchAndParse, $[11] = task._rev, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== task._rev ? (t7 = [task._rev], $[13] = task._rev, $[14] = t7) : t7 = $[14], useEffect(t6, t7);
  let t8;
  return $[15] !== changes ? (t8 = {
    changes
  }, $[15] = changes, $[16] = t8) : t8 = $[16], t8;
}
function useTaskOperations() {
  const $ = c(12), {
    client,
    createAddonDataset
  } = useAddonDataset(), currentUser = useCurrentUser();
  let t0;
  $[0] !== client || $[1] !== createAddonDataset || $[2] !== currentUser ? (t0 = async (payload) => {
    if (!currentUser)
      throw new Error("No current user found. Unable to create task.");
    const task = {
      ...payload,
      authorId: currentUser.id,
      _type: "tasks.task"
    };
    if (!client) {
      const newCreatedClient = await createAddonDataset();
      if (!newCreatedClient)
        throw new Error("No addon client found. Unable to create task.");
      return await newCreatedClient.create(task);
    }
    return await client.create(task);
  }, $[0] = client, $[1] = createAddonDataset, $[2] = currentUser, $[3] = t0) : t0 = $[3];
  const handleCreate = t0;
  let t1;
  $[4] !== client ? (t1 = async (id2, set2) => {
    if (!client)
      throw new Error("No client. Unable to create task.");
    return await client.patch(id2).set(set2).commit();
  }, $[4] = client, $[5] = t1) : t1 = $[5];
  const handleEdit = t1;
  let t2;
  $[6] !== client ? (t2 = async (id_0) => {
    if (!client)
      throw new Error("No client. Unable to create task.");
    await client.delete(id_0);
  }, $[6] = client, $[7] = t2) : t2 = $[7];
  const handleRemove = t2;
  let t3;
  return $[8] !== handleCreate || $[9] !== handleEdit || $[10] !== handleRemove ? (t3 = {
    create: handleCreate,
    edit: handleEdit,
    remove: handleRemove
  }, $[8] = handleCreate, $[9] = handleEdit, $[10] = handleRemove, $[11] = t3) : t3 = $[11], t3;
}
function useRemoveTask(t0) {
  const $ = c(12), {
    id: id2,
    onError,
    onRemoved
  } = t0, [removeStatus, setRemoveStatus] = useState("idle"), [showDialog, setShowDialog] = useState(!1), [error, setError] = useState(null), operations = useTaskOperations();
  let t1;
  $[0] !== id2 || $[1] !== onError || $[2] !== onRemoved || $[3] !== operations ? (t1 = async () => {
    const run = async () => {
      setRemoveStatus("loading"), await operations.remove(id2), onRemoved?.(), setRemoveStatus("idle"), await new Promise(_temp$O), setShowDialog(!1);
    };
    try {
      await run();
    } catch (t22) {
      const e = t22;
      onError?.(e.message), setError(e.message), setRemoveStatus("error");
    }
    setRemoveStatus("idle");
  }, $[0] = id2, $[1] = onError, $[2] = onRemoved, $[3] = operations, $[4] = t1) : t1 = $[4];
  const handleRemove = t1;
  let t2;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setShowDialog(!0);
  }, $[5] = t2) : t2 = $[5];
  const handleOpenDialog = t2;
  let t3;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setShowDialog(!1);
  }, $[6] = t3) : t3 = $[6];
  const handleCloseDialog = t3;
  let t4;
  return $[7] !== error || $[8] !== handleRemove || $[9] !== removeStatus || $[10] !== showDialog ? (t4 = {
    removeStatus,
    showDialog,
    error,
    handleRemove,
    handleOpenDialog,
    handleCloseDialog
  }, $[7] = error, $[8] = handleRemove, $[9] = removeStatus, $[10] = showDialog, $[11] = t4) : t4 = $[11], t4;
}
function _temp$O(resolve) {
  return setTimeout(resolve, 300);
}
const DATE_FORMAT_OPTIONS$1 = {
  month: "long",
  day: "2-digit",
  minute: "2-digit",
  hour: "2-digit",
  second: "2-digit"
}, RELATIVE_TIME_OPTIONS = {
  minimal: !0,
  useTemporalPhrase: !0
}, Strong = styled.strong.withConfig({
  displayName: "Strong",
  componentId: "sc-wah2ag-0"
})`font-weight:600;`, NoWrap = styled.span.withConfig({
  displayName: "NoWrap",
  componentId: "sc-wah2ag-1"
})`white-space:nowrap;`;
function useUpdatedTimeAgo(timestamp) {
  const $ = c(3), date = new Date(timestamp), formattedDate = useDateTimeFormat(DATE_FORMAT_OPTIONS$1).format(date), updatedTimeAgo = useRelativeTime(date || "", RELATIVE_TIME_OPTIONS);
  let t0;
  return $[0] !== formattedDate || $[1] !== updatedTimeAgo ? (t0 = {
    timeAgo: updatedTimeAgo,
    formattedDate
  }, $[0] = formattedDate, $[1] = updatedTimeAgo, $[2] = t0) : t0 = $[2], t0;
}
function UserName(t0) {
  const $ = c(3), {
    userId
  } = t0, [user, isLoading] = useUser(userId);
  let t1;
  return $[0] !== isLoading || $[1] !== user?.displayName ? (t1 = isLoading ? /* @__PURE__ */ jsx(TextSkeleton, { style: {
    width: "15ch"
  } }) : /* @__PURE__ */ jsx(Strong, { children: user?.displayName }), $[0] = isLoading, $[1] = user?.displayName, $[2] = t1) : t1 = $[2], t1;
}
const DUE_BY_DATE_OPTIONS$1 = {
  month: "short",
  day: "numeric",
  timeZone: "UTC"
};
function DueByChange(t0) {
  const $ = c(2), {
    date
  } = t0, dueBy = new Date(date), formattedDate = useDateTimeFormat(DUE_BY_DATE_OPTIONS$1).format(dueBy);
  let t1;
  return $[0] !== formattedDate ? (t1 = /* @__PURE__ */ jsx(Strong, { children: /* @__PURE__ */ jsx(NoWrap, { children: formattedDate }) }), $[0] = formattedDate, $[1] = t1) : t1 = $[1], t1;
}
const LinkWrapper = styled.span.withConfig({
  displayName: "LinkWrapper",
  componentId: "sc-wah2ag-2"
})`> a{color:var(--card-fg-muted-color);text-decoration:underline;text-underline-offset:1px;font-weight:600;}`;
function TargetContentChange(t0) {
  const $ = c(11), {
    target
  } = t0, schema2 = useSchema(), documentId = target.document._ref, documentType = target.documentType, documentSchema = schema2.get(documentType), {
    perspectiveStack
  } = usePerspective();
  let t1;
  $[0] !== documentId || $[1] !== documentType || $[2] !== perspectiveStack ? (t1 = {
    documentId,
    documentType,
    perspectiveStack
  }, $[0] = documentId, $[1] = documentType, $[2] = perspectiveStack, $[3] = t1) : t1 = $[3];
  const {
    isLoading,
    value
  } = useDocumentPreviewValues(t1);
  if (isLoading) {
    let t22;
    return $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(TextSkeleton, { style: {
      width: "15ch"
    } }), $[4] = t22) : t22 = $[4], t22;
  }
  if (!documentSchema)
    return null;
  let t2;
  $[5] !== documentId || $[6] !== documentType ? (t2 = {
    id: documentId,
    type: documentType
  }, $[5] = documentId, $[6] = documentType, $[7] = t2) : t2 = $[7];
  const t3 = value?.title;
  let t4;
  return $[8] !== t2 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(LinkWrapper, { children: /* @__PURE__ */ jsx(IntentLink, { intent: "edit", params: t2, children: t3 }) }), $[8] = t2, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
}
function getChangeDetails(activity) {
  switch (activity.field) {
    case "status": {
      const statusTitle = TASK_STATUS.find((s) => s.value === activity.to)?.title;
      return {
        text: "changed status to",
        icon: TASK_STATUS.find((s) => s.value === activity.to)?.icon || /* @__PURE__ */ jsx(CircleIcon, {}),
        changeTo: /* @__PURE__ */ jsx(Strong, { children: statusTitle })
      };
    }
    case "target":
      return activity.to ? {
        text: "set target content to",
        icon: /* @__PURE__ */ jsx(LinkIcon, {}),
        changeTo: /* @__PURE__ */ jsx(TargetContentChange, { target: activity.to })
      } : {
        text: "removed target content",
        icon: /* @__PURE__ */ jsx(LinkIcon, {}),
        changeTo: void 0
      };
    case "dueBy":
      return activity.from ? activity.to ? {
        text: "changed the due date to",
        icon: /* @__PURE__ */ jsx(CalendarIcon, {}),
        changeTo: /* @__PURE__ */ jsx(DueByChange, { date: activity.to })
      } : {
        text: "removed the due date",
        icon: /* @__PURE__ */ jsx(CalendarIcon, {}),
        changeTo: void 0
      } : {
        text: "set the due date to",
        icon: /* @__PURE__ */ jsx(CalendarIcon, {}),
        changeTo: /* @__PURE__ */ jsx(DueByChange, { date: activity.to })
      };
    case "assignedTo":
      return activity.to ? {
        text: "assigned to",
        icon: /* @__PURE__ */ jsx(UserIcon, {}),
        changeTo: /* @__PURE__ */ jsx(UserName, { userId: activity.to })
      } : {
        text: "unassigned this task",
        icon: /* @__PURE__ */ jsx(UserIcon, {}),
        changeTo: void 0
      };
    case "description":
      return {
        text: "updated the task description",
        icon: /* @__PURE__ */ jsx(EditIcon, {}),
        changeTo: void 0
      };
    case "title":
      return {
        text: "updated the task title",
        icon: /* @__PURE__ */ jsx(EditIcon, {}),
        changeTo: void 0
      };
    default:
      return {
        text: "",
        icon: /* @__PURE__ */ jsx(CircleIcon, {})
      };
  }
}
const EditedAt = memo(function(props2) {
  const $ = c(20), {
    activity
  } = props2, {
    formattedDate,
    timeAgo
  } = useUpdatedTimeAgo(activity.timestamp);
  let t0;
  $[0] !== activity ? (t0 = getChangeDetails(activity), $[0] = activity, $[1] = t0) : t0 = $[1];
  const {
    icon,
    text,
    changeTo
  } = t0;
  let t1;
  $[2] !== icon ? (t1 = /* @__PURE__ */ jsx(Box, { marginTop: 1, marginLeft: 1, marginRight: 3, children: /* @__PURE__ */ jsx(Box, { marginRight: 1, children: /* @__PURE__ */ jsx(Text$1, { children: icon }) }) }), $[2] = icon, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== activity.author ? (t2 = /* @__PURE__ */ jsx(UserName, { userId: activity.author }), $[4] = activity.author, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== formattedDate || $[7] !== timeAgo ? (t3 = /* @__PURE__ */ jsx(NoWrap, { children: /* @__PURE__ */ jsx("time", { dateTime: formattedDate, children: timeAgo }) }), $[6] = formattedDate, $[7] = timeAgo, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== formattedDate || $[10] !== t3 ? (t4 = /* @__PURE__ */ jsx(Tooltip, { content: formattedDate, placement: "top-end", children: t3 }), $[9] = formattedDate, $[10] = t3, $[11] = t4) : t4 = $[11];
  let t5;
  $[12] !== changeTo || $[13] !== t2 || $[14] !== t4 || $[15] !== text ? (t5 = /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
    t2,
    " ",
    text,
    " ",
    changeTo,
    " \u2022",
    " ",
    t4
  ] }), $[12] = changeTo, $[13] = t2, $[14] = t4, $[15] = text, $[16] = t5) : t5 = $[16];
  let t6;
  return $[17] !== t1 || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t1,
    t5
  ] }), $[17] = t1, $[18] = t5, $[19] = t6) : t6 = $[19], t6;
}, (prevProps, nextProps) => prevProps.activity.timestamp === nextProps.activity.timestamp), AvatarRoot = /* @__PURE__ */ styled.div.withConfig({
  displayName: "AvatarRoot",
  componentId: "sc-nls8jj-0"
})((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
      min-height: ${theme.avatar.sizes[props2.$size]?.size}px;
      min-width: ${theme.avatar.sizes[props2.$size]?.size}px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      ${props2.$border ? "box-shadow: inset 0 0 0 1px var(--card-border-color);" : ""};
      ${props2.$removeBg ? "--card-avatar-gray-bg-color: transparent;" : ""}
    `;
});
function TasksUserAvatar(props2) {
  const $ = c(27), {
    user,
    size: t0,
    border: t1
  } = props2, size = t0 === void 0 ? 0 : t0, border = t1 === void 0 ? !0 : t1, [loadedUser, loading] = useUser(user?.id || "");
  if (loading) {
    let t22;
    return $[0] !== size ? (t22 = /* @__PURE__ */ jsx(AvatarSkeleton$1, { $size: size, animated: !0 }), $[0] = size, $[1] = t22) : t22 = $[1], t22;
  }
  if (!user || !loadedUser) {
    let t22;
    $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(UserIcon, {}), $[2] = t22) : t22 = $[2];
    let t32;
    $[3] !== size ? (t32 = /* @__PURE__ */ jsx(Text$1, { size, children: t22 }), $[3] = size, $[4] = t32) : t32 = $[4];
    let t42;
    return $[5] !== border || $[6] !== size || $[7] !== t32 ? (t42 = /* @__PURE__ */ jsx(AvatarRoot, { $size: size, $border: border, children: t32 }), $[5] = border, $[6] = size, $[7] = t32, $[8] = t42) : t42 = $[8], t42;
  }
  const t2 = !props2.withTooltip;
  let t3;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = ["top", "top-start"], $[9] = t3) : t3 = $[9];
  const t4 = !!loadedUser?.imageUrl;
  let t5;
  $[10] !== loadedUser.imageUrl ? (t5 = loadedUser?.imageUrl ? {
    color: void 0
  } : {}, $[10] = loadedUser.imageUrl, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== props2.withTooltip ? (t6 = props2.withTooltip ? {
    title: null
  } : {}, $[12] = props2.withTooltip, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== loadedUser || $[15] !== size || $[16] !== t5 || $[17] !== t6 ? (t7 = /* @__PURE__ */ jsx(UserAvatar, { user: loadedUser, size, ...t5, ...t6 }), $[14] = loadedUser, $[15] = size, $[16] = t5, $[17] = t6, $[18] = t7) : t7 = $[18];
  let t8;
  $[19] !== size || $[20] !== t4 || $[21] !== t7 ? (t8 = /* @__PURE__ */ jsx(AvatarRoot, { $size: size, $removeBg: t4, children: t7 }), $[19] = size, $[20] = t4, $[21] = t7, $[22] = t8) : t8 = $[22];
  let t9;
  return $[23] !== loadedUser.displayName || $[24] !== t2 || $[25] !== t8 ? (t9 = /* @__PURE__ */ jsx(Tooltip, { content: loadedUser.displayName, disabled: t2, portal: !0, fallbackPlacements: t3, placement: "top-end", children: t8 }), $[23] = loadedUser.displayName, $[24] = t2, $[25] = t8, $[26] = t9) : t9 = $[26], t9;
}
const ActivityChildrenRoot = styled(Flex).withConfig({
  displayName: "ActivityChildrenRoot",
  componentId: "sc-ymm4s0-0"
})`height:100%;`, ActivityItemChildrenContainer = styled.div.withConfig({
  displayName: "ActivityItemChildrenContainer",
  componentId: "sc-ymm4s0-1"
})`width:100%;`;
function ActivityItem(t0) {
  const $ = c(10), {
    avatarPaddingTop: t1,
    userId,
    children
  } = t0, avatarPaddingTop = t1 === void 0 ? 1 : t1;
  let t2;
  $[0] !== userId ? (t2 = /* @__PURE__ */ jsx(TasksUserAvatar, { user: {
    id: userId
  }, size: 0 }), $[0] = userId, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== avatarPaddingTop || $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { marginRight: 3, paddingTop: avatarPaddingTop, children: t2 }), $[2] = avatarPaddingTop, $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== children ? (t4 = /* @__PURE__ */ jsx(ActivityChildrenRoot, { align: "center", flex: 1, children: /* @__PURE__ */ jsx(ActivityItemChildrenContainer, { children }) }), $[5] = children, $[6] = t4) : t4 = $[6];
  let t5;
  return $[7] !== t3 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { children: [
    t3,
    t4
  ] }), $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9], t5;
}
function TasksActivityCommentInput(props2) {
  const $ = c(25), {
    mentionOptions,
    currentUser,
    onSubmit
  } = props2, {
    mode
  } = useTasksEnabled(), [value, setValue] = useState(null), editorRef = useRef(null);
  let t0;
  $[0] !== value ? (t0 = hasCommentMessageValue(value), $[0] = value, $[1] = t0) : t0 = $[1];
  const hasValue2 = t0;
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (nextValue) => {
    setValue(nextValue);
  }, $[2] = t1) : t1 = $[2];
  const handleChange = t1;
  let t2;
  $[3] !== hasValue2 || $[4] !== onSubmit || $[5] !== value ? (t2 = () => {
    hasValue2 && (onSubmit(value), setValue(null));
  }, $[3] = hasValue2, $[4] = onSubmit, $[5] = value, $[6] = t2) : t2 = $[6];
  const handleSubmit = t2;
  let t3;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    editorRef.current?.discardDialogController.close();
  }, $[7] = t3) : t3 = $[7];
  const handleDiscardCancel = t3;
  let t4;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    editorRef.current?.discardDialogController.close(), setValue(null);
  }, $[8] = t4) : t4 = $[8];
  const handleDiscardConfirm = t4;
  let t5;
  $[9] !== hasValue2 ? (t5 = (e) => {
    e.key === "Escape" && (e.preventDefault(), e.stopPropagation(), hasValue2 ? editorRef.current?.discardDialogController.open() : (editorRef.current?.discardDialogController.close(), setValue(null)));
  }, $[9] = hasValue2, $[10] = t5) : t5 = $[10];
  const handleKeyDown = t5, {
    t
  } = useTranslation(tasksLocaleNamespace), t6 = mode === "upsell";
  let t7;
  $[11] !== mode || $[12] !== t ? (t7 = t(mode === "upsell" ? "panel.comment.placeholder.upsell" : "panel.comment.placeholder"), $[11] = mode, $[12] = t, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== currentUser || $[15] !== handleKeyDown || $[16] !== handleSubmit || $[17] !== mentionOptions || $[18] !== t6 || $[19] !== t7 || $[20] !== value ? (t8 = /* @__PURE__ */ jsx(Card, { tone: "transparent", radius: 3, padding: 2, children: /* @__PURE__ */ jsx(CommentInput, { withAvatar: !1, currentUser, expandOnFocus: !0, mentionOptions, onChange: handleChange, onDiscardConfirm: handleDiscardConfirm, onDiscardCancel: handleDiscardCancel, onKeyDown: handleKeyDown, onSubmit: handleSubmit, readOnly: t6, placeholder: t7, ref: editorRef, value }) }), $[14] = currentUser, $[15] = handleKeyDown, $[16] = handleSubmit, $[17] = mentionOptions, $[18] = t6, $[19] = t7, $[20] = value, $[21] = t8) : t8 = $[21];
  let t9;
  return $[22] !== currentUser.id || $[23] !== t8 ? (t9 = /* @__PURE__ */ jsx(ActivityItem, { userId: currentUser.id, avatarPaddingTop: 3, children: t8 }), $[22] = currentUser.id, $[23] = t8, $[24] = t9) : t9 = $[24], t9;
}
const COMMENTS_LIST_ITEM_AVATAR_CONFIG = {
  parentCommentAvatar: !1,
  threadCommentsAvatar: !0,
  replyAvatar: !0,
  avatarSize: 0
}, CommentListItemRoot = /* @__PURE__ */ styled.div.withConfig({
  displayName: "CommentListItemRoot",
  componentId: "sc-noev9t-0"
})((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    [data-ui='CommentsListItem'] {
      padding-right: ${theme.space[2]}px;
    }

    // Increase the padding when the comment input is focused
    [data-ui='CommentInputEditableWrap']:focus-within {
      padding-bottom: ${theme.space[2]}px;
    }
  `;
});
function TasksActivityCommentItem(props2) {
  const $ = c(6), {
    parentComment
  } = props2, {
    mode
  } = useTasksEnabled(), t0 = mode ?? "default";
  let t1;
  $[0] !== props2 || $[1] !== t0 ? (t1 = /* @__PURE__ */ jsx(CommentListItemRoot, { children: /* @__PURE__ */ jsx(CommentsListItem, { ...props2, avatarConfig: COMMENTS_LIST_ITEM_AVATAR_CONFIG, canReply: !0, isSelected: !1, mode: t0 }) }), $[0] = props2, $[1] = t0, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== parentComment.authorId || $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(ActivityItem, { userId: parentComment.authorId, avatarPaddingTop: 3, children: t1 }), $[3] = parentComment.authorId, $[4] = t1, $[5] = t2) : t2 = $[5], t2;
}
const UserSkeleton = styled(TextSkeleton).withConfig({
  displayName: "UserSkeleton",
  componentId: "sc-i297zw-0"
})`max-width:15ch;width:'100%';`, TasksActivityCreatedAt = memo(function(props2) {
  const $ = c(22), {
    createdAt,
    authorId
  } = props2, [user, loading] = useUser(authorId), {
    timeAgo,
    formattedDate
  } = useUpdatedTimeAgo(createdAt), {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    fontWeight: 600
  }, $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== loading || $[2] !== t || $[3] !== user?.displayName ? (t1 = loading ? /* @__PURE__ */ jsx(UserSkeleton, {}) : user?.displayName ?? t("panel.activity.unknown-user"), $[1] = loading, $[2] = t, $[3] = user?.displayName, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== t1 ? (t2 = /* @__PURE__ */ jsxs("strong", { style: t0, children: [
    t1,
    " "
  ] }), $[5] = t1, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] !== t ? (t3 = t("panel.activity.created-fragment"), $[7] = t, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== createdAt || $[10] !== timeAgo ? (t4 = /* @__PURE__ */ jsx(NoWrap, { children: /* @__PURE__ */ jsx("time", { dateTime: createdAt, children: timeAgo }) }), $[9] = createdAt, $[10] = timeAgo, $[11] = t4) : t4 = $[11];
  let t5;
  $[12] !== formattedDate || $[13] !== t4 ? (t5 = /* @__PURE__ */ jsx(Tooltip, { content: formattedDate, placement: "top-end", children: t4 }), $[12] = formattedDate, $[13] = t4, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] !== t2 || $[16] !== t3 || $[17] !== t5 ? (t6 = /* @__PURE__ */ jsx(Flex, { align: "center", paddingTop: 1, children: /* @__PURE__ */ jsxs(Text$1, { size: 1, muted: !0, children: [
    t2,
    t3,
    " \u2022",
    " ",
    t5
  ] }) }), $[15] = t2, $[16] = t3, $[17] = t5, $[18] = t6) : t6 = $[18];
  let t7;
  return $[19] !== authorId || $[20] !== t6 ? (t7 = /* @__PURE__ */ jsx(ActivityItem, { userId: authorId, children: t6 }), $[19] = authorId, $[20] = t6, $[21] = t7) : t7 = $[21], t7;
}, (prevProps, nextProps) => prevProps.createdAt === nextProps.createdAt);
function TasksSubscribers(props2) {
  const $ = c(13), {
    value,
    onChange,
    path,
    currentUserId
  } = props2, buttonText = value.subscribers?.includes(currentUserId) ? "Unsubscribe" : "Subscribe";
  let t0;
  $[0] !== currentUserId || $[1] !== onChange || $[2] !== path || $[3] !== value.subscribers ? (t0 = () => {
    const subscribers2 = value.subscribers || [];
    subscribers2.includes(currentUserId) || onChange(set(subscribers2.concat(currentUserId), path)), subscribers2.includes(currentUserId) && onChange(set(subscribers2.filter((subscriberId) => subscriberId !== currentUserId), path));
  }, $[0] = currentUserId, $[1] = onChange, $[2] = path, $[3] = value.subscribers, $[4] = t0) : t0 = $[4];
  const handleToggleSubscribe = t0;
  let t1;
  $[5] !== buttonText || $[6] !== handleToggleSubscribe ? (t1 = /* @__PURE__ */ jsx(Button, { mode: "bleed", text: buttonText, onClick: handleToggleSubscribe }), $[5] = buttonText, $[6] = handleToggleSubscribe, $[7] = t1) : t1 = $[7];
  let t2;
  $[8] !== value.subscribers ? (t2 = value.subscribers && value.subscribers?.length > 0 && /* @__PURE__ */ jsx(TasksSubscriberAvatars, { subscriberIds: value.subscribers }), $[8] = value.subscribers, $[9] = t2) : t2 = $[9];
  let t3;
  return $[10] !== t1 || $[11] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", children: [
    t1,
    t2
  ] }), $[10] = t1, $[11] = t2, $[12] = t3) : t3 = $[12], t3;
}
const EMPTY_ARRAY$4 = [];
function TasksSubscriberAvatars(props2) {
  const $ = c(6), {
    subscriberIds: subscriberIdsProp
  } = props2;
  let t0;
  $[0] !== subscriberIdsProp ? (t0 = subscriberIdsProp?.filter(Boolean) || EMPTY_ARRAY$4, $[0] = subscriberIdsProp, $[1] = t0) : t0 = $[1];
  const subscriberIds = t0;
  let t1;
  $[2] !== subscriberIds ? (t1 = subscriberIds.map(_temp$N), $[2] = subscriberIds, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(AnimatePresence, { initial: !1, children: /* @__PURE__ */ jsx(AvatarStack, { maxLength: 3, size: 0, children: t1 }) }), $[4] = t1, $[5] = t2) : t2 = $[5], t2;
}
function _temp$N(subscriberId) {
  return /* @__PURE__ */ jsx(motion.div, { exit: {
    opacity: 0,
    x: "2px",
    scale: 0.9
  }, animate: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      type: "spring",
      visualDuration: 0.2
    }
  }, initial: {
    opacity: 0,
    x: "2px",
    scale: 0.9
  }, children: /* @__PURE__ */ jsx(TasksUserAvatar, { user: {
    id: subscriberId
  }, size: 0 }) }, subscriberId);
}
const EMPTY_ARRAY$3 = [], VARIANTS$1 = {
  hidden: {
    opacity: 0,
    x: 0
  },
  visible: {
    opacity: 1,
    x: 0
  }
}, MotionStack = styled(motion.create(Stack)).withConfig({
  displayName: "MotionStack",
  componentId: "sc-e0lmf7-0"
})``;
function TasksActivityLog(props2) {
  const $ = c(79), {
    value,
    onChange,
    path,
    activityData: t0
  } = props2;
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const activityData = t1, currentUser = useCurrentUser(), {
    title: workspaceTitle,
    basePath,
    name: workspaceName
  } = useWorkspace(), {
    comments: comments2,
    mentionOptions,
    operation,
    getComment
  } = useComments(), [commentToDeleteId, setCommentToDeleteId] = useState(null), [commentDeleteError, setCommentDeleteError] = useState(null), [commentDeleteLoading, setCommentDeleteLoading] = useState(!1), loading = comments2.loading, taskComments = comments2.data.open;
  let t2;
  $[2] !== basePath || $[3] !== value._id || $[4] !== value.subscribers || $[5] !== value.title || $[6] !== workspaceName || $[7] !== workspaceTitle ? (t2 = (message, commentId) => {
    const studioUrl = new URL(`${window.location.origin}${basePath ? `${basePath}/` : ""}`);
    studioUrl.searchParams.set(TASKS_SIDEBAR_SEARCH_PARAM, "tasks"), studioUrl.searchParams.set(TASKS_SELECTED_TASK_SEARCH_PARAM, value?._id), studioUrl.searchParams.set(TASKS_VIEW_MODE_SEARCH_PARAM, "edit"), studioUrl.searchParams.set("commentId", commentId);
    const mentionedUsers = getMentionedUsers(message), subscribers2 = Array.from(/* @__PURE__ */ new Set([...value.subscribers || [], ...mentionedUsers]));
    return {
      documentTitle: value.title || "Sanity task",
      url: studioUrl.toString(),
      workspaceTitle,
      workspaceName,
      subscribers: subscribers2
    };
  }, $[2] = basePath, $[3] = value._id, $[4] = value.subscribers, $[5] = value.title, $[6] = workspaceName, $[7] = workspaceTitle, $[8] = t2) : t2 = $[8];
  const handleGetNotificationValue = t2;
  let t3;
  $[9] !== handleGetNotificationValue || $[10] !== onChange || $[11] !== operation ? (t3 = async (message_0) => {
    const commentId_0 = uuid(), notification = handleGetNotificationValue(message_0, commentId_0), nextComment = {
      id: commentId_0,
      type: "task",
      message: message_0,
      parentCommentId: void 0,
      reactions: EMPTY_ARRAY$3,
      status: "open",
      threadId: uuid(),
      context: {
        notification
      }
    };
    onChange(set(notification.subscribers, ["subscribers"])), await operation.create(nextComment);
  }, $[9] = handleGetNotificationValue, $[10] = onChange, $[11] = operation, $[12] = t3) : t3 = $[12];
  const handleCommentCreate = t3;
  let t4;
  $[13] !== handleGetNotificationValue || $[14] !== onChange || $[15] !== operation ? (t4 = async (nextComment_0) => {
    const commentId_1 = uuid(), notification_0 = handleGetNotificationValue(nextComment_0.message, commentId_1);
    onChange(set(notification_0.subscribers, ["subscribers"])), await operation.create({
      id: commentId_1,
      type: "task",
      message: nextComment_0.message,
      parentCommentId: nextComment_0.parentCommentId,
      reactions: EMPTY_ARRAY$3,
      status: "open",
      threadId: nextComment_0.threadId,
      context: {
        notification: notification_0
      }
    });
  }, $[13] = handleGetNotificationValue, $[14] = onChange, $[15] = operation, $[16] = t4) : t4 = $[16];
  const handleCommentReply = t4;
  let t5;
  $[17] !== getComment || $[18] !== handleGetNotificationValue || $[19] !== onChange || $[20] !== operation ? (t5 = async (id2) => {
    const comment = getComment(id2);
    if (!comment)
      return;
    const notification_1 = handleGetNotificationValue(comment.message, comment._id);
    onChange(set(notification_1.subscribers, ["subscribers"])), await operation.create({
      type: "task",
      id: comment._id,
      message: comment.message,
      parentCommentId: comment.parentCommentId,
      reactions: comment.reactions || EMPTY_ARRAY$3,
      status: comment.status,
      threadId: comment.threadId,
      context: {
        notification: notification_1
      }
    });
  }, $[17] = getComment, $[18] = handleGetNotificationValue, $[19] = onChange, $[20] = operation, $[21] = t5) : t5 = $[21];
  const handleCommentCreateRetry = t5;
  let t6;
  $[22] !== operation ? (t6 = async (id_0, reaction) => {
    await operation.react(id_0, reaction);
  }, $[22] = operation, $[23] = t6) : t6 = $[23];
  const handleCommentReact = t6;
  let t7;
  $[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = (id_1) => setCommentToDeleteId(id_1), $[24] = t7) : t7 = $[24];
  const handleDeleteCommentStart = t7;
  let t8;
  $[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = () => setCommentToDeleteId(null), $[25] = t8) : t8 = $[25];
  const handleDeleteCommentCancel = t8;
  let t9;
  $[26] !== operation ? (t9 = async (id_2) => {
    try {
      setCommentDeleteLoading(!0), setCommentDeleteError(null), await operation.remove(id_2), setCommentToDeleteId(null);
    } catch (t102) {
      setCommentDeleteError(t102);
    }
    setCommentDeleteLoading(!1);
  }, $[26] = operation, $[27] = t9) : t9 = $[27];
  const handleDeleteCommentConfirm = t9;
  let t10;
  $[28] !== operation ? (t10 = async (id_3, next) => {
    await operation.update(id_3, next);
  }, $[28] = operation, $[29] = t10) : t10 = $[29];
  const handleCommentEdit = t10;
  let t11;
  if ($[30] !== activityData || $[31] !== taskComments) {
    const taskActivity = activityData.map(_temp$M), commentsActivity = taskComments.map(_temp2$i);
    t11 = taskActivity.concat(commentsActivity).sort(_temp3$8), $[30] = activityData, $[31] = taskComments, $[32] = t11;
  } else
    t11 = $[32];
  const activity = t11, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t12;
  if ($[33] !== commentToDeleteId || $[34] !== taskComments) {
    let t132;
    $[36] !== commentToDeleteId ? (t132 = (c2) => c2.parentComment?._id === commentToDeleteId, $[36] = commentToDeleteId, $[37] = t132) : t132 = $[37], t12 = taskComments.find(t132), $[33] = commentToDeleteId, $[34] = taskComments, $[35] = t12;
  } else
    t12 = $[35];
  const parent = t12, commentToDeleteIsParent = !!(parent && parent?.replies?.length > 0);
  let t13;
  $[38] !== commentDeleteError || $[39] !== commentDeleteLoading || $[40] !== commentToDeleteId || $[41] !== commentToDeleteIsParent || $[42] !== handleDeleteCommentConfirm ? (t13 = commentToDeleteId && /* @__PURE__ */ jsx(CommentDeleteDialog, { commentId: commentToDeleteId, error: commentDeleteError, isParent: commentToDeleteIsParent, loading: commentDeleteLoading, onClose: handleDeleteCommentCancel, onConfirm: handleDeleteCommentConfirm }), $[38] = commentDeleteError, $[39] = commentDeleteLoading, $[40] = commentToDeleteId, $[41] = commentToDeleteIsParent, $[42] = handleDeleteCommentConfirm, $[43] = t13) : t13 = $[43];
  let t14;
  $[44] !== t ? (t14 = t("panel.activity.title"), $[44] = t, $[45] = t14) : t14 = $[45];
  let t15;
  $[46] !== t14 ? (t15 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 2, weight: "semibold", children: t14 }) }), $[46] = t14, $[47] = t15) : t15 = $[47];
  let t16;
  $[48] !== currentUser || $[49] !== onChange || $[50] !== path || $[51] !== value ? (t16 = currentUser?.id && /* @__PURE__ */ jsx(TasksSubscribers, { currentUserId: currentUser.id, value, onChange, path }), $[48] = currentUser, $[49] = onChange, $[50] = path, $[51] = value, $[52] = t16) : t16 = $[52];
  let t17;
  $[53] !== t15 || $[54] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t15,
    t16
  ] }), $[53] = t15, $[54] = t16, $[55] = t17) : t17 = $[55];
  let t18;
  $[56] !== loading ? (t18 = loading && /* @__PURE__ */ jsx(LoadingBlock, { showText: !0, title: "Loading activity" }), $[56] = loading, $[57] = t18) : t18 = $[57];
  let t19;
  $[58] !== activity || $[59] !== currentUser || $[60] !== handleCommentCreate || $[61] !== handleCommentCreateRetry || $[62] !== handleCommentEdit || $[63] !== handleCommentReact || $[64] !== handleCommentReply || $[65] !== loading || $[66] !== mentionOptions || $[67] !== value.authorId || $[68] !== value.createdByUser ? (t19 = !loading && /* @__PURE__ */ jsxs(MotionStack, { animate: "visible", initial: "hidden", space: 4, variants: VARIANTS$1, children: [
    value.createdByUser && /* @__PURE__ */ jsx(Stack, { paddingBottom: 1, children: /* @__PURE__ */ jsx(TasksActivityCreatedAt, { createdAt: value.createdByUser, authorId: value.authorId }) }),
    currentUser && /* @__PURE__ */ jsxs(Stack, { space: 4, marginTop: 1, children: [
      activity.map((item_0) => item_0._type === "activity" ? /* @__PURE__ */ jsx(EditedAt, { activity: item_0.payload }, item_0.timestamp) : /* @__PURE__ */ jsx(TasksActivityCommentItem, { currentUser, mentionOptions, onCreateRetry: handleCommentCreateRetry, onDelete: handleDeleteCommentStart, onEdit: handleCommentEdit, onReactionSelect: handleCommentReact, onReply: handleCommentReply, parentComment: item_0.payload.parentComment, replies: item_0.payload.replies }, item_0.payload.parentComment._id)),
      /* @__PURE__ */ jsx(TasksActivityCommentInput, { currentUser, mentionOptions, onSubmit: handleCommentCreate })
    ] })
  ] }), $[58] = activity, $[59] = currentUser, $[60] = handleCommentCreate, $[61] = handleCommentCreateRetry, $[62] = handleCommentEdit, $[63] = handleCommentReact, $[64] = handleCommentReply, $[65] = loading, $[66] = mentionOptions, $[67] = value.authorId, $[68] = value.createdByUser, $[69] = t19) : t19 = $[69];
  let t20;
  $[70] !== t19 ? (t20 = /* @__PURE__ */ jsx(AnimatePresence, { children: t19 }), $[70] = t19, $[71] = t20) : t20 = $[71];
  let t21;
  $[72] !== t17 || $[73] !== t18 || $[74] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Stack, { space: 5, children: [
    t17,
    t18,
    t20
  ] }), $[72] = t17, $[73] = t18, $[74] = t20, $[75] = t21) : t21 = $[75];
  let t22;
  return $[76] !== t13 || $[77] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t13,
    t21
  ] }), $[76] = t13, $[77] = t21, $[78] = t22) : t22 = $[78], t22;
}
function _temp3$8(a, b) {
  return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
}
function _temp2$i(comment_0) {
  return {
    _type: "comment",
    payload: comment_0,
    timestamp: comment_0.parentComment._createdAt
  };
}
function _temp$M(item) {
  return {
    _type: "activity",
    payload: item,
    timestamp: item.timestamp
  };
}
function MentionUserMenuItem(props2) {
  const $ = c(21), {
    user,
    onSelect,
    pressed
  } = props2, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t0;
  $[0] !== onSelect || $[1] !== user.id ? (t0 = () => onSelect(user.id), $[0] = onSelect, $[1] = user.id, $[2] = t0) : t0 = $[2];
  const handleSelect = t0, t1 = !user.granted, t2 = user.id ? user : void 0;
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(TasksUserAvatar, { user: t2, size: 1 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== user.displayName ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", title: user.displayName, children: user.displayName }), $[5] = user.displayName, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t3 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, flex: 1, children: [
    t3,
    t4
  ] }), $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t || $[11] !== user.granted ? (t6 = !user.granted && /* @__PURE__ */ jsx(Badge, { fontSize: 1, mode: "outline", children: t("form.input.assignee.unauthorized.text") }), $[10] = t, $[11] = user.granted, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== t5 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t5,
    t6
  ] }), $[13] = t5, $[14] = t6, $[15] = t7) : t7 = $[15];
  let t8;
  return $[16] !== handleSelect || $[17] !== pressed || $[18] !== t1 || $[19] !== t7 ? (t8 = /* @__PURE__ */ jsx(MenuItem$1, { onClick: handleSelect, padding: 1, disabled: t1, pressed, children: t7 }), $[16] = handleSelect, $[17] = pressed, $[18] = t1, $[19] = t7, $[20] = t8) : t8 = $[20], t8;
}
const StyledMenu$5 = styled(Menu).withConfig({
  displayName: "StyledMenu",
  componentId: "sc-195clky-0"
})`width:308px;border-radius:3px;`, IGNORED_KEYS = ["Control", "Shift", "Alt", "Enter", "Home", "End", "PageUp", "PageDown", "Meta", "Tab", "CapsLock"], NO_ASSIGNEE_OPTION = {
  id: "",
  displayName: "No assignee",
  granted: !0
};
function MentionsMenu(t0) {
  const $ = c(29), {
    onSelect,
    value: t1
  } = t0, value = t1 === void 0 ? "" : t1, [searchTerm, setSearchTerm] = useState(""), {
    mentionOptions
  } = useMentionUser(), inputRef = useRef(null);
  let t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = [NO_ASSIGNEE_OPTION], $[0] = t2) : t2 = $[0];
  let t3;
  $[1] !== mentionOptions.data ? (t3 = t2.concat(mentionOptions.data || []), $[1] = mentionOptions.data, $[2] = t3) : t3 = $[2];
  const options = t3;
  let t4;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = (event) => {
    setSearchTerm(event.currentTarget.value);
  }, $[3] = t4) : t4 = $[3];
  const handleSearchChange = t4;
  let t5;
  bb0: {
    if (!searchTerm) {
      let t63;
      $[4] !== options ? (t63 = options || [], $[4] = options, $[5] = t63) : t63 = $[5], t5 = t63;
      break bb0;
    }
    let t62;
    if ($[6] !== options || $[7] !== searchTerm) {
      const deburredSearchTerm = deburr(searchTerm).toLocaleLowerCase();
      t62 = options?.map(_temp$L)?.filter((option_0) => option_0?.searchName.includes(deburredSearchTerm))?.sort((a, b) => {
        const matchA = a.searchName.startsWith(deburredSearchTerm), matchB = b.searchName.startsWith(deburredSearchTerm);
        return matchA && !matchB ? -1 : !matchA && matchB ? 1 : 0;
      }), $[6] = options, $[7] = searchTerm, $[8] = t62;
    } else
      t62 = $[8];
    const filtered = t62;
    let t72;
    $[9] !== filtered ? (t72 = filtered || [], $[9] = filtered, $[10] = t72) : t72 = $[10], t5 = t72;
  }
  const filteredOptions = t5;
  let t6;
  $[11] !== onSelect || $[12] !== value ? (t6 = (user) => /* @__PURE__ */ jsx(MentionUserMenuItem, { user, onSelect, pressed: user.id === value }, user.id), $[11] = onSelect, $[12] = value, $[13] = t6) : t6 = $[13];
  const renderItem2 = t6;
  let t7;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = (event_0) => {
    event_0.target !== inputRef.current && (IGNORED_KEYS.includes(event_0.key) || inputRef.current?.focus());
  }, $[14] = t7) : t7 = $[14];
  const handleKeyDown = t7, {
    t
  } = useTranslation(tasksLocaleNamespace);
  if (mentionOptions.loading) {
    let t82;
    return $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t82 = /* @__PURE__ */ jsx(Container$3, { width: 0, children: /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) }), $[15] = t82) : t82 = $[15], t82;
  }
  let t8;
  $[16] !== t ? (t8 = t("form.input.assignee.search.placeholder"), $[16] = t, $[17] = t8) : t8 = $[17];
  let t9;
  $[18] !== searchTerm || $[19] !== t8 ? (t9 = /* @__PURE__ */ jsx(TextInput$1, { placeholder: t8, autoFocus: !0, border: !1, onChange: handleSearchChange, value: searchTerm, fontSize: 1, icon: UserIcon, ref: inputRef, name: "assigneeSearch", autoComplete: "off" }), $[18] = searchTerm, $[19] = t8, $[20] = t9) : t9 = $[20];
  let t10;
  $[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    maxHeight: "320px",
    overflowY: "scroll",
    paddingTop: "8px"
  }, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== filteredOptions || $[23] !== renderItem2 || $[24] !== t ? (t11 = /* @__PURE__ */ jsx("div", { style: t10, children: filteredOptions.length === 0 ? /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, muted: !0, children: t("form.input.assignee.search.no-users.text") }) }) : /* @__PURE__ */ jsx(VirtualList$1, { items: filteredOptions, renderItem: renderItem2 }) }), $[22] = filteredOptions, $[23] = renderItem2, $[24] = t, $[25] = t11) : t11 = $[25];
  let t12;
  return $[26] !== t11 || $[27] !== t9 ? (t12 = /* @__PURE__ */ jsxs("div", { onKeyDown: handleKeyDown, children: [
    t9,
    t11
  ] }), $[26] = t11, $[27] = t9, $[28] = t12) : t12 = $[28], t12;
}
function _temp$L(option) {
  return {
    ...option,
    searchName: deburr(option.displayName || "").toLocaleLowerCase()
  };
}
function AssigneeSelectionMenu(props2) {
  const $ = c(7), {
    onSelect,
    menuButton,
    value
  } = props2;
  let t0;
  $[0] !== onSelect || $[1] !== value ? (t0 = /* @__PURE__ */ jsx(StyledMenu$5, { children: /* @__PURE__ */ jsx(MentionsMenu, { onSelect, value }) }), $[0] = onSelect, $[1] = value, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    placement: "bottom",
    fallbackPlacements: ["bottom"],
    portal: !0,
    constrainSize: !0
  }, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== menuButton || $[5] !== t0 ? (t2 = /* @__PURE__ */ jsx(MenuButton, { button: menuButton, id: "assign-user-menu", menu: t0, popover: t1 }), $[4] = menuButton, $[5] = t0, $[6] = t2) : t2 = $[6], t2;
}
const FocusableCard = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "FocusableCard",
  componentId: "sc-zmjcha-0"
})((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    &[data-as='button'] {
      border: 1px solid var(--card-border-color);
      &:focus-within {
        border: 1px solid var(--card-focus-ring-color);
      }
      --card-muted-fg-color: ${theme.color.input.default.enabled.placeholder};
    }
  `;
});
function AssigneeCreateFormField(props2) {
  const $ = c(29), {
    value,
    onChange
  } = props2, {
    mentionOptions
  } = useMentionUser();
  let t0;
  $[0] !== mentionOptions.data || $[1] !== value ? (t0 = mentionOptions.data?.find((u) => u.id === value), $[0] = mentionOptions.data, $[1] = value, $[2] = t0) : t0 = $[2];
  const mentionedUser = t0;
  let t1;
  $[3] !== onChange ? (t1 = (userId) => onChange(set(userId)), $[3] = onChange, $[4] = t1) : t1 = $[4];
  const onSelect = t1, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t2;
  bb0: {
    if (value) {
      if (mentionOptions.loading) {
        let t33;
        $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t33 = /* @__PURE__ */ jsx(TextSkeleton, { animated: !0, style: {
          width: "10ch"
        } }), $[5] = t33) : t33 = $[5], t2 = t33;
        break bb0;
      }
      if (mentionedUser) {
        t2 = mentionedUser.displayName || mentionedUser.email;
        break bb0;
      }
      if (!mentionedUser) {
        let t33;
        $[6] !== t ? (t33 = t("form.input.assignee.user-not-found.text"), $[6] = t, $[7] = t33) : t33 = $[7], t2 = t33;
        break bb0;
      }
    }
    let t32;
    $[8] !== t ? (t32 = t("form.input.assignee.search.placeholder"), $[8] = t, $[9] = t32) : t32 = $[9], t2 = t32;
  }
  const displayText = t2;
  let t3;
  $[10] !== mentionedUser ? (t3 = /* @__PURE__ */ jsx(TasksUserAvatar, { user: mentionedUser, size: 1, border: !1 }), $[10] = mentionedUser, $[11] = t3) : t3 = $[11];
  const t4 = !mentionedUser;
  let t5;
  $[12] !== displayText || $[13] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", muted: t4, children: displayText }), $[12] = displayText, $[13] = t4, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] !== t3 || $[16] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, flex: 1, children: [
    t3,
    t5
  ] }), $[15] = t3, $[16] = t5, $[17] = t6) : t6 = $[17];
  let t7;
  $[18] !== mentionedUser || $[19] !== t || $[20] !== value ? (t7 = value && mentionedUser && !mentionedUser.granted && /* @__PURE__ */ jsx(Badge, { fontSize: 1, mode: "outline", children: t("form.input.assignee.unauthorized.text") }), $[18] = mentionedUser, $[19] = t, $[20] = value, $[21] = t7) : t7 = $[21];
  let t8;
  $[22] !== t6 || $[23] !== t7 ? (t8 = /* @__PURE__ */ jsx(FocusableCard, { "data-as": "button", padding: 1, radius: 2, tabIndex: 0, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t6,
    t7
  ] }) }), $[22] = t6, $[23] = t7, $[24] = t8) : t8 = $[24];
  let t9;
  return $[25] !== onSelect || $[26] !== t8 || $[27] !== value ? (t9 = /* @__PURE__ */ jsx(AssigneeSelectionMenu, { onSelect, value, menuButton: t8 }), $[25] = onSelect, $[26] = t8, $[27] = value, $[28] = t9) : t9 = $[28], t9;
}
const StyledButton$2 = styled(Button$1).withConfig({
  displayName: "StyledButton",
  componentId: "sc-j38c0m-0"
})`padding:3px 6px;`;
function AssigneeEditFormField(props2) {
  const $ = c(37), {
    value,
    onChange,
    path
  } = props2;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = ["subscribers"], $[0] = t0) : t0 = $[0];
  const subscribers2 = useFormValue(t0), {
    mentionOptions
  } = useMentionUser();
  let t1;
  $[1] !== mentionOptions.data || $[2] !== value ? (t1 = mentionOptions.data?.find((u) => u.id === value), $[1] = mentionOptions.data, $[2] = value, $[3] = t1) : t1 = $[3];
  const mentionedUser = t1, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t2;
  $[4] !== onChange || $[5] !== path || $[6] !== subscribers2 ? (t2 = (userId) => {
    onChange(set(userId, path)), subscribers2 && !subscribers2.includes(userId) && userId && onChange(set([...subscribers2, userId], ["subscribers"]));
  }, $[4] = onChange, $[5] = path, $[6] = subscribers2, $[7] = t2) : t2 = $[7];
  const onSelect = t2;
  let t3;
  bb0: {
    if (value) {
      if (mentionOptions.loading) {
        let t43;
        $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t43 = /* @__PURE__ */ jsx(TextSkeleton, { animated: !0, style: {
          width: "10ch"
        } }), $[8] = t43) : t43 = $[8], t3 = t43;
        break bb0;
      }
      if (mentionedUser) {
        t3 = mentionedUser.displayName || mentionedUser.email;
        break bb0;
      }
      if (!mentionedUser) {
        let t43;
        $[9] !== t ? (t43 = t("form.input.assignee.user-not-found.text"), $[9] = t, $[10] = t43) : t43 = $[10], t3 = t43;
        break bb0;
      }
    }
    let t42;
    $[11] !== t ? (t42 = t("form.input.assignee.no-user-assigned.text"), $[11] = t, $[12] = t42) : t42 = $[12], t3 = t42;
  }
  const displayText = t3;
  let t4;
  $[13] !== t || $[14] !== value ? (t4 = t(value ? "form.input.assignee.user-assigned.tooltip" : "form.input.assignee.no-user-assigned.tooltip"), $[13] = t, $[14] = value, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== mentionedUser ? (t5 = /* @__PURE__ */ jsx(TasksUserAvatar, { user: mentionedUser, size: 0 }), $[16] = mentionedUser, $[17] = t5) : t5 = $[17];
  let t6;
  $[18] !== displayText ? (t6 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", children: displayText }) }), $[18] = displayText, $[19] = t6) : t6 = $[19];
  let t7;
  $[20] !== t5 || $[21] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, flex: 1, children: [
    t5,
    t6
  ] }), $[20] = t5, $[21] = t6, $[22] = t7) : t7 = $[22];
  let t8;
  $[23] !== mentionedUser || $[24] !== t || $[25] !== value ? (t8 = value && mentionedUser && !mentionedUser.granted && /* @__PURE__ */ jsx(Badge, { fontSize: 1, mode: "outline", children: t("form.input.assignee.unauthorized.text") }), $[23] = mentionedUser, $[24] = t, $[25] = value, $[26] = t8) : t8 = $[26];
  let t9;
  $[27] !== t7 || $[28] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t7,
    t8
  ] }), $[27] = t7, $[28] = t8, $[29] = t9) : t9 = $[29];
  let t10;
  $[30] !== t4 || $[31] !== t9 ? (t10 = /* @__PURE__ */ jsx(StyledButton$2, { mode: "ghost", padding: 0, children: /* @__PURE__ */ jsx(Tooltip, { content: t4, children: t9 }) }), $[30] = t4, $[31] = t9, $[32] = t10) : t10 = $[32];
  let t11;
  return $[33] !== onSelect || $[34] !== t10 || $[35] !== value ? (t11 = /* @__PURE__ */ jsx(AssigneeSelectionMenu, { onSelect, value, menuButton: t10 }), $[33] = onSelect, $[34] = t10, $[35] = value, $[36] = t11) : t11 = $[36], t11;
}
const serialize = (date) => format$1(date, DEFAULT_DATE_FORMAT), deserialize = (value) => parse$2(value || "", DEFAULT_DATE_FORMAT), DUE_BY_DATE_OPTIONS = {
  dateStyle: "long",
  timeZone: "UTC"
}, SHORT_DATE_OPTIONS = {
  month: "short",
  day: "numeric",
  timeZone: "UTC"
};
function DateEditFormField(props2) {
  const $ = c(49), {
    value,
    onChange,
    path
  } = props2, {
    t: coreT
  } = useTranslation(), {
    t
  } = useTranslation(tasksLocaleNamespace), [pickerOpen, setPickerOpen] = useState(!1), popoverRef = useRef(null), buttonRef = useRef(null), longDateFormatter = useDateTimeFormat(DUE_BY_DATE_OPTIONS), shortDateFormatter = useDateTimeFormat(SHORT_DATE_OPTIONS);
  let t0;
  bb0: {
    if (!value) {
      let t18;
      $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t18 = {
        short: "----",
        full: "----"
      }, $[0] = t18) : t18 = $[0], t0 = t18;
      break bb0;
    }
    let t17;
    $[1] !== longDateFormatter || $[2] !== value ? (t17 = longDateFormatter.format(new Date(value)), $[1] = longDateFormatter, $[2] = value, $[3] = t17) : t17 = $[3];
    const dueFormatted = t17;
    let t22;
    $[4] !== shortDateFormatter || $[5] !== value ? (t22 = shortDateFormatter.format(new Date(value)), $[4] = shortDateFormatter, $[5] = value, $[6] = t22) : t22 = $[6];
    const shortDueFormatted = t22;
    let t32;
    $[7] !== dueFormatted || $[8] !== shortDueFormatted ? (t32 = {
      short: shortDueFormatted,
      full: dueFormatted
    }, $[7] = dueFormatted, $[8] = shortDueFormatted, $[9] = t32) : t32 = $[9], t0 = t32;
  }
  const dueByeDisplayValue = t0;
  let t1, t2;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setPickerOpen(!1), t2 = () => [popoverRef.current], $[10] = t1, $[11] = t2) : (t1 = $[10], t2 = $[11]), useClickOutsideEvent(t1, t2);
  let t3;
  $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (e) => {
    e.key === "Escape" && setPickerOpen(!1);
  }, $[12] = t3) : t3 = $[12];
  const handleKeyUp = t3;
  let t4;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => setPickerOpen(_temp$K), $[13] = t4) : t4 = $[13];
  const handleClick = t4;
  let t5;
  $[14] !== coreT ? (t5 = getCalendarLabels(coreT), $[14] = coreT, $[15] = t5) : t5 = $[15];
  const calendarLabels = t5;
  let t6;
  $[16] !== onChange || $[17] !== path ? (t6 = (nextDate) => {
    onChange(nextDate ? set(serialize(nextDate), path) : unset(path)), setPickerOpen(!1);
  }, $[16] = onChange, $[17] = path, $[18] = t6) : t6 = $[18];
  const handleChange = t6;
  let deserializedValue, handleDeactivation, t7;
  if ($[19] !== value) {
    deserializedValue = deserialize(value);
    let t82;
    $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t82 = () => {
      buttonRef.current?.focus();
    }, $[23] = t82) : t82 = $[23], handleDeactivation = t82, t7 = deserializedValue?.date?.getFullYear(), $[19] = value, $[20] = deserializedValue, $[21] = handleDeactivation, $[22] = t7;
  } else
    deserializedValue = $[20], handleDeactivation = $[21], t7 = $[22];
  const dueDateIsThisYear = t7 === (/* @__PURE__ */ new Date()).getFullYear();
  let t8;
  $[24] !== calendarLabels || $[25] !== deserializedValue.date || $[26] !== handleChange ? (t8 = /* @__PURE__ */ jsx(DatePicker$2, { calendarLabels, selectTime: !1, timeStep: 1, onKeyUp: handleKeyUp, value: deserializedValue.date, onChange: handleChange, timeZoneScope: SCHEDULED_PUBLISHING_TIME_ZONE_SCOPE$1 }), $[24] = calendarLabels, $[25] = deserializedValue.date, $[26] = handleChange, $[27] = t8) : t8 = $[27];
  let t9;
  $[28] !== handleChange || $[29] !== t || $[30] !== value ? (t9 = value && /* @__PURE__ */ jsx(Flex, { justify: "flex-start", padding: 3, paddingTop: 0, children: /* @__PURE__ */ jsx(Button, { mode: "bleed", text: t("form.input.date.buttons.remove.text"), onClick: () => handleChange(null), tone: "critical" }) }), $[28] = handleChange, $[29] = t, $[30] = value, $[31] = t9) : t9 = $[31];
  let t10;
  $[32] !== handleDeactivation || $[33] !== t8 || $[34] !== t9 ? (t10 = /* @__PURE__ */ jsx(Box, { overflow: "auto", children: /* @__PURE__ */ jsxs(FocusLock, { onDeactivation: handleDeactivation, children: [
    t8,
    t9
  ] }) }), $[32] = handleDeactivation, $[33] = t8, $[34] = t9, $[35] = t10) : t10 = $[35];
  let t11;
  $[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = ["bottom-start", "bottom-end"], $[36] = t11) : t11 = $[36];
  const t12 = dueDateIsThisYear ? dueByeDisplayValue.short : dueByeDisplayValue.full;
  let t13;
  $[37] !== t || $[38] !== value ? (t13 = t(value ? "form.input.date.buttons.tooltip" : "form.input.date.buttons.empty.tooltip"), $[37] = t, $[38] = value, $[39] = t13) : t13 = $[39];
  let t14;
  $[40] !== t13 ? (t14 = {
    content: t13
  }, $[40] = t13, $[41] = t14) : t14 = $[41];
  let t15;
  $[42] !== t12 || $[43] !== t14 ? (t15 = /* @__PURE__ */ jsx(Button, { icon: CalendarIcon, mode: "ghost", text: t12, onClick: handleClick, ref: buttonRef, tooltipProps: t14 }), $[42] = t12, $[43] = t14, $[44] = t15) : t15 = $[44];
  let t16;
  return $[45] !== pickerOpen || $[46] !== t10 || $[47] !== t15 ? (t16 = /* @__PURE__ */ jsx(Popover, { constrainSize: !0, "data-testid": "date-input-dialog", portal: !0, ref: popoverRef, content: t10, open: pickerOpen, placement: "bottom", fallbackPlacements: t11, children: t15 }), $[45] = pickerOpen, $[46] = t10, $[47] = t15, $[48] = t16) : t16 = $[48], t16;
}
function _temp$K(p) {
  return !p;
}
const NormalText = styled(Text$1).withConfig({
  displayName: "NormalText",
  componentId: "sc-lvza0v-0"
})`word-break:break-word;`;
function DescriptionInputBlock(props2) {
  const $ = c(2), {
    children
  } = props2;
  let t0;
  return $[0] !== children ? (t0 = /* @__PURE__ */ jsx(Box, { paddingTop: 2, paddingBottom: 3, children: /* @__PURE__ */ jsx(NormalText, { size: 1, children }) }), $[0] = children, $[1] = t0) : t0 = $[1], t0;
}
const renderBlock = (blockProps) => {
  const {
    children
  } = blockProps;
  return /* @__PURE__ */ jsx(DescriptionInputBlock, { children });
}, DescriptionInputRoot = /* @__PURE__ */ styled.div.withConfig({
  displayName: "DescriptionInputRoot",
  componentId: "sc-11riqti-0"
})((props2) => {
  const theme = getTheme_v2(props2.theme), verticalPadding = props2.$mode === "edit" ? theme.space[1] : theme.space[3], minHeight = props2.$mode === "edit" ? 120 : 200;
  return css`
    /* select CommentInputEditableWrap and change the padding */
    [data-ui='CommentInputEditableWrap'] {
      overflow: hidden;
      padding: ${props2.$mode === "edit" ? `${verticalPadding}px 0px` : `${verticalPadding}px ${theme.space[2]}px`};
      min-height: ${Math.max(props2.$minHeight + verticalPadding, minHeight)}px !important;
    }
    #comment-input-root {
      box-shadow: ${props2.$mode === "edit" ? "none" : ""};
    }
    [data-ui='CommentInputActions'] {
      display: none !important;
    }
  `;
});
function DescriptionInput(props2) {
  const $ = c(23), {
    value: _propValue,
    mode,
    inputProps: t0
  } = props2, {
    onChange
  } = t0, value = _propValue, currentUser = useCurrentUser(), {
    mentionOptions
  } = useMentionUser();
  let t1;
  $[0] !== onChange ? (t1 = (next) => onChange(set(next)), $[0] = onChange, $[1] = t1) : t1 = $[1];
  const handleChange = t1, [rootRef, setRootRef] = useState(null), [textBoxScrollHeight, setTextBoxScrollHeight] = useState(200);
  let t2;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (ref) => {
    const textBox = ref.querySelector('[role="textbox"]');
    if (!textBox)
      return;
    const height = textBox.scrollHeight;
    setTextBoxScrollHeight(height);
  }, $[2] = t2) : t2 = $[2];
  const setTextboxHeight = t2;
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (ref_0) => {
    ref_0 && startTransition(() => {
      setRootRef(ref_0);
    });
  }, $[3] = t3) : t3 = $[3];
  const handleSetRootRef = t3, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t4;
  $[4] !== rootRef ? (t4 = () => {
    rootRef && setTextboxHeight(rootRef);
  }, $[4] = rootRef, $[5] = t4) : t4 = $[5];
  let t5;
  if ($[6] !== rootRef || $[7] !== value ? (t5 = [value, setTextboxHeight, rootRef], $[6] = rootRef, $[7] = value, $[8] = t5) : t5 = $[8], useEffect(t4, t5), !currentUser)
    return null;
  let t6;
  $[9] !== value ? (t6 = value ?? [], $[9] = value, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== t ? (t7 = t("form.input.description.placeholder"), $[11] = t, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== currentUser || $[14] !== handleChange || $[15] !== mentionOptions || $[16] !== t6 || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(CommentInput, { expandOnFocus: !1, currentUser, mentionOptions, onChange: handleChange, value: t6, withAvatar: !1, placeholder: t7, onDiscardConfirm: _temp$J, renderBlock }), $[13] = currentUser, $[14] = handleChange, $[15] = mentionOptions, $[16] = t6, $[17] = t7, $[18] = t8) : t8 = $[18];
  let t9;
  return $[19] !== mode || $[20] !== t8 || $[21] !== textBoxScrollHeight ? (t9 = /* @__PURE__ */ jsx(DescriptionInputRoot, { $mode: mode, ref: handleSetRootRef, $minHeight: textBoxScrollHeight, children: t8 }), $[19] = mode, $[20] = t8, $[21] = textBoxScrollHeight, $[22] = t9) : t9 = $[22], t9;
}
function _temp$J() {
  return null;
}
const FieldWrapperRoot = /* @__PURE__ */ styled.div.withConfig({
  displayName: "FieldWrapperRoot",
  componentId: "sc-1who9vc-0"
})((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    // Reset the padding of the field header content box
    [data-ui='fieldHeaderContentBox'] {
      padding: 0;
      label {
        font-weight: ${theme.font.text.weights.regular};
      }
    }
  `;
});
function FieldWrapper(props2) {
  const $ = c(4);
  let t0;
  $[0] !== props2 ? (t0 = props2.renderDefault(props2), $[0] = props2, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(FieldWrapperRoot, { children: t0 }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}
const StatusMenuButton = forwardRef(function(props2, ref) {
  const $ = c(21), {
    t
  } = useTranslation(tasksLocaleNamespace);
  let options, rest, value;
  $[0] !== props2 ? ({
    value,
    options,
    ...rest
  } = props2, $[0] = props2, $[1] = options, $[2] = rest, $[3] = value) : (options = $[1], rest = $[2], value = $[3]);
  let t0;
  if ($[4] !== options || $[5] !== value) {
    let t12;
    $[7] !== value ? (t12 = (option) => option.value === value, $[7] = value, $[8] = t12) : t12 = $[8], t0 = options.find(t12), $[4] = options, $[5] = value, $[6] = t0;
  } else
    t0 = $[6];
  const selectedOption = t0;
  let t1;
  $[9] !== value ? (t1 = TASK_STATUS.find((status) => status.value === value)?.icon, $[9] = value, $[10] = t1) : t1 = $[10];
  const icon = t1;
  let t2;
  $[11] !== t ? (t2 = t("form.input.status.button.tooltip"), $[11] = t, $[12] = t2) : t2 = $[12];
  let t3;
  $[13] !== t2 ? (t3 = {
    content: t2
  }, $[13] = t2, $[14] = t3) : t3 = $[14];
  const t4 = selectedOption?.title || value;
  let t5;
  return $[15] !== icon || $[16] !== ref || $[17] !== rest || $[18] !== t3 || $[19] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { ...rest, ref, tooltipProps: t3, icon, text: t4, tone: "default", mode: "ghost" }), $[15] = icon, $[16] = ref, $[17] = rest, $[18] = t3, $[19] = t4, $[20] = t5) : t5 = $[20], t5;
});
function StatusSelector(props2) {
  const $ = c(20), {
    value,
    onChange,
    options,
    path
  } = props2, telemetry = useTelemetry();
  let t0;
  $[0] !== onChange || $[1] !== path || $[2] !== telemetry || $[3] !== value ? (t0 = (next) => {
    onChange(set(next, path)), telemetry.log(TaskStatusChanged, {
      from: value,
      to: next
    });
  }, $[0] = onChange, $[1] = path, $[2] = telemetry, $[3] = value, $[4] = t0) : t0 = $[4];
  const handleStatusChange = t0;
  let t1;
  $[5] !== options || $[6] !== value ? (t1 = /* @__PURE__ */ jsx(StatusMenuButton, { value, options }), $[5] = options, $[6] = value, $[7] = t1) : t1 = $[7];
  let t2;
  if ($[8] !== handleStatusChange || $[9] !== options || $[10] !== value) {
    let t32;
    $[12] !== handleStatusChange || $[13] !== value ? (t32 = (option) => {
      const isSelected = value === option.value, icon = TASK_STATUS.find((status) => status.value === option.value)?.icon;
      return /* @__PURE__ */ jsx(MenuItem, { icon: typeof option.value == "string" ? icon || CircleIcon : CircleIcon, text: option.title || option.value, pressed: isSelected, iconRight: isSelected && /* @__PURE__ */ jsx(CheckmarkIcon, {}), onClick: () => handleStatusChange(option.value) }, option.title);
    }, $[12] = handleStatusChange, $[13] = value, $[14] = t32) : t32 = $[14], t2 = options.map(t32), $[8] = handleStatusChange, $[9] = options, $[10] = value, $[11] = t2;
  } else
    t2 = $[11];
  let t3;
  $[15] !== t2 ? (t3 = /* @__PURE__ */ jsx(Menu, { children: t2 }), $[15] = t2, $[16] = t3) : t3 = $[16];
  let t4;
  return $[17] !== t1 || $[18] !== t3 ? (t4 = /* @__PURE__ */ jsx(MenuButton, { button: t1, id: "reference-menuButton", menu: t3 }), $[17] = t1, $[18] = t3, $[19] = t4) : t4 = $[19], t4;
}
function ConfigErrorsScreen$1() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("div", { children: "Config errors" }), $[0] = t0) : t0 = $[0], t0;
}
function CurrentWorkspaceProvider(t0) {
  const $ = c(2), {
    children
  } = t0;
  let t1;
  return $[0] !== children ? (t1 = /* @__PURE__ */ jsx(WorkspaceLoaderBoundary, { LoadingComponent: LoadingBlock, ConfigErrorsComponent: ConfigErrorsScreen$1, children }), $[0] = children, $[1] = t1) : t1 = $[1], t1;
}
const EmptyReferenceRoot = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "EmptyReferenceRoot",
  componentId: "sc-uj54jx-0"
})((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    &:focus {
      border: 1px solid var(--card-focus-ring-color);
    }
    &:focus-visible {
      outline: none;
      border: 1px solid var(--card-focus-ring-color);
    }
    &:hover {
      border-color: ${theme.color.input.default.hovered.border};
    }
  `;
}), Placeholder = /* @__PURE__ */ styled(Text$1).withConfig({
  displayName: "Placeholder",
  componentId: "sc-uj54jx-1"
})((props2) => `
      color: ${getTheme_v2(props2.theme).color.input.default.enabled.placeholder};
      margin-left: 3px;
  `), TargetRoot = styled(Card).withConfig({
  displayName: "TargetRoot",
  componentId: "sc-uj54jx-2"
})`position:relative;[data-ui='show-on-hover']{opacity:0;position:absolute;right:6px;top:4px;display:flex;}&:focus-within,&:hover{padding-right:36px;[data-testid='compact-preview__status']{opacity:0;}[data-ui='show-on-hover']{transition:opacity 200ms;opacity:1;}}`, StyledIntentLink$1 = /* @__PURE__ */ styled(IntentLink).withConfig({
  displayName: "StyledIntentLink",
  componentId: "sc-uj54jx-3"
})(() => css`
    text-decoration: none;
    width: 100%;
    overflow: hidden;
    cursor: pointer;
    &:focus {
      box-shadow: 0 0 0 1px var(--card-focus-ring-color);
    }
    &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 1px var(--card-focus-ring-color);
    }
  `);
function Preview(props2) {
  const $ = c(28), {
    value,
    handleRemove
  } = props2, documentId = value.document._ref, documentType = value.documentType, schema2 = useSchema();
  let t0;
  $[0] !== schema2 || $[1] !== value.documentType ? (t0 = schema2.get(value.documentType), $[0] = schema2, $[1] = value.documentType, $[2] = t0) : t0 = $[2];
  const schemaType = t0, documentPresence = useDocumentPresence(documentId), {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t1;
  $[3] !== documentId || $[4] !== documentType ? (t1 = forwardRef(function(linkProps, ref) {
    const versionId = getVersionFromId(documentId);
    return /* @__PURE__ */ jsx(StyledIntentLink$1, { ...linkProps, intent: "edit", params: {
      id: getPublishedId(documentId),
      type: documentType
    }, ref, searchParams: versionId ? [["perspective", versionId]] : void 0 });
  }), $[3] = documentId, $[4] = documentType, $[5] = t1) : t1 = $[5];
  const CardLink = t1;
  if (!schemaType) {
    let t22;
    $[6] !== t ? (t22 = t("form.input.target.error.schema-not-found"), $[6] = t, $[7] = t22) : t22 = $[7];
    let t32;
    return $[8] !== t22 ? (t32 = /* @__PURE__ */ jsx(Text$1, { children: t22 }), $[8] = t22, $[9] = t32) : t32 = $[9], t32;
  }
  let t2;
  $[10] !== documentPresence || $[11] !== documentType || $[12] !== schemaType || $[13] !== value.document._ref ? (t2 = /* @__PURE__ */ jsx(SearchResultItemPreview, { documentType, documentId: value.document._ref, layout: "compact", presence: documentPresence, schemaType, showBadge: !1 }), $[10] = documentPresence, $[11] = documentType, $[12] = schemaType, $[13] = value.document._ref, $[14] = t2) : t2 = $[14];
  let t3;
  $[15] !== CardLink || $[16] !== t2 ? (t3 = /* @__PURE__ */ jsx(Card, { as: CardLink, radius: 2, "data-as": "button", children: t2 }), $[15] = CardLink, $[16] = t2, $[17] = t3) : t3 = $[17];
  let t4;
  $[18] !== t ? (t4 = t("form.input.target.buttons.remove.text"), $[18] = t, $[19] = t4) : t4 = $[19];
  let t5;
  $[20] !== t4 ? (t5 = {
    content: t4
  }, $[20] = t4, $[21] = t5) : t5 = $[21];
  let t6;
  $[22] !== handleRemove || $[23] !== t5 ? (t6 = /* @__PURE__ */ jsx("div", { "data-ui": "show-on-hover", children: /* @__PURE__ */ jsx(Button, { icon: CloseIcon, mode: "bleed", onClick: handleRemove, tooltipProps: t5 }) }), $[22] = handleRemove, $[23] = t5, $[24] = t6) : t6 = $[24];
  let t7;
  return $[25] !== t3 || $[26] !== t6 ? (t7 = /* @__PURE__ */ jsx(TargetRoot, { border: !0, radius: 2, children: /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", justify: "space-between", children: [
    t3,
    t6
  ] }) }), $[25] = t3, $[26] = t6, $[27] = t7) : t7 = $[27], t7;
}
function TargetField(props2) {
  const $ = c(32), [open, setOpen] = useState(!1), {
    dataset,
    projectId
  } = useWorkspace(), {
    mode,
    inputProps: t0,
    value: _propValue
  } = props2, {
    onChange
  } = t0, value = _propValue;
  let t1;
  $[0] !== dataset || $[1] !== onChange || $[2] !== projectId ? (t1 = (item) => {
    onChange(set(getTargetValue({
      documentId: item._id,
      documentType: item._type,
      dataset,
      projectId
    })));
  }, $[0] = dataset, $[1] = onChange, $[2] = projectId, $[3] = t1) : t1 = $[3];
  const handleItemSelect = t1;
  let t2;
  $[4] !== onChange ? (t2 = () => {
    onChange(unset());
  }, $[4] = onChange, $[5] = t2) : t2 = $[5];
  const handleRemove = t2;
  let t3;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setOpen(!0);
  }, $[6] = t3) : t3 = $[6];
  const handleOpenSearch = t3;
  let t4;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setOpen(!1);
  }, $[7] = t4) : t4 = $[7];
  const handleCloseSearch = t4;
  let t5;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = (event) => {
    (event.key === "Enter" || event.key === " ") && setOpen(!0);
  }, $[8] = t5) : t5 = $[8];
  const handleKeyDown = t5, {
    t
  } = useTranslation(tasksLocaleNamespace), t6 = mode === "edit", t7 = mode === "edit" ? 4 : 0;
  let t8;
  $[9] !== mode || $[10] !== props2.description || $[11] !== props2.inputId || $[12] !== props2.title || $[13] !== props2.validation ? (t8 = mode === "create" && /* @__PURE__ */ jsx(Box, { "data-ui": "fieldHeaderContentBox", children: /* @__PURE__ */ jsx(FormFieldHeaderText, { description: props2.description, inputId: props2.inputId, title: props2.title, validation: props2.validation, deprecated: void 0 }) }), $[9] = mode, $[10] = props2.description, $[11] = props2.inputId, $[12] = props2.title, $[13] = props2.validation, $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== handleRemove || $[16] !== t || $[17] !== value ? (t9 = value ? /* @__PURE__ */ jsx(Preview, { value, handleRemove }) : /* @__PURE__ */ jsx(EmptyReferenceRoot, { border: !0, radius: 2, paddingX: 2, paddingY: 3, onClick: handleOpenSearch, onKeyDown: handleKeyDown, tabIndex: 0, children: /* @__PURE__ */ jsxs(Flex, { gap: 1, justify: "flex-start", align: "center", children: [
    /* @__PURE__ */ jsx(Box, { paddingX: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(DocumentIcon, {}) }) }),
    /* @__PURE__ */ jsx(Placeholder, { size: 1, children: t("form.input.target.search.placeholder") })
  ] }) }), $[15] = handleRemove, $[16] = t, $[17] = value, $[18] = t9) : t9 = $[18];
  let t10;
  $[19] !== t8 || $[20] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t8,
    t9
  ] }), $[19] = t8, $[20] = t9, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== handleItemSelect || $[23] !== open ? (t11 = /* @__PURE__ */ jsx(SearchPopover, { open, onClose: handleCloseSearch, onItemSelect: handleItemSelect, disableIntentLink: !0 }), $[22] = handleItemSelect, $[23] = open, $[24] = t11) : t11 = $[24];
  let t12;
  $[25] !== t10 || $[26] !== t11 ? (t12 = /* @__PURE__ */ jsx(FieldWrapperRoot, { children: /* @__PURE__ */ jsx(LayerProvider, { zOffset: 100, children: /* @__PURE__ */ jsx(CurrentWorkspaceProvider, { children: /* @__PURE__ */ jsxs(SearchProvider, { children: [
    t10,
    t11
  ] }) }) }) }), $[25] = t10, $[26] = t11, $[27] = t12) : t12 = $[27];
  let t13;
  return $[28] !== t12 || $[29] !== t6 || $[30] !== t7 ? (t13 = /* @__PURE__ */ jsx(Card, { borderBottom: t6, paddingBottom: t7, children: t12 }), $[28] = t12, $[29] = t6, $[30] = t7, $[31] = t13) : t13 = $[31], t13;
}
const Root$a = /* @__PURE__ */ styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1a3jozv-0"
})((props2) => `
      display: grid;
      grid-template-columns: 1fr;
      padding-top: ${getTheme_v2(props2.theme).space[3]}px;
    `), TitleInput = /* @__PURE__ */ styled.textarea.withConfig({
  displayName: "TitleInput",
  componentId: "sc-1a3jozv-1"
})((props2) => {
  const {
    color,
    font
  } = getTheme_v2(props2.theme);
  return css`
    resize: none;
    overflow: hidden;
    appearance: none;
    background: none;
    border: 0;
    padding: 0;
    border-radius: 0;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    font-family: ${font.text.family};
    font-weight: ${font.text.weights.semibold};
    font-size: ${font.text.sizes[3].fontSize}px;
    line-height: ${font.text.sizes[3].lineHeight}px;
    margin: 0;
    position: relative;
    z-index: 1;
    display: block;
    transition: height 500ms;
    /* NOTE: This is a hack to disable Chrome’s autofill styles */
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: var(--input-fg-color) !important;
      transition: background-color 5000s;
      transition-delay: 86400s /* 24h */;
    }

    color: ${color.input.default.enabled.fg};

    &::placeholder {
      color: ${color.input.default.enabled.placeholder};
    }
  `;
});
function Title(props2) {
  const $ = c(11), {
    value,
    onChange,
    placeholder,
    path
  } = props2, ref = useRef(null);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    ref.current && (ref.current.style.height = "auto", ref.current.style.height = `${ref.current.scrollHeight}px`);
  }, $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== value ? (t1 = [value], $[1] = value, $[2] = t1) : t1 = $[2], useEffect(t0, t1);
  let t2;
  $[3] !== onChange || $[4] !== path ? (t2 = (event) => {
    const inputValue = event.currentTarget.value;
    return inputValue || onChange(unset(path)), onChange(set(inputValue.replace(/\n/g, ""), path));
  }, $[3] = onChange, $[4] = path, $[5] = t2) : t2 = $[5];
  const handleChange = t2, t3 = !value;
  let t4;
  return $[6] !== handleChange || $[7] !== placeholder || $[8] !== t3 || $[9] !== value ? (t4 = /* @__PURE__ */ jsx(Root$a, { children: /* @__PURE__ */ jsx(TitleInput, { ref, autoFocus: t3, value, placeholder, onChange: handleChange, rows: 1 }) }), $[6] = handleChange, $[7] = placeholder, $[8] = t3, $[9] = value, $[10] = t4) : t4 = $[10], t4;
}
function TitleField(props2) {
  const $ = c(4), {
    value,
    inputProps
  } = props2, {
    onChange,
    schemaType
  } = inputProps;
  let t0;
  return $[0] !== onChange || $[1] !== schemaType.placeholder || $[2] !== value ? (t0 = /* @__PURE__ */ jsx(Title, { value, onChange, placeholder: schemaType.placeholder }), $[0] = onChange, $[1] = schemaType.placeholder, $[2] = value, $[3] = t0) : t0 = $[3], t0;
}
const getTaskSubscribers = (task) => {
  const subscribers2 = task.subscribers || [];
  return getMentionedUsers(task.description).forEach((user) => {
    subscribers2.includes(user) || subscribers2.push(user);
  }), task.assignedTo && (subscribers2.includes(task.assignedTo) || subscribers2.push(task.assignedTo)), subscribers2;
};
function FormCreate(props2) {
  const $ = c(67), [creating, setCreating] = useState(!1), {
    onChange
  } = props2, {
    setViewMode,
    setActiveTab
  } = useTasksNavigation(), toast = useToast(), telemetry = useTelemetry(), [createMore, setCreateMore] = useState(!1);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setCreateMore(_temp$I), $[0] = t0) : t0 = $[0];
  const handleCreateMore = t0, value = props2.value;
  let t1;
  $[1] !== setViewMode ? (t1 = () => {
    setViewMode({
      type: "list"
    });
  }, $[1] = setViewMode, $[2] = t1) : t1 = $[2];
  const onRemove = t1;
  let t2;
  $[3] !== onRemove || $[4] !== value._id ? (t2 = {
    id: value._id,
    onRemoved: onRemove
  }, $[3] = onRemove, $[4] = value._id, $[5] = t2) : t2 = $[5];
  const {
    handleRemove,
    removeStatus
  } = useRemoveTask(t2), {
    t
  } = useTranslation(tasksLocaleNamespace), {
    data
  } = useTasks();
  let t3;
  if ($[6] !== data || $[7] !== value._id) {
    let t42;
    $[9] !== value._id ? (t42 = (task) => task._id === value._id, $[9] = value._id, $[10] = t42) : t42 = $[10], t3 = data.find(t42), $[6] = data, $[7] = value._id, $[8] = t3;
  } else
    t3 = $[8];
  const savedTask = t3;
  let t4;
  $[11] !== createMore || $[12] !== setActiveTab || $[13] !== setViewMode || $[14] !== t || $[15] !== telemetry || $[16] !== toast ? (t4 = () => {
    telemetry.log(TaskCreated), toast.push({
      closable: !0,
      status: "success",
      title: t("form.status.success")
    }), setCreating(!1), createMore ? setViewMode({
      type: "create"
    }) : setActiveTab("subscribed");
  }, $[11] = createMore, $[12] = setActiveTab, $[13] = setViewMode, $[14] = t, $[15] = telemetry, $[16] = toast, $[17] = t4) : t4 = $[17];
  const handleCreatingSuccess = useEffectEvent(t4);
  let t5;
  $[18] !== creating || $[19] !== handleCreatingSuccess || $[20] !== savedTask?.createdByUser ? (t5 = () => {
    creating && savedTask?.createdByUser && handleCreatingSuccess();
  }, $[18] = creating, $[19] = handleCreatingSuccess, $[20] = savedTask?.createdByUser, $[21] = t5) : t5 = $[21];
  const t6 = savedTask?.createdByUser;
  let t7;
  $[22] !== creating || $[23] !== t6 ? (t7 = [creating, t6], $[22] = creating, $[23] = t6, $[24] = t7) : t7 = $[24], useEffect(t5, t7);
  let t8;
  $[25] !== t || $[26] !== toast ? (t8 = () => {
    setCreating(!1), toast.push({
      closable: !0,
      status: "error",
      title: t("form.status.error.creation-failed")
    });
  }, $[25] = t, $[26] = toast, $[27] = t8) : t8 = $[27];
  const handleCreatingTimeout = useEffectEvent(t8);
  let t9;
  $[28] !== creating || $[29] !== handleCreatingTimeout ? (t9 = () => {
    let timeoutId = null;
    return creating && (timeoutId = setTimeout(() => handleCreatingTimeout(), 1e4)), () => {
      timeoutId && clearTimeout(timeoutId);
    };
  }, $[28] = creating, $[29] = handleCreatingTimeout, $[30] = t9) : t9 = $[30];
  let t10;
  $[31] !== creating ? (t10 = [creating], $[31] = creating, $[32] = t10) : t10 = $[32], useEffect(t9, t10);
  let t11;
  $[33] !== onChange || $[34] !== t || $[35] !== toast || $[36] !== value ? (t11 = async () => {
    if (setCreating(!0), !value?.title) {
      toast.push({
        closable: !0,
        status: "error",
        title: t("form.status.error.title-required")
      });
      return;
    }
    onChange([set(getTaskSubscribers(value), ["subscribers"]), set((/* @__PURE__ */ new Date()).toISOString(), ["createdByUser"])]);
  }, $[33] = onChange, $[34] = t, $[35] = toast, $[36] = value, $[37] = t11) : t11 = $[37];
  const handleCreate = t11;
  let t12;
  $[38] !== props2 ? (t12 = props2.renderDefault(props2), $[38] = props2, $[39] = t12) : t12 = $[39];
  let t13;
  $[40] !== handleRemove || $[41] !== removeStatus || $[42] !== t || $[43] !== value._rev ? (t13 = value._rev && /* @__PURE__ */ jsx(Button, { onClick: handleRemove, mode: "bleed", icon: TrashIcon, tooltipProps: {
    content: t("buttons.discard.text")
  }, disabled: removeStatus === "loading", loading: removeStatus === "loading" }), $[40] = handleRemove, $[41] = removeStatus, $[42] = t, $[43] = value._rev, $[44] = t13) : t13 = $[44];
  let t14;
  $[45] !== createMore ? (t14 = /* @__PURE__ */ jsx(Switch$1, { onChange: handleCreateMore, checked: createMore }), $[45] = createMore, $[46] = t14) : t14 = $[46];
  let t15;
  $[47] !== t ? (t15 = t("form.input.create-more.text"), $[47] = t, $[48] = t15) : t15 = $[48];
  let t16;
  $[49] !== t15 ? (t16 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t15 }), $[49] = t15, $[50] = t16) : t16 = $[50];
  let t17;
  $[51] !== t14 || $[52] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, justify: "flex-end", flex: 1, children: [
    t14,
    t16
  ] }), $[51] = t14, $[52] = t16, $[53] = t17) : t17 = $[53];
  let t18;
  $[54] !== t ? (t18 = t("buttons.create.text"), $[54] = t, $[55] = t18) : t18 = $[55];
  let t19;
  $[56] !== creating || $[57] !== handleCreate || $[58] !== t18 ? (t19 = /* @__PURE__ */ jsx(Button, { text: t18, onClick: handleCreate, disabled: creating, loading: creating }), $[56] = creating, $[57] = handleCreate, $[58] = t18, $[59] = t19) : t19 = $[59];
  let t20;
  $[60] !== t13 || $[61] !== t17 || $[62] !== t19 ? (t20 = /* @__PURE__ */ jsx(Box, { paddingY: 5, children: /* @__PURE__ */ jsxs(Flex, { paddingTop: 1, gap: 4, children: [
    t13,
    t17,
    t19
  ] }) }), $[60] = t13, $[61] = t17, $[62] = t19, $[63] = t20) : t20 = $[63];
  let t21;
  return $[64] !== t12 || $[65] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t12,
    t20
  ] }), $[64] = t12, $[65] = t20, $[66] = t21) : t21 = $[66], t21;
}
function _temp$I(p) {
  return !p;
}
function RemoveTaskDialog(props2) {
  const $ = c(25), {
    handleCloseDialog,
    handleRemove,
    removeStatus,
    showDialog
  } = props2, {
    t
  } = useTranslation(tasksLocaleNamespace);
  if (showDialog) {
    let t0;
    $[0] !== t ? (t0 = t("dialog.remove-task.title"), $[0] = t, $[1] = t0) : t0 = $[1];
    let t1;
    $[2] !== t ? (t1 = t("dialog.remove-task.buttons.cancel.text"), $[2] = t, $[3] = t1) : t1 = $[3];
    let t2;
    $[4] !== handleCloseDialog || $[5] !== t1 ? (t2 = {
      text: t1,
      onClick: handleCloseDialog
    }, $[4] = handleCloseDialog, $[5] = t1, $[6] = t2) : t2 = $[6];
    let t3;
    $[7] !== t ? (t3 = t("dialog.remove-task.buttons.confirm.text"), $[7] = t, $[8] = t3) : t3 = $[8];
    const t4 = removeStatus === "loading";
    let t5;
    $[9] !== handleRemove || $[10] !== t3 || $[11] !== t4 ? (t5 = {
      text: t3,
      tone: "critical",
      onClick: handleRemove,
      loading: t4
    }, $[9] = handleRemove, $[10] = t3, $[11] = t4, $[12] = t5) : t5 = $[12];
    let t6;
    $[13] !== t2 || $[14] !== t5 ? (t6 = {
      cancelButton: t2,
      confirmButton: t5
    }, $[13] = t2, $[14] = t5, $[15] = t6) : t6 = $[15];
    let t7;
    $[16] !== t ? (t7 = t("dialog.remove-task.body"), $[16] = t, $[17] = t7) : t7 = $[17];
    let t8;
    $[18] !== t7 ? (t8 = /* @__PURE__ */ jsx(Stack, { space: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "p", children: t7 }) }), $[18] = t7, $[19] = t8) : t8 = $[19];
    let t9;
    return $[20] !== handleCloseDialog || $[21] !== t0 || $[22] !== t6 || $[23] !== t8 ? (t9 = /* @__PURE__ */ jsx(Dialog$1, { id: "remove-task", header: t0, onClose: handleCloseDialog, footer: t6, children: t8 }), $[20] = handleCloseDialog, $[21] = t0, $[22] = t6, $[23] = t8, $[24] = t9) : t9 = $[24], t9;
  }
  return null;
}
const FirstRow = /* @__PURE__ */ styled(Flex).withConfig({
  displayName: "FirstRow",
  componentId: "sc-1obzhuh-0"
})((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    column-gap: ${theme.space[2]}px;
    row-gap: ${theme.space[3]}px;
  `;
});
function FormActionsMenu(t0) {
  const $ = c(42), {
    id: id2,
    value
  } = t0, {
    setViewMode,
    handleCopyLinkToTask
  } = useTasksNavigation(), {
    mode
  } = useTasksEnabled(), telemetry = useTelemetry();
  let t1;
  $[0] !== setViewMode || $[1] !== telemetry ? (t1 = () => {
    setViewMode({
      type: "list"
    }), telemetry.log(TaskRemoved);
  }, $[0] = setViewMode, $[1] = telemetry, $[2] = t1) : t1 = $[2];
  const onTaskRemoved = t1;
  let t2;
  $[3] !== id2 || $[4] !== onTaskRemoved ? (t2 = {
    id: id2,
    onRemoved: onTaskRemoved
  }, $[3] = id2, $[4] = onTaskRemoved, $[5] = t2) : t2 = $[5];
  const removeTask = useRemoveTask(t2);
  let t3;
  $[6] !== setViewMode || $[7] !== telemetry || $[8] !== value ? (t3 = () => {
    setViewMode({
      type: "duplicate",
      duplicateTaskValues: value
    }), telemetry.log(TaskDuplicated);
  }, $[6] = setViewMode, $[7] = telemetry, $[8] = value, $[9] = t3) : t3 = $[9];
  const duplicateTask = t3, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t4;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[10] = t4) : t4 = $[10];
  let t5;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    placement: "bottom",
    fallbackPlacements: ["bottom-end", "bottom-start"]
  }, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t ? (t6 = t("menuitem.duplicate.text"), $[12] = t, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== mode || $[15] !== t ? (t7 = mode === "upsell" ? {
    content: t("menuitem.duplicate.upsell-tooltip")
  } : void 0, $[14] = mode, $[15] = t, $[16] = t7) : t7 = $[16];
  const t8 = mode === "upsell";
  let t9;
  $[17] !== duplicateTask || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 ? (t9 = /* @__PURE__ */ jsx(MenuItem, { text: t6, icon: CopyIcon, onClick: duplicateTask, tooltipProps: t7, disabled: t8 }), $[17] = duplicateTask, $[18] = t6, $[19] = t7, $[20] = t8, $[21] = t9) : t9 = $[21];
  let t10;
  $[22] !== t ? (t10 = t("menuitem.copylink.text"), $[22] = t, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] !== handleCopyLinkToTask || $[25] !== t10 ? (t11 = /* @__PURE__ */ jsx(MenuItem, { text: t10, icon: LinkIcon, onClick: handleCopyLinkToTask }), $[24] = handleCopyLinkToTask, $[25] = t10, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(MenuDivider, {}), $[27] = t12) : t12 = $[27];
  let t13;
  $[28] !== t ? (t13 = t("menuitem.delete.text"), $[28] = t, $[29] = t13) : t13 = $[29];
  let t14;
  $[30] !== removeTask.handleOpenDialog || $[31] !== t13 ? (t14 = /* @__PURE__ */ jsx(MenuItem, { text: t13, icon: TrashIcon, onClick: removeTask.handleOpenDialog, tone: "critical" }), $[30] = removeTask.handleOpenDialog, $[31] = t13, $[32] = t14) : t14 = $[32];
  let t15;
  $[33] !== t11 || $[34] !== t14 || $[35] !== t9 ? (t15 = /* @__PURE__ */ jsx(Box, { paddingTop: 3, children: /* @__PURE__ */ jsx(MenuButton, { id: "edit-task-menu", button: t4, popover: t5, menu: /* @__PURE__ */ jsxs(Menu, { children: [
    t9,
    t11,
    t12,
    t14
  ] }) }) }), $[33] = t11, $[34] = t14, $[35] = t9, $[36] = t15) : t15 = $[36];
  let t16;
  $[37] !== removeTask ? (t16 = /* @__PURE__ */ jsx(RemoveTaskDialog, { ...removeTask }), $[37] = removeTask, $[38] = t16) : t16 = $[38];
  let t17;
  return $[39] !== t15 || $[40] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t15,
    t16
  ] }), $[39] = t15, $[40] = t16, $[41] = t17) : t17 = $[41], t17;
}
function FormEditInner(props2) {
  const $ = c(52);
  let t0;
  $[0] !== props2.schemaType.fields ? (t0 = props2.schemaType.fields.find(_temp$H), $[0] = props2.schemaType.fields, $[1] = t0) : t0 = $[1];
  const statusField = t0, value = props2.value, currentUser = useCurrentUser(), {
    t
  } = useTranslation(tasksLocaleNamespace), activityData = useActivityLog(value).changes;
  let t1;
  $[2] !== currentUser || $[3] !== props2 || $[4] !== value.subscribers ? (t1 = (patch2) => {
    const subscribers2 = value.subscribers || [];
    props2.onChange(patch2), currentUser && (subscribers2.includes(currentUser.id) || props2.onChange(set([...subscribers2, currentUser.id], ["subscribers"])));
  }, $[2] = currentUser, $[3] = props2, $[4] = value.subscribers, $[5] = t1) : t1 = $[5];
  const handleChangeAndSubscribe = t1;
  if (!statusField)
    throw new Error("Status field not found");
  if (!value?._id) {
    let t24;
    return $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t24 = /* @__PURE__ */ jsx(LoadingBlock, {}), $[6] = t24) : t24 = $[6], t24;
  }
  const t2 = props2.value?.title;
  let t3;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = ["title"], $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t ? (t4 = t("form.input.title.placeholder"), $[8] = t, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== handleChangeAndSubscribe || $[11] !== t2 || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsx(Stack, { flex: 1, children: /* @__PURE__ */ jsx(Title, { onChange: handleChangeAndSubscribe, value: t2, path: t3, placeholder: t4 }) }), $[10] = handleChangeAndSubscribe, $[11] = t2, $[12] = t4, $[13] = t5) : t5 = $[13];
  const t6 = props2.value?._id;
  let t7;
  $[14] !== t6 || $[15] !== value ? (t7 = /* @__PURE__ */ jsx(FormActionsMenu, { id: t6, value }), $[14] = t6, $[15] = value, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t5 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, children: [
    t5,
    t7
  ] }), $[17] = t5, $[18] = t7, $[19] = t8) : t8 = $[19];
  const t9 = props2.value?.status;
  let t10;
  $[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = ["status"], $[20] = t10) : t10 = $[20];
  let t11;
  $[21] !== handleChangeAndSubscribe || $[22] !== statusField.type.options.list || $[23] !== t9 ? (t11 = /* @__PURE__ */ jsx(StatusSelector, { value: t9, path: t10, onChange: handleChangeAndSubscribe, options: statusField.type.options.list }), $[21] = handleChangeAndSubscribe, $[22] = statusField.type.options.list, $[23] = t9, $[24] = t11) : t11 = $[24];
  const t12 = props2.value?.assignedTo;
  let t13;
  $[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = ["assignedTo"], $[25] = t13) : t13 = $[25];
  let t14;
  $[26] !== handleChangeAndSubscribe || $[27] !== t12 ? (t14 = /* @__PURE__ */ jsx(AssigneeEditFormField, { value: t12, onChange: handleChangeAndSubscribe, path: t13 }), $[26] = handleChangeAndSubscribe, $[27] = t12, $[28] = t14) : t14 = $[28];
  const t15 = props2.value?.dueBy;
  let t16;
  $[29] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = ["dueBy"], $[29] = t16) : t16 = $[29];
  let t17;
  $[30] !== handleChangeAndSubscribe || $[31] !== t15 ? (t17 = /* @__PURE__ */ jsx(DateEditFormField, { value: t15, onChange: handleChangeAndSubscribe, path: t16 }), $[30] = handleChangeAndSubscribe, $[31] = t15, $[32] = t17) : t17 = $[32];
  let t18;
  $[33] !== t11 || $[34] !== t14 || $[35] !== t17 ? (t18 = /* @__PURE__ */ jsx(Card, { borderTop: !0, marginTop: 3, children: /* @__PURE__ */ jsx(FirstRow, { paddingBottom: 3, paddingTop: 4, align: "flex-start", justify: "flex-start", wrap: "wrap", children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
    t11,
    t14,
    t17
  ] }) }) }), $[33] = t11, $[34] = t14, $[35] = t17, $[36] = t18) : t18 = $[36];
  let t19;
  $[37] !== props2 ? (t19 = props2.renderDefault(props2), $[37] = props2, $[38] = t19) : t19 = $[38];
  let t20;
  $[39] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t20 = ["subscribers"], $[39] = t20) : t20 = $[39];
  let t21;
  $[40] !== activityData || $[41] !== props2.onChange || $[42] !== value ? (t21 = /* @__PURE__ */ jsx(Card, { borderTop: !0, paddingTop: 4, marginTop: 4, paddingBottom: 6, children: /* @__PURE__ */ jsx(TasksActivityLog, { value, onChange: props2.onChange, path: t20, activityData }) }), $[40] = activityData, $[41] = props2.onChange, $[42] = value, $[43] = t21) : t21 = $[43];
  let t22;
  $[44] !== t21 || $[45] !== value._id ? (t22 = /* @__PURE__ */ jsx(CurrentWorkspaceProvider, { children: /* @__PURE__ */ jsx(CommentsProvider, { documentId: value._id, documentType: "tasks.task", sortOrder: "asc", type: "task", children: t21 }) }), $[44] = t21, $[45] = value._id, $[46] = t22) : t22 = $[46];
  let t23;
  return $[47] !== t18 || $[48] !== t19 || $[49] !== t22 || $[50] !== t8 ? (t23 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t8,
    t18,
    t19,
    t22
  ] }), $[47] = t18, $[48] = t19, $[49] = t22, $[50] = t8, $[51] = t23) : t23 = $[51], t23;
}
function _temp$H(f) {
  return f.name === "status";
}
function FormEdit(props2) {
  const $ = c(11), value = props2.value, currentUser = useCurrentUser();
  let t0;
  $[0] !== value.subscribers ? (t0 = value.subscribers || [], $[0] = value.subscribers, $[1] = t0) : t0 = $[1];
  const subscribers2 = t0;
  let t1;
  $[2] !== currentUser || $[3] !== subscribers2 || $[4] !== value.description ? (t1 = (patches) => {
    if (!currentUser || patches.some(_temp2$h) || patches.some(_temp3$7))
      return patches;
    const newSubscribers = [...subscribers2], changeAssigneePatch = patches.find(_temp4$2);
    changeAssigneePatch && changeAssigneePatch.type === "set" && typeof changeAssigneePatch.value == "string" && !newSubscribers.includes(changeAssigneePatch.value) && newSubscribers.push(changeAssigneePatch.value), newSubscribers.includes(currentUser.id) || newSubscribers.push(currentUser.id);
    const changedDescriptionPatch = patches.find(_temp5$1);
    if (changedDescriptionPatch) {
      const prevMentionedUser = getMentionedUsers(value.description), newDescription = changedDescriptionPatch.type === "set" ? changedDescriptionPatch.value : void 0;
      getMentionedUsers(newDescription).filter((user) => !prevMentionedUser.includes(user)).forEach((user_0) => {
        newSubscribers.includes(user_0) || newSubscribers.push(user_0);
      });
    }
    return newSubscribers.length !== subscribers2.length && patches.push(set(newSubscribers, ["subscribers"])), patches;
  }, $[2] = currentUser, $[3] = subscribers2, $[4] = value.description, $[5] = t1) : t1 = $[5];
  const transformPatches = t1;
  let t2;
  $[6] !== props2 ? (t2 = /* @__PURE__ */ jsx(FormEditInner, { ...props2 }), $[6] = props2, $[7] = t2) : t2 = $[7];
  let t3;
  return $[8] !== t2 || $[9] !== transformPatches ? (t3 = /* @__PURE__ */ jsx(TransformPatches, { transform: transformPatches, children: t2 }), $[8] = t2, $[9] = transformPatches, $[10] = t3) : t3 = $[10], t3;
}
function _temp5$1(patch_2) {
  return patch_2.path[0] === "description" && patch_2.type === "set";
}
function _temp4$2(patch_1) {
  return patch_1.path[0] === "assignedTo";
}
function _temp3$7(patch_0) {
  return patch_0.path[0] === "context" && patch_0.path[1] === "notification";
}
function _temp2$h(patch2) {
  return patch2.path[0] === "subscribers";
}
function getTaskURL(taskId, basePath, toolName = "") {
  let path = window.location.origin;
  basePath && (path += basePath), toolName && (path += `/${toolName}`);
  const currentUrl = new URL(`${path}/`);
  return currentUrl.searchParams.set(TASKS_SIDEBAR_SEARCH_PARAM, "tasks"), currentUrl.searchParams.set(TASKS_SELECTED_TASK_SEARCH_PARAM, taskId), currentUrl.searchParams.set(TASKS_VIEW_MODE_SEARCH_PARAM, "edit"), currentUrl.toString();
}
function TasksNotificationTargetInner(props2) {
  const $ = c(37), {
    inputProps
  } = props2, {
    onChange
  } = inputProps, activeToolName = useRouterState(_temp$G);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const {
    target,
    _id,
    context,
    _rev
  } = useFormValue(t0), {
    title: workspaceTitle,
    basePath,
    name: workspaceName
  } = useWorkspace(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t1;
  $[1] !== client ? (t1 = createImageUrlBuilder(client), $[1] = client, $[2] = t1) : t1 = $[2];
  const imageBuilder = t1, documentId = target?.document?._ref ?? "", documentType = target?.documentType ?? "", {
    perspectiveStack
  } = usePerspective();
  let t2;
  $[3] !== documentId || $[4] !== documentType || $[5] !== perspectiveStack ? (t2 = {
    documentId,
    documentType,
    perspectiveStack
  }, $[3] = documentId, $[4] = documentType, $[5] = perspectiveStack, $[6] = t2) : t2 = $[6];
  const {
    isLoading: previewValuesLoading,
    value
  } = useDocumentPreviewValues(t2), targetContentTitle = value?.title || null;
  let t3;
  $[7] !== imageBuilder || $[8] !== value ? (t3 = isImageSource(value?.media) ? imageBuilder.image(value.media).width(96).height(96).url() : null, $[7] = imageBuilder, $[8] = value, $[9] = t3) : t3 = $[9];
  const imageUrl = t3, contextUrl = context?.notification?.url;
  let t4;
  $[10] !== _id || $[11] !== activeToolName || $[12] !== basePath || $[13] !== contextUrl ? (t4 = contextUrl && isDev ? contextUrl : getTaskURL(_id, basePath, activeToolName), $[10] = _id, $[11] = activeToolName, $[12] = basePath, $[13] = contextUrl, $[14] = t4) : t4 = $[14];
  const studioUrl = t4;
  let t5;
  $[15] !== imageUrl || $[16] !== studioUrl || $[17] !== targetContentTitle || $[18] !== workspaceName || $[19] !== workspaceTitle ? (t5 = {
    url: studioUrl,
    workspaceTitle,
    targetContentImageUrl: imageUrl,
    targetContentTitle,
    workspaceName
  }, $[15] = imageUrl, $[16] = studioUrl, $[17] = targetContentTitle, $[18] = workspaceName, $[19] = workspaceTitle, $[20] = t5) : t5 = $[20];
  const notificationTarget = t5;
  let t6;
  $[21] !== _rev || $[22] !== context?.notification || $[23] !== documentId || $[24] !== documentType || $[25] !== notificationTarget || $[26] !== onChange || $[27] !== previewValuesLoading ? (t6 = () => {
    documentId && documentType && previewValuesLoading || _rev && (deepEquals(context?.notification, notificationTarget) || onChange(set(notificationTarget, ["notification"])));
  }, $[21] = _rev, $[22] = context?.notification, $[23] = documentId, $[24] = documentType, $[25] = notificationTarget, $[26] = onChange, $[27] = previewValuesLoading, $[28] = t6) : t6 = $[28];
  let t7;
  return $[29] !== _rev || $[30] !== context || $[31] !== documentId || $[32] !== documentType || $[33] !== notificationTarget || $[34] !== onChange || $[35] !== previewValuesLoading ? (t7 = [_rev, context, documentId, documentType, notificationTarget, previewValuesLoading, onChange], $[29] = _rev, $[30] = context, $[31] = documentId, $[32] = documentType, $[33] = notificationTarget, $[34] = onChange, $[35] = previewValuesLoading, $[36] = t7) : t7 = $[36], useEffect(t6, t7), null;
}
function _temp$G(routerState) {
  return typeof routerState.tool == "string" ? routerState.tool : void 0;
}
function TasksNotificationTarget(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CurrentWorkspaceProvider, { children: /* @__PURE__ */ jsx(TasksNotificationTargetInner, { ...props2 }) }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
const targetContentField = (mode) => defineField({
  type: "object",
  name: "target",
  title: "Target",
  components: {
    field: (props2) => /* @__PURE__ */ jsx(TargetField, { ...props2, mode })
  },
  fields: [{
    name: "document",
    type: "crossDatasetReference",
    dataset: "playground",
    weak: !0,
    studioUrl: ({
      id: id2,
      type
    }) => `intent/edit/id=${id2};type=${type}/`,
    to: [{
      type: "any_document",
      preview: {
        select: {
          title: "title"
        }
      }
    }]
  }, {
    name: "documentType",
    type: "string",
    title: "Document type"
  }]
}), descriptionInputField = (mode) => defineField({
  type: "array",
  name: "description",
  title: "Description",
  components: {
    field: (props2) => /* @__PURE__ */ jsx(DescriptionInput, { ...props2, mode })
  },
  of: [{
    type: "block",
    name: "block",
    of: [{
      name: "mention",
      type: "object",
      fields: [{
        name: "userId",
        type: "string"
      }]
    }],
    marks: {
      annotations: []
    },
    styles: [{
      title: "Normal",
      value: "normal"
    }],
    lists: []
  }]
}), taskSchema = (mode) => defineType({
  type: "document",
  name: "tasks.task",
  liveEdit: !0,
  components: {
    input: mode === "edit" ? FormEdit : FormCreate
  },
  fields: [{
    type: "string",
    title: "Title",
    name: "title",
    placeholder: "Task title",
    components: {
      field: TitleField
    },
    hidden: mode === "edit"
  }, ...mode === "edit" ? [targetContentField(mode), descriptionInputField(mode)] : [descriptionInputField(mode), targetContentField(mode)], {
    type: "string",
    name: "assignedTo",
    title: "Assign to",
    placeholder: "Select assignee",
    components: {
      field: FieldWrapper,
      input: AssigneeCreateFormField
    },
    hidden: mode === "edit"
  }, {
    type: "date",
    name: "dueBy",
    title: "Deadline",
    placeholder: "yyyy-mm-dd",
    components: {
      field: FieldWrapper
    },
    hidden: mode === "edit"
  }, {
    type: "string",
    name: "authorId",
    hidden: !0
  }, {
    type: "string",
    name: "createdByUser",
    hidden: !0
  }, {
    type: "array",
    of: [{
      type: "string"
    }],
    name: "subscribers",
    hidden: !0
  }, {
    type: "string",
    name: "status",
    title: "Status",
    options: {
      list: TASK_STATUS.map((s) => ({
        value: s.value,
        title: s.title
      }))
    },
    hidden: !0
  }, {
    type: "object",
    name: "context",
    components: {
      field: TasksNotificationTarget
    },
    fields: [{
      type: "object",
      name: "notification",
      fields: [{
        type: "string",
        name: "url"
      }, {
        type: "string",
        name: "workspaceTitle"
      }, {
        type: "string",
        name: "targetContentImageUrl"
      }, {
        type: "string",
        name: "targetContentTitle"
      }]
    }]
  }]
});
function TasksAddonWorkspaceProviderInner(t0) {
  const $ = c(23), {
    children,
    mode,
    addonDataset
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    apiVersion: API_VERSION
  }, $[0] = t1) : t1 = $[0];
  const client = useClient(t1);
  let t2;
  $[1] !== client ? (t2 = client.config(), $[1] = client, $[2] = t2) : t2 = $[2];
  const apiHost = t2.apiHost, source = useSource(), t3 = `addon-dataset-${addonDataset}`, t4 = source.projectId;
  let t5;
  $[3] !== mode ? (t5 = taskSchema(mode), $[3] = mode, $[4] = t5) : t5 = $[4];
  let t6;
  $[5] !== t5 ? (t6 = {
    types: [t5]
  }, $[5] = t5, $[6] = t6) : t6 = $[6];
  let t7;
  $[7] !== addonDataset || $[8] !== apiHost || $[9] !== source.projectId || $[10] !== t3 || $[11] !== t6 ? (t7 = {
    basePath: "",
    dataset: addonDataset,
    name: t3,
    projectId: t4,
    apiHost,
    schema: t6
  }, $[7] = addonDataset, $[8] = apiHost, $[9] = source.projectId, $[10] = t3, $[11] = t6, $[12] = t7) : t7 = $[12];
  const addonDatasetConfig = t7;
  let t8;
  $[13] !== addonDatasetConfig ? (t8 = prepareConfig(addonDatasetConfig, {
    basePath: ""
  }), $[13] = addonDatasetConfig, $[14] = t8) : t8 = $[14];
  const {
    workspaces
  } = t8, addonWorkspace = useWorkspaceLoader(workspaces[0]);
  if (!addonWorkspace)
    return null;
  let t9;
  $[15] !== children ? (t9 = /* @__PURE__ */ jsx(ResourceCacheProvider, { children }), $[15] = children, $[16] = t9) : t9 = $[16];
  let t10;
  $[17] !== addonWorkspace.unstable_sources[0] || $[18] !== t9 ? (t10 = /* @__PURE__ */ jsx(SourceProvider, { source: addonWorkspace.unstable_sources[0], children: t9 }), $[17] = addonWorkspace.unstable_sources[0], $[18] = t9, $[19] = t10) : t10 = $[19];
  let t11;
  return $[20] !== addonWorkspace || $[21] !== t10 ? (t11 = /* @__PURE__ */ jsx(WorkspaceProvider, { workspace: addonWorkspace, children: t10 }), $[20] = addonWorkspace, $[21] = t10, $[22] = t11) : t11 = $[22], t11;
}
function TasksAddonWorkspaceProvider(props2) {
  const $ = c(11), {
    client: addonDatasetClient,
    ready,
    createAddonDataset
  } = useAddonDataset();
  let t0;
  $[0] !== addonDatasetClient ? (t0 = addonDatasetClient?.config().dataset, $[0] = addonDatasetClient, $[1] = t0) : t0 = $[1];
  const addonDataset = t0;
  let t1, t2;
  if ($[2] !== addonDataset || $[3] !== createAddonDataset || $[4] !== ready ? (t1 = () => {
    !addonDataset && ready && createAddonDataset();
  }, t2 = [addonDataset, ready, createAddonDataset], $[2] = addonDataset, $[3] = createAddonDataset, $[4] = ready, $[5] = t1, $[6] = t2) : (t1 = $[5], t2 = $[6]), useEffect(t1, t2), !addonDataset) {
    let t32;
    return $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t32 = /* @__PURE__ */ jsx(LoadingBlock, {}), $[7] = t32) : t32 = $[7], t32;
  }
  let t3;
  return $[8] !== addonDataset || $[9] !== props2 ? (t3 = /* @__PURE__ */ jsx(TasksAddonWorkspaceProviderInner, { ...props2, addonDataset }), $[8] = addonDataset, $[9] = props2, $[10] = t3) : t3 = $[10], t3;
}
const VARIANTS = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.2,
      delay: 0.2
    }
  }
}, FormBuilderRoot = /* @__PURE__ */ styled(motion.div).withConfig({
  displayName: "FormBuilderRoot",
  componentId: "sc-9e51nn-0"
})((props2) => {
  const theme = getTheme_v2(props2.theme);
  return `
    // Update spacing for the form builder
    & > [data-ui='Stack'] {
      grid-gap: ${rem(theme.space[4])};
    }
`;
}), TasksFormBuilderInner = (t0) => {
  const $ = c(25), {
    documentId,
    initialValue
  } = t0, [patchChannel] = useState(_temp$F);
  let t1;
  $[0] !== initialValue ? (t1 = initialValue ? {
    loading: !1,
    value: initialValue,
    error: null
  } : void 0, $[0] = initialValue, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== documentId || $[3] !== t1 ? (t2 = {
    documentId,
    documentType: "tasks.task",
    initialValue: t1
  }, $[2] = documentId, $[3] = t1, $[4] = t2) : t2 = $[4];
  const {
    formState,
    onChange,
    onPathOpen,
    onFocus,
    onBlur,
    onSetActiveFieldGroup,
    onSetCollapsedFieldSet,
    onSetCollapsedPath,
    collapsedFieldSets,
    ready,
    collapsedPaths,
    schemaType,
    value
  } = useDocumentForm(t2), isLoading = formState === null || !ready, {
    setSelectedDocument
  } = useMentionUser(), target = isLoading ? void 0 : value?.target, targetId = target?.document?._ref, targetType = target?.documentType;
  let t3, t4;
  $[5] !== setSelectedDocument || $[6] !== targetId || $[7] !== targetType ? (t3 = () => {
    setSelectedDocument(targetId && targetType ? {
      _id: targetId,
      _type: targetType
    } : null);
  }, t4 = [targetId, targetType, setSelectedDocument], $[5] = setSelectedDocument, $[6] = targetId, $[7] = targetType, $[8] = t3, $[9] = t4) : (t3 = $[8], t4 = $[9]), useEffect(t3, t4);
  let t5;
  return $[10] !== collapsedFieldSets || $[11] !== collapsedPaths || $[12] !== formState || $[13] !== isLoading || $[14] !== onBlur || $[15] !== onChange || $[16] !== onFocus || $[17] !== onPathOpen || $[18] !== onSetActiveFieldGroup || $[19] !== onSetCollapsedFieldSet || $[20] !== onSetCollapsedPath || $[21] !== patchChannel || $[22] !== schemaType || $[23] !== value ? (t5 = /* @__PURE__ */ jsx(Box, { children: isLoading ? /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) : /* @__PURE__ */ jsx(FormBuilderRoot, { id: "wrapper", initial: "hidden", animate: "visible", variants: VARIANTS, children: /* @__PURE__ */ jsx(FormBuilder, { __internal_patchChannel: patchChannel, id: "root", onChange, onPathFocus: onFocus, onPathOpen, onPathBlur: onBlur, onFieldGroupSelect: onSetActiveFieldGroup, onSetFieldSetCollapsed: onSetCollapsedFieldSet, onSetPathCollapsed: onSetCollapsedPath, collapsedPaths, collapsedFieldSets, focusPath: formState.focusPath, changed: formState.changed, focused: formState.focused, groups: formState.groups, validation: formState.validation, members: formState.members, presence: formState.presence, schemaType, value, hasUpstreamVersion: !1 }) }) }), $[10] = collapsedFieldSets, $[11] = collapsedPaths, $[12] = formState, $[13] = isLoading, $[14] = onBlur, $[15] = onChange, $[16] = onFocus, $[17] = onPathOpen, $[18] = onSetActiveFieldGroup, $[19] = onSetCollapsedFieldSet, $[20] = onSetCollapsedPath, $[21] = patchChannel, $[22] = schemaType, $[23] = value, $[24] = t5) : t5 = $[24], t5;
};
function TasksFormBuilder() {
  const $ = c(23), currentUser = useCurrentUser(), {
    activeDocument
  } = useTasks(), {
    dataset,
    projectId
  } = useWorkspace(), {
    state: t0
  } = useTasksNavigation(), {
    selectedTask,
    viewMode,
    duplicateTaskValues
  } = t0;
  let t1;
  bb0: {
    if (!currentUser) {
      t1 = void 0;
      break bb0;
    }
    if (!selectedTask) {
      t1 = void 0;
      break bb0;
    }
    if (viewMode === "duplicate") {
      const t22 = `${duplicateTaskValues?.title} (copy)`;
      let t32;
      $[0] !== currentUser.id || $[1] !== duplicateTaskValues || $[2] !== selectedTask || $[3] !== t22 ? (t32 = {
        ...duplicateTaskValues,
        title: t22,
        createdByUser: void 0,
        _id: selectedTask,
        _type: "tasks.task",
        authorId: currentUser.id,
        status: "open"
      }, $[0] = currentUser.id, $[1] = duplicateTaskValues, $[2] = selectedTask, $[3] = t22, $[4] = t32) : t32 = $[4], t1 = t32;
      break bb0;
    }
    if (viewMode === "create") {
      let t22;
      $[5] !== currentUser.id ? (t22 = [currentUser.id], $[5] = currentUser.id, $[6] = t22) : t22 = $[6];
      let t32;
      $[7] !== activeDocument || $[8] !== dataset || $[9] !== projectId ? (t32 = activeDocument ? getTargetValue({
        documentId: activeDocument.documentId,
        documentType: activeDocument.documentType,
        dataset,
        projectId
      }) : void 0, $[7] = activeDocument, $[8] = dataset, $[9] = projectId, $[10] = t32) : t32 = $[10];
      let t42;
      $[11] !== currentUser.id || $[12] !== selectedTask || $[13] !== t22 || $[14] !== t32 ? (t42 = {
        _id: selectedTask,
        _type: "tasks.task",
        authorId: currentUser.id,
        status: "open",
        subscribers: t22,
        target: t32
      }, $[11] = currentUser.id, $[12] = selectedTask, $[13] = t22, $[14] = t32, $[15] = t42) : t42 = $[15], t1 = t42;
      break bb0;
    }
    t1 = void 0;
  }
  const initialValue = t1;
  if (!currentUser) {
    let t22;
    return $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0, title: "Loading current user" }), $[16] = t22) : t22 = $[16], t22;
  }
  if (!selectedTask)
    return null;
  const t2 = viewMode === "edit" ? "edit" : "create";
  let t3;
  $[17] !== initialValue || $[18] !== selectedTask ? (t3 = /* @__PURE__ */ jsx(TasksFormBuilderInner, { documentId: selectedTask, initialValue }), $[17] = initialValue, $[18] = selectedTask, $[19] = t3) : t3 = $[19];
  let t4;
  return $[20] !== t2 || $[21] !== t3 ? (t4 = /* @__PURE__ */ jsx(MentionUserProvider, { children: /* @__PURE__ */ jsx(TasksAddonWorkspaceProvider, { mode: t2, children: t3 }) }), $[20] = t2, $[21] = t3, $[22] = t4) : t4 = $[22], t4;
}
function _temp$F() {
  return createPatchChannel();
}
const HEADING_BY_STATUS = {
  open: {
    assigned: {
      heading: "empty-state.status.list.open.assigned.heading",
      text: "empty-state.status.list.open.assigned.text"
    },
    document: {
      heading: "empty-state.status.list.open.document.heading",
      text: ""
    },
    subscribed: {
      heading: "empty-state.status.list.open.subscribed.heading",
      text: "empty-state.status.list.open.subscribed.text"
    }
  },
  closed: {
    assigned: {
      heading: "empty-state.status.list.closed.assigned.heading",
      text: "empty-state.status.list.closed.assigned.text"
    },
    document: {
      heading: "empty-state.status.list.closed.document.heading",
      text: ""
    },
    subscribed: {
      heading: "empty-state.status.list.closed.subscribed.heading",
      text: "empty-state.status.list.closed.subscribed.text"
    }
  }
};
function EmptyStatusListState(t0) {
  const $ = c(13), {
    status
  } = t0, {
    state: t1
  } = useTasksNavigation(), {
    activeTabId
  } = t1, {
    t
  } = useTranslation(tasksLocaleNamespace), {
    heading,
    text
  } = HEADING_BY_STATUS[status][activeTabId];
  let t2;
  $[0] !== heading || $[1] !== t ? (t2 = t(heading), $[0] = heading, $[1] = t, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t || $[6] !== text ? (t4 = t(text), $[5] = t, $[6] = text, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t4 }), $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  return $[10] !== t3 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t3,
    t5
  ] }), $[10] = t3, $[11] = t5, $[12] = t6) : t6 = $[12], t6;
}
const EMPTY_TASK_LIST = {
  assigned: {
    heading: "empty-state.list.assigned.heading",
    text: "empty-state.list.assigned.text"
  },
  subscribed: {
    heading: "empty-state.list.subscribed.heading",
    text: "empty-state.list.subscribed.text"
  },
  document: {
    heading: "empty-state.list.document.heading",
    text: "empty-state.list.document.text"
  },
  noActiveDocument: {
    heading: "empty-state.list.no-active-document.heading",
    text: "empty-state.list.no-active-document.text"
  }
}, Root$9 = styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1li3f83-0"
})`max-width:268px;margin:0 auto;height:100%;margin-top:40%;`, AnimatedText = styled(Text$1).withConfig({
  displayName: "AnimatedText",
  componentId: "sc-1li3f83-1"
})`@keyframes fadeIn{from{opacity:0;}to{opacity:1;}}animation:fadeIn 0.2s ease-in-out;`;
function EmptyTasksListState() {
  const $ = c(22), {
    activeDocument
  } = useTasks(), {
    mode
  } = useTasksEnabled(), {
    state: t0,
    setViewMode
  } = useTasksNavigation(), {
    activeTabId
  } = t0, key = !activeDocument && activeTabId === "document" ? "noActiveDocument" : activeTabId, {
    heading,
    text
  } = EMPTY_TASK_LIST[key], {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t1;
  $[0] !== setViewMode ? (t1 = () => {
    setViewMode({
      type: "create"
    });
  }, $[0] = setViewMode, $[1] = t1) : t1 = $[1];
  const handleTaskCreate = t1;
  let t2;
  $[2] !== heading || $[3] !== t ? (t2 = t(heading), $[2] = heading, $[3] = t, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== key || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(AnimatedText, { size: 1, weight: "semibold", children: t2 }, key), $[5] = key, $[6] = t2, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t || $[9] !== text ? (t4 = t(text), $[8] = t, $[9] = text, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== key || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { paddingBottom: 6, paddingTop: 1, children: /* @__PURE__ */ jsx(AnimatedText, { size: 1, align: "center", children: t4 }, key) }), $[11] = key, $[12] = t4, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== handleTaskCreate || $[15] !== mode || $[16] !== t ? (t6 = mode !== "upsell" && /* @__PURE__ */ jsx(Button, { icon: AddIcon, text: t("empty-state.list.create-new"), onClick: handleTaskCreate }), $[14] = handleTaskCreate, $[15] = mode, $[16] = t, $[17] = t6) : t6 = $[17];
  let t7;
  return $[18] !== t3 || $[19] !== t5 || $[20] !== t6 ? (t7 = /* @__PURE__ */ jsx(Root$9, { children: /* @__PURE__ */ jsxs(Flex, { direction: "column", gap: 3, align: "center", flex: 1, justify: "center", children: [
    t3,
    t5,
    t6
  ] }) }), $[18] = t3, $[19] = t5, $[20] = t6, $[21] = t7) : t7 = $[21], t7;
}
const StyledIntentLink = /* @__PURE__ */ styled(IntentLink).withConfig({
  displayName: "StyledIntentLink",
  componentId: "sc-3e5coy-0"
})((props2) => `
  text-decoration: underline;
  text-decoration-color: ${getTheme_v2(props2.theme).color.input.default.enabled.border};
  text-underline-offset: 2px;
`);
function DocumentPreview(t0) {
  const $ = c(12), {
    documentId,
    documentType
  } = t0, documentSchema = useSchema().get(documentType), {
    perspectiveStack
  } = usePerspective();
  let t1;
  $[0] !== documentId || $[1] !== documentType || $[2] !== perspectiveStack ? (t1 = {
    documentId,
    documentType,
    perspectiveStack
  }, $[0] = documentId, $[1] = documentType, $[2] = perspectiveStack, $[3] = t1) : t1 = $[3];
  const {
    isLoading,
    value
  } = useDocumentPreviewValues(t1);
  let t2;
  $[4] !== documentId || $[5] !== documentType ? (t2 = forwardRef(function(linkProps, ref) {
    return /* @__PURE__ */ jsx(StyledIntentLink, { ...linkProps, intent: "edit", params: {
      id: documentId,
      type: documentType
    }, ref });
  }), $[4] = documentId, $[5] = documentType, $[6] = t2) : t2 = $[6];
  const Link2 = t2;
  if (!documentSchema)
    return null;
  let t3;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(DocumentIcon, {}) }), $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== Link2 || $[9] !== isLoading || $[10] !== value?.title ? (t4 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t3,
    isLoading ? /* @__PURE__ */ jsx(TextSkeleton, { size: 1, muted: !0 }) : /* @__PURE__ */ jsx(Text$1, { size: 1, as: Link2, weight: "medium", style: {
      maxWidth: "20ch"
    }, textOverflow: "ellipsis", children: value?.title || "Untitled" })
  ] }), $[8] = Link2, $[9] = isLoading, $[10] = value?.title, $[11] = t4) : t4 = $[11], t4;
}
function TasksStatus(props2) {
  const $ = c(7), operations = useTaskOperations(), {
    documentId,
    status
  } = props2, [checkboxValue, setCheckboxValue] = useState(status === "closed"), [isLoading, setIsLoading] = useState(!1);
  let t0;
  $[0] !== documentId || $[1] !== operations ? (t0 = async (event) => {
    const isChecked = event.target.checked;
    setCheckboxValue(isChecked), setIsLoading(!0);
    try {
      isChecked ? await operations.edit(documentId, {
        status: "closed"
      }) : isChecked || await operations.edit(documentId, {
        status: "open"
      });
    } catch (t12) {
      console.error("An error occurred while updating the task status", t12);
    }
    setIsLoading(!1);
  }, $[0] = documentId, $[1] = operations, $[2] = t0) : t0 = $[2];
  const handleCheckboxChange = t0;
  let t1;
  return $[3] !== checkboxValue || $[4] !== handleCheckboxChange || $[5] !== isLoading ? (t1 = /* @__PURE__ */ jsx(Flex, { children: isLoading ? /* @__PURE__ */ jsx("div", { style: {
    height: "17px",
    width: "17px"
  }, children: /* @__PURE__ */ jsx(Spinner, { style: {
    marginLeft: "3.5px",
    marginRight: "3.5px",
    marginTop: "3.5px"
  } }) }) : /* @__PURE__ */ jsx(Checkbox$1, { onChange: handleCheckboxChange, checked: checkboxValue, disabled: isLoading }) }), $[3] = checkboxValue, $[4] = handleCheckboxChange, $[5] = isLoading, $[6] = t1) : t1 = $[6], t1;
}
const TitleButton = styled(Button$1).withConfig({
  displayName: "TitleButton",
  componentId: "sc-l0skoq-0"
})`width:100%;max-width:100%;`, TaskDetailsRoot = styled(Flex).withConfig({
  displayName: "TaskDetailsRoot",
  componentId: "sc-l0skoq-1"
})`margin-left:29px;`;
function getTargetDocumentMeta(target) {
  if (target?.document?._ref)
    return {
      _ref: target?.document._ref,
      _type: target?.documentType
    };
}
const FULL_DATE_FORMAT_OPTIONS = {
  dateStyle: "medium",
  timeZone: "UTC"
}, MONTH_AND_DAY_FORMAT_OPTIONS = {
  month: "short",
  day: "numeric",
  timeZone: "UTC"
}, DAY_FORMAT_OPTIONS = {
  weekday: "long",
  timeZone: "UTC"
};
function TaskDueDate(t0) {
  const $ = c(24), {
    dueBy
  } = t0, fullDateFormatter = useDateTimeFormat(FULL_DATE_FORMAT_OPTIONS), monthAndDayFormatter = useDateTimeFormat(MONTH_AND_DAY_FORMAT_OPTIONS), dayFormatter = useDateTimeFormat(DAY_FORMAT_OPTIONS);
  let t1, t2, t3, t4, t5;
  if ($[0] !== dayFormatter || $[1] !== dueBy || $[2] !== fullDateFormatter || $[3] !== monthAndDayFormatter) {
    const date = new Date(dueBy);
    t1 = fullDateFormatter.format(date), t2 = monthAndDayFormatter.format(date), t3 = dayFormatter.format(date), t4 = isToday(date), t5 = isThisISOWeek(date), $[0] = dayFormatter, $[1] = dueBy, $[2] = fullDateFormatter, $[3] = monthAndDayFormatter, $[4] = t1, $[5] = t2, $[6] = t3, $[7] = t4, $[8] = t5;
  } else
    t1 = $[4], t2 = $[5], t3 = $[6], t4 = $[7], t5 = $[8];
  let t6;
  $[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 ? (t6 = {
    fullDate: t1,
    monthAndDay: t2,
    day: t3,
    isDueByToday: t4,
    isDueThisWeek: t5
  }, $[9] = t1, $[10] = t2, $[11] = t3, $[12] = t4, $[13] = t5, $[14] = t6) : t6 = $[14];
  const dateOptions = t6, {
    fullDate,
    monthAndDay,
    day,
    isDueByToday,
    isDueThisWeek
  } = dateOptions, t7 = isDueByToday ? "critical" : "transparent", t8 = isDueByToday ? "Today" : isDueThisWeek ? day : monthAndDay;
  let t9;
  $[15] !== dueBy || $[16] !== t8 ? (t9 = /* @__PURE__ */ jsx(Flex, { align: "center", gap: 2, children: /* @__PURE__ */ jsx(Text$1, { as: "time", size: 1, dateTime: dueBy, muted: !0, children: t8 }) }), $[15] = dueBy, $[16] = t8, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== t7 || $[19] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { tone: t7, padding: 1, radius: 2, children: t9 }), $[18] = t7, $[19] = t9, $[20] = t10) : t10 = $[20];
  let t11;
  return $[21] !== fullDate || $[22] !== t10 ? (t11 = /* @__PURE__ */ jsx(Tooltip, { content: fullDate, children: t10 }), $[21] = fullDate, $[22] = t10, $[23] = t11) : t11 = $[23], t11;
}
function TasksListItem(props2) {
  const $ = c(24), {
    assignedTo,
    title,
    dueBy,
    target,
    onSelect,
    documentId,
    status
  } = props2;
  let t0;
  $[0] !== target ? (t0 = getTargetDocumentMeta(target), $[0] = target, $[1] = t0) : t0 = $[1];
  const targetDocument = t0;
  let t1;
  $[2] !== documentId || $[3] !== status ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(TasksStatus, { documentId, status }) }), $[2] = documentId, $[3] = status, $[4] = t1) : t1 = $[4];
  const t2 = title || "Untitled";
  let t3;
  $[5] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "semibold", children: t2 }), $[5] = t2, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== onSelect || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(Flex, { flex: 1, children: /* @__PURE__ */ jsx(TitleButton, { onClick: onSelect, mode: "bleed", padding: 2, children: t3 }) }), $[7] = onSelect, $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== assignedTo ? (t5 = assignedTo ? {
    id: assignedTo
  } : void 0, $[10] = assignedTo, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t5 ? (t6 = /* @__PURE__ */ jsx(TasksUserAvatar, { user: t5, withTooltip: !0 }), $[12] = t5, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== t1 || $[15] !== t4 || $[16] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
    t1,
    t4,
    t6
  ] }), $[14] = t1, $[15] = t4, $[16] = t6, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== dueBy || $[19] !== targetDocument ? (t8 = (dueBy || targetDocument) && /* @__PURE__ */ jsxs(TaskDetailsRoot, { align: "center", gap: 2, paddingX: 0, children: [
    dueBy && /* @__PURE__ */ jsx(TaskDueDate, { dueBy }),
    targetDocument && /* @__PURE__ */ jsx(Box, { marginLeft: 1, children: /* @__PURE__ */ jsx(DocumentPreview, { documentId: targetDocument._ref, documentType: targetDocument._type }) })
  ] }), $[18] = dueBy, $[19] = targetDocument, $[20] = t8) : t8 = $[20];
  let t9;
  return $[21] !== t7 || $[22] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t7,
    t8
  ] }), $[21] = t7, $[22] = t8, $[23] = t9) : t9 = $[23], t9;
}
const EMPTY_ARRAY$2 = [], getLabelForStatus = (status) => TASK_STATUS.find((item) => item.value === status)?.title, DetailsFlex = styled(Flex).withConfig({
  displayName: "DetailsFlex",
  componentId: "sc-1e5ydah-0"
})`[data-ui='summary-icon']{transition:transform 0.2s;transform:rotate(-90deg);}&[open] [data-ui='summary-icon']{transform:rotate(0);}> summary::-webkit-details-marker{display:none;}`, SummaryBox = styled(Box).withConfig({
  displayName: "SummaryBox",
  componentId: "sc-1e5ydah-1"
})`list-style:none;`;
function TaskList(props2) {
  const $ = c(17), {
    status,
    tasks: tasks2,
    onTaskSelect
  } = props2, t0 = status === "open";
  let t1;
  $[0] !== status ? (t1 = getLabelForStatus(status), $[0] = status, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", muted: !0, children: t1 }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ChevronDownIcon, { "data-ui": "summary-icon" }) }), $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t2 ? (t4 = /* @__PURE__ */ jsx(SummaryBox, { forwardedAs: "summary", paddingY: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, paddingY: 1, children: [
    t2,
    t3
  ] }) }), $[5] = t2, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== onTaskSelect || $[8] !== status || $[9] !== tasks2 ? (t5 = tasks2?.length > 0 ? tasks2.map((task, index) => {
    const showDivider = index < tasks2.length - 1;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(TasksListItem, { documentId: task._id, title: task.title, dueBy: task.dueBy, assignedTo: task.assignedTo, target: task.target, onSelect: () => onTaskSelect(task._id), status: task.status }),
      showDivider && /* @__PURE__ */ jsx(MenuDivider, {})
    ] }, task._id);
  }) : /* @__PURE__ */ jsx(EmptyStatusListState, { status }), $[7] = onTaskSelect, $[8] = status, $[9] = tasks2, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(Stack, { space: 4, marginTop: 3, paddingBottom: 5, children: t5 }), $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  return $[13] !== t0 || $[14] !== t4 || $[15] !== t6 ? (t7 = /* @__PURE__ */ jsxs(DetailsFlex, { forwardedAs: "details", direction: "column", open: t0, children: [
    t4,
    t6
  ] }), $[13] = t0, $[14] = t4, $[15] = t6, $[16] = t7) : t7 = $[16], t7;
}
function TasksList(props2) {
  const $ = c(8), {
    items: t0,
    onTaskSelect
  } = props2, items = t0 === void 0 ? EMPTY_ARRAY$2 : t0;
  let t1;
  $[0] !== items ? (t1 = items.reduce(_temp$E, {}), $[0] = items, $[1] = t1) : t1 = $[1];
  const tasksByStatus = t1, hasOpenTasks = tasksByStatus.open?.length > 0, hasClosedTasks = tasksByStatus.closed?.length > 0;
  let t2;
  return $[2] !== hasClosedTasks || $[3] !== hasOpenTasks || $[4] !== onTaskSelect || $[5] !== tasksByStatus.closed || $[6] !== tasksByStatus.open ? (t2 = /* @__PURE__ */ jsx(Stack, { space: 4, flex: 1, children: !hasOpenTasks && !hasClosedTasks ? /* @__PURE__ */ jsx(EmptyTasksListState, {}) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(TaskList, { status: "open", tasks: tasksByStatus.open, onTaskSelect }),
    /* @__PURE__ */ jsx(TaskList, { status: "closed", tasks: tasksByStatus.closed, onTaskSelect })
  ] }) }), $[2] = hasClosedTasks, $[3] = hasOpenTasks, $[4] = onTaskSelect, $[5] = tasksByStatus.closed, $[6] = tasksByStatus.open, $[7] = t2) : t2 = $[7], t2;
}
function _temp$E(acc, task) {
  return acc[task.status] || (acc[task.status] = []), acc[task.status].push(task), acc;
}
function TasksUpsellPanel() {
  const $ = c(4), {
    upsellData: data,
    telemetryLogs: t0
  } = useTasksUpsell(), {
    panelPrimaryClicked: onPrimaryClick,
    panelSecondaryClicked: onSecondaryClick
  } = t0;
  if (!data)
    return null;
  let t1;
  return $[0] !== data || $[1] !== onPrimaryClick || $[2] !== onSecondaryClick ? (t1 = /* @__PURE__ */ jsx(Container$3, { width: 1, children: /* @__PURE__ */ jsx(Box, { marginBottom: 6, children: /* @__PURE__ */ jsx(UpsellPanel, { data, onPrimaryClick, onSecondaryClick }) }) }), $[0] = data, $[1] = onPrimaryClick, $[2] = onSecondaryClick, $[3] = t1) : t1 = $[3], t1;
}
const LIST_STYLES = {
  marginLeft: "-0.5em",
  justifyContent: "space-between",
  display: "flex"
};
function TasksListTabs(t0) {
  const $ = c(22), {
    activeTabId,
    onChange
  } = t0, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t1;
  $[0] !== t ? (t1 = t("tab.assigned.label"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = {
    id: "assigned",
    label: t1
  }, $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t ? (t3 = t("tab.subscribed.label"), $[4] = t, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t3 ? (t4 = {
    id: "subscribed",
    label: t3
  }, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t ? (t5 = t("tab.document.label"), $[8] = t, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t5 ? (t6 = {
    id: "document",
    label: t5
  }, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t2 || $[13] !== t4 || $[14] !== t6 ? (t7 = [t2, t4, t6], $[12] = t2, $[13] = t4, $[14] = t6, $[15] = t7) : t7 = $[15];
  const tabs = t7;
  let t8;
  $[16] !== onChange ? (t8 = (tab) => {
    onChange(tab.id);
  }, $[16] = onChange, $[17] = t8) : t8 = $[17];
  const handleTabChange = t8;
  let t9;
  return $[18] !== activeTabId || $[19] !== handleTabChange || $[20] !== tabs ? (t9 = /* @__PURE__ */ jsx(TabList, { space: 2, style: LIST_STYLES, children: tabs.map((tab_0) => /* @__PURE__ */ jsx(Tab, { "aria-controls": `${tab_0.id}-panel`, id: `${tab_0.id}-tab`, onClick: () => handleTabChange(tab_0), selected: tab_0.id === activeTabId, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: tab_0.label }) }, `${tab_0.id}-tab`)) }), $[18] = activeTabId, $[19] = handleTabChange, $[20] = tabs, $[21] = t9) : t9 = $[21], t9;
}
const Divider$1 = /* @__PURE__ */ styled.div.withConfig({
  displayName: "Divider",
  componentId: "sc-12ergp7-0"
})((props2) => `
    height: 25px;
    width: 1px;
    background-color: ${getTheme_v2(props2.theme).color.input.default.enabled.border};
  `);
function TasksActiveTabNavigation(props2) {
  const $ = c(41), {
    items: allItems
  } = props2, {
    state,
    setViewMode
  } = useTasksNavigation(), {
    selectedTask
  } = state;
  let items, t0;
  if ($[0] !== allItems || $[1] !== selectedTask) {
    items = allItems.filter(_temp$D);
    let t15;
    $[4] !== selectedTask ? (t15 = (item) => item._id === selectedTask, $[4] = selectedTask, $[5] = t15) : t15 = $[5], t0 = items.findIndex(t15), $[0] = allItems, $[1] = selectedTask, $[2] = items, $[3] = t0;
  } else
    items = $[2], t0 = $[3];
  const currentItemIndex = t0;
  let t1;
  $[6] !== currentItemIndex || $[7] !== items || $[8] !== setViewMode ? (t1 = () => {
    const prevTaskId = currentItemIndex > 0 ? items[currentItemIndex - 1]._id : items[items.length - 1]._id;
    setViewMode({
      type: "edit",
      id: prevTaskId
    });
  }, $[6] = currentItemIndex, $[7] = items, $[8] = setViewMode, $[9] = t1) : t1 = $[9];
  const goToPreviousTask = t1;
  let t2;
  $[10] !== currentItemIndex || $[11] !== items || $[12] !== setViewMode ? (t2 = () => {
    const nextTaskId = currentItemIndex < items.length - 1 ? items[currentItemIndex + 1]._id : items[0]._id;
    setViewMode({
      type: "edit",
      id: nextTaskId
    });
  }, $[10] = currentItemIndex, $[11] = items, $[12] = setViewMode, $[13] = t2) : t2 = $[13];
  const goToNextTask = t2, {
    t: t_0
  } = useTranslation(tasksLocaleNamespace);
  if (!items.length)
    return null;
  let t3;
  $[14] !== t_0 ? (t3 = t_0("buttons.previous.tooltip"), $[14] = t_0, $[15] = t3) : t3 = $[15];
  let t4;
  $[16] !== t3 ? (t4 = {
    content: t3
  }, $[16] = t3, $[17] = t4) : t4 = $[17];
  let t5;
  $[18] !== goToPreviousTask || $[19] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { tooltipProps: t4, mode: "bleed", icon: ChevronLeftIcon, onClick: goToPreviousTask }), $[18] = goToPreviousTask, $[19] = t4, $[20] = t5) : t5 = $[20];
  let t6;
  $[21] !== t_0 ? (t6 = t_0("panel.navigation.tooltip"), $[21] = t_0, $[22] = t6) : t6 = $[22];
  const t7 = currentItemIndex + 1;
  let t8;
  $[23] !== items.length || $[24] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { paddingY: 2, children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t7,
    " / ",
    items.length
  ] }) }), $[23] = items.length, $[24] = t7, $[25] = t8) : t8 = $[25];
  let t9;
  $[26] !== t6 || $[27] !== t8 ? (t9 = /* @__PURE__ */ jsx(Tooltip, { content: t6, children: t8 }), $[26] = t6, $[27] = t8, $[28] = t9) : t9 = $[28];
  let t10;
  $[29] !== t_0 ? (t10 = t_0("buttons.next.tooltip"), $[29] = t_0, $[30] = t10) : t10 = $[30];
  let t11;
  $[31] !== t10 ? (t11 = {
    content: t10
  }, $[31] = t10, $[32] = t11) : t11 = $[32];
  let t12;
  $[33] !== goToNextTask || $[34] !== t11 ? (t12 = /* @__PURE__ */ jsx(Button, { tooltipProps: t11, mode: "bleed", icon: ChevronRightIcon, onClick: goToNextTask }), $[33] = goToNextTask, $[34] = t11, $[35] = t12) : t12 = $[35];
  let t13;
  $[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = /* @__PURE__ */ jsx(Divider$1, {}), $[36] = t13) : t13 = $[36];
  let t14;
  return $[37] !== t12 || $[38] !== t5 || $[39] !== t9 ? (t14 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", children: [
    t5,
    t9,
    t12,
    t13
  ] }) }), $[37] = t12, $[38] = t5, $[39] = t9, $[40] = t14) : t14 = $[40], t14;
}
function _temp$D(t) {
  return t.status === "open";
}
const MENU_BUTTON_POPOVER_PROPS = {
  constrainSize: !0,
  fallbackPlacements: ["bottom-end"],
  placement: "bottom-end",
  portal: !0
}, StyledMenu$4 = styled(Menu).withConfig({
  displayName: "StyledMenu",
  componentId: "sc-1p0npqq-0"
})`width:220px;`;
function TasksDraftsMenuItem(props2) {
  const $ = c(8), {
    isSelected,
    item,
    onSelect
  } = props2;
  let t0;
  $[0] !== item._id || $[1] !== onSelect ? (t0 = () => {
    onSelect(item._id);
  }, $[0] = item._id, $[1] = onSelect, $[2] = t0) : t0 = $[2];
  const handleClick = t0, iconRight = isSelected ? CheckmarkIcon : void 0, text = item.title || "Untitled";
  let t1;
  return $[3] !== handleClick || $[4] !== iconRight || $[5] !== isSelected || $[6] !== text ? (t1 = /* @__PURE__ */ jsx(MenuItem, { iconRight, onClick: handleClick, pressed: isSelected, selected: isSelected, text }), $[3] = handleClick, $[4] = iconRight, $[5] = isSelected, $[6] = text, $[7] = t1) : t1 = $[7], t1;
}
function TasksHeaderDraftsMenu() {
  const $ = c(20), {
    data
  } = useTasks(), {
    state,
    setViewMode
  } = useTasksNavigation(), {
    viewMode,
    selectedTask
  } = state, currentUser = useCurrentUser(), draftTasks = currentUser?.id ? data.filter((task) => {
    const isAuthoredByUser = task.authorId === currentUser.id, isDraft2 = !task.createdByUser, hasEdits = task._updatedAt !== task._createdAt, isNotTheTaskBeingCreated = viewMode === "create" ? task._id !== selectedTask : !0;
    return isAuthoredByUser && isDraft2 && isNotTheTaskBeingCreated && hasEdits;
  }) : EMPTY_ARRAY$y;
  let t0;
  $[0] !== setViewMode ? (t0 = (id2) => {
    setViewMode({
      type: "draft",
      id: id2
    });
  }, $[0] = setViewMode, $[1] = t0) : t0 = $[1];
  const handleSelectTask = t0, {
    t
  } = useTranslation(tasksLocaleNamespace);
  if (!draftTasks.length)
    return null;
  const T0 = MenuButton;
  let t1;
  $[2] !== t ? (t1 = t("buttons.draft.text"), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(Button, { text: t1, mode: "ghost", iconRight: ChevronDownIcon }), $[4] = t1, $[5] = t2) : t2 = $[5];
  const t3 = "edit-task-menu", T1 = StyledMenu$4;
  let t4;
  $[6] !== t ? (t4 = t("panel.drafts.title"), $[6] = t, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t4 }) }), $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx(MenuDivider, {}), $[10] = t6) : t6 = $[10];
  const t7 = draftTasks?.map((task_0) => /* @__PURE__ */ jsx(TasksDraftsMenuItem, { isSelected: selectedTask === task_0._id, item: task_0, onSelect: handleSelectTask }, task_0._id));
  let t8;
  $[11] !== T1 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7 ? (t8 = /* @__PURE__ */ jsxs(T1, { children: [
    t5,
    t6,
    t7
  ] }), $[11] = T1, $[12] = t5, $[13] = t6, $[14] = t7, $[15] = t8) : t8 = $[15];
  let t9;
  return $[16] !== T0 || $[17] !== t2 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsx(T0, { button: t2, id: t3, menu: t8, popover: MENU_BUTTON_POPOVER_PROPS }), $[16] = T0, $[17] = t2, $[18] = t8, $[19] = t9) : t9 = $[19], t9;
}
function TasksSidebarHeader(props2) {
  const $ = c(34), {
    items: allItems
  } = props2, {
    mode
  } = useTasksEnabled(), {
    state,
    setViewMode,
    handleCloseTasks
  } = useTasksNavigation(), {
    viewMode,
    activeTabId
  } = state;
  let t0;
  $[0] !== setViewMode ? (t0 = () => {
    setViewMode({
      type: "create"
    });
  }, $[0] = setViewMode, $[1] = t0) : t0 = $[1];
  const handleTaskCreate = t0;
  let t1;
  $[2] !== setViewMode ? (t1 = () => {
    setViewMode({
      type: "list"
    });
  }, $[2] = setViewMode, $[3] = t1) : t1 = $[3];
  const handleGoBack = t1, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t2;
  $[4] !== activeTabId || $[5] !== handleGoBack || $[6] !== t || $[7] !== viewMode ? (t2 = /* @__PURE__ */ jsx(Flex, { align: "center", flex: 1, children: viewMode === "list" ? /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 2, weight: "semibold", children: t("panel.title") }) }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(Button$1, { mode: "bleed", space: 2, padding: 2, onClick: handleGoBack, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("panel.title") }) }),
    /* @__PURE__ */ jsx(ChevronRightIcon, {}),
    /* @__PURE__ */ jsx(Box, { paddingX: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", style: {
      textTransform: "capitalize"
    }, children: viewMode === "create" || viewMode === "draft" ? t("panel.create.title") : activeTabId }) })
  ] }) }), $[4] = activeTabId, $[5] = handleGoBack, $[6] = t, $[7] = viewMode, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== viewMode ? (t3 = (viewMode === "create" || viewMode === "draft") && /* @__PURE__ */ jsx(TasksHeaderDraftsMenu, {}), $[9] = viewMode, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== allItems || $[12] !== viewMode ? (t4 = viewMode === "edit" && /* @__PURE__ */ jsx(TasksActiveTabNavigation, { items: allItems }), $[11] = allItems, $[12] = viewMode, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== handleTaskCreate || $[15] !== mode || $[16] !== t || $[17] !== viewMode ? (t5 = viewMode === "list" && /* @__PURE__ */ jsx(Button, { icon: AddIcon, onClick: handleTaskCreate, mode: "bleed", text: t("buttons.new.text"), disabled: mode === "upsell", tooltipProps: mode === "upsell" ? {
    content: t("buttons.new.upsell-tooltip")
  } : void 0 }), $[14] = handleTaskCreate, $[15] = mode, $[16] = t, $[17] = viewMode, $[18] = t5) : t5 = $[18];
  let t6;
  $[19] !== t ? (t6 = t("panel.close.tooltip"), $[19] = t, $[20] = t6) : t6 = $[20];
  let t7;
  $[21] !== t6 ? (t7 = {
    content: t6
  }, $[21] = t6, $[22] = t7) : t7 = $[22];
  let t8;
  $[23] !== handleCloseTasks || $[24] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { tooltipProps: t7, iconRight: CloseIcon, mode: "bleed", onClick: handleCloseTasks }), $[23] = handleCloseTasks, $[24] = t7, $[25] = t8) : t8 = $[25];
  let t9;
  $[26] !== t5 || $[27] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t5,
    t8
  ] }), $[26] = t5, $[27] = t8, $[28] = t9) : t9 = $[28];
  let t10;
  return $[29] !== t2 || $[30] !== t3 || $[31] !== t4 || $[32] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { justify: "space-between", align: "center", gap: 1, children: [
    t2,
    t3,
    t4,
    t9
  ] }), $[29] = t2, $[30] = t3, $[31] = t4, $[32] = t9, $[33] = t10) : t10 = $[33], t10;
}
const MotionCard = motion.create(Card), RootCard$1 = styled(MotionCard).withConfig({
  displayName: "RootCard",
  componentId: "sc-a0aemq-0"
})`flex:1;flex-direction:column;`, HeaderStack = styled(Stack).withConfig({
  displayName: "HeaderStack",
  componentId: "sc-a0aemq-1"
})`border-bottom:1px solid var(--card-border-color);`, ContentFlex$1 = styled(Flex).withConfig({
  displayName: "ContentFlex",
  componentId: "sc-a0aemq-2"
})`overflow-y:scroll;overflow-x:hidden;`;
function TasksStudioSidebarInner() {
  const $ = c(39), {
    mode
  } = useTasksEnabled(), {
    activeDocument,
    data,
    isLoading
  } = useTasks(), {
    state,
    setActiveTab,
    setViewMode
  } = useTasksNavigation(), {
    activeTabId,
    viewMode,
    selectedTask
  } = state, currentUser = useCurrentUser();
  let t0;
  $[0] !== setViewMode ? (t0 = (id2) => setViewMode({
    type: "edit",
    id: id2
  }), $[0] = setViewMode, $[1] = t0) : t0 = $[1];
  const onTaskSelect = t0;
  let t1;
  if ($[2] !== activeDocument || $[3] !== activeTabId || $[4] !== currentUser || $[5] !== data) {
    let t22;
    $[7] !== activeDocument || $[8] !== activeTabId || $[9] !== currentUser ? (t22 = (item) => item.createdByUser ? activeTabId === "assigned" ? item.assignedTo === currentUser?.id : activeTabId === "subscribed" ? currentUser?.id && item.subscribers?.includes(currentUser.id) : activeTabId === "document" ? activeDocument?.documentId && item.target?.document._ref === activeDocument.documentId : !1 : !1, $[7] = activeDocument, $[8] = activeTabId, $[9] = currentUser, $[10] = t22) : t22 = $[10], t1 = data.filter(t22), $[2] = activeDocument, $[3] = activeTabId, $[4] = currentUser, $[5] = data, $[6] = t1;
  } else
    t1 = $[6];
  const filteredList = t1;
  let t2;
  bb0: {
    if (viewMode !== "list") {
      let t33;
      $[11] !== selectedTask ? (t33 = /* @__PURE__ */ jsx(TasksFormBuilder, {}, selectedTask), $[11] = selectedTask, $[12] = t33) : t33 = $[12], t2 = t33;
      break bb0;
    }
    if (isLoading) {
      let t33;
      $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t33 = /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", children: /* @__PURE__ */ jsx(Spinner, {}) }), $[13] = t33) : t33 = $[13], t2 = t33;
      break bb0;
    }
    let t32;
    $[14] !== mode ? (t32 = mode === "upsell" && /* @__PURE__ */ jsx(TasksUpsellPanel, {}), $[14] = mode, $[15] = t32) : t32 = $[15];
    let t42;
    $[16] !== filteredList || $[17] !== onTaskSelect ? (t42 = /* @__PURE__ */ jsx(TasksList, { items: filteredList, onTaskSelect }), $[16] = filteredList, $[17] = onTaskSelect, $[18] = t42) : t42 = $[18];
    let t52;
    $[19] !== t32 || $[20] !== t42 ? (t52 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
      t32,
      t42
    ] }), $[19] = t32, $[20] = t42, $[21] = t52) : t52 = $[21], t2 = t52;
  }
  const content = t2;
  let t3;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    opacity: 0
  }, $[22] = t3) : t3 = $[22];
  let t4;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    opacity: 1,
    transition: {
      duration: 0.2
    }
  }, $[23] = t4) : t4 = $[23];
  let t5;
  $[24] !== filteredList ? (t5 = /* @__PURE__ */ jsx(TasksSidebarHeader, { items: filteredList }), $[24] = filteredList, $[25] = t5) : t5 = $[25];
  let t6;
  $[26] !== activeTabId || $[27] !== isLoading || $[28] !== setActiveTab || $[29] !== viewMode ? (t6 = viewMode === "list" && !isLoading && /* @__PURE__ */ jsx(TasksListTabs, { activeTabId, onChange: setActiveTab }), $[26] = activeTabId, $[27] = isLoading, $[28] = setActiveTab, $[29] = viewMode, $[30] = t6) : t6 = $[30];
  let t7;
  $[31] !== t5 || $[32] !== t6 ? (t7 = /* @__PURE__ */ jsxs(HeaderStack, { space: 3, padding: 3, sizing: "border", children: [
    t5,
    t6
  ] }), $[31] = t5, $[32] = t6, $[33] = t7) : t7 = $[33];
  let t8;
  $[34] !== content ? (t8 = /* @__PURE__ */ jsx(ContentFlex$1, { direction: "column", flex: 1, overflow: "auto", padding: 3, paddingTop: 4, paddingX: 4, sizing: "border", children: content }), $[34] = content, $[35] = t8) : t8 = $[35];
  let t9;
  return $[36] !== t7 || $[37] !== t8 ? (t9 = /* @__PURE__ */ jsxs(RootCard$1, { display: "flex", height: "fill", flex: 1, overflow: "hidden", initial: t3, animate: t4, children: [
    t7,
    t8
  ] }), $[36] = t7, $[37] = t8, $[38] = t9) : t9 = $[38], t9;
}
function TasksStudioSidebar() {
  const $ = c(1), {
    enabled
  } = useTasksEnabled();
  if (!enabled)
    return null;
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(TasksStudioSidebarInner, {}), $[0] = t0) : t0 = $[0], t0;
}
const FULLSCREEN_MEDIA_INDEX = 1, POSITION_ABSOLUTE_MEDIA_INDEX = 3, RootFlex$1 = /* @__PURE__ */ styled(Flex).withConfig({
  displayName: "RootFlex",
  componentId: "sc-1y8zfkj-0"
})(({
  theme
}) => {
  const media = theme.sanity.media;
  return css`
    min-height: 100%;

    @media (max-width: ${media[POSITION_ABSOLUTE_MEDIA_INDEX]}px) {
      position: relative;
    }
  `;
}), SidebarMotionLayer = /* @__PURE__ */ styled(Layer).withConfig({
  displayName: "SidebarMotionLayer",
  componentId: "sc-1y8zfkj-1"
})(({
  theme
}) => {
  const media = theme.sanity.media;
  return css`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 360px;
    border-left: 1px solid var(--card-border-color);
    box-sizing: border-box;
    overflow: hidden;

    box-shadow:
      0px 6px 8px -4px var(--card-shadow-umbra-color),
      0px 12px 17px -1px var(--card-shadow-penumbra-color);

    @media (max-width: ${media[POSITION_ABSOLUTE_MEDIA_INDEX]}px) {
      bottom: 0;
      position: absolute;
      right: 0;
      top: 0;
    }

    @media (max-width: ${media[FULLSCREEN_MEDIA_INDEX]}px) {
      border-left: 0;
      min-width: 100%;
      left: 0;
    }
  `;
});
function TasksStudioActiveToolLayoutInner(props2) {
  const $ = c(12), mediaIndex = useMediaIndex(), {
    state: t0
  } = useTasksNavigation(), {
    isOpen
  } = t0, t1 = mediaIndex <= FULLSCREEN_MEDIA_INDEX && isOpen ? "hidden" : "auto";
  let t2;
  $[0] !== props2 ? (t2 = props2.renderDefault(props2), $[0] = props2, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== t1 || $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { flex: 1, height: "fill", overflow: t1, children: t2 }), $[2] = t1, $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== isOpen ? (t4 = isOpen && /* @__PURE__ */ jsx(SidebarMotionLayer, { zOffset: 100, height: "fill", children: /* @__PURE__ */ jsx(TasksStudioSidebar, {}) }), $[5] = isOpen, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(AnimatePresence, { initial: !1, children: t4 }), $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  return $[9] !== t3 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsxs(RootFlex$1, { sizing: "border", height: "fill", children: [
    t3,
    t5
  ] }), $[9] = t3, $[10] = t5, $[11] = t6) : t6 = $[11], t6;
}
function TasksStudioActiveToolLayout(props2) {
  const $ = c(4), {
    enabled
  } = useTasksEnabled();
  if (!enabled) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== props2 ? (t0 = /* @__PURE__ */ jsx(TasksStudioActiveToolLayoutInner, { ...props2 }), $[2] = props2, $[3] = t0) : t0 = $[3], t0;
}
const TasksStudioLayoutInner = (props2) => {
  const $ = c(10), {
    enabled,
    mode
  } = useTasksEnabled();
  if (!enabled) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  $[2] !== props2 ? (t0 = props2.renderDefault(props2), $[2] = props2, $[3] = t0) : t0 = $[3];
  let t1;
  $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(TasksProvider, { children: /* @__PURE__ */ jsx(TasksNavigationProvider, { children: t0 }) }), $[4] = t0, $[5] = t1) : t1 = $[5];
  const children = t1;
  if (mode === "upsell") {
    let t22;
    return $[6] !== children ? (t22 = /* @__PURE__ */ jsx(AddonDatasetProvider, { children: /* @__PURE__ */ jsx(TasksUpsellProvider, { children }) }), $[6] = children, $[7] = t22) : t22 = $[7], t22;
  }
  let t2;
  return $[8] !== children ? (t2 = /* @__PURE__ */ jsx(AddonDatasetProvider, { children }), $[8] = children, $[9] = t2) : t2 = $[9], t2;
};
function TasksStudioLayout(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(TasksEnabledProvider, { children: /* @__PURE__ */ jsx(TasksStudioLayoutInner, { ...props2 }) }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
const EMPTY_ARRAY$1 = [], TasksToolbar = (t0) => {
  const $ = c(8), {
    onClick: onClick2,
    isOpen
  } = t0, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t1;
  $[0] !== t ? (t1 = t("toolbar.tooltip"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = {
    content: t1
  }, $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  return $[4] !== isOpen || $[5] !== onClick2 || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Button, { tooltipProps: t2, icon: CheckmarkCircleIcon, mode: "bleed", onClick: onClick2, selected: isOpen, "data-testid": "tasks-toolbar" }), $[4] = isOpen, $[5] = onClick2, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
};
function TasksStudioNavbarInner(props2) {
  const $ = c(22), {
    handleOpenTasks,
    handleCloseTasks,
    state: t0
  } = useTasksNavigation(), {
    isOpen
  } = t0, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t1;
  $[0] !== handleCloseTasks || $[1] !== handleOpenTasks || $[2] !== isOpen ? (t1 = () => {
    isOpen ? handleCloseTasks() : handleOpenTasks();
  }, $[0] = handleCloseTasks, $[1] = handleOpenTasks, $[2] = isOpen, $[3] = t1) : t1 = $[3];
  const handleClick = t1;
  let t2;
  $[4] !== handleClick || $[5] !== isOpen ? (t2 = () => /* @__PURE__ */ jsx(TasksToolbar, { onClick: handleClick, isOpen }), $[4] = handleClick, $[5] = isOpen, $[6] = t2) : t2 = $[6];
  const renderTasksNav = t2, t3 = props2?.__internal_actions || EMPTY_ARRAY$1;
  let t4;
  $[7] !== renderTasksNav ? (t4 = {
    location: "topbar",
    name: "tasks-topbar",
    render: renderTasksNav
  }, $[7] = renderTasksNav, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t ? (t5 = t("actions.open.text"), $[9] = t, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== handleClick || $[12] !== isOpen || $[13] !== t5 ? (t6 = {
    icon: CheckmarkCircleIcon,
    location: "sidebar",
    name: "tasks-sidebar",
    onAction: handleClick,
    selected: isOpen,
    title: t5
  }, $[11] = handleClick, $[12] = isOpen, $[13] = t5, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== t3 || $[16] !== t4 || $[17] !== t6 ? (t7 = [...t3, t4, t6], $[15] = t3, $[16] = t4, $[17] = t6, $[18] = t7) : t7 = $[18];
  const actions = t7;
  let t8;
  return $[19] !== actions || $[20] !== props2 ? (t8 = props2.renderDefault({
    ...props2,
    __internal_actions: actions
  }), $[19] = actions, $[20] = props2, $[21] = t8) : t8 = $[21], t8;
}
function TasksStudioNavbar(props2) {
  const $ = c(4), {
    enabled
  } = useTasksEnabled();
  if (!enabled) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== props2 ? (t0 = /* @__PURE__ */ jsx(TasksStudioNavbarInner, { ...props2 }), $[2] = props2, $[3] = t0) : t0 = $[3], t0;
}
const TASKS_NAME = "sanity/tasks", tasks = definePlugin({
  name: TASKS_NAME,
  // eslint-disable-next-line camelcase
  __internal_tasks: {
    footerAction: /* @__PURE__ */ jsx(TasksFooterOpenTasks, {})
  },
  document: {
    actions: (prev) => [...prev, TaskCreateAction].filter(Boolean)
  },
  studio: {
    components: {
      layout: TasksStudioLayout,
      navbar: TasksStudioNavbar,
      activeToolLayout: TasksStudioActiveToolLayout
    }
  },
  form: {
    components: {
      input: (props2) => props2.id === "root" && props2.schemaType.type?.name === "document" ? /* @__PURE__ */ jsx(TasksDocumentInputLayout, { ...props2 }) : props2.renderDefault(props2)
    }
  },
  i18n: {
    bundles: [tasksUsEnglishLocaleBundle]
  }
}), defaultPlugins = (options) => [comments(), tasks(), scheduledPublishing(), releases(), canvasIntegration(), mediaLibrary(), schedules(options), singleDocRelease()];
function getDefaultPlugins(options, plugins) {
  return defaultPlugins(options).filter((plugin) => plugin.name === SCHEDULED_PUBLISHING_NAME ? options.scheduledPublishing.enabled && !!plugins?.length : plugin.name === TASKS_NAME ? options.tasks.enabled : plugin.name === RELEASES_NAME ? options.releases.enabled : plugin.name === CANVAS_INTEGRATION_NAME ? options.apps?.canvas?.enabled ?? !1 : plugin.name === MEDIA_LIBRARY_NAME ? options.mediaLibrary?.enabled : plugin.name === SCHEDULES_NAME ? options.releases.enabled || options.scheduledDrafts?.enabled : plugin.name === SINGLE_DOC_RELEASE_NAME ? options.scheduledDrafts?.enabled : !0);
}
function getDefaultPluginsOptions(workspace) {
  return {
    tasks: {
      enabled: !0,
      ...workspace.unstable_tasks,
      ...workspace.tasks
    },
    scheduledPublishing: {
      enabled: !0,
      // 25/12/2022 22:00
      inputDateTimeFormat: "dd/MM/yyyy HH:mm",
      ...workspace.scheduledPublishing,
      // If the user has explicitly enabled scheduled publishing, we should respect that
      // eslint-disable-next-line camelcase
      __internal__workspaceEnabled: workspace.scheduledPublishing?.enabled ?? !1
    },
    releases: {
      ...workspace.releases,
      enabled: workspace.releases?.enabled ?? !0
    },
    apps: {
      canvas: {
        // By default canvas app is enabled
        enabled: !0,
        ...workspace.apps?.canvas
      }
    },
    mediaLibrary: workspace?.mediaLibrary,
    scheduledDrafts: workspace.scheduledDrafts ?? {
      enabled: !0
    }
  };
}
function resolveSchemaTypes({
  config,
  context
}) {
  return resolveConfigProperty({
    propertyName: "schema.types",
    config,
    context,
    initialValue: [],
    reducer: schemaTypesReducer
  });
}
class SchemaError extends Error {
  constructor(schema2) {
    super("SchemaError"), this.schema = schema2, this.name = "SchemaError";
  }
}
const debug$3 = debug$c("sanity:config"), isError$1 = (p) => p.severity === "error";
function normalizeIcon$1(Icon2, title, subtitle = "") {
  return isValidElementType(Icon2) ? /* @__PURE__ */ jsx(Icon2, {}) : isValidElement(Icon2) ? Icon2 : createDefaultIcon(title, subtitle);
}
const preparedWorkspaces = /* @__PURE__ */ new WeakMap(), createMediaLibraryAssetSources = (config) => {
  const libraryId = mediaLibraryLibraryIdReducer({
    config,
    initialValue: void 0
  });
  if (!mediaLibraryEnabledReducer({
    config,
    initialValue: !1
  }))
    return {
      fileSource: null,
      imageSource: null
    };
  const fileSource = createSanityMediaLibraryFileSource({
    libraryId: libraryId || null
  }), imageSource = createSanityMediaLibraryImageSource({
    libraryId: libraryId || null
  });
  return {
    fileSource,
    imageSource
  };
}, createDatasetAssetSources = (config, client) => {
  const fileSource = createDatasetFileAssetSource({
    client,
    title: config.title || config.name
  }), imageSource = createDatasetImageAssetSource({
    client,
    title: config.title || config.name
  });
  return {
    fileSource,
    imageSource
  };
};
function prepareConfig(config, options) {
  if (!Array.isArray(config) && "missingConfigFile" in config)
    throw new ConfigResolutionError({
      name: "",
      type: "configuration file",
      causes: ["No `sanity.config.ts` file found", "No `sanity.config.js` file found"]
    });
  const rootPath = getRootPath(options?.basePath), workspaceOptions = Array.isArray(config) ? config : [{
    ...config,
    name: config.name ?? "default"
  }];
  try {
    validateWorkspaces({
      workspaces: workspaceOptions
    });
  } catch (e) {
    throw new ConfigResolutionError({
      name: "",
      type: "workspace",
      causes: [e.message]
    });
  }
  return {
    type: "prepared-config",
    workspaces: workspaceOptions.map((rawWorkspace) => {
      if (preparedWorkspaces.has(rawWorkspace))
        return preparedWorkspaces.get(rawWorkspace);
      const defaultPluginsOptions = getDefaultPluginsOptions(rawWorkspace), {
        unstable_sources: nestedSources = [],
        ...rootSource
      } = rawWorkspace, resolvedSources = [rootSource, ...nestedSources].map(({
        plugins,
        ...source
      }) => ({
        ...source,
        plugins: [...plugins ?? [], ...getDefaultPlugins(defaultPluginsOptions, plugins)].filter((plugin) => {
          const validPlugin = plugin.name !== "@sanity/assist" || plugin.handlesGDR;
          return validPlugin || console.warn(`Found an incompatible version of @sanity/assist plugin. It has been disabled.
To re-enable the plugin, please upgrade to https://github.com/sanity-io/assist/releases/tag/v3.2.2 or later.`), validPlugin;
        })
      })).map((source) => {
        const {
          projectId,
          dataset
        } = source;
        let schemaTypes;
        try {
          schemaTypes = resolveSchemaTypes({
            config: source,
            context: {
              projectId,
              dataset
            }
          });
        } catch (e) {
          throw new ConfigResolutionError({
            name: source.name,
            type: "source",
            causes: [e]
          });
        }
        const schema2 = createSchema({
          name: source.name,
          types: schemaTypes
        }), schemaValidationProblemGroups = schema2._validation, schemaErrors = schemaValidationProblemGroups?.filter((msg) => msg.problems.some(isError$1));
        if (schemaValidationProblemGroups && schemaErrors?.length)
          throw new SchemaError(schema2);
        const auth = getAuthStore(source), i18n = prepareI18n(source), source$ = auth.state.pipe(map(({
          client,
          authenticated,
          currentUser
        }) => resolveSource$1({
          config: source,
          client,
          currentUser,
          schema: schema2,
          authenticated,
          auth,
          i18n
        })), shareReplay(1));
        return {
          name: source.name,
          projectId: source.projectId,
          dataset: source.dataset,
          title: source.title || startCase(source.name),
          auth,
          schema: schema2,
          i18n: i18n.source,
          source: source$
        };
      }), title = rootSource.title || startCase(rootSource.name), workspaceSummary = {
        type: "workspace-summary",
        auth: resolvedSources[0].auth,
        basePath: joinBasePath(rootPath, rootSource.basePath),
        dataset: rootSource.dataset,
        apiHost: rootSource.apiHost,
        schema: resolvedSources[0].schema,
        i18n: resolvedSources[0].i18n,
        customIcon: !!rootSource.icon,
        icon: normalizeIcon$1(rootSource.icon, title, `${rootSource.projectId} ${rootSource.dataset}`),
        name: rootSource.name || "default",
        projectId: rootSource.projectId,
        theme: rootSource.theme || studioTheme,
        title,
        subtitle: rootSource.subtitle,
        __internal: {
          sources: resolvedSources
        },
        ...defaultPluginsOptions
      };
      return preparedWorkspaces.set(rawWorkspace, workspaceSummary), workspaceSummary;
    })
  };
}
function getAuthStore(source) {
  if (isAuthStore(source.auth))
    return source.auth;
  const clientFactory = source.unstable_clientFactory || createClient, {
    projectId,
    dataset,
    apiHost
  } = source;
  return createAuthStore({
    apiHost,
    ...source.auth,
    clientFactory,
    dataset,
    projectId
  });
}
function getBifurClient(client, auth) {
  const bifurVersionedClient = client.withConfig({
    apiVersion: "2022-06-30"
  }), {
    dataset,
    url: baseUrl,
    requestTagPrefix = "sanity.studio"
  } = bifurVersionedClient.config(), urlWithTag = `${`${baseUrl.replace(/\/+$/, "")}/socket/${dataset}`.replace(/^http/, "ws")}?tag=${requestTagPrefix}`, options = auth.token ? {
    token$: auth.token
  } : {};
  return fromUrl(urlWithTag, options);
}
function resolveSource$1({
  config,
  client,
  currentUser,
  schema: schema2,
  authenticated,
  auth,
  i18n
}) {
  const {
    dataset,
    projectId
  } = config, bifur = getBifurClient(client, auth), errors = [], clients = {}, getClient2 = (options) => {
    if (!options || !options.apiVersion)
      throw new Error("Missing required `apiVersion` option");
    return clients[options.apiVersion] || (clients[options.apiVersion] = client.withConfig(options)), clients[options.apiVersion];
  }, context = {
    client,
    getClient: getClient2,
    currentUser,
    dataset,
    projectId,
    schema: schema2,
    i18n: i18n.source,
    [DECISION_PARAMETERS_SCHEMA]: decisionParametersSchemaReducer({
      config,
      initialValue: void 0
    })
  }, wrappedClient = client;
  context.client = [...Object.keys(client), ...Object.keys(wrappedClient.__proto__)].reduce((acc, key) => {
    const original = Object.hasOwnProperty.call(client, key) ? wrappedClient[key] : wrappedClient.__proto__[key];
    return Object.defineProperty(acc, key, {
      get() {
        return console.warn('`configContext.client` is deprecated and will be removed in the next release! Use `context.getClient({apiVersion: "2021-06-07"})` instead'), original;
      }
    });
  }, {});
  const defaultAssetSources = createDatasetAssetSources(config, context.client), mediaLibraryAssetSources = createMediaLibraryAssetSources(config);
  let templates;
  try {
    templates = resolveConfigProperty({
      config,
      context,
      propertyName: "schema.templates",
      reducer: schemaTemplatesReducer,
      initialValue: schema2.getTypeNames().filter((typeName) => !typeName.startsWith("sanity.")).map((typeName) => schema2.get(typeName)).filter(isNonNullable$2).filter((schemaType) => schemaType.type?.name === "document").map((schemaType) => ({
        id: schemaType.name,
        schemaType: schemaType.name,
        title: schemaType.title || schemaType.name,
        icon: schemaType.icon,
        value: schemaType.initialValue || {
          _type: schemaType.name
        }
      }))
    });
  } catch (e) {
    throw new ConfigResolutionError({
      name: config.name,
      type: "source",
      causes: [e]
    });
  }
  let tools;
  try {
    tools = resolveConfigProperty({
      config,
      context,
      initialValue: [],
      propertyName: "tools",
      reducer: toolsReducer
    });
  } catch (e) {
    throw new ConfigResolutionError({
      name: config.name,
      type: "source",
      causes: [e]
    });
  }
  if (tools.some(({
    name
  }) => name === "tool"))
    throw new Error('A tool cannot have the name "tool". Please enter a different name.');
  const initialTemplatesResponses = templates.filter((template) => !template.parameters?.length).map((template) => ({
    templateId: template.id,
    description: template.description,
    icon: template.icon,
    title: template.title
  })), templateMap = templates.reduce((acc, template) => (acc.set(template.id, template), acc), /* @__PURE__ */ new Map()), resolveNewDocumentOptions = (creationContext) => {
    const {
      schemaType: schemaTypeName
    } = creationContext, templateResponses = resolveConfigProperty({
      config,
      context: {
        ...context,
        creationContext
      },
      initialValue: initialTemplatesResponses,
      propertyName: "document.resolveNewDocumentOptions",
      reducer: newDocumentOptionsResolver
    }), templateErrors = [];
    if (templateErrors.length)
      throw new ConfigResolutionError({
        name: config.name,
        type: "source",
        causes: templateErrors
      });
    return templateResponses.map((response, index) => {
      const template = templateMap.get(response.templateId);
      if (!template)
        throw new Error(`Could not find template with ID \`${response.templateId}\``);
      const schemaType = schema2.get(template.schemaType);
      if (!schemaType)
        throw new Error(`Could not find matching schema type \`${template.schemaType}\` for template \`${template.id}\``);
      const title = response.title || template.title, defaultSubtitle = schemaType?.title === title ? void 0 : schemaType?.title;
      return {
        id: `${response.templateId}-${index}`,
        templateId: response.templateId,
        type: "initialValueTemplateItem",
        title,
        i18n: response.i18n || template.i18n,
        subtitle: response.subtitle || defaultSubtitle,
        description: response.description || template.description,
        icon: response.icon || template.icon || schemaType?.icon,
        initialDocumentId: response.initialDocumentId,
        parameters: response.parameters,
        schemaType: template.schemaType
      };
    }).filter((item) => !schemaTypeName || creationContext.type === "document" ? !0 : schemaTypeName === templateMap.get(item.templateId)?.schemaType);
  };
  let staticInitialValueTemplateItems;
  try {
    staticInitialValueTemplateItems = resolveNewDocumentOptions({
      type: "global"
    });
  } catch (e) {
    errors.push(e);
  }
  if (errors.length)
    throw new ConfigResolutionError({
      name: config.name,
      type: "source",
      causes: errors
    });
  return {
    type: "source",
    name: config.name,
    title: config.title || startCase(config.name),
    schema: schema2,
    getClient: getClient2,
    dataset,
    projectId,
    tools,
    currentUser,
    authenticated,
    templates,
    auth,
    i18n: i18n.source,
    // eslint-disable-next-line camelcase
    __internal_tasks: internalTasksReducer({
      config
    }),
    document: {
      actions: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: initialDocumentActions,
        propertyName: "document.actions",
        reducer: documentActionsReducer
      }),
      badges: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: initialDocumentBadges,
        propertyName: "document.badges",
        reducer: documentBadgesReducer
      }),
      drafts: {
        enabled: resolveConfigProperty({
          config,
          context,
          reducer: draftsEnabledReducer,
          propertyName: "document.drafts.enabled",
          initialValue: !0
        })
      },
      unstable_fieldActions: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: initialDocumentFieldActions,
        propertyName: "document.unstable_fieldActions",
        reducer: documentFieldActionsReducer
      }),
      inspectors: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: EMPTY_ARRAY$y,
        propertyName: "document.inspectors",
        reducer: documentInspectorsReducer
      }),
      resolveProductionUrl: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: void 0,
        propertyName: "resolveProductionUrl",
        asyncReducer: resolveProductionUrlReducer
      }),
      resolveNewDocumentOptions,
      unstable_languageFilter: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: initialLanguageFilter,
        propertyName: "document.unstable_languageFilter",
        reducer: documentLanguageFilterReducer
      }),
      /** @todo this is deprecated so it will eventually be removed */
      unstable_comments: {
        enabled: (partialContext) => documentCommentsEnabledReducer({
          context: partialContext,
          config,
          initialValue: !0
        })
      },
      comments: {
        enabled: (partialContext) => documentCommentsEnabledReducer({
          context: partialContext,
          config,
          initialValue: !0
        })
      }
    },
    form: {
      file: {
        assetSources: resolveConfigProperty({
          config,
          context,
          initialValue: mediaLibraryAssetSources.fileSource ? [mediaLibraryAssetSources.fileSource, defaultAssetSources.fileSource] : [defaultAssetSources.fileSource],
          propertyName: "formBuilder.file.assetSources",
          reducer: fileAssetSourceResolver
        }),
        directUploads: directUploadsReducer({
          config,
          schemaTypeName: "file"
        })
      },
      image: {
        assetSources: resolveConfigProperty({
          config,
          context,
          initialValue: mediaLibraryAssetSources.imageSource ? [mediaLibraryAssetSources.imageSource, defaultAssetSources.imageSource] : [defaultAssetSources.imageSource],
          propertyName: "formBuilder.image.assetSources",
          reducer: imageAssetSourceResolver
        }),
        directUploads: directUploadsReducer({
          config,
          schemaTypeName: "image"
        })
      }
    },
    search: {
      filters: filterDefinitions,
      operators: operatorDefinitions,
      unstable_partialIndexing: {
        enabled: partialIndexingEnabledReducer({
          config,
          initialValue: config.search?.unstable_partialIndexing?.enabled ?? !1
        })
      },
      strategy: searchStrategyReducer({
        config,
        initialValue: "groqLegacy"
      }),
      enableLegacySearch: resolveConfigProperty({
        config,
        context,
        reducer: legacySearchEnabledReducer,
        propertyName: "enableLegacySearch",
        initialValue: !0
      })
      // we will use this when we add search config to PluginOptions
      /*filters: resolveConfigProperty({
        config,
        context: context,
        initialValue: filterDefinitions,
        propertyName: 'search.filters',
        reducer: searchFilterReducer,
      }),
      operators: resolveConfigProperty({
        config,
        context: context,
        initialValue: operatorDefinitions as SearchOperatorDefinition[],
        propertyName: 'search.operators',
        reducer: searchOperatorsReducer,
      }),*/
    },
    __internal: {
      bifur,
      i18next: i18n.i18next,
      staticInitialValueTemplateItems,
      options: config,
      schemaDescriptorId: authenticated ? catchTap(uploadSchema(schema2, getClient2(DEFAULT_STUDIO_CLIENT_OPTIONS)), (err) => {
        debug$3("Uploading schema failed", {
          err
        });
      }) : Promise.resolve(void 0)
    },
    onUncaughtError: (error, errorInfo) => onUncaughtErrorResolver({
      config,
      context: {
        error,
        errorInfo
      }
    }),
    beta: {
      eventsAPI: {
        documents: eventsAPIReducer({
          config,
          initialValue: !0,
          key: "documents"
        }),
        releases: eventsAPIReducer({
          config,
          initialValue: !1,
          key: "releases"
        })
      }
    },
    // eslint-disable-next-line camelcase
    __internal_serverDocumentActions: {
      enabled: serverDocumentActionsReducer({
        config,
        initialValue: void 0
      })
    },
    announcements: {
      enabled: announcementsEnabledReducer({
        config,
        initialValue: !0
      })
    },
    mediaLibrary: {
      enabled: mediaLibraryEnabledReducer({
        config,
        initialValue: !1
      }),
      libraryId: mediaLibraryLibraryIdReducer({
        config,
        initialValue: void 0
      }),
      __internal: {
        frontendHost: mediaLibraryFrontendHostReducer({
          config,
          initialValue: void 0
        })
      }
    },
    advancedVersionControl: {
      enabled: resolveConfigProperty({
        config,
        context,
        reducer: advancedVersionControlEnabledReducer,
        propertyName: "advancedVersionControl.enabled",
        initialValue: !1
      })
    },
    scheduledDrafts: {
      enabled: scheduledDraftsEnabledReducer({
        config,
        initialValue: !0
      })
    },
    releases: config.releases ? {
      enabled: config.releases.enabled ?? !0,
      limit: config.releases.limit,
      actions: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: [],
        propertyName: "releases.actions",
        reducer: releaseActionsReducer
      })
    } : {
      enabled: !0
    }
  };
}
function getRootPath(basePath) {
  const rootPath = basePath || "";
  if (typeof rootPath != "string" || rootPath.length > 0 && !rootPath.startsWith("/"))
    throw new ConfigResolutionError({
      name: "",
      type: "options",
      causes: ["basePath must be a string, and must start with a slash"]
    });
  return rootPath === "/" ? "" : rootPath;
}
function joinBasePath(rootPath, basePath) {
  return `/${[rootPath, basePath || ""].map((path) => path.replace(/^\/+/g, "").replace(/\/+$/g, "")).filter(Boolean).join("/")}`;
}
function catchTap(promise, cb) {
  return promise.catch(cb), promise;
}
function resolveConfig(config) {
  const {
    workspaces
  } = prepareConfig(config);
  return combineLatest(workspaces.flatMap((workspaceSummary) => combineLatest(workspaceSummary.__internal.sources.map(({
    source
  }) => source)).pipe(map((sources) => {
    const {
      releases: _releases,
      ...workspaceMetadata
    } = workspaceSummary;
    return {
      ...workspaceMetadata,
      ...sources[0],
      unstable_sources: sources,
      type: "workspace"
    };
  }))));
}
async function createWorkspaceFromConfig(options) {
  const client = "getClient" in options ? options.getClient({
    apiVersion: "2023-11-13"
  }) : void 0, [workspace] = await firstValueFrom(resolveConfig({
    ...options,
    ...client && "currentUser" in options && {
      auth: createMockAuthStore({
        ...options,
        client
      })
    }
  }));
  return workspace;
}
async function createSourceFromConfig(options) {
  return (await createWorkspaceFromConfig(options)).unstable_sources[0];
}
function useConfigContextFromSource(source) {
  const $ = c(7), {
    projectId,
    dataset,
    schema: schema2,
    currentUser,
    getClient: getClient2,
    i18n
  } = source;
  let t0;
  return $[0] !== currentUser || $[1] !== dataset || $[2] !== getClient2 || $[3] !== i18n || $[4] !== projectId || $[5] !== schema2 ? (t0 = {
    projectId,
    dataset,
    schema: schema2,
    currentUser,
    getClient: getClient2,
    i18n
  }, $[0] = currentUser, $[1] = dataset, $[2] = getClient2, $[3] = i18n, $[4] = projectId, $[5] = schema2, $[6] = t0) : t0 = $[6], t0;
}
function getConfigContextFromSource(source) {
  const {
    projectId,
    dataset,
    schema: schema2,
    currentUser,
    getClient: getClient2,
    i18n
  } = source;
  return {
    projectId,
    dataset,
    schema: schema2,
    currentUser,
    getClient: getClient2,
    i18n
  };
}
function WorkspacesProvider(t0) {
  const $ = c(8), {
    config,
    children,
    basePath,
    LoadingComponent
  } = t0;
  let t1;
  $[0] !== basePath || $[1] !== config ? (t1 = prepareConfig(config, {
    basePath
  }), $[0] = basePath, $[1] = config, $[2] = t1) : t1 = $[2];
  const workspaces = useDeferredValue(t1.workspaces, null);
  if (workspaces === null) {
    let t22;
    return $[3] !== LoadingComponent ? (t22 = /* @__PURE__ */ jsx(LoadingComponent, {}), $[3] = LoadingComponent, $[4] = t22) : t22 = $[4], t22;
  }
  let t2;
  return $[5] !== children || $[6] !== workspaces ? (t2 = /* @__PURE__ */ jsx(WorkspacesContext.Provider, { value: workspaces, children }), $[5] = children, $[6] = workspaces, $[7] = t2) : t2 = $[7], t2;
}
function RouterHistoryProvider(t0) {
  const $ = c(3), {
    children,
    history: history2
  } = t0;
  let t1;
  return $[0] !== children || $[1] !== history2 ? (t1 = /* @__PURE__ */ jsx(RouterHistoryContext.Provider, { value: history2, children }), $[0] = children, $[1] = history2, $[2] = t1) : t1 = $[2], t1;
}
function useRouterHistory() {
  const value = useContext(RouterHistoryContext);
  if (!value)
    throw new Error("Could not find `RouterHistoryProvider` context");
  return value;
}
const ActiveWorkspaceMatcherProvider = memo(function(t0) {
  const $ = c(9), {
    children,
    history: history2,
    activeWorkspace,
    setActiveWorkspace
  } = t0;
  let t1;
  $[0] !== activeWorkspace || $[1] !== setActiveWorkspace ? (t1 = {
    activeWorkspace,
    setActiveWorkspace
  }, $[0] = activeWorkspace, $[1] = setActiveWorkspace, $[2] = t1) : t1 = $[2];
  const value = t1;
  let t2;
  $[3] !== children || $[4] !== history2 ? (t2 = /* @__PURE__ */ jsx(RouterHistoryProvider, { history: history2, children }), $[3] = children, $[4] = history2, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== t2 || $[7] !== value ? (t3 = /* @__PURE__ */ jsx(ActiveWorkspaceMatcherContext.Provider, { value, children: t2 }), $[6] = t2, $[7] = value, $[8] = t3) : t3 = $[8], t3;
});
function createCommonBasePathRegex(workspaces) {
  const commonBasePath = workspaces.map((workspace) => (
    // gets the segments from the basePath
    workspace.basePath.slice(1).split("/")
  )).reduce((commonSegments, segments) => {
    for (let i = 0; i < commonSegments.length; i++) {
      const commonSegment = commonSegments[i], segment = segments[i].toLowerCase();
      if (commonSegment !== segment)
        return commonSegments.slice(0, i);
    }
    return commonSegments;
  });
  function createCommonBasePathRegexRecursively([first2, ...rest]) {
    return first2 ? `(\\/${escapeRegExp$1(first2)}${createCommonBasePathRegexRecursively(rest)}(\\/|$))?` : "";
  }
  return new RegExp(`^${createCommonBasePathRegexRecursively(commonBasePath)}$`, "i");
}
function matchWorkspace({
  pathname,
  workspaces,
  basePathRegex
}) {
  const [firstWorkspace] = workspaces;
  for (const {
    workspace,
    basePath,
    basePathRegex: basePathRegex2
  } of workspaces)
    if (basePathRegex2.test(pathname) || basePath === "/")
      return {
        type: "match",
        workspace
      };
  return pathname === "/" ? {
    type: "redirect",
    pathname: firstWorkspace.basePath
  } : basePathRegex.test(pathname) ? {
    type: "redirect",
    pathname: firstWorkspace.basePath
  } : {
    type: "not-found"
  };
}
function useNormalizedWorkspaces(workspaces) {
  const $ = c(2);
  let t0;
  return $[0] !== workspaces ? (t0 = normalizedWorkspaces(workspaces), $[0] = workspaces, $[1] = t0) : t0 = $[1], t0;
}
function normalizedWorkspaces(workspaces) {
  return workspaces.map((workspace) => {
    const basePath = workspace.basePath || "/";
    return {
      workspace,
      name: workspace.name,
      basePath,
      // this regex ends with a `(\\/|$)` (forward slash or end) to prevent false
      // matches where the pathname is a false subset of the current pathname.
      // e.g. if the `workspace.basePath` is `/base/foobar` and the current
      // pathname is `/base/foo`, then that should not be a match
      basePathRegex: new RegExp(`^${escapeRegExp$1(basePath)}(\\/|$)`, "i")
    };
  });
}
function useSyncPathnameWithWorkspace(history2, _workspaces) {
  const $ = c(18), workspaces = useNormalizedWorkspaces(_workspaces);
  let t0;
  $[0] !== workspaces ? (t0 = createCommonBasePathRegex(workspaces), $[0] = workspaces, $[1] = t0) : t0 = $[1];
  const basePathRegex = t0;
  let t1;
  $[2] !== history2.location.pathname ? (t1 = () => history2.location.pathname, $[2] = history2.location.pathname, $[3] = t1) : t1 = $[3];
  const [serverSnapshot] = useState(t1);
  let t2;
  $[4] !== history2 ? (t2 = (onStoreChange) => history2.listen(onStoreChange), $[4] = history2, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== history2.location.pathname ? (t3 = () => history2.location.pathname, $[6] = history2.location.pathname, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== serverSnapshot ? (t4 = () => serverSnapshot, $[8] = serverSnapshot, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== basePathRegex || $[11] !== workspaces ? (t5 = (pathname) => matchWorkspace({
    basePathRegex,
    pathname,
    workspaces
  }), $[10] = basePathRegex, $[11] = workspaces, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 ? (t6 = {
    subscribe: t2,
    getSnapshot: t3,
    getServerSnapshot: t4,
    selector: t5,
    isEqual: _temp$C
  }, $[13] = t2, $[14] = t3, $[15] = t4, $[16] = t5, $[17] = t6) : t6 = $[17];
  const store = t6;
  return useSyncExternalStoreWithSelector(store.subscribe, store.getSnapshot, store.getServerSnapshot, store.selector, store.isEqual);
}
function _temp$C(a, b) {
  if (a.type !== b.type)
    return !1;
  switch (a.type) {
    case "match":
      return a.workspace === b.workspace;
    case "redirect":
      return a.pathname === b.pathname;
    case "not-found":
      return !0;
    default:
      throw new Error(`Unknown type: ${a.type}`);
  }
}
const createHistory = () => typeof document > "u" ? createMemoryHistory() : createBrowserHistory();
function ActiveWorkspaceMatcher(t0) {
  const $ = c(25), {
    children,
    LoadingComponent,
    NotFoundComponent,
    unstable_history: historyProp
  } = t0, workspaces = useWorkspaces();
  let t1;
  $[0] !== historyProp ? (t1 = historyProp || createHistory(), $[0] = historyProp, $[1] = t1) : t1 = $[1];
  const history2 = t1;
  let t2;
  $[2] !== history2 || $[3] !== workspaces ? (t2 = (workspaceName) => {
    const foundWorkspace = workspaces.find((workspace) => workspace.name === workspaceName);
    foundWorkspace && history2.push(foundWorkspace.basePath);
  }, $[2] = history2, $[3] = workspaces, $[4] = t2) : t2 = $[4];
  const setActiveWorkspaceName = t2;
  let t3;
  $[5] !== setActiveWorkspaceName || $[6] !== workspaces[0].name ? (t3 = () => {
    setActiveWorkspaceName(workspaces[0].name);
  }, $[5] = setActiveWorkspaceName, $[6] = workspaces[0].name, $[7] = t3) : t3 = $[7];
  const handleNavigateToDefaultWorkspace = t3, result = useSyncPathnameWithWorkspace(history2, workspaces);
  let t4;
  $[8] !== history2 || $[9] !== result.pathname || $[10] !== result.type ? (t4 = () => {
    result.type === "redirect" && history2.replace({
      pathname: result.pathname,
      search: history2.location.search,
      hash: history2.location.hash
    });
  }, $[8] = history2, $[9] = result.pathname, $[10] = result.type, $[11] = t4) : t4 = $[11];
  let t5;
  switch ($[12] !== history2 || $[13] !== result ? (t5 = [history2, result], $[12] = history2, $[13] = result, $[14] = t5) : t5 = $[14], useEffect(t4, t5), result.type) {
    case "match": {
      let t6;
      return $[15] !== children || $[16] !== history2 || $[17] !== result.workspace || $[18] !== setActiveWorkspaceName ? (t6 = /* @__PURE__ */ jsx(ActiveWorkspaceMatcherProvider, { activeWorkspace: result.workspace, history: history2, setActiveWorkspace: setActiveWorkspaceName, children }), $[15] = children, $[16] = history2, $[17] = result.workspace, $[18] = setActiveWorkspaceName, $[19] = t6) : t6 = $[19], t6;
    }
    case "redirect": {
      let t6;
      return $[20] !== LoadingComponent ? (t6 = /* @__PURE__ */ jsx(LoadingComponent, {}), $[20] = LoadingComponent, $[21] = t6) : t6 = $[21], t6;
    }
    case "not-found": {
      let t6;
      return $[22] !== NotFoundComponent || $[23] !== handleNavigateToDefaultWorkspace ? (t6 = /* @__PURE__ */ jsx(NotFoundComponent, { onNavigateToDefaultWorkspace: handleNavigateToDefaultWorkspace }), $[22] = NotFoundComponent, $[23] = handleNavigateToDefaultWorkspace, $[24] = t6) : t6 = $[24], t6;
    }
    default:
      throw new Error(`Unknown type: ${result.type}`);
  }
}
function getScheme(scheme) {
  switch (scheme) {
    case "dark":
    case "light":
      return scheme;
    default:
      return "system";
  }
}
const LOCAL_STORAGE_KEY$1 = "sanityStudio:ui:colorScheme";
let snapshot;
const subscribers = /* @__PURE__ */ new Set(), subscribe = (onStoreChange) => (snapshot || (snapshot = getScheme(localStorage.getItem(LOCAL_STORAGE_KEY$1)) || "system"), subscribers.add(onStoreChange), () => {
  subscribers.delete(onStoreChange);
});
function getSnapshot() {
  return snapshot;
}
function setSnapshot(nextScheme) {
  snapshot = getScheme(nextScheme);
  for (const subscription of subscribers)
    subscription();
}
function useSystemScheme() {
  return usePrefersDark() ? "dark" : "light";
}
function ColorThemeProvider(t0) {
  const $ = c(3), {
    children,
    scheme: _scheme
  } = t0, systemScheme = useSystemScheme(), scheme = _scheme === "system" ? systemScheme : _scheme;
  let t1;
  return $[0] !== children || $[1] !== scheme ? (t1 = /* @__PURE__ */ jsx(ThemeProvider, { scheme, theme: studioTheme, children }), $[0] = children, $[1] = scheme, $[2] = t1) : t1 = $[2], t1;
}
const LOCAL_STORAGE_KEY = "sanityStudio:ui:colorScheme";
function ColorSchemeProvider(t0) {
  const $ = c(7), {
    children,
    onSchemeChange,
    scheme: schemeProp
  } = t0;
  if (schemeProp) {
    let t12;
    return $[0] !== children || $[1] !== onSchemeChange || $[2] !== schemeProp ? (t12 = /* @__PURE__ */ jsx(ColorSchemeCustomProvider, { scheme: schemeProp, onSchemeChange, children }), $[0] = children, $[1] = onSchemeChange, $[2] = schemeProp, $[3] = t12) : t12 = $[3], t12;
  }
  let t1;
  return $[4] !== children || $[5] !== onSchemeChange ? (t1 = /* @__PURE__ */ jsx(ColorSchemeLocalStorageProvider, { onSchemeChange, children }), $[4] = children, $[5] = onSchemeChange, $[6] = t1) : t1 = $[6], t1;
}
function ColorSchemeLocalStorageProvider(t0) {
  const $ = c(10), {
    children,
    onSchemeChange
  } = t0, scheme = useSyncExternalStore(subscribe, getSnapshot, _temp$B);
  let t1, t2;
  $[0] !== onSchemeChange || $[1] !== scheme ? (t1 = () => {
    typeof onSchemeChange == "function" && onSchemeChange(scheme), localStorage.setItem(LOCAL_STORAGE_KEY, scheme);
  }, t2 = [onSchemeChange, scheme], $[0] = onSchemeChange, $[1] = scheme, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  let t3;
  $[4] !== children || $[5] !== scheme ? (t3 = /* @__PURE__ */ jsx(ColorThemeProvider, { scheme, children }), $[4] = children, $[5] = scheme, $[6] = t3) : t3 = $[6];
  let t4;
  return $[7] !== scheme || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(ColorSchemeSetValueContext.Provider, { value: setSnapshot, children: /* @__PURE__ */ jsx(ColorSchemeValueContext.Provider, { value: scheme, children: t3 }) }), $[7] = scheme, $[8] = t3, $[9] = t4) : t4 = $[9], t4;
}
function _temp$B() {
  return "system";
}
function ColorSchemeCustomProvider(t0) {
  const $ = c(9), {
    children,
    onSchemeChange,
    scheme
  } = t0, t1 = typeof onSchemeChange == "function" ? onSchemeChange : !1;
  let t2;
  $[0] !== children || $[1] !== scheme ? (t2 = /* @__PURE__ */ jsx(ColorThemeProvider, { scheme, children }), $[0] = children, $[1] = scheme, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== scheme || $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(ColorSchemeValueContext.Provider, { value: scheme, children: t2 }), $[3] = scheme, $[4] = t2, $[5] = t3) : t3 = $[5];
  let t4;
  return $[6] !== t1 || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(ColorSchemeSetValueContext.Provider, { value: t1, children: t3 }), $[6] = t1, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
function useColorSchemeSetValue() {
  const setValue = useContext(ColorSchemeSetValueContext);
  if (setValue === null)
    throw new Error("Could not find `ColorSchemeSetValueContext` context");
  return setValue;
}
function useColorSchemeInternalValue() {
  const value = useContext(ColorSchemeValueContext);
  if (value === null)
    throw new Error("Could not find `ColorSchemeValueContext` context");
  return value;
}
function useColorSchemeValue() {
  const scheme = useColorSchemeInternalValue(), systemScheme = useSystemScheme();
  return scheme === "system" ? systemScheme : scheme;
}
function useColorScheme() {
  const $ = c(4);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0], useEffect(_temp2$g, t0);
  const scheme = useColorSchemeValue(), setScheme = useColorSchemeSetValue();
  let t1;
  return $[1] !== scheme || $[2] !== setScheme ? (t1 = {
    scheme,
    setScheme
  }, $[1] = scheme, $[2] = setScheme, $[3] = t1) : t1 = $[3], t1;
}
function _temp2$g() {
  console.warn("useColorScheme() is deprecated, use useColorSchemeValue() or useColorSchemeSetValue() instead");
}
function useColorSchemeOptions(setScheme, t) {
  const $ = c(37), scheme = useColorSchemeInternalValue();
  let t0;
  $[0] !== t ? (t0 = t("user-menu.color-scheme.system-title"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t ? (t1 = t("user-menu.color-scheme.system-description"), $[2] = t, $[3] = t1) : t1 = $[3];
  const t2 = scheme === "system";
  let t3;
  $[4] !== setScheme ? (t3 = () => setScheme("system"), $[4] = setScheme, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t0 || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 ? (t4 = {
    title: t0,
    name: "system",
    label: t1,
    selected: t2,
    onSelect: t3,
    icon: DesktopIcon
  }, $[6] = t0, $[7] = t1, $[8] = t2, $[9] = t3, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== t ? (t5 = t("user-menu.color-scheme.dark-title"), $[11] = t, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== t ? (t6 = t("user-menu.color-scheme.dark-description"), $[13] = t, $[14] = t6) : t6 = $[14];
  const t7 = scheme === "dark";
  let t8;
  $[15] !== setScheme ? (t8 = () => setScheme("dark"), $[15] = setScheme, $[16] = t8) : t8 = $[16];
  let t9;
  $[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 ? (t9 = {
    title: t5,
    name: "dark",
    label: t6,
    selected: t7,
    onSelect: t8,
    icon: MoonIcon
  }, $[17] = t5, $[18] = t6, $[19] = t7, $[20] = t8, $[21] = t9) : t9 = $[21];
  let t10;
  $[22] !== t ? (t10 = t("user-menu.color-scheme.light-title"), $[22] = t, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] !== t ? (t11 = t("user-menu.color-scheme.light-description"), $[24] = t, $[25] = t11) : t11 = $[25];
  const t12 = scheme === "light";
  let t13;
  $[26] !== setScheme ? (t13 = () => setScheme("light"), $[26] = setScheme, $[27] = t13) : t13 = $[27];
  let t14;
  $[28] !== t10 || $[29] !== t11 || $[30] !== t12 || $[31] !== t13 ? (t14 = {
    title: t10,
    name: "light",
    label: t11,
    selected: t12,
    onSelect: t13,
    icon: SunIcon
  }, $[28] = t10, $[29] = t11, $[30] = t12, $[31] = t13, $[32] = t14) : t14 = $[32];
  let t15;
  return $[33] !== t14 || $[34] !== t4 || $[35] !== t9 ? (t15 = [t4, t9, t14], $[33] = t14, $[34] = t4, $[35] = t9, $[36] = t15) : t15 = $[36], t15;
}
const SearchButton = forwardRef(function(t0, ref) {
  const $ = c(12), {
    onClick: onClick2
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("search.action-open-aria-label"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t ? (t2 = t("search.button.tooltip"), $[2] = t, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = [GLOBAL_SEARCH_KEY_MODIFIER, GLOBAL_SEARCH_KEY.toUpperCase()], $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t2 ? (t4 = {
    content: t2,
    hotkeys: t3,
    portal: !0
  }, $[5] = t2, $[6] = t4) : t4 = $[6];
  let t5;
  return $[7] !== onClick2 || $[8] !== ref || $[9] !== t1 || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { "aria-label": t1, "data-testid": "studio-search", icon: SearchIcon, tooltipProps: t4, onClick: onClick2, mode: "bleed", ref }), $[7] = onClick2, $[8] = ref, $[9] = t1, $[10] = t4, $[11] = t5) : t5 = $[11], t5;
}), InnerCard = styled(Card).withConfig({
  displayName: "InnerCard",
  componentId: "sc-1tllvnd-0"
})`flex-direction:column;overflow:hidden;overflow:clip;pointer-events:all;position:relative;`, SearchDialogBox = styled(Box).withConfig({
  displayName: "SearchDialogBox",
  componentId: "sc-1tllvnd-1"
})`height:100%;left:0;overflow:hidden;overflow:clip;pointer-events:none;position:fixed;top:0;width:100%;z-index:1;`;
function SearchDialog(t0) {
  const $ = c(15), {
    onClose,
    onOpen,
    open
  } = t0, [inputElement, setInputElement] = useState(null), scheme = useColorSchemeValue(), {
    state: t1
  } = useSearchState(), {
    filtersVisible,
    terms
  } = t1;
  let t2;
  $[0] !== terms ? (t2 = hasSearchableTerms({
    terms
  }), $[0] = terms, $[1] = t2) : t2 = $[1];
  const hasValidTerms = t2;
  let t3;
  $[2] !== filtersVisible || $[3] !== hasValidTerms || $[4] !== inputElement || $[5] !== onClose || $[6] !== open || $[7] !== scheme ? (t3 = open && /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(FocusLock, { autoFocus: !supportsTouch, returnFocus: !0, children: /* @__PURE__ */ jsx(SearchDialogBox, { children: /* @__PURE__ */ jsxs(InnerCard, { display: "flex", height: "fill", scheme, tone: "default", children: [
    /* @__PURE__ */ jsx(SearchHeader, { onClose, ref: setInputElement }),
    filtersVisible && /* @__PURE__ */ jsx(Card, { borderTop: !0, flex: "none", children: /* @__PURE__ */ jsx(Filters, {}) }),
    hasValidTerms ? /* @__PURE__ */ jsx(SearchResults, { inputElement }) : /* @__PURE__ */ jsx(RecentSearches, { inputElement })
  ] }) }) }) }), $[2] = filtersVisible, $[3] = hasValidTerms, $[4] = inputElement, $[5] = onClose, $[6] = open, $[7] = scheme, $[8] = t3) : t3 = $[8];
  let t4;
  return $[9] !== hasValidTerms || $[10] !== onClose || $[11] !== onOpen || $[12] !== open || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsx(SearchWrapper, { hasValidTerms, onClose, onOpen, open, children: t3 }), $[9] = hasValidTerms, $[10] = onClose, $[11] = onOpen, $[12] = open, $[13] = t3, $[14] = t4) : t4 = $[14], t4;
}
function StudioLogo(props2) {
  const $ = c(2), {
    title
  } = props2;
  let t0;
  return $[0] !== title ? (t0 = /* @__PURE__ */ jsx(Box, { padding: 3, "data-testid": "studio-logo", children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: title }) }), $[0] = title, $[1] = t0) : t0 = $[1], t0;
}
const CapabilityGate = (t0) => {
  const $ = c(1), {
    children,
    capability,
    condition: t1
  } = t0, condition = t1 === void 0 ? "unavailable" : t1, renderingContextStore = useRenderingContextStore();
  let t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {}, $[0] = t2) : t2 = $[0];
  const renderingContextHasCapability = useObservable(renderingContextStore.capabilities, t2)[capability] === !0;
  return condition === "available" && !renderingContextHasCapability || condition === "unavailable" && renderingContextHasCapability ? null : children;
}, ToolLink = forwardRef(function(props2, ref) {
  const $ = c(9);
  let name, rest;
  $[0] !== props2 ? ({
    name,
    ...rest
  } = props2, $[0] = props2, $[1] = name, $[2] = rest) : (name = $[1], rest = $[2]);
  let t0;
  $[3] !== name ? (t0 = () => ({
    tool: name,
    [name]: void 0
  }), $[3] = name, $[4] = t0) : t0 = $[4];
  const state = useRouterState(t0);
  let t1;
  return $[5] !== ref || $[6] !== rest || $[7] !== state ? (t1 = /* @__PURE__ */ jsx(StateLink, { state, ...rest, ref }), $[5] = ref, $[6] = rest, $[7] = state, $[8] = t1) : t1 = $[8], t1;
}), oversizedButtonStyle = css`
  position: relative;
  cursor: default;
  &::before {
    content: '';
    position: absolute;
    display: block;
    inset: -4px;
    border-radius: 9999px;
  }
`, Dot$1 = /* @__PURE__ */ styled.div.withConfig({
  displayName: "Dot",
  componentId: "sc-1wfug2b-0"
})({
  width: 4,
  height: 4,
  borderRadius: 3,
  boxShadow: "0 0 0 1px var(--card-bg-color)"
}), OversizedButton$2 = styled(ToolLink).withConfig({
  displayName: "OversizedButton",
  componentId: "sc-1wfug2b-1"
})`${oversizedButtonStyle}`;
function ReleasesToolLink() {
  const $ = c(13), {
    t
  } = useTranslation(), {
    errorCount$
  } = useReleasesStore(), hasError = useObservable(errorCount$) !== 0, {
    selectedPerspective
  } = usePerspective(), activeToolName = useRouterState(_temp$A);
  let t0;
  $[0] !== t ? (t0 = t("release.navbar.tooltip"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== selectedPerspective ? (t1 = /* @__PURE__ */ jsx(ReleaseAvatarIcon, { release: selectedPerspective }), $[2] = selectedPerspective, $[3] = t1) : t1 = $[3];
  const t2 = activeToolName === SCHEDULES_TOOL_NAME;
  let t3;
  $[4] !== hasError ? (t3 = hasError && /* @__PURE__ */ jsx(Dot$1, { "data-ui": "error-status-icon", style: {
    backgroundColor: "var(--card-badge-critical-dot-color)"
  } }), $[4] = hasError, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t1 || $[7] !== t2 || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(Button$1, { as: OversizedButton$2, name: SCHEDULES_TOOL_NAME, "data-as": "a", icon: t1, mode: "bleed", padding: 2, radius: "full", "data-testid": "releases-tool-link", selected: t2, children: t3 }), $[6] = t1, $[7] = t2, $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== t0 || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(Tooltip, { content: t0, children: t4 }), $[10] = t0, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
}
function _temp$A(routerState) {
  return typeof routerState.tool == "string" ? routerState.tool : void 0;
}
const OversizedButton$1 = styled(IntentLink).withConfig({
  displayName: "OversizedButton",
  componentId: "sc-1pt35p9-0"
})`${oversizedButtonStyle}`;
function AnimatedTextWidth(t0) {
  const $ = c(18), {
    children,
    text
  } = t0, textRef = useRef(null), [containerWidth, setContainerWidth] = useState(null), [isAnimating, setIsAnimating] = useState(!1);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    if (!textRef.current)
      return;
    const newWidth = textRef.current.offsetWidth;
    setContainerWidth(newWidth);
  }, $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== text ? (t2 = [text], $[1] = text, $[2] = t2) : t2 = $[2], useLayoutEffect(t1, t2);
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setIsAnimating(!0);
  }, $[3] = t3) : t3 = $[3];
  const onAnimationStart = t3;
  let t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setIsAnimating(!1);
  }, $[4] = t4) : t4 = $[4];
  const onAnimationComplete = t4, t5 = containerWidth === null ? "auto" : containerWidth, t6 = isAnimating ? "hidden" : "visible";
  let t7;
  $[5] !== t5 || $[6] !== t6 ? (t7 = {
    display: "inline-block",
    width: t5,
    overflow: t6
  }, $[5] = t5, $[6] = t6, $[7] = t7) : t7 = $[7];
  const t8 = containerWidth || "auto";
  let t9;
  $[8] !== t8 ? (t9 = {
    width: t8
  }, $[8] = t8, $[9] = t9) : t9 = $[9];
  let t10;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    type: "spring",
    bounce: 0,
    duration: 0.3
  }, $[10] = t10) : t10 = $[10];
  let t11;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = {
    display: "inline-block",
    whiteSpace: "nowrap",
    verticalAlign: "middle"
  }, $[11] = t11) : t11 = $[11];
  let t12;
  $[12] !== children ? (t12 = /* @__PURE__ */ jsx("div", { ref: textRef, style: t11, children }), $[12] = children, $[13] = t12) : t12 = $[13];
  let t13;
  return $[14] !== t12 || $[15] !== t7 || $[16] !== t9 ? (t13 = /* @__PURE__ */ jsx(motion.div, { style: t7, animate: t9, transition: t10, onAnimationStart, onAnimationComplete, children: t12 }), $[14] = t12, $[15] = t7, $[16] = t9, $[17] = t13) : t13 = $[17], t13;
}
const ReleasesLink = (t0) => {
  const $ = c(10), {
    selectedPerspective
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== selectedPerspective._id ? (t1 = forwardRef(function(t22, linkRef) {
    const {
      children,
      ...intentProps
    } = t22;
    return /* @__PURE__ */ jsx(OversizedButton$1, { ...intentProps, ref: linkRef, intent: RELEASES_INTENT, params: {
      id: getReleaseIdFromReleaseDocumentId(selectedPerspective._id)
    }, children });
  }), $[0] = selectedPerspective._id, $[1] = t1) : t1 = $[1];
  const ReleasesIntentLink = t1, t2 = selectedPerspective.metadata?.title;
  let t3;
  $[2] !== t ? (t3 = t("release.placeholder-untitled-release"), $[2] = t, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== ReleasesIntentLink ? (t4 = (t52) => {
    const {
      displayTitle
    } = t52;
    return /* @__PURE__ */ jsx(Button$1, { as: ReleasesIntentLink, "data-as": "a", rel: "noopener noreferrer", mode: "bleed", padding: 2, radius: "full", style: {
      maxWidth: "180px"
    }, text: displayTitle });
  }, $[4] = ReleasesIntentLink, $[5] = t4) : t4 = $[5];
  let t5;
  return $[6] !== t2 || $[7] !== t3 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(ReleaseTitle, { title: t2, fallback: t3, children: t4 }), $[6] = t2, $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9], t5;
};
function CurrentGlobalPerspectiveLabel(t0) {
  const $ = c(7), {
    selectedPerspective
  } = t0, {
    t
  } = useTranslation(), {
    bundles
  } = useAgentBundles(), t1 = isReleaseDocument(selectedPerspective) ? selectedPerspective._id : selectedPerspective;
  let t2;
  $[0] !== bundles || $[1] !== selectedPerspective || $[2] !== t ? (t2 = isPublishedPerspective(selectedPerspective) || isDraftPerspective(selectedPerspective) ? /* @__PURE__ */ jsx(Box, { padding: 2, style: {
    userSelect: "none",
    overflow: "hidden"
  }, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: isPublishedPerspective(selectedPerspective) ? t("release.chip.published") : t("release.chip.global.drafts") }) }) : isReleaseDocument(selectedPerspective) ? /* @__PURE__ */ jsx(ReleasesLink, { selectedPerspective }) : /* @__PURE__ */ jsx(Box, { padding: 2, style: {
    userSelect: "none",
    overflow: "hidden"
  }, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: isAgentBundleName(selectedPerspective) ? t(bundles.some((b) => b.id === selectedPerspective) ? "version.agent-bundle.proposed-changes" : "version.agent-bundle.agent-changes") : selectedPerspective }) }), $[0] = bundles, $[1] = selectedPerspective, $[2] = t, $[3] = t2) : t2 = $[3];
  let t3;
  return $[4] !== t1 || $[5] !== t2 ? (t3 = /* @__PURE__ */ jsx(AnimatedTextWidth, { text: t1, children: t2 }), $[4] = t1, $[5] = t2, $[6] = t3) : t3 = $[6], t3;
}
const iconStyle = {
  "--card-icon-color": "var(--card-badge-suggest-icon-color)"
}, AgentBundleMenuItem = memo(function(t0) {
  const $ = c(15), {
    bundle
  } = t0, {
    t
  } = useTranslation(), setPerspective = useSetPerspective(), {
    selectedPerspectiveName
  } = usePerspective(), active = selectedPerspectiveName === bundle.id;
  let t1;
  $[0] !== t ? (t1 = t("version.agent-bundle.proposed-changes"), $[0] = t, $[1] = t1) : t1 = $[1];
  const label = t1;
  let t2;
  $[2] !== bundle.id || $[3] !== setPerspective ? (t2 = () => setPerspective(bundle.id), $[2] = bundle.id, $[3] = setPerspective, $[4] = t2) : t2 = $[4];
  const handleClick = t2;
  let t3;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Box, { flex: "none", paddingX: 3, paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, style: iconStyle, children: /* @__PURE__ */ jsx(SparkleIcon, {}) }) }), $[5] = t3) : t3 = $[5];
  let t4;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    maxWidth: "200px",
    minWidth: 0
  }, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    minWidth: 0
  }, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    minWidth: 0
  }, $[8] = t6) : t6 = $[8];
  let t7;
  $[9] !== label ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 1, children: [
    t3,
    /* @__PURE__ */ jsx(Stack, { flex: 1, paddingY: 2, paddingRight: 2, space: 2, style: t4, children: /* @__PURE__ */ jsx(Flex, { gap: 3, align: "center", style: t5, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", style: t6, children: label }) }) })
  ] }), $[9] = label, $[10] = t7) : t7 = $[10];
  let t8;
  return $[11] !== active || $[12] !== handleClick || $[13] !== t7 ? (t8 = /* @__PURE__ */ jsx(MenuItem$1, { onClick: handleClick, padding: 1, pressed: active, selected: active, children: t7 }), $[11] = active, $[12] = handleClick, $[13] = t7, $[14] = t8) : t8 = $[14], t8;
});
function useExcludedPerspective() {
  const $ = c(9), {
    navigate
  } = useRouter(), {
    excludedPerspectives
  } = usePerspective();
  let t0;
  $[0] !== excludedPerspectives || $[1] !== navigate ? (t0 = (excluded) => {
    const existingPerspectives = excludedPerspectives || [], nextExcludedPerspectives = existingPerspectives.includes(excluded) ? existingPerspectives.filter((id2) => id2 !== excluded) : [...existingPerspectives, excluded];
    navigate({
      stickyParams: {
        excludedPerspectives: nextExcludedPerspectives.toString()
      }
    });
  }, $[0] = excludedPerspectives, $[1] = navigate, $[2] = t0) : t0 = $[2];
  const toggleExcludedPerspective = t0;
  let t1;
  $[3] !== excludedPerspectives ? (t1 = (perspectiveId) => !!excludedPerspectives?.includes(perspectiveId), $[3] = excludedPerspectives, $[4] = t1) : t1 = $[4];
  const isPerspectiveExcluded = t1;
  let t2;
  return $[5] !== excludedPerspectives || $[6] !== isPerspectiveExcluded || $[7] !== toggleExcludedPerspective ? (t2 = {
    excludedPerspectives,
    toggleExcludedPerspective,
    isPerspectiveExcluded
  }, $[5] = excludedPerspectives, $[6] = isPerspectiveExcluded, $[7] = toggleExcludedPerspective, $[8] = t2) : t2 = $[8], t2;
}
const INDICATOR_LEFT_OFFSET = 20, INDICATOR_WIDTH = 1, INDICATOR_COLOR_VAR_NAME = "--card-border-color", INDICATOR_BOTTOM_OFFSET = 4, GlobalPerspectiveMenuItemIndicator = /* @__PURE__ */ styled.div.withConfig({
  displayName: "GlobalPerspectiveMenuItemIndicator",
  componentId: "sc-fhv8td-0"
})(({
  $inRange,
  $last,
  $first,
  $isDefaultPerspective
}) => css`
    position: relative;

    --indicator-left: ${INDICATOR_LEFT_OFFSET}px;
    --indicator-width: ${INDICATOR_WIDTH}px;
    --indicator-color: var(${INDICATOR_COLOR_VAR_NAME});
    --indicator-bottom: ${INDICATOR_BOTTOM_OFFSET}px;

    --indicator-in-range-height: 16.5px;

    ${$inRange && !$last && css`
      &:after {
        content: '';
        display: block;
        position: absolute;
        left: var(--indicator-left);
        bottom: -var(--indicator-bottom);
        width: var(--indicator-width);
        height: ${$isDefaultPerspective ? "calc(var(--indicator-bottom) + 12px)" : "var(--indicator-bottom)"};
        background-color: var(--card-border-color);
      }
    `}

    ${$inRange && css`
        > [data-ui='MenuItem'] {
          position: relative;

          &:before,
          &:after {
            content: '';
            display: block;
            position: absolute;
            left: var(--indicator-left);
            width: var(--indicator-width);
            background-color: var(--card-border-color);
          }

          &:before {
            top: 0;
            height: var(--indicator-in-range-height);
          }

          &:after {
            top: var(--indicator-in-range-height);
            bottom: 0;
          }
        }
      `}

    ${$first && css`
      > [data-ui='MenuItem']:after {
        margin-top: -3px;
        border-top-left-radius: ${INDICATOR_WIDTH}px;
        border-top-right-radius: ${INDICATOR_WIDTH}px;
      }
      > [data-ui='MenuItem']:before {
        display: none;
      }
    `}

    ${$last && css`
      > [data-ui='MenuItem']:before {
        // dot diameter (5px) - 1.6px stroke divided by 2
        padding-bottom: 1.7px;
        border-bottom-left-radius: ${INDICATOR_WIDTH}px;
        border-bottom-right-radius: ${INDICATOR_WIDTH}px;
      }
      > [data-ui='MenuItem']:after {
        display: none;
      }
    `}
  `), GlobalPerspectiveMenuLabelIndicator = /* @__PURE__ */ styled(Box).withConfig({
  displayName: "GlobalPerspectiveMenuLabelIndicator",
  componentId: "sc-fhv8td-1"
})(({
  $withinRange
}) => css`
    position: relative;
    // 4px padding + 33px release indicator width + 4px gap
    padding-left: 41px;

    ${$withinRange && css`
      &:before {
        content: '';
        display: block;
        position: absolute;
        left: ${INDICATOR_LEFT_OFFSET}px;
        top: -8px;
        bottom: -${INDICATOR_BOTTOM_OFFSET}px;
        width: ${INDICATOR_WIDTH}px;
        background-color: var(${INDICATOR_COLOR_VAR_NAME});
      }
    `}
  `), ToggleLayerButton = /* @__PURE__ */ styled(Button$1).withConfig({
  displayName: "ToggleLayerButton",
  componentId: "sc-12cs1nb-0"
})(({
  $visible
}) => css`
    --card-fg-color: inherit;
    --card-icon-color: inherit;

    background-color: inherit;
    opacity: ${$visible ? 0 : 1};

    @media (hover: hover) {
      &:not([data-disabled='true']):hover {
        --card-fg-color: inherit;
        --card-icon-color: inherit;
      }
    }

    [data-ui='MenuItem']:hover & {
      opacity: 1;
    }
  `), IconWrapperBox = /* @__PURE__ */ styled(Box).withConfig({
  displayName: "IconWrapperBox",
  componentId: "sc-12cs1nb-1"
})(({
  $isExcluded
}) => css`
    position: relative;
    z-index: 1;
    border-radius: 50%;
    /* background-color: var(--card-background-color);  */
    opacity: ${$isExcluded ? 0 : 1};
    // The icon needs a white background to visually sit on top of the line indicator
    & svg {
      background-color: var(--card-bg-color);
    }
  `);
function getRangePosition(range2, index) {
  const {
    lastIndex
  } = range2;
  if (lastIndex !== 0) {
    if (index === 0) return "first";
    if (index === lastIndex) return "last";
    if (index > 0 && index < lastIndex) return "within";
  }
}
const GlobalPerspectiveMenuItem = forwardRef((props2, ref) => {
  const $ = c(67), {
    release,
    rangePosition
  } = props2, {
    document: t0
  } = useWorkspace(), {
    drafts: t1
  } = t0, {
    enabled: isDraftModelEnabled
  } = t1, defaultPerspective = isDraftModelEnabled ? LATEST : PUBLISHED$1, {
    selectedPerspective,
    selectedPerspectiveName
  } = usePerspective(), setPerspective = useSetPerspective(), {
    toggleExcludedPerspective,
    isPerspectiveExcluded
  } = useExcludedPerspective();
  let t2;
  $[0] !== release ? (t2 = isReleaseDocument(release) ? getReleaseIdFromReleaseDocumentId(release._id) : release, $[0] = release, $[1] = t2) : t2 = $[1];
  const releaseId = t2, isDefaultPerspective = release === defaultPerspective, active = selectedPerspectiveName ? releaseId === selectedPerspectiveName : isDefaultPerspective;
  let t3;
  $[2] !== isPerspectiveExcluded || $[3] !== releaseId ? (t3 = isPerspectiveExcluded(releaseId), $[2] = isPerspectiveExcluded, $[3] = releaseId, $[4] = t3) : t3 = $[4];
  const isReleasePerspectiveExcluded = t3, {
    t
  } = useTranslation();
  let t4;
  $[5] !== releaseId || $[6] !== toggleExcludedPerspective ? (t4 = (event) => {
    event.stopPropagation(), toggleExcludedPerspective(releaseId);
  }, $[5] = releaseId, $[6] = toggleExcludedPerspective, $[7] = t4) : t4 = $[7];
  const handleToggleReleaseVisibility = t4;
  let t5;
  $[8] !== releaseId || $[9] !== setPerspective ? (t5 = () => setPerspective(releaseId), $[8] = releaseId, $[9] = setPerspective, $[10] = t5) : t5 = $[10];
  const handleOnReleaseClick = t5;
  let t6;
  bb0: {
    if (release === "published") {
      t6 = !1;
      break bb0;
    }
    if (isDraftPerspective(release)) {
      let t73;
      $[11] !== selectedPerspective ? (t73 = isReleaseDocument(selectedPerspective), $[11] = selectedPerspective, $[12] = t73) : t73 = $[12], t6 = t73;
      break bb0;
    }
    if (isReleaseScheduledOrScheduling(release)) {
      t6 = !1;
      break bb0;
    }
    let t72;
    $[13] !== rangePosition ? (t72 = rangePosition && ["first", "within"].includes(rangePosition), $[13] = rangePosition, $[14] = t72) : t72 = $[14], t6 = t72;
  }
  const canReleaseBeExcluded = t6, t7 = rangePosition === "first", t8 = rangePosition === "last", t9 = !!rangePosition, t10 = `release-${releaseId}`;
  let t11;
  $[15] !== props2.menuItemProps || $[16] !== release ? (t11 = props2.menuItemProps?.({
    perspective: release
  }), $[15] = props2.menuItemProps, $[16] = release, $[17] = t11) : t11 = $[17];
  let t12;
  $[18] !== release ? (t12 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ReleaseAvatarIcon, { release }) }), $[18] = release, $[19] = t12) : t12 = $[19];
  let t13;
  $[20] !== isReleasePerspectiveExcluded || $[21] !== t12 ? (t13 = /* @__PURE__ */ jsx(IconWrapperBox, { $isExcluded: isReleasePerspectiveExcluded, flex: "none", "data-testid": "release-indicator-icon", paddingX: 3, paddingY: 2, children: t12 }), $[20] = isReleasePerspectiveExcluded, $[21] = t12, $[22] = t13) : t13 = $[22];
  const t14 = isReleasePerspectiveExcluded ? 0.5 : void 0;
  let t15;
  $[23] !== t14 ? (t15 = {
    opacity: t14,
    maxWidth: "200px",
    minWidth: 0
  }, $[23] = t14, $[24] = t15) : t15 = $[24];
  let t16;
  $[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = {
    minWidth: 0
  }, $[25] = t16) : t16 = $[25];
  let t17;
  $[26] !== release || $[27] !== t ? (t17 = isReleaseDocument(release) ? /* @__PURE__ */ jsx(ReleaseTitle, { title: release.metadata.title, fallback: t("release.placeholder-untitled-release"), textProps: {
    size: 1,
    weight: "medium",
    style: {
      minWidth: 0
    }
  } }) : /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", style: {
    minWidth: 0
  }, children: isDraftPerspective(release) ? t("release.navbar.drafts") : t("release.navbar.published") }), $[26] = release, $[27] = t, $[28] = t17) : t17 = $[28];
  let t18;
  $[29] !== release ? (t18 = isReleaseDocument(release) && typeof release.error < "u" && release.state === "active" && /* @__PURE__ */ jsx(Text$1, { size: 1, "data-testid": "release-error-icon", children: /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: "critical" }) }), $[29] = release, $[30] = t18) : t18 = $[30];
  let t19;
  $[31] !== t17 || $[32] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Flex, { gap: 3, align: "center", style: t16, children: [
    t17,
    t18
  ] }), $[31] = t17, $[32] = t18, $[33] = t19) : t19 = $[33];
  let t20;
  $[34] !== release ? (t20 = isReleaseDocument(release) && release.metadata.releaseType === "scheduled" && (release.publishAt || release.metadata.intendedPublishAt) && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: formatRelativeLocalePublishDate(release) }), $[34] = release, $[35] = t20) : t20 = $[35];
  let t21;
  $[36] !== t15 || $[37] !== t19 || $[38] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Stack, { flex: 1, paddingY: 2, paddingRight: 2, space: 2, style: t15, children: [
    t19,
    t20
  ] }), $[36] = t15, $[37] = t19, $[38] = t20, $[39] = t21) : t21 = $[39];
  let t22;
  $[40] !== canReleaseBeExcluded || $[41] !== handleToggleReleaseVisibility || $[42] !== isReleasePerspectiveExcluded || $[43] !== t ? (t22 = canReleaseBeExcluded && /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t("release.layer.hide"), placement: "bottom", children: /* @__PURE__ */ jsx(ToggleLayerButton, { $visible: !isReleasePerspectiveExcluded, forwardedAs: "div", icon: isReleasePerspectiveExcluded ? EyeClosedIcon : EyeOpenIcon, mode: "bleed", onClick: handleToggleReleaseVisibility, padding: 2, "data-testid": "release-toggle-visibility" }) }), $[40] = canReleaseBeExcluded, $[41] = handleToggleReleaseVisibility, $[42] = isReleasePerspectiveExcluded, $[43] = t, $[44] = t22) : t22 = $[44];
  let t23;
  $[45] !== release ? (t23 = isReleaseDocument(release) && isReleaseScheduledOrScheduling(release) && /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, "data-testid": "release-lock-icon", children: /* @__PURE__ */ jsx(LockIcon, {}) }) }), $[45] = release, $[46] = t23) : t23 = $[46];
  let t24;
  $[47] !== t22 || $[48] !== t23 ? (t24 = /* @__PURE__ */ jsxs(Box, { flex: "none", children: [
    t22,
    t23
  ] }), $[47] = t22, $[48] = t23, $[49] = t24) : t24 = $[49];
  let t25;
  $[50] !== t13 || $[51] !== t21 || $[52] !== t24 ? (t25 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 1, children: [
    t13,
    t21,
    t24
  ] }), $[50] = t13, $[51] = t21, $[52] = t24, $[53] = t25) : t25 = $[53];
  let t26;
  $[54] !== active || $[55] !== handleOnReleaseClick || $[56] !== t10 || $[57] !== t11 || $[58] !== t25 ? (t26 = /* @__PURE__ */ jsx(MenuItem$1, { onClick: handleOnReleaseClick, padding: 1, pressed: active, selected: active, "data-testid": t10, ...t11, children: t25 }), $[54] = active, $[55] = handleOnReleaseClick, $[56] = t10, $[57] = t11, $[58] = t25, $[59] = t26) : t26 = $[59];
  let t27;
  return $[60] !== isDefaultPerspective || $[61] !== ref || $[62] !== t26 || $[63] !== t7 || $[64] !== t8 || $[65] !== t9 ? (t27 = /* @__PURE__ */ jsx(GlobalPerspectiveMenuItemIndicator, { $isDefaultPerspective: isDefaultPerspective, $first: t7, $last: t8, $inRange: t9, ref, children: t26 }), $[60] = isDefaultPerspective, $[61] = ref, $[62] = t26, $[63] = t7, $[64] = t8, $[65] = t9, $[66] = t27) : t27 = $[66], t27;
});
GlobalPerspectiveMenuItem.displayName = "GlobalPerspectiveMenuItem";
const RELEASE_TYPE_LABELS = {
  asap: "release.type.asap",
  scheduled: "release.type.scheduled",
  undecided: "release.type.undecided"
};
function ReleaseTypeMenuSection(t0) {
  const $ = c(28), {
    releaseType,
    releases: releases2,
    range: range2,
    currentGlobalBundleMenuItemRef,
    menuItemProps
  } = t0, {
    t
  } = useTranslation(), {
    selectedReleaseId
  } = usePerspective();
  let t1;
  $[0] !== currentGlobalBundleMenuItemRef || $[1] !== selectedReleaseId ? (t1 = (releaseId) => selectedReleaseId === releaseId ? currentGlobalBundleMenuItemRef : void 0, $[0] = currentGlobalBundleMenuItemRef, $[1] = selectedReleaseId, $[2] = t1) : t1 = $[2];
  const getMenuItemRef = t1;
  if (releases2.length === 0)
    return null;
  const {
    lastIndex,
    offsets
  } = range2, releaseTypeOffset = offsets[releaseType], t2 = releaseTypeOffset > 0 && lastIndex >= releaseTypeOffset;
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    textTransform: "uppercase"
  }, $[3] = t3) : t3 = $[3];
  const t4 = RELEASE_TYPE_LABELS[releaseType];
  let t5;
  $[4] !== t || $[5] !== t4 ? (t5 = t(t4), $[4] = t, $[5] = t4, $[6] = t5) : t5 = $[6];
  let t6;
  $[7] !== t5 ? (t6 = /* @__PURE__ */ jsx(Label, { muted: !0, style: t3, size: 1, children: t5 }), $[7] = t5, $[8] = t6) : t6 = $[8];
  let t7;
  $[9] !== t2 || $[10] !== t6 ? (t7 = /* @__PURE__ */ jsx(GlobalPerspectiveMenuLabelIndicator, { $withinRange: t2, paddingLeft: 2, paddingTop: 3, paddingBottom: 1, children: t6 }), $[9] = t2, $[10] = t6, $[11] = t7) : t7 = $[11];
  let t8;
  if ($[12] !== getMenuItemRef || $[13] !== menuItemProps || $[14] !== range2 || $[15] !== releaseTypeOffset || $[16] !== releases2) {
    let t92;
    $[18] !== getMenuItemRef || $[19] !== menuItemProps || $[20] !== range2 || $[21] !== releaseTypeOffset ? (t92 = (release, index) => /* @__PURE__ */ jsx(GlobalPerspectiveMenuItem, { release, ref: getMenuItemRef(getReleaseIdFromReleaseDocumentId(release._id)), rangePosition: getRangePosition(range2, releaseTypeOffset + index), menuItemProps }, release._id), $[18] = getMenuItemRef, $[19] = menuItemProps, $[20] = range2, $[21] = releaseTypeOffset, $[22] = t92) : t92 = $[22], t8 = releases2.map(t92), $[12] = getMenuItemRef, $[13] = menuItemProps, $[14] = range2, $[15] = releaseTypeOffset, $[16] = releases2, $[17] = t8;
  } else
    t8 = $[17];
  let t9;
  $[23] !== t8 ? (t9 = /* @__PURE__ */ jsx(Flex, { direction: "column", gap: 1, children: t8 }), $[23] = t8, $[24] = t9) : t9 = $[24];
  let t10;
  return $[25] !== t7 || $[26] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { padding: 1, borderBottom: !0, children: /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    t7,
    t9
  ] }) }), $[25] = t7, $[26] = t9, $[27] = t10) : t10 = $[27], t10;
}
const StyledLinkComponent$1 = styled(IntentLink).withConfig({
  displayName: "StyledLinkComponent",
  componentId: "sc-4l76h7-0"
})`text-decoration:none;`, ScheduledDraftsMenuItem = () => {
  const $ = c(11), router = useRouter(), {
    t
  } = useTranslation(), telemetry = useTelemetry(), isScheduledDraftsEnabled = useScheduledDraftsEnabled(), {
    enabled: isSingleDocReleaseEnabled
  } = useFeatureEnabled(FEATURES.singleDocRelease), {
    document: t0
  } = useWorkspace(), {
    drafts: t1
  } = t0, {
    enabled: isDraftModelEnabled
  } = t1;
  let t2;
  $[0] !== router ? (t2 = router.resolveIntentLink(RELEASES_SCHEDULED_DRAFTS_INTENT, {
    view: "drafts"
  }), $[0] = router, $[1] = t2) : t2 = $[1];
  const scheduledDraftsUrl = t2;
  let t3;
  $[2] !== telemetry ? (t3 = () => {
    telemetry.log(NavigatedToScheduledDrafts, {
      source: "menu"
    });
  }, $[2] = telemetry, $[3] = t3) : t3 = $[3];
  const handleClick = t3;
  let t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = forwardRef(function(restProps, ref) {
    return /* @__PURE__ */ jsx(StyledLinkComponent$1, { ...restProps, intent: RELEASES_SCHEDULED_DRAFTS_INTENT, params: {
      view: "drafts"
    }, ref });
  }), $[4] = t4) : t4 = $[4];
  const LinkComponent = t4;
  if (!isScheduledDraftsEnabled || !isSingleDocReleaseEnabled || !isDraftModelEnabled)
    return null;
  let t5;
  $[5] !== t ? (t5 = t("release.menu.scheduled-drafts"), $[5] = t, $[6] = t5) : t5 = $[6];
  let t6;
  return $[7] !== handleClick || $[8] !== scheduledDraftsUrl || $[9] !== t5 ? (t6 = /* @__PURE__ */ jsx(MenuItem, { as: LinkComponent, href: scheduledDraftsUrl, onClick: handleClick, icon: CalendarIcon, text: t5, "data-testid": "scheduled-drafts-menu-item" }), $[7] = handleClick, $[8] = scheduledDraftsUrl, $[9] = t5, $[10] = t6) : t6 = $[10], t6;
}, StyledLinkComponent = styled(IntentLink).withConfig({
  displayName: "StyledLinkComponent",
  componentId: "sc-1z0umyx-0"
})`text-decoration:none;`, ViewContentReleasesMenuItem = () => {
  const $ = c(11), router = useRouter(), {
    t
  } = useTranslation(), telemetry = useTelemetry();
  let t0;
  $[0] !== router ? (t0 = router.resolvePathFromState({
    tool: SCHEDULES_TOOL_NAME
  }), $[0] = router, $[1] = t0) : t0 = $[1];
  const releasesUrl = t0;
  let t1;
  $[2] !== telemetry ? (t1 = () => {
    telemetry.log(NavigatedToReleasesOverview, {
      source: "menu"
    });
  }, $[2] = telemetry, $[3] = t1) : t1 = $[3];
  const handleClick = t1;
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = forwardRef(function(restProps, ref) {
    return /* @__PURE__ */ jsx(StyledLinkComponent, { ...restProps, intent: RELEASES_INTENT, params: {
      source: "menu"
    }, ref });
  }), $[4] = t2) : t2 = $[4];
  const LinkComponent = t2;
  let t3;
  $[5] !== t ? (t3 = t("release.menu.view-releases"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  return $[7] !== handleClick || $[8] !== releasesUrl || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(MenuItem, { as: LinkComponent, href: releasesUrl, onClick: handleClick, icon: CalendarIcon, text: t3, "data-testid": "view-content-releases-menu-item" }), $[7] = handleClick, $[8] = releasesUrl, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
}, orderedReleaseTypes = ["asap", "scheduled", "undecided"], StickyCard = styled(Card).withConfig({
  displayName: "StickyCard",
  componentId: "sc-150hw49-0"
})`position:sticky;z-index:2;background:var(--card-bg-color);`, StickyTopCard = styled(StickyCard).withConfig({
  displayName: "StickyTopCard",
  componentId: "sc-150hw49-1"
})`top:0;`, StickyBottomCard = styled(StickyCard).withConfig({
  displayName: "StickyBottomCard",
  componentId: "sc-150hw49-2"
})`bottom:0;`;
function ReleasesList(t0) {
  const $ = c(51), {
    areReleasesEnabled,
    setScrollContainer,
    isRangeVisible,
    selectedPerspectiveName,
    handleOpenBundleDialog,
    scrollElementRef,
    menuItemProps
  } = t0, {
    loading,
    data: allReleases
  } = useActiveReleases(), {
    bundles: agentBundles
  } = useAgentBundles();
  let t1;
  $[0] !== allReleases ? (t1 = allReleases.filter(_temp$z), $[0] = allReleases, $[1] = t1) : t1 = $[1];
  const releases2 = t1, {
    document: t2
  } = useWorkspace(), {
    drafts: t3
  } = t2, {
    enabled: isDraftModelEnabled
  } = t3;
  let t4;
  $[2] !== releases2 ? (t4 = orderedReleaseTypes.reduce((ReleaseTypeReleases, releaseType) => ({
    ...ReleaseTypeReleases,
    [releaseType]: releases2.filter((t52) => {
      const {
        metadata
      } = t52;
      return metadata.releaseType === releaseType;
    })
  }), {}), $[2] = releases2, $[3] = t4) : t4 = $[3];
  const sortedReleaseTypeReleases = t4, isDraftsPerspective = typeof selectedPerspectiveName > "u";
  let lastIndex, offsets;
  if ($[4] !== isDraftModelEnabled || $[5] !== isDraftsPerspective || $[6] !== selectedPerspectiveName || $[7] !== sortedReleaseTypeReleases) {
    lastIndex = isDraftsPerspective ? 1 : 0;
    let t52;
    $[10] !== isDraftModelEnabled ? (t52 = [PUBLISHED$1, isDraftModelEnabled ? LATEST : []].flat(), $[10] = isDraftModelEnabled, $[11] = t52) : t52 = $[11];
    const systemStack = t52, {
      asap,
      scheduled
    } = sortedReleaseTypeReleases, t62 = systemStack.length + asap.length, t72 = systemStack.length + asap.length + scheduled.length;
    let t82;
    $[12] !== systemStack.length || $[13] !== t62 || $[14] !== t72 ? (t82 = {
      asap: systemStack.length,
      scheduled: t62,
      undecided: t72
    }, $[12] = systemStack.length, $[13] = t62, $[14] = t72, $[15] = t82) : t82 = $[15], offsets = t82;
    const adjustIndexForReleaseType = (type) => {
      const groupSubsetReleases = sortedReleaseTypeReleases[type], offset = offsets[type];
      groupSubsetReleases.forEach((release_0, groupReleaseIndex) => {
        const index = offset + groupReleaseIndex;
        selectedPerspectiveName === getReleaseIdFromReleaseDocumentId(release_0._id) && (lastIndex = index);
      });
    };
    orderedReleaseTypes.forEach(adjustIndexForReleaseType), $[4] = isDraftModelEnabled, $[5] = isDraftsPerspective, $[6] = selectedPerspectiveName, $[7] = sortedReleaseTypeReleases, $[8] = lastIndex, $[9] = offsets;
  } else
    lastIndex = $[8], offsets = $[9];
  let t5;
  $[16] !== lastIndex || $[17] !== offsets ? (t5 = {
    lastIndex,
    offsets
  }, $[16] = lastIndex, $[17] = offsets, $[18] = t5) : t5 = $[18];
  const range2 = t5;
  if (loading) {
    let t62;
    return $[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t62 = /* @__PURE__ */ jsx(Flex, { padding: 4, justify: "center", "data-testid": "spinner", children: /* @__PURE__ */ jsx(Spinner, { muted: !0 }) }), $[19] = t62) : t62 = $[19], t62;
  }
  let t6;
  $[20] !== isRangeVisible || $[21] !== range2 ? (t6 = isRangeVisible ? getRangePosition(range2, 0) : void 0, $[20] = isRangeVisible, $[21] = range2, $[22] = t6) : t6 = $[22];
  let t7;
  $[23] !== menuItemProps || $[24] !== t6 ? (t7 = /* @__PURE__ */ jsx(GlobalPerspectiveMenuItem, { rangePosition: t6, release: "published", menuItemProps }), $[23] = menuItemProps, $[24] = t6, $[25] = t7) : t7 = $[25];
  let t8;
  $[26] !== isDraftModelEnabled || $[27] !== isRangeVisible || $[28] !== menuItemProps || $[29] !== range2 ? (t8 = isDraftModelEnabled && /* @__PURE__ */ jsx(GlobalPerspectiveMenuItem, { rangePosition: isRangeVisible ? getRangePosition(range2, 1) : void 0, release: LATEST, menuItemProps }), $[26] = isDraftModelEnabled, $[27] = isRangeVisible, $[28] = menuItemProps, $[29] = range2, $[30] = t8) : t8 = $[30];
  let t9;
  $[31] !== t7 || $[32] !== t8 ? (t9 = /* @__PURE__ */ jsx(StickyTopCard, { borderBottom: !0, padding: 1, children: /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    t7,
    t8
  ] }) }), $[31] = t7, $[32] = t8, $[33] = t9) : t9 = $[33];
  let t10;
  $[34] !== agentBundles[0] ? (t10 = agentBundles[0] && /* @__PURE__ */ jsx(Card, { borderBottom: !0, padding: 1, children: /* @__PURE__ */ jsx(Stack, { space: 1, children: /* @__PURE__ */ jsx(AgentBundleMenuItem, { bundle: agentBundles[0] }) }) }), $[34] = agentBundles[0], $[35] = t10) : t10 = $[35];
  let t11;
  $[36] !== areReleasesEnabled || $[37] !== menuItemProps || $[38] !== range2 || $[39] !== scrollElementRef || $[40] !== setScrollContainer || $[41] !== sortedReleaseTypeReleases ? (t11 = areReleasesEnabled && /* @__PURE__ */ jsx(Stack, { ref: setScrollContainer, "data-ui": "scroll-wrapper", children: orderedReleaseTypes.map((releaseType_0) => /* @__PURE__ */ jsx(ReleaseTypeMenuSection, { releaseType: releaseType_0, releases: sortedReleaseTypeReleases[releaseType_0], range: range2, currentGlobalBundleMenuItemRef: scrollElementRef, menuItemProps }, releaseType_0)) }), $[36] = areReleasesEnabled, $[37] = menuItemProps, $[38] = range2, $[39] = scrollElementRef, $[40] = setScrollContainer, $[41] = sortedReleaseTypeReleases, $[42] = t11) : t11 = $[42];
  let t12;
  $[43] !== areReleasesEnabled || $[44] !== handleOpenBundleDialog ? (t12 = areReleasesEnabled && /* @__PURE__ */ jsx(StickyBottomCard, { borderTop: !0, paddingY: 1, paddingX: 2, children: /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    /* @__PURE__ */ jsx(ScheduledDraftsMenuItem, {}),
    /* @__PURE__ */ jsx(ViewContentReleasesMenuItem, {}),
    /* @__PURE__ */ jsx(CreateReleaseMenuItem, { onCreateRelease: handleOpenBundleDialog })
  ] }) }), $[43] = areReleasesEnabled, $[44] = handleOpenBundleDialog, $[45] = t12) : t12 = $[45];
  let t13;
  return $[46] !== t10 || $[47] !== t11 || $[48] !== t12 || $[49] !== t9 ? (t13 = /* @__PURE__ */ jsxs(Card, { radius: 3, children: [
    t9,
    t10,
    t11,
    t12
  ] }), $[46] = t10, $[47] = t11, $[48] = t12, $[49] = t9, $[50] = t13) : t13 = $[50], t13;
}
function _temp$z(release) {
  return !isCardinalityOneRelease(release);
}
function findScrollableAncestor(element) {
  let current = element.parentElement;
  for (; current; ) {
    const {
      overflowY
    } = getComputedStyle(current);
    if (overflowY === "auto" || overflowY === "scroll")
      return current;
    current = current.parentElement;
  }
  return null;
}
function isElementVisibleInContainer(container, element) {
  if (!container || !element) return !0;
  const containerRect = container.getBoundingClientRect();
  return element.getBoundingClientRect().top >= containerRect.top + 32.5 * 2;
}
const useScrollIndicatorVisibility = () => {
  const $ = c(7), scrollElementRef = useRef(null), scrollAncestorRef = useRef(null), [isRangeVisible, setIsRangeVisible] = useState(!0);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setIsRangeVisible(isElementVisibleInContainer(scrollAncestorRef.current, scrollElementRef.current)), $[0] = t0) : t0 = $[0];
  const handleScroll = t0;
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (container) => {
    const previousAncestor = scrollAncestorRef.current;
    if (previousAncestor && (previousAncestor.removeEventListener("scroll", handleScroll), scrollAncestorRef.current = null), container) {
      const scrollableAncestor = findScrollableAncestor(container);
      scrollAncestorRef.current = scrollableAncestor, scrollableAncestor && scrollableAncestor.addEventListener("scroll", handleScroll, {
        passive: !0
      });
    }
  }, $[1] = t1) : t1 = $[1];
  const setScrollContainer = t1;
  let t2, t3;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => () => {
    const ancestor = scrollAncestorRef.current;
    ancestor && ancestor.removeEventListener("scroll", handleScroll);
  }, t3 = [handleScroll], $[2] = t2, $[3] = t3) : (t2 = $[2], t3 = $[3]), useEffect(t2, t3);
  let t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => setIsRangeVisible(!0), $[4] = t4) : t4 = $[4];
  const resetRangeVisibility = t4;
  let t5;
  return $[5] !== isRangeVisible ? (t5 = {
    resetRangeVisibility,
    isRangeVisible,
    setScrollContainer,
    scrollElementRef
  }, $[5] = isRangeVisible, $[6] = t5) : t5 = $[6], t5;
}, StyledMenu$3 = styled(Menu).withConfig({
  displayName: "StyledMenu",
  componentId: "sc-3ke5c8-0"
})`min-width:200px;max-width:320px;> [data-ui='Stack']{gap:0;}`, OversizedButton = styled(Button$1).withConfig({
  displayName: "OversizedButton",
  componentId: "sc-3ke5c8-1"
})`${oversizedButtonStyle}`;
function GlobalPerspectiveMenu(t0) {
  const $ = c(25), {
    selectedPerspectiveName,
    areReleasesEnabled: t1,
    menuItemProps
  } = t0, areReleasesEnabled = t1 === void 0 ? !0 : t1, [createBundleDialogOpen, setCreateBundleDialogOpen] = useState(!1), {
    handleOpenDialog: handleOpenReleasesUpsellDialog,
    mode: releasesUpsellMode
  } = useReleasesUpsell(), styledMenuRef = useRef(null), {
    isRangeVisible,
    resetRangeVisibility,
    setScrollContainer,
    scrollElementRef
  } = useScrollIndicatorVisibility();
  let t2;
  $[0] !== handleOpenReleasesUpsellDialog || $[1] !== releasesUpsellMode ? (t2 = () => {
    if (releasesUpsellMode === "upsell") {
      handleOpenReleasesUpsellDialog();
      return;
    }
    setCreateBundleDialogOpen(!0);
  }, $[0] = handleOpenReleasesUpsellDialog, $[1] = releasesUpsellMode, $[2] = t2) : t2 = $[2];
  const handleOpenBundleDialog = t2;
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setCreateBundleDialogOpen(!1);
  }, $[3] = t3) : t3 = $[3];
  const handleClose = t3;
  let t4;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(OversizedButton, { "data-testid": "global-perspective-menu-button", iconRight: ChevronDownIcon, mode: "bleed", padding: 2, radius: "full" }), $[4] = t4) : t4 = $[4];
  let t5;
  $[5] !== areReleasesEnabled || $[6] !== handleOpenBundleDialog || $[7] !== isRangeVisible || $[8] !== menuItemProps || $[9] !== scrollElementRef || $[10] !== selectedPerspectiveName || $[11] !== setScrollContainer ? (t5 = /* @__PURE__ */ jsx(StyledMenu$3, { "data-testid": "release-menu", ref: styledMenuRef, padding: 0, children: /* @__PURE__ */ jsx(ReleasesList, { areReleasesEnabled, setScrollContainer, isRangeVisible, scrollElementRef, selectedPerspectiveName, handleOpenBundleDialog, menuItemProps }) }), $[5] = areReleasesEnabled, $[6] = handleOpenBundleDialog, $[7] = isRangeVisible, $[8] = menuItemProps, $[9] = scrollElementRef, $[10] = selectedPerspectiveName, $[11] = setScrollContainer, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = [0, 0, 32, 0], $[13] = t6) : t6 = $[13];
  let t7;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = ["bottom-end"], $[14] = t7) : t7 = $[14];
  let t8;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = {
    overflow: "hidden"
  }, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = {
    __unstable_margins: t6,
    constrainSize: !0,
    fallbackPlacements: t7,
    placement: "bottom-end",
    portal: !0,
    style: t8,
    tone: "default",
    zOffset: 3e3
  }, $[16] = t9) : t9 = $[16];
  let t10;
  $[17] !== resetRangeVisibility || $[18] !== t5 ? (t10 = /* @__PURE__ */ jsx(MenuButton, { button: t4, id: "releases-menu", onClose: resetRangeVisibility, menu: t5, popover: t9 }), $[17] = resetRangeVisibility, $[18] = t5, $[19] = t10) : t10 = $[19];
  let t11;
  $[20] !== createBundleDialogOpen ? (t11 = createBundleDialogOpen && /* @__PURE__ */ jsx(CreateReleaseDialog, { onCancel: handleClose, onSubmit: handleClose, origin: "structure" }), $[20] = createBundleDialogOpen, $[21] = t11) : t11 = $[21];
  let t12;
  return $[22] !== t10 || $[23] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t10,
    t11
  ] }), $[22] = t10, $[23] = t11, $[24] = t12) : t12 = $[24], t12;
}
const ReleasesNavContainer = styled(Card).withConfig({
  displayName: "ReleasesNavContainer",
  componentId: "sc-d4iobr-0"
})`position:relative;display:flex;&:not([hidden]){display:flex;}align-items:center;gap:2px;padding:2px;margin:-3px 0;span:has(> [data-ui='error-status-icon']){position:absolute;top:6px;right:6px;padding:0;}a:hover,button:hover{position:relative;z-index:2;}`, ReleasesNav = (t0) => {
  const $ = c(13), {
    withReleasesToolButton,
    menuItemProps
  } = t0, releasesToolAvailable = useReleasesToolAvailable(), isReleasesEnabled = !!useWorkspace().releases?.enabled, {
    selectedPerspective,
    selectedPerspectiveName
  } = usePerspective();
  let t1;
  $[0] !== releasesToolAvailable || $[1] !== withReleasesToolButton ? (t1 = withReleasesToolButton && releasesToolAvailable && /* @__PURE__ */ jsx(ReleasesToolLink, {}), $[0] = releasesToolAvailable, $[1] = withReleasesToolButton, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== selectedPerspective ? (t2 = /* @__PURE__ */ jsx(CurrentGlobalPerspectiveLabel, { selectedPerspective }), $[3] = selectedPerspective, $[4] = t2) : t2 = $[4];
  const t3 = releasesToolAvailable && isReleasesEnabled;
  let t4;
  $[5] !== menuItemProps || $[6] !== selectedPerspectiveName || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(GlobalPerspectiveMenu, { selectedPerspectiveName, areReleasesEnabled: t3, menuItemProps }), $[5] = menuItemProps, $[6] = selectedPerspectiveName, $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  return $[9] !== t1 || $[10] !== t2 || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsxs(ReleasesNavContainer, { flex: "none", tone: "inherit", radius: "full", "data-ui": "ReleasesNav", border: !0, children: [
    t1,
    t2,
    t4
  ] }), $[9] = t1, $[10] = t2, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
};
function StudioActiveToolLayout(props2) {
  const $ = c(3), {
    activeTool
  } = props2, Component2 = activeTool.component;
  let t0;
  return $[0] !== Component2 || $[1] !== activeTool ? (t0 = /* @__PURE__ */ jsx(Component2, { tool: activeTool }), $[0] = Component2, $[1] = activeTool, $[2] = t0) : t0 = $[2], t0;
}
const NON_DEFAULT_ROUTE_TOOL_TYPES = ["sanity/schedules"];
function isDefaultRouteTool(tool) {
  return !tool.__internalApplicationType || !NON_DEFAULT_ROUTE_TOOL_TYPES.includes(tool.__internalApplicationType);
}
function DocumentLimitUpsellProvider(t0) {
  const $ = c(9), {
    children
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    dataUri: "/journey/document-limit",
    feature: "document-limits"
  }, $[0] = t1) : t1 = $[0];
  const contextValue = useUpsellContext(t1);
  let t2;
  $[1] !== contextValue ? (t2 = getDialogPropsFromContext(contextValue), $[1] = contextValue, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(UpsellDialog, { ...t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== children || $[6] !== contextValue || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(DocumentLimitUpsellContext.Provider, { value: contextValue, children: [
    children,
    t3
  ] }), $[5] = children, $[6] = contextValue, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
const useDocumentLimitsUpsellContext = () => {
  const context = useContext(DocumentLimitUpsellContext);
  if (!context)
    throw new Error("useDocumentLimitsUpsellContext must be used within a DocumentLimitUpsellProvider");
  return context;
};
function DocumentLimitsUpsellPanel() {
  const $ = c(12), {
    upsellData,
    telemetryLogs
  } = useDocumentLimitsUpsellContext();
  let t0;
  $[0] !== telemetryLogs ? (t0 = () => {
    telemetryLogs.panelPrimaryClicked();
  }, $[0] = telemetryLogs, $[1] = t0) : t0 = $[1];
  const handlePrimaryButtonClick = t0;
  let t1;
  $[2] !== telemetryLogs ? (t1 = () => {
    telemetryLogs.panelSecondaryClicked();
  }, $[2] = telemetryLogs, $[3] = t1) : t1 = $[3];
  const handleSecondaryButtonClick = t1;
  if (!upsellData) {
    let t22;
    return $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(LoadingBlock, { title: "Loading documents limit", showText: !0 }), $[4] = t22) : t22 = $[4], t22;
  }
  let t2, t3, t4;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    opacity: 0,
    scale: 0.95
  }, t3 = {
    opacity: 1,
    scale: 1
  }, t4 = {
    duration: 0.2
  }, $[5] = t2, $[6] = t3, $[7] = t4) : (t2 = $[5], t3 = $[6], t4 = $[7]);
  let t5;
  return $[8] !== handlePrimaryButtonClick || $[9] !== handleSecondaryButtonClick || $[10] !== upsellData ? (t5 = /* @__PURE__ */ jsx(Flex, { height: "fill", width: "fill", justify: "center", align: "center", padding: 4, children: /* @__PURE__ */ jsx(motion.div, { initial: t2, animate: t3, transition: t4, children: /* @__PURE__ */ jsx(Container$3, { width: 0, children: /* @__PURE__ */ jsx(UpsellPanel, { data: upsellData, onPrimaryClick: handlePrimaryButtonClick, onSecondaryClick: handleSecondaryButtonClick }) }) }) }), $[8] = handlePrimaryButtonClick, $[9] = handleSecondaryButtonClick, $[10] = upsellData, $[11] = t5) : t5 = $[11], t5;
}
const isDocumentLimitError = (error) => error instanceof ClientError ? error.response.body.error.type === "documentLimitExceededError" : !1, checkPath = "/ping", checkRequestTag = "protocol-check";
function isUsingLegacyHttp(client) {
  return getProtocolForApi(client).pipe(map((protocol) => {
    if (protocol)
      return protocol.startsWith("http/0") || protocol.startsWith("http/1");
  }));
}
function getProtocolForApi(client) {
  return typeof PerformanceObserver > "u" || typeof PerformanceResourceTiming > "u" ? of(void 0) : detectProtocol(`${client.getUrl(checkPath)}?tag=sanity.studio.${checkRequestTag}`);
}
function detectProtocol(checkUrl) {
  const timingEntry = firstValueFrom(listenBufferedPerformanceEntries().pipe(filter((entry) => entry instanceof PerformanceResourceTiming && entry.name === checkUrl), take(1), map((entry) => localStorage._sanity_debugProtocol ?? entry.nextHopProtocol)));
  return defer(() => fetch(checkUrl)).pipe(
    // when the request is over, we map it to the corresponding timing entry
    mergeMap(() => timingEntry),
    // Race the actual timing detection against a 2.5s timer.
    // If the timer wins, we emit undefined to indicate we couldn’t detect the protocol.
    timeout$1({
      first: 2500,
      with: () => of(void 0)
    })
  );
}
function listenBufferedPerformanceEntries() {
  return new Observable((subscriber) => {
    const perfObserver = new PerformanceObserver((list) => {
      for (const entry of list.getEntries())
        subscriber.next(entry);
    });
    return perfObserver.observe({
      type: "resource",
      buffered: !0
    }), () => perfObserver.disconnect();
  });
}
const HTTP_HELP_URL = generateHelpUrl("http1-performance-issues"), SNOOZE_DURATION_HOURS = 24;
function useNetworkProtocolCheck() {
  const $ = c(46), {
    push: pushToast
  } = useToast(), {
    t
  } = useTranslation();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "2025-03-01"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0);
  let t1;
  $[1] !== t ? (t1 = t("network-check.slow-protocol-warning.title"), $[1] = t, $[2] = t1) : t1 = $[2];
  const title = t1, [isOnLegacyHttp, setIsOnLegacyHttp] = useState(), [warningSnoozedAtRaw, setWarningSnoozedAt] = useSessionStorageState("sanity-studio.network.check.snooze");
  let t2;
  $[3] !== warningSnoozedAtRaw ? (t2 = warningSnoozedAtRaw ? new Date(warningSnoozedAtRaw) : void 0, $[3] = warningSnoozedAtRaw, $[4] = t2) : t2 = $[4];
  const warningDismissedAt = t2;
  let t3;
  $[5] !== warningDismissedAt ? (t3 = warningDismissedAt && (/* @__PURE__ */ new Date()).getTime() - warningDismissedAt.getTime() < 36e5 * SNOOZE_DURATION_HOURS, $[5] = warningDismissedAt, $[6] = t3) : t3 = $[6];
  const isWarningSnoozed = t3;
  let t4;
  $[7] !== client || $[8] !== isWarningSnoozed ? (t4 = () => {
    const sub2 = (isWarningSnoozed ? of(void 0) : isUsingLegacyHttp(client)).subscribe((result) => setIsOnLegacyHttp(result));
    return () => sub2.unsubscribe();
  }, $[7] = client, $[8] = isWarningSnoozed, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== client || $[11] !== isWarningSnoozed || $[12] !== pushToast || $[13] !== title || $[14] !== warningDismissedAt ? (t5 = [client, isWarningSnoozed, pushToast, title, warningDismissedAt], $[10] = client, $[11] = isWarningSnoozed, $[12] = pushToast, $[13] = title, $[14] = warningDismissedAt, $[15] = t5) : t5 = $[15], useEffect(t4, t5);
  let t6;
  $[16] !== setWarningSnoozedAt ? (t6 = () => setWarningSnoozedAt((/* @__PURE__ */ new Date()).toISOString()), $[16] = setWarningSnoozedAt, $[17] = t6) : t6 = $[17];
  const handleSnooze = t6, t7 = isOnLegacyHttp && !isWarningSnoozed;
  let t8;
  $[18] !== t ? (t8 = t("network-check.slow-protocol-warning.description"), $[18] = t, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== t8 ? (t9 = /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t8,
    " "
  ] }) }), $[20] = t8, $[21] = t9) : t9 = $[21];
  let t10;
  $[22] !== t ? (t10 = t("network-check.slow-protocol-warning.learn-more-button.tooltip"), $[22] = t, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] !== t10 ? (t11 = {
    content: t10
  }, $[24] = t10, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== t ? (t12 = t("network-check.slow-protocol-warning.learn-more-button.text"), $[26] = t, $[27] = t12) : t12 = $[27];
  let t13;
  $[28] !== t11 || $[29] !== t12 ? (t13 = /* @__PURE__ */ jsx(Button, { as: "a", href: HTTP_HELP_URL, target: "_blank", rel: "noreferrer", mode: "ghost", tone: "primary", size: "default", icon: LaunchIcon, tooltipProps: t11, text: t12 }), $[28] = t11, $[29] = t12, $[30] = t13) : t13 = $[30];
  let t14;
  $[31] !== t ? (t14 = t("network-check.slow-protocol-warning.snooze-button.text"), $[31] = t, $[32] = t14) : t14 = $[32];
  let t15;
  $[33] !== handleSnooze || $[34] !== t14 ? (t15 = /* @__PURE__ */ jsx(Button, { mode: "bleed", tone: "neutral", size: "default", text: t14, onClick: handleSnooze }), $[33] = handleSnooze, $[34] = t14, $[35] = t15) : t15 = $[35];
  let t16;
  $[36] !== t13 || $[37] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
    t13,
    t15
  ] }), $[36] = t13, $[37] = t15, $[38] = t16) : t16 = $[38];
  let t17;
  $[39] !== t16 || $[40] !== t9 ? (t17 = /* @__PURE__ */ jsxs(Stack, { space: 4, paddingY: 1, children: [
    t9,
    t16
  ] }), $[39] = t16, $[40] = t9, $[41] = t17) : t17 = $[41];
  let t18;
  $[42] !== t17 || $[43] !== t7 || $[44] !== title ? (t18 = {
    id: "network-protocol-check",
    status: "warning",
    enabled: t7,
    title,
    description: t17
  }, $[42] = t17, $[43] = t7, $[44] = title, $[45] = t18) : t18 = $[45], useConditionalToast(t18);
}
function useSessionStorageState(key) {
  const $ = c(7);
  let t0;
  $[0] !== key ? (t0 = () => {
    const stored = sessionStorage.getItem(key);
    return typeof stored == "string" ? stored : void 0;
  }, $[0] = key, $[1] = t0) : t0 = $[1];
  const [state, setState] = useState(t0);
  let t1;
  $[2] !== key ? (t1 = (value) => {
    setState(value), value === void 0 ? sessionStorage.removeItem(key) : sessionStorage.setItem(key, value);
  }, $[2] = key, $[3] = t1) : t1 = $[3];
  const setValue = t1, t2 = typeof state == "string" ? state : void 0;
  let t3;
  return $[4] !== setValue || $[5] !== t2 ? (t3 = [t2, setValue], $[4] = setValue, $[5] = t2, $[6] = t3) : t3 = $[6], t3;
}
function NoToolsScreen() {
  const $ = c(4);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t0) : t0 = $[0];
  let t1, t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Text$1, { as: "h1", size: 1, weight: "medium", children: "No configured tools" }), t2 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: "Please configure a tool in your Studio configuration." }), $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]);
  let t3;
  return $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Card, { height: "fill", children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", padding: 4, sizing: "border", children: /* @__PURE__ */ jsx(Container$3, { width: 0, children: /* @__PURE__ */ jsx(Card, { padding: 4, radius: 2, shadow: 1, tone: "caution", children: /* @__PURE__ */ jsxs(Flex, { children: [
    t0,
    /* @__PURE__ */ jsxs(Stack, { flex: 1, marginLeft: 3, space: 3, children: [
      t1,
      t2,
      /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx("a", { href: "https://www.sanity.io/docs/studio-tools", rel: "noreferrer", target: "_blank", children: "Learn how to add a tool \u2192" }) })
    ] })
  ] }) }) }) }) }), $[3] = t3) : t3 = $[3], t3;
}
function RedirectingScreen(props2) {
  const $ = c(3), {
    reason: t0
  } = props2, reason = t0 === void 0 ? "Redirecting\u2026" : t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(DoubleChevronRightIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  let t2;
  return $[1] !== reason ? (t2 = /* @__PURE__ */ jsx(Card, { height: "fill", children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", padding: 4, sizing: "border", children: /* @__PURE__ */ jsx(Container$3, { width: 0, children: /* @__PURE__ */ jsx(Card, { padding: 4, radius: 2, shadow: 1, tone: "primary", children: /* @__PURE__ */ jsxs(Flex, { children: [
    t1,
    /* @__PURE__ */ jsx(Stack, { flex: 1, marginLeft: 3, space: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "h1", size: 1, weight: "bold", children: reason }) })
  ] }) }) }) }) }), $[1] = reason, $[2] = t2) : t2 = $[2], t2;
}
function ToolNotFoundScreen(props2) {
  const $ = c(3), {
    toolName
  } = props2;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] !== toolName ? (t1 = /* @__PURE__ */ jsx(Card, { height: "fill", children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", padding: 4, sizing: "border", children: /* @__PURE__ */ jsx(Container$3, { width: 0, children: /* @__PURE__ */ jsx(Card, { padding: 4, radius: 2, shadow: 1, tone: "caution", children: /* @__PURE__ */ jsxs(Flex, { children: [
    t0,
    /* @__PURE__ */ jsx(Stack, { flex: 1, marginLeft: 3, space: 3, children: /* @__PURE__ */ jsxs(Text$1, { as: "h1", size: 1, weight: "medium", children: [
      "Tool not found: ",
      /* @__PURE__ */ jsx("code", { children: toolName })
    ] }) })
  ] }) }) }) }) }), $[1] = toolName, $[2] = t1) : t1 = $[2], t1;
}
const hasSanityPackageInImportMap = () => !!getSanityImportMapUrl(), getSanityImportMapUrl = () => {
  if (typeof document > "u" || !("querySelectorAll" in document))
    return;
  const importMapEntries = document.querySelectorAll('script[type="importmap"]');
  let found;
  return Array.from(importMapEntries).some((entry) => {
    if (!entry.textContent) return !1;
    const imports = JSON.parse(entry.textContent).imports || {};
    return "sanity" in imports ? (found = imports.sanity, !0) : !1;
  }), found;
};
function makeBufferedTransport(options) {
  let buffer = [], consentGiven;
  const fetchTransport = makeFetchTransport(options), send = async (event) => consentGiven ? sendImmediately(event) : (typeof consentGiven > "u" && buffer.push(event), {}), sendImmediately = async (event) => fetchTransport.send(event), setConsent = async (consent) => {
    consentGiven = consent, consent && await flushBuffer(), buffer = [];
  }, flushBuffer = async () => {
    await Promise.all(buffer.map(sendImmediately)).catch((err) => {
      console.error("Failed to send buffered events from transport: ", err);
    });
  };
  return {
    flush: async () => fetchTransport.flush(),
    send,
    setConsent
  };
}
const SANITY_DSN = "https://8914c8dde7e1ebce191f15af8bf6b7b9@sentry.sanity.io/4507342122123264", IS_EMBEDDED_STUDIO = !("__sanityErrorChannel" in globalScope), DEBUG_ERROR_REPORTING = supportsLocalStorage && !!localStorage.getItem("SANITY_DEBUG_ERROR_REPORTING"), IS_BROWSER = typeof window < "u", clientOptions = {
  dsn: SANITY_DSN,
  release: SANITY_VERSION,
  environment: isDev ? "development" : "production",
  debug: DEBUG_ERROR_REPORTING,
  enabled: IS_BROWSER && (!isDev || DEBUG_ERROR_REPORTING),
  transport: makeBufferedTransport
}, integrations = [inboundFiltersIntegration(), functionToStringIntegration(), browserApiErrorsIntegration({
  eventTarget: !1
}), breadcrumbsIntegration({
  console: !1
}), globalHandlersIntegration({
  onerror: !0,
  onunhandledrejection: !0
}), linkedErrorsIntegration(), dedupeIntegration(), sanityDedupeIntegration(), httpContextIntegration()];
function getSentryErrorReporter() {
  let client, scope;
  const preInitErrors = [];
  function _initialize() {
    if (client || !DEBUG_ERROR_REPORTING && !hasSanityPackageInImportMap() || !DEBUG_ERROR_REPORTING && IS_EMBEDDED_STUDIO)
      return;
    const isSentryInitialized = isInitialized(), hasThirdPartySentry = isSentryInitialized && getClient()?.getOptions().dsn === SANITY_DSN;
    if (isSentryInitialized && !hasThirdPartySentry) {
      client = getClient(), scope = getCurrentScope();
      return;
    }
    if (hasThirdPartySentry) {
      client = new BrowserClient({
        ...clientOptions,
        stackParser: defaultStackParser,
        integrations,
        beforeSend,
        transport: makeBufferedTransport
      }), scope = new Scope(), scope.setClient(client), client.init();
      return;
    }
    init({
      ...clientOptions,
      defaultIntegrations: !1,
      integrations,
      beforeSend
    }), client = getClient(), scope = getCurrentScope();
  }
  function initialize() {
    _initialize(), client && preInitErrors.length > 0 && (preInitErrors.forEach(({
      error,
      options
    }) => reportError(error, options)), preInitErrors.length = 0);
  }
  function reportError(error, options = {}) {
    if (!client)
      return preInitErrors.push({
        error,
        options
      }), null;
    const {
      reactErrorInfo = {},
      errorBoundary
    } = options, {
      componentStack
    } = reactErrorInfo, contexts = {};
    componentStack && (contexts.react = {
      componentStack
    });
    const tags = {
      handled: "no"
    };
    errorBoundary && (tags.errorBoundary = errorBoundary);
    let eventId = null;
    return withScope(() => {
      if (componentStack && isError(error)) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `${errorBoundary || "ErrorBoundary"} ${error.name}`, errorBoundaryError.stack = componentStack, setCause(error, errorBoundaryError);
      }
      eventId = captureException(error, {
        mechanism: {
          handled: !1
        },
        captureContext: {
          contexts,
          tags
        }
      });
    }), eventId ? {
      eventId
    } : null;
  }
  function isBufferedTransport(transport) {
    return !!transport && "setConsent" in transport && typeof transport.setConsent == "function";
  }
  function enable() {
    const transport = client?.getTransport();
    isBufferedTransport(transport) && transport.setConsent(!0);
  }
  function disable() {
    const transport = client?.getTransport();
    isBufferedTransport(transport) && transport.setConsent(!1);
  }
  return {
    initialize,
    reportError,
    enable,
    disable
  };
}
const objectToString = Object.prototype.toString;
function isError(thing) {
  switch (objectToString.call(thing)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return !0;
    default:
      return isInstanceOf(thing, Error);
  }
}
function isInstanceOf(thing, base) {
  try {
    return thing instanceof base;
  } catch {
    return !1;
  }
}
function setCause(error, cause) {
  const seenErrors = /* @__PURE__ */ new WeakMap();
  function recurse(err, subCause) {
    if (!seenErrors.has(err)) {
      if (isError(err.cause)) {
        seenErrors.set(err, !0), recurse(err.cause, subCause);
        return;
      }
      err.cause = subCause;
    }
  }
  recurse(error, cause);
}
function setAsUnhandled(event) {
  for (const exception of event.exception?.values || [])
    exception.mechanism && (exception.mechanism.handled = !1);
}
function beforeSend(event) {
  return setAsUnhandled(event), event;
}
function sanityDedupeIntegration() {
  const previousEvents = [];
  return {
    name: "SanityDedupe",
    processEvent(currentEvent) {
      if (currentEvent.type)
        return currentEvent;
      try {
        if (shouldDropEvent(currentEvent, previousEvents))
          return DEBUG_ERROR_REPORTING && console.warn("[sanity/sentry] Dropping error from being reported because it is a duplicate"), null;
      } catch {
      }
      return previousEvents.length > 10 && previousEvents.shift(), previousEvents.push(currentEvent), currentEvent;
    }
  };
}
function shouldDropEvent(currentEvent, previousEvents) {
  for (const previousEvent of previousEvents) {
    const currentMessage = getMessageFromEvent(currentEvent), previousMessage = getMessageFromEvent(previousEvent);
    if (currentMessage && previousMessage && currentMessage !== previousMessage)
      continue;
    const currentTimestamp = Math.floor(currentEvent.timestamp || 0), previousTimestamp = Math.floor(previousEvent.timestamp || 0);
    if (Math.abs(currentTimestamp - previousTimestamp) < 300)
      return !0;
  }
  return !1;
}
function getMessageFromEvent(event) {
  if (event.message)
    return event.message;
  if (event.exception) {
    for (const exception of event.exception.values || [])
      if (exception.value)
        return exception.value;
  }
}
const errorReporter = getSentryErrorReporter(), MESSAGES = [
  // chromium
  "Failed to fetch dynamically imported module:",
  // safari
  "Importing a module script failed.",
  // firefox
  "error loading dynamically imported module"
];
function isImportError(error) {
  return error.name === "TypeError" && MESSAGES.some((msg) => error.message.toLowerCase().startsWith(msg.toLowerCase()));
}
const WORKSPACES_DOCS_URL = "https://www.sanity.io/docs/workspaces", useWorkspaceAuthStates = createHookFromObservableFactory((workspaces) => combineLatest(workspaces.map((workspace) => workspace.auth.state.pipe(map((state) => [workspace.name, state])))).pipe(map((entries) => Object.fromEntries(entries)))), STATE_TITLES = {
  "logged-in": "",
  "logged-out": "Signed out",
  "no-access": ""
}, Media$1 = styled.div.withConfig({
  displayName: "Media",
  componentId: "sc-13u8s6k-0"
})`width:${(props2) => props2.$size === "small" ? "25px" : "41px"};height:${(props2) => props2.$size === "small" ? "25px" : "41px"};border-radius:0.25rem;padding:0;svg{width:100%;height:100%;border-radius:inherit;}`, WorkspacePreviewIcon = (t0) => {
  const $ = c(5), {
    icon,
    size: t1
  } = t0, size = t1 === void 0 ? "small" : t1;
  let t2;
  $[0] !== icon ? (t2 = createIcon(icon), $[0] = icon, $[1] = t2) : t2 = $[1];
  const iconComponent = t2;
  let t3;
  return $[2] !== iconComponent || $[3] !== size ? (t3 = /* @__PURE__ */ jsx(Media$1, { $size: size, children: iconComponent }), $[2] = iconComponent, $[3] = size, $[4] = t3) : t3 = $[4], t3;
}, createIcon = (Icon2) => {
  if (isValidElementType(Icon2)) return /* @__PURE__ */ jsx(Icon2, {});
  if (isValidElement(Icon2)) return Icon2;
};
function WorkspacePreview(props2) {
  const $ = c(21), {
    state,
    subtitle,
    selected,
    title,
    icon,
    iconRight
  } = props2;
  let t0;
  $[0] !== iconRight ? (t0 = createIcon(iconRight), $[0] = iconRight, $[1] = t0) : t0 = $[1];
  const iconRightComponent = t0;
  let t1;
  $[2] !== icon ? (t1 = /* @__PURE__ */ jsx(WorkspacePreviewIcon, { icon, size: "small" }), $[2] = icon, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== title ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: title }), $[4] = title, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== subtitle ? (t3 = subtitle && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: subtitle }), $[6] = subtitle, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t2 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
    t2,
    t3
  ] }), $[8] = t2, $[9] = t3, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== state ? (t5 = state && STATE_TITLES[state] && /* @__PURE__ */ jsx(Box, { paddingLeft: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, textOverflow: "ellipsis", children: STATE_TITLES[state] }) }), $[11] = state, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== iconRightComponent || $[14] !== selected ? (t6 = (selected || iconRightComponent) && /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 4, paddingLeft: 3, paddingRight: 2, children: [
    selected && /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(CheckmarkIcon, {}) }),
    iconRightComponent && /* @__PURE__ */ jsx(Text$1, { muted: !0, children: iconRightComponent })
  ] }), $[13] = iconRightComponent, $[14] = selected, $[15] = t6) : t6 = $[15];
  let t7;
  return $[16] !== t1 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: "none", gap: 3, children: [
    t1,
    t4,
    t5,
    t6
  ] }), $[16] = t1, $[17] = t4, $[18] = t5, $[19] = t6, $[20] = t7) : t7 = $[20], t7;
}
const LINKS = [{
  url: "https://snty.link/community",
  i18nKey: "workspaces.community-title",
  title: "Community"
}, {
  url: "https://www.sanity.io/docs",
  i18nKey: "workspaces.docs-title",
  title: "Docs"
}, {
  url: "https://www.sanity.io/legal/privacy",
  i18nKey: "workspaces.privacy-title",
  title: "Privacy"
}, {
  url: "https://www.sanity.io",
  i18nKey: "workspaces.sanity-io-title",
  title: "sanity.io"
}], StyledText = styled(Text$1).withConfig({
  displayName: "StyledText",
  componentId: "sc-cwavj5-0"
})`a{color:inherit;}`;
function Layout(props2) {
  const $ = c(23), {
    children,
    footer,
    header
  } = props2, prefersDark = usePrefersDark();
  let t0;
  $[0] !== header ? (t0 = typeof header == "object" && /* @__PURE__ */ jsx(Box, { children: header }), $[0] = header, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== header ? (t1 = typeof header == "string" && /* @__PURE__ */ jsx(Box, { paddingY: 4, children: /* @__PURE__ */ jsx(Heading, { align: "center", size: 1, children: header }) }), $[2] = header, $[3] = t1) : t1 = $[3];
  const t2 = !!header, t3 = !!footer;
  let t4;
  $[4] !== children || $[5] !== t2 || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(Box, { paddingX: 1, children: /* @__PURE__ */ jsx(Card, { borderTop: t2, borderBottom: t3, children }) }), $[4] = children, $[5] = t2, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== footer ? (t5 = footer && /* @__PURE__ */ jsx(Box, { children: footer }), $[8] = footer, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t0 || $[11] !== t1 || $[12] !== t4 || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { border: !0, radius: 3, overflow: "auto", children: /* @__PURE__ */ jsxs(Stack, { children: [
    t0,
    t1,
    t4,
    t5
  ] }) }), $[10] = t0, $[11] = t1, $[12] = t4, $[13] = t5, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== prefersDark ? (t7 = /* @__PURE__ */ jsx(Text$1, { size: 3, children: /* @__PURE__ */ jsx(SanityLogo, { dark: prefersDark }) }), $[15] = prefersDark, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = /* @__PURE__ */ jsx(Flex, { align: "center", gap: 2, children: LINKS.map(_temp$y) }), $[17] = t8) : t8 = $[17];
  let t9;
  $[18] !== t7 ? (t9 = /* @__PURE__ */ jsxs(Flex, { direction: "column", gap: 4, justify: "center", align: "center", paddingBottom: 4, children: [
    t7,
    t8
  ] }), $[18] = t7, $[19] = t9) : t9 = $[19];
  let t10;
  return $[20] !== t6 || $[21] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { space: 6, children: [
    t6,
    t9
  ] }), $[20] = t6, $[21] = t9, $[22] = t10) : t10 = $[22], t10;
}
function _temp$y(link, index) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(StyledText, { muted: !0, size: 1, children: /* @__PURE__ */ jsx("a", { href: link.url, target: "_blank", rel: "noopener noreferrer", children: link.title }) }),
    index < LINKS.length - 1 && /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: "\u2022" })
  ] }, link.title);
}
function WorkspaceAuth() {
  const $ = c(46), workspaces = useWorkspaces(), {
    activeWorkspace,
    setActiveWorkspace
  } = useActiveWorkspace(), [authStates] = useWorkspaceAuthStates(workspaces), [selectedWorkspaceName, setSelectedWorkspaceName] = useState(activeWorkspace?.name || null);
  let t0;
  $[0] !== selectedWorkspaceName || $[1] !== workspaces ? (t0 = workspaces.length === 1 ? workspaces[0] : workspaces.find((workspace) => workspace.name === selectedWorkspaceName), $[0] = selectedWorkspaceName, $[1] = workspaces, $[2] = t0) : t0 = $[2];
  const selectedWorkspace = t0, LoginComponent = selectedWorkspace?.auth?.LoginComponent;
  let t1;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setSelectedWorkspaceName(null), $[3] = t1) : t1 = $[3];
  const handleBack = t1, {
    t
  } = useTranslation();
  if (!authStates) {
    let t22;
    return $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }), $[4] = t22) : t22 = $[4], t22;
  }
  if (LoginComponent && selectedWorkspace) {
    let t22;
    $[5] !== t || $[6] !== workspaces.length ? (t22 = workspaces.length > 1 && /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(Button, { icon: ArrowLeftIcon, mode: "bleed", onClick: handleBack, text: t("workspaces.action.choose-another-workspace") }) }), $[5] = t, $[6] = workspaces.length, $[7] = t22) : t22 = $[7];
    const t32 = selectedWorkspace?.subtitle;
    let t42;
    $[8] !== selectedWorkspace.icon || $[9] !== selectedWorkspace.title || $[10] !== t32 ? (t42 = /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(WorkspacePreview, { icon: selectedWorkspace.icon, title: selectedWorkspace.title, subtitle: t32 }) }), $[8] = selectedWorkspace.icon, $[9] = selectedWorkspace.title, $[10] = t32, $[11] = t42) : t42 = $[11];
    let t52;
    $[12] !== selectedWorkspace.basePath ? (t52 = window.location.pathname.startsWith(selectedWorkspace.basePath) ? `${window.location.pathname}${window.location.search}` : selectedWorkspace.basePath, $[12] = selectedWorkspace.basePath, $[13] = t52) : t52 = $[13];
    let t62;
    $[14] !== LoginComponent || $[15] !== selectedWorkspace.projectId || $[16] !== selectedWorkspaceName || $[17] !== t52 ? (t62 = /* @__PURE__ */ jsx(Stack, { padding: 2, paddingBottom: 3, paddingTop: 4, children: /* @__PURE__ */ jsx(LoginComponent, { projectId: selectedWorkspace.projectId, redirectPath: t52 }, selectedWorkspaceName) }), $[14] = LoginComponent, $[15] = selectedWorkspace.projectId, $[16] = selectedWorkspaceName, $[17] = t52, $[18] = t62) : t62 = $[18];
    let t72;
    $[19] !== t42 || $[20] !== t62 ? (t72 = /* @__PURE__ */ jsx(Layout, { header: t42, children: t62 }), $[19] = t42, $[20] = t62, $[21] = t72) : t72 = $[21];
    let t8;
    return $[22] !== t22 || $[23] !== t72 ? (t8 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
      t22,
      t72
    ] }), $[22] = t22, $[23] = t72, $[24] = t8) : t8 = $[24], t8;
  }
  let t2;
  $[25] !== t ? (t2 = t("workspaces.choose-your-workspace-label"), $[25] = t, $[26] = t2) : t2 = $[26];
  let t3;
  $[27] !== t ? (t3 = t("workspaces.action.add-workspace"), $[27] = t, $[28] = t3) : t3 = $[28];
  let t4;
  $[29] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { padding: 1, children: /* @__PURE__ */ jsx(Button, { as: "a", href: WORKSPACES_DOCS_URL, icon: AddIcon, mode: "bleed", rel: "noopener noreferrer", size: "large", target: "__blank", text: t3 }) }), $[29] = t3, $[30] = t4) : t4 = $[30];
  let t5;
  if ($[31] !== activeWorkspace || $[32] !== authStates || $[33] !== setActiveWorkspace || $[34] !== workspaces) {
    let t62;
    $[36] !== activeWorkspace || $[37] !== authStates || $[38] !== setActiveWorkspace ? (t62 = (workspace_0) => {
      const state = authStates[workspace_0.name].authenticated ? "logged-in" : workspace_0.auth.LoginComponent ? "logged-out" : "no-access";
      return /* @__PURE__ */ jsx(Card, { as: "button", radius: 2, padding: 2, onClick: () => {
        state === "logged-in" && workspace_0.name !== activeWorkspace.name && setActiveWorkspace(workspace_0.name), state === "logged-out" && setSelectedWorkspaceName(workspace_0.name);
      }, children: /* @__PURE__ */ jsx(WorkspacePreview, { icon: workspace_0?.icon, iconRight: ChevronRightIcon, state, subtitle: workspace_0?.subtitle, title: workspace_0?.title || workspace_0.name }) }, workspace_0.name);
    }, $[36] = activeWorkspace, $[37] = authStates, $[38] = setActiveWorkspace, $[39] = t62) : t62 = $[39], t5 = workspaces.map(t62), $[31] = activeWorkspace, $[32] = authStates, $[33] = setActiveWorkspace, $[34] = workspaces, $[35] = t5;
  } else
    t5 = $[35];
  let t6;
  $[40] !== t5 ? (t6 = /* @__PURE__ */ jsx(Stack, { space: 1, paddingX: 1, paddingY: 2, children: t5 }), $[40] = t5, $[41] = t6) : t6 = $[41];
  let t7;
  return $[42] !== t2 || $[43] !== t4 || $[44] !== t6 ? (t7 = /* @__PURE__ */ jsx(Layout, { header: t2, footer: t4, children: t6 }), $[42] = t2, $[43] = t4, $[44] = t6, $[45] = t7) : t7 = $[45], t7;
}
const PERMISSION_NAME = "sanity.project.members", GRANT_NAME = "invite";
function useCanInviteProjectMembers(opts) {
  const $ = c(7);
  let t0;
  $[0] !== opts ? (t0 = opts || {}, $[0] = opts, $[1] = t0) : t0 = $[1];
  const {
    enabled: t1
  } = t0, enabled = t1 === void 0 ? !0 : t1, projectStore = useProjectStore();
  let t2;
  $[2] !== projectStore ? (t2 = projectStore.getGrants().pipe(map$1(_temp3$6)), $[2] = projectStore, $[3] = t2) : t2 = $[3];
  const result$ = t2;
  let t3;
  return $[4] !== enabled || $[5] !== result$ ? (t3 = enabled ? result$ : of(!1), $[4] = enabled, $[5] = result$, $[6] = t3) : t3 = $[6], useObservable(t3, !1);
}
function _temp3$6(grants) {
  return !!grants[PERMISSION_NAME]?.some(_temp2$f);
}
function _temp2$f(p) {
  return p.grants.some(_temp$x);
}
function _temp$x(g) {
  return g.name === GRANT_NAME;
}
function ManageMenu$1(t0) {
  const $ = c(30), {
    multipleWorkspaces
  } = t0, {
    projectId
  } = useWorkspace(), {
    value: project
  } = useProject(), {
    activeWorkspace
  } = useActiveWorkspace(), envAwareWebsiteUrl = useEnvAwareSanityWebsiteUrl(), canInviteMembers = useCanInviteProjectMembers(), {
    t
  } = useTranslation(), t1 = multipleWorkspaces ? 3 : 4;
  let t2;
  $[0] !== activeWorkspace.icon ? (t2 = /* @__PURE__ */ jsx(WorkspacePreviewIcon, { icon: activeWorkspace.icon, size: "large" }), $[0] = activeWorkspace.icon, $[1] = t2) : t2 = $[1];
  const t3 = project?.displayName;
  let t4;
  $[2] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 0, children: t3 }), $[2] = t3, $[3] = t4) : t4 = $[3];
  let t5;
  $[4] !== activeWorkspace.title ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 2, weight: "medium", children: activeWorkspace.title }), $[4] = activeWorkspace.title, $[5] = t5) : t5 = $[5];
  let t6;
  $[6] !== t4 || $[7] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { marginLeft: 2, space: 2, children: [
    t4,
    t5
  ] }), $[6] = t4, $[7] = t5, $[8] = t6) : t6 = $[8];
  let t7;
  $[9] !== t2 || $[10] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t2,
    t6
  ] }), $[9] = t2, $[10] = t6, $[11] = t7) : t7 = $[11];
  const t8 = `${envAwareWebsiteUrl}/manage/project/${projectId}`;
  let t9;
  $[12] !== t ? (t9 = t("user-menu.action.manage-project-aria-label"), $[12] = t, $[13] = t9) : t9 = $[13];
  let t10;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    "--card-border-color": "unset"
  }, $[14] = t10) : t10 = $[14];
  let t11;
  $[15] !== t8 || $[16] !== t9 ? (t11 = /* @__PURE__ */ jsx(Button, { mode: "bleed", as: "a", href: t8, target: "_blank", icon: CogIcon, text: t9, style: t10 }), $[15] = t8, $[16] = t9, $[17] = t11) : t11 = $[17];
  let t12;
  $[18] !== canInviteMembers || $[19] !== envAwareWebsiteUrl || $[20] !== projectId || $[21] !== t ? (t12 = canInviteMembers && /* @__PURE__ */ jsx(Button, { mode: "bleed", as: "a", href: `${envAwareWebsiteUrl}/manage/project/${projectId}/members?invite=true`, target: "_blank", icon: AddUserIcon, text: t("user-menu.action.invite-members"), style: {
    "--card-border-color": "unset"
  } }), $[18] = canInviteMembers, $[19] = envAwareWebsiteUrl, $[20] = projectId, $[21] = t, $[22] = t12) : t12 = $[22];
  let t13;
  $[23] !== t11 || $[24] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Flex, { justify: "flex-start", gap: 3, paddingTop: 4, children: [
    t11,
    t12
  ] }), $[23] = t11, $[24] = t12, $[25] = t13) : t13 = $[25];
  let t14;
  return $[26] !== t1 || $[27] !== t13 || $[28] !== t7 ? (t14 = /* @__PURE__ */ jsxs(Stack, { paddingX: 4, paddingTop: 4, paddingBottom: t1, children: [
    t7,
    t13
  ] }), $[26] = t1, $[27] = t13, $[28] = t7, $[29] = t14) : t14 = $[29], t14;
}
const POPOVER_PROPS = {
  constrainSize: !0,
  fallbackPlacements: ["bottom-end", "bottom"],
  placement: "bottom-end",
  tone: "default"
};
function WorkspaceMenuButton() {
  const $ = c(25), workspaces = useWorkspaces(), {
    activeWorkspace
  } = useActiveWorkspace(), [authStates] = useWorkspaceAuthStates(workspaces), {
    t
  } = useTranslation(), [scrollbarWidth, setScrollbarWidth] = useState(0);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = (node) => {
    if (node) {
      const hasScroll = node.scrollHeight > node.clientHeight;
      setScrollbarWidth(hasScroll ? node.offsetWidth - node.clientWidth : 0);
    }
  }, $[0] = t0) : t0 = $[0];
  const stackRef = t0, disabled = !authStates;
  let t1;
  $[1] !== t ? (t1 = t("workspaces.select-workspace-tooltip"), $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== activeWorkspace.title ? (t2 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: activeWorkspace.title }) }), $[3] = activeWorkspace.title, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ChevronDownIcon, {}) }), $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t2 ? (t4 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t2,
    t3
  ] }), $[6] = t2, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== disabled || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button$1, { disabled, mode: "bleed", padding: 2, width: "fill", children: t4 }), $[8] = disabled, $[9] = t4, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== disabled || $[12] !== t1 || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(Tooltip, { content: t1, disabled, portal: !0, children: t5 }) }), $[11] = disabled, $[12] = t1, $[13] = t5, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== activeWorkspace.name || $[16] !== authStates || $[17] !== disabled || $[18] !== scrollbarWidth || $[19] !== t || $[20] !== workspaces ? (t7 = !disabled && authStates ? /* @__PURE__ */ jsxs(Menu, { padding: 0, style: {
    maxWidth: "350px",
    minWidth: "250px",
    overflowY: "hidden"
  }, children: [
    /* @__PURE__ */ jsx(ManageMenu$1, { multipleWorkspaces: workspaces.length > 1 }),
    workspaces.length > 1 && /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(MenuDivider, { style: {
        padding: 0
      } }),
      /* @__PURE__ */ jsxs(Box, { paddingTop: 2, paddingBottom: 1, children: [
        /* @__PURE__ */ jsx(Box, { paddingRight: 5, paddingLeft: 4, paddingBottom: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 0, weight: "medium", children: t("workspaces.action.switch-workspace") }) }),
        /* @__PURE__ */ jsx(Stack, { ref: stackRef, space: 1, style: {
          overflowY: "auto",
          maxHeight: "40vh"
        }, children: workspaces.map((workspace) => {
          const state = authStates[workspace.name].authenticated ? "logged-in" : workspace.auth.LoginComponent ? "logged-out" : "no-access", isSelected = workspace.name === activeWorkspace.name;
          return /* @__PURE__ */ jsx(MenuItem, { as: "a", href: workspace.basePath, badgeText: STATE_TITLES[state], iconRight: isSelected ? CheckmarkIcon : void 0, pressed: isSelected, preview: /* @__PURE__ */ jsx(WorkspacePreviewIcon, { icon: workspace.icon, size: "small" }), selected: isSelected, __unstable_subtitle: workspace.subtitle, text: workspace?.title || workspace.name, style: {
            marginLeft: "1rem",
            marginRight: `calc(1.25rem - ${scrollbarWidth}px)`
          }, __unstable_space: 0 }, workspace.name);
        }) })
      ] })
    ] })
  ] }) : void 0, $[15] = activeWorkspace.name, $[16] = authStates, $[17] = disabled, $[18] = scrollbarWidth, $[19] = t, $[20] = workspaces, $[21] = t7) : t7 = $[21];
  let t8;
  return $[22] !== t6 || $[23] !== t7 ? (t8 = /* @__PURE__ */ jsx(MenuButton, { button: t6, id: "workspace-menu", menu: t7, popover: POPOVER_PROPS }), $[22] = t6, $[23] = t7, $[24] = t8) : t8 = $[24], t8;
}
function AuthenticateScreen() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Card, { height: "fill", overflow: "auto", paddingX: 4, children: /* @__PURE__ */ jsx(Flex, { height: "fill", direction: "column", align: "center", justify: "center", paddingTop: 4, children: /* @__PURE__ */ jsx(Container$3, { width: 0, children: /* @__PURE__ */ jsx(WorkspaceAuth, {}) }) }) }), $[0] = t0) : t0 = $[0], t0;
}
function ConfigErrorsScreen() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Fragment$1, { children: "TODO: implement config errors screen" }), $[0] = t0) : t0 = $[0], t0;
}
const CenteredContainer = styled(Flex).withConfig({
  displayName: "CenteredContainer",
  componentId: "sc-sih713-0"
})`min-height:100vh;box-sizing:border-box;`, ContentWrapper = styled(Box).withConfig({
  displayName: "ContentWrapper",
  componentId: "sc-sih713-1"
})`width:100%;max-width:640px;`, HelpLink = styled.a.withConfig({
  displayName: "HelpLink",
  componentId: "sc-sih713-2"
})`color:var(--card-link-fg-color);text-decoration:none;display:inline-flex;align-items:center;gap:0.25em;&:hover{text-decoration:underline;}`;
function CorsOriginErrorScreen(props2) {
  const $ = c(27), {
    projectId,
    isStaging: isStaging2,
    primaryProjectId
  } = props2, showRegisterOption = !!(primaryProjectId && projectId && primaryProjectId === projectId), origin = window.location.origin, manageBaseUrl = isStaging2 ? "https://sanity.work" : "https://sanity.io";
  let t0;
  if ($[0] !== manageBaseUrl || $[1] !== projectId) {
    const url = new URL(`/manage/project/${projectId}/api`, manageBaseUrl);
    url.searchParams.set("cors", "add"), url.searchParams.set("origin", origin), url.searchParams.set("credentials", ""), t0 = url.toString(), $[0] = manageBaseUrl, $[1] = projectId, $[2] = t0;
  } else
    t0 = $[2];
  const corsUrl = t0;
  let t1;
  if ($[3] !== manageBaseUrl || $[4] !== projectId) {
    const url_0 = new URL(`/manage/project/${projectId}/studios`, manageBaseUrl);
    url_0.searchParams.set("studio", "add"), url_0.searchParams.set("origin", origin), t1 = url_0.toString(), $[3] = manageBaseUrl, $[4] = projectId, $[5] = t1;
  } else
    t1 = $[5];
  const registerUrl = t1;
  let t2;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[6] = t2) : t2 = $[6], useEffect(_temp2$e, t2);
  let t3, t4;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Heading, { as: "h1", size: 2, children: "Connect this studio to your project" }), t4 = /* @__PURE__ */ jsx(Text$1, { size: 2, muted: !0, children: "This studio is not registered and cannot access your content yet. Choose how you want to connect it." }), $[7] = t3, $[8] = t4) : (t3 = $[7], t4 = $[8]);
  let t5;
  $[9] !== showRegisterOption ? (t5 = showRegisterOption ? [1, 1, 2] : 1, $[9] = showRegisterOption, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== registerUrl || $[12] !== showRegisterOption ? (t6 = showRegisterOption && /* @__PURE__ */ jsx(Card, { border: !0, padding: 4, radius: 4, children: /* @__PURE__ */ jsxs(Flex, { direction: "column", gap: 4, height: "fill", children: [
    /* @__PURE__ */ jsxs(Stack, { space: 4, flex: 1, children: [
      /* @__PURE__ */ jsx(Text$1, { size: 2, weight: "medium", children: "Register studio" }),
      /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: "For production and editor-facing studios. Enables schema syncing, Content Agent, and other COS features." })
    ] }),
    /* @__PURE__ */ jsx(Button, { as: "a", href: registerUrl, target: "_blank", rel: "noopener noreferrer", size: "large", text: "Register this studio", width: "fill" })
  ] }) }), $[11] = registerUrl, $[12] = showRegisterOption, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 4, flex: 1, children: [
    /* @__PURE__ */ jsx(Text$1, { size: 2, weight: "medium", children: "Add development host" }),
    /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: "For localhost and preview URLs. Does not register this Studio and does not sync schemas." })
  ] }), $[14] = t7) : t7 = $[14];
  let t8;
  $[15] !== corsUrl ? (t8 = /* @__PURE__ */ jsx(Card, { border: !0, padding: 4, radius: 4, children: /* @__PURE__ */ jsxs(Flex, { direction: "column", gap: 4, height: "fill", children: [
    t7,
    /* @__PURE__ */ jsx(Button, { as: "a", href: corsUrl, iconRight: LaunchIcon, target: "_blank", rel: "noopener noreferrer", text: "Add development host", mode: "ghost", size: "large", width: "fill" })
  ] }) }), $[15] = corsUrl, $[16] = t8) : t8 = $[16];
  let t9;
  $[17] !== showRegisterOption ? (t9 = showRegisterOption && isProd && /* @__PURE__ */ jsx(Flex, { justify: "center", children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: "Recommended" }) }), $[17] = showRegisterOption, $[18] = t9) : t9 = $[18];
  let t10;
  $[19] !== t5 || $[20] !== t6 || $[21] !== t8 || $[22] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Grid, { columns: t5, gapX: 4, gapY: 3, children: [
    t6,
    t8,
    t9
  ] }), $[19] = t5, $[20] = t6, $[21] = t8, $[22] = t9, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = /* @__PURE__ */ jsx(Flex, { justify: "flex-end", children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(HelpLink, { href: "https://www.sanity.io/docs/cors", target: "_blank", rel: "noopener noreferrer", style: {
    textDecoration: "none"
  }, children: "Need help? \u2192" }) }) }), $[24] = t11) : t11 = $[24];
  let t12;
  return $[25] !== t10 ? (t12 = /* @__PURE__ */ jsx(Card, { height: "fill", children: /* @__PURE__ */ jsx(CenteredContainer, { align: "center", justify: "center", padding: 4, children: /* @__PURE__ */ jsx(ContentWrapper, { paddingBottom: 5, children: /* @__PURE__ */ jsxs(Stack, { space: 5, children: [
    t3,
    t4,
    t10,
    t11
  ] }) }) }) }), $[25] = t10, $[26] = t12) : t12 = $[26], t12;
}
function _temp2$e() {
  const handleFocus = _temp$w;
  return window.addEventListener("focus", handleFocus), () => {
    window.removeEventListener("focus", handleFocus);
  };
}
function _temp$w() {
  window.location.reload();
}
function NotAuthenticatedScreen() {
  const $ = c(20), [currentUser, setCurrentUser] = useState(null), [error, handleError] = useState(null);
  if (error)
    throw error;
  const {
    activeWorkspace
  } = useActiveWorkspace();
  let t0;
  $[0] !== activeWorkspace.auth ? (t0 = () => {
    activeWorkspace.auth.logout?.();
  }, $[0] = activeWorkspace.auth, $[1] = t0) : t0 = $[1];
  const handleLogout = t0;
  let t1;
  $[2] !== activeWorkspace.auth.state ? (t1 = () => {
    const subscription = activeWorkspace.auth.state.subscribe({
      next: (t22) => {
        const {
          currentUser: user
        } = t22;
        setCurrentUser(user);
      },
      error: handleError
    });
    return () => {
      subscription.unsubscribe();
    };
  }, $[2] = activeWorkspace.auth.state, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== activeWorkspace ? (t2 = [activeWorkspace], $[4] = activeWorkspace, $[5] = t2) : t2 = $[5], useEffect(t1, t2);
  const t3 = currentUser?.provider;
  let t4;
  $[6] !== t3 ? (t4 = getProviderTitle(t3), $[6] = t3, $[7] = t4) : t4 = $[7];
  const providerTitle = t4, providerHelp = providerTitle ? ` through ${providerTitle}` : "";
  let t5;
  $[8] !== handleLogout ? (t5 = {
    confirmButton: {
      text: "Sign out",
      onClick: handleLogout,
      tone: "default"
    }
  }, $[8] = handleLogout, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx(Text$1, { children: "You are not authorized to access this studio. Please contact someone with access to invite you to this project." }), $[10] = t6) : t6 = $[10];
  const t7 = currentUser?.name, t8 = currentUser?.email;
  let t9;
  $[11] !== t7 || $[12] !== t8 ? (t9 = /* @__PURE__ */ jsxs("strong", { children: [
    t7,
    " (",
    t8,
    ")"
  ] }), $[11] = t7, $[12] = t8, $[13] = t9) : t9 = $[13];
  let t10;
  $[14] !== providerHelp || $[15] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t6,
    /* @__PURE__ */ jsxs(Text$1, { children: [
      "If you think this is an error, verify that you are signed in with the correct account. You are currently signed in as",
      " ",
      t9,
      providerHelp,
      "."
    ] })
  ] }), $[14] = providerHelp, $[15] = t9, $[16] = t10) : t10 = $[16];
  let t11;
  return $[17] !== t10 || $[18] !== t5 ? (t11 = /* @__PURE__ */ jsx(Card, { height: "fill", children: /* @__PURE__ */ jsx(Dialog$1, { id: "not-authorized-dialog", header: "Not authorized", width: 1, footer: t5, children: t10 }) }), $[17] = t10, $[18] = t5, $[19] = t11) : t11 = $[19], t11;
}
function NotFoundScreen(props2) {
  const $ = c(3);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Heading, { as: "h1", children: "Workspace not found" }), $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] !== props2.onNavigateToDefaultWorkspace ? (t1 = /* @__PURE__ */ jsx(Card, { height: "fill", sizing: "border", tone: "caution", display: "flex", children: /* @__PURE__ */ jsx(Flex, { direction: "row", justify: "center", flex: 1, align: "center", children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t0,
    /* @__PURE__ */ jsx(Inline, { children: /* @__PURE__ */ jsx(Button, { text: "Go to default workspace", onClick: props2.onNavigateToDefaultWorkspace, mode: "ghost" }) })
  ] }) }) }), $[1] = props2.onNavigateToDefaultWorkspace, $[2] = t1) : t1 = $[2], t1;
}
const MAX_NOTE_LENGTH = 150;
function RequestAccessScreen() {
  const $ = c(52), [currentUser, setCurrentUser] = useState(null), [client, setClient] = useState(), [projectId, setProjectId] = useState(), toast = useToast(), [error, setError] = useState(null), [msgError, setMsgError] = useState(), [loading, setLoading] = useState(!0), [isSubmitting, setIsSubmitting] = useState(!1), [hasPendingRequest, setHasPendingRequest] = useState(!1), [hasExpiredPendingRequest, setExpiredHasPendingRequest] = useState(!1), [hasTooManyRequests, setHasTooManyRequests] = useState(!1), [hasBeenDenied, setHasBeenDenied] = useState(!1), [note, setNote] = useState(), [noteLength, setNoteLength] = useState(0), {
    activeWorkspace
  } = useActiveWorkspace();
  let t0;
  $[0] !== activeWorkspace.auth ? (t0 = () => {
    activeWorkspace.auth.logout?.();
  }, $[0] = activeWorkspace.auth, $[1] = t0) : t0 = $[1];
  const handleLogout = t0;
  let t1;
  $[2] !== activeWorkspace.auth.state ? (t1 = () => {
    const subscription = activeWorkspace.auth.state.subscribe({
      next: (t22) => {
        const {
          client: sanityClient,
          currentUser: user
        } = t22;
        setProjectId(sanityClient.config().projectId), setClient(sanityClient.withConfig({
          apiVersion: "2024-07-01"
        })), setCurrentUser(user);
      },
      error: setError
    });
    return () => {
      subscription.unsubscribe();
    };
  }, $[2] = activeWorkspace.auth.state, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== activeWorkspace ? (t2 = [activeWorkspace], $[4] = activeWorkspace, $[5] = t2) : t2 = $[5], useEffect(t1, t2);
  let t3, t4;
  $[6] !== client || $[7] !== projectId ? (t3 = () => {
    if (!client || !projectId)
      return _temp$v;
    const request$ = client.observable.request({
      url: "/access/requests/me",
      tag: "request-access"
    }).pipe(finalize(() => setLoading(!1))).subscribe({
      next: (requests) => {
        if (!requests || !requests.length)
          return;
        const projectRequests = requests.filter((request) => request.resourceId === projectId), declinedRequest = projectRequests.find(_temp2$d);
        if (declinedRequest && isAfter(addWeeks(new Date(declinedRequest.createdAt), 2), /* @__PURE__ */ new Date())) {
          setHasBeenDenied(!0);
          return;
        }
        if (projectRequests.find(_temp3$5)) {
          setHasPendingRequest(!0);
          return;
        }
        projectRequests.find(_temp4$1) && setExpiredHasPendingRequest(!0);
      },
      error: (err) => {
        console.error(err), setError(!0);
      }
    });
    return () => {
      request$.unsubscribe();
    };
  }, t4 = [client, projectId], $[6] = client, $[7] = projectId, $[8] = t3, $[9] = t4) : (t3 = $[8], t4 = $[9]), useEffect(t3, t4);
  let t5;
  $[10] !== client || $[11] !== note || $[12] !== projectId || $[13] !== toast ? (t5 = () => {
    !client || !projectId || (setIsSubmitting(!0), client.request({
      url: `/access/project/${projectId}/requests`,
      method: "post",
      body: {
        note,
        requestUrl: window?.location.href,
        type: "access"
      }
    }).then((request_3) => {
      request_3 && setHasPendingRequest(!0);
    }).catch((err_0) => {
      const statusCode = err_0?.response?.statusCode, errMessage = err_0?.response?.body?.message;
      statusCode === 429 && (setHasTooManyRequests(!0), setMsgError(errMessage)), statusCode === 409 ? (setHasBeenDenied(!0), setMsgError(errMessage)) : toast.push({
        title: "There was a problem submitting your request.",
        status: "error"
      });
    }).finally(() => {
      setIsSubmitting(!1);
    }));
  }, $[10] = client, $[11] = note, $[12] = projectId, $[13] = toast, $[14] = t5) : t5 = $[14];
  const handleSubmitRequest = t5, t6 = currentUser?.provider;
  let t7;
  $[15] !== t6 ? (t7 = getProviderTitle(t6), $[15] = t6, $[16] = t7) : t7 = $[16];
  const providerTitle = t7, providerHelp = providerTitle ? ` through ${providerTitle}` : "";
  if (loading) {
    let t82;
    return $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t82 = /* @__PURE__ */ jsx(LoadingBlock, {}), $[17] = t82) : t82 = $[17], t82;
  }
  if (error) {
    let t82;
    return $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t82 = /* @__PURE__ */ jsx(NotAuthenticatedScreen, {}), $[18] = t82) : t82 = $[18], t82;
  }
  const t8 = currentUser?.name, t9 = currentUser?.email;
  let t10;
  $[19] !== t8 || $[20] !== t9 ? (t10 = /* @__PURE__ */ jsxs("strong", { children: [
    t8,
    " (",
    t9,
    ")"
  ] }), $[19] = t8, $[20] = t9, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== providerHelp || $[23] !== t10 ? (t11 = /* @__PURE__ */ jsxs(Text$1, { children: [
    "You are not authorized to access this studio (currently signed in as",
    " ",
    t10,
    providerHelp,
    ")."
  ] }), $[22] = providerHelp, $[23] = t10, $[24] = t11) : t11 = $[24];
  let t12;
  $[25] !== handleSubmitRequest || $[26] !== hasBeenDenied || $[27] !== hasExpiredPendingRequest || $[28] !== hasPendingRequest || $[29] !== hasTooManyRequests || $[30] !== isSubmitting || $[31] !== msgError || $[32] !== note || $[33] !== noteLength ? (t12 = hasTooManyRequests || hasPendingRequest || hasBeenDenied ? /* @__PURE__ */ jsx(Card, { tone: hasPendingRequest ? "transparent" : "caution", padding: 3, radius: 2, shadow: 1, children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    hasTooManyRequests && !hasPendingRequest && /* @__PURE__ */ jsx(Fragment$1, { children: msgError ?? `You've reached the limit for access requests across all projects. Please wait
                      before submitting more requests or contact an admin for assistance.` }),
    hasPendingRequest && /* @__PURE__ */ jsx(Fragment$1, { children: "Your request to access this project is pending approval." }),
    hasBeenDenied && /* @__PURE__ */ jsx(Fragment$1, { children: msgError ?? "Your request to access this project has been declined." })
  ] }) }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(Text$1, { children: hasExpiredPendingRequest ? /* @__PURE__ */ jsx(Fragment$1, { children: "Your previous request has expired. You may again request access below with an optional note. The administrator(s) will receive an email letting them know that you are requesting access." }) : /* @__PURE__ */ jsx(Fragment$1, { children: "You can request access below with an optional note. The administrator(s) will receive an email letting them know that you are requesting access." }) }),
    /* @__PURE__ */ jsxs(Stack, { space: 3, paddingBottom: 0, children: [
      /* @__PURE__ */ jsx(TextInput$1, { maxLength: MAX_NOTE_LENGTH, disabled: isSubmitting, onKeyDown: (e) => {
        e.key === "Enter" && handleSubmitRequest();
      }, onChange: (e_0) => {
        setNote(e_0.currentTarget.value), setNoteLength(e_0.currentTarget.value.length);
      }, value: note, placeholder: "Add your note\u2026" }),
      /* @__PURE__ */ jsx(Text$1, { align: "right", muted: !0, size: 1, children: `${noteLength}/${MAX_NOTE_LENGTH}` })
    ] })
  ] }), $[25] = handleSubmitRequest, $[26] = hasBeenDenied, $[27] = hasExpiredPendingRequest, $[28] = hasPendingRequest, $[29] = hasTooManyRequests, $[30] = isSubmitting, $[31] = msgError, $[32] = note, $[33] = noteLength, $[34] = t12) : t12 = $[34];
  let t13;
  $[35] !== t11 || $[36] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t11,
    t12
  ] }), $[35] = t11, $[36] = t12, $[37] = t13) : t13 = $[37];
  let t14;
  $[38] !== handleLogout ? (t14 = /* @__PURE__ */ jsx(Button, { mode: "bleed", text: "Sign out", tone: "default", onClick: handleLogout, size: "large" }), $[38] = handleLogout, $[39] = t14) : t14 = $[39];
  let t15;
  $[40] !== handleSubmitRequest || $[41] !== hasBeenDenied || $[42] !== hasPendingRequest || $[43] !== hasTooManyRequests || $[44] !== isSubmitting ? (t15 = !hasTooManyRequests && !hasBeenDenied && /* @__PURE__ */ jsx(Button, { mode: "default", text: hasPendingRequest ? "Request sent" : "Request access", disabled: hasPendingRequest || isSubmitting, loading: isSubmitting, tone: "default", onClick: handleSubmitRequest, size: "large" }), $[40] = handleSubmitRequest, $[41] = hasBeenDenied, $[42] = hasPendingRequest, $[43] = hasTooManyRequests, $[44] = isSubmitting, $[45] = t15) : t15 = $[45];
  let t16;
  $[46] !== t14 || $[47] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-between", paddingTop: 4, children: [
    t14,
    t15
  ] }), $[46] = t14, $[47] = t15, $[48] = t16) : t16 = $[48];
  let t17;
  return $[49] !== t13 || $[50] !== t16 ? (t17 = /* @__PURE__ */ jsx(Card, { height: "fill", children: /* @__PURE__ */ jsx(Dialog$1, { id: "not-authorized-dialog", header: "Not authorized", width: 1, children: /* @__PURE__ */ jsxs(Box, { children: [
    t13,
    t16
  ] }) }) }), $[49] = t13, $[50] = t16, $[51] = t17) : t17 = $[51], t17;
}
function _temp4$1(request_2) {
  return request_2.status === "pending" && isBefore(addWeeks(new Date(request_2.createdAt), 2), /* @__PURE__ */ new Date());
}
function _temp3$5(request_1) {
  return request_1.status === "pending" && isAfter(addWeeks(new Date(request_1.createdAt), 2), /* @__PURE__ */ new Date());
}
function _temp2$d(request_0) {
  return request_0.status === "declined";
}
function _temp$v() {
}
function useCopyToClipboard() {
  const $ = c(3), [copiedText, setCopiedText] = useState(null);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = async (text) => {
    if (!navigator?.clipboard)
      return console.warn("Clipboard not supported"), !1;
    try {
      return await navigator.clipboard.writeText(text), setCopiedText(text), !0;
    } catch (t12) {
      return console.warn("Copy failed", t12), setCopiedText(null), !1;
    }
  }, $[0] = t0) : t0 = $[0];
  const copy = t0;
  let t1;
  return $[1] !== copiedText ? (t1 = [copiedText, copy], $[1] = copiedText, $[2] = t1) : t1 = $[2], t1;
}
function getTypeInfo(problem) {
  const first2 = problem.path[0];
  return first2.kind === "type" ? {
    name: first2.name || `<anonymous ${first2.type}>`,
    type: first2.type
  } : null;
}
function formatSchemaErrorsToMarkdown(groups) {
  let text = `# Schema errors

`;
  text += `There were errors while attempting to compile the configuration of your Sanity Studio Schema types.

`;
  for (const group2 of groups) {
    const schemaType = getTypeInfo(group2);
    schemaType ? text += `## ${capitalize(schemaType.type)} type "${schemaType.name}"

` : text += `## Unknown type

`;
    const parts = [];
    for (const segment of group2.path)
      segment.kind === "type" ? parts.push(`${segment.name || `<anonymous ${segment.type}>`}:${segment.type}`) : segment.kind === "property" && parts.push(`${segment.name}`);
    text += `Path: ${parts.join(" \u2192 ")}
`;
    for (const problem of group2.problems)
      text += `${capitalize(problem.severity)}: ${problem.message}
`, problem.helpId && (text += `[View documentation for this ${problem.severity}](${generateHelpUrl(problem.helpId)})
`);
    text += `
`;
  }
  return text;
}
function renderPath(path) {
  return path.map((segment) => segment.kind === "type" ? `${segment.name || "<unnamed>"}(${segment.type})` : segment.kind === "property" ? segment.name : null).filter(Boolean).join(" > ");
}
function reportWarnings(schema2) {
  const groupsWithWarnings = schema2._validation?.filter((group2) => group2.problems.some((problem) => problem.severity === "warning"));
  groupsWithWarnings?.length !== 0 && (console.groupCollapsed(`\u26A0\uFE0F Schema has ${groupsWithWarnings?.length} warnings`), groupsWithWarnings?.forEach((group2) => {
    const path = renderPath(group2.path);
    console.group(`%cAt ${path}`, "color: #FF7636"), group2.problems.forEach((problem) => {
      console.log(problem.message);
    }), console.groupEnd();
  }), console.groupEnd());
}
const TONES = {
  error: "critical",
  warning: "caution"
}, SegmentSpan = styled.code.withConfig({
  displayName: "SegmentSpan",
  componentId: "sc-7o71rt-0"
})`&&{background:none;color:inherit;}`, ErrorMessageText = styled(Text$1).withConfig({
  displayName: "ErrorMessageText",
  componentId: "sc-7o71rt-1"
})`white-space:pre-line;`;
function SchemaProblemGroups(props2) {
  const $ = c(4), {
    problemGroups
  } = props2;
  useTranslation();
  let ret;
  if ($[0] !== problemGroups) {
    ret = [];
    for (const problemGroup of problemGroups)
      for (const problem of problemGroup.problems)
        ret.push({
          group: problemGroup,
          problem
        });
    $[0] = problemGroups, $[1] = ret;
  } else
    ret = $[1];
  const items = ret;
  let t0;
  return $[2] !== items ? (t0 = /* @__PURE__ */ jsx(Stack, { as: "ul", space: 4, children: items.map(_temp2$c) }), $[2] = items, $[3] = t0) : t0 = $[3], t0;
}
function _temp2$c(t0, i) {
  const {
    group: group2,
    problem: problem_0
  } = t0, isError2 = problem_0.severity === "error", isWarning = problem_0.severity === "warning", schemaType = getTypeInfo(group2);
  return /* @__PURE__ */ jsxs(Card, { border: !0, padding: 4, radius: 2, tone: TONES[problem_0.severity], children: [
    /* @__PURE__ */ jsxs(Flex, { children: [
      /* @__PURE__ */ jsx(Box, { marginRight: 3, children: /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
        isError2 && /* @__PURE__ */ jsx(ErrorOutlineIcon, {}),
        isWarning && /* @__PURE__ */ jsx(WarningOutlineIcon, {})
      ] }) }),
      /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: schemaType ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
        capitalize(schemaType.type),
        ' type "',
        schemaType.name,
        '"'
      ] }) : null }) })
    ] }),
    /* @__PURE__ */ jsx(Box, { marginTop: 4, children: /* @__PURE__ */ jsx(Card, { border: !0, overflow: "auto", padding: 2, tone: "inherit", children: /* @__PURE__ */ jsx(Breadcrumbs, { separator: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: "\u2192" }), children: group2.path.map(_temp$u) }) }) }),
    /* @__PURE__ */ jsx(Box, { as: "ul", marginTop: 4, children: /* @__PURE__ */ jsx(Box, { as: "li", children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      /* @__PURE__ */ jsx(ErrorMessageText, { muted: !0, size: 1, children: problem_0.message }),
      problem_0.helpId && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx("a", { href: generateHelpUrl(problem_0.helpId), target: "_blank", rel: "noopener noreferrer", children: "View documentation \u2192" }) })
    ] }) }) })
  ] }, i);
}
function _temp$u(segment, j) {
  if (segment.kind === "type") {
    const text = `${_renderSegmentName(segment.name || `<anonymous ${segment.type}>`)}:${segment.type}`;
    return /* @__PURE__ */ jsx(Text$1, { title: text, size: 1, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(SegmentSpan, { children: text }) }, j);
  }
  return segment.kind === "property" ? /* @__PURE__ */ jsx(Text$1, { title: segment.name, size: 1, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(SegmentSpan, { children: segment.name }) }, j) : null;
}
function _renderSegmentName(str) {
  return str?.startsWith("<unnamed_type_@_index") ? `[${str.slice(1, -1).split("_")[4]}]` : str;
}
function SchemaErrorsScreen(t0) {
  const $ = c(29), {
    schema: schema2
  } = t0;
  let t1;
  $[0] !== schema2._validation ? (t1 = schema2._validation?.filter(_temp2$b) || [], $[0] = schema2._validation, $[1] = t1) : t1 = $[1];
  const groupsWithErrors = t1;
  let t2, t3;
  $[2] !== schema2 ? (t2 = () => reportWarnings(schema2), t3 = [schema2], $[2] = schema2, $[3] = t2, $[4] = t3) : (t2 = $[3], t3 = $[4]), useEffect(t2, t3);
  const toast = useToast(), {
    t
  } = useTranslation("studio"), {
    t: tCopyPaste
  } = useTranslation("copy-paste"), [, copy] = useCopyToClipboard();
  let t4;
  $[5] !== copy || $[6] !== groupsWithErrors || $[7] !== t || $[8] !== tCopyPaste || $[9] !== toast ? (t4 = async () => {
    const errorsText = formatSchemaErrorsToMarkdown(groupsWithErrors);
    try {
      await copy(errorsText) ? toast.push({
        status: "success",
        title: t("about-dialog.version-info.copy-to-clipboard-button.copied-text", "Copied to clipboard")
      }) : toast.push({
        status: "error",
        title: tCopyPaste("copy-paste.on-copy.validation.clipboard-not-supported.title", "Clipboard not supported")
      });
    } catch {
      toast.push({
        status: "error",
        title: tCopyPaste("copy-paste.on-copy.validation.clipboard-not-supported.title", "Clipboard not supported")
      });
    }
  }, $[5] = copy, $[6] = groupsWithErrors, $[7] = t, $[8] = tCopyPaste, $[9] = toast, $[10] = t4) : t4 = $[10];
  const handleCopyToClipboard = t4;
  let t5;
  $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = [4, 5, 6, 7], $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t ? (t6 = t("schema-errors.title", "Schema errors"), $[12] = t, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== t6 ? (t7 = /* @__PURE__ */ jsx(Heading, { as: "h1", children: t6 }), $[14] = t6, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t ? (t8 = t("about-dialog.version-info.copy-to-clipboard-button.text", "Copy to clipboard"), $[16] = t, $[17] = t8) : t8 = $[17];
  let t9;
  $[18] !== handleCopyToClipboard || $[19] !== t8 ? (t9 = /* @__PURE__ */ jsx(Button, { text: t8, onClick: handleCopyToClipboard }), $[18] = handleCopyToClipboard, $[19] = t8, $[20] = t9) : t9 = $[20];
  let t10;
  $[21] !== t7 || $[22] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { justify: "space-between", align: "center", gap: 2, children: [
    t7,
    t9
  ] }), $[21] = t7, $[22] = t9, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] !== groupsWithErrors ? (t11 = /* @__PURE__ */ jsx(SchemaProblemGroups, { problemGroups: groupsWithErrors }), $[24] = groupsWithErrors, $[25] = t11) : t11 = $[25];
  let t12;
  return $[26] !== t10 || $[27] !== t11 ? (t12 = /* @__PURE__ */ jsx(Card, { height: "fill", overflow: "auto", paddingY: t5, paddingX: 4, sizing: "border", children: /* @__PURE__ */ jsx(Container$3, { width: 1, children: /* @__PURE__ */ jsxs(Stack, { space: 5, children: [
    t10,
    t11
  ] }) }) }), $[26] = t10, $[27] = t11, $[28] = t12) : t12 = $[28], t12;
}
function _temp2$b(group2) {
  return group2.problems.some(_temp$t);
}
function _temp$t(problem) {
  return problem.severity === "error";
}
const View$1 = styled(Box).withConfig({
  displayName: "View",
  componentId: "sc-13fi13m-0"
})`align-items:center;`;
function FallbackErrorScreen(props2) {
  const $ = c(19), {
    error,
    eventId,
    heading: t0,
    onReset
  } = props2, heading = t0 === void 0 ? "An error occurred" : t0, message = error?.message, stack = typeof error?.stack == "string" && error?.stack;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [4, 5, 6, 7], $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== heading ? (t2 = /* @__PURE__ */ jsx(Heading, { children: heading }), $[1] = heading, $[2] = t2) : t2 = $[2];
  let t3, t4;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text$1, { children: "An error occurred that Sanity Studio was unable to recover from." }), t4 = isProd && /* @__PURE__ */ jsxs(Text$1, { children: [
    /* @__PURE__ */ jsx("strong", { children: "To report this error," }),
    " copy the error details and share them with your development team or Sanity Support."
  ] }), $[3] = t3, $[4] = t4) : (t3 = $[3], t4 = $[4]);
  let t5;
  $[5] !== eventId || $[6] !== message || $[7] !== stack ? (t5 = isDev && /* @__PURE__ */ jsx(Card, { border: !0, radius: 2, overflow: "auto", padding: 4, tone: "critical", children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    message && /* @__PURE__ */ jsx(Code, { weight: "bold", size: 1, children: message }),
    stack && /* @__PURE__ */ jsx(Code, { size: 1, children: stack }),
    eventId && /* @__PURE__ */ jsxs(Code, { size: 1, children: [
      "Event ID: ",
      eventId
    ] })
  ] }) }), $[5] = eventId, $[6] = message, $[7] = stack, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t2 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t2,
    t3,
    t4,
    t5
  ] }), $[9] = t2, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== error || $[13] !== eventId || $[14] !== onReset ? (t7 = /* @__PURE__ */ jsx(ErrorActions, { error, eventId, onRetry: onReset, size: "large" }), $[12] = error, $[13] = eventId, $[14] = onReset, $[15] = t7) : t7 = $[15];
  let t8;
  return $[16] !== t6 || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(Card, { height: "fill", overflow: "auto", paddingY: t1, paddingX: 4, sizing: "border", children: /* @__PURE__ */ jsx(View$1, { display: "flex", height: "fill", children: /* @__PURE__ */ jsx(Container$3, { width: 3, children: /* @__PURE__ */ jsxs(Stack, { space: 6, children: [
    t6,
    t7
  ] }) }) }) }), $[16] = t6, $[17] = t7, $[18] = t8) : t8 = $[18], t8;
}
const View = styled(Box).withConfig({
  displayName: "View",
  componentId: "sc-nf9q0j-0"
})`align-items:center;`;
function reloadPage() {
  window.location.reload();
}
const COUNTDOWN_SECONDS = 5;
function ImportErrorScreen(props2) {
  const $ = c(21), {
    error,
    eventId,
    autoReload
  } = props2;
  let t0;
  $[0] !== autoReload ? (t0 = autoReload ? timer(0, 1e3).pipe(take(COUNTDOWN_SECONDS + 1), map(_temp$s)) : of(0), $[0] = autoReload, $[1] = t0) : t0 = $[1];
  const countdownSeconds = useObservable(t0, COUNTDOWN_SECONDS);
  let t1, t2;
  $[2] !== autoReload || $[3] !== countdownSeconds ? (t1 = () => {
    autoReload && countdownSeconds < 1 && reloadPage();
  }, t2 = [autoReload, countdownSeconds], $[2] = autoReload, $[3] = countdownSeconds, $[4] = t1, $[5] = t2) : (t1 = $[4], t2 = $[5]), useEffect(t1, t2);
  let t3;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = [4, 5, 6, 7], $[6] = t3) : t3 = $[6];
  let t4, t5;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(Heading, { children: "Import error" }), t5 = /* @__PURE__ */ jsx(Text$1, { children: "An error occurred during dynamic import." }), $[7] = t4, $[8] = t5) : (t4 = $[7], t5 = $[8]);
  let t6;
  $[9] !== error || $[10] !== eventId ? (t6 = isDev && /* @__PURE__ */ jsx(Card, { border: !0, radius: 2, overflow: "auto", padding: 4, tone: "critical", children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    error.message && /* @__PURE__ */ jsx(Code, { weight: "bold", size: 1, children: error.message }),
    error.stack && /* @__PURE__ */ jsx(Code, { size: 1, children: error.stack }),
    eventId && /* @__PURE__ */ jsxs(Code, { size: 1, children: [
      "Event ID: ",
      eventId
    ] })
  ] }) }), $[9] = error, $[10] = eventId, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== autoReload || $[13] !== countdownSeconds ? (t7 = autoReload ? /* @__PURE__ */ jsxs(Text$1, { muted: !0, children: [
    "Reloading ",
    countdownSeconds <= 0 ? "now" : `in ${countdownSeconds}s`,
    "\u2026"
  ] }) : null, $[12] = autoReload, $[13] = countdownSeconds, $[14] = t7) : t7 = $[14];
  const t8 = autoReload ? "Reload now" : "Reload";
  let t9;
  $[15] !== t8 ? (t9 = /* @__PURE__ */ jsx(Inline, { space: 3, children: /* @__PURE__ */ jsx(Button, { onClick: reloadPage, text: t8, tone: "primary", icon: SyncIcon, size: "large" }) }), $[15] = t8, $[16] = t9) : t9 = $[16];
  let t10;
  return $[17] !== t6 || $[18] !== t7 || $[19] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { height: "fill", overflow: "auto", paddingY: t3, paddingX: 4, sizing: "border", children: /* @__PURE__ */ jsx(View, { display: "flex", height: "fill", children: /* @__PURE__ */ jsx(Container$3, { width: 3, children: /* @__PURE__ */ jsx(Stack, { space: 6, children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t4,
    t5,
    t6,
    t7,
    t9
  ] }) }) }) }) }), $[17] = t6, $[18] = t7, $[19] = t9, $[20] = t10) : t10 = $[20], t10;
}
function _temp$s(seconds) {
  return COUNTDOWN_SECONDS - seconds;
}
const DevServerStoppedErrorScreen = lazy(() => import("./_chunks-es/ViteDevServerStopped.js").then((DevServerStopped) => ({
  default: DevServerStopped.DevServerStoppedErrorScreen
})));
function StudioErrorBoundary(props2) {
  const $ = c(20), {
    children,
    heading: t0,
    getErrorScreen,
    primaryProjectId
  } = props2, heading = t0 === void 0 ? "An error occurred" : t0, [caughtError, setCaughtError] = useState(), [errorScreen, setErrorScreen] = useState();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setCaughtError(void 0), $[0] = t1) : t1 = $[0];
  const handleResetError = t1;
  let t2;
  $[1] !== getErrorScreen ? (t2 = (params) => {
    let eventId;
    const run = () => {
      eventId = errorReporter.reportError(params.error, {
        reactErrorInfo: params.info,
        errorBoundary: "StudioErrorBoundary"
      })?.eventId;
    };
    try {
      run();
    } catch (t32) {
      const e = t32;
      e.message = `Encountered an additional error when reporting error: ${e.message}`, console.error(e);
    }
    setErrorScreen(getErrorScreen?.(params.error)), setCaughtError({
      error: params.error,
      componentStack: params.info.componentStack,
      eventId
    });
  }, $[1] = getErrorScreen, $[2] = t2) : t2 = $[2];
  const handleCatchError = t2;
  if (useHotModuleReload(handleResetError), !caughtError?.error) {
    let t32;
    return $[3] !== children || $[4] !== handleCatchError ? (t32 = /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: handleCatchError, children }), $[3] = children, $[4] = handleCatchError, $[5] = t32) : t32 = $[5], t32;
  }
  if (errorScreen)
    return errorScreen;
  if (caughtError.error instanceof CorsOriginError) {
    let t32;
    return $[6] !== caughtError.error.isStaging || $[7] !== caughtError.error.projectId || $[8] !== primaryProjectId ? (t32 = /* @__PURE__ */ jsx(CorsOriginErrorScreen, { projectId: caughtError.error.projectId, isStaging: caughtError.error.isStaging, primaryProjectId }), $[6] = caughtError.error.isStaging, $[7] = caughtError.error.projectId, $[8] = primaryProjectId, $[9] = t32) : t32 = $[9], t32;
  }
  if (caughtError.error instanceof SchemaError) {
    let t32;
    return $[10] !== caughtError.error.schema ? (t32 = /* @__PURE__ */ jsx(SchemaErrorsScreen, { schema: caughtError.error.schema }), $[10] = caughtError.error.schema, $[11] = t32) : t32 = $[11], t32;
  }
  if ("ViteDevServerStoppedError" in caughtError.error && caughtError.error.ViteDevServerStoppedError) {
    let t32;
    return $[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t32 = /* @__PURE__ */ jsx(DevServerStoppedErrorScreen, {}), $[12] = t32) : t32 = $[12], t32;
  }
  if (isImportError(caughtError.error)) {
    let t32;
    return $[13] !== caughtError.error || $[14] !== caughtError.eventId ? (t32 = /* @__PURE__ */ jsx(ImportErrorScreen, { error: caughtError.error, eventId: caughtError.eventId, autoReload: !0 }), $[13] = caughtError.error, $[14] = caughtError.eventId, $[15] = t32) : t32 = $[15], t32;
  }
  let t3;
  return $[16] !== caughtError.error || $[17] !== caughtError.eventId || $[18] !== heading ? (t3 = /* @__PURE__ */ jsx(FallbackErrorScreen, { heading, error: caughtError.error, eventId: caughtError.eventId, onReset: handleResetError }), $[16] = caughtError.error, $[17] = caughtError.eventId, $[18] = heading, $[19] = t3) : t3 = $[19], t3;
}
const DetectViteDevServerStopped = lazy(() => import("./_chunks-es/ViteDevServerStopped.js").then((DevServerStopped) => ({
  default: DevServerStopped.DetectViteDevServerStopped
}))), detectViteDevServerStopped = import.meta.hot && process.env.NODE_ENV === "development", SearchFullscreenPortalCard = styled(Card).withConfig({
  displayName: "SearchFullscreenPortalCard",
  componentId: "sc-ryuemf-0"
})`height:100%;left:0;overflow:hidden;overflow:clip;position:fixed;top:0;width:100%;z-index:200;`;
function StudioLayout() {
  const $ = c(2), Layout2 = useLayoutComponent();
  let t0;
  return $[0] !== Layout2 ? (t0 = /* @__PURE__ */ jsx(Layout2, {}), $[0] = Layout2, $[1] = t0) : t0 = $[1], t0;
}
function StudioLayoutComponent() {
  const $ = c(64), {
    name,
    title,
    tools
  } = useWorkspace();
  useNetworkProtocolCheck();
  let t0;
  $[0] !== tools ? (t0 = tools.filter(isDefaultRouteTool), $[0] = tools, $[1] = t0) : t0 = $[1];
  const defaultRouteTools = t0, router = useRouter(), activeToolName = useRouterState(_temp$r);
  let t1;
  if ($[2] !== activeToolName || $[3] !== tools) {
    let t24;
    $[5] !== activeToolName ? (t24 = (tool) => tool.name === activeToolName, $[5] = activeToolName, $[6] = t24) : t24 = $[6], t1 = tools.find(t24), $[2] = activeToolName, $[3] = tools, $[4] = t1;
  } else
    t1 = $[4];
  const activeTool = t1, [searchFullscreenOpen, setSearchFullscreenOpen] = useState(!1), [searchFullscreenPortalEl, setSearchFullscreenPortalEl] = useState(null), [searchOpen, setSearchOpen] = useState(!1);
  let t2;
  bb0: {
    let t32;
    $[7] !== name || $[8] !== title ? (t32 = title || startCase(name), $[7] = name, $[8] = title, $[9] = t32) : t32 = $[9];
    const workspaceTitle = t32, toolTitle = activeTool ? activeTool.title || activeTool.name : void 0;
    if (toolTitle) {
      t2 = `${toolTitle} | ${workspaceTitle}`;
      break bb0;
    }
    t2 = workspaceTitle;
  }
  const documentTitle = t2, toolControlsDocumentTitle = !!activeTool?.controlsDocumentTitle;
  let t3, t4;
  $[10] !== documentTitle || $[11] !== toolControlsDocumentTitle ? (t3 = () => {
    toolControlsDocumentTitle || (document.title = documentTitle);
  }, t4 = [documentTitle, toolControlsDocumentTitle], $[10] = documentTitle, $[11] = toolControlsDocumentTitle, $[12] = t3, $[13] = t4) : (t3 = $[12], t4 = $[13]), useEffect(t3, t4);
  let t5;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = (open) => {
    setSearchFullscreenOpen(open);
  }, $[14] = t5) : t5 = $[14];
  const handleSearchFullscreenOpenChange = t5;
  let t6;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = (open_0) => {
    setSearchOpen(open_0);
  }, $[15] = t6) : t6 = $[15];
  const handleSearchOpenChange = t6;
  let t7;
  $[16] !== searchFullscreenOpen || $[17] !== searchFullscreenPortalEl || $[18] !== searchOpen ? (t7 = {
    searchFullscreenOpen,
    searchFullscreenPortalEl,
    searchOpen,
    onSearchFullscreenOpenChange: handleSearchFullscreenOpenChange,
    onSearchOpenChange: handleSearchOpenChange
  }, $[16] = searchFullscreenOpen, $[17] = searchFullscreenPortalEl, $[18] = searchOpen, $[19] = t7) : t7 = $[19];
  const navbarContextValue = t7, Navbar = useNavbarComponent(), ActiveToolLayout = useActiveToolLayoutComponent();
  let t8;
  $[20] !== activeTool || $[21] !== activeToolName || $[22] !== tools ? (t8 = !activeTool && (activeToolName === "desk" || !activeToolName) && typeof window < "u" && /\/desk(\/|$)/.test(window.location.pathname) && tools.some(_temp2$a), $[20] = activeTool, $[21] = activeToolName, $[22] = tools, $[23] = t8) : t8 = $[23];
  const isLegacyDeskRedirect = t8;
  let t10, t9;
  $[24] !== isLegacyDeskRedirect || $[25] !== router ? (t9 = () => {
    isLegacyDeskRedirect && router.navigateUrl({
      path: window.location.pathname.replace(/\/desk/, "/structure"),
      replace: !0
    });
  }, t10 = [isLegacyDeskRedirect, router], $[24] = isLegacyDeskRedirect, $[25] = router, $[26] = t10, $[27] = t9) : (t10 = $[26], t9 = $[27]), useEffect(t9, t10);
  const getErrorScreen = _temp3$4;
  let t11;
  $[28] !== Navbar ? (t11 = /* @__PURE__ */ jsx(Navbar, {}), $[28] = Navbar, $[29] = t11) : t11 = $[29];
  let t12;
  $[30] !== navbarContextValue || $[31] !== t11 ? (t12 = /* @__PURE__ */ jsx(NavbarContext.Provider, { value: navbarContextValue, children: t11 }), $[30] = navbarContextValue, $[31] = t11, $[32] = t12) : t12 = $[32];
  let t13;
  $[33] !== isLegacyDeskRedirect ? (t13 = isLegacyDeskRedirect && /* @__PURE__ */ jsx(RedirectingScreen, {}), $[33] = isLegacyDeskRedirect, $[34] = t13) : t13 = $[34];
  let t14;
  $[35] !== activeTool || $[36] !== defaultRouteTools ? (t14 = !activeTool && defaultRouteTools.length === 0 && /* @__PURE__ */ jsx(NoToolsScreen, {}), $[35] = activeTool, $[36] = defaultRouteTools, $[37] = t14) : t14 = $[37];
  let t15;
  $[38] !== activeTool || $[39] !== activeToolName || $[40] !== isLegacyDeskRedirect || $[41] !== tools.length ? (t15 = tools.length > 0 && !activeTool && activeToolName && !isLegacyDeskRedirect && /* @__PURE__ */ jsx(ToolNotFoundScreen, { toolName: activeToolName }), $[38] = activeTool, $[39] = activeToolName, $[40] = isLegacyDeskRedirect, $[41] = tools.length, $[42] = t15) : t15 = $[42];
  let t16;
  $[43] !== searchFullscreenOpen ? (t16 = searchFullscreenOpen && /* @__PURE__ */ jsx(SearchFullscreenPortalCard, { ref: setSearchFullscreenPortalEl, overflow: "auto" }), $[43] = searchFullscreenOpen, $[44] = t16) : t16 = $[44];
  const t17 = activeTool?.name, t18 = `The ${activeTool?.name} tool crashed`;
  let t19;
  $[45] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t19 = detectViteDevServerStopped && /* @__PURE__ */ jsx(DetectViteDevServerStopped, {}), $[45] = t19) : t19 = $[45];
  let t20;
  $[46] !== ActiveToolLayout || $[47] !== activeTool || $[48] !== activeToolName ? (t20 = activeTool && activeToolName && /* @__PURE__ */ jsx(RouteScope, { scope: activeToolName, __unsafe_disableScopedSearchParams: activeTool.router?.__unsafe_disableScopedSearchParams, children: /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }), children: /* @__PURE__ */ jsx(ActiveToolLayout, { activeTool }) }) }), $[46] = ActiveToolLayout, $[47] = activeTool, $[48] = activeToolName, $[49] = t20) : t20 = $[49];
  let t21;
  $[50] !== searchFullscreenOpen || $[51] !== t20 ? (t21 = /* @__PURE__ */ jsx(Card, { flex: 1, hidden: searchFullscreenOpen, children: t20 }), $[50] = searchFullscreenOpen, $[51] = t20, $[52] = t21) : t21 = $[52];
  let t22;
  $[53] !== t17 || $[54] !== t18 || $[55] !== t21 ? (t22 = /* @__PURE__ */ jsxs(StudioErrorBoundary, { heading: t18, getErrorScreen, children: [
    t19,
    t21
  ] }, t17), $[53] = t17, $[54] = t18, $[55] = t21, $[56] = t22) : t22 = $[56];
  let t23;
  return $[57] !== t12 || $[58] !== t13 || $[59] !== t14 || $[60] !== t15 || $[61] !== t16 || $[62] !== t22 ? (t23 = /* @__PURE__ */ jsxs(Flex, { "data-ui": "ToolScreen", direction: "column", height: "fill", "data-testid": "studio-layout", children: [
    t12,
    t13,
    t14,
    t15,
    t16,
    t22
  ] }), $[57] = t12, $[58] = t13, $[59] = t14, $[60] = t15, $[61] = t16, $[62] = t22, $[63] = t23) : t23 = $[63], t23;
}
function _temp3$4(error) {
  return isDocumentLimitError(error) ? /* @__PURE__ */ jsx(DocumentLimitsUpsellPanel, {}) : null;
}
function _temp2$a(tool_0) {
  return tool_0.name === "structure";
}
function _temp$r(routerState) {
  return typeof routerState.tool == "string" ? routerState.tool : void 0;
}
function pickToolMenuComponent(plugin) {
  return plugin.studio?.components?.toolMenu;
}
function pickNavbarComponent(plugin) {
  return plugin.studio?.components?.navbar;
}
function pickLayoutComponent(plugin) {
  return plugin.studio?.components?.layout;
}
function pickActiveToolLayoutComponent(plugin) {
  return plugin.studio?.components?.activeToolLayout;
}
function useToolMenuComponent() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: StudioToolMenu,
    pick: pickToolMenuComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useNavbarComponent() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: StudioNavbar,
    pick: pickNavbarComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useLayoutComponent() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: StudioLayoutComponent,
    pick: pickLayoutComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useActiveToolLayoutComponent() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: StudioActiveToolLayout,
    pick: pickActiveToolLayoutComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function ConfigIssuesButton() {
  const $ = c(25), schema2 = useSchema();
  let t0;
  $[0] !== schema2._validation ? (t0 = schema2._validation?.filter(_temp2$9) || [], $[0] = schema2._validation, $[1] = t0) : t0 = $[1];
  const groupsWithWarnings = t0, scheme = useColorSchemeValue(), {
    t
  } = useTranslation(), dialogId = useId(), [isDialogOpen, setDialogOpen] = useState(!1), [buttonElement, setButtonElement] = useState(null);
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setDialogOpen(!0), $[2] = t1) : t1 = $[2];
  const handleOpen = t1;
  let t2;
  $[3] !== buttonElement ? (t2 = () => {
    setDialogOpen(!1), buttonElement && buttonElement.focus();
  }, $[3] = buttonElement, $[4] = t2) : t2 = $[4];
  const handleClose = t2;
  if (groupsWithWarnings.length === 0)
    return null;
  let t3;
  $[5] !== t ? (t3 = t("configuration-issues.button.label"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t ? (t4 = t("configuration-issues.button.tooltip"), $[7] = t, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== scheme || $[10] !== t4 ? (t5 = {
    scheme,
    content: t4
  }, $[9] = scheme, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== isDialogOpen || $[13] !== t3 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(StatusButton, { icon: WarningOutlineIcon, mode: "bleed", onClick: handleOpen, ref: setButtonElement, selected: isDialogOpen, tone: "caution", "aria-label": t3, tooltipProps: t5 }), $[12] = isDialogOpen, $[13] = t3, $[14] = t5, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== dialogId || $[17] !== groupsWithWarnings || $[18] !== handleClose || $[19] !== isDialogOpen || $[20] !== scheme ? (t7 = isDialogOpen && /* @__PURE__ */ jsx(Dialog$1, { header: "Configuration issues", width: 2, onClickOutside: handleClose, onClose: handleClose, scheme, id: dialogId, children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      /* @__PURE__ */ jsxs(Text$1, { as: "h2", size: 1, weight: "medium", children: [
        "Found ",
        groupsWithWarnings.length,
        " schema warnings"
      ] }),
      " ",
      /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: "Configuration checks are only performed during development and will not be visible in production builds" })
    ] }),
    /* @__PURE__ */ jsx(SchemaProblemGroups, { problemGroups: groupsWithWarnings })
  ] }) }), $[16] = dialogId, $[17] = groupsWithWarnings, $[18] = handleClose, $[19] = isDialogOpen, $[20] = scheme, $[21] = t7) : t7 = $[21];
  let t8;
  return $[22] !== t6 || $[23] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t6,
    t7
  ] }), $[22] = t6, $[23] = t7, $[24] = t8) : t8 = $[24], t8;
}
function _temp2$9(group2) {
  return group2.problems.some(_temp$q);
}
function _temp$q(problem) {
  return problem.severity === "warning";
}
const TrialDialogViewed = defineEvent({
  name: "Trial Dialog Viewed",
  version: 1,
  description: "User viewed a dialog or popover related to free trial"
}), TrialDialogDismissed = defineEvent({
  name: "Trial Dialog Dismissed",
  version: 1,
  description: "User dismissed a dialog or popover related to free trial"
}), TrialDialogCTAClicked = defineEvent({
  name: "Trial Dialog CTA Clicked",
  version: 1,
  description: "User clicked a CTA in a dialog or popover related to free trial"
});
function getTrialStage({
  showOnLoad,
  dialogId
}) {
  return showOnLoad && dialogId.toLowerCase() === "free-upgrade-popover" ? "trialStarted" : showOnLoad && dialogId.toLowerCase() === "trial-ending-popover" ? "trialEndingSoon" : showOnLoad && dialogId.toLowerCase() === "project-downgraded-to-free" ? "trialEnded" : !showOnLoad && dialogId.toLowerCase() === "after-trial-upgrade" ? "postTrial" : "trialActive";
}
const UpsellDialogViewed = defineEvent({
  name: "Upsell Dialog Viewed",
  version: 1,
  description: "User viewed the upsell dialog"
}), UpsellDialogDismissed = defineEvent({
  name: "Upsell Dialog Dismissed",
  version: 1,
  description: "User dismissed the upsell dialog"
}), UpsellDialogUpgradeCtaClicked = defineEvent({
  name: "Upsell Dialog Upgrade CTA Clicked",
  version: 1,
  description: 'User clicked the "Upgrade" CTA in the upsell dialog'
}), UpsellDialogLearnMoreCtaClicked = defineEvent({
  name: "Upsell Dialog Learn More CTA Clicked",
  version: 1,
  description: 'User clicked the "Learn More" CTA in the upsell dialog'
}), StyledButton$1 = styled(Button).withConfig({
  displayName: "StyledButton",
  componentId: "sc-ytxa91-0"
})`position:absolute;top:12px;right:12px;z-index:20;background:transparent;border-radius:9999px;box-shadow:none;color:white;--card-fg-color:white;:hover{--card-fg-color:white;}`, Image$2 = styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-ytxa91-1"
})`object-fit:cover;width:100%;height:100%;height:196px;`, StyledDialog$1 = styled(Dialog$1).withConfig({
  displayName: "StyledDialog",
  componentId: "sc-ytxa91-2"
})`> [data-ui='DialogCard']{max-width:22.5rem;}`;
function DialogContent(t0) {
  const $ = c(39), {
    onClose,
    onOpenNext,
    onOpenUrlCallback,
    content,
    open
  } = t0;
  let t1;
  $[0] !== onClose ? (t1 = function() {
    onClose("xClick");
  }, $[0] = onClose, $[1] = t1) : t1 = $[1];
  const handleClose = t1;
  let t2;
  $[2] !== onClose ? (t2 = function() {
    onClose("outsideClick");
  }, $[2] = onClose, $[3] = t2) : t2 = $[3];
  const handleClickOutside = t2;
  let t3;
  $[4] !== onClose ? (t3 = function() {
    onClose("ctaClicked");
  }, $[4] = onClose, $[5] = t3) : t3 = $[5];
  const handleCTAClose = t3, schemeValue = useColorSchemeValue();
  if (!open)
    return null;
  let t4;
  $[6] !== content.secondaryButton || $[7] !== handleClose ? (t4 = content.secondaryButton?.text ? {
    text: content.secondaryButton.text,
    mode: "bleed",
    tone: "default",
    onClick: handleClose
  } : void 0, $[6] = content.secondaryButton, $[7] = handleClose, $[8] = t4) : t4 = $[8];
  const t5 = content.ctaButton?.text;
  let t6;
  $[9] !== content.ctaButton || $[10] !== handleCTAClose || $[11] !== onOpenNext || $[12] !== onOpenUrlCallback ? (t6 = content.ctaButton?.action === "openUrl" ? {
    href: content.ctaButton.url,
    target: "_blank",
    rel: "noopener noreferrer",
    as: "a",
    onClick: onOpenUrlCallback
  } : {
    onClick: content.ctaButton?.action === "openNext" ? onOpenNext : handleCTAClose
  }, $[9] = content.ctaButton, $[10] = handleCTAClose, $[11] = onOpenNext, $[12] = onOpenUrlCallback, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== t5 || $[15] !== t6 ? (t7 = {
    text: t5,
    mode: "default",
    tone: "primary",
    ...t6
  }, $[14] = t5, $[15] = t6, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t4 || $[18] !== t7 ? (t8 = {
    cancelButton: t4,
    confirmButton: t7
  }, $[17] = t4, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== handleClose ? (t9 = /* @__PURE__ */ jsx(StyledButton$1, { icon: CloseIcon, mode: "bleed", tone: "default", onClick: handleClose, tabIndex: -1, tooltipProps: null }), $[20] = handleClose, $[21] = t9) : t9 = $[21];
  let t10;
  $[22] !== content.image ? (t10 = content.image && /* @__PURE__ */ jsx(Image$2, { src: content.image.asset.url, alt: content.image.asset.altText ?? "" }), $[22] = content.image, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] !== content.headingText ? (t11 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginTop: 3, children: /* @__PURE__ */ jsx(Heading, { size: 2, children: content.headingText }) }), $[24] = content.headingText, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== content.descriptionText ? (t12 = /* @__PURE__ */ jsx(Box, { marginTop: 4, paddingBottom: 3, children: /* @__PURE__ */ jsx(UpsellDescriptionSerializer, { blocks: content.descriptionText }) }), $[26] = content.descriptionText, $[27] = t12) : t12 = $[27];
  let t13;
  $[28] !== t11 || $[29] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Flex, { padding: 3, direction: "column", children: [
    t11,
    t12
  ] }), $[28] = t11, $[29] = t12, $[30] = t13) : t13 = $[30];
  let t14;
  return $[31] !== handleClickOutside || $[32] !== onClose || $[33] !== schemeValue || $[34] !== t10 || $[35] !== t13 || $[36] !== t8 || $[37] !== t9 ? (t14 = /* @__PURE__ */ jsxs(StyledDialog$1, { id: "free-trial-modal", onClose, onClickOutside: handleClickOutside, padding: !1, __unstable_hideCloseButton: !0, scheme: schemeValue, footer: t8, children: [
    t9,
    t10,
    t13
  ] }), $[31] = handleClickOutside, $[32] = onClose, $[33] = schemeValue, $[34] = t10, $[35] = t13, $[36] = t8, $[37] = t9, $[38] = t14) : t14 = $[38], t14;
}
const CenteredStroke = styled.div.withConfig({
  displayName: "CenteredStroke",
  componentId: "sc-olne1x-0"
})`position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);`, SvgFilledOutline = (t0) => {
  const $ = c(8), {
    daysLeft,
    totalDays
  } = t0, progress = totalDays - daysLeft, percentage = Math.round(progress / totalDays * 100), strokeDasharray = 2 * Math.PI * 10, strokeDashOffset = strokeDasharray * ((100 - percentage) / 100);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    transform: "rotate(-90deg)"
  }, $[0] = t1) : t1 = $[0];
  const t2 = percentage > 75 ? yellow[600].hex : purple[400].hex;
  let t3;
  $[1] !== t2 ? (t3 = /* @__PURE__ */ jsx("circle", { r: 10, cx: 10.6, cy: 10.6, fill: "transparent", strokeWidth: 1.2, stroke: t2 }), $[1] = t2, $[2] = t3) : t3 = $[2];
  let t4;
  $[3] !== strokeDashOffset ? (t4 = /* @__PURE__ */ jsx("circle", { r: 10, cx: 10.6, cy: 10.6, fill: "transparent", strokeWidth: 1.2, stroke: "var(--card-border-color)", strokeDasharray, strokeDashoffset: strokeDashOffset }), $[3] = strokeDashOffset, $[4] = t4) : t4 = $[4];
  let t5;
  return $[5] !== t3 || $[6] !== t4 ? (t5 = /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx(CenteredStroke, { children: /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21.2, height: 21.2, viewBox: "0 0 21.2 21.2", style: t1, children: [
    t3,
    t4
  ] }) }) }), $[5] = t3, $[6] = t4, $[7] = t5) : t5 = $[7], t5;
}, FreeTrialButtonTopbar = forwardRef(function(t0, ref) {
  const $ = c(14), {
    toggleShowContent,
    daysLeft,
    totalDays
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== daysLeft || $[1] !== t ? (t1 = daysLeft ? t("free-trial.tooltip.days-count", {
    count: daysLeft
  }) : t("free-trial.tooltip.trial-finished"), $[0] = daysLeft, $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = {
    content: t1
  }, $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 0, children: /* @__PURE__ */ jsx(BoltIcon, {}) }), $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== daysLeft || $[7] !== totalDays ? (t4 = daysLeft > 0 && /* @__PURE__ */ jsx(SvgFilledOutline, { daysLeft, totalDays }), $[6] = daysLeft, $[7] = totalDays, $[8] = t4) : t4 = $[8];
  let t5;
  return $[9] !== ref || $[10] !== t2 || $[11] !== t4 || $[12] !== toggleShowContent ? (t5 = /* @__PURE__ */ jsxs(Button, { mode: "bleed", onClick: toggleShowContent, ref, tooltipProps: t2, children: [
    t3,
    t4
  ] }), $[9] = ref, $[10] = t2, $[11] = t4, $[12] = toggleShowContent, $[13] = t5) : t5 = $[13], t5;
}), FreeTrialButtonSidebar = forwardRef(function(t0, ref) {
  const $ = c(7), {
    toggleShowContent,
    daysLeft
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== daysLeft || $[1] !== t ? (t1 = daysLeft ? t("user-menu.action.free-trial", {
    count: daysLeft
  }) : t("user-menu.action.free-trial-finished"), $[0] = daysLeft, $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== ref || $[4] !== t1 || $[5] !== toggleShowContent ? (t2 = /* @__PURE__ */ jsx(Button, { ref, icon: BoltIcon, justify: "flex-start", mode: "bleed", size: "large", onClick: toggleShowContent, text: t1 }), $[3] = ref, $[4] = t1, $[5] = toggleShowContent, $[6] = t2) : t2 = $[6], t2;
}), useFreeTrialContext = () => {
  const context = useContext(FreeTrialContext);
  if (!context)
    throw new Error("useFreeTrial must be used within a FreeTrialProvider");
  return context;
}, Image$1 = styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-1ch473w-0"
})`object-fit:cover;width:100%;height:100%;height:180px;`;
function PopoverContent(t0) {
  const $ = c(26), {
    content,
    handleClose,
    handleOpenNext
  } = t0;
  let t1;
  $[0] !== content.image ? (t1 = content.image && /* @__PURE__ */ jsx(Image$1, { src: content.image.asset.url, alt: content.image.asset.altText ?? "" }), $[0] = content.image, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== content.headingText ? (t2 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginTop: 3, children: /* @__PURE__ */ jsx(Heading, { size: 1, children: content.headingText }) }), $[2] = content.headingText, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== content.descriptionText ? (t3 = /* @__PURE__ */ jsx(Box, { marginTop: 4, children: /* @__PURE__ */ jsx(UpsellDescriptionSerializer, { blocks: content.descriptionText }) }), $[4] = content.descriptionText, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t2 || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { padding: 3, direction: "column", children: [
    t2,
    t3
  ] }), $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== content.secondaryButton || $[10] !== handleClose ? (t5 = content.secondaryButton?.text && /* @__PURE__ */ jsx(Button, { mode: "bleed", text: content.secondaryButton.text, tone: "default", onClick: () => handleClose("xClick") }), $[9] = content.secondaryButton, $[10] = handleClose, $[11] = t5) : t5 = $[11];
  const t6 = content.ctaButton?.text;
  let t7;
  $[12] !== content.ctaButton || $[13] !== handleClose || $[14] !== handleOpenNext ? (t7 = content.ctaButton?.action === "openUrl" ? {
    href: content.ctaButton.url,
    target: "_blank",
    rel: "noopener noreferrer",
    as: "a"
  } : {
    onClick: content.ctaButton?.action === "openNext" ? handleOpenNext : () => handleClose("ctaClicked")
  }, $[12] = content.ctaButton, $[13] = handleClose, $[14] = handleOpenNext, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t6 || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { mode: "default", tooltipProps: null, text: t6, autoFocus: !0, tone: "primary", ...t7 }), $[16] = t6, $[17] = t7, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== t5 || $[20] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { width: "full", gap: 3, justify: "flex-end", padding: 3, children: [
    t5,
    t8
  ] }), $[19] = t5, $[20] = t8, $[21] = t9) : t9 = $[21];
  let t10;
  return $[22] !== t1 || $[23] !== t4 || $[24] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { radius: 3, overflow: "hidden", width: 0, children: /* @__PURE__ */ jsxs(Container$3, { width: 0, children: [
    t1,
    t4,
    t9
  ] }) }), $[22] = t1, $[23] = t4, $[24] = t9, $[25] = t10) : t10 = $[25], t10;
}
function FreeTrial(t0) {
  const $ = c(57), {
    type
  } = t0, {
    data,
    showDialog,
    showOnLoad,
    toggleShowContent
  } = useFreeTrialContext(), scheme = useColorSchemeValue(), telemetry = useTelemetry(), [ref, setRef] = useState(null), [showPopover, setShowPopover] = useState(!1);
  let t1, t2;
  $[0] !== ref ? (t1 = () => {
    ref && setShowPopover(!0);
  }, t2 = [ref], $[0] = ref, $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]), useEffect(t1, t2);
  let t3;
  $[3] !== toggleShowContent ? (t3 = () => toggleShowContent(!0), $[3] = toggleShowContent, $[4] = t3) : t3 = $[4];
  const closeAndReOpen = t3;
  let t4;
  $[5] !== ref || $[6] !== toggleShowContent ? (t4 = () => {
    ref?.focus(), toggleShowContent(!1);
  }, $[5] = ref, $[6] = toggleShowContent, $[7] = t4) : t4 = $[7];
  const toggleDialog = t4;
  let t5;
  $[8] !== data || $[9] !== showOnLoad || $[10] !== telemetry || $[11] !== toggleDialog ? (t5 = (dialogType) => (action) => {
    const dialog = data?.showOnLoad || data?.showOnClick;
    dialog && telemetry.log(TrialDialogDismissed, {
      dialogId: dialog.id,
      dialogRevision: dialog._rev,
      dialogType,
      source: "studio",
      trialDaysLeft: data.daysLeft,
      dialogTrialStage: getTrialStage({
        showOnLoad,
        dialogId: dialog.id
      }),
      dialogDismissAction: action
    }), toggleDialog();
  }, $[8] = data, $[9] = showOnLoad, $[10] = telemetry, $[11] = toggleDialog, $[12] = t5) : t5 = $[12];
  const handleClose = t5;
  let t6;
  $[13] !== closeAndReOpen || $[14] !== data || $[15] !== showOnLoad || $[16] !== telemetry ? (t6 = (action_0) => () => {
    const dialog_0 = data?.showOnLoad || data?.showOnClick;
    dialog_0 && telemetry.log(TrialDialogCTAClicked, {
      dialogId: dialog_0.id,
      dialogRevision: dialog_0._rev,
      dialogType: "modal",
      source: "studio",
      trialDaysLeft: data.daysLeft,
      dialogTrialStage: getTrialStage({
        showOnLoad,
        dialogId: dialog_0.id
      }),
      dialogCtaType: action_0 === "openURL" ? "upgrade" : "learnMore"
    }), closeAndReOpen();
  }, $[13] = closeAndReOpen, $[14] = data, $[15] = showOnLoad, $[16] = telemetry, $[17] = t6) : t6 = $[17];
  const handleDialogCTAClick = t6;
  let t7;
  $[18] !== closeAndReOpen || $[19] !== data || $[20] !== telemetry ? (t7 = () => {
    data?.showOnLoad && telemetry.log(TrialDialogCTAClicked, {
      dialogId: data.showOnLoad.id,
      dialogRevision: data.showOnLoad._rev,
      dialogType: "popover",
      source: "studio",
      trialDaysLeft: data.daysLeft,
      dialogTrialStage: getTrialStage({
        showOnLoad: !0,
        dialogId: data.showOnLoad.id
      }),
      dialogCtaType: "learnMore"
    }), closeAndReOpen();
  }, $[18] = closeAndReOpen, $[19] = data, $[20] = telemetry, $[21] = t7) : t7 = $[21];
  const handlePopoverCTAClick = t7;
  let t8;
  $[22] !== closeAndReOpen || $[23] !== data || $[24] !== telemetry ? (t8 = () => {
    data?.showOnClick && telemetry.log(TrialDialogViewed, {
      dialogId: data.showOnClick.id,
      dialogRevision: data.showOnClick._rev,
      dialogTrigger: "fromClick",
      dialogType: "modal",
      source: "studio",
      trialDaysLeft: data.daysLeft,
      dialogTrialStage: getTrialStage({
        showOnLoad: !0,
        dialogId: data.showOnClick.id
      })
    }), closeAndReOpen();
  }, $[22] = closeAndReOpen, $[23] = data, $[24] = telemetry, $[25] = t8) : t8 = $[25];
  const handleOnTrialButtonClick = t8;
  if (!data?.id)
    return null;
  const dialogToRender = showOnLoad ? data.showOnLoad : data.showOnClick;
  if (!dialogToRender)
    return null;
  let t9;
  $[26] !== data.daysLeft || $[27] !== data.totalDays || $[28] !== handleOnTrialButtonClick || $[29] !== type ? (t9 = type === "sidebar" ? /* @__PURE__ */ jsx(FreeTrialButtonSidebar, { toggleShowContent: handleOnTrialButtonClick, daysLeft: data.daysLeft, ref: setRef }) : /* @__PURE__ */ jsx(FreeTrialButtonTopbar, { toggleShowContent: handleOnTrialButtonClick, daysLeft: data.daysLeft, totalDays: data.totalDays, ref: setRef }), $[26] = data.daysLeft, $[27] = data.totalDays, $[28] = handleOnTrialButtonClick, $[29] = type, $[30] = t9) : t9 = $[30];
  const button = t9;
  if (dialogToRender?.dialogType === "popover") {
    const t102 = showDialog && showPopover, t112 = type === "sidebar" ? "top" : "bottom-end";
    let t122;
    $[31] !== handleClose ? (t122 = handleClose("popover"), $[31] = handleClose, $[32] = t122) : t122 = $[32];
    let t132;
    $[33] !== dialogToRender || $[34] !== handlePopoverCTAClick || $[35] !== t122 ? (t132 = /* @__PURE__ */ jsx(PopoverContent, { content: dialogToRender, handleClose: t122, handleOpenNext: handlePopoverCTAClick }), $[33] = dialogToRender, $[34] = handlePopoverCTAClick, $[35] = t122, $[36] = t132) : t132 = $[36];
    let t142;
    return $[37] !== button || $[38] !== scheme || $[39] !== t102 || $[40] !== t112 || $[41] !== t132 ? (t142 = /* @__PURE__ */ jsx(Popover, { open: t102, size: 0, scheme, radius: 3, tone: "default", portal: !0, placement: t112, content: t132, children: button }), $[37] = button, $[38] = scheme, $[39] = t102, $[40] = t112, $[41] = t132, $[42] = t142) : t142 = $[42], t142;
  }
  let t10;
  $[43] !== handleClose ? (t10 = handleClose("modal"), $[43] = handleClose, $[44] = t10) : t10 = $[44];
  let t11, t12;
  $[45] !== handleDialogCTAClick ? (t11 = handleDialogCTAClick("openNext"), t12 = handleDialogCTAClick("openURL"), $[45] = handleDialogCTAClick, $[46] = t11, $[47] = t12) : (t11 = $[46], t12 = $[47]);
  let t13;
  $[48] !== dialogToRender || $[49] !== showDialog || $[50] !== t10 || $[51] !== t11 || $[52] !== t12 ? (t13 = /* @__PURE__ */ jsx(DialogContent, { content: dialogToRender, onClose: t10, onOpenNext: t11, onOpenUrlCallback: t12, open: showDialog }), $[48] = dialogToRender, $[49] = showDialog, $[50] = t10, $[51] = t11, $[52] = t12, $[53] = t13) : t13 = $[53];
  let t14;
  return $[54] !== button || $[55] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    button,
    t13
  ] }), $[54] = button, $[55] = t13, $[56] = t14) : t14 = $[56], t14;
}
const FreeTrialProvider = (t0) => {
  const $ = c(30), {
    children
  } = t0, router = useRouter(), [data, setData] = useState(null), [showDialog, setShowDialog] = useState(!1), [showOnLoad, setShowOnLoad] = useState(!1);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    apiVersion: "2023-12-11"
  }, $[0] = t1) : t1 = $[0];
  const client = useClient(t1), telemetry = useTelemetry();
  let t2, t3;
  $[1] !== data || $[2] !== showDialog || $[3] !== showOnLoad || $[4] !== telemetry ? (t2 = () => {
    const dialog = data?.showOnLoad;
    showDialog && showOnLoad && dialog && telemetry.log(TrialDialogViewed, {
      dialogId: dialog.id,
      dialogRevision: dialog._rev,
      dialogTrialStage: getTrialStage({
        showOnLoad,
        dialogId: dialog.id
      }),
      dialogTrigger: showOnLoad ? "auto" : "fromClick",
      dialogType: dialog.dialogType,
      source: "studio",
      trialDaysLeft: data.daysLeft
    });
  }, t3 = [showDialog, data, showOnLoad, telemetry], $[1] = data, $[2] = showDialog, $[3] = showOnLoad, $[4] = telemetry, $[5] = t2, $[6] = t3) : (t2 = $[5], t3 = $[6]), useEffect(t2, t3);
  let t4, trialState;
  if ($[7] !== router.state._searchParams) {
    const searchParams = new URLSearchParams(router.state._searchParams);
    trialState = searchParams.get("trialState"), t4 = searchParams.get("seenBefore"), $[7] = router.state._searchParams, $[8] = t4, $[9] = trialState;
  } else
    t4 = $[8], trialState = $[9];
  const seenBefore = t4;
  let t5;
  $[10] !== client.observable || $[11] !== seenBefore || $[12] !== trialState ? (t5 = () => {
    const queryParams = new URLSearchParams();
    queryParams.append("studioVersion", SANITY_VERSION), trialState && queryParams.append("trialState", trialState), seenBefore && queryParams.append("seenBefore", seenBefore);
    const queryURL = queryParams.get("trialState") ? "/journey/trial/override" : "/journey/trial", request = client.observable.request({
      url: `${queryURL}?${queryParams.toString()}`
    }).subscribe((response) => {
      setData(response), response?.showOnLoad && (setShowOnLoad(!0), setShowDialog(!0));
    }, _temp$p);
    return () => {
      request.unsubscribe();
    };
  }, $[10] = client.observable, $[11] = seenBefore, $[12] = trialState, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== client || $[15] !== seenBefore || $[16] !== trialState ? (t6 = [client, seenBefore, trialState], $[14] = client, $[15] = seenBefore, $[16] = trialState, $[17] = t6) : t6 = $[17], useEffect(t5, t6);
  let t7;
  $[18] !== client || $[19] !== data?.showOnLoad || $[20] !== showOnLoad ? (t7 = (t82) => {
    const closeAndReOpen = t82 === void 0 ? !1 : t82;
    showOnLoad ? (setShowOnLoad(!1), setShowDialog(closeAndReOpen), data?.showOnLoad?.id && client.request({
      url: `/journey/trial/${data?.showOnLoad.id}`,
      method: "POST"
    })) : setShowDialog(_temp2$8);
  }, $[18] = client, $[19] = data?.showOnLoad, $[20] = showOnLoad, $[21] = t7) : t7 = $[21];
  const toggleShowContent = t7;
  let t8;
  $[22] !== data || $[23] !== showDialog || $[24] !== showOnLoad || $[25] !== toggleShowContent ? (t8 = {
    data,
    showDialog,
    toggleShowContent,
    showOnLoad
  }, $[22] = data, $[23] = showDialog, $[24] = showOnLoad, $[25] = toggleShowContent, $[26] = t8) : t8 = $[26];
  let t9;
  return $[27] !== children || $[28] !== t8 ? (t9 = /* @__PURE__ */ jsx(FreeTrialContext.Provider, { value: t8, children }), $[27] = children, $[28] = t8, $[29] = t9) : t9 = $[29], t9;
};
function _temp$p() {
}
function _temp2$8(p) {
  return !p;
}
const LOGO_MARK_SIZE = 25, RADIUS = 2, LogoMarkContainer = styled(Card).attrs({
  overflow: "hidden",
  radius: RADIUS
}).withConfig({
  displayName: "LogoMarkContainer",
  componentId: "sc-1blqnlt-0"
})`height:${LOGO_MARK_SIZE}px;width:${LOGO_MARK_SIZE}px;`, StyledCard$1 = styled(Card).withConfig({
  displayName: "StyledCard",
  componentId: "sc-1blqnlt-1"
})`border-radius:${({
  theme
}) => rem(theme.sanity.radius[RADIUS])};display:flex;outline:none;text-decoration:none;&:focus-visible{box-shadow:${({
  theme
}) => focusRingStyle$1({
  base: theme.sanity.color.base,
  focusRing: {
    ...theme.sanity.focusRing,
    offset: 1
  }
})};}`;
function HomeButton() {
  const $ = c(7), {
    activeWorkspace
  } = useActiveWorkspace();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    state: {}
  }, $[0] = t0) : t0 = $[0];
  const {
    href: rootHref,
    onClick: handleRootClick
  } = useStateLink(t0);
  let t1;
  $[1] !== activeWorkspace.icon ? (t1 = /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(LogoMarkContainer, { children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(WorkspacePreviewIcon, { icon: activeWorkspace.icon, size: "small" }) }) }) }), $[1] = activeWorkspace.icon, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== handleRootClick || $[4] !== rootHref || $[5] !== t1 ? (t2 = /* @__PURE__ */ jsx(StyledCard$1, { as: "a", href: rootHref, onClick: handleRootClick, children: t1 }), $[3] = handleRootClick, $[4] = rootHref, $[5] = t1, $[6] = t2) : t2 = $[6], t2;
}
function AppearanceMenu$1(t0) {
  const $ = c(4), {
    setScheme
  } = t0, {
    t
  } = useTranslation(), options = useColorSchemeOptions(setScheme, t);
  let t1;
  $[0] !== options ? (t1 = options.map(_temp$o), $[0] = options, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Card, { borderTop: !0, flex: "none", padding: 2, overflow: "auto", children: /* @__PURE__ */ jsx(Stack, { as: "ul", space: 1, children: t1 }) }), $[2] = t1, $[3] = t2) : t2 = $[3], t2;
}
function _temp$o(t0) {
  const {
    icon,
    label,
    name,
    onSelect,
    selected,
    title
  } = t0;
  return /* @__PURE__ */ jsx(Stack, { as: "li", children: /* @__PURE__ */ jsx(Button, { "aria-label": label, icon, iconRight: selected && /* @__PURE__ */ jsx(CheckmarkIcon, {}), justify: "flex-start", mode: "bleed", onClick: onSelect, selected, size: "large", text: title }) }, name);
}
function LocaleMenu$1() {
  return c(9), useLocale(), null;
}
function ManageMenu() {
  const $ = c(17), {
    projectId
  } = useWorkspace(), {
    t
  } = useTranslation(), envAwareWebsiteUrl = useEnvAwareSanityWebsiteUrl(), canInviteMembers = useCanInviteProjectMembers();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Stack, { as: "li", children: /* @__PURE__ */ jsx(FreeTrial, { type: "sidebar" }) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== t ? (t1 = t("user-menu.action.manage-project-aria-label"), $[1] = t, $[2] = t1) : t1 = $[2];
  const t2 = `${envAwareWebsiteUrl}/manage/project/${projectId}`;
  let t3;
  $[3] !== t ? (t3 = t("user-menu.action.manage-project"), $[3] = t, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t1 || $[6] !== t2 || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { as: "li", children: /* @__PURE__ */ jsx(Button, { "aria-label": t1, as: "a", href: t2, icon: CogIcon, justify: "flex-start", mode: "bleed", size: "large", target: "_blank", text: t3 }) }), $[5] = t1, $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== canInviteMembers || $[10] !== envAwareWebsiteUrl || $[11] !== projectId || $[12] !== t ? (t5 = canInviteMembers && /* @__PURE__ */ jsx(Stack, { as: "li", children: /* @__PURE__ */ jsx(Button, { "aria-label": t("user-menu.action.invite-members-aria-label"), as: "a", href: `${envAwareWebsiteUrl}/manage/project/${projectId}/members?invite=true`, icon: AddUserIcon, justify: "flex-start", mode: "bleed", size: "large", target: "_blank", text: t("user-menu.action.invite-members") }) }), $[9] = canInviteMembers, $[10] = envAwareWebsiteUrl, $[11] = projectId, $[12] = t, $[13] = t5) : t5 = $[13];
  let t6;
  return $[14] !== t4 || $[15] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { borderTop: !0, flex: "none", padding: 2, children: /* @__PURE__ */ jsxs(Stack, { as: "ul", space: 1, children: [
    t0,
    t4,
    t5
  ] }) }), $[14] = t4, $[15] = t5, $[16] = t6) : t6 = $[16], t6;
}
const ANIMATION_TRANSITION = {
  bounce: 0,
  damping: 20,
  mass: 0.5,
  stiffness: 200,
  type: "spring"
}, BACKDROP_VARIANTS = {
  open: {
    opacity: 1
  },
  closed: {
    opacity: 0
  }
}, INNER_CARD_VARIANTS = {
  open: {
    x: "0%"
  },
  closed: {
    x: "-100%"
  }
}, Root$8 = styled(Layer).withConfig({
  displayName: "Root",
  componentId: "sc-7l5ixj-0"
})`position:fixed;top:0;left:0;width:100%;height:100%;`, BackdropMotion = styled(motion.create(Card)).withConfig({
  displayName: "BackdropMotion",
  componentId: "sc-7l5ixj-1"
})`position:absolute;top:0;left:0;right:0;bottom:0;background:var(--card-shadow-penumbra-color);`, InnerCardMotion = styled(motion.create(Card)).withConfig({
  displayName: "InnerCardMotion",
  componentId: "sc-7l5ixj-2"
})`position:relative;pointer-events:all;flex-direction:column;height:100%;min-width:200px;max-width:280px;overflow:auto;`, NavDrawer = memo(function(props2) {
  const $ = c(23), {
    __internal_actions: actions,
    activeToolName,
    isOpen,
    onClose,
    tools
  } = props2, setScheme = useColorSchemeSetValue(), {
    auth,
    currentUser
  } = useWorkspace(), workspaces = useWorkspaces(), ToolMenu = useToolMenuComponent(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== onClose ? (t0 = (event) => {
    event.key === "Escape" && onClose();
  }, $[0] = onClose, $[1] = t0) : t0 = $[1];
  const handleKeyDown = t0;
  let t1;
  $[2] !== onClose ? (t1 = (action) => {
    action?.(), onClose();
  }, $[2] = onClose, $[3] = t1) : t1 = $[3];
  const handleActionClick = t1;
  let t2;
  $[4] !== actions || $[5] !== handleActionClick ? (t2 = actions?.filter(_temp$n)?.map((action_0) => {
    const {
      render: ActionComponent
    } = action_0;
    return ActionComponent ? /* @__PURE__ */ jsx(ActionComponent, {}, action_0.name) : /* @__PURE__ */ jsx(Button, { icon: action_0?.icon, justify: "flex-start", mode: "bleed", onClick: () => handleActionClick(action_0.onAction), selected: action_0.selected, size: "large", text: action_0.title, width: "fill" }, action_0.name);
  }), $[4] = actions, $[5] = handleActionClick, $[6] = t2) : t2 = $[6];
  const actionNodes = t2;
  let t3;
  $[7] !== ToolMenu || $[8] !== actionNodes || $[9] !== activeToolName || $[10] !== auth || $[11] !== currentUser?.email || $[12] !== currentUser?.name || $[13] !== handleKeyDown || $[14] !== isOpen || $[15] !== onClose || $[16] !== setScheme || $[17] !== t || $[18] !== tools || $[19] !== workspaces ? (t3 = isOpen && /* @__PURE__ */ jsx(FocusLock, { returnFocus: !0, children: /* @__PURE__ */ jsxs(Root$8, { onKeyDown: handleKeyDown, children: [
    /* @__PURE__ */ jsx(BackdropMotion, { animate: "open", "data-open": isOpen, exit: "closed", initial: "closed", onClick: onClose, transition: ANIMATION_TRANSITION, variants: BACKDROP_VARIANTS }),
    /* @__PURE__ */ jsxs(InnerCardMotion, { animate: "open", "data-open": isOpen, display: "flex", exit: "closed", height: "fill", initial: "closed", shadow: 1, transition: ANIMATION_TRANSITION, variants: INNER_CARD_VARIANTS, children: [
      /* @__PURE__ */ jsx(Card, { borderBottom: !0, children: /* @__PURE__ */ jsxs(Stack, { space: 3, padding: 3, children: [
        /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
          /* @__PURE__ */ jsx(Flex, { flex: 1, align: "center", paddingRight: 2, children: /* @__PURE__ */ jsx(CapabilityGate, { capability: "globalUserMenu", children: /* @__PURE__ */ jsxs(Flex, { flex: 1, align: "center", children: [
            /* @__PURE__ */ jsx(UserAvatar, { size: 1, user: "me" }),
            /* @__PURE__ */ jsx(Box, { flex: 1, marginLeft: 3, title: currentUser?.name || currentUser?.email, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: currentUser?.name || currentUser?.email }) })
          ] }) }) }),
          /* @__PURE__ */ jsx(Button, { icon: CloseIcon, mode: "bleed", onClick: onClose, tooltipProps: {
            content: t("user-menu.close-menu")
          } })
        ] }),
        workspaces.length > 1 && /* @__PURE__ */ jsxs(Flex, { flex: 1, gap: 1, children: [
          /* @__PURE__ */ jsx(HomeButton, {}),
          /* @__PURE__ */ jsx(WorkspaceMenuButton, {})
        ] })
      ] }) }),
      /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, justify: "space-between", overflow: "auto", children: [
        /* @__PURE__ */ jsx(Card, { flex: "none", padding: 2, children: /* @__PURE__ */ jsx(ToolMenu, { activeToolName, closeSidebar: onClose, context: "sidebar", isSidebarOpen: isOpen, tools }) }),
        /* @__PURE__ */ jsxs(Flex, { direction: "column", children: [
          actionNodes && /* @__PURE__ */ jsx(Card, { flex: "none", padding: 2, children: /* @__PURE__ */ jsx(Stack, { space: 1, children: actionNodes }) }),
          setScheme && /* @__PURE__ */ jsx(AppearanceMenu$1, { setScheme }),
          /* @__PURE__ */ jsx(LocaleMenu$1, {}),
          /* @__PURE__ */ jsx(ManageMenu, {})
        ] })
      ] }),
      auth.logout && /* @__PURE__ */ jsx(Card, { flex: "none", padding: 2, borderTop: !0, children: /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Button, { iconRight: LeaveIcon, justify: "flex-start", mode: "bleed", onClick: auth.logout, size: "large", text: t("user-menu.action.sign-out") }) }) })
    ] })
  ] }) }), $[7] = ToolMenu, $[8] = actionNodes, $[9] = activeToolName, $[10] = auth, $[11] = currentUser?.email, $[12] = currentUser?.name, $[13] = handleKeyDown, $[14] = isOpen, $[15] = onClose, $[16] = setScheme, $[17] = t, $[18] = tools, $[19] = workspaces, $[20] = t3) : t3 = $[20];
  let t4;
  return $[21] !== t3 ? (t4 = /* @__PURE__ */ jsx(AnimatePresence, { children: t3 }), $[21] = t3, $[22] = t4) : t4 = $[22], t4;
});
function _temp$n(v) {
  return v.location === "sidebar";
}
function isQueryMatch(query, option) {
  const lowercaseTitle = option.title.toLowerCase();
  return query.trim().toLowerCase().split(/[\s\-_]+/).every((word) => lowercaseTitle.includes(word));
}
function sortResultRelevance(query, a, b) {
  const titleA = a.title.toLowerCase(), titleB = b.title.toLowerCase(), lowercaseQuery = query.trim().toLowerCase();
  return titleA.startsWith(lowercaseQuery) && !titleB.startsWith(lowercaseQuery) ? -1 : titleB.startsWith(lowercaseQuery) && !titleA.startsWith(lowercaseQuery) ? 1 : titleA.includes(lowercaseQuery) && !titleB.includes(lowercaseQuery) ? -1 : titleB.includes(lowercaseQuery) && !titleA.includes(lowercaseQuery) ? 1 : 0;
}
function filterOptions(options, query, getI18nText) {
  return options.map((option) => ({
    ...option,
    title: getI18nText({
      ...option,
      title: option?.title || option.id
    }).title
  })).sort((a, b) => a.title.localeCompare(b.title)).filter((option) => isQueryMatch(query, option)).sort((a, b) => sortResultRelevance(query, a, b));
}
const StyledPopover$1 = /* @__PURE__ */ styled(Popover).withConfig({
  displayName: "StyledPopover",
  componentId: "sc-1oe0xko-0"
})(() => css`
    [data-ui='Popover__wrapper'] {
      width: 320px;
      display: flex;
      flex-direction: column;
      border-radius: ${({
  theme
}) => theme.sanity.radius[3]}px;
      position: relative;
      overflow: hidden;
      overflow: clip;
    }
  `), StyledDialog = /* @__PURE__ */ styled(Dialog$1).withConfig({
  displayName: "StyledDialog",
  componentId: "sc-1oe0xko-1"
})(() => css`
    [data-ui='DialogCard'] {
      justify-content: flex-start;
    }
  `), RootFlex = styled(Flex).withConfig({
  displayName: "RootFlex",
  componentId: "sc-1oe0xko-2"
})``, PopoverHeaderCard = styled(Card).withConfig({
  displayName: "PopoverHeaderCard",
  componentId: "sc-1oe0xko-3"
})`min-height:max-content;`, DialogHeaderCard = styled(Card).withConfig({
  displayName: "DialogHeaderCard",
  componentId: "sc-1oe0xko-4"
})`min-height:max-content;`, PopoverListFlex = /* @__PURE__ */ styled(Flex).withConfig({
  displayName: "PopoverListFlex",
  componentId: "sc-1oe0xko-5"
})((props2) => {
  const {
    $maxDisplayedItems,
    $itemHeight
  } = props2;
  return css`
    --item-height: ${$itemHeight}px;
    --max-items: ${$maxDisplayedItems};
    --list-padding: 0.5rem;

    position: relative;
    max-height: calc(var(--item-height) * var(--max-items) + var(--list-padding));
    min-height: calc((var(--item-height) * 1));
  `;
}), INLINE_PREVIEW_HEIGHT = 33;
function NewDocumentListOption(props2) {
  const $ = c(28), {
    option,
    currentUser,
    onClick: onClick2,
    preview
  } = props2, {
    selectedReleaseId
  } = usePerspective();
  let t0;
  $[0] !== option.schemaType || $[1] !== option.templateId || $[2] !== selectedReleaseId ? (t0 = {
    template: option.templateId,
    type: option.schemaType,
    version: selectedReleaseId
  }, $[0] = option.schemaType, $[1] = option.templateId, $[2] = selectedReleaseId, $[3] = t0) : t0 = $[3];
  const params = t0;
  let t1;
  $[4] !== params ? (t1 = {
    intent: "create",
    params
  }, $[4] = params, $[5] = t1) : t1 = $[5];
  const {
    onClick: onIntentClick,
    href
  } = useIntentLink(t1);
  let t2;
  $[6] !== onClick2 || $[7] !== onIntentClick || $[8] !== option ? (t2 = (event) => {
    onIntentClick(event), onClick2(option);
  }, $[6] = onClick2, $[7] = onIntentClick, $[8] = option, $[9] = t2) : t2 = $[9];
  const handleDocumentClick = t2, {
    title
  } = useI18nText(option);
  let t3;
  $[10] !== currentUser ? (t3 = /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: "create-document" }), $[10] = currentUser, $[11] = t3) : t3 = $[11];
  const t4 = option.hasPermission ? "a" : "button", t5 = `create-new-${option.templateId}`, t6 = !option.hasPermission, t7 = preview === "inline" ? 3 : 4, t8 = preview === "inline" ? 1 : void 0;
  let t9;
  $[12] !== t8 || $[13] !== title ? (t9 = /* @__PURE__ */ jsx(Text$1, { size: t8, children: title }), $[12] = t8, $[13] = title, $[14] = t9) : t9 = $[14];
  let t10;
  $[15] !== handleDocumentClick || $[16] !== href || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t9 ? (t10 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Card, { as: t4, "data-testid": t5, disabled: t6, href, marginBottom: 1, onClick: handleDocumentClick, padding: t7, radius: 2, children: t9 }) }), $[15] = handleDocumentClick, $[16] = href, $[17] = t4, $[18] = t5, $[19] = t6, $[20] = t7, $[21] = t9, $[22] = t10) : t10 = $[22];
  let t11;
  return $[23] !== option.hasPermission || $[24] !== option.id || $[25] !== t10 || $[26] !== t3 ? (t11 = /* @__PURE__ */ jsx(Tooltip, { disabled: option.hasPermission, portal: !0, content: t3, children: t10 }, option.id), $[23] = option.hasPermission, $[24] = option.id, $[25] = t10, $[26] = t3, $[27] = t11) : t11 = $[27], t11;
}
const ContentFlex = styled(Flex).withConfig({
  displayName: "ContentFlex",
  componentId: "sc-1jduvp1-0"
})`min-height:100px;`;
function NewDocumentList(props2) {
  const $ = c(27), {
    currentUser,
    loading,
    onDocumentClick,
    options,
    preview,
    searchQuery,
    textInputElement
  } = props2, {
    t
  } = useTranslation(), hasOptions = options.length > 0 && !loading;
  let t0;
  $[0] !== onDocumentClick ? (t0 = () => {
    onDocumentClick();
  }, $[0] = onDocumentClick, $[1] = t0) : t0 = $[1];
  const handleDocumentClick = t0;
  let t1;
  $[2] !== options ? (t1 = (index) => options[index]?.hasPermission ?? !0, $[2] = options, $[3] = t1) : t1 = $[3];
  const getItemDisabled = t1;
  let t2;
  $[4] !== currentUser || $[5] !== handleDocumentClick || $[6] !== preview ? (t2 = (item) => /* @__PURE__ */ jsx(NewDocumentListOption, { currentUser, onClick: handleDocumentClick, option: item, preview }, item.id), $[4] = currentUser, $[5] = handleDocumentClick, $[6] = preview, $[7] = t2) : t2 = $[7];
  const renderItem2 = t2;
  if (loading) {
    let t32;
    return $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t32 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }), $[8] = t32) : t32 = $[8], t32;
  }
  if (!hasOptions && searchQuery) {
    let t32;
    $[9] !== searchQuery ? (t32 = {
      searchQuery
    }, $[9] = searchQuery, $[10] = t32) : t32 = $[10];
    let t42;
    return $[11] !== t || $[12] !== t32 ? (t42 = /* @__PURE__ */ jsx(ContentFlex, { align: "center", flex: 1, height: "fill", justify: "center", padding: 4, sizing: "border", children: /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "new-document.no-results", values: t32 }) }) }), $[11] = t, $[12] = t32, $[13] = t42) : t42 = $[13], t42;
  }
  if (!hasOptions) {
    let t32;
    $[14] !== t ? (t32 = t("new-document.no-document-types-found"), $[14] = t, $[15] = t32) : t32 = $[15];
    let t42;
    return $[16] !== t32 ? (t42 = /* @__PURE__ */ jsx(ContentFlex, { align: "center", flex: 1, height: "fill", justify: "center", padding: 4, sizing: "border", children: /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: t32 }) }), $[16] = t32, $[17] = t42) : t42 = $[17], t42;
  }
  let t3;
  $[18] !== t ? (t3 = t("new-document.new-document"), $[18] = t, $[19] = t3) : t3 = $[19];
  const t4 = preview === "inline" ? 1 : 2;
  let t5;
  return $[20] !== getItemDisabled || $[21] !== options || $[22] !== renderItem2 || $[23] !== t3 || $[24] !== t4 || $[25] !== textInputElement ? (t5 = /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t3, autoFocus: supportsTouch ? void 0 : "input", getItemDisabled, inputElement: textInputElement, itemHeight: INLINE_PREVIEW_HEIGHT, items: options, overscan: 5, padding: t4, paddingBottom: 0, renderItem: renderItem2 }), $[20] = getItemDisabled, $[21] = options, $[22] = renderItem2, $[23] = t3, $[24] = t4, $[25] = textInputElement, $[26] = t5) : t5 = $[26], t5;
}
const MAX_DISPLAYED_ITEMS = 10;
function NewDocumentButton(props2) {
  const $ = c(90), {
    canCreateDocument,
    modal: t0,
    loading,
    options
  } = props2, modal = t0 === void 0 ? "popover" : t0, [open, setOpen] = useState(!1), [searchQuery, setSearchQuery] = useState(""), popoverRef = useRef(null), dialogRef = useRef(null), [buttonElement, setButtonElement] = useState(null), [searchInputElement, setSearchInputElement] = useState(null), {
    t
  } = useTranslation(), getI18nText = useGetI18nText(options), scheme = useColorSchemeValue(), currentUser = useCurrentUser(), schema2 = useSchema(), hasNewDocumentOptions = options.length > 0, disabled = !canCreateDocument || !hasNewDocumentOptions;
  let t1;
  $[0] !== t ? (t1 = t("new-document.filter-placeholder"), $[0] = t, $[1] = t1) : t1 = $[1];
  const placeholder = t1;
  let t2;
  $[2] !== t ? (t2 = t("new-document.title"), $[2] = t, $[3] = t2) : t2 = $[3];
  const title = t2;
  let t3;
  $[4] !== t ? (t3 = t("new-document.open-dialog-aria-label"), $[4] = t, $[5] = t3) : t3 = $[5];
  const openDialogAriaLabel = t3;
  let t4;
  if ($[6] !== options || $[7] !== schema2) {
    let t52;
    $[9] !== schema2 ? (t52 = (option) => {
      const optionSchema = schema2.get(option.schemaType);
      return optionSchema && !isDeprecatedSchemaType(optionSchema);
    }, $[9] = schema2, $[10] = t52) : t52 = $[10], t4 = options.filter(t52), $[6] = options, $[7] = schema2, $[8] = t4;
  } else
    t4 = $[8];
  const validOptions = t4;
  let t5;
  $[11] !== getI18nText || $[12] !== searchQuery || $[13] !== validOptions ? (t5 = filterOptions(validOptions, searchQuery, getI18nText), $[11] = getI18nText, $[12] = searchQuery, $[13] = validOptions, $[14] = t5) : t5 = $[14];
  const filteredOptions = t5;
  let t6;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = (event) => {
    setSearchQuery(event.currentTarget.value);
  }, $[15] = t6) : t6 = $[15];
  const handleSearchChange = t6;
  let t7;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = () => setOpen(_temp$m), $[16] = t7) : t7 = $[16];
  const handleToggleOpen = t7;
  let t8;
  $[17] !== buttonElement ? (t8 = () => {
    setOpen(!1), setSearchQuery(""), buttonElement?.focus();
  }, $[17] = buttonElement, $[18] = t8) : t8 = $[18];
  const handleClose = t8;
  let t9;
  $[19] !== open ? (t9 = (e) => {
    e.key === "ArrowDown" && !open && setOpen(!0);
  }, $[19] = open, $[20] = t9) : t9 = $[20];
  const handleOpenButtonKeyDown = t9;
  let t10;
  $[21] !== handleClose || $[22] !== open ? (t10 = (e_0) => {
    (e_0.key === "Escape" || e_0.key === "Tab") && open && handleClose();
  }, $[21] = handleClose, $[22] = open, $[23] = t10) : t10 = $[23];
  const handlePopoverKeyDown = t10;
  let t11;
  $[24] !== buttonElement ? (t11 = () => [buttonElement, dialogRef.current, popoverRef.current], $[24] = buttonElement, $[25] = t11) : t11 = $[25], useClickOutsideEvent(open && handleClose, t11);
  const t12 = modal === "popover" ? "inline" : "default";
  let t13;
  $[26] !== currentUser || $[27] !== filteredOptions || $[28] !== loading || $[29] !== searchInputElement || $[30] !== searchQuery || $[31] !== t12 ? (t13 = {
    currentUser,
    loading,
    onDocumentClick: handleToggleOpen,
    options: filteredOptions,
    searchQuery,
    preview: t12,
    textInputElement: searchInputElement
  }, $[26] = currentUser, $[27] = filteredOptions, $[28] = loading, $[29] = searchInputElement, $[30] = searchQuery, $[31] = t12, $[32] = t13) : t13 = $[32];
  const sharedListProps = t13;
  let t14;
  $[33] !== loading || $[34] !== placeholder || $[35] !== searchQuery ? (t14 = {
    __unstable_disableFocusRing: !0,
    border: !1,
    "data-testid": "new-document-button-search-input",
    defaultValue: searchQuery,
    disabled: loading,
    icon: SearchIcon,
    onChange: handleSearchChange,
    placeholder,
    ref: setSearchInputElement
  }, $[33] = loading, $[34] = placeholder, $[35] = searchQuery, $[36] = t14) : t14 = $[36];
  const sharedTextInputProps = t14, t15 = disabled || loading;
  let t16;
  $[37] !== open || $[38] !== openDialogAriaLabel || $[39] !== t15 ? (t16 = {
    "aria-label": openDialogAriaLabel,
    "data-testid": "new-document-button",
    disabled: t15,
    icon: AddIcon,
    text: "",
    mode: "bleed",
    onClick: handleToggleOpen,
    ref: setButtonElement,
    selected: open
  }, $[37] = open, $[38] = openDialogAriaLabel, $[39] = t15, $[40] = t16) : t16 = $[40];
  const sharedOpenButtonProps = t16;
  let t17;
  bb0: {
    if (!hasNewDocumentOptions) {
      let t183;
      $[41] !== t ? (t183 = t("new-document.no-document-types-label"), $[41] = t, $[42] = t183) : t183 = $[42];
      let t192;
      $[43] !== t183 ? (t192 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t183 }), $[43] = t183, $[44] = t192) : t192 = $[44], t17 = t192;
      break bb0;
    }
    if (canCreateDocument) {
      let t183;
      $[45] !== t ? (t183 = t("new-document.create-new-document-label"), $[45] = t, $[46] = t183) : t183 = $[46];
      let t192;
      $[47] !== t183 ? (t192 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t183 }), $[47] = t183, $[48] = t192) : t192 = $[48], t17 = t192;
      break bb0;
    }
    let t182;
    $[49] !== currentUser ? (t182 = /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: "create-any-document" }), $[49] = currentUser, $[50] = t182) : t182 = $[50], t17 = t182;
  }
  const tooltipContent = t17, t18 = loading || open;
  let t19;
  $[51] !== scheme || $[52] !== t18 || $[53] !== tooltipContent ? (t19 = {
    content: tooltipContent,
    disabled: t18,
    scheme
  }, $[51] = scheme, $[52] = t18, $[53] = tooltipContent, $[54] = t19) : t19 = $[54];
  const sharedTooltipProps = t19;
  if (modal === "dialog") {
    let t202;
    $[55] !== sharedOpenButtonProps ? (t202 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Button, { ...sharedOpenButtonProps }) }), $[55] = sharedOpenButtonProps, $[56] = t202) : t202 = $[56];
    let t212;
    $[57] !== sharedTooltipProps || $[58] !== t202 ? (t212 = /* @__PURE__ */ jsx(Tooltip, { ...sharedTooltipProps, children: t202 }), $[57] = sharedTooltipProps, $[58] = t202, $[59] = t212) : t212 = $[59];
    let t222;
    $[60] !== handleClose || $[61] !== open || $[62] !== scheme || $[63] !== sharedListProps || $[64] !== sharedTextInputProps || $[65] !== title ? (t222 = open && /* @__PURE__ */ jsx(StyledDialog, { header: title, id: "create-new-document-dialog", onClickOutside: handleClose, onClose: handleClose, ref: dialogRef, scheme, width: 1, children: /* @__PURE__ */ jsxs(RootFlex, { direction: "column", flex: 1, height: "fill", children: [
      /* @__PURE__ */ jsx(DialogHeaderCard, { padding: 2, borderBottom: !0, children: /* @__PURE__ */ jsx(TextInput$1, { "data-testid": "new-document-button-search-input", ...sharedTextInputProps }) }),
      /* @__PURE__ */ jsx(Flex, { direction: "column", overflow: "hidden", children: /* @__PURE__ */ jsx(NewDocumentList, { ...sharedListProps }) })
    ] }) }), $[60] = handleClose, $[61] = open, $[62] = scheme, $[63] = sharedListProps, $[64] = sharedTextInputProps, $[65] = title, $[66] = t222) : t222 = $[66];
    let t232;
    return $[67] !== t212 || $[68] !== t222 ? (t232 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
      t212,
      t222
    ] }), $[67] = t212, $[68] = t222, $[69] = t232) : t232 = $[69], t232;
  }
  let t20;
  $[70] !== sharedTextInputProps ? (t20 = /* @__PURE__ */ jsx(PopoverHeaderCard, { sizing: "border", children: /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Card, { borderBottom: !0, padding: 1, children: /* @__PURE__ */ jsx(TextInput$1, { ...sharedTextInputProps, fontSize: 1, radius: 1 }) }) }) }), $[70] = sharedTextInputProps, $[71] = t20) : t20 = $[71];
  let t21;
  $[72] !== sharedListProps ? (t21 = /* @__PURE__ */ jsx(PopoverListFlex, { $itemHeight: INLINE_PREVIEW_HEIGHT, $maxDisplayedItems: MAX_DISPLAYED_ITEMS, direction: "column", overflow: "hidden", children: /* @__PURE__ */ jsx(NewDocumentList, { ...sharedListProps }) }), $[72] = sharedListProps, $[73] = t21) : t21 = $[73];
  let t22;
  $[74] !== t20 || $[75] !== t21 ? (t22 = /* @__PURE__ */ jsxs(RootFlex, { direction: "column", flex: 1, forwardedAs: FocusLock, height: "fill", returnFocus: !0, children: [
    t20,
    t21
  ] }), $[74] = t20, $[75] = t21, $[76] = t22) : t22 = $[76];
  let t23;
  $[77] !== handleOpenButtonKeyDown || $[78] !== open || $[79] !== sharedOpenButtonProps ? (t23 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Button, { ...sharedOpenButtonProps, "aria-expanded": open, "aria-haspopup": "true", onKeyDown: handleOpenButtonKeyDown }) }), $[77] = handleOpenButtonKeyDown, $[78] = open, $[79] = sharedOpenButtonProps, $[80] = t23) : t23 = $[80];
  let t24;
  $[81] !== sharedTooltipProps || $[82] !== t23 ? (t24 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Tooltip, { ...sharedTooltipProps, children: t23 }) }), $[81] = sharedTooltipProps, $[82] = t23, $[83] = t24) : t24 = $[83];
  let t25;
  return $[84] !== handlePopoverKeyDown || $[85] !== open || $[86] !== scheme || $[87] !== t22 || $[88] !== t24 ? (t25 = /* @__PURE__ */ jsx(StyledPopover$1, { constrainSize: !0, onKeyDown: handlePopoverKeyDown, open, tone: "default", portal: !0, radius: 3, ref: popoverRef, scheme, content: t22, children: t24 }), $[84] = handlePopoverKeyDown, $[85] = open, $[86] = scheme, $[87] = t22, $[88] = t24, $[89] = t25) : t25 = $[89], t25;
}
function _temp$m(v) {
  return !v;
}
function useNewDocumentOptions() {
  const $ = c(14), {
    __internal: t0
  } = useSource(), {
    staticInitialValueTemplateItems
  } = t0;
  let t1;
  $[0] !== staticInitialValueTemplateItems ? (t1 = {
    templateItems: staticInitialValueTemplateItems
  }, $[0] = staticInitialValueTemplateItems, $[1] = t1) : t1 = $[1];
  const [permissions, loading] = useTemplatePermissions(t1);
  let t2;
  $[2] !== permissions || $[3] !== staticInitialValueTemplateItems ? (t2 = permissions?.some((p) => staticInitialValueTemplateItems.some((t) => t.id === p.id)) || !1, $[2] = permissions, $[3] = staticInitialValueTemplateItems, $[4] = t2) : t2 = $[4];
  const canCreateDocument = t2;
  let t3;
  if ($[5] !== permissions || $[6] !== staticInitialValueTemplateItems) {
    let t42;
    $[8] !== permissions ? (t42 = (item) => ({
      ...item,
      title: item?.title || item.id,
      hasPermission: permissions?.find((p_0) => p_0.id === item.id)?.granted || !1
    }), $[8] = permissions, $[9] = t42) : t42 = $[9], t3 = staticInitialValueTemplateItems.map(t42), $[5] = permissions, $[6] = staticInitialValueTemplateItems, $[7] = t3;
  } else
    t3 = $[7];
  const optionsWithPermissions = t3;
  let t4;
  return $[10] !== canCreateDocument || $[11] !== loading || $[12] !== optionsWithPermissions ? (t4 = {
    canCreateDocument,
    loading,
    options: optionsWithPermissions
  }, $[10] = canCreateDocument, $[11] = loading, $[12] = optionsWithPermissions, $[13] = t4) : t4 = $[13], t4;
}
const PresenceMenuItem = memo(function(props2) {
  const $ = c(31), {
    locations,
    user,
    focused,
    onFocus
  } = props2, [menuItemElement, setMenuItemElement] = useState(null), {
    t
  } = useTranslation();
  let t0, t1;
  $[0] !== focused || $[1] !== menuItemElement ? (t0 = () => {
    focused && menuItemElement && (menuItemElement.focus(), menuItemElement.setAttribute("data-selected", "")), focused || menuItemElement?.removeAttribute("data-selected");
  }, t1 = [menuItemElement, focused], $[0] = focused, $[1] = menuItemElement, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1);
  let t2;
  $[4] !== onFocus || $[5] !== user.id ? (t2 = () => {
    onFocus(user.id);
  }, $[4] = onFocus, $[5] = user.id, $[6] = t2) : t2 = $[6];
  const handleFocus = t2;
  let hasLink, t3;
  if ($[7] !== handleFocus || $[8] !== locations || $[9] !== user) {
    t3 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    bb0: {
      const lastActiveLocation = orderBy(locations || [], ["lastActiveAt"], ["desc"]).find(_temp$l);
      if (hasLink = !!lastActiveLocation?.documentId, lastActiveLocation) {
        const perspective = getVersionFromId(lastActiveLocation.documentId), t42 = {
          id: getPublishedId(lastActiveLocation.documentId),
          path: PathUtils.toString(lastActiveLocation.path)
        }, t52 = perspective ? [["perspective", perspective]] : [];
        let t62;
        $[12] !== user ? (t62 = /* @__PURE__ */ jsx(UserAvatar, { size: 1, user }), $[12] = user, $[13] = t62) : t62 = $[13];
        let t72;
        $[14] !== handleFocus || $[15] !== t42 || $[16] !== t52 || $[17] !== t62 || $[18] !== user.displayName ? (t72 = /* @__PURE__ */ jsx(MenuItem, { as: IntentLink, intent: "edit", params: t42, searchParams: t52, "data-as": "a", onFocus: handleFocus, preview: t62, ref: setMenuItemElement, text: user.displayName }), $[14] = handleFocus, $[15] = t42, $[16] = t52, $[17] = t62, $[18] = user.displayName, $[19] = t72) : t72 = $[19], t3 = t72;
        break bb0;
      }
    }
    $[7] = handleFocus, $[8] = locations, $[9] = user, $[10] = hasLink, $[11] = t3;
  } else
    hasLink = $[10], t3 = $[11];
  if (t3 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return t3;
  const t4 = !hasLink;
  let t5;
  $[20] !== hasLink || $[21] !== t ? (t5 = hasLink ? void 0 : {
    content: t("presence.not-in-a-document"),
    placement: "left"
  }, $[20] = hasLink, $[21] = t, $[22] = t5) : t5 = $[22];
  let t6;
  $[23] !== user ? (t6 = /* @__PURE__ */ jsx(UserAvatar, { size: 1, user }), $[23] = user, $[24] = t6) : t6 = $[24];
  let t7;
  return $[25] !== handleFocus || $[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== user.displayName ? (t7 = /* @__PURE__ */ jsx(MenuItem, { as: "div", disabled: t4, tooltipProps: t5, "data-as": "a", onFocus: handleFocus, preview: t6, ref: setMenuItemElement, text: user.displayName }), $[25] = handleFocus, $[26] = t4, $[27] = t5, $[28] = t6, $[29] = user.displayName, $[30] = t7) : t7 = $[30], t7;
});
function _temp$l(location2) {
  return location2.documentId;
}
const StyledMenu$2 = styled(Menu).withConfig({
  displayName: "StyledMenu",
  componentId: "sc-2q9fcp-0"
})`max-width:260px;`, FooterStack = styled(Stack).withConfig({
  displayName: "FooterStack",
  componentId: "sc-2q9fcp-1"
})`position:sticky;bottom:0;background-color:var(--card-bg-color);`;
function PresenceMenu() {
  const $ = c(42), presence = useGlobalPresence(), {
    projectId
  } = useWorkspace(), scheme = useColorSchemeValue(), {
    t
  } = useTranslation(), hasPresence = presence.length > 0, [open, setOpen] = useState(!1);
  let t0;
  $[0] !== open ? (t0 = {
    enabled: open
  }, $[0] = open, $[1] = t0) : t0 = $[1];
  const canInviteMembers = useCanInviteProjectMembers(t0), [focusedId, setFocusedId] = useState();
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (id2) => {
    setFocusedId(id2);
  }, $[2] = t1) : t1 = $[2];
  const handleItemFocus = t1;
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setFocusedId("");
  }, $[3] = t2) : t2 = $[3];
  const handleClearFocusedItem = t2;
  let t3;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setFocusedId("");
  }, $[4] = t3) : t3 = $[4];
  const handleClose = t3;
  let t4;
  $[5] !== t ? (t4 = t("presence.aria-label"), $[5] = t, $[6] = t4) : t4 = $[6];
  const t5 = hasPresence ? "positive" : void 0;
  let t6;
  $[7] !== t ? (t6 = t("presence.tooltip-content"), $[7] = t, $[8] = t6) : t6 = $[8];
  let t7;
  $[9] !== t6 ? (t7 = {
    content: t6
  }, $[9] = t6, $[10] = t7) : t7 = $[10];
  let t8;
  $[11] !== t4 || $[12] !== t5 || $[13] !== t7 ? (t8 = /* @__PURE__ */ jsx(StatusButton, { icon: UsersIcon, "aria-label": t4, mode: "bleed", tone: t5, tooltipProps: t7 }), $[11] = t4, $[12] = t5, $[13] = t7, $[14] = t8) : t8 = $[14];
  const button = t8;
  let t9;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = ["bottom"], $[15] = t9) : t9 = $[15];
  let t10;
  $[16] !== scheme ? (t10 = {
    constrainSize: !0,
    fallbackPlacements: t9,
    placement: "bottom",
    portal: !0,
    scheme,
    tone: "default"
  }, $[16] = scheme, $[17] = t10) : t10 = $[17];
  const popoverProps = t10, envAwareWebsiteUrl = useEnvAwareSanityWebsiteUrl();
  let t11;
  $[18] !== t ? (t11 = t("presence.aria-label"), $[18] = t, $[19] = t11) : t11 = $[19];
  let t12;
  $[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = () => setOpen(!0), $[20] = t12) : t12 = $[20];
  let t13;
  $[21] !== focusedId || $[22] !== hasPresence || $[23] !== presence ? (t13 = hasPresence && presence.map((item) => /* @__PURE__ */ jsx(PresenceMenuItem, { focused: focusedId === item.user.id, onFocus: handleItemFocus, locations: item.locations, user: item.user }, item.user.id)), $[21] = focusedId, $[22] = hasPresence, $[23] = presence, $[24] = t13) : t13 = $[24];
  let t14;
  $[25] !== hasPresence || $[26] !== t ? (t14 = !hasPresence && /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: t("presence.no-one-else-title") }),
    /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t("presence.no-one-else-description") })
  ] }) }), $[25] = hasPresence, $[26] = t, $[27] = t14) : t14 = $[27];
  let t15;
  $[28] !== canInviteMembers || $[29] !== envAwareWebsiteUrl || $[30] !== projectId || $[31] !== t ? (t15 = canInviteMembers && /* @__PURE__ */ jsxs(FooterStack, { space: 1, children: [
    /* @__PURE__ */ jsx(MenuDivider, {}),
    /* @__PURE__ */ jsx(MenuItem, { as: "a", href: `${envAwareWebsiteUrl}/manage/project/${projectId}/members?invite=true`, icon: AddUserIcon, onFocus: handleClearFocusedItem, rel: "noopener noreferrer", target: "_blank", text: t("presence.action.manage-members") })
  ] }), $[28] = canInviteMembers, $[29] = envAwareWebsiteUrl, $[30] = projectId, $[31] = t, $[32] = t15) : t15 = $[32];
  let t16;
  $[33] !== t13 || $[34] !== t14 || $[35] !== t15 ? (t16 = /* @__PURE__ */ jsxs(StyledMenu$2, { children: [
    t13,
    t14,
    t15
  ] }), $[33] = t13, $[34] = t14, $[35] = t15, $[36] = t16) : t16 = $[36];
  let t17;
  return $[37] !== button || $[38] !== popoverProps || $[39] !== t11 || $[40] !== t16 ? (t17 = /* @__PURE__ */ jsx(MenuButton, { button, "aria-label": t11, id: "global-presence-menu", onOpen: t12, menu: t16, onClose: handleClose, popover: popoverProps }), $[37] = button, $[38] = popoverProps, $[39] = t11, $[40] = t16, $[41] = t17) : t17 = $[41], t17;
}
function useLiveUserApplication() {
  return useContext(LiveUserApplicationContext);
}
function usePackageVersionStatus() {
  return useContext(PackageVersionInfoContext);
}
function getHelpResources(client, locale) {
  return client.withConfig({
    apiVersion: "1"
  }).observable.request({
    url: "/help",
    /*
      query and tag is used by analytics for tracking.
      Builds to: `{m: ['sanity@3.0.2']}' and serializes to: `?m=sanity@3.0.2`.
      Final format will be e.g. https://api.sanity.io/v1/help?tag=sanity.studio.module.version-check&m=sanity%403.0.2
      */
    query: {
      m: [`sanity@${SANITY_VERSION}`],
      locale
    },
    tag: "module.version-check",
    json: !0
  });
}
function useGetHelpResources() {
  const $ = c(4);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "1"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0), locale = useCurrentLocale().id;
  let t1;
  return $[1] !== client || $[2] !== locale ? (t1 = getHelpResources(client, locale), $[1] = client, $[2] = locale, $[3] = t1) : t1 = $[3], useLoadable(t1);
}
const ProductAnnouncementCardSeen = defineEvent({
  name: "Product Announcement Card Seen",
  version: 1,
  description: "User viewed the product announcement card"
}), ProductAnnouncementCardClicked = defineEvent({
  name: "Product Announcement Card Clicked",
  version: 1,
  description: "User clicked the product announcement card"
}), ProductAnnouncementCardDismissed = defineEvent({
  name: "Product Announcement Card Dismissed",
  version: 1,
  description: "User dismissed the product announcement card"
}), ProductAnnouncementViewed = defineEvent({
  name: "Product Announcement Viewed",
  version: 1,
  description: "User viewed the product announcement"
}), ProductAnnouncementLinkClicked = defineEvent({
  name: "Product Announcement Link Clicked",
  version: 1,
  description: "User clicked the link in the product announcement "
}), ProductAnnouncementModalDismissed = defineEvent({
  name: "Product Announcement Dismissed",
  version: 1,
  description: "User dismissed the product announcement modal "
}), WhatsNewHelpMenuItemClicked = defineEvent({
  name: "Whats New Help Menu Item Clicked",
  version: 1,
  description: 'User clicked the "Whats new" help menu item'
});
function useStudioAnnouncements() {
  const $ = c(1), context = useContext(StudioAnnouncementContext);
  if (!context) {
    let t0;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
      studioAnnouncements: [],
      unseenAnnouncements: [],
      onDialogOpen: _temp$k
    }, $[0] = t0) : t0 = $[0], t0;
  }
  return context;
}
function _temp$k() {
}
function StudioAnnouncementsMenuItem(t0) {
  const $ = c(9), {
    text
  } = t0, {
    onDialogOpen,
    studioAnnouncements
  } = useStudioAnnouncements(), telemetry = useTelemetry();
  let t1;
  $[0] !== onDialogOpen || $[1] !== studioAnnouncements[0]?._id || $[2] !== studioAnnouncements[0]?.name || $[3] !== studioAnnouncements[0]?.title || $[4] !== telemetry ? (t1 = () => {
    onDialogOpen("help_menu"), telemetry.log(WhatsNewHelpMenuItemClicked, {
      source: "studio",
      announcement_id: studioAnnouncements[0]?._id,
      announcement_title: studioAnnouncements[0]?.title,
      announcement_internal_name: studioAnnouncements[0]?.name,
      studio_version: SANITY_VERSION
    });
  }, $[0] = onDialogOpen, $[1] = studioAnnouncements[0]?._id, $[2] = studioAnnouncements[0]?.name, $[3] = studioAnnouncements[0]?.title, $[4] = telemetry, $[5] = t1) : t1 = $[5];
  const handleOpenDialog = t1;
  if (studioAnnouncements.length === 0)
    return null;
  let t2;
  return $[6] !== handleOpenDialog || $[7] !== text ? (t2 = /* @__PURE__ */ jsx(MenuItem, { tone: "default", text, onClick: handleOpenDialog }), $[6] = handleOpenDialog, $[7] = text, $[8] = t2) : t2 = $[8], t2;
}
const DEPLOY_STUDIO_PERMISSION = "sanity.project", DEPLOY_STUDIO_GRANT = "deployStudio";
function useCanDeployStudio(t0) {
  const $ = c(5), enabled = t0 === void 0 ? !0 : t0, projectStore = useProjectStore();
  let t1;
  $[0] !== projectStore ? (t1 = projectStore.getGrants().pipe(map$1(_temp3$3)), $[0] = projectStore, $[1] = t1) : t1 = $[1];
  const result$ = t1;
  let t2;
  return $[2] !== enabled || $[3] !== result$ ? (t2 = enabled ? result$ : of(!1), $[2] = enabled, $[3] = result$, $[4] = t2) : t2 = $[4], useObservable(t2, !1);
}
function _temp3$3(grants) {
  return !!grants[DEPLOY_STUDIO_PERMISSION]?.some(_temp2$7);
}
function _temp2$7(p) {
  return p.grants.some(_temp$j);
}
function _temp$j(g) {
  return g.name === DEPLOY_STUDIO_GRANT;
}
function reload$1() {
  document.location.reload();
}
function ResourcesMenuItems(t0) {
  const $ = c(35), {
    error,
    isLoading,
    value,
    latestTaggedVersion,
    currentVersion,
    onOpenStudioVersionDialog,
    newAutoUpdateVersion
  } = t0, sections = value?.resources?.sectionArray, {
    t
  } = useTranslation();
  if (isLoading) {
    let t14;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t14 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }), $[0] = t14) : t14 = $[0], t14;
  }
  let t1;
  $[1] !== t ? (t1 = t("help-resources.action.join-our-community"), $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(MenuItem, { as: "a", text: t1, href: "https://www.sanity.io/exchange/community", target: "_blank" }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("help-resources.action.help-and-support"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(MenuItem, { as: "a", text: t3, href: "https://www.sanity.io/contact/support", target: "_blank" }), $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t ? (t5 = t("help-resources.action.contact-sales"), $[9] = t, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(MenuItem, { as: "a", text: t5, href: "https://www.sanity.io/contact/sales?ref=studio", target: "_blank" }), $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== t2 || $[14] !== t4 || $[15] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t2,
    t4,
    t6
  ] }), $[13] = t2, $[14] = t4, $[15] = t6, $[16] = t7) : t7 = $[16];
  const fallbackLinks = t7;
  let t8;
  $[17] !== currentVersion || $[18] !== latestTaggedVersion || $[19] !== newAutoUpdateVersion || $[20] !== onOpenStudioVersionDialog ? (t8 = /* @__PURE__ */ jsx(StudioVersion, { currentVersion, newAutoUpdateVersion, latestTaggedVersion, onOpenStudioVersionDialog }), $[17] = currentVersion, $[18] = latestTaggedVersion, $[19] = newAutoUpdateVersion, $[20] = onOpenStudioVersionDialog, $[21] = t8) : t8 = $[21];
  let t10, t9;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = /* @__PURE__ */ jsx(StudioRegistration, {}), t10 = /* @__PURE__ */ jsx(MenuDivider, {}), $[22] = t10, $[23] = t9) : (t10 = $[22], t9 = $[23]);
  let t11;
  $[24] !== error || $[25] !== sections ? (t11 = !error && sections?.map((subSection, i) => subSection ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(SubSection, { subSection }),
    i < sections.length - 1 && /* @__PURE__ */ jsx(MenuDivider, {})
  ] }, subSection._key) : null), $[24] = error, $[25] = sections, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== error || $[28] !== fallbackLinks || $[29] !== value ? (t12 = (value === void 0 || error) && /* @__PURE__ */ jsx("div", { children: fallbackLinks }), $[27] = error, $[28] = fallbackLinks, $[29] = value, $[30] = t12) : t12 = $[30];
  let t13;
  return $[31] !== t11 || $[32] !== t12 || $[33] !== t8 ? (t13 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t8,
    t9,
    t10,
    t11,
    t12
  ] }), $[31] = t11, $[32] = t12, $[33] = t8, $[34] = t13) : t13 = $[34], t13;
}
function StudioVersion(t0) {
  const $ = c(30), {
    currentVersion,
    newAutoUpdateVersion,
    latestTaggedVersion,
    onOpenStudioVersionDialog
  } = t0, {
    t
  } = useTranslation(), isOutdated = latestTaggedVersion ? (currentVersion?.compareMain?.(latestTaggedVersion) ?? 0) < 0 : !1;
  let versionTone = "positive", t1;
  $[0] !== t ? (t1 = t("help-resources.up-to-date"), $[0] = t, $[1] = t1) : t1 = $[1];
  let subtitle = t1, action = onOpenStudioVersionDialog, testId = "menu-item-studio-version";
  if (newAutoUpdateVersion) {
    let t22;
    $[2] !== newAutoUpdateVersion.version || $[3] !== t ? (t22 = t("help-resources.studio-auto-update-now", {
      newVersion: newAutoUpdateVersion.version
    }), $[2] = newAutoUpdateVersion.version, $[3] = t, $[4] = t22) : t22 = $[4], subtitle = t22, versionTone = "caution", action = reload$1, testId = "menu-item-update-studio-now";
  } else if (isOutdated) {
    const t22 = latestTaggedVersion?.version;
    let t32;
    $[5] !== t || $[6] !== t22 ? (t32 = t("help-resources.latest-sanity-version", {
      latestVersion: t22
    }), $[5] = t, $[6] = t22, $[7] = t32) : t32 = $[7], subtitle = t32, versionTone = "caution";
  }
  const t2 = action, t3 = testId;
  let t4;
  $[8] !== t ? (t4 = t("help-resources.studio"), $[8] = t, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t4 }), $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== subtitle ? (t6 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: subtitle }), $[12] = subtitle, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== t5 || $[15] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, gap: 2, padding: 1, children: [
    t5,
    t6
  ] }), $[14] = t5, $[15] = t6, $[16] = t7) : t7 = $[16];
  const t8 = versionTone;
  let t9;
  $[17] !== currentVersion.version || $[18] !== t ? (t9 = t("help-resources.version", {
    version: currentVersion.version
  }), $[17] = currentVersion.version, $[18] = t, $[19] = t9) : t9 = $[19];
  let t10;
  $[20] !== t9 || $[21] !== versionTone ? (t10 = /* @__PURE__ */ jsx(Badge, { tone: t8, children: t9 }), $[20] = t9, $[21] = versionTone, $[22] = t10) : t10 = $[22];
  let t11;
  $[23] !== t10 || $[24] !== t7 ? (t11 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", children: [
    t7,
    t10
  ] }), $[23] = t10, $[24] = t7, $[25] = t11) : t11 = $[25];
  let t12;
  return $[26] !== action || $[27] !== t11 || $[28] !== testId ? (t12 = /* @__PURE__ */ jsx(MenuItem$1, { padding: 2, onClick: t2, "data-testid": t3, children: t11 }), $[26] = action, $[27] = t11, $[28] = testId, $[29] = t12) : t12 = $[29], t12;
}
function StudioRegistration() {
  const $ = c(11), {
    t
  } = useTranslation(), {
    userApplication
  } = useLiveUserApplication(), sanityWebsiteUrl = useEnvAwareSanityWebsiteUrl(), projectId = useWorkspaces()[0]?.projectId, canDeployStudio = useCanDeployStudio(!userApplication);
  let t0;
  $[0] !== canDeployStudio || $[1] !== projectId || $[2] !== sanityWebsiteUrl ? (t0 = () => {
    if (!projectId || !canDeployStudio)
      return;
    const url = new URL(`${sanityWebsiteUrl}/manage/project/${projectId}/studios`);
    url.searchParams.set("studio", "add"), url.searchParams.set("origin", window.location.origin), window.open(url, "_blank", "noopener,noreferrer");
  }, $[0] = canDeployStudio, $[1] = projectId, $[2] = sanityWebsiteUrl, $[3] = t0) : t0 = $[3];
  const handleRegisterStudio = t0;
  if (userApplication)
    return null;
  let t1;
  $[4] !== t ? (t1 = t("help-resources.register-studio"), $[4] = t, $[5] = t1) : t1 = $[5];
  let t2;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(LaunchIcon, {}), $[6] = t2) : t2 = $[6];
  const t3 = !canDeployStudio;
  let t4;
  return $[7] !== handleRegisterStudio || $[8] !== t1 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(Card, { tone: "caution", radius: 4, children: /* @__PURE__ */ jsx(MenuItem, { text: t1, iconRight: t2, onClick: handleRegisterStudio, tone: "caution", disabled: t3 }) }), $[7] = handleRegisterStudio, $[8] = t1, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
}
function SubSection(t0) {
  const $ = c(4), {
    subSection
  } = t0;
  let t1;
  $[0] !== subSection?.items ? (t1 = subSection?.items?.map(_temp$i), $[0] = subSection?.items, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Fragment$1, { children: t1 }), $[2] = t1, $[3] = t2) : t2 = $[3], t2;
}
function _temp$i(item) {
  if (!item || !item.title)
    return null;
  switch (item._type) {
    case "externalLink":
      return item.url ? /* @__PURE__ */ jsx(MenuItem, { as: "a", tone: "default", text: item.title, href: item.url, target: "_blank" }, item._key) : null;
    case "internalAction":
      return item.type ? item.type === "studio-announcements-modal" ? /* @__PURE__ */ jsx(StudioAnnouncementsMenuItem, { text: item.title }, item._key) : item.type === "show-welcome-modal" && /* @__PURE__ */ jsx(MenuItem, { text: item.title }, item._key) : null;
    default:
      return null;
  }
}
const MonogramContainer = styled(Card).attrs({
  overflow: "hidden",
  radius: 4
}).withConfig({
  displayName: "MonogramContainer",
  componentId: "sc-5co060-0"
})`height:${75}px;width:${75}px;`;
function reload() {
  window.location.reload();
}
function getVersionType(ver) {
  return ver.prerelease.length === 0 ? "default" : ver.prerelease.length === 1 && ver.prerelease[0] === "dev" ? "development" : "prerelease";
}
const TruncateBadge = styled(Badge).withConfig({
  displayName: "TruncateBadge",
  componentId: "sc-5co060-1"
})`display:block;span{display:block;white-space:nowrap;text-overflow:ellipsis;overflow:clip;}`, HEX_ONLY = /^[0-9a-fA-F]+$/i;
function resolveGithubURLFromVersion(ver) {
  const preids = ver.prerelease;
  if (preids.length === 0)
    return `https://github.com/sanity-io/sanity/releases/tag/v${ver.version}`;
  if (preids[0] === "pr" && typeof preids[1] == "number")
    return `https://github.com/sanity-io/sanity/pull/${preids[1]}`;
  if (preids[0] === "next" && ver.build.length === 1 && HEX_ONLY.test(ver.build[0]))
    return `https://github.com/sanity-io/sanity/tree/${ver.build[0]}`;
  const isGitBranch = ver.prerelease[0] === "git", hasBuildInfo = ver.build.length > 0 && HEX_ONLY.test(ver.build[0]);
  if (isGitBranch && hasBuildInfo)
    return `https://github.com/sanity-io/sanity/commit/${ver.build[0]}`;
}
function StudioInfoDialog(props2) {
  const $ = c(74), {
    t
  } = useTranslation(), {
    onClose
  } = props2, dialogId = useId(), {
    projectId
  } = useWorkspace(), {
    isAutoUpdating,
    autoUpdatingVersion,
    currentVersion,
    importMapInfo,
    latestTaggedVersion,
    versionCheckStatus,
    checkForUpdates
  } = usePackageVersionStatus(), isUpToDate = latestTaggedVersion && currentVersion && currentVersion.compareMain(latestTaggedVersion) >= 0;
  let t0;
  $[0] !== currentVersion ? (t0 = getVersionType(currentVersion), $[0] = currentVersion, $[1] = t0) : t0 = $[1];
  const currentVersionType = t0;
  let t1;
  $[2] !== autoUpdatingVersion || $[3] !== currentVersion ? (t1 = currentVersion && autoUpdatingVersion ? semver.neq(currentVersion, autoUpdatingVersion) : !1, $[2] = autoUpdatingVersion, $[3] = currentVersion, $[4] = t1) : t1 = $[4];
  const newAutoUpdateVersionAvailable = t1;
  let t2, t3;
  $[5] !== checkForUpdates ? (t2 = () => {
    checkForUpdates();
    const interval = setInterval(checkForUpdates, 1e4);
    return () => clearInterval(interval);
  }, t3 = [checkForUpdates], $[5] = checkForUpdates, $[6] = t2, $[7] = t3) : (t2 = $[6], t3 = $[7]), useEffect(t2, t3);
  let t4;
  $[8] !== currentVersion ? (t4 = resolveGithubURLFromVersion(currentVersion), $[8] = currentVersion, $[9] = t4) : t4 = $[9];
  const githubUrl = t4, sanityWebsiteUrl = useEnvAwareSanityWebsiteUrl();
  let t5;
  $[10] !== importMapInfo || $[11] !== t ? (t5 = importMapInfo?.valid && !importMapInfo.appId ? /* @__PURE__ */ jsxs(Card, { padding: 4, tone: "caution", children: [
    /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, children: [
      /* @__PURE__ */ jsx(TextWithTone, { tone: "caution", children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }),
      /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
        /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "caution", weight: "medium", children: t("about-dialog.configuration-issue.header") }),
        /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "caution", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "about-dialog.configuration-issue.missing-appid" }) }),
        /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "caution", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsxs("a", { href: "https://www.sanity.io/docs/studio/latest-version-of-sanity", target: "_blank", rel: "noopener noreferrer", children: [
          t("about-dialog.configuration-issue.missing-appid.view-documentation"),
          " \u2192"
        ] }) }) })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Stack, { space: 2 })
  ] }) : null, $[10] = importMapInfo, $[11] = t, $[12] = t5) : t5 = $[12];
  const importMapWarning = t5, versionBadgeTone = currentVersionType === "development" ? "caution" : currentVersionType === "prerelease" ? "suggest" : "neutral";
  let t6;
  $[13] !== versionCheckStatus?.checking ? (t6 = versionCheckStatus?.checking ? /* @__PURE__ */ jsx(Flex, { margin: 2, padding: 2, style: {
    position: "absolute",
    right: 0
  }, children: /* @__PURE__ */ jsx(Spinner, { size: 0 }) }) : null, $[13] = versionCheckStatus?.checking, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", paddingY: 4, children: /* @__PURE__ */ jsx(MonogramContainer, { children: /* @__PURE__ */ jsx(SanityMonogram, { height: 75, width: 75 }) }) }), $[15] = t7) : t7 = $[15];
  let t8;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = /* @__PURE__ */ jsx(Flex, { justify: "flex-end", align: "center", children: /* @__PURE__ */ jsx(Text$1, { as: "h2", size: 1, weight: "semibold", children: "Sanity Studio" }) }), $[16] = t8) : t8 = $[16];
  let t9;
  $[17] !== currentVersion.version ? (t9 = ensureVersionPrefix(currentVersion.version), $[17] = currentVersion.version, $[18] = t9) : t9 = $[18];
  let t10;
  $[19] !== t9 || $[20] !== versionBadgeTone ? (t10 = /* @__PURE__ */ jsx(Badge, { tone: versionBadgeTone, children: t9 }), $[19] = t9, $[20] = versionBadgeTone, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== currentVersionType || $[23] !== t ? (t11 = t(currentVersionType === "development" ? "about-dialog.version-info.tooltip.development" : currentVersionType === "prerelease" ? "about-dialog.version-info.tooltip.prerelease" : "about-dialog.version-info.tooltip.up-to-date"), $[22] = currentVersionType, $[23] = t, $[24] = t11) : t11 = $[24];
  let t12;
  $[25] !== t11 ? (t12 = /* @__PURE__ */ jsx(Badge, { size: 1, children: t11 }), $[25] = t11, $[26] = t12) : t12 = $[26];
  let t13;
  $[27] !== t10 || $[28] !== t12 ? (t13 = /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsxs(Inline, { space: 1, children: [
    t10,
    t12
  ] }) }), $[27] = t10, $[28] = t12, $[29] = t13) : t13 = $[29];
  let t14;
  $[30] !== currentVersion ? (t14 = currentVersion ? ensureVersionPrefix(currentVersion.version) : "unknown", $[30] = currentVersion, $[31] = t14) : t14 = $[31];
  let t15;
  $[32] !== t14 || $[33] !== versionBadgeTone ? (t15 = /* @__PURE__ */ jsx(TruncateBadge, { tone: versionBadgeTone, children: t14 }), $[32] = t14, $[33] = versionBadgeTone, $[34] = t15) : t15 = $[34];
  let t16;
  $[35] !== githubUrl || $[36] !== t ? (t16 = githubUrl && /* @__PURE__ */ jsx(Button, { as: "a", target: "_blank", rel: "noopener noreferrer", icon: GithubIcon, mode: "bleed", tooltipProps: {
    content: t("about-dialog.version-info.view-on-github")
  }, href: githubUrl }), $[35] = githubUrl, $[36] = t, $[37] = t16) : t16 = $[37];
  let t17;
  $[38] !== t15 || $[39] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "center", paddingRight: 2, children: [
    t15,
    t16
  ] }), $[38] = t15, $[39] = t16, $[40] = t17) : t17 = $[40];
  let t18;
  $[41] !== t13 || $[42] !== t17 ? (t18 = /* @__PURE__ */ jsx(Tooltip, { placement: "bottom", content: t13, children: t17 }), $[41] = t13, $[42] = t17, $[43] = t18) : t18 = $[43];
  let t19;
  $[44] !== autoUpdatingVersion || $[45] !== currentVersionType || $[46] !== isAutoUpdating || $[47] !== isUpToDate || $[48] !== latestTaggedVersion || $[49] !== newAutoUpdateVersionAvailable || $[50] !== t ? (t19 = isAutoUpdating && newAutoUpdateVersionAvailable ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(Flex, { justify: "flex-end", align: "center", children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t("about-dialog.version-info.new-version.text") }) }),
    /* @__PURE__ */ jsxs(Flex, { justify: "flex-start", align: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(Badge, { tone: "primary", children: autoUpdatingVersion && ensureVersionPrefix(autoUpdatingVersion?.version) }),
      /* @__PURE__ */ jsx(Button, { onClick: reload, mode: "bleed", tone: "primary", text: autoUpdatingVersion && getVersionType(autoUpdatingVersion) === "prerelease" ? void 0 : t("about-dialog.version-info.update-button.text"), tooltipProps: {
        content: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("about-dialog.version-info.reload-to-update") })
      }, icon: RefreshIcon })
    ] })
  ] }) : !isUpToDate || currentVersionType ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(Flex, { justify: "flex-end", align: "center", children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t("about-dialog.version-info.latest-version.header") }) }),
    /* @__PURE__ */ jsxs(Flex, { justify: "flex-start", align: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(Badge, { tone: "primary", children: latestTaggedVersion ? ensureVersionPrefix(latestTaggedVersion.version) : "unknown" }),
      currentVersionType ? null : /* @__PURE__ */ jsx(Button, { as: "a", href: "https://www.sanity.io/docs/upgrade", target: "_blank", rel: "noopener noreferrer", mode: "bleed", tooltipProps: {
        content: t("about-dialog.version-info.update-button.tooltip")
      }, text: t("about-dialog.version-info.update-button.text"), iconRight: LaunchIcon })
    ] })
  ] }) : null, $[44] = autoUpdatingVersion, $[45] = currentVersionType, $[46] = isAutoUpdating, $[47] = isUpToDate, $[48] = latestTaggedVersion, $[49] = newAutoUpdateVersionAvailable, $[50] = t, $[51] = t19) : t19 = $[51];
  let t20;
  $[52] !== t18 || $[53] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Grid, { columns: 2, gap: 2, children: [
    t8,
    t18,
    t19
  ] }), $[52] = t18, $[53] = t19, $[54] = t20) : t20 = $[54];
  let t21;
  $[55] !== isAutoUpdating || $[56] !== projectId || $[57] !== sanityWebsiteUrl || $[58] !== t ? (t21 = isAutoUpdating ? /* @__PURE__ */ jsx(Card, { tone: "transparent", padding: 2, radius: 3, marginX: 2, children: /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-evenly", gap: 2, children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t("about-dialog.version-info.auto-updates.enabled") }),
    /* @__PURE__ */ jsx(Button, { as: "a", href: `${sanityWebsiteUrl}/manage/project/${projectId}/studios?host=${document.location.hostname}`, target: "_blank", rel: "noopener noreferrer", mode: "ghost", text: t("about-dialog.version-info.auto-updates.manage-version"), icon: CogIcon })
  ] }) }) : isProd ? /* @__PURE__ */ jsx(Card, { tone: "transparent", padding: 2, radius: 3, marginX: 2, children: /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-evenly", gap: 2, children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t("about-dialog.version-info.auto-updates.disabled") }),
    /* @__PURE__ */ jsx(Button, { as: "a", href: "https://www.sanity.io/docs/auto-updating-studios", target: "_blank", rel: "noopener noreferrer", mode: "ghost", text: t("about-dialog.version-info.auto-updates.how-to-enable"), iconRight: LaunchIcon })
  ] }) }) : null, $[55] = isAutoUpdating, $[56] = projectId, $[57] = sanityWebsiteUrl, $[58] = t, $[59] = t21) : t21 = $[59];
  let t22;
  $[60] !== importMapWarning || $[61] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Stack, { space: 2, paddingY: 3, children: [
    t21,
    importMapWarning
  ] }), $[60] = importMapWarning, $[61] = t21, $[62] = t22) : t22 = $[62];
  let t23;
  $[63] !== onClose ? (t23 = /* @__PURE__ */ jsx(Stack, { paddingX: 3, children: /* @__PURE__ */ jsx(Button, { tone: "primary", text: "OK", paddingY: 3, onClick: onClose }) }), $[63] = onClose, $[64] = t23) : t23 = $[64];
  let t24;
  $[65] !== t20 || $[66] !== t22 || $[67] !== t23 ? (t24 = /* @__PURE__ */ jsxs(Stack, { space: 3, paddingY: 3, children: [
    t7,
    t20,
    t22,
    t23
  ] }), $[65] = t20, $[66] = t22, $[67] = t23, $[68] = t24) : t24 = $[68];
  let t25;
  return $[69] !== dialogId || $[70] !== onClose || $[71] !== t24 || $[72] !== t6 ? (t25 = /* @__PURE__ */ jsxs(Dialog$1, { width: 0, onClickOutside: onClose, id: dialogId, padding: !1, children: [
    t6,
    t24
  ] }), $[69] = dialogId, $[70] = onClose, $[71] = t24, $[72] = t6, $[73] = t25) : t25 = $[73], t25;
}
function ensureVersionPrefix(str) {
  return str.startsWith("v") ? str : `v${str}`;
}
const StyledMenu$1 = styled(Menu).withConfig({
  displayName: "StyledMenu",
  componentId: "sc-1fgplss-0"
})`max-width:300px;min-width:200px;`;
function ResourcesButton() {
  const $ = c(43), {
    t
  } = useTranslation(), {
    userApplication,
    isLoading: isLoadingUserApplication
  } = useLiveUserApplication(), {
    value,
    error,
    isLoading
  } = useGetHelpResources(), {
    autoUpdatingVersion: autoUpdatingVersionStr,
    currentVersion: currentVersionStr,
    latestTaggedVersion: latestTaggedVersionStr
  } = usePackageVersionStatus();
  let autoUpdatingVersion, currentVersion, latestTaggedVersion, t0;
  if ($[0] !== autoUpdatingVersionStr || $[1] !== currentVersionStr || $[2] !== latestTaggedVersionStr) {
    currentVersion = semver.parse(currentVersionStr), autoUpdatingVersion = semver.parse(autoUpdatingVersionStr) || void 0;
    let t15;
    $[7] !== latestTaggedVersionStr ? (t15 = semver.parse(latestTaggedVersionStr) || void 0, $[7] = latestTaggedVersionStr, $[8] = t15) : t15 = $[8], latestTaggedVersion = t15, t0 = currentVersion && autoUpdatingVersion ? semver.neq(currentVersion, autoUpdatingVersion) : !1, $[0] = autoUpdatingVersionStr, $[1] = currentVersionStr, $[2] = latestTaggedVersionStr, $[3] = autoUpdatingVersion, $[4] = currentVersion, $[5] = latestTaggedVersion, $[6] = t0;
  } else
    autoUpdatingVersion = $[3], currentVersion = $[4], latestTaggedVersion = $[5], t0 = $[6];
  const newAutoUpdateVersionAvailable = t0;
  let t1;
  $[9] !== isLoadingUserApplication || $[10] !== newAutoUpdateVersionAvailable || $[11] !== userApplication ? (t1 = () => {
    if (newAutoUpdateVersionAvailable)
      return "primary";
    if (!isLoadingUserApplication && !userApplication)
      return "caution";
  }, $[9] = isLoadingUserApplication, $[10] = newAutoUpdateVersionAvailable, $[11] = userApplication, $[12] = t1) : t1 = $[12];
  const getButtonTone = t1, [studioInfoDialogOpen, setStudioInfoDialogOpen] = useState(!1);
  let t2;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setStudioInfoDialogOpen(!1);
  }, $[13] = t2) : t2 = $[13];
  const handleStudioInfoDialogClose = t2;
  let t3;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setStudioInfoDialogOpen(!0);
  }, $[14] = t3) : t3 = $[14];
  const handleOpenVersionDialog = t3;
  let t4;
  $[15] !== studioInfoDialogOpen ? (t4 = studioInfoDialogOpen && /* @__PURE__ */ jsx(StudioInfoDialog, { onClose: handleStudioInfoDialogClose }), $[15] = studioInfoDialogOpen, $[16] = t4) : t4 = $[16];
  let t5;
  $[17] !== getButtonTone ? (t5 = getButtonTone(), $[17] = getButtonTone, $[18] = t5) : t5 = $[18];
  let t6;
  $[19] !== t ? (t6 = t("help-resources.title"), $[19] = t, $[20] = t6) : t6 = $[20];
  let t7;
  $[21] !== t ? (t7 = t("help-resources.title"), $[21] = t, $[22] = t7) : t7 = $[22];
  let t8;
  $[23] !== t7 ? (t8 = {
    content: t7
  }, $[23] = t7, $[24] = t8) : t8 = $[24];
  let t9;
  $[25] !== t5 || $[26] !== t6 || $[27] !== t8 ? (t9 = /* @__PURE__ */ jsx(StatusButton, { tone: t5, "aria-label": t6, icon: HelpCircleIcon, "data-testid": "button-resources-menu", mode: "bleed", tooltipProps: t8 }), $[25] = t5, $[26] = t6, $[27] = t8, $[28] = t9) : t9 = $[28];
  const t10 = newAutoUpdateVersionAvailable ? autoUpdatingVersion : void 0;
  let t11;
  $[29] !== currentVersion || $[30] !== error || $[31] !== isLoading || $[32] !== latestTaggedVersion || $[33] !== t10 || $[34] !== value ? (t11 = /* @__PURE__ */ jsx(StyledMenu$1, { "data-testid": "menu-button-resources", children: /* @__PURE__ */ jsx(ResourcesMenuItems, { currentVersion, latestTaggedVersion, newAutoUpdateVersion: t10, error, isLoading, value, onOpenStudioVersionDialog: handleOpenVersionDialog }) }), $[29] = currentVersion, $[30] = error, $[31] = isLoading, $[32] = latestTaggedVersion, $[33] = t10, $[34] = value, $[35] = t11) : t11 = $[35];
  let t12;
  $[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = {
    constrainSize: !0,
    tone: "default"
  }, $[36] = t12) : t12 = $[36];
  let t13;
  $[37] !== t11 || $[38] !== t9 ? (t13 = /* @__PURE__ */ jsx(MenuButton, { button: t9, id: "menu-button-resources", menu: t11, popover: t12 }), $[37] = t11, $[38] = t9, $[39] = t13) : t13 = $[39];
  let t14;
  return $[40] !== t13 || $[41] !== t4 ? (t14 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t4,
    t13
  ] }), $[40] = t13, $[41] = t4, $[42] = t14) : t14 = $[42], t14;
}
function AppearanceMenu(t0) {
  const $ = c(5), {
    setScheme
  } = t0, {
    t
  } = useTranslation(), options = useColorSchemeOptions(setScheme, t);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(MenuDivider, {}), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== options ? (t2 = options.map(_temp$h), $[1] = options, $[2] = t2) : t2 = $[2];
  let t3;
  return $[3] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t1,
    t2
  ] }), $[3] = t2, $[4] = t3) : t3 = $[4], t3;
}
function _temp$h(t0) {
  const {
    icon,
    label,
    name,
    onSelect,
    selected,
    title
  } = t0;
  return /* @__PURE__ */ jsx(MenuItem, { "aria-label": label, icon, onClick: onSelect, pressed: selected, text: title, iconRight: selected && /* @__PURE__ */ jsx(CheckmarkIcon, {}), "data-testid": `color-scheme-${name}` }, name);
}
function LocaleMenu() {
  return c(10), useLocale(), null;
}
const Root$7 = styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-a7k4iv-0"
})`position:absolute;width:18px;height:18px;background:var(--card-bg-color);bottom:-4px;right:-4px;border-radius:50%;display:flex;justify-content:center;align-items:center;border:1px solid var(--card-bg-color);box-sizing:content-box;svg{box-sizing:content-box;border:1px solid var(--card-hairline-soft-color);border-radius:50%;padding:2px;width:12px;height:12px;}&[data-logo='github']{svg{path{fill:var(--card-fg-color);}}}&[data-logo='saml']{svg{path{fill:var(--card-fg-color);}}}`, Google = /* @__PURE__ */ jsxs("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0)", children: [
    /* @__PURE__ */ jsx("path", { d: "M12 6.13764C12 5.72977 11.9663 5.31971 11.8943 4.91846H6.12036V7.22895H9.42684C9.28963 7.97412 8.84876 8.63332 8.20322 9.05221V10.5514H10.1759C11.3342 9.50637 12 7.9631 12 6.13764Z", fill: "#4285F4" }),
    /* @__PURE__ */ jsx("path", { d: "M6.12019 12.0002C7.77118 12.0002 9.16349 11.4688 10.1779 10.5517L8.20529 9.05253C7.65646 9.41851 6.94793 9.62574 6.12244 9.62574C4.52544 9.62574 3.17136 8.56971 2.68552 7.1499H0.649902V8.69537C1.68908 10.7215 3.80567 12.0002 6.12019 12.0002V12.0002Z", fill: "#34A853" }),
    /* @__PURE__ */ jsx("path", { d: "M2.68332 7.14986C2.4269 6.40469 2.4269 5.59778 2.68332 4.8526V3.30713H0.649951C-0.218278 5.00252 -0.218278 6.99995 0.649951 8.69533L2.68332 7.14986V7.14986Z", fill: "#FBBC04" }),
    /* @__PURE__ */ jsx("path", { d: "M6.12019 2.37483C6.99291 2.3616 7.8364 2.68348 8.46845 3.27433L10.2161 1.56131C9.1095 0.542752 7.64071 -0.017233 6.12019 0.000404333C3.80566 0.000404333 1.68908 1.27911 0.649902 3.3074L2.68326 4.85288C3.16686 3.43087 4.52319 2.37483 6.12019 2.37483V2.37483Z", fill: "#EA4335" })
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ jsx("rect", { width: "12", height: "12", fill: "white" }) }) })
] }), GitHub = /* @__PURE__ */ jsxs("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx("g", { clipPath: "url(#clip0)", children: /* @__PURE__ */ jsx("path", { d: "M11.195 3.13503C10.6711 2.22838 9.91808 1.47537 9.01144 0.951471C8.09222 0.414976 7.08837 0.146729 5.99987 0.146729C4.91137 0.146729 3.90752 0.414976 2.98831 0.951471C2.08163 1.47534 1.32862 2.22836 0.804744 3.13503C0.268248 4.05497 0 5.05883 0 6.14659C0 7.45399 0.381531 8.62978 1.14459 9.67394C1.90765 10.7181 2.89327 11.4408 4.10143 11.8419C4.24208 11.868 4.34624 11.8497 4.41392 11.7872C4.44666 11.7577 4.47263 11.7215 4.49006 11.681C4.50749 11.6405 4.51595 11.5967 4.51488 11.5527C4.51488 11.537 4.51361 11.3963 4.51105 11.1307C4.5085 10.8651 4.50722 10.6334 4.50722 10.4355L4.32745 10.4666C4.18407 10.4895 4.03885 10.4986 3.89375 10.494C3.71159 10.4908 3.53001 10.4725 3.35087 10.4393C3.16049 10.4045 2.98119 10.3246 2.82796 10.2064C2.66705 10.0846 2.54715 9.91661 2.48428 9.72484L2.40602 9.54506C2.34022 9.40286 2.25754 9.2691 2.15976 9.14666C2.04775 9.00072 1.93447 8.90176 1.81991 8.84977L1.76518 8.81064C1.72769 8.78356 1.6936 8.75205 1.66367 8.71679C1.63479 8.6841 1.61108 8.64719 1.59334 8.60734C1.57766 8.57085 1.5907 8.54085 1.63247 8.51731C1.67461 8.49405 1.75123 8.48256 1.86068 8.48256L2.01692 8.50582C2.12108 8.52662 2.24996 8.5891 2.40356 8.69326C2.5585 8.79876 2.68797 8.93748 2.78254 9.09932C2.90239 9.31294 3.04695 9.47575 3.21624 9.58775C3.38552 9.69976 3.55609 9.75576 3.72793 9.75576C3.87725 9.7578 4.02641 9.74479 4.17312 9.7169C4.29459 9.69195 4.41264 9.65254 4.52473 9.59952C4.57162 9.25037 4.69931 8.98212 4.90782 8.79477C4.63684 8.76849 4.36827 8.72157 4.10444 8.6544C3.84797 8.58382 3.60133 8.48141 3.37029 8.34958C3.12825 8.218 2.91442 8.04015 2.74095 7.82613C2.57421 7.6178 2.4374 7.34417 2.3305 7.00524C2.2236 6.6663 2.1707 6.27584 2.1718 5.83383C2.1718 5.20357 2.37757 4.66708 2.7891 4.22435C2.59629 3.75006 2.61453 3.21885 2.84383 2.63073C2.99487 2.58385 3.21879 2.61897 3.51559 2.73608C3.81239 2.85319 4.02983 2.95352 4.16792 3.03707C4.30601 3.12025 4.41665 3.19058 4.49983 3.24804C5.48153 2.9773 6.51821 2.9773 7.49991 3.24804L7.79679 3.0606C8.0249 2.92356 8.26549 2.80849 8.51535 2.71693C8.79135 2.61276 9.00231 2.58412 9.14825 2.63101C9.38248 3.21949 9.40327 3.7507 9.21064 4.22462C9.62199 4.66735 9.82776 5.20385 9.82795 5.83411C9.82795 6.27684 9.77459 6.66904 9.66787 7.01071C9.56116 7.35238 9.42325 7.62601 9.25415 7.8316C9.07785 8.04326 8.86311 8.21966 8.62124 8.35149C8.39008 8.48329 8.14337 8.5857 7.88682 8.65632C7.62412 8.72277 7.35674 8.76915 7.087 8.79505C7.35698 9.02927 7.49206 9.3994 7.49225 9.90543V11.5527C7.49115 11.5964 7.49929 11.6398 7.51612 11.6802C7.53295 11.7206 7.5581 11.7569 7.58993 11.7869C7.65505 11.8493 7.75794 11.8675 7.89858 11.8416C9.10693 11.4403 10.0926 10.7177 10.8557 9.67367C11.6188 8.62968 12.0003 7.4539 12.0003 6.14632C11.9997 5.05873 11.7313 4.05497 11.195 3.13503V3.13503Z", fill: "black" }) }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ jsx("rect", { width: "12", height: "12", fill: "white" }) }) })
] }), Saml = /* @__PURE__ */ jsxs("svg", { width: "17", height: "9", viewBox: "0 0 17 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx("path", { d: "M0.0691681 5.98162C0.115833 7.24157 1.07247 8.00221 2.59841 8.00221C4.17102 8.00221 5.12299 7.19957 5.12299 5.86962C5.12299 4.83832 4.55367 4.25501 3.25172 3.96569L2.56108 3.80703C1.8331 3.64837 1.53445 3.38704 1.53445 2.91106C1.53445 2.40708 1.94977 2.09442 2.61708 2.09442C3.27505 2.09442 3.6997 2.43508 3.75103 2.99039H5.00166C4.95966 1.78643 4.01236 0.997795 2.60308 0.997795C1.14713 0.997795 0.218496 1.79577 0.218496 3.05105C0.218496 4.04968 0.815808 4.69366 2.03376 4.96898L2.73374 5.13231C3.51304 5.30497 3.8117 5.54763 3.8117 6.00495C3.8117 6.55093 3.34972 6.90092 2.62174 6.90092C1.85644 6.90092 1.38045 6.56493 1.31979 5.98162H0.0691681Z" }),
  /* @__PURE__ */ jsx("path", { d: "M5.97695 5.98162C6.02362 7.24157 6.98025 8.00221 8.5062 8.00221C10.0788 8.00221 11.0308 7.19957 11.0308 5.86962C11.0308 4.83832 10.4615 4.25501 9.15951 3.96569L8.46886 3.80703C7.74089 3.64837 7.44223 3.38704 7.44223 2.91106C7.44223 2.40708 7.85755 2.09442 8.52486 2.09442C9.18284 2.09442 9.60749 2.43508 9.65882 2.99039H10.9094C10.8674 1.78643 9.92015 0.997795 8.51086 0.997795C7.05492 0.997795 6.12628 1.79577 6.12628 3.05105C6.12628 4.04968 6.72359 4.69366 7.94155 4.96898L8.64153 5.13231C9.42083 5.30497 9.71949 5.54763 9.71949 6.00495C9.71949 6.55093 9.2575 6.90092 8.52953 6.90092C7.76422 6.90092 7.28824 6.56493 7.22758 5.98162H5.97695Z" }),
  /* @__PURE__ */ jsx("path", { d: "M16.9852 5.01565V3.98435C16.9852 2.11309 16.0099 0.997795 14.3953 0.997795C12.7807 0.997795 11.8054 2.11309 11.8054 3.98435V5.01565C11.8054 6.88692 12.7807 8.00221 14.3953 8.00221C16.0099 8.00221 16.9852 6.88692 16.9852 5.01565ZM14.3953 6.82625C13.5833 6.82625 13.154 6.21494 13.154 5.00165V3.99835C13.154 2.78506 13.5833 2.17375 14.3953 2.17375C15.2073 2.17375 15.6366 2.78506 15.6366 3.99835V5.00165C15.6366 6.21494 15.2073 6.82625 14.3953 6.82625Z" })
] }), LoginProviderLogo = (t0) => {
  const $ = c(10), {
    provider
  } = t0;
  let t1;
  $[0] !== provider ? (t1 = provider?.startsWith("saml-"), $[0] = provider, $[1] = t1) : t1 = $[1];
  const isSaml = t1, logoName = isSaml ? "saml" : provider, t2 = provider === "google" && Google, t3 = provider === "github" && GitHub;
  let t4;
  $[2] !== provider ? (t4 = provider === "sanity" && /* @__PURE__ */ jsx(SanityMonogram, {}), $[2] = provider, $[3] = t4) : t4 = $[3];
  const t5 = isSaml && Saml;
  let t6;
  return $[4] !== logoName || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Root$7, { "data-logo": logoName, children: [
    t2,
    t3,
    t4,
    t5
  ] }), $[4] = logoName, $[5] = t2, $[6] = t3, $[7] = t4, $[8] = t5, $[9] = t6) : t6 = $[9], t6;
}, StyledMenu = styled(Menu).withConfig({
  displayName: "StyledMenu",
  componentId: "sc-oyyyzo-0"
})`min-width:200px;max-width:300px;`, AvatarBox = styled(Box).withConfig({
  displayName: "AvatarBox",
  componentId: "sc-oyyyzo-1"
})`position:relative;min-width:${({
  theme
}) => theme.sanity.avatar.sizes[2].size}px;min-height:${({
  theme
}) => theme.sanity.avatar.sizes[2].size}px;`;
function UserMenu() {
  const $ = c(43), {
    currentUser,
    auth
  } = useWorkspace(), scheme = useColorSchemeValue(), setScheme = useColorSchemeSetValue(), providerTitle = getProviderTitle(currentUser?.provider), {
    t
  } = useTranslation();
  let t0;
  $[0] !== scheme ? (t0 = {
    placement: "bottom",
    portal: !0,
    preventOverflow: !0,
    scheme,
    constrainSize: !0,
    tone: "default"
  }, $[0] = scheme, $[1] = t0) : t0 = $[1];
  const popoverProps = t0, T0 = MenuButton;
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Button$1, { mode: "bleed", padding: 0, radius: "full", children: /* @__PURE__ */ jsx(UserAvatar, { size: 1, user: "me" }) }), $[2] = t1) : t1 = $[2];
  const t2 = "user-menu", T1 = StyledMenu, t3 = "user-menu", T2 = Card, t4 = 2, T3 = Flex, t5 = "center", T4 = Tooltip, t6 = !providerTitle, t7 = !0, t8 = t("user-menu.login-provider", {
    providerTitle
  });
  let t9;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = /* @__PURE__ */ jsx(UserAvatar, { size: 2, user: "me" }), $[3] = t9) : t9 = $[3];
  let t10;
  $[4] !== currentUser ? (t10 = currentUser?.provider && /* @__PURE__ */ jsx(LoginProviderLogo, { provider: currentUser.provider }), $[4] = currentUser, $[5] = t10) : t10 = $[5];
  let t11;
  $[6] !== t10 ? (t11 = /* @__PURE__ */ jsxs(AvatarBox, { marginRight: 3, children: [
    t9,
    t10
  ] }), $[6] = t10, $[7] = t11) : t11 = $[7];
  let t12;
  $[8] !== T4 || $[9] !== t11 || $[10] !== t6 || $[11] !== t8 ? (t12 = /* @__PURE__ */ jsx(T4, { disabled: t6, portal: t7, content: t8, children: t11 }), $[8] = T4, $[9] = t11, $[10] = t6, $[11] = t8, $[12] = t12) : t12 = $[12];
  const t13 = currentUser?.name;
  let t14;
  $[13] !== t13 ? (t14 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", textOverflow: "ellipsis", children: t13 }), $[13] = t13, $[14] = t14) : t14 = $[14];
  const t15 = currentUser?.email;
  let t16;
  $[15] !== t15 ? (t16 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, textOverflow: "ellipsis", children: t15 }), $[15] = t15, $[16] = t16) : t16 = $[16];
  let t17;
  $[17] !== t14 || $[18] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Stack, { space: 2, flex: 1, children: [
    t14,
    t16
  ] }), $[17] = t14, $[18] = t16, $[19] = t17) : t17 = $[19];
  let t18;
  $[20] !== T3 || $[21] !== t12 || $[22] !== t17 ? (t18 = /* @__PURE__ */ jsxs(T3, { align: t5, children: [
    t12,
    t17
  ] }), $[20] = T3, $[21] = t12, $[22] = t17, $[23] = t18) : t18 = $[23];
  let t19;
  $[24] !== T2 || $[25] !== t18 ? (t19 = /* @__PURE__ */ jsx(T2, { padding: t4, children: t18 }), $[24] = T2, $[25] = t18, $[26] = t19) : t19 = $[26];
  let t20;
  $[27] !== setScheme ? (t20 = setScheme && /* @__PURE__ */ jsx(AppearanceMenu, { setScheme }), $[27] = setScheme, $[28] = t20) : t20 = $[28];
  let t21;
  $[29] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t21 = /* @__PURE__ */ jsx(LocaleMenu, {}), $[29] = t21) : t21 = $[29];
  let t22;
  $[30] !== auth.logout || $[31] !== t ? (t22 = auth.logout && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(MenuDivider, {}),
    /* @__PURE__ */ jsx(MenuItem, { iconRight: LeaveIcon, text: t("user-menu.action.sign-out"), disabled: !auth.logout, ...auth.logout && {
      onClick: auth.logout
    } })
  ] }), $[30] = auth.logout, $[31] = t, $[32] = t22) : t22 = $[32];
  let t23;
  $[33] !== T1 || $[34] !== t19 || $[35] !== t20 || $[36] !== t22 ? (t23 = /* @__PURE__ */ jsxs(T1, { "data-testid": t3, children: [
    t19,
    t20,
    t21,
    t22
  ] }), $[33] = T1, $[34] = t19, $[35] = t20, $[36] = t22, $[37] = t23) : t23 = $[37];
  let t24;
  return $[38] !== T0 || $[39] !== popoverProps || $[40] !== t1 || $[41] !== t23 ? (t24 = /* @__PURE__ */ jsx(T0, { button: t1, id: t2, menu: t23, popover: popoverProps }), $[38] = T0, $[39] = popoverProps, $[40] = t1, $[41] = t23, $[42] = t24) : t24 = $[42], t24;
}
const EMPTY_ARRAY = [], RootLayer = styled(Layer).withConfig({
  displayName: "RootLayer",
  componentId: "sc-zgp1z1-0"
})`min-height:auto;position:relative;&[data-search-open='true']{top:0;position:sticky;}`, RootCard = styled(Card).withConfig({
  displayName: "RootCard",
  componentId: "sc-zgp1z1-1"
})`line-height:0;`, NavGrid = styled(Grid).withConfig({
  displayName: "NavGrid",
  componentId: "sc-zgp1z1-2"
})`grid-template-columns:auto auto auto;@media screen and (min-width:${({
  theme
}) => `${theme.sanity.media[4]}px`}){grid-template-columns:1fr auto 1fr;}`;
function StudioNavbar(props2) {
  const $ = c(113), {
    __internal_actions: t0
  } = props2, actions = t0 === void 0 ? EMPTY_ARRAY : t0, {
    name,
    tools
  } = useWorkspace(), routerState = useRouterState(), mediaIndex = useMediaIndex(), activeToolName = typeof routerState.tool == "string" ? routerState.tool : void 0, newDocumentOptions = useNewDocumentOptions(), {
    t
  } = useTranslation(), {
    onSearchFullscreenOpenChange,
    onSearchOpenChange,
    searchFullscreenOpen,
    searchFullscreenPortalEl,
    searchOpen
  } = useContext(NavbarContext), {
    selectedPerspective,
    perspectiveStack
  } = usePerspective(), ToolMenu = useToolMenuComponent(), [drawerOpen, setDrawerOpen] = useState(!1), routerStateRef = useRef(routerState), workspaceNameRef = useRef(name);
  let t1, t2;
  $[0] !== name || $[1] !== routerState ? (t1 = () => {
    (routerStateRef.current.tool !== routerState.tool || name !== workspaceNameRef.current) && setDrawerOpen(!1), routerStateRef.current = routerState, workspaceNameRef.current = name;
  }, t2 = [name, routerState], $[0] = name, $[1] = routerState, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  const [drawerButtonEl, setDrawerButtonEl] = useState(null), [searchOpenButtonEl, setSearchOpenButtonEl] = useState(null), t3 = mediaIndex > 1, t4 = mediaIndex <= 1, t5 = mediaIndex > 1, t6 = mediaIndex <= 1, t7 = mediaIndex > 1 && isDev, t8 = mediaIndex <= 1, t9 = mediaIndex >= 3;
  let t10;
  $[4] !== t3 || $[5] !== t4 || $[6] !== t5 || $[7] !== t6 || $[8] !== t7 || $[9] !== t8 || $[10] !== t9 ? (t10 = {
    resources: t3,
    collapsedPresenceMenu: t4,
    loginStatus: t5,
    searchFullscreen: t6,
    configIssues: t7,
    newDocumentFullscreen: t8,
    tools: t9
  }, $[4] = t3, $[5] = t4, $[6] = t5, $[7] = t6, $[8] = t7, $[9] = t8, $[10] = t9, $[11] = t10) : t10 = $[11];
  const shouldRender = t10;
  let t11, t12;
  $[12] !== onSearchFullscreenOpenChange || $[13] !== searchFullscreenOpen ? (t11 = () => {
    onSearchFullscreenOpenChange(searchFullscreenOpen);
  }, t12 = [searchFullscreenOpen, onSearchFullscreenOpenChange], $[12] = onSearchFullscreenOpenChange, $[13] = searchFullscreenOpen, $[14] = t11, $[15] = t12) : (t11 = $[14], t12 = $[15]), useEffect(t11, t12);
  let t13, t14;
  $[16] !== onSearchFullscreenOpenChange || $[17] !== onSearchOpenChange || $[18] !== shouldRender.searchFullscreen ? (t13 = () => {
    shouldRender.searchFullscreen ? onSearchOpenChange(!1) : onSearchFullscreenOpenChange(!1);
  }, t14 = [onSearchFullscreenOpenChange, onSearchOpenChange, shouldRender.searchFullscreen], $[16] = onSearchFullscreenOpenChange, $[17] = onSearchOpenChange, $[18] = shouldRender.searchFullscreen, $[19] = t13, $[20] = t14) : (t13 = $[19], t14 = $[20]), useEffect(t13, t14);
  let t15;
  $[21] !== onSearchOpenChange ? (t15 = () => {
    onSearchOpenChange(!0);
  }, $[21] = onSearchOpenChange, $[22] = t15) : t15 = $[22];
  const handleOpenSearch = t15;
  let t16;
  $[23] !== onSearchFullscreenOpenChange ? (t16 = () => {
    onSearchFullscreenOpenChange(!0);
  }, $[23] = onSearchFullscreenOpenChange, $[24] = t16) : t16 = $[24];
  const handleOpenSearchFullscreen = t16;
  let t17;
  $[25] !== onSearchOpenChange ? (t17 = () => {
    onSearchOpenChange(!1);
  }, $[25] = onSearchOpenChange, $[26] = t17) : t17 = $[26];
  const handleCloseSearch = t17;
  let t18;
  $[27] !== onSearchFullscreenOpenChange || $[28] !== searchOpenButtonEl ? (t18 = () => {
    onSearchFullscreenOpenChange(!1), searchOpenButtonEl?.focus();
  }, $[27] = onSearchFullscreenOpenChange, $[28] = searchOpenButtonEl, $[29] = t18) : t18 = $[29];
  const handleCloseSearchFullscreen = t18;
  let t19;
  $[30] !== drawerButtonEl ? (t19 = () => {
    setDrawerOpen(!1), drawerButtonEl?.focus();
  }, $[30] = drawerButtonEl, $[31] = t19) : t19 = $[31];
  const handleCloseDrawer = t19;
  let t20;
  $[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t20 = () => {
    setDrawerOpen(!0);
  }, $[32] = t20) : t20 = $[32];
  const handleOpenDrawer = t20;
  let t21;
  bb0: {
    if (!shouldRender.tools) {
      t21 = null;
      break bb0;
    }
    let t222;
    $[33] !== actions ? (t222 = actions?.filter(_temp$g)?.map(_temp2$6), $[33] = actions, $[34] = t222) : t222 = $[34], t21 = t222;
  }
  const actionNodes = t21;
  let t22;
  $[35] !== selectedPerspective ? (t22 = getReleaseTone(selectedPerspective), $[35] = selectedPerspective, $[36] = t22) : t22 = $[36];
  let t23;
  $[37] !== shouldRender.tools || $[38] !== t ? (t23 = !shouldRender.tools && /* @__PURE__ */ jsx(Button, { mode: "bleed", icon: MenuIcon, onClick: handleOpenDrawer, ref: setDrawerButtonEl, tooltipProps: {
    content: t("user-menu.open-menu"),
    placement: "bottom"
  } }), $[37] = shouldRender.tools, $[38] = t, $[39] = t23) : t23 = $[39];
  let t24;
  $[40] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t24 = /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    /* @__PURE__ */ jsx(HomeButton, {}),
    /* @__PURE__ */ jsx(WorkspaceMenuButton, {})
  ] }), $[40] = t24) : t24 = $[40];
  let t25;
  $[41] !== t23 ? (t25 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t23,
    t24
  ] }), $[41] = t23, $[42] = t25) : t25 = $[42];
  const t26 = shouldRender.newDocumentFullscreen ? "dialog" : "popover";
  let t27;
  $[43] !== newDocumentOptions || $[44] !== t26 ? (t27 = /* @__PURE__ */ jsx(NewDocumentButton, { ...newDocumentOptions, modal: t26 }), $[43] = newDocumentOptions, $[44] = t26, $[45] = t27) : t27 = $[45];
  let t28;
  $[46] !== handleOpenSearch || $[47] !== shouldRender.searchFullscreen ? (t28 = !shouldRender.searchFullscreen && /* @__PURE__ */ jsx(SearchButton, { onClick: handleOpenSearch, ref: setSearchOpenButtonEl }), $[46] = handleOpenSearch, $[47] = shouldRender.searchFullscreen, $[48] = t28) : t28 = $[48];
  let t29;
  $[49] !== t25 || $[50] !== t27 || $[51] !== t28 ? (t29 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, justify: "flex-start", children: [
    t25,
    t27,
    t28
  ] }) }), $[49] = t25, $[50] = t27, $[51] = t28, $[52] = t29) : t29 = $[52];
  let t30;
  $[53] !== ToolMenu || $[54] !== activeToolName || $[55] !== handleCloseDrawer || $[56] !== shouldRender.tools || $[57] !== tools ? (t30 = shouldRender.tools && /* @__PURE__ */ jsx(ToolMenu, { activeToolName, closeSidebar: handleCloseDrawer, context: "topbar", isSidebarOpen: !1, tools }), $[53] = ToolMenu, $[54] = activeToolName, $[55] = handleCloseDrawer, $[56] = shouldRender.tools, $[57] = tools, $[58] = t30) : t30 = $[58];
  let t31;
  $[59] !== t30 ? (t31 = /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", children: t30 }), $[59] = t30, $[60] = t31) : t31 = $[60];
  let t32;
  $[61] !== handleCloseSearch || $[62] !== handleCloseSearchFullscreen || $[63] !== handleOpenSearch || $[64] !== handleOpenSearchFullscreen || $[65] !== perspectiveStack || $[66] !== searchFullscreenOpen || $[67] !== searchFullscreenPortalEl || $[68] !== searchOpen || $[69] !== shouldRender.searchFullscreen ? (t32 = /* @__PURE__ */ jsx(BoundaryElementProvider, { element: document.body, children: shouldRender.searchFullscreen ? /* @__PURE__ */ jsx(PortalProvider, { element: searchFullscreenPortalEl, children: /* @__PURE__ */ jsx(SearchDialog, { onClose: handleCloseSearchFullscreen, onOpen: handleOpenSearchFullscreen, open: searchFullscreenOpen }) }) : /* @__PURE__ */ jsx(SearchPopover, { onClose: handleCloseSearch, onOpen: handleOpenSearch, open: searchOpen, previewPerspective: perspectiveStack }) }), $[61] = handleCloseSearch, $[62] = handleCloseSearchFullscreen, $[63] = handleOpenSearch, $[64] = handleOpenSearchFullscreen, $[65] = perspectiveStack, $[66] = searchFullscreenOpen, $[67] = searchFullscreenPortalEl, $[68] = searchOpen, $[69] = shouldRender.searchFullscreen, $[70] = t32) : t32 = $[70];
  let t33;
  $[71] !== shouldRender.searchFullscreen || $[72] !== t32 ? (t33 = /* @__PURE__ */ jsx(LayerProvider, { children: /* @__PURE__ */ jsx(SearchProvider, { fullscreen: shouldRender.searchFullscreen, children: t32 }) }), $[71] = shouldRender.searchFullscreen, $[72] = t32, $[73] = t33) : t33 = $[73];
  let t34;
  $[74] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t34 = /* @__PURE__ */ jsx(ReleasesNav, { withReleasesToolButton: !0 }), $[74] = t34) : t34 = $[74];
  let t35;
  $[75] !== shouldRender.tools ? (t35 = shouldRender.tools && /* @__PURE__ */ jsx(FreeTrial, { type: "topbar" }), $[75] = shouldRender.tools, $[76] = t35) : t35 = $[76];
  let t36;
  $[77] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t36 = /* @__PURE__ */ jsx(PresenceMenu, {}), $[77] = t36) : t36 = $[77];
  let t37;
  $[78] !== shouldRender.configIssues ? (t37 = shouldRender.configIssues && /* @__PURE__ */ jsx(ConfigIssuesButton, {}), $[78] = shouldRender.configIssues, $[79] = t37) : t37 = $[79];
  let t38;
  $[80] !== shouldRender.resources ? (t38 = shouldRender.resources && /* @__PURE__ */ jsx(ResourcesButton, {}), $[80] = shouldRender.resources, $[81] = t38) : t38 = $[81];
  let t39;
  $[82] !== handleOpenSearchFullscreen || $[83] !== shouldRender.searchFullscreen ? (t39 = shouldRender.searchFullscreen && /* @__PURE__ */ jsx(SearchButton, { onClick: handleOpenSearchFullscreen, ref: setSearchOpenButtonEl }), $[82] = handleOpenSearchFullscreen, $[83] = shouldRender.searchFullscreen, $[84] = t39) : t39 = $[84];
  let t40;
  $[85] !== shouldRender.tools ? (t40 = shouldRender.tools && /* @__PURE__ */ jsx(CapabilityGate, { capability: "globalUserMenu", children: /* @__PURE__ */ jsx(Box, { flex: "none", marginLeft: 1, children: /* @__PURE__ */ jsx(UserMenu, {}) }) }), $[85] = shouldRender.tools, $[86] = t40) : t40 = $[86];
  let t41;
  $[87] !== actionNodes || $[88] !== t33 || $[89] !== t35 || $[90] !== t37 || $[91] !== t38 || $[92] !== t39 || $[93] !== t40 ? (t41 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, justify: "flex-end", children: [
    t33,
    t34,
    actionNodes,
    t35,
    t36,
    t37,
    t38,
    t39,
    t40
  ] }) }), $[87] = actionNodes, $[88] = t33, $[89] = t35, $[90] = t37, $[91] = t38, $[92] = t39, $[93] = t40, $[94] = t41) : t41 = $[94];
  let t42;
  $[95] !== t29 || $[96] !== t31 || $[97] !== t41 ? (t42 = /* @__PURE__ */ jsxs(NavGrid, { gap: 1, children: [
    t29,
    t31,
    t41
  ] }), $[95] = t29, $[96] = t31, $[97] = t41, $[98] = t42) : t42 = $[98];
  let t43;
  $[99] !== t22 || $[100] !== t42 ? (t43 = /* @__PURE__ */ jsx(RootCard, { tone: t22, borderBottom: !0, "data-testid": "studio-navbar", "data-ui": "Navbar", padding: 3, sizing: "border", children: t42 }), $[99] = t22, $[100] = t42, $[101] = t43) : t43 = $[101];
  let t44;
  $[102] !== actions || $[103] !== activeToolName || $[104] !== drawerOpen || $[105] !== handleCloseDrawer || $[106] !== shouldRender.tools || $[107] !== tools ? (t44 = !shouldRender.tools && /* @__PURE__ */ jsx(NavDrawer, { __internal_actions: actions, activeToolName, isOpen: drawerOpen, onClose: handleCloseDrawer, tools }), $[102] = actions, $[103] = activeToolName, $[104] = drawerOpen, $[105] = handleCloseDrawer, $[106] = shouldRender.tools, $[107] = tools, $[108] = t44) : t44 = $[108];
  let t45;
  return $[109] !== searchFullscreenOpen || $[110] !== t43 || $[111] !== t44 ? (t45 = /* @__PURE__ */ jsx(FreeTrialProvider, { children: /* @__PURE__ */ jsxs(RootLayer, { zOffset: 100, "data-search-open": searchFullscreenOpen, children: [
    t43,
    t44
  ] }) }), $[109] = searchFullscreenOpen, $[110] = t43, $[111] = t44, $[112] = t45) : t45 = $[112], t45;
}
function _temp2$6(action) {
  const {
    render: ActionComponent
  } = action;
  return ActionComponent ? /* @__PURE__ */ jsx(ActionComponent, {}, action.name) : /* @__PURE__ */ jsx(Button, { iconRight: action?.icon, mode: "bleed", onClick: action?.onAction, selected: action.selected, text: action.title }, action.name);
}
function _temp$g(v) {
  return v.location === "topbar";
}
const SCHEDULED_PUBLISHING_TOOL_NAME = "schedules";
function _isReactElement(node) {
  return !!node;
}
const OptionObserveElement = styled(ObserveElement).withConfig({
  displayName: "OptionObserveElement",
  componentId: "sc-1w3wepe-0"
})`list-style:none;white-space:nowrap;flex-shrink:0;opacity:0;visibility:hidden;`, HiddenRow = styled(Flex).withConfig({
  displayName: "HiddenRow",
  componentId: "sc-1w3wepe-1"
})`opacity:0;height:0.1px;overflow:hidden;`, CollapseTabList = forwardRef(function(props2, ref) {
  const $ = c(55);
  let childrenProp, collapsed, disableRestoreFocusOnClose, gap, menuButtonProps, onMenuClose, rest;
  $[0] !== props2 ? ({
    children: childrenProp,
    gap,
    menuButtonProps,
    disableRestoreFocusOnClose,
    onMenuClose,
    collapsed,
    ...rest
  } = props2, $[0] = props2, $[1] = childrenProp, $[2] = collapsed, $[3] = disableRestoreFocusOnClose, $[4] = gap, $[5] = menuButtonProps, $[6] = onMenuClose, $[7] = rest) : (childrenProp = $[1], collapsed = $[2], disableRestoreFocusOnClose = $[3], gap = $[4], menuButtonProps = $[5], onMenuClose = $[6], rest = $[7]);
  const [rootEl, setRootEl] = useState(null);
  let t0;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[8] = t0) : t0 = $[8];
  const [hiddenElements, setHiddenElements] = useState(t0), [showChildren, setShowChildren] = useState(!1);
  let t1;
  $[9] !== childrenProp ? (t1 = Children.toArray(childrenProp).filter(_isReactElement), $[9] = childrenProp, $[10] = t1) : t1 = $[10];
  const children = t1;
  let t2;
  bb0: {
    if (collapsed) {
      t2 = null;
      break bb0;
    }
    if (!showChildren) {
      t2 = null;
      break bb0;
    }
    let t32;
    if ($[11] !== children || $[12] !== hiddenElements) {
      let t42;
      $[14] !== hiddenElements ? (t42 = (c2) => !hiddenElements.some((h) => h.key === c2.key), $[14] = hiddenElements, $[15] = t42) : t42 = $[15], t32 = children.filter(t42), $[11] = children, $[12] = hiddenElements, $[13] = t32;
    } else
      t32 = $[13];
    t2 = t32;
  }
  const displayChildren = t2;
  let t3;
  $[16] !== rootEl ? (t3 = {
    root: rootEl,
    threshold: 1,
    rootMargin: "1px"
  }, $[16] = rootEl, $[17] = t3) : t3 = $[17];
  const intersectionOptions = t3;
  let t4;
  $[18] !== menuButtonProps?.button ? (t4 = menuButtonProps?.button || /* @__PURE__ */ jsx(ContextMenuButton, {}), $[18] = menuButtonProps?.button, $[19] = t4) : t4 = $[19];
  const menuButton = t4;
  let t5;
  $[20] !== children || $[21] !== collapsed || $[22] !== hiddenElements ? (t5 = collapsed ? children : children.filter((t62) => {
    const {
      key
    } = t62;
    return hiddenElements.find((o) => o.key === key);
  }), $[20] = children, $[21] = collapsed, $[22] = hiddenElements, $[23] = t5) : t5 = $[23];
  const menuOptionsArray = t5;
  let t6;
  $[24] !== hiddenElements || $[25] !== showChildren ? (t6 = (e, child) => {
    const isHidden = hiddenElements.some((el) => el.key === child.key);
    showChildren || setShowChildren(!0);
    const isIntersecting = e.isIntersecting;
    !isHidden && !isIntersecting && setHiddenElements((prev) => [...prev, child]), isHidden && isIntersecting && setHiddenElements((prev_0) => prev_0.filter((el_0) => el_0.key !== child.key));
  }, $[24] = hiddenElements, $[25] = showChildren, $[26] = t6) : t6 = $[26];
  const handleIntersection = t6;
  let t7;
  $[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    position: "relative"
  }, $[27] = t7) : t7 = $[27];
  let t8;
  $[28] !== collapsed || $[29] !== disableRestoreFocusOnClose || $[30] !== hiddenElements.length || $[31] !== menuButton || $[32] !== menuButtonProps || $[33] !== menuOptionsArray || $[34] !== onMenuClose ? (t8 = (hiddenElements.length > 0 || collapsed) && /* @__PURE__ */ jsx(CollapseOverflowMenu, { disableRestoreFocusOnClose, menuButton, menuButtonProps, menuOptions: menuOptionsArray, onMenuClose }), $[28] = collapsed, $[29] = disableRestoreFocusOnClose, $[30] = hiddenElements.length, $[31] = menuButton, $[32] = menuButtonProps, $[33] = menuOptionsArray, $[34] = onMenuClose, $[35] = t8) : t8 = $[35];
  let t9;
  $[36] !== displayChildren || $[37] !== gap || $[38] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { justify: "center", gap, flex: 1, children: [
    displayChildren,
    t8
  ] }), $[36] = displayChildren, $[37] = gap, $[38] = t8, $[39] = t9) : t9 = $[39];
  let t10;
  $[40] !== menuButton ? (t10 = cloneElement(menuButton, {
    disabled: !0,
    "aria-hidden": !0
  }), $[40] = menuButton, $[41] = t10) : t10 = $[41];
  let t11;
  $[42] !== children || $[43] !== handleIntersection || $[44] !== intersectionOptions ? (t11 = children?.map((child_0) => /* @__PURE__ */ jsx(OptionObserveElement, { options: intersectionOptions, onIntersectionChange: (e_0) => handleIntersection(e_0[0], child_0), children: cloneElement(child_0, {
    disabled: !0,
    "aria-hidden": !0,
    tabIndex: -1
  }) }, `${child_0.key}_observer`)), $[42] = children, $[43] = handleIntersection, $[44] = intersectionOptions, $[45] = t11) : t11 = $[45];
  let t12;
  $[46] !== gap || $[47] !== t10 || $[48] !== t11 ? (t12 = /* @__PURE__ */ jsxs(HiddenRow, { justify: "flex-start", gap, ref: setRootEl, "data-hidden": !0, "aria-hidden": "true", children: [
    t10,
    t11
  ] }), $[46] = gap, $[47] = t10, $[48] = t11, $[49] = t12) : t12 = $[49];
  let t13;
  return $[50] !== ref || $[51] !== rest || $[52] !== t12 || $[53] !== t9 ? (t13 = /* @__PURE__ */ jsxs(Flex, { direction: "column", ref, sizing: "border", style: t7, ...rest, children: [
    t9,
    t12
  ] }), $[50] = ref, $[51] = rest, $[52] = t12, $[53] = t9, $[54] = t13) : t13 = $[54], t13;
});
function ToolCollapseMenu(props2) {
  const $ = c(13), {
    activeToolName,
    tools
  } = props2, scheme = useColorSchemeValue(), [collapseMenuEl, setCollapseMenuEl] = useState(null);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = ["arrows"], $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== collapseMenuEl ? (t1 = {
    rootElement: collapseMenuEl,
    navigation: t0
  }, $[1] = collapseMenuEl, $[2] = t1) : t1 = $[2], useRovingFocus(t1);
  let t2;
  $[3] !== scheme ? (t2 = {
    popover: {
      constrainSize: !0,
      portal: !0,
      scheme,
      tone: "default"
    }
  }, $[3] = scheme, $[4] = t2) : t2 = $[4];
  const menuButtonProps = t2;
  let t3;
  if ($[5] !== activeToolName || $[6] !== tools) {
    let t42;
    $[8] !== activeToolName ? (t42 = (tool, index) => {
      const title = tool?.title || startCase(tool.name), Link2 = forwardRef(function(linkProps, ref) {
        return /* @__PURE__ */ jsx(ToolLink, { ...linkProps, ref, name: tool.name, children: linkProps.children });
      });
      return /* @__PURE__ */ jsx(Button, { as: Link2, "data-as": "a", mode: "bleed", selected: activeToolName === tool.name, text: title }, `${tool.name}-${index}`);
    }, $[8] = activeToolName, $[9] = t42) : t42 = $[9], t3 = tools.map(t42), $[5] = activeToolName, $[6] = tools, $[7] = t3;
  } else
    t3 = $[7];
  const children = t3;
  let t4;
  return $[10] !== children || $[11] !== menuButtonProps ? (t4 = /* @__PURE__ */ jsx(Flex, { justify: "center", marginX: 4, children: /* @__PURE__ */ jsx(CollapseTabList, { "data-testid": "tool-collapse-menu", gap: 1, menuButtonProps, ref: setCollapseMenuEl, children }) }), $[10] = children, $[11] = menuButtonProps, $[12] = t4) : t4 = $[12], t4;
}
function ToolVerticalMenu(props2) {
  const $ = c(9), {
    activeToolName,
    isVisible: isVisible2,
    tools
  } = props2;
  let t0;
  if ($[0] !== activeToolName || $[1] !== isVisible2 || $[2] !== tools) {
    let t12;
    $[4] !== activeToolName || $[5] !== isVisible2 ? (t12 = (tool) => {
      const title = tool?.title || startCase(tool.name), Link2 = forwardRef(function(linkProps, ref) {
        return /* @__PURE__ */ jsx(ToolLink, { ...linkProps, ref, name: tool.name, children: linkProps.children });
      });
      return /* @__PURE__ */ jsx(Stack, { as: "li", children: /* @__PURE__ */ jsx(Button, { as: Link2, justify: "flex-start", mode: "bleed", selected: activeToolName === tool.name, size: "large", tabIndex: isVisible2 ? 0 : -1, text: title }) }, tool.name);
    }, $[4] = activeToolName, $[5] = isVisible2, $[6] = t12) : t12 = $[6], t0 = tools.map(t12), $[0] = activeToolName, $[1] = isVisible2, $[2] = tools, $[3] = t0;
  } else
    t0 = $[3];
  let t1;
  return $[7] !== t0 ? (t1 = /* @__PURE__ */ jsx(Stack, { as: "ul", space: 1, children: t0 }), $[7] = t0, $[8] = t1) : t1 = $[8], t1;
}
function StudioToolMenu(props2) {
  const $ = c(17);
  let context, isSidebarOpen, restProps, tools;
  $[0] !== props2 ? ({
    context,
    isSidebarOpen,
    tools,
    ...restProps
  } = props2, $[0] = props2, $[1] = context, $[2] = isSidebarOpen, $[3] = restProps, $[4] = tools) : (context = $[1], isSidebarOpen = $[2], restProps = $[3], tools = $[4]);
  const {
    enabled: scheduledPublishingEnabled
  } = useScheduledPublishingEnabled();
  let t0;
  if ($[5] !== scheduledPublishingEnabled || $[6] !== tools) {
    let t12;
    $[8] !== scheduledPublishingEnabled ? (t12 = (tool) => !(tool.name === SCHEDULED_PUBLISHING_TOOL_NAME && !scheduledPublishingEnabled), $[8] = scheduledPublishingEnabled, $[9] = t12) : t12 = $[9], t0 = tools.filter(t12), $[5] = scheduledPublishingEnabled, $[6] = tools, $[7] = t0;
  } else
    t0 = $[7];
  const visibleTools = t0;
  if (visibleTools.length <= 1)
    return null;
  if (context === "sidebar") {
    let t12;
    return $[10] !== isSidebarOpen || $[11] !== restProps || $[12] !== visibleTools ? (t12 = /* @__PURE__ */ jsx(ToolVerticalMenu, { isVisible: isSidebarOpen, tools: visibleTools, ...restProps }), $[10] = isSidebarOpen, $[11] = restProps, $[12] = visibleTools, $[13] = t12) : t12 = $[13], t12;
  }
  let t1;
  return $[14] !== restProps || $[15] !== visibleTools ? (t1 = /* @__PURE__ */ jsx(ToolCollapseMenu, { tools: visibleTools, ...restProps }), $[14] = restProps, $[15] = visibleTools, $[16] = t1) : t1 = $[16], t1;
}
const FieldCopied = defineEvent({
  name: "Field Copied",
  version: 1,
  description: 'User clicked the "Copy field" button in the field action menu or used the Ctrl+C shortcut'
}), FieldPasted = defineEvent({
  name: "Field Pasted",
  version: 1,
  description: 'User clicked the "Paste field" button in the field action menu or used the Ctrl+V shortcut'
}), MIMETYPE_SANITY_CLIPBOARD = "web application/vnd.sanity-clipboard-item+json", MIMETYPE_HTML = "text/html", MIMETYPE_PLAINTEXT = "text/plain", MIMETYPE_PORTABLE_TEXT = "web application/x-portable-text", SUPPORTS_SANITY_CLIPBOARD_MIMETYPE = typeof ClipboardItem < "u" && "supports" in ClipboardItem && ClipboardItem.supports(MIMETYPE_SANITY_CLIPBOARD), SUPPORTS_PORTABLE_TEXT_MIMETYPE = typeof ClipboardItem < "u" && "supports" in ClipboardItem && ClipboardItem.supports(MIMETYPE_PORTABLE_TEXT), BASE64_ATTR = "sanity-clipboard-base64";
async function getClipboardItem() {
  const items = await navigator.clipboard.read();
  for (const item of items) {
    const sanityClipboardItem = await parseClipboardItem(item);
    if (sanityClipboardItem)
      return sanityClipboardItem;
  }
  return null;
}
function isTypedObject(value) {
  return typeof value == "object" && value !== null && "_type" in value;
}
function isPortableTextValue(value) {
  return Array.isArray(value) ? value.some((item) => isTypedObject(item) && isPortableTextBlock(item)) : !1;
}
async function writeClipboardItem(copyActionResult) {
  const textValue = transformValueToText(copyActionResult.value), base64SanityClipboardItem = utf8ToBase64(JSON.stringify(copyActionResult)), isPTE = isPortableTextValue(copyActionResult.value), htmlValue = transformValueToHtml(copyActionResult.value), htmlWithData = `<div data-${BASE64_ATTR}="${base64SanityClipboardItem}">${htmlValue}</div>`, clipboardItem = new ClipboardItem({
    ...SUPPORTS_SANITY_CLIPBOARD_MIMETYPE && {
      [MIMETYPE_SANITY_CLIPBOARD]: new Blob([JSON.stringify(copyActionResult)], {
        type: MIMETYPE_SANITY_CLIPBOARD
      })
    },
    // Include x-portable-text format for PTE-to-PTE paste operations
    ...isPTE && SUPPORTS_PORTABLE_TEXT_MIMETYPE && {
      [MIMETYPE_PORTABLE_TEXT]: new Blob([JSON.stringify(copyActionResult.value)], {
        type: MIMETYPE_PORTABLE_TEXT
      })
    },
    [MIMETYPE_HTML]: new Blob([htmlWithData], {
      type: MIMETYPE_HTML
    }),
    [MIMETYPE_PLAINTEXT]: new Blob([textValue], {
      type: MIMETYPE_PLAINTEXT
    })
  });
  try {
    return await navigator.clipboard.write([clipboardItem]), !0;
  } catch (error) {
    if (error.name === "NotAllowedError")
      throw error;
    return console.error(`Failed to write to clipboard: ${error.message}`, error), !1;
  }
}
async function parseClipboardItem(item) {
  if (item.types.includes(MIMETYPE_SANITY_CLIPBOARD)) {
    const text = await (await item.getType(MIMETYPE_SANITY_CLIPBOARD)).text();
    return JSON.parse(text);
  }
  if (!item.types.includes(MIMETYPE_HTML)) return null;
  const html = await (await item.getType(MIMETYPE_HTML)).text(), doc = new DOMParser().parseFromString(html, "text/html");
  try {
    const el = doc.querySelector(`[data-${BASE64_ATTR}]`);
    if (!el) return null;
    const {
      sanityClipboardBase64
    } = el.dataset;
    return sanityClipboardBase64 ? JSON.parse(base64ToUtf8(sanityClipboardBase64)) : null;
  } catch {
    return null;
  }
}
function utf8ToBase64(text) {
  const uint8Array = new TextEncoder().encode(text);
  let binary = "";
  for (let i = 0; i < uint8Array.byteLength; i++)
    binary += String.fromCharCode(uint8Array[i]);
  return btoa(binary);
}
function base64ToUtf8(base64String) {
  const binary = atob(base64String), uint8Array = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++)
    uint8Array[i] = binary.charCodeAt(i);
  return new TextDecoder().decode(uint8Array);
}
function escapeHtml(text) {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
function transformValueToHtml(value) {
  if (!value) return "";
  if (isString(value)) return `<p>${escapeHtml(value)}</p>`;
  if (Number.isFinite(value)) return `<p>${value}</p>`;
  if (Array.isArray(value)) {
    if (value.some((item) => isTypedObject(item) && isPortableTextBlock(item)))
      return toHTML(value);
    const text = value.map(transformValueToText).filter(Boolean).join(", ");
    return text ? `<p>${escapeHtml(text)}</p>` : "";
  }
  if (typeof value == "object") {
    if (isTypedObject(value) && isPortableTextBlock(value))
      return toHTML([value]);
    const text = Object.entries(value).map(([key, subValue]) => key.startsWith("_") ? "" : transformValueToText(subValue)).filter(Boolean).join(", ");
    return text ? `<p>${escapeHtml(text)}</p>` : "";
  }
  return "";
}
function transformValueToText(value) {
  return value ? isString(value) ? value : Number.isFinite(value) ? value.toString() : Array.isArray(value) ? value.some((item) => isTypedObject(item) && isPortableTextBlock(item)) ? toPlainText(value) : value.map(transformValueToText).filter(Boolean).join(", ") : typeof value == "object" ? isTypedObject(value) && isPortableTextBlock(value) ? toPlainText(value) : Object.entries(value).map(([key, subValue]) => key.startsWith("_") ? "" : transformValueToText(subValue)).filter(Boolean).join(", ") : "" : "";
}
function isEmptyValue(value) {
  if (value == null) return !0;
  if (typeof value == "object") {
    const keys = Object.keys(value);
    if (keys.length === 1 && keys[0] === "_key")
      return !0;
  }
  return !!(Array.isArray(value) && value.length === 0);
}
function isPortableTextPreserveEmptyField(member, targetSchemaType) {
  return member.name === "markDefs" && isBlockSchemaType(targetSchemaType) || member.name === "marks" && isSpanSchemaType(targetSchemaType);
}
function isNativeEditableElement(el) {
  return !!(el instanceof HTMLElement && el.isContentEditable || el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement);
}
function hasSelection() {
  if (typeof window > "u" || !window.getSelection) return !1;
  const selection = window.getSelection();
  return selection !== null && !selection.isCollapsed;
}
function isEmptyFocusPath(path) {
  return path.length === 0 || path.length === 1 && path[0] === "";
}
async function documentMatchesGroqFilter(ctx) {
  const {
    targetRootPath,
    rootDocumentValue,
    referencedDocument,
    getClient: getClient2,
    schemaTypeOptions
  } = ctx;
  if (!schemaTypeOptions.filter)
    return !0;
  const options = await resolveUserDefinedFilter$2({
    options: schemaTypeOptions,
    document: rootDocumentValue,
    valuePath: targetRootPath,
    perspective: [],
    getClient: getClient2
  });
  if (!options.filter)
    return !0;
  try {
    const params = options.params || {}, query = `*[${options.filter}]`, tree = parse$1(query, params), result = await (await evaluate(tree, {
      params,
      dataset: [referencedDocument]
    })).get();
    return !isEmptyValue(result);
  } catch (error) {
    return console.error("Error evaluating GROQ filter:", error), !1;
  }
}
function getObjectTypeFromPath(path) {
  if (path.length === 0)
    return "object";
  const lastPathSegment = path[path.length - 1];
  return isKeySegment(lastPathSegment) || isIndexSegment(lastPathSegment) || isIndexTuple(lastPathSegment) ? "object" : lastPathSegment;
}
function isCompatiblePrimitiveType(value, targetJsonTypes) {
  return !!(typeof value == "string" && targetJsonTypes.includes("string") || typeof value == "number" && (targetJsonTypes.includes("number") || targetJsonTypes.includes("string")) || typeof value == "boolean" && targetJsonTypes.includes("boolean"));
}
function isNumberToStringSchemaType(a, b) {
  return isRecord$4(a) && isRecord$4(b) && (a.jsonType === "number" && b.jsonType === "string" || isNumberToStringSchemaType(a.type, b.type));
}
function arrayJsonTypes(schemaType) {
  return schemaType.of.map((type) => type.jsonType);
}
function isNumberToArrayOfStrings(a, b) {
  return isRecord$4(a) && isRecord$4(b) && (a.jsonType === "number" && isArrayOfPrimitivesSchemaType(b) && arrayJsonTypes(b).includes("string") || isNumberToArrayOfStrings(a.type, b.type));
}
const defaultKeyGenerator = () => randomKey(12);
function resolveReadOnlyAncestor({
  path,
  value,
  schemaType,
  currentUser
}) {
  return !!path.find((_, index) => {
    const currentPath = path.slice(0, index + 1), schemaTypeAtPath = resolveSchemaTypeForPath(schemaType, currentPath, value);
    if (!schemaTypeAtPath)
      throw new Error(`Could not find target schema type at path ${path.join(".")}`);
    return resolveConditionalProperty(schemaTypeAtPath.readOnly, {
      value,
      parent: null,
      document: value,
      currentUser,
      path: currentPath
    });
  });
}
async function transferValue({
  sourceRootSchemaType,
  sourcePath,
  sourceValue,
  sourceRootPath = [],
  targetRootSchemaType,
  targetRootValue,
  targetRootPath,
  targetValue,
  targetPath,
  keyGenerator: keyGenerator2 = defaultKeyGenerator,
  targetDocumentSchemaType,
  currentUser,
  options = {
    validateReferences: !0,
    validateAssets: !0,
    client: void 0
  }
}) {
  const errors = [];
  if (!sourceRootSchemaType)
    throw new Error("Source root schema type is not defined");
  if (!targetRootSchemaType)
    throw new Error("Target root schema type is not defined");
  const sourceSchemaTypeAtPath = resolveSchemaTypeForPath(sourceRootSchemaType, sourcePath, sourceValue), targetSchemaTypeAtPath = resolveSchemaTypeForPath(targetRootSchemaType, targetPath, targetValue);
  if (!sourceSchemaTypeAtPath)
    throw new Error("Could not find source schema type at path");
  if (!targetSchemaTypeAtPath)
    throw new Error("Could not find target schema type at path");
  const targetRootSchemaTypeReadOnly = resolveConditionalProperty(targetRootSchemaType.readOnly, {
    value: targetRootValue,
    parent: null,
    document: targetRootValue,
    currentUser,
    path: targetRootPath
  }), targetSchemaTypeAtPathReadOnly = resolveConditionalProperty(targetSchemaTypeAtPath.readOnly, {
    value: targetValue,
    parent: null,
    document: targetRootValue,
    currentUser,
    path: targetPath
  }), isAncestorReadOnly = resolveReadOnlyAncestor({
    path: targetRootPath,
    value: targetRootValue,
    schemaType: targetDocumentSchemaType,
    currentUser
  });
  if (targetRootSchemaTypeReadOnly || targetSchemaTypeAtPathReadOnly || isAncestorReadOnly)
    return {
      targetValue: void 0,
      errors: [{
        level: "error",
        sourceValue,
        i18n: {
          key: "copy-paste.on-paste.validation.read-only-target.description"
        }
      }]
    };
  if (isFileSchemaType(sourceSchemaTypeAtPath) && isImageSchemaType(targetSchemaTypeAtPath) || isImageSchemaType(sourceSchemaTypeAtPath) && isFileSchemaType(targetSchemaTypeAtPath))
    return {
      targetValue: void 0,
      errors: [{
        level: "error",
        sourceValue,
        i18n: {
          key: "copy-paste.on-paste.validation.image-file-incompatible.description",
          args: {
            sourceSchemaType: sourceRootSchemaType.name,
            targetSchemaType: targetRootSchemaType.name
          }
        }
      }]
    };
  const sourceJsonType = sourceSchemaTypeAtPath.jsonType, targetJsonType = targetSchemaTypeAtPath.jsonType, lastSourcePathSegment = last$1(sourceRootPath), isIndexSourcePathSegmentKey = typeof lastSourcePathSegment < "u" && isIndexSegment(lastSourcePathSegment), isSourceSinglePrimitiveArrayItem = sourcePath.length === 0 && sourceJsonType === "array" && !Array.isArray(sourceValue) && isIndexSourcePathSegmentKey, isPrimitiveSourceAndPrimitiveArrayTarget = (["number", "string", "boolean"].includes(sourceJsonType) || isSourceSinglePrimitiveArrayItem) && isArrayOfPrimitivesSchemaType(targetSchemaTypeAtPath), isObjectSourceAndArrayOfObjectsTarget = sourceJsonType === "object" && isArrayOfObjectsSchemaType(targetSchemaTypeAtPath);
  if (!(sourceJsonType === targetJsonType || isNumberToStringSchemaType(sourceSchemaTypeAtPath, targetSchemaTypeAtPath) || isNumberToArrayOfStrings(sourceSchemaTypeAtPath, targetSchemaTypeAtPath) || isPrimitiveSourceAndPrimitiveArrayTarget || isObjectSourceAndArrayOfObjectsTarget))
    return {
      targetValue: void 0,
      errors: [{
        level: "error",
        sourceValue,
        i18n: {
          key: "copy-paste.on-paste.validation.schema-type-incompatible.description"
        }
      }]
    };
  const sourceValueAtPath = getValueAtPath(sourceValue, sourcePath);
  if (sourceSchemaTypeAtPath.jsonType === "object" && targetSchemaTypeAtPath.jsonType === "object")
    return collateObjectValue({
      sourceValue: sourceValueAtPath,
      targetSchemaType: targetSchemaTypeAtPath,
      targetRootValue,
      targetRootPath,
      targetPath: [],
      errors,
      keyGenerator: keyGenerator2,
      options
    });
  if (sourceSchemaTypeAtPath.jsonType === "array" && targetSchemaTypeAtPath.jsonType === "array") {
    const wrappedSourceValueAtPath = isSourceSinglePrimitiveArrayItem && !Array.isArray(sourceValueAtPath) ? [sourceValueAtPath] : sourceValueAtPath;
    return collateArrayValue({
      sourceValue: wrappedSourceValueAtPath,
      targetSchemaType: targetSchemaTypeAtPath,
      targetRootValue,
      targetRootPath,
      errors,
      options,
      keyGenerator: keyGenerator2
    });
  }
  if (isPrimitiveSourceAndPrimitiveArrayTarget || isObjectSourceAndArrayOfObjectsTarget) {
    let objectType;
    isObjectSourceAndArrayOfObjectsTarget && isTypedObject$1(sourceValueAtPath) && sourceValueAtPath._type === "object" || !isTypedObject$1(sourceValueAtPath) ? objectType = getObjectTypeFromPath(sourceRootPath) : isTypedObject$1(sourceValueAtPath) ? objectType = sourceValueAtPath._type : objectType = "object";
    const wrappedSourceValue = isObjectSourceAndArrayOfObjectsTarget && !Array.isArray(sourceValueAtPath) ? [{
      ...sourceValueAtPath,
      _type: objectType,
      _key: keyGenerator2()
    }] : [sourceValueAtPath];
    return collateArrayValue({
      sourceValue: Array.isArray(sourceValueAtPath) ? sourceValueAtPath : wrappedSourceValue,
      targetSchemaType: targetSchemaTypeAtPath,
      targetRootValue,
      targetRootPath,
      errors,
      options,
      keyGenerator: keyGenerator2
    });
  }
  return collatePrimitiveValue({
    sourceValue: sourceValueAtPath,
    targetSchemaType: targetSchemaTypeAtPath,
    errors
  });
}
async function collateObjectValue({
  sourceValue,
  targetSchemaType,
  targetPath,
  targetRootValue,
  targetRootPath,
  errors,
  keyGenerator: keyGenerator2,
  options
}) {
  if (isEmptyValue(sourceValue))
    return {
      targetValue: void 0,
      errors
    };
  const targetValue = {
    // Only set _type if the source value had one (preserves anonymous objects)
    ...isTypedObject$1(sourceValue) ? {
      _type: targetSchemaType.name
    } : {},
    ...sourceValue && typeof sourceValue == "object" && "_key" in sourceValue ? {
      _key: keyGenerator2()
    } : {}
  }, sourceValueRef = isAssetObjectStub(sourceValue) && isReference$1(sourceValue.asset) ? sourceValue.asset._ref : void 0, sourceValueType = isTypedObject$1(sourceValue) ? sourceValue._type : void 0, isImageRef = sourceValueRef && isImageAssetId(sourceValueRef), isFileRef = sourceValueRef && isFileAssetId(sourceValueRef), isIncompatibleImageRef = (sourceValueType === "image" || isImageRef) && !isImageSchemaType(targetSchemaType), isIncompatibleFileRef = (sourceValueType === "file" || isFileRef) && !isFileSchemaType(targetSchemaType);
  if (isTypedObject$1(sourceValue) && (isIncompatibleImageRef || isIncompatibleFileRef))
    return errors.push({
      level: "error",
      sourceValue,
      i18n: {
        key: "copy-paste.on-paste.validation.image-file-incompatible.description",
        args: {
          sourceSchemaType: sourceValueType,
          targetSchemaType: targetSchemaType.name
        }
      }
    }), {
      targetValue: void 0,
      errors
    };
  if (options?.validateAssets && options.client && (isImageSchemaType(targetSchemaType) || isFileSchemaType(targetSchemaType)) && targetSchemaType.options?.accept && isAssetObjectStub(sourceValue) && isReference$1(sourceValue.asset)) {
    const sourceRef = sourceValue.asset?._ref;
    if (!sourceRef)
      return {
        targetValue: void 0,
        errors
      };
    try {
      const assetType = isImageSchemaType(targetSchemaType) ? "sanity.imageAsset" : "sanity.fileAsset", asset = await options.client.fetch("*[_type == $type &&_id == $ref][0]{mimeType, originalFilename}", {
        ref: sourceRef,
        type: assetType
      });
      if (!asset)
        return {
          targetValue: void 0,
          errors
        };
      const fileLike = {
        type: asset.mimeType,
        name: asset.originalFilename
      }, mimeType = asset.mimeType;
      if (!accepts(fileLike, targetSchemaType.options.accept))
        return errors.push({
          level: "error",
          sourceValue,
          i18n: {
            key: "copy-paste.on-paste.validation.mime-type-incompatible.description",
            args: {
              mimeType
            }
          }
        }), {
          targetValue: void 0,
          errors
        };
    } catch (error) {
      return console.error("Error fetching asset document:", error), errors.push({
        level: "error",
        sourceValue,
        i18n: {
          key: "copy-paste.on-paste.validation.mime-type-validation-failed.description"
        }
      }), {
        targetValue: void 0,
        errors
      };
    }
  }
  if (isReferenceSchemaType(targetSchemaType)) {
    const targetReferenceTypes = targetSchemaType.to.map((type) => type.name);
    if (options?.validateReferences && options.client && isReference$1(sourceValue))
      try {
        const query = targetSchemaType.options?.filter ? "*[_id in $ids]|order(_updatedAt)[0]" : "*[_id in $ids]|order(_updatedAt)[0]{_id, _type}", {
          publishedId,
          draftId
        } = getIdPair(sourceValue._ref), reference = await options.client.fetch(query, {
          ids: [publishedId, draftId]
        });
        if (!reference && !targetSchemaType.weak)
          return errors.push({
            level: "error",
            sourceValue,
            i18n: {
              key: "copy-paste.on-paste.validation.reference-validation-failed.description",
              args: {
                ref: sourceValue._ref
              }
            }
          }), {
            targetValue: void 0,
            errors
          };
        if (reference && !targetReferenceTypes.includes(reference._type))
          return errors.push({
            level: "error",
            sourceValue,
            i18n: {
              key: "copy-paste.on-paste.validation.reference-type-incompatible.description",
              args: {
                sourceReferenceType: reference._type,
                targetReferenceTypes: targetReferenceTypes.join(", ")
              }
            }
          }), {
            targetValue: void 0,
            errors
          };
        if (options.client && targetSchemaType.options?.filter) {
          const getClient2 = (clientOptions2) => options.client.withConfig(clientOptions2);
          if (!await documentMatchesGroqFilter({
            rootDocumentValue: targetRootValue || {},
            referencedDocument: reference,
            schemaTypeOptions: targetSchemaType.options,
            targetRootPath,
            getClient: getClient2
          }))
            return errors.push({
              level: "error",
              sourceValue,
              i18n: {
                key: "copy-paste.on-paste.validation.reference-filter-incompatible.description"
              }
            }), {
              targetValue: void 0,
              errors
            };
        }
      } catch (error) {
        return console.error("Error fetching reference document:", error), errors.push({
          level: "error",
          sourceValue: targetValue,
          i18n: {
            key: "copy-paste.on-paste.validation.reference-validation-failed.description",
            args: {
              ref: sourceValue._ref
            }
          }
        }), {
          targetValue: void 0,
          errors
        };
      }
  }
  const markDefKeyMap = {}, isPortableTextBlockWithMarkdefs = isBlockSchemaType(targetSchemaType) && isPortableTextTextBlock(sourceValue) && !isEmptyValue(sourceValue.markDefs);
  if (isPortableTextBlockWithMarkdefs) {
    const markDefs = sourceValue.markDefs || [];
    markDefs.filter((item) => item._key).forEach((item) => {
      markDefKeyMap[item._key] = keyGenerator2();
    }), targetValue.markDefs = markDefs.map((item) => ({
      ...item,
      _key: markDefKeyMap[item._key]
    }));
  }
  const objectMembers = targetSchemaType.fields;
  for (const member of objectMembers) {
    const memberSchemaType = member.type, memberIsArray = isArraySchemaType(memberSchemaType), memberIsObject = isObjectSchemaType(memberSchemaType);
    if (isPrimitiveSchemaType(memberSchemaType)) {
      const genericValue = sourceValue ? sourceValue[member.name] : void 0, collated = collatePrimitiveValue({
        sourceValue: genericValue,
        targetSchemaType: memberSchemaType,
        errors
      });
      isEmptyValue(collated.targetValue) || (targetValue[member.name] = collated.targetValue);
    } else if (memberIsObject) {
      const collated = await collateObjectValue({
        sourceValue: getValueAtPath(sourceValue, targetPath.concat(member.name)),
        targetPath: [],
        targetSchemaType: memberSchemaType,
        targetRootValue,
        targetRootPath,
        errors,
        options,
        keyGenerator: keyGenerator2
      });
      isEmptyValue(collated.targetValue) || (targetValue[member.name] = cleanObjectKeys(collated.targetValue));
    } else if (memberIsArray) {
      const genericValue = sourceValue ? sourceValue[member.name] : void 0, collated = await collateArrayValue({
        sourceValue: genericValue,
        targetSchemaType: memberSchemaType,
        targetRootValue,
        targetRootPath,
        errors,
        options,
        keyGenerator: keyGenerator2
      });
      if (isPortableTextBlockWithMarkdefs && member.name === "markDefs" && !isEmptyValue(targetValue.markDefs))
        continue;
      const shouldPreserveEmptyArray = Array.isArray(genericValue) && genericValue.length === 0 && isPortableTextPreserveEmptyField(member, targetSchemaType);
      isEmptyValue(collated.targetValue) ? shouldPreserveEmptyArray && (targetValue[member.name] = []) : targetValue[member.name] = collated.targetValue;
    }
  }
  const valueAtTargetPath = getValueAtPath(targetValue, targetPath), resultingValue = cleanObjectKeys(valueAtTargetPath);
  return Object.keys(markDefKeyMap).length > 0 && isPortableTextTextBlock(resultingValue) && (resultingValue.children = resultingValue.children.map((child) => isPortableTextSpan(child) && child.marks ? {
    ...child,
    marks: child.marks.map((markKey) => markDefKeyMap[markKey] || markKey)
  } : child)), isReferenceSchemaType(targetSchemaType) && (targetSchemaType.weak ? resultingValue._weak = !0 : delete resultingValue._weak), isReferenceSchemaType(targetSchemaType) && isReference$1(sourceValue) && sourceValue._strengthenOnPublish && (resultingValue._weak = !0, resultingValue._strengthenOnPublish = sourceValue._strengthenOnPublish), {
    targetValue: resultingValue,
    errors
  };
}
function findMatchingArrayMemberType(item, targetSchemaType) {
  const itemTypeName = resolveTypeName$1(item);
  return targetSchemaType.of.find((type) => type.name === itemTypeName);
}
async function collateArrayValue({
  sourceValue,
  targetSchemaType,
  targetRootValue,
  targetRootPath,
  errors,
  options,
  keyGenerator: keyGenerator2
}) {
  let targetValue;
  const genericValue = sourceValue;
  if (!genericValue || !Array.isArray(genericValue))
    return {
      targetValue: void 0,
      errors: [{
        level: "error",
        sourceValue,
        i18n: {
          key: "copy-paste.on-paste.validation.array-type-incompatible.description",
          args: {
            type: typeof genericValue
          }
        }
      }]
    };
  const isArrayOfPrimitivesMember = isArrayOfPrimitivesSchemaType(targetSchemaType), isArrayOfObjectsMember = isArrayOfObjectsSchemaType(targetSchemaType);
  if (isArrayOfPrimitivesMember) {
    const jsonTypes = targetSchemaType.of.map((type) => type.jsonType), isNumberCompatible = jsonTypes.includes("number"), transferredItems = genericValue.filter((item) => isCompatiblePrimitiveType(item, jsonTypes)).map((item) => !isNumberCompatible && typeof item == "number" ? `${item}` : item), nonTransferredItems = genericValue.filter((item) => !transferredItems.includes(!isNumberCompatible && typeof item == "number" ? `${item}` : item));
    nonTransferredItems.length > 0 && nonTransferredItems.forEach((item) => {
      errors.push({
        level: transferredItems.length > 0 ? "warning" : "error",
        sourceValue: item,
        i18n: {
          key: "copy-paste.on-paste.validation.array-value-incompatible.description",
          args: {
            type: typeof item
          }
        }
      });
    }), transferredItems.length > 0 && (targetValue = transferredItems);
  }
  if (isArrayOfObjectsMember) {
    const value = sourceValue, transferredItems = value.filter((item) => findMatchingArrayMemberType(item, targetSchemaType) !== void 0), nonTransferredItems = value.filter((item) => findMatchingArrayMemberType(item, targetSchemaType) === void 0);
    transferredItems.length === 0 ? targetValue = void 0 : targetValue = (await Promise.all(transferredItems.map((item) => collateObjectValue({
      sourceValue: item,
      targetSchemaType: findMatchingArrayMemberType(item, targetSchemaType),
      targetPath: [],
      targetRootValue,
      targetRootPath,
      errors,
      options,
      keyGenerator: keyGenerator2
    })))).map((item) => item.targetValue).filter((item) => !isEmptyValue(item)), nonTransferredItems.length > 0 && nonTransferredItems.forEach((item) => {
      errors.push({
        level: transferredItems.length > 0 ? "warning" : "error",
        sourceValue: item,
        i18n: {
          key: "copy-paste.on-paste.validation.array-value-incompatible.description",
          args: {
            type: resolveTypeName$1(item)
          }
        }
      });
    });
  }
  return {
    targetValue,
    errors
  };
}
function collatePrimitiveValue({
  sourceValue,
  targetSchemaType,
  errors
}) {
  let targetValue;
  const primitiveValue = sourceValue;
  if (typeof primitiveValue > "u")
    return {
      targetValue: void 0,
      errors
    };
  const isSamePrimitiveType = targetSchemaType.jsonType === typeof primitiveValue, isNumberToString = typeof primitiveValue == "number" && targetSchemaType.jsonType === "string";
  if (isSamePrimitiveType || isNumberToString) {
    const isNumberOrString = typeof primitiveValue == "string" || typeof primitiveValue == "number";
    if ((isNumberSchemaType(targetSchemaType) || isStringSchemaType(targetSchemaType)) && isNumberOrString) {
      const allowedStrings = targetSchemaType.options?.list?.map((item) => typeof item == "string" || typeof item == "number" ? item : item.value) || [];
      allowedStrings.length > 0 && !allowedStrings.includes(primitiveValue) && errors.push({
        level: "error",
        sourceValue: primitiveValue,
        i18n: {
          key: "copy-paste.on-paste.validation.string-value-incompatible.description",
          args: {
            value: primitiveValue,
            allowedStrings
          }
        }
      });
    }
    targetValue = isNumberToString ? `${primitiveValue}` : primitiveValue;
  } else
    errors.push({
      level: "error",
      sourceValue: primitiveValue,
      i18n: {
        key: "copy-paste.on-paste.validation.primitive-type-incompatible.description",
        args: {
          type: typeof primitiveValue
        }
      }
    });
  return {
    targetValue,
    errors
  };
}
function cleanObjectKeys(obj) {
  const disallowedKeys = /* @__PURE__ */ new Set(["_id", "_createdAt", "_updatedAt", "_rev"]);
  return Object.keys(obj).reduce((acc, key) => disallowedKeys.has(key) ? acc : {
    ...acc,
    [key]: obj[key]
  }, {});
}
const CopyPasteProvider = (t0) => {
  const $ = c(20), {
    children
  } = t0, toast = useToast(), telemetry = useTelemetry(), schema2 = useSchema(), currentUser = useCurrentUser(), {
    t
  } = useTranslation("copy-paste"), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), [documentMeta, setDocumentMetaState] = useState(null);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (t22) => {
    const {
      documentId,
      documentType,
      schemaType,
      onChange
    } = t22, processedMeta = {
      documentId: getPublishedId(documentId),
      documentType,
      schemaType,
      onChange
    };
    setDocumentMetaState((prevMeta) => isEqual$1(prevMeta, processedMeta) ? prevMeta : processedMeta);
  }, $[0] = t1) : t1 = $[0];
  const setDocumentMeta = t1;
  let t2;
  $[1] !== documentMeta || $[2] !== t || $[3] !== telemetry || $[4] !== toast ? (t2 = async (path, value, options) => {
    if (!documentMeta)
      return;
    const {
      documentId: documentId_0,
      documentType: documentType_0,
      schemaType: schemaType_0
    } = documentMeta, schemaTypeAtPath = resolveSchemaTypeForPath(schemaType_0, path, value);
    if (!schemaTypeAtPath) {
      toast.push({
        status: "error",
        title: t("copy-paste.on-copy.validation.schema-type-incompatible.title", {
          path: PathUtils.toString(path)
        })
      });
      return;
    }
    const isDocument = schemaTypeAtPath.type?.name === "document", valueAtPath = getValueAtPath(value, path);
    if (isEmptyValue(valueAtPath)) {
      toast.push({
        status: "warning",
        title: t("copy-paste.on-copy.validation.no-value.title")
      });
      return;
    }
    const lastSegment = path.length > 0 ? last$1(path) : void 0, isLastSegmentKeyOrIndex = lastSegment && (isKeySegment(lastSegment) || isIndexSegment(lastSegment)), isAppend = options.context.source === "arrayItem" || isLastSegmentKeyOrIndex || options.patchType === "append", normalizedPath = isAppend && isLastSegmentKeyOrIndex ? path.slice(0, -1) : path, patchType = isAppend ? "append" : "replace", shouldWrapInArray = isLastSegmentKeyOrIndex && !Array.isArray(valueAtPath), payloadValue = {
      type: "sanityClipboardItem",
      documentId: documentId_0,
      documentType: documentType_0,
      isDocument,
      schemaTypeName: schemaTypeAtPath.name,
      valuePath: normalizedPath,
      value: shouldWrapInArray ? [valueAtPath] : valueAtPath,
      patchType
    };
    telemetry.log(FieldCopied, {
      context: options?.context?.source || "unknown",
      schemaTypes: [schemaTypeAtPath.jsonType]
    });
    try {
      await writeClipboardItem(payloadValue) || toast.push({
        status: "error",
        title: t("copy-paste.on-copy.validation.clipboard-not-supported.title"),
        description: t("copy-paste.on-copy.validation.clipboard-not-supported.description")
      });
    } catch (t32) {
      const error = t32;
      if (error.name === "NotAllowedError")
        toast.push({
          status: "error",
          title: t("copy-paste.on-copy.validation.clipboard-not-supported.title"),
          description: t("copy-paste.on-copy.validation.clipboard-not-supported.description")
        });
      else
        throw error;
    }
  }, $[1] = documentMeta, $[2] = t, $[3] = telemetry, $[4] = toast, $[5] = t2) : t2 = $[5];
  const onCopy = t2;
  let t3;
  $[6] !== client || $[7] !== currentUser || $[8] !== documentMeta || $[9] !== schema2 || $[10] !== t || $[11] !== telemetry || $[12] !== toast ? (t3 = async (targetPath, value_0, options_0) => {
    if (!documentMeta)
      return;
    const {
      schemaType: targetDocumentSchemaType,
      onChange: onChange_0
    } = documentMeta, targetSchemaType = resolveSchemaTypeForPath(targetDocumentSchemaType, targetPath, value_0);
    let clipboardItem = null;
    try {
      clipboardItem = await getClipboardItem();
    } catch (t42) {
      t42.name === "NotAllowedError" && toast.push({
        status: "error",
        title: t("copy-paste.on-copy.validation.clipboard-not-supported.title"),
        description: t("copy-paste.on-copy.validation.clipboard-not-supported.description")
      });
      return;
    }
    if (!clipboardItem) {
      toast.push({
        status: "info",
        title: t("copy-paste.on-paste.validation.clipboard-empty.title")
      });
      return;
    }
    if (!clipboardItem.documentType) {
      toast.push({
        status: "error",
        title: t("copy-paste.on-paste.validation.clipboard-invalid.title")
      });
      return;
    }
    const sourceDocumentSchemaType = schema2.get(clipboardItem.documentType);
    if (!sourceDocumentSchemaType) {
      toast.push({
        status: "error",
        title: t("copy-paste.on-paste.validation.clipboard-invalid.title")
      });
      return;
    }
    const updateItems = [], copiedJsonTypes = [], sourceSchemaType = resolveSchemaTypeForPath(sourceDocumentSchemaType, clipboardItem.valuePath, value_0);
    if (!sourceSchemaType) {
      toast.push({
        status: "error",
        title: t("copy-paste.on-paste.validation.schema-type-incompatible.title", {
          path: PathUtils.toString(clipboardItem.valuePath)
        })
      });
      return;
    }
    if (!targetDocumentSchemaType) {
      toast.push({
        status: "error",
        title: t("copy-paste.on-paste.validation.schema-type-incompatible.title", {
          path: PathUtils.toString(targetPath)
        })
      });
      return;
    }
    const targetSchemaTypeTitle = targetSchemaType.title || targetSchemaType.name, transferValueOptions = {
      targetDocumentSchemaType,
      sourceRootSchemaType: sourceSchemaType,
      sourcePath: [],
      sourceRootPath: clipboardItem.valuePath,
      sourceValue: clipboardItem.value,
      targetRootSchemaType: targetSchemaType,
      targetPath: [],
      targetRootPath: targetPath,
      targetRootValue: value_0,
      currentUser,
      options: {
        validateAssets: !0,
        validateReferences: !0,
        client
      }
    };
    copiedJsonTypes.push(sourceSchemaType.jsonType);
    const run = async () => {
      const {
        targetValue,
        errors
      } = await transferValue(transferValueOptions), nonWarningErrors = errors.filter(_temp$f), _isEmptyValue = isEmptyValue(targetValue);
      if (nonWarningErrors.length > 0) {
        const description = t(nonWarningErrors[0].i18n.key, nonWarningErrors[0].i18n.args);
        toast.push({
          status: "error",
          title: t("copy-paste.on-paste.validation.clipboard-invalid.title"),
          description
        });
        return;
      }
      if (errors.length > 0 && !_isEmptyValue) {
        const description_0 = errors.map((error_2) => t(error_2.i18n.key, error_2.i18n.args)).join(", ");
        toast.push({
          status: "warning",
          title: t("copy-paste.on-paste.validation.partial-warning.title"),
          description: description_0
        });
      }
      if (_isEmptyValue) {
        toast.push({
          status: "warning",
          title: t("copy-paste.on-paste.validation.clipboard-empty.title")
        });
        return;
      }
      const patchType_0 = clipboardItem?.patchType || "replace", isAppendable = clipboardItem.schemaTypeName !== "array" && targetSchemaType.jsonType === "array" || patchType_0 === "append", isAppendArray = isAppendable && targetPath.length > 0 && targetSchemaType.jsonType === "array", insertPath = isAppendable && targetPath.length > 0 ? [...targetPath.slice(0, -1), `${targetPath.slice(-1)?.[0]}[-1]`] : targetPath, prefixPatches = targetSchemaType.jsonType === "array" ? [setIfMissing([], targetPath)] : [];
      updateItems.push({
        patches: isAppendArray ? [...prefixPatches, insert$1(targetValue, "after", insertPath)] : [...prefixPatches, set(targetValue, targetPath)],
        targetSchemaTypeTitle
      });
    };
    try {
      await run();
    } catch (t52) {
      const error_3 = t52;
      toast.push({
        status: "error",
        title: error_3.message
      });
      return;
    }
    if (telemetry.log(FieldPasted, {
      context: options_0?.context?.source || "unknown",
      schemaTypes: copiedJsonTypes
    }), updateItems.length) {
      const allPatches = flatten$1(updateItems.map(_temp2$5));
      onChange_0(PatchEvent.from(allPatches));
    }
  }, $[6] = client, $[7] = currentUser, $[8] = documentMeta, $[9] = schema2, $[10] = t, $[11] = telemetry, $[12] = toast, $[13] = t3) : t3 = $[13];
  const onPaste = t3;
  let t4;
  $[14] !== onCopy || $[15] !== onPaste ? (t4 = {
    setDocumentMeta,
    onCopy,
    onPaste
  }, $[14] = onCopy, $[15] = onPaste, $[16] = t4) : t4 = $[16];
  const contextValue = t4;
  let t5;
  return $[17] !== children || $[18] !== contextValue ? (t5 = /* @__PURE__ */ jsx(CopyPasteContext.Provider, { value: contextValue, children }), $[17] = children, $[18] = contextValue, $[19] = t5) : t5 = $[19], t5;
}, useCopyPaste = () => {
  const context = useContext(CopyPasteContext);
  if (!context)
    throw new Error("useCopyPaste must be used within a CopyPasteProvider");
  return context;
};
function _temp$f(error_1) {
  return error_1.level !== "warning";
}
function _temp2$5(t0) {
  const {
    patches
  } = t0;
  return patches;
}
async function generateWorkspaceManifest(workspace, schemaDescriptorId, resolveIcon2) {
  return {
    name: workspace.name,
    projectId: workspace.projectId,
    dataset: workspace.dataset,
    schemaDescriptorId,
    basePath: workspace.basePath || void 0,
    title: workspace.title || void 0,
    subtitle: workspace.subtitle || void 0,
    icon: await resolveIcon2(workspace),
    mediaLibraryId: workspace.mediaLibrary?.enabled ? workspace.mediaLibrary.libraryId : void 0
  };
}
async function generateStudioManifest(options) {
  const {
    workspaces,
    resolveSchemaDescriptorId: resolveSchemaDescriptorId2,
    resolveIcon: resolveIcon2,
    bundleVersion,
    buildId: buildId2
  } = options, workspaceManifests = await Promise.all(workspaces.map(async (workspace) => {
    const schemaDescriptorId = await resolveSchemaDescriptorId2(workspace);
    return schemaDescriptorId ? generateWorkspaceManifest(workspace, schemaDescriptorId, resolveIcon2) : null;
  }));
  return {
    buildId: buildId2,
    bundleVersion,
    workspaces: workspaceManifests.filter((manifest) => manifest !== null)
  };
}
function normalizeIcon(Icon2, title, subtitle = "") {
  return isValidElementType(Icon2) ? /* @__PURE__ */ jsx(Icon2, {}) : isValidElement(Icon2) ? Icon2 : createDefaultIcon(title, subtitle);
}
const resolveIcon = (props2) => {
  try {
    const iconElement = normalizeIcon(props2.icon, props2.title, props2.subtitle), wrappedElement = /* @__PURE__ */ jsx(ThemeProvider, { theme: props2.theme, children: iconElement });
    return renderToStaticMarkup(wrappedElement).trim() || void 0;
  } catch {
    return;
  }
}, buildId = (
  // @ts-expect-error: __SANITY_BUILD_TIMESTAMP__ is a global env variable set by the vite config
  typeof __SANITY_BUILD_TIMESTAMP__ > "u" ? void 0 : `${__SANITY_BUILD_TIMESTAMP__}`
);
async function resolveSource(workspace) {
  const sourceEntry = workspace.__internal.sources[0];
  if (sourceEntry)
    return firstValueFrom(sourceEntry.source);
}
async function resolveSchemaDescriptorId(workspace) {
  return await (await resolveSource(workspace))?.__internal?.schemaDescriptorId;
}
async function registerStudioManifest(userApplication, workspaces, theme) {
  const {
    id: id2,
    projectId
  } = userApplication, workspace = workspaces.find((ws) => ws.projectId === projectId);
  if (!workspace)
    return;
  const liveManifest = await generateStudioManifest({
    workspaces,
    resolveSchemaDescriptorId,
    resolveIcon: (ws) => resolveIcon({
      icon: ws.icon,
      title: ws.title || ws.name,
      subtitle: ws.subtitle,
      theme
    }),
    bundleVersion: SANITY_VERSION,
    buildId
  });
  if (liveManifest.workspaces.length === 0)
    return;
  const {
    client,
    authenticated
  } = await firstValueFrom(workspace.auth.state);
  authenticated && await client.withConfig(DEFAULT_STUDIO_CLIENT_OPTIONS).request({
    method: "POST",
    uri: `/projects/${projectId}/user-applications/${id2}/config/live-manifest`,
    body: {
      value: liveManifest
    },
    tag: "live-manifest-register"
  });
}
const debug$2 = debug$c("sanity:manifest");
function LiveManifestRegisterProvider() {
  const $ = c(5), workspaces = useWorkspaces(), {
    userApplication
  } = useLiveUserApplication(), {
    theme
  } = useRootTheme();
  let t0, t1;
  return $[0] !== theme || $[1] !== userApplication || $[2] !== workspaces ? (t0 = () => {
    !userApplication || workspaces.length === 0 || registerStudioManifest(userApplication, workspaces, theme).catch(_temp$e);
  }, t1 = [userApplication, workspaces, theme], $[0] = theme, $[1] = userApplication, $[2] = workspaces, $[3] = t0, $[4] = t1) : (t0 = $[3], t1 = $[4]), useEffect(t0, t1), null;
}
function _temp$e(err) {
  debug$2("Failed to upload studio manifest", err);
}
var formGutterGap = "var(--formGutterGap)", formGutterSize = "var(--formGutterSize)", selectionBackgroundColor = "var(--_5e8sxk0)", uiColoBg = "var(--_5e8sxk3)", uiColorBorder = "var(--_5e8sxk4)", uiColorMutedFg = "var(--_5e8sxk5)", uiFontTextFamily = "var(--_5e8sxk1)", uiFontTextWeightsMedium = "var(--_5e8sxk2)", webkitResizerSvg = "var(--_5e8sxk6)";
function buildResizeHandleDataUri(hexColor) {
  const encodedStrokeColor = encodeURIComponent(hexColor);
  return `url("data:image/svg+xml,${`%3Csvg width='9' height='9' viewBox='0 0 9 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 8L8 1' stroke='${encodedStrokeColor}' stroke-linecap='round'/%3E%3Cpath d='M5 8L8 5' stroke='${encodedStrokeColor}' stroke-linecap='round'/%3E%3C/svg%3E%0A`}")`;
}
const GlobalStyle = () => {
  const $ = c(15), {
    advancedVersionControl: t0
  } = useWorkspace(), {
    enabled: advancedVersionControlEnabled
  } = t0, {
    color,
    font,
    space
  } = useTheme_v2();
  let t1;
  $[0] !== color.icon ? (t1 = buildResizeHandleDataUri(color.icon), $[0] = color.icon, $[1] = t1) : t1 = $[1];
  const webkitResizerSvgDataUri = t1;
  let t2;
  $[2] !== color.focusRing ? (t2 = rgba$1(color.focusRing, 0.3), $[2] = color.focusRing, $[3] = t2) : t2 = $[3];
  const selectionBackgroundColorVar = t2;
  let t3, t4;
  return $[4] !== advancedVersionControlEnabled || $[5] !== color.bg || $[6] !== color.border || $[7] !== color.muted.fg || $[8] !== font.text.family || $[9] !== font.text.weights.medium || $[10] !== selectionBackgroundColorVar || $[11] !== space || $[12] !== webkitResizerSvgDataUri ? (t3 = () => (setElementVars(document.documentElement, {
    [formGutterSize]: advancedVersionControlEnabled ? `${space[4]}px` : "0px",
    [formGutterGap]: advancedVersionControlEnabled ? `${space[3]}px` : "0px",
    [selectionBackgroundColor]: selectionBackgroundColorVar,
    [uiFontTextFamily]: font.text.family,
    [uiFontTextWeightsMedium]: font.text.weights.medium.toString(),
    [uiColoBg]: color.bg,
    [uiColorBorder]: color.border,
    [uiColorMutedFg]: color.muted.fg,
    [webkitResizerSvg]: webkitResizerSvgDataUri
  }), _temp$d), t4 = [advancedVersionControlEnabled, space, selectionBackgroundColorVar, font.text.family, font.text.weights.medium, color.bg, color.border, color.muted.fg, webkitResizerSvgDataUri], $[4] = advancedVersionControlEnabled, $[5] = color.bg, $[6] = color.border, $[7] = color.muted.fg, $[8] = font.text.family, $[9] = font.text.weights.medium, $[10] = selectionBackgroundColorVar, $[11] = space, $[12] = webkitResizerSvgDataUri, $[13] = t3, $[14] = t4) : (t3 = $[13], t4 = $[14]), useInsertionEffect(t3, t4), null;
};
function _temp$d() {
  setElementVars(document.documentElement, {
    [formGutterSize]: null,
    [formGutterGap]: null,
    [selectionBackgroundColor]: null,
    [uiFontTextFamily]: null,
    [uiFontTextWeightsMedium]: null,
    [uiColoBg]: null,
    [uiColorBorder]: null,
    [uiColorMutedFg]: null,
    [webkitResizerSvg]: null
  });
}
function PerspectiveProvider(t0) {
  const $ = c(20), {
    children,
    selectedPerspectiveName,
    excludedPerspectives: t1
  } = t0, excludedPerspectives = t1 === void 0 ? EMPTY_ARRAY$y : t1, {
    data: releases2
  } = useActiveReleases(), {
    document: t2
  } = useWorkspace(), {
    drafts: t3
  } = t2, {
    enabled: isDraftModelEnabled
  } = t3;
  let t4;
  $[0] !== releases2 || $[1] !== selectedPerspectiveName ? (t4 = getSelectedPerspective(selectedPerspectiveName, releases2), $[0] = releases2, $[1] = selectedPerspectiveName, $[2] = t4) : t4 = $[2];
  const selectedPerspective = t4;
  let t5;
  $[3] !== excludedPerspectives || $[4] !== isDraftModelEnabled || $[5] !== releases2 || $[6] !== selectedPerspectiveName ? (t5 = getReleasesPerspectiveStack({
    releases: releases2,
    selectedPerspectiveName,
    excludedPerspectives,
    isDraftModelEnabled
  }), $[3] = excludedPerspectives, $[4] = isDraftModelEnabled, $[5] = releases2, $[6] = selectedPerspectiveName, $[7] = t5) : t5 = $[7];
  const perspectiveStack = t5;
  let t6;
  $[8] !== releases2 || $[9] !== selectedPerspectiveName ? (t6 = isSystemBundleName(selectedPerspectiveName) ? void 0 : releases2.map(_temp$c).find((releaseName) => releaseName === selectedPerspectiveName), $[8] = releases2, $[9] = selectedPerspectiveName, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== excludedPerspectives || $[12] !== perspectiveStack || $[13] !== selectedPerspective || $[14] !== selectedPerspectiveName || $[15] !== t6 ? (t7 = {
    selectedPerspective,
    selectedPerspectiveName,
    selectedReleaseId: t6,
    perspectiveStack,
    excludedPerspectives
  }, $[11] = excludedPerspectives, $[12] = perspectiveStack, $[13] = selectedPerspective, $[14] = selectedPerspectiveName, $[15] = t6, $[16] = t7) : t7 = $[16];
  const value = t7;
  let t8;
  return $[17] !== children || $[18] !== value ? (t8 = /* @__PURE__ */ jsx(PerspectiveContext.Provider, { value, children }), $[17] = children, $[18] = value, $[19] = t8) : t8 = $[19], t8;
}
function _temp$c(release) {
  return getReleaseIdFromReleaseDocumentId(release._id);
}
function GlobalPerspectiveProvider(t0) {
  const $ = c(6), {
    children
  } = t0, router = useRouter(), {
    document: t1
  } = useWorkspace(), {
    drafts: t2
  } = t1, {
    enabled: isDraftModelEnabled
  } = t2;
  let selectedPerspectiveName = router.stickyParams.perspective;
  !isDraftModelEnabled && typeof selectedPerspectiveName > "u" && (selectedPerspectiveName = PUBLISHED$1);
  let t3;
  $[0] !== router.stickyParams.excludedPerspectives ? (t3 = router.stickyParams.excludedPerspectives?.split(",") || EMPTY_ARRAY$y, $[0] = router.stickyParams.excludedPerspectives, $[1] = t3) : t3 = $[1];
  const excludedPerspectives = t3;
  let t4;
  return $[2] !== children || $[3] !== excludedPerspectives || $[4] !== selectedPerspectiveName ? (t4 = /* @__PURE__ */ jsx(PerspectiveProvider, { selectedPerspectiveName, excludedPerspectives, children }), $[2] = children, $[3] = excludedPerspectives, $[4] = selectedPerspectiveName, $[5] = t4) : t4 = $[5], t4;
}
const debug$1 = debug$c("sanity:store");
function createUserApplicationCache() {
  const appCache = {}, projectIndex = {};
  return {
    get: async (client) => {
      const {
        projectId
      } = client.config();
      if (projectId === void 0)
        return [];
      const existingIndex = projectIndex[projectId];
      if (existingIndex) {
        const appIds = await existingIndex;
        return Promise.all(appIds.map((id2) => appCache[id2]));
      }
      const promise = client.withConfig(DEFAULT_STUDIO_CLIENT_OPTIONS).request({
        method: "GET",
        url: `/projects/${projectId}/user-applications`,
        tag: "user-application-cache.fetch-user-applications"
      }).then((apps) => (projectIndex[projectId] = apps.map((app) => (appCache[app.id] = app, app.id)), apps)).catch((err) => (debug$1("Fetching user application failed.", {
        err
      }), delete projectIndex[projectId], []));
      return projectIndex[projectId] = promise.then((apps) => apps.map((app) => app.id)), promise;
    }
  };
}
function UserApplicationCacheProvider(t0) {
  const $ = c(5), {
    children
  } = t0, parentCache = useContext(UserApplicationCacheContext);
  let t1;
  $[0] !== parentCache ? (t1 = parentCache || createUserApplicationCache(), $[0] = parentCache, $[1] = t1) : t1 = $[1];
  const cache2 = t1;
  let t2;
  return $[2] !== cache2 || $[3] !== children ? (t2 = /* @__PURE__ */ jsx(UserApplicationCacheContext.Provider, { value: cache2, children }), $[2] = cache2, $[3] = children, $[4] = t2) : t2 = $[4], t2;
}
function useUserApplicationCache() {
  const cache2 = useContext(UserApplicationCacheContext);
  if (!cache2)
    throw new Error("UserApplicationCache: missing context value. Ensure the component is wrapped in a UserApplicationCacheProvider.");
  return cache2;
}
function AuthBoundary(t0) {
  const $ = c(16), {
    children,
    AuthenticateComponent: t1,
    LoadingComponent: t2,
    NotAuthenticatedComponent: t3
  } = t0, AuthenticateComponent = t1 === void 0 ? AuthenticateScreen : t1, LoadingComponent = t2 === void 0 ? LoadingBlock : t2, NotAuthenticatedComponent = t3 === void 0 ? NotAuthenticatedScreen : t3, [error, handleError] = useState(null);
  if (error)
    throw error;
  const [loggedIn, setLoggedIn] = useState("loading"), [loginProvider, setLoginProvider] = useState(), {
    activeWorkspace
  } = useActiveWorkspace();
  let t4, t5;
  $[0] !== activeWorkspace.auth ? (t4 = () => {
    activeWorkspace.auth.handleCallbackUrl?.().catch(handleError);
  }, t5 = [activeWorkspace.auth], $[0] = activeWorkspace.auth, $[1] = t4, $[2] = t5) : (t4 = $[1], t5 = $[2]), useEffect(t4, t5);
  let t6;
  $[3] !== activeWorkspace.auth.state ? (t6 = () => {
    const subscription = activeWorkspace.auth.state.subscribe({
      next: (t72) => {
        const {
          authenticated,
          currentUser
        } = t72;
        if (authenticated && (!Array.isArray(currentUser?.roles) || currentUser.roles.length === 0)) {
          setLoggedIn("unauthorized"), currentUser?.provider && setLoginProvider(currentUser.provider);
          return;
        }
        setLoggedIn(authenticated ? "logged-in" : "logged-out");
      },
      error: handleError
    });
    return () => {
      subscription.unsubscribe();
    };
  }, $[3] = activeWorkspace.auth.state, $[4] = t6) : t6 = $[4];
  let t7;
  if ($[5] !== activeWorkspace ? (t7 = [activeWorkspace], $[5] = activeWorkspace, $[6] = t7) : t7 = $[6], useEffect(t6, t7), loggedIn === "loading") {
    let t82;
    return $[7] !== LoadingComponent ? (t82 = /* @__PURE__ */ jsx(LoadingComponent, {}), $[7] = LoadingComponent, $[8] = t82) : t82 = $[8], t82;
  }
  if (loggedIn === "unauthorized") {
    if (!loginProvider || loginProvider === "sanity") {
      let t83;
      return $[9] !== NotAuthenticatedComponent ? (t83 = /* @__PURE__ */ jsx(NotAuthenticatedComponent, {}), $[9] = NotAuthenticatedComponent, $[10] = t83) : t83 = $[10], t83;
    }
    let t82;
    return $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t82 = /* @__PURE__ */ jsx(RequestAccessScreen, {}), $[11] = t82) : t82 = $[11], t82;
  }
  if (loggedIn === "logged-out") {
    let t82;
    return $[12] !== AuthenticateComponent ? (t82 = /* @__PURE__ */ jsx(AuthenticateComponent, {}), $[12] = AuthenticateComponent, $[13] = t82) : t82 = $[13], t82;
  }
  let t8;
  return $[14] !== children ? (t8 = /* @__PURE__ */ jsx(Fragment$1, { children }), $[14] = children, $[15] = t8) : t8 = $[15], t8;
}
function useComlinkRouteHandler() {
  const $ = c(4), {
    node
  } = useComlinkStore(), {
    navigateUrl
  } = useRouter();
  let t0, t1;
  $[0] !== navigateUrl || $[1] !== node ? (t0 = () => node?.on("dashboard/v1/history/change-path", (t2) => {
    const {
      path
    } = t2;
    navigateUrl({
      path: sanitizePath(path),
      replace: !1
    });
  }), t1 = [navigateUrl, node], $[0] = navigateUrl, $[1] = node, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1);
}
function sanitizePath(path) {
  return path.replace(/^\/+/, "/");
}
const ComlinkRouteHandler = () => (useComlinkRouteHandler(), null);
function getAppUrl(app, internalHost) {
  return app.urlType === "internal" ? `https://${app.appHost}.${internalHost}` : app.appHost;
}
function currentUrlMatchesApp({
  origin,
  pathname
}, appUrl) {
  const url = new URL(appUrl);
  if (origin !== url.origin) return !1;
  const appPathname = url.pathname;
  return pathname === appPathname ? !0 : pathname.startsWith(appPathname.endsWith("/") ? appPathname : `${appPathname}/`);
}
async function findUserApplication(cache2, workspaces) {
  if (typeof window > "u" || !window.location || workspaces.length === 0)
    return;
  const workspace = workspaces[0], state = await firstValueFrom(workspace.auth.state);
  if (!state.authenticated)
    return;
  let internalHost = "sanity.studio";
  return workspace.apiHost !== void 0 && workspace.apiHost.includes("sanity.work") && (internalHost = "studio.sanity.work"), (await cache2.get(state.client)).reduce((best, app) => {
    const appUrl = getAppUrl(app, internalHost);
    return appUrl && currentUrlMatchesApp(window.location, appUrl) && appUrl.length > best[1].length ? [app, appUrl] : best;
  }, [void 0, ""])[0];
}
const debug = debug$c("studio:live-user-application");
function LiveUserApplicationProvider(t0) {
  const $ = c(10), {
    children
  } = t0, [userApplication, setUserApplication] = useState(void 0), [isLoading, setIsLoading] = useState(!0), workspaces = useWorkspaces(), userApplicationCache = useUserApplicationCache();
  let t1, t2;
  $[0] !== userApplicationCache || $[1] !== workspaces ? (t1 = () => {
    let hasSubscriber = !0;
    return setIsLoading(!0), findUserApplication(userApplicationCache, workspaces).then((found) => {
      hasSubscriber && (setUserApplication(found), setIsLoading(!1));
    }).catch((error) => {
      debug("Error when determining live user application id:", error), hasSubscriber && (setUserApplication(void 0), setIsLoading(!1));
    }), () => {
      hasSubscriber = !1;
    };
  }, t2 = [userApplicationCache, workspaces], $[0] = userApplicationCache, $[1] = workspaces, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  let t3;
  $[4] !== isLoading || $[5] !== userApplication ? (t3 = {
    userApplication,
    isLoading
  }, $[4] = isLoading, $[5] = userApplication, $[6] = t3) : t3 = $[6];
  const contextValue = t3;
  let t4;
  return $[7] !== children || $[8] !== contextValue ? (t4 = /* @__PURE__ */ jsx(LiveUserApplicationContext.Provider, { value: contextValue, children }), $[7] = children, $[8] = contextValue, $[9] = t4) : t4 = $[9], t4;
}
const CONSENT_CLIENT_OPTIONS = {
  apiVersion: "2023-12-18"
};
function MaybeEnableErrorReporting(props2) {
  const $ = c(6), {
    errorReporter: errorReporter2
  } = props2, client = useClient(CONSENT_CLIENT_OPTIONS);
  let t0;
  $[0] !== client.observable || $[1] !== errorReporter2 ? (t0 = () => {
    const request = client.observable.request({
      uri: "/intake/telemetry-status",
      tag: "telemetry-consent.error-reporting"
    }).subscribe({
      next: (res) => {
        res?.status === "granted" ? errorReporter2.enable() : errorReporter2.disable();
      },
      error: _temp$b
    });
    return () => request.unsubscribe();
  }, $[0] = client.observable, $[1] = errorReporter2, $[2] = t0) : t0 = $[2];
  let t1;
  return $[3] !== client || $[4] !== errorReporter2 ? (t1 = [client, errorReporter2], $[3] = client, $[4] = errorReporter2, $[5] = t1) : t1 = $[5], useEffect(t0, t1), null;
}
function _temp$b(err) {
  console.error("Error fetching telemetry status", err);
}
const isStaging = typeof __SANITY_STAGING__ < "u" && __SANITY_STAGING__ === !0, MODULES_URL_VERSION = "v1", MODULES_HOST = isStaging ? "https://sanity-cdn.work" : "https://sanity-cdn.com", MODULES_URL = `${MODULES_HOST}/${MODULES_URL_VERSION}/modules`;
function currentUnixTimestamp() {
  return Math.floor(Date.now() / 1e3);
}
function getAppIdModuleUrl({
  packageName,
  minVersion,
  appId
}) {
  const timestamp = currentUnixTimestamp();
  return `${MODULES_URL}/by-app/${appId}/t${timestamp}/^${minVersion.version}/${packageName}`;
}
function getModuleUrl({
  packageName,
  minVersion,
  tag = "latest"
}) {
  const timestamp = currentUnixTimestamp();
  return `${MODULES_URL}/${packageName}/${tag}/^${minVersion.version}/t${timestamp}`;
}
const fetchLatestAutoUpdatingVersion = async (options) => {
  const {
    packageName,
    minVersion,
    appId
  } = options;
  try {
    return (await fetch(getAppIdModuleUrl({
      appId,
      packageName,
      minVersion
    }), {
      headers: {
        accept: "application/json"
      }
    })).json().then((data) => data.packageVersion);
  } catch (err) {
    console.error(new Error(`Failed to fetch version for package "${packageName}" (using appId=${appId})`, {
      cause: err
    }));
    return;
  }
}, fetchLatestAvailableVersionForPackage = async (options) => {
  const {
    packageName,
    minVersion,
    tag = "latest"
  } = options;
  try {
    return (await fetch(getModuleUrl({
      packageName,
      minVersion,
      tag
    }), {
      headers: {
        accept: "application/json"
      }
    })).json().then((data) => data.latest);
  } catch (err) {
    console.error(`Failed to fetch version for package (using tag=${tag})`, packageName, "Error:", err);
    return;
  }
}, MODULE_PATH_REGEX = /^\/v1\/modules\/sanity\/[^/]+\/[^/]+\/[^/]+\/?$/, MODULE_PATH_REGEX_BY_APP = /^\/v1\/modules\/by-app\/[^/]+\/[^/]+\/[^/]+\/[^/]+\/?$/;
function parseImportMapModuleCdnUrl(moduleCdnUrl) {
  const url = new URL(moduleCdnUrl, "https://example.com"), rawParseResult = rawParseModuleCDNUrl(url);
  if (!rawParseResult.valid)
    return rawParseResult;
  const {
    appId,
    version: rawVersion
  } = rawParseResult, minVersion = decodeURIComponent(rawVersion);
  return semver.validRange(minVersion) ? {
    valid: !0,
    appId,
    minVersion
  } : {
    valid: !1,
    error: new Error(`Invalid minVersion "${minVersion}" in module cdn url: ${moduleCdnUrl}`)
  };
}
function rawParseModuleCDNUrl(url) {
  if (MODULE_PATH_REGEX_BY_APP.test(url.pathname)) {
    const [
      /*v1*/
      /*modules*/
      /*by-app*/
      /*timestamp*/
      ,
      ,
      ,
      ,
      appId,
      ,
      encodedVersion
    ] = url.pathname.split("/");
    return {
      valid: !0,
      appId,
      version: encodedVersion
    };
  }
  if (MODULE_PATH_REGEX.test(url.pathname)) {
    const [
      /*v1*/
      /*modules*/
      /*sanity*/
      /*default*/
      ,
      ,
      ,
      ,
      ,
      encodedVersion
    ] = url.pathname.split("/");
    return {
      valid: !0,
      appId: void 0,
      version: encodedVersion
    };
  }
  return {
    valid: !1,
    error: new Error(`Unable to parse module CDN URL: ${url.pathname}`)
  };
}
const POLL_INTERVAL_MS = 1e3 * 60 * 15, CHECK_THROTTLE_TIME_MS = 1e3 * 10, noop = () => {
}, getCurrentVersion = memoize$1(() => semver.parse(SANITY_VERSION)), getSanityImportMapEntryValue = memoize$1(() => getSanityImportMapUrl()), REFERENCE_PACKAGE = "sanity";
function PackageVersionStatusProvider(t0) {
  const $ = c(17), {
    children
  } = t0;
  let t1;
  if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    bb0: {
      const importMapUrl = getSanityImportMapEntryValue();
      if (!importMapUrl) {
        t1 = void 0;
        break bb0;
      }
      const result = parseImportMapModuleCdnUrl(importMapUrl);
      result.valid || console.warn(new Error("Unable to extract version from import map, auto updates may not work as expected", {
        cause: result.error
      })), t1 = result.valid ? {
        ...result,
        minVersion: semver.coerce(result.minVersion, {
          includePrerelease: !0
        })
      } : result;
    }
    $[0] = t1;
  } else
    t1 = $[0];
  const importMapInfo = t1;
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = getCurrentVersion(), $[1] = t2) : t2 = $[1];
  const currentVersion = t2, isAutoUpdating = !!importMapInfo, lastCheckRef = useRef(void 0), [autoUpdatingVersionRaw, setAutoUpdatingVersionRaw] = useState(), [latestTaggedVersionRaw, setLatestTaggedVersionRaw] = useState();
  let t3;
  $[2] !== autoUpdatingVersionRaw ? (t3 = autoUpdatingVersionRaw ? semver.parse(autoUpdatingVersionRaw) : void 0, $[2] = autoUpdatingVersionRaw, $[3] = t3) : t3 = $[3];
  const autoUpdatingVersion = t3;
  let t4;
  $[4] !== latestTaggedVersionRaw ? (t4 = latestTaggedVersionRaw ? semver.parse(latestTaggedVersionRaw) : void 0, $[4] = latestTaggedVersionRaw, $[5] = t4) : t4 = $[5];
  const latestTaggedVersion = t4;
  let t5;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    lastCheckedAt: null,
    checking: !1
  }, $[6] = t5) : t5 = $[6];
  const [versionCheckStatus, setVersionCheckStatus] = useState(t5);
  let t6;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = async () => {
    if (lastCheckRef.current && lastCheckRef.current + CHECK_THROTTLE_TIME_MS > (/* @__PURE__ */ new Date()).getTime())
      return;
    lastCheckRef.current = (/* @__PURE__ */ new Date()).getTime(), setVersionCheckStatus(_temp$a);
    const resolveLatestTaggedVersion = fetchLatestAvailableVersionForPackage({
      packageName: REFERENCE_PACKAGE,
      minVersion: importMapInfo?.valid ? importMapInfo.minVersion : currentVersion,
      tag: "latest"
    }), resolveAutoUpdatingVersion = importMapInfo?.valid ? importMapInfo.appId ? fetchLatestAutoUpdatingVersion({
      packageName: REFERENCE_PACKAGE,
      minVersion: importMapInfo?.valid ? importMapInfo.minVersion : currentVersion,
      appId: importMapInfo.appId
    }) : resolveLatestTaggedVersion : void 0;
    Promise.all([resolveLatestTaggedVersion, resolveAutoUpdatingVersion]).then((t72) => {
      const [nextLatestVersion, nextAutoUpdatingVersion] = t72;
      setAutoUpdatingVersionRaw(nextAutoUpdatingVersion), setLatestTaggedVersionRaw(nextLatestVersion);
    }).finally(() => setVersionCheckStatus({
      lastCheckedAt: /* @__PURE__ */ new Date(),
      checking: !1
    }));
  }, $[7] = t6) : t6 = $[7];
  const fetchNewVersions = t6;
  let t7, t8;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = () => {
    const poll = async function() {
      await fetchNewVersions();
    };
    poll();
    const intervalId = setInterval(poll, POLL_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, t8 = [fetchNewVersions], $[8] = t7, $[9] = t8) : (t7 = $[8], t8 = $[9]), useEffect(t7, t8);
  let t9;
  $[10] !== autoUpdatingVersion || $[11] !== latestTaggedVersion || $[12] !== versionCheckStatus ? (t9 = {
    isAutoUpdating,
    autoUpdatingVersion,
    importMapInfo,
    latestTaggedVersion,
    currentVersion,
    checkForUpdates: isAutoUpdating ? fetchNewVersions : noop,
    versionCheckStatus
  }, $[10] = autoUpdatingVersion, $[11] = latestTaggedVersion, $[12] = versionCheckStatus, $[13] = t9) : t9 = $[13];
  const contextValue = t9;
  let t10;
  return $[14] !== children || $[15] !== contextValue ? (t10 = /* @__PURE__ */ jsx(PackageVersionInfoContext.Provider, { value: contextValue, children }), $[14] = children, $[15] = contextValue, $[16] = t10) : t10 = $[16], t10;
}
function _temp$a(current) {
  return {
    ...current,
    checking: !0
  };
}
const keyframe = keyframes`
  0% {
    background-position: 100%;
  }
  100% {
    background-position: -100%;
  }
`, Root$6 = /* @__PURE__ */ styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1i1h10i-0"
})((props2) => {
  const theme = getTheme_v2(props2.theme), cardHoverBg = theme.color.selectable.default.hovered.bg, cardNormalBg = theme.color.selectable.default.enabled.bg;
  return css`
    position: relative;
    cursor: pointer;
    // hide the close button
    #close-floating-button {
      opacity: 0;
      transition: opacity 0.2s;
    }

    &:hover {
      > [data-ui='whats-new-card'] {
        --card-bg-color: ${cardHoverBg};
        box-shadow: inset 0 0 2px 1px var(--card-skeleton-color-to);
        background-image: linear-gradient(
          to right,
          var(--card-bg-color),
          var(--card-bg-color),
          ${cardNormalBg},
          var(--card-bg-color),
          var(--card-bg-color),
          var(--card-bg-color)
        );
        background-position: 100%;
        background-size: 200% 100%;
        background-attachment: fixed;
        animation-name: ${keyframe};
        animation-timing-function: ease-in;
        animation-iteration-count: infinite;
        animation-duration: 2000ms;
      }
      #close-floating-button {
        opacity: 1;
        background: transparent;

        &:hover {
          transition: all 0.2s;
          box-shadow: 0 0 0 1px ${theme.color.selectable.default.hovered.border};
        }
      }
    }
  `;
}), ButtonRoot = styled.div.withConfig({
  displayName: "ButtonRoot",
  componentId: "sc-1i1h10i-1"
})`z-index:1;position:absolute;top:2px;right:6px;`;
function StudioAnnouncementsCard(t0) {
  const $ = c(37), {
    title,
    id: id2,
    isOpen,
    name,
    preHeader,
    onCardClick,
    onCardDismiss
  } = t0, {
    t
  } = useTranslation(), telemetry = useTelemetry();
  let t1, t2;
  $[0] !== id2 || $[1] !== isOpen || $[2] !== name || $[3] !== telemetry || $[4] !== title ? (t1 = () => {
    isOpen && telemetry.log(ProductAnnouncementCardSeen, {
      announcement_id: id2,
      announcement_title: title,
      announcement_internal_name: name,
      source: "studio",
      studio_version: SANITY_VERSION
    });
  }, t2 = [telemetry, id2, title, isOpen, name], $[0] = id2, $[1] = isOpen, $[2] = name, $[3] = telemetry, $[4] = title, $[5] = t1, $[6] = t2) : (t1 = $[5], t2 = $[6]), useEffect(t1, t2);
  let t3;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    bottom: 12,
    left: 12,
    top: "none"
  }, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t ? (t4 = t("announcement.floating-button.open-label"), $[8] = t, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== preHeader ? (t5 = /* @__PURE__ */ jsx(Box, { marginRight: 6, children: /* @__PURE__ */ jsx(Text$1, { as: "h3", size: 1, muted: !0, children: preHeader }) }), $[10] = preHeader, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== title ? (t6 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: title }), $[12] = title, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== t5 || $[15] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t5,
    t6
  ] }), $[14] = t5, $[15] = t6, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== onCardClick || $[18] !== t4 || $[19] !== t7 ? (t8 = /* @__PURE__ */ jsx(Card, { "data-ui": "whats-new-card", padding: 3, radius: 3, onClick: onCardClick, role: "button", "aria-label": t4, children: t7 }), $[17] = onCardClick, $[18] = t4, $[19] = t7, $[20] = t8) : t8 = $[20];
  let t9;
  $[21] !== t ? (t9 = t("announcement.floating-button.dismiss-label"), $[21] = t, $[22] = t9) : t9 = $[22];
  let t10;
  $[23] !== t ? (t10 = t("announcement.floating-button.dismiss"), $[23] = t, $[24] = t10) : t10 = $[24];
  let t11;
  $[25] !== t10 ? (t11 = {
    content: t10
  }, $[25] = t10, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== onCardDismiss || $[28] !== t11 || $[29] !== t9 ? (t12 = /* @__PURE__ */ jsx(ButtonRoot, { children: /* @__PURE__ */ jsx(Button, { id: "close-floating-button", mode: "bleed", onClick: onCardDismiss, icon: CloseIcon, tone: "default", "aria-label": t9, tooltipProps: t11 }) }), $[27] = onCardDismiss, $[28] = t11, $[29] = t9, $[30] = t12) : t12 = $[30];
  let t13;
  $[31] !== t12 || $[32] !== t8 ? (t13 = /* @__PURE__ */ jsxs(Root$6, { "data-ui": "whats-new-root", children: [
    t8,
    t12
  ] }), $[31] = t12, $[32] = t8, $[33] = t13) : t13 = $[33];
  let t14;
  return $[34] !== isOpen || $[35] !== t13 ? (t14 = /* @__PURE__ */ jsx(Popover, { open: isOpen, shadow: 3, portal: !0, style: t3, width: 0, placement: "bottom-start", content: t13 }), $[34] = isOpen, $[35] = t13, $[36] = t14) : t14 = $[36], t14;
}
const Hr = styled.hr.withConfig({
  displayName: "Hr",
  componentId: "sc-k789fr-0"
})`height:1px;background:var(--card-border-color);width:100%;opacity:${({
  $show
}) => $show ? 1 : 0};transition:opacity 0.3s ease;margin:0;border:none;`, DIVIDER_FADE_THRESHOLD = "-60px 0px 0px 0px";
function Divider(t0) {
  const $ = c(5), {
    parentRef
  } = t0, itemRef = useRef(null), [show, setShow] = useState(!0);
  let t1, t2;
  $[0] !== parentRef ? (t1 = () => {
    const item = itemRef.current, parent = parentRef.current;
    if (!item || !parent)
      return;
    const observer = new IntersectionObserver((t32) => {
      const [entry] = t32;
      setShow(entry.isIntersecting);
    }, {
      root: parent,
      threshold: 0,
      rootMargin: DIVIDER_FADE_THRESHOLD
    });
    return observer.observe(item), () => {
      observer.disconnect();
    };
  }, t2 = [parentRef], $[0] = parentRef, $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]), useEffect(t1, t2);
  let t3;
  return $[3] !== show ? (t3 = /* @__PURE__ */ jsx(Box, { paddingBottom: 4, children: /* @__PURE__ */ jsx(Box, { paddingY: 3, paddingX: 3, children: /* @__PURE__ */ jsx(Hr, { ref: itemRef, $show: show }) }) }), $[3] = show, $[4] = t3) : t3 = $[4], t3;
}
const DATE_FORMAT_OPTIONS = {
  month: "short",
  day: "2-digit"
}, Root$5 = styled(Box).withConfig({
  displayName: "Root",
  componentId: "sc-j96pa2-0"
})`overflow:auto;max-height:75vh;`, DialogHeader = styled(Grid).withConfig({
  displayName: "DialogHeader",
  componentId: "sc-j96pa2-1"
})`position:sticky;display:grid;grid-template-columns:64px 1fr 64px;top:0;z-index:1;background:var(--card-bg-color);`, FloatingButtonBox = styled(Box).withConfig({
  displayName: "FloatingButtonBox",
  componentId: "sc-j96pa2-2"
})`position:absolute;top:12px;right:24px;z-index:2;`, FloatingButton = styled(Button).withConfig({
  displayName: "FloatingButton",
  componentId: "sc-j96pa2-3"
})``;
function Announcement(t0) {
  const $ = c(35), {
    announcement,
    mode,
    isFirst,
    parentRef
  } = t0, telemetry = useTelemetry(), dateFormatter = useDateTimeFormat(DATE_FORMAT_OPTIONS), logViewedItemRef = useRef(null);
  let t1;
  bb0: {
    if (!announcement.publishedDate) {
      t1 = "";
      break bb0;
    }
    let t22;
    $[0] !== announcement.publishedDate || $[1] !== dateFormatter ? (t22 = dateFormatter.format(new Date(announcement.publishedDate)), $[0] = announcement.publishedDate, $[1] = dateFormatter, $[2] = t22) : t22 = $[2], t1 = t22;
  }
  const formattedDate = t1;
  let t2;
  $[3] !== announcement._id || $[4] !== announcement.name || $[5] !== announcement.title || $[6] !== mode || $[7] !== telemetry ? (t2 = (t32) => {
    const {
      url,
      linkTitle
    } = t32;
    telemetry.log(ProductAnnouncementLinkClicked, {
      announcement_id: announcement._id,
      announcement_title: announcement.title,
      announcement_internal_name: announcement.name,
      source: "studio",
      studio_version: SANITY_VERSION,
      origin: mode,
      link_url: url,
      link_title: linkTitle
    });
  }, $[3] = announcement._id, $[4] = announcement.name, $[5] = announcement.title, $[6] = mode, $[7] = telemetry, $[8] = t2) : t2 = $[8];
  const handleLinkClick = t2;
  let t3;
  $[9] !== announcement._id || $[10] !== announcement.name || $[11] !== announcement.title || $[12] !== mode || $[13] !== telemetry ? (t3 = (scrolledIntoView) => {
    telemetry.log(ProductAnnouncementViewed, {
      announcement_id: announcement._id,
      announcement_title: announcement.title,
      announcement_internal_name: announcement.name,
      source: "studio",
      studio_version: SANITY_VERSION,
      scrolled_into_view: scrolledIntoView,
      origin: mode
    });
  }, $[9] = announcement._id, $[10] = announcement.name, $[11] = announcement.title, $[12] = mode, $[13] = telemetry, $[14] = t3) : t3 = $[14];
  const logViewed = t3;
  let t4, t5;
  $[15] !== isFirst || $[16] !== logViewed || $[17] !== parentRef ? (t4 = () => {
    if (isFirst) {
      logViewed(!1);
      return;
    }
    const item = logViewedItemRef.current, parent = parentRef.current;
    if (!item || !parent)
      return;
    const observer = new IntersectionObserver((t62) => {
      const [entry] = t62;
      entry.isIntersecting && (logViewed(!0), observer.disconnect());
    }, {
      root: parent,
      threshold: 1,
      rootMargin: "0px 0px -100px 0px"
    });
    return observer.observe(item), () => {
      observer.disconnect();
    };
  }, t5 = [logViewed, parentRef, isFirst], $[15] = isFirst, $[16] = logViewed, $[17] = parentRef, $[18] = t4, $[19] = t5) : (t4 = $[18], t5 = $[19]), useEffect(t4, t5);
  let t6;
  $[20] !== formattedDate ? (t6 = /* @__PURE__ */ jsx(Box, { flex: "none", padding: 2, paddingRight: 0, children: /* @__PURE__ */ jsx(Box, { paddingLeft: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: formattedDate }) }) }), $[20] = formattedDate, $[21] = t6) : t6 = $[21];
  let t7;
  $[22] !== announcement.title ? (t7 = /* @__PURE__ */ jsx(Flex, { flex: 1, padding: 2, justify: "center", ref: logViewedItemRef, children: /* @__PURE__ */ jsx(Text$1, { as: "h2", size: 1, weight: "semibold", children: announcement.title }) }), $[22] = announcement.title, $[23] = t7) : t7 = $[23];
  let t8;
  $[24] !== t6 || $[25] !== t7 ? (t8 = /* @__PURE__ */ jsxs(DialogHeader, { padding: 3, children: [
    t6,
    t7
  ] }), $[24] = t6, $[25] = t7, $[26] = t8) : t8 = $[26];
  let t9;
  $[27] !== announcement.body ? (t9 = announcement.body || [], $[27] = announcement.body, $[28] = t9) : t9 = $[28];
  let t10;
  $[29] !== handleLinkClick || $[30] !== t9 ? (t10 = /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(UpsellDescriptionSerializer, { blocks: t9, onLinkClick: handleLinkClick }) }), $[29] = handleLinkClick, $[30] = t9, $[31] = t10) : t10 = $[31];
  let t11;
  return $[32] !== t10 || $[33] !== t8 ? (t11 = /* @__PURE__ */ jsxs(Box, { children: [
    t8,
    t10
  ] }), $[32] = t10, $[33] = t8, $[34] = t11) : t11 = $[34], t11;
}
function StudioAnnouncementsDialog(t0) {
  const $ = c(18), {
    announcements: t1,
    onClose,
    mode
  } = t0, announcements = t1 === void 0 ? [] : t1, dialogRef = useRef(null), {
    t
  } = useTranslation(), T0 = Dialog$1, t2 = "in-app-communication-dialog", t3 = 1, t4 = "fill", t5 = !1, t6 = !0, t7 = !1, T1 = Root$5, t8 = "fill", t9 = announcements.map((announcement, index) => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Announcement, { announcement, mode, isFirst: index === 0, parentRef: dialogRef }),
    index < announcements.length - 1 && /* @__PURE__ */ jsx(Divider, { parentRef: dialogRef })
  ] }, announcement._id));
  let t10;
  $[0] !== t ? (t10 = t("announcement.dialog.close-label"), $[0] = t, $[1] = t10) : t10 = $[1];
  let t11;
  $[2] !== t ? (t11 = t("announcement.dialog.close"), $[2] = t, $[3] = t11) : t11 = $[3];
  let t12;
  $[4] !== t11 ? (t12 = {
    content: t11
  }, $[4] = t11, $[5] = t12) : t12 = $[5];
  let t13;
  $[6] !== onClose || $[7] !== t10 || $[8] !== t12 ? (t13 = /* @__PURE__ */ jsx(FloatingButtonBox, { children: /* @__PURE__ */ jsx(FloatingButton, { "aria-label": t10, icon: CloseIcon, mode: "bleed", onClick: onClose, tooltipProps: t12 }) }), $[6] = onClose, $[7] = t10, $[8] = t12, $[9] = t13) : t13 = $[9];
  let t14;
  $[10] !== T1 || $[11] !== t13 || $[12] !== t9 ? (t14 = /* @__PURE__ */ jsxs(T1, { ref: dialogRef, height: t8, children: [
    t9,
    t13
  ] }), $[10] = T1, $[11] = t13, $[12] = t9, $[13] = t14) : t14 = $[13];
  let t15;
  return $[14] !== T0 || $[15] !== onClose || $[16] !== t14 ? (t15 = /* @__PURE__ */ jsx(T0, { id: t2, onClose, onClickOutside: onClose, width: t3, bodyHeight: t4, padding: t5, __unstable_hideCloseButton: t6, __unstable_autoFocus: t7, children: t14 }), $[14] = T0, $[15] = onClose, $[16] = t14, $[17] = t15) : t15 = $[17], t15;
}
const KEY = "studio.announcement.seen", RESET_PARAM = "reset-announcements", INITIAL_STATE$2 = {
  value: null,
  error: null,
  loading: !0
};
function useSeenAnnouncements() {
  const $ = c(13), router = useRouter(), keyValueStore = useKeyValueStore();
  let t0;
  $[0] !== keyValueStore ? (t0 = keyValueStore.getKey(KEY).pipe(map$1(_temp$9), startWith$1(INITIAL_STATE$2), catchError$1(_temp2$4)), $[0] = keyValueStore, $[1] = t0) : t0 = $[1];
  const seenAnnouncements$ = t0;
  let t1;
  $[2] !== keyValueStore ? (t1 = async (seen) => {
    await keyValueStore.setKey(KEY, seen);
  }, $[2] = keyValueStore, $[3] = t1) : t1 = $[3];
  const setSeenAnnouncements = t1;
  let t2;
  $[4] !== router.state._searchParams ? (t2 = new URLSearchParams(router.state._searchParams)?.get(RESET_PARAM), $[4] = router.state._searchParams, $[5] = t2) : t2 = $[5];
  const resetAnnouncementsParams = t2;
  let t3, t4;
  $[6] !== resetAnnouncementsParams || $[7] !== setSeenAnnouncements ? (t3 = () => {
    if (resetAnnouncementsParams !== null) {
      const resetValue = resetAnnouncementsParams ? resetAnnouncementsParams.split(",") : [];
      setSeenAnnouncements(resetValue);
    }
  }, t4 = [resetAnnouncementsParams, setSeenAnnouncements], $[6] = resetAnnouncementsParams, $[7] = setSeenAnnouncements, $[8] = t3, $[9] = t4) : (t3 = $[8], t4 = $[9]), useEffect(t3, t4);
  let t5;
  return $[10] !== seenAnnouncements$ || $[11] !== setSeenAnnouncements ? (t5 = [seenAnnouncements$, setSeenAnnouncements], $[10] = seenAnnouncements$, $[11] = setSeenAnnouncements, $[12] = t5) : t5 = $[12], t5;
}
function _temp2$4(error) {
  return of({
    value: null,
    error,
    loading: !1
  });
}
function _temp$9(value) {
  return {
    value,
    error: null,
    loading: !1
  };
}
const audienceRoles = ["administrator", "editor", "viewer", "contributor", "developer", "custom"];
function isValidAnnouncementAudience(document2, sanityVersion) {
  switch (document2.audience) {
    case "everyone":
      return !0;
    case "specific-version":
      return satisfies(sanityVersion, `= ${document2.studioVersion}`, {
        includePrerelease: !0
      });
    case "greater-than-or-equal-version":
      return satisfies(sanityVersion, `>= ${document2.studioVersion}`, {
        includePrerelease: !0
      });
    case "less-than-or-equal-version":
      return satisfies(sanityVersion, `<= ${document2.studioVersion}`, {
        includePrerelease: !0
      });
    default:
      return !0;
  }
}
function isValidAnnouncementRole(audience, userRoles) {
  return !audience || !audience.length ? !0 : !userRoles || !userRoles.length ? !1 : userRoles.some((role) => audience.includes(role.name)) ? !0 : userRoles.some((role) => !audienceRoles.includes(role.name)) ? audience.includes("custom") : !1;
}
const CLIENT_OPTIONS = {
  apiVersion: "v2024-09-19"
};
function StudioAnnouncementsProviderInner(t0) {
  const $ = c(47), {
    children
  } = t0, telemetry = useTelemetry(), [dialogMode, setDialogMode] = useState(null), [isCardDismissed, setIsCardDismissed] = useState(!1), [seenAnnouncements$, setSeenAnnouncements] = useSeenAnnouncements(), {
    currentUser
  } = useWorkspace(), client = useClient(CLIENT_OPTIONS);
  let t1;
  if ($[0] !== client.observable || $[1] !== currentUser?.roles || $[2] !== seenAnnouncements$) {
    let t22;
    $[4] !== currentUser?.roles ? (t22 = (docs) => docs ? docs.filter((doc) => isValidAnnouncementAudience({
      audience: doc.audience,
      studioVersion: doc.studioVersion
    }, SANITY_VERSION) && isValidAnnouncementRole(doc.audienceRole, currentUser?.roles)) : [], $[4] = currentUser?.roles, $[5] = t22) : t22 = $[5];
    const allAnnouncements$ = client.observable.request({
      url: "/journey/announcements"
    }).pipe(map$1(t22), catchError$1(_temp$8), startWith$1([]));
    t1 = combineLatest([allAnnouncements$, seenAnnouncements$]).pipe(map$1(_temp2$3)), $[0] = client.observable, $[1] = currentUser?.roles, $[2] = seenAnnouncements$, $[3] = t1;
  } else
    t1 = $[3];
  const getAnnouncements$ = t1;
  let t2;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    unseen: [],
    all: []
  }, $[6] = t2) : t2 = $[6];
  const announcements = useObservable(getAnnouncements$, t2), unseenAnnouncements = announcements.unseen, studioAnnouncements = announcements.all;
  let t3;
  $[7] !== setSeenAnnouncements || $[8] !== studioAnnouncements ? (t3 = () => {
    setSeenAnnouncements(studioAnnouncements.map(_temp3$2));
  }, $[7] = setSeenAnnouncements, $[8] = studioAnnouncements, $[9] = t3) : t3 = $[9];
  const saveSeenAnnouncements = t3;
  let t4;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = (mode) => {
    setDialogMode(mode), setIsCardDismissed(!0);
  }, $[10] = t4) : t4 = $[10];
  const handleOpenDialog = t4;
  let t5;
  $[11] !== saveSeenAnnouncements || $[12] !== telemetry || $[13] !== unseenAnnouncements[0]?._id || $[14] !== unseenAnnouncements[0]?.name || $[15] !== unseenAnnouncements[0]?.title ? (t5 = () => {
    saveSeenAnnouncements(), setIsCardDismissed(!0), telemetry.log(ProductAnnouncementCardDismissed, {
      announcement_id: unseenAnnouncements[0]?._id,
      announcement_title: unseenAnnouncements[0]?.title,
      announcement_internal_name: unseenAnnouncements[0]?.name,
      source: "studio",
      studio_version: SANITY_VERSION
    });
  }, $[11] = saveSeenAnnouncements, $[12] = telemetry, $[13] = unseenAnnouncements[0]?._id, $[14] = unseenAnnouncements[0]?.name, $[15] = unseenAnnouncements[0]?.title, $[16] = t5) : t5 = $[16];
  const handleCardDismiss = t5;
  let t6;
  $[17] !== telemetry || $[18] !== unseenAnnouncements[0]?._id || $[19] !== unseenAnnouncements[0]?.name || $[20] !== unseenAnnouncements[0]?.title ? (t6 = () => {
    handleOpenDialog("card"), telemetry.log(ProductAnnouncementCardClicked, {
      announcement_id: unseenAnnouncements[0]?._id,
      announcement_title: unseenAnnouncements[0]?.title,
      announcement_internal_name: unseenAnnouncements[0]?.name,
      source: "studio",
      studio_version: SANITY_VERSION
    });
  }, $[17] = telemetry, $[18] = unseenAnnouncements[0]?._id, $[19] = unseenAnnouncements[0]?.name, $[20] = unseenAnnouncements[0]?.title, $[21] = t6) : t6 = $[21];
  const handleCardClick = t6;
  let t7;
  $[22] !== dialogMode || $[23] !== saveSeenAnnouncements || $[24] !== studioAnnouncements[0] || $[25] !== telemetry || $[26] !== unseenAnnouncements[0] ? (t7 = () => {
    const firstAnnouncement = dialogMode === "help_menu" ? studioAnnouncements[0] : unseenAnnouncements[0];
    telemetry.log(ProductAnnouncementModalDismissed, {
      announcement_id: firstAnnouncement?._id,
      announcement_title: firstAnnouncement?.title,
      announcement_internal_name: firstAnnouncement?.name,
      source: "studio",
      studio_version: SANITY_VERSION,
      origin: dialogMode ?? "card"
    }), setDialogMode(null), saveSeenAnnouncements();
  }, $[22] = dialogMode, $[23] = saveSeenAnnouncements, $[24] = studioAnnouncements[0], $[25] = telemetry, $[26] = unseenAnnouncements[0], $[27] = t7) : t7 = $[27];
  const handleDialogClose = t7;
  let t8;
  $[28] !== studioAnnouncements || $[29] !== unseenAnnouncements ? (t8 = {
    studioAnnouncements,
    unseenAnnouncements,
    onDialogOpen: handleOpenDialog
  }, $[28] = studioAnnouncements, $[29] = unseenAnnouncements, $[30] = t8) : t8 = $[30];
  const contextValue = t8;
  let t9;
  $[31] !== handleCardClick || $[32] !== handleCardDismiss || $[33] !== isCardDismissed || $[34] !== unseenAnnouncements[0] || $[35] !== unseenAnnouncements.length ? (t9 = unseenAnnouncements.length > 0 && /* @__PURE__ */ jsx(StudioAnnouncementsCard, { preHeader: unseenAnnouncements[0].preHeader, title: unseenAnnouncements[0].title, name: unseenAnnouncements[0].name, id: unseenAnnouncements[0]._id, onCardClick: handleCardClick, isOpen: !isCardDismissed, onCardDismiss: handleCardDismiss }), $[31] = handleCardClick, $[32] = handleCardDismiss, $[33] = isCardDismissed, $[34] = unseenAnnouncements[0], $[35] = unseenAnnouncements.length, $[36] = t9) : t9 = $[36];
  let t10;
  $[37] !== dialogMode || $[38] !== handleDialogClose || $[39] !== studioAnnouncements || $[40] !== unseenAnnouncements ? (t10 = dialogMode && /* @__PURE__ */ jsx(StudioAnnouncementsDialog, { mode: dialogMode, announcements: dialogMode === "help_menu" ? studioAnnouncements : unseenAnnouncements, onClose: handleDialogClose }), $[37] = dialogMode, $[38] = handleDialogClose, $[39] = studioAnnouncements, $[40] = unseenAnnouncements, $[41] = t10) : t10 = $[41];
  let t11;
  return $[42] !== children || $[43] !== contextValue || $[44] !== t10 || $[45] !== t9 ? (t11 = /* @__PURE__ */ jsxs(StudioAnnouncementContext.Provider, { value: contextValue, children: [
    children,
    t9,
    t10
  ] }), $[42] = children, $[43] = contextValue, $[44] = t10, $[45] = t9, $[46] = t11) : t11 = $[46], t11;
}
function _temp3$2(doc_1) {
  return doc_1._id;
}
function _temp2$3(t0) {
  const [all, seen] = t0;
  return seen.loading || seen.error ? {
    unseen: [],
    all
  } : seen.value ? {
    unseen: all.filter((doc_0) => !seen.value?.includes(doc_0._id)),
    all
  } : {
    unseen: all,
    all
  };
}
function _temp$8() {
  return [];
}
function StudioAnnouncementsProvider(props2) {
  const $ = c(2);
  if (useSource().announcements?.enabled) {
    let t0;
    return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(StudioAnnouncementsProviderInner, { ...props2 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
  }
  return props2.children;
}
function isKnownError(err) {
  return !!(err instanceof SchemaError || err instanceof CorsOriginError || err instanceof ConfigResolutionError || isObject(err) && "ViteDevServerStoppedError" in err && err.ViteDevServerStoppedError);
}
const errorChannel = globalScope.__sanityErrorChannel;
function StudioRootErrorHandler(props2) {
  const $ = c(16), {
    children,
    primaryProjectId
  } = props2, [errorState, setErrorState] = useState();
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setErrorState(void 0), $[0] = t0) : t0 = $[0];
  const handleResetError = t0, toast = useToast();
  useHotModuleReload(handleResetError);
  let t1, t2;
  if ($[1] !== toast ? (t1 = () => {
    if (errorChannel)
      return errorChannel.subscribe((event) => {
        if (isDocumentLimitError(event.error) || !event.error || !(event.error instanceof Error))
          return;
        if (isKnownError(event.error)) {
          setErrorState({
            error: event.error
          });
          return;
        }
        let eventId;
        const run = () => {
          eventId = errorReporter.reportError(event.error)?.eventId;
        };
        try {
          run();
        } catch (t32) {
          const e = t32;
          e.message = `Encountered an additional error when reporting error: ${e.message}`, console.error(e);
        }
        if (isImportError(event.error)) {
          setErrorState({
            error: event.error,
            eventId
          });
          return;
        }
        toast.push({
          id: event.error.message,
          closable: !0,
          description: event.error.message,
          duration: 5e3,
          title: "Uncaught error",
          status: "error"
        });
      });
  }, t2 = [toast], $[1] = toast, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2), !errorState?.error)
    return children;
  if (errorState.error instanceof CorsOriginError) {
    let t32;
    return $[4] !== errorState.error.isStaging || $[5] !== errorState.error.projectId || $[6] !== primaryProjectId ? (t32 = /* @__PURE__ */ jsx(CorsOriginErrorScreen, { projectId: errorState.error.projectId, isStaging: errorState.error.isStaging, primaryProjectId }), $[4] = errorState.error.isStaging, $[5] = errorState.error.projectId, $[6] = primaryProjectId, $[7] = t32) : t32 = $[7], t32;
  }
  if (errorState.error instanceof SchemaError) {
    let t32;
    return $[8] !== errorState.error.schema ? (t32 = /* @__PURE__ */ jsx(SchemaErrorsScreen, { schema: errorState.error.schema }), $[8] = errorState.error.schema, $[9] = t32) : t32 = $[9], t32;
  }
  if (isImportError(errorState.error)) {
    let t32;
    return $[10] !== errorState.error || $[11] !== errorState.eventId ? (t32 = /* @__PURE__ */ jsx(ImportErrorScreen, { error: errorState.error, eventId: errorState.eventId }), $[10] = errorState.error, $[11] = errorState.eventId, $[12] = t32) : t32 = $[12], t32;
  }
  let t3;
  return $[13] !== errorState.error || $[14] !== errorState.eventId ? (t3 = /* @__PURE__ */ jsx(FallbackErrorScreen, { error: errorState.error, eventId: errorState.eventId, onReset: handleResetError }), $[13] = errorState.error, $[14] = errorState.eventId, $[15] = t3) : t3 = $[15], t3;
}
function _buildTints(bg, mid, fg) {
  return {
    50: mix(0.1, mid, bg),
    100: mix(0.2, mid, bg),
    200: mix(0.4, mid, bg),
    300: mix(0.6, mid, bg),
    400: mix(0.8, mid, bg),
    500: mid,
    600: mix(0.8, mid, fg),
    700: mix(0.6, mid, fg),
    800: mix(0.4, mid, fg),
    900: mix(0.2, mid, fg),
    950: mix(0.1, mid, fg)
  };
}
function _toHex(color) {
  const {
    red: red2,
    green: green2,
    blue: blue2
  } = parseToRgb(color);
  return rgb(red2, green2, blue2);
}
function _isDark(bg, fg) {
  return getLuminance(bg) < getLuminance(fg);
}
function _multiply(bg, fg) {
  const b = parseColor(bg), s = parseColor(fg);
  return rgbToHex(multiply(b, s));
}
function _screen(bg, fg) {
  const b = parseColor(bg), s = parseColor(fg);
  return rgbToHex(screen(b, s));
}
const NEUTRAL_TONES = ["default", "transparent"];
function buildColor(legacyPalette, legacyTones) {
  return createColorTheme({
    base: ({
      dark: navbar,
      name
    }) => {
      const stateTones = navbar ? legacyTones.state.navbar : legacyTones.state.default, dark = stateTones.dark, blend = navbar ? _screen : _multiply, tints = stateTones[name] || stateTones.default;
      if (name === "default") {
        const skeletonFrom2 = stateTones.default[100];
        return {
          fg: stateTones.fg,
          bg: stateTones.bg,
          border: stateTones.default[200],
          focusRing: legacyPalette.focus.base,
          shadow: {
            outline: rgba$1(stateTones.default[500], 0.4),
            umbra: rgba$1(dark ? legacyPalette.black : stateTones.default[500], 0.2),
            penumbra: rgba$1(dark ? legacyPalette.black : stateTones.default[500], 0.14),
            ambient: rgba$1(dark ? legacyPalette.black : stateTones.default[500], 0.12)
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (name === "transparent") {
        const bg2 = tints[50], skeletonFrom2 = blend(bg2, tints[100]);
        return {
          fg: tints[900],
          bg: bg2,
          border: tints[300],
          focusRing: legacyPalette.focus.base,
          shadow: {
            outline: rgba$1(tints[500], dark ? 0.2 : 0.4),
            umbra: rgba$1(dark ? legacyPalette.black : tints[500], 0.2),
            penumbra: rgba$1(dark ? legacyPalette.black : tints[500], 0.14),
            ambient: rgba$1(dark ? legacyPalette.black : tints[500], 0.12)
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      const bg = tints[50], skeletonFrom = blend(bg, tints[100]);
      return {
        fg: tints[900],
        bg,
        border: tints[200],
        focusRing: tints[500],
        shadow: {
          outline: rgba$1(tints[500], dark ? 0.2 : 0.4),
          umbra: rgba$1(dark ? legacyPalette.black : tints[500], 0.2),
          penumbra: rgba$1(dark ? legacyPalette.black : tints[500], 0.14),
          ambient: rgba$1(dark ? legacyPalette.black : tints[500], 0.12)
        },
        skeleton: {
          from: skeletonFrom,
          to: rgba$1(skeletonFrom, 0.5)
        }
      };
    },
    solid: ({
      base,
      dark: navbar,
      name,
      state,
      tone
    }) => {
      const buttonTones = navbar ? legacyTones.button.navbar : legacyTones.button.default, dark = buttonTones.dark, blend = dark ? _screen : _multiply, blendInvert = dark ? _multiply : _screen, defaultTints = buttonTones[name] || buttonTones.default, isNeutral = NEUTRAL_TONES.includes(name) && NEUTRAL_TONES.includes(tone);
      let tints = buttonTones[tone === "default" ? name : tone] || defaultTints;
      if (state === "disabled") {
        tints = defaultTints;
        const bg2 = blend(base.bg, tints[200]), skeletonFrom2 = blendInvert(bg2, tints[800]);
        return {
          bg: bg2,
          border: blend(base.bg, tints[200]),
          fg: blend(base.bg, buttonTones.bg),
          icon: blend(base.bg, buttonTones.bg),
          muted: {
            fg: blend(base.bg, tints[50])
          },
          accent: {
            fg: blend(base.bg, tints[50])
          },
          link: {
            fg: blend(base.bg, tints[50])
          },
          code: {
            bg: bg2,
            fg: blend(base.bg, tints[50])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (state === "hovered") {
        const bg2 = blend(base.bg, tints[600]), skeletonFrom2 = blendInvert(bg2, tints[800]);
        return {
          bg: bg2,
          border: blend(base.bg, tints[600]),
          fg: blend(base.bg, buttonTones.bg),
          icon: blend(base.bg, buttonTones.bg),
          muted: {
            fg: blend(base.bg, tints[200])
          },
          accent: {
            fg: blendInvert(bg2, buttonTones.critical[300])
          },
          link: {
            fg: blendInvert(bg2, buttonTones.primary[200])
          },
          code: {
            bg: blend(bg2, tints[50]),
            fg: blend(base.bg, tints[200])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (state === "pressed") {
        const bg2 = blend(base.bg, tints[800]), skeletonFrom2 = blendInvert(bg2, tints[800]);
        return {
          bg: bg2,
          border: blend(base.bg, tints[800]),
          fg: blend(base.bg, buttonTones.bg),
          icon: blend(base.bg, buttonTones.bg),
          muted: {
            fg: blend(base.bg, tints[200])
          },
          accent: {
            fg: blendInvert(bg2, buttonTones.critical[300])
          },
          link: {
            fg: blendInvert(bg2, buttonTones.primary[200])
          },
          code: {
            bg: blend(bg2, tints[50]),
            fg: blend(base.bg, tints[200])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (state === "selected") {
        isNeutral && (tints = buttonTones.primary);
        const bg2 = blend(base.bg, tints[800]), skeletonFrom2 = blendInvert(bg2, tints[800]);
        return {
          bg: bg2,
          border: blend(base.bg, tints[800]),
          fg: blend(base.bg, buttonTones.bg),
          icon: blend(base.bg, buttonTones.bg),
          muted: {
            fg: blend(base.bg, tints[200])
          },
          accent: {
            fg: blendInvert(bg2, buttonTones.critical[300])
          },
          link: {
            fg: blendInvert(bg2, buttonTones.primary[200])
          },
          code: {
            bg: blend(bg2, tints[50]),
            fg: blend(base.bg, tints[200])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      const bg = blend(base.bg, tints[500]), skeletonFrom = blendInvert(bg, tints[800]);
      return {
        bg,
        border: blend(base.bg, tints[500]),
        fg: blend(base.bg, buttonTones.bg),
        icon: blend(base.bg, buttonTones.bg),
        muted: {
          fg: blend(base.bg, tints[100])
        },
        accent: {
          fg: blendInvert(bg, buttonTones.critical[200])
        },
        link: {
          fg: blendInvert(bg, buttonTones.primary[100])
        },
        code: {
          bg: blend(bg, tints[50]),
          fg: blend(base.bg, tints[100])
        },
        skeleton: {
          from: skeletonFrom,
          to: rgba$1(skeletonFrom, 0.5)
        }
      };
    },
    muted: ({
      base,
      dark: navbar,
      name,
      state,
      tone
    }) => {
      const stateTones = navbar ? legacyTones.state.navbar : legacyTones.state.default, blend = stateTones.dark ? _screen : _multiply, defaultTints = stateTones[name] || stateTones.default, isNeutral = NEUTRAL_TONES.includes(name) && NEUTRAL_TONES.includes(tone);
      let tints = stateTones[tone === "default" ? name : tone] || defaultTints;
      if (state === "disabled") {
        tints = defaultTints;
        const bg2 = base.bg, skeletonFrom2 = blend(bg2, tints[100]);
        return {
          bg: bg2,
          border: blend(base.bg, tints[50]),
          fg: blend(base.bg, tints[200]),
          icon: blend(base.bg, tints[200]),
          muted: {
            fg: blend(bg2, tints[100])
          },
          accent: {
            fg: blend(bg2, tints[100])
          },
          link: {
            fg: blend(bg2, tints[100])
          },
          code: {
            bg: bg2,
            fg: blend(bg2, tints[100])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (state === "hovered") {
        const bg2 = blend(base.bg, tints[50]), skeletonFrom2 = blend(bg2, tints[100]);
        return {
          bg: bg2,
          border: blend(bg2, tints[100]),
          fg: blend(base.bg, tints[900]),
          icon: blend(base.bg, tints[900]),
          muted: {
            fg: blend(base.bg, tints[600])
          },
          accent: {
            fg: blend(base.bg, stateTones.critical[500])
          },
          link: {
            fg: blend(base.bg, stateTones.primary[600])
          },
          code: {
            bg: blend(bg2, tints[50]),
            fg: blend(base.bg, tints[600])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (state === "pressed") {
        isNeutral && (tints = stateTones.primary);
        const bg2 = blend(base.bg, tints[100]), skeletonFrom2 = blend(bg2, tints[100]);
        return {
          bg: bg2,
          border: blend(bg2, tints[100]),
          fg: blend(base.bg, tints[800]),
          icon: blend(base.bg, tints[800]),
          muted: {
            fg: blend(base.bg, tints[600])
          },
          accent: {
            fg: blend(bg2, stateTones.critical[500])
          },
          link: {
            fg: blend(bg2, stateTones.primary[600])
          },
          code: {
            bg: blend(bg2, tints[50]),
            fg: blend(bg2, tints[600])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (state === "selected") {
        isNeutral && (tints = stateTones.primary);
        const bg2 = blend(base.bg, tints[100]), skeletonFrom2 = blend(bg2, tints[100]);
        return {
          bg: bg2,
          border: blend(bg2, tints[100]),
          fg: blend(bg2, tints[800]),
          icon: blend(bg2, tints[800]),
          muted: {
            fg: blend(bg2, tints[600])
          },
          accent: {
            fg: blend(bg2, stateTones.critical[500])
          },
          link: {
            fg: blend(bg2, stateTones.primary[600])
          },
          code: {
            bg: blend(bg2, tints[50]),
            fg: blend(bg2, tints[600])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      const bg = base.bg, skeletonFrom = blend(base.bg, tints[100]);
      return {
        bg,
        border: blend(bg, tints[100]),
        fg: blend(bg, tints[700]),
        icon: blend(bg, tints[700]),
        muted: {
          fg: blend(bg, tints[600])
        },
        accent: {
          fg: blend(bg, stateTones.critical[500])
        },
        link: {
          fg: blend(bg, stateTones.primary[600])
        },
        code: {
          bg: blend(bg, tints[50]),
          fg: blend(bg, tints[600])
        },
        skeleton: {
          from: skeletonFrom,
          to: rgba$1(skeletonFrom, 0.5)
        }
      };
    },
    button: ({
      base,
      mode,
      muted,
      solid
    }) => mode === "bleed" ? {
      enabled: {
        ...muted.enabled,
        border: muted.enabled.bg
      },
      hovered: {
        ...muted.hovered,
        border: muted.hovered.bg
      },
      pressed: {
        ...muted.pressed,
        border: muted.pressed.bg
      },
      selected: {
        ...muted.selected,
        border: muted.selected.bg
      },
      disabled: {
        ...muted.disabled,
        border: muted.disabled.bg
      }
    } : mode === "ghost" ? {
      ...solid,
      enabled: {
        ...muted.enabled,
        border: base.border
      },
      disabled: muted.disabled
    } : solid,
    card: ({
      base,
      dark: navbar,
      muted,
      name,
      solid,
      state
    }) => {
      if (state === "hovered")
        return muted[name].hovered;
      if (state === "disabled")
        return muted[name].disabled;
      const isNeutral = NEUTRAL_TONES.includes(name), stateTones = navbar ? legacyTones.state.navbar : legacyTones.state.default, tints = stateTones[name] || stateTones.default, dark = stateTones.dark, blend = dark ? _screen : _multiply;
      if (state === "pressed")
        return isNeutral ? muted.primary.pressed : muted[name].pressed;
      if (state === "selected")
        return isNeutral ? solid.primary.enabled : solid[name].enabled;
      const bg = base.bg, skeletonFrom = blend(base.bg, tints[dark ? 900 : 100]);
      return {
        bg,
        fg: base.fg,
        icon: base.fg,
        border: base.border,
        muted: {
          fg: blend(base.bg, tints[dark ? 400 : 600])
        },
        accent: {
          fg: blend(base.bg, stateTones.critical[dark ? 400 : 500])
        },
        link: {
          fg: blend(base.bg, stateTones.primary[dark ? 400 : 600])
        },
        code: {
          bg: blend(base.bg, tints[dark ? 950 : 50]),
          fg: tints[dark ? 400 : 600]
        },
        skeleton: {
          from: skeletonFrom,
          to: rgba$1(skeletonFrom, 0.5)
        }
      };
    },
    input: ({
      base,
      dark: navbar,
      mode,
      state
    }) => {
      const stateTones = navbar ? legacyTones.state.navbar : legacyTones.state.default, blend = stateTones.dark ? _screen : _multiply;
      if (mode === "invalid") {
        const tints = stateTones.critical;
        return {
          bg: blend(base.bg, tints[50]),
          bg2: blend(base.bg, tints[50]),
          fg: blend(base.bg, tints[700]),
          border: blend(base.bg, tints[200]),
          placeholder: blend(base.bg, tints[400])
        };
      }
      return state === "hovered" ? {
        bg: base.bg,
        bg2: base.bg,
        fg: base.fg,
        border: blend(base.bg, hues.gray[300].hex),
        placeholder: blend(base.bg, hues.gray[400].hex)
      } : state === "disabled" ? {
        bg: blend(base.bg, hues.gray[50].hex),
        bg2: blend(base.bg, hues.gray[50].hex),
        fg: blend(base.bg, hues.gray[200].hex),
        border: blend(base.bg, hues.gray[100].hex),
        placeholder: blend(base.bg, hues.gray[100].hex)
      } : state === "readOnly" ? {
        bg: blend(base.bg, hues.gray[50].hex),
        bg2: blend(base.bg, hues.gray[50].hex),
        fg: blend(base.bg, hues.gray[800].hex),
        border: blend(base.bg, hues.gray[200].hex),
        placeholder: blend(base.bg, hues.gray[400].hex)
      } : {
        bg: base.bg,
        bg2: base.bg,
        fg: base.fg,
        border: base.border,
        placeholder: blend(base.bg, hues.gray[700].hex)
      };
    },
    selectable: ({
      base,
      muted,
      tone,
      solid,
      state
    }) => state === "enabled" ? {
      ...muted[tone].enabled,
      bg: base.bg
    } : state === "pressed" ? tone === "default" ? muted.primary.pressed : muted[tone].pressed : state === "selected" ? tone === "default" ? solid.primary.enabled : solid[tone].enabled : state === "disabled" ? {
      ...muted[tone].disabled,
      bg: base.bg
    } : muted[tone][state],
    spot: ({
      base,
      key
    }) => {
      const dark = _isDark(base.bg, base.fg);
      return (dark ? _screen : _multiply)(base.bg, hues[key][dark ? 400 : 500].hex);
    },
    syntax: ({
      base,
      dark: navbar
    }) => {
      const stateTones = navbar ? legacyTones.state.navbar : legacyTones.state.default, blend = stateTones.dark ? _screen : _multiply, mainShade = 600, secondaryShade = 400;
      return {
        atrule: blend(base.bg, hues.purple[mainShade].hex),
        attrName: blend(base.bg, stateTones.positive[mainShade]),
        attrValue: blend(base.bg, stateTones.caution[mainShade]),
        attribute: blend(base.bg, stateTones.caution[mainShade]),
        boolean: blend(base.bg, hues.purple[mainShade].hex),
        builtin: blend(base.bg, hues.purple[mainShade].hex),
        cdata: blend(base.bg, stateTones.caution[mainShade]),
        char: blend(base.bg, stateTones.caution[mainShade]),
        class: blend(base.bg, hues.orange[mainShade].hex),
        className: blend(base.bg, hues.cyan[mainShade].hex),
        comment: blend(base.bg, stateTones.default[secondaryShade]),
        constant: blend(base.bg, hues.purple[mainShade].hex),
        deleted: blend(base.bg, stateTones.critical[mainShade]),
        doctype: blend(base.bg, stateTones.default[secondaryShade]),
        entity: blend(base.bg, stateTones.critical[mainShade]),
        function: blend(base.bg, stateTones.positive[mainShade]),
        hexcode: blend(base.bg, stateTones.primary[mainShade]),
        id: blend(base.bg, hues.purple[mainShade].hex),
        important: blend(base.bg, hues.purple[mainShade].hex),
        inserted: blend(base.bg, stateTones.caution[mainShade]),
        keyword: blend(base.bg, hues.magenta[mainShade].hex),
        number: blend(base.bg, hues.purple[mainShade].hex),
        operator: blend(base.bg, hues.magenta[mainShade].hex),
        prolog: blend(base.bg, stateTones.default[secondaryShade]),
        property: blend(base.bg, stateTones.primary[mainShade]),
        pseudoClass: blend(base.bg, stateTones.caution[mainShade]),
        pseudoElement: blend(base.bg, stateTones.caution[mainShade]),
        punctuation: blend(base.bg, stateTones.default[mainShade]),
        regex: blend(base.bg, stateTones.primary[mainShade]),
        selector: blend(base.bg, stateTones.critical[mainShade]),
        string: blend(base.bg, stateTones.caution[mainShade]),
        symbol: blend(base.bg, hues.purple[mainShade].hex),
        tag: blend(base.bg, stateTones.critical[mainShade]),
        unit: blend(base.bg, hues.orange[mainShade].hex),
        url: blend(base.bg, stateTones.critical[mainShade]),
        variable: blend(base.bg, stateTones.critical[mainShade])
      };
    }
  });
}
function buildFonts(cssCustomProperties) {
  return {
    ...studioTheme.fonts,
    code: {
      ...studioTheme.fonts.code,
      family: cssCustomProperties["--font-family-monospace"] || studioTheme.fonts.code.family
    },
    heading: {
      ...studioTheme.fonts.heading,
      family: cssCustomProperties["--font-family-base"] || studioTheme.fonts.code.family
    },
    label: {
      ...studioTheme.fonts.label,
      family: cssCustomProperties["--font-family-base"] || studioTheme.fonts.code.family
    },
    text: {
      ...studioTheme.fonts.text,
      family: cssCustomProperties["--font-family-base"] || studioTheme.fonts.code.family
    }
  };
}
function buildLegacyPalette(cssCustomProperties) {
  return {
    black: _toHex(cssCustomProperties["--black"]),
    component: {
      bg: _toHex(cssCustomProperties["--component-bg"]),
      fg: _toHex(cssCustomProperties["--component-text-color"])
    },
    defaultButton: {
      default: {
        base: _toHex(cssCustomProperties["--default-button-color"])
      },
      primary: {
        base: _toHex(cssCustomProperties["--default-button-primary-color"])
      },
      success: {
        base: _toHex(cssCustomProperties["--default-button-success-color"])
      },
      warning: {
        base: _toHex(cssCustomProperties["--default-button-warning-color"])
      },
      danger: {
        base: _toHex(cssCustomProperties["--default-button-danger-color"])
      }
    },
    focus: {
      base: _toHex(cssCustomProperties["--focus-color"])
    },
    gray: {
      base: _toHex(cssCustomProperties["--gray-base"])
    },
    mainNavigation: {
      bg: _toHex(cssCustomProperties["--main-navigation-color"]),
      fg: _toHex(cssCustomProperties["--main-navigation-color--inverted"])
    },
    state: {
      info: {
        fg: _toHex(cssCustomProperties["--state-info-color"])
      },
      success: {
        fg: _toHex(cssCustomProperties["--state-success-color"])
      },
      warning: {
        fg: _toHex(cssCustomProperties["--state-warning-color"])
      },
      danger: {
        fg: _toHex(cssCustomProperties["--state-danger-color"])
      }
    }
  };
}
function buildLegacyTones(legacyPalette) {
  return {
    state: {
      default: {
        bg: legacyPalette.component.bg,
        fg: legacyPalette.component.fg,
        dark: _isDark(legacyPalette.component.bg, legacyPalette.component.fg),
        default: _buildTints(legacyPalette.component.bg, legacyPalette.gray.base, legacyPalette.component.fg),
        transparent: _buildTints(legacyPalette.component.bg, legacyPalette.gray.base, legacyPalette.component.fg),
        primary: _buildTints(legacyPalette.component.bg, legacyPalette.state.info.fg, legacyPalette.component.fg),
        positive: _buildTints(legacyPalette.component.bg, legacyPalette.state.success.fg, legacyPalette.component.fg),
        caution: _buildTints(legacyPalette.component.bg, legacyPalette.state.warning.fg, legacyPalette.component.fg),
        critical: _buildTints(legacyPalette.component.bg, legacyPalette.state.danger.fg, legacyPalette.component.fg)
      },
      navbar: {
        bg: legacyPalette.mainNavigation.bg,
        fg: legacyPalette.mainNavigation.fg,
        dark: _isDark(legacyPalette.mainNavigation.bg, legacyPalette.mainNavigation.fg),
        default: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.gray.base, legacyPalette.mainNavigation.fg),
        transparent: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.gray.base, legacyPalette.mainNavigation.fg),
        primary: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.state.info.fg, legacyPalette.mainNavigation.fg),
        positive: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.state.success.fg, legacyPalette.mainNavigation.fg),
        caution: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.state.warning.fg, legacyPalette.mainNavigation.fg),
        critical: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.state.danger.fg, legacyPalette.mainNavigation.fg)
      }
    },
    button: {
      default: {
        bg: legacyPalette.component.bg,
        fg: legacyPalette.component.fg,
        dark: _isDark(legacyPalette.component.bg, legacyPalette.component.fg),
        default: _buildTints(legacyPalette.component.bg, legacyPalette.defaultButton.default.base, legacyPalette.component.fg),
        transparent: _buildTints(legacyPalette.component.bg, legacyPalette.defaultButton.default.base, legacyPalette.component.fg),
        primary: _buildTints(legacyPalette.component.bg, legacyPalette.defaultButton.primary.base, legacyPalette.component.fg),
        positive: _buildTints(legacyPalette.component.bg, legacyPalette.defaultButton.success.base, legacyPalette.component.fg),
        caution: _buildTints(legacyPalette.component.bg, legacyPalette.defaultButton.warning.base, legacyPalette.component.fg),
        critical: _buildTints(legacyPalette.component.bg, legacyPalette.defaultButton.danger.base, legacyPalette.component.fg)
      },
      navbar: {
        bg: legacyPalette.mainNavigation.bg,
        fg: legacyPalette.mainNavigation.fg,
        dark: _isDark(legacyPalette.mainNavigation.bg, legacyPalette.mainNavigation.fg),
        default: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.defaultButton.default.base, legacyPalette.mainNavigation.fg),
        transparent: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.defaultButton.default.base, legacyPalette.mainNavigation.fg),
        primary: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.defaultButton.primary.base, legacyPalette.mainNavigation.fg),
        positive: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.defaultButton.success.base, legacyPalette.mainNavigation.fg),
        caution: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.defaultButton.warning.base, legacyPalette.mainNavigation.fg),
        critical: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.defaultButton.danger.base, legacyPalette.mainNavigation.fg)
      }
    }
  };
}
function buildLegacyTheme(partialLegacyTheme) {
  const legacyTheme = resolveLegacyTheme(partialLegacyTheme), legacyPalette = buildLegacyPalette(legacyTheme), legacyTones = buildLegacyTones(legacyPalette), color = buildColor(legacyPalette, legacyTones), fonts = buildFonts(legacyTheme);
  return {
    __dark: _isDark(color.light.default.base.bg, color.light.default.base.fg),
    __legacy: !0,
    color,
    fonts
  };
}
const defaultCustomProperties = {
  "--font-family-monospace": studioTheme.fonts.code.family,
  "--font-family-base": studioTheme.fonts.text.family,
  "--black": black.hex,
  "--white": white.hex,
  // Brand
  "--brand-primary": blue[500].hex,
  // Component
  "--component-bg": white.hex,
  "--component-text-color": black.hex,
  // Gray
  "--gray": gray[500].hex,
  "--gray-base": gray[500].hex,
  // Default button
  "--default-button-color": gray[500].hex,
  "--default-button-danger-color": red[500].hex,
  "--default-button-primary-color": blue[500].hex,
  "--default-button-success-color": green[500].hex,
  "--default-button-warning-color": yellow[500].hex,
  // Focus
  "--focus-color": blue[500].hex,
  // Screen
  "--screen-medium-break": "512px",
  "--screen-default-break": "640px",
  "--screen-large-break": "960px",
  "--screen-xlarge-break": "1600px",
  // State
  "--state-info-color": blue[500].hex,
  "--state-success-color": green[500].hex,
  "--state-warning-color": yellow[500].hex,
  "--state-danger-color": red[500].hex,
  // Navbar
  "--main-navigation-color": black.hex,
  "--main-navigation-color--inverted": white.hex
};
function resolveLegacyTheme(legacyTheme) {
  const props2 = {
    ...defaultCustomProperties,
    ...legacyTheme
  };
  return props2["--focus-color"] = legacyTheme["--focus-color"] || props2["--brand-primary"], props2["--default-button-primary-color"] = legacyTheme["--default-button-primary-color"] || props2["--brand-primary"], props2["--main-navigation-color"] = legacyTheme["--main-navigation-color"] || props2["--black"], props2["--main-navigation-color--inverted"] = legacyTheme["--main-navigation-color--inverted"] || props2["--white"], props2["--state-info-color"] = legacyTheme["--brand-primary"] || props2["--brand-primary"], props2;
}
let _defaultTheme;
function getDefaultTheme() {
  return _defaultTheme || (_defaultTheme = buildTheme()), _defaultTheme;
}
const defaultTheme = /* @__PURE__ */ new Proxy({}, {
  get(_target, prop, receiver) {
    return Reflect.get(getDefaultTheme(), prop, receiver);
  },
  ownKeys() {
    return Reflect.ownKeys(getDefaultTheme());
  },
  getOwnPropertyDescriptor(_target, prop) {
    return Object.getOwnPropertyDescriptor(getDefaultTheme(), prop);
  },
  has(_target, prop) {
    return prop in getDefaultTheme();
  }
}), isThemerTheme = (theme) => theme.__themer === !0;
function getThemeValues(theme) {
  const defaultTheme2 = getDefaultTheme();
  return {
    ...defaultTheme2,
    v2: theme.v2,
    fonts: isThemerTheme(theme) ? defaultTheme2.fonts : theme.fonts ?? defaultTheme2.fonts,
    color: theme.color ?? defaultTheme2.color
  };
}
function StudioThemeProvider(t0) {
  const $ = c(18), {
    children
  } = t0, theme = useActiveWorkspace().activeWorkspace.theme;
  if (theme.__legacy) {
    const scheme = theme.__dark ? "dark" : "light";
    let t12;
    $[0] !== theme ? (t12 = getThemeValues(theme), $[0] = theme, $[1] = t12) : t12 = $[1];
    let t22;
    $[2] !== children ? (t22 = /* @__PURE__ */ jsx(LayerProvider, { children }), $[2] = children, $[3] = t22) : t22 = $[3];
    let t32;
    $[4] !== scheme || $[5] !== t12 || $[6] !== t22 ? (t32 = /* @__PURE__ */ jsx(ThemeProvider, { scheme, theme: t12, children: t22 }), $[4] = scheme, $[5] = t12, $[6] = t22, $[7] = t32) : t32 = $[7];
    let t4;
    return $[8] !== scheme || $[9] !== t32 ? (t4 = /* @__PURE__ */ jsx(ColorSchemeSetValueContext.Provider, { value: !1, children: /* @__PURE__ */ jsx(ColorSchemeValueContext.Provider, { value: scheme, children: t32 }) }), $[8] = scheme, $[9] = t32, $[10] = t4) : t4 = $[10], t4;
  }
  let t1;
  $[11] !== theme ? (t1 = getThemeValues(theme), $[11] = theme, $[12] = t1) : t1 = $[12];
  let t2;
  $[13] !== children ? (t2 = /* @__PURE__ */ jsx(LayerProvider, { children }), $[13] = children, $[14] = t2) : t2 = $[14];
  let t3;
  return $[15] !== t1 || $[16] !== t2 ? (t3 = /* @__PURE__ */ jsx(ThemeProvider, { theme: t1, children: t2 }), $[15] = t1, $[16] = t2, $[17] = t3) : t3 = $[17], t3;
}
const PerformanceINPMeasured = defineEvent({
  name: "Performance INP Measured",
  // Sample at most every minute
  maxSampleRate: 6e4,
  version: 1,
  description: "Performance INP (Interaction to Next Paint) measurement happened"
}), PerformanceLCPMeasured = defineEvent({
  name: "Performance LCP Measured",
  version: 2,
  description: "Largest Contentful Paint measurement with attribution"
}), PerformanceFCPMeasured = defineEvent({
  name: "Performance FCP Measured",
  version: 2,
  description: "First Contentful Paint measurement with attribution"
}), PerformanceCLSMeasured = defineEvent({
  name: "Performance CLS Measured",
  version: 2,
  description: "Cumulative Layout Shift measurement with attribution"
}), PerformanceTTFBMeasured = defineEvent({
  name: "Performance TTFB Measured",
  version: 2,
  description: "Time to First Byte measurement with attribution"
}), PerformanceINPMeasuredV2 = defineEvent({
  name: "Performance INP Measured",
  version: 2,
  description: "Interaction to Next Paint with attribution (web-vitals)",
  maxSampleRate: 3e4
  // Sample at most every 30 seconds
});
function getInterestingAttrs(node) {
  if (!node || !(node instanceof Element))
    return;
  const ui = node.getAttribute("data-ui") || void 0, testId = node.getAttribute("data-testid") || void 0;
  return ui || testId ? {
    ui,
    testId
  } : void 0;
}
function getElementIdentifier(node) {
  if (!node)
    return null;
  if (!(node instanceof Element))
    return node.nodeName;
  const {
    nodeName,
    classList,
    id: id2
  } = node;
  return nodeName.toLowerCase() + (id2 ? `#${id2}` : "") + (classList ? `.${classList.value.replaceAll(" ", ".")}` : "");
}
function isPerformanceEventTiming(entry) {
  return entry.entryType === "event";
}
function useMeasurePerformanceTelemetry() {
  const $ = c(5), telemetry = useTelemetry();
  let t0;
  $[0] !== telemetry ? (t0 = (list, observer) => {
    const entries = list.getEntries();
    let maxEntry;
    for (const entry of entries)
      isPerformanceEventTiming(entry) && entry.duration > (maxEntry?.duration || 0) && (maxEntry = entry);
    maxEntry && telemetry.log(PerformanceINPMeasured, {
      target: getElementIdentifier(maxEntry.target),
      attrs: getInterestingAttrs(maxEntry.target),
      interaction: maxEntry.name,
      duration: maxEntry.duration
    });
  }, $[0] = telemetry, $[1] = t0) : t0 = $[1];
  const onEvent = t0;
  let t1, t2;
  $[2] !== onEvent ? (t1 = () => {
    if (!("PerformanceObserver" in globalThis))
      return;
    const observer_0 = new PerformanceObserver(onEvent);
    return observer_0.observe({
      type: "event",
      buffered: !0
    }), () => {
      observer_0.disconnect();
    };
  }, t2 = [onEvent], $[2] = onEvent, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]), useEffect(t1, t2);
}
function useWebVitalsTelemetry() {
  const $ = c(3), telemetry = useTelemetry(), hasInitialized = useRef(!1);
  let t0, t1;
  $[0] !== telemetry ? (t0 = () => {
    hasInitialized.current || (hasInitialized.current = !0, onLCP((metric) => {
      telemetry.log(PerformanceLCPMeasured, metric);
    }), onFCP((metric_0) => {
      telemetry.log(PerformanceFCPMeasured, metric_0);
    }), onCLS((metric_1) => {
      telemetry.log(PerformanceCLSMeasured, metric_1);
    }), onTTFB((metric_2) => {
      telemetry.log(PerformanceTTFBMeasured, metric_2);
    }), onINP((metric_3) => {
      telemetry.log(PerformanceINPMeasuredV2, metric_3);
    }));
  }, t1 = [telemetry], $[0] = telemetry, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
}
function PerformanceTelemetryTracker(props2) {
  return useMeasurePerformanceTelemetry(), useWebVitalsTelemetry(), props2.children;
}
const sessionId = createSessionId(), DEBUG_TELEMETRY = import.meta && import.meta.env?.SANITY_STUDIO_DEBUG_TELEMETRY === "true", isClient = typeof window < "u", debugLoggingStore = {
  flushInterval: 1e3,
  resolveConsent: () => Promise.resolve({
    status: "granted"
  }),
  sendEvents: async (batch) => {
    console.log("[telemetry] submit events (noop): %O", batch);
  },
  sendBeacon: (batch) => (console.log("[telemetry] submit events (noop): %O", batch), !0)
};
function StudioTelemetryProvider(props2) {
  const client = useClient({
    apiVersion: "v2023-12-18"
  }), projectId = client.config().projectId, workspace = useWorkspace(), {
    value: orgId
  } = useProjectOrganizationId(), activeTool = useRouterState(useCallback((routerState) => typeof routerState.tool == "string" ? routerState.tool : void 0, [])), contextRef = useRef(null);
  useEffect(() => {
    isClient && (contextRef.current = {
      // Static values
      userAgent: navigator.userAgent,
      screen: {
        density: window.devicePixelRatio,
        height: window.screen.height,
        width: window.screen.width,
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth
      },
      studioVersion: SANITY_VERSION,
      reactVersion: version,
      environment: isProd ? "production" : "development",
      // Dynamic values
      orgId: orgId || null,
      activeTool,
      activeWorkspace: workspace.name,
      activeProjectId: workspace.projectId,
      activeDataset: workspace.dataset
    });
  }, [orgId, activeTool, workspace.name, workspace.projectId, workspace.dataset]);
  const storeOptions = useMemo(() => DEBUG_TELEMETRY ? debugLoggingStore : {
    flushInterval: 3e4,
    resolveConsent: () => client.request({
      uri: "/intake/telemetry-status",
      tag: "telemetry-consent.studio"
    }),
    // Each event is enriched with the current context
    sendEvents: (batch) => {
      if (!isClient || !contextRef.current) return Promise.resolve();
      const context = contextRef.current, enrichedBatch = batch.map((event) => ({
        ...event,
        context
      }));
      return client.request({
        uri: "/intake/batch",
        method: "POST",
        json: !0,
        body: {
          projectId,
          batch: enrichedBatch
        }
      });
    },
    sendBeacon: (batch_0) => {
      if (!isClient || !contextRef.current) return !1;
      const context_0 = contextRef.current, enrichedBatch_0 = batch_0.map((event_0) => ({
        ...event_0,
        context: context_0
      }));
      return navigator.sendBeacon(client.getUrl("/intake/batch"), JSON.stringify({
        projectId,
        batch: enrichedBatch_0
      }));
    }
  }, [client, projectId]), store = useMemo(() => createBatchedStore(sessionId, storeOptions), [storeOptions]);
  return useEffect(() => {
    !isClient || !contextRef.current || store.logger.updateUserProperties({
      userAgent: contextRef.current.userAgent,
      screen: contextRef.current.screen,
      reactVersion: version,
      studioVersion: SANITY_VERSION,
      environment: contextRef.current.environment
    });
  }, [store.logger]), /* @__PURE__ */ jsx(TelemetryProvider, { store, children: /* @__PURE__ */ jsx(PerformanceTelemetryTracker, { children: props2.children }) });
}
const ListItem = styled(Flex).withConfig({
  displayName: "ListItem",
  componentId: "sc-q8j4kz-0"
})``, ErrorMessageRoot = styled(Box).attrs({
  padding: 4
}).withConfig({
  displayName: "ErrorMessageRoot",
  componentId: "sc-q8j4kz-1"
})``;
function ErrorMessage(t0) {
  const $ = c(20), {
    error,
    message,
    path,
    stack
  } = t0;
  let t1, t2;
  $[0] !== error ? (t1 = () => {
    console.error(error);
  }, t2 = [error], $[0] = error, $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]), useEffect(t1, t2);
  const last2 = path[path.length - 1];
  let t3;
  $[3] !== last2.type ? (t3 = startCase(last2.type), $[3] = last2.type, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t3 ? (t4 = /* @__PURE__ */ jsx(Flex, { direction: "column", gap: 2, children: /* @__PURE__ */ jsxs(Text$1, { weight: "medium", size: 3, children: [
    t3,
    " Error"
  ] }) }), $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== message ? (t5 = /* @__PURE__ */ jsx(Card, { tone: "critical", overflow: "auto", padding: 4, children: /* @__PURE__ */ jsx(Code, { children: message }) }), $[7] = message, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== path ? (t6 = path.map(_temp$7), $[9] = path, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== t6 ? (t7 = /* @__PURE__ */ jsx(Flex, { as: "ul", direction: "column", gap: 2, children: t6 }), $[11] = t6, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== stack ? (t8 = stack && /* @__PURE__ */ jsxs("details", { children: [
    /* @__PURE__ */ jsx(Text$1, { as: "summary", children: "Stack Trace" }),
    /* @__PURE__ */ jsx(Box, { overflow: "auto", marginTop: 4, children: /* @__PURE__ */ jsx(Code, { children: stack }) })
  ] }), $[13] = stack, $[14] = t8) : t8 = $[14];
  let t9;
  return $[15] !== t4 || $[16] !== t5 || $[17] !== t7 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsxs(ErrorMessageRoot, { forwardedAs: Flex, direction: "column", gap: 4, children: [
    t4,
    t5,
    t7,
    t8
  ] }), $[15] = t4, $[16] = t5, $[17] = t7, $[18] = t8, $[19] = t9) : t9 = $[19], t9;
}
function _temp$7(t0, index) {
  const {
    name,
    type
  } = t0;
  return /* @__PURE__ */ jsxs(ListItem, { forwardedAs: "li", gap: 2, align: "center", children: [
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Code, { children: name }) }),
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: type }) })
  ] }, index);
}
function createRouter(opts) {
  const {
    basePath = "/",
    tools
  } = opts, toolRoute = route.create("/:tool", (toolParams) => {
    let tool = tools.find((current) => current.name === toolParams.tool);
    return !tool && toolParams.tool === "desk" && (tool = tools.find((current) => current.name === "structure")), tool ? route.scope(tool.name, "/", tool.router) : route.create("/");
  });
  return route.create(basePath, [route.intents("/intent"), toolRoute]);
}
function getOrderedTools(tools) {
  const config = {}.toolSwitcher || {}, order = config.order || [], hidden = config.hidden || [];
  if (!order.length && !hidden.length)
    return tools;
  const keyed = tools.reduce((target, tool) => {
    const title = tool.title || "<unknown>";
    if (!tool.name)
      return console.warn(`Tool "${title}" does not have the required "name" property`), target;
    if (target[tool.name]) {
      const existing = target[tool.name].tool.title;
      return console.warn(`Tools with duplicate name "${tool.name}" found ("${title}" and "${existing}")`), target;
    }
    const toolIndex = order.indexOf(tool.name);
    return target[tool.name] = {
      tool,
      index: toolIndex === -1 ? 1 / 0 : toolIndex
    }, target;
  }, {}), isVisible2 = (tool) => hidden.indexOf(tool.name) === -1, ret = tools.filter(isVisible2);
  return ret.sort((tool1, tool2) => {
    const toolA = keyed[tool1.name], toolB = keyed[tool2.name], indexA = toolA ? toolA.index : 1 / 0, indexB = toolB ? toolB.index : 1 / 0;
    return indexA === indexB ? 0 : indexA - indexB;
  }), ret;
}
const WEIGHTED_CREATE_INTENT_PARAMS = ["mode", "template"], WEIGHTED_EDIT_INTENT_PARAMS = ["mode"];
function resolveUrlStateWithDefaultTool(tools, state) {
  const defaultTool = getOrderedTools(tools).find(isDefaultRouteTool);
  return !state || state.tool || !defaultTool ? state : Object.assign({}, state, {
    tool: defaultTool.name
  });
}
function makeBackwardsCompatible(tools, state) {
  return state && (getOrderedTools(tools).find((tool) => tool.name === state.space) ? {
    ...state,
    tool: state.space,
    space: void 0
  } : state);
}
function resolveDefaultState(tools, state) {
  return resolveUrlStateWithDefaultTool(tools, makeBackwardsCompatible(tools, state));
}
function resolveIntentState(tools, prevState, nextState) {
  const {
    intent,
    params,
    payload
  } = nextState;
  if (typeof intent != "string")
    throw new Error("intent must be a string");
  if (!isRecord$4(params))
    throw new Error("intent params must be a string");
  const orderedTools = getOrderedTools(tools), currentTool = prevState?.tool ? orderedTools.find((tool) => tool.name === prevState.tool) : null, otherTools = currentTool ? orderedTools.filter((tool) => tool !== currentTool) : orderedTools;
  let weightedParams = [];
  intent === "create" ? weightedParams = WEIGHTED_CREATE_INTENT_PARAMS : intent === "edit" && (weightedParams = WEIGHTED_EDIT_INTENT_PARAMS);
  const initialMatch = {
    score: -1,
    tool: null
  }, {
    tool: matchingTool
  } = (currentTool ? [currentTool, ...otherTools] : orderedTools).reduce((prev, tool) => {
    if (!tool || typeof tool.canHandleIntent != "function")
      return prev;
    const canHandle = tool.canHandleIntent(intent, params, prevState && prevState[tool.name]);
    if (typeof canHandle == "boolean")
      return canHandle && prev.score < 0 ? {
        score: 0,
        tool
      } : prev;
    if (!isRecord$4(canHandle))
      return prev;
    const score = weightedParams.reduce((prevScore, weightedParam) => weightedParam in params && canHandle[weightedParam] ? prevScore + 1 : prevScore, 0);
    return score > prev.score ? {
      score,
      tool
    } : prev;
  }, initialMatch);
  if (matchingTool?.getIntentState) {
    const _toolState = matchingTool.getIntentState(intent, params, prevState && prevState[matchingTool.name], payload), {
      _searchParams,
      ...toolState
    } = _toolState, nextUrlState = {
      ...prevState,
      _searchParams: nextState._searchParams,
      tool: matchingTool.name,
      [matchingTool.name]: toolState
    };
    if (matchingTool.router?.__unsafe_disableScopedSearchParams) {
      const stickyParams = nextState._searchParams?.filter(([key]) => STICKY_PARAMS.includes(key));
      nextUrlState._searchParams = [...stickyParams || [], ...Array.isArray(_searchParams) ? _searchParams : []];
    } else
      toolState._searchParams = _searchParams;
    return {
      type: "state",
      isNotFound: !1,
      state: nextUrlState
    };
  }
  return {
    type: "intent",
    isNotFound: !0,
    intent: {
      name: intent,
      params
    }
  };
}
function decodeUrlState(rootRouter, pathname) {
  return {
    type: "state",
    state: rootRouter.decode(pathname) || {},
    isNotFound: rootRouter.isNotFound(pathname)
  };
}
function WorkspaceRouterProvider(t0) {
  const $ = c(10), {
    children,
    LoadingComponent,
    workspace
  } = t0, {
    basePath,
    tools
  } = workspace, history2 = useRouterHistory();
  let t1;
  $[0] !== basePath || $[1] !== tools ? (t1 = createRouter({
    basePath,
    tools
  }), $[0] = basePath, $[1] = tools, $[2] = t1) : t1 = $[2];
  const router = t1, [state, onNavigate] = useRouterFromWorkspaceHistory(history2, router, tools), handleCatchError = _temp$6;
  if (!state) {
    let t22;
    return $[3] !== LoadingComponent ? (t22 = /* @__PURE__ */ jsx(LoadingComponent, {}), $[3] = LoadingComponent, $[4] = t22) : t22 = $[4], t22;
  }
  let t2;
  return $[5] !== children || $[6] !== onNavigate || $[7] !== router || $[8] !== state ? (t2 = /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: handleCatchError, children: /* @__PURE__ */ jsx(RouterProvider, { onNavigate, router, state, children }) }), $[5] = children, $[6] = onNavigate, $[7] = router, $[8] = state, $[9] = t2) : t2 = $[9], t2;
}
function _temp$6(t0) {
  const {
    error
  } = t0;
  throw error;
}
function useRouterFromWorkspaceHistory(history2, router, tools) {
  const $ = c(45);
  let routerBasePath, t0, t1;
  $[0] !== router ? (routerBasePath = router.getBasePath(), t1 = RegExp, t0 = escapeRegExp$1(routerBasePath), $[0] = router, $[1] = routerBasePath, $[2] = t0, $[3] = t1) : (routerBasePath = $[1], t0 = $[2], t1 = $[3]);
  const t2 = `^${t0}(\\/|\\?|$)`;
  let t3;
  $[4] !== t1 || $[5] !== t2 ? (t3 = new t1(t2, "i"), $[4] = t1, $[5] = t2, $[6] = t3) : t3 = $[6];
  const routerBasePathRegex = t3;
  let t4;
  $[7] !== routerBasePath || $[8] !== routerBasePathRegex ? (t4 = (pathname) => routerBasePath === "/" ? !0 : routerBasePathRegex.test(pathname), $[7] = routerBasePath, $[8] = routerBasePathRegex, $[9] = t4) : t4 = $[9];
  const shouldHandle = t4;
  let t5, t6;
  $[10] !== history2 ? (t5 = (onStoreChange) => history2.listen(onStoreChange), t6 = () => `${history2.location.pathname}${history2.location.search || ""}`, $[10] = history2, $[11] = t5, $[12] = t6) : (t5 = $[11], t6 = $[12]);
  let t7;
  $[13] !== router || $[14] !== shouldHandle ? (t7 = (pathname_0) => typeof pathname_0 == "string" && shouldHandle(pathname_0) ? decodeUrlState(router, pathname_0) : null, $[13] = router, $[14] = shouldHandle, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t5 || $[17] !== t6 || $[18] !== t7 ? (t8 = {
    subscribe: t5,
    getSnapshot: t6,
    getServerSnapshot: _temp2$2,
    selector: t7
  }, $[16] = t5, $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19];
  const store = t8, event = useSyncExternalStoreWithSelector(store.subscribe, store.getSnapshot, store.getServerSnapshot, store.selector, isEqual$1), prevEvent = useRef(event);
  let t9;
  $[20] !== event || $[21] !== history2 || $[22] !== router || $[23] !== tools ? (t9 = () => {
    if (event?.type === "state" && !event.state?.intent) {
      const defaultState = resolveDefaultState(tools, event.state);
      defaultState && defaultState !== event.state && history2.replace(router.encode(defaultState));
    }
  }, $[20] = event, $[21] = history2, $[22] = router, $[23] = tools, $[24] = t9) : t9 = $[24];
  const t10 = event?.state, t11 = event?.type;
  let t12;
  $[25] !== history2 || $[26] !== router || $[27] !== t10 || $[28] !== t11 || $[29] !== tools ? (t12 = [t10, t11, history2, router, tools], $[25] = history2, $[26] = router, $[27] = t10, $[28] = t11, $[29] = tools, $[30] = t12) : t12 = $[30], useEffect(t9, t12);
  let t13, t14;
  $[31] !== event || $[32] !== history2 || $[33] !== router || $[34] !== tools ? (t13 = () => {
    const resolvedIntent = maybeResolveIntent(event, router, tools, prevEvent);
    resolvedIntent ? history2.replace(resolvedIntent) : prevEvent.current = event;
  }, t14 = [event, history2, router, tools], $[31] = event, $[32] = history2, $[33] = router, $[34] = tools, $[35] = t13, $[36] = t14) : (t13 = $[35], t14 = $[36]), useEffect(t13, t14);
  let t15;
  $[37] !== history2 || $[38] !== router || $[39] !== store || $[40] !== tools ? (t15 = (t162) => {
    const {
      path,
      replace
    } = t162, predictedEvent = store.selector(path), resolvedIntent_0 = maybeResolveIntent(predictedEvent, router, tools, prevEvent), resolvedPath = typeof resolvedIntent_0 == "string" ? resolvedIntent_0 : path;
    replace ? history2.replace(resolvedPath) : history2.push(resolvedPath);
  }, $[37] = history2, $[38] = router, $[39] = store, $[40] = tools, $[41] = t15) : t15 = $[41];
  const handleNavigate = t15, t16 = event?.state ?? null;
  let t17;
  return $[42] !== handleNavigate || $[43] !== t16 ? (t17 = [t16, handleNavigate], $[42] = handleNavigate, $[43] = t16, $[44] = t17) : t17 = $[44], t17;
}
function _temp2$2() {
  return null;
}
function maybeResolveIntent(event, router, tools, prevEvent) {
  if (event?.type === "state" && event.state?.intent) {
    const redirectState = resolveIntentState(tools, prevEvent.current?.type === "state" ? prevEvent.current.state : {}, event.state);
    if (redirectState?.type === "state")
      return router.encode(redirectState.state);
  }
  return null;
}
function useWorkspaceLoader(activeWorkspace) {
  const $ = c(3), [error, handleError] = useState(null);
  if (error)
    throw error;
  const [workspace, setWorkspace] = useState(null);
  let t0, t1;
  return $[0] !== activeWorkspace ? (t0 = () => {
    const subscription = combineLatest(activeWorkspace.__internal.sources.map(_temp2$1)).pipe(map((results) => {
      const errors = results.filter(_temp3$1);
      if (errors.length)
        throw new ConfigResolutionError({
          name: activeWorkspace.name,
          causes: errors,
          type: "workspace"
        });
      return results;
    }), map((t2) => {
      const [rootSource, ...restOfSources] = t2, {
        releases: _releases,
        ...workspaceMetadata
      } = activeWorkspace;
      return {
        ...workspaceMetadata,
        ...rootSource,
        unstable_sources: [rootSource, ...restOfSources],
        type: "workspace"
      };
    })).subscribe({
      next: setWorkspace,
      error: handleError
    });
    return () => subscription.unsubscribe();
  }, t1 = [activeWorkspace], $[0] = activeWorkspace, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1), workspace;
}
function _temp3$1(result) {
  return result instanceof ConfigResolutionError;
}
function _temp2$1(t0) {
  const {
    source
  } = t0;
  return source.pipe(catchError(_temp$5));
}
function _temp$5(err) {
  if (err instanceof ConfigResolutionError)
    return of(err);
  throw err;
}
function WorkspaceLoader(t0) {
  const $ = c(12), {
    children,
    LoadingComponent
  } = t0, {
    activeWorkspace
  } = useActiveWorkspace(), workspace = useWorkspaceLoader(activeWorkspace);
  if (!workspace) {
    let t12;
    return $[0] !== LoadingComponent ? (t12 = /* @__PURE__ */ jsx(LoadingComponent, {}), $[0] = LoadingComponent, $[1] = t12) : t12 = $[1], t12;
  }
  let t1;
  $[2] !== LoadingComponent || $[3] !== children || $[4] !== workspace ? (t1 = /* @__PURE__ */ jsx(WorkspaceRouterProvider, { LoadingComponent, workspace, children }), $[2] = LoadingComponent, $[3] = children, $[4] = workspace, $[5] = t1) : t1 = $[5];
  let t2;
  $[6] !== t1 || $[7] !== workspace.unstable_sources[0] ? (t2 = /* @__PURE__ */ jsx(SourceProvider, { source: workspace.unstable_sources[0], children: t1 }), $[6] = t1, $[7] = workspace.unstable_sources[0], $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== t2 || $[10] !== workspace ? (t3 = /* @__PURE__ */ jsx(WorkspaceProvider, { workspace, children: t2 }), $[9] = t2, $[10] = workspace, $[11] = t3) : t3 = $[11], t3;
}
function WorkspaceLoaderBoundary(t0) {
  const $ = c(5);
  let props2;
  if ($[0] !== t0) {
    const {
      ConfigErrorsComponent,
      ...t12
    } = t0;
    props2 = t12, $[0] = t0, $[1] = props2;
  } else
    props2 = $[1];
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    error: null
  }, $[2] = t1) : t1 = $[2];
  const [t2, setError] = useState(t1), {
    error
  } = t2;
  if (error)
    throw error;
  let t3;
  return $[3] !== props2 ? (t3 = /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: setError, children: /* @__PURE__ */ jsx(WorkspaceLoader, { ...props2 }) }), $[3] = props2, $[4] = t3) : t3 = $[4], t3;
}
function StudioProvider(t0) {
  const $ = c(25), {
    children,
    config,
    basePath,
    onSchemeChange,
    scheme,
    unstable_history: history2,
    unstable_noAuthBoundary: noAuthBoundary
  } = t0;
  errorReporter.initialize(), ensureRefractorLanguages();
  const primaryProjectId = (Array.isArray(config) ? config[0] : config)?.projectId;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(LiveManifestRegisterProvider, {}), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(MaybeEnableErrorReporting, { errorReporter }), $[1] = t2) : t2 = $[1];
  let t3;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(ComlinkRouteHandler, {}), $[2] = t3) : t3 = $[2];
  let t4;
  $[3] !== children ? (t4 = /* @__PURE__ */ jsx(UserApplicationCacheProvider, { children: /* @__PURE__ */ jsxs(LiveUserApplicationProvider, { children: [
    t1,
    /* @__PURE__ */ jsx(WorkspaceLoaderBoundary, { LoadingComponent: LoadingBlock, ConfigErrorsComponent: ConfigErrorsScreen, children: /* @__PURE__ */ jsx(LocaleProvider, { children: /* @__PURE__ */ jsxs(PackageVersionStatusProvider, { children: [
      t2,
      /* @__PURE__ */ jsx(ResourceCacheProvider, { children: /* @__PURE__ */ jsx(StudioTelemetryProvider, { children: /* @__PURE__ */ jsxs(AppIdCacheProvider, { children: [
        t3,
        /* @__PURE__ */ jsx(StudioAnnouncementsProvider, { children: /* @__PURE__ */ jsx(GlobalPerspectiveProvider, { children: /* @__PURE__ */ jsx(DocumentLimitUpsellProvider, { children: /* @__PURE__ */ jsx(AssetLimitUpsellProvider, { children }) }) }) })
      ] }) }) })
    ] }) }) })
  ] }) }), $[3] = children, $[4] = t4) : t4 = $[4];
  const _children = t4;
  let t5;
  $[5] !== _children || $[6] !== noAuthBoundary ? (t5 = /* @__PURE__ */ jsx(StudioThemeProvider, { children: /* @__PURE__ */ jsx(UserColorManagerProvider, { children: noAuthBoundary ? _children : /* @__PURE__ */ jsx(AuthBoundary, { LoadingComponent: LoadingBlock, AuthenticateComponent: AuthenticateScreen, NotAuthenticatedComponent: NotAuthenticatedScreen, children: _children }) }) }), $[5] = _children, $[6] = noAuthBoundary, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== history2 || $[9] !== t5 ? (t6 = /* @__PURE__ */ jsx(ActiveWorkspaceMatcher, { unstable_history: history2, NotFoundComponent: NotFoundScreen, LoadingComponent: LoadingBlock, children: t5 }), $[8] = history2, $[9] = t5, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== basePath || $[12] !== config || $[13] !== t6 ? (t7 = /* @__PURE__ */ jsx(WorkspacesProvider, { config, basePath, LoadingComponent: LoadingBlock, children: t6 }), $[11] = basePath, $[12] = config, $[13] = t6, $[14] = t7) : t7 = $[14];
  let t8;
  $[15] !== primaryProjectId || $[16] !== t7 ? (t8 = /* @__PURE__ */ jsx(StudioRootErrorHandler, { primaryProjectId, children: t7 }), $[15] = primaryProjectId, $[16] = t7, $[17] = t8) : t8 = $[17];
  let t9;
  $[18] !== primaryProjectId || $[19] !== t8 ? (t9 = /* @__PURE__ */ jsx(ToastProvider, { paddingY: 7, zOffset: Z_OFFSET$1.toast, children: /* @__PURE__ */ jsx(StudioErrorBoundary, { primaryProjectId, children: t8 }) }), $[18] = primaryProjectId, $[19] = t8, $[20] = t9) : t9 = $[20];
  let t10;
  return $[21] !== onSchemeChange || $[22] !== scheme || $[23] !== t9 ? (t10 = /* @__PURE__ */ jsx(DeferredTelemetryProvider, { children: /* @__PURE__ */ jsx(ColorSchemeProvider, { onSchemeChange, scheme, children: t9 }) }), $[21] = onSchemeChange, $[22] = scheme, $[23] = t9, $[24] = t10) : t10 = $[24], t10;
}
let _refractorRegistered = !1;
function ensureRefractorLanguages() {
  _refractorRegistered || (_refractorRegistered = !0, import("react-refractor").then(({
    registerLanguage
  }) => Promise.all([import("refractor/bash"), import("refractor/javascript"), import("refractor/json"), import("refractor/jsx"), import("refractor/typescript")]).then((languages) => languages.forEach((lang) => registerLanguage(lang.default))).catch((error) => console.warn("Failed to load syntax highlighting languages for code blocks", error))));
}
function Studio(props2) {
  const $ = c(11), {
    basePath,
    config,
    onSchemeChange,
    scheme,
    unstable_globalStyles: globalStyles,
    unstable_history,
    unstable_noAuthBoundary
  } = props2;
  let t0;
  $[0] !== globalStyles ? (t0 = globalStyles && /* @__PURE__ */ jsx(GlobalStyle, {}), $[0] = globalStyles, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(StudioLayout, {}), $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== basePath || $[4] !== config || $[5] !== onSchemeChange || $[6] !== scheme || $[7] !== t0 || $[8] !== unstable_history || $[9] !== unstable_noAuthBoundary ? (t2 = /* @__PURE__ */ jsxs(StudioProvider, { basePath, config, onSchemeChange, scheme, unstable_history, unstable_noAuthBoundary, children: [
    t0,
    t1
  ] }), $[3] = basePath, $[4] = config, $[5] = onSchemeChange, $[6] = scheme, $[7] = t0, $[8] = unstable_history, $[9] = unstable_noAuthBoundary, $[10] = t2) : t2 = $[10], t2;
}
function renderStudio(rootElement, config, options = !1) {
  if (!rootElement)
    throw new Error("Missing root element to mount application into");
  const opts = typeof options == "boolean" ? {
    reactStrictMode: options
  } : options, {
    reactStrictMode = !1,
    basePath
  } = opts, root = createRoot(rootElement);
  return root.render(reactStrictMode ? /* @__PURE__ */ jsx(StrictMode, { children: /* @__PURE__ */ jsx(Studio, { config, basePath, unstable_globalStyles: !0 }) }) : /* @__PURE__ */ jsx(Studio, { config, basePath, unstable_globalStyles: !0 })), () => root.unmount();
}
function useClient(clientOptions2) {
  const $ = c(5), source = useSource();
  if (!clientOptions2) {
    console.warn('Calling `useClient()` without specifying an API version is deprecated and will stop working in the next major version - please specify a date, e.g. `useClient({apiVersion: "2025-02-10"})`.');
    let t02;
    return $[0] !== source ? (t02 = source.getClient({
      apiVersion: "v2025-02-07"
    }), $[0] = source, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== clientOptions2 || $[3] !== source ? (t0 = source.getClient(clientOptions2), $[2] = clientOptions2, $[3] = source, $[4] = t0) : t0 = $[4], t0;
}
function useConditionalToast(params) {
  const $ = c(8), toast = useToast(), [enabledAt, setEnabledAt] = useState();
  let t0, t1;
  $[0] !== params.enabled ? (t0 = () => {
    startTransition(() => setEnabledAt((current) => params.enabled ? current || /* @__PURE__ */ new Date() : void 0));
  }, t1 = [params.enabled], $[0] = params.enabled, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  const now = useCurrentTime(1e3, !!params.enabled), enabled = enabledAt && params.enabled && now.getTime() - enabledAt.getTime() > (params?.delay ?? 0);
  let t2, t3;
  $[3] !== enabled || $[4] !== params || $[5] !== toast ? (t2 = () => {
    if (enabled)
      return toast.push({
        ...params,
        duration: 1 / 0
      }), () => {
        toast.push({
          ...params,
          duration: 0.01
        });
      };
  }, t3 = [params, toast, enabled], $[3] = enabled, $[4] = params, $[5] = toast, $[6] = t2, $[7] = t3) : (t2 = $[6], t3 = $[7]), useEffect(t2, t3);
}
function useCurrentTime(updateIntervalMs, enabled) {
  const $ = c(4), [currentTime, setCurrentTime] = useState(_temp$4);
  let t0, t1;
  return $[0] !== enabled || $[1] !== updateIntervalMs ? (t0 = () => {
    if (!enabled)
      return;
    const intervalId = setInterval(() => {
      startTransition(() => setCurrentTime(/* @__PURE__ */ new Date()));
    }, updateIntervalMs);
    return () => clearInterval(intervalId);
  }, t1 = [updateIntervalMs, enabled], $[0] = enabled, $[1] = updateIntervalMs, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1), currentTime;
}
function _temp$4() {
  return /* @__PURE__ */ new Date();
}
function useDocumentOperationEvent(publishedDocId, docTypeName) {
  const $ = c(4), documentStore = useDocumentStore();
  let t0;
  return $[0] !== docTypeName || $[1] !== documentStore.pair || $[2] !== publishedDocId ? (t0 = documentStore.pair.operationEvents(publishedDocId, docTypeName), $[0] = docTypeName, $[1] = documentStore.pair, $[2] = publishedDocId, $[3] = t0) : t0 = $[3], useObservable(t0);
}
const PERIODS = ["days", "hours", "minutes", "seconds", "milliseconds"];
function useFormattedDuration(durationMs, options) {
  const $ = c(36);
  let t0;
  $[0] !== options ? (t0 = options || {}, $[0] = options, $[1] = t0) : t0 = $[1];
  const {
    style: t1,
    resolution: t2
  } = t0, style = t1 === void 0 ? "short" : t1, resolution = t2 === void 0 ? "seconds" : t2, unitDisplay = style, locale = useCurrentLocale().id;
  let t3;
  $[2] !== style ? (t3 = {
    type: "unit",
    style
  }, $[2] = style, $[3] = t3) : t3 = $[3];
  const listFormat = useListFormat(t3), isNegative = durationMs < 0;
  let formatted, t4;
  if ($[4] !== durationMs || $[5] !== isNegative || $[6] !== listFormat || $[7] !== locale || $[8] !== resolution || $[9] !== unitDisplay) {
    const duration = parseMilliseconds(Math.abs(durationMs));
    let t52;
    $[12] !== locale || $[13] !== unitDisplay ? (t52 = intlCache.numberFormat(locale, {
      style: "unit",
      unit: "day",
      unitDisplay
    }), $[12] = locale, $[13] = unitDisplay, $[14] = t52) : t52 = $[14];
    let t6;
    $[15] !== locale || $[16] !== unitDisplay ? (t6 = intlCache.numberFormat(locale, {
      style: "unit",
      unit: "hour",
      unitDisplay
    }), $[15] = locale, $[16] = unitDisplay, $[17] = t6) : t6 = $[17];
    let t7;
    $[18] !== locale || $[19] !== unitDisplay ? (t7 = intlCache.numberFormat(locale, {
      style: "unit",
      unit: "minute",
      unitDisplay
    }), $[18] = locale, $[19] = unitDisplay, $[20] = t7) : t7 = $[20];
    let t8;
    $[21] !== locale || $[22] !== unitDisplay ? (t8 = intlCache.numberFormat(locale, {
      style: "unit",
      unit: "second",
      unitDisplay
    }), $[21] = locale, $[22] = unitDisplay, $[23] = t8) : t8 = $[23];
    let t9;
    $[24] !== locale || $[25] !== unitDisplay ? (t9 = intlCache.numberFormat(locale, {
      style: "unit",
      unit: "millisecond",
      unitDisplay
    }), $[24] = locale, $[25] = unitDisplay, $[26] = t9) : t9 = $[26];
    let t10;
    $[27] !== t52 || $[28] !== t6 || $[29] !== t7 || $[30] !== t8 || $[31] !== t9 ? (t10 = {
      days: t52,
      hours: t6,
      minutes: t7,
      seconds: t8,
      milliseconds: t9
    }, $[27] = t52, $[28] = t6, $[29] = t7, $[30] = t8, $[31] = t9, $[32] = t10) : t10 = $[32];
    const formatters = t10, parts = [];
    for (const period of PERIODS) {
      const value = duration[period];
      if (!value || resolution === "seconds" && period === "milliseconds")
        continue;
      const prefix = isNegative && parts.length === 0 ? "-" : "";
      parts.push(`${prefix}${formatters[period].format(value)}`);
    }
    formatted = parts.length === 0 ? formatters[resolution].format(0) : listFormat.format(parts), t4 = durationToISO8601(duration, isNegative), $[4] = durationMs, $[5] = isNegative, $[6] = listFormat, $[7] = locale, $[8] = resolution, $[9] = unitDisplay, $[10] = formatted, $[11] = t4;
  } else
    formatted = $[10], t4 = $[11];
  const iso8601 = t4;
  let t5;
  return $[33] !== formatted || $[34] !== iso8601 ? (t5 = {
    formatted,
    iso8601
  }, $[33] = formatted, $[34] = iso8601, $[35] = t5) : t5 = $[35], t5;
}
function parseMilliseconds(milliseconds) {
  return {
    days: Math.trunc(milliseconds / 864e5),
    hours: Math.trunc(milliseconds / 36e5) % 24,
    minutes: Math.trunc(milliseconds / 6e4) % 60,
    seconds: Math.trunc(milliseconds / 1e3) % 60,
    milliseconds: Math.trunc(milliseconds) % 1e3
  };
}
function durationToISO8601(dur, isNegative) {
  const date = dur.days ? `${dur.days}D` : "";
  let time = "";
  if (dur.hours && (time += `${dur.hours}H`), dur.minutes && (time += `${dur.minutes}M`), dur.milliseconds ? time += `${((dur.seconds * 1e3 + dur.milliseconds) / 1e3).toFixed(3)}S` : dur.seconds && (time += `${dur.seconds}S`), !date && !time)
    return "PT0S";
  const duration = `P${(time ? [date, time] : [date]).join("T")}`;
  return isNegative ? `-${duration}` : duration;
}
const isCopyHotKey = isHotkey("mod+c"), isPasteHotKey = isHotkey("mod+v");
function useGlobalCopyPasteElementHandler(t0) {
  const $ = c(11), {
    value,
    element,
    focusPath
  } = t0, {
    onCopy,
    onPaste
  } = useCopyPaste();
  let t1;
  $[0] !== focusPath || $[1] !== onCopy || $[2] !== onPaste || $[3] !== value ? (t1 = (event) => {
    const targetElement = event.target;
    if (isCopyHotKey(event)) {
      if (isNativeEditableElement(targetElement) || hasSelection() || isEmptyFocusPath(focusPath))
        return;
      event.preventDefault(), event.stopPropagation(), onCopy(focusPath, value, {
        context: {
          source: "keyboardShortcut"
        }
      });
    }
    if (isPasteHotKey(event)) {
      if (isNativeEditableElement(targetElement) || isEmptyFocusPath(focusPath) || isFileTargetElement(targetElement))
        return;
      event.stopPropagation(), event.preventDefault(), onPaste(focusPath, value, {
        context: {
          source: "keyboardShortcut"
        }
      });
    }
  }, $[0] = focusPath, $[1] = onCopy, $[2] = onPaste, $[3] = value, $[4] = t1) : t1 = $[4];
  const handleKeydown = useEffectEvent(t1);
  let t2;
  $[5] !== element || $[6] !== handleKeydown ? (t2 = () => (element?.addEventListener("keydown", handleKeydown), () => {
    element?.removeEventListener("keydown", handleKeydown);
  }), $[5] = element, $[6] = handleKeydown, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== element || $[9] !== onPaste ? (t3 = [element, onPaste], $[8] = element, $[9] = onPaste, $[10] = t3) : t3 = $[10], useEffect(t2, t3);
}
const FAVORITES_FETCH_TIMEOUT = 3e3;
function useManageFavorite(t0) {
  const $ = c(18), {
    documentId,
    documentType,
    projectId,
    dataset,
    resourceId: paramResourceId,
    resourceType,
    schemaName
  } = t0, {
    node
  } = useComlinkStore();
  if (resourceType === "studio" && (!projectId || !dataset))
    throw new Error("projectId and dataset are required for studio resources");
  const resourceId = resourceType === "studio" && !paramResourceId ? `${projectId}.${dataset}` : paramResourceId;
  if (!resourceId)
    throw new Error("resourceId is required for media-library and canvas resources");
  let t1;
  $[0] !== documentId || $[1] !== documentType || $[2] !== resourceId || $[3] !== resourceType || $[4] !== schemaName ? (t1 = {
    documentId,
    documentType,
    resourceId,
    resourceType,
    schemaName
  }, $[0] = documentId, $[1] = documentType, $[2] = resourceId, $[3] = resourceType, $[4] = schemaName, $[5] = t1) : t1 = $[5];
  const context = t1;
  let t2;
  $[6] !== context || $[7] !== node ? (t2 = optimisticState({
    node,
    context
  }), $[6] = context, $[7] = node, $[8] = t2) : t2 = $[8];
  const stateController = t2, state = useObservable(stateController.state);
  let t3;
  $[9] !== stateController ? (t3 = () => stateController.setState(!0), $[9] = stateController, $[10] = t3) : t3 = $[10];
  const t4 = t3;
  let t5;
  $[11] !== stateController ? (t5 = () => stateController.setState(!1), $[11] = stateController, $[12] = t5) : t5 = $[12];
  const t6 = t5, t7 = state?.value, t8 = state?.isReady ?? !1;
  let t9;
  return $[13] !== t4 || $[14] !== t6 || $[15] !== t7 || $[16] !== t8 ? (t9 = {
    favorite: t4,
    unfavorite: t6,
    isFavorited: t7,
    isReady: t8
  }, $[13] = t4, $[14] = t6, $[15] = t7, $[16] = t8, $[17] = t9) : t9 = $[17], t9;
}
const INITIAL_STATE$1 = {
  value: void 0,
  isReady: !1
};
function optimisticState({
  node,
  context
}) {
  const dispatchSubject = new Subject(), setState = (value) => dispatchSubject.next(value);
  let previousState;
  return {
    state: iif(() => typeof node > "u", of(INITIAL_STATE$1), merge(dispatchSubject.pipe(distinctUntilChanged$1(), filter$1((value) => typeof value == "boolean"), connect((shared) => merge(shared.pipe(map$1((value) => ({
      type: "SET",
      payload: value
    }))), shared.pipe(debounceTime$1(750), filter$1((value) => typeof previousState > "u" ? !1 : value !== previousState), writeRemoteState({
      node,
      context
    }), tap$1(({
      success,
      isFavorited
    }) => {
      success && (previousState = isFavorited);
    }), switchMap$1(() => EMPTY$5))))), readRemoteState({
      node,
      context
    }).pipe(map$1((response) => ({
      type: "END_READ",
      payload: response
    })), tap$1(({
      payload
    }) => {
      previousState = payload.isFavorited;
    }), startWith$1({
      type: "BEGIN_READ"
    }))).pipe(reducer())),
    setState
  };
}
function reducer() {
  return scan$1((previousState, action) => {
    switch (action.type) {
      case "BEGIN_READ":
        return {
          ...previousState,
          isReady: !1
        };
      case "END_READ":
        return {
          ...previousState,
          value: action.payload.isFavorited,
          isReady: !0
        };
      case "SET":
        return {
          ...previousState,
          value: action.payload
        };
      default:
        return previousState;
    }
  }, INITIAL_STATE$1);
}
function readRemoteState({
  node,
  context
}) {
  if (typeof context.resourceId > "u")
    return EMPTY$5;
  if (typeof node > "u")
    return EMPTY$5;
  const payload = {
    document: {
      id: context.documentId,
      type: context.documentType,
      resource: {
        id: context.resourceId,
        type: context.resourceType,
        schemaName: context.schemaName
      }
    }
  };
  return from(node.fetch("dashboard/v1/events/favorite/query", payload)).pipe(timeout$1({
    first: FAVORITES_FETCH_TIMEOUT,
    with: () => throwError(() => new Error("Favorites service connection timeout"))
  }), map$1((response) => ({
    isFavorited: response.isFavorited
  })), catchError$1((err) => (console.error("Favorites service connection error", err), of({
    isFavorited: !1
  }))));
}
function writeRemoteState({
  node,
  context
}) {
  return pipe(mergeMap$1((value) => {
    if (typeof context.resourceId > "u")
      return EMPTY$5;
    if (typeof node > "u")
      return EMPTY$5;
    const payload = {
      eventType: value ? "added" : "removed",
      document: {
        id: context.documentId,
        type: context.documentType,
        resource: {
          id: context.resourceId,
          type: context.resourceType,
          ...context.schemaName ? {
            schemaName: context.schemaName
          } : {}
        }
      }
    };
    return from(node.fetch("dashboard/v1/events/favorite/mutate", payload)).pipe(catchError$1((error) => (console.error("Favorites service write error", error), NEVER)), map$1((response) => ({
      success: typeof response == "object" && response !== null && "success" in response && !!response.success,
      isFavorited: value
    })));
  }, 1));
}
function useNumberFormat(t0) {
  const $ = c(5);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1, currentLocale = useCurrentLocale().id;
  let t2;
  return $[2] !== currentLocale || $[3] !== options ? (t2 = intlCache.numberFormat(currentLocale, options), $[2] = currentLocale, $[3] = options, $[4] = t2) : t2 = $[4], t2;
}
const useReconnectingToast = (isReconnecting) => {
  const $ = c(5), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("common.reconnecting.toast.title"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== isReconnecting || $[3] !== t0 ? (t1 = {
    enabled: isReconnecting,
    delay: 2e3,
    id: "sanity/reconnecting",
    status: "warning",
    title: t0
  }, $[2] = isReconnecting, $[3] = t0, $[4] = t1) : t1 = $[4], useConditionalToast(t1);
};
function useReviewChanges() {
  const $ = c(2), context = useContext(ReviewChangesContext);
  let t0;
  return $[0] !== context ? (t0 = {
    ...context,
    changesOpen: context.isReviewChangesOpen
  }, $[0] = context, $[1] = t0) : t0 = $[1], t0;
}
const SYNCING = {
  isSyncing: !0
}, NOT_SYNCING = {
  isSyncing: !1
};
function useSyncState(publishedDocId, documentType, version2) {
  const $ = c(5), documentStore = useDocumentStore();
  let t0;
  return $[0] !== documentStore.pair || $[1] !== documentType || $[2] !== publishedDocId || $[3] !== version2 ? (t0 = documentStore.pair.consistencyStatus(publishedDocId, documentType, version2).pipe(map(_temp$3)), $[0] = documentStore.pair, $[1] = documentType, $[2] = publishedDocId, $[3] = version2, $[4] = t0) : t0 = $[4], useObservable(t0, NOT_SYNCING);
}
function _temp$3(isConsistent) {
  return isConsistent ? NOT_SYNCING : SYNCING;
}
function useTemplates() {
  return useSource().templates;
}
function useTimeAgo(time, t0) {
  const $ = c(5);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1;
  let t2;
  return $[2] !== options.agoSuffix || $[3] !== options.minimal ? (t2 = {
    minimal: options.minimal,
    useTemporalPhrase: options.agoSuffix
  }, $[2] = options.agoSuffix, $[3] = options.minimal, $[4] = t2) : t2 = $[4], useRelativeTime(time, t2);
}
function useTools() {
  return useSource().tools;
}
const CACHE_MAX_AGE = 300 * 1e3, CACHE_MAX_SIZE = 50, cache = new QuickLRU({
  maxAge: CACHE_MAX_AGE,
  maxSize: CACHE_MAX_SIZE
});
function getCacheKey(client) {
  const {
    projectId,
    dataset
  } = client.config();
  return `${projectId}-${dataset}`;
}
function getSystemGroups$(client) {
  const key = getCacheKey(client), cached$ = cache.get(key);
  if (cached$)
    return cached$;
  const result$ = defer(() => client.fetch('*[_type == "system.group"]{members, grants}')).pipe(tap$1({
    error: () => {
      cache.delete(key);
    }
  }), shareReplay$1(1));
  return cache.set(key, result$), result$;
}
const INITIAL_STATE = {
  data: [],
  error: null,
  loading: !0
};
function useUserListWithPermissions(opts) {
  const $ = c(21), {
    documentValue,
    permission
  } = opts, projectStore = useProjectStore(), userStore = useUserStore(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), [state, setState] = useState(INITIAL_STATE);
  let t0;
  if ($[0] !== projectStore || $[1] !== userStore) {
    const members$ = projectStore.get().pipe(map$1(_temp2)).pipe(shareReplay$1(1));
    let t12;
    $[3] !== userStore ? (t12 = async (members) => {
      const ids = members.map(_temp3);
      return await userStore.getUsers(ids);
    }, $[3] = userStore, $[4] = t12) : t12 = $[4], t0 = members$.pipe(switchMap$1(t12), map$1(_temp5)), $[0] = projectStore, $[1] = userStore, $[2] = t0;
  } else
    t0 = $[2];
  const _users$ = t0;
  let t1;
  $[5] !== client.observable ? (t1 = getSystemGroups$(client.observable), $[5] = client.observable, $[6] = t1) : t1 = $[6];
  const _systemGroup$ = t1;
  let t2;
  $[7] !== _systemGroup$ || $[8] !== _users$ ? (t2 = [_users$, _systemGroup$], $[7] = _systemGroup$, $[8] = _users$, $[9] = t2) : t2 = $[9];
  const [users$, systemGroup$] = t2;
  let t3;
  if ($[10] !== documentValue || $[11] !== permission || $[12] !== systemGroup$ || $[13] !== users$) {
    let t42;
    $[15] !== documentValue || $[16] !== permission ? (t42 = async (t52) => {
      const [users_0, groups] = t52, grantPromises = users_0?.map(async (user_0) => {
        const flattenedGrants = [...groups.map((group2) => group2.members?.includes(user_0.id) ? group2.grants : [])].flat(), {
          granted
        } = await grantsPermissionOn(user_0.id, flattenedGrants, permission, documentValue);
        return {
          ...user_0,
          granted
        };
      });
      return await Promise.all(grantPromises || []);
    }, $[15] = documentValue, $[16] = permission, $[17] = t42) : t42 = $[17], t3 = forkJoin([users$, systemGroup$]).pipe(mergeMap$1(t42)).pipe(map$1(_temp6)), $[10] = documentValue, $[11] = permission, $[12] = systemGroup$, $[13] = users$, $[14] = t3;
  } else
    t3 = $[14];
  const list$ = t3;
  let t4, t5;
  return $[18] !== list$ ? (t4 = () => {
    const initial$ = of(INITIAL_STATE), sub2 = concat(initial$, list$).subscribe({
      next: setState,
      error: (error) => {
        setState({
          data: [],
          error,
          loading: !1
        });
      }
    });
    return () => {
      sub2.unsubscribe();
    };
  }, t5 = [list$], $[18] = list$, $[19] = t4, $[20] = t5) : (t4 = $[19], t5 = $[20]), useEffect(t4, t5), state;
}
function _temp6(res_1) {
  return {
    error: null,
    loading: !1,
    data: sortBy(res_1, "displayName")
  };
}
function _temp5(res_0) {
  return res_0.map(_temp4);
}
function _temp4(user) {
  return {
    displayName: user.displayName,
    id: user.id,
    granted: !1
  };
}
function _temp3(t0) {
  const {
    id: id2
  } = t0;
  return id2;
}
function _temp2(res) {
  return res.members?.filter(_temp$2);
}
function _temp$2(m) {
  return !m.isRobot;
}
function DocumentStatus(t0) {
  const $ = c(19), {
    draft,
    published,
    versions,
    singleLine
  } = t0, {
    data: releases2
  } = useActiveReleases();
  let t1;
  $[0] !== versions ? (t1 = Object.entries(versions ?? {}), $[0] = versions, $[1] = t1) : t1 = $[1];
  const versionsList = t1, {
    t
  } = useTranslation(), {
    document: t2
  } = useWorkspace(), {
    drafts: t3
  } = t2, {
    enabled: isDraftModelEnabled
  } = t3, t4 = singleLine ? "center" : "flex-start", t5 = singleLine ? "row" : "column";
  let t6;
  $[2] !== published || $[3] !== t ? (t6 = published && /* @__PURE__ */ jsx(VersionStatus, { title: t("release.chip.published"), mode: "published", timestamp: published._updatedAt, release: PUBLISHED$1 }), $[2] = published, $[3] = t, $[4] = t6) : t6 = $[4];
  let t7;
  $[5] !== draft || $[6] !== isDraftModelEnabled || $[7] !== t ? (t7 = isDraftModelEnabled && draft && /* @__PURE__ */ jsx(VersionStatus, { title: t("release.chip.draft"), mode: "draft", timestamp: draft._updatedAt, release: LATEST }), $[5] = draft, $[6] = isDraftModelEnabled, $[7] = t, $[8] = t7) : t7 = $[8];
  let t8;
  $[9] !== releases2 || $[10] !== t || $[11] !== versionsList ? (t8 = versionsList.map((t92) => {
    const [versionName, snapshot2] = t92;
    if (!snapshot2)
      return null;
    const release = releases2?.find((r) => getReleaseIdFromReleaseDocumentId(r._id) === versionName);
    return release ? /* @__PURE__ */ jsx(VersionStatus, { mode: snapshot2._updatedAt === snapshot2._createdAt ? "created" : "edited", title: release?.metadata.title || t("release.placeholder-untitled-release"), timestamp: snapshot2?._updatedAt, release }, versionName) : null;
  }), $[9] = releases2, $[10] = t, $[11] = versionsList, $[12] = t8) : t8 = $[12];
  let t9;
  return $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { align: t4, direction: t5, gap: 3, wrap: "nowrap", children: [
    t6,
    t7,
    t8
  ] }), $[13] = t4, $[14] = t5, $[15] = t6, $[16] = t7, $[17] = t8, $[18] = t9) : t9 = $[18], t9;
}
const labels = {
  draft: "document-status.edited",
  published: "document-status.published",
  edited: "document-status.edited",
  created: "document-status.created"
}, VersionStatus = (t0) => {
  const $ = c(16), {
    title,
    timestamp,
    mode,
    release
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    minimal: !0,
    useTemporalPhrase: !0
  }, $[0] = t1) : t1 = $[0];
  const relativeTime = useRelativeTime(timestamp || "", t1);
  let t2;
  $[1] !== release ? (t2 = /* @__PURE__ */ jsx(ReleaseAvatar, { release, padding: 0 }), $[1] = release, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    color: "var(--card-muted-fg-color)"
  }, $[3] = t3) : t3 = $[3];
  const t4 = labels[mode];
  let t5;
  $[4] !== relativeTime || $[5] !== t || $[6] !== t4 ? (t5 = t(t4, {
    date: relativeTime
  }), $[4] = relativeTime, $[5] = t, $[6] = t4, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== t5 ? (t6 = /* @__PURE__ */ jsx("span", { style: t3, children: t5 }), $[8] = t5, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== t6 || $[11] !== title ? (t7 = /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    title,
    " -",
    " ",
    t6
  ] }), $[10] = t6, $[11] = title, $[12] = t7) : t7 = $[12];
  let t8;
  return $[13] !== t2 || $[14] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t2,
    t7
  ] }), $[13] = t2, $[14] = t7, $[15] = t8) : t8 = $[15], t8;
}, strings = {
  "retry.title": "Retry",
  "copy-error-details.description": "These technical details may be useful for developers.",
  "copy-error-details.title": "Copy error details",
  "copy-error-details.toast.get-failed": "Failed to get error details",
  "copy-error-details.toast.copy-failed": "Failed to copy error details"
}, TOAST_ID = "copyErrorDetails";
function useCopyErrorDetails(error, eventId) {
  const $ = c(4), toast = useToast();
  let t0;
  return $[0] !== error || $[1] !== eventId || $[2] !== toast ? (t0 = () => {
    of({
      error,
      eventId
    }).pipe(serializeError(), catchError$1((serializeErrorError) => (console.error(serializeErrorError), toast.push({
      status: "error",
      title: strings["copy-error-details.toast.get-failed"],
      id: TOAST_ID
    }), EMPTY$5)), tap$1(_temp$1), catchError$1((copyErrorError) => (console.error(copyErrorError), toast.push({
      status: "error",
      title: strings["copy-error-details.toast.copy-failed"],
      id: TOAST_ID
    }), EMPTY$5))).subscribe();
  }, $[0] = error, $[1] = eventId, $[2] = toast, $[3] = t0) : t0 = $[3], t0;
}
function _temp$1(errorDetailsString) {
  return navigator.clipboard.writeText(errorDetailsString);
}
function serializeError() {
  return map$1(({
    error,
    eventId
  }) => {
    const errorInfo = isRecord$4(error) ? pick(error, Object.getOwnPropertyNames(error)) : void 0, sanitizedErrorInfo = sanitizeErrorInfo(errorInfo);
    return JSON.stringify({
      error: sanitizedErrorInfo,
      eventId
    }, null, 2);
  });
}
const SENSITIVE_HEADERS = ["authorization"];
function sanitizeErrorInfo(obj) {
  if (!isRecord$4(obj))
    return obj;
  const sanitized = {};
  for (const [key, value] of Object.entries(obj))
    if (key.toLowerCase() === "headers" && isRecord$4(value)) {
      const sanitizedHeaders = {};
      for (const [headerName, headerValue] of Object.entries(value))
        SENSITIVE_HEADERS.some((sensitiveHeader) => headerName.toLowerCase().includes(sensitiveHeader)) ? sanitizedHeaders[headerName] = "[hidden]" : sanitizedHeaders[headerName] = headerValue;
      sanitized[key] = sanitizedHeaders;
    } else isRecord$4(value) || Array.isArray(value) ? sanitized[key] = sanitizeErrorInfo(value) : sanitized[key] = value;
  return sanitized;
}
const ErrorActions = (t0) => {
  const $ = c(10), {
    error,
    eventId,
    onRetry: onRetry2,
    isRetrying,
    size
  } = t0, copyErrorDetails = useCopyErrorDetails(error, eventId);
  let t1;
  $[0] !== isRetrying || $[1] !== onRetry2 || $[2] !== size ? (t1 = onRetry2 && /* @__PURE__ */ jsx(Button, { disabled: isRetrying, loading: isRetrying, onClick: onRetry2, text: strings["retry.title"], tone: "primary", icon: SyncIcon, size }), $[0] = isRetrying, $[1] = onRetry2, $[2] = size, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== copyErrorDetails || $[5] !== size ? (t2 = /* @__PURE__ */ jsx(Tooltip, { content: strings["copy-error-details.description"], children: /* @__PURE__ */ jsx(Button, { onClick: copyErrorDetails, text: strings["copy-error-details.title"], tone: "default", mode: "ghost", icon: CopyIcon, size }) }), $[4] = copyErrorDetails, $[5] = size, $[6] = t2) : t2 = $[6];
  let t3;
  return $[7] !== t1 || $[8] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Inline, { space: 3, children: [
    t1,
    t2
  ] }), $[7] = t1, $[8] = t2, $[9] = t3) : t3 = $[9], t3;
};
function IntentButton(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = props2.disabled ? /* @__PURE__ */ jsx(Button, { ...props2, as: "a", role: "link", "aria-disabled": "true" }) : /* @__PURE__ */ jsx(Button, { ...props2, as: IntentLink }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
const StyledContainer = /* @__PURE__ */ styled(Container$3).withConfig({
  displayName: "StyledContainer",
  componentId: "sc-bnxr1x-0"
})((props2) => {
  const {
    theme
  } = props2, {
    container,
    media
  } = theme.sanity;
  return _responsive(media, props2.$width, (val) => ({
    // Make sure that the Container gets the correct width when used inside a popover.
    width: val === "auto" ? "none" : rem(container[val]),
    // Make sure that the Container width is constrained by available space.
    maxWidth: "100%"
  }));
}), PopoverContainer = forwardRef(function(props2, ref) {
  const $ = c(11);
  let restProps, t0;
  $[0] !== props2 ? ({
    width: t0,
    ...restProps
  } = props2, $[0] = props2, $[1] = restProps, $[2] = t0) : (restProps = $[1], t0 = $[2]);
  let t1;
  $[3] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[3] = t0, $[4] = t1) : t1 = $[4];
  const width = t1;
  let t2;
  $[5] !== width ? (t2 = Array.isArray(width) ? width : [width], $[5] = width, $[6] = t2) : t2 = $[6];
  let t3;
  return $[7] !== ref || $[8] !== restProps || $[9] !== t2 ? (t3 = /* @__PURE__ */ jsx(StyledContainer, { ...restProps, "data-ui": "PopoverContainer", $width: t2, ref }), $[7] = ref, $[8] = restProps, $[9] = t2, $[10] = t3) : t3 = $[10], t3;
}), StyledPopover = /* @__PURE__ */ styled(Popover).withConfig({
  displayName: "StyledPopover",
  componentId: "sc-qlxjvl-0"
})(() => css`
    /* Make the popover scrollable if it overflows the viewport */
    [data-ui='Popover__wrapper'] {
      overflow: auto;
    }
  `), StickyLayer = /* @__PURE__ */ styled(Layer).withConfig({
  displayName: "StickyLayer",
  componentId: "sc-qlxjvl-1"
})((props2) => {
  const radii = props2.theme.sanity.radius[3];
  return css`
    position: sticky;
    top: 0;
    width: 100%;
    background: var(--card-bg-color);
    border-bottom: 1px solid var(--card-border-color);
    border-top-left-radius: ${radii}px;
    border-top-right-radius: ${radii}px;
  `;
});
function PopoverDialog(props2) {
  const $ = c(23), {
    children,
    header,
    onClose,
    referenceElement,
    containerRef,
    width
  } = props2;
  let t0;
  $[0] !== onClose || $[1] !== referenceElement ? (t0 = () => {
    onClose(), referenceElement?.focus();
  }, $[0] = onClose, $[1] = referenceElement, $[2] = t0) : t0 = $[2];
  const handleClose = t0;
  let t1;
  $[3] !== header ? (t1 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: header }) }), $[3] = header, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    content: "Close"
  }, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== handleClose ? (t3 = /* @__PURE__ */ jsx(Button, { icon: CloseIcon, mode: "bleed", onClick: handleClose, tooltipProps: t2 }), $[6] = handleClose, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t1 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(StickyLayer, { children: /* @__PURE__ */ jsx(Box, { padding: 2, paddingLeft: 4, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t1,
    t3
  ] }) }) }), $[8] = t1, $[9] = t3, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== children ? (t5 = /* @__PURE__ */ jsx(Box, { padding: 4, children }), $[11] = children, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== containerRef || $[14] !== t4 || $[15] !== t5 ? (t6 = /* @__PURE__ */ jsx(FocusLock, { autoFocus: !0, children: /* @__PURE__ */ jsxs(Stack, { ref: containerRef, children: [
    t4,
    t5
  ] }) }), $[13] = containerRef, $[14] = t4, $[15] = t5, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== t6 || $[18] !== width ? (t7 = /* @__PURE__ */ jsx(PopoverContainer, { width, "data-testid": "popover-dialog", children: t6 }), $[17] = t6, $[18] = width, $[19] = t7) : t7 = $[19];
  const content = t7;
  let t8;
  return $[20] !== content || $[21] !== referenceElement ? (t8 = /* @__PURE__ */ jsx(StyledPopover, { portal: !0, constrainSize: !0, content, open: !0, referenceElement }), $[20] = content, $[21] = referenceElement, $[22] = t8) : t8 = $[22], t8;
}
const StyledCard = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "StyledCard",
  componentId: "sc-13z6s3f-0"
})(() => css`
    /* TextWithTone uses its own logic to set color, and we therefore need */
    /* to override this logic in order to set the correct color in different states */
    &[data-selected],
    &[data-pressed],
    &:active {
      [data-ui='TextWithTone'] {
        color: inherit;
      }
    }
  `);
function usePreviewCard() {
  const context = useContext(PreviewCardContext);
  if (!context)
    throw new Error("PreviewCard: missing context value");
  return context;
}
const PreviewCard = forwardRef(function(props2, ref) {
  const $ = c(16);
  let as, children, restProps, selected;
  $[0] !== props2 ? ({
    children,
    selected,
    as,
    ...restProps
  } = props2, $[0] = props2, $[1] = as, $[2] = children, $[3] = restProps, $[4] = selected) : (as = $[1], children = $[2], restProps = $[3], selected = $[4]);
  let t0;
  $[5] !== selected ? (t0 = {
    selected
  }, $[5] = selected, $[6] = t0) : t0 = $[6];
  const value = t0;
  let t1;
  $[7] !== children || $[8] !== value ? (t1 = /* @__PURE__ */ jsx(PreviewCardContext.Provider, { value, children }), $[7] = children, $[8] = value, $[9] = t1) : t1 = $[9];
  let t2;
  return $[10] !== as || $[11] !== ref || $[12] !== restProps || $[13] !== selected || $[14] !== t1 ? (t2 = /* @__PURE__ */ jsx(StyledCard, { "data-ui": "PreviewCard", ...restProps, forwardedAs: as, ref, selected, children: t1 }), $[10] = as, $[11] = ref, $[12] = restProps, $[13] = selected, $[14] = t1, $[15] = t2) : t2 = $[15], t2;
}), ReferenceInputPreviewCard = styled(PreviewCard).withConfig({
  displayName: "ReferenceInputPreviewCard",
  componentId: "sc-13z6s3f-1"
})`min-height:36px;`, MediaWrapper = /* @__PURE__ */ styled.span.withConfig({
  displayName: "MediaWrapper",
  componentId: "sc-9zn1wt-0"
})((props2) => {
  const {
    $dimensions,
    $layout,
    $radius,
    $responsive
  } = props2, width = $dimensions.width || 0, height = $dimensions.width || 0, iconSize = PREVIEW_SIZES[$layout].icon;
  return css`
    position: relative;
    width: ${$responsive ? "100%" : rem(width)};
    height: ${$responsive ? "100%" : rem(height)};
    min-width: ${$responsive ? void 0 : rem(width)};
    border-radius: ${({
    theme
  }) => rem(theme.sanity.radius[$radius])};
    display: flex;
    overflow: hidden;
    overflow: clip;
    align-items: center;
    justify-content: center;

    & img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: inherit;
    }

    & svg {
      // Shared styles for SVG icons
      color: var(--card-icon-color);
      display: block;
      flex: 1;

      // Specific styles for non Sanity icons
      &:not([data-sanity-icon]) {
        height: 1em;
        width: 1em;
        max-width: 1em;
        max-height: 1em;
      }

      // Specific styles for Sanity icons
      &[data-sanity-icon] {
        display: block;
        font-size: calc(${iconSize} / 16 * 1em);
      }
    }

    & > span[data-border] {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      box-shadow: inset 0 0 0 1px var(--card-fg-color);
      opacity: 0.1;
      border-radius: inherit;
      pointer-events: none;
    }
  `;
});
MediaWrapper.displayName = "Styled(MediaWrapper)";
function Media(props2) {
  const $ = c(14), {
    border: t0,
    dimensions,
    layout,
    media,
    radius: t1,
    responsive: t2,
    styles
  } = props2, border = t0 === void 0 ? !0 : t0, radius = t1 === void 0 ? 1 : t1, responsive = t2 === void 0 ? !1 : t2, t3 = styles?.media;
  let t4;
  $[0] !== dimensions || $[1] !== layout || $[2] !== media ? (t4 = renderMedia({
    dimensions,
    layout,
    media
  }), $[0] = dimensions, $[1] = layout, $[2] = media, $[3] = t4) : t4 = $[3];
  let t5;
  $[4] !== border ? (t5 = border && /* @__PURE__ */ jsx("span", { "data-border": !0 }), $[4] = border, $[5] = t5) : t5 = $[5];
  let t6;
  return $[6] !== dimensions || $[7] !== layout || $[8] !== radius || $[9] !== responsive || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 ? (t6 = /* @__PURE__ */ jsxs(MediaWrapper, { $dimensions: dimensions, $layout: layout, $radius: radius, $responsive: responsive, className: t3, "data-testid": "Media", children: [
    t4,
    t5
  ] }), $[6] = dimensions, $[7] = layout, $[8] = radius, $[9] = responsive, $[10] = t3, $[11] = t4, $[12] = t5, $[13] = t6) : t6 = $[13], t6;
}
function renderMedia(props2) {
  const {
    dimensions,
    layout,
    media,
    styles
  } = props2;
  return typeof media == "string" ? /* @__PURE__ */ jsx(Text$1, { as: "span", className: styles?.mediaString, size: 1, children: media }) : isValidElementType(media) ? /* @__PURE__ */ jsx(media, { dimensions, layout }) : isValidElement(media) ? media : null;
}
function renderPreviewMedia(value, layout, dimensions) {
  return isValidElementType(value) ? /* @__PURE__ */ jsx(value, { layout, dimensions }) : typeof value == "string" ? /* @__PURE__ */ jsx("div", { children: value }) : value;
}
function renderPreviewNode(value, layout, fallbackNode) {
  return typeof value == "string" ? value : isValidElementType(value) ? /* @__PURE__ */ jsx(value, { layout }) : value || fallbackNode;
}
const DEFAULT_MEDIA_DIMENSIONS$6 = {
  ...PREVIEW_SIZES.compact.media,
  aspect: 1,
  fit: "crop",
  dpr: getDevicePixelRatio()
}, Root$4 = styled(Flex).withConfig({
  displayName: "Root",
  componentId: "sc-81976j-0"
})`height:${rem(PREVIEW_SIZES.compact.media.height)};box-sizing:content-box;`, TitleSkeleton$2 = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
}).withConfig({
  displayName: "TitleSkeleton",
  componentId: "sc-81976j-1"
})`max-width:${rem(160)};width:80%;`;
function CompactPreview(props2) {
  const $ = c(32), {
    children,
    isPlaceholder,
    media,
    status,
    title
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== status ? (t0 = status && /* @__PURE__ */ jsx(Box, { "data-testid": "compact-preview__status", paddingLeft: 4, paddingRight: 1, children: renderPreviewNode(status, "compact") }), $[0] = status, $[1] = t0) : t0 = $[1];
  const statusNode = t0;
  if (isPlaceholder) {
    const t12 = media ? 1 : 2;
    let t22;
    $[2] !== media ? (t22 = media && /* @__PURE__ */ jsx(Skeleton, { animated: !0, radius: 2, style: PREVIEW_SIZES.compact.media }), $[2] = media, $[3] = t22) : t22 = $[3];
    let t32;
    $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t32 = /* @__PURE__ */ jsx(Stack, { "data-testid": "compact-preview__heading", flex: 1, space: 2, children: /* @__PURE__ */ jsx(TitleSkeleton$2, {}) }), $[4] = t32) : t32 = $[4];
    let t42;
    $[5] !== statusNode || $[6] !== t22 ? (t42 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 2, children: [
      t22,
      t32,
      statusNode
    ] }), $[5] = statusNode, $[6] = t22, $[7] = t42) : t42 = $[7];
    let t52;
    return $[8] !== t12 || $[9] !== t42 ? (t52 = /* @__PURE__ */ jsx(Root$4, { align: "center", "data-testid": "default-preview", paddingLeft: t12, paddingRight: 2, paddingY: 1, children: t42 }), $[8] = t12, $[9] = t42, $[10] = t52) : t52 = $[10], t52;
  }
  const t1 = media ? 1 : 2;
  let t2;
  $[11] !== media ? (t2 = media && /* @__PURE__ */ jsx(Media, { border: !1, dimensions: DEFAULT_MEDIA_DIMENSIONS$6, layout: "compact", media }), $[11] = media, $[12] = t2) : t2 = $[12];
  let t3;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    color: "inherit"
  }, $[13] = t3) : t3 = $[13];
  let t4;
  $[14] !== title ? (t4 = title && renderPreviewNode(title, "compact"), $[14] = title, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== t || $[17] !== title ? (t5 = !title && /* @__PURE__ */ jsx("span", { style: {
    color: "var(--card-muted-fg-color)"
  }, children: t("preview.default.title-fallback") }), $[16] = t, $[17] = title, $[18] = t5) : t5 = $[18];
  let t6;
  $[19] !== t4 || $[20] !== t5 ? (t6 = /* @__PURE__ */ jsx(Stack, { "data-testid": "compact-preview__header", flex: 1, space: 2, children: /* @__PURE__ */ jsxs(Text$1, { size: 1, style: t3, textOverflow: "ellipsis", weight: "medium", children: [
    t4,
    t5
  ] }) }), $[19] = t4, $[20] = t5, $[21] = t6) : t6 = $[21];
  let t7;
  $[22] !== statusNode || $[23] !== t2 || $[24] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 2, children: [
    t2,
    t6,
    statusNode
  ] }), $[22] = statusNode, $[23] = t2, $[24] = t6, $[25] = t7) : t7 = $[25];
  let t8;
  $[26] !== children ? (t8 = children && /* @__PURE__ */ jsx(Box, { marginLeft: 1, children }), $[26] = children, $[27] = t8) : t8 = $[27];
  let t9;
  return $[28] !== t1 || $[29] !== t7 || $[30] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Root$4, { align: "center", "data-testid": "compact-preview", paddingLeft: t1, paddingRight: 2, paddingY: 1, children: [
    t7,
    t8
  ] }), $[28] = t1, $[29] = t7, $[30] = t8, $[31] = t9) : t9 = $[31], t9;
}
const STROKE_WIDTH$1 = 0.5, Root$3 = styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-sggonj-0"
})`overflow:hidden;overflow:clip;`, Bar = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "Bar",
  componentId: "sc-sggonj-1"
})(({
  theme
}) => {
  const {
    color
  } = theme.sanity;
  return css`
    height: ${STROKE_WIDTH$1}rem;
    background: ${hues.blue[color.dark ? 400 : 500].hex};
    transition: transform 75ms;
  `;
});
function LinearProgress(props2) {
  const $ = c(2), {
    value
  } = props2, t0 = `translate3d(${value - 100}%, 0, 0)`;
  let t1;
  return $[0] !== t0 ? (t1 = /* @__PURE__ */ jsx(Root$3, { radius: 5, children: /* @__PURE__ */ jsx(Bar, { radius: 5, style: {
    transform: t0
  } }) }), $[0] = t0, $[1] = t1) : t1 = $[1], t1;
}
const DEFAULT_MEDIA_DIMENSIONS$5 = {
  ...PREVIEW_SIZES.default.media,
  aspect: 1,
  fit: "crop",
  dpr: getDevicePixelRatio()
}, Root$2 = styled(Flex).withConfig({
  displayName: "Root",
  componentId: "sc-1wtcvgg-0"
})`height:${rem(PREVIEW_SIZES.default.media.height)};box-sizing:content-box;`, TitleSkeleton$1 = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
}).withConfig({
  displayName: "TitleSkeleton",
  componentId: "sc-1wtcvgg-1"
})`max-width:${rem(160)};width:80%;`, SubtitleSkeleton$1 = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
}).withConfig({
  displayName: "SubtitleSkeleton",
  componentId: "sc-1wtcvgg-2"
})`max-width:${rem(120)};width:60%;`, SKELETON_DELAY = 300;
function DefaultPreview(props2) {
  const $ = c(49), {
    title,
    subtitle,
    media,
    status,
    isPlaceholder,
    children,
    styles,
    progress
  } = props2, {
    t
  } = useTranslation(), t0 = styles?.root, t1 = !!subtitle && styles?.hasSubtitle;
  let t2;
  $[0] !== t0 || $[1] !== t1 ? (t2 = classNames(t0, t1), $[0] = t0, $[1] = t1, $[2] = t2) : t2 = $[2];
  const rootClassName = t2, isUploading = typeof progress == "number" && progress > -1;
  let t3;
  $[3] !== status || $[4] !== styles?.status ? (t3 = status && /* @__PURE__ */ jsx(Box, { className: styles?.status, "data-testid": "default-preview__status", children: renderPreviewNode(status, "default") }), $[3] = status, $[4] = styles?.status, $[5] = t3) : t3 = $[5];
  const statusNode = t3;
  if (isPlaceholder) {
    const t42 = styles?.placeholder, t52 = media ? 2 : 3;
    let t62;
    $[6] !== media ? (t62 = media && /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(Skeleton, { animated: !0, delay: SKELETON_DELAY, radius: 1, style: PREVIEW_SIZES.default.media }) }), $[6] = media, $[7] = t62) : t62 = $[7];
    let t72;
    $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t72 = /* @__PURE__ */ jsxs(Stack, { "data-testid": "default-preview__heading", flex: 1, space: 2, children: [
      /* @__PURE__ */ jsx(TitleSkeleton$1, { delay: SKELETON_DELAY }),
      /* @__PURE__ */ jsx(SubtitleSkeleton$1, { delay: SKELETON_DELAY })
    ] }), $[8] = t72) : t72 = $[8];
    let t82;
    $[9] !== statusNode ? (t82 = /* @__PURE__ */ jsx(Box, { flex: "none", padding: 1, children: statusNode }), $[9] = statusNode, $[10] = t82) : t82 = $[10];
    let t92;
    $[11] !== t62 || $[12] !== t82 ? (t92 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 2, children: [
      t62,
      t72,
      t82
    ] }), $[11] = t62, $[12] = t82, $[13] = t92) : t92 = $[13];
    let t102;
    return $[14] !== t42 || $[15] !== t52 || $[16] !== t92 ? (t102 = /* @__PURE__ */ jsx(Root$2, { align: "center", className: t42, "data-testid": "default-preview", padding: 2, paddingLeft: t52, children: t92 }), $[14] = t42, $[15] = t52, $[16] = t92, $[17] = t102) : t102 = $[17], t102;
  }
  const t4 = media ? 2 : 3;
  let t5;
  $[18] !== media || $[19] !== styles ? (t5 = media && /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(Media, { dimensions: DEFAULT_MEDIA_DIMENSIONS$5, layout: "default", media, styles }) }), $[18] = media, $[19] = styles, $[20] = t5) : t5 = $[20];
  const t6 = styles?.heading;
  let t7;
  $[21] !== isUploading || $[22] !== progress ? (t7 = isUploading && /* @__PURE__ */ jsx(LinearProgress, { value: progress }), $[21] = isUploading, $[22] = progress, $[23] = t7) : t7 = $[23];
  let t8;
  $[24] !== isUploading || $[25] !== styles?.subtitle || $[26] !== styles?.title || $[27] !== subtitle || $[28] !== t || $[29] !== title ? (t8 = !isUploading && /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsxs(Text$1, { className: styles?.title, size: 1, style: {
      color: "inherit"
    }, textOverflow: "ellipsis", weight: "medium", children: [
      title && renderPreviewNode(title, "default"),
      !title && /* @__PURE__ */ jsx("span", { style: {
        color: "var(--card-muted-fg-color)"
      }, children: t("preview.default.title-fallback") })
    ] }),
    subtitle && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", className: styles?.subtitle, children: renderPreviewNode(subtitle, "default") })
  ] }), $[24] = isUploading, $[25] = styles?.subtitle, $[26] = styles?.title, $[27] = subtitle, $[28] = t, $[29] = title, $[30] = t8) : t8 = $[30];
  let t9;
  $[31] !== t6 || $[32] !== t7 || $[33] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Stack, { className: t6, "data-testid": "default-preview__header", flex: 1, space: 2, children: [
    t7,
    t8
  ] }), $[31] = t6, $[32] = t7, $[33] = t8, $[34] = t9) : t9 = $[34];
  let t10;
  $[35] !== statusNode ? (t10 = /* @__PURE__ */ jsx(Box, { flex: "none", padding: 1, children: statusNode }), $[35] = statusNode, $[36] = t10) : t10 = $[36];
  let t11;
  $[37] !== children || $[38] !== styles?.children ? (t11 = children && /* @__PURE__ */ jsx("div", { className: styles?.children, children }), $[37] = children, $[38] = styles?.children, $[39] = t11) : t11 = $[39];
  let t12;
  $[40] !== t10 || $[41] !== t11 || $[42] !== t5 || $[43] !== t9 ? (t12 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 2, children: [
    t5,
    t9,
    t10,
    t11
  ] }), $[40] = t10, $[41] = t11, $[42] = t5, $[43] = t9, $[44] = t12) : t12 = $[44];
  let t13;
  return $[45] !== rootClassName || $[46] !== t12 || $[47] !== t4 ? (t13 = /* @__PURE__ */ jsx(Root$2, { align: "center", className: rootClassName, "data-testid": "default-preview", padding: 2, paddingLeft: t4, children: t12 }), $[45] = rootClassName, $[46] = t12, $[47] = t4, $[48] = t13) : t13 = $[48], t13;
}
const DEFAULT_MEDIA_DIMENSIONS$4 = {
  ...PREVIEW_SIZES.detail.media,
  fit: "crop",
  aspect: 1,
  dpr: getDevicePixelRatio()
};
function DetailPreview(props2) {
  const $ = c(47), {
    title,
    subtitle,
    description,
    mediaDimensions: t0,
    media,
    status,
    children,
    isPlaceholder
  } = props2, mediaDimensions = t0 === void 0 ? DEFAULT_MEDIA_DIMENSIONS$4 : t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== status ? (t1 = status && /* @__PURE__ */ jsx(StatusBox, { marginLeft: 3, paddingRight: 1, children: renderPreviewNode(status, "detail") }), $[0] = status, $[1] = t1) : t1 = $[1];
  const statusNode = t1;
  if (isPlaceholder) {
    const t22 = media ? 2 : 3;
    let t32;
    $[2] !== media ? (t32 = media && /* @__PURE__ */ jsx(MediaSkeleton$1, { "data-testid": "detail-preview__media" }), $[2] = media, $[3] = t32) : t32 = $[3];
    let t42, t52;
    $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = /* @__PURE__ */ jsx(TitleSkeleton$3, {}), t52 = /* @__PURE__ */ jsx(SubtitleSkeleton$2, {}), $[4] = t42, $[5] = t52) : (t42 = $[4], t52 = $[5]);
    let t62;
    $[6] !== description ? (t62 = description && /* @__PURE__ */ jsx(Box, { marginTop: 1, children: /* @__PURE__ */ jsx(DescriptionSkeleton, {}) }), $[6] = description, $[7] = t62) : t62 = $[7];
    let t72;
    $[8] !== t62 ? (t72 = /* @__PURE__ */ jsx(Flex, { align: "center", "data-testid": "detail-preview__header", flex: 1, children: /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
      t42,
      t52,
      t62
    ] }) }), $[8] = t62, $[9] = t72) : t72 = $[9];
    let t82;
    $[10] !== statusNode || $[11] !== t32 || $[12] !== t72 ? (t82 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 3, children: [
      t32,
      t72,
      statusNode
    ] }), $[10] = statusNode, $[11] = t32, $[12] = t72, $[13] = t82) : t82 = $[13];
    let t92;
    return $[14] !== t22 || $[15] !== t82 ? (t92 = /* @__PURE__ */ jsx(RootFlex$2, { "data-testid": "detail-preview", paddingLeft: t22, paddingRight: 2, paddingY: 2, children: t82 }), $[14] = t22, $[15] = t82, $[16] = t92) : t92 = $[16], t92;
  }
  const t2 = media ? 2 : 3;
  let t3;
  $[17] !== media || $[18] !== mediaDimensions ? (t3 = media && /* @__PURE__ */ jsx(Media, { dimensions: mediaDimensions, layout: "detail", media }), $[17] = media, $[18] = mediaDimensions, $[19] = t3) : t3 = $[19];
  let t4;
  $[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    color: "inherit"
  }, $[20] = t4) : t4 = $[20];
  let t5;
  $[21] !== title ? (t5 = title && renderPreviewNode(title, "detail"), $[21] = title, $[22] = t5) : t5 = $[22];
  let t6;
  $[23] !== t || $[24] !== title ? (t6 = !title && /* @__PURE__ */ jsx(Fragment$1, { children: t("preview.default.title-fallback") }), $[23] = t, $[24] = title, $[25] = t6) : t6 = $[25];
  let t7;
  $[26] !== t5 || $[27] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Text$1, { textOverflow: "ellipsis", size: 1, style: t4, weight: "medium", children: [
    t5,
    t6
  ] }), $[26] = t5, $[27] = t6, $[28] = t7) : t7 = $[28];
  let t8;
  $[29] !== subtitle ? (t8 = subtitle && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: renderPreviewNode(subtitle, "detail") }), $[29] = subtitle, $[30] = t8) : t8 = $[30];
  let t9;
  $[31] !== description ? (t9 = description && /* @__PURE__ */ jsx(Box, { marginTop: 1, children: /* @__PURE__ */ jsx(DescriptionText, { muted: !0, size: 1, children: renderPreviewNode(description, "detail") }) }), $[31] = description, $[32] = t9) : t9 = $[32];
  let t10;
  $[33] !== t7 || $[34] !== t8 || $[35] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
    t7,
    t8,
    t9
  ] }), $[33] = t7, $[34] = t8, $[35] = t9, $[36] = t10) : t10 = $[36];
  let t11;
  $[37] !== statusNode || $[38] !== t10 ? (t11 = /* @__PURE__ */ jsxs(Flex, { align: "center", "data-testid": "detail-preview__header", flex: 1, children: [
    t10,
    statusNode
  ] }), $[37] = statusNode, $[38] = t10, $[39] = t11) : t11 = $[39];
  let t12;
  $[40] !== children || $[41] !== t11 || $[42] !== t3 ? (t12 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 3, children: [
    t3,
    t11,
    children
  ] }), $[40] = children, $[41] = t11, $[42] = t3, $[43] = t12) : t12 = $[43];
  let t13;
  return $[44] !== t12 || $[45] !== t2 ? (t13 = /* @__PURE__ */ jsx(RootFlex$2, { "data-testid": "detail-preview", paddingLeft: t2, paddingRight: 2, paddingY: 2, children: t12 }), $[44] = t12, $[45] = t2, $[46] = t13) : t13 = $[46], t13;
}
const SIZE = 43, STROKE_WIDTH = 3, Root$1 = styled.svg.withConfig({
  displayName: "Root",
  componentId: "sc-29w9ng-0"
})`width:${SIZE}px;height:${SIZE}px;transform:rotate(-90deg);`, BgCircle = /* @__PURE__ */ styled.circle.withConfig({
  displayName: "BgCircle",
  componentId: "sc-29w9ng-1"
})(({
  theme
}) => {
  const {
    color
  } = theme.sanity;
  return css`
    fill: none;
    stroke: ${hues.gray[color.dark ? 900 : 100].hex};
    stroke-width: ${STROKE_WIDTH}px;
  `;
}), ProgressCircle = /* @__PURE__ */ styled.circle.withConfig({
  displayName: "ProgressCircle",
  componentId: "sc-29w9ng-2"
})(({
  theme
}) => {
  const {
    color
  } = theme.sanity;
  return css`
    fill: none;
    stroke: ${hues.blue[color.dark ? 400 : 500].hex};
    stroke-width: ${STROKE_WIDTH}px;
    transition: stroke-dashoffset 75ms;
  `;
});
function CircularProgress(props2) {
  const $ = c(3), {
    value: valueProp
  } = props2, value = Math.min(Math.max(valueProp, 0), 100), radius = SIZE / 2 - STROKE_WIDTH / 2, circ = 2 * Math.PI * radius, offset = (100 - value) / 100 * circ, viewBox = `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(BgCircle, { cx: SIZE, cy: SIZE, r: radius }), $[0] = t0) : t0 = $[0];
  const t1 = `${offset}px`;
  let t2;
  return $[1] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Root$1, { viewBox, children: [
    t0,
    /* @__PURE__ */ jsx(ProgressCircle, { cx: SIZE, cy: SIZE, r: radius, style: {
      strokeDasharray: circ,
      strokeDashoffset: t1
    } })
  ] }), $[1] = t1, $[2] = t2) : t2 = $[2], t2;
}
const RootBox$1 = styled(Box).withConfig({
  displayName: "RootBox",
  componentId: "sc-g2aiwo-0"
})`position:relative;`, MediaFlex = styled(Flex).attrs({
  align: "center",
  justify: "center"
}).withConfig({
  displayName: "MediaFlex",
  componentId: "sc-g2aiwo-1"
})`position:absolute;left:0;top:0;right:0;bottom:0;`, MediaSkeleton = styled(Skeleton).attrs({
  animated: !0,
  radius: 2
}).withConfig({
  displayName: "MediaSkeleton",
  componentId: "sc-g2aiwo-2"
})`width:100%;height:100%;`, ProgressFlex = styled(Flex).attrs({
  align: "center",
  justify: "center"
}).withConfig({
  displayName: "ProgressFlex",
  componentId: "sc-g2aiwo-3"
})`position:absolute;left:0;top:0;right:0;bottom:0;&:before{background-color:var(--card-bg-color);opacity:0.75;content:'';display:block;position:absolute;left:0;top:0;right:0;bottom:0;}> svg{position:relative;z-index:2;}`, TooltipContentStack = styled(Stack).attrs({
  space: 2
}).withConfig({
  displayName: "TooltipContentStack",
  componentId: "sc-g2aiwo-4"
})`max-width:${rem(200)};`, DEFAULT_MEDIA_DIMENSIONS$3 = {
  ...PREVIEW_SIZES.media.media,
  aspect: 1,
  fit: "crop",
  dpr: getDevicePixelRatio()
};
function MediaPreview(props2) {
  const $ = c(30), {
    media,
    mediaDimensions: t0,
    children,
    isPlaceholder,
    progress: t1,
    subtitle,
    title,
    withBorder: t2,
    withRadius: t3
  } = props2, mediaDimensions = t0 === void 0 ? DEFAULT_MEDIA_DIMENSIONS$3 : t0, progress = t1 === void 0 ? -1 : t1, withBorder = t2 === void 0 ? !0 : t2, withRadius = t3 === void 0 ? !0 : t3, t4 = `${100 / (mediaDimensions.aspect || 1)}%`;
  let t5;
  $[0] !== t4 ? (t5 = {
    paddingBottom: t4
  }, $[0] = t4, $[1] = t5) : t5 = $[1];
  const STYLES_PADDER = t5;
  let t6;
  bb0: {
    if (!title || !subtitle) {
      t6 = null;
      break bb0;
    }
    let t72;
    $[2] !== title ? (t72 = title && /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, weight: "medium", children: renderPreviewNode(title, "media") }), $[2] = title, $[3] = t72) : t72 = $[3];
    let t82;
    $[4] !== subtitle ? (t82 = subtitle && /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: renderPreviewNode(subtitle, "media") }), $[4] = subtitle, $[5] = t82) : t82 = $[5];
    let t92;
    $[6] !== t72 || $[7] !== t82 ? (t92 = /* @__PURE__ */ jsxs(TooltipContentStack, { children: [
      t72,
      t82
    ] }), $[6] = t72, $[7] = t82, $[8] = t92) : t92 = $[8], t6 = t92;
  }
  const tooltipContent = t6;
  let t7;
  $[9] !== STYLES_PADDER ? (t7 = /* @__PURE__ */ jsx("div", { style: STYLES_PADDER }), $[9] = STYLES_PADDER, $[10] = t7) : t7 = $[10];
  const t8 = !tooltipContent;
  let t9;
  $[11] !== isPlaceholder || $[12] !== media || $[13] !== mediaDimensions || $[14] !== withBorder || $[15] !== withRadius ? (t9 = isPlaceholder ? /* @__PURE__ */ jsx(MediaSkeleton, {}) : /* @__PURE__ */ jsx(Media, { border: withBorder, dimensions: mediaDimensions, layout: "media", media, radius: withRadius ? 1 : 0, responsive: !0 }), $[11] = isPlaceholder, $[12] = media, $[13] = mediaDimensions, $[14] = withBorder, $[15] = withRadius, $[16] = t9) : t9 = $[16];
  let t10;
  $[17] !== progress ? (t10 = typeof progress == "number" && progress > -1 && /* @__PURE__ */ jsx(ProgressFlex, { children: /* @__PURE__ */ jsx(CircularProgress, { value: progress }) }), $[17] = progress, $[18] = t10) : t10 = $[18];
  let t11;
  $[19] !== t10 || $[20] !== t9 ? (t11 = /* @__PURE__ */ jsxs(MediaFlex, { children: [
    t9,
    t10
  ] }), $[19] = t10, $[20] = t9, $[21] = t11) : t11 = $[21];
  let t12;
  $[22] !== t11 || $[23] !== t8 || $[24] !== tooltipContent ? (t12 = /* @__PURE__ */ jsx(Tooltip, { content: tooltipContent, disabled: t8, placement: "top", portal: !0, children: t11 }), $[22] = t11, $[23] = t8, $[24] = tooltipContent, $[25] = t12) : t12 = $[25];
  let t13;
  return $[26] !== children || $[27] !== t12 || $[28] !== t7 ? (t13 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsxs(RootBox$1, { "data-testid": "media-preview", flex: 1, overflow: "hidden", children: [
    t7,
    t12,
    children
  ] }) }), $[26] = children, $[27] = t12, $[28] = t7, $[29] = t13) : t13 = $[29], t13;
}
const HeaderFlex$2 = styled(Flex).attrs({
  align: "center"
}).withConfig({
  displayName: "HeaderFlex",
  componentId: "sc-1ss4u22-0"
})`height:${rem(PREVIEW_SIZES.block.media.height)};white-space:nowrap;position:relative;z-index:1;`, MediaCard = styled(Card).withConfig({
  displayName: "MediaCard",
  componentId: "sc-1ss4u22-1"
})`overflow:hidden;position:relative;padding-bottom:${({
  $ratio
}) => $ratio}%;& > span{position:absolute;top:0;left:0;right:0;bottom:0;}`, RootBox = styled(Box).attrs({
  overflow: "hidden"
}).withConfig({
  displayName: "RootBox",
  componentId: "sc-1ss4u22-2"
})`border-radius:${({
  theme
}) => theme.sanity.radius[1]}px;`, DEFAULT_MEDIA_DIMENSIONS$2 = {
  ...PREVIEW_SIZES.blockImage.media,
  fit: "fillmax",
  dpr: getDevicePixelRatio()
}, getRatio = (dimensions) => {
  const {
    height,
    width
  } = dimensions;
  return !height || !width ? 1 : height / width * 100;
};
function BlockImagePreview(props2) {
  const $ = c(35), {
    actions,
    title,
    subtitle,
    description,
    fallbackTitle: t0,
    mediaDimensions: t1,
    media,
    children,
    status
  } = props2, fallbackTitle = t0 === void 0 ? "Untitled" : t0, mediaDimensions = t1 === void 0 ? DEFAULT_MEDIA_DIMENSIONS$2 : t1;
  let t2;
  $[0] !== fallbackTitle || $[1] !== title ? (t2 = (title || fallbackTitle) && /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: title ? renderPreviewNode(title, "block") : fallbackTitle }), $[0] = fallbackTitle, $[1] = title, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== subtitle ? (t3 = subtitle && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: renderPreviewNode(subtitle, "block") }), $[3] = subtitle, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t2 || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
    t2,
    t3
  ] }), $[5] = t2, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== status ? (t5 = status && /* @__PURE__ */ jsx(Box, { paddingX: 2, paddingY: 3, children: renderPreviewNode(status, "block") }), $[8] = status, $[9] = t5) : t5 = $[9];
  const t6 = actions;
  let t7;
  $[10] !== t5 || $[11] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { gap: 1, paddingLeft: 1, children: [
    t5,
    t6
  ] }), $[10] = t5, $[11] = t6, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== t4 || $[14] !== t7 ? (t8 = /* @__PURE__ */ jsxs(HeaderFlex$2, { paddingBottom: 3, paddingLeft: 2, paddingRight: 1, paddingTop: 1, children: [
    t4,
    t7
  ] }), $[13] = t4, $[14] = t7, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] !== mediaDimensions ? (t9 = getRatio(mediaDimensions), $[16] = mediaDimensions, $[17] = t9) : t9 = $[17];
  const t10 = media;
  let t11;
  $[18] !== mediaDimensions || $[19] !== t10 ? (t11 = /* @__PURE__ */ jsx(Media, { border: !1, dimensions: mediaDimensions, layout: "blockImage", media: t10, radius: 0, responsive: !0 }), $[18] = mediaDimensions, $[19] = t10, $[20] = t11) : t11 = $[20];
  let t12;
  $[21] !== t11 || $[22] !== t9 ? (t12 = /* @__PURE__ */ jsx(MediaCard, { $ratio: t9, __unstable_checkered: !0, display: "flex", sizing: "border", radius: 2, tone: "inherit", children: t11 }), $[21] = t11, $[22] = t9, $[23] = t12) : t12 = $[23];
  let t13;
  $[24] !== t12 || $[25] !== t8 ? (t13 = /* @__PURE__ */ jsxs(Stack, { children: [
    t8,
    t12
  ] }), $[24] = t12, $[25] = t8, $[26] = t13) : t13 = $[26];
  let t14;
  $[27] !== description ? (t14 = description && /* @__PURE__ */ jsx(Box, { paddingX: 2, paddingY: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: renderPreviewNode(description, "block") }) }), $[27] = description, $[28] = t14) : t14 = $[28];
  let t15;
  $[29] !== children ? (t15 = children && /* @__PURE__ */ jsx("div", { children }), $[29] = children, $[30] = t15) : t15 = $[30];
  let t16;
  return $[31] !== t13 || $[32] !== t14 || $[33] !== t15 ? (t16 = /* @__PURE__ */ jsxs(RootBox, { children: [
    t13,
    t14,
    t15
  ] }), $[31] = t13, $[32] = t14, $[33] = t15, $[34] = t16) : t16 = $[34], t16;
}
const DEFAULT_MEDIA_DIMENSIONS$1 = {
  ...PREVIEW_SIZES.block.media,
  aspect: 1,
  fit: "crop",
  dpr: getDevicePixelRatio()
}, HeaderFlex$1 = styled(Flex).attrs({
  align: "center"
}).withConfig({
  displayName: "HeaderFlex",
  componentId: "sc-2nqxb9-0"
})`min-height:${rem(PREVIEW_SIZES.block.media.height)};`;
function BlockPreview(props2) {
  const $ = c(34), {
    actions,
    title,
    subtitle,
    description,
    mediaDimensions: t0,
    media,
    progress,
    status,
    children
  } = props2, mediaDimensions = t0 === void 0 ? DEFAULT_MEDIA_DIMENSIONS$1 : t0, isUploading = typeof progress == "number" && progress > -1;
  let t1;
  $[0] !== media || $[1] !== mediaDimensions ? (t1 = media && /* @__PURE__ */ jsx(Media, { dimensions: mediaDimensions, layout: "block", media }), $[0] = media, $[1] = mediaDimensions, $[2] = t1) : t1 = $[2];
  const t2 = media ? 2 : 1;
  let t3;
  $[3] !== title ? (t3 = title ? renderPreviewNode(title, "block") : "Untitled", $[3] = title, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: t3 }), $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== subtitle ? (t5 = subtitle && /* @__PURE__ */ jsx(Box, { marginTop: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: renderPreviewNode(subtitle, "block") }) }), $[7] = subtitle, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== description ? (t6 = description && /* @__PURE__ */ jsx(Box, { marginTop: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: renderPreviewNode(description, "block") }) }), $[9] = description, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== isUploading || $[12] !== progress ? (t7 = isUploading && /* @__PURE__ */ jsx(Box, { marginTop: 3, children: /* @__PURE__ */ jsx(LinearProgress, { value: progress }) }), $[11] = isUploading, $[12] = progress, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t2 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Box, { flex: 1, paddingLeft: t2, children: [
    t4,
    t5,
    t6,
    t7
  ] }), $[14] = t2, $[15] = t4, $[16] = t5, $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== status ? (t9 = status && /* @__PURE__ */ jsx(Box, { paddingX: 2, paddingY: 3, children: renderPreviewNode(status, "block") }), $[20] = status, $[21] = t9) : t9 = $[21];
  const t10 = actions;
  let t11;
  $[22] !== t10 || $[23] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Flex, { gap: 1, paddingLeft: 1, children: [
    t9,
    t10
  ] }), $[22] = t10, $[23] = t9, $[24] = t11) : t11 = $[24];
  let t12;
  $[25] !== t1 || $[26] !== t11 || $[27] !== t8 ? (t12 = /* @__PURE__ */ jsxs(HeaderFlex$1, { "data-testid": "block-preview__header", children: [
    t1,
    t8,
    t11
  ] }), $[25] = t1, $[26] = t11, $[27] = t8, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== children ? (t13 = children && /* @__PURE__ */ jsx("div", { "data-testid": "block-preview__children", children }), $[29] = children, $[30] = t13) : t13 = $[30];
  let t14;
  return $[31] !== t12 || $[32] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Stack, { "data-testid": "block-preview", space: 1, children: [
    t12,
    t13
  ] }), $[31] = t12, $[32] = t13, $[33] = t14) : t14 = $[33], t14;
}
const RootSpan = styled.span.withConfig({
  displayName: "RootSpan",
  componentId: "sc-uy374x-0"
})`display:inline-flex;align-items:center;vertical-align:top;height:calc(1em - 1px);max-width:100%;`, MediaSpan = styled.span.withConfig({
  displayName: "MediaSpan",
  componentId: "sc-uy374x-1"
})`position:relative;display:inline-block;width:calc(1em - 1px);height:calc(1em - 1px);min-width:calc(1em - 1px);& img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;border-radius:${({
  theme
}) => rem(theme.sanity.radius[1])};}& img + span{position:absolute;left:0;top:0;right:0;bottom:0;box-shadow:inset 0 0 0 1px var(--card-fg-color);opacity:0.2;border-radius:${({
  theme
}) => rem(theme.sanity.radius[1])};}& svg{display:block;font-size:calc(14 / 16 * 1em);margin:1px 0;&[data-sanity-icon]{font-size:calc(18 / 16 * 1em);margin:calc(1px + (2 / 18 * -1em)) 0;}}`, TextSpan = /* @__PURE__ */ styled(Text$1).attrs({
  forwardedAs: "span"
}).withConfig({
  displayName: "TextSpan",
  componentId: "sc-uy374x-2"
})(({
  theme
}) => {
  const textFont = theme.sanity.fonts.text, textSize = textFont.sizes[1];
  return css`
    font-size: calc(${textSize.fontSize} / 16 * 1em);
    font-weight: ${textFont.weights.medium};
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    line-height: ${textSize.lineHeight / textSize.fontSize};
    padding-left: 0.5em;
    padding-right: calc(0.5em - 2px);
    min-width: 0;

    & > span {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      overflow: clip;
    }
  `;
}), DEFAULT_MEDIA_DIMENSIONS = {
  ...PREVIEW_SIZES.inline.media,
  fit: "crop",
  aspect: 1,
  dpr: getDevicePixelRatio()
};
function InlinePreview(props2) {
  const $ = c(11), {
    title,
    fallbackTitle: t0,
    media,
    mediaDimensions: t1
  } = props2, fallbackTitle = t0 === void 0 ? "Untitled" : t0, mediaDimensions = t1 === void 0 ? DEFAULT_MEDIA_DIMENSIONS : t1;
  let t2;
  $[0] !== media || $[1] !== mediaDimensions ? (t2 = media && /* @__PURE__ */ jsxs(MediaSpan, { "data-testid": "inline-preview-media", children: [
    renderPreviewMedia(media, "inline", mediaDimensions),
    /* @__PURE__ */ jsx("span", {})
  ] }), $[0] = media, $[1] = mediaDimensions, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== fallbackTitle || $[4] !== title ? (t3 = renderPreviewNode(title, "inline", fallbackTitle), $[3] = fallbackTitle, $[4] = title, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(TextSpan, { "data-testid": "inline-preview-title", size: 1, children: t3 }), $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  return $[8] !== t2 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsxs(RootSpan, { "data-testid": "inline-preview", children: [
    t2,
    t4
  ] }), $[8] = t2, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
}
const DEFAULT_MEDIA_DIMENSION = {
  ...PREVIEW_SIZES.default.media,
  aspect: 1,
  fit: "crop",
  dpr: getDevicePixelRatio()
}, Root = styled(Box).withConfig({
  displayName: "Root",
  componentId: "sc-1ar6jbk-0"
})`height:100%;a{color:currentColor;text-decoration:none;}svg[data-sanity-icon]{margin:0;}`, HeaderFlex = styled(Flex).attrs({
  align: "center"
}).withConfig({
  displayName: "HeaderFlex",
  componentId: "sc-1ar6jbk-1"
})`height:${rem(PREVIEW_SIZES.default.media.height)};`, TitleSkeleton = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1
}).withConfig({
  displayName: "TitleSkeleton",
  componentId: "sc-1ar6jbk-2"
})`max-width:${rem(160)};width:80%;`, SubtitleSkeleton = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
}).withConfig({
  displayName: "SubtitleSkeleton",
  componentId: "sc-1ar6jbk-3"
})`max-width:${rem(120)};width:60%;`;
function TemplatePreview(props2) {
  const $ = c(25), {
    description,
    isPlaceholder,
    media,
    mediaDimensions: t0,
    subtitle: Subtitle,
    title: t1
  } = props2, mediaDimensions = t0 === void 0 ? DEFAULT_MEDIA_DIMENSION : t0, Title2 = t1 === void 0 ? "Untitled" : t1;
  if (isPlaceholder) {
    let t22;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(Root, { children: /* @__PURE__ */ jsx(HeaderFlex, { children: /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
      /* @__PURE__ */ jsx(TitleSkeleton, {}),
      /* @__PURE__ */ jsx(SubtitleSkeleton, {})
    ] }) }) }), $[0] = t22) : t22 = $[0], t22;
  }
  let t2;
  $[1] !== Title2 ? (t2 = isValidElementType(Title2) && /* @__PURE__ */ jsx(Text$1, { textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(Title2, { layout: "default" }) }), $[1] = Title2, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== Title2 ? (t3 = isValidElement(Title2) && /* @__PURE__ */ jsx(Text$1, { textOverflow: "ellipsis", children: Title2 }), $[3] = Title2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== Subtitle ? (t4 = isValidElementType(Subtitle) && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(Subtitle, { layout: "default" }) }), $[5] = Subtitle, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== Subtitle ? (t5 = isValidElement(Subtitle) && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: Subtitle }), $[7] = Subtitle, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
    t2,
    t3,
    t4,
    t5
  ] }), $[9] = t2, $[10] = t3, $[11] = t4, $[12] = t5, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== media || $[15] !== mediaDimensions ? (t7 = media && /* @__PURE__ */ jsx(Flex, { align: "flex-start", paddingLeft: 2, children: /* @__PURE__ */ jsx(Media, { dimensions: mediaDimensions, layout: "default", media }) }), $[14] = media, $[15] = mediaDimensions, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t6 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsxs(HeaderFlex, { children: [
    t6,
    t7
  ] }), $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== description ? (t9 = description && /* @__PURE__ */ jsx(Box, { marginTop: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, style: {
    whiteSpace: "break-spaces"
  }, children: description }) }), $[20] = description, $[21] = t9) : t9 = $[21];
  let t10;
  return $[22] !== t8 || $[23] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Root, { children: [
    t8,
    t9
  ] }), $[22] = t8, $[23] = t9, $[24] = t10) : t10 = $[24], t10;
}
const MUTATION_ATTRIBUTE_FILTER = ["aria-hidden", "disabled", "href"], FOCUSABLE = 'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
function getFocusableElements(element) {
  return [...element.querySelectorAll(FOCUSABLE)].filter((el) => !el.hasAttribute("disabled") && el.getAttribute("aria-hidden") !== "true");
}
function useRovingFocus(props2) {
  const $ = c(25), {
    direction: t0,
    initialFocus,
    loop: t1,
    navigation: t2,
    pause: t3,
    rootElement
  } = props2, direction = t0 === void 0 ? "horizontal" : t0, loop = t1 === void 0 ? !0 : t1;
  let t4;
  $[0] !== t2 ? (t4 = t2 === void 0 ? ["arrows"] : t2, $[0] = t2, $[1] = t4) : t4 = $[1];
  const navigation = t4, pause = t3 === void 0 ? !1 : t3, [focusedIndex, setFocusedIndex] = useState(-1);
  let t5;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = [], $[2] = t5) : t5 = $[2];
  const [focusableElements, setFocusableElements] = useState(t5), focusableLen = focusableElements.length, lastFocusableIndex = focusableLen - 1, nextKey = direction === "horizontal" ? "ArrowRight" : "ArrowDown", prevKey = direction === "horizontal" ? "ArrowLeft" : "ArrowUp";
  let t6;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = (index) => {
    setFocusedIndex(index);
  }, $[3] = t6) : t6 = $[3];
  const handleFocus = t6;
  let t7;
  $[4] !== focusableLen || $[5] !== lastFocusableIndex || $[6] !== loop || $[7] !== navigation || $[8] !== nextKey || $[9] !== pause || $[10] !== prevKey ? (t7 = (event) => {
    if (pause)
      return;
    const focusPrev = () => {
      event.preventDefault(), setFocusedIndex((prevIndex) => {
        const next = (prevIndex + lastFocusableIndex) % focusableLen;
        return !loop && next === lastFocusableIndex ? prevIndex : next;
      });
    }, focusNext = () => {
      event.preventDefault(), setFocusedIndex((prevIndex_0) => {
        const next_0 = (prevIndex_0 + 1) % focusableLen;
        return !loop && next_0 === 0 ? prevIndex_0 : next_0;
      });
    };
    event.key === "Tab" && navigation.includes("tab") && (event.shiftKey ? focusPrev() : focusNext()), navigation.includes("arrows") && (event.key === prevKey && focusPrev(), event.key === nextKey && focusNext());
  }, $[4] = focusableLen, $[5] = lastFocusableIndex, $[6] = loop, $[7] = navigation, $[8] = nextKey, $[9] = pause, $[10] = prevKey, $[11] = t7) : t7 = $[11];
  const handleKeyDown = t7;
  let t8, t9;
  $[12] !== rootElement ? (t8 = () => {
    const handleSetElements = () => {
      if (rootElement) {
        const els = getFocusableElements(rootElement);
        setFocusableElements(els);
      }
    };
    handleSetElements();
    const mo = new MutationObserver(handleSetElements);
    return rootElement && mo.observe(rootElement, {
      childList: !0,
      subtree: !0,
      attributeFilter: MUTATION_ATTRIBUTE_FILTER
    }), () => {
      mo.disconnect();
    };
  }, t9 = [rootElement], $[12] = rootElement, $[13] = t8, $[14] = t9) : (t8 = $[13], t9 = $[14]), useEffect(t8, t9);
  let t10, t11;
  $[15] !== focusableElements || $[16] !== focusedIndex || $[17] !== initialFocus || $[18] !== lastFocusableIndex ? (t10 = () => {
    focusableElements.forEach((el, index_0) => {
      index_0 === focusedIndex ? (el.setAttribute("tabIndex", "0"), el.setAttribute("aria-selected", "true"), el.focus(), el.onfocus = () => handleFocus(index_0), el.onblur = () => handleFocus(-1)) : (el.setAttribute("tabIndex", "-1"), el.setAttribute("aria-selected", "false"), el.onfocus = () => handleFocus(index_0));
    }), focusedIndex === -1 && focusableElements && focusableElements[initialFocus === "last" ? lastFocusableIndex : 0]?.setAttribute("tabIndex", "0");
  }, t11 = [focusableElements, focusedIndex, handleFocus, initialFocus, lastFocusableIndex], $[15] = focusableElements, $[16] = focusedIndex, $[17] = initialFocus, $[18] = lastFocusableIndex, $[19] = t10, $[20] = t11) : (t10 = $[19], t11 = $[20]), useEffect(t10, t11);
  let t12, t13;
  $[21] !== handleKeyDown || $[22] !== rootElement ? (t12 = () => (rootElement?.addEventListener("keydown", handleKeyDown), () => {
    rootElement?.removeEventListener("keydown", handleKeyDown);
  }), t13 = [handleKeyDown, rootElement], $[21] = handleKeyDown, $[22] = rootElement, $[23] = t12, $[24] = t13) : (t12 = $[23], t13 = $[24]), useEffect(t12, t13);
}
const StyledButton = styled(Button).withConfig({
  displayName: "StyledButton",
  componentId: "sc-1352kvs-0"
})`position:relative;& > span:nth-child(2){position:absolute;top:6px;right:6px;padding:0;}`, Dot = /* @__PURE__ */ styled.div.withConfig({
  displayName: "Dot",
  componentId: "sc-1352kvs-1"
})({
  width: 4,
  height: 4,
  borderRadius: 3,
  boxShadow: "0 0 0 1px var(--card-bg-color)"
}), StatusButton = forwardRef(function(props2, ref) {
  const $ = c(22);
  let disabledProp, icon, label, restProps, t0, text, tone;
  $[0] !== props2 ? ({
    disabled: disabledProp,
    icon,
    "aria-label": label,
    mode: t0,
    text,
    tone,
    ...restProps
  } = props2, $[0] = props2, $[1] = disabledProp, $[2] = icon, $[3] = label, $[4] = restProps, $[5] = t0, $[6] = text, $[7] = tone) : (disabledProp = $[1], icon = $[2], label = $[3], restProps = $[4], t0 = $[5], text = $[6], tone = $[7]);
  const mode = t0 === void 0 ? "bleed" : t0, t1 = `var(--card-badge-${tone}-dot-color)`;
  let t2;
  $[8] !== t1 ? (t2 = {
    backgroundColor: t1
  }, $[8] = t1, $[9] = t2) : t2 = $[9];
  const dotStyle = t2, disabled = !!disabledProp;
  let t3;
  $[10] !== dotStyle || $[11] !== tone ? (t3 = tone && /* @__PURE__ */ jsx(Dot, { style: dotStyle }), $[10] = dotStyle, $[11] = tone, $[12] = t3) : t3 = $[12];
  let t4;
  return $[13] !== disabled || $[14] !== icon || $[15] !== label || $[16] !== mode || $[17] !== ref || $[18] !== restProps || $[19] !== t3 || $[20] !== text ? (t4 = /* @__PURE__ */ jsx(StyledButton, { "data-ui": "StatusButton", ...restProps, "aria-label": label, disabled, mode, ref, text, icon, children: t3 }), $[13] = disabled, $[14] = icon, $[15] = label, $[16] = mode, $[17] = ref, $[18] = restProps, $[19] = t3, $[20] = text, $[21] = t4) : t4 = $[21], t4;
}), TooltipOfDisabled = forwardRef(function(t0, ref) {
  const $ = c(13);
  let children, content, disabled, restProps;
  $[0] !== t0 ? ({
    children,
    content,
    disabled,
    ...restProps
  } = t0, $[0] = t0, $[1] = children, $[2] = content, $[3] = disabled, $[4] = restProps) : (children = $[1], content = $[2], disabled = $[3], restProps = $[4]);
  const t1 = disabled || !content;
  let t2;
  $[5] !== children ? (t2 = /* @__PURE__ */ jsx("div", { children }), $[5] = children, $[6] = t2) : t2 = $[6];
  let t3;
  return $[7] !== content || $[8] !== ref || $[9] !== restProps || $[10] !== t1 || $[11] !== t2 ? (t3 = /* @__PURE__ */ jsx(Tooltip, { ...restProps, content, disabled: t1, ref, children: t2 }), $[7] = content, $[8] = ref, $[9] = restProps, $[10] = t1, $[11] = t2, $[12] = t3) : t3 = $[12], t3;
}), ImperativeToast = forwardRef((_, ref) => {
  const $ = c(2), {
    push
  } = useToast();
  let t0;
  return $[0] !== push ? (t0 = () => ({
    push
  }), $[0] = push, $[1] = t0) : t0 = $[1], useImperativeHandle(ref, t0), null;
});
ImperativeToast.displayName = "ForwardRef(ImperativeToast)";
function useZIndex() {
  return useContext(ZIndexContext);
}
function LegacyLayerProvider(t0) {
  const $ = c(3), {
    children,
    zOffset: zOffsetKey
  } = t0, zOffset = useZIndex()[zOffsetKey];
  let t1;
  return $[0] !== children || $[1] !== zOffset ? (t1 = /* @__PURE__ */ jsx(LayerProvider, { zOffset, children }), $[0] = children, $[1] = zOffset, $[2] = t1) : t1 = $[2], t1;
}
const EMPTY = [];
function WithReferringDocuments(t0) {
  const $ = c(3), {
    children,
    id: id2
  } = t0, t1 = useReferringDocuments(id2, EMPTY);
  let t2;
  return $[0] !== children || $[1] !== t1 ? (t2 = children(t1), $[0] = children, $[1] = t1, $[2] = t2) : t2 = $[2], t2;
}
function ZIndexProvider(t0) {
  const $ = c(2), {
    children
  } = t0;
  let t1;
  return $[0] !== children ? (t1 = /* @__PURE__ */ jsx(ZIndexContext.Provider, { value: zIndexContextDefaults, children }), $[0] = children, $[1] = t1) : t1 = $[1], t1;
}
const ChangeFieldWrapper = (props2) => {
  const $ = c(20), {
    path,
    hasRevertHover
  } = props2, {
    onSetFocus
  } = useContext(ReviewChangesContext), zIndex = useZIndex(), [hasHover, setHover] = useState(!1);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setHover(!0);
  }, $[0] = t0) : t0 = $[0];
  const onMouseEnter = t0;
  let t1;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setHover(!1);
  }, $[1] = t1) : t1 = $[1];
  const onMouseLeave = t1, [element, setElement] = useState(null);
  let t2;
  $[2] !== element || $[3] !== path ? (t2 = element ? `change-${PathUtils.toString(path)}` : null, $[2] = element, $[3] = path, $[4] = t2) : t2 = $[4];
  const reporterId = t2;
  let t3;
  $[5] !== element || $[6] !== hasHover || $[7] !== hasRevertHover || $[8] !== path || $[9] !== zIndex.popover ? (t3 = () => ({
    element,
    path,
    isChanged: !0,
    hasFocus: !1,
    hasHover,
    zIndex: Array.isArray(zIndex.popover) ? zIndex.popover[0] : zIndex.popover,
    hasRevertHover
  }), $[5] = element, $[6] = hasHover, $[7] = hasRevertHover, $[8] = path, $[9] = zIndex.popover, $[10] = t3) : t3 = $[10], useChangeIndicatorsReporter(reporterId, t3, deepEquals);
  let t4;
  $[11] !== onSetFocus || $[12] !== path ? (t4 = (event) => {
    setFocusWithStopPropagation(event, onSetFocus, path);
  }, $[11] = onSetFocus, $[12] = path, $[13] = t4) : t4 = $[13];
  const handleClick = t4;
  let t5;
  $[14] !== path ? (t5 = DEBUG, $[14] = path, $[15] = t5) : t5 = $[15];
  let t6;
  return $[16] !== handleClick || $[17] !== props2.children || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsxs("div", { ref: setElement, onClick: handleClick, onMouseLeave, onMouseEnter, children: [
    t5,
    props2.children
  ] }), $[16] = handleClick, $[17] = props2.children, $[18] = t5, $[19] = t6) : t6 = $[19], t6;
};
function setFocusWithStopPropagation(event, onSetFocus, path) {
  event.stopPropagation(), onSetFocus(path);
}
function findMostSpecificTarget(targetType, id2, values2) {
  const pathString = id2.slice(id2.indexOf("-") + 1) || "[]", path = PathUtils.fromString(pathString), exactId = `${targetType}-${PathUtils.toString(path)}`;
  if (values2.has(exactId))
    return values2.get(exactId);
  if (path.length > 0)
    for (let i = path.length - 1; i >= 0; i--) {
      const lessSpecificPath = path.slice(0, i), lessSpecificExactId = `${targetType}-${PathUtils.toString(lessSpecificPath)}`;
      if (values2.has(lessSpecificExactId))
        return values2.get(lessSpecificExactId);
    }
  let mostSpecific;
  for (const [targetId, target] of values2) {
    if (!("path" in target) || !targetId.startsWith(targetType))
      continue;
    const numEqual = PathUtils.numEqualSegments(path, target.path), lastPathSegment = target.path[target.path.length - 1], pathOnlyDiffersByKey = numEqual === target.path.length - 1 && isKeyedObject(lastPathSegment);
    if (numEqual !== 0 && !(numEqual !== target.path.length && !pathOnlyDiffersByKey) && (mostSpecific = target, numEqual === path.length))
      break;
  }
  return mostSpecific;
}
function hasOverflowScroll(el) {
  const overflow = getComputedStyle(el).overflow;
  return overflow.includes("auto") || overflow.includes("scroll");
}
function isScrollable(el) {
  return (el.scrollHeight !== el.offsetHeight || el.scrollWidth !== el.offsetWidth) && hasOverflowScroll(el);
}
const getOffsetsTo = (source, target) => {
  const bounds = {
    top: 0,
    left: 0,
    height: target.offsetHeight,
    width: target.offsetWidth
  }, rect = {
    top: 0,
    left: 0,
    height: source.offsetHeight,
    width: source.offsetWidth
  };
  let foundScrollContainer = !1, el = source;
  for (; el && el !== target && target.contains(el); )
    foundScrollContainer && (bounds.top += el.offsetTop, bounds.left += el.offsetLeft), hasOverflowScroll(el) && (bounds.top = el.offsetTop, bounds.height = el.offsetHeight, bounds.left = el.offsetLeft, bounds.width = el.offsetWidth, foundScrollContainer = !0), rect.top += el.offsetTop - el.scrollTop, rect.left += el.offsetLeft - el.scrollLeft, el = el.offsetParent;
  return {
    rect,
    bounds
  };
};
function isChangeBar(v) {
  return v[0] !== "changePanel";
}
const SCROLL_INTO_VIEW_TOP_PADDING = -15;
function scrollIntoView(field) {
  const element = field.element;
  if (!element) return;
  let parentElementWithScroll = element;
  for (; !isScrollable(parentElementWithScroll); )
    if (parentElementWithScroll = parentElementWithScroll.parentElement, !parentElementWithScroll)
      return;
  parentElementWithScroll.scroll({
    top: parentElementWithScroll.scrollTop + field.rect.top - field.bounds.top + SCROLL_INTO_VIEW_TOP_PADDING,
    left: 0,
    behavior: "smooth"
  });
}
function ClampedRect(props2) {
  const $ = c(9);
  let bounds, rest;
  $[0] !== props2 ? ({
    bounds,
    ...rest
  } = props2, $[0] = props2, $[1] = bounds, $[2] = rest) : (bounds = $[1], rest = $[2]);
  const x = Math.max(bounds.left, props2.left), y = Math.max(props2.top, bounds.top), height = Math.max(0, props2.height - (y - props2.top)), width = Math.max(0, props2.width - (x - props2.left));
  let t0;
  return $[3] !== height || $[4] !== rest || $[5] !== width || $[6] !== x || $[7] !== y ? (t0 = /* @__PURE__ */ jsx("rect", { ...rest, x, y, height, width }), $[3] = height, $[4] = rest, $[5] = width, $[6] = x, $[7] = y, $[8] = t0) : t0 = $[8], t0;
}
styled.rect.withConfig({
  displayName: "DebugRect",
  componentId: "sc-42jssh-0"
})`stroke:#ccc;fill:none;pointer-events:none;stroke-linecap:round;`;
const ConnectorPath = styled.path.withConfig({
  displayName: "ConnectorPath",
  componentId: "sc-42jssh-1"
})`fill:none;pointer-events:none;stroke-linejoin:round;stroke:var(--card-badge-caution-dot-color);`, InteractivePath = styled.path.withConfig({
  displayName: "InteractivePath",
  componentId: "sc-42jssh-2"
})`fill:none;pointer-events:stroke;stroke:transparent;cursor:pointer;stroke-linecap:round;stroke-linejoin:round;opacity:0;&:hover{opacity:0.2;}`, RightBarWrapper = styled(ClampedRect).withConfig({
  displayName: "RightBarWrapper",
  componentId: "sc-42jssh-3"
})`stroke:none;pointer-events:none;fill:var(--card-badge-caution-dot-color);`;
function arrowPath(x, y, dir) {
  return [`M ${x - ARROW_SIZE} ${y - ARROW_SIZE * dir} `, `L ${x} ${y}`, `L ${x + ARROW_SIZE} ${y - ARROW_SIZE * dir}`].join("");
}
function moveTo(x, y) {
  return `M${x} ${y}`;
}
function lineTo(x, y) {
  return `L${x} ${y}`;
}
function join(strings2, delim = "") {
  return strings2.join(delim);
}
function quadCurve(x1, y1, x, y) {
  return `Q${x1} ${y1} ${x} ${y}`;
}
function generateConnectorPath(line) {
  const {
    from: from2,
    to
  } = line, {
    left: fromX,
    top: fromY
  } = from2, {
    left: toX,
    top: toY
  } = to, cmds = [], r1 = Math.min(CORNER_RADIUS, Math.abs(fromY - toY) / 2);
  return from2.isAbove ? cmds.push(moveTo(fromX + ARROW_MARGIN_X, fromY - ARROW_THRESHOLD + ARROW_MARGIN_Y), lineTo(fromX + ARROW_MARGIN_X, fromY - CORNER_RADIUS), quadCurve(fromX + ARROW_MARGIN_X, fromY, fromX + ARROW_MARGIN_X + CORNER_RADIUS, fromY)) : from2.isBelow ? cmds.push(moveTo(fromX + ARROW_MARGIN_X, fromY + ARROW_THRESHOLD - ARROW_MARGIN_Y), lineTo(fromX + ARROW_MARGIN_X, fromY + CORNER_RADIUS), quadCurve(fromX + ARROW_MARGIN_X, fromY, fromX + ARROW_MARGIN_X + CORNER_RADIUS, fromY)) : cmds.push(moveTo(fromX, fromY)), to.isAbove ? fromY < to.bounds.top ? cmds.push(lineTo(to.bounds.left - 8 - r1, fromY), quadCurve(to.bounds.left - 8, fromY, to.bounds.left - 8, fromY + r1), lineTo(to.bounds.left - 8, toY - r1), quadCurve(to.bounds.left - 8, toY, to.bounds.left - 8 + r1, toY), lineTo(to.bounds.left + ARROW_MARGIN_X - CORNER_RADIUS, toY), quadCurve(to.bounds.left + ARROW_MARGIN_X, toY, to.bounds.left + ARROW_MARGIN_X, toY - CORNER_RADIUS), lineTo(to.bounds.left + ARROW_MARGIN_X, toY - ARROW_THRESHOLD + ARROW_MARGIN_Y)) : cmds.push(lineTo(to.bounds.left + ARROW_MARGIN_X - CORNER_RADIUS, fromY), quadCurve(to.bounds.left + ARROW_MARGIN_X, fromY, to.bounds.left + ARROW_MARGIN_X, fromY - CORNER_RADIUS), lineTo(to.bounds.left + ARROW_MARGIN_X, toY - ARROW_THRESHOLD + ARROW_MARGIN_Y)) : to.isBelow ? fromY > to.bounds.top + to.bounds.height ? cmds.push(lineTo(to.bounds.left - ARROW_MARGIN_X - r1, fromY), quadCurve(to.bounds.left - ARROW_MARGIN_X, fromY, to.bounds.left - ARROW_MARGIN_X, fromY - r1), lineTo(to.bounds.left - ARROW_MARGIN_X, toY + r1), quadCurve(to.bounds.left - ARROW_MARGIN_X, toY, to.bounds.left - ARROW_MARGIN_X + r1, toY), lineTo(to.bounds.left + ARROW_MARGIN_X - CORNER_RADIUS, toY), quadCurve(to.bounds.left + ARROW_MARGIN_X, toY, to.bounds.left + ARROW_MARGIN_X, toY + CORNER_RADIUS), lineTo(to.bounds.left + ARROW_MARGIN_X, toY + ARROW_THRESHOLD - ARROW_MARGIN_Y)) : cmds.push(lineTo(to.bounds.left + ARROW_MARGIN_X - CORNER_RADIUS, fromY), quadCurve(to.bounds.left + ARROW_MARGIN_X, fromY, to.bounds.left + ARROW_MARGIN_X, fromY + CORNER_RADIUS), lineTo(to.bounds.left + ARROW_MARGIN_X, toY + ARROW_THRESHOLD - ARROW_MARGIN_Y)) : fromY < toY ? cmds.push(lineTo(to.bounds.left + ARROW_MARGIN_X - r1, fromY), quadCurve(to.bounds.left + ARROW_MARGIN_X, fromY, to.bounds.left + ARROW_MARGIN_X, fromY + r1), lineTo(to.bounds.left + ARROW_MARGIN_X, toY - r1), quadCurve(to.bounds.left + ARROW_MARGIN_X, toY, to.bounds.left + ARROW_MARGIN_X + r1, toY), lineTo(toX, toY)) : cmds.push(lineTo(to.bounds.left + ARROW_MARGIN_X - r1, fromY), quadCurve(to.bounds.left + ARROW_MARGIN_X, fromY, to.bounds.left + ARROW_MARGIN_X, fromY - r1), lineTo(to.bounds.left + ARROW_MARGIN_X, toY + r1), quadCurve(to.bounds.left + ARROW_MARGIN_X, toY, to.bounds.left + ARROW_MARGIN_X + r1, toY), lineTo(toX, toY)), join(cmds);
}
function getConnectorLinePoint(rect, bounds) {
  const centerY = rect.top + rect.height / 2, isAbove = rect.top + rect.height < bounds.top + ARROW_MARGIN_Y, isBelow = rect.top > bounds.top + bounds.height - ARROW_MARGIN_Y;
  return {
    bounds,
    left: rect.left,
    top: centerY,
    centerY,
    startY: rect.top + CONNECTOR_MARGIN,
    endY: rect.top + rect.height - CONNECTOR_MARGIN,
    isAbove,
    isBelow,
    outOfBounds: isAbove || isBelow
  };
}
function mapConnectorToLine(connector) {
  const fromBounds = {
    top: connector.from.bounds.top + ARROW_THRESHOLD,
    bottom: connector.from.bounds.top + connector.from.bounds.height - ARROW_THRESHOLD,
    left: connector.from.bounds.left,
    right: connector.from.bounds.left + connector.from.bounds.width,
    width: connector.from.bounds.width,
    height: connector.from.bounds.height - ARROW_THRESHOLD * 2
  }, from2 = getConnectorLinePoint(connector.from.rect, fromBounds);
  from2.left = connector.from.rect.left + connector.from.rect.width + 1;
  const toBounds = {
    top: connector.to.bounds.top + ARROW_THRESHOLD,
    bottom: connector.to.bounds.top + connector.to.bounds.height - ARROW_THRESHOLD,
    left: connector.to.bounds.left,
    right: connector.to.bounds.left + connector.to.bounds.width,
    width: connector.to.bounds.width,
    height: connector.to.bounds.height - ARROW_THRESHOLD * 2
  }, to = getConnectorLinePoint(connector.to.rect, toBounds), maxStartY = Math.max(to.startY, from2.startY);
  return from2.top = Math.min(maxStartY, from2.endY), from2.top < toBounds.top ? from2.top = Math.min(toBounds.top, from2.endY) : from2.top > toBounds.bottom && (from2.top = Math.max(toBounds.bottom, from2.startY)), to.top = Math.min(maxStartY, to.endY), to.top < fromBounds.top ? to.top = Math.min(fromBounds.top, to.endY) : to.top > fromBounds.bottom && (to.top = Math.max(fromBounds.bottom, to.startY)), from2.top = Math.min(Math.max(from2.top, fromBounds.top), fromBounds.bottom), to.top = Math.min(Math.max(to.top, toBounds.top), toBounds.bottom), {
    from: from2,
    to
  };
}
const Connector = memo(function(t0) {
  const $ = c(41), {
    from: from2,
    to
  } = t0;
  let line, t1, t2;
  if ($[0] !== from2 || $[1] !== to) {
    t2 = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    bb0: {
      if (line = mapConnectorToLine({
        from: from2,
        to
      }), line.from.outOfBounds && line.to.outOfBounds) {
        t2 = null;
        break bb0;
      }
      t1 = generateConnectorPath(line);
    }
    $[0] = from2, $[1] = to, $[2] = line, $[3] = t1, $[4] = t2;
  } else
    line = $[2], t1 = $[3], t2 = $[4];
  if (t2 !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return t2;
  const linePathDescription = t1;
  let t3, t4;
  $[5] !== linePathDescription ? (t3 = /* @__PURE__ */ jsx(InteractivePath, { d: linePathDescription, strokeWidth: INTERACTIVE_STROKE_WIDTH }), t4 = /* @__PURE__ */ jsx(ConnectorPath, { d: linePathDescription, strokeWidth: STROKE_WIDTH$2 }), $[5] = linePathDescription, $[6] = t3, $[7] = t4) : (t3 = $[6], t4 = $[7]);
  const t5 = to.rect.left - 0.5;
  let t6;
  $[8] !== t5 || $[9] !== to.bounds || $[10] !== to.rect.height || $[11] !== to.rect.top ? (t6 = /* @__PURE__ */ jsx(RightBarWrapper, { top: to.rect.top, left: t5, height: to.rect.height, width: STROKE_WIDTH$2, bounds: to.bounds }), $[8] = t5, $[9] = to.bounds, $[10] = to.rect.height, $[11] = to.rect.top, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== line.from.bounds || $[14] !== line.from.isAbove || $[15] !== line.from.left ? (t7 = line.from.isAbove && /* @__PURE__ */ jsx(ConnectorPath, { d: arrowPath(line.from.left + ARROW_MARGIN_X, line.from.bounds.top - ARROW_THRESHOLD + ARROW_MARGIN_Y, -1), strokeWidth: STROKE_WIDTH$2 }), $[13] = line.from.bounds, $[14] = line.from.isAbove, $[15] = line.from.left, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== line.from.bounds || $[18] !== line.from.isBelow || $[19] !== line.from.left ? (t8 = line.from.isBelow && /* @__PURE__ */ jsx(ConnectorPath, { d: arrowPath(line.from.left + ARROW_MARGIN_X, line.from.bounds.top + line.from.bounds.height + ARROW_THRESHOLD - ARROW_MARGIN_Y, 1), strokeWidth: STROKE_WIDTH$2 }), $[17] = line.from.bounds, $[18] = line.from.isBelow, $[19] = line.from.left, $[20] = t8) : t8 = $[20];
  let t9;
  $[21] !== line.to.bounds || $[22] !== line.to.isAbove ? (t9 = line.to.isAbove && /* @__PURE__ */ jsx(ConnectorPath, { d: arrowPath(line.to.bounds.left + ARROW_MARGIN_X, line.to.bounds.top - ARROW_THRESHOLD + ARROW_MARGIN_Y, -1), strokeWidth: STROKE_WIDTH$2 }), $[21] = line.to.bounds, $[22] = line.to.isAbove, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== line.to.bounds || $[25] !== line.to.isBelow ? (t10 = line.to.isBelow && /* @__PURE__ */ jsx(ConnectorPath, { d: arrowPath(line.to.bounds.left + ARROW_MARGIN_X, line.to.bounds.top + line.to.bounds.height + ARROW_THRESHOLD - ARROW_MARGIN_Y, 1), strokeWidth: STROKE_WIDTH$2 }), $[24] = line.to.bounds, $[25] = line.to.isBelow, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== line.from.bounds || $[28] !== line.from.outOfBounds || $[29] !== line.to.bounds || $[30] !== line.to.outOfBounds ? (t11 = DEBUG, $[27] = line.from.bounds, $[28] = line.from.outOfBounds, $[29] = line.to.bounds, $[30] = line.to.outOfBounds, $[31] = t11) : t11 = $[31];
  let t12;
  return $[32] !== t10 || $[33] !== t11 || $[34] !== t3 || $[35] !== t4 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9 ? (t12 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t3,
    t4,
    t6,
    t7,
    t8,
    t9,
    t10,
    t11
  ] }), $[32] = t10, $[33] = t11, $[34] = t3, $[35] = t4, $[36] = t6, $[37] = t7, $[38] = t8, $[39] = t9, $[40] = t12) : t12 = $[40], t12;
}), SvgWrapper = styled.svg.withConfig({
  displayName: "SvgWrapper",
  componentId: "sc-1u9wd4m-0"
})`pointer-events:none;position:absolute;left:0;top:0;right:0;bottom:0;width:100%;height:100%;`;
function useResizeObserver(element, onResize) {
  const $ = c(4);
  let t0, t1;
  $[0] !== element || $[1] !== onResize ? (t0 = () => resizeObserver.observe(element, onResize), t1 = [element, onResize], $[0] = element, $[1] = onResize, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1);
}
function getState(allReportedValues, hovered, byId, rootElement) {
  const changeBarsWithHover = [], changeBarsWithFocus = [];
  for (const value of allReportedValues) {
    if (!isChangeBar(value) || !value[1].isChanged)
      continue;
    const [id2, reportedChangeBar] = value;
    if (id2 === hovered) {
      changeBarsWithHover.push(value);
      continue;
    }
    if (reportedChangeBar.hasHover) {
      changeBarsWithHover.push(value);
      continue;
    }
    if (reportedChangeBar.hasFocus) {
      changeBarsWithFocus.push(value);
      continue;
    }
  }
  const isHoverConnector = changeBarsWithHover.length > 0;
  return {
    connectors: (isHoverConnector ? changeBarsWithHover : changeBarsWithFocus).map(([id2]) => {
      const field = findMostSpecificTarget("field", id2, byId), change = findMostSpecificTarget("change", id2, byId);
      return !field || !change ? null : {
        field: {
          id: id2,
          ...field
        },
        change: {
          id: id2,
          ...change
        }
      };
    }).filter((value) => !!value?.field.element && !!value?.change.element).map(({
      field,
      change
    }) => ({
      hasHover: field.hasHover || change.hasHover,
      hasFocus: field.hasFocus,
      hasRevertHover: change.hasRevertHover,
      field: {
        ...field,
        ...getOffsetsTo(field.element, rootElement)
      },
      change: {
        ...change,
        ...getOffsetsTo(change.element, rootElement)
      }
    })),
    isHoverConnector
  };
}
function ConnectorsOverlay(props2) {
  const $ = c(23), {
    rootElement,
    onSetFocus
  } = props2, [hovered, setHovered] = useState(null), allReportedValues = useChangeIndicatorsReportedValues(), {
    isReviewChangesOpen
  } = useReviewChanges();
  let t0;
  $[0] !== allReportedValues ? (t0 = new Map(allReportedValues), $[0] = allReportedValues, $[1] = t0) : t0 = $[1];
  const byId = t0;
  let t1;
  $[2] !== allReportedValues || $[3] !== byId || $[4] !== hovered || $[5] !== rootElement ? (t1 = () => getState(allReportedValues, hovered, byId, rootElement), $[2] = allReportedValues, $[3] = byId, $[4] = hovered, $[5] = rootElement, $[6] = t1) : t1 = $[6];
  const [t2, setState] = useState(t1), {
    connectors
  } = t2;
  let t3;
  $[7] !== connectors ? (t3 = connectors.sort(_temp), $[7] = connectors, $[8] = t3) : t3 = $[8];
  const visibleConnector = t3[0];
  let t4;
  $[9] !== allReportedValues || $[10] !== byId || $[11] !== hovered || $[12] !== isReviewChangesOpen || $[13] !== rootElement ? (t4 = () => {
    isReviewChangesOpen && setState(getState(allReportedValues, hovered, byId, rootElement));
  }, $[9] = allReportedValues, $[10] = byId, $[11] = hovered, $[12] = isReviewChangesOpen, $[13] = rootElement, $[14] = t4) : t4 = $[14];
  const handleScrollOrResize = t4;
  useResizeObserver(rootElement, handleScrollOrResize), useOnScroll(handleScrollOrResize);
  const t5 = visibleConnector && visibleConnector.field.zIndex;
  let t6;
  $[15] !== t5 ? (t6 = {
    zIndex: t5
  }, $[15] = t5, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== onSetFocus || $[18] !== visibleConnector ? (t7 = visibleConnector?.change && /* @__PURE__ */ jsx(ConnectorGroup, { field: visibleConnector.field, change: visibleConnector.change, onSetFocus, setHovered }, visibleConnector.field.id), $[17] = onSetFocus, $[18] = visibleConnector, $[19] = t7) : t7 = $[19];
  let t8;
  return $[20] !== t6 || $[21] !== t7 ? (t8 = /* @__PURE__ */ jsx(SvgWrapper, { style: t6, children: t7 }), $[20] = t6, $[21] = t7, $[22] = t8) : t8 = $[22], t8;
}
function _temp(a, b) {
  return b.field.id.length - a.field.id.length;
}
function ConnectorGroup(props2) {
  const $ = c(35), {
    change,
    field,
    onSetFocus,
    setHovered
  } = props2;
  let t0;
  $[0] !== change || $[1] !== field || $[2] !== onSetFocus ? (t0 = () => {
    scrollIntoView(field), scrollIntoView(change), onSetFocus(field.path);
  }, $[0] = change, $[1] = field, $[2] = onSetFocus, $[3] = t0) : t0 = $[3];
  const onConnectorClick = t0;
  let t1;
  $[4] !== field.id || $[5] !== setHovered ? (t1 = () => setHovered(field.id), $[4] = field.id, $[5] = setHovered, $[6] = t1) : t1 = $[6];
  const handleMouseEnter = t1;
  let t2;
  $[7] !== setHovered ? (t2 = () => setHovered(null), $[7] = setHovered, $[8] = t2) : t2 = $[8];
  const handleMouseLeave = t2, t3 = field.rect.left + 3;
  let t4;
  $[9] !== field.rect || $[10] !== t3 ? (t4 = {
    ...field.rect,
    left: t3
  }, $[9] = field.rect, $[10] = t3, $[11] = t4) : t4 = $[11];
  let t5;
  $[12] !== field.bounds || $[13] !== t4 ? (t5 = {
    rect: t4,
    bounds: field.bounds
  }, $[12] = field.bounds, $[13] = t4, $[14] = t5) : t5 = $[14];
  const from2 = t5, t6 = change.rect.left + 1;
  let t7;
  $[15] !== change.rect || $[16] !== t6 ? (t7 = {
    ...change.rect,
    left: t6
  }, $[15] = change.rect, $[16] = t6, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== change.bounds || $[19] !== t7 ? (t8 = {
    rect: t7,
    bounds: change.bounds
  }, $[18] = change.bounds, $[19] = t7, $[20] = t8) : t8 = $[20];
  const to = t8;
  let t9;
  $[21] !== from2 || $[22] !== to ? (t9 = /* @__PURE__ */ jsx(Connector, { from: from2, to }), $[21] = from2, $[22] = to, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== handleMouseEnter || $[25] !== handleMouseLeave || $[26] !== onConnectorClick || $[27] !== t9 ? (t10 = /* @__PURE__ */ jsx("g", { onClick: onConnectorClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: t9 }), $[24] = handleMouseEnter, $[25] = handleMouseLeave, $[26] = onConnectorClick, $[27] = t9, $[28] = t10) : t10 = $[28];
  let t11;
  $[29] !== change || $[30] !== field ? (t11 = DEBUG_LAYER_BOUNDS, $[29] = change, $[30] = field, $[31] = t11) : t11 = $[31];
  let t12;
  return $[32] !== t10 || $[33] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
    t10,
    t11
  ] }), $[32] = t10, $[33] = t11, $[34] = t12) : t12 = $[34], t12;
}
function ChangeConnectorRoot(t0) {
  const $ = c(22);
  let children, className, isReviewChangesOpen, onOpenReviewChanges, onSetFocus, restProps;
  $[0] !== t0 ? ({
    children,
    className,
    isReviewChangesOpen,
    onOpenReviewChanges,
    onSetFocus,
    ...restProps
  } = t0, $[0] = t0, $[1] = children, $[2] = className, $[3] = isReviewChangesOpen, $[4] = onOpenReviewChanges, $[5] = onSetFocus, $[6] = restProps) : (children = $[1], className = $[2], isReviewChangesOpen = $[3], onOpenReviewChanges = $[4], onSetFocus = $[5], restProps = $[6]);
  const [rootElement, setRootElement] = useState();
  let t1;
  $[7] !== isReviewChangesOpen || $[8] !== onOpenReviewChanges || $[9] !== onSetFocus ? (t1 = {
    isReviewChangesOpen,
    onOpenReviewChanges,
    onSetFocus
  }, $[7] = isReviewChangesOpen, $[8] = onOpenReviewChanges, $[9] = onSetFocus, $[10] = t1) : t1 = $[10];
  const contextValue = t1;
  let t2;
  $[11] !== onSetFocus || $[12] !== rootElement ? (t2 = rootElement && /* @__PURE__ */ jsx(ConnectorsOverlay, { rootElement, onSetFocus }), $[11] = onSetFocus, $[12] = rootElement, $[13] = t2) : t2 = $[13];
  let t3;
  $[14] !== children || $[15] !== className || $[16] !== restProps || $[17] !== t2 ? (t3 = /* @__PURE__ */ jsx(ChangeIndicatorsTracker, { children: /* @__PURE__ */ jsxs(ScrollContainer, { ...restProps, ref: setRootElement, className, children: [
    children,
    t2
  ] }) }), $[14] = children, $[15] = className, $[16] = restProps, $[17] = t2, $[18] = t3) : t3 = $[18];
  let t4;
  return $[19] !== contextValue || $[20] !== t3 ? (t4 = /* @__PURE__ */ jsx(ReviewChangesContext.Provider, { value: contextValue, children: t3 }), $[19] = contextValue, $[20] = t3, $[21] = t4) : t4 = $[21], t4;
}
function isPerspectiveWriteable({
  selectedPerspective,
  isDraftModelEnabled,
  schemaType
}) {
  return typeof schemaType > "u" ? {
    result: !1,
    reason: "INSUFFICIENT_DATA"
  } : isReleaseDocument(selectedPerspective) && selectedPerspective.state !== "active" ? {
    result: !1,
    reason: "RELEASE_NOT_ACTIVE"
  } : isPublishedPerspective(selectedPerspective) && schemaType.liveEdit !== !0 ? {
    result: !1,
    reason: "PUBLISHED_NOT_WRITEABLE"
  } : isDraftPerspective(selectedPerspective) && !isDraftModelEnabled && schemaType.liveEdit !== !0 ? {
    result: !1,
    reason: "DRAFTS_NOT_WRITEABLE"
  } : {
    result: !0
  };
}
function usePausedScheduledDraft() {
  const $ = c(9), {
    selectedReleaseId
  } = usePerspective(), {
    data: t0
  } = useActiveReleases();
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const allReleases = t1;
  let currentRelease, t2;
  $[2] !== allReleases || $[3] !== selectedReleaseId ? (currentRelease = selectedReleaseId ? allReleases.find((release) => getReleaseIdFromReleaseDocumentId(release._id) === selectedReleaseId) : void 0, t2 = isPausedCardinalityOneRelease(currentRelease), $[2] = allReleases, $[3] = selectedReleaseId, $[4] = currentRelease, $[5] = t2) : (currentRelease = $[4], t2 = $[5]);
  let t3;
  return $[6] !== currentRelease || $[7] !== t2 ? (t3 = {
    isPaused: t2,
    currentRelease
  }, $[6] = currentRelease, $[7] = t2, $[8] = t3) : t3 = $[8], t3;
}
export {
  ALL_FIELDS_GROUP,
  ActiveWorkspaceMatcher,
  AddonDatasetProvider,
  ArrayOfObjectOptionsInput,
  ArrayOfObjectsFunctions,
  ArrayOfObjectsInput,
  ArrayOfObjectsInputMember,
  ArrayOfObjectsInputMembers,
  ArrayOfObjectsItem,
  ArrayOfOptionsInput,
  ArrayOfPrimitiveOptionsInput,
  ArrayOfPrimitivesFunctions,
  ArrayOfPrimitivesInput,
  ArrayOfPrimitivesItem,
  AutoCollapseMenu,
  AvatarSkeleton$1 as AvatarSkeleton,
  BetaBadge,
  PortableTextInput as BlockEditor,
  BlockImagePreview,
  BlockPreview,
  BooleanInput,
  COMMENTS_INSPECTOR_NAME,
  CONNECTING,
  CapabilityGate,
  ChangeBreadcrumb,
  ChangeConnectorRoot,
  ChangeFieldWrapper,
  ChangeIndicator,
  ChangeIndicatorsTracker,
  ChangeList,
  ChangeResolver,
  ChangeTitleSegment,
  ChangesError,
  Chip,
  CircularProgress,
  CollapseMenu,
  CollapseMenuButton,
  ColorSchemeCustomProvider,
  ColorSchemeLocalStorageProvider,
  ColorSchemeProvider,
  CommandList,
  CommentDeleteDialog,
  CommentDisabledIcon,
  CommentInlineHighlightSpan,
  CommentInput,
  CommentsAuthoringPathProvider,
  CommentsEnabledProvider,
  CommentsIntentProvider,
  CommentsList,
  CommentsProvider,
  CommentsSelectedPathProvider,
  CompactPreview,
  Rule as ConcreteRuleClass,
  ConfigPropertyError,
  ConfigResolutionError,
  ContextMenuButton,
  CopyPasteProvider,
  CorsOriginError,
  CreateButton as CreateReferenceButton,
  StudioCrossDatasetReferenceInput as CrossDatasetReferenceInput,
  CrossDatasetReferencePreview,
  DECISION_PARAMETERS_SCHEMA,
  DEFAULT_ANNOTATIONS,
  DEFAULT_DECORATORS,
  DEFAULT_MAX_RECURSION_DEPTH,
  DEFAULT_STUDIO_CLIENT_OPTIONS,
  DRAFTS_FOLDER2 as DRAFTS_FOLDER,
  DateInput,
  DateTimeInput$2 as DateTimeInput,
  DefaultPreview,
  DetailPreview,
  DiffCard,
  DiffErrorBoundary,
  DiffFromTo,
  DiffInspectWrapper,
  DiffString,
  DiffStringSegment,
  DiffTooltip,
  DivergencesProvider,
  DocumentPreviewPresence,
  DocumentStatus,
  DocumentStatusIndicator,
  EMPTY_ARRAY$y as EMPTY_ARRAY,
  EMPTY_OBJECT,
  EditPortal,
  EditScheduleForm,
  EmailInput,
  EnhancedObjectDialog,
  ErrorActions,
  ErrorMessage,
  Event$1 as Event,
  EventsProvider,
  FallbackDiff,
  FieldActionMenu,
  FieldActionsProvider,
  FieldActionsResolver,
  FieldChange,
  FieldPresence,
  FieldPresenceInner,
  FieldPresenceWithOverlay,
  StudioFileInput as FileInput,
  Filters,
  FormBuilder,
  FormCallbacksProvider,
  FormCell,
  FormContainer,
  FormField,
  FormFieldHeaderText,
  FormFieldSet,
  FormFieldStatus,
  FormFieldValidationStatus,
  FormInput,
  FormProvider,
  FormRow,
  FormValueProvider,
  FromTo,
  FromToArrow,
  GetFormValueProvider,
  GetHookCollectionState,
  GroupChange,
  Hotkeys,
  HoveredFieldProvider,
  StudioImageInput as ImageInput,
  ImperativeToast,
  InlinePreview,
  InsufficientPermissionsMessage,
  IntentButton,
  IsLastPaneProvider,
  LATEST,
  LegacyLayerProvider,
  LinearProgress,
  LiveManifestRegisterProvider,
  LoadingBlock,
  LocaleProvider,
  LocaleProviderBase,
  MediaPreview,
  MemberField,
  MemberFieldError,
  MemberFieldSet,
  MemberItemError,
  MetaInfo,
  NoChanges,
  NumberInput,
  ObjectInput,
  ObjectInputMember,
  ObjectInputMembers,
  ObjectMembers,
  PUBLISHED$1 as PUBLISHED,
  PatchEvent,
  PerspectiveProvider,
  PopoverDialog,
  PortableTextInput,
  PresenceOverlay,
  PresenceScope,
  Preview$1 as Preview,
  PreviewCard,
  PreviewLoader,
  RELEASES_INTENT,
  RELEASES_STUDIO_CLIENT_OPTIONS,
  ReferenceAutocomplete$3 as ReferenceAutocomplete,
  StudioReferenceInput as ReferenceInput,
  ReferenceInputOptionsProvider,
  ReferenceInputPreviewCard,
  RelativeTime,
  ReleaseAvatar,
  ReleaseAvatarIcon,
  ReleaseTitle,
  ReleasesNav,
  Resizable,
  ResourceCacheProvider,
  RevertChangesButton,
  RevertChangesConfirmDialog,
  SANITY_PATCH_TYPE,
  SANITY_VERSION,
  SESSION_ID,
  SanityDefaultPreview,
  useScheduleAction as ScheduleAction,
  ScheduledBadge,
  SchedulesContext2 as SchedulesContext,
  SchemaError,
  ScrollContainer,
  SearchButton,
  SearchDialog,
  SearchHeader,
  SearchPopover,
  SearchProvider,
  SearchResultItemPreview,
  SelectInput,
  SingleDocReleaseProvider,
  SlugInput,
  SourceProvider,
  StatusButton,
  StringInput,
  Studio,
  StudioAnnouncementsCard,
  StudioAnnouncementsDialog,
  StudioLayout,
  StudioLayoutComponent,
  StudioLogo,
  StudioNavbar,
  StudioProvider,
  StudioToolMenu,
  TIMELINE_ITEM_I18N_KEY_MAPPING,
  TagsArrayInput,
  TelephoneInput,
  TemplatePreview,
  TextInput,
  TextWithTone,
  Timeline,
  TimelineController,
  ToolLink,
  TooltipOfDisabled,
  TransformPatches,
  Translate,
  UniversalArrayInput,
  UpdateReadOnlyPlugin$1 as UpdateReadOnlyPlugin,
  UpsellDescriptionSerializer,
  UpsellDialogDismissed,
  UpsellDialogLearnMoreCtaClicked,
  UpsellDialogUpgradeCtaClicked,
  UpsellDialogViewed,
  UrlInput,
  UserAvatar,
  UserColorManagerProvider,
  VERSION_FOLDER,
  ValueError,
  VersionChip$1 as VersionChip,
  VersionInlineBadge,
  VirtualizerScrollInstanceProvider,
  WithReferringDocuments,
  WorkspaceLoaderBoundary as WorkspaceLoader,
  WorkspaceProvider,
  WorkspacesProvider,
  ZIndexProvider,
  _createAuthStore,
  _isCustomDocumentTypeDefinition,
  _isSanityDocumentTypeDefinition,
  _isType,
  asLoadable,
  buildCommentRangeDecorations,
  buildLegacyTheme,
  buildRangeDecorationSelectionsFromComments,
  buildTextSelectionFromFragment,
  catchWithCount,
  checkoutPair,
  collate,
  createAuthStore,
  createBufferedDocument,
  createConfig,
  createConnectionStatusStore,
  createDefaultIcon,
  createDocumentPreviewStore,
  createDocumentStore,
  createDraftFrom,
  createGrantsStore,
  createHistoryStore,
  createHookFromObservableFactory,
  createKeyValueStore,
  createMockAuthStore,
  createObservableBufferedDocument,
  createPatchChannel,
  createPlugin,
  createPresenceStore,
  createProjectStore,
  createPublishedFrom,
  createSWR,
  createSanityMediaLibraryFileSource,
  createSanityMediaLibraryImageSource,
  createSchema,
  createSearch,
  createSharedResizeObserver,
  createSourceFromConfig,
  createUserColorManager,
  createUserStore,
  createWorkspaceFromConfig,
  dec,
  decodePath,
  defaultLocale,
  defaultRenderAnnotation,
  defaultRenderBlock,
  defaultRenderField,
  defaultRenderInlineBlock,
  defaultRenderInput,
  defaultRenderItem,
  defaultRenderPreview,
  defaultTemplateForType,
  defaultTemplatesForSchema,
  defaultTheme,
  defineConfig,
  defineDocumentFieldAction,
  defineDocumentInspector,
  defineLocale,
  defineLocaleResourceBundle,
  defineLocalesResources,
  definePlugin,
  defineSearchFilter,
  defineSearchFilterOperators,
  defineSearchOperator,
  diffMatchPatch,
  documentFieldActionsReducer,
  documentIdEquals,
  editState,
  emitOperation,
  emptyValuesByType,
  encodePath,
  escapeField,
  fieldNeedsEscape,
  findIndex,
  flattenConfig,
  formatRelativeLocale,
  formatRelativeLocalePublishDate,
  fromMutationPatches,
  generateStudioManifest,
  getAnnotationAtPath,
  getAnnotationColor,
  getCalendarLabels,
  getConfigContextFromSource,
  getDiffAtPath,
  getDocumentIdForCanvasLink,
  getDocumentIsInPerspective,
  getDocumentPairPermissions,
  getDocumentValuePermissions,
  getDocumentVariantType,
  getDraftId2 as getDraftId,
  getErrorMessage$2 as getErrorMessage,
  getExpandOperations,
  getIdPair,
  getInitialValueStream,
  getItemKey,
  getItemKeySegment,
  getNamelessWorkspaceIdentifier,
  getPairListener,
  getPreviewPaths,
  getPreviewStateObservable$1 as getPreviewStateObservable,
  getPreviewValueWithFallback,
  getProviderTitle,
  getPublishedId2 as getPublishedId,
  getReferencePaths,
  getReleaseIdFromReleaseDocumentId,
  getReleaseTone,
  getSchemaTypeTitle,
  getSearchableTypes,
  getTemplatePermissions,
  getValueAtPath,
  getValueError,
  getVersionFromId2 as getVersionFromId,
  getVersionId2 as getVersionId,
  getVersionInlineBadge,
  getWorkspaceIdentifier,
  globalScope,
  grantsPermissionOn,
  hasCommentMessageValue,
  idMatchesPerspective,
  inc,
  initialDocumentFieldActions,
  insert$1 as insert,
  isAddedItemDiff,
  isAgentBundleName,
  isArray,
  isArrayOfBlocksInputProps,
  isArrayOfObjectsInputProps,
  isArrayOfPrimitivesInputProps,
  isAuthStore,
  isBooleanInputProps,
  isBuilder,
  isCardinalityOnePerspective,
  isCardinalityOneRelease,
  isCookielessCompatibleLoginMethod,
  isCreateDocumentVersionEvent,
  isCreateLiveDocumentEvent,
  isDeleteDocumentGroupEvent,
  isDeleteDocumentVersionEvent,
  isDev,
  isDocumentLimitError,
  isDraft,
  isDraftId2 as isDraftId,
  isDraftPerspective,
  isEditDocumentVersionEvent,
  isEmptyObject$1 as isEmptyObject,
  isFieldChange,
  isGoingToUnpublish,
  isGroupChange,
  isNewDocument,
  isNonNullable$2 as isNonNullable,
  isNumberInputProps,
  isObjectInputProps$1 as isObjectInputProps,
  isObjectItemProps,
  isPausedCardinalityOneRelease,
  isPerspectiveRaw,
  isPerspectiveWriteable,
  isProd,
  isPublishDocumentVersionEvent,
  isPublishedId2 as isPublishedId,
  isPublishedPerspective,
  isRecord$4 as isRecord,
  isReleaseDocument,
  isReleasePerspective,
  isReleaseScheduledOrScheduling,
  isRemovedItemDiff,
  isSanityDefinedAction,
  isScheduleDocumentVersionEvent,
  isString,
  isStringInputProps,
  isSystemBundle,
  isSystemBundleName,
  isTextSelectionComment,
  isTruthy,
  isUnchangedDiff,
  isUnpublishDocumentEvent,
  isUnscheduleDocumentVersionEvent,
  isUpdateLiveDocumentEvent,
  isValidAnnouncementAudience,
  isValidAnnouncementRole,
  isVersionId2 as isVersionId,
  joinPath,
  listenQuery,
  matchWorkspace,
  measureFirstEmission,
  measureFirstMatch,
  newDraftFrom,
  noop$6 as noop,
  normalizeIndexSegment,
  normalizeIndexTupleSegment,
  normalizeKeySegment,
  normalizePathSegment$1 as normalizePathSegment,
  onRetry,
  operationEvents,
  operatorDefinitions,
  pathToString$1 as pathToString,
  pathsAreEqual,
  prefixPath,
  prepareConfig,
  prepareForPreview,
  prepareTemplates,
  remoteSnapshots,
  removeDupes$3 as removeDupes,
  removeMissingReferences,
  removeUndefinedLocaleResources,
  renderStudio,
  resizeObserver,
  resolveConditionalProperty,
  resolveConfig,
  resolveDiffComponent,
  resolveInitialObjectValue,
  resolveInitialValue,
  resolveInitialValueForType,
  resolveSchemaTypes,
  selectUpstreamVersion,
  serializeError,
  set,
  setAtPath,
  setIfMissing,
  sliceString,
  snapshotPair,
  sortReleases,
  stringToPath,
  supportsTouch,
  systemBundles,
  toMutationPatches,
  truncateString,
  uncaughtErrorHandler,
  unset,
  unstable_useObserveDocument,
  unstable_useValuePreview,
  uploadSchema,
  usEnglishLocale,
  useActiveReleases,
  useActiveWorkspace,
  useAddonDataset,
  useAgentVersionDisplay,
  useAnnotationColor,
  useArchivedReleases,
  useCanvasCompanionDoc,
  useChangeIndicatorsReportedValues,
  useChangeIndicatorsReporter,
  useClient,
  useColorScheme,
  useColorSchemeInternalValue,
  useColorSchemeOptions,
  useColorSchemeSetValue,
  useColorSchemeValue,
  useComlinkStore,
  useComments,
  useCommentsEnabled,
  useCommentsSelectedPath,
  useCommentsTelemetry,
  useConditionalToast,
  useConfigContextFromSource,
  useConnectionState,
  useConnectionStatusStore,
  useCopyErrorDetails,
  useCopyPaste,
  useCurrentLocale,
  useCurrentUser,
  useDataset,
  useDateTimeFormat,
  useDialogStack,
  useDidUpdate,
  useDiffAnnotationColor,
  useDivergenceNavigator,
  useDocumentChange,
  useDocumentDivergences,
  useDocumentForm,
  useDocumentIdStack,
  useDocumentLimitsUpsellContext,
  useDocumentOperation,
  useDocumentOperationEvent,
  useDocumentPairPermissions,
  useDocumentPairPermissionsFromHookFactory,
  useDocumentPresence,
  useDocumentPreviewStore,
  useDocumentPreviewValues,
  useDocumentStore,
  useDocumentType,
  useDocumentValuePermissions,
  useDocumentValues,
  useDocumentVersionInfo,
  useDocumentVersionTypeSortedList,
  useDocumentVersions,
  useEditState,
  useEnhancedObjectDialog,
  useEvents,
  useEventsStore,
  useExcludedPerspective,
  useFeatureEnabled,
  useFieldActions,
  useFilteredReleases,
  useFormBuilder,
  useFormCallbacks,
  useFormState,
  useFormValue,
  useFormattedDuration,
  useGetDefaultPerspective,
  useGetFormValue,
  useGetI18nText,
  useGlobalCopyPasteElementHandler,
  useGlobalPresence,
  useGrantsStore,
  useHistoryStore,
  useHoveredField,
  useI18nText,
  useInitialValue,
  useInitialValueResolverContext,
  useIsReleaseActive,
  useKeyValueStore,
  useListFormat,
  useLoadable,
  useLocale,
  useManageFavorite,
  useMiddlewareComponents,
  useNavigateToCanvasDoc,
  useNumberFormat,
  useOnScroll,
  useOnlyHasVersions,
  usePausedScheduledDraft,
  usePerspective,
  usePresenceStore,
  usePreviewCard,
  useProject,
  useProjectDatasets,
  useProjectId,
  useProjectStore,
  useReconnectingToast,
  useReferenceInputOptions,
  useReferringDocuments,
  useRelativeTime,
  useReleasesIds,
  useRenderingContextStore,
  useResolveInitialValueForType,
  useResourceCache,
  useReviewChanges,
  useRovingFocus,
  useScheduledDraftDocument,
  useScheduledDraftsEnabled,
  useSchema,
  useSearchMaxFieldDepth,
  useSearchState,
  useSetPerspective,
  useSingleDocRelease,
  useSource,
  useStudioUrl,
  useSyncState,
  useTemplatePermissions,
  useTemplatePermissionsFromHookFactory,
  useTemplates,
  useThrottledCallback,
  useTimeAgo,
  useTimelineSelector,
  useTimelineStore,
  useTools,
  useTrackerStore,
  useTrackerStoreReporter,
  useTranslation,
  useUnique,
  useUnitFormatter,
  useUnstableObserveDocument,
  useUser,
  useUserColor,
  useUserColorManager,
  useUserListWithPermissions,
  useUserStore,
  useValidationStatus,
  useValuePreview,
  useVersionOperations,
  useVirtualizerScrollInstance,
  useWorkspace,
  useWorkspaceLoader,
  useWorkspaceSchemaId,
  useWorkspaces,
  useZIndex,
  userHasRole,
  validateBasePaths,
  validateDocument,
  validateNames,
  validateWorkspaces,
  validation,
  visitDiff
};
//# sourceMappingURL=index.js.map
